webpackJsonp([0],Array(760).concat([
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _root = __webpack_require__(1581);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    return {
        diagnosticsEnabled: config.DiagnosticsEnabled === 'true',
        noAccounts: config.NoAccounts === 'true'
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_root2.default);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? 'wrappedInstance' : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 // months to year
};

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  if (false) {
    console.error('[React Intl] No ' + type + ' format named: ' + name);
  }
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting date.\n' + e);
    }
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting time.\n' + e);
    }
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting relative time.\n' + e);
    }
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting number.\n' + e);
    }
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting plural.\n' + e);
    }
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // `id` is a required field of a Message Descriptor.

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
      }
    }
  } else {
    if (false) {
      // This prevents warnings from littering the console in development
      // when no `messages` are passed into the <IntlProvider> for the
      // default locale, and a default message is in the source.
      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
      }
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
      }
    }
  }

  if (!formattedMessage) {
    if (false) {
      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
    }
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {}
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats;


        if (false) {
          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
        }

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatMessage = _context$intl.formatMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REACTION_PATTERN = exports.getFileType = undefined;

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _from = __webpack_require__(181);

var _from2 = _interopRequireDefault(_from);

var _apply = __webpack_require__(1655);

var _apply2 = _interopRequireDefault(_apply);

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__(180);

var _typeof3 = _interopRequireDefault(_typeof2);

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

exports.isEmail = isEmail;
exports.isMac = isMac;
exports.createSafeId = createSafeId;
exports.cmdOrCtrlPressed = cmdOrCtrlPressed;
exports.isKeyPressed = isKeyPressed;
exports.isInRole = isInRole;
exports.isChannelAdmin = isChannelAdmin;
exports.isAdmin = isAdmin;
exports.isSystemAdmin = isSystemAdmin;
exports.getCookie = getCookie;
exports.notifyMe = notifyMe;
exports.ding = ding;
exports.hasSoundOptions = hasSoundOptions;
exports.getDateForUnixTicks = getDateForUnixTicks;
exports.displayDate = displayDate;
exports.displayTime = displayTime;
exports.getTimestamp = getTimestamp;
exports.loopReplacePattern = loopReplacePattern;
exports.extractFirstLink = extractFirstLink;
exports.areObjectsEqual = areObjectsEqual;
exports.areMapsEqual = areMapsEqual;
exports.replaceHtmlEntities = replaceHtmlEntities;
exports.insertHtmlEntities = insertHtmlEntities;
exports.isGIFImage = isGIFImage;
exports.getFileIconPath = getFileIconPath;
exports.getIconClassName = getIconClassName;
exports.splitFileLocation = splitFileLocation;
exports.sortFilesByName = sortFilesByName;
exports.toTitleCase = toTitleCase;
exports.isHexColor = isHexColor;
exports.applyTheme = applyTheme;
exports.resetTheme = resetTheme;
exports.changeCss = changeCss;
exports.updateCodeTheme = updateCodeTheme;
exports.placeCaretAtEnd = placeCaretAtEnd;
exports.getCaretPosition = getCaretPosition;
exports.setSelectionRange = setSelectionRange;
exports.setCaretPosition = setCaretPosition;
exports.getSelectedText = getSelectedText;
exports.isValidUsername = isValidUsername;
exports.isMobile = isMobile;
exports.getDirectTeammate = getDirectTeammate;
exports.loadImage = loadImage;
exports.changeColor = changeColor;
exports.changeOpacity = changeOpacity;
exports.getFullName = getFullName;
exports.getDisplayName = getDisplayName;
exports.getDisplayNameByUserId = getDisplayNameByUserId;
exports.getDisplayNameByUser = getDisplayNameByUser;
exports.sortUsersByStatusAndDisplayName = sortUsersByStatusAndDisplayName;
exports.displayEntireName = displayEntireName;
exports.displayEntireNameForUser = displayEntireNameForUser;
exports.imageURLForUser = imageURLForUser;
exports.imageURLForTeam = imageURLForTeam;
exports.fileSizeToString = fileSizeToString;
exports.generateId = generateId;
exports.getDirectChannelName = getDirectChannelName;
exports.getUserIdFromChannelName = getUserIdFromChannelName;
exports.getUserIdFromChannelId = getUserIdFromChannelId;
exports.isDirectChannelForUser = isDirectChannelForUser;
exports.importSlack = importSlack;
exports.windowWidth = windowWidth;
exports.windowHeight = windowHeight;
exports.getChannelTerm = getChannelTerm;
exports.getPostTerm = getPostTerm;
exports.isFeatureEnabled = isFeatureEnabled;
exports.fillArray = fillArray;
exports.isFileTransfer = isFileTransfer;
exports.clearFileInput = clearFileInput;
exports.isPostEphemeral = isPostEphemeral;
exports.getRootId = getRootId;
exports.localizeMessage = localizeMessage;
exports.mod = mod;
exports.canCreateCustomEmoji = canCreateCustomEmoji;
exports.getPasswordConfig = getPasswordConfig;
exports.isValidPassword = isValidPassword;
exports.handleFormattedTextClick = handleFormattedTextClick;
exports.isEmptyObject = isEmptyObject;
exports.removePrefixFromLocalStorage = removePrefixFromLocalStorage;
exports.getEmailInterval = getEmailInterval;
exports.copyToClipboard = copyToClipboard;

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _general = __webpack_require__(113);

var _preferences = __webpack_require__(784);

var _user_utils = __webpack_require__(175);

var _browser_history = __webpack_require__(273);

var _post_actions = __webpack_require__(802);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _localization_store = __webpack_require__(906);

var _localization_store2 = _interopRequireDefault(_localization_store);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _bing = __webpack_require__(1874);

var _bing2 = _interopRequireDefault(_bing);

var _icon50x = __webpack_require__(1035);

var _icon50x2 = _interopRequireDefault(_icon50x);

var _icon_WS = __webpack_require__(1875);

var _icon_WS2 = _interopRequireDefault(_icon_WS);

var _url = __webpack_require__(793);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function isEmail(email) {
    // writing a regex to match all valid email addresses is really, really hard. (see http://stackoverflow.com/a/201378)
    // this regex ensures:
    // - at least one character that is not a space, comma, or @ symbol
    // - followed by a single @ symbol
    // - followed by at least one character that is not a space, comma, or @ symbol
    // this prevents <Outlook Style> outlook.style@domain.com addresses and multiple comma-separated addresses from being accepted
    return (/^[^ ,@]+@[^ ,@]+$/.test(email)
    );
}

function isMac() {
    return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
}

function createSafeId(prop) {
    if (prop === null) {
        return null;
    }

    var str = '';

    if (prop.props && prop.props.defaultMessage) {
        str = prop.props.defaultMessage;
    } else {
        str = prop.toString();
    }

    return str.replace(new RegExp(' ', 'g'), '_');
}

function cmdOrCtrlPressed(e) {
    var allowAlt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (allowAlt) {
        return isMac() && e.metaKey || !isMac() && e.ctrlKey;
    }
    return isMac() && e.metaKey || !isMac() && e.ctrlKey && !e.altKey;
}

function isKeyPressed(event, key) {
    if (typeof event.key !== 'undefined' && event.key !== 'Unidentified' && event.key !== 'Dead') {
        return event.key === key[0] || event.key === key[0].toUpperCase();
    }
    return event.keyCode === key[1];
}

function isInRole(roles, inRole) {
    if (roles) {
        var parts = roles.split(' ');
        for (var i = 0; i < parts.length; i++) {
            if (parts[i] === inRole) {
                return true;
            }
        }
    }

    return false;
}

function isChannelAdmin(isLicensed, roles) {
    if (!isLicensed) {
        return false;
    }

    if (isInRole(roles, 'channel_admin')) {
        return true;
    }

    return false;
}

function isAdmin(roles) {
    if (isInRole(roles, 'team_admin')) {
        return true;
    }

    if (isInRole(roles, 'system_admin')) {
        return true;
    }

    return false;
}

function isSystemAdmin(roles) {
    if (isInRole(roles, 'system_admin')) {
        return true;
    }

    return false;
}

function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return '';
}

var requestedNotificationPermission = false;

function notifyMe(title, body, channel, teamId, duration, silent) {
    if (!('Notification' in window)) {
        return;
    }

    var notificationDuration = _constants3.default.DEFAULT_NOTIFICATION_DURATION;
    if (duration != null) {
        notificationDuration = duration;
    }

    if (Notification.permission === 'granted' || Notification.permission === 'default' && !requestedNotificationPermission) {
        requestedNotificationPermission = true;

        if (typeof Notification.requestPermission === 'function') {
            Notification.requestPermission(function (permission) {
                if (permission === 'granted') {
                    try {
                        var icon = _icon50x2.default;
                        if (UserAgent.isEdge()) {
                            icon = _icon_WS2.default;
                        }

                        var notification = new Notification(title, { body: body, tag: body, icon: icon, requireInteraction: notificationDuration === 0, silent: silent });
                        notification.onclick = function () {
                            window.focus();
                            if (channel && (channel.type === _constants3.default.DM_CHANNEL || channel.type === _constants3.default.GM_CHANNEL)) {
                                _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name);
                            } else if (channel) {
                                _browser_history.browserHistory.push(_team_store2.default.getTeamRelativeUrl(teamId) + '/channels/' + channel.name);
                            } else if (teamId) {
                                _browser_history.browserHistory.push(_team_store2.default.getTeamRelativeUrl(teamId) + ('/channels/' + _constants3.default.DEFAULT_CHANNEL));
                            } else {
                                _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + ('/channels/' + _constants3.default.DEFAULT_CHANNEL));
                            }
                        };

                        if (notificationDuration > 0) {
                            setTimeout(function () {
                                notification.close();
                            }, notificationDuration);
                        }
                    } catch (e) {
                        console.error(e); //eslint-disable-line no-console
                    }
                }
            });
        }
    }
}

var canDing = true;

function ding() {
    if (hasSoundOptions() && canDing) {
        var audio = new Audio(_bing2.default);
        audio.play();
        canDing = false;
        setTimeout(function () {
            canDing = true;
        }, 3000);
    }
}

function hasSoundOptions() {
    return !UserAgent.isFirefox() && !UserAgent.isEdge();
}

function getDateForUnixTicks(ticks) {
    return new Date(ticks);
}

function displayDate(ticks) {
    var d = new Date(ticks);
    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
}

function displayTime(ticks, utc) {
    var d = new Date(ticks);
    var hours = void 0;
    var minutes = void 0;
    var ampm = '';
    var timezone = '';

    if (utc) {
        hours = d.getUTCHours();
        minutes = d.getUTCMinutes();
        timezone = ' UTC';
    } else {
        hours = d.getHours();
        minutes = d.getMinutes();
    }

    if (minutes <= 9) {
        minutes = '0' + minutes;
    }

    var useMilitaryTime = _preference_store2.default.getBool(_constants3.default.Preferences.CATEGORY_DISPLAY_SETTINGS, 'use_military_time');
    if (!useMilitaryTime) {
        ampm = ' AM';
        if (hours >= 12) {
            ampm = ' PM';
        }

        hours %= 12;
        if (!hours) {
            hours = '12';
        }
    }

    return hours + ':' + minutes + ampm + timezone;
}

// returns Unix timestamp in milliseconds
function getTimestamp() {
    return Date.now();
}

// Replaces all occurrences of a pattern
function loopReplacePattern(text, pattern, replacement) {
    var result = text;

    var match = pattern.exec(result);
    while (match) {
        result = result.replace(pattern, replacement);
        match = pattern.exec(result);
    }

    return result;
}

// extracts the first link from the text
function extractFirstLink(text) {
    var pattern = /(^|[\s\n]|<br\/?>)((?:https?|ftp):\/\/[-A-Z0-9+\u0026\u2019@#/%?=()~_|!:,.;]*[-A-Z0-9+\u0026@#/%=~()_|])/i;
    var inText = text;

    // strip out code blocks
    inText = inText.replace(/`[^`]*`/g, '');

    // strip out inline markdown images
    inText = inText.replace(/!\[[^\]]*]\([^)]*\)/g, '');

    // remove markdown *, ~~ and _ characters
    inText = loopReplacePattern(inText, /(\*|~~)(.*?)\1/, '$2');
    inText = loopReplacePattern(inText, /([\s\n]|^)_(.*?)_([\s\n]|$)/, '$1$2$3');

    var match = pattern.exec(inText);
    if (match) {
        return match[0].trim();
    }

    return '';
}

// Taken from http://stackoverflow.com/questions/1068834/object-comparison-in-javascript and modified slightly
function areObjectsEqual(x, y) {
    var p = void 0;
    var leftChain = [];
    var rightChain = [];

    // Remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
        return true;
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on step when comparing prototypes
    if (x === y) {
        return true;
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if (typeof x === 'function' && typeof y === 'function' || x instanceof Date && y instanceof Date || x instanceof RegExp && y instanceof RegExp || x instanceof String && y instanceof String || x instanceof Number && y instanceof Number) {
        return x.toString() === y.toString();
    }

    if (x instanceof _map2.default && y instanceof _map2.default) {
        return areMapsEqual(x, y);
    }

    // At last checking prototypes as good a we can
    if (!(x instanceof Object && y instanceof Object)) {
        return false;
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
        return false;
    }

    if (x.constructor !== y.constructor) {
        return false;
    }

    if (x.prototype !== y.prototype) {
        return false;
    }

    // Check for infinitive linking loops
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
        return false;
    }

    // Quick checking of one object being a subset of another.
    for (p in y) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        } else if ((0, _typeof3.default)(y[p]) !== (0, _typeof3.default)(x[p])) {
            return false;
        }
    }

    for (p in x) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        } else if ((0, _typeof3.default)(y[p]) !== (0, _typeof3.default)(x[p])) {
            return false;
        }

        switch ((0, _typeof3.default)(x[p])) {
            case 'object':
            case 'function':

                leftChain.push(x);
                rightChain.push(y);

                if (!areObjectsEqual(x[p], y[p])) {
                    return false;
                }

                leftChain.pop();
                rightChain.pop();
                break;

            default:
                if (x[p] !== y[p]) {
                    return false;
                }
                break;
        }
    }

    return true;
}

function areMapsEqual(a, b) {
    if (a.size !== b.size) {
        return false;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(a), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                key = _step$value[0],
                value = _step$value[1];

            if (!b.has(key)) {
                return false;
            }

            if (!areObjectsEqual(value, b.get(key))) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return true;
}

function replaceHtmlEntities(text) {
    var tagsToReplace = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>'
    };
    var newtext = text;
    for (var tag in tagsToReplace) {
        if ((0, _apply2.default)({}.hasOwnProperty, this, [tagsToReplace, tag])) {
            var regex = new RegExp(tag, 'g');
            newtext = newtext.replace(regex, tagsToReplace[tag]);
        }
    }
    return newtext;
}

function insertHtmlEntities(text) {
    var tagsToReplace = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;'
    };
    var newtext = text;
    for (var tag in tagsToReplace) {
        if ((0, _apply2.default)({}.hasOwnProperty, this, [tagsToReplace, tag])) {
            var regex = new RegExp(tag, 'g');
            newtext = newtext.replace(regex, tagsToReplace[tag]);
        }
    }
    return newtext;
}

function isGIFImage(extin) {
    return extin.toLowerCase() === _constants3.default.IMAGE_TYPE_GIF;
}

var removeQuerystringOrHash = function removeQuerystringOrHash(extin) {
    return extin.split(/[?#]/)[0];
};

var getFileType = exports.getFileType = function getFileType(extin) {
    var ext = removeQuerystringOrHash(extin.toLowerCase());

    if (_constants3.default.IMAGE_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.IMAGE;
    }

    if (_constants3.default.AUDIO_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.AUDIO;
    }

    if (_constants3.default.VIDEO_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.VIDEO;
    }

    if (_constants3.default.SPREADSHEET_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.SPREADSHEET;
    }

    if (_constants3.default.CODE_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.CODE;
    }

    if (_constants3.default.WORD_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.WORD;
    }

    if (_constants3.default.PRESENTATION_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.PRESENTATION;
    }

    if (_constants3.default.PDF_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.PDF;
    }

    if (_constants3.default.PATCH_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.PATCH;
    }

    if (_constants3.default.SVG_TYPES.indexOf(ext) > -1) {
        return _constants2.FileTypes.SVG;
    }

    return _constants2.FileTypes.OTHER;
};

function getFileIconPath(fileInfo) {
    var fileType = getFileType(fileInfo.extension);

    var icon;
    if (fileType in _constants3.default.ICON_FROM_TYPE) {
        icon = _constants3.default.ICON_FROM_TYPE[fileType];
    } else {
        icon = _constants3.default.ICON_FROM_TYPE.other;
    }

    return icon;
}

function getIconClassName(fileTypeIn) {
    var fileType = fileTypeIn.toLowerCase();

    if (fileType in _constants3.default.ICON_NAME_FROM_TYPE) {
        return _constants3.default.ICON_NAME_FROM_TYPE[fileType];
    }

    return 'generic';
}

function splitFileLocation(fileLocation) {
    var fileSplit = fileLocation.split('.');

    var ext = '';
    if (fileSplit.length > 1) {
        ext = fileSplit[fileSplit.length - 1];
        fileSplit.splice(fileSplit.length - 1, 1);
    }

    var filePath = fileSplit.join('.');
    var filename = filePath.split('/')[filePath.split('/').length - 1];

    return { ext: ext, name: filename, path: filePath };
}

function sortFilesByName(files) {
    var locale = _localization_store2.default.getLocale();
    return (0, _from2.default)(files).sort(function (a, b) {
        return a.name.localeCompare(b.name, locale, { numeric: true });
    });
}

function toTitleCase(str) {
    function doTitleCase(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
    return str.replace(/\w\S*/g, doTitleCase);
}

function isHexColor(value) {
    return value && /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(value);
}

function applyTheme(theme) {
    if (theme.sidebarBg) {
        changeCss('.app__body .sidebar--left .sidebar__switcher, .sidebar--left, .sidebar--left .sidebar__divider .sidebar__divider__text, .app__body .modal .settings-modal .settings-table .settings-links, .app__body .sidebar--menu', 'background:' + theme.sidebarBg);
        changeCss('body.app__body', 'scrollbar-face-color:' + theme.sidebarBg);
        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal:not(.settings-modal--tabless):not(.display--content) .modal-content', 'background:' + theme.sidebarBg);
    }

    if (theme.sidebarText) {
        changeCss('.app__body .ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y', 'background:' + theme.sidebarText);
        changeCss('.app__body .ps-container:hover .ps-scrollbar-y-rail:hover, .app__body .sidebar__switcher button:hover', 'background:' + changeOpacity(theme.sidebarText, 0.15));
        changeCss('.app__body .sidebar--left .nav-pills__container li > h4, .app__body .sidebar--left .nav-pills__container li .sidebar-item, .app__body .sidebar--left .nav-pills__container li > .nav-more, .app__body .sidebar--right, .app__body .modal .settings-modal .nav-pills>li button', 'color:' + changeOpacity(theme.sidebarText, 0.6));
        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .settings-table .nav>li>a, .app__body .sidebar--menu', 'color:' + changeOpacity(theme.sidebarText, 0.8));
        changeCss('.app__body .sidebar--left .add-channel-btn', 'color:' + changeOpacity(theme.sidebarText, 0.8));
        changeCss('.sidebar--left .add-channel-btn:hover, .sidebar--left .add-channel-btn:focus', 'color:' + theme.sidebarText);
        changeCss('.sidebar--left .status .offline--icon, .app__body .sidebar--menu svg, .app__body .sidebar-item .icon', 'fill:' + theme.sidebarText);
        changeCss('.sidebar--left .status.status--group', 'background:' + changeOpacity(theme.sidebarText, 0.3));
        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .settings-table .nav>li>button, .app__body .sidebar--menu .divider', 'border-color:' + changeOpacity(theme.sidebarText, 0.2));
        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .settings-table .nav>li>button, .app__body .modal .settings-modal .settings-table .nav>li.active>button', 'color:' + theme.sidebarText);
        changeCss('.app__body .sidebar--left .sidebar__switcher', 'border-color:' + changeOpacity(theme.sidebarText, 0.2));
        changeCss('@media(max-width: 768px){.sidebar--left .add-channel-btn:hover, .sidebar--left .add-channel-btn:focus', 'color:' + changeOpacity(theme.sidebarText, 0.6));
        changeCss('@media(max-width: 768px){.app__body .search__icon svg', 'stroke:' + theme.sidebarText);
        changeCss('.app__body .sidebar--left .sidebar__switcher span', 'color:' + theme.sidebarText);
        changeCss('.app__body .sidebar--left .sidebar__switcher button svg', 'fill:' + theme.sidebarText);
        changeCss('.app__body .sidebar__switcher button', 'background:' + changeOpacity(theme.sidebarText, 0.08));
    }

    if (theme.sidebarUnreadText) {
        changeCss('.sidebar--left .nav-pills__container li .sidebar-item.unread-title', 'color:' + theme.sidebarUnreadText);
    }

    if (theme.sidebarTextHoverBg) {
        changeCss('.sidebar--left .nav-pills__container li .sidebar-item:hover, .sidebar--left .nav-pills__container li > .nav-more:hover, .app__body .modal .settings-modal .nav-pills>li:hover button', 'background:' + theme.sidebarTextHoverBg);
    }

    if (theme.sidebarTextActiveBorder) {
        changeCss('.sidebar--left .nav li.active .sidebar-item:before, .app__body .modal .settings-modal .nav-pills>li.active button:before', 'background:' + theme.sidebarTextActiveBorder);
        changeCss('.sidebar--left .sidebar__divider:before', 'background:' + changeOpacity(theme.sidebarTextActiveBorder, 0.5));
        changeCss('.sidebar--left .sidebar__divider', 'color:' + theme.sidebarTextActiveBorder);
        changeCss('.multi-teams .team-sidebar .team-wrapper .team-container.active:before', 'background:' + theme.sidebarTextActiveBorder);
        changeCss('.multi-teams .team-sidebar .team-wrapper .team-container.unread:before', 'background:' + theme.sidebarTextActiveBorder);
    }

    if (theme.sidebarTextActiveColor) {
        changeCss('.sidebar--left .nav-pills__container li.active .sidebar-item, .sidebar--left .nav-pills__container li.active .sidebar-item:hover, .sidebar--left .nav-pills__container li.active .sidebar-item:focus, .app__body .modal .settings-modal .nav-pills>li.active button, .app__body .modal .settings-modal .nav-pills>li.active button:hover, .app__body .modal .settings-modal .nav-pills>li.active button:active', 'color:' + theme.sidebarTextActiveColor);
        changeCss('.sidebar--left .nav li.active .sidebar-item, .sidebar--left .nav li.active .sidebar-item:hover, .sidebar--left .nav li.active .sidebar-item:focus', 'background:' + changeOpacity(theme.sidebarTextActiveColor, 0.1));
        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .nav-pills > li.active button', 'color:' + changeOpacity(theme.sidebarText, 0.8));
    }

    if (theme.sidebarHeaderBg) {
        changeCss('.app__body #status-dropdown .status-wrapper .status, .app__body #status-dropdown .status-wrapper .status-edit, .sidebar--left .team__header, .app__body .sidebar--menu .team__header, .app__body .post-list__timestamp > div', 'background:' + theme.sidebarHeaderBg);
        changeCss('.app__body .modal .modal-header', 'background:' + theme.sidebarHeaderBg);
        changeCss('.app__body .multi-teams .team-sidebar, .app__body #navbar .navbar-default', 'background:' + theme.sidebarHeaderBg);
        changeCss('@media(max-width: 768px){.app__body .search-bar__container', 'background:' + theme.sidebarHeaderBg);
        changeCss('.app__body .attachment .attachment__container', 'border-left-color:' + theme.sidebarHeaderBg);
    }

    if (theme.sidebarHeaderTextColor) {
        changeCss('.app__body #status-dropdown .status-wrapper .status, .app__body #status-dropdown .status-wrapper .status-edit, .multi-teams .team-sidebar .team-wrapper .team-container .team-btn, .sidebar--left .team__header .header__info, .app__body .sidebar--menu .team__header .header__info, .app__body .post-list__timestamp > div', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .icon--sidebarHeaderTextColor svg, .app__body .sidebar-header-dropdown__icon svg', 'fill:' + theme.sidebarHeaderTextColor);
        changeCss('.sidebar--left .team__header .user__name, .app__body .sidebar--menu .team__header .user__name', 'color:' + changeOpacity(theme.sidebarHeaderTextColor, 0.8));
        changeCss('.sidebar--left .team__header:hover .user__name, .app__body .sidebar--menu .team__header:hover .user__name', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .modal .modal-header .modal-title, .app__body .modal .modal-header .modal-title .name, .app__body .modal .modal-header button.close', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body #navbar .navbar-default .navbar-brand .dropdown-toggle', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body #navbar .navbar-default .navbar-toggle .icon-bar', 'background:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .post-list__timestamp > div, .app__body .multi-teams .team-sidebar .team-wrapper .team-container a:hover .team-btn, .app__body .multi-teams .team-sidebar .team-wrapper .team-container.active .team-btn', 'border-color:' + changeOpacity(theme.sidebarHeaderTextColor, 0.5));
        changeCss('@media(max-width: 768px){.app__body .search-bar__container', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .navbar-right__icon', 'background:' + changeOpacity(theme.sidebarHeaderTextColor, 0.2));
        changeCss('.app__body .navbar-right__icon:hover, .app__body .navbar-right__icon:focus', 'background:' + changeOpacity(theme.sidebarHeaderTextColor, 0.3));
        changeCss('.app__body .navbar-right__icon svg', 'fill:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .navbar-right__icon svg', 'stroke:' + theme.sidebarHeaderTextColor);
    }

    if (theme.onlineIndicator) {
        changeCss('.app__body .status.status--online', 'color:' + theme.onlineIndicator);
        changeCss('.app__body .status .online--icon', 'fill:' + theme.onlineIndicator);
    }

    if (theme.awayIndicator) {
        changeCss('.app__body .status.status--away', 'color:' + theme.awayIndicator);
        changeCss('.app__body .status .away--icon', 'fill:' + theme.awayIndicator);
    }

    var dndIndicator = void 0;
    if (theme.dndIndicator) {
        dndIndicator = theme.dndIndicator;
    } else {
        switch (theme.type) {
            case 'Organization':
                dndIndicator = _constants3.default.THEMES.organization.dndIndicator;
                break;
            case 'Mattermost Dark':
                dndIndicator = _constants3.default.THEMES.mattermostDark.dndIndicator;
                break;
            case 'Windows Dark':
                dndIndicator = _constants3.default.THEMES.windows10.dndIndicator;
                break;
            default:
                dndIndicator = _constants3.default.THEMES.default.dndIndicator;
                break;
        }
    }
    changeCss('.app__body .status.status--dnd', 'color:' + dndIndicator);
    changeCss('.app__body .status .dnd--icon', 'fill:' + dndIndicator);

    // Including 'mentionBj' for backwards compatability (old typo)
    var mentionBg = theme.mentionBg || theme.mentionBj;
    if (mentionBg) {
        changeCss('.sidebar--left .nav-pills__unread-indicator', 'background:' + mentionBg);
        changeCss('.app__body .sidebar--left .badge, .app__body .list-group-item.active > .badge, .nav-pills > .active > a > .badge', 'background:' + mentionBg);
        changeCss('.multi-teams .team-sidebar .badge, .app__body .list-group-item.active > .badge, .nav-pills > .active > a > .badge', 'background:' + mentionBg);
    }

    if (theme.mentionColor) {
        changeCss('.sidebar--left .nav-pills__unread-indicator svg', 'fill:' + theme.mentionColor);
        changeCss('.app__body .sidebar--left .nav-pills__unread-indicator', 'color:' + theme.mentionColor);
        changeCss('.app__body .sidebar--left .badge, .app__body .list-group-item.active > .badge, .nav-pills > .active > a > .badge', 'color:' + theme.mentionColor);
        changeCss('.app__body .multi-teams .team-sidebar .badge, .app__body .list-group-item.active > .badge, .nav-pills > .active > a > .badge', 'color:' + theme.mentionColor);
    }

    if (theme.centerChannelBg) {
        changeCss('@media(max-width: 640px){.app__body .post .dropdown .dropdown-menu button', 'background:' + theme.centerChannelBg);
        changeCss('@media(min-width: 768px){.app__body .post:hover .post__header .col__reply, .app__body .post.post--hovered .post__header .col__reply', 'background:' + theme.centerChannelBg);
        changeCss('@media(max-width: 320px){.tutorial-steps__container', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .channel-header__info .channel-header__description:before, .app__body .app__content, .app__body .markdown__table, .app__body .markdown__table tbody tr, .app__body .suggestion-list__content, .app__body .modal .modal-content, .app__body .modal .modal-footer, .app__body .post.post--compact .post-image__column, .app__body .suggestion-list__divider > span, .app__body .status-wrapper .status, .app__body .alert.alert-transparent, .app__body .post-image__column', 'background:' + theme.centerChannelBg);
        changeCss('#post-list .post-list-holder-by-time, .app__body .post .dropdown-menu a', 'background:' + theme.centerChannelBg);
        changeCss('#post-create, .app__body .emoji-picker__preview', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .date-separator .separator__text, .app__body .new-separator .separator__text', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .post-image__details, .app__body .search-help-popover .search-autocomplete__divider span', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .sidebar--right, .app__body .dropdown-menu, .app__body .popover, .app__body .tip-overlay', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .popover.bottom>.arrow:after', 'border-bottom-color:' + theme.centerChannelBg);
        changeCss('.app__body .popover.right>.arrow:after, .app__body .tip-overlay.tip-overlay--sidebar .arrow, .app__body .tip-overlay.tip-overlay--header .arrow', 'border-right-color:' + theme.centerChannelBg);
        changeCss('.app__body .popover.left>.arrow:after', 'border-left-color:' + theme.centerChannelBg);
        changeCss('.app__body .popover.top>.arrow:after, .app__body .tip-overlay.tip-overlay--chat .arrow', 'border-top-color:' + theme.centerChannelBg);
        changeCss('@media(min-width: 768px){.app__body .form-control', 'background:' + theme.centerChannelBg);
        changeCss('@media(min-width: 768px){.app__body .sidebar--right.sidebar--right--expanded .sidebar-right-container', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .attachment__content, .app__body .attachment-actions button', 'background:' + theme.centerChannelBg);
        changeCss('body.app__body', 'scrollbar-face-color:' + theme.centerChannelBg);
        changeCss('body.app__body', 'scrollbar-track-color:' + theme.centerChannelBg);
        changeCss('.app__body .shortcut-key, .app__body .post-list__new-messages-below', 'color:' + theme.centerChannelBg);
        changeCss('.app__body .emoji-picker, .app__body .emoji-picker__search', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .nav-tabs, .app__body .nav-tabs > li.active > a', 'background:' + theme.centerChannelBg);
    }

    if (theme.centerChannelColor) {
        changeCss('.app__body .mentions__name .status.status--group, .app__body .multi-select__note', 'background:' + changeOpacity(theme.centerChannelColor, 0.12));
        changeCss('.app__body .file-view--single .file__image .image-loaded, .app__body .post .dropdown .dropdown-menu button, .app__body .member-list__popover .more-modal__body, .app__body .alert.alert-transparent, .app__body .channel-header .channel-header__icon, .app__body .search-bar__container .search__form, .app__body .table > thead > tr > th, .app__body .table > tbody > tr > td', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.12));
        changeCss('.app__body .post-list__arrows, .app__body .post .flag-icon__container', 'fill:' + changeOpacity(theme.centerChannelColor, 0.3));
        changeCss('@media(min-width: 768px){.app__body .search__icon svg', 'stroke:' + changeOpacity(theme.centerChannelColor, 0.4));
        changeCss('.app__body .post-image__details .post-image__download svg', 'stroke:' + changeOpacity(theme.centerChannelColor, 0.4));
        changeCss('.app__body .post-image__details .post-image__download svg', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.35));
        changeCss('.app__body .channel-header__icon svg', 'fill:' + changeOpacity(theme.centerChannelColor, 0.4));
        changeCss('.app__body .channel-header__icon .icon--stroke svg', 'stroke:' + changeOpacity(theme.centerChannelColor, 0.4));
        changeCss('.app__body .channel-header__icon .icon--stroke.icon__search svg', 'stroke:' + changeOpacity(theme.centerChannelColor, 0.55));
        changeCss('.app__body .modal .status .offline--icon, .app__body .channel-header__links .icon, .app__body .sidebar--right .sidebar--right__subheader .usage__icon, .app__body .more-modal__header svg, .app__body .icon--body', 'fill:' + theme.centerChannelColor);
        changeCss('@media(min-width: 768px){.app__body .post:hover .post__header .col__reply, .app__body .post.post--hovered .post__header .col__reply', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .modal .shortcuts-modal .subsection, .app__body .sidebar--right .sidebar--right__header, .app__body .channel-header, .app__body .nav-tabs > li > a:hover, .app__body .nav-tabs, .app__body .nav-tabs > li.active > a, .app__body .nav-tabs, .app__body .nav-tabs > li.active > a:focus, .app__body .nav-tabs, .app__body .nav-tabs > li.active > a:hover, .app__body .post .dropdown-menu a, .sidebar--left, .app__body .suggestion-list__content .command', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .post.post--system .post__body, .app__body .modal .channel-switch-modal .modal-header .close', 'color:' + changeOpacity(theme.centerChannelColor, 0.6));
        changeCss('.app__body .nav-tabs, .app__body .nav-tabs > li.active > a, pp__body .input-group-addon, .app__body .app__content, .app__body .post-create__container .post-create-body .btn-file, .app__body .post-create__container .post-create-footer .msg-typing, .app__body .suggestion-list__content .command, .app__body .modal .modal-content, .app__body .dropdown-menu, .app__body .popover, .app__body .mentions__name, .app__body .tip-overlay, .app__body .form-control[disabled], .app__body .form-control[readonly], .app__body fieldset[disabled] .form-control', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .post .post__link', 'color:' + changeOpacity(theme.centerChannelColor, 0.65));
        changeCss('.app__body #archive-link-home, .video-div .video-thumbnail__error', 'background:' + changeOpacity(theme.centerChannelColor, 0.15));
        changeCss('.app__body #post-create', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .mentions--top, .app__body .suggestion-list', 'box-shadow:' + changeOpacity(theme.centerChannelColor, 0.2) + ' 1px -3px 12px');
        changeCss('.app__body .mentions--top, .app__body .suggestion-list', '-webkit-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.2) + ' 1px -3px 12px');
        changeCss('.app__body .mentions--top, .app__body .suggestion-list', '-moz-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.2) + ' 1px -3px 12px');
        changeCss('.app__body .dropdown-menu, .app__body .popover ', 'box-shadow: 0 17px 50px 0 ' + changeOpacity(theme.centerChannelColor, 0.1) + ', 0 12px 15px 0 ' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('.app__body .dropdown-menu, .app__body .popover ', '-moz-box-shadow: 0 17px 50px 0 ' + changeOpacity(theme.centerChannelColor, 0.1) + ', 0 12px 15px 0 ' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('.app__body .dropdown-menu, .app__body .popover ', '-webkit-box-shadow: 0 17px 50px 0 ' + changeOpacity(theme.centerChannelColor, 0.1) + ', 0 12px 15px 0 ' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('.app__body .shortcut-key, .app__body .post__body hr, .app__body .loading-screen .loading__content .round, .app__body .tutorial__circles .circle', 'background:' + theme.centerChannelColor);
        changeCss('.app__body .channel-header .heading', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .markdown__table tbody tr:nth-child(2n)', 'background:' + changeOpacity(theme.centerChannelColor, 0.07));
        changeCss('.app__body .channel-header__info .header-dropdown__icon', 'color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .post-create__container .post-create-body .send-button.disabled i, .app__body .channel-header #member_popover', 'color:' + changeOpacity(theme.centerChannelColor, 0.4));
        changeCss('.app__body .channel-header .pinned-posts-button svg', 'fill:' + changeOpacity(theme.centerChannelColor, 0.6));
        changeCss('.app__body .custom-textarea, .app__body .custom-textarea:focus, .app__body .file-preview, .app__body .post-image__details, .app__body .sidebar--right .sidebar-right__body, .app__body .markdown__table th, .app__body .markdown__table td, .app__body .suggestion-list__content, .app__body .modal .modal-content, .app__body .modal .settings-modal .settings-table .settings-content .divider-light, .app__body .webhooks__container, .app__body .dropdown-menu, .app__body .modal .modal-header', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .popover.bottom>.arrow', 'border-bottom-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .search-help-popover .search-autocomplete__divider span, .app__body .suggestion-list__divider > span', 'color:' + changeOpacity(theme.centerChannelColor, 0.7));
        changeCss('.app__body .popover.right>.arrow', 'border-right-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .popover.left>.arrow', 'border-left-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .popover.top>.arrow', 'border-top-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .suggestion-list__content .command, .app__body .popover .popover-title', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .suggestion-list__content .command, .app__body .popover .popover__row', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .suggestion-list__divider:before, .app__body .dropdown-menu .divider, .app__body .search-help-popover .search-autocomplete__divider:before', 'background:' + theme.centerChannelColor);
        changeCss('.app__body .custom-textarea', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .post-image__column', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('.app__body .post-image__details', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .post-image__column a, .app__body .post-image__column a:hover, .app__body .post-image__column a:focus', 'color:' + theme.centerChannelColor);
        changeCss('@media(min-width: 768px){.app__body .search-bar__container .search__form .search-bar, .app__body .form-control', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .input-group-addon, .app__body .form-control, .app__body .post-create__container .post-body__actions > span, .app__body .post-create__container .post-body__actions > a', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('@media(min-width: 768px){.app__body .post-list__table .post-list__content .dropdown-menu a:hover, .dropdown-menu > li > button:hover', 'background:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('.app__body .form-control:focus', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .attachment .attachment__content, .app__body .attachment-actions button', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.3));
        changeCss('.app__body .attachment-actions button:focus, .app__body .attachment-actions button:hover', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.5));
        changeCss('.app__body .attachment-actions button:focus, .app__body .attachment-actions button:hover', 'background:' + changeOpacity(theme.centerChannelColor, 0.03));
        changeCss('.app__body .input-group-addon, .app__body .channel-intro .channel-intro__content, .app__body .webhooks__container', 'background:' + changeOpacity(theme.centerChannelColor, 0.05));
        changeCss('.app__body .date-separator .separator__text', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .date-separator .separator__hr, .app__body .modal-footer, .app__body .modal .custom-textarea', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .search-item-container, .app__body .post-right__container .post.post--root', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('.app__body .modal .custom-textarea:focus', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.3));
        changeCss('.app__body .channel-intro, .app__body .modal .settings-modal .settings-table .settings-content .divider-dark, .app__body hr, .app__body .modal .settings-modal .settings-table .settings-links, .app__body .modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header, .app__body .user-settings .authorized-app:not(:last-child)', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .post.current--user .post__body, .app__body .post.post--comment.other--root.current--user .post-comment, .app__body pre, .app__body .post-right__container .post.post--root', 'background:' + changeOpacity(theme.centerChannelColor, 0.05));
        changeCss('.app__body .post.post--comment.other--root.current--user .post-comment, .app__body .more-modal__list .more-modal__row, .app__body .member-div:first-child, .app__body .member-div, .app__body .access-history__table .access__report, .app__body .activity-log__table', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('@media(max-width: 1800px){.app__body .inner-wrap.move--left .post.post--comment.same--root', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.07));
        changeCss('.app__body .post.post--hovered', 'background:' + changeOpacity(theme.centerChannelColor, 0.08));
        changeCss('.app__body .attachment__body__wrap.btn-close', 'background:' + changeOpacity(theme.centerChannelColor, 0.08));
        changeCss('.app__body .attachment__body__wrap.btn-close', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('@media(min-width: 768px){.app__body .post:hover, .app__body .more-modal__list .more-modal__row:hover, .app__body .modal .settings-modal .settings-table .settings-content .section-min:hover', 'background:' + changeOpacity(theme.centerChannelColor, 0.08));
        changeCss('.app__body .more-modal__row.more-modal__row--selected, .app__body .date-separator.hovered--before:after, .app__body .date-separator.hovered--after:before, .app__body .new-separator.hovered--after:before, .app__body .new-separator.hovered--before:after', 'background:' + changeOpacity(theme.centerChannelColor, 0.07));
        changeCss('@media(min-width: 768px){.app__body .suggestion-list__content .command:hover, .app__body .mentions__name:hover, .app__body .dropdown-menu>li>a:focus, .app__body .dropdown-menu>li>a:hover', 'background:' + changeOpacity(theme.centerChannelColor, 0.15));
        changeCss('.app__body .suggestion--selected, .app__body .emoticon-suggestion:hover, .app__body .bot-indicator', 'background:' + changeOpacity(theme.centerChannelColor, 0.15));
        changeCss('code, .app__body .form-control[disabled], .app__body .form-control[readonly], .app__body fieldset[disabled] .form-control', 'background:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('@media(min-width: 960px){.app__body .post.current--user:hover .post__body ', 'background: none;');
        changeCss('.app__body .sidebar--right', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .search-help-popover .search-autocomplete__item:hover, .app__body .modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__body', 'background:' + changeOpacity(theme.centerChannelColor, 0.05));
        changeCss('.app__body .search-help-popover .search-autocomplete__item.selected', 'background:' + changeOpacity(theme.centerChannelColor, 0.15));
        if (!UserAgent.isFirefox() && !UserAgent.isInternetExplorer() && !UserAgent.isEdge()) {
            changeCss('body.app__body ::-webkit-scrollbar-thumb', 'background:' + changeOpacity(theme.centerChannelColor, 0.4));
        }
        changeCss('body', 'scrollbar-arrow-color:' + theme.centerChannelColor);
        changeCss('.app__body .post-create__container .post-create-body .btn-file svg, .app__body .post.post--compact .post-image__column .post-image__details svg, .app__body .modal .about-modal .about-modal__logo svg, .app__body .post .post__img svg, .app__body .post-body__actions svg, .app__body .edit-post__actions .icon svg', 'fill:' + theme.centerChannelColor);
        changeCss('.app__body .scrollbar--horizontal, .app__body .scrollbar--vertical', 'background:' + changeOpacity(theme.centerChannelColor, 0.5));
        changeCss('.app__body .post-list__new-messages-below', 'background:' + changeColor(theme.centerChannelColor, 0.5));
        changeCss('.app__body .post.post--comment .post__body', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('@media(min-width: 768px){.app__body .post.post--compact.same--root.post--comment .post__content', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .post.post--comment.current--user .post__body', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .channel-header__info .status .offline--icon', 'fill:' + theme.centerChannelColor);
        changeCss('.app__body .navbar .status .offline--icon', 'fill:' + theme.centerChannelColor);
        changeCss('.app__body .post-reaction:not(.post-reaction--current-user)', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .post-reaction:not(.post-reaction--current-user)', 'color:' + changeOpacity(theme.centerChannelColor, 0.7));
        changeCss('.app__body .emoji-picker', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .emoji-picker', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .emoji-picker__preview, .app__body .emoji-picker__items, .app__body .emoji-picker__search-container', 'border-top-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .emoji-picker__items', 'background-color:' + changeOpacity(theme.centerChannelColor, 0.05));
        changeCss('.emoji-picker__category .fa:hover', 'color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .emoji-picker__category, .app__body .emoji-picker__category:focus, .app__body .emoji-picker__category:hover', 'color:' + changeOpacity(theme.centerChannelColor, 0.3));
        changeCss('.app__body .emoji-picker__category--selected, .app__body .emoji-picker__category--selected:focus, .app__body .emoji-picker__category--selected:hover', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .emoji-picker__item-wrapper:hover', 'background-color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .emoji-picker-items__container .emoji-picker__item.selected', 'background-color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .icon__postcontent_picker:hover', 'color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .popover', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.07));
    }

    if (theme.newMessageSeparator) {
        changeCss('.app__body .new-separator .separator__text', 'color:' + theme.newMessageSeparator);
        changeCss('.app__body .new-separator .separator__hr', 'border-color:' + changeOpacity(theme.newMessageSeparator, 0.5));
    }

    if (theme.linkColor) {
        changeCss('.app__body .webrtc__header:not(.offline) button:hover, .app__body .post-add-reaction:hover .post-reaction, .app__body .channel-header .channel-header__favorites.inactive:hover, .app__body .channel-header__links > a.active, .app__body a, .app__body a:focus, .app__body a:hover, .app__body .channel-header__links > .color--link.active, .app__body .color--link, .app__body a:focus, .app__body .color--link:hover, .app__body .btn, .app__body .btn:focus, .app__body .btn:hover', 'color:' + theme.linkColor);
        changeCss('.app__body .attachment .attachment__container', 'border-left-color:' + changeOpacity(theme.linkColor, 0.5));
        changeCss('.app__body .member-list__popover .more-modal__list .more-modal__row:hover', 'background:' + changeOpacity(theme.linkColor, 0.08));
        changeCss('.app__body .channel-header__links .icon:hover, .app__body .channel-header__links > a.active .icon, .app__body .post .flag-icon__container.visible, .app__body .post .reacticon__container, .app__body .post .comment-icon__container, .app__body .post .post__reply', 'fill:' + theme.linkColor);
        changeCss('@media(min-width: 768px){.app__body .search__form.focused .search__icon svg', 'stroke:' + theme.linkColor);
        changeCss('.app__body .channel-header__links .icon:hover, .app__body .post .flag-icon__container.visible, .app__body .post .comment-icon__container, .app__body .post .post__reply', 'fill:' + theme.linkColor);
        changeCss('.app__body .channel-header .channel-header__icon:hover #member_popover, .app__body .channel-header .channel-header__icon.active #member_popover', 'color:' + theme.linkColor);
        changeCss('.app__body .channel-header .pinned-posts-button:hover svg', 'fill:' + changeOpacity(theme.linkColor, 0.6));
        changeCss('.app__body .member-list__popover .more-modal__actions svg, .app__body .channel-header .channel-header__icon:hover svg, .app__body .channel-header .channel-header__icon.active svg', 'fill:' + theme.linkColor);
        changeCss('.app__body .channel-header .channel-header__icon:hover .icon--stroke svg', 'stroke:' + theme.linkColor);
        changeCss('.app__body .post-reaction.post-reaction--current-user', 'background:' + changeOpacity(theme.linkColor, 0.1));
        changeCss('.app__body .post-add-reaction:hover .post-reaction, .app__body .post-reaction.post-reaction--current-user', 'border-color:' + changeOpacity(theme.linkColor, 0.4));
        changeCss('.app__body .member-list__popover .more-modal__list .more-modal__row:hover, .app__body .channel-header .channel-header__icon:hover, .app__body .channel-header .channel-header__icon.active, .app__body .search-bar__container .search__form.focused', 'border-color:' + theme.linkColor);
        changeCss('.app__body .post-reaction.post-reaction--current-user', 'color:' + theme.linkColor);
        changeCss('.app__body .channel-header .dropdown-toggle:hover .heading, .app__body .channel-header .dropdown-toggle:hover .header-dropdown__icon, .app__body .channel-header__title .open .heading, .app__body .channel-header__info .channel-header__title .open .header-dropdown__icon, .app__body .channel-header__title .open .heading, .app__body .channel-header__info .channel-header__title .open .heading', 'color:' + theme.linkColor);
        changeCss('.emoji-picker__container .icon--emoji.active svg', 'fill:' + theme.linkColor);
        changeCss('.sidebar--right--expanded .sidebar--right__expand', 'color:' + theme.linkColor);
    }

    if (theme.buttonBg) {
        changeCss('.app__body .post-image__details .post-image__download svg:hover, .app__body .file-view--single .file__download:hover, .app__body .new-messages__button div, .app__body .btn.btn-primary, .app__body .tutorial__circles .circle.active, .app__body .post__pinned-badge', 'background:' + theme.buttonBg);
        changeCss('.app__body .post-image__details .post-image__download svg:hover', 'border-color:' + theme.buttonBg);
        changeCss('.app__body .btn.btn-primary:hover, .app__body .btn.btn-primary:active, .app__body .btn.btn-primary:focus', 'background:' + changeColor(theme.buttonBg, -0.15));
    }

    if (theme.buttonColor) {
        changeCss('.app__body .new-messages__button div, .app__body .btn.btn-primary, .app__body .post__pinned-badge', 'color:' + theme.buttonColor);
        changeCss('.app__body .new-messages__button svg', 'fill:' + theme.buttonColor);
        changeCss('.app__body .post-image__details .post-image__download svg:hover, .app__body .file-view--single .file__download svg', 'stroke:' + theme.buttonColor);
    }

    if (theme.errorTextColor) {
        changeCss('.app__body .color--error, .app__body .has-error .help-block, .app__body .has-error .control-label, .app__body .has-error .radio, .app__body .has-error .checkbox, .app__body .has-error .radio-inline, .app__body .has-error .checkbox-inline, .app__body .has-error.radio label, .app__body .has-error.checkbox label, .app__body .has-error.radio-inline label, .app__body .has-error.checkbox-inline label', 'color:' + theme.errorTextColor);
    }

    if (theme.mentionHighlightBg) {
        changeCss('.app__body .mention--highlight, .app__body .search-highlight', 'background:' + theme.mentionHighlightBg);
        changeCss('.app__body .post.post--comment .post__body.mention-comment', 'border-color:' + theme.mentionHighlightBg);
        changeCss('.app__body .post.post--highlight', 'background:' + changeOpacity(theme.mentionHighlightBg, 0.5));
    }

    if (theme.mentionHighlightLink) {
        changeCss('.app__body .mention--highlight .mention-link, .app__body .mention--highlight, .app__body .search-highlight', 'color:' + theme.mentionHighlightLink);
    }

    if (!theme.codeTheme) {
        theme.codeTheme = _constants3.default.DEFAULT_CODE_THEME;
    }
    updateCodeTheme(theme.codeTheme);
}

function resetTheme() {
    applyTheme(_constants3.default.THEMES.default);
}

function changeCss(className, classValue) {
    var styleEl = document.querySelector('style[data-class="' + className + '"]');
    if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.setAttribute('data-class', className);

        // Append style element to head
        document.head.appendChild(styleEl);
    }

    // Grab style sheet
    var styleSheet = styleEl.sheet;
    var rules = styleSheet.cssRules || styleSheet.rules;
    var style = classValue.substr(0, classValue.indexOf(':'));
    var value = classValue.substr(classValue.indexOf(':') + 1);

    for (var i = 0; i < rules.length; i++) {
        if (rules[i].selectorText === className) {
            rules[i].style[style] = value;
            return;
        }
    }

    var mediaQuery = '';
    if (className.indexOf('@media') >= 0) {
        mediaQuery = '}';
    }
    try {
        styleSheet.insertRule(className + '{' + classValue + '}' + mediaQuery, styleSheet.cssRules.length);
    } catch (e) {
        console.error(e); // eslint-disable-line no-console
    }
}

function updateCodeTheme(userTheme) {
    var cssPath = '';
    _constants3.default.THEME_ELEMENTS.forEach(function (element) {
        if (element.id === 'codeTheme') {
            element.themes.forEach(function (theme) {
                if (userTheme === theme.id) {
                    cssPath = theme.cssURL;
                }
            });
        }
    });
    var $link = (0, _jquery2.default)('link.code_theme');
    if (cssPath !== $link.attr('href')) {
        changeCss('code.hljs', 'visibility: hidden');
        var xmlHTTP = new XMLHttpRequest();
        xmlHTTP.open('GET', cssPath, true);
        xmlHTTP.onload = function onLoad() {
            $link.attr('href', cssPath);
            if (UserAgent.isFirefox()) {
                $link.one('load', function () {
                    changeCss('code.hljs', 'visibility: visible');
                });
            } else {
                changeCss('code.hljs', 'visibility: visible');
            }
        };
        xmlHTTP.send();
    }
}

function placeCaretAtEnd(el) {
    el.focus();
    el.selectionStart = el.value.length;
    el.selectionEnd = el.value.length;
}

function getCaretPosition(el) {
    if (el.selectionStart) {
        return el.selectionStart;
    } else if (document.selection) {
        el.focus();

        var r = document.selection.createRange();
        if (r == null) {
            return 0;
        }

        var re = el.createTextRange();
        var rc = re.duplicate();
        re.moveToBookmark(r.getBookmark());
        rc.setEndPoint('EndToStart', re);

        return rc.text.length;
    }
    return 0;
}

function setSelectionRange(input, selectionStart, selectionEnd) {
    if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveEnd('character', selectionEnd);
        range.moveStart('character', selectionStart);
        range.select();
    }
}

function setCaretPosition(input, pos) {
    setSelectionRange(input, pos, pos);
}

function getSelectedText(input) {
    var selectedText;
    if (typeof document.selection !== 'undefined') {
        input.focus();
        var sel = document.selection.createRange();
        selectedText = sel.text;
    } else if (typeof input.selectionStart !== 'undefined') {
        var startPos = input.selectionStart;
        var endPos = input.selectionEnd;
        selectedText = input.value.substring(startPos, endPos);
    }

    return selectedText;
}

function isValidUsername(name) {
    var error = '';
    if (!name) {
        error = 'This field is required';
    } else if (name.length < _constants3.default.MIN_USERNAME_LENGTH || name.length > _constants3.default.MAX_USERNAME_LENGTH) {
        error = 'Must be between ' + _constants3.default.MIN_USERNAME_LENGTH + ' and ' + _constants3.default.MAX_USERNAME_LENGTH + ' characters';
    } else if (!/^[a-z0-9.\-_]+$/.test(name)) {
        error = "Must contain only letters, numbers, and the symbols '.', '-', and '_'.";
    } else if (!/[a-z]/.test(name.charAt(0))) {
        //eslint-disable-line no-negated-condition
        error = 'First character must be a letter.';
    } else {
        for (var i = 0; i < _constants3.default.RESERVED_USERNAMES.length; i++) {
            if (name === _constants3.default.RESERVED_USERNAMES[i]) {
                error = 'Cannot use a reserved word as a username.';
                break;
            }
        }
    }

    return error;
}

function isMobile() {
    return window.innerWidth <= _constants3.default.MOBILE_SCREEN_WIDTH;
}

function getDirectTeammate(channelId) {
    var teammate = {};

    var channel = _channel_store2.default.get(channelId);
    if (!channel) {
        return teammate;
    }

    var userIds = channel.name.split('__');
    var curUserId = _user_store2.default.getCurrentId();

    if (userIds.length !== 2 || userIds.indexOf(curUserId) === -1) {
        return teammate;
    }

    if (userIds[0] === userIds[1]) {
        return _user_store2.default.getProfile(userIds[0]);
    }

    for (var idx in userIds) {
        if (userIds[idx] !== curUserId) {
            teammate = _user_store2.default.getProfile(userIds[idx]);
            break;
        }
    }

    return teammate;
}

function loadImage(url, onLoad, onProgress) {
    var request = new XMLHttpRequest();

    request.open('GET', url, true);
    request.responseType = 'arraybuffer';
    request.onload = onLoad;
    request.onprogress = function (e) {
        if (onProgress) {
            var completedPercentage = Math.round(e.loaded / e.total * 100);

            onProgress(completedPercentage);
        }
    };

    request.send();
}

function changeColor(colourIn, amt) {
    var hex = colourIn;
    var lum = amt;

    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = '#';
    var c;
    var i;
    for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        rgb += ('00' + c).substr(c.length);
    }

    return rgb;
}

function changeOpacity(oldColor, opacity) {
    var color = oldColor;
    if (color[0] === '#') {
        color = color.slice(1);
    }

    if (color.length === 3) {
        var tempColor = color;
        color = '';

        color += tempColor[0] + tempColor[0];
        color += tempColor[1] + tempColor[1];
        color += tempColor[2] + tempColor[2];
    }

    var r = parseInt(color.substring(0, 2), 16);
    var g = parseInt(color.substring(2, 4), 16);
    var b = parseInt(color.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
}

function getFullName(user) {
    if (user.first_name && user.last_name) {
        return user.first_name + ' ' + user.last_name;
    } else if (user.first_name) {
        return user.first_name;
    } else if (user.last_name) {
        return user.last_name;
    }

    return '';
}

function getDisplayName(user) {
    if (user.nickname && user.nickname.trim().length > 0) {
        return user.nickname;
    }
    var fullName = getFullName(user);

    if (fullName) {
        return fullName;
    }

    return user.username;
}

/**
 * Gets the display name of the user with the specified id, respecting the TeammateNameDisplay configuration setting
 */
function getDisplayNameByUserId(userId) {
    return getDisplayNameByUser(_user_store2.default.getProfile(userId));
}

/**
 * Gets the display name of the specified user, respecting the TeammateNameDisplay configuration setting
 */
function getDisplayNameByUser(user) {
    var state = _redux_store2.default.getState();
    var teammateNameDisplay = (0, _preferences.getTeammateNameDisplaySetting)(state);
    if (user) {
        return (0, _user_utils.displayUsername)(user, teammateNameDisplay);
    }

    return '';
}

var UserStatusesWeight = {
    online: 0,
    away: 1,
    dnd: 2,
    offline: 3
};

/**
 * Sort users by status then by display name, respecting the TeammateNameDisplay configuration setting
 */
function sortUsersByStatusAndDisplayName(users, statusesByUserId) {
    function compareUsers(a, b) {
        var aStatus = statusesByUserId[a.id] || _constants2.UserStatuses.OFFLINE;
        var bStatus = statusesByUserId[b.id] || _constants2.UserStatuses.OFFLINE;

        if (UserStatusesWeight[aStatus] !== UserStatusesWeight[bStatus]) {
            return UserStatusesWeight[aStatus] - UserStatusesWeight[bStatus];
        }

        var aName = getDisplayNameByUser(a);
        var bName = getDisplayNameByUser(b);

        return aName.localeCompare(bName);
    }

    return users.sort(compareUsers);
}

/**
 * Gets the entire name, including username, full name, and nickname, of the user with the specified id
 */
function displayEntireName(userId) {
    return displayEntireNameForUser(_user_store2.default.getProfile(userId));
}

/**
 * Gets the entire name, including username, full name, and nickname, of the specified user
 */
function displayEntireNameForUser(user) {
    if (!user) {
        return '';
    }

    var displayName = '@' + user.username;
    var fullName = getFullName(user);

    if (fullName && user.nickname) {
        displayName = _react2.default.createElement(
            'span',
            null,
            '@' + user.username,
            ' - ',
            _react2.default.createElement(
                'span',
                { className: 'light' },
                fullName + ' (' + user.nickname + ')'
            )
        );
    } else if (fullName) {
        displayName = _react2.default.createElement(
            'span',
            null,
            '@' + user.username,
            ' - ',
            _react2.default.createElement(
                'span',
                { className: 'light' },
                fullName
            )
        );
    } else if (user.nickname) {
        displayName = _react2.default.createElement(
            'span',
            null,
            '@' + user.username,
            ' - ',
            _react2.default.createElement(
                'span',
                { className: 'light' },
                '(' + user.nickname + ')'
            )
        );
    }

    return displayName;
}

function imageURLForUser(userIdOrObject) {
    if (typeof userIdOrObject == 'string') {
        var profile = _user_store2.default.getProfile(userIdOrObject);
        if (profile) {
            return imageURLForUser(profile);
        }
        return _constants3.default.TRANSPARENT_PIXEL;
    }
    return _client.Client4.getUsersRoute() + '/' + userIdOrObject.id + '/image?_=' + (userIdOrObject.last_picture_update || 0);
}

// in contrast to Client4.getTeamIconUrl, for ui logic this function returns null if last_team_icon_update is unset
function imageURLForTeam(teamIdOrObject) {
    if (typeof teamIdOrObject == 'string') {
        var team = _team_store2.default.get(teamIdOrObject);
        if (team) {
            return imageURLForTeam(team);
        }
        return null;
    }

    return teamIdOrObject.last_team_icon_update ? _client.Client4.getTeamIconUrl(teamIdOrObject.id, teamIdOrObject.last_team_icon_update) : null;
}

// Converts a file size in bytes into a human-readable string of the form '123MB'.
function fileSizeToString(bytes) {
    // it's unlikely that we'll have files bigger than this
    if (bytes > 1024 * 1024 * 1024 * 1024) {
        return Math.floor(bytes / (1024 * 1024 * 1024 * 1024)) + 'TB';
    } else if (bytes > 1024 * 1024 * 1024) {
        return Math.floor(bytes / (1024 * 1024 * 1024)) + 'GB';
    } else if (bytes > 1024 * 1024) {
        return Math.floor(bytes / (1024 * 1024)) + 'MB';
    } else if (bytes > 1024) {
        return Math.floor(bytes / 1024) + 'KB';
    }

    return bytes + 'B';
}

// Generates a RFC-4122 version 4 compliant globally unique identifier.
function generateId() {
    // implementation taken from http://stackoverflow.com/a/2117523
    var id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

    id = id.replace(/[xy]/g, function (c) {
        var r = Math.floor(Math.random() * 16);

        var v;
        if (c === 'x') {
            v = r;
        } else {
            v = r & 0x3 | 0x8;
        }

        return v.toString(16);
    });

    return id;
}

function getDirectChannelName(id, otherId) {
    var handle = void 0;

    if (otherId > id) {
        handle = id + '__' + otherId;
    } else {
        handle = otherId + '__' + id;
    }

    return handle;
}

// Used to get the id of the other user from a DM channel
function getUserIdFromChannelName(channel) {
    return getUserIdFromChannelId(channel.name);
}

// Used to get the id of the other user from a DM channel id (id1_id2)
function getUserIdFromChannelId(channelId) {
    var ids = channelId.split('__');
    var otherUserId = '';
    if (ids[0] === _user_store2.default.getCurrentId()) {
        otherUserId = ids[1];
    } else {
        otherUserId = ids[0];
    }

    return otherUserId;
}

// Returns true if the given channel is a direct channel between the current user and the given one
function isDirectChannelForUser(otherUserId, channel) {
    return channel.type === _constants3.default.DM_CHANNEL && getUserIdFromChannelName(channel) === otherUserId;
}

function importSlack(file, success, error) {
    _client.Client4.importTeam(_team_store2.default.getCurrent().id, file, 'slack').then(success).catch(error);
}

function windowWidth() {
    return (0, _jquery2.default)(window).width();
}

function windowHeight() {
    return (0, _jquery2.default)(window).height();
}

function getChannelTerm(channelType) {
    var channelTerm = 'Channel';
    if (channelType === _constants3.default.PRIVATE_CHANNEL) {
        channelTerm = 'Group';
    }

    return channelTerm;
}

function getPostTerm(post) {
    var postTerm = 'Post';
    if (post.root_id) {
        postTerm = 'Comment';
    }

    return postTerm;
}

function isFeatureEnabled(feature) {
    return _preference_store2.default.getBool(_constants3.default.Preferences.CATEGORY_ADVANCED_SETTINGS, _constants3.default.FeatureTogglePrefix + feature.label);
}

function fillArray(value, length) {
    var arr = [];

    for (var i = 0; i < length; i++) {
        arr.push(value);
    }

    return arr;
}

// Checks if a data transfer contains files not text, folders, etc..
// Slightly modified from http://stackoverflow.com/questions/6848043/how-do-i-detect-a-file-is-being-dragged-rather-than-a-draggable-element-on-my-pa
function isFileTransfer(files) {
    if (UserAgent.isInternetExplorer() || UserAgent.isEdge()) {
        return files.types != null && files.types.contains('Files');
    }

    return files.types != null && (files.types.indexOf ? files.types.indexOf('Files') !== -1 : files.types.contains('application/x-moz-file'));
}

function clearFileInput(elm) {
    // clear file input for all modern browsers
    try {
        elm.value = '';
        if (elm.value) {
            elm.type = 'text';
            elm.type = 'file';
        }
    } catch (e) {
        // Do nothing
    }
}

function isPostEphemeral(post) {
    return post.type === _constants3.default.PostTypes.EPHEMERAL || post.state === _constants.Posts.POST_DELETED;
}

function getRootId(post) {
    return post.root_id === '' ? post.id : post.root_id;
}

function localizeMessage(id, defaultMessage) {
    var translations = _localization_store2.default.getTranslations();
    if (translations) {
        var value = translations[id];
        if (value) {
            return value;
        }
    }

    if (defaultMessage) {
        return defaultMessage;
    }

    return id;
}

function mod(a, b) {
    return (a % b + b) % b;
}

var REACTION_PATTERN = exports.REACTION_PATTERN = /^(\+|-):([^:\s]+):\s*$/;

function canCreateCustomEmoji(user) {
    var state = _redux_store2.default.getState();
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    if (license.IsLicensed !== 'true') {
        return true;
    }

    if (isSystemAdmin(user.roles)) {
        return true;
    }

    // already checked for system admin for both these cases
    if (config.RestrictCustomEmojiCreation === 'system_admin') {
        return false;
    } else if (config.RestrictCustomEmojiCreation === 'admin') {
        // check whether the user is an admin on any of their teams
        if (_team_store2.default.isTeamAdminForAnyTeam()) {
            return true;
        }

        return false;
    }

    return true;
}

function getPasswordConfig(license, config) {
    return {
        isEnterprise: config.BuildEnterpriseReady === 'true',
        isLicensed: license.IsLicensed === 'true',
        isPasswordRequirements: license.PasswordRequirements === 'true',
        minimumLength: parseInt(config.PasswordMinimumLength, 10),
        requireLowercase: config.PasswordRequireLowercase === 'true',
        requireUppercase: config.PasswordRequireUppercase === 'true',
        requireNumber: config.PasswordRequireNumber === 'true',
        requireSymbol: config.PasswordRequireSymbol === 'true'
    };
}

function isValidPassword(password, passwordConfig) {
    var errorMsg = '';
    var errorId = 'user.settings.security.passwordError';
    var error = false;
    var minimumLength = _constants3.default.MIN_PASSWORD_LENGTH;

    if (passwordConfig.isEnterprise && passwordConfig.isLicensed && passwordConfig.isPasswordRequirements) {
        if (password.length < passwordConfig.minimumLength || password.length > _constants3.default.MAX_PASSWORD_LENGTH) {
            error = true;
        }

        if (passwordConfig.requireLowercase) {
            if (!password.match(/[a-z]/)) {
                error = true;
            }

            errorId += 'Lowercase';
        }

        if (passwordConfig.requireUppercase) {
            if (!password.match(/[A-Z]/)) {
                error = true;
            }

            errorId += 'Uppercase';
        }

        if (passwordConfig.requireNumber) {
            if (!password.match(/[0-9]/)) {
                error = true;
            }

            errorId += 'Number';
        }

        if (passwordConfig.requireSymbol) {
            if (!password.match(/[ !"\\#$%&'()*+,-./:;<=>?@[\]^_`|~]/)) {
                error = true;
            }

            errorId += 'Symbol';
        }

        minimumLength = passwordConfig.minimumLength;
    } else if (password.length < _constants3.default.MIN_PASSWORD_LENGTH || password.length > _constants3.default.MAX_PASSWORD_LENGTH) {
        error = true;
    }

    if (error) {
        errorMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: errorId,
            'default': 'Your password must contain between {min} and {max} characters.',
            values: {
                min: minimumLength,
                max: _constants3.default.MAX_PASSWORD_LENGTH
            }
        });
    }

    return errorMsg;
}

function handleFormattedTextClick(e) {
    var hashtagAttribute = e.target.getAttributeNode('data-hashtag');
    var linkAttribute = e.target.getAttributeNode('data-link');
    var channelMentionAttribute = e.target.getAttributeNode('data-channel-mention');

    if (hashtagAttribute) {
        e.preventDefault();

        (0, _post_actions.searchForTerm)(hashtagAttribute.value);
    } else if (linkAttribute) {
        var MIDDLE_MOUSE_BUTTON = 1;

        if (!(e.button === MIDDLE_MOUSE_BUTTON || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey)) {
            e.preventDefault();

            _browser_history.browserHistory.push(linkAttribute.value);
        }
    } else if (channelMentionAttribute) {
        e.preventDefault();
        _browser_history.browserHistory.push('/' + _team_store2.default.getCurrent().name + '/channels/' + channelMentionAttribute.value);
    }
}

function isEmptyObject(object) {
    if (!object) {
        return true;
    }

    if ((0, _keys2.default)(object).length === 0) {
        return true;
    }

    return false;
}

function removePrefixFromLocalStorage(prefix) {
    var keys = [];
    for (var i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).startsWith(prefix)) {
            keys.push(localStorage.key(i));
        }
    }

    for (var _i = 0; _i < keys.length; _i++) {
        localStorage.removeItem(keys[_i]);
    }
}

function getEmailInterval(enableEmailBatching, isEmailEnabled) {
    var _Constants$Preference = _constants3.default.Preferences,
        INTERVAL_NEVER = _Constants$Preference.INTERVAL_NEVER,
        INTERVAL_IMMEDIATE = _Constants$Preference.INTERVAL_IMMEDIATE,
        INTERVAL_FIFTEEN_MINUTES = _Constants$Preference.INTERVAL_FIFTEEN_MINUTES,
        INTERVAL_HOUR = _Constants$Preference.INTERVAL_HOUR,
        CATEGORY_NOTIFICATIONS = _Constants$Preference.CATEGORY_NOTIFICATIONS,
        EMAIL_INTERVAL = _Constants$Preference.EMAIL_INTERVAL;


    if (!isEmailEnabled) {
        return INTERVAL_NEVER;
    }

    var validValuesWithEmailBatching = [INTERVAL_IMMEDIATE, INTERVAL_FIFTEEN_MINUTES, INTERVAL_HOUR];
    var validValuesWithoutEmailBatching = [INTERVAL_IMMEDIATE];

    var emailInterval = void 0;

    if (enableEmailBatching) {
        // when email batching is enabled, the default interval is 15 minutes
        emailInterval = _preference_store2.default.getInt(CATEGORY_NOTIFICATIONS, EMAIL_INTERVAL, INTERVAL_FIFTEEN_MINUTES);

        if (validValuesWithEmailBatching.indexOf(emailInterval) === -1) {
            emailInterval = INTERVAL_FIFTEEN_MINUTES;
        }
    } else {
        // otherwise, the default interval is immediately
        emailInterval = _preference_store2.default.getInt(CATEGORY_NOTIFICATIONS, EMAIL_INTERVAL, INTERVAL_IMMEDIATE);

        if (validValuesWithoutEmailBatching.indexOf(emailInterval) === -1) {
            emailInterval = INTERVAL_IMMEDIATE;
        }
    }

    return emailInterval;
}

function copyToClipboard(e, data) {
    // creates a tiny temporary text area to copy text out of
    // see https://stackoverflow.com/a/30810322/591374 for details
    var textArea = document.createElement('textarea');
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = (0, _url.getSiteURL)() + data.link;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return globalLocale;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(1885)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
        else {
            if ((typeof console !==  'undefined') && console.warn) {
                //warn user if arguments are passed but the locale could not be set
                console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
            }
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var locale, parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                locale = loadLocale(config.parentLocale);
                if (locale != null) {
                    parentConfig = locale._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports

hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.21.0';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 764 */,
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(1022);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1714);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1715);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(1022);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1142);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1716)();
}


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var bootstrapUtils_namespaceObject = {};
__webpack_require__.d(bootstrapUtils_namespaceObject, "prefix", function() { return prefix; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "bsClass", function() { return bootstrapUtils_bsClass; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "bsStyles", function() { return bsStyles; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "bsSizes", function() { return bsSizes; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "getClassSet", function() { return getClassSet; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "splitBsProps", function() { return splitBsProps; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "splitBsPropsAndOmit", function() { return splitBsPropsAndOmit; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "addStyle", function() { return addStyle; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "_curry", function() { return _curry; });
var utils_namespaceObject = {};
__webpack_require__.d(utils_namespaceObject, "bootstrapUtils", function() { return bootstrapUtils_namespaceObject; });
__webpack_require__.d(utils_namespaceObject, "createChainedFunction", function() { return utils_createChainedFunction; });
__webpack_require__.d(utils_namespaceObject, "ValidComponentChildren", function() { return ValidComponentChildren; });

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(768);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(765);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(766);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(767);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(14);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(770);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(769);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/prop-types/index.js
var prop_types = __webpack_require__(771);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/uncontrollable/index.js
var uncontrollable = __webpack_require__(879);
var uncontrollable_default = /*#__PURE__*/__webpack_require__.n(uncontrollable);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__(1143);
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(30);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/StyleConfig.js
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};

var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};

var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];

var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/bootstrapUtils.js


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.






function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : browser_default()(false) : void 0;
  return bsClass + (variant ? '-' + variant : '');
}

var bootstrapUtils_bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = prop_types_default.a.string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = prop_types_default.a.oneOf(existing);

  // expose the values on the propType function for documentation
  Component.STYLES = existing;
  propType._values = existing;

  Component.propTypes = extends_default()({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});

var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = SIZE_MAP[size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = prop_types_default.a.oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  Component.SIZES = existing;

  Component.propTypes = extends_default()({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }
    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = SIZE_MAP[props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  entries_default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });

  var elementProps = {};
  entries_default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/ValidComponentChildren.js
// TODO: This module should be ElementChildren, and should use named exports.



/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;

  return react_default.a.Children.map(children, function (child) {
    if (!react_default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
function forEach(children, func, context) {
  var index = 0;

  react_default.a.Children.forEach(children, function (child) {
    if (!react_default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function ValidComponentChildren_count(children) {
  var result = 0;

  react_default.a.Children.forEach(children, function (child) {
    if (!react_default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
  var index = 0;
  var result = [];

  react_default.a.Children.forEach(children, function (child) {
    if (!react_default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result = void 0;

  react_default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!react_default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  react_default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }
    if (!react_default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  react_default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!react_default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  react_default.a.Children.forEach(children, function (child) {
    if (!react_default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

/* harmony default export */ var ValidComponentChildren = ({
  map: map,
  forEach: forEach,
  count: ValidComponentChildren_count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/utils/createChainableTypeChecker.js
var createChainableTypeChecker = __webpack_require__(949);
var createChainableTypeChecker_default = /*#__PURE__*/__webpack_require__.n(createChainableTypeChecker);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/PropTypes.js





var idPropType = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]);

function generatedId(name) {
  return function (props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var error = null;

    if (!props.generateChildId) {
      error = idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize the ' + name + ' in a way that is accessible to assistive technologies ' + ('(such as screen readers) an `id` or a `generateChildId` prop to ' + name + ' is required'));
      }
    }
    return error;
  };
}

function requiredRoles() {
  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return createChainableTypeChecker_default()(function (props, propName, component) {
    var missing = void 0;

    roles.every(function (role) {
      if (!ValidComponentChildren.some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return createChainableTypeChecker_default()(function (props, propName, component) {
    var duplicate = void 0;

    roles.every(function (role) {
      var childrenWithRole = ValidComponentChildren.filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelGroup.js














var PanelGroup_propTypes = {
  accordion: prop_types_default.a.bool,
  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: prop_types_default.a.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: prop_types_default.a.func,

  /**
   * An HTML role attribute
   */
  role: prop_types_default.a.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: prop_types_default.a.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: generatedId('PanelGroup')
};

var PanelGroup_defaultProps = {
  accordion: false
};

var childContextTypes = {
  $bs_panelGroup: prop_types_default.a.shape({
    getId: prop_types_default.a.func,
    headerRole: prop_types_default.a.string,
    panelRole: prop_types_default.a.string,
    activeKey: prop_types_default.a.any,
    onToggle: prop_types_default.a.func
  })
};

var PanelGroup_PanelGroup = function (_React$Component) {
  inherits_default()(PanelGroup, _React$Component);

  function PanelGroup() {
    var _temp, _this, _ret;

    classCallCheck_default()(this, PanelGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  PanelGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        accordion = _props.accordion,
        generateChildId = _props.generateChildId,
        id = _props.id;

    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + '-' + type + '-' + key : null;
      };
    }

    return {
      $bs_panelGroup: extends_default()({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  PanelGroup.prototype.render = function render() {
    var _props2 = this.props,
        accordion = _props2.accordion,
        className = _props2.className,
        children = _props2.children,
        props = objectWithoutProperties_default()(_props2, ['accordion', 'className', 'children']);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      ValidComponentChildren.map(children, function (child) {
        return Object(react["cloneElement"])(child, {
          bsStyle: child.props.bsStyle || bsProps.bsStyle
        });
      })
    );
  };

  return PanelGroup;
}(react_default.a.Component);

PanelGroup_PanelGroup.propTypes = PanelGroup_propTypes;
PanelGroup_PanelGroup.defaultProps = PanelGroup_defaultProps;
PanelGroup_PanelGroup.childContextTypes = childContextTypes;

/* harmony default export */ var es_PanelGroup = (uncontrollable_default()(bootstrapUtils_bsClass('panel-group', PanelGroup_PanelGroup), {
  activeKey: 'onSelect'
}));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Accordion.js








var Accordion_Accordion = function (_React$Component) {
  inherits_default()(Accordion, _React$Component);

  function Accordion() {
    classCallCheck_default()(this, Accordion);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Accordion.prototype.render = function render() {
    return react_default.a.createElement(
      es_PanelGroup,
      extends_default()({}, this.props, { accordion: true }),
      this.props.children
    );
  };

  return Accordion;
}(react_default.a.Component);

/* harmony default export */ var es_Accordion = (Accordion_Accordion);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/core-js/object/values.js
var object_values = __webpack_require__(901);
var values_default = /*#__PURE__*/__webpack_require__.n(object_values);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/CloseButton.js






var CloseButton_propTypes = {
  label: prop_types_default.a.string.isRequired,
  onClick: prop_types_default.a.func
};

var CloseButton_defaultProps = {
  label: 'Close'
};

var CloseButton_CloseButton = function (_React$Component) {
  inherits_default()(CloseButton, _React$Component);

  function CloseButton() {
    classCallCheck_default()(this, CloseButton);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  CloseButton.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        onClick = _props.onClick;

    return react_default.a.createElement(
      'button',
      { type: 'button', className: 'close', onClick: onClick },
      react_default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      ),
      react_default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      )
    );
  };

  return CloseButton;
}(react_default.a.Component);

CloseButton_CloseButton.propTypes = CloseButton_propTypes;
CloseButton_CloseButton.defaultProps = CloseButton_defaultProps;

/* harmony default export */ var es_CloseButton = (CloseButton_CloseButton);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Alert.js














var Alert_propTypes = {
  onDismiss: prop_types_default.a.func,
  closeLabel: prop_types_default.a.string
};

var Alert_defaultProps = {
  closeLabel: 'Close alert'
};

var Alert_Alert = function (_React$Component) {
  inherits_default()(Alert, _React$Component);

  function Alert() {
    classCallCheck_default()(this, Alert);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        onDismiss = _props.onDismiss,
        closeLabel = _props.closeLabel,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['onDismiss', 'closeLabel', 'className', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;
    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'dismissable')] = dismissable, _extends2));

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, {
        role: 'alert',
        className: classnames_default()(className, classes)
      }),
      dismissable && react_default.a.createElement(es_CloseButton, { onClick: onDismiss, label: closeLabel }),
      children
    );
  };

  return Alert;
}(react_default.a.Component);

Alert_Alert.propTypes = Alert_propTypes;
Alert_Alert.defaultProps = Alert_defaultProps;

/* harmony default export */ var es_Alert = (bsStyles(values_default()(State), State.INFO, bootstrapUtils_bsClass('alert', Alert_Alert)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Badge.js











// TODO: `pullRight` doesn't belong here. There's no special handling here.

var Badge_propTypes = {
  pullRight: prop_types_default.a.bool
};

var Badge_defaultProps = {
  pullRight: false
};

var Badge_Badge = function (_React$Component) {
  inherits_default()(Badge, _React$Component);

  function Badge() {
    classCallCheck_default()(this, Badge);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Badge.prototype.hasContent = function hasContent(children) {
    var result = false;

    react_default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Badge.prototype.render = function render() {
    var _props = this.props,
        pullRight = _props.pullRight,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['pullRight', 'className', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), {
      'pull-right': pullRight,

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return react_default.a.createElement(
      'span',
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      children
    );
  };

  return Badge;
}(react_default.a.Component);

Badge_Badge.propTypes = Badge_propTypes;
Badge_Badge.defaultProps = Badge_defaultProps;

/* harmony default export */ var es_Badge = (bootstrapUtils_bsClass('badge', Badge_Badge));
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/elementType.js
var elementType = __webpack_require__(795);
var elementType_default = /*#__PURE__*/__webpack_require__.n(elementType);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var utils_createChainedFunction = (createChainedFunction);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/SafeAnchor.js











var SafeAnchor_propTypes = {
  href: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  onKeyDown: prop_types_default.a.func,
  disabled: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  tabIndex: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: elementType_default.a
};

var SafeAnchor_defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor_SafeAnchor = function (_React$Component) {
  inherits_default()(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    classCallCheck_default()(this, SafeAnchor);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  SafeAnchor.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;


    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  SafeAnchor.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        onKeyDown = _props2.onKeyDown,
        props = objectWithoutProperties_default()(_props2, ['componentClass', 'disabled', 'onKeyDown']);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button';
      // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')
      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = extends_default()({ pointerEvents: 'none' }, props.style);
    }

    return react_default.a.createElement(Component, extends_default()({}, props, {
      onClick: this.handleClick,
      onKeyDown: utils_createChainedFunction(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(react_default.a.Component);

SafeAnchor_SafeAnchor.propTypes = SafeAnchor_propTypes;
SafeAnchor_SafeAnchor.defaultProps = SafeAnchor_defaultProps;

/* harmony default export */ var es_SafeAnchor = (SafeAnchor_SafeAnchor);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/BreadcrumbItem.js











var BreadcrumbItem_propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: prop_types_default.a.bool,
  /**
   * `href` attribute for the inner `a` element
   */
  href: prop_types_default.a.string,
  /**
   * `title` attribute for the inner `a` element
   */
  title: prop_types_default.a.node,
  /**
   * `target` attribute for the inner `a` element
   */
  target: prop_types_default.a.string
};

var BreadcrumbItem_defaultProps = {
  active: false
};

var BreadcrumbItem_BreadcrumbItem = function (_React$Component) {
  inherits_default()(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    classCallCheck_default()(this, BreadcrumbItem);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  BreadcrumbItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        href = _props.href,
        title = _props.title,
        target = _props.target,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['active', 'href', 'title', 'target', 'className']);

    // Don't try to render these props on non-active <span>.


    var linkProps = { href: href, title: title, target: target };

    return react_default.a.createElement(
      'li',
      { className: classnames_default()(className, { active: active }) },
      active ? react_default.a.createElement('span', props) : react_default.a.createElement(es_SafeAnchor, extends_default()({}, props, linkProps))
    );
  };

  return BreadcrumbItem;
}(react_default.a.Component);

BreadcrumbItem_BreadcrumbItem.propTypes = BreadcrumbItem_propTypes;
BreadcrumbItem_BreadcrumbItem.defaultProps = BreadcrumbItem_defaultProps;

/* harmony default export */ var es_BreadcrumbItem = (BreadcrumbItem_BreadcrumbItem);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Breadcrumb.js











var Breadcrumb_Breadcrumb = function (_React$Component) {
  inherits_default()(Breadcrumb, _React$Component);

  function Breadcrumb() {
    classCallCheck_default()(this, Breadcrumb);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Breadcrumb.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement('ol', extends_default()({}, elementProps, {
      role: 'navigation',
      'aria-label': 'breadcrumbs',
      className: classnames_default()(className, classes)
    }));
  };

  return Breadcrumb;
}(react_default.a.Component);

Breadcrumb_Breadcrumb.Item = es_BreadcrumbItem;

/* harmony default export */ var es_Breadcrumb = (bootstrapUtils_bsClass('breadcrumb', Breadcrumb_Breadcrumb));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Button.js
















var Button_propTypes = {
  active: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  block: prop_types_default.a.bool,
  onClick: prop_types_default.a.func,
  componentClass: elementType_default.a,
  href: prop_types_default.a.string,
  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: prop_types_default.a.oneOf(['button', 'reset', 'submit'])
};

var Button_defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button_Button = function (_React$Component) {
  inherits_default()(Button, _React$Component);

  function Button() {
    classCallCheck_default()(this, Button);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
    return react_default.a.createElement(es_SafeAnchor, extends_default()({}, elementProps, {
      className: classnames_default()(className, elementProps.disabled && 'disabled')
    }));
  };

  Button.prototype.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = objectWithoutProperties_default()(_ref, ['componentClass']);

    var Component = componentClass || 'button';

    return react_default.a.createElement(Component, extends_default()({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  Button.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['active', 'block', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {
      active: active
    }, _extends2[prefix(bsProps, 'block')] = block, _extends2));
    var fullClassName = classnames_default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(react_default.a.Component);

Button_Button.propTypes = Button_propTypes;
Button_Button.defaultProps = Button_defaultProps;

/* harmony default export */ var es_Button = (bootstrapUtils_bsClass('btn', bsSizes([Size.LARGE, Size.SMALL, Size.XSMALL], bsStyles([].concat(values_default()(State), [Style.DEFAULT, Style.PRIMARY, Style.LINK]), Style.DEFAULT, Button_Button))));
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/all.js
var lib_all = __webpack_require__(950);
var all_default = /*#__PURE__*/__webpack_require__.n(lib_all);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ButtonGroup.js













var ButtonGroup_propTypes = {
  vertical: prop_types_default.a.bool,
  justified: prop_types_default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: all_default()(prop_types_default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};

var ButtonGroup_defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup_ButtonGroup = function (_React$Component) {
  inherits_default()(ButtonGroup, _React$Component);

  function ButtonGroup() {
    classCallCheck_default()(this, ButtonGroup);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        block = _props.block,
        justified = _props.justified,
        vertical = _props.vertical,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['block', 'justified', 'vertical', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps)] = !vertical, _extends2[prefix(bsProps, 'vertical')] = vertical, _extends2[prefix(bsProps, 'justified')] = justified, _extends2[prefix(es_Button.defaultProps, 'block')] = block, _extends2));

    return react_default.a.createElement('div', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return ButtonGroup;
}(react_default.a.Component);

ButtonGroup_ButtonGroup.propTypes = ButtonGroup_propTypes;
ButtonGroup_ButtonGroup.defaultProps = ButtonGroup_defaultProps;

/* harmony default export */ var es_ButtonGroup = (bootstrapUtils_bsClass('btn-group', ButtonGroup_ButtonGroup));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ButtonToolbar.js










var ButtonToolbar_ButtonToolbar = function (_React$Component) {
  inherits_default()(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    classCallCheck_default()(this, ButtonToolbar);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ButtonToolbar.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement('div', extends_default()({}, elementProps, {
      role: 'toolbar',
      className: classnames_default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(react_default.a.Component);

/* harmony default export */ var es_ButtonToolbar = (bootstrapUtils_bsClass('btn-toolbar', ButtonToolbar_ButtonToolbar));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/CarouselCaption.js











var CarouselCaption_propTypes = {
  componentClass: elementType_default.a
};

var CarouselCaption_defaultProps = {
  componentClass: 'div'
};

var CarouselCaption_CarouselCaption = function (_React$Component) {
  inherits_default()(CarouselCaption, _React$Component);

  function CarouselCaption() {
    classCallCheck_default()(this, CarouselCaption);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  CarouselCaption.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return CarouselCaption;
}(react_default.a.Component);

CarouselCaption_CarouselCaption.propTypes = CarouselCaption_propTypes;
CarouselCaption_CarouselCaption.defaultProps = CarouselCaption_defaultProps;

/* harmony default export */ var es_CarouselCaption = (bootstrapUtils_bsClass('carousel-caption', CarouselCaption_CarouselCaption));
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(272);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/dom-helpers/transition/index.js
var dom_helpers_transition = __webpack_require__(1723);
var transition_default = /*#__PURE__*/__webpack_require__.n(dom_helpers_transition);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/CarouselItem.js











var CarouselItem_propTypes = {
  direction: prop_types_default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: prop_types_default.a.func,
  active: prop_types_default.a.bool,
  animateIn: prop_types_default.a.bool,
  animateOut: prop_types_default.a.bool,
  index: prop_types_default.a.number
};

var CarouselItem_defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem_CarouselItem = function (_React$Component) {
  inherits_default()(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    classCallCheck_default()(this, CarouselItem);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);

    _this.state = {
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({ direction: null });
    }
  };

  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;

    var prevActive = prevProps.active;

    if (!active && prevActive) {
      transition_default.a.end(react_dom_default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  CarouselItem.prototype.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  CarouselItem.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        active = _props.active,
        animateIn = _props.animateIn,
        animateOut = _props.animateOut,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);

    delete props.onAnimateOutEnd;
    delete props.index;

    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };
    if (direction && active && animateIn) {
      classes[direction] = true;
    }
    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return react_default.a.createElement('div', extends_default()({}, props, { className: classnames_default()(className, classes) }));
  };

  return CarouselItem;
}(react_default.a.Component);

CarouselItem_CarouselItem.propTypes = CarouselItem_propTypes;
CarouselItem_CarouselItem.defaultProps = CarouselItem_defaultProps;

/* harmony default export */ var es_CarouselItem = (CarouselItem_CarouselItem);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Glyphicon.js











var Glyphicon_propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: prop_types_default.a.string.isRequired
};

var Glyphicon_Glyphicon = function (_React$Component) {
  inherits_default()(Glyphicon, _React$Component);

  function Glyphicon() {
    classCallCheck_default()(this, Glyphicon);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Glyphicon.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        glyph = _props.glyph,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['glyph', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, glyph)] = true, _extends2));

    return react_default.a.createElement('span', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return Glyphicon;
}(react_default.a.Component);

Glyphicon_Glyphicon.propTypes = Glyphicon_propTypes;

/* harmony default export */ var es_Glyphicon = (bootstrapUtils_bsClass('glyphicon', Glyphicon_Glyphicon));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Carousel.js
















// TODO: `slide` should be `animate`.

// TODO: Use uncontrollable.

var Carousel_propTypes = {
  slide: prop_types_default.a.bool,
  indicators: prop_types_default.a.bool,
  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: prop_types_default.a.number,
  controls: prop_types_default.a.bool,
  pauseOnHover: prop_types_default.a.bool,
  wrap: prop_types_default.a.bool,
  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any, ?event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: prop_types_default.a.func,
  onSlideEnd: prop_types_default.a.func,
  activeIndex: prop_types_default.a.number,
  defaultActiveIndex: prop_types_default.a.number,
  direction: prop_types_default.a.oneOf(['prev', 'next']),
  prevIcon: prop_types_default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: prop_types_default.a.string,
  nextIcon: prop_types_default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: prop_types_default.a.string
};

var Carousel_defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: react_default.a.createElement(es_Glyphicon, { glyph: 'chevron-left' }),
  prevLabel: 'Previous',
  nextIcon: react_default.a.createElement(es_Glyphicon, { glyph: 'chevron-right' }),
  nextLabel: 'Next'
};

var Carousel_Carousel = function (_React$Component) {
  inherits_default()(Carousel, _React$Component);

  function Carousel(props, context) {
    classCallCheck_default()(this, Carousel);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);

    var defaultActiveIndex = props.defaultActiveIndex;


    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  Carousel.prototype.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);

      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  Carousel.prototype.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  Carousel.prototype.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  Carousel.prototype.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  Carousel.prototype.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = ValidComponentChildren.count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }
      index = 0;
    }

    this.select(index, e, 'next');
  };

  Carousel.prototype.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }
      index = ValidComponentChildren.count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  };

  // This might be a public API.


  Carousel.prototype.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  };

  // This might be a public API.


  Carousel.prototype.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  Carousel.prototype.select = function select(index, e, direction) {
    clearTimeout(this.timeout);

    // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.
    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);

    var onSelect = this.props.onSelect;


    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = { direction: direction };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  Carousel.prototype.waitForNext = function waitForNext() {
    var _props = this.props,
        slide = _props.slide,
        interval = _props.interval,
        activeIndexProp = _props.activeIndex;


    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  Carousel.prototype.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;

    var controlClassName = prefix(bsProps, 'control');
    var count = ValidComponentChildren.count(children);

    return [(wrap || activeIndex !== 0) && react_default.a.createElement(
      es_SafeAnchor,
      {
        key: 'prev',
        className: classnames_default()(controlClassName, 'left'),
        onClick: this.handlePrev
      },
      prevIcon,
      prevLabel && react_default.a.createElement(
        'span',
        { className: 'sr-only' },
        prevLabel
      )
    ), (wrap || activeIndex !== count - 1) && react_default.a.createElement(
      es_SafeAnchor,
      {
        key: 'next',
        className: classnames_default()(controlClassName, 'right'),
        onClick: this.handleNext
      },
      nextIcon,
      nextLabel && react_default.a.createElement(
        'span',
        { className: 'sr-only' },
        nextLabel
      )
    )];
  };

  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];

    ValidComponentChildren.forEach(children, function (child, index) {
      indicators.push(react_default.a.createElement('li', {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }),

      // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });

    return react_default.a.createElement(
      'ol',
      { className: prefix(bsProps, 'indicators') },
      indicators
    );
  };

  Carousel.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        slide = _props2.slide,
        indicators = _props2.indicators,
        controls = _props2.controls,
        wrap = _props2.wrap,
        prevIcon = _props2.prevIcon,
        prevLabel = _props2.prevLabel,
        nextIcon = _props2.nextIcon,
        nextLabel = _props2.nextLabel,
        className = _props2.className,
        children = _props2.children,
        props = objectWithoutProperties_default()(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);

    var _state = this.state,
        previousActiveIndex = _state.previousActiveIndex,
        direction = _state.direction;

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = extends_default()({}, getClassSet(bsProps), {
      slide: slide
    });

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, {
        className: classnames_default()(className, classes),
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      }),
      indicators && this.renderIndicators(children, activeIndex, bsProps),
      react_default.a.createElement(
        'div',
        { className: prefix(bsProps, 'inner') },
        ValidComponentChildren.map(children, function (child, index) {
          var active = index === activeIndex;
          var previousActive = slide && index === previousActiveIndex;

          return Object(react["cloneElement"])(child, {
            active: active,
            index: index,
            animateOut: previousActive,
            animateIn: active && previousActiveIndex != null && slide,
            direction: direction,
            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
          });
        })
      ),
      controls && this.renderControls({
        wrap: wrap,
        children: children,
        activeIndex: activeIndex,
        prevIcon: prevIcon,
        prevLabel: prevLabel,
        nextIcon: nextIcon,
        nextLabel: nextLabel,
        bsProps: bsProps
      })
    );
  };

  return Carousel;
}(react_default.a.Component);

Carousel_Carousel.propTypes = Carousel_propTypes;
Carousel_Carousel.defaultProps = Carousel_defaultProps;

Carousel_Carousel.Caption = es_CarouselCaption;
Carousel_Carousel.Item = es_CarouselItem;

/* harmony default export */ var es_Carousel = (bootstrapUtils_bsClass('carousel', Carousel_Carousel));
// EXTERNAL MODULE: ./node_modules/warning/browser.js
var warning_browser = __webpack_require__(15);
var warning_browser_default = /*#__PURE__*/__webpack_require__.n(warning_browser);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Checkbox.js





/* eslint-disable jsx-a11y/label-has-for */








var Checkbox_propTypes = {
  inline: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  title: prop_types_default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: prop_types_default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: prop_types_default.a.func
};

var Checkbox_defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox_Checkbox = function (_React$Component) {
  inherits_default()(Checkbox, _React$Component);

  function Checkbox() {
    classCallCheck_default()(this, Checkbox);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Checkbox.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = react_default.a.createElement('input', extends_default()({}, elementProps, {
      ref: inputRef,
      type: 'checkbox',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[prefix(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return react_default.a.createElement(
        'label',
        {
          className: classnames_default()(className, _classes),
          style: style,
          title: title
        },
        input,
        children
      );
    }

    var classes = extends_default()({}, getClassSet(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return react_default.a.createElement(
      'div',
      { className: classnames_default()(className, classes), style: style },
      react_default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Checkbox;
}(react_default.a.Component);

Checkbox_Checkbox.propTypes = Checkbox_propTypes;
Checkbox_Checkbox.defaultProps = Checkbox_defaultProps;

/* harmony default export */ var es_Checkbox = (bootstrapUtils_bsClass('checkbox', Checkbox_Checkbox));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/capitalize.js
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Clearfix.js














var Clearfix_propTypes = {
  componentClass: elementType_default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: prop_types_default.a.bool,
  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: prop_types_default.a.bool,
  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: prop_types_default.a.bool,
  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: prop_types_default.a.bool
};

var Clearfix_defaultProps = {
  componentClass: 'div'
};

var Clearfix_Clearfix = function (_React$Component) {
  inherits_default()(Clearfix, _React$Component);

  function Clearfix() {
    classCallCheck_default()(this, Clearfix);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Clearfix.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    DEVICE_SIZES.forEach(function (size) {
      var propName = 'visible' + capitalize(size) + 'Block';
      if (elementProps[propName]) {
        classes['visible-' + size + '-block'] = true;
      }

      delete elementProps[propName];
    });

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return Clearfix;
}(react_default.a.Component);

Clearfix_Clearfix.propTypes = Clearfix_propTypes;
Clearfix_Clearfix.defaultProps = Clearfix_defaultProps;

/* harmony default export */ var es_Clearfix = (bootstrapUtils_bsClass('clearfix', Clearfix_Clearfix));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ControlLabel.js












var ControlLabel_propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: prop_types_default.a.string,
  srOnly: prop_types_default.a.bool
};

var ControlLabel_defaultProps = {
  srOnly: false
};

var contextTypes = {
  $bs_formGroup: prop_types_default.a.object
};

var ControlLabel_ControlLabel = function (_React$Component) {
  inherits_default()(ControlLabel, _React$Component);

  function ControlLabel() {
    classCallCheck_default()(this, ControlLabel);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ControlLabel.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        _props$htmlFor = _props.htmlFor,
        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
        srOnly = _props.srOnly,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['htmlFor', 'srOnly', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = extends_default()({}, getClassSet(bsProps), {
      'sr-only': srOnly
    });

    return react_default.a.createElement('label', extends_default()({}, elementProps, {
      htmlFor: htmlFor,
      className: classnames_default()(className, classes)
    }));
  };

  return ControlLabel;
}(react_default.a.Component);

ControlLabel_ControlLabel.propTypes = ControlLabel_propTypes;
ControlLabel_ControlLabel.defaultProps = ControlLabel_defaultProps;
ControlLabel_ControlLabel.contextTypes = contextTypes;

/* harmony default export */ var es_ControlLabel = (bootstrapUtils_bsClass('control-label', ControlLabel_ControlLabel));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Col.js













var Col_propTypes = {
  componentClass: elementType_default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: prop_types_default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: prop_types_default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: prop_types_default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: prop_types_default.a.number,
  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: prop_types_default.a.bool,
  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: prop_types_default.a.bool,
  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: prop_types_default.a.bool,
  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: prop_types_default.a.bool,
  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: prop_types_default.a.number,
  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: prop_types_default.a.number,
  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: prop_types_default.a.number,
  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: prop_types_default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: prop_types_default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: prop_types_default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: prop_types_default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: prop_types_default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: prop_types_default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: prop_types_default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: prop_types_default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: prop_types_default.a.number
};

var Col_defaultProps = {
  componentClass: 'div'
};

var Col_Col = function (_React$Component) {
  inherits_default()(Col, _React$Component);

  function Col() {
    classCallCheck_default()(this, Col);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Col.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    DEVICE_SIZES.forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = '' + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(prefix(bsProps, '' + size + modifier + '-' + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');

      var hiddenPropName = size + 'Hidden';
      if (elementProps[hiddenPropName]) {
        classes.push('hidden-' + size);
      }
      delete elementProps[hiddenPropName];
    });

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return Col;
}(react_default.a.Component);

Col_Col.propTypes = Col_propTypes;
Col_Col.defaultProps = Col_defaultProps;

/* harmony default export */ var es_Col = (bootstrapUtils_bsClass('col', Col_Col));
// EXTERNAL MODULE: ./node_modules/dom-helpers/style/index.js
var dom_helpers_style = __webpack_require__(922);
var style_default = /*#__PURE__*/__webpack_require__.n(dom_helpers_style);

// EXTERNAL MODULE: ./node_modules/react-transition-group/Transition.js
var react_transition_group_Transition = __webpack_require__(1146);
var Transition_default = /*#__PURE__*/__webpack_require__.n(react_transition_group_Transition);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Collapse.js






var _collapseStyles;










var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem['offset' + capitalize(dimension)];
  var margins = MARGINS[dimension];

  return value + parseInt(style_default()(elem, margins[0]), 10) + parseInt(style_default()(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[react_transition_group_Transition["EXITED"]] = 'collapse', _collapseStyles[react_transition_group_Transition["EXITING"]] = 'collapsing', _collapseStyles[react_transition_group_Transition["ENTERING"]] = 'collapsing', _collapseStyles[react_transition_group_Transition["ENTERED"]] = 'collapse in', _collapseStyles);

var Collapse_propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: prop_types_default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: prop_types_default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: prop_types_default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: prop_types_default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: prop_types_default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: prop_types_default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: prop_types_default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: prop_types_default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: prop_types_default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: prop_types_default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: prop_types_default.a.oneOfType([prop_types_default.a.oneOf(['height', 'width']), prop_types_default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: prop_types_default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: prop_types_default.a.string
};

var Collapse_defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,

  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse_Collapse = function (_React$Component) {
  inherits_default()(Collapse, _React$Component);

  function Collapse() {
    var _temp, _this, _ret;

    classCallCheck_default()(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    }, _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();
      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    }, _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    }, _this.handleExit = function (elem) {
      var dimension = _this.getDimension();
      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + 'px';
      triggerBrowserReflow(elem);
    }, _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  Collapse.prototype.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  };

  // for testing


  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem['scroll' + capitalize(dimension)] + 'px';
  };

  /* -- Expanding -- */


  /* -- Collapsing -- */


  Collapse.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className', 'children']);

    delete props.dimension;
    delete props.getDimensionValue;

    var handleEnter = utils_createChainedFunction(this.handleEnter, onEnter);
    var handleEntering = utils_createChainedFunction(this.handleEntering, onEntering);
    var handleEntered = utils_createChainedFunction(this.handleEntered, onEntered);
    var handleExit = utils_createChainedFunction(this.handleExit, onExit);
    var handleExiting = utils_createChainedFunction(this.handleExiting, onExiting);

    return react_default.a.createElement(
      Transition_default.a,
      extends_default()({}, props, {
        'aria-expanded': props.role ? props.in : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting
      }),
      function (state, innerProps) {
        return react_default.a.cloneElement(children, extends_default()({}, innerProps, {
          className: classnames_default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
        }));
      }
    );
  };

  return Collapse;
}(react_default.a.Component);

Collapse_Collapse.propTypes = Collapse_propTypes;
Collapse_Collapse.defaultProps = Collapse_defaultProps;

/* harmony default export */ var es_Collapse = (Collapse_Collapse);
// EXTERNAL MODULE: ./node_modules/dom-helpers/activeElement.js
var activeElement = __webpack_require__(1148);
var activeElement_default = /*#__PURE__*/__webpack_require__.n(activeElement);

// EXTERNAL MODULE: ./node_modules/dom-helpers/query/contains.js
var contains = __webpack_require__(903);
var contains_default = /*#__PURE__*/__webpack_require__.n(contains);

// EXTERNAL MODULE: ./node_modules/keycode/index.js
var keycode = __webpack_require__(1024);
var keycode_default = /*#__PURE__*/__webpack_require__.n(keycode);

// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/isRequiredForA11y.js
var isRequiredForA11y = __webpack_require__(951);
var isRequiredForA11y_default = /*#__PURE__*/__webpack_require__.n(isRequiredForA11y);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__(1736);
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/react-overlays/lib/RootCloseWrapper.js
var RootCloseWrapper = __webpack_require__(1149);
var RootCloseWrapper_default = /*#__PURE__*/__webpack_require__.n(RootCloseWrapper);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/DropdownMenu.js

















var DropdownMenu_propTypes = {
  open: prop_types_default.a.bool,
  pullRight: prop_types_default.a.bool,
  onClose: prop_types_default.a.func,
  labelledBy: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  onSelect: prop_types_default.a.func,
  rootCloseEvent: prop_types_default.a.oneOf(['click', 'mousedown'])
};

var DropdownMenu_defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu_DropdownMenu = function (_React$Component) {
  inherits_default()(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    classCallCheck_default()(this, DropdownMenu);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

    _this.handleRootClose = _this.handleRootClose.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = react_dom_default.a.findDOMNode(this);
    if (!node) {
      return [];
    }

    return from_default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);

    return { items: items, activeIndex: activeIndex };
  };

  DropdownMenu.prototype.focusNext = function focusNext() {
    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd.items,
        activeIndex = _getItemsAndActiveInd.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd2.items,
        activeIndex = _getItemsAndActiveInd2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case keycode_default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;
      case keycode_default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;
      case keycode_default.a.codes.esc:
      case keycode_default.a.codes.tab:
        this.props.onClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, { source: 'rootClose' });
  };

  DropdownMenu.prototype.render = function render() {
    var _extends2,
        _this2 = this;

    var _props = this.props,
        open = _props.open,
        pullRight = _props.pullRight,
        labelledBy = _props.labelledBy,
        onSelect = _props.onSelect,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'right')] = pullRight, _extends2));

    return react_default.a.createElement(
      RootCloseWrapper_default.a,
      {
        disabled: !open,
        onRootClose: this.handleRootClose,
        event: rootCloseEvent
      },
      react_default.a.createElement(
        'ul',
        extends_default()({}, elementProps, {
          role: 'menu',
          className: classnames_default()(className, classes),
          'aria-labelledby': labelledBy
        }),
        ValidComponentChildren.map(children, function (child) {
          return react_default.a.cloneElement(child, {
            onKeyDown: utils_createChainedFunction(child.props.onKeyDown, _this2.handleKeyDown),
            onSelect: utils_createChainedFunction(child.props.onSelect, onSelect)
          });
        })
      )
    );
  };

  return DropdownMenu;
}(react_default.a.Component);

DropdownMenu_DropdownMenu.propTypes = DropdownMenu_propTypes;
DropdownMenu_DropdownMenu.defaultProps = DropdownMenu_defaultProps;

/* harmony default export */ var es_DropdownMenu = (bootstrapUtils_bsClass('dropdown-menu', DropdownMenu_DropdownMenu));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/DropdownToggle.js













var DropdownToggle_propTypes = {
  noCaret: prop_types_default.a.bool,
  open: prop_types_default.a.bool,
  title: prop_types_default.a.string,
  useAnchor: prop_types_default.a.bool
};

var DropdownToggle_defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle_DropdownToggle = function (_React$Component) {
  inherits_default()(DropdownToggle, _React$Component);

  function DropdownToggle() {
    classCallCheck_default()(this, DropdownToggle);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  DropdownToggle.prototype.render = function render() {
    var _props = this.props,
        noCaret = _props.noCaret,
        open = _props.open,
        useAnchor = _props.useAnchor,
        bsClass = _props.bsClass,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);

    delete props.bsRole;

    var Component = useAnchor ? es_SafeAnchor : es_Button;
    var useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return react_default.a.createElement(
      Component,
      extends_default()({}, props, {
        role: 'button',
        className: classnames_default()(className, bsClass),
        'aria-haspopup': true,
        'aria-expanded': open
      }),
      children || props.title,
      useCaret && ' ',
      useCaret && react_default.a.createElement('span', { className: 'caret' })
    );
  };

  return DropdownToggle;
}(react_default.a.Component);

DropdownToggle_DropdownToggle.propTypes = DropdownToggle_propTypes;
DropdownToggle_DropdownToggle.defaultProps = DropdownToggle_defaultProps;

/* harmony default export */ var es_DropdownToggle = (bootstrapUtils_bsClass('dropdown-toggle', DropdownToggle_DropdownToggle));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Dropdown.js


























var TOGGLE_ROLE = es_DropdownToggle.defaultProps.bsRole;
var MENU_ROLE = es_DropdownMenu.defaultProps.bsRole;

var Dropdown_propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: prop_types_default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: isRequiredForA11y_default()(prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])),

  componentClass: elementType_default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: all_default()(requiredRoles(TOGGLE_ROLE, MENU_ROLE), exclusiveRoles(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: prop_types_default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: prop_types_default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: prop_types_default.a.bool,

  defaultOpen: prop_types_default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: prop_types_default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: prop_types_default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: prop_types_default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   *
   * *Note: For custom dropdown components, you will have to pass the
   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
   */
  rootCloseEvent: prop_types_default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: prop_types_default.a.func,
  /**
   * @private
   */
  onMouseLeave: prop_types_default.a.func
};

var Dropdown_defaultProps = {
  componentClass: es_ButtonGroup
};

var Dropdown_Dropdown = function (_React$Component) {
  inherits_default()(Dropdown, _React$Component);

  function Dropdown(props, context) {
    classCallCheck_default()(this, Dropdown);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);

    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  Dropdown.prototype.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = contains_default()(react_dom_default.a.findDOMNode(this.menu), activeElement_default()(document));
    }
  };

  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;

    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  Dropdown.prototype.focus = function focus() {
    var toggle = react_dom_default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  Dropdown.prototype.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, { source: 'click' });
  };

  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case keycode_default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, { source: 'keydown' });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }
        event.preventDefault();
        break;
      case keycode_default.a.codes.esc:
      case keycode_default.a.codes.tab:
        this.handleClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = objectWithoutProperties_default()(_ref, ['id', 'onSelect', 'rootCloseEvent']);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = utils_createChainedFunction(child.ref, ref);
    }

    return Object(react["cloneElement"])(child, extends_default()({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: prefix(props, 'menu'),
      onClose: utils_createChainedFunction(child.props.onClose, this.handleClose),
      onSelect: utils_createChainedFunction(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, { source: 'select' });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = utils_createChainedFunction(child.ref, ref);
    }

    return Object(react["cloneElement"])(child, extends_default()({}, props, {
      ref: ref,
      bsClass: prefix(props, 'toggle'),
      onClick: utils_createChainedFunction(child.props.onClick, this.handleClick),
      onKeyDown: utils_createChainedFunction(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  Dropdown.prototype.render = function render() {
    var _classes,
        _this4 = this;

    var _props = this.props,
        Component = _props.componentClass,
        id = _props.id,
        dropup = _props.dropup,
        disabled = _props.disabled,
        pullRight = _props.pullRight,
        open = _props.open,
        onSelect = _props.onSelect,
        role = _props.role,
        bsClass = _props.bsClass,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);

    delete props.onToggle;

    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    }

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    return react_default.a.createElement(
      Component,
      extends_default()({}, props, { className: classnames_default()(className, classes) }),
      ValidComponentChildren.map(children, function (child) {
        switch (child.props.bsRole) {
          case TOGGLE_ROLE:
            return _this4.renderToggle(child, {
              id: id,
              disabled: disabled,
              open: open,
              role: role,
              bsClass: bsClass
            });
          case MENU_ROLE:
            return _this4.renderMenu(child, {
              id: id,
              open: open,
              pullRight: pullRight,
              bsClass: bsClass,
              onSelect: onSelect,
              rootCloseEvent: rootCloseEvent
            });
          default:
            return child;
        }
      })
    );
  };

  return Dropdown;
}(react_default.a.Component);

Dropdown_Dropdown.propTypes = Dropdown_propTypes;
Dropdown_Dropdown.defaultProps = Dropdown_defaultProps;

bootstrapUtils_bsClass('dropdown', Dropdown_Dropdown);

var UncontrolledDropdown = uncontrollable_default()(Dropdown_Dropdown, { open: 'onToggle' });

UncontrolledDropdown.Toggle = es_DropdownToggle;
UncontrolledDropdown.Menu = es_DropdownMenu;

/* harmony default export */ var es_Dropdown = (UncontrolledDropdown);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/splitComponentProps.js

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;

  var parentProps = {};
  var childProps = {};

  entries_default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/DropdownButton.js











var DropdownButton_propTypes = extends_default()({}, es_Dropdown.propTypes, {

  // Toggle props.
  bsStyle: prop_types_default.a.string,
  bsSize: prop_types_default.a.string,
  title: prop_types_default.a.node.isRequired,
  noCaret: prop_types_default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: prop_types_default.a.node
});

var DropdownButton_DropdownButton = function (_React$Component) {
  inherits_default()(DropdownButton, _React$Component);

  function DropdownButton() {
    classCallCheck_default()(this, DropdownButton);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  DropdownButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['bsSize', 'bsStyle', 'title', 'children']);

    var _splitComponentProps = splitComponentProps(props, es_Dropdown.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return react_default.a.createElement(
      es_Dropdown,
      extends_default()({}, dropdownProps, { bsSize: bsSize, bsStyle: bsStyle }),
      react_default.a.createElement(
        es_Dropdown.Toggle,
        extends_default()({}, toggleProps, { bsSize: bsSize, bsStyle: bsStyle }),
        title
      ),
      react_default.a.createElement(
        es_Dropdown.Menu,
        null,
        children
      )
    );
  };

  return DropdownButton;
}(react_default.a.Component);

DropdownButton_DropdownButton.propTypes = DropdownButton_propTypes;

/* harmony default export */ var es_DropdownButton = (DropdownButton_DropdownButton);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Fade.js






var _fadeStyles;






var Fade_propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: prop_types_default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: prop_types_default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: prop_types_default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: prop_types_default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: prop_types_default.a.func,
  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: prop_types_default.a.func,
  /**
   * Callback fired after the has component faded in
   */
  onEntered: prop_types_default.a.func,
  /**
   * Callback fired before the component fades out
   */
  onExit: prop_types_default.a.func,
  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: prop_types_default.a.func,
  /**
   * Callback fired after the component has faded out
   */
  onExited: prop_types_default.a.func
};

var Fade_defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};

var fadeStyles = (_fadeStyles = {}, _fadeStyles[react_transition_group_Transition["ENTERING"]] = 'in', _fadeStyles[react_transition_group_Transition["ENTERED"]] = 'in', _fadeStyles);

var Fade_Fade = function (_React$Component) {
  inherits_default()(Fade, _React$Component);

  function Fade() {
    classCallCheck_default()(this, Fade);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Fade.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['className', 'children']);

    return react_default.a.createElement(
      Transition_default.a,
      props,
      function (status, innerProps) {
        return react_default.a.cloneElement(children, extends_default()({}, innerProps, {
          className: classnames_default()('fade', className, children.props.className, fadeStyles[status])
        }));
      }
    );
  };

  return Fade;
}(react_default.a.Component);

Fade_Fade.propTypes = Fade_propTypes;
Fade_Fade.defaultProps = Fade_defaultProps;

/* harmony default export */ var es_Fade = (Fade_Fade);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Form.js












var Form_propTypes = {
  horizontal: prop_types_default.a.bool,
  inline: prop_types_default.a.bool,
  componentClass: elementType_default.a
};

var Form_defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form_Form = function (_React$Component) {
  inherits_default()(Form, _React$Component);

  function Form() {
    classCallCheck_default()(this, Form);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Form.prototype.render = function render() {
    var _props = this.props,
        horizontal = _props.horizontal,
        inline = _props.inline,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['horizontal', 'inline', 'componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    if (horizontal) {
      classes.push(prefix(bsProps, 'horizontal'));
    }
    if (inline) {
      classes.push(prefix(bsProps, 'inline'));
    }

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return Form;
}(react_default.a.Component);

Form_Form.propTypes = Form_propTypes;
Form_Form.defaultProps = Form_defaultProps;

/* harmony default export */ var es_Form = (bootstrapUtils_bsClass('form', Form_Form));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/FormControlFeedback.js












var FormControlFeedback_defaultProps = {
  bsRole: 'feedback'
};

var FormControlFeedback_contextTypes = {
  $bs_formGroup: prop_types_default.a.object
};

var FormControlFeedback_FormControlFeedback = function (_React$Component) {
  inherits_default()(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    classCallCheck_default()(this, FormControlFeedback);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';
      case 'warning':
        return 'warning-sign';
      case 'error':
        return 'remove';
      default:
        return null;
    }
  };

  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);
    if (!glyph) {
      return null;
    }

    return react_default.a.createElement(es_Glyphicon, extends_default()({}, elementProps, {
      glyph: glyph,
      className: classnames_default()(className, classes)
    }));
  };

  FormControlFeedback.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['className', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = react_default.a.Children.only(children);
    return react_default.a.cloneElement(child, extends_default()({}, elementProps, {
      className: classnames_default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(react_default.a.Component);

FormControlFeedback_FormControlFeedback.defaultProps = FormControlFeedback_defaultProps;
FormControlFeedback_FormControlFeedback.contextTypes = FormControlFeedback_contextTypes;

/* harmony default export */ var es_FormControlFeedback = (bootstrapUtils_bsClass('form-control-feedback', FormControlFeedback_FormControlFeedback));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/FormControlStatic.js











var FormControlStatic_propTypes = {
  componentClass: elementType_default.a
};

var FormControlStatic_defaultProps = {
  componentClass: 'p'
};

var FormControlStatic_FormControlStatic = function (_React$Component) {
  inherits_default()(FormControlStatic, _React$Component);

  function FormControlStatic() {
    classCallCheck_default()(this, FormControlStatic);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  FormControlStatic.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return FormControlStatic;
}(react_default.a.Component);

FormControlStatic_FormControlStatic.propTypes = FormControlStatic_propTypes;
FormControlStatic_FormControlStatic.defaultProps = FormControlStatic_defaultProps;

/* harmony default export */ var es_FormControlStatic = (bootstrapUtils_bsClass('form-control-static', FormControlStatic_FormControlStatic));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/FormControl.js
















var FormControl_propTypes = {
  componentClass: elementType_default.a,
  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: prop_types_default.a.string,
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: prop_types_default.a.string,
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: prop_types_default.a.func
};

var FormControl_defaultProps = {
  componentClass: 'input'
};

var FormControl_contextTypes = {
  $bs_formGroup: prop_types_default.a.object
};

var FormControl_FormControl = function (_React$Component) {
  inherits_default()(FormControl, _React$Component);

  function FormControl() {
    classCallCheck_default()(this, FormControl);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        Component = _props.componentClass,
        type = _props.type,
        _props$id = _props.id,
        id = _props$id === undefined ? controlId : _props$id,
        inputRef = _props.inputRef,
        className = _props.className,
        bsSize = _props.bsSize,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;

    // input[type="file"] should not have .form-control.
    var classes = void 0;
    if (type !== 'file') {
      classes = getClassSet(bsProps);
    }

    // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm
    if (bsSize) {
      var size = SIZE_MAP[bsSize] || bsSize;
      classes[prefix({ bsClass: 'input' }, size)] = true;
    }

    return react_default.a.createElement(Component, extends_default()({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: classnames_default()(className, classes)
    }));
  };

  return FormControl;
}(react_default.a.Component);

FormControl_FormControl.propTypes = FormControl_propTypes;
FormControl_FormControl.defaultProps = FormControl_defaultProps;
FormControl_FormControl.contextTypes = FormControl_contextTypes;

FormControl_FormControl.Feedback = es_FormControlFeedback;
FormControl_FormControl.Static = es_FormControlStatic;

/* harmony default export */ var es_FormControl = (bootstrapUtils_bsClass('form-control', bsSizes([Size.SMALL, Size.LARGE], FormControl_FormControl)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/FormGroup.js













var FormGroup_propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: prop_types_default.a.string,
  validationState: prop_types_default.a.oneOf(['success', 'warning', 'error', null])
};

var FormGroup_childContextTypes = {
  $bs_formGroup: prop_types_default.a.object.isRequired
};

var FormGroup_FormGroup = function (_React$Component) {
  inherits_default()(FormGroup, _React$Component);

  function FormGroup() {
    classCallCheck_default()(this, FormGroup);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  FormGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        controlId = _props.controlId,
        validationState = _props.validationState;


    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
    var _this2 = this;

    return ValidComponentChildren.some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
    });
  };

  FormGroup.prototype.render = function render() {
    var _props2 = this.props,
        validationState = _props2.validationState,
        className = _props2.className,
        children = _props2.children,
        props = objectWithoutProperties_default()(_props2, ['validationState', 'className', 'children']);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = extends_default()({}, getClassSet(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      children
    );
  };

  return FormGroup;
}(react_default.a.Component);

FormGroup_FormGroup.propTypes = FormGroup_propTypes;
FormGroup_FormGroup.childContextTypes = FormGroup_childContextTypes;

/* harmony default export */ var es_FormGroup = (bootstrapUtils_bsClass('form-group', bsSizes([Size.LARGE, Size.SMALL], FormGroup_FormGroup)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Grid.js












var Grid_propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: prop_types_default.a.bool,
  /**
   * You can use a custom element for this component
   */
  componentClass: elementType_default.a
};

var Grid_defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid_Grid = function (_React$Component) {
  inherits_default()(Grid, _React$Component);

  function Grid() {
    classCallCheck_default()(this, Grid);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Grid.prototype.render = function render() {
    var _props = this.props,
        fluid = _props.fluid,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['fluid', 'componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = prefix(bsProps, fluid && 'fluid');

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return Grid;
}(react_default.a.Component);

Grid_Grid.propTypes = Grid_propTypes;
Grid_Grid.defaultProps = Grid_defaultProps;

/* harmony default export */ var es_Grid = (bootstrapUtils_bsClass('container', Grid_Grid));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/HelpBlock.js










var HelpBlock_HelpBlock = function (_React$Component) {
  inherits_default()(HelpBlock, _React$Component);

  function HelpBlock() {
    classCallCheck_default()(this, HelpBlock);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  HelpBlock.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement('span', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return HelpBlock;
}(react_default.a.Component);

/* harmony default export */ var es_HelpBlock = (bootstrapUtils_bsClass('help-block', HelpBlock_HelpBlock));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Image.js











var Image_propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: prop_types_default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: prop_types_default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: prop_types_default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: prop_types_default.a.bool
};

var Image_defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image_Image = function (_React$Component) {
  inherits_default()(Image, _React$Component);

  function Image() {
    classCallCheck_default()(this, Image);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Image.prototype.render = function render() {
    var _classes;

    var _props = this.props,
        responsive = _props.responsive,
        rounded = _props.rounded,
        circle = _props.circle,
        thumbnail = _props.thumbnail,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[prefix(bsProps, 'responsive')] = responsive, _classes[prefix(bsProps, 'rounded')] = rounded, _classes[prefix(bsProps, 'circle')] = circle, _classes[prefix(bsProps, 'thumbnail')] = thumbnail, _classes);

    return react_default.a.createElement('img', extends_default()({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Image;
}(react_default.a.Component);

Image_Image.propTypes = Image_propTypes;
Image_Image.defaultProps = Image_defaultProps;

/* harmony default export */ var es_Image = (bootstrapUtils_bsClass('img', Image_Image));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/InputGroupAddon.js










var InputGroupAddon_InputGroupAddon = function (_React$Component) {
  inherits_default()(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    classCallCheck_default()(this, InputGroupAddon);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupAddon.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement('span', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return InputGroupAddon;
}(react_default.a.Component);

/* harmony default export */ var es_InputGroupAddon = (bootstrapUtils_bsClass('input-group-addon', InputGroupAddon_InputGroupAddon));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/InputGroupButton.js










var InputGroupButton_InputGroupButton = function (_React$Component) {
  inherits_default()(InputGroupButton, _React$Component);

  function InputGroupButton() {
    classCallCheck_default()(this, InputGroupButton);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement('span', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return InputGroupButton;
}(react_default.a.Component);

/* harmony default export */ var es_InputGroupButton = (bootstrapUtils_bsClass('input-group-btn', InputGroupButton_InputGroupButton));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/InputGroup.js













var InputGroup_InputGroup = function (_React$Component) {
  inherits_default()(InputGroup, _React$Component);

  function InputGroup() {
    classCallCheck_default()(this, InputGroup);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  InputGroup.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement('span', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return InputGroup;
}(react_default.a.Component);

InputGroup_InputGroup.Addon = es_InputGroupAddon;
InputGroup_InputGroup.Button = es_InputGroupButton;

/* harmony default export */ var es_InputGroup = (bootstrapUtils_bsClass('input-group', bsSizes([Size.LARGE, Size.SMALL], InputGroup_InputGroup)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Jumbotron.js











var Jumbotron_propTypes = {
  componentClass: elementType_default.a
};

var Jumbotron_defaultProps = {
  componentClass: 'div'
};

var Jumbotron_Jumbotron = function (_React$Component) {
  inherits_default()(Jumbotron, _React$Component);

  function Jumbotron() {
    classCallCheck_default()(this, Jumbotron);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Jumbotron.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return Jumbotron;
}(react_default.a.Component);

Jumbotron_Jumbotron.propTypes = Jumbotron_propTypes;
Jumbotron_Jumbotron.defaultProps = Jumbotron_defaultProps;

/* harmony default export */ var es_Jumbotron = (bootstrapUtils_bsClass('jumbotron', Jumbotron_Jumbotron));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Label.js












var Label_Label = function (_React$Component) {
  inherits_default()(Label, _React$Component);

  function Label() {
    classCallCheck_default()(this, Label);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Label.prototype.hasContent = function hasContent(children) {
    var result = false;

    react_default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Label.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['className', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), {

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return react_default.a.createElement(
      'span',
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      children
    );
  };

  return Label;
}(react_default.a.Component);

/* harmony default export */ var es_Label = (bootstrapUtils_bsClass('label', bsStyles([].concat(values_default()(State), [Style.DEFAULT, Style.PRIMARY]), Style.DEFAULT, Label_Label)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ListGroupItem.js













var ListGroupItem_propTypes = {
  active: prop_types_default.a.any,
  disabled: prop_types_default.a.any,
  header: prop_types_default.a.node,
  listItem: prop_types_default.a.bool,
  onClick: prop_types_default.a.func,
  href: prop_types_default.a.string,
  type: prop_types_default.a.string
};

var ListGroupItem_defaultProps = {
  listItem: false
};

var ListGroupItem_ListGroupItem = function (_React$Component) {
  inherits_default()(ListGroupItem, _React$Component);

  function ListGroupItem() {
    classCallCheck_default()(this, ListGroupItem);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
    if (react_default.a.isValidElement(header)) {
      return Object(react["cloneElement"])(header, {
        className: classnames_default()(header.props.className, headingClassName)
      });
    }

    return react_default.a.createElement(
      'h4',
      { className: headingClassName },
      header
    );
  };

  ListGroupItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        className = _props.className,
        header = _props.header,
        listItem = _props.listItem,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component = void 0;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = classnames_default()(className, classes);

    // TODO: Deprecate `header` prop.
    if (header) {
      return react_default.a.createElement(
        Component,
        elementProps,
        this.renderHeader(header, prefix(bsProps, 'heading')),
        react_default.a.createElement(
          'p',
          { className: prefix(bsProps, 'text') },
          children
        )
      );
    }

    return react_default.a.createElement(
      Component,
      elementProps,
      children
    );
  };

  return ListGroupItem;
}(react_default.a.Component);

ListGroupItem_ListGroupItem.propTypes = ListGroupItem_propTypes;
ListGroupItem_ListGroupItem.defaultProps = ListGroupItem_defaultProps;

/* harmony default export */ var es_ListGroupItem = (bootstrapUtils_bsClass('list-group-item', bsStyles(values_default()(State), ListGroupItem_ListGroupItem)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ListGroup.js













var ListGroup_propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: elementType_default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (ValidComponentChildren.some(children, function (child) {
    return child.type !== es_ListGroupItem || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup_ListGroup = function (_React$Component) {
  inherits_default()(ListGroup, _React$Component);

  function ListGroup() {
    classCallCheck_default()(this, ListGroup);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ListGroup.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$componentClass = _props.componentClass,
        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['children', 'componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    var useListItem = Component === 'ul' && ValidComponentChildren.every(children, function (child) {
      return child.type === es_ListGroupItem;
    });

    return react_default.a.createElement(
      Component,
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      useListItem ? ValidComponentChildren.map(children, function (child) {
        return Object(react["cloneElement"])(child, { listItem: true });
      }) : children
    );
  };

  return ListGroup;
}(react_default.a.Component);

ListGroup_ListGroup.propTypes = ListGroup_propTypes;

/* harmony default export */ var es_ListGroup = (bootstrapUtils_bsClass('list-group', ListGroup_ListGroup));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaBody.js













var MediaBody_propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: prop_types_default.a.oneOf(['top', 'middle', 'bottom']),

  componentClass: elementType_default.a
};

var MediaBody_defaultProps = {
  componentClass: 'div'
};

var MediaBody_MediaBody = function (_React$Component) {
  inherits_default()(MediaBody, _React$Component);

  function MediaBody() {
    classCallCheck_default()(this, MediaBody);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  MediaBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        align = _props.align,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'align', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[prefix(es_Media.defaultProps, align)] = true;
    }

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return MediaBody;
}(react_default.a.Component);

MediaBody_MediaBody.propTypes = MediaBody_propTypes;
MediaBody_MediaBody.defaultProps = MediaBody_defaultProps;

/* harmony default export */ var es_MediaBody = (bootstrapUtils_bsClass('media-body', MediaBody_MediaBody));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaHeading.js











var MediaHeading_propTypes = {
  componentClass: elementType_default.a
};

var MediaHeading_defaultProps = {
  componentClass: 'h4'
};

var MediaHeading_MediaHeading = function (_React$Component) {
  inherits_default()(MediaHeading, _React$Component);

  function MediaHeading() {
    classCallCheck_default()(this, MediaHeading);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  MediaHeading.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return MediaHeading;
}(react_default.a.Component);

MediaHeading_MediaHeading.propTypes = MediaHeading_propTypes;
MediaHeading_MediaHeading.defaultProps = MediaHeading_defaultProps;

/* harmony default export */ var es_MediaHeading = (bootstrapUtils_bsClass('media-heading', MediaHeading_MediaHeading));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaLeft.js












var MediaLeft_propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: prop_types_default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft_MediaLeft = function (_React$Component) {
  inherits_default()(MediaLeft, _React$Component);

  function MediaLeft() {
    classCallCheck_default()(this, MediaLeft);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  MediaLeft.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['align', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[prefix(es_Media.defaultProps, align)] = true;
    }

    return react_default.a.createElement('div', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return MediaLeft;
}(react_default.a.Component);

MediaLeft_MediaLeft.propTypes = MediaLeft_propTypes;

/* harmony default export */ var es_MediaLeft = (bootstrapUtils_bsClass('media-left', MediaLeft_MediaLeft));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaList.js










var MediaList_MediaList = function (_React$Component) {
  inherits_default()(MediaList, _React$Component);

  function MediaList() {
    classCallCheck_default()(this, MediaList);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  MediaList.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement('ul', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return MediaList;
}(react_default.a.Component);

/* harmony default export */ var es_MediaList = (bootstrapUtils_bsClass('media-list', MediaList_MediaList));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaListItem.js










var MediaListItem_MediaListItem = function (_React$Component) {
  inherits_default()(MediaListItem, _React$Component);

  function MediaListItem() {
    classCallCheck_default()(this, MediaListItem);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  MediaListItem.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement('li', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return MediaListItem;
}(react_default.a.Component);

/* harmony default export */ var es_MediaListItem = (bootstrapUtils_bsClass('media', MediaListItem_MediaListItem));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaRight.js












var MediaRight_propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: prop_types_default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight_MediaRight = function (_React$Component) {
  inherits_default()(MediaRight, _React$Component);

  function MediaRight() {
    classCallCheck_default()(this, MediaRight);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  MediaRight.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['align', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[prefix(es_Media.defaultProps, align)] = true;
    }

    return react_default.a.createElement('div', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return MediaRight;
}(react_default.a.Component);

MediaRight_MediaRight.propTypes = MediaRight_propTypes;

/* harmony default export */ var es_MediaRight = (bootstrapUtils_bsClass('media-right', MediaRight_MediaRight));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Media.js

















var Media_propTypes = {
  componentClass: elementType_default.a
};

var Media_defaultProps = {
  componentClass: 'div'
};

var Media_Media = function (_React$Component) {
  inherits_default()(Media, _React$Component);

  function Media() {
    classCallCheck_default()(this, Media);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Media.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return Media;
}(react_default.a.Component);

Media_Media.propTypes = Media_propTypes;
Media_Media.defaultProps = Media_defaultProps;

Media_Media.Heading = es_MediaHeading;
Media_Media.Body = es_MediaBody;
Media_Media.Left = es_MediaLeft;
Media_Media.Right = es_MediaRight;
Media_Media.List = es_MediaList;
Media_Media.ListItem = es_MediaListItem;

/* harmony default export */ var es_Media = (bootstrapUtils_bsClass('media', Media_Media));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MenuItem.js














var MenuItem_propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: prop_types_default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: prop_types_default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: all_default()(prop_types_default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: prop_types_default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: prop_types_default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: prop_types_default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: prop_types_default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: prop_types_default.a.func
};

var MenuItem_defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem_MenuItem = function (_React$Component) {
  inherits_default()(MenuItem, _React$Component);

  function MenuItem(props, context) {
    classCallCheck_default()(this, MenuItem);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  MenuItem.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        href = _props.href,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  MenuItem.prototype.render = function render() {
    var _props2 = this.props,
        active = _props2.active,
        disabled = _props2.disabled,
        divider = _props2.divider,
        header = _props2.header,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = objectWithoutProperties_default()(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;

      return react_default.a.createElement('li', extends_default()({}, elementProps, {
        role: 'separator',
        className: classnames_default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return react_default.a.createElement('li', extends_default()({}, elementProps, {
        role: 'heading',
        className: classnames_default()(className, prefix(bsProps, 'header')),
        style: style
      }));
    }

    return react_default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: classnames_default()(className, { active: active, disabled: disabled }),
        style: style
      },
      react_default.a.createElement(es_SafeAnchor, extends_default()({}, elementProps, {
        role: 'menuitem',
        tabIndex: '-1',
        onClick: utils_createChainedFunction(onClick, this.handleClick)
      }))
    );
  };

  return MenuItem;
}(react_default.a.Component);

MenuItem_MenuItem.propTypes = MenuItem_propTypes;
MenuItem_MenuItem.defaultProps = MenuItem_defaultProps;

/* harmony default export */ var es_MenuItem = (bootstrapUtils_bsClass('dropdown', MenuItem_MenuItem));
// EXTERNAL MODULE: ./node_modules/dom-helpers/events/index.js
var events = __webpack_require__(1741);
var events_default = /*#__PURE__*/__webpack_require__.n(events);

// EXTERNAL MODULE: ./node_modules/dom-helpers/ownerDocument.js
var ownerDocument = __webpack_require__(902);
var ownerDocument_default = /*#__PURE__*/__webpack_require__.n(ownerDocument);

// EXTERNAL MODULE: ./node_modules/dom-helpers/util/inDOM.js
var inDOM = __webpack_require__(862);
var inDOM_default = /*#__PURE__*/__webpack_require__.n(inDOM);

// EXTERNAL MODULE: ./node_modules/dom-helpers/util/scrollbarSize.js
var scrollbarSize = __webpack_require__(1151);
var scrollbarSize_default = /*#__PURE__*/__webpack_require__.n(scrollbarSize);

// EXTERNAL MODULE: ./node_modules/react-overlays/lib/Modal.js
var lib_Modal = __webpack_require__(1745);
var Modal_default = /*#__PURE__*/__webpack_require__.n(lib_Modal);

// EXTERNAL MODULE: ./node_modules/react-overlays/lib/utils/isOverflowing.js
var isOverflowing = __webpack_require__(1153);
var isOverflowing_default = /*#__PURE__*/__webpack_require__.n(isOverflowing);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalBody.js











var ModalBody_propTypes = {
  componentClass: elementType_default.a
};

var ModalBody_defaultProps = {
  componentClass: 'div'
};

var ModalBody_ModalBody = function (_React$Component) {
  inherits_default()(ModalBody, _React$Component);

  function ModalBody() {
    classCallCheck_default()(this, ModalBody);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ModalBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return ModalBody;
}(react_default.a.Component);

ModalBody_ModalBody.propTypes = ModalBody_propTypes;
ModalBody_ModalBody.defaultProps = ModalBody_defaultProps;

/* harmony default export */ var es_ModalBody = (bootstrapUtils_bsClass('modal-body', ModalBody_ModalBody));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalDialog.js












var ModalDialog_propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: prop_types_default.a.string
};

var ModalDialog_ModalDialog = function (_React$Component) {
  inherits_default()(ModalDialog, _React$Component);

  function ModalDialog() {
    classCallCheck_default()(this, ModalDialog);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ModalDialog.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        dialogClassName = _props.dialogClassName,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['dialogClassName', 'className', 'style', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = prefix(bsProps);

    var modalStyle = extends_default()({ display: 'block' }, style);

    var dialogClasses = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[prefix(bsProps, 'dialog')] = true, _extends2));

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, {
        tabIndex: '-1',
        role: 'dialog',
        style: modalStyle,
        className: classnames_default()(className, bsClassName)
      }),
      react_default.a.createElement(
        'div',
        { className: classnames_default()(dialogClassName, dialogClasses) },
        react_default.a.createElement(
          'div',
          { className: prefix(bsProps, 'content'), role: 'document' },
          children
        )
      )
    );
  };

  return ModalDialog;
}(react_default.a.Component);

ModalDialog_ModalDialog.propTypes = ModalDialog_propTypes;

/* harmony default export */ var es_ModalDialog = (bootstrapUtils_bsClass('modal', bsSizes([Size.LARGE, Size.SMALL], ModalDialog_ModalDialog)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalFooter.js











var ModalFooter_propTypes = {
  componentClass: elementType_default.a
};

var ModalFooter_defaultProps = {
  componentClass: 'div'
};

var ModalFooter_ModalFooter = function (_React$Component) {
  inherits_default()(ModalFooter, _React$Component);

  function ModalFooter() {
    classCallCheck_default()(this, ModalFooter);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ModalFooter.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return ModalFooter;
}(react_default.a.Component);

ModalFooter_ModalFooter.propTypes = ModalFooter_propTypes;
ModalFooter_ModalFooter.defaultProps = ModalFooter_defaultProps;

/* harmony default export */ var es_ModalFooter = (bootstrapUtils_bsClass('modal-footer', ModalFooter_ModalFooter));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalHeader.js













// TODO: `aria-label` should be `closeLabel`.

var ModalHeader_propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: prop_types_default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: prop_types_default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: prop_types_default.a.func
};

var ModalHeader_defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};

var ModalHeader_contextTypes = {
  $bs_modal: prop_types_default.a.shape({
    onHide: prop_types_default.a.func
  })
};

var ModalHeader_ModalHeader = function (_React$Component) {
  inherits_default()(ModalHeader, _React$Component);

  function ModalHeader() {
    classCallCheck_default()(this, ModalHeader);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ModalHeader.prototype.render = function render() {
    var _props = this.props,
        closeLabel = _props.closeLabel,
        closeButton = _props.closeButton,
        onHide = _props.onHide,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);

    var modal = this.context.$bs_modal;

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      closeButton && react_default.a.createElement(es_CloseButton, {
        label: closeLabel,
        onClick: utils_createChainedFunction(modal && modal.onHide, onHide)
      }),
      children
    );
  };

  return ModalHeader;
}(react_default.a.Component);

ModalHeader_ModalHeader.propTypes = ModalHeader_propTypes;
ModalHeader_ModalHeader.defaultProps = ModalHeader_defaultProps;
ModalHeader_ModalHeader.contextTypes = ModalHeader_contextTypes;

/* harmony default export */ var es_ModalHeader = (bootstrapUtils_bsClass('modal-header', ModalHeader_ModalHeader));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalTitle.js











var ModalTitle_propTypes = {
  componentClass: elementType_default.a
};

var ModalTitle_defaultProps = {
  componentClass: 'h4'
};

var ModalTitle_ModalTitle = function (_React$Component) {
  inherits_default()(ModalTitle, _React$Component);

  function ModalTitle() {
    classCallCheck_default()(this, ModalTitle);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ModalTitle.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return ModalTitle;
}(react_default.a.Component);

ModalTitle_ModalTitle.propTypes = ModalTitle_propTypes;
ModalTitle_ModalTitle.defaultProps = ModalTitle_defaultProps;

/* harmony default export */ var es_ModalTitle = (bootstrapUtils_bsClass('modal-title', ModalTitle_ModalTitle));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Modal.js




























var Modal_propTypes = extends_default()({}, Modal_default.a.propTypes, es_ModalDialog.propTypes, {

  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: prop_types_default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: prop_types_default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: prop_types_default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: prop_types_default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: elementType_default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: prop_types_default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: prop_types_default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: prop_types_default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: prop_types_default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: prop_types_default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: prop_types_default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: prop_types_default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: prop_types_default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: prop_types_default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: prop_types_default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: prop_types_default.a.func,

  /**
   * @private
   */
  container: Modal_default.a.propTypes.container
});

var Modal_defaultProps = extends_default()({}, Modal_default.a.defaultProps, {
  animation: true,
  dialogComponentClass: es_ModalDialog
});

var Modal_childContextTypes = {
  $bs_modal: prop_types_default.a.shape({
    onHide: prop_types_default.a.func
  })
};

/* eslint-disable no-use-before-define, react/no-multi-comp */
function DialogTransition(props) {
  return react_default.a.createElement(es_Fade, extends_default()({}, props, { timeout: Modal_Modal.TRANSITION_DURATION }));
}

function BackdropTransition(props) {
  return react_default.a.createElement(es_Fade, extends_default()({}, props, { timeout: Modal_Modal.BACKDROP_TRANSITION_DURATION }));
}

/* eslint-enable no-use-before-define */

var Modal_Modal = function (_React$Component) {
  inherits_default()(Modal, _React$Component);

  function Modal(props, context) {
    classCallCheck_default()(this, Modal);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
    _this.setModalRef = _this.setModalRef.bind(_this);

    _this.state = {
      style: {}
    };
    return _this;
  }

  Modal.prototype.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  Modal.prototype.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  Modal.prototype.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    events_default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  Modal.prototype.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    events_default.a.off(window, 'resize', this.handleWindowResize);
  };

  Modal.prototype.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  Modal.prototype.updateStyle = function updateStyle() {
    if (!inDOM_default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();
    var dialogHeight = dialogNode.scrollHeight;

    var document = ownerDocument_default()(dialogNode);
    var bodyIsOverflowing = isOverflowing_default()(react_dom_default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;

    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? scrollbarSize_default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? scrollbarSize_default()() : undefined
      }
    });
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        backdrop = _props.backdrop,
        backdropClassName = _props.backdropClassName,
        animation = _props.animation,
        show = _props.show,
        Dialog = _props.dialogComponentClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        onEntering = _props.onEntering,
        onExited = _props.onExited,
        props = objectWithoutProperties_default()(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);

    var _splitComponentProps = splitComponentProps(props, Modal_default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';

    return react_default.a.createElement(
      Modal_default.a,
      extends_default()({}, baseModalProps, {
        ref: this.setModalRef,
        show: show,
        containerClassName: prefix(props, 'open'),
        transition: animation ? DialogTransition : undefined,
        backdrop: backdrop,
        backdropTransition: animation ? BackdropTransition : undefined,
        backdropClassName: classnames_default()(prefix(props, 'backdrop'), backdropClassName, inClassName),
        onEntering: utils_createChainedFunction(onEntering, this.handleEntering),
        onExited: utils_createChainedFunction(onExited, this.handleExited)
      }),
      react_default.a.createElement(
        Dialog,
        extends_default()({}, dialogProps, {
          style: extends_default()({}, this.state.style, style),
          className: classnames_default()(className, inClassName),
          onClick: backdrop === true ? this.handleDialogClick : null
        }),
        children
      )
    );
  };

  return Modal;
}(react_default.a.Component);

Modal_Modal.propTypes = Modal_propTypes;
Modal_Modal.defaultProps = Modal_defaultProps;
Modal_Modal.childContextTypes = Modal_childContextTypes;

Modal_Modal.Body = es_ModalBody;
Modal_Modal.Header = es_ModalHeader;
Modal_Modal.Title = es_ModalTitle;
Modal_Modal.Footer = es_ModalFooter;

Modal_Modal.Dialog = es_ModalDialog;

Modal_Modal.TRANSITION_DURATION = 300;
Modal_Modal.BACKDROP_TRANSITION_DURATION = 150;

/* harmony default export */ var es_Modal = (bootstrapUtils_bsClass('modal', bsSizes([Size.LARGE, Size.SMALL], Modal_Modal)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Nav.js

















// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?

// TODO: This `bsStyle` is very unlike the others. Should we rename it?

// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var Nav_propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: prop_types_default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: prop_types_default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: prop_types_default.a.bool,

  justified: all_default()(prop_types_default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: prop_types_default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: prop_types_default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: prop_types_default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: prop_types_default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: prop_types_default.a.bool
};

var Nav_defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};

var Nav_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    onSelect: prop_types_default.a.func
  }),

  $bs_tabContainer: prop_types_default.a.shape({
    activeKey: prop_types_default.a.any,
    onSelect: prop_types_default.a.func.isRequired,
    getTabId: prop_types_default.a.func.isRequired,
    getPaneId: prop_types_default.a.func.isRequired
  })
};

var Nav_Nav = function (_React$Component) {
  inherits_default()(Nav, _React$Component);

  function Nav() {
    classCallCheck_default()(this, Nav);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;

    var children = this.props.children;

    var _getActiveProps = this.getActiveProps(),
        activeKey = _getActiveProps.activeKey,
        activeHref = _getActiveProps.activeHref;

    var activeChild = ValidComponentChildren.find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    });

    var childrenArray = ValidComponentChildren.toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);

    var childNodes = react_dom_default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  Nav.prototype.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;

      return tabContainer;
    }

    return this.props;
  };

  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
    var _this3 = this;

    var children = this.props.children;

    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _getActiveProps2 = this.getActiveProps(),
        activeKey = _getActiveProps2.activeKey,
        activeHref = _getActiveProps2.activeHref;

    var activeChild = ValidComponentChildren.find(children, function (child) {
      return _this3.isActive(child, activeKey, activeHref);
    });

    // This assumes the active child is not disabled.
    var activeChildIndex = validChildren.indexOf(activeChild);
    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this4 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;


    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = utils_createChainedFunction(function (event) {
        return _this4.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild = void 0;

    switch (event.keyCode) {
      case keycode_default.a.codes.left:
      case keycode_default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;
      case keycode_default.a.codes.right:
      case keycode_default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;
      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  Nav.prototype.render = function render() {
    var _extends2,
        _this5 = this;

    var _props = this.props,
        stacked = _props.stacked,
        justified = _props.justified,
        onSelect = _props.onSelect,
        propsRole = _props.role,
        propsNavbar = _props.navbar,
        pullRight = _props.pullRight,
        pullLeft = _props.pullLeft,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _getActiveProps3 = this.getActiveProps(),
        activeKey = _getActiveProps3.activeKey,
        activeHref = _getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().
    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'stacked')] = stacked, _extends2[prefix(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName = void 0;
    var pullRightClassName = void 0;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

      classes[prefix(navbarProps, 'nav')] = true;

      pullRightClassName = prefix(navbarProps, 'right');
      pullLeftClassName = prefix(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;

    return react_default.a.createElement(
      'ul',
      extends_default()({}, elementProps, {
        role: role,
        className: classnames_default()(className, classes)
      }),
      ValidComponentChildren.map(children, function (child) {
        var active = _this5.isActive(child, activeKey, activeHref);
        var childOnSelect = utils_createChainedFunction(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);

        return Object(react["cloneElement"])(child, extends_default()({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
          active: active,
          activeKey: activeKey,
          activeHref: activeHref,
          onSelect: childOnSelect
        }));
      })
    );
  };

  return Nav;
}(react_default.a.Component);

Nav_Nav.propTypes = Nav_propTypes;
Nav_Nav.defaultProps = Nav_defaultProps;
Nav_Nav.contextTypes = Nav_contextTypes;

/* harmony default export */ var es_Nav = (bootstrapUtils_bsClass('nav', bsStyles(['tabs', 'pills'], Nav_Nav)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavbarBrand.js











var NavbarBrand_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};

var NavbarBrand_NavbarBrand = function (_React$Component) {
  inherits_default()(NavbarBrand, _React$Component);

  function NavbarBrand() {
    classCallCheck_default()(this, NavbarBrand);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  NavbarBrand.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = prefix(navbarProps, 'brand');

    if (react_default.a.isValidElement(children)) {
      return react_default.a.cloneElement(children, {
        className: classnames_default()(children.props.className, className, bsClassName)
      });
    }

    return react_default.a.createElement(
      'span',
      extends_default()({}, props, { className: classnames_default()(className, bsClassName) }),
      children
    );
  };

  return NavbarBrand;
}(react_default.a.Component);

NavbarBrand_NavbarBrand.contextTypes = NavbarBrand_contextTypes;

/* harmony default export */ var es_NavbarBrand = (NavbarBrand_NavbarBrand);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavbarCollapse.js











var NavbarCollapse_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    expanded: prop_types_default.a.bool
  })
};

var NavbarCollapse_NavbarCollapse = function (_React$Component) {
  inherits_default()(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    classCallCheck_default()(this, NavbarCollapse);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  NavbarCollapse.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = prefix(navbarProps, 'collapse');

    return react_default.a.createElement(
      es_Collapse,
      extends_default()({ 'in': navbarProps.expanded }, props),
      react_default.a.createElement(
        'div',
        { className: bsClassName },
        children
      )
    );
  };

  return NavbarCollapse;
}(react_default.a.Component);

NavbarCollapse_NavbarCollapse.contextTypes = NavbarCollapse_contextTypes;

/* harmony default export */ var es_NavbarCollapse = (NavbarCollapse_NavbarCollapse);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavbarHeader.js











var NavbarHeader_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};

var NavbarHeader_NavbarHeader = function (_React$Component) {
  inherits_default()(NavbarHeader, _React$Component);

  function NavbarHeader() {
    classCallCheck_default()(this, NavbarHeader);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  NavbarHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = prefix(navbarProps, 'header');

    return react_default.a.createElement('div', extends_default()({}, props, { className: classnames_default()(className, bsClassName) }));
  };

  return NavbarHeader;
}(react_default.a.Component);

NavbarHeader_NavbarHeader.contextTypes = NavbarHeader_contextTypes;

/* harmony default export */ var es_NavbarHeader = (NavbarHeader_NavbarHeader);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavbarToggle.js












var NavbarToggle_propTypes = {
  onClick: prop_types_default.a.func,
  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: prop_types_default.a.node
};

var NavbarToggle_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    expanded: prop_types_default.a.bool,
    onToggle: prop_types_default.a.func.isRequired
  })
};

var NavbarToggle_NavbarToggle = function (_React$Component) {
  inherits_default()(NavbarToggle, _React$Component);

  function NavbarToggle() {
    classCallCheck_default()(this, NavbarToggle);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  NavbarToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['onClick', 'className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var buttonProps = extends_default()({
      type: 'button'
    }, props, {
      onClick: utils_createChainedFunction(onClick, navbarProps.onToggle),
      className: classnames_default()(className, prefix(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return react_default.a.createElement(
        'button',
        buttonProps,
        children
      );
    }

    return react_default.a.createElement(
      'button',
      buttonProps,
      react_default.a.createElement(
        'span',
        { className: 'sr-only' },
        'Toggle navigation'
      ),
      react_default.a.createElement('span', { className: 'icon-bar' }),
      react_default.a.createElement('span', { className: 'icon-bar' }),
      react_default.a.createElement('span', { className: 'icon-bar' })
    );
  };

  return NavbarToggle;
}(react_default.a.Component);

NavbarToggle_NavbarToggle.propTypes = NavbarToggle_propTypes;
NavbarToggle_NavbarToggle.contextTypes = NavbarToggle_contextTypes;

/* harmony default export */ var es_NavbarToggle = (NavbarToggle_NavbarToggle);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Navbar.js





// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
/* eslint-disable react/no-multi-comp */
















var Navbar_propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: prop_types_default.a.bool,
  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: prop_types_default.a.bool,
  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: prop_types_default.a.bool,
  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: prop_types_default.a.bool,
  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: prop_types_default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: elementType_default.a,
  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: prop_types_default.a.func,
  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: prop_types_default.a.func,
  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: prop_types_default.a.bool,
  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: prop_types_default.a.bool,

  role: prop_types_default.a.string
};

var Navbar_defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};

var Navbar_childContextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    expanded: prop_types_default.a.bool,
    onToggle: prop_types_default.a.func.isRequired,
    onSelect: prop_types_default.a.func
  })
};

var Navbar_Navbar = function (_React$Component) {
  inherits_default()(Navbar, _React$Component);

  function Navbar(props, context) {
    classCallCheck_default()(this, Navbar);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleCollapse = _this.handleCollapse.bind(_this);
    return _this;
  }

  Navbar.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        expanded = _props.expanded,
        onSelect = _props.onSelect,
        collapseOnSelect = _props.collapseOnSelect;


    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: utils_createChainedFunction(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  Navbar.prototype.handleCollapse = function handleCollapse() {
    var _props2 = this.props,
        onToggle = _props2.onToggle,
        expanded = _props2.expanded;


    if (expanded) {
      onToggle(false);
    }
  };

  Navbar.prototype.handleToggle = function handleToggle() {
    var _props3 = this.props,
        onToggle = _props3.onToggle,
        expanded = _props3.expanded;


    onToggle(!expanded);
  };

  Navbar.prototype.render = function render() {
    var _extends2;

    var _props4 = this.props,
        Component = _props4.componentClass,
        fixedTop = _props4.fixedTop,
        fixedBottom = _props4.fixedBottom,
        staticTop = _props4.staticTop,
        inverse = _props4.inverse,
        fluid = _props4.fluid,
        className = _props4.className,
        children = _props4.children,
        props = objectWithoutProperties_default()(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = Style.INVERSE;
    }

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'fixed-top')] = fixedTop, _extends2[prefix(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[prefix(bsProps, 'static-top')] = staticTop, _extends2));

    return react_default.a.createElement(
      Component,
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      react_default.a.createElement(
        es_Grid,
        { fluid: fluid },
        children
      )
    );
  };

  return Navbar;
}(react_default.a.Component);

Navbar_Navbar.propTypes = Navbar_propTypes;
Navbar_Navbar.defaultProps = Navbar_defaultProps;
Navbar_Navbar.childContextTypes = Navbar_childContextTypes;

bootstrapUtils_bsClass('navbar', Navbar_Navbar);

var UncontrollableNavbar = uncontrollable_default()(Navbar_Navbar, { expanded: 'onToggle' });

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;

    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = objectWithoutProperties_default()(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);

    return react_default.a.createElement(Component, extends_default()({}, props, {
      className: classnames_default()(className, prefix(navbarProps, suffix), pullRight && prefix(navbarProps, 'right'), pullLeft && prefix(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;

  Wrapper.propTypes = {
    componentClass: elementType_default.a,
    pullRight: prop_types_default.a.bool,
    pullLeft: prop_types_default.a.bool
  };

  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };

  Wrapper.contextTypes = {
    $bs_navbar: prop_types_default.a.shape({
      bsClass: prop_types_default.a.string
    })
  };

  return Wrapper;
}

UncontrollableNavbar.Brand = es_NavbarBrand;
UncontrollableNavbar.Header = es_NavbarHeader;
UncontrollableNavbar.Toggle = es_NavbarToggle;
UncontrollableNavbar.Collapse = es_NavbarCollapse;

UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');

// Set bsStyles here so they can be overridden.
/* harmony default export */ var es_Navbar = (bsStyles([Style.DEFAULT, Style.INVERSE], Style.DEFAULT, UncontrollableNavbar));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavDropdown.js













var NavDropdown_propTypes = extends_default()({}, es_Dropdown.propTypes, {

  // Toggle props.
  title: prop_types_default.a.node.isRequired,
  noCaret: prop_types_default.a.bool,
  active: prop_types_default.a.bool,
  activeKey: prop_types_default.a.any,
  activeHref: prop_types_default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: prop_types_default.a.node
});

var NavDropdown_NavDropdown = function (_React$Component) {
  inherits_default()(NavDropdown, _React$Component);

  function NavDropdown() {
    classCallCheck_default()(this, NavDropdown);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
    var props = _ref.props;

    var _this2 = this;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (ValidComponentChildren.some(props.children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  NavDropdown.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        title = _props.title,
        activeKey = _props.activeKey,
        activeHref = _props.activeHref,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().
    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = splitComponentProps(props, es_Dropdown.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.

    return react_default.a.createElement(
      es_Dropdown,
      extends_default()({}, dropdownProps, {
        componentClass: 'li',
        className: classnames_default()(className, { active: active }),
        style: style
      }),
      react_default.a.createElement(
        es_Dropdown.Toggle,
        extends_default()({}, toggleProps, { useAnchor: true }),
        title
      ),
      react_default.a.createElement(
        es_Dropdown.Menu,
        null,
        ValidComponentChildren.map(children, function (child) {
          return react_default.a.cloneElement(child, {
            active: _this3.isActive(child, activeKey, activeHref)
          });
        })
      )
    );
  };

  return NavDropdown;
}(react_default.a.Component);

NavDropdown_NavDropdown.propTypes = NavDropdown_propTypes;

/* harmony default export */ var es_NavDropdown = (NavDropdown_NavDropdown);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavItem.js












var NavItem_propTypes = {
  active: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  href: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  onSelect: prop_types_default.a.func,
  eventKey: prop_types_default.a.any
};

var NavItem_defaultProps = {
  active: false,
  disabled: false
};

var NavItem_NavItem = function (_React$Component) {
  inherits_default()(NavItem, _React$Component);

  function NavItem(props, context) {
    classCallCheck_default()(this, NavItem);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  NavItem.prototype.handleClick = function handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  };

  NavItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        onClick = _props.onClick,
        className = _props.className,
        style = _props.style,
        props = objectWithoutProperties_default()(_props, ['active', 'disabled', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return react_default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: classnames_default()(className, { active: active, disabled: disabled }),
        style: style
      },
      react_default.a.createElement(es_SafeAnchor, extends_default()({}, props, {
        disabled: disabled,
        onClick: utils_createChainedFunction(onClick, this.handleClick)
      }))
    );
  };

  return NavItem;
}(react_default.a.Component);

NavItem_NavItem.propTypes = NavItem_propTypes;
NavItem_NavItem.defaultProps = NavItem_defaultProps;

/* harmony default export */ var es_NavItem = (NavItem_NavItem);
// EXTERNAL MODULE: ./node_modules/react-overlays/lib/Overlay.js
var lib_Overlay = __webpack_require__(1755);
var Overlay_default = /*#__PURE__*/__webpack_require__.n(lib_Overlay);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Overlay.js













var Overlay_propTypes = extends_default()({}, Overlay_default.a.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: prop_types_default.a.bool,
  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: prop_types_default.a.bool,
  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: prop_types_default.a.func,

  /**
   * Use animation
   */
  animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: prop_types_default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: prop_types_default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: prop_types_default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: prop_types_default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: prop_types_default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: prop_types_default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: prop_types_default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var Overlay_defaultProps = {
  animation: es_Fade,
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay_Overlay = function (_React$Component) {
  inherits_default()(Overlay, _React$Component);

  function Overlay() {
    classCallCheck_default()(this, Overlay);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Overlay.prototype.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['animation', 'children']);

    var transition = animation === true ? es_Fade : animation || null;

    var child = void 0;

    if (!transition) {
      child = Object(react["cloneElement"])(children, {
        className: classnames_default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return react_default.a.createElement(
      Overlay_default.a,
      extends_default()({}, props, { transition: transition }),
      child
    );
  };

  return Overlay;
}(react_default.a.Component);

Overlay_Overlay.propTypes = Overlay_propTypes;
Overlay_Overlay.defaultProps = Overlay_defaultProps;

/* harmony default export */ var es_Overlay = (Overlay_Overlay);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/OverlayTrigger.js















/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }
  return one === of;
}

var triggerType = prop_types_default.a.oneOf(['click', 'hover', 'focus']);

var OverlayTrigger_propTypes = extends_default()({}, es_Overlay.propTypes, {

  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: prop_types_default.a.oneOfType([triggerType, prop_types_default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: prop_types_default.a.number,
  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: prop_types_default.a.number,
  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: prop_types_default.a.number,

  // FIXME: This should be `defaultShow`.
  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: prop_types_default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: prop_types_default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: prop_types_default.a.func,
  /**
   * @private
   */
  onClick: prop_types_default.a.func,
  /**
   * @private
   */
  onFocus: prop_types_default.a.func,
  /**
   * @private
   */
  onMouseOut: prop_types_default.a.func,
  /**
   * @private
   */
  onMouseOver: prop_types_default.a.func,

  // Overridden props from `<Overlay>`.
  /**
   * @private
   */
  target: prop_types_default.a.oneOf([null]),
  /**
   * @private
   */
  onHide: prop_types_default.a.oneOf([null]),
  /**
   * @private
   */
  show: prop_types_default.a.oneOf([null])
});

var OverlayTrigger_defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger_OverlayTrigger = function (_React$Component) {
  inherits_default()(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    classCallCheck_default()(this, OverlayTrigger);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };
    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;

    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
    react_dom_default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;

    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;
      _this2.hide();
    }, delay);
  };

  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;
      _this3.show();
    }, delay);
  };

  OverlayTrigger.prototype.handleHide = function handleHide() {
    this.hide();
  };

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !contains_default()(target, related)) {
      handler(e);
    }
  };

  OverlayTrigger.prototype.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  OverlayTrigger.prototype.hide = function hide() {
    this.setState({ show: false });
  };

  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
    return react_default.a.createElement(
      es_Overlay,
      extends_default()({}, props, {
        show: this.state.show,
        onHide: this.handleHide,
        target: this
      }),
      overlay
    );
  };

  OverlayTrigger.prototype.show = function show() {
    this.setState({ show: true });
  };

  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
    react_dom_default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  OverlayTrigger.prototype.render = function render() {
    var _props = this.props,
        trigger = _props.trigger,
        overlay = _props.overlay,
        children = _props.children,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        props = objectWithoutProperties_default()(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    var child = react_default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    }

    // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.

    triggerProps.onClick = utils_createChainedFunction(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = utils_createChainedFunction(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;

      triggerProps.onMouseOver = utils_createChainedFunction(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = utils_createChainedFunction(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = utils_createChainedFunction(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = utils_createChainedFunction(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);

    return Object(react["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(react_default.a.Component);

OverlayTrigger_OverlayTrigger.propTypes = OverlayTrigger_propTypes;
OverlayTrigger_OverlayTrigger.defaultProps = OverlayTrigger_defaultProps;

/* harmony default export */ var es_OverlayTrigger = (OverlayTrigger_OverlayTrigger);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PageHeader.js










var PageHeader_PageHeader = function (_React$Component) {
  inherits_default()(PageHeader, _React$Component);

  function PageHeader() {
    classCallCheck_default()(this, PageHeader);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  PageHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['className', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      react_default.a.createElement(
        'h1',
        null,
        children
      )
    );
  };

  return PageHeader;
}(react_default.a.Component);

/* harmony default export */ var es_PageHeader = (bootstrapUtils_bsClass('page-header', PageHeader_PageHeader));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PagerItem.js












var PagerItem_propTypes = {
  disabled: prop_types_default.a.bool,
  previous: prop_types_default.a.bool,
  next: prop_types_default.a.bool,
  onClick: prop_types_default.a.func,
  onSelect: prop_types_default.a.func,
  eventKey: prop_types_default.a.any
};

var PagerItem_defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem_PagerItem = function (_React$Component) {
  inherits_default()(PagerItem, _React$Component);

  function PagerItem(props, context) {
    classCallCheck_default()(this, PagerItem);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }

  PagerItem.prototype.handleSelect = function handleSelect(e) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  PagerItem.prototype.render = function render() {
    var _props2 = this.props,
        disabled = _props2.disabled,
        previous = _props2.previous,
        next = _props2.next,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = objectWithoutProperties_default()(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    return react_default.a.createElement(
      'li',
      {
        className: classnames_default()(className, { disabled: disabled, previous: previous, next: next }),
        style: style
      },
      react_default.a.createElement(es_SafeAnchor, extends_default()({}, props, {
        disabled: disabled,
        onClick: utils_createChainedFunction(onClick, this.handleSelect)
      }))
    );
  };

  return PagerItem;
}(react_default.a.Component);

PagerItem_PagerItem.propTypes = PagerItem_propTypes;
PagerItem_PagerItem.defaultProps = PagerItem_defaultProps;

/* harmony default export */ var es_PagerItem = (PagerItem_PagerItem);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__(1022);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/deprecationWarning.js






var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message = void 0;

  if ((typeof oldname === 'undefined' ? 'undefined' : typeof_default()(oldname)) === 'object') {
    message = oldname.message;
  } else {
    message = oldname + ' is deprecated. Use ' + newname + ' instead.';

    if (link) {
      message += '\nYou can read more about it at ' + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (_Component) {
    inherits_default()(DeprecatedComponent, _Component);

    function DeprecatedComponent() {
      classCallCheck_default()(this, DeprecatedComponent);

      return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
      deprecationWarning.apply(undefined, args);

      if (_Component.prototype.componentWillMount) {
        var _Component$prototype$;

        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          methodArgs[_key2] = arguments[_key2];
        }

        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
      }
    };

    return DeprecatedComponent;
  }(Component);
};

/* harmony default export */ var utils_deprecationWarning = (deprecationWarning);

function _resetWarned() {
  warned = {};
}
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PageItem.js



/* harmony default export */ var PageItem = (utils_deprecationWarning.wrapper(es_PagerItem, '`<PageItem>`', '`<Pager.Item>`'));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Pager.js














var Pager_propTypes = {
  onSelect: prop_types_default.a.func
};

var Pager_Pager = function (_React$Component) {
  inherits_default()(Pager, _React$Component);

  function Pager() {
    classCallCheck_default()(this, Pager);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Pager.prototype.render = function render() {
    var _props = this.props,
        onSelect = _props.onSelect,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['onSelect', 'className', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(
      'ul',
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      ValidComponentChildren.map(children, function (child) {
        return Object(react["cloneElement"])(child, {
          onSelect: utils_createChainedFunction(child.props.onSelect, onSelect)
        });
      })
    );
  };

  return Pager;
}(react_default.a.Component);

Pager_Pager.propTypes = Pager_propTypes;

Pager_Pager.Item = es_PagerItem;

/* harmony default export */ var es_Pager = (bootstrapUtils_bsClass('pager', Pager_Pager));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PaginationItem.js





/* eslint-disable react/no-multi-comp */






var PaginationItem_propTypes = {
  eventKey: prop_types_default.a.any,
  className: prop_types_default.a.string,
  onSelect: prop_types_default.a.func,
  disabled: prop_types_default.a.bool,
  active: prop_types_default.a.bool,
  activeLabel: prop_types_default.a.string.isRequired
};

var PaginationItem_defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};

function PaginationItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = objectWithoutProperties_default()(_ref, ['active', 'disabled', 'className', 'style', 'activeLabel', 'children']);

  var Component = active || disabled ? 'span' : es_SafeAnchor;
  return react_default.a.createElement(
    'li',
    { style: style, className: classnames_default()(className, { active: active, disabled: disabled }) },
    react_default.a.createElement(
      Component,
      extends_default()({ disabled: disabled }, props),
      children,
      active && react_default.a.createElement(
        'span',
        { className: 'sr-only' },
        activeLabel
      )
    )
  );
}

PaginationItem.propTypes = PaginationItem_propTypes;
PaginationItem.defaultProps = PaginationItem_defaultProps;

function createButton(name, defaultValue) {
  var _class, _temp;

  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : name;

  return _temp = _class = function (_React$Component) {
    inherits_default()(_class, _React$Component);

    function _class() {
      classCallCheck_default()(this, _class);

      return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
    }

    _class.prototype.render = function render() {
      var _props = this.props,
          disabled = _props.disabled,
          children = _props.children,
          className = _props.className,
          props = objectWithoutProperties_default()(_props, ['disabled', 'children', 'className']);

      var Component = disabled ? 'span' : es_SafeAnchor;

      return react_default.a.createElement(
        'li',
        extends_default()({
          'aria-label': label,
          className: classnames_default()(className, { disabled: disabled })
        }, props),
        react_default.a.createElement(
          Component,
          null,
          children || defaultValue
        )
      );
    };

    return _class;
  }(react_default.a.Component), _class.displayName = name, _class.propTypes = { disabled: prop_types_default.a.bool }, _temp;
}

var First = createButton('First', '\xAB');
var Prev = createButton('Prev', '\u2039');
var Ellipsis = createButton('Ellipsis', '\u2026', 'More');
var Next = createButton('Next', '\u203A');
var Last = createButton('Last', '\xBB');
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Pagination.js











var Pagination_Pagination = function (_React$Component) {
  inherits_default()(Pagination, _React$Component);

  function Pagination() {
    classCallCheck_default()(this, Pagination);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Pagination.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['className', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(
      'ul',
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      children
    );
  };

  return Pagination;
}(react_default.a.Component);

bootstrapUtils_bsClass('pagination', Pagination_Pagination);

Pagination_Pagination.First = First;
Pagination_Pagination.Prev = Prev;
Pagination_Pagination.Ellipsis = Ellipsis;
Pagination_Pagination.Item = PaginationItem;
Pagination_Pagination.Next = Next;
Pagination_Pagination.Last = Last;

/* harmony default export */ var es_Pagination = (Pagination_Pagination);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__(1142);
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelCollapse.js










var PanelCollapse_propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: prop_types_default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: prop_types_default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: prop_types_default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: prop_types_default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: prop_types_default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: prop_types_default.a.func
};

var PanelCollapse_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    headingId: prop_types_default.a.string,
    bodyId: prop_types_default.a.string,
    bsClass: prop_types_default.a.string,
    expanded: prop_types_default.a.bool
  })
};

var PanelCollapse_PanelCollapse = function (_React$Component) {
  inherits_default()(PanelCollapse, _React$Component);

  function PanelCollapse() {
    classCallCheck_default()(this, PanelCollapse);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  PanelCollapse.prototype.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = splitBsProps(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return react_default.a.createElement(
      es_Collapse,
      extends_default()({ 'in': expanded }, props),
      react_default.a.createElement(
        'div',
        { className: prefix(bsProps, 'collapse') },
        children
      )
    );
  };

  return PanelCollapse;
}(react_default.a.Component);

PanelCollapse_PanelCollapse.propTypes = PanelCollapse_propTypes;
PanelCollapse_PanelCollapse.contextTypes = PanelCollapse_contextTypes;

/* harmony default export */ var es_PanelCollapse = (bootstrapUtils_bsClass('panel', PanelCollapse_PanelCollapse));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelBody.js










var PanelBody_propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: prop_types_default.a.bool.isRequired
};

var PanelBody_defaultProps = {
  collapsible: false
};

var PanelBody_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};

var PanelBody_PanelBody = function (_React$Component) {
  inherits_default()(PanelBody, _React$Component);

  function PanelBody() {
    classCallCheck_default()(this, PanelBody);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  PanelBody.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        collapsible = _props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    var body = react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, { className: classnames_default()(className, prefix(bsProps, 'body')) }),
      children
    );

    if (collapsible) {
      body = react_default.a.createElement(
        es_PanelCollapse,
        null,
        body
      );
    }

    return body;
  };

  return PanelBody;
}(react_default.a.Component);

PanelBody_PanelBody.propTypes = PanelBody_propTypes;
PanelBody_PanelBody.defaultProps = PanelBody_defaultProps;
PanelBody_PanelBody.contextTypes = PanelBody_contextTypes;

/* harmony default export */ var es_PanelBody = (bootstrapUtils_bsClass('panel', PanelBody_PanelBody));
// EXTERNAL MODULE: ./node_modules/react-prop-types/lib/elementType.js
var lib_elementType = __webpack_require__(1027);
var lib_elementType_default = /*#__PURE__*/__webpack_require__.n(lib_elementType);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelHeading.js












var PanelHeading_propTypes = {
  componentClass: lib_elementType_default.a
};

var PanelHeading_defaultProps = {
  componentClass: 'div'
};

var PanelHeading_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    headingId: prop_types_default.a.string,
    bsClass: prop_types_default.a.string
  })
};

var PanelHeading_PanelHeading = function (_React$Component) {
  inherits_default()(PanelHeading, _React$Component);

  function PanelHeading() {
    classCallCheck_default()(this, PanelHeading);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  PanelHeading.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        Component = _props.componentClass,
        props = objectWithoutProperties_default()(_props, ['children', 'className', 'componentClass']);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return react_default.a.createElement(
      Component,
      extends_default()({}, elementProps, {
        className: classnames_default()(className, prefix(bsProps, 'heading'))
      }),
      children
    );
  };

  return PanelHeading;
}(react_default.a.Component);

PanelHeading_PanelHeading.propTypes = PanelHeading_propTypes;
PanelHeading_PanelHeading.defaultProps = PanelHeading_defaultProps;
PanelHeading_PanelHeading.contextTypes = PanelHeading_contextTypes;

/* harmony default export */ var es_PanelHeading = (bootstrapUtils_bsClass('panel', PanelHeading_PanelHeading));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelToggle.js











var PanelToggle_propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: prop_types_default.a.func,
  /**
   * You can use a custom element for this component
   */
  componentClass: lib_elementType_default.a
};

var PanelToggle_defaultProps = {
  componentClass: es_SafeAnchor
};

var PanelToggle_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    bodyId: prop_types_default.a.string,
    onToggle: prop_types_default.a.func,
    expanded: prop_types_default.a.bool
  })
};

var PanelToggle_PanelToggle = function (_React$Component) {
  inherits_default()(PanelToggle, _React$Component);

  function PanelToggle() {
    classCallCheck_default()(this, PanelToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args)));

    _this.handleToggle = _this.handleToggle.bind(_this);
    return _this;
  }

  PanelToggle.prototype.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  PanelToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        componentClass = _props.componentClass,
        props = objectWithoutProperties_default()(_props, ['onClick', 'className', 'componentClass']);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;

    props.onClick = utils_createChainedFunction(onClick, this.handleToggle);

    props['aria-expanded'] = expanded;
    props.className = classnames_default()(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return react_default.a.createElement(Component, props);
  };

  return PanelToggle;
}(react_default.a.Component);

PanelToggle_PanelToggle.propTypes = PanelToggle_propTypes;
PanelToggle_PanelToggle.defaultProps = PanelToggle_defaultProps;
PanelToggle_PanelToggle.contextTypes = PanelToggle_contextTypes;

/* harmony default export */ var es_PanelToggle = (PanelToggle_PanelToggle);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelTitle.js













var PanelTitle_propTypes = {
  componentClass: lib_elementType_default.a,
  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: prop_types_default.a.bool
};

var PanelTitle_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};

var PanelTitle_defaultProps = {
  componentClass: 'div'
};

var PanelTitle_PanelTitle = function (_React$Component) {
  inherits_default()(PanelTitle, _React$Component);

  function PanelTitle() {
    classCallCheck_default()(this, PanelTitle);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  PanelTitle.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        toggle = _props.toggle,
        Component = _props.componentClass,
        props = objectWithoutProperties_default()(_props, ['children', 'className', 'toggle', 'componentClass']);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = react_default.a.createElement(
        es_PanelToggle,
        null,
        children
      );
    }

    return react_default.a.createElement(
      Component,
      extends_default()({}, elementProps, {
        className: classnames_default()(className, prefix(bsProps, 'title'))
      }),
      children
    );
  };

  return PanelTitle;
}(react_default.a.Component);

PanelTitle_PanelTitle.propTypes = PanelTitle_propTypes;
PanelTitle_PanelTitle.defaultProps = PanelTitle_defaultProps;
PanelTitle_PanelTitle.contextTypes = PanelTitle_contextTypes;

/* harmony default export */ var es_PanelTitle = (bootstrapUtils_bsClass('panel', PanelTitle_PanelTitle));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelFooter.js









var PanelFooter_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};

var PanelFooter_PanelFooter = function (_React$Component) {
  inherits_default()(PanelFooter, _React$Component);

  function PanelFooter() {
    classCallCheck_default()(this, PanelFooter);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  PanelFooter.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = splitBsProps(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, {
        className: classnames_default()(className, prefix(bsProps, 'footer'))
      }),
      children
    );
  };

  return PanelFooter;
}(react_default.a.Component);

PanelFooter_PanelFooter.contextTypes = PanelFooter_contextTypes;

/* harmony default export */ var es_PanelFooter = (bootstrapUtils_bsClass('panel', PanelFooter_PanelFooter));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Panel.js





















var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + '--' + type : null;
};

var Panel_propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: prop_types_default.a.bool,
  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: prop_types_default.a.func,
  eventKey: prop_types_default.a.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: prop_types_default.a.string
};

var Panel_contextTypes = {
  $bs_panelGroup: prop_types_default.a.shape({
    getId: prop_types_default.a.func,
    activeKey: prop_types_default.a.any,
    onToggle: prop_types_default.a.func
  })
};

var Panel_childContextTypes = {
  $bs_panel: prop_types_default.a.shape({
    headingId: prop_types_default.a.string,
    bodyId: prop_types_default.a.string,
    bsClass: prop_types_default.a.string,
    onToggle: prop_types_default.a.func,
    expanded: prop_types_default.a.bool
  })
};

var Panel_Panel = function (_React$Component) {
  inherits_default()(Panel, _React$Component);

  function Panel() {
    var _temp, _this, _ret;

    classCallCheck_default()(this, Panel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  Panel.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        eventKey = _props.eventKey,
        id = _props.id;

    var idKey = eventKey == null ? id : eventKey;

    var ids = void 0;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;

      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: extends_default()({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  Panel.prototype.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? warning(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;

      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  Panel.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        children = _props2.children;

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return react_default.a.createElement(
      'div',
      extends_default()({}, props, { className: classnames_default()(className, getClassSet(bsProps)) }),
      children
    );
  };

  return Panel;
}(react_default.a.Component);

Panel_Panel.propTypes = Panel_propTypes;

Panel_Panel.contextTypes = Panel_contextTypes;
Panel_Panel.childContextTypes = Panel_childContextTypes;

var UncontrolledPanel = uncontrollable_default()(bootstrapUtils_bsClass('panel', bsStyles([].concat(values_default()(State), [Style.DEFAULT, Style.PRIMARY]), Style.DEFAULT, Panel_Panel)), { expanded: 'onToggle' });

assign_default()(UncontrolledPanel, {
  Heading: es_PanelHeading,
  Title: es_PanelTitle,
  Body: es_PanelBody,
  Footer: es_PanelFooter,
  Toggle: es_PanelToggle,
  Collapse: es_PanelCollapse
});

/* harmony default export */ var es_Panel = (UncontrolledPanel);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Popover.js












var Popover_propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: isRequiredForA11y_default()(prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: prop_types_default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
  /**
   * The "left" position value for the Popover.
   */
  positionLeft: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * Title content
   */
  title: prop_types_default.a.node
};

var Popover_defaultProps = {
  placement: 'right'
};

var Popover_Popover = function (_React$Component) {
  inherits_default()(Popover, _React$Component);

  function Popover() {
    classCallCheck_default()(this, Popover);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Popover.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        title = _props.title,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = extends_default()({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, {
        role: 'tooltip',
        className: classnames_default()(className, classes),
        style: outerStyle
      }),
      react_default.a.createElement('div', { className: 'arrow', style: arrowStyle }),
      title && react_default.a.createElement(
        'h3',
        { className: prefix(bsProps, 'title') },
        title
      ),
      react_default.a.createElement(
        'div',
        { className: prefix(bsProps, 'content') },
        children
      )
    );
  };

  return Popover;
}(react_default.a.Component);

Popover_Popover.propTypes = Popover_propTypes;
Popover_Popover.defaultProps = Popover_defaultProps;

/* harmony default export */ var es_Popover = (bootstrapUtils_bsClass('popover', Popover_Popover));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ProgressBar.js














var ROUND_PRECISION = 1000;

/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */
function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];
  if (!children) {
    return null;
  }

  var error = null;

  react_default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }

    // eslint-disable-next-line no-use-before-define
    if (child.type === ProgressBar_ProgressBar) return;

    var childIdentifier = react_default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
  });

  return error;
}

var ProgressBar_propTypes = {
  min: prop_types_default.a.number,
  now: prop_types_default.a.number,
  max: prop_types_default.a.number,
  label: prop_types_default.a.node,
  srOnly: prop_types_default.a.bool,
  striped: prop_types_default.a.bool,
  active: prop_types_default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: prop_types_default.a.bool
};

var ProgressBar_defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar_ProgressBar = function (_React$Component) {
  inherits_default()(ProgressBar, _React$Component);

  function ProgressBar() {
    classCallCheck_default()(this, ProgressBar);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = objectWithoutProperties_default()(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {
      active: active
    }, _extends2[prefix(bsProps, 'striped')] = active || striped, _extends2));

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, {
        role: 'progressbar',
        className: classnames_default()(className, classes),
        style: extends_default()({ width: getPercentage(now, min, max) + '%' }, style),
        'aria-valuenow': now,
        'aria-valuemin': min,
        'aria-valuemax': max
      }),
      srOnly ? react_default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      ) : label
    );
  };

  ProgressBar.prototype.render = function render() {
    var _props = this.props,
        isChild = _props.isChild,
        props = objectWithoutProperties_default()(_props, ['isChild']);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = objectWithoutProperties_default()(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);

    return react_default.a.createElement(
      'div',
      extends_default()({}, wrapperProps, { className: classnames_default()(className, 'progress') }),
      children ? ValidComponentChildren.map(children, function (child) {
        return Object(react["cloneElement"])(child, { isChild: true });
      }) : this.renderProgressBar({
        min: min,
        now: now,
        max: max,
        label: label,
        srOnly: srOnly,
        striped: striped,
        active: active,
        bsClass: bsClass,
        bsStyle: bsStyle
      })
    );
  };

  return ProgressBar;
}(react_default.a.Component);

ProgressBar_ProgressBar.propTypes = ProgressBar_propTypes;
ProgressBar_ProgressBar.defaultProps = ProgressBar_defaultProps;

/* harmony default export */ var es_ProgressBar = (bootstrapUtils_bsClass('progress-bar', bsStyles(values_default()(State), ProgressBar_ProgressBar)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Radio.js





/* eslint-disable jsx-a11y/label-has-for */








var Radio_propTypes = {
  inline: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  title: prop_types_default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: prop_types_default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: prop_types_default.a.func
};

var Radio_defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio_Radio = function (_React$Component) {
  inherits_default()(Radio, _React$Component);

  function Radio() {
    classCallCheck_default()(this, Radio);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = react_default.a.createElement('input', extends_default()({}, elementProps, {
      ref: inputRef,
      type: 'radio',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[prefix(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return react_default.a.createElement(
        'label',
        {
          className: classnames_default()(className, _classes),
          style: style,
          title: title
        },
        input,
        children
      );
    }

    var classes = extends_default()({}, getClassSet(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return react_default.a.createElement(
      'div',
      { className: classnames_default()(className, classes), style: style },
      react_default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Radio;
}(react_default.a.Component);

Radio_Radio.propTypes = Radio_propTypes;
Radio_Radio.defaultProps = Radio_defaultProps;

/* harmony default export */ var es_Radio = (bootstrapUtils_bsClass('radio', Radio_Radio));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ResponsiveEmbed.js












// TODO: This should probably take a single `aspectRatio` prop.

var ResponsiveEmbed_propTypes = {
  /**
   * This component requires a single child element
   */
  children: prop_types_default.a.element.isRequired,
  /**
   * 16by9 aspect ratio
   */
  a16by9: prop_types_default.a.bool,
  /**
   * 4by3 aspect ratio
   */
  a4by3: prop_types_default.a.bool
};

var ResponsiveEmbed_defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed_ResponsiveEmbed = function (_React$Component) {
  inherits_default()(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    classCallCheck_default()(this, ResponsiveEmbed);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ResponsiveEmbed.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        a16by9 = _props.a16by9,
        a4by3 = _props.a4by3,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['a16by9', 'a4by3', 'className', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, '16by9')] = a16by9, _extends2[prefix(bsProps, '4by3')] = a4by3, _extends2));

    return react_default.a.createElement(
      'div',
      { className: classnames_default()(classes) },
      Object(react["cloneElement"])(children, extends_default()({}, elementProps, {
        className: classnames_default()(className, prefix(bsProps, 'item'))
      }))
    );
  };

  return ResponsiveEmbed;
}(react_default.a.Component);

ResponsiveEmbed_ResponsiveEmbed.propTypes = ResponsiveEmbed_propTypes;
ResponsiveEmbed_ResponsiveEmbed.defaultProps = ResponsiveEmbed_defaultProps;

/* harmony default export */ var es_ResponsiveEmbed = (bootstrapUtils_bsClass('embed-responsive', ResponsiveEmbed_ResponsiveEmbed));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Row.js











var Row_propTypes = {
  componentClass: elementType_default.a
};

var Row_defaultProps = {
  componentClass: 'div'
};

var Row_Row = function (_React$Component) {
  inherits_default()(Row, _React$Component);

  function Row() {
    classCallCheck_default()(this, Row);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Row.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['componentClass', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement(Component, extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return Row;
}(react_default.a.Component);

Row_Row.propTypes = Row_propTypes;
Row_Row.defaultProps = Row_defaultProps;

/* harmony default export */ var es_Row = (bootstrapUtils_bsClass('row', Row_Row));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/SplitToggle.js








var SplitToggle_SplitToggle = function (_React$Component) {
  inherits_default()(SplitToggle, _React$Component);

  function SplitToggle() {
    classCallCheck_default()(this, SplitToggle);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  SplitToggle.prototype.render = function render() {
    return react_default.a.createElement(es_DropdownToggle, extends_default()({}, this.props, { useAnchor: false, noCaret: false }));
  };

  return SplitToggle;
}(react_default.a.Component);

SplitToggle_SplitToggle.defaultProps = es_DropdownToggle.defaultProps;

/* harmony default export */ var es_SplitToggle = (SplitToggle_SplitToggle);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/SplitButton.js













var SplitButton_propTypes = extends_default()({}, es_Dropdown.propTypes, {

  // Toggle props.
  bsStyle: prop_types_default.a.string,
  bsSize: prop_types_default.a.string,
  href: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  /**
   * The content of the split button.
   */
  title: prop_types_default.a.node.isRequired,
  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: prop_types_default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: prop_types_default.a.node
});

var SplitButton_SplitButton = function (_React$Component) {
  inherits_default()(SplitButton, _React$Component);

  function SplitButton() {
    classCallCheck_default()(this, SplitButton);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  SplitButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        toggleLabel = _props.toggleLabel,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);

    var _splitComponentProps = splitComponentProps(props, es_Dropdown.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return react_default.a.createElement(
      es_Dropdown,
      extends_default()({}, dropdownProps, { bsSize: bsSize, bsStyle: bsStyle }),
      react_default.a.createElement(
        es_Button,
        extends_default()({}, buttonProps, {
          disabled: props.disabled,
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      react_default.a.createElement(es_SplitToggle, {
        'aria-label': toggleLabel || title,
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      react_default.a.createElement(
        es_Dropdown.Menu,
        null,
        children
      )
    );
  };

  return SplitButton;
}(react_default.a.Component);

SplitButton_SplitButton.propTypes = SplitButton_propTypes;

SplitButton_SplitButton.Toggle = es_SplitToggle;

/* harmony default export */ var es_SplitButton = (SplitButton_SplitButton);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/TabContainer.js








var TAB = 'tab';
var PANE = 'pane';

var TabContainer_idPropType = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]);

var TabContainer_propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = TabContainer_idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },


  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: prop_types_default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: prop_types_default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: prop_types_default.a.any
};

var TabContainer_childContextTypes = {
  $bs_tabContainer: prop_types_default.a.shape({
    activeKey: prop_types_default.a.any,
    onSelect: prop_types_default.a.func.isRequired,
    getTabId: prop_types_default.a.func.isRequired,
    getPaneId: prop_types_default.a.func.isRequired
  })
};

var TabContainer_TabContainer = function (_React$Component) {
  inherits_default()(TabContainer, _React$Component);

  function TabContainer() {
    classCallCheck_default()(this, TabContainer);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  TabContainer.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        onSelect = _props.onSelect,
        generateChildId = _props.generateChildId,
        id = _props.id;


    var getId = generateChildId || function (key, type) {
      return id ? id + '-' + type + '-' + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  TabContainer.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        props = objectWithoutProperties_default()(_props2, ['children']);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;

    return react_default.a.cloneElement(react_default.a.Children.only(children), props);
  };

  return TabContainer;
}(react_default.a.Component);

TabContainer_TabContainer.propTypes = TabContainer_propTypes;
TabContainer_TabContainer.childContextTypes = TabContainer_childContextTypes;

/* harmony default export */ var es_TabContainer = (uncontrollable_default()(TabContainer_TabContainer, { activeKey: 'onSelect' }));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/TabContent.js












var TabContent_propTypes = {
  componentClass: elementType_default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: prop_types_default.a.bool
};

var TabContent_defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

var TabContent_contextTypes = {
  $bs_tabContainer: prop_types_default.a.shape({
    activeKey: prop_types_default.a.any
  })
};

var TabContent_childContextTypes = {
  $bs_tabContent: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),
    activeKey: prop_types_default.a.any,
    mountOnEnter: prop_types_default.a.bool,
    unmountOnExit: prop_types_default.a.bool,
    onPaneEnter: prop_types_default.a.func.isRequired,
    onPaneExited: prop_types_default.a.func.isRequired,
    exiting: prop_types_default.a.bool.isRequired
  })
};

var TabContent_TabContent = function (_React$Component) {
  inherits_default()(TabContent, _React$Component);

  function TabContent(props, context) {
    classCallCheck_default()(this, TabContent);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
    _this.handlePaneExited = _this.handlePaneExited.bind(_this);

    // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.
    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  TabContent.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit;


    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();

    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;

    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({ activeKey: null, activeChild: null });
    }
  };

  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    }

    // It's possible that this child should be transitioning out.
    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });

    return true;
  };

  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  TabContent.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        className = _props2.className,
        props = objectWithoutProperties_default()(_props2, ['componentClass', 'className']);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return react_default.a.createElement(Component, extends_default()({}, elementProps, {
      className: classnames_default()(className, prefix(bsProps, 'content'))
    }));
  };

  return TabContent;
}(react_default.a.Component);

TabContent_TabContent.propTypes = TabContent_propTypes;
TabContent_TabContent.defaultProps = TabContent_defaultProps;
TabContent_TabContent.contextTypes = TabContent_contextTypes;
TabContent_TabContent.childContextTypes = TabContent_childContextTypes;

/* harmony default export */ var es_TabContent = (bootstrapUtils_bsClass('tab', TabContent_TabContent));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/TabPane.js
















var TabPane_propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: prop_types_default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),

  /** @private * */
  id: prop_types_default.a.string,

  /** @private * */
  'aria-labelledby': prop_types_default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: prop_types_default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: prop_types_default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: prop_types_default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: prop_types_default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: prop_types_default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: prop_types_default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: prop_types_default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: prop_types_default.a.bool
};

var TabPane_contextTypes = {
  $bs_tabContainer: prop_types_default.a.shape({
    getTabId: prop_types_default.a.func,
    getPaneId: prop_types_default.a.func
  }),
  $bs_tabContent: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),
    activeKey: prop_types_default.a.any,
    mountOnEnter: prop_types_default.a.bool,
    unmountOnExit: prop_types_default.a.bool,
    onPaneEnter: prop_types_default.a.func.isRequired,
    onPaneExited: prop_types_default.a.func.isRequired,
    exiting: prop_types_default.a.bool.isRequired
  })
};

/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */
var TabPane_childContextTypes = {
  $bs_tabContainer: prop_types_default.a.oneOf([null])
};

var TabPane_TabPane = function (_React$Component) {
  inherits_default()(TabPane, _React$Component);

  function TabPane(props, context) {
    classCallCheck_default()(this, TabPane);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);

    _this.in = false;
    return _this;
  }

  TabPane.prototype.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  TabPane.prototype.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  TabPane.prototype.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  TabPane.prototype.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  TabPane.prototype.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  TabPane.prototype.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;

    return this.props.eventKey === activeKey;
  };

  TabPane.prototype.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  TabPane.prototype.render = function render() {
    var _props = this.props,
        eventKey = _props.eventKey,
        className = _props.className,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        propsMountOnEnter = _props.mountOnEnter,
        propsUnmountOnExit = _props.unmountOnExit,
        props = objectWithoutProperties_default()(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);

    var _context = this.context,
        tabContent = _context.$bs_tabContent,
        tabContainer = _context.$bs_tabContainer;

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();

    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? es_Fade : animation || null;

    if (tabContent) {
      bsProps.bsClass = prefix(tabContent, 'pane');
    }

    var classes = extends_default()({}, getClassSet(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = react_default.a.createElement('div', extends_default()({}, elementProps, {
      role: 'tabpanel',
      'aria-hidden': !active,
      className: classnames_default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;

      return react_default.a.createElement(
        Transition,
        {
          'in': active && !exiting,
          onEnter: utils_createChainedFunction(this.handleEnter, onEnter),
          onEntering: onEntering,
          onEntered: onEntered,
          onExit: onExit,
          onExiting: onExiting,
          onExited: utils_createChainedFunction(this.handleExited, onExited),
          mountOnEnter: mountOnEnter,
          unmountOnExit: unmountOnExit
        },
        pane
      );
    }

    return pane;
  };

  return TabPane;
}(react_default.a.Component);

TabPane_TabPane.propTypes = TabPane_propTypes;
TabPane_TabPane.contextTypes = TabPane_contextTypes;
TabPane_TabPane.childContextTypes = TabPane_childContextTypes;

/* harmony default export */ var es_TabPane = (bootstrapUtils_bsClass('tab-pane', TabPane_TabPane));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Tab.js











var Tab_propTypes = extends_default()({}, es_TabPane.propTypes, {

  disabled: prop_types_default.a.bool,

  title: prop_types_default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: prop_types_default.a.string
});

var Tab_Tab = function (_React$Component) {
  inherits_default()(Tab, _React$Component);

  function Tab() {
    classCallCheck_default()(this, Tab);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Tab.prototype.render = function render() {
    var props = extends_default()({}, this.props);

    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
    delete props.title;
    delete props.disabled;
    delete props.tabClassName;

    return react_default.a.createElement(es_TabPane, props);
  };

  return Tab;
}(react_default.a.Component);

Tab_Tab.propTypes = Tab_propTypes;

Tab_Tab.Container = es_TabContainer;
Tab_Tab.Content = es_TabContent;
Tab_Tab.Pane = es_TabPane;

/* harmony default export */ var es_Tab = (Tab_Tab);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Table.js











var Table_propTypes = {
  striped: prop_types_default.a.bool,
  bordered: prop_types_default.a.bool,
  condensed: prop_types_default.a.bool,
  hover: prop_types_default.a.bool,
  responsive: prop_types_default.a.bool
};

var Table_defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table_Table = function (_React$Component) {
  inherits_default()(Table, _React$Component);

  function Table() {
    classCallCheck_default()(this, Table);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Table.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        striped = _props.striped,
        bordered = _props.bordered,
        condensed = _props.condensed,
        hover = _props.hover,
        responsive = _props.responsive,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'striped')] = striped, _extends2[prefix(bsProps, 'bordered')] = bordered, _extends2[prefix(bsProps, 'condensed')] = condensed, _extends2[prefix(bsProps, 'hover')] = hover, _extends2));

    var table = react_default.a.createElement('table', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));

    if (responsive) {
      return react_default.a.createElement(
        'div',
        { className: prefix(bsProps, 'responsive') },
        table
      );
    }

    return table;
  };

  return Table;
}(react_default.a.Component);

Table_Table.propTypes = Table_propTypes;
Table_Table.defaultProps = Table_defaultProps;

/* harmony default export */ var es_Table = (bootstrapUtils_bsClass('table', Table_Table));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Tabs.js

















var Tabs_TabContainer = es_TabContainer.ControlledComponent;

var Tabs_propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: prop_types_default.a.any,

  /**
   * Navigation style
   */
  bsStyle: prop_types_default.a.oneOf(['tabs', 'pills']),

  animation: prop_types_default.a.bool,

  id: isRequiredForA11y_default()(prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: prop_types_default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: prop_types_default.a.bool
};

var Tabs_defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey = void 0;
  ValidComponentChildren.forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });

  return defaultActiveKey;
}

var Tabs_Tabs = function (_React$Component) {
  inherits_default()(Tabs, _React$Component);

  function Tabs() {
    classCallCheck_default()(this, Tabs);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Tabs.prototype.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return react_default.a.createElement(
      es_NavItem,
      { eventKey: eventKey, disabled: disabled, className: tabClassName },
      title
    );
  };

  Tabs.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        onSelect = _props.onSelect,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit,
        bsClass = _props.bsClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        _props$activeKey = _props.activeKey,
        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
        props = objectWithoutProperties_default()(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);

    return react_default.a.createElement(
      Tabs_TabContainer,
      {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        className: className,
        style: style
      },
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          es_Nav,
          extends_default()({}, props, { role: 'tablist' }),
          ValidComponentChildren.map(children, this.renderTab)
        ),
        react_default.a.createElement(
          es_TabContent,
          {
            bsClass: bsClass,
            animation: animation,
            mountOnEnter: mountOnEnter,
            unmountOnExit: unmountOnExit
          },
          children
        )
      )
    );
  };

  return Tabs;
}(react_default.a.Component);

Tabs_Tabs.propTypes = Tabs_propTypes;
Tabs_Tabs.defaultProps = Tabs_defaultProps;

bootstrapUtils_bsClass('tab', Tabs_Tabs);

/* harmony default export */ var es_Tabs = (uncontrollable_default()(Tabs_Tabs, { activeKey: 'onSelect' }));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Thumbnail.js





/* eslint-disable jsx-a11y/alt-text */








var Thumbnail_propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: prop_types_default.a.string,
  /**
   * alt property that is passed down to the image inside this component
   */
  alt: prop_types_default.a.string,
  /**
   * href property that is passed down to the image inside this component
   */
  href: prop_types_default.a.string,
  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: prop_types_default.a.func,
  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: prop_types_default.a.func
};

var Thumbnail_Thumbnail = function (_React$Component) {
  inherits_default()(Thumbnail, _React$Component);

  function Thumbnail() {
    classCallCheck_default()(this, Thumbnail);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Thumbnail.prototype.render = function render() {
    var _props = this.props,
        src = _props.src,
        alt = _props.alt,
        onError = _props.onError,
        onLoad = _props.onLoad,
        className = _props.className,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? es_SafeAnchor : 'div';
    var classes = getClassSet(bsProps);

    return react_default.a.createElement(
      Component,
      extends_default()({}, elementProps, { className: classnames_default()(className, classes) }),
      react_default.a.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
      children && react_default.a.createElement(
        'div',
        { className: 'caption' },
        children
      )
    );
  };

  return Thumbnail;
}(react_default.a.Component);

Thumbnail_Thumbnail.propTypes = Thumbnail_propTypes;

/* harmony default export */ var es_Thumbnail = (bootstrapUtils_bsClass('thumbnail', Thumbnail_Thumbnail));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ToggleButton.js










var ToggleButton_propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: prop_types_default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: prop_types_default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: prop_types_default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: prop_types_default.a.bool,

  /**
   * [onChange description]
   */
  onChange: prop_types_default.a.func,
  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: prop_types_default.a.any.isRequired
};

var ToggleButton_ToggleButton = function (_React$Component) {
  inherits_default()(ToggleButton, _React$Component);

  function ToggleButton() {
    classCallCheck_default()(this, ToggleButton);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButton.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        name = _props.name,
        checked = _props.checked,
        type = _props.type,
        onChange = _props.onChange,
        value = _props.value,
        props = objectWithoutProperties_default()(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);

    var disabled = props.disabled;

    return react_default.a.createElement(
      es_Button,
      extends_default()({}, props, { active: !!checked, componentClass: 'label' }),
      react_default.a.createElement('input', {
        name: name,
        type: type,
        autoComplete: 'off',
        value: value,
        checked: !!checked,
        disabled: !!disabled,
        onChange: onChange
      }),
      children
    );
  };

  return ToggleButton;
}(react_default.a.Component);

ToggleButton_ToggleButton.propTypes = ToggleButton_propTypes;

/* harmony default export */ var es_ToggleButton = (ToggleButton_ToggleButton);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ToggleButtonGroup.js















var ToggleButtonGroup_propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: prop_types_default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: prop_types_default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: prop_types_default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: prop_types_default.a.oneOf(['checkbox', 'radio']).isRequired
};

var ToggleButtonGroup_defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup_ToggleButtonGroup = function (_React$Component) {
  inherits_default()(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    classCallCheck_default()(this, ToggleButtonGroup);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButtonGroup.prototype.getValues = function getValues() {
    var value = this.props.value;

    return value == null ? [] : [].concat(value);
  };

  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
    var _props = this.props,
        type = _props.type,
        onChange = _props.onChange;

    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }
      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange([].concat(values, [value]));
    }
  };

  ToggleButtonGroup.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        children = _props2.children,
        type = _props2.type,
        name = _props2.name,
        props = objectWithoutProperties_default()(_props2, ['children', 'type', 'name']);

    var values = this.getValues();

    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : browser_default()(false) : void 0;

    delete props.onChange;
    delete props.value;

    // the data attribute is required b/c twbs css uses it in the selector
    return react_default.a.createElement(
      es_ButtonGroup,
      extends_default()({}, props, { 'data-toggle': 'buttons' }),
      ValidComponentChildren.map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            onChange = _child$props.onChange;

        var handler = function handler() {
          return _this2.handleToggle(value);
        };

        return react_default.a.cloneElement(child, {
          type: type,
          name: child.name || name,
          checked: values.indexOf(value) !== -1,
          onChange: utils_createChainedFunction(onChange, handler)
        });
      })
    );
  };

  return ToggleButtonGroup;
}(react_default.a.Component);

ToggleButtonGroup_ToggleButtonGroup.propTypes = ToggleButtonGroup_propTypes;
ToggleButtonGroup_ToggleButtonGroup.defaultProps = ToggleButtonGroup_defaultProps;

var UncontrolledToggleButtonGroup = uncontrollable_default()(ToggleButtonGroup_ToggleButtonGroup, {
  value: 'onChange'
});

UncontrolledToggleButtonGroup.Button = es_ToggleButton;

/* harmony default export */ var es_ToggleButtonGroup = (UncontrolledToggleButtonGroup);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Tooltip.js












var Tooltip_propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: isRequiredForA11y_default()(prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: prop_types_default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string])
};

var Tooltip_defaultProps = {
  placement: 'right'
};

var Tooltip_Tooltip = function (_React$Component) {
  inherits_default()(Tooltip, _React$Component);

  function Tooltip() {
    classCallCheck_default()(this, Tooltip);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Tooltip.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = objectWithoutProperties_default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = extends_default()({}, getClassSet(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = extends_default()({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return react_default.a.createElement(
      'div',
      extends_default()({}, elementProps, {
        role: 'tooltip',
        className: classnames_default()(className, classes),
        style: outerStyle
      }),
      react_default.a.createElement('div', { className: prefix(bsProps, 'arrow'), style: arrowStyle }),
      react_default.a.createElement(
        'div',
        { className: prefix(bsProps, 'inner') },
        children
      )
    );
  };

  return Tooltip;
}(react_default.a.Component);

Tooltip_Tooltip.propTypes = Tooltip_propTypes;
Tooltip_Tooltip.defaultProps = Tooltip_defaultProps;

/* harmony default export */ var es_Tooltip = (bootstrapUtils_bsClass('tooltip', Tooltip_Tooltip));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Well.js











var Well_Well = function (_React$Component) {
  inherits_default()(Well, _React$Component);

  function Well() {
    classCallCheck_default()(this, Well);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Well.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = objectWithoutProperties_default()(_props, ['className']);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    return react_default.a.createElement('div', extends_default()({}, elementProps, { className: classnames_default()(className, classes) }));
  };

  return Well;
}(react_default.a.Component);

/* harmony default export */ var es_Well = (bootstrapUtils_bsClass('well', bsSizes([Size.LARGE, Size.SMALL], Well_Well)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/index.js






// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Accordion", function() { return es_Accordion; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Alert", function() { return es_Alert; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Badge", function() { return es_Badge; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return es_Breadcrumb; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return es_BreadcrumbItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Button", function() { return es_Button; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return es_ButtonGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return es_ButtonToolbar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Carousel", function() { return es_Carousel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CarouselItem", function() { return es_CarouselItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Checkbox", function() { return es_Checkbox; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Clearfix", function() { return es_Clearfix; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CloseButton", function() { return es_CloseButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ControlLabel", function() { return es_ControlLabel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Col", function() { return es_Col; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Collapse", function() { return es_Collapse; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Dropdown", function() { return es_Dropdown; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DropdownButton", function() { return es_DropdownButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Fade", function() { return es_Fade; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Form", function() { return es_Form; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormControl", function() { return es_FormControl; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormGroup", function() { return es_FormGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Glyphicon", function() { return es_Glyphicon; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Grid", function() { return es_Grid; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HelpBlock", function() { return es_HelpBlock; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Image", function() { return es_Image; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "InputGroup", function() { return es_InputGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Jumbotron", function() { return es_Jumbotron; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Label", function() { return es_Label; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListGroup", function() { return es_ListGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListGroupItem", function() { return es_ListGroupItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Media", function() { return es_Media; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MenuItem", function() { return es_MenuItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Modal", function() { return es_Modal; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalBody", function() { return es_ModalBody; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalFooter", function() { return es_ModalFooter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return es_ModalHeader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalTitle", function() { return es_ModalTitle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Nav", function() { return es_Nav; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Navbar", function() { return es_Navbar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NavbarBrand", function() { return es_NavbarBrand; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NavDropdown", function() { return es_NavDropdown; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NavItem", function() { return es_NavItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Overlay", function() { return es_Overlay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "OverlayTrigger", function() { return es_OverlayTrigger; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PageHeader", function() { return es_PageHeader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PageItem", function() { return PageItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Pager", function() { return es_Pager; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Pagination", function() { return es_Pagination; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Panel", function() { return es_Panel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PanelGroup", function() { return es_PanelGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Popover", function() { return es_Popover; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ProgressBar", function() { return es_ProgressBar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Radio", function() { return es_Radio; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ResponsiveEmbed", function() { return es_ResponsiveEmbed; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Row", function() { return es_Row; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SafeAnchor", function() { return es_SafeAnchor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SplitButton", function() { return es_SplitButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tab", function() { return es_Tab; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TabContainer", function() { return es_TabContainer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TabContent", function() { return es_TabContent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Table", function() { return es_Table; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TabPane", function() { return es_TabPane; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tabs", function() { return es_Tabs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return es_Thumbnail; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ToggleButton", function() { return es_ToggleButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ToggleButtonGroup", function() { return es_ToggleButtonGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tooltip", function() { return es_Tooltip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Well", function() { return es_Well; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "utils", function() { return utils_namespaceObject; });













































































































































/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(815),
	__webpack_require__(898),
	__webpack_require__(1008),
	__webpack_require__(897),
	__webpack_require__(1590),
	__webpack_require__(1113),
	__webpack_require__(1591),
	__webpack_require__(1010),
	__webpack_require__(1592),
	__webpack_require__(1596),
	__webpack_require__(899),
	__webpack_require__(1600),
	__webpack_require__(945),
	__webpack_require__(1602),
	__webpack_require__(1605),
	__webpack_require__(917),
	__webpack_require__(1606),
	__webpack_require__(1127),
	__webpack_require__(900),
	__webpack_require__(1607),
	__webpack_require__(1608),
	__webpack_require__(1609),
	__webpack_require__(1610),
	__webpack_require__(1613),
	__webpack_require__(1011),
	__webpack_require__(1614),
	__webpack_require__(1615),
	__webpack_require__(1616),
	__webpack_require__(1617),
	__webpack_require__(1619),
	__webpack_require__(1620)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

return jQuery;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _from = __webpack_require__(181);

var _from2 = _interopRequireDefault(_from);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _action_types = __webpack_require__(3);

var _users = __webpack_require__(777);

var Selectors = _interopRequireWildcard(_users);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserStatuses = _constants2.default.UserStatuses; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT_NOT_IN_CHANNEL = 'change_not_in_channel';
var CHANGE_EVENT_IN_CHANNEL = 'change_in_channel';
var CHANGE_EVENT_NOT_IN_TEAM = 'change_not_in_team';
var CHANGE_EVENT_IN_TEAM = 'change_in_team';
var CHANGE_EVENT_WITHOUT_TEAM = 'change_without_team';
var CHANGE_EVENT = 'change';
var CHANGE_EVENT_SESSIONS = 'change_sessions';
var CHANGE_EVENT_AUDITS = 'change_audits';
var CHANGE_EVENT_STATUSES = 'change_statuses';

var UserStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(UserStoreClass, _EventEmitter);

    function UserStoreClass() {
        (0, _classCallCheck3.default)(this, UserStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserStoreClass.__proto__ || (0, _getPrototypeOf2.default)(UserStoreClass)).call(this));

        _this.entities = {};

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.users;
            var entities = _this.entities;
            _this.entities = newEntities;

            if (newEntities.profiles !== entities.profiles) {
                _this.emitChange();
            }

            if (newEntities.profilesInChannel !== entities.profilesInChannel) {
                _this.emitInChannelChange();
            }

            if (newEntities.profilesNotInChannel !== entities.profilesNotInChannel) {
                _this.emitNotInChannelChange();
            }

            if (newEntities.profilesInTeam !== entities.profilesInTeam) {
                _this.emitInTeamChange();
            }

            if (newEntities.profilesNotInTeam !== entities.profilesNotInTeam) {
                _this.emitNotInTeamChange();
            }

            if (newEntities.profilesWithoutTeam !== entities.profilesWithoutTeam) {
                _this.emitWithoutTeamChange();
            }

            if (newEntities.statuses !== entities.statuses) {
                _this.emitStatusesChange();
            }

            if (newEntities.myAudits !== entities.myAudits) {
                _this.emitAuditsChange();
            }

            if (newEntities.mySessions !== entities.mySessions) {
                _this.emitSessionsChange();
            }
        });
        return _this;
    }

    (0, _createClass3.default)(UserStoreClass, [{
        key: 'emitChange',
        value: function emitChange(userId) {
            this.emit(CHANGE_EVENT, userId);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitInTeamChange',
        value: function emitInTeamChange() {
            this.emit(CHANGE_EVENT_IN_TEAM);
        }
    }, {
        key: 'addInTeamChangeListener',
        value: function addInTeamChangeListener(callback) {
            this.on(CHANGE_EVENT_IN_TEAM, callback);
        }
    }, {
        key: 'removeInTeamChangeListener',
        value: function removeInTeamChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_IN_TEAM, callback);
        }
    }, {
        key: 'emitNotInTeamChange',
        value: function emitNotInTeamChange() {
            this.emit(CHANGE_EVENT_NOT_IN_TEAM);
        }
    }, {
        key: 'addNotInTeamChangeListener',
        value: function addNotInTeamChangeListener(callback) {
            this.on(CHANGE_EVENT_NOT_IN_TEAM, callback);
        }
    }, {
        key: 'removeNotInTeamChangeListener',
        value: function removeNotInTeamChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_NOT_IN_TEAM, callback);
        }
    }, {
        key: 'emitInChannelChange',
        value: function emitInChannelChange() {
            this.emit(CHANGE_EVENT_IN_CHANNEL);
        }
    }, {
        key: 'addInChannelChangeListener',
        value: function addInChannelChangeListener(callback) {
            this.on(CHANGE_EVENT_IN_CHANNEL, callback);
        }
    }, {
        key: 'removeInChannelChangeListener',
        value: function removeInChannelChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_IN_CHANNEL, callback);
        }
    }, {
        key: 'emitNotInChannelChange',
        value: function emitNotInChannelChange() {
            this.emit(CHANGE_EVENT_NOT_IN_CHANNEL);
        }
    }, {
        key: 'addNotInChannelChangeListener',
        value: function addNotInChannelChangeListener(callback) {
            this.on(CHANGE_EVENT_NOT_IN_CHANNEL, callback);
        }
    }, {
        key: 'removeNotInChannelChangeListener',
        value: function removeNotInChannelChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_NOT_IN_CHANNEL, callback);
        }
    }, {
        key: 'emitWithoutTeamChange',
        value: function emitWithoutTeamChange() {
            this.emit(CHANGE_EVENT_WITHOUT_TEAM);
        }
    }, {
        key: 'addWithoutTeamChangeListener',
        value: function addWithoutTeamChangeListener(callback) {
            this.on(CHANGE_EVENT_WITHOUT_TEAM, callback);
        }
    }, {
        key: 'removeWithoutTeamChangeListener',
        value: function removeWithoutTeamChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_WITHOUT_TEAM, callback);
        }
    }, {
        key: 'emitSessionsChange',
        value: function emitSessionsChange() {
            this.emit(CHANGE_EVENT_SESSIONS);
        }
    }, {
        key: 'addSessionsChangeListener',
        value: function addSessionsChangeListener(callback) {
            this.on(CHANGE_EVENT_SESSIONS, callback);
        }
    }, {
        key: 'removeSessionsChangeListener',
        value: function removeSessionsChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_SESSIONS, callback);
        }
    }, {
        key: 'emitAuditsChange',
        value: function emitAuditsChange() {
            this.emit(CHANGE_EVENT_AUDITS);
        }
    }, {
        key: 'addAuditsChangeListener',
        value: function addAuditsChangeListener(callback) {
            this.on(CHANGE_EVENT_AUDITS, callback);
        }
    }, {
        key: 'removeAuditsChangeListener',
        value: function removeAuditsChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_AUDITS, callback);
        }
    }, {
        key: 'emitStatusesChange',
        value: function emitStatusesChange() {
            this.emit(CHANGE_EVENT_STATUSES);
        }
    }, {
        key: 'addStatusesChangeListener',
        value: function addStatusesChangeListener(callback) {
            this.on(CHANGE_EVENT_STATUSES, callback);
        }
    }, {
        key: 'removeStatusesChangeListener',
        value: function removeStatusesChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_STATUSES, callback);
        }

        // General

    }, {
        key: 'getCurrentUser',
        value: function getCurrentUser() {
            return Selectors.getCurrentUser(_redux_store2.default.getState());
        }
    }, {
        key: 'getCurrentId',
        value: function getCurrentId() {
            return Selectors.getCurrentUserId(_redux_store2.default.getState());
        }

        // System-Wide Profiles

    }, {
        key: 'getProfiles',
        value: function getProfiles() {
            return Selectors.getUsers(_redux_store2.default.getState());
        }
    }, {
        key: 'getProfile',
        value: function getProfile(userId) {
            return Selectors.getUser(_redux_store2.default.getState(), userId);
        }
    }, {
        key: 'getProfileListForIds',
        value: function getProfileListForIds(userIds) {
            var skipCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var skipInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var profiles = [];
            var currentId = this.getCurrentId();

            for (var i = 0; i < userIds.length; i++) {
                var profile = this.getProfile(userIds[i]);

                if (!profile) {
                    continue;
                }

                if (skipCurrent && profile.id === currentId) {
                    continue;
                }

                if (skipInactive && profile.delete_at > 0) {
                    continue;
                }

                profiles.push(profile);
            }

            return profiles;
        }
    }, {
        key: 'hasProfile',
        value: function hasProfile(userId) {
            return this.getProfiles().hasOwnProperty(userId);
        }
    }, {
        key: 'getProfileByUsername',
        value: function getProfileByUsername(username) {
            return this.getProfilesUsernameMap()[username];
        }
    }, {
        key: 'getProfilesUsernameMap',
        value: function getProfilesUsernameMap() {
            return Selectors.getUsersByUsername(_redux_store2.default.getState());
        }
    }, {
        key: 'getProfileByEmail',
        value: function getProfileByEmail(email) {
            return Selectors.getUsersByEmail(_redux_store2.default.getState())[email];
        }
    }, {
        key: 'getActiveOnlyProfiles',
        value: function getActiveOnlyProfiles(skipCurrent) {
            var active = {};
            var profiles = this.getProfiles();
            var currentId = this.getCurrentId();

            for (var key in profiles) {
                if (!(profiles[key].id === currentId && skipCurrent) && profiles[key].delete_at === 0) {
                    active[key] = profiles[key];
                }
            }

            return active;
        }
    }, {
        key: 'getActiveOnlyProfileList',
        value: function getActiveOnlyProfileList() {
            var profileMap = this.getActiveOnlyProfiles();
            var profiles = [];

            for (var id in profileMap) {
                if (profileMap.hasOwnProperty(id)) {
                    profiles.push(profileMap[id]);
                }
            }

            profiles.sort(function (a, b) {
                if (a.username < b.username) {
                    return -1;
                }
                if (a.username > b.username) {
                    return 1;
                }
                return 0;
            });

            return profiles;
        }
    }, {
        key: 'getProfileList',
        value: function getProfileList() {
            var skipCurrent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var allowInactive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var profiles = [];
            var currentId = this.getCurrentId();
            var profileMap = this.getProfiles();

            for (var id in profileMap) {
                if (profileMap.hasOwnProperty(id)) {
                    var profile = profileMap[id];

                    if (skipCurrent && id === currentId) {
                        continue;
                    }

                    if (allowInactive || profile.delete_at === 0) {
                        profiles.push(profile);
                    }
                }
            }

            profiles.sort(function (a, b) {
                if (a.username < b.username) {
                    return -1;
                }
                if (a.username > b.username) {
                    return 1;
                }
                return 0;
            });

            return profiles;
        }
    }, {
        key: 'saveProfile',
        value: function saveProfile(profile) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE,
                data: profile
            });
        }

        // Team-Wide Profiles

    }, {
        key: 'getProfileListInTeam',
        value: function getProfileListInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _team_store2.default.getCurrentId();
            var skipCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var skipInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsInTeams(_redux_store2.default.getState())[teamId] || []);

            return this.getProfileListForIds(userIds, skipCurrent, skipInactive);
        }
    }, {
        key: 'removeProfileFromTeam',
        value: function removeProfileFromTeam(teamId, userId) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_TEAM,
                data: { user_id: userId },
                id: teamId
            });
        }

        // Not In Team Profiles

    }, {
        key: 'getProfileListNotInTeam',
        value: function getProfileListNotInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _team_store2.default.getCurrentId();
            var skipCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var skipInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsNotInTeams(_redux_store2.default.getState())[teamId] || []);
            var profiles = [];
            var currentId = this.getCurrentId();

            for (var i = 0; i < userIds.length; i++) {
                var profile = this.getProfile(userIds[i]);

                if (!profile) {
                    continue;
                }

                if (skipCurrent && profile.id === currentId) {
                    continue;
                }

                if (skipInactive && profile.delete_at > 0) {
                    continue;
                }

                profiles.push(profile);
            }

            return profiles;
        }
    }, {
        key: 'removeProfileNotInTeam',
        value: function removeProfileNotInTeam(teamId, userId) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_TEAM,
                data: { user_id: userId },
                id: teamId
            });
        }

        // Channel-Wide Profiles

    }, {
        key: 'saveProfileInChannel',
        value: function saveProfileInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var profile = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: { user_id: profile.id },
                id: channelId
            });
        }
    }, {
        key: 'saveUserIdInChannel',
        value: function saveUserIdInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var userId = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: { user_id: userId },
                id: channelId
            });
        }
    }, {
        key: 'removeProfileInChannel',
        value: function removeProfileInChannel(channelId, userId) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL,
                data: { user_id: userId },
                id: channelId
            });
        }
    }, {
        key: 'getProfileListInChannel',
        value: function getProfileListInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var skipCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var skipInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsInChannels(_redux_store2.default.getState())[channelId] || []);

            return this.getProfileListForIds(userIds, skipCurrent, skipInactive);
        }
    }, {
        key: 'saveProfileNotInChannel',
        value: function saveProfileNotInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var profile = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL,
                data: { user_id: profile.id },
                id: channelId
            });
        }
    }, {
        key: 'removeProfileNotInChannel',
        value: function removeProfileNotInChannel(channelId, userId) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: { user_id: userId },
                id: channelId
            });
        }
    }, {
        key: 'getProfileListNotInChannel',
        value: function getProfileListNotInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var skipInactive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsNotInChannels(_redux_store2.default.getState())[channelId] || []);

            return this.getProfileListForIds(userIds, false, skipInactive);
        }

        // Profiles without any teams

    }, {
        key: 'getProfileListWithoutTeam',
        value: function getProfileListWithoutTeam() {
            var skipCurrent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var skipInactive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsWithoutTeam(_redux_store2.default.getState()) || []);

            return this.getProfileListForIds(userIds, skipCurrent, skipInactive);
        }

        // Other

    }, {
        key: 'getSessions',
        value: function getSessions() {
            return _redux_store2.default.getState().entities.users.mySessions;
        }
    }, {
        key: 'getAudits',
        value: function getAudits() {
            return _redux_store2.default.getState().entities.users.myAudits;
        }
    }, {
        key: 'setStatus',
        value: function setStatus(userId, status) {
            var data = [{ user_id: userId, status: status }];
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_STATUSES,
                data: data
            });
        }
    }, {
        key: 'getStatuses',
        value: function getStatuses() {
            return _redux_store2.default.getState().entities.users.statuses;
        }
    }, {
        key: 'getStatus',
        value: function getStatus(id) {
            return this.getStatuses()[id] || UserStatuses.OFFLINE;
        }
    }, {
        key: 'getNoAccounts',
        value: function getNoAccounts() {
            return global.window.mm_config.NoAccounts === 'true';
        }
    }, {
        key: 'setNoAccounts',
        value: function setNoAccounts(noAccounts) {
            this.noAccounts = noAccounts;
        }
    }]);
    return UserStoreClass;
}(_events2.default);

var UserStore = new UserStoreClass();
UserStore.setMaxListeners(600);

exports.default = UserStore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 775 */,
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(918),
	__webpack_require__(812),
	__webpack_require__(1582),
	__webpack_require__(944),
	__webpack_require__(1101),
	__webpack_require__(1102),
	__webpack_require__(1001),
	__webpack_require__(943),
	__webpack_require__(1103),
	__webpack_require__(1000),
	__webpack_require__(1104),
	__webpack_require__(1583),
	__webpack_require__(874),
	__webpack_require__(807),
	__webpack_require__(919),
	__webpack_require__(1105),
	__webpack_require__(896)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr, document, getProto, slice, concat, push, indexOf,
	class2type, toString, hasOwn, fnToString, ObjectFunctionString,
	support, isFunction, isWindow, DOMEval, toType ) {

"use strict";

var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUsersInVisibleDMs = exports.getProfilesWithoutTeam = exports.getProfilesNotInCurrentTeam = exports.getProfilesInTeam = exports.getProfilesInCurrentTeam = exports.getProfilesNotInCurrentChannel = exports.getProfilesInCurrentChannel = exports.getProfileSetNotInCurrentTeam = exports.getProfileSetInCurrentTeam = exports.getProfileSetNotInCurrentChannel = exports.getProfileSetInCurrentChannel = exports.getCurrentUserMentionKeys = exports.getCurrentUserRoles = exports.isCurrentUserSystemAdmin = exports.getUsersByEmail = exports.getUsersByUsername = exports.getUsers = exports.getCurrentUser = exports.getCurrentUserId = undefined;
exports.getUserIdsInChannels = getUserIdsInChannels;
exports.getUserIdsNotInChannels = getUserIdsNotInChannels;
exports.getUserIdsInTeams = getUserIdsInTeams;
exports.getUserIdsNotInTeams = getUserIdsNotInTeams;
exports.getUserIdsWithoutTeam = getUserIdsWithoutTeam;
exports.getUserStatuses = getUserStatuses;
exports.getUser = getUser;
exports.getUserByUsername = getUserByUsername;
exports.getUserByEmail = getUserByEmail;
exports.getStatusForUserId = getStatusForUserId;
exports.searchProfiles = searchProfiles;
exports.searchProfilesInCurrentChannel = searchProfilesInCurrentChannel;
exports.searchProfilesNotInCurrentChannel = searchProfilesNotInCurrentChannel;
exports.searchProfilesInCurrentTeam = searchProfilesInCurrentTeam;
exports.searchProfilesInTeam = searchProfilesInTeam;
exports.searchProfilesNotInCurrentTeam = searchProfilesNotInCurrentTeam;
exports.searchProfilesWithoutTeam = searchProfilesWithoutTeam;
exports.makeGetProfilesForReactions = makeGetProfilesForReactions;
exports.makeGetProfilesInChannel = makeGetProfilesInChannel;

var _reselect = __webpack_require__(78);

var _common = __webpack_require__(280);

var _preferences = __webpack_require__(784);

var _user_utils = __webpack_require__(175);

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.getCurrentUserId = _common.getCurrentUserId;
exports.getCurrentUser = _common.getCurrentUser;
exports.getUsers = _common.getUsers;
function getUserIdsInChannels(state) {
    return state.entities.users.profilesInChannel;
}

function getUserIdsNotInChannels(state) {
    return state.entities.users.profilesNotInChannel;
}

function getUserIdsInTeams(state) {
    return state.entities.users.profilesInTeam;
}

function getUserIdsNotInTeams(state) {
    return state.entities.users.profilesNotInTeam;
}

function getUserIdsWithoutTeam(state) {
    return state.entities.users.profilesWithoutTeam;
}

function getUserStatuses(state) {
    return state.entities.users.statuses;
}

function getUser(state, id) {
    return state.entities.users.profiles[id];
}

var getUsersByUsername = exports.getUsersByUsername = (0, _reselect.createSelector)(_common.getUsers, function (users) {
    var usersByUsername = {};

    for (var id in users) {
        if (users.hasOwnProperty(id)) {
            var user = users[id];
            usersByUsername[user.username] = user;
        }
    }

    return usersByUsername;
});

function getUserByUsername(state, username) {
    return getUsersByUsername(state)[username];
}

var getUsersByEmail = exports.getUsersByEmail = (0, _reselect.createSelector)(_common.getUsers, function (users) {
    var usersByEmail = {};

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.values(users)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var user = _step.value;

            usersByEmail[user.email] = user;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return usersByEmail;
});

function getUserByEmail(state, email) {
    return getUsersByEmail(state)[email];
}

var isCurrentUserSystemAdmin = exports.isCurrentUserSystemAdmin = (0, _reselect.createSelector)(_common.getCurrentUser, function (user) {
    var roles = user.roles || '';
    return (0, _user_utils.isSystemAdmin)(roles);
});

var getCurrentUserRoles = exports.getCurrentUserRoles = (0, _reselect.createSelector)(_common.getMyCurrentChannelMembership, function (state) {
    return state.entities.teams.myMembers[state.entities.teams.currentTeamId];
}, _common.getCurrentUser, function (currentChannelMembership, currentTeamMembership, currentUser) {
    var roles = '';
    if (currentTeamMembership) {
        roles += currentTeamMembership.roles + ' ';
    }

    if (currentChannelMembership) {
        roles += currentChannelMembership.roles + ' ';
    }

    if (currentUser) {
        roles += currentUser.roles;
    }
    return roles.trim();
});

var getCurrentUserMentionKeys = exports.getCurrentUserMentionKeys = (0, _reselect.createSelector)(_common.getCurrentUser, function (user) {
    var keys = [];

    if (!user || !user.notify_props) {
        return keys;
    }

    if (user.notify_props.mention_keys) {
        keys = keys.concat(user.notify_props.mention_keys.split(',').map(function (key) {
            return { key: key };
        }));
    }

    if (user.notify_props.first_name === 'true' && user.first_name) {
        keys.push({ key: user.first_name, caseSensitive: true });
    }

    if (user.notify_props.channel === 'true') {
        keys.push({ key: '@channel' });
        keys.push({ key: '@all' });
        keys.push({ key: '@here' });
    }

    var usernameKey = '@' + user.username;
    if (keys.findIndex(function (key) {
        return key.key === usernameKey;
    }) === -1) {
        keys.push({ key: usernameKey });
    }

    return keys;
});

var getProfileSetInCurrentChannel = exports.getProfileSetInCurrentChannel = (0, _reselect.createSelector)(_common.getCurrentChannelId, getUserIdsInChannels, function (currentChannel, channelProfiles) {
    return channelProfiles[currentChannel];
});

var getProfileSetNotInCurrentChannel = exports.getProfileSetNotInCurrentChannel = (0, _reselect.createSelector)(_common.getCurrentChannelId, getUserIdsNotInChannels, function (currentChannel, channelProfiles) {
    return channelProfiles[currentChannel];
});

var getProfileSetInCurrentTeam = exports.getProfileSetInCurrentTeam = (0, _reselect.createSelector)(function (state) {
    return state.entities.teams.currentTeamId;
}, getUserIdsInTeams, function (currentTeam, teamProfiles) {
    return teamProfiles[currentTeam];
});

var getProfileSetNotInCurrentTeam = exports.getProfileSetNotInCurrentTeam = (0, _reselect.createSelector)(function (state) {
    return state.entities.teams.currentTeamId;
}, getUserIdsNotInTeams, function (currentTeam, teamProfiles) {
    return teamProfiles[currentTeam];
});

function sortAndInjectProfiles(profiles, profileSet) {
    var skipInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var currentProfiles = [];
    if (typeof profileSet === 'undefined') {
        return currentProfiles;
    }

    profileSet.forEach(function (p) {
        var profile = profiles[p];
        if (skipInactive && profile.delete_at && profile.delete_at !== 0) {
            return;
        }
        currentProfiles.push(profile);
    });

    var sortedCurrentProfiles = currentProfiles.sort(_user_utils.sortByUsername);

    return sortedCurrentProfiles;
}

var getProfilesInCurrentChannel = exports.getProfilesInCurrentChannel = (0, _reselect.createSelector)(_common.getUsers, getProfileSetInCurrentChannel, function (profiles, currentChannelProfileSet) {
    return sortAndInjectProfiles(profiles, currentChannelProfileSet);
});

var getProfilesNotInCurrentChannel = exports.getProfilesNotInCurrentChannel = (0, _reselect.createSelector)(_common.getUsers, getProfileSetNotInCurrentChannel, function (profiles, notInCurrentChannelProfileSet) {
    return sortAndInjectProfiles(profiles, notInCurrentChannelProfileSet);
});

var getProfilesInCurrentTeam = exports.getProfilesInCurrentTeam = (0, _reselect.createSelector)(_common.getUsers, getProfileSetInCurrentTeam, function (profiles, currentTeamProfileSet) {
    return sortAndInjectProfiles(profiles, currentTeamProfileSet);
});

var getProfilesInTeam = exports.getProfilesInTeam = (0, _reselect.createSelector)(_common.getUsers, getUserIdsInTeams, function (state, teamId) {
    return teamId;
}, function (profiles, usersInTeams, teamId) {
    return sortAndInjectProfiles(profiles, usersInTeams[teamId] || new Set());
});

var getProfilesNotInCurrentTeam = exports.getProfilesNotInCurrentTeam = (0, _reselect.createSelector)(_common.getUsers, getProfileSetNotInCurrentTeam, function (profiles, notInCurrentTeamProfileSet) {
    return sortAndInjectProfiles(profiles, notInCurrentTeamProfileSet);
});

var getProfilesWithoutTeam = exports.getProfilesWithoutTeam = (0, _reselect.createSelector)(_common.getUsers, getUserIdsWithoutTeam, function (profiles, withoutTeamProfileSet) {
    return sortAndInjectProfiles(profiles, withoutTeamProfileSet);
});

function getStatusForUserId(state, userId) {
    return getUserStatuses(state)[userId];
}

function searchProfiles(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(Object.values((0, _common.getUsers)(state)), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, (0, _common.getCurrentUserId)(state));
    }

    return profiles;
}

function searchProfilesInCurrentChannel(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesInCurrentChannel(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, (0, _common.getCurrentUserId)(state));
    }

    return profiles;
}

function searchProfilesNotInCurrentChannel(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesNotInCurrentChannel(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, (0, _common.getCurrentUserId)(state));
    }

    return profiles;
}

function searchProfilesInCurrentTeam(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesInCurrentTeam(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, (0, _common.getCurrentUserId)(state));
    }

    return profiles;
}

function searchProfilesInTeam(state, teamId, term) {
    var skipCurrent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesInTeam(state, teamId), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, (0, _common.getCurrentUserId)(state));
    }

    return profiles;
}

function searchProfilesNotInCurrentTeam(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesNotInCurrentTeam(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, (0, _common.getCurrentUserId)(state));
    }

    return profiles;
}

function searchProfilesWithoutTeam(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesWithoutTeam(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, (0, _common.getCurrentUserId)(state));
    }

    return profiles;
}

function removeCurrentUserFromList(profiles, currentUserId) {
    var index = profiles.findIndex(function (p) {
        return p.id === currentUserId;
    });
    if (index >= 0) {
        profiles.splice(index, 1);
    }
}

var getUsersInVisibleDMs = exports.getUsersInVisibleDMs = (0, _reselect.createSelector)(_common.getUsers, _preferences.getDirectShowPreferences, function (users, preferences) {
    var dmUsers = [];
    preferences.forEach(function (pref) {
        if (pref.value === 'true' && users[pref.name]) {
            dmUsers.push(users[pref.name]);
        }
    });
    return dmUsers;
});

function makeGetProfilesForReactions() {
    return (0, _reselect.createSelector)(_common.getUsers, function (state, reactions) {
        return reactions;
    }, function (users, reactions) {
        var profiles = [];
        reactions.forEach(function (r) {
            if (users[r.user_id]) {
                profiles.push(users[r.user_id]);
            }
        });
        return profiles;
    });
}

function makeGetProfilesInChannel() {
    return (0, _reselect.createSelector)(_common.getUsers, getUserIdsInChannels, function (state, channelId) {
        return channelId;
    }, function (state, channelId, skipInactive) {
        return skipInactive;
    }, function (users, userIds, channelId) {
        var skipInactive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var userIdsInChannel = userIds[channelId];

        if (!userIdsInChannel) {
            return [];
        }

        return sortAndInjectProfiles(users, userIdsInChannel, skipInactive);
    });
}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.redirectUserToDefaultTeam = exports.emitPostFocusEvent = exports.doFocusPost = undefined;

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var doFocusPost = exports.doFocusPost = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(channelId, postId, data) {
        var member;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _app_dispatcher2.default.handleServerAction({
                            type: _constants.ActionTypes.RECEIVED_FOCUSED_POST,
                            postId: postId,
                            channelId: channelId,
                            post_list: data
                        });

                        dispatch({
                            type: _constants.ActionTypes.RECEIVED_FOCUSED_POST,
                            data: postId
                        });

                        member = getState().entities.channels.myMembers[channelId];

                        if (!(member == null)) {
                            _context2.next = 6;
                            break;
                        }

                        _context2.next = 6;
                        return (0, _channels.joinChannel)(_user_store2.default.getCurrentId(), null, channelId)(dispatch, getState);

                    case 6:

                        (0, _channel_actions.loadChannelsForCurrentUser)();
                        (0, _channels.getChannelStats)(channelId)(dispatch, getState);

                    case 8:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function doFocusPost(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}();

var emitPostFocusEvent = exports.emitPostFocusEvent = function () {
    var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(postId) {
        var returnTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var _ref5, data, channelId, channel, teamId, _ref6, channelData;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        (0, _channel_actions.loadChannelsForCurrentUser)();
                        _context3.next = 3;
                        return dispatch((0, _posts.getPostThread)(postId));

                    case 3:
                        _ref5 = _context3.sent;
                        data = _ref5.data;

                        if (data) {
                            _context3.next = 8;
                            break;
                        }

                        _browser_history.browserHistory.push('/error?type=' + _constants.ErrorPageTypes.PERMALINK_NOT_FOUND + '&returnTo=' + returnTo);
                        return _context3.abrupt('return');

                    case 8:
                        channelId = data.posts[data.order[0]].channel_id;
                        channel = getState().entities.channels.channels[channelId];
                        teamId = (0, _teams2.getCurrentTeamId)(getState());

                        if (channel) {
                            _context3.next = 20;
                            break;
                        }

                        _context3.next = 14;
                        return dispatch((0, _channels.getChannel)(channelId));

                    case 14:
                        _ref6 = _context3.sent;
                        channelData = _ref6.data;

                        if (channelData) {
                            _context3.next = 19;
                            break;
                        }

                        _browser_history.browserHistory.push('/error?type=' + _constants.ErrorPageTypes.PERMALINK_NOT_FOUND + '&returnTo=' + returnTo);
                        return _context3.abrupt('return');

                    case 19:
                        channel = channelData;

                    case 20:
                        if (!(channel.team_id && channel.team_id !== teamId)) {
                            _context3.next = 23;
                            break;
                        }

                        _browser_history.browserHistory.push('/error?type=' + _constants.ErrorPageTypes.PERMALINK_NOT_FOUND + '&returnTo=' + returnTo);
                        return _context3.abrupt('return');

                    case 23:

                        if (channel && channel.type === _constants.Constants.DM_CHANNEL) {
                            (0, _user_actions.loadNewDMIfNeeded)(channel.id);
                        } else if (channel && channel.type === _constants.Constants.GM_CHANNEL) {
                            (0, _user_actions.loadNewGMIfNeeded)(channel.id);
                        }

                        _context3.next = 26;
                        return doFocusPost(channelId, postId, data);

                    case 26:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function emitPostFocusEvent(_x7) {
        return _ref4.apply(this, arguments);
    };
}();

var redirectUserToDefaultTeam = exports.redirectUserToDefaultTeam = function () {
    var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var teams, teamMembers, teamId, redirect, myTeams, index, teamMember, team, channelId, channel, channelName, _ref9, data, _ref10, _data;

        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        redirect = function redirect(teamName, channelName) {
                            _browser_history.browserHistory.push('/' + teamName + '/channels/' + channelName);
                        };

                        teams = _team_store2.default.getAll();
                        teamMembers = _team_store2.default.getMyTeamMembers();
                        teamId = _browser_store2.default.getGlobalItem('team');


                        if (!teams[teamId] && teamMembers.length > 0) {
                            myTeams = [];

                            for (index in teamMembers) {
                                if (teamMembers.hasOwnProperty(index)) {
                                    teamMember = teamMembers[index];

                                    myTeams.push(teams[teamMember.team_id]);
                                }
                            }

                            if (myTeams.length > 0) {
                                myTeams = (0, _team_utils.filterAndSortTeamsByDisplayName)(myTeams);
                                if (myTeams && myTeams[0]) {
                                    teamId = myTeams[0].id;
                                }
                            }
                        }

                        team = teams[teamId];

                        if (!team) {
                            _context5.next = 31;
                            break;
                        }

                        channelId = _browser_store2.default.getGlobalItem(teamId);
                        channel = _channel_store2.default.getChannelById(channelId);
                        channelName = _constants.Constants.DEFAULT_CHANNEL;

                        if (!(channel && channel.team_id === team.id)) {
                            _context5.next = 15;
                            break;
                        }

                        dispatch((0, _channels.selectChannel)(channel.id));
                        channelName = channel.name;
                        _context5.next = 28;
                        break;

                    case 15:
                        if (!channelId) {
                            _context5.next = 23;
                            break;
                        }

                        _context5.next = 18;
                        return (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState);

                    case 18:
                        _ref9 = _context5.sent;
                        data = _ref9.data;

                        if (data) {
                            dispatch((0, _channels.selectChannel)(channelId));
                            channelName = data.channel.name;
                        }
                        _context5.next = 28;
                        break;

                    case 23:
                        _context5.next = 25;
                        return dispatch((0, _channels.getChannelByNameAndTeamName)(team.name, channelName));

                    case 25:
                        _ref10 = _context5.sent;
                        _data = _ref10.data;

                        if (_data) {
                            dispatch((0, _channels.selectChannel)(_data.id));
                        }

                    case 28:

                        redirect(team.name, channelName);
                        _context5.next = 32;
                        break;

                    case 31:
                        _browser_history.browserHistory.push('/select_team');

                    case 32:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function redirectUserToDefaultTeam() {
        return _ref8.apply(this, arguments);
    };
}();

exports.emitChannelClickEvent = emitChannelClickEvent;
exports.emitCloseRightHandSide = emitCloseRightHandSide;
exports.emitLeaveTeam = emitLeaveTeam;
exports.emitUserPostedEvent = emitUserPostedEvent;
exports.emitUserCommentedEvent = emitUserCommentedEvent;
exports.showAccountSettingsModal = showAccountSettingsModal;
exports.toggleShortcutsModal = toggleShortcutsModal;
exports.showChannelHeaderUpdateModal = showChannelHeaderUpdateModal;
exports.showChannelPurposeUpdateModal = showChannelPurposeUpdateModal;
exports.showChannelNameUpdateModal = showChannelNameUpdateModal;
exports.showGetPostLinkModal = showGetPostLinkModal;
exports.showGetPublicLinkModal = showGetPublicLinkModal;
exports.showGetTeamInviteLinkModal = showGetTeamInviteLinkModal;
exports.showInviteMemberModal = showInviteMemberModal;
exports.showLeaveTeamModal = showLeaveTeamModal;
exports.showLeavePrivateChannelModal = showLeavePrivateChannelModal;
exports.emitSuggestionPretextChanged = emitSuggestionPretextChanged;
exports.emitSelectNextSuggestion = emitSelectNextSuggestion;
exports.emitSelectPreviousSuggestion = emitSelectPreviousSuggestion;
exports.emitCompleteWordSuggestion = emitCompleteWordSuggestion;
exports.emitClearSuggestions = emitClearSuggestions;
exports.emitPreferenceChangedEvent = emitPreferenceChangedEvent;
exports.emitPreferencesChangedEvent = emitPreferencesChangedEvent;
exports.emitPreferencesDeletedEvent = emitPreferencesDeletedEvent;
exports.sendEphemeralPost = sendEphemeralPost;
exports.sendAddToChannelEphemeralPost = sendAddToChannelEphemeralPost;
exports.newLocalizationSelected = newLocalizationSelected;
exports.loadCurrentLocale = loadCurrentLocale;
exports.loadDefaultLocale = loadDefaultLocale;
exports.emitLocalUserTypingEvent = emitLocalUserTypingEvent;
exports.emitRemoteUserTypingEvent = emitRemoteUserTypingEvent;
exports.emitUserLoggedOutEvent = emitUserLoggedOutEvent;
exports.clientLogout = clientLogout;
exports.toggleSideBarRightMenuAction = toggleSideBarRightMenuAction;
exports.emitBrowserFocus = emitBrowserFocus;
exports.postListScrollChange = postListScrollChange;
exports.emitPopoverMentionKeyClick = emitPopoverMentionKeyClick;
exports.reloadIfServerVersionChanged = reloadIfServerVersionChanged;

var _channels = __webpack_require__(798);

var _posts = __webpack_require__(808);

var _teams = __webpack_require__(816);

var _client = __webpack_require__(270);

var _general = __webpack_require__(113);

var _teams2 = __webpack_require__(274);

var _channels2 = __webpack_require__(783);

var _browser_history = __webpack_require__(273);

var _channel_actions = __webpack_require__(809);

var _post_actions = __webpack_require__(802);

var _status_actions = __webpack_require__(955);

var _user_actions = __webpack_require__(781);

var _rhs = __webpack_require__(817);

var _lhs = __webpack_require__(958);

var _websocket_actions = __webpack_require__(1030);

var WebsocketActions = _interopRequireWildcard(_websocket_actions);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _web_websocket_client = __webpack_require__(959);

var _web_websocket_client2 = _interopRequireDefault(_web_websocket_client);

var _constants = __webpack_require__(29);

var _event_types = __webpack_require__(1034);

var _event_types2 = _interopRequireDefault(_event_types);

var _team_utils = __webpack_require__(960);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _en = __webpack_require__(1839);

var _en2 = _interopRequireDefault(_en);

var _i18n = __webpack_require__(924);

var I18n = _interopRequireWildcard(_i18n);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

function emitChannelClickEvent(channel) {
    var _this = this;

    var userVisitedFakeChannel = function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(chan, success, fail) {
            var currentUserId, otherUserId, _ref2, receivedChannel;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            currentUserId = _user_store2.default.getCurrentId();
                            otherUserId = Utils.getUserIdFromChannelName(chan);
                            _context.next = 4;
                            return (0, _channels.createDirectChannel)(currentUserId, otherUserId)(dispatch, getState);

                        case 4:
                            _ref2 = _context.sent;
                            receivedChannel = _ref2.data;

                            if (receivedChannel) {
                                success(receivedChannel);
                            } else {
                                fail();
                            }

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function userVisitedFakeChannel(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        };
    }();

    function switchToChannel(chan) {
        var getMyChannelMemberPromise = (0, _channels.getMyChannelMember)(chan.id)(dispatch, getState);
        var oldChannelId = _channel_store2.default.getCurrentId();

        getMyChannelMemberPromise.then(function () {
            (0, _channels.getChannelStats)(chan.id)(dispatch, getState);

            // Mark previous and next channel as read
            dispatch((0, _channels.markChannelAsRead)(chan.id, oldChannelId));
            reloadIfServerVersionChanged();
        });

        _browser_store2.default.setGlobalItem(_constants.Constants.PREV_CHANNEL_KEY + chan.team_id, chan.name);

        (0, _user_actions.loadProfilesForSidebar)();

        _app_dispatcher2.default.handleViewAction({
            type: _constants.ActionTypes.CLICK_CHANNEL,
            id: chan.id,
            team_id: chan.team_id
        });
    }

    if (channel.fake) {
        userVisitedFakeChannel(channel, function (data) {
            switchToChannel(data);
        }, function () {
            _browser_history.browserHistory.push('/' + _this.state.currentTeam.name);
        });
    } else {
        switchToChannel(channel);
    }
}

function emitCloseRightHandSide() {
    dispatch((0, _rhs.closeRightHandSide)());
}

function emitLeaveTeam() {
    (0, _teams.removeUserFromTeam)(_team_store2.default.getCurrentId(), _user_store2.default.getCurrentId())(dispatch, getState);
}

function emitUserPostedEvent(post) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.ActionTypes.CREATE_POST,
        post: post
    });
}

function emitUserCommentedEvent(post) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.ActionTypes.CREATE_COMMENT,
        post: post
    });
}

function showAccountSettingsModal() {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_ACCOUNT_SETTINGS_MODAL,
        value: true
    });
}

function toggleShortcutsModal() {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_SHORTCUTS_MODAL,
        value: true
    });
}

function showChannelHeaderUpdateModal(channel) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_CHANNEL_HEADER_UPDATE_MODAL,
        value: true,
        channel: channel
    });
}

function showChannelPurposeUpdateModal(channel) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_CHANNEL_PURPOSE_UPDATE_MODAL,
        value: true,
        channel: channel
    });
}

function showChannelNameUpdateModal(channel) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_CHANNEL_NAME_UPDATE_MODAL,
        value: true,
        channel: channel
    });
}

function showGetPostLinkModal(post) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_GET_POST_LINK_MODAL,
        value: true,
        post: post
    });
}

function showGetPublicLinkModal(fileId) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL,
        value: true,
        fileId: fileId
    });
}

function showGetTeamInviteLinkModal() {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL,
        value: true
    });
}

function showInviteMemberModal() {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_INVITE_MEMBER_MODAL,
        value: true
    });
}

function showLeaveTeamModal() {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_LEAVE_TEAM_MODAL,
        value: true
    });
}

function showLeavePrivateChannelModal(channel) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.TOGGLE_LEAVE_PRIVATE_CHANNEL_MODAL,
        value: channel
    });
}

function emitSuggestionPretextChanged(suggestionId, pretext) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.SUGGESTION_PRETEXT_CHANGED,
        id: suggestionId,
        pretext: pretext
    });
}

function emitSelectNextSuggestion(suggestionId) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.SUGGESTION_SELECT_NEXT,
        id: suggestionId
    });
}

function emitSelectPreviousSuggestion(suggestionId) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.SUGGESTION_SELECT_PREVIOUS,
        id: suggestionId
    });
}

function emitCompleteWordSuggestion(suggestionId) {
    var term = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.SUGGESTION_COMPLETE_WORD,
        id: suggestionId,
        term: term
    });
}

function emitClearSuggestions(suggestionId) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.SUGGESTION_CLEAR_SUGGESTIONS,
        id: suggestionId
    });
}

function emitPreferenceChangedEvent(preference) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.Constants.ActionTypes.RECEIVED_PREFERENCE,
        preference: preference
    });

    if (addedNewDmUser(preference)) {
        (0, _user_actions.loadProfilesForSidebar)();
    }
}

function emitPreferencesChangedEvent(preferences) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.Constants.ActionTypes.RECEIVED_PREFERENCES,
        preferences: preferences
    });

    if (preferences.findIndex(addedNewDmUser) !== -1) {
        (0, _user_actions.loadProfilesForSidebar)();
    }
}

function addedNewDmUser(preference) {
    return preference.category === _constants.Constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW && preference.value === 'true';
}

function emitPreferencesDeletedEvent(preferences) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.Constants.ActionTypes.DELETED_PREFERENCES,
        preferences: preferences
    });
}

function sendEphemeralPost(message, channelId, parentId) {
    var timestamp = Utils.getTimestamp();
    var post = {
        id: Utils.generateId(),
        user_id: '0',
        channel_id: channelId || _channel_store2.default.getCurrentId(),
        message: message,
        type: _constants.PostTypes.EPHEMERAL,
        create_at: timestamp,
        update_at: timestamp,
        root_id: parentId,
        parent_id: parentId,
        props: {}
    };

    (0, _post_actions.handleNewPost)(post);
}

function sendAddToChannelEphemeralPost(user, addedUsername, addedUserId, channelId) {
    var postRootId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var timestamp = arguments[5];

    var post = {
        id: Utils.generateId(),
        user_id: user.id,
        channel_id: channelId || _channel_store2.default.getCurrentId(),
        message: '',
        type: _constants.PostTypes.EPHEMERAL_ADD_TO_CHANNEL,
        create_at: timestamp,
        update_at: timestamp,
        root_id: postRootId,
        parent_id: postRootId,
        props: {
            username: user.username,
            addedUsername: addedUsername,
            addedUserId: addedUserId
        }
    };

    (0, _post_actions.handleNewPost)(post);
}

function newLocalizationSelected(locale) {
    var localeInfo = I18n.getLanguageInfo(locale);

    if (locale === 'en' || !localeInfo) {
        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_LOCALE,
            locale: locale,
            translations: _en2.default
        });
    } else {
        _client.Client4.getTranslations(localeInfo.url).then(function (data, res) {
            var translations = data;
            if (!data && res.text) {
                translations = JSON.parse(res.text);
            }
            _app_dispatcher2.default.handleServerAction({
                type: _constants.ActionTypes.RECEIVED_LOCALE,
                locale: locale,
                translations: translations
            });
        }).catch(function () {} //eslint-disable-line no-empty-function
        );
    }
}

function loadCurrentLocale() {
    var user = _user_store2.default.getCurrentUser();

    if (user && user.locale) {
        newLocalizationSelected(user.locale);
    } else {
        loadDefaultLocale();
    }
}

function loadDefaultLocale() {
    var config = (0, _general.getConfig)(getState());
    var locale = config.DefaultClientLocale;

    if (!I18n.getLanguageInfo(locale)) {
        locale = 'en';
    }

    return newLocalizationSelected(locale);
}

var lastTimeTypingSent = 0;
function emitLocalUserTypingEvent(channelId, parentPostId) {
    var _this2 = this;

    var userTyping = function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(actionDispatch, actionGetState) {
            var state, config, t, stats, membersInChannel;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = actionGetState();
                            config = (0, _general.getConfig)(state);
                            t = Date.now();
                            stats = (0, _channels2.getCurrentChannelStats)(state);
                            membersInChannel = stats ? stats.member_count : 0;


                            if (t - lastTimeTypingSent > config.TimeBetweenUserTypingUpdatesMilliseconds && membersInChannel < config.MaxNotificationsPerChannel && config.EnableUserTypingMessages === 'true') {
                                _web_websocket_client2.default.userTyping(channelId, parentPostId);
                                lastTimeTypingSent = t;
                            }

                            return _context4.abrupt('return', { data: true });

                        case 7:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this2);
        }));

        return function userTyping(_x11, _x12) {
            return _ref7.apply(this, arguments);
        };
    }();

    return dispatch(userTyping);
}

function emitRemoteUserTypingEvent(channelId, userId, postParentId) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.USER_TYPING,
        channelId: channelId,
        userId: userId,
        postParentId: postParentId
    });
}

function emitUserLoggedOutEvent() {
    var redirectTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
    var shouldSignalLogout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _client.Client4.logout().then(function () {
        if (shouldSignalLogout) {
            _browser_store2.default.signalLogout();
        }

        clientLogout(redirectTo);
    }).catch(function () {
        _browser_history.browserHistory.push(redirectTo);
    });
}

function clientLogout() {
    var redirectTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';

    _browser_store2.default.clear({ exclude: [_constants.Constants.RECENT_EMOJI_KEY, '__landingPageSeen__', 'selected_teams'] });
    _error_store2.default.clearLastError();
    _channel_store2.default.clear();
    (0, _status_actions.stopPeriodicStatusUpdates)();
    WebsocketActions.close();
    document.cookie = 'MMUSERID=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    _browser_history.browserHistory.push(redirectTo);
}

function toggleSideBarRightMenuAction() {
    dispatch((0, _rhs.closeRightHandSide)());
    dispatch((0, _lhs.close)());
    dispatch((0, _rhs.closeMenu)());
}

function emitBrowserFocus(focus) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.BROWSER_CHANGE_FOCUS,
        focus: focus
    });
}

function postListScrollChange() {
    var forceScrollToBottom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _app_dispatcher2.default.handleViewAction({
        type: _event_types2.default.POST_LIST_SCROLL_CHANGE,
        value: forceScrollToBottom
    });
}

function emitPopoverMentionKeyClick(isRHS, mentionKey) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants.ActionTypes.POPOVER_MENTION_KEY_CLICK,
        isRHS: isRHS,
        mentionKey: mentionKey
    });
}

var serverVersion = '';

function reloadIfServerVersionChanged() {
    var newServerVersion = _client.Client4.getServerVersion();
    if (serverVersion && serverVersion !== newServerVersion) {
        console.log('Detected version update refreshing the page'); //eslint-disable-line no-console
        window.location.reload(true);
    }

    serverVersion = newServerVersion;
}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _action_types = __webpack_require__(3);

var _teams = __webpack_require__(274);

var Selectors = _interopRequireWildcard(_teams);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _url = __webpack_require__(793);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPrefs = _constants2.default.NotificationPrefs; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ActionTypes = _constants2.default.ActionTypes;

var CHANGE_EVENT = 'change';
var STATS_EVENT = 'stats';
var UNREAD_EVENT = 'unread';

var Utils;

var TeamStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(TeamStoreClass, _EventEmitter);

    function TeamStoreClass() {
        (0, _classCallCheck3.default)(this, TeamStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamStoreClass.__proto__ || (0, _getPrototypeOf2.default)(TeamStoreClass)).call(this));

        _this.entities = _redux_store2.default.getState().entities.teams;

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.teams;
            var entities = _this.entities;
            _this.entities = newEntities;

            var doEmit = false;

            if (newEntities.currentTeamId !== entities.currentTeamId) {
                doEmit = true;
            }

            if (newEntities.teams !== entities.teams) {
                doEmit = true;
            }

            if (newEntities.myMembers !== entities.myMembers) {
                doEmit = true;
                _this.emitUnreadChange();
            }

            if (newEntities.membersInTeam !== entities.membersInTeam) {
                doEmit = true;
            }

            if (newEntities.stats !== entities.stats) {
                _this.emitStatsChange();
            }

            if (doEmit) {
                _this.emitChange();
            }
        });
        return _this;
    }

    (0, _createClass3.default)(TeamStoreClass, [{
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitStatsChange',
        value: function emitStatsChange() {
            this.emit(STATS_EVENT);
        }
    }, {
        key: 'addStatsChangeListener',
        value: function addStatsChangeListener(callback) {
            this.on(STATS_EVENT, callback);
        }
    }, {
        key: 'removeStatsChangeListener',
        value: function removeStatsChangeListener(callback) {
            this.removeListener(STATS_EVENT, callback);
        }
    }, {
        key: 'emitUnreadChange',
        value: function emitUnreadChange() {
            this.emit(UNREAD_EVENT);
        }
    }, {
        key: 'addUnreadChangeListener',
        value: function addUnreadChangeListener(callback) {
            this.on(UNREAD_EVENT, callback);
        }
    }, {
        key: 'removeUnreadChangeListener',
        value: function removeUnreadChangeListener(callback) {
            this.removeListener(UNREAD_EVENT, callback);
        }
    }, {
        key: 'get',
        value: function get(id) {
            var c = this.getAll();
            return c[id];
        }
    }, {
        key: 'getByName',
        value: function getByName(name) {
            var t = this.getAll();

            for (var id in t) {
                if (t.hasOwnProperty(id)) {
                    if (t[id].name === name) {
                        return t[id];
                    }
                }
            }

            return null;
        }
    }, {
        key: 'getAll',
        value: function getAll() {
            var list = Selectors.getMyTeams(_redux_store2.default.getState());
            var teams = {};
            list.forEach(function (t) {
                teams[t.id] = t;
            });
            return teams;
        }
    }, {
        key: 'getCurrentId',
        value: function getCurrentId() {
            return Selectors.getCurrentTeamId(_redux_store2.default.getState());
        }
    }, {
        key: 'setCurrentId',
        value: function setCurrentId(id) {
            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.SELECT_TEAM,
                data: id
            });
        }
    }, {
        key: 'getCurrent',
        value: function getCurrent() {
            var team = Selectors.getCurrentTeam(_redux_store2.default.getState());

            if (team) {
                return team;
            }

            return null;
        }
    }, {
        key: 'getCurrentTeamUrl',
        value: function getCurrentTeamUrl() {
            return this.getTeamUrl(this.getCurrentId());
        }
    }, {
        key: 'getCurrentTeamRelativeUrl',
        value: function getCurrentTeamRelativeUrl() {
            return this.getTeamRelativeUrl(this.getCurrentId());
        }
    }, {
        key: 'getCurrentInviteLink',
        value: function getCurrentInviteLink() {
            var current = this.getCurrent();

            if (current) {
                return (0, _url.getSiteURL)() + '/signup_user_complete/?id=' + current.invite_id;
            }

            return '';
        }
    }, {
        key: 'getTeamRelativeUrl',
        value: function getTeamRelativeUrl(id) {
            var team = this.get(id);

            if (!team) {
                return '';
            }

            return '/' + team.name;
        }
    }, {
        key: 'getTeamUrl',
        value: function getTeamUrl(id) {
            var team = this.get(id);

            if (!team) {
                return '';
            }

            return (0, _url.getSiteURL)() + '/' + team.name;
        }
    }, {
        key: 'getCurrentStats',
        value: function getCurrentStats() {
            return this.getStats(this.getCurrentId());
        }
    }, {
        key: 'getStats',
        value: function getStats(teamId) {
            var stats = void 0;

            if (teamId) {
                stats = Selectors.getTeamStats(_redux_store2.default.getState())[teamId];
            }

            if (stats) {
                // create a defensive copy
                stats = (0, _assign2.default)({}, stats);
            } else {
                stats = { member_count: 0 };
            }

            return stats;
        }
    }, {
        key: 'saveTeam',
        value: function saveTeam(team) {
            var teams = {};
            teams[team.id] = team;
            this.saveTeams(teams);
        }
    }, {
        key: 'saveTeams',
        value: function saveTeams(teams) {
            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_TEAMS,
                data: teams
            });
        }
    }, {
        key: 'updateTeam',
        value: function updateTeam(team) {
            var t = JSON.parse(team);
            var teams = (0, _assign2.default)({}, this.getAll(), this.getTeamListings());
            if (teams && teams[t.id]) {
                this.saveTeam(t);
            }
        }
    }, {
        key: 'saveMyTeam',
        value: function saveMyTeam(team) {
            this.saveTeam(team);
            this.setCurrentId(team.id);
        }
    }, {
        key: 'saveStats',
        value: function saveStats(teamId, stats) {
            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_TEAM_STATS,
                data: stats
            });
        }
    }, {
        key: 'saveMyTeamMembers',
        value: function saveMyTeamMembers(members) {
            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBERS,
                data: members
            });
        }
    }, {
        key: 'appendMyTeamMember',
        value: function appendMyTeamMember(member) {
            var members = this.getMyTeamMembers();
            members.push(member);
            this.saveMyTeamMembers(members);
        }
    }, {
        key: 'saveMyTeamMembersUnread',
        value: function saveMyTeamMembersUnread(members) {
            var myMembers = this.getMyTeamMembers();

            var _loop = function _loop(i) {
                var team = myMembers[i];
                var member = members.filter(function (m) {
                    return m.team_id === team.team_id;
                })[0];

                if (member) {
                    myMembers[i] = (0, _assign2.default)({}, team, {
                        msg_count: member.msg_count,
                        mention_count: member.mention_count
                    });
                }
            };

            for (var i = 0; i < myMembers.length; i++) {
                _loop(i);
            }

            this.saveMyTeamMembers(myMembers);
        }
    }, {
        key: 'removeMyTeamMember',
        value: function removeMyTeamMember(teamId) {
            var myMembers = this.getMyTeamMembers();
            for (var i = 0; i < myMembers.length; i++) {
                if (myMembers[i].team_id === teamId) {
                    myMembers.splice(i, 1);
                }
            }

            this.saveMyTeamMembers(myMembers);
        }
    }, {
        key: 'getMyTeamMembers',
        value: function getMyTeamMembers() {
            return (0, _values2.default)(Selectors.getTeamMemberships(_redux_store2.default.getState()));
        }
    }, {
        key: 'saveMembersInTeam',
        value: function saveMembersInTeam(members) {
            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                data: (0, _values2.default)(members)
            });
        }
    }, {
        key: 'removeMemberInTeam',
        value: function removeMemberInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var userId = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.REMOVE_MEMBER_FROM_TEAM,
                data: { team_id: teamId, user_id: userId }
            });
        }
    }, {
        key: 'getMembersInTeam',
        value: function getMembersInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();

            return Selectors.getMembersInTeams(_redux_store2.default.getState())[teamId] || {};
        }
    }, {
        key: 'getMemberInTeam',
        value: function getMemberInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var userId = arguments[1];

            return Selectors.getTeamMember(_redux_store2.default.getState(), teamId, userId);
        }
    }, {
        key: 'hasActiveMemberInTeam',
        value: function hasActiveMemberInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var userId = arguments[1];

            if (this.getMemberInTeam(teamId, userId)) {
                return true;
            }

            return false;
        }
    }, {
        key: 'getTeamListings',
        value: function getTeamListings() {
            return Selectors.getJoinableTeams(_redux_store2.default.getState());
        }
    }, {
        key: 'isTeamAdminForAnyTeam',
        value: function isTeamAdminForAnyTeam() {
            if (!Utils) {
                Utils = __webpack_require__(762); //eslint-disable-line global-require
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.getMyTeamMembers()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var teamMember = _step.value;

                    if (Utils.isAdmin(teamMember.roles)) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return false;
        }
    }, {
        key: 'isTeamAdmin',
        value: function isTeamAdmin(userId, teamId) {
            if (!Utils) {
                Utils = __webpack_require__(762); //eslint-disable-line global-require
            }

            var teamMembers = this.getMyTeamMembers();
            var teamMember = teamMembers.find(function (m) {
                return m.user_id === userId && m.team_id === teamId;
            });

            if (teamMember) {
                return Utils.isAdmin(teamMember.roles);
            }

            return false;
        }
    }, {
        key: 'updateMyRoles',
        value: function updateMyRoles(member) {
            var teamMembers = this.getMyTeamMembers();
            var teamMember = teamMembers.find(function (m) {
                return m.user_id === member.user_id && m.team_id === member.team_id;
            });

            if (teamMember) {
                var newMember = (0, _assign2.default)({}, teamMember, {
                    roles: member.roles
                });

                _redux_store2.default.dispatch({
                    type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                    data: newMember
                });
            }
        }
    }, {
        key: 'incrementMessages',
        value: function incrementMessages(id, channelId) {
            var channelMember = _channel_store2.default.getMyMember(channelId);
            if (channelMember && channelMember.notify_props && channelMember.notify_props.mark_unread === NotificationPrefs.MENTION) {
                return;
            }

            var member = (0, _assign2.default)({}, this.getMyTeamMembers().filter(function (m) {
                return m.team_id === id;
            })[0]);
            member.msg_count++;

            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                data: member
            });
        }
    }, {
        key: 'incrementMentionsIfNeeded',
        value: function incrementMentionsIfNeeded(id, msgProps) {
            var mentions = [];
            if (msgProps && msgProps.mentions) {
                mentions = JSON.parse(msgProps.mentions);
            }

            if (mentions.indexOf(_user_store2.default.getCurrentId()) !== -1) {
                var _member = (0, _assign2.default)({}, this.getMyTeamMembers().filter(function (m) {
                    return m.team_id === id;
                })[0]);
                _member.mention_count++;

                _redux_store2.default.dispatch({
                    type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                    data: _member
                });
            }
        }
    }]);
    return TeamStoreClass;
}(_events2.default);

var TeamStore = new TeamStoreClass();

TeamStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case ActionTypes.RECEIVED_MY_TEAM:
            TeamStore.saveMyTeam(action.team);
            break;
        case ActionTypes.RECEIVED_TEAM:
            TeamStore.saveTeam(action.team);
            break;
        case ActionTypes.CREATED_TEAM:
            TeamStore.saveTeam(action.team);
            TeamStore.appendMyTeamMember(action.member);
            break;
        case ActionTypes.UPDATE_TEAM:
            TeamStore.saveTeam(action.team);
            break;
        case ActionTypes.RECEIVED_ALL_TEAMS:
            TeamStore.saveTeams(action.teams);
            break;
        case ActionTypes.RECEIVED_MY_TEAM_MEMBERS:
            TeamStore.saveMyTeamMembers(action.team_members);
            break;
        case ActionTypes.RECEIVED_MY_TEAMS_UNREAD:
            TeamStore.saveMyTeamMembersUnread(action.team_members);
            break;
        case ActionTypes.RECEIVED_ALL_TEAM_LISTINGS:
            TeamStore.saveTeamListings(action.teams);
            break;
        case ActionTypes.RECEIVED_MEMBERS_IN_TEAM:
            TeamStore.saveMembersInTeam(action.team_members);
            break;
        case ActionTypes.RECEIVED_TEAM_STATS:
            TeamStore.saveStats(action.team_id, action.stats);
            break;
        default:
    }
});

TeamStore.setMaxListeners(15);

window.TeamStore = TeamStore;
exports.default = TeamStore;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = __webpack_require__(2181);

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = __webpack_require__(2252);

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = __webpack_require__(2277);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = __webpack_require__(2278);

var _hover3 = _interopRequireDefault(_hover2);

var _active = __webpack_require__(2279);

var _active2 = _interopRequireDefault(_active);

var _loop2 = __webpack_require__(2280);

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.default = ReactCSS;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendPasswordResetEmail = exports.savePreference = exports.savePreferences = exports.loadMyTeamMembers = exports.loadProfiles = exports.uploadProfileImage = exports.webLoginByLdap = exports.webLogin = exports.createUserWithInvite = exports.loginById = exports.resendVerification = exports.resetPassword = exports.verifyEmail = exports.updatePassword = exports.updateActive = exports.checkMfa = exports.deactivateMfa = exports.activateMfa = exports.updateUserRoles = exports.updateUserNotifyProps = exports.generateMfaSecret = exports.updateUser = exports.autocompleteUsers = exports.autocompleteUsersInTeam = exports.autocompleteUsersInChannel = exports.searchUsersNotInTeam = exports.searchUsers = exports.saveTheme = exports.loadProfilesForDM = exports.loadProfilesForGM = exports.loadNewGMIfNeeded = exports.loadNewDMIfNeeded = exports.loadProfilesWithoutTeam = exports.loadProfilesAndTeamMembersAndChannelMembers = exports.loadProfilesAndTeamMembers = exports.switchFromLdapToEmail = exports.loadMeAndConfig = exports.loadMe = undefined;

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(283);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var loadMe = exports.loadMe = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return UserActions.loadMe()(dispatch, getState);

                    case 2:
                        (0, _global_actions.loadCurrentLocale)();

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function loadMe() {
        return _ref.apply(this, arguments);
    };
}();

var loadMeAndConfig = exports.loadMeAndConfig = function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(callback) {
        var _ref3, config, promises;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _general.getClientConfig)()(_redux_store2.default.dispatch, _redux_store2.default.getState);

                    case 2:
                        _ref3 = _context2.sent;
                        config = _ref3.data;
                        promises = [];


                        if (document.cookie.indexOf('MMUSERID=') > -1) {
                            if (global.window && global.window.analytics) {
                                global.window.analytics.identify(config.DiagnosticId, {}, {
                                    context: {
                                        ip: '0.0.0.0'
                                    },
                                    page: {
                                        path: '',
                                        referrer: '',
                                        search: '',
                                        title: '',
                                        url: ''
                                    },
                                    anonymousId: '00000000000000000000000000'
                                });
                            }

                            promises.push(loadMe());
                        }

                        promises.push((0, _general.getLicenseConfig)()(_redux_store2.default.dispatch, _redux_store2.default.getState));

                        _promise2.default.all(promises).then(callback);

                    case 8:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function loadMeAndConfig(_x) {
        return _ref2.apply(this, arguments);
    };
}();

var switchFromLdapToEmail = exports.switchFromLdapToEmail = function () {
    var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(email, password, token, ldapPassword, success, error) {
        var _ref5, data, err;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return UserActions.switchLdapToEmail(ldapPassword, email, password, token)(dispatch, getState);

                    case 2:
                        _ref5 = _context3.sent;
                        data = _ref5.data;
                        err = _ref5.error;


                        if (data) {
                            if (success) {
                                success(data);
                            }
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function switchFromLdapToEmail(_x2, _x3, _x4, _x5, _x6, _x7) {
        return _ref4.apply(this, arguments);
    };
}();

var loadProfilesAndTeamMembers = exports.loadProfilesAndTeamMembers = function () {
    var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(page, perPage) {
        var teamId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _team_store2.default.getCurrentId();
        var success = arguments[3];

        var _ref7, data;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return UserActions.getProfilesInTeam(teamId, page, perPage)(dispatch, getState);

                    case 2:
                        _ref7 = _context4.sent;
                        data = _ref7.data;

                        loadTeamMembersForProfilesList(data, teamId, success);
                        (0, _status_actions.loadStatusesForProfilesList)(data);

                    case 6:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function loadProfilesAndTeamMembers(_x8, _x9) {
        return _ref6.apply(this, arguments);
    };
}();

var loadProfilesAndTeamMembersAndChannelMembers = exports.loadProfilesAndTeamMembersAndChannelMembers = function () {
    var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(page, perPage) {
        var teamId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _team_store2.default.getCurrentId();
        var channelId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _channel_store2.default.getCurrentId();
        var success = arguments[4];
        var error = arguments[5];

        var _ref9, data;

        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return UserActions.getProfilesInChannel(channelId, page, perPage)(dispatch, getState);

                    case 2:
                        _ref9 = _context5.sent;
                        data = _ref9.data;


                        loadTeamMembersForProfilesList(data, teamId, function () {
                            loadChannelMembersForProfilesList(data, channelId, success, error);
                            (0, _status_actions.loadStatusesForProfilesList)(data);
                        });

                    case 5:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function loadProfilesAndTeamMembersAndChannelMembers(_x11, _x12) {
        return _ref8.apply(this, arguments);
    };
}();

var loadProfilesWithoutTeam = exports.loadProfilesWithoutTeam = function () {
    var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(page, perPage, success) {
        var _ref11, data;

        return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return UserActions.getProfilesWithoutTeam(page, perPage)(dispatch, getState);

                    case 2:
                        _ref11 = _context6.sent;
                        data = _ref11.data;

                        (0, _status_actions.loadStatusesForProfilesMap)(data);

                        if (success) {
                            success(data);
                        }

                    case 6:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function loadProfilesWithoutTeam(_x16, _x17, _x18) {
        return _ref10.apply(this, arguments);
    };
}();

var loadTeamMembersForProfiles = function () {
    var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(userIds, teamId, success, error) {
        var _ref13, data, err;

        return _regenerator2.default.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return (0, _teams.getTeamMembersByIds)(teamId, userIds)(dispatch, getState);

                    case 2:
                        _ref13 = _context7.sent;
                        data = _ref13.data;
                        err = _ref13.error;


                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function loadTeamMembersForProfiles(_x19, _x20, _x21, _x22) {
        return _ref12.apply(this, arguments);
    };
}();

var loadNewDMIfNeeded = exports.loadNewDMIfNeeded = function () {
    var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(channelId) {
        var checkPreference, channel, _ref15, data;

        return _regenerator2.default.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        checkPreference = function checkPreference(channel) {
                            var userId = Utils.getUserIdFromChannelName(channel);

                            if (!userId) {
                                return;
                            }

                            var pref = _preference_store2.default.getBool(_constants2.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, userId, false);
                            if (pref === false) {
                                var now = Utils.getTimestamp();
                                _preference_store2.default.setPreference(_constants2.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, userId, 'true');
                                _preference_store2.default.setPreference(_constants2.Preferences.CATEGORY_CHANNEL_OPEN_TIME, channelId, now.toString());
                                var currentUserId = _user_store2.default.getCurrentId();
                                (0, _preferences.savePreferences)(currentUserId, [{ user_id: currentUserId, category: _constants2.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, name: userId, value: 'true' }, { user_id: currentUserId, category: _constants2.Preferences.CATEGORY_CHANNEL_OPEN_TIME, name: channelId, value: now.toString() }])(dispatch, getState);
                                loadProfilesForDM();
                            }
                        };

                        channel = _channel_store2.default.get(channelId);

                        if (!channel) {
                            _context8.next = 6;
                            break;
                        }

                        checkPreference(channel);
                        _context8.next = 11;
                        break;

                    case 6:
                        _context8.next = 8;
                        return (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState);

                    case 8:
                        _ref15 = _context8.sent;
                        data = _ref15.data;

                        if (data) {
                            checkPreference(data.channel);
                        }

                    case 11:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function loadNewDMIfNeeded(_x27) {
        return _ref14.apply(this, arguments);
    };
}();

var loadNewGMIfNeeded = exports.loadNewGMIfNeeded = function () {
    var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(channelId) {
        var checkPreference, channel;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        checkPreference = function checkPreference() {
                            var pref = _preference_store2.default.getBool(_constants2.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channelId, false);
                            if (pref === false) {
                                _preference_store2.default.setPreference(_constants2.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channelId, 'true');
                                var currentUserId = _user_store2.default.getCurrentId();
                                (0, _preferences.savePreferences)(currentUserId, [{ user_id: currentUserId, category: _constants2.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, name: channelId, value: 'true' }])(dispatch, getState);
                                loadProfilesForGM();
                            }
                        };

                        channel = _channel_store2.default.get(channelId);

                        if (channel) {
                            _context9.next = 5;
                            break;
                        }

                        _context9.next = 5;
                        return (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState);

                    case 5:
                        checkPreference();

                    case 6:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function loadNewGMIfNeeded(_x28) {
        return _ref16.apply(this, arguments);
    };
}();

var loadProfilesForGM = exports.loadProfilesForGM = function () {
    var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
        var channels, newPreferences, i, channel, isVisible, member, currentUserId;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        channels = _channel_store2.default.getChannels();
                        newPreferences = [];
                        i = 0;

                    case 3:
                        if (!(i < channels.length)) {
                            _context10.next = 20;
                            break;
                        }

                        channel = channels[i];

                        if (!(channel.type !== _constants2.Constants.GM_CHANNEL)) {
                            _context10.next = 7;
                            break;
                        }

                        return _context10.abrupt('continue', 17);

                    case 7:
                        if (!(_user_store2.default.getProfileListInChannel(channel.id).length >= _constants2.Constants.MIN_USERS_IN_GM)) {
                            _context10.next = 9;
                            break;
                        }

                        return _context10.abrupt('continue', 17);

                    case 9:
                        isVisible = _preference_store2.default.getBool(_constants2.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channel.id);

                        if (isVisible) {
                            _context10.next = 15;
                            break;
                        }

                        member = _channel_store2.default.getMyMember(channel.id);

                        if (!(!member || member.mention_count === 0 && member.msg_count >= channel.total_msg_count)) {
                            _context10.next = 14;
                            break;
                        }

                        return _context10.abrupt('continue', 17);

                    case 14:

                        newPreferences.push({
                            user_id: _user_store2.default.getCurrentId(),
                            category: _constants2.Preferences.CATEGORY_GROUP_CHANNEL_SHOW,
                            name: channel.id,
                            value: 'true'
                        });

                    case 15:
                        _context10.next = 17;
                        return dispatch(UserActions.getProfilesInChannel(channel.id, 0, _constants2.Constants.MAX_USERS_IN_GM));

                    case 17:
                        i++;
                        _context10.next = 3;
                        break;

                    case 20:

                        if (newPreferences.length > 0) {
                            currentUserId = _user_store2.default.getCurrentId();

                            (0, _preferences.savePreferences)(currentUserId, newPreferences)(dispatch, getState);
                        }

                    case 21:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function loadProfilesForGM() {
        return _ref17.apply(this, arguments);
    };
}();

var loadProfilesForDM = exports.loadProfilesForDM = function () {
    var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
        var channels, newPreferences, profilesToLoad, profileIds, i, channel, teammateId, isVisible, member, currentUserId;
        return _regenerator2.default.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        channels = _channel_store2.default.getChannels();
                        newPreferences = [];
                        profilesToLoad = [];
                        profileIds = [];
                        i = 0;

                    case 5:
                        if (!(i < channels.length)) {
                            _context11.next = 21;
                            break;
                        }

                        channel = channels[i];

                        if (!(channel.type !== _constants2.Constants.DM_CHANNEL)) {
                            _context11.next = 9;
                            break;
                        }

                        return _context11.abrupt('continue', 18);

                    case 9:
                        teammateId = channel.name.replace(_user_store2.default.getCurrentId(), '').replace('__', '');
                        isVisible = _preference_store2.default.getBool(_constants2.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, teammateId);

                        if (isVisible) {
                            _context11.next = 16;
                            break;
                        }

                        member = _channel_store2.default.getMyMember(channel.id);

                        if (!(!member || member.mention_count === 0)) {
                            _context11.next = 15;
                            break;
                        }

                        return _context11.abrupt('continue', 18);

                    case 15:

                        newPreferences.push({
                            user_id: _user_store2.default.getCurrentId(),
                            category: _constants2.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW,
                            name: teammateId,
                            value: 'true'
                        });

                    case 16:

                        if (!_user_store2.default.hasProfile(teammateId)) {
                            profilesToLoad.push(teammateId);
                        }
                        profileIds.push(teammateId);

                    case 18:
                        i++;
                        _context11.next = 5;
                        break;

                    case 21:

                        if (newPreferences.length > 0) {
                            currentUserId = _user_store2.default.getCurrentId();

                            (0, _preferences.savePreferences)(currentUserId, newPreferences)(dispatch, getState);
                        }

                        if (!(profilesToLoad.length > 0)) {
                            _context11.next = 25;
                            break;
                        }

                        _context11.next = 25;
                        return UserActions.getProfilesByIds(profilesToLoad)(dispatch, getState);

                    case 25:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function loadProfilesForDM() {
        return _ref18.apply(this, arguments);
    };
}();

var saveTheme = exports.saveTheme = function () {
    var _ref19 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(teamId, theme, cb) {
        var currentUserId, preference;
        return _regenerator2.default.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        currentUserId = _user_store2.default.getCurrentId();
                        preference = [{
                            user_id: currentUserId,
                            category: _constants2.Preferences.CATEGORY_THEME,
                            name: teamId,
                            value: (0, _stringify2.default)(theme)
                        }];
                        _context12.next = 4;
                        return (0, _preferences.savePreferences)(currentUserId, preference)(dispatch, getState);

                    case 4:
                        onThemeSaved(teamId, theme, cb);

                    case 5:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function saveTheme(_x29, _x30, _x31) {
        return _ref19.apply(this, arguments);
    };
}();

var searchUsers = exports.searchUsers = function () {
    var _ref20 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(term) {
        var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var success = arguments[3];

        var _ref21, data;

        return _regenerator2.default.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        _context13.next = 2;
                        return UserActions.searchProfiles(term, (0, _extends3.default)({ team_id: teamId }, options))(dispatch, getState);

                    case 2:
                        _ref21 = _context13.sent;
                        data = _ref21.data;

                        (0, _status_actions.loadStatusesForProfilesList)(data);

                        if (success) {
                            success(data);
                        }

                    case 6:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, this);
    }));

    return function searchUsers(_x32) {
        return _ref20.apply(this, arguments);
    };
}();

var searchUsersNotInTeam = exports.searchUsersNotInTeam = function () {
    var _ref22 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(term) {
        var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var success = arguments[3];

        var _ref23, data;

        return _regenerator2.default.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        _context14.next = 2;
                        return UserActions.searchProfiles(term, (0, _extends3.default)({ not_in_team_id: teamId }, options))(dispatch, getState);

                    case 2:
                        _ref23 = _context14.sent;
                        data = _ref23.data;

                        (0, _status_actions.loadStatusesForProfilesList)(data);

                        if (success) {
                            success(data);
                        }

                    case 6:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, this);
    }));

    return function searchUsersNotInTeam(_x35) {
        return _ref22.apply(this, arguments);
    };
}();

var autocompleteUsersInChannel = exports.autocompleteUsersInChannel = function () {
    var _ref24 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15(username, channelId, success) {
        var channel, teamId, _ref25, data;

        return _regenerator2.default.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        channel = _channel_store2.default.get(channelId);
                        teamId = channel ? channel.team_id : _team_store2.default.getCurrentId();
                        _context15.next = 4;
                        return UserActions.autocompleteUsers(username, teamId, channelId)(dispatch, getState);

                    case 4:
                        _ref25 = _context15.sent;
                        data = _ref25.data;

                        if (success) {
                            success(data);
                        }

                    case 7:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, this);
    }));

    return function autocompleteUsersInChannel(_x38, _x39, _x40) {
        return _ref24.apply(this, arguments);
    };
}();

var autocompleteUsersInTeam = exports.autocompleteUsersInTeam = function () {
    var _ref26 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16(username, success) {
        var _ref27, data;

        return _regenerator2.default.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        _context16.next = 2;
                        return UserActions.autocompleteUsers(username, _team_store2.default.getCurrentId())(dispatch, getState);

                    case 2:
                        _ref27 = _context16.sent;
                        data = _ref27.data;

                        if (success) {
                            success(data);
                        }

                    case 5:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, this);
    }));

    return function autocompleteUsersInTeam(_x41, _x42) {
        return _ref26.apply(this, arguments);
    };
}();

var autocompleteUsers = exports.autocompleteUsers = function () {
    var _ref28 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17(username, success) {
        var _ref29, data;

        return _regenerator2.default.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        _context17.next = 2;
                        return UserActions.autocompleteUsers(username)(dispatch, getState);

                    case 2:
                        _ref29 = _context17.sent;
                        data = _ref29.data;

                        if (success) {
                            success(data);
                        }

                    case 5:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, this);
    }));

    return function autocompleteUsers(_x43, _x44) {
        return _ref28.apply(this, arguments);
    };
}();

var updateUser = exports.updateUser = function () {
    var _ref30 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18(user, success, error) {
        var _ref31, data, err;

        return _regenerator2.default.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        _context18.next = 2;
                        return UserActions.updateMe(user)(dispatch, getState);

                    case 2:
                        _ref31 = _context18.sent;
                        data = _ref31.data;
                        err = _ref31.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context18.stop();
                }
            }
        }, _callee18, this);
    }));

    return function updateUser(_x45, _x46, _x47) {
        return _ref30.apply(this, arguments);
    };
}();

var generateMfaSecret = exports.generateMfaSecret = function () {
    var _ref32 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19(success, error) {
        var _ref33, data, err;

        return _regenerator2.default.wrap(function _callee19$(_context19) {
            while (1) {
                switch (_context19.prev = _context19.next) {
                    case 0:
                        _context19.next = 2;
                        return UserActions.generateMfaSecret(_user_store2.default.getCurrentId())(dispatch, getState);

                    case 2:
                        _ref33 = _context19.sent;
                        data = _ref33.data;
                        err = _ref33.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context19.stop();
                }
            }
        }, _callee19, this);
    }));

    return function generateMfaSecret(_x48, _x49) {
        return _ref32.apply(this, arguments);
    };
}();

var updateUserNotifyProps = exports.updateUserNotifyProps = function () {
    var _ref34 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20(props, success, error) {
        var _ref35, data, err;

        return _regenerator2.default.wrap(function _callee20$(_context20) {
            while (1) {
                switch (_context20.prev = _context20.next) {
                    case 0:
                        _context20.next = 2;
                        return UserActions.updateMe({ notify_props: props })(dispatch, getState);

                    case 2:
                        _ref35 = _context20.sent;
                        data = _ref35.data;
                        err = _ref35.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context20.stop();
                }
            }
        }, _callee20, this);
    }));

    return function updateUserNotifyProps(_x50, _x51, _x52) {
        return _ref34.apply(this, arguments);
    };
}();

var updateUserRoles = exports.updateUserRoles = function () {
    var _ref36 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21(userId, newRoles, success, error) {
        var _ref37, data, err;

        return _regenerator2.default.wrap(function _callee21$(_context21) {
            while (1) {
                switch (_context21.prev = _context21.next) {
                    case 0:
                        _context21.next = 2;
                        return UserActions.updateUserRoles(userId, newRoles)(dispatch, getState);

                    case 2:
                        _ref37 = _context21.sent;
                        data = _ref37.data;
                        err = _ref37.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context21.stop();
                }
            }
        }, _callee21, this);
    }));

    return function updateUserRoles(_x53, _x54, _x55, _x56) {
        return _ref36.apply(this, arguments);
    };
}();

var activateMfa = exports.activateMfa = function () {
    var _ref38 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee22(code, success, error) {
        var _ref39, data, err;

        return _regenerator2.default.wrap(function _callee22$(_context22) {
            while (1) {
                switch (_context22.prev = _context22.next) {
                    case 0:
                        _context22.next = 2;
                        return UserActions.updateUserMfa(_user_store2.default.getCurrentId(), true, code)(dispatch, getState);

                    case 2:
                        _ref39 = _context22.sent;
                        data = _ref39.data;
                        err = _ref39.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context22.stop();
                }
            }
        }, _callee22, this);
    }));

    return function activateMfa(_x57, _x58, _x59) {
        return _ref38.apply(this, arguments);
    };
}();

var deactivateMfa = exports.deactivateMfa = function () {
    var _ref40 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee23(success, error) {
        var _ref41, data, err;

        return _regenerator2.default.wrap(function _callee23$(_context23) {
            while (1) {
                switch (_context23.prev = _context23.next) {
                    case 0:
                        _context23.next = 2;
                        return UserActions.updateUserMfa(_user_store2.default.getCurrentId(), false)(dispatch, getState);

                    case 2:
                        _ref41 = _context23.sent;
                        data = _ref41.data;
                        err = _ref41.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context23.stop();
                }
            }
        }, _callee23, this);
    }));

    return function deactivateMfa(_x60, _x61) {
        return _ref40.apply(this, arguments);
    };
}();

var checkMfa = exports.checkMfa = function () {
    var _ref42 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee24(loginId, success, error) {
        var config, _ref43, data, err;

        return _regenerator2.default.wrap(function _callee24$(_context24) {
            while (1) {
                switch (_context24.prev = _context24.next) {
                    case 0:
                        config = (0, _general2.getConfig)(getState());

                        if (!(config.EnableMultifactorAuthentication !== 'true')) {
                            _context24.next = 4;
                            break;
                        }

                        success(false);
                        return _context24.abrupt('return');

                    case 4:
                        _context24.next = 6;
                        return UserActions.checkMfa(loginId)(dispatch, getState);

                    case 6:
                        _ref43 = _context24.sent;
                        data = _ref43.data;
                        err = _ref43.error;

                        if (data != null && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 10:
                    case 'end':
                        return _context24.stop();
                }
            }
        }, _callee24, this);
    }));

    return function checkMfa(_x62, _x63, _x64) {
        return _ref42.apply(this, arguments);
    };
}();

var updateActive = exports.updateActive = function () {
    var _ref44 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee25(userId, active, success, error) {
        var _ref45, data, err;

        return _regenerator2.default.wrap(function _callee25$(_context25) {
            while (1) {
                switch (_context25.prev = _context25.next) {
                    case 0:
                        _context25.next = 2;
                        return UserActions.updateUserActive(userId, active)(dispatch, getState);

                    case 2:
                        _ref45 = _context25.sent;
                        data = _ref45.data;
                        err = _ref45.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context25.stop();
                }
            }
        }, _callee25, this);
    }));

    return function updateActive(_x65, _x66, _x67, _x68) {
        return _ref44.apply(this, arguments);
    };
}();

var updatePassword = exports.updatePassword = function () {
    var _ref46 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee26(userId, currentPassword, newPassword, success, error) {
        var _ref47, data, err;

        return _regenerator2.default.wrap(function _callee26$(_context26) {
            while (1) {
                switch (_context26.prev = _context26.next) {
                    case 0:
                        _context26.next = 2;
                        return UserActions.updateUserPassword(userId, currentPassword, newPassword)(dispatch, getState);

                    case 2:
                        _ref47 = _context26.sent;
                        data = _ref47.data;
                        err = _ref47.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context26.stop();
                }
            }
        }, _callee26, this);
    }));

    return function updatePassword(_x69, _x70, _x71, _x72, _x73) {
        return _ref46.apply(this, arguments);
    };
}();

var verifyEmail = exports.verifyEmail = function () {
    var _ref48 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee27(token, success, error) {
        var _ref49, data, err;

        return _regenerator2.default.wrap(function _callee27$(_context27) {
            while (1) {
                switch (_context27.prev = _context27.next) {
                    case 0:
                        _context27.next = 2;
                        return UserActions.verifyUserEmail(token)(dispatch, getState);

                    case 2:
                        _ref49 = _context27.sent;
                        data = _ref49.data;
                        err = _ref49.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context27.stop();
                }
            }
        }, _callee27, this);
    }));

    return function verifyEmail(_x74, _x75, _x76) {
        return _ref48.apply(this, arguments);
    };
}();

var resetPassword = exports.resetPassword = function () {
    var _ref50 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee28(token, password, success, error) {
        var _ref51, data, err;

        return _regenerator2.default.wrap(function _callee28$(_context28) {
            while (1) {
                switch (_context28.prev = _context28.next) {
                    case 0:
                        _context28.next = 2;
                        return UserActions.resetUserPassword(token, password)(dispatch, getState);

                    case 2:
                        _ref51 = _context28.sent;
                        data = _ref51.data;
                        err = _ref51.error;

                        if (data) {
                            _browser_history.browserHistory.push('/login?extra=' + _constants2.Constants.PASSWORD_CHANGE);
                            if (success) {
                                success(data);
                            }
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context28.stop();
                }
            }
        }, _callee28, this);
    }));

    return function resetPassword(_x77, _x78, _x79, _x80) {
        return _ref50.apply(this, arguments);
    };
}();

var resendVerification = exports.resendVerification = function () {
    var _ref52 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee29(email, success, error) {
        var _ref53, data, err;

        return _regenerator2.default.wrap(function _callee29$(_context29) {
            while (1) {
                switch (_context29.prev = _context29.next) {
                    case 0:
                        _context29.next = 2;
                        return UserActions.sendVerificationEmail(email)(dispatch, getState);

                    case 2:
                        _ref53 = _context29.sent;
                        data = _ref53.data;
                        err = _ref53.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context29.stop();
                }
            }
        }, _callee29, this);
    }));

    return function resendVerification(_x81, _x82, _x83) {
        return _ref52.apply(this, arguments);
    };
}();

var loginById = exports.loginById = function () {
    var _ref54 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee30(userId, password, mfaToken, success, error) {
        var _ref55, ok, err;

        return _regenerator2.default.wrap(function _callee30$(_context30) {
            while (1) {
                switch (_context30.prev = _context30.next) {
                    case 0:
                        _context30.next = 2;
                        return UserActions.loginById(userId, password, mfaToken)(dispatch, getState);

                    case 2:
                        _ref55 = _context30.sent;
                        ok = _ref55.data;
                        err = _ref55.error;

                        if (!(ok && success)) {
                            _context30.next = 9;
                            break;
                        }

                        success();
                        _context30.next = 14;
                        break;

                    case 9:
                        if (!(err && error)) {
                            _context30.next = 14;
                            break;
                        }

                        if (!(err.server_error_id === 'api.context.mfa_required.app_error')) {
                            _context30.next = 13;
                            break;
                        }

                        if (success) {
                            success();
                        }
                        return _context30.abrupt('return');

                    case 13:
                        error((0, _extends3.default)({ id: err.server_error_id }, err));

                    case 14:
                    case 'end':
                        return _context30.stop();
                }
            }
        }, _callee30, this);
    }));

    return function loginById(_x84, _x85, _x86, _x87, _x88) {
        return _ref54.apply(this, arguments);
    };
}();

var createUserWithInvite = exports.createUserWithInvite = function () {
    var _ref56 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee31(user, data, emailHash, inviteId, success, error) {
        var _ref57, resp, err;

        return _regenerator2.default.wrap(function _callee31$(_context31) {
            while (1) {
                switch (_context31.prev = _context31.next) {
                    case 0:
                        _context31.next = 2;
                        return UserActions.createUser(user, data, emailHash, inviteId)(dispatch, getState);

                    case 2:
                        _ref57 = _context31.sent;
                        resp = _ref57.data;
                        err = _ref57.error;

                        if (resp && success) {
                            success(resp);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context31.stop();
                }
            }
        }, _callee31, this);
    }));

    return function createUserWithInvite(_x89, _x90, _x91, _x92, _x93, _x94) {
        return _ref56.apply(this, arguments);
    };
}();

var webLogin = exports.webLogin = function () {
    var _ref58 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee32(loginId, password, token, success, error) {
        var _ref59, ok, err;

        return _regenerator2.default.wrap(function _callee32$(_context32) {
            while (1) {
                switch (_context32.prev = _context32.next) {
                    case 0:
                        _context32.next = 2;
                        return UserActions.login(loginId, password, token)(dispatch, getState);

                    case 2:
                        _ref59 = _context32.sent;
                        ok = _ref59.data;
                        err = _ref59.error;

                        if (!(ok && success)) {
                            _context32.next = 9;
                            break;
                        }

                        success();
                        _context32.next = 14;
                        break;

                    case 9:
                        if (!(err && error)) {
                            _context32.next = 14;
                            break;
                        }

                        if (!(err.server_error_id === 'api.context.mfa_required.app_error')) {
                            _context32.next = 13;
                            break;
                        }

                        if (success) {
                            success();
                        }
                        return _context32.abrupt('return');

                    case 13:
                        error((0, _extends3.default)({ id: err.server_error_id }, err));

                    case 14:
                    case 'end':
                        return _context32.stop();
                }
            }
        }, _callee32, this);
    }));

    return function webLogin(_x95, _x96, _x97, _x98, _x99) {
        return _ref58.apply(this, arguments);
    };
}();

var webLoginByLdap = exports.webLoginByLdap = function () {
    var _ref60 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee33(loginId, password, token, success, error) {
        var _ref61, ok, err;

        return _regenerator2.default.wrap(function _callee33$(_context33) {
            while (1) {
                switch (_context33.prev = _context33.next) {
                    case 0:
                        _context33.next = 2;
                        return UserActions.login(loginId, password, token, true)(dispatch, getState);

                    case 2:
                        _ref61 = _context33.sent;
                        ok = _ref61.data;
                        err = _ref61.error;

                        if (!(ok && success)) {
                            _context33.next = 9;
                            break;
                        }

                        success();
                        _context33.next = 14;
                        break;

                    case 9:
                        if (!(err && error)) {
                            _context33.next = 14;
                            break;
                        }

                        if (!(err.server_error_id === 'api.context.mfa_required.app_error')) {
                            _context33.next = 13;
                            break;
                        }

                        if (success) {
                            success();
                        }
                        return _context33.abrupt('return');

                    case 13:
                        error((0, _extends3.default)({ id: err.server_error_id }, err));

                    case 14:
                    case 'end':
                        return _context33.stop();
                }
            }
        }, _callee33, this);
    }));

    return function webLoginByLdap(_x100, _x101, _x102, _x103, _x104) {
        return _ref60.apply(this, arguments);
    };
}();

var uploadProfileImage = exports.uploadProfileImage = function () {
    var _ref62 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee34(userPicture, success, error) {
        var _ref63, data, err;

        return _regenerator2.default.wrap(function _callee34$(_context34) {
            while (1) {
                switch (_context34.prev = _context34.next) {
                    case 0:
                        _context34.next = 2;
                        return UserActions.uploadProfileImage(Selectors.getCurrentUserId(getState()), userPicture)(dispatch, getState);

                    case 2:
                        _ref63 = _context34.sent;
                        data = _ref63.data;
                        err = _ref63.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context34.stop();
                }
            }
        }, _callee34, this);
    }));

    return function uploadProfileImage(_x105, _x106, _x107) {
        return _ref62.apply(this, arguments);
    };
}();

var loadProfiles = exports.loadProfiles = function () {
    var _ref64 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee35(page, perPage, success) {
        var _ref65, data;

        return _regenerator2.default.wrap(function _callee35$(_context35) {
            while (1) {
                switch (_context35.prev = _context35.next) {
                    case 0:
                        _context35.next = 2;
                        return UserActions.getProfiles(page, perPage)(dispatch, getState);

                    case 2:
                        _ref65 = _context35.sent;
                        data = _ref65.data;

                        if (success) {
                            success(data);
                        }

                    case 5:
                    case 'end':
                        return _context35.stop();
                }
            }
        }, _callee35, this);
    }));

    return function loadProfiles(_x108, _x109, _x110) {
        return _ref64.apply(this, arguments);
    };
}();

var loadMyTeamMembers = exports.loadMyTeamMembers = function () {
    var _ref66 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee36() {
        return _regenerator2.default.wrap(function _callee36$(_context36) {
            while (1) {
                switch (_context36.prev = _context36.next) {
                    case 0:
                        _context36.next = 2;
                        return (0, _teams.getMyTeamMembers)()(dispatch, getState);

                    case 2:
                        (0, _teams.getMyTeamUnreads)()(dispatch, getState);

                    case 3:
                    case 'end':
                        return _context36.stop();
                }
            }
        }, _callee36, this);
    }));

    return function loadMyTeamMembers() {
        return _ref66.apply(this, arguments);
    };
}();

var savePreferences = exports.savePreferences = function () {
    var _ref67 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee37(prefs, callback) {
        var currentUserId;
        return _regenerator2.default.wrap(function _callee37$(_context37) {
            while (1) {
                switch (_context37.prev = _context37.next) {
                    case 0:
                        currentUserId = _user_store2.default.getCurrentId();
                        _context37.next = 3;
                        return (0, _preferences.savePreferences)(currentUserId, prefs)(dispatch, getState);

                    case 3:
                        callback();

                    case 4:
                    case 'end':
                        return _context37.stop();
                }
            }
        }, _callee37, this);
    }));

    return function savePreferences(_x111, _x112) {
        return _ref67.apply(this, arguments);
    };
}();

var savePreference = exports.savePreference = function () {
    var _ref68 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee38(category, name, value) {
        var currentUserId;
        return _regenerator2.default.wrap(function _callee38$(_context38) {
            while (1) {
                switch (_context38.prev = _context38.next) {
                    case 0:
                        currentUserId = _user_store2.default.getCurrentId();
                        return _context38.abrupt('return', (0, _preferences.savePreferences)(currentUserId, [{ user_id: currentUserId, category: category, name: name, value: value }])(dispatch, getState));

                    case 2:
                    case 'end':
                        return _context38.stop();
                }
            }
        }, _callee38, this);
    }));

    return function savePreference(_x113, _x114, _x115) {
        return _ref68.apply(this, arguments);
    };
}();

var sendPasswordResetEmail = exports.sendPasswordResetEmail = function () {
    var _ref71 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee40(email, success, error) {
        var _ref72, data, err;

        return _regenerator2.default.wrap(function _callee40$(_context40) {
            while (1) {
                switch (_context40.prev = _context40.next) {
                    case 0:
                        _context40.next = 2;
                        return UserActions.sendPasswordResetEmail(email)(dispatch, getState);

                    case 2:
                        _ref72 = _context40.sent;
                        data = _ref72.data;
                        err = _ref72.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context40.stop();
                }
            }
        }, _callee40, this);
    }));

    return function sendPasswordResetEmail(_x118, _x119, _x120) {
        return _ref71.apply(this, arguments);
    };
}();

exports.loadTeamMembersForProfilesList = loadTeamMembersForProfilesList;
exports.loadChannelMembersForProfilesMap = loadChannelMembersForProfilesMap;
exports.loadTeamMembersAndChannelMembersForProfilesList = loadTeamMembersAndChannelMembersForProfilesList;
exports.loadChannelMembersForProfilesList = loadChannelMembersForProfilesList;
exports.loadProfilesForSidebar = loadProfilesForSidebar;
exports.revokeAllSessions = revokeAllSessions;
exports.getAuthorizedApps = getAuthorizedApps;
exports.deauthorizeOAuthApp = deauthorizeOAuthApp;
exports.getMissingProfiles = getMissingProfiles;
exports.deletePreferences = deletePreferences;
exports.autoResetStatus = autoResetStatus;

var _channels = __webpack_require__(798);

var _general = __webpack_require__(946);

var _preferences = __webpack_require__(861);

var _teams = __webpack_require__(816);

var _users = __webpack_require__(786);

var UserActions = _interopRequireWildcard(_users);

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _preferences2 = __webpack_require__(784);

var _users2 = __webpack_require__(777);

var Selectors = _interopRequireWildcard(_users2);

var _general2 = __webpack_require__(113);

var _browser_history = __webpack_require__(273);

var _channel_actions = __webpack_require__(809);

var _global_actions = __webpack_require__(778);

var _status_actions = __webpack_require__(955);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _constants2 = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

function loadTeamMembersForProfilesList(profiles) {
    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();
    var success = arguments[2];
    var error = arguments[3];

    var membersToLoad = {};
    for (var i = 0; i < profiles.length; i++) {
        var pid = profiles[i].id;

        if (!_team_store2.default.hasActiveMemberInTeam(teamId, pid)) {
            membersToLoad[pid] = true;
        }
    }

    var list = (0, _keys2.default)(membersToLoad);
    if (list.length === 0) {
        if (success) {
            success({});
        }
        return;
    }

    loadTeamMembersForProfiles(list, teamId, success, error);
}

function loadChannelMembersForProfilesMap(profiles) {
    var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _channel_store2.default.getCurrentId();
    var success = arguments[2];
    var error = arguments[3];

    var membersToLoad = {};
    for (var pid in profiles) {
        if (!profiles.hasOwnProperty(pid)) {
            continue;
        }

        if (!_channel_store2.default.hasActiveMemberInChannel(channelId, pid)) {
            membersToLoad[pid] = true;
        }
    }

    var list = (0, _keys2.default)(membersToLoad);
    if (list.length === 0) {
        if (success) {
            success({});
        }
        return;
    }

    (0, _channel_actions.getChannelMembersForUserIds)(channelId, list, success, error);
}

function loadTeamMembersAndChannelMembersForProfilesList(profiles) {
    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();
    var channelId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _channel_store2.default.getCurrentId();
    var success = arguments[3];
    var error = arguments[4];

    loadTeamMembersForProfilesList(profiles, teamId, function () {
        loadChannelMembersForProfilesList(profiles, channelId, success, error);
    }, error);
}

function loadChannelMembersForProfilesList(profiles) {
    var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _channel_store2.default.getCurrentId();
    var success = arguments[2];
    var error = arguments[3];

    var membersToLoad = {};
    for (var i = 0; i < profiles.length; i++) {
        var pid = profiles[i].id;

        if (!_channel_store2.default.hasActiveMemberInChannel(channelId, pid)) {
            membersToLoad[pid] = true;
        }
    }

    var list = (0, _keys2.default)(membersToLoad);
    if (list.length === 0) {
        if (success) {
            success({});
        }
        return;
    }

    (0, _channel_actions.getChannelMembersForUserIds)(channelId, list, success, error);
}

function loadProfilesForSidebar() {
    loadProfilesForDM();
    loadProfilesForGM();
}

function onThemeSaved(teamId, theme, onSuccess) {
    var themePreferences = _preference_store2.default.getCategory(_constants2.Preferences.CATEGORY_THEME);

    if (teamId !== '' && themePreferences.size > 1) {
        // no extra handling to be done to delete team-specific themes
        onSuccess();
        return;
    }

    var toDelete = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(themePreferences), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 1),
                name = _step$value[0];

            if (name === '' || name === teamId) {
                continue;
            }

            toDelete.push({
                user_id: _user_store2.default.getCurrentId(),
                category: _constants2.Preferences.CATEGORY_THEME,
                name: name
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (toDelete.length > 0) {
        // we're saving a new global theme so delete any team-specific ones
        var currentUserId = _user_store2.default.getCurrentId();
        (0, _preferences.deletePreferences)(currentUserId, toDelete)(dispatch, getState);
    }

    onSuccess();
}

function revokeAllSessions(userId, success, error) {
    UserActions.revokeAllSessionsForUser(userId)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateUser.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function getAuthorizedApps(success, error) {
    _client.Client4.getAuthorizedOAuthApps(getState().entities.users.currentUserId).then(function (authorizedApps) {
        if (success) {
            success(authorizedApps);
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function deauthorizeOAuthApp(appId, success, error) {
    _client.Client4.deauthorizeOAuthApp(appId).then(function () {
        if (success) {
            success();
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function getMissingProfiles(ids) {
    var missingIds = ids.filter(function (id) {
        return !_user_store2.default.hasProfile(id);
    });

    if (missingIds.length === 0) {
        return;
    }

    UserActions.getProfilesByIds(missingIds)(dispatch, getState);
}

function deletePreferences(prefs) {
    var currentUserId = _user_store2.default.getCurrentId();
    return (0, _preferences.deletePreferences)(currentUserId, prefs)(dispatch, getState);
}

function autoResetStatus() {
    var _this = this;

    return function () {
        var _ref69 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee39(doDispatch, doGetState) {
            var currentUserId, _ref70, userStatus, autoReset;

            return _regenerator2.default.wrap(function _callee39$(_context39) {
                while (1) {
                    switch (_context39.prev = _context39.next) {
                        case 0:
                            currentUserId = getState().entities.users.currentUserId;
                            _context39.next = 3;
                            return UserActions.getStatus(currentUserId)(doDispatch, doGetState);

                        case 3:
                            _ref70 = _context39.sent;
                            userStatus = _ref70.data;

                            if (userStatus.manual) {
                                _context39.next = 7;
                                break;
                            }

                            return _context39.abrupt('return', userStatus);

                        case 7:
                            autoReset = (0, _preferences2.getBool)(getState(), _constants.Preferences.CATEGORY_AUTO_RESET_MANUAL_STATUS, currentUserId, false);

                            if (!autoReset) {
                                _context39.next = 11;
                                break;
                            }

                            UserActions.setStatus({ user_id: currentUserId, status: 'online' })(doDispatch, doGetState);
                            return _context39.abrupt('return', userStatus);

                        case 11:
                            return _context39.abrupt('return', userStatus);

                        case 12:
                        case 'end':
                            return _context39.stop();
                    }
                }
            }, _callee39, _this);
        }));

        return function (_x116, _x117) {
            return _ref69.apply(this, arguments);
        };
    }();
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1652), __esModule: true };

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSortedDirectChannelIds = exports.getSortedDirectChannelWithUnreadsIds = exports.getSortedPrivateChannelIds = exports.getSortedPrivateChannelWithUnreadsIds = exports.getSortedPublicChannelIds = exports.getSortedPublicChannelWithUnreadsIds = exports.getSortedFavoriteChannelIds = exports.getSortedFavoriteChannelWithUnreadsIds = exports.getSortedUnreadChannelIds = exports.getUnreadChannelIds = exports.getChannelIdsForCurrentTeam = exports.getChannelIdsInCurrentTeam = exports.getDirectChannelIds = exports.canManageChannelMembers = exports.getUnreadsInCurrentTeam = exports.getUnreads = exports.getMembersInCurrentChannel = exports.getDefaultChannel = exports.getChannelsWithUnreadSection = exports.getChannelsByCategory = exports.getOtherChannels = exports.getMyChannels = exports.getGroupChannels = exports.getDirectChannels = exports.getChannelsNameMapInCurrentTeam = exports.getChannelsInCurrentTeam = exports.getChannelSetInCurrentTeam = exports.getCurrentChannelStats = exports.getMyChannelMember = exports.getCurrentChannel = exports.getChannel = exports.getDirectChannelsSet = exports.getMyCurrentChannelMembership = exports.getMyChannelMemberships = exports.getCurrentChannelId = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getAllChannels = getAllChannels;
exports.getAllChannelStats = getAllChannelStats;
exports.getChannelsInTeam = getChannelsInTeam;
exports.getChannelMembersInChannels = getChannelMembersInChannels;
exports.makeGetChannel = makeGetChannel;
exports.isCurrentChannelReadOnly = isCurrentChannelReadOnly;
exports.isChannelReadOnlyById = isChannelReadOnlyById;
exports.isChannelReadOnly = isChannelReadOnly;
exports.getGroupOrDirectChannelVisibility = getGroupOrDirectChannelVisibility;

var _reselect = __webpack_require__(78);

var _constants = __webpack_require__(19);

var _common = __webpack_require__(280);

var _general = __webpack_require__(113);

var _preferences = __webpack_require__(784);

var _posts = __webpack_require__(805);

var _teams = __webpack_require__(274);

var _roles = __webpack_require__(276);

var _users = __webpack_require__(777);

var _channel_utils = __webpack_require__(854);

var _helpers = __webpack_require__(117);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.getCurrentChannelId = _common.getCurrentChannelId;
exports.getMyChannelMemberships = _common.getMyChannelMemberships;
exports.getMyCurrentChannelMembership = _common.getMyCurrentChannelMembership;
function getAllChannels(state) {
    return state.entities.channels.channels;
}

function getAllChannelStats(state) {
    return state.entities.channels.stats;
}

function getChannelsInTeam(state) {
    return state.entities.channels.channelsInTeam;
}

var getDirectChannelsSet = exports.getDirectChannelsSet = (0, _reselect.createSelector)(getChannelsInTeam, function (channelsInTeam) {
    return channelsInTeam[''] || new Set();
});

function getChannelMembersInChannels(state) {
    return state.entities.channels.membersInChannel;
}

function makeGetChannel() {
    return (0, _reselect.createSelector)(getAllChannels, function (state, props) {
        return props.id;
    }, function (state) {
        return state.entities.users;
    }, _preferences.getTeammateNameDisplaySetting, function (allChannels, channelId, users, teammateNameDisplay) {
        var channel = allChannels[channelId];
        if (channel) {
            return (0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channel);
        }
        return channel;
    });
}

var getChannel = exports.getChannel = (0, _reselect.createSelector)(getAllChannels, function (state, id) {
    return id;
}, function (state) {
    return state.entities.users;
}, _preferences.getTeammateNameDisplaySetting, function (allChannels, channelId, users, teammateNameDisplay) {
    var channel = allChannels[channelId];
    if (channel) {
        return (0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channel);
    }
    return channel;
});

var getCurrentChannel = exports.getCurrentChannel = (0, _reselect.createSelector)(getAllChannels, _common.getCurrentChannelId, function (state) {
    return state.entities.users;
}, _preferences.getTeammateNameDisplaySetting, function (allChannels, currentChannelId, users, teammateNameDisplay) {
    var channel = allChannels[currentChannelId];
    if (channel) {
        return (0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channel);
    }
    return channel;
});

var getMyChannelMember = exports.getMyChannelMember = (0, _reselect.createSelector)(_common.getMyChannelMemberships, function (state, channelId) {
    return channelId;
}, function (channelMemberships, channelId) {
    return channelMemberships[channelId] || {};
});

var getCurrentChannelStats = exports.getCurrentChannelStats = (0, _reselect.createSelector)(getAllChannelStats, _common.getCurrentChannelId, function (allChannelStats, currentChannelId) {
    return allChannelStats[currentChannelId];
});

function isCurrentChannelReadOnly(state) {
    return isChannelReadOnly(state, getCurrentChannel(state));
}

function isChannelReadOnlyById(state, channelId) {
    return isChannelReadOnly(state, getChannel(state, channelId));
}

function isChannelReadOnly(state, channel) {
    return channel && channel.name === _constants.General.DEFAULT_CHANNEL && !(0, _users.isCurrentUserSystemAdmin)(state) && (0, _general.getConfig)(state).ExperimentalTownSquareIsReadOnly === 'true';
}

var getChannelSetInCurrentTeam = exports.getChannelSetInCurrentTeam = (0, _reselect.createSelector)(_teams.getCurrentTeamId, getChannelsInTeam, function (currentTeamId, channelsInTeam) {
    return channelsInTeam[currentTeamId] || [];
});

function sortAndInjectChannels(channels, channelSet, locale) {
    var currentChannels = [];
    if (typeof channelSet === 'undefined') {
        return currentChannels;
    }

    channelSet.forEach(function (c) {
        currentChannels.push(channels[c]);
    });

    return currentChannels.sort(_channel_utils.sortChannelsByDisplayName.bind(null, locale));
}

var getChannelsInCurrentTeam = exports.getChannelsInCurrentTeam = (0, _reselect.createSelector)(getAllChannels, getChannelSetInCurrentTeam, _common.getCurrentUser, function (channels, currentTeamChannelSet, currentUser) {
    var locale = 'en';
    if (currentUser && currentUser.locale) {
        locale = currentUser.locale;
    }
    return sortAndInjectChannels(channels, currentTeamChannelSet, locale);
});

var getChannelsNameMapInCurrentTeam = exports.getChannelsNameMapInCurrentTeam = (0, _reselect.createSelector)(getAllChannels, getChannelSetInCurrentTeam, function (channels, currentTeamChannelSet) {
    var channelMap = {};
    currentTeamChannelSet.forEach(function (id) {
        var channel = channels[id];
        channelMap[channel.name] = channel;
    });
    return channelMap;
});

// Returns both DMs and GMs
var getDirectChannels = exports.getDirectChannels = (0, _reselect.createSelector)(getAllChannels, getDirectChannelsSet, function (state) {
    return state.entities.users;
}, _preferences.getTeammateNameDisplaySetting, function (channels, channelSet, users, teammateNameDisplay) {
    var dmChannels = [];
    channelSet.forEach(function (c) {
        dmChannels.push((0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channels[c]));
    });
    return dmChannels;
});

// Returns only GMs
var getGroupChannels = exports.getGroupChannels = (0, _reselect.createSelector)(getAllChannels, getDirectChannelsSet, function (state) {
    return state.entities.users;
}, _preferences.getTeammateNameDisplaySetting, function (channels, channelSet, users, teammateNameDisplay) {
    var gmChannels = [];
    channelSet.forEach(function (id) {
        var channel = channels[id];
        if (channel.type === _constants.General.GM_CHANNEL) {
            gmChannels.push((0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channel));
        }
    });
    return gmChannels;
});

var getMyChannels = exports.getMyChannels = (0, _reselect.createSelector)(getChannelsInCurrentTeam, getDirectChannels, _common.getMyChannelMemberships, function (channels, directChannels, myMembers) {
    return [].concat(_toConsumableArray(channels), _toConsumableArray(directChannels)).filter(function (c) {
        return myMembers.hasOwnProperty(c.id);
    });
});

var getOtherChannels = exports.getOtherChannels = (0, _reselect.createSelector)(getChannelsInCurrentTeam, _common.getMyChannelMemberships, function (channels, myMembers) {
    return channels.filter(function (c) {
        return !myMembers.hasOwnProperty(c.id) && c.type === _constants.General.OPEN_CHANNEL;
    });
});

var getChannelsByCategory = exports.getChannelsByCategory = (0, _reselect.createSelector)(_common.getCurrentChannelId, getMyChannels, _common.getMyChannelMemberships, _general.getConfig, _preferences.getMyPreferences, _preferences.getTeammateNameDisplaySetting, function (state) {
    return state.entities.users;
}, _posts.getLastPostPerChannel, function (currentChannelId, channels, myMembers, config, myPreferences, teammateNameDisplay, usersState, lastPosts) {
    var allChannels = channels.map(function (c) {
        var channel = _extends({}, c);
        channel.isCurrent = c.id === currentChannelId;
        return channel;
    });

    return (0, _channel_utils.buildDisplayableChannelList)(usersState, allChannels, myMembers, config, myPreferences, teammateNameDisplay, lastPosts);
});

var getChannelsWithUnreadSection = exports.getChannelsWithUnreadSection = (0, _reselect.createSelector)(_common.getCurrentChannelId, getMyChannels, _common.getMyChannelMemberships, _general.getConfig, _preferences.getMyPreferences, _preferences.getTeammateNameDisplaySetting, function (state) {
    return state.entities.users;
}, _posts.getLastPostPerChannel, function (currentChannelId, channels, myMembers, config, myPreferences, teammateNameDisplay, usersState, lastPosts) {
    var allChannels = channels.map(function (c) {
        var channel = _extends({}, c);
        channel.isCurrent = c.id === currentChannelId;
        return channel;
    });

    return (0, _channel_utils.buildDisplayableChannelListWithUnreadSection)(usersState, allChannels, myMembers, config, myPreferences, teammateNameDisplay, lastPosts);
});

var getDefaultChannel = exports.getDefaultChannel = (0, _reselect.createSelector)(getAllChannels, _teams.getCurrentTeamId, function (channels, teamId) {
    return Object.values(channels).find(function (c) {
        return c.team_id === teamId && c.name === _constants.General.DEFAULT_CHANNEL;
    });
});

var getMembersInCurrentChannel = exports.getMembersInCurrentChannel = (0, _reselect.createSelector)(_common.getCurrentChannelId, getChannelMembersInChannels, function (currentChannelId, members) {
    return members[currentChannelId];
});

var getUnreads = exports.getUnreads = (0, _reselect.createSelector)(getAllChannels, _common.getMyChannelMemberships, function (channels, myMembers) {
    var messageCount = 0;
    var mentionCount = 0;
    Object.keys(myMembers).forEach(function (channelId) {
        var channel = channels[channelId];
        var m = myMembers[channelId];
        if (channel && m) {
            if (channel.type === 'D') {
                mentionCount += channel.total_msg_count - m.msg_count;
            } else if (m.mention_count > 0) {
                mentionCount += m.mention_count;
            }
            if (m.notify_props && m.notify_props.mark_unread !== 'mention' && channel.total_msg_count - m.msg_count > 0) {
                messageCount += 1;
            }
        }
    });

    return { messageCount: messageCount, mentionCount: mentionCount };
});

var getUnreadsInCurrentTeam = exports.getUnreadsInCurrentTeam = (0, _reselect.createSelector)(_common.getCurrentChannelId, getMyChannels, _common.getMyChannelMemberships, function (currentChannelId, channels, myMembers) {
    var messageCount = 0;
    var mentionCount = 0;

    channels.forEach(function (channel) {
        var m = myMembers[channel.id];
        if (m && channel.id !== currentChannelId) {
            if (channel.type === 'D') {
                mentionCount += channel.total_msg_count - m.msg_count;
            } else if (m.mention_count > 0) {
                mentionCount += m.mention_count;
            }
            if (m.notify_props && m.notify_props.mark_unread !== 'mention' && channel.total_msg_count - m.msg_count > 0) {
                messageCount += 1;
            }
        }
    });

    return { messageCount: messageCount, mentionCount: mentionCount };
});

var canManageChannelMembers = exports.canManageChannelMembers = (0, _reselect.createSelector)(getCurrentChannel, _common.getCurrentUser, _teams.getCurrentTeamMembership, _common.getMyCurrentChannelMembership, _general.getConfig, _general.getLicense, _general.hasNewPermissions, function (state) {
    return (0, _roles.haveICurrentChannelPermission)(state, { permission: _constants.Permissions.MANAGE_PRIVATE_CHANNEL_MEMBERS });
}, function (state) {
    return (0, _roles.haveICurrentChannelPermission)(state, { permission: _constants.Permissions.MANAGE_PUBLIC_CHANNEL_MEMBERS });
}, function (channel, user, teamMembership, channelMembership, config, license, newPermissions, managePrivateMembers, managePublicMembers) {
    if (channel.type === _constants.General.DM_CHANNEL || channel.type === _constants.General.GM_CHANNEL || channel.name === _constants.General.DEFAULT_CHANNEL) {
        return false;
    }

    if (newPermissions) {
        if (channel.type === _constants.General.OPEN_CHANNEL) {
            return managePublicMembers;
        } else if (channel.type === _constants.General.PRIVATE_CHANNEL) {
            return managePrivateMembers;
        }
        return true;
    }
    return (0, _channel_utils.canManageMembersOldPermissions)(channel, user, teamMembership, channelMembership, config, license);
});

var getDirectChannelIds = exports.getDirectChannelIds = (0, _helpers.createIdsSelector)(getDirectChannelsSet, function (directIds) {
    return Array.from(directIds);
});

var getChannelIdsInCurrentTeam = exports.getChannelIdsInCurrentTeam = (0, _helpers.createIdsSelector)(_teams.getCurrentTeamId, getChannelsInTeam, function (currentTeamId, channelsInTeam) {
    return Array.from(channelsInTeam[currentTeamId] || []);
});

var getChannelIdsForCurrentTeam = exports.getChannelIdsForCurrentTeam = (0, _helpers.createIdsSelector)(getChannelIdsInCurrentTeam, getDirectChannelIds, function (channels, direct) {
    return [].concat(_toConsumableArray(channels), _toConsumableArray(direct));
});

var getUnreadChannelIds = exports.getUnreadChannelIds = (0, _helpers.createIdsSelector)(getAllChannels, _common.getMyChannelMemberships, getChannelIdsForCurrentTeam, function (state) {
    var lastUnreadChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return lastUnreadChannel;
}, function (channels, members, teamChannelIds, lastUnreadChannel) {
    var unreadIds = teamChannelIds.filter(function (id) {
        var c = channels[id];
        var m = members[id];

        if (c && m) {
            var chHasUnread = c.total_msg_count - m.msg_count > 0;
            var chHasMention = m.mention_count > 0;
            if (m.notify_props && m.notify_props.mark_unread !== 'mention' && chHasUnread || chHasMention) {
                return true;
            }
        }
        return false;
    });

    if (lastUnreadChannel && !unreadIds.includes(lastUnreadChannel.id)) {
        unreadIds.push(lastUnreadChannel.id);
    }

    return unreadIds;
});

function filterUnreadChannels(unreadIds, channelIds) {
    return channelIds.filter(function (id) {
        return !unreadIds.includes(id);
    });
}

var getSortedUnreadChannelIds = exports.getSortedUnreadChannelIds = (0, _helpers.createIdsSelector)(_common.getCurrentUser, _common.getUsers, getAllChannels, _common.getMyChannelMemberships, getUnreadChannelIds, _preferences.getTeammateNameDisplaySetting, function (state) {
    var lastUnreadChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return lastUnreadChannel;
}, function (currentUser, profiles, channels, myMembers, unreadIds, settings, lastUnreadChannel) {
    // If we receive an unread for a channel and then a mention the channel
    // won't be sorted correctly until we receive a message in another channel
    if (!currentUser) {
        return [];
    }

    var locale = currentUser.locale || 'en';
    var allUnreadChannels = unreadIds.map(function (id) {
        var c = channels[id];

        if (c.type === _constants.General.DM_CHANNEL || c.type === _constants.General.GM_CHANNEL) {
            return (0, _channel_utils.completeDirectChannelDisplayName)(currentUser.id, profiles, settings, c);
        }

        return c;
    }).sort(function (a, b) {
        var aMember = myMembers[a.id];
        var bMember = myMembers[b.id];
        var aIsMention = a.type === _constants.General.DM_CHANNEL || aMember && aMember.mention_count > 0;
        var bIsMention = b.type === _constants.General.DM_CHANNEL || bMember && bMember.mention_count > 0;

        if (lastUnreadChannel && b.id === lastUnreadChannel.id && lastUnreadChannel.hadMentions) {
            bIsMention = true;
        }

        if (aIsMention === bIsMention && (0, _channel_utils.isChannelMuted)(bMember) === (0, _channel_utils.isChannelMuted)(aMember)) {
            return (0, _channel_utils.sortChannelsByDisplayName)(locale, a, b);
        } else if (aIsMention || (0, _channel_utils.isChannelMuted)(bMember) && !(0, _channel_utils.isChannelMuted)(aMember)) {
            return -1;
        }

        return 1;
    });

    return allUnreadChannels.map(function (c) {
        return c.id;
    });
});

var getSortedFavoriteChannelWithUnreadsIds = exports.getSortedFavoriteChannelWithUnreadsIds = (0, _helpers.createIdsSelector)(_common.getCurrentUser, _common.getUsers, getAllChannels, _common.getMyChannelMemberships, _preferences.getFavoritesPreferences, getChannelIdsForCurrentTeam, _preferences.getTeammateNameDisplaySetting, _general.getConfig, _preferences.getMyPreferences, _common.getCurrentChannelId, function (currentUser, profiles, channels, myMembers, favoriteIds, teamChannelIds, settings, config, prefs, currentChannelId) {
    if (!currentUser) {
        return [];
    }

    var locale = currentUser.locale || 'en';
    var favoriteChannel = favoriteIds.filter(function (id) {
        if (!myMembers[id] || !channels[id]) {
            return false;
        }

        var channel = channels[id];
        var otherUserId = (0, _channel_utils.getUserIdFromChannelName)(currentUser.id, channel.name);
        if (channel.type === _constants.General.DM_CHANNEL && !(0, _channel_utils.isDirectChannelVisible)(profiles[otherUserId] || otherUserId, config, prefs, channel, null, null, currentChannelId)) {
            return false;
        } else if (channel.type === _constants.General.GM_CHANNEL && !(0, _channel_utils.isGroupChannelVisible)(config, prefs, channel)) {
            return false;
        }

        return teamChannelIds.includes(id);
    }).map(function (id) {
        var c = channels[id];
        if (c.type === _constants.General.DM_CHANNEL || c.type === _constants.General.GM_CHANNEL) {
            return (0, _channel_utils.completeDirectChannelDisplayName)(currentUser.id, profiles, settings, c);
        }

        return c;
    }).sort(_channel_utils.sortChannelsByDisplayNameAndMuted.bind(null, locale, myMembers));
    return favoriteChannel.map(function (f) {
        return f.id;
    });
});

var getSortedFavoriteChannelIds = exports.getSortedFavoriteChannelIds = (0, _helpers.createIdsSelector)(getUnreadChannelIds, getSortedFavoriteChannelWithUnreadsIds, filterUnreadChannels);

var getSortedPublicChannelWithUnreadsIds = exports.getSortedPublicChannelWithUnreadsIds = (0, _helpers.createIdsSelector)(_common.getCurrentUser, getAllChannels, _common.getMyChannelMemberships, getChannelIdsForCurrentTeam, getSortedFavoriteChannelWithUnreadsIds, function (currentUser, channels, myMembers, teamChannelIds, favoriteIds) {
    if (!currentUser) {
        return [];
    }

    var locale = currentUser.locale || 'en';
    var publicChannels = teamChannelIds.filter(function (id) {
        if (!myMembers[id]) {
            return false;
        }
        var channel = channels[id];
        return !favoriteIds.includes(id) && teamChannelIds.includes(id) && channel.type === _constants.General.OPEN_CHANNEL;
    }).map(function (id) {
        return channels[id];
    }).sort(_channel_utils.sortChannelsByDisplayNameAndMuted.bind(null, locale, myMembers));

    return publicChannels.map(function (c) {
        return c.id;
    });
});

var getSortedPublicChannelIds = exports.getSortedPublicChannelIds = (0, _helpers.createIdsSelector)(getUnreadChannelIds, getSortedPublicChannelWithUnreadsIds, filterUnreadChannels);

var getSortedPrivateChannelWithUnreadsIds = exports.getSortedPrivateChannelWithUnreadsIds = (0, _helpers.createIdsSelector)(_common.getCurrentUser, getAllChannels, _common.getMyChannelMemberships, getChannelIdsForCurrentTeam, getSortedFavoriteChannelWithUnreadsIds, function (currentUser, channels, myMembers, teamChannelIds, favoriteIds) {
    if (!currentUser) {
        return [];
    }

    var locale = currentUser.locale || 'en';
    var privateChannels = teamChannelIds.filter(function (id) {
        if (!myMembers[id]) {
            return false;
        }
        var channel = channels[id];
        return !favoriteIds.includes(id) && teamChannelIds.includes(id) && channel.type === _constants.General.PRIVATE_CHANNEL;
    }).map(function (id) {
        return channels[id];
    }).sort(_channel_utils.sortChannelsByDisplayNameAndMuted.bind(null, locale, myMembers));
    return privateChannels.map(function (c) {
        return c.id;
    });
});

var getSortedPrivateChannelIds = exports.getSortedPrivateChannelIds = (0, _helpers.createIdsSelector)(getUnreadChannelIds, getSortedPrivateChannelWithUnreadsIds, filterUnreadChannels);

var getSortedDirectChannelWithUnreadsIds = exports.getSortedDirectChannelWithUnreadsIds = (0, _helpers.createIdsSelector)(_common.getCurrentUser, _common.getUsers, getAllChannels, _common.getMyChannelMemberships, _preferences.getVisibleTeammate, _preferences.getVisibleGroupIds, getSortedFavoriteChannelWithUnreadsIds, _preferences.getTeammateNameDisplaySetting, _general.getConfig, _preferences.getMyPreferences, _posts.getLastPostPerChannel, _common.getCurrentChannelId, function (currentUser, profiles, channels, myMembers, teammates, groupIds, favoriteIds, settings, config, preferences, lastPosts, currentChannelId) {
    if (!currentUser) {
        return [];
    }

    var locale = currentUser.locale || 'en';
    var channelValues = Object.values(channels);
    var directChannelsIds = [];
    teammates.reduce(function (result, teammateId) {
        var name = (0, _channel_utils.getDirectChannelName)(currentUser.id, teammateId);
        var channel = channelValues.find(function (c) {
            return c.name === name;
        }); //eslint-disable-line max-nested-callbacks
        if (channel) {
            var lastPost = lastPosts[channel.id];
            var otherUser = profiles[(0, _channel_utils.getUserIdFromChannelName)(currentUser.id, channel.name)];
            if (!favoriteIds.includes(channel.id) && !(0, _channel_utils.isAutoClosed)(config, preferences, channel, lastPost ? lastPost.create_at : 0, otherUser ? otherUser.delete_at : 0, currentChannelId)) {
                result.push(channel.id);
            }
        }
        return result;
    }, directChannelsIds);
    var directChannels = groupIds.filter(function (id) {
        var channel = channels[id];
        if (channel) {
            var lastPost = lastPosts[channel.id];
            return !favoriteIds.includes(id) && !(0, _channel_utils.isAutoClosed)(config, preferences, channels[id], lastPost ? lastPost.create_at : 0, currentChannelId);
        }

        return false;
    }).concat(directChannelsIds).map(function (id) {
        var channel = channels[id];
        return (0, _channel_utils.completeDirectChannelDisplayName)(currentUser.id, profiles, settings, channel);
    }).sort(_channel_utils.sortChannelsByDisplayNameAndMuted.bind(null, locale, myMembers));
    return directChannels.map(function (c) {
        return c.id;
    });
});

var getSortedDirectChannelIds = exports.getSortedDirectChannelIds = (0, _helpers.createIdsSelector)(getUnreadChannelIds, getSortedDirectChannelWithUnreadsIds, filterUnreadChannels);

function getGroupOrDirectChannelVisibility(state, channelId) {
    return (0, _channel_utils.isGroupOrDirectChannelVisible)(getChannel(state, channelId), (0, _common.getMyChannelMemberships)(state), (0, _general.getConfig)(state), (0, _preferences.getMyPreferences)(state), (0, _common.getCurrentUser)(state).id, (0, _common.getUsers)(state), (0, _posts.getLastPostPerChannel)(state));
}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTheme = exports.getTeammateNameDisplaySetting = exports.getVisibleGroupIds = exports.getVisibleTeammate = undefined;
exports.getMyPreferences = getMyPreferences;
exports.get = get;
exports.getBool = getBool;
exports.getInt = getInt;
exports.makeGetCategory = makeGetCategory;
exports.getDirectShowPreferences = getDirectShowPreferences;
exports.getGroupShowPreferences = getGroupShowPreferences;
exports.getFavoritesPreferences = getFavoritesPreferences;
exports.makeGetStyleFromTheme = makeGetStyleFromTheme;

var _reselect = __webpack_require__(78);

var _constants = __webpack_require__(19);

var _general = __webpack_require__(113);

var _teams = __webpack_require__(274);

var _helpers = __webpack_require__(117);

var _preference_utils = __webpack_require__(284);

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getMyPreferences(state) {
    return state.entities.preferences.myPreferences;
}

function get(state, category, name) {
    var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var key = (0, _preference_utils.getPreferenceKey)(category, name);
    var prefs = getMyPreferences(state);

    if (!(key in prefs)) {
        return defaultValue;
    }

    return prefs[key].value;
}

function getBool(state, category, name) {
    var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var value = get(state, category, name, String(defaultValue));

    return value !== 'false';
}

function getInt(state, category, name) {
    var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var value = get(state, category, name, defaultValue);

    return parseInt(value, 10);
}

function makeGetCategory() {
    return (0, _reselect.createSelector)(getMyPreferences, function (state, category) {
        return category;
    }, function (preferences, category) {
        var prefix = category + '--';
        var prefsInCategory = [];

        for (var key in preferences) {
            if (key.startsWith(prefix)) {
                prefsInCategory.push(preferences[key]);
            }
        }

        return prefsInCategory;
    });
}

var getDirectShowCategory = makeGetCategory();

function getDirectShowPreferences(state) {
    return getDirectShowCategory(state, _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);
}

var getGroupShowCategory = makeGetCategory();

function getGroupShowPreferences(state) {
    return getGroupShowCategory(state, _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW);
}

var getFavoritesCategory = makeGetCategory();

function getFavoritesPreferences(state) {
    var favorites = getFavoritesCategory(state, _constants.Preferences.CATEGORY_FAVORITE_CHANNEL);
    return favorites.filter(function (f) {
        return f.value === 'true';
    }).map(function (f) {
        return f.name;
    });
}

var getVisibleTeammate = exports.getVisibleTeammate = (0, _reselect.createSelector)(getDirectShowPreferences, function (direct) {
    return direct.filter(function (dm) {
        return dm.value === 'true' && dm.name;
    }).map(function (dm) {
        return dm.name;
    });
});

var getVisibleGroupIds = exports.getVisibleGroupIds = (0, _reselect.createSelector)(getGroupShowPreferences, function (groups) {
    return groups.filter(function (dm) {
        return dm.value === 'true' && dm.name;
    }).map(function (dm) {
        return dm.name;
    });
});

var getTeammateNameDisplaySetting = exports.getTeammateNameDisplaySetting = (0, _reselect.createSelector)(_general.getConfig, getMyPreferences, function (config, preferences) {
    var key = (0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.NAME_NAME_FORMAT);
    if (preferences[key]) {
        return preferences[key].value;
    } else if (config.TeammateNameDisplay) {
        return config.TeammateNameDisplay;
    }
    return _constants.General.TEAMMATE_NAME_DISPLAY.SHOW_USERNAME;
});

var getThemePreference = (0, _reselect.createSelector)(getMyPreferences, _teams.getCurrentTeamId, function (myPreferences, currentTeamId) {
    // Prefer the user's current team-specific theme over the user's current global theme
    var themePreference = void 0;

    if (currentTeamId) {
        themePreference = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_THEME, currentTeamId)];
    }

    if (!themePreference) {
        themePreference = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_THEME, '')];
    }

    return themePreference;
});

var getDefaultTheme = (0, _reselect.createSelector)(_general.getConfig, function (config) {
    if (config.DefaultTheme) {
        var theme = _constants.Preferences.THEMES[config.DefaultTheme];
        if (theme) {
            return theme;
        }
    }

    // If no config.DefaultTheme or value doesn't refer to a valid theme name...
    return _constants.Preferences.THEMES.default;
});

var getTheme = exports.getTheme = (0, _helpers.createShallowSelector)(getThemePreference, getDefaultTheme, function (themePreference, defaultTheme) {
    var theme = void 0;
    if (themePreference) {
        theme = themePreference.value;
    } else {
        theme = defaultTheme;
    }

    if (typeof theme === 'string') {
        // A custom theme will be a JSON-serialized object stored in a preference
        theme = JSON.parse(theme);
    }

    // At this point, the theme should be a plain object

    // If this is a system theme, find it in case the user's theme is missing any fields
    if (theme.type && theme.type !== 'custom') {
        var match = Object.values(_constants.Preferences.THEMES).find(function (v) {
            return v.type === theme.type;
        });
        if (match) {
            return match;
        }
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(defaultTheme)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (theme[key]) {
                // Fix a case where upper case theme colours are rendered as black
                theme[key] = theme[key].toLowerCase();
            }
        }

        // Backwards compatability with old name
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (!theme.mentionBg) {
        theme.mentionBg = theme.mentionBj;
    }

    return Object.assign({}, defaultTheme, theme);
});

function makeGetStyleFromTheme() {
    return (0, _reselect.createSelector)(getTheme, function (state, getStyleFromTheme) {
        return getStyleFromTheme;
    }, function (theme, getStyleFromTheme) {
        return getStyleFromTheme(theme);
    });
}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _reduxBatchedActions = __webpack_require__(921);

var _action_types = __webpack_require__(3);

var _channels = __webpack_require__(798);

var _channels2 = __webpack_require__(783);

var Selectors = _interopRequireWildcard(_channels2);

var _common = __webpack_require__(280);

var _post_utils = __webpack_require__(281);

var _general = __webpack_require__(113);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _constants = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChannelUtils; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Utils;
var NotificationPrefs = _constants.Constants.NotificationPrefs;

var CHANGE_EVENT = 'change';
var STATS_EVENT = 'stats';
var LAST_VIEWED_EVENT = 'last_viewed';

var ChannelStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(ChannelStoreClass, _EventEmitter);

    function ChannelStoreClass(props) {
        (0, _classCallCheck3.default)(this, ChannelStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelStoreClass.__proto__ || (0, _getPrototypeOf2.default)(ChannelStoreClass)).call(this, props));

        _this.setMaxListeners(600);
        _this.clear();

        _this.entities = _redux_store2.default.getState().entities.channels;

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.channels;
            var doEmit = false;

            var entities = _this.entities;
            _this.entities = newEntities;

            if (newEntities.currentChannelId !== entities.currentChannelId) {
                doEmit = true;
            }

            if (newEntities.channels !== entities.channels) {
                _this.setUnreadCountsByChannels((0, _values2.default)(newEntities.channels));
                doEmit = true;
            }

            if (newEntities.myMembers !== entities.myMembers) {
                _this.setUnreadCountsByMembers((0, _values2.default)(newEntities.myMembers));
                _this.emitLastViewed();
                doEmit = true;
            }

            if (newEntities.membersInChannel !== entities.membersInChannel) {
                doEmit = true;
            }

            if (newEntities.stats !== entities.stats) {
                _this.emitStatsChange();
            }

            if (doEmit) {
                _this.emitChange();
            }
        });
        return _this;
    }

    (0, _createClass3.default)(ChannelStoreClass, [{
        key: 'clear',
        value: function clear() {
            this.postMode = this.POST_MODE_CHANNEL;
            this.unreadCounts = {};
        }
    }, {
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitStatsChange',
        value: function emitStatsChange() {
            this.emit(STATS_EVENT);
        }
    }, {
        key: 'addStatsChangeListener',
        value: function addStatsChangeListener(callback) {
            this.on(STATS_EVENT, callback);
        }
    }, {
        key: 'removeStatsChangeListener',
        value: function removeStatsChangeListener(callback) {
            this.removeListener(STATS_EVENT, callback);
        }
    }, {
        key: 'emitLastViewed',
        value: function emitLastViewed() {
            this.emit(LAST_VIEWED_EVENT);
        }
    }, {
        key: 'addLastViewedListener',
        value: function addLastViewedListener(callback) {
            this.on(LAST_VIEWED_EVENT, callback);
        }
    }, {
        key: 'removeLastViewedListener',
        value: function removeLastViewedListener(callback) {
            this.removeListener(LAST_VIEWED_EVENT, callback);
        }
    }, {
        key: 'findFirstBy',
        value: function findFirstBy(field, value) {
            return this.doFindFirst(field, value, this.getChannels());
        }
    }, {
        key: 'findFirstMoreBy',
        value: function findFirstMoreBy(field, value) {
            return this.doFindFirst(field, value, this.getMoreChannels());
        }
    }, {
        key: 'doFindFirst',
        value: function doFindFirst(field, value, channels) {
            for (var i = 0; i < channels.length; i++) {
                if (channels[i][field] === value) {
                    return channels[i];
                }
            }

            return null;
        }
    }, {
        key: 'get',
        value: function get(id) {
            return this.findFirstBy('id', id);
        }
    }, {
        key: 'getMyMember',
        value: function getMyMember(id) {
            return this.getMyMembers()[id];
        }
    }, {
        key: 'getByName',
        value: function getByName(name) {
            return this.findFirstBy('name', name);
        }
    }, {
        key: 'getByDisplayName',
        value: function getByDisplayName(displayName) {
            return this.findFirstBy('display_name', displayName);
        }
    }, {
        key: 'getMoreByName',
        value: function getMoreByName(name) {
            return this.findFirstMoreBy('name', name);
        }
    }, {
        key: 'getAll',
        value: function getAll() {
            return this.getChannels();
        }
    }, {
        key: 'getMoreAll',
        value: function getMoreAll() {
            return this.getMoreChannels();
        }
    }, {
        key: 'setCurrentId',
        value: function setCurrentId(id) {
            _redux_store2.default.dispatch((0, _reduxBatchedActions.batchActions)([{
                type: _action_types.ChannelTypes.SELECT_CHANNEL,
                data: id
            }, {
                type: _constants.ActionTypes.SELECT_CHANNEL_WITH_MEMBER,
                data: id,
                channel: this.getChannelById(id),
                member: this.getMyMember(id)
            }]));
        }
    }, {
        key: 'resetCounts',
        value: function resetCounts(ids) {
            var _this2 = this;

            var membersToStore = [];
            ids.forEach(function (id) {
                var member = _this2.getMyMember(id);
                var channel = _this2.get(id);
                if (member && channel) {
                    var memberToStore = (0, _extends3.default)({}, member);
                    memberToStore.msg_count = channel.total_msg_count;
                    memberToStore.mention_count = 0;
                    membersToStore.push(memberToStore);
                    _this2.setUnreadCountByChannel(id);
                }
            });

            if (membersToStore.length) {
                this.storeMyChannelMembersList(membersToStore);
            }
        }
    }, {
        key: 'getCurrentId',
        value: function getCurrentId() {
            return Selectors.getCurrentChannelId(_redux_store2.default.getState());
        }
    }, {
        key: 'getCurrent',
        value: function getCurrent() {
            var currentId = this.getCurrentId();

            if (currentId) {
                return this.get(currentId);
            }

            return null;
        }
    }, {
        key: 'getCurrentMember',
        value: function getCurrentMember() {
            var currentId = this.getCurrentId();

            if (currentId) {
                return this.getMyMembers()[currentId];
            }

            return null;
        }
    }, {
        key: 'getCurrentStats',
        value: function getCurrentStats() {
            return this.getStats(this.getCurrentId());
        }
    }, {
        key: 'getStats',
        value: function getStats(channelId) {
            var stats = void 0;

            if (channelId) {
                stats = Selectors.getAllChannelStats(_redux_store2.default.getState())[channelId];
            }

            if (stats) {
                // create a defensive copy
                stats = (0, _assign2.default)({}, stats);
            } else {
                stats = { member_count: 0 };
            }

            return stats;
        }
    }, {
        key: 'storeChannel',
        value: function storeChannel(channel) {
            var channels = this.getChannels();
            var found;

            for (var i = 0; i < channels.length; i++) {
                if (channels[i].id === channel.id) {
                    channels[i] = channel;
                    found = true;
                    break;
                }
            }

            if (!found) {
                channels.push(channel);
            }

            if (!ChannelUtils) {
                ChannelUtils = __webpack_require__(830); //eslint-disable-line global-require
            }

            channels = channels.sort(ChannelUtils.sortChannelsByDisplayName);
            this.storeChannels(channels);
        }
    }, {
        key: 'storeChannels',
        value: function storeChannels(channels) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                data: channels,
                teamId: channels[0].team_id
            });
        }
    }, {
        key: 'getChannels',
        value: function getChannels() {
            return Selectors.getMyChannels(_redux_store2.default.getState());
        }
    }, {
        key: 'getChannelById',
        value: function getChannelById(id) {
            return this.get(id);
        }
    }, {
        key: 'storeMyChannelMember',
        value: function storeMyChannelMember(channelMember) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                data: channelMember
            });
        }
    }, {
        key: 'storeMyChannelMembers',
        value: function storeMyChannelMembers(channelMembers) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                data: (0, _values2.default)(channelMembers)
            });
        }
    }, {
        key: 'storeMyChannelMembersList',
        value: function storeMyChannelMembersList(channelMembers) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                data: channelMembers
            });
        }
    }, {
        key: 'getMyMembers',
        value: function getMyMembers() {
            return (0, _common.getMyChannelMemberships)(_redux_store2.default.getState());
        }
    }, {
        key: 'saveMembersInChannel',
        value: function saveMembersInChannel(channelId, members) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
                data: (0, _values2.default)(members)
            });
        }
    }, {
        key: 'getMembersInChannel',
        value: function getMembersInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();

            return Selectors.getChannelMembersInChannels(_redux_store2.default.getState())[channelId] || {};
        }
    }, {
        key: 'hasActiveMemberInChannel',
        value: function hasActiveMemberInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var userId = arguments[1];

            var members = this.getMembersInChannel(channelId);
            if (members && members[userId]) {
                return true;
            }

            return false;
        }
    }, {
        key: 'storeMoreChannels',
        value: function storeMoreChannels(channels) {
            var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();

            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                data: channels,
                teamId: teamId
            });
        }
    }, {
        key: 'getMoreChannels',
        value: function getMoreChannels() {
            var channels = Selectors.getOtherChannels(_redux_store2.default.getState());
            var channelMap = {};
            channels.forEach(function (c) {
                channelMap[c.id] = c;
            });
            return channelMap;
        }
    }, {
        key: 'getMoreChannelsList',
        value: function getMoreChannelsList() {
            return Selectors.getOtherChannels(_redux_store2.default.getState());
        }
    }, {
        key: 'isDefault',
        value: function isDefault(channel) {
            return channel.name === _constants.Constants.DEFAULT_CHANNEL;
        }
    }, {
        key: 'setPostMode',
        value: function setPostMode(mode) {
            this.postMode = mode;
        }
    }, {
        key: 'getPostMode',
        value: function getPostMode() {
            return this.postMode;
        }
    }, {
        key: 'setUnreadCountsByMembers',
        value: function setUnreadCountsByMembers(members) {
            var _this3 = this;

            members.forEach(function (m) {
                _this3.setUnreadCountByChannel(m.channel_id);
            });
        }
    }, {
        key: 'setUnreadCountsByCurrentMembers',
        value: function setUnreadCountsByCurrentMembers() {
            var _this4 = this;

            (0, _keys2.default)(this.getMyMembers()).forEach(function (key) {
                _this4.setUnreadCountByChannel(_this4.getMyMember(key).channel_id);
            });
        }
    }, {
        key: 'setUnreadCountsByChannels',
        value: function setUnreadCountsByChannels(channels) {
            var _this5 = this;

            channels.forEach(function (c) {
                _this5.setUnreadCountByChannel(c.id);
            });
        }
    }, {
        key: 'setUnreadCountByChannel',
        value: function setUnreadCountByChannel(id) {
            var ch = this.get(id);
            var chMember = this.getMyMember(id);

            if (ch == null || chMember == null) {
                return;
            }

            var chMentionCount = chMember.mention_count;
            var chUnreadCount = ch.total_msg_count - chMember.msg_count;

            if (chMember.notify_props && chMember.notify_props.mark_unread === NotificationPrefs.MENTION) {
                chUnreadCount = 0;
            }

            this.unreadCounts[id] = { msgs: chUnreadCount, mentions: chMentionCount };
        }
    }, {
        key: 'getUnreadCount',
        value: function getUnreadCount(id) {
            return this.unreadCounts[id] || { msgs: 0, mentions: 0 };
        }
    }, {
        key: 'getUnreadCounts',
        value: function getUnreadCounts() {
            return this.unreadCounts;
        }
    }, {
        key: 'getChannelNamesMap',
        value: function getChannelNamesMap() {
            var channelNamesMap = {};

            var channels = this.getChannels();
            for (var key in channels) {
                if (channels.hasOwnProperty(key)) {
                    var channel = channels[key];
                    channelNamesMap[channel.name] = channel;
                }
            }

            var moreChannels = this.getMoreChannels();
            for (var moreKey in moreChannels) {
                if (moreChannels.hasOwnProperty(moreKey)) {
                    var moreChannel = moreChannels[moreKey];
                    channelNamesMap[moreChannel.name] = moreChannel;
                }
            }

            return channelNamesMap;
        }
    }, {
        key: 'isChannelAdminForCurrentChannel',
        value: function isChannelAdminForCurrentChannel() {
            if (!Utils) {
                Utils = __webpack_require__(762); //eslint-disable-line global-require
            }

            var member = this.getMyMember(this.getCurrentId());

            if (!member) {
                return false;
            }

            var isLicensed = (0, _general.getLicense)(_redux_store2.default.getState()).IsLicensed === 'true';

            return Utils.isChannelAdmin(isLicensed, member.roles);
        }
    }, {
        key: 'isChannelAdmin',
        value: function isChannelAdmin(userId, channelId) {
            if (!Utils) {
                Utils = __webpack_require__(762); //eslint-disable-line global-require
            }

            var channelMembers = this.getMembersInChannel(channelId);
            var channelMember = channelMembers[userId];

            if (channelMember) {
                var isLicensed = (0, _general.getLicense)(_redux_store2.default.getState()).IsLicensed === 'true';
                return Utils.isChannelAdmin(isLicensed, channelMember.roles);
            }

            return false;
        }
    }, {
        key: 'incrementMessages',
        value: function incrementMessages(id) {
            var markRead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!this.unreadCounts[id]) {
                // Should never happen
                console.log('Missing channel_id=' + id + ' in unreads object'); //eslint-disable-line no-console
            }

            var member = this.getMyMember(id);
            if (member && member.notify_props && member.notify_props.mark_unread === NotificationPrefs.MENTION) {
                return;
            }

            var channel = (0, _extends3.default)({}, this.get(id));
            channel.total_msg_count++;

            var actions = [];
            if (markRead) {
                actions.push({
                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                    data: (0, _extends3.default)({}, member, { msg_count: channel.total_msg_count })
                });
            }

            actions.push({
                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                data: channel
            });
            _redux_store2.default.dispatch((0, _reduxBatchedActions.batchActions)(actions));
        }
    }, {
        key: 'incrementMentionsIfNeeded',
        value: function incrementMentionsIfNeeded(id, msgProps) {
            var mentions = [];
            if (msgProps && msgProps.mentions) {
                mentions = JSON.parse(msgProps.mentions);
            }

            if (!this.unreadCounts[id]) {
                // Should never happen
                console.log('Missing channel_id=' + id + ' in unreads object'); //eslint-disable-line no-console
            }

            if (mentions.indexOf(_user_store2.default.getCurrentId()) !== -1) {
                var member = (0, _extends3.default)({}, this.getMyMember(id));
                member.mention_count++;
                _redux_store2.default.dispatch({
                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                    data: member
                });
            }
        }
    }, {
        key: 'POST_MODE_CHANNEL',
        get: function get() {
            return 1;
        }
    }, {
        key: 'POST_MODE_FOCUS',
        get: function get() {
            return 2;
        }
    }]);
    return ChannelStoreClass;
}(_events2.default);

var ChannelStore = new ChannelStoreClass();

ChannelStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case _constants.ActionTypes.CLICK_CHANNEL:
            ChannelStore.setCurrentId(action.id);
            ChannelStore.setPostMode(ChannelStore.POST_MODE_CHANNEL);
            break;

        case _constants.ActionTypes.RECEIVED_FOCUSED_POST:
            {
                var post = action.post_list.posts[action.postId];
                ChannelStore.setCurrentId(post.channel_id);
                ChannelStore.setPostMode(ChannelStore.POST_MODE_FOCUS);
                ChannelStore.emitChange();
                break;
            }

        case _constants.ActionTypes.RECEIVED_CHANNELS:
            ChannelStore.storeChannels(action.channels);
            break;

        case _constants.ActionTypes.RECEIVED_CHANNEL:
            ChannelStore.storeChannel(action.channel);
            if (action.member) {
                ChannelStore.storeMyChannelMember(action.member);
            }
            break;

        case _constants.ActionTypes.RECEIVED_MY_CHANNEL_MEMBERS:
            ChannelStore.storeMyChannelMembersList(action.members);
            break;
        case _constants.ActionTypes.RECEIVED_CHANNEL_MEMBER:
            ChannelStore.storeMyChannelMember(action.member);
            break;
        case _constants.ActionTypes.RECEIVED_MORE_CHANNELS:
            ChannelStore.storeMoreChannels(action.channels);
            break;
        case _constants.ActionTypes.RECEIVED_MEMBERS_IN_CHANNEL:
            ChannelStore.saveMembersInChannel(action.channel_members);
            break;
        case _constants.ActionTypes.RECEIVED_CHANNEL_STATS:
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_STATS,
                data: action.stats
            });
            break;

        case _constants.ActionTypes.RECEIVED_POST:
            {
                var _post = action.post,
                    data = action.websocketMessageProps;
                var dispatch = _redux_store2.default.dispatch;

                if ((0, _post_utils.shouldIgnorePost)(_post)) {
                    return;
                }

                var markAsRead = false;
                var markAsReadOnServer = false;
                if (_post.user_id === _user_store2.default.getCurrentId() && !(0, _post_utils.isSystemMessage)(_post) && !(0, _post_utils.isFromWebhook)(_post)) {
                    markAsRead = true;
                    markAsReadOnServer = false;
                } else if (action.post.channel_id === ChannelStore.getCurrentId() && window.isActive) {
                    markAsRead = true;
                    markAsReadOnServer = true;
                }

                if (markAsRead) {
                    dispatch((0, _channels.markChannelAsRead)(_post.channel_id, null, markAsReadOnServer));
                    dispatch((0, _channels.markChannelAsViewed)(_post.channel_id));
                } else {
                    dispatch((0, _channels.markChannelAsUnread)(data.team_id, _post.channel_id, data.mentions));
                }
                break;
            }
        case _constants.ActionTypes.CREATE_POST:
            ChannelStore.incrementMessages(action.post.channel_id, true);
            break;

        case _constants.ActionTypes.CREATE_COMMENT:
            ChannelStore.incrementMessages(action.post.channel_id, true);
            break;

        default:
            break;
    }
});

global.channelstore = ChannelStore;

exports.default = ChannelStore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.checkMfa = checkMfa;
exports.generateMfaSecret = generateMfaSecret;
exports.createUser = createUser;
exports.login = login;
exports.loginById = loginById;
exports.loadMe = loadMe;
exports.logout = logout;
exports.getProfiles = getProfiles;
exports.getMissingProfilesByIds = getMissingProfilesByIds;
exports.getProfilesByIds = getProfilesByIds;
exports.getProfilesByUsernames = getProfilesByUsernames;
exports.getProfilesInTeam = getProfilesInTeam;
exports.getProfilesNotInTeam = getProfilesNotInTeam;
exports.getProfilesWithoutTeam = getProfilesWithoutTeam;
exports.getProfilesInChannel = getProfilesInChannel;
exports.getProfilesNotInChannel = getProfilesNotInChannel;
exports.getMe = getMe;
exports.getUser = getUser;
exports.getUserByUsername = getUserByUsername;
exports.getUserByEmail = getUserByEmail;
exports.getStatusesByIdsBatchedDebounced = getStatusesByIdsBatchedDebounced;
exports.getStatusesByIds = getStatusesByIds;
exports.getStatus = getStatus;
exports.setStatus = setStatus;
exports.getSessions = getSessions;
exports.revokeSession = revokeSession;
exports.revokeAllSessionsForUser = revokeAllSessionsForUser;
exports.loadProfilesForDirect = loadProfilesForDirect;
exports.getUserAudits = getUserAudits;
exports.autocompleteUsers = autocompleteUsers;
exports.searchProfiles = searchProfiles;
exports.startPeriodicStatusUpdates = startPeriodicStatusUpdates;
exports.stopPeriodicStatusUpdates = stopPeriodicStatusUpdates;
exports.updateMe = updateMe;
exports.patchUser = patchUser;
exports.updateUserRoles = updateUserRoles;
exports.updateUserMfa = updateUserMfa;
exports.updateUserPassword = updateUserPassword;
exports.updateUserActive = updateUserActive;
exports.verifyUserEmail = verifyUserEmail;
exports.sendVerificationEmail = sendVerificationEmail;
exports.resetUserPassword = resetUserPassword;
exports.sendPasswordResetEmail = sendPasswordResetEmail;
exports.uploadProfileImage = uploadProfileImage;
exports.switchEmailToOAuth = switchEmailToOAuth;
exports.switchOAuthToEmail = switchOAuthToEmail;
exports.switchEmailToLdap = switchEmailToLdap;
exports.switchLdapToEmail = switchLdapToEmail;
exports.createUserAccessToken = createUserAccessToken;
exports.getUserAccessToken = getUserAccessToken;
exports.getUserAccessTokens = getUserAccessTokens;
exports.getUserAccessTokensForUser = getUserAccessTokensForUser;
exports.revokeUserAccessToken = revokeUserAccessToken;
exports.disableUserAccessToken = disableUserAccessToken;
exports.enableUserAccessToken = enableUserAccessToken;
exports.clearUserAccessTokens = clearUserAccessTokens;

var _reduxBatchedActions = __webpack_require__(278);

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _action_types = __webpack_require__(3);

var _emojis = __webpack_require__(853);

var _teams = __webpack_require__(816);

var _roles = __webpack_require__(860);

var _channel_utils = __webpack_require__(854);

var _user_utils = __webpack_require__(175);

var _helpers = __webpack_require__(117);

var _errors = __webpack_require__(828);

var _helpers2 = __webpack_require__(821);

var _preferences = __webpack_require__(861);

var _general = __webpack_require__(113);

var _users = __webpack_require__(777);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function checkMfa(loginId) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.CHECK_MFA_REQUEST }, getState);
                            _context.prev = 1;
                            _context.next = 4;
                            return _client.Client4.checkUserMfa(loginId);

                        case 4:
                            data = _context.sent;

                            dispatch({ type: _action_types.UserTypes.CHECK_MFA_SUCCESS }, getState);
                            return _context.abrupt('return', { data: data.mfa_required });

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](1);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.CHECK_MFA_FAILURE, error: _context.t0 }, (0, _errors.logError)(_context.t0)(dispatch)]), getState);
                            return _context.abrupt('return', { error: _context.t0 });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[1, 9]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function generateMfaSecret(userId) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.generateMfaSecret, _action_types.UserTypes.MFA_SECRET_REQUEST, _action_types.UserTypes.MFA_SECRET_SUCCESS, _action_types.UserTypes.MFA_SECRET_FAILURE, userId);
}

function createUser(user, data, hash, inviteId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var created, profiles;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.CREATE_USER_REQUEST }, getState);

                            created = void 0;
                            _context2.prev = 2;
                            _context2.next = 5;
                            return _client.Client4.createUser(user, data, hash, inviteId);

                        case 5:
                            created = _context2.sent;
                            _context2.next = 13;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](2);

                            (0, _helpers2.forceLogoutIfNecessary)(_context2.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.CREATE_USER_FAILURE,
                                error: _context2.t0
                            }, (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', { error: _context2.t0 });

                        case 13:
                            profiles = {};

                            profiles[created.id] = created;
                            dispatch({ type: _action_types.UserTypes.RECEIVED_PROFILES, data: profiles });

                            return _context2.abrupt('return', { data: created });

                        case 17:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[2, 8]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function login(loginId, password) {
    var _this3 = this;

    var mfaToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var ldapOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var deviceId, data;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.LOGIN_REQUEST }, getState);

                            deviceId = getState().entities.general.deviceToken;
                            data = void 0;
                            _context3.prev = 3;
                            _context3.next = 6;
                            return _client.Client4.login(loginId, password, mfaToken, deviceId, ldapOnly);

                        case 6:
                            data = _context3.sent;

                            _client.Client.setToken(_client.Client4.getToken());
                            _context3.next = 14;
                            break;

                        case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](3);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.LOGIN_FAILURE,
                                error: _context3.t0
                            }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', { error: _context3.t0 });

                        case 14:
                            _context3.next = 16;
                            return completeLogin(data)(dispatch, getState);

                        case 16:
                            return _context3.abrupt('return', _context3.sent);

                        case 17:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[3, 10]]);
        }));

        return function (_x7, _x8) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function loginById(id, password) {
    var _this4 = this;

    var mfaToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var deviceId, data;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.LOGIN_REQUEST }, getState);

                            deviceId = getState().entities.general.deviceToken;
                            data = void 0;
                            _context4.prev = 3;
                            _context4.next = 6;
                            return _client.Client4.loginById(id, password, mfaToken, deviceId);

                        case 6:
                            data = _context4.sent;
                            _context4.next = 13;
                            break;

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](3);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.LOGIN_FAILURE,
                                error: _context4.t0
                            }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', { error: _context4.t0 });

                        case 13:
                            _context4.next = 15;
                            return completeLogin(data)(dispatch, getState);

                        case 15:
                            return _context4.abrupt('return', _context4.sent);

                        case 16:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[3, 9]]);
        }));

        return function (_x10, _x11) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function completeLogin(data) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var teamMembers, membersRequest, unreadsRequest, teamUnreads, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, u, promises, state, serverVersion, roles, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, teamMember, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, role, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _role;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({
                                type: _action_types.UserTypes.RECEIVED_ME,
                                data: data
                            });

                            _client.Client4.setUserId(data.id);

                            teamMembers = void 0;
                            _context5.prev = 3;
                            membersRequest = _client.Client4.getMyTeamMembers();
                            unreadsRequest = _client.Client4.getMyTeamUnreads();
                            _context5.next = 8;
                            return membersRequest;

                        case 8:
                            teamMembers = _context5.sent;
                            _context5.next = 11;
                            return unreadsRequest;

                        case 11:
                            teamUnreads = _context5.sent;

                            if (!teamUnreads) {
                                _context5.next = 33;
                                break;
                            }

                            _loop = function _loop(u) {
                                var index = teamMembers.findIndex(function (m) {
                                    return m.team_id === u.team_id;
                                });
                                var member = teamMembers[index];
                                member.mention_count = u.mention_count;
                                member.msg_count = u.msg_count;
                            };

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context5.prev = 17;

                            for (_iterator = teamUnreads[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                u = _step.value;

                                _loop(u);
                            }
                            _context5.next = 25;
                            break;

                        case 21:
                            _context5.prev = 21;
                            _context5.t0 = _context5['catch'](17);
                            _didIteratorError = true;
                            _iteratorError = _context5.t0;

                        case 25:
                            _context5.prev = 25;
                            _context5.prev = 26;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 28:
                            _context5.prev = 28;

                            if (!_didIteratorError) {
                                _context5.next = 31;
                                break;
                            }

                            throw _iteratorError;

                        case 31:
                            return _context5.finish(28);

                        case 32:
                            return _context5.finish(25);

                        case 33:
                            _context5.next = 39;
                            break;

                        case 35:
                            _context5.prev = 35;
                            _context5.t1 = _context5['catch'](3);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.LOGIN_FAILURE, error: _context5.t1 }, (0, _errors.logError)(_context5.t1)(dispatch)]), getState);
                            return _context5.abrupt('return', { error: _context5.t1 });

                        case 39:
                            promises = [(0, _preferences.getMyPreferences)()(dispatch, getState), (0, _teams.getMyTeams)()(dispatch, getState)];
                            state = getState();
                            serverVersion = _client.Client4.getServerVersion();

                            if (!(0, _helpers.isMinimumServerVersion)(serverVersion, 4, 7) && (0, _general.getConfig)(state).EnableCustomEmoji === 'true') {
                                dispatch((0, _emojis.getAllCustomEmojis)());
                            }

                            _context5.prev = 43;
                            _context5.next = 46;
                            return Promise.all(promises);

                        case 46:
                            _context5.next = 52;
                            break;

                        case 48:
                            _context5.prev = 48;
                            _context5.t2 = _context5['catch'](43);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.LOGIN_FAILURE, error: _context5.t2 }, (0, _errors.logError)(_context5.t2)(dispatch)]), getState);
                            return _context5.abrupt('return', { error: _context5.t2 });

                        case 52:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBERS,
                                data: teamMembers
                            }, {
                                type: _action_types.UserTypes.LOGIN_SUCCESS
                            }]), getState);

                            roles = new Set();
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context5.prev = 57;
                            _iterator2 = teamMembers[Symbol.iterator]();

                        case 59:
                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                _context5.next = 102;
                                break;
                            }

                            teamMember = _step2.value;
                            _iteratorNormalCompletion3 = true;
                            _didIteratorError3 = false;
                            _iteratorError3 = undefined;
                            _context5.prev = 64;

                            for (_iterator3 = teamMember.roles.split(' ')[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                role = _step3.value;

                                roles.add(role);
                            }
                            _context5.next = 72;
                            break;

                        case 68:
                            _context5.prev = 68;
                            _context5.t3 = _context5['catch'](64);
                            _didIteratorError3 = true;
                            _iteratorError3 = _context5.t3;

                        case 72:
                            _context5.prev = 72;
                            _context5.prev = 73;

                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }

                        case 75:
                            _context5.prev = 75;

                            if (!_didIteratorError3) {
                                _context5.next = 78;
                                break;
                            }

                            throw _iteratorError3;

                        case 78:
                            return _context5.finish(75);

                        case 79:
                            return _context5.finish(72);

                        case 80:
                            _iteratorNormalCompletion4 = true;
                            _didIteratorError4 = false;
                            _iteratorError4 = undefined;
                            _context5.prev = 83;
                            for (_iterator4 = data.roles.split(' ')[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                _role = _step4.value;

                                roles.add(_role);
                            }
                            _context5.next = 91;
                            break;

                        case 87:
                            _context5.prev = 87;
                            _context5.t4 = _context5['catch'](83);
                            _didIteratorError4 = true;
                            _iteratorError4 = _context5.t4;

                        case 91:
                            _context5.prev = 91;
                            _context5.prev = 92;

                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }

                        case 94:
                            _context5.prev = 94;

                            if (!_didIteratorError4) {
                                _context5.next = 97;
                                break;
                            }

                            throw _iteratorError4;

                        case 97:
                            return _context5.finish(94);

                        case 98:
                            return _context5.finish(91);

                        case 99:
                            _iteratorNormalCompletion2 = true;
                            _context5.next = 59;
                            break;

                        case 102:
                            _context5.next = 108;
                            break;

                        case 104:
                            _context5.prev = 104;
                            _context5.t5 = _context5['catch'](57);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context5.t5;

                        case 108:
                            _context5.prev = 108;
                            _context5.prev = 109;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 111:
                            _context5.prev = 111;

                            if (!_didIteratorError2) {
                                _context5.next = 114;
                                break;
                            }

                            throw _iteratorError2;

                        case 114:
                            return _context5.finish(111);

                        case 115:
                            return _context5.finish(108);

                        case 116:
                            if (roles.size > 0) {
                                dispatch((0, _roles.loadRolesIfNeeded)(roles));
                            }

                            return _context5.abrupt('return', { data: true });

                        case 118:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[3, 35], [17, 21, 25, 33], [26,, 28, 32], [43, 48], [57, 104, 108, 116], [64, 68, 72, 80], [73,, 75, 79], [83, 87, 91, 99], [92,, 94, 98], [109,, 111, 115]]);
        }));

        return function (_x12, _x13) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function loadMe() {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var state, deviceId, promises, serverVersion, currentUserId;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            state = getState();
                            deviceId = state.entities.general.deviceToken;

                            if (deviceId) {
                                _client.Client4.attachDevice(deviceId);
                            }

                            promises = [getMe()(dispatch, getState), (0, _preferences.getMyPreferences)()(dispatch, getState), (0, _teams.getMyTeams)()(dispatch, getState), (0, _teams.getMyTeamMembers)()(dispatch, getState), (0, _teams.getMyTeamUnreads)()(dispatch, getState)];

                            // Sometimes the server version is set in one or the other

                            serverVersion = _client.Client4.getServerVersion() || getState().entities.general.serverVersion;

                            if (!(0, _helpers.isMinimumServerVersion)(serverVersion, 4, 7) && (0, _general.getConfig)(state).EnableCustomEmoji === 'true') {
                                dispatch((0, _emojis.getAllCustomEmojis)());
                            }

                            _context6.next = 8;
                            return Promise.all(promises);

                        case 8:
                            currentUserId = getState().entities.users.currentUserId;

                            _client.Client4.setUserId(currentUserId);

                            return _context6.abrupt('return', { data: true });

                        case 11:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }));

        return function (_x14, _x15) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function logout() {
    var _this7 = this;

    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.LOGOUT_REQUEST }, getState);

                            _context7.prev = 1;
                            _context7.next = 4;
                            return _client.Client4.logout();

                        case 4:
                            _context7.next = 8;
                            break;

                        case 6:
                            _context7.prev = 6;
                            _context7.t0 = _context7['catch'](1);

                        case 8:

                            _client.Client.setToken('');
                            dispatch({ type: _action_types.UserTypes.LOGOUT_SUCCESS }, getState);

                        case 10:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[1, 6]]);
        }));

        return function (_x16, _x17) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function getProfiles() {
    var _this8 = this;

    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context8.prev = 3;
                            _context8.next = 6;
                            return _client.Client4.getProfiles(page, perPage);

                        case 6:
                            profiles = _context8.sent;

                            (0, _user_utils.removeUserFromList)(currentUserId, profiles);
                            _context8.next = 15;
                            break;

                        case 10:
                            _context8.prev = 10;
                            _context8.t0 = _context8['catch'](3);

                            (0, _helpers2.forceLogoutIfNecessary)(_context8.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_FAILURE, error: _context8.t0 }, (0, _errors.logError)(_context8.t0)(dispatch)]), getState);
                            return _context8.abrupt('return', { error: _context8.t0 });

                        case 15:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_SUCCESS
                            }]), getState);

                            return _context8.abrupt('return', { data: profiles });

                        case 17:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8, [[3, 10]]);
        }));

        return function (_x20, _x21) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function getMissingProfilesByIds(userIds) {
    var _this9 = this;

    return function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var profiles, missingIds;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            profiles = getState().entities.users.profiles;
                            missingIds = [];

                            userIds.forEach(function (id) {
                                if (!profiles[id]) {
                                    missingIds.push(id);
                                }
                            });

                            if (!(missingIds.length > 0)) {
                                _context9.next = 8;
                                break;
                            }

                            getStatusesByIds(missingIds)(dispatch, getState);
                            _context9.next = 7;
                            return getProfilesByIds(missingIds)(dispatch, getState);

                        case 7:
                            return _context9.abrupt('return', _context9.sent);

                        case 8:
                            return _context9.abrupt('return', { data: [] });

                        case 9:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9);
        }));

        return function (_x22, _x23) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function getProfilesByIds(userIds) {
    var _this10 = this;

    return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context10.prev = 3;
                            _context10.next = 6;
                            return _client.Client4.getProfilesByIds(userIds);

                        case 6:
                            profiles = _context10.sent;

                            (0, _user_utils.removeUserFromList)(currentUserId, profiles);
                            _context10.next = 15;
                            break;

                        case 10:
                            _context10.prev = 10;
                            _context10.t0 = _context10['catch'](3);

                            (0, _helpers2.forceLogoutIfNecessary)(_context10.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_FAILURE, error: _context10.t0 }, (0, _errors.logError)(_context10.t0)(dispatch)]), getState);
                            return _context10.abrupt('return', { error: _context10.t0 });

                        case 15:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_SUCCESS
                            }]), getState);

                            return _context10.abrupt('return', { data: profiles });

                        case 17:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10, [[3, 10]]);
        }));

        return function (_x24, _x25) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function getProfilesByUsernames(usernames) {
    var _this11 = this;

    return function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context11.prev = 3;
                            _context11.next = 6;
                            return _client.Client4.getProfilesByUsernames(usernames);

                        case 6:
                            profiles = _context11.sent;

                            (0, _user_utils.removeUserFromList)(currentUserId, profiles);
                            _context11.next = 15;
                            break;

                        case 10:
                            _context11.prev = 10;
                            _context11.t0 = _context11['catch'](3);

                            (0, _helpers2.forceLogoutIfNecessary)(_context11.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', { error: _context11.t0 });

                        case 15:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_SUCCESS
                            }]), getState);

                            return _context11.abrupt('return', { data: profiles });

                        case 17:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11, [[3, 10]]);
        }));

        return function (_x26, _x27) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function getProfilesInTeam(teamId, page) {
    var _this12 = this;

    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;
    var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_IN_TEAM_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context12.prev = 3;
                            _context12.next = 6;
                            return _client.Client4.getProfilesInTeam(teamId, page, perPage, sort);

                        case 6:
                            profiles = _context12.sent;
                            _context12.next = 14;
                            break;

                        case 9:
                            _context12.prev = 9;
                            _context12.t0 = _context12['catch'](3);

                            (0, _helpers2.forceLogoutIfNecessary)(_context12.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_IN_TEAM_FAILURE, error: _context12.t0 }, (0, _errors.logError)(_context12.t0)(dispatch)]), getState);
                            return _context12.abrupt('return', { error: _context12.t0 });

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat(_toConsumableArray(profiles)))
                            }, {
                                type: _action_types.UserTypes.PROFILES_IN_TEAM_SUCCESS
                            }]), getState);

                            return _context12.abrupt('return', { data: profiles });

                        case 16:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12, [[3, 9]]);
        }));

        return function (_x30, _x31) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function getProfilesNotInTeam(teamId, page) {
    var _this13 = this;

    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var profiles;
            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_NOT_IN_TEAM_REQUEST }, getState);

                            profiles = void 0;
                            _context13.prev = 2;
                            _context13.next = 5;
                            return _client.Client4.getProfilesNotInTeam(teamId, page, perPage);

                        case 5:
                            profiles = _context13.sent;
                            _context13.next = 13;
                            break;

                        case 8:
                            _context13.prev = 8;
                            _context13.t0 = _context13['catch'](2);

                            (0, _helpers2.forceLogoutIfNecessary)(_context13.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_NOT_IN_TEAM_FAILURE, error: _context13.t0 }, (0, _errors.logError)(_context13.t0)(dispatch)]), getState);
                            return _context13.abrupt('return', { error: _context13.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_NOT_IN_TEAM_SUCCESS
                            }]), getState);

                            return _context13.abrupt('return', { data: profiles });

                        case 15:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13, [[2, 8]]);
        }));

        return function (_x33, _x34) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function getProfilesWithoutTeam(page) {
    var _this14 = this;

    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(dispatch, getState) {
            var profiles;
            return regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_WITHOUT_TEAM_REQUEST }, getState);

                            profiles = void 0;
                            _context14.prev = 2;
                            _context14.next = 5;
                            return _client.Client4.getProfilesWithoutTeam(page, perPage);

                        case 5:
                            profiles = _context14.sent;
                            _context14.next = 13;
                            break;

                        case 8:
                            _context14.prev = 8;
                            _context14.t0 = _context14['catch'](2);

                            (0, _helpers2.forceLogoutIfNecessary)(_context14.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_WITHOUT_TEAM_FAILURE, error: _context14.t0 }, (0, _errors.logError)(_context14.t0)(dispatch)]), getState);
                            return _context14.abrupt('return', { error: _context14.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_WITHOUT_TEAM,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_WITHOUT_TEAM_SUCCESS
                            }]), getState);

                            return _context14.abrupt('return', { data: profiles });

                        case 15:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14, [[2, 8]]);
        }));

        return function (_x36, _x37) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function getProfilesInChannel(channelId, page) {
    var _this15 = this;

    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;
    var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_IN_CHANNEL_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context15.prev = 3;
                            _context15.next = 6;
                            return _client.Client4.getProfilesInChannel(channelId, page, perPage, sort);

                        case 6:
                            profiles = _context15.sent;
                            _context15.next = 14;
                            break;

                        case 9:
                            _context15.prev = 9;
                            _context15.t0 = _context15['catch'](3);

                            (0, _helpers2.forceLogoutIfNecessary)(_context15.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_IN_CHANNEL_FAILURE, error: _context15.t0 }, (0, _errors.logError)(_context15.t0)(dispatch)]), getState);
                            return _context15.abrupt('return', { error: _context15.t0 });

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL,
                                data: profiles,
                                id: channelId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat(_toConsumableArray(profiles)))
                            }, {
                                type: _action_types.UserTypes.PROFILES_IN_CHANNEL_SUCCESS
                            }]), getState);

                            return _context15.abrupt('return', { data: profiles });

                        case 16:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15, [[3, 9]]);
        }));

        return function (_x40, _x41) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function getProfilesNotInChannel(teamId, channelId, page) {
    var _this16 = this;

    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context16.prev = 3;
                            _context16.next = 6;
                            return _client.Client4.getProfilesNotInChannel(teamId, channelId, page, perPage);

                        case 6:
                            profiles = _context16.sent;
                            _context16.next = 14;
                            break;

                        case 9:
                            _context16.prev = 9;
                            _context16.t0 = _context16['catch'](3);

                            (0, _helpers2.forceLogoutIfNecessary)(_context16.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_FAILURE, error: _context16.t0 }, (0, _errors.logError)(_context16.t0)(dispatch)]), getState);
                            return _context16.abrupt('return', { error: _context16.t0 });

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL,
                                data: profiles,
                                id: channelId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat(_toConsumableArray(profiles)))
                            }, {
                                type: _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_SUCCESS
                            }]), getState);

                            return _context16.abrupt('return', { data: profiles });

                        case 16:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16, [[3, 9]]);
        }));

        return function (_x43, _x44) {
            return _ref16.apply(this, arguments);
        };
    }();
}

function getMe() {
    var _this17 = this;

    return function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(dispatch, getState) {
            var getMeFunc, me;
            return regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            getMeFunc = (0, _helpers2.bindClientFunc)(_client.Client4.getMe, _action_types.UserTypes.USER_REQUEST, [_action_types.UserTypes.RECEIVED_ME, _action_types.UserTypes.USER_SUCCESS], _action_types.UserTypes.USER_FAILURE);
                            _context17.next = 3;
                            return getMeFunc(dispatch, getState);

                        case 3:
                            me = _context17.sent;

                            if (!me.error) {
                                _context17.next = 6;
                                break;
                            }

                            return _context17.abrupt('return', me);

                        case 6:
                            dispatch((0, _roles.loadRolesIfNeeded)(me.data.roles.split(' ')));
                            return _context17.abrupt('return', me);

                        case 8:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17);
        }));

        return function (_x45, _x46) {
            return _ref17.apply(this, arguments);
        };
    }();
}

function getUser(id) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.getUser, _action_types.UserTypes.USER_REQUEST, [_action_types.UserTypes.RECEIVED_PROFILE, _action_types.UserTypes.USER_SUCCESS], _action_types.UserTypes.USER_FAILURE, id);
}

function getUserByUsername(username) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.getUserByUsername, _action_types.UserTypes.USER_BY_USERNAME_REQUEST, [_action_types.UserTypes.RECEIVED_PROFILE, _action_types.UserTypes.USER_BY_USERNAME_SUCCESS], _action_types.UserTypes.USER_BY_USERNAME_FAILURE, username);
}

function getUserByEmail(email) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.getUserByEmail, _action_types.UserTypes.USER_REQUEST, [_action_types.UserTypes.RECEIVED_PROFILE, _action_types.UserTypes.USER_SUCCESS], _action_types.UserTypes.USER_FAILURE, email);
}

// We create an array to hold the id's that we want to get a status for. We build our
// debounced function that will get called after a set period of idle time in which
// the array of id's will be passed to the getStatusesByIds with a cb that clears out
// the array. Helps with performance because instead of making 75 different calls for
// statuses, we are only making one call for 75 ids.
// We could maybe clean it up somewhat by storing the array of ids in redux state possbily?
var ids = [];
var debouncedGetStatusesByIds = (0, _helpers2.debounce)(function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(dispatch, getState) {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        getStatusesByIds([].concat(_toConsumableArray(new Set(ids))))(dispatch, getState);

                    case 1:
                    case 'end':
                        return _context18.stop();
                }
            }
        }, _callee18, undefined);
    }));

    return function (_x47, _x48) {
        return _ref18.apply(this, arguments);
    };
}(), 20, false, function () {
    ids = [];
});
function getStatusesByIdsBatchedDebounced(id) {
    ids = [].concat(_toConsumableArray(ids), [id]);
    return debouncedGetStatusesByIds;
}

function getStatusesByIds(userIds) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.getStatusesByIds, _action_types.UserTypes.PROFILES_STATUSES_REQUEST, [_action_types.UserTypes.RECEIVED_STATUSES, _action_types.UserTypes.PROFILES_STATUSES_SUCCESS], _action_types.UserTypes.PROFILES_STATUSES_FAILURE, userIds);
}

function getStatus(userId) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.getStatus, _action_types.UserTypes.PROFILE_STATUS_REQUEST, [_action_types.UserTypes.RECEIVED_STATUS, _action_types.UserTypes.PROFILE_STATUS_SUCCESS], _action_types.UserTypes.PROFILE_STATUS_FAILURE, userId);
}

function setStatus(status) {
    var _this18 = this;

    return function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.SET_STATUS_REQUEST }, getState);

                            _context19.prev = 1;
                            _context19.next = 4;
                            return _client.Client4.updateStatus(status);

                        case 4:
                            _context19.next = 11;
                            break;

                        case 6:
                            _context19.prev = 6;
                            _context19.t0 = _context19['catch'](1);

                            (0, _helpers2.forceLogoutIfNecessary)(_context19.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.SET_STATUS_FAILURE, error: _context19.t0 }, (0, _errors.logError)(_context19.t0)(dispatch)]), getState);
                            return _context19.abrupt('return', { error: _context19.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_STATUS,
                                data: status
                            }, {
                                type: _action_types.UserTypes.SET_STATUS_SUCCESS
                            }]), getState);

                            return _context19.abrupt('return', { data: status });

                        case 13:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, _this18, [[1, 6]]);
        }));

        return function (_x49, _x50) {
            return _ref19.apply(this, arguments);
        };
    }();
}

function getSessions(userId) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.getSessions, _action_types.UserTypes.SESSIONS_REQUEST, [_action_types.UserTypes.RECEIVED_SESSIONS, _action_types.UserTypes.SESSIONS_SUCCESS], _action_types.UserTypes.SESSIONS_FAILURE, userId);
}

function revokeSession(userId, sessionId) {
    var _this19 = this;

    return function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.REVOKE_SESSION_REQUEST }, getState);

                            _context20.prev = 1;
                            _context20.next = 4;
                            return _client.Client4.revokeSession(userId, sessionId);

                        case 4:
                            _context20.next = 11;
                            break;

                        case 6:
                            _context20.prev = 6;
                            _context20.t0 = _context20['catch'](1);

                            (0, _helpers2.forceLogoutIfNecessary)(_context20.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.REVOKE_SESSION_FAILURE, error: _context20.t0 }, (0, _errors.logError)(_context20.t0)(dispatch)]), getState);
                            return _context20.abrupt('return', { error: _context20.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_REVOKED_SESSION,
                                sessionId: sessionId
                            }, {
                                type: _action_types.UserTypes.REVOKE_SESSION_SUCCESS
                            }]), getState);

                            return _context20.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, _this19, [[1, 6]]);
        }));

        return function (_x51, _x52) {
            return _ref20.apply(this, arguments);
        };
    }();
}

function revokeAllSessionsForUser(userId) {
    var _this20 = this;

    return function () {
        var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.REVOKE_ALL_USER_SESSIONS_REQUEST }, getState);

                            _context21.prev = 1;
                            _context21.next = 4;
                            return _client.Client4.revokeAllSessionsForUser(userId);

                        case 4:
                            _context21.next = 11;
                            break;

                        case 6:
                            _context21.prev = 6;
                            _context21.t0 = _context21['catch'](1);

                            (0, _helpers2.forceLogoutIfNecessary)(_context21.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.REVOKE_ALL_USER_SESSIONS_FAILURE, error: _context21.t0 }, (0, _errors.logError)(_context21.t0)(dispatch)]), getState);
                            return _context21.abrupt('return', { error: _context21.t0 });

                        case 11:
                            data = { isCurrentUser: userId === (0, _users.getCurrentUserId)(getState()) };

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.REVOKE_ALL_USER_SESSIONS_SUCCESS,
                                data: data
                            }]), getState);

                            return _context21.abrupt('return', { data: true });

                        case 14:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, _this20, [[1, 6]]);
        }));

        return function (_x53, _x54) {
            return _ref21.apply(this, arguments);
        };
    }();
}

function loadProfilesForDirect() {
    var _this21 = this;

    return function () {
        var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(dispatch, getState) {
            var state, config, _state$entities$chann, channels, myMembers, myPreferences, _state$entities$users, currentUserId, profiles, values, i, channel, member, otherUserId;

            return regeneratorRuntime.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            state = getState();
                            config = state.entities.general.config;
                            _state$entities$chann = state.entities.channels, channels = _state$entities$chann.channels, myMembers = _state$entities$chann.myMembers;
                            myPreferences = state.entities.preferences.myPreferences;
                            _state$entities$users = state.entities.users, currentUserId = _state$entities$users.currentUserId, profiles = _state$entities$users.profiles;
                            values = Object.values(channels);
                            i = 0;

                        case 7:
                            if (!(i < values.length)) {
                                _context22.next = 16;
                                break;
                            }

                            channel = values[i];
                            member = myMembers[channel.id];

                            if (!(!(0, _channel_utils.isDirectChannel)(channel) && !(0, _channel_utils.isGroupChannel)(channel))) {
                                _context22.next = 12;
                                break;
                            }

                            return _context22.abrupt('continue', 13);

                        case 12:

                            if (member) {
                                if (member.mention_count > 0 && (0, _channel_utils.isDirectChannel)(channel)) {
                                    otherUserId = (0, _channel_utils.getUserIdFromChannelName)(currentUserId, channel.name);

                                    if (!(0, _channel_utils.isDirectChannelVisible)(profiles[otherUserId] || otherUserId, config, myPreferences, channel)) {
                                        (0, _preferences.makeDirectChannelVisibleIfNecessary)(otherUserId)(dispatch, getState);
                                    }
                                } else if ((member.mention_count > 0 || member.msg_count < channel.total_msg_count) && (0, _channel_utils.isGroupChannel)(channel) && !(0, _channel_utils.isGroupChannelVisible)(config, myPreferences, channel)) {
                                    (0, _preferences.makeGroupMessageVisibleIfNecessary)(channel.id)(dispatch, getState);
                                }
                            }

                        case 13:
                            i++;
                            _context22.next = 7;
                            break;

                        case 16:
                            return _context22.abrupt('return', { data: true });

                        case 17:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this21);
        }));

        return function (_x55, _x56) {
            return _ref22.apply(this, arguments);
        };
    }();
}

function getUserAudits(userId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.AUDITS_CHUNK_SIZE;

    return (0, _helpers2.bindClientFunc)(_client.Client4.getUserAudits, _action_types.UserTypes.AUDITS_REQUEST, [_action_types.UserTypes.RECEIVED_AUDITS, _action_types.UserTypes.AUDITS_SUCCESS], _action_types.UserTypes.AUDITS_FAILURE, userId, page, perPage);
}

function autocompleteUsers(term) {
    var _this22 = this;

    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var channelId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return function () {
        var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(dispatch, getState) {
            var currentUserId, data, users, actions;
            return regeneratorRuntime.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.AUTOCOMPLETE_USERS_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            data = void 0;
                            _context23.prev = 3;
                            _context23.next = 6;
                            return _client.Client4.autocompleteUsers(term, teamId, channelId);

                        case 6:
                            data = _context23.sent;
                            _context23.next = 14;
                            break;

                        case 9:
                            _context23.prev = 9;
                            _context23.t0 = _context23['catch'](3);

                            (0, _helpers2.forceLogoutIfNecessary)(_context23.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.AUTOCOMPLETE_USERS_FAILURE, error: _context23.t0 }, (0, _errors.logError)(_context23.t0)(dispatch)]), getState);
                            return _context23.abrupt('return', { error: _context23.t0 });

                        case 14:
                            users = [].concat(_toConsumableArray(data.users));

                            if (data.out_of_channel) {
                                users = [].concat(_toConsumableArray(users), _toConsumableArray(data.out_of_channel));
                            }
                            (0, _user_utils.removeUserFromList)(currentUserId, users);

                            actions = [{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: users
                            }, {
                                type: _action_types.UserTypes.AUTOCOMPLETE_USERS_SUCCESS
                            }];


                            if (channelId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL,
                                    data: data.users,
                                    id: channelId
                                });
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL,
                                    data: data.out_of_channel,
                                    id: channelId
                                });
                            }

                            if (teamId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                    data: users,
                                    id: teamId
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context23.abrupt('return', { data: data });

                        case 22:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this22, [[3, 9]]);
        }));

        return function (_x61, _x62) {
            return _ref23.apply(this, arguments);
        };
    }();
}

function searchProfiles(term) {
    var _this23 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return function () {
        var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(dispatch, getState) {
            var currentUserId, profiles, actions;
            return regeneratorRuntime.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.SEARCH_PROFILES_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context24.prev = 3;
                            _context24.next = 6;
                            return _client.Client4.searchUsers(term, options);

                        case 6:
                            profiles = _context24.sent;
                            _context24.next = 14;
                            break;

                        case 9:
                            _context24.prev = 9;
                            _context24.t0 = _context24['catch'](3);

                            (0, _helpers2.forceLogoutIfNecessary)(_context24.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.SEARCH_PROFILES_FAILURE, error: _context24.t0 }, (0, _errors.logError)(_context24.t0)(dispatch)]), getState);
                            return _context24.abrupt('return', { error: _context24.t0 });

                        case 14:
                            actions = [{ type: _action_types.UserTypes.RECEIVED_PROFILES_LIST, data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat(_toConsumableArray(profiles))) }];


                            if (options.in_channel_id) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL,
                                    data: profiles,
                                    id: options.in_channel_id
                                });
                            }

                            if (options.not_in_channel_id) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL,
                                    data: profiles,
                                    id: options.not_in_channel_id
                                });
                            }

                            if (options.team_id) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                    data: profiles,
                                    id: options.team_id
                                });
                            }

                            if (options.not_in_team_id) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_TEAM,
                                    data: profiles,
                                    id: options.not_in_team_id
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(actions, [{
                                type: _action_types.UserTypes.SEARCH_PROFILES_SUCCESS
                            }])), getState);

                            return _context24.abrupt('return', { data: profiles });

                        case 21:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this23, [[3, 9]]);
        }));

        return function (_x64, _x65) {
            return _ref24.apply(this, arguments);
        };
    }();
}

var statusIntervalId = '';
function startPeriodicStatusUpdates() {
    var _this24 = this;

    return function () {
        var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            clearInterval(statusIntervalId);

                            statusIntervalId = setInterval(function () {
                                var statuses = getState().entities.users.statuses;


                                if (!statuses) {
                                    return;
                                }

                                var userIds = Object.keys(statuses);
                                if (!userIds.length) {
                                    return;
                                }

                                getStatusesByIds(userIds)(dispatch, getState);
                            }, _constants.General.STATUS_INTERVAL);

                            return _context25.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, _this24);
        }));

        return function (_x66, _x67) {
            return _ref25.apply(this, arguments);
        };
    }();
}

function stopPeriodicStatusUpdates() {
    var _this25 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
            while (1) {
                switch (_context26.prev = _context26.next) {
                    case 0:
                        if (statusIntervalId) {
                            clearInterval(statusIntervalId);
                        }

                        return _context26.abrupt('return', { data: true });

                    case 2:
                    case 'end':
                        return _context26.stop();
                }
            }
        }, _callee26, _this25);
    }));
}

function updateMe(user) {
    var _this26 = this;

    return function () {
        var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_ME_REQUEST }, getState);

                            data = void 0;
                            _context27.prev = 2;
                            _context27.next = 5;
                            return _client.Client4.patchMe(user);

                        case 5:
                            data = _context27.sent;
                            _context27.next = 12;
                            break;

                        case 8:
                            _context27.prev = 8;
                            _context27.t0 = _context27['catch'](2);

                            dispatch({ type: _action_types.UserTypes.UPDATE_ME_FAILURE, error: _context27.t0 }, getState);
                            return _context27.abrupt('return', { error: _context27.t0 });

                        case 12:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.RECEIVED_ME, data: data }, { type: _action_types.UserTypes.UPDATE_ME_SUCCESS }]), getState);
                            dispatch((0, _roles.loadRolesIfNeeded)(data.roles.split(' ')));

                            return _context27.abrupt('return', { data: data });

                        case 15:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, _this26, [[2, 8]]);
        }));

        return function (_x68, _x69) {
            return _ref27.apply(this, arguments);
        };
    }();
}

function patchUser(user) {
    var _this27 = this;

    return function () {
        var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            data = void 0;
                            _context28.prev = 2;
                            _context28.next = 5;
                            return _client.Client4.patchUser(user);

                        case 5:
                            data = _context28.sent;
                            _context28.next = 12;
                            break;

                        case 8:
                            _context28.prev = 8;
                            _context28.t0 = _context28['catch'](2);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context28.t0 }, getState);
                            return _context28.abrupt('return', { error: _context28.t0 });

                        case 12:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.RECEIVED_PROFILE, data: data }, { type: _action_types.UserTypes.UPDATE_USER_SUCCESS }]), getState);

                            return _context28.abrupt('return', { data: data });

                        case 14:
                        case 'end':
                            return _context28.stop();
                    }
                }
            }, _callee28, _this27, [[2, 8]]);
        }));

        return function (_x70, _x71) {
            return _ref28.apply(this, arguments);
        };
    }();
}

function updateUserRoles(userId, roles) {
    var _this28 = this;

    return function () {
        var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(dispatch, getState) {
            var actions, profile;
            return regeneratorRuntime.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context29.prev = 1;
                            _context29.next = 4;
                            return _client.Client4.updateUserRoles(userId, roles);

                        case 4:
                            _context29.next = 10;
                            break;

                        case 6:
                            _context29.prev = 6;
                            _context29.t0 = _context29['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context29.t0 }, getState);
                            return _context29.abrupt('return', { error: _context29.t0 });

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { roles: roles }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context29.abrupt('return', { data: true });

                        case 15:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, _this28, [[1, 6]]);
        }));

        return function (_x72, _x73) {
            return _ref29.apply(this, arguments);
        };
    }();
}

function updateUserMfa(userId, activate) {
    var _this29 = this;

    var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return function () {
        var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(dispatch, getState) {
            var actions, profile;
            return regeneratorRuntime.wrap(function _callee30$(_context30) {
                while (1) {
                    switch (_context30.prev = _context30.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context30.prev = 1;
                            _context30.next = 4;
                            return _client.Client4.updateUserMfa(userId, activate, code);

                        case 4:
                            _context30.next = 10;
                            break;

                        case 6:
                            _context30.prev = 6;
                            _context30.t0 = _context30['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context30.t0 }, getState);
                            return _context30.abrupt('return', { error: _context30.t0 });

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { mfa_active: activate }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context30.abrupt('return', { data: true });

                        case 15:
                        case 'end':
                            return _context30.stop();
                    }
                }
            }, _callee30, _this29, [[1, 6]]);
        }));

        return function (_x75, _x76) {
            return _ref30.apply(this, arguments);
        };
    }();
}

function updateUserPassword(userId, currentPassword, newPassword) {
    var _this30 = this;

    return function () {
        var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31(dispatch, getState) {
            var actions, profile;
            return regeneratorRuntime.wrap(function _callee31$(_context31) {
                while (1) {
                    switch (_context31.prev = _context31.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context31.prev = 1;
                            _context31.next = 4;
                            return _client.Client4.updateUserPassword(userId, currentPassword, newPassword);

                        case 4:
                            _context31.next = 10;
                            break;

                        case 6:
                            _context31.prev = 6;
                            _context31.t0 = _context31['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context31.t0 }, getState);
                            return _context31.abrupt('return', { error: _context31.t0 });

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { last_password_update_at: new Date().getTime() }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context31.abrupt('return', { data: true });

                        case 15:
                        case 'end':
                            return _context31.stop();
                    }
                }
            }, _callee31, _this30, [[1, 6]]);
        }));

        return function (_x77, _x78) {
            return _ref31.apply(this, arguments);
        };
    }();
}

function updateUserActive(userId, active) {
    var _this31 = this;

    return function () {
        var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32(dispatch, getState) {
            var actions, profile, deleteAt;
            return regeneratorRuntime.wrap(function _callee32$(_context32) {
                while (1) {
                    switch (_context32.prev = _context32.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context32.prev = 1;
                            _context32.next = 4;
                            return _client.Client4.updateUserActive(userId, active);

                        case 4:
                            _context32.next = 10;
                            break;

                        case 6:
                            _context32.prev = 6;
                            _context32.t0 = _context32['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context32.t0 }, getState);
                            return _context32.abrupt('return', { error: _context32.t0 });

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                deleteAt = active ? 0 : new Date().getTime();

                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { delete_at: deleteAt }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context32.abrupt('return', { data: true });

                        case 15:
                        case 'end':
                            return _context32.stop();
                    }
                }
            }, _callee32, _this31, [[1, 6]]);
        }));

        return function (_x79, _x80) {
            return _ref32.apply(this, arguments);
        };
    }();
}

function verifyUserEmail(token) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.verifyUserEmail, _action_types.UserTypes.VERIFY_EMAIL_REQUEST, _action_types.UserTypes.VERIFY_EMAIL_SUCCESS, _action_types.UserTypes.VERIFY_EMAIL_FAILURE, token);
}

function sendVerificationEmail(email) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.sendVerificationEmail, _action_types.UserTypes.VERIFY_EMAIL_REQUEST, _action_types.UserTypes.VERIFY_EMAIL_SUCCESS, _action_types.UserTypes.VERIFY_EMAIL_FAILURE, email);
}

function resetUserPassword(token, newPassword) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.resetUserPassword, _action_types.UserTypes.PASSWORD_RESET_REQUEST, _action_types.UserTypes.PASSWORD_RESET_SUCCESS, _action_types.UserTypes.PASSWORD_RESET_FAILURE, token, newPassword);
}

function sendPasswordResetEmail(email) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.sendPasswordResetEmail, _action_types.UserTypes.PASSWORD_RESET_REQUEST, _action_types.UserTypes.PASSWORD_RESET_SUCCESS, _action_types.UserTypes.PASSWORD_RESET_FAILURE, email);
}

function uploadProfileImage(userId, imageData) {
    var _this32 = this;

    return function () {
        var _ref33 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33(dispatch, getState) {
            var actions, profile;
            return regeneratorRuntime.wrap(function _callee33$(_context33) {
                while (1) {
                    switch (_context33.prev = _context33.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context33.prev = 1;
                            _context33.next = 4;
                            return _client.Client4.uploadProfileImage(userId, imageData);

                        case 4:
                            _context33.next = 10;
                            break;

                        case 6:
                            _context33.prev = 6;
                            _context33.t0 = _context33['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context33.t0 }, getState);
                            return _context33.abrupt('return', { error: _context33.t0 });

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { last_picture_update: new Date().getTime() }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context33.abrupt('return', { data: true });

                        case 15:
                        case 'end':
                            return _context33.stop();
                    }
                }
            }, _callee33, _this32, [[1, 6]]);
        }));

        return function (_x81, _x82) {
            return _ref33.apply(this, arguments);
        };
    }();
}

function switchEmailToOAuth(service, email, password) {
    var mfaCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return (0, _helpers2.bindClientFunc)(_client.Client4.switchEmailToOAuth, _action_types.UserTypes.SWITCH_LOGIN_REQUEST, _action_types.UserTypes.SWITCH_LOGIN_SUCCESS, _action_types.UserTypes.SWITCH_LOGIN_FAILURE, service, email, password, mfaCode);
}

function switchOAuthToEmail(currentService, email, password) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.switchOAuthToEmail, _action_types.UserTypes.SWITCH_LOGIN_REQUEST, _action_types.UserTypes.SWITCH_LOGIN_SUCCESS, _action_types.UserTypes.SWITCH_LOGIN_FAILURE, currentService, email, password);
}

function switchEmailToLdap(email, emailPassword, ldapId, ldapPassword) {
    var mfaCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    return (0, _helpers2.bindClientFunc)(_client.Client4.switchEmailToLdap, _action_types.UserTypes.SWITCH_LOGIN_REQUEST, _action_types.UserTypes.SWITCH_LOGIN_SUCCESS, _action_types.UserTypes.SWITCH_LOGIN_FAILURE, email, emailPassword, ldapId, ldapPassword, mfaCode);
}

function switchLdapToEmail(ldapPassword, email, emailPassword) {
    var mfaCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return (0, _helpers2.bindClientFunc)(_client.Client4.switchLdapToEmail, _action_types.UserTypes.SWITCH_LOGIN_REQUEST, _action_types.UserTypes.SWITCH_LOGIN_SUCCESS, _action_types.UserTypes.SWITCH_LOGIN_FAILURE, ldapPassword, email, emailPassword, mfaCode);
}

function createUserAccessToken(userId, description) {
    var _this33 = this;

    return function () {
        var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34(dispatch, getState) {
            var data, actions, currentUserId;
            return regeneratorRuntime.wrap(function _callee34$(_context34) {
                while (1) {
                    switch (_context34.prev = _context34.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.CREATE_USER_ACCESS_TOKEN_REQUEST });

                            data = void 0;
                            _context34.prev = 2;
                            _context34.next = 5;
                            return _client.Client4.createUserAccessToken(userId, description);

                        case 5:
                            data = _context34.sent;
                            _context34.next = 13;
                            break;

                        case 8:
                            _context34.prev = 8;
                            _context34.t0 = _context34['catch'](2);

                            (0, _helpers2.forceLogoutIfNecessary)(_context34.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.CREATE_USER_ACCESS_TOKEN_FAILURE, error: _context34.t0 }, (0, _errors.logError)(_context34.t0)(dispatch)]), getState);
                            return _context34.abrupt('return', { error: _context34.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.UserTypes.CREATE_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.AdminTypes.RECEIVED_USER_ACCESS_TOKEN,
                                data: _extends({}, data, { token: '' })
                            }];
                            currentUserId = getState().entities.users.currentUserId;

                            if (userId === currentUserId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_MY_USER_ACCESS_TOKEN,
                                    data: _extends({}, data, { token: '' })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions));

                            return _context34.abrupt('return', { data: data });

                        case 18:
                        case 'end':
                            return _context34.stop();
                    }
                }
            }, _callee34, _this33, [[2, 8]]);
        }));

        return function (_x86, _x87) {
            return _ref34.apply(this, arguments);
        };
    }();
}

function getUserAccessToken(tokenId) {
    var _this34 = this;

    return function () {
        var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee35(dispatch, getState) {
            var data, actions, currentUserId;
            return regeneratorRuntime.wrap(function _callee35$(_context35) {
                while (1) {
                    switch (_context35.prev = _context35.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_REQUEST });

                            data = void 0;
                            _context35.prev = 2;
                            _context35.next = 5;
                            return _client.Client4.getUserAccessToken(tokenId);

                        case 5:
                            data = _context35.sent;
                            _context35.next = 13;
                            break;

                        case 8:
                            _context35.prev = 8;
                            _context35.t0 = _context35['catch'](2);

                            (0, _helpers2.forceLogoutIfNecessary)(_context35.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_FAILURE, error: _context35.t0 }, (0, _errors.logError)(_context35.t0)(dispatch)]), getState);
                            return _context35.abrupt('return', { error: _context35.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.AdminTypes.RECEIVED_USER_ACCESS_TOKEN,
                                data: data
                            }];
                            currentUserId = getState().entities.users.currentUserId;

                            if (data.user_id === currentUserId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_MY_USER_ACCESS_TOKEN,
                                    data: data
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions));

                            return _context35.abrupt('return', { data: data });

                        case 18:
                        case 'end':
                            return _context35.stop();
                    }
                }
            }, _callee35, _this34, [[2, 8]]);
        }));

        return function (_x88, _x89) {
            return _ref35.apply(this, arguments);
        };
    }();
}

function getUserAccessTokens() {
    var _this35 = this;

    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref36 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee36(dispatch, getState) {
            var data, actions;
            return regeneratorRuntime.wrap(function _callee36$(_context36) {
                while (1) {
                    switch (_context36.prev = _context36.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_REQUEST });
                            data = void 0;
                            _context36.prev = 2;
                            _context36.next = 5;
                            return _client.Client4.getUserAccessTokens(page, perPage);

                        case 5:
                            data = _context36.sent;
                            _context36.next = 13;
                            break;

                        case 8:
                            _context36.prev = 8;
                            _context36.t0 = _context36['catch'](2);

                            (0, _helpers2.forceLogoutIfNecessary)(_context36.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_FAILURE, error: _context36.t0 }, (0, _errors.logError)(_context36.t0)(dispatch)]), getState);
                            return _context36.abrupt('return', { error: _context36.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.AdminTypes.RECEIVED_USER_ACCESS_TOKENS,
                                data: data
                            }];


                            dispatch((0, _reduxBatchedActions.batchActions)(actions));

                            return _context36.abrupt('return', { data: data });

                        case 16:
                        case 'end':
                            return _context36.stop();
                    }
                }
            }, _callee36, _this35, [[2, 8]]);
        }));

        return function (_x92, _x93) {
            return _ref36.apply(this, arguments);
        };
    }();
}

function getUserAccessTokensForUser(userId) {
    var _this36 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref37 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee37(dispatch, getState) {
            var data, actions, currentUserId;
            return regeneratorRuntime.wrap(function _callee37$(_context37) {
                while (1) {
                    switch (_context37.prev = _context37.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_REQUEST });

                            data = void 0;
                            _context37.prev = 2;
                            _context37.next = 5;
                            return _client.Client4.getUserAccessTokensForUser(userId, page, perPage);

                        case 5:
                            data = _context37.sent;
                            _context37.next = 13;
                            break;

                        case 8:
                            _context37.prev = 8;
                            _context37.t0 = _context37['catch'](2);

                            (0, _helpers2.forceLogoutIfNecessary)(_context37.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_FAILURE, error: _context37.t0 }, (0, _errors.logError)(_context37.t0)(dispatch)]), getState);
                            return _context37.abrupt('return', { error: _context37.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.AdminTypes.RECEIVED_USER_ACCESS_TOKENS_FOR_USER,
                                data: data,
                                userId: userId
                            }];
                            currentUserId = getState().entities.users.currentUserId;

                            if (userId === currentUserId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_MY_USER_ACCESS_TOKENS,
                                    data: data
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions));

                            return _context37.abrupt('return', { data: data });

                        case 18:
                        case 'end':
                            return _context37.stop();
                    }
                }
            }, _callee37, _this36, [[2, 8]]);
        }));

        return function (_x96, _x97) {
            return _ref37.apply(this, arguments);
        };
    }();
}

function revokeUserAccessToken(tokenId) {
    var _this37 = this;

    return function () {
        var _ref38 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee38(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee38$(_context38) {
                while (1) {
                    switch (_context38.prev = _context38.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.REVOKE_USER_ACCESS_TOKEN_REQUEST });

                            _context38.prev = 1;
                            _context38.next = 4;
                            return _client.Client4.revokeUserAccessToken(tokenId);

                        case 4:
                            _context38.next = 11;
                            break;

                        case 6:
                            _context38.prev = 6;
                            _context38.t0 = _context38['catch'](1);

                            (0, _helpers2.forceLogoutIfNecessary)(_context38.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.REVOKE_USER_ACCESS_TOKEN_FAILURE, error: _context38.t0 }, (0, _errors.logError)(_context38.t0)(dispatch)]), getState);
                            return _context38.abrupt('return', { error: _context38.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.REVOKE_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.UserTypes.REVOKED_USER_ACCESS_TOKEN,
                                data: tokenId
                            }]));

                            return _context38.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context38.stop();
                    }
                }
            }, _callee38, _this37, [[1, 6]]);
        }));

        return function (_x98, _x99) {
            return _ref38.apply(this, arguments);
        };
    }();
}

function disableUserAccessToken(tokenId) {
    var _this38 = this;

    return function () {
        var _ref39 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee39(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee39$(_context39) {
                while (1) {
                    switch (_context39.prev = _context39.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.DISABLE_USER_ACCESS_TOKEN_REQUEST });

                            _context39.prev = 1;
                            _context39.next = 4;
                            return _client.Client4.disableUserAccessToken(tokenId);

                        case 4:
                            _context39.next = 11;
                            break;

                        case 6:
                            _context39.prev = 6;
                            _context39.t0 = _context39['catch'](1);

                            (0, _helpers2.forceLogoutIfNecessary)(_context39.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.DISABLE_USER_ACCESS_TOKEN_FAILURE, error: _context39.t0 }, (0, _errors.logError)(_context39.t0)(dispatch)]), getState);
                            return _context39.abrupt('return', { error: _context39.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.DISABLE_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.UserTypes.DISABLED_USER_ACCESS_TOKEN,
                                data: tokenId
                            }]));

                            return _context39.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context39.stop();
                    }
                }
            }, _callee39, _this38, [[1, 6]]);
        }));

        return function (_x100, _x101) {
            return _ref39.apply(this, arguments);
        };
    }();
}

function enableUserAccessToken(tokenId) {
    var _this39 = this;

    return function () {
        var _ref40 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee40(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee40$(_context40) {
                while (1) {
                    switch (_context40.prev = _context40.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.ENABLE_USER_ACCESS_TOKEN_REQUEST });

                            _context40.prev = 1;
                            _context40.next = 4;
                            return _client.Client4.enableUserAccessToken(tokenId);

                        case 4:
                            _context40.next = 11;
                            break;

                        case 6:
                            _context40.prev = 6;
                            _context40.t0 = _context40['catch'](1);

                            (0, _helpers2.forceLogoutIfNecessary)(_context40.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.ENABLE_USER_ACCESS_TOKEN_FAILURE, error: _context40.t0 }, (0, _errors.logError)(_context40.t0)(dispatch)]), getState);
                            return _context40.abrupt('return', { error: _context40.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.ENABLE_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.UserTypes.ENABLED_USER_ACCESS_TOKEN,
                                data: tokenId
                            }]));

                            return _context40.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context40.stop();
                    }
                }
            }, _callee40, _this39, [[1, 6]]);
        }));

        return function (_x102, _x103) {
            return _ref40.apply(this, arguments);
        };
    }();
}

function clearUserAccessTokens() {
    var _this40 = this;

    return function () {
        var _ref41 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee41(dispatch) {
            return regeneratorRuntime.wrap(function _callee41$(_context41) {
                while (1) {
                    switch (_context41.prev = _context41.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.CLEAR_MY_USER_ACCESS_TOKENS });
                            return _context41.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context41.stop();
                    }
                }
            }, _callee41, _this40);
        }));

        return function (_x104) {
            return _ref41.apply(this, arguments);
        };
    }();
}

exports.default = {
    checkMfa: checkMfa,
    generateMfaSecret: generateMfaSecret,
    login: login,
    logout: logout,
    getProfiles: getProfiles,
    getProfilesByIds: getProfilesByIds,
    getProfilesInTeam: getProfilesInTeam,
    getProfilesInChannel: getProfilesInChannel,
    getProfilesNotInChannel: getProfilesNotInChannel,
    getUser: getUser,
    getMe: getMe,
    getUserByUsername: getUserByUsername,
    getStatus: getStatus,
    getStatusesByIds: getStatusesByIds,
    getSessions: getSessions,
    loadProfilesForDirect: loadProfilesForDirect,
    revokeSession: revokeSession,
    revokeAllSessionsForUser: revokeAllSessionsForUser,
    getUserAudits: getUserAudits,
    searchProfiles: searchProfiles,
    startPeriodicStatusUpdates: startPeriodicStatusUpdates,
    stopPeriodicStatusUpdates: stopPeriodicStatusUpdates,
    updateMe: updateMe,
    updateUserRoles: updateUserRoles,
    updateUserMfa: updateUserMfa,
    updateUserPassword: updateUserPassword,
    updateUserActive: updateUserActive,
    verifyUserEmail: verifyUserEmail,
    sendVerificationEmail: sendVerificationEmail,
    resetUserPassword: resetUserPassword,
    sendPasswordResetEmail: sendPasswordResetEmail,
    uploadProfileImage: uploadProfileImage,
    switchEmailToOAuth: switchEmailToOAuth,
    switchOAuthToEmail: switchOAuthToEmail,
    switchEmailToLdap: switchEmailToLdap,
    switchLdapToEmail: switchLdapToEmail,
    createUserAccessToken: createUserAccessToken,
    getUserAccessToken: getUserAccessToken,
    getUserAccessTokensForUser: getUserAccessTokensForUser,
    revokeUserAccessToken: revokeUserAccessToken,
    disableUserAccessToken: disableUserAccessToken,
    enableUserAccessToken: enableUserAccessToken
};

/***/ }),
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isChrome = isChrome;
exports.isSafari = isSafari;
exports.isIosSafari = isIosSafari;
exports.isIosChrome = isIosChrome;
exports.isIosWeb = isIosWeb;
exports.isIos = isIos;
exports.isAndroid = isAndroid;
exports.isAndroidChrome = isAndroidChrome;
exports.isAndroidWeb = isAndroidWeb;
exports.isIosClassic = isIosClassic;
exports.isMobileApp = isMobileApp;
exports.isMobile = isMobile;
exports.isFirefox = isFirefox;
exports.isInternetExplorer = isInternetExplorer;
exports.isEdge = isEdge;
exports.isDesktopApp = isDesktopApp;
exports.isWindowsApp = isWindowsApp;
exports.isMacApp = isMacApp;
exports.isWindows7 = isWindows7;
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/*
Example User Agents
--------------------

Chrome:
    Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/51.0.2704.103 Safari/537.36

Firefox:
    Mozilla/5.0 (Windows NT 10.0; WOW64; rv:47.0) Gecko/20100101 Firefox/47.0

IE11:
    Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; rv:11.0) like Gecko

Edge:
    Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586

Desktop App:
    Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Mattermost/1.2.1 Chrome/49.0.2623.75 Electron/0.37.8 Safari/537.36
    Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586
    Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_0) AppleWebKit/537.36 (KHTML, like Gecko) Mattermost/3.4.1 Chrome/53.0.2785.113 Electron/1.4.2 Safari/537.36
    Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Mattermost/3.4.1 Chrome/51.0.2704.106 Electron/1.2.8 Safari/537.36

Android Chrome:
    Mozilla/5.0 (Linux; Android 4.0.4; Galaxy Nexus Build/IMM76B) AppleWebKit/535.19 (KHTML, like Gecko) Chrome/18.0.1025.133 Mobile Safari/535.19

Android App:
    Mozilla/5.0 (Linux; U; Android 4.1.1; en-gb; Build/KLP) AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Safari/534.30
    Mozilla/5.0 (Linux; Android 4.4; Nexus 5 Build/_BuildID_) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/30.0.0.0 Mobile Safari/537.36
    Mozilla/5.0 (Linux; Android 5.1.1; Nexus 5 Build/LMY48B; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/43.0.2357.65 Mobile Safari/537.36

iOS Safari:
    Mozilla/5.0 (iPhone; U; CPU like Mac OS X; en) AppleWebKit/420+ (KHTML, like Gecko) Version/3.0 Mobile/1A543 Safari/419.3

iOS Android:
    Mozilla/5.0 (iPhone; U; CPU iPhone OS 5_1_1 like Mac OS X; en) AppleWebKit/534.46.0 (KHTML, like Gecko) CriOS/19.0.1084.60 Mobile/9B206 Safari/7534.48.3

iOS App:
    Mozilla/5.0 (iPhone; CPU iPhone OS 9_3_2 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Mobile/13F69
*/

var userAgent = window.navigator.userAgent;

function isChrome() {
    return userAgent.indexOf('Chrome') > -1;
}

function isSafari() {
    return userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1;
}

function isIosSafari() {
    return userAgent.indexOf('iPhone') !== -1 && userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('CriOS') === -1;
}

function isIosChrome() {
    return userAgent.indexOf('CriOS') !== -1;
}

function isIosWeb() {
    return isIosSafari() || isIosChrome();
}

function isIos() {
    return userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPad') !== -1;
}

function isAndroid() {
    return userAgent.indexOf('Android') !== -1;
}

function isAndroidChrome() {
    return userAgent.indexOf('Android') !== -1 && userAgent.indexOf('Chrome') !== -1 && userAgent.indexOf('Version') === -1;
}

function isAndroidWeb() {
    return isAndroidChrome();
}

function isIosClassic() {
    return isMobileApp() && isIos();
}

// Returns true if and only if the user is using a Mattermost mobile app. This will return false if the user is using the
// web browser on a mobile device.
function isMobileApp() {
    return isMobile() && !isIosWeb() && !isAndroidWeb();
}

// Returns true if and only if the user is using Mattermost from either the mobile app or the web browser on a mobile device.
function isMobile() {
    return isIos() || isAndroid();
}

function isFirefox() {
    return userAgent.indexOf('Firefox') !== -1;
}

function isInternetExplorer() {
    return userAgent.indexOf('Trident') !== -1;
}

function isEdge() {
    return userAgent.indexOf('Edge') !== -1;
}

function isDesktopApp() {
    return userAgent.indexOf('Mattermost') !== -1 && userAgent.indexOf('Electron') !== -1;
}

function isWindowsApp() {
    return isDesktopApp() && userAgent.indexOf('Windows') !== -1;
}

function isMacApp() {
    return isDesktopApp() && userAgent.indexOf('Macintosh') !== -1;
}

function isWindows7() {
    var appVersion = navigator.appVersion;

    if (!appVersion) {
        return false;
    }

    return (/\bWindows NT 6\.1\b/.test(appVersion)
    );
}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _flux = __webpack_require__(1649);

var Flux = _interopRequireWildcard(_flux);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PayloadSources = _constants2.default.PayloadSources;

var AppDispatcher = (0, _assign2.default)(new Flux.Dispatcher(), {
    handleServerAction: function performServerAction(action) {
        if (!action.type) {
            console.warn('handleServerAction called with undefined action type'); // eslint-disable-line no-console
        }

        var payload = {
            source: PayloadSources.SERVER_ACTION,
            action: action
        };
        this.dispatch(payload);
    },

    handleViewAction: function performViewAction(action) {
        if (!action.type) {
            console.warn('handleViewAction called with undefined action type'); // eslint-disable-line no-console
        }

        var payload = {
            source: PayloadSources.VIEW_ACTION,
            action: action
        };
        this.dispatch(payload);
    }
});

exports.default = AppDispatcher;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingScreen = function (_React$Component) {
    (0, _inherits3.default)(LoadingScreen, _React$Component);

    function LoadingScreen(props) {
        (0, _classCallCheck3.default)(this, LoadingScreen);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoadingScreen.__proto__ || (0, _getPrototypeOf2.default)(LoadingScreen)).call(this, props));

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(LoadingScreen, [{
        key: 'render',
        value: function render() {
            var message = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'loading_screen.loading',
                defaultMessage: 'Loading'
            });

            if (this.props.message) {
                message = this.props.message;
            }

            return _react2.default.createElement(
                'div',
                {
                    className: 'loading-screen',
                    style: (0, _extends3.default)({ position: this.props.position }, this.props.style)
                },
                _react2.default.createElement(
                    'div',
                    { className: 'loading__content' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        message
                    ),
                    _react2.default.createElement('div', { className: 'round round-1' }),
                    _react2.default.createElement('div', { className: 'round round-2' }),
                    _react2.default.createElement('div', { className: 'round round-3' })
                )
            );
        }
    }]);
    return LoadingScreen;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

LoadingScreen.propTypes = {
    position: _propTypes2.default.oneOf(['absolute', 'fixed', 'relative', 'static', 'inherit']),
    style: _propTypes2.default.object,
    message: _propTypes2.default.node
};
LoadingScreen.defaultProps = {
    position: 'relative',
    style: {}
};
exports.default = LoadingScreen;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cleanUpUrlable = cleanUpUrlable;
exports.getShortenedURL = getShortenedURL;
exports.getSiteURL = getSiteURL;
exports.isUrlSafe = isUrlSafe;
exports.useSafeUrl = useSafeUrl;

var _latinise = __webpack_require__(1654);

function cleanUpUrlable(input) {
    var cleaned = (0, _latinise.latinise)(input);
    cleaned = cleaned.trim().replace(/-/g, ' ').replace(/[^\w\s]/gi, '').toLowerCase().replace(/\s/g, '-');
    cleaned = cleaned.replace(/-{2,}/, '-');
    cleaned = cleaned.replace(/^-+/, '');
    cleaned = cleaned.replace(/-+$/, '');
    return cleaned;
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getShortenedURL() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var getLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 27;

    if (url.length > 35) {
        var subLength = getLength - 14;
        return url.substring(0, 10) + '...' + url.substring(url.length - subLength, url.length) + '/';
    }
    return url + '/';
}

function getSiteURL() {
    if (window.location.origin) {
        return window.location.origin;
    }

    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

function isUrlSafe(url) {
    var unescaped = void 0;

    try {
        unescaped = decodeURIComponent(url);
    } catch (e) {
        unescaped = unescape(url);
    }

    unescaped = unescaped.replace(/[^\w:]/g, '').toLowerCase();

    return !unescaped.startsWith('javascript:') && // eslint-disable-line no-script-url
    !unescaped.startsWith('vbscript:') && !unescaped.startsWith('data:');
}

function useSafeUrl(url) {
    var defaultUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (isUrlSafe(url)) {
        return url;
    }

    return defaultUrl;
}

/***/ }),
/* 794 */,
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(949);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 796 */,
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.elasticsearchPurgeIndexes = exports.elasticsearchTest = exports.getUsersPerDayAnalytics = exports.getPostsPerDayAnalytics = exports.getAdvancedAnalytics = exports.getStandardAnalytics = exports.removeIdpSamlCertificate = exports.removePrivateSamlCertificate = exports.removePublicSamlCertificate = exports.uploadIdpSamlCertificate = exports.uploadPrivateSamlCertificate = exports.uploadPublicSamlCertificate = exports.removeLicenseFile = exports.uploadLicenseFile = exports.uploadBrandImage = exports.oauthToEmail = exports.emailToOAuth = exports.emailToLdap = exports.samlCertificateStatus = exports.adminResetPassword = exports.recycleDatabaseConnection = exports.invalidateAllCaches = exports.ldapTest = exports.getClusterStatus = exports.adminResetMfa = exports.reloadConfig = exports.saveConfig = undefined;

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var saveConfig = exports.saveConfig = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(config, success, error) {
        var _ref2, data, err;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return AdminActions.updateConfig(config)(dispatch, getState);

                    case 2:
                        _ref2 = _context.sent;
                        data = _ref2.data;
                        err = _ref2.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function saveConfig(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var reloadConfig = exports.reloadConfig = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(success, error) {
        var _ref4, data, err;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return AdminActions.reloadConfig()(dispatch, getState);

                    case 2:
                        _ref4 = _context2.sent;
                        data = _ref4.data;
                        err = _ref4.error;

                        if (data && success) {
                            AdminActions.getConfig()(dispatch, getState);
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function reloadConfig(_x4, _x5) {
        return _ref3.apply(this, arguments);
    };
}();

var adminResetMfa = exports.adminResetMfa = function () {
    var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(userId, success, error) {
        var _ref6, data, err;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return UserActions.updateUserMfa(userId, false)(dispatch, getState);

                    case 2:
                        _ref6 = _context3.sent;
                        data = _ref6.data;
                        err = _ref6.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function adminResetMfa(_x6, _x7, _x8) {
        return _ref5.apply(this, arguments);
    };
}();

var getClusterStatus = exports.getClusterStatus = function () {
    var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(success, error) {
        var _ref8, data, err;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return AdminActions.getClusterStatus()(dispatch, getState);

                    case 2:
                        _ref8 = _context4.sent;
                        data = _ref8.data;
                        err = _ref8.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function getClusterStatus(_x9, _x10) {
        return _ref7.apply(this, arguments);
    };
}();

var ldapTest = exports.ldapTest = function () {
    var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(success, error) {
        var _ref10, data, err;

        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return AdminActions.testLdap()(dispatch, getState);

                    case 2:
                        _ref10 = _context5.sent;
                        data = _ref10.data;
                        err = _ref10.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function ldapTest(_x11, _x12) {
        return _ref9.apply(this, arguments);
    };
}();

var invalidateAllCaches = exports.invalidateAllCaches = function () {
    var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(success, error) {
        var _ref12, data, err;

        return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return AdminActions.invalidateCaches()(dispatch, getState);

                    case 2:
                        _ref12 = _context6.sent;
                        data = _ref12.data;
                        err = _ref12.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function invalidateAllCaches(_x13, _x14) {
        return _ref11.apply(this, arguments);
    };
}();

var recycleDatabaseConnection = exports.recycleDatabaseConnection = function () {
    var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(success, error) {
        var _ref14, data, err;

        return _regenerator2.default.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return AdminActions.recycleDatabase()(dispatch, getState);

                    case 2:
                        _ref14 = _context7.sent;
                        data = _ref14.data;
                        err = _ref14.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function recycleDatabaseConnection(_x15, _x16) {
        return _ref13.apply(this, arguments);
    };
}();

var adminResetPassword = exports.adminResetPassword = function () {
    var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(userId, currentPassword, password, success, error) {
        var _ref16, data, err;

        return _regenerator2.default.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        _context8.next = 2;
                        return UserActions.updateUserPassword(userId, currentPassword, password)(dispatch, getState);

                    case 2:
                        _ref16 = _context8.sent;
                        data = _ref16.data;
                        err = _ref16.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function adminResetPassword(_x17, _x18, _x19, _x20, _x21) {
        return _ref15.apply(this, arguments);
    };
}();

var samlCertificateStatus = exports.samlCertificateStatus = function () {
    var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(success, error) {
        var _ref18, data, err;

        return _regenerator2.default.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.next = 2;
                        return AdminActions.getSamlCertificateStatus()(dispatch, getState);

                    case 2:
                        _ref18 = _context9.sent;
                        data = _ref18.data;
                        err = _ref18.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function samlCertificateStatus(_x22, _x23) {
        return _ref17.apply(this, arguments);
    };
}();

var emailToLdap = exports.emailToLdap = function () {
    var _ref19 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(loginId, password, token, ldapId, ldapPassword, success, error) {
        var _ref20, data, err;

        return _regenerator2.default.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        _context10.next = 2;
                        return UserActions.switchEmailToLdap(loginId, password, ldapId, ldapPassword, token)(dispatch, getState);

                    case 2:
                        _ref20 = _context10.sent;
                        data = _ref20.data;
                        err = _ref20.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function emailToLdap(_x24, _x25, _x26, _x27, _x28, _x29, _x30) {
        return _ref19.apply(this, arguments);
    };
}();

var emailToOAuth = exports.emailToOAuth = function () {
    var _ref21 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(loginId, password, token, newType, success, error) {
        var _ref22, data, err;

        return _regenerator2.default.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        _context11.next = 2;
                        return UserActions.switchEmailToOAuth(newType, loginId, password, token)(dispatch, getState);

                    case 2:
                        _ref22 = _context11.sent;
                        data = _ref22.data;
                        err = _ref22.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function emailToOAuth(_x31, _x32, _x33, _x34, _x35, _x36) {
        return _ref21.apply(this, arguments);
    };
}();

var oauthToEmail = exports.oauthToEmail = function () {
    var _ref23 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(currentService, email, password, success, error) {
        var _ref24, data, err;

        return _regenerator2.default.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        _context12.next = 2;
                        return UserActions.switchOAuthToEmail(currentService, email, password)(dispatch, getState);

                    case 2:
                        _ref24 = _context12.sent;
                        data = _ref24.data;
                        err = _ref24.error;

                        if (data) {
                            if (data.follow_link) {
                                (0, _global_actions.clientLogout)(data.follow_link);
                            }
                            if (success) {
                                success(data);
                            }
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function oauthToEmail(_x37, _x38, _x39, _x40, _x41) {
        return _ref23.apply(this, arguments);
    };
}();

var uploadBrandImage = exports.uploadBrandImage = function () {
    var _ref25 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(brandImage, success, error) {
        var _ref26, data, err;

        return _regenerator2.default.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        _context13.next = 2;
                        return AdminActions.uploadBrandImage(brandImage)(dispatch, getState);

                    case 2:
                        _ref26 = _context13.sent;
                        data = _ref26.data;
                        err = _ref26.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, this);
    }));

    return function uploadBrandImage(_x42, _x43, _x44) {
        return _ref25.apply(this, arguments);
    };
}();

var uploadLicenseFile = exports.uploadLicenseFile = function () {
    var _ref27 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(file, success, error) {
        var _ref28, data, err;

        return _regenerator2.default.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        _context14.next = 2;
                        return AdminActions.uploadLicense(file)(dispatch, getState);

                    case 2:
                        _ref28 = _context14.sent;
                        data = _ref28.data;
                        err = _ref28.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, this);
    }));

    return function uploadLicenseFile(_x45, _x46, _x47) {
        return _ref27.apply(this, arguments);
    };
}();

var removeLicenseFile = exports.removeLicenseFile = function () {
    var _ref29 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15(success, error) {
        var _ref30, data, err;

        return _regenerator2.default.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        _context15.next = 2;
                        return AdminActions.removeLicense()(dispatch, getState);

                    case 2:
                        _ref30 = _context15.sent;
                        data = _ref30.data;
                        err = _ref30.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, this);
    }));

    return function removeLicenseFile(_x48, _x49) {
        return _ref29.apply(this, arguments);
    };
}();

var uploadPublicSamlCertificate = exports.uploadPublicSamlCertificate = function () {
    var _ref31 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16(file, success, error) {
        var _ref32, data, err;

        return _regenerator2.default.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        _context16.next = 2;
                        return AdminActions.uploadPublicSamlCertificate(file)(dispatch, getState);

                    case 2:
                        _ref32 = _context16.sent;
                        data = _ref32.data;
                        err = _ref32.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, this);
    }));

    return function uploadPublicSamlCertificate(_x50, _x51, _x52) {
        return _ref31.apply(this, arguments);
    };
}();

var uploadPrivateSamlCertificate = exports.uploadPrivateSamlCertificate = function () {
    var _ref33 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17(file, success, error) {
        var _ref34, data, err;

        return _regenerator2.default.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        _context17.next = 2;
                        return AdminActions.uploadPrivateSamlCertificate(file)(dispatch, getState);

                    case 2:
                        _ref34 = _context17.sent;
                        data = _ref34.data;
                        err = _ref34.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, this);
    }));

    return function uploadPrivateSamlCertificate(_x53, _x54, _x55) {
        return _ref33.apply(this, arguments);
    };
}();

var uploadIdpSamlCertificate = exports.uploadIdpSamlCertificate = function () {
    var _ref35 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18(file, success, error) {
        var _ref36, data, err;

        return _regenerator2.default.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        _context18.next = 2;
                        return AdminActions.uploadIdpSamlCertificate(file)(dispatch, getState);

                    case 2:
                        _ref36 = _context18.sent;
                        data = _ref36.data;
                        err = _ref36.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context18.stop();
                }
            }
        }, _callee18, this);
    }));

    return function uploadIdpSamlCertificate(_x56, _x57, _x58) {
        return _ref35.apply(this, arguments);
    };
}();

var removePublicSamlCertificate = exports.removePublicSamlCertificate = function () {
    var _ref37 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19(success, error) {
        var _ref38, data, err;

        return _regenerator2.default.wrap(function _callee19$(_context19) {
            while (1) {
                switch (_context19.prev = _context19.next) {
                    case 0:
                        _context19.next = 2;
                        return AdminActions.removePublicSamlCertificate()(dispatch, getState);

                    case 2:
                        _ref38 = _context19.sent;
                        data = _ref38.data;
                        err = _ref38.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context19.stop();
                }
            }
        }, _callee19, this);
    }));

    return function removePublicSamlCertificate(_x59, _x60) {
        return _ref37.apply(this, arguments);
    };
}();

var removePrivateSamlCertificate = exports.removePrivateSamlCertificate = function () {
    var _ref39 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20(success, error) {
        var _ref40, data, err;

        return _regenerator2.default.wrap(function _callee20$(_context20) {
            while (1) {
                switch (_context20.prev = _context20.next) {
                    case 0:
                        _context20.next = 2;
                        return AdminActions.removePrivateSamlCertificate()(dispatch, getState);

                    case 2:
                        _ref40 = _context20.sent;
                        data = _ref40.data;
                        err = _ref40.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context20.stop();
                }
            }
        }, _callee20, this);
    }));

    return function removePrivateSamlCertificate(_x61, _x62) {
        return _ref39.apply(this, arguments);
    };
}();

var removeIdpSamlCertificate = exports.removeIdpSamlCertificate = function () {
    var _ref41 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21(success, error) {
        var _ref42, data, err;

        return _regenerator2.default.wrap(function _callee21$(_context21) {
            while (1) {
                switch (_context21.prev = _context21.next) {
                    case 0:
                        _context21.next = 2;
                        return AdminActions.removeIdpSamlCertificate()(dispatch, getState);

                    case 2:
                        _ref42 = _context21.sent;
                        data = _ref42.data;
                        err = _ref42.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context21.stop();
                }
            }
        }, _callee21, this);
    }));

    return function removeIdpSamlCertificate(_x63, _x64) {
        return _ref41.apply(this, arguments);
    };
}();

var getStandardAnalytics = exports.getStandardAnalytics = function () {
    var _ref43 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee22(teamId) {
        return _regenerator2.default.wrap(function _callee22$(_context22) {
            while (1) {
                switch (_context22.prev = _context22.next) {
                    case 0:
                        _context22.next = 2;
                        return AdminActions.getStandardAnalytics(teamId)(dispatch, getState);

                    case 2:
                    case 'end':
                        return _context22.stop();
                }
            }
        }, _callee22, this);
    }));

    return function getStandardAnalytics(_x65) {
        return _ref43.apply(this, arguments);
    };
}();

var getAdvancedAnalytics = exports.getAdvancedAnalytics = function () {
    var _ref44 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee23(teamId) {
        return _regenerator2.default.wrap(function _callee23$(_context23) {
            while (1) {
                switch (_context23.prev = _context23.next) {
                    case 0:
                        _context23.next = 2;
                        return AdminActions.getAdvancedAnalytics(teamId)(dispatch, getState);

                    case 2:
                    case 'end':
                        return _context23.stop();
                }
            }
        }, _callee23, this);
    }));

    return function getAdvancedAnalytics(_x66) {
        return _ref44.apply(this, arguments);
    };
}();

var getPostsPerDayAnalytics = exports.getPostsPerDayAnalytics = function () {
    var _ref45 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee24(teamId) {
        return _regenerator2.default.wrap(function _callee24$(_context24) {
            while (1) {
                switch (_context24.prev = _context24.next) {
                    case 0:
                        _context24.next = 2;
                        return AdminActions.getPostsPerDayAnalytics(teamId)(dispatch, getState);

                    case 2:
                    case 'end':
                        return _context24.stop();
                }
            }
        }, _callee24, this);
    }));

    return function getPostsPerDayAnalytics(_x67) {
        return _ref45.apply(this, arguments);
    };
}();

var getUsersPerDayAnalytics = exports.getUsersPerDayAnalytics = function () {
    var _ref46 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee25(teamId) {
        return _regenerator2.default.wrap(function _callee25$(_context25) {
            while (1) {
                switch (_context25.prev = _context25.next) {
                    case 0:
                        _context25.next = 2;
                        return AdminActions.getUsersPerDayAnalytics(teamId)(dispatch, getState);

                    case 2:
                    case 'end':
                        return _context25.stop();
                }
            }
        }, _callee25, this);
    }));

    return function getUsersPerDayAnalytics(_x68) {
        return _ref46.apply(this, arguments);
    };
}();

var elasticsearchTest = exports.elasticsearchTest = function () {
    var _ref47 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee26(config, success, error) {
        var _ref48, data, err;

        return _regenerator2.default.wrap(function _callee26$(_context26) {
            while (1) {
                switch (_context26.prev = _context26.next) {
                    case 0:
                        _context26.next = 2;
                        return AdminActions.testElasticsearch(config)(dispatch, getState);

                    case 2:
                        _ref48 = _context26.sent;
                        data = _ref48.data;
                        err = _ref48.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context26.stop();
                }
            }
        }, _callee26, this);
    }));

    return function elasticsearchTest(_x69, _x70, _x71) {
        return _ref47.apply(this, arguments);
    };
}();

var elasticsearchPurgeIndexes = exports.elasticsearchPurgeIndexes = function () {
    var _ref49 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee27(success, error) {
        var _ref50, data, err;

        return _regenerator2.default.wrap(function _callee27$(_context27) {
            while (1) {
                switch (_context27.prev = _context27.next) {
                    case 0:
                        _context27.next = 2;
                        return AdminActions.purgeElasticsearchIndexes()(dispatch, getState);

                    case 2:
                        _ref50 = _context27.sent;
                        data = _ref50.data;
                        err = _ref50.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context27.stop();
                }
            }
        }, _callee27, this);
    }));

    return function elasticsearchPurgeIndexes(_x72, _x73) {
        return _ref49.apply(this, arguments);
    };
}();

exports.getOAuthAppInfo = getOAuthAppInfo;
exports.allowOAuth2 = allowOAuth2;
exports.setNavigationBlocked = setNavigationBlocked;
exports.deferNavigation = deferNavigation;
exports.cancelNavigation = cancelNavigation;
exports.confirmNavigation = confirmNavigation;

var _admin = __webpack_require__(855);

var AdminActions = _interopRequireWildcard(_admin);

var _users = __webpack_require__(786);

var UserActions = _interopRequireWildcard(_users);

var _client = __webpack_require__(270);

var _global_actions = __webpack_require__(778);

var _admin2 = __webpack_require__(963);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

function getOAuthAppInfo(clientId, success, error) {
    _client.Client4.getOAuthAppInfo(clientId).then(function (data) {
        if (success) {
            success(data);
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function allowOAuth2(params, success, error) {
    var responseType = params.get('response_type');
    var clientId = params.get('client_id');
    var redirectUri = params.get('redirect_uri');
    var state = params.get('state');
    var scope = params.get('scope');

    _client.Client4.authorizeOAuthApp(responseType, clientId, redirectUri, state, scope).then(function (data) {
        if (success) {
            success(data);
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function setNavigationBlocked(blocked) {
    return {
        type: _constants.ActionTypes.SET_NAVIGATION_BLOCKED,
        blocked: blocked
    };
}

function deferNavigation(onNavigationConfirmed) {
    return {
        type: _constants.ActionTypes.DEFER_NAVIGATION,
        onNavigationConfirmed: onNavigationConfirmed
    };
}

function cancelNavigation() {
    return {
        type: _constants.ActionTypes.CANCEL_NAVIGATION
    };
}

function confirmNavigation() {
    // have to rename these because of lint no-shadow
    return function (thunkDispatch, thunkGetState) {
        var callback = (0, _admin2.getOnNavigationConfirmed)(thunkGetState());

        if (callback) {
            callback();
        }

        thunkDispatch({
            type: _constants.ActionTypes.CONFIRM_NAVIGATION
        });
    };
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.selectChannel = selectChannel;
exports.createChannel = createChannel;
exports.createDirectChannel = createDirectChannel;
exports.createGroupChannel = createGroupChannel;
exports.patchChannel = patchChannel;
exports.updateChannel = updateChannel;
exports.updateChannelNotifyProps = updateChannelNotifyProps;
exports.getChannelByNameAndTeamName = getChannelByNameAndTeamName;
exports.getChannel = getChannel;
exports.getChannelAndMyMember = getChannelAndMyMember;
exports.fetchMyChannelsAndMembers = fetchMyChannelsAndMembers;
exports.getMyChannelMembers = getMyChannelMembers;
exports.getChannelMembers = getChannelMembers;
exports.leaveChannel = leaveChannel;
exports.joinChannel = joinChannel;
exports.deleteChannel = deleteChannel;
exports.viewChannel = viewChannel;
exports.markChannelAsViewed = markChannelAsViewed;
exports.getChannels = getChannels;
exports.autocompleteChannels = autocompleteChannels;
exports.searchChannels = searchChannels;
exports.getChannelStats = getChannelStats;
exports.addChannelMember = addChannelMember;
exports.removeChannelMember = removeChannelMember;
exports.updateChannelMemberRoles = updateChannelMemberRoles;
exports.updateChannelHeader = updateChannelHeader;
exports.updateChannelPurpose = updateChannelPurpose;
exports.markChannelAsRead = markChannelAsRead;
exports.markChannelAsUnread = markChannelAsUnread;
exports.getChannelMembersByIds = getChannelMembersByIds;
exports.getChannelMember = getChannelMember;
exports.getMyChannelMember = getMyChannelMember;
exports.favoriteChannel = favoriteChannel;
exports.unfavoriteChannel = unfavoriteChannel;

var _reduxBatchedActions = __webpack_require__(278);

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _action_types = __webpack_require__(3);

var _preferences = __webpack_require__(861);

var _channel_utils = __webpack_require__(854);

var _errors = __webpack_require__(828);

var _helpers = __webpack_require__(821);

var _users = __webpack_require__(786);

var _roles = __webpack_require__(860);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function selectChannel(channelId) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            dispatch({
                                type: _action_types.ChannelTypes.SELECT_CHANNEL,
                                data: channelId
                            }, getState);
                            _context.next = 8;
                            break;

                        case 4:
                            _context.prev = 4;
                            _context.t0 = _context['catch'](0);

                            (0, _errors.logError)(_context.t0)(dispatch);
                            return _context.abrupt('return', { error: _context.t0 });

                        case 8:
                            return _context.abrupt('return', { data: true });

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[0, 4]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function createChannel(channel, userId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var created, member, actions, _getState$entities$ch, channels, myMembers;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_REQUEST
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST
                            }]), getState);

                            created = void 0;
                            _context2.prev = 2;
                            _context2.next = 5;
                            return _client.Client4.createChannel(channel);

                        case 5:
                            created = _context2.sent;
                            _context2.next = 13;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE,
                                error: _context2.t0
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE,
                                error: _context2.t0
                            }, (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', { error: _context2.t0 });

                        case 13:
                            member = {
                                channel_id: created.id,
                                user_id: userId,
                                roles: _constants.General.CHANNEL_USER_ROLE + ' ' + _constants.General.CHANNEL_ADMIN_ROLE,
                                last_viewed_at: 0,
                                msg_count: 0,
                                mention_count: 0,
                                notify_props: { desktop: 'default', mark_unread: 'all' },
                                last_update_at: created.create_at
                            };
                            actions = [];
                            _getState$entities$ch = getState().entities.channels, channels = _getState$entities$ch.channels, myMembers = _getState$entities$ch.myMembers;


                            if (!channels[created.id]) {
                                actions.push({ type: _action_types.ChannelTypes.RECEIVED_CHANNEL, data: created });
                            }

                            if (!myMembers[created.id]) {
                                actions.push({ type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER, data: member });
                                dispatch((0, _roles.loadRolesIfNeeded)(member.roles.split(' ')));
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(actions, [{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }])), getState);

                            return _context2.abrupt('return', { data: created });

                        case 20:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[2, 8]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function createDirectChannel(userId, otherUserId) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var created, member, preferences;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CREATE_CHANNEL_REQUEST }, getState);

                            created = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.createDirectChannel([userId, otherUserId]);

                        case 5:
                            created = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE, error: _context3.t0 }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', { error: _context3.t0 });

                        case 13:
                            member = {
                                channel_id: created.id,
                                user_id: userId,
                                roles: '' + _constants.General.CHANNEL_USER_ROLE,
                                last_viewed_at: 0,
                                msg_count: 0,
                                mention_count: 0,
                                notify_props: { desktop: 'default', mark_unread: 'all' },
                                last_update_at: created.create_at
                            };
                            preferences = [{ user_id: userId, category: _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, name: otherUserId, value: 'true' }, { user_id: userId, category: _constants.Preferences.CATEGORY_CHANNEL_OPEN_TIME, name: created.id, value: new Date().getTime().toString() }];


                            (0, _preferences.savePreferences)(userId, preferences)(dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: created
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                                data: preferences
                            }, {
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL,
                                id: created.id,
                                data: [{ id: userId }, { id: otherUserId }]
                            }]), getState);
                            dispatch((0, _roles.loadRolesIfNeeded)(member.roles.split(' ')));

                            return _context3.abrupt('return', { data: created });

                        case 19:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function createGroupChannel(userIds) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var currentUserId, created, member, preferences, profilesInChannel;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CREATE_CHANNEL_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            created = void 0;
                            _context4.prev = 3;
                            _context4.next = 6;
                            return _client.Client4.createGroupChannel(userIds);

                        case 6:
                            created = _context4.sent;
                            _context4.next = 14;
                            break;

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', { error: _context4.t0 });

                        case 14:
                            member = {
                                channel_id: created.id,
                                user_id: currentUserId,
                                roles: '' + _constants.General.CHANNEL_USER_ROLE,
                                last_viewed_at: 0,
                                msg_count: 0,
                                mention_count: 0,
                                notify_props: { desktop: 'default', mark_unread: 'all' },
                                last_update_at: created.create_at
                            };
                            preferences = [{ user_id: currentUserId, category: _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, name: created.id, value: 'true' }, { user_id: currentUserId, category: _constants.Preferences.CATEGORY_CHANNEL_OPEN_TIME, name: created.id, value: new Date().getTime().toString() }];


                            (0, _preferences.savePreferences)(currentUserId, preferences)(dispatch, getState);

                            profilesInChannel = userIds.map(function (id) {
                                return { id: id };
                            });

                            profilesInChannel.push({ id: currentUserId }); // currentUserId is optionally in userIds, but the reducer will get rid of a duplicate

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: created
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                                data: preferences
                            }, {
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL,
                                id: created.id,
                                data: profilesInChannel
                            }]), getState);
                            dispatch((0, _roles.loadRolesIfNeeded)(member.roles.split(' ')));

                            return _context4.abrupt('return', { data: created });

                        case 22:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[3, 9]]);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function patchChannel(channelId, patch) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var updated;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            updated = void 0;
                            _context5.prev = 2;
                            _context5.next = 5;
                            return _client.Client4.patchChannel(channelId, patch);

                        case 5:
                            updated = _context5.sent;
                            _context5.next = 13;
                            break;

                        case 8:
                            _context5.prev = 8;
                            _context5.t0 = _context5['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context5.t0 }, (0, _errors.logError)(_context5.t0)(dispatch)]), getState);
                            return _context5.abrupt('return', { error: _context5.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: updated
                            }, {
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context5.abrupt('return', { data: updated });

                        case 15:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[2, 8]]);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function updateChannel(channel) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var updated;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            updated = void 0;
                            _context6.prev = 2;
                            _context6.next = 5;
                            return _client.Client4.updateChannel(channel);

                        case 5:
                            updated = _context6.sent;
                            _context6.next = 13;
                            break;

                        case 8:
                            _context6.prev = 8;
                            _context6.t0 = _context6['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context6.t0 }, (0, _errors.logError)(_context6.t0)(dispatch)]), getState);
                            return _context6.abrupt('return', { error: _context6.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: updated
                            }, {
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context6.abrupt('return', { data: updated });

                        case 15:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[2, 8]]);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function updateChannelNotifyProps(userId, channelId, props) {
    var _this7 = this;

    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var notifyProps, member, currentNotifyProps;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.NOTIFY_PROPS_REQUEST }, getState);

                            notifyProps = _extends({
                                user_id: userId,
                                channel_id: channelId
                            }, props);
                            _context7.prev = 2;
                            _context7.next = 5;
                            return _client.Client4.updateChannelNotifyProps(notifyProps);

                        case 5:
                            _context7.next = 12;
                            break;

                        case 7:
                            _context7.prev = 7;
                            _context7.t0 = _context7['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.NOTIFY_PROPS_FAILURE, error: _context7.t0 }, (0, _errors.logError)(_context7.t0)(dispatch)]), getState);
                            return _context7.abrupt('return', { error: _context7.t0 });

                        case 12:
                            member = getState().entities.channels.myMembers[channelId] || {};
                            currentNotifyProps = member.notify_props || {};


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_PROPS,
                                data: {
                                    channel_id: channelId,
                                    notifyProps: _extends({}, currentNotifyProps, notifyProps)
                                }
                            }, {
                                type: _action_types.ChannelTypes.NOTIFY_PROPS_SUCCESS
                            }]), getState);

                            return _context7.abrupt('return', { data: true });

                        case 16:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[2, 7]]);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function getChannelByNameAndTeamName(teamName, channelName) {
    var _this8 = this;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_REQUEST }, getState);

                            data = void 0;
                            _context8.prev = 2;
                            _context8.next = 5;
                            return _client.Client4.getChannelByNameAndTeamName(teamName, channelName);

                        case 5:
                            data = _context8.sent;
                            _context8.next = 13;
                            break;

                        case 8:
                            _context8.prev = 8;
                            _context8.t0 = _context8['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context8.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context8.t0 }, (0, _errors.logError)(_context8.t0)(dispatch)]), getState);
                            return _context8.abrupt('return', { error: _context8.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: data
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_SUCCESS
                            }]), getState);

                            return _context8.abrupt('return', { data: data });

                        case 15:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8, [[2, 8]]);
        }));

        return function (_x15, _x16) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function getChannel(channelId) {
    var _this9 = this;

    return function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_REQUEST }, getState);

                            data = void 0;
                            _context9.prev = 2;
                            _context9.next = 5;
                            return _client.Client4.getChannel(channelId);

                        case 5:
                            data = _context9.sent;
                            _context9.next = 13;
                            break;

                        case 8:
                            _context9.prev = 8;
                            _context9.t0 = _context9['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context9.t0 }, (0, _errors.logError)(_context9.t0)(dispatch)]), getState);
                            return _context9.abrupt('return', { error: _context9.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: data
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_SUCCESS
                            }]), getState);

                            return _context9.abrupt('return', { data: data });

                        case 15:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9, [[2, 8]]);
        }));

        return function (_x17, _x18) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function getChannelAndMyMember(channelId) {
    var _this10 = this;

    return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var channel, member, channelRequest, memberRequest;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_REQUEST }, getState);

                            channel = void 0;
                            member = void 0;
                            _context10.prev = 3;
                            channelRequest = _client.Client4.getChannel(channelId);
                            memberRequest = _client.Client4.getMyChannelMember(channelId);
                            _context10.next = 8;
                            return channelRequest;

                        case 8:
                            channel = _context10.sent;
                            _context10.next = 11;
                            return memberRequest;

                        case 11:
                            member = _context10.sent;
                            _context10.next = 19;
                            break;

                        case 14:
                            _context10.prev = 14;
                            _context10.t0 = _context10['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context10.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context10.t0 }, (0, _errors.logError)(_context10.t0)(dispatch)]), getState);
                            return _context10.abrupt('return', { error: _context10.t0 });

                        case 19:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: channel
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }]), getState);
                            dispatch((0, _roles.loadRolesIfNeeded)(member.roles.split(' ')));

                            return _context10.abrupt('return', { data: { channel: channel, member: member } });

                        case 22:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10, [[3, 14]]);
        }));

        return function (_x19, _x20) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function fetchMyChannelsAndMembers(teamId) {
    var _this11 = this;

    return function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var channelsRequest, channelMembersRequest, channels, channelMembers, currentUserId, roles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, member, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, role;

            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CHANNELS_REQUEST
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST
                            }]), getState);

                            channelsRequest = _client.Client4.getMyChannels(teamId);
                            channelMembersRequest = _client.Client4.getMyChannelMembers(teamId);
                            channels = void 0;
                            _context11.prev = 4;
                            _context11.next = 7;
                            return channelsRequest;

                        case 7:
                            channels = _context11.sent;
                            _context11.next = 15;
                            break;

                        case 10:
                            _context11.prev = 10;
                            _context11.t0 = _context11['catch'](4);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context11.t0 }, { type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', { error: _context11.t0 });

                        case 15:
                            channelMembers = void 0;
                            _context11.prev = 16;
                            _context11.next = 19;
                            return channelMembersRequest;

                        case 19:
                            channelMembers = _context11.sent;
                            _context11.next = 27;
                            break;

                        case 22:
                            _context11.prev = 22;
                            _context11.t1 = _context11['catch'](16);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t1, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context11.t1 }, { type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context11.t1 }, (0, _errors.logError)(_context11.t1)(dispatch)]), getState);
                            return _context11.abrupt('return', { error: _context11.t1 });

                        case 27:
                            currentUserId = getState().entities.users.currentUserId;


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                                teamId: teamId,
                                data: channels
                            }, {
                                type: _action_types.ChannelTypes.CHANNELS_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                                data: channelMembers,
                                remove: (0, _channel_utils.getChannelsIdForTeam)(getState(), teamId),
                                currentUserId: currentUserId
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }]), getState);
                            roles = new Set();
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context11.prev = 33;
                            _iterator = channelMembers[Symbol.iterator]();

                        case 35:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context11.next = 59;
                                break;
                            }

                            member = _step.value;
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context11.prev = 40;

                            for (_iterator2 = member.roles.split(' ')[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                role = _step2.value;

                                roles.add(role);
                            }
                            _context11.next = 48;
                            break;

                        case 44:
                            _context11.prev = 44;
                            _context11.t2 = _context11['catch'](40);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context11.t2;

                        case 48:
                            _context11.prev = 48;
                            _context11.prev = 49;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 51:
                            _context11.prev = 51;

                            if (!_didIteratorError2) {
                                _context11.next = 54;
                                break;
                            }

                            throw _iteratorError2;

                        case 54:
                            return _context11.finish(51);

                        case 55:
                            return _context11.finish(48);

                        case 56:
                            _iteratorNormalCompletion = true;
                            _context11.next = 35;
                            break;

                        case 59:
                            _context11.next = 65;
                            break;

                        case 61:
                            _context11.prev = 61;
                            _context11.t3 = _context11['catch'](33);
                            _didIteratorError = true;
                            _iteratorError = _context11.t3;

                        case 65:
                            _context11.prev = 65;
                            _context11.prev = 66;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 68:
                            _context11.prev = 68;

                            if (!_didIteratorError) {
                                _context11.next = 71;
                                break;
                            }

                            throw _iteratorError;

                        case 71:
                            return _context11.finish(68);

                        case 72:
                            return _context11.finish(65);

                        case 73:
                            if (roles.size > 0) {
                                dispatch((0, _roles.loadRolesIfNeeded)(roles));
                            }

                            return _context11.abrupt('return', { data: { channels: channels, members: channelMembers } });

                        case 75:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11, [[4, 10], [16, 22], [33, 61, 65, 73], [40, 44, 48, 56], [49,, 51, 55], [66,, 68, 72]]);
        }));

        return function (_x21, _x22) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function getMyChannelMembers(teamId) {
    var _this12 = this;

    return function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            var channelMembers, channelMembersRequest, currentUserId, roles, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, member, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, role;

            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_REQUEST }, getState);

                            channelMembers = void 0;
                            _context12.prev = 2;
                            channelMembersRequest = _client.Client4.getMyChannelMembers(teamId);
                            _context12.next = 6;
                            return channelMembersRequest;

                        case 6:
                            channelMembers = _context12.sent;
                            _context12.next = 14;
                            break;

                        case 9:
                            _context12.prev = 9;
                            _context12.t0 = _context12['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context12.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_FAILURE, error: _context12.t0 }, (0, _errors.logError)(_context12.t0)(dispatch)]), getState);
                            return _context12.abrupt('return', { error: _context12.t0 });

                        case 14:
                            currentUserId = getState().entities.users.currentUserId;


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                                data: channelMembers,
                                remove: (0, _channel_utils.getChannelsIdForTeam)(getState(), teamId),
                                currentUserId: currentUserId
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_SUCCESS
                            }]), getState);

                            roles = new Set();
                            _iteratorNormalCompletion3 = true;
                            _didIteratorError3 = false;
                            _iteratorError3 = undefined;
                            _context12.prev = 20;
                            _iterator3 = channelMembers[Symbol.iterator]();

                        case 22:
                            if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                                _context12.next = 46;
                                break;
                            }

                            member = _step3.value;
                            _iteratorNormalCompletion4 = true;
                            _didIteratorError4 = false;
                            _iteratorError4 = undefined;
                            _context12.prev = 27;

                            for (_iterator4 = member.roles.split(' ')[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                role = _step4.value;

                                roles.add(role);
                            }
                            _context12.next = 35;
                            break;

                        case 31:
                            _context12.prev = 31;
                            _context12.t1 = _context12['catch'](27);
                            _didIteratorError4 = true;
                            _iteratorError4 = _context12.t1;

                        case 35:
                            _context12.prev = 35;
                            _context12.prev = 36;

                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }

                        case 38:
                            _context12.prev = 38;

                            if (!_didIteratorError4) {
                                _context12.next = 41;
                                break;
                            }

                            throw _iteratorError4;

                        case 41:
                            return _context12.finish(38);

                        case 42:
                            return _context12.finish(35);

                        case 43:
                            _iteratorNormalCompletion3 = true;
                            _context12.next = 22;
                            break;

                        case 46:
                            _context12.next = 52;
                            break;

                        case 48:
                            _context12.prev = 48;
                            _context12.t2 = _context12['catch'](20);
                            _didIteratorError3 = true;
                            _iteratorError3 = _context12.t2;

                        case 52:
                            _context12.prev = 52;
                            _context12.prev = 53;

                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }

                        case 55:
                            _context12.prev = 55;

                            if (!_didIteratorError3) {
                                _context12.next = 58;
                                break;
                            }

                            throw _iteratorError3;

                        case 58:
                            return _context12.finish(55);

                        case 59:
                            return _context12.finish(52);

                        case 60:
                            if (roles.size > 0) {
                                dispatch((0, _roles.loadRolesIfNeeded)(roles));
                            }

                            return _context12.abrupt('return', { data: channelMembers });

                        case 62:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12, [[2, 9], [20, 48, 52, 60], [27, 31, 35, 43], [36,, 38, 42], [53,, 55, 59]]);
        }));

        return function (_x23, _x24) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function getChannelMembers(channelId) {
    var _this13 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.CHANNELS_CHUNK_SIZE;

    return function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var channelMembers, channelMembersRequest, userIds;
            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST }, getState);

                            channelMembers = void 0;
                            _context13.prev = 2;
                            channelMembersRequest = _client.Client4.getChannelMembers(channelId, page, perPage);
                            _context13.next = 6;
                            return channelMembersRequest;

                        case 6:
                            channelMembers = _context13.sent;
                            _context13.next = 14;
                            break;

                        case 9:
                            _context13.prev = 9;
                            _context13.t0 = _context13['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context13.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context13.t0 }, (0, _errors.logError)(_context13.t0)(dispatch)]), getState);
                            return _context13.abrupt('return', { error: _context13.t0 });

                        case 14:
                            userIds = channelMembers.map(function (cm) {
                                return cm.user_id;
                            });

                            (0, _users.getMissingProfilesByIds)(userIds)(dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
                                data: channelMembers
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }]), getState);

                            return _context13.abrupt('return', { data: channelMembers });

                        case 18:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13, [[2, 9]]);
        }));

        return function (_x27, _x28) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function leaveChannel(channelId) {
    var _this14 = this;

    return function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(dispatch, getState) {
            var state, currentUserId, _state$entities$chann, channels, myMembers, channel, member;

            return regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            state = getState();
                            currentUserId = state.entities.users.currentUserId;
                            _state$entities$chann = state.entities.channels, channels = _state$entities$chann.channels, myMembers = _state$entities$chann.myMembers;
                            channel = channels[channelId];
                            member = myMembers[channelId];


                            _client.Client4.trackEvent('action', 'action_channels_leave', { channel_id: channelId });

                            dispatch({
                                type: _action_types.ChannelTypes.LEAVE_CHANNEL,
                                data: {
                                    id: channelId,
                                    user_id: currentUserId,
                                    team_id: channel.team_id,
                                    type: channel.type
                                },
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.removeFromChannel(currentUserId, channelId);
                                        },
                                        commit: { type: _action_types.ChannelTypes.LEAVE_CHANNEL },
                                        rollback: function rollback() {
                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                                data: channel
                                            }, {
                                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                                data: member
                                            }]));
                                        }
                                    }
                                }
                            });

                            return _context14.abrupt('return', { data: true });

                        case 8:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14);
        }));

        return function (_x29, _x30) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function joinChannel(userId, teamId, channelId, channelName) {
    var _this15 = this;

    return function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(dispatch, getState) {
            var member, channel;
            return regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.JOIN_CHANNEL_REQUEST }, getState);

                            member = void 0;
                            channel = void 0;
                            _context15.prev = 3;

                            if (!channelId) {
                                _context15.next = 13;
                                break;
                            }

                            _context15.next = 7;
                            return _client.Client4.addToChannel(userId, channelId);

                        case 7:
                            member = _context15.sent;
                            _context15.next = 10;
                            return _client.Client4.getChannel(channelId);

                        case 10:
                            channel = _context15.sent;
                            _context15.next = 26;
                            break;

                        case 13:
                            if (!channelName) {
                                _context15.next = 26;
                                break;
                            }

                            _context15.next = 16;
                            return _client.Client4.getChannelByName(teamId, channelName);

                        case 16:
                            channel = _context15.sent;

                            if (!(channel.type === _constants.General.GM_CHANNEL || channel.type === _constants.General.DM_CHANNEL)) {
                                _context15.next = 23;
                                break;
                            }

                            _context15.next = 20;
                            return _client.Client4.getChannelMember(channel.id, userId);

                        case 20:
                            member = _context15.sent;
                            _context15.next = 26;
                            break;

                        case 23:
                            _context15.next = 25;
                            return _client.Client4.addToChannel(userId, channel.id);

                        case 25:
                            member = _context15.sent;

                        case 26:
                            _context15.next = 33;
                            break;

                        case 28:
                            _context15.prev = 28;
                            _context15.t0 = _context15['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context15.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.JOIN_CHANNEL_FAILURE, error: _context15.t0 }, (0, _errors.logError)(_context15.t0)(dispatch)]), getState);
                            return _context15.abrupt('return', { error: _context15.t0 });

                        case 33:

                            _client.Client4.trackEvent('action', 'action_channels_join', { channel_id: channelId });

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: channel
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.ChannelTypes.JOIN_CHANNEL_SUCCESS
                            }]), getState);
                            dispatch((0, _roles.loadRolesIfNeeded)(member.roles.split(' ')));

                            return _context15.abrupt('return', { data: { channel: channel, member: member } });

                        case 37:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15, [[3, 28]]);
        }));

        return function (_x31, _x32) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function deleteChannel(channelId) {
    var _this16 = this;

    return function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(dispatch, getState) {
            var entities, _entities$channels, channels, currentChannelId, channel, defaultChannelId, teamId;

            return regeneratorRuntime.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.DELETE_CHANNEL_REQUEST }, getState);

                            _context16.prev = 1;
                            _context16.next = 4;
                            return _client.Client4.deleteChannel(channelId);

                        case 4:
                            _context16.next = 11;
                            break;

                        case 6:
                            _context16.prev = 6;
                            _context16.t0 = _context16['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context16.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.DELETE_CHANNEL_FAILURE, error: _context16.t0 }, (0, _errors.logError)(_context16.t0)(dispatch)]), getState);
                            return _context16.abrupt('return', { error: _context16.t0 });

                        case 11:
                            entities = getState().entities;
                            _entities$channels = entities.channels, channels = _entities$channels.channels, currentChannelId = _entities$channels.currentChannelId;

                            if (channelId === currentChannelId) {
                                channel = Object.keys(channels).filter(function (key) {
                                    return channels[key].name === _constants.General.DEFAULT_CHANNEL;
                                });
                                defaultChannelId = '';

                                if (channel.length) {
                                    defaultChannelId = channel[0];
                                }

                                dispatch({ type: _action_types.ChannelTypes.SELECT_CHANNEL, data: defaultChannelId }, getState);
                            }

                            teamId = channels[channelId] ? channels[channelId].team_id : '';


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED,
                                data: { id: channelId, team_id: teamId }
                            }, {
                                type: _action_types.ChannelTypes.DELETE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context16.abrupt('return', { data: true });

                        case 17:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16, [[1, 6]]);
        }));

        return function (_x33, _x34) {
            return _ref16.apply(this, arguments);
        };
    }();
}

function viewChannel(channelId) {
    var _this17 = this;

    var prevChannelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(dispatch, getState) {
            var currentUserId, myPreferences, viewTimePref, viewTime, preferences, actions, myMembers, member, prevMember;
            return regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            currentUserId = getState().entities.users.currentUserId;
                            myPreferences = getState().entities.preferences.myPreferences;
                            viewTimePref = myPreferences[_constants.Preferences.CATEGORY_CHANNEL_APPROXIMATE_VIEW_TIME + '--' + channelId];
                            viewTime = viewTimePref ? parseInt(viewTimePref.value, 10) : 0;

                            if (viewTime < new Date().getTime() - 3 * 60 * 60 * 1000) {
                                preferences = [{ user_id: currentUserId, category: _constants.Preferences.CATEGORY_CHANNEL_APPROXIMATE_VIEW_TIME, name: channelId, value: new Date().getTime().toString() }];

                                (0, _preferences.savePreferences)(currentUserId, preferences)(dispatch, getState);
                            }

                            dispatch({ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_REQUEST }, getState);

                            _context17.prev = 6;
                            _context17.next = 9;
                            return _client.Client4.viewMyChannel(channelId, prevChannelId);

                        case 9:
                            _context17.next = 16;
                            break;

                        case 11:
                            _context17.prev = 11;
                            _context17.t0 = _context17['catch'](6);

                            (0, _helpers.forceLogoutIfNecessary)(_context17.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_FAILURE, error: _context17.t0 }, (0, _errors.logError)(_context17.t0)(dispatch)]), getState);
                            return _context17.abrupt('return', { error: _context17.t0 });

                        case 16:
                            actions = [{ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_SUCCESS }];
                            myMembers = getState().entities.channels.myMembers;
                            member = myMembers[channelId];

                            if (member) {
                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                    data: _extends({}, member, { last_viewed_at: new Date().getTime() })
                                });
                                dispatch((0, _roles.loadRolesIfNeeded)(member.roles.split(' ')));
                            }

                            prevMember = myMembers[prevChannelId];

                            if (prevMember) {
                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                    data: _extends({}, prevMember, { last_viewed_at: new Date().getTime() })
                                });
                                dispatch((0, _roles.loadRolesIfNeeded)(prevMember.roles.split(' ')));
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context17.abrupt('return', { data: true });

                        case 24:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17, [[6, 11]]);
        }));

        return function (_x36, _x37) {
            return _ref17.apply(this, arguments);
        };
    }();
}

function markChannelAsViewed(channelId) {
    var _this18 = this;

    var prevChannelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(dispatch, getState) {
            var actions, myMembers, member, prevMember;
            return regeneratorRuntime.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            actions = [];
                            myMembers = getState().entities.channels.myMembers;
                            member = myMembers[channelId];

                            if (member) {
                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                    data: _extends({}, member, { last_viewed_at: Date.now() })
                                });
                                dispatch((0, _roles.loadRolesIfNeeded)(member.roles.split(' ')));
                            }

                            prevMember = myMembers[prevChannelId];

                            if (prevMember) {
                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                    data: _extends({}, prevMember, { last_viewed_at: Date.now() })
                                });
                                dispatch((0, _roles.loadRolesIfNeeded)(prevMember.roles.split(' ')));
                            }

                            if (actions.length) {
                                dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);
                            }

                            return _context18.abrupt('return', { data: true });

                        case 8:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18);
        }));

        return function (_x39, _x40) {
            return _ref18.apply(this, arguments);
        };
    }();
}

function getChannels(teamId) {
    var _this19 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.CHANNELS_CHUNK_SIZE;

    return function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(dispatch, getState) {
            var channels;
            return regeneratorRuntime.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.GET_CHANNELS_REQUEST }, getState);

                            channels = void 0;
                            _context19.prev = 2;
                            _context19.next = 5;
                            return _client.Client4.getChannels(teamId, page, perPage);

                        case 5:
                            channels = _context19.sent;
                            _context19.next = 13;
                            break;

                        case 8:
                            _context19.prev = 8;
                            _context19.t0 = _context19['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context19.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.GET_CHANNELS_FAILURE, error: _context19.t0 }, (0, _errors.logError)(_context19.t0)(dispatch)]), getState);
                            return _context19.abrupt('return', { error: _context19.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                                teamId: teamId,
                                data: channels
                            }, {
                                type: _action_types.ChannelTypes.GET_CHANNELS_SUCCESS
                            }]), getState);

                            return _context19.abrupt('return', { data: channels });

                        case 15:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, _this19, [[2, 8]]);
        }));

        return function (_x43, _x44) {
            return _ref19.apply(this, arguments);
        };
    }();
}

function autocompleteChannels(teamId, term) {
    var _this20 = this;

    return function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(dispatch, getState) {
            var channels;
            return regeneratorRuntime.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.GET_CHANNELS_REQUEST }, getState);

                            channels = void 0;
                            _context20.prev = 2;
                            _context20.next = 5;
                            return _client.Client4.autocompleteChannels(teamId, term);

                        case 5:
                            channels = _context20.sent;
                            _context20.next = 13;
                            break;

                        case 8:
                            _context20.prev = 8;
                            _context20.t0 = _context20['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context20.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.GET_CHANNELS_FAILURE, error: _context20.t0 }, (0, _errors.logError)(_context20.t0)(dispatch)]), getState);
                            return _context20.abrupt('return', { error: _context20.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                                teamId: teamId,
                                data: channels
                            }, {
                                type: _action_types.ChannelTypes.GET_CHANNELS_SUCCESS
                            }]), getState);

                            return _context20.abrupt('return', { data: channels });

                        case 15:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, _this20, [[2, 8]]);
        }));

        return function (_x45, _x46) {
            return _ref20.apply(this, arguments);
        };
    }();
}

function searchChannels(teamId, term) {
    var _this21 = this;

    return function () {
        var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(dispatch, getState) {
            var channels;
            return regeneratorRuntime.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.GET_CHANNELS_REQUEST }, getState);

                            channels = void 0;
                            _context21.prev = 2;
                            _context21.next = 5;
                            return _client.Client4.searchChannels(teamId, term);

                        case 5:
                            channels = _context21.sent;
                            _context21.next = 13;
                            break;

                        case 8:
                            _context21.prev = 8;
                            _context21.t0 = _context21['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context21.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.GET_CHANNELS_FAILURE, error: _context21.t0 }, (0, _errors.logError)(_context21.t0)(dispatch)]), getState);
                            return _context21.abrupt('return', { error: _context21.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                                teamId: teamId,
                                data: channels
                            }, {
                                type: _action_types.ChannelTypes.GET_CHANNELS_SUCCESS
                            }]), getState);

                            return _context21.abrupt('return', { data: channels });

                        case 15:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, _this21, [[2, 8]]);
        }));

        return function (_x47, _x48) {
            return _ref21.apply(this, arguments);
        };
    }();
}

function getChannelStats(channelId) {
    var _this22 = this;

    return function () {
        var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(dispatch, getState) {
            var stat;
            return regeneratorRuntime.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_STATS_REQUEST }, getState);

                            stat = void 0;
                            _context22.prev = 2;
                            _context22.next = 5;
                            return _client.Client4.getChannelStats(channelId);

                        case 5:
                            stat = _context22.sent;
                            _context22.next = 13;
                            break;

                        case 8:
                            _context22.prev = 8;
                            _context22.t0 = _context22['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context22.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNEL_STATS_FAILURE, error: _context22.t0 }, (0, _errors.logError)(_context22.t0)(dispatch)]), getState);
                            return _context22.abrupt('return', { error: _context22.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_STATS,
                                data: stat
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_STATS_SUCCESS
                            }]), getState);

                            return _context22.abrupt('return', { data: stat });

                        case 15:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this22, [[2, 8]]);
        }));

        return function (_x49, _x50) {
            return _ref22.apply(this, arguments);
        };
    }();
}

function addChannelMember(channelId, userId) {
    var _this23 = this;

    var postRootId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return function () {
        var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(dispatch, getState) {
            var member;
            return regeneratorRuntime.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST }, getState);

                            member = void 0;
                            _context23.prev = 2;
                            _context23.next = 5;
                            return _client.Client4.addToChannel(userId, channelId, postRootId);

                        case 5:
                            member = _context23.sent;
                            _context23.next = 13;
                            break;

                        case 8:
                            _context23.prev = 8;
                            _context23.t0 = _context23['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context23.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error: _context23.t0 }, (0, _errors.logError)(_context23.t0)(dispatch)]), getState);
                            return _context23.abrupt('return', { error: _context23.t0 });

                        case 13:

                            _client.Client4.trackEvent('action', 'action_channels_add_member', { channel_id: channelId });

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                                data: { user_id: userId },
                                id: channelId
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
                                id: channelId
                            }], 'ADD_CHANNEL_MEMBER.BATCH'), getState);

                            return _context23.abrupt('return', { data: member });

                        case 16:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this23, [[2, 8]]);
        }));

        return function (_x52, _x53) {
            return _ref23.apply(this, arguments);
        };
    }();
}

function removeChannelMember(channelId, userId) {
    var _this24 = this;

    return function () {
        var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_REQUEST }, getState);

                            _context24.prev = 1;
                            _context24.next = 4;
                            return _client.Client4.removeFromChannel(userId, channelId);

                        case 4:
                            _context24.next = 11;
                            break;

                        case 6:
                            _context24.prev = 6;
                            _context24.t0 = _context24['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context24.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_FAILURE, error: _context24.t0 }, (0, _errors.logError)(_context24.t0)(dispatch)]), getState);
                            return _context24.abrupt('return', { error: _context24.t0 });

                        case 11:

                            _client.Client4.trackEvent('action', 'action_channels_remove_member', { channel_id: channelId });

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL,
                                data: { user_id: userId },
                                id: channelId
                            }, {
                                type: _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_SUCCESS,
                                id: channelId
                            }], 'REMOVE_CHANNEL_MEMBER.BATCH'), getState);

                            return _context24.abrupt('return', { data: true });

                        case 14:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this24, [[1, 6]]);
        }));

        return function (_x54, _x55) {
            return _ref24.apply(this, arguments);
        };
    }();
}

function updateChannelMemberRoles(channelId, userId, roles) {
    var _this25 = this;

    return function () {
        var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(dispatch, getState) {
            var actions, membersInChannel;
            return regeneratorRuntime.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_REQUEST }, getState);

                            _context25.prev = 1;
                            _context25.next = 4;
                            return _client.Client4.updateChannelMemberRoles(channelId, userId, roles);

                        case 4:
                            _context25.next = 11;
                            break;

                        case 6:
                            _context25.prev = 6;
                            _context25.t0 = _context25['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context25.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_FAILURE, error: _context25.t0 }, (0, _errors.logError)(_context25.t0)(dispatch)]), getState);
                            return _context25.abrupt('return', { error: _context25.t0 });

                        case 11:
                            actions = [{
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_SUCCESS
                            }];
                            membersInChannel = getState().entities.channels.membersInChannel[channelId];

                            if (membersInChannel && membersInChannel[userId]) {
                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER,
                                    data: _extends({}, membersInChannel[userId], { roles: roles })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context25.abrupt('return', { data: true });

                        case 16:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, _this25, [[1, 6]]);
        }));

        return function (_x56, _x57) {
            return _ref25.apply(this, arguments);
        };
    }();
}

function updateChannelHeader(channelId, header) {
    var _this26 = this;

    return function () {
        var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            _client.Client4.trackEvent('action', 'action_channels_update_header', { channel_id: channelId });

                            dispatch({
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_HEADER,
                                data: {
                                    channelId: channelId,
                                    header: header
                                }
                            }, getState);

                            return _context26.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, _this26);
        }));

        return function (_x58, _x59) {
            return _ref26.apply(this, arguments);
        };
    }();
}

function updateChannelPurpose(channelId, purpose) {
    var _this27 = this;

    return function () {
        var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            _client.Client4.trackEvent('action', 'action_channels_update_purpose', { channel_id: channelId });

                            dispatch({
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_PURPOSE,
                                data: {
                                    channelId: channelId,
                                    purpose: purpose
                                }
                            }, getState);

                            return _context27.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, _this27);
        }));

        return function (_x60, _x61) {
            return _ref27.apply(this, arguments);
        };
    }();
}

function markChannelAsRead(channelId, prevChannelId) {
    var updateLastViewedAt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return function (dispatch, getState) {
        // Send channel last viewed at to the server
        if (updateLastViewedAt) {
            dispatch({ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_REQUEST }, getState);

            _client.Client4.viewMyChannel(channelId, prevChannelId).then(function () {
                dispatch({ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_SUCCESS }, getState);
            }).catch(function (error) {
                (0, _helpers.forceLogoutIfNecessary)(error, dispatch, getState);
                dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                return { error: error };
            });
        }

        var state = getState();
        var _state$entities$chann2 = state.entities.channels,
            channels = _state$entities$chann2.channels,
            myMembers = _state$entities$chann2.myMembers;

        // Update channel member objects to set all mentions and posts as viewed

        var channel = channels[channelId];
        var prevChannel = channels[prevChannelId]; // May be null since prevChannelId is optional

        // Update team member objects to set mentions and posts in channel as viewed
        var channelMember = myMembers[channelId];
        var prevChannelMember = myMembers[prevChannelId]; // May also be null

        var actions = [];

        if (channel && channelMember) {
            actions.push({
                type: _action_types.ChannelTypes.DECREMENT_UNREAD_MSG_COUNT,
                data: {
                    teamId: channel.team_id,
                    channelId: channelId,
                    amount: channel.total_msg_count - channelMember.msg_count
                }
            });

            actions.push({
                type: _action_types.ChannelTypes.DECREMENT_UNREAD_MENTION_COUNT,
                data: {
                    teamId: channel.team_id,
                    channelId: channelId,
                    amount: channelMember.mention_count
                }
            });
        }

        if (prevChannel && prevChannelMember) {
            actions.push({
                type: _action_types.ChannelTypes.DECREMENT_UNREAD_MSG_COUNT,
                data: {
                    teamId: prevChannel.team_id,
                    channelId: prevChannelId,
                    amount: prevChannel.total_msg_count - prevChannelMember.msg_count
                }
            });

            actions.push({
                type: _action_types.ChannelTypes.DECREMENT_UNREAD_MENTION_COUNT,
                data: {
                    teamId: prevChannel.team_id,
                    channelId: prevChannelId,
                    amount: prevChannelMember.mention_count
                }
            });
        }

        if (actions.length > 0) {
            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);
        }

        return { data: true };
    };
}

// Increments the number of posts in the channel by 1 and marks it as unread if necessary
function markChannelAsUnread(teamId, channelId, mentions) {
    return function (dispatch, getState) {
        var state = getState();
        var myMembers = state.entities.channels.myMembers;
        var currentUserId = state.entities.users.currentUserId;


        var actions = [{
            type: _action_types.ChannelTypes.INCREMENT_TOTAL_MSG_COUNT,
            data: {
                channelId: channelId,
                amount: 1
            }
        }, {
            type: _action_types.ChannelTypes.INCREMENT_UNREAD_MSG_COUNT,
            data: {
                teamId: teamId,
                channelId: channelId,
                amount: 1,
                onlyMentions: myMembers[channelId] && myMembers[channelId].notify_props && myMembers[channelId].notify_props.mark_unread === _constants.General.MENTION
            }
        }];

        if (mentions && mentions.indexOf(currentUserId) !== -1) {
            actions.push({
                type: _action_types.ChannelTypes.INCREMENT_UNREAD_MENTION_COUNT,
                data: {
                    teamId: teamId,
                    channelId: channelId,
                    amount: 1
                }
            });
        }

        dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

        return { data: true };
    };
}

function getChannelMembersByIds(channelId, userIds) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getChannelMembersByIds, _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, [_action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS], _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, channelId, userIds);
}

function getChannelMember(channelId, userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getChannelMember, _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, [_action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS], _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, channelId, userId);
}

function getMyChannelMember(channelId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyChannelMember, _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, [_action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS], _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, channelId);
}

function favoriteChannel(channelId) {
    var _this28 = this;

    return function () {
        var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(dispatch, getState) {
            var currentUserId, preference;
            return regeneratorRuntime.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            currentUserId = getState().entities.users.currentUserId;
                            preference = {
                                user_id: currentUserId,
                                category: _constants.Preferences.CATEGORY_FAVORITE_CHANNEL,
                                name: channelId,
                                value: 'true'
                            };


                            _client.Client4.trackEvent('action', 'action_channels_favorite');

                            return _context28.abrupt('return', (0, _preferences.savePreferences)(currentUserId, [preference])(dispatch, getState));

                        case 4:
                        case 'end':
                            return _context28.stop();
                    }
                }
            }, _callee28, _this28);
        }));

        return function (_x63, _x64) {
            return _ref28.apply(this, arguments);
        };
    }();
}

function unfavoriteChannel(channelId) {
    var _this29 = this;

    return function () {
        var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(dispatch, getState) {
            var currentUserId, preference;
            return regeneratorRuntime.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            currentUserId = getState().entities.users.currentUserId;
                            preference = {
                                user_id: currentUserId,
                                category: _constants.Preferences.CATEGORY_FAVORITE_CHANNEL,
                                name: channelId
                            };


                            _client.Client4.trackEvent('action', 'action_channels_unfavorite');

                            return _context29.abrupt('return', (0, _preferences.deletePreferences)(currentUserId, [preference])(dispatch, getState));

                        case 4:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, _this29);
        }));

        return function (_x65, _x66) {
            return _ref29.apply(this, arguments);
        };
    }();
}

exports.default = {
    selectChannel: selectChannel,
    createChannel: createChannel,
    createDirectChannel: createDirectChannel,
    updateChannel: updateChannel,
    patchChannel: patchChannel,
    updateChannelNotifyProps: updateChannelNotifyProps,
    getChannel: getChannel,
    fetchMyChannelsAndMembers: fetchMyChannelsAndMembers,
    getMyChannelMembers: getMyChannelMembers,
    getChannelMembersByIds: getChannelMembersByIds,
    leaveChannel: leaveChannel,
    joinChannel: joinChannel,
    deleteChannel: deleteChannel,
    viewChannel: viewChannel,
    markChannelAsViewed: markChannelAsViewed,
    getChannels: getChannels,
    autocompleteChannels: autocompleteChannels,
    searchChannels: searchChannels,
    getChannelStats: getChannelStats,
    addChannelMember: addChannelMember,
    removeChannelMember: removeChannelMember,
    updateChannelHeader: updateChannelHeader,
    updateChannelPurpose: updateChannelPurpose,
    markChannelAsRead: markChannelAsRead,
    markChannelAsUnread: markChannelAsUnread,
    favoriteChannel: favoriteChannel,
    unfavoriteChannel: unfavoriteChannel
};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alpha = __webpack_require__(2281);

Object.defineProperty(exports, 'Alpha', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Checkboard = __webpack_require__(1401);

Object.defineProperty(exports, 'Checkboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkboard).default;
  }
});

var _EditableInput = __webpack_require__(2284);

Object.defineProperty(exports, 'EditableInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditableInput).default;
  }
});

var _Hue = __webpack_require__(2285);

Object.defineProperty(exports, 'Hue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Raised = __webpack_require__(2287);

Object.defineProperty(exports, 'Raised', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Raised).default;
  }
});

var _Saturation = __webpack_require__(2292);

Object.defineProperty(exports, 'Saturation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Saturation).default;
  }
});

var _ColorWrap = __webpack_require__(1402);

Object.defineProperty(exports, 'ColorWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Swatch = __webpack_require__(2297);

Object.defineProperty(exports, 'Swatch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 800 */,
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1130), __esModule: true };

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updatePost = exports.createPost = exports.unflagPost = exports.flagPost = undefined;

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var flagPost = exports.flagPost = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(postId) {
        var rhsState, results, index, posts;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return PostActions.flagPost(postId)(dispatch, getState);

                    case 2:
                        rhsState = (0, _rhs2.getRhsState)(getState());

                        // This is a hack that should be fixed with better reducers/actions, see MM-9793

                        if (rhsState === _constants.RHSStates.FLAG) {
                            results = getState().entities.search.results;
                            index = results.indexOf(postId);

                            if (index === -1) {
                                results = [].concat((0, _toConsumableArray3.default)(results), [postId]);

                                posts = {};

                                results.forEach(function (id) {
                                    posts[id] = Selectors.getPost(getState(), id);
                                });

                                results.sort(function (a, b) {
                                    return (0, _post_utils.comparePosts)(posts[a], posts[b]);
                                });

                                dispatch({
                                    type: _action_types.SearchTypes.RECEIVED_SEARCH_POSTS,
                                    data: { posts: posts, order: results }
                                });
                            }
                        }

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function flagPost(_x) {
        return _ref.apply(this, arguments);
    };
}();

var unflagPost = exports.unflagPost = function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(postId) {
        var rhsState, results, index, posts;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return PostActions.unflagPost(postId)(dispatch, getState);

                    case 2:
                        rhsState = (0, _rhs2.getRhsState)(getState());

                        // This is a hack that should be fixed with better reducers/actions, see MM-9793

                        if (rhsState === _constants.RHSStates.FLAG) {
                            results = getState().entities.search.results;
                            index = results.indexOf(postId);

                            if (index > -1) {
                                results = [].concat((0, _toConsumableArray3.default)(results));
                                results.splice(index, 1);

                                posts = {};

                                results.forEach(function (id) {
                                    posts[id] = Selectors.getPost(getState(), id);
                                });

                                dispatch({
                                    type: _action_types.SearchTypes.RECEIVED_SEARCH_POSTS,
                                    data: { posts: posts, order: results }
                                });
                            }
                        }

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function unflagPost(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

var createPost = exports.createPost = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(post, files, success) {
        var emojis, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, emoji, trimmed;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        // parse message and emit emoji event
                        emojis = post.message.match(_emoticons.EMOJI_PATTERN);

                        if (!emojis) {
                            _context3.next = 21;
                            break;
                        }

                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _iteratorError = undefined;
                        _context3.prev = 5;

                        for (_iterator = (0, _getIterator3.default)(emojis); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            emoji = _step.value;
                            trimmed = emoji.substring(1, emoji.length - 1);

                            emitEmojiPosted(trimmed);
                        }
                        _context3.next = 13;
                        break;

                    case 9:
                        _context3.prev = 9;
                        _context3.t0 = _context3['catch'](5);
                        _didIteratorError = true;
                        _iteratorError = _context3.t0;

                    case 13:
                        _context3.prev = 13;
                        _context3.prev = 14;

                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }

                    case 16:
                        _context3.prev = 16;

                        if (!_didIteratorError) {
                            _context3.next = 19;
                            break;
                        }

                        throw _iteratorError;

                    case 19:
                        return _context3.finish(16);

                    case 20:
                        return _context3.finish(13);

                    case 21:
                        if (!UserAgent.isIosClassic()) {
                            _context3.next = 26;
                            break;
                        }

                        _context3.next = 24;
                        return PostActions.createPostImmediately(post, files)(dispatch, getState);

                    case 24:
                        _context3.next = 28;
                        break;

                    case 26:
                        _context3.next = 28;
                        return PostActions.createPost(post, files)(dispatch, getState);

                    case 28:

                        if (post.root_id) {
                            _post_store2.default.storeCommentDraft(post.root_id, null);
                        } else {
                            _post_store2.default.storeDraft(post.channel_id, null);
                        }

                        if (success) {
                            success();
                        }

                    case 30:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this, [[5, 9, 13, 21], [14,, 16, 20]]);
    }));

    return function createPost(_x3, _x4, _x5) {
        return _ref3.apply(this, arguments);
    };
}();

var updatePost = exports.updatePost = function () {
    var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(post, success) {
        var _ref5, data, err;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return PostActions.editPost(post)(dispatch, getState);

                    case 2:
                        _ref5 = _context4.sent;
                        data = _ref5.data;
                        err = _ref5.error;

                        if (data && success) {
                            success();
                        } else if (err) {
                            _app_dispatcher2.default.handleServerAction({
                                type: _constants.ActionTypes.RECEIVED_ERROR,
                                err: (0, _extends3.default)({ id: err.server_error_id }, err),
                                method: 'editPost'
                            });
                        }

                    case 6:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function updatePost(_x6, _x7) {
        return _ref4.apply(this, arguments);
    };
}();

exports.handleNewPost = handleNewPost;
exports.addReaction = addReaction;
exports.removeReaction = removeReaction;
exports.emitEmojiPosted = emitEmojiPosted;
exports.increasePostVisibility = increasePostVisibility;
exports.searchForTerm = searchForTerm;
exports.pinPost = pinPost;
exports.unpinPost = unpinPost;
exports.doPostAction = doPostAction;
exports.setEditingPost = setEditingPost;
exports.hideEditPostModal = hideEditPostModal;
exports.deleteAndRemovePost = deleteAndRemovePost;

var _reduxBatchedActions = __webpack_require__(921);

var _action_types = __webpack_require__(3);

var _channels = __webpack_require__(798);

var _posts2 = __webpack_require__(808);

var PostActions = _interopRequireWildcard(_posts2);

var _posts3 = __webpack_require__(805);

var Selectors = _interopRequireWildcard(_posts3);

var _post_utils = __webpack_require__(281);

var _notification_actions = __webpack_require__(1661);

var _user_actions = __webpack_require__(781);

var _rhs = __webpack_require__(817);

var RhsActions = _interopRequireWildcard(_rhs);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _post_store = __webpack_require__(956);

var _post_store2 = _interopRequireDefault(_post_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _rhs2 = __webpack_require__(818);

var _constants = __webpack_require__(29);

var _emoticons = __webpack_require__(1032);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

function handleNewPost(post, msg) {
    var websocketMessageProps = {};
    if (msg) {
        websocketMessageProps = msg.data;
    }

    if (_channel_store2.default.getMyMember(post.channel_id)) {
        completePostReceive(post, websocketMessageProps);
    } else {
        (0, _channels.getMyChannelMember)(post.channel_id)(dispatch, getState).then(function () {
            return completePostReceive(post, websocketMessageProps);
        });
    }

    if (msg && msg.data) {
        if (msg.data.channel_type === _constants.Constants.DM_CHANNEL) {
            (0, _user_actions.loadNewDMIfNeeded)(post.channel_id);
        } else if (msg.data.channel_type === _constants.Constants.GM_CHANNEL) {
            (0, _user_actions.loadNewGMIfNeeded)(post.channel_id);
        }
    }
}

function completePostReceive(post, websocketMessageProps) {
    if (post.root_id && Selectors.getPost(getState(), post.root_id) == null) {
        PostActions.getPostThread(post.root_id)(dispatch, getState).then(function (data) {
            dispatchPostActions(post, websocketMessageProps);
            PostActions.getProfilesAndStatusesForPosts(data.posts, dispatch, getState);
        });

        return;
    }

    dispatchPostActions(post, websocketMessageProps);
}

function dispatchPostActions(post, websocketMessageProps) {
    var currentChannelId = getState().entities.channels.currentChannelId;


    if (post.channel_id === currentChannelId) {
        dispatch({
            type: _constants.ActionTypes.INCREASE_POST_VISIBILITY,
            data: post.channel_id,
            amount: 1
        });
    }

    // Need manual dispatch to remove pending post
    dispatch({
        type: _action_types.PostTypes.RECEIVED_POSTS,
        data: {
            order: [],
            posts: (0, _defineProperty3.default)({}, post.id, post)
        },
        channelId: post.channel_id
    });

    // Still needed to update unreads
    _app_dispatcher2.default.handleServerAction({
        type: _constants.ActionTypes.RECEIVED_POST,
        post: post,
        websocketMessageProps: websocketMessageProps
    });

    (0, _notification_actions.sendDesktopNotification)(post, websocketMessageProps);
}

function addReaction(channelId, postId, emojiName) {
    PostActions.addReaction(postId, emojiName)(dispatch, getState);
}

function removeReaction(channelId, postId, emojiName) {
    PostActions.removeReaction(postId, emojiName)(dispatch, getState);
}

function emitEmojiPosted(emoji) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.ActionTypes.EMOJI_POSTED,
        alias: emoji
    });
}

var POST_INCREASE_AMOUNT = _constants.Constants.POST_CHUNK_SIZE / 2;

// Returns true if there are more posts to load
function increasePostVisibility(channelId, focusedPostId) {
    var _this = this;

    return function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(doDispatch, doGetState) {
            var currentPostVisibility, page, result, posts;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (!doGetState().views.channel.loadingPosts[channelId]) {
                                _context5.next = 2;
                                break;
                            }

                            return _context5.abrupt('return', true);

                        case 2:
                            currentPostVisibility = doGetState().views.channel.postVisibility[channelId];

                            if (!(currentPostVisibility >= _constants.Constants.MAX_POST_VISIBILITY)) {
                                _context5.next = 5;
                                break;
                            }

                            return _context5.abrupt('return', true);

                        case 5:

                            doDispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _constants.ActionTypes.LOADING_POSTS,
                                data: true,
                                channelId: channelId
                            }, {
                                type: _constants.ActionTypes.INCREASE_POST_VISIBILITY,
                                data: channelId,
                                amount: POST_INCREASE_AMOUNT
                            }]));

                            page = Math.floor(currentPostVisibility / POST_INCREASE_AMOUNT);
                            result = void 0;

                            if (!focusedPostId) {
                                _context5.next = 14;
                                break;
                            }

                            _context5.next = 11;
                            return PostActions.getPostsBefore(channelId, focusedPostId, page, POST_INCREASE_AMOUNT)(dispatch, getState);

                        case 11:
                            result = _context5.sent;
                            _context5.next = 17;
                            break;

                        case 14:
                            _context5.next = 16;
                            return PostActions.getPosts(channelId, page, POST_INCREASE_AMOUNT)(doDispatch, doGetState);

                        case 16:
                            result = _context5.sent;

                        case 17:
                            posts = result.data;


                            doDispatch({
                                type: _constants.ActionTypes.LOADING_POSTS,
                                data: false,
                                channelId: channelId
                            });

                            return _context5.abrupt('return', posts.order.length >= POST_INCREASE_AMOUNT);

                        case 20:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this);
        }));

        return function (_x8, _x9) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function searchForTerm(term) {
    dispatch(RhsActions.updateSearchTerms(term));
    dispatch(RhsActions.showSearchResults());
}

function pinPost(postId) {
    var _this2 = this;

    return function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(doDispatch, doGetState) {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return PostActions.pinPost(postId)(doDispatch, doGetState);

                        case 2:

                            _app_dispatcher2.default.handleServerAction({
                                type: _constants.ActionTypes.RECEIVED_POST_PINNED,
                                postId: postId
                            });

                        case 3:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this2);
        }));

        return function (_x10, _x11) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function unpinPost(postId) {
    var _this3 = this;

    return function () {
        var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(doDispatch, doGetState) {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.next = 2;
                            return PostActions.unpinPost(postId)(doDispatch, doGetState);

                        case 2:

                            _app_dispatcher2.default.handleServerAction({
                                type: _constants.ActionTypes.RECEIVED_POST_UNPINNED,
                                postId: postId
                            });

                        case 3:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this3);
        }));

        return function (_x12, _x13) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function doPostAction(postId, actionId) {
    PostActions.doPostAction(postId, actionId)(dispatch, getState);
}

function setEditingPost() {
    var postId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var commentsCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var refocusId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var _this4 = this;

    var title = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var isRHS = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    return function () {
        var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(doDispatch, doGetState) {
            var state, canEditNow, config, post;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            state = doGetState();
                            canEditNow = true;

                            // Only show the modal if we can edit the post now, but allow it to be hidden at any time

                            if (postId && state.entities.general.license.IsLicensed === 'true') {
                                config = state.entities.general.config;


                                if (config.AllowEditPost === _constants.Constants.ALLOW_EDIT_POST_NEVER) {
                                    canEditNow = false;
                                } else if (config.AllowEditPost === _constants.Constants.ALLOW_EDIT_POST_TIME_LIMIT) {
                                    post = Selectors.getPost(state, postId);


                                    if (post.create_at + config.PostEditTimeLimit * 1000 < Date.now()) {
                                        canEditNow = false;
                                    }
                                }
                            }

                            if (canEditNow) {
                                doDispatch({
                                    type: _constants.ActionTypes.SHOW_EDIT_POST_MODAL,
                                    data: { postId: postId, commentsCount: commentsCount, refocusId: refocusId, title: title, isRHS: isRHS }
                                }, doGetState);
                            }

                            return _context8.abrupt('return', { data: canEditNow });

                        case 5:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this4);
        }));

        return function (_x19, _x20) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function hideEditPostModal() {
    return {
        type: _constants.ActionTypes.HIDE_EDIT_POST_MODAL
    };
}

function deleteAndRemovePost(post) {
    var _this5 = this;

    return function () {
        var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(doDispatch, doGetState) {
            var currentUserId, hardDelete, _ref11, error;

            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            currentUserId = doGetState().entities.users.currentUserId;
                            hardDelete = false;

                            if (post.user_id === currentUserId) {
                                hardDelete = true;
                            }

                            _context9.next = 5;
                            return doDispatch(PostActions.deletePost(post, hardDelete));

                        case 5:
                            _ref11 = _context9.sent;
                            error = _ref11.error;

                            if (!error) {
                                _context9.next = 9;
                                break;
                            }

                            return _context9.abrupt('return', { error: error });

                        case 9:

                            if (post.id === (0, _rhs2.getSelectedPostId)(doGetState())) {
                                dispatch({
                                    type: _constants.ActionTypes.SELECT_POST,
                                    postId: '',
                                    channelId: ''
                                });
                            }

                            doDispatch({
                                type: _action_types.PostTypes.REMOVE_POST,
                                data: post
                            });

                            // Needed for search store
                            _app_dispatcher2.default.handleViewAction({
                                type: _constants.Constants.ActionTypes.REMOVE_POST,
                                post: post
                            });

                            return _context9.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this5);
        }));

        return function (_x21, _x22) {
            return _ref10.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.isSystemMessage = isSystemMessage;
exports.isFromWebhook = isFromWebhook;
exports.isPostOwner = isPostOwner;
exports.isComment = isComment;
exports.isEdited = isEdited;
exports.getImageSrc = getImageSrc;
exports.getProfilePicSrcForPost = getProfilePicSrcForPost;
exports.canDeletePost = canDeletePost;
exports.canEditPost = canEditPost;
exports.shouldShowDotMenu = shouldShowDotMenu;
exports.containsAtChannel = containsAtChannel;
exports.messageHtmlToComponent = messageHtmlToComponent;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = __webpack_require__(1663);

var _client = __webpack_require__(270);

var _general = __webpack_require__(113);

var _roles = __webpack_require__(276);

var _channels = __webpack_require__(783);

var _constants = __webpack_require__(19);

var _at_mention = __webpack_require__(1141);

var _at_mention2 = _interopRequireDefault(_at_mention);

var _latex_block = __webpack_require__(1868);

var _latex_block2 = _interopRequireDefault(_latex_block);

var _markdown_image = __webpack_require__(1870);

var _markdown_image2 = _interopRequireDefault(_markdown_image);

var _post_emoji = __webpack_require__(1871);

var _post_emoji2 = _interopRequireDefault(_post_emoji);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _markdown = __webpack_require__(1159);

var _mentionable_renderer = __webpack_require__(1873);

var _mentionable_renderer2 = _interopRequireDefault(_mentionable_renderer);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isSystemMessage(post) {
    return Boolean(post.type && post.type.lastIndexOf(_constants3.default.SYSTEM_MESSAGE_PREFIX) === 0);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function isFromWebhook(post) {
    return post.props && post.props.from_webhook === 'true';
}

function isPostOwner(post) {
    return _user_store2.default.getCurrentId() === post.user_id;
}

function isComment(post) {
    if ('root_id' in post) {
        return post.root_id !== '' && post.root_id != null;
    }
    return false;
}

function isEdited(post) {
    return post.edit_at > 0;
}

function getImageSrc(src, hasImageProxy) {
    if (hasImageProxy) {
        return _client.Client4.getBaseRoute() + '/image?url=' + encodeURIComponent(src);
    }
    return src;
}

function getProfilePicSrcForPost(post, user) {
    var config = (0, _general.getConfig)(_redux_store2.default.getState());

    var src = '';
    if (user && user.id === post.user_id) {
        src = Utils.imageURLForUser(user);
    } else {
        src = Utils.imageURLForUser(post.user_id);
    }

    if (post.props && post.props.from_webhook && !post.props.use_user_icon && config.EnablePostIconOverride === 'true') {
        if (post.props.override_icon_url) {
            src = post.props.override_icon_url;
        } else {
            src = _constants3.default.DEFAULT_WEBHOOK_LOGO;
        }
    } else if (isSystemMessage(post)) {
        src = _constants3.default.SYSTEM_MESSAGE_PROFILE_IMAGE;
    }

    return src;
}

function canDeletePost(post) {
    if (post.type === _constants3.default.PostTypes.FAKE_PARENT_DELETED) {
        return false;
    }
    var channel = (0, _channels.getChannel)(_redux_store2.default.getState(), post.channel_id);

    if (isPostOwner(post)) {
        return (0, _roles.haveIChannelPermission)(_redux_store2.default.getState(), { channel: post.channel_id, team: channel && channel.team_id, permission: _constants.Permissions.DELETE_POST });
    }
    return (0, _roles.haveIChannelPermission)(_redux_store2.default.getState(), { channel: post.channel_id, team: channel && channel.team_id, permission: _constants.Permissions.DELETE_OTHERS_POSTS });
}

function canEditPost(post, editDisableAction) {
    if (isSystemMessage(post)) {
        return false;
    }

    var canEdit = false;
    var license = (0, _general.getLicense)(_redux_store2.default.getState());
    var config = (0, _general.getConfig)(_redux_store2.default.getState());
    var channel = (0, _channels.getChannel)(_redux_store2.default.getState(), post.channel_id);

    var isOwner = isPostOwner(post);
    canEdit = (0, _roles.haveIChannelPermission)(_redux_store2.default.getState(), { channel: post.channel_id, team: channel && channel.team_id, permission: _constants.Permissions.EDIT_POST });
    if (!isOwner) {
        // I only can edit my posts, at least until phase-2
        //canEdit = canEdit && haveIChannelPermission(store.getState(), {channel: post.channel_id, team: channel && channel.team_id, permission: Permissions.EDIT_OTHERS_POSTS});
        canEdit = false;
    }

    if (canEdit && license.IsLicensed === 'true') {
        if (config.PostEditTimeLimit !== '-1' && config.PostEditTimeLimit !== -1) {
            var timeLeft = post.create_at + config.PostEditTimeLimit * 1000 - Utils.getTimestamp();
            if (timeLeft > 0) {
                editDisableAction.fireAfter(timeLeft + 1000);
            } else {
                canEdit = false;
            }
        }
    }

    return canEdit;
}

function shouldShowDotMenu(post) {
    if (Utils.isMobile()) {
        return true;
    }

    if (!isSystemMessage(post)) {
        return true;
    }

    if (canDeletePost(post)) {
        return true;
    }

    if (canEditPost(post)) {
        return true;
    }

    return false;
}

function containsAtChannel(text) {
    // Don't warn for slash commands
    if (!text || text.startsWith('/')) {
        return false;
    }

    var mentionableText = (0, _markdown.formatWithRenderer)(text, new _mentionable_renderer2.default());

    return (/\B@(all|channel)\b/i.test(mentionableText)
    );
}

/*
 * Converts HTML to React components using html-to-react.
 * The following options can be specified:
 * - mentions - If specified, mentions are replaced with the AtMention component. Defaults to true.
 * - emoji - If specified, emoji text is replaced with the PostEmoji component. Defaults to true.
 * - images - If specified, markdown images are replaced with the PostMarkdown component. Defaults to true.
 * - latex - If specified, latex is replaced with the LatexBlock component. Defaults to true.
 */
function messageHtmlToComponent(html, isRHS) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!html) {
        return null;
    }

    var parser = new _htmlToReact.Parser();
    var processNodeDefinitions = new _htmlToReact.ProcessNodeDefinitions(_react2.default);

    function isValidNode() {
        return true;
    }

    var processingInstructions = [];
    if (!('mentions' in options) || options.mentions) {
        var mentionAttrib = 'data-mention';
        processingInstructions.push({
            replaceChildren: true,
            shouldProcessNode: function shouldProcessNode(node) {
                return node.attribs && node.attribs[mentionAttrib];
            },
            processNode: function processNode(node) {
                var mentionName = node.attribs[mentionAttrib];
                var callAtMention = _react2.default.createElement(_at_mention2.default, {
                    mentionName: mentionName,
                    isRHS: isRHS,
                    hasMention: true
                });
                return callAtMention;
            }
        });
    }

    if (!('emoji' in options) || options.emoji) {
        var emojiAttrib = 'data-emoticon';
        processingInstructions.push({
            replaceChildren: true,
            shouldProcessNode: function shouldProcessNode(node) {
                return node.attribs && node.attribs[emojiAttrib];
            },
            processNode: function processNode(node) {
                var emojiName = node.attribs[emojiAttrib];
                var callPostEmoji = _react2.default.createElement(_post_emoji2.default, {
                    name: emojiName
                });
                return callPostEmoji;
            }
        });
    }

    if (!('images' in options) || options.images) {
        processingInstructions.push({
            shouldProcessNode: function shouldProcessNode(node) {
                return node.type === 'tag' && node.name === 'img';
            },
            processNode: function processNode(node) {
                var _node$attribs = node.attribs,
                    className = _node$attribs.class,
                    attribs = (0, _objectWithoutProperties3.default)(_node$attribs, ['class']);

                var callMarkdownImage = _react2.default.createElement(_markdown_image2.default, (0, _extends3.default)({
                    className: className
                }, attribs));
                return callMarkdownImage;
            }
        });
    }

    if (!('latex' in options) || options.latex) {
        processingInstructions.push({
            shouldProcessNode: function shouldProcessNode(node) {
                return node.attribs && node.attribs['data-latex'];
            },
            processNode: function processNode(node) {
                return _react2.default.createElement(_latex_block2.default, { content: node.attribs['data-latex'] });
            }
        });
    }

    processingInstructions.push({
        shouldProcessNode: function shouldProcessNode() {
            return true;
        },
        processNode: processNodeDefinitions.processDefaultNode
    });

    return parser.parseWithInstructions(html, isValidNode, processingInstructions);
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

exports.trackEvent = trackEvent;
exports.clearMarks = clearMarks;
exports.mark = mark;
exports.measure = measure;
exports.trackLoadTime = trackLoadTime;

var _general = __webpack_require__(113);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUPPORTS_CLEAR_MARKS = isSupported([performance.clearMarks]); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SUPPORTS_MARK = isSupported([performance.mark]);
var SUPPORTS_MEASURE_METHODS = isSupported([performance.measure, performance.getEntries, performance.getEntriesByName, performance.clearMeasures]);

function trackEvent(category, event, props) {
    if (global.window && global.window.analytics) {
        var properties = (0, _assign2.default)({ category: category, type: event, user_actual_id: _user_store2.default.getCurrentId() }, props);
        var options = {
            context: {
                ip: '0.0.0.0'
            },
            page: {
                path: '',
                referrer: '',
                search: '',
                title: '',
                url: ''
            },
            anonymousId: '00000000000000000000000000'
        };
        global.window.analytics.track('event', properties, options);
    }
}

/**
 * Takes an array of string names of performance markers and invokes
 * performance.clearMarkers on each.
 * @param   {array} names of markers to clear
 *
 */
function clearMarks(names) {
    if (!isDevMode() || !SUPPORTS_CLEAR_MARKS) {
        return;
    }
    names.forEach(function (name) {
        return performance.clearMarks(name);
    });
}

function mark(name) {
    if (!isDevMode() || !SUPPORTS_MARK) {
        return;
    }
    performance.mark(name);
}

/**
 * Takes the names of two markers and invokes performance.measure on
 * them. The measured duration (ms) and the string name of the measure is
 * are returned.
 *
 * @param   {string} name1 the first marker
 * @param   {string} name2 the second marker
 *
 * @returns {[number, string]} Either the measured duration (ms) and the string name
 * of the measure are returned or -1 and and empty string is returned if
 * in dev. mode or one of the marker can't be found.
 *
 */
function measure(name1, name2) {
    if (!isDevMode() || !SUPPORTS_MEASURE_METHODS) {
        return [-1, ''];
    }

    // Check for existence of entry name to avoid DOMException
    var performanceEntries = performance.getEntries();
    if (![name1, name2].every(function (name) {
        return performanceEntries.find(function (item) {
            return item.name === name;
        });
    })) {
        return [-1, ''];
    }

    var displayPrefix = '🐐 Mattermost: ';
    var measurementName = '' + displayPrefix + name1 + ' - ' + name2;
    performance.measure(measurementName, name1, name2);
    var lastDuration = mostRecentDurationByEntryName(measurementName);

    // Clean up the measures we created
    performance.clearMeasures(measurementName);
    return [lastDuration, measurementName];
}

function trackLoadTime() {
    if (!isSupported([performance.timing.loadEventEnd, performance.timing.navigationStart])) {
        return;
    }

    // Must be wrapped in setTimeout because loadEventEnd property is 0
    // until onload is complete, also time added because analytics
    // code isn't loaded until a subsequent window event has fired.
    var tenSeconds = 10000;
    setTimeout(function () {
        var _window$performance$t = window.performance.timing,
            loadEventEnd = _window$performance$t.loadEventEnd,
            navigationStart = _window$performance$t.navigationStart;

        var pageLoadTime = loadEventEnd - navigationStart;
        trackEvent('performance', 'page_load', { duration: pageLoadTime });
    }, tenSeconds);
}

function mostRecentDurationByEntryName(entryName) {
    var entriesWithName = performance.getEntriesByName(entryName);
    return entriesWithName.map(function (item) {
        return item.duration;
    })[entriesWithName.length - 1];
}

function isSupported(checks) {
    for (var i = 0, len = checks.length; i < len; i++) {
        var item = checks[i];
        if (typeof item === 'undefined') {
            return false;
        }
    }
    return true;
}

function isDevMode() {
    var config = (0, _general.getConfig)(_redux_store2.default.getState());

    return config.EnableDeveloper === 'true';
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPostIdsInChannel = exports.getCurrentUsersLatestPost = exports.getLatestReplyablePostId = exports.getMostRecentPostIdInChannel = exports.getLastPostPerChannel = exports.getSearchResults = exports.getPostsInCurrentChannel = exports.getPostIdsInCurrentChannel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.getAllPosts = getAllPosts;
exports.getPost = getPost;
exports.getPostsInThread = getPostsInThread;
exports.getReactionsForPosts = getReactionsForPosts;
exports.makeGetReactionsForPost = makeGetReactionsForPost;
exports.getOpenGraphMetadata = getOpenGraphMetadata;
exports.getOpenGraphMetadataForUrl = getOpenGraphMetadataForUrl;
exports.makeGetPostIdsForThread = makeGetPostIdsForThread;
exports.makeGetPostIdsAroundPost = makeGetPostIdsAroundPost;
exports.makeGetPostsInChannel = makeGetPostsInChannel;
exports.makeGetPostsAroundPost = makeGetPostsAroundPost;
exports.makeGetPostsForThread = makeGetPostsForThread;
exports.makeGetCommentCountForPost = makeGetCommentCountForPost;
exports.makeGetMessageInHistoryItem = makeGetMessageInHistoryItem;
exports.makeGetPostsForIds = makeGetPostsForIds;

var _reselect = __webpack_require__(78);

var _common = __webpack_require__(280);

var _preferences = __webpack_require__(784);

var _helpers = __webpack_require__(117);

var _constants = __webpack_require__(19);

var _post_utils = __webpack_require__(281);

var _preference_utils = __webpack_require__(284);

function getAllPosts(state) {
    return state.entities.posts.posts;
}

function getPost(state, postId) {
    return getAllPosts(state)[postId];
}

function getPostsInThread(state) {
    return state.entities.posts.postsInThread;
}

function getReactionsForPosts(state) {
    return state.entities.posts.reactions;
}

function makeGetReactionsForPost() {
    return (0, _reselect.createSelector)(getReactionsForPosts, function (state, postId) {
        return postId;
    }, function (reactions, postId) {
        return Object.values(reactions[postId] || {});
    });
}

function getOpenGraphMetadata(state) {
    return state.entities.posts.openGraph;
}

function getOpenGraphMetadataForUrl(state, url) {
    return state.entities.posts.openGraph[url];
}

var getPostIdsInCurrentChannel = exports.getPostIdsInCurrentChannel = (0, _helpers.createIdsSelector)(function (state) {
    return state.entities.posts.postsInChannel[state.entities.channels.currentChannelId];
}, function (postIdsInCurrentChannel) {
    return postIdsInCurrentChannel || [];
});

var getPostsInCurrentChannel = exports.getPostsInCurrentChannel = (0, _reselect.createSelector)(getAllPosts, getPostIdsInCurrentChannel, function (posts, postIds) {
    return postIds.map(function (id) {
        return posts[id];
    });
});

function makeGetPostIdsForThread() {
    return (0, _helpers.createIdsSelector)(getAllPosts, function (state, rootId) {
        return state.entities.posts.postsInThread[rootId] || [];
    }, function (state, rootId) {
        return state.entities.posts.posts[rootId];
    }, function (posts, postsForThread, rootPost) {
        var thread = [];

        if (rootPost) {
            thread.push(rootPost);
        }

        postsForThread.forEach(function (id) {
            var post = posts[id];
            if (post) {
                thread.push(post);
            }
        });

        thread.sort(_post_utils.comparePosts);

        return thread.map(function (post) {
            return post.id;
        });
    });
}

function makeGetPostIdsAroundPost() {
    return (0, _helpers.createIdsSelector)(function (state, focusedPostId, channelId) {
        return state.entities.posts.postsInChannel[channelId];
    }, function (state, focusedPostId) {
        return focusedPostId;
    }, function (state, focusedPostId, channelId, options) {
        return options && options.postsBeforeCount;
    }, function (state, focusedPostId, channelId, options) {
        return options && options.postsAfterCount;
    }, function (postIds, focusedPostId) {
        var postsBeforeCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.Posts.POST_CHUNK_SIZE / 2;
        var postsAfterCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.Posts.POST_CHUNK_SIZE / 2;

        if (!postIds) {
            return null;
        }

        var focusedPostIndex = postIds.indexOf(focusedPostId);
        if (focusedPostIndex === -1) {
            return null;
        }

        var desiredPostIndexBefore = focusedPostIndex - postsBeforeCount;
        var minPostIndex = desiredPostIndexBefore < 0 ? 0 : desiredPostIndexBefore;
        var maxPostIndex = focusedPostIndex + postsAfterCount + 1; // Needs the extra 1 to include the focused post

        return postIds.slice(minPostIndex, maxPostIndex);
    });
}

function formatPostInChannel(post, previousPost, index, allPosts, postsInThread, postIds, currentUser) {
    var isFirstReply = false;
    var isLastReply = false;
    var commentedOnPost = void 0;

    if (post.root_id) {
        if (previousPost.root_id !== post.root_id) {
            // Post is the first reply in a list of consecutive replies
            isFirstReply = true;

            if (previousPost.id !== post.root_id) {
                commentedOnPost = allPosts[post.root_id];
            }
        }

        if (index - 1 < 0 || allPosts[postIds[index - 1]].root_id !== post.root_id) {
            // Post is the last reply in a list of consecutive replies
            isLastReply = true;
        }
    }

    var previousPostIsComment = false;
    if (previousPost.root_id) {
        previousPostIsComment = true;
    }

    var postFromWebhook = Boolean(post.props && post.props.from_webhook);
    var prevPostFromWebhook = Boolean(previousPost.props && previousPost.props.from_webhook);
    var consecutivePostByUser = false;
    if (previousPost.user_id === post.user_id && post.create_at - previousPost.create_at <= _constants.Posts.POST_COLLAPSE_TIMEOUT && !postFromWebhook && !prevPostFromWebhook && !(0, _post_utils.isSystemMessage)(post) && !(0, _post_utils.isSystemMessage)(previousPost)) {
        // The last post and this post were made by the same user within some time
        consecutivePostByUser = true;
    }

    var threadRepliedToByCurrentUser = false;
    var threadCreatedByCurrentUser = false;
    var replyCount = 0;
    var isCommentMention = false;

    if (currentUser) {
        var rootId = post.root_id || post.id;
        var threadIds = postsInThread[rootId] || [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = threadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var pid = _step.value;

                var p = allPosts[pid];
                if (!p) {
                    continue;
                }

                if (p.user_id === currentUser.id) {
                    threadRepliedToByCurrentUser = true;
                }

                if (!(0, _post_utils.isPostEphemeral)(p)) {
                    replyCount += 1;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var rootPost = allPosts[rootId];
        if (rootPost && rootPost.user_id === currentUser.id) {
            threadCreatedByCurrentUser = true;
        }

        var commentsNotifyLevel = 'never';
        if (currentUser.notify_props && currentUser.notify_props.comments) {
            commentsNotifyLevel = currentUser.notify_props.comments;
        }

        var notCurrentUser = post.user_id !== currentUser.id || post.props && post.props.from_webhook;
        if (notCurrentUser) {
            if (commentsNotifyLevel === 'any' && (threadCreatedByCurrentUser || threadRepliedToByCurrentUser)) {
                isCommentMention = true;
            } else if (commentsNotifyLevel === 'root' && threadCreatedByCurrentUser) {
                isCommentMention = true;
            }
        }
    }

    return _extends({}, post, {
        isFirstReply: isFirstReply,
        isLastReply: isLastReply,
        previousPostIsComment: previousPostIsComment,
        commentedOnPost: commentedOnPost,
        consecutivePostByUser: consecutivePostByUser,
        replyCount: replyCount,
        isCommentMention: isCommentMention
    });
}

function makeGetPostsInChannel() {
    return (0, _reselect.createSelector)(getAllPosts, getPostsInThread, function (state, channelId) {
        return state.entities.posts.postsInChannel[channelId];
    }, _common.getCurrentUser, _preferences.getMyPreferences, function (state, channelId, numPosts) {
        return numPosts || _constants.Posts.POST_CHUNK_SIZE;
    }, function (allPosts, postsInThread, postIds, currentUser, myPreferences, numPosts) {
        if (!postIds || !currentUser) {
            return null;
        }

        var posts = [];

        var joinLeavePref = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'join_leave')];
        var showJoinLeave = joinLeavePref ? joinLeavePref.value !== 'false' : true;

        for (var i = 0; i < postIds.length && i < numPosts; i++) {
            var post = allPosts[postIds[i]];

            if ((0, _post_utils.shouldFilterJoinLeavePost)(post, showJoinLeave, currentUser.username)) {
                continue;
            }

            var previousPost = allPosts[postIds[i + 1]] || { create_at: 0 };
            posts.push(formatPostInChannel(post, previousPost, i, allPosts, postsInThread, postIds, currentUser));
        }

        return posts;
    });
}

function makeGetPostsAroundPost() {
    return (0, _reselect.createSelector)(getAllPosts, getPostsInThread, function (state, postId, channelId) {
        return state.entities.posts.postsInChannel[channelId];
    }, function (state, postId) {
        return postId;
    }, _common.getCurrentUser, _preferences.getMyPreferences, function (allPosts, postsInThread, postIds, focusedPostId, currentUser, myPreferences) {
        if (!postIds || !currentUser) {
            return null;
        }

        var focusedPostIndex = postIds.indexOf(focusedPostId);
        if (focusedPostIndex === -1) {
            return null;
        }

        var desiredPostIndexBefore = focusedPostIndex - _constants.Posts.POST_CHUNK_SIZE / 2;
        var minPostIndex = desiredPostIndexBefore < 0 ? 0 : desiredPostIndexBefore;

        var slicedPostIds = postIds.slice(minPostIndex);

        var posts = [];
        var joinLeavePref = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'join_leave')];
        var showJoinLeave = joinLeavePref ? joinLeavePref.value !== 'false' : true;

        for (var i = 0; i < slicedPostIds.length; i++) {
            var post = allPosts[slicedPostIds[i]];

            if ((0, _post_utils.shouldFilterJoinLeavePost)(post, showJoinLeave, currentUser.username)) {
                continue;
            }

            var previousPost = allPosts[slicedPostIds[i + 1]] || { create_at: 0 };
            var formattedPost = formatPostInChannel(post, previousPost, i, allPosts, postsInThread, slicedPostIds, currentUser);

            if (post.id === focusedPostId) {
                formattedPost.highlight = true;
            }

            posts.push(formattedPost);
        }

        return posts;
    });
}

// Returns a function that creates a creates a selector that will get the posts for a given thread.
// That selector will take a props object (containing a rootId field) as its
// only argument and will be memoized based on that argument.
function makeGetPostsForThread() {
    return (0, _reselect.createSelector)(getAllPosts, function (state, _ref) {
        var rootId = _ref.rootId;
        return state.entities.posts.postsInThread[rootId] || [];
    }, function (state, _ref2) {
        var rootId = _ref2.rootId;
        return state.entities.posts.posts[rootId];
    }, function (posts, postsForThread, rootPost) {
        var thread = [];

        if (rootPost) {
            thread.push(rootPost);
        }

        postsForThread.forEach(function (id) {
            var post = posts[id];
            if (post) {
                thread.push(post);
            }
        });

        thread.sort(_post_utils.comparePosts);

        return thread;
    });
}

function makeGetCommentCountForPost() {
    return (0, _reselect.createSelector)(getAllPosts, function (state, _ref3) {
        var post = _ref3.post;
        return state.entities.posts.postsInThread[post ? post.id : ''] || [];
    }, function (state, props) {
        return props;
    }, function (posts, postsForThread, _ref4) {
        var currentPost = _ref4.post;

        if (!currentPost) {
            return 0;
        }

        var count = 0;
        postsForThread.forEach(function (id) {
            var post = posts[id];
            if (post && post.state !== _constants.Posts.POST_DELETED && !(0, _post_utils.isPostEphemeral)(post)) {
                count += 1;
            }
        });
        return count;
    });
}

var getSearchResults = exports.getSearchResults = (0, _reselect.createSelector)(getAllPosts, function (state) {
    return state.entities.search.results;
}, function (posts, postIds) {
    if (!postIds) {
        return [];
    }

    return postIds.map(function (id) {
        return posts[id];
    });
});

function makeGetMessageInHistoryItem(type) {
    return (0, _reselect.createSelector)(function (state) {
        return state.entities.posts.messagesHistory;
    }, function (messagesHistory) {
        var idx = messagesHistory.index[type];
        var messages = messagesHistory.messages;
        if (idx >= 0 && messages && messages.length > idx) {
            return messages[idx];
        }
        return '';
    });
}

function makeGetPostsForIds() {
    return (0, _helpers.createIdsSelector)(getAllPosts, function (state, postIds) {
        return postIds;
    }, function (allPosts, postIds) {
        if (!postIds) {
            return [];
        }

        return postIds.map(function (id) {
            return allPosts[id];
        });
    });
}

var getLastPostPerChannel = exports.getLastPostPerChannel = (0, _reselect.createSelector)(getAllPosts, function (state) {
    return state.entities.posts.postsInChannel;
}, function (allPosts, allChannels) {
    var ret = {};

    for (var channelId in allChannels) {
        if (allChannels.hasOwnProperty(channelId)) {
            var channelPosts = allChannels[channelId];
            if (channelPosts.length > 0) {
                var postId = channelPosts[0];
                if (allPosts.hasOwnProperty(postId)) {
                    ret[channelId] = allPosts[postId];
                }
            }
        }
    }

    return ret;
});

var getMostRecentPostIdInChannel = exports.getMostRecentPostIdInChannel = (0, _reselect.createSelector)(getAllPosts, function (state, channelId) {
    return state.entities.posts.postsInChannel[channelId];
}, _preferences.getMyPreferences, function (posts, postIdsInChannel, preferences) {
    if (!postIdsInChannel) {
        return '';
    }
    var key = (0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'join_leave');
    var allowSystemMessages = preferences[key] ? preferences[key].value === 'true' : true;

    if (!allowSystemMessages) {
        // return the most recent non-system message in the channel
        var postId = void 0;
        for (var i = 0; i < postIdsInChannel.length; i++) {
            var p = posts[postIdsInChannel[i]];
            if (!p.type || !p.type.startsWith(_constants.Posts.SYSTEM_MESSAGE_PREFIX)) {
                postId = p.id;
                break;
            }
        }
        return postId;
    }

    // return the most recent message in the channel
    return postIdsInChannel[0];
});

var getLatestReplyablePostId = exports.getLatestReplyablePostId = (0, _reselect.createSelector)(getPostsInCurrentChannel, function (posts) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = posts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var post = _step2.value;

            if (post.state !== _constants.Posts.POST_DELETED && !(0, _post_utils.isSystemMessage)(post) && !(0, _post_utils.isPostEphemeral)(post)) {
                return post.id;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return null;
});

var getCurrentUsersLatestPost = exports.getCurrentUsersLatestPost = (0, _reselect.createSelector)(getPostsInCurrentChannel, _common.getCurrentUser, function (_, rootId) {
    return rootId;
}, function (posts, currentUser, rootId) {
    var lastPost = null;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = posts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var post = _step3.value;

            // don't edit webhook posts, deleted posts, or system messages
            if (post.user_id !== currentUser.id || post.props && post.props.from_webhook || post.state === _constants.Posts.POST_DELETED || (0, _post_utils.isSystemMessage)(post) || (0, _post_utils.isPostEphemeral)(post)) {
                continue;
            }

            if (rootId) {
                if (post.root_id === rootId || post.id === rootId) {
                    lastPost = post;
                    break;
                }
            } else {
                lastPost = post;
                break;
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return lastPost;
});

var getPostIdsInChannel = exports.getPostIdsInChannel = (0, _helpers.createIdsSelector)(function (state, channelId) {
    return state.entities.posts.postsInChannel[channelId];
}, function (postIdsInChannel) {
    return postIdsInChannel || [];
});

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(45).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProfilesAndStatusesForPosts = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Note that getProfilesAndStatusesForPosts can take either an array of posts or a map of ids to posts
var getProfilesAndStatusesForPosts = exports.getProfilesAndStatusesForPosts = function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(posts, dispatch, getState) {
        var state, _state$entities$users, currentUserId, profiles, statuses, userIdsToLoad, statusesToLoad, promises, usernamesToLoad, emojisToLoad;

        return regeneratorRuntime.wrap(function _callee21$(_context21) {
            while (1) {
                switch (_context21.prev = _context21.next) {
                    case 0:
                        if (posts) {
                            _context21.next = 2;
                            break;
                        }

                        return _context21.abrupt('return', Promise.resolve());

                    case 2:
                        state = getState();
                        _state$entities$users = state.entities.users, currentUserId = _state$entities$users.currentUserId, profiles = _state$entities$users.profiles, statuses = _state$entities$users.statuses;
                        userIdsToLoad = new Set();
                        statusesToLoad = new Set();


                        Object.values(posts).forEach(function (post) {
                            var userId = post.user_id;

                            if (!statuses[userId]) {
                                statusesToLoad.add(userId);
                            }

                            if (userId === currentUserId) {
                                return;
                            }

                            if (!profiles[userId]) {
                                userIdsToLoad.add(userId);
                            }
                        });

                        promises = [];

                        if (userIdsToLoad.size > 0) {
                            promises.push((0, _users2.getProfilesByIds)(Array.from(userIdsToLoad))(dispatch, getState));
                        }

                        if (statusesToLoad.size > 0) {
                            promises.push((0, _users2.getStatusesByIds)(Array.from(statusesToLoad))(dispatch, getState));
                        }

                        // Do this after firing the other requests as it's more expensive
                        usernamesToLoad = getNeededAtMentionedUsernames(state, posts);
                        emojisToLoad = void 0;

                        if ((0, _general.getConfig)(state).EnableCustomEmoji === 'true') {
                            emojisToLoad = getNeededCustomEmojis(state, posts);
                        }

                        if (usernamesToLoad.size > 0) {
                            promises.push((0, _users2.getProfilesByUsernames)(Array.from(usernamesToLoad))(dispatch, getState));
                        }

                        if (emojisToLoad && emojisToLoad.size > 0) {
                            promises.push((0, _emojis2.getCustomEmojisByName)(Array.from(emojisToLoad))(dispatch, getState));
                        }

                        return _context21.abrupt('return', Promise.all(promises));

                    case 16:
                    case 'end':
                        return _context21.stop();
                }
            }
        }, _callee21, this);
    }));

    return function getProfilesAndStatusesForPosts(_x55, _x56, _x57) {
        return _ref21.apply(this, arguments);
    };
}();

exports.createPost = createPost;
exports.createPostImmediately = createPostImmediately;
exports.resetCreatePostRequest = resetCreatePostRequest;
exports.deletePost = deletePost;
exports.editPost = editPost;
exports.pinPost = pinPost;
exports.unpinPost = unpinPost;
exports.addReaction = addReaction;
exports.removeReaction = removeReaction;
exports.getCustomEmojiForReaction = getCustomEmojiForReaction;
exports.getReactionsForPost = getReactionsForPost;
exports.flagPost = flagPost;
exports.getPostThread = getPostThread;
exports.getPostThreadWithRetry = getPostThreadWithRetry;
exports.getPosts = getPosts;
exports.getPostsWithRetry = getPostsWithRetry;
exports.getPostsSince = getPostsSince;
exports.getPostsSinceWithRetry = getPostsSinceWithRetry;
exports.getPostsBefore = getPostsBefore;
exports.getPostsBeforeWithRetry = getPostsBeforeWithRetry;
exports.getPostsAfter = getPostsAfter;
exports.getPostsAfterWithRetry = getPostsAfterWithRetry;
exports.getNeededAtMentionedUsernames = getNeededAtMentionedUsernames;
exports.getNeededCustomEmojis = getNeededCustomEmojis;
exports.removePost = removePost;
exports.selectPost = selectPost;
exports.selectFocusedPostId = selectFocusedPostId;
exports.unflagPost = unflagPost;
exports.getOpenGraphMetadata = getOpenGraphMetadata;
exports.doPostAction = doPostAction;
exports.addMessageIntoHistory = addMessageIntoHistory;
exports.resetHistoryIndex = resetHistoryIndex;
exports.moveHistoryIndexBack = moveHistoryIndexBack;
exports.moveHistoryIndexForward = moveHistoryIndexForward;

var _reduxBatchedActions = __webpack_require__(278);

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _action_types = __webpack_require__(3);

var _users = __webpack_require__(777);

var _emojis = __webpack_require__(877);

var _posts3 = __webpack_require__(805);

var Selectors = _interopRequireWildcard(_posts3);

var _general = __webpack_require__(113);

var _emoji_utils = __webpack_require__(1015);

var _helpers = __webpack_require__(821);

var _errors = __webpack_require__(828);

var _preferences = __webpack_require__(861);

var _users2 = __webpack_require__(786);

var _emojis2 = __webpack_require__(853);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function createPost(post) {
    var _this = this;

    var files = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var state, currentUserId, timestamp, pendingPostId, newPost, fileIds;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            currentUserId = state.entities.users.currentUserId;
                            timestamp = Date.now();
                            pendingPostId = post.pending_post_id || currentUserId + ':' + timestamp;
                            newPost = _extends({}, post, {
                                pending_post_id: pendingPostId,
                                create_at: timestamp,
                                update_at: timestamp
                            });

                            // We are retrying a pending post that had files

                            if (newPost.file_ids && !files.length) {
                                files = newPost.file_ids.map(function (id) {
                                    return state.entities.files.files[id];
                                }); // eslint-disable-line
                            }

                            if (files.length) {
                                fileIds = files.map(function (file) {
                                    return file.id;
                                });


                                newPost = _extends({}, newPost, {
                                    file_ids: fileIds
                                });

                                dispatch({
                                    type: _action_types.FileTypes.RECEIVED_FILES_FOR_POST,
                                    postId: pendingPostId,
                                    data: files
                                });
                            }

                            dispatch({
                                type: _action_types.PostTypes.RECEIVED_NEW_POST,
                                data: _extends({
                                    id: pendingPostId
                                }, newPost),
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.createPost(_extends({}, newPost, { create_at: 0 }));
                                        },
                                        commit: function commit(success, payload) {
                                            // Use RECEIVED_POSTS to clear pending posts
                                            var actions = [{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: {
                                                    order: [],
                                                    posts: _defineProperty({}, payload.id, payload)
                                                },
                                                channelId: payload.channel_id
                                            }];

                                            if (files) {
                                                actions.push({
                                                    type: _action_types.FileTypes.RECEIVED_FILES_FOR_POST,
                                                    postId: payload.id,
                                                    data: files
                                                });
                                            }

                                            actions.push({
                                                type: _action_types.PostTypes.CREATE_POST_SUCCESS
                                            });

                                            dispatch((0, _reduxBatchedActions.batchActions)(actions));
                                        },
                                        maxRetry: 0,
                                        offlineRollback: true,
                                        rollback: function rollback(success, error) {
                                            var data = _extends({}, newPost, {
                                                id: pendingPostId,
                                                failed: true
                                            });

                                            var actions = [{ type: _action_types.PostTypes.CREATE_POST_FAILURE, error: error }];

                                            // If the failure was because: the root post was deleted or
                                            // TownSquareIsReadOnly=true then remove the post
                                            if (error.server_error_id === 'api.post.create_post.root_id.app_error' || error.server_error_id === 'api.post.create_post.town_square_read_only') {
                                                dispatch(removePost(data));
                                            } else {
                                                actions.push({
                                                    type: _action_types.PostTypes.RECEIVED_POST,
                                                    data: data
                                                });
                                            }

                                            dispatch((0, _reduxBatchedActions.batchActions)(actions));
                                        }
                                    }
                                }
                            });

                            return _context.abrupt('return', { data: true });

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x2, _x3) {
            return _ref.apply(this, arguments);
        };
    }();
}

function createPostImmediately(post) {
    var _this2 = this;

    var files = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var state, currentUserId, timestamp, pendingPostId, newPost, fileIds, created, actions;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            currentUserId = state.entities.users.currentUserId;
                            timestamp = Date.now();
                            pendingPostId = currentUserId + ':' + timestamp;
                            newPost = _extends({}, post, {
                                pending_post_id: pendingPostId,
                                create_at: timestamp,
                                update_at: timestamp
                            });


                            if (files.length) {
                                fileIds = files.map(function (file) {
                                    return file.id;
                                });


                                newPost = _extends({}, newPost, {
                                    file_ids: fileIds
                                });

                                dispatch({
                                    type: _action_types.FileTypes.RECEIVED_FILES_FOR_POST,
                                    postId: pendingPostId,
                                    data: files
                                });
                            }

                            dispatch({
                                type: _action_types.PostTypes.RECEIVED_NEW_POST,
                                data: _extends({
                                    id: pendingPostId
                                }, newPost)
                            });

                            _context2.prev = 7;
                            _context2.next = 10;
                            return _client.Client4.createPost(_extends({}, newPost, { create_at: 0 }));

                        case 10:
                            created = _context2.sent;

                            newPost.id = created.id;
                            _context2.next = 19;
                            break;

                        case 14:
                            _context2.prev = 14;
                            _context2.t0 = _context2['catch'](7);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.CREATE_POST_FAILURE, error: _context2.t0 }, { type: _action_types.PostTypes.REMOVE_PENDING_POST, data: { id: pendingPostId, channel_id: newPost.channel_id } }, (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', { error: _context2.t0 });

                        case 19:
                            actions = [{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: {
                                    order: [],
                                    posts: _defineProperty({}, newPost.id, newPost)
                                },
                                channelId: newPost.channel_id
                            }];


                            if (files) {
                                actions.push({
                                    type: _action_types.FileTypes.RECEIVED_FILES_FOR_POST,
                                    postId: newPost.id,
                                    data: files
                                });
                            }

                            actions.push({
                                type: _action_types.PostTypes.CREATE_POST_SUCCESS
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context2.abrupt('return', { data: newPost });

                        case 24:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[7, 14]]);
        }));

        return function (_x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function resetCreatePostRequest() {
    return { type: _action_types.PostTypes.CREATE_POST_RESET_REQUEST };
}

function deletePost(post) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
            var delPost;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            delPost = _extends({}, post);


                            dispatch({
                                type: _action_types.PostTypes.POST_DELETED,
                                data: delPost,
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.deletePost(post.id);
                                        },
                                        commit: { type: _action_types.PostTypes.POST_DELETED },
                                        rollback: {
                                            type: _action_types.PostTypes.RECEIVED_POST,
                                            data: delPost
                                        }
                                    }
                                }
                            });

                            return _context3.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x7) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function editPost(post) {
    return (0, _helpers.bindClientFunc)(_client.Client4.patchPost, _action_types.PostTypes.EDIT_POST_REQUEST, [_action_types.PostTypes.RECEIVED_POST, _action_types.PostTypes.EDIT_POST_SUCCESS], _action_types.PostTypes.EDIT_POST_FAILURE, post);
}

function pinPost(postId) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var posts, actions, post;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.EDIT_POST_REQUEST }, getState);
                            posts = void 0;
                            _context4.prev = 2;
                            _context4.next = 5;
                            return _client.Client4.pinPost(postId);

                        case 5:
                            posts = _context4.sent;
                            _context4.next = 13;
                            break;

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.EDIT_POST_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', { error: _context4.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.PostTypes.EDIT_POST_SUCCESS
                            }];
                            post = Selectors.getPost(getState(), postId);

                            if (post) {
                                actions.push({
                                    type: _action_types.PostTypes.RECEIVED_POST,
                                    data: _extends({}, post, { is_pinned: true })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context4.abrupt('return', { data: posts });

                        case 18:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[2, 8]]);
        }));

        return function (_x8, _x9) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function unpinPost(postId) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var posts, actions, post;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.EDIT_POST_REQUEST }, getState);
                            posts = void 0;
                            _context5.prev = 2;
                            _context5.next = 5;
                            return _client.Client4.unpinPost(postId);

                        case 5:
                            posts = _context5.sent;
                            _context5.next = 13;
                            break;

                        case 8:
                            _context5.prev = 8;
                            _context5.t0 = _context5['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.EDIT_POST_FAILURE, error: _context5.t0 }, (0, _errors.logError)(_context5.t0)(dispatch)]), getState);
                            return _context5.abrupt('return', { error: _context5.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.PostTypes.EDIT_POST_SUCCESS
                            }];
                            post = Selectors.getPost(getState(), postId);

                            if (post) {
                                actions.push({
                                    type: _action_types.PostTypes.RECEIVED_POST,
                                    data: _extends({}, post, { is_pinned: false })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context5.abrupt('return', { data: posts });

                        case 18:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[2, 8]]);
        }));

        return function (_x10, _x11) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function addReaction(postId, emojiName) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var currentUserId, reaction;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.REACTION_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            reaction = void 0;
                            _context6.prev = 3;
                            _context6.next = 6;
                            return _client.Client4.addReaction(currentUserId, postId, emojiName);

                        case 6:
                            reaction = _context6.sent;
                            _context6.next = 14;
                            break;

                        case 9:
                            _context6.prev = 9;
                            _context6.t0 = _context6['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.REACTION_FAILURE, error: _context6.t0 }, (0, _errors.logError)(_context6.t0)(dispatch)]), getState);
                            return _context6.abrupt('return', { error: _context6.t0 });

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.REACTION_SUCCESS
                            }, {
                                type: _action_types.PostTypes.RECEIVED_REACTION,
                                data: reaction
                            }]));

                            return _context6.abrupt('return', { data: true });

                        case 16:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[3, 9]]);
        }));

        return function (_x12, _x13) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function removeReaction(postId, emojiName) {
    var _this7 = this;

    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var currentUserId;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.REACTION_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            _context7.prev = 2;
                            _context7.next = 5;
                            return _client.Client4.removeReaction(currentUserId, postId, emojiName);

                        case 5:
                            _context7.next = 12;
                            break;

                        case 7:
                            _context7.prev = 7;
                            _context7.t0 = _context7['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.REACTION_FAILURE, error: _context7.t0 }, (0, _errors.logError)(_context7.t0)(dispatch)]), getState);
                            return _context7.abrupt('return', { error: _context7.t0 });

                        case 12:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.REACTION_SUCCESS
                            }, {
                                type: _action_types.PostTypes.REACTION_DELETED,
                                data: { user_id: currentUserId, post_id: postId, emoji_name: emojiName }
                            }]));

                            return _context7.abrupt('return', { data: true });

                        case 14:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[2, 7]]);
        }));

        return function (_x14, _x15) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function getCustomEmojiForReaction(name) {
    var _this8 = this;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var nonExistentEmoji, customEmojisByName;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            nonExistentEmoji = getState().entities.emojis.nonExistentEmoji;
                            customEmojisByName = (0, _emojis.getCustomEmojisByName)(getState());

                            if (!_emojis2.systemEmojis.has(name)) {
                                _context8.next = 4;
                                break;
                            }

                            return _context8.abrupt('return', { data: true });

                        case 4:
                            if (!nonExistentEmoji.has(name)) {
                                _context8.next = 6;
                                break;
                            }

                            return _context8.abrupt('return', { data: true });

                        case 6:
                            if (!customEmojisByName.has(name)) {
                                _context8.next = 8;
                                break;
                            }

                            return _context8.abrupt('return', { data: true });

                        case 8:
                            _context8.next = 10;
                            return dispatch((0, _emojis2.getCustomEmojiByName)(name));

                        case 10:
                            return _context8.abrupt('return', _context8.sent);

                        case 11:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }));

        return function (_x16, _x17) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function getReactionsForPost(postId) {
    var _this9 = this;

    return function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var reactions, nonExistentEmoji, customEmojisByName, emojisToLoad;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.REACTION_REQUEST }, getState);

                            reactions = void 0;
                            _context9.prev = 2;
                            _context9.next = 5;
                            return _client.Client4.getReactionsForPost(postId);

                        case 5:
                            reactions = _context9.sent;
                            _context9.next = 13;
                            break;

                        case 8:
                            _context9.prev = 8;
                            _context9.t0 = _context9['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.REACTION_FAILURE, error: _context9.t0 }, (0, _errors.logError)(_context9.t0)(dispatch)]), getState);
                            return _context9.abrupt('return', { error: _context9.t0 });

                        case 13:

                            if (reactions && reactions.length > 0) {
                                nonExistentEmoji = getState().entities.emojis.nonExistentEmoji;
                                customEmojisByName = (0, _emojis.getCustomEmojisByName)(getState());
                                emojisToLoad = new Set();


                                reactions.forEach(function (r) {
                                    var name = r.emoji_name;

                                    if (_emojis2.systemEmojis.has(name)) {
                                        // It's a system emoji, go the next match
                                        return;
                                    }

                                    if (nonExistentEmoji.has(name)) {
                                        // We've previously confirmed this is not a custom emoji
                                        return;
                                    }

                                    if (customEmojisByName.has(name)) {
                                        // We have the emoji, go to the next match
                                        return;
                                    }

                                    emojisToLoad.add(name);
                                });

                                dispatch((0, _emojis2.getCustomEmojisByName)(Array.from(emojisToLoad)));
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.REACTION_SUCCESS
                            }, {
                                type: _action_types.PostTypes.RECEIVED_REACTIONS,
                                data: reactions,
                                postId: postId
                            }]));

                            return _context9.abrupt('return', reactions);

                        case 16:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9, [[2, 8]]);
        }));

        return function (_x18, _x19) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function flagPost(postId) {
    var _this10 = this;

    return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var currentUserId, preference;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            currentUserId = getState().entities.users.currentUserId;
                            preference = {
                                user_id: currentUserId,
                                category: _constants.Preferences.CATEGORY_FLAGGED_POST,
                                name: postId,
                                value: 'true'
                            };


                            _client.Client4.trackEvent('action', 'action_posts_flag');

                            _context10.next = 5;
                            return (0, _preferences.savePreferences)(currentUserId, [preference])(dispatch, getState);

                        case 5:
                            return _context10.abrupt('return', _context10.sent);

                        case 6:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10);
        }));

        return function (_x20, _x21) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function getPostThread(postId) {
    var _this11 = this;

    var skipAddToChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var posts, post;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POST_THREAD_REQUEST }, getState);

                            posts = void 0;
                            _context11.prev = 2;
                            _context11.next = 5;
                            return _client.Client4.getPostThread(postId);

                        case 5:
                            posts = _context11.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context11.next = 14;
                            break;

                        case 9:
                            _context11.prev = 9;
                            _context11.t0 = _context11['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POST_THREAD_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', { error: _context11.t0 });

                        case 14:
                            post = posts.posts[postId];


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: post.channel_id,
                                skipAddToChannel: skipAddToChannel
                            }, {
                                type: _action_types.PostTypes.GET_POST_THREAD_SUCCESS
                            }], 'BATCH_GET_POST_THREAD'), getState);

                            return _context11.abrupt('return', { data: posts });

                        case 17:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11, [[2, 9]]);
        }));

        return function (_x23, _x24) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function getPostThreadWithRetry(postId) {
    var _this12 = this;

    return function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.GET_POST_THREAD_REQUEST
                            });

                            dispatch({
                                type: _action_types.PostTypes.GET_POST_THREAD_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPostThread(postId);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            var post = posts[postId];
                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: post.channel_id,
                                                skipAddToChannel: true
                                            }, {
                                                type: _action_types.PostTypes.GET_POST_THREAD_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POST_THREAD_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch, getState);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POST_THREAD_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                            return _context12.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }));

        return function (_x25, _x26) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function getPosts(channelId) {
    var _this13 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var posts;
            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_REQUEST }, getState);
                            posts = void 0;
                            _context13.prev = 2;
                            _context13.next = 5;
                            return _client.Client4.getPosts(channelId, page, perPage);

                        case 5:
                            posts = _context13.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context13.next = 14;
                            break;

                        case 9:
                            _context13.prev = 9;
                            _context13.t0 = _context13['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context13.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_FAILURE, error: _context13.t0 }, (0, _errors.logError)(_context13.t0)(dispatch)]), getState);
                            return _context13.abrupt('return', { error: _context13.t0 });

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: channelId
                            }, {
                                type: _action_types.PostTypes.GET_POSTS_SUCCESS
                            }]), getState);

                            return _context13.abrupt('return', { data: posts });

                        case 16:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13, [[2, 9]]);
        }));

        return function (_x29, _x30) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function getPostsWithRetry(channelId) {
    var _this14 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_REQUEST
                            });

                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPosts(channelId, page, perPage);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: channelId
                                            }, {
                                                type: _action_types.PostTypes.GET_POSTS_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POSTS_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch, getState);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                            return _context14.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14);
        }));

        return function (_x33, _x34) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function getPostsSince(channelId, since) {
    var _this15 = this;

    return function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(dispatch, getState) {
            var posts;
            return regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_SINCE_REQUEST }, getState);

                            posts = void 0;
                            _context15.prev = 2;
                            _context15.next = 5;
                            return _client.Client4.getPostsSince(channelId, since);

                        case 5:
                            posts = _context15.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context15.next = 14;
                            break;

                        case 9:
                            _context15.prev = 9;
                            _context15.t0 = _context15['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context15.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_SINCE_FAILURE, error: _context15.t0 }, (0, _errors.logError)(_context15.t0)(dispatch)]), getState);
                            return _context15.abrupt('return', { error: _context15.t0 });

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: channelId
                            }, {
                                type: _action_types.PostTypes.GET_POSTS_SINCE_SUCCESS
                            }]), getState);

                            return _context15.abrupt('return', { data: posts });

                        case 16:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15, [[2, 9]]);
        }));

        return function (_x35, _x36) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function getPostsSinceWithRetry(channelId, since) {
    var _this16 = this;

    return function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_SINCE_REQUEST }, getState);

                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_SINCE_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPostsSince(channelId, since);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: channelId
                                            }, {
                                                type: _action_types.PostTypes.GET_POSTS_SINCE_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POSTS_SINCE_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch, getState);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_SINCE_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                            return _context16.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16);
        }));

        return function (_x37, _x38) {
            return _ref16.apply(this, arguments);
        };
    }();
}

function getPostsBefore(channelId, postId) {
    var _this17 = this;

    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(dispatch, getState) {
            var posts;
            return regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_BEFORE_REQUEST }, getState);

                            posts = void 0;
                            _context17.prev = 2;
                            _context17.next = 5;
                            return _client.Client4.getPostsBefore(channelId, postId, page, perPage);

                        case 5:
                            posts = _context17.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context17.next = 14;
                            break;

                        case 9:
                            _context17.prev = 9;
                            _context17.t0 = _context17['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context17.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_BEFORE_FAILURE, error: _context17.t0 }, (0, _errors.logError)(_context17.t0)(dispatch)]), getState);
                            return _context17.abrupt('return', { error: _context17.t0 });

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: channelId
                            }, {
                                type: _action_types.PostTypes.GET_POSTS_BEFORE_SUCCESS
                            }]), getState);

                            return _context17.abrupt('return', { data: posts });

                        case 16:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17, [[2, 9]]);
        }));

        return function (_x41, _x42) {
            return _ref17.apply(this, arguments);
        };
    }();
}

function getPostsBeforeWithRetry(channelId, postId) {
    var _this18 = this;

    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_BEFORE_REQUEST
                            });

                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_BEFORE_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPostsBefore(channelId, postId, page, perPage);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: channelId
                                            }, {
                                                type: _action_types.PostTypes.GET_POSTS_BEFORE_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POSTS_BEFORE_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch, getState);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_BEFORE_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                            return _context18.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18);
        }));

        return function (_x45, _x46) {
            return _ref18.apply(this, arguments);
        };
    }();
}

function getPostsAfter(channelId, postId) {
    var _this19 = this;

    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(dispatch, getState) {
            var posts;
            return regeneratorRuntime.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_AFTER_REQUEST }, getState);

                            posts = void 0;
                            _context19.prev = 2;
                            _context19.next = 5;
                            return _client.Client4.getPostsAfter(channelId, postId, page, perPage);

                        case 5:
                            posts = _context19.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context19.next = 14;
                            break;

                        case 9:
                            _context19.prev = 9;
                            _context19.t0 = _context19['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context19.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_AFTER_FAILURE, error: _context19.t0 }, (0, _errors.logError)(_context19.t0)(dispatch)]), getState);
                            return _context19.abrupt('return', { error: _context19.t0 });

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: channelId
                            }, {
                                type: _action_types.PostTypes.GET_POSTS_AFTER_SUCCESS
                            }]), getState);

                            return _context19.abrupt('return', { data: posts });

                        case 16:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, _this19, [[2, 9]]);
        }));

        return function (_x49, _x50) {
            return _ref19.apply(this, arguments);
        };
    }();
}

function getPostsAfterWithRetry(channelId, postId) {
    var _this20 = this;

    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_AFTER_REQUEST
                            });

                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_AFTER_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPostsAfter(channelId, postId, page, perPage);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: channelId
                                            }, {
                                                type: _action_types.PostTypes.GET_POSTS_AFTER_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POSTS_AFTER_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch, getState);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_AFTER_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                            return _context20.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, _this20);
        }));

        return function (_x53, _x54) {
            return _ref20.apply(this, arguments);
        };
    }();
}function getNeededAtMentionedUsernames(state, posts) {
    var usersByUsername = void 0; // Populate this lazily since it's relatively expensive

    var usernamesToLoad = new Set();

    Object.values(posts).forEach(function (post) {
        if (!post.message.includes('@')) {
            return;
        }

        if (!usersByUsername) {
            usersByUsername = (0, _users.getUsersByUsername)(state);
        }

        var pattern = /\B@(([a-z0-9_.-]*[a-z0-9_])[.-]*)/gi;

        var match = void 0;
        while ((match = pattern.exec(post.message)) !== null) {
            // match[1] is the matched mention including trailing punctuation
            // match[2] is the matched mention without trailing punctuation
            if (_constants.General.SPECIAL_MENTIONS.indexOf(match[2]) !== -1) {
                continue;
            }

            if (usersByUsername[match[1]] || usersByUsername[match[2]]) {
                // We have the user, go to the next match
                continue;
            }

            // If there's no trailing punctuation, this will only add 1 item to the set
            usernamesToLoad.add(match[1]);
            usernamesToLoad.add(match[2]);
        }
    });

    return usernamesToLoad;
}

function buildPostAttachmentText(attachments) {
    var attachmentText = '';

    attachments.forEach(function (a) {
        if (a.fields && a.fields.length) {
            a.fields.forEach(function (f) {
                attachmentText += ' ' + (f.value || '');
            });
        }

        if (a.pretext) {
            attachmentText += ' ' + a.pretext;
        }

        if (a.text) {
            attachmentText += ' ' + a.text;
        }
    });

    return attachmentText;
}

function getNeededCustomEmojis(state, posts) {
    var customEmojisByName = void 0; // Populate this lazily since it's relatively expensive
    var nonExistentEmoji = state.entities.emojis.nonExistentEmoji;

    var customEmojisToLoad = new Set();

    Object.values(posts).forEach(function (post) {
        if (post.message.includes(':')) {
            if (!customEmojisByName) {
                customEmojisByName = (0, _emojis.getCustomEmojisByName)(state);
            }

            var emojisFromPost = (0, _emoji_utils.parseNeededCustomEmojisFromText)(post.message, _emojis2.systemEmojis, customEmojisByName, nonExistentEmoji);

            if (emojisFromPost.size > 0) {
                customEmojisToLoad = new Set([].concat(_toConsumableArray(customEmojisToLoad), _toConsumableArray(emojisFromPost)));
            }
        }

        var props = post.props;
        if (props && props.attachments && props.attachments.length) {
            if (!customEmojisByName) {
                customEmojisByName = (0, _emojis.getCustomEmojisByName)(state);
            }

            var attachmentText = buildPostAttachmentText(props.attachments);

            if (attachmentText) {
                var emojisFromAttachment = (0, _emoji_utils.parseNeededCustomEmojisFromText)(attachmentText, _emojis2.systemEmojis, customEmojisByName, nonExistentEmoji);

                if (emojisFromAttachment.size > 0) {
                    customEmojisToLoad = new Set([].concat(_toConsumableArray(customEmojisToLoad), _toConsumableArray(emojisFromAttachment)));
                }
            }
        }
    });

    return customEmojisToLoad;
}

function removePost(post) {
    var _this21 = this;

    return function () {
        var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.REMOVE_POST,
                                data: _extends({}, post)
                            }, getState);

                            return _context22.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this21);
        }));

        return function (_x58, _x59) {
            return _ref22.apply(this, arguments);
        };
    }();
}

function selectPost(postId) {
    var _this22 = this;

    return function () {
        var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.RECEIVED_POST_SELECTED,
                                data: postId
                            }, getState);

                            return _context23.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this22);
        }));

        return function (_x60, _x61) {
            return _ref23.apply(this, arguments);
        };
    }();
}

function selectFocusedPostId(postId) {
    return {
        type: _action_types.PostTypes.RECEIVED_FOCUSED_POST,
        data: postId
    };
}

function unflagPost(postId) {
    var _this23 = this;

    return function () {
        var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(dispatch, getState) {
            var currentUserId, preference;
            return regeneratorRuntime.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            currentUserId = getState().entities.users.currentUserId;
                            preference = {
                                user_id: currentUserId,
                                category: _constants.Preferences.CATEGORY_FLAGGED_POST,
                                name: postId
                            };


                            _client.Client4.trackEvent('action', 'action_posts_unflag');

                            _context24.next = 5;
                            return (0, _preferences.deletePreferences)(currentUserId, [preference])(dispatch, getState);

                        case 5:
                            return _context24.abrupt('return', _context24.sent);

                        case 6:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this23);
        }));

        return function (_x62, _x63) {
            return _ref24.apply(this, arguments);
        };
    }();
}

function getOpenGraphMetadata(url) {
    var _this24 = this;

    return function () {
        var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(dispatch, getState) {
            var data, actions;
            return regeneratorRuntime.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.OPEN_GRAPH_REQUEST }, getState);

                            data = void 0;
                            _context25.prev = 2;
                            _context25.next = 5;
                            return _client.Client4.getOpenGraphMetadata(url);

                        case 5:
                            data = _context25.sent;
                            _context25.next = 13;
                            break;

                        case 8:
                            _context25.prev = 8;
                            _context25.t0 = _context25['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context25.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.OPEN_GRAPH_FAILURE, error: _context25.t0 }, (0, _errors.logError)(_context25.t0)(dispatch)]), getState);
                            return _context25.abrupt('return', { error: _context25.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.PostTypes.OPEN_GRAPH_SUCCESS
                            }];


                            if (data.description) {
                                actions.push({
                                    type: _action_types.PostTypes.RECEIVED_OPEN_GRAPH_METADATA,
                                    data: data,
                                    url: url
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context25.abrupt('return', { data: data });

                        case 17:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, _this24, [[2, 8]]);
        }));

        return function (_x64, _x65) {
            return _ref25.apply(this, arguments);
        };
    }();
}

function doPostAction(postId, actionId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.doPostAction, _action_types.PostTypes.DO_POST_ACTION_REQUEST, [_action_types.PostTypes.DO_POST_ACTION_SUCCESS], _action_types.PostTypes.DO_POST_ACTION_FAILURE, postId, actionId);
}

function addMessageIntoHistory(message) {
    var _this25 = this;

    return function () {
        var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.ADD_MESSAGE_INTO_HISTORY,
                                data: message
                            }, getState);

                            return _context26.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, _this25);
        }));

        return function (_x66, _x67) {
            return _ref26.apply(this, arguments);
        };
    }();
}

function resetHistoryIndex(index) {
    var _this26 = this;

    return function () {
        var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.RESET_HISTORY_INDEX,
                                data: index
                            }, getState);

                            return _context27.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, _this26);
        }));

        return function (_x68, _x69) {
            return _ref27.apply(this, arguments);
        };
    }();
}

function moveHistoryIndexBack(index) {
    var _this27 = this;

    return function () {
        var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.MOVE_HISTORY_INDEX_BACK,
                                data: index
                            }, getState);

                            return _context28.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context28.stop();
                    }
                }
            }, _callee28, _this27);
        }));

        return function (_x70, _x71) {
            return _ref28.apply(this, arguments);
        };
    }();
}

function moveHistoryIndexForward(index) {
    var _this28 = this;

    return function () {
        var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.MOVE_HISTORY_INDEX_FORWARD,
                                data: index
                            }, getState);

                            return _context29.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, _this28);
        }));

        return function (_x72, _x73) {
            return _ref29.apply(this, arguments);
        };
    }();
}

exports.default = {
    createPost: createPost,
    createPostImmediately: createPostImmediately,
    resetCreatePostRequest: resetCreatePostRequest,
    editPost: editPost,
    deletePost: deletePost,
    removePost: removePost,
    getPostThread: getPostThread,
    getPostThreadWithRetry: getPostThreadWithRetry,
    getPosts: getPosts,
    getPostsWithRetry: getPostsWithRetry,
    getPostsSince: getPostsSince,
    getPostsSinceWithRetry: getPostsSinceWithRetry,
    getPostsBefore: getPostsBefore,
    getPostsBeforeWithRetry: getPostsBeforeWithRetry,
    getPostsAfter: getPostsAfter,
    getPostsAfterWithRetry: getPostsAfterWithRetry,
    selectPost: selectPost,
    selectFocusedPostId: selectFocusedPostId,
    addMessageIntoHistory: addMessageIntoHistory,
    resetHistoryIndex: resetHistoryIndex,
    moveHistoryIndexBack: moveHistoryIndexBack,
    moveHistoryIndexForward: moveHistoryIndexForward
};

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteChannel = exports.leaveChannel = exports.getChannelMembersForUserIds = exports.updateChannelHeader = exports.updateChannelPurpose = exports.createChannel = exports.autocompleteChannels = exports.searchMoreChannels = exports.updateChannel = exports.joinChannel = exports.loadChannelsForCurrentUser = exports.openGroupChannelToUsers = exports.openDirectChannelToUser = exports.makeUserChannelMember = exports.makeUserChannelAdmin = exports.removeUserFromChannel = exports.addUserToChannel = undefined;

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var addUserToChannel = exports.addUserToChannel = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(channelId, userId, success, error) {
        var _ref2, data, err;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return ChannelActions.addChannelMember(channelId, userId)(dispatch, getState);

                    case 2:
                        _ref2 = _context.sent;
                        data = _ref2.data;
                        err = _ref2.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function addUserToChannel(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
    };
}();

var removeUserFromChannel = exports.removeUserFromChannel = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(channelId, userId, success, error) {
        var _ref4, data, err;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return ChannelActions.removeChannelMember(channelId, userId)(dispatch, getState);

                    case 2:
                        _ref4 = _context2.sent;
                        data = _ref4.data;
                        err = _ref4.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function removeUserFromChannel(_x5, _x6, _x7, _x8) {
        return _ref3.apply(this, arguments);
    };
}();

var makeUserChannelAdmin = exports.makeUserChannelAdmin = function () {
    var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(channelId, userId, success, error) {
        var _ref6, data, err;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return ChannelActions.updateChannelMemberRoles(channelId, userId, 'channel_user channel_admin')(dispatch, getState);

                    case 2:
                        _ref6 = _context3.sent;
                        data = _ref6.data;
                        err = _ref6.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function makeUserChannelAdmin(_x9, _x10, _x11, _x12) {
        return _ref5.apply(this, arguments);
    };
}();

var makeUserChannelMember = exports.makeUserChannelMember = function () {
    var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(channelId, userId, success, error) {
        var _ref8, data, err;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return ChannelActions.updateChannelMemberRoles(channelId, userId, 'channel_user')(dispatch, getState);

                    case 2:
                        _ref8 = _context4.sent;
                        data = _ref8.data;
                        err = _ref8.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function makeUserChannelMember(_x13, _x14, _x15, _x16) {
        return _ref7.apply(this, arguments);
    };
}();

var openDirectChannelToUser = exports.openDirectChannelToUser = function () {
    var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(userId, success, error) {
        var channelName, channel, now, currentUserId, result;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        channelName = Utils.getDirectChannelName(_user_store2.default.getCurrentId(), userId);
                        channel = _channel_store2.default.getByName(channelName);

                        if (!channel) {
                            _context5.next = 12;
                            break;
                        }

                        (0, _diagnostics_actions.trackEvent)('api', 'api_channels_join_direct');
                        now = Utils.getTimestamp();

                        _preference_store2.default.setPreference(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, userId, 'true');
                        _preference_store2.default.setPreference(_constants.Preferences.CATEGORY_CHANNEL_OPEN_TIME, channel.id, now.toString());
                        (0, _user_actions.loadProfilesForSidebar)();

                        currentUserId = _user_store2.default.getCurrentId();

                        (0, _preferences.savePreferences)(currentUserId, [{ user_id: currentUserId, category: _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, name: userId, value: 'true' }, { user_id: currentUserId, category: _constants.Preferences.CATEGORY_CHANNEL_OPEN_TIME, name: channel.id, value: now.toString() }])(dispatch, getState);

                        if (success) {
                            success(channel, true);
                        }

                        return _context5.abrupt('return');

                    case 12:
                        _context5.next = 14;
                        return ChannelActions.createDirectChannel(_user_store2.default.getCurrentId(), userId)(dispatch, getState);

                    case 14:
                        result = _context5.sent;

                        (0, _user_actions.loadProfilesForSidebar)();
                        if (result.data && success) {
                            success(result.data, false);
                        } else if (result.error && error) {
                            error((0, _extends3.default)({ id: result.error.server_error_id }, result.error));
                        }

                    case 17:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function openDirectChannelToUser(_x17, _x18, _x19) {
        return _ref9.apply(this, arguments);
    };
}();

var openGroupChannelToUsers = exports.openGroupChannelToUsers = function () {
    var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(userIds, success, error) {
        var result;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return ChannelActions.createGroupChannel(userIds)(dispatch, getState);

                    case 2:
                        result = _context6.sent;

                        (0, _user_actions.loadProfilesForSidebar)();
                        if (result.data && success) {
                            success(result.data, false);
                        } else if (result.error && error) {
                            _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamUrl());
                            error((0, _extends3.default)({ id: result.error.server_error_id }, result.error));
                        }

                    case 5:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function openGroupChannelToUsers(_x20, _x21, _x22) {
        return _ref10.apply(this, arguments);
    };
}();

var loadChannelsForCurrentUser = exports.loadChannelsForCurrentUser = function () {
    var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
        return _regenerator2.default.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return ChannelActions.fetchMyChannelsAndMembers(_team_store2.default.getCurrentId())(dispatch, getState);

                    case 2:
                        loadDMsAndGMsForUnreads();

                    case 3:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function loadChannelsForCurrentUser() {
        return _ref11.apply(this, arguments);
    };
}();

var joinChannel = exports.joinChannel = function () {
    var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(channel, success, error) {
        var _ref13, data, err;

        return _regenerator2.default.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        _context8.next = 2;
                        return ChannelActions.joinChannel(_user_store2.default.getCurrentId(), null, channel.id)(dispatch, getState);

                    case 2:
                        _ref13 = _context8.sent;
                        data = _ref13.data;
                        err = _ref13.err;


                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function joinChannel(_x23, _x24, _x25) {
        return _ref12.apply(this, arguments);
    };
}();

var updateChannel = exports.updateChannel = function () {
    var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(channel, success, error) {
        var _ref15, data, err;

        return _regenerator2.default.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.next = 2;
                        return ChannelActions.updateChannel(channel)(dispatch, getState);

                    case 2:
                        _ref15 = _context9.sent;
                        data = _ref15.data;
                        err = _ref15.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function updateChannel(_x26, _x27, _x28) {
        return _ref14.apply(this, arguments);
    };
}();

var searchMoreChannels = exports.searchMoreChannels = function () {
    var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(term, success, error) {
        var teamId, _ref17, data, err, myMembers, channels;

        return _regenerator2.default.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        teamId = _team_store2.default.getCurrentId();

                        if (teamId) {
                            _context10.next = 3;
                            break;
                        }

                        return _context10.abrupt('return');

                    case 3:
                        _context10.next = 5;
                        return ChannelActions.searchChannels(teamId, term)(dispatch, getState);

                    case 5:
                        _ref17 = _context10.sent;
                        data = _ref17.data;
                        err = _ref17.error;

                        if (data && success) {
                            myMembers = (0, _common.getMyChannelMemberships)(getState());
                            channels = data.filter(function (c) {
                                return !myMembers[c.id];
                            });

                            success(channels);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 9:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function searchMoreChannels(_x29, _x30, _x31) {
        return _ref16.apply(this, arguments);
    };
}();

var autocompleteChannels = exports.autocompleteChannels = function () {
    var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(term, success, error) {
        var teamId, _ref19, data, err;

        return _regenerator2.default.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        teamId = _team_store2.default.getCurrentId();

                        if (teamId) {
                            _context11.next = 3;
                            break;
                        }

                        return _context11.abrupt('return');

                    case 3:
                        _context11.next = 5;
                        return ChannelActions.autocompleteChannels(teamId, term)(dispatch, getState);

                    case 5:
                        _ref19 = _context11.sent;
                        data = _ref19.data;
                        err = _ref19.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 9:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function autocompleteChannels(_x32, _x33, _x34) {
        return _ref18.apply(this, arguments);
    };
}();

var createChannel = exports.createChannel = function () {
    var _ref20 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(channel, success, error) {
        var _ref21, data, err;

        return _regenerator2.default.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        _context12.next = 2;
                        return ChannelActions.createChannel(channel)(dispatch, getState);

                    case 2:
                        _ref21 = _context12.sent;
                        data = _ref21.data;
                        err = _ref21.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function createChannel(_x35, _x36, _x37) {
        return _ref20.apply(this, arguments);
    };
}();

var updateChannelPurpose = exports.updateChannelPurpose = function () {
    var _ref22 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(channelId, purpose, success, error) {
        var _ref23, data, err;

        return _regenerator2.default.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        _context13.next = 2;
                        return ChannelActions.patchChannel(channelId, { purpose: purpose })(dispatch, getState);

                    case 2:
                        _ref23 = _context13.sent;
                        data = _ref23.data;
                        err = _ref23.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, this);
    }));

    return function updateChannelPurpose(_x38, _x39, _x40, _x41) {
        return _ref22.apply(this, arguments);
    };
}();

var updateChannelHeader = exports.updateChannelHeader = function () {
    var _ref24 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(channelId, header, success, error) {
        var _ref25, data, err;

        return _regenerator2.default.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        _context14.next = 2;
                        return ChannelActions.patchChannel(channelId, { header: header })(dispatch, getState);

                    case 2:
                        _ref25 = _context14.sent;
                        data = _ref25.data;
                        err = _ref25.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, this);
    }));

    return function updateChannelHeader(_x42, _x43, _x44, _x45) {
        return _ref24.apply(this, arguments);
    };
}();

var getChannelMembersForUserIds = exports.getChannelMembersForUserIds = function () {
    var _ref26 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15(channelId, userIds, success, error) {
        var _ref27, data, err;

        return _regenerator2.default.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        _context15.next = 2;
                        return ChannelActions.getChannelMembersByIds(channelId, userIds)(dispatch, getState);

                    case 2:
                        _ref27 = _context15.sent;
                        data = _ref27.data;
                        err = _ref27.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, this);
    }));

    return function getChannelMembersForUserIds(_x46, _x47, _x48, _x49) {
        return _ref26.apply(this, arguments);
    };
}();

var leaveChannel = exports.leaveChannel = function () {
    var _ref28 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16(channelId, success) {
        var townsquare;
        return _regenerator2.default.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        townsquare = _channel_store2.default.getByName('town-square');

                        _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + townsquare.name);

                        _context16.next = 4;
                        return ChannelActions.leaveChannel(channelId)(dispatch, getState);

                    case 4:
                        if (ChannelUtils.isFavoriteChannelId(channelId)) {
                            unmarkFavorite(channelId);
                        }
                        if (success) {
                            success();
                        }

                    case 6:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, this);
    }));

    return function leaveChannel(_x50, _x51) {
        return _ref28.apply(this, arguments);
    };
}();

var deleteChannel = exports.deleteChannel = function () {
    var _ref29 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17(channelId, success, error) {
        var _ref30, data, err;

        return _regenerator2.default.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        _context17.next = 2;
                        return ChannelActions.deleteChannel(channelId)(dispatch, getState);

                    case 2:
                        _ref30 = _context17.sent;
                        data = _ref30.data;
                        err = _ref30.error;


                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, this);
    }));

    return function deleteChannel(_x52, _x53, _x54) {
        return _ref29.apply(this, arguments);
    };
}();

exports.goToChannelById = goToChannelById;
exports.goToChannel = goToChannel;
exports.executeCommand = executeCommand;
exports.setChannelAsRead = setChannelAsRead;
exports.markFavorite = markFavorite;
exports.unmarkFavorite = unmarkFavorite;
exports.loadDMsAndGMsForUnreads = loadDMsAndGMsForUnreads;

var _channels = __webpack_require__(798);

var ChannelActions = _interopRequireWildcard(_channels);

var _preferences = __webpack_require__(861);

var _client = __webpack_require__(270);

var _common = __webpack_require__(280);

var _channels2 = __webpack_require__(783);

var _browser_history = __webpack_require__(273);

var _storage = __webpack_require__(285);

var _diagnostics_actions = __webpack_require__(804);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _post_actions = __webpack_require__(802);

var PostActions = _interopRequireWildcard(_post_actions);

var _user_actions = __webpack_require__(781);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_utils = __webpack_require__(830);

var ChannelUtils = _interopRequireWildcard(_channel_utils);

var _constants = __webpack_require__(29);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _url = __webpack_require__(793);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

function goToChannelById(channelId) {
    var channel = (0, _channels2.getChannel)(getState(), channelId);
    _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name);
}

function goToChannel(channel) {
    if (channel.fake) {
        var user = _user_store2.default.getProfileByUsername(channel.display_name);
        if (!user) {
            return;
        }
        openDirectChannelToUser(user.id, function () {
            _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name);
        }, null);
    } else {
        _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name);
    }
}

function executeCommand(message, args, success, error) {
    var msg = message;

    var cmdLength = msg.indexOf(' ');
    if (cmdLength < 0) {
        cmdLength = msg.length;
    }
    var cmd = msg.substring(0, cmdLength).toLowerCase();
    msg = cmd + msg.substring(cmdLength, msg.length);

    switch (cmd) {
        case '/search':
            PostActions.searchForTerm(msg.substring(cmdLength + 1, msg.length));
            return;
        case '/shortcuts':
            if (UserAgent.isMobile()) {
                var err = { message: Utils.localizeMessage('create_post.shortcutsNotSupported', 'Keyboard shortcuts are not supported on your device') };
                error(err);
                return;
            }

            GlobalActions.toggleShortcutsModal();
            return;
        case '/leave':
            {
                // /leave command not supported in reply threads.
                if (args.channel_id && (args.root_id || args.parent_id)) {
                    GlobalActions.sendEphemeralPost('/leave is not supported in reply threads. Use it in the center channel instead.', args.channel_id, args.parent_id);
                    return;
                }
                var channel = _channel_store2.default.getCurrent();
                if (channel.type === _constants.Constants.PRIVATE_CHANNEL) {
                    GlobalActions.showLeavePrivateChannelModal(channel);
                    return;
                } else if (channel.type === _constants.Constants.DM_CHANNEL || channel.type === _constants.Constants.GM_CHANNEL) {
                    var name = void 0;
                    var category = void 0;
                    if (channel.type === _constants.Constants.DM_CHANNEL) {
                        name = Utils.getUserIdFromChannelName(channel);
                        category = _constants.Constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW;
                    } else {
                        name = channel.id;
                        category = _constants.Constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW;
                    }
                    var currentUserId = _user_store2.default.getCurrentId();
                    (0, _preferences.savePreferences)(currentUserId, [{ category: category, name: name, user_id: currentUserId, value: 'false' }])(dispatch, getState);
                    if (ChannelUtils.isFavoriteChannel(channel)) {
                        unmarkFavorite(channel.id);
                    }
                    _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + _constants.Constants.DEFAULT_CHANNEL);
                    return;
                }
                break;
            }
        case '/settings':
            GlobalActions.showAccountSettingsModal();
            return;
        case '/collapse':
        case '/expand':
            (0, _storage.actionOnGlobalItemsWithPrefix)(_constants.StoragePrefixes.EMBED_VISIBLE, function () {
                return null;
            })(dispatch, getState);
    }

    _client.Client4.executeCommand(msg, args).then(function (data) {
        if (success) {
            success(data);
        }

        var hasGotoLocation = data.goto_location && (0, _url.isUrlSafe)(data.goto_location);

        if (msg.trim() === '/logout') {
            GlobalActions.clientLogout(hasGotoLocation ? data.goto_location : '/');
            return;
        }

        if (hasGotoLocation) {
            if (data.goto_location.startsWith('/')) {
                _browser_history.browserHistory.push(data.goto_location);
            } else if (data.goto_location.startsWith((0, _url.getSiteURL)())) {
                _browser_history.browserHistory.push(data.goto_location.substr((0, _url.getSiteURL)().length));
            } else {
                window.open(data.goto_location);
            }
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function setChannelAsRead(channelIdParam) {
    var channelId = channelIdParam || _channel_store2.default.getCurrentId();
    ChannelActions.viewChannel(channelId)(dispatch, getState);
    _channel_store2.default.resetCounts([channelId]);
    _channel_store2.default.emitChange();
    if (channelId === _channel_store2.default.getCurrentId()) {
        _channel_store2.default.emitLastViewed(Number.MAX_VALUE, false);
    }
}

function markFavorite(channelId) {
    (0, _diagnostics_actions.trackEvent)('api', 'api_channels_favorited');
    var currentUserId = _user_store2.default.getCurrentId();
    (0, _preferences.savePreferences)(currentUserId, [{ user_id: currentUserId, category: _constants.Preferences.CATEGORY_FAVORITE_CHANNEL, name: channelId, value: 'true' }])(dispatch, getState);
}

function unmarkFavorite(channelId) {
    (0, _diagnostics_actions.trackEvent)('api', 'api_channels_unfavorited');
    var currentUserId = _user_store2.default.getCurrentId();

    var pref = {
        user_id: currentUserId,
        category: _constants.Preferences.CATEGORY_FAVORITE_CHANNEL,
        name: channelId
    };

    (0, _preferences.deletePreferences)(currentUserId, [pref])(dispatch, getState);
}

function loadDMsAndGMsForUnreads() {
    var unreads = _channel_store2.default.getUnreadCounts();
    for (var id in unreads) {
        if (!unreads.hasOwnProperty(id)) {
            continue;
        }

        if (unreads[id].msgs > 0 || unreads[id].mentions > 0) {
            var channel = _channel_store2.default.get(id);
            if (channel && channel.type === _constants.Constants.DM_CHANNEL) {
                (0, _user_actions.loadNewDMIfNeeded)(channel.id);
            } else if (channel && channel.type === _constants.Constants.GM_CHANNEL) {
                (0, _user_actions.loadNewGMIfNeeded)(channel.id);
            }
        }
    }
}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

exports.formatText = formatText;
exports.doFormatText = doFormatText;
exports.sanitizeHtml = sanitizeHtml;
exports.autolinkAtMentions = autolinkAtMentions;
exports.escapeRegex = escapeRegex;
exports.escapeHtml = escapeHtml;
exports.highlightSearchTerms = highlightSearchTerms;
exports.replaceTokens = replaceTokens;

var _autolinker = __webpack_require__(1767);

var _autolinker2 = _interopRequireDefault(_autolinker);

var _twemoji = __webpack_require__(1768);

var _twemoji2 = _interopRequireDefault(_twemoji);

var _xregexp = __webpack_require__(1031);

var _xregexp2 = _interopRequireDefault(_xregexp);

var _emoji_store = __webpack_require__(829);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _emoticons = __webpack_require__(1032);

var Emoticons = _interopRequireWildcard(_emoticons);

var _markdown = __webpack_require__(1159);

var Markdown = _interopRequireWildcard(_markdown);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var punctuation = _xregexp2.default.cache('[^\\pL\\d]');

// pattern to detect the existence of a Chinese, Japanese, or Korean character in a string
// http://stackoverflow.com/questions/15033196/using-javascript-to-check-whether-a-string-contains-japanese-characters-includi
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var cjkPattern = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf\uac00-\ud7a3]/;

// Performs formatting of user posts including highlighting mentions and search terms and converting urls, hashtags,
// @mentions and ~channels to links by taking a user's message and returning a string of formatted html. Also takes
// a number of options as part of the second parameter:
// - searchTerm - If specified, this word is highlighted in the resulting html. Defaults to nothing.
// - mentionHighlight - Specifies whether or not to highlight mentions of the current user. Defaults to true.
// - mentionKeys - A list of mention keys for the current user to highlight.
// - singleline - Specifies whether or not to remove newlines. Defaults to false.
// - emoticons - Enables emoticon parsing with a data-emoticon attribute. Defaults to true.
// - markdown - Enables markdown parsing. Defaults to true.
// - siteURL - The origin of this Mattermost instance. If provided, links to channels and posts will be replaced with internal
//     links that can be handled by a special click handler.
// - atMentions - Whether or not to render at mentions into spans with a data-mention attribute. Defaults to false.
// - channelNamesMap - An object mapping channel display names to channels. If provided, ~channel mentions will be replaced with
//      links to the relevant channel.
// - team - The current team.
// - proxyImages - If specified, images are proxied. Defaults to false.
function formatText(text, inputOptions) {
    if (!text || typeof text !== 'string') {
        return '';
    }

    var output = text;

    var options = (0, _assign2.default)({}, inputOptions);
    options.searchPatterns = parseSearchTerms(options.searchTerm).map(convertSearchTermToRegex);

    if (!('markdown' in options) || options.markdown) {
        // the markdown renderer will call doFormatText as necessary
        output = Markdown.format(output, options);
    } else {
        output = sanitizeHtml(output);
        output = doFormatText(output, options);
    }

    // replace newlines with spaces if necessary
    if (options.singleline) {
        output = replaceNewlines(output);
    }

    return output;
}

// Performs most of the actual formatting work for formatText. Not intended to be called normally.
function doFormatText(text, options) {
    var output = text;

    var tokens = new _map2.default();

    // replace important words and phrases with tokens
    if (options.atMentions) {
        output = autolinkAtMentions(output, tokens);
    }

    if (options.channelNamesMap) {
        output = autolinkChannelMentions(output, tokens, options.channelNamesMap, options.team);
    }

    output = autolinkEmails(output, tokens);
    output = autolinkHashtags(output, tokens);

    if (!('emoticons' in options) || options.emoticon) {
        output = Emoticons.handleEmoticons(output, tokens);
    }

    if (options.searchPatterns) {
        output = highlightSearchTerms(output, tokens, options.searchPatterns);
    }

    if (!('mentionHighlight' in options) || options.mentionHighlight) {
        output = highlightCurrentMentions(output, tokens, options.mentionKeys);
    }

    if (!('emoticons' in options) || options.emoticon) {
        output = _twemoji2.default.parse(output, {
            className: 'emoticon',
            callback: function callback(icon) {
                if (!_emoji_store2.default.hasUnicode(icon)) {
                    // just leave the unicode characters and hope the browser can handle it
                    return null;
                }

                return _emoji_store2.default.getEmojiImageUrl(_emoji_store2.default.getUnicode(icon));
            }
        });
    }

    // reinsert tokens with formatted versions of the important words and phrases
    output = replaceTokens(output, tokens);

    return output;
}

function sanitizeHtml(text) {
    var output = text;

    // normal string.replace only does a single occurrance so use a regex instead
    output = output.replace(/&/g, '&amp;');
    output = output.replace(/</g, '&lt;');
    output = output.replace(/>/g, '&gt;');
    output = output.replace(/'/g, '&apos;');
    output = output.replace(/"/g, '&quot;');

    return output;
}

// Convert emails into tokens
function autolinkEmails(text, tokens) {
    function replaceEmailWithToken(match) {
        var linkText = match.getMatchedText();
        var url = linkText;

        if (match.getType() === 'email') {
            url = 'mailto:' + url;
        }

        var index = tokens.size;
        var alias = '$MM_EMAIL' + index;

        tokens.set(alias, {
            value: '<a class="theme" href="' + url + '">' + linkText + '</a>',
            originalText: linkText
        });

        return alias;
    }

    // we can't just use a static autolinker because we need to set replaceFn
    var autolinker = new _autolinker2.default({
        urls: false,
        email: true,
        phone: false,
        mention: false,
        hashtag: false,
        replaceFn: replaceEmailWithToken
    });

    return autolinker.link(text);
}

function autolinkAtMentions(text, tokens) {
    function replaceAtMentionWithToken(fullMatch, username) {
        var index = tokens.size;
        var alias = '$MM_ATMENTION' + index;

        tokens.set(alias, {
            value: '<span data-mention="' + username + '">@' + username + '</span>',
            originalText: fullMatch
        });

        return alias;
    }

    var output = text;
    output = output.replace(/\B@([a-z0-9.\-_]*)/gi, replaceAtMentionWithToken);

    return output;
}

function autolinkChannelMentions(text, tokens, channelNamesMap, team) {
    function channelMentionExists(c) {
        return Boolean(channelNamesMap[c]);
    }
    function addToken(channelName, mention, displayName) {
        var index = tokens.size;
        var alias = '$MM_CHANNELMENTION' + index;
        var href = '#';
        if (team) {
            href = '/' + team.name + '/channels/' + channelName;
        }

        tokens.set(alias, {
            value: '<a class="mention-link" href="' + href + '" data-channel-mention="' + channelName + '">~' + displayName + '</a>',
            originalText: mention
        });
        return alias;
    }

    function replaceChannelMentionWithToken(fullMatch, spacer, mention, channelName) {
        var channelNameLower = channelName.toLowerCase();

        if (channelMentionExists(channelNameLower)) {
            // Exact match
            var alias = addToken(channelNameLower, mention, escapeHtml(channelNamesMap[channelNameLower].display_name));
            return spacer + alias;
        }

        // Not an exact match, attempt to truncate any punctuation to see if we can find a channel
        var originalChannelName = channelNameLower;

        for (var c = channelNameLower.length; c > 0; c--) {
            if (punctuation.test(channelNameLower[c - 1])) {
                channelNameLower = channelNameLower.substring(0, c - 1);

                if (channelMentionExists(channelNameLower)) {
                    var suffix = originalChannelName.substr(c - 1);
                    var _alias = addToken(channelNameLower, '~' + channelNameLower, escapeHtml(channelNamesMap[channelNameLower].display_name));
                    return spacer + _alias + suffix;
                }
            } else {
                // If the last character is not punctuation, no point in going any further
                break;
            }
        }

        return fullMatch;
    }

    var output = text;
    output = output.replace(/(^|\s)(~([a-z0-9.\-_]*))/gi, replaceChannelMentionWithToken);

    return output;
}

function escapeRegex(text) {
    return text.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var htmlEntities = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
};

function escapeHtml(text) {
    return text.replace(/[&<>"']/g, function (match) {
        return htmlEntities[match];
    });
}

function highlightCurrentMentions(text, tokens) {
    var mentionKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var output = text;

    // look for any existing tokens which are self mentions and should be highlighted
    var newTokens = new _map2.default();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                alias = _step$value[0],
                token = _step$value[1];

            if (mentionKeys.findIndex(function (key) {
                return key.key === token.originalText;
            }) !== -1) {
                var index = tokens.size + newTokens.size;
                var newAlias = '$MM_SELFMENTION' + index;

                newTokens.set(newAlias, {
                    value: '<span class=\'mention--highlight\'>' + alias + '</span>',
                    originalText: token.originalText
                });
                output = output.replace(alias, newAlias);
            }
        };

        for (var _iterator = (0, _getIterator3.default)(tokens), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }

        // the new tokens are stashed in a separate map since we can't add objects to a map during iteration
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = (0, _getIterator3.default)(newTokens), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var newToken = _step2.value;

            tokens.set(newToken[0], newToken[1]);
        }

        // look for self mentions in the text
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    function replaceCurrentMentionWithToken(fullMatch, prefix, mention) {
        var index = tokens.size;
        var alias = '$MM_SELFMENTION' + index;

        tokens.set(alias, {
            value: '<span class=\'mention--highlight\'>' + mention + '</span>',
            originalText: mention
        });

        return prefix + alias;
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = (0, _getIterator3.default)(mentionKeys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var mention = _step3.value;

            if (!mention || !mention.key) {
                continue;
            }

            var flags = 'g';
            if (!mention.caseSensitive) {
                flags += 'i';
            }

            output = output.replace(new RegExp('(^|\\W)(' + escapeRegex(mention.key) + ')\\b', flags), replaceCurrentMentionWithToken);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return output;
}

function autolinkHashtags(text, tokens) {
    var output = text;

    var newTokens = new _map2.default();
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = (0, _getIterator3.default)(tokens), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
                _alias2 = _step4$value[0],
                _token = _step4$value[1];

            if (_token.originalText.lastIndexOf('#', 0) === 0) {
                var index = tokens.size + newTokens.size;
                var newAlias = '$MM_HASHTAG' + index;

                newTokens.set(newAlias, {
                    value: '<a class=\'mention-link\' href=\'#\' data-hashtag=\'' + _token.originalText + '\'>' + _token.originalText + '</a>',
                    originalText: _token.originalText,
                    hashtag: _token.originalText.substring(1)
                });

                output = output.replace(_alias2, newAlias);
            }
        }

        // the new tokens are stashed in a separate map since we can't add objects to a map during iteration
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
        for (var _iterator5 = (0, _getIterator3.default)(newTokens), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var newToken = _step5.value;

            tokens.set(newToken[0], newToken[1]);
        }

        // look for hashtags in the text
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
            }
        } finally {
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }

    function replaceHashtagWithToken(fullMatch, prefix, originalText) {
        var index = tokens.size;
        var alias = '$MM_HASHTAG' + index;

        if (text.length < _constants2.default.MIN_HASHTAG_LINK_LENGTH + 1) {
            // too short to be a hashtag
            return fullMatch;
        }

        tokens.set(alias, {
            value: '<a class=\'mention-link\' href=\'#\' data-hashtag=\'' + originalText + '\'>' + originalText + '</a>',
            originalText: originalText,
            hashtag: originalText.substring(1)
        });

        return prefix + alias;
    }

    return output.replace(_xregexp2.default.cache('(^|\\W)(#\\pL[\\pL\\d\\-_.]*[\\pL\\d])', 'g'), replaceHashtagWithToken);
}

var puncStart = _xregexp2.default.cache('^[^\\pL\\d\\s#]+');
var puncEnd = _xregexp2.default.cache('[^\\pL\\d\\s]+$');

function parseSearchTerms(searchTerm) {
    var terms = [];

    var termString = searchTerm;

    while (termString) {
        var captured = void 0;

        // check for a quoted string
        captured = /^"(.*?)"/.exec(termString);
        if (captured) {
            termString = termString.substring(captured[0].length);
            terms.push(captured[1]);
            continue;
        }

        // check for a search flag (and don't add it to terms)
        captured = /^(?:in|from|channel): ?\S+/.exec(termString);
        if (captured) {
            termString = termString.substring(captured[0].length);
            continue;
        }

        // capture at mentions differently from the server so we can highlight them with the preceeding at sign
        captured = /^@[a-z0-9.-_]+\b/.exec(termString);
        if (captured) {
            termString = termString.substring(captured[0].length);

            terms.push(captured[0]);
            continue;
        }

        // capture any plain text up until the next quote or search flag
        captured = /^.+?(?=\bin:|\bfrom:|\bchannel:|"|$)/.exec(termString);
        if (captured) {
            var _terms;

            termString = termString.substring(captured[0].length);

            // break the text up into words based on how the server splits them in SqlPostStore.SearchPosts and then discard empty terms
            (_terms = terms).push.apply(_terms, (0, _toConsumableArray3.default)(captured[0].split(/[ <>+()~@]/).filter(function (term) {
                return Boolean(term);
            })));
            continue;
        }

        // we should never reach this point since at least one of the regexes should match something in the remaining text
        throw new Error('Infinite loop in search term parsing: "' + termString + '"');
    }

    // remove punctuation from each term
    terms = terms.map(function (term) {
        term.replace(puncStart, '');
        if (term.charAt(term.length - 1) !== '*') {
            term.replace(puncEnd, '');
        }
        return term;
    });

    return terms;
}

function convertSearchTermToRegex(term) {
    var pattern = void 0;

    if (cjkPattern.test(term)) {
        // term contains Chinese, Japanese, or Korean characters so don't mark word boundaries
        pattern = '()(' + escapeRegex(term.replace(/\*/g, '')) + ')';
    } else if (term.endsWith('*')) {
        pattern = '\\b()(' + escapeRegex(term.substring(0, term.length - 1)) + ')';
    } else if (term.startsWith('@') || term.startsWith('#')) {
        // needs special handling of the first boundary because a word boundary doesn't work before a symbol
        pattern = '(\\W|^)(' + escapeRegex(term) + ')\\b';
    } else {
        pattern = '\\b()(' + escapeRegex(term) + ')\\b';
    }

    return {
        pattern: new RegExp(pattern, 'gi'),
        term: term
    };
}

function highlightSearchTerms(text, tokens, searchPatterns) {
    if (!searchPatterns || searchPatterns.length === 0) {
        return text;
    }

    var output = text;

    function replaceSearchTermWithToken(match, prefix, word) {
        var index = tokens.size;
        var alias = '$MM_SEARCHTERM' + index;

        tokens.set(alias, {
            value: '<span class=\'search-highlight\'>' + word + '</span>',
            originalText: word
        });

        return prefix + alias;
    }

    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
        for (var _iterator6 = (0, _getIterator3.default)(searchPatterns), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var pattern = _step6.value;

            // highlight existing tokens matching search terms
            var newTokens = new _map2.default();
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = (0, _getIterator3.default)(tokens), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _step7$value = (0, _slicedToArray3.default)(_step7.value, 2),
                        _alias3 = _step7$value[0],
                        _token2 = _step7$value[1];

                    if (pattern.pattern.test(_token2.originalText)) {
                        // If it's a Hashtag, skip it unless the search term is an exact match.
                        var originalText = _token2.originalText;
                        if (originalText.startsWith('#')) {
                            originalText = originalText.substr(1);
                        }
                        var term = pattern.term;
                        if (term.startsWith('#')) {
                            term = term.substr(1);
                        }

                        if (_alias3.startsWith('$MM_HASHTAG') && originalText !== term) {
                            continue;
                        }

                        var index = tokens.size + newTokens.size;
                        var newAlias = '$MM_SEARCHTERM' + index;

                        newTokens.set(newAlias, {
                            value: '<span class=\'search-highlight\'>' + _alias3 + '</span>',
                            originalText: _token2.originalText
                        });

                        output = output.replace(_alias3, newAlias);
                    }

                    // The pattern regexes are global, so calling pattern.pattern.test() above alters their
                    // state. Reset lastIndex to 0 between calls to test() to ensure it returns the
                    // same result every time it is called with the same value of token.originalText.
                    pattern.pattern.lastIndex = 0;
                }

                // the new tokens are stashed in a separate map since we can't add objects to a map during iteration
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = (0, _getIterator3.default)(newTokens), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var newToken = _step8.value;

                    tokens.set(newToken[0], newToken[1]);
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            output = output.replace(pattern.pattern, replaceSearchTermWithToken);
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
            }
        } finally {
            if (_didIteratorError6) {
                throw _iteratorError6;
            }
        }
    }

    return output;
}

function replaceTokens(text, tokens) {
    var output = text;

    // iterate backwards through the map so that we do replacement in the opposite order that we added tokens
    var aliases = [].concat((0, _toConsumableArray3.default)(tokens.keys()));
    for (var i = aliases.length - 1; i >= 0; i--) {
        var _alias4 = aliases[i];
        var _token3 = tokens.get(_alias4);
        output = output.replace(_alias4, _token3.value);
    }

    return output;
}

function replaceNewlines(text) {
    return text.replace(/\n/g, ' ');
}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return window.document;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 813 */,
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _action_types = __webpack_require__(3);

var _preferences = __webpack_require__(784);

var Selectors = _interopRequireWildcard(_preferences);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ActionTypes = _constants2.default.ActionTypes;

var CHANGE_EVENT = 'change';

var PreferenceStore = function (_EventEmitter) {
    (0, _inherits3.default)(PreferenceStore, _EventEmitter);

    function PreferenceStore() {
        (0, _classCallCheck3.default)(this, PreferenceStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PreferenceStore.__proto__ || (0, _getPrototypeOf2.default)(PreferenceStore)).call(this));

        _this.handleEventPayload = _this.handleEventPayload.bind(_this);
        _this.dispatchToken = _app_dispatcher2.default.register(_this.handleEventPayload);

        _this.preferences = new _map2.default();
        _this.entities = Selectors.getMyPreferences(_redux_store2.default.getState());
        (0, _keys2.default)(_this.entities).forEach(function (key) {
            _this.preferences.set(key, _this.entities[key].value);
        });

        _redux_store2.default.subscribe(function () {
            var newEntities = Selectors.getMyPreferences(_redux_store2.default.getState());
            var entities = _this.entities;
            _this.entities = newEntities;

            if (entities !== newEntities) {
                _this.preferences = new _map2.default();
                (0, _keys2.default)(newEntities).forEach(function (key) {
                    _this.preferences.set(key, newEntities[key].value);
                });
                _this.emitChange();
            }
        });

        _this.setMaxListeners(600);
        return _this;
    }

    (0, _createClass3.default)(PreferenceStore, [{
        key: 'getKey',
        value: function getKey(category, name) {
            return category + '--' + name;
        }
    }, {
        key: 'get',
        value: function get(category, name) {
            var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var key = this.getKey(category, name);

            if (!this.preferences.has(key)) {
                return defaultValue;
            }

            return this.preferences.get(key);
        }
    }, {
        key: 'getBool',
        value: function getBool(category, name) {
            var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var key = this.getKey(category, name);

            if (!this.preferences.has(key)) {
                return defaultValue;
            }

            return this.preferences.get(key) !== 'false';
        }
    }, {
        key: 'getInt',
        value: function getInt(category, name) {
            var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            var key = this.getKey(category, name);

            if (!this.preferences.has(key)) {
                return defaultValue;
            }

            return parseInt(this.preferences.get(key), 10);
        }
    }, {
        key: 'getObject',
        value: function getObject(category, name) {
            var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var key = this.getKey(category, name);

            if (!this.preferences.has(key)) {
                return defaultValue;
            }

            return JSON.parse(this.preferences.get(key));
        }
    }, {
        key: 'getCategory',
        value: function getCategory(category) {
            var prefix = category + '--';

            var preferences = new _map2.default();

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.preferences), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        key = _step$value[0],
                        value = _step$value[1];

                    if (key.startsWith(prefix)) {
                        preferences.set(key.substring(prefix.length), value);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return preferences;
        }
    }, {
        key: 'setPreference',
        value: function setPreference(category, name, value) {
            _redux_store2.default.dispatch({
                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                data: [{ category: category, name: name, value: value }]
            });
        }
    }, {
        key: 'setPreferencesFromServer',
        value: function setPreferencesFromServer(newPreferences) {
            _redux_store2.default.dispatch({
                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                data: newPreferences
            });
        }
    }, {
        key: 'deletePreference',
        value: function deletePreference(preference) {
            _redux_store2.default.dispatch({
                type: _action_types.PreferenceTypes.DELETED_PREFERENCES,
                data: [preference]
            });
        }
    }, {
        key: 'emitChange',
        value: function emitChange(category) {
            this.emit(CHANGE_EVENT, category);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'getTheme',
        value: function getTheme() {
            return Selectors.getTheme(_redux_store2.default.getState());
        }
    }, {
        key: 'handleEventPayload',
        value: function handleEventPayload(payload) {
            var action = payload.action;

            switch (action.type) {
                case ActionTypes.RECEIVED_PREFERENCE:
                    {
                        var preference = action.preference;
                        this.setPreference(preference.category, preference.name, preference.value);
                        this.emitChange(preference.category);
                        break;
                    }
                case ActionTypes.RECEIVED_PREFERENCES:
                    this.setPreferencesFromServer(action.preferences);
                    this.emitChange();
                    break;
                case ActionTypes.DELETED_PREFERENCES:
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)(action.preferences), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var _preference = _step2.value;

                            this.deletePreference(_preference);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    this.emitChange();
                    break;
                case ActionTypes.CLICK_CHANNEL:
                    this.setPreference(action.team_id, 'channel', action.id);
                    break;
            }
        }
    }]);
    return PreferenceStore;
}(_events2.default);

global.PreferenceStore = new PreferenceStore();
exports.default = global.PreferenceStore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1585) ], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getProfilesAndStatusesForMembers = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userIds, dispatch, getState) {
        var _getState$entities$us, currentUserId, profiles, statuses, profilesToLoad, statusesToLoad, requests;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _getState$entities$us = getState().entities.users, currentUserId = _getState$entities$us.currentUserId, profiles = _getState$entities$us.profiles, statuses = _getState$entities$us.statuses;
                        profilesToLoad = [];
                        statusesToLoad = [];


                        userIds.forEach(function (userId) {
                            if (!profiles[userId] && !profilesToLoad.includes(userId) && userId !== currentUserId) {
                                profilesToLoad.push(userId);
                            }

                            if (!statuses[userId] && !statusesToLoad.includes(userId) && userId !== currentUserId) {
                                statusesToLoad.push(userId);
                            }
                        });

                        requests = [];


                        if (profilesToLoad.length) {
                            requests.push((0, _users.getProfilesByIds)(profilesToLoad)(dispatch, getState));
                        }

                        if (statusesToLoad.length) {
                            requests.push((0, _users.getStatusesByIds)(statusesToLoad)(dispatch, getState));
                        }

                        _context.next = 9;
                        return Promise.all(requests);

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getProfilesAndStatusesForMembers(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

exports.selectTeam = selectTeam;
exports.getMyTeams = getMyTeams;
exports.getMyTeamUnreads = getMyTeamUnreads;
exports.getTeam = getTeam;
exports.getTeamByName = getTeamByName;
exports.getTeams = getTeams;
exports.createTeam = createTeam;
exports.deleteTeam = deleteTeam;
exports.updateTeam = updateTeam;
exports.getMyTeamMembers = getMyTeamMembers;
exports.getTeamMembers = getTeamMembers;
exports.getTeamMember = getTeamMember;
exports.getTeamMembersByIds = getTeamMembersByIds;
exports.getTeamsForUser = getTeamsForUser;
exports.getTeamMembersForUser = getTeamMembersForUser;
exports.getTeamStats = getTeamStats;
exports.addUserToTeam = addUserToTeam;
exports.addUsersToTeam = addUsersToTeam;
exports.removeUserFromTeam = removeUserFromTeam;
exports.updateTeamMemberRoles = updateTeamMemberRoles;
exports.sendEmailInvitesToTeam = sendEmailInvitesToTeam;
exports.checkIfTeamExists = checkIfTeamExists;
exports.joinTeam = joinTeam;
exports.setTeamIcon = setTeamIcon;

var _reduxBatchedActions = __webpack_require__(278);

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _action_types = __webpack_require__(3);

var _event_emitter = __webpack_require__(182);

var _event_emitter2 = _interopRequireDefault(_event_emitter);

var _errors = __webpack_require__(828);

var _helpers = __webpack_require__(821);

var _users = __webpack_require__(786);

var _roles = __webpack_require__(860);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function selectTeam(team) {
    var _this = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({
                                type: _action_types.TeamTypes.SELECT_TEAM,
                                data: team.id
                            }, getState);

                            return _context2.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function (_x4, _x5) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function getMyTeams() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyTeams, _action_types.TeamTypes.MY_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.MY_TEAMS_SUCCESS], _action_types.TeamTypes.MY_TEAMS_FAILURE);
}

function getMyTeamUnreads() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyTeamUnreads, _action_types.TeamTypes.MY_TEAM_UNREADS_REQUEST, [_action_types.TeamTypes.RECEIVED_MY_TEAM_UNREADS, _action_types.TeamTypes.MY_TEAM_UNREADS_SUCCESS], _action_types.TeamTypes.MY_TEAM_UNREADS_FAILURE);
}

function getTeam(teamId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeam, _action_types.TeamTypes.GET_TEAM_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM, _action_types.TeamTypes.GET_TEAM_SUCCESS], _action_types.TeamTypes.GET_TEAM_FAILURE, teamId);
}

function getTeamByName(teamName) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamByName, _action_types.TeamTypes.GET_TEAM_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM, _action_types.TeamTypes.GET_TEAM_SUCCESS], _action_types.TeamTypes.GET_TEAM_FAILURE, teamName);
}

function getTeams() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.TEAMS_CHUNK_SIZE;

    return (0, _helpers.bindClientFunc)(_client.Client4.getTeams, _action_types.TeamTypes.GET_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.GET_TEAMS_SUCCESS], _action_types.TeamTypes.GET_TEAMS_FAILURE, page, perPage);
}

function createTeam(team) {
    var _this2 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var created, member;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.CREATE_TEAM_REQUEST }, getState);

                            created = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.createTeam(team);

                        case 5:
                            created = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.CREATE_TEAM_FAILURE, error: _context3.t0 }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', { error: _context3.t0 });

                        case 13:
                            member = {
                                team_id: created.id,
                                user_id: getState().entities.users.currentUserId,
                                roles: _constants.General.TEAM_ADMIN_ROLE + ' ' + _constants.General.TEAM_USER_ROLE,
                                delete_at: 0,
                                msg_count: 0,
                                mention_count: 0
                            };


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.CREATED_TEAM,
                                data: created
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.SELECT_TEAM,
                                data: created.id
                            }, {
                                type: _action_types.TeamTypes.CREATE_TEAM_SUCCESS
                            }]), getState);
                            dispatch((0, _roles.loadRolesIfNeeded)(member.roles.split(' ')));

                            return _context3.abrupt('return', { data: created });

                        case 17:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2, [[2, 8]]);
        }));

        return function (_x8, _x9) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function deleteTeam(teamId) {
    var _this3 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var entities, currentTeamId, actions;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.DELETE_TEAM_REQUEST }, getState);

                            _context4.prev = 1;
                            _context4.next = 4;
                            return _client.Client4.deleteTeam(teamId);

                        case 4:
                            _context4.next = 11;
                            break;

                        case 6:
                            _context4.prev = 6;
                            _context4.t0 = _context4['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.DELETE_TEAM_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', { error: _context4.t0 });

                        case 11:
                            entities = getState().entities;
                            currentTeamId = entities.teams.currentTeamId;
                            actions = [];

                            if (teamId === currentTeamId) {
                                _event_emitter2.default.emit('leave_team');
                                actions.push({ type: _action_types.ChannelTypes.SELECT_CHANNEL, data: '' });
                            }

                            actions.push({
                                type: _action_types.TeamTypes.RECEIVED_TEAM_DELETED,
                                data: { id: teamId }
                            }, {
                                type: _action_types.TeamTypes.DELETE_TEAM_SUCCESS
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context4.abrupt('return', { data: true });

                        case 18:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this3, [[1, 6]]);
        }));

        return function (_x10, _x11) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function updateTeam(team) {
    return (0, _helpers.bindClientFunc)(_client.Client4.updateTeam, _action_types.TeamTypes.UPDATE_TEAM_REQUEST, [_action_types.TeamTypes.UPDATED_TEAM, _action_types.TeamTypes.UPDATE_TEAM_SUCCESS], _action_types.TeamTypes.UPDATE_TEAM_FAILURE, team);
}

function getMyTeamMembers() {
    var _this4 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var getMyTeamMembersFunc, teamMembers, roles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, teamMember, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, role;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            getMyTeamMembersFunc = (0, _helpers.bindClientFunc)(_client.Client4.getMyTeamMembers, _action_types.TeamTypes.MY_TEAM_MEMBERS_REQUEST, [_action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBERS, _action_types.TeamTypes.MY_TEAM_MEMBERS_SUCCESS], _action_types.TeamTypes.MY_TEAM_MEMBERS_FAILURE);
                            _context5.next = 3;
                            return getMyTeamMembersFunc(dispatch, getState);

                        case 3:
                            teamMembers = _context5.sent;

                            if (!teamMembers.error) {
                                _context5.next = 6;
                                break;
                            }

                            return _context5.abrupt('return', teamMembers);

                        case 6:
                            roles = new Set();
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context5.prev = 10;
                            _iterator = teamMembers.data[Symbol.iterator]();

                        case 12:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context5.next = 36;
                                break;
                            }

                            teamMember = _step.value;
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context5.prev = 17;

                            for (_iterator2 = teamMember.roles.split(' ')[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                role = _step2.value;

                                roles.add(role);
                            }
                            _context5.next = 25;
                            break;

                        case 21:
                            _context5.prev = 21;
                            _context5.t0 = _context5['catch'](17);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context5.t0;

                        case 25:
                            _context5.prev = 25;
                            _context5.prev = 26;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 28:
                            _context5.prev = 28;

                            if (!_didIteratorError2) {
                                _context5.next = 31;
                                break;
                            }

                            throw _iteratorError2;

                        case 31:
                            return _context5.finish(28);

                        case 32:
                            return _context5.finish(25);

                        case 33:
                            _iteratorNormalCompletion = true;
                            _context5.next = 12;
                            break;

                        case 36:
                            _context5.next = 42;
                            break;

                        case 38:
                            _context5.prev = 38;
                            _context5.t1 = _context5['catch'](10);
                            _didIteratorError = true;
                            _iteratorError = _context5.t1;

                        case 42:
                            _context5.prev = 42;
                            _context5.prev = 43;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 45:
                            _context5.prev = 45;

                            if (!_didIteratorError) {
                                _context5.next = 48;
                                break;
                            }

                            throw _iteratorError;

                        case 48:
                            return _context5.finish(45);

                        case 49:
                            return _context5.finish(42);

                        case 50:
                            if (roles.size > 0) {
                                dispatch((0, _roles.loadRolesIfNeeded)(roles));
                            }
                            return _context5.abrupt('return', teamMembers);

                        case 52:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4, [[10, 38, 42, 50], [17, 21, 25, 33], [26,, 28, 32], [43,, 45, 49]]);
        }));

        return function (_x12, _x13) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function getTeamMembers(teamId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.TEAMS_CHUNK_SIZE;

    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamMembers, _action_types.TeamTypes.GET_TEAM_MEMBERS_REQUEST, [_action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM, _action_types.TeamTypes.GET_TEAM_MEMBERS_SUCCESS], _action_types.TeamTypes.GET_TEAM_MEMBERS_FAILURE, teamId, page, perPage);
}

function getTeamMember(teamId, userId) {
    var _this5 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var member, memberRequest;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.TEAM_MEMBERS_REQUEST }, getState);

                            member = void 0;
                            _context6.prev = 2;
                            memberRequest = _client.Client4.getTeamMember(teamId, userId);


                            getProfilesAndStatusesForMembers([userId], dispatch, getState);

                            _context6.next = 7;
                            return memberRequest;

                        case 7:
                            member = _context6.sent;
                            _context6.next = 15;
                            break;

                        case 10:
                            _context6.prev = 10;
                            _context6.t0 = _context6['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, error: _context6.t0 }, (0, _errors.logError)(_context6.t0)(dispatch)]), getState);
                            return _context6.abrupt('return', { error: _context6.t0 });

                        case 15:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: [member]
                            }, {
                                type: _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS
                            }]), getState);

                            return _context6.abrupt('return', { data: member });

                        case 17:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this5, [[2, 10]]);
        }));

        return function (_x16, _x17) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function getTeamMembersByIds(teamId, userIds) {
    var _this6 = this;

    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var members, membersRequest;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.TEAM_MEMBERS_REQUEST }, getState);

                            members = void 0;
                            _context7.prev = 2;
                            membersRequest = _client.Client4.getTeamMembersByIds(teamId, userIds);


                            getProfilesAndStatusesForMembers(userIds, dispatch, getState);

                            _context7.next = 7;
                            return membersRequest;

                        case 7:
                            members = _context7.sent;
                            _context7.next = 15;
                            break;

                        case 10:
                            _context7.prev = 10;
                            _context7.t0 = _context7['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, error: _context7.t0 }, (0, _errors.logError)(_context7.t0)(dispatch)]), getState);
                            return _context7.abrupt('return', { error: _context7.t0 });

                        case 15:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: members
                            }, {
                                type: _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS
                            }]), getState);

                            return _context7.abrupt('return', { data: members });

                        case 17:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this6, [[2, 10]]);
        }));

        return function (_x18, _x19) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function getTeamsForUser(userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamsForUser, _action_types.TeamTypes.GET_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.GET_TEAMS_SUCCESS], _action_types.TeamTypes.GET_TEAMS_FAILURE, userId);
}

function getTeamMembersForUser(userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamMembersForUser, _action_types.TeamTypes.TEAM_MEMBERS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM_MEMBERS, _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS], _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, userId);
}

function getTeamStats(teamId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamStats, _action_types.TeamTypes.TEAM_STATS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM_STATS, _action_types.TeamTypes.TEAM_STATS_SUCCESS], _action_types.TeamTypes.TEAM_STATS_FAILURE, teamId);
}

function addUserToTeam(teamId, userId) {
    var _this7 = this;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var member;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            member = void 0;
                            _context8.prev = 2;
                            _context8.next = 5;
                            return _client.Client4.addToTeam(teamId, userId);

                        case 5:
                            member = _context8.sent;
                            _context8.next = 13;
                            break;

                        case 8:
                            _context8.prev = 8;
                            _context8.t0 = _context8['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context8.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context8.t0 }, (0, _errors.logError)(_context8.t0)(dispatch)]), getState);
                            return _context8.abrupt('return', { error: _context8.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_TEAM,
                                data: { user_id: userId },
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBER_IN_TEAM,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context8.abrupt('return', { data: member });

                        case 15:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this7, [[2, 8]]);
        }));

        return function (_x20, _x21) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function addUsersToTeam(teamId, userIds) {
    var _this8 = this;

    return function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var members, profiles;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context9.prev = 2;
                            _context9.next = 5;
                            return _client.Client4.addUsersToTeam(teamId, userIds);

                        case 5:
                            members = _context9.sent;
                            _context9.next = 13;
                            break;

                        case 8:
                            _context9.prev = 8;
                            _context9.t0 = _context9['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context9.t0 }, (0, _errors.logError)(_context9.t0)(dispatch)]), getState);
                            return _context9.abrupt('return', { error: _context9.t0 });

                        case 13:
                            profiles = [];

                            members.forEach(function (m) {
                                return profiles.push({ id: m.user_id });
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: members
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context9.abrupt('return', { data: members });

                        case 17:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this8, [[2, 8]]);
        }));

        return function (_x22, _x23) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function removeUserFromTeam(teamId, userId) {
    var _this9 = this;

    return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var member, actions, state, currentUserId, _state$entities$chann, channels, myMembers, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, channelMember, channel;

            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.REMOVE_TEAM_MEMBER_REQUEST }, getState);

                            _context10.prev = 1;
                            _context10.next = 4;
                            return _client.Client4.removeFromTeam(teamId, userId);

                        case 4:
                            _context10.next = 11;
                            break;

                        case 6:
                            _context10.prev = 6;
                            _context10.t0 = _context10['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context10.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.REMOVE_TEAM_MEMBER_FAILURE, error: _context10.t0 }, (0, _errors.logError)(_context10.t0)(dispatch)]), getState);
                            return _context10.abrupt('return', { error: _context10.t0 });

                        case 11:
                            member = {
                                team_id: teamId,
                                user_id: userId
                            };
                            actions = [{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_TEAM,
                                data: { user_id: userId },
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.REMOVE_MEMBER_FROM_TEAM,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.REMOVE_TEAM_MEMBER_SUCCESS
                            }];
                            state = getState();
                            currentUserId = state.entities.users.currentUserId;

                            if (!(currentUserId === userId)) {
                                _context10.next = 36;
                                break;
                            }

                            _state$entities$chann = state.entities.channels, channels = _state$entities$chann.channels, myMembers = _state$entities$chann.myMembers;
                            _iteratorNormalCompletion3 = true;
                            _didIteratorError3 = false;
                            _iteratorError3 = undefined;
                            _context10.prev = 20;


                            for (_iterator3 = Object.values(myMembers)[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                channelMember = _step3.value;
                                channel = channels[channelMember.channel_id];

                                if (channel && channel.team_id === teamId) {
                                    actions.push({
                                        type: _action_types.ChannelTypes.LEAVE_CHANNEL,
                                        data: channel
                                    });
                                }
                            }
                            _context10.next = 28;
                            break;

                        case 24:
                            _context10.prev = 24;
                            _context10.t1 = _context10['catch'](20);
                            _didIteratorError3 = true;
                            _iteratorError3 = _context10.t1;

                        case 28:
                            _context10.prev = 28;
                            _context10.prev = 29;

                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }

                        case 31:
                            _context10.prev = 31;

                            if (!_didIteratorError3) {
                                _context10.next = 34;
                                break;
                            }

                            throw _iteratorError3;

                        case 34:
                            return _context10.finish(31);

                        case 35:
                            return _context10.finish(28);

                        case 36:

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context10.abrupt('return', { data: true });

                        case 38:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this9, [[1, 6], [20, 24, 28, 36], [29,, 31, 35]]);
        }));

        return function (_x24, _x25) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function updateTeamMemberRoles(teamId, userId, roles) {
    var _this10 = this;

    return function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var actions, membersInTeam;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_MEMBER_REQUEST }, getState);

                            _context11.prev = 1;
                            _context11.next = 4;
                            return _client.Client4.updateTeamMemberRoles(teamId, userId, roles);

                        case 4:
                            _context11.next = 11;
                            break;

                        case 6:
                            _context11.prev = 6;
                            _context11.t0 = _context11['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.UPDATE_TEAM_MEMBER_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', { error: _context11.t0 });

                        case 11:
                            actions = [{
                                type: _action_types.TeamTypes.UPDATE_TEAM_MEMBER_SUCCESS
                            }];
                            membersInTeam = getState().entities.teams.membersInTeam[teamId];

                            if (membersInTeam && membersInTeam[userId]) {
                                actions.push({
                                    type: _action_types.TeamTypes.RECEIVED_MEMBER_IN_TEAM,
                                    data: _extends({}, membersInTeam[userId], { roles: roles })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context11.abrupt('return', { data: true });

                        case 16:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this10, [[1, 6]]);
        }));

        return function (_x26, _x27) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function sendEmailInvitesToTeam(teamId, emails) {
    return (0, _helpers.bindClientFunc)(_client.Client4.sendEmailInvitesToTeam, _action_types.TeamTypes.TEAM_EMAIL_INVITE_REQUEST, [_action_types.TeamTypes.TEAM_EMAIL_INVITE_SUCCESS], _action_types.TeamTypes.TEAM_EMAIL_INVITE_FAILURE, teamId, emails);
}

function checkIfTeamExists(teamName) {
    var _this11 = this;

    return function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.GET_TEAM_REQUEST }, getState);

                            data = void 0;
                            _context12.prev = 2;
                            _context12.next = 5;
                            return _client.Client4.checkIfTeamExists(teamName);

                        case 5:
                            data = _context12.sent;
                            _context12.next = 13;
                            break;

                        case 8:
                            _context12.prev = 8;
                            _context12.t0 = _context12['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context12.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.GET_TEAM_FAILURE, error: _context12.t0 }, (0, _errors.logError)(_context12.t0)(dispatch)]));
                            return _context12.abrupt('return', { error: _context12.t0 });

                        case 13:

                            dispatch({ type: _action_types.TeamTypes.GET_TEAM_SUCCESS });

                            return _context12.abrupt('return', { data: data.exists });

                        case 15:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this11, [[2, 8]]);
        }));

        return function (_x28, _x29) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function joinTeam(inviteId, teamId) {
    var _this12 = this;

    return function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var serverVersion;
            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.JOIN_TEAM_REQUEST }, getState);

                            serverVersion = getState().entities.general.serverVersion;
                            _context13.prev = 2;

                            if (!(serverVersion.charAt(0) === '3')) {
                                _context13.next = 8;
                                break;
                            }

                            _context13.next = 6;
                            return _client.Client.joinTeamFromInvite(inviteId);

                        case 6:
                            _context13.next = 10;
                            break;

                        case 8:
                            _context13.next = 10;
                            return _client.Client4.joinTeam(inviteId);

                        case 10:
                            _context13.next = 17;
                            break;

                        case 12:
                            _context13.prev = 12;
                            _context13.t0 = _context13['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context13.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.JOIN_TEAM_FAILURE, error: _context13.t0 }, (0, _errors.logError)(_context13.t0)(dispatch)]), getState);
                            return _context13.abrupt('return', { error: _context13.t0 });

                        case 17:

                            getMyTeamUnreads()(dispatch, getState);

                            _context13.next = 20;
                            return Promise.all([getTeam(teamId)(dispatch, getState), getMyTeamMembers()(dispatch, getState)]);

                        case 20:

                            dispatch({ type: _action_types.TeamTypes.JOIN_TEAM_SUCCESS }, getState);
                            return _context13.abrupt('return', { data: true });

                        case 22:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this12, [[2, 12]]);
        }));

        return function (_x30, _x31) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function setTeamIcon(teamId, imageData) {
    return (0, _helpers.bindClientFunc)(_client.Client4.setTeamIcon, _action_types.TeamTypes.SET_TEAM_ICON_REQUEST, _action_types.TeamTypes.SET_TEAM_ICON_SUCCESS, _action_types.TeamTypes.SET_TEAM_ICON_FAILURE, teamId, imageData);
}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeMenu = exports.openMenu = exports.toggleMenu = undefined;

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.updateRhsState = updateRhsState;
exports.selectPostFromRightHandSideSearch = selectPostFromRightHandSideSearch;
exports.selectPostFromRightHandSideSearchByPostId = selectPostFromRightHandSideSearchByPostId;
exports.updateSearchTerms = updateSearchTerms;
exports.performSearch = performSearch;
exports.showSearchResults = showSearchResults;
exports.getFlaggedPosts = getFlaggedPosts;
exports.showFlaggedPosts = showFlaggedPosts;
exports.getPinnedPosts = getPinnedPosts;
exports.showPinnedPosts = showPinnedPosts;
exports.showMentions = showMentions;
exports.closeRightHandSide = closeRightHandSide;

var _reduxBatchedActions = __webpack_require__(921);

var _action_types = __webpack_require__(3);

var _search = __webpack_require__(1765);

var _posts = __webpack_require__(808);

var PostActions = _interopRequireWildcard(_posts);

var _client = __webpack_require__(270);

var _users = __webpack_require__(777);

var _teams = __webpack_require__(274);

var _channels = __webpack_require__(783);

var _posts2 = __webpack_require__(805);

var _diagnostics_actions = __webpack_require__(804);

var _rhs = __webpack_require__(818);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateRhsState(rhsState) {
    return function (dispatch, getState) {
        var action = {
            type: _constants.ActionTypes.UPDATE_RHS_STATE,
            state: rhsState
        };

        if (rhsState === _constants.RHSStates.PIN) {
            action.channelId = (0, _channels.getCurrentChannelId)(getState());
        }

        dispatch(action);
    };
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function selectPostFromRightHandSideSearch(post) {
    var _this = this;

    return function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return dispatch(PostActions.getPostThread(post.id));

                        case 2:

                            dispatch({
                                type: _constants.ActionTypes.SELECT_POST,
                                postId: Utils.getRootId(post),
                                channelId: post.channel_id,
                                previousRhsState: (0, _rhs.getRhsState)(getState())
                            });

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function selectPostFromRightHandSideSearchByPostId(postId) {
    var _this2 = this;

    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var post;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            post = (0, _posts2.getPost)(getState(), postId);
                            return _context2.abrupt('return', selectPostFromRightHandSideSearch(post)(dispatch, getState));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function updateSearchTerms(terms) {
    return {
        type: _constants.ActionTypes.UPDATE_RHS_SEARCH_TERMS,
        terms: terms
    };
}

function performSearch(terms, isMentionSearch) {
    return function (dispatch, getState) {
        var teamId = (0, _teams.getCurrentTeamId)(getState());

        return dispatch((0, _search.searchPosts)(teamId, terms, isMentionSearch));
    };
}

function showSearchResults() {
    return function (dispatch, getState) {
        var searchTerms = (0, _rhs.getSearchTerms)(getState());

        dispatch(updateRhsState(_constants.RHSStates.SEARCH));
        dispatch({
            type: _constants.ActionTypes.UPDATE_RHS_SEARCH_RESULTS_TERMS,
            terms: searchTerms
        });

        return dispatch(performSearch(searchTerms));
    };
}

function getSearchActions(result, teamId) {
    return [{
        type: _action_types.SearchTypes.RECEIVED_SEARCH_POSTS,
        data: result
    }, {
        type: _action_types.SearchTypes.RECEIVED_SEARCH_TERM,
        data: {
            teamId: teamId,
            terms: null,
            isOrSearch: false
        }
    }, {
        type: _action_types.SearchTypes.SEARCH_POSTS_SUCCESS
    }];
}

function getPreRHSSearchActions(searchPostRequest, terms, rhsState, channelId) {
    var updateRHSState = {
        type: _constants.ActionTypes.UPDATE_RHS_STATE,
        state: rhsState
    };

    if (channelId) {
        updateRHSState.channelId = channelId;
    }

    return [{
        type: searchPostRequest
    }, {
        type: _constants.ActionTypes.UPDATE_RHS_SEARCH_TERMS,
        terms: terms
    }, updateRHSState];
}

function getPostRHSSearchActions(searchPostSuccess, result, teamId) {
    var searchActions = getSearchActions(result, teamId);

    return [].concat((0, _toConsumableArray3.default)(searchActions), [{ type: searchPostSuccess }]);
}

function getFlaggedPosts() {
    var _this3 = this;

    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var state, userId, teamId, result, searchActions;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = getState();
                            userId = (0, _users.getCurrentUserId)(state);
                            teamId = (0, _teams.getCurrentTeamId)(state);
                            _context3.next = 5;
                            return _client.Client4.getFlaggedPosts(userId, '', teamId);

                        case 5:
                            result = _context3.sent;
                            _context3.next = 8;
                            return PostActions.getProfilesAndStatusesForPosts(result.posts, dispatch, getState);

                        case 8:
                            searchActions = getSearchActions(result, teamId);


                            dispatch((0, _reduxBatchedActions.batchActions)(searchActions));

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function showFlaggedPosts() {
    var _this4 = this;

    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatch, getState) {
            var state, userId, teamId, preRHSSearchActions, result, postRHSSearchActions;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = getState();
                            userId = (0, _users.getCurrentUserId)(state);
                            teamId = (0, _teams.getCurrentTeamId)(state);
                            preRHSSearchActions = getPreRHSSearchActions(_constants.ActionTypes.SEARCH_FLAGGED_POSTS_REQUEST, '', _constants.RHSStates.FLAG);


                            dispatch((0, _reduxBatchedActions.batchActions)(preRHSSearchActions));

                            result = void 0;
                            _context4.prev = 6;
                            _context4.next = 9;
                            return _client.Client4.getFlaggedPosts(userId, '', teamId);

                        case 9:
                            result = _context4.sent;
                            _context4.next = 15;
                            break;

                        case 12:
                            _context4.prev = 12;
                            _context4.t0 = _context4['catch'](6);

                            dispatch({ type: _constants.ActionTypes.SEARCH_FLAGGED_POSTS_FAILURE, error: _context4.t0 });

                        case 15:
                            _context4.next = 17;
                            return PostActions.getProfilesAndStatusesForPosts(result.posts, dispatch, getState);

                        case 17:
                            postRHSSearchActions = getPostRHSSearchActions(_constants.ActionTypes.SEARCH_FLAGGED_POSTS_SUCCESS, result, teamId);


                            dispatch((0, _reduxBatchedActions.batchActions)(postRHSSearchActions));

                        case 19:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[6, 12]]);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function getPinnedPosts(channelId) {
    var _this5 = this;

    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(dispatch, getState) {
            var currentChannelId, result, teamId, searchActions;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            currentChannelId = (0, _channels.getCurrentChannelId)(getState());
                            _context5.next = 3;
                            return _client.Client4.getPinnedPosts(channelId || currentChannelId);

                        case 3:
                            result = _context5.sent;
                            _context5.next = 6;
                            return PostActions.getProfilesAndStatusesForPosts(result.posts, dispatch, getState);

                        case 6:
                            teamId = (0, _teams.getCurrentTeamId)(getState());
                            searchActions = getSearchActions(result, teamId);


                            dispatch((0, _reduxBatchedActions.batchActions)(searchActions));

                        case 9:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function showPinnedPosts(channelId) {
    var _this6 = this;

    return function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(dispatch, getState) {
            var state, currentChannelId, preRHSSearchActions, result, teamId, postRHSSearchActions;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            state = getState();
                            currentChannelId = (0, _channels.getCurrentChannelId)(state);
                            preRHSSearchActions = getPreRHSSearchActions(_constants.ActionTypes.SEARCH_PINNED_POSTS_REQUEST, '', _constants.RHSStates.PIN, currentChannelId);


                            dispatch((0, _reduxBatchedActions.batchActions)(preRHSSearchActions));

                            result = void 0;
                            _context6.prev = 5;
                            _context6.next = 8;
                            return _client.Client4.getPinnedPosts(channelId || currentChannelId);

                        case 8:
                            result = _context6.sent;
                            _context6.next = 14;
                            break;

                        case 11:
                            _context6.prev = 11;
                            _context6.t0 = _context6['catch'](5);

                            dispatch({ type: _constants.ActionTypes.SEARCH_PINNED_POSTS_FAILURE, error: _context6.t0 });

                        case 14:
                            _context6.next = 16;
                            return PostActions.getProfilesAndStatusesForPosts(result.posts, dispatch, getState);

                        case 16:
                            teamId = (0, _teams.getCurrentTeamId)(state);
                            postRHSSearchActions = getPostRHSSearchActions(_constants.ActionTypes.SEARCH_PINNED_POSTS_SUCCESS, result, teamId);


                            dispatch((0, _reduxBatchedActions.batchActions)(postRHSSearchActions));

                        case 19:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[5, 11]]);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function showMentions() {
    return function (dispatch, getState) {
        var termKeys = (0, _users.getCurrentUserMentionKeys)(getState()).filter(function (_ref7) {
            var key = _ref7.key;

            return key !== '@channel' && key !== '@all' && key !== '@here';
        });

        var terms = termKeys.map(function (_ref8) {
            var key = _ref8.key;
            return key;
        }).join(' ').trim() + ' ';

        (0, _diagnostics_actions.trackEvent)('api', 'api_posts_search_mention');

        dispatch(performSearch(terms, true));
        dispatch((0, _reduxBatchedActions.batchActions)([{
            type: _constants.ActionTypes.UPDATE_RHS_SEARCH_TERMS,
            terms: terms
        }, {
            type: _constants.ActionTypes.UPDATE_RHS_STATE,
            state: _constants.RHSStates.MENTION
        }]));
    };
}

function closeRightHandSide() {
    return function (dispatch) {
        dispatch((0, _reduxBatchedActions.batchActions)([{
            type: _constants.ActionTypes.UPDATE_RHS_STATE,
            state: null
        }, {
            type: _constants.ActionTypes.SELECT_POST,
            postId: '',
            channelId: ''
        }]));
    };
}

var toggleMenu = exports.toggleMenu = function toggleMenu() {
    return function (dispatch) {
        return dispatch({
            type: _constants.ActionTypes.TOGGLE_RHS_MENU
        });
    };
};

var openMenu = exports.openMenu = function openMenu() {
    return function (dispatch) {
        return dispatch({
            type: _constants.ActionTypes.OPEN_RHS_MENU
        });
    };
};

var closeMenu = exports.closeMenu = function closeMenu() {
    return function (dispatch) {
        return dispatch({
            type: _constants.ActionTypes.CLOSE_RHS_MENU
        });
    };
};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSelectedPost = undefined;

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.getSelectedPostId = getSelectedPostId;
exports.getSelectedChannelId = getSelectedChannelId;
exports.getRhsState = getRhsState;
exports.getPreviousRhsState = getPreviousRhsState;
exports.getSearchTerms = getSearchTerms;
exports.getSearchResultsTerms = getSearchResultsTerms;
exports.getIsSearchingTerm = getIsSearchingTerm;
exports.getIsSearchingFlaggedPost = getIsSearchingFlaggedPost;
exports.getIsSearchingPinnedPost = getIsSearchingPinnedPost;
exports.getPostDraft = getPostDraft;
exports.makeGetPostsEmbedVisibleObj = makeGetPostsEmbedVisibleObj;
exports.getIsRhsOpen = getIsRhsOpen;
exports.getIsRhsMenuOpen = getIsRhsMenuOpen;

var _reselect = __webpack_require__(78);

var _users = __webpack_require__(777);

var _preferences = __webpack_require__(784);

var _storage = __webpack_require__(957);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getSelectedPostId(state) {
    return state.views.rhs.selectedPostId;
}

function getSelectedChannelId(state) {
    return state.views.rhs.selectedChannelId;
}

function getRealSelectedPost(state) {
    return state.entities.posts.posts[getSelectedPostId(state)];
}

var getSelectedPost = exports.getSelectedPost = (0, _reselect.createSelector)(getSelectedPostId, getRealSelectedPost, getSelectedChannelId, _users.getCurrentUserId, function (selectedPostId, selectedPost, selectedPostChannelId, currentUserId) {
    if (selectedPost) {
        return selectedPost;
    }

    // If there is no root post found, assume it has been deleted by data retention policy, and create a fake one.
    return {
        id: selectedPostId,
        exists: false,
        type: _constants.PostTypes.FAKE_PARENT_DELETED,
        message: (0, _utils.localizeMessage)('rhs_thread.rootPostDeletedMessage.body', 'Part of this thread has been deleted due to a data retention policy. You can no longer reply to this thread.'),
        channel_id: selectedPostChannelId,
        user_id: currentUserId
    };
});

function getRhsState(state) {
    return state.views.rhs.rhsState;
}

function getPreviousRhsState(state) {
    return state.views.rhs.previousRhsState;
}

function getSearchTerms(state) {
    return state.views.rhs.searchTerms;
}

function getSearchResultsTerms(state) {
    return state.views.rhs.searchResultsTerms;
}

function getIsSearchingTerm(state) {
    return state.views.rhs.isSearchingTerm;
}

function getIsSearchingFlaggedPost(state) {
    return state.views.rhs.isSearchingFlaggedPost;
}

function getIsSearchingPinnedPost(state) {
    return state.views.rhs.isSearchingPinnedPost;
}

function getPostDraft(state, prefixId, suffixId) {
    var defaultDraft = { message: '', fileInfos: [], uploadsInProgress: [] };
    var draft = (0, _storage.makeGetGlobalItem)(prefixId + suffixId, defaultDraft)(state);

    if (typeof draft.message !== 'undefined' && typeof draft.uploadsInProgress !== 'undefined' && typeof draft.fileInfos !== 'undefined') {
        return draft;
    }

    return defaultDraft;
}

function makeGetPostsEmbedVisibleObj() {
    return (0, _reselect.createSelector)(function (state) {
        return state.storage.storage;
    }, function (state) {
        return (0, _preferences.getBool)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.COLLAPSE_DISPLAY, _constants.Preferences.COLLAPSE_DISPLAY_DEFAULT);
    }, function (state, posts) {
        return posts;
    }, function (storage, previewCollapsed, posts) {
        var postsEmbedVisibleObj = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var post = _step.value;

                postsEmbedVisibleObj[post.id] = (0, _storage.getItemFromStorage)(storage, _constants.StoragePrefixes.EMBED_VISIBLE + post.id, !previewCollapsed);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return postsEmbedVisibleObj;
    });
}

function getIsRhsOpen(state) {
    return state.views.rhs.isSidebarOpen;
}

function getIsRhsMenuOpen(state) {
    return state.views.rhs.isMenuOpen;
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ConfirmModal = function (_React$Component) {
    (0, _inherits3.default)(ConfirmModal, _React$Component);

    function ConfirmModal() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ConfirmModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeypress = function (e) {
            if (e.key === 'Enter' && _this.props.show) {
                _this.handleConfirm();
            }
        }, _this.handleConfirm = function () {
            var checked = _this.refs.checkbox ? _this.refs.checkbox.checked : false;
            _this.props.onConfirm(checked);
        }, _this.handleCancel = function () {
            var checked = _this.refs.checkbox ? _this.refs.checkbox.checked : false;
            _this.props.onCancel(checked);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ConfirmModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.show) {
                document.addEventListener('keypress', this.handleKeypress);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keypress', this.handleKeypress);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.show && !nextProps.show) {
                document.removeEventListener('keypress', this.handleKeypress);
            } else if (!this.props.show && nextProps.show) {
                document.addEventListener('keypress', this.handleKeypress);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var checkbox = void 0;
            if (this.props.showCheckbox) {
                checkbox = _react2.default.createElement(
                    'div',
                    { className: 'checkbox text-right margin-bottom--none' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            ref: 'checkbox',
                            type: 'checkbox'
                        }),
                        this.props.checkboxText
                    )
                );
            }

            var cancelText = void 0;
            if (this.props.cancelButtonText) {
                cancelText = this.props.cancelButtonText;
            } else {
                cancelText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'confirm_modal.cancel',
                    defaultMessage: 'Cancel'
                });
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    className: 'modal-confirm ' + this.props.modalClass,
                    show: this.props.show,
                    onHide: this.props.onCancel
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: false },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        this.props.title
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    this.props.message,
                    checkbox
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-default',
                            onClick: this.handleCancel
                        },
                        cancelText
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: this.props.confirmButtonClass,
                            onClick: this.handleConfirm
                        },
                        this.props.confirmButtonText
                    )
                )
            );
        }
    }]);
    return ConfirmModal;
}(_react2.default.Component);

ConfirmModal.propTypes = {

    /*
     * Set to show modal
     */
    show: _propTypes2.default.bool.isRequired,

    /*
     * Title to use for the modal
     */
    title: _propTypes2.default.node,

    /*
     * Message to display in the body of the modal
     */
    message: _propTypes2.default.node,

    /*
     * The CSS class to apply to the confirm button
     */
    confirmButtonClass: _propTypes2.default.string,

    /*
     * The CSS class to apply to the modal
     */
    modalClass: _propTypes2.default.string,

    /*
     * Text/jsx element on the confirm button
     */
    confirmButtonText: _propTypes2.default.node,

    /*
     * Text/jsx element on the cancel button
     */
    cancelButtonText: _propTypes2.default.node,

    /*
     * Set to show checkbox
     */
    showCheckbox: _propTypes2.default.bool,

    /*
     * Text/jsx element to display with the checkbox
     */
    checkboxText: _propTypes2.default.node,

    /*
     * Function called when the confirm button or ENTER is pressed. Passes `true` if the checkbox is checked
     */
    onConfirm: _propTypes2.default.func.isRequired,

    /*
     * Function called when the cancel button is pressed or the modal is hidden. Passes `true` if the checkbox is checked
     */
    onCancel: _propTypes2.default.func.isRequired
};
ConfirmModal.defaultProps = {
    title: '',
    message: '',
    confirmButtonClass: 'btn btn-primary',
    confirmButtonText: '',
    modalClass: ''
};
exports.default = ConfirmModal;

/***/ }),
/* 820 */,
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormattedError = undefined;
exports.forceLogoutIfNecessary = forceLogoutIfNecessary;
exports.requestData = requestData;
exports.requestSuccess = requestSuccess;
exports.requestFailure = requestFailure;
exports.bindClientFunc = bindClientFunc;
exports.debounce = debounce;

var _reduxBatchedActions = __webpack_require__(278);

var _client = __webpack_require__(270);

var _action_types = __webpack_require__(3);

var _errors = __webpack_require__(828);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var HTTP_UNAUTHORIZED = 401;

function forceLogoutIfNecessary(err, dispatch, getState) {
    var currentUserId = getState().entities.users.currentUserId;

    if (err.status_code === HTTP_UNAUTHORIZED && err.url.indexOf('/login') === -1 && currentUserId) {
        _client.Client4.setToken('');
        dispatch({ type: _action_types.UserTypes.LOGOUT_SUCCESS });
    }
}

function dispatcher(type, data, dispatch, getState) {
    if (type.indexOf('SUCCESS') === -1) {
        // we don't want to pass the data for the request types
        dispatch(requestSuccess(type, data), getState);
    } else {
        dispatch(requestData(type), getState);
    }
}

function requestData(type) {
    return {
        type: type
    };
}

function requestSuccess(type, data) {
    return {
        type: type,
        data: data
    };
}

function requestFailure(type, error) {
    return {
        type: type,
        error: error
    };
}

function bindClientFunc(clientFunc, request, success, failure) {
    for (var _len = arguments.length, args = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        args[_key - 4] = arguments[_key];
    }

    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch(requestData(request), getState);

                            data = null;
                            _context.prev = 2;
                            _context.next = 5;
                            return clientFunc.apply(undefined, args);

                        case 5:
                            data = _context.sent;
                            _context.next = 13;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](2);

                            forceLogoutIfNecessary(_context.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([requestFailure(failure, _context.t0), (0, _errors.logError)(_context.t0)(dispatch)]), getState);
                            return _context.abrupt('return', { data: null, error: _context.t0 });

                        case 13:

                            if (Array.isArray(success)) {
                                success.forEach(function (s) {
                                    dispatcher(s, data, dispatch, getState);
                                });
                            } else {
                                dispatcher(success, data, dispatch, getState);
                            }

                            return _context.abrupt('return', { data: data, error: null });

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[2, 8]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

// Debounce function based on underscores modified to use es6 and a cb
function debounce(func, wait, immediate, cb) {
    var timeout = void 0;
    return function fx() {
        var _this2 = this;

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var runLater = function runLater() {
            timeout = null;
            if (!immediate) {
                Reflect.apply(func, _this2, args);
                if (cb) {
                    cb();
                }
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(runLater, wait);
        if (callNow) {
            Reflect.apply(func, this, args);
            if (cb) {
                cb();
            }
        }
    };
}

var FormattedError = exports.FormattedError = function (_Error) {
    _inherits(FormattedError, _Error);

    function FormattedError(id, defaultMessage) {
        var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, FormattedError);

        var _this3 = _possibleConstructorReturn(this, (FormattedError.__proto__ || Object.getPrototypeOf(FormattedError)).call(this, defaultMessage));

        _this3.intl = {
            id: id,
            defaultMessage: defaultMessage,
            values: values
        };
        return _this3;
    }

    return FormattedError;
}(Error);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var FormError = function (_React$Component) {
    (0, _inherits3.default)(FormError, _React$Component);

    function FormError() {
        (0, _classCallCheck3.default)(this, FormError);
        return (0, _possibleConstructorReturn3.default)(this, (FormError.__proto__ || (0, _getPrototypeOf2.default)(FormError)).apply(this, arguments));
    }

    (0, _createClass3.default)(FormError, [{
        key: 'render',
        value: function render() {
            if (!this.props.error && this.props.errors.length === 0) {
                return null;
            }

            // look for the first truthy error to display
            var message = this.props.error;

            if (!message) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.props.errors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var error = _step.value;

                        if (error) {
                            message = error;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            if (!message) {
                return null;
            }

            if (this.props.type === 'modal') {
                return _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        { className: 'col-sm-12 has-error' },
                        message
                    )
                );
            }

            if (this.props.type === 'backstage') {
                return _react2.default.createElement(
                    'div',
                    { className: 'pull-left has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        message
                    )
                );
            }

            if (this.props.margin) {
                return _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        message
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12 has-error' },
                _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    message
                )
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            // accepts either a single error or an array of errors
            return {
                type: _propTypes2.default.node,
                error: _propTypes2.default.node,
                margin: _propTypes2.default.bool,
                errors: _propTypes2.default.arrayOf(_propTypes2.default.node)
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                error: null,
                errors: []
            };
        }
    }]);
    return FormError;
}(_react2.default.Component);

exports.default = FormError;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createIncomingHook = createIncomingHook;
exports.getIncomingHook = getIncomingHook;
exports.getIncomingHooks = getIncomingHooks;
exports.removeIncomingHook = removeIncomingHook;
exports.updateIncomingHook = updateIncomingHook;
exports.createOutgoingHook = createOutgoingHook;
exports.getOutgoingHook = getOutgoingHook;
exports.getOutgoingHooks = getOutgoingHooks;
exports.removeOutgoingHook = removeOutgoingHook;
exports.updateOutgoingHook = updateOutgoingHook;
exports.regenOutgoingHookToken = regenOutgoingHookToken;
exports.getCommands = getCommands;
exports.getAutocompleteCommands = getAutocompleteCommands;
exports.getCustomTeamCommands = getCustomTeamCommands;
exports.addCommand = addCommand;
exports.editCommand = editCommand;
exports.executeCommand = executeCommand;
exports.regenCommandToken = regenCommandToken;
exports.deleteCommand = deleteCommand;
exports.addOAuthApp = addOAuthApp;
exports.editOAuthApp = editOAuthApp;
exports.getOAuthApps = getOAuthApps;
exports.getOAuthApp = getOAuthApp;
exports.deleteOAuthApp = deleteOAuthApp;
exports.regenOAuthAppSecret = regenOAuthAppSecret;

var _action_types = __webpack_require__(3);

var _constants = __webpack_require__(19);

var _reduxBatchedActions = __webpack_require__(278);

var _client = __webpack_require__(270);

var _errors = __webpack_require__(828);

var _helpers = __webpack_require__(821);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function createIncomingHook(hook) {
    return (0, _helpers.bindClientFunc)(_client.Client4.createIncomingWebhook, _action_types.IntegrationTypes.CREATE_INCOMING_HOOK_REQUEST, [_action_types.IntegrationTypes.RECEIVED_INCOMING_HOOK, _action_types.IntegrationTypes.CREATE_INCOMING_HOOK_SUCCESS], _action_types.IntegrationTypes.CREATE_INCOMING_HOOK_FAILURE, hook);
}

function getIncomingHook(hookId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getIncomingWebhook, _action_types.IntegrationTypes.GET_INCOMING_HOOKS_REQUEST, [_action_types.IntegrationTypes.RECEIVED_INCOMING_HOOK, _action_types.IntegrationTypes.GET_INCOMING_HOOKS_SUCCESS], _action_types.IntegrationTypes.GET_INCOMING_HOOKS_FAILURE, hookId);
}

function getIncomingHooks() {
    var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PAGE_SIZE_DEFAULT;

    return (0, _helpers.bindClientFunc)(_client.Client4.getIncomingWebhooks, _action_types.IntegrationTypes.GET_INCOMING_HOOKS_REQUEST, [_action_types.IntegrationTypes.RECEIVED_INCOMING_HOOKS, _action_types.IntegrationTypes.GET_INCOMING_HOOKS_SUCCESS], _action_types.IntegrationTypes.GET_INCOMING_HOOKS_FAILURE, teamId, page, perPage);
}

function removeIncomingHook(hookId) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.IntegrationTypes.DELETE_INCOMING_HOOK_REQUEST }, getState);

                            _context.prev = 1;
                            _context.next = 4;
                            return _client.Client4.removeIncomingWebhook(hookId);

                        case 4:
                            _context.next = 11;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.IntegrationTypes.DELETE_INCOMING_HOOK_FAILURE, error: _context.t0 }, (0, _errors.logError)(_context.t0)(dispatch)]), getState);
                            return _context.abrupt('return', { error: _context.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.IntegrationTypes.DELETED_INCOMING_HOOK,
                                data: { id: hookId }
                            }, {
                                type: _action_types.IntegrationTypes.DELETE_INCOMING_HOOK_SUCCESS
                            }]), getState);

                            return _context.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[1, 6]]);
        }));

        return function (_x4, _x5) {
            return _ref.apply(this, arguments);
        };
    }();
}

function updateIncomingHook(hook) {
    return (0, _helpers.bindClientFunc)(_client.Client4.updateIncomingWebhook, _action_types.IntegrationTypes.UPDATE_INCOMING_HOOK_REQUEST, [_action_types.IntegrationTypes.RECEIVED_INCOMING_HOOK, _action_types.IntegrationTypes.UPDATE_INCOMING_HOOK_SUCCESS], _action_types.IntegrationTypes.UPDATE_INCOMING_HOOK_FAILURE, hook);
}

function createOutgoingHook(hook) {
    return (0, _helpers.bindClientFunc)(_client.Client4.createOutgoingWebhook, _action_types.IntegrationTypes.CREATE_OUTGOING_HOOK_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OUTGOING_HOOK, _action_types.IntegrationTypes.CREATE_OUTGOING_HOOK_SUCCESS], _action_types.IntegrationTypes.CREATE_OUTGOING_HOOK_FAILURE, hook);
}

function getOutgoingHook(hookId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getOutgoingWebhook, _action_types.IntegrationTypes.GET_OUTGOING_HOOKS_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OUTGOING_HOOK, _action_types.IntegrationTypes.GET_OUTGOING_HOOKS_SUCCESS], _action_types.IntegrationTypes.GET_OUTGOING_HOOKS_FAILURE, hookId);
}

function getOutgoingHooks() {
    var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.General.PAGE_SIZE_DEFAULT;

    return (0, _helpers.bindClientFunc)(_client.Client4.getOutgoingWebhooks, _action_types.IntegrationTypes.GET_OUTGOING_HOOKS_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OUTGOING_HOOKS, _action_types.IntegrationTypes.GET_OUTGOING_HOOKS_SUCCESS], _action_types.IntegrationTypes.GET_OUTGOING_HOOKS_FAILURE, channelId, teamId, page, perPage);
}

function removeOutgoingHook(hookId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.IntegrationTypes.DELETE_OUTGOING_HOOK_REQUEST }, getState);

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _client.Client4.removeOutgoingWebhook(hookId);

                        case 4:
                            _context2.next = 11;
                            break;

                        case 6:
                            _context2.prev = 6;
                            _context2.t0 = _context2['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.IntegrationTypes.DELETE_OUTGOING_HOOK_FAILURE, error: _context2.t0 }, (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', { error: _context2.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.IntegrationTypes.DELETED_OUTGOING_HOOK,
                                data: { id: hookId }
                            }, {
                                type: _action_types.IntegrationTypes.DELETE_OUTGOING_HOOK_SUCCESS
                            }]), getState);

                            return _context2.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[1, 6]]);
        }));

        return function (_x10, _x11) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function updateOutgoingHook(hook) {
    return (0, _helpers.bindClientFunc)(_client.Client4.updateOutgoingWebhook, _action_types.IntegrationTypes.UPDATE_OUTGOING_HOOK_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OUTGOING_HOOK, _action_types.IntegrationTypes.UPDATE_OUTGOING_HOOK_SUCCESS], _action_types.IntegrationTypes.UPDATE_OUTGOING_HOOK_FAILURE, hook);
}

function regenOutgoingHookToken(hookId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.regenOutgoingHookToken, _action_types.IntegrationTypes.UPDATE_OUTGOING_HOOK_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OUTGOING_HOOK, _action_types.IntegrationTypes.UPDATE_OUTGOING_HOOK_SUCCESS], _action_types.IntegrationTypes.UPDATE_OUTGOING_HOOK_FAILURE, hookId);
}

function getCommands(teamId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getCommandsList, _action_types.IntegrationTypes.GET_COMMANDS_REQUEST, [_action_types.IntegrationTypes.RECEIVED_COMMANDS, _action_types.IntegrationTypes.GET_COMMANDS_SUCCESS], _action_types.IntegrationTypes.GET_COMMANDS_FAILURE, teamId);
}

function getAutocompleteCommands(teamId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PAGE_SIZE_DEFAULT;

    return (0, _helpers.bindClientFunc)(_client.Client4.getAutocompleteCommandsList, _action_types.IntegrationTypes.GET_AUTOCOMPLETE_COMMANDS_REQUEST, [_action_types.IntegrationTypes.RECEIVED_COMMANDS, _action_types.IntegrationTypes.GET_AUTOCOMPLETE_COMMANDS_SUCCESS], _action_types.IntegrationTypes.GET_AUTOCOMPLETE_COMMANDS_FAILURE, teamId, page, perPage);
}

function getCustomTeamCommands(teamId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getCustomTeamCommands, _action_types.IntegrationTypes.GET_CUSTOM_TEAM_COMMANDS_REQUEST, [_action_types.IntegrationTypes.RECEIVED_CUSTOM_TEAM_COMMANDS, _action_types.IntegrationTypes.GET_CUSTOM_TEAM_COMMANDS_SUCCESS], _action_types.IntegrationTypes.GET_CUSTOM_TEAM_COMMANDS_FAILURE, teamId);
}

function addCommand(command) {
    return (0, _helpers.bindClientFunc)(_client.Client4.addCommand, _action_types.IntegrationTypes.ADD_COMMAND_REQUEST, [_action_types.IntegrationTypes.RECEIVED_COMMAND, _action_types.IntegrationTypes.ADD_COMMAND_SUCCESS], _action_types.IntegrationTypes.ADD_COMMAND_FAILURE, command);
}

function editCommand(command) {
    return (0, _helpers.bindClientFunc)(_client.Client4.editCommand, _action_types.IntegrationTypes.EDIT_COMMAND_REQUEST, [_action_types.IntegrationTypes.RECEIVED_COMMAND, _action_types.IntegrationTypes.EDIT_COMMAND_SUCCESS], _action_types.IntegrationTypes.EDIT_COMMAND_FAILURE, command);
}

function executeCommand(command, args) {
    return (0, _helpers.bindClientFunc)(_client.Client4.executeCommand, _action_types.IntegrationTypes.EXECUTE_COMMAND_REQUEST, _action_types.IntegrationTypes.EXECUTE_COMMAND_SUCCESS, _action_types.IntegrationTypes.EXECUTE_COMMAND_FAILURE, command, args);
}

function regenCommandToken(id) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var res;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.IntegrationTypes.REGEN_COMMAND_TOKEN_REQUEST }, getState);

                            res = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.regenCommandToken(id);

                        case 5:
                            res = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.IntegrationTypes.REGEN_COMMAND_TOKEN_FAILURE, error: _context3.t0 }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', { error: _context3.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.IntegrationTypes.RECEIVED_COMMAND_TOKEN,
                                data: {
                                    id: id,
                                    token: res.token
                                }
                            }, {
                                type: _action_types.IntegrationTypes.REGEN_COMMAND_TOKEN_SUCCESS
                            }]), getState);

                            return _context3.abrupt('return', { data: true });

                        case 15:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x14, _x15) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function deleteCommand(id) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.IntegrationTypes.DELETE_COMMAND_REQUEST }, getState);

                            _context4.prev = 1;
                            _context4.next = 4;
                            return _client.Client4.deleteCommand(id);

                        case 4:
                            _context4.next = 11;
                            break;

                        case 6:
                            _context4.prev = 6;
                            _context4.t0 = _context4['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.IntegrationTypes.DELETE_COMMAND_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', { error: _context4.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.IntegrationTypes.DELETED_COMMAND,
                                data: { id: id }
                            }, {
                                type: _action_types.IntegrationTypes.DELETE_COMMAND_SUCCESS
                            }]), getState);

                            return _context4.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[1, 6]]);
        }));

        return function (_x16, _x17) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function addOAuthApp(app) {
    return (0, _helpers.bindClientFunc)(_client.Client4.createOAuthApp, _action_types.IntegrationTypes.ADD_OAUTH_APP_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OAUTH_APP, _action_types.IntegrationTypes.ADD_OAUTH_APP_SUCCESS], _action_types.IntegrationTypes.ADD_OAUTH_APP_FAILURE, app);
}

function editOAuthApp(app) {
    return (0, _helpers.bindClientFunc)(_client.Client4.editOAuthApp, _action_types.IntegrationTypes.UPDATE_OAUTH_APP_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OAUTH_APP, _action_types.IntegrationTypes.UPDATE_OAUTH_APP_SUCCESS], _action_types.IntegrationTypes.UPDATE_OAUTH_APP_FAILURE, app);
}

function getOAuthApps() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PAGE_SIZE_DEFAULT;

    return (0, _helpers.bindClientFunc)(_client.Client4.getOAuthApps, _action_types.IntegrationTypes.GET_OAUTH_APPS_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OAUTH_APPS, _action_types.IntegrationTypes.GET_OAUTH_APPS_SUCCESS], _action_types.IntegrationTypes.GET_OAUTH_APPS_FAILURE, page, perPage);
}

function getOAuthApp(appId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getOAuthApp, _action_types.IntegrationTypes.GET_OAUTH_APP_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OAUTH_APP, _action_types.IntegrationTypes.GET_OAUTH_APP_SUCCESS], _action_types.IntegrationTypes.GET_OAUTH_APP_FAILURE, appId);
}

function deleteOAuthApp(id) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.IntegrationTypes.DELETE_OAUTH_APP_REQUEST }, getState);

                            _context5.prev = 1;
                            _context5.next = 4;
                            return _client.Client4.deleteOAuthApp(id);

                        case 4:
                            _context5.next = 11;
                            break;

                        case 6:
                            _context5.prev = 6;
                            _context5.t0 = _context5['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.IntegrationTypes.DELETE_OAUTH_APP_FAILURE, error: _context5.t0 }, (0, _errors.logError)(_context5.t0)(dispatch)]), getState);
                            return _context5.abrupt('return', { error: _context5.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.IntegrationTypes.DELETED_OAUTH_APP,
                                data: { id: id }
                            }, {
                                type: _action_types.IntegrationTypes.DELETE_OAUTH_APP_SUCCESS
                            }]), getState);

                            return _context5.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[1, 6]]);
        }));

        return function (_x20, _x21) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function regenOAuthAppSecret(appId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.regenOAuthAppSecret, _action_types.IntegrationTypes.UPDATE_OAUTH_APP_REQUEST, [_action_types.IntegrationTypes.RECEIVED_OAUTH_APP, _action_types.IntegrationTypes.UPDATE_OAUTH_APP_SUCCESS], _action_types.IntegrationTypes.UPDATE_OAUTH_APP_FAILURE, appId);
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(2521).version;
elliptic.utils = __webpack_require__(2522);
elliptic.rand = __webpack_require__(1442);
elliptic.curve = __webpack_require__(992);
elliptic.curves = __webpack_require__(2527);

// Protocols
elliptic.ec = __webpack_require__(2534);
elliptic.eddsa = __webpack_require__(2538);


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _browser_history = __webpack_require__(273);

var _storage = __webpack_require__(957);

var Selectors = _interopRequireWildcard(_storage);

var _storage2 = __webpack_require__(285);

var Actions = _interopRequireWildcard(_storage2);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

var BrowserStoreClass = function () {
    function BrowserStoreClass() {
        (0, _classCallCheck3.default)(this, BrowserStoreClass);
    }

    (0, _createClass3.default)(BrowserStoreClass, [{
        key: 'setItem',
        value: function setItem(name, value) {
            dispatch(Actions.setItem(name, value));
        }
    }, {
        key: 'getItem',
        value: function getItem(name, defaultValue) {
            return Selectors.makeGetItem(name, defaultValue)(getState());
        }
    }, {
        key: 'removeItem',
        value: function removeItem(name) {
            dispatch(Actions.removeItem(name));
        }
    }, {
        key: 'setGlobalItem',
        value: function setGlobalItem(name, value) {
            dispatch(Actions.setGlobalItem(name, value));
        }
    }, {
        key: 'getGlobalItem',
        value: function getGlobalItem(name) {
            var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return Selectors.makeGetGlobalItem(name, defaultValue)(getState());
        }
    }, {
        key: 'removeGlobalItem',
        value: function removeGlobalItem(name) {
            dispatch(Actions.removeGlobalItem(name));
        }
    }, {
        key: 'signalLogout',
        value: function signalLogout() {
            if (this.isLocalStorageSupported()) {
                // PLT-1285 store an identifier in session storage so we can catch if the logout came from this tab on IE11
                var logoutId = Utils.generateId();

                Utils.removePrefixFromLocalStorage(_constants.StoragePrefixes.ANNOUNCEMENT);

                sessionStorage.setItem(_constants.StoragePrefixes.LOGOUT, logoutId);
                localStorage.setItem(_constants.StoragePrefixes.LOGOUT, logoutId);
                localStorage.removeItem(_constants.StoragePrefixes.LOGOUT);
            }
        }
    }, {
        key: 'isSignallingLogout',
        value: function isSignallingLogout(logoutId) {
            return logoutId === sessionStorage.getItem(_constants.StoragePrefixes.LOGOUT);
        }
    }, {
        key: 'signalLogin',
        value: function signalLogin() {
            if (this.isLocalStorageSupported()) {
                // PLT-1285 store an identifier in session storage so we can catch if the logout came from this tab on IE11
                var loginId = Utils.generateId();

                sessionStorage.setItem(_constants.StoragePrefixes.LOGIN, loginId);
                localStorage.setItem(_constants.StoragePrefixes.LOGIN, loginId);
                localStorage.removeItem(_constants.StoragePrefixes.LOGIN);
            }
        }
    }, {
        key: 'isSignallingLogin',
        value: function isSignallingLogin(loginId) {
            return loginId === sessionStorage.getItem(_constants.StoragePrefixes.LOGIN);
        }

        /**
         * Preforms the given action on each item that has the given prefix
         * Signature for action is action(key, value)
         */

    }, {
        key: 'actionOnGlobalItemsWithPrefix',
        value: function actionOnGlobalItemsWithPrefix(prefix, action) {
            dispatch(Actions.actionOnGlobalItemsWithPrefix(prefix, action));
        }
    }, {
        key: 'actionOnItemsWithPrefix',
        value: function actionOnItemsWithPrefix(prefix, action) {
            dispatch(Actions.actionOnItemsWithPrefix(prefix, action));
        }
    }, {
        key: 'clear',
        value: function clear(options) {
            dispatch(Actions.clear(options));
        }
    }, {
        key: 'isLocalStorageSupported',
        value: function isLocalStorageSupported() {
            if (this.hasCheckedLocalStorage) {
                return this.localStorageSupported;
            }

            this.localStorageSupported = false;

            try {
                localStorage.setItem('__testLocal__', '1');
                if (localStorage.getItem('__testLocal__') === '1') {
                    this.localStorageSupported = true;
                }
                localStorage.removeItem('__testLocal__', '1');
            } catch (e) {
                this.localStorageSupported = false;
            }

            try {
                sessionStorage.setItem('__testSession__', '1');
                sessionStorage.removeItem('__testSession__');
            } catch (e) {
                // Session storage not usable, website is unusable
                _browser_history.browserHistory.push('/error?type=' + _constants.ErrorPageTypes.LOCAL_STORAGE);
            }

            this.hasCheckedLocalStorage = true;

            return this.localStorageSupported;
        }
    }, {
        key: 'hasSeenLandingPage',
        value: function hasSeenLandingPage() {
            return this.getItem('__landingPageSeen__', false);
        }
    }, {
        key: 'setLandingPageSeen',
        value: function setLandingPageSeen(landingPageSeen) {
            return this.setItem('__landingPageSeen__', landingPageSeen);
        }
    }]);
    return BrowserStoreClass;
}();

var BrowserStore = new BrowserStoreClass();
exports.default = BrowserStore;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _save_button = __webpack_require__(925);

var _save_button2 = _interopRequireDefault(_save_button);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SettingItemMax = function (_React$PureComponent) {
    (0, _inherits3.default)(SettingItemMax, _React$PureComponent);

    function SettingItemMax() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SettingItemMax);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SettingItemMax.__proto__ || (0, _getPrototypeOf2.default)(SettingItemMax)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (e) {
            if ((0, _utils.isKeyPressed)(e, _constants2.default.KeyCodes.ENTER) && _this.props.submit) {
                _this.handleSubmit(e);
            }
        }, _this.handleSubmit = function (e) {
            e.preventDefault();

            if (_this.props.setting) {
                _this.props.submit(_this.props.setting);
            } else {
                _this.props.submit();
            }
        }, _this.handleUpdateSection = function (e) {
            _this.props.updateSection(_this.props.section);
            e.preventDefault();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SettingItemMax, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'render',
        value: function render() {
            var clientError = null;
            if (this.props.clientError) {
                clientError = _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        {
                            id: 'clientError',
                            className: 'col-sm-12 has-error'
                        },
                        this.props.clientError
                    )
                );
            }

            var serverError = null;
            if (this.props.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        {
                            id: 'serverError',
                            className: 'col-sm-12 has-error'
                        },
                        this.props.serverError
                    )
                );
            }

            var extraInfo = null;
            var hintClass = 'setting-list__hint';
            if (this.props.infoPosition === 'top') {
                hintClass = 'padding-bottom x2';
            }

            if (this.props.extraInfo) {
                extraInfo = _react2.default.createElement(
                    'div',
                    { className: hintClass },
                    this.props.extraInfo
                );
            }

            var submit = '';
            if (this.props.submit) {
                submit = _react2.default.createElement(_save_button2.default, {
                    saving: this.props.saving,
                    disabled: this.props.saving,
                    onClick: this.handleSubmit
                });
            }

            var inputs = this.props.inputs;
            var widthClass = void 0;
            if (this.props.width === 'full') {
                widthClass = 'col-sm-12';
            } else if (this.props.width === 'medium') {
                widthClass = 'col-sm-10 col-sm-offset-2';
            } else {
                widthClass = 'col-sm-9 col-sm-offset-3';
            }

            var title = void 0;
            if (this.props.title) {
                title = _react2.default.createElement(
                    'li',
                    { className: 'col-sm-12 section-title' },
                    this.props.title
                );
            }

            var listContent = _react2.default.createElement(
                'li',
                { className: 'setting-list-item' },
                inputs,
                extraInfo
            );

            if (this.props.infoPosition === 'top') {
                listContent = _react2.default.createElement(
                    'li',
                    null,
                    extraInfo,
                    inputs
                );
            }

            var cancelButtonText = void 0;
            if (this.props.cancelButtonText) {
                cancelButtonText = this.props.cancelButtonText;
            } else {
                cancelButtonText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'setting_item_max.cancel',
                    defaultMessage: 'Cancel'
                });
            }

            return _react2.default.createElement(
                'ul',
                {
                    className: 'section-max form-horizontal ' + this.props.containerStyle
                },
                title,
                _react2.default.createElement(
                    'li',
                    { className: widthClass },
                    _react2.default.createElement(
                        'ul',
                        { className: 'setting-list' },
                        listContent,
                        _react2.default.createElement(
                            'li',
                            { className: 'setting-list-item' },
                            _react2.default.createElement('hr', null),
                            this.props.submitExtra,
                            serverError,
                            clientError,
                            submit,
                            _react2.default.createElement(
                                'button',
                                {
                                    id: 'cancelSetting',
                                    className: 'btn btn-sm cursor--pointer style--none',
                                    onClick: this.handleUpdateSection
                                },
                                cancelButtonText
                            )
                        )
                    )
                )
            );
        }
    }]);
    return SettingItemMax;
}(_react2.default.PureComponent);

SettingItemMax.defaultProps = {
    infoPosition: 'bottom',
    saving: false,
    section: '',
    containerStyle: ''
};
SettingItemMax.propTypes = {

    /**
     * Array of inputs selection
     */
    inputs: _propTypes2.default.array,

    /**
     * Styles for main component
     */
    containerStyle: _propTypes2.default.string,

    /**
     * Client error
     */
    clientError: _propTypes2.default.string,

    /**
     * Server error
     */
    serverError: _propTypes2.default.string,

    /**
     * Settings extra information
     */
    extraInfo: _propTypes2.default.element,

    /**
     * Info position
     */
    infoPosition: _propTypes2.default.string,

    /**
     * Settings or tab section
     */
    section: _propTypes2.default.string,

    /**
     * Function to update section
     */
    updateSection: _propTypes2.default.func,

    /**
     * setting to submit
     */
    setting: _propTypes2.default.string,

    /**
     * Function to submit setting
     */
    submit: _propTypes2.default.func,

    /**
     * Extra information on submit
     */
    submitExtra: _propTypes2.default.node,

    /**
     * Indicates whether setting is on saving
     */
    saving: _propTypes2.default.bool,

    /**
     * Settings title
     */
    title: _propTypes2.default.node,

    /**
     * Settings width
     */
    width: _propTypes2.default.string,

    /**
     * Text of cancel button
     */
    cancelButtonText: _propTypes2.default.node
};
exports.default = SettingItemMax;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(872);
var defaultSettings = __webpack_require__(2781);
var dom = __webpack_require__(895);
var EventManager = __webpack_require__(2782);
var guid = __webpack_require__(2783);

var instances = {};

function Instance(element, userSettings) {
  var i = this;

  i.settings = defaultSettings();
  for (var key in userSettings) {
    i.settings[key] = userSettings[key];
  }

  i.containerWidth = null;
  i.containerHeight = null;
  i.contentWidth = null;
  i.contentHeight = null;

  i.isRtl = dom.css(element, 'direction') === "rtl";
  i.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
  i.event = new EventManager();
  i.ownerDocument = element.ownerDocument || document;

  function focus() {
    element.classList.add('ps--focus');
  }

  function blur() {
    element.classList.remove('ps--focus');
  }

  i.scrollbarXRail = dom.appendTo(dom.create('div', 'ps__scrollbar-x-rail'), element);
  i.scrollbarX = dom.appendTo(dom.create('div', 'ps__scrollbar-x'), i.scrollbarXRail);
  i.scrollbarX.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarX, 'focus', focus);
  i.event.bind(i.scrollbarX, 'blur', blur);
  i.scrollbarXActive = null;
  i.scrollbarXWidth = null;
  i.scrollbarXLeft = null;
  i.scrollbarXBottom = _.toInt(dom.css(i.scrollbarXRail, 'bottom'));
  i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
  i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : _.toInt(dom.css(i.scrollbarXRail, 'top'));
  i.railBorderXWidth = _.toInt(dom.css(i.scrollbarXRail, 'borderLeftWidth')) + _.toInt(dom.css(i.scrollbarXRail, 'borderRightWidth'));
  // Set rail to display:block to calculate margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  dom.css(i.scrollbarXRail, 'display', '');
  i.railXWidth = null;
  i.railXRatio = null;

  i.scrollbarYRail = dom.appendTo(dom.create('div', 'ps__scrollbar-y-rail'), element);
  i.scrollbarY = dom.appendTo(dom.create('div', 'ps__scrollbar-y'), i.scrollbarYRail);
  i.scrollbarY.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarY, 'focus', focus);
  i.event.bind(i.scrollbarY, 'blur', blur);
  i.scrollbarYActive = null;
  i.scrollbarYHeight = null;
  i.scrollbarYTop = null;
  i.scrollbarYRight = _.toInt(dom.css(i.scrollbarYRail, 'right'));
  i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
  i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : _.toInt(dom.css(i.scrollbarYRail, 'left'));
  i.scrollbarYOuterWidth = i.isRtl ? _.outerWidth(i.scrollbarY) : null;
  i.railBorderYWidth = _.toInt(dom.css(i.scrollbarYRail, 'borderTopWidth')) + _.toInt(dom.css(i.scrollbarYRail, 'borderBottomWidth'));
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));
  dom.css(i.scrollbarYRail, 'display', '');
  i.railYHeight = null;
  i.railYRatio = null;
}

function getId(element) {
  return element.getAttribute('data-ps-id');
}

function setId(element, id) {
  element.setAttribute('data-ps-id', id);
}

function removeId(element) {
  element.removeAttribute('data-ps-id');
}

exports.add = function (element, userSettings) {
  var newId = guid();
  setId(element, newId);
  instances[newId] = new Instance(element, userSettings);
  return instances[newId];
};

exports.remove = function (element) {
  delete instances[getId(element)];
  removeId(element);
};

exports.get = function (element) {
  return instances[getId(element)];
};


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dismissErrorObject = dismissErrorObject;
exports.dismissError = dismissError;
exports.getLogErrorAction = getLogErrorAction;
exports.logError = logError;
exports.clearErrors = clearErrors;

var _action_types = __webpack_require__(3);

var _serializeError = __webpack_require__(1641);

var _serializeError2 = _interopRequireDefault(_serializeError);

var _client = __webpack_require__(270);

var _event_emitter = __webpack_require__(182);

var _event_emitter2 = _interopRequireDefault(_event_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function dismissErrorObject(index) {
    return {
        type: _action_types.ErrorTypes.DISMISS_ERROR,
        index: index
    };
}

function dismissError(index) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch(dismissErrorObject(index));

                            return _context.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
}

function getLogErrorAction(error) {
    var displayable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return {
        type: _action_types.ErrorTypes.LOG_ERROR,
        displayable: displayable,
        error: error
    };
}

function logError(error) {
    var _this2 = this;

    var displayable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
            var serializedError, sendToServer, stringifiedSerializedError;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            serializedError = (0, _serializeError2.default)(error);
                            sendToServer = true;

                            if (error.stack && error.stack.includes('TypeError: Failed to fetch')) {
                                sendToServer = false;
                            }

                            if (!sendToServer) {
                                _context2.next = 12;
                                break;
                            }

                            _context2.prev = 4;
                            stringifiedSerializedError = JSON.stringify(serializedError).toString();
                            _context2.next = 8;
                            return _client.Client4.logClientError(stringifiedSerializedError);

                        case 8:
                            _context2.next = 12;
                            break;

                        case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2['catch'](4);

                        case 12:

                            _event_emitter2.default.emit(_action_types.ErrorTypes.LOG_ERROR, error);
                            dispatch(getLogErrorAction(serializedError, displayable));

                            return _context2.abrupt('return', { data: true });

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[4, 10]]);
        }));

        return function (_x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function clearErrors() {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.ErrorTypes.CLEAR_ERRORS });

                            return _context3.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x5) {
            return _ref3.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmojiMap = undefined;

var _typeof2 = __webpack_require__(180);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _iterator = __webpack_require__(297);

var _iterator2 = _interopRequireDefault(_iterator);

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _client = __webpack_require__(270);

var _emojis = __webpack_require__(877);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _emoji2 = __webpack_require__(947);

var Emoji = _interopRequireWildcard(_emoji2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'changed';
var MAXIMUM_RECENT_EMOJI = 27;
var LOADED_EMOJI_ITEMS = 'loadedEmojiItems';

// Wrap the contents of the store so that we don't need to construct an ES6 map where most of the content
// (the system emojis) will never change. It provides the get/has functions of a map and an iterator so
// that it can be used in for..of loops

var EmojiMap = exports.EmojiMap = function () {
    function EmojiMap(customEmojis) {
        (0, _classCallCheck3.default)(this, EmojiMap);

        this.customEmojis = customEmojis;

        // Store customEmojis to an array so we can iterate it more easily
        this.customEmojisArray = [].concat((0, _toConsumableArray3.default)(customEmojis));
    }

    (0, _createClass3.default)(EmojiMap, [{
        key: 'has',
        value: function has(name) {
            return Emoji.EmojiIndicesByAlias.has(name) || this.customEmojis.has(name);
        }
    }, {
        key: 'get',
        value: function get(name) {
            if (Emoji.EmojiIndicesByAlias.has(name)) {
                return Emoji.Emojis[Emoji.EmojiIndicesByAlias.get(name)];
            }

            return this.customEmojis.get(name);
        }
    }, {
        key: _iterator2.default,
        value: function value() {
            var customEmojisArray = this.customEmojisArray;

            return {
                systemIndex: 0,
                customIndex: 0,
                next: function next() {
                    if (this.systemIndex < Emoji.Emojis.length) {
                        var emoji = Emoji.Emojis[this.systemIndex];

                        this.systemIndex += 1;

                        return { value: [emoji.aliases[0], emoji] };
                    }

                    if (this.customIndex < customEmojisArray.length) {
                        var _emoji = customEmojisArray[this.customIndex][1];

                        this.customIndex += 1;

                        return { value: [_emoji.name, _emoji] };
                    }

                    return { done: true };
                }
            };
        }
    }]);
    return EmojiMap;
}();

var EmojiStore = function (_EventEmitter) {
    (0, _inherits3.default)(EmojiStore, _EventEmitter);

    function EmojiStore() {
        (0, _classCallCheck3.default)(this, EmojiStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiStore.__proto__ || (0, _getPrototypeOf2.default)(EmojiStore)).call(this));

        _this.dispatchToken = _app_dispatcher2.default.register(_this.handleEventPayload.bind(_this));

        _this.setMaxListeners(600);

        _this.map = new EmojiMap((0, _emojis.getCustomEmojisByName)(_redux_store2.default.getState()));

        _this.entities = {};

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.emojis.customEmoji;
            var entities = _this.entities;
            _this.entities = newEntities;

            if (newEntities !== entities) {
                _this.map = new EmojiMap((0, _emojis.getCustomEmojisByName)(_redux_store2.default.getState()));
                _this.emitChange();
            }
        });
        return _this;
    }

    (0, _createClass3.default)(EmojiStore, [{
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'hasSystemEmoji',
        value: function hasSystemEmoji(name) {
            return Emoji.EmojiIndicesByAlias.has(name);
        }
    }, {
        key: 'getCustomEmojiMap',
        value: function getCustomEmojiMap() {
            return (0, _emojis.getCustomEmojisByName)(_redux_store2.default.getState());
        }
    }, {
        key: 'getEmojis',
        value: function getEmojis() {
            return this.map;
        }
    }, {
        key: 'has',
        value: function has(name) {
            return this.map.has(name);
        }
    }, {
        key: 'get',
        value: function get(name) {
            return this.map.get(name);
        }
    }, {
        key: 'addRecentEmoji',
        value: function addRecentEmoji(alias) {
            var recentEmojis = this.getRecentEmojis();

            var name = void 0;
            var emoji = this.get(alias);
            if (!emoji) {
                return;
            } else if (emoji.name) {
                name = emoji.name;
            } else {
                name = emoji.aliases[0];
            }

            var index = recentEmojis.indexOf(name);
            if (index !== -1) {
                recentEmojis.splice(index, 1);
            }

            recentEmojis.push(name);

            if (recentEmojis.length > MAXIMUM_RECENT_EMOJI) {
                recentEmojis.splice(0, recentEmojis.length - MAXIMUM_RECENT_EMOJI);
            }

            localStorage.setItem(_constants2.default.RECENT_EMOJI_KEY, (0, _stringify2.default)(recentEmojis));
        }
    }, {
        key: 'getRecentEmojis',
        value: function getRecentEmojis() {
            var recentEmojis = void 0;
            try {
                recentEmojis = JSON.parse(localStorage.getItem(_constants2.default.RECENT_EMOJI_KEY));
            } catch (e) {
                // Errors are handled below
            }

            if (!recentEmojis) {
                return [];
            }

            if (recentEmojis.length > 0 && (0, _typeof3.default)(recentEmojis[0]) === 'object') {
                // Prior to PLT-7267, recent emojis were stored with the entire object for the emoji, but this
                // has been changed to store only the names of the emojis, so we need to change that
                recentEmojis = recentEmojis.map(function (emoji) {
                    return emoji.name || emoji.aliases[0];
                });
            }

            return recentEmojis;
        }
    }, {
        key: 'saveEmojiItems',
        value: function saveEmojiItems(emojiItems) {
            var loadedEmojis = this.getEmojiItems();
            if (loadedEmojis.length < emojiItems.length) {
                localStorage.setItem(LOADED_EMOJI_ITEMS, (0, _stringify2.default)(emojiItems));
            }
        }
    }, {
        key: 'getEmojiItems',
        value: function getEmojiItems() {
            var emojiItems = void 0;
            try {
                emojiItems = JSON.parse(localStorage.getItem(LOADED_EMOJI_ITEMS));
            } catch (e) {
                // Error is handled below
            }

            if (!emojiItems) {
                return [];
            }

            return emojiItems;
        }
    }, {
        key: 'hasUnicode',
        value: function hasUnicode(codepoint) {
            return Emoji.EmojiIndicesByUnicode.has(codepoint);
        }
    }, {
        key: 'getUnicode',
        value: function getUnicode(codepoint) {
            return Emoji.Emojis[Emoji.EmojiIndicesByUnicode.get(codepoint)];
        }
    }, {
        key: 'getEmojiImageUrl',
        value: function getEmojiImageUrl(emoji) {
            if (emoji.id) {
                return _client.Client4.getUrlVersion() + '/emoji/' + emoji.id + '/image';
            }

            var filename = emoji.filename || emoji.aliases[0];

            return _constants2.default.EMOJI_PATH + '/' + filename + '.png';
        }
    }, {
        key: 'handleEventPayload',
        value: function handleEventPayload(payload) {
            var action = payload.action;

            switch (action.type) {
                case ActionTypes.EMOJI_POSTED:
                    this.addRecentEmoji(action.alias);
                    this.emitChange();
                    break;
            }
        }
    }]);
    return EmojiStore;
}(_events2.default);

exports.default = new EmojiStore();

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

exports.isFavoriteChannel = isFavoriteChannel;
exports.isFavoriteChannelId = isFavoriteChannelId;
exports.sortChannelsByDisplayName = sortChannelsByDisplayName;
exports.getChannelDisplayName = getChannelDisplayName;
exports.canManageMembers = canManageMembers;
exports.getCountsStateFromStores = getCountsStateFromStores;
exports.findNextUnreadChannelId = findNextUnreadChannelId;

var _roles = __webpack_require__(276);

var _permissions = __webpack_require__(279);

var _permissions2 = _interopRequireDefault(_permissions);

var _channel_utils = __webpack_require__(854);

var ChannelUtilsRedux = _interopRequireWildcard(_channel_utils);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _localization_store = __webpack_require__(906);

var _localization_store2 = _interopRequireDefault(_localization_store);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFavoriteChannel(channel) {
    return _preference_store2.default.getBool(_constants.Preferences.CATEGORY_FAVORITE_CHANNEL, channel.id);
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function isFavoriteChannelId(channelId) {
    return _preference_store2.default.getBool(_constants.Preferences.CATEGORY_FAVORITE_CHANNEL, channelId);
}

function sortChannelsByDisplayName(a, b) {
    var locale = _localization_store2.default.getLocale();

    return ChannelUtilsRedux.sortChannelsByTypeAndDisplayName(locale, a, b);
}

var MAX_CHANNEL_NAME_LENGTH = 64;

function getChannelDisplayName(channel) {
    if (channel.type !== _constants2.default.GM_CHANNEL) {
        return channel.display_name;
    }

    var currentUser = _user_store2.default.getCurrentUser();

    if (currentUser) {
        var displayName = channel.display_name;
        if (displayName.length >= MAX_CHANNEL_NAME_LENGTH) {
            displayName += '...';
        }
        displayName = displayName.replace(currentUser.username + ', ', '').replace(currentUser.username, '').trim();
        if (displayName[displayName.length - 1] === ',') {
            return displayName.slice(0, -1);
        }
        return displayName;
    }

    return channel.display_name;
}

function canManageMembers(channel) {
    if (channel.type === _constants2.default.PRIVATE_CHANNEL) {
        return (0, _roles.haveIChannelPermission)(_redux_store2.default.getState(), {
            channel: channel.id,
            team: channel.team_id,
            permission: _permissions2.default.MANAGE_PRIVATE_CHANNEL_MEMBERS
        });
    }

    if (channel.type === _constants2.default.OPEN_CHANNEL) {
        return (0, _roles.haveIChannelPermission)(_redux_store2.default.getState(), {
            channel: channel.id,
            team: channel.team_id,
            permission: _permissions2.default.MANAGE_PUBLIC_CHANNEL_MEMBERS
        });
    }

    return true;
}

function getCountsStateFromStores() {
    var team = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _team_store2.default.getCurrent();
    var teamMembers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getMyTeamMembers();
    var unreadCounts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _channel_store2.default.getUnreadCounts();

    var mentionCount = 0;
    var messageCount = 0;

    teamMembers.forEach(function (member) {
        if (member.team_id !== _team_store2.default.getCurrentId()) {
            mentionCount += member.mention_count || 0;
            messageCount += member.msg_count || 0;
        }
    });

    (0, _keys2.default)(unreadCounts).forEach(function (chId) {
        var channel = _channel_store2.default.get(chId);

        if (channel && (channel.type === _constants2.default.DM_CHANNEL || channel.type === _constants2.default.GM_CHANNEL || channel.team_id === team.id)) {
            messageCount += unreadCounts[chId].msgs;
            mentionCount += unreadCounts[chId].mentions;
        }
    });

    return { mentionCount: mentionCount, messageCount: messageCount };
}

function findNextUnreadChannelId(curChannelId, allChannelIds, unreadChannelIds, direction) {
    var curIndex = allChannelIds.indexOf(curChannelId);

    for (var i = 1; i < allChannelIds.length; i++) {
        var index = Utils.mod(curIndex + i * direction, allChannelIds.length);

        if (unreadChannelIds.includes(allChannelIds[index])) {
            return index;
        }
    }

    return -1;
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants = __webpack_require__(29);

var _webrtc = __webpack_require__(1176);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var WebrtcStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(WebrtcStoreClass, _EventEmitter);

    function WebrtcStoreClass() {
        (0, _classCallCheck3.default)(this, WebrtcStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WebrtcStoreClass.__proto__ || (0, _getPrototypeOf2.default)(WebrtcStoreClass)).call(this));

        _this.video_call_with = null;
        return _this;
    }

    (0, _createClass3.default)(WebrtcStoreClass, [{
        key: 'setVideoCallWith',
        value: function setVideoCallWith(userId) {
            this.video_call_with = userId;
            this.emitBusy(userId !== null);
        }
    }, {
        key: 'getVideoCallWith',
        value: function getVideoCallWith() {
            return this.video_call_with;
        }
    }, {
        key: 'isBusy',
        value: function isBusy() {
            return this.video_call_with !== null;
        }
    }, {
        key: 'emitInit',
        value: function emitInit(userId, isCaller) {
            this.emit(_constants.WebrtcActionTypes.INITIALIZE, userId, isCaller);
            dispatch((0, _webrtc.initWebrtc)(userId, isCaller));
        }
    }, {
        key: 'addInitListener',
        value: function addInitListener(callback) {
            this.on(_constants.WebrtcActionTypes.INITIALIZE, callback);
        }
    }, {
        key: 'removeInitListener',
        value: function removeInitListener(callback) {
            this.removeListener(_constants.WebrtcActionTypes.INITIALIZE, callback);
        }
    }, {
        key: 'emitBusy',
        value: function emitBusy(isBusy) {
            this.emit(_constants.WebrtcActionTypes.BUSY, isBusy);
        }
    }, {
        key: 'addBusyListener',
        value: function addBusyListener(callback) {
            this.on(_constants.WebrtcActionTypes.BUSY, callback);
        }
    }, {
        key: 'removeBusyListener',
        value: function removeBusyListener(callback) {
            this.removeListener(_constants.WebrtcActionTypes.BUSY, callback);
        }
    }, {
        key: 'emitNotify',
        value: function emitNotify(message) {
            this.emit(_constants.WebrtcActionTypes.NOTIFY, message);
        }
    }, {
        key: 'addNotifyListener',
        value: function addNotifyListener(callback) {
            this.on(_constants.WebrtcActionTypes.NOTIFY, callback);
        }
    }, {
        key: 'removeNotifyListener',
        value: function removeNotifyListener(callback) {
            this.removeListener(_constants.WebrtcActionTypes.NOTIFY, callback);
        }
    }, {
        key: 'emitChanged',
        value: function emitChanged(message) {
            this.emit(_constants.WebrtcActionTypes.CHANGED, message);
        }
    }, {
        key: 'addChangedListener',
        value: function addChangedListener(callback) {
            this.on(_constants.WebrtcActionTypes.CHANGED, callback);
        }
    }, {
        key: 'removeChangedListener',
        value: function removeChangedListener(callback) {
            this.removeListener(_constants.WebrtcActionTypes.CHANGED, callback);
        }
    }]);
    return WebrtcStoreClass;
}(_events2.default);

var WebrtcStore = new WebrtcStoreClass();
WebrtcStore.setMaxListeners(0);

WebrtcStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case _constants.WebrtcActionTypes.INITIALIZE:
            WebrtcStore.emitInit(action.user_id, action.is_calling);
            break;
        case _constants.WebrtcActionTypes.NOTIFY:
            WebrtcStore.emitNotify(action.message);
            break;
        default:
            if (action.message) {
                WebrtcStore.emitChanged(action.message);
            }
            break;
    }
});

exports.default = WebrtcStore;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTeamMembersForUser = exports.getTeamsForUser = exports.inviteMembers = exports.addUsersToTeam = exports.updateTeamMemberRoles = exports.removeUserFromTeam = exports.updateTeam = exports.createTeam = exports.checkIfTeamExists = undefined;

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var checkIfTeamExists = exports.checkIfTeamExists = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(teamName, onSuccess, onError) {
        var _ref2, exists, err;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return TeamActions.checkIfTeamExists(teamName)(dispatch, getState);

                    case 2:
                        _ref2 = _context.sent;
                        exists = _ref2.data;
                        err = _ref2.error;

                        if (exists != null && onSuccess) {
                            onSuccess(exists);
                        } else if (err && onError) {
                            onError((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function checkIfTeamExists(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var createTeam = exports.createTeam = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(team, onSuccess, onError) {
        var _ref4, rteam, err;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return TeamActions.createTeam(team)(dispatch, getState);

                    case 2:
                        _ref4 = _context2.sent;
                        rteam = _ref4.data;
                        err = _ref4.error;

                        if (rteam && onSuccess) {
                            onSuccess(rteam);
                        } else if (err && onError) {
                            onError((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function createTeam(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}();

var updateTeam = exports.updateTeam = function () {
    var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(team, onSuccess, onError) {
        var _ref6, rteam, err;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return TeamActions.updateTeam(team)(dispatch, getState);

                    case 2:
                        _ref6 = _context3.sent;
                        rteam = _ref6.data;
                        err = _ref6.error;

                        if (rteam && onSuccess) {
                            onSuccess(rteam);
                        } else if (err && onError) {
                            onError((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function updateTeam(_x7, _x8, _x9) {
        return _ref5.apply(this, arguments);
    };
}();

var removeUserFromTeam = exports.removeUserFromTeam = function () {
    var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(teamId, userId, success, error) {
        var _ref8, data, err;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return TeamActions.removeUserFromTeam(teamId, userId)(dispatch, getState);

                    case 2:
                        _ref8 = _context4.sent;
                        data = _ref8.data;
                        err = _ref8.error;

                        (0, _users.getUser)(userId)(dispatch, getState);
                        TeamActions.getTeamStats(teamId)(dispatch, getState);
                        (0, _channels.getChannelStats)(_channel_store2.default.getCurrentId())(dispatch, getState);

                        if (data && success) {
                            success();
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 9:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function removeUserFromTeam(_x10, _x11, _x12, _x13) {
        return _ref7.apply(this, arguments);
    };
}();

var updateTeamMemberRoles = exports.updateTeamMemberRoles = function () {
    var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(teamId, userId, newRoles, success, error) {
        var _ref10, data, err;

        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return TeamActions.updateTeamMemberRoles(teamId, userId, newRoles)(dispatch, getState);

                    case 2:
                        _ref10 = _context5.sent;
                        data = _ref10.data;
                        err = _ref10.error;

                        if (data && success) {
                            success();
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function updateTeamMemberRoles(_x14, _x15, _x16, _x17, _x18) {
        return _ref9.apply(this, arguments);
    };
}();

var addUsersToTeam = exports.addUsersToTeam = function () {
    var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(teamId, userIds, success, error) {
        var _ref14, teamMembers, err;

        return _regenerator2.default.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return TeamActions.addUsersToTeam(teamId, userIds)(dispatch, getState);

                    case 2:
                        _ref14 = _context7.sent;
                        teamMembers = _ref14.data;
                        err = _ref14.error;

                        (0, _channels.getChannelStats)(_channel_store2.default.getCurrentId())(dispatch, getState);
                        if (teamMembers && success) {
                            success(teamMembers);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 7:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function addUsersToTeam(_x20, _x21, _x22, _x23) {
        return _ref13.apply(this, arguments);
    };
}();

var inviteMembers = exports.inviteMembers = function () {
    var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(data, success, error) {
        var emails, _ref16, result, err;

        return _regenerator2.default.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        if (!data.invites) {
                            success();
                        }
                        emails = [];

                        data.invites.forEach(function (i) {
                            emails.push(i.email);
                        });
                        _context8.next = 5;
                        return TeamActions.sendEmailInvitesToTeam(_team_store2.default.getCurrentId(), emails)(dispatch, getState);

                    case 5:
                        _ref16 = _context8.sent;
                        result = _ref16.data;
                        err = _ref16.error;

                        if (result && success) {
                            success();
                        } else if (result == null && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 9:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function inviteMembers(_x24, _x25, _x26) {
        return _ref15.apply(this, arguments);
    };
}();

var getTeamsForUser = exports.getTeamsForUser = function () {
    var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(userId, success, error) {
        var _ref18, data, err;

        return _regenerator2.default.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.next = 2;
                        return TeamActions.getTeamsForUser(userId)(dispatch, getState);

                    case 2:
                        _ref18 = _context9.sent;
                        data = _ref18.data;
                        err = _ref18.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function getTeamsForUser(_x27, _x28, _x29) {
        return _ref17.apply(this, arguments);
    };
}();

var getTeamMembersForUser = exports.getTeamMembersForUser = function () {
    var _ref19 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(userId, success, error) {
        var _ref20, data, err;

        return _regenerator2.default.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        _context10.next = 2;
                        return TeamActions.getTeamMembersForUser(userId)(dispatch, getState);

                    case 2:
                        _ref20 = _context10.sent;
                        data = _ref20.data;
                        err = _ref20.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function getTeamMembersForUser(_x30, _x31, _x32) {
        return _ref19.apply(this, arguments);
    };
}();

exports.addUserToTeamFromInvite = addUserToTeamFromInvite;
exports.getInviteInfo = getInviteInfo;
exports.switchTeams = switchTeams;

var _action_types = __webpack_require__(3);

var _channels = __webpack_require__(798);

var _teams = __webpack_require__(816);

var TeamActions = _interopRequireWildcard(_teams);

var _users = __webpack_require__(786);

var _client = __webpack_require__(270);

var _browser_history = __webpack_require__(273);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

function addUserToTeamFromInvite(data, hash, inviteId, success, error) {
    var _this = this;

    _client.Client4.addToTeamFromInvite(hash, data, inviteId).then(function () {
        var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(member) {
            var _ref12, team;

            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return TeamActions.getTeam(member.team_id)(dispatch, getState);

                        case 2:
                            _ref12 = _context6.sent;
                            team = _ref12.data;

                            dispatch({
                                type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                                data: (0, _extends3.default)({}, member, {
                                    delete_at: 0,
                                    msg_count: 0,
                                    mention_count: 0
                                })
                            });

                            if (success) {
                                success(team);
                            }

                        case 6:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this);
        }));

        return function (_x19) {
            return _ref11.apply(this, arguments);
        };
    }()).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function getInviteInfo(inviteId, success, error) {
    _client.Client4.getTeamInviteInfo(inviteId).then(function (inviteData) {
        if (success) {
            success(inviteData);
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function switchTeams(url) {
    (0, _channels.viewChannel)(_channel_store2.default.getCurrentId())(dispatch, getState);
    _browser_history.browserHistory.push(url);
}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Initialize a jQuery object
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(812),
	__webpack_require__(807),
	__webpack_require__(1110),

	__webpack_require__(1111)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, isFunction, rsingleTag ) {

"use strict";

// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );

return init;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1642), __esModule: true };

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1311);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _pluggable = __webpack_require__(881);

var _pluggable2 = _interopRequireDefault(_pluggable);

var _profile_popover = __webpack_require__(1028);

var _profile_popover2 = _interopRequireDefault(_profile_popover);

var _status_icon = __webpack_require__(932);

var _status_icon2 = _interopRequireDefault(_status_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ProfilePicture = function (_React$PureComponent) {
    (0, _inherits3.default)(ProfilePicture, _React$PureComponent);

    function ProfilePicture() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ProfilePicture);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProfilePicture.__proto__ || (0, _getPrototypeOf2.default)(ProfilePicture)).call.apply(_ref, [this].concat(args))), _this), _this.hideProfilePopover = function () {
            _this.refs.overlay.hide();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ProfilePicture, [{
        key: 'render',
        value: function render() {
            if (this.props.user) {
                return _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        ref: 'overlay',
                        trigger: 'click',
                        placement: 'right',
                        rootClose: true,
                        overlay: _react2.default.createElement(
                            _pluggable2.default,
                            null,
                            _react2.default.createElement(_profile_popover2.default, {
                                user: this.props.user,
                                src: this.props.src,
                                status: this.props.status,
                                isBusy: this.props.isBusy,
                                hide: this.hideProfilePopover,
                                isRHS: this.props.isRHS,
                                hasMention: this.props.hasMention
                            })
                        )
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'status-wrapper' },
                        _react2.default.createElement('img', {
                            className: 'more-modal__image',
                            alt: (this.props.user.username || 'user') + ' profile image',
                            width: this.props.width,
                            height: this.props.width,
                            src: this.props.src
                        }),
                        _react2.default.createElement(_status_icon2.default, { status: this.props.status })
                    )
                );
            }
            return _react2.default.createElement(
                'span',
                { className: 'status-wrapper' },
                _react2.default.createElement('img', {
                    className: 'more-modal__image',
                    alt: 'user profile image',
                    width: this.props.width,
                    height: this.props.width,
                    src: this.props.src
                }),
                _react2.default.createElement(_status_icon2.default, { status: this.props.status })
            );
        }
    }]);
    return ProfilePicture;
}(_react2.default.PureComponent);

ProfilePicture.defaultProps = {
    width: '36',
    height: '36',
    isRHS: false,
    hasMention: false
};
ProfilePicture.propTypes = {
    src: _propTypes2.default.string.isRequired,
    status: _propTypes2.default.string,
    width: _propTypes2.default.string,
    height: _propTypes2.default.string,
    user: _propTypes2.default.object,
    isBusy: _propTypes2.default.bool,
    isRHS: _propTypes2.default.bool,
    hasMention: _propTypes2.default.bool
};
exports.default = ProfilePicture;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SettingItemMin = function (_React$PureComponent) {
    (0, _inherits3.default)(SettingItemMin, _React$PureComponent);

    function SettingItemMin() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SettingItemMin);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SettingItemMin.__proto__ || (0, _getPrototypeOf2.default)(SettingItemMin)).call.apply(_ref, [this].concat(args))), _this), _this.getEdit = function (node) {
            _this.edit = node;
        }, _this.handleUpdateSection = function (e) {
            e.preventDefault();
            _this.props.updateSection(_this.props.section);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SettingItemMin, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.focused && this.edit) {
                this.edit.focus();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.focused && this.edit) {
                this.edit.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var editButton = null;
            var describeSection = null;

            if (!this.props.disableOpen && (0, _utils.isMobile)()) {
                editButton = _react2.default.createElement(
                    'li',
                    { className: 'col-xs-12 col-sm-3 section-edit' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: this.props.section + 'Edit',
                            className: 'color--link cursor--pointer style--none',
                            onClick: this.handleUpdateSection,
                            ref: this.getEdit
                        },
                        _react2.default.createElement('i', { className: 'fa fa-pencil' }),
                        this.props.describe
                    )
                );
            } else if (!this.props.disableOpen) {
                editButton = _react2.default.createElement(
                    'li',
                    { className: 'col-xs-12 col-sm-3 section-edit' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: this.props.section + 'Edit',
                            className: 'color--link cursor--pointer style--none text-left',
                            onClick: this.handleUpdateSection,
                            ref: this.getEdit
                        },
                        _react2.default.createElement('i', { className: 'fa fa-pencil' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'setting_item_min.edit',
                            defaultMessage: 'Edit'
                        })
                    )
                );

                describeSection = _react2.default.createElement(
                    'li',
                    {
                        id: this.props.section + 'Desc',
                        className: 'col-xs-12 section-describe'
                    },
                    this.props.describe
                );
            }

            return _react2.default.createElement(
                'ul',
                {
                    className: 'section-min',
                    onClick: this.handleUpdateSection
                },
                _react2.default.createElement(
                    'li',
                    {
                        id: this.props.section + 'Title',
                        className: 'col-xs-12 col-sm-9 section-title'
                    },
                    this.props.title
                ),
                editButton,
                describeSection
            );
        }
    }]);
    return SettingItemMin;
}(_react2.default.PureComponent);

SettingItemMin.defaultProps = {
    section: '',
    focused: false
};
SettingItemMin.propTypes = {

    /**
     * Settings title
     */
    title: _propTypes2.default.node,

    /**
     * Option to disable opening the setting
     */
    disableOpen: _propTypes2.default.bool,

    /**
     * Indicates whether the focus should be on the "Edit" button
     */
    focused: _propTypes2.default.bool,

    /**
     * Settings or tab section
     */
    section: _propTypes2.default.string,

    /**
     * Function to update section
     */
    updateSection: _propTypes2.default.func,

    /**
     * Settings description
     */
    describe: _propTypes2.default.node
};
exports.default = SettingItemMin;

/***/ }),
/* 839 */,
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2288)();
}


/***/ }),
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1114)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Data ) {
	"use strict";

	return new Data();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1658);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__(878);

var _isPlaceholder = /*#__PURE__*/__webpack_require__(948);

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}
module.exports = _curry2;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ActionTypes = _constants2.default.ActionTypes;

var CHANGE_EVENT = 'change';

var ErrorStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(ErrorStoreClass, _EventEmitter);

    function ErrorStoreClass() {
        (0, _classCallCheck3.default)(this, ErrorStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ErrorStoreClass.__proto__ || (0, _getPrototypeOf2.default)(ErrorStoreClass)).call(this));

        _this.emitChange = _this.emitChange.bind(_this);
        _this.addChangeListener = _this.addChangeListener.bind(_this);
        _this.removeChangeListener = _this.removeChangeListener.bind(_this);
        _this.getLastError = _this.getLastError.bind(_this);
        _this.storeLastError = _this.storeLastError.bind(_this);
        _this.getIgnoreNotification = _this.getIgnoreNotification.bind(_this);
        _this.ignore_notification = false;
        return _this;
    }

    (0, _createClass3.default)(ErrorStoreClass, [{
        key: 'getIgnoreNotification',
        value: function getIgnoreNotification() {
            return this.ignore_notification;
        }
    }, {
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'getLastError',
        value: function getLastError() {
            return _browser_store2.default.getGlobalItem('last_error');
        }
    }, {
        key: 'storeLastError',
        value: function storeLastError(error) {
            _browser_store2.default.setGlobalItem('last_error', error);
        }
    }, {
        key: 'getConnectionErrorCount',
        value: function getConnectionErrorCount() {
            var count = _browser_store2.default.getGlobalItem('last_error_conn');

            if (count == null) {
                return 0;
            }

            return count;
        }
    }, {
        key: 'setConnectionErrorCount',
        value: function setConnectionErrorCount(count) {
            _browser_store2.default.setGlobalItem('last_error_conn', count);
        }
    }, {
        key: 'clearError',
        value: function clearError(message) {
            var lastError = this.getLastError();

            if (lastError && lastError.message === message) {
                this.clearLastError(true);
            }
        }
    }, {
        key: 'clearLastError',
        value: function clearLastError(force) {
            var lastError = this.getLastError();

            // preview message can only be cleared by clearNotificationError
            if (!force && lastError && lastError.notification) {
                return;
            }

            _browser_store2.default.removeGlobalItem('last_error');
            _browser_store2.default.removeGlobalItem('last_error_conn');
            if (lastError) {
                this.emitChange();
            }
        }
    }, {
        key: 'clearNotificationError',
        value: function clearNotificationError() {
            this.ignore_notification = true;
            this.storeLastError('');
            this.clearLastError();
        }
    }]);
    return ErrorStoreClass;
}(_events2.default);

var ErrorStore = new ErrorStoreClass();

ErrorStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;
    switch (action.type) {
        case ActionTypes.RECEIVED_ERROR:
            ErrorStore.storeLastError(action.err);
            ErrorStore.emitChange();
            break;

        default:
    }
});

exports.default = ErrorStore;

window.ErrorStore = ErrorStore;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Suggestion = function (_React$Component) {
    (0, _inherits3.default)(Suggestion, _React$Component);
    (0, _createClass3.default)(Suggestion, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                item: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
                term: _propTypes2.default.string.isRequired,
                matchedPretext: _propTypes2.default.string.isRequired,
                isSelection: _propTypes2.default.bool,
                onClick: _propTypes2.default.func
            };
        }
    }]);

    function Suggestion(props) {
        (0, _classCallCheck3.default)(this, Suggestion);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Suggestion.__proto__ || (0, _getPrototypeOf2.default)(Suggestion)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Suggestion, [{
        key: 'handleClick',
        value: function handleClick(e) {
            e.preventDefault();

            this.props.onClick(this.props.term, this.props.matchedPretext);
        }
    }]);
    return Suggestion;
}(_react2.default.Component);

exports.default = Suggestion;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ModalStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(ModalStoreClass, _EventEmitter);

    function ModalStoreClass() {
        (0, _classCallCheck3.default)(this, ModalStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ModalStoreClass.__proto__ || (0, _getPrototypeOf2.default)(ModalStoreClass)).call(this));

        _this.addModalListener = function (action, callback) {
            _this.on(action, callback);
        };

        _this.removeModalListener = function (action, callback) {
            _this.removeListener(action, callback);
        };

        _this.handleEventPayload = function (payload) {
            // toggle event handlers should accept a boolean show/hide value and can accept a map of arguments
            var _payload$action = payload.action,
                type = _payload$action.type,
                value = _payload$action.value,
                args = (0, _objectWithoutProperties3.default)(_payload$action, ['type', 'value']); //eslint-disable-line no-use-before-define

            switch (type) {
                case ActionTypes.TOGGLE_ACCOUNT_SETTINGS_MODAL:
                case ActionTypes.TOGGLE_SHORTCUTS_MODAL:
                case ActionTypes.TOGGLE_IMPORT_THEME_MODAL:
                case ActionTypes.TOGGLE_INVITE_MEMBER_MODAL:
                case ActionTypes.TOGGLE_LEAVE_TEAM_MODAL:
                case ActionTypes.TOGGLE_DELETE_POST_MODAL:
                case ActionTypes.TOGGLE_GET_POST_LINK_MODAL:
                case ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL:
                case ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL:
                case ActionTypes.TOGGLE_QUICK_SWITCH_MODAL:
                case ActionTypes.TOGGLE_CHANNEL_HEADER_UPDATE_MODAL:
                case ActionTypes.TOGGLE_CHANNEL_PURPOSE_UPDATE_MODAL:
                case ActionTypes.TOGGLE_CHANNEL_NAME_UPDATE_MODAL:
                case ActionTypes.TOGGLE_LEAVE_PRIVATE_CHANNEL_MODAL:
                    _this.emit(type, value, args);
                    break;
            }
        };

        _this.dispatchToken = _app_dispatcher2.default.register(_this.handleEventPayload);
        return _this;
    }

    return ModalStoreClass;
}(_events2.default);

var ModalStore = new ModalStoreClass();
exports.default = ModalStore;

/***/ }),
/* 850 */,
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/5d6be4015bde2a4e0358c8bc110deadc.png";

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var BackButton = function (_React$PureComponent) {
    (0, _inherits3.default)(BackButton, _React$PureComponent);

    function BackButton() {
        (0, _classCallCheck3.default)(this, BackButton);
        return (0, _possibleConstructorReturn3.default)(this, (BackButton.__proto__ || (0, _getPrototypeOf2.default)(BackButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(BackButton, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'signup-header' },
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        onClick: this.props.onClick,
                        to: this.props.url
                    },
                    _react2.default.createElement('span', { className: 'fa fa-chevron-left' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'web.header.back',
                        defaultMessage: 'Back'
                    })
                )
            );
        }
    }]);
    return BackButton;
}(_react2.default.PureComponent);

BackButton.propTypes = {

    /**
     * URL to return to
     */
    url: _propTypes2.default.string,

    /**
     * An optional click handler that will trigger when the user clicks on the back button
     */
    onClick: _propTypes2.default.func
};
BackButton.defaultProps = {
    url: '/'
};
exports.default = BackButton;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.systemEmojis = undefined;
exports.setSystemEmojis = setSystemEmojis;
exports.createCustomEmoji = createCustomEmoji;
exports.getCustomEmoji = getCustomEmoji;
exports.getCustomEmojiByName = getCustomEmojiByName;
exports.getCustomEmojisByName = getCustomEmojisByName;
exports.getCustomEmojisInText = getCustomEmojisInText;
exports.getCustomEmojis = getCustomEmojis;
exports.getAllCustomEmojis = getAllCustomEmojis;
exports.deleteCustomEmoji = deleteCustomEmoji;
exports.searchCustomEmojis = searchCustomEmojis;
exports.autocompleteCustomEmojis = autocompleteCustomEmojis;

var _reduxBatchedActions = __webpack_require__(278);

var _client = __webpack_require__(270);

var _action_types = __webpack_require__(3);

var _constants = __webpack_require__(19);

var _users = __webpack_require__(786);

var _emojis = __webpack_require__(877);

var _emoji_utils = __webpack_require__(1015);

var _helpers = __webpack_require__(117);

var _errors = __webpack_require__(828);

var _helpers2 = __webpack_require__(821);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


var systemEmojis = exports.systemEmojis = new Map();

function setSystemEmojis(emojis) {
    exports.systemEmojis = systemEmojis = emojis;
}

function createCustomEmoji(emoji, image) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.createCustomEmoji, _action_types.EmojiTypes.CREATE_CUSTOM_EMOJI_REQUEST, [_action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJI, _action_types.EmojiTypes.CREATE_CUSTOM_EMOJI_SUCCESS], _action_types.EmojiTypes.CREATE_CUSTOM_EMOJI_FAILURE, emoji, image);
}

function getCustomEmoji(emojiId) {
    return (0, _helpers2.bindClientFunc)(_client.Client4.getCustomEmoji, _action_types.EmojiTypes.GET_CUSTOM_EMOJI_REQUEST, [_action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJI, _action_types.EmojiTypes.GET_CUSTOM_EMOJI_SUCCESS], _action_types.EmojiTypes.GET_CUSTOM_EMOJI_FAILURE, emojiId);
}

function getCustomEmojiByName(name) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var serverVersion, data, actions;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            serverVersion = _client.Client4.getServerVersion();

                            if ((0, _helpers.isMinimumServerVersion)(serverVersion, 4, 7)) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt('return', { data: {} });

                        case 3:

                            dispatch({ type: _action_types.EmojiTypes.GET_CUSTOM_EMOJI_REQUEST, data: null }, getState);

                            data = void 0;
                            _context.prev = 5;
                            _context.next = 8;
                            return _client.Client4.getCustomEmojiByName(name);

                        case 8:
                            data = _context.sent;
                            _context.next = 18;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](5);

                            (0, _helpers2.forceLogoutIfNecessary)(_context.t0, dispatch, getState);

                            actions = [{ type: _action_types.EmojiTypes.GET_CUSTOM_EMOJI_FAILURE, error: _context.t0 }];


                            if (_context.t0.status_code === 404) {
                                actions.push({ type: _action_types.EmojiTypes.CUSTOM_EMOJI_DOES_NOT_EXIST, data: name });
                            } else {
                                dispatch((0, _errors.logError)(_context.t0));
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);
                            return _context.abrupt('return', { error: _context.t0 });

                        case 18:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJI,
                                data: data
                            }, {
                                type: _action_types.EmojiTypes.GET_CUSTOM_EMOJI_SUCCESS
                            }]));

                            return _context.abrupt('return', { data: data });

                        case 20:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[5, 11]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function getCustomEmojisByName(names) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var promises;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(!names || names.length === 0)) {
                                _context2.next = 2;
                                break;
                            }

                            return _context2.abrupt('return', { data: true });

                        case 2:
                            promises = [];

                            names.forEach(function (name) {
                                return promises.push(getCustomEmojiByName(name)(dispatch, getState));
                            });

                            _context2.next = 6;
                            return Promise.all(promises);

                        case 6:
                            return _context2.abrupt('return', { data: true });

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function getCustomEmojisInText(text) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var state, nonExistentEmoji, customEmojisByName, emojisToLoad;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (text) {
                                _context3.next = 2;
                                break;
                            }

                            return _context3.abrupt('return', { data: true });

                        case 2:
                            state = getState();
                            nonExistentEmoji = state.entities.emojis.nonExistentEmoji;
                            customEmojisByName = (0, _emojis.getCustomEmojisByName)(state);
                            emojisToLoad = (0, _emoji_utils.parseNeededCustomEmojisFromText)(text, systemEmojis, customEmojisByName, nonExistentEmoji);
                            _context3.next = 8;
                            return getCustomEmojisByName(Array.from(emojisToLoad))(dispatch, getState);

                        case 8:
                            return _context3.abrupt('return', _context3.sent);

                        case 9:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function getCustomEmojis() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PAGE_SIZE_DEFAULT;

    var _this4 = this;

    var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.Emoji.SORT_BY_NAME;
    var loadUsers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var data, usersToLoad, userIds;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_REQUEST, data: {} }, getState);

                            data = void 0;
                            _context4.prev = 2;
                            _context4.next = 5;
                            return _client.Client4.getCustomEmojis(page, perPage, sort);

                        case 5:
                            data = _context4.sent;
                            _context4.next = 13;
                            break;

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](2);

                            (0, _helpers2.forceLogoutIfNecessary)(_context4.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', { error: _context4.t0 });

                        case 13:

                            if (loadUsers) {
                                usersToLoad = {};

                                Object.keys(data).forEach(function (key) {
                                    var emoji = data[key];
                                    if (!getState().entities.users.profiles[emoji.creator_id]) {
                                        usersToLoad[emoji.creator_id] = true;
                                    }
                                });

                                userIds = Object.keys(usersToLoad);


                                if (userIds.length > 0) {
                                    (0, _users.getProfilesByIds)(userIds)(dispatch, getState);
                                }
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJIS,
                                data: data
                            }, {
                                type: _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_SUCCESS,
                                data: {}
                            }]));

                            return _context4.abrupt('return', { data: data });

                        case 16:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[2, 8]]);
        }));

        return function (_x11, _x12) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function getAllCustomEmojis() {
    var _this5 = this;

    var perPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.General.PAGE_SIZE_MAXIMUM;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var hasMore, page, allEmojis, serverVersion, emojis;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.GET_ALL_CUSTOM_EMOJIS_REQUEST }, { type: _action_types.EmojiTypes.CLEAR_CUSTOM_EMOJIS }]), getState);

                            hasMore = true;
                            page = 0;
                            allEmojis = [];
                            serverVersion = getState().entities.general.serverVersion;

                        case 5:
                            _context5.prev = 5;
                            emojis = [];

                            if (!(serverVersion.charAt(0) === '3')) {
                                _context5.next = 14;
                                break;
                            }

                            _context5.next = 10;
                            return _client.Client.getCustomEmojis();

                        case 10:
                            emojis = _context5.sent;

                            hasMore = false;
                            _context5.next = 19;
                            break;

                        case 14:
                            _context5.next = 16;
                            return _client.Client4.getCustomEmojis(page, perPage, _constants.Emoji.SORT_BY_NAME);

                        case 16:
                            emojis = _context5.sent;

                            if (emojis.length < perPage) {
                                hasMore = false;
                            } else {
                                page += 1;
                            }
                            allEmojis.push.apply(allEmojis, _toConsumableArray(emojis));

                        case 19:
                            _context5.next = 26;
                            break;

                        case 21:
                            _context5.prev = 21;
                            _context5.t0 = _context5['catch'](5);

                            (0, _helpers2.forceLogoutIfNecessary)(_context5.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.GET_ALL_CUSTOM_EMOJIS_FAILURE, error: _context5.t0 }, (0, _errors.logError)(_context5.t0)(dispatch)]), getState);
                            return _context5.abrupt('return', { error: true });

                        case 26:
                            if (hasMore) {
                                _context5.next = 5;
                                break;
                            }

                        case 27:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.GET_ALL_CUSTOM_EMOJIS_SUCCESS }, {
                                type: _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJIS,
                                data: allEmojis
                            }]), getState);

                            return _context5.abrupt('return', { data: true });

                        case 29:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[5, 21]]);
        }));

        return function (_x14, _x15) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function deleteCustomEmoji(emojiId) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.EmojiTypes.DELETE_CUSTOM_EMOJI_REQUEST, data: {} }, getState);

                            _context6.prev = 1;
                            _context6.next = 4;
                            return _client.Client4.deleteCustomEmoji(emojiId);

                        case 4:
                            _context6.next = 11;
                            break;

                        case 6:
                            _context6.prev = 6;
                            _context6.t0 = _context6['catch'](1);

                            (0, _helpers2.forceLogoutIfNecessary)(_context6.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.DELETE_CUSTOM_EMOJI_FAILURE, error: _context6.t0 }, (0, _errors.logError)(_context6.t0)(dispatch)]), getState);
                            return _context6.abrupt('return', { error: _context6.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.EmojiTypes.DELETED_CUSTOM_EMOJI,
                                data: { id: emojiId }
                            }, {
                                type: _action_types.EmojiTypes.DELETE_CUSTOM_EMOJI_SUCCESS
                            }]), getState);

                            return _context6.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[1, 6]]);
        }));

        return function (_x16, _x17) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function searchCustomEmojis(term) {
    var _this7 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var serverVersion, data;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            serverVersion = _client.Client4.getServerVersion();

                            if ((0, _helpers.isMinimumServerVersion)(serverVersion, 4, 7)) {
                                _context7.next = 3;
                                break;
                            }

                            return _context7.abrupt('return', { data: [] });

                        case 3:

                            dispatch({ type: _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_REQUEST, data: null }, getState);

                            data = void 0;
                            _context7.prev = 5;
                            _context7.next = 8;
                            return _client.Client4.searchCustomEmoji(term, options);

                        case 8:
                            data = _context7.sent;
                            _context7.next = 16;
                            break;

                        case 11:
                            _context7.prev = 11;
                            _context7.t0 = _context7['catch'](5);

                            (0, _helpers2.forceLogoutIfNecessary)(_context7.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_FAILURE, error: _context7.t0 }, (0, _errors.logError)(_context7.t0)(dispatch)]), getState);
                            return _context7.abrupt('return', { error: _context7.t0 });

                        case 16:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJIS,
                                data: data
                            }, {
                                type: _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_SUCCESS
                            }]), getState);

                            return _context7.abrupt('return', { data: data });

                        case 18:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[5, 11]]);
        }));

        return function (_x19, _x20) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function autocompleteCustomEmojis(name) {
    var _this8 = this;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var serverVersion, data;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            serverVersion = _client.Client4.getServerVersion();

                            if ((0, _helpers.isMinimumServerVersion)(serverVersion, 4, 7)) {
                                _context8.next = 3;
                                break;
                            }

                            return _context8.abrupt('return', { data: [] });

                        case 3:

                            dispatch({ type: _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_REQUEST, data: null }, getState);

                            data = void 0;
                            _context8.prev = 5;
                            _context8.next = 8;
                            return _client.Client4.autocompleteCustomEmoji(name);

                        case 8:
                            data = _context8.sent;
                            _context8.next = 16;
                            break;

                        case 11:
                            _context8.prev = 11;
                            _context8.t0 = _context8['catch'](5);

                            (0, _helpers2.forceLogoutIfNecessary)(_context8.t0, dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_FAILURE, error: _context8.t0 }, (0, _errors.logError)(_context8.t0)(dispatch)]), getState);
                            return _context8.abrupt('return', { error: _context8.t0 });

                        case 16:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJIS,
                                data: data
                            }, {
                                type: _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_SUCCESS
                            }]), getState);

                            return _context8.abrupt('return', { data: data });

                        case 18:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8, [[5, 11]]);
        }));

        return function (_x21, _x22) {
            return _ref8.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _channelTypeOrder;

exports.buildDisplayableChannelList = buildDisplayableChannelList;
exports.buildDisplayableChannelListWithUnreadSection = buildDisplayableChannelListWithUnreadSection;
exports.completeDirectChannelInfo = completeDirectChannelInfo;
exports.completeDirectChannelDisplayName = completeDirectChannelDisplayName;
exports.cleanUpUrlable = cleanUpUrlable;
exports.getChannelByName = getChannelByName;
exports.getDirectChannelName = getDirectChannelName;
exports.getUserIdFromChannelName = getUserIdFromChannelName;
exports.isAutoClosed = isAutoClosed;
exports.isDirectChannel = isDirectChannel;
exports.isDirectChannelVisible = isDirectChannelVisible;
exports.isGroupChannel = isGroupChannel;
exports.isGroupChannelVisible = isGroupChannelVisible;
exports.isGroupOrDirectChannelVisible = isGroupOrDirectChannelVisible;
exports.showCreateOption = showCreateOption;
exports.showManagementOptions = showManagementOptions;
exports.showDeleteOption = showDeleteOption;
exports.canManageMembersOldPermissions = canManageMembersOldPermissions;
exports.getChannelsIdForTeam = getChannelsIdForTeam;
exports.getGroupDisplayNameFromUserIds = getGroupDisplayNameFromUserIds;
exports.isFavoriteChannel = isFavoriteChannel;
exports.isDefault = isDefault;
exports.isOpenChannel = isOpenChannel;
exports.isPrivateChannel = isPrivateChannel;
exports.sortChannelsByTypeAndDisplayName = sortChannelsByTypeAndDisplayName;
exports.sortChannelsByDisplayName = sortChannelsByDisplayName;
exports.sortChannelsByDisplayNameAndMuted = sortChannelsByDisplayNameAndMuted;
exports.isChannelMuted = isChannelMuted;

var _constants = __webpack_require__(19);

var _user_utils = __webpack_require__(175);

var _preference_utils = __webpack_require__(284);

var _general = __webpack_require__(113);

var _roles = __webpack_require__(276);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var channelTypeOrder = (_channelTypeOrder = {}, _defineProperty(_channelTypeOrder, _constants.General.OPEN_CHANNEL, 0), _defineProperty(_channelTypeOrder, _constants.General.PRIVATE_CHANNEL, 1), _defineProperty(_channelTypeOrder, _constants.General.DM_CHANNEL, 2), _defineProperty(_channelTypeOrder, _constants.General.GM_CHANNEL, 2), _channelTypeOrder);

/**
 * Returns list of sorted channels grouped by type. Favorites here is considered as separated type.
 *
 * Example: {
 *  publicChannels: [...],
 *  privateChannels: [...],
 *  directAndGroupChannels: [...],
 *  favoriteChannels: [...]
 * }
 */
function buildDisplayableChannelList(usersState, allChannels, myMembers, config, myPreferences, teammateNameDisplay, lastPosts) {
    var missingDirectChannels = createMissingDirectChannels(usersState.currentUserId, allChannels, myPreferences);

    var currentUserId = usersState.currentUserId,
        profiles = usersState.profiles;

    var locale = getUserLocale(currentUserId, profiles);

    var channels = buildChannels(usersState, allChannels, missingDirectChannels, teammateNameDisplay, locale);
    var favoriteChannels = buildFavoriteChannels(channels, myPreferences, locale);
    var notFavoriteChannels = buildNotFavoriteChannels(channels, myPreferences);
    var directAndGroupChannels = buildDirectAndGroupChannels(notFavoriteChannels, myMembers, config, myPreferences, currentUserId, profiles, lastPosts);

    return {
        favoriteChannels: favoriteChannels,
        publicChannels: notFavoriteChannels.filter(isOpenChannel),
        privateChannels: notFavoriteChannels.filter(isPrivateChannel),
        directAndGroupChannels: directAndGroupChannels
    };
}

function buildDisplayableChannelListWithUnreadSection(usersState, myChannels, myMembers, config, myPreferences, teammateNameDisplay, lastPosts) {
    var currentUserId = usersState.currentUserId,
        profiles = usersState.profiles;

    var locale = getUserLocale(currentUserId, profiles);

    var missingDirectChannels = createMissingDirectChannels(currentUserId, myChannels, myPreferences);
    var channels = buildChannels(usersState, myChannels, missingDirectChannels, teammateNameDisplay, locale);
    var unreadChannels = [].concat(_toConsumableArray(buildChannelsWithMentions(channels, myMembers, locale)), _toConsumableArray(buildUnreadChannels(channels, myMembers, locale)));
    var notUnreadChannels = channels.filter(not(isUnreadChannel.bind(null, myMembers)));
    var favoriteChannels = buildFavoriteChannels(notUnreadChannels, myPreferences, locale);
    var notFavoriteChannels = buildNotFavoriteChannels(notUnreadChannels, myPreferences);
    var directAndGroupChannels = buildDirectAndGroupChannels(notFavoriteChannels, myMembers, config, myPreferences, currentUserId, profiles, lastPosts);

    return {
        unreadChannels: unreadChannels,
        favoriteChannels: favoriteChannels,
        publicChannels: notFavoriteChannels.filter(isOpenChannel),
        privateChannels: notFavoriteChannels.filter(isPrivateChannel),
        directAndGroupChannels: directAndGroupChannels
    };
}

function completeDirectChannelInfo(usersState, teammateNameDisplay, channel) {
    if (isDirectChannel(channel)) {
        var dmChannelClone = _extends({}, channel);
        var teammateId = getUserIdFromChannelName(usersState.currentUserId, channel.name);

        return Object.assign(dmChannelClone, {
            display_name: (0, _user_utils.displayUsername)(usersState.profiles[teammateId], teammateNameDisplay),
            teammate_id: teammateId,
            status: usersState.statuses[teammateId] || 'offline'
        });
    } else if (isGroupChannel(channel)) {
        return completeDirectGroupInfo(usersState, teammateNameDisplay, channel);
    }

    return channel;
}

function completeDirectChannelDisplayName(currentUserId, profiles, teammateNameDisplay, channel) {
    if (isDirectChannel(channel)) {
        var dmChannelClone = _extends({}, channel);
        var teammateId = getUserIdFromChannelName(currentUserId, channel.name);

        return Object.assign(dmChannelClone, { display_name: (0, _user_utils.displayUsername)(profiles[teammateId], teammateNameDisplay) });
    } else if (isGroupChannel(channel)) {
        var usernames = channel.display_name.split(', ');
        var users = Object.values(profiles);
        var userIds = [];
        usernames.forEach(function (username) {
            var u = users.find(function (p) {
                return p.username === username;
            });
            if (u) {
                userIds.push(u.id);
            }
        });
        if (usernames.length === userIds.length) {
            return Object.assign({}, channel, {
                display_name: getGroupDisplayNameFromUserIds(userIds, profiles, currentUserId, teammateNameDisplay)
            });
        }
    }

    return channel;
}

function cleanUpUrlable(input) {
    var cleaned = input.trim().replace(/-/g, ' ').replace(/[^\w\s]/gi, '').toLowerCase().replace(/\s/g, '-');
    cleaned = cleaned.replace(/-{2,}/, '-');
    cleaned = cleaned.replace(/^-+/, '');
    cleaned = cleaned.replace(/-+$/, '');
    return cleaned;
}

function getChannelByName(channels, name) {
    var channelIds = Object.keys(channels);
    for (var i = 0; i < channelIds.length; i++) {
        var id = channelIds[i];
        if (channels[id].name === name) {
            return channels[id];
        }
    }
    return null;
}

function getDirectChannelName(id, otherId) {
    var handle = void 0;

    if (otherId > id) {
        handle = id + '__' + otherId;
    } else {
        handle = otherId + '__' + id;
    }

    return handle;
}

function getUserIdFromChannelName(userId, channelName) {
    var ids = channelName.split('__');
    var otherUserId = '';
    if (ids[0] === userId) {
        otherUserId = ids[1];
    } else {
        otherUserId = ids[0];
    }

    return otherUserId;
}

function isAutoClosed(config, myPreferences, channel, channelActivity, channelArchiveTime) {
    var currentChannelId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

    var cutoff = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;

    var viewTimePref = myPreferences[_constants.Preferences.CATEGORY_CHANNEL_APPROXIMATE_VIEW_TIME + '--' + channel.id];
    var viewTime = viewTimePref ? parseInt(viewTimePref.value, 10) : 0;
    if (viewTime > cutoff) {
        return false;
    }

    var openTimePref = myPreferences[_constants.Preferences.CATEGORY_CHANNEL_OPEN_TIME + '--' + channel.id];
    var openTime = openTimePref ? parseInt(openTimePref.value, 10) : 0;

    // Only close archived channels when not being viewed
    if (channel.id !== currentChannelId && channelArchiveTime && channelArchiveTime > openTime) {
        return true;
    }

    if (config.CloseUnusedDirectMessages !== 'true' || isFavoriteChannel(myPreferences, channel.id)) {
        return false;
    }
    var autoClose = myPreferences[_constants.Preferences.CATEGORY_SIDEBAR_SETTINGS + '--close_unused_direct_messages'];
    if (!autoClose || autoClose.value === 'after_seven_days') {
        if (channelActivity && channelActivity > cutoff) {
            return false;
        }
        if (openTime > cutoff) {
            return false;
        }
        var lastActivity = channel.last_post_at;
        return !lastActivity || lastActivity < cutoff;
    }
    return false;
}

function isDirectChannel(channel) {
    return channel.type === _constants.General.DM_CHANNEL;
}

function isDirectChannelVisible(otherUserOrOtherUserId, config, myPreferences, channel, lastPost, isUnread, currentChannelId) {
    var otherUser = (typeof otherUserOrOtherUserId === 'undefined' ? 'undefined' : _typeof(otherUserOrOtherUserId)) === 'object' ? otherUserOrOtherUserId : null;
    var otherUserId = (typeof otherUserOrOtherUserId === 'undefined' ? 'undefined' : _typeof(otherUserOrOtherUserId)) === 'object' ? otherUserOrOtherUserId.id : otherUserOrOtherUserId;
    var dm = myPreferences[_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW + '--' + otherUserId];
    if (!dm || dm.value !== 'true') {
        return false;
    }
    return isUnread || !isAutoClosed(config, myPreferences, channel, lastPost ? lastPost.create_at : 0, otherUser ? otherUser.delete_at : 0, currentChannelId);
}

function isGroupChannel(channel) {
    return channel.type === _constants.General.GM_CHANNEL;
}

function isGroupChannelVisible(config, myPreferences, channel, lastPost, isUnread) {
    var gm = myPreferences[_constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW + '--' + channel.id];
    if (!gm || gm.value !== 'true') {
        return false;
    }
    return isUnread || !isAutoClosed(config, myPreferences, channel, lastPost ? lastPost.create_at : 0);
}

function isGroupOrDirectChannelVisible(channel, memberships, config, myPreferences, currentUserId, users, lastPosts) {
    var lastPost = lastPosts[channel.id];
    if (isGroupChannel(channel) && isGroupChannelVisible(config, myPreferences, channel, lastPost, isUnreadChannel(memberships, channel))) {
        return true;
    }
    if (!isDirectChannel(channel)) {
        return false;
    }
    var otherUserId = getUserIdFromChannelName(currentUserId, channel.name);
    return isDirectChannelVisible(users[otherUserId] || otherUserId, config, myPreferences, channel, lastPost, isUnreadChannel(memberships, channel));
}

function showCreateOption(state, config, license, teamId, channelType, isAdmin, isSystemAdmin) {
    if ((0, _general.hasNewPermissions)(state)) {
        if (channelType === _constants.General.OPEN_CHANNEL) {
            return (0, _roles.haveITeamPermission)(state, { team: teamId, permission: _constants.Permissions.CREATE_PUBLIC_CHANNEL });
        } else if (channelType === _constants.General.PRIVATE_CHANNEL) {
            return (0, _roles.haveITeamPermission)(state, { team: teamId, permission: _constants.Permissions.CREATE_PRIVATE_CHANNEL });
        }
        return true;
    }

    if (license.IsLicensed !== 'true') {
        return true;
    }

    if (channelType === _constants.General.OPEN_CHANNEL) {
        if (config.RestrictPublicChannelCreation === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        } else if (config.RestrictPublicChannelCreation === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
    } else if (channelType === _constants.General.PRIVATE_CHANNEL) {
        if (config.RestrictPrivateChannelCreation === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        } else if (config.RestrictPrivateChannelCreation === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
    }

    return true;
}

function showManagementOptions(state, config, license, channel, isAdmin, isSystemAdmin, isChannelAdmin) {
    if ((0, _general.hasNewPermissions)(state)) {
        if (channel.type === _constants.General.OPEN_CHANNEL) {
            return (0, _roles.haveITeamPermission)(state, { team: channel.team_idteamId, permission: _constants.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES });
        } else if (channel.type === _constants.General.PRIVATE_CHANNEL) {
            return (0, _roles.haveITeamPermission)(state, { team: channel.team_id, permission: _constants.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES });
        }
        return true;
    }

    if (license.IsLicensed !== 'true') {
        return true;
    }

    if (channel.type === _constants.General.OPEN_CHANNEL) {
        if (config.RestrictPublicChannelManagement === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        }
        if (config.RestrictPublicChannelManagement === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
        if (config.RestrictPublicChannelManagement === _constants.General.CHANNEL_ADMIN_ROLE && !isChannelAdmin && !isAdmin) {
            return false;
        }
    } else if (channel.type === _constants.General.PRIVATE_CHANNEL) {
        if (config.RestrictPrivateChannelManagement === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        }
        if (config.RestrictPrivateChannelManagement === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
        if (config.RestrictPrivateChannelManagement === _constants.General.CHANNEL_ADMIN_ROLE && !isChannelAdmin && !isAdmin) {
            return false;
        }
    }

    return true;
}

function showDeleteOption(state, config, license, channel, isAdmin, isSystemAdmin, isChannelAdmin) {
    if ((0, _general.hasNewPermissions)(state)) {
        if (channel.type === _constants.General.OPEN_CHANNEL) {
            return (0, _roles.haveITeamPermission)(state, { team: channel.team_idteamId, permission: _constants.Permissions.DELETE_PUBLIC_CHANNEL });
        } else if (channel.type === _constants.General.PRIVATE_CHANNEL) {
            return (0, _roles.haveITeamPermission)(state, { team: channel.team_id, permission: _constants.Permissions.DELETE_PRIVATE_CHANNEL });
        }
        return true;
    }

    if (license.IsLicensed !== 'true') {
        return true;
    }

    if (channel.type === _constants.General.OPEN_CHANNEL) {
        if (config.RestrictPublicChannelDeletion === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        }
        if (config.RestrictPublicChannelDeletion === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
        if (config.RestrictPublicChannelDeletion === _constants.General.CHANNEL_ADMIN_ROLE && !isChannelAdmin && !isAdmin) {
            return false;
        }
    } else if (channel.type === _constants.General.PRIVATE_CHANNEL) {
        if (config.RestrictPrivateChannelDeletion === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        }
        if (config.RestrictPrivateChannelDeletion === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
        if (config.RestrictPrivateChannelDeletion === _constants.General.CHANNEL_ADMIN_ROLE && !isChannelAdmin && !isAdmin) {
            return false;
        }
    }

    return true;
}

function canManageMembersOldPermissions(channel, user, teamMember, channelMember, config, license) {
    if (channel.type === _constants.General.DM_CHANNEL || channel.type === _constants.General.GM_CHANNEL || channel.name === _constants.General.DEFAULT_CHANNEL) {
        return false;
    }

    if (license.IsLicensed !== 'true') {
        return true;
    }

    if (channel.type === _constants.General.PRIVATE_CHANNEL) {
        var isSystemAdmin = user.roles.includes(_constants.General.SYSTEM_ADMIN_ROLE);
        if (config.RestrictPrivateChannelManageMembers === _constants.General.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        }

        var isTeamAdmin = teamMember.roles.includes(_constants.General.TEAM_ADMIN_ROLE);
        if (config.RestrictPrivateChannelManageMembers === _constants.General.PERMISSIONS_TEAM_ADMIN && !isTeamAdmin && !isSystemAdmin) {
            return false;
        }

        var isChannelAdmin = channelMember.roles.includes(_constants.General.CHANNEL_ADMIN_ROLE);
        if (config.RestrictPrivateChannelManageMembers === _constants.General.PERMISSIONS_CHANNEL_ADMIN && !isChannelAdmin && !isTeamAdmin && !isSystemAdmin) {
            return false;
        }
    }

    return true;
}

function getChannelsIdForTeam(state, teamId) {
    var channels = state.entities.channels.channels;


    return Object.values(channels).reduce(function (res, channel) {
        if (channel.team_id === teamId) {
            res.push(channel.id);
        }
        return res;
    }, []);
}

function getGroupDisplayNameFromUserIds(userIds, profiles, currentUserId, teammateNameDisplay) {
    var names = [];
    userIds.forEach(function (id) {
        if (id !== currentUserId) {
            names.push((0, _user_utils.displayUsername)(profiles[id], teammateNameDisplay));
        }
    });

    function sortUsernames(a, b) {
        var locale = getUserLocale(currentUserId, profiles);
        return a.localeCompare(b, locale, { numeric: true });
    }

    return names.sort(sortUsernames).join(', ');
}

function isFavoriteChannel(myPreferences, id) {
    var fav = myPreferences[_constants.Preferences.CATEGORY_FAVORITE_CHANNEL + '--' + id];
    return fav && fav.value === 'true';
}

function isDefault(channel) {
    return channel.name === _constants.General.DEFAULT_CHANNEL;
}

//====================================================

function createFakeChannel(userId, otherUserId) {
    return {
        name: getDirectChannelName(userId, otherUserId),
        last_post_at: 0,
        total_msg_count: 0,
        type: _constants.General.DM_CHANNEL,
        fake: true
    };
}

function createFakeChannelCurried(userId) {
    return function (otherUserId) {
        return createFakeChannel(userId, otherUserId);
    };
}

function createMissingDirectChannels(currentUserId, allChannels, myPreferences) {
    var directChannelsDisplayPreferences = (0, _preference_utils.getPreferencesByCategory)(myPreferences, _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);

    return Array.from(directChannelsDisplayPreferences).filter(function (entry) {
        return entry[1] === 'true';
    }).map(function (entry) {
        return entry[0];
    }).filter(function (teammateId) {
        return !allChannels.some(isDirectChannelForUser.bind(null, currentUserId, teammateId));
    }).map(createFakeChannelCurried(currentUserId));
}

function completeDirectGroupInfo(usersState, teammateNameDisplay, channel) {
    var currentUserId = usersState.currentUserId,
        profiles = usersState.profiles,
        profilesInChannel = usersState.profilesInChannel;

    var profilesIds = profilesInChannel[channel.id];
    var gm = _extends({}, channel);

    if (profilesIds) {
        return Object.assign(gm, {
            display_name: getGroupDisplayNameFromUserIds(profilesIds, profiles, currentUserId, teammateNameDisplay)
        });
    }

    var usernames = gm.display_name.split(', ');
    var users = Object.values(profiles);
    var userIds = [];
    usernames.forEach(function (username) {
        var u = users.find(function (p) {
            return p.username === username;
        });
        if (u) {
            userIds.push(u.id);
        }
    });
    if (usernames.length === userIds.length) {
        return Object.assign(gm, {
            display_name: getGroupDisplayNameFromUserIds(userIds, profiles, currentUserId, teammateNameDisplay)
        });
    }

    return channel;
}

function isDirectChannelForUser(userId, otherUserId, channel) {
    return channel.type === _constants.General.DM_CHANNEL && getUserIdFromChannelName(userId, channel.name) === otherUserId;
}

function channelHasMentions(members, channel) {
    var member = members[channel.id];
    if (member) {
        return member.mention_count > 0;
    }
    return false;
}

function channelHasUnreadMessages(members, channel) {
    var member = members[channel.id];
    if (member) {
        var msgCount = channel.total_msg_count - member.msg_count;
        var onlyMentions = member.notify_props && member.notify_props.mark_unread === _constants.General.MENTION;
        return msgCount && !onlyMentions && member.mention_count === 0;
    }

    return false;
}

function isUnreadChannel(members, channel) {
    var member = members[channel.id];
    if (member) {
        var msgCount = channel.total_msg_count - member.msg_count;
        var onlyMentions = member.notify_props && member.notify_props.mark_unread === _constants.General.MENTION;
        return member.mention_count > 0 || msgCount && !onlyMentions;
    }

    return false;
}

function isNotDeletedChannel(channel) {
    return channel.delete_at === 0;
}

function isOpenChannel(channel) {
    return channel.type === _constants.General.OPEN_CHANNEL;
}

function isPrivateChannel(channel) {
    return channel.type === _constants.General.PRIVATE_CHANNEL;
}

function sortChannelsByTypeAndDisplayName(locale, a, b) {
    if (channelTypeOrder[a.type] !== channelTypeOrder[b.type]) {
        if (channelTypeOrder[a.type] < channelTypeOrder[b.type]) {
            return -1;
        }

        return 1;
    }

    var aDisplayName = filterName(a.display_name);
    var bDisplayName = filterName(b.display_name);

    if (aDisplayName !== bDisplayName) {
        return aDisplayName.toLowerCase().localeCompare(bDisplayName.toLowerCase(), locale, { numeric: true });
    }

    return a.name.toLowerCase().localeCompare(b.name.toLowerCase(), locale, { numeric: true });
}

function filterName(name) {
    return name.replace(/[.,'"\/#!$%\^&\*;:{}=\-_`~()]/g, ''); // eslint-disable-line no-useless-escape
}

function sortChannelsByDisplayName(locale, a, b) {
    if (a.display_name !== b.display_name) {
        return a.display_name.toLowerCase().localeCompare(b.display_name.toLowerCase(), locale, { numeric: true });
    }

    return a.name.toLowerCase().localeCompare(b.name.toLowerCase(), locale, { numeric: true });
}

function sortChannelsByDisplayNameAndMuted(locale, members, a, b) {
    var aMember = members[a.id];
    var bMember = members[b.id];

    if (isChannelMuted(bMember) === isChannelMuted(aMember)) {
        return sortChannelsByDisplayName(locale, a, b);
    }

    if (!isChannelMuted(bMember) && isChannelMuted(aMember)) {
        return 1;
    }

    return -1;
}

function isChannelMuted(member) {
    return member && member.notify_props ? member.notify_props.mark_unread === 'mention' : false;
}

function not(f) {
    return function () {
        return !f.apply(undefined, arguments);
    };
}

function buildChannels(usersState, channels, missingDirectChannels, teammateNameDisplay, locale) {
    return channels.concat(missingDirectChannels).map(completeDirectChannelInfo.bind(null, usersState, teammateNameDisplay)).filter(isNotDeletedChannel).sort(sortChannelsByTypeAndDisplayName.bind(null, locale));
}

function buildFavoriteChannels(channels, myPreferences, locale) {
    return channels.filter(function (channel) {
        return isFavoriteChannel(myPreferences, channel.id);
    }).sort(sortChannelsByDisplayName.bind(null, locale));
}

function buildNotFavoriteChannels(channels, myPreferences) {
    return channels.filter(function (channel) {
        return !isFavoriteChannel(myPreferences, channel.id);
    });
}

function buildDirectAndGroupChannels(channels, memberships, config, myPreferences, currentUserId, users, lastPosts) {
    return channels.filter(function (channel) {
        return isGroupOrDirectChannelVisible(channel, memberships, config, myPreferences, currentUserId, users, lastPosts);
    });
}

function buildChannelsWithMentions(channels, members, locale) {
    return channels.filter(channelHasMentions.bind(null, members)).sort(sortChannelsByDisplayName.bind(null, locale));
}

function buildUnreadChannels(channels, members, locale) {
    return channels.filter(channelHasUnreadMessages.bind(null, members)).sort(sortChannelsByDisplayName.bind(null, locale));
}

function getUserLocale(userId, profiles) {
    var locale = 'en';
    if (profiles && profiles[userId] && profiles[userId].locale) {
        locale = profiles[userId].locale;
    }

    return locale;
}

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getLogs = getLogs;
exports.getAudits = getAudits;
exports.getConfig = getConfig;
exports.updateConfig = updateConfig;
exports.reloadConfig = reloadConfig;
exports.testEmail = testEmail;
exports.testS3Connection = testS3Connection;
exports.invalidateCaches = invalidateCaches;
exports.recycleDatabase = recycleDatabase;
exports.createComplianceReport = createComplianceReport;
exports.getComplianceReport = getComplianceReport;
exports.getComplianceReports = getComplianceReports;
exports.uploadBrandImage = uploadBrandImage;
exports.getClusterStatus = getClusterStatus;
exports.testLdap = testLdap;
exports.syncLdap = syncLdap;
exports.getSamlCertificateStatus = getSamlCertificateStatus;
exports.uploadPublicSamlCertificate = uploadPublicSamlCertificate;
exports.uploadPrivateSamlCertificate = uploadPrivateSamlCertificate;
exports.uploadIdpSamlCertificate = uploadIdpSamlCertificate;
exports.removePublicSamlCertificate = removePublicSamlCertificate;
exports.removePrivateSamlCertificate = removePrivateSamlCertificate;
exports.removeIdpSamlCertificate = removeIdpSamlCertificate;
exports.testElasticsearch = testElasticsearch;
exports.purgeElasticsearchIndexes = purgeElasticsearchIndexes;
exports.uploadLicense = uploadLicense;
exports.removeLicense = removeLicense;
exports.getAnalytics = getAnalytics;
exports.getStandardAnalytics = getStandardAnalytics;
exports.getAdvancedAnalytics = getAdvancedAnalytics;
exports.getPostsPerDayAnalytics = getPostsPerDayAnalytics;
exports.getUsersPerDayAnalytics = getUsersPerDayAnalytics;
exports.uploadPlugin = uploadPlugin;
exports.getPlugins = getPlugins;
exports.removePlugin = removePlugin;
exports.activatePlugin = activatePlugin;
exports.deactivatePlugin = deactivatePlugin;

var _action_types = __webpack_require__(3);

var _constants = __webpack_require__(19);

var _client = __webpack_require__(270);

var _errors = __webpack_require__(828);

var _helpers = __webpack_require__(821);

var _reduxBatchedActions = __webpack_require__(278);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getLogs() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.LOGS_PAGE_SIZE_DEFAULT;

    return (0, _helpers.bindClientFunc)(_client.Client4.getLogs, _action_types.AdminTypes.GET_LOGS_REQUEST, [_action_types.AdminTypes.RECEIVED_LOGS, _action_types.AdminTypes.GET_LOGS_SUCCESS], _action_types.AdminTypes.GET_LOGS_FAILURE, page, perPage);
}

function getAudits() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PAGE_SIZE_DEFAULT;

    return (0, _helpers.bindClientFunc)(_client.Client4.getAudits, _action_types.AdminTypes.GET_AUDITS_REQUEST, [_action_types.AdminTypes.RECEIVED_AUDITS, _action_types.AdminTypes.GET_AUDITS_SUCCESS], _action_types.AdminTypes.GET_AUDITS_FAILURE, page, perPage);
}

function getConfig() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getConfig, _action_types.AdminTypes.GET_CONFIG_REQUEST, [_action_types.AdminTypes.RECEIVED_CONFIG, _action_types.AdminTypes.GET_CONFIG_SUCCESS], _action_types.AdminTypes.GET_CONFIG_FAILURE);
}

function updateConfig(config) {
    return (0, _helpers.bindClientFunc)(_client.Client4.updateConfig, _action_types.AdminTypes.UPDATE_CONFIG_REQUEST, [_action_types.AdminTypes.RECEIVED_CONFIG, _action_types.AdminTypes.UPDATE_CONFIG_SUCCESS], _action_types.AdminTypes.UPDATE_CONFIG_FAILURE, config);
}

function reloadConfig() {
    return (0, _helpers.bindClientFunc)(_client.Client4.reloadConfig, _action_types.AdminTypes.RELOAD_CONFIG_REQUEST, _action_types.AdminTypes.RELOAD_CONFIG_SUCCESS, _action_types.AdminTypes.RELOAD_CONFIG_FAILURE);
}

function testEmail(config) {
    return (0, _helpers.bindClientFunc)(_client.Client4.testEmail, _action_types.AdminTypes.TEST_EMAIL_REQUEST, _action_types.AdminTypes.TEST_EMAIL_SUCCESS, _action_types.AdminTypes.TEST_EMAIL_FAILURE, config);
}

function testS3Connection(config) {
    return (0, _helpers.bindClientFunc)(_client.Client4.testS3Connection, _action_types.AdminTypes.TEST_S3_REQUEST, _action_types.AdminTypes.TEST_S3_SUCCESS, _action_types.AdminTypes.TEST_S3_FAILURE, config);
}

function invalidateCaches() {
    return (0, _helpers.bindClientFunc)(_client.Client4.invalidateCaches, _action_types.AdminTypes.INVALIDATE_CACHES_REQUEST, _action_types.AdminTypes.INVALIDATE_CACHES_SUCCESS, _action_types.AdminTypes.INVALIDATE_CACHES_FAILURE);
}

function recycleDatabase() {
    return (0, _helpers.bindClientFunc)(_client.Client4.recycleDatabase, _action_types.AdminTypes.RECYCLE_DATABASE_REQUEST, _action_types.AdminTypes.RECYCLE_DATABASE_SUCCESS, _action_types.AdminTypes.RECYCLE_DATABASE_FAILURE);
}

function createComplianceReport(job) {
    return (0, _helpers.bindClientFunc)(_client.Client4.createComplianceReport, _action_types.AdminTypes.CREATE_COMPLIANCE_REQUEST, [_action_types.AdminTypes.RECEIVED_COMPLIANCE_REPORT, _action_types.AdminTypes.CREATE_COMPLIANCE_SUCCESS], _action_types.AdminTypes.CREATE_COMPLIANCE_FAILURE, job);
}

function getComplianceReport(reportId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getComplianceReport, _action_types.AdminTypes.GET_COMPLIANCE_REQUEST, [_action_types.AdminTypes.RECEIVED_COMPLIANCE_REPORT, _action_types.AdminTypes.GET_COMPLIANCE_SUCCESS], _action_types.AdminTypes.GET_COMPLIANCE_FAILURE, reportId);
}

function getComplianceReports() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PER_PAGE_DEFAULT;

    return (0, _helpers.bindClientFunc)(_client.Client4.getComplianceReports, _action_types.AdminTypes.GET_COMPLIANCE_REQUEST, [_action_types.AdminTypes.RECEIVED_COMPLIANCE_REPORTS, _action_types.AdminTypes.GET_COMPLIANCE_SUCCESS], _action_types.AdminTypes.GET_COMPLIANCE_FAILURE, page, perPage);
}

function uploadBrandImage(imageData) {
    return (0, _helpers.bindClientFunc)(_client.Client4.uploadBrandImage, _action_types.AdminTypes.UPLOAD_BRAND_IMAGE_REQUEST, _action_types.AdminTypes.UPLOAD_BRAND_IMAGE_SUCCESS, _action_types.AdminTypes.UPLOAD_BRAND_IMAGE_FAILURE, imageData);
}

function getClusterStatus() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getClusterStatus, _action_types.AdminTypes.GET_CLUSTER_STATUS_REQUEST, [_action_types.AdminTypes.RECEIVED_CLUSTER_STATUS, _action_types.AdminTypes.GET_CLUSTER_STATUS_SUCCESS], _action_types.AdminTypes.GET_CLUSTER_STATUS_FAILURE);
}

function testLdap() {
    return (0, _helpers.bindClientFunc)(_client.Client4.testLdap, _action_types.AdminTypes.TEST_LDAP_REQUEST, _action_types.AdminTypes.TEST_LDAP_SUCCESS, _action_types.AdminTypes.TEST_LDAP_FAILURE);
}

function syncLdap() {
    return (0, _helpers.bindClientFunc)(_client.Client4.syncLdap, _action_types.AdminTypes.SYNC_LDAP_REQUEST, _action_types.AdminTypes.SYNC_LDAP_SUCCESS, _action_types.AdminTypes.SYNC_LDAP_FAILURE);
}

function getSamlCertificateStatus() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getSamlCertificateStatus, _action_types.AdminTypes.SAML_CERT_STATUS_REQUEST, [_action_types.AdminTypes.RECEIVED_SAML_CERT_STATUS, _action_types.AdminTypes.SAML_CERT_STATUS_SUCCESS], _action_types.AdminTypes.SAML_CERT_STATUS_FAILURE);
}

function uploadPublicSamlCertificate(fileData) {
    return (0, _helpers.bindClientFunc)(_client.Client4.uploadPublicSamlCertificate, _action_types.AdminTypes.UPLOAD_SAML_PUBLIC_REQUEST, _action_types.AdminTypes.UPLOAD_SAML_PUBLIC_SUCCESS, _action_types.AdminTypes.UPLOAD_SAML_PUBLIC_FAILURE, fileData);
}

function uploadPrivateSamlCertificate(fileData) {
    return (0, _helpers.bindClientFunc)(_client.Client4.uploadPrivateSamlCertificate, _action_types.AdminTypes.UPLOAD_SAML_PRIVATE_REQUEST, _action_types.AdminTypes.UPLOAD_SAML_PRIVATE_SUCCESS, _action_types.AdminTypes.UPLOAD_SAML_PRIVATE_FAILURE, fileData);
}

function uploadIdpSamlCertificate(fileData) {
    return (0, _helpers.bindClientFunc)(_client.Client4.uploadIdpSamlCertificate, _action_types.AdminTypes.UPLOAD_SAML_IDP_REQUEST, _action_types.AdminTypes.UPLOAD_SAML_IDP_SUCCESS, _action_types.AdminTypes.UPLOAD_SAML_IDP_FAILURE, fileData);
}

function removePublicSamlCertificate() {
    return (0, _helpers.bindClientFunc)(_client.Client4.deletePublicSamlCertificate, _action_types.AdminTypes.DELETE_SAML_PUBLIC_REQUEST, _action_types.AdminTypes.DELETE_SAML_PUBLIC_SUCCESS, _action_types.AdminTypes.DELETE_SAML_PUBLIC_FAILURE);
}

function removePrivateSamlCertificate() {
    return (0, _helpers.bindClientFunc)(_client.Client4.deletePrivateSamlCertificate, _action_types.AdminTypes.DELETE_SAML_PRIVATE_REQUEST, _action_types.AdminTypes.DELETE_SAML_PRIVATE_SUCCESS, _action_types.AdminTypes.DELETE_SAML_PRIVATE_FAILURE);
}

function removeIdpSamlCertificate() {
    return (0, _helpers.bindClientFunc)(_client.Client4.deleteIdpSamlCertificate, _action_types.AdminTypes.DELETE_SAML_IDP_REQUEST, _action_types.AdminTypes.DELETE_SAML_IDP_SUCCESS, _action_types.AdminTypes.DELETE_SAML_IDP_FAILURE);
}

function testElasticsearch(config) {
    return (0, _helpers.bindClientFunc)(_client.Client4.testElasticsearch, _action_types.AdminTypes.TEST_ELASTICSEARCH_REQUEST, _action_types.AdminTypes.TEST_ELASTICSEARCH_SUCCESS, _action_types.AdminTypes.TEST_ELASTICSEARCH_FAILURE, config);
}

function purgeElasticsearchIndexes() {
    return (0, _helpers.bindClientFunc)(_client.Client4.purgeElasticsearchIndexes, _action_types.AdminTypes.PURGE_ELASTICSEARCH_INDEXES_REQUEST, _action_types.AdminTypes.PURGE_ELASTICSEARCH_INDEXES_SUCCESS, _action_types.AdminTypes.PURGE_ELASTICSEARCH_INDEXES_FAILURE);
}

function uploadLicense(fileData) {
    return (0, _helpers.bindClientFunc)(_client.Client4.uploadLicense, _action_types.AdminTypes.UPLOAD_LICENSE_REQUEST, _action_types.AdminTypes.UPLOAD_LICENSE_SUCCESS, _action_types.AdminTypes.UPLOAD_LICENSE_FAILURE, fileData);
}

function removeLicense() {
    return (0, _helpers.bindClientFunc)(_client.Client4.removeLicense, _action_types.AdminTypes.REMOVE_LICENSE_REQUEST, _action_types.AdminTypes.REMOVE_LICENSE_SUCCESS, _action_types.AdminTypes.REMOVE_LICENSE_FAILURE);
}

function getAnalytics(name) {
    var _this = this;

    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var data, actions;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.AdminTypes.GET_ANALYTICS_REQUEST }, getState);

                            data = void 0;
                            _context.prev = 2;
                            _context.next = 5;
                            return _client.Client4.getAnalytics(name, teamId);

                        case 5:
                            data = _context.sent;
                            _context.next = 13;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.GET_ANALYTICS_FAILURE, error: _context.t0 }, (0, _errors.logError)(_context.t0)(dispatch)]), getState);
                            return _context.abrupt('return', { error: _context.t0 });

                        case 13:
                            actions = [{ type: _action_types.AdminTypes.GET_ANALYTICS_SUCCESS }];

                            if (teamId === '') {
                                actions.push({ type: _action_types.AdminTypes.RECEIVED_SYSTEM_ANALYTICS, data: data, name: name });
                            } else {
                                actions.push({ type: _action_types.AdminTypes.RECEIVED_TEAM_ANALYTICS, data: data, name: name, teamId: teamId });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context.abrupt('return', { data: data });

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[2, 8]]);
        }));

        return function (_x8, _x9) {
            return _ref.apply(this, arguments);
        };
    }();
}

function getStandardAnalytics() {
    var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return getAnalytics('standard', teamId);
}

function getAdvancedAnalytics() {
    var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return getAnalytics('extra_counts', teamId);
}

function getPostsPerDayAnalytics() {
    var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return getAnalytics('post_counts_day', teamId);
}

function getUsersPerDayAnalytics() {
    var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return getAnalytics('user_counts_with_posts_day', teamId);
}

// EXPERIMENTAL - SUBJECT TO CHANGE
function uploadPlugin(fileData) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.AdminTypes.UPLOAD_PLUGIN_REQUEST });

                            data = void 0;
                            _context2.prev = 2;
                            _context2.next = 5;
                            return _client.Client4.uploadPlugin(fileData);

                        case 5:
                            data = _context2.sent;
                            _context2.next = 13;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.UPLOAD_PLUGIN_FAILURE, error: _context2.t0 }, (0, _errors.logError)(_context2.t0)(dispatch)]));
                            return _context2.abrupt('return', { error: _context2.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.UPLOAD_PLUGIN_SUCCESS }, { type: _action_types.AdminTypes.RECEIVED_PLUGIN, data: _extends({}, data, { active: false }) }]));

                            return _context2.abrupt('return', { data: data });

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[2, 8]]);
        }));

        return function (_x14, _x15) {
            return _ref2.apply(this, arguments);
        };
    }();
}

// EXPERIMENTAL - SUBJECT TO CHANGE
function getPlugins() {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.AdminTypes.GET_PLUGIN_REQUEST });

                            data = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.getPlugins();

                        case 5:
                            data = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.GET_PLUGIN_FAILURE, error: _context3.t0 }, (0, _errors.logError)(_context3.t0)(dispatch)]));
                            return _context3.abrupt('return', { error: _context3.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.GET_PLUGIN_SUCCESS }, { type: _action_types.AdminTypes.RECEIVED_PLUGINS, data: data }]));

                            return _context3.abrupt('return', { data: data });

                        case 15:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x16, _x17) {
            return _ref3.apply(this, arguments);
        };
    }();
}

// EXPERIMENTAL - SUBJECT TO CHANGE
function removePlugin(pluginId) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.AdminTypes.REMOVE_PLUGIN_REQUEST });

                            _context4.prev = 1;
                            _context4.next = 4;
                            return _client.Client4.removePlugin(pluginId);

                        case 4:
                            _context4.next = 11;
                            break;

                        case 6:
                            _context4.prev = 6;
                            _context4.t0 = _context4['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.REMOVE_PLUGIN_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]));
                            return _context4.abrupt('return', { error: _context4.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.REMOVE_PLUGIN_SUCCESS }, { type: _action_types.AdminTypes.REMOVED_PLUGIN, data: pluginId }]));

                            return _context4.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[1, 6]]);
        }));

        return function (_x18, _x19) {
            return _ref4.apply(this, arguments);
        };
    }();
}

// EXPERIMENTAL - SUBJECT TO CHANGE
function activatePlugin(pluginId) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.AdminTypes.ACTIVATE_PLUGIN_REQUEST });

                            _context5.prev = 1;
                            _context5.next = 4;
                            return _client.Client4.activatePlugin(pluginId);

                        case 4:
                            _context5.next = 11;
                            break;

                        case 6:
                            _context5.prev = 6;
                            _context5.t0 = _context5['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.ACTIVATE_PLUGIN_FAILURE, error: _context5.t0 }, (0, _errors.logError)(_context5.t0)(dispatch)]));
                            return _context5.abrupt('return', { error: _context5.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.ACTIVATE_PLUGIN_SUCCESS }, { type: _action_types.AdminTypes.ACTIVATED_PLUGIN, data: pluginId }]));

                            return _context5.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[1, 6]]);
        }));

        return function (_x20, _x21) {
            return _ref5.apply(this, arguments);
        };
    }();
}

// EXPERIMENTAL - SUBJECT TO CHANGE
function deactivatePlugin(pluginId) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.AdminTypes.DEACTIVATE_PLUGIN_REQUEST });

                            _context6.prev = 1;
                            _context6.next = 4;
                            return _client.Client4.deactivatePlugin(pluginId);

                        case 4:
                            _context6.next = 11;
                            break;

                        case 6:
                            _context6.prev = 6;
                            _context6.t0 = _context6['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.DEACTIVATE_PLUGIN_FAILURE, error: _context6.t0 }, (0, _errors.logError)(_context6.t0)(dispatch)]));
                            return _context6.abrupt('return', { error: _context6.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.AdminTypes.DEACTIVATE_PLUGIN_SUCCESS }, { type: _action_types.AdminTypes.DEACTIVATED_PLUGIN, data: pluginId }]));

                            return _context6.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[1, 6]]);
        }));

        return function (_x22, _x23) {
            return _ref6.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.red = undefined;

var _each = __webpack_require__(2294);

var _each2 = _interopRequireDefault(_each);

var _tinycolor = __webpack_require__(2296);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
    var checked = 0;
    var passed = 0;
    (0, _each2.default)(keysToCheck, function (letter) {
      if (data[letter]) {
        checked += 1;
        if (!isNaN(data[letter])) {
          passed += 1;
        }
      }
    });
    return checked === passed ? data : false;
  },
  toState: function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
      hsl.h = oldHue || 0;
      hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;

    return {
      hsl: hsl,
      hex: transparent ? 'transparent' : '#' + hex,
      rgb: rgb,
      hsv: hsv,
      oldHue: data.h || oldHue || hsl.h,
      source: data.source
    };
  },
  isValidHex: function isValidHex(hex) {
    return (0, _tinycolor2.default)(hex).isValid();
  }
};
var red = exports.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(872);
var dom = __webpack_require__(895);
var instances = __webpack_require__(827);
var updateScroll = __webpack_require__(873);

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = {width: i.railXWidth};
  if (i.isRtl) {
    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
  }
  dom.css(i.scrollbarXRail, xRailOffset);

  var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  dom.css(i.scrollbarYRail, yRailOffset);

  dom.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
  dom.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
}

module.exports = function (element) {
  var i = instances.get(element);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  var existingRails;
  if (!element.contains(i.scrollbarXRail)) {
    existingRails = dom.queryChildren(element, '.ps__scrollbar-x-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarXRail, element);
  }
  if (!element.contains(i.scrollbarYRail)) {
    existingRails = dom.queryChildren(element, '.ps__scrollbar-y-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarYRail, element);
  }

  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(i, _.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
    i.scrollbarXLeft = _.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
  } else {
    i.scrollbarXActive = false;
  }

  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(i, _.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
    i.scrollbarYTop = _.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    element.classList.add('ps--active-x');
  } else {
    element.classList.remove('ps--active-x');
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    updateScroll(element, 'left', 0);
  }
  if (i.scrollbarYActive) {
    element.classList.add('ps--active-y');
  } else {
    element.classList.remove('ps--active-y');
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    updateScroll(element, 'top', 0);
  }
};


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	// Only count HTML whitespace
	// Other whitespace should count in values
	// https://infra.spec.whatwg.org/#ascii-whitespace
	return ( /[^\x20\t\r\n\f]+/g );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRolesByNames = getRolesByNames;
exports.getRoleByName = getRoleByName;
exports.getRole = getRole;
exports.editRole = editRole;
exports.setPendingRoles = setPendingRoles;
exports.loadRolesIfNeeded = loadRolesIfNeeded;

var _client = __webpack_require__(270);

var _action_types = __webpack_require__(3);

var _roles = __webpack_require__(276);

var _general = __webpack_require__(113);

var _helpers = __webpack_require__(821);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getRolesByNames(rolesNames) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getRolesByNames, _action_types.RoleTypes.ROLES_BY_NAMES_REQUEST, [_action_types.RoleTypes.RECEIVED_ROLES, _action_types.RoleTypes.ROLES_BY_NAMES_SUCCESS], _action_types.RoleTypes.ROLES_BY_NAMES_FAILURE, rolesNames);
}

function getRoleByName(roleName) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getRoleByName, _action_types.RoleTypes.ROLE_BY_NAME_REQUEST, [_action_types.RoleTypes.RECEIVED_ROLE, _action_types.RoleTypes.ROLE_BY_NAME_SUCCESS], _action_types.RoleTypes.ROLE_BY_NAME_FAILURE, roleName);
}

function getRole(roleId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getRole, _action_types.RoleTypes.ROLE_BY_ID_REQUEST, [_action_types.RoleTypes.RECEIVED_ROLE, _action_types.RoleTypes.ROLE_BY_ID_SUCCESS], _action_types.RoleTypes.ROLE_BY_ID_FAILURE, roleId);
}

function editRole(role) {
    return (0, _helpers.bindClientFunc)(_client.Client4.patchRole, _action_types.RoleTypes.EDIT_ROLE_REQUEST, [_action_types.RoleTypes.RECEIVED_ROLE, _action_types.RoleTypes.EDIT_ROLE_SUCCESS], _action_types.RoleTypes.EDIT_ROLE_FAILURE, role.id, role);
}

function setPendingRoles(roles) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.RoleTypes.SET_PENDING_ROLES, data: roles }, getState);
                            return _context.abrupt('return', { data: roles });

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function loadRolesIfNeeded(roles) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var state, pendingRoles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, role, loadedRoles, newRoles, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _role;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            pendingRoles = new Set(state.entities.roles.pending);
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 5;

                            for (_iterator = roles[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                role = _step.value;

                                pendingRoles.add(role);
                            }
                            _context2.next = 13;
                            break;

                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](5);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                        case 13:
                            _context2.prev = 13;
                            _context2.prev = 14;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 16:
                            _context2.prev = 16;

                            if (!_didIteratorError) {
                                _context2.next = 19;
                                break;
                            }

                            throw _iteratorError;

                        case 19:
                            return _context2.finish(16);

                        case 20:
                            return _context2.finish(13);

                        case 21:
                            if (state.entities.general.serverVersion) {
                                _context2.next = 24;
                                break;
                            }

                            setPendingRoles(pendingRoles)(dispatch, getState);
                            return _context2.abrupt('return', { data: [] });

                        case 24:
                            if ((0, _general.hasNewPermissions)(state)) {
                                _context2.next = 29;
                                break;
                            }

                            if (!state.entities.roles.pending) {
                                _context2.next = 28;
                                break;
                            }

                            _context2.next = 28;
                            return setPendingRoles(new Set())(dispatch, getState);

                        case 28:
                            return _context2.abrupt('return', { data: [] });

                        case 29:
                            loadedRoles = (0, _roles.getRoles)(state);
                            newRoles = new Set();
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context2.prev = 34;

                            for (_iterator2 = pendingRoles[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                _role = _step2.value;

                                if (!loadedRoles[_role] && _role.trim() !== '') {
                                    newRoles.add(_role);
                                }
                            }

                            _context2.next = 42;
                            break;

                        case 38:
                            _context2.prev = 38;
                            _context2.t1 = _context2['catch'](34);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context2.t1;

                        case 42:
                            _context2.prev = 42;
                            _context2.prev = 43;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 45:
                            _context2.prev = 45;

                            if (!_didIteratorError2) {
                                _context2.next = 48;
                                break;
                            }

                            throw _iteratorError2;

                        case 48:
                            return _context2.finish(45);

                        case 49:
                            return _context2.finish(42);

                        case 50:
                            if (!state.entities.roles.pending) {
                                _context2.next = 53;
                                break;
                            }

                            _context2.next = 53;
                            return setPendingRoles(new Set())(dispatch, getState);

                        case 53:
                            if (!(newRoles.size > 0)) {
                                _context2.next = 57;
                                break;
                            }

                            _context2.next = 56;
                            return getRolesByNames(newRoles)(dispatch, getState);

                        case 56:
                            return _context2.abrupt('return', _context2.sent);

                        case 57:
                            return _context2.abrupt('return', { data: state.entities.roles.roles });

                        case 58:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[5, 9, 13, 21], [14,, 16, 20], [34, 38, 42, 50], [43,, 45, 49]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deletePreferences = deletePreferences;
exports.getMyPreferences = getMyPreferences;
exports.makeDirectChannelVisibleIfNecessary = makeDirectChannelVisibleIfNecessary;
exports.makeGroupMessageVisibleIfNecessary = makeGroupMessageVisibleIfNecessary;
exports.savePreferences = savePreferences;

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _action_types = __webpack_require__(3);

var _preferences = __webpack_require__(784);

var _users = __webpack_require__(777);

var _preference_utils = __webpack_require__(284);

var _helpers = __webpack_require__(821);

var _users2 = __webpack_require__(786);

var _channels = __webpack_require__(798);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function deletePreferences(userId, preferences) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var state, myPreferences, currentPreferences;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            myPreferences = (0, _preferences.getMyPreferences)(state);
                            currentPreferences = preferences.map(function (pref) {
                                return myPreferences[(0, _preference_utils.getPreferenceKey)(pref.category, pref.name)];
                            });


                            dispatch({
                                type: _action_types.PreferenceTypes.DELETED_PREFERENCES,
                                data: preferences,
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.deletePreferences(userId, preferences);
                                        },
                                        commit: {
                                            type: _action_types.PreferenceTypes.DELETED_PREFERENCES
                                        },
                                        rollback: {
                                            type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                                            data: currentPreferences
                                        }
                                    }
                                }
                            });

                            return _context.abrupt('return', { data: true });

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function getMyPreferences() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyPreferences, _action_types.PreferenceTypes.MY_PREFERENCES_REQUEST, [_action_types.PreferenceTypes.RECEIVED_ALL_PREFERENCES, _action_types.PreferenceTypes.MY_PREFERENCES_SUCCESS], _action_types.PreferenceTypes.MY_PREFERENCES_FAILURE);
}

function makeDirectChannelVisibleIfNecessary(otherUserId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var state, myPreferences, currentUserId, preference;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            myPreferences = (0, _preferences.getMyPreferences)(state);
                            currentUserId = (0, _users.getCurrentUserId)(state);
                            preference = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, otherUserId)];


                            if (!preference || preference.value === 'false') {
                                preference = {
                                    user_id: currentUserId,
                                    category: _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW,
                                    name: otherUserId,
                                    value: 'true'
                                };
                                (0, _users2.getProfilesByIds)([otherUserId])(dispatch, getState);
                                savePreferences(currentUserId, [preference])(dispatch, getState);
                            }

                            return _context2.abrupt('return', { data: true });

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function makeGroupMessageVisibleIfNecessary(channelId) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var state, myPreferences, currentUserId, channels, preference;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = getState();
                            myPreferences = (0, _preferences.getMyPreferences)(state);
                            currentUserId = (0, _users.getCurrentUserId)(state);
                            channels = state.entities.channels.channels;
                            preference = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channelId)];


                            if (!preference || preference.value === 'false') {
                                preference = {
                                    user_id: currentUserId,
                                    category: _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW,
                                    name: channelId,
                                    value: 'true'
                                };

                                if (channels[channelId]) {
                                    (0, _channels.getMyChannelMember)(channelId)(dispatch, getState);
                                } else {
                                    (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState);
                                }

                                (0, _users2.getProfilesInChannel)(channelId, 0)(dispatch, getState);
                                savePreferences(currentUserId, [preference])(dispatch, getState);
                            }

                            return _context3.abrupt('return', { data: true });

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function savePreferences(userId, preferences) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                                data: preferences,
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.savePreferences(userId, preferences);
                                        },
                                        commit: {
                                            type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES
                                        },
                                        rollback: {
                                            type: _action_types.PreferenceTypes.DELETED_PREFERENCES,
                                            data: preferences
                                        }
                                    }
                                }
                            });

                            return _context4.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x7) {
            return _ref4.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _reactRedux = __webpack_require__(268);

var _roles = __webpack_require__(276);

var _system_permission_gate = __webpack_require__(1901);

var _system_permission_gate2 = _interopRequireDefault(_system_permission_gate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(ownProps.permissions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var permission = _step.value;

            if ((0, _roles.haveISystemPermission)(state, { permission: permission })) {
                return { hasPermission: true };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return { hasPermission: false };
} // Copyright (c) 2017 Mattermost Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_system_permission_gate2.default);

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _reactRedux = __webpack_require__(268);

var _roles = __webpack_require__(276);

var _team_permission_gate = __webpack_require__(1902);

var _team_permission_gate2 = _interopRequireDefault(_team_permission_gate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    if (!ownProps.teamId) {
        return { hasPermission: false };
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(ownProps.permissions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var permission = _step.value;

            if ((0, _roles.haveITeamPermission)(state, { team: ownProps.teamId, permission: permission })) {
                return { hasPermission: true };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return { hasPermission: false };
} // Copyright (c) 2017 Mattermost Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_team_permission_gate2.default);

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/1171271cb71e89919600b8c3ae1774cb.gif";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Provider = function () {
    function Provider() {
        (0, _classCallCheck3.default)(this, Provider);

        this.latestPrefix = '';
        this.latestComplete = true;
        this.disableDispatches = false;
    }

    (0, _createClass3.default)(Provider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, pretext) {// eslint-disable-line no-unused-vars
            // NO-OP for inherited classes to override
        }
    }, {
        key: 'startNewRequest',
        value: function startNewRequest(suggestionId, prefix) {
            this.latestPrefix = prefix;
            this.latestComplete = false;
        }
    }, {
        key: 'shouldCancelDispatch',
        value: function shouldCancelDispatch(prefix) {
            if (this.disableDispatches) {
                return true;
            }

            if (prefix === this.latestPrefix) {
                this.latestComplete = true;
            } else if (this.latestComplete) {
                return true;
            }

            return false;
        }
    }]);
    return Provider;
}();

exports.default = Provider;

/***/ }),
/* 867 */,
/* 868 */,
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(1378),
    baseIteratee = __webpack_require__(2194),
    baseMap = __webpack_require__(2250),
    isArray = __webpack_require__(833);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var logDisabled_ = true;
var deprecationWarnings_ = true;

/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */
function extractVersion(uastring, expr, pos) {
  var match = uastring.match(expr);
  return match && match.length >= pos && parseInt(match[pos], 10);
}

// Utility methods.
module.exports = {
  extractVersion: extractVersion,
  disableLog: function(bool) {
    if (typeof bool !== 'boolean') {
      return new Error('Argument type: ' + typeof bool +
          '. Please use a boolean.');
    }
    logDisabled_ = bool;
    return (bool) ? 'adapter.js logging disabled' :
        'adapter.js logging enabled';
  },

  /**
   * Disable or enable deprecation warnings
   * @param {!boolean} bool set to true to disable warnings.
   */
  disableWarnings: function(bool) {
    if (typeof bool !== 'boolean') {
      return new Error('Argument type: ' + typeof bool +
          '. Please use a boolean.');
    }
    deprecationWarnings_ = !bool;
    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
  },

  log: function() {
    if (typeof window === 'object') {
      if (logDisabled_) {
        return;
      }
      if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log.apply(console, arguments);
      }
    }
  },

  /**
   * Shows a deprecation warning suggesting the modern and spec-compatible API.
   */
  deprecated: function(oldMethod, newMethod) {
    if (!deprecationWarnings_) {
      return;
    }
    console.warn(oldMethod + ' is deprecated, please use ' + newMethod +
        ' instead.');
  },

  /**
   * Browser detector.
   *
   * @return {object} result containing browser and version
   *     properties.
   */
  detectBrowser: function(window) {
    var navigator = window && window.navigator;

    // Returned result object.
    var result = {};
    result.browser = null;
    result.version = null;

    // Fail early if it's not a browser
    if (typeof window === 'undefined' || !window.navigator) {
      result.browser = 'Not a browser.';
      return result;
    }

    // Firefox.
    if (navigator.mozGetUserMedia) {
      result.browser = 'firefox';
      result.version = extractVersion(navigator.userAgent,
          /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia) {
      // Chrome, Chromium, Webview, Opera, all use the chrome shim for now
      if (window.webkitRTCPeerConnection) {
        result.browser = 'chrome';
        result.version = extractVersion(navigator.userAgent,
          /Chrom(e|ium)\/(\d+)\./, 2);
      } else { // Safari (in an unpublished version) or unknown webkit-based.
        if (navigator.userAgent.match(/Version\/(\d+).(\d+)/)) {
          result.browser = 'safari';
          result.version = extractVersion(navigator.userAgent,
            /AppleWebKit\/(\d+)\./, 1);
        } else { // unknown webkit-based browser.
          result.browser = 'Unsupported webkit-based browser ' +
              'with GUM support but no WebRTC support.';
          return result;
        }
      }
    } else if (navigator.mediaDevices &&
        navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) { // Edge.
      result.browser = 'edge';
      result.version = extractVersion(navigator.userAgent,
          /Edge\/(\d+).(\d+)$/, 2);
    } else if (navigator.mediaDevices &&
        navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        // Safari, with webkitGetUserMedia removed.
      result.browser = 'safari';
      result.version = extractVersion(navigator.userAgent,
          /AppleWebKit\/(\d+)\./, 1);
    } else { // Default fallthrough: not supported.
      result.browser = 'Not a supported browser.';
      return result;
    }

    return result;
  }
};


/***/ }),
/* 871 */,
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dom = __webpack_require__(895);

var toInt = exports.toInt = function (x) {
  return parseInt(x, 10) || 0;
};

exports.isEditable = function (el) {
  return dom.matches(el, "input,[contenteditable]") ||
         dom.matches(el, "select,[contenteditable]") ||
         dom.matches(el, "textarea,[contenteditable]") ||
         dom.matches(el, "button,[contenteditable]");
};

exports.removePsClasses = function (element) {
  for (var i = 0; i < element.classList.length; i++) {
    var className = element.classList[i];
    if (className.indexOf('ps-') === 0) {
      element.classList.remove(className);
    }
  }
};

exports.outerWidth = function (element) {
  return toInt(dom.css(element, 'width')) +
         toInt(dom.css(element, 'paddingLeft')) +
         toInt(dom.css(element, 'paddingRight')) +
         toInt(dom.css(element, 'borderLeftWidth')) +
         toInt(dom.css(element, 'borderRightWidth'));
};

function psClasses(axis) {
  var classes = ['ps--in-scrolling'];
  var axisClasses;
  if (typeof axis === 'undefined') {
    axisClasses = ['ps--x', 'ps--y'];
  } else {
    axisClasses = ['ps--' + axis];
  }
  return classes.concat(axisClasses);
}

exports.startScrolling = function (element, axis) {
  var classes = psClasses(axis);
  for (var i = 0; i < classes.length; i++) {
    element.classList.add(classes[i]);
  }
};

exports.stopScrolling = function (element, axis) {
  var classes = psClasses(axis);
  for (var i = 0; i < classes.length; i++) {
    element.classList.remove(classes[i]);
  }
};

exports.env = {
  isWebKit: typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style,
  supportsTouch: typeof window !== 'undefined' && (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: typeof window !== 'undefined' && window.navigator.msMaxTouchPoints !== null
};


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(827);

var createDOMEvent = function (name) {
  var event = document.createEvent("Event");
  event.initEvent(name, true, true);
  return event;
};

module.exports = function (element, axis, value) {
  if (typeof element === 'undefined') {
    throw 'You must provide an element to the update-scroll function';
  }

  if (typeof axis === 'undefined') {
    throw 'You must provide an axis to the update-scroll function';
  }

  if (typeof value === 'undefined') {
    throw 'You must provide a value to the update-scroll function';
  }

  if (axis === 'top' && value <= 0) {
    element.scrollTop = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-y-reach-start'));
  }

  if (axis === 'left' && value <= 0) {
    element.scrollLeft = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-x-reach-start'));
  }

  var i = instances.get(element);

  if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
    // don't allow scroll past container
    value = i.contentHeight - i.containerHeight;
    if (value - element.scrollTop <= 2) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollTop;
    } else {
      element.scrollTop = value;
    }
    element.dispatchEvent(createDOMEvent('ps-y-reach-end'));
  }

  if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
    // don't allow scroll past container
    value = i.contentWidth - i.containerWidth;
    if (value - element.scrollLeft <= 2) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollLeft;
    } else {
      element.scrollLeft = value;
    }
    element.dispatchEvent(createDOMEvent('ps-x-reach-end'));
  }

  if (i.lastTop === undefined) {
    i.lastTop = element.scrollTop;
  }

  if (i.lastLeft === undefined) {
    i.lastLeft = element.scrollLeft;
  }

  if (axis === 'top' && value < i.lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-up'));
  }

  if (axis === 'top' && value > i.lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-down'));
  }

  if (axis === 'left' && value < i.lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-left'));
  }

  if (axis === 'left' && value > i.lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-right'));
  }

  if (axis === 'top' && value !== i.lastTop) {
    element.scrollTop = i.lastTop = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-y'));
  }

  if (axis === 'left' && value !== i.lastLeft) {
    element.scrollLeft = i.lastLeft = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-x'));
  }

};


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	// All support tests are defined in their respective modules.
	return {};
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(896),
	__webpack_require__(807)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, toType, isFunction ) {

"use strict";

// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};

return access;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};

return nodeName;

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCustomEmojiIdsSortedByName = exports.getCustomEmojisByName = exports.getCustomEmojisAsMap = undefined;
exports.getCustomEmojis = getCustomEmojis;

var _reselect = __webpack_require__(78);

var _helpers = __webpack_require__(117);

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
function getCustomEmojis(state) {
    return state.entities.emojis.customEmoji;
}

var getCustomEmojisAsMap = exports.getCustomEmojisAsMap = (0, _reselect.createSelector)(getCustomEmojis, function (emojis) {
    var map = new Map();
    Object.keys(emojis).forEach(function (key) {
        map.set(key, emojis[key]);
    });
    return map;
});

var getCustomEmojisByName = exports.getCustomEmojisByName = (0, _reselect.createSelector)(getCustomEmojis, function (emojis) {
    var map = new Map();

    Object.keys(emojis).forEach(function (key) {
        map.set(emojis[key].name, emojis[key]);
    });

    return map;
});

var getCustomEmojiIdsSortedByName = exports.getCustomEmojiIdsSortedByName = (0, _helpers.createIdsSelector)(function (state) {
    return state.entities.emojis.customEmoji;
}, function (emojis) {
    return Object.keys(emojis).sort(function (a, b) {
        return emojis[a].name.localeCompare(emojis[b].name);
    });
});

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var _isPlaceholder = /*#__PURE__*/__webpack_require__(948);

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}
module.exports = _curry1;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(1720);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1737)();
}


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _preferences = __webpack_require__(784);

var _pluggable = __webpack_require__(1762);

var _pluggable2 = _interopRequireDefault(_pluggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        components: state.plugins.components,
        theme: (0, _preferences.getTheme)(state)
    });
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_pluggable2.default);

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _users = __webpack_require__(777);

var _roles = __webpack_require__(276);

var _constants = __webpack_require__(19);

var _general = __webpack_require__(113);

var _announcement_bar = __webpack_require__(1893);

var _announcement_bar2 = _interopRequireDefault(_announcement_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var canViewSystemErrors = (0, _roles.haveISystemPermission)(state, { permission: _constants.Permissions.MANAGE_SYSTEM });
    var canViewAPIv3Banner = (0, _roles.haveISystemPermission)(state, { permission: _constants.Permissions.MANAGE_SYSTEM });
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    var licenseId = license.Id;
    var siteURL = config.SiteURL;
    var sendEmailNotifications = config.SendEmailNotifications === 'true';
    var bannerText = config.BannerText;
    var allowBannerDismissal = config.AllowBannerDismissal === 'true';
    var enableBanner = config.EnableBanner === 'true';
    var bannerColor = config.BannerColor;
    var bannerTextColor = config.BannerTextColor;
    var enableSignUpWithGitLab = config.EnableSignUpWithGitLab === 'true';

    return {
        isLoggedIn: Boolean((0, _users.getCurrentUserId)(state)),
        canViewSystemErrors: canViewSystemErrors,
        canViewAPIv3Banner: canViewAPIv3Banner,
        licenseId: licenseId,
        siteURL: siteURL,
        sendEmailNotifications: sendEmailNotifications,
        bannerText: bannerText,
        allowBannerDismissal: allowBannerDismissal,
        enableBanner: enableBanner,
        bannerColor: bannerColor,
        bannerTextColor: bannerTextColor,
        enableSignUpWithGitLab: enableSignUpWithGitLab
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_announcement_bar2.default);

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _ = __webpack_require__(1954);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EmojiPickerOverlay = function (_React$PureComponent) {
    (0, _inherits3.default)(EmojiPickerOverlay, _React$PureComponent);

    function EmojiPickerOverlay(props) {
        (0, _classCallCheck3.default)(this, EmojiPickerOverlay);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiPickerOverlay.__proto__ || (0, _getPrototypeOf2.default)(EmojiPickerOverlay)).call(this, props));

        _this.state = {
            placement: 'top'
        };
        return _this;
    }

    // Reasonable defaults calculated from from the center channel


    (0, _createClass3.default)(EmojiPickerOverlay, [{
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            if (nextProps.show && !this.props.show) {
                var targetBounds = nextProps.target().getBoundingClientRect();

                var placement = void 0;
                if (targetBounds.top > nextProps.spaceRequiredAbove) {
                    placement = 'top';
                } else if (window.innerHeight - targetBounds.bottom > nextProps.spaceRequiredBelow) {
                    placement = 'bottom';
                } else {
                    placement = 'left';
                }

                this.setState({ placement: placement });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactBootstrap.Overlay,
                {
                    show: this.props.show,
                    placement: this.state.placement,
                    rootClose: true,
                    container: this.props.container,
                    onHide: this.props.onHide,
                    target: this.props.target,
                    animation: false
                },
                _react2.default.createElement(_2.default, {
                    onEmojiClick: this.props.onEmojiClick,
                    rightOffset: this.props.rightOffset,
                    topOffset: this.props.topOffset
                })
            );
        }
    }]);
    return EmojiPickerOverlay;
}(_react2.default.PureComponent);

EmojiPickerOverlay.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    container: _propTypes2.default.func,
    target: _propTypes2.default.func.isRequired,
    onEmojiClick: _propTypes2.default.func.isRequired,
    onHide: _propTypes2.default.func.isRequired,
    rightOffset: _propTypes2.default.number,
    topOffset: _propTypes2.default.number,
    spaceRequiredAbove: _propTypes2.default.number,
    spaceRequiredBelow: _propTypes2.default.number };
EmojiPickerOverlay.defaultProps = {
    spaceRequiredAbove: 422,
    spaceRequiredBelow: 436
};
exports.default = EmojiPickerOverlay;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(928),
    getRawTag = __webpack_require__(1958),
    objectToString = __webpack_require__(1959);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 885 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFormattedFileSize = getFormattedFileSize;
exports.getFileType = getFileType;
exports.lookupMimeType = lookupMimeType;
exports.getFileUrl = getFileUrl;
exports.getFileDownloadUrl = getFileDownloadUrl;
exports.getFileThumbnailUrl = getFileThumbnailUrl;
exports.getFilePreviewUrl = getFilePreviewUrl;

var _constants = __webpack_require__(19);

var _client = __webpack_require__(270);

var _mimeDb = __webpack_require__(2021);

var _mimeDb2 = _interopRequireDefault(_mimeDb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFormattedFileSize(file) {
    var bytes = file.size;
    var fileSizes = [['TB', 1024 * 1024 * 1024 * 1024], ['GB', 1024 * 1024 * 1024], ['MB', 1024 * 1024], ['KB', 1024]];
    var size = fileSizes.find(function (unitAndMinBytes) {
        var minBytes = unitAndMinBytes[1];
        return bytes > minBytes;
    });
    if (size) {
        return Math.floor(bytes / size[1]) + ' ' + size[0];
    }
    return bytes + ' B';
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getFileType(file) {
    if (!file || !file.extension) {
        return 'other';
    }

    var fileExt = file.extension.toLowerCase();
    var fileTypes = ['image', 'code', 'pdf', 'video', 'audio', 'spreadsheet', 'word', 'presentation', 'patch'];
    return fileTypes.find(function (fileType) {
        var constForFileTypeExtList = (fileType + '_types').toUpperCase();
        var fileTypeExts = _constants.Files[constForFileTypeExtList];
        return fileTypeExts.indexOf(fileExt) > -1;
    }) || 'other';
}

var extToMime = void 0;
function buildExtToMime() {
    extToMime = {};
    Object.keys(_mimeDb2.default).forEach(function (key) {
        var mime = _mimeDb2.default[key];
        if (mime.extensions) {
            mime.extensions.forEach(function (ext) {
                extToMime[ext] = key;
            });
        }
    });
}

function lookupMimeType(filename) {
    if (!extToMime) {
        buildExtToMime();
    }

    var ext = filename.split('.').pop();

    return extToMime[ext] || 'application/octet-stream';
}

function getFileUrl(fileId) {
    return _client.Client4.getFileRoute(fileId);
}

function getFileDownloadUrl(fileId) {
    return _client.Client4.getFileRoute(fileId) + '?download=1';
}

function getFileThumbnailUrl(fileId) {
    return _client.Client4.getFileRoute(fileId) + '/thumbnail';
}

function getFilePreviewUrl(fileId) {
    return _client.Client4.getFileRoute(fileId) + '/preview';
}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canUploadFiles = canUploadFiles;
exports.canDownloadFiles = canDownloadFiles;
exports.trimFilename = trimFilename;

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function canUploadFiles(config) {
    var enableFileAttachments = config.EnableFileAttachments === 'true';
    var enableMobileFileUpload = config.EnableMobileFileUpload === 'true';

    if (!enableFileAttachments) {
        return false;
    }

    if (UserAgent.isMobileApp()) {
        return enableMobileFileUpload;
    }

    return true;
}

function canDownloadFiles(config) {
    if (UserAgent.isMobileApp()) {
        return config.EnableMobileFileDownload === 'true';
    }

    return true;
}

function trimFilename(filename) {
    var trimmedFilename = filename;
    if (filename.length > _constants2.default.MAX_FILENAME_LENGTH) {
        trimmedFilename = filename.substring(0, Math.min(_constants2.default.MAX_FILENAME_LENGTH, filename.length)) + '...';
    }

    return trimmedFilename;
}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _reactRedux = __webpack_require__(268);

var _roles = __webpack_require__(276);

var _channel_permission_gate = __webpack_require__(2054);

var _channel_permission_gate2 = _interopRequireDefault(_channel_permission_gate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    if (!ownProps.teamId || !ownProps.channelId) {
        return { hasPermission: false };
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(ownProps.permissions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var permission = _step.value;

            if ((0, _roles.haveIChannelPermission)(state, { channel: ownProps.channelId, team: ownProps.teamId, permission: permission })) {
                return { hasPermission: true };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return { hasPermission: false };
} // Copyright (c) 2017 Mattermost Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_channel_permission_gate2.default);

/***/ }),
/* 889 */,
/* 890 */,
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(2207),
    getValue = __webpack_require__(2210);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(987);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(79);
util.inherits = __webpack_require__(77);
/*</replacement>*/

var Readable = __webpack_require__(1426);
var Writable = __webpack_require__(1093);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(2528);
hash.common = __webpack_require__(2529);
hash.sha = __webpack_require__(2530);
hash.ripemd = __webpack_require__(2531);
hash.hmac = __webpack_require__(2532);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOM = {};

DOM.create = function (tagName, className) {
  var element = document.createElement(tagName);
  element.className = className;
  return element;
};

DOM.appendTo = function (child, parent) {
  parent.appendChild(child);
  return child;
};

function cssGet(element, styleName) {
  return window.getComputedStyle(element)[styleName];
}

function cssSet(element, styleName, styleValue) {
  if (typeof styleValue === 'number') {
    styleValue = styleValue.toString() + 'px';
  }
  element.style[styleName] = styleValue;
  return element;
}

function cssMultiSet(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val.toString() + 'px';
    }
    element.style[key] = val;
  }
  return element;
}

DOM.css = function (element, styleNameOrObject, styleValue) {
  if (typeof styleNameOrObject === 'object') {
    // multiple set with object
    return cssMultiSet(element, styleNameOrObject);
  } else {
    if (typeof styleValue === 'undefined') {
      return cssGet(element, styleNameOrObject);
    } else {
      return cssSet(element, styleNameOrObject, styleValue);
    }
  }
};

DOM.matches = function (element, query) {
  if (typeof element.matches !== 'undefined') {
    return element.matches(query);
  } else {
    // must be IE11 and Edge
    return element.msMatchesSelector(query);
  }
};

DOM.remove = function (element) {
  if (typeof element.remove !== 'undefined') {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
};

DOM.queryChildren = function (element, selector) {
  return Array.prototype.filter.call(element.childNodes, function (child) {
    return DOM.matches(child, selector);
  });
};

module.exports = DOM;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(943),
	__webpack_require__(1103)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( class2type, toString ) {

"use strict";

function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}

return toType;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(807),
	__webpack_require__(944),
	__webpack_require__(1008)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, isFunction, slice ) {

"use strict";

function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1001),
	__webpack_require__(1588),
	__webpack_require__(1589),
	__webpack_require__(1112),
	__webpack_require__(876),

	__webpack_require__(834),
	__webpack_require__(1111),
	__webpack_require__(815)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, indexOf, dir, siblings, rneedsContext, nodeName ) {

"use strict";

var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(812),
	__webpack_require__(1007),
	__webpack_require__(807),
	__webpack_require__(859),
	__webpack_require__(944),
	__webpack_require__(844),
	__webpack_require__(876),

	__webpack_require__(834),
	__webpack_require__(815)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, documentElement, isFunction, rnothtmlwhite,
	slice, dataPriv, nodeName ) {

"use strict";

var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(812),
	__webpack_require__(807),
	__webpack_require__(859),
	__webpack_require__(1603),
	__webpack_require__(1126),
	__webpack_require__(1125),

	__webpack_require__(834),
	__webpack_require__(1604),
	__webpack_require__(1014),
	__webpack_require__(897),
	__webpack_require__(1127) // jQuery.param
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, isFunction, rnothtmlwhite, location, nonce, rquery ) {

"use strict";

var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1130), __esModule: true };

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(862);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(902);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initWebrtc = initWebrtc;
exports.handle = handle;
exports.webrtcToken = webrtcToken;

var _client = __webpack_require__(270);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initWebrtc(userId, isCalling) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.WebrtcActionTypes.INITIALIZE,
        user_id: userId,
        is_calling: isCalling
    });
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function handle(message) {
    _app_dispatcher2.default.handleServerAction({
        type: message.action,
        message: message
    });
}

function webrtcToken(success, error) {
    _client.Client4.webrtcToken().then(function (data) {
        if (success) {
            success(data);
        }
    }).catch(function () {
        if (error) {
            error();
        }
    });
}

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'change';

var LocalizationStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(LocalizationStoreClass, _EventEmitter);

    function LocalizationStoreClass() {
        (0, _classCallCheck3.default)(this, LocalizationStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocalizationStoreClass.__proto__ || (0, _getPrototypeOf2.default)(LocalizationStoreClass)).call(this));

        _this.currentLocale = 'en';
        _this.currentTranslations = null;
        return _this;
    }

    (0, _createClass3.default)(LocalizationStoreClass, [{
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'setCurrentLocale',
        value: function setCurrentLocale(locale, translations) {
            this.currentLocale = locale;
            this.currentTranslations = translations;
        }
    }, {
        key: 'getLocale',
        value: function getLocale() {
            return this.currentLocale;
        }
    }, {
        key: 'getTranslations',
        value: function getTranslations() {
            return this.currentTranslations;
        }
    }]);
    return LocalizationStoreClass;
}(_events2.default);

var LocalizationStore = new LocalizationStoreClass();
LocalizationStore.setMaxListeners(0);

LocalizationStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case ActionTypes.RECEIVED_LOCALE:
            LocalizationStore.setCurrentLocale(action.locale, action.translations);
            LocalizationStore.emitChange();
            break;
        default:
    }
});

exports.default = LocalizationStore;

/***/ }),
/* 907 */,
/* 908 */,
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmojiIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(EmojiIcon, _React$PureComponent);

    function EmojiIcon() {
        (0, _classCallCheck3.default)(this, EmojiIcon);
        return (0, _possibleConstructorReturn3.default)(this, (EmojiIcon.__proto__ || (0, _getPrototypeOf2.default)(EmojiIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(EmojiIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '15px',
                        height: '15px',
                        viewBox: '0 0 15 15'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-1071.000000, -954.000000)',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                { transform: 'translate(25.000000, 937.000000)' },
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(1046.000000, 17.000000)' },
                                    _react2.default.createElement('path', { d: 'M7.5,0.0852272727 C3.405,0.0852272727 0.0852272727,3.405 0.0852272727,7.5 C0.0852272727,11.595 3.405,14.9147727 7.5,14.9147727 C11.595,14.9147727 14.9147727,11.595 14.9147727,7.5 C14.9147727,3.405 11.595,0.0852272727 7.5,0.0852272727 Z M7.5,14.0663436 C3.87926951,14.0663436 0.933656417,11.1207305 0.933656417,7.5 C0.933656417,3.87926951 3.87926951,0.933656417 7.5,0.933656417 C11.1207305,0.933656417 14.0663436,3.87926951 14.0663436,7.5 C14.0663436,11.1207305 11.1207305,14.0663436 7.5,14.0663436 Z' }),
                                    _react2.default.createElement('path', { d: 'M11.7732955,8.95397727 C12.0119318,8.90488636 12.2159659,9.11778409 12.1684091,9.35676136 C11.8063636,11.1790909 9.85346591,12.5710227 7.49846591,12.5710227 C5.15096591,12.5710227 3.20284091,11.1877841 2.83193182,9.37397727 C2.78181818,9.129375 2.99267045,8.911875 3.23744318,8.96198864 C4.85369318,9.29232955 10.1786932,9.28142045 11.7732955,8.95397727 Z' }),
                                    _react2.default.createElement('ellipse', {
                                        cx: '4.94318182',
                                        cy: '5.50431818',
                                        rx: '1',
                                        ry: '1.06534091'
                                    }),
                                    _react2.default.createElement('ellipse', {
                                        cx: '10.0568182',
                                        cy: '5.50431818',
                                        rx: '1',
                                        ry: '1.06534091'
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return EmojiIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = EmojiIcon;

/***/ }),
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
var inherits = __webpack_require__(77)
var md5 = __webpack_require__(1423)
var rmd160 = __webpack_require__(2488)
var sha = __webpack_require__(2489)

var Base = __webpack_require__(916)

function HashNoConstructor(hash) {
  Base.call(this, 'digest')

  this._hash = hash
  this.buffers = []
}

inherits(HashNoConstructor, Base)

HashNoConstructor.prototype._update = function (data) {
  this.buffers.push(data)
}

HashNoConstructor.prototype._final = function () {
  var buf = Buffer.concat(this.buffers)
  var r = this._hash(buf)
  this.buffers = null

  return r
}

function Hash(hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if ('md5' === alg) return new HashNoConstructor(md5)
  if ('rmd160' === alg || 'ripemd160' === alg) return new HashNoConstructor(rmd160)

  return new Hash(sha(alg))
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = new Buffer(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
  this._s = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = new Buffer(data, enc)
  }

  var l = this._len += data.length
  var s = this._s || 0
  var f = 0
  var buffer = this._block

  while (s < l) {
    var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
    var ch = (t - f)

    for (var i = 0; i < ch; i++) {
      buffer[(s % this._blockSize) + i] = data[i + f]
    }

    s += ch
    f += ch

    if ((s % this._blockSize) === 0) {
      this._update(buffer)
    }
  }
  this._s = s

  return this
}

Hash.prototype.digest = function (enc) {
  // Suppose the length of the message M, in bits, is l
  var l = this._len * 8

  // Append the bit 1 to the end of the message
  this._block[this._len % this._blockSize] = 0x80

  // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
  this._block.fill(0, this._len % this._blockSize + 1)

  if (l % (this._blockSize * 8) >= this._finalSize * 8) {
    this._update(this._block)
    this._block.fill(0)
  }

  // to this append the block which is equal to the number l written in binary
  // TODO: handle case where l is > Math.pow(2, 29)
  this._block.writeInt32BE(l, this._blockSize - 4)

  var hash = this._update(this._block) || this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(1090).Transform
var inherits = __webpack_require__(77)
var StringDecoder = __webpack_require__(179).StringDecoder
module.exports = CipherBase
inherits(CipherBase, Transform)
function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  this._decoder = null
  this._encoding = null
}
CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = new Buffer(data, inputEnc)
  }
  var outData = this._update(data)
  if (this.hashMode) {
    return this
  }
  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }
  return outData
}

CipherBase.prototype.setAutoPadding = function () {}

CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this._final())
  } catch (e) {
    err = e
  } finally {
    done(err)
  }
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this._final() || new Buffer('')
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }
  if (this._encoding !== enc) {
    throw new Error('can\'t switch encodings')
  }
  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }
  return out
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1003),
	__webpack_require__(875),
	__webpack_require__(920),
	__webpack_require__(812),
	__webpack_require__(1002),
	__webpack_require__(1004),
	__webpack_require__(1005),
	__webpack_require__(1106),
	__webpack_require__(1100),
	__webpack_require__(1107),
	__webpack_require__(1108),
	__webpack_require__(1109),
	__webpack_require__(1006),

	__webpack_require__(834),
	__webpack_require__(1113),
	__webpack_require__(815) // contains
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, pnum, access, camelCase, document, rcssNum, rnumnonpx, cssExpand,
	getStyles, swap, curCSS, adjustCSS, addGetHookIf, support ) {

"use strict";

var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return [];
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}

return camelCase;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.batchActions = batchActions;
exports.enableBatching = enableBatching;
exports.batchDispatchMiddleware = batchDispatchMiddleware;
var BATCH = exports.BATCH = 'BATCHING_REDUCER.BATCH';

function batchActions(actions) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BATCH;

	return { type: type, meta: { batch: true }, payload: actions };
}

function enableBatching(reduce) {
	return function batchingReducer(state, action) {
		if (action && action.meta && action.meta.batch) {
			return action.payload.reduce(batchingReducer, state);
		}
		return reduce(state, action);
	};
}

function batchDispatchMiddleware(store) {
	function dispatchChildActions(store, action) {
		if (action.meta && action.meta.batch) {
			action.payload.forEach(function (childAction) {
				dispatchChildActions(store, childAction);
			});
		} else {
			store.dispatch(action);
		}
	}

	return function (next) {
		return function (action) {
			dispatchChildActions(store, action);
			next(action);
		};
	};
}

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(1145);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(1726);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(1728);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(1729);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(1023);

var _isTransform = __webpack_require__(1730);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserCurrentTimezone = getUserCurrentTimezone;
exports.getTimezoneRegion = getTimezoneRegion;
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getUserCurrentTimezone(userTimezone) {
    if (!userTimezone) {
        return null;
    }
    var useAutomaticTimezone = userTimezone.useAutomaticTimezone,
        automaticTimezone = userTimezone.automaticTimezone,
        manualTimezone = userTimezone.manualTimezone;


    var useAutomatic = useAutomaticTimezone;
    if (typeof useAutomaticTimezone === 'string') {
        useAutomatic = useAutomaticTimezone === 'true';
    }

    if (useAutomatic) {
        return automaticTimezone;
    }
    return manualTimezone;
}

function getTimezoneRegion(timezone) {
    if (timezone) {
        var split = timezone.split('/');
        if (split.length > 1) {
            return split.pop().replace(/_/g, ' ');
        }
    }

    return timezone;
}

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAllLanguages = getAllLanguages;
exports.getLanguages = getLanguages;
exports.getLanguageInfo = getLanguageInfo;
exports.isLanguageAvailable = isLanguageAvailable;
exports.safariFix = safariFix;
exports.doAddLocaleData = doAddLocaleData;

var _reactIntl = __webpack_require__(761);

var _de = __webpack_require__(1840);

var _de2 = _interopRequireDefault(_de);

var _en = __webpack_require__(1841);

var _en2 = _interopRequireDefault(_en);

var _es = __webpack_require__(1842);

var _es2 = _interopRequireDefault(_es);

var _fr = __webpack_require__(1843);

var _fr2 = _interopRequireDefault(_fr);

var _it = __webpack_require__(1844);

var _it2 = _interopRequireDefault(_it);

var _ja = __webpack_require__(1845);

var _ja2 = _interopRequireDefault(_ja);

var _ko = __webpack_require__(1846);

var _ko2 = _interopRequireDefault(_ko);

var _nl = __webpack_require__(1847);

var _nl2 = _interopRequireDefault(_nl);

var _pl = __webpack_require__(1848);

var _pl2 = _interopRequireDefault(_pl);

var _pt = __webpack_require__(1849);

var _pt2 = _interopRequireDefault(_pt);

var _tr = __webpack_require__(1850);

var _tr2 = _interopRequireDefault(_tr);

var _ru = __webpack_require__(1851);

var _ru2 = _interopRequireDefault(_ru);

var _zh = __webpack_require__(1852);

var _zh2 = _interopRequireDefault(_zh);

var _general = __webpack_require__(113);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/* eslint-disable import/order */
var de = __webpack_require__(1853);

var es = __webpack_require__(1854);

var fr = __webpack_require__(1855);

var it = __webpack_require__(1856);

var ja = __webpack_require__(1857);

var ko = __webpack_require__(1858);

var nl = __webpack_require__(1859);

var pl = __webpack_require__(1860);

var ptBR = __webpack_require__(1861);

//eslint-disable-line camelcase
var tr = __webpack_require__(1862);

var ru = __webpack_require__(1863);

var zhTW = __webpack_require__(1864);

//eslint-disable-line camelcase
var zhCN = __webpack_require__(1865); //eslint-disable-line camelcase

// should match the values in model/config.go
var languages = {
    de: {
        value: 'de',
        name: 'Deutsch',
        order: 0,
        url: de
    },
    en: {
        value: 'en',
        name: 'English',
        order: 1,
        url: ''
    },
    es: {
        value: 'es',
        name: 'Español',
        order: 2,
        url: es
    },
    fr: {
        value: 'fr',
        name: 'Français',
        order: 3,
        url: fr
    },
    it: {
        value: 'it',
        name: 'Italiano',
        order: 4,
        url: it
    },
    ja: {
        value: 'ja',
        name: '日本語',
        order: 13,
        url: ja
    },
    ko: {
        value: 'ko',
        name: '한국어 (Alpha)',
        order: 10,
        url: ko
    },
    nl: {
        value: 'nl',
        name: 'Nederlands (Alpha)',
        order: 5,
        url: nl
    },
    pl: {
        value: 'pl',
        name: 'Polski (Alpha)',
        order: 6,
        url: pl
    },
    'pt-BR': {
        value: 'pt-BR',
        name: 'Português (Brasil)',
        order: 7,
        url: ptBR
    },
    tr: {
        value: 'tr',
        name: 'Türkçe',
        order: 8,
        url: tr
    },
    ru: {
        value: 'ru',
        name: 'Pусский (Alpha)',
        order: 9,
        url: ru
    },
    'zh-TW': {
        value: 'zh-TW',
        name: '中文 (繁體)',
        order: 12,
        url: zhTW
    },
    'zh-CN': {
        value: 'zh-CN',
        name: '中文 (简体)',
        order: 11,
        url: zhCN
    }
};

function getAllLanguages() {
    return languages;
}

function getLanguages() {
    var config = (0, _general.getConfig)(_redux_store2.default.getState());
    if (!config.AvailableLocales) {
        return getAllLanguages();
    }

    return config.AvailableLocales.split(',').filter(function (l) {
        return languages[l];
    }).map(function (l) {
        return languages[l];
    });
}

function getLanguageInfo(locale) {
    return getAllLanguages()[locale];
}

function isLanguageAvailable(locale) {
    return Boolean(getLanguages()[locale]);
}

function safariFix(callback) {
    __webpack_require__.e/* require.ensure */(5).then((function (require) {
        __webpack_require__(1162);
        __webpack_require__(1163);
        __webpack_require__(1164);
        __webpack_require__(1165);
        __webpack_require__(1166);
        __webpack_require__(1167);
        __webpack_require__(1168);
        __webpack_require__(1169);
        __webpack_require__(1170);
        __webpack_require__(1171);
        __webpack_require__(1172);
        __webpack_require__(1173);
        __webpack_require__(1174);
        __webpack_require__(1175);
        callback();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

function doAddLocaleData() {
    (0, _reactIntl.addLocaleData)(_en2.default);
    (0, _reactIntl.addLocaleData)(_de2.default);
    (0, _reactIntl.addLocaleData)(_es2.default);
    (0, _reactIntl.addLocaleData)(_fr2.default);
    (0, _reactIntl.addLocaleData)(_it2.default);
    (0, _reactIntl.addLocaleData)(_ja2.default);
    (0, _reactIntl.addLocaleData)(_ko2.default);
    (0, _reactIntl.addLocaleData)(_nl2.default);
    (0, _reactIntl.addLocaleData)(_pl2.default);
    (0, _reactIntl.addLocaleData)(_pt2.default);
    (0, _reactIntl.addLocaleData)(_tr2.default);
    (0, _reactIntl.addLocaleData)(_ru2.default);
    (0, _reactIntl.addLocaleData)(_zh2.default);
}

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(762);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveButton = function (_React$PureComponent) {
    (0, _inherits3.default)(SaveButton, _React$PureComponent);

    function SaveButton() {
        (0, _classCallCheck3.default)(this, SaveButton);
        return (0, _possibleConstructorReturn3.default)(this, (SaveButton.__proto__ || (0, _getPrototypeOf2.default)(SaveButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(SaveButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                saving = _props.saving,
                disabled = _props.disabled,
                savingMessage = _props.savingMessage,
                defaultMessage = _props.defaultMessage,
                btnClass = _props.btnClass,
                extraClasses = _props.extraClasses,
                props = (0, _objectWithoutProperties3.default)(_props, ['saving', 'disabled', 'savingMessage', 'defaultMessage', 'btnClass', 'extraClasses']); // eslint-disable-line no-use-before-define

            var contents = void 0;
            if (saving) {
                contents = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('span', { className: 'fa fa-refresh icon--rotate' }),
                    savingMessage
                );
            } else {
                contents = defaultMessage;
            }

            var className = 'save-button btn';
            if (!disabled || saving) {
                className += ' ' + btnClass;
            }

            if (extraClasses) {
                className += ' ' + extraClasses;
            }

            return _react2.default.createElement(
                'button',
                (0, _extends3.default)({
                    type: 'submit',
                    id: 'saveSetting',
                    className: className,
                    disabled: disabled
                }, props),
                contents
            );
        }
    }]);
    return SaveButton;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SaveButton.propTypes = {
    saving: _propTypes2.default.bool.isRequired,
    disabled: _propTypes2.default.bool,
    savingMessage: _propTypes2.default.node,
    defaultMessage: _propTypes2.default.node,
    btnClass: _propTypes2.default.string,
    extraClasses: _propTypes2.default.string
};
SaveButton.defaultProps = {
    disabled: false,
    savingMessage: (0, _utils.localizeMessage)('save_button.saving', 'Saving'),
    defaultMessage: (0, _utils.localizeMessage)('save_button.save', 'Save'),
    btnClass: 'btn-primary',
    extraClasses: ''
};
exports.default = SaveButton;

/***/ }),
/* 926 */,
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openModal = openModal;
exports.closeModal = closeModal;

var _constants = __webpack_require__(29);

function openModal(modalData) {
    return function (dispatch) {
        var action = {
            type: _constants.ActionTypes.MODAL_OPEN,
            modalId: modalData.modalId,
            dialogProps: modalData.dialogProps,
            dialogType: modalData.dialogType
        };

        dispatch(action);
    };
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function closeModal(modalId) {
    return function (dispatch) {
        var action = {
            type: _constants.ActionTypes.MODAL_CLOSE,
            modalId: modalId
        };

        dispatch(action);
    };
}

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(836);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _deleteProperty = __webpack_require__(176);

var _deleteProperty2 = _interopRequireDefault(_deleteProperty);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _quick_input = __webpack_require__(1038);

var _quick_input2 = _interopRequireDefault(_quick_input);

var _suggestion_store = __webpack_require__(969);

var _suggestion_store2 = _interopRequireDefault(_suggestion_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyCodes = _constants2.default.KeyCodes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SuggestionBox = function (_React$Component) {
    (0, _inherits3.default)(SuggestionBox, _React$Component);

    function SuggestionBox(props) {
        (0, _classCallCheck3.default)(this, SuggestionBox);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SuggestionBox.__proto__ || (0, _getPrototypeOf2.default)(SuggestionBox)).call(this, props));

        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);

        _this.handlePopoverMentionKeyClick = _this.handlePopoverMentionKeyClick.bind(_this);
        _this.handleCompleteWord = _this.handleCompleteWord.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleCompositionStart = _this.handleCompositionStart.bind(_this);
        _this.handleCompositionUpdate = _this.handleCompositionUpdate.bind(_this);
        _this.handleCompositionEnd = _this.handleCompositionEnd.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handlePretextChanged = _this.handlePretextChanged.bind(_this);
        _this.blur = _this.blur.bind(_this);

        _this.suggestionId = Utils.generateId();
        _suggestion_store2.default.registerSuggestionBox(_this.suggestionId);

        // Keep track of whether we're composing a CJK character so we can make suggestions for partial characters
        _this.composing = false;
        return _this;
    }

    (0, _createClass3.default)(SuggestionBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.popoverMentionKeyClick) {
                _suggestion_store2.default.addPopoverMentionKeyClickListener(this.props.isRHS, this.handlePopoverMentionKeyClick);
            }
            _suggestion_store2.default.addPretextChangedListener(this.suggestionId, this.handlePretextChanged);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.popoverMentionKeyClick) {
                _suggestion_store2.default.removePopoverMentionKeyClickListener(this.props.isRHS, this.handlePopoverMentionKeyClick);
            }
            _suggestion_store2.default.removePretextChangedListener(this.suggestionId, this.handlePretextChanged);

            _suggestion_store2.default.unregisterSuggestionBox(this.suggestionId);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.providers !== prevProps.providers) {
                var textbox = this.getTextbox();
                var pretext = textbox.value.substring(0, textbox.selectionEnd);
                GlobalActions.emitSuggestionPretextChanged(this.suggestionId, pretext);
            }
        }
    }, {
        key: 'getTextbox',
        value: function getTextbox() {
            var input = this.refs.input.getInput();

            if (input.getDOMNode) {
                return input.getDOMNode();
            }

            return input;
        }
    }, {
        key: 'recalculateSize',
        value: function recalculateSize() {
            // Pretty hacky way to force an AutosizeTextarea to recalculate its height if that's what
            // we're rendering as the input
            var input = this.refs.input.getInput();

            if (input.recalculateSize) {
                input.recalculateSize();
            }
        }
    }, {
        key: 'handleBlur',
        value: function handleBlur() {
            var _this2 = this;

            setTimeout(function () {
                // Delay this slightly so that we don't clear the suggestions before we run click handlers on SuggestionList
                GlobalActions.emitClearSuggestions(_this2.suggestionId);
            }, 200);

            if (this.props.onBlur) {
                this.props.onBlur();
            }
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus() {
            var _this3 = this;

            if (this.props.openOnFocus || this.props.openWhenEmpty) {
                setTimeout(function () {
                    var textbox = _this3.getTextbox();
                    if (textbox) {
                        var pretext = textbox.value.substring(0, textbox.selectionEnd);
                        if (_this3.props.openWhenEmpty || pretext.length >= _this3.props.requiredCharacters) {
                            GlobalActions.emitSuggestionPretextChanged(_this3.suggestionId, pretext);
                        }
                    }
                });
            }

            if (this.props.onFocus) {
                this.props.onFocus();
            }
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var textbox = this.getTextbox();
            var pretext = textbox.value.substring(0, textbox.selectionEnd);

            if (!this.composing && _suggestion_store2.default.getPretext(this.suggestionId) !== pretext && (this.props.openWhenEmpty || pretext.length >= this.props.requiredCharacters)) {
                GlobalActions.emitSuggestionPretextChanged(this.suggestionId, pretext);
            }

            if (this.props.onChange) {
                this.props.onChange(e);
            }
        }
    }, {
        key: 'handleCompositionStart',
        value: function handleCompositionStart() {
            this.composing = true;
        }
    }, {
        key: 'handleCompositionUpdate',
        value: function handleCompositionUpdate(e) {
            if (!e.data) {
                return;
            }

            // The caret appears before the CJK character currently being composed, so re-add it to the pretext
            var textbox = this.getTextbox();
            var pretext = textbox.value.substring(0, textbox.selectionStart) + e.data;

            if (_suggestion_store2.default.getPretext(this.suggestionId) !== pretext) {
                GlobalActions.emitSuggestionPretextChanged(this.suggestionId, pretext);
            }
        }
    }, {
        key: 'handleCompositionEnd',
        value: function handleCompositionEnd() {
            this.composing = false;
        }
    }, {
        key: 'handlePopoverMentionKeyClick',
        value: function handlePopoverMentionKeyClick(mentionKey) {
            var insertText = '@' + mentionKey;

            // if the current text does not end with a whitespace, then insert a space
            if (this.props.value && /[^\s]$/.test(this.props.value)) {
                insertText = ' ' + insertText;
            }

            this.addTextAtCaret(insertText, '');
        }
    }, {
        key: 'addTextAtCaret',
        value: function addTextAtCaret(term, matchedPretext) {
            var textbox = this.getTextbox();
            var caret = textbox.selectionEnd;
            var text = this.props.value;
            var pretext = textbox.value.substring(0, textbox.selectionEnd);

            var prefix = void 0;
            var keepPretext = false;
            if (pretext.toLowerCase().endsWith(matchedPretext.toLowerCase())) {
                prefix = pretext.substring(0, pretext.length - matchedPretext.length);
            } else {
                // the pretext has changed since we got a term to complete so see if the term still fits the pretext
                var termWithoutMatched = term.substring(matchedPretext.length);
                var overlap = SuggestionBox.findOverlap(pretext, termWithoutMatched);

                keepPretext = overlap.length === 0;
                prefix = pretext.substring(0, pretext.length - overlap.length - matchedPretext.length);
            }

            var suffix = text.substring(caret);

            var newValue = void 0;
            if (keepPretext) {
                newValue = pretext;
            } else {
                newValue = prefix + term + ' ' + suffix;
            }

            textbox.value = newValue;

            if (this.props.onChange) {
                // fake an input event to send back to parent components
                var e = {
                    target: textbox
                };

                // don't call handleChange or we'll get into an event loop
                this.props.onChange(e);
            }

            // set the caret position after the next rendering
            window.requestAnimationFrame(function () {
                if (textbox.value === newValue) {
                    Utils.setCaretPosition(textbox, prefix.length + term.length + 1);
                }
            });
        }
    }, {
        key: 'handleCompleteWord',
        value: function handleCompleteWord(term, matchedPretext) {
            this.addTextAtCaret(term, matchedPretext);

            if (this.props.onItemSelected) {
                var items = _suggestion_store2.default.getItems(this.suggestionId);
                var terms = _suggestion_store2.default.getTerms(this.suggestionId);
                for (var i = 0; i < terms.length; i++) {
                    if (terms[i] === term) {
                        this.props.onItemSelected(items[i]);
                        break;
                    }
                }
            }

            this.refs.input.focus();

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.props.providers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var provider = _step.value;

                    if (provider.handleCompleteWord) {
                        provider.handleCompleteWord(term, matchedPretext);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            GlobalActions.emitCompleteWordSuggestion(this.suggestionId);
        }
    }, {
        key: 'handleKeyDown',
        value: function handleKeyDown(e) {
            if ((this.props.openWhenEmpty || this.props.value) && _suggestion_store2.default.hasSuggestions(this.suggestionId)) {
                if (Utils.isKeyPressed(e, KeyCodes.UP)) {
                    GlobalActions.emitSelectPreviousSuggestion(this.suggestionId);
                    e.preventDefault();
                } else if (Utils.isKeyPressed(e, KeyCodes.DOWN)) {
                    GlobalActions.emitSelectNextSuggestion(this.suggestionId);
                    e.preventDefault();
                } else if (Utils.isKeyPressed(e, KeyCodes.ENTER) || this.props.completeOnTab && Utils.isKeyPressed(e, KeyCodes.TAB)) {
                    this.handleCompleteWord(_suggestion_store2.default.getSelection(this.suggestionId), _suggestion_store2.default.getSelectedMatchedPretext(this.suggestionId));
                    if (this.props.onKeyDown) {
                        this.props.onKeyDown(e);
                    }
                    e.preventDefault();
                } else if (Utils.isKeyPressed(e, KeyCodes.ESCAPE)) {
                    GlobalActions.emitClearSuggestions(this.suggestionId);
                    e.preventDefault();
                    e.stopPropagation();
                } else if (this.props.onKeyDown) {
                    this.props.onKeyDown(e);
                }
            } else if (this.props.onKeyDown) {
                this.props.onKeyDown(e);
            }
        }
    }, {
        key: 'handlePretextChanged',
        value: function handlePretextChanged(pretext) {
            var handled = false;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.props.providers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var provider = _step2.value;

                    handled = provider.handlePretextChanged(this.suggestionId, pretext) || handled;

                    if (handled) {
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (!handled) {
                _suggestion_store2.default.clearSuggestions(this.suggestionId);
            }
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.refs.input.blur();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                listComponent = _props.listComponent,
                listStyle = _props.listStyle,
                renderDividers = _props.renderDividers,
                props = (0, _objectWithoutProperties3.default)(_props, ['listComponent', 'listStyle', 'renderDividers']);

            // Don't pass props used by SuggestionBox

            (0, _deleteProperty2.default)(props, 'providers');
            (0, _deleteProperty2.default)(props, 'onChange'); // We use onInput instead of onChange on the actual input
            (0, _deleteProperty2.default)(props, 'onItemSelected');
            (0, _deleteProperty2.default)(props, 'completeOnTab');
            (0, _deleteProperty2.default)(props, 'isRHS');
            (0, _deleteProperty2.default)(props, 'popoverMentionKeyClick');
            (0, _deleteProperty2.default)(props, 'requiredCharacters');
            (0, _deleteProperty2.default)(props, 'openOnFocus');
            (0, _deleteProperty2.default)(props, 'openWhenEmpty');

            // This needs to be upper case so React doesn't think it's an html tag
            var SuggestionListComponent = listComponent;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_quick_input2.default, (0, _extends3.default)({
                    ref: 'input',
                    autoComplete: 'off'
                }, props, {
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onInput: this.handleChange,
                    onCompositionStart: this.handleCompositionStart,
                    onCompositionUpdate: this.handleCompositionUpdate,
                    onCompositionEnd: this.handleCompositionEnd,
                    onKeyDown: this.handleKeyDown
                })),
                (this.props.openWhenEmpty || this.props.value.length >= this.props.requiredCharacters) && _react2.default.createElement(SuggestionListComponent, {
                    suggestionId: this.suggestionId,
                    location: listStyle,
                    renderDividers: renderDividers,
                    onCompleteWord: this.handleCompleteWord
                })
            );
        }

        // Finds the longest substring that's at both the end of b and the start of a. For example,
        // if a = "firepit" and b = "pitbull", findOverlap would return "pit".

    }], [{
        key: 'findOverlap',
        value: function findOverlap(a, b) {
            var aLower = a.toLowerCase();
            var bLower = b.toLowerCase();

            for (var i = bLower.length; i > 0; i--) {
                var substring = bLower.substring(0, i);

                if (aLower.endsWith(substring)) {
                    return substring;
                }
            }

            return '';
        }
    }]);
    return SuggestionBox;
}(_react2.default.Component);

SuggestionBox.propTypes = {

    /**
     * The list component to render, usually SuggestionList
     */
    listComponent: _propTypes2.default.func.isRequired,

    /**
     * The value of in the input
     */
    value: _propTypes2.default.string.isRequired,

    /**
     * Array of suggestion providers
     */
    providers: _propTypes2.default.arrayOf(_propTypes2.default.object),

    /**
     * Where the list will be displayed relative to the input box, defaults to 'top'
     */
    listStyle: _propTypes2.default.string,

    /**
     * Set to true to draw dividers between types of list items, defaults to false
     */
    renderDividers: _propTypes2.default.bool,

    /**
     * Set to allow TAB to select an item in the list, defaults to true
     */
    completeOnTab: _propTypes2.default.bool,

    /**
     * Function called when input box gains focus
     */
    onFocus: _propTypes2.default.func,

    /**
     * Function called when input box loses focus
     */
    onBlur: _propTypes2.default.func,

    /**
     * Function called when input box value changes
     */
    onChange: _propTypes2.default.func,

    /**
     * Function called when a key is pressed and the input box is in focus
     */
    onKeyDown: _propTypes2.default.func,

    /**
     * Function called when an item is selected
     */
    onItemSelected: _propTypes2.default.func,

    /**
     * Flags if the suggestion_box is for the RHS (Reply).
     */
    isRHS: _propTypes2.default.bool,

    /**
     * Function called when @mention is clicked
     */
    popoverMentionKeyClick: _propTypes2.default.bool,

    /**
     * The number of characters required to show the suggestion list, defaults to 1
     */
    requiredCharacters: _propTypes2.default.number,

    /**
     * If true, the suggestion box is opened on focus, default to false
     */
    openOnFocus: _propTypes2.default.bool,

    /**
     * If true, the suggestion box is disabled
     */
    disabled: _propTypes2.default.bool,

    /**
     * If true, it displays allow to display a default list when empty
     */
    openWhenEmpty: _propTypes2.default.bool
};
SuggestionBox.defaultProps = {
    listStyle: 'top',
    renderDividers: false,
    completeOnTab: true,
    isRHS: false,
    requiredCharacters: 1,
    openOnFocus: false,
    openWhenEmpty: false
};
exports.default = SuggestionBox;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _suggestion_store = __webpack_require__(969);

var _suggestion_store2 = _interopRequireDefault(_suggestion_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SuggestionList = function (_React$Component) {
    (0, _inherits3.default)(SuggestionList, _React$Component);

    function SuggestionList(props) {
        (0, _classCallCheck3.default)(this, SuggestionList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SuggestionList.__proto__ || (0, _getPrototypeOf2.default)(SuggestionList)).call(this, props));

        _this.getStateFromStores = _this.getStateFromStores.bind(_this);

        _this.getContent = _this.getContent.bind(_this);

        _this.handleSuggestionsChanged = _this.handleSuggestionsChanged.bind(_this);

        _this.scrollToItem = _this.scrollToItem.bind(_this);

        _this.state = _this.getStateFromStores(props.suggestionId);
        return _this;
    }

    (0, _createClass3.default)(SuggestionList, [{
        key: 'getStateFromStores',
        value: function getStateFromStores(suggestionId) {
            var suggestions = _suggestion_store2.default.getSuggestions(suggestionId || this.props.suggestionId);

            return {
                matchedPretext: suggestions.matchedPretext,
                items: suggestions.items,
                terms: suggestions.terms,
                components: suggestions.components,
                selection: suggestions.selection
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _suggestion_store2.default.addSuggestionsChangedListener(this.props.suggestionId, this.handleSuggestionsChanged);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.selection !== prevState.selection && this.state.selection) {
                this.scrollToItem(this.state.selection);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _suggestion_store2.default.removeSuggestionsChangedListener(this.props.suggestionId, this.handleSuggestionsChanged);
        }
    }, {
        key: 'getContent',
        value: function getContent() {
            return (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.content));
        }
    }, {
        key: 'handleSuggestionsChanged',
        value: function handleSuggestionsChanged() {
            this.setState(this.getStateFromStores());
        }
    }, {
        key: 'scrollToItem',
        value: function scrollToItem(term) {
            var content = this.getContent();
            if (!content || content.length === 0) {
                return;
            }

            var visibleContentHeight = content[0].clientHeight;
            var actualContentHeight = content[0].scrollHeight;

            if (visibleContentHeight < actualContentHeight) {
                var contentTop = content.scrollTop();
                var contentTopPadding = parseInt(content.css('padding-top'), 10);
                var contentBottomPadding = parseInt(content.css('padding-top'), 10);

                var item = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs[term]));
                var itemTop = item[0].offsetTop - parseInt(item.css('margin-top'), 10);
                var itemBottomMargin = parseInt(item.css('margin-bottom'), 10) + parseInt(item.css('padding-bottom'), 10);
                var itemBottom = item[0].offsetTop + item.height() + itemBottomMargin;

                if (itemTop - contentTopPadding < contentTop) {
                    // the item is off the top of the visible space
                    content.scrollTop(itemTop - contentTopPadding);
                } else if (itemBottom + contentTopPadding + contentBottomPadding > contentTop + visibleContentHeight) {
                    // the item has gone off the bottom of the visible space
                    content.scrollTop(itemBottom - visibleContentHeight + contentTopPadding + contentBottomPadding);
                }
            }
        }
    }, {
        key: 'renderDivider',
        value: function renderDivider(type) {
            return _react2.default.createElement(
                'div',
                {
                    key: type + '-divider',
                    className: 'suggestion-list__divider'
                },
                _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'suggestion.' + type })
                )
            );
        }
    }, {
        key: 'renderLoading',
        value: function renderLoading(type) {
            return _react2.default.createElement(
                'div',
                {
                    key: type + '-loading',
                    className: 'suggestion-loader'
                },
                _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-fw margin-bottom' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.items.length === 0) {
                return null;
            }

            var items = [];
            var lastType = void 0;
            for (var i = 0; i < this.state.items.length; i++) {
                var item = this.state.items[i];
                var term = this.state.terms[i];
                var isSelection = term === this.state.selection;

                // ReactComponent names need to be upper case when used in JSX
                var Component = this.state.components[i];

                if (this.props.renderDividers && item.type !== lastType) {
                    items.push(this.renderDivider(item.type));
                    lastType = item.type;
                }

                if (item.loading) {
                    items.push(this.renderLoading(item.type));
                    continue;
                }

                items.push(_react2.default.createElement(Component, {
                    key: term,
                    ref: term,
                    item: this.state.items[i],
                    term: term,
                    matchedPretext: this.state.matchedPretext[i],
                    isSelection: isSelection,
                    onClick: this.props.onCompleteWord
                }));
            }

            var mainClass = 'suggestion-list suggestion-list--' + this.props.location;
            var contentClass = 'suggestion-list__content suggestion-list__content--' + this.props.location;

            return _react2.default.createElement(
                'div',
                { className: mainClass },
                _react2.default.createElement(
                    'div',
                    {
                        ref: 'content',
                        className: contentClass
                    },
                    items
                )
            );
        }
    }]);
    return SuggestionList;
}(_react2.default.Component);

SuggestionList.propTypes = {
    suggestionId: _propTypes2.default.string.isRequired,
    location: _propTypes2.default.string,
    renderDividers: _propTypes2.default.bool,
    onCompleteWord: _propTypes2.default.func.isRequired
};
SuggestionList.defaultProps = {
    renderDividers: false
};
exports.default = SuggestionList;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DelayedAction = function () {
    function DelayedAction(action) {
        (0, _classCallCheck3.default)(this, DelayedAction);

        this.action = action;

        this.timer = -1;

        // bind fire since it doesn't get passed the correct this value with setTimeout
        this.fire = this.fire.bind(this);
    }

    (0, _createClass3.default)(DelayedAction, [{
        key: "fire",
        value: function fire() {
            this.action();

            this.timer = -1;
        }
    }, {
        key: "fireAfter",
        value: function fireAfter(timeout) {
            if (this.timer >= 0) {
                window.clearTimeout(this.timer);
            }

            this.timer = window.setTimeout(this.fire, timeout);
        }
    }, {
        key: "cancel",
        value: function cancel() {
            window.clearTimeout(this.timer);
        }
    }]);
    return DelayedAction;
}();

exports.default = DelayedAction;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _status_away_avatar_icon = __webpack_require__(2055);

var _status_away_avatar_icon2 = _interopRequireDefault(_status_away_avatar_icon);

var _status_away_icon = __webpack_require__(2056);

var _status_away_icon2 = _interopRequireDefault(_status_away_icon);

var _status_dnd_avatar_icon = __webpack_require__(2057);

var _status_dnd_avatar_icon2 = _interopRequireDefault(_status_dnd_avatar_icon);

var _status_dnd_icon = __webpack_require__(2058);

var _status_dnd_icon2 = _interopRequireDefault(_status_dnd_icon);

var _status_offline_avatar_icon = __webpack_require__(2059);

var _status_offline_avatar_icon2 = _interopRequireDefault(_status_offline_avatar_icon);

var _status_offline_icon = __webpack_require__(2060);

var _status_offline_icon2 = _interopRequireDefault(_status_offline_icon);

var _status_online_avatar_icon = __webpack_require__(2061);

var _status_online_avatar_icon2 = _interopRequireDefault(_status_online_avatar_icon);

var _status_online_icon = __webpack_require__(2062);

var _status_online_icon2 = _interopRequireDefault(_status_online_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var StatusIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(StatusIcon, _React$PureComponent);

    function StatusIcon() {
        (0, _classCallCheck3.default)(this, StatusIcon);
        return (0, _possibleConstructorReturn3.default)(this, (StatusIcon.__proto__ || (0, _getPrototypeOf2.default)(StatusIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusIcon, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                status = _props.status,
                type = _props.type;


            if (!status) {
                return null;
            }

            var className = 'status ' + this.props.className;

            var IconComponent = 'span';
            if (type === 'avatar') {
                if (status === 'online') {
                    IconComponent = _status_online_avatar_icon2.default;
                } else if (status === 'away') {
                    IconComponent = _status_away_avatar_icon2.default;
                } else if (status === 'dnd') {
                    IconComponent = _status_dnd_avatar_icon2.default;
                } else {
                    IconComponent = _status_offline_avatar_icon2.default;
                }
            } else if (status === 'online') {
                IconComponent = _status_online_icon2.default;
            } else if (status === 'away') {
                IconComponent = _status_away_icon2.default;
            } else if (status === 'dnd') {
                IconComponent = _status_dnd_icon2.default;
            } else {
                IconComponent = _status_offline_icon2.default;
            }

            return _react2.default.createElement(IconComponent, { className: className });
        }
    }]);
    return StatusIcon;
}(_react2.default.PureComponent);

StatusIcon.propTypes = {
    status: _propTypes2.default.string,
    className: _propTypes2.default.string,
    type: _propTypes2.default.string
};
StatusIcon.defaultProps = {
    className: ''
};
exports.default = StatusIcon;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _pluggable = __webpack_require__(881);

var _pluggable2 = _interopRequireDefault(_pluggable);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _profile_popover = __webpack_require__(1028);

var _profile_popover2 = _interopRequireDefault(_profile_popover);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var UserProfile = function (_React$Component) {
    (0, _inherits3.default)(UserProfile, _React$Component);

    function UserProfile(props) {
        (0, _classCallCheck3.default)(this, UserProfile);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserProfile.__proto__ || (0, _getPrototypeOf2.default)(UserProfile)).call(this, props));

        _this.hideProfilePopover = _this.hideProfilePopover.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(UserProfile, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            if (!Utils.areObjectsEqual(nextProps.user, this.props.user)) {
                return true;
            }

            if (nextProps.overwriteName !== this.props.overwriteName) {
                return true;
            }

            if (nextProps.overwriteImage !== this.props.overwriteImage) {
                return true;
            }

            if (nextProps.disablePopover !== this.props.disablePopover) {
                return true;
            }

            if (nextProps.displayNameType !== this.props.displayNameType) {
                return true;
            }

            if (nextProps.status !== this.props.status) {
                return true;
            }

            if (nextProps.isBusy !== this.props.isBusy) {
                return true;
            }

            return false;
        }
    }, {
        key: 'hideProfilePopover',
        value: function hideProfilePopover() {
            this.refs.overlay.hide();
        }
    }, {
        key: 'render',
        value: function render() {
            var name = '...';
            var profileImg = '';

            if (this.props.user && this.props.user.id) {
                name = Utils.getDisplayNameByUserId(this.props.user.id);
                profileImg = Utils.imageURLForUser(this.props.user);
            }

            if (this.props.overwriteName) {
                name = this.props.overwriteName;
            }

            if (this.props.disablePopover) {
                return _react2.default.createElement(
                    'div',
                    { className: 'user-popover' },
                    name
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.OverlayTrigger,
                {
                    ref: 'overlay',
                    trigger: 'click',
                    placement: 'right',
                    rootClose: true,
                    overlay: _react2.default.createElement(
                        _pluggable2.default,
                        null,
                        _react2.default.createElement(_profile_popover2.default, {
                            user: this.props.user,
                            src: profileImg,
                            status: this.props.status,
                            isBusy: this.props.isBusy,
                            hide: this.hideProfilePopover,
                            isRHS: this.props.isRHS,
                            hasMention: this.props.hasMention
                        })
                    )
                },
                _react2.default.createElement(
                    'div',
                    {
                        className: 'user-popover'
                    },
                    name
                )
            );
        }
    }]);
    return UserProfile;
}(_react2.default.Component);

exports.default = UserProfile;


UserProfile.defaultProps = {
    user: {},
    overwriteName: '',
    overwriteImage: '',
    disablePopover: false,
    isRHS: false,
    hasMention: false
};
UserProfile.propTypes = {
    user: _propTypes2.default.object,
    overwriteName: _propTypes2.default.node,
    overwriteImage: _propTypes2.default.string,
    disablePopover: _propTypes2.default.bool,
    displayNameType: _propTypes2.default.string,
    status: _propTypes2.default.string,
    isBusy: _propTypes2.default.bool,
    isRHS: _propTypes2.default.bool,
    hasMention: _propTypes2.default.bool
};

/***/ }),
/* 934 */,
/* 935 */,
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1370),
    baseKeys = __webpack_require__(2191),
    isArrayLike = __webpack_require__(979);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, Buffer, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}

var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }
  // phantomjs doesn't like a buffer being passed here
  var bytes = new Buffer(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(45).Buffer, __webpack_require__(51)))

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(806);

asn1.define = __webpack_require__(2542).define;
asn1.base = __webpack_require__(940);
asn1.constants = __webpack_require__(1445);
asn1.decoders = __webpack_require__(2548);
asn1.encoders = __webpack_require__(2550);


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(2545).Reporter;
base.DecoderBuffer = __webpack_require__(1444).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(1444).EncoderBuffer;
base.Node = __webpack_require__(2546);


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SiteNameAndDescription = function (_React$PureComponent) {
    (0, _inherits3.default)(SiteNameAndDescription, _React$PureComponent);

    function SiteNameAndDescription() {
        (0, _classCallCheck3.default)(this, SiteNameAndDescription);
        return (0, _possibleConstructorReturn3.default)(this, (SiteNameAndDescription.__proto__ || (0, _getPrototypeOf2.default)(SiteNameAndDescription)).apply(this, arguments));
    }

    (0, _createClass3.default)(SiteNameAndDescription, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                customDescriptionText = _props.customDescriptionText,
                isLicensed = _props.isLicensed,
                siteName = _props.siteName;

            var description = null;
            if (isLicensed && customDescriptionText) {
                description = customDescriptionText;
            } else {
                description = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'web.root.signup_info',
                    defaultMessage: 'All team communication in one place, searchable and accessible anywhere'
                });
            }

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'h1',
                    null,
                    siteName
                ),
                _react2.default.createElement(
                    'h4',
                    { className: 'color--light' },
                    description
                )
            );
        }
    }]);
    return SiteNameAndDescription;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SiteNameAndDescription.propTypes = {
    customDescriptionText: _propTypes2.default.string,
    isLicensed: _propTypes2.default.bool,
    siteName: _propTypes2.default.string
};
SiteNameAndDescription.defaultProps = {
    isLicensed: false,
    siteName: 'Mattermost'
};
exports.default = SiteNameAndDescription;

/***/ }),
/* 942 */,
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	// [[Class]] -> type pairs
	return {};
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(918)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr ) {
	"use strict";

	return arr.slice;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1101),
	__webpack_require__(807),
	__webpack_require__(1102),
	__webpack_require__(875),
	__webpack_require__(1123),
	__webpack_require__(1118),
	__webpack_require__(1119),
	__webpack_require__(1120),
	__webpack_require__(1121),
	__webpack_require__(1122),
	__webpack_require__(1117),
	__webpack_require__(1594),

	__webpack_require__(844),
	__webpack_require__(1115),
	__webpack_require__(1009),
	__webpack_require__(1105),
	__webpack_require__(876),

	__webpack_require__(834),
	__webpack_require__(898),
	__webpack_require__(815),
	__webpack_require__(899)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, concat, isFunction, push, access,
	rcheckableType, rtagName, rscriptType,
	wrapMap, getAll, setGlobalEval, buildFragment, support,
	dataPriv, dataUser, acceptData, DOMEval, nodeName ) {

"use strict";

var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPing = getPing;
exports.resetPing = resetPing;
exports.getClientConfig = getClientConfig;
exports.getDataRetentionPolicy = getDataRetentionPolicy;
exports.getLicenseConfig = getLicenseConfig;
exports.logClientError = logClientError;
exports.setAppState = setAppState;
exports.setDeviceToken = setDeviceToken;
exports.setServerVersion = setServerVersion;
exports.setStoreFromLocalData = setStoreFromLocalData;
exports.getSupportedTimezones = getSupportedTimezones;
exports.setUrl = setUrl;

var _client = __webpack_require__(270);

var _helpers = __webpack_require__(821);

var _action_types = __webpack_require__(3);

var _users = __webpack_require__(786);

var _roles = __webpack_require__(860);

var _errors = __webpack_require__(828);

var _reduxBatchedActions = __webpack_require__(278);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getPing() {
    var _this = this;

    var useV3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var data, pingError;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.PING_REQUEST }, getState);

                            data = void 0;
                            pingError = new _helpers.FormattedError('mobile.server_ping_failed', 'Cannot connect to the server. Please check your server URL and internet connection.');
                            _context.prev = 3;

                            if (!useV3) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 7;
                            return _client.Client.getPing();

                        case 7:
                            data = _context.sent;
                            _context.next = 13;
                            break;

                        case 10:
                            _context.next = 12;
                            return _client.Client4.ping();

                        case 12:
                            data = _context.sent;

                        case 13:
                            if (!(useV3 && !data.version || !useV3 && data.status !== 'OK')) {
                                _context.next = 16;
                                break;
                            }

                            // successful ping but not the right return {data}
                            dispatch({ type: _action_types.GeneralTypes.PING_FAILURE, error: pingError }, getState);
                            return _context.abrupt('return', { error: pingError });

                        case 16:
                            _context.next = 25;
                            break;

                        case 18:
                            _context.prev = 18;
                            _context.t0 = _context['catch'](3);

                            if (!(!useV3 && _context.t0.status_code === 404)) {
                                _context.next = 23;
                                break;
                            }

                            if (!_client.Client.getUrl()) {
                                _client.Client.setUrl(_client.Client4.getUrl());
                            }
                            return _context.abrupt('return', getPing(true)(dispatch, getState));

                        case 23:
                            dispatch({ type: _action_types.GeneralTypes.PING_FAILURE, error: pingError }, getState);
                            return _context.abrupt('return', { error: pingError });

                        case 25:

                            dispatch({ type: _action_types.GeneralTypes.PING_SUCCESS, data: data }, getState);
                            return _context.abrupt('return', { data: data });

                        case 27:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[3, 18]]);
        }));

        return function (_x2, _x3) {
            return _ref.apply(this, arguments);
        };
    }();
}

function resetPing() {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.PING_RESET }, getState);

                            return _context2.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x4, _x5) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function getClientConfig() {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.CLIENT_CONFIG_REQUEST }, getState);

                            data = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.getClientConfigOld();

                        case 5:
                            data = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.GeneralTypes.CLIENT_CONFIG_FAILURE,
                                error: _context3.t0
                            }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', { error: _context3.t0 });

                        case 13:

                            _client.Client4.setEnableLogging(data.EnableDeveloper === 'true');
                            _client.Client4.setDiagnosticId(data.DiagnosticId);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.GeneralTypes.CLIENT_CONFIG_RECEIVED, data: data }, { type: _action_types.GeneralTypes.CLIENT_CONFIG_SUCCESS }]));

                            return _context3.abrupt('return', { data: data });

                        case 17:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function getDataRetentionPolicy() {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.DATA_RETENTION_POLICY_REQUEST }, getState);

                            data = void 0;
                            _context4.prev = 2;
                            _context4.next = 5;
                            return _client.Client4.getDataRetentionPolicy();

                        case 5:
                            data = _context4.sent;
                            _context4.next = 13;
                            break;

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.GeneralTypes.DATA_RETENTION_POLICY_FAILURE,
                                error: _context4.t0
                            }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', { error: _context4.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.GeneralTypes.RECEIVED_DATA_RETENTION_POLICY, data: data }, { type: _action_types.GeneralTypes.DATA_RETENTION_POLICY_SUCCESS }]));

                            return _context4.abrupt('return', { data: data });

                        case 15:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[2, 8]]);
        }));

        return function (_x8, _x9) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function getLicenseConfig() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getClientLicenseOld, _action_types.GeneralTypes.CLIENT_LICENSE_REQUEST, [_action_types.GeneralTypes.CLIENT_LICENSE_RECEIVED, _action_types.GeneralTypes.CLIENT_LICENSE_SUCCESS], _action_types.GeneralTypes.CLIENT_LICENSE_FAILURE);
}

function logClientError(message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ERROR';

    return (0, _helpers.bindClientFunc)(_client.Client4.logClientError, _action_types.GeneralTypes.LOG_CLIENT_ERROR_REQUEST, _action_types.GeneralTypes.LOG_CLIENT_ERROR_SUCCESS, _action_types.GeneralTypes.LOG_CLIENT_ERROR_FAILURE, message, level);
}

function setAppState(state) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.RECEIVED_APP_STATE, data: state }, getState);

                            return _context5.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }));

        return function (_x11, _x12) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function setDeviceToken(token) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.RECEIVED_APP_DEVICE_TOKEN, data: token }, getState);

                            return _context6.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }));

        return function (_x13, _x14) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function setServerVersion(serverVersion) {
    var _this7 = this;

    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.RECEIVED_SERVER_VERSION, data: serverVersion }, getState);
                            dispatch((0, _roles.loadRolesIfNeeded)([]));

                            return _context7.abrupt('return', { data: true });

                        case 3:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }));

        return function (_x15, _x16) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function setStoreFromLocalData(data) {
    var _this8 = this;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _client.Client.setToken(data.token);
                            _client.Client.setUrl(data.url);
                            _client.Client4.setToken(data.token);
                            _client.Client4.setUrl(data.url);

                            return _context8.abrupt('return', (0, _users.loadMe)()(dispatch, getState));

                        case 5:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }));

        return function (_x17, _x18) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function getSupportedTimezones() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTimezones, _action_types.GeneralTypes.SUPPORTED_TIMEZONES_REQUEST, [_action_types.GeneralTypes.SUPPORTED_TIMEZONES_RECEIVED, _action_types.GeneralTypes.SUPPORTED_TIMEZONES_SUCCESS], _action_types.GeneralTypes.SUPPORTED_TIMEZONES_FAILURE);
}

function setUrl(url) {
    _client.Client.setUrl(url);
    _client.Client4.setUrl(url);
    return true;
}

exports.default = {
    getPing: getPing,
    getClientConfig: getClientConfig,
    getDataRetentionPolicy: getDataRetentionPolicy,
    getSupportedTimezones: getSupportedTimezones,
    getLicenseConfig: getLicenseConfig,
    logClientError: logClientError,
    setAppState: setAppState,
    setDeviceToken: setDeviceToken,
    setServerVersion: setServerVersion,
    setStoreFromLocalData: setStoreFromLocalData,
    setUrl: setUrl
};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiIndicesByCategory = exports.CategoryNames = exports.EmojiIndicesByUnicode = exports.EmojiIndicesByAlias = exports.Emojis = undefined;

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

var _emoji = __webpack_require__(1647);

var _emoji2 = _interopRequireDefault(_emoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Emojis = exports.Emojis = _emoji2.default; // This file is automatically generated via `make emojis`. Do not modify it manually.

/* eslint-disable */

var EmojiIndicesByAlias = exports.EmojiIndicesByAlias = new _map2.default([["grinning", 0], ["smiley", 1], ["smile", 2], ["grin", 3], ["laughing", 4], ["satisfied", 4], ["sweat_smile", 5], ["joy", 6], ["rofl", 7], ["relaxed", 8], ["blush", 9], ["innocent", 10], ["slightly_smiling_face", 11], ["upside_down_face", 12], ["wink", 13], ["relieved", 14], ["heart_eyes", 15], ["kissing_heart", 16], ["kissing", 17], ["kissing_smiling_eyes", 18], ["kissing_closed_eyes", 19], ["yum", 20], ["stuck_out_tongue_winking_eye", 21], ["stuck_out_tongue_closed_eyes", 22], ["stuck_out_tongue", 23], ["money_mouth_face", 24], ["hugs", 25], ["nerd_face", 26], ["sunglasses", 27], ["clown_face", 28], ["cowboy_hat_face", 29], ["smirk", 30], ["unamused", 31], ["disappointed", 32], ["pensive", 33], ["worried", 34], ["confused", 35], ["slightly_frowning_face", 36], ["frowning_face", 37], ["persevere", 38], ["confounded", 39], ["tired_face", 40], ["weary", 41], ["triumph", 42], ["angry", 43], ["rage", 44], ["pout", 44], ["no_mouth", 45], ["neutral_face", 46], ["expressionless", 47], ["hushed", 48], ["frowning", 49], ["anguished", 50], ["open_mouth", 51], ["astonished", 52], ["dizzy_face", 53], ["flushed", 54], ["scream", 55], ["fearful", 56], ["cold_sweat", 57], ["cry", 58], ["disappointed_relieved", 59], ["drooling_face", 60], ["sob", 61], ["sweat", 62], ["sleepy", 63], ["sleeping", 64], ["roll_eyes", 65], ["thinking", 66], ["lying_face", 67], ["grimacing", 68], ["zipper_mouth_face", 69], ["nauseated_face", 70], ["sneezing_face", 71], ["mask", 72], ["face_with_thermometer", 73], ["face_with_head_bandage", 74], ["smiling_imp", 75], ["imp", 76], ["japanese_ogre", 77], ["japanese_goblin", 78], ["hankey", 79], ["poop", 79], ["shit", 79], ["ghost", 80], ["skull", 81], ["skull_and_crossbones", 82], ["alien", 83], ["space_invader", 84], ["robot", 85], ["jack_o_lantern", 86], ["smiley_cat", 87], ["smile_cat", 88], ["joy_cat", 89], ["heart_eyes_cat", 90], ["smirk_cat", 91], ["kissing_cat", 92], ["scream_cat", 93], ["crying_cat_face", 94], ["pouting_cat", 95], ["open_hands", 96], ["raised_hands", 97], ["clap", 98], ["pray", 99], ["handshake", 100], ["+1", 101], ["thumbsup", 101], ["-1", 102], ["thumbsdown", 102], ["fist_oncoming", 103], ["facepunch", 103], ["punch", 103], ["fist_raised", 104], ["fist", 104], ["fist_left", 105], ["fist_right", 106], ["crossed_fingers", 107], ["v", 108], ["metal", 109], ["ok_hand", 110], ["point_left", 111], ["point_right", 112], ["point_up_2", 113], ["point_down", 114], ["point_up", 115], ["hand", 116], ["raised_hand", 116], ["raised_back_of_hand", 117], ["raised_hand_with_fingers_splayed", 118], ["vulcan_salute", 119], ["wave", 120], ["call_me_hand", 121], ["muscle", 122], ["middle_finger", 123], ["fu", 123], ["writing_hand", 124], ["selfie", 125], ["nail_care", 126], ["ring", 127], ["lipstick", 128], ["kiss", 129], ["lips", 130], ["tongue", 131], ["ear", 132], ["nose", 133], ["footprints", 134], ["eye", 135], ["eyes", 136], ["speaking_head", 137], ["bust_in_silhouette", 138], ["busts_in_silhouette", 139], ["baby", 140], ["boy", 141], ["girl", 142], ["man", 143], ["woman", 144], ["blonde_woman", 145], ["blonde_man", 146], ["person_with_blond_hair", 146], ["older_man", 147], ["older_woman", 148], ["man_with_gua_pi_mao", 149], ["woman_with_turban", 150], ["man_with_turban", 151], ["policewoman", 152], ["policeman", 153], ["cop", 153], ["construction_worker_woman", 154], ["construction_worker_man", 155], ["construction_worker", 155], ["guardswoman", 156], ["guardsman", 157], ["female_detective", 158], ["male_detective", 159], ["detective", 159], ["woman_health_worker", 160], ["man_health_worker", 161], ["woman_farmer", 162], ["man_farmer", 163], ["woman_cook", 164], ["man_cook", 165], ["woman_student", 166], ["man_student", 167], ["woman_singer", 168], ["man_singer", 169], ["woman_teacher", 170], ["man_teacher", 171], ["woman_factory_worker", 172], ["man_factory_worker", 173], ["woman_technologist", 174], ["man_technologist", 175], ["woman_office_worker", 176], ["man_office_worker", 177], ["woman_mechanic", 178], ["man_mechanic", 179], ["woman_scientist", 180], ["man_scientist", 181], ["woman_artist", 182], ["man_artist", 183], ["woman_firefighter", 184], ["man_firefighter", 185], ["woman_pilot", 186], ["man_pilot", 187], ["woman_astronaut", 188], ["man_astronaut", 189], ["woman_judge", 190], ["man_judge", 191], ["mrs_claus", 192], ["santa", 193], ["princess", 194], ["prince", 195], ["bride_with_veil", 196], ["man_in_tuxedo", 197], ["angel", 198], ["pregnant_woman", 199], ["bowing_woman", 200], ["bowing_man", 201], ["bow", 201], ["tipping_hand_woman", 202], ["information_desk_person", 202], ["tipping_hand_man", 203], ["no_good_woman", 204], ["no_good", 204], ["ng_woman", 204], ["no_good_man", 205], ["ng_man", 205], ["ok_woman", 206], ["ok_man", 207], ["raising_hand_woman", 208], ["raising_hand", 208], ["raising_hand_man", 209], ["woman_facepalming", 210], ["man_facepalming", 211], ["woman_shrugging", 212], ["man_shrugging", 213], ["pouting_woman", 214], ["person_with_pouting_face", 214], ["pouting_man", 215], ["frowning_woman", 216], ["person_frowning", 216], ["frowning_man", 217], ["haircut_woman", 218], ["haircut", 218], ["haircut_man", 219], ["massage_woman", 220], ["massage", 220], ["massage_man", 221], ["business_suit_levitating", 222], ["dancer", 223], ["man_dancing", 224], ["dancing_women", 225], ["dancers", 225], ["dancing_men", 226], ["walking_woman", 227], ["walking_man", 228], ["walking", 228], ["running_woman", 229], ["running_man", 230], ["runner", 230], ["running", 230], ["couple", 231], ["two_women_holding_hands", 232], ["two_men_holding_hands", 233], ["couple_with_heart_woman_man", 234], ["couple_with_heart", 234], ["couple_with_heart_woman_woman", 235], ["couple_with_heart_man_man", 236], ["couplekiss_man_woman", 237], ["couplekiss_woman_woman", 238], ["couplekiss_man_man", 239], ["family_man_woman_boy", 240], ["family", 240], ["family_man_woman_girl", 241], ["family_man_woman_girl_boy", 242], ["family_man_woman_boy_boy", 243], ["family_man_woman_girl_girl", 244], ["family_woman_woman_boy", 245], ["family_woman_woman_girl", 246], ["family_woman_woman_girl_boy", 247], ["family_woman_woman_boy_boy", 248], ["family_woman_woman_girl_girl", 249], ["family_man_man_boy", 250], ["family_man_man_girl", 251], ["family_man_man_girl_boy", 252], ["family_man_man_boy_boy", 253], ["family_man_man_girl_girl", 254], ["family_woman_boy", 255], ["family_woman_girl", 256], ["family_woman_girl_boy", 257], ["family_woman_boy_boy", 258], ["family_woman_girl_girl", 259], ["family_man_boy", 260], ["family_man_girl", 261], ["family_man_girl_boy", 262], ["family_man_boy_boy", 263], ["family_man_girl_girl", 264], ["womans_clothes", 265], ["shirt", 266], ["tshirt", 266], ["jeans", 267], ["necktie", 268], ["dress", 269], ["bikini", 270], ["kimono", 271], ["high_heel", 272], ["sandal", 273], ["boot", 274], ["mans_shoe", 275], ["shoe", 275], ["athletic_shoe", 276], ["womans_hat", 277], ["tophat", 278], ["mortar_board", 279], ["crown", 280], ["rescue_worker_helmet", 281], ["school_satchel", 282], ["pouch", 283], ["purse", 284], ["handbag", 285], ["briefcase", 286], ["eyeglasses", 287], ["dark_sunglasses", 288], ["closed_umbrella", 289], ["open_umbrella", 290], ["dog", 291], ["cat", 292], ["mouse", 293], ["hamster", 294], ["rabbit", 295], ["fox_face", 296], ["bear", 297], ["panda_face", 298], ["koala", 299], ["tiger", 300], ["lion", 301], ["cow", 302], ["pig", 303], ["pig_nose", 304], ["frog", 305], ["monkey_face", 306], ["see_no_evil", 307], ["hear_no_evil", 308], ["speak_no_evil", 309], ["monkey", 310], ["chicken", 311], ["penguin", 312], ["bird", 313], ["baby_chick", 314], ["hatching_chick", 315], ["hatched_chick", 316], ["duck", 317], ["eagle", 318], ["owl", 319], ["bat", 320], ["wolf", 321], ["boar", 322], ["horse", 323], ["unicorn", 324], ["bee", 325], ["honeybee", 325], ["bug", 326], ["butterfly", 327], ["snail", 328], ["shell", 329], ["beetle", 330], ["ant", 331], ["spider", 332], ["spider_web", 333], ["turtle", 334], ["snake", 335], ["lizard", 336], ["scorpion", 337], ["crab", 338], ["squid", 339], ["octopus", 340], ["shrimp", 341], ["tropical_fish", 342], ["fish", 343], ["blowfish", 344], ["dolphin", 345], ["flipper", 345], ["shark", 346], ["whale", 347], ["whale2", 348], ["crocodile", 349], ["leopard", 350], ["tiger2", 351], ["water_buffalo", 352], ["ox", 353], ["cow2", 354], ["deer", 355], ["dromedary_camel", 356], ["camel", 357], ["elephant", 358], ["rhinoceros", 359], ["gorilla", 360], ["racehorse", 361], ["pig2", 362], ["goat", 363], ["ram", 364], ["sheep", 365], ["dog2", 366], ["poodle", 367], ["cat2", 368], ["rooster", 369], ["turkey", 370], ["dove", 371], ["rabbit2", 372], ["mouse2", 373], ["rat", 374], ["chipmunk", 375], ["feet", 376], ["paw_prints", 376], ["dragon", 377], ["dragon_face", 378], ["cactus", 379], ["christmas_tree", 380], ["evergreen_tree", 381], ["deciduous_tree", 382], ["palm_tree", 383], ["seedling", 384], ["herb", 385], ["shamrock", 386], ["four_leaf_clover", 387], ["bamboo", 388], ["tanabata_tree", 389], ["leaves", 390], ["fallen_leaf", 391], ["maple_leaf", 392], ["mushroom", 393], ["ear_of_rice", 394], ["bouquet", 395], ["tulip", 396], ["rose", 397], ["wilted_flower", 398], ["sunflower", 399], ["blossom", 400], ["cherry_blossom", 401], ["hibiscus", 402], ["earth_americas", 403], ["earth_africa", 404], ["earth_asia", 405], ["full_moon", 406], ["waning_gibbous_moon", 407], ["last_quarter_moon", 408], ["waning_crescent_moon", 409], ["new_moon", 410], ["waxing_crescent_moon", 411], ["first_quarter_moon", 412], ["moon", 413], ["waxing_gibbous_moon", 413], ["new_moon_with_face", 414], ["full_moon_with_face", 415], ["sun_with_face", 416], ["first_quarter_moon_with_face", 417], ["last_quarter_moon_with_face", 418], ["crescent_moon", 419], ["dizzy", 420], ["star", 421], ["star2", 422], ["sparkles", 423], ["zap", 424], ["fire", 425], ["boom", 426], ["collision", 426], ["comet", 427], ["sunny", 428], ["sun_behind_small_cloud", 429], ["partly_sunny", 430], ["sun_behind_large_cloud", 431], ["sun_behind_rain_cloud", 432], ["rainbow", 433], ["cloud", 434], ["cloud_with_rain", 435], ["cloud_with_lightning_and_rain", 436], ["cloud_with_lightning", 437], ["cloud_with_snow", 438], ["snowman_with_snow", 439], ["snowman", 440], ["snowflake", 441], ["wind_face", 442], ["dash", 443], ["tornado", 444], ["fog", 445], ["ocean", 446], ["droplet", 447], ["sweat_drops", 448], ["umbrella", 449], ["green_apple", 450], ["apple", 451], ["pear", 452], ["tangerine", 453], ["orange", 453], ["mandarin", 453], ["lemon", 454], ["banana", 455], ["watermelon", 456], ["grapes", 457], ["strawberry", 458], ["melon", 459], ["cherries", 460], ["peach", 461], ["pineapple", 462], ["kiwi_fruit", 463], ["avocado", 464], ["tomato", 465], ["eggplant", 466], ["cucumber", 467], ["carrot", 468], ["corn", 469], ["hot_pepper", 470], ["potato", 471], ["sweet_potato", 472], ["chestnut", 473], ["peanuts", 474], ["honey_pot", 475], ["croissant", 476], ["bread", 477], ["baguette_bread", 478], ["cheese", 479], ["egg", 480], ["fried_egg", 481], ["bacon", 482], ["pancakes", 483], ["fried_shrimp", 484], ["poultry_leg", 485], ["meat_on_bone", 486], ["pizza", 487], ["hotdog", 488], ["hamburger", 489], ["fries", 490], ["stuffed_flatbread", 491], ["taco", 492], ["burrito", 493], ["green_salad", 494], ["shallow_pan_of_food", 495], ["spaghetti", 496], ["ramen", 497], ["stew", 498], ["fish_cake", 499], ["sushi", 500], ["bento", 501], ["curry", 502], ["rice", 503], ["rice_ball", 504], ["rice_cracker", 505], ["oden", 506], ["dango", 507], ["shaved_ice", 508], ["ice_cream", 509], ["icecream", 510], ["cake", 511], ["birthday", 512], ["custard", 513], ["lollipop", 514], ["candy", 515], ["chocolate_bar", 516], ["popcorn", 517], ["doughnut", 518], ["cookie", 519], ["milk_glass", 520], ["baby_bottle", 521], ["coffee", 522], ["tea", 523], ["sake", 524], ["beer", 525], ["beers", 526], ["clinking_glasses", 527], ["wine_glass", 528], ["tumbler_glass", 529], ["cocktail", 530], ["tropical_drink", 531], ["champagne", 532], ["spoon", 533], ["fork_and_knife", 534], ["plate_with_cutlery", 535], ["soccer", 536], ["basketball", 537], ["football", 538], ["baseball", 539], ["tennis", 540], ["volleyball", 541], ["rugby_football", 542], ["8ball", 543], ["ping_pong", 544], ["badminton", 545], ["goal_net", 546], ["ice_hockey", 547], ["field_hockey", 548], ["cricket", 549], ["golf", 550], ["bow_and_arrow", 551], ["fishing_pole_and_fish", 552], ["boxing_glove", 553], ["martial_arts_uniform", 554], ["ice_skate", 555], ["ski", 556], ["skier", 557], ["snowboarder", 558], ["weight_lifting_woman", 559], ["weight_lifting_man", 560], ["person_fencing", 561], ["women_wrestling", 562], ["men_wrestling", 563], ["woman_cartwheeling", 564], ["man_cartwheeling", 565], ["basketball_woman", 566], ["basketball_man", 567], ["woman_playing_handball", 568], ["man_playing_handball", 569], ["golfing_woman", 570], ["golfing_man", 571], ["surfing_woman", 572], ["surfing_man", 573], ["surfer", 573], ["swimming_woman", 574], ["swimming_man", 575], ["swimmer", 575], ["woman_playing_water_polo", 576], ["man_playing_water_polo", 577], ["rowing_woman", 578], ["rowing_man", 579], ["rowboat", 579], ["horse_racing", 580], ["biking_woman", 581], ["biking_man", 582], ["bicyclist", 582], ["mountain_biking_woman", 583], ["mountain_biking_man", 584], ["mountain_bicyclist", 584], ["running_shirt_with_sash", 585], ["medal_sports", 586], ["medal_military", 587], ["1st_place_medal", 588], ["2nd_place_medal", 589], ["3rd_place_medal", 590], ["trophy", 591], ["rosette", 592], ["reminder_ribbon", 593], ["ticket", 594], ["tickets", 595], ["circus_tent", 596], ["woman_juggling", 597], ["man_juggling", 598], ["performing_arts", 599], ["art", 600], ["clapper", 601], ["microphone", 602], ["headphones", 603], ["musical_score", 604], ["musical_keyboard", 605], ["drum", 606], ["saxophone", 607], ["trumpet", 608], ["guitar", 609], ["violin", 610], ["game_die", 611], ["dart", 612], ["bowling", 613], ["video_game", 614], ["slot_machine", 615], ["car", 616], ["red_car", 616], ["taxi", 617], ["blue_car", 618], ["bus", 619], ["trolleybus", 620], ["racing_car", 621], ["police_car", 622], ["ambulance", 623], ["fire_engine", 624], ["minibus", 625], ["truck", 626], ["articulated_lorry", 627], ["tractor", 628], ["kick_scooter", 629], ["bike", 630], ["motor_scooter", 631], ["motorcycle", 632], ["rotating_light", 633], ["oncoming_police_car", 634], ["oncoming_bus", 635], ["oncoming_automobile", 636], ["oncoming_taxi", 637], ["aerial_tramway", 638], ["mountain_cableway", 639], ["suspension_railway", 640], ["railway_car", 641], ["train", 642], ["mountain_railway", 643], ["monorail", 644], ["bullettrain_side", 645], ["bullettrain_front", 646], ["light_rail", 647], ["steam_locomotive", 648], ["train2", 649], ["metro", 650], ["tram", 651], ["station", 652], ["helicopter", 653], ["small_airplane", 654], ["airplane", 655], ["flight_departure", 656], ["flight_arrival", 657], ["rocket", 658], ["artificial_satellite", 659], ["seat", 660], ["canoe", 661], ["boat", 662], ["sailboat", 662], ["motor_boat", 663], ["speedboat", 664], ["passenger_ship", 665], ["ferry", 666], ["ship", 667], ["anchor", 668], ["construction", 669], ["fuelpump", 670], ["busstop", 671], ["vertical_traffic_light", 672], ["traffic_light", 673], ["world_map", 674], ["moyai", 675], ["statue_of_liberty", 676], ["fountain", 677], ["tokyo_tower", 678], ["european_castle", 679], ["japanese_castle", 680], ["stadium", 681], ["ferris_wheel", 682], ["roller_coaster", 683], ["carousel_horse", 684], ["parasol_on_ground", 685], ["beach_umbrella", 686], ["desert_island", 687], ["mountain", 688], ["mountain_snow", 689], ["mount_fuji", 690], ["volcano", 691], ["desert", 692], ["camping", 693], ["tent", 694], ["railway_track", 695], ["motorway", 696], ["building_construction", 697], ["factory", 698], ["house", 699], ["house_with_garden", 700], ["houses", 701], ["derelict_house", 702], ["office", 703], ["department_store", 704], ["post_office", 705], ["european_post_office", 706], ["hospital", 707], ["bank", 708], ["hotel", 709], ["convenience_store", 710], ["school", 711], ["love_hotel", 712], ["wedding", 713], ["classical_building", 714], ["church", 715], ["mosque", 716], ["synagogue", 717], ["kaaba", 718], ["shinto_shrine", 719], ["japan", 720], ["rice_scene", 721], ["national_park", 722], ["sunrise", 723], ["sunrise_over_mountains", 724], ["stars", 725], ["sparkler", 726], ["fireworks", 727], ["city_sunrise", 728], ["city_sunset", 729], ["cityscape", 730], ["night_with_stars", 731], ["milky_way", 732], ["bridge_at_night", 733], ["foggy", 734], ["watch", 735], ["iphone", 736], ["calling", 737], ["computer", 738], ["keyboard", 739], ["desktop_computer", 740], ["printer", 741], ["computer_mouse", 742], ["trackball", 743], ["joystick", 744], ["clamp", 745], ["minidisc", 746], ["floppy_disk", 747], ["cd", 748], ["dvd", 749], ["vhs", 750], ["camera", 751], ["camera_flash", 752], ["video_camera", 753], ["movie_camera", 754], ["film_projector", 755], ["film_strip", 756], ["telephone_receiver", 757], ["phone", 758], ["telephone", 758], ["pager", 759], ["fax", 760], ["tv", 761], ["radio", 762], ["studio_microphone", 763], ["level_slider", 764], ["control_knobs", 765], ["stopwatch", 766], ["timer_clock", 767], ["alarm_clock", 768], ["mantelpiece_clock", 769], ["hourglass", 770], ["hourglass_flowing_sand", 771], ["satellite", 772], ["battery", 773], ["electric_plug", 774], ["bulb", 775], ["flashlight", 776], ["candle", 777], ["wastebasket", 778], ["oil_drum", 779], ["money_with_wings", 780], ["dollar", 781], ["yen", 782], ["euro", 783], ["pound", 784], ["moneybag", 785], ["credit_card", 786], ["gem", 787], ["balance_scale", 788], ["wrench", 789], ["hammer", 790], ["hammer_and_pick", 791], ["hammer_and_wrench", 792], ["pick", 793], ["nut_and_bolt", 794], ["gear", 795], ["chains", 796], ["gun", 797], ["bomb", 798], ["hocho", 799], ["knife", 799], ["dagger", 800], ["crossed_swords", 801], ["shield", 802], ["smoking", 803], ["coffin", 804], ["funeral_urn", 805], ["amphora", 806], ["crystal_ball", 807], ["prayer_beads", 808], ["barber", 809], ["alembic", 810], ["telescope", 811], ["microscope", 812], ["hole", 813], ["pill", 814], ["syringe", 815], ["thermometer", 816], ["toilet", 817], ["potable_water", 818], ["shower", 819], ["bathtub", 820], ["bath", 821], ["bellhop_bell", 822], ["key", 823], ["old_key", 824], ["door", 825], ["couch_and_lamp", 826], ["bed", 827], ["sleeping_bed", 828], ["framed_picture", 829], ["shopping", 830], ["shopping_cart", 831], ["gift", 832], ["balloon", 833], ["flags", 834], ["ribbon", 835], ["confetti_ball", 836], ["tada", 837], ["dolls", 838], ["izakaya_lantern", 839], ["lantern", 839], ["wind_chime", 840], ["email", 841], ["envelope", 841], ["envelope_with_arrow", 842], ["incoming_envelope", 843], ["e-mail", 844], ["love_letter", 845], ["inbox_tray", 846], ["outbox_tray", 847], ["package", 848], ["label", 849], ["mailbox_closed", 850], ["mailbox", 851], ["mailbox_with_mail", 852], ["mailbox_with_no_mail", 853], ["postbox", 854], ["postal_horn", 855], ["scroll", 856], ["page_with_curl", 857], ["page_facing_up", 858], ["bookmark_tabs", 859], ["bar_chart", 860], ["chart_with_upwards_trend", 861], ["chart_with_downwards_trend", 862], ["spiral_notepad", 863], ["spiral_calendar", 864], ["calendar", 865], ["date", 866], ["card_index", 867], ["card_file_box", 868], ["ballot_box", 869], ["file_cabinet", 870], ["clipboard", 871], ["file_folder", 872], ["open_file_folder", 873], ["card_index_dividers", 874], ["newspaper_roll", 875], ["newspaper", 876], ["notebook", 877], ["notebook_with_decorative_cover", 878], ["ledger", 879], ["closed_book", 880], ["green_book", 881], ["blue_book", 882], ["orange_book", 883], ["books", 884], ["book", 885], ["open_book", 885], ["bookmark", 886], ["link", 887], ["paperclip", 888], ["paperclips", 889], ["triangular_ruler", 890], ["straight_ruler", 891], ["pushpin", 892], ["round_pushpin", 893], ["scissors", 894], ["pen", 895], ["fountain_pen", 896], ["black_nib", 897], ["paintbrush", 898], ["crayon", 899], ["memo", 900], ["pencil", 900], ["pencil2", 901], ["mag", 902], ["mag_right", 903], ["lock_with_ink_pen", 904], ["closed_lock_with_key", 905], ["lock", 906], ["unlock", 907], ["heart", 908], ["yellow_heart", 909], ["green_heart", 910], ["blue_heart", 911], ["purple_heart", 912], ["black_heart", 913], ["broken_heart", 914], ["heavy_heart_exclamation", 915], ["two_hearts", 916], ["revolving_hearts", 917], ["heartbeat", 918], ["heartpulse", 919], ["sparkling_heart", 920], ["cupid", 921], ["gift_heart", 922], ["heart_decoration", 923], ["peace_symbol", 924], ["latin_cross", 925], ["star_and_crescent", 926], ["om", 927], ["wheel_of_dharma", 928], ["star_of_david", 929], ["six_pointed_star", 930], ["menorah", 931], ["yin_yang", 932], ["orthodox_cross", 933], ["place_of_worship", 934], ["ophiuchus", 935], ["aries", 936], ["taurus", 937], ["gemini", 938], ["cancer", 939], ["leo", 940], ["virgo", 941], ["libra", 942], ["scorpius", 943], ["sagittarius", 944], ["capricorn", 945], ["aquarius", 946], ["pisces", 947], ["id", 948], ["atom_symbol", 949], ["accept", 950], ["radioactive", 951], ["biohazard", 952], ["mobile_phone_off", 953], ["vibration_mode", 954], ["u6709", 955], ["u7121", 956], ["u7533", 957], ["u55b6", 958], ["u6708", 959], ["eight_pointed_black_star", 960], ["vs", 961], ["white_flower", 962], ["ideograph_advantage", 963], ["secret", 964], ["congratulations", 965], ["u5408", 966], ["u6e80", 967], ["u5272", 968], ["u7981", 969], ["a", 970], ["b", 971], ["ab", 972], ["cl", 973], ["o2", 974], ["sos", 975], ["x", 976], ["o", 977], ["stop_sign", 978], ["no_entry", 979], ["name_badge", 980], ["no_entry_sign", 981], ["100", 982], ["anger", 983], ["hotsprings", 984], ["no_pedestrians", 985], ["do_not_litter", 986], ["no_bicycles", 987], ["non-potable_water", 988], ["underage", 989], ["no_mobile_phones", 990], ["no_smoking", 991], ["exclamation", 992], ["heavy_exclamation_mark", 992], ["grey_exclamation", 993], ["question", 994], ["grey_question", 995], ["bangbang", 996], ["interrobang", 997], ["low_brightness", 998], ["high_brightness", 999], ["part_alternation_mark", 1000], ["warning", 1001], ["children_crossing", 1002], ["trident", 1003], ["fleur_de_lis", 1004], ["beginner", 1005], ["recycle", 1006], ["white_check_mark", 1007], ["u6307", 1008], ["chart", 1009], ["sparkle", 1010], ["eight_spoked_asterisk", 1011], ["negative_squared_cross_mark", 1012], ["globe_with_meridians", 1013], ["diamond_shape_with_a_dot_inside", 1014], ["m", 1015], ["cyclone", 1016], ["zzz", 1017], ["atm", 1018], ["wc", 1019], ["wheelchair", 1020], ["parking", 1021], ["u7a7a", 1022], ["sa", 1023], ["passport_control", 1024], ["customs", 1025], ["baggage_claim", 1026], ["left_luggage", 1027], ["mens", 1028], ["womens", 1029], ["baby_symbol", 1030], ["restroom", 1031], ["put_litter_in_its_place", 1032], ["cinema", 1033], ["signal_strength", 1034], ["koko", 1035], ["symbols", 1036], ["information_source", 1037], ["abc", 1038], ["abcd", 1039], ["capital_abcd", 1040], ["ng", 1041], ["ok", 1042], ["up", 1043], ["cool", 1044], ["new", 1045], ["free", 1046], ["zero", 1047], ["one", 1048], ["two", 1049], ["three", 1050], ["four", 1051], ["five", 1052], ["six", 1053], ["seven", 1054], ["eight", 1055], ["nine", 1056], ["keycap_ten", 1057], ["1234", 1058], ["hash", 1059], ["asterisk", 1060], ["arrow_forward", 1061], ["pause_button", 1062], ["play_or_pause_button", 1063], ["stop_button", 1064], ["record_button", 1065], ["next_track_button", 1066], ["previous_track_button", 1067], ["fast_forward", 1068], ["rewind", 1069], ["arrow_double_up", 1070], ["arrow_double_down", 1071], ["arrow_backward", 1072], ["arrow_up_small", 1073], ["arrow_down_small", 1074], ["arrow_right", 1075], ["arrow_left", 1076], ["arrow_up", 1077], ["arrow_down", 1078], ["arrow_upper_right", 1079], ["arrow_lower_right", 1080], ["arrow_lower_left", 1081], ["arrow_upper_left", 1082], ["arrow_up_down", 1083], ["left_right_arrow", 1084], ["arrow_right_hook", 1085], ["leftwards_arrow_with_hook", 1086], ["arrow_heading_up", 1087], ["arrow_heading_down", 1088], ["twisted_rightwards_arrows", 1089], ["repeat", 1090], ["repeat_one", 1091], ["arrows_counterclockwise", 1092], ["arrows_clockwise", 1093], ["musical_note", 1094], ["notes", 1095], ["heavy_plus_sign", 1096], ["heavy_minus_sign", 1097], ["heavy_division_sign", 1098], ["heavy_multiplication_x", 1099], ["heavy_dollar_sign", 1100], ["currency_exchange", 1101], ["tm", 1102], ["copyright", 1103], ["registered", 1104], ["wavy_dash", 1105], ["curly_loop", 1106], ["loop", 1107], ["end", 1108], ["back", 1109], ["on", 1110], ["top", 1111], ["soon", 1112], ["heavy_check_mark", 1113], ["ballot_box_with_check", 1114], ["radio_button", 1115], ["white_circle", 1116], ["black_circle", 1117], ["red_circle", 1118], ["large_blue_circle", 1119], ["small_red_triangle", 1120], ["small_red_triangle_down", 1121], ["small_orange_diamond", 1122], ["small_blue_diamond", 1123], ["large_orange_diamond", 1124], ["large_blue_diamond", 1125], ["white_square_button", 1126], ["black_square_button", 1127], ["black_small_square", 1128], ["white_small_square", 1129], ["black_medium_small_square", 1130], ["white_medium_small_square", 1131], ["black_medium_square", 1132], ["white_medium_square", 1133], ["black_large_square", 1134], ["white_large_square", 1135], ["speaker", 1136], ["mute", 1137], ["sound", 1138], ["loud_sound", 1139], ["bell", 1140], ["no_bell", 1141], ["mega", 1142], ["loudspeaker", 1143], ["eye_speech_bubble", 1144], ["speech_balloon", 1145], ["thought_balloon", 1146], ["right_anger_bubble", 1147], ["spades", 1148], ["clubs", 1149], ["hearts", 1150], ["diamonds", 1151], ["black_joker", 1152], ["flower_playing_cards", 1153], ["mahjong", 1154], ["clock1", 1155], ["clock2", 1156], ["clock3", 1157], ["clock4", 1158], ["clock5", 1159], ["clock6", 1160], ["clock7", 1161], ["clock8", 1162], ["clock9", 1163], ["clock10", 1164], ["clock11", 1165], ["clock12", 1166], ["clock130", 1167], ["clock230", 1168], ["clock330", 1169], ["clock430", 1170], ["clock530", 1171], ["clock630", 1172], ["clock730", 1173], ["clock830", 1174], ["clock930", 1175], ["clock1030", 1176], ["clock1130", 1177], ["clock1230", 1178], ["white_flag", 1179], ["black_flag", 1180], ["checkered_flag", 1181], ["triangular_flag_on_post", 1182], ["rainbow_flag", 1183], ["afghanistan", 1184], ["aland_islands", 1185], ["albania", 1186], ["algeria", 1187], ["american_samoa", 1188], ["andorra", 1189], ["angola", 1190], ["anguilla", 1191], ["antarctica", 1192], ["antigua_barbuda", 1193], ["argentina", 1194], ["armenia", 1195], ["aruba", 1196], ["australia", 1197], ["austria", 1198], ["azerbaijan", 1199], ["bahamas", 1200], ["bahrain", 1201], ["bangladesh", 1202], ["barbados", 1203], ["belarus", 1204], ["belgium", 1205], ["belize", 1206], ["benin", 1207], ["bermuda", 1208], ["bhutan", 1209], ["bolivia", 1210], ["caribbean_netherlands", 1211], ["bosnia_herzegovina", 1212], ["botswana", 1213], ["brazil", 1214], ["british_indian_ocean_territory", 1215], ["british_virgin_islands", 1216], ["brunei", 1217], ["bulgaria", 1218], ["burkina_faso", 1219], ["burundi", 1220], ["cape_verde", 1221], ["cambodia", 1222], ["cameroon", 1223], ["canada", 1224], ["ca", 1224], ["canary_islands", 1225], ["cayman_islands", 1226], ["central_african_republic", 1227], ["chad", 1228], ["chile", 1229], ["cn", 1230], ["christmas_island", 1231], ["cocos_islands", 1232], ["colombia", 1233], ["comoros", 1234], ["congo_brazzaville", 1235], ["congo_kinshasa", 1236], ["cook_islands", 1237], ["costa_rica", 1238], ["cote_divoire", 1239], ["croatia", 1240], ["cuba", 1241], ["curacao", 1242], ["cyprus", 1243], ["czech_republic", 1244], ["denmark", 1245], ["djibouti", 1246], ["dominica", 1247], ["dominican_republic", 1248], ["ecuador", 1249], ["egypt", 1250], ["el_salvador", 1251], ["equatorial_guinea", 1252], ["eritrea", 1253], ["estonia", 1254], ["ethiopia", 1255], ["eu", 1256], ["european_union", 1256], ["falkland_islands", 1257], ["faroe_islands", 1258], ["fiji", 1259], ["finland", 1260], ["fr", 1261], ["french_guiana", 1262], ["french_polynesia", 1263], ["french_southern_territories", 1264], ["gabon", 1265], ["gambia", 1266], ["georgia", 1267], ["de", 1268], ["ghana", 1269], ["gibraltar", 1270], ["greece", 1271], ["greenland", 1272], ["grenada", 1273], ["guadeloupe", 1274], ["guam", 1275], ["guatemala", 1276], ["guernsey", 1277], ["guinea", 1278], ["guinea_bissau", 1279], ["guyana", 1280], ["haiti", 1281], ["honduras", 1282], ["hong_kong", 1283], ["hungary", 1284], ["iceland", 1285], ["india", 1286], ["indonesia", 1287], ["iran", 1288], ["iraq", 1289], ["ireland", 1290], ["isle_of_man", 1291], ["israel", 1292], ["it", 1293], ["jamaica", 1294], ["jp", 1295], ["crossed_flags", 1296], ["jersey", 1297], ["jordan", 1298], ["kazakhstan", 1299], ["kenya", 1300], ["kiribati", 1301], ["kosovo", 1302], ["kuwait", 1303], ["kyrgyzstan", 1304], ["laos", 1305], ["latvia", 1306], ["lebanon", 1307], ["lesotho", 1308], ["liberia", 1309], ["libya", 1310], ["liechtenstein", 1311], ["lithuania", 1312], ["luxembourg", 1313], ["macau", 1314], ["macedonia", 1315], ["madagascar", 1316], ["malawi", 1317], ["malaysia", 1318], ["maldives", 1319], ["mali", 1320], ["malta", 1321], ["marshall_islands", 1322], ["martinique", 1323], ["mauritania", 1324], ["mauritius", 1325], ["mayotte", 1326], ["mexico", 1327], ["micronesia", 1328], ["moldova", 1329], ["monaco", 1330], ["mongolia", 1331], ["montenegro", 1332], ["montserrat", 1333], ["morocco", 1334], ["mozambique", 1335], ["myanmar", 1336], ["namibia", 1337], ["nauru", 1338], ["nepal", 1339], ["netherlands", 1340], ["new_caledonia", 1341], ["new_zealand", 1342], ["nicaragua", 1343], ["niger", 1344], ["nigeria", 1345], ["niue", 1346], ["norfolk_island", 1347], ["northern_mariana_islands", 1348], ["north_korea", 1349], ["norway", 1350], ["oman", 1351], ["pakistan", 1352], ["pk", 1352], ["palau", 1353], ["palestinian_territories", 1354], ["panama", 1355], ["papua_new_guinea", 1356], ["paraguay", 1357], ["peru", 1358], ["philippines", 1359], ["pitcairn_islands", 1360], ["poland", 1361], ["portugal", 1362], ["puerto_rico", 1363], ["qatar", 1364], ["reunion", 1365], ["romania", 1366], ["ru", 1367], ["rwanda", 1368], ["st_barthelemy", 1369], ["st_helena", 1370], ["st_kitts_nevis", 1371], ["st_lucia", 1372], ["st_pierre_miquelon", 1373], ["st_vincent_grenadines", 1374], ["samoa", 1375], ["san_marino", 1376], ["sao_tome_principe", 1377], ["saudi_arabia", 1378], ["senegal", 1379], ["serbia", 1380], ["seychelles", 1381], ["sierra_leone", 1382], ["singapore", 1383], ["sint_maarten", 1384], ["slovakia", 1385], ["slovenia", 1386], ["solomon_islands", 1387], ["somalia", 1388], ["south_africa", 1389], ["za", 1389], ["south_georgia_south_sandwich_islands", 1390], ["kr", 1391], ["south_sudan", 1392], ["es", 1393], ["sri_lanka", 1394], ["sudan", 1395], ["suriname", 1396], ["swaziland", 1397], ["sweden", 1398], ["switzerland", 1399], ["syria", 1400], ["taiwan", 1401], ["tajikistan", 1402], ["tanzania", 1403], ["thailand", 1404], ["timor_leste", 1405], ["togo", 1406], ["tokelau", 1407], ["tonga", 1408], ["trinidad_tobago", 1409], ["tunisia", 1410], ["tr", 1411], ["turkmenistan", 1412], ["turks_caicos_islands", 1413], ["tuvalu", 1414], ["uganda", 1415], ["ukraine", 1416], ["united_arab_emirates", 1417], ["gb", 1418], ["uk", 1418], ["us", 1419], ["us_virgin_islands", 1420], ["uruguay", 1421], ["uzbekistan", 1422], ["vanuatu", 1423], ["vatican_city", 1424], ["venezuela", 1425], ["vietnam", 1426], ["wallis_futuna", 1427], ["western_sahara", 1428], ["yemen", 1429], ["zambia", 1430], ["zimbabwe", 1431], ["bowtie", 1432], ["feelsgood", 1433], ["finnadie", 1434], ["goberserk", 1435], ["godmode", 1436], ["hurtrealbad", 1437], ["neckbeard", 1438], ["octocat", 1439], ["rage1", 1440], ["rage2", 1441], ["rage3", 1442], ["rage4", 1443], ["shipit", 1444], ["squirrel", 1444], ["suspect", 1445], ["trollface", 1446], ["mattermost", 1447], ["open_hands_light_skin_tone", 1448], ["open_hands_medium_light_skin_tone", 1449], ["open_hands_medium_skin_tone", 1450], ["open_hands_medium_dark_skin_tone", 1451], ["open_hands_dark_skin_tone", 1452], ["raised_hands_light_skin_tone", 1453], ["raised_hands_medium_light_skin_tone", 1454], ["raised_hands_medium_skin_tone", 1455], ["raised_hands_medium_dark_skin_tone", 1456], ["raised_hands_dark_skin_tone", 1457], ["clap_light_skin_tone", 1458], ["clap_medium_light_skin_tone", 1459], ["clap_medium_skin_tone", 1460], ["clap_medium_dark_skin_tone", 1461], ["clap_dark_skin_tone", 1462], ["pray_light_skin_tone", 1463], ["pray_medium_light_skin_tone", 1464], ["pray_medium_skin_tone", 1465], ["pray_medium_dark_skin_tone", 1466], ["pray_dark_skin_tone", 1467], ["+1_light_skin_tone", 1468], ["+1_medium_light_skin_tone", 1469], ["+1_medium_skin_tone", 1470], ["+1_medium_dark_skin_tone", 1471], ["+1_dark_skin_tone", 1472], ["-1_light_skin_tone", 1473], ["-1_medium_light_skin_tone", 1474], ["-1_medium_skin_tone", 1475], ["-1_medium_dark_skin_tone", 1476], ["-1_dark_skin_tone", 1477], ["fist_oncoming_light_skin_tone", 1478], ["fist_oncoming_medium_light_skin_tone", 1479], ["fist_oncoming_medium_skin_tone", 1480], ["fist_oncoming_medium_dark_skin_tone", 1481], ["fist_oncoming_dark_skin_tone", 1482], ["fist_raised_light_skin_tone", 1483], ["fist_raised_medium_light_skin_tone", 1484], ["fist_raised_medium_skin_tone", 1485], ["fist_raised_medium_dark_skin_tone", 1486], ["fist_raised_dark_skin_tone", 1487], ["fist_left_light_skin_tone", 1488], ["fist_left_medium_light_skin_tone", 1489], ["fist_left_medium_skin_tone", 1490], ["fist_left_medium_dark_skin_tone", 1491], ["fist_left_dark_skin_tone", 1492], ["fist_right_light_skin_tone", 1493], ["fist_right_medium_light_skin_tone", 1494], ["fist_right_medium_skin_tone", 1495], ["fist_right_medium_dark_skin_tone", 1496], ["fist_right_dark_skin_tone", 1497], ["crossed_fingers_light_skin_tone", 1498], ["crossed_fingers_medium_light_skin_tone", 1499], ["crossed_fingers_medium_skin_tone", 1500], ["crossed_fingers_medium_dark_skin_tone", 1501], ["crossed_fingers_dark_skin_tone", 1502], ["v_light_skin_tone", 1503], ["v_medium_light_skin_tone", 1504], ["v_medium_skin_tone", 1505], ["v_medium_dark_skin_tone", 1506], ["v_dark_skin_tone", 1507], ["metal_light_skin_tone", 1508], ["metal_medium_light_skin_tone", 1509], ["metal_medium_skin_tone", 1510], ["metal_medium_dark_skin_tone", 1511], ["metal_dark_skin_tone", 1512], ["ok_hand_light_skin_tone", 1513], ["ok_hand_medium_light_skin_tone", 1514], ["ok_hand_medium_skin_tone", 1515], ["ok_hand_medium_dark_skin_tone", 1516], ["ok_hand_dark_skin_tone", 1517], ["point_left_light_skin_tone", 1518], ["point_left_medium_light_skin_tone", 1519], ["point_left_medium_skin_tone", 1520], ["point_left_medium_dark_skin_tone", 1521], ["point_left_dark_skin_tone", 1522], ["point_right_light_skin_tone", 1523], ["point_right_medium_light_skin_tone", 1524], ["point_right_medium_skin_tone", 1525], ["point_right_medium_dark_skin_tone", 1526], ["point_right_dark_skin_tone", 1527], ["point_up_2_light_skin_tone", 1528], ["point_up_2_medium_light_skin_tone", 1529], ["point_up_2_medium_skin_tone", 1530], ["point_up_2_medium_dark_skin_tone", 1531], ["point_up_2_dark_skin_tone", 1532], ["point_down_light_skin_tone", 1533], ["point_down_medium_light_skin_tone", 1534], ["point_down_medium_skin_tone", 1535], ["point_down_medium_dark_skin_tone", 1536], ["point_down_dark_skin_tone", 1537], ["point_up_light_skin_tone", 1538], ["point_up_medium_light_skin_tone", 1539], ["point_up_medium_skin_tone", 1540], ["point_up_medium_dark_skin_tone", 1541], ["point_up_dark_skin_tone", 1542], ["hand_light_skin_tone", 1543], ["hand_medium_light_skin_tone", 1544], ["hand_medium_skin_tone", 1545], ["hand_medium_dark_skin_tone", 1546], ["hand_dark_skin_tone", 1547], ["raised_back_of_hand_light_skin_tone", 1548], ["raised_back_of_hand_medium_light_skin_tone", 1549], ["raised_back_of_hand_medium_skin_tone", 1550], ["raised_back_of_hand_medium_dark_skin_tone", 1551], ["raised_back_of_hand_dark_skin_tone", 1552], ["raised_hand_with_fingers_splayed_light_skin_tone", 1553], ["raised_hand_with_fingers_splayed_medium_light_skin_tone", 1554], ["raised_hand_with_fingers_splayed_medium_skin_tone", 1555], ["raised_hand_with_fingers_splayed_medium_dark_skin_tone", 1556], ["raised_hand_with_fingers_splayed_dark_skin_tone", 1557], ["vulcan_salute_light_skin_tone", 1558], ["vulcan_salute_medium_light_skin_tone", 1559], ["vulcan_salute_medium_skin_tone", 1560], ["vulcan_salute_medium_dark_skin_tone", 1561], ["vulcan_salute_dark_skin_tone", 1562], ["wave_light_skin_tone", 1563], ["wave_medium_light_skin_tone", 1564], ["wave_medium_skin_tone", 1565], ["wave_medium_dark_skin_tone", 1566], ["wave_dark_skin_tone", 1567], ["call_me_hand_light_skin_tone", 1568], ["call_me_hand_medium_light_skin_tone", 1569], ["call_me_hand_medium_skin_tone", 1570], ["call_me_hand_medium_dark_skin_tone", 1571], ["call_me_hand_dark_skin_tone", 1572], ["muscle_light_skin_tone", 1573], ["muscle_medium_light_skin_tone", 1574], ["muscle_medium_skin_tone", 1575], ["muscle_medium_dark_skin_tone", 1576], ["muscle_dark_skin_tone", 1577], ["middle_finger_light_skin_tone", 1578], ["middle_finger_medium_light_skin_tone", 1579], ["middle_finger_medium_skin_tone", 1580], ["middle_finger_medium_dark_skin_tone", 1581], ["middle_finger_dark_skin_tone", 1582], ["writing_hand_light_skin_tone", 1583], ["writing_hand_medium_light_skin_tone", 1584], ["writing_hand_medium_skin_tone", 1585], ["writing_hand_medium_dark_skin_tone", 1586], ["writing_hand_dark_skin_tone", 1587], ["selfie_light_skin_tone", 1588], ["selfie_medium_light_skin_tone", 1589], ["selfie_medium_skin_tone", 1590], ["selfie_medium_dark_skin_tone", 1591], ["selfie_dark_skin_tone", 1592], ["nail_care_light_skin_tone", 1593], ["nail_care_medium_light_skin_tone", 1594], ["nail_care_medium_skin_tone", 1595], ["nail_care_medium_dark_skin_tone", 1596], ["nail_care_dark_skin_tone", 1597], ["ear_light_skin_tone", 1598], ["ear_medium_light_skin_tone", 1599], ["ear_medium_skin_tone", 1600], ["ear_medium_dark_skin_tone", 1601], ["ear_dark_skin_tone", 1602], ["nose_light_skin_tone", 1603], ["nose_medium_light_skin_tone", 1604], ["nose_medium_skin_tone", 1605], ["nose_medium_dark_skin_tone", 1606], ["nose_dark_skin_tone", 1607], ["baby_light_skin_tone", 1608], ["baby_medium_light_skin_tone", 1609], ["baby_medium_skin_tone", 1610], ["baby_medium_dark_skin_tone", 1611], ["baby_dark_skin_tone", 1612], ["boy_light_skin_tone", 1613], ["boy_medium_light_skin_tone", 1614], ["boy_medium_skin_tone", 1615], ["boy_medium_dark_skin_tone", 1616], ["boy_dark_skin_tone", 1617], ["girl_light_skin_tone", 1618], ["girl_medium_light_skin_tone", 1619], ["girl_medium_skin_tone", 1620], ["girl_medium_dark_skin_tone", 1621], ["girl_dark_skin_tone", 1622], ["man_light_skin_tone", 1623], ["man_medium_light_skin_tone", 1624], ["man_medium_skin_tone", 1625], ["man_medium_dark_skin_tone", 1626], ["man_dark_skin_tone", 1627], ["woman_light_skin_tone", 1628], ["woman_medium_light_skin_tone", 1629], ["woman_medium_skin_tone", 1630], ["woman_medium_dark_skin_tone", 1631], ["woman_dark_skin_tone", 1632], ["blonde_woman_light_skin_tone", 1633], ["blonde_woman_medium_light_skin_tone", 1634], ["blonde_woman_medium_skin_tone", 1635], ["blonde_woman_medium_dark_skin_tone", 1636], ["blonde_woman_dark_skin_tone", 1637], ["blonde_woman_light_skin_tone", 1638], ["blonde_woman_medium_light_skin_tone", 1639], ["blonde_woman_medium_skin_tone", 1640], ["blonde_woman_medium_dark_skin_tone", 1641], ["blonde_woman_dark_skin_tone", 1642], ["blonde_man_light_skin_tone", 1643], ["blonde_man_medium_light_skin_tone", 1644], ["blonde_man_medium_skin_tone", 1645], ["blonde_man_medium_dark_skin_tone", 1646], ["blonde_man_dark_skin_tone", 1647], ["blonde_man_light_skin_tone", 1648], ["blonde_man_medium_light_skin_tone", 1649], ["blonde_man_medium_skin_tone", 1650], ["blonde_man_medium_dark_skin_tone", 1651], ["blonde_man_dark_skin_tone", 1652], ["older_man_light_skin_tone", 1653], ["older_man_medium_light_skin_tone", 1654], ["older_man_medium_skin_tone", 1655], ["older_man_medium_dark_skin_tone", 1656], ["older_man_dark_skin_tone", 1657], ["older_woman_light_skin_tone", 1658], ["older_woman_medium_light_skin_tone", 1659], ["older_woman_medium_skin_tone", 1660], ["older_woman_medium_dark_skin_tone", 1661], ["older_woman_dark_skin_tone", 1662], ["man_with_gua_pi_mao_light_skin_tone", 1663], ["man_with_gua_pi_mao_medium_light_skin_tone", 1664], ["man_with_gua_pi_mao_medium_skin_tone", 1665], ["man_with_gua_pi_mao_medium_dark_skin_tone", 1666], ["man_with_gua_pi_mao_dark_skin_tone", 1667], ["woman_with_turban_light_skin_tone", 1668], ["woman_with_turban_medium_light_skin_tone", 1669], ["woman_with_turban_medium_skin_tone", 1670], ["woman_with_turban_medium_dark_skin_tone", 1671], ["woman_with_turban_dark_skin_tone", 1672], ["woman_with_turban_light_skin_tone", 1673], ["woman_with_turban_medium_light_skin_tone", 1674], ["woman_with_turban_medium_skin_tone", 1675], ["woman_with_turban_medium_dark_skin_tone", 1676], ["woman_with_turban_dark_skin_tone", 1677], ["man_with_turban_light_skin_tone", 1678], ["man_with_turban_medium_light_skin_tone", 1679], ["man_with_turban_medium_skin_tone", 1680], ["man_with_turban_medium_dark_skin_tone", 1681], ["man_with_turban_dark_skin_tone", 1682], ["man_with_turban_light_skin_tone", 1683], ["man_with_turban_medium_light_skin_tone", 1684], ["man_with_turban_medium_skin_tone", 1685], ["man_with_turban_medium_dark_skin_tone", 1686], ["man_with_turban_dark_skin_tone", 1687], ["policewoman_light_skin_tone", 1688], ["policewoman_medium_light_skin_tone", 1689], ["policewoman_medium_skin_tone", 1690], ["policewoman_medium_dark_skin_tone", 1691], ["policewoman_dark_skin_tone", 1692], ["policewoman_light_skin_tone", 1693], ["policewoman_medium_light_skin_tone", 1694], ["policewoman_medium_skin_tone", 1695], ["policewoman_medium_dark_skin_tone", 1696], ["policewoman_dark_skin_tone", 1697], ["policeman_light_skin_tone", 1698], ["policeman_medium_light_skin_tone", 1699], ["policeman_medium_skin_tone", 1700], ["policeman_medium_dark_skin_tone", 1701], ["policeman_dark_skin_tone", 1702], ["policeman_light_skin_tone", 1703], ["policeman_medium_light_skin_tone", 1704], ["policeman_medium_skin_tone", 1705], ["policeman_medium_dark_skin_tone", 1706], ["policeman_dark_skin_tone", 1707], ["construction_worker_woman_light_skin_tone", 1708], ["construction_worker_woman_medium_light_skin_tone", 1709], ["construction_worker_woman_medium_skin_tone", 1710], ["construction_worker_woman_medium_dark_skin_tone", 1711], ["construction_worker_woman_dark_skin_tone", 1712], ["construction_worker_woman_light_skin_tone", 1713], ["construction_worker_woman_medium_light_skin_tone", 1714], ["construction_worker_woman_medium_skin_tone", 1715], ["construction_worker_woman_medium_dark_skin_tone", 1716], ["construction_worker_woman_dark_skin_tone", 1717], ["construction_worker_man_light_skin_tone", 1718], ["construction_worker_man_medium_light_skin_tone", 1719], ["construction_worker_man_medium_skin_tone", 1720], ["construction_worker_man_medium_dark_skin_tone", 1721], ["construction_worker_man_dark_skin_tone", 1722], ["construction_worker_man_light_skin_tone", 1723], ["construction_worker_man_medium_light_skin_tone", 1724], ["construction_worker_man_medium_skin_tone", 1725], ["construction_worker_man_medium_dark_skin_tone", 1726], ["construction_worker_man_dark_skin_tone", 1727], ["guardswoman_light_skin_tone", 1728], ["guardswoman_medium_light_skin_tone", 1729], ["guardswoman_medium_skin_tone", 1730], ["guardswoman_medium_dark_skin_tone", 1731], ["guardswoman_dark_skin_tone", 1732], ["guardswoman_light_skin_tone", 1733], ["guardswoman_medium_light_skin_tone", 1734], ["guardswoman_medium_skin_tone", 1735], ["guardswoman_medium_dark_skin_tone", 1736], ["guardswoman_dark_skin_tone", 1737], ["guardsman_light_skin_tone", 1738], ["guardsman_medium_light_skin_tone", 1739], ["guardsman_medium_skin_tone", 1740], ["guardsman_medium_dark_skin_tone", 1741], ["guardsman_dark_skin_tone", 1742], ["guardsman_light_skin_tone", 1743], ["guardsman_medium_light_skin_tone", 1744], ["guardsman_medium_skin_tone", 1745], ["guardsman_medium_dark_skin_tone", 1746], ["guardsman_dark_skin_tone", 1747], ["female_detective_light_skin_tone", 1748], ["female_detective_medium_light_skin_tone", 1749], ["female_detective_medium_skin_tone", 1750], ["female_detective_medium_dark_skin_tone", 1751], ["female_detective_dark_skin_tone", 1752], ["female_detective_light_skin_tone", 1753], ["female_detective_medium_light_skin_tone", 1754], ["female_detective_medium_skin_tone", 1755], ["female_detective_medium_dark_skin_tone", 1756], ["female_detective_dark_skin_tone", 1757], ["male_detective_light_skin_tone", 1758], ["male_detective_medium_light_skin_tone", 1759], ["male_detective_medium_skin_tone", 1760], ["male_detective_medium_dark_skin_tone", 1761], ["male_detective_dark_skin_tone", 1762], ["male_detective_light_skin_tone", 1763], ["male_detective_medium_light_skin_tone", 1764], ["male_detective_medium_skin_tone", 1765], ["male_detective_medium_dark_skin_tone", 1766], ["male_detective_dark_skin_tone", 1767], ["woman_health_worker_light_skin_tone", 1768], ["woman_health_worker_medium_light_skin_tone", 1769], ["woman_health_worker_medium_skin_tone", 1770], ["woman_health_worker_medium_dark_skin_tone", 1771], ["woman_health_worker_dark_skin_tone", 1772], ["man_health_worker_light_skin_tone", 1773], ["man_health_worker_medium_light_skin_tone", 1774], ["man_health_worker_medium_skin_tone", 1775], ["man_health_worker_medium_dark_skin_tone", 1776], ["man_health_worker_dark_skin_tone", 1777], ["woman_farmer_light_skin_tone", 1778], ["woman_farmer_medium_light_skin_tone", 1779], ["woman_farmer_medium_skin_tone", 1780], ["woman_farmer_medium_dark_skin_tone", 1781], ["woman_farmer_dark_skin_tone", 1782], ["man_farmer_light_skin_tone", 1783], ["man_farmer_medium_light_skin_tone", 1784], ["man_farmer_medium_skin_tone", 1785], ["man_farmer_medium_dark_skin_tone", 1786], ["man_farmer_dark_skin_tone", 1787], ["woman_cook_light_skin_tone", 1788], ["woman_cook_medium_light_skin_tone", 1789], ["woman_cook_medium_skin_tone", 1790], ["woman_cook_medium_dark_skin_tone", 1791], ["woman_cook_dark_skin_tone", 1792], ["man_cook_light_skin_tone", 1793], ["man_cook_medium_light_skin_tone", 1794], ["man_cook_medium_skin_tone", 1795], ["man_cook_medium_dark_skin_tone", 1796], ["man_cook_dark_skin_tone", 1797], ["woman_student_light_skin_tone", 1798], ["woman_student_medium_light_skin_tone", 1799], ["woman_student_medium_skin_tone", 1800], ["woman_student_medium_dark_skin_tone", 1801], ["woman_student_dark_skin_tone", 1802], ["man_student_light_skin_tone", 1803], ["man_student_medium_light_skin_tone", 1804], ["man_student_medium_skin_tone", 1805], ["man_student_medium_dark_skin_tone", 1806], ["man_student_dark_skin_tone", 1807], ["woman_singer_light_skin_tone", 1808], ["woman_singer_medium_light_skin_tone", 1809], ["woman_singer_medium_skin_tone", 1810], ["woman_singer_medium_dark_skin_tone", 1811], ["woman_singer_dark_skin_tone", 1812], ["man_singer_light_skin_tone", 1813], ["man_singer_medium_light_skin_tone", 1814], ["man_singer_medium_skin_tone", 1815], ["man_singer_medium_dark_skin_tone", 1816], ["man_singer_dark_skin_tone", 1817], ["woman_teacher_light_skin_tone", 1818], ["woman_teacher_medium_light_skin_tone", 1819], ["woman_teacher_medium_skin_tone", 1820], ["woman_teacher_medium_dark_skin_tone", 1821], ["woman_teacher_dark_skin_tone", 1822], ["man_teacher_light_skin_tone", 1823], ["man_teacher_medium_light_skin_tone", 1824], ["man_teacher_medium_skin_tone", 1825], ["man_teacher_medium_dark_skin_tone", 1826], ["man_teacher_dark_skin_tone", 1827], ["woman_factory_worker_light_skin_tone", 1828], ["woman_factory_worker_medium_light_skin_tone", 1829], ["woman_factory_worker_medium_skin_tone", 1830], ["woman_factory_worker_medium_dark_skin_tone", 1831], ["woman_factory_worker_dark_skin_tone", 1832], ["man_factory_worker_light_skin_tone", 1833], ["man_factory_worker_medium_light_skin_tone", 1834], ["man_factory_worker_medium_skin_tone", 1835], ["man_factory_worker_medium_dark_skin_tone", 1836], ["man_factory_worker_dark_skin_tone", 1837], ["woman_technologist_light_skin_tone", 1838], ["woman_technologist_medium_light_skin_tone", 1839], ["woman_technologist_medium_skin_tone", 1840], ["woman_technologist_medium_dark_skin_tone", 1841], ["woman_technologist_dark_skin_tone", 1842], ["man_technologist_light_skin_tone", 1843], ["man_technologist_medium_light_skin_tone", 1844], ["man_technologist_medium_skin_tone", 1845], ["man_technologist_medium_dark_skin_tone", 1846], ["man_technologist_dark_skin_tone", 1847], ["woman_office_worker_light_skin_tone", 1848], ["woman_office_worker_medium_light_skin_tone", 1849], ["woman_office_worker_medium_skin_tone", 1850], ["woman_office_worker_medium_dark_skin_tone", 1851], ["woman_office_worker_dark_skin_tone", 1852], ["man_office_worker_light_skin_tone", 1853], ["man_office_worker_medium_light_skin_tone", 1854], ["man_office_worker_medium_skin_tone", 1855], ["man_office_worker_medium_dark_skin_tone", 1856], ["man_office_worker_dark_skin_tone", 1857], ["woman_mechanic_light_skin_tone", 1858], ["woman_mechanic_medium_light_skin_tone", 1859], ["woman_mechanic_medium_skin_tone", 1860], ["woman_mechanic_medium_dark_skin_tone", 1861], ["woman_mechanic_dark_skin_tone", 1862], ["man_mechanic_light_skin_tone", 1863], ["man_mechanic_medium_light_skin_tone", 1864], ["man_mechanic_medium_skin_tone", 1865], ["man_mechanic_medium_dark_skin_tone", 1866], ["man_mechanic_dark_skin_tone", 1867], ["woman_scientist_light_skin_tone", 1868], ["woman_scientist_medium_light_skin_tone", 1869], ["woman_scientist_medium_skin_tone", 1870], ["woman_scientist_medium_dark_skin_tone", 1871], ["woman_scientist_dark_skin_tone", 1872], ["man_scientist_light_skin_tone", 1873], ["man_scientist_medium_light_skin_tone", 1874], ["man_scientist_medium_skin_tone", 1875], ["man_scientist_medium_dark_skin_tone", 1876], ["man_scientist_dark_skin_tone", 1877], ["woman_artist_light_skin_tone", 1878], ["woman_artist_medium_light_skin_tone", 1879], ["woman_artist_medium_skin_tone", 1880], ["woman_artist_medium_dark_skin_tone", 1881], ["woman_artist_dark_skin_tone", 1882], ["man_artist_light_skin_tone", 1883], ["man_artist_medium_light_skin_tone", 1884], ["man_artist_medium_skin_tone", 1885], ["man_artist_medium_dark_skin_tone", 1886], ["man_artist_dark_skin_tone", 1887], ["woman_firefighter_light_skin_tone", 1888], ["woman_firefighter_medium_light_skin_tone", 1889], ["woman_firefighter_medium_skin_tone", 1890], ["woman_firefighter_medium_dark_skin_tone", 1891], ["woman_firefighter_dark_skin_tone", 1892], ["man_firefighter_light_skin_tone", 1893], ["man_firefighter_medium_light_skin_tone", 1894], ["man_firefighter_medium_skin_tone", 1895], ["man_firefighter_medium_dark_skin_tone", 1896], ["man_firefighter_dark_skin_tone", 1897], ["woman_pilot_light_skin_tone", 1898], ["woman_pilot_medium_light_skin_tone", 1899], ["woman_pilot_medium_skin_tone", 1900], ["woman_pilot_medium_dark_skin_tone", 1901], ["woman_pilot_dark_skin_tone", 1902], ["man_pilot_light_skin_tone", 1903], ["man_pilot_medium_light_skin_tone", 1904], ["man_pilot_medium_skin_tone", 1905], ["man_pilot_medium_dark_skin_tone", 1906], ["man_pilot_dark_skin_tone", 1907], ["woman_astronaut_light_skin_tone", 1908], ["woman_astronaut_medium_light_skin_tone", 1909], ["woman_astronaut_medium_skin_tone", 1910], ["woman_astronaut_medium_dark_skin_tone", 1911], ["woman_astronaut_dark_skin_tone", 1912], ["man_astronaut_light_skin_tone", 1913], ["man_astronaut_medium_light_skin_tone", 1914], ["man_astronaut_medium_skin_tone", 1915], ["man_astronaut_medium_dark_skin_tone", 1916], ["man_astronaut_dark_skin_tone", 1917], ["woman_judge_light_skin_tone", 1918], ["woman_judge_medium_light_skin_tone", 1919], ["woman_judge_medium_skin_tone", 1920], ["woman_judge_medium_dark_skin_tone", 1921], ["woman_judge_dark_skin_tone", 1922], ["man_judge_light_skin_tone", 1923], ["man_judge_medium_light_skin_tone", 1924], ["man_judge_medium_skin_tone", 1925], ["man_judge_medium_dark_skin_tone", 1926], ["man_judge_dark_skin_tone", 1927], ["mrs_claus_light_skin_tone", 1928], ["mrs_claus_medium_light_skin_tone", 1929], ["mrs_claus_medium_skin_tone", 1930], ["mrs_claus_medium_dark_skin_tone", 1931], ["mrs_claus_dark_skin_tone", 1932], ["santa_light_skin_tone", 1933], ["santa_medium_light_skin_tone", 1934], ["santa_medium_skin_tone", 1935], ["santa_medium_dark_skin_tone", 1936], ["santa_dark_skin_tone", 1937], ["princess_light_skin_tone", 1938], ["princess_medium_light_skin_tone", 1939], ["princess_medium_skin_tone", 1940], ["princess_medium_dark_skin_tone", 1941], ["princess_dark_skin_tone", 1942], ["prince_light_skin_tone", 1943], ["prince_medium_light_skin_tone", 1944], ["prince_medium_skin_tone", 1945], ["prince_medium_dark_skin_tone", 1946], ["prince_dark_skin_tone", 1947], ["bride_with_veil_light_skin_tone", 1948], ["bride_with_veil_medium_light_skin_tone", 1949], ["bride_with_veil_medium_skin_tone", 1950], ["bride_with_veil_medium_dark_skin_tone", 1951], ["bride_with_veil_dark_skin_tone", 1952], ["man_in_tuxedo_light_skin_tone", 1953], ["man_in_tuxedo_medium_light_skin_tone", 1954], ["man_in_tuxedo_medium_skin_tone", 1955], ["man_in_tuxedo_medium_dark_skin_tone", 1956], ["man_in_tuxedo_dark_skin_tone", 1957], ["angel_light_skin_tone", 1958], ["angel_medium_light_skin_tone", 1959], ["angel_medium_skin_tone", 1960], ["angel_medium_dark_skin_tone", 1961], ["angel_dark_skin_tone", 1962], ["pregnant_woman_light_skin_tone", 1963], ["pregnant_woman_medium_light_skin_tone", 1964], ["pregnant_woman_medium_skin_tone", 1965], ["pregnant_woman_medium_dark_skin_tone", 1966], ["pregnant_woman_dark_skin_tone", 1967], ["bowing_woman_light_skin_tone", 1968], ["bowing_woman_medium_light_skin_tone", 1969], ["bowing_woman_medium_skin_tone", 1970], ["bowing_woman_medium_dark_skin_tone", 1971], ["bowing_woman_dark_skin_tone", 1972], ["bowing_woman_light_skin_tone", 1973], ["bowing_woman_medium_light_skin_tone", 1974], ["bowing_woman_medium_skin_tone", 1975], ["bowing_woman_medium_dark_skin_tone", 1976], ["bowing_woman_dark_skin_tone", 1977], ["bowing_man_light_skin_tone", 1978], ["bowing_man_medium_light_skin_tone", 1979], ["bowing_man_medium_skin_tone", 1980], ["bowing_man_medium_dark_skin_tone", 1981], ["bowing_man_dark_skin_tone", 1982], ["bowing_man_light_skin_tone", 1983], ["bowing_man_medium_light_skin_tone", 1984], ["bowing_man_medium_skin_tone", 1985], ["bowing_man_medium_dark_skin_tone", 1986], ["bowing_man_dark_skin_tone", 1987], ["tipping_hand_woman_light_skin_tone", 1988], ["tipping_hand_woman_medium_light_skin_tone", 1989], ["tipping_hand_woman_medium_skin_tone", 1990], ["tipping_hand_woman_medium_dark_skin_tone", 1991], ["tipping_hand_woman_dark_skin_tone", 1992], ["tipping_hand_woman_light_skin_tone", 1993], ["tipping_hand_woman_medium_light_skin_tone", 1994], ["tipping_hand_woman_medium_skin_tone", 1995], ["tipping_hand_woman_medium_dark_skin_tone", 1996], ["tipping_hand_woman_dark_skin_tone", 1997], ["tipping_hand_man_light_skin_tone", 1998], ["tipping_hand_man_medium_light_skin_tone", 1999], ["tipping_hand_man_medium_skin_tone", 2000], ["tipping_hand_man_medium_dark_skin_tone", 2001], ["tipping_hand_man_dark_skin_tone", 2002], ["no_good_woman_light_skin_tone", 2003], ["no_good_woman_medium_light_skin_tone", 2004], ["no_good_woman_medium_skin_tone", 2005], ["no_good_woman_medium_dark_skin_tone", 2006], ["no_good_woman_dark_skin_tone", 2007], ["no_good_woman_light_skin_tone", 2008], ["no_good_woman_medium_light_skin_tone", 2009], ["no_good_woman_medium_skin_tone", 2010], ["no_good_woman_medium_dark_skin_tone", 2011], ["no_good_woman_dark_skin_tone", 2012], ["no_good_man_light_skin_tone", 2013], ["no_good_man_medium_light_skin_tone", 2014], ["no_good_man_medium_skin_tone", 2015], ["no_good_man_medium_dark_skin_tone", 2016], ["no_good_man_dark_skin_tone", 2017], ["ok_woman_light_skin_tone", 2018], ["ok_woman_medium_light_skin_tone", 2019], ["ok_woman_medium_skin_tone", 2020], ["ok_woman_medium_dark_skin_tone", 2021], ["ok_woman_dark_skin_tone", 2022], ["ok_woman_light_skin_tone", 2023], ["ok_woman_medium_light_skin_tone", 2024], ["ok_woman_medium_skin_tone", 2025], ["ok_woman_medium_dark_skin_tone", 2026], ["ok_woman_dark_skin_tone", 2027], ["ok_man_light_skin_tone", 2028], ["ok_man_medium_light_skin_tone", 2029], ["ok_man_medium_skin_tone", 2030], ["ok_man_medium_dark_skin_tone", 2031], ["ok_man_dark_skin_tone", 2032], ["raising_hand_woman_light_skin_tone", 2033], ["raising_hand_woman_medium_light_skin_tone", 2034], ["raising_hand_woman_medium_skin_tone", 2035], ["raising_hand_woman_medium_dark_skin_tone", 2036], ["raising_hand_woman_dark_skin_tone", 2037], ["raising_hand_woman_light_skin_tone", 2038], ["raising_hand_woman_medium_light_skin_tone", 2039], ["raising_hand_woman_medium_skin_tone", 2040], ["raising_hand_woman_medium_dark_skin_tone", 2041], ["raising_hand_woman_dark_skin_tone", 2042], ["raising_hand_man_light_skin_tone", 2043], ["raising_hand_man_medium_light_skin_tone", 2044], ["raising_hand_man_medium_skin_tone", 2045], ["raising_hand_man_medium_dark_skin_tone", 2046], ["raising_hand_man_dark_skin_tone", 2047], ["woman_facepalming_light_skin_tone", 2048], ["woman_facepalming_medium_light_skin_tone", 2049], ["woman_facepalming_medium_skin_tone", 2050], ["woman_facepalming_medium_dark_skin_tone", 2051], ["woman_facepalming_dark_skin_tone", 2052], ["woman_facepalming_light_skin_tone", 2053], ["woman_facepalming_medium_light_skin_tone", 2054], ["woman_facepalming_medium_skin_tone", 2055], ["woman_facepalming_medium_dark_skin_tone", 2056], ["woman_facepalming_dark_skin_tone", 2057], ["man_facepalming_light_skin_tone", 2058], ["man_facepalming_medium_light_skin_tone", 2059], ["man_facepalming_medium_skin_tone", 2060], ["man_facepalming_medium_dark_skin_tone", 2061], ["man_facepalming_dark_skin_tone", 2062], ["woman_shrugging_light_skin_tone", 2063], ["woman_shrugging_medium_light_skin_tone", 2064], ["woman_shrugging_medium_skin_tone", 2065], ["woman_shrugging_medium_dark_skin_tone", 2066], ["woman_shrugging_dark_skin_tone", 2067], ["woman_shrugging_light_skin_tone", 2068], ["woman_shrugging_medium_light_skin_tone", 2069], ["woman_shrugging_medium_skin_tone", 2070], ["woman_shrugging_medium_dark_skin_tone", 2071], ["woman_shrugging_dark_skin_tone", 2072], ["man_shrugging_light_skin_tone", 2073], ["man_shrugging_medium_light_skin_tone", 2074], ["man_shrugging_medium_skin_tone", 2075], ["man_shrugging_medium_dark_skin_tone", 2076], ["man_shrugging_dark_skin_tone", 2077], ["pouting_woman_light_skin_tone", 2078], ["pouting_woman_medium_light_skin_tone", 2079], ["pouting_woman_medium_skin_tone", 2080], ["pouting_woman_medium_dark_skin_tone", 2081], ["pouting_woman_dark_skin_tone", 2082], ["pouting_woman_light_skin_tone", 2083], ["pouting_woman_medium_light_skin_tone", 2084], ["pouting_woman_medium_skin_tone", 2085], ["pouting_woman_medium_dark_skin_tone", 2086], ["pouting_woman_dark_skin_tone", 2087], ["pouting_man_light_skin_tone", 2088], ["pouting_man_medium_light_skin_tone", 2089], ["pouting_man_medium_skin_tone", 2090], ["pouting_man_medium_dark_skin_tone", 2091], ["pouting_man_dark_skin_tone", 2092], ["frowning_woman_light_skin_tone", 2093], ["frowning_woman_medium_light_skin_tone", 2094], ["frowning_woman_medium_skin_tone", 2095], ["frowning_woman_medium_dark_skin_tone", 2096], ["frowning_woman_dark_skin_tone", 2097], ["frowning_woman_light_skin_tone", 2098], ["frowning_woman_medium_light_skin_tone", 2099], ["frowning_woman_medium_skin_tone", 2100], ["frowning_woman_medium_dark_skin_tone", 2101], ["frowning_woman_dark_skin_tone", 2102], ["frowning_man_light_skin_tone", 2103], ["frowning_man_medium_light_skin_tone", 2104], ["frowning_man_medium_skin_tone", 2105], ["frowning_man_medium_dark_skin_tone", 2106], ["frowning_man_dark_skin_tone", 2107], ["haircut_woman_light_skin_tone", 2108], ["haircut_woman_medium_light_skin_tone", 2109], ["haircut_woman_medium_skin_tone", 2110], ["haircut_woman_medium_dark_skin_tone", 2111], ["haircut_woman_dark_skin_tone", 2112], ["haircut_woman_light_skin_tone", 2113], ["haircut_woman_medium_light_skin_tone", 2114], ["haircut_woman_medium_skin_tone", 2115], ["haircut_woman_medium_dark_skin_tone", 2116], ["haircut_woman_dark_skin_tone", 2117], ["haircut_man_light_skin_tone", 2118], ["haircut_man_medium_light_skin_tone", 2119], ["haircut_man_medium_skin_tone", 2120], ["haircut_man_medium_dark_skin_tone", 2121], ["haircut_man_dark_skin_tone", 2122], ["massage_woman_light_skin_tone", 2123], ["massage_woman_medium_light_skin_tone", 2124], ["massage_woman_medium_skin_tone", 2125], ["massage_woman_medium_dark_skin_tone", 2126], ["massage_woman_dark_skin_tone", 2127], ["massage_woman_light_skin_tone", 2128], ["massage_woman_medium_light_skin_tone", 2129], ["massage_woman_medium_skin_tone", 2130], ["massage_woman_medium_dark_skin_tone", 2131], ["massage_woman_dark_skin_tone", 2132], ["massage_man_light_skin_tone", 2133], ["massage_man_medium_light_skin_tone", 2134], ["massage_man_medium_skin_tone", 2135], ["massage_man_medium_dark_skin_tone", 2136], ["massage_man_dark_skin_tone", 2137], ["business_suit_levitating_light_skin_tone", 2138], ["business_suit_levitating_medium_light_skin_tone", 2139], ["business_suit_levitating_medium_skin_tone", 2140], ["business_suit_levitating_medium_dark_skin_tone", 2141], ["business_suit_levitating_dark_skin_tone", 2142], ["dancer_light_skin_tone", 2143], ["dancer_medium_light_skin_tone", 2144], ["dancer_medium_skin_tone", 2145], ["dancer_medium_dark_skin_tone", 2146], ["dancer_dark_skin_tone", 2147], ["man_dancing_light_skin_tone", 2148], ["man_dancing_medium_light_skin_tone", 2149], ["man_dancing_medium_skin_tone", 2150], ["man_dancing_medium_dark_skin_tone", 2151], ["man_dancing_dark_skin_tone", 2152], ["walking_woman_light_skin_tone", 2153], ["walking_woman_medium_light_skin_tone", 2154], ["walking_woman_medium_skin_tone", 2155], ["walking_woman_medium_dark_skin_tone", 2156], ["walking_woman_dark_skin_tone", 2157], ["walking_woman_light_skin_tone", 2158], ["walking_woman_medium_light_skin_tone", 2159], ["walking_woman_medium_skin_tone", 2160], ["walking_woman_medium_dark_skin_tone", 2161], ["walking_woman_dark_skin_tone", 2162], ["walking_man_light_skin_tone", 2163], ["walking_man_medium_light_skin_tone", 2164], ["walking_man_medium_skin_tone", 2165], ["walking_man_medium_dark_skin_tone", 2166], ["walking_man_dark_skin_tone", 2167], ["walking_man_light_skin_tone", 2168], ["walking_man_medium_light_skin_tone", 2169], ["walking_man_medium_skin_tone", 2170], ["walking_man_medium_dark_skin_tone", 2171], ["walking_man_dark_skin_tone", 2172], ["running_woman_light_skin_tone", 2173], ["running_woman_medium_light_skin_tone", 2174], ["running_woman_medium_skin_tone", 2175], ["running_woman_medium_dark_skin_tone", 2176], ["running_woman_dark_skin_tone", 2177], ["running_woman_light_skin_tone", 2178], ["running_woman_medium_light_skin_tone", 2179], ["running_woman_medium_skin_tone", 2180], ["running_woman_medium_dark_skin_tone", 2181], ["running_woman_dark_skin_tone", 2182], ["running_man_light_skin_tone", 2183], ["running_man_medium_light_skin_tone", 2184], ["running_man_medium_skin_tone", 2185], ["running_man_medium_dark_skin_tone", 2186], ["running_man_dark_skin_tone", 2187], ["running_man_light_skin_tone", 2188], ["running_man_medium_light_skin_tone", 2189], ["running_man_medium_skin_tone", 2190], ["running_man_medium_dark_skin_tone", 2191], ["running_man_dark_skin_tone", 2192], ["couple_with_heart_woman_woman_light_skin_tone", 2193], ["couple_with_heart_woman_woman_medium_light_skin_tone", 2194], ["couple_with_heart_woman_woman_medium_skin_tone", 2195], ["couple_with_heart_woman_woman_medium_dark_skin_tone", 2196], ["couple_with_heart_woman_woman_dark_skin_tone", 2197], ["couple_with_heart_man_man_light_skin_tone", 2198], ["couple_with_heart_man_man_medium_light_skin_tone", 2199], ["couple_with_heart_man_man_medium_skin_tone", 2200], ["couple_with_heart_man_man_medium_dark_skin_tone", 2201], ["couple_with_heart_man_man_dark_skin_tone", 2202], ["couplekiss_woman_woman_light_skin_tone", 2203], ["couplekiss_woman_woman_medium_light_skin_tone", 2204], ["couplekiss_woman_woman_medium_skin_tone", 2205], ["couplekiss_woman_woman_medium_dark_skin_tone", 2206], ["couplekiss_woman_woman_dark_skin_tone", 2207], ["couplekiss_man_man_light_skin_tone", 2208], ["couplekiss_man_man_medium_light_skin_tone", 2209], ["couplekiss_man_man_medium_skin_tone", 2210], ["couplekiss_man_man_medium_dark_skin_tone", 2211], ["couplekiss_man_man_dark_skin_tone", 2212], ["family_man_woman_girl_light_skin_tone", 2213], ["family_man_woman_girl_medium_light_skin_tone", 2214], ["family_man_woman_girl_medium_skin_tone", 2215], ["family_man_woman_girl_medium_dark_skin_tone", 2216], ["family_man_woman_girl_dark_skin_tone", 2217], ["family_man_woman_girl_boy_light_skin_tone", 2218], ["family_man_woman_girl_boy_medium_light_skin_tone", 2219], ["family_man_woman_girl_boy_medium_skin_tone", 2220], ["family_man_woman_girl_boy_medium_dark_skin_tone", 2221], ["family_man_woman_girl_boy_dark_skin_tone", 2222], ["family_man_woman_boy_boy_light_skin_tone", 2223], ["family_man_woman_boy_boy_medium_light_skin_tone", 2224], ["family_man_woman_boy_boy_medium_skin_tone", 2225], ["family_man_woman_boy_boy_medium_dark_skin_tone", 2226], ["family_man_woman_boy_boy_dark_skin_tone", 2227], ["family_man_woman_girl_girl_light_skin_tone", 2228], ["family_man_woman_girl_girl_medium_light_skin_tone", 2229], ["family_man_woman_girl_girl_medium_skin_tone", 2230], ["family_man_woman_girl_girl_medium_dark_skin_tone", 2231], ["family_man_woman_girl_girl_dark_skin_tone", 2232], ["family_woman_woman_boy_light_skin_tone", 2233], ["family_woman_woman_boy_medium_light_skin_tone", 2234], ["family_woman_woman_boy_medium_skin_tone", 2235], ["family_woman_woman_boy_medium_dark_skin_tone", 2236], ["family_woman_woman_boy_dark_skin_tone", 2237], ["family_woman_woman_girl_light_skin_tone", 2238], ["family_woman_woman_girl_medium_light_skin_tone", 2239], ["family_woman_woman_girl_medium_skin_tone", 2240], ["family_woman_woman_girl_medium_dark_skin_tone", 2241], ["family_woman_woman_girl_dark_skin_tone", 2242], ["family_woman_woman_girl_boy_light_skin_tone", 2243], ["family_woman_woman_girl_boy_medium_light_skin_tone", 2244], ["family_woman_woman_girl_boy_medium_skin_tone", 2245], ["family_woman_woman_girl_boy_medium_dark_skin_tone", 2246], ["family_woman_woman_girl_boy_dark_skin_tone", 2247], ["family_woman_woman_boy_boy_light_skin_tone", 2248], ["family_woman_woman_boy_boy_medium_light_skin_tone", 2249], ["family_woman_woman_boy_boy_medium_skin_tone", 2250], ["family_woman_woman_boy_boy_medium_dark_skin_tone", 2251], ["family_woman_woman_boy_boy_dark_skin_tone", 2252], ["family_woman_woman_girl_girl_light_skin_tone", 2253], ["family_woman_woman_girl_girl_medium_light_skin_tone", 2254], ["family_woman_woman_girl_girl_medium_skin_tone", 2255], ["family_woman_woman_girl_girl_medium_dark_skin_tone", 2256], ["family_woman_woman_girl_girl_dark_skin_tone", 2257], ["family_man_man_boy_light_skin_tone", 2258], ["family_man_man_boy_medium_light_skin_tone", 2259], ["family_man_man_boy_medium_skin_tone", 2260], ["family_man_man_boy_medium_dark_skin_tone", 2261], ["family_man_man_boy_dark_skin_tone", 2262], ["family_man_man_girl_light_skin_tone", 2263], ["family_man_man_girl_medium_light_skin_tone", 2264], ["family_man_man_girl_medium_skin_tone", 2265], ["family_man_man_girl_medium_dark_skin_tone", 2266], ["family_man_man_girl_dark_skin_tone", 2267], ["family_man_man_girl_boy_light_skin_tone", 2268], ["family_man_man_girl_boy_medium_light_skin_tone", 2269], ["family_man_man_girl_boy_medium_skin_tone", 2270], ["family_man_man_girl_boy_medium_dark_skin_tone", 2271], ["family_man_man_girl_boy_dark_skin_tone", 2272], ["family_man_man_boy_boy_light_skin_tone", 2273], ["family_man_man_boy_boy_medium_light_skin_tone", 2274], ["family_man_man_boy_boy_medium_skin_tone", 2275], ["family_man_man_boy_boy_medium_dark_skin_tone", 2276], ["family_man_man_boy_boy_dark_skin_tone", 2277], ["family_man_man_girl_girl_light_skin_tone", 2278], ["family_man_man_girl_girl_medium_light_skin_tone", 2279], ["family_man_man_girl_girl_medium_skin_tone", 2280], ["family_man_man_girl_girl_medium_dark_skin_tone", 2281], ["family_man_man_girl_girl_dark_skin_tone", 2282], ["family_woman_boy_light_skin_tone", 2283], ["family_woman_boy_medium_light_skin_tone", 2284], ["family_woman_boy_medium_skin_tone", 2285], ["family_woman_boy_medium_dark_skin_tone", 2286], ["family_woman_boy_dark_skin_tone", 2287], ["family_woman_girl_light_skin_tone", 2288], ["family_woman_girl_medium_light_skin_tone", 2289], ["family_woman_girl_medium_skin_tone", 2290], ["family_woman_girl_medium_dark_skin_tone", 2291], ["family_woman_girl_dark_skin_tone", 2292], ["family_woman_girl_boy_light_skin_tone", 2293], ["family_woman_girl_boy_medium_light_skin_tone", 2294], ["family_woman_girl_boy_medium_skin_tone", 2295], ["family_woman_girl_boy_medium_dark_skin_tone", 2296], ["family_woman_girl_boy_dark_skin_tone", 2297], ["family_woman_boy_boy_light_skin_tone", 2298], ["family_woman_boy_boy_medium_light_skin_tone", 2299], ["family_woman_boy_boy_medium_skin_tone", 2300], ["family_woman_boy_boy_medium_dark_skin_tone", 2301], ["family_woman_boy_boy_dark_skin_tone", 2302], ["family_woman_girl_girl_light_skin_tone", 2303], ["family_woman_girl_girl_medium_light_skin_tone", 2304], ["family_woman_girl_girl_medium_skin_tone", 2305], ["family_woman_girl_girl_medium_dark_skin_tone", 2306], ["family_woman_girl_girl_dark_skin_tone", 2307], ["family_man_boy_light_skin_tone", 2308], ["family_man_boy_medium_light_skin_tone", 2309], ["family_man_boy_medium_skin_tone", 2310], ["family_man_boy_medium_dark_skin_tone", 2311], ["family_man_boy_dark_skin_tone", 2312], ["family_man_girl_light_skin_tone", 2313], ["family_man_girl_medium_light_skin_tone", 2314], ["family_man_girl_medium_skin_tone", 2315], ["family_man_girl_medium_dark_skin_tone", 2316], ["family_man_girl_dark_skin_tone", 2317], ["family_man_girl_boy_light_skin_tone", 2318], ["family_man_girl_boy_medium_light_skin_tone", 2319], ["family_man_girl_boy_medium_skin_tone", 2320], ["family_man_girl_boy_medium_dark_skin_tone", 2321], ["family_man_girl_boy_dark_skin_tone", 2322], ["family_man_boy_boy_light_skin_tone", 2323], ["family_man_boy_boy_medium_light_skin_tone", 2324], ["family_man_boy_boy_medium_skin_tone", 2325], ["family_man_boy_boy_medium_dark_skin_tone", 2326], ["family_man_boy_boy_dark_skin_tone", 2327], ["family_man_girl_girl_light_skin_tone", 2328], ["family_man_girl_girl_medium_light_skin_tone", 2329], ["family_man_girl_girl_medium_skin_tone", 2330], ["family_man_girl_girl_medium_dark_skin_tone", 2331], ["family_man_girl_girl_dark_skin_tone", 2332], ["weight_lifting_woman_light_skin_tone", 2333], ["weight_lifting_woman_medium_light_skin_tone", 2334], ["weight_lifting_woman_medium_skin_tone", 2335], ["weight_lifting_woman_medium_dark_skin_tone", 2336], ["weight_lifting_woman_dark_skin_tone", 2337], ["weight_lifting_woman_light_skin_tone", 2338], ["weight_lifting_woman_medium_light_skin_tone", 2339], ["weight_lifting_woman_medium_skin_tone", 2340], ["weight_lifting_woman_medium_dark_skin_tone", 2341], ["weight_lifting_woman_dark_skin_tone", 2342], ["weight_lifting_man_light_skin_tone", 2343], ["weight_lifting_man_medium_light_skin_tone", 2344], ["weight_lifting_man_medium_skin_tone", 2345], ["weight_lifting_man_medium_dark_skin_tone", 2346], ["weight_lifting_man_dark_skin_tone", 2347], ["weight_lifting_man_light_skin_tone", 2348], ["weight_lifting_man_medium_light_skin_tone", 2349], ["weight_lifting_man_medium_skin_tone", 2350], ["weight_lifting_man_medium_dark_skin_tone", 2351], ["weight_lifting_man_dark_skin_tone", 2352], ["woman_cartwheeling_light_skin_tone", 2353], ["woman_cartwheeling_medium_light_skin_tone", 2354], ["woman_cartwheeling_medium_skin_tone", 2355], ["woman_cartwheeling_medium_dark_skin_tone", 2356], ["woman_cartwheeling_dark_skin_tone", 2357], ["woman_cartwheeling_light_skin_tone", 2358], ["woman_cartwheeling_medium_light_skin_tone", 2359], ["woman_cartwheeling_medium_skin_tone", 2360], ["woman_cartwheeling_medium_dark_skin_tone", 2361], ["woman_cartwheeling_dark_skin_tone", 2362], ["man_cartwheeling_light_skin_tone", 2363], ["man_cartwheeling_medium_light_skin_tone", 2364], ["man_cartwheeling_medium_skin_tone", 2365], ["man_cartwheeling_medium_dark_skin_tone", 2366], ["man_cartwheeling_dark_skin_tone", 2367], ["basketball_woman_light_skin_tone", 2368], ["basketball_woman_medium_light_skin_tone", 2369], ["basketball_woman_medium_skin_tone", 2370], ["basketball_woman_medium_dark_skin_tone", 2371], ["basketball_woman_dark_skin_tone", 2372], ["basketball_woman_light_skin_tone", 2373], ["basketball_woman_medium_light_skin_tone", 2374], ["basketball_woman_medium_skin_tone", 2375], ["basketball_woman_medium_dark_skin_tone", 2376], ["basketball_woman_dark_skin_tone", 2377], ["basketball_man_light_skin_tone", 2378], ["basketball_man_medium_light_skin_tone", 2379], ["basketball_man_medium_skin_tone", 2380], ["basketball_man_medium_dark_skin_tone", 2381], ["basketball_man_dark_skin_tone", 2382], ["basketball_man_light_skin_tone", 2383], ["basketball_man_medium_light_skin_tone", 2384], ["basketball_man_medium_skin_tone", 2385], ["basketball_man_medium_dark_skin_tone", 2386], ["basketball_man_dark_skin_tone", 2387], ["woman_playing_handball_light_skin_tone", 2388], ["woman_playing_handball_medium_light_skin_tone", 2389], ["woman_playing_handball_medium_skin_tone", 2390], ["woman_playing_handball_medium_dark_skin_tone", 2391], ["woman_playing_handball_dark_skin_tone", 2392], ["woman_playing_handball_light_skin_tone", 2393], ["woman_playing_handball_medium_light_skin_tone", 2394], ["woman_playing_handball_medium_skin_tone", 2395], ["woman_playing_handball_medium_dark_skin_tone", 2396], ["woman_playing_handball_dark_skin_tone", 2397], ["man_playing_handball_light_skin_tone", 2398], ["man_playing_handball_medium_light_skin_tone", 2399], ["man_playing_handball_medium_skin_tone", 2400], ["man_playing_handball_medium_dark_skin_tone", 2401], ["man_playing_handball_dark_skin_tone", 2402], ["golfing_woman_light_skin_tone", 2403], ["golfing_woman_medium_light_skin_tone", 2404], ["golfing_woman_medium_skin_tone", 2405], ["golfing_woman_medium_dark_skin_tone", 2406], ["golfing_woman_dark_skin_tone", 2407], ["golfing_woman_light_skin_tone", 2408], ["golfing_woman_medium_light_skin_tone", 2409], ["golfing_woman_medium_skin_tone", 2410], ["golfing_woman_medium_dark_skin_tone", 2411], ["golfing_woman_dark_skin_tone", 2412], ["golfing_man_light_skin_tone", 2413], ["golfing_man_medium_light_skin_tone", 2414], ["golfing_man_medium_skin_tone", 2415], ["golfing_man_medium_dark_skin_tone", 2416], ["golfing_man_dark_skin_tone", 2417], ["golfing_man_light_skin_tone", 2418], ["golfing_man_medium_light_skin_tone", 2419], ["golfing_man_medium_skin_tone", 2420], ["golfing_man_medium_dark_skin_tone", 2421], ["golfing_man_dark_skin_tone", 2422], ["surfing_woman_light_skin_tone", 2423], ["surfing_woman_medium_light_skin_tone", 2424], ["surfing_woman_medium_skin_tone", 2425], ["surfing_woman_medium_dark_skin_tone", 2426], ["surfing_woman_dark_skin_tone", 2427], ["surfing_woman_light_skin_tone", 2428], ["surfing_woman_medium_light_skin_tone", 2429], ["surfing_woman_medium_skin_tone", 2430], ["surfing_woman_medium_dark_skin_tone", 2431], ["surfing_woman_dark_skin_tone", 2432], ["surfing_man_light_skin_tone", 2433], ["surfing_man_medium_light_skin_tone", 2434], ["surfing_man_medium_skin_tone", 2435], ["surfing_man_medium_dark_skin_tone", 2436], ["surfing_man_dark_skin_tone", 2437], ["surfing_man_light_skin_tone", 2438], ["surfing_man_medium_light_skin_tone", 2439], ["surfing_man_medium_skin_tone", 2440], ["surfing_man_medium_dark_skin_tone", 2441], ["surfing_man_dark_skin_tone", 2442], ["swimming_woman_light_skin_tone", 2443], ["swimming_woman_medium_light_skin_tone", 2444], ["swimming_woman_medium_skin_tone", 2445], ["swimming_woman_medium_dark_skin_tone", 2446], ["swimming_woman_dark_skin_tone", 2447], ["swimming_woman_light_skin_tone", 2448], ["swimming_woman_medium_light_skin_tone", 2449], ["swimming_woman_medium_skin_tone", 2450], ["swimming_woman_medium_dark_skin_tone", 2451], ["swimming_woman_dark_skin_tone", 2452], ["swimming_man_light_skin_tone", 2453], ["swimming_man_medium_light_skin_tone", 2454], ["swimming_man_medium_skin_tone", 2455], ["swimming_man_medium_dark_skin_tone", 2456], ["swimming_man_dark_skin_tone", 2457], ["swimming_man_light_skin_tone", 2458], ["swimming_man_medium_light_skin_tone", 2459], ["swimming_man_medium_skin_tone", 2460], ["swimming_man_medium_dark_skin_tone", 2461], ["swimming_man_dark_skin_tone", 2462], ["woman_playing_water_polo_light_skin_tone", 2463], ["woman_playing_water_polo_medium_light_skin_tone", 2464], ["woman_playing_water_polo_medium_skin_tone", 2465], ["woman_playing_water_polo_medium_dark_skin_tone", 2466], ["woman_playing_water_polo_dark_skin_tone", 2467], ["woman_playing_water_polo_light_skin_tone", 2468], ["woman_playing_water_polo_medium_light_skin_tone", 2469], ["woman_playing_water_polo_medium_skin_tone", 2470], ["woman_playing_water_polo_medium_dark_skin_tone", 2471], ["woman_playing_water_polo_dark_skin_tone", 2472], ["man_playing_water_polo_light_skin_tone", 2473], ["man_playing_water_polo_medium_light_skin_tone", 2474], ["man_playing_water_polo_medium_skin_tone", 2475], ["man_playing_water_polo_medium_dark_skin_tone", 2476], ["man_playing_water_polo_dark_skin_tone", 2477], ["rowing_woman_light_skin_tone", 2478], ["rowing_woman_medium_light_skin_tone", 2479], ["rowing_woman_medium_skin_tone", 2480], ["rowing_woman_medium_dark_skin_tone", 2481], ["rowing_woman_dark_skin_tone", 2482], ["rowing_woman_light_skin_tone", 2483], ["rowing_woman_medium_light_skin_tone", 2484], ["rowing_woman_medium_skin_tone", 2485], ["rowing_woman_medium_dark_skin_tone", 2486], ["rowing_woman_dark_skin_tone", 2487], ["rowing_man_light_skin_tone", 2488], ["rowing_man_medium_light_skin_tone", 2489], ["rowing_man_medium_skin_tone", 2490], ["rowing_man_medium_dark_skin_tone", 2491], ["rowing_man_dark_skin_tone", 2492], ["rowing_man_light_skin_tone", 2493], ["rowing_man_medium_light_skin_tone", 2494], ["rowing_man_medium_skin_tone", 2495], ["rowing_man_medium_dark_skin_tone", 2496], ["rowing_man_dark_skin_tone", 2497], ["horse_racing_light_skin_tone", 2498], ["horse_racing_medium_light_skin_tone", 2499], ["horse_racing_medium_skin_tone", 2500], ["horse_racing_medium_dark_skin_tone", 2501], ["horse_racing_dark_skin_tone", 2502], ["biking_woman_light_skin_tone", 2503], ["biking_woman_medium_light_skin_tone", 2504], ["biking_woman_medium_skin_tone", 2505], ["biking_woman_medium_dark_skin_tone", 2506], ["biking_woman_dark_skin_tone", 2507], ["biking_woman_light_skin_tone", 2508], ["biking_woman_medium_light_skin_tone", 2509], ["biking_woman_medium_skin_tone", 2510], ["biking_woman_medium_dark_skin_tone", 2511], ["biking_woman_dark_skin_tone", 2512], ["biking_man_light_skin_tone", 2513], ["biking_man_medium_light_skin_tone", 2514], ["biking_man_medium_skin_tone", 2515], ["biking_man_medium_dark_skin_tone", 2516], ["biking_man_dark_skin_tone", 2517], ["biking_man_light_skin_tone", 2518], ["biking_man_medium_light_skin_tone", 2519], ["biking_man_medium_skin_tone", 2520], ["biking_man_medium_dark_skin_tone", 2521], ["biking_man_dark_skin_tone", 2522], ["mountain_biking_woman_light_skin_tone", 2523], ["mountain_biking_woman_medium_light_skin_tone", 2524], ["mountain_biking_woman_medium_skin_tone", 2525], ["mountain_biking_woman_medium_dark_skin_tone", 2526], ["mountain_biking_woman_dark_skin_tone", 2527], ["mountain_biking_woman_light_skin_tone", 2528], ["mountain_biking_woman_medium_light_skin_tone", 2529], ["mountain_biking_woman_medium_skin_tone", 2530], ["mountain_biking_woman_medium_dark_skin_tone", 2531], ["mountain_biking_woman_dark_skin_tone", 2532], ["mountain_biking_man_light_skin_tone", 2533], ["mountain_biking_man_medium_light_skin_tone", 2534], ["mountain_biking_man_medium_skin_tone", 2535], ["mountain_biking_man_medium_dark_skin_tone", 2536], ["mountain_biking_man_dark_skin_tone", 2537], ["mountain_biking_man_light_skin_tone", 2538], ["mountain_biking_man_medium_light_skin_tone", 2539], ["mountain_biking_man_medium_skin_tone", 2540], ["mountain_biking_man_medium_dark_skin_tone", 2541], ["mountain_biking_man_dark_skin_tone", 2542], ["woman_juggling_light_skin_tone", 2543], ["woman_juggling_medium_light_skin_tone", 2544], ["woman_juggling_medium_skin_tone", 2545], ["woman_juggling_medium_dark_skin_tone", 2546], ["woman_juggling_dark_skin_tone", 2547], ["woman_juggling_light_skin_tone", 2548], ["woman_juggling_medium_light_skin_tone", 2549], ["woman_juggling_medium_skin_tone", 2550], ["woman_juggling_medium_dark_skin_tone", 2551], ["woman_juggling_dark_skin_tone", 2552], ["man_juggling_light_skin_tone", 2553], ["man_juggling_medium_light_skin_tone", 2554], ["man_juggling_medium_skin_tone", 2555], ["man_juggling_medium_dark_skin_tone", 2556], ["man_juggling_dark_skin_tone", 2557], ["bath_light_skin_tone", 2558], ["bath_medium_light_skin_tone", 2559], ["bath_medium_skin_tone", 2560], ["bath_medium_dark_skin_tone", 2561], ["bath_dark_skin_tone", 2562]]);

var EmojiIndicesByUnicode = exports.EmojiIndicesByUnicode = new _map2.default([["1f600", 0], ["1f600-fe0f", 0], ["1f603", 1], ["1f603-fe0f", 1], ["1f604", 2], ["1f604-fe0f", 2], ["1f601", 3], ["1f601-fe0f", 3], ["1f606", 4], ["1f606-fe0f", 4], ["1f605", 5], ["1f605-fe0f", 5], ["1f602", 6], ["1f602-fe0f", 6], ["1f923", 7], ["1f923-fe0f", 7], ["263a-fe0f", 8], ["1f60a", 9], ["1f60a-fe0f", 9], ["1f607", 10], ["1f607-fe0f", 10], ["1f642", 11], ["1f642-fe0f", 11], ["1f643", 12], ["1f643-fe0f", 12], ["1f609", 13], ["1f609-fe0f", 13], ["1f60c", 14], ["1f60c-fe0f", 14], ["1f60d", 15], ["1f60d-fe0f", 15], ["1f618", 16], ["1f618-fe0f", 16], ["1f617", 17], ["1f617-fe0f", 17], ["1f619", 18], ["1f619-fe0f", 18], ["1f61a", 19], ["1f61a-fe0f", 19], ["1f60b", 20], ["1f60b-fe0f", 20], ["1f61c", 21], ["1f61c-fe0f", 21], ["1f61d", 22], ["1f61d-fe0f", 22], ["1f61b", 23], ["1f61b-fe0f", 23], ["1f911", 24], ["1f911-fe0f", 24], ["1f917", 25], ["1f917-fe0f", 25], ["1f913", 26], ["1f913-fe0f", 26], ["1f60e", 27], ["1f60e-fe0f", 27], ["1f921", 28], ["1f921-fe0f", 28], ["1f920", 29], ["1f920-fe0f", 29], ["1f60f", 30], ["1f60f-fe0f", 30], ["1f612", 31], ["1f612-fe0f", 31], ["1f61e", 32], ["1f61e-fe0f", 32], ["1f614", 33], ["1f614-fe0f", 33], ["1f61f", 34], ["1f61f-fe0f", 34], ["1f615", 35], ["1f615-fe0f", 35], ["1f641", 36], ["1f641-fe0f", 36], ["2639-fe0f", 37], ["1f623", 38], ["1f623-fe0f", 38], ["1f616", 39], ["1f616-fe0f", 39], ["1f62b", 40], ["1f62b-fe0f", 40], ["1f629", 41], ["1f629-fe0f", 41], ["1f624", 42], ["1f624-fe0f", 42], ["1f620", 43], ["1f620-fe0f", 43], ["1f621", 44], ["1f621-fe0f", 44], ["1f636", 45], ["1f636-fe0f", 45], ["1f610", 46], ["1f610-fe0f", 46], ["1f611", 47], ["1f611-fe0f", 47], ["1f62f", 48], ["1f62f-fe0f", 48], ["1f626", 49], ["1f626-fe0f", 49], ["1f627", 50], ["1f627-fe0f", 50], ["1f62e", 51], ["1f62e-fe0f", 51], ["1f632", 52], ["1f632-fe0f", 52], ["1f635", 53], ["1f635-fe0f", 53], ["1f633", 54], ["1f633-fe0f", 54], ["1f631", 55], ["1f631-fe0f", 55], ["1f628", 56], ["1f628-fe0f", 56], ["1f630", 57], ["1f630-fe0f", 57], ["1f622", 58], ["1f622-fe0f", 58], ["1f625", 59], ["1f625-fe0f", 59], ["1f924", 60], ["1f924-fe0f", 60], ["1f62d", 61], ["1f62d-fe0f", 61], ["1f613", 62], ["1f613-fe0f", 62], ["1f62a", 63], ["1f62a-fe0f", 63], ["1f634", 64], ["1f634-fe0f", 64], ["1f644", 65], ["1f644-fe0f", 65], ["1f914", 66], ["1f914-fe0f", 66], ["1f925", 67], ["1f925-fe0f", 67], ["1f62c", 68], ["1f62c-fe0f", 68], ["1f910", 69], ["1f910-fe0f", 69], ["1f922", 70], ["1f922-fe0f", 70], ["1f927", 71], ["1f927-fe0f", 71], ["1f637", 72], ["1f637-fe0f", 72], ["1f912", 73], ["1f912-fe0f", 73], ["1f915", 74], ["1f915-fe0f", 74], ["1f608", 75], ["1f608-fe0f", 75], ["1f47f", 76], ["1f47f-fe0f", 76], ["1f479", 77], ["1f479-fe0f", 77], ["1f47a", 78], ["1f47a-fe0f", 78], ["1f4a9", 79], ["1f4a9-fe0f", 79], ["1f47b", 80], ["1f47b-fe0f", 80], ["1f480", 81], ["1f480-fe0f", 81], ["2620-fe0f", 82], ["1f47d", 83], ["1f47d-fe0f", 83], ["1f47e", 84], ["1f47e-fe0f", 84], ["1f916", 85], ["1f916-fe0f", 85], ["1f383", 86], ["1f383-fe0f", 86], ["1f63a", 87], ["1f63a-fe0f", 87], ["1f638", 88], ["1f638-fe0f", 88], ["1f639", 89], ["1f639-fe0f", 89], ["1f63b", 90], ["1f63b-fe0f", 90], ["1f63c", 91], ["1f63c-fe0f", 91], ["1f63d", 92], ["1f63d-fe0f", 92], ["1f640", 93], ["1f640-fe0f", 93], ["1f63f", 94], ["1f63f-fe0f", 94], ["1f63e", 95], ["1f63e-fe0f", 95], ["1f450", 96], ["1f450-fe0f", 96], ["1f64c", 97], ["1f64c-fe0f", 97], ["1f44f", 98], ["1f44f-fe0f", 98], ["1f64f", 99], ["1f64f-fe0f", 99], ["1f91d", 100], ["1f91d-fe0f", 100], ["1f44d", 101], ["1f44d-fe0f", 101], ["1f44e", 102], ["1f44e-fe0f", 102], ["1f44a", 103], ["1f44a-fe0f", 103], ["270a", 104], ["270a-fe0f", 104], ["1f91b", 105], ["1f91b-fe0f", 105], ["1f91c", 106], ["1f91c-fe0f", 106], ["1f91e", 107], ["1f91e-fe0f", 107], ["270c-fe0f", 108], ["1f918", 109], ["1f918-fe0f", 109], ["1f44c", 110], ["1f44c-fe0f", 110], ["1f448", 111], ["1f448-fe0f", 111], ["1f449", 112], ["1f449-fe0f", 112], ["1f446", 113], ["1f446-fe0f", 113], ["1f447", 114], ["1f447-fe0f", 114], ["261d-fe0f", 115], ["270b", 116], ["270b-fe0f", 116], ["1f91a", 117], ["1f91a-fe0f", 117], ["1f590", 118], ["1f590-fe0f", 118], ["1f596", 119], ["1f596-fe0f", 119], ["1f44b", 120], ["1f44b-fe0f", 120], ["1f919", 121], ["1f919-fe0f", 121], ["1f4aa", 122], ["1f4aa-fe0f", 122], ["1f595", 123], ["1f595-fe0f", 123], ["270d-fe0f", 124], ["1f933", 125], ["1f933-fe0f", 125], ["1f485", 126], ["1f485-fe0f", 126], ["1f48d", 127], ["1f48d-fe0f", 127], ["1f484", 128], ["1f484-fe0f", 128], ["1f48b", 129], ["1f48b-fe0f", 129], ["1f444", 130], ["1f444-fe0f", 130], ["1f445", 131], ["1f445-fe0f", 131], ["1f442", 132], ["1f442-fe0f", 132], ["1f443", 133], ["1f443-fe0f", 133], ["1f463", 134], ["1f463-fe0f", 134], ["1f441", 135], ["1f441-fe0f", 135], ["1f440", 136], ["1f440-fe0f", 136], ["1f5e3", 137], ["1f5e3-fe0f", 137], ["1f464", 138], ["1f464-fe0f", 138], ["1f465", 139], ["1f465-fe0f", 139], ["1f476", 140], ["1f476-fe0f", 140], ["1f466", 141], ["1f466-fe0f", 141], ["1f467", 142], ["1f467-fe0f", 142], ["1f468", 143], ["1f468-fe0f", 143], ["1f469", 144], ["1f469-fe0f", 144], ["1f471-200d-2640-fe0f", 145], ["1f471", 146], ["1f471-fe0f", 146], ["1f471-200d-2642-fe0f", 146], ["1f474", 147], ["1f474-fe0f", 147], ["1f475", 148], ["1f475-fe0f", 148], ["1f472", 149], ["1f472-fe0f", 149], ["1f473-200d-2640-fe0f", 150], ["1f473", 151], ["1f473-fe0f", 151], ["1f473-200d-2642-fe0f", 151], ["1f46e-200d-2640-fe0f", 152], ["1f46e", 153], ["1f46e-fe0f", 153], ["1f46e-200d-2642-fe0f", 153], ["1f477-200d-2640-fe0f", 154], ["1f477", 155], ["1f477-fe0f", 155], ["1f477-200d-2642-fe0f", 155], ["1f482-200d-2640-fe0f", 156], ["1f482", 157], ["1f482-fe0f", 157], ["1f482-200d-2642-fe0f", 157], ["1f575-fe0f-200d-2640-fe0f", 158], ["1f575-200d-2640-fe0f-fe0f", 158], ["1f575-fe0f", 159], ["1f575-fe0f-200d-2642-fe0f", 159], ["1f469-200d-2695-fe0f", 160], ["1f468-200d-2695-fe0f", 161], ["1f469-200d-1f33e", 162], ["1f469-200d-1f33e-fe0f", 162], ["1f468-200d-1f33e", 163], ["1f468-200d-1f33e-fe0f", 163], ["1f469-200d-1f373", 164], ["1f469-200d-1f373-fe0f", 164], ["1f468-200d-1f373", 165], ["1f468-200d-1f373-fe0f", 165], ["1f469-200d-1f393", 166], ["1f469-200d-1f393-fe0f", 166], ["1f468-200d-1f393", 167], ["1f468-200d-1f393-fe0f", 167], ["1f469-200d-1f3a4", 168], ["1f469-200d-1f3a4-fe0f", 168], ["1f468-200d-1f3a4", 169], ["1f468-200d-1f3a4-fe0f", 169], ["1f469-200d-1f3eb", 170], ["1f469-200d-1f3eb-fe0f", 170], ["1f468-200d-1f3eb", 171], ["1f468-200d-1f3eb-fe0f", 171], ["1f469-200d-1f3ed", 172], ["1f469-200d-1f3ed-fe0f", 172], ["1f468-200d-1f3ed", 173], ["1f468-200d-1f3ed-fe0f", 173], ["1f469-200d-1f4bb", 174], ["1f469-200d-1f4bb-fe0f", 174], ["1f468-200d-1f4bb", 175], ["1f468-200d-1f4bb-fe0f", 175], ["1f469-200d-1f4bc", 176], ["1f469-200d-1f4bc-fe0f", 176], ["1f468-200d-1f4bc", 177], ["1f468-200d-1f4bc-fe0f", 177], ["1f469-200d-1f527", 178], ["1f469-200d-1f527-fe0f", 178], ["1f468-200d-1f527", 179], ["1f468-200d-1f527-fe0f", 179], ["1f469-200d-1f52c", 180], ["1f469-200d-1f52c-fe0f", 180], ["1f468-200d-1f52c", 181], ["1f468-200d-1f52c-fe0f", 181], ["1f469-200d-1f3a8", 182], ["1f469-200d-1f3a8-fe0f", 182], ["1f468-200d-1f3a8", 183], ["1f468-200d-1f3a8-fe0f", 183], ["1f469-200d-1f692", 184], ["1f469-200d-1f692-fe0f", 184], ["1f468-200d-1f692", 185], ["1f468-200d-1f692-fe0f", 185], ["1f469-200d-2708-fe0f", 186], ["1f468-200d-2708-fe0f", 187], ["1f469-200d-1f680", 188], ["1f469-200d-1f680-fe0f", 188], ["1f468-200d-1f680", 189], ["1f468-200d-1f680-fe0f", 189], ["1f469-200d-2696-fe0f", 190], ["1f468-200d-2696-fe0f", 191], ["1f936", 192], ["1f936-fe0f", 192], ["1f385", 193], ["1f385-fe0f", 193], ["1f478", 194], ["1f478-fe0f", 194], ["1f934", 195], ["1f934-fe0f", 195], ["1f470", 196], ["1f470-fe0f", 196], ["1f935", 197], ["1f935-fe0f", 197], ["1f47c", 198], ["1f47c-fe0f", 198], ["1f930", 199], ["1f930-fe0f", 199], ["1f647-200d-2640-fe0f", 200], ["1f647", 201], ["1f647-fe0f", 201], ["1f647-200d-2642-fe0f", 201], ["1f481", 202], ["1f481-fe0f", 202], ["1f481-200d-2640-fe0f", 202], ["1f481-200d-2642-fe0f", 203], ["1f645", 204], ["1f645-fe0f", 204], ["1f645-200d-2640-fe0f", 204], ["1f645-200d-2642-fe0f", 205], ["1f646", 206], ["1f646-fe0f", 206], ["1f646-200d-2640-fe0f", 206], ["1f646-200d-2642-fe0f", 207], ["1f64b", 208], ["1f64b-fe0f", 208], ["1f64b-200d-2640-fe0f", 208], ["1f64b-200d-2642-fe0f", 209], ["1f926-200d-2640-fe0f", 210], ["1f926-200d-2642-fe0f", 211], ["1f937-200d-2640-fe0f", 212], ["1f937-200d-2642-fe0f", 213], ["1f64e", 214], ["1f64e-fe0f", 214], ["1f64e-200d-2640-fe0f", 214], ["1f64e-200d-2642-fe0f", 215], ["1f64d", 216], ["1f64d-fe0f", 216], ["1f64d-200d-2640-fe0f", 216], ["1f64d-200d-2642-fe0f", 217], ["1f487", 218], ["1f487-fe0f", 218], ["1f487-200d-2640-fe0f", 218], ["1f487-200d-2642-fe0f", 219], ["1f486", 220], ["1f486-fe0f", 220], ["1f486-200d-2640-fe0f", 220], ["1f486-200d-2642-fe0f", 221], ["1f574", 222], ["1f574-fe0f", 222], ["1f483", 223], ["1f483-fe0f", 223], ["1f57a", 224], ["1f57a-fe0f", 224], ["1f46f", 225], ["1f46f-fe0f", 225], ["1f46f-200d-2640-fe0f", 225], ["1f46f-200d-2642-fe0f", 226], ["1f6b6-200d-2640-fe0f", 227], ["1f6b6", 228], ["1f6b6-fe0f", 228], ["1f6b6-200d-2642-fe0f", 228], ["1f3c3-200d-2640-fe0f", 229], ["1f3c3", 230], ["1f3c3-fe0f", 230], ["1f3c3-200d-2642-fe0f", 230], ["1f46b", 231], ["1f46b-fe0f", 231], ["1f46d", 232], ["1f46d-fe0f", 232], ["1f46c", 233], ["1f46c-fe0f", 233], ["1f491", 234], ["1f491-fe0f", 234], ["1f469-200d-2764-fe0f-200d-1f469", 235], ["1f469-200d-2764-200d-1f469-fe0f", 235], ["1f468-200d-2764-fe0f-200d-1f468", 236], ["1f468-200d-2764-200d-1f468-fe0f", 236], ["1f48f", 237], ["1f48f-fe0f", 237], ["1f469-200d-2764-fe0f-200d-1f48b-200d-1f469", 238], ["1f469-200d-2764-200d-1f48b-200d-1f469-fe0f", 238], ["1f468-200d-2764-fe0f-200d-1f48b-200d-1f468", 239], ["1f468-200d-2764-200d-1f48b-200d-1f468-fe0f", 239], ["1f46a", 240], ["1f46a-fe0f", 240], ["1f468-200d-1f469-200d-1f467", 241], ["1f468-200d-1f469-200d-1f467-fe0f", 241], ["1f468-200d-1f469-200d-1f467-200d-1f466", 242], ["1f468-200d-1f469-200d-1f467-200d-1f466-fe0f", 242], ["1f468-200d-1f469-200d-1f466-200d-1f466", 243], ["1f468-200d-1f469-200d-1f466-200d-1f466-fe0f", 243], ["1f468-200d-1f469-200d-1f467-200d-1f467", 244], ["1f468-200d-1f469-200d-1f467-200d-1f467-fe0f", 244], ["1f469-200d-1f469-200d-1f466", 245], ["1f469-200d-1f469-200d-1f466-fe0f", 245], ["1f469-200d-1f469-200d-1f467", 246], ["1f469-200d-1f469-200d-1f467-fe0f", 246], ["1f469-200d-1f469-200d-1f467-200d-1f466", 247], ["1f469-200d-1f469-200d-1f467-200d-1f466-fe0f", 247], ["1f469-200d-1f469-200d-1f466-200d-1f466", 248], ["1f469-200d-1f469-200d-1f466-200d-1f466-fe0f", 248], ["1f469-200d-1f469-200d-1f467-200d-1f467", 249], ["1f469-200d-1f469-200d-1f467-200d-1f467-fe0f", 249], ["1f468-200d-1f468-200d-1f466", 250], ["1f468-200d-1f468-200d-1f466-fe0f", 250], ["1f468-200d-1f468-200d-1f467", 251], ["1f468-200d-1f468-200d-1f467-fe0f", 251], ["1f468-200d-1f468-200d-1f467-200d-1f466", 252], ["1f468-200d-1f468-200d-1f467-200d-1f466-fe0f", 252], ["1f468-200d-1f468-200d-1f466-200d-1f466", 253], ["1f468-200d-1f468-200d-1f466-200d-1f466-fe0f", 253], ["1f468-200d-1f468-200d-1f467-200d-1f467", 254], ["1f468-200d-1f468-200d-1f467-200d-1f467-fe0f", 254], ["1f469-200d-1f466", 255], ["1f469-200d-1f466-fe0f", 255], ["1f469-200d-1f467", 256], ["1f469-200d-1f467-fe0f", 256], ["1f469-200d-1f467-200d-1f466", 257], ["1f469-200d-1f467-200d-1f466-fe0f", 257], ["1f469-200d-1f466-200d-1f466", 258], ["1f469-200d-1f466-200d-1f466-fe0f", 258], ["1f469-200d-1f467-200d-1f467", 259], ["1f469-200d-1f467-200d-1f467-fe0f", 259], ["1f468-200d-1f466", 260], ["1f468-200d-1f466-fe0f", 260], ["1f468-200d-1f467", 261], ["1f468-200d-1f467-fe0f", 261], ["1f468-200d-1f467-200d-1f466", 262], ["1f468-200d-1f467-200d-1f466-fe0f", 262], ["1f468-200d-1f466-200d-1f466", 263], ["1f468-200d-1f466-200d-1f466-fe0f", 263], ["1f468-200d-1f467-200d-1f467", 264], ["1f468-200d-1f467-200d-1f467-fe0f", 264], ["1f45a", 265], ["1f45a-fe0f", 265], ["1f455", 266], ["1f455-fe0f", 266], ["1f456", 267], ["1f456-fe0f", 267], ["1f454", 268], ["1f454-fe0f", 268], ["1f457", 269], ["1f457-fe0f", 269], ["1f459", 270], ["1f459-fe0f", 270], ["1f458", 271], ["1f458-fe0f", 271], ["1f460", 272], ["1f460-fe0f", 272], ["1f461", 273], ["1f461-fe0f", 273], ["1f462", 274], ["1f462-fe0f", 274], ["1f45e", 275], ["1f45e-fe0f", 275], ["1f45f", 276], ["1f45f-fe0f", 276], ["1f452", 277], ["1f452-fe0f", 277], ["1f3a9", 278], ["1f3a9-fe0f", 278], ["1f393", 279], ["1f393-fe0f", 279], ["1f451", 280], ["1f451-fe0f", 280], ["26d1", 281], ["26d1-fe0f", 281], ["1f392", 282], ["1f392-fe0f", 282], ["1f45d", 283], ["1f45d-fe0f", 283], ["1f45b", 284], ["1f45b-fe0f", 284], ["1f45c", 285], ["1f45c-fe0f", 285], ["1f4bc", 286], ["1f4bc-fe0f", 286], ["1f453", 287], ["1f453-fe0f", 287], ["1f576", 288], ["1f576-fe0f", 288], ["1f302", 289], ["1f302-fe0f", 289], ["2602-fe0f", 290], ["1f436", 291], ["1f436-fe0f", 291], ["1f431", 292], ["1f431-fe0f", 292], ["1f42d", 293], ["1f42d-fe0f", 293], ["1f439", 294], ["1f439-fe0f", 294], ["1f430", 295], ["1f430-fe0f", 295], ["1f98a", 296], ["1f98a-fe0f", 296], ["1f43b", 297], ["1f43b-fe0f", 297], ["1f43c", 298], ["1f43c-fe0f", 298], ["1f428", 299], ["1f428-fe0f", 299], ["1f42f", 300], ["1f42f-fe0f", 300], ["1f981", 301], ["1f981-fe0f", 301], ["1f42e", 302], ["1f42e-fe0f", 302], ["1f437", 303], ["1f437-fe0f", 303], ["1f43d", 304], ["1f43d-fe0f", 304], ["1f438", 305], ["1f438-fe0f", 305], ["1f435", 306], ["1f435-fe0f", 306], ["1f648", 307], ["1f648-fe0f", 307], ["1f649", 308], ["1f649-fe0f", 308], ["1f64a", 309], ["1f64a-fe0f", 309], ["1f412", 310], ["1f412-fe0f", 310], ["1f414", 311], ["1f414-fe0f", 311], ["1f427", 312], ["1f427-fe0f", 312], ["1f426", 313], ["1f426-fe0f", 313], ["1f424", 314], ["1f424-fe0f", 314], ["1f423", 315], ["1f423-fe0f", 315], ["1f425", 316], ["1f425-fe0f", 316], ["1f986", 317], ["1f986-fe0f", 317], ["1f985", 318], ["1f985-fe0f", 318], ["1f989", 319], ["1f989-fe0f", 319], ["1f987", 320], ["1f987-fe0f", 320], ["1f43a", 321], ["1f43a-fe0f", 321], ["1f417", 322], ["1f417-fe0f", 322], ["1f434", 323], ["1f434-fe0f", 323], ["1f984", 324], ["1f984-fe0f", 324], ["1f41d", 325], ["1f41d-fe0f", 325], ["1f41b", 326], ["1f41b-fe0f", 326], ["1f98b", 327], ["1f98b-fe0f", 327], ["1f40c", 328], ["1f40c-fe0f", 328], ["1f41a", 329], ["1f41a-fe0f", 329], ["1f41e", 330], ["1f41e-fe0f", 330], ["1f41c", 331], ["1f41c-fe0f", 331], ["1f577", 332], ["1f577-fe0f", 332], ["1f578", 333], ["1f578-fe0f", 333], ["1f422", 334], ["1f422-fe0f", 334], ["1f40d", 335], ["1f40d-fe0f", 335], ["1f98e", 336], ["1f98e-fe0f", 336], ["1f982", 337], ["1f982-fe0f", 337], ["1f980", 338], ["1f980-fe0f", 338], ["1f991", 339], ["1f991-fe0f", 339], ["1f419", 340], ["1f419-fe0f", 340], ["1f990", 341], ["1f990-fe0f", 341], ["1f420", 342], ["1f420-fe0f", 342], ["1f41f", 343], ["1f41f-fe0f", 343], ["1f421", 344], ["1f421-fe0f", 344], ["1f42c", 345], ["1f42c-fe0f", 345], ["1f988", 346], ["1f988-fe0f", 346], ["1f433", 347], ["1f433-fe0f", 347], ["1f40b", 348], ["1f40b-fe0f", 348], ["1f40a", 349], ["1f40a-fe0f", 349], ["1f406", 350], ["1f406-fe0f", 350], ["1f405", 351], ["1f405-fe0f", 351], ["1f403", 352], ["1f403-fe0f", 352], ["1f402", 353], ["1f402-fe0f", 353], ["1f404", 354], ["1f404-fe0f", 354], ["1f98c", 355], ["1f98c-fe0f", 355], ["1f42a", 356], ["1f42a-fe0f", 356], ["1f42b", 357], ["1f42b-fe0f", 357], ["1f418", 358], ["1f418-fe0f", 358], ["1f98f", 359], ["1f98f-fe0f", 359], ["1f98d", 360], ["1f98d-fe0f", 360], ["1f40e", 361], ["1f40e-fe0f", 361], ["1f416", 362], ["1f416-fe0f", 362], ["1f410", 363], ["1f410-fe0f", 363], ["1f40f", 364], ["1f40f-fe0f", 364], ["1f411", 365], ["1f411-fe0f", 365], ["1f415", 366], ["1f415-fe0f", 366], ["1f429", 367], ["1f429-fe0f", 367], ["1f408", 368], ["1f408-fe0f", 368], ["1f413", 369], ["1f413-fe0f", 369], ["1f983", 370], ["1f983-fe0f", 370], ["1f54a", 371], ["1f54a-fe0f", 371], ["1f407", 372], ["1f407-fe0f", 372], ["1f401", 373], ["1f401-fe0f", 373], ["1f400", 374], ["1f400-fe0f", 374], ["1f43f", 375], ["1f43f-fe0f", 375], ["1f43e", 376], ["1f43e-fe0f", 376], ["1f409", 377], ["1f409-fe0f", 377], ["1f432", 378], ["1f432-fe0f", 378], ["1f335", 379], ["1f335-fe0f", 379], ["1f384", 380], ["1f384-fe0f", 380], ["1f332", 381], ["1f332-fe0f", 381], ["1f333", 382], ["1f333-fe0f", 382], ["1f334", 383], ["1f334-fe0f", 383], ["1f331", 384], ["1f331-fe0f", 384], ["1f33f", 385], ["1f33f-fe0f", 385], ["2618-fe0f", 386], ["1f340", 387], ["1f340-fe0f", 387], ["1f38d", 388], ["1f38d-fe0f", 388], ["1f38b", 389], ["1f38b-fe0f", 389], ["1f343", 390], ["1f343-fe0f", 390], ["1f342", 391], ["1f342-fe0f", 391], ["1f341", 392], ["1f341-fe0f", 392], ["1f344", 393], ["1f344-fe0f", 393], ["1f33e", 394], ["1f33e-fe0f", 394], ["1f490", 395], ["1f490-fe0f", 395], ["1f337", 396], ["1f337-fe0f", 396], ["1f339", 397], ["1f339-fe0f", 397], ["1f940", 398], ["1f940-fe0f", 398], ["1f33b", 399], ["1f33b-fe0f", 399], ["1f33c", 400], ["1f33c-fe0f", 400], ["1f338", 401], ["1f338-fe0f", 401], ["1f33a", 402], ["1f33a-fe0f", 402], ["1f30e", 403], ["1f30e-fe0f", 403], ["1f30d", 404], ["1f30d-fe0f", 404], ["1f30f", 405], ["1f30f-fe0f", 405], ["1f315", 406], ["1f315-fe0f", 406], ["1f316", 407], ["1f316-fe0f", 407], ["1f317", 408], ["1f317-fe0f", 408], ["1f318", 409], ["1f318-fe0f", 409], ["1f311", 410], ["1f311-fe0f", 410], ["1f312", 411], ["1f312-fe0f", 411], ["1f313", 412], ["1f313-fe0f", 412], ["1f314", 413], ["1f314-fe0f", 413], ["1f31a", 414], ["1f31a-fe0f", 414], ["1f31d", 415], ["1f31d-fe0f", 415], ["1f31e", 416], ["1f31e-fe0f", 416], ["1f31b", 417], ["1f31b-fe0f", 417], ["1f31c", 418], ["1f31c-fe0f", 418], ["1f319", 419], ["1f319-fe0f", 419], ["1f4ab", 420], ["1f4ab-fe0f", 420], ["2b50-fe0f", 421], ["1f31f", 422], ["1f31f-fe0f", 422], ["2728", 423], ["2728-fe0f", 423], ["26a1-fe0f", 424], ["1f525", 425], ["1f525-fe0f", 425], ["1f4a5", 426], ["1f4a5-fe0f", 426], ["2604-fe0f", 427], ["2600-fe0f", 428], ["1f324", 429], ["1f324-fe0f", 429], ["26c5-fe0f", 430], ["1f325", 431], ["1f325-fe0f", 431], ["1f326", 432], ["1f326-fe0f", 432], ["1f308", 433], ["1f308-fe0f", 433], ["2601-fe0f", 434], ["1f327", 435], ["1f327-fe0f", 435], ["26c8", 436], ["26c8-fe0f", 436], ["1f329", 437], ["1f329-fe0f", 437], ["1f328", 438], ["1f328-fe0f", 438], ["2603-fe0f", 439], ["26c4-fe0f", 440], ["2744-fe0f", 441], ["1f32c", 442], ["1f32c-fe0f", 442], ["1f4a8", 443], ["1f4a8-fe0f", 443], ["1f32a", 444], ["1f32a-fe0f", 444], ["1f32b", 445], ["1f32b-fe0f", 445], ["1f30a", 446], ["1f30a-fe0f", 446], ["1f4a7", 447], ["1f4a7-fe0f", 447], ["1f4a6", 448], ["1f4a6-fe0f", 448], ["2614-fe0f", 449], ["1f34f", 450], ["1f34f-fe0f", 450], ["1f34e", 451], ["1f34e-fe0f", 451], ["1f350", 452], ["1f350-fe0f", 452], ["1f34a", 453], ["1f34a-fe0f", 453], ["1f34b", 454], ["1f34b-fe0f", 454], ["1f34c", 455], ["1f34c-fe0f", 455], ["1f349", 456], ["1f349-fe0f", 456], ["1f347", 457], ["1f347-fe0f", 457], ["1f353", 458], ["1f353-fe0f", 458], ["1f348", 459], ["1f348-fe0f", 459], ["1f352", 460], ["1f352-fe0f", 460], ["1f351", 461], ["1f351-fe0f", 461], ["1f34d", 462], ["1f34d-fe0f", 462], ["1f95d", 463], ["1f95d-fe0f", 463], ["1f951", 464], ["1f951-fe0f", 464], ["1f345", 465], ["1f345-fe0f", 465], ["1f346", 466], ["1f346-fe0f", 466], ["1f952", 467], ["1f952-fe0f", 467], ["1f955", 468], ["1f955-fe0f", 468], ["1f33d", 469], ["1f33d-fe0f", 469], ["1f336", 470], ["1f336-fe0f", 470], ["1f954", 471], ["1f954-fe0f", 471], ["1f360", 472], ["1f360-fe0f", 472], ["1f330", 473], ["1f330-fe0f", 473], ["1f95c", 474], ["1f95c-fe0f", 474], ["1f36f", 475], ["1f36f-fe0f", 475], ["1f950", 476], ["1f950-fe0f", 476], ["1f35e", 477], ["1f35e-fe0f", 477], ["1f956", 478], ["1f956-fe0f", 478], ["1f9c0", 479], ["1f9c0-fe0f", 479], ["1f95a", 480], ["1f95a-fe0f", 480], ["1f373", 481], ["1f373-fe0f", 481], ["1f953", 482], ["1f953-fe0f", 482], ["1f95e", 483], ["1f95e-fe0f", 483], ["1f364", 484], ["1f364-fe0f", 484], ["1f357", 485], ["1f357-fe0f", 485], ["1f356", 486], ["1f356-fe0f", 486], ["1f355", 487], ["1f355-fe0f", 487], ["1f32d", 488], ["1f32d-fe0f", 488], ["1f354", 489], ["1f354-fe0f", 489], ["1f35f", 490], ["1f35f-fe0f", 490], ["1f959", 491], ["1f959-fe0f", 491], ["1f32e", 492], ["1f32e-fe0f", 492], ["1f32f", 493], ["1f32f-fe0f", 493], ["1f957", 494], ["1f957-fe0f", 494], ["1f958", 495], ["1f958-fe0f", 495], ["1f35d", 496], ["1f35d-fe0f", 496], ["1f35c", 497], ["1f35c-fe0f", 497], ["1f372", 498], ["1f372-fe0f", 498], ["1f365", 499], ["1f365-fe0f", 499], ["1f363", 500], ["1f363-fe0f", 500], ["1f371", 501], ["1f371-fe0f", 501], ["1f35b", 502], ["1f35b-fe0f", 502], ["1f35a", 503], ["1f35a-fe0f", 503], ["1f359", 504], ["1f359-fe0f", 504], ["1f358", 505], ["1f358-fe0f", 505], ["1f362", 506], ["1f362-fe0f", 506], ["1f361", 507], ["1f361-fe0f", 507], ["1f367", 508], ["1f367-fe0f", 508], ["1f368", 509], ["1f368-fe0f", 509], ["1f366", 510], ["1f366-fe0f", 510], ["1f370", 511], ["1f370-fe0f", 511], ["1f382", 512], ["1f382-fe0f", 512], ["1f36e", 513], ["1f36e-fe0f", 513], ["1f36d", 514], ["1f36d-fe0f", 514], ["1f36c", 515], ["1f36c-fe0f", 515], ["1f36b", 516], ["1f36b-fe0f", 516], ["1f37f", 517], ["1f37f-fe0f", 517], ["1f369", 518], ["1f369-fe0f", 518], ["1f36a", 519], ["1f36a-fe0f", 519], ["1f95b", 520], ["1f95b-fe0f", 520], ["1f37c", 521], ["1f37c-fe0f", 521], ["2615-fe0f", 522], ["1f375", 523], ["1f375-fe0f", 523], ["1f376", 524], ["1f376-fe0f", 524], ["1f37a", 525], ["1f37a-fe0f", 525], ["1f37b", 526], ["1f37b-fe0f", 526], ["1f942", 527], ["1f942-fe0f", 527], ["1f377", 528], ["1f377-fe0f", 528], ["1f943", 529], ["1f943-fe0f", 529], ["1f378", 530], ["1f378-fe0f", 530], ["1f379", 531], ["1f379-fe0f", 531], ["1f37e", 532], ["1f37e-fe0f", 532], ["1f944", 533], ["1f944-fe0f", 533], ["1f374", 534], ["1f374-fe0f", 534], ["1f37d", 535], ["1f37d-fe0f", 535], ["26bd-fe0f", 536], ["1f3c0", 537], ["1f3c0-fe0f", 537], ["1f3c8", 538], ["1f3c8-fe0f", 538], ["26be-fe0f", 539], ["1f3be", 540], ["1f3be-fe0f", 540], ["1f3d0", 541], ["1f3d0-fe0f", 541], ["1f3c9", 542], ["1f3c9-fe0f", 542], ["1f3b1", 543], ["1f3b1-fe0f", 543], ["1f3d3", 544], ["1f3d3-fe0f", 544], ["1f3f8", 545], ["1f3f8-fe0f", 545], ["1f945", 546], ["1f945-fe0f", 546], ["1f3d2", 547], ["1f3d2-fe0f", 547], ["1f3d1", 548], ["1f3d1-fe0f", 548], ["1f3cf", 549], ["1f3cf-fe0f", 549], ["26f3-fe0f", 550], ["1f3f9", 551], ["1f3f9-fe0f", 551], ["1f3a3", 552], ["1f3a3-fe0f", 552], ["1f94a", 553], ["1f94a-fe0f", 553], ["1f94b", 554], ["1f94b-fe0f", 554], ["26f8", 555], ["26f8-fe0f", 555], ["1f3bf", 556], ["1f3bf-fe0f", 556], ["26f7", 557], ["26f7-fe0f", 557], ["1f3c2", 558], ["1f3c2-fe0f", 558], ["1f3cb-fe0f-200d-2640-fe0f", 559], ["1f3cb-200d-2640-fe0f-fe0f", 559], ["1f3cb-fe0f", 560], ["1f3cb-fe0f-200d-2642-fe0f", 560], ["1f93a", 561], ["1f93a-fe0f", 561], ["1f93c-200d-2640-fe0f", 562], ["1f93c-200d-2642-fe0f", 563], ["1f938-200d-2640-fe0f", 564], ["1f938-200d-2642-fe0f", 565], ["26f9-fe0f-200d-2640-fe0f", 566], ["26f9-200d-2640-fe0f-fe0f", 566], ["26f9-fe0f", 567], ["26f9-fe0f-200d-2642-fe0f", 567], ["1f93e-200d-2640-fe0f", 568], ["1f93e-200d-2642-fe0f", 569], ["1f3cc-fe0f-200d-2640-fe0f", 570], ["1f3cc-200d-2640-fe0f-fe0f", 570], ["1f3cc-fe0f", 571], ["1f3cc-fe0f-200d-2642-fe0f", 571], ["1f3c4-200d-2640-fe0f", 572], ["1f3c4", 573], ["1f3c4-fe0f", 573], ["1f3c4-200d-2642-fe0f", 573], ["1f3ca-200d-2640-fe0f", 574], ["1f3ca", 575], ["1f3ca-fe0f", 575], ["1f3ca-200d-2642-fe0f", 575], ["1f93d-200d-2640-fe0f", 576], ["1f93d-200d-2642-fe0f", 577], ["1f6a3-200d-2640-fe0f", 578], ["1f6a3", 579], ["1f6a3-fe0f", 579], ["1f6a3-200d-2642-fe0f", 579], ["1f3c7", 580], ["1f3c7-fe0f", 580], ["1f6b4-200d-2640-fe0f", 581], ["1f6b4", 582], ["1f6b4-fe0f", 582], ["1f6b4-200d-2642-fe0f", 582], ["1f6b5-200d-2640-fe0f", 583], ["1f6b5", 584], ["1f6b5-fe0f", 584], ["1f6b5-200d-2642-fe0f", 584], ["1f3bd", 585], ["1f3bd-fe0f", 585], ["1f3c5", 586], ["1f3c5-fe0f", 586], ["1f396", 587], ["1f396-fe0f", 587], ["1f947", 588], ["1f947-fe0f", 588], ["1f948", 589], ["1f948-fe0f", 589], ["1f949", 590], ["1f949-fe0f", 590], ["1f3c6", 591], ["1f3c6-fe0f", 591], ["1f3f5", 592], ["1f3f5-fe0f", 592], ["1f397", 593], ["1f397-fe0f", 593], ["1f3ab", 594], ["1f3ab-fe0f", 594], ["1f39f", 595], ["1f39f-fe0f", 595], ["1f3aa", 596], ["1f3aa-fe0f", 596], ["1f939-200d-2640-fe0f", 597], ["1f939-200d-2642-fe0f", 598], ["1f3ad", 599], ["1f3ad-fe0f", 599], ["1f3a8", 600], ["1f3a8-fe0f", 600], ["1f3ac", 601], ["1f3ac-fe0f", 601], ["1f3a4", 602], ["1f3a4-fe0f", 602], ["1f3a7", 603], ["1f3a7-fe0f", 603], ["1f3bc", 604], ["1f3bc-fe0f", 604], ["1f3b9", 605], ["1f3b9-fe0f", 605], ["1f941", 606], ["1f941-fe0f", 606], ["1f3b7", 607], ["1f3b7-fe0f", 607], ["1f3ba", 608], ["1f3ba-fe0f", 608], ["1f3b8", 609], ["1f3b8-fe0f", 609], ["1f3bb", 610], ["1f3bb-fe0f", 610], ["1f3b2", 611], ["1f3b2-fe0f", 611], ["1f3af", 612], ["1f3af-fe0f", 612], ["1f3b3", 613], ["1f3b3-fe0f", 613], ["1f3ae", 614], ["1f3ae-fe0f", 614], ["1f3b0", 615], ["1f3b0-fe0f", 615], ["1f697", 616], ["1f697-fe0f", 616], ["1f695", 617], ["1f695-fe0f", 617], ["1f699", 618], ["1f699-fe0f", 618], ["1f68c", 619], ["1f68c-fe0f", 619], ["1f68e", 620], ["1f68e-fe0f", 620], ["1f3ce", 621], ["1f3ce-fe0f", 621], ["1f693", 622], ["1f693-fe0f", 622], ["1f691", 623], ["1f691-fe0f", 623], ["1f692", 624], ["1f692-fe0f", 624], ["1f690", 625], ["1f690-fe0f", 625], ["1f69a", 626], ["1f69a-fe0f", 626], ["1f69b", 627], ["1f69b-fe0f", 627], ["1f69c", 628], ["1f69c-fe0f", 628], ["1f6f4", 629], ["1f6f4-fe0f", 629], ["1f6b2", 630], ["1f6b2-fe0f", 630], ["1f6f5", 631], ["1f6f5-fe0f", 631], ["1f3cd", 632], ["1f3cd-fe0f", 632], ["1f6a8", 633], ["1f6a8-fe0f", 633], ["1f694", 634], ["1f694-fe0f", 634], ["1f68d", 635], ["1f68d-fe0f", 635], ["1f698", 636], ["1f698-fe0f", 636], ["1f696", 637], ["1f696-fe0f", 637], ["1f6a1", 638], ["1f6a1-fe0f", 638], ["1f6a0", 639], ["1f6a0-fe0f", 639], ["1f69f", 640], ["1f69f-fe0f", 640], ["1f683", 641], ["1f683-fe0f", 641], ["1f68b", 642], ["1f68b-fe0f", 642], ["1f69e", 643], ["1f69e-fe0f", 643], ["1f69d", 644], ["1f69d-fe0f", 644], ["1f684", 645], ["1f684-fe0f", 645], ["1f685", 646], ["1f685-fe0f", 646], ["1f688", 647], ["1f688-fe0f", 647], ["1f682", 648], ["1f682-fe0f", 648], ["1f686", 649], ["1f686-fe0f", 649], ["1f687", 650], ["1f687-fe0f", 650], ["1f68a", 651], ["1f68a-fe0f", 651], ["1f689", 652], ["1f689-fe0f", 652], ["1f681", 653], ["1f681-fe0f", 653], ["1f6e9", 654], ["1f6e9-fe0f", 654], ["2708-fe0f", 655], ["1f6eb", 656], ["1f6eb-fe0f", 656], ["1f6ec", 657], ["1f6ec-fe0f", 657], ["1f680", 658], ["1f680-fe0f", 658], ["1f6f0", 659], ["1f6f0-fe0f", 659], ["1f4ba", 660], ["1f4ba-fe0f", 660], ["1f6f6", 661], ["1f6f6-fe0f", 661], ["26f5-fe0f", 662], ["1f6e5", 663], ["1f6e5-fe0f", 663], ["1f6a4", 664], ["1f6a4-fe0f", 664], ["1f6f3", 665], ["1f6f3-fe0f", 665], ["26f4", 666], ["26f4-fe0f", 666], ["1f6a2", 667], ["1f6a2-fe0f", 667], ["2693-fe0f", 668], ["1f6a7", 669], ["1f6a7-fe0f", 669], ["26fd-fe0f", 670], ["1f68f", 671], ["1f68f-fe0f", 671], ["1f6a6", 672], ["1f6a6-fe0f", 672], ["1f6a5", 673], ["1f6a5-fe0f", 673], ["1f5fa", 674], ["1f5fa-fe0f", 674], ["1f5ff", 675], ["1f5ff-fe0f", 675], ["1f5fd", 676], ["1f5fd-fe0f", 676], ["26f2-fe0f", 677], ["1f5fc", 678], ["1f5fc-fe0f", 678], ["1f3f0", 679], ["1f3f0-fe0f", 679], ["1f3ef", 680], ["1f3ef-fe0f", 680], ["1f3df", 681], ["1f3df-fe0f", 681], ["1f3a1", 682], ["1f3a1-fe0f", 682], ["1f3a2", 683], ["1f3a2-fe0f", 683], ["1f3a0", 684], ["1f3a0-fe0f", 684], ["26f1", 685], ["26f1-fe0f", 685], ["1f3d6", 686], ["1f3d6-fe0f", 686], ["1f3dd", 687], ["1f3dd-fe0f", 687], ["26f0", 688], ["26f0-fe0f", 688], ["1f3d4", 689], ["1f3d4-fe0f", 689], ["1f5fb", 690], ["1f5fb-fe0f", 690], ["1f30b", 691], ["1f30b-fe0f", 691], ["1f3dc", 692], ["1f3dc-fe0f", 692], ["1f3d5", 693], ["1f3d5-fe0f", 693], ["26fa-fe0f", 694], ["1f6e4", 695], ["1f6e4-fe0f", 695], ["1f6e3", 696], ["1f6e3-fe0f", 696], ["1f3d7", 697], ["1f3d7-fe0f", 697], ["1f3ed", 698], ["1f3ed-fe0f", 698], ["1f3e0", 699], ["1f3e0-fe0f", 699], ["1f3e1", 700], ["1f3e1-fe0f", 700], ["1f3d8", 701], ["1f3d8-fe0f", 701], ["1f3da", 702], ["1f3da-fe0f", 702], ["1f3e2", 703], ["1f3e2-fe0f", 703], ["1f3ec", 704], ["1f3ec-fe0f", 704], ["1f3e3", 705], ["1f3e3-fe0f", 705], ["1f3e4", 706], ["1f3e4-fe0f", 706], ["1f3e5", 707], ["1f3e5-fe0f", 707], ["1f3e6", 708], ["1f3e6-fe0f", 708], ["1f3e8", 709], ["1f3e8-fe0f", 709], ["1f3ea", 710], ["1f3ea-fe0f", 710], ["1f3eb", 711], ["1f3eb-fe0f", 711], ["1f3e9", 712], ["1f3e9-fe0f", 712], ["1f492", 713], ["1f492-fe0f", 713], ["1f3db", 714], ["1f3db-fe0f", 714], ["26ea-fe0f", 715], ["1f54c", 716], ["1f54c-fe0f", 716], ["1f54d", 717], ["1f54d-fe0f", 717], ["1f54b", 718], ["1f54b-fe0f", 718], ["26e9", 719], ["26e9-fe0f", 719], ["1f5fe", 720], ["1f5fe-fe0f", 720], ["1f391", 721], ["1f391-fe0f", 721], ["1f3de", 722], ["1f3de-fe0f", 722], ["1f305", 723], ["1f305-fe0f", 723], ["1f304", 724], ["1f304-fe0f", 724], ["1f320", 725], ["1f320-fe0f", 725], ["1f387", 726], ["1f387-fe0f", 726], ["1f386", 727], ["1f386-fe0f", 727], ["1f307", 728], ["1f307-fe0f", 728], ["1f306", 729], ["1f306-fe0f", 729], ["1f3d9", 730], ["1f3d9-fe0f", 730], ["1f303", 731], ["1f303-fe0f", 731], ["1f30c", 732], ["1f30c-fe0f", 732], ["1f309", 733], ["1f309-fe0f", 733], ["1f301", 734], ["1f301-fe0f", 734], ["231a-fe0f", 735], ["1f4f1", 736], ["1f4f1-fe0f", 736], ["1f4f2", 737], ["1f4f2-fe0f", 737], ["1f4bb", 738], ["1f4bb-fe0f", 738], ["2328-fe0f", 739], ["1f5a5", 740], ["1f5a5-fe0f", 740], ["1f5a8", 741], ["1f5a8-fe0f", 741], ["1f5b1", 742], ["1f5b1-fe0f", 742], ["1f5b2", 743], ["1f5b2-fe0f", 743], ["1f579", 744], ["1f579-fe0f", 744], ["1f5dc", 745], ["1f5dc-fe0f", 745], ["1f4bd", 746], ["1f4bd-fe0f", 746], ["1f4be", 747], ["1f4be-fe0f", 747], ["1f4bf", 748], ["1f4bf-fe0f", 748], ["1f4c0", 749], ["1f4c0-fe0f", 749], ["1f4fc", 750], ["1f4fc-fe0f", 750], ["1f4f7", 751], ["1f4f7-fe0f", 751], ["1f4f8", 752], ["1f4f8-fe0f", 752], ["1f4f9", 753], ["1f4f9-fe0f", 753], ["1f3a5", 754], ["1f3a5-fe0f", 754], ["1f4fd", 755], ["1f4fd-fe0f", 755], ["1f39e", 756], ["1f39e-fe0f", 756], ["1f4de", 757], ["1f4de-fe0f", 757], ["260e-fe0f", 758], ["1f4df", 759], ["1f4df-fe0f", 759], ["1f4e0", 760], ["1f4e0-fe0f", 760], ["1f4fa", 761], ["1f4fa-fe0f", 761], ["1f4fb", 762], ["1f4fb-fe0f", 762], ["1f399", 763], ["1f399-fe0f", 763], ["1f39a", 764], ["1f39a-fe0f", 764], ["1f39b", 765], ["1f39b-fe0f", 765], ["23f1", 766], ["23f1-fe0f", 766], ["23f2", 767], ["23f2-fe0f", 767], ["23f0", 768], ["23f0-fe0f", 768], ["1f570", 769], ["1f570-fe0f", 769], ["231b-fe0f", 770], ["23f3", 771], ["23f3-fe0f", 771], ["1f4e1", 772], ["1f4e1-fe0f", 772], ["1f50b", 773], ["1f50b-fe0f", 773], ["1f50c", 774], ["1f50c-fe0f", 774], ["1f4a1", 775], ["1f4a1-fe0f", 775], ["1f526", 776], ["1f526-fe0f", 776], ["1f56f", 777], ["1f56f-fe0f", 777], ["1f5d1", 778], ["1f5d1-fe0f", 778], ["1f6e2", 779], ["1f6e2-fe0f", 779], ["1f4b8", 780], ["1f4b8-fe0f", 780], ["1f4b5", 781], ["1f4b5-fe0f", 781], ["1f4b4", 782], ["1f4b4-fe0f", 782], ["1f4b6", 783], ["1f4b6-fe0f", 783], ["1f4b7", 784], ["1f4b7-fe0f", 784], ["1f4b0", 785], ["1f4b0-fe0f", 785], ["1f4b3", 786], ["1f4b3-fe0f", 786], ["1f48e", 787], ["1f48e-fe0f", 787], ["2696-fe0f", 788], ["1f527", 789], ["1f527-fe0f", 789], ["1f528", 790], ["1f528-fe0f", 790], ["2692", 791], ["2692-fe0f", 791], ["1f6e0", 792], ["1f6e0-fe0f", 792], ["26cf", 793], ["26cf-fe0f", 793], ["1f529", 794], ["1f529-fe0f", 794], ["2699-fe0f", 795], ["26d3", 796], ["26d3-fe0f", 796], ["1f52b", 797], ["1f52b-fe0f", 797], ["1f4a3", 798], ["1f4a3-fe0f", 798], ["1f52a", 799], ["1f52a-fe0f", 799], ["1f5e1", 800], ["1f5e1-fe0f", 800], ["2694-fe0f", 801], ["1f6e1", 802], ["1f6e1-fe0f", 802], ["1f6ac", 803], ["1f6ac-fe0f", 803], ["26b0-fe0f", 804], ["26b1-fe0f", 805], ["1f3fa", 806], ["1f3fa-fe0f", 806], ["1f52e", 807], ["1f52e-fe0f", 807], ["1f4ff", 808], ["1f4ff-fe0f", 808], ["1f488", 809], ["1f488-fe0f", 809], ["2697-fe0f", 810], ["1f52d", 811], ["1f52d-fe0f", 811], ["1f52c", 812], ["1f52c-fe0f", 812], ["1f573", 813], ["1f573-fe0f", 813], ["1f48a", 814], ["1f48a-fe0f", 814], ["1f489", 815], ["1f489-fe0f", 815], ["1f321", 816], ["1f321-fe0f", 816], ["1f6bd", 817], ["1f6bd-fe0f", 817], ["1f6b0", 818], ["1f6b0-fe0f", 818], ["1f6bf", 819], ["1f6bf-fe0f", 819], ["1f6c1", 820], ["1f6c1-fe0f", 820], ["1f6c0", 821], ["1f6c0-fe0f", 821], ["1f6ce", 822], ["1f6ce-fe0f", 822], ["1f511", 823], ["1f511-fe0f", 823], ["1f5dd", 824], ["1f5dd-fe0f", 824], ["1f6aa", 825], ["1f6aa-fe0f", 825], ["1f6cb", 826], ["1f6cb-fe0f", 826], ["1f6cf", 827], ["1f6cf-fe0f", 827], ["1f6cc", 828], ["1f6cc-fe0f", 828], ["1f5bc", 829], ["1f5bc-fe0f", 829], ["1f6cd", 830], ["1f6cd-fe0f", 830], ["1f6d2", 831], ["1f6d2-fe0f", 831], ["1f381", 832], ["1f381-fe0f", 832], ["1f388", 833], ["1f388-fe0f", 833], ["1f38f", 834], ["1f38f-fe0f", 834], ["1f380", 835], ["1f380-fe0f", 835], ["1f38a", 836], ["1f38a-fe0f", 836], ["1f389", 837], ["1f389-fe0f", 837], ["1f38e", 838], ["1f38e-fe0f", 838], ["1f3ee", 839], ["1f3ee-fe0f", 839], ["1f390", 840], ["1f390-fe0f", 840], ["2709-fe0f", 841], ["1f4e9", 842], ["1f4e9-fe0f", 842], ["1f4e8", 843], ["1f4e8-fe0f", 843], ["1f4e7", 844], ["1f4e7-fe0f", 844], ["1f48c", 845], ["1f48c-fe0f", 845], ["1f4e5", 846], ["1f4e5-fe0f", 846], ["1f4e4", 847], ["1f4e4-fe0f", 847], ["1f4e6", 848], ["1f4e6-fe0f", 848], ["1f3f7", 849], ["1f3f7-fe0f", 849], ["1f4ea", 850], ["1f4ea-fe0f", 850], ["1f4eb", 851], ["1f4eb-fe0f", 851], ["1f4ec", 852], ["1f4ec-fe0f", 852], ["1f4ed", 853], ["1f4ed-fe0f", 853], ["1f4ee", 854], ["1f4ee-fe0f", 854], ["1f4ef", 855], ["1f4ef-fe0f", 855], ["1f4dc", 856], ["1f4dc-fe0f", 856], ["1f4c3", 857], ["1f4c3-fe0f", 857], ["1f4c4", 858], ["1f4c4-fe0f", 858], ["1f4d1", 859], ["1f4d1-fe0f", 859], ["1f4ca", 860], ["1f4ca-fe0f", 860], ["1f4c8", 861], ["1f4c8-fe0f", 861], ["1f4c9", 862], ["1f4c9-fe0f", 862], ["1f5d2", 863], ["1f5d2-fe0f", 863], ["1f5d3", 864], ["1f5d3-fe0f", 864], ["1f4c6", 865], ["1f4c6-fe0f", 865], ["1f4c5", 866], ["1f4c5-fe0f", 866], ["1f4c7", 867], ["1f4c7-fe0f", 867], ["1f5c3", 868], ["1f5c3-fe0f", 868], ["1f5f3", 869], ["1f5f3-fe0f", 869], ["1f5c4", 870], ["1f5c4-fe0f", 870], ["1f4cb", 871], ["1f4cb-fe0f", 871], ["1f4c1", 872], ["1f4c1-fe0f", 872], ["1f4c2", 873], ["1f4c2-fe0f", 873], ["1f5c2", 874], ["1f5c2-fe0f", 874], ["1f5de", 875], ["1f5de-fe0f", 875], ["1f4f0", 876], ["1f4f0-fe0f", 876], ["1f4d3", 877], ["1f4d3-fe0f", 877], ["1f4d4", 878], ["1f4d4-fe0f", 878], ["1f4d2", 879], ["1f4d2-fe0f", 879], ["1f4d5", 880], ["1f4d5-fe0f", 880], ["1f4d7", 881], ["1f4d7-fe0f", 881], ["1f4d8", 882], ["1f4d8-fe0f", 882], ["1f4d9", 883], ["1f4d9-fe0f", 883], ["1f4da", 884], ["1f4da-fe0f", 884], ["1f4d6", 885], ["1f4d6-fe0f", 885], ["1f516", 886], ["1f516-fe0f", 886], ["1f517", 887], ["1f517-fe0f", 887], ["1f4ce", 888], ["1f4ce-fe0f", 888], ["1f587", 889], ["1f587-fe0f", 889], ["1f4d0", 890], ["1f4d0-fe0f", 890], ["1f4cf", 891], ["1f4cf-fe0f", 891], ["1f4cc", 892], ["1f4cc-fe0f", 892], ["1f4cd", 893], ["1f4cd-fe0f", 893], ["2702-fe0f", 894], ["1f58a", 895], ["1f58a-fe0f", 895], ["1f58b", 896], ["1f58b-fe0f", 896], ["2712-fe0f", 897], ["1f58c", 898], ["1f58c-fe0f", 898], ["1f58d", 899], ["1f58d-fe0f", 899], ["1f4dd", 900], ["1f4dd-fe0f", 900], ["270f-fe0f", 901], ["1f50d", 902], ["1f50d-fe0f", 902], ["1f50e", 903], ["1f50e-fe0f", 903], ["1f50f", 904], ["1f50f-fe0f", 904], ["1f510", 905], ["1f510-fe0f", 905], ["1f512", 906], ["1f512-fe0f", 906], ["1f513", 907], ["1f513-fe0f", 907], ["2764-fe0f", 908], ["1f49b", 909], ["1f49b-fe0f", 909], ["1f49a", 910], ["1f49a-fe0f", 910], ["1f499", 911], ["1f499-fe0f", 911], ["1f49c", 912], ["1f49c-fe0f", 912], ["1f5a4", 913], ["1f5a4-fe0f", 913], ["1f494", 914], ["1f494-fe0f", 914], ["2763-fe0f", 915], ["1f495", 916], ["1f495-fe0f", 916], ["1f49e", 917], ["1f49e-fe0f", 917], ["1f493", 918], ["1f493-fe0f", 918], ["1f497", 919], ["1f497-fe0f", 919], ["1f496", 920], ["1f496-fe0f", 920], ["1f498", 921], ["1f498-fe0f", 921], ["1f49d", 922], ["1f49d-fe0f", 922], ["1f49f", 923], ["1f49f-fe0f", 923], ["262e-fe0f", 924], ["271d-fe0f", 925], ["262a-fe0f", 926], ["1f549", 927], ["1f549-fe0f", 927], ["2638-fe0f", 928], ["2721-fe0f", 929], ["1f52f", 930], ["1f52f-fe0f", 930], ["1f54e", 931], ["1f54e-fe0f", 931], ["262f-fe0f", 932], ["2626-fe0f", 933], ["1f6d0", 934], ["1f6d0-fe0f", 934], ["26ce", 935], ["26ce-fe0f", 935], ["2648-fe0f", 936], ["2649-fe0f", 937], ["264a-fe0f", 938], ["264b-fe0f", 939], ["264c-fe0f", 940], ["264d-fe0f", 941], ["264e-fe0f", 942], ["264f-fe0f", 943], ["2650-fe0f", 944], ["2651-fe0f", 945], ["2652-fe0f", 946], ["2653-fe0f", 947], ["1f194", 948], ["1f194-fe0f", 948], ["269b-fe0f", 949], ["1f251", 950], ["1f251-fe0f", 950], ["2622-fe0f", 951], ["2623-fe0f", 952], ["1f4f4", 953], ["1f4f4-fe0f", 953], ["1f4f3", 954], ["1f4f3-fe0f", 954], ["1f236", 955], ["1f236-fe0f", 955], ["1f21a-fe0f", 956], ["1f238", 957], ["1f238-fe0f", 957], ["1f23a", 958], ["1f23a-fe0f", 958], ["1f237-fe0f", 959], ["2734-fe0f", 960], ["1f19a", 961], ["1f19a-fe0f", 961], ["1f4ae", 962], ["1f4ae-fe0f", 962], ["1f250", 963], ["1f250-fe0f", 963], ["3299-fe0f", 964], ["3297-fe0f", 965], ["1f234", 966], ["1f234-fe0f", 966], ["1f235", 967], ["1f235-fe0f", 967], ["1f239", 968], ["1f239-fe0f", 968], ["1f232", 969], ["1f232-fe0f", 969], ["1f170-fe0f", 970], ["1f171-fe0f", 971], ["1f18e", 972], ["1f18e-fe0f", 972], ["1f191", 973], ["1f191-fe0f", 973], ["1f17e-fe0f", 974], ["1f198", 975], ["1f198-fe0f", 975], ["274c", 976], ["274c-fe0f", 976], ["2b55-fe0f", 977], ["1f6d1", 978], ["1f6d1-fe0f", 978], ["26d4-fe0f", 979], ["1f4db", 980], ["1f4db-fe0f", 980], ["1f6ab", 981], ["1f6ab-fe0f", 981], ["1f4af", 982], ["1f4af-fe0f", 982], ["1f4a2", 983], ["1f4a2-fe0f", 983], ["2668-fe0f", 984], ["1f6b7", 985], ["1f6b7-fe0f", 985], ["1f6af", 986], ["1f6af-fe0f", 986], ["1f6b3", 987], ["1f6b3-fe0f", 987], ["1f6b1", 988], ["1f6b1-fe0f", 988], ["1f51e", 989], ["1f51e-fe0f", 989], ["1f4f5", 990], ["1f4f5-fe0f", 990], ["1f6ad", 991], ["1f6ad-fe0f", 991], ["2757-fe0f", 992], ["2755", 993], ["2755-fe0f", 993], ["2753", 994], ["2753-fe0f", 994], ["2754", 995], ["2754-fe0f", 995], ["203c-fe0f", 996], ["2049-fe0f", 997], ["1f505", 998], ["1f505-fe0f", 998], ["1f506", 999], ["1f506-fe0f", 999], ["303d-fe0f", 1000], ["26a0-fe0f", 1001], ["1f6b8", 1002], ["1f6b8-fe0f", 1002], ["1f531", 1003], ["1f531-fe0f", 1003], ["269c-fe0f", 1004], ["1f530", 1005], ["1f530-fe0f", 1005], ["267b-fe0f", 1006], ["2705", 1007], ["2705-fe0f", 1007], ["1f22f-fe0f", 1008], ["1f4b9", 1009], ["1f4b9-fe0f", 1009], ["2747-fe0f", 1010], ["2733-fe0f", 1011], ["274e", 1012], ["274e-fe0f", 1012], ["1f310", 1013], ["1f310-fe0f", 1013], ["1f4a0", 1014], ["1f4a0-fe0f", 1014], ["24c2-fe0f", 1015], ["1f300", 1016], ["1f300-fe0f", 1016], ["1f4a4", 1017], ["1f4a4-fe0f", 1017], ["1f3e7", 1018], ["1f3e7-fe0f", 1018], ["1f6be", 1019], ["1f6be-fe0f", 1019], ["267f-fe0f", 1020], ["1f17f-fe0f", 1021], ["1f233", 1022], ["1f233-fe0f", 1022], ["1f202-fe0f", 1023], ["1f6c2", 1024], ["1f6c2-fe0f", 1024], ["1f6c3", 1025], ["1f6c3-fe0f", 1025], ["1f6c4", 1026], ["1f6c4-fe0f", 1026], ["1f6c5", 1027], ["1f6c5-fe0f", 1027], ["1f6b9", 1028], ["1f6b9-fe0f", 1028], ["1f6ba", 1029], ["1f6ba-fe0f", 1029], ["1f6bc", 1030], ["1f6bc-fe0f", 1030], ["1f6bb", 1031], ["1f6bb-fe0f", 1031], ["1f6ae", 1032], ["1f6ae-fe0f", 1032], ["1f3a6", 1033], ["1f3a6-fe0f", 1033], ["1f4f6", 1034], ["1f4f6-fe0f", 1034], ["1f201", 1035], ["1f201-fe0f", 1035], ["1f523", 1036], ["1f523-fe0f", 1036], ["2139-fe0f", 1037], ["1f524", 1038], ["1f524-fe0f", 1038], ["1f521", 1039], ["1f521-fe0f", 1039], ["1f520", 1040], ["1f520-fe0f", 1040], ["1f196", 1041], ["1f196-fe0f", 1041], ["1f197", 1042], ["1f197-fe0f", 1042], ["1f199", 1043], ["1f199-fe0f", 1043], ["1f192", 1044], ["1f192-fe0f", 1044], ["1f195", 1045], ["1f195-fe0f", 1045], ["1f193", 1046], ["1f193-fe0f", 1046], ["0030-fe0f-20e3", 1047], ["0030-20e3-fe0f", 1047], ["0031-fe0f-20e3", 1048], ["0031-20e3-fe0f", 1048], ["0032-fe0f-20e3", 1049], ["0032-20e3-fe0f", 1049], ["0033-fe0f-20e3", 1050], ["0033-20e3-fe0f", 1050], ["0034-fe0f-20e3", 1051], ["0034-20e3-fe0f", 1051], ["0035-fe0f-20e3", 1052], ["0035-20e3-fe0f", 1052], ["0036-fe0f-20e3", 1053], ["0036-20e3-fe0f", 1053], ["0037-fe0f-20e3", 1054], ["0037-20e3-fe0f", 1054], ["0038-fe0f-20e3", 1055], ["0038-20e3-fe0f", 1055], ["0039-fe0f-20e3", 1056], ["0039-20e3-fe0f", 1056], ["1f51f", 1057], ["1f51f-fe0f", 1057], ["1f522", 1058], ["1f522-fe0f", 1058], ["0023-fe0f-20e3", 1059], ["0023-20e3-fe0f", 1059], ["002a-fe0f-20e3", 1060], ["002a-20e3-fe0f", 1060], ["25b6-fe0f", 1061], ["23f8", 1062], ["23f8-fe0f", 1062], ["23ef", 1063], ["23ef-fe0f", 1063], ["23f9", 1064], ["23f9-fe0f", 1064], ["23fa", 1065], ["23fa-fe0f", 1065], ["23ed", 1066], ["23ed-fe0f", 1066], ["23ee", 1067], ["23ee-fe0f", 1067], ["23e9", 1068], ["23e9-fe0f", 1068], ["23ea", 1069], ["23ea-fe0f", 1069], ["23eb", 1070], ["23eb-fe0f", 1070], ["23ec", 1071], ["23ec-fe0f", 1071], ["25c0-fe0f", 1072], ["1f53c", 1073], ["1f53c-fe0f", 1073], ["1f53d", 1074], ["1f53d-fe0f", 1074], ["27a1-fe0f", 1075], ["2b05-fe0f", 1076], ["2b06-fe0f", 1077], ["2b07-fe0f", 1078], ["2197-fe0f", 1079], ["2198-fe0f", 1080], ["2199-fe0f", 1081], ["2196-fe0f", 1082], ["2195-fe0f", 1083], ["2194-fe0f", 1084], ["21aa-fe0f", 1085], ["21a9-fe0f", 1086], ["2934-fe0f", 1087], ["2935-fe0f", 1088], ["1f500", 1089], ["1f500-fe0f", 1089], ["1f501", 1090], ["1f501-fe0f", 1090], ["1f502", 1091], ["1f502-fe0f", 1091], ["1f504", 1092], ["1f504-fe0f", 1092], ["1f503", 1093], ["1f503-fe0f", 1093], ["1f3b5", 1094], ["1f3b5-fe0f", 1094], ["1f3b6", 1095], ["1f3b6-fe0f", 1095], ["2795", 1096], ["2795-fe0f", 1096], ["2796", 1097], ["2796-fe0f", 1097], ["2797", 1098], ["2797-fe0f", 1098], ["2716-fe0f", 1099], ["1f4b2", 1100], ["1f4b2-fe0f", 1100], ["1f4b1", 1101], ["1f4b1-fe0f", 1101], ["2122-fe0f", 1102], ["00a9-fe0f", 1103], ["00ae-fe0f", 1104], ["3030-fe0f", 1105], ["27b0", 1106], ["27b0-fe0f", 1106], ["27bf", 1107], ["27bf-fe0f", 1107], ["1f51a", 1108], ["1f51a-fe0f", 1108], ["1f519", 1109], ["1f519-fe0f", 1109], ["1f51b", 1110], ["1f51b-fe0f", 1110], ["1f51d", 1111], ["1f51d-fe0f", 1111], ["1f51c", 1112], ["1f51c-fe0f", 1112], ["2714-fe0f", 1113], ["2611-fe0f", 1114], ["1f518", 1115], ["1f518-fe0f", 1115], ["26aa-fe0f", 1116], ["26ab-fe0f", 1117], ["1f534", 1118], ["1f534-fe0f", 1118], ["1f535", 1119], ["1f535-fe0f", 1119], ["1f53a", 1120], ["1f53a-fe0f", 1120], ["1f53b", 1121], ["1f53b-fe0f", 1121], ["1f538", 1122], ["1f538-fe0f", 1122], ["1f539", 1123], ["1f539-fe0f", 1123], ["1f536", 1124], ["1f536-fe0f", 1124], ["1f537", 1125], ["1f537-fe0f", 1125], ["1f533", 1126], ["1f533-fe0f", 1126], ["1f532", 1127], ["1f532-fe0f", 1127], ["25aa-fe0f", 1128], ["25ab-fe0f", 1129], ["25fe-fe0f", 1130], ["25fd-fe0f", 1131], ["25fc-fe0f", 1132], ["25fb-fe0f", 1133], ["2b1b-fe0f", 1134], ["2b1c-fe0f", 1135], ["1f508", 1136], ["1f508-fe0f", 1136], ["1f507", 1137], ["1f507-fe0f", 1137], ["1f509", 1138], ["1f509-fe0f", 1138], ["1f50a", 1139], ["1f50a-fe0f", 1139], ["1f514", 1140], ["1f514-fe0f", 1140], ["1f515", 1141], ["1f515-fe0f", 1141], ["1f4e3", 1142], ["1f4e3-fe0f", 1142], ["1f4e2", 1143], ["1f4e2-fe0f", 1143], ["1f441-200d-1f5e8", 1144], ["1f441-200d-1f5e8-fe0f", 1144], ["1f4ac", 1145], ["1f4ac-fe0f", 1145], ["1f4ad", 1146], ["1f4ad-fe0f", 1146], ["1f5ef", 1147], ["1f5ef-fe0f", 1147], ["2660-fe0f", 1148], ["2663-fe0f", 1149], ["2665-fe0f", 1150], ["2666-fe0f", 1151], ["1f0cf", 1152], ["1f0cf-fe0f", 1152], ["1f3b4", 1153], ["1f3b4-fe0f", 1153], ["1f004-fe0f", 1154], ["1f550", 1155], ["1f550-fe0f", 1155], ["1f551", 1156], ["1f551-fe0f", 1156], ["1f552", 1157], ["1f552-fe0f", 1157], ["1f553", 1158], ["1f553-fe0f", 1158], ["1f554", 1159], ["1f554-fe0f", 1159], ["1f555", 1160], ["1f555-fe0f", 1160], ["1f556", 1161], ["1f556-fe0f", 1161], ["1f557", 1162], ["1f557-fe0f", 1162], ["1f558", 1163], ["1f558-fe0f", 1163], ["1f559", 1164], ["1f559-fe0f", 1164], ["1f55a", 1165], ["1f55a-fe0f", 1165], ["1f55b", 1166], ["1f55b-fe0f", 1166], ["1f55c", 1167], ["1f55c-fe0f", 1167], ["1f55d", 1168], ["1f55d-fe0f", 1168], ["1f55e", 1169], ["1f55e-fe0f", 1169], ["1f55f", 1170], ["1f55f-fe0f", 1170], ["1f560", 1171], ["1f560-fe0f", 1171], ["1f561", 1172], ["1f561-fe0f", 1172], ["1f562", 1173], ["1f562-fe0f", 1173], ["1f563", 1174], ["1f563-fe0f", 1174], ["1f564", 1175], ["1f564-fe0f", 1175], ["1f565", 1176], ["1f565-fe0f", 1176], ["1f566", 1177], ["1f566-fe0f", 1177], ["1f567", 1178], ["1f567-fe0f", 1178], ["1f3f3-fe0f", 1179], ["1f3f4", 1180], ["1f3f4-fe0f", 1180], ["1f3c1", 1181], ["1f3c1-fe0f", 1181], ["1f6a9", 1182], ["1f6a9-fe0f", 1182], ["1f3f3-fe0f-200d-1f308", 1183], ["1f3f3-200d-1f308-fe0f", 1183], ["1f1e6-1f1eb", 1184], ["1f1e6-1f1eb-fe0f", 1184], ["1f1e6-1f1fd", 1185], ["1f1e6-1f1fd-fe0f", 1185], ["1f1e6-1f1f1", 1186], ["1f1e6-1f1f1-fe0f", 1186], ["1f1e9-1f1ff", 1187], ["1f1e9-1f1ff-fe0f", 1187], ["1f1e6-1f1f8", 1188], ["1f1e6-1f1f8-fe0f", 1188], ["1f1e6-1f1e9", 1189], ["1f1e6-1f1e9-fe0f", 1189], ["1f1e6-1f1f4", 1190], ["1f1e6-1f1f4-fe0f", 1190], ["1f1e6-1f1ee", 1191], ["1f1e6-1f1ee-fe0f", 1191], ["1f1e6-1f1f6", 1192], ["1f1e6-1f1f6-fe0f", 1192], ["1f1e6-1f1ec", 1193], ["1f1e6-1f1ec-fe0f", 1193], ["1f1e6-1f1f7", 1194], ["1f1e6-1f1f7-fe0f", 1194], ["1f1e6-1f1f2", 1195], ["1f1e6-1f1f2-fe0f", 1195], ["1f1e6-1f1fc", 1196], ["1f1e6-1f1fc-fe0f", 1196], ["1f1e6-1f1fa", 1197], ["1f1e6-1f1fa-fe0f", 1197], ["1f1e6-1f1f9", 1198], ["1f1e6-1f1f9-fe0f", 1198], ["1f1e6-1f1ff", 1199], ["1f1e6-1f1ff-fe0f", 1199], ["1f1e7-1f1f8", 1200], ["1f1e7-1f1f8-fe0f", 1200], ["1f1e7-1f1ed", 1201], ["1f1e7-1f1ed-fe0f", 1201], ["1f1e7-1f1e9", 1202], ["1f1e7-1f1e9-fe0f", 1202], ["1f1e7-1f1e7", 1203], ["1f1e7-1f1e7-fe0f", 1203], ["1f1e7-1f1fe", 1204], ["1f1e7-1f1fe-fe0f", 1204], ["1f1e7-1f1ea", 1205], ["1f1e7-1f1ea-fe0f", 1205], ["1f1e7-1f1ff", 1206], ["1f1e7-1f1ff-fe0f", 1206], ["1f1e7-1f1ef", 1207], ["1f1e7-1f1ef-fe0f", 1207], ["1f1e7-1f1f2", 1208], ["1f1e7-1f1f2-fe0f", 1208], ["1f1e7-1f1f9", 1209], ["1f1e7-1f1f9-fe0f", 1209], ["1f1e7-1f1f4", 1210], ["1f1e7-1f1f4-fe0f", 1210], ["1f1e7-1f1f6", 1211], ["1f1e7-1f1f6-fe0f", 1211], ["1f1e7-1f1e6", 1212], ["1f1e7-1f1e6-fe0f", 1212], ["1f1e7-1f1fc", 1213], ["1f1e7-1f1fc-fe0f", 1213], ["1f1e7-1f1f7", 1214], ["1f1e7-1f1f7-fe0f", 1214], ["1f1ee-1f1f4", 1215], ["1f1ee-1f1f4-fe0f", 1215], ["1f1fb-1f1ec", 1216], ["1f1fb-1f1ec-fe0f", 1216], ["1f1e7-1f1f3", 1217], ["1f1e7-1f1f3-fe0f", 1217], ["1f1e7-1f1ec", 1218], ["1f1e7-1f1ec-fe0f", 1218], ["1f1e7-1f1eb", 1219], ["1f1e7-1f1eb-fe0f", 1219], ["1f1e7-1f1ee", 1220], ["1f1e7-1f1ee-fe0f", 1220], ["1f1e8-1f1fb", 1221], ["1f1e8-1f1fb-fe0f", 1221], ["1f1f0-1f1ed", 1222], ["1f1f0-1f1ed-fe0f", 1222], ["1f1e8-1f1f2", 1223], ["1f1e8-1f1f2-fe0f", 1223], ["1f1e8-1f1e6", 1224], ["1f1e8-1f1e6-fe0f", 1224], ["1f1ee-1f1e8", 1225], ["1f1ee-1f1e8-fe0f", 1225], ["1f1f0-1f1fe", 1226], ["1f1f0-1f1fe-fe0f", 1226], ["1f1e8-1f1eb", 1227], ["1f1e8-1f1eb-fe0f", 1227], ["1f1f9-1f1e9", 1228], ["1f1f9-1f1e9-fe0f", 1228], ["1f1e8-1f1f1", 1229], ["1f1e8-1f1f1-fe0f", 1229], ["1f1e8-1f1f3", 1230], ["1f1e8-1f1f3-fe0f", 1230], ["1f1e8-1f1fd", 1231], ["1f1e8-1f1fd-fe0f", 1231], ["1f1e8-1f1e8", 1232], ["1f1e8-1f1e8-fe0f", 1232], ["1f1e8-1f1f4", 1233], ["1f1e8-1f1f4-fe0f", 1233], ["1f1f0-1f1f2", 1234], ["1f1f0-1f1f2-fe0f", 1234], ["1f1e8-1f1ec", 1235], ["1f1e8-1f1ec-fe0f", 1235], ["1f1e8-1f1e9", 1236], ["1f1e8-1f1e9-fe0f", 1236], ["1f1e8-1f1f0", 1237], ["1f1e8-1f1f0-fe0f", 1237], ["1f1e8-1f1f7", 1238], ["1f1e8-1f1f7-fe0f", 1238], ["1f1e8-1f1ee", 1239], ["1f1e8-1f1ee-fe0f", 1239], ["1f1ed-1f1f7", 1240], ["1f1ed-1f1f7-fe0f", 1240], ["1f1e8-1f1fa", 1241], ["1f1e8-1f1fa-fe0f", 1241], ["1f1e8-1f1fc", 1242], ["1f1e8-1f1fc-fe0f", 1242], ["1f1e8-1f1fe", 1243], ["1f1e8-1f1fe-fe0f", 1243], ["1f1e8-1f1ff", 1244], ["1f1e8-1f1ff-fe0f", 1244], ["1f1e9-1f1f0", 1245], ["1f1e9-1f1f0-fe0f", 1245], ["1f1e9-1f1ef", 1246], ["1f1e9-1f1ef-fe0f", 1246], ["1f1e9-1f1f2", 1247], ["1f1e9-1f1f2-fe0f", 1247], ["1f1e9-1f1f4", 1248], ["1f1e9-1f1f4-fe0f", 1248], ["1f1ea-1f1e8", 1249], ["1f1ea-1f1e8-fe0f", 1249], ["1f1ea-1f1ec", 1250], ["1f1ea-1f1ec-fe0f", 1250], ["1f1f8-1f1fb", 1251], ["1f1f8-1f1fb-fe0f", 1251], ["1f1ec-1f1f6", 1252], ["1f1ec-1f1f6-fe0f", 1252], ["1f1ea-1f1f7", 1253], ["1f1ea-1f1f7-fe0f", 1253], ["1f1ea-1f1ea", 1254], ["1f1ea-1f1ea-fe0f", 1254], ["1f1ea-1f1f9", 1255], ["1f1ea-1f1f9-fe0f", 1255], ["1f1ea-1f1fa", 1256], ["1f1ea-1f1fa-fe0f", 1256], ["1f1eb-1f1f0", 1257], ["1f1eb-1f1f0-fe0f", 1257], ["1f1eb-1f1f4", 1258], ["1f1eb-1f1f4-fe0f", 1258], ["1f1eb-1f1ef", 1259], ["1f1eb-1f1ef-fe0f", 1259], ["1f1eb-1f1ee", 1260], ["1f1eb-1f1ee-fe0f", 1260], ["1f1eb-1f1f7", 1261], ["1f1eb-1f1f7-fe0f", 1261], ["1f1ec-1f1eb", 1262], ["1f1ec-1f1eb-fe0f", 1262], ["1f1f5-1f1eb", 1263], ["1f1f5-1f1eb-fe0f", 1263], ["1f1f9-1f1eb", 1264], ["1f1f9-1f1eb-fe0f", 1264], ["1f1ec-1f1e6", 1265], ["1f1ec-1f1e6-fe0f", 1265], ["1f1ec-1f1f2", 1266], ["1f1ec-1f1f2-fe0f", 1266], ["1f1ec-1f1ea", 1267], ["1f1ec-1f1ea-fe0f", 1267], ["1f1e9-1f1ea", 1268], ["1f1e9-1f1ea-fe0f", 1268], ["1f1ec-1f1ed", 1269], ["1f1ec-1f1ed-fe0f", 1269], ["1f1ec-1f1ee", 1270], ["1f1ec-1f1ee-fe0f", 1270], ["1f1ec-1f1f7", 1271], ["1f1ec-1f1f7-fe0f", 1271], ["1f1ec-1f1f1", 1272], ["1f1ec-1f1f1-fe0f", 1272], ["1f1ec-1f1e9", 1273], ["1f1ec-1f1e9-fe0f", 1273], ["1f1ec-1f1f5", 1274], ["1f1ec-1f1f5-fe0f", 1274], ["1f1ec-1f1fa", 1275], ["1f1ec-1f1fa-fe0f", 1275], ["1f1ec-1f1f9", 1276], ["1f1ec-1f1f9-fe0f", 1276], ["1f1ec-1f1ec", 1277], ["1f1ec-1f1ec-fe0f", 1277], ["1f1ec-1f1f3", 1278], ["1f1ec-1f1f3-fe0f", 1278], ["1f1ec-1f1fc", 1279], ["1f1ec-1f1fc-fe0f", 1279], ["1f1ec-1f1fe", 1280], ["1f1ec-1f1fe-fe0f", 1280], ["1f1ed-1f1f9", 1281], ["1f1ed-1f1f9-fe0f", 1281], ["1f1ed-1f1f3", 1282], ["1f1ed-1f1f3-fe0f", 1282], ["1f1ed-1f1f0", 1283], ["1f1ed-1f1f0-fe0f", 1283], ["1f1ed-1f1fa", 1284], ["1f1ed-1f1fa-fe0f", 1284], ["1f1ee-1f1f8", 1285], ["1f1ee-1f1f8-fe0f", 1285], ["1f1ee-1f1f3", 1286], ["1f1ee-1f1f3-fe0f", 1286], ["1f1ee-1f1e9", 1287], ["1f1ee-1f1e9-fe0f", 1287], ["1f1ee-1f1f7", 1288], ["1f1ee-1f1f7-fe0f", 1288], ["1f1ee-1f1f6", 1289], ["1f1ee-1f1f6-fe0f", 1289], ["1f1ee-1f1ea", 1290], ["1f1ee-1f1ea-fe0f", 1290], ["1f1ee-1f1f2", 1291], ["1f1ee-1f1f2-fe0f", 1291], ["1f1ee-1f1f1", 1292], ["1f1ee-1f1f1-fe0f", 1292], ["1f1ee-1f1f9", 1293], ["1f1ee-1f1f9-fe0f", 1293], ["1f1ef-1f1f2", 1294], ["1f1ef-1f1f2-fe0f", 1294], ["1f1ef-1f1f5", 1295], ["1f1ef-1f1f5-fe0f", 1295], ["1f38c", 1296], ["1f38c-fe0f", 1296], ["1f1ef-1f1ea", 1297], ["1f1ef-1f1ea-fe0f", 1297], ["1f1ef-1f1f4", 1298], ["1f1ef-1f1f4-fe0f", 1298], ["1f1f0-1f1ff", 1299], ["1f1f0-1f1ff-fe0f", 1299], ["1f1f0-1f1ea", 1300], ["1f1f0-1f1ea-fe0f", 1300], ["1f1f0-1f1ee", 1301], ["1f1f0-1f1ee-fe0f", 1301], ["1f1fd-1f1f0", 1302], ["1f1fd-1f1f0-fe0f", 1302], ["1f1f0-1f1fc", 1303], ["1f1f0-1f1fc-fe0f", 1303], ["1f1f0-1f1ec", 1304], ["1f1f0-1f1ec-fe0f", 1304], ["1f1f1-1f1e6", 1305], ["1f1f1-1f1e6-fe0f", 1305], ["1f1f1-1f1fb", 1306], ["1f1f1-1f1fb-fe0f", 1306], ["1f1f1-1f1e7", 1307], ["1f1f1-1f1e7-fe0f", 1307], ["1f1f1-1f1f8", 1308], ["1f1f1-1f1f8-fe0f", 1308], ["1f1f1-1f1f7", 1309], ["1f1f1-1f1f7-fe0f", 1309], ["1f1f1-1f1fe", 1310], ["1f1f1-1f1fe-fe0f", 1310], ["1f1f1-1f1ee", 1311], ["1f1f1-1f1ee-fe0f", 1311], ["1f1f1-1f1f9", 1312], ["1f1f1-1f1f9-fe0f", 1312], ["1f1f1-1f1fa", 1313], ["1f1f1-1f1fa-fe0f", 1313], ["1f1f2-1f1f4", 1314], ["1f1f2-1f1f4-fe0f", 1314], ["1f1f2-1f1f0", 1315], ["1f1f2-1f1f0-fe0f", 1315], ["1f1f2-1f1ec", 1316], ["1f1f2-1f1ec-fe0f", 1316], ["1f1f2-1f1fc", 1317], ["1f1f2-1f1fc-fe0f", 1317], ["1f1f2-1f1fe", 1318], ["1f1f2-1f1fe-fe0f", 1318], ["1f1f2-1f1fb", 1319], ["1f1f2-1f1fb-fe0f", 1319], ["1f1f2-1f1f1", 1320], ["1f1f2-1f1f1-fe0f", 1320], ["1f1f2-1f1f9", 1321], ["1f1f2-1f1f9-fe0f", 1321], ["1f1f2-1f1ed", 1322], ["1f1f2-1f1ed-fe0f", 1322], ["1f1f2-1f1f6", 1323], ["1f1f2-1f1f6-fe0f", 1323], ["1f1f2-1f1f7", 1324], ["1f1f2-1f1f7-fe0f", 1324], ["1f1f2-1f1fa", 1325], ["1f1f2-1f1fa-fe0f", 1325], ["1f1fe-1f1f9", 1326], ["1f1fe-1f1f9-fe0f", 1326], ["1f1f2-1f1fd", 1327], ["1f1f2-1f1fd-fe0f", 1327], ["1f1eb-1f1f2", 1328], ["1f1eb-1f1f2-fe0f", 1328], ["1f1f2-1f1e9", 1329], ["1f1f2-1f1e9-fe0f", 1329], ["1f1f2-1f1e8", 1330], ["1f1f2-1f1e8-fe0f", 1330], ["1f1f2-1f1f3", 1331], ["1f1f2-1f1f3-fe0f", 1331], ["1f1f2-1f1ea", 1332], ["1f1f2-1f1ea-fe0f", 1332], ["1f1f2-1f1f8", 1333], ["1f1f2-1f1f8-fe0f", 1333], ["1f1f2-1f1e6", 1334], ["1f1f2-1f1e6-fe0f", 1334], ["1f1f2-1f1ff", 1335], ["1f1f2-1f1ff-fe0f", 1335], ["1f1f2-1f1f2", 1336], ["1f1f2-1f1f2-fe0f", 1336], ["1f1f3-1f1e6", 1337], ["1f1f3-1f1e6-fe0f", 1337], ["1f1f3-1f1f7", 1338], ["1f1f3-1f1f7-fe0f", 1338], ["1f1f3-1f1f5", 1339], ["1f1f3-1f1f5-fe0f", 1339], ["1f1f3-1f1f1", 1340], ["1f1f3-1f1f1-fe0f", 1340], ["1f1f3-1f1e8", 1341], ["1f1f3-1f1e8-fe0f", 1341], ["1f1f3-1f1ff", 1342], ["1f1f3-1f1ff-fe0f", 1342], ["1f1f3-1f1ee", 1343], ["1f1f3-1f1ee-fe0f", 1343], ["1f1f3-1f1ea", 1344], ["1f1f3-1f1ea-fe0f", 1344], ["1f1f3-1f1ec", 1345], ["1f1f3-1f1ec-fe0f", 1345], ["1f1f3-1f1fa", 1346], ["1f1f3-1f1fa-fe0f", 1346], ["1f1f3-1f1eb", 1347], ["1f1f3-1f1eb-fe0f", 1347], ["1f1f2-1f1f5", 1348], ["1f1f2-1f1f5-fe0f", 1348], ["1f1f0-1f1f5", 1349], ["1f1f0-1f1f5-fe0f", 1349], ["1f1f3-1f1f4", 1350], ["1f1f3-1f1f4-fe0f", 1350], ["1f1f4-1f1f2", 1351], ["1f1f4-1f1f2-fe0f", 1351], ["1f1f5-1f1f0", 1352], ["1f1f5-1f1f0-fe0f", 1352], ["1f1f5-1f1fc", 1353], ["1f1f5-1f1fc-fe0f", 1353], ["1f1f5-1f1f8", 1354], ["1f1f5-1f1f8-fe0f", 1354], ["1f1f5-1f1e6", 1355], ["1f1f5-1f1e6-fe0f", 1355], ["1f1f5-1f1ec", 1356], ["1f1f5-1f1ec-fe0f", 1356], ["1f1f5-1f1fe", 1357], ["1f1f5-1f1fe-fe0f", 1357], ["1f1f5-1f1ea", 1358], ["1f1f5-1f1ea-fe0f", 1358], ["1f1f5-1f1ed", 1359], ["1f1f5-1f1ed-fe0f", 1359], ["1f1f5-1f1f3", 1360], ["1f1f5-1f1f3-fe0f", 1360], ["1f1f5-1f1f1", 1361], ["1f1f5-1f1f1-fe0f", 1361], ["1f1f5-1f1f9", 1362], ["1f1f5-1f1f9-fe0f", 1362], ["1f1f5-1f1f7", 1363], ["1f1f5-1f1f7-fe0f", 1363], ["1f1f6-1f1e6", 1364], ["1f1f6-1f1e6-fe0f", 1364], ["1f1f7-1f1ea", 1365], ["1f1f7-1f1ea-fe0f", 1365], ["1f1f7-1f1f4", 1366], ["1f1f7-1f1f4-fe0f", 1366], ["1f1f7-1f1fa", 1367], ["1f1f7-1f1fa-fe0f", 1367], ["1f1f7-1f1fc", 1368], ["1f1f7-1f1fc-fe0f", 1368], ["1f1e7-1f1f1", 1369], ["1f1e7-1f1f1-fe0f", 1369], ["1f1f8-1f1ed", 1370], ["1f1f8-1f1ed-fe0f", 1370], ["1f1f0-1f1f3", 1371], ["1f1f0-1f1f3-fe0f", 1371], ["1f1f1-1f1e8", 1372], ["1f1f1-1f1e8-fe0f", 1372], ["1f1f5-1f1f2", 1373], ["1f1f5-1f1f2-fe0f", 1373], ["1f1fb-1f1e8", 1374], ["1f1fb-1f1e8-fe0f", 1374], ["1f1fc-1f1f8", 1375], ["1f1fc-1f1f8-fe0f", 1375], ["1f1f8-1f1f2", 1376], ["1f1f8-1f1f2-fe0f", 1376], ["1f1f8-1f1f9", 1377], ["1f1f8-1f1f9-fe0f", 1377], ["1f1f8-1f1e6", 1378], ["1f1f8-1f1e6-fe0f", 1378], ["1f1f8-1f1f3", 1379], ["1f1f8-1f1f3-fe0f", 1379], ["1f1f7-1f1f8", 1380], ["1f1f7-1f1f8-fe0f", 1380], ["1f1f8-1f1e8", 1381], ["1f1f8-1f1e8-fe0f", 1381], ["1f1f8-1f1f1", 1382], ["1f1f8-1f1f1-fe0f", 1382], ["1f1f8-1f1ec", 1383], ["1f1f8-1f1ec-fe0f", 1383], ["1f1f8-1f1fd", 1384], ["1f1f8-1f1fd-fe0f", 1384], ["1f1f8-1f1f0", 1385], ["1f1f8-1f1f0-fe0f", 1385], ["1f1f8-1f1ee", 1386], ["1f1f8-1f1ee-fe0f", 1386], ["1f1f8-1f1e7", 1387], ["1f1f8-1f1e7-fe0f", 1387], ["1f1f8-1f1f4", 1388], ["1f1f8-1f1f4-fe0f", 1388], ["1f1ff-1f1e6", 1389], ["1f1ff-1f1e6-fe0f", 1389], ["1f1ec-1f1f8", 1390], ["1f1ec-1f1f8-fe0f", 1390], ["1f1f0-1f1f7", 1391], ["1f1f0-1f1f7-fe0f", 1391], ["1f1f8-1f1f8", 1392], ["1f1f8-1f1f8-fe0f", 1392], ["1f1ea-1f1f8", 1393], ["1f1ea-1f1f8-fe0f", 1393], ["1f1f1-1f1f0", 1394], ["1f1f1-1f1f0-fe0f", 1394], ["1f1f8-1f1e9", 1395], ["1f1f8-1f1e9-fe0f", 1395], ["1f1f8-1f1f7", 1396], ["1f1f8-1f1f7-fe0f", 1396], ["1f1f8-1f1ff", 1397], ["1f1f8-1f1ff-fe0f", 1397], ["1f1f8-1f1ea", 1398], ["1f1f8-1f1ea-fe0f", 1398], ["1f1e8-1f1ed", 1399], ["1f1e8-1f1ed-fe0f", 1399], ["1f1f8-1f1fe", 1400], ["1f1f8-1f1fe-fe0f", 1400], ["1f1f9-1f1fc", 1401], ["1f1f9-1f1fc-fe0f", 1401], ["1f1f9-1f1ef", 1402], ["1f1f9-1f1ef-fe0f", 1402], ["1f1f9-1f1ff", 1403], ["1f1f9-1f1ff-fe0f", 1403], ["1f1f9-1f1ed", 1404], ["1f1f9-1f1ed-fe0f", 1404], ["1f1f9-1f1f1", 1405], ["1f1f9-1f1f1-fe0f", 1405], ["1f1f9-1f1ec", 1406], ["1f1f9-1f1ec-fe0f", 1406], ["1f1f9-1f1f0", 1407], ["1f1f9-1f1f0-fe0f", 1407], ["1f1f9-1f1f4", 1408], ["1f1f9-1f1f4-fe0f", 1408], ["1f1f9-1f1f9", 1409], ["1f1f9-1f1f9-fe0f", 1409], ["1f1f9-1f1f3", 1410], ["1f1f9-1f1f3-fe0f", 1410], ["1f1f9-1f1f7", 1411], ["1f1f9-1f1f7-fe0f", 1411], ["1f1f9-1f1f2", 1412], ["1f1f9-1f1f2-fe0f", 1412], ["1f1f9-1f1e8", 1413], ["1f1f9-1f1e8-fe0f", 1413], ["1f1f9-1f1fb", 1414], ["1f1f9-1f1fb-fe0f", 1414], ["1f1fa-1f1ec", 1415], ["1f1fa-1f1ec-fe0f", 1415], ["1f1fa-1f1e6", 1416], ["1f1fa-1f1e6-fe0f", 1416], ["1f1e6-1f1ea", 1417], ["1f1e6-1f1ea-fe0f", 1417], ["1f1ec-1f1e7", 1418], ["1f1ec-1f1e7-fe0f", 1418], ["1f1fa-1f1f8", 1419], ["1f1fa-1f1f8-fe0f", 1419], ["1f1fb-1f1ee", 1420], ["1f1fb-1f1ee-fe0f", 1420], ["1f1fa-1f1fe", 1421], ["1f1fa-1f1fe-fe0f", 1421], ["1f1fa-1f1ff", 1422], ["1f1fa-1f1ff-fe0f", 1422], ["1f1fb-1f1fa", 1423], ["1f1fb-1f1fa-fe0f", 1423], ["1f1fb-1f1e6", 1424], ["1f1fb-1f1e6-fe0f", 1424], ["1f1fb-1f1ea", 1425], ["1f1fb-1f1ea-fe0f", 1425], ["1f1fb-1f1f3", 1426], ["1f1fb-1f1f3-fe0f", 1426], ["1f1fc-1f1eb", 1427], ["1f1fc-1f1eb-fe0f", 1427], ["1f1ea-1f1ed", 1428], ["1f1ea-1f1ed-fe0f", 1428], ["1f1fe-1f1ea", 1429], ["1f1fe-1f1ea-fe0f", 1429], ["1f1ff-1f1f2", 1430], ["1f1ff-1f1f2-fe0f", 1430], ["1f1ff-1f1fc", 1431], ["1f1ff-1f1fc-fe0f", 1431], ["1f450-1f3fb", 1448], ["1f450-1f3fc", 1449], ["1f450-1f3fd", 1450], ["1f450-1f3fe", 1451], ["1f450-1f3ff", 1452], ["1f64c-1f3fb", 1453], ["1f64c-1f3fc", 1454], ["1f64c-1f3fd", 1455], ["1f64c-1f3fe", 1456], ["1f64c-1f3ff", 1457], ["1f44f-1f3fb", 1458], ["1f44f-1f3fc", 1459], ["1f44f-1f3fd", 1460], ["1f44f-1f3fe", 1461], ["1f44f-1f3ff", 1462], ["1f64f-1f3fb", 1463], ["1f64f-1f3fc", 1464], ["1f64f-1f3fd", 1465], ["1f64f-1f3fe", 1466], ["1f64f-1f3ff", 1467], ["1f44d-1f3fb", 1468], ["1f44d-1f3fc", 1469], ["1f44d-1f3fd", 1470], ["1f44d-1f3fe", 1471], ["1f44d-1f3ff", 1472], ["1f44e-1f3fb", 1473], ["1f44e-1f3fc", 1474], ["1f44e-1f3fd", 1475], ["1f44e-1f3fe", 1476], ["1f44e-1f3ff", 1477], ["1f44a-1f3fb", 1478], ["1f44a-1f3fc", 1479], ["1f44a-1f3fd", 1480], ["1f44a-1f3fe", 1481], ["1f44a-1f3ff", 1482], ["270a-1f3fb", 1483], ["270a-1f3fc", 1484], ["270a-1f3fd", 1485], ["270a-1f3fe", 1486], ["270a-1f3ff", 1487], ["1f91b-1f3fb", 1488], ["1f91b-1f3fc", 1489], ["1f91b-1f3fd", 1490], ["1f91b-1f3fe", 1491], ["1f91b-1f3ff", 1492], ["1f91c-1f3fb", 1493], ["1f91c-1f3fc", 1494], ["1f91c-1f3fd", 1495], ["1f91c-1f3fe", 1496], ["1f91c-1f3ff", 1497], ["1f91e-1f3fb", 1498], ["1f91e-1f3fc", 1499], ["1f91e-1f3fd", 1500], ["1f91e-1f3fe", 1501], ["1f91e-1f3ff", 1502], ["270c-1f3fb", 1503], ["270c-1f3fc", 1504], ["270c-1f3fd", 1505], ["270c-1f3fe", 1506], ["270c-1f3ff", 1507], ["1f918-1f3fb", 1508], ["1f918-1f3fc", 1509], ["1f918-1f3fd", 1510], ["1f918-1f3fe", 1511], ["1f918-1f3ff", 1512], ["1f44c-1f3fb", 1513], ["1f44c-1f3fc", 1514], ["1f44c-1f3fd", 1515], ["1f44c-1f3fe", 1516], ["1f44c-1f3ff", 1517], ["1f448-1f3fb", 1518], ["1f448-1f3fc", 1519], ["1f448-1f3fd", 1520], ["1f448-1f3fe", 1521], ["1f448-1f3ff", 1522], ["1f449-1f3fb", 1523], ["1f449-1f3fc", 1524], ["1f449-1f3fd", 1525], ["1f449-1f3fe", 1526], ["1f449-1f3ff", 1527], ["1f446-1f3fb", 1528], ["1f446-1f3fc", 1529], ["1f446-1f3fd", 1530], ["1f446-1f3fe", 1531], ["1f446-1f3ff", 1532], ["1f447-1f3fb", 1533], ["1f447-1f3fc", 1534], ["1f447-1f3fd", 1535], ["1f447-1f3fe", 1536], ["1f447-1f3ff", 1537], ["261d-1f3fb", 1538], ["261d-1f3fc", 1539], ["261d-1f3fd", 1540], ["261d-1f3fe", 1541], ["261d-1f3ff", 1542], ["270b-1f3fb", 1543], ["270b-1f3fc", 1544], ["270b-1f3fd", 1545], ["270b-1f3fe", 1546], ["270b-1f3ff", 1547], ["1f91a-1f3fb", 1548], ["1f91a-1f3fc", 1549], ["1f91a-1f3fd", 1550], ["1f91a-1f3fe", 1551], ["1f91a-1f3ff", 1552], ["1f590-1f3fb", 1553], ["1f590-1f3fc", 1554], ["1f590-1f3fd", 1555], ["1f590-1f3fe", 1556], ["1f590-1f3ff", 1557], ["1f596-1f3fb", 1558], ["1f596-1f3fc", 1559], ["1f596-1f3fd", 1560], ["1f596-1f3fe", 1561], ["1f596-1f3ff", 1562], ["1f44b-1f3fb", 1563], ["1f44b-1f3fc", 1564], ["1f44b-1f3fd", 1565], ["1f44b-1f3fe", 1566], ["1f44b-1f3ff", 1567], ["1f919-1f3fb", 1568], ["1f919-1f3fc", 1569], ["1f919-1f3fd", 1570], ["1f919-1f3fe", 1571], ["1f919-1f3ff", 1572], ["1f4aa-1f3fb", 1573], ["1f4aa-1f3fc", 1574], ["1f4aa-1f3fd", 1575], ["1f4aa-1f3fe", 1576], ["1f4aa-1f3ff", 1577], ["1f595-1f3fb", 1578], ["1f595-1f3fc", 1579], ["1f595-1f3fd", 1580], ["1f595-1f3fe", 1581], ["1f595-1f3ff", 1582], ["270d-1f3fb", 1583], ["270d-1f3fc", 1584], ["270d-1f3fd", 1585], ["270d-1f3fe", 1586], ["270d-1f3ff", 1587], ["1f933-1f3fb", 1588], ["1f933-1f3fc", 1589], ["1f933-1f3fd", 1590], ["1f933-1f3fe", 1591], ["1f933-1f3ff", 1592], ["1f485-1f3fb", 1593], ["1f485-1f3fc", 1594], ["1f485-1f3fd", 1595], ["1f485-1f3fe", 1596], ["1f485-1f3ff", 1597], ["1f442-1f3fb", 1598], ["1f442-1f3fc", 1599], ["1f442-1f3fd", 1600], ["1f442-1f3fe", 1601], ["1f442-1f3ff", 1602], ["1f443-1f3fb", 1603], ["1f443-1f3fc", 1604], ["1f443-1f3fd", 1605], ["1f443-1f3fe", 1606], ["1f443-1f3ff", 1607], ["1f476-1f3fb", 1608], ["1f476-1f3fc", 1609], ["1f476-1f3fd", 1610], ["1f476-1f3fe", 1611], ["1f476-1f3ff", 1612], ["1f466-1f3fb", 1613], ["1f466-1f3fc", 1614], ["1f466-1f3fd", 1615], ["1f466-1f3fe", 1616], ["1f466-1f3ff", 1617], ["1f467-1f3fb", 1618], ["1f467-1f3fc", 1619], ["1f467-1f3fd", 1620], ["1f467-1f3fe", 1621], ["1f467-1f3ff", 1622], ["1f468-1f3fb", 1623], ["1f468-1f3fc", 1624], ["1f468-1f3fd", 1625], ["1f468-1f3fe", 1626], ["1f468-1f3ff", 1627], ["1f469-1f3fb", 1628], ["1f469-1f3fc", 1629], ["1f469-1f3fd", 1630], ["1f469-1f3fe", 1631], ["1f469-1f3ff", 1632], ["1f471-1f3fb", 1633], ["1f471-1f3fc", 1634], ["1f471-1f3fd", 1635], ["1f471-1f3fe", 1636], ["1f471-1f3ff", 1637], ["1f471-1f3fb-200d-2640-fe0f", 1638], ["1f471-1f3fc-200d-2640-fe0f", 1639], ["1f471-1f3fd-200d-2640-fe0f", 1640], ["1f471-1f3fe-200d-2640-fe0f", 1641], ["1f471-1f3ff-200d-2640-fe0f", 1642], ["1f471-1f3fb", 1643], ["1f471-1f3fc", 1644], ["1f471-1f3fd", 1645], ["1f471-1f3fe", 1646], ["1f471-1f3ff", 1647], ["1f471-1f3fb-200d-2640-fe0f", 1648], ["1f471-1f3fc-200d-2640-fe0f", 1649], ["1f471-1f3fd-200d-2640-fe0f", 1650], ["1f471-1f3fe-200d-2640-fe0f", 1651], ["1f471-1f3ff-200d-2640-fe0f", 1652], ["1f474-1f3fb", 1653], ["1f474-1f3fc", 1654], ["1f474-1f3fd", 1655], ["1f474-1f3fe", 1656], ["1f474-1f3ff", 1657], ["1f475-1f3fb", 1658], ["1f475-1f3fc", 1659], ["1f475-1f3fd", 1660], ["1f475-1f3fe", 1661], ["1f475-1f3ff", 1662], ["1f472-1f3fb", 1663], ["1f472-1f3fc", 1664], ["1f472-1f3fd", 1665], ["1f472-1f3fe", 1666], ["1f472-1f3ff", 1667], ["1f473-1f3fb", 1668], ["1f473-1f3fc", 1669], ["1f473-1f3fd", 1670], ["1f473-1f3fe", 1671], ["1f473-1f3ff", 1672], ["1f473-1f3fb-200d-2640-fe0f", 1673], ["1f473-1f3fc-200d-2640-fe0f", 1674], ["1f473-1f3fd-200d-2640-fe0f", 1675], ["1f473-1f3fe-200d-2640-fe0f", 1676], ["1f473-1f3ff-200d-2640-fe0f", 1677], ["1f473-1f3fb", 1678], ["1f473-1f3fc", 1679], ["1f473-1f3fd", 1680], ["1f473-1f3fe", 1681], ["1f473-1f3ff", 1682], ["1f473-1f3fb-200d-2640-fe0f", 1683], ["1f473-1f3fc-200d-2640-fe0f", 1684], ["1f473-1f3fd-200d-2640-fe0f", 1685], ["1f473-1f3fe-200d-2640-fe0f", 1686], ["1f473-1f3ff-200d-2640-fe0f", 1687], ["1f46e-1f3fb", 1688], ["1f46e-1f3fc", 1689], ["1f46e-1f3fd", 1690], ["1f46e-1f3fe", 1691], ["1f46e-1f3ff", 1692], ["1f46e-1f3fb-200d-2640-fe0f", 1693], ["1f46e-1f3fc-200d-2640-fe0f", 1694], ["1f46e-1f3fd-200d-2640-fe0f", 1695], ["1f46e-1f3fe-200d-2640-fe0f", 1696], ["1f46e-1f3ff-200d-2640-fe0f", 1697], ["1f46e-1f3fb", 1698], ["1f46e-1f3fc", 1699], ["1f46e-1f3fd", 1700], ["1f46e-1f3fe", 1701], ["1f46e-1f3ff", 1702], ["1f46e-1f3fb-200d-2640-fe0f", 1703], ["1f46e-1f3fc-200d-2640-fe0f", 1704], ["1f46e-1f3fd-200d-2640-fe0f", 1705], ["1f46e-1f3fe-200d-2640-fe0f", 1706], ["1f46e-1f3ff-200d-2640-fe0f", 1707], ["1f477-1f3fb", 1708], ["1f477-1f3fc", 1709], ["1f477-1f3fd", 1710], ["1f477-1f3fe", 1711], ["1f477-1f3ff", 1712], ["1f477-1f3fb-200d-2640-fe0f", 1713], ["1f477-1f3fc-200d-2640-fe0f", 1714], ["1f477-1f3fd-200d-2640-fe0f", 1715], ["1f477-1f3fe-200d-2640-fe0f", 1716], ["1f477-1f3ff-200d-2640-fe0f", 1717], ["1f477-1f3fb", 1718], ["1f477-1f3fc", 1719], ["1f477-1f3fd", 1720], ["1f477-1f3fe", 1721], ["1f477-1f3ff", 1722], ["1f477-1f3fb-200d-2640-fe0f", 1723], ["1f477-1f3fc-200d-2640-fe0f", 1724], ["1f477-1f3fd-200d-2640-fe0f", 1725], ["1f477-1f3fe-200d-2640-fe0f", 1726], ["1f477-1f3ff-200d-2640-fe0f", 1727], ["1f482-1f3fb", 1728], ["1f482-1f3fc", 1729], ["1f482-1f3fd", 1730], ["1f482-1f3fe", 1731], ["1f482-1f3ff", 1732], ["1f482-1f3fb-200d-2640-fe0f", 1733], ["1f482-1f3fc-200d-2640-fe0f", 1734], ["1f482-1f3fd-200d-2640-fe0f", 1735], ["1f482-1f3fe-200d-2640-fe0f", 1736], ["1f482-1f3ff-200d-2640-fe0f", 1737], ["1f482-1f3fb", 1738], ["1f482-1f3fc", 1739], ["1f482-1f3fd", 1740], ["1f482-1f3fe", 1741], ["1f482-1f3ff", 1742], ["1f482-1f3fb-200d-2640-fe0f", 1743], ["1f482-1f3fc-200d-2640-fe0f", 1744], ["1f482-1f3fd-200d-2640-fe0f", 1745], ["1f482-1f3fe-200d-2640-fe0f", 1746], ["1f482-1f3ff-200d-2640-fe0f", 1747], ["1f575-1f3fb", 1748], ["1f575-1f3fc", 1749], ["1f575-1f3fd", 1750], ["1f575-1f3fe", 1751], ["1f575-1f3ff", 1752], ["1f575-1f3fb-200d-2640-fe0f", 1753], ["1f575-1f3fc-200d-2640-fe0f", 1754], ["1f575-1f3fd-200d-2640-fe0f", 1755], ["1f575-1f3fe-200d-2640-fe0f", 1756], ["1f575-1f3ff-200d-2640-fe0f", 1757], ["1f575-1f3fb", 1758], ["1f575-1f3fc", 1759], ["1f575-1f3fd", 1760], ["1f575-1f3fe", 1761], ["1f575-1f3ff", 1762], ["1f575-1f3fb-200d-2640-fe0f", 1763], ["1f575-1f3fc-200d-2640-fe0f", 1764], ["1f575-1f3fd-200d-2640-fe0f", 1765], ["1f575-1f3fe-200d-2640-fe0f", 1766], ["1f575-1f3ff-200d-2640-fe0f", 1767], ["1f469-1f3fb", 1768], ["1f469-1f3fc", 1769], ["1f469-1f3fd", 1770], ["1f469-1f3fe", 1771], ["1f469-1f3ff", 1772], ["1f468-1f3fb", 1773], ["1f468-1f3fc", 1774], ["1f468-1f3fd", 1775], ["1f468-1f3fe", 1776], ["1f468-1f3ff", 1777], ["1f469-1f3fb", 1778], ["1f469-1f3fc", 1779], ["1f469-1f3fd", 1780], ["1f469-1f3fe", 1781], ["1f469-1f3ff", 1782], ["1f468-1f3fb", 1783], ["1f468-1f3fc", 1784], ["1f468-1f3fd", 1785], ["1f468-1f3fe", 1786], ["1f468-1f3ff", 1787], ["1f469-1f3fb", 1788], ["1f469-1f3fc", 1789], ["1f469-1f3fd", 1790], ["1f469-1f3fe", 1791], ["1f469-1f3ff", 1792], ["1f468-1f3fb", 1793], ["1f468-1f3fc", 1794], ["1f468-1f3fd", 1795], ["1f468-1f3fe", 1796], ["1f468-1f3ff", 1797], ["1f469-1f3fb", 1798], ["1f469-1f3fc", 1799], ["1f469-1f3fd", 1800], ["1f469-1f3fe", 1801], ["1f469-1f3ff", 1802], ["1f468-1f3fb", 1803], ["1f468-1f3fc", 1804], ["1f468-1f3fd", 1805], ["1f468-1f3fe", 1806], ["1f468-1f3ff", 1807], ["1f469-1f3fb", 1808], ["1f469-1f3fc", 1809], ["1f469-1f3fd", 1810], ["1f469-1f3fe", 1811], ["1f469-1f3ff", 1812], ["1f468-1f3fb", 1813], ["1f468-1f3fc", 1814], ["1f468-1f3fd", 1815], ["1f468-1f3fe", 1816], ["1f468-1f3ff", 1817], ["1f469-1f3fb", 1818], ["1f469-1f3fc", 1819], ["1f469-1f3fd", 1820], ["1f469-1f3fe", 1821], ["1f469-1f3ff", 1822], ["1f468-1f3fb", 1823], ["1f468-1f3fc", 1824], ["1f468-1f3fd", 1825], ["1f468-1f3fe", 1826], ["1f468-1f3ff", 1827], ["1f469-1f3fb", 1828], ["1f469-1f3fc", 1829], ["1f469-1f3fd", 1830], ["1f469-1f3fe", 1831], ["1f469-1f3ff", 1832], ["1f468-1f3fb", 1833], ["1f468-1f3fc", 1834], ["1f468-1f3fd", 1835], ["1f468-1f3fe", 1836], ["1f468-1f3ff", 1837], ["1f469-1f3fb", 1838], ["1f469-1f3fc", 1839], ["1f469-1f3fd", 1840], ["1f469-1f3fe", 1841], ["1f469-1f3ff", 1842], ["1f468-1f3fb", 1843], ["1f468-1f3fc", 1844], ["1f468-1f3fd", 1845], ["1f468-1f3fe", 1846], ["1f468-1f3ff", 1847], ["1f469-1f3fb", 1848], ["1f469-1f3fc", 1849], ["1f469-1f3fd", 1850], ["1f469-1f3fe", 1851], ["1f469-1f3ff", 1852], ["1f468-1f3fb", 1853], ["1f468-1f3fc", 1854], ["1f468-1f3fd", 1855], ["1f468-1f3fe", 1856], ["1f468-1f3ff", 1857], ["1f469-1f3fb", 1858], ["1f469-1f3fc", 1859], ["1f469-1f3fd", 1860], ["1f469-1f3fe", 1861], ["1f469-1f3ff", 1862], ["1f468-1f3fb", 1863], ["1f468-1f3fc", 1864], ["1f468-1f3fd", 1865], ["1f468-1f3fe", 1866], ["1f468-1f3ff", 1867], ["1f469-1f3fb", 1868], ["1f469-1f3fc", 1869], ["1f469-1f3fd", 1870], ["1f469-1f3fe", 1871], ["1f469-1f3ff", 1872], ["1f468-1f3fb", 1873], ["1f468-1f3fc", 1874], ["1f468-1f3fd", 1875], ["1f468-1f3fe", 1876], ["1f468-1f3ff", 1877], ["1f469-1f3fb", 1878], ["1f469-1f3fc", 1879], ["1f469-1f3fd", 1880], ["1f469-1f3fe", 1881], ["1f469-1f3ff", 1882], ["1f468-1f3fb", 1883], ["1f468-1f3fc", 1884], ["1f468-1f3fd", 1885], ["1f468-1f3fe", 1886], ["1f468-1f3ff", 1887], ["1f469-1f3fb", 1888], ["1f469-1f3fc", 1889], ["1f469-1f3fd", 1890], ["1f469-1f3fe", 1891], ["1f469-1f3ff", 1892], ["1f468-1f3fb", 1893], ["1f468-1f3fc", 1894], ["1f468-1f3fd", 1895], ["1f468-1f3fe", 1896], ["1f468-1f3ff", 1897], ["1f469-1f3fb", 1898], ["1f469-1f3fc", 1899], ["1f469-1f3fd", 1900], ["1f469-1f3fe", 1901], ["1f469-1f3ff", 1902], ["1f468-1f3fb", 1903], ["1f468-1f3fc", 1904], ["1f468-1f3fd", 1905], ["1f468-1f3fe", 1906], ["1f468-1f3ff", 1907], ["1f469-1f3fb", 1908], ["1f469-1f3fc", 1909], ["1f469-1f3fd", 1910], ["1f469-1f3fe", 1911], ["1f469-1f3ff", 1912], ["1f468-1f3fb", 1913], ["1f468-1f3fc", 1914], ["1f468-1f3fd", 1915], ["1f468-1f3fe", 1916], ["1f468-1f3ff", 1917], ["1f469-1f3fb", 1918], ["1f469-1f3fc", 1919], ["1f469-1f3fd", 1920], ["1f469-1f3fe", 1921], ["1f469-1f3ff", 1922], ["1f468-1f3fb", 1923], ["1f468-1f3fc", 1924], ["1f468-1f3fd", 1925], ["1f468-1f3fe", 1926], ["1f468-1f3ff", 1927], ["1f936-1f3fb", 1928], ["1f936-1f3fc", 1929], ["1f936-1f3fd", 1930], ["1f936-1f3fe", 1931], ["1f936-1f3ff", 1932], ["1f385-1f3fb", 1933], ["1f385-1f3fc", 1934], ["1f385-1f3fd", 1935], ["1f385-1f3fe", 1936], ["1f385-1f3ff", 1937], ["1f478-1f3fb", 1938], ["1f478-1f3fc", 1939], ["1f478-1f3fd", 1940], ["1f478-1f3fe", 1941], ["1f478-1f3ff", 1942], ["1f934-1f3fb", 1943], ["1f934-1f3fc", 1944], ["1f934-1f3fd", 1945], ["1f934-1f3fe", 1946], ["1f934-1f3ff", 1947], ["1f470-1f3fb", 1948], ["1f470-1f3fc", 1949], ["1f470-1f3fd", 1950], ["1f470-1f3fe", 1951], ["1f470-1f3ff", 1952], ["1f935-1f3fb", 1953], ["1f935-1f3fc", 1954], ["1f935-1f3fd", 1955], ["1f935-1f3fe", 1956], ["1f935-1f3ff", 1957], ["1f47c-1f3fb", 1958], ["1f47c-1f3fc", 1959], ["1f47c-1f3fd", 1960], ["1f47c-1f3fe", 1961], ["1f47c-1f3ff", 1962], ["1f930-1f3fb", 1963], ["1f930-1f3fc", 1964], ["1f930-1f3fd", 1965], ["1f930-1f3fe", 1966], ["1f930-1f3ff", 1967], ["1f647-1f3fb", 1968], ["1f647-1f3fc", 1969], ["1f647-1f3fd", 1970], ["1f647-1f3fe", 1971], ["1f647-1f3ff", 1972], ["1f647-1f3fb-200d-2640-fe0f", 1973], ["1f647-1f3fc-200d-2640-fe0f", 1974], ["1f647-1f3fd-200d-2640-fe0f", 1975], ["1f647-1f3fe-200d-2640-fe0f", 1976], ["1f647-1f3ff-200d-2640-fe0f", 1977], ["1f647-1f3fb", 1978], ["1f647-1f3fc", 1979], ["1f647-1f3fd", 1980], ["1f647-1f3fe", 1981], ["1f647-1f3ff", 1982], ["1f647-1f3fb-200d-2640-fe0f", 1983], ["1f647-1f3fc-200d-2640-fe0f", 1984], ["1f647-1f3fd-200d-2640-fe0f", 1985], ["1f647-1f3fe-200d-2640-fe0f", 1986], ["1f647-1f3ff-200d-2640-fe0f", 1987], ["1f481-1f3fb", 1988], ["1f481-1f3fc", 1989], ["1f481-1f3fd", 1990], ["1f481-1f3fe", 1991], ["1f481-1f3ff", 1992], ["1f481-1f3fb-200d-2640-fe0f", 1993], ["1f481-1f3fc-200d-2640-fe0f", 1994], ["1f481-1f3fd-200d-2640-fe0f", 1995], ["1f481-1f3fe-200d-2640-fe0f", 1996], ["1f481-1f3ff-200d-2640-fe0f", 1997], ["1f481-1f3fb-200d-2642-fe0f", 1998], ["1f481-1f3fc-200d-2642-fe0f", 1999], ["1f481-1f3fd-200d-2642-fe0f", 2000], ["1f481-1f3fe-200d-2642-fe0f", 2001], ["1f481-1f3ff-200d-2642-fe0f", 2002], ["1f645-1f3fb", 2003], ["1f645-1f3fc", 2004], ["1f645-1f3fd", 2005], ["1f645-1f3fe", 2006], ["1f645-1f3ff", 2007], ["1f645-1f3fb-200d-2640-fe0f", 2008], ["1f645-1f3fc-200d-2640-fe0f", 2009], ["1f645-1f3fd-200d-2640-fe0f", 2010], ["1f645-1f3fe-200d-2640-fe0f", 2011], ["1f645-1f3ff-200d-2640-fe0f", 2012], ["1f645-1f3fb-200d-2642-fe0f", 2013], ["1f645-1f3fc-200d-2642-fe0f", 2014], ["1f645-1f3fd-200d-2642-fe0f", 2015], ["1f645-1f3fe-200d-2642-fe0f", 2016], ["1f645-1f3ff-200d-2642-fe0f", 2017], ["1f646-1f3fb", 2018], ["1f646-1f3fc", 2019], ["1f646-1f3fd", 2020], ["1f646-1f3fe", 2021], ["1f646-1f3ff", 2022], ["1f646-1f3fb-200d-2640-fe0f", 2023], ["1f646-1f3fc-200d-2640-fe0f", 2024], ["1f646-1f3fd-200d-2640-fe0f", 2025], ["1f646-1f3fe-200d-2640-fe0f", 2026], ["1f646-1f3ff-200d-2640-fe0f", 2027], ["1f646-1f3fb-200d-2642-fe0f", 2028], ["1f646-1f3fc-200d-2642-fe0f", 2029], ["1f646-1f3fd-200d-2642-fe0f", 2030], ["1f646-1f3fe-200d-2642-fe0f", 2031], ["1f646-1f3ff-200d-2642-fe0f", 2032], ["1f64b-1f3fb", 2033], ["1f64b-1f3fc", 2034], ["1f64b-1f3fd", 2035], ["1f64b-1f3fe", 2036], ["1f64b-1f3ff", 2037], ["1f64b-1f3fb-200d-2640-fe0f", 2038], ["1f64b-1f3fc-200d-2640-fe0f", 2039], ["1f64b-1f3fd-200d-2640-fe0f", 2040], ["1f64b-1f3fe-200d-2640-fe0f", 2041], ["1f64b-1f3ff-200d-2640-fe0f", 2042], ["1f64b-1f3fb-200d-2642-fe0f", 2043], ["1f64b-1f3fc-200d-2642-fe0f", 2044], ["1f64b-1f3fd-200d-2642-fe0f", 2045], ["1f64b-1f3fe-200d-2642-fe0f", 2046], ["1f64b-1f3ff-200d-2642-fe0f", 2047], ["1f926-1f3fb", 2048], ["1f926-1f3fc", 2049], ["1f926-1f3fd", 2050], ["1f926-1f3fe", 2051], ["1f926-1f3ff", 2052], ["1f926-1f3fb-200d-2640-fe0f", 2053], ["1f926-1f3fc-200d-2640-fe0f", 2054], ["1f926-1f3fd-200d-2640-fe0f", 2055], ["1f926-1f3fe-200d-2640-fe0f", 2056], ["1f926-1f3ff-200d-2640-fe0f", 2057], ["1f926-1f3fb-200d-2642-fe0f", 2058], ["1f926-1f3fc-200d-2642-fe0f", 2059], ["1f926-1f3fd-200d-2642-fe0f", 2060], ["1f926-1f3fe-200d-2642-fe0f", 2061], ["1f926-1f3ff-200d-2642-fe0f", 2062], ["1f937-1f3fb", 2063], ["1f937-1f3fc", 2064], ["1f937-1f3fd", 2065], ["1f937-1f3fe", 2066], ["1f937-1f3ff", 2067], ["1f937-1f3fb-200d-2640-fe0f", 2068], ["1f937-1f3fc-200d-2640-fe0f", 2069], ["1f937-1f3fd-200d-2640-fe0f", 2070], ["1f937-1f3fe-200d-2640-fe0f", 2071], ["1f937-1f3ff-200d-2640-fe0f", 2072], ["1f937-1f3fb-200d-2642-fe0f", 2073], ["1f937-1f3fc-200d-2642-fe0f", 2074], ["1f937-1f3fd-200d-2642-fe0f", 2075], ["1f937-1f3fe-200d-2642-fe0f", 2076], ["1f937-1f3ff-200d-2642-fe0f", 2077], ["1f64e-1f3fb", 2078], ["1f64e-1f3fc", 2079], ["1f64e-1f3fd", 2080], ["1f64e-1f3fe", 2081], ["1f64e-1f3ff", 2082], ["1f64e-1f3fb-200d-2640-fe0f", 2083], ["1f64e-1f3fc-200d-2640-fe0f", 2084], ["1f64e-1f3fd-200d-2640-fe0f", 2085], ["1f64e-1f3fe-200d-2640-fe0f", 2086], ["1f64e-1f3ff-200d-2640-fe0f", 2087], ["1f64e-1f3fb-200d-2642-fe0f", 2088], ["1f64e-1f3fc-200d-2642-fe0f", 2089], ["1f64e-1f3fd-200d-2642-fe0f", 2090], ["1f64e-1f3fe-200d-2642-fe0f", 2091], ["1f64e-1f3ff-200d-2642-fe0f", 2092], ["1f64d-1f3fb", 2093], ["1f64d-1f3fc", 2094], ["1f64d-1f3fd", 2095], ["1f64d-1f3fe", 2096], ["1f64d-1f3ff", 2097], ["1f64d-1f3fb-200d-2640-fe0f", 2098], ["1f64d-1f3fc-200d-2640-fe0f", 2099], ["1f64d-1f3fd-200d-2640-fe0f", 2100], ["1f64d-1f3fe-200d-2640-fe0f", 2101], ["1f64d-1f3ff-200d-2640-fe0f", 2102], ["1f64d-1f3fb-200d-2642-fe0f", 2103], ["1f64d-1f3fc-200d-2642-fe0f", 2104], ["1f64d-1f3fd-200d-2642-fe0f", 2105], ["1f64d-1f3fe-200d-2642-fe0f", 2106], ["1f64d-1f3ff-200d-2642-fe0f", 2107], ["1f487-1f3fb", 2108], ["1f487-1f3fc", 2109], ["1f487-1f3fd", 2110], ["1f487-1f3fe", 2111], ["1f487-1f3ff", 2112], ["1f487-1f3fb-200d-2640-fe0f", 2113], ["1f487-1f3fc-200d-2640-fe0f", 2114], ["1f487-1f3fd-200d-2640-fe0f", 2115], ["1f487-1f3fe-200d-2640-fe0f", 2116], ["1f487-1f3ff-200d-2640-fe0f", 2117], ["1f487-1f3fb-200d-2642-fe0f", 2118], ["1f487-1f3fc-200d-2642-fe0f", 2119], ["1f487-1f3fd-200d-2642-fe0f", 2120], ["1f487-1f3fe-200d-2642-fe0f", 2121], ["1f487-1f3ff-200d-2642-fe0f", 2122], ["1f486-1f3fb", 2123], ["1f486-1f3fc", 2124], ["1f486-1f3fd", 2125], ["1f486-1f3fe", 2126], ["1f486-1f3ff", 2127], ["1f486-1f3fb-200d-2640-fe0f", 2128], ["1f486-1f3fc-200d-2640-fe0f", 2129], ["1f486-1f3fd-200d-2640-fe0f", 2130], ["1f486-1f3fe-200d-2640-fe0f", 2131], ["1f486-1f3ff-200d-2640-fe0f", 2132], ["1f486-1f3fb-200d-2642-fe0f", 2133], ["1f486-1f3fc-200d-2642-fe0f", 2134], ["1f486-1f3fd-200d-2642-fe0f", 2135], ["1f486-1f3fe-200d-2642-fe0f", 2136], ["1f486-1f3ff-200d-2642-fe0f", 2137], ["1f574-1f3fb", 2138], ["1f574-1f3fc", 2139], ["1f574-1f3fd", 2140], ["1f574-1f3fe", 2141], ["1f574-1f3ff", 2142], ["1f483-1f3fb", 2143], ["1f483-1f3fc", 2144], ["1f483-1f3fd", 2145], ["1f483-1f3fe", 2146], ["1f483-1f3ff", 2147], ["1f57a-1f3fb", 2148], ["1f57a-1f3fc", 2149], ["1f57a-1f3fd", 2150], ["1f57a-1f3fe", 2151], ["1f57a-1f3ff", 2152], ["1f6b6-1f3fb", 2153], ["1f6b6-1f3fc", 2154], ["1f6b6-1f3fd", 2155], ["1f6b6-1f3fe", 2156], ["1f6b6-1f3ff", 2157], ["1f6b6-1f3fb-200d-2640-fe0f", 2158], ["1f6b6-1f3fc-200d-2640-fe0f", 2159], ["1f6b6-1f3fd-200d-2640-fe0f", 2160], ["1f6b6-1f3fe-200d-2640-fe0f", 2161], ["1f6b6-1f3ff-200d-2640-fe0f", 2162], ["1f6b6-1f3fb", 2163], ["1f6b6-1f3fc", 2164], ["1f6b6-1f3fd", 2165], ["1f6b6-1f3fe", 2166], ["1f6b6-1f3ff", 2167], ["1f6b6-1f3fb-200d-2640-fe0f", 2168], ["1f6b6-1f3fc-200d-2640-fe0f", 2169], ["1f6b6-1f3fd-200d-2640-fe0f", 2170], ["1f6b6-1f3fe-200d-2640-fe0f", 2171], ["1f6b6-1f3ff-200d-2640-fe0f", 2172], ["1f3c3-1f3fb", 2173], ["1f3c3-1f3fc", 2174], ["1f3c3-1f3fd", 2175], ["1f3c3-1f3fe", 2176], ["1f3c3-1f3ff", 2177], ["1f3c3-1f3fb-200d-2640-fe0f", 2178], ["1f3c3-1f3fc-200d-2640-fe0f", 2179], ["1f3c3-1f3fd-200d-2640-fe0f", 2180], ["1f3c3-1f3fe-200d-2640-fe0f", 2181], ["1f3c3-1f3ff-200d-2640-fe0f", 2182], ["1f3c3-1f3fb", 2183], ["1f3c3-1f3fc", 2184], ["1f3c3-1f3fd", 2185], ["1f3c3-1f3fe", 2186], ["1f3c3-1f3ff", 2187], ["1f3c3-1f3fb-200d-2640-fe0f", 2188], ["1f3c3-1f3fc-200d-2640-fe0f", 2189], ["1f3c3-1f3fd-200d-2640-fe0f", 2190], ["1f3c3-1f3fe-200d-2640-fe0f", 2191], ["1f3c3-1f3ff-200d-2640-fe0f", 2192], ["1f469-1f3fb", 2193], ["1f469-1f3fc", 2194], ["1f469-1f3fd", 2195], ["1f469-1f3fe", 2196], ["1f469-1f3ff", 2197], ["1f468-1f3fb", 2198], ["1f468-1f3fc", 2199], ["1f468-1f3fd", 2200], ["1f468-1f3fe", 2201], ["1f468-1f3ff", 2202], ["1f469-1f3fb", 2203], ["1f469-1f3fc", 2204], ["1f469-1f3fd", 2205], ["1f469-1f3fe", 2206], ["1f469-1f3ff", 2207], ["1f468-1f3fb", 2208], ["1f468-1f3fc", 2209], ["1f468-1f3fd", 2210], ["1f468-1f3fe", 2211], ["1f468-1f3ff", 2212], ["1f468-1f3fb", 2213], ["1f468-1f3fc", 2214], ["1f468-1f3fd", 2215], ["1f468-1f3fe", 2216], ["1f468-1f3ff", 2217], ["1f468-1f3fb", 2218], ["1f468-1f3fc", 2219], ["1f468-1f3fd", 2220], ["1f468-1f3fe", 2221], ["1f468-1f3ff", 2222], ["1f468-1f3fb", 2223], ["1f468-1f3fc", 2224], ["1f468-1f3fd", 2225], ["1f468-1f3fe", 2226], ["1f468-1f3ff", 2227], ["1f468-1f3fb", 2228], ["1f468-1f3fc", 2229], ["1f468-1f3fd", 2230], ["1f468-1f3fe", 2231], ["1f468-1f3ff", 2232], ["1f469-1f3fb", 2233], ["1f469-1f3fc", 2234], ["1f469-1f3fd", 2235], ["1f469-1f3fe", 2236], ["1f469-1f3ff", 2237], ["1f469-1f3fb", 2238], ["1f469-1f3fc", 2239], ["1f469-1f3fd", 2240], ["1f469-1f3fe", 2241], ["1f469-1f3ff", 2242], ["1f469-1f3fb", 2243], ["1f469-1f3fc", 2244], ["1f469-1f3fd", 2245], ["1f469-1f3fe", 2246], ["1f469-1f3ff", 2247], ["1f469-1f3fb", 2248], ["1f469-1f3fc", 2249], ["1f469-1f3fd", 2250], ["1f469-1f3fe", 2251], ["1f469-1f3ff", 2252], ["1f469-1f3fb", 2253], ["1f469-1f3fc", 2254], ["1f469-1f3fd", 2255], ["1f469-1f3fe", 2256], ["1f469-1f3ff", 2257], ["1f468-1f3fb", 2258], ["1f468-1f3fc", 2259], ["1f468-1f3fd", 2260], ["1f468-1f3fe", 2261], ["1f468-1f3ff", 2262], ["1f468-1f3fb", 2263], ["1f468-1f3fc", 2264], ["1f468-1f3fd", 2265], ["1f468-1f3fe", 2266], ["1f468-1f3ff", 2267], ["1f468-1f3fb", 2268], ["1f468-1f3fc", 2269], ["1f468-1f3fd", 2270], ["1f468-1f3fe", 2271], ["1f468-1f3ff", 2272], ["1f468-1f3fb", 2273], ["1f468-1f3fc", 2274], ["1f468-1f3fd", 2275], ["1f468-1f3fe", 2276], ["1f468-1f3ff", 2277], ["1f468-1f3fb", 2278], ["1f468-1f3fc", 2279], ["1f468-1f3fd", 2280], ["1f468-1f3fe", 2281], ["1f468-1f3ff", 2282], ["1f469-1f3fb", 2283], ["1f469-1f3fc", 2284], ["1f469-1f3fd", 2285], ["1f469-1f3fe", 2286], ["1f469-1f3ff", 2287], ["1f469-1f3fb", 2288], ["1f469-1f3fc", 2289], ["1f469-1f3fd", 2290], ["1f469-1f3fe", 2291], ["1f469-1f3ff", 2292], ["1f469-1f3fb", 2293], ["1f469-1f3fc", 2294], ["1f469-1f3fd", 2295], ["1f469-1f3fe", 2296], ["1f469-1f3ff", 2297], ["1f469-1f3fb", 2298], ["1f469-1f3fc", 2299], ["1f469-1f3fd", 2300], ["1f469-1f3fe", 2301], ["1f469-1f3ff", 2302], ["1f469-1f3fb", 2303], ["1f469-1f3fc", 2304], ["1f469-1f3fd", 2305], ["1f469-1f3fe", 2306], ["1f469-1f3ff", 2307], ["1f468-1f3fb", 2308], ["1f468-1f3fc", 2309], ["1f468-1f3fd", 2310], ["1f468-1f3fe", 2311], ["1f468-1f3ff", 2312], ["1f468-1f3fb", 2313], ["1f468-1f3fc", 2314], ["1f468-1f3fd", 2315], ["1f468-1f3fe", 2316], ["1f468-1f3ff", 2317], ["1f468-1f3fb", 2318], ["1f468-1f3fc", 2319], ["1f468-1f3fd", 2320], ["1f468-1f3fe", 2321], ["1f468-1f3ff", 2322], ["1f468-1f3fb", 2323], ["1f468-1f3fc", 2324], ["1f468-1f3fd", 2325], ["1f468-1f3fe", 2326], ["1f468-1f3ff", 2327], ["1f468-1f3fb", 2328], ["1f468-1f3fc", 2329], ["1f468-1f3fd", 2330], ["1f468-1f3fe", 2331], ["1f468-1f3ff", 2332], ["1f3cb-1f3fb", 2333], ["1f3cb-1f3fc", 2334], ["1f3cb-1f3fd", 2335], ["1f3cb-1f3fe", 2336], ["1f3cb-1f3ff", 2337], ["1f3cb-1f3fb-200d-2640-fe0f", 2338], ["1f3cb-1f3fc-200d-2640-fe0f", 2339], ["1f3cb-1f3fd-200d-2640-fe0f", 2340], ["1f3cb-1f3fe-200d-2640-fe0f", 2341], ["1f3cb-1f3ff-200d-2640-fe0f", 2342], ["1f3cb-1f3fb", 2343], ["1f3cb-1f3fc", 2344], ["1f3cb-1f3fd", 2345], ["1f3cb-1f3fe", 2346], ["1f3cb-1f3ff", 2347], ["1f3cb-1f3fb-200d-2640-fe0f", 2348], ["1f3cb-1f3fc-200d-2640-fe0f", 2349], ["1f3cb-1f3fd-200d-2640-fe0f", 2350], ["1f3cb-1f3fe-200d-2640-fe0f", 2351], ["1f3cb-1f3ff-200d-2640-fe0f", 2352], ["1f938-1f3fb", 2353], ["1f938-1f3fc", 2354], ["1f938-1f3fd", 2355], ["1f938-1f3fe", 2356], ["1f938-1f3ff", 2357], ["1f938-1f3fb-200d-2640-fe0f", 2358], ["1f938-1f3fc-200d-2640-fe0f", 2359], ["1f938-1f3fd-200d-2640-fe0f", 2360], ["1f938-1f3fe-200d-2640-fe0f", 2361], ["1f938-1f3ff-200d-2640-fe0f", 2362], ["1f938-1f3fb-200d-2642-fe0f", 2363], ["1f938-1f3fc-200d-2642-fe0f", 2364], ["1f938-1f3fd-200d-2642-fe0f", 2365], ["1f938-1f3fe-200d-2642-fe0f", 2366], ["1f938-1f3ff-200d-2642-fe0f", 2367], ["26f9-1f3fb", 2368], ["26f9-1f3fc", 2369], ["26f9-1f3fd", 2370], ["26f9-1f3fe", 2371], ["26f9-1f3ff", 2372], ["26f9-1f3fb-200d-2640-fe0f", 2373], ["26f9-1f3fc-200d-2640-fe0f", 2374], ["26f9-1f3fd-200d-2640-fe0f", 2375], ["26f9-1f3fe-200d-2640-fe0f", 2376], ["26f9-1f3ff-200d-2640-fe0f", 2377], ["26f9-1f3fb", 2378], ["26f9-1f3fc", 2379], ["26f9-1f3fd", 2380], ["26f9-1f3fe", 2381], ["26f9-1f3ff", 2382], ["26f9-1f3fb-200d-2640-fe0f", 2383], ["26f9-1f3fc-200d-2640-fe0f", 2384], ["26f9-1f3fd-200d-2640-fe0f", 2385], ["26f9-1f3fe-200d-2640-fe0f", 2386], ["26f9-1f3ff-200d-2640-fe0f", 2387], ["1f93e-1f3fb", 2388], ["1f93e-1f3fc", 2389], ["1f93e-1f3fd", 2390], ["1f93e-1f3fe", 2391], ["1f93e-1f3ff", 2392], ["1f93e-1f3fb-200d-2640-fe0f", 2393], ["1f93e-1f3fc-200d-2640-fe0f", 2394], ["1f93e-1f3fd-200d-2640-fe0f", 2395], ["1f93e-1f3fe-200d-2640-fe0f", 2396], ["1f93e-1f3ff-200d-2640-fe0f", 2397], ["1f93e-1f3fb-200d-2642-fe0f", 2398], ["1f93e-1f3fc-200d-2642-fe0f", 2399], ["1f93e-1f3fd-200d-2642-fe0f", 2400], ["1f93e-1f3fe-200d-2642-fe0f", 2401], ["1f93e-1f3ff-200d-2642-fe0f", 2402], ["1f3cc-1f3fb", 2403], ["1f3cc-1f3fc", 2404], ["1f3cc-1f3fd", 2405], ["1f3cc-1f3fe", 2406], ["1f3cc-1f3ff", 2407], ["1f3cc-1f3fb-200d-2640-fe0f", 2408], ["1f3cc-1f3fc-200d-2640-fe0f", 2409], ["1f3cc-1f3fd-200d-2640-fe0f", 2410], ["1f3cc-1f3fe-200d-2640-fe0f", 2411], ["1f3cc-1f3ff-200d-2640-fe0f", 2412], ["1f3cc-1f3fb", 2413], ["1f3cc-1f3fc", 2414], ["1f3cc-1f3fd", 2415], ["1f3cc-1f3fe", 2416], ["1f3cc-1f3ff", 2417], ["1f3cc-1f3fb-200d-2640-fe0f", 2418], ["1f3cc-1f3fc-200d-2640-fe0f", 2419], ["1f3cc-1f3fd-200d-2640-fe0f", 2420], ["1f3cc-1f3fe-200d-2640-fe0f", 2421], ["1f3cc-1f3ff-200d-2640-fe0f", 2422], ["1f3c4-1f3fb", 2423], ["1f3c4-1f3fc", 2424], ["1f3c4-1f3fd", 2425], ["1f3c4-1f3fe", 2426], ["1f3c4-1f3ff", 2427], ["1f3c4-1f3fb-200d-2640-fe0f", 2428], ["1f3c4-1f3fc-200d-2640-fe0f", 2429], ["1f3c4-1f3fd-200d-2640-fe0f", 2430], ["1f3c4-1f3fe-200d-2640-fe0f", 2431], ["1f3c4-1f3ff-200d-2640-fe0f", 2432], ["1f3c4-1f3fb", 2433], ["1f3c4-1f3fc", 2434], ["1f3c4-1f3fd", 2435], ["1f3c4-1f3fe", 2436], ["1f3c4-1f3ff", 2437], ["1f3c4-1f3fb-200d-2640-fe0f", 2438], ["1f3c4-1f3fc-200d-2640-fe0f", 2439], ["1f3c4-1f3fd-200d-2640-fe0f", 2440], ["1f3c4-1f3fe-200d-2640-fe0f", 2441], ["1f3c4-1f3ff-200d-2640-fe0f", 2442], ["1f3ca-1f3fb", 2443], ["1f3ca-1f3fc", 2444], ["1f3ca-1f3fd", 2445], ["1f3ca-1f3fe", 2446], ["1f3ca-1f3ff", 2447], ["1f3ca-1f3fb-200d-2640-fe0f", 2448], ["1f3ca-1f3fc-200d-2640-fe0f", 2449], ["1f3ca-1f3fd-200d-2640-fe0f", 2450], ["1f3ca-1f3fe-200d-2640-fe0f", 2451], ["1f3ca-1f3ff-200d-2640-fe0f", 2452], ["1f3ca-1f3fb", 2453], ["1f3ca-1f3fc", 2454], ["1f3ca-1f3fd", 2455], ["1f3ca-1f3fe", 2456], ["1f3ca-1f3ff", 2457], ["1f3ca-1f3fb-200d-2640-fe0f", 2458], ["1f3ca-1f3fc-200d-2640-fe0f", 2459], ["1f3ca-1f3fd-200d-2640-fe0f", 2460], ["1f3ca-1f3fe-200d-2640-fe0f", 2461], ["1f3ca-1f3ff-200d-2640-fe0f", 2462], ["1f93d-1f3fb", 2463], ["1f93d-1f3fc", 2464], ["1f93d-1f3fd", 2465], ["1f93d-1f3fe", 2466], ["1f93d-1f3ff", 2467], ["1f93d-1f3fb-200d-2640-fe0f", 2468], ["1f93d-1f3fc-200d-2640-fe0f", 2469], ["1f93d-1f3fd-200d-2640-fe0f", 2470], ["1f93d-1f3fe-200d-2640-fe0f", 2471], ["1f93d-1f3ff-200d-2640-fe0f", 2472], ["1f93d-1f3fb-200d-2642-fe0f", 2473], ["1f93d-1f3fc-200d-2642-fe0f", 2474], ["1f93d-1f3fd-200d-2642-fe0f", 2475], ["1f93d-1f3fe-200d-2642-fe0f", 2476], ["1f93d-1f3ff-200d-2642-fe0f", 2477], ["1f6a3-1f3fb", 2478], ["1f6a3-1f3fc", 2479], ["1f6a3-1f3fd", 2480], ["1f6a3-1f3fe", 2481], ["1f6a3-1f3ff", 2482], ["1f6a3-1f3fb-200d-2640-fe0f", 2483], ["1f6a3-1f3fc-200d-2640-fe0f", 2484], ["1f6a3-1f3fd-200d-2640-fe0f", 2485], ["1f6a3-1f3fe-200d-2640-fe0f", 2486], ["1f6a3-1f3ff-200d-2640-fe0f", 2487], ["1f6a3-1f3fb", 2488], ["1f6a3-1f3fc", 2489], ["1f6a3-1f3fd", 2490], ["1f6a3-1f3fe", 2491], ["1f6a3-1f3ff", 2492], ["1f6a3-1f3fb-200d-2640-fe0f", 2493], ["1f6a3-1f3fc-200d-2640-fe0f", 2494], ["1f6a3-1f3fd-200d-2640-fe0f", 2495], ["1f6a3-1f3fe-200d-2640-fe0f", 2496], ["1f6a3-1f3ff-200d-2640-fe0f", 2497], ["1f3c7-1f3fb", 2498], ["1f3c7-1f3fc", 2499], ["1f3c7-1f3fd", 2500], ["1f3c7-1f3fe", 2501], ["1f3c7-1f3ff", 2502], ["1f6b4-1f3fb", 2503], ["1f6b4-1f3fc", 2504], ["1f6b4-1f3fd", 2505], ["1f6b4-1f3fe", 2506], ["1f6b4-1f3ff", 2507], ["1f6b4-1f3fb-200d-2640-fe0f", 2508], ["1f6b4-1f3fc-200d-2640-fe0f", 2509], ["1f6b4-1f3fd-200d-2640-fe0f", 2510], ["1f6b4-1f3fe-200d-2640-fe0f", 2511], ["1f6b4-1f3ff-200d-2640-fe0f", 2512], ["1f6b4-1f3fb", 2513], ["1f6b4-1f3fc", 2514], ["1f6b4-1f3fd", 2515], ["1f6b4-1f3fe", 2516], ["1f6b4-1f3ff", 2517], ["1f6b4-1f3fb-200d-2640-fe0f", 2518], ["1f6b4-1f3fc-200d-2640-fe0f", 2519], ["1f6b4-1f3fd-200d-2640-fe0f", 2520], ["1f6b4-1f3fe-200d-2640-fe0f", 2521], ["1f6b4-1f3ff-200d-2640-fe0f", 2522], ["1f6b5-1f3fb", 2523], ["1f6b5-1f3fc", 2524], ["1f6b5-1f3fd", 2525], ["1f6b5-1f3fe", 2526], ["1f6b5-1f3ff", 2527], ["1f6b5-1f3fb-200d-2640-fe0f", 2528], ["1f6b5-1f3fc-200d-2640-fe0f", 2529], ["1f6b5-1f3fd-200d-2640-fe0f", 2530], ["1f6b5-1f3fe-200d-2640-fe0f", 2531], ["1f6b5-1f3ff-200d-2640-fe0f", 2532], ["1f6b5-1f3fb", 2533], ["1f6b5-1f3fc", 2534], ["1f6b5-1f3fd", 2535], ["1f6b5-1f3fe", 2536], ["1f6b5-1f3ff", 2537], ["1f6b5-1f3fb-200d-2640-fe0f", 2538], ["1f6b5-1f3fc-200d-2640-fe0f", 2539], ["1f6b5-1f3fd-200d-2640-fe0f", 2540], ["1f6b5-1f3fe-200d-2640-fe0f", 2541], ["1f6b5-1f3ff-200d-2640-fe0f", 2542], ["1f939-1f3fb", 2543], ["1f939-1f3fc", 2544], ["1f939-1f3fd", 2545], ["1f939-1f3fe", 2546], ["1f939-1f3ff", 2547], ["1f939-1f3fb-200d-2640-fe0f", 2548], ["1f939-1f3fc-200d-2640-fe0f", 2549], ["1f939-1f3fd-200d-2640-fe0f", 2550], ["1f939-1f3fe-200d-2640-fe0f", 2551], ["1f939-1f3ff-200d-2640-fe0f", 2552], ["1f939-1f3fb-200d-2642-fe0f", 2553], ["1f939-1f3fc-200d-2642-fe0f", 2554], ["1f939-1f3fd-200d-2642-fe0f", 2555], ["1f939-1f3fe-200d-2642-fe0f", 2556], ["1f939-1f3ff-200d-2642-fe0f", 2557], ["1f6c0-1f3fb", 2558], ["1f6c0-1f3fc", 2559], ["1f6c0-1f3fd", 2560], ["1f6c0-1f3fe", 2561], ["1f6c0-1f3ff", 2562]]);

var CategoryNames = exports.CategoryNames = ["people", "nature", "foods", "activity", "places", "objects", "symbols", "flags", "custom", "skintone"];

var EmojiIndicesByCategory = exports.EmojiIndicesByCategory = new _map2.default([["people", [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290]], ["nature", [291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449]], ["foods", [450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478, 479, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493, 494, 495, 496, 497, 498, 499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534, 535]], ["activity", [536, 537, 538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 562, 563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573, 574, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 589, 590, 591, 592, 593, 594, 595, 596, 597, 598, 599, 600, 601, 602, 603, 604, 605, 606, 607, 608, 609, 610, 611, 612, 613, 614, 615]], ["places", [616, 617, 618, 619, 620, 621, 622, 623, 624, 625, 626, 627, 628, 629, 630, 631, 632, 633, 634, 635, 636, 637, 638, 639, 640, 641, 642, 643, 644, 645, 646, 647, 648, 649, 650, 651, 652, 653, 654, 655, 656, 657, 658, 659, 660, 661, 662, 663, 664, 665, 666, 667, 668, 669, 670, 671, 672, 673, 674, 675, 676, 677, 678, 679, 680, 681, 682, 683, 684, 685, 686, 687, 688, 689, 690, 691, 692, 693, 694, 695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 705, 706, 707, 708, 709, 710, 711, 712, 713, 714, 715, 716, 717, 718, 719, 720, 721, 722, 723, 724, 725, 726, 727, 728, 729, 730, 731, 732, 733, 734]], ["objects", [735, 736, 737, 738, 739, 740, 741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 752, 753, 754, 755, 756, 757, 758, 759, 760, 761, 762, 763, 764, 765, 766, 767, 768, 769, 770, 771, 772, 773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787, 788, 789, 790, 791, 792, 793, 794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 815, 816, 817, 818, 819, 820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 832, 833, 834, 835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 848, 849, 850, 851, 852, 853, 854, 855, 856, 857, 858, 859, 860, 861, 862, 863, 864, 865, 866, 867, 868, 869, 870, 871, 872, 873, 874, 875, 876, 877, 878, 879, 880, 881, 882, 883, 884, 885, 886, 887, 888, 889, 890, 891, 892, 893, 894, 895, 896, 897, 898, 899, 900, 901, 902, 903, 904, 905, 906, 907]], ["symbols", [908, 909, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 930, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 975, 976, 977, 978, 979, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992, 993, 994, 995, 996, 997, 998, 999, 1000, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1120, 1121, 1122, 1123, 1124, 1125, 1126, 1127, 1128, 1129, 1130, 1131, 1132, 1133, 1134, 1135, 1136, 1137, 1138, 1139, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150, 1151, 1152, 1153, 1154, 1155, 1156, 1157, 1158, 1159, 1160, 1161, 1162, 1163, 1164, 1165, 1166, 1167, 1168, 1169, 1170, 1171, 1172, 1173, 1174, 1175, 1176, 1177, 1178]], ["flags", [1179, 1180, 1181, 1182, 1183, 1184, 1185, 1186, 1187, 1188, 1189, 1190, 1191, 1192, 1193, 1194, 1195, 1196, 1197, 1198, 1199, 1200, 1201, 1202, 1203, 1204, 1205, 1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216, 1217, 1218, 1219, 1220, 1221, 1222, 1223, 1224, 1225, 1226, 1227, 1228, 1229, 1230, 1231, 1232, 1233, 1234, 1235, 1236, 1237, 1238, 1239, 1240, 1241, 1242, 1243, 1244, 1245, 1246, 1247, 1248, 1249, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1259, 1260, 1261, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1270, 1271, 1272, 1273, 1274, 1275, 1276, 1277, 1278, 1279, 1280, 1281, 1282, 1283, 1284, 1285, 1286, 1287, 1288, 1289, 1290, 1291, 1292, 1293, 1294, 1295, 1296, 1297, 1298, 1299, 1300, 1301, 1302, 1303, 1304, 1305, 1306, 1307, 1308, 1309, 1310, 1311, 1312, 1313, 1314, 1315, 1316, 1317, 1318, 1319, 1320, 1321, 1322, 1323, 1324, 1325, 1326, 1327, 1328, 1329, 1330, 1331, 1332, 1333, 1334, 1335, 1336, 1337, 1338, 1339, 1340, 1341, 1342, 1343, 1344, 1345, 1346, 1347, 1348, 1349, 1350, 1351, 1352, 1353, 1354, 1355, 1356, 1357, 1358, 1359, 1360, 1361, 1362, 1363, 1364, 1365, 1366, 1367, 1368, 1369, 1370, 1371, 1372, 1373, 1374, 1375, 1376, 1377, 1378, 1379, 1380, 1381, 1382, 1383, 1384, 1385, 1386, 1387, 1388, 1389, 1390, 1391, 1392, 1393, 1394, 1395, 1396, 1397, 1398, 1399, 1400, 1401, 1402, 1403, 1404, 1405, 1406, 1407, 1408, 1409, 1410, 1411, 1412, 1413, 1414, 1415, 1416, 1417, 1418, 1419, 1420, 1421, 1422, 1423, 1424, 1425, 1426, 1427, 1428, 1429, 1430, 1431]], ["custom", [1432, 1433, 1434, 1435, 1436, 1437, 1438, 1439, 1440, 1441, 1442, 1443, 1444, 1445, 1446, 1447]], ["skintone", [1448, 1449, 1450, 1451, 1452, 1453, 1454, 1455, 1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1466, 1467, 1468, 1469, 1470, 1471, 1472, 1473, 1474, 1475, 1476, 1477, 1478, 1479, 1480, 1481, 1482, 1483, 1484, 1485, 1486, 1487, 1488, 1489, 1490, 1491, 1492, 1493, 1494, 1495, 1496, 1497, 1498, 1499, 1500, 1501, 1502, 1503, 1504, 1505, 1506, 1507, 1508, 1509, 1510, 1511, 1512, 1513, 1514, 1515, 1516, 1517, 1518, 1519, 1520, 1521, 1522, 1523, 1524, 1525, 1526, 1527, 1528, 1529, 1530, 1531, 1532, 1533, 1534, 1535, 1536, 1537, 1538, 1539, 1540, 1541, 1542, 1543, 1544, 1545, 1546, 1547, 1548, 1549, 1550, 1551, 1552, 1553, 1554, 1555, 1556, 1557, 1558, 1559, 1560, 1561, 1562, 1563, 1564, 1565, 1566, 1567, 1568, 1569, 1570, 1571, 1572, 1573, 1574, 1575, 1576, 1577, 1578, 1579, 1580, 1581, 1582, 1583, 1584, 1585, 1586, 1587, 1588, 1589, 1590, 1591, 1592, 1593, 1594, 1595, 1596, 1597, 1598, 1599, 1600, 1601, 1602, 1603, 1604, 1605, 1606, 1607, 1608, 1609, 1610, 1611, 1612, 1613, 1614, 1615, 1616, 1617, 1618, 1619, 1620, 1621, 1622, 1623, 1624, 1625, 1626, 1627, 1628, 1629, 1630, 1631, 1632, 1633, 1634, 1635, 1636, 1637, 1638, 1639, 1640, 1641, 1642, 1643, 1644, 1645, 1646, 1647, 1648, 1649, 1650, 1651, 1652, 1653, 1654, 1655, 1656, 1657, 1658, 1659, 1660, 1661, 1662, 1663, 1664, 1665, 1666, 1667, 1668, 1669, 1670, 1671, 1672, 1673, 1674, 1675, 1676, 1677, 1678, 1679, 1680, 1681, 1682, 1683, 1684, 1685, 1686, 1687, 1688, 1689, 1690, 1691, 1692, 1693, 1694, 1695, 1696, 1697, 1698, 1699, 1700, 1701, 1702, 1703, 1704, 1705, 1706, 1707, 1708, 1709, 1710, 1711, 1712, 1713, 1714, 1715, 1716, 1717, 1718, 1719, 1720, 1721, 1722, 1723, 1724, 1725, 1726, 1727, 1728, 1729, 1730, 1731, 1732, 1733, 1734, 1735, 1736, 1737, 1738, 1739, 1740, 1741, 1742, 1743, 1744, 1745, 1746, 1747, 1748, 1749, 1750, 1751, 1752, 1753, 1754, 1755, 1756, 1757, 1758, 1759, 1760, 1761, 1762, 1763, 1764, 1765, 1766, 1767, 1768, 1769, 1770, 1771, 1772, 1773, 1774, 1775, 1776, 1777, 1778, 1779, 1780, 1781, 1782, 1783, 1784, 1785, 1786, 1787, 1788, 1789, 1790, 1791, 1792, 1793, 1794, 1795, 1796, 1797, 1798, 1799, 1800, 1801, 1802, 1803, 1804, 1805, 1806, 1807, 1808, 1809, 1810, 1811, 1812, 1813, 1814, 1815, 1816, 1817, 1818, 1819, 1820, 1821, 1822, 1823, 1824, 1825, 1826, 1827, 1828, 1829, 1830, 1831, 1832, 1833, 1834, 1835, 1836, 1837, 1838, 1839, 1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850, 1851, 1852, 1853, 1854, 1855, 1856, 1857, 1858, 1859, 1860, 1861, 1862, 1863, 1864, 1865, 1866, 1867, 1868, 1869, 1870, 1871, 1872, 1873, 1874, 1875, 1876, 1877, 1878, 1879, 1880, 1881, 1882, 1883, 1884, 1885, 1886, 1887, 1888, 1889, 1890, 1891, 1892, 1893, 1894, 1895, 1896, 1897, 1898, 1899, 1900, 1901, 1902, 1903, 1904, 1905, 1906, 1907, 1908, 1909, 1910, 1911, 1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921, 1922, 1923, 1924, 1925, 1926, 1927, 1928, 1929, 1930, 1931, 1932, 1933, 1934, 1935, 1936, 1937, 1938, 1939, 1940, 1941, 1942, 1943, 1944, 1945, 1946, 1947, 1948, 1949, 1950, 1951, 1952, 1953, 1954, 1955, 1956, 1957, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056, 2057, 2058, 2059, 2060, 2061, 2062, 2063, 2064, 2065, 2066, 2067, 2068, 2069, 2070, 2071, 2072, 2073, 2074, 2075, 2076, 2077, 2078, 2079, 2080, 2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088, 2089, 2090, 2091, 2092, 2093, 2094, 2095, 2096, 2097, 2098, 2099, 2100, 2101, 2102, 2103, 2104, 2105, 2106, 2107, 2108, 2109, 2110, 2111, 2112, 2113, 2114, 2115, 2116, 2117, 2118, 2119, 2120, 2121, 2122, 2123, 2124, 2125, 2126, 2127, 2128, 2129, 2130, 2131, 2132, 2133, 2134, 2135, 2136, 2137, 2138, 2139, 2140, 2141, 2142, 2143, 2144, 2145, 2146, 2147, 2148, 2149, 2150, 2151, 2152, 2153, 2154, 2155, 2156, 2157, 2158, 2159, 2160, 2161, 2162, 2163, 2164, 2165, 2166, 2167, 2168, 2169, 2170, 2171, 2172, 2173, 2174, 2175, 2176, 2177, 2178, 2179, 2180, 2181, 2182, 2183, 2184, 2185, 2186, 2187, 2188, 2189, 2190, 2191, 2192, 2193, 2194, 2195, 2196, 2197, 2198, 2199, 2200, 2201, 2202, 2203, 2204, 2205, 2206, 2207, 2208, 2209, 2210, 2211, 2212, 2213, 2214, 2215, 2216, 2217, 2218, 2219, 2220, 2221, 2222, 2223, 2224, 2225, 2226, 2227, 2228, 2229, 2230, 2231, 2232, 2233, 2234, 2235, 2236, 2237, 2238, 2239, 2240, 2241, 2242, 2243, 2244, 2245, 2246, 2247, 2248, 2249, 2250, 2251, 2252, 2253, 2254, 2255, 2256, 2257, 2258, 2259, 2260, 2261, 2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272, 2273, 2274, 2275, 2276, 2277, 2278, 2279, 2280, 2281, 2282, 2283, 2284, 2285, 2286, 2287, 2288, 2289, 2290, 2291, 2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2300, 2301, 2302, 2303, 2304, 2305, 2306, 2307, 2308, 2309, 2310, 2311, 2312, 2313, 2314, 2315, 2316, 2317, 2318, 2319, 2320, 2321, 2322, 2323, 2324, 2325, 2326, 2327, 2328, 2329, 2330, 2331, 2332, 2333, 2334, 2335, 2336, 2337, 2338, 2339, 2340, 2341, 2342, 2343, 2344, 2345, 2346, 2347, 2348, 2349, 2350, 2351, 2352, 2353, 2354, 2355, 2356, 2357, 2358, 2359, 2360, 2361, 2362, 2363, 2364, 2365, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2384, 2385, 2386, 2387, 2388, 2389, 2390, 2391, 2392, 2393, 2394, 2395, 2396, 2397, 2398, 2399, 2400, 2401, 2402, 2403, 2404, 2405, 2406, 2407, 2408, 2409, 2410, 2411, 2412, 2413, 2414, 2415, 2416, 2417, 2418, 2419, 2420, 2421, 2422, 2423, 2424, 2425, 2426, 2427, 2428, 2429, 2430, 2431, 2432, 2433, 2434, 2435, 2436, 2437, 2438, 2439, 2440, 2441, 2442, 2443, 2444, 2445, 2446, 2447, 2448, 2449, 2450, 2451, 2452, 2453, 2454, 2455, 2456, 2457, 2458, 2459, 2460, 2461, 2462, 2463, 2464, 2465, 2466, 2467, 2468, 2469, 2470, 2471, 2472, 2473, 2474, 2475, 2476, 2477, 2478, 2479, 2480, 2481, 2482, 2483, 2484, 2485, 2486, 2487, 2488, 2489, 2490, 2491, 2492, 2493, 2494, 2495, 2496, 2497, 2498, 2499, 2500, 2501, 2502, 2503, 2504, 2505, 2506, 2507, 2508, 2509, 2510, 2511, 2512, 2513, 2514, 2515, 2516, 2517, 2518, 2519, 2520, 2521, 2522, 2523, 2524, 2525, 2526, 2527, 2528, 2529, 2530, 2531, 2532, 2533, 2534, 2535, 2536, 2537, 2538, 2539, 2540, 2541, 2542, 2543, 2544, 2545, 2546, 2547, 2548, 2549, 2550, 2551, 2552, 2553, 2554, 2555, 2556, 2557, 2558, 2559, 2560, 2561, 2562]]]);

/* eslint-enable */

/***/ }),
/* 948 */
/***/ (function(module, exports) {

function _isPlaceholder(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = _isPlaceholder;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(949);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(949);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

exports.loadStatusesForChannel = loadStatusesForChannel;
exports.loadStatusesForDMSidebar = loadStatusesForDMSidebar;
exports.loadStatusesForChannelAndSidebar = loadStatusesForChannelAndSidebar;
exports.loadStatusesForProfilesList = loadStatusesForProfilesList;
exports.loadStatusesForProfilesMap = loadStatusesForProfilesMap;
exports.loadStatusesByIds = loadStatusesByIds;
exports.startPeriodicStatusUpdates = startPeriodicStatusUpdates;
exports.stopPeriodicStatusUpdates = stopPeriodicStatusUpdates;

var _users = __webpack_require__(786);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _post_store = __webpack_require__(956);

var _post_store2 = _interopRequireDefault(_post_store);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

function loadStatusesForChannel() {
    var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();

    var postList = _post_store2.default.getVisiblePosts(channelId);
    if (!postList || !postList.posts) {
        return;
    }

    var statuses = _user_store2.default.getStatuses();
    var statusesToLoad = {};
    for (var pid in postList.posts) {
        if (!postList.posts.hasOwnProperty(pid)) {
            continue;
        }

        var post = postList.posts[pid];
        if (statuses[post.user_id] == null) {
            statusesToLoad[post.user_id] = true;
        }
    }

    loadStatusesByIds((0, _keys2.default)(statusesToLoad));
}

function loadStatusesForDMSidebar() {
    var dmPrefs = _preference_store2.default.getCategory(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);
    var statusesToLoad = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(dmPrefs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                key = _step$value[0],
                value = _step$value[1];

            if (value === 'true') {
                statusesToLoad.push(key);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    loadStatusesByIds(statusesToLoad);
}

function loadStatusesForChannelAndSidebar() {
    var statusesToLoad = {};

    var channelId = _channel_store2.default.getCurrentId();
    var posts = _post_store2.default.getVisiblePosts(channelId) || [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = (0, _getIterator3.default)(posts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var post = _step2.value;

            statusesToLoad[post.user_id] = true;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var dmPrefs = _preference_store2.default.getCategory(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = (0, _getIterator3.default)(dmPrefs), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
                key = _step3$value[0],
                value = _step3$value[1];

            if (value === 'true') {
                statusesToLoad[key] = true;
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    var currentUserId = getState().entities.users.currentUserId;

    statusesToLoad[currentUserId] = true;

    loadStatusesByIds((0, _keys2.default)(statusesToLoad));
}

function loadStatusesForProfilesList(users) {
    if (users == null) {
        return;
    }

    var statusesToLoad = [];
    for (var i = 0; i < users.length; i++) {
        statusesToLoad.push(users[i].id);
    }

    loadStatusesByIds(statusesToLoad);
}

function loadStatusesForProfilesMap(users) {
    if (users == null) {
        return;
    }

    var statusesToLoad = [];
    for (var userId in users) {
        if (!users.hasOwnProperty(userId)) {
            return;
        }
        statusesToLoad.push(userId);
    }

    loadStatusesByIds(statusesToLoad);
}

function loadStatusesByIds(userIds) {
    if (userIds.length === 0) {
        return;
    }

    (0, _users.getStatusesByIds)(userIds)(dispatch, getState);
}

var intervalId = '';

function startPeriodicStatusUpdates() {
    clearInterval(intervalId);

    intervalId = setInterval(function () {
        loadStatusesForChannelAndSidebar();
    }, _constants.Constants.STATUS_INTERVAL);
}

function stopPeriodicStatusUpdates() {
    clearInterval(intervalId);
}

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _posts = __webpack_require__(805);

var Selectors = _interopRequireWildcard(_posts);

var _action_types = __webpack_require__(3);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants.Constants.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var FOCUSED_POST_CHANGE = 'focused_post_change';
var POST_PINNED_CHANGE_EVENT = 'post_pinned_change';

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

var PostStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(PostStoreClass, _EventEmitter);

    function PostStoreClass() {
        (0, _classCallCheck3.default)(this, PostStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostStoreClass.__proto__ || (0, _getPrototypeOf2.default)(PostStoreClass)).call(this));

        _this.selectedPostId = null;
        _this.currentFocusedPostId = null;
        return _this;
    }

    (0, _createClass3.default)(PostStoreClass, [{
        key: 'emitPostFocused',
        value: function emitPostFocused() {
            this.emit(FOCUSED_POST_CHANGE);
        }
    }, {
        key: 'addPostFocusedListener',
        value: function addPostFocusedListener(callback) {
            this.on(FOCUSED_POST_CHANGE, callback);
        }
    }, {
        key: 'removePostFocusedListener',
        value: function removePostFocusedListener(callback) {
            this.removeListener(FOCUSED_POST_CHANGE, callback);
        }
    }, {
        key: 'emitPostPinnedChange',
        value: function emitPostPinnedChange() {
            this.emit(POST_PINNED_CHANGE_EVENT);
        }
    }, {
        key: 'addPostPinnedChangeListener',
        value: function addPostPinnedChangeListener(callback) {
            this.on(POST_PINNED_CHANGE_EVENT, callback);
        }
    }, {
        key: 'removePostPinnedChangeListener',
        value: function removePostPinnedChangeListener(callback) {
            this.removeListener(POST_PINNED_CHANGE_EVENT, callback);
        }
    }, {
        key: 'getMostRecentPostIdInChannel',
        value: function getMostRecentPostIdInChannel(channelId) {
            return Selectors.getMostRecentPostIdInChannel(getState(), channelId);
        }
    }, {
        key: 'getVisiblePosts',
        value: function getVisiblePosts() {
            var posts = Selectors.getPostsInCurrentChannel(getState());
            var currentChannelId = getState().entities.channels.currentChannelId;
            return posts.slice(0, getState().views.channel.postVisibility[currentChannelId]);
        }
    }, {
        key: 'getFocusedPostId',
        value: function getFocusedPostId() {
            return this.currentFocusedPostId;
        }
    }, {
        key: 'storeFocusedPostId',
        value: function storeFocusedPostId(postId) {
            this.currentFocusedPostId = postId;
        }
    }, {
        key: 'clearFocusedPost',
        value: function clearFocusedPost() {
            this.currentFocusedPostId = null;
        }
    }, {
        key: 'getCurrentUsersLatestPost',
        value: function getCurrentUsersLatestPost(channelId, rootId) {
            var userId = _user_store2.default.getCurrentId();

            var postIds = getState().entities.posts.postsInChannel[channelId] || [];

            var lastPost = null;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(postIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var id = _step.value;

                    var post = Selectors.getPost(getState(), id) || {};

                    // don't edit webhook posts, deleted posts, or system messages
                    if (post.user_id !== userId || post.props && post.props.from_webhook || post.state === _constants.Constants.POST_DELETED || post.type && post.type.startsWith(_constants.Constants.SYSTEM_MESSAGE_PREFIX)) {
                        continue;
                    }

                    if (rootId) {
                        if (post.root_id === rootId || post.id === rootId) {
                            lastPost = post;
                            break;
                        }
                    } else {
                        lastPost = post;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return lastPost;
        }
    }, {
        key: 'normalizeDraft',
        value: function normalizeDraft(originalDraft) {
            var draft = {
                message: '',
                uploadsInProgress: [],
                fileInfos: []
            };

            // Make sure that the post draft is non-null and has all the required fields
            if (originalDraft) {
                draft = {
                    message: originalDraft.message || draft.message,
                    uploadsInProgress: originalDraft.uploadsInProgress || draft.uploadsInProgress,
                    fileInfos: originalDraft.fileInfos || draft.fileInfos
                };
            }

            return draft;
        }
    }, {
        key: 'storeCurrentDraft',
        value: function storeCurrentDraft(draft) {
            var channelId = _channel_store2.default.getCurrentId();
            _browser_store2.default.setGlobalItem('draft_' + channelId, draft);
        }
    }, {
        key: 'getCurrentDraft',
        value: function getCurrentDraft() {
            var channelId = _channel_store2.default.getCurrentId();
            return this.getDraft(channelId);
        }
    }, {
        key: 'storeDraft',
        value: function storeDraft(channelId, draft) {
            _browser_store2.default.setGlobalItem('draft_' + channelId, draft);
        }
    }, {
        key: 'getDraft',
        value: function getDraft(channelId) {
            // deep clone because many components need to modify the draft
            return JSON.parse((0, _stringify2.default)(this.normalizeDraft(_browser_store2.default.getGlobalItem('draft_' + channelId))));
        }
    }, {
        key: 'storeCommentDraft',
        value: function storeCommentDraft(parentPostId, draft) {
            _browser_store2.default.setGlobalItem('comment_draft_' + parentPostId, draft);
        }
    }, {
        key: 'getCommentDraft',
        value: function getCommentDraft(parentPostId) {
            // deep clone because many components need to modify the draft
            return JSON.parse((0, _stringify2.default)(this.normalizeDraft(_browser_store2.default.getGlobalItem('comment_draft_' + parentPostId))));
        }
    }, {
        key: 'clearDraftUploads',
        value: function clearDraftUploads() {
            _browser_store2.default.actionOnGlobalItemsWithPrefix('draft_', function (key, value) {
                if (value) {
                    return (0, _extends3.default)({}, value, { uploadsInProgress: [] });
                }
                return value;
            });
        }
    }, {
        key: 'clearCommentDraftUploads',
        value: function clearCommentDraftUploads() {
            _browser_store2.default.actionOnGlobalItemsWithPrefix('comment_draft_', function (key, value) {
                if (value) {
                    return (0, _extends3.default)({}, value, { uploadsInProgress: [] });
                }
                return value;
            });
        }
    }, {
        key: 'getCommentCount',
        value: function getCommentCount(rootPost) {
            var postIds = getState().entities.posts.postsInChannel[rootPost.channel_id] || [];

            var commentCount = 0;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(postIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var postId = _step2.value;

                    var post = Selectors.getPost(getState(), postId) || {};
                    if (post.root_id === rootPost.id) {
                        commentCount += 1;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return commentCount;
        }
    }]);
    return PostStoreClass;
}(_events2.default);

var PostStore = new PostStoreClass();

PostStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case ActionTypes.RECEIVED_FOCUSED_POST:
            PostStore.storeFocusedPostId(action.postId);
            PostStore.emitPostFocused();
            break;
        case ActionTypes.CLICK_CHANNEL:
            PostStore.clearFocusedPost();
            break;
        case ActionTypes.RECEIVED_EDIT_POST:
            dispatch((0, _extends3.default)({}, action, { type: ActionTypes.EDIT_POST }));
            break;
        case ActionTypes.RECEIVED_POST_SELECTED:
            dispatch({ data: action.postId, type: _action_types.PostTypes.RECEIVED_POST_SELECTED });
            dispatch((0, _extends3.default)({}, action, { type: ActionTypes.SELECT_POST }));
            break;
        case ActionTypes.RECEIVED_POST_PINNED:
        case ActionTypes.RECEIVED_POST_UNPINNED:
            PostStore.emitPostPinnedChange();
            break;
        default:
    }
});

exports.default = PostStore;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getItemFromStorage = exports.makeGetGlobalItem = exports.makeGetItem = exports.getGlobalItem = undefined;

var _storage_utils = __webpack_require__(303);

var getGlobalItem = exports.getGlobalItem = function getGlobalItem(state, name, defaultValue) {
    var storage = state && state.storage && state.storage.storage;

    return getItemFromStorage(storage, name, defaultValue);
}; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var makeGetItem = exports.makeGetItem = function makeGetItem(name, defaultValue) {
    return function (state) {
        return getGlobalItem(state, (0, _storage_utils.getPrefix)(state) + name, defaultValue);
    };
};

var makeGetGlobalItem = exports.makeGetGlobalItem = function makeGetGlobalItem(name, defaultValue) {
    return function (state) {
        return getGlobalItem(state, name, defaultValue);
    };
};

var getItemFromStorage = exports.getItemFromStorage = function getItemFromStorage(storage, name, defaultValue) {
    if (storage && typeof storage[name] !== 'undefined' && storage[name] !== null && typeof storage[name].value !== 'undefined' && storage[name].value !== null) {
        return storage[name].value;
    }

    return defaultValue;
};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.close = exports.open = exports.toggle = undefined;

var _constants = __webpack_require__(29);

var toggle = exports.toggle = function toggle() {
    return function (dispatch) {
        return dispatch({
            type: _constants.ActionTypes.TOGGLE_LHS
        });
    };
}; // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var open = exports.open = function open() {
    return function (dispatch) {
        return dispatch({
            type: _constants.ActionTypes.OPEN_LHS
        });
    };
};

var close = exports.close = function close() {
    return function (dispatch) {
        return dispatch({
            type: _constants.ActionTypes.CLOSE_LHS
        });
    };
};

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _websocket_client = __webpack_require__(1766);

var _websocket_client2 = _interopRequireDefault(_websocket_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebClient = new _websocket_client2.default(); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = WebClient;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterAndSortTeamsByDisplayName = filterAndSortTeamsByDisplayName;

var _localization_store = __webpack_require__(906);

var _localization_store2 = _interopRequireDefault(_localization_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Use when sorting multiple teams by their `display_name` field
function sortTeamsByDisplayName(a, b) {
    var locale = _localization_store2.default.getLocale();

    if (a.display_name !== b.display_name) {
        return a.display_name.localeCompare(b.display_name, locale, { numeric: true });
    }

    return a.name.localeCompare(b.name, locale, { numeric: true });
}

// Use to filter out teams that are deleted and without display_name, then sort by their `display_name` field
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function filterAndSortTeamsByDisplayName() {
    var teams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (!teams) {
        return [];
    }

    return teams.filter(function (team) {
        return team && !team.delete_at > 0 && team.display_name != null;
    }).sort(sortTeamsByDisplayName);
}

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEmojiMap = undefined;

var _reselect = __webpack_require__(78);

var _emojis = __webpack_require__(877);

var _emoji_store = __webpack_require__(829);

var getEmojiMap = exports.getEmojiMap = (0, _reselect.createSelector)(_emojis.getCustomEmojisByName, function (customEmojisByName) {
    return new _emoji_store.EmojiMap(customEmojisByName);
}); // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSupportedTimezones = getSupportedTimezones;
exports.getBrowserTimezone = getBrowserTimezone;

var _general = __webpack_require__(113);

var _momentTimezone = __webpack_require__(1883);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSupportedTimezones() {
    return (0, _general.getSupportedTimezones)(_redux_store2.default.getState());
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getBrowserTimezone() {
    return _momentTimezone2.default.tz.guess();
}

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNavigationBlocked = getNavigationBlocked;
exports.showNavigationPrompt = showNavigationPrompt;
exports.getOnNavigationConfirmed = getOnNavigationConfirmed;
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getNavigationBlocked(state) {
    return state.views.admin.navigationBlock.blocked;
}

function showNavigationPrompt(state) {
    return state.views.admin.navigationBlock.showNavigationPrompt;
}

function getOnNavigationConfirmed(state) {
    return state.views.admin.navigationBlock.onNavigationConfirmed;
}

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'change';

var AnalyticsStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(AnalyticsStoreClass, _EventEmitter);

    function AnalyticsStoreClass() {
        (0, _classCallCheck3.default)(this, AnalyticsStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsStoreClass.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsStoreClass)).call(this));

        _this.entities = {};

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.admin;

            var entities = _this.entities;
            _this.entities = newEntities;

            var analyticsChanged = newEntities.analytics !== entities.analytics;
            var teamAnalyticsChanged = newEntities.teamAnalytics !== entities.teamAnalytics;

            if (analyticsChanged || teamAnalyticsChanged) {
                _this.emitChange();
            }
        });
        return _this;
    }

    (0, _createClass3.default)(AnalyticsStoreClass, [{
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'getAllSystem',
        value: function getAllSystem() {
            return JSON.parse((0, _stringify2.default)(_redux_store2.default.getState().entities.admin.analytics));
        }
    }, {
        key: 'getAllTeam',
        value: function getAllTeam(id) {
            var teamStats = _redux_store2.default.getState().entities.admin.teamAnalytics[id];
            if (teamStats) {
                return JSON.parse((0, _stringify2.default)(teamStats));
            }

            return {};
        }
    }]);
    return AnalyticsStoreClass;
}(_events2.default);

var AnalyticsStore = new AnalyticsStoreClass();
exports.default = AnalyticsStore;

/***/ }),
/* 965 */,
/* 966 */,
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(884),
    isObjectLike = __webpack_require__(885);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _autosize_textarea = __webpack_require__(1964);

var _autosize_textarea2 = _interopRequireDefault(_autosize_textarea);

var _post_markdown = __webpack_require__(1312);

var _post_markdown2 = _interopRequireDefault(_post_markdown);

var _at_mention_provider = __webpack_require__(1969);

var _at_mention_provider2 = _interopRequireDefault(_at_mention_provider);

var _channel_mention_provider = __webpack_require__(1970);

var _channel_mention_provider2 = _interopRequireDefault(_channel_mention_provider);

var _command_provider = __webpack_require__(1971);

var _command_provider2 = _interopRequireDefault(_command_provider);

var _emoticon_provider = __webpack_require__(1977);

var _emoticon_provider2 = _interopRequireDefault(_emoticon_provider);

var _suggestion_box = __webpack_require__(929);

var _suggestion_box2 = _interopRequireDefault(_suggestion_box);

var _suggestion_list = __webpack_require__(930);

var _suggestion_list2 = _interopRequireDefault(_suggestion_list);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreReleaseFeatures = _constants2.default.PRE_RELEASE_FEATURES; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Textbox = function (_React$Component) {
    (0, _inherits3.default)(Textbox, _React$Component);

    function Textbox(props) {
        (0, _classCallCheck3.default)(this, Textbox);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Textbox.__proto__ || (0, _getPrototypeOf2.default)(Textbox)).call(this, props));

        _this.onReceivedError = function () {
            var errorCount = _error_store2.default.getConnectionErrorCount();

            if (errorCount > 1) {
                _this.setState({ connection: 'bad-connection' });
            } else {
                _this.setState({ connection: '' });
            }
        };

        _this.handleChange = function (e) {
            _this.checkMessageLength(e.target.value);
            _this.props.onChange(e);
        };

        _this.checkMessageLength = function (message) {
            if (_this.props.handlePostError) {
                if (message.length > _this.props.characterLimit) {
                    var errorMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'create_post.error_message',
                        defaultMessage: 'Your message is too long. Character count: {length}/{limit}',
                        values: {
                            length: message.length,
                            limit: _this.props.characterLimit
                        }
                    });
                    _this.props.handlePostError(errorMessage);
                } else {
                    _this.props.handlePostError(null);
                }
            }
        };

        _this.handleKeyDown = function (e) {
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(e);
            }
        };

        _this.handleBlur = function (e) {
            if (_this.props.onBlur) {
                _this.props.onBlur(e);
            }
        };

        _this.handleHeightChange = function (height, maxHeight) {
            var wrapper = (0, _jquery2.default)(_this.refs.wrapper);

            // Move over attachment icon to compensate for the scrollbar
            if (height > maxHeight) {
                wrapper.closest('.post-create').addClass('scroll');
            } else {
                wrapper.closest('.post-create').removeClass('scroll');
            }
        };

        _this.focus = function () {
            var textbox = _this.refs.message.getTextbox();

            textbox.focus();
            Utils.placeCaretAtEnd(textbox);

            // reset character count warning
            _this.checkMessageLength(textbox.value);
        };

        _this.blur = function () {
            var textbox = _this.refs.message.getTextbox();
            textbox.blur();
        };

        _this.recalculateSize = function () {
            _this.refs.message.recalculateSize();
        };

        _this.togglePreview = function (e) {
            e.preventDefault();
            e.target.blur();
            _this.setState(function (prevState) {
                return { preview: !prevState.preview };
            });
        };

        _this.hidePreview = function () {
            _this.setState({ preview: false });
        };

        _this.state = {
            connection: ''
        };

        _this.suggestionProviders = [new _at_mention_provider2.default(_this.props.channelId), new _channel_mention_provider2.default(), new _emoticon_provider2.default()];
        if (props.supportsCommands) {
            _this.suggestionProviders.push(new _command_provider2.default());
        }
        return _this;
    }

    (0, _createClass3.default)(Textbox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _error_store2.default.addChangeListener(this.onReceivedError);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.checkMessageLength(this.props.value);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _error_store2.default.removeChangeListener(this.onReceivedError);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.channelId !== this.props.channelId) {
                // Update channel id for AtMentionProvider.
                var providers = this.suggestionProviders;
                for (var i = 0; i < providers.length; i++) {
                    if (providers[i] instanceof _at_mention_provider2.default) {
                        providers[i] = new _at_mention_provider2.default(nextProps.channelId);
                    }
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var hasText = this.props.value && this.props.value.length > 0;

            var editHeader = void 0;
            var helpTextClass = '';

            if (this.props.value && this.props.value.length > this.props.characterLimit) {
                helpTextClass = 'hidden';
            }

            if (this.props.previewMessageLink) {
                editHeader = _react2.default.createElement(
                    'span',
                    null,
                    this.props.previewMessageLink
                );
            } else {
                editHeader = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'textbox.edit',
                    defaultMessage: 'Edit message'
                });
            }

            var previewLink = null;
            if (Utils.isFeatureEnabled(PreReleaseFeatures.MARKDOWN_PREVIEW)) {
                previewLink = _react2.default.createElement(
                    'a',
                    {
                        id: 'previewLink',
                        onClick: this.togglePreview,
                        className: 'textbox-preview-link'
                    },
                    this.state.preview ? editHeader : _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'textbox.preview',
                        defaultMessage: 'Preview'
                    })
                );
            }

            var helpText = _react2.default.createElement(
                'div',
                {
                    id: 'helpText',
                    style: { visibility: hasText ? 'visible' : 'hidden', opacity: hasText ? '0.45' : '0' },
                    className: 'help__format-text'
                },
                _react2.default.createElement(
                    'b',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'textbox.bold',
                        defaultMessage: '**bold**'
                    })
                ),
                _react2.default.createElement(
                    'i',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'textbox.italic',
                        defaultMessage: '_italic_'
                    })
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '~~',
                    _react2.default.createElement(
                        'strike',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'textbox.strike',
                            defaultMessage: 'strike'
                        })
                    ),
                    '~~ '
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'textbox.inlinecode',
                        defaultMessage: '`inline code`'
                    })
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'textbox.preformatted',
                        defaultMessage: '```preformatted```'
                    })
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'textbox.quote',
                        defaultMessage: '>quote'
                    })
                )
            );

            var preview = null;

            var textboxClassName = 'form-control custom-textarea';
            if (this.props.emojiEnabled) {
                textboxClassName += ' custom-textarea--emoji-picker';
            }
            if (this.state.connection) {
                textboxClassName += ' ' + this.state.connection;
            }
            if (this.state.preview) {
                textboxClassName += ' custom-textarea--preview';

                preview = _react2.default.createElement(
                    'div',
                    {
                        ref: 'preview',
                        className: 'form-control custom-textarea textbox-preview-area',
                        style: { display: this.state.preview ? 'block' : 'none' }
                    },
                    _react2.default.createElement(_post_markdown2.default, {
                        isRHS: this.props.isRHS,
                        message: this.props.value
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    ref: 'wrapper',
                    className: 'textarea-wrapper'
                },
                _react2.default.createElement(_suggestion_box2.default, {
                    id: this.props.id,
                    ref: 'message',
                    className: textboxClassName,
                    spellCheck: 'true',
                    placeholder: this.props.createMessage,
                    onChange: this.handleChange,
                    onKeyPress: this.props.onKeyPress,
                    onKeyDown: this.handleKeyDown,
                    onBlur: this.handleBlur,
                    onHeightChange: this.handleHeightChange,
                    style: { visibility: this.state.preview ? 'hidden' : 'visible' },
                    inputComponent: _autosize_textarea2.default,
                    listComponent: _suggestion_list2.default,
                    listStyle: this.props.suggestionListStyle,
                    providers: this.suggestionProviders,
                    channelId: this.props.channelId,
                    value: this.props.value,
                    renderDividers: true,
                    isRHS: this.props.isRHS,
                    popoverMentionKeyClick: this.props.popoverMentionKeyClick,
                    disabled: this.props.disabled
                }),
                preview,
                _react2.default.createElement(
                    'div',
                    { className: 'help__text ' + helpTextClass },
                    helpText,
                    previewLink,
                    _react2.default.createElement(
                        'a',
                        {
                            id: 'helpTextLink',
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            href: '/help/messaging',
                            className: 'textbox-help-link'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'textbox.help',
                            defaultMessage: 'Help'
                        })
                    )
                )
            );
        }
    }]);
    return Textbox;
}(_react2.default.Component);

Textbox.propTypes = {
    id: _propTypes2.default.string.isRequired,
    channelId: _propTypes2.default.string,
    value: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onKeyPress: _propTypes2.default.func.isRequired,
    createMessage: _propTypes2.default.string.isRequired,
    previewMessageLink: _propTypes2.default.string,
    onKeyDown: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    supportsCommands: _propTypes2.default.bool.isRequired,
    handlePostError: _propTypes2.default.func,
    suggestionListStyle: _propTypes2.default.string,
    emojiEnabled: _propTypes2.default.bool,
    isRHS: _propTypes2.default.bool,
    popoverMentionKeyClick: _propTypes2.default.bool,
    characterLimit: _propTypes2.default.number,
    disabled: _propTypes2.default.bool
};
Textbox.defaultProps = {
    supportsCommands: true,
    isRHS: false,
    popoverMentionKeyClick: false,
    characterLimit: _constants2.default.CHARACTER_LIMIT
};
exports.default = Textbox;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var COMPLETE_WORD_EVENT = 'complete_word';
var PRETEXT_CHANGED_EVENT = 'pretext_changed';
var SUGGESTIONS_CHANGED_EVENT = 'suggestions_changed';
var POPOVER_MENTION_KEY_CLICK_EVENT = 'popover_mention_key_click';

var SuggestionStore = function (_EventEmitter) {
    (0, _inherits3.default)(SuggestionStore, _EventEmitter);

    function SuggestionStore() {
        (0, _classCallCheck3.default)(this, SuggestionStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SuggestionStore.__proto__ || (0, _getPrototypeOf2.default)(SuggestionStore)).call(this));

        _this.addSuggestionsChangedListener = _this.addSuggestionsChangedListener.bind(_this);
        _this.removeSuggestionsChangedListener = _this.removeSuggestionsChangedListener.bind(_this);
        _this.emitSuggestionsChanged = _this.emitSuggestionsChanged.bind(_this);

        _this.addPretextChangedListener = _this.addPretextChangedListener.bind(_this);
        _this.removePretextChangedListener = _this.removePretextChangedListener.bind(_this);
        _this.emitPretextChanged = _this.emitPretextChanged.bind(_this);

        _this.addCompleteWordListener = _this.addCompleteWordListener.bind(_this);
        _this.removeCompleteWordListener = _this.removeCompleteWordListener.bind(_this);
        _this.emitCompleteWord = _this.emitCompleteWord.bind(_this);

        _this.addPopoverMentionKeyClickListener = _this.addPopoverMentionKeyClickListener.bind(_this);
        _this.removePopoverMentionKeyClickListener = _this.removePopoverMentionKeyClickListener.bind(_this);
        _this.emitPopoverMentionKeyClick = _this.emitPopoverMentionKeyClick.bind(_this);

        _this.handleEventPayload = _this.handleEventPayload.bind(_this);
        _this.dispatchToken = _app_dispatcher2.default.register(_this.handleEventPayload);

        // this.suggestions stores the state of all SuggestionBoxes by mapping their unique identifier to an
        // object with the following fields:
        // pretext: the text before the cursor
        // matchedPretext: a list of the text before the cursor that will be replaced if the corresponding autocomplete term is selected
        // terms: a list of strings which the previously typed text may be replaced by
        // items: a list of objects backing the terms which may be used in rendering
        // components: a list of react components that can be used to render their corresponding item
        // selection: the term currently selected by the keyboard
        _this.suggestions = new _map2.default();
        return _this;
    }

    (0, _createClass3.default)(SuggestionStore, [{
        key: 'addSuggestionsChangedListener',
        value: function addSuggestionsChangedListener(id, callback) {
            this.on(SUGGESTIONS_CHANGED_EVENT + id, callback);
        }
    }, {
        key: 'removeSuggestionsChangedListener',
        value: function removeSuggestionsChangedListener(id, callback) {
            this.removeListener(SUGGESTIONS_CHANGED_EVENT + id, callback);
        }
    }, {
        key: 'emitSuggestionsChanged',
        value: function emitSuggestionsChanged(id) {
            this.emit(SUGGESTIONS_CHANGED_EVENT + id);
        }
    }, {
        key: 'addPretextChangedListener',
        value: function addPretextChangedListener(id, callback) {
            this.on(PRETEXT_CHANGED_EVENT + id, callback);
        }
    }, {
        key: 'removePretextChangedListener',
        value: function removePretextChangedListener(id, callback) {
            this.removeListener(PRETEXT_CHANGED_EVENT + id, callback);
        }
    }, {
        key: 'emitPretextChanged',
        value: function emitPretextChanged(id, pretext) {
            this.emit(PRETEXT_CHANGED_EVENT + id, pretext);
        }
    }, {
        key: 'addCompleteWordListener',
        value: function addCompleteWordListener(id, callback) {
            this.on(COMPLETE_WORD_EVENT + id, callback);
        }
    }, {
        key: 'removeCompleteWordListener',
        value: function removeCompleteWordListener(id, callback) {
            this.removeListener(COMPLETE_WORD_EVENT + id, callback);
        }
    }, {
        key: 'emitCompleteWord',
        value: function emitCompleteWord(id, term, matchedPretext) {
            this.emit(COMPLETE_WORD_EVENT + id, term, matchedPretext);
        }
    }, {
        key: 'addPopoverMentionKeyClickListener',
        value: function addPopoverMentionKeyClickListener(id, callback) {
            this.on(POPOVER_MENTION_KEY_CLICK_EVENT + id, callback);
        }
    }, {
        key: 'removePopoverMentionKeyClickListener',
        value: function removePopoverMentionKeyClickListener(id, callback) {
            this.removeListener(POPOVER_MENTION_KEY_CLICK_EVENT + id, callback);
        }
    }, {
        key: 'emitPopoverMentionKeyClick',
        value: function emitPopoverMentionKeyClick(isRHS, mentionKey) {
            this.emit(POPOVER_MENTION_KEY_CLICK_EVENT + isRHS, mentionKey);
        }
    }, {
        key: 'registerSuggestionBox',
        value: function registerSuggestionBox(id) {
            this.suggestions.set(id, {
                pretext: '',
                matchedPretext: [],
                terms: [],
                items: [],
                components: [],
                selection: ''
            });
        }
    }, {
        key: 'unregisterSuggestionBox',
        value: function unregisterSuggestionBox(id) {
            this.suggestions.delete(id);
        }
    }, {
        key: 'clearSuggestions',
        value: function clearSuggestions(id) {
            var suggestion = this.getSuggestions(id);

            suggestion.matchedPretext = [];
            suggestion.terms = [];
            suggestion.items = [];
            suggestion.components = [];
        }
    }, {
        key: 'clearSelection',
        value: function clearSelection(id) {
            var suggestion = this.getSuggestions(id);

            suggestion.selection = '';
        }
    }, {
        key: 'suggestionBoxExists',
        value: function suggestionBoxExists(id) {
            return this.suggestions.has(id);
        }
    }, {
        key: 'hasSuggestions',
        value: function hasSuggestions(id) {
            return this.getSuggestions(id).terms.length > 0;
        }
    }, {
        key: 'setPretext',
        value: function setPretext(id, pretext) {
            var suggestion = this.getSuggestions(id);

            suggestion.pretext = pretext;
        }
    }, {
        key: 'addSuggestion',
        value: function addSuggestion(id, term, item, component, matchedPretext) {
            var suggestion = this.getSuggestions(id);

            suggestion.terms.push(term);
            suggestion.items.push(item);
            suggestion.components.push(component);
            suggestion.matchedPretext.push(matchedPretext);
        }
    }, {
        key: 'addSuggestions',
        value: function addSuggestions(id, terms, items, component, matchedPretext) {
            var _suggestion$terms, _suggestion$items;

            var suggestion = this.getSuggestions(id);

            (_suggestion$terms = suggestion.terms).push.apply(_suggestion$terms, (0, _toConsumableArray3.default)(terms));
            (_suggestion$items = suggestion.items).push.apply(_suggestion$items, (0, _toConsumableArray3.default)(items));

            for (var i = 0; i < terms.length; i++) {
                suggestion.components.push(component);
                suggestion.matchedPretext.push(matchedPretext);
            }
        }

        // make sure that if suggestions exist, then one of them is selected. return true if the selection changes.

    }, {
        key: 'ensureSelectionExists',
        value: function ensureSelectionExists(id) {
            var suggestion = this.getSuggestions(id);

            if (suggestion.terms.length > 0) {
                // if the current selection is no longer in the map, select the first term in the list
                if (!suggestion.selection || suggestion.terms.indexOf(suggestion.selection) === -1) {
                    suggestion.selection = suggestion.terms[0];

                    return true;
                }
            } else if (suggestion.selection) {
                suggestion.selection = '';

                return true;
            }

            return false;
        }
    }, {
        key: 'getPretext',
        value: function getPretext(id) {
            return this.getSuggestions(id).pretext;
        }
    }, {
        key: 'getSelectedMatchedPretext',
        value: function getSelectedMatchedPretext(id) {
            var suggestion = this.getSuggestions(id);

            for (var i = 0; i < suggestion.terms.length; i++) {
                if (suggestion.terms[i] === suggestion.selection) {
                    return suggestion.matchedPretext[i];
                }
            }

            return '';
        }
    }, {
        key: 'getItems',
        value: function getItems(id) {
            return this.getSuggestions(id).items;
        }
    }, {
        key: 'getTerms',
        value: function getTerms(id) {
            return this.getSuggestions(id).terms;
        }
    }, {
        key: 'getComponents',
        value: function getComponents(id) {
            return this.getSuggestions(id).components;
        }
    }, {
        key: 'getSuggestions',
        value: function getSuggestions(id) {
            return this.suggestions.get(id) || {};
        }
    }, {
        key: 'getSelection',
        value: function getSelection(id) {
            return this.getSuggestions(id).selection;
        }
    }, {
        key: 'selectNext',
        value: function selectNext(id) {
            this.setSelectionByDelta(id, 1);
        }
    }, {
        key: 'selectPrevious',
        value: function selectPrevious(id) {
            this.setSelectionByDelta(id, -1);
        }
    }, {
        key: 'setSelectionByDelta',
        value: function setSelectionByDelta(id, delta) {
            var suggestion = this.suggestions.get(id);

            var selectionIndex = suggestion.terms.indexOf(suggestion.selection);

            if (selectionIndex === -1) {
                // this should never happen since selection should always be in terms
                throw new Error('selection is not in terms');
            }

            selectionIndex += delta;

            if (selectionIndex < 0) {
                selectionIndex = 0;
            } else if (selectionIndex > suggestion.terms.length - 1) {
                selectionIndex = suggestion.terms.length - 1;
            }

            suggestion.selection = suggestion.terms[selectionIndex];
        }
    }, {
        key: 'checkIfPretextMatches',
        value: function checkIfPretextMatches(id, matchedPretext) {
            var pretext = this.getPretext(id) || '';
            return pretext.endsWith(matchedPretext);
        }
    }, {
        key: 'completeWord',
        value: function completeWord(id) {
            var term = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var matchedPretext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            this.emitCompleteWord(id, term || this.getSelection(id), matchedPretext || this.getSelectedMatchedPretext(id));

            this.setPretext(id, '');
            this.clearSuggestions(id);
            this.clearSelection(id);
            this.emitSuggestionsChanged(id);
        }
    }, {
        key: 'handleEventPayload',
        value: function handleEventPayload(payload) {
            var _payload$action = payload.action,
                type = _payload$action.type,
                id = _payload$action.id,
                other = (0, _objectWithoutProperties3.default)(_payload$action, ['type', 'id']);


            if (id && !this.suggestionBoxExists(id)) {
                return;
            }

            switch (type) {
                case ActionTypes.SUGGESTION_PRETEXT_CHANGED:
                    // Clear the suggestions if the pretext is empty or ends with whitespace
                    if (other.pretext === '') {
                        this.clearSuggestions(id);
                    }

                    other.pretext = other.pretext.toLowerCase();

                    this.setPretext(id, other.pretext);
                    this.emitPretextChanged(id, other.pretext);

                    this.ensureSelectionExists(id);
                    this.emitSuggestionsChanged(id);
                    break;
                case ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS:
                    if (!this.checkIfPretextMatches(id, other.matchedPretext)) {
                        // These suggestions are out of date since the pretext has changed
                        return;
                    }

                    this.clearSuggestions(id);
                    this.addSuggestions(id, other.terms, other.items, other.component, other.matchedPretext);
                    this.ensureSelectionExists(id);

                    this.emitSuggestionsChanged(id);
                    break;
                case ActionTypes.SUGGESTION_CLEAR_SUGGESTIONS:
                    this.setPretext(id, '');
                    this.clearSuggestions(id);
                    this.clearSelection(id);
                    this.emitSuggestionsChanged(id);
                    break;
                case ActionTypes.SUGGESTION_SELECT_NEXT:
                    this.selectNext(id);
                    this.emitSuggestionsChanged(id);
                    break;
                case ActionTypes.SUGGESTION_SELECT_PREVIOUS:
                    this.selectPrevious(id);
                    this.emitSuggestionsChanged(id);
                    break;
                case ActionTypes.SUGGESTION_COMPLETE_WORD:
                    this.completeWord(id, other.term, other.matchedPretext);
                    break;
                case ActionTypes.POPOVER_MENTION_KEY_CLICK:
                    this.emitPopoverMentionKeyClick(other.isRHS, other.mentionKey);
                    break;
            }
        }
    }]);
    return SuggestionStore;
}(_events2.default);

exports.default = new SuggestionStore();

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _posts = __webpack_require__(808);

var _modals = __webpack_require__(927);

var _post_actions = __webpack_require__(802);

var _dot_menu = __webpack_require__(2030);

var _dot_menu2 = _interopRequireDefault(_dot_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return ownProps;
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            flagPost: _posts.flagPost,
            unflagPost: _posts.unflagPost,
            setEditingPost: _post_actions.setEditingPost,
            pinPost: _post_actions.pinPost,
            unpinPost: _post_actions.unpinPost,
            openModal: _modals.openModal
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_dot_menu2.default);

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _files = __webpack_require__(1040);

var _files2 = __webpack_require__(1041);

var _file_attachment_list = __webpack_require__(2034);

var _file_attachment_list2 = _interopRequireDefault(_file_attachment_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeMapStateToProps() {
    var selectFilesForPost = (0, _files2.makeGetFilesForPost)();
    return function mapStateToProps(state, ownProps) {
        var postId = ownProps.post ? ownProps.post.id : '';
        var fileInfos = selectFilesForPost(state, postId);

        var fileCount = 0;
        if (ownProps.post.file_ids) {
            fileCount = ownProps.post.file_ids.length;
        } else if (ownProps.post.filenames) {
            fileCount = ownProps.post.filenames.length;
        }

        return (0, _extends3.default)({}, ownProps, {
            fileInfos: fileInfos,
            fileCount: fileCount
        });
    };
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getMissingFilesForPost: _files.getMissingFilesForPost
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_file_attachment_list2.default);

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _file_utils = __webpack_require__(887);

var _file_info_preview = __webpack_require__(2043);

var _file_info_preview2 = _interopRequireDefault(_file_info_preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    return {
        canDownloadFiles: (0, _file_utils.canDownloadFiles)(config)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_file_info_preview2.default);

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _post_actions = __webpack_require__(802);

var _flag_icon = __webpack_require__(974);

var _flag_icon2 = _interopRequireDefault(_flag_icon);

var _flag_icon_filled = __webpack_require__(2050);

var _flag_icon_filled2 = _interopRequireDefault(_flag_icon_filled);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostFlagIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(PostFlagIcon, _React$PureComponent);

    function PostFlagIcon() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PostFlagIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PostFlagIcon.__proto__ || (0, _getPrototypeOf2.default)(PostFlagIcon)).call.apply(_ref, [this].concat(args))), _this), _this.handlePress = function (e) {
            e.preventDefault();

            if (_this.props.isFlagged) {
                (0, _post_actions.unflagPost)(_this.props.postId);
            } else {
                (0, _post_actions.flagPost)(_this.props.postId);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PostFlagIcon, [{
        key: 'render',
        value: function render() {
            if (this.props.isEphemeral) {
                return null;
            }

            var isFlagged = this.props.isFlagged;

            var flagVisible = isFlagged ? 'visible' : '';

            var flagIconId = null;
            if (this.props.idCount > -1) {
                flagIconId = Utils.createSafeId(this.props.idPrefix + this.props.idCount);
            }

            var flagIcon = void 0;
            if (isFlagged) {
                flagIcon = _react2.default.createElement(_flag_icon_filled2.default, { className: 'icon' });
            } else {
                flagIcon = _react2.default.createElement(_flag_icon2.default, { className: 'icon' });
            }

            return _react2.default.createElement(
                _reactBootstrap.OverlayTrigger,
                {
                    trigger: ['hover', 'focus'],
                    key: 'flagtooltipkey' + flagVisible,
                    delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                    placement: 'top',
                    overlay: _react2.default.createElement(
                        _reactBootstrap.Tooltip,
                        { id: 'flagTooltip' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: isFlagged ? 'flag_post.unflag' : 'flag_post.flag',
                            defaultMessage: isFlagged ? 'Unflag' : 'Flag for follow up'
                        })
                    )
                },
                _react2.default.createElement(
                    'button',
                    {
                        id: flagIconId,
                        className: 'style--none flag-icon__container ' + flagVisible,
                        onClick: this.handlePress
                    },
                    flagIcon
                )
            );
        }
    }]);
    return PostFlagIcon;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PostFlagIcon.propTypes = {
    idPrefix: _propTypes2.default.string.isRequired,
    idCount: _propTypes2.default.number,
    postId: _propTypes2.default.string.isRequired,
    isFlagged: _propTypes2.default.bool.isRequired,
    isEphemeral: _propTypes2.default.bool
};
PostFlagIcon.defaultProps = {
    idCount: -1,
    isEphemeral: false
};
exports.default = PostFlagIcon;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlagIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(FlagIcon, _React$PureComponent);

    function FlagIcon() {
        (0, _classCallCheck3.default)(this, FlagIcon);
        return (0, _possibleConstructorReturn3.default)(this, (FlagIcon.__proto__ || (0, _getPrototypeOf2.default)(FlagIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(FlagIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '14px',
                        height: '14px',
                        viewBox: '0 0 16 16'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-1106.000000, -33.000000)',
                                fillRule: 'nonzero',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                null,
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(1096.000000, 22.000000)' },
                                    _react2.default.createElement(
                                        'g',
                                        { transform: 'translate(10.000000, 11.000000)' },
                                        _react2.default.createElement('path', { d: 'M8,1 L2,1 C2,0.447 1.553,0 1,0 C0.447,0 0,0.447 0,1 L0,15.5 C0,15.776 0.224,16 0.5,16 L1.5,16 C1.776,16 2,15.776 2,15.5 L2,11 L7,11 L7,12 C7,12.553 7.447,13 8,13 L15,13 C15.553,13 16,12.553 16,12 L16,4 C16,3.447 15.553,3 15,3 L9,3 L9,2 C9,1.447 8.553,1 8,1 Z M9,11 L9,9.5 C9,9.224 8.776,9 8.5,9 L2,9 L2,3 L7,3 L7,4.5 C7,4.776 7.224,5 7.5,5 L14,5 L14,11 L9,11 Z' })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return FlagIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = FlagIcon;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_agent = __webpack_require__(790);

var _utils = __webpack_require__(762);

var _local_date_time = __webpack_require__(1157);

var _local_date_time2 = _interopRequireDefault(_local_date_time);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PostTime = function (_React$PureComponent) {
    (0, _inherits3.default)(PostTime, _React$PureComponent);

    function PostTime(props) {
        (0, _classCallCheck3.default)(this, PostTime);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostTime.__proto__ || (0, _getPrototypeOf2.default)(PostTime)).call(this, props));

        _this.handleClick = function () {
            if ((0, _utils.isMobile)()) {
                GlobalActions.emitCloseRightHandSide();
            }
        };

        _this.state = {
            currentTeamDisplayName: _team_store2.default.getCurrent().name
        };
        return _this;
    }

    (0, _createClass3.default)(PostTime, [{
        key: 'render',
        value: function render() {
            var localDateTime = _react2.default.createElement(_local_date_time2.default, {
                eventTime: this.props.eventTime
            });
            if ((0, _user_agent.isMobile)() || !this.props.isPermalink) {
                return localDateTime;
            }

            return _react2.default.createElement(
                _reactRouterDom.Link,
                {
                    to: '/' + this.state.currentTeamDisplayName + '/pl/' + this.props.postId,
                    className: 'post__permalink',
                    onClick: this.handleClick
                },
                localDateTime
            );
        }
    }]);
    return PostTime;
}(_react2.default.PureComponent);

PostTime.propTypes = {

    /*
     * If true, time will be rendered as a permalink to the post
     */
    isPermalink: _propTypes2.default.bool.isRequired,

    /*
     * The time to display
     */
    eventTime: _propTypes2.default.number.isRequired,

    /*
     * The post id of posting being rendered
     */
    postId: _propTypes2.default.string
};
PostTime.defaultProps = {
    eventTime: 0
};
exports.default = PostTime;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MattermostLogo = function (_React$PureComponent) {
    (0, _inherits3.default)(MattermostLogo, _React$PureComponent);

    function MattermostLogo() {
        (0, _classCallCheck3.default)(this, MattermostLogo);
        return (0, _possibleConstructorReturn3.default)(this, (MattermostLogo.__proto__ || (0, _getPrototypeOf2.default)(MattermostLogo)).apply(this, arguments));
    }

    (0, _createClass3.default)(MattermostLogo, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        version: '1.1',
                        id: 'Layer_1',
                        x: '0px',
                        y: '0px',
                        viewBox: '0 0 500 500',
                        style: style.background
                    },
                    _react2.default.createElement(
                        'g',
                        { id: 'XMLID_1_' },
                        _react2.default.createElement(
                            'g',
                            { id: 'XMLID_3_' },
                            _react2.default.createElement('path', {
                                id: 'XMLID_4_',
                                style: style.st0,
                                d: 'M396.9,47.7l2.6,53.1c43,47.5,60,114.8,38.6,178.1c-32,94.4-137.4,144.1-235.4,110.9 S51.1,253.1,83,158.7C104.5,95.2,159.2,52,222.5,40.5l34.2-40.4C150-2.8,49.3,63.4,13.3,169.9C-31,300.6,39.1,442.5,169.9,486.7 s272.6-25.8,316.9-156.6C522.7,223.9,483.1,110.3,396.9,47.7z'
                            })
                        ),
                        _react2.default.createElement('path', {
                            id: 'XMLID_2_',
                            style: style.st0,
                            d: 'M335.6,204.3l-1.8-74.2l-1.5-42.7l-1-37c0,0,0.2-17.8-0.4-22c-0.1-0.9-0.4-1.6-0.7-2.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.2c-0.7-1.2-1.8-2.1-3.1-2.6c-1.4-0.5-2.9-0.4-4.2,0.2c0,0-0.1,0-0.1,0 c-0.2,0.1-0.3,0.1-0.4,0.2c-0.6,0.3-1.2,0.7-1.8,1.3c-3,3-13.7,17.2-13.7,17.2l-23.2,28.8l-27.1,33l-46.5,57.8 c0,0-21.3,26.6-16.6,59.4s29.1,48.7,48,55.1c18.9,6.4,48,8.5,71.6-14.7C336.4,238.4,335.6,204.3,335.6,204.3z'
                        })
                    )
                )
            );
        }
    }]);
    return MattermostLogo;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = MattermostLogo;


var style = {
    background: {
        enableBackground: 'new 0 0 500 500'
    },
    st0: {
        fillRule: 'evenodd',
        clipRule: 'evenodd'
    }
};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ModalToggleButton = function (_React$Component) {
    (0, _inherits3.default)(ModalToggleButton, _React$Component);

    function ModalToggleButton(props) {
        (0, _classCallCheck3.default)(this, ModalToggleButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ModalToggleButton.__proto__ || (0, _getPrototypeOf2.default)(ModalToggleButton)).call(this, props));

        _this.show = _this.show.bind(_this);
        _this.hide = _this.hide.bind(_this);

        _this.state = {
            show: false
        };
        return _this;
    }

    (0, _createClass3.default)(ModalToggleButton, [{
        key: 'show',
        value: function show(e) {
            if (e) {
                e.preventDefault();
            }
            this.setState({ show: true });
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.setState({ show: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                dialogType = _props.dialogType,
                dialogProps = _props.dialogProps,
                onClick = _props.onClick,
                props = (0, _objectWithoutProperties3.default)(_props, ['children', 'dialogType', 'dialogProps', 'onClick']);

            // allow callers to provide an onClick which will be called before the modal is shown

            var clickHandler = this.show;
            if (onClick) {
                clickHandler = function clickHandler(e) {
                    onClick();

                    _this2.show(e);
                };
            }

            var dialog = void 0;
            if (this.state.show) {
                // this assumes that all modals will have an onHide event and will show when mounted
                dialog = _react2.default.createElement(dialogType, (0, _assign2.default)({}, dialogProps, {
                    onHide: function onHide() {
                        _this2.hide();

                        if (dialogProps.onHide) {
                            dialogProps.onHide();
                        }
                    }
                }));
            }

            // nesting the dialog in the anchor tag looks like it shouldn't work, but it does due to how react-bootstrap
            // renders modals at the top level of the DOM instead of where you specify in the virtual DOM
            return _react2.default.createElement(
                'button',
                (0, _extends3.default)({}, props, {
                    className: 'style--none ' + props.className,
                    onClick: clickHandler
                }),
                children,
                dialog
            );
        }
    }]);
    return ModalToggleButton;
}(_react2.default.Component);

exports.default = ModalToggleButton;


ModalToggleButton.propTypes = {
    children: _propTypes2.default.node.isRequired,
    dialogType: _propTypes2.default.func.isRequired,
    dialogProps: _propTypes2.default.object,
    onClick: _propTypes2.default.func,
    className: _propTypes2.default.string
};

ModalToggleButton.defaultProps = {
    dialogProps: {},
    className: ''
};

/***/ }),
/* 978 */,
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(1375),
    isLength = __webpack_require__(1073);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2197),
    listCacheDelete = __webpack_require__(2198),
    listCacheGet = __webpack_require__(2199),
    listCacheHas = __webpack_require__(2200),
    listCacheSet = __webpack_require__(2201);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(1077);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(891);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2219);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(967);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(1396),
    baseAssignValue = __webpack_require__(1397);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _teams = __webpack_require__(816);

var _users = __webpack_require__(786);

var _channel_invite_modal = __webpack_require__(2422);

var _channel_invite_modal2 = _interopRequireDefault(_channel_invite_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps);
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getProfilesNotInChannel: _users.getProfilesNotInChannel,
            getTeamStats: _teams.getTeamStats
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_channel_invite_modal2.default);

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var md5 = __webpack_require__(1423)
module.exports = EVP_BytesToKey
function EVP_BytesToKey (password, salt, keyLen, ivLen) {
  if (!Buffer.isBuffer(password)) {
    password = new Buffer(password, 'binary')
  }
  if (salt && !Buffer.isBuffer(salt)) {
    salt = new Buffer(salt, 'binary')
  }
  keyLen = keyLen / 8
  ivLen = ivLen || 0
  var ki = 0
  var ii = 0
  var key = new Buffer(keyLen)
  var iv = new Buffer(ivLen)
  var addmd = 0
  var md_buf
  var i
  var bufs = []
  while (true) {
    if (addmd++ > 0) {
      bufs.push(md_buf)
    }
    bufs.push(password)
    if (salt) {
      bufs.push(salt)
    }
    md_buf = md5(Buffer.concat(bufs))
    bufs = []
    i = 0
    if (keyLen > 0) {
      while (true) {
        if (keyLen === 0) {
          break
        }
        if (i === md_buf.length) {
          break
        }
        key[ki++] = md_buf[i]
        keyLen--
        i++
      }
    }
    if (ivLen > 0 && i !== md_buf.length) {
      while (true) {
        if (ivLen === 0) {
          break
        }
        if (i === md_buf.length) {
          break
        }
        iv[ii++] = md_buf[i]
        ivLen--
        i++
      }
    }
    if (keyLen === 0 && ivLen === 0) {
      break
    }
  }
  for (i = 0; i < md_buf.length; i++) {
    md_buf[i] = 0
  }
  return {
    key: key,
    iv: iv
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec

// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var uint_max = Math.pow(2, 32)
function fixup_uint32 (x) {
  var ret, x_pos
  ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x
  return ret
}
function scrub_vec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
  return false
}

function Global () {
  this.SBOX = []
  this.INV_SBOX = []
  this.SUB_MIX = [[], [], [], []]
  this.INV_SUB_MIX = [[], [], [], []]
  this.init()
  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
}

Global.prototype.init = function () {
  var d, i, sx, t, x, x2, x4, x8, xi, _i
  d = (function () {
    var _i, _results
    _results = []
    for (i = _i = 0; _i < 256; i = ++_i) {
      if (i < 128) {
        _results.push(i << 1)
      } else {
        _results.push((i << 1) ^ 0x11b)
      }
    }
    return _results
  })()
  x = 0
  xi = 0
  for (i = _i = 0; _i < 256; i = ++_i) {
    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    this.SBOX[x] = sx
    this.INV_SBOX[sx] = x
    x2 = d[x]
    x4 = d[x2]
    x8 = d[x4]
    t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    this.SUB_MIX[3][x] = t
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    this.INV_SUB_MIX[3][sx] = t
    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }
  return true
}

var G = new Global()

AES.blockSize = 4 * 4

AES.prototype.blockSize = AES.blockSize

AES.keySize = 256 / 8

AES.prototype.keySize = AES.keySize

function bufferToArray (buf) {
  var len = buf.length / 4
  var out = new Array(len)
  var i = -1
  while (++i < len) {
    out[i] = buf.readUInt32BE(i * 4)
  }
  return out
}
function AES (key) {
  this._key = bufferToArray(key)
  this._doReset()
}

AES.prototype._doReset = function () {
  var invKsRow, keySize, keyWords, ksRow, ksRows, t
  keyWords = this._key
  keySize = keyWords.length
  this._nRounds = keySize + 6
  ksRows = (this._nRounds + 1) * 4
  this._keySchedule = []
  for (ksRow = 0; ksRow < ksRows; ksRow++) {
    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t)
  }
  this._invKeySchedule = []
  for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
    ksRow = ksRows - invKsRow
    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)]
    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]]
  }
  return true
}

AES.prototype.encryptBlock = function (M) {
  M = bufferToArray(new Buffer(M))
  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX)
  var buf = new Buffer(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = bufferToArray(new Buffer(M))
  var temp = [M[3], M[1]]
  M[1] = temp[0]
  M[3] = temp[1]
  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX)
  var buf = new Buffer(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrub_vec(this._keySchedule)
  scrub_vec(this._invKeySchedule)
  scrub_vec(this._key)
}

AES.prototype._doCryptBlock = function (M, keySchedule, SUB_MIX, SBOX) {
  var ksRow, s0, s1, s2, s3, t0, t1, t2, t3

  s0 = M[0] ^ keySchedule[0]
  s1 = M[1] ^ keySchedule[1]
  s2 = M[2] ^ keySchedule[2]
  s3 = M[3] ^ keySchedule[3]
  ksRow = 4
  for (var round = 1; round < this._nRounds; round++) {
    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }
  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  return [
    fixup_uint32(t0),
    fixup_uint32(t1),
    fixup_uint32(t2),
    fixup_uint32(t3)
  ]
}

exports.AES = AES

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 990 */
/***/ (function(module, exports) {

exports['aes-128-ecb'] = {
  cipher: 'AES',
  key: 128,
  iv: 0,
  mode: 'ECB',
  type: 'block'
}
exports['aes-192-ecb'] = {
  cipher: 'AES',
  key: 192,
  iv: 0,
  mode: 'ECB',
  type: 'block'
}
exports['aes-256-ecb'] = {
  cipher: 'AES',
  key: 256,
  iv: 0,
  mode: 'ECB',
  type: 'block'
}
exports['aes-128-cbc'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CBC',
  type: 'block'
}
exports['aes-192-cbc'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CBC',
  type: 'block'
}
exports['aes-256-cbc'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CBC',
  type: 'block'
}
exports['aes128'] = exports['aes-128-cbc']
exports['aes192'] = exports['aes-192-cbc']
exports['aes256'] = exports['aes-256-cbc']
exports['aes-128-cfb'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CFB',
  type: 'stream'
}
exports['aes-192-cfb'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CFB',
  type: 'stream'
}
exports['aes-256-cfb'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CFB',
  type: 'stream'
}
exports['aes-128-cfb8'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CFB8',
  type: 'stream'
}
exports['aes-192-cfb8'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CFB8',
  type: 'stream'
}
exports['aes-256-cfb8'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CFB8',
  type: 'stream'
}
exports['aes-128-cfb1'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CFB1',
  type: 'stream'
}
exports['aes-192-cfb1'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CFB1',
  type: 'stream'
}
exports['aes-256-cfb1'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CFB1',
  type: 'stream'
}
exports['aes-128-ofb'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'OFB',
  type: 'stream'
}
exports['aes-192-ofb'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'OFB',
  type: 'stream'
}
exports['aes-256-ofb'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'OFB',
  type: 'stream'
}
exports['aes-128-ctr'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CTR',
  type: 'stream'
}
exports['aes-192-ctr'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CTR',
  type: 'stream'
}
exports['aes-256-ctr'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CTR',
  type: 'stream'
}
exports['aes-128-gcm'] = {
  cipher: 'AES',
  key: 128,
  iv: 12,
  mode: 'GCM',
  type: 'auth'
}
exports['aes-192-gcm'] = {
  cipher: 'AES',
  key: 192,
  iv: 12,
  mode: 'GCM',
  type: 'auth'
}
exports['aes-256-gcm'] = {
  cipher: 'AES',
  key: 256,
  iv: 12,
  mode: 'GCM',
  type: 'auth'
}


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(938)

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}

function getBlock (self) {
  var out = self._cipher.encryptBlock(self._prev)
  incr32(self._prev)
  return out
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(2523);
curve.short = __webpack_require__(2524);
curve.mont = __webpack_require__(2525);
curve.edwards = __webpack_require__(2526);


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(2541)
var aesid = __webpack_require__(2553)
var fixProc = __webpack_require__(2554)
var ciphers = __webpack_require__(1095)
var compat = __webpack_require__(1431)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = new Buffer(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var _save_button = __webpack_require__(925);

var _save_button2 = _interopRequireDefault(_save_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginMfa = function (_React$PureComponent) {
    (0, _inherits3.default)(LoginMfa, _React$PureComponent);

    function LoginMfa(props) {
        (0, _classCallCheck3.default)(this, LoginMfa);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoginMfa.__proto__ || (0, _getPrototypeOf2.default)(LoginMfa)).call(this, props));

        _this.handleChange = function (e) {
            e.preventDefault();
            var token = e.target.value.trim().replace(/\s/g, '');

            if (token !== _this.state.token) {
                _this.setState({
                    token: token
                });
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            var state = {};

            if (!_this.state.token) {
                state.serverError = (0, _utils.localizeMessage)('login_mfa.tokenReq', 'Please enter an MFA token');
                _this.setState(state);
                return;
            }

            state.serverError = '';
            state.saving = true;
            _this.setState(state);

            _this.props.submit(_this.props.loginId, _this.props.password, _this.state.token);
        };

        _this.state = {
            saving: false,
            token: '',
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(LoginMfa, [{
        key: 'render',
        value: function render() {
            var serverError = void 0;
            var errorClass = '';
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    this.state.serverError
                );
                errorClass = ' has-error';
            }

            return _react2.default.createElement(
                'form',
                { onSubmit: this.handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'signup__email-container' },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login_mfa.enterToken',
                            defaultMessage: 'To complete the sign in process, please enter a token from your smartphone\'s authenticator'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' + errorClass },
                        serverError
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' + errorClass },
                        _react2.default.createElement('input', {
                            type: 'text',
                            className: 'form-control',
                            name: 'token',
                            placeholder: (0, _utils.localizeMessage)('login_mfa.token', 'MFA Token'),
                            spellCheck: 'false',
                            autoComplete: 'off',
                            autoFocus: true,
                            onChange: this.handleChange
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(_save_button2.default, {
                            saving: this.state.saving,
                            disabled: this.state.saving,
                            onClick: this.handleSubmit,
                            defaultMessage: (0, _utils.localizeMessage)('login_mfa.submit', 'Submit'),
                            savingMessage: (0, _utils.localizeMessage)('login_mfa.submitting', 'Submitting...')
                        })
                    )
                )
            );
        }
    }]);
    return LoginMfa;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

LoginMfa.propTypes = {

    /*
     * User's login ID
     */
    loginId: _propTypes2.default.string.isRequired,

    /*
     * User's password
     */
    password: _propTypes2.default.string.isRequired,

    /*
     * Function to call when submitting user credentials
     */
    submit: _propTypes2.default.func.isRequired
};
exports.default = LoginMfa;

/***/ }),
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(943)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( class2type ) {
	"use strict";

	return class2type.hasOwnProperty;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(918)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr ) {
	"use strict";

	return arr.indexOf;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1003)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( pnum ) {

"use strict";

return new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1003)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( pnum ) {
	"use strict";

	return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return [ "Top", "Right", "Bottom", "Left" ];
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(812),
	__webpack_require__(1007),
	__webpack_require__(874)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, documentElement, support ) {

"use strict";

( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();

return support;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(812)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document ) {
	"use strict";

	return document.documentElement;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(896),
	__webpack_require__(807),
	__webpack_require__(859)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, toType, isFunction, rnothtmlwhite ) {

"use strict";

// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

/**
 * Determines whether an object can have data
 */
return function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(844),
	__webpack_require__(897),
	__webpack_require__(1008)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, dataPriv ) {

"use strict";

jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(920),
	__webpack_require__(812),
	__webpack_require__(807),
	__webpack_require__(1002),
	__webpack_require__(859),
	__webpack_require__(1005),
	__webpack_require__(1116),
	__webpack_require__(1100),
	__webpack_require__(1108),
	__webpack_require__(844),
	__webpack_require__(1593),

	__webpack_require__(834),
	__webpack_require__(1010),
	__webpack_require__(897),
	__webpack_require__(898),
	__webpack_require__(945),
	__webpack_require__(917),
	__webpack_require__(1595)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, camelCase, document, isFunction, rcssNum, rnothtmlwhite, cssExpand,
	isHiddenWithinTree, swap, adjustCSS, dataPriv, showHide ) {

"use strict";

var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(812),
	__webpack_require__(874)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document, support ) {

"use strict";

( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();

return support;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(859)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( rnothtmlwhite ) {
	"use strict";

	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}

	return stripAndCollapse;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(812),
	__webpack_require__(844),
	__webpack_require__(1009),
	__webpack_require__(1000),
	__webpack_require__(807),
	__webpack_require__(919),
	__webpack_require__(899)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, dataPriv, acceptData, hasOwn, isFunction, isWindow ) {

"use strict";

var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEmojiImageUrl = getEmojiImageUrl;
exports.parseNeededCustomEmojisFromText = parseNeededCustomEmojisFromText;

var _client = __webpack_require__(270);

function getEmojiImageUrl(emoji) {
    if (emoji.id) {
        return _client.Client4.getEmojiRoute(emoji.id) + '/image';
    }

    var filename = emoji.filename || emoji.aliases[0];

    return '/static/emoji/' + filename + '.png';
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function parseNeededCustomEmojisFromText(text, systemEmojis, customEmojisByName, nonExistentEmoji) {
    if (!text.includes(':')) {
        return new Set();
    }

    var pattern = /:([A-Za-z0-9_-]+):/gi;

    var customEmojis = new Set();

    var match = void 0;
    while ((match = pattern.exec(text)) !== null) {
        if (systemEmojis.has(match[1])) {
            // It's a system emoji, go the next match
            continue;
        }

        if (nonExistentEmoji.has(match[1])) {
            // We've previously confirmed this is not a custom emoji
            continue;
        }

        if (customEmojisByName.has(match[1])) {
            // We have the emoji, go to the next match
            continue;
        }

        customEmojis.add(match[1]);
    }

    return customEmojis;
}

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var _isArray = /*#__PURE__*/__webpack_require__(1132);

var _isTransformer = /*#__PURE__*/__webpack_require__(1666);

/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */


function _dispatchable(methodNames, xf, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}
module.exports = _dispatchable;

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports = {
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
};

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var _isArrayLike = /*#__PURE__*/__webpack_require__(1674);

var _xwrap = /*#__PURE__*/__webpack_require__(1676);

var bind = /*#__PURE__*/__webpack_require__(1677);

function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    idx += 1;
  }
  return xf['@@transducer/result'](acc);
}

function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf['@@transducer/step'](acc, step.value);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    step = iter.next();
  }
  return xf['@@transducer/result'](acc);
}

function _methodReduce(xf, acc, obj, methodName) {
  return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
}

var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

function _reduce(fn, acc, list) {
  if (typeof fn === 'function') {
    fn = _xwrap(fn);
  }
  if (_isArrayLike(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list['fantasy-land/reduce'] === 'function') {
    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === 'function') {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === 'function') {
    return _methodReduce(fn, acc, list, 'reduce');
  }

  throw new TypeError('reduce: list must be array or iterable');
}
module.exports = _reduce;

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
}
module.exports = _arity;

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = _has;

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

/**
 * Ensure some object is a coerced to a string
 **/
module.exports = function makeString(object) {
  if (object == null) return '';
  return '' + object;
};


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1712);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1713);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(862);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(862);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(862);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1761);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _profile_popover = __webpack_require__(1763);

var _profile_popover2 = _interopRequireDefault(_profile_popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var config = state.entities.general.config;

    var enableWebrtc = config.EnableWebrtc === 'true';
    var enableTimezone = config.ExperimentalTimezone === 'true';

    return (0, _extends3.default)({}, ownProps, {
        enableWebrtc: enableWebrtc,
        enableTimezone: enableTimezone
    });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_profile_popover2.default);

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getUserTimezone = getUserTimezone;
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getUserTimezone(state, id) {
    var profile = state.entities.users.profiles[id];

    if (profile && profile.timezone) {
        return _extends({}, profile.timezone, {
            useAutomaticTimezone: profile.timezone.useAutomaticTimezone === 'true'
        });
    }

    return {
        useAutomaticTimezone: true,
        automaticTimezone: '',
        manualTimezone: ''
    };
}

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var handleTeamAddedEvent = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(msg) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return TeamActions.getTeam(msg.data.team_id)(dispatch, getState);

                    case 2:
                        _context.next = 4;
                        return TeamActions.getMyTeamMembers()(dispatch, getState);

                    case 4:
                        _context.next = 6;
                        return TeamActions.getMyTeamUnreads()(dispatch, getState);

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function handleTeamAddedEvent(_x2) {
        return _ref.apply(this, arguments);
    };
}();

exports.initialize = initialize;
exports.close = close;
exports.reconnect = reconnect;
exports.startPeriodicSync = startPeriodicSync;
exports.stopPeriodicSync = stopPeriodicSync;

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _reduxBatchedActions = __webpack_require__(921);

var _action_types = __webpack_require__(3);

var _constants = __webpack_require__(19);

var _channels = __webpack_require__(798);

var _general = __webpack_require__(946);

var _posts2 = __webpack_require__(808);

var _teams = __webpack_require__(816);

var TeamActions = _interopRequireWildcard(_teams);

var _users = __webpack_require__(786);

var _client = __webpack_require__(270);

var _users2 = __webpack_require__(777);

var _teams2 = __webpack_require__(274);

var _general2 = __webpack_require__(113);

var _browser_history = __webpack_require__(273);

var _channel_actions = __webpack_require__(809);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _post_actions = __webpack_require__(802);

var _status_actions = __webpack_require__(955);

var StatusActions = _interopRequireWildcard(_status_actions);

var _user_actions = __webpack_require__(781);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _web_websocket_client = __webpack_require__(959);

var _web_websocket_client2 = _interopRequireDefault(_web_websocket_client);

var _plugins = __webpack_require__(1158);

var _constants2 = __webpack_require__(29);

var _url = __webpack_require__(793);

var _webrtc_actions = __webpack_require__(905);

var WebrtcActions = _interopRequireWildcard(_webrtc_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

var MAX_WEBSOCKET_FAILS = 7;

function initialize() {
    if (!window.WebSocket) {
        console.log('Browser does not support websocket'); //eslint-disable-line no-console
        return;
    }

    var config = (0, _general2.getConfig)(getState());
    var connUrl = '';
    if (config.WebsocketURL) {
        connUrl = config.WebsocketURL;
    } else {
        connUrl = (0, _url.getSiteURL)();

        // replace the protocol with a websocket one
        if (connUrl.startsWith('https:')) {
            connUrl = connUrl.replace(/^https:/, 'wss:');
        } else {
            connUrl = connUrl.replace(/^http:/, 'ws:');
        }

        // append a port number if one isn't already specified
        if (!/:\d+$/.test(connUrl)) {
            if (connUrl.startsWith('wss:')) {
                connUrl += ':' + config.WebsocketSecurePort;
            } else {
                connUrl += ':' + config.WebsocketPort;
            }
        }
    }

    connUrl += _client.Client4.getUrlVersion() + '/websocket';

    _web_websocket_client2.default.setEventCallback(handleEvent);
    _web_websocket_client2.default.setFirstConnectCallback(handleFirstConnect);
    _web_websocket_client2.default.setReconnectCallback(function () {
        return reconnect(false);
    });
    _web_websocket_client2.default.setMissedEventCallback(function () {
        return reconnect(false);
    });
    _web_websocket_client2.default.setCloseCallback(handleClose);
    _web_websocket_client2.default.initialize(connUrl);
}

function close() {
    _web_websocket_client2.default.close();
}

function reconnectWebSocket() {
    close();
    initialize();
}

function reconnect() {
    var includeWebSocket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (includeWebSocket) {
        reconnectWebSocket();
    }

    (0, _plugins.loadPluginsIfNecessary)();

    var currentTeamId = getState().entities.teams.currentTeamId;
    if (currentTeamId) {
        (0, _channel_actions.loadChannelsForCurrentUser)();
        (0, _posts2.getPosts)(_channel_store2.default.getCurrentId())(dispatch, getState);
        StatusActions.loadStatusesForChannelAndSidebar();
        TeamActions.getMyTeamUnreads()(dispatch, getState);
    }

    _error_store2.default.setConnectionErrorCount(0);
    _error_store2.default.clearLastError();
    _error_store2.default.emitChange();
}

var intervalId = '';
var SYNC_INTERVAL_MILLISECONDS = 1000 * 60 * 15; // 15 minutes

function startPeriodicSync() {
    clearInterval(intervalId);

    intervalId = setInterval(function () {
        if (_user_store2.default.getCurrentUser() != null) {
            reconnect(false);
        }
    }, SYNC_INTERVAL_MILLISECONDS);
}

function stopPeriodicSync() {
    clearInterval(intervalId);
}

function handleFirstConnect() {
    _error_store2.default.clearLastError();
    _error_store2.default.emitChange();
}

function handleClose(failCount) {
    if (failCount > MAX_WEBSOCKET_FAILS) {
        _error_store2.default.storeLastError({ message: _constants2.ErrorBarTypes.WEBSOCKET_PORT_ERROR });
    }

    _error_store2.default.setConnectionErrorCount(failCount);
    _error_store2.default.emitChange();
}

function handleEvent(msg) {
    switch (msg.event) {
        case _constants2.SocketEvents.POSTED:
        case _constants2.SocketEvents.EPHEMERAL_MESSAGE:
            handleNewPostEvent(msg);
            break;

        case _constants2.SocketEvents.POST_EDITED:
            handlePostEditEvent(msg);
            break;

        case _constants2.SocketEvents.POST_DELETED:
            handlePostDeleteEvent(msg);
            break;

        case _constants2.SocketEvents.LEAVE_TEAM:
            handleLeaveTeamEvent(msg);
            break;

        case _constants2.SocketEvents.UPDATE_TEAM:
            handleUpdateTeamEvent(msg);
            break;

        case _constants2.SocketEvents.DELETE_TEAM:
            handleDeleteTeamEvent(msg);
            break;

        case _constants2.SocketEvents.ADDED_TO_TEAM:
            handleTeamAddedEvent(msg);
            break;

        case _constants2.SocketEvents.USER_ADDED:
            handleUserAddedEvent(msg);
            break;

        case _constants2.SocketEvents.USER_REMOVED:
            handleUserRemovedEvent(msg);
            break;

        case _constants2.SocketEvents.USER_UPDATED:
            handleUserUpdatedEvent(msg);
            break;

        case _constants2.SocketEvents.ROLE_ADDED:
            handleRoleAddedEvent(msg, dispatch, getState);
            break;

        case _constants2.SocketEvents.ROLE_REMOVED:
            handleRoleRemovedEvent(msg, dispatch, getState);
            break;

        case _constants2.SocketEvents.MEMBERROLE_UPDATED:
            handleUpdateMemberRoleEvent(msg);
            break;

        case _constants2.SocketEvents.ROLE_UPDATED:
            handleRoleUpdatedEvent(msg, dispatch, getState);
            break;

        case _constants2.SocketEvents.CHANNEL_CREATED:
            handleChannelCreatedEvent(msg);
            break;

        case _constants2.SocketEvents.CHANNEL_DELETED:
            handleChannelDeletedEvent(msg);
            break;

        case _constants2.SocketEvents.CHANNEL_UPDATED:
            handleChannelUpdatedEvent(msg);
            break;

        case _constants2.SocketEvents.CHANNEL_MEMBER_UPDATED:
            handleChannelMemberUpdatedEvent(msg);
            break;

        case _constants2.SocketEvents.DIRECT_ADDED:
            handleDirectAddedEvent(msg);
            break;

        case _constants2.SocketEvents.PREFERENCE_CHANGED:
            handlePreferenceChangedEvent(msg);
            break;

        case _constants2.SocketEvents.PREFERENCES_CHANGED:
            handlePreferencesChangedEvent(msg);
            break;

        case _constants2.SocketEvents.PREFERENCES_DELETED:
            handlePreferencesDeletedEvent(msg);
            break;

        case _constants2.SocketEvents.TYPING:
            handleUserTypingEvent(msg);
            break;

        case _constants2.SocketEvents.STATUS_CHANGED:
            handleStatusChangedEvent(msg);
            break;

        case _constants2.SocketEvents.HELLO:
            handleHelloEvent(msg);
            break;

        case _constants2.SocketEvents.WEBRTC:
            handleWebrtc(msg);
            break;

        case _constants2.SocketEvents.REACTION_ADDED:
            handleReactionAddedEvent(msg);
            break;

        case _constants2.SocketEvents.REACTION_REMOVED:
            handleReactionRemovedEvent(msg);
            break;

        case _constants2.SocketEvents.EMOJI_ADDED:
            handleAddEmoji(msg);
            break;

        case _constants2.SocketEvents.CHANNEL_VIEWED:
            handleChannelViewedEvent(msg);
            break;

        case _constants2.SocketEvents.PLUGIN_ACTIVATED:
            handlePluginActivated(msg);
            break;

        case _constants2.SocketEvents.PLUGIN_DEACTIVATED:
            handlePluginDeactivated(msg);
            break;

        case _constants2.SocketEvents.USER_ROLE_UPDATED:
            handleUserRoleUpdated(msg);
            break;

        default:
    }
}

function handleChannelUpdatedEvent(msg) {
    var channel = JSON.parse(msg.data.channel);
    dispatch({ type: _action_types.ChannelTypes.RECEIVED_CHANNEL, data: channel });
}

function handleChannelMemberUpdatedEvent(msg) {
    var channelMember = JSON.parse(msg.data.channelMember);
    dispatch({ type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER, data: channelMember });
}

function handleNewPostEvent(msg) {
    var post = JSON.parse(msg.data.post);
    (0, _post_actions.handleNewPost)(post, msg);

    (0, _posts2.getProfilesAndStatusesForPosts)([post], dispatch, getState);

    if (post.user_id !== _user_store2.default.getCurrentId()) {
        _user_store2.default.setStatus(post.user_id, _constants2.UserStatuses.ONLINE);
    }
}

function handlePostEditEvent(msg) {
    // Store post
    var post = JSON.parse(msg.data.post);
    dispatch({
        type: _action_types.PostTypes.RECEIVED_POSTS,
        data: {
            order: [],
            posts: (0, _defineProperty3.default)({}, post.id, post)
        },
        channelId: post.channel_id
    });

    (0, _posts2.getProfilesAndStatusesForPosts)([post], dispatch, getState);

    // Update channel state
    if (_channel_store2.default.getCurrentId() === msg.broadcast.channel_id) {
        if (window.isActive) {
            (0, _channels.viewChannel)(_channel_store2.default.getCurrentId())(dispatch, getState);
        }
    }

    // Needed for search store
    _app_dispatcher2.default.handleViewAction({
        type: _constants2.Constants.ActionTypes.POST_UPDATED,
        post: post
    });
}

function handlePostDeleteEvent(msg) {
    var post = JSON.parse(msg.data.post);
    dispatch({ type: _action_types.PostTypes.POST_DELETED, data: post });

    // Needed for search store
    _app_dispatcher2.default.handleViewAction({
        type: _constants2.Constants.ActionTypes.POST_DELETED,
        post: post
    });
}

function handleLeaveTeamEvent(msg) {
    if (_user_store2.default.getCurrentId() === msg.data.user_id) {
        _team_store2.default.removeMyTeamMember(msg.data.team_id);

        // if they are on the team being removed redirect them to default team
        if (_team_store2.default.getCurrentId() === msg.data.team_id) {
            _browser_store2.default.removeGlobalItem('team');
            _browser_store2.default.removeGlobalItem(msg.data.team_id);

            if (!global.location.pathname.startsWith('/admin_console')) {
                GlobalActions.redirectUserToDefaultTeam();
            }
        }

        dispatch((0, _reduxBatchedActions.batchActions)([{
            type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_TEAM,
            data: { user_id: msg.data.user_id },
            id: msg.data.team_id
        }, {
            type: _action_types.TeamTypes.REMOVE_MEMBER_FROM_TEAM,
            data: { team_id: msg.data.team_id, user_id: msg.data.user_id }
        }]));
    } else {
        _user_store2.default.removeProfileFromTeam(msg.data.team_id, msg.data.user_id);
        _team_store2.default.removeMemberInTeam(msg.data.team_id, msg.data.user_id);
    }
}

function handleUpdateTeamEvent(msg) {
    _team_store2.default.updateTeam(msg.data.team);
}

function handleDeleteTeamEvent(msg) {
    var deletedTeam = JSON.parse(msg.data.team);
    var state = _redux_store2.default.getState();
    var teams = state.entities.teams.teams;

    if (deletedTeam && teams && teams[deletedTeam.id] && teams[deletedTeam.id].delete_at === 0) {
        var currentUserId = state.entities.users.currentUserId;
        var _state$entities$teams = state.entities.teams,
            currentTeamId = _state$entities$teams.currentTeamId,
            myMembers = _state$entities$teams.myMembers;

        var teamMembers = (0, _values2.default)(myMembers);
        var teamMember = teamMembers.find(function (m) {
            return m.user_id === currentUserId && m.team_id === currentTeamId;
        });

        var newTeamId = '';
        if (deletedTeam && teamMember && deletedTeam.id === teamMember.team_id) {
            var myTeams = {};
            (0, _teams2.getMyTeams)(state).forEach(function (t) {
                myTeams[t.id] = t;
            });

            for (var i = 0; i < teamMembers.length; i++) {
                var memberTeamId = teamMembers[i].team_id;
                if (myTeams && myTeams[memberTeamId] && myTeams[memberTeamId].delete_at === 0 && deletedTeam.id !== memberTeamId) {
                    newTeamId = memberTeamId;
                    break;
                }
            }
        }

        dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.RECEIVED_TEAM_DELETED, data: { id: deletedTeam.id } }, { type: _action_types.TeamTypes.UPDATED_TEAM, data: deletedTeam }]));

        if (newTeamId) {
            dispatch({ type: _action_types.TeamTypes.SELECT_TEAM, data: newTeamId });
            _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamUrl() + '/channels/' + _constants2.Constants.DEFAULT_CHANNEL);
        } else {
            _browser_history.browserHistory.push('/');
        }
    }
}

function handleUpdateMemberRoleEvent(msg) {
    var member = JSON.parse(msg.data.member);
    _team_store2.default.updateMyRoles(member);
}

function handleDirectAddedEvent(msg) {
    (0, _channels.getChannelAndMyMember)(msg.broadcast.channel_id)(dispatch, getState);
    _preference_store2.default.setPreference(_constants2.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, msg.data.teammate_id, 'true');
    (0, _user_actions.loadProfilesForSidebar)();
}

function handleUserAddedEvent(msg) {
    if (_channel_store2.default.getCurrentId() === msg.broadcast.channel_id) {
        (0, _channels.getChannelStats)(_channel_store2.default.getCurrentId())(dispatch, getState);
    }

    if (_team_store2.default.getCurrentId() === msg.data.team_id && _user_store2.default.getCurrentId() === msg.data.user_id) {
        (0, _channels.getChannelAndMyMember)(msg.broadcast.channel_id)(dispatch, getState);
    }
}

function handleUserRemovedEvent(msg) {
    if (_user_store2.default.getCurrentId() === msg.broadcast.user_id) {
        (0, _channel_actions.loadChannelsForCurrentUser)();

        if (msg.data.channel_id === _channel_store2.default.getCurrentId()) {
            if (msg.data.remover_id !== msg.broadcast.user_id && (0, _jquery2.default)('#removed_from_channel').length > 0) {
                var sentState = {};
                sentState.channelName = _channel_store2.default.getCurrent().display_name;
                sentState.remover = _user_store2.default.getProfile(msg.data.remover_id).username;

                _browser_store2.default.setItem('channel-removed-state', sentState);
                (0, _jquery2.default)('#removed_from_channel').modal('show');
            }

            GlobalActions.emitCloseRightHandSide();

            var townsquare = _channel_store2.default.getByName(_constants2.Constants.DEFAULT_CHANNEL);
            _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + townsquare.name);
        }

        dispatch({
            type: _action_types.ChannelTypes.LEAVE_CHANNEL,
            data: { id: msg.data.channel_id, user_id: msg.broadcast.user_id }
        });
    } else if (_channel_store2.default.getCurrentId() === msg.broadcast.channel_id) {
        (0, _channels.getChannelStats)(_channel_store2.default.getCurrentId())(dispatch, getState);
        dispatch({
            type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL,
            data: { user_id: msg.data.user_id },
            id: msg.broadcast.channel_id
        });
    }
}

function handleUserUpdatedEvent(msg) {
    var currentUser = (0, _users2.getCurrentUser)(getState());
    var user = msg.data.user;

    if (currentUser.id === user.id) {
        if (user.update_at > currentUser.update_at) {
            // Need to request me to make sure we don't override with sanitized fields from the
            // websocket event
            (0, _users.getMe)()(dispatch, getState);
        }
    } else {
        _user_store2.default.saveProfile(user);
    }
}

function handleRoleAddedEvent(msg) {
    var role = JSON.parse(msg.data.role);

    dispatch({
        type: _action_types.RoleTypes.RECEIVED_ROLE,
        data: role
    });
}

function handleRoleRemovedEvent(msg) {
    var role = JSON.parse(msg.data.role);

    dispatch({
        type: _action_types.RoleTypes.ROLE_DELETED,
        data: role
    });
}

function handleRoleUpdatedEvent(msg) {
    var role = JSON.parse(msg.data.role);

    dispatch({
        type: _action_types.RoleTypes.RECEIVED_ROLE,
        data: role
    });
}

function handleChannelCreatedEvent(msg) {
    var channelId = msg.data.channel_id;
    var teamId = msg.data.team_id;

    if (_team_store2.default.getCurrentId() === teamId && !_channel_store2.default.getChannelById(channelId)) {
        (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState);
    }
}

function handleChannelDeletedEvent(msg) {
    if (_channel_store2.default.getCurrentId() === msg.data.channel_id) {
        var teamUrl = _team_store2.default.getCurrentTeamRelativeUrl();
        _browser_history.browserHistory.push(teamUrl + '/channels/' + _constants2.Constants.DEFAULT_CHANNEL);
    }
    dispatch({ type: _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED, data: { id: msg.data.channel_id, team_id: msg.broadcast.team_id } }, getState);
    (0, _channel_actions.loadChannelsForCurrentUser)();
    TeamActions.getMyTeamUnreads()(dispatch, getState);
}

function handlePreferenceChangedEvent(msg) {
    var preference = JSON.parse(msg.data.preference);
    GlobalActions.emitPreferenceChangedEvent(preference);
}

function handlePreferencesChangedEvent(msg) {
    var preferences = JSON.parse(msg.data.preferences);
    GlobalActions.emitPreferencesChangedEvent(preferences);
}

function handlePreferencesDeletedEvent(msg) {
    var preferences = JSON.parse(msg.data.preferences);
    GlobalActions.emitPreferencesDeletedEvent(preferences);
}

function handleUserTypingEvent(msg) {
    var state = getState();
    var config = (0, _general2.getConfig)(state);
    var currentUserId = (0, _users2.getCurrentUserId)(state);
    var currentUser = (0, _users2.getCurrentUser)(state);
    var userId = msg.data.user_id;

    var data = {
        id: msg.broadcast.channel_id + msg.data.parent_id,
        userId: userId,
        now: Date.now()
    };

    dispatch({
        type: _constants.WebsocketEvents.TYPING,
        data: data
    }, getState);

    setTimeout(function () {
        dispatch({
            type: _constants.WebsocketEvents.STOP_TYPING,
            data: data
        }, getState);
    }, parseInt(config.TimeBetweenUserTypingUpdatesMilliseconds, 10));

    if (!currentUser && userId !== currentUserId) {
        (0, _users.getProfilesByIds)([userId])(dispatch, getState);
    }

    var status = (0, _users2.getStatusForUserId)(state, userId);
    if (status !== _constants.General.ONLINE) {
        (0, _users.getStatusesByIds)([userId])(dispatch, getState);
    }
}

function handleStatusChangedEvent(msg) {
    _user_store2.default.setStatus(msg.data.user_id, msg.data.status);
}

function handleHelloEvent(msg) {
    (0, _general.setServerVersion)(msg.data.server_version)(dispatch, getState);
}

function handleWebrtc(msg) {
    var data = msg.data;
    return WebrtcActions.handle(data);
}

function handleReactionAddedEvent(msg) {
    var reaction = JSON.parse(msg.data.reaction);

    dispatch((0, _posts2.getCustomEmojiForReaction)(reaction.emoji_name));

    dispatch({
        type: _action_types.PostTypes.RECEIVED_REACTION,
        data: reaction
    });
}

function handleAddEmoji(msg) {
    var data = JSON.parse(msg.data.emoji);

    dispatch({
        type: _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJI,
        data: data
    });
}

function handleReactionRemovedEvent(msg) {
    var reaction = JSON.parse(msg.data.reaction);

    dispatch({
        type: _action_types.PostTypes.REACTION_DELETED,
        data: reaction
    });
}

function handleChannelViewedEvent(msg) {
    // Useful for when multiple devices have the app open to different channels
    if ((!window.isActive || _channel_store2.default.getCurrentId() !== msg.data.channel_id) && _user_store2.default.getCurrentId() === msg.broadcast.user_id) {
        // Mark previous and next channel as read
        _channel_store2.default.resetCounts([msg.data.channel_id]);
    }
}

function handlePluginActivated(msg) {
    var manifest = msg.data.manifest;
    _redux_store2.default.dispatch({ type: _constants2.ActionTypes.RECEIVED_WEBAPP_PLUGIN, data: manifest });
    (0, _plugins.loadPlugin)(manifest);
}

function handlePluginDeactivated(msg) {
    var manifest = msg.data.manifest;
    _redux_store2.default.dispatch({ type: _constants2.ActionTypes.REMOVED_WEBAPP_PLUGIN, data: manifest });
    (0, _plugins.removePlugin)(manifest);
}

function handleUserRoleUpdated(msg) {
    var user = _redux_store2.default.getState().entities.users.profiles[msg.data.user_id];

    if (user) {
        var roles = msg.data.roles;
        var demoted = user.roles.includes(_constants2.Constants.PERMISSIONS_SYSTEM_ADMIN) && !roles.includes(_constants2.Constants.PERMISSIONS_SYSTEM_ADMIN);

        _redux_store2.default.dispatch({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: (0, _extends3.default)({}, user, { roles: roles }) });

        if (demoted && global.location.pathname.startsWith('/admin_console')) {
            GlobalActions.redirectUserToDefaultTeam();
        }
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xregexp = __webpack_require__(1769);

var _xregexp2 = _interopRequireDefault(_xregexp);

var _build = __webpack_require__(1770);

var _build2 = _interopRequireDefault(_build);

var _matchrecursive = __webpack_require__(1771);

var _matchrecursive2 = _interopRequireDefault(_matchrecursive);

var _unicodeBase = __webpack_require__(1772);

var _unicodeBase2 = _interopRequireDefault(_unicodeBase);

var _unicodeBlocks = __webpack_require__(1773);

var _unicodeBlocks2 = _interopRequireDefault(_unicodeBlocks);

var _unicodeCategories = __webpack_require__(1774);

var _unicodeCategories2 = _interopRequireDefault(_unicodeCategories);

var _unicodeProperties = __webpack_require__(1775);

var _unicodeProperties2 = _interopRequireDefault(_unicodeProperties);

var _unicodeScripts = __webpack_require__(1776);

var _unicodeScripts2 = _interopRequireDefault(_unicodeScripts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _build2.default)(_xregexp2.default);
(0, _matchrecursive2.default)(_xregexp2.default);
(0, _unicodeBase2.default)(_xregexp2.default);
(0, _unicodeBlocks2.default)(_xregexp2.default);
(0, _unicodeCategories2.default)(_xregexp2.default);
(0, _unicodeProperties2.default)(_xregexp2.default);
(0, _unicodeScripts2.default)(_xregexp2.default);

exports.default = _xregexp2.default;
module.exports = exports['default'];

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMOJI_PATTERN = exports.emoticonPatterns = undefined;

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.handleEmoticons = handleEmoticons;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var emoticonPatterns = exports.emoticonPatterns = {
    slightly_smiling_face: /(^|\s)(:-?\))(?=$|\s)/g, // :)
    wink: /(^|\s)(;-?\))(?=$|\s)/g, // ;)
    open_mouth: /(^|\s)(:o)(?=$|\s)/gi, // :o
    scream: /(^|\s)(:-o)(?=$|\s)/gi, // :-o
    smirk: /(^|\s)(:-?])(?=$|\s)/g, // :]
    smile: /(^|\s)(:-?d)(?=$|\s)/gi, // :D
    stuck_out_tongue_closed_eyes: /(^|\s)(x-d)(?=$|\s)/gi, // x-d
    stuck_out_tongue: /(^|\s)(:-?p)(?=$|\s)/gi, // :p
    rage: /(^|\s)(:-?[[@])(?=$|\s)/g, // :@
    slightly_frowning_face: /(^|\s)(:-?\()(?=$|\s)/g, // :(
    cry: /(^|\s)(:['’]-?\(|:&#x27;\(|:&#39;\()(?=$|\s)/g, // :`(
    confused: /(^|\s)(:-?\/)(?=$|\s)/g, // :/
    confounded: /(^|\s)(:-?s)(?=$|\s)/gi, // :s
    neutral_face: /(^|\s)(:-?\|)(?=$|\s)/g, // :|
    flushed: /(^|\s)(:-?\$)(?=$|\s)/g, // :$
    mask: /(^|\s)(:-x)(?=$|\s)/gi, // :-x
    heart: /(^|\s)(<3|&lt;3)(?=$|\s)/g, // <3
    broken_heart: /(^|\s)(<\/3|&lt;&#x2F;3)(?=$|\s)/g, // </3
    thumbsup: /(^|\s)(:\+1:)(?=$|\s)/g, // :+1:
    thumbsdown: /(^|\s)(:-1:)(?=$|\s)/g // :-1:
};

var EMOJI_PATTERN = exports.EMOJI_PATTERN = /(:([a-zA-Z0-9_-]+):)/g;

function handleEmoticons(text, tokens) {
    var output = text;

    function replaceEmoticonWithToken(fullMatch, prefix, matchText, name) {
        var index = tokens.size;
        var alias = '$MM_EMOTICON' + index;

        tokens.set(alias, {
            value: '<span data-emoticon="' + name + '">' + matchText + '</span>',
            originalText: fullMatch
        });

        return prefix + alias;
    }

    // match named emoticons like :goat:
    output = output.replace(EMOJI_PATTERN, function (fullMatch, matchText, name) {
        return replaceEmoticonWithToken(fullMatch, '', matchText, name);
    });

    // match text smilies like :D
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var name = _step.value;

            var pattern = emoticonPatterns[name];

            // this might look a bit funny, but since the name isn't contained in the actual match
            // like with the named emoticons, we need to add it in manually
            output = output.replace(pattern, function (fullMatch, prefix, matchText) {
                return replaceEmoticonWithToken(fullMatch, prefix, matchText, name);
            });
        };

        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(emoticonPatterns)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return output;
}

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * marked - a markdown parser
 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/chjj/marked
 */

;(function() {

var XRegExp = __webpack_require__(1031);

/**
 * Block-Level Grammar
 */

var block = {
  newline: /^\n+/,
  code: /^( {4}[^\n]*(\s*\n)*)+/,
  fences: noop,
  hr: /^( *[-*_]){3,} *(?:(?:\n +)*\n|$)/,
  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
  nptable: noop,
  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
  blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
  def: /^ *\[([^\]]+)\]: *<?((?:\w*?:(?:\/\/)?|\/|#)[^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
  table: noop,
  paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
  text: /^[^\n]+/
};

block.bullet = /(?:[*+-]|\d+\.)/;
block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
block.item = replace(block.item, 'gm')
  (/bull/g, block.bullet)
  ();

block.list = replace(block.list)
  (/bull/g, block.bullet)
  ('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')
  ('def', '\\n+(?=' + block.def.source + ')')
  ();

block.blockquote = replace(block.blockquote)
  ('def', block.def)
  ();

block._tag = '(?!(?:'
  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';

block.html = replace(block.html)
  ('comment', /<!--[\s\S]*?-->/)
  ('closed', /<(tag)[\s\S]+?<\/\1>/)
  ('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)
  (/tag/g, block._tag)
  ();

block.paragraph = replace(block.paragraph)
  ('hr', block.hr)
  ('heading', block.heading)
  ('lheading', block.lheading)
  ('blockquote', block.blockquote)
  ('tag', '<' + block._tag)
  ('def', block.def)
  ();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?\s*)\1 *(?:\n+|$)/,
  paragraph: /^/,
  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
});

block.gfm.paragraph = replace(block.paragraph)
  ('(?!', '(?!'
    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
    + block.list.source.replace('\\1', '\\3') + '|')
  ();

/**
 * GFM + Tables Block Grammar
 */

block.tables = merge({}, block.gfm, {
  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
});

/**
 * Block Lexer
 */

function Lexer(options) {
  this.options = options || marked.defaults;
  this.rules = block.normal;

  if (this.options.gfm) {
    if (this.options.tables) {
      this.rules = block.tables;
    } else {
      this.rules = block.gfm;
    }
  }
}

/**
 * Expose Block Rules
 */

Lexer.rules = block;

/**
 * Static Lex Method
 */

Lexer.lex = function(src, options) {
  var lexer = new Lexer(options);
  return lexer.lex(src);
};

/**
 * Preprocessing
 */

Lexer.prototype.lex = function(src) {
  src = src
    .replace(/\r\n|\r/g, '\n')
    .replace(/\t/g, '    ')
    .replace(/\u00a0/g, ' ')
    .replace(/\u2424/g, '\n');

  return this.token(src, true, false, [], 1);
};

/**
 * Lexing
 */

var MAX_DEPTH = 100;

Lexer.prototype.token = function(src, top, bq, links, depth) {
  var tokens = []
    , next
    , loose
    , cap
    , bull
    , b
    , item
    , space
    , i
    , l
    , token
    , ordered;

  // @hmhealey We shouldn't end up this deep under regular circumstances
  if (depth > MAX_DEPTH) {
    return {
      tokens: [{
        type: 'text',
        text: src
      }],
      links: links
    };
  }

  while (src) {
    // newline
    if (cap = this.rules.newline.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[0].length > 1) {
        tokens.push({
          type: 'space'
        });
      }
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      cap = cap[0].replace(/^ {4}/gm, '');
      tokens.push({
        type: 'code',
        text: !this.options.pedantic
          ? cap.replace(/\n+$/, '')
          : cap
      });
      continue;
    }

    // fences (gfm)
    if (cap = this.rules.fences.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'code',
        lang: cap[2],
        text: cap[3] || ''
      });
      continue;
    }

    // heading
    if (cap = this.rules.heading.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'heading',
        depth: cap[1].length,
        text: cap[2]
      });
      continue;
    }

    // table no leading pipe (gfm)
    if (top && (cap = this.rules.nptable.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: splitOnPipes(cap[1]),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = splitOnPipes(item.cells[i]);
      }

      tokens.push(item);

      continue;
    }

    // lheading
    if (cap = this.rules.lheading.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'heading',
        depth: cap[2] === '=' ? 1 : 2,
        text: cap[1]
      });
      continue;
    }

    // hr
    if (cap = this.rules.hr.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'hr'
      });
      continue;
    }

    // blockquote
    if (cap = this.rules.blockquote.exec(src)) {
      src = src.substring(cap[0].length);

      tokens.push({
        type: 'blockquote_start'
      });

      cap = cap[0].replace(/^ *> ?/gm, '');

      // Pass `top` to keep the current
      // "toplevel" state. This is exactly
      // how markdown.pl works.
      tokens = tokens.concat(this.token(cap, top, true, links, depth + 1).tokens);

      tokens.push({
        type: 'blockquote_end'
      });

      continue;
    }

    // list
    if (cap = this.rules.list.exec(src)) {
      src = src.substring(cap[0].length);
      bull = cap[2];
      ordered = bull.length > 1;

      tokens.push({
        type: 'list_start',
        ordered: ordered
      });

      // Get each top-level item.
      cap = cap[0].match(this.rules.item);
      next = false;
      l = cap.length;
      i = 0;

      for (; i < l; i++) {
        item = cap[i];

        // Remove the list item's bullet
        // so it is seen as the next token.
        space = item.length;
        bull = (/^ *([*+-]|\d+\.) +/).exec(item)[1];
        item = item.replace(/^ *([*+-]|\d+\.) +/, '');

        // @hmhealey only allow newlines in list items if they are followed by indentation to indicate that
        // they're intended to actually be part of the list
        var newlinesInItem = /^([^\n]+)\n(\S[\s\S]+)$/.exec(item);
        if (newlinesInItem && newlinesInItem.length > 0) {
          item = newlinesInItem[1];

          // add any unprocessed input back onto src and exit the list
          src = newlinesInItem[2] + '\n' + cap.slice(i + 1).join('\n') + src;
          l = i + 1;
        }

        // Outdent whatever the
        // list item contains. Hacky.
        if (item.indexOf('\n ') !== -1) {
          space -= item.length;
          item = !this.options.pedantic
            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
            : item.replace(/^ {1,4}/gm, '');
        }

        // Determine whether the next list item belongs here.
        // Backpedal if it does not belong in this list.
        if (this.options.smartLists && i !== l - 1) {
          b = block.bullet.exec(cap[i + 1])[0];
          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
            src = cap.slice(i + 1).join('\n') + src;
            i = l - 1;
          }
        }

        // Determine whether item is loose or not.
        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
        // for discount behavior.
        loose = next || /\n\n(?!\s*$)/.test(item);
        if (i !== l - 1) {
          next = item.charAt(item.length - 1) === '\n';
          if (!loose) loose = next;
        }

        token = {
          type: loose
            ? 'loose_item_start'
            : 'list_item_start'
        };

        // @hmhealey only provide an overridden bullet value for the first list item
        // so that autonumbering still works
        if (ordered && i === 0) {
          token.bullet = bull;
        }

        tokens.push(token);

        // Recurse.
        tokens = tokens.concat(this.token(item, false, bq, links, depth + 1).tokens);

        tokens.push({
          type: 'list_item_end'
        });
      }

      tokens.push({
        type: 'list_end'
      });

      continue;
    }

    // html
    if (cap = this.rules.html.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: this.options.sanitize
          ? 'paragraph'
          : 'html',
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      });
      continue;
    }

    // def
    if ((!bq && top) && (cap = this.rules.def.exec(src))) {
      src = src.substring(cap[0].length);
      links[cap[1].toLowerCase()] = {
        href: cap[2],
        title: cap[3]
      };
      continue;
    }

    // table (gfm)
    if (top && (cap = this.rules.table.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: splitOnPipes(cap[1].replace(/^ *| *\| *$/g, '')),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = splitOnPipes(item.cells[i].replace(/^ *\| *| *\| *$/g, ''));
      }

      tokens.push(item);

      continue;
    }

    // top-level paragraph
    if (top && (cap = this.rules.paragraph.exec(src))) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'paragraph',
        text: cap[1].charAt(cap[1].length - 1) === '\n'
          ? cap[1].slice(0, -1)
          : cap[1]
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      // Top-level should never reach here.
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'text',
        text: cap[0]
      });
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return {
    tokens: tokens,
    links: links
  };
};

/**
 * Inline-Level Grammar
 */

var inline = {
  escape: /^\\([`*{}\[\]()#+\-.!_>|]|\\(?!\w))/,
  autolink: /^<((?:[^ >]+(@|:\/)|www\d{0,3}\.)[^ >]+)>/,
  url: noop,
  tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
  link: /^!?\[(inside)\]\((href)\)/,
  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
  nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
  em: /^_((?:\B__|[^_]|_\B)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
  code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
  br: /^ {2,}\n(?!\s*$)/,
  del: noop,
  text: /^[\s\S]+?(?=[\\<!\[*`]| {2,}\n|\b_|$)/
};

inline._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;
inline._href = /(?:[^()]|\([^()]*\))*/;
inline.link = replace(inline.link)
  ('inside', inline._inside)
  ('href', inline._href)
  ();

// @hmhealey extra regex to separate the url from the title in a link
inline.href = /^\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*$/;

inline.reflink = replace(inline.reflink)
  ('inside', inline._inside)
  ();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: replace(inline.escape)('])', '~|])')(),
  url: XRegExp.cache('^((?:[a-z][\\pL\\d-]+:(?:\\/{1,3}|[\\pL\\d%])|www\\d{0,3}[.]|[\\pL\\d.\\-]+[.]\\pL{2,4}\\/)(?:\\[[\\da-f:]+\\]|[^\\s`!()\\[\\]{};:\'".,<>?«»“”‘’]|[`!\\[\\]{};:\'",<>?«»“”‘’](?=[^\\s()<>])|\\.+(?=[\\pL\\d])|\\((?:[^\\s()<>]|(?:\\([^\\s()<>]+\\)))*\\))+)', ''),
  del: /^~~(?=\S)([\s\S]*?\S)~~/,
  text: replace(inline.text)
    (']|', '~]|\\b[a-z][a-z0-9.+-]{1,31}:|\\bwww\d{0,3}\.|')
    ()
});

/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: replace(inline.br)('{2,}', '*')(),
  text: replace(inline.gfm.text)('{2,}', '*')()
});

/**
 * Inline Lexer & Compiler
 */

function InlineLexer(links, options) {
  this.options = options || marked.defaults;
  this.links = links;
  this.rules = inline.normal;
  this.renderer = this.options.renderer || new Renderer;
  this.renderer.options = this.options;

  if (!this.links) {
    throw new
      Error('Tokens array requires a `links` property.');
  }

  if (this.options.gfm) {
    if (this.options.breaks) {
      this.rules = inline.breaks;
    } else {
      this.rules = inline.gfm;
    }
  } else if (this.options.pedantic) {
    this.rules = inline.pedantic;
  }
}

/**
 * Expose Inline Rules
 */

InlineLexer.rules = inline;

/**
 * Static Lexing/Compiling Method
 */

InlineLexer.output = function(src, links, options) {
  var inline = new InlineLexer(links, options);
  return inline.output(src);
};

/**
 * Lexing/Compiling
 */

InlineLexer.prototype.output = function(src) {
  var link
    , text
    , href
    , title
    , cap
    , subcap
    , tokens = []
    , remaining = -1;

  while (src) {
    // prevent DOS due to a failing regex
    if (src.length === remaining) {
      throw new
        Error('Nothing consumed on last loop at: ' + src);
    }
    remaining = src.length;

    // escape
    if (cap = this.rules.escape.exec(src)) {
      src = src.substring(cap[0].length);

      tokens.push({
        type: 'text',
        text: cap[1]
      });
      continue;
    }

    // autolink
    if (cap = this.rules.autolink.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = cap[1].charAt(6) === ':'
          ? this.mangle(cap[1].substring(7))
          : this.mangle(cap[1]);
        text = escape(text);
        href = this.mangle('mailto:') + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }

      tokens.push({
        type: 'link',
        text: text,
        title: null,
        href: href
      });
      continue;
    }

    // url (gfm)
    if (!this.inLink && (cap = this.rules.url.exec(src))) {
      src = src.substring(cap[0].length);
      text = escape(cap[1]);
      href = text;

      tokens.push({
        type: 'link',
        text: text,
        title: null,
        href: href
      });
      continue;
    }

    // tag
    if (cap = this.rules.tag.exec(src)) {
      if (!this.inLink && /^<a /i.test(cap[0])) {
        this.inLink = true;
      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
        this.inLink = false;
      }
      src = src.substring(cap[0].length);

      if (this.options.sanitize) {
        if (this.options.sanitizer) {
          tokens.push({
            type: 'text',
            text: this.options.sanitizer(cap[0])
          });
        } else {
          tokens.push({
            type: 'text',
            text: escape(cap[0])
          });
        }
      } else {
        tokens.push({
          type: 'text',
          text: cap[0]
        });
      }
      continue;
    }

    // link
    if (cap = this.rules.link.exec(src)) {
      src = src.substring(cap[0].length);
      this.inLink = true;
      subcap = this.rules.href.exec(cap[2]);
      tokens.push({
        type: 'preformatted',
        text: this.outputLink(cap, {
          href: subcap[1],
          title: subcap[2]
        })
      });
      this.inLink = false;
      continue;
    }

    // reflink, nolink
    if ((cap = this.rules.reflink.exec(src))
        || (cap = this.rules.nolink.exec(src))) {
      src = src.substring(cap[0].length);
      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = this.links[link.toLowerCase()];
      if (!link || !link.href) {
        tokens.push({
          type: 'text',
          text: cap[0].charAt(0)
        });
        src = cap[0].substring(1) + src;
        continue;
      }
      this.inLink = true;
      tokens.push({
        type: 'preformatted',
        text: this.outputLink(cap, link)
      });
      this.inLink = false;
      continue;
    }

    // strong
    if (cap = this.rules.strong.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'strong',
        text: this.output(cap[2] || cap[1])
      });
      continue;
    }

    // em
    if (cap = this.rules.em.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'em',
        text: this.output(cap[2] || cap[1])
      });
      continue;
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'code',
        text: escape(cap[2], true)
      });
      continue;
    }

    // br
    if (cap = this.rules.br.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'br'
      });
      continue;
    }

    // del (gfm)
    if (cap = this.rules.del.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'del',
        text: this.output(cap[1])
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      src = src.substring(cap[0].length);
      tokens.push({
        type: 'text',
        text: escape(this.smartypants(cap[0]))
      });
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  // combine adjacent text tokens into one
  tokens = tokens.reduce(function(arr, token) {
    if (arr.length > 0) {
      var prevToken = arr[arr.length - 1];

      if (prevToken.type === 'text' && token.type === 'text') {
        prevToken.text += token.text;
      } else {
        arr.push(token);
      }

      return arr;
    } else {
      return [token];
    }
  }, []);

  return this.renderTokens(tokens);
};

InlineLexer.prototype.renderTokens = function(tokens) {
  var out = '';

  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    switch(token.type) {
      case 'text':
        out += this.renderer.text(token.text);
        break;
      case 'link':
        out += this.renderer.link(token.href, token.title, token.text);
        break;
      case 'preformatted':
        out += token.text;
        break;
      case 'strong':
        out += this.renderer.strong(token.text);
        break;
      case 'em':
        out += this.renderer.em(token.text);
        break;
      case 'code':
        out += this.renderer.codespan(token.text);
        break;
      case 'br':
        out += this.renderer.br();
        break;
      case 'del':
        out += this.renderer.del(token.text);
        break;
      default:
        console.log('unrecognized inline token type ' + token.type);
    }
  }

  return out;
};

/**
 * Compile Link
 */

InlineLexer.prototype.outputLink = function(cap, link) {
  var href = escape(link.href)
    , title = link.title ? escape(link.title) : null;

  return cap[0].charAt(0) !== '!'
    ? this.renderer.link(href, title, this.output(cap[1]))
    : this.renderer.image(href, title, escape(cap[1]));
};

/**
 * Smartypants Transformations
 */

InlineLexer.prototype.smartypants = function(text) {
  if (!this.options.smartypants) return text;
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
};

/**
 * Mangle Links
 */

InlineLexer.prototype.mangle = function(text) {
  if (!this.options.mangle) return text;
  var out = ''
    , l = text.length
    , i = 0
    , ch;

  for (; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
};

/**
 * Renderer
 */

function Renderer(options) {
  this.options = options || {};
}

Renderer.prototype.code = function(code, lang, escaped) {
  if (this.options.highlight) {
    var out = this.options.highlight(code, lang);
    if (out != null && out !== code) {
      escaped = true;
      code = out;
    }
  }

  if (!lang) {
    return '<pre><code>'
      + (escaped ? code : escape(code, true))
      + '</code></pre>';
  }

  return '<pre><code class="'
    + this.options.langPrefix
    + escape(lang, true)
    + '">'
    + (escaped ? code : escape(code, true))
    + '\n</code></pre>\n';
};

Renderer.prototype.blockquote = function(quote) {
  return '<blockquote>\n' + quote + '</blockquote>\n';
};

Renderer.prototype.html = function(html) {
  return html;
};

Renderer.prototype.heading = function(text, level, raw) {
  return '<h'
    + level
    + ' id="'
    + this.options.headerPrefix
    + raw.toLowerCase().replace(/[^\w]+/g, '-')
    + '">'
    + text
    + '</h'
    + level
    + '>\n';
};

Renderer.prototype.hr = function() {
  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
};

Renderer.prototype.list = function(body, ordered) {
  var type = ordered ? 'ol' : 'ul';
  return '<' + type + '>\n' + body + '</' + type + '>\n';
};

Renderer.prototype.listitem = function(text) {
  return '<li>' + text + '</li>\n';
};

Renderer.prototype.paragraph = function(text) {
  return '<p>' + text + '</p>\n';
};

Renderer.prototype.table = function(header, body) {
  return '<table>\n'
    + '<thead>\n'
    + header
    + '</thead>\n'
    + '<tbody>\n'
    + body
    + '</tbody>\n'
    + '</table>\n';
};

Renderer.prototype.tablerow = function(content) {
  return '<tr>\n' + content + '</tr>\n';
};

Renderer.prototype.tablecell = function(content, flags) {
  var type = flags.header ? 'th' : 'td';
  var tag = flags.align
    ? '<' + type + ' style="text-align:' + flags.align + '">'
    : '<' + type + '>';
  return tag + content + '</' + type + '>\n';
};

// span level renderer
Renderer.prototype.strong = function(text) {
  return '<strong>' + text + '</strong>';
};

Renderer.prototype.em = function(text) {
  return '<em>' + text + '</em>';
};

Renderer.prototype.codespan = function(text) {
  return '<code>' + text + '</code>';
};

Renderer.prototype.br = function() {
  return this.options.xhtml ? '<br/>' : '<br>';
};

Renderer.prototype.del = function(text) {
  return '<del>' + text + '</del>';
};

Renderer.prototype.link = function(href, title, text) {
  if (this.options.sanitize) {
    try {
      var prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return '';
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
      return '';
    }
  }
  var out = '<a href="' + href + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};

Renderer.prototype.image = function(href, title, text) {
  var out = '<img src="' + href + '" alt="' + text + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += this.options.xhtml ? '/>' : '>';
  return out;
};

Renderer.prototype.text = function(text) {
  return text;
};

/**
 * Parsing & Compiling
 */

function Parser(options) {
  this.tokens = [];
  this.token = null;
  this.options = options || marked.defaults;
  this.options.renderer = this.options.renderer || new Renderer;
  this.renderer = this.options.renderer;
  this.renderer.options = this.options;
}

/**
 * Static Parse Method
 */

Parser.parse = function(tokens, links, options, renderer) {
  var parser = new Parser(options, renderer);
  return parser.parse(tokens, links);
};

/**
 * Parse Loop
 */

Parser.prototype.parse = function(tokens, links) {
  this.inline = new InlineLexer(links, this.options, this.renderer);
  this.tokens = tokens.reverse();

  var out = '';
  while (this.next()) {
    out += this.tok();
  }

  return out;
};

/**
 * Next Token
 */

Parser.prototype.next = function() {
  return this.token = this.tokens.pop();
};

/**
 * Preview Next Token
 */

Parser.prototype.peek = function() {
  return this.tokens[this.tokens.length - 1] || 0;
};

/**
 * Parse Text Tokens
 */

Parser.prototype.parseText = function() {
  var body = this.token.text;

  while (this.peek().type === 'text') {
    body += '\n' + this.next().text;
  }

  return this.inline.output(body);
};

/**
 * Parse Current Token
 */

Parser.prototype.tok = function() {
  switch (this.token.type) {
    case 'space': {
      return '';
    }
    case 'hr': {
      return this.renderer.hr();
    }
    case 'heading': {
      return this.renderer.heading(
        this.inline.output(this.token.text),
        this.token.depth,
        this.token.text);
    }
    case 'code': {
      return this.renderer.code(this.token.text,
        this.token.lang,
        this.token.escaped);
    }
    case 'table': {
      var header = ''
        , body = ''
        , i
        , row
        , cell
        , flags
        , j;

      // header
      cell = '';
      for (i = 0; i < this.token.header.length; i++) {
        flags = { header: true, align: this.token.align[i] };
        cell += this.renderer.tablecell(
          this.inline.output(this.token.header[i]),
          { header: true, align: this.token.align[i] }
        );
      }
      header += this.renderer.tablerow(cell);

      for (i = 0; i < this.token.cells.length; i++) {
        row = this.token.cells[i];

        cell = '';
        for (j = 0; j < row.length; j++) {
          cell += this.renderer.tablecell(
            this.inline.output(row[j]),
            { header: false, align: this.token.align[j] }
          );
        }

        body += this.renderer.tablerow(cell);
      }
      return this.renderer.table(header, body);
    }
    case 'blockquote_start': {
      var body = '';

      while (this.next().type !== 'blockquote_end') {
        body += this.tok();
      }

      return this.renderer.blockquote(body);
    }
    case 'list_start': {
      var body = ''
        , ordered = this.token.ordered;

      while (this.next().type !== 'list_end') {
        body += this.tok();
      }

      return this.renderer.list(body, ordered);
    }
    case 'list_item_start': {
      var body = ''
        , bullet = this.token.bullet;

      while (this.next().type !== 'list_item_end') {
        body += this.token.type === 'text'
          ? this.parseText()
          : this.tok();
      }

      return this.renderer.listitem(body, bullet);
    }
    case 'loose_item_start': {
      var body = ''
        , bullet = this.token.bullet;

      while (this.next().type !== 'list_item_end') {
        body += this.tok();
      }

      return this.renderer.listitem(body, bullet);
    }
    case 'html': {
      var html = !this.token.pre && !this.options.pedantic
        ? this.inline.output(this.token.text)
        : this.token.text;
      return this.renderer.html(html);
    }
    case 'paragraph': {
      return this.renderer.paragraph(this.inline.output(this.token.text));
    }
    case 'text': {
      return this.renderer.paragraph(this.parseText());
    }
  }
};

/**
 * Helpers
 */

function escape(html, encode) {
  return html
    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function unescape(html) {
	// explicitly match decimal, hex, and named HTML entities 
  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function(_, n) {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

function replace(regex, opt) {
  regex = regex.source;
  opt = opt || '';
  return function self(name, val) {
    if (!name) return new RegExp(regex, opt);
    val = val.source || val;
    val = val.replace(/(^|[^\[])\^/g, '$1');
    regex = regex.replace(name, val);
    return self;
  };
}

function noop() {}
noop.exec = noop;

function merge(obj) {
  var i = 1
    , target
    , key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}

function splitOnPipes(str) {
  var start = 0;
  var parts = [];

  for (var i = 0; i < str.length; i++) {
    if (str[i] === '|' && (i === 0 || str[i - 1] !== '\\')) {
      parts.push(str.substring(start, i).trim());
      start = i + 1;
    }

    if (i === str.length - 1) {
      parts.push(str.substring(start, str.length).trim());
    }
  }

  return parts;
}


/**
 * Marked
 */

function marked(src, opt, callback) {
  if (callback || typeof opt === 'function') {
    if (!callback) {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});

    var highlight = opt.highlight
      , lexed
      , pending
      , i = 0;

    try {
      lexed = Lexer.lex(src, opt)
    } catch (e) {
      return callback(e);
    }

    pending = tokens.length;

    var done = function(err) {
      if (err) {
        opt.highlight = highlight;
        return callback(err);
      }

      var out;

      try {
        out = Parser.parse(lexed.tokens, lexed.links, opt);
      } catch (e) {
        err = e;
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!pending) return done();

    for (; i < tokens.length; i++) {
      (function(token) {
        if (token.type !== 'code') {
          return --pending || done();
        }
        return highlight(token.text, token.lang, function(err, code) {
          if (err) return done(err);
          if (code == null || code === token.text) {
            return --pending || done();
          }
          token.text = code;
          token.escaped = true;
          --pending || done();
        });
      })(tokens[i]);
    }

    return;
  }
  try {
    if (opt) opt = merge({}, marked.defaults, opt);

    var lexed = Lexer.lex(src, opt);

    return Parser.parse(lexed.tokens, lexed.links, opt);
  } catch (e) {
    if ((opt || marked.defaults).silent) {
      return '<p>An error occured:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  return marked;
};

marked.defaults = {
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  sanitizer: null,
  mangle: false,
  smartLists: false,
  silent: false,
  highlight: null,
  langPrefix: 'lang-',
  smartypants: false,
  headerPrefix: '',
  renderer: new Renderer,
  xhtml: false
};

/**
 * Expose
 */

marked.Parser = Parser;
marked.parser = Parser.parse;

marked.Renderer = Renderer;

marked.Lexer = Lexer;
marked.lexer = Lexer.lex;

marked.InlineLexer = InlineLexer;
marked.inlineLexer = InlineLexer.output;

marked.parse = marked;

if (true) {
  module.exports = marked;
} else if (typeof define === 'function' && define.amd) {
  define(function() { return marked; });
} else {
  this.marked = marked;
}

}).call(function() {
  return this || (typeof window !== 'undefined' ? window : global);
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keyMirror = __webpack_require__(302);

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _keyMirror2.default)({
    POST_LIST_SCROLL_CHANGE: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/c9564dbb91f79bc157bb27f7a4f95846.png";

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteEmoji = exports.addEmoji = undefined;

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var addEmoji = exports.addEmoji = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(emoji, image, success, error) {
        var _ref2, data, err;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return EmojiActions.createCustomEmoji(emoji, image)(_redux_store2.default.dispatch, _redux_store2.default.getState);

                    case 2:
                        _ref2 = _context.sent;
                        data = _ref2.data;
                        err = _ref2.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function addEmoji(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
    };
}();

var deleteEmoji = exports.deleteEmoji = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(emojiId, success, error) {
        var _ref4, data, err;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return EmojiActions.deleteCustomEmoji(emojiId)(_redux_store2.default.dispatch, _redux_store2.default.getState);

                    case 2:
                        _ref4 = _context2.sent;
                        data = _ref4.data;
                        err = _ref4.error;

                        if (data) {
                            // Needed to remove recently used emoji
                            _app_dispatcher2.default.handleServerAction({
                                type: _constants.ActionTypes.REMOVED_CUSTOM_EMOJI,
                                id: emojiId
                            });

                            if (success) {
                                success(data);
                            }
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function deleteEmoji(_x5, _x6, _x7) {
        return _ref3.apply(this, arguments);
    };
}();

exports.loadRecentlyUsedCustomEmojis = loadRecentlyUsedCustomEmojis;
exports.incrementEmojiPickerPage = incrementEmojiPickerPage;

var _emojis = __webpack_require__(853);

var EmojiActions = _interopRequireWildcard(_emojis);

var _emojis2 = __webpack_require__(961);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _emoji_store = __webpack_require__(829);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

var _constants = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadRecentlyUsedCustomEmojis() {
    var _this = this;

    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var recentEmojis, emojiMap, missingEmojis;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(getState().entities.general.config.EnableCustomEmoji !== 'true')) {
                                _context3.next = 2;
                                break;
                            }

                            return _context3.abrupt('return', { data: true });

                        case 2:
                            recentEmojis = _emoji_store2.default.getRecentEmojis();
                            emojiMap = (0, _emojis2.getEmojiMap)(getState());
                            missingEmojis = recentEmojis.filter(function (name) {
                                return !emojiMap.has(name);
                            });


                            missingEmojis.forEach(function (name) {
                                EmojiActions.getCustomEmojiByName(name)(dispatch, getState);
                            });

                            return _context3.abrupt('return', { data: true });

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        return function (_x8, _x9) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function incrementEmojiPickerPage() {
    var _this2 = this;

    return function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatch) {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({
                                type: _constants.ActionTypes.INCREMENT_EMOJI_PICKER_PAGE
                            });

                            return _context4.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this2);
        }));

        return function (_x10) {
            return _ref6.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(856),
    now = __webpack_require__(1956),
    toNumber = __webpack_require__(1957);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _deleteProperty = __webpack_require__(176);

var _deleteProperty2 = _interopRequireDefault(_deleteProperty);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// A component that can be used to make controlled inputs that function properly in certain
// environments (ie. IE11) where typing quickly would sometimes miss inputs
// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var QuickInput = function (_React$PureComponent) {
    (0, _inherits3.default)(QuickInput, _React$PureComponent);

    function QuickInput() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, QuickInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuickInput.__proto__ || (0, _getPrototypeOf2.default)(QuickInput)).call.apply(_ref, [this].concat(args))), _this), _this.updateInputFromProps = function () {
            if (!_this.input || _this.input.value === _this.props.value) {
                return;
            }

            _this.input.value = _this.props.value;
        }, _this.getInput = function () {
            return _this.input;
        }, _this.setInput = function (input) {
            _this.input = input;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(QuickInput, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.value !== this.props.value) {
                if (this.props.delayInputUpdate) {
                    requestAnimationFrame(this.updateInputFromProps);
                } else {
                    this.updateInputFromProps();
                }
            }
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.input.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.input.blur();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                value = _props.value,
                inputComponent = _props.inputComponent,
                props = (0, _objectWithoutProperties3.default)(_props, ['value', 'inputComponent']);


            (0, _deleteProperty2.default)(props, 'delayInputUpdate');

            return _react2.default.createElement(inputComponent || 'input', (0, _extends3.default)({}, props, {
                ref: this.setInput,
                defaultValue: value // Only set the defaultValue since the real one will be updated using componentDidUpdate
            }));
        }
    }, {
        key: 'value',
        get: function get() {
            return this.input.value;
        },
        set: function set(value) {
            this.input.value = value;
        }
    }]);
    return QuickInput;
}(_react2.default.PureComponent);

QuickInput.propTypes = {

    /**
     * Whether to delay updating the value of the textbox from props. Should only be used
     * on textboxes that to properly compose CJK characters as the user types.
     */
    delayInputUpdate: _propTypes2.default.bool,

    /**
     * An optional React component that will be used instead of an HTML input when rendering
     */
    inputComponent: _propTypes2.default.func,

    /**
     * The string value displayed in this input
     */
    value: _propTypes2.default.string.isRequired
};
QuickInput.defaultProps = {
    delayInputUpdate: false
};
exports.default = QuickInput;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var GetLinkModal = function (_React$PureComponent) {
    (0, _inherits3.default)(GetLinkModal, _React$PureComponent);

    function GetLinkModal(props) {
        (0, _classCallCheck3.default)(this, GetLinkModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GetLinkModal.__proto__ || (0, _getPrototypeOf2.default)(GetLinkModal)).call(this, props));

        _this.onHide = function () {
            _this.setState({ copiedLink: false });
            _this.props.onHide();
        };

        _this.copyLink = function () {
            var textarea = _this.refs.textarea;
            textarea.focus();
            textarea.setSelectionRange(0, _this.props.link.length);

            try {
                if (document.execCommand('copy')) {
                    _this.setState({ copiedLink: true });
                } else {
                    _this.setState({ copiedLink: false });
                }
            } catch (err) {
                _this.setState({ copiedLink: false });
            }
        };

        _this.state = {
            copiedLink: false
        };
        return _this;
    }

    (0, _createClass3.default)(GetLinkModal, [{
        key: 'render',
        value: function render() {
            var helpText = null;
            if (this.props.helpText) {
                helpText = _react2.default.createElement(
                    'p',
                    null,
                    this.props.helpText,
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null)
                );
            }

            var copyLink = null;

            if (document.queryCommandSupported('copy')) {
                copyLink = _react2.default.createElement(
                    'button',
                    {
                        id: 'linkModalCopyLink',
                        'data-copy-btn': 'true',
                        type: 'button',
                        className: 'btn btn-primary pull-left',
                        onClick: this.copyLink
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'get_link.copy',
                        defaultMessage: 'Copy Link'
                    })
                );
            }

            var linkText = _react2.default.createElement('textarea', {
                id: 'linkModalTextArea',
                className: 'form-control no-resize min-height',
                ref: 'textarea',
                value: this.props.link,
                onClick: this.copyLink,
                readOnly: true
            });

            var copyLinkConfirm = null;
            if (this.state.copiedLink) {
                copyLinkConfirm = _react2.default.createElement(
                    'p',
                    { className: 'alert alert-success alert--confirm' },
                    _react2.default.createElement('i', { className: 'fa fa-check' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'get_link.clipboard',
                        defaultMessage: ' Link copied'
                    })
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.props.show,
                    onHide: this.onHide
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        'h4',
                        { className: 'modal-title' },
                        this.props.title
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    helpText,
                    linkText
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'linkModalCloseButton',
                            type: 'button',
                            className: 'btn btn-default',
                            onClick: this.onHide
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'get_link.close',
                            defaultMessage: 'Close'
                        })
                    ),
                    copyLink,
                    copyLinkConfirm
                )
            );
        }
    }]);
    return GetLinkModal;
}(_react2.default.PureComponent);

GetLinkModal.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    onHide: _propTypes2.default.func.isRequired,
    title: _propTypes2.default.string.isRequired,
    helpText: _propTypes2.default.string,
    link: _propTypes2.default.string.isRequired
};
GetLinkModal.defaultProps = {
    helpText: null
};
exports.default = GetLinkModal;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getFilesForPost = getFilesForPost;
exports.getMissingFilesForPost = getMissingFilesForPost;
exports.uploadFile = uploadFile;
exports.getFilePublicLink = getFilePublicLink;

var _reduxBatchedActions = __webpack_require__(278);

var _client = __webpack_require__(270);

var _action_types = __webpack_require__(3);

var _errors = __webpack_require__(828);

var _helpers = __webpack_require__(821);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getFilesForPost(postId) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var files;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.FileTypes.FETCH_FILES_FOR_POST_REQUEST }, getState);
                            files = void 0;
                            _context.prev = 2;
                            _context.next = 5;
                            return _client.Client4.getFileInfosForPost(postId);

                        case 5:
                            files = _context.sent;
                            _context.next = 13;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.FileTypes.FETCH_FILES_FOR_POST_FAILURE, error: _context.t0 }, (0, _errors.logError)(_context.t0)(dispatch)]), getState);
                            return _context.abrupt('return', { error: _context.t0 });

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.FileTypes.RECEIVED_FILES_FOR_POST,
                                data: files,
                                postId: postId
                            }, {
                                type: _action_types.FileTypes.FETCH_FILES_FOR_POST_SUCCESS
                            }]), getState);

                            return _context.abrupt('return', { data: true });

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[2, 8]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function getMissingFilesForPost(postId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var fileIdsByPostId, posts;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            fileIdsByPostId = getState().entities.files.fileIdsByPostId;
                            posts = [];

                            if (fileIdsByPostId[postId]) {
                                _context2.next = 6;
                                break;
                            }

                            _context2.next = 5;
                            return getFilesForPost(postId)(dispatch, getState);

                        case 5:
                            posts = _context2.sent;

                        case 6:
                            return _context2.abrupt('return', { data: posts });

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function uploadFile(channelId, rootId, clientIds, fileFormData, formBoundary) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var files, failure, data;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.FileTypes.UPLOAD_FILES_REQUEST }, getState);

                            files = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.uploadFile(fileFormData, formBoundary);

                        case 5:
                            files = _context3.sent;
                            _context3.next = 14;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch, getState);

                            failure = {
                                type: _action_types.FileTypes.UPLOAD_FILES_FAILURE,
                                clientIds: clientIds,
                                channelId: channelId,
                                rootId: rootId,
                                error: _context3.t0
                            };


                            dispatch((0, _reduxBatchedActions.batchActions)([failure, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', { error: _context3.t0 });

                        case 14:
                            data = files.file_infos.map(function (file, index) {
                                return _extends({}, file, {
                                    clientId: files.client_ids[index]
                                });
                            });


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.FileTypes.RECEIVED_UPLOAD_FILES,
                                data: data,
                                channelId: channelId,
                                rootId: rootId
                            }, {
                                type: _action_types.FileTypes.UPLOAD_FILES_SUCCESS
                            }]), getState);

                            return _context3.abrupt('return', { data: files });

                        case 17:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function getFilePublicLink(fileId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getFilePublicLink, _action_types.FileTypes.GET_FILE_PUBLIC_LINK_REQUEST, [_action_types.FileTypes.RECEIVED_FILE_PUBLIC_LINK, _action_types.FileTypes.GET_FILE_PUBLIC_LINK_SUCCESS], _action_types.FileTypes.GET_FILE_PUBLIC_LINK_FAILURE, fileId);
}

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFilePublicLink = getFilePublicLink;
exports.makeGetFilesForPost = makeGetFilesForPost;

var _reselect = __webpack_require__(78);

function getAllFiles(state) {
    return state.entities.files.files;
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getFilesIdsForPost(state, postId) {
    if (postId) {
        return state.entities.files.fileIdsByPostId[postId] || [];
    }

    return [];
}

function getFilePublicLink(state) {
    return state.entities.files.filePublicLink;
}

function makeGetFilesForPost() {
    return (0, _reselect.createSelector)([getAllFiles, getFilesIdsForPost], function (allFiles, fileIdsForPost) {
        return fileIdsForPost.map(function (id) {
            return allFiles[id];
        }).filter(function (id) {
            return Boolean(id);
        });
    });
}

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateSeparator = function (_React$PureComponent) {
    (0, _inherits3.default)(DateSeparator, _React$PureComponent);

    function DateSeparator() {
        (0, _classCallCheck3.default)(this, DateSeparator);
        return (0, _possibleConstructorReturn3.default)(this, (DateSeparator.__proto__ || (0, _getPrototypeOf2.default)(DateSeparator)).apply(this, arguments));
    }

    (0, _createClass3.default)(DateSeparator, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    className: 'date-separator'
                },
                _react2.default.createElement('hr', { className: 'separator__hr' }),
                _react2.default.createElement(
                    'div',
                    { className: 'separator__text' },
                    _react2.default.createElement(_reactIntl.FormattedDate, {
                        value: this.props.date,
                        weekday: 'short',
                        month: 'short',
                        day: '2-digit',
                        year: 'numeric'
                    })
                )
            );
        }
    }]);
    return DateSeparator;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

DateSeparator.propTypes = {

    /*
     * The date to display in the separator
     */
    date: _propTypes2.default.instanceOf(Date)
};
exports.default = DateSeparator;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _file_utils = __webpack_require__(887);

var _view_image = __webpack_require__(2041);

var _view_image2 = _interopRequireDefault(_view_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    return {
        canDownloadFiles: (0, _file_utils.canDownloadFiles)(config),
        enablePublicLink: config.EnablePublicLink === 'true'
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_view_image2.default);

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _posts = __webpack_require__(808);

var Actions = _interopRequireWildcard(_posts);

var _emojis = __webpack_require__(877);

var _channels = __webpack_require__(783);

var _posts2 = __webpack_require__(805);

var _general = __webpack_require__(113);

var _reaction_list = __webpack_require__(2051);

var _reaction_list2 = _interopRequireDefault(_reaction_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function makeMapStateToProps() {
    var getReactionsForPost = (0, _posts2.makeGetReactionsForPost)();

    return function mapStateToProps(state, ownProps) {
        var config = (0, _general.getConfig)(state);
        var enableEmojiPicker = config.EnableEmojiPicker === 'true' && !ownProps.isReadOnly;

        var channel = (0, _channels.getChannel)(state, ownProps.post.channel_id) || {};
        var teamId = channel.team_id;

        return {
            teamId: teamId,
            reactions: getReactionsForPost(state, ownProps.post.id),
            emojis: (0, _emojis.getCustomEmojisByName)(state),
            enableEmojiPicker: enableEmojiPicker
        };
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getReactionsForPost: Actions.getReactionsForPost,
            addReaction: Actions.addReaction
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_reaction_list2.default);

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _post_body_additional_content = __webpack_require__(2063);

var _post_body_additional_content2 = _interopRequireDefault(_post_body_additional_content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var enableLinkPreviews = config.EnableLinkPreviews === 'true';
    var hasImageProxy = config.HasImageProxy === 'true';

    return {
        enableLinkPreviews: enableLinkPreviews,
        hasImageProxy: hasImageProxy
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_post_body_additional_content2.default);

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _constants = __webpack_require__(19);

var _preferences = __webpack_require__(784);

var _post_message_view = __webpack_require__(2073);

var _post_message_view2 = _interopRequireDefault(_post_message_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    return {
        enableFormatting: (0, _preferences.getBool)(state, _constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'formatting', true),
        pluginPostTypes: state.plugins.postTypes,
        theme: (0, _preferences.getTheme)(state)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_post_message_view2.default);

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _rhs = __webpack_require__(817);

var _webrtc = __webpack_require__(1176);

var _rhs2 = __webpack_require__(818);

var _constants = __webpack_require__(29);

var _search_bar = __webpack_require__(2078);

var _search_bar2 = _interopRequireDefault(_search_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var rhsState = (0, _rhs2.getRhsState)(state);

    return {
        isSearchingTerm: (0, _rhs2.getIsSearchingTerm)(state),
        searchTerms: (0, _rhs2.getSearchTerms)(state),
        isMentionSearch: rhsState === _constants.RHSStates.MENTION,
        isFlaggedPosts: rhsState === _constants.RHSStates.FLAG
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            updateSearchTerms: _rhs.updateSearchTerms,
            showSearchResults: _rhs.showSearchResults,
            showMentions: _rhs.showMentions,
            showFlaggedPosts: _rhs.showFlaggedPosts,
            closeRightHandSide: _rhs.closeRightHandSide,
            closeWebrtc: _webrtc.closeWebrtc
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_search_bar2.default);

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(SearchIcon, _React$PureComponent);

    function SearchIcon() {
        (0, _classCallCheck3.default)(this, SearchIcon);
        return (0, _possibleConstructorReturn3.default)(this, (SearchIcon.__proto__ || (0, _getPrototypeOf2.default)(SearchIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(SearchIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '14px',
                        height: '14px',
                        viewBox: '0 0 19 18'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'inherit',
                            strokeWidth: '1',
                            fill: 'none',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-719.000000, -20.000000)',
                                strokeWidth: '1.5'
                            },
                            _react2.default.createElement(
                                'g',
                                { transform: 'translate(0.000000, 1.000000)' },
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(63.000000, 10.000000)' },
                                    _react2.default.createElement(
                                        'g',
                                        { transform: 'translate(657.000000, 10.000000)' },
                                        _react2.default.createElement('circle', {
                                            cx: '7',
                                            cy: '7',
                                            r: '7'
                                        }),
                                        _react2.default.createElement('path', {
                                            d: 'M12.5,11.5 L16.5,15.5',
                                            strokeLinecap: 'round'
                                        })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return SearchIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = SearchIcon;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _about_build_modal = __webpack_require__(2091);

var _about_build_modal2 = _interopRequireDefault(_about_build_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        config: (0, _general.getConfig)(state),
        license: (0, _general.getLicense)(state)
    });
} // Copyright (c) 2017 Mattermost Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_about_build_modal2.default);

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactSelect = __webpack_require__(1333);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var _save_button = __webpack_require__(925);

var _save_button2 = _interopRequireDefault(_save_button);

var _multiselect_list = __webpack_require__(2104);

var _multiselect_list2 = _interopRequireDefault(_multiselect_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var KeyCodes = _constants2.default.KeyCodes;

var MultiSelect = function (_React$Component) {
    (0, _inherits3.default)(MultiSelect, _React$Component);

    function MultiSelect(props) {
        (0, _classCallCheck3.default)(this, MultiSelect);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MultiSelect.__proto__ || (0, _getPrototypeOf2.default)(MultiSelect)).call(this, props));

        _this.nextPage = function () {
            if (_this.props.handlePageChange) {
                _this.props.handlePageChange(_this.state.page + 1, _this.state.page);
            }
            _this.refs.list.setSelected(0);
            _this.setState({ page: _this.state.page + 1 });
        };

        _this.prevPage = function () {
            if (_this.state.page === 0) {
                return;
            }

            if (_this.props.handlePageChange) {
                _this.props.handlePageChange(_this.state.page - 1, _this.state.page);
            }
            _this.refs.list.setSelected(0);
            _this.setState({ page: _this.state.page - 1 });
        };

        _this.resetPaging = function () {
            _this.setState({ page: 0 });
        };

        _this.onSelect = function (selected) {
            _this.selected = selected;
        };

        _this.onAdd = function (value) {
            if (_this.props.maxValues && _this.props.values.length >= _this.props.maxValues) {
                return;
            }

            for (var i = 0; i < _this.props.values.length; i++) {
                if (_this.props.values[i].id === value.id) {
                    return;
                }
            }

            _this.props.handleAdd(value);
            _this.selected = null;
            _this.refs.select.handleInputChange({ target: { value: '' } });
            _this.onInput('');
            _this.refs.select.focus();

            var submitImmediatelyOn = _this.props.submitImmediatelyOn;
            if (submitImmediatelyOn && submitImmediatelyOn(value)) {
                _this.props.handleSubmit([value]);
            }
        };

        _this.onInput = function (input) {
            if (input === '') {
                _this.refs.list.setSelected(-1);
            } else {
                _this.refs.list.setSelected(0);
            }
            _this.selected = null;

            _this.props.handleInput(input);
        };

        _this.onInputKeyDown = function (e) {
            switch (e.key) {
                case KeyCodes.ENTER[0]:
                    e.preventDefault();
                    break;
            }
        };

        _this.handleEnterPress = function (e) {
            switch (e.key) {
                case KeyCodes.ENTER[0]:
                    if (_this.selected == null) {
                        _this.props.handleSubmit();
                        return;
                    }
                    _this.onAdd(_this.selected);
                    break;
            }
        };

        _this.handleOnClick = function (e) {
            e.preventDefault();
            _this.props.handleSubmit();
        };

        _this.onChange = function (values) {
            if (values.length < _this.props.values.length) {
                _this.props.handleDelete(values);
            }
        };

        _this.handleRender = function () {
            return null;
        };

        _this.selected = null;

        _this.state = {
            page: 0
        };
        return _this;
    }

    (0, _createClass3.default)(MultiSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('keydown', this.handleEnterPress);
            this.refs.select.focus();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.handleEnterPress);
        }
    }, {
        key: 'render',
        value: function render() {
            var options = (0, _assign2.default)([], this.props.options);
            var values = this.props.values;

            var numRemainingText = void 0;
            if (this.props.numRemainingText) {
                numRemainingText = this.props.numRemainingText;
            } else if (this.props.maxValues != null) {
                numRemainingText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'multiselect.numRemaining',
                    defaultMessage: 'You can add {num, number} more. ',
                    values: {
                        num: this.props.maxValues - this.props.values.length
                    }
                });
            }

            var buttonSubmitText = void 0;
            if (this.props.buttonSubmitText) {
                buttonSubmitText = this.props.buttonSubmitText;
            } else if (this.props.maxValues != null) {
                buttonSubmitText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'multiselect.go',
                    defaultMessage: 'Go'
                });
            }

            var optionsToDisplay = [];
            var nextButton = void 0;
            var previousButton = void 0;
            var noteTextContainer = void 0;

            if (this.props.noteText) {
                noteTextContainer = _react2.default.createElement(
                    'div',
                    { className: 'multi-select__note' },
                    _react2.default.createElement(
                        'div',
                        { className: 'note__icon' },
                        _react2.default.createElement('span', { className: 'fa fa-info' })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        this.props.noteText
                    )
                );
            }

            var valueMap = {};
            for (var i = 0; i < values.length; i++) {
                valueMap[values[i].id] = true;
            }

            for (var _i = options.length - 1; _i >= 0; _i--) {
                if (valueMap[options[_i].id]) {
                    options.splice(_i, 1);
                }
            }

            if (options && options.length > this.props.perPage) {
                var pageStart = this.state.page * this.props.perPage;
                var pageEnd = pageStart + this.props.perPage;
                optionsToDisplay = options.slice(pageStart, pageEnd);
                if (!this.props.loading) {
                    if (options.length > pageEnd) {
                        nextButton = _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-default filter-control filter-control__next',
                                onClick: this.nextPage
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'filtered_user_list.next',
                                defaultMessage: 'Next'
                            })
                        );
                    }

                    if (this.state.page > 0) {
                        previousButton = _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-default filter-control filter-control__prev',
                                onClick: this.prevPage
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'filtered_user_list.prev',
                                defaultMessage: 'Previous'
                            })
                        );
                    }
                }
            } else {
                optionsToDisplay = options;
            }

            return _react2.default.createElement(
                'div',
                { className: 'filtered-user-list' },
                _react2.default.createElement(
                    'div',
                    { className: 'filter-row filter-row--full' },
                    _react2.default.createElement(
                        'div',
                        { className: 'multi-select__container' },
                        _react2.default.createElement(_reactSelect2.default, {
                            ref: 'select',
                            multi: true,
                            options: this.props.options,
                            joinValues: true,
                            clearable: false,
                            openOnFocus: true,
                            onInputChange: this.onInput,
                            onInputKeyDown: this.onInputKeyDown,
                            onBlurResetsInput: false,
                            onCloseResetsInput: false,
                            onChange: this.onChange,
                            value: this.props.values,
                            valueKey: this.props.valueKey,
                            valueRenderer: this.props.valueRenderer,
                            menuRenderer: this.handleRender,
                            arrowRenderer: this.handleRender,
                            noResultsText: null,
                            placeholder: (0, _utils.localizeMessage)('multiselect.placeholder', 'Search and add members')
                        }),
                        _react2.default.createElement(_save_button2.default, {
                            saving: this.props.saving,
                            disabled: this.props.saving,
                            onClick: this.handleOnClick,
                            defaultMessage: buttonSubmitText
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'multi-select__help' },
                        numRemainingText,
                        noteTextContainer
                    )
                ),
                _react2.default.createElement(_multiselect_list2.default, {
                    ref: 'list',
                    options: optionsToDisplay,
                    optionRenderer: this.props.optionRenderer,
                    page: this.state.page,
                    perPage: this.props.perPage,
                    onPageChange: this.props.handlePageChange,
                    onAdd: this.onAdd,
                    onSelect: this.onSelect,
                    loading: this.props.loading
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'filter-controls' },
                    previousButton,
                    nextButton
                )
            );
        }
    }]);
    return MultiSelect;
}(_react2.default.Component);

exports.default = MultiSelect;


MultiSelect.propTypes = {
    options: _propTypes2.default.arrayOf(_propTypes2.default.object),
    optionRenderer: _propTypes2.default.func,
    values: _propTypes2.default.arrayOf(_propTypes2.default.object),
    valueKey: _propTypes2.default.string,
    valueRenderer: _propTypes2.default.func,
    handleInput: _propTypes2.default.func,
    handleDelete: _propTypes2.default.func,
    perPage: _propTypes2.default.number,
    handlePageChange: _propTypes2.default.func,
    handleAdd: _propTypes2.default.func,
    handleSubmit: _propTypes2.default.func,
    noteText: _propTypes2.default.node,
    maxValues: _propTypes2.default.number,
    numRemainingText: _propTypes2.default.node,
    buttonSubmitText: _propTypes2.default.node,
    submitImmediatelyOn: _propTypes2.default.func,
    saving: _propTypes2.default.bool,
    loading: _propTypes2.default.bool
};

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _teams = __webpack_require__(274);

var _team_members_modal = __webpack_require__(2106);

var _team_members_modal2 = _interopRequireDefault(_team_members_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        currentTeam: (0, _teams.getCurrentTeam)(state)
    });
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_team_members_modal2.default);

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _async_load = __webpack_require__(282);

var _settings_sidebar = __webpack_require__(1336);

var _settings_sidebar2 = _interopRequireDefault(_settings_sidebar);

var _team_settings = __webpack_require__(2114);

var _team_settings2 = _interopRequireDefault(_team_settings);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var holders = (0, _reactIntl.defineMessages)({
    generalTab: {
        id: 'team_settings_modal.generalTab',
        defaultMessage: 'General'
    },
    importTab: {
        id: 'team_settings_modal.importTab',
        defaultMessage: 'Import'
    }
});

var TeamSettingsModal = function (_React$Component) {
    (0, _inherits3.default)(TeamSettingsModal, _React$Component);

    function TeamSettingsModal(props) {
        (0, _classCallCheck3.default)(this, TeamSettingsModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamSettingsModal.__proto__ || (0, _getPrototypeOf2.default)(TeamSettingsModal)).call(this, props));

        _this.updateTab = function (tab) {
            _this.setState({
                activeTab: tab,
                activeSection: ''
            });

            if (!Utils.isMobile()) {
                (0, _jquery2.default)('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
            }
        };

        _this.updateSection = function (section) {
            if ((0, _jquery2.default)('.section-max').length) {
                (0, _jquery2.default)('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
            }

            _this.setState({ activeSection: section });
        };

        _this.closeModal = function () {
            _this.props.onModalDismissed();
        };

        _this.collapseModal = function () {
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this.refs.modalBody)).closest('.modal-dialog').removeClass('display--content');

            _this.setState({
                active_tab: '',
                active_section: ''
            });
        };

        _this.handleHide = function () {
            _this.props.onModalDismissed();
        };

        _this.handleHidden = function () {
            _this.setState({
                activeTab: 'general',
                activeSection: ''
            });
        };

        _this.state = {
            activeTab: 'general',
            activeSection: ''
        };
        return _this;
    }

    (0, _createClass3.default)(TeamSettingsModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!Utils.isMobile()) {
                (0, _jquery2.default)('.settings-modal .settings-content').perfectScrollbar();
            }
        }

        // called after the dialog is fully hidden and faded out

    }, {
        key: 'render',
        value: function render() {
            var formatMessage = this.props.intl.formatMessage;

            var tabs = [];
            tabs.push({ name: 'general', uiName: formatMessage(holders.generalTab), icon: 'icon fa fa-cog' });
            tabs.push({ name: 'import', uiName: formatMessage(holders.importTab), icon: 'icon fa fa-upload' });

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'settings-modal settings-modal--action',
                    show: this.props.show,
                    onHide: this.handleHide,
                    onExited: this.handleHidden
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_settings_modal.title',
                            defaultMessage: 'Team Settings'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    { ref: 'modalBody' },
                    _react2.default.createElement(
                        'div',
                        { className: 'settings-table' },
                        _react2.default.createElement(
                            'div',
                            { className: 'settings-links' },
                            _react2.default.createElement(_async_load.AsyncComponent, {
                                doLoad: _settings_sidebar2.default,
                                tabs: tabs,
                                activeTab: this.state.activeTab,
                                updateTab: this.updateTab
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'settings-content minimize-settings' },
                            _react2.default.createElement(_team_settings2.default, {
                                activeTab: this.state.activeTab,
                                activeSection: this.state.activeSection,
                                updateSection: this.updateSection,
                                closeModal: this.closeModal,
                                collapseModal: this.collapseModal
                            })
                        )
                    )
                )
            );
        }
    }]);
    return TeamSettingsModal;
}(_react2.default.Component);

TeamSettingsModal.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    show: _propTypes2.default.bool,
    onModalDismissed: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)(TeamSettingsModal);

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _rhs = __webpack_require__(817);

var _tutorial_tip = __webpack_require__(2120);

var _tutorial_tip2 = _interopRequireDefault(_tutorial_tip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            closeRhsMenu: _rhs.closeMenu
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_tutorial_tip2.default);

/***/ }),
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1369),
    castFunction = __webpack_require__(1376);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(836),
    stubFalse = __webpack_require__(2187);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1374);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(980),
    stackClear = __webpack_require__(2202),
    stackDelete = __webpack_require__(2203),
    stackGet = __webpack_require__(2204),
    stackHas = __webpack_require__(2205),
    stackSet = __webpack_require__(2206);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 1077 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(891),
    root = __webpack_require__(836);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2211),
    mapCacheDelete = __webpack_require__(2218),
    mapCacheGet = __webpack_require__(2220),
    mapCacheHas = __webpack_require__(2221),
    mapCacheSet = __webpack_require__(2222);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(2231),
    stubArray = __webpack_require__(1388);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(833),
    isSymbol = __webpack_require__(967);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(1382);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIsLhsOpen = getIsLhsOpen;
// Copyright (c) 2018 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getIsLhsOpen(state) {
    return state.views.lhs.isOpen;
}

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _users2 = __webpack_require__(777);

var _general = __webpack_require__(113);

var _more_direct_channels = __webpack_require__(2382);

var _more_direct_channels2 = _interopRequireDefault(_more_direct_channels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var currentChannelMembers = [];
    if (ownProps.isExistingChannel) {
        currentChannelMembers = (0, _users2.getProfilesInCurrentChannel)(state);
    }

    var config = (0, _general.getConfig)(state);
    var restrictDirectMessage = config.RestrictDirectMessage;

    return {
        currentChannelMembers: currentChannelMembers,
        currentUserId: (0, _users2.getCurrentUserId)(state),
        restrictDirectMessage: restrictDirectMessage
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getProfiles: _users.getProfiles,
            getProfilesInTeam: _users.getProfilesInTeam
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_more_direct_channels2.default);

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(MenuIcon, _React$PureComponent);

    function MenuIcon() {
        (0, _classCallCheck3.default)(this, MenuIcon);
        return (0, _possibleConstructorReturn3.default)(this, (MenuIcon.__proto__ || (0, _getPrototypeOf2.default)(MenuIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(MenuIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '16px',
                        height: '10px',
                        viewBox: '0 0 16 10',
                        version: '1.1'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-188.000000, -38.000000)',
                                fillRule: 'nonzero',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                null,
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        { transform: 'translate(188.000000, 38.000000)' },
                                        _react2.default.createElement('path', { d: 'M15.5,0 C15.776,0 16,0.224 16,0.5 L16,1.5 C16,1.776 15.776,2 15.5,2 L0.5,2 C0.224,2 0,1.776 0,1.5 L0,0.5 C0,0.224 0.224,0 0.5,0 L15.5,0 Z M15.5,4 C15.776,4 16,4.224 16,4.5 L16,5.5 C16,5.776 15.776,6 15.5,6 L0.5,6 C0.224,6 0,5.776 0,5.5 L0,4.5 C0,4.224 0.224,4 0.5,4 L15.5,4 Z M15.5,8 C15.776,8 16,8.224 16,8.5 L16,9.5 C16,9.776 15.776,10 15.5,10 L0.5,10 C0.224,10 0,9.776 0,9.5 L0,8.5 C0,8.224 0.224,8 0.5,8 L15.5,8 Z' })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return MenuIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = MenuIcon;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobeIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(GlobeIcon, _React$PureComponent);

    function GlobeIcon() {
        (0, _classCallCheck3.default)(this, GlobeIcon);
        return (0, _possibleConstructorReturn3.default)(this, (GlobeIcon.__proto__ || (0, _getPrototypeOf2.default)(GlobeIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(GlobeIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '13px',
                        height: '13px',
                        viewBox: '0 0 14 14'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-115.000000, -147.000000)',
                                fillRule: 'nonzero',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                { transform: 'translate(95.000000, 0.000000)' },
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(20.000000, 113.000000)' },
                                    _react2.default.createElement(
                                        'g',
                                        { transform: 'translate(0.000000, 34.000000)' },
                                        _react2.default.createElement('path', { d: 'M10.409,0.893375 C9.40275,0.329875 8.24075,0.00875 7,0 C3.13075,0 0,3.140375 0,7 C0,10.521875 2.594375,13.42775 5.97625,13.93 C6.314875,13.974625 6.6535,14 7,14 C8.24075,14 9.40275,13.678875 10.409,13.1145 C12.551875,11.918375 14,9.6285 14,7 C13.99125,4.3715 12.551875,2.090375 10.409,0.893375 Z M11.554375,4.375 L9.431625,4.375 C9.302125,3.5 9.10875,2.736125 8.86725,2.085125 C10.003875,2.519125 10.9515,3.5 11.554375,4.375 Z M6.941375,1.73775 C6.960625,1.736875 6.979875,1.73425 7,1.73425 C7.020125,1.73425 7.039375,1.736875 7.058625,1.73775 C7.340375,2.172625 7.697375,3.5 7.92225,4.375 L6.07775,4.375 C6.302625,3.5 6.659625,2.172625 6.941375,1.73775 Z M1.81475,7.875 C1.7675,7.875 1.73425,7.29925 1.73425,7 C1.73425,6.70075 1.764875,6.125 1.813,6.125 L4.396875,6.125 C4.384625,6.125 4.375,6.7025 4.375,7 C4.375,7.2975 4.384625,7.875 4.396875,7.875 L1.81475,7.875 Z M4.354875,11.54475 C4.346125,11.54475 4.337375,11.54475 4.337375,11.536 C3.548125,11.07575 2.893625,10.5 2.436875,9.625 L4.568375,9.625 C4.697875,10.5 4.890375,11.262125 5.131875,11.91225 C4.8615,11.81075 4.599875,11.692625 4.354875,11.54475 Z M4.568375,4.375 L2.443875,4.375 C3.045875,3.5 3.994375,2.517375 5.131875,2.083375 C4.89125,2.734375 4.697875,3.5 4.568375,4.375 Z M7.0595,12.26225 C7.039375,12.26225 7.020125,12.26575 7,12.26575 C6.979875,12.26575 6.960625,12.26225 6.9405,12.26225 C6.65875,11.8265 6.302625,11.375 6.07775,9.625 L7.921375,9.625 C7.697375,11.375 7.34125,11.8265 7.0595,12.26225 Z M8.11125,7.875 L5.88875,7.875 C5.873875,7.875 5.8625,7.30625 5.8625,7 C5.8625,6.69375 5.873875,6.125 5.88875,6.125 L8.11125,6.125 C8.126125,6.125 8.1375,6.69375 8.1375,7 C8.1375,7.30625 8.126125,7.875 8.11125,7.875 Z M10.409,11.0075 C10.13075,11.242 9.828,11.45025 9.506875,11.631375 C9.30125,11.74075 9.086875,11.839625 8.8655,11.923625 C9.107,11.270875 9.30125,10.5 9.431625,9.625 L11.557875,9.625 C11.25425,10.5 10.8675,10.618125 10.409,11.0075 Z M9.603125,7.875 C9.615375,7.875 9.625,7.2975 9.625,7 C9.625,6.7025 9.615375,6.125 9.603125,6.125 L12.186125,6.125 C12.235125,6.125 12.26575,6.70075 12.26575,7 C12.26575,7.29925 12.233375,7.875 12.18525,7.875 L9.603125,7.875 Z' })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return GlobeIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = GlobeIcon;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LockIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(LockIcon, _React$PureComponent);

    function LockIcon() {
        (0, _classCallCheck3.default)(this, LockIcon);
        return (0, _possibleConstructorReturn3.default)(this, (LockIcon.__proto__ || (0, _getPrototypeOf2.default)(LockIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(LockIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '12px',
                        height: '13px',
                        viewBox: '0 0 13 15'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-116.000000, -175.000000)',
                                fillRule: 'nonzero',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                { transform: 'translate(95.000000, 0.000000)' },
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(20.000000, 113.000000)' },
                                    _react2.default.createElement(
                                        'g',
                                        { transform: 'translate(1.000000, 62.000000)' },
                                        _react2.default.createElement('path', { d: 'M12.0714286,6.5 L11.1428571,6.5 L11.1428571,4.64285714 C11.1428571,2.07814286 9.06471429,0 6.5,0 C3.93528571,0 1.85714286,2.07814286 1.85714286,4.64285714 L1.85714286,6.5 L0.928571429,6.5 C0.415071429,6.5 0,7.00792857 0,7.52142857 L0,13.9285714 C0,14.4420714 0.415071429,14.8571429 0.928571429,14.8571429 L12.0714286,14.8571429 C12.5849286,14.8571429 13,14.4420714 13,13.9285714 L13,7.52142857 C13,7.00792857 12.5849286,6.5 12.0714286,6.5 Z M6.5,1.85714286 C8.03585714,1.85714286 9.28571429,3.107 9.28571429,4.64285714 L9.28571429,6.5 L8.35714286,6.5 L4.64285714,6.5 L3.71428571,6.5 L3.71428571,4.64285714 C3.71428571,3.107 4.96414286,1.85714286 6.5,1.85714286 Z' })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return LockIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = LockIcon;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(783);

var _channel_members_modal = __webpack_require__(2423);

var _channel_members_modal2 = _interopRequireDefault(_channel_members_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        canManageChannelMembers: (0, _channels.canManageChannelMembers)(state)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_channel_members_modal2.default);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _reselect = __webpack_require__(78);

var _preferences = __webpack_require__(784);

var _channels = __webpack_require__(798);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _edit_channel_header_modal = __webpack_require__(2434);

var _edit_channel_header_modal2 = _interopRequireDefault(_edit_channel_header_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = (0, _reselect.createSelector)(function (state) {
    return (0, _preferences.getBool)(state, _constants2.default.Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter');
}, function (_ref) {
    var requests = _ref.requests;
    var updateChannel = requests.channels.updateChannel;

    return {
        serverError: updateChannel.error,
        requestStatus: updateChannel.status
    };
}, function (ctrlSend, submitInfo) {
    return (0, _extends3.default)({
        ctrlSend: ctrlSend
    }, submitInfo);
}); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


function mapDispatchToProps(dispatch) {
    return {
        actions: {
            patchChannel: (0, _redux.bindActionCreators)(_channels.patchChannel, dispatch)
        }
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_edit_channel_header_modal2.default);

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(173).EventEmitter;
var inherits = __webpack_require__(77);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(1091);
Stream.Writable = __webpack_require__(2498);
Stream.Duplex = __webpack_require__(2499);
Stream.Transform = __webpack_require__(2500);
Stream.PassThrough = __webpack_require__(2501);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1426);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(1093);
exports.Duplex = __webpack_require__(892);
exports.Transform = __webpack_require__(1429);
exports.PassThrough = __webpack_require__(2497);


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(45)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(987);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(79);
util.inherits = __webpack_require__(77);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(295)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(1427);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(1092).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(1428);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(892);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(892);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(294).setImmediate, __webpack_require__(8)))

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
var createHash = __webpack_require__(914);
var inherits = __webpack_require__(77)

var Transform = __webpack_require__(1090).Transform

var ZEROS = new Buffer(128)
ZEROS.fill(0)

function Hmac(alg, key) {
  Transform.call(this)
  alg = alg.toLowerCase()
  if (typeof key === 'string') {
    key = new Buffer(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = createHash(alg).update(key).digest()

  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = new Buffer(blocksize)
  var opad = this._opad = new Buffer(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = createHash(alg).update(ipad)
}

inherits(Hmac, Transform)

Hmac.prototype.update = function (data, enc) {
  this._hash.update(data, enc)

  return this
}

Hmac.prototype._transform = function (data, _, next) {
  this._hash.update(data)

  next()
}

Hmac.prototype._flush = function (next) {
  this.push(this.digest())

  next()
}

Hmac.prototype.digest = function (enc) {
  var h = this._hash.digest()

  return createHash(this._alg).update(this._opad).update(h).digest(enc)
}

module.exports = function createHmac(alg, key) {
  return new Hmac(alg, key)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(2505)
exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
var deciphers = __webpack_require__(2507)
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
var modes = __webpack_require__(990)
function getCiphers () {
  return Object.keys(modes)
}
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(2509);
exports.Cipher = __webpack_require__(2510);
exports.DES = __webpack_require__(2511);
exports.CBC = __webpack_require__(2512);
exports.EDE = __webpack_require__(2513);


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(806);
var randomBytes = __webpack_require__(937);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1098 */,
/* 1099 */,
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

// A method for quickly swapping in/out CSS properties to get correct calculations.
return function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(918)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr ) {
	"use strict";

	return arr.concat;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(918)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( arr ) {
	"use strict";

	return arr.push;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(943)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( class2type ) {
	"use strict";

	return class2type.toString;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1000)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( hasOwn ) {
	"use strict";

	return hasOwn.toString;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(812)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document ) {
	"use strict";

	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}

	return DOMEval;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1584),
	__webpack_require__(1004),
	__webpack_require__(1106),
	__webpack_require__(1006),
	__webpack_require__(815) // Get jQuery.contains
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, rboxStyle, rnumnonpx, getStyles, support ) {

"use strict";

function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}

return curCSS;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1002)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, rcssNum ) {

"use strict";

function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}

return adjustCSS;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}

return addGetHookIf;

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	// Match a standalone tag
	return ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1001),
	__webpack_require__(807),
	__webpack_require__(1112),
	__webpack_require__(815)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, indexOf, isFunction, rneedsContext ) {

"use strict";

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(815)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {
	"use strict";

	return jQuery.expr.match.needsContext;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(812),
	__webpack_require__(1587),
	__webpack_require__(897)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document ) {

"use strict";

// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(920),
	__webpack_require__(859),
	__webpack_require__(1009)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, camelCase, rnothtmlwhite, acceptData ) {

"use strict";

function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};

return Data;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1114)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Data ) {
	"use strict";

	return new Data();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(815)

	// css is assumed
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {
	"use strict";

	// isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
	// through the CSS cascade), which is useful in deciding whether or not to make it visible.
	// It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
	// * A hidden ancestor does not force an element to be classified as hidden.
	// * Being disconnected from the document does not force an element to be classified as hidden.
	// These differences improve the behavior of .toggle() et al. when applied to elements that are
	// detached or contained within hidden ancestors (gh-2404, gh-2863).
	return function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(896),
	__webpack_require__(1118),
	__webpack_require__(1119),
	__webpack_require__(1120),
	__webpack_require__(1121),
	__webpack_require__(1122)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, toType, rtagName, rscriptType, wrapMap, getAll, setGlobalEval ) {

"use strict";

var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}

return buildFragment;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /^$|^module$|\/(?:java|ecma)script/i );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

return wrapMap;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(876)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, nodeName ) {

"use strict";

function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}

return getAll;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(844)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( dataPriv ) {

"use strict";

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}

return setGlobalEval;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /^(?:checkbox|radio)$/i );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(875),
	__webpack_require__(1012),
	__webpack_require__(815)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access, support ) {

"use strict";

var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return ( /\?/ );
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return Date.now();
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(896),
	__webpack_require__(1123),
	__webpack_require__(807),
	__webpack_require__(834),
	__webpack_require__(898), // filter
	__webpack_require__(1124)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, toType, rcheckableType, isFunction ) {

"use strict";

var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(1622)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1629);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1648);
module.exports = __webpack_require__(12).Object.values;


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(69);
var toIObject = __webpack_require__(56);
var isEnum = __webpack_require__(91).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
module.exports = Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__(878);

var _has = /*#__PURE__*/__webpack_require__(1020);

var _isArguments = /*#__PURE__*/__webpack_require__(1679);

// cover IE < 9 keys issues


var hasEnumBug = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
// Safari bug
var hasArgsEnumBug = /*#__PURE__*/function () {
  'use strict';

  return arguments.propertyIsEnumerable('length');
}();

var contains = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};

/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var _keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
} : function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
  for (prop in obj) {
    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];
      if (_has(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }
      nIdx -= 1;
    }
  }
  return ks;
};
var keys = /*#__PURE__*/_curry1(_keys);
module.exports = keys;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = /*#__PURE__*/__webpack_require__(1019);

var _curry1 = /*#__PURE__*/__webpack_require__(878);

var _curry2 = /*#__PURE__*/__webpack_require__(846);

var _curryN = /*#__PURE__*/__webpack_require__(1682);

/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */


var curryN = /*#__PURE__*/_curry2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});
module.exports = curryN;

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var NodePrototype = module.exports = {
	get firstChild() {
		var children = this.children;
		return children && children[0] || null;
	},
	get lastChild() {
		var children = this.children;
		return children && children[children.length - 1] || null;
	},
	get nodeType() {
		return nodeTypes[this.type] || nodeTypes.element;
	}
};

var domLvl1 = {
	tagName: "name",
	childNodes: "children",
	parentNode: "parent",
	previousSibling: "prev",
	nextSibling: "next",
	nodeValue: "data"
};

var nodeTypes = {
	element: 1,
	text: 3,
	cdata: 4,
	comment: 8
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(NodePrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ShouldProcessNodeDefinitions = __webpack_require__(1696);
var ProcessNodeDefinitions = __webpack_require__(1137);

function ProcessingInstructions() {
  var processNodeDefinitions = new ProcessNodeDefinitions();

  return {
    defaultProcessingInstructions: [{
      shouldProcessNode: ShouldProcessNodeDefinitions.shouldProcessEveryNode,
      processNode: processNodeDefinitions.processDefaultNode,
    },],
  };
};

module.exports = ProcessingInstructions;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(1138);

// eslint-disable-next-line max-len
// https://github.com/facebook/react/blob/15.0-stable/src/renderers/dom/shared/ReactDOMComponent.js#L457
var voidElementTags = [
  'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param',
  'source', 'track', 'wbr', 'menuitem', 'textarea',
];

function ProcessNodeDefinitions() {
  function processDefaultNode(node, children, index) {
    if (node.type === 'text') {
      return node.data;
    } else if (node.type === 'comment') {
      // FIXME: The following doesn't work as the generated HTML results in
      // "&lt;!--  This is a comment  --&gt;"
      // return '<!-- ' + node.data + ' -->';
      return false;
    }

    if (voidElementTags.indexOf(node.name) > -1) {
      return utils.createElement(node, index);
    } else {
      return utils.createElement(node, index, node.data, children);
    }
  }

  return {
    processDefaultNode: processDefaultNode,
  };
}

module.exports = ProcessNodeDefinitions;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var camelize = __webpack_require__(1697);
var toPairs = __webpack_require__(1707);
var reduce = __webpack_require__(1708);
var React = __webpack_require__(14);
var camelCaseAttrMap = __webpack_require__(1710);

function createStyleJsonFromString(styleString) {
  styleString = styleString || '';
  var styles = styleString.split(/;(?!base64)/);
  var singleStyle, key, value, jsonStyles = {};
  for (var i = 0; i < styles.length; ++i) {
    singleStyle = styles[i].split(':');
    if (singleStyle.length > 2) {
      singleStyle[1] = singleStyle.slice(1).join(':');
    }

    key = singleStyle[0];
    value = singleStyle[1];
    if (typeof value === 'string'){
      value = value.trim();
    }

    if (key != null && value != null && key.length > 0 && value.length > 0) {
      jsonStyles[camelize(key)] = value;
    }
  }
  return jsonStyles;
}

function createElement(node, index, data, children) {
  var elementProps = {
    key: index,
  };
  if (node.attribs) {
    elementProps = reduce(function(result, keyAndValue) {
      var key = keyAndValue[0];
      var value = keyAndValue[1];
      key = camelCaseAttrMap[key.replace(/[-:]/, '')] || key;
      if (key === 'style') {
        value = createStyleJsonFromString(value);
      } else if (key === 'class') {
        key = 'className';
      } else if (key === 'for') {
        key = 'htmlFor';
      }
      if (typeof value === 'string') {
        value = value;
      }
      result[key] = value || key;
      return result;
    }, elementProps, toPairs(node.attribs));
  }

  children = children || [];
  var allChildren = data != null ? [data,].concat(children) : children;
  return React.createElement.apply(
    null, [node.name, elementProps,].concat(allChildren)
  );
}

module.exports = {
  createElement: createElement,
};


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

module.exports = function forEach(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(i, arr[i]);
  }
};


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function alwaysValid() {
  return true;
}

module.exports = {
  alwaysValid: alwaysValid,
};


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _users = __webpack_require__(777);

var _at_mention = __webpack_require__(1711);

var _at_mention2 = _interopRequireDefault(_at_mention);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        currentUserId: (0, _users.getCurrentUserId)(state),
        usersByUsername: (0, _users.getUsersByUsername)(state)
    };
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_at_mention2.default);

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(296), __esModule: true };

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1144), __esModule: true };

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1722);
module.exports = __webpack_require__(12).Object.entries;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(1725);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(1147);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(1735);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1731)();
}


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activeElement;

var _ownerDocument = __webpack_require__(902);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeElement() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();

  try {
    return doc.activeElement;
  } catch (e) {/* ie throws if no active element */}
}
module.exports = exports['default'];

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(903);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(880);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(1150);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(904);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(1025);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(1026);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(862);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(953);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(902);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(880);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(952);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(954);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(904);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(1752);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;

var _contains = __webpack_require__(903);

var _contains2 = _interopRequireDefault(_contains);

var _isWindow = __webpack_require__(953);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(902);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function offset(node) {
  var doc = (0, _ownerDocument2.default)(node),
      win = (0, _isWindow2.default)(doc),
      docElem = doc && doc.documentElement,
      box = { top: 0, left: 0, height: 0, width: 0 };

  if (!doc) return;

  // Make sure it's not a disconnected DOM node
  if (!(0, _contains2.default)(docElem, node)) return box;

  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();

  // IE8 getBoundingClientRect doesn't support width & height
  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };

  return box;
}
module.exports = exports['default'];

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(953);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}
module.exports = exports['default'];

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _users = __webpack_require__(777);

var _timezone = __webpack_require__(1029);

var _timezone_utils = __webpack_require__(923);

var _preferences = __webpack_require__(784);

var _constants = __webpack_require__(29);

var _local_date_time = __webpack_require__(1764);

var _local_date_time2 = _interopRequireDefault(_local_date_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, props) {
    var config = (0, _general.getConfig)(state);
    var currentUserId = (0, _users.getCurrentUserId)(state);

    var userTimezone = void 0;
    if (props.userTimezone) {
        userTimezone = props.userTimezone;
    } else {
        userTimezone = (0, _timezone.getUserTimezone)(state, currentUserId);
    }

    return {
        enableTimezone: config.ExperimentalTimezone === 'true',
        useMilitaryTime: (0, _preferences.getBool)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.USE_MILITARY_TIME, false),
        timeZone: (0, _timezone_utils.getUserCurrentTimezone)(userTimezone)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_local_date_time2.default);

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadPluginsIfNecessary = exports.initializePlugins = undefined;

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var initializePlugins = exports.initializePlugins = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _ref2, data, error;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(_redux_store2.default.getState().entities.general.config.PluginsEnabled !== 'true')) {
                            _context.next = 2;
                            break;
                        }

                        return _context.abrupt('return');

                    case 2:
                        _context.next = 4;
                        return getPlugins()(_redux_store2.default.dispatch);

                    case 4:
                        _ref2 = _context.sent;
                        data = _ref2.data;
                        error = _ref2.error;

                        if (!error) {
                            _context.next = 10;
                            break;
                        }

                        console.error(error); //eslint-disable-line no-console
                        return _context.abrupt('return');

                    case 10:
                        if (!(data == null || data.length === 0)) {
                            _context.next = 12;
                            break;
                        }

                        return _context.abrupt('return');

                    case 12:

                        data.forEach(function (m) {
                            loadPlugin(m);
                        });

                    case 13:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function initializePlugins() {
        return _ref.apply(this, arguments);
    };
}();

var loadPluginsIfNecessary = exports.loadPluginsIfNecessary = function () {
    var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var oldManifests, _ref5, error, newManifests;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        if (!(_redux_store2.default.getState().entities.general.config.PluginsEnabled !== 'true')) {
                            _context3.next = 2;
                            break;
                        }

                        return _context3.abrupt('return');

                    case 2:
                        oldManifests = _redux_store2.default.getState().plugins.plugins;
                        _context3.next = 5;
                        return getPlugins()(_redux_store2.default.dispatch);

                    case 5:
                        _ref5 = _context3.sent;
                        error = _ref5.error;

                        if (!error) {
                            _context3.next = 10;
                            break;
                        }

                        console.error(error); //eslint-disable-line no-console
                        return _context3.abrupt('return');

                    case 10:
                        newManifests = _redux_store2.default.getState().plugins.plugins;

                        // Get new plugins and update existing plugins if version changed

                        (0, _values2.default)(newManifests).forEach(function (newManifest) {
                            var oldManifest = oldManifests[newManifest.id];
                            if (!oldManifest || oldManifest.version !== newManifest.version) {
                                loadPlugin(newManifest);
                            }
                        });

                        // Remove old plugins
                        (0, _keys2.default)(oldManifests).forEach(function (id) {
                            if (!newManifests.hasOwnProperty(id)) {
                                var oldManifest = oldManifests[id];
                                _redux_store2.default.dispatch({ type: _constants.ActionTypes.REMOVED_WEBAPP_PLUGIN, data: oldManifest });
                                removePlugin(oldManifest);
                            }
                        });

                    case 13:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function loadPluginsIfNecessary() {
        return _ref4.apply(this, arguments);
    };
}();

exports.registerComponents = registerComponents;
exports.getPlugins = getPlugins;
exports.loadPlugin = loadPlugin;
exports.removePlugin = removePlugin;

var _client = __webpack_require__(270);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants = __webpack_require__(29);

var _url = __webpack_require__(793);

var _text_formatting = __webpack_require__(811);

var _post_utils = __webpack_require__(803);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

// EXPERIMENTAL - SUBJECT TO CHANGE

window.plugins = {};

// Common libraries exposed on window for plugins to access
window.react = __webpack_require__(14);
window['react-dom'] = __webpack_require__(272);
window.redux = __webpack_require__(1);
window['react-redux'] = __webpack_require__(268);
window['react-bootstrap'] = __webpack_require__(772);
window['post-utils'] = { formatText: _text_formatting.formatText, messageHtmlToComponent: _post_utils.messageHtmlToComponent };

function registerComponents(id) {
    var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var postTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var mainMenuActions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    var wrappedComponents = {};
    (0, _keys2.default)(components).forEach(function (name) {
        wrappedComponents[name] = { component: components[name], id: id };
    });

    _redux_store2.default.dispatch({
        type: _constants.ActionTypes.RECEIVED_PLUGIN_COMPONENTS,
        data: wrappedComponents
    });

    var wrappedPostTypes = {};
    (0, _keys2.default)(postTypes).forEach(function (type) {
        wrappedPostTypes[type] = { component: postTypes[type], id: id };
    });

    _redux_store2.default.dispatch({
        type: _constants.ActionTypes.RECEIVED_PLUGIN_POST_TYPES,
        data: wrappedPostTypes
    });

    var wrappedMainMenuActions = mainMenuActions.map(function (action) {
        return (0, _extends3.default)({ id: id }, action);
    });

    _redux_store2.default.dispatch({
        type: _constants.ActionTypes.RECEIVED_PLUGIN_MENU_ACTIONS,
        data: wrappedMainMenuActions
    });
}

function getPlugins() {
    var _this = this;

    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatch) {
            var plugins;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            plugins = void 0;
                            _context2.prev = 1;
                            _context2.next = 4;
                            return _client.Client4.getWebappPlugins();

                        case 4:
                            plugins = _context2.sent;
                            _context2.next = 10;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](1);
                            return _context2.abrupt('return', { error: _context2.t0 });

                        case 10:

                            dispatch({ type: _constants.ActionTypes.RECEIVED_WEBAPP_PLUGINS, data: plugins });

                            return _context2.abrupt('return', { data: plugins });

                        case 12:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[1, 7]]);
        }));

        return function (_x4) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function loadPlugin(manifest) {
    function onLoad() {
        // Initialize the plugin
        console.log('Registering ' + manifest.id + ' plugin...'); //eslint-disable-line no-console
        var plugin = window.plugins[manifest.id];
        plugin.initialize(registerComponents.bind(null, manifest.id), _redux_store2.default);
        console.log('...done'); //eslint-disable-line no-console
    }

    // Backwards compatibility for old plugins
    var bundlePath = manifest.webapp.bundle_path;
    if (bundlePath.includes('/static/') && !bundlePath.includes('/static/plugins/')) {
        bundlePath = bundlePath.replace('/static/', '/static/plugins/');
    }

    var script = document.createElement('script');
    script.id = 'plugin_' + manifest.id;
    script.type = 'text/javascript';
    script.src = (0, _url.getSiteURL)() + bundlePath;
    script.onload = onLoad;
    document.getElementsByTagName('head')[0].appendChild(script);
}

function removePlugin(manifest) {
    var script = document.getElementById('plugin_' + manifest.id);
    script.parentNode.removeChild(script);
    console.log('Removed ' + manifest.id + ' plugin'); //eslint-disable-line no-console
}

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.format = format;
exports.formatWithRenderer = formatWithRenderer;

var _marked = __webpack_require__(1033);

var _marked2 = _interopRequireDefault(_marked);

var _renderer = __webpack_require__(1777);

var _renderer2 = _interopRequireDefault(_renderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function format(text) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return formatWithRenderer(text, new _renderer2.default(null, options));
}

function formatWithRenderer(text, renderer) {
    var markdownOptions = {
        renderer: renderer,
        sanitize: true,
        gfm: true,
        tables: true,
        mangle: false
    };

    return (0, _marked2.default)(text, markdownOptions);
}

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(1778);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

exports.highlight = highlight;
exports.getLanguageFromFileExtension = getLanguageFromFileExtension;
exports.canHighlight = canHighlight;
exports.getLanguageName = getLanguageName;

var _highlight = __webpack_require__(1781);

var _highlight2 = _interopRequireDefault(_highlight);

var _actionscript = __webpack_require__(1782);

var _actionscript2 = _interopRequireDefault(_actionscript);

var _applescript = __webpack_require__(1783);

var _applescript2 = _interopRequireDefault(_applescript);

var _bash = __webpack_require__(1784);

var _bash2 = _interopRequireDefault(_bash);

var _clojure = __webpack_require__(1785);

var _clojure2 = _interopRequireDefault(_clojure);

var _coffeescript = __webpack_require__(1786);

var _coffeescript2 = _interopRequireDefault(_coffeescript);

var _cpp = __webpack_require__(1787);

var _cpp2 = _interopRequireDefault(_cpp);

var _cs = __webpack_require__(1788);

var _cs2 = _interopRequireDefault(_cs);

var _css = __webpack_require__(1789);

var _css2 = _interopRequireDefault(_css);

var _d = __webpack_require__(1790);

var _d2 = _interopRequireDefault(_d);

var _dart = __webpack_require__(1791);

var _dart2 = _interopRequireDefault(_dart);

var _delphi = __webpack_require__(1792);

var _delphi2 = _interopRequireDefault(_delphi);

var _diff = __webpack_require__(1793);

var _diff2 = _interopRequireDefault(_diff);

var _django = __webpack_require__(1794);

var _django2 = _interopRequireDefault(_django);

var _dockerfile = __webpack_require__(1795);

var _dockerfile2 = _interopRequireDefault(_dockerfile);

var _erlang = __webpack_require__(1796);

var _erlang2 = _interopRequireDefault(_erlang);

var _fortran = __webpack_require__(1797);

var _fortran2 = _interopRequireDefault(_fortran);

var _fsharp = __webpack_require__(1798);

var _fsharp2 = _interopRequireDefault(_fsharp);

var _gcode = __webpack_require__(1799);

var _gcode2 = _interopRequireDefault(_gcode);

var _go = __webpack_require__(1800);

var _go2 = _interopRequireDefault(_go);

var _groovy = __webpack_require__(1801);

var _groovy2 = _interopRequireDefault(_groovy);

var _handlebars = __webpack_require__(1802);

var _handlebars2 = _interopRequireDefault(_handlebars);

var _haskell = __webpack_require__(1803);

var _haskell2 = _interopRequireDefault(_haskell);

var _haxe = __webpack_require__(1804);

var _haxe2 = _interopRequireDefault(_haxe);

var _java = __webpack_require__(1805);

var _java2 = _interopRequireDefault(_java);

var _javascript = __webpack_require__(1806);

var _javascript2 = _interopRequireDefault(_javascript);

var _json = __webpack_require__(1807);

var _json2 = _interopRequireDefault(_json);

var _julia = __webpack_require__(1808);

var _julia2 = _interopRequireDefault(_julia);

var _kotlin = __webpack_require__(1809);

var _kotlin2 = _interopRequireDefault(_kotlin);

var _less = __webpack_require__(1810);

var _less2 = _interopRequireDefault(_less);

var _lisp = __webpack_require__(1811);

var _lisp2 = _interopRequireDefault(_lisp);

var _lua = __webpack_require__(1812);

var _lua2 = _interopRequireDefault(_lua);

var _makefile = __webpack_require__(1813);

var _makefile2 = _interopRequireDefault(_makefile);

var _markdown = __webpack_require__(1814);

var _markdown2 = _interopRequireDefault(_markdown);

var _matlab = __webpack_require__(1815);

var _matlab2 = _interopRequireDefault(_matlab);

var _objectivec = __webpack_require__(1816);

var _objectivec2 = _interopRequireDefault(_objectivec);

var _ocaml = __webpack_require__(1817);

var _ocaml2 = _interopRequireDefault(_ocaml);

var _perl = __webpack_require__(1818);

var _perl2 = _interopRequireDefault(_perl);

var _php = __webpack_require__(1819);

var _php2 = _interopRequireDefault(_php);

var _powershell = __webpack_require__(1820);

var _powershell2 = _interopRequireDefault(_powershell);

var _puppet = __webpack_require__(1821);

var _puppet2 = _interopRequireDefault(_puppet);

var _python = __webpack_require__(1822);

var _python2 = _interopRequireDefault(_python);

var _r = __webpack_require__(1823);

var _r2 = _interopRequireDefault(_r);

var _ruby = __webpack_require__(1824);

var _ruby2 = _interopRequireDefault(_ruby);

var _rust = __webpack_require__(1825);

var _rust2 = _interopRequireDefault(_rust);

var _scala = __webpack_require__(1826);

var _scala2 = _interopRequireDefault(_scala);

var _scheme = __webpack_require__(1827);

var _scheme2 = _interopRequireDefault(_scheme);

var _scss = __webpack_require__(1828);

var _scss2 = _interopRequireDefault(_scss);

var _smalltalk = __webpack_require__(1829);

var _smalltalk2 = _interopRequireDefault(_smalltalk);

var _sql = __webpack_require__(1830);

var _sql2 = _interopRequireDefault(_sql);

var _stylus = __webpack_require__(1831);

var _stylus2 = _interopRequireDefault(_stylus);

var _swift = __webpack_require__(1832);

var _swift2 = _interopRequireDefault(_swift);

var _tex = __webpack_require__(1833);

var _tex2 = _interopRequireDefault(_tex);

var _vbnet = __webpack_require__(1834);

var _vbnet2 = _interopRequireDefault(_vbnet);

var _vbscript = __webpack_require__(1835);

var _vbscript2 = _interopRequireDefault(_vbscript);

var _verilog = __webpack_require__(1836);

var _verilog2 = _interopRequireDefault(_verilog);

var _xml = __webpack_require__(1837);

var _xml2 = _interopRequireDefault(_xml);

var _yaml = __webpack_require__(1838);

var _yaml2 = _interopRequireDefault(_yaml);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _text_formatting = __webpack_require__(811);

var TextFormatting = _interopRequireWildcard(_text_formatting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

_highlight2.default.registerLanguage('actionscript', _actionscript2.default);
_highlight2.default.registerLanguage('applescript', _applescript2.default);
_highlight2.default.registerLanguage('bash', _bash2.default);
_highlight2.default.registerLanguage('clojure', _clojure2.default);
_highlight2.default.registerLanguage('coffeescript', _coffeescript2.default);
_highlight2.default.registerLanguage('cpp', _cpp2.default);
_highlight2.default.registerLanguage('cs', _cs2.default);
_highlight2.default.registerLanguage('css', _css2.default);
_highlight2.default.registerLanguage('d', _d2.default);
_highlight2.default.registerLanguage('dart', _dart2.default);
_highlight2.default.registerLanguage('delphi', _delphi2.default);
_highlight2.default.registerLanguage('diff', _diff2.default);
_highlight2.default.registerLanguage('django', _django2.default);
_highlight2.default.registerLanguage('dockerfile', _dockerfile2.default);
_highlight2.default.registerLanguage('erlang', _erlang2.default);
_highlight2.default.registerLanguage('fortran', _fortran2.default);
_highlight2.default.registerLanguage('fsharp', _fsharp2.default);
_highlight2.default.registerLanguage('gcode', _gcode2.default);
_highlight2.default.registerLanguage('go', _go2.default);
_highlight2.default.registerLanguage('groovy', _groovy2.default);
_highlight2.default.registerLanguage('handlebars', _handlebars2.default);
_highlight2.default.registerLanguage('haskell', _haskell2.default);
_highlight2.default.registerLanguage('haxe', _haxe2.default);
_highlight2.default.registerLanguage('java', _java2.default);
_highlight2.default.registerLanguage('javascript', _javascript2.default);
_highlight2.default.registerLanguage('json', _json2.default);
_highlight2.default.registerLanguage('julia', _julia2.default);
_highlight2.default.registerLanguage('kotlin', _kotlin2.default);
_highlight2.default.registerLanguage('less', _less2.default);
_highlight2.default.registerLanguage('lisp', _lisp2.default);
_highlight2.default.registerLanguage('lua', _lua2.default);
_highlight2.default.registerLanguage('makefile', _makefile2.default);
_highlight2.default.registerLanguage('markdown', _markdown2.default);
_highlight2.default.registerLanguage('matlab', _matlab2.default);
_highlight2.default.registerLanguage('objectivec', _objectivec2.default);
_highlight2.default.registerLanguage('ocaml', _ocaml2.default);
_highlight2.default.registerLanguage('perl', _perl2.default);
_highlight2.default.registerLanguage('php', _php2.default);
_highlight2.default.registerLanguage('powershell', _powershell2.default);
_highlight2.default.registerLanguage('puppet', _puppet2.default);
_highlight2.default.registerLanguage('python', _python2.default);
_highlight2.default.registerLanguage('r', _r2.default);
_highlight2.default.registerLanguage('ruby', _ruby2.default);
_highlight2.default.registerLanguage('rust', _rust2.default);
_highlight2.default.registerLanguage('scala', _scala2.default);
_highlight2.default.registerLanguage('scheme', _scheme2.default);
_highlight2.default.registerLanguage('scss', _scss2.default);
_highlight2.default.registerLanguage('smalltalk', _smalltalk2.default);
_highlight2.default.registerLanguage('sql', _sql2.default);
_highlight2.default.registerLanguage('styl', _stylus2.default);
_highlight2.default.registerLanguage('swift', _swift2.default);
_highlight2.default.registerLanguage('tex', _tex2.default);
_highlight2.default.registerLanguage('vbnet', _vbnet2.default);
_highlight2.default.registerLanguage('vbscript', _vbscript2.default);
_highlight2.default.registerLanguage('verilog', _verilog2.default);
_highlight2.default.registerLanguage('xml', _xml2.default);
_highlight2.default.registerLanguage('yaml', _yaml2.default);

var HighlightedLanguages = _constants2.default.HighlightedLanguages;

function highlight(lang, code) {
    var language = getLanguageFromNameOrAlias(lang);

    if (language) {
        try {
            return _highlight2.default.highlight(language, code).value;
        } catch (e) {
            // fall through if highlighting fails and handle below
        }
    }

    return TextFormatting.sanitizeHtml(code);
}

function getLanguageFromFileExtension(extension) {
    for (var key in HighlightedLanguages) {
        if (HighlightedLanguages[key].extensions.find(function (x) {
            return x === extension;
        })) {
            return key;
        }
    }

    return null;
}

function canHighlight(language) {
    return Boolean(getLanguageFromNameOrAlias(language));
}

function getLanguageName(language) {
    if (canHighlight(language)) {
        return HighlightedLanguages[getLanguageFromNameOrAlias(language)].name;
    }

    return '';
}

function getLanguageFromNameOrAlias(name) {
    var langName = name.toLowerCase();
    if (HighlightedLanguages[langName]) {
        return langName;
    }

    return (0, _keys2.default)(HighlightedLanguages).find(function (key) {
        var aliases = HighlightedLanguages[key].aliases;
        return aliases && aliases.find(function (a) {
            return a === langName;
        });
    });
}

/***/ }),
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeWebrtc = exports.initWebrtc = undefined;

var _constants = __webpack_require__(29);

var initWebrtc = exports.initWebrtc = function initWebrtc(userId, isCaller) {
    return function (dispatch) {
        return dispatch({
            type: _constants.ActionTypes.INIT_WEBRTC,
            userId: userId,
            isCaller: isCaller
        });
    };
}; // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var closeWebrtc = exports.closeWebrtc = function closeWebrtc() {
    return function (dispatch) {
        return dispatch({
            type: _constants.ActionTypes.CLOSE_WEBRTC
        });
    };
};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(13).then((function(require) {
		cb(__webpack_require__(1880));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.autoUpdateTimezone = autoUpdateTimezone;

var _users = __webpack_require__(777);

var _timezone = __webpack_require__(1029);

var _users2 = __webpack_require__(786);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function autoUpdateTimezone(deviceTimezone) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var currentUer, currentTimezone, newTimezoneExists, timezone, updatedUser;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            currentUer = (0, _users.getCurrentUser)(getState());
                            currentTimezone = (0, _timezone.getUserTimezone)(getState(), currentUer.id);
                            newTimezoneExists = currentTimezone.automaticTimezone !== deviceTimezone;


                            if (currentTimezone.useAutomaticTimezone && newTimezoneExists) {
                                timezone = {
                                    useAutomaticTimezone: 'true',
                                    automaticTimezone: deviceTimezone,
                                    manualTimezone: currentTimezone.manualTimezone
                                };
                                updatedUser = _extends({}, currentUer, {
                                    timezone: timezone
                                });


                                (0, _users2.updateMe)(updatedUser)(dispatch, getState);
                            }

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notFoundParams = undefined;
exports.importComponentSuccess = importComponentSuccess;
exports.createGetChildComponentsFunction = createGetChildComponentsFunction;
exports.checkIfMFARequired = checkIfMFARequired;

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function importComponentSuccess(callback) {
    return function (comp) {
        return callback(null, comp.default);
    };
}

function createGetChildComponentsFunction(arrayOfComponents) {
    return function (locaiton, callback) {
        return callback(null, arrayOfComponents);
    };
}

var notFoundParams = exports.notFoundParams = {
    type: _constants.ErrorPageTypes.PAGE_NOT_FOUND
};

var mfaPaths = ['/mfa/setup', '/mfa/confirm'];

var mfaAuthServices = ['', 'email', 'ldap'];

function checkIfMFARequired(license, config, path) {
    if (license.MFA === 'true' && config.EnableMultifactorAuthentication === 'true' && config.EnforceMultifactorAuthentication === 'true' && mfaPaths.indexOf(path) === -1) {
        var user = _user_store2.default.getCurrentUser();
        if (user && !user.mfa_active && mfaAuthServices.indexOf(user.auth_service) !== -1) {
            return true;
        }
    }

    return false;
}

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        ss : '%d sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
}, numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
}, pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
}, plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
}, pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
}, months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
}, pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
}, plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
}, pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
}, months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
}, numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss : '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        ss : '%d saniyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        ss : 'sekondi %d',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
},
numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        ss : '%d সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
},
numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        ss : '%d སྐར་ཆ།',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        ss : '%d eilenn',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        ss : '%d segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
    monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekund');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        ss : '%d ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        ss: '%d eiliad',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        ss : '%d sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
], weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        ss : 'd% ސިކުންތު',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        ss : '%d δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIl = moment.defineLocale('en-il', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enIl;

})));


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        ss : '%d sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
    monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
    monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
    monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY h:mm A',
        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'ss': [number + 'sekundi', number + 'sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        ss : '%d segundo',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
}, numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        ss : 'ثانیه d%',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
    numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'ss':
            return isFuture ? 'sekunnin' : 'sekuntia';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        ss : '%d sekundir',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
    monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        ss : '%d sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        ss : '%d diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'ss': [number + ' secondanim', number + ' second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    },
    numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        ss: '%d સેકંડ',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        ss : '%d שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
},
numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        ss : '%d सेकंड',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'ss':
            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        ss : '%d վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        ss : '%d detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'ss':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
            }
            return result + 'sekúnda';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        ss : '%d secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        ss : '%d秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        ss : '%d detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        ss : '%d წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        ss : '%d секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        ss: '%d វិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
},
numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        ss : '%d ಸೆಕೆಂಡುಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD.',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        ss : '%d секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        ss : '%d Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        ss : '%d ວິນາທີ' ,
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss' : 'sekundė_sekundžių_sekundes',
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        ss : translate,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        ss : relativeTimeWithPlural,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekund', 'sekunda', 'sekundi'],
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        ss: '%d hēkona',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        ss : '%d സെക്കൻഡ്',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
},
numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'ss': output = '%d सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'ss': output = '%d सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        ss: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mt = moment.defineLocale('mt', {
    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Illum fil-]LT',
        nextDay : '[Għada fil-]LT',
        nextWeek : 'dddd [fil-]LT',
        lastDay : '[Il-bieraħ fil-]LT',
        lastWeek : 'dddd [li għadda] [fil-]LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'f’ %s',
        past : '%s ilu',
        s : 'ftit sekondi',
        ss : '%d sekondi',
        m : 'minuta',
        mm : '%d minuti',
        h : 'siegħa',
        hh : '%d siegħat',
        d : 'ġurnata',
        dd : '%d ġranet',
        M : 'xahar',
        MM : '%d xhur',
        y : 'sena',
        yy : '%d sni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mt;

})));


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
}, numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        ss : '%d စက္ကန့်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        ss : '%d sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
},
numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        ss : '%d सेकेण्ड',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        ss : '%d sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
},
numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        ss : '%d ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
    monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            return result + (plural(number) ? 'sekundy' : 'sekund');
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'ss': 'secunde',
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        ss : relativeTimeWithPlural,
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., H:mm',
        LLLL : 'dddd, D MMMM YYYY г., H:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        ss : '%d سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        ss: '%d sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        ss : 'තත්පර %d',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
    monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekúnd');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'ss':
            if (number === 1) {
                result += withoutSuffix ? 'sekundo' : 'sekundi';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
            } else {
                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        ss : '%d sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekunda', 'sekunde', 'sekundi'],
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['секунда', 'секунде', 'секунди'],
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        ss : '%d mzuzwana',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        ss : '%d sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        ss : 'sekunde %d',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
}, numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        ss : '%d விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        ss : '%d సెకన్లు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        ss : 'minutu %d',
        m : 'minutu ida',
        mm : 'minutu %d',
        h : 'oras ida',
        hh : 'oras %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ум',
    1: '-ум',
    2: '-юм',
    3: '-юм',
    4: '-ум',
    5: '-ум',
    6: '-ум',
    7: '-ум',
    8: '-ум',
    9: '-ум',
    10: '-ум',
    12: '-ум',
    13: '-ум',
    20: '-ум',
    30: '-юм',
    40: '-ум',
    50: '-ум',
    60: '-ум',
    70: '-ум',
    80: '-ум',
    90: '-ум',
    100: '-ум'
};

var tg = moment.defineLocale('tg', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
    weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
    weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Имрӯз соати] LT',
        nextDay : '[Пагоҳ соати] LT',
        lastDay : '[Дирӯз соати] LT',
        nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
        lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'баъди %s',
        past : '%s пеш',
        s : 'якчанд сония',
        m : 'як дақиқа',
        mm : '%d дақиқа',
        h : 'як соат',
        hh : '%d соат',
        d : 'як рӯз',
        dd : '%d рӯз',
        M : 'як моҳ',
        MM : '%d моҳ',
        y : 'як сол',
        yy : '%d сол'
    },
    meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'шаб') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'субҳ') {
            return hour;
        } else if (meridiem === 'рӯз') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'бегоҳ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'шаб';
        } else if (hour < 11) {
            return 'субҳ';
        } else if (hour < 16) {
            return 'рӯз';
        } else if (hour < 19) {
            return 'бегоҳ';
        } else {
            return 'шаб';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
    ordinal: function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1th is the first week of the year.
    }
});

return tg;

})));


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        ss : '%d วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        ss : '%d segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'ss':
            return numberNoun + ' lup';
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        ss : translate,
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        ss : '%d saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    ordinal: function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'Do':
            case 'DD':
                return number;
            default:
                if (number === 0) {  // special case for zero
                    return number + '\'ıncı';
                }
                var a = number % 10,
                    b = number % 100 - a,
                    c = number >= 100 ? 100 : null;
                return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'ss': [number + ' secunds', '' + number + ' secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        ss : '%d ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        ss : '%d imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ugCn = moment.defineLocale('ug-cn', {
    months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
        '_'
    ),
    monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
        '_'
    ),
    weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
        '_'
    ),
    weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
    weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
        LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
    },
    meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (
            meridiem === 'يېرىم كېچە' ||
            meridiem === 'سەھەر' ||
            meridiem === 'چۈشتىن بۇرۇن'
        ) {
            return hour;
        } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
            return hour + 12;
        } else {
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return 'يېرىم كېچە';
        } else if (hm < 900) {
            return 'سەھەر';
        } else if (hm < 1130) {
            return 'چۈشتىن بۇرۇن';
        } else if (hm < 1230) {
            return 'چۈش';
        } else if (hm < 1800) {
            return 'چۈشتىن كېيىن';
        } else {
            return 'كەچ';
        }
    },
    calendar: {
        sameDay: '[بۈگۈن سائەت] LT',
        nextDay: '[ئەتە سائەت] LT',
        nextWeek: '[كېلەركى] dddd [سائەت] LT',
        lastDay: '[تۆنۈگۈن] LT',
        lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s كېيىن',
        past: '%s بۇرۇن',
        s: 'نەچچە سېكونت',
        ss: '%d سېكونت',
        m: 'بىر مىنۇت',
        mm: '%d مىنۇت',
        h: 'بىر سائەت',
        hh: '%d سائەت',
        d: 'بىر كۈن',
        dd: '%d كۈن',
        M: 'بىر ئاي',
        MM: '%d ئاي',
        y: 'بىر يىل',
        yy: '%d يىل'
    },

    dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '-كۈنى';
            case 'w':
            case 'W':
                return number + '-ھەپتە';
            default:
                return number;
        }
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week: {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow: 1, // Monday is the first day of the week.
        doy: 7 // The week that contains Jan 1st is the first week of the year.
    }
});

return ugCn;

})));


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        ss : '%d سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        ss : '%d фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        ss : '%d soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        ss : '%d giây' ,
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        ss : '%d s~écóñ~ds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        ss :'aayá %d',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日Ah点mm分',
        LLLL : 'YYYY年M月D日ddddAh点mm分',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        ss : '%d 秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(763)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(783);

var _teams = __webpack_require__(274);

var _post_actions = __webpack_require__(802);

var _delete_post_modal = __webpack_require__(1953);

var _delete_post_modal2 = _interopRequireDefault(_delete_post_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var channel = (0, _channels.getChannel)(state, ownProps.post.channel_id);
    var channelName = '';
    if (channel) {
        channelName = channel.name;
    }

    var focusedPostId = state.views.channel.focusedPostId;


    return {
        channelName: channelName,
        focusedPostId: focusedPostId,
        teamName: (0, _teams.getCurrentTeam)(state).name
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            deleteAndRemovePost: _post_actions.deleteAndRemovePost
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_delete_post_modal2.default);

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(1037),
    isObject = __webpack_require__(856);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _reactRedux = __webpack_require__(268);

var _reselect = __webpack_require__(78);

var _channels = __webpack_require__(783);

var _general = __webpack_require__(113);

var _teams = __webpack_require__(274);

var _users = __webpack_require__(777);

var _url = __webpack_require__(793);

var _post_markdown = __webpack_require__(1965);

var _post_markdown2 = _interopRequireDefault(_post_markdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getChannelNamesMap = (0, _reselect.createSelector)(_channels.getChannelsNameMapInCurrentTeam, function (state, props) {
    return props;
}, function (channelNamesMap, props) {
    if (props && props.channel_mentions) {
        return (0, _assign2.default)({}, props.channel_mentions, channelNamesMap);
    }
    return channelNamesMap;
});

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    return {
        channelNamesMap: getChannelNamesMap(state),
        mentionKeys: (0, _users.getCurrentUserMentionKeys)(state),
        siteURL: (0, _url.getSiteURL)(),
        team: (0, _teams.getCurrentTeam)(state),
        hasImageProxy: config.HasImageProxy === 'true'
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_post_markdown2.default);

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editCommand = exports.addCommand = exports.updateOutgoingHook = exports.addOutgoingHook = exports.updateIncomingHook = exports.addIncomingHook = exports.loadTeamCommands = exports.loadOutgoingHooksForTeam = exports.loadOutgoingHooks = exports.loadIncomingHooksForTeam = exports.loadIncomingHooks = undefined;

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var loadIncomingHooks = exports.loadIncomingHooks = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(complete) {
        var _ref2, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return IntegrationActions.getIncomingHooks('', 0, 10000)(dispatch, getState);

                    case 2:
                        _ref2 = _context.sent;
                        data = _ref2.data;

                        if (data) {
                            loadProfilesForIncomingHooks(data);
                        }

                        if (complete) {
                            complete(data);
                        }

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function loadIncomingHooks(_x) {
        return _ref.apply(this, arguments);
    };
}();

var loadIncomingHooksForTeam = exports.loadIncomingHooksForTeam = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(teamId, complete) {
        var _ref4, data;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return IntegrationActions.getIncomingHooks(teamId, 0, 10000)(dispatch, getState);

                    case 2:
                        _ref4 = _context2.sent;
                        data = _ref4.data;

                        if (data) {
                            loadProfilesForIncomingHooks(data);
                        }

                        if (complete) {
                            complete(data);
                        }

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function loadIncomingHooksForTeam(_x2, _x3) {
        return _ref3.apply(this, arguments);
    };
}();

var loadOutgoingHooks = exports.loadOutgoingHooks = function () {
    var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(complete) {
        var _ref6, data;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return IntegrationActions.getOutgoingHooks('', '', 0, 10000)(dispatch, getState);

                    case 2:
                        _ref6 = _context3.sent;
                        data = _ref6.data;

                        if (data) {
                            loadProfilesForOutgoingHooks(data);
                        }

                        if (complete) {
                            complete(data);
                        }

                    case 6:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function loadOutgoingHooks(_x4) {
        return _ref5.apply(this, arguments);
    };
}();

var loadOutgoingHooksForTeam = exports.loadOutgoingHooksForTeam = function () {
    var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(teamId, complete) {
        var _ref8, data;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return IntegrationActions.getOutgoingHooks('', teamId, 0, 10000)(dispatch, getState);

                    case 2:
                        _ref8 = _context4.sent;
                        data = _ref8.data;

                        if (data) {
                            loadProfilesForOutgoingHooks(data);
                        }

                        if (complete) {
                            complete(data);
                        }

                    case 6:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function loadOutgoingHooksForTeam(_x5, _x6) {
        return _ref7.apply(this, arguments);
    };
}();

var loadTeamCommands = exports.loadTeamCommands = function () {
    var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(complete) {
        var _ref10, data;

        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return IntegrationActions.getCustomTeamCommands(_team_store2.default.getCurrentId())(dispatch, getState);

                    case 2:
                        _ref10 = _context5.sent;
                        data = _ref10.data;

                        if (data) {
                            loadProfilesForCommands(data);
                        }

                        if (complete) {
                            complete(data);
                        }

                    case 6:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function loadTeamCommands(_x7) {
        return _ref9.apply(this, arguments);
    };
}();

var addIncomingHook = exports.addIncomingHook = function () {
    var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(hook, success, error) {
        var _ref12, data, err;

        return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return IntegrationActions.createIncomingHook(hook)(dispatch, getState);

                    case 2:
                        _ref12 = _context6.sent;
                        data = _ref12.data;
                        err = _ref12.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function addIncomingHook(_x8, _x9, _x10) {
        return _ref11.apply(this, arguments);
    };
}();

var updateIncomingHook = exports.updateIncomingHook = function () {
    var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(hook, success, error) {
        var _ref14, data, err;

        return _regenerator2.default.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return IntegrationActions.updateIncomingHook(hook)(dispatch, getState);

                    case 2:
                        _ref14 = _context7.sent;
                        data = _ref14.data;
                        err = _ref14.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function updateIncomingHook(_x11, _x12, _x13) {
        return _ref13.apply(this, arguments);
    };
}();

var addOutgoingHook = exports.addOutgoingHook = function () {
    var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(hook, success, error) {
        var _ref16, data, err;

        return _regenerator2.default.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        _context8.next = 2;
                        return IntegrationActions.createOutgoingHook(hook)(dispatch, getState);

                    case 2:
                        _ref16 = _context8.sent;
                        data = _ref16.data;
                        err = _ref16.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function addOutgoingHook(_x14, _x15, _x16) {
        return _ref15.apply(this, arguments);
    };
}();

var updateOutgoingHook = exports.updateOutgoingHook = function () {
    var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(hook, success, error) {
        var _ref18, data, err;

        return _regenerator2.default.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.next = 2;
                        return IntegrationActions.updateOutgoingHook(hook)(dispatch, getState);

                    case 2:
                        _ref18 = _context9.sent;
                        data = _ref18.data;
                        err = _ref18.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function updateOutgoingHook(_x17, _x18, _x19) {
        return _ref17.apply(this, arguments);
    };
}();

var addCommand = exports.addCommand = function () {
    var _ref19 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(command, success, error) {
        var _ref20, data, err;

        return _regenerator2.default.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        _context10.next = 2;
                        return IntegrationActions.addCommand(command)(dispatch, getState);

                    case 2:
                        _ref20 = _context10.sent;
                        data = _ref20.data;
                        err = _ref20.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function addCommand(_x20, _x21, _x22) {
        return _ref19.apply(this, arguments);
    };
}();

var editCommand = exports.editCommand = function () {
    var _ref21 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(command, success, error) {
        var _ref22, data, err;

        return _regenerator2.default.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        _context11.next = 2;
                        return IntegrationActions.editCommand(command)(dispatch, getState);

                    case 2:
                        _ref22 = _context11.sent;
                        data = _ref22.data;
                        err = _ref22.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function editCommand(_x23, _x24, _x25) {
        return _ref21.apply(this, arguments);
    };
}();

exports.deleteIncomingHook = deleteIncomingHook;
exports.deleteOutgoingHook = deleteOutgoingHook;
exports.regenOutgoingHookToken = regenOutgoingHookToken;
exports.deleteCommand = deleteCommand;
exports.regenCommandToken = regenCommandToken;
exports.getSuggestedCommands = getSuggestedCommands;
exports.getYoutubeVideoInfo = getYoutubeVideoInfo;

var _superagent = __webpack_require__(1314);

var _superagent2 = _interopRequireDefault(_superagent);

var _integrations = __webpack_require__(823);

var IntegrationActions = _interopRequireWildcard(_integrations);

var _users = __webpack_require__(786);

var _client = __webpack_require__(270);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

function loadProfilesForIncomingHooks(hooks) {
    var profilesToLoad = {};
    for (var i = 0; i < hooks.length; i++) {
        var hook = hooks[i];
        if (!_user_store2.default.hasProfile(hook.user_id)) {
            profilesToLoad[hook.user_id] = true;
        }
    }

    var list = (0, _keys2.default)(profilesToLoad);
    if (list.length === 0) {
        return;
    }

    (0, _users.getProfilesByIds)(list)(dispatch, getState);
}

function loadProfilesForOutgoingHooks(hooks) {
    var profilesToLoad = {};
    for (var i = 0; i < hooks.length; i++) {
        var hook = hooks[i];
        if (!_user_store2.default.hasProfile(hook.creator_id)) {
            profilesToLoad[hook.creator_id] = true;
        }
    }

    var list = (0, _keys2.default)(profilesToLoad);
    if (list.length === 0) {
        return;
    }

    (0, _users.getProfilesByIds)(list)(dispatch, getState);
}

function loadProfilesForCommands(commands) {
    var profilesToLoad = {};
    for (var i = 0; i < commands.length; i++) {
        var command = commands[i];
        if (!_user_store2.default.hasProfile(command.creator_id)) {
            profilesToLoad[command.creator_id] = true;
        }
    }

    var list = (0, _keys2.default)(profilesToLoad);
    if (list.length === 0) {
        return;
    }

    (0, _users.getProfilesByIds)(list)(dispatch, getState);
}

function deleteIncomingHook(id) {
    IntegrationActions.removeIncomingHook(id)(dispatch, getState);
}

function deleteOutgoingHook(id) {
    IntegrationActions.removeOutgoingHook(id)(dispatch, getState);
}

function regenOutgoingHookToken(id) {
    IntegrationActions.regenOutgoingHookToken(id)(dispatch, getState);
}

function deleteCommand(id) {
    IntegrationActions.deleteCommand(id)(dispatch, getState);
}

function regenCommandToken(id) {
    IntegrationActions.regenCommandToken(id)(dispatch, getState);
}

function getSuggestedCommands(command, suggestionId, component) {
    _client.Client4.getCommandsList(_team_store2.default.getCurrentId()).then(function (data) {
        var matches = [];
        data.forEach(function (cmd) {
            if (!cmd.auto_complete) {
                return;
            }

            if (cmd.trigger !== 'shortcuts' || !UserAgent.isMobile()) {
                if (('/' + cmd.trigger).indexOf(command) === 0) {
                    var s = '/' + cmd.trigger;
                    var hint = '';
                    if (cmd.auto_complete_hint && cmd.auto_complete_hint.length !== 0) {
                        hint = cmd.auto_complete_hint;
                    }
                    matches.push({
                        suggestion: s,
                        hint: hint,
                        description: cmd.auto_complete_desc
                    });
                }
            }
        });

        matches = matches.sort(function (a, b) {
            return a.suggestion.localeCompare(b.suggestion);
        });

        // pull out the suggested commands from the returned data
        var terms = matches.map(function (suggestion) {
            return suggestion.suggestion;
        });

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
            id: suggestionId,
            matchedPretext: command,
            terms: terms,
            items: matches,
            component: component
        });
    }).catch(function () {} //eslint-disable-line no-empty-function
    );
}

function getYoutubeVideoInfo(googleKey, videoId, success, error) {
    _superagent2.default.get('https://www.googleapis.com/youtube/v3/videos').query({ part: 'snippet', id: videoId, key: googleKey }).end(function (err, res) {
        if (err) {
            return error(err);
        }

        if (!res.body) {
            console.error('Missing response body for getYoutubeVideoInfo'); // eslint-disable-line no-console
        }

        return success(res.body);
    });
}

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(1972);
var RequestBase = __webpack_require__(1973);
var isObject = __webpack_require__(1315);
var ResponseBase = __webpack_require__(1974);
var Agent = __webpack_require__(1976);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify,
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse,
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FileUploadOverlay;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _filesOverlay = __webpack_require__(1994);

var _filesOverlay2 = _interopRequireDefault(_filesOverlay);

var _logoWhite = __webpack_require__(1995);

var _logoWhite2 = _interopRequireDefault(_logoWhite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FileUploadOverlay(props) {
    var overlayClass = 'file-overlay hidden';
    if (props.overlayType === 'right') {
        overlayClass += ' right-file-overlay';
    } else if (props.overlayType === 'center') {
        overlayClass += ' center-file-overlay';
    }

    return _react2.default.createElement(
        'div',
        { className: overlayClass },
        _react2.default.createElement(
            'div',
            { className: 'overlay__indent' },
            _react2.default.createElement(
                'div',
                { className: 'overlay__circle' },
                _react2.default.createElement('img', {
                    className: 'overlay__files',
                    src: _filesOverlay2.default,
                    alt: 'Files'
                }),
                _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('i', { className: 'fa fa-upload' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'upload_overlay.info',
                        defaultMessage: 'Drop a file to upload it.'
                    })
                ),
                _react2.default.createElement('img', {
                    className: 'overlay__logo',
                    src: _logoWhite2.default,
                    width: '100',
                    alt: 'Logo'
                })
            )
        )
    );
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

FileUploadOverlay.propTypes = {
    overlayType: _propTypes2.default.string
};

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = undefined;

var _Scrollbars = __webpack_require__(1998);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var prefix = __webpack_require__(2001)
var toCamelCase = __webpack_require__(2002)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(2005)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _file_utils = __webpack_require__(886);

var _filename_overlay = __webpack_require__(1320);

var _filename_overlay2 = _interopRequireDefault(_filename_overlay);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _load = __webpack_require__(865);

var _load2 = _interopRequireDefault(_load);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilePreview = function (_React$PureComponent) {
    (0, _inherits3.default)(FilePreview, _React$PureComponent);

    function FilePreview(props) {
        (0, _classCallCheck3.default)(this, FilePreview);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FilePreview.__proto__ || (0, _getPrototypeOf2.default)(FilePreview)).call(this, props));

        _this.handleRemove = _this.handleRemove.bind(_this);
        _this.state = {
            fileInfos: [].concat((0, _toConsumableArray3.default)(_this.props.fileInfos))
        };
        return _this;
    }

    (0, _createClass3.default)(FilePreview, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.uploadsInProgress.length > 0) {
                this.refs[this.props.uploadsInProgress[0]].scrollIntoView();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (!Utils.areObjectsEqual(this.props.fileInfos, newProps.fileInfos)) {
                this.setState({
                    fileInfos: [].concat((0, _toConsumableArray3.default)(newProps.fileInfos))
                });
            }
        }
    }, {
        key: 'handleRemove',
        value: function handleRemove(id) {
            this.props.onRemove(id);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var previews = [];
            var fileInfos = this.state.fileInfos.sort(function (a, b) {
                return a.create_at - b.create_at;
            });
            fileInfos.forEach(function (info, idx) {
                var type = Utils.getFileType(info.extension);

                var className = 'file-preview post-image__column';
                var previewImage = void 0;
                if (type === _constants.FileTypes.SVG) {
                    previewImage = _react2.default.createElement('img', {
                        className: 'post-image normal',
                        src: (0, _file_utils.getFileUrl)(info.id)
                    });
                } else if (type === _constants.FileTypes.IMAGE) {
                    var imageClassName = 'post-image';

                    if (info.width < _constants2.default.THUMBNAIL_WIDTH && info.height < _constants2.default.THUMBNAIL_HEIGHT) {
                        imageClassName += ' small';
                    } else {
                        imageClassName += ' normal';
                    }

                    var thumbnailUrl = (0, _file_utils.getFileThumbnailUrl)(info.id);
                    if (Utils.isGIFImage(info.extension) && !info.has_preview_image) {
                        thumbnailUrl = (0, _file_utils.getFileUrl)(info.id);
                    }

                    previewImage = _react2.default.createElement('div', {
                        className: imageClassName,
                        style: {
                            backgroundImage: 'url(' + thumbnailUrl + ')',
                            backgroundSize: 'cover'
                        }
                    });
                } else {
                    className += ' custom-file';
                    previewImage = _react2.default.createElement('div', { className: 'file-icon ' + Utils.getIconClassName(type) });
                }

                previews.push(_react2.default.createElement(
                    'div',
                    {
                        key: info.id,
                        className: className
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'post-image__thumbnail' },
                        previewImage
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'post-image__details' },
                        _react2.default.createElement(
                            'div',
                            { className: 'post-image__detail_wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'post-image__detail' },
                                _react2.default.createElement(_filename_overlay2.default, {
                                    fileInfo: info,
                                    index: idx,
                                    handleImageClick: null,
                                    compactDisplay: false,
                                    canDownload: false
                                }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'post-image__type' },
                                    info.extension.toUpperCase()
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'post-image__size' },
                                    Utils.fileSizeToString(info.size)
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    className: 'file-preview__remove',
                                    onClick: _this2.handleRemove.bind(_this2, info.id)
                                },
                                _react2.default.createElement('i', { className: 'fa fa-remove' })
                            )
                        )
                    )
                ));
            });

            this.props.uploadsInProgress.forEach(function (clientId) {
                previews.push(_react2.default.createElement(
                    'div',
                    {
                        ref: clientId,
                        key: clientId,
                        className: 'file-preview',
                        'data-client-id': clientId
                    },
                    _react2.default.createElement('img', {
                        className: 'spinner',
                        src: _load2.default
                    }),
                    _react2.default.createElement(
                        'a',
                        {
                            className: 'file-preview__remove',
                            onClick: _this2.handleRemove.bind(_this2, clientId)
                        },
                        _react2.default.createElement('i', { className: 'fa fa-remove' })
                    )
                ));
            });

            return _react2.default.createElement(
                'div',
                {
                    className: 'file-preview__container',
                    ref: 'container'
                },
                previews
            );
        }
    }]);
    return FilePreview;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

FilePreview.propTypes = {
    onRemove: _propTypes2.default.func.isRequired,
    fileInfos: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    uploadsInProgress: _propTypes2.default.array
};
FilePreview.defaultProps = {
    fileInfos: [],
    uploadsInProgress: []
};
exports.default = FilePreview;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _file_utils = __webpack_require__(886);

var _attachment_icon = __webpack_require__(1321);

var _attachment_icon2 = _interopRequireDefault(_attachment_icon);

var _file_utils2 = __webpack_require__(887);

var _utils = __webpack_require__(762);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilenameOverlay = function (_React$PureComponent) {
    (0, _inherits3.default)(FilenameOverlay, _React$PureComponent);

    function FilenameOverlay() {
        (0, _classCallCheck3.default)(this, FilenameOverlay);
        return (0, _possibleConstructorReturn3.default)(this, (FilenameOverlay.__proto__ || (0, _getPrototypeOf2.default)(FilenameOverlay)).apply(this, arguments));
    }

    (0, _createClass3.default)(FilenameOverlay, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                canDownload = _props.canDownload,
                children = _props.children,
                compactDisplay = _props.compactDisplay,
                fileInfo = _props.fileInfo,
                handleImageClick = _props.handleImageClick,
                iconClass = _props.iconClass;


            var fileName = fileInfo.name;
            var trimmedFilename = (0, _file_utils2.trimFilename)(fileName);

            var filenameOverlay = void 0;
            if (compactDisplay) {
                filenameOverlay = _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        trigger: ['hover', 'focus'],
                        delayShow: 1000,
                        placement: 'top',
                        overlay: _react2.default.createElement(
                            _reactBootstrap.Tooltip,
                            { id: 'file-name__tooltip' },
                            fileName
                        )
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            onClick: handleImageClick,
                            className: 'post-image__name',
                            rel: 'noopener noreferrer'
                        },
                        _react2.default.createElement(_attachment_icon2.default, { className: 'icon' }),
                        trimmedFilename
                    )
                );
            } else if (canDownload) {
                filenameOverlay = _react2.default.createElement(
                    'a',
                    {
                        href: (0, _file_utils.getFileDownloadUrl)(fileInfo.id),
                        download: fileName,
                        className: iconClass || 'post-image__name',
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    },
                    _react2.default.createElement(
                        _reactBootstrap.OverlayTrigger,
                        {
                            trigger: ['hover', 'focus'],
                            delayShow: 1000,
                            placement: 'top',
                            overlay: _react2.default.createElement(
                                _reactBootstrap.Tooltip,
                                { id: 'file-name__tooltip' },
                                (0, _utils.localizeMessage)('file_attachment.download', 'Download')
                            )
                        },
                        children || trimmedFilename
                    )
                );
            } else {
                filenameOverlay = _react2.default.createElement(
                    'span',
                    { className: 'post-image__name' },
                    trimmedFilename
                );
            }

            return filenameOverlay;
        }
    }]);
    return FilenameOverlay;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

FilenameOverlay.propTypes = {

    /*
     * File detailed information
     */
    fileInfo: _propTypes2.default.object.isRequired,

    /*
     * Handler for when the thumbnail is clicked passed the index above
     */
    handleImageClick: _propTypes2.default.func,

    /*
     * Display in compact format
     */
    compactDisplay: _propTypes2.default.bool,

    /*
     * If it should display link to download on file name
     */
    canDownload: _propTypes2.default.bool,

    /**
     * Optional children like download icon
     */
    children: _propTypes2.default.element,

    /**
     * Optional class like for icon
     */
    iconClass: _propTypes2.default.string
};
exports.default = FilenameOverlay;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AttachmentIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(AttachmentIcon, _React$PureComponent);

    function AttachmentIcon() {
        (0, _classCallCheck3.default)(this, AttachmentIcon);
        return (0, _possibleConstructorReturn3.default)(this, (AttachmentIcon.__proto__ || (0, _getPrototypeOf2.default)(AttachmentIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(AttachmentIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '16px',
                        height: '15px',
                        viewBox: '0 0 18 15'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-1029.000000, -954.000000)',
                                fillRule: 'nonzero',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                { transform: 'translate(25.000000, 937.000000)' },
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(1004.000000, 17.000000)' },
                                    _react2.default.createElement('path', { d: 'M5.35,15.56 C3.98,15.56 2.61,15.039 1.567,13.997 C0.557,12.984 0,11.642 0,10.212 C0,8.783 0.557,7.44 1.566,6.429 L6.869,1.126 C8.371,-0.376 10.812,-0.375 12.314,1.125 C13.815,2.627 13.815,5.069 12.314,6.57 L7.011,11.873 C6.094,12.792 4.603,12.79 3.687,11.873 C2.771,10.958 2.771,9.467 3.687,8.551 L8.99,3.248 C9.323,2.916 9.861,2.916 10.193,3.248 C10.525,3.579 10.525,4.118 10.193,4.449 L4.89,9.752 C4.637,10.006 4.637,10.418 4.89,10.672 C5.143,10.923 5.555,10.925 5.809,10.672 L11.113,5.369 C11.952,4.53 11.952,3.166 11.113,2.327 C10.276,1.49 8.911,1.488 8.073,2.327 L2.769,7.631 C2.079,8.32 1.699,9.237 1.699,10.212 C1.699,11.188 2.079,12.104 2.768,12.794 C4.19,14.216 6.502,14.216 7.925,12.798 L7.929,12.794 C7.929,12.793 7.929,12.793 7.929,12.793 L15.355,5.369 C15.687,5.037 16.224,5.037 16.556,5.369 C16.888,5.7 16.888,6.239 16.556,6.57 L8.779,14.348 L8.761,14.332 C7.776,15.15 6.562,15.56 5.35,15.56 Z' })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return AttachmentIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = AttachmentIcon;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(783);

var _general = __webpack_require__(113);

var _file_actions = __webpack_require__(2023);

var _file_utils = __webpack_require__(887);

var _file_upload = __webpack_require__(2024);

var _file_upload2 = _interopRequireDefault(_file_upload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var maxFileSize = parseInt(config.MaxFileSize, 10);

    return {
        currentChannelId: (0, _channels.getCurrentChannelId)(state),
        uploadFile: _file_actions.uploadFile,
        maxFileSize: maxFileSize,
        canUploadFiles: (0, _file_utils.canUploadFiles)(config)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(_file_upload2.default);

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _typing = __webpack_require__(2026);

var _msg_typing = __webpack_require__(2027);

var _msg_typing2 = _interopRequireDefault(_msg_typing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeMapStateToProps() {
    var getUsersTypingByChannelAndPost = (0, _typing.makeGetUsersTypingByChannelAndPost)();

    return function mapStateToProps(state, ownProps) {
        var typingUsers = getUsersTypingByChannelAndPost(state, { channelId: ownProps.channelId, postId: ownProps.postId });

        return {
            typingUsers: typingUsers
        };
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(makeMapStateToProps)(_msg_typing2.default);

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PostDeletedModal = function (_React$Component) {
    (0, _inherits3.default)(PostDeletedModal, _React$Component);

    function PostDeletedModal() {
        (0, _classCallCheck3.default)(this, PostDeletedModal);
        return (0, _possibleConstructorReturn3.default)(this, (PostDeletedModal.__proto__ || (0, _getPrototypeOf2.default)(PostDeletedModal)).apply(this, arguments));
    }

    (0, _createClass3.default)(PostDeletedModal, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.show !== this.props.show;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.props.show,
                    onHide: this.props.onHide
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'post_delete.notPosted',
                            defaultMessage: 'Comment could not be posted'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'post_delete.someone',
                            defaultMessage: 'Someone deleted the message on which you tried to post a comment.'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-primary',
                            onClick: this.props.onHide
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'post_delete.okay',
                            defaultMessage: 'Okay'
                        })
                    )
                )
            );
        }
    }]);
    return PostDeletedModal;
}(_react2.default.Component);

PostDeletedModal.propTypes = {

    /**
     * Determines whether this modal should be shown or not
     */
    show: _propTypes2.default.bool.isRequired,

    /**
     * Function that is called when modal is hidden
     */
    onHide: _propTypes2.default.func.isRequired
};
exports.default = PostDeletedModal;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FloatingTimestamp = function (_React$PureComponent) {
    (0, _inherits3.default)(FloatingTimestamp, _React$PureComponent);

    function FloatingTimestamp() {
        (0, _classCallCheck3.default)(this, FloatingTimestamp);
        return (0, _possibleConstructorReturn3.default)(this, (FloatingTimestamp.__proto__ || (0, _getPrototypeOf2.default)(FloatingTimestamp)).apply(this, arguments));
    }

    (0, _createClass3.default)(FloatingTimestamp, [{
        key: 'render',
        value: function render() {
            if (!this.props.isMobile) {
                return _react2.default.createElement('noscript', null);
            }

            if (this.props.createAt === 0) {
                return _react2.default.createElement('noscript', null);
            }

            var dateString = _react2.default.createElement(_reactIntl.FormattedDate, {
                value: this.props.createAt,
                weekday: 'short',
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });

            var className = 'post-list__timestamp';
            if (this.props.isScrolling) {
                className += ' scrolling';
            }

            if (this.props.isRhsPost) {
                className += ' rhs';
            }

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'span',
                        null,
                        dateString
                    )
                )
            );
        }
    }]);
    return FloatingTimestamp;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

FloatingTimestamp.propTypes = {
    isScrolling: _propTypes2.default.bool.isRequired,
    isMobile: _propTypes2.default.bool,
    createAt: _propTypes2.default.number,
    isRhsPost: _propTypes2.default.bool
};
exports.default = FloatingTimestamp;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LoadingImagePreview;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _load = __webpack_require__(865);

var _load2 = _interopRequireDefault(_load);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingImagePreview(_ref) {
    var loading = _ref.loading,
        progress = _ref.progress,
        containerClass = _ref.containerClass;

    var progressView = null;
    if (progress) {
        progressView = _react2.default.createElement(
            'span',
            { className: 'loader-percent' },
            loading + ' ' + progress + '%'
        );
    }

    return _react2.default.createElement(
        'div',
        { className: containerClass },
        _react2.default.createElement('img', {
            className: 'loader-image',
            src: _load2.default
        }),
        progressView
    );
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

LoadingImagePreview.propTypes = {

    /**
     * The percent number of the progress
     */
    progress: _propTypes2.default.number,

    /**
     * The loading message to display
     */
    loading: _propTypes2.default.string,

    /**
     * Loading style
     */
    containerClass: _propTypes2.default.string
};

LoadingImagePreview.defaultProps = {
    containerClass: 'view-image__loading'
};

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _posts = __webpack_require__(808);

var _failed_post_options = __webpack_require__(2049);

var _failed_post_options2 = _interopRequireDefault(_failed_post_options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            removePost: _posts.removePost
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_failed_post_options2.default);

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MessageWithAdditionalContent;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(19);

var _post_body_additional_content = __webpack_require__(1045);

var _post_body_additional_content2 = _interopRequireDefault(_post_body_additional_content);

var _post_message_view = __webpack_require__(1046);

var _post_message_view2 = _interopRequireDefault(_post_message_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessageWithAdditionalContent(_ref) {
    var post = _ref.post,
        previewCollapsed = _ref.previewCollapsed,
        previewEnabled = _ref.previewEnabled,
        isEmbedVisible = _ref.isEmbedVisible,
        pluginPostTypes = _ref.pluginPostTypes;

    var hasPlugin = post.type && pluginPostTypes.hasOwnProperty(post.type);
    var msg = void 0;
    var messageWrapper = _react2.default.createElement(_post_message_view2.default, {
        post: post,
        isRHS: true,
        hasMention: true
    });
    if (post.state === _constants.Posts.POST_DELETED || hasPlugin) {
        msg = messageWrapper;
    } else {
        msg = _react2.default.createElement(
            _post_body_additional_content2.default,
            {
                post: post,
                previewCollapsed: previewCollapsed,
                previewEnabled: previewEnabled,
                isEmbedVisible: isEmbedVisible
            },
            messageWrapper
        );
    }
    return msg;
}

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HeaderIconWrapper;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactBootstrap = __webpack_require__(772);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HeaderIconWrapper(_ref) {
    var iconComponent = _ref.iconComponent,
        buttonClass = _ref.buttonClass,
        buttonId = _ref.buttonId,
        onClick = _ref.onClick,
        tooltipKey = _ref.tooltipKey;

    function getTooltip(key) {
        var toolTips = {
            flaggedPosts: {
                class: 'text-nowrap',
                id: 'flaggedTooltip',
                messageID: 'channel_header.flagged',
                message: 'Flagged Posts'
            },
            pinnedPosts: {
                class: '',
                id: 'pinnedPostTooltip',
                messageID: 'channel_header.pinnedPosts',
                message: 'Pinned Posts'
            },
            recentMentions: {
                class: '',
                id: 'recentMentionsTooltip',
                messageID: 'channel_header.recentMentions',
                message: 'Recent Mentions'
            },
            search: {
                class: '',
                id: 'searchTooltip',
                messageID: 'channel_header.search',
                message: 'Search'
            }
        };

        return _react2.default.createElement(
            _reactBootstrap.Tooltip,
            {
                id: toolTips[key].id,
                className: toolTips[key].class
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: toolTips[key].messageID,
                defaultMessage: toolTips[key].message
            })
        );
    }

    return _react2.default.createElement(
        'div',
        { className: 'flex-child' },
        _react2.default.createElement(
            _reactBootstrap.OverlayTrigger,
            {
                trigger: ['hover', 'focus'],
                delayShow: _constants.Constants.OVERLAY_TIME_DELAY,
                placement: 'bottom',
                overlay: getTooltip(tooltipKey)
            },
            _react2.default.createElement(
                'button',
                {
                    id: buttonId,
                    className: buttonClass || 'channel-header__icon icon--hidden style--none',
                    onClick: onClick
                },
                iconComponent
            )
        )
    );
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

HeaderIconWrapper.propTypes = {
    buttonClass: _propTypes2.default.string,
    buttonId: _propTypes2.default.string.isRequired,
    iconComponent: _propTypes2.default.element.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    tooltipKey: _propTypes2.default.string.isRequired
};

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MentionsIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(MentionsIcon, _React$PureComponent);

    function MentionsIcon() {
        (0, _classCallCheck3.default)(this, MentionsIcon);
        return (0, _possibleConstructorReturn3.default)(this, (MentionsIcon.__proto__ || (0, _getPrototypeOf2.default)(MentionsIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(MentionsIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '14px',
                        height: '14px',
                        viewBox: '0 0 20 20',
                        version: '1.1'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-1057.000000, -31.000000)',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                null,
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(1049.000000, 22.000000)' },
                                    _react2.default.createElement('path', { d: 'M17.4296875,15.8867188 C15.9882812,15.8867188 15.1210938,17.0351562 15.1210938,18.96875 C15.1210938,20.8789062 15.9882812,22.0507812 17.4179688,22.0507812 C18.8945312,22.0507812 19.84375,20.8554688 19.84375,18.96875 C19.84375,17.0820312 18.90625,15.8867188 17.4296875,15.8867188 Z M17.8398438,9.125 C23.3242188,9.125 27.25,12.59375 27.25,17.7734375 C27.25,21.5117188 25.5625,23.9609375 22.7734375,23.9609375 C21.4023438,23.9609375 20.265625,23.1992188 20.078125,22.0390625 L19.9609375,22.0390625 C19.46875,23.2226562 18.4140625,23.8789062 17.0429688,23.8789062 C14.6054687,23.8789062 12.9648438,21.8867188 12.9648438,18.9101562 C12.9648438,16.0625 14.6171875,14.09375 16.9960938,14.09375 C18.25,14.09375 19.3632812,14.7382812 19.8085938,15.7460938 L19.9375,15.7460938 L19.9375,14.328125 L21.9179688,14.328125 L21.9179688,20.984375 C21.9179688,21.7578125 22.328125,22.2851562 23.171875,22.2851562 C24.4726562,22.2851562 25.421875,20.6679688 25.421875,17.8320312 C25.421875,13.5664062 22.2929688,10.7421875 17.7109375,10.7421875 C13.1640625,10.7421875 9.90625,14.140625 9.90625,18.96875 C9.90625,24.1367188 13.3515625,27.0429688 18.109375,27.0429688 C19.5625,27.0429688 21.0507812,26.84375 21.7773438,26.5390625 L21.7773438,28.15625 C20.78125,28.484375 19.4570312,28.671875 18.0273438,28.671875 C12.2382812,28.671875 8.078125,25.109375 8.078125,18.8984375 C8.078125,13.0625 12.0859375,9.125 17.8398438,9.125 Z' })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return MentionsIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = MentionsIcon;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reply_icon = __webpack_require__(2088);

var _reply_icon2 = _interopRequireDefault(_reply_icon);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CommentIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(CommentIcon, _React$PureComponent);

    function CommentIcon() {
        (0, _classCallCheck3.default)(this, CommentIcon);
        return (0, _possibleConstructorReturn3.default)(this, (CommentIcon.__proto__ || (0, _getPrototypeOf2.default)(CommentIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(CommentIcon, [{
        key: 'render',
        value: function render() {
            var commentCountSpan = '';
            var iconStyle = 'comment-icon__container';
            if (this.props.commentCount > 0) {
                iconStyle += ' icon--show';
                commentCountSpan = _react2.default.createElement(
                    'span',
                    { className: 'comment-count' },
                    this.props.commentCount
                );
            } else if (this.props.searchStyle !== '') {
                iconStyle = iconStyle + ' ' + this.props.searchStyle;
            }

            var selectorId = this.props.idPrefix;
            if (this.props.idCount > -1) {
                selectorId += this.props.idCount;
            }

            var id = Utils.createSafeId(this.props.idPrefix + '_' + this.props.id);

            return _react2.default.createElement(
                'button',
                {
                    id: id,
                    className: iconStyle + ' color--link style--none ' + selectorId + ' ' + this.props.extraClass,
                    onClick: this.props.handleCommentClick
                },
                _react2.default.createElement(_reply_icon2.default, { className: 'comment-icon' }),
                commentCountSpan
            );
        }
    }]);
    return CommentIcon;
}(_react2.default.PureComponent);

CommentIcon.propTypes = {
    idPrefix: _propTypes2.default.string.isRequired,
    idCount: _propTypes2.default.number,
    handleCommentClick: _propTypes2.default.func.isRequired,
    searchStyle: _propTypes2.default.string,
    commentCount: _propTypes2.default.number,
    id: _propTypes2.default.string,
    extraClass: _propTypes2.default.string
};
CommentIcon.defaultProps = {
    idCount: -1,
    searchStyle: '',
    commentCount: 0,
    id: '',
    extraClass: ''
};
exports.default = CommentIcon;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _add_users_to_team = __webpack_require__(2092);

var _add_users_to_team2 = _interopRequireDefault(_add_users_to_team);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getProfilesNotInTeam: _users.getProfilesNotInTeam
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_add_users_to_team2.default);

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				className: className,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _searchable_user_list = __webpack_require__(1335);

var _searchable_user_list2 = _interopRequireDefault(_searchable_user_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchableUserListContainer = function (_React$Component) {
    (0, _inherits3.default)(SearchableUserListContainer, _React$Component);

    function SearchableUserListContainer(props) {
        (0, _classCallCheck3.default)(this, SearchableUserListContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchableUserListContainer.__proto__ || (0, _getPrototypeOf2.default)(SearchableUserListContainer)).call(this, props));

        _this.handleTermChange = _this.handleTermChange.bind(_this);

        _this.nextPage = _this.nextPage.bind(_this);
        _this.previousPage = _this.previousPage.bind(_this);
        _this.search = _this.search.bind(_this);

        _this.state = {
            term: '',
            page: 0
        };
        return _this;
    }

    (0, _createClass3.default)(SearchableUserListContainer, [{
        key: 'handleTermChange',
        value: function handleTermChange(term) {
            this.setState({ term: term });
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            this.setState({ page: this.state.page + 1 });

            this.props.nextPage(this.state.page + 1);
        }
    }, {
        key: 'previousPage',
        value: function previousPage() {
            this.setState({ page: this.state.page - 1 });
        }
    }, {
        key: 'search',
        value: function search(term) {
            this.props.search(term);

            if (term !== '') {
                this.setState({ page: 0 });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_searchable_user_list2.default, (0, _extends3.default)({}, this.props, {
                nextPage: this.nextPage,
                previousPage: this.previousPage,
                search: this.search,
                page: this.state.page,
                term: this.state.term,
                onTermChange: this.handleTermChange
            }));
        }
    }]);
    return SearchableUserListContainer;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SearchableUserListContainer.propTypes = {
    users: _propTypes2.default.arrayOf(_propTypes2.default.object),
    usersPerPage: _propTypes2.default.number,
    total: _propTypes2.default.number,
    extraInfo: _propTypes2.default.object,
    nextPage: _propTypes2.default.func.isRequired,
    search: _propTypes2.default.func.isRequired,
    actions: _propTypes2.default.arrayOf(_propTypes2.default.func),
    actionProps: _propTypes2.default.object,
    actionUserProps: _propTypes2.default.object,
    focusOnMount: _propTypes2.default.bool
};
exports.default = SearchableUserListContainer;

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _quick_input = __webpack_require__(1038);

var _quick_input2 = _interopRequireDefault(_quick_input);

var _user_list = __webpack_require__(2109);

var _user_list2 = _interopRequireDefault(_user_list);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var NEXT_BUTTON_TIMEOUT = 500;

var SearchableUserList = function (_React$Component) {
    (0, _inherits3.default)(SearchableUserList, _React$Component);

    function SearchableUserList(props) {
        (0, _classCallCheck3.default)(this, SearchableUserList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchableUserList.__proto__ || (0, _getPrototypeOf2.default)(SearchableUserList)).call(this, props));

        _this.nextPage = _this.nextPage.bind(_this);
        _this.previousPage = _this.previousPage.bind(_this);
        _this.focusSearchBar = _this.focusSearchBar.bind(_this);

        _this.handleInput = _this.handleInput.bind(_this);

        _this.renderCount = _this.renderCount.bind(_this);

        _this.nextTimeoutId = 0;

        _this.state = {
            nextDisabled: false
        };
        return _this;
    }

    (0, _createClass3.default)(SearchableUserList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.focusSearchBar();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.page !== prevProps.page || this.props.term !== prevProps.term) {
                this.refs.userList.scrollToTop();
            }

            this.focusSearchBar();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.nextTimeoutId);
        }
    }, {
        key: 'nextPage',
        value: function nextPage(e) {
            var _this2 = this;

            e.preventDefault();

            this.setState({ nextDisabled: true });
            this.nextTimeoutId = setTimeout(function () {
                return _this2.setState({ nextDisabled: false });
            }, NEXT_BUTTON_TIMEOUT);

            this.props.nextPage();
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.channelListScroll)).scrollTop(0);
        }
    }, {
        key: 'previousPage',
        value: function previousPage(e) {
            e.preventDefault();

            this.props.previousPage();
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.channelListScroll)).scrollTop(0);
        }
    }, {
        key: 'focusSearchBar',
        value: function focusSearchBar() {
            if (this.props.focusOnMount) {
                this.refs.filter.focus();
            }
        }
    }, {
        key: 'handleInput',
        value: function handleInput(e) {
            this.props.onTermChange(e.target.value);
            this.props.search(e.target.value);
        }
    }, {
        key: 'renderCount',
        value: function renderCount(users) {
            if (!users) {
                return null;
            }

            var count = users.length;
            var total = this.props.total;
            var isSearch = Boolean(this.props.term);

            var startCount = void 0;
            var endCount = void 0;
            if (isSearch) {
                startCount = -1;
                endCount = -1;
            } else {
                startCount = this.props.page * this.props.usersPerPage;
                endCount = Math.min(startCount + this.props.usersPerPage, total);
            }

            if (this.props.renderCount) {
                return this.props.renderCount(count, this.props.total, startCount, endCount, isSearch);
            }

            if (this.props.total) {
                if (isSearch) {
                    return _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'filtered_user_list.countTotal',
                        defaultMessage: '{count, number} {count, plural, one {member} other {members}} of {total, number} total',
                        values: {
                            count: count,
                            total: total
                        }
                    });
                }

                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'filtered_user_list.countTotalPage',
                    defaultMessage: '{startCount, number} - {endCount, number} {count, plural, one {member} other {members}} of {total, number} total',
                    values: {
                        count: count,
                        startCount: startCount + 1,
                        endCount: endCount,
                        total: total
                    }
                });
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var nextButton = void 0;
            var previousButton = void 0;
            var usersToDisplay = void 0;

            if (this.props.term || !this.props.users) {
                usersToDisplay = this.props.users;
            } else if (!this.props.term) {
                var pageStart = this.props.page * this.props.usersPerPage;
                var pageEnd = pageStart + this.props.usersPerPage;
                usersToDisplay = this.props.users.slice(pageStart, pageEnd);

                if (pageEnd < this.props.users.length) {
                    nextButton = _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-default filter-control filter-control__next',
                            onClick: this.nextPage,
                            disabled: this.state.nextDisabled
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'filtered_user_list.next',
                            defaultMessage: 'Next'
                        })
                    );
                }

                if (this.props.page > 0) {
                    previousButton = _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-default filter-control filter-control__prev',
                            onClick: this.previousPage
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'filtered_user_list.prev',
                            defaultMessage: 'Previous'
                        })
                    );
                }
            }

            var filterRow = void 0;
            if (this.props.renderFilterRow) {
                filterRow = this.props.renderFilterRow(this.handleInput);
            } else {
                filterRow = _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    _react2.default.createElement(_quick_input2.default, {
                        ref: 'filter',
                        className: 'form-control filter-textbox',
                        placeholder: Utils.localizeMessage('filtered_user_list.search', 'Search users'),
                        value: this.props.term,
                        onInput: this.handleInput
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'filtered-user-list' },
                _react2.default.createElement(
                    'div',
                    { className: 'filter-row' },
                    filterRow,
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(
                            'span',
                            { className: 'member-count pull-left' },
                            this.renderCount(usersToDisplay)
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'more-modal__list'
                    },
                    _react2.default.createElement(_user_list2.default, {
                        ref: 'userList',
                        users: usersToDisplay,
                        extraInfo: this.props.extraInfo,
                        actions: this.props.actions,
                        actionProps: this.props.actionProps,
                        actionUserProps: this.props.actionUserProps,
                        rowComponentType: this.props.rowComponentType
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'filter-controls' },
                    previousButton,
                    nextButton
                )
            );
        }
    }]);
    return SearchableUserList;
}(_react2.default.Component);

SearchableUserList.propTypes = {
    users: _propTypes2.default.arrayOf(_propTypes2.default.object),
    usersPerPage: _propTypes2.default.number,
    total: _propTypes2.default.number,
    extraInfo: _propTypes2.default.object,
    nextPage: _propTypes2.default.func.isRequired,
    previousPage: _propTypes2.default.func.isRequired,
    search: _propTypes2.default.func.isRequired,
    actions: _propTypes2.default.arrayOf(_propTypes2.default.func),
    actionProps: _propTypes2.default.object,
    actionUserProps: _propTypes2.default.object,
    focusOnMount: _propTypes2.default.bool,
    renderCount: _propTypes2.default.func,
    renderFilterRow: _propTypes2.default.func,

    page: _propTypes2.default.number.isRequired,
    term: _propTypes2.default.string.isRequired,
    onTermChange: _propTypes2.default.func.isRequired,

    // the type of user list row to render
    rowComponentType: _propTypes2.default.func
};
SearchableUserList.defaultProps = {
    users: [],
    usersPerPage: 50, // eslint-disable-line no-magic-numbers
    extraInfo: {},
    actions: [],
    actionProps: {},
    actionUserProps: {},
    showTeamToggle: false,
    focusOnMount: false
};
exports.default = SearchableUserList;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(23).then((function(require) {
		cb(__webpack_require__(2113));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _exif2css2 = __webpack_require__(2117);

var _exif2css3 = _interopRequireDefault(_exif2css2);

var _load = __webpack_require__(865);

var _load2 = _interopRequireDefault(_load);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SettingPicture = function (_Component) {
    (0, _inherits3.default)(SettingPicture, _Component);

    function SettingPicture(props) {
        (0, _classCallCheck3.default)(this, SettingPicture);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SettingPicture.__proto__ || (0, _getPrototypeOf2.default)(SettingPicture)).call(this, props));

        _this.setPicture = function (file) {
            if (file) {
                _this.previewBlob = URL.createObjectURL(file);

                var reader = new FileReader();
                reader.onload = function (e) {
                    var orientation = _this.getExifOrientation(e.target.result);
                    var orientationStyles = _this.getOrientationStyles(orientation);

                    _this.setState({
                        image: _this.previewBlob,
                        orientationStyles: orientationStyles
                    });
                };
                reader.readAsArrayBuffer(file);
            }
        };

        _this.state = {
            image: null
        };
        return _this;
    }

    (0, _createClass3.default)(SettingPicture, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.file !== this.props.file) {
                this.setState({ image: null });

                this.setPicture(nextProps.file);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.previewBlob) {
                URL.revokeObjectURL(this.previewBlob);
            }
        }
    }, {
        key: 'getExifOrientation',


        // based on https://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side/32490603#32490603
        value: function getExifOrientation(data) {
            var view = new DataView(data);

            if (view.getUint16(0, false) !== 0xFFD8) {
                return -2;
            }

            var length = view.byteLength;
            var offset = 2;

            while (offset < length) {
                var marker = view.getUint16(offset, false);
                offset += 2;

                if (marker === 0xFFE1) {
                    if (view.getUint32(offset += 2, false) !== 0x45786966) {
                        return -1;
                    }

                    var little = view.getUint16(offset += 6, false) === 0x4949;
                    offset += view.getUint32(offset + 4, little);
                    var tags = view.getUint16(offset, little);
                    offset += 2;

                    for (var i = 0; i < tags; i++) {
                        if (view.getUint16(offset + i * 12, little) === 0x0112) {
                            return view.getUint16(offset + i * 12 + 8, little);
                        }
                    }
                } else if ((marker & 0xFF00) === 0xFF00) {
                    offset += view.getUint16(offset, false);
                } else {
                    break;
                }
            }
            return -1;
        }
    }, {
        key: 'getOrientationStyles',
        value: function getOrientationStyles(orientation) {
            var _exif2css = (0, _exif2css3.default)(orientation),
                transform = _exif2css.transform,
                transformOrigin = _exif2css['transform-origin'];

            return { transform: transform, transformOrigin: transformOrigin };
        }
    }, {
        key: 'render',
        value: function render() {
            var imageContext = this.props.imageContext;

            var img = void 0;

            if (this.props.file) {
                var imageStyles = (0, _extends3.default)({
                    backgroundImage: 'url(' + this.state.image + ')'
                }, this.state.orientationStyles);

                img = _react2.default.createElement('div', {
                    className: imageContext + '-img-preview',
                    alt: imageContext + ' image preview',
                    style: imageStyles
                });
            } else if (this.props.src) {
                img = _react2.default.createElement('img', {
                    ref: 'image',
                    className: imageContext + '-img',
                    alt: imageContext + ' image',
                    src: this.props.src
                });
            }

            var confirmButton = void 0;
            var selectButtonSpinner = void 0;
            var fileInputDisabled = false;
            if (this.props.loadingPicture) {
                confirmButton = _react2.default.createElement('img', {
                    className: 'spinner',
                    src: _load2.default
                });
                selectButtonSpinner = _react2.default.createElement('span', { className: 'icon fa fa-refresh icon--rotate' });
                fileInputDisabled = true;
            } else {
                var confirmButtonClass = 'btn btn-sm';
                if (this.props.submitActive) {
                    confirmButtonClass += ' btn-primary';
                } else {
                    confirmButtonClass += ' btn-inactive disabled';
                }

                confirmButton = _react2.default.createElement(
                    'a',
                    {
                        className: confirmButtonClass,
                        onClick: this.props.submit
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'setting_picture.save',
                        defaultMessage: 'Save'
                    })
                );
            }

            return _react2.default.createElement(
                'ul',
                { className: 'section-max form-horizontal' },
                _react2.default.createElement(
                    'li',
                    { className: 'col-xs-12 section-title' },
                    this.props.title
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'col-xs-offset-3 col-xs-8' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'setting-list' },
                        img ? _react2.default.createElement(
                            'li',
                            { className: 'setting-list-item' },
                            ' ',
                            img,
                            ' '
                        ) : '',
                        _react2.default.createElement(
                            'li',
                            { className: 'setting-list-item padding-top x2' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'setting_picture.help.' + imageContext,
                                defaultMessage: 'Upload a picture in BMP, JPG or PNG format.'
                            })
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'setting-list-item' },
                            _react2.default.createElement('hr', null),
                            _react2.default.createElement(_form_error2.default, {
                                errors: [this.props.clientError, this.props.serverError],
                                type: 'modal'
                            }),
                            _react2.default.createElement(
                                'div',
                                {
                                    className: 'btn btn-sm btn-primary btn-file sel-btn',
                                    disabled: fileInputDisabled
                                },
                                selectButtonSpinner,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'setting_picture.select',
                                    defaultMessage: 'Select'
                                }),
                                _react2.default.createElement('input', {
                                    ref: 'input',
                                    accept: '.jpg,.png,.bmp',
                                    type: 'file',
                                    onChange: this.props.onFileChange,
                                    disabled: fileInputDisabled
                                })
                            ),
                            confirmButton,
                            _react2.default.createElement(
                                'a',
                                {
                                    className: 'btn btn-sm theme',
                                    href: '#',
                                    onClick: this.props.updateSection
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'setting_picture.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return SettingPicture;
}(_react.Component);

SettingPicture.defaultProps = {
    imageContext: 'profile'
};
SettingPicture.propTypes = {
    clientError: _propTypes2.default.string,
    serverError: _propTypes2.default.string,
    src: _propTypes2.default.string,
    file: _propTypes2.default.object,
    loadingPicture: _propTypes2.default.bool,
    submitActive: _propTypes2.default.bool,
    submit: _propTypes2.default.func,
    title: _propTypes2.default.string,
    onFileChange: _propTypes2.default.func,
    updateSection: _propTypes2.default.func,
    imageContext: _propTypes2.default.string
};
exports.default = SettingPicture;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _tutorial_tip = __webpack_require__(1053);

var _tutorial_tip2 = _interopRequireDefault(_tutorial_tip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
//
var MenuTutorialTip = function MenuTutorialTip(_ref) {
    var toggleFunc = _ref.toggleFunc,
        onBottom = _ref.onBottom;

    var screens = [];

    screens.push(_react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
            id: 'sidebar_header.tutorial',
            defaultMessage: '<h4>Main Menu</h4> <p>The <strong>Main Menu</strong> is where you can <strong>Invite New Members</strong>, access your <strong>Account Settings</strong> and set your <strong>Theme Color</strong>.</p> <p>Team administrators can also access their <strong>Team Settings</strong> from this menu.</p><p>System administrators will find a <strong>System Console</strong> option to administrate the entire system.</p>'
        })
    ));

    var placement = 'right';
    var arrow = 'left';
    if (onBottom) {
        placement = 'bottom';
        arrow = 'up';
    }

    return _react2.default.createElement(
        'div',
        {
            onClick: toggleFunc
        },
        _react2.default.createElement(_tutorial_tip2.default, {
            placement: placement,
            screens: screens,
            overlayClass: 'tip-overlay--header--' + arrow,
            diagnosticsTag: 'tutorial_tip_3_main_menu'
        })
    );
};

MenuTutorialTip.propTypes = {
    toggleFunc: _propTypes2.default.func,
    onBottom: _propTypes2.default.bool.isRequired
};

exports.default = MenuTutorialTip;

/***/ }),
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;

var _Alpha = __webpack_require__(2180);

Object.defineProperty(exports, 'AlphaPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Block = __webpack_require__(2300);

Object.defineProperty(exports, 'BlockPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Block).default;
  }
});

var _Circle = __webpack_require__(2302);

Object.defineProperty(exports, 'CirclePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _Chrome = __webpack_require__(2304);

Object.defineProperty(exports, 'ChromePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Chrome).default;
  }
});

var _Compact = __webpack_require__(2308);

Object.defineProperty(exports, 'CompactPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Compact).default;
  }
});

var _Github = __webpack_require__(2311);

Object.defineProperty(exports, 'GithubPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Github).default;
  }
});

var _Hue = __webpack_require__(2313);

Object.defineProperty(exports, 'HuePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Material = __webpack_require__(2315);

Object.defineProperty(exports, 'MaterialPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Material).default;
  }
});

var _Photoshop = __webpack_require__(2316);

Object.defineProperty(exports, 'PhotoshopPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Photoshop).default;
  }
});

var _Sketch = __webpack_require__(2322);

Object.defineProperty(exports, 'SketchPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sketch).default;
  }
});

var _Slider = __webpack_require__(2325);

Object.defineProperty(exports, 'SliderPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slider).default;
  }
});

var _Swatches = __webpack_require__(2329);

Object.defineProperty(exports, 'SwatchesPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatches).default;
  }
});

var _Twitter = __webpack_require__(2332);

Object.defineProperty(exports, 'TwitterPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Twitter).default;
  }
});

var _ColorWrap = __webpack_require__(1402);

Object.defineProperty(exports, 'CustomPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Chrome2 = _interopRequireDefault(_Chrome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chrome2.default;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(2183),
    keys = __webpack_require__(936);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(2185),
    isArguments = __webpack_require__(1371),
    isArray = __webpack_require__(833),
    isBuffer = __webpack_require__(1072),
    isIndex = __webpack_require__(1372),
    isTypedArray = __webpack_require__(1373);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2186),
    isObjectLike = __webpack_require__(885);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 1372 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2188),
    baseUnary = __webpack_require__(2189),
    nodeUtil = __webpack_require__(2190);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 1374 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(884),
    isObject = __webpack_require__(856);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(1377);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1377 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1378 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1379 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2223),
    isObjectLike = __webpack_require__(885);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(2224),
    arraySome = __webpack_require__(2227),
    cacheHas = __webpack_require__(2228);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(836);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1383 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1384 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1386),
    getSymbols = __webpack_require__(1080),
    keys = __webpack_require__(936);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1387),
    isArray = __webpack_require__(833);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1387 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1388 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2232),
    Map = __webpack_require__(1078),
    Promise = __webpack_require__(2233),
    Set = __webpack_require__(2234),
    WeakMap = __webpack_require__(2235),
    baseGetTag = __webpack_require__(884),
    toSource = __webpack_require__(1379);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(856);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 1391 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(1393),
    toKey = __webpack_require__(984);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(833),
    isKey = __webpack_require__(1081),
    stringToPath = __webpack_require__(2239),
    toString = __webpack_require__(2242);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1369),
    createBaseEach = __webpack_require__(2251);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1395 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(1397),
    eq = __webpack_require__(1077);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(2255);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1370),
    baseKeysIn = __webpack_require__(2258),
    isArrayLike = __webpack_require__(979);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1387),
    getPrototype = __webpack_require__(1075),
    getSymbols = __webpack_require__(1080),
    stubArray = __webpack_require__(1388);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 1400 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkboard = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _checkboard = __webpack_require__(2283);

var checkboard = _interopRequireWildcard(_checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = exports.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow;

  var styles = (0, _reactcss2.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

exports.default = Checkboard;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorWrap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _debounce = __webpack_require__(1037);

var _debounce2 = _interopRequireDefault(_debounce);

var _color = __webpack_require__(857);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck(this, ColorPicker);

      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends({}, _color2.default.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass(ColorPicker, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.setState(_extends({}, _color2.default.toState(nextProps.color, this.state.oldHue)));
      }
    }, {
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }]);

    return ColorPicker;
  }(_react.PureComponent || _react.Component);

  ColorPicker.propTypes = _extends({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

exports.default = ColorWrap;

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pink", function() { return pink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepPurple", function() { return deepPurple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indigo", function() { return indigo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightBlue", function() { return lightBlue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cyan", function() { return cyan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightGreen", function() { return lightGreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lime", function() { return lime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "amber", function() { return amber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orange", function() { return orange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepOrange", function() { return deepOrange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "brown", function() { return brown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "grey", function() { return grey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blueGrey", function() { return blueGrey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkText", function() { return darkText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightText", function() { return lightText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkIcons", function() { return darkIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightIcons", function() { return lightIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "white", function() { return white; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "black", function() { return black; });
var red = {"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"};
var pink = {"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"};
var purple = {"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"};
var deepPurple = {"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"};
var indigo = {"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"};
var blue = {"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"};
var lightBlue = {"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"};
var cyan = {"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"};
var teal = {"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"};
var green = {"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"};
var lightGreen = {"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"};
var lime = {"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"};
var yellow = {"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"};
var amber = {"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"};
var orange = {"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"};
var deepOrange = {"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"};
var brown = {"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"};
var grey = {"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"};
var blueGrey = {"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"};
var darkText = {"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"};
var lightText = {"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"};
var darkIcons = {"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"};
var lightIcons = {"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"};
var white = "#ffffff";
var black = "#000000";

/* harmony default export */ __webpack_exports__["default"] = ({
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  grey: grey,
  blueGrey: blueGrey,
  darkText: darkText,
  lightText: lightText,
  darkIcons: darkIcons,
  lightIcons: lightIcons,
  white: white,
  black: black
});


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatAuditInfo = formatAuditInfo;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var holders = (0, _reactIntl.defineMessages)({
    sessionRevoked: {
        id: 'audit_table.sessionRevoked',
        defaultMessage: 'The session with id {sessionId} was revoked'
    },
    channelCreated: {
        id: 'audit_table.channelCreated',
        defaultMessage: 'Created the {channelName} channel'
    },
    establishedDM: {
        id: 'audit_table.establishedDM',
        defaultMessage: 'Established a direct message channel with {username}'
    },
    nameUpdated: {
        id: 'audit_table.nameUpdated',
        defaultMessage: 'Updated the {channelName} channel name'
    },
    headerUpdated: {
        id: 'audit_table.headerUpdated',
        defaultMessage: 'Updated the {channelName} channel header'
    },
    channelDeleted: {
        id: 'audit_table.channelDeleted',
        defaultMessage: 'Deleted the channel with the URL {url}'
    },
    userAdded: {
        id: 'audit_table.userAdded',
        defaultMessage: 'Added {username} to the {channelName} channel'
    },
    userRemoved: {
        id: 'audit_table.userRemoved',
        defaultMessage: 'Removed {username} to the {channelName} channel'
    },
    attemptedRegisterApp: {
        id: 'audit_table.attemptedRegisterApp',
        defaultMessage: 'Attempted to register a new OAuth Application with ID {id}'
    },
    attemptedAllowOAuthAccess: {
        id: 'audit_table.attemptedAllowOAuthAccess',
        defaultMessage: 'Attempted to allow a new OAuth service access'
    },
    successfullOAuthAccess: {
        id: 'audit_table.successfullOAuthAccess',
        defaultMessage: 'Successfully gave a new OAuth service access'
    },
    failedOAuthAccess: {
        id: 'audit_table.failedOAuthAccess',
        defaultMessage: 'Failed to allow a new OAuth service access - the redirect URI did not match the previously registered callback'
    },
    attemptedOAuthToken: {
        id: 'audit_table.attemptedOAuthToken',
        defaultMessage: 'Attempted to get an OAuth access token'
    },
    successfullOAuthToken: {
        id: 'audit_table.successfullOAuthToken',
        defaultMessage: 'Successfully added a new OAuth service'
    },
    oauthTokenFailed: {
        id: 'audit_table.oauthTokenFailed',
        defaultMessage: 'Failed to get an OAuth access token - {token}'
    },
    attemptedLogin: {
        id: 'audit_table.attemptedLogin',
        defaultMessage: 'Attempted to login'
    },
    authenticated: {
        id: 'audit_table.authenticated',
        defauleMessage: 'Successfully authenticated'
    },
    successfullLogin: {
        id: 'audit_table.successfullLogin',
        defaultMessage: 'Successfully logged in'
    },
    failedLogin: {
        id: 'audit_table.failedLogin',
        defaultMessage: 'FAILED login attempt'
    },
    updatePicture: {
        id: 'audit_table.updatePicture',
        defaultMessage: 'Updated your profile picture'
    },
    updateGeneral: {
        id: 'audit_table.updateGeneral',
        defaultMessage: 'Updated the general settings of your account'
    },
    attemptedPassword: {
        id: 'audit_table.attemptedPassword',
        defaultMessage: 'Attempted to change password'
    },
    successfullPassword: {
        id: 'audit_table.successfullPassword',
        defaultMessage: 'Successfully changed password'
    },
    failedPassword: {
        id: 'audit_table.failedPassword',
        defaultMessage: 'Failed to change password - tried to update user password who was logged in through OAuth'
    },
    updatedRol: {
        id: 'audit_table.updatedRol',
        defaultMessage: 'Updated user role(s) to '
    },
    member: {
        id: 'audit_table.member',
        defaultMessage: 'member'
    },
    accountActive: {
        id: 'audit_table.accountActive',
        defaultMessage: 'Account activated'
    },
    accountInactive: {
        id: 'audit_table.accountInactive',
        defaultMessage: 'Account deactivated'
    },
    by: {
        id: 'audit_table.by',
        defaultMessage: ' by {username}'
    },
    byAdmin: {
        id: 'audit_table.byAdmin',
        defaultMessage: ' by an admin'
    },
    sentEmail: {
        id: 'audit_table.sentEmail',
        defaultMessage: 'Sent an email to {email} to reset your password'
    },
    attemptedReset: {
        id: 'audit_table.attemptedReset',
        defaultMessage: 'Attempted to reset password'
    },
    successfullReset: {
        id: 'audit_table.successfullReset',
        defaultMessage: 'Successfully reset password'
    },
    updateGlobalNotifications: {
        id: 'audit_table.updateGlobalNotifications',
        defaultMessage: 'Updated your global notification settings'
    },
    attemptedWebhookCreate: {
        id: 'audit_table.attemptedWebhookCreate',
        defaultMessage: 'Attempted to create a webhook'
    },
    succcessfullWebhookCreate: {
        id: 'audit_table.successfullWebhookCreate',
        defaultMessage: 'Successfully created a webhook'
    },
    failedWebhookCreate: {
        id: 'audit_table.failedWebhookCreate',
        defaultMessage: 'Failed to create a webhook - bad channel permissions'
    },
    attemptedWebhookDelete: {
        id: 'audit_table.attemptedWebhookDelete',
        defaultMessage: 'Attempted to delete a webhook'
    },
    successfullWebhookDelete: {
        id: 'audit_table.successfullWebhookDelete',
        defaultMessage: 'Successfully deleted a webhook'
    },
    failedWebhookDelete: {
        id: 'audit_table.failedWebhookDelete',
        defaultMessage: 'Failed to delete a webhook - inappropriate conditions'
    },
    logout: {
        id: 'audit_table.logout',
        defaultMessage: 'Logged out of your account'
    },
    verified: {
        id: 'audit_table.verified',
        defaultMessage: 'Successfully verified your email address'
    },
    revokedAll: {
        id: 'audit_table.revokedAll',
        defaultMessage: 'Revoked all current sessions for the team'
    },
    loginAttempt: {
        id: 'audit_table.loginAttempt',
        defaultMessage: ' (Login attempt)'
    },
    loginFailure: {
        id: 'audit_table.loginFailure',
        defaultMessage: ' (Login failure)'
    },
    attemptedLicenseAdd: {
        id: 'audit_table.attemptedLicenseAdd',
        defaultMessage: 'Attempted to add new license'
    },
    successfullLicenseAdd: {
        id: 'audit_table.successfullLicenseAdd',
        defaultMessage: 'Successfully added new license'
    },
    failedExpiredLicenseAdd: {
        id: 'audit_table.failedExpiredLicenseAdd',
        defaultMessage: 'Failed to add a new license as it has either expired or not yet been started'
    },
    failedInvalidLicenseAdd: {
        id: 'audit_table.failedInvalidLicenseAdd',
        defaultMessage: 'Failed to add an invalid license'
    },
    licenseRemoved: {
        id: 'audit_table.licenseRemoved',
        defaultMessage: 'Successfully removed a license'
    }
});

function AuditTable(props) {
    var accessList = [];

    var formatMessage = props.intl.formatMessage;

    for (var i = 0; i < props.audits.length; i++) {
        var audit = props.audits[i];
        var auditInfo = formatAuditInfo(audit, formatMessage);

        var uContent = void 0;
        if (props.showUserId) {
            var profile = _user_store2.default.getProfile(auditInfo.userId);
            if (profile) {
                uContent = _react2.default.createElement(
                    'td',
                    { className: 'word-break--all' },
                    profile.email
                );
            } else {
                uContent = _react2.default.createElement(
                    'td',
                    { className: 'word-break--all' },
                    auditInfo.userId
                );
            }
        }

        var iContent = void 0;
        if (props.showIp) {
            iContent = _react2.default.createElement(
                'td',
                { className: 'whitespace--nowrap word-break--all' },
                auditInfo.ip
            );
        }

        var sContent = void 0;
        if (props.showSession) {
            sContent = _react2.default.createElement(
                'td',
                { className: 'whitespace--nowrap word-break--all' },
                auditInfo.sessionId
            );
        }

        var descStyle = '';
        if (auditInfo.desc.toLowerCase().indexOf('fail') !== -1) {
            descStyle = ' color--error';
        }

        accessList[i] = _react2.default.createElement(
            'tr',
            { key: audit.id },
            _react2.default.createElement(
                'td',
                { className: 'whitespace--nowrap word-break--all' },
                auditInfo.timestamp
            ),
            uContent,
            _react2.default.createElement(
                'td',
                {
                    className: 'word-break--all' + descStyle
                },
                auditInfo.desc
            ),
            iContent,
            sContent
        );
    }

    var userIdContent = void 0;
    if (props.showUserId) {
        userIdContent = _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'audit_table.userId',
                defaultMessage: 'User ID'
            })
        );
    }

    var ipContent = void 0;
    if (props.showIp) {
        ipContent = _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'audit_table.ip',
                defaultMessage: 'IP Address'
            })
        );
    }

    var sessionContent = void 0;
    if (props.showSession) {
        sessionContent = _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'audit_table.session',
                defaultMessage: 'Session ID'
            })
        );
    }

    return _react2.default.createElement(
        'table',
        { className: 'table' },
        _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'audit_table.timestamp',
                        defaultMessage: 'Timestamp'
                    })
                ),
                userIdContent,
                _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'audit_table.action',
                        defaultMessage: 'Action'
                    })
                ),
                ipContent,
                sessionContent
            )
        ),
        _react2.default.createElement(
            'tbody',
            null,
            accessList
        )
    );
}

AuditTable.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    audits: _propTypes2.default.array.isRequired,
    showUserId: _propTypes2.default.bool,
    showIp: _propTypes2.default.bool,
    showSession: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)(AuditTable);
function formatAuditInfo(audit, formatMessage) {
    var actionURL = audit.action.replace(/\/api\/v[1-9]/, '');
    var auditDesc = '';

    if (actionURL.indexOf('/channels') === 0) {
        var channelInfo = audit.extra_info.split(' ');
        var channelNameField = channelInfo[0].split('=');

        var channelURL = '';
        var channelObj = void 0;
        var channelName = '';
        if (channelNameField.indexOf('name') >= 0) {
            channelURL = channelNameField[channelNameField.indexOf('name') + 1];
            channelObj = _channel_store2.default.getByName(channelURL);
            if (channelObj) {
                channelName = channelObj.display_name;
            } else {
                channelName = channelURL;
            }
        }

        switch (actionURL) {
            case '/channels/create':
                auditDesc = formatMessage(holders.channelCreated, { channelName: channelName });
                break;
            case '/channels/create_direct':
                auditDesc = formatMessage(holders.establishedDM, { username: Utils.getDirectTeammate(channelObj.id).username });
                break;
            case '/channels/update':
                auditDesc = formatMessage(holders.nameUpdated, { channelName: channelName });
                break;
            case '/channels/update_desc': // support the old path
            case '/channels/update_header':
                auditDesc = formatMessage(holders.headerUpdated, { channelName: channelName });
                break;
            default:
                {
                    var userIdField = [];
                    var userId = '';
                    var username = '';

                    if (channelInfo[1]) {
                        userIdField = channelInfo[1].split('=');

                        if (userIdField.indexOf('user_id') >= 0) {
                            userId = userIdField[userIdField.indexOf('user_id') + 1];
                            var profile = _user_store2.default.getProfile(userId);
                            if (profile) {
                                username = profile.username;
                            }
                        }
                    }

                    if (/\/channels\/[A-Za-z0-9]+\/delete/.test(actionURL)) {
                        auditDesc = formatMessage(holders.channelDeleted, { url: channelURL });
                    } else if (/\/channels\/[A-Za-z0-9]+\/add/.test(actionURL)) {
                        auditDesc = formatMessage(holders.userAdded, { username: username, channelName: channelName });
                    } else if (/\/channels\/[A-Za-z0-9]+\/remove/.test(actionURL)) {
                        auditDesc = formatMessage(holders.userRemoved, { username: username, channelName: channelName });
                    }

                    break;
                }
        }
    } else if (actionURL.indexOf('/oauth') === 0) {
        var oauthInfo = audit.extra_info.split(' ');

        switch (actionURL) {
            case '/oauth/register':
                {
                    var clientIdField = oauthInfo[0].split('=');

                    if (clientIdField[0] === 'client_id') {
                        auditDesc = formatMessage(holders.attemptedRegisterApp, { id: clientIdField[1] });
                    }

                    break;
                }
            case '/oauth/allow':
                if (oauthInfo[0] === 'attempt') {
                    auditDesc = formatMessage(holders.attemptedAllowOAuthAccess);
                } else if (oauthInfo[0] === 'success') {
                    auditDesc = formatMessage(holders.successfullOAuthAccess);
                } else if (oauthInfo[0] === 'fail - redirect_uri did not match registered callback') {
                    auditDesc = formatMessage(holders.failedOAuthAccess);
                }

                break;
            case '/oauth/access_token':
                if (oauthInfo[0] === 'attempt') {
                    auditDesc = formatMessage(holders.attemptedOAuthToken);
                } else if (oauthInfo[0] === 'success') {
                    auditDesc = formatMessage(holders.successfullOAuthToken);
                } else {
                    var oauthTokenFailure = oauthInfo[0].split('-');

                    if (oauthTokenFailure[0].trim() === 'fail' && oauthTokenFailure[1]) {
                        auditDesc = formatMessage(oauthTokenFailure, { token: oauthTokenFailure[1].trim() });
                    }
                }

                break;
            default:
                break;
        }
    } else if (actionURL.indexOf('/users') === 0) {
        var userInfo = audit.extra_info.split(' ');

        switch (actionURL) {
            case '/users/login':
                if (userInfo[0] === 'attempt') {
                    auditDesc = formatMessage(holders.attemptedLogin);
                } else if (userInfo[0] === 'success') {
                    auditDesc = formatMessage(holders.successfullLogin);
                } else if (userInfo[0] === 'authenticated') {
                    auditDesc = formatMessage(holders.authenticated);
                } else if (userInfo[0]) {
                    auditDesc = formatMessage(holders.failedLogin);
                }

                break;
            case '/users/revoke_session':
                auditDesc = formatMessage(holders.sessionRevoked, { sessionId: userInfo[0].split('=')[1] });
                break;
            case '/users/newimage':
                auditDesc = formatMessage(holders.updatePicture);
                break;
            case '/users/update':
                auditDesc = formatMessage(holders.updateGeneral);
                break;
            case '/users/newpassword':
                if (userInfo[0] === 'attempted') {
                    auditDesc = formatMessage(holders.attemptedPassword);
                } else if (userInfo[0] === 'completed') {
                    auditDesc = formatMessage(holders.successfullPassword);
                } else if (userInfo[0] === 'failed - tried to update user password who was logged in through oauth') {
                    auditDesc = formatMessage(holders.failedPassword);
                }

                break;
            case '/users/update_roles':
                {
                    var userRoles = userInfo[0].split('=')[1];

                    auditDesc = formatMessage(holders.updatedRol);
                    if (userRoles.trim()) {
                        auditDesc += userRoles;
                    } else {
                        auditDesc += formatMessage(holders.member);
                    }

                    break;
                }
            case '/users/update_active':
                {
                    var updateType = userInfo[0].split('=')[0];
                    var updateField = userInfo[0].split('=')[1];

                    /* Either describes account activation/deactivation or a revoked session as part of an account deactivation */
                    if (updateType === 'active') {
                        if (updateField === 'true') {
                            auditDesc = formatMessage(holders.accountActive);
                        } else if (updateField === 'false') {
                            auditDesc = formatMessage(holders.accountInactive);
                        }

                        var actingUserInfo = userInfo[1].split('=');
                        if (actingUserInfo[0] === 'session_user') {
                            var actingUser = _user_store2.default.getProfile(actingUserInfo[1]);
                            var user = _user_store2.default.getCurrentUser();
                            if (user && actingUser && Utils.isSystemAdmin(user.roles)) {
                                auditDesc += formatMessage(holders.by, { username: actingUser.username });
                            } else if (user && actingUser) {
                                auditDesc += formatMessage(holders.byAdmin);
                            }
                        }
                    } else if (updateType === 'session_id') {
                        auditDesc = formatMessage(holders.sessionRevoked, { sessionId: updateField });
                    }

                    break;
                }
            case '/users/send_password_reset':
                auditDesc = formatMessage(holders.sentEmail, { email: userInfo[0].split('=')[1] });
                break;
            case '/users/reset_password':
                if (userInfo[0] === 'attempt') {
                    auditDesc = formatMessage(holders.attemptedReset);
                } else if (userInfo[0] === 'success') {
                    auditDesc = formatMessage(holders.successfullReset);
                }

                break;
            case '/users/update_notify':
                auditDesc = formatMessage(holders.updateGlobalNotifications);
                break;
            default:
                break;
        }
    } else if (actionURL.indexOf('/hooks') === 0) {
        var webhookInfo = audit.extra_info;

        switch (actionURL) {
            case '/hooks/incoming/create':
                if (webhookInfo === 'attempt') {
                    auditDesc = formatMessage(holders.attemptedWebhookCreate);
                } else if (webhookInfo === 'success') {
                    auditDesc = formatMessage(holders.succcessfullWebhookCreate);
                } else if (webhookInfo === 'fail - bad channel permissions') {
                    auditDesc = formatMessage(holders.failedWebhookCreate);
                }

                break;
            case '/hooks/incoming/delete':
                if (webhookInfo === 'attempt') {
                    auditDesc = formatMessage(holders.attemptedWebhookDelete);
                } else if (webhookInfo === 'success') {
                    auditDesc = formatMessage(holders.successfullWebhookDelete);
                } else if (webhookInfo === 'fail - inappropriate conditions') {
                    auditDesc = formatMessage(holders.failedWebhookDelete);
                }

                break;
            default:
                break;
        }
    } else if (actionURL.indexOf('/license') === 0) {
        var licenseInfo = audit.extra_info;

        switch (actionURL) {
            case '/license/add':
                if (licenseInfo === 'attempt') {
                    auditDesc = formatMessage(holders.attemptedLicenseAdd);
                } else if (licenseInfo === 'success') {
                    auditDesc = formatMessage(holders.successfullLicenseAdd);
                } else if (licenseInfo === 'failed - expired or non-started license') {
                    auditDesc = formatMessage(holders.failedExpiredLicenseAdd);
                } else if (licenseInfo === 'failed - invalid license') {
                    auditDesc = formatMessage(holders.failedInvalidLicenseAdd);
                }

                break;
            case '/license/remove':
                auditDesc = formatMessage(holders.licenseRemoved);
                break;
            default:
                break;
        }
    } else if (actionURL.indexOf('/admin/download_compliance_report') === 0) {
        auditDesc = Utils.toTitleCase(audit.extra_info);
    } else {
        switch (actionURL) {
            case '/logout':
                auditDesc = formatMessage(holders.logout);
                break;
            case '/verify_email':
                auditDesc = formatMessage(holders.verified);
                break;
            default:
                break;
        }
    }

    /* If all else fails... */
    if (!auditDesc) {
        /* Currently not called anywhere */
        if (audit.extra_info.indexOf('revoked_all=') >= 0) {
            auditDesc = formatMessage(holders.revokedAll);
        } else {
            var actionDesc = '';
            if (actionURL && actionURL.lastIndexOf('/') !== -1) {
                actionDesc = actionURL.substring(actionURL.lastIndexOf('/') + 1).replace('_', ' ');
                actionDesc = Utils.toTitleCase(actionDesc);
            }

            var extraInfoDesc = '';
            if (audit.extra_info) {
                extraInfoDesc = audit.extra_info;

                if (extraInfoDesc.indexOf('=') !== -1) {
                    extraInfoDesc = extraInfoDesc.substring(extraInfoDesc.indexOf('=') + 1);
                }
            }
            auditDesc = actionDesc + ' ' + extraInfoDesc;
        }
    }

    var date = new Date(audit.create_at);
    var auditInfo = {};
    auditInfo.timestamp = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactIntl.FormattedDate, {
                value: date,
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactIntl.FormattedTime, {
                value: date,
                hour: '2-digit',
                minute: '2-digit'
            })
        )
    );
    auditInfo.userId = audit.user_id;
    auditInfo.desc = auditDesc;
    auditInfo.ip = audit.ip_address;
    auditInfo.sessionId = audit.session_id;

    return auditInfo;
}

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a4a8b617d1f6c75ad4bf17bafc2aec6a.mp3";

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIsWebrtcOpen = getIsWebrtcOpen;
// Copyright (c) 2018 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getIsWebrtcOpen(state) {
    return state.views.webrtc.isOpen;
}

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
 /* eslint-env node */


// SDP helpers.
var SDPUtils = {};

// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
SDPUtils.generateIdentifier = function() {
  return Math.random().toString(36).substr(2, 10);
};

// The RTCP CNAME used by all peerconnections from the same JS.
SDPUtils.localCName = SDPUtils.generateIdentifier();

// Splits SDP into lines, dealing with both CRLF and LF.
SDPUtils.splitLines = function(blob) {
  return blob.trim().split('\n').map(function(line) {
    return line.trim();
  });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
SDPUtils.splitSections = function(blob) {
  var parts = blob.split('\nm=');
  return parts.map(function(part, index) {
    return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
  });
};

// Returns lines that start with a certain prefix.
SDPUtils.matchPrefix = function(blob, prefix) {
  return SDPUtils.splitLines(blob).filter(function(line) {
    return line.indexOf(prefix) === 0;
  });
};

// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
SDPUtils.parseCandidate = function(line) {
  var parts;
  // Parse both variants.
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }

  var candidate = {
    foundation: parts[0],
    component: parseInt(parts[1], 10),
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    port: parseInt(parts[5], 10),
    // skip parts[6] == 'typ'
    type: parts[7]
  };

  for (var i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;
      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;
      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;
      case 'ufrag':
        candidate.ufrag = parts[i + 1]; // for backward compability.
        candidate.usernameFragment = parts[i + 1];
        break;
      default: // extension handling, in particular ufrag
        candidate[parts[i]] = parts[i + 1];
        break;
    }
  }
  return candidate;
};

// Translates a candidate object into SDP candidate attribute.
SDPUtils.writeCandidate = function(candidate) {
  var sdp = [];
  sdp.push(candidate.foundation);
  sdp.push(candidate.component);
  sdp.push(candidate.protocol.toUpperCase());
  sdp.push(candidate.priority);
  sdp.push(candidate.ip);
  sdp.push(candidate.port);

  var type = candidate.type;
  sdp.push('typ');
  sdp.push(type);
  if (type !== 'host' && candidate.relatedAddress &&
      candidate.relatedPort) {
    sdp.push('raddr');
    sdp.push(candidate.relatedAddress); // was: relAddr
    sdp.push('rport');
    sdp.push(candidate.relatedPort); // was: relPort
  }
  if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
    sdp.push('tcptype');
    sdp.push(candidate.tcpType);
  }
  if (candidate.ufrag) {
    sdp.push('ufrag');
    sdp.push(candidate.ufrag);
  }
  return 'candidate:' + sdp.join(' ');
};

// Parses an ice-options line, returns an array of option tags.
// a=ice-options:foo bar
SDPUtils.parseIceOptions = function(line) {
  return line.substr(14).split(' ');
}

// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
SDPUtils.parseRtpMap = function(line) {
  var parts = line.substr(9).split(' ');
  var parsed = {
    payloadType: parseInt(parts.shift(), 10) // was: id
  };

  parts = parts[0].split('/');

  parsed.name = parts[0];
  parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
  // was: channels
  parsed.numChannels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
  return parsed;
};

// Generate an a=rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
SDPUtils.writeRtpMap = function(codec) {
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate +
      (codec.numChannels !== 1 ? '/' + codec.numChannels : '') + '\r\n';
};

// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
SDPUtils.parseExtmap = function(line) {
  var parts = line.substr(9).split(' ');
  return {
    id: parseInt(parts[0], 10),
    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
    uri: parts[1]
  };
};

// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
SDPUtils.writeExtmap = function(headerExtension) {
  return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) +
      (headerExtension.direction && headerExtension.direction !== 'sendrecv'
          ? '/' + headerExtension.direction
          : '') +
      ' ' + headerExtension.uri + '\r\n';
};

// Parses an ftmp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
SDPUtils.parseFmtp = function(line) {
  var parsed = {};
  var kv;
  var parts = line.substr(line.indexOf(' ') + 1).split(';');
  for (var j = 0; j < parts.length; j++) {
    kv = parts[j].trim().split('=');
    parsed[kv[0].trim()] = kv[1];
  }
  return parsed;
};

// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeFmtp = function(codec) {
  var line = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.parameters && Object.keys(codec.parameters).length) {
    var params = [];
    Object.keys(codec.parameters).forEach(function(param) {
      params.push(param + '=' + codec.parameters[param]);
    });
    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
  }
  return line;
};

// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
SDPUtils.parseRtcpFb = function(line) {
  var parts = line.substr(line.indexOf(' ') + 1).split(' ');
  return {
    type: parts.shift(),
    parameter: parts.join(' ')
  };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeRtcpFb = function(codec) {
  var lines = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
    // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function(fb) {
      lines += 'a=rtcp-fb:' + pt + ' ' + fb.type +
      (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') +
          '\r\n';
    });
  }
  return lines;
};

// Parses an RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
SDPUtils.parseSsrcMedia = function(line) {
  var sp = line.indexOf(' ');
  var parts = {
    ssrc: parseInt(line.substr(7, sp - 7), 10)
  };
  var colon = line.indexOf(':', sp);
  if (colon > -1) {
    parts.attribute = line.substr(sp + 1, colon - sp - 1);
    parts.value = line.substr(colon + 1);
  } else {
    parts.attribute = line.substr(sp + 1);
  }
  return parts;
};

// Extracts the MID (RFC 5888) from a media section.
// returns the MID or undefined if no mid line was found.
SDPUtils.getMid = function(mediaSection) {
  var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
  if (mid) {
    return mid.substr(6);
  }
}

SDPUtils.parseFingerprint = function(line) {
  var parts = line.substr(14).split(' ');
  return {
    algorithm: parts[0].toLowerCase(), // algorithm is case-sensitive in Edge.
    value: parts[1]
  };
};

// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
      'a=fingerprint:');
  // Note: a=setup line is ignored since we use the 'auto' role.
  // Note2: 'algorithm' is not case sensitive except in Edge.
  return {
    role: 'auto',
    fingerprints: lines.map(SDPUtils.parseFingerprint)
  };
};

// Serializes DTLS parameters to SDP.
SDPUtils.writeDtlsParameters = function(params, setupType) {
  var sdp = 'a=setup:' + setupType + '\r\n';
  params.fingerprints.forEach(function(fp) {
    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
  });
  return sdp;
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.splitLines(mediaSection);
  // Search in session part, too.
  lines = lines.concat(SDPUtils.splitLines(sessionpart));
  var iceParameters = {
    usernameFragment: lines.filter(function(line) {
      return line.indexOf('a=ice-ufrag:') === 0;
    })[0].substr(12),
    password: lines.filter(function(line) {
      return line.indexOf('a=ice-pwd:') === 0;
    })[0].substr(10)
  };
  return iceParameters;
};

// Serializes ICE parameters to SDP.
SDPUtils.writeIceParameters = function(params) {
  return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' +
      'a=ice-pwd:' + params.password + '\r\n';
};

// Parses the SDP media section and returns RTCRtpParameters.
SDPUtils.parseRtpParameters = function(mediaSection) {
  var description = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: [],
    rtcp: []
  };
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  for (var i = 3; i < mline.length; i++) { // find all codecs from mline[3..]
    var pt = mline[i];
    var rtpmapline = SDPUtils.matchPrefix(
        mediaSection, 'a=rtpmap:' + pt + ' ')[0];
    if (rtpmapline) {
      var codec = SDPUtils.parseRtpMap(rtpmapline);
      var fmtps = SDPUtils.matchPrefix(
          mediaSection, 'a=fmtp:' + pt + ' ');
      // Only the first a=fmtp:<pt> is considered.
      codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
      codec.rtcpFeedback = SDPUtils.matchPrefix(
          mediaSection, 'a=rtcp-fb:' + pt + ' ')
        .map(SDPUtils.parseRtcpFb);
      description.codecs.push(codec);
      // parse FEC mechanisms from rtpmap lines.
      switch (codec.name.toUpperCase()) {
        case 'RED':
        case 'ULPFEC':
          description.fecMechanisms.push(codec.name.toUpperCase());
          break;
        default: // only RED and ULPFEC are recognized as FEC mechanisms.
          break;
      }
    }
  }
  SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function(line) {
    description.headerExtensions.push(SDPUtils.parseExtmap(line));
  });
  // FIXME: parse rtcp.
  return description;
};

// Generates parts of the SDP media section describing the capabilities /
// parameters.
SDPUtils.writeRtpDescription = function(kind, caps) {
  var sdp = '';

  // Build the mline.
  sdp += 'm=' + kind + ' ';
  sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
  sdp += ' UDP/TLS/RTP/SAVPF ';
  sdp += caps.codecs.map(function(codec) {
    if (codec.preferredPayloadType !== undefined) {
      return codec.preferredPayloadType;
    }
    return codec.payloadType;
  }).join(' ') + '\r\n';

  sdp += 'c=IN IP4 0.0.0.0\r\n';
  sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';

  // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
  caps.codecs.forEach(function(codec) {
    sdp += SDPUtils.writeRtpMap(codec);
    sdp += SDPUtils.writeFmtp(codec);
    sdp += SDPUtils.writeRtcpFb(codec);
  });
  var maxptime = 0;
  caps.codecs.forEach(function(codec) {
    if (codec.maxptime > maxptime) {
      maxptime = codec.maxptime;
    }
  });
  if (maxptime > 0) {
    sdp += 'a=maxptime:' + maxptime + '\r\n';
  }
  sdp += 'a=rtcp-mux\r\n';

  caps.headerExtensions.forEach(function(extension) {
    sdp += SDPUtils.writeExtmap(extension);
  });
  // FIXME: write fecMechanisms.
  return sdp;
};

// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
  var encodingParameters = [];
  var description = SDPUtils.parseRtpParameters(mediaSection);
  var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
  var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;

  // filter a=ssrc:... cname:, ignore PlanB-msid
  var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
  .map(function(line) {
    return SDPUtils.parseSsrcMedia(line);
  })
  .filter(function(parts) {
    return parts.attribute === 'cname';
  });
  var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
  var secondarySsrc;

  var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID')
  .map(function(line) {
    var parts = line.split(' ');
    parts.shift();
    return parts.map(function(part) {
      return parseInt(part, 10);
    });
  });
  if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
    secondarySsrc = flows[0][1];
  }

  description.codecs.forEach(function(codec) {
    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
      var encParam = {
        ssrc: primarySsrc,
        codecPayloadType: parseInt(codec.parameters.apt, 10),
        rtx: {
          ssrc: secondarySsrc
        }
      };
      encodingParameters.push(encParam);
      if (hasRed) {
        encParam = JSON.parse(JSON.stringify(encParam));
        encParam.fec = {
          ssrc: secondarySsrc,
          mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
        };
        encodingParameters.push(encParam);
      }
    }
  });
  if (encodingParameters.length === 0 && primarySsrc) {
    encodingParameters.push({
      ssrc: primarySsrc
    });
  }

  // we support both b=AS and b=TIAS but interpret AS as TIAS.
  var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
  if (bandwidth.length) {
    if (bandwidth[0].indexOf('b=TIAS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(7), 10);
    } else if (bandwidth[0].indexOf('b=AS:') === 0) {
      // use formula from JSEP to convert b=AS to TIAS value.
      bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95
          - (50 * 40 * 8);
    } else {
      bandwidth = undefined;
    }
    encodingParameters.forEach(function(params) {
      params.maxBitrate = bandwidth;
    });
  }
  return encodingParameters;
};

// parses http://draft.ortc.org/#rtcrtcpparameters*
SDPUtils.parseRtcpParameters = function(mediaSection) {
  var rtcpParameters = {};

  var cname;
  // Gets the first SSRC. Note that with RTX there might be multiple
  // SSRCs.
  var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
      .map(function(line) {
        return SDPUtils.parseSsrcMedia(line);
      })
      .filter(function(obj) {
        return obj.attribute === 'cname';
      })[0];
  if (remoteSsrc) {
    rtcpParameters.cname = remoteSsrc.value;
    rtcpParameters.ssrc = remoteSsrc.ssrc;
  }

  // Edge uses the compound attribute instead of reducedSize
  // compound is !reducedSize
  var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
  rtcpParameters.reducedSize = rsize.length > 0;
  rtcpParameters.compound = rsize.length === 0;

  // parses the rtcp-mux attrіbute.
  // Note that Edge does not support unmuxed RTCP.
  var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
  rtcpParameters.mux = mux.length > 0;

  return rtcpParameters;
};

// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
SDPUtils.parseMsid = function(mediaSection) {
  var parts;
  var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
  if (spec.length === 1) {
    parts = spec[0].substr(7).split(' ');
    return {stream: parts[0], track: parts[1]};
  }
  var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
  .map(function(line) {
    return SDPUtils.parseSsrcMedia(line);
  })
  .filter(function(parts) {
    return parts.attribute === 'msid';
  });
  if (planB.length > 0) {
    parts = planB[0].value.split(' ');
    return {stream: parts[0], track: parts[1]};
  }
};

// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
SDPUtils.generateSessionId = function() {
  return Math.random().toString().substr(2, 21);
};

// Write boilder plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
SDPUtils.writeSessionBoilerplate = function(sessId, sessVer) {
  var sessionId;
  var version = sessVer !== undefined ? sessVer : 2;
  if (sessId) {
    sessionId = sessId;
  } else {
    sessionId = SDPUtils.generateSessionId();
  }
  // FIXME: sess-id should be an NTP timestamp.
  return 'v=0\r\n' +
      'o=thisisadapterortc ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' +
      's=-\r\n' +
      't=0 0\r\n';
};

SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);

  // Map ICE parameters (ufrag, pwd) to SDP.
  sdp += SDPUtils.writeIceParameters(
      transceiver.iceGatherer.getLocalParameters());

  // Map DTLS parameters to SDP.
  sdp += SDPUtils.writeDtlsParameters(
      transceiver.dtlsTransport.getLocalParameters(),
      type === 'offer' ? 'actpass' : 'active');

  sdp += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.direction) {
    sdp += 'a=' + transceiver.direction + '\r\n';
  } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    // spec.
    var msid = 'msid:' + stream.id + ' ' +
        transceiver.rtpSender.track.id + '\r\n';
    sdp += 'a=' + msid;

    // for Chrome.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  // FIXME: this should be written by writeRtpDescription.
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
};

// Gets the direction from the mediaSection or the sessionpart.
SDPUtils.getDirection = function(mediaSection, sessionpart) {
  // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
  var lines = SDPUtils.splitLines(mediaSection);
  for (var i = 0; i < lines.length; i++) {
    switch (lines[i]) {
      case 'a=sendrecv':
      case 'a=sendonly':
      case 'a=recvonly':
      case 'a=inactive':
        return lines[i].substr(2);
      default:
        // FIXME: What should happen here?
    }
  }
  if (sessionpart) {
    return SDPUtils.getDirection(sessionpart);
  }
  return 'sendrecv';
};

SDPUtils.getKind = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  return mline[0].substr(2);
};

SDPUtils.isRejected = function(mediaSection) {
  return mediaSection.split(' ', 2)[1] === '0';
};

SDPUtils.parseMLine = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  return {
    kind: mline[0].substr(2),
    port: parseInt(mline[1], 10),
    protocol: mline[2],
    fmt: mline.slice(3).join(' ')
  };
};

// Expose public methods.
if (true) {
  module.exports = SDPUtils;
}


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactContextmenu = __webpack_require__(2373);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyUrlContextMenu = function (_React$Component) {
    (0, _inherits3.default)(CopyUrlContextMenu, _React$Component);

    function CopyUrlContextMenu() {
        (0, _classCallCheck3.default)(this, CopyUrlContextMenu);
        return (0, _possibleConstructorReturn3.default)(this, (CopyUrlContextMenu.__proto__ || (0, _getPrototypeOf2.default)(CopyUrlContextMenu)).apply(this, arguments));
    }

    (0, _createClass3.default)(CopyUrlContextMenu, [{
        key: 'render',
        value: function render() {
            var contextMenu = _react2.default.createElement(
                _reactContextmenu.ContextMenu,
                { id: 'copy-url-context-menu' + this.props.menuId },
                _react2.default.createElement(
                    _reactContextmenu.MenuItem,
                    {
                        data: { link: this.props.link },
                        onClick: Utils.copyToClipboard
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'copy_url_context_menu.getChannelLink',
                        defaultMessage: 'Copy Link'
                    })
                )
            );

            var contextMenuTrigger = _react2.default.createElement(
                _reactContextmenu.ContextMenuTrigger,
                { id: 'copy-url-context-menu' + this.props.menuId },
                this.props.children
            );

            return _react2.default.createElement(
                'span',
                null,
                contextMenu,
                contextMenuTrigger
            );
        }
    }]);
    return CopyUrlContextMenu;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

CopyUrlContextMenu.propTypes = {

    /**
     * The child component that will be right-clicked on to show the context menu
     */
    children: _propTypes2.default.element,

    /**
     * The link to copy to the user's clipboard when the 'Copy' option is selected from the context menu
     */
    link: _propTypes2.default.string.isRequired,

    /**
     * A unique id differentiating this instance of context menu from others on the page. Will be set to a random value if not provided.
     */
    menuId: _propTypes2.default.string.isRequired
};
exports.default = CopyUrlContextMenu;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnreadBelowIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(UnreadBelowIcon, _React$PureComponent);

    function UnreadBelowIcon() {
        (0, _classCallCheck3.default)(this, UnreadBelowIcon);
        return (0, _possibleConstructorReturn3.default)(this, (UnreadBelowIcon.__proto__ || (0, _getPrototypeOf2.default)(UnreadBelowIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(UnreadBelowIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '10px',
                        height: '10px',
                        viewBox: '0 0 10 10',
                        style: style
                    },
                    _react2.default.createElement(
                        'g',
                        { transform: 'matrix(1,0,0,1,-20,-18)' },
                        _react2.default.createElement(
                            'g',
                            { transform: 'matrix(0.0330723,0,0,0.0322634,15.8132,12.3164)' },
                            _react2.default.createElement('path', { d: 'M245.803,377.493C245.803,377.493 204.794,336.485 179.398,311.088C168.55,300.24 150.962,300.24 140.114,311.088C138.327,312.875 136.517,314.686 134.73,316.473C123.882,327.321 123.882,344.908 134.73,355.756C167.972,388.998 233.949,454.975 256.949,477.975C262.158,483.184 269.223,486.111 276.591,486.111C277.38,486.111 278.176,486.111 278.965,486.111C286.332,486.111 293.397,483.184 298.607,477.975C321.607,454.975 387.584,388.998 420.826,355.756C431.674,344.908 431.674,327.321 420.826,316.473C419.039,314.686 417.228,312.875 415.441,311.088C404.593,300.24 387.005,300.24 376.158,311.088C350.761,336.485 309.753,377.493 309.753,377.493C309.753,377.493 309.753,279.687 309.753,203.94C309.753,196.573 306.826,189.508 301.617,184.298C296.408,179.089 289.342,176.162 281.975,176.162C279.191,176.162 276.364,176.162 273.58,176.162C266.213,176.162 259.148,179.089 253.939,184.298C248.729,189.508 245.803,196.573 245.803,203.94L245.803,377.493Z' })
                        )
                    )
                )
            );
        }
    }]);
    return UnreadBelowIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = UnreadBelowIcon;


var style = {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    strokeLinejoin: 'round',
    strokeMiterlimit: 1.41421
};

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _channels = __webpack_require__(798);

var _emojis = __webpack_require__(853);

var _constants = __webpack_require__(19);

var _channels2 = __webpack_require__(783);

var _preferences = __webpack_require__(784);

var _teams = __webpack_require__(274);

var _users = __webpack_require__(777);

var _channel_utils = __webpack_require__(854);

var _general = __webpack_require__(113);

var _reactRouterDom = __webpack_require__(269);

var _rhs = __webpack_require__(817);

var _modals = __webpack_require__(927);

var _rhs2 = __webpack_require__(818);

var _channel_header = __webpack_require__(2408);

var _channel_header2 = _interopRequireDefault(_channel_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var channel = (0, _channels2.getChannel)(state, ownProps.channelId) || {};
    var prefs = state.entities.preferences.myPreferences;
    var user = (0, _users.getCurrentUser)(state);

    var dmUser = void 0;
    var dmUserStatus = void 0;
    if (channel && channel.type === _constants.General.DM_CHANNEL) {
        var dmUserId = (0, _channel_utils.getUserIdFromChannelName)(user.id, channel.name);
        dmUser = (0, _users.getUser)(state, dmUserId);
        dmUserStatus = { status: (0, _users.getStatusForUserId)(state, dmUserId) };
    }

    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    return {
        channel: channel,
        channelMember: (0, _channels2.getMyChannelMember)(state, ownProps.channelId),
        teamMember: (0, _teams.getMyTeamMember)(state, channel.team_id),
        isFavorite: (0, _channel_utils.isFavoriteChannel)(prefs, ownProps.channelId),
        isDefault: (0, _channel_utils.isDefault)(channel),
        currentUser: user,
        dmUser: dmUser,
        dmUserStatus: dmUserStatus,
        enableFormatting: (0, _preferences.getBool)(state, _constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'formatting', true),
        rhsState: (0, _rhs2.getRhsState)(state),
        isLicensed: license.IsLicensed === 'true',
        enableWebrtc: config.EnableWebrtc === 'true',
        isReadOnly: (0, _channels2.isCurrentChannelReadOnly)(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            leaveChannel: _channels.leaveChannel,
            favoriteChannel: _channels.favoriteChannel,
            unfavoriteChannel: _channels.unfavoriteChannel,
            showFlaggedPosts: _rhs.showFlaggedPosts,
            showPinnedPosts: _rhs.showPinnedPosts,
            showMentions: _rhs.showMentions,
            closeRightHandSide: _rhs.closeRightHandSide,
            updateRhsState: _rhs.updateRhsState,
            openModal: _modals.openModal,
            getCustomEmojisInText: _emojis.getCustomEmojisInText,
            updateChannelNotifyProps: _channels.updateChannelNotifyProps
        }, dispatch)
    };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_channel_header2.default));

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
__webpack_require__(2409)
__webpack_require__(2410)
__webpack_require__(2411)
__webpack_require__(2412)
__webpack_require__(2413)
__webpack_require__(2414)
__webpack_require__(2415)
__webpack_require__(2416)
__webpack_require__(2417)
__webpack_require__(2418)
__webpack_require__(2419)
__webpack_require__(2420)

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _text_formatting = __webpack_require__(811);

var TextFormatting = _interopRequireWildcard(_text_formatting);

var _url = __webpack_require__(793);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _post_utils = __webpack_require__(803);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MessageWrapper = function (_React$Component) {
    (0, _inherits3.default)(MessageWrapper, _React$Component);

    function MessageWrapper(props) {
        (0, _classCallCheck3.default)(this, MessageWrapper);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MessageWrapper.__proto__ || (0, _getPrototypeOf2.default)(MessageWrapper)).call(this, props));

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(MessageWrapper, [{
        key: 'render',
        value: function render() {
            if (this.props.message) {
                var options = (0, _assign2.default)({}, this.props.options, {
                    siteURL: (0, _url.getSiteURL)()
                });

                var formattedText = TextFormatting.formatText(this.props.message, options);

                return _react2.default.createElement(
                    'div',
                    { onClick: Utils.handleFormattedTextClick },
                    (0, _post_utils.messageHtmlToComponent)(formattedText, false, { mentions: false })
                );
            }

            return _react2.default.createElement('div', null);
        }
    }]);
    return MessageWrapper;
}(_react2.default.Component);

exports.default = MessageWrapper;


MessageWrapper.defaultProps = {
    message: ''
};
MessageWrapper.propTypes = {
    message: _propTypes2.default.string,
    options: _propTypes2.default.object
};

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _teams = __webpack_require__(274);

var _channel_info_modal = __webpack_require__(2421);

var _channel_info_modal2 = _interopRequireDefault(_channel_info_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        currentTeam: (0, _teams.getCurrentTeam)(state)
    });
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_channel_info_modal2.default);

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _channels = __webpack_require__(798);

var _general = __webpack_require__(113);

var _channel_notifications_modal = __webpack_require__(2428);

var _channel_notifications_modal2 = _interopRequireDefault(_channel_notifications_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var sendPushNotifications = config.SendPushNotifications === 'true';

    return {
        sendPushNotifications: sendPushNotifications
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            updateChannelNotifyProps: _channels.updateChannelNotifyProps
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_channel_notifications_modal2.default);

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Describe;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function Describe(_ref) {
    var section = _ref.section,
        memberNotifyLevel = _ref.memberNotifyLevel,
        globalNotifyLevel = _ref.globalNotifyLevel;

    if (memberNotifyLevel === _constants.NotificationLevels.DEFAULT && globalNotifyLevel) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'channel_notifications.globalDefault',
            defaultMessage: 'Global default ({notifyLevel})',
            values: {
                notifyLevel: globalNotifyLevel
            }
        });
    } else if (memberNotifyLevel === _constants.NotificationLevels.MENTION && section === _constants.NotificationSections.MARK_UNREAD) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'channel_notifications.muteChannel.on.title',
            defaultMessage: 'On'
        });
    } else if (memberNotifyLevel === _constants.NotificationLevels.MENTION) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'channel_notifications.onlyMentions',
            defaultMessage: 'Only for mentions'
        });
    } else if ((section === _constants.NotificationSections.DESKTOP || section === _constants.NotificationSections.PUSH) && memberNotifyLevel === _constants.NotificationLevels.ALL) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'channel_notifications.allActivity',
            defaultMessage: 'For all activity'
        });
    } else if (section === _constants.NotificationSections.MARK_UNREAD && memberNotifyLevel === _constants.NotificationLevels.ALL) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'channel_notifications.muteChannel.off.title',
            defaultMessage: 'Off'
        });
    }

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'channel_notifications.never',
        defaultMessage: 'Never'
    });
}

Describe.propTypes = {
    globalNotifyLevel: _propTypes2.default.string,
    memberNotifyLevel: _propTypes2.default.string.isRequired,
    section: _propTypes2.default.string.isRequired
};

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SectionTitle;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function SectionTitle(_ref) {
    var section = _ref.section;

    if (section === _constants.NotificationSections.DESKTOP) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'channel_notifications.sendDesktop',
            defaultMessage: 'Send desktop notifications'
        });
    } else if (section === _constants.NotificationSections.PUSH) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'channel_notifications.push',
            defaultMessage: 'Send mobile push notifications'
        });
    } else if (section === _constants.NotificationSections.MARK_UNREAD) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'channel_notifications.muteChannel.settings',
            defaultMessage: 'Mute Channel'
        });
    }

    return null;
}

SectionTitle.propTypes = {
    section: _propTypes2.default.string.isRequired
};

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(798);

var _teams = __webpack_require__(274);

var _delete_channel_modal = __webpack_require__(2433);

var _delete_channel_modal2 = _interopRequireDefault(_delete_channel_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        currentTeamDetails: (0, _teams.getCurrentTeam)(state)
    });
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            deleteChannel: _channels.deleteChannel
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_delete_channel_modal2.default);

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _reselect = __webpack_require__(78);

var _preferences = __webpack_require__(784);

var _channels = __webpack_require__(798);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _edit_channel_purpose_modal = __webpack_require__(2435);

var _edit_channel_purpose_modal2 = _interopRequireDefault(_edit_channel_purpose_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = (0, _reselect.createSelector)(function (state) {
    return (0, _preferences.getBool)(state, _constants2.default.Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter');
}, function (_ref) {
    var requests = _ref.requests;
    var updateChannel = requests.channels.updateChannel;

    return {
        serverError: updateChannel.error,
        requestStatus: updateChannel.status
    };
}, function (ctrlSend, requestInfo) {
    return (0, _extends3.default)({ ctrlSend: ctrlSend }, requestInfo);
});

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            patchChannel: (0, _redux.bindActionCreators)(_channels.patchChannel, dispatch)
        }
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_edit_channel_purpose_modal2.default);

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _reselect = __webpack_require__(78);

var _channels = __webpack_require__(798);

var _teams = __webpack_require__(274);

var _url = __webpack_require__(793);

var _rename_channel_modal = __webpack_require__(2441);

var _rename_channel_modal2 = _interopRequireDefault(_rename_channel_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = (0, _reselect.createSelector)(function (state) {
    var currentTeamId = state.entities.teams.currentTeamId;
    var team = (0, _teams.getTeam)(state, currentTeamId);
    var currentTeamUrl = (0, _url.getSiteURL)() + '/' + team.name;
    return {
        currentTeamUrl: currentTeamUrl,
        team: team
    };
}, function (teamInfo) {
    return (0, _extends3.default)({}, teamInfo);
}); // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            updateChannel: (0, _redux.bindActionCreators)(_channels.updateChannel, dispatch)
        }
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_rename_channel_modal2.default);

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _modals = __webpack_require__(927);

var _toggle_modal_button_redux = __webpack_require__(2443);

var _toggle_modal_button_redux2 = _interopRequireDefault(_toggle_modal_button_redux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            openModal: _modals.openModal
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_toggle_modal_button_redux2.default);

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _posts = __webpack_require__(808);

var _channels = __webpack_require__(783);

var _posts2 = __webpack_require__(805);

var _preferences = __webpack_require__(784);

var _users = __webpack_require__(777);

var _post_actions = __webpack_require__(802);

var _channel = __webpack_require__(2444);

var _constants = __webpack_require__(29);

var _post_list = __webpack_require__(2445);

var _post_list2 = _interopRequireDefault(_post_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeMapStateToProps() {
    var getPostsInChannel = (0, _posts2.makeGetPostsInChannel)();
    var getPostsAroundPost = (0, _posts2.makeGetPostsAroundPost)();

    return function mapStateToProps(state, ownProps) {
        var postVisibility = state.views.channel.postVisibility[ownProps.channelId];

        var posts = void 0;
        if (ownProps.focusedPostId) {
            posts = getPostsAroundPost(state, ownProps.focusedPostId, ownProps.channelId);
        } else {
            posts = getPostsInChannel(state, ownProps.channelId, postVisibility);
        }

        return {
            channel: (0, _channels.getChannel)(state, ownProps.channelId) || {},
            lastViewedAt: state.views.channel.lastChannelViewTime[ownProps.channelId],
            posts: posts,
            postVisibility: postVisibility,
            loadingPosts: state.views.channel.loadingPosts[ownProps.channelId],
            focusedPostId: ownProps.focusedPostId,
            currentUserId: (0, _users.getCurrentUserId)(state),
            fullWidth: (0, _preferences.get)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.CHANNEL_DISPLAY_MODE, _constants.Preferences.CHANNEL_DISPLAY_MODE_DEFAULT) === _constants.Preferences.CHANNEL_DISPLAY_MODE_FULL_SCREEN
        };
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getPosts: _posts.getPosts,
            getPostsBefore: _posts.getPostsBefore,
            getPostsAfter: _posts.getPostsAfter,
            getPostThread: _posts.getPostThread,
            increasePostVisibility: _post_actions.increasePostVisibility,
            checkAndSetMobileView: _channel.checkAndSetMobileView
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_post_list2.default);

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(937)
exports.createHash = exports.Hash = __webpack_require__(914)
exports.createHmac = exports.Hmac = __webpack_require__(1094)

var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(Object.keys(__webpack_require__(2502)))
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(1431)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(2504)
;[
  'Cipher',
  'createCipher',
  'Cipheriv',
  'createCipheriv',
  'Decipher',
  'createDecipher',
  'Decipheriv',
  'createDecipheriv',
  'getCiphers',
  'listCiphers'
].forEach(function (key) {
  exports[key] = aes[key]
})

var dh = __webpack_require__(2515)
;[
  'DiffieHellmanGroup',
  'createDiffieHellmanGroup',
  'getDiffieHellman',
  'createDiffieHellman',
  'DiffieHellman'
].forEach(function (key) {
  exports[key] = dh[key]
})

var sign = __webpack_require__(2519)
;[
  'createSign',
  'Sign',
  'createVerify',
  'Verify'
].forEach(function (key) {
  exports[key] = sign[key]
})

exports.createECDH = __webpack_require__(2556)

var publicEncrypt = __webpack_require__(2557)

;[
  'publicEncrypt',
  'privateEncrypt',
  'publicDecrypt',
  'privateDecrypt'
].forEach(function (key) {
  exports[key] = publicEncrypt[key]
})

// the least I can do is make error messages for the rest of the node.js/crypto api.
;[
  'createCredentials'
].forEach(function (name) {
  exports[name] = function () {
    throw new Error([
      'sorry, ' + name + ' is not implemented yet',
      'we accept pull requests',
      'https://github.com/crypto-browserify/crypto-browserify'
    ].join('\n'))
  }
})


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

var helpers = __webpack_require__(2487);

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << ((len) % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);

}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t)
{
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
}
function md5_ff(a, b, c, d, x, s, t)
{
  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t)
{
  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t)
{
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t)
{
  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}

module.exports = function md5(buf) {
  return helpers.hash(buf, core_md5, 16);
};

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(77)
var Hash = __webpack_require__(915)

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = new Buffer(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var inherits = __webpack_require__(77)
var Hash = __webpack_require__(915)

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = new Buffer(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(987);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(184);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(173).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(1427);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(1092).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(79);
util.inherits = __webpack_require__(77);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(2494);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(2495);
var destroyImpl = __webpack_require__(1428);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(892);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(179).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(892);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(179).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(51)))

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(173).EventEmitter;


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(987);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(892);

/*<replacement>*/
var util = __webpack_require__(79);
util.inherits = __webpack_require__(77);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer) {var createHmac = __webpack_require__(1094)
var checkParameters = __webpack_require__(2503)

exports.pbkdf2 = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  checkParameters(iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

  setTimeout(function () {
    callback(null, exports.pbkdf2Sync(password, salt, iterations, keylen, digest))
  })
}

var defaultEncoding
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}

exports.pbkdf2Sync = function (password, salt, iterations, keylen, digest) {
  if (!Buffer.isBuffer(password)) password = new Buffer(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = new Buffer(salt, defaultEncoding)

  checkParameters(iterations, keylen)

  digest = digest || 'sha1'

  var hLen
  var l = 1
  var DK = new Buffer(keylen)
  var block1 = new Buffer(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var r
  var T

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)
    var U = createHmac(digest, password).update(block1).digest()

    if (!hLen) {
      hLen = U.length
      T = new Buffer(hLen)
      l = Math.ceil(keylen / hLen)
      r = keylen - (l - 1) * hLen
    }

    U.copy(T, 0, 0, hLen)

    for (var j = 1; j < iterations; j++) {
      U = createHmac(digest, password).update(U).digest()
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    var destPos = (i - 1) * hLen
    var len = (i === l ? r : hLen)
    T.copy(DK, destPos, 0, len)
  }

  return DK
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(45).Buffer))

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(989)
var Transform = __webpack_require__(916)
var inherits = __webpack_require__(77)

inherits(StreamCipher, Transform)
module.exports = StreamCipher
function StreamCipher (mode, key, iv, decrypt) {
  if (!(this instanceof StreamCipher)) {
    return new StreamCipher(mode, key, iv)
  }
  Transform.call(this)
  this._cipher = new aes.AES(key)
  this._prev = new Buffer(iv.length)
  this._cache = new Buffer('')
  this._secCache = new Buffer('')
  this._decrypt = decrypt
  iv.copy(this._prev)
  this._mode = mode
}
StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}
StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(989)
var Transform = __webpack_require__(916)
var inherits = __webpack_require__(77)
var GHASH = __webpack_require__(2506)
var xor = __webpack_require__(938)
inherits(StreamCipher, Transform)
module.exports = StreamCipher

function StreamCipher (mode, key, iv, decrypt) {
  if (!(this instanceof StreamCipher)) {
    return new StreamCipher(mode, key, iv)
  }
  Transform.call(this)
  this._finID = Buffer.concat([iv, new Buffer([0, 0, 0, 1])])
  iv = Buffer.concat([iv, new Buffer([0, 0, 0, 2])])
  this._cipher = new aes.AES(key)
  this._prev = new Buffer(iv.length)
  this._cache = new Buffer('')
  this._secCache = new Buffer('')
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  iv.copy(this._prev)
  this._mode = mode
  var h = new Buffer(4)
  h.fill(0)
  this._ghash = new GHASH(this._cipher.encryptBlock(h))
  this._authTag = null
  this._called = false
}
StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = new Buffer(rump)
      rump.fill(0)
      this._ghash.update(rump)
    }
  }
  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}
StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) {
    throw new Error('Unsupported state or unable to authenticate data')
  }
  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt) {
    if (xorTest(tag, this._authTag)) {
      throw new Error('Unsupported state or unable to authenticate data')
    }
  } else {
    this._authTag = tag
  }
  this._cipher.scrub()
}
StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (!this._decrypt && Buffer.isBuffer(this._authTag)) {
    return this._authTag
  } else {
    throw new Error('Attempting to get auth tag in unsupported state')
  }
}
StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (this._decrypt) {
    this._authTag = tag
  } else {
    throw new Error('Attempting to set auth tag in unsupported state')
  }
}
StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (!this._called) {
    this._ghash.update(buf)
    this._alen += buf.length
  } else {
    throw new Error('Attempting to set AAD in unsupported state')
  }
}
function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) {
    out++
  }
  var len = Math.min(a.length, b.length)
  var i = -1
  while (++i < len) {
    out += (a[i] ^ b[i])
  }
  return out
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}
exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(938)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(938)

exports.encrypt = function (self, data, decrypt) {
  var out = new Buffer('')
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = new Buffer('')
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}
function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam
  self._prev = Buffer.concat([self._prev.slice(1), new Buffer([decrypt ? byteParam : out])])
  return out
}
exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = new Buffer(len)
  var i = -1
  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }
  return out
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}
exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = new Buffer(len)
  var i = -1
  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }
  return out
}
function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = new Buffer(buffer.length)
  buffer = Buffer.concat([buffer, new Buffer([value])])
  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }
  return out
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(938)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(937);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(806);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(1441);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(806);
var brorand = __webpack_require__(1442);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._rand = function _rand(n) {
  var len = n.bitLength();
  var buf = this.rand.generate(Math.ceil(len / 8));

  // Set low bits
  buf[0] |= 3;

  // Mask high bits
  var mask = len & 0x7;
  if (mask !== 0)
    buf[buf.length - 1] >>= 7 - mask;

  return new bn(buf);
}

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  var n2 = n1.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._rand(n2);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  var n2 = n1.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._rand(n2);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(2516);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(77);
var Reporter = __webpack_require__(940).Reporter;
var Buffer = __webpack_require__(45).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(2547);


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(77);

var asn1 = __webpack_require__(939);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(77);
var Buffer = __webpack_require__(45).Buffer;

var asn1 = __webpack_require__(939);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 1448 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(914);
module.exports = function (seed, len) {
  var t = new Buffer('');
  var  i = 0, c;
  while (t.length < len) {
    c = i2ops(i++);
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()]);
  }
  return t.slice(0, len);
};

function i2ops(c) {
  var out = new Buffer(4);
  out.writeUInt32BE(c,0);
  return out;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports = function xor(a, b) {
  var len = a.length;
  var i = -1;
  while (++i < len) {
    a[i] ^= b[i];
  }
  return a
};

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(806);
function withPublic(paddedMsg, key) {
  return new Buffer(paddedMsg
    .toRed(bn.mont(key.modulus))
    .redPow(new bn(key.publicExponent))
    .fromRed()
    .toArray());
}

module.exports = withPublic;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _fastclick = __webpack_require__(1640);

var _fastclick2 = _interopRequireDefault(_fastclick);

var _reactRouterDom = __webpack_require__(269);

var _general = __webpack_require__(946);

var _emojis = __webpack_require__(853);

var _general2 = __webpack_require__(113);

var _client = __webpack_require__(270);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _emoji = __webpack_require__(947);

var _diagnostics_actions = __webpack_require__(804);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _localization_store = __webpack_require__(906);

var _localization_store2 = _interopRequireDefault(_localization_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _user_actions = __webpack_require__(781);

var _emoji_actions = __webpack_require__(1036);

var _i18n = __webpack_require__(924);

var I18n = _interopRequireWildcard(_i18n);

var _plugins = __webpack_require__(1158);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _header_footer_template_route = __webpack_require__(1876);

var _needs_team = __webpack_require__(1887);

var _needs_team2 = _interopRequireDefault(_needs_team);

var _async_load = __webpack_require__(282);

var _error_page = __webpack_require__(2484);

var _error_page2 = _interopRequireDefault(_error_page);

var _login_controller = __webpack_require__(2563);

var _login_controller2 = _interopRequireDefault(_login_controller);

var _admin_console = __webpack_require__(2566);

var _admin_console2 = _interopRequireDefault(_admin_console);

var _logged_in = __webpack_require__(1177);

var _logged_in2 = _interopRequireDefault(_logged_in);

var _password_reset_send_link = __webpack_require__(2714);

var _password_reset_send_link2 = _interopRequireDefault(_password_reset_send_link);

var _password_reset_form = __webpack_require__(2716);

var _password_reset_form2 = _interopRequireDefault(_password_reset_form);

var _signup_controller = __webpack_require__(2719);

var _signup_controller2 = _interopRequireDefault(_signup_controller);

var _signup_email = __webpack_require__(2722);

var _signup_email2 = _interopRequireDefault(_signup_email);

var _signup_ldap = __webpack_require__(2725);

var _signup_ldap2 = _interopRequireDefault(_signup_ldap);

var _should_verify_email = __webpack_require__(2728);

var _should_verify_email2 = _interopRequireDefault(_should_verify_email);

var _do_verify_email = __webpack_require__(2731);

var _do_verify_email2 = _interopRequireDefault(_do_verify_email);

var _claim = __webpack_require__(2734);

var _claim2 = _interopRequireDefault(_claim);

var _help_controller = __webpack_require__(2741);

var _help_controller2 = _interopRequireDefault(_help_controller);

var _get_ios_app = __webpack_require__(2749);

var _get_ios_app2 = _interopRequireDefault(_get_ios_app);

var _get_android_app = __webpack_require__(2754);

var _get_android_app2 = _interopRequireDefault(_get_android_app);

var _select_team = __webpack_require__(2758);

var _select_team2 = _interopRequireDefault(_select_team);

var _authorize = __webpack_require__(2763);

var _authorize2 = _interopRequireDefault(_authorize);

var _create_team = __webpack_require__(2765);

var _create_team2 = _interopRequireDefault(_create_team);

var _mfa_controller = __webpack_require__(2771);

var _mfa_controller2 = _interopRequireDefault(_mfa_controller);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(2777)(_jquery2.default); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CreateTeam = (0, _async_load.makeAsyncComponent)(_create_team2.default);
var ErrorPage = (0, _async_load.makeAsyncComponent)(_error_page2.default);
var LoginController = (0, _async_load.makeAsyncComponent)(_login_controller2.default);
var AdminConsole = (0, _async_load.makeAsyncComponent)(_admin_console2.default);
var LoggedIn = (0, _async_load.makeAsyncComponent)(_logged_in2.default);
var PasswordResetSendLink = (0, _async_load.makeAsyncComponent)(_password_reset_send_link2.default);
var PasswordResetForm = (0, _async_load.makeAsyncComponent)(_password_reset_form2.default);
var SignupController = (0, _async_load.makeAsyncComponent)(_signup_controller2.default);
var SignupEmail = (0, _async_load.makeAsyncComponent)(_signup_email2.default);
var SignupLdap = (0, _async_load.makeAsyncComponent)(_signup_ldap2.default);
var ShouldVerifyEmail = (0, _async_load.makeAsyncComponent)(_should_verify_email2.default);
var DoVerifyEmail = (0, _async_load.makeAsyncComponent)(_do_verify_email2.default);
var ClaimController = (0, _async_load.makeAsyncComponent)(_claim2.default);
var HelpController = (0, _async_load.makeAsyncComponent)(_help_controller2.default);
var GetIosApp = (0, _async_load.makeAsyncComponent)(_get_ios_app2.default);
var GetAndroidApp = (0, _async_load.makeAsyncComponent)(_get_android_app2.default);
var SelectTeam = (0, _async_load.makeAsyncComponent)(_select_team2.default);
var Authorize = (0, _async_load.makeAsyncComponent)(_authorize2.default);
var Mfa = (0, _async_load.makeAsyncComponent)(_mfa_controller2.default);

var LoggedInRoute = function LoggedInRoute(_ref) {
    var Component = _ref.component,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['component']);
    return _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
        render: function render(props) {
            return _react2.default.createElement(
                LoggedIn,
                props,
                _react2.default.createElement(Component, props)
            );
        }
    }));
};

var Root = function (_React$Component) {
    (0, _inherits3.default)(Root, _React$Component);

    function Root(props) {
        (0, _classCallCheck3.default)(this, Root);

        // Redux
        var _this = (0, _possibleConstructorReturn3.default)(this, (Root.__proto__ || (0, _getPrototypeOf2.default)(Root)).call(this, props));

        _initialiseProps.call(_this);

        (0, _general.setUrl)(window.location.origin);
        (0, _emojis.setSystemEmojis)(_emoji.EmojiIndicesByAlias);

        // Force logout of all tabs if one tab is logged out
        (0, _jquery2.default)(window).bind('storage', function (e) {
            // when one tab on a browser logs out, it sets __logout__ in localStorage to trigger other tabs to log out
            if (e.originalEvent.key === _constants.StoragePrefixes.LOGOUT && e.originalEvent.storageArea === localStorage && e.originalEvent.newValue) {
                // make sure it isn't this tab that is sending the logout signal (only necessary for IE11)
                if (_browser_store2.default.isSignallingLogout(e.originalEvent.newValue)) {
                    return;
                }

                console.log('detected logout from a different tab'); //eslint-disable-line no-console
                GlobalActions.emitUserLoggedOutEvent('/', false);
            }

            if (e.originalEvent.key === _constants.StoragePrefixes.LOGIN && e.originalEvent.storageArea === localStorage && e.originalEvent.newValue) {
                // make sure it isn't this tab that is sending the logout signal (only necessary for IE11)
                if (_browser_store2.default.isSignallingLogin(e.originalEvent.newValue)) {
                    return;
                }

                console.log('detected login from a different tab'); //eslint-disable-line no-console
                location.reload();
            }
        });

        // Prevent drag and drop files from navigating away from the app
        document.addEventListener('drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

        document.addEventListener('dragover', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

        // Fastclick
        _fastclick2.default.attach(document.body);

        // Loading page so reset connection failure count
        _error_store2.default.setConnectionErrorCount(0);

        _this.state = {
            configLoaded: false,
            locale: _localization_store2.default.getLocale(),
            translations: _localization_store2.default.getTranslations()
        };
        return _this;
    }

    (0, _createClass3.default)(Root, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this.redirectIfNecessary(newProps);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _user_actions.loadMeAndConfig)(this.onConfigLoaded);
            (0, _diagnostics_actions.trackLoadTime)();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _localization_store2.default.removeChangeListener(this.localizationChanged);
            (0, _jquery2.default)(window).unbind('storage');
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.translations == null || this.state.configLoaded === false) {
                return _react2.default.createElement('div', null);
            }

            return _react2.default.createElement(
                _reactIntl.IntlProvider,
                {
                    locale: this.state.locale,
                    messages: this.state.translations,
                    key: this.state.locale
                },
                _react2.default.createElement(
                    _reactRouterDom.Switch,
                    null,
                    _react2.default.createElement(_reactRouterDom.Route, {
                        path: '/error',
                        component: ErrorPage
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/login',
                        component: LoginController
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/reset_password',
                        component: PasswordResetSendLink
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/reset_password_complete',
                        component: PasswordResetForm
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/signup_user_complete',
                        component: SignupController
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/signup_email',
                        component: SignupEmail
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/signup_ldap',
                        component: SignupLdap
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/should_verify_email',
                        component: ShouldVerifyEmail
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/do_verify_email',
                        component: DoVerifyEmail
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/claim',
                        component: ClaimController
                    }),
                    _react2.default.createElement(_header_footer_template_route.HFTRoute, {
                        path: '/help',
                        component: HelpController
                    }),
                    _react2.default.createElement(_reactRouterDom.Route, {
                        path: '/get_ios_app',
                        component: GetIosApp
                    }),
                    _react2.default.createElement(_reactRouterDom.Route, {
                        path: '/get_android_app',
                        component: GetAndroidApp
                    }),
                    _react2.default.createElement(LoggedInRoute, {
                        path: '/admin_console',
                        component: AdminConsole
                    }),
                    _react2.default.createElement(_header_footer_template_route.LoggedInHFTRoute, {
                        path: '/select_team',
                        component: SelectTeam
                    }),
                    _react2.default.createElement(_header_footer_template_route.LoggedInHFTRoute, {
                        path: '/oauth/authorize',
                        component: Authorize
                    }),
                    _react2.default.createElement(_header_footer_template_route.LoggedInHFTRoute, {
                        path: '/create_team',
                        component: CreateTeam
                    }),
                    _react2.default.createElement(LoggedInRoute, {
                        path: '/mfa',
                        component: Mfa
                    }),
                    _react2.default.createElement(LoggedInRoute, {
                        path: '/:team',
                        component: _needs_team2.default
                    }),
                    _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' })
                )
            );
        }
    }]);
    return Root;
}(_react2.default.Component);

Root.propTypes = {
    diagnosticsEnabled: _propTypes2.default.bool,
    noAccounts: _propTypes2.default.bool,
    children: _propTypes2.default.object
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.onConfigLoaded = function () {
        var segmentKey = _constants2.default.DIAGNOSTICS_SEGMENT_KEY;

        /*eslint-disable */
        if (segmentKey != null && segmentKey !== '' && _this2.props.diagnosticsEnabled) {
            !function () {
                var analytics = global.window.analytics = global.window.analytics || [];if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice.");else {
                    analytics.invoked = !0;analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "group", "track", "ready", "alias", "page", "once", "off", "on"];analytics.factory = function (t) {
                        return function () {
                            var e = Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics;
                        };
                    };for (var t = 0; t < analytics.methods.length; t++) {
                        var e = analytics.methods[t];analytics[e] = analytics.factory(e);
                    }analytics.load = function (t) {
                        var e = document.createElement("script");e.type = "text/javascript";e.async = !0;e.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";var n = document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e, n);
                    };analytics.SNIPPET_VERSION = "3.0.1";
                    analytics.load(segmentKey);

                    analytics.page('ApplicationLoaded', {
                        path: '',
                        referrer: '',
                        search: '',
                        title: '',
                        url: ''
                    }, {
                        context: {
                            ip: '0.0.0.0'
                        },
                        anonymousId: '00000000000000000000000000'
                    });
                }
            }();
        }
        /*eslint-enable */

        var afterIntl = function afterIntl() {
            (0, _plugins.initializePlugins)();
            I18n.doAddLocaleData();

            // Setup localization listener
            _localization_store2.default.addChangeListener(_this2.localizationChanged);

            // Get our localizaiton
            GlobalActions.loadCurrentLocale();

            _this2.redirectIfNecessary(_this2.props);
            _this2.setState({ configLoaded: true });
        };
        if (global.Intl) {
            afterIntl();
        } else {
            I18n.safariFix(afterIntl);
        }

        (0, _emoji_actions.loadRecentlyUsedCustomEmojis)()(_redux_store2.default.dispatch, _redux_store2.default.getState);

        var iosDownloadLink = (0, _general2.getConfig)(_redux_store2.default.getState()).IosAppDownloadLink;
        var androidDownloadLink = (0, _general2.getConfig)(_redux_store2.default.getState()).AndroidAppDownloadLink;

        // redirect to the mobile landing page if the user hasn't seen it before
        if (iosDownloadLink && UserAgent.isIosWeb() && !_browser_store2.default.hasSeenLandingPage()) {
            _this2.props.history.push('/get_ios_app');
            _browser_store2.default.setLandingPageSeen(true);
        } else if (androidDownloadLink && UserAgent.isAndroidWeb() && !_browser_store2.default.hasSeenLandingPage()) {
            _this2.props.history.push('/get_android_app');
            _browser_store2.default.setLandingPageSeen(true);
        }
    };

    this.localizationChanged = function () {
        var locale = _localization_store2.default.getLocale();

        _client.Client4.setAcceptLanguage(locale);
        _this2.setState({ locale: locale, translations: _localization_store2.default.getTranslations() });
    };

    this.redirectIfNecessary = function (props) {
        if (props.location.pathname === '/') {
            if (_this2.props.noAccounts) {
                _this2.props.history.push('/signup_user_complete');
            } else if (_user_store2.default.getCurrentUser()) {
                GlobalActions.redirectUserToDefaultTeam();
            }
        }
    };
};

exports.default = Root;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return Object.getPrototypeOf;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1104)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( fnToString ) {
	"use strict";

	return fnToString.call( Object );
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(1005)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( cssExpand ) {
	"use strict";

	return new RegExp( cssExpand.join( "|" ), "i" );
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1586)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, Sizzle ) {

"use strict";

jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

// EXPOSE
var _sizzle = window.Sizzle;

Sizzle.noConflict = function() {
	if ( window.Sizzle === Sizzle ) {
		window.Sizzle = _sizzle;
	}

	return Sizzle;
};

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return Sizzle; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
// Sizzle requires that there be a global window in Common-JS like environments
} else if ( typeof module !== "undefined" && module.exports ) {
	module.exports = Sizzle;
} else {
	window.Sizzle = Sizzle;
}
// EXPOSE

})( window );


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

return function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";

return function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(897)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(875),
	__webpack_require__(920),
	__webpack_require__(844),
	__webpack_require__(1115)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access, camelCase, dataPriv, dataUser ) {

"use strict";

//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1010),
	__webpack_require__(1011) // Delay is optional because of this dependency
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};

return jQuery.fn.delay;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(844),
	__webpack_require__(1116)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, dataPriv, isHiddenWithinTree ) {

"use strict";

var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );

return showHide;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(812),
	__webpack_require__(874)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document, support ) {

"use strict";

( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();

return support;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(917)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1597),
	__webpack_require__(1124),
	__webpack_require__(1598),
	__webpack_require__(1599)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Return jQuery for attributes-only inclusion
return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(875),
	__webpack_require__(876),
	__webpack_require__(1012),
	__webpack_require__(859),
	__webpack_require__(815)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access, nodeName, support, rnothtmlwhite ) {

"use strict";

var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1013),
	__webpack_require__(807),
	__webpack_require__(859),
	__webpack_require__(844),
	__webpack_require__(834)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, stripAndCollapse, isFunction, rnothtmlwhite, dataPriv ) {

"use strict";

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1013),
	__webpack_require__(1012),
	__webpack_require__(876),
	__webpack_require__(807),

	__webpack_require__(834)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, stripAndCollapse, support, nodeName, isFunction ) {

"use strict";

var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(844),
	__webpack_require__(1601),

	__webpack_require__(899),
	__webpack_require__(1014)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, dataPriv, support ) {

"use strict";

// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(874)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( support ) {

"use strict";

support.focusin = "onfocusin" in window;

return support;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(900)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};

return jQuery._evalUrl;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	"use strict";

	return window.location;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};

return jQuery.parseXML;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(807),
	__webpack_require__(834),
	__webpack_require__(945), // clone
	__webpack_require__(898) // parent, contents
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, isFunction ) {

"use strict";

jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(815)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(874),
	__webpack_require__(900)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, support ) {

"use strict";

jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(812),
	__webpack_require__(900)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document ) {

"use strict";

// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(807),
	__webpack_require__(1126),
	__webpack_require__(1125),
	__webpack_require__(900)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, isFunction, nonce, rquery ) {

"use strict";

var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(1013),
	__webpack_require__(807),
	__webpack_require__(1611),
	__webpack_require__(900),
	__webpack_require__(898),
	__webpack_require__(945),
	__webpack_require__(815)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, stripAndCollapse, isFunction ) {

"use strict";

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(812),
	__webpack_require__(1110),
	__webpack_require__(1117),

	// This is the only module that needs core/support
	__webpack_require__(1612)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, document, rsingleTag, buildFragment, support ) {

"use strict";

// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};

return jQuery.parseHTML;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(812),
	__webpack_require__(874)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( document, support ) {

"use strict";

// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();

return support;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(899)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(815),
	__webpack_require__(1011)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(875),
	__webpack_require__(812),
	__webpack_require__(1007),
	__webpack_require__(807),
	__webpack_require__(1004),
	__webpack_require__(1107),
	__webpack_require__(1109),
	__webpack_require__(1006),
	__webpack_require__(919),
	__webpack_require__(834),
	__webpack_require__(917),
	__webpack_require__(815) // contains
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access, document, documentElement, isFunction, rnumnonpx,
             curCSS, addGetHookIf, support, isWindow ) {

"use strict";

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(875),
	__webpack_require__(919),
	__webpack_require__(917)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, access, isWindow ) {

"use strict";

// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );

return jQuery;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),
	__webpack_require__(876),
	__webpack_require__(920),
	__webpack_require__(896),
	__webpack_require__(807),
	__webpack_require__(919),
	__webpack_require__(944),

	__webpack_require__(1618)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, nodeName, camelCase, toType, isFunction, isWindow, slice ) {

"use strict";

jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776),

	__webpack_require__(899),
	__webpack_require__(1014)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery ) {

"use strict";

// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	__webpack_require__(776)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function( jQuery, noGlobal ) {

"use strict";

var

	// Map over jQuery in case of overwrite
	_jQuery = __webpack_provided_window_dot_jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && __webpack_provided_window_dot_jQuery === jQuery ) {
		__webpack_provided_window_dot_jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	__webpack_provided_window_dot_jQuery = window.$ = jQuery;
}

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1623), src$en$$ = __webpack_require__(1628);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(1129), src$es5$$ = __webpack_require__(1624), src$compiler$$ = __webpack_require__(1625), intl$messageformat$parser$$ = __webpack_require__(1626);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(1129);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1627)['default'];
exports['default'] = exports;


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = [],
        peg$c1 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements
                };
            },
        peg$c2 = peg$FAILED,
        peg$c3 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c4 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText
                };
            },
        peg$c5 = /^[^ \t\n\r,.+={}#]/,
        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c7 = "{",
        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c9 = null,
        peg$c10 = ",",
        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
        peg$c12 = "}",
        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c14 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2]
                };
            },
        peg$c15 = "number",
        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c17 = "date",
        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c19 = "time",
        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c21 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2]
                };
            },
        peg$c22 = "plural",
        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                };
            },
        peg$c25 = "selectordinal",
        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c27 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                }
            },
        peg$c28 = "select",
        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c30 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options
                };
            },
        peg$c31 = "=",
        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c33 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern
                };
            },
        peg$c34 = "offset:",
        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c36 = function(number) {
                return number;
            },
        peg$c37 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options
                };
            },
        peg$c38 = { type: "other", description: "whitespace" },
        peg$c39 = /^[ \t\n\r]/,
        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c41 = { type: "other", description: "optionalWhitespace" },
        peg$c42 = /^[0-9]/,
        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c44 = /^[0-9a-f]/i,
        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c46 = "0",
        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c48 = /^[1-9]/,
        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c50 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
        peg$c53 = "\\\\",
        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c55 = function() { return '\\'; },
        peg$c56 = "\\#",
        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c58 = function() { return '\\#'; },
        peg$c59 = "\\{",
        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c61 = function() { return '\u007B'; },
        peg$c62 = "\\}",
        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c64 = function() { return '\u007D'; },
        peg$c65 = "\\u",
        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c67 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c68 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$c2;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c2;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c2;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c5.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c5.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
          }
        } else {
          s1 = peg$c2;
        }
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c8); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c10;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c11); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$c2;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$c2;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$c2;
              }
              if (s5 === peg$FAILED) {
                s5 = peg$c9;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c12;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c14(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c15) {
        s1 = peg$c15;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c16); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c17) {
          s1 = peg$c17;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c18); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c20); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c10;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c2;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c2;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c2;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$c9;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c21(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c28) {
        s1 = peg$c28;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$c2;
              }
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c31;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$c2;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c7;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c12;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s0;
                      s1 = peg$c33(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c2;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c36(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = peg$c9;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$c2;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c37(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s0 = peg$c2;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c42.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c43); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c44.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c46;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
        if (s2 !== peg$FAILED) {
          s2 = input.substring(s1, peg$currPos);
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c50(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c51.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c53) {
          s1 = peg$c53;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c54); }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c55();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c56) {
            s1 = peg$c56;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c58();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c59) {
              s1 = peg$c59;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c60); }
            }
            if (s1 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c61();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c62) {
                s1 = peg$c62;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c63); }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c64();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c65) {
                  s1 = peg$c65;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$c2;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$c2;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$c2;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$c2;
                  }
                  if (s3 !== peg$FAILED) {
                    s3 = input.substring(s2, peg$currPos);
                  }
                  s2 = s3;
                  if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c67(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c68(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(1631)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1636);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1632), src$en$$ = __webpack_require__(1635);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(1128), src$diff$$ = __webpack_require__(1633), src$es5$$ = __webpack_require__(1634);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45,  // seconds to minute
        minute: 45,  // minutes to hour
        hour  : 22,  // hours to day
        day   : 26,  // days to month
        month : 11   // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;

    for (i = 0, l = FIELDS.length; i < l; i += 1) {
        units = FIELDS[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond: millisecond,
        second     : second,
        minute     : minute,
        hour       : hour,
        day        : day,
        week       : week,
        month      : month,
        year       : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1638)['default'];
exports['default'] = exports;


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var src$es5$$ = __webpack_require__(1639);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill

var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (true) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return FastClick;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Make a value ready for JSON.stringify() / process.send()
module.exports = function (value) {
	if (typeof value === 'object') {
		return destroyCircular(value, []);
	}

	// People sometimes throw things besides Error objects, so...

	if (typeof value === 'function') {
		// JSON.stringify discards functions. We do to, unless a function is thrown directly.
		return '[Function: ' + (value.name || 'anonymous') + ']';
	}

	return value;
};

// https://www.npmjs.com/package/destroy-circular
function destroyCircular(from, seen) {
	var to;
	if (Array.isArray(from)) {
		to = [];
	} else {
		to = {};
	}

	seen.push(from);

	Object.keys(from).forEach(function (key) {
		var value = from[key];

		if (typeof value === 'function') {
			return;
		}

		if (!value || typeof value !== 'object') {
			to[key] = value;
			return;
		}

		if (seen.indexOf(from[key]) === -1) {
			to[key] = destroyCircular(from[key], seen.slice(0));
			return;
		}

		to[key] = '[Circular]';
	});

	if (typeof from.name === 'string') {
		to.name = from.name;
	}

	if (typeof from.message === 'string') {
		to.message = from.message;
	}

	if (typeof from.stack === 'string') {
		to.stack = from.stack;
	}

	return to;
}


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(122);
__webpack_require__(90);
__webpack_require__(118);
__webpack_require__(1643);
__webpack_require__(1644);
__webpack_require__(1645);
__webpack_require__(1646);
module.exports = __webpack_require__(12).Map;


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(306);
var validate = __webpack_require__(187);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(307)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(16);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(308)('Map') });


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(309)('Map');


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(310)('Map');


/***/ }),
/* 1647 */
/***/ (function(module, exports) {

module.exports = [{"aliases":["grinning"],"filename":"1f600","category":"people","batch":"1"},{"aliases":["smiley"],"filename":"1f603","category":"people","batch":"1"},{"aliases":["smile"],"filename":"1f604","category":"people","batch":"1"},{"aliases":["grin"],"filename":"1f601","category":"people","batch":"1"},{"aliases":["laughing","satisfied"],"filename":"1f606","category":"people","batch":"1"},{"aliases":["sweat_smile"],"filename":"1f605","category":"people","batch":"1"},{"aliases":["joy"],"filename":"1f602","category":"people","batch":"1"},{"aliases":["rofl"],"filename":"1f923","category":"people","batch":"1"},{"aliases":["relaxed"],"filename":"263a-fe0f","category":"people","batch":"1"},{"aliases":["blush"],"filename":"1f60a","category":"people","batch":"1"},{"aliases":["innocent"],"filename":"1f607","category":"people","batch":"1"},{"aliases":["slightly_smiling_face"],"filename":"1f642","category":"people","batch":"1"},{"aliases":["upside_down_face"],"filename":"1f643","category":"people","batch":"1"},{"aliases":["wink"],"filename":"1f609","category":"people","batch":"1"},{"aliases":["relieved"],"filename":"1f60c","category":"people","batch":"1"},{"aliases":["heart_eyes"],"filename":"1f60d","category":"people","batch":"1"},{"aliases":["kissing_heart"],"filename":"1f618","category":"people","batch":"1"},{"aliases":["kissing"],"filename":"1f617","category":"people","batch":"1"},{"aliases":["kissing_smiling_eyes"],"filename":"1f619","category":"people","batch":"1"},{"aliases":["kissing_closed_eyes"],"filename":"1f61a","category":"people","batch":"1"},{"aliases":["yum"],"filename":"1f60b","category":"people","batch":"1"},{"aliases":["stuck_out_tongue_winking_eye"],"filename":"1f61c","category":"people","batch":"1"},{"aliases":["stuck_out_tongue_closed_eyes"],"filename":"1f61d","category":"people","batch":"1"},{"aliases":["stuck_out_tongue"],"filename":"1f61b","category":"people","batch":"1"},{"aliases":["money_mouth_face"],"filename":"1f911","category":"people","batch":"1"},{"aliases":["hugs"],"filename":"1f917","category":"people","batch":"1"},{"aliases":["nerd_face"],"filename":"1f913","category":"people","batch":"1"},{"aliases":["sunglasses"],"filename":"1f60e","category":"people","batch":"1"},{"aliases":["clown_face"],"filename":"1f921","category":"people","batch":"1"},{"aliases":["cowboy_hat_face"],"filename":"1f920","category":"people","batch":"1"},{"aliases":["smirk"],"filename":"1f60f","category":"people","batch":"1"},{"aliases":["unamused"],"filename":"1f612","category":"people","batch":"1"},{"aliases":["disappointed"],"filename":"1f61e","category":"people","batch":"1"},{"aliases":["pensive"],"filename":"1f614","category":"people","batch":"1"},{"aliases":["worried"],"filename":"1f61f","category":"people","batch":"1"},{"aliases":["confused"],"filename":"1f615","category":"people","batch":"1"},{"aliases":["slightly_frowning_face"],"filename":"1f641","category":"people","batch":"1"},{"aliases":["frowning_face"],"filename":"2639-fe0f","category":"people","batch":"1"},{"aliases":["persevere"],"filename":"1f623","category":"people","batch":"1"},{"aliases":["confounded"],"filename":"1f616","category":"people","batch":"1"},{"aliases":["tired_face"],"filename":"1f62b","category":"people","batch":"1"},{"aliases":["weary"],"filename":"1f629","category":"people","batch":"1"},{"aliases":["triumph"],"filename":"1f624","category":"people","batch":"1"},{"aliases":["angry"],"filename":"1f620","category":"people","batch":"1"},{"aliases":["rage","pout"],"filename":"1f621","category":"people","batch":"1"},{"aliases":["no_mouth"],"filename":"1f636","category":"people","batch":"2"},{"aliases":["neutral_face"],"filename":"1f610","category":"people","batch":"2"},{"aliases":["expressionless"],"filename":"1f611","category":"people","batch":"2"},{"aliases":["hushed"],"filename":"1f62f","category":"people","batch":"2"},{"aliases":["frowning"],"filename":"1f626","category":"people","batch":"2"},{"aliases":["anguished"],"filename":"1f627","category":"people","batch":"2"},{"aliases":["open_mouth"],"filename":"1f62e","category":"people","batch":"2"},{"aliases":["astonished"],"filename":"1f632","category":"people","batch":"2"},{"aliases":["dizzy_face"],"filename":"1f635","category":"people","batch":"2"},{"aliases":["flushed"],"filename":"1f633","category":"people","batch":"2"},{"aliases":["scream"],"filename":"1f631","category":"people","batch":"2"},{"aliases":["fearful"],"filename":"1f628","category":"people","batch":"2"},{"aliases":["cold_sweat"],"filename":"1f630","category":"people","batch":"2"},{"aliases":["cry"],"filename":"1f622","category":"people","batch":"2"},{"aliases":["disappointed_relieved"],"filename":"1f625","category":"people","batch":"2"},{"aliases":["drooling_face"],"filename":"1f924","category":"people","batch":"2"},{"aliases":["sob"],"filename":"1f62d","category":"people","batch":"2"},{"aliases":["sweat"],"filename":"1f613","category":"people","batch":"2"},{"aliases":["sleepy"],"filename":"1f62a","category":"people","batch":"2"},{"aliases":["sleeping"],"filename":"1f634","category":"people","batch":"2"},{"aliases":["roll_eyes"],"filename":"1f644","category":"people","batch":"2"},{"aliases":["thinking"],"filename":"1f914","category":"people","batch":"2"},{"aliases":["lying_face"],"filename":"1f925","category":"people","batch":"2"},{"aliases":["grimacing"],"filename":"1f62c","category":"people","batch":"2"},{"aliases":["zipper_mouth_face"],"filename":"1f910","category":"people","batch":"2"},{"aliases":["nauseated_face"],"filename":"1f922","category":"people","batch":"2"},{"aliases":["sneezing_face"],"filename":"1f927","category":"people","batch":"2"},{"aliases":["mask"],"filename":"1f637","category":"people","batch":"2"},{"aliases":["face_with_thermometer"],"filename":"1f912","category":"people","batch":"2"},{"aliases":["face_with_head_bandage"],"filename":"1f915","category":"people","batch":"2"},{"aliases":["smiling_imp"],"filename":"1f608","category":"people","batch":"2"},{"aliases":["imp"],"filename":"1f47f","category":"people","batch":"2"},{"aliases":["japanese_ogre"],"filename":"1f479","category":"people","batch":"2"},{"aliases":["japanese_goblin"],"filename":"1f47a","category":"people","batch":"2"},{"aliases":["hankey","poop","shit"],"filename":"1f4a9","category":"people","batch":"2"},{"aliases":["ghost"],"filename":"1f47b","category":"people","batch":"2"},{"aliases":["skull"],"filename":"1f480","category":"people","batch":"2"},{"aliases":["skull_and_crossbones"],"filename":"2620-fe0f","category":"people","batch":"2"},{"aliases":["alien"],"filename":"1f47d","category":"people","batch":"2"},{"aliases":["space_invader"],"filename":"1f47e","category":"people","batch":"2"},{"aliases":["robot"],"filename":"1f916","category":"people","batch":"2"},{"aliases":["jack_o_lantern"],"filename":"1f383","category":"people","batch":"2"},{"aliases":["smiley_cat"],"filename":"1f63a","category":"people","batch":"2"},{"aliases":["smile_cat"],"filename":"1f638","category":"people","batch":"2"},{"aliases":["joy_cat"],"filename":"1f639","category":"people","batch":"2"},{"aliases":["heart_eyes_cat"],"filename":"1f63b","category":"people","batch":"3"},{"aliases":["smirk_cat"],"filename":"1f63c","category":"people","batch":"3"},{"aliases":["kissing_cat"],"filename":"1f63d","category":"people","batch":"3"},{"aliases":["scream_cat"],"filename":"1f640","category":"people","batch":"3"},{"aliases":["crying_cat_face"],"filename":"1f63f","category":"people","batch":"3"},{"aliases":["pouting_cat"],"filename":"1f63e","category":"people","batch":"3"},{"aliases":["open_hands"],"filename":"1f450","category":"people","batch":"3"},{"aliases":["raised_hands"],"filename":"1f64c","category":"people","batch":"3"},{"aliases":["clap"],"filename":"1f44f","category":"people","batch":"3"},{"aliases":["pray"],"filename":"1f64f","category":"people","batch":"3"},{"aliases":["handshake"],"filename":"1f91d","category":"people","batch":"3"},{"aliases":["+1","thumbsup"],"filename":"1f44d","category":"people","batch":"3"},{"aliases":["-1","thumbsdown"],"filename":"1f44e","category":"people","batch":"3"},{"aliases":["fist_oncoming","facepunch","punch"],"filename":"1f44a","category":"people","batch":"3"},{"aliases":["fist_raised","fist"],"filename":"270a","category":"people","batch":"3"},{"aliases":["fist_left"],"filename":"1f91b","category":"people","batch":"3"},{"aliases":["fist_right"],"filename":"1f91c","category":"people","batch":"3"},{"aliases":["crossed_fingers"],"filename":"1f91e","category":"people","batch":"3"},{"aliases":["v"],"filename":"270c-fe0f","category":"people","batch":"3"},{"aliases":["metal"],"filename":"1f918","category":"people","batch":"3"},{"aliases":["ok_hand"],"filename":"1f44c","category":"people","batch":"3"},{"aliases":["point_left"],"filename":"1f448","category":"people","batch":"3"},{"aliases":["point_right"],"filename":"1f449","category":"people","batch":"3"},{"aliases":["point_up_2"],"filename":"1f446","category":"people","batch":"3"},{"aliases":["point_down"],"filename":"1f447","category":"people","batch":"3"},{"aliases":["point_up"],"filename":"261d-fe0f","category":"people","batch":"3"},{"aliases":["hand","raised_hand"],"filename":"270b","category":"people","batch":"3"},{"aliases":["raised_back_of_hand"],"filename":"1f91a","category":"people","batch":"3"},{"aliases":["raised_hand_with_fingers_splayed"],"filename":"1f590","category":"people","batch":"3"},{"aliases":["vulcan_salute"],"filename":"1f596","category":"people","batch":"3"},{"aliases":["wave"],"filename":"1f44b","category":"people","batch":"3"},{"aliases":["call_me_hand"],"filename":"1f919","category":"people","batch":"3"},{"aliases":["muscle"],"filename":"1f4aa","category":"people","batch":"3"},{"aliases":["middle_finger","fu"],"filename":"1f595","category":"people","batch":"3"},{"aliases":["writing_hand"],"filename":"270d-fe0f","category":"people","batch":"3"},{"aliases":["selfie"],"filename":"1f933","category":"people","batch":"3"},{"aliases":["nail_care"],"filename":"1f485","category":"people","batch":"3"},{"aliases":["ring"],"filename":"1f48d","category":"people","batch":"3"},{"aliases":["lipstick"],"filename":"1f484","category":"people","batch":"3"},{"aliases":["kiss"],"filename":"1f48b","category":"people","batch":"3"},{"aliases":["lips"],"filename":"1f444","category":"people","batch":"3"},{"aliases":["tongue"],"filename":"1f445","category":"people","batch":"3"},{"aliases":["ear"],"filename":"1f442","category":"people","batch":"3"},{"aliases":["nose"],"filename":"1f443","category":"people","batch":"3"},{"aliases":["footprints"],"filename":"1f463","category":"people","batch":"3"},{"aliases":["eye"],"filename":"1f441","category":"people","batch":"4"},{"aliases":["eyes"],"filename":"1f440","category":"people","batch":"4"},{"aliases":["speaking_head"],"filename":"1f5e3","category":"people","batch":"4"},{"aliases":["bust_in_silhouette"],"filename":"1f464","category":"people","batch":"4"},{"aliases":["busts_in_silhouette"],"filename":"1f465","category":"people","batch":"4"},{"aliases":["baby"],"filename":"1f476","category":"people","batch":"4"},{"aliases":["boy"],"filename":"1f466","category":"people","batch":"4"},{"aliases":["girl"],"filename":"1f467","category":"people","batch":"4"},{"aliases":["man"],"filename":"1f468","category":"people","batch":"4"},{"aliases":["woman"],"filename":"1f469","category":"people","batch":"4"},{"aliases":["blonde_woman"],"filename":"1f471-200d-2640-fe0f","category":"people","batch":"4"},{"aliases":["blonde_man","person_with_blond_hair"],"filename":"1f471","category":"people","batch":"4"},{"aliases":["older_man"],"filename":"1f474","category":"people","batch":"4"},{"aliases":["older_woman"],"filename":"1f475","category":"people","batch":"4"},{"aliases":["man_with_gua_pi_mao"],"filename":"1f472","category":"people","batch":"4"},{"aliases":["woman_with_turban"],"filename":"1f473-200d-2640-fe0f","category":"people","batch":"4"},{"aliases":["man_with_turban"],"filename":"1f473","category":"people","batch":"4"},{"aliases":["policewoman"],"filename":"1f46e-200d-2640-fe0f","category":"people","batch":"4"},{"aliases":["policeman","cop"],"filename":"1f46e","category":"people","batch":"4"},{"aliases":["construction_worker_woman"],"filename":"1f477-200d-2640-fe0f","category":"people","batch":"4"},{"aliases":["construction_worker_man","construction_worker"],"filename":"1f477","category":"people","batch":"4"},{"aliases":["guardswoman"],"filename":"1f482-200d-2640-fe0f","category":"people","batch":"4"},{"aliases":["guardsman"],"filename":"1f482","category":"people","batch":"4"},{"aliases":["female_detective"],"filename":"1f575-fe0f-200d-2640-fe0f","category":"people","batch":"4"},{"aliases":["male_detective","detective"],"filename":"1f575-fe0f","category":"people","batch":"4"},{"aliases":["woman_health_worker"],"filename":"1f469-200d-2695-fe0f","category":"people","batch":"4"},{"aliases":["man_health_worker"],"filename":"1f468-200d-2695-fe0f","category":"people","batch":"4"},{"aliases":["woman_farmer"],"filename":"1f469-200d-1f33e","category":"people","batch":"4"},{"aliases":["man_farmer"],"filename":"1f468-200d-1f33e","category":"people","batch":"4"},{"aliases":["woman_cook"],"filename":"1f469-200d-1f373","category":"people","batch":"4"},{"aliases":["man_cook"],"filename":"1f468-200d-1f373","category":"people","batch":"4"},{"aliases":["woman_student"],"filename":"1f469-200d-1f393","category":"people","batch":"4"},{"aliases":["man_student"],"filename":"1f468-200d-1f393","category":"people","batch":"4"},{"aliases":["woman_singer"],"filename":"1f469-200d-1f3a4","category":"people","batch":"4"},{"aliases":["man_singer"],"filename":"1f468-200d-1f3a4","category":"people","batch":"4"},{"aliases":["woman_teacher"],"filename":"1f469-200d-1f3eb","category":"people","batch":"4"},{"aliases":["man_teacher"],"filename":"1f468-200d-1f3eb","category":"people","batch":"4"},{"aliases":["woman_factory_worker"],"filename":"1f469-200d-1f3ed","category":"people","batch":"4"},{"aliases":["man_factory_worker"],"filename":"1f468-200d-1f3ed","category":"people","batch":"4"},{"aliases":["woman_technologist"],"filename":"1f469-200d-1f4bb","category":"people","batch":"4"},{"aliases":["man_technologist"],"filename":"1f468-200d-1f4bb","category":"people","batch":"4"},{"aliases":["woman_office_worker"],"filename":"1f469-200d-1f4bc","category":"people","batch":"4"},{"aliases":["man_office_worker"],"filename":"1f468-200d-1f4bc","category":"people","batch":"4"},{"aliases":["woman_mechanic"],"filename":"1f469-200d-1f527","category":"people","batch":"4"},{"aliases":["man_mechanic"],"filename":"1f468-200d-1f527","category":"people","batch":"4"},{"aliases":["woman_scientist"],"filename":"1f469-200d-1f52c","category":"people","batch":"5"},{"aliases":["man_scientist"],"filename":"1f468-200d-1f52c","category":"people","batch":"5"},{"aliases":["woman_artist"],"filename":"1f469-200d-1f3a8","category":"people","batch":"5"},{"aliases":["man_artist"],"filename":"1f468-200d-1f3a8","category":"people","batch":"5"},{"aliases":["woman_firefighter"],"filename":"1f469-200d-1f692","category":"people","batch":"5"},{"aliases":["man_firefighter"],"filename":"1f468-200d-1f692","category":"people","batch":"5"},{"aliases":["woman_pilot"],"filename":"1f469-200d-2708-fe0f","category":"people","batch":"5"},{"aliases":["man_pilot"],"filename":"1f468-200d-2708-fe0f","category":"people","batch":"5"},{"aliases":["woman_astronaut"],"filename":"1f469-200d-1f680","category":"people","batch":"5"},{"aliases":["man_astronaut"],"filename":"1f468-200d-1f680","category":"people","batch":"5"},{"aliases":["woman_judge"],"filename":"1f469-200d-2696-fe0f","category":"people","batch":"5"},{"aliases":["man_judge"],"filename":"1f468-200d-2696-fe0f","category":"people","batch":"5"},{"aliases":["mrs_claus"],"filename":"1f936","category":"people","batch":"5"},{"aliases":["santa"],"filename":"1f385","category":"people","batch":"5"},{"aliases":["princess"],"filename":"1f478","category":"people","batch":"5"},{"aliases":["prince"],"filename":"1f934","category":"people","batch":"5"},{"aliases":["bride_with_veil"],"filename":"1f470","category":"people","batch":"5"},{"aliases":["man_in_tuxedo"],"filename":"1f935","category":"people","batch":"5"},{"aliases":["angel"],"filename":"1f47c","category":"people","batch":"5"},{"aliases":["pregnant_woman"],"filename":"1f930","category":"people","batch":"5"},{"aliases":["bowing_woman"],"filename":"1f647-200d-2640-fe0f","category":"people","batch":"5"},{"aliases":["bowing_man","bow"],"filename":"1f647","category":"people","batch":"5"},{"aliases":["tipping_hand_woman","information_desk_person"],"filename":"1f481","category":"people","batch":"5"},{"aliases":["tipping_hand_man"],"filename":"1f481-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["no_good_woman","no_good","ng_woman"],"filename":"1f645","category":"people","batch":"5"},{"aliases":["no_good_man","ng_man"],"filename":"1f645-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["ok_woman"],"filename":"1f646","category":"people","batch":"5"},{"aliases":["ok_man"],"filename":"1f646-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["raising_hand_woman","raising_hand"],"filename":"1f64b","category":"people","batch":"5"},{"aliases":["raising_hand_man"],"filename":"1f64b-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["woman_facepalming"],"filename":"1f926-200d-2640-fe0f","category":"people","batch":"5"},{"aliases":["man_facepalming"],"filename":"1f926-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["woman_shrugging"],"filename":"1f937-200d-2640-fe0f","category":"people","batch":"5"},{"aliases":["man_shrugging"],"filename":"1f937-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["pouting_woman","person_with_pouting_face"],"filename":"1f64e","category":"people","batch":"5"},{"aliases":["pouting_man"],"filename":"1f64e-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["frowning_woman","person_frowning"],"filename":"1f64d","category":"people","batch":"5"},{"aliases":["frowning_man"],"filename":"1f64d-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["haircut_woman","haircut"],"filename":"1f487","category":"people","batch":"5"},{"aliases":["haircut_man"],"filename":"1f487-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["massage_woman","massage"],"filename":"1f486","category":"people","batch":"5"},{"aliases":["massage_man"],"filename":"1f486-200d-2642-fe0f","category":"people","batch":"5"},{"aliases":["business_suit_levitating"],"filename":"1f574","category":"people","batch":"5"},{"aliases":["dancer"],"filename":"1f483","category":"people","batch":"5"},{"aliases":["man_dancing"],"filename":"1f57a","category":"people","batch":"5"},{"aliases":["dancing_women","dancers"],"filename":"1f46f","category":"people","batch":"6"},{"aliases":["dancing_men"],"filename":"1f46f-200d-2642-fe0f","category":"people","batch":"6"},{"aliases":["walking_woman"],"filename":"1f6b6-200d-2640-fe0f","category":"people","batch":"6"},{"aliases":["walking_man","walking"],"filename":"1f6b6","category":"people","batch":"6"},{"aliases":["running_woman"],"filename":"1f3c3-200d-2640-fe0f","category":"people","batch":"6"},{"aliases":["running_man","runner","running"],"filename":"1f3c3","category":"people","batch":"6"},{"aliases":["couple"],"filename":"1f46b","category":"people","batch":"6"},{"aliases":["two_women_holding_hands"],"filename":"1f46d","category":"people","batch":"6"},{"aliases":["two_men_holding_hands"],"filename":"1f46c","category":"people","batch":"6"},{"aliases":["couple_with_heart_woman_man","couple_with_heart"],"filename":"1f491","category":"people","batch":"6"},{"aliases":["couple_with_heart_woman_woman"],"filename":"1f469-200d-2764-fe0f-200d-1f469","category":"people","batch":"6"},{"aliases":["couple_with_heart_man_man"],"filename":"1f468-200d-2764-fe0f-200d-1f468","category":"people","batch":"6"},{"aliases":["couplekiss_man_woman"],"filename":"1f48f","category":"people","batch":"6"},{"aliases":["couplekiss_woman_woman"],"filename":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","category":"people","batch":"6"},{"aliases":["couplekiss_man_man"],"filename":"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","category":"people","batch":"6"},{"aliases":["family_man_woman_boy","family"],"filename":"1f46a","category":"people","batch":"6"},{"aliases":["family_man_woman_girl"],"filename":"1f468-200d-1f469-200d-1f467","category":"people","batch":"6"},{"aliases":["family_man_woman_girl_boy"],"filename":"1f468-200d-1f469-200d-1f467-200d-1f466","category":"people","batch":"6"},{"aliases":["family_man_woman_boy_boy"],"filename":"1f468-200d-1f469-200d-1f466-200d-1f466","category":"people","batch":"6"},{"aliases":["family_man_woman_girl_girl"],"filename":"1f468-200d-1f469-200d-1f467-200d-1f467","category":"people","batch":"6"},{"aliases":["family_woman_woman_boy"],"filename":"1f469-200d-1f469-200d-1f466","category":"people","batch":"6"},{"aliases":["family_woman_woman_girl"],"filename":"1f469-200d-1f469-200d-1f467","category":"people","batch":"6"},{"aliases":["family_woman_woman_girl_boy"],"filename":"1f469-200d-1f469-200d-1f467-200d-1f466","category":"people","batch":"6"},{"aliases":["family_woman_woman_boy_boy"],"filename":"1f469-200d-1f469-200d-1f466-200d-1f466","category":"people","batch":"6"},{"aliases":["family_woman_woman_girl_girl"],"filename":"1f469-200d-1f469-200d-1f467-200d-1f467","category":"people","batch":"6"},{"aliases":["family_man_man_boy"],"filename":"1f468-200d-1f468-200d-1f466","category":"people","batch":"6"},{"aliases":["family_man_man_girl"],"filename":"1f468-200d-1f468-200d-1f467","category":"people","batch":"6"},{"aliases":["family_man_man_girl_boy"],"filename":"1f468-200d-1f468-200d-1f467-200d-1f466","category":"people","batch":"6"},{"aliases":["family_man_man_boy_boy"],"filename":"1f468-200d-1f468-200d-1f466-200d-1f466","category":"people","batch":"6"},{"aliases":["family_man_man_girl_girl"],"filename":"1f468-200d-1f468-200d-1f467-200d-1f467","category":"people","batch":"6"},{"aliases":["family_woman_boy"],"filename":"1f469-200d-1f466","category":"people","batch":"6"},{"aliases":["family_woman_girl"],"filename":"1f469-200d-1f467","category":"people","batch":"6"},{"aliases":["family_woman_girl_boy"],"filename":"1f469-200d-1f467-200d-1f466","category":"people","batch":"6"},{"aliases":["family_woman_boy_boy"],"filename":"1f469-200d-1f466-200d-1f466","category":"people","batch":"6"},{"aliases":["family_woman_girl_girl"],"filename":"1f469-200d-1f467-200d-1f467","category":"people","batch":"6"},{"aliases":["family_man_boy"],"filename":"1f468-200d-1f466","category":"people","batch":"6"},{"aliases":["family_man_girl"],"filename":"1f468-200d-1f467","category":"people","batch":"6"},{"aliases":["family_man_girl_boy"],"filename":"1f468-200d-1f467-200d-1f466","category":"people","batch":"6"},{"aliases":["family_man_boy_boy"],"filename":"1f468-200d-1f466-200d-1f466","category":"people","batch":"6"},{"aliases":["family_man_girl_girl"],"filename":"1f468-200d-1f467-200d-1f467","category":"people","batch":"6"},{"aliases":["womans_clothes"],"filename":"1f45a","category":"people","batch":"6"},{"aliases":["shirt","tshirt"],"filename":"1f455","category":"people","batch":"6"},{"aliases":["jeans"],"filename":"1f456","category":"people","batch":"6"},{"aliases":["necktie"],"filename":"1f454","category":"people","batch":"6"},{"aliases":["dress"],"filename":"1f457","category":"people","batch":"6"},{"aliases":["bikini"],"filename":"1f459","category":"people","batch":"7"},{"aliases":["kimono"],"filename":"1f458","category":"people","batch":"7"},{"aliases":["high_heel"],"filename":"1f460","category":"people","batch":"7"},{"aliases":["sandal"],"filename":"1f461","category":"people","batch":"7"},{"aliases":["boot"],"filename":"1f462","category":"people","batch":"7"},{"aliases":["mans_shoe","shoe"],"filename":"1f45e","category":"people","batch":"7"},{"aliases":["athletic_shoe"],"filename":"1f45f","category":"people","batch":"7"},{"aliases":["womans_hat"],"filename":"1f452","category":"people","batch":"7"},{"aliases":["tophat"],"filename":"1f3a9","category":"people","batch":"7"},{"aliases":["mortar_board"],"filename":"1f393","category":"people","batch":"7"},{"aliases":["crown"],"filename":"1f451","category":"people","batch":"7"},{"aliases":["rescue_worker_helmet"],"filename":"26d1","category":"people","batch":"7"},{"aliases":["school_satchel"],"filename":"1f392","category":"people","batch":"7"},{"aliases":["pouch"],"filename":"1f45d","category":"people","batch":"7"},{"aliases":["purse"],"filename":"1f45b","category":"people","batch":"7"},{"aliases":["handbag"],"filename":"1f45c","category":"people","batch":"7"},{"aliases":["briefcase"],"filename":"1f4bc","category":"people","batch":"7"},{"aliases":["eyeglasses"],"filename":"1f453","category":"people","batch":"7"},{"aliases":["dark_sunglasses"],"filename":"1f576","category":"people","batch":"7"},{"aliases":["closed_umbrella"],"filename":"1f302","category":"people","batch":"7"},{"aliases":["open_umbrella"],"filename":"2602-fe0f","category":"people","batch":"7"},{"aliases":["dog"],"filename":"1f436","category":"nature","batch":"1"},{"aliases":["cat"],"filename":"1f431","category":"nature","batch":"1"},{"aliases":["mouse"],"filename":"1f42d","category":"nature","batch":"1"},{"aliases":["hamster"],"filename":"1f439","category":"nature","batch":"1"},{"aliases":["rabbit"],"filename":"1f430","category":"nature","batch":"1"},{"aliases":["fox_face"],"filename":"1f98a","category":"nature","batch":"1"},{"aliases":["bear"],"filename":"1f43b","category":"nature","batch":"1"},{"aliases":["panda_face"],"filename":"1f43c","category":"nature","batch":"1"},{"aliases":["koala"],"filename":"1f428","category":"nature","batch":"1"},{"aliases":["tiger"],"filename":"1f42f","category":"nature","batch":"1"},{"aliases":["lion"],"filename":"1f981","category":"nature","batch":"1"},{"aliases":["cow"],"filename":"1f42e","category":"nature","batch":"1"},{"aliases":["pig"],"filename":"1f437","category":"nature","batch":"1"},{"aliases":["pig_nose"],"filename":"1f43d","category":"nature","batch":"1"},{"aliases":["frog"],"filename":"1f438","category":"nature","batch":"1"},{"aliases":["monkey_face"],"filename":"1f435","category":"nature","batch":"1"},{"aliases":["see_no_evil"],"filename":"1f648","category":"nature","batch":"1"},{"aliases":["hear_no_evil"],"filename":"1f649","category":"nature","batch":"1"},{"aliases":["speak_no_evil"],"filename":"1f64a","category":"nature","batch":"1"},{"aliases":["monkey"],"filename":"1f412","category":"nature","batch":"1"},{"aliases":["chicken"],"filename":"1f414","category":"nature","batch":"1"},{"aliases":["penguin"],"filename":"1f427","category":"nature","batch":"1"},{"aliases":["bird"],"filename":"1f426","category":"nature","batch":"1"},{"aliases":["baby_chick"],"filename":"1f424","category":"nature","batch":"1"},{"aliases":["hatching_chick"],"filename":"1f423","category":"nature","batch":"1"},{"aliases":["hatched_chick"],"filename":"1f425","category":"nature","batch":"1"},{"aliases":["duck"],"filename":"1f986","category":"nature","batch":"1"},{"aliases":["eagle"],"filename":"1f985","category":"nature","batch":"1"},{"aliases":["owl"],"filename":"1f989","category":"nature","batch":"1"},{"aliases":["bat"],"filename":"1f987","category":"nature","batch":"1"},{"aliases":["wolf"],"filename":"1f43a","category":"nature","batch":"1"},{"aliases":["boar"],"filename":"1f417","category":"nature","batch":"1"},{"aliases":["horse"],"filename":"1f434","category":"nature","batch":"1"},{"aliases":["unicorn"],"filename":"1f984","category":"nature","batch":"1"},{"aliases":["bee","honeybee"],"filename":"1f41d","category":"nature","batch":"1"},{"aliases":["bug"],"filename":"1f41b","category":"nature","batch":"1"},{"aliases":["butterfly"],"filename":"1f98b","category":"nature","batch":"1"},{"aliases":["snail"],"filename":"1f40c","category":"nature","batch":"1"},{"aliases":["shell"],"filename":"1f41a","category":"nature","batch":"1"},{"aliases":["beetle"],"filename":"1f41e","category":"nature","batch":"1"},{"aliases":["ant"],"filename":"1f41c","category":"nature","batch":"1"},{"aliases":["spider"],"filename":"1f577","category":"nature","batch":"1"},{"aliases":["spider_web"],"filename":"1f578","category":"nature","batch":"1"},{"aliases":["turtle"],"filename":"1f422","category":"nature","batch":"1"},{"aliases":["snake"],"filename":"1f40d","category":"nature","batch":"1"},{"aliases":["lizard"],"filename":"1f98e","category":"nature","batch":"2"},{"aliases":["scorpion"],"filename":"1f982","category":"nature","batch":"2"},{"aliases":["crab"],"filename":"1f980","category":"nature","batch":"2"},{"aliases":["squid"],"filename":"1f991","category":"nature","batch":"2"},{"aliases":["octopus"],"filename":"1f419","category":"nature","batch":"2"},{"aliases":["shrimp"],"filename":"1f990","category":"nature","batch":"2"},{"aliases":["tropical_fish"],"filename":"1f420","category":"nature","batch":"2"},{"aliases":["fish"],"filename":"1f41f","category":"nature","batch":"2"},{"aliases":["blowfish"],"filename":"1f421","category":"nature","batch":"2"},{"aliases":["dolphin","flipper"],"filename":"1f42c","category":"nature","batch":"2"},{"aliases":["shark"],"filename":"1f988","category":"nature","batch":"2"},{"aliases":["whale"],"filename":"1f433","category":"nature","batch":"2"},{"aliases":["whale2"],"filename":"1f40b","category":"nature","batch":"2"},{"aliases":["crocodile"],"filename":"1f40a","category":"nature","batch":"2"},{"aliases":["leopard"],"filename":"1f406","category":"nature","batch":"2"},{"aliases":["tiger2"],"filename":"1f405","category":"nature","batch":"2"},{"aliases":["water_buffalo"],"filename":"1f403","category":"nature","batch":"2"},{"aliases":["ox"],"filename":"1f402","category":"nature","batch":"2"},{"aliases":["cow2"],"filename":"1f404","category":"nature","batch":"2"},{"aliases":["deer"],"filename":"1f98c","category":"nature","batch":"2"},{"aliases":["dromedary_camel"],"filename":"1f42a","category":"nature","batch":"2"},{"aliases":["camel"],"filename":"1f42b","category":"nature","batch":"2"},{"aliases":["elephant"],"filename":"1f418","category":"nature","batch":"2"},{"aliases":["rhinoceros"],"filename":"1f98f","category":"nature","batch":"2"},{"aliases":["gorilla"],"filename":"1f98d","category":"nature","batch":"2"},{"aliases":["racehorse"],"filename":"1f40e","category":"nature","batch":"2"},{"aliases":["pig2"],"filename":"1f416","category":"nature","batch":"2"},{"aliases":["goat"],"filename":"1f410","category":"nature","batch":"2"},{"aliases":["ram"],"filename":"1f40f","category":"nature","batch":"2"},{"aliases":["sheep"],"filename":"1f411","category":"nature","batch":"2"},{"aliases":["dog2"],"filename":"1f415","category":"nature","batch":"2"},{"aliases":["poodle"],"filename":"1f429","category":"nature","batch":"2"},{"aliases":["cat2"],"filename":"1f408","category":"nature","batch":"2"},{"aliases":["rooster"],"filename":"1f413","category":"nature","batch":"2"},{"aliases":["turkey"],"filename":"1f983","category":"nature","batch":"2"},{"aliases":["dove"],"filename":"1f54a","category":"nature","batch":"2"},{"aliases":["rabbit2"],"filename":"1f407","category":"nature","batch":"2"},{"aliases":["mouse2"],"filename":"1f401","category":"nature","batch":"2"},{"aliases":["rat"],"filename":"1f400","category":"nature","batch":"2"},{"aliases":["chipmunk"],"filename":"1f43f","category":"nature","batch":"2"},{"aliases":["feet","paw_prints"],"filename":"1f43e","category":"nature","batch":"2"},{"aliases":["dragon"],"filename":"1f409","category":"nature","batch":"2"},{"aliases":["dragon_face"],"filename":"1f432","category":"nature","batch":"2"},{"aliases":["cactus"],"filename":"1f335","category":"nature","batch":"2"},{"aliases":["christmas_tree"],"filename":"1f384","category":"nature","batch":"2"},{"aliases":["evergreen_tree"],"filename":"1f332","category":"nature","batch":"3"},{"aliases":["deciduous_tree"],"filename":"1f333","category":"nature","batch":"3"},{"aliases":["palm_tree"],"filename":"1f334","category":"nature","batch":"3"},{"aliases":["seedling"],"filename":"1f331","category":"nature","batch":"3"},{"aliases":["herb"],"filename":"1f33f","category":"nature","batch":"3"},{"aliases":["shamrock"],"filename":"2618-fe0f","category":"nature","batch":"3"},{"aliases":["four_leaf_clover"],"filename":"1f340","category":"nature","batch":"3"},{"aliases":["bamboo"],"filename":"1f38d","category":"nature","batch":"3"},{"aliases":["tanabata_tree"],"filename":"1f38b","category":"nature","batch":"3"},{"aliases":["leaves"],"filename":"1f343","category":"nature","batch":"3"},{"aliases":["fallen_leaf"],"filename":"1f342","category":"nature","batch":"3"},{"aliases":["maple_leaf"],"filename":"1f341","category":"nature","batch":"3"},{"aliases":["mushroom"],"filename":"1f344","category":"nature","batch":"3"},{"aliases":["ear_of_rice"],"filename":"1f33e","category":"nature","batch":"3"},{"aliases":["bouquet"],"filename":"1f490","category":"nature","batch":"3"},{"aliases":["tulip"],"filename":"1f337","category":"nature","batch":"3"},{"aliases":["rose"],"filename":"1f339","category":"nature","batch":"3"},{"aliases":["wilted_flower"],"filename":"1f940","category":"nature","batch":"3"},{"aliases":["sunflower"],"filename":"1f33b","category":"nature","batch":"3"},{"aliases":["blossom"],"filename":"1f33c","category":"nature","batch":"3"},{"aliases":["cherry_blossom"],"filename":"1f338","category":"nature","batch":"3"},{"aliases":["hibiscus"],"filename":"1f33a","category":"nature","batch":"3"},{"aliases":["earth_americas"],"filename":"1f30e","category":"nature","batch":"3"},{"aliases":["earth_africa"],"filename":"1f30d","category":"nature","batch":"3"},{"aliases":["earth_asia"],"filename":"1f30f","category":"nature","batch":"3"},{"aliases":["full_moon"],"filename":"1f315","category":"nature","batch":"3"},{"aliases":["waning_gibbous_moon"],"filename":"1f316","category":"nature","batch":"3"},{"aliases":["last_quarter_moon"],"filename":"1f317","category":"nature","batch":"3"},{"aliases":["waning_crescent_moon"],"filename":"1f318","category":"nature","batch":"3"},{"aliases":["new_moon"],"filename":"1f311","category":"nature","batch":"3"},{"aliases":["waxing_crescent_moon"],"filename":"1f312","category":"nature","batch":"3"},{"aliases":["first_quarter_moon"],"filename":"1f313","category":"nature","batch":"3"},{"aliases":["moon","waxing_gibbous_moon"],"filename":"1f314","category":"nature","batch":"3"},{"aliases":["new_moon_with_face"],"filename":"1f31a","category":"nature","batch":"3"},{"aliases":["full_moon_with_face"],"filename":"1f31d","category":"nature","batch":"3"},{"aliases":["sun_with_face"],"filename":"1f31e","category":"nature","batch":"3"},{"aliases":["first_quarter_moon_with_face"],"filename":"1f31b","category":"nature","batch":"3"},{"aliases":["last_quarter_moon_with_face"],"filename":"1f31c","category":"nature","batch":"3"},{"aliases":["crescent_moon"],"filename":"1f319","category":"nature","batch":"3"},{"aliases":["dizzy"],"filename":"1f4ab","category":"nature","batch":"3"},{"aliases":["star"],"filename":"2b50-fe0f","category":"nature","batch":"3"},{"aliases":["star2"],"filename":"1f31f","category":"nature","batch":"3"},{"aliases":["sparkles"],"filename":"2728","category":"nature","batch":"3"},{"aliases":["zap"],"filename":"26a1-fe0f","category":"nature","batch":"3"},{"aliases":["fire"],"filename":"1f525","category":"nature","batch":"3"},{"aliases":["boom","collision"],"filename":"1f4a5","category":"nature","batch":"4"},{"aliases":["comet"],"filename":"2604-fe0f","category":"nature","batch":"4"},{"aliases":["sunny"],"filename":"2600-fe0f","category":"nature","batch":"4"},{"aliases":["sun_behind_small_cloud"],"filename":"1f324","category":"nature","batch":"4"},{"aliases":["partly_sunny"],"filename":"26c5-fe0f","category":"nature","batch":"4"},{"aliases":["sun_behind_large_cloud"],"filename":"1f325","category":"nature","batch":"4"},{"aliases":["sun_behind_rain_cloud"],"filename":"1f326","category":"nature","batch":"4"},{"aliases":["rainbow"],"filename":"1f308","category":"nature","batch":"4"},{"aliases":["cloud"],"filename":"2601-fe0f","category":"nature","batch":"4"},{"aliases":["cloud_with_rain"],"filename":"1f327","category":"nature","batch":"4"},{"aliases":["cloud_with_lightning_and_rain"],"filename":"26c8","category":"nature","batch":"4"},{"aliases":["cloud_with_lightning"],"filename":"1f329","category":"nature","batch":"4"},{"aliases":["cloud_with_snow"],"filename":"1f328","category":"nature","batch":"4"},{"aliases":["snowman_with_snow"],"filename":"2603-fe0f","category":"nature","batch":"4"},{"aliases":["snowman"],"filename":"26c4-fe0f","category":"nature","batch":"4"},{"aliases":["snowflake"],"filename":"2744-fe0f","category":"nature","batch":"4"},{"aliases":["wind_face"],"filename":"1f32c","category":"nature","batch":"4"},{"aliases":["dash"],"filename":"1f4a8","category":"nature","batch":"4"},{"aliases":["tornado"],"filename":"1f32a","category":"nature","batch":"4"},{"aliases":["fog"],"filename":"1f32b","category":"nature","batch":"4"},{"aliases":["ocean"],"filename":"1f30a","category":"nature","batch":"4"},{"aliases":["droplet"],"filename":"1f4a7","category":"nature","batch":"4"},{"aliases":["sweat_drops"],"filename":"1f4a6","category":"nature","batch":"4"},{"aliases":["umbrella"],"filename":"2614-fe0f","category":"nature","batch":"4"},{"aliases":["green_apple"],"filename":"1f34f","category":"foods","batch":"1"},{"aliases":["apple"],"filename":"1f34e","category":"foods","batch":"1"},{"aliases":["pear"],"filename":"1f350","category":"foods","batch":"1"},{"aliases":["tangerine","orange","mandarin"],"filename":"1f34a","category":"foods","batch":"1"},{"aliases":["lemon"],"filename":"1f34b","category":"foods","batch":"1"},{"aliases":["banana"],"filename":"1f34c","category":"foods","batch":"1"},{"aliases":["watermelon"],"filename":"1f349","category":"foods","batch":"1"},{"aliases":["grapes"],"filename":"1f347","category":"foods","batch":"1"},{"aliases":["strawberry"],"filename":"1f353","category":"foods","batch":"1"},{"aliases":["melon"],"filename":"1f348","category":"foods","batch":"1"},{"aliases":["cherries"],"filename":"1f352","category":"foods","batch":"1"},{"aliases":["peach"],"filename":"1f351","category":"foods","batch":"1"},{"aliases":["pineapple"],"filename":"1f34d","category":"foods","batch":"1"},{"aliases":["kiwi_fruit"],"filename":"1f95d","category":"foods","batch":"1"},{"aliases":["avocado"],"filename":"1f951","category":"foods","batch":"1"},{"aliases":["tomato"],"filename":"1f345","category":"foods","batch":"1"},{"aliases":["eggplant"],"filename":"1f346","category":"foods","batch":"1"},{"aliases":["cucumber"],"filename":"1f952","category":"foods","batch":"1"},{"aliases":["carrot"],"filename":"1f955","category":"foods","batch":"1"},{"aliases":["corn"],"filename":"1f33d","category":"foods","batch":"1"},{"aliases":["hot_pepper"],"filename":"1f336","category":"foods","batch":"1"},{"aliases":["potato"],"filename":"1f954","category":"foods","batch":"1"},{"aliases":["sweet_potato"],"filename":"1f360","category":"foods","batch":"1"},{"aliases":["chestnut"],"filename":"1f330","category":"foods","batch":"1"},{"aliases":["peanuts"],"filename":"1f95c","category":"foods","batch":"1"},{"aliases":["honey_pot"],"filename":"1f36f","category":"foods","batch":"1"},{"aliases":["croissant"],"filename":"1f950","category":"foods","batch":"1"},{"aliases":["bread"],"filename":"1f35e","category":"foods","batch":"1"},{"aliases":["baguette_bread"],"filename":"1f956","category":"foods","batch":"1"},{"aliases":["cheese"],"filename":"1f9c0","category":"foods","batch":"1"},{"aliases":["egg"],"filename":"1f95a","category":"foods","batch":"1"},{"aliases":["fried_egg"],"filename":"1f373","category":"foods","batch":"1"},{"aliases":["bacon"],"filename":"1f953","category":"foods","batch":"1"},{"aliases":["pancakes"],"filename":"1f95e","category":"foods","batch":"1"},{"aliases":["fried_shrimp"],"filename":"1f364","category":"foods","batch":"1"},{"aliases":["poultry_leg"],"filename":"1f357","category":"foods","batch":"1"},{"aliases":["meat_on_bone"],"filename":"1f356","category":"foods","batch":"1"},{"aliases":["pizza"],"filename":"1f355","category":"foods","batch":"1"},{"aliases":["hotdog"],"filename":"1f32d","category":"foods","batch":"1"},{"aliases":["hamburger"],"filename":"1f354","category":"foods","batch":"1"},{"aliases":["fries"],"filename":"1f35f","category":"foods","batch":"1"},{"aliases":["stuffed_flatbread"],"filename":"1f959","category":"foods","batch":"1"},{"aliases":["taco"],"filename":"1f32e","category":"foods","batch":"1"},{"aliases":["burrito"],"filename":"1f32f","category":"foods","batch":"1"},{"aliases":["green_salad"],"filename":"1f957","category":"foods","batch":"1"},{"aliases":["shallow_pan_of_food"],"filename":"1f958","category":"foods","batch":"2"},{"aliases":["spaghetti"],"filename":"1f35d","category":"foods","batch":"2"},{"aliases":["ramen"],"filename":"1f35c","category":"foods","batch":"2"},{"aliases":["stew"],"filename":"1f372","category":"foods","batch":"2"},{"aliases":["fish_cake"],"filename":"1f365","category":"foods","batch":"2"},{"aliases":["sushi"],"filename":"1f363","category":"foods","batch":"2"},{"aliases":["bento"],"filename":"1f371","category":"foods","batch":"2"},{"aliases":["curry"],"filename":"1f35b","category":"foods","batch":"2"},{"aliases":["rice"],"filename":"1f35a","category":"foods","batch":"2"},{"aliases":["rice_ball"],"filename":"1f359","category":"foods","batch":"2"},{"aliases":["rice_cracker"],"filename":"1f358","category":"foods","batch":"2"},{"aliases":["oden"],"filename":"1f362","category":"foods","batch":"2"},{"aliases":["dango"],"filename":"1f361","category":"foods","batch":"2"},{"aliases":["shaved_ice"],"filename":"1f367","category":"foods","batch":"2"},{"aliases":["ice_cream"],"filename":"1f368","category":"foods","batch":"2"},{"aliases":["icecream"],"filename":"1f366","category":"foods","batch":"2"},{"aliases":["cake"],"filename":"1f370","category":"foods","batch":"2"},{"aliases":["birthday"],"filename":"1f382","category":"foods","batch":"2"},{"aliases":["custard"],"filename":"1f36e","category":"foods","batch":"2"},{"aliases":["lollipop"],"filename":"1f36d","category":"foods","batch":"2"},{"aliases":["candy"],"filename":"1f36c","category":"foods","batch":"2"},{"aliases":["chocolate_bar"],"filename":"1f36b","category":"foods","batch":"2"},{"aliases":["popcorn"],"filename":"1f37f","category":"foods","batch":"2"},{"aliases":["doughnut"],"filename":"1f369","category":"foods","batch":"2"},{"aliases":["cookie"],"filename":"1f36a","category":"foods","batch":"2"},{"aliases":["milk_glass"],"filename":"1f95b","category":"foods","batch":"2"},{"aliases":["baby_bottle"],"filename":"1f37c","category":"foods","batch":"2"},{"aliases":["coffee"],"filename":"2615-fe0f","category":"foods","batch":"2"},{"aliases":["tea"],"filename":"1f375","category":"foods","batch":"2"},{"aliases":["sake"],"filename":"1f376","category":"foods","batch":"2"},{"aliases":["beer"],"filename":"1f37a","category":"foods","batch":"2"},{"aliases":["beers"],"filename":"1f37b","category":"foods","batch":"2"},{"aliases":["clinking_glasses"],"filename":"1f942","category":"foods","batch":"2"},{"aliases":["wine_glass"],"filename":"1f377","category":"foods","batch":"2"},{"aliases":["tumbler_glass"],"filename":"1f943","category":"foods","batch":"2"},{"aliases":["cocktail"],"filename":"1f378","category":"foods","batch":"2"},{"aliases":["tropical_drink"],"filename":"1f379","category":"foods","batch":"2"},{"aliases":["champagne"],"filename":"1f37e","category":"foods","batch":"2"},{"aliases":["spoon"],"filename":"1f944","category":"foods","batch":"2"},{"aliases":["fork_and_knife"],"filename":"1f374","category":"foods","batch":"2"},{"aliases":["plate_with_cutlery"],"filename":"1f37d","category":"foods","batch":"2"},{"aliases":["soccer"],"filename":"26bd-fe0f","category":"activity","batch":"1"},{"aliases":["basketball"],"filename":"1f3c0","category":"activity","batch":"1"},{"aliases":["football"],"filename":"1f3c8","category":"activity","batch":"1"},{"aliases":["baseball"],"filename":"26be-fe0f","category":"activity","batch":"1"},{"aliases":["tennis"],"filename":"1f3be","category":"activity","batch":"1"},{"aliases":["volleyball"],"filename":"1f3d0","category":"activity","batch":"1"},{"aliases":["rugby_football"],"filename":"1f3c9","category":"activity","batch":"1"},{"aliases":["8ball"],"filename":"1f3b1","category":"activity","batch":"1"},{"aliases":["ping_pong"],"filename":"1f3d3","category":"activity","batch":"1"},{"aliases":["badminton"],"filename":"1f3f8","category":"activity","batch":"1"},{"aliases":["goal_net"],"filename":"1f945","category":"activity","batch":"1"},{"aliases":["ice_hockey"],"filename":"1f3d2","category":"activity","batch":"1"},{"aliases":["field_hockey"],"filename":"1f3d1","category":"activity","batch":"1"},{"aliases":["cricket"],"filename":"1f3cf","category":"activity","batch":"1"},{"aliases":["golf"],"filename":"26f3-fe0f","category":"activity","batch":"1"},{"aliases":["bow_and_arrow"],"filename":"1f3f9","category":"activity","batch":"1"},{"aliases":["fishing_pole_and_fish"],"filename":"1f3a3","category":"activity","batch":"1"},{"aliases":["boxing_glove"],"filename":"1f94a","category":"activity","batch":"1"},{"aliases":["martial_arts_uniform"],"filename":"1f94b","category":"activity","batch":"1"},{"aliases":["ice_skate"],"filename":"26f8","category":"activity","batch":"1"},{"aliases":["ski"],"filename":"1f3bf","category":"activity","batch":"1"},{"aliases":["skier"],"filename":"26f7","category":"activity","batch":"1"},{"aliases":["snowboarder"],"filename":"1f3c2","category":"activity","batch":"1"},{"aliases":["weight_lifting_woman"],"filename":"1f3cb-fe0f-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["weight_lifting_man"],"filename":"1f3cb-fe0f","category":"activity","batch":"1"},{"aliases":["person_fencing"],"filename":"1f93a","category":"activity","batch":"1"},{"aliases":["women_wrestling"],"filename":"1f93c-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["men_wrestling"],"filename":"1f93c-200d-2642-fe0f","category":"activity","batch":"1"},{"aliases":["woman_cartwheeling"],"filename":"1f938-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["man_cartwheeling"],"filename":"1f938-200d-2642-fe0f","category":"activity","batch":"1"},{"aliases":["basketball_woman"],"filename":"26f9-fe0f-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["basketball_man"],"filename":"26f9-fe0f","category":"activity","batch":"1"},{"aliases":["woman_playing_handball"],"filename":"1f93e-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["man_playing_handball"],"filename":"1f93e-200d-2642-fe0f","category":"activity","batch":"1"},{"aliases":["golfing_woman"],"filename":"1f3cc-fe0f-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["golfing_man"],"filename":"1f3cc-fe0f","category":"activity","batch":"1"},{"aliases":["surfing_woman"],"filename":"1f3c4-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["surfing_man","surfer"],"filename":"1f3c4","category":"activity","batch":"1"},{"aliases":["swimming_woman"],"filename":"1f3ca-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["swimming_man","swimmer"],"filename":"1f3ca","category":"activity","batch":"1"},{"aliases":["woman_playing_water_polo"],"filename":"1f93d-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["man_playing_water_polo"],"filename":"1f93d-200d-2642-fe0f","category":"activity","batch":"1"},{"aliases":["rowing_woman"],"filename":"1f6a3-200d-2640-fe0f","category":"activity","batch":"1"},{"aliases":["rowing_man","rowboat"],"filename":"1f6a3","category":"activity","batch":"1"},{"aliases":["horse_racing"],"filename":"1f3c7","category":"activity","batch":"1"},{"aliases":["biking_woman"],"filename":"1f6b4-200d-2640-fe0f","category":"activity","batch":"2"},{"aliases":["biking_man","bicyclist"],"filename":"1f6b4","category":"activity","batch":"2"},{"aliases":["mountain_biking_woman"],"filename":"1f6b5-200d-2640-fe0f","category":"activity","batch":"2"},{"aliases":["mountain_biking_man","mountain_bicyclist"],"filename":"1f6b5","category":"activity","batch":"2"},{"aliases":["running_shirt_with_sash"],"filename":"1f3bd","category":"activity","batch":"2"},{"aliases":["medal_sports"],"filename":"1f3c5","category":"activity","batch":"2"},{"aliases":["medal_military"],"filename":"1f396","category":"activity","batch":"2"},{"aliases":["1st_place_medal"],"filename":"1f947","category":"activity","batch":"2"},{"aliases":["2nd_place_medal"],"filename":"1f948","category":"activity","batch":"2"},{"aliases":["3rd_place_medal"],"filename":"1f949","category":"activity","batch":"2"},{"aliases":["trophy"],"filename":"1f3c6","category":"activity","batch":"2"},{"aliases":["rosette"],"filename":"1f3f5","category":"activity","batch":"2"},{"aliases":["reminder_ribbon"],"filename":"1f397","category":"activity","batch":"2"},{"aliases":["ticket"],"filename":"1f3ab","category":"activity","batch":"2"},{"aliases":["tickets"],"filename":"1f39f","category":"activity","batch":"2"},{"aliases":["circus_tent"],"filename":"1f3aa","category":"activity","batch":"2"},{"aliases":["woman_juggling"],"filename":"1f939-200d-2640-fe0f","category":"activity","batch":"2"},{"aliases":["man_juggling"],"filename":"1f939-200d-2642-fe0f","category":"activity","batch":"2"},{"aliases":["performing_arts"],"filename":"1f3ad","category":"activity","batch":"2"},{"aliases":["art"],"filename":"1f3a8","category":"activity","batch":"2"},{"aliases":["clapper"],"filename":"1f3ac","category":"activity","batch":"2"},{"aliases":["microphone"],"filename":"1f3a4","category":"activity","batch":"2"},{"aliases":["headphones"],"filename":"1f3a7","category":"activity","batch":"2"},{"aliases":["musical_score"],"filename":"1f3bc","category":"activity","batch":"2"},{"aliases":["musical_keyboard"],"filename":"1f3b9","category":"activity","batch":"2"},{"aliases":["drum"],"filename":"1f941","category":"activity","batch":"2"},{"aliases":["saxophone"],"filename":"1f3b7","category":"activity","batch":"2"},{"aliases":["trumpet"],"filename":"1f3ba","category":"activity","batch":"2"},{"aliases":["guitar"],"filename":"1f3b8","category":"activity","batch":"2"},{"aliases":["violin"],"filename":"1f3bb","category":"activity","batch":"2"},{"aliases":["game_die"],"filename":"1f3b2","category":"activity","batch":"2"},{"aliases":["dart"],"filename":"1f3af","category":"activity","batch":"2"},{"aliases":["bowling"],"filename":"1f3b3","category":"activity","batch":"2"},{"aliases":["video_game"],"filename":"1f3ae","category":"activity","batch":"2"},{"aliases":["slot_machine"],"filename":"1f3b0","category":"activity","batch":"2"},{"aliases":["car","red_car"],"filename":"1f697","category":"places","batch":"1"},{"aliases":["taxi"],"filename":"1f695","category":"places","batch":"1"},{"aliases":["blue_car"],"filename":"1f699","category":"places","batch":"1"},{"aliases":["bus"],"filename":"1f68c","category":"places","batch":"1"},{"aliases":["trolleybus"],"filename":"1f68e","category":"places","batch":"1"},{"aliases":["racing_car"],"filename":"1f3ce","category":"places","batch":"1"},{"aliases":["police_car"],"filename":"1f693","category":"places","batch":"1"},{"aliases":["ambulance"],"filename":"1f691","category":"places","batch":"1"},{"aliases":["fire_engine"],"filename":"1f692","category":"places","batch":"1"},{"aliases":["minibus"],"filename":"1f690","category":"places","batch":"1"},{"aliases":["truck"],"filename":"1f69a","category":"places","batch":"1"},{"aliases":["articulated_lorry"],"filename":"1f69b","category":"places","batch":"1"},{"aliases":["tractor"],"filename":"1f69c","category":"places","batch":"1"},{"aliases":["kick_scooter"],"filename":"1f6f4","category":"places","batch":"1"},{"aliases":["bike"],"filename":"1f6b2","category":"places","batch":"1"},{"aliases":["motor_scooter"],"filename":"1f6f5","category":"places","batch":"1"},{"aliases":["motorcycle"],"filename":"1f3cd","category":"places","batch":"1"},{"aliases":["rotating_light"],"filename":"1f6a8","category":"places","batch":"1"},{"aliases":["oncoming_police_car"],"filename":"1f694","category":"places","batch":"1"},{"aliases":["oncoming_bus"],"filename":"1f68d","category":"places","batch":"1"},{"aliases":["oncoming_automobile"],"filename":"1f698","category":"places","batch":"1"},{"aliases":["oncoming_taxi"],"filename":"1f696","category":"places","batch":"1"},{"aliases":["aerial_tramway"],"filename":"1f6a1","category":"places","batch":"1"},{"aliases":["mountain_cableway"],"filename":"1f6a0","category":"places","batch":"1"},{"aliases":["suspension_railway"],"filename":"1f69f","category":"places","batch":"1"},{"aliases":["railway_car"],"filename":"1f683","category":"places","batch":"1"},{"aliases":["train"],"filename":"1f68b","category":"places","batch":"1"},{"aliases":["mountain_railway"],"filename":"1f69e","category":"places","batch":"1"},{"aliases":["monorail"],"filename":"1f69d","category":"places","batch":"1"},{"aliases":["bullettrain_side"],"filename":"1f684","category":"places","batch":"1"},{"aliases":["bullettrain_front"],"filename":"1f685","category":"places","batch":"1"},{"aliases":["light_rail"],"filename":"1f688","category":"places","batch":"1"},{"aliases":["steam_locomotive"],"filename":"1f682","category":"places","batch":"1"},{"aliases":["train2"],"filename":"1f686","category":"places","batch":"1"},{"aliases":["metro"],"filename":"1f687","category":"places","batch":"1"},{"aliases":["tram"],"filename":"1f68a","category":"places","batch":"1"},{"aliases":["station"],"filename":"1f689","category":"places","batch":"1"},{"aliases":["helicopter"],"filename":"1f681","category":"places","batch":"1"},{"aliases":["small_airplane"],"filename":"1f6e9","category":"places","batch":"1"},{"aliases":["airplane"],"filename":"2708-fe0f","category":"places","batch":"1"},{"aliases":["flight_departure"],"filename":"1f6eb","category":"places","batch":"1"},{"aliases":["flight_arrival"],"filename":"1f6ec","category":"places","batch":"1"},{"aliases":["rocket"],"filename":"1f680","category":"places","batch":"1"},{"aliases":["artificial_satellite"],"filename":"1f6f0","category":"places","batch":"1"},{"aliases":["seat"],"filename":"1f4ba","category":"places","batch":"1"},{"aliases":["canoe"],"filename":"1f6f6","category":"places","batch":"2"},{"aliases":["boat","sailboat"],"filename":"26f5-fe0f","category":"places","batch":"2"},{"aliases":["motor_boat"],"filename":"1f6e5","category":"places","batch":"2"},{"aliases":["speedboat"],"filename":"1f6a4","category":"places","batch":"2"},{"aliases":["passenger_ship"],"filename":"1f6f3","category":"places","batch":"2"},{"aliases":["ferry"],"filename":"26f4","category":"places","batch":"2"},{"aliases":["ship"],"filename":"1f6a2","category":"places","batch":"2"},{"aliases":["anchor"],"filename":"2693-fe0f","category":"places","batch":"2"},{"aliases":["construction"],"filename":"1f6a7","category":"places","batch":"2"},{"aliases":["fuelpump"],"filename":"26fd-fe0f","category":"places","batch":"2"},{"aliases":["busstop"],"filename":"1f68f","category":"places","batch":"2"},{"aliases":["vertical_traffic_light"],"filename":"1f6a6","category":"places","batch":"2"},{"aliases":["traffic_light"],"filename":"1f6a5","category":"places","batch":"2"},{"aliases":["world_map"],"filename":"1f5fa","category":"places","batch":"2"},{"aliases":["moyai"],"filename":"1f5ff","category":"places","batch":"2"},{"aliases":["statue_of_liberty"],"filename":"1f5fd","category":"places","batch":"2"},{"aliases":["fountain"],"filename":"26f2-fe0f","category":"places","batch":"2"},{"aliases":["tokyo_tower"],"filename":"1f5fc","category":"places","batch":"2"},{"aliases":["european_castle"],"filename":"1f3f0","category":"places","batch":"2"},{"aliases":["japanese_castle"],"filename":"1f3ef","category":"places","batch":"2"},{"aliases":["stadium"],"filename":"1f3df","category":"places","batch":"2"},{"aliases":["ferris_wheel"],"filename":"1f3a1","category":"places","batch":"2"},{"aliases":["roller_coaster"],"filename":"1f3a2","category":"places","batch":"2"},{"aliases":["carousel_horse"],"filename":"1f3a0","category":"places","batch":"2"},{"aliases":["parasol_on_ground"],"filename":"26f1","category":"places","batch":"2"},{"aliases":["beach_umbrella"],"filename":"1f3d6","category":"places","batch":"2"},{"aliases":["desert_island"],"filename":"1f3dd","category":"places","batch":"2"},{"aliases":["mountain"],"filename":"26f0","category":"places","batch":"2"},{"aliases":["mountain_snow"],"filename":"1f3d4","category":"places","batch":"2"},{"aliases":["mount_fuji"],"filename":"1f5fb","category":"places","batch":"2"},{"aliases":["volcano"],"filename":"1f30b","category":"places","batch":"2"},{"aliases":["desert"],"filename":"1f3dc","category":"places","batch":"2"},{"aliases":["camping"],"filename":"1f3d5","category":"places","batch":"2"},{"aliases":["tent"],"filename":"26fa-fe0f","category":"places","batch":"2"},{"aliases":["railway_track"],"filename":"1f6e4","category":"places","batch":"2"},{"aliases":["motorway"],"filename":"1f6e3","category":"places","batch":"2"},{"aliases":["building_construction"],"filename":"1f3d7","category":"places","batch":"2"},{"aliases":["factory"],"filename":"1f3ed","category":"places","batch":"2"},{"aliases":["house"],"filename":"1f3e0","category":"places","batch":"2"},{"aliases":["house_with_garden"],"filename":"1f3e1","category":"places","batch":"2"},{"aliases":["houses"],"filename":"1f3d8","category":"places","batch":"2"},{"aliases":["derelict_house"],"filename":"1f3da","category":"places","batch":"2"},{"aliases":["office"],"filename":"1f3e2","category":"places","batch":"2"},{"aliases":["department_store"],"filename":"1f3ec","category":"places","batch":"2"},{"aliases":["post_office"],"filename":"1f3e3","category":"places","batch":"2"},{"aliases":["european_post_office"],"filename":"1f3e4","category":"places","batch":"3"},{"aliases":["hospital"],"filename":"1f3e5","category":"places","batch":"3"},{"aliases":["bank"],"filename":"1f3e6","category":"places","batch":"3"},{"aliases":["hotel"],"filename":"1f3e8","category":"places","batch":"3"},{"aliases":["convenience_store"],"filename":"1f3ea","category":"places","batch":"3"},{"aliases":["school"],"filename":"1f3eb","category":"places","batch":"3"},{"aliases":["love_hotel"],"filename":"1f3e9","category":"places","batch":"3"},{"aliases":["wedding"],"filename":"1f492","category":"places","batch":"3"},{"aliases":["classical_building"],"filename":"1f3db","category":"places","batch":"3"},{"aliases":["church"],"filename":"26ea-fe0f","category":"places","batch":"3"},{"aliases":["mosque"],"filename":"1f54c","category":"places","batch":"3"},{"aliases":["synagogue"],"filename":"1f54d","category":"places","batch":"3"},{"aliases":["kaaba"],"filename":"1f54b","category":"places","batch":"3"},{"aliases":["shinto_shrine"],"filename":"26e9","category":"places","batch":"3"},{"aliases":["japan"],"filename":"1f5fe","category":"places","batch":"3"},{"aliases":["rice_scene"],"filename":"1f391","category":"places","batch":"3"},{"aliases":["national_park"],"filename":"1f3de","category":"places","batch":"3"},{"aliases":["sunrise"],"filename":"1f305","category":"places","batch":"3"},{"aliases":["sunrise_over_mountains"],"filename":"1f304","category":"places","batch":"3"},{"aliases":["stars"],"filename":"1f320","category":"places","batch":"3"},{"aliases":["sparkler"],"filename":"1f387","category":"places","batch":"3"},{"aliases":["fireworks"],"filename":"1f386","category":"places","batch":"3"},{"aliases":["city_sunrise"],"filename":"1f307","category":"places","batch":"3"},{"aliases":["city_sunset"],"filename":"1f306","category":"places","batch":"3"},{"aliases":["cityscape"],"filename":"1f3d9","category":"places","batch":"3"},{"aliases":["night_with_stars"],"filename":"1f303","category":"places","batch":"3"},{"aliases":["milky_way"],"filename":"1f30c","category":"places","batch":"3"},{"aliases":["bridge_at_night"],"filename":"1f309","category":"places","batch":"3"},{"aliases":["foggy"],"filename":"1f301","category":"places","batch":"3"},{"aliases":["watch"],"filename":"231a-fe0f","category":"objects","batch":"1"},{"aliases":["iphone"],"filename":"1f4f1","category":"objects","batch":"1"},{"aliases":["calling"],"filename":"1f4f2","category":"objects","batch":"1"},{"aliases":["computer"],"filename":"1f4bb","category":"objects","batch":"1"},{"aliases":["keyboard"],"filename":"2328-fe0f","category":"objects","batch":"1"},{"aliases":["desktop_computer"],"filename":"1f5a5","category":"objects","batch":"1"},{"aliases":["printer"],"filename":"1f5a8","category":"objects","batch":"1"},{"aliases":["computer_mouse"],"filename":"1f5b1","category":"objects","batch":"1"},{"aliases":["trackball"],"filename":"1f5b2","category":"objects","batch":"1"},{"aliases":["joystick"],"filename":"1f579","category":"objects","batch":"1"},{"aliases":["clamp"],"filename":"1f5dc","category":"objects","batch":"1"},{"aliases":["minidisc"],"filename":"1f4bd","category":"objects","batch":"1"},{"aliases":["floppy_disk"],"filename":"1f4be","category":"objects","batch":"1"},{"aliases":["cd"],"filename":"1f4bf","category":"objects","batch":"1"},{"aliases":["dvd"],"filename":"1f4c0","category":"objects","batch":"1"},{"aliases":["vhs"],"filename":"1f4fc","category":"objects","batch":"1"},{"aliases":["camera"],"filename":"1f4f7","category":"objects","batch":"1"},{"aliases":["camera_flash"],"filename":"1f4f8","category":"objects","batch":"1"},{"aliases":["video_camera"],"filename":"1f4f9","category":"objects","batch":"1"},{"aliases":["movie_camera"],"filename":"1f3a5","category":"objects","batch":"1"},{"aliases":["film_projector"],"filename":"1f4fd","category":"objects","batch":"1"},{"aliases":["film_strip"],"filename":"1f39e","category":"objects","batch":"1"},{"aliases":["telephone_receiver"],"filename":"1f4de","category":"objects","batch":"1"},{"aliases":["phone","telephone"],"filename":"260e-fe0f","category":"objects","batch":"1"},{"aliases":["pager"],"filename":"1f4df","category":"objects","batch":"1"},{"aliases":["fax"],"filename":"1f4e0","category":"objects","batch":"1"},{"aliases":["tv"],"filename":"1f4fa","category":"objects","batch":"1"},{"aliases":["radio"],"filename":"1f4fb","category":"objects","batch":"1"},{"aliases":["studio_microphone"],"filename":"1f399","category":"objects","batch":"1"},{"aliases":["level_slider"],"filename":"1f39a","category":"objects","batch":"1"},{"aliases":["control_knobs"],"filename":"1f39b","category":"objects","batch":"1"},{"aliases":["stopwatch"],"filename":"23f1","category":"objects","batch":"1"},{"aliases":["timer_clock"],"filename":"23f2","category":"objects","batch":"1"},{"aliases":["alarm_clock"],"filename":"23f0","category":"objects","batch":"1"},{"aliases":["mantelpiece_clock"],"filename":"1f570","category":"objects","batch":"1"},{"aliases":["hourglass"],"filename":"231b-fe0f","category":"objects","batch":"1"},{"aliases":["hourglass_flowing_sand"],"filename":"23f3","category":"objects","batch":"1"},{"aliases":["satellite"],"filename":"1f4e1","category":"objects","batch":"1"},{"aliases":["battery"],"filename":"1f50b","category":"objects","batch":"1"},{"aliases":["electric_plug"],"filename":"1f50c","category":"objects","batch":"1"},{"aliases":["bulb"],"filename":"1f4a1","category":"objects","batch":"1"},{"aliases":["flashlight"],"filename":"1f526","category":"objects","batch":"1"},{"aliases":["candle"],"filename":"1f56f","category":"objects","batch":"1"},{"aliases":["wastebasket"],"filename":"1f5d1","category":"objects","batch":"1"},{"aliases":["oil_drum"],"filename":"1f6e2","category":"objects","batch":"1"},{"aliases":["money_with_wings"],"filename":"1f4b8","category":"objects","batch":"2"},{"aliases":["dollar"],"filename":"1f4b5","category":"objects","batch":"2"},{"aliases":["yen"],"filename":"1f4b4","category":"objects","batch":"2"},{"aliases":["euro"],"filename":"1f4b6","category":"objects","batch":"2"},{"aliases":["pound"],"filename":"1f4b7","category":"objects","batch":"2"},{"aliases":["moneybag"],"filename":"1f4b0","category":"objects","batch":"2"},{"aliases":["credit_card"],"filename":"1f4b3","category":"objects","batch":"2"},{"aliases":["gem"],"filename":"1f48e","category":"objects","batch":"2"},{"aliases":["balance_scale"],"filename":"2696-fe0f","category":"objects","batch":"2"},{"aliases":["wrench"],"filename":"1f527","category":"objects","batch":"2"},{"aliases":["hammer"],"filename":"1f528","category":"objects","batch":"2"},{"aliases":["hammer_and_pick"],"filename":"2692","category":"objects","batch":"2"},{"aliases":["hammer_and_wrench"],"filename":"1f6e0","category":"objects","batch":"2"},{"aliases":["pick"],"filename":"26cf","category":"objects","batch":"2"},{"aliases":["nut_and_bolt"],"filename":"1f529","category":"objects","batch":"2"},{"aliases":["gear"],"filename":"2699-fe0f","category":"objects","batch":"2"},{"aliases":["chains"],"filename":"26d3","category":"objects","batch":"2"},{"aliases":["gun"],"filename":"1f52b","category":"objects","batch":"2"},{"aliases":["bomb"],"filename":"1f4a3","category":"objects","batch":"2"},{"aliases":["hocho","knife"],"filename":"1f52a","category":"objects","batch":"2"},{"aliases":["dagger"],"filename":"1f5e1","category":"objects","batch":"2"},{"aliases":["crossed_swords"],"filename":"2694-fe0f","category":"objects","batch":"2"},{"aliases":["shield"],"filename":"1f6e1","category":"objects","batch":"2"},{"aliases":["smoking"],"filename":"1f6ac","category":"objects","batch":"2"},{"aliases":["coffin"],"filename":"26b0-fe0f","category":"objects","batch":"2"},{"aliases":["funeral_urn"],"filename":"26b1-fe0f","category":"objects","batch":"2"},{"aliases":["amphora"],"filename":"1f3fa","category":"objects","batch":"2"},{"aliases":["crystal_ball"],"filename":"1f52e","category":"objects","batch":"2"},{"aliases":["prayer_beads"],"filename":"1f4ff","category":"objects","batch":"2"},{"aliases":["barber"],"filename":"1f488","category":"objects","batch":"2"},{"aliases":["alembic"],"filename":"2697-fe0f","category":"objects","batch":"2"},{"aliases":["telescope"],"filename":"1f52d","category":"objects","batch":"2"},{"aliases":["microscope"],"filename":"1f52c","category":"objects","batch":"2"},{"aliases":["hole"],"filename":"1f573","category":"objects","batch":"2"},{"aliases":["pill"],"filename":"1f48a","category":"objects","batch":"2"},{"aliases":["syringe"],"filename":"1f489","category":"objects","batch":"2"},{"aliases":["thermometer"],"filename":"1f321","category":"objects","batch":"2"},{"aliases":["toilet"],"filename":"1f6bd","category":"objects","batch":"2"},{"aliases":["potable_water"],"filename":"1f6b0","category":"objects","batch":"2"},{"aliases":["shower"],"filename":"1f6bf","category":"objects","batch":"2"},{"aliases":["bathtub"],"filename":"1f6c1","category":"objects","batch":"2"},{"aliases":["bath"],"filename":"1f6c0","category":"objects","batch":"2"},{"aliases":["bellhop_bell"],"filename":"1f6ce","category":"objects","batch":"2"},{"aliases":["key"],"filename":"1f511","category":"objects","batch":"2"},{"aliases":["old_key"],"filename":"1f5dd","category":"objects","batch":"2"},{"aliases":["door"],"filename":"1f6aa","category":"objects","batch":"3"},{"aliases":["couch_and_lamp"],"filename":"1f6cb","category":"objects","batch":"3"},{"aliases":["bed"],"filename":"1f6cf","category":"objects","batch":"3"},{"aliases":["sleeping_bed"],"filename":"1f6cc","category":"objects","batch":"3"},{"aliases":["framed_picture"],"filename":"1f5bc","category":"objects","batch":"3"},{"aliases":["shopping"],"filename":"1f6cd","category":"objects","batch":"3"},{"aliases":["shopping_cart"],"filename":"1f6d2","category":"objects","batch":"3"},{"aliases":["gift"],"filename":"1f381","category":"objects","batch":"3"},{"aliases":["balloon"],"filename":"1f388","category":"objects","batch":"3"},{"aliases":["flags"],"filename":"1f38f","category":"objects","batch":"3"},{"aliases":["ribbon"],"filename":"1f380","category":"objects","batch":"3"},{"aliases":["confetti_ball"],"filename":"1f38a","category":"objects","batch":"3"},{"aliases":["tada"],"filename":"1f389","category":"objects","batch":"3"},{"aliases":["dolls"],"filename":"1f38e","category":"objects","batch":"3"},{"aliases":["izakaya_lantern","lantern"],"filename":"1f3ee","category":"objects","batch":"3"},{"aliases":["wind_chime"],"filename":"1f390","category":"objects","batch":"3"},{"aliases":["email","envelope"],"filename":"2709-fe0f","category":"objects","batch":"3"},{"aliases":["envelope_with_arrow"],"filename":"1f4e9","category":"objects","batch":"3"},{"aliases":["incoming_envelope"],"filename":"1f4e8","category":"objects","batch":"3"},{"aliases":["e-mail"],"filename":"1f4e7","category":"objects","batch":"3"},{"aliases":["love_letter"],"filename":"1f48c","category":"objects","batch":"3"},{"aliases":["inbox_tray"],"filename":"1f4e5","category":"objects","batch":"3"},{"aliases":["outbox_tray"],"filename":"1f4e4","category":"objects","batch":"3"},{"aliases":["package"],"filename":"1f4e6","category":"objects","batch":"3"},{"aliases":["label"],"filename":"1f3f7","category":"objects","batch":"3"},{"aliases":["mailbox_closed"],"filename":"1f4ea","category":"objects","batch":"3"},{"aliases":["mailbox"],"filename":"1f4eb","category":"objects","batch":"3"},{"aliases":["mailbox_with_mail"],"filename":"1f4ec","category":"objects","batch":"3"},{"aliases":["mailbox_with_no_mail"],"filename":"1f4ed","category":"objects","batch":"3"},{"aliases":["postbox"],"filename":"1f4ee","category":"objects","batch":"3"},{"aliases":["postal_horn"],"filename":"1f4ef","category":"objects","batch":"3"},{"aliases":["scroll"],"filename":"1f4dc","category":"objects","batch":"3"},{"aliases":["page_with_curl"],"filename":"1f4c3","category":"objects","batch":"3"},{"aliases":["page_facing_up"],"filename":"1f4c4","category":"objects","batch":"3"},{"aliases":["bookmark_tabs"],"filename":"1f4d1","category":"objects","batch":"3"},{"aliases":["bar_chart"],"filename":"1f4ca","category":"objects","batch":"3"},{"aliases":["chart_with_upwards_trend"],"filename":"1f4c8","category":"objects","batch":"3"},{"aliases":["chart_with_downwards_trend"],"filename":"1f4c9","category":"objects","batch":"3"},{"aliases":["spiral_notepad"],"filename":"1f5d2","category":"objects","batch":"3"},{"aliases":["spiral_calendar"],"filename":"1f5d3","category":"objects","batch":"3"},{"aliases":["calendar"],"filename":"1f4c6","category":"objects","batch":"3"},{"aliases":["date"],"filename":"1f4c5","category":"objects","batch":"3"},{"aliases":["card_index"],"filename":"1f4c7","category":"objects","batch":"3"},{"aliases":["card_file_box"],"filename":"1f5c3","category":"objects","batch":"3"},{"aliases":["ballot_box"],"filename":"1f5f3","category":"objects","batch":"3"},{"aliases":["file_cabinet"],"filename":"1f5c4","category":"objects","batch":"4"},{"aliases":["clipboard"],"filename":"1f4cb","category":"objects","batch":"4"},{"aliases":["file_folder"],"filename":"1f4c1","category":"objects","batch":"4"},{"aliases":["open_file_folder"],"filename":"1f4c2","category":"objects","batch":"4"},{"aliases":["card_index_dividers"],"filename":"1f5c2","category":"objects","batch":"4"},{"aliases":["newspaper_roll"],"filename":"1f5de","category":"objects","batch":"4"},{"aliases":["newspaper"],"filename":"1f4f0","category":"objects","batch":"4"},{"aliases":["notebook"],"filename":"1f4d3","category":"objects","batch":"4"},{"aliases":["notebook_with_decorative_cover"],"filename":"1f4d4","category":"objects","batch":"4"},{"aliases":["ledger"],"filename":"1f4d2","category":"objects","batch":"4"},{"aliases":["closed_book"],"filename":"1f4d5","category":"objects","batch":"4"},{"aliases":["green_book"],"filename":"1f4d7","category":"objects","batch":"4"},{"aliases":["blue_book"],"filename":"1f4d8","category":"objects","batch":"4"},{"aliases":["orange_book"],"filename":"1f4d9","category":"objects","batch":"4"},{"aliases":["books"],"filename":"1f4da","category":"objects","batch":"4"},{"aliases":["book","open_book"],"filename":"1f4d6","category":"objects","batch":"4"},{"aliases":["bookmark"],"filename":"1f516","category":"objects","batch":"4"},{"aliases":["link"],"filename":"1f517","category":"objects","batch":"4"},{"aliases":["paperclip"],"filename":"1f4ce","category":"objects","batch":"4"},{"aliases":["paperclips"],"filename":"1f587","category":"objects","batch":"4"},{"aliases":["triangular_ruler"],"filename":"1f4d0","category":"objects","batch":"4"},{"aliases":["straight_ruler"],"filename":"1f4cf","category":"objects","batch":"4"},{"aliases":["pushpin"],"filename":"1f4cc","category":"objects","batch":"4"},{"aliases":["round_pushpin"],"filename":"1f4cd","category":"objects","batch":"4"},{"aliases":["scissors"],"filename":"2702-fe0f","category":"objects","batch":"4"},{"aliases":["pen"],"filename":"1f58a","category":"objects","batch":"4"},{"aliases":["fountain_pen"],"filename":"1f58b","category":"objects","batch":"4"},{"aliases":["black_nib"],"filename":"2712-fe0f","category":"objects","batch":"4"},{"aliases":["paintbrush"],"filename":"1f58c","category":"objects","batch":"4"},{"aliases":["crayon"],"filename":"1f58d","category":"objects","batch":"4"},{"aliases":["memo","pencil"],"filename":"1f4dd","category":"objects","batch":"4"},{"aliases":["pencil2"],"filename":"270f-fe0f","category":"objects","batch":"4"},{"aliases":["mag"],"filename":"1f50d","category":"objects","batch":"4"},{"aliases":["mag_right"],"filename":"1f50e","category":"objects","batch":"4"},{"aliases":["lock_with_ink_pen"],"filename":"1f50f","category":"objects","batch":"4"},{"aliases":["closed_lock_with_key"],"filename":"1f510","category":"objects","batch":"4"},{"aliases":["lock"],"filename":"1f512","category":"objects","batch":"4"},{"aliases":["unlock"],"filename":"1f513","category":"objects","batch":"4"},{"aliases":["heart"],"filename":"2764-fe0f","category":"symbols","batch":"1"},{"aliases":["yellow_heart"],"filename":"1f49b","category":"symbols","batch":"1"},{"aliases":["green_heart"],"filename":"1f49a","category":"symbols","batch":"1"},{"aliases":["blue_heart"],"filename":"1f499","category":"symbols","batch":"1"},{"aliases":["purple_heart"],"filename":"1f49c","category":"symbols","batch":"1"},{"aliases":["black_heart"],"filename":"1f5a4","category":"symbols","batch":"1"},{"aliases":["broken_heart"],"filename":"1f494","category":"symbols","batch":"1"},{"aliases":["heavy_heart_exclamation"],"filename":"2763-fe0f","category":"symbols","batch":"1"},{"aliases":["two_hearts"],"filename":"1f495","category":"symbols","batch":"1"},{"aliases":["revolving_hearts"],"filename":"1f49e","category":"symbols","batch":"1"},{"aliases":["heartbeat"],"filename":"1f493","category":"symbols","batch":"1"},{"aliases":["heartpulse"],"filename":"1f497","category":"symbols","batch":"1"},{"aliases":["sparkling_heart"],"filename":"1f496","category":"symbols","batch":"1"},{"aliases":["cupid"],"filename":"1f498","category":"symbols","batch":"1"},{"aliases":["gift_heart"],"filename":"1f49d","category":"symbols","batch":"1"},{"aliases":["heart_decoration"],"filename":"1f49f","category":"symbols","batch":"1"},{"aliases":["peace_symbol"],"filename":"262e-fe0f","category":"symbols","batch":"1"},{"aliases":["latin_cross"],"filename":"271d-fe0f","category":"symbols","batch":"1"},{"aliases":["star_and_crescent"],"filename":"262a-fe0f","category":"symbols","batch":"1"},{"aliases":["om"],"filename":"1f549","category":"symbols","batch":"1"},{"aliases":["wheel_of_dharma"],"filename":"2638-fe0f","category":"symbols","batch":"1"},{"aliases":["star_of_david"],"filename":"2721-fe0f","category":"symbols","batch":"1"},{"aliases":["six_pointed_star"],"filename":"1f52f","category":"symbols","batch":"1"},{"aliases":["menorah"],"filename":"1f54e","category":"symbols","batch":"1"},{"aliases":["yin_yang"],"filename":"262f-fe0f","category":"symbols","batch":"1"},{"aliases":["orthodox_cross"],"filename":"2626-fe0f","category":"symbols","batch":"1"},{"aliases":["place_of_worship"],"filename":"1f6d0","category":"symbols","batch":"1"},{"aliases":["ophiuchus"],"filename":"26ce","category":"symbols","batch":"1"},{"aliases":["aries"],"filename":"2648-fe0f","category":"symbols","batch":"1"},{"aliases":["taurus"],"filename":"2649-fe0f","category":"symbols","batch":"1"},{"aliases":["gemini"],"filename":"264a-fe0f","category":"symbols","batch":"1"},{"aliases":["cancer"],"filename":"264b-fe0f","category":"symbols","batch":"1"},{"aliases":["leo"],"filename":"264c-fe0f","category":"symbols","batch":"1"},{"aliases":["virgo"],"filename":"264d-fe0f","category":"symbols","batch":"1"},{"aliases":["libra"],"filename":"264e-fe0f","category":"symbols","batch":"1"},{"aliases":["scorpius"],"filename":"264f-fe0f","category":"symbols","batch":"1"},{"aliases":["sagittarius"],"filename":"2650-fe0f","category":"symbols","batch":"1"},{"aliases":["capricorn"],"filename":"2651-fe0f","category":"symbols","batch":"1"},{"aliases":["aquarius"],"filename":"2652-fe0f","category":"symbols","batch":"1"},{"aliases":["pisces"],"filename":"2653-fe0f","category":"symbols","batch":"1"},{"aliases":["id"],"filename":"1f194","category":"symbols","batch":"1"},{"aliases":["atom_symbol"],"filename":"269b-fe0f","category":"symbols","batch":"1"},{"aliases":["accept"],"filename":"1f251","category":"symbols","batch":"1"},{"aliases":["radioactive"],"filename":"2622-fe0f","category":"symbols","batch":"1"},{"aliases":["biohazard"],"filename":"2623-fe0f","category":"symbols","batch":"1"},{"aliases":["mobile_phone_off"],"filename":"1f4f4","category":"symbols","batch":"2"},{"aliases":["vibration_mode"],"filename":"1f4f3","category":"symbols","batch":"2"},{"aliases":["u6709"],"filename":"1f236","category":"symbols","batch":"2"},{"aliases":["u7121"],"filename":"1f21a-fe0f","category":"symbols","batch":"2"},{"aliases":["u7533"],"filename":"1f238","category":"symbols","batch":"2"},{"aliases":["u55b6"],"filename":"1f23a","category":"symbols","batch":"2"},{"aliases":["u6708"],"filename":"1f237-fe0f","category":"symbols","batch":"2"},{"aliases":["eight_pointed_black_star"],"filename":"2734-fe0f","category":"symbols","batch":"2"},{"aliases":["vs"],"filename":"1f19a","category":"symbols","batch":"2"},{"aliases":["white_flower"],"filename":"1f4ae","category":"symbols","batch":"2"},{"aliases":["ideograph_advantage"],"filename":"1f250","category":"symbols","batch":"2"},{"aliases":["secret"],"filename":"3299-fe0f","category":"symbols","batch":"2"},{"aliases":["congratulations"],"filename":"3297-fe0f","category":"symbols","batch":"2"},{"aliases":["u5408"],"filename":"1f234","category":"symbols","batch":"2"},{"aliases":["u6e80"],"filename":"1f235","category":"symbols","batch":"2"},{"aliases":["u5272"],"filename":"1f239","category":"symbols","batch":"2"},{"aliases":["u7981"],"filename":"1f232","category":"symbols","batch":"2"},{"aliases":["a"],"filename":"1f170-fe0f","category":"symbols","batch":"2"},{"aliases":["b"],"filename":"1f171-fe0f","category":"symbols","batch":"2"},{"aliases":["ab"],"filename":"1f18e","category":"symbols","batch":"2"},{"aliases":["cl"],"filename":"1f191","category":"symbols","batch":"2"},{"aliases":["o2"],"filename":"1f17e-fe0f","category":"symbols","batch":"2"},{"aliases":["sos"],"filename":"1f198","category":"symbols","batch":"2"},{"aliases":["x"],"filename":"274c","category":"symbols","batch":"2"},{"aliases":["o"],"filename":"2b55-fe0f","category":"symbols","batch":"2"},{"aliases":["stop_sign"],"filename":"1f6d1","category":"symbols","batch":"2"},{"aliases":["no_entry"],"filename":"26d4-fe0f","category":"symbols","batch":"2"},{"aliases":["name_badge"],"filename":"1f4db","category":"symbols","batch":"2"},{"aliases":["no_entry_sign"],"filename":"1f6ab","category":"symbols","batch":"2"},{"aliases":["100"],"filename":"1f4af","category":"symbols","batch":"2"},{"aliases":["anger"],"filename":"1f4a2","category":"symbols","batch":"2"},{"aliases":["hotsprings"],"filename":"2668-fe0f","category":"symbols","batch":"2"},{"aliases":["no_pedestrians"],"filename":"1f6b7","category":"symbols","batch":"2"},{"aliases":["do_not_litter"],"filename":"1f6af","category":"symbols","batch":"2"},{"aliases":["no_bicycles"],"filename":"1f6b3","category":"symbols","batch":"2"},{"aliases":["non-potable_water"],"filename":"1f6b1","category":"symbols","batch":"2"},{"aliases":["underage"],"filename":"1f51e","category":"symbols","batch":"2"},{"aliases":["no_mobile_phones"],"filename":"1f4f5","category":"symbols","batch":"2"},{"aliases":["no_smoking"],"filename":"1f6ad","category":"symbols","batch":"2"},{"aliases":["exclamation","heavy_exclamation_mark"],"filename":"2757-fe0f","category":"symbols","batch":"2"},{"aliases":["grey_exclamation"],"filename":"2755","category":"symbols","batch":"2"},{"aliases":["question"],"filename":"2753","category":"symbols","batch":"2"},{"aliases":["grey_question"],"filename":"2754","category":"symbols","batch":"2"},{"aliases":["bangbang"],"filename":"203c-fe0f","category":"symbols","batch":"2"},{"aliases":["interrobang"],"filename":"2049-fe0f","category":"symbols","batch":"2"},{"aliases":["low_brightness"],"filename":"1f505","category":"symbols","batch":"3"},{"aliases":["high_brightness"],"filename":"1f506","category":"symbols","batch":"3"},{"aliases":["part_alternation_mark"],"filename":"303d-fe0f","category":"symbols","batch":"3"},{"aliases":["warning"],"filename":"26a0-fe0f","category":"symbols","batch":"3"},{"aliases":["children_crossing"],"filename":"1f6b8","category":"symbols","batch":"3"},{"aliases":["trident"],"filename":"1f531","category":"symbols","batch":"3"},{"aliases":["fleur_de_lis"],"filename":"269c-fe0f","category":"symbols","batch":"3"},{"aliases":["beginner"],"filename":"1f530","category":"symbols","batch":"3"},{"aliases":["recycle"],"filename":"267b-fe0f","category":"symbols","batch":"3"},{"aliases":["white_check_mark"],"filename":"2705","category":"symbols","batch":"3"},{"aliases":["u6307"],"filename":"1f22f-fe0f","category":"symbols","batch":"3"},{"aliases":["chart"],"filename":"1f4b9","category":"symbols","batch":"3"},{"aliases":["sparkle"],"filename":"2747-fe0f","category":"symbols","batch":"3"},{"aliases":["eight_spoked_asterisk"],"filename":"2733-fe0f","category":"symbols","batch":"3"},{"aliases":["negative_squared_cross_mark"],"filename":"274e","category":"symbols","batch":"3"},{"aliases":["globe_with_meridians"],"filename":"1f310","category":"symbols","batch":"3"},{"aliases":["diamond_shape_with_a_dot_inside"],"filename":"1f4a0","category":"symbols","batch":"3"},{"aliases":["m"],"filename":"24c2-fe0f","category":"symbols","batch":"3"},{"aliases":["cyclone"],"filename":"1f300","category":"symbols","batch":"3"},{"aliases":["zzz"],"filename":"1f4a4","category":"symbols","batch":"3"},{"aliases":["atm"],"filename":"1f3e7","category":"symbols","batch":"3"},{"aliases":["wc"],"filename":"1f6be","category":"symbols","batch":"3"},{"aliases":["wheelchair"],"filename":"267f-fe0f","category":"symbols","batch":"3"},{"aliases":["parking"],"filename":"1f17f-fe0f","category":"symbols","batch":"3"},{"aliases":["u7a7a"],"filename":"1f233","category":"symbols","batch":"3"},{"aliases":["sa"],"filename":"1f202-fe0f","category":"symbols","batch":"3"},{"aliases":["passport_control"],"filename":"1f6c2","category":"symbols","batch":"3"},{"aliases":["customs"],"filename":"1f6c3","category":"symbols","batch":"3"},{"aliases":["baggage_claim"],"filename":"1f6c4","category":"symbols","batch":"3"},{"aliases":["left_luggage"],"filename":"1f6c5","category":"symbols","batch":"3"},{"aliases":["mens"],"filename":"1f6b9","category":"symbols","batch":"3"},{"aliases":["womens"],"filename":"1f6ba","category":"symbols","batch":"3"},{"aliases":["baby_symbol"],"filename":"1f6bc","category":"symbols","batch":"3"},{"aliases":["restroom"],"filename":"1f6bb","category":"symbols","batch":"3"},{"aliases":["put_litter_in_its_place"],"filename":"1f6ae","category":"symbols","batch":"3"},{"aliases":["cinema"],"filename":"1f3a6","category":"symbols","batch":"3"},{"aliases":["signal_strength"],"filename":"1f4f6","category":"symbols","batch":"3"},{"aliases":["koko"],"filename":"1f201","category":"symbols","batch":"3"},{"aliases":["symbols"],"filename":"1f523","category":"symbols","batch":"3"},{"aliases":["information_source"],"filename":"2139-fe0f","category":"symbols","batch":"3"},{"aliases":["abc"],"filename":"1f524","category":"symbols","batch":"3"},{"aliases":["abcd"],"filename":"1f521","category":"symbols","batch":"3"},{"aliases":["capital_abcd"],"filename":"1f520","category":"symbols","batch":"3"},{"aliases":["ng"],"filename":"1f196","category":"symbols","batch":"3"},{"aliases":["ok"],"filename":"1f197","category":"symbols","batch":"3"},{"aliases":["up"],"filename":"1f199","category":"symbols","batch":"4"},{"aliases":["cool"],"filename":"1f192","category":"symbols","batch":"4"},{"aliases":["new"],"filename":"1f195","category":"symbols","batch":"4"},{"aliases":["free"],"filename":"1f193","category":"symbols","batch":"4"},{"aliases":["zero"],"filename":"0030-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["one"],"filename":"0031-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["two"],"filename":"0032-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["three"],"filename":"0033-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["four"],"filename":"0034-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["five"],"filename":"0035-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["six"],"filename":"0036-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["seven"],"filename":"0037-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["eight"],"filename":"0038-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["nine"],"filename":"0039-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["keycap_ten"],"filename":"1f51f","category":"symbols","batch":"4"},{"aliases":["1234"],"filename":"1f522","category":"symbols","batch":"4"},{"aliases":["hash"],"filename":"0023-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["asterisk"],"filename":"002a-fe0f-20e3","category":"symbols","batch":"4"},{"aliases":["arrow_forward"],"filename":"25b6-fe0f","category":"symbols","batch":"4"},{"aliases":["pause_button"],"filename":"23f8","category":"symbols","batch":"4"},{"aliases":["play_or_pause_button"],"filename":"23ef","category":"symbols","batch":"4"},{"aliases":["stop_button"],"filename":"23f9","category":"symbols","batch":"4"},{"aliases":["record_button"],"filename":"23fa","category":"symbols","batch":"4"},{"aliases":["next_track_button"],"filename":"23ed","category":"symbols","batch":"4"},{"aliases":["previous_track_button"],"filename":"23ee","category":"symbols","batch":"4"},{"aliases":["fast_forward"],"filename":"23e9","category":"symbols","batch":"4"},{"aliases":["rewind"],"filename":"23ea","category":"symbols","batch":"4"},{"aliases":["arrow_double_up"],"filename":"23eb","category":"symbols","batch":"4"},{"aliases":["arrow_double_down"],"filename":"23ec","category":"symbols","batch":"4"},{"aliases":["arrow_backward"],"filename":"25c0-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_up_small"],"filename":"1f53c","category":"symbols","batch":"4"},{"aliases":["arrow_down_small"],"filename":"1f53d","category":"symbols","batch":"4"},{"aliases":["arrow_right"],"filename":"27a1-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_left"],"filename":"2b05-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_up"],"filename":"2b06-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_down"],"filename":"2b07-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_upper_right"],"filename":"2197-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_lower_right"],"filename":"2198-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_lower_left"],"filename":"2199-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_upper_left"],"filename":"2196-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_up_down"],"filename":"2195-fe0f","category":"symbols","batch":"4"},{"aliases":["left_right_arrow"],"filename":"2194-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_right_hook"],"filename":"21aa-fe0f","category":"symbols","batch":"4"},{"aliases":["leftwards_arrow_with_hook"],"filename":"21a9-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_heading_up"],"filename":"2934-fe0f","category":"symbols","batch":"4"},{"aliases":["arrow_heading_down"],"filename":"2935-fe0f","category":"symbols","batch":"5"},{"aliases":["twisted_rightwards_arrows"],"filename":"1f500","category":"symbols","batch":"5"},{"aliases":["repeat"],"filename":"1f501","category":"symbols","batch":"5"},{"aliases":["repeat_one"],"filename":"1f502","category":"symbols","batch":"5"},{"aliases":["arrows_counterclockwise"],"filename":"1f504","category":"symbols","batch":"5"},{"aliases":["arrows_clockwise"],"filename":"1f503","category":"symbols","batch":"5"},{"aliases":["musical_note"],"filename":"1f3b5","category":"symbols","batch":"5"},{"aliases":["notes"],"filename":"1f3b6","category":"symbols","batch":"5"},{"aliases":["heavy_plus_sign"],"filename":"2795","category":"symbols","batch":"5"},{"aliases":["heavy_minus_sign"],"filename":"2796","category":"symbols","batch":"5"},{"aliases":["heavy_division_sign"],"filename":"2797","category":"symbols","batch":"5"},{"aliases":["heavy_multiplication_x"],"filename":"2716-fe0f","category":"symbols","batch":"5"},{"aliases":["heavy_dollar_sign"],"filename":"1f4b2","category":"symbols","batch":"5"},{"aliases":["currency_exchange"],"filename":"1f4b1","category":"symbols","batch":"5"},{"aliases":["tm"],"filename":"2122-fe0f","category":"symbols","batch":"5"},{"aliases":["copyright"],"filename":"00a9-fe0f","category":"symbols","batch":"5"},{"aliases":["registered"],"filename":"00ae-fe0f","category":"symbols","batch":"5"},{"aliases":["wavy_dash"],"filename":"3030-fe0f","category":"symbols","batch":"5"},{"aliases":["curly_loop"],"filename":"27b0","category":"symbols","batch":"5"},{"aliases":["loop"],"filename":"27bf","category":"symbols","batch":"5"},{"aliases":["end"],"filename":"1f51a","category":"symbols","batch":"5"},{"aliases":["back"],"filename":"1f519","category":"symbols","batch":"5"},{"aliases":["on"],"filename":"1f51b","category":"symbols","batch":"5"},{"aliases":["top"],"filename":"1f51d","category":"symbols","batch":"5"},{"aliases":["soon"],"filename":"1f51c","category":"symbols","batch":"5"},{"aliases":["heavy_check_mark"],"filename":"2714-fe0f","category":"symbols","batch":"5"},{"aliases":["ballot_box_with_check"],"filename":"2611-fe0f","category":"symbols","batch":"5"},{"aliases":["radio_button"],"filename":"1f518","category":"symbols","batch":"5"},{"aliases":["white_circle"],"filename":"26aa-fe0f","category":"symbols","batch":"5"},{"aliases":["black_circle"],"filename":"26ab-fe0f","category":"symbols","batch":"5"},{"aliases":["red_circle"],"filename":"1f534","category":"symbols","batch":"5"},{"aliases":["large_blue_circle"],"filename":"1f535","category":"symbols","batch":"5"},{"aliases":["small_red_triangle"],"filename":"1f53a","category":"symbols","batch":"5"},{"aliases":["small_red_triangle_down"],"filename":"1f53b","category":"symbols","batch":"5"},{"aliases":["small_orange_diamond"],"filename":"1f538","category":"symbols","batch":"5"},{"aliases":["small_blue_diamond"],"filename":"1f539","category":"symbols","batch":"5"},{"aliases":["large_orange_diamond"],"filename":"1f536","category":"symbols","batch":"5"},{"aliases":["large_blue_diamond"],"filename":"1f537","category":"symbols","batch":"5"},{"aliases":["white_square_button"],"filename":"1f533","category":"symbols","batch":"5"},{"aliases":["black_square_button"],"filename":"1f532","category":"symbols","batch":"5"},{"aliases":["black_small_square"],"filename":"25aa-fe0f","category":"symbols","batch":"5"},{"aliases":["white_small_square"],"filename":"25ab-fe0f","category":"symbols","batch":"5"},{"aliases":["black_medium_small_square"],"filename":"25fe-fe0f","category":"symbols","batch":"5"},{"aliases":["white_medium_small_square"],"filename":"25fd-fe0f","category":"symbols","batch":"5"},{"aliases":["black_medium_square"],"filename":"25fc-fe0f","category":"symbols","batch":"5"},{"aliases":["white_medium_square"],"filename":"25fb-fe0f","category":"symbols","batch":"6"},{"aliases":["black_large_square"],"filename":"2b1b-fe0f","category":"symbols","batch":"6"},{"aliases":["white_large_square"],"filename":"2b1c-fe0f","category":"symbols","batch":"6"},{"aliases":["speaker"],"filename":"1f508","category":"symbols","batch":"6"},{"aliases":["mute"],"filename":"1f507","category":"symbols","batch":"6"},{"aliases":["sound"],"filename":"1f509","category":"symbols","batch":"6"},{"aliases":["loud_sound"],"filename":"1f50a","category":"symbols","batch":"6"},{"aliases":["bell"],"filename":"1f514","category":"symbols","batch":"6"},{"aliases":["no_bell"],"filename":"1f515","category":"symbols","batch":"6"},{"aliases":["mega"],"filename":"1f4e3","category":"symbols","batch":"6"},{"aliases":["loudspeaker"],"filename":"1f4e2","category":"symbols","batch":"6"},{"aliases":["eye_speech_bubble"],"filename":"1f441-200d-1f5e8","category":"symbols","batch":"6"},{"aliases":["speech_balloon"],"filename":"1f4ac","category":"symbols","batch":"6"},{"aliases":["thought_balloon"],"filename":"1f4ad","category":"symbols","batch":"6"},{"aliases":["right_anger_bubble"],"filename":"1f5ef","category":"symbols","batch":"6"},{"aliases":["spades"],"filename":"2660-fe0f","category":"symbols","batch":"6"},{"aliases":["clubs"],"filename":"2663-fe0f","category":"symbols","batch":"6"},{"aliases":["hearts"],"filename":"2665-fe0f","category":"symbols","batch":"6"},{"aliases":["diamonds"],"filename":"2666-fe0f","category":"symbols","batch":"6"},{"aliases":["black_joker"],"filename":"1f0cf","category":"symbols","batch":"6"},{"aliases":["flower_playing_cards"],"filename":"1f3b4","category":"symbols","batch":"6"},{"aliases":["mahjong"],"filename":"1f004-fe0f","category":"symbols","batch":"6"},{"aliases":["clock1"],"filename":"1f550","category":"symbols","batch":"6"},{"aliases":["clock2"],"filename":"1f551","category":"symbols","batch":"6"},{"aliases":["clock3"],"filename":"1f552","category":"symbols","batch":"6"},{"aliases":["clock4"],"filename":"1f553","category":"symbols","batch":"6"},{"aliases":["clock5"],"filename":"1f554","category":"symbols","batch":"6"},{"aliases":["clock6"],"filename":"1f555","category":"symbols","batch":"6"},{"aliases":["clock7"],"filename":"1f556","category":"symbols","batch":"6"},{"aliases":["clock8"],"filename":"1f557","category":"symbols","batch":"6"},{"aliases":["clock9"],"filename":"1f558","category":"symbols","batch":"6"},{"aliases":["clock10"],"filename":"1f559","category":"symbols","batch":"6"},{"aliases":["clock11"],"filename":"1f55a","category":"symbols","batch":"6"},{"aliases":["clock12"],"filename":"1f55b","category":"symbols","batch":"6"},{"aliases":["clock130"],"filename":"1f55c","category":"symbols","batch":"6"},{"aliases":["clock230"],"filename":"1f55d","category":"symbols","batch":"6"},{"aliases":["clock330"],"filename":"1f55e","category":"symbols","batch":"6"},{"aliases":["clock430"],"filename":"1f55f","category":"symbols","batch":"6"},{"aliases":["clock530"],"filename":"1f560","category":"symbols","batch":"6"},{"aliases":["clock630"],"filename":"1f561","category":"symbols","batch":"6"},{"aliases":["clock730"],"filename":"1f562","category":"symbols","batch":"6"},{"aliases":["clock830"],"filename":"1f563","category":"symbols","batch":"6"},{"aliases":["clock930"],"filename":"1f564","category":"symbols","batch":"6"},{"aliases":["clock1030"],"filename":"1f565","category":"symbols","batch":"6"},{"aliases":["clock1130"],"filename":"1f566","category":"symbols","batch":"6"},{"aliases":["clock1230"],"filename":"1f567","category":"symbols","batch":"7"},{"aliases":["white_flag"],"filename":"1f3f3-fe0f","category":"flags","batch":"1"},{"aliases":["black_flag"],"filename":"1f3f4","category":"flags","batch":"1"},{"aliases":["checkered_flag"],"filename":"1f3c1","category":"flags","batch":"1"},{"aliases":["triangular_flag_on_post"],"filename":"1f6a9","category":"flags","batch":"1"},{"aliases":["rainbow_flag"],"filename":"1f3f3-fe0f-200d-1f308","category":"flags","batch":"1"},{"aliases":["afghanistan"],"filename":"1f1e6-1f1eb","category":"flags","batch":"1"},{"aliases":["aland_islands"],"filename":"1f1e6-1f1fd","category":"flags","batch":"1"},{"aliases":["albania"],"filename":"1f1e6-1f1f1","category":"flags","batch":"1"},{"aliases":["algeria"],"filename":"1f1e9-1f1ff","category":"flags","batch":"1"},{"aliases":["american_samoa"],"filename":"1f1e6-1f1f8","category":"flags","batch":"1"},{"aliases":["andorra"],"filename":"1f1e6-1f1e9","category":"flags","batch":"1"},{"aliases":["angola"],"filename":"1f1e6-1f1f4","category":"flags","batch":"1"},{"aliases":["anguilla"],"filename":"1f1e6-1f1ee","category":"flags","batch":"1"},{"aliases":["antarctica"],"filename":"1f1e6-1f1f6","category":"flags","batch":"1"},{"aliases":["antigua_barbuda"],"filename":"1f1e6-1f1ec","category":"flags","batch":"1"},{"aliases":["argentina"],"filename":"1f1e6-1f1f7","category":"flags","batch":"1"},{"aliases":["armenia"],"filename":"1f1e6-1f1f2","category":"flags","batch":"1"},{"aliases":["aruba"],"filename":"1f1e6-1f1fc","category":"flags","batch":"1"},{"aliases":["australia"],"filename":"1f1e6-1f1fa","category":"flags","batch":"1"},{"aliases":["austria"],"filename":"1f1e6-1f1f9","category":"flags","batch":"1"},{"aliases":["azerbaijan"],"filename":"1f1e6-1f1ff","category":"flags","batch":"1"},{"aliases":["bahamas"],"filename":"1f1e7-1f1f8","category":"flags","batch":"1"},{"aliases":["bahrain"],"filename":"1f1e7-1f1ed","category":"flags","batch":"1"},{"aliases":["bangladesh"],"filename":"1f1e7-1f1e9","category":"flags","batch":"1"},{"aliases":["barbados"],"filename":"1f1e7-1f1e7","category":"flags","batch":"1"},{"aliases":["belarus"],"filename":"1f1e7-1f1fe","category":"flags","batch":"1"},{"aliases":["belgium"],"filename":"1f1e7-1f1ea","category":"flags","batch":"1"},{"aliases":["belize"],"filename":"1f1e7-1f1ff","category":"flags","batch":"1"},{"aliases":["benin"],"filename":"1f1e7-1f1ef","category":"flags","batch":"1"},{"aliases":["bermuda"],"filename":"1f1e7-1f1f2","category":"flags","batch":"1"},{"aliases":["bhutan"],"filename":"1f1e7-1f1f9","category":"flags","batch":"1"},{"aliases":["bolivia"],"filename":"1f1e7-1f1f4","category":"flags","batch":"1"},{"aliases":["caribbean_netherlands"],"filename":"1f1e7-1f1f6","category":"flags","batch":"1"},{"aliases":["bosnia_herzegovina"],"filename":"1f1e7-1f1e6","category":"flags","batch":"1"},{"aliases":["botswana"],"filename":"1f1e7-1f1fc","category":"flags","batch":"1"},{"aliases":["brazil"],"filename":"1f1e7-1f1f7","category":"flags","batch":"1"},{"aliases":["british_indian_ocean_territory"],"filename":"1f1ee-1f1f4","category":"flags","batch":"1"},{"aliases":["british_virgin_islands"],"filename":"1f1fb-1f1ec","category":"flags","batch":"1"},{"aliases":["brunei"],"filename":"1f1e7-1f1f3","category":"flags","batch":"1"},{"aliases":["bulgaria"],"filename":"1f1e7-1f1ec","category":"flags","batch":"1"},{"aliases":["burkina_faso"],"filename":"1f1e7-1f1eb","category":"flags","batch":"1"},{"aliases":["burundi"],"filename":"1f1e7-1f1ee","category":"flags","batch":"1"},{"aliases":["cape_verde"],"filename":"1f1e8-1f1fb","category":"flags","batch":"1"},{"aliases":["cambodia"],"filename":"1f1f0-1f1ed","category":"flags","batch":"1"},{"aliases":["cameroon"],"filename":"1f1e8-1f1f2","category":"flags","batch":"1"},{"aliases":["canada","ca"],"filename":"1f1e8-1f1e6","category":"flags","batch":"2"},{"aliases":["canary_islands"],"filename":"1f1ee-1f1e8","category":"flags","batch":"2"},{"aliases":["cayman_islands"],"filename":"1f1f0-1f1fe","category":"flags","batch":"2"},{"aliases":["central_african_republic"],"filename":"1f1e8-1f1eb","category":"flags","batch":"2"},{"aliases":["chad"],"filename":"1f1f9-1f1e9","category":"flags","batch":"2"},{"aliases":["chile"],"filename":"1f1e8-1f1f1","category":"flags","batch":"2"},{"aliases":["cn"],"filename":"1f1e8-1f1f3","category":"flags","batch":"2"},{"aliases":["christmas_island"],"filename":"1f1e8-1f1fd","category":"flags","batch":"2"},{"aliases":["cocos_islands"],"filename":"1f1e8-1f1e8","category":"flags","batch":"2"},{"aliases":["colombia"],"filename":"1f1e8-1f1f4","category":"flags","batch":"2"},{"aliases":["comoros"],"filename":"1f1f0-1f1f2","category":"flags","batch":"2"},{"aliases":["congo_brazzaville"],"filename":"1f1e8-1f1ec","category":"flags","batch":"2"},{"aliases":["congo_kinshasa"],"filename":"1f1e8-1f1e9","category":"flags","batch":"2"},{"aliases":["cook_islands"],"filename":"1f1e8-1f1f0","category":"flags","batch":"2"},{"aliases":["costa_rica"],"filename":"1f1e8-1f1f7","category":"flags","batch":"2"},{"aliases":["cote_divoire"],"filename":"1f1e8-1f1ee","category":"flags","batch":"2"},{"aliases":["croatia"],"filename":"1f1ed-1f1f7","category":"flags","batch":"2"},{"aliases":["cuba"],"filename":"1f1e8-1f1fa","category":"flags","batch":"2"},{"aliases":["curacao"],"filename":"1f1e8-1f1fc","category":"flags","batch":"2"},{"aliases":["cyprus"],"filename":"1f1e8-1f1fe","category":"flags","batch":"2"},{"aliases":["czech_republic"],"filename":"1f1e8-1f1ff","category":"flags","batch":"2"},{"aliases":["denmark"],"filename":"1f1e9-1f1f0","category":"flags","batch":"2"},{"aliases":["djibouti"],"filename":"1f1e9-1f1ef","category":"flags","batch":"2"},{"aliases":["dominica"],"filename":"1f1e9-1f1f2","category":"flags","batch":"2"},{"aliases":["dominican_republic"],"filename":"1f1e9-1f1f4","category":"flags","batch":"2"},{"aliases":["ecuador"],"filename":"1f1ea-1f1e8","category":"flags","batch":"2"},{"aliases":["egypt"],"filename":"1f1ea-1f1ec","category":"flags","batch":"2"},{"aliases":["el_salvador"],"filename":"1f1f8-1f1fb","category":"flags","batch":"2"},{"aliases":["equatorial_guinea"],"filename":"1f1ec-1f1f6","category":"flags","batch":"2"},{"aliases":["eritrea"],"filename":"1f1ea-1f1f7","category":"flags","batch":"2"},{"aliases":["estonia"],"filename":"1f1ea-1f1ea","category":"flags","batch":"2"},{"aliases":["ethiopia"],"filename":"1f1ea-1f1f9","category":"flags","batch":"2"},{"aliases":["eu","european_union"],"filename":"1f1ea-1f1fa","category":"flags","batch":"2"},{"aliases":["falkland_islands"],"filename":"1f1eb-1f1f0","category":"flags","batch":"2"},{"aliases":["faroe_islands"],"filename":"1f1eb-1f1f4","category":"flags","batch":"2"},{"aliases":["fiji"],"filename":"1f1eb-1f1ef","category":"flags","batch":"2"},{"aliases":["finland"],"filename":"1f1eb-1f1ee","category":"flags","batch":"2"},{"aliases":["fr"],"filename":"1f1eb-1f1f7","category":"flags","batch":"2"},{"aliases":["french_guiana"],"filename":"1f1ec-1f1eb","category":"flags","batch":"2"},{"aliases":["french_polynesia"],"filename":"1f1f5-1f1eb","category":"flags","batch":"2"},{"aliases":["french_southern_territories"],"filename":"1f1f9-1f1eb","category":"flags","batch":"2"},{"aliases":["gabon"],"filename":"1f1ec-1f1e6","category":"flags","batch":"2"},{"aliases":["gambia"],"filename":"1f1ec-1f1f2","category":"flags","batch":"2"},{"aliases":["georgia"],"filename":"1f1ec-1f1ea","category":"flags","batch":"2"},{"aliases":["de"],"filename":"1f1e9-1f1ea","category":"flags","batch":"2"},{"aliases":["ghana"],"filename":"1f1ec-1f1ed","category":"flags","batch":"3"},{"aliases":["gibraltar"],"filename":"1f1ec-1f1ee","category":"flags","batch":"3"},{"aliases":["greece"],"filename":"1f1ec-1f1f7","category":"flags","batch":"3"},{"aliases":["greenland"],"filename":"1f1ec-1f1f1","category":"flags","batch":"3"},{"aliases":["grenada"],"filename":"1f1ec-1f1e9","category":"flags","batch":"3"},{"aliases":["guadeloupe"],"filename":"1f1ec-1f1f5","category":"flags","batch":"3"},{"aliases":["guam"],"filename":"1f1ec-1f1fa","category":"flags","batch":"3"},{"aliases":["guatemala"],"filename":"1f1ec-1f1f9","category":"flags","batch":"3"},{"aliases":["guernsey"],"filename":"1f1ec-1f1ec","category":"flags","batch":"3"},{"aliases":["guinea"],"filename":"1f1ec-1f1f3","category":"flags","batch":"3"},{"aliases":["guinea_bissau"],"filename":"1f1ec-1f1fc","category":"flags","batch":"3"},{"aliases":["guyana"],"filename":"1f1ec-1f1fe","category":"flags","batch":"3"},{"aliases":["haiti"],"filename":"1f1ed-1f1f9","category":"flags","batch":"3"},{"aliases":["honduras"],"filename":"1f1ed-1f1f3","category":"flags","batch":"3"},{"aliases":["hong_kong"],"filename":"1f1ed-1f1f0","category":"flags","batch":"3"},{"aliases":["hungary"],"filename":"1f1ed-1f1fa","category":"flags","batch":"3"},{"aliases":["iceland"],"filename":"1f1ee-1f1f8","category":"flags","batch":"3"},{"aliases":["india"],"filename":"1f1ee-1f1f3","category":"flags","batch":"3"},{"aliases":["indonesia"],"filename":"1f1ee-1f1e9","category":"flags","batch":"3"},{"aliases":["iran"],"filename":"1f1ee-1f1f7","category":"flags","batch":"3"},{"aliases":["iraq"],"filename":"1f1ee-1f1f6","category":"flags","batch":"3"},{"aliases":["ireland"],"filename":"1f1ee-1f1ea","category":"flags","batch":"3"},{"aliases":["isle_of_man"],"filename":"1f1ee-1f1f2","category":"flags","batch":"3"},{"aliases":["israel"],"filename":"1f1ee-1f1f1","category":"flags","batch":"3"},{"aliases":["it"],"filename":"1f1ee-1f1f9","category":"flags","batch":"3"},{"aliases":["jamaica"],"filename":"1f1ef-1f1f2","category":"flags","batch":"3"},{"aliases":["jp"],"filename":"1f1ef-1f1f5","category":"flags","batch":"3"},{"aliases":["crossed_flags"],"filename":"1f38c","category":"flags","batch":"3"},{"aliases":["jersey"],"filename":"1f1ef-1f1ea","category":"flags","batch":"3"},{"aliases":["jordan"],"filename":"1f1ef-1f1f4","category":"flags","batch":"3"},{"aliases":["kazakhstan"],"filename":"1f1f0-1f1ff","category":"flags","batch":"3"},{"aliases":["kenya"],"filename":"1f1f0-1f1ea","category":"flags","batch":"3"},{"aliases":["kiribati"],"filename":"1f1f0-1f1ee","category":"flags","batch":"3"},{"aliases":["kosovo"],"filename":"1f1fd-1f1f0","category":"flags","batch":"3"},{"aliases":["kuwait"],"filename":"1f1f0-1f1fc","category":"flags","batch":"3"},{"aliases":["kyrgyzstan"],"filename":"1f1f0-1f1ec","category":"flags","batch":"3"},{"aliases":["laos"],"filename":"1f1f1-1f1e6","category":"flags","batch":"3"},{"aliases":["latvia"],"filename":"1f1f1-1f1fb","category":"flags","batch":"3"},{"aliases":["lebanon"],"filename":"1f1f1-1f1e7","category":"flags","batch":"3"},{"aliases":["lesotho"],"filename":"1f1f1-1f1f8","category":"flags","batch":"3"},{"aliases":["liberia"],"filename":"1f1f1-1f1f7","category":"flags","batch":"3"},{"aliases":["libya"],"filename":"1f1f1-1f1fe","category":"flags","batch":"3"},{"aliases":["liechtenstein"],"filename":"1f1f1-1f1ee","category":"flags","batch":"3"},{"aliases":["lithuania"],"filename":"1f1f1-1f1f9","category":"flags","batch":"3"},{"aliases":["luxembourg"],"filename":"1f1f1-1f1fa","category":"flags","batch":"3"},{"aliases":["macau"],"filename":"1f1f2-1f1f4","category":"flags","batch":"4"},{"aliases":["macedonia"],"filename":"1f1f2-1f1f0","category":"flags","batch":"4"},{"aliases":["madagascar"],"filename":"1f1f2-1f1ec","category":"flags","batch":"4"},{"aliases":["malawi"],"filename":"1f1f2-1f1fc","category":"flags","batch":"4"},{"aliases":["malaysia"],"filename":"1f1f2-1f1fe","category":"flags","batch":"4"},{"aliases":["maldives"],"filename":"1f1f2-1f1fb","category":"flags","batch":"4"},{"aliases":["mali"],"filename":"1f1f2-1f1f1","category":"flags","batch":"4"},{"aliases":["malta"],"filename":"1f1f2-1f1f9","category":"flags","batch":"4"},{"aliases":["marshall_islands"],"filename":"1f1f2-1f1ed","category":"flags","batch":"4"},{"aliases":["martinique"],"filename":"1f1f2-1f1f6","category":"flags","batch":"4"},{"aliases":["mauritania"],"filename":"1f1f2-1f1f7","category":"flags","batch":"4"},{"aliases":["mauritius"],"filename":"1f1f2-1f1fa","category":"flags","batch":"4"},{"aliases":["mayotte"],"filename":"1f1fe-1f1f9","category":"flags","batch":"4"},{"aliases":["mexico"],"filename":"1f1f2-1f1fd","category":"flags","batch":"4"},{"aliases":["micronesia"],"filename":"1f1eb-1f1f2","category":"flags","batch":"4"},{"aliases":["moldova"],"filename":"1f1f2-1f1e9","category":"flags","batch":"4"},{"aliases":["monaco"],"filename":"1f1f2-1f1e8","category":"flags","batch":"4"},{"aliases":["mongolia"],"filename":"1f1f2-1f1f3","category":"flags","batch":"4"},{"aliases":["montenegro"],"filename":"1f1f2-1f1ea","category":"flags","batch":"4"},{"aliases":["montserrat"],"filename":"1f1f2-1f1f8","category":"flags","batch":"4"},{"aliases":["morocco"],"filename":"1f1f2-1f1e6","category":"flags","batch":"4"},{"aliases":["mozambique"],"filename":"1f1f2-1f1ff","category":"flags","batch":"4"},{"aliases":["myanmar"],"filename":"1f1f2-1f1f2","category":"flags","batch":"4"},{"aliases":["namibia"],"filename":"1f1f3-1f1e6","category":"flags","batch":"4"},{"aliases":["nauru"],"filename":"1f1f3-1f1f7","category":"flags","batch":"4"},{"aliases":["nepal"],"filename":"1f1f3-1f1f5","category":"flags","batch":"4"},{"aliases":["netherlands"],"filename":"1f1f3-1f1f1","category":"flags","batch":"4"},{"aliases":["new_caledonia"],"filename":"1f1f3-1f1e8","category":"flags","batch":"4"},{"aliases":["new_zealand"],"filename":"1f1f3-1f1ff","category":"flags","batch":"4"},{"aliases":["nicaragua"],"filename":"1f1f3-1f1ee","category":"flags","batch":"4"},{"aliases":["niger"],"filename":"1f1f3-1f1ea","category":"flags","batch":"4"},{"aliases":["nigeria"],"filename":"1f1f3-1f1ec","category":"flags","batch":"4"},{"aliases":["niue"],"filename":"1f1f3-1f1fa","category":"flags","batch":"4"},{"aliases":["norfolk_island"],"filename":"1f1f3-1f1eb","category":"flags","batch":"4"},{"aliases":["northern_mariana_islands"],"filename":"1f1f2-1f1f5","category":"flags","batch":"4"},{"aliases":["north_korea"],"filename":"1f1f0-1f1f5","category":"flags","batch":"4"},{"aliases":["norway"],"filename":"1f1f3-1f1f4","category":"flags","batch":"4"},{"aliases":["oman"],"filename":"1f1f4-1f1f2","category":"flags","batch":"4"},{"aliases":["pakistan","pk"],"filename":"1f1f5-1f1f0","category":"flags","batch":"4"},{"aliases":["palau"],"filename":"1f1f5-1f1fc","category":"flags","batch":"4"},{"aliases":["palestinian_territories"],"filename":"1f1f5-1f1f8","category":"flags","batch":"4"},{"aliases":["panama"],"filename":"1f1f5-1f1e6","category":"flags","batch":"4"},{"aliases":["papua_new_guinea"],"filename":"1f1f5-1f1ec","category":"flags","batch":"4"},{"aliases":["paraguay"],"filename":"1f1f5-1f1fe","category":"flags","batch":"4"},{"aliases":["peru"],"filename":"1f1f5-1f1ea","category":"flags","batch":"4"},{"aliases":["philippines"],"filename":"1f1f5-1f1ed","category":"flags","batch":"5"},{"aliases":["pitcairn_islands"],"filename":"1f1f5-1f1f3","category":"flags","batch":"5"},{"aliases":["poland"],"filename":"1f1f5-1f1f1","category":"flags","batch":"5"},{"aliases":["portugal"],"filename":"1f1f5-1f1f9","category":"flags","batch":"5"},{"aliases":["puerto_rico"],"filename":"1f1f5-1f1f7","category":"flags","batch":"5"},{"aliases":["qatar"],"filename":"1f1f6-1f1e6","category":"flags","batch":"5"},{"aliases":["reunion"],"filename":"1f1f7-1f1ea","category":"flags","batch":"5"},{"aliases":["romania"],"filename":"1f1f7-1f1f4","category":"flags","batch":"5"},{"aliases":["ru"],"filename":"1f1f7-1f1fa","category":"flags","batch":"5"},{"aliases":["rwanda"],"filename":"1f1f7-1f1fc","category":"flags","batch":"5"},{"aliases":["st_barthelemy"],"filename":"1f1e7-1f1f1","category":"flags","batch":"5"},{"aliases":["st_helena"],"filename":"1f1f8-1f1ed","category":"flags","batch":"5"},{"aliases":["st_kitts_nevis"],"filename":"1f1f0-1f1f3","category":"flags","batch":"5"},{"aliases":["st_lucia"],"filename":"1f1f1-1f1e8","category":"flags","batch":"5"},{"aliases":["st_pierre_miquelon"],"filename":"1f1f5-1f1f2","category":"flags","batch":"5"},{"aliases":["st_vincent_grenadines"],"filename":"1f1fb-1f1e8","category":"flags","batch":"5"},{"aliases":["samoa"],"filename":"1f1fc-1f1f8","category":"flags","batch":"5"},{"aliases":["san_marino"],"filename":"1f1f8-1f1f2","category":"flags","batch":"5"},{"aliases":["sao_tome_principe"],"filename":"1f1f8-1f1f9","category":"flags","batch":"5"},{"aliases":["saudi_arabia"],"filename":"1f1f8-1f1e6","category":"flags","batch":"5"},{"aliases":["senegal"],"filename":"1f1f8-1f1f3","category":"flags","batch":"5"},{"aliases":["serbia"],"filename":"1f1f7-1f1f8","category":"flags","batch":"5"},{"aliases":["seychelles"],"filename":"1f1f8-1f1e8","category":"flags","batch":"5"},{"aliases":["sierra_leone"],"filename":"1f1f8-1f1f1","category":"flags","batch":"5"},{"aliases":["singapore"],"filename":"1f1f8-1f1ec","category":"flags","batch":"5"},{"aliases":["sint_maarten"],"filename":"1f1f8-1f1fd","category":"flags","batch":"5"},{"aliases":["slovakia"],"filename":"1f1f8-1f1f0","category":"flags","batch":"5"},{"aliases":["slovenia"],"filename":"1f1f8-1f1ee","category":"flags","batch":"5"},{"aliases":["solomon_islands"],"filename":"1f1f8-1f1e7","category":"flags","batch":"5"},{"aliases":["somalia"],"filename":"1f1f8-1f1f4","category":"flags","batch":"5"},{"aliases":["south_africa","za"],"filename":"1f1ff-1f1e6","category":"flags","batch":"5"},{"aliases":["south_georgia_south_sandwich_islands"],"filename":"1f1ec-1f1f8","category":"flags","batch":"5"},{"aliases":["kr"],"filename":"1f1f0-1f1f7","category":"flags","batch":"5"},{"aliases":["south_sudan"],"filename":"1f1f8-1f1f8","category":"flags","batch":"5"},{"aliases":["es"],"filename":"1f1ea-1f1f8","category":"flags","batch":"5"},{"aliases":["sri_lanka"],"filename":"1f1f1-1f1f0","category":"flags","batch":"5"},{"aliases":["sudan"],"filename":"1f1f8-1f1e9","category":"flags","batch":"5"},{"aliases":["suriname"],"filename":"1f1f8-1f1f7","category":"flags","batch":"5"},{"aliases":["swaziland"],"filename":"1f1f8-1f1ff","category":"flags","batch":"5"},{"aliases":["sweden"],"filename":"1f1f8-1f1ea","category":"flags","batch":"5"},{"aliases":["switzerland"],"filename":"1f1e8-1f1ed","category":"flags","batch":"5"},{"aliases":["syria"],"filename":"1f1f8-1f1fe","category":"flags","batch":"5"},{"aliases":["taiwan"],"filename":"1f1f9-1f1fc","category":"flags","batch":"5"},{"aliases":["tajikistan"],"filename":"1f1f9-1f1ef","category":"flags","batch":"5"},{"aliases":["tanzania"],"filename":"1f1f9-1f1ff","category":"flags","batch":"5"},{"aliases":["thailand"],"filename":"1f1f9-1f1ed","category":"flags","batch":"6"},{"aliases":["timor_leste"],"filename":"1f1f9-1f1f1","category":"flags","batch":"6"},{"aliases":["togo"],"filename":"1f1f9-1f1ec","category":"flags","batch":"6"},{"aliases":["tokelau"],"filename":"1f1f9-1f1f0","category":"flags","batch":"6"},{"aliases":["tonga"],"filename":"1f1f9-1f1f4","category":"flags","batch":"6"},{"aliases":["trinidad_tobago"],"filename":"1f1f9-1f1f9","category":"flags","batch":"6"},{"aliases":["tunisia"],"filename":"1f1f9-1f1f3","category":"flags","batch":"6"},{"aliases":["tr"],"filename":"1f1f9-1f1f7","category":"flags","batch":"6"},{"aliases":["turkmenistan"],"filename":"1f1f9-1f1f2","category":"flags","batch":"6"},{"aliases":["turks_caicos_islands"],"filename":"1f1f9-1f1e8","category":"flags","batch":"6"},{"aliases":["tuvalu"],"filename":"1f1f9-1f1fb","category":"flags","batch":"6"},{"aliases":["uganda"],"filename":"1f1fa-1f1ec","category":"flags","batch":"6"},{"aliases":["ukraine"],"filename":"1f1fa-1f1e6","category":"flags","batch":"6"},{"aliases":["united_arab_emirates"],"filename":"1f1e6-1f1ea","category":"flags","batch":"6"},{"aliases":["gb","uk"],"filename":"1f1ec-1f1e7","category":"flags","batch":"6"},{"aliases":["us"],"filename":"1f1fa-1f1f8","category":"flags","batch":"6"},{"aliases":["us_virgin_islands"],"filename":"1f1fb-1f1ee","category":"flags","batch":"6"},{"aliases":["uruguay"],"filename":"1f1fa-1f1fe","category":"flags","batch":"6"},{"aliases":["uzbekistan"],"filename":"1f1fa-1f1ff","category":"flags","batch":"6"},{"aliases":["vanuatu"],"filename":"1f1fb-1f1fa","category":"flags","batch":"6"},{"aliases":["vatican_city"],"filename":"1f1fb-1f1e6","category":"flags","batch":"6"},{"aliases":["venezuela"],"filename":"1f1fb-1f1ea","category":"flags","batch":"6"},{"aliases":["vietnam"],"filename":"1f1fb-1f1f3","category":"flags","batch":"6"},{"aliases":["wallis_futuna"],"filename":"1f1fc-1f1eb","category":"flags","batch":"6"},{"aliases":["western_sahara"],"filename":"1f1ea-1f1ed","category":"flags","batch":"6"},{"aliases":["yemen"],"filename":"1f1fe-1f1ea","category":"flags","batch":"6"},{"aliases":["zambia"],"filename":"1f1ff-1f1f2","category":"flags","batch":"6"},{"aliases":["zimbabwe"],"filename":"1f1ff-1f1fc","category":"flags","batch":"6"},{"aliases":["bowtie"],"filename":"bowtie","category":"custom","batch":"1"},{"aliases":["feelsgood"],"filename":"feelsgood","category":"custom","batch":"1"},{"aliases":["finnadie"],"filename":"finnadie","category":"custom","batch":"1"},{"aliases":["goberserk"],"filename":"goberserk","category":"custom","batch":"1"},{"aliases":["godmode"],"filename":"godmode","category":"custom","batch":"1"},{"aliases":["hurtrealbad"],"filename":"hurtrealbad","category":"custom","batch":"1"},{"aliases":["neckbeard"],"filename":"neckbeard","category":"custom","batch":"1"},{"aliases":["octocat"],"filename":"octocat","category":"custom","batch":"1"},{"aliases":["rage1"],"filename":"rage1","category":"custom","batch":"1"},{"aliases":["rage2"],"filename":"rage2","category":"custom","batch":"1"},{"aliases":["rage3"],"filename":"rage3","category":"custom","batch":"1"},{"aliases":["rage4"],"filename":"rage4","category":"custom","batch":"1"},{"aliases":["shipit","squirrel"],"filename":"shipit","category":"custom","batch":"1"},{"aliases":["suspect"],"filename":"suspect","category":"custom","batch":"1"},{"aliases":["trollface"],"filename":"trollface","category":"custom","batch":"1"},{"aliases":["mattermost"],"filename":"mattermost","category":"custom","batch":"1"},{"aliases":["open_hands_light_skin_tone"],"filename":"1f450-1f3fb","category":"skintone","batch":"1"},{"aliases":["open_hands_medium_light_skin_tone"],"filename":"1f450-1f3fc","category":"skintone","batch":"1"},{"aliases":["open_hands_medium_skin_tone"],"filename":"1f450-1f3fd","category":"skintone","batch":"1"},{"aliases":["open_hands_medium_dark_skin_tone"],"filename":"1f450-1f3fe","category":"skintone","batch":"1"},{"aliases":["open_hands_dark_skin_tone"],"filename":"1f450-1f3ff","category":"skintone","batch":"1"},{"aliases":["raised_hands_light_skin_tone"],"filename":"1f64c-1f3fb","category":"skintone","batch":"1"},{"aliases":["raised_hands_medium_light_skin_tone"],"filename":"1f64c-1f3fc","category":"skintone","batch":"1"},{"aliases":["raised_hands_medium_skin_tone"],"filename":"1f64c-1f3fd","category":"skintone","batch":"1"},{"aliases":["raised_hands_medium_dark_skin_tone"],"filename":"1f64c-1f3fe","category":"skintone","batch":"1"},{"aliases":["raised_hands_dark_skin_tone"],"filename":"1f64c-1f3ff","category":"skintone","batch":"1"},{"aliases":["clap_light_skin_tone"],"filename":"1f44f-1f3fb","category":"skintone","batch":"1"},{"aliases":["clap_medium_light_skin_tone"],"filename":"1f44f-1f3fc","category":"skintone","batch":"1"},{"aliases":["clap_medium_skin_tone"],"filename":"1f44f-1f3fd","category":"skintone","batch":"1"},{"aliases":["clap_medium_dark_skin_tone"],"filename":"1f44f-1f3fe","category":"skintone","batch":"1"},{"aliases":["clap_dark_skin_tone"],"filename":"1f44f-1f3ff","category":"skintone","batch":"1"},{"aliases":["pray_light_skin_tone"],"filename":"1f64f-1f3fb","category":"skintone","batch":"1"},{"aliases":["pray_medium_light_skin_tone"],"filename":"1f64f-1f3fc","category":"skintone","batch":"1"},{"aliases":["pray_medium_skin_tone"],"filename":"1f64f-1f3fd","category":"skintone","batch":"1"},{"aliases":["pray_medium_dark_skin_tone"],"filename":"1f64f-1f3fe","category":"skintone","batch":"1"},{"aliases":["pray_dark_skin_tone"],"filename":"1f64f-1f3ff","category":"skintone","batch":"1"},{"aliases":["+1_light_skin_tone"],"filename":"1f44d-1f3fb","category":"skintone","batch":"1"},{"aliases":["+1_medium_light_skin_tone"],"filename":"1f44d-1f3fc","category":"skintone","batch":"1"},{"aliases":["+1_medium_skin_tone"],"filename":"1f44d-1f3fd","category":"skintone","batch":"1"},{"aliases":["+1_medium_dark_skin_tone"],"filename":"1f44d-1f3fe","category":"skintone","batch":"1"},{"aliases":["+1_dark_skin_tone"],"filename":"1f44d-1f3ff","category":"skintone","batch":"1"},{"aliases":["-1_light_skin_tone"],"filename":"1f44e-1f3fb","category":"skintone","batch":"1"},{"aliases":["-1_medium_light_skin_tone"],"filename":"1f44e-1f3fc","category":"skintone","batch":"1"},{"aliases":["-1_medium_skin_tone"],"filename":"1f44e-1f3fd","category":"skintone","batch":"1"},{"aliases":["-1_medium_dark_skin_tone"],"filename":"1f44e-1f3fe","category":"skintone","batch":"1"},{"aliases":["-1_dark_skin_tone"],"filename":"1f44e-1f3ff","category":"skintone","batch":"1"},{"aliases":["fist_oncoming_light_skin_tone"],"filename":"1f44a-1f3fb","category":"skintone","batch":"1"},{"aliases":["fist_oncoming_medium_light_skin_tone"],"filename":"1f44a-1f3fc","category":"skintone","batch":"1"},{"aliases":["fist_oncoming_medium_skin_tone"],"filename":"1f44a-1f3fd","category":"skintone","batch":"1"},{"aliases":["fist_oncoming_medium_dark_skin_tone"],"filename":"1f44a-1f3fe","category":"skintone","batch":"1"},{"aliases":["fist_oncoming_dark_skin_tone"],"filename":"1f44a-1f3ff","category":"skintone","batch":"1"},{"aliases":["fist_raised_light_skin_tone"],"filename":"270a-1f3fb","category":"skintone","batch":"1"},{"aliases":["fist_raised_medium_light_skin_tone"],"filename":"270a-1f3fc","category":"skintone","batch":"1"},{"aliases":["fist_raised_medium_skin_tone"],"filename":"270a-1f3fd","category":"skintone","batch":"1"},{"aliases":["fist_raised_medium_dark_skin_tone"],"filename":"270a-1f3fe","category":"skintone","batch":"1"},{"aliases":["fist_raised_dark_skin_tone"],"filename":"270a-1f3ff","category":"skintone","batch":"1"},{"aliases":["fist_left_light_skin_tone"],"filename":"1f91b-1f3fb","category":"skintone","batch":"1"},{"aliases":["fist_left_medium_light_skin_tone"],"filename":"1f91b-1f3fc","category":"skintone","batch":"1"},{"aliases":["fist_left_medium_skin_tone"],"filename":"1f91b-1f3fd","category":"skintone","batch":"1"},{"aliases":["fist_left_medium_dark_skin_tone"],"filename":"1f91b-1f3fe","category":"skintone","batch":"1"},{"aliases":["fist_left_dark_skin_tone"],"filename":"1f91b-1f3ff","category":"skintone","batch":"1"},{"aliases":["fist_right_light_skin_tone"],"filename":"1f91c-1f3fb","category":"skintone","batch":"2"},{"aliases":["fist_right_medium_light_skin_tone"],"filename":"1f91c-1f3fc","category":"skintone","batch":"2"},{"aliases":["fist_right_medium_skin_tone"],"filename":"1f91c-1f3fd","category":"skintone","batch":"2"},{"aliases":["fist_right_medium_dark_skin_tone"],"filename":"1f91c-1f3fe","category":"skintone","batch":"2"},{"aliases":["fist_right_dark_skin_tone"],"filename":"1f91c-1f3ff","category":"skintone","batch":"2"},{"aliases":["crossed_fingers_light_skin_tone"],"filename":"1f91e-1f3fb","category":"skintone","batch":"2"},{"aliases":["crossed_fingers_medium_light_skin_tone"],"filename":"1f91e-1f3fc","category":"skintone","batch":"2"},{"aliases":["crossed_fingers_medium_skin_tone"],"filename":"1f91e-1f3fd","category":"skintone","batch":"2"},{"aliases":["crossed_fingers_medium_dark_skin_tone"],"filename":"1f91e-1f3fe","category":"skintone","batch":"2"},{"aliases":["crossed_fingers_dark_skin_tone"],"filename":"1f91e-1f3ff","category":"skintone","batch":"2"},{"aliases":["v_light_skin_tone"],"filename":"270c-1f3fb","category":"skintone","batch":"2"},{"aliases":["v_medium_light_skin_tone"],"filename":"270c-1f3fc","category":"skintone","batch":"2"},{"aliases":["v_medium_skin_tone"],"filename":"270c-1f3fd","category":"skintone","batch":"2"},{"aliases":["v_medium_dark_skin_tone"],"filename":"270c-1f3fe","category":"skintone","batch":"2"},{"aliases":["v_dark_skin_tone"],"filename":"270c-1f3ff","category":"skintone","batch":"2"},{"aliases":["metal_light_skin_tone"],"filename":"1f918-1f3fb","category":"skintone","batch":"2"},{"aliases":["metal_medium_light_skin_tone"],"filename":"1f918-1f3fc","category":"skintone","batch":"2"},{"aliases":["metal_medium_skin_tone"],"filename":"1f918-1f3fd","category":"skintone","batch":"2"},{"aliases":["metal_medium_dark_skin_tone"],"filename":"1f918-1f3fe","category":"skintone","batch":"2"},{"aliases":["metal_dark_skin_tone"],"filename":"1f918-1f3ff","category":"skintone","batch":"2"},{"aliases":["ok_hand_light_skin_tone"],"filename":"1f44c-1f3fb","category":"skintone","batch":"2"},{"aliases":["ok_hand_medium_light_skin_tone"],"filename":"1f44c-1f3fc","category":"skintone","batch":"2"},{"aliases":["ok_hand_medium_skin_tone"],"filename":"1f44c-1f3fd","category":"skintone","batch":"2"},{"aliases":["ok_hand_medium_dark_skin_tone"],"filename":"1f44c-1f3fe","category":"skintone","batch":"2"},{"aliases":["ok_hand_dark_skin_tone"],"filename":"1f44c-1f3ff","category":"skintone","batch":"2"},{"aliases":["point_left_light_skin_tone"],"filename":"1f448-1f3fb","category":"skintone","batch":"2"},{"aliases":["point_left_medium_light_skin_tone"],"filename":"1f448-1f3fc","category":"skintone","batch":"2"},{"aliases":["point_left_medium_skin_tone"],"filename":"1f448-1f3fd","category":"skintone","batch":"2"},{"aliases":["point_left_medium_dark_skin_tone"],"filename":"1f448-1f3fe","category":"skintone","batch":"2"},{"aliases":["point_left_dark_skin_tone"],"filename":"1f448-1f3ff","category":"skintone","batch":"2"},{"aliases":["point_right_light_skin_tone"],"filename":"1f449-1f3fb","category":"skintone","batch":"2"},{"aliases":["point_right_medium_light_skin_tone"],"filename":"1f449-1f3fc","category":"skintone","batch":"2"},{"aliases":["point_right_medium_skin_tone"],"filename":"1f449-1f3fd","category":"skintone","batch":"2"},{"aliases":["point_right_medium_dark_skin_tone"],"filename":"1f449-1f3fe","category":"skintone","batch":"2"},{"aliases":["point_right_dark_skin_tone"],"filename":"1f449-1f3ff","category":"skintone","batch":"2"},{"aliases":["point_up_2_light_skin_tone"],"filename":"1f446-1f3fb","category":"skintone","batch":"2"},{"aliases":["point_up_2_medium_light_skin_tone"],"filename":"1f446-1f3fc","category":"skintone","batch":"2"},{"aliases":["point_up_2_medium_skin_tone"],"filename":"1f446-1f3fd","category":"skintone","batch":"2"},{"aliases":["point_up_2_medium_dark_skin_tone"],"filename":"1f446-1f3fe","category":"skintone","batch":"2"},{"aliases":["point_up_2_dark_skin_tone"],"filename":"1f446-1f3ff","category":"skintone","batch":"2"},{"aliases":["point_down_light_skin_tone"],"filename":"1f447-1f3fb","category":"skintone","batch":"2"},{"aliases":["point_down_medium_light_skin_tone"],"filename":"1f447-1f3fc","category":"skintone","batch":"2"},{"aliases":["point_down_medium_skin_tone"],"filename":"1f447-1f3fd","category":"skintone","batch":"2"},{"aliases":["point_down_medium_dark_skin_tone"],"filename":"1f447-1f3fe","category":"skintone","batch":"2"},{"aliases":["point_down_dark_skin_tone"],"filename":"1f447-1f3ff","category":"skintone","batch":"2"},{"aliases":["point_up_light_skin_tone"],"filename":"261d-1f3fb","category":"skintone","batch":"3"},{"aliases":["point_up_medium_light_skin_tone"],"filename":"261d-1f3fc","category":"skintone","batch":"3"},{"aliases":["point_up_medium_skin_tone"],"filename":"261d-1f3fd","category":"skintone","batch":"3"},{"aliases":["point_up_medium_dark_skin_tone"],"filename":"261d-1f3fe","category":"skintone","batch":"3"},{"aliases":["point_up_dark_skin_tone"],"filename":"261d-1f3ff","category":"skintone","batch":"3"},{"aliases":["hand_light_skin_tone"],"filename":"270b-1f3fb","category":"skintone","batch":"3"},{"aliases":["hand_medium_light_skin_tone"],"filename":"270b-1f3fc","category":"skintone","batch":"3"},{"aliases":["hand_medium_skin_tone"],"filename":"270b-1f3fd","category":"skintone","batch":"3"},{"aliases":["hand_medium_dark_skin_tone"],"filename":"270b-1f3fe","category":"skintone","batch":"3"},{"aliases":["hand_dark_skin_tone"],"filename":"270b-1f3ff","category":"skintone","batch":"3"},{"aliases":["raised_back_of_hand_light_skin_tone"],"filename":"1f91a-1f3fb","category":"skintone","batch":"3"},{"aliases":["raised_back_of_hand_medium_light_skin_tone"],"filename":"1f91a-1f3fc","category":"skintone","batch":"3"},{"aliases":["raised_back_of_hand_medium_skin_tone"],"filename":"1f91a-1f3fd","category":"skintone","batch":"3"},{"aliases":["raised_back_of_hand_medium_dark_skin_tone"],"filename":"1f91a-1f3fe","category":"skintone","batch":"3"},{"aliases":["raised_back_of_hand_dark_skin_tone"],"filename":"1f91a-1f3ff","category":"skintone","batch":"3"},{"aliases":["raised_hand_with_fingers_splayed_light_skin_tone"],"filename":"1f590-1f3fb","category":"skintone","batch":"3"},{"aliases":["raised_hand_with_fingers_splayed_medium_light_skin_tone"],"filename":"1f590-1f3fc","category":"skintone","batch":"3"},{"aliases":["raised_hand_with_fingers_splayed_medium_skin_tone"],"filename":"1f590-1f3fd","category":"skintone","batch":"3"},{"aliases":["raised_hand_with_fingers_splayed_medium_dark_skin_tone"],"filename":"1f590-1f3fe","category":"skintone","batch":"3"},{"aliases":["raised_hand_with_fingers_splayed_dark_skin_tone"],"filename":"1f590-1f3ff","category":"skintone","batch":"3"},{"aliases":["vulcan_salute_light_skin_tone"],"filename":"1f596-1f3fb","category":"skintone","batch":"3"},{"aliases":["vulcan_salute_medium_light_skin_tone"],"filename":"1f596-1f3fc","category":"skintone","batch":"3"},{"aliases":["vulcan_salute_medium_skin_tone"],"filename":"1f596-1f3fd","category":"skintone","batch":"3"},{"aliases":["vulcan_salute_medium_dark_skin_tone"],"filename":"1f596-1f3fe","category":"skintone","batch":"3"},{"aliases":["vulcan_salute_dark_skin_tone"],"filename":"1f596-1f3ff","category":"skintone","batch":"3"},{"aliases":["wave_light_skin_tone"],"filename":"1f44b-1f3fb","category":"skintone","batch":"3"},{"aliases":["wave_medium_light_skin_tone"],"filename":"1f44b-1f3fc","category":"skintone","batch":"3"},{"aliases":["wave_medium_skin_tone"],"filename":"1f44b-1f3fd","category":"skintone","batch":"3"},{"aliases":["wave_medium_dark_skin_tone"],"filename":"1f44b-1f3fe","category":"skintone","batch":"3"},{"aliases":["wave_dark_skin_tone"],"filename":"1f44b-1f3ff","category":"skintone","batch":"3"},{"aliases":["call_me_hand_light_skin_tone"],"filename":"1f919-1f3fb","category":"skintone","batch":"3"},{"aliases":["call_me_hand_medium_light_skin_tone"],"filename":"1f919-1f3fc","category":"skintone","batch":"3"},{"aliases":["call_me_hand_medium_skin_tone"],"filename":"1f919-1f3fd","category":"skintone","batch":"3"},{"aliases":["call_me_hand_medium_dark_skin_tone"],"filename":"1f919-1f3fe","category":"skintone","batch":"3"},{"aliases":["call_me_hand_dark_skin_tone"],"filename":"1f919-1f3ff","category":"skintone","batch":"3"},{"aliases":["muscle_light_skin_tone"],"filename":"1f4aa-1f3fb","category":"skintone","batch":"3"},{"aliases":["muscle_medium_light_skin_tone"],"filename":"1f4aa-1f3fc","category":"skintone","batch":"3"},{"aliases":["muscle_medium_skin_tone"],"filename":"1f4aa-1f3fd","category":"skintone","batch":"3"},{"aliases":["muscle_medium_dark_skin_tone"],"filename":"1f4aa-1f3fe","category":"skintone","batch":"3"},{"aliases":["muscle_dark_skin_tone"],"filename":"1f4aa-1f3ff","category":"skintone","batch":"3"},{"aliases":["middle_finger_light_skin_tone"],"filename":"1f595-1f3fb","category":"skintone","batch":"3"},{"aliases":["middle_finger_medium_light_skin_tone"],"filename":"1f595-1f3fc","category":"skintone","batch":"3"},{"aliases":["middle_finger_medium_skin_tone"],"filename":"1f595-1f3fd","category":"skintone","batch":"3"},{"aliases":["middle_finger_medium_dark_skin_tone"],"filename":"1f595-1f3fe","category":"skintone","batch":"3"},{"aliases":["middle_finger_dark_skin_tone"],"filename":"1f595-1f3ff","category":"skintone","batch":"3"},{"aliases":["writing_hand_light_skin_tone"],"filename":"270d-1f3fb","category":"skintone","batch":"4"},{"aliases":["writing_hand_medium_light_skin_tone"],"filename":"270d-1f3fc","category":"skintone","batch":"4"},{"aliases":["writing_hand_medium_skin_tone"],"filename":"270d-1f3fd","category":"skintone","batch":"4"},{"aliases":["writing_hand_medium_dark_skin_tone"],"filename":"270d-1f3fe","category":"skintone","batch":"4"},{"aliases":["writing_hand_dark_skin_tone"],"filename":"270d-1f3ff","category":"skintone","batch":"4"},{"aliases":["selfie_light_skin_tone"],"filename":"1f933-1f3fb","category":"skintone","batch":"4"},{"aliases":["selfie_medium_light_skin_tone"],"filename":"1f933-1f3fc","category":"skintone","batch":"4"},{"aliases":["selfie_medium_skin_tone"],"filename":"1f933-1f3fd","category":"skintone","batch":"4"},{"aliases":["selfie_medium_dark_skin_tone"],"filename":"1f933-1f3fe","category":"skintone","batch":"4"},{"aliases":["selfie_dark_skin_tone"],"filename":"1f933-1f3ff","category":"skintone","batch":"4"},{"aliases":["nail_care_light_skin_tone"],"filename":"1f485-1f3fb","category":"skintone","batch":"4"},{"aliases":["nail_care_medium_light_skin_tone"],"filename":"1f485-1f3fc","category":"skintone","batch":"4"},{"aliases":["nail_care_medium_skin_tone"],"filename":"1f485-1f3fd","category":"skintone","batch":"4"},{"aliases":["nail_care_medium_dark_skin_tone"],"filename":"1f485-1f3fe","category":"skintone","batch":"4"},{"aliases":["nail_care_dark_skin_tone"],"filename":"1f485-1f3ff","category":"skintone","batch":"4"},{"aliases":["ear_light_skin_tone"],"filename":"1f442-1f3fb","category":"skintone","batch":"4"},{"aliases":["ear_medium_light_skin_tone"],"filename":"1f442-1f3fc","category":"skintone","batch":"4"},{"aliases":["ear_medium_skin_tone"],"filename":"1f442-1f3fd","category":"skintone","batch":"4"},{"aliases":["ear_medium_dark_skin_tone"],"filename":"1f442-1f3fe","category":"skintone","batch":"4"},{"aliases":["ear_dark_skin_tone"],"filename":"1f442-1f3ff","category":"skintone","batch":"4"},{"aliases":["nose_light_skin_tone"],"filename":"1f443-1f3fb","category":"skintone","batch":"4"},{"aliases":["nose_medium_light_skin_tone"],"filename":"1f443-1f3fc","category":"skintone","batch":"4"},{"aliases":["nose_medium_skin_tone"],"filename":"1f443-1f3fd","category":"skintone","batch":"4"},{"aliases":["nose_medium_dark_skin_tone"],"filename":"1f443-1f3fe","category":"skintone","batch":"4"},{"aliases":["nose_dark_skin_tone"],"filename":"1f443-1f3ff","category":"skintone","batch":"4"},{"aliases":["baby_light_skin_tone"],"filename":"1f476-1f3fb","category":"skintone","batch":"4"},{"aliases":["baby_medium_light_skin_tone"],"filename":"1f476-1f3fc","category":"skintone","batch":"4"},{"aliases":["baby_medium_skin_tone"],"filename":"1f476-1f3fd","category":"skintone","batch":"4"},{"aliases":["baby_medium_dark_skin_tone"],"filename":"1f476-1f3fe","category":"skintone","batch":"4"},{"aliases":["baby_dark_skin_tone"],"filename":"1f476-1f3ff","category":"skintone","batch":"4"},{"aliases":["boy_light_skin_tone"],"filename":"1f466-1f3fb","category":"skintone","batch":"4"},{"aliases":["boy_medium_light_skin_tone"],"filename":"1f466-1f3fc","category":"skintone","batch":"4"},{"aliases":["boy_medium_skin_tone"],"filename":"1f466-1f3fd","category":"skintone","batch":"4"},{"aliases":["boy_medium_dark_skin_tone"],"filename":"1f466-1f3fe","category":"skintone","batch":"4"},{"aliases":["boy_dark_skin_tone"],"filename":"1f466-1f3ff","category":"skintone","batch":"4"},{"aliases":["girl_light_skin_tone"],"filename":"1f467-1f3fb","category":"skintone","batch":"4"},{"aliases":["girl_medium_light_skin_tone"],"filename":"1f467-1f3fc","category":"skintone","batch":"4"},{"aliases":["girl_medium_skin_tone"],"filename":"1f467-1f3fd","category":"skintone","batch":"4"},{"aliases":["girl_medium_dark_skin_tone"],"filename":"1f467-1f3fe","category":"skintone","batch":"4"},{"aliases":["girl_dark_skin_tone"],"filename":"1f467-1f3ff","category":"skintone","batch":"4"},{"aliases":["man_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"4"},{"aliases":["man_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"4"},{"aliases":["man_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"4"},{"aliases":["man_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"4"},{"aliases":["man_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"4"},{"aliases":["woman_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"5"},{"aliases":["woman_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"5"},{"aliases":["woman_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"5"},{"aliases":["woman_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"5"},{"aliases":["woman_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"5"},{"aliases":["blonde_woman_light_skin_tone"],"filename":"1f471-1f3fb","category":"skintone","batch":"5"},{"aliases":["blonde_woman_medium_light_skin_tone"],"filename":"1f471-1f3fc","category":"skintone","batch":"5"},{"aliases":["blonde_woman_medium_skin_tone"],"filename":"1f471-1f3fd","category":"skintone","batch":"5"},{"aliases":["blonde_woman_medium_dark_skin_tone"],"filename":"1f471-1f3fe","category":"skintone","batch":"5"},{"aliases":["blonde_woman_dark_skin_tone"],"filename":"1f471-1f3ff","category":"skintone","batch":"5"},{"aliases":["blonde_woman_light_skin_tone"],"filename":"1f471-1f3fb-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["blonde_woman_medium_light_skin_tone"],"filename":"1f471-1f3fc-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["blonde_woman_medium_skin_tone"],"filename":"1f471-1f3fd-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["blonde_woman_medium_dark_skin_tone"],"filename":"1f471-1f3fe-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["blonde_woman_dark_skin_tone"],"filename":"1f471-1f3ff-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["blonde_man_light_skin_tone"],"filename":"1f471-1f3fb","category":"skintone","batch":"5"},{"aliases":["blonde_man_medium_light_skin_tone"],"filename":"1f471-1f3fc","category":"skintone","batch":"5"},{"aliases":["blonde_man_medium_skin_tone"],"filename":"1f471-1f3fd","category":"skintone","batch":"5"},{"aliases":["blonde_man_medium_dark_skin_tone"],"filename":"1f471-1f3fe","category":"skintone","batch":"5"},{"aliases":["blonde_man_dark_skin_tone"],"filename":"1f471-1f3ff","category":"skintone","batch":"5"},{"aliases":["blonde_man_light_skin_tone"],"filename":"1f471-1f3fb-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["blonde_man_medium_light_skin_tone"],"filename":"1f471-1f3fc-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["blonde_man_medium_skin_tone"],"filename":"1f471-1f3fd-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["blonde_man_medium_dark_skin_tone"],"filename":"1f471-1f3fe-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["blonde_man_dark_skin_tone"],"filename":"1f471-1f3ff-200d-2640-fe0f","category":"skintone","batch":"5"},{"aliases":["older_man_light_skin_tone"],"filename":"1f474-1f3fb","category":"skintone","batch":"5"},{"aliases":["older_man_medium_light_skin_tone"],"filename":"1f474-1f3fc","category":"skintone","batch":"5"},{"aliases":["older_man_medium_skin_tone"],"filename":"1f474-1f3fd","category":"skintone","batch":"5"},{"aliases":["older_man_medium_dark_skin_tone"],"filename":"1f474-1f3fe","category":"skintone","batch":"5"},{"aliases":["older_man_dark_skin_tone"],"filename":"1f474-1f3ff","category":"skintone","batch":"5"},{"aliases":["older_woman_light_skin_tone"],"filename":"1f475-1f3fb","category":"skintone","batch":"5"},{"aliases":["older_woman_medium_light_skin_tone"],"filename":"1f475-1f3fc","category":"skintone","batch":"5"},{"aliases":["older_woman_medium_skin_tone"],"filename":"1f475-1f3fd","category":"skintone","batch":"5"},{"aliases":["older_woman_medium_dark_skin_tone"],"filename":"1f475-1f3fe","category":"skintone","batch":"5"},{"aliases":["older_woman_dark_skin_tone"],"filename":"1f475-1f3ff","category":"skintone","batch":"5"},{"aliases":["man_with_gua_pi_mao_light_skin_tone"],"filename":"1f472-1f3fb","category":"skintone","batch":"5"},{"aliases":["man_with_gua_pi_mao_medium_light_skin_tone"],"filename":"1f472-1f3fc","category":"skintone","batch":"5"},{"aliases":["man_with_gua_pi_mao_medium_skin_tone"],"filename":"1f472-1f3fd","category":"skintone","batch":"5"},{"aliases":["man_with_gua_pi_mao_medium_dark_skin_tone"],"filename":"1f472-1f3fe","category":"skintone","batch":"5"},{"aliases":["man_with_gua_pi_mao_dark_skin_tone"],"filename":"1f472-1f3ff","category":"skintone","batch":"5"},{"aliases":["woman_with_turban_light_skin_tone"],"filename":"1f473-1f3fb","category":"skintone","batch":"5"},{"aliases":["woman_with_turban_medium_light_skin_tone"],"filename":"1f473-1f3fc","category":"skintone","batch":"5"},{"aliases":["woman_with_turban_medium_skin_tone"],"filename":"1f473-1f3fd","category":"skintone","batch":"5"},{"aliases":["woman_with_turban_medium_dark_skin_tone"],"filename":"1f473-1f3fe","category":"skintone","batch":"5"},{"aliases":["woman_with_turban_dark_skin_tone"],"filename":"1f473-1f3ff","category":"skintone","batch":"5"},{"aliases":["woman_with_turban_light_skin_tone"],"filename":"1f473-1f3fb-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["woman_with_turban_medium_light_skin_tone"],"filename":"1f473-1f3fc-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["woman_with_turban_medium_skin_tone"],"filename":"1f473-1f3fd-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["woman_with_turban_medium_dark_skin_tone"],"filename":"1f473-1f3fe-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["woman_with_turban_dark_skin_tone"],"filename":"1f473-1f3ff-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["man_with_turban_light_skin_tone"],"filename":"1f473-1f3fb","category":"skintone","batch":"6"},{"aliases":["man_with_turban_medium_light_skin_tone"],"filename":"1f473-1f3fc","category":"skintone","batch":"6"},{"aliases":["man_with_turban_medium_skin_tone"],"filename":"1f473-1f3fd","category":"skintone","batch":"6"},{"aliases":["man_with_turban_medium_dark_skin_tone"],"filename":"1f473-1f3fe","category":"skintone","batch":"6"},{"aliases":["man_with_turban_dark_skin_tone"],"filename":"1f473-1f3ff","category":"skintone","batch":"6"},{"aliases":["man_with_turban_light_skin_tone"],"filename":"1f473-1f3fb-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["man_with_turban_medium_light_skin_tone"],"filename":"1f473-1f3fc-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["man_with_turban_medium_skin_tone"],"filename":"1f473-1f3fd-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["man_with_turban_medium_dark_skin_tone"],"filename":"1f473-1f3fe-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["man_with_turban_dark_skin_tone"],"filename":"1f473-1f3ff-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policewoman_light_skin_tone"],"filename":"1f46e-1f3fb","category":"skintone","batch":"6"},{"aliases":["policewoman_medium_light_skin_tone"],"filename":"1f46e-1f3fc","category":"skintone","batch":"6"},{"aliases":["policewoman_medium_skin_tone"],"filename":"1f46e-1f3fd","category":"skintone","batch":"6"},{"aliases":["policewoman_medium_dark_skin_tone"],"filename":"1f46e-1f3fe","category":"skintone","batch":"6"},{"aliases":["policewoman_dark_skin_tone"],"filename":"1f46e-1f3ff","category":"skintone","batch":"6"},{"aliases":["policewoman_light_skin_tone"],"filename":"1f46e-1f3fb-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policewoman_medium_light_skin_tone"],"filename":"1f46e-1f3fc-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policewoman_medium_skin_tone"],"filename":"1f46e-1f3fd-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policewoman_medium_dark_skin_tone"],"filename":"1f46e-1f3fe-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policewoman_dark_skin_tone"],"filename":"1f46e-1f3ff-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policeman_light_skin_tone"],"filename":"1f46e-1f3fb","category":"skintone","batch":"6"},{"aliases":["policeman_medium_light_skin_tone"],"filename":"1f46e-1f3fc","category":"skintone","batch":"6"},{"aliases":["policeman_medium_skin_tone"],"filename":"1f46e-1f3fd","category":"skintone","batch":"6"},{"aliases":["policeman_medium_dark_skin_tone"],"filename":"1f46e-1f3fe","category":"skintone","batch":"6"},{"aliases":["policeman_dark_skin_tone"],"filename":"1f46e-1f3ff","category":"skintone","batch":"6"},{"aliases":["policeman_light_skin_tone"],"filename":"1f46e-1f3fb-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policeman_medium_light_skin_tone"],"filename":"1f46e-1f3fc-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policeman_medium_skin_tone"],"filename":"1f46e-1f3fd-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policeman_medium_dark_skin_tone"],"filename":"1f46e-1f3fe-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["policeman_dark_skin_tone"],"filename":"1f46e-1f3ff-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_light_skin_tone"],"filename":"1f477-1f3fb","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_medium_light_skin_tone"],"filename":"1f477-1f3fc","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_medium_skin_tone"],"filename":"1f477-1f3fd","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_medium_dark_skin_tone"],"filename":"1f477-1f3fe","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_dark_skin_tone"],"filename":"1f477-1f3ff","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_light_skin_tone"],"filename":"1f477-1f3fb-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_medium_light_skin_tone"],"filename":"1f477-1f3fc-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_medium_skin_tone"],"filename":"1f477-1f3fd-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_medium_dark_skin_tone"],"filename":"1f477-1f3fe-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["construction_worker_woman_dark_skin_tone"],"filename":"1f477-1f3ff-200d-2640-fe0f","category":"skintone","batch":"6"},{"aliases":["construction_worker_man_light_skin_tone"],"filename":"1f477-1f3fb","category":"skintone","batch":"7"},{"aliases":["construction_worker_man_medium_light_skin_tone"],"filename":"1f477-1f3fc","category":"skintone","batch":"7"},{"aliases":["construction_worker_man_medium_skin_tone"],"filename":"1f477-1f3fd","category":"skintone","batch":"7"},{"aliases":["construction_worker_man_medium_dark_skin_tone"],"filename":"1f477-1f3fe","category":"skintone","batch":"7"},{"aliases":["construction_worker_man_dark_skin_tone"],"filename":"1f477-1f3ff","category":"skintone","batch":"7"},{"aliases":["construction_worker_man_light_skin_tone"],"filename":"1f477-1f3fb-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["construction_worker_man_medium_light_skin_tone"],"filename":"1f477-1f3fc-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["construction_worker_man_medium_skin_tone"],"filename":"1f477-1f3fd-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["construction_worker_man_medium_dark_skin_tone"],"filename":"1f477-1f3fe-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["construction_worker_man_dark_skin_tone"],"filename":"1f477-1f3ff-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardswoman_light_skin_tone"],"filename":"1f482-1f3fb","category":"skintone","batch":"7"},{"aliases":["guardswoman_medium_light_skin_tone"],"filename":"1f482-1f3fc","category":"skintone","batch":"7"},{"aliases":["guardswoman_medium_skin_tone"],"filename":"1f482-1f3fd","category":"skintone","batch":"7"},{"aliases":["guardswoman_medium_dark_skin_tone"],"filename":"1f482-1f3fe","category":"skintone","batch":"7"},{"aliases":["guardswoman_dark_skin_tone"],"filename":"1f482-1f3ff","category":"skintone","batch":"7"},{"aliases":["guardswoman_light_skin_tone"],"filename":"1f482-1f3fb-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardswoman_medium_light_skin_tone"],"filename":"1f482-1f3fc-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardswoman_medium_skin_tone"],"filename":"1f482-1f3fd-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardswoman_medium_dark_skin_tone"],"filename":"1f482-1f3fe-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardswoman_dark_skin_tone"],"filename":"1f482-1f3ff-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardsman_light_skin_tone"],"filename":"1f482-1f3fb","category":"skintone","batch":"7"},{"aliases":["guardsman_medium_light_skin_tone"],"filename":"1f482-1f3fc","category":"skintone","batch":"7"},{"aliases":["guardsman_medium_skin_tone"],"filename":"1f482-1f3fd","category":"skintone","batch":"7"},{"aliases":["guardsman_medium_dark_skin_tone"],"filename":"1f482-1f3fe","category":"skintone","batch":"7"},{"aliases":["guardsman_dark_skin_tone"],"filename":"1f482-1f3ff","category":"skintone","batch":"7"},{"aliases":["guardsman_light_skin_tone"],"filename":"1f482-1f3fb-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardsman_medium_light_skin_tone"],"filename":"1f482-1f3fc-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardsman_medium_skin_tone"],"filename":"1f482-1f3fd-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardsman_medium_dark_skin_tone"],"filename":"1f482-1f3fe-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["guardsman_dark_skin_tone"],"filename":"1f482-1f3ff-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["female_detective_light_skin_tone"],"filename":"1f575-1f3fb","category":"skintone","batch":"7"},{"aliases":["female_detective_medium_light_skin_tone"],"filename":"1f575-1f3fc","category":"skintone","batch":"7"},{"aliases":["female_detective_medium_skin_tone"],"filename":"1f575-1f3fd","category":"skintone","batch":"7"},{"aliases":["female_detective_medium_dark_skin_tone"],"filename":"1f575-1f3fe","category":"skintone","batch":"7"},{"aliases":["female_detective_dark_skin_tone"],"filename":"1f575-1f3ff","category":"skintone","batch":"7"},{"aliases":["female_detective_light_skin_tone"],"filename":"1f575-1f3fb-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["female_detective_medium_light_skin_tone"],"filename":"1f575-1f3fc-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["female_detective_medium_skin_tone"],"filename":"1f575-1f3fd-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["female_detective_medium_dark_skin_tone"],"filename":"1f575-1f3fe-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["female_detective_dark_skin_tone"],"filename":"1f575-1f3ff-200d-2640-fe0f","category":"skintone","batch":"7"},{"aliases":["male_detective_light_skin_tone"],"filename":"1f575-1f3fb","category":"skintone","batch":"7"},{"aliases":["male_detective_medium_light_skin_tone"],"filename":"1f575-1f3fc","category":"skintone","batch":"7"},{"aliases":["male_detective_medium_skin_tone"],"filename":"1f575-1f3fd","category":"skintone","batch":"7"},{"aliases":["male_detective_medium_dark_skin_tone"],"filename":"1f575-1f3fe","category":"skintone","batch":"7"},{"aliases":["male_detective_dark_skin_tone"],"filename":"1f575-1f3ff","category":"skintone","batch":"7"},{"aliases":["male_detective_light_skin_tone"],"filename":"1f575-1f3fb-200d-2640-fe0f","category":"skintone","batch":"8"},{"aliases":["male_detective_medium_light_skin_tone"],"filename":"1f575-1f3fc-200d-2640-fe0f","category":"skintone","batch":"8"},{"aliases":["male_detective_medium_skin_tone"],"filename":"1f575-1f3fd-200d-2640-fe0f","category":"skintone","batch":"8"},{"aliases":["male_detective_medium_dark_skin_tone"],"filename":"1f575-1f3fe-200d-2640-fe0f","category":"skintone","batch":"8"},{"aliases":["male_detective_dark_skin_tone"],"filename":"1f575-1f3ff-200d-2640-fe0f","category":"skintone","batch":"8"},{"aliases":["woman_health_worker_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"8"},{"aliases":["woman_health_worker_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"8"},{"aliases":["woman_health_worker_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"8"},{"aliases":["woman_health_worker_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"8"},{"aliases":["woman_health_worker_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"8"},{"aliases":["man_health_worker_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"8"},{"aliases":["man_health_worker_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"8"},{"aliases":["man_health_worker_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"8"},{"aliases":["man_health_worker_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"8"},{"aliases":["man_health_worker_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"8"},{"aliases":["woman_farmer_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"8"},{"aliases":["woman_farmer_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"8"},{"aliases":["woman_farmer_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"8"},{"aliases":["woman_farmer_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"8"},{"aliases":["woman_farmer_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"8"},{"aliases":["man_farmer_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"8"},{"aliases":["man_farmer_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"8"},{"aliases":["man_farmer_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"8"},{"aliases":["man_farmer_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"8"},{"aliases":["man_farmer_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"8"},{"aliases":["woman_cook_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"8"},{"aliases":["woman_cook_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"8"},{"aliases":["woman_cook_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"8"},{"aliases":["woman_cook_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"8"},{"aliases":["woman_cook_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"8"},{"aliases":["man_cook_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"8"},{"aliases":["man_cook_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"8"},{"aliases":["man_cook_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"8"},{"aliases":["man_cook_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"8"},{"aliases":["man_cook_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"8"},{"aliases":["woman_student_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"8"},{"aliases":["woman_student_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"8"},{"aliases":["woman_student_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"8"},{"aliases":["woman_student_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"8"},{"aliases":["woman_student_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"8"},{"aliases":["man_student_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"8"},{"aliases":["man_student_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"8"},{"aliases":["man_student_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"8"},{"aliases":["man_student_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"8"},{"aliases":["man_student_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"8"},{"aliases":["woman_singer_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"9"},{"aliases":["woman_singer_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"9"},{"aliases":["woman_singer_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"9"},{"aliases":["woman_singer_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"9"},{"aliases":["woman_singer_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"9"},{"aliases":["man_singer_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"9"},{"aliases":["man_singer_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"9"},{"aliases":["man_singer_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"9"},{"aliases":["man_singer_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"9"},{"aliases":["man_singer_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"9"},{"aliases":["woman_teacher_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"9"},{"aliases":["woman_teacher_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"9"},{"aliases":["woman_teacher_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"9"},{"aliases":["woman_teacher_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"9"},{"aliases":["woman_teacher_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"9"},{"aliases":["man_teacher_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"9"},{"aliases":["man_teacher_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"9"},{"aliases":["man_teacher_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"9"},{"aliases":["man_teacher_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"9"},{"aliases":["man_teacher_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"9"},{"aliases":["woman_factory_worker_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"9"},{"aliases":["woman_factory_worker_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"9"},{"aliases":["woman_factory_worker_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"9"},{"aliases":["woman_factory_worker_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"9"},{"aliases":["woman_factory_worker_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"9"},{"aliases":["man_factory_worker_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"9"},{"aliases":["man_factory_worker_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"9"},{"aliases":["man_factory_worker_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"9"},{"aliases":["man_factory_worker_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"9"},{"aliases":["man_factory_worker_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"9"},{"aliases":["woman_technologist_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"9"},{"aliases":["woman_technologist_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"9"},{"aliases":["woman_technologist_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"9"},{"aliases":["woman_technologist_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"9"},{"aliases":["woman_technologist_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"9"},{"aliases":["man_technologist_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"9"},{"aliases":["man_technologist_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"9"},{"aliases":["man_technologist_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"9"},{"aliases":["man_technologist_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"9"},{"aliases":["man_technologist_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"9"},{"aliases":["woman_office_worker_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"9"},{"aliases":["woman_office_worker_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"9"},{"aliases":["woman_office_worker_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"9"},{"aliases":["woman_office_worker_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"9"},{"aliases":["woman_office_worker_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"9"},{"aliases":["man_office_worker_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"10"},{"aliases":["man_office_worker_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"10"},{"aliases":["man_office_worker_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"10"},{"aliases":["man_office_worker_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"10"},{"aliases":["man_office_worker_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"10"},{"aliases":["woman_mechanic_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"10"},{"aliases":["woman_mechanic_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"10"},{"aliases":["woman_mechanic_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"10"},{"aliases":["woman_mechanic_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"10"},{"aliases":["woman_mechanic_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"10"},{"aliases":["man_mechanic_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"10"},{"aliases":["man_mechanic_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"10"},{"aliases":["man_mechanic_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"10"},{"aliases":["man_mechanic_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"10"},{"aliases":["man_mechanic_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"10"},{"aliases":["woman_scientist_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"10"},{"aliases":["woman_scientist_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"10"},{"aliases":["woman_scientist_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"10"},{"aliases":["woman_scientist_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"10"},{"aliases":["woman_scientist_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"10"},{"aliases":["man_scientist_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"10"},{"aliases":["man_scientist_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"10"},{"aliases":["man_scientist_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"10"},{"aliases":["man_scientist_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"10"},{"aliases":["man_scientist_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"10"},{"aliases":["woman_artist_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"10"},{"aliases":["woman_artist_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"10"},{"aliases":["woman_artist_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"10"},{"aliases":["woman_artist_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"10"},{"aliases":["woman_artist_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"10"},{"aliases":["man_artist_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"10"},{"aliases":["man_artist_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"10"},{"aliases":["man_artist_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"10"},{"aliases":["man_artist_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"10"},{"aliases":["man_artist_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"10"},{"aliases":["woman_firefighter_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"10"},{"aliases":["woman_firefighter_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"10"},{"aliases":["woman_firefighter_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"10"},{"aliases":["woman_firefighter_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"10"},{"aliases":["woman_firefighter_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"10"},{"aliases":["man_firefighter_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"10"},{"aliases":["man_firefighter_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"10"},{"aliases":["man_firefighter_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"10"},{"aliases":["man_firefighter_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"10"},{"aliases":["man_firefighter_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"10"},{"aliases":["woman_pilot_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"11"},{"aliases":["woman_pilot_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"11"},{"aliases":["woman_pilot_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"11"},{"aliases":["woman_pilot_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"11"},{"aliases":["woman_pilot_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"11"},{"aliases":["man_pilot_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"11"},{"aliases":["man_pilot_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"11"},{"aliases":["man_pilot_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"11"},{"aliases":["man_pilot_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"11"},{"aliases":["man_pilot_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"11"},{"aliases":["woman_astronaut_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"11"},{"aliases":["woman_astronaut_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"11"},{"aliases":["woman_astronaut_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"11"},{"aliases":["woman_astronaut_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"11"},{"aliases":["woman_astronaut_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"11"},{"aliases":["man_astronaut_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"11"},{"aliases":["man_astronaut_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"11"},{"aliases":["man_astronaut_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"11"},{"aliases":["man_astronaut_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"11"},{"aliases":["man_astronaut_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"11"},{"aliases":["woman_judge_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"11"},{"aliases":["woman_judge_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"11"},{"aliases":["woman_judge_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"11"},{"aliases":["woman_judge_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"11"},{"aliases":["woman_judge_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"11"},{"aliases":["man_judge_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"11"},{"aliases":["man_judge_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"11"},{"aliases":["man_judge_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"11"},{"aliases":["man_judge_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"11"},{"aliases":["man_judge_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"11"},{"aliases":["mrs_claus_light_skin_tone"],"filename":"1f936-1f3fb","category":"skintone","batch":"11"},{"aliases":["mrs_claus_medium_light_skin_tone"],"filename":"1f936-1f3fc","category":"skintone","batch":"11"},{"aliases":["mrs_claus_medium_skin_tone"],"filename":"1f936-1f3fd","category":"skintone","batch":"11"},{"aliases":["mrs_claus_medium_dark_skin_tone"],"filename":"1f936-1f3fe","category":"skintone","batch":"11"},{"aliases":["mrs_claus_dark_skin_tone"],"filename":"1f936-1f3ff","category":"skintone","batch":"11"},{"aliases":["santa_light_skin_tone"],"filename":"1f385-1f3fb","category":"skintone","batch":"11"},{"aliases":["santa_medium_light_skin_tone"],"filename":"1f385-1f3fc","category":"skintone","batch":"11"},{"aliases":["santa_medium_skin_tone"],"filename":"1f385-1f3fd","category":"skintone","batch":"11"},{"aliases":["santa_medium_dark_skin_tone"],"filename":"1f385-1f3fe","category":"skintone","batch":"11"},{"aliases":["santa_dark_skin_tone"],"filename":"1f385-1f3ff","category":"skintone","batch":"11"},{"aliases":["princess_light_skin_tone"],"filename":"1f478-1f3fb","category":"skintone","batch":"11"},{"aliases":["princess_medium_light_skin_tone"],"filename":"1f478-1f3fc","category":"skintone","batch":"11"},{"aliases":["princess_medium_skin_tone"],"filename":"1f478-1f3fd","category":"skintone","batch":"11"},{"aliases":["princess_medium_dark_skin_tone"],"filename":"1f478-1f3fe","category":"skintone","batch":"11"},{"aliases":["princess_dark_skin_tone"],"filename":"1f478-1f3ff","category":"skintone","batch":"11"},{"aliases":["prince_light_skin_tone"],"filename":"1f934-1f3fb","category":"skintone","batch":"12"},{"aliases":["prince_medium_light_skin_tone"],"filename":"1f934-1f3fc","category":"skintone","batch":"12"},{"aliases":["prince_medium_skin_tone"],"filename":"1f934-1f3fd","category":"skintone","batch":"12"},{"aliases":["prince_medium_dark_skin_tone"],"filename":"1f934-1f3fe","category":"skintone","batch":"12"},{"aliases":["prince_dark_skin_tone"],"filename":"1f934-1f3ff","category":"skintone","batch":"12"},{"aliases":["bride_with_veil_light_skin_tone"],"filename":"1f470-1f3fb","category":"skintone","batch":"12"},{"aliases":["bride_with_veil_medium_light_skin_tone"],"filename":"1f470-1f3fc","category":"skintone","batch":"12"},{"aliases":["bride_with_veil_medium_skin_tone"],"filename":"1f470-1f3fd","category":"skintone","batch":"12"},{"aliases":["bride_with_veil_medium_dark_skin_tone"],"filename":"1f470-1f3fe","category":"skintone","batch":"12"},{"aliases":["bride_with_veil_dark_skin_tone"],"filename":"1f470-1f3ff","category":"skintone","batch":"12"},{"aliases":["man_in_tuxedo_light_skin_tone"],"filename":"1f935-1f3fb","category":"skintone","batch":"12"},{"aliases":["man_in_tuxedo_medium_light_skin_tone"],"filename":"1f935-1f3fc","category":"skintone","batch":"12"},{"aliases":["man_in_tuxedo_medium_skin_tone"],"filename":"1f935-1f3fd","category":"skintone","batch":"12"},{"aliases":["man_in_tuxedo_medium_dark_skin_tone"],"filename":"1f935-1f3fe","category":"skintone","batch":"12"},{"aliases":["man_in_tuxedo_dark_skin_tone"],"filename":"1f935-1f3ff","category":"skintone","batch":"12"},{"aliases":["angel_light_skin_tone"],"filename":"1f47c-1f3fb","category":"skintone","batch":"12"},{"aliases":["angel_medium_light_skin_tone"],"filename":"1f47c-1f3fc","category":"skintone","batch":"12"},{"aliases":["angel_medium_skin_tone"],"filename":"1f47c-1f3fd","category":"skintone","batch":"12"},{"aliases":["angel_medium_dark_skin_tone"],"filename":"1f47c-1f3fe","category":"skintone","batch":"12"},{"aliases":["angel_dark_skin_tone"],"filename":"1f47c-1f3ff","category":"skintone","batch":"12"},{"aliases":["pregnant_woman_light_skin_tone"],"filename":"1f930-1f3fb","category":"skintone","batch":"12"},{"aliases":["pregnant_woman_medium_light_skin_tone"],"filename":"1f930-1f3fc","category":"skintone","batch":"12"},{"aliases":["pregnant_woman_medium_skin_tone"],"filename":"1f930-1f3fd","category":"skintone","batch":"12"},{"aliases":["pregnant_woman_medium_dark_skin_tone"],"filename":"1f930-1f3fe","category":"skintone","batch":"12"},{"aliases":["pregnant_woman_dark_skin_tone"],"filename":"1f930-1f3ff","category":"skintone","batch":"12"},{"aliases":["bowing_woman_light_skin_tone"],"filename":"1f647-1f3fb","category":"skintone","batch":"12"},{"aliases":["bowing_woman_medium_light_skin_tone"],"filename":"1f647-1f3fc","category":"skintone","batch":"12"},{"aliases":["bowing_woman_medium_skin_tone"],"filename":"1f647-1f3fd","category":"skintone","batch":"12"},{"aliases":["bowing_woman_medium_dark_skin_tone"],"filename":"1f647-1f3fe","category":"skintone","batch":"12"},{"aliases":["bowing_woman_dark_skin_tone"],"filename":"1f647-1f3ff","category":"skintone","batch":"12"},{"aliases":["bowing_woman_light_skin_tone"],"filename":"1f647-1f3fb-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["bowing_woman_medium_light_skin_tone"],"filename":"1f647-1f3fc-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["bowing_woman_medium_skin_tone"],"filename":"1f647-1f3fd-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["bowing_woman_medium_dark_skin_tone"],"filename":"1f647-1f3fe-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["bowing_woman_dark_skin_tone"],"filename":"1f647-1f3ff-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["bowing_man_light_skin_tone"],"filename":"1f647-1f3fb","category":"skintone","batch":"12"},{"aliases":["bowing_man_medium_light_skin_tone"],"filename":"1f647-1f3fc","category":"skintone","batch":"12"},{"aliases":["bowing_man_medium_skin_tone"],"filename":"1f647-1f3fd","category":"skintone","batch":"12"},{"aliases":["bowing_man_medium_dark_skin_tone"],"filename":"1f647-1f3fe","category":"skintone","batch":"12"},{"aliases":["bowing_man_dark_skin_tone"],"filename":"1f647-1f3ff","category":"skintone","batch":"12"},{"aliases":["bowing_man_light_skin_tone"],"filename":"1f647-1f3fb-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["bowing_man_medium_light_skin_tone"],"filename":"1f647-1f3fc-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["bowing_man_medium_skin_tone"],"filename":"1f647-1f3fd-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["bowing_man_medium_dark_skin_tone"],"filename":"1f647-1f3fe-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["bowing_man_dark_skin_tone"],"filename":"1f647-1f3ff-200d-2640-fe0f","category":"skintone","batch":"12"},{"aliases":["tipping_hand_woman_light_skin_tone"],"filename":"1f481-1f3fb","category":"skintone","batch":"13"},{"aliases":["tipping_hand_woman_medium_light_skin_tone"],"filename":"1f481-1f3fc","category":"skintone","batch":"13"},{"aliases":["tipping_hand_woman_medium_skin_tone"],"filename":"1f481-1f3fd","category":"skintone","batch":"13"},{"aliases":["tipping_hand_woman_medium_dark_skin_tone"],"filename":"1f481-1f3fe","category":"skintone","batch":"13"},{"aliases":["tipping_hand_woman_dark_skin_tone"],"filename":"1f481-1f3ff","category":"skintone","batch":"13"},{"aliases":["tipping_hand_woman_light_skin_tone"],"filename":"1f481-1f3fb-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["tipping_hand_woman_medium_light_skin_tone"],"filename":"1f481-1f3fc-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["tipping_hand_woman_medium_skin_tone"],"filename":"1f481-1f3fd-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["tipping_hand_woman_medium_dark_skin_tone"],"filename":"1f481-1f3fe-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["tipping_hand_woman_dark_skin_tone"],"filename":"1f481-1f3ff-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["tipping_hand_man_light_skin_tone"],"filename":"1f481-1f3fb-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["tipping_hand_man_medium_light_skin_tone"],"filename":"1f481-1f3fc-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["tipping_hand_man_medium_skin_tone"],"filename":"1f481-1f3fd-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["tipping_hand_man_medium_dark_skin_tone"],"filename":"1f481-1f3fe-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["tipping_hand_man_dark_skin_tone"],"filename":"1f481-1f3ff-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_woman_light_skin_tone"],"filename":"1f645-1f3fb","category":"skintone","batch":"13"},{"aliases":["no_good_woman_medium_light_skin_tone"],"filename":"1f645-1f3fc","category":"skintone","batch":"13"},{"aliases":["no_good_woman_medium_skin_tone"],"filename":"1f645-1f3fd","category":"skintone","batch":"13"},{"aliases":["no_good_woman_medium_dark_skin_tone"],"filename":"1f645-1f3fe","category":"skintone","batch":"13"},{"aliases":["no_good_woman_dark_skin_tone"],"filename":"1f645-1f3ff","category":"skintone","batch":"13"},{"aliases":["no_good_woman_light_skin_tone"],"filename":"1f645-1f3fb-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_woman_medium_light_skin_tone"],"filename":"1f645-1f3fc-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_woman_medium_skin_tone"],"filename":"1f645-1f3fd-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_woman_medium_dark_skin_tone"],"filename":"1f645-1f3fe-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_woman_dark_skin_tone"],"filename":"1f645-1f3ff-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_man_light_skin_tone"],"filename":"1f645-1f3fb-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_man_medium_light_skin_tone"],"filename":"1f645-1f3fc-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_man_medium_skin_tone"],"filename":"1f645-1f3fd-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_man_medium_dark_skin_tone"],"filename":"1f645-1f3fe-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["no_good_man_dark_skin_tone"],"filename":"1f645-1f3ff-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_woman_light_skin_tone"],"filename":"1f646-1f3fb","category":"skintone","batch":"13"},{"aliases":["ok_woman_medium_light_skin_tone"],"filename":"1f646-1f3fc","category":"skintone","batch":"13"},{"aliases":["ok_woman_medium_skin_tone"],"filename":"1f646-1f3fd","category":"skintone","batch":"13"},{"aliases":["ok_woman_medium_dark_skin_tone"],"filename":"1f646-1f3fe","category":"skintone","batch":"13"},{"aliases":["ok_woman_dark_skin_tone"],"filename":"1f646-1f3ff","category":"skintone","batch":"13"},{"aliases":["ok_woman_light_skin_tone"],"filename":"1f646-1f3fb-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_woman_medium_light_skin_tone"],"filename":"1f646-1f3fc-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_woman_medium_skin_tone"],"filename":"1f646-1f3fd-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_woman_medium_dark_skin_tone"],"filename":"1f646-1f3fe-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_woman_dark_skin_tone"],"filename":"1f646-1f3ff-200d-2640-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_man_light_skin_tone"],"filename":"1f646-1f3fb-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_man_medium_light_skin_tone"],"filename":"1f646-1f3fc-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_man_medium_skin_tone"],"filename":"1f646-1f3fd-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_man_medium_dark_skin_tone"],"filename":"1f646-1f3fe-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["ok_man_dark_skin_tone"],"filename":"1f646-1f3ff-200d-2642-fe0f","category":"skintone","batch":"13"},{"aliases":["raising_hand_woman_light_skin_tone"],"filename":"1f64b-1f3fb","category":"skintone","batch":"14"},{"aliases":["raising_hand_woman_medium_light_skin_tone"],"filename":"1f64b-1f3fc","category":"skintone","batch":"14"},{"aliases":["raising_hand_woman_medium_skin_tone"],"filename":"1f64b-1f3fd","category":"skintone","batch":"14"},{"aliases":["raising_hand_woman_medium_dark_skin_tone"],"filename":"1f64b-1f3fe","category":"skintone","batch":"14"},{"aliases":["raising_hand_woman_dark_skin_tone"],"filename":"1f64b-1f3ff","category":"skintone","batch":"14"},{"aliases":["raising_hand_woman_light_skin_tone"],"filename":"1f64b-1f3fb-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["raising_hand_woman_medium_light_skin_tone"],"filename":"1f64b-1f3fc-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["raising_hand_woman_medium_skin_tone"],"filename":"1f64b-1f3fd-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["raising_hand_woman_medium_dark_skin_tone"],"filename":"1f64b-1f3fe-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["raising_hand_woman_dark_skin_tone"],"filename":"1f64b-1f3ff-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["raising_hand_man_light_skin_tone"],"filename":"1f64b-1f3fb-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["raising_hand_man_medium_light_skin_tone"],"filename":"1f64b-1f3fc-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["raising_hand_man_medium_skin_tone"],"filename":"1f64b-1f3fd-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["raising_hand_man_medium_dark_skin_tone"],"filename":"1f64b-1f3fe-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["raising_hand_man_dark_skin_tone"],"filename":"1f64b-1f3ff-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_light_skin_tone"],"filename":"1f926-1f3fb","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_medium_light_skin_tone"],"filename":"1f926-1f3fc","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_medium_skin_tone"],"filename":"1f926-1f3fd","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_medium_dark_skin_tone"],"filename":"1f926-1f3fe","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_dark_skin_tone"],"filename":"1f926-1f3ff","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_light_skin_tone"],"filename":"1f926-1f3fb-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_medium_light_skin_tone"],"filename":"1f926-1f3fc-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_medium_skin_tone"],"filename":"1f926-1f3fd-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_medium_dark_skin_tone"],"filename":"1f926-1f3fe-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_facepalming_dark_skin_tone"],"filename":"1f926-1f3ff-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["man_facepalming_light_skin_tone"],"filename":"1f926-1f3fb-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["man_facepalming_medium_light_skin_tone"],"filename":"1f926-1f3fc-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["man_facepalming_medium_skin_tone"],"filename":"1f926-1f3fd-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["man_facepalming_medium_dark_skin_tone"],"filename":"1f926-1f3fe-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["man_facepalming_dark_skin_tone"],"filename":"1f926-1f3ff-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_light_skin_tone"],"filename":"1f937-1f3fb","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_medium_light_skin_tone"],"filename":"1f937-1f3fc","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_medium_skin_tone"],"filename":"1f937-1f3fd","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_medium_dark_skin_tone"],"filename":"1f937-1f3fe","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_dark_skin_tone"],"filename":"1f937-1f3ff","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_light_skin_tone"],"filename":"1f937-1f3fb-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_medium_light_skin_tone"],"filename":"1f937-1f3fc-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_medium_skin_tone"],"filename":"1f937-1f3fd-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_medium_dark_skin_tone"],"filename":"1f937-1f3fe-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["woman_shrugging_dark_skin_tone"],"filename":"1f937-1f3ff-200d-2640-fe0f","category":"skintone","batch":"14"},{"aliases":["man_shrugging_light_skin_tone"],"filename":"1f937-1f3fb-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["man_shrugging_medium_light_skin_tone"],"filename":"1f937-1f3fc-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["man_shrugging_medium_skin_tone"],"filename":"1f937-1f3fd-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["man_shrugging_medium_dark_skin_tone"],"filename":"1f937-1f3fe-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["man_shrugging_dark_skin_tone"],"filename":"1f937-1f3ff-200d-2642-fe0f","category":"skintone","batch":"14"},{"aliases":["pouting_woman_light_skin_tone"],"filename":"1f64e-1f3fb","category":"skintone","batch":"15"},{"aliases":["pouting_woman_medium_light_skin_tone"],"filename":"1f64e-1f3fc","category":"skintone","batch":"15"},{"aliases":["pouting_woman_medium_skin_tone"],"filename":"1f64e-1f3fd","category":"skintone","batch":"15"},{"aliases":["pouting_woman_medium_dark_skin_tone"],"filename":"1f64e-1f3fe","category":"skintone","batch":"15"},{"aliases":["pouting_woman_dark_skin_tone"],"filename":"1f64e-1f3ff","category":"skintone","batch":"15"},{"aliases":["pouting_woman_light_skin_tone"],"filename":"1f64e-1f3fb-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["pouting_woman_medium_light_skin_tone"],"filename":"1f64e-1f3fc-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["pouting_woman_medium_skin_tone"],"filename":"1f64e-1f3fd-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["pouting_woman_medium_dark_skin_tone"],"filename":"1f64e-1f3fe-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["pouting_woman_dark_skin_tone"],"filename":"1f64e-1f3ff-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["pouting_man_light_skin_tone"],"filename":"1f64e-1f3fb-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["pouting_man_medium_light_skin_tone"],"filename":"1f64e-1f3fc-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["pouting_man_medium_skin_tone"],"filename":"1f64e-1f3fd-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["pouting_man_medium_dark_skin_tone"],"filename":"1f64e-1f3fe-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["pouting_man_dark_skin_tone"],"filename":"1f64e-1f3ff-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_woman_light_skin_tone"],"filename":"1f64d-1f3fb","category":"skintone","batch":"15"},{"aliases":["frowning_woman_medium_light_skin_tone"],"filename":"1f64d-1f3fc","category":"skintone","batch":"15"},{"aliases":["frowning_woman_medium_skin_tone"],"filename":"1f64d-1f3fd","category":"skintone","batch":"15"},{"aliases":["frowning_woman_medium_dark_skin_tone"],"filename":"1f64d-1f3fe","category":"skintone","batch":"15"},{"aliases":["frowning_woman_dark_skin_tone"],"filename":"1f64d-1f3ff","category":"skintone","batch":"15"},{"aliases":["frowning_woman_light_skin_tone"],"filename":"1f64d-1f3fb-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_woman_medium_light_skin_tone"],"filename":"1f64d-1f3fc-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_woman_medium_skin_tone"],"filename":"1f64d-1f3fd-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_woman_medium_dark_skin_tone"],"filename":"1f64d-1f3fe-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_woman_dark_skin_tone"],"filename":"1f64d-1f3ff-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_man_light_skin_tone"],"filename":"1f64d-1f3fb-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_man_medium_light_skin_tone"],"filename":"1f64d-1f3fc-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_man_medium_skin_tone"],"filename":"1f64d-1f3fd-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_man_medium_dark_skin_tone"],"filename":"1f64d-1f3fe-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["frowning_man_dark_skin_tone"],"filename":"1f64d-1f3ff-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_woman_light_skin_tone"],"filename":"1f487-1f3fb","category":"skintone","batch":"15"},{"aliases":["haircut_woman_medium_light_skin_tone"],"filename":"1f487-1f3fc","category":"skintone","batch":"15"},{"aliases":["haircut_woman_medium_skin_tone"],"filename":"1f487-1f3fd","category":"skintone","batch":"15"},{"aliases":["haircut_woman_medium_dark_skin_tone"],"filename":"1f487-1f3fe","category":"skintone","batch":"15"},{"aliases":["haircut_woman_dark_skin_tone"],"filename":"1f487-1f3ff","category":"skintone","batch":"15"},{"aliases":["haircut_woman_light_skin_tone"],"filename":"1f487-1f3fb-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_woman_medium_light_skin_tone"],"filename":"1f487-1f3fc-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_woman_medium_skin_tone"],"filename":"1f487-1f3fd-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_woman_medium_dark_skin_tone"],"filename":"1f487-1f3fe-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_woman_dark_skin_tone"],"filename":"1f487-1f3ff-200d-2640-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_man_light_skin_tone"],"filename":"1f487-1f3fb-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_man_medium_light_skin_tone"],"filename":"1f487-1f3fc-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_man_medium_skin_tone"],"filename":"1f487-1f3fd-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_man_medium_dark_skin_tone"],"filename":"1f487-1f3fe-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["haircut_man_dark_skin_tone"],"filename":"1f487-1f3ff-200d-2642-fe0f","category":"skintone","batch":"15"},{"aliases":["massage_woman_light_skin_tone"],"filename":"1f486-1f3fb","category":"skintone","batch":"16"},{"aliases":["massage_woman_medium_light_skin_tone"],"filename":"1f486-1f3fc","category":"skintone","batch":"16"},{"aliases":["massage_woman_medium_skin_tone"],"filename":"1f486-1f3fd","category":"skintone","batch":"16"},{"aliases":["massage_woman_medium_dark_skin_tone"],"filename":"1f486-1f3fe","category":"skintone","batch":"16"},{"aliases":["massage_woman_dark_skin_tone"],"filename":"1f486-1f3ff","category":"skintone","batch":"16"},{"aliases":["massage_woman_light_skin_tone"],"filename":"1f486-1f3fb-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["massage_woman_medium_light_skin_tone"],"filename":"1f486-1f3fc-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["massage_woman_medium_skin_tone"],"filename":"1f486-1f3fd-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["massage_woman_medium_dark_skin_tone"],"filename":"1f486-1f3fe-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["massage_woman_dark_skin_tone"],"filename":"1f486-1f3ff-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["massage_man_light_skin_tone"],"filename":"1f486-1f3fb-200d-2642-fe0f","category":"skintone","batch":"16"},{"aliases":["massage_man_medium_light_skin_tone"],"filename":"1f486-1f3fc-200d-2642-fe0f","category":"skintone","batch":"16"},{"aliases":["massage_man_medium_skin_tone"],"filename":"1f486-1f3fd-200d-2642-fe0f","category":"skintone","batch":"16"},{"aliases":["massage_man_medium_dark_skin_tone"],"filename":"1f486-1f3fe-200d-2642-fe0f","category":"skintone","batch":"16"},{"aliases":["massage_man_dark_skin_tone"],"filename":"1f486-1f3ff-200d-2642-fe0f","category":"skintone","batch":"16"},{"aliases":["business_suit_levitating_light_skin_tone"],"filename":"1f574-1f3fb","category":"skintone","batch":"16"},{"aliases":["business_suit_levitating_medium_light_skin_tone"],"filename":"1f574-1f3fc","category":"skintone","batch":"16"},{"aliases":["business_suit_levitating_medium_skin_tone"],"filename":"1f574-1f3fd","category":"skintone","batch":"16"},{"aliases":["business_suit_levitating_medium_dark_skin_tone"],"filename":"1f574-1f3fe","category":"skintone","batch":"16"},{"aliases":["business_suit_levitating_dark_skin_tone"],"filename":"1f574-1f3ff","category":"skintone","batch":"16"},{"aliases":["dancer_light_skin_tone"],"filename":"1f483-1f3fb","category":"skintone","batch":"16"},{"aliases":["dancer_medium_light_skin_tone"],"filename":"1f483-1f3fc","category":"skintone","batch":"16"},{"aliases":["dancer_medium_skin_tone"],"filename":"1f483-1f3fd","category":"skintone","batch":"16"},{"aliases":["dancer_medium_dark_skin_tone"],"filename":"1f483-1f3fe","category":"skintone","batch":"16"},{"aliases":["dancer_dark_skin_tone"],"filename":"1f483-1f3ff","category":"skintone","batch":"16"},{"aliases":["man_dancing_light_skin_tone"],"filename":"1f57a-1f3fb","category":"skintone","batch":"16"},{"aliases":["man_dancing_medium_light_skin_tone"],"filename":"1f57a-1f3fc","category":"skintone","batch":"16"},{"aliases":["man_dancing_medium_skin_tone"],"filename":"1f57a-1f3fd","category":"skintone","batch":"16"},{"aliases":["man_dancing_medium_dark_skin_tone"],"filename":"1f57a-1f3fe","category":"skintone","batch":"16"},{"aliases":["man_dancing_dark_skin_tone"],"filename":"1f57a-1f3ff","category":"skintone","batch":"16"},{"aliases":["walking_woman_light_skin_tone"],"filename":"1f6b6-1f3fb","category":"skintone","batch":"16"},{"aliases":["walking_woman_medium_light_skin_tone"],"filename":"1f6b6-1f3fc","category":"skintone","batch":"16"},{"aliases":["walking_woman_medium_skin_tone"],"filename":"1f6b6-1f3fd","category":"skintone","batch":"16"},{"aliases":["walking_woman_medium_dark_skin_tone"],"filename":"1f6b6-1f3fe","category":"skintone","batch":"16"},{"aliases":["walking_woman_dark_skin_tone"],"filename":"1f6b6-1f3ff","category":"skintone","batch":"16"},{"aliases":["walking_woman_light_skin_tone"],"filename":"1f6b6-1f3fb-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["walking_woman_medium_light_skin_tone"],"filename":"1f6b6-1f3fc-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["walking_woman_medium_skin_tone"],"filename":"1f6b6-1f3fd-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["walking_woman_medium_dark_skin_tone"],"filename":"1f6b6-1f3fe-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["walking_woman_dark_skin_tone"],"filename":"1f6b6-1f3ff-200d-2640-fe0f","category":"skintone","batch":"16"},{"aliases":["walking_man_light_skin_tone"],"filename":"1f6b6-1f3fb","category":"skintone","batch":"16"},{"aliases":["walking_man_medium_light_skin_tone"],"filename":"1f6b6-1f3fc","category":"skintone","batch":"16"},{"aliases":["walking_man_medium_skin_tone"],"filename":"1f6b6-1f3fd","category":"skintone","batch":"16"},{"aliases":["walking_man_medium_dark_skin_tone"],"filename":"1f6b6-1f3fe","category":"skintone","batch":"16"},{"aliases":["walking_man_dark_skin_tone"],"filename":"1f6b6-1f3ff","category":"skintone","batch":"16"},{"aliases":["walking_man_light_skin_tone"],"filename":"1f6b6-1f3fb-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["walking_man_medium_light_skin_tone"],"filename":"1f6b6-1f3fc-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["walking_man_medium_skin_tone"],"filename":"1f6b6-1f3fd-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["walking_man_medium_dark_skin_tone"],"filename":"1f6b6-1f3fe-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["walking_man_dark_skin_tone"],"filename":"1f6b6-1f3ff-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_woman_light_skin_tone"],"filename":"1f3c3-1f3fb","category":"skintone","batch":"17"},{"aliases":["running_woman_medium_light_skin_tone"],"filename":"1f3c3-1f3fc","category":"skintone","batch":"17"},{"aliases":["running_woman_medium_skin_tone"],"filename":"1f3c3-1f3fd","category":"skintone","batch":"17"},{"aliases":["running_woman_medium_dark_skin_tone"],"filename":"1f3c3-1f3fe","category":"skintone","batch":"17"},{"aliases":["running_woman_dark_skin_tone"],"filename":"1f3c3-1f3ff","category":"skintone","batch":"17"},{"aliases":["running_woman_light_skin_tone"],"filename":"1f3c3-1f3fb-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_woman_medium_light_skin_tone"],"filename":"1f3c3-1f3fc-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_woman_medium_skin_tone"],"filename":"1f3c3-1f3fd-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_woman_medium_dark_skin_tone"],"filename":"1f3c3-1f3fe-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_woman_dark_skin_tone"],"filename":"1f3c3-1f3ff-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_man_light_skin_tone"],"filename":"1f3c3-1f3fb","category":"skintone","batch":"17"},{"aliases":["running_man_medium_light_skin_tone"],"filename":"1f3c3-1f3fc","category":"skintone","batch":"17"},{"aliases":["running_man_medium_skin_tone"],"filename":"1f3c3-1f3fd","category":"skintone","batch":"17"},{"aliases":["running_man_medium_dark_skin_tone"],"filename":"1f3c3-1f3fe","category":"skintone","batch":"17"},{"aliases":["running_man_dark_skin_tone"],"filename":"1f3c3-1f3ff","category":"skintone","batch":"17"},{"aliases":["running_man_light_skin_tone"],"filename":"1f3c3-1f3fb-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_man_medium_light_skin_tone"],"filename":"1f3c3-1f3fc-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_man_medium_skin_tone"],"filename":"1f3c3-1f3fd-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_man_medium_dark_skin_tone"],"filename":"1f3c3-1f3fe-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["running_man_dark_skin_tone"],"filename":"1f3c3-1f3ff-200d-2640-fe0f","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_woman_woman_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_woman_woman_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_woman_woman_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_woman_woman_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_woman_woman_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_man_man_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_man_man_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_man_man_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_man_man_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"17"},{"aliases":["couple_with_heart_man_man_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"17"},{"aliases":["couplekiss_woman_woman_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"17"},{"aliases":["couplekiss_woman_woman_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"17"},{"aliases":["couplekiss_woman_woman_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"17"},{"aliases":["couplekiss_woman_woman_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"17"},{"aliases":["couplekiss_woman_woman_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"17"},{"aliases":["couplekiss_man_man_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"17"},{"aliases":["couplekiss_man_man_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"17"},{"aliases":["couplekiss_man_man_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"17"},{"aliases":["couplekiss_man_man_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"17"},{"aliases":["couplekiss_man_man_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"17"},{"aliases":["family_man_woman_girl_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_boy_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_boy_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_boy_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_boy_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_boy_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"18"},{"aliases":["family_man_woman_boy_boy_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"18"},{"aliases":["family_man_woman_boy_boy_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"18"},{"aliases":["family_man_woman_boy_boy_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"18"},{"aliases":["family_man_woman_boy_boy_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"18"},{"aliases":["family_man_woman_boy_boy_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_girl_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_girl_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_girl_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_girl_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"18"},{"aliases":["family_man_woman_girl_girl_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_boy_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_boy_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_boy_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_boy_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_boy_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_boy_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_boy_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_boy_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_boy_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_boy_boy_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_girl_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_girl_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_girl_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_girl_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"18"},{"aliases":["family_woman_woman_girl_girl_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"18"},{"aliases":["family_man_man_boy_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"19"},{"aliases":["family_man_man_boy_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"19"},{"aliases":["family_man_man_boy_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"19"},{"aliases":["family_man_man_boy_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"19"},{"aliases":["family_man_man_boy_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_boy_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_boy_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_boy_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_boy_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_boy_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"19"},{"aliases":["family_man_man_boy_boy_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"19"},{"aliases":["family_man_man_boy_boy_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"19"},{"aliases":["family_man_man_boy_boy_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"19"},{"aliases":["family_man_man_boy_boy_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"19"},{"aliases":["family_man_man_boy_boy_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_girl_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_girl_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_girl_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_girl_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"19"},{"aliases":["family_man_man_girl_girl_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_boy_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_boy_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_boy_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_boy_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_boy_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_boy_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_boy_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_boy_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_boy_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"19"},{"aliases":["family_woman_boy_boy_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"19"},{"aliases":["family_woman_girl_girl_light_skin_tone"],"filename":"1f469-1f3fb","category":"skintone","batch":"20"},{"aliases":["family_woman_girl_girl_medium_light_skin_tone"],"filename":"1f469-1f3fc","category":"skintone","batch":"20"},{"aliases":["family_woman_girl_girl_medium_skin_tone"],"filename":"1f469-1f3fd","category":"skintone","batch":"20"},{"aliases":["family_woman_girl_girl_medium_dark_skin_tone"],"filename":"1f469-1f3fe","category":"skintone","batch":"20"},{"aliases":["family_woman_girl_girl_dark_skin_tone"],"filename":"1f469-1f3ff","category":"skintone","batch":"20"},{"aliases":["family_man_boy_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"20"},{"aliases":["family_man_boy_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"20"},{"aliases":["family_man_boy_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"20"},{"aliases":["family_man_boy_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"20"},{"aliases":["family_man_boy_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"20"},{"aliases":["family_man_girl_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"20"},{"aliases":["family_man_girl_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"20"},{"aliases":["family_man_girl_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"20"},{"aliases":["family_man_girl_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"20"},{"aliases":["family_man_girl_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"20"},{"aliases":["family_man_girl_boy_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"20"},{"aliases":["family_man_girl_boy_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"20"},{"aliases":["family_man_girl_boy_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"20"},{"aliases":["family_man_girl_boy_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"20"},{"aliases":["family_man_girl_boy_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"20"},{"aliases":["family_man_boy_boy_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"20"},{"aliases":["family_man_boy_boy_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"20"},{"aliases":["family_man_boy_boy_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"20"},{"aliases":["family_man_boy_boy_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"20"},{"aliases":["family_man_boy_boy_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"20"},{"aliases":["family_man_girl_girl_light_skin_tone"],"filename":"1f468-1f3fb","category":"skintone","batch":"20"},{"aliases":["family_man_girl_girl_medium_light_skin_tone"],"filename":"1f468-1f3fc","category":"skintone","batch":"20"},{"aliases":["family_man_girl_girl_medium_skin_tone"],"filename":"1f468-1f3fd","category":"skintone","batch":"20"},{"aliases":["family_man_girl_girl_medium_dark_skin_tone"],"filename":"1f468-1f3fe","category":"skintone","batch":"20"},{"aliases":["family_man_girl_girl_dark_skin_tone"],"filename":"1f468-1f3ff","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_light_skin_tone"],"filename":"1f3cb-1f3fb","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_medium_light_skin_tone"],"filename":"1f3cb-1f3fc","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_medium_skin_tone"],"filename":"1f3cb-1f3fd","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_medium_dark_skin_tone"],"filename":"1f3cb-1f3fe","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_dark_skin_tone"],"filename":"1f3cb-1f3ff","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_light_skin_tone"],"filename":"1f3cb-1f3fb-200d-2640-fe0f","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_medium_light_skin_tone"],"filename":"1f3cb-1f3fc-200d-2640-fe0f","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_medium_skin_tone"],"filename":"1f3cb-1f3fd-200d-2640-fe0f","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_medium_dark_skin_tone"],"filename":"1f3cb-1f3fe-200d-2640-fe0f","category":"skintone","batch":"20"},{"aliases":["weight_lifting_woman_dark_skin_tone"],"filename":"1f3cb-1f3ff-200d-2640-fe0f","category":"skintone","batch":"20"},{"aliases":["weight_lifting_man_light_skin_tone"],"filename":"1f3cb-1f3fb","category":"skintone","batch":"20"},{"aliases":["weight_lifting_man_medium_light_skin_tone"],"filename":"1f3cb-1f3fc","category":"skintone","batch":"20"},{"aliases":["weight_lifting_man_medium_skin_tone"],"filename":"1f3cb-1f3fd","category":"skintone","batch":"20"},{"aliases":["weight_lifting_man_medium_dark_skin_tone"],"filename":"1f3cb-1f3fe","category":"skintone","batch":"20"},{"aliases":["weight_lifting_man_dark_skin_tone"],"filename":"1f3cb-1f3ff","category":"skintone","batch":"20"},{"aliases":["weight_lifting_man_light_skin_tone"],"filename":"1f3cb-1f3fb-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["weight_lifting_man_medium_light_skin_tone"],"filename":"1f3cb-1f3fc-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["weight_lifting_man_medium_skin_tone"],"filename":"1f3cb-1f3fd-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["weight_lifting_man_medium_dark_skin_tone"],"filename":"1f3cb-1f3fe-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["weight_lifting_man_dark_skin_tone"],"filename":"1f3cb-1f3ff-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_light_skin_tone"],"filename":"1f938-1f3fb","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_medium_light_skin_tone"],"filename":"1f938-1f3fc","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_medium_skin_tone"],"filename":"1f938-1f3fd","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_medium_dark_skin_tone"],"filename":"1f938-1f3fe","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_dark_skin_tone"],"filename":"1f938-1f3ff","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_light_skin_tone"],"filename":"1f938-1f3fb-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_medium_light_skin_tone"],"filename":"1f938-1f3fc-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_medium_skin_tone"],"filename":"1f938-1f3fd-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_medium_dark_skin_tone"],"filename":"1f938-1f3fe-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["woman_cartwheeling_dark_skin_tone"],"filename":"1f938-1f3ff-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["man_cartwheeling_light_skin_tone"],"filename":"1f938-1f3fb-200d-2642-fe0f","category":"skintone","batch":"21"},{"aliases":["man_cartwheeling_medium_light_skin_tone"],"filename":"1f938-1f3fc-200d-2642-fe0f","category":"skintone","batch":"21"},{"aliases":["man_cartwheeling_medium_skin_tone"],"filename":"1f938-1f3fd-200d-2642-fe0f","category":"skintone","batch":"21"},{"aliases":["man_cartwheeling_medium_dark_skin_tone"],"filename":"1f938-1f3fe-200d-2642-fe0f","category":"skintone","batch":"21"},{"aliases":["man_cartwheeling_dark_skin_tone"],"filename":"1f938-1f3ff-200d-2642-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_woman_light_skin_tone"],"filename":"26f9-1f3fb","category":"skintone","batch":"21"},{"aliases":["basketball_woman_medium_light_skin_tone"],"filename":"26f9-1f3fc","category":"skintone","batch":"21"},{"aliases":["basketball_woman_medium_skin_tone"],"filename":"26f9-1f3fd","category":"skintone","batch":"21"},{"aliases":["basketball_woman_medium_dark_skin_tone"],"filename":"26f9-1f3fe","category":"skintone","batch":"21"},{"aliases":["basketball_woman_dark_skin_tone"],"filename":"26f9-1f3ff","category":"skintone","batch":"21"},{"aliases":["basketball_woman_light_skin_tone"],"filename":"26f9-1f3fb-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_woman_medium_light_skin_tone"],"filename":"26f9-1f3fc-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_woman_medium_skin_tone"],"filename":"26f9-1f3fd-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_woman_medium_dark_skin_tone"],"filename":"26f9-1f3fe-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_woman_dark_skin_tone"],"filename":"26f9-1f3ff-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_man_light_skin_tone"],"filename":"26f9-1f3fb","category":"skintone","batch":"21"},{"aliases":["basketball_man_medium_light_skin_tone"],"filename":"26f9-1f3fc","category":"skintone","batch":"21"},{"aliases":["basketball_man_medium_skin_tone"],"filename":"26f9-1f3fd","category":"skintone","batch":"21"},{"aliases":["basketball_man_medium_dark_skin_tone"],"filename":"26f9-1f3fe","category":"skintone","batch":"21"},{"aliases":["basketball_man_dark_skin_tone"],"filename":"26f9-1f3ff","category":"skintone","batch":"21"},{"aliases":["basketball_man_light_skin_tone"],"filename":"26f9-1f3fb-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_man_medium_light_skin_tone"],"filename":"26f9-1f3fc-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_man_medium_skin_tone"],"filename":"26f9-1f3fd-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_man_medium_dark_skin_tone"],"filename":"26f9-1f3fe-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["basketball_man_dark_skin_tone"],"filename":"26f9-1f3ff-200d-2640-fe0f","category":"skintone","batch":"21"},{"aliases":["woman_playing_handball_light_skin_tone"],"filename":"1f93e-1f3fb","category":"skintone","batch":"21"},{"aliases":["woman_playing_handball_medium_light_skin_tone"],"filename":"1f93e-1f3fc","category":"skintone","batch":"21"},{"aliases":["woman_playing_handball_medium_skin_tone"],"filename":"1f93e-1f3fd","category":"skintone","batch":"21"},{"aliases":["woman_playing_handball_medium_dark_skin_tone"],"filename":"1f93e-1f3fe","category":"skintone","batch":"21"},{"aliases":["woman_playing_handball_dark_skin_tone"],"filename":"1f93e-1f3ff","category":"skintone","batch":"21"},{"aliases":["woman_playing_handball_light_skin_tone"],"filename":"1f93e-1f3fb-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["woman_playing_handball_medium_light_skin_tone"],"filename":"1f93e-1f3fc-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["woman_playing_handball_medium_skin_tone"],"filename":"1f93e-1f3fd-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["woman_playing_handball_medium_dark_skin_tone"],"filename":"1f93e-1f3fe-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["woman_playing_handball_dark_skin_tone"],"filename":"1f93e-1f3ff-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["man_playing_handball_light_skin_tone"],"filename":"1f93e-1f3fb-200d-2642-fe0f","category":"skintone","batch":"22"},{"aliases":["man_playing_handball_medium_light_skin_tone"],"filename":"1f93e-1f3fc-200d-2642-fe0f","category":"skintone","batch":"22"},{"aliases":["man_playing_handball_medium_skin_tone"],"filename":"1f93e-1f3fd-200d-2642-fe0f","category":"skintone","batch":"22"},{"aliases":["man_playing_handball_medium_dark_skin_tone"],"filename":"1f93e-1f3fe-200d-2642-fe0f","category":"skintone","batch":"22"},{"aliases":["man_playing_handball_dark_skin_tone"],"filename":"1f93e-1f3ff-200d-2642-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_woman_light_skin_tone"],"filename":"1f3cc-1f3fb","category":"skintone","batch":"22"},{"aliases":["golfing_woman_medium_light_skin_tone"],"filename":"1f3cc-1f3fc","category":"skintone","batch":"22"},{"aliases":["golfing_woman_medium_skin_tone"],"filename":"1f3cc-1f3fd","category":"skintone","batch":"22"},{"aliases":["golfing_woman_medium_dark_skin_tone"],"filename":"1f3cc-1f3fe","category":"skintone","batch":"22"},{"aliases":["golfing_woman_dark_skin_tone"],"filename":"1f3cc-1f3ff","category":"skintone","batch":"22"},{"aliases":["golfing_woman_light_skin_tone"],"filename":"1f3cc-1f3fb-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_woman_medium_light_skin_tone"],"filename":"1f3cc-1f3fc-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_woman_medium_skin_tone"],"filename":"1f3cc-1f3fd-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_woman_medium_dark_skin_tone"],"filename":"1f3cc-1f3fe-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_woman_dark_skin_tone"],"filename":"1f3cc-1f3ff-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_man_light_skin_tone"],"filename":"1f3cc-1f3fb","category":"skintone","batch":"22"},{"aliases":["golfing_man_medium_light_skin_tone"],"filename":"1f3cc-1f3fc","category":"skintone","batch":"22"},{"aliases":["golfing_man_medium_skin_tone"],"filename":"1f3cc-1f3fd","category":"skintone","batch":"22"},{"aliases":["golfing_man_medium_dark_skin_tone"],"filename":"1f3cc-1f3fe","category":"skintone","batch":"22"},{"aliases":["golfing_man_dark_skin_tone"],"filename":"1f3cc-1f3ff","category":"skintone","batch":"22"},{"aliases":["golfing_man_light_skin_tone"],"filename":"1f3cc-1f3fb-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_man_medium_light_skin_tone"],"filename":"1f3cc-1f3fc-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_man_medium_skin_tone"],"filename":"1f3cc-1f3fd-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_man_medium_dark_skin_tone"],"filename":"1f3cc-1f3fe-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["golfing_man_dark_skin_tone"],"filename":"1f3cc-1f3ff-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["surfing_woman_light_skin_tone"],"filename":"1f3c4-1f3fb","category":"skintone","batch":"22"},{"aliases":["surfing_woman_medium_light_skin_tone"],"filename":"1f3c4-1f3fc","category":"skintone","batch":"22"},{"aliases":["surfing_woman_medium_skin_tone"],"filename":"1f3c4-1f3fd","category":"skintone","batch":"22"},{"aliases":["surfing_woman_medium_dark_skin_tone"],"filename":"1f3c4-1f3fe","category":"skintone","batch":"22"},{"aliases":["surfing_woman_dark_skin_tone"],"filename":"1f3c4-1f3ff","category":"skintone","batch":"22"},{"aliases":["surfing_woman_light_skin_tone"],"filename":"1f3c4-1f3fb-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["surfing_woman_medium_light_skin_tone"],"filename":"1f3c4-1f3fc-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["surfing_woman_medium_skin_tone"],"filename":"1f3c4-1f3fd-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["surfing_woman_medium_dark_skin_tone"],"filename":"1f3c4-1f3fe-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["surfing_woman_dark_skin_tone"],"filename":"1f3c4-1f3ff-200d-2640-fe0f","category":"skintone","batch":"22"},{"aliases":["surfing_man_light_skin_tone"],"filename":"1f3c4-1f3fb","category":"skintone","batch":"22"},{"aliases":["surfing_man_medium_light_skin_tone"],"filename":"1f3c4-1f3fc","category":"skintone","batch":"22"},{"aliases":["surfing_man_medium_skin_tone"],"filename":"1f3c4-1f3fd","category":"skintone","batch":"22"},{"aliases":["surfing_man_medium_dark_skin_tone"],"filename":"1f3c4-1f3fe","category":"skintone","batch":"22"},{"aliases":["surfing_man_dark_skin_tone"],"filename":"1f3c4-1f3ff","category":"skintone","batch":"22"},{"aliases":["surfing_man_light_skin_tone"],"filename":"1f3c4-1f3fb-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["surfing_man_medium_light_skin_tone"],"filename":"1f3c4-1f3fc-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["surfing_man_medium_skin_tone"],"filename":"1f3c4-1f3fd-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["surfing_man_medium_dark_skin_tone"],"filename":"1f3c4-1f3fe-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["surfing_man_dark_skin_tone"],"filename":"1f3c4-1f3ff-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_woman_light_skin_tone"],"filename":"1f3ca-1f3fb","category":"skintone","batch":"23"},{"aliases":["swimming_woman_medium_light_skin_tone"],"filename":"1f3ca-1f3fc","category":"skintone","batch":"23"},{"aliases":["swimming_woman_medium_skin_tone"],"filename":"1f3ca-1f3fd","category":"skintone","batch":"23"},{"aliases":["swimming_woman_medium_dark_skin_tone"],"filename":"1f3ca-1f3fe","category":"skintone","batch":"23"},{"aliases":["swimming_woman_dark_skin_tone"],"filename":"1f3ca-1f3ff","category":"skintone","batch":"23"},{"aliases":["swimming_woman_light_skin_tone"],"filename":"1f3ca-1f3fb-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_woman_medium_light_skin_tone"],"filename":"1f3ca-1f3fc-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_woman_medium_skin_tone"],"filename":"1f3ca-1f3fd-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_woman_medium_dark_skin_tone"],"filename":"1f3ca-1f3fe-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_woman_dark_skin_tone"],"filename":"1f3ca-1f3ff-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_man_light_skin_tone"],"filename":"1f3ca-1f3fb","category":"skintone","batch":"23"},{"aliases":["swimming_man_medium_light_skin_tone"],"filename":"1f3ca-1f3fc","category":"skintone","batch":"23"},{"aliases":["swimming_man_medium_skin_tone"],"filename":"1f3ca-1f3fd","category":"skintone","batch":"23"},{"aliases":["swimming_man_medium_dark_skin_tone"],"filename":"1f3ca-1f3fe","category":"skintone","batch":"23"},{"aliases":["swimming_man_dark_skin_tone"],"filename":"1f3ca-1f3ff","category":"skintone","batch":"23"},{"aliases":["swimming_man_light_skin_tone"],"filename":"1f3ca-1f3fb-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_man_medium_light_skin_tone"],"filename":"1f3ca-1f3fc-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_man_medium_skin_tone"],"filename":"1f3ca-1f3fd-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_man_medium_dark_skin_tone"],"filename":"1f3ca-1f3fe-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["swimming_man_dark_skin_tone"],"filename":"1f3ca-1f3ff-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_light_skin_tone"],"filename":"1f93d-1f3fb","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_medium_light_skin_tone"],"filename":"1f93d-1f3fc","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_medium_skin_tone"],"filename":"1f93d-1f3fd","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_medium_dark_skin_tone"],"filename":"1f93d-1f3fe","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_dark_skin_tone"],"filename":"1f93d-1f3ff","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_light_skin_tone"],"filename":"1f93d-1f3fb-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_medium_light_skin_tone"],"filename":"1f93d-1f3fc-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_medium_skin_tone"],"filename":"1f93d-1f3fd-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_medium_dark_skin_tone"],"filename":"1f93d-1f3fe-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["woman_playing_water_polo_dark_skin_tone"],"filename":"1f93d-1f3ff-200d-2640-fe0f","category":"skintone","batch":"23"},{"aliases":["man_playing_water_polo_light_skin_tone"],"filename":"1f93d-1f3fb-200d-2642-fe0f","category":"skintone","batch":"23"},{"aliases":["man_playing_water_polo_medium_light_skin_tone"],"filename":"1f93d-1f3fc-200d-2642-fe0f","category":"skintone","batch":"23"},{"aliases":["man_playing_water_polo_medium_skin_tone"],"filename":"1f93d-1f3fd-200d-2642-fe0f","category":"skintone","batch":"23"},{"aliases":["man_playing_water_polo_medium_dark_skin_tone"],"filename":"1f93d-1f3fe-200d-2642-fe0f","category":"skintone","batch":"23"},{"aliases":["man_playing_water_polo_dark_skin_tone"],"filename":"1f93d-1f3ff-200d-2642-fe0f","category":"skintone","batch":"23"},{"aliases":["rowing_woman_light_skin_tone"],"filename":"1f6a3-1f3fb","category":"skintone","batch":"23"},{"aliases":["rowing_woman_medium_light_skin_tone"],"filename":"1f6a3-1f3fc","category":"skintone","batch":"23"},{"aliases":["rowing_woman_medium_skin_tone"],"filename":"1f6a3-1f3fd","category":"skintone","batch":"23"},{"aliases":["rowing_woman_medium_dark_skin_tone"],"filename":"1f6a3-1f3fe","category":"skintone","batch":"23"},{"aliases":["rowing_woman_dark_skin_tone"],"filename":"1f6a3-1f3ff","category":"skintone","batch":"23"},{"aliases":["rowing_woman_light_skin_tone"],"filename":"1f6a3-1f3fb-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["rowing_woman_medium_light_skin_tone"],"filename":"1f6a3-1f3fc-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["rowing_woman_medium_skin_tone"],"filename":"1f6a3-1f3fd-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["rowing_woman_medium_dark_skin_tone"],"filename":"1f6a3-1f3fe-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["rowing_woman_dark_skin_tone"],"filename":"1f6a3-1f3ff-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["rowing_man_light_skin_tone"],"filename":"1f6a3-1f3fb","category":"skintone","batch":"24"},{"aliases":["rowing_man_medium_light_skin_tone"],"filename":"1f6a3-1f3fc","category":"skintone","batch":"24"},{"aliases":["rowing_man_medium_skin_tone"],"filename":"1f6a3-1f3fd","category":"skintone","batch":"24"},{"aliases":["rowing_man_medium_dark_skin_tone"],"filename":"1f6a3-1f3fe","category":"skintone","batch":"24"},{"aliases":["rowing_man_dark_skin_tone"],"filename":"1f6a3-1f3ff","category":"skintone","batch":"24"},{"aliases":["rowing_man_light_skin_tone"],"filename":"1f6a3-1f3fb-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["rowing_man_medium_light_skin_tone"],"filename":"1f6a3-1f3fc-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["rowing_man_medium_skin_tone"],"filename":"1f6a3-1f3fd-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["rowing_man_medium_dark_skin_tone"],"filename":"1f6a3-1f3fe-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["rowing_man_dark_skin_tone"],"filename":"1f6a3-1f3ff-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["horse_racing_light_skin_tone"],"filename":"1f3c7-1f3fb","category":"skintone","batch":"24"},{"aliases":["horse_racing_medium_light_skin_tone"],"filename":"1f3c7-1f3fc","category":"skintone","batch":"24"},{"aliases":["horse_racing_medium_skin_tone"],"filename":"1f3c7-1f3fd","category":"skintone","batch":"24"},{"aliases":["horse_racing_medium_dark_skin_tone"],"filename":"1f3c7-1f3fe","category":"skintone","batch":"24"},{"aliases":["horse_racing_dark_skin_tone"],"filename":"1f3c7-1f3ff","category":"skintone","batch":"24"},{"aliases":["biking_woman_light_skin_tone"],"filename":"1f6b4-1f3fb","category":"skintone","batch":"24"},{"aliases":["biking_woman_medium_light_skin_tone"],"filename":"1f6b4-1f3fc","category":"skintone","batch":"24"},{"aliases":["biking_woman_medium_skin_tone"],"filename":"1f6b4-1f3fd","category":"skintone","batch":"24"},{"aliases":["biking_woman_medium_dark_skin_tone"],"filename":"1f6b4-1f3fe","category":"skintone","batch":"24"},{"aliases":["biking_woman_dark_skin_tone"],"filename":"1f6b4-1f3ff","category":"skintone","batch":"24"},{"aliases":["biking_woman_light_skin_tone"],"filename":"1f6b4-1f3fb-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["biking_woman_medium_light_skin_tone"],"filename":"1f6b4-1f3fc-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["biking_woman_medium_skin_tone"],"filename":"1f6b4-1f3fd-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["biking_woman_medium_dark_skin_tone"],"filename":"1f6b4-1f3fe-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["biking_woman_dark_skin_tone"],"filename":"1f6b4-1f3ff-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["biking_man_light_skin_tone"],"filename":"1f6b4-1f3fb","category":"skintone","batch":"24"},{"aliases":["biking_man_medium_light_skin_tone"],"filename":"1f6b4-1f3fc","category":"skintone","batch":"24"},{"aliases":["biking_man_medium_skin_tone"],"filename":"1f6b4-1f3fd","category":"skintone","batch":"24"},{"aliases":["biking_man_medium_dark_skin_tone"],"filename":"1f6b4-1f3fe","category":"skintone","batch":"24"},{"aliases":["biking_man_dark_skin_tone"],"filename":"1f6b4-1f3ff","category":"skintone","batch":"24"},{"aliases":["biking_man_light_skin_tone"],"filename":"1f6b4-1f3fb-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["biking_man_medium_light_skin_tone"],"filename":"1f6b4-1f3fc-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["biking_man_medium_skin_tone"],"filename":"1f6b4-1f3fd-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["biking_man_medium_dark_skin_tone"],"filename":"1f6b4-1f3fe-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["biking_man_dark_skin_tone"],"filename":"1f6b4-1f3ff-200d-2640-fe0f","category":"skintone","batch":"24"},{"aliases":["mountain_biking_woman_light_skin_tone"],"filename":"1f6b5-1f3fb","category":"skintone","batch":"24"},{"aliases":["mountain_biking_woman_medium_light_skin_tone"],"filename":"1f6b5-1f3fc","category":"skintone","batch":"24"},{"aliases":["mountain_biking_woman_medium_skin_tone"],"filename":"1f6b5-1f3fd","category":"skintone","batch":"24"},{"aliases":["mountain_biking_woman_medium_dark_skin_tone"],"filename":"1f6b5-1f3fe","category":"skintone","batch":"24"},{"aliases":["mountain_biking_woman_dark_skin_tone"],"filename":"1f6b5-1f3ff","category":"skintone","batch":"24"},{"aliases":["mountain_biking_woman_light_skin_tone"],"filename":"1f6b5-1f3fb-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["mountain_biking_woman_medium_light_skin_tone"],"filename":"1f6b5-1f3fc-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["mountain_biking_woman_medium_skin_tone"],"filename":"1f6b5-1f3fd-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["mountain_biking_woman_medium_dark_skin_tone"],"filename":"1f6b5-1f3fe-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["mountain_biking_woman_dark_skin_tone"],"filename":"1f6b5-1f3ff-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_light_skin_tone"],"filename":"1f6b5-1f3fb","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_medium_light_skin_tone"],"filename":"1f6b5-1f3fc","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_medium_skin_tone"],"filename":"1f6b5-1f3fd","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_medium_dark_skin_tone"],"filename":"1f6b5-1f3fe","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_dark_skin_tone"],"filename":"1f6b5-1f3ff","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_light_skin_tone"],"filename":"1f6b5-1f3fb-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_medium_light_skin_tone"],"filename":"1f6b5-1f3fc-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_medium_skin_tone"],"filename":"1f6b5-1f3fd-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_medium_dark_skin_tone"],"filename":"1f6b5-1f3fe-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["mountain_biking_man_dark_skin_tone"],"filename":"1f6b5-1f3ff-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["woman_juggling_light_skin_tone"],"filename":"1f939-1f3fb","category":"skintone","batch":"25"},{"aliases":["woman_juggling_medium_light_skin_tone"],"filename":"1f939-1f3fc","category":"skintone","batch":"25"},{"aliases":["woman_juggling_medium_skin_tone"],"filename":"1f939-1f3fd","category":"skintone","batch":"25"},{"aliases":["woman_juggling_medium_dark_skin_tone"],"filename":"1f939-1f3fe","category":"skintone","batch":"25"},{"aliases":["woman_juggling_dark_skin_tone"],"filename":"1f939-1f3ff","category":"skintone","batch":"25"},{"aliases":["woman_juggling_light_skin_tone"],"filename":"1f939-1f3fb-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["woman_juggling_medium_light_skin_tone"],"filename":"1f939-1f3fc-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["woman_juggling_medium_skin_tone"],"filename":"1f939-1f3fd-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["woman_juggling_medium_dark_skin_tone"],"filename":"1f939-1f3fe-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["woman_juggling_dark_skin_tone"],"filename":"1f939-1f3ff-200d-2640-fe0f","category":"skintone","batch":"25"},{"aliases":["man_juggling_light_skin_tone"],"filename":"1f939-1f3fb-200d-2642-fe0f","category":"skintone","batch":"25"},{"aliases":["man_juggling_medium_light_skin_tone"],"filename":"1f939-1f3fc-200d-2642-fe0f","category":"skintone","batch":"25"},{"aliases":["man_juggling_medium_skin_tone"],"filename":"1f939-1f3fd-200d-2642-fe0f","category":"skintone","batch":"25"},{"aliases":["man_juggling_medium_dark_skin_tone"],"filename":"1f939-1f3fe-200d-2642-fe0f","category":"skintone","batch":"25"},{"aliases":["man_juggling_dark_skin_tone"],"filename":"1f939-1f3ff-200d-2642-fe0f","category":"skintone","batch":"25"},{"aliases":["bath_light_skin_tone"],"filename":"1f6c0-1f3fb","category":"skintone","batch":"25"},{"aliases":["bath_medium_light_skin_tone"],"filename":"1f6c0-1f3fc","category":"skintone","batch":"25"},{"aliases":["bath_medium_skin_tone"],"filename":"1f6c0-1f3fd","category":"skintone","batch":"25"},{"aliases":["bath_medium_dark_skin_tone"],"filename":"1f6c0-1f3fe","category":"skintone","batch":"25"},{"aliases":["bath_dark_skin_tone"],"filename":"1f6c0-1f3ff","category":"skintone","batch":"25"}]

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(16);
var $values = __webpack_require__(1131)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

module.exports.Dispatcher = __webpack_require__(1650);


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Dispatcher
 * 
 * @preventMunge
 */



exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var invariant = __webpack_require__(1651);

var _prefix = 'ID_';

/**
 * Dispatcher is used to broadcast payloads to registered callbacks. This is
 * different from generic pub-sub systems in two ways:
 *
 *   1) Callbacks are not subscribed to particular events. Every payload is
 *      dispatched to every registered callback.
 *   2) Callbacks can be deferred in whole or part until other callbacks have
 *      been executed.
 *
 * For example, consider this hypothetical flight destination form, which
 * selects a default city when a country is selected:
 *
 *   var flightDispatcher = new Dispatcher();
 *
 *   // Keeps track of which country is selected
 *   var CountryStore = {country: null};
 *
 *   // Keeps track of which city is selected
 *   var CityStore = {city: null};
 *
 *   // Keeps track of the base flight price of the selected city
 *   var FlightPriceStore = {price: null}
 *
 * When a user changes the selected city, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'city-update',
 *     selectedCity: 'paris'
 *   });
 *
 * This payload is digested by `CityStore`:
 *
 *   flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'city-update') {
 *       CityStore.city = payload.selectedCity;
 *     }
 *   });
 *
 * When the user selects a country, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'country-update',
 *     selectedCountry: 'australia'
 *   });
 *
 * This payload is digested by both stores:
 *
 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       CountryStore.country = payload.selectedCountry;
 *     }
 *   });
 *
 * When the callback to update `CountryStore` is registered, we save a reference
 * to the returned token. Using this token with `waitFor()`, we can guarantee
 * that `CountryStore` is updated before the callback that updates `CityStore`
 * needs to query its data.
 *
 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       // `CountryStore.country` may not be updated.
 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
 *       // `CountryStore.country` is now guaranteed to be updated.
 *
 *       // Select the default city for the new country
 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
 *     }
 *   });
 *
 * The usage of `waitFor()` can be chained, for example:
 *
 *   FlightPriceStore.dispatchToken =
 *     flightDispatcher.register(function(payload) {
 *       switch (payload.actionType) {
 *         case 'country-update':
 *         case 'city-update':
 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
 *           FlightPriceStore.price =
 *             getFlightPriceStore(CountryStore.country, CityStore.city);
 *           break;
 *     }
 *   });
 *
 * The `country-update` payload will be guaranteed to invoke the stores'
 * registered callbacks in order: `CountryStore`, `CityStore`, then
 * `FlightPriceStore`.
 */

var Dispatcher = (function () {
  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    this._callbacks = {};
    this._isDispatching = false;
    this._isHandled = {};
    this._isPending = {};
    this._lastID = 1;
  }

  /**
   * Registers a callback to be invoked with every dispatched payload. Returns
   * a token that can be used with `waitFor()`.
   */

  Dispatcher.prototype.register = function register(callback) {
    var id = _prefix + this._lastID++;
    this._callbacks[id] = callback;
    return id;
  };

  /**
   * Removes a callback based on its token.
   */

  Dispatcher.prototype.unregister = function unregister(id) {
    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
    delete this._callbacks[id];
  };

  /**
   * Waits for the callbacks specified to be invoked before continuing execution
   * of the current callback. This method should only be used by a callback in
   * response to a dispatched payload.
   */

  Dispatcher.prototype.waitFor = function waitFor(ids) {
    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
    for (var ii = 0; ii < ids.length; ii++) {
      var id = ids[ii];
      if (this._isPending[id]) {
        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
        continue;
      }
      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
      this._invokeCallback(id);
    }
  };

  /**
   * Dispatches a payload to all registered callbacks.
   */

  Dispatcher.prototype.dispatch = function dispatch(payload) {
    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
    this._startDispatching(payload);
    try {
      for (var id in this._callbacks) {
        if (this._isPending[id]) {
          continue;
        }
        this._invokeCallback(id);
      }
    } finally {
      this._stopDispatching();
    }
  };

  /**
   * Is this Dispatcher currently dispatching.
   */

  Dispatcher.prototype.isDispatching = function isDispatching() {
    return this._isDispatching;
  };

  /**
   * Call the callback stored with the given id. Also do some internal
   * bookkeeping.
   *
   * @internal
   */

  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
    this._isPending[id] = true;
    this._callbacks[id](this._pendingPayload);
    this._isHandled[id] = true;
  };

  /**
   * Set up bookkeeping needed when dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
    for (var id in this._callbacks) {
      this._isPending[id] = false;
      this._isHandled[id] = false;
    }
    this._pendingPayload = payload;
    this._isDispatching = true;
  };

  /**
   * Clear bookkeeping used for dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
    delete this._pendingPayload;
    this._isDispatching = false;
  };

  return Dispatcher;
})();

module.exports = Dispatcher;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118);
__webpack_require__(90);
module.exports = __webpack_require__(1653);


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(46);
var get = __webpack_require__(186);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.map = map;
exports.latinise = latinise;
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
// Credit to http://semplicewebsites.com/removing-accents-javascript

var latinMap = {
    Á: 'A', // LATIN CAPITAL LETTER A WITH ACUTE
    Ă: 'A', // LATIN CAPITAL LETTER A WITH BREVE
    Ắ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND ACUTE
    Ặ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND DOT BELOW
    Ằ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND GRAVE
    Ẳ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND HOOK ABOVE
    Ẵ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND TILDE
    Ǎ: 'A', // LATIN CAPITAL LETTER A WITH CARON
    Â: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX
    Ấ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND ACUTE
    Ậ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND DOT BELOW
    Ầ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND GRAVE
    Ẩ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND HOOK ABOVE
    Ẫ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND TILDE
    Ä: 'A', // LATIN CAPITAL LETTER A WITH DIAERESIS
    Ǟ: 'A', // LATIN CAPITAL LETTER A WITH DIAERESIS AND MACRON
    Ȧ: 'A', // LATIN CAPITAL LETTER A WITH DOT ABOVE
    Ǡ: 'A', // LATIN CAPITAL LETTER A WITH DOT ABOVE AND MACRON
    Ạ: 'A', // LATIN CAPITAL LETTER A WITH DOT BELOW
    Ȁ: 'A', // LATIN CAPITAL LETTER A WITH DOUBLE GRAVE
    À: 'A', // LATIN CAPITAL LETTER A WITH GRAVE
    Ả: 'A', // LATIN CAPITAL LETTER A WITH HOOK ABOVE
    Ȃ: 'A', // LATIN CAPITAL LETTER A WITH INVERTED BREVE
    Ā: 'A', // LATIN CAPITAL LETTER A WITH MACRON
    Ą: 'A', // LATIN CAPITAL LETTER A WITH OGONEK
    Å: 'A', // LATIN CAPITAL LETTER A WITH RING ABOVE
    Ǻ: 'A', // LATIN CAPITAL LETTER A WITH RING ABOVE AND ACUTE
    Ḁ: 'A', // LATIN CAPITAL LETTER A WITH RING BELOW
    Ⱥ: 'A', // LATIN CAPITAL LETTER A WITH STROKE
    Ã: 'A', // LATIN CAPITAL LETTER A WITH TILDE
    Ꜳ: 'AA', // LATIN CAPITAL LETTER AA
    Æ: 'AE', // LATIN CAPITAL LETTER AE
    Ǽ: 'AE', // LATIN CAPITAL LETTER AE WITH ACUTE
    Ǣ: 'AE', // LATIN CAPITAL LETTER AE WITH MACRON
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER AFRICAN D' (Ɖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ALPHA' (Ɑ)
    Ꜵ: 'AO', // LATIN CAPITAL LETTER AO
    Ꜷ: 'AU', // LATIN CAPITAL LETTER AU
    Ꜹ: 'AV', // LATIN CAPITAL LETTER AV
    Ꜻ: 'AV', // LATIN CAPITAL LETTER AV WITH HORIZONTAL BAR
    Ꜽ: 'AY', // LATIN CAPITAL LETTER AY
    Ḃ: 'B', // LATIN CAPITAL LETTER B WITH DOT ABOVE
    Ḅ: 'B', // LATIN CAPITAL LETTER B WITH DOT BELOW
    Ɓ: 'B', // LATIN CAPITAL LETTER B WITH HOOK
    Ḇ: 'B', // LATIN CAPITAL LETTER B WITH LINE BELOW
    Ƀ: 'B', // LATIN CAPITAL LETTER B WITH STROKE
    Ƃ: 'B', // LATIN CAPITAL LETTER B WITH TOPBAR
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER BROKEN L' (Ꝇ)
    Ć: 'C', // LATIN CAPITAL LETTER C WITH ACUTE
    Č: 'C', // LATIN CAPITAL LETTER C WITH CARON
    Ç: 'C', // LATIN CAPITAL LETTER C WITH CEDILLA
    Ḉ: 'C', // LATIN CAPITAL LETTER C WITH CEDILLA AND ACUTE
    Ĉ: 'C', // LATIN CAPITAL LETTER C WITH CIRCUMFLEX
    Ċ: 'C', // LATIN CAPITAL LETTER C WITH DOT ABOVE
    Ƈ: 'C', // LATIN CAPITAL LETTER C WITH HOOK
    Ȼ: 'C', // LATIN CAPITAL LETTER C WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CON' (Ꝯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CUATRILLO' (Ꜭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CUATRILLO WITH COMMA' (Ꜯ)
    Ď: 'D', // LATIN CAPITAL LETTER D WITH CARON
    Ḑ: 'D', // LATIN CAPITAL LETTER D WITH CEDILLA
    Ḓ: 'D', // LATIN CAPITAL LETTER D WITH CIRCUMFLEX BELOW
    Ḋ: 'D', // LATIN CAPITAL LETTER D WITH DOT ABOVE
    Ḍ: 'D', // LATIN CAPITAL LETTER D WITH DOT BELOW
    Ɗ: 'D', // LATIN CAPITAL LETTER D WITH HOOK
    Ḏ: 'D', // LATIN CAPITAL LETTER D WITH LINE BELOW
    ǲ: 'D', // LATIN CAPITAL LETTER D WITH SMALL LETTER Z
    ǅ: 'D', // LATIN CAPITAL LETTER D WITH SMALL LETTER Z WITH CARON
    Đ: 'D', // LATIN CAPITAL LETTER D WITH STROKE
    Ƌ: 'D', // LATIN CAPITAL LETTER D WITH TOPBAR
    Ǳ: 'DZ', // LATIN CAPITAL LETTER DZ
    Ǆ: 'DZ', // LATIN CAPITAL LETTER DZ WITH CARON
    É: 'E', // LATIN CAPITAL LETTER E WITH ACUTE
    Ĕ: 'E', // LATIN CAPITAL LETTER E WITH BREVE
    Ě: 'E', // LATIN CAPITAL LETTER E WITH CARON
    Ȩ: 'E', // LATIN CAPITAL LETTER E WITH CEDILLA
    Ḝ: 'E', // LATIN CAPITAL LETTER E WITH CEDILLA AND BREVE
    Ê: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX
    Ế: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND ACUTE
    Ệ: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND DOT BELOW
    Ề: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND GRAVE
    Ể: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND HOOK ABOVE
    Ễ: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND TILDE
    Ḙ: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX BELOW
    Ë: 'E', // LATIN CAPITAL LETTER E WITH DIAERESIS
    Ė: 'E', // LATIN CAPITAL LETTER E WITH DOT ABOVE
    Ẹ: 'E', // LATIN CAPITAL LETTER E WITH DOT BELOW
    Ȅ: 'E', // LATIN CAPITAL LETTER E WITH DOUBLE GRAVE
    È: 'E', // LATIN CAPITAL LETTER E WITH GRAVE
    Ẻ: 'E', // LATIN CAPITAL LETTER E WITH HOOK ABOVE
    Ȇ: 'E', // LATIN CAPITAL LETTER E WITH INVERTED BREVE
    Ē: 'E', // LATIN CAPITAL LETTER E WITH MACRON
    Ḗ: 'E', // LATIN CAPITAL LETTER E WITH MACRON AND ACUTE
    Ḕ: 'E', // LATIN CAPITAL LETTER E WITH MACRON AND GRAVE
    Ę: 'E', // LATIN CAPITAL LETTER E WITH OGONEK
    Ɇ: 'E', // LATIN CAPITAL LETTER E WITH STROKE
    Ẽ: 'E', // LATIN CAPITAL LETTER E WITH TILDE
    Ḛ: 'E', // LATIN CAPITAL LETTER E WITH TILDE BELOW
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EGYPTOLOGICAL AIN' (Ꜥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EGYPTOLOGICAL ALEF' (Ꜣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ENG' (Ŋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ESH' (Ʃ)
    Ꝫ: 'ET', // LATIN CAPITAL LETTER ET
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ETH' (Ð)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH' (Ʒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH REVERSED' (Ƹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH WITH CARON' (Ǯ)
    Ḟ: 'F', // LATIN CAPITAL LETTER F WITH DOT ABOVE
    Ƒ: 'F', // LATIN CAPITAL LETTER F WITH HOOK
    Ǵ: 'G', // LATIN CAPITAL LETTER G WITH ACUTE
    Ğ: 'G', // LATIN CAPITAL LETTER G WITH BREVE
    Ǧ: 'G', // LATIN CAPITAL LETTER G WITH CARON
    Ģ: 'G', // LATIN CAPITAL LETTER G WITH CEDILLA
    Ĝ: 'G', // LATIN CAPITAL LETTER G WITH CIRCUMFLEX
    Ġ: 'G', // LATIN CAPITAL LETTER G WITH DOT ABOVE
    Ɠ: 'G', // LATIN CAPITAL LETTER G WITH HOOK
    Ḡ: 'G', // LATIN CAPITAL LETTER G WITH MACRON
    Ǥ: 'G', // LATIN CAPITAL LETTER G WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER GAMMA' (Ɣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER GLOTTAL STOP' (Ɂ)
    Ḫ: 'H', // LATIN CAPITAL LETTER H WITH BREVE BELOW
    Ȟ: 'H', // LATIN CAPITAL LETTER H WITH CARON
    Ḩ: 'H', // LATIN CAPITAL LETTER H WITH CEDILLA
    Ĥ: 'H', // LATIN CAPITAL LETTER H WITH CIRCUMFLEX
    Ⱨ: 'H', // LATIN CAPITAL LETTER H WITH DESCENDER
    Ḧ: 'H', // LATIN CAPITAL LETTER H WITH DIAERESIS
    Ḣ: 'H', // LATIN CAPITAL LETTER H WITH DOT ABOVE
    Ḥ: 'H', // LATIN CAPITAL LETTER H WITH DOT BELOW
    Ħ: 'H', // LATIN CAPITAL LETTER H WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HALF H' (Ⱶ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HENG' (Ꜧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HWAIR' (Ƕ)
    Í: 'I', // LATIN CAPITAL LETTER I WITH ACUTE
    Ĭ: 'I', // LATIN CAPITAL LETTER I WITH BREVE
    Ǐ: 'I', // LATIN CAPITAL LETTER I WITH CARON
    Î: 'I', // LATIN CAPITAL LETTER I WITH CIRCUMFLEX
    Ï: 'I', // LATIN CAPITAL LETTER I WITH DIAERESIS
    Ḯ: 'I', // LATIN CAPITAL LETTER I WITH DIAERESIS AND ACUTE
    İ: 'I', // LATIN CAPITAL LETTER I WITH DOT ABOVE
    Ị: 'I', // LATIN CAPITAL LETTER I WITH DOT BELOW
    Ȉ: 'I', // LATIN CAPITAL LETTER I WITH DOUBLE GRAVE
    Ì: 'I', // LATIN CAPITAL LETTER I WITH GRAVE
    Ỉ: 'I', // LATIN CAPITAL LETTER I WITH HOOK ABOVE
    Ȋ: 'I', // LATIN CAPITAL LETTER I WITH INVERTED BREVE
    Ī: 'I', // LATIN CAPITAL LETTER I WITH MACRON
    Į: 'I', // LATIN CAPITAL LETTER I WITH OGONEK
    Ɨ: 'I', // LATIN CAPITAL LETTER I WITH STROKE
    Ĩ: 'I', // LATIN CAPITAL LETTER I WITH TILDE
    Ḭ: 'I', // LATIN CAPITAL LETTER I WITH TILDE BELOW
    Ꝺ: 'D', // LATIN CAPITAL LETTER INSULAR D
    Ꝼ: 'F', // LATIN CAPITAL LETTER INSULAR F
    Ᵹ: 'G', // LATIN CAPITAL LETTER INSULAR G
    Ꞃ: 'R', // LATIN CAPITAL LETTER INSULAR R
    Ꞅ: 'S', // LATIN CAPITAL LETTER INSULAR S
    Ꞇ: 'T', // LATIN CAPITAL LETTER INSULAR T
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER IOTA' (Ɩ)
    Ꝭ: 'IS', // LATIN CAPITAL LETTER IS
    Ĵ: 'J', // LATIN CAPITAL LETTER J WITH CIRCUMFLEX
    Ɉ: 'J', // LATIN CAPITAL LETTER J WITH STROKE
    Ḱ: 'K', // LATIN CAPITAL LETTER K WITH ACUTE
    Ǩ: 'K', // LATIN CAPITAL LETTER K WITH CARON
    Ķ: 'K', // LATIN CAPITAL LETTER K WITH CEDILLA
    Ⱪ: 'K', // LATIN CAPITAL LETTER K WITH DESCENDER
    Ꝃ: 'K', // LATIN CAPITAL LETTER K WITH DIAGONAL STROKE
    Ḳ: 'K', // LATIN CAPITAL LETTER K WITH DOT BELOW
    Ƙ: 'K', // LATIN CAPITAL LETTER K WITH HOOK
    Ḵ: 'K', // LATIN CAPITAL LETTER K WITH LINE BELOW
    Ꝁ: 'K', // LATIN CAPITAL LETTER K WITH STROKE
    Ꝅ: 'K', // LATIN CAPITAL LETTER K WITH STROKE AND DIAGONAL STROKE
    Ĺ: 'L', // LATIN CAPITAL LETTER L WITH ACUTE
    Ƚ: 'L', // LATIN CAPITAL LETTER L WITH BAR
    Ľ: 'L', // LATIN CAPITAL LETTER L WITH CARON
    Ļ: 'L', // LATIN CAPITAL LETTER L WITH CEDILLA
    Ḽ: 'L', // LATIN CAPITAL LETTER L WITH CIRCUMFLEX BELOW
    Ḷ: 'L', // LATIN CAPITAL LETTER L WITH DOT BELOW
    Ḹ: 'L', // LATIN CAPITAL LETTER L WITH DOT BELOW AND MACRON
    Ⱡ: 'L', // LATIN CAPITAL LETTER L WITH DOUBLE BAR
    Ꝉ: 'L', // LATIN CAPITAL LETTER L WITH HIGH STROKE
    Ḻ: 'L', // LATIN CAPITAL LETTER L WITH LINE BELOW
    Ŀ: 'L', // LATIN CAPITAL LETTER L WITH MIDDLE DOT
    Ɫ: 'L', // LATIN CAPITAL LETTER L WITH MIDDLE TILDE
    ǈ: 'L', // LATIN CAPITAL LETTER L WITH SMALL LETTER J
    Ł: 'L', // LATIN CAPITAL LETTER L WITH STROKE
    Ǉ: 'LJ', // LATIN CAPITAL LETTER LJ
    Ḿ: 'M', // LATIN CAPITAL LETTER M WITH ACUTE
    Ṁ: 'M', // LATIN CAPITAL LETTER M WITH DOT ABOVE
    Ṃ: 'M', // LATIN CAPITAL LETTER M WITH DOT BELOW
    Ɱ: 'M', // LATIN CAPITAL LETTER M WITH HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER MIDDLE-WELSH LL' (Ỻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER MIDDLE-WELSH V' (Ỽ)
    Ń: 'N', // LATIN CAPITAL LETTER N WITH ACUTE
    Ň: 'N', // LATIN CAPITAL LETTER N WITH CARON
    Ņ: 'N', // LATIN CAPITAL LETTER N WITH CEDILLA
    Ṋ: 'N', // LATIN CAPITAL LETTER N WITH CIRCUMFLEX BELOW
    Ṅ: 'N', // LATIN CAPITAL LETTER N WITH DOT ABOVE
    Ṇ: 'N', // LATIN CAPITAL LETTER N WITH DOT BELOW
    Ǹ: 'N', // LATIN CAPITAL LETTER N WITH GRAVE
    Ɲ: 'N', // LATIN CAPITAL LETTER N WITH LEFT HOOK
    Ṉ: 'N', // LATIN CAPITAL LETTER N WITH LINE BELOW
    Ƞ: 'N', // LATIN CAPITAL LETTER N WITH LONG RIGHT LEG
    ǋ: 'N', // LATIN CAPITAL LETTER N WITH SMALL LETTER J
    Ñ: 'N', // LATIN CAPITAL LETTER N WITH TILDE
    Ǌ: 'NJ', // LATIN CAPITAL LETTER NJ
    Ó: 'O', // LATIN CAPITAL LETTER O WITH ACUTE
    Ŏ: 'O', // LATIN CAPITAL LETTER O WITH BREVE
    Ǒ: 'O', // LATIN CAPITAL LETTER O WITH CARON
    Ô: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX
    Ố: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND ACUTE
    Ộ: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND DOT BELOW
    Ồ: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND GRAVE
    Ổ: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND HOOK ABOVE
    Ỗ: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND TILDE
    Ö: 'O', // LATIN CAPITAL LETTER O WITH DIAERESIS
    Ȫ: 'O', // LATIN CAPITAL LETTER O WITH DIAERESIS AND MACRON
    Ȯ: 'O', // LATIN CAPITAL LETTER O WITH DOT ABOVE
    Ȱ: 'O', // LATIN CAPITAL LETTER O WITH DOT ABOVE AND MACRON
    Ọ: 'O', // LATIN CAPITAL LETTER O WITH DOT BELOW
    Ő: 'O', // LATIN CAPITAL LETTER O WITH DOUBLE ACUTE
    Ȍ: 'O', // LATIN CAPITAL LETTER O WITH DOUBLE GRAVE
    Ò: 'O', // LATIN CAPITAL LETTER O WITH GRAVE
    Ỏ: 'O', // LATIN CAPITAL LETTER O WITH HOOK ABOVE
    Ơ: 'O', // LATIN CAPITAL LETTER O WITH HORN
    Ớ: 'O', // LATIN CAPITAL LETTER O WITH HORN AND ACUTE
    Ợ: 'O', // LATIN CAPITAL LETTER O WITH HORN AND DOT BELOW
    Ờ: 'O', // LATIN CAPITAL LETTER O WITH HORN AND GRAVE
    Ở: 'O', // LATIN CAPITAL LETTER O WITH HORN AND HOOK ABOVE
    Ỡ: 'O', // LATIN CAPITAL LETTER O WITH HORN AND TILDE
    Ȏ: 'O', // LATIN CAPITAL LETTER O WITH INVERTED BREVE
    Ꝋ: 'O', // LATIN CAPITAL LETTER O WITH LONG STROKE OVERLAY
    Ꝍ: 'O', // LATIN CAPITAL LETTER O WITH LOOP
    Ō: 'O', // LATIN CAPITAL LETTER O WITH MACRON
    Ṓ: 'O', // LATIN CAPITAL LETTER O WITH MACRON AND ACUTE
    Ṑ: 'O', // LATIN CAPITAL LETTER O WITH MACRON AND GRAVE
    Ɵ: 'O', // LATIN CAPITAL LETTER O WITH MIDDLE TILDE
    Ǫ: 'O', // LATIN CAPITAL LETTER O WITH OGONEK
    Ǭ: 'O', // LATIN CAPITAL LETTER O WITH OGONEK AND MACRON
    Ø: 'O', // LATIN CAPITAL LETTER O WITH STROKE
    Ǿ: 'O', // LATIN CAPITAL LETTER O WITH STROKE AND ACUTE
    Õ: 'O', // LATIN CAPITAL LETTER O WITH TILDE
    Ṍ: 'O', // LATIN CAPITAL LETTER O WITH TILDE AND ACUTE
    Ṏ: 'O', // LATIN CAPITAL LETTER O WITH TILDE AND DIAERESIS
    Ȭ: 'O', // LATIN CAPITAL LETTER O WITH TILDE AND MACRON
    Ƣ: 'OI', // LATIN CAPITAL LETTER OI
    Ꝏ: 'OO', // LATIN CAPITAL LETTER OO
    Ɛ: 'E', // LATIN CAPITAL LETTER OPEN E
    Ɔ: 'O', // LATIN CAPITAL LETTER OPEN O
    Ȣ: 'OU', // LATIN CAPITAL LETTER OU
    Ṕ: 'P', // LATIN CAPITAL LETTER P WITH ACUTE
    Ṗ: 'P', // LATIN CAPITAL LETTER P WITH DOT ABOVE
    Ꝓ: 'P', // LATIN CAPITAL LETTER P WITH FLOURISH
    Ƥ: 'P', // LATIN CAPITAL LETTER P WITH HOOK
    Ꝕ: 'P', // LATIN CAPITAL LETTER P WITH SQUIRREL TAIL
    Ᵽ: 'P', // LATIN CAPITAL LETTER P WITH STROKE
    Ꝑ: 'P', // LATIN CAPITAL LETTER P WITH STROKE THROUGH DESCENDER
    Ꝙ: 'Q', // LATIN CAPITAL LETTER Q WITH DIAGONAL STROKE
    Ꝗ: 'Q', // LATIN CAPITAL LETTER Q WITH STROKE THROUGH DESCENDER
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER R ROTUNDA' (Ꝛ)
    Ŕ: 'R', // LATIN CAPITAL LETTER R WITH ACUTE
    Ř: 'R', // LATIN CAPITAL LETTER R WITH CARON
    Ŗ: 'R', // LATIN CAPITAL LETTER R WITH CEDILLA
    Ṙ: 'R', // LATIN CAPITAL LETTER R WITH DOT ABOVE
    Ṛ: 'R', // LATIN CAPITAL LETTER R WITH DOT BELOW
    Ṝ: 'R', // LATIN CAPITAL LETTER R WITH DOT BELOW AND MACRON
    Ȑ: 'R', // LATIN CAPITAL LETTER R WITH DOUBLE GRAVE
    Ȓ: 'R', // LATIN CAPITAL LETTER R WITH INVERTED BREVE
    Ṟ: 'R', // LATIN CAPITAL LETTER R WITH LINE BELOW
    Ɍ: 'R', // LATIN CAPITAL LETTER R WITH STROKE
    Ɽ: 'R', // LATIN CAPITAL LETTER R WITH TAIL
    Ꜿ: 'C', // LATIN CAPITAL LETTER REVERSED C WITH DOT
    Ǝ: 'E', // LATIN CAPITAL LETTER REVERSED E
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER RUM ROTUNDA' (Ꝝ)
    Ś: 'S', // LATIN CAPITAL LETTER S WITH ACUTE
    Ṥ: 'S', // LATIN CAPITAL LETTER S WITH ACUTE AND DOT ABOVE
    Š: 'S', // LATIN CAPITAL LETTER S WITH CARON
    Ṧ: 'S', // LATIN CAPITAL LETTER S WITH CARON AND DOT ABOVE
    Ş: 'S', // LATIN CAPITAL LETTER S WITH CEDILLA
    Ŝ: 'S', // LATIN CAPITAL LETTER S WITH CIRCUMFLEX
    Ș: 'S', // LATIN CAPITAL LETTER S WITH COMMA BELOW
    Ṡ: 'S', // LATIN CAPITAL LETTER S WITH DOT ABOVE
    Ṣ: 'S', // LATIN CAPITAL LETTER S WITH DOT BELOW
    Ṩ: 'S', // LATIN CAPITAL LETTER S WITH DOT BELOW AND DOT ABOVE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SALTILLO' (Ꞌ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SCHWA' (Ə)
    ẞ: 'SS', // LATIN CAPITAL LETTER SHARP S
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SMALL Q WITH HOOK TAIL' (Ɋ)
    Ť: 'T', // LATIN CAPITAL LETTER T WITH CARON
    Ţ: 'T', // LATIN CAPITAL LETTER T WITH CEDILLA
    Ṱ: 'T', // LATIN CAPITAL LETTER T WITH CIRCUMFLEX BELOW
    Ț: 'T', // LATIN CAPITAL LETTER T WITH COMMA BELOW
    Ⱦ: 'T', // LATIN CAPITAL LETTER T WITH DIAGONAL STROKE
    Ṫ: 'T', // LATIN CAPITAL LETTER T WITH DOT ABOVE
    Ṭ: 'T', // LATIN CAPITAL LETTER T WITH DOT BELOW
    Ƭ: 'T', // LATIN CAPITAL LETTER T WITH HOOK
    Ṯ: 'T', // LATIN CAPITAL LETTER T WITH LINE BELOW
    Ʈ: 'T', // LATIN CAPITAL LETTER T WITH RETROFLEX HOOK
    Ŧ: 'T', // LATIN CAPITAL LETTER T WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN' (Þ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN WITH STROKE' (Ꝥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN WITH STROKE THROUGH DESCENDER' (Ꝧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE FIVE' (Ƽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE SIX' (Ƅ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE TWO' (Ƨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TRESILLO' (Ꜫ)
    Ɐ: 'A', // LATIN CAPITAL LETTER TURNED A
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TURNED INSULAR G' (Ꝿ)
    Ꞁ: 'L', // LATIN CAPITAL LETTER TURNED L
    Ɯ: 'M', // LATIN CAPITAL LETTER TURNED M
    Ʌ: 'V', // LATIN CAPITAL LETTER TURNED V
    Ꜩ: 'TZ', // LATIN CAPITAL LETTER TZ
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER U BAR' (Ʉ)
    Ú: 'U', // LATIN CAPITAL LETTER U WITH ACUTE
    Ŭ: 'U', // LATIN CAPITAL LETTER U WITH BREVE
    Ǔ: 'U', // LATIN CAPITAL LETTER U WITH CARON
    Û: 'U', // LATIN CAPITAL LETTER U WITH CIRCUMFLEX
    Ṷ: 'U', // LATIN CAPITAL LETTER U WITH CIRCUMFLEX BELOW
    Ü: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS
    Ǘ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS AND ACUTE
    Ǚ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS AND CARON
    Ǜ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS AND GRAVE
    Ǖ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS AND MACRON
    Ṳ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS BELOW
    Ụ: 'U', // LATIN CAPITAL LETTER U WITH DOT BELOW
    Ű: 'U', // LATIN CAPITAL LETTER U WITH DOUBLE ACUTE
    Ȕ: 'U', // LATIN CAPITAL LETTER U WITH DOUBLE GRAVE
    Ù: 'U', // LATIN CAPITAL LETTER U WITH GRAVE
    Ủ: 'U', // LATIN CAPITAL LETTER U WITH HOOK ABOVE
    Ư: 'U', // LATIN CAPITAL LETTER U WITH HORN
    Ứ: 'U', // LATIN CAPITAL LETTER U WITH HORN AND ACUTE
    Ự: 'U', // LATIN CAPITAL LETTER U WITH HORN AND DOT BELOW
    Ừ: 'U', // LATIN CAPITAL LETTER U WITH HORN AND GRAVE
    Ử: 'U', // LATIN CAPITAL LETTER U WITH HORN AND HOOK ABOVE
    Ữ: 'U', // LATIN CAPITAL LETTER U WITH HORN AND TILDE
    Ȗ: 'U', // LATIN CAPITAL LETTER U WITH INVERTED BREVE
    Ū: 'U', // LATIN CAPITAL LETTER U WITH MACRON
    Ṻ: 'U', // LATIN CAPITAL LETTER U WITH MACRON AND DIAERESIS
    Ų: 'U', // LATIN CAPITAL LETTER U WITH OGONEK
    Ů: 'U', // LATIN CAPITAL LETTER U WITH RING ABOVE
    Ũ: 'U', // LATIN CAPITAL LETTER U WITH TILDE
    Ṹ: 'U', // LATIN CAPITAL LETTER U WITH TILDE AND ACUTE
    Ṵ: 'U', // LATIN CAPITAL LETTER U WITH TILDE BELOW
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER UPSILON' (Ʊ)
    Ꝟ: 'V', // LATIN CAPITAL LETTER V WITH DIAGONAL STROKE
    Ṿ: 'V', // LATIN CAPITAL LETTER V WITH DOT BELOW
    Ʋ: 'V', // LATIN CAPITAL LETTER V WITH HOOK
    Ṽ: 'V', // LATIN CAPITAL LETTER V WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER VEND' (Ꝩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER VISIGOTHIC Z' (Ꝣ)
    Ꝡ: 'VY', // LATIN CAPITAL LETTER VY
    Ẃ: 'W', // LATIN CAPITAL LETTER W WITH ACUTE
    Ŵ: 'W', // LATIN CAPITAL LETTER W WITH CIRCUMFLEX
    Ẅ: 'W', // LATIN CAPITAL LETTER W WITH DIAERESIS
    Ẇ: 'W', // LATIN CAPITAL LETTER W WITH DOT ABOVE
    Ẉ: 'W', // LATIN CAPITAL LETTER W WITH DOT BELOW
    Ẁ: 'W', // LATIN CAPITAL LETTER W WITH GRAVE
    Ⱳ: 'W', // LATIN CAPITAL LETTER W WITH HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER WYNN' (Ƿ)
    Ẍ: 'X', // LATIN CAPITAL LETTER X WITH DIAERESIS
    Ẋ: 'X', // LATIN CAPITAL LETTER X WITH DOT ABOVE
    Ý: 'Y', // LATIN CAPITAL LETTER Y WITH ACUTE
    Ŷ: 'Y', // LATIN CAPITAL LETTER Y WITH CIRCUMFLEX
    Ÿ: 'Y', // LATIN CAPITAL LETTER Y WITH DIAERESIS
    Ẏ: 'Y', // LATIN CAPITAL LETTER Y WITH DOT ABOVE
    Ỵ: 'Y', // LATIN CAPITAL LETTER Y WITH DOT BELOW
    Ỳ: 'Y', // LATIN CAPITAL LETTER Y WITH GRAVE
    Ƴ: 'Y', // LATIN CAPITAL LETTER Y WITH HOOK
    Ỷ: 'Y', // LATIN CAPITAL LETTER Y WITH HOOK ABOVE
    Ỿ: 'Y', // LATIN CAPITAL LETTER Y WITH LOOP
    Ȳ: 'Y', // LATIN CAPITAL LETTER Y WITH MACRON
    Ɏ: 'Y', // LATIN CAPITAL LETTER Y WITH STROKE
    Ỹ: 'Y', // LATIN CAPITAL LETTER Y WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER YOGH' (Ȝ)
    Ź: 'Z', // LATIN CAPITAL LETTER Z WITH ACUTE
    Ž: 'Z', // LATIN CAPITAL LETTER Z WITH CARON
    Ẑ: 'Z', // LATIN CAPITAL LETTER Z WITH CIRCUMFLEX
    Ⱬ: 'Z', // LATIN CAPITAL LETTER Z WITH DESCENDER
    Ż: 'Z', // LATIN CAPITAL LETTER Z WITH DOT ABOVE
    Ẓ: 'Z', // LATIN CAPITAL LETTER Z WITH DOT BELOW
    Ȥ: 'Z', // LATIN CAPITAL LETTER Z WITH HOOK
    Ẕ: 'Z', // LATIN CAPITAL LETTER Z WITH LINE BELOW
    Ƶ: 'Z', // LATIN CAPITAL LETTER Z WITH STROKE
    Ĳ: 'IJ', // LATIN CAPITAL LIGATURE IJ
    Œ: 'OE', // LATIN CAPITAL LIGATURE OE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CROSS' (✝)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER ARCHAIC M' (ꟿ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER I LONGA' (ꟾ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER INVERTED M' (ꟽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER REVERSED F' (ꟻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER REVERSED P' (ꟼ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER AIN' (ᴥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER ALVEOLAR CLICK' (ǂ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BIDENTAL PERCUSSIVE' (ʭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BILABIAL CLICK' (ʘ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BILABIAL PERCUSSIVE' (ʬ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER DENTAL CLICK' (ǀ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER GLOTTAL STOP' (ʔ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER GLOTTAL STOP WITH STROKE' (ʡ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER INVERTED GLOTTAL STOP' (ʖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER INVERTED GLOTTAL STOP WITH STROKE' (ƾ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER LATERAL CLICK' (ǁ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER PHARYNGEAL VOICED FRICATIVE' (ʕ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER RETROFLEX CLICK' (ǃ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER REVERSED ESH LOOP' (ƪ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER REVERSED GLOTTAL STOP WITH STROKE' (ʢ)
    ᴀ: 'A', // LATIN LETTER SMALL CAPITAL A
    ᴁ: 'AE', // LATIN LETTER SMALL CAPITAL AE
    ʙ: 'B', // LATIN LETTER SMALL CAPITAL B
    ᴃ: 'B', // LATIN LETTER SMALL CAPITAL BARRED B
    ᴄ: 'C', // LATIN LETTER SMALL CAPITAL C
    ᴅ: 'D', // LATIN LETTER SMALL CAPITAL D
    ᴇ: 'E', // LATIN LETTER SMALL CAPITAL E
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL ETH' (ᴆ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL EZH' (ᴣ)
    ꜰ: 'F', // LATIN LETTER SMALL CAPITAL F
    ɢ: 'G', // LATIN LETTER SMALL CAPITAL G
    ʛ: 'G', // LATIN LETTER SMALL CAPITAL G WITH HOOK
    ʜ: 'H', // LATIN LETTER SMALL CAPITAL H
    ɪ: 'I', // LATIN LETTER SMALL CAPITAL I
    ʁ: 'R', // LATIN LETTER SMALL CAPITAL INVERTED R
    ᴊ: 'J', // LATIN LETTER SMALL CAPITAL J
    ᴋ: 'K', // LATIN LETTER SMALL CAPITAL K
    ʟ: 'L', // LATIN LETTER SMALL CAPITAL L
    ᴌ: 'L', // LATIN LETTER SMALL CAPITAL L WITH STROKE
    ᴍ: 'M', // LATIN LETTER SMALL CAPITAL M
    ɴ: 'N', // LATIN LETTER SMALL CAPITAL N
    ᴏ: 'O', // LATIN LETTER SMALL CAPITAL O
    ɶ: 'OE', // LATIN LETTER SMALL CAPITAL OE
    ᴐ: 'O', // LATIN LETTER SMALL CAPITAL OPEN O
    ᴕ: 'OU', // LATIN LETTER SMALL CAPITAL OU
    ᴘ: 'P', // LATIN LETTER SMALL CAPITAL P
    ʀ: 'R', // LATIN LETTER SMALL CAPITAL R
    ᴎ: 'N', // LATIN LETTER SMALL CAPITAL REVERSED N
    ᴙ: 'R', // LATIN LETTER SMALL CAPITAL REVERSED R
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL RUM' (ꝶ)
    ꜱ: 'S', // LATIN LETTER SMALL CAPITAL S
    ᴛ: 'T', // LATIN LETTER SMALL CAPITAL T
    ⱻ: 'E', // LATIN LETTER SMALL CAPITAL TURNED E
    ᴚ: 'R', // LATIN LETTER SMALL CAPITAL TURNED R
    ᴜ: 'U', // LATIN LETTER SMALL CAPITAL U
    ᴠ: 'V', // LATIN LETTER SMALL CAPITAL V
    ᴡ: 'W', // LATIN LETTER SMALL CAPITAL W
    ʏ: 'Y', // LATIN LETTER SMALL CAPITAL Y
    ᴢ: 'Z', // LATIN LETTER SMALL CAPITAL Z
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER STRETCHED C' (ʗ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER TWO WITH STROKE' (ƻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER VOICED LARYNGEAL SPIRANT' (ᴤ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER WYNN' (ƿ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER YR' (Ʀ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL CAPITAL LETTER I WITH STROKE' (ᵻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL CAPITAL LETTER U WITH STROKE' (ᵾ)
    á: 'a', // LATIN SMALL LETTER A WITH ACUTE
    ă: 'a', // LATIN SMALL LETTER A WITH BREVE
    ắ: 'a', // LATIN SMALL LETTER A WITH BREVE AND ACUTE
    ặ: 'a', // LATIN SMALL LETTER A WITH BREVE AND DOT BELOW
    ằ: 'a', // LATIN SMALL LETTER A WITH BREVE AND GRAVE
    ẳ: 'a', // LATIN SMALL LETTER A WITH BREVE AND HOOK ABOVE
    ẵ: 'a', // LATIN SMALL LETTER A WITH BREVE AND TILDE
    ǎ: 'a', // LATIN SMALL LETTER A WITH CARON
    â: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX
    ấ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND ACUTE
    ậ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND DOT BELOW
    ầ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND GRAVE
    ẩ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND HOOK ABOVE
    ẫ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND TILDE
    ä: 'a', // LATIN SMALL LETTER A WITH DIAERESIS
    ǟ: 'a', // LATIN SMALL LETTER A WITH DIAERESIS AND MACRON
    ȧ: 'a', // LATIN SMALL LETTER A WITH DOT ABOVE
    ǡ: 'a', // LATIN SMALL LETTER A WITH DOT ABOVE AND MACRON
    ạ: 'a', // LATIN SMALL LETTER A WITH DOT BELOW
    ȁ: 'a', // LATIN SMALL LETTER A WITH DOUBLE GRAVE
    à: 'a', // LATIN SMALL LETTER A WITH GRAVE
    ả: 'a', // LATIN SMALL LETTER A WITH HOOK ABOVE
    ȃ: 'a', // LATIN SMALL LETTER A WITH INVERTED BREVE
    ā: 'a', // LATIN SMALL LETTER A WITH MACRON
    ą: 'a', // LATIN SMALL LETTER A WITH OGONEK
    ᶏ: 'a', // LATIN SMALL LETTER A WITH RETROFLEX HOOK
    ẚ: 'a', // LATIN SMALL LETTER A WITH RIGHT HALF RING
    å: 'a', // LATIN SMALL LETTER A WITH RING ABOVE
    ǻ: 'a', // LATIN SMALL LETTER A WITH RING ABOVE AND ACUTE
    ḁ: 'a', // LATIN SMALL LETTER A WITH RING BELOW
    ⱥ: 'a', // LATIN SMALL LETTER A WITH STROKE
    ã: 'a', // LATIN SMALL LETTER A WITH TILDE
    ꜳ: 'aa', // LATIN SMALL LETTER AA
    æ: 'ae', // LATIN SMALL LETTER AE
    ǽ: 'ae', // LATIN SMALL LETTER AE WITH ACUTE
    ǣ: 'ae', // LATIN SMALL LETTER AE WITH MACRON
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ALPHA' (ɑ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ALPHA WITH RETROFLEX HOOK' (ᶐ)
    ꜵ: 'ao', // LATIN SMALL LETTER AO
    ꜷ: 'au', // LATIN SMALL LETTER AU
    ꜹ: 'av', // LATIN SMALL LETTER AV
    ꜻ: 'av', // LATIN SMALL LETTER AV WITH HORIZONTAL BAR
    ꜽ: 'ay', // LATIN SMALL LETTER AY
    ḃ: 'b', // LATIN SMALL LETTER B WITH DOT ABOVE
    ḅ: 'b', // LATIN SMALL LETTER B WITH DOT BELOW
    ɓ: 'b', // LATIN SMALL LETTER B WITH HOOK
    ḇ: 'b', // LATIN SMALL LETTER B WITH LINE BELOW
    ᵬ: 'b', // LATIN SMALL LETTER B WITH MIDDLE TILDE
    ᶀ: 'b', // LATIN SMALL LETTER B WITH PALATAL HOOK
    ƀ: 'b', // LATIN SMALL LETTER B WITH STROKE
    ƃ: 'b', // LATIN SMALL LETTER B WITH TOPBAR
    ɵ: 'o', // LATIN SMALL LETTER BARRED O
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER BOTTOM HALF O' (ᴗ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER BROKEN L' (ꝇ)
    ć: 'c', // LATIN SMALL LETTER C WITH ACUTE
    č: 'c', // LATIN SMALL LETTER C WITH CARON
    ç: 'c', // LATIN SMALL LETTER C WITH CEDILLA
    ḉ: 'c', // LATIN SMALL LETTER C WITH CEDILLA AND ACUTE
    ĉ: 'c', // LATIN SMALL LETTER C WITH CIRCUMFLEX
    ɕ: 'c', // LATIN SMALL LETTER C WITH CURL
    ċ: 'c', // LATIN SMALL LETTER C WITH DOT ABOVE
    ƈ: 'c', // LATIN SMALL LETTER C WITH HOOK
    ȼ: 'c', // LATIN SMALL LETTER C WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED OMEGA' (ɷ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED OPEN E' (ʚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED REVERSED OPEN E' (ɞ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CON' (ꝯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CUATRILLO' (ꜭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CUATRILLO WITH COMMA' (ꜯ)
    ď: 'd', // LATIN SMALL LETTER D WITH CARON
    ḑ: 'd', // LATIN SMALL LETTER D WITH CEDILLA
    ḓ: 'd', // LATIN SMALL LETTER D WITH CIRCUMFLEX BELOW
    ȡ: 'd', // LATIN SMALL LETTER D WITH CURL
    ḋ: 'd', // LATIN SMALL LETTER D WITH DOT ABOVE
    ḍ: 'd', // LATIN SMALL LETTER D WITH DOT BELOW
    ɗ: 'd', // LATIN SMALL LETTER D WITH HOOK
    ᶑ: 'd', // LATIN SMALL LETTER D WITH HOOK AND TAIL
    ḏ: 'd', // LATIN SMALL LETTER D WITH LINE BELOW
    ᵭ: 'd', // LATIN SMALL LETTER D WITH MIDDLE TILDE
    ᶁ: 'd', // LATIN SMALL LETTER D WITH PALATAL HOOK
    đ: 'd', // LATIN SMALL LETTER D WITH STROKE
    ɖ: 'd', // LATIN SMALL LETTER D WITH TAIL
    ƌ: 'd', // LATIN SMALL LETTER D WITH TOPBAR
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DB DIGRAPH' (ȸ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DELTA' (ẟ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DEZH DIGRAPH' (ʤ)
    ı: 'i', // LATIN SMALL LETTER DOTLESS I
    ȷ: 'j', // LATIN SMALL LETTER DOTLESS J
    ɟ: 'j', // LATIN SMALL LETTER DOTLESS J WITH STROKE
    ʄ: 'j', // LATIN SMALL LETTER DOTLESS J WITH STROKE AND HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DUM' (ꝱ)
    ǳ: 'dz', // LATIN SMALL LETTER DZ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DZ DIGRAPH' (ʣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DZ DIGRAPH WITH CURL' (ʥ)
    ǆ: 'dz', // LATIN SMALL LETTER DZ WITH CARON
    é: 'e', // LATIN SMALL LETTER E WITH ACUTE
    ĕ: 'e', // LATIN SMALL LETTER E WITH BREVE
    ě: 'e', // LATIN SMALL LETTER E WITH CARON
    ȩ: 'e', // LATIN SMALL LETTER E WITH CEDILLA
    ḝ: 'e', // LATIN SMALL LETTER E WITH CEDILLA AND BREVE
    ê: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX
    ế: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND ACUTE
    ệ: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND DOT BELOW
    ề: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND GRAVE
    ể: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND HOOK ABOVE
    ễ: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND TILDE
    ḙ: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX BELOW
    ë: 'e', // LATIN SMALL LETTER E WITH DIAERESIS
    ė: 'e', // LATIN SMALL LETTER E WITH DOT ABOVE
    ẹ: 'e', // LATIN SMALL LETTER E WITH DOT BELOW
    ȅ: 'e', // LATIN SMALL LETTER E WITH DOUBLE GRAVE
    è: 'e', // LATIN SMALL LETTER E WITH GRAVE
    ẻ: 'e', // LATIN SMALL LETTER E WITH HOOK ABOVE
    ȇ: 'e', // LATIN SMALL LETTER E WITH INVERTED BREVE
    ē: 'e', // LATIN SMALL LETTER E WITH MACRON
    ḗ: 'e', // LATIN SMALL LETTER E WITH MACRON AND ACUTE
    ḕ: 'e', // LATIN SMALL LETTER E WITH MACRON AND GRAVE
    ⱸ: 'e', // LATIN SMALL LETTER E WITH NOTCH
    ę: 'e', // LATIN SMALL LETTER E WITH OGONEK
    ᶒ: 'e', // LATIN SMALL LETTER E WITH RETROFLEX HOOK
    ɇ: 'e', // LATIN SMALL LETTER E WITH STROKE
    ẽ: 'e', // LATIN SMALL LETTER E WITH TILDE
    ḛ: 'e', // LATIN SMALL LETTER E WITH TILDE BELOW
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EGYPTOLOGICAL AIN' (ꜥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EGYPTOLOGICAL ALEF' (ꜣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ENG' (ŋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH' (ʃ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH CURL' (ʆ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH PALATAL HOOK' (ᶋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH RETROFLEX HOOK' (ᶘ)
    ꝫ: 'et', // LATIN SMALL LETTER ET
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ETH' (ð)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH' (ʒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH REVERSED' (ƹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH CARON' (ǯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH CURL' (ʓ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH RETROFLEX HOOK' (ᶚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH TAIL' (ƺ)
    ḟ: 'f', // LATIN SMALL LETTER F WITH DOT ABOVE
    ƒ: 'f', // LATIN SMALL LETTER F WITH HOOK
    ᵮ: 'f', // LATIN SMALL LETTER F WITH MIDDLE TILDE
    ᶂ: 'f', // LATIN SMALL LETTER F WITH PALATAL HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER FENG DIGRAPH' (ʩ)
    ǵ: 'g', // LATIN SMALL LETTER G WITH ACUTE
    ğ: 'g', // LATIN SMALL LETTER G WITH BREVE
    ǧ: 'g', // LATIN SMALL LETTER G WITH CARON
    ģ: 'g', // LATIN SMALL LETTER G WITH CEDILLA
    ĝ: 'g', // LATIN SMALL LETTER G WITH CIRCUMFLEX
    ġ: 'g', // LATIN SMALL LETTER G WITH DOT ABOVE
    ɠ: 'g', // LATIN SMALL LETTER G WITH HOOK
    ḡ: 'g', // LATIN SMALL LETTER G WITH MACRON
    ᶃ: 'g', // LATIN SMALL LETTER G WITH PALATAL HOOK
    ǥ: 'g', // LATIN SMALL LETTER G WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER GAMMA' (ɣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER GLOTTAL STOP' (ɂ)
    ḫ: 'h', // LATIN SMALL LETTER H WITH BREVE BELOW
    ȟ: 'h', // LATIN SMALL LETTER H WITH CARON
    ḩ: 'h', // LATIN SMALL LETTER H WITH CEDILLA
    ĥ: 'h', // LATIN SMALL LETTER H WITH CIRCUMFLEX
    ⱨ: 'h', // LATIN SMALL LETTER H WITH DESCENDER
    ḧ: 'h', // LATIN SMALL LETTER H WITH DIAERESIS
    ḣ: 'h', // LATIN SMALL LETTER H WITH DOT ABOVE
    ḥ: 'h', // LATIN SMALL LETTER H WITH DOT BELOW
    ɦ: 'h', // LATIN SMALL LETTER H WITH HOOK
    ẖ: 'h', // LATIN SMALL LETTER H WITH LINE BELOW
    ħ: 'h', // LATIN SMALL LETTER H WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HALF H' (ⱶ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HENG' (ꜧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HENG WITH HOOK' (ɧ)
    ƕ: 'hv', // LATIN SMALL LETTER HV
    í: 'i', // LATIN SMALL LETTER I WITH ACUTE
    ĭ: 'i', // LATIN SMALL LETTER I WITH BREVE
    ǐ: 'i', // LATIN SMALL LETTER I WITH CARON
    î: 'i', // LATIN SMALL LETTER I WITH CIRCUMFLEX
    ï: 'i', // LATIN SMALL LETTER I WITH DIAERESIS
    ḯ: 'i', // LATIN SMALL LETTER I WITH DIAERESIS AND ACUTE
    ị: 'i', // LATIN SMALL LETTER I WITH DOT BELOW
    ȉ: 'i', // LATIN SMALL LETTER I WITH DOUBLE GRAVE
    ì: 'i', // LATIN SMALL LETTER I WITH GRAVE
    ỉ: 'i', // LATIN SMALL LETTER I WITH HOOK ABOVE
    ȋ: 'i', // LATIN SMALL LETTER I WITH INVERTED BREVE
    ī: 'i', // LATIN SMALL LETTER I WITH MACRON
    į: 'i', // LATIN SMALL LETTER I WITH OGONEK
    ᶖ: 'i', // LATIN SMALL LETTER I WITH RETROFLEX HOOK
    ɨ: 'i', // LATIN SMALL LETTER I WITH STROKE
    ĩ: 'i', // LATIN SMALL LETTER I WITH TILDE
    ḭ: 'i', // LATIN SMALL LETTER I WITH TILDE BELOW
    ꝺ: 'd', // LATIN SMALL LETTER INSULAR D
    ꝼ: 'f', // LATIN SMALL LETTER INSULAR F
    ᵹ: 'g', // LATIN SMALL LETTER INSULAR G
    ꞃ: 'r', // LATIN SMALL LETTER INSULAR R
    ꞅ: 's', // LATIN SMALL LETTER INSULAR S
    ꞇ: 't', // LATIN SMALL LETTER INSULAR T
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER IOTA' (ɩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER IOTA WITH STROKE' (ᵼ)
    ꝭ: 'is', // LATIN SMALL LETTER IS
    ǰ: 'j', // LATIN SMALL LETTER J WITH CARON
    ĵ: 'j', // LATIN SMALL LETTER J WITH CIRCUMFLEX
    ʝ: 'j', // LATIN SMALL LETTER J WITH CROSSED-TAIL
    ɉ: 'j', // LATIN SMALL LETTER J WITH STROKE
    ḱ: 'k', // LATIN SMALL LETTER K WITH ACUTE
    ǩ: 'k', // LATIN SMALL LETTER K WITH CARON
    ķ: 'k', // LATIN SMALL LETTER K WITH CEDILLA
    ⱪ: 'k', // LATIN SMALL LETTER K WITH DESCENDER
    ꝃ: 'k', // LATIN SMALL LETTER K WITH DIAGONAL STROKE
    ḳ: 'k', // LATIN SMALL LETTER K WITH DOT BELOW
    ƙ: 'k', // LATIN SMALL LETTER K WITH HOOK
    ḵ: 'k', // LATIN SMALL LETTER K WITH LINE BELOW
    ᶄ: 'k', // LATIN SMALL LETTER K WITH PALATAL HOOK
    ꝁ: 'k', // LATIN SMALL LETTER K WITH STROKE
    ꝅ: 'k', // LATIN SMALL LETTER K WITH STROKE AND DIAGONAL STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER KRA' (ĸ)
    ĺ: 'l', // LATIN SMALL LETTER L WITH ACUTE
    ƚ: 'l', // LATIN SMALL LETTER L WITH BAR
    ɬ: 'l', // LATIN SMALL LETTER L WITH BELT
    ľ: 'l', // LATIN SMALL LETTER L WITH CARON
    ļ: 'l', // LATIN SMALL LETTER L WITH CEDILLA
    ḽ: 'l', // LATIN SMALL LETTER L WITH CIRCUMFLEX BELOW
    ȴ: 'l', // LATIN SMALL LETTER L WITH CURL
    ḷ: 'l', // LATIN SMALL LETTER L WITH DOT BELOW
    ḹ: 'l', // LATIN SMALL LETTER L WITH DOT BELOW AND MACRON
    ⱡ: 'l', // LATIN SMALL LETTER L WITH DOUBLE BAR
    ꝉ: 'l', // LATIN SMALL LETTER L WITH HIGH STROKE
    ḻ: 'l', // LATIN SMALL LETTER L WITH LINE BELOW
    ŀ: 'l', // LATIN SMALL LETTER L WITH MIDDLE DOT
    ɫ: 'l', // LATIN SMALL LETTER L WITH MIDDLE TILDE
    ᶅ: 'l', // LATIN SMALL LETTER L WITH PALATAL HOOK
    ɭ: 'l', // LATIN SMALL LETTER L WITH RETROFLEX HOOK
    ł: 'l', // LATIN SMALL LETTER L WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LAMBDA WITH STROKE' (ƛ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LEZH' (ɮ)
    ǉ: 'lj', // LATIN SMALL LETTER LJ
    ſ: 's', // LATIN SMALL LETTER LONG S
    ẜ: 's', // LATIN SMALL LETTER LONG S WITH DIAGONAL STROKE
    ẛ: 's', // LATIN SMALL LETTER LONG S WITH DOT ABOVE
    ẝ: 's', // LATIN SMALL LETTER LONG S WITH HIGH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LS DIGRAPH' (ʪ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LUM' (ꝲ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LZ DIGRAPH' (ʫ)
    ḿ: 'm', // LATIN SMALL LETTER M WITH ACUTE
    ṁ: 'm', // LATIN SMALL LETTER M WITH DOT ABOVE
    ṃ: 'm', // LATIN SMALL LETTER M WITH DOT BELOW
    ɱ: 'm', // LATIN SMALL LETTER M WITH HOOK
    ᵯ: 'm', // LATIN SMALL LETTER M WITH MIDDLE TILDE
    ᶆ: 'm', // LATIN SMALL LETTER M WITH PALATAL HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MIDDLE-WELSH LL' (ỻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MIDDLE-WELSH V' (ỽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MUM' (ꝳ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER N PRECEDED BY APOSTROPHE' (ŉ)
    ń: 'n', // LATIN SMALL LETTER N WITH ACUTE
    ň: 'n', // LATIN SMALL LETTER N WITH CARON
    ņ: 'n', // LATIN SMALL LETTER N WITH CEDILLA
    ṋ: 'n', // LATIN SMALL LETTER N WITH CIRCUMFLEX BELOW
    ȵ: 'n', // LATIN SMALL LETTER N WITH CURL
    ṅ: 'n', // LATIN SMALL LETTER N WITH DOT ABOVE
    ṇ: 'n', // LATIN SMALL LETTER N WITH DOT BELOW
    ǹ: 'n', // LATIN SMALL LETTER N WITH GRAVE
    ɲ: 'n', // LATIN SMALL LETTER N WITH LEFT HOOK
    ṉ: 'n', // LATIN SMALL LETTER N WITH LINE BELOW
    ƞ: 'n', // LATIN SMALL LETTER N WITH LONG RIGHT LEG
    ᵰ: 'n', // LATIN SMALL LETTER N WITH MIDDLE TILDE
    ᶇ: 'n', // LATIN SMALL LETTER N WITH PALATAL HOOK
    ɳ: 'n', // LATIN SMALL LETTER N WITH RETROFLEX HOOK
    ñ: 'n', // LATIN SMALL LETTER N WITH TILDE
    ǌ: 'nj', // LATIN SMALL LETTER NJ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER NUM' (ꝴ)
    ó: 'o', // LATIN SMALL LETTER O WITH ACUTE
    ŏ: 'o', // LATIN SMALL LETTER O WITH BREVE
    ǒ: 'o', // LATIN SMALL LETTER O WITH CARON
    ô: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX
    ố: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND ACUTE
    ộ: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND DOT BELOW
    ồ: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND GRAVE
    ổ: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND HOOK ABOVE
    ỗ: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND TILDE
    ö: 'o', // LATIN SMALL LETTER O WITH DIAERESIS
    ȫ: 'o', // LATIN SMALL LETTER O WITH DIAERESIS AND MACRON
    ȯ: 'o', // LATIN SMALL LETTER O WITH DOT ABOVE
    ȱ: 'o', // LATIN SMALL LETTER O WITH DOT ABOVE AND MACRON
    ọ: 'o', // LATIN SMALL LETTER O WITH DOT BELOW
    ő: 'o', // LATIN SMALL LETTER O WITH DOUBLE ACUTE
    ȍ: 'o', // LATIN SMALL LETTER O WITH DOUBLE GRAVE
    ò: 'o', // LATIN SMALL LETTER O WITH GRAVE
    ỏ: 'o', // LATIN SMALL LETTER O WITH HOOK ABOVE
    ơ: 'o', // LATIN SMALL LETTER O WITH HORN
    ớ: 'o', // LATIN SMALL LETTER O WITH HORN AND ACUTE
    ợ: 'o', // LATIN SMALL LETTER O WITH HORN AND DOT BELOW
    ờ: 'o', // LATIN SMALL LETTER O WITH HORN AND GRAVE
    ở: 'o', // LATIN SMALL LETTER O WITH HORN AND HOOK ABOVE
    ỡ: 'o', // LATIN SMALL LETTER O WITH HORN AND TILDE
    ȏ: 'o', // LATIN SMALL LETTER O WITH INVERTED BREVE
    ꝋ: 'o', // LATIN SMALL LETTER O WITH LONG STROKE OVERLAY
    ꝍ: 'o', // LATIN SMALL LETTER O WITH LOOP
    ⱺ: 'o', // LATIN SMALL LETTER O WITH LOW RING INSIDE
    ō: 'o', // LATIN SMALL LETTER O WITH MACRON
    ṓ: 'o', // LATIN SMALL LETTER O WITH MACRON AND ACUTE
    ṑ: 'o', // LATIN SMALL LETTER O WITH MACRON AND GRAVE
    ǫ: 'o', // LATIN SMALL LETTER O WITH OGONEK
    ǭ: 'o', // LATIN SMALL LETTER O WITH OGONEK AND MACRON
    ø: 'o', // LATIN SMALL LETTER O WITH STROKE
    ǿ: 'o', // LATIN SMALL LETTER O WITH STROKE AND ACUTE
    õ: 'o', // LATIN SMALL LETTER O WITH TILDE
    ṍ: 'o', // LATIN SMALL LETTER O WITH TILDE AND ACUTE
    ṏ: 'o', // LATIN SMALL LETTER O WITH TILDE AND DIAERESIS
    ȭ: 'o', // LATIN SMALL LETTER O WITH TILDE AND MACRON
    ƣ: 'oi', // LATIN SMALL LETTER OI
    ꝏ: 'oo', // LATIN SMALL LETTER OO
    ɛ: 'e', // LATIN SMALL LETTER OPEN E
    ᶓ: 'e', // LATIN SMALL LETTER OPEN E WITH RETROFLEX HOOK
    ɔ: 'o', // LATIN SMALL LETTER OPEN O
    ᶗ: 'o', // LATIN SMALL LETTER OPEN O WITH RETROFLEX HOOK
    ȣ: 'ou', // LATIN SMALL LETTER OU
    ṕ: 'p', // LATIN SMALL LETTER P WITH ACUTE
    ṗ: 'p', // LATIN SMALL LETTER P WITH DOT ABOVE
    ꝓ: 'p', // LATIN SMALL LETTER P WITH FLOURISH
    ƥ: 'p', // LATIN SMALL LETTER P WITH HOOK
    ᵱ: 'p', // LATIN SMALL LETTER P WITH MIDDLE TILDE
    ᶈ: 'p', // LATIN SMALL LETTER P WITH PALATAL HOOK
    ꝕ: 'p', // LATIN SMALL LETTER P WITH SQUIRREL TAIL
    ᵽ: 'p', // LATIN SMALL LETTER P WITH STROKE
    ꝑ: 'p', // LATIN SMALL LETTER P WITH STROKE THROUGH DESCENDER
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER PHI' (ɸ)
    ꝙ: 'q', // LATIN SMALL LETTER Q WITH DIAGONAL STROKE
    ʠ: 'q', // LATIN SMALL LETTER Q WITH HOOK
    ɋ: 'q', // LATIN SMALL LETTER Q WITH HOOK TAIL
    ꝗ: 'q', // LATIN SMALL LETTER Q WITH STROKE THROUGH DESCENDER
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER QP DIGRAPH' (ȹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER R ROTUNDA' (ꝛ)
    ŕ: 'r', // LATIN SMALL LETTER R WITH ACUTE
    ř: 'r', // LATIN SMALL LETTER R WITH CARON
    ŗ: 'r', // LATIN SMALL LETTER R WITH CEDILLA
    ṙ: 'r', // LATIN SMALL LETTER R WITH DOT ABOVE
    ṛ: 'r', // LATIN SMALL LETTER R WITH DOT BELOW
    ṝ: 'r', // LATIN SMALL LETTER R WITH DOT BELOW AND MACRON
    ȑ: 'r', // LATIN SMALL LETTER R WITH DOUBLE GRAVE
    ɾ: 'r', // LATIN SMALL LETTER R WITH FISHHOOK
    ᵳ: 'r', // LATIN SMALL LETTER R WITH FISHHOOK AND MIDDLE TILDE
    ȓ: 'r', // LATIN SMALL LETTER R WITH INVERTED BREVE
    ṟ: 'r', // LATIN SMALL LETTER R WITH LINE BELOW
    ɼ: 'r', // LATIN SMALL LETTER R WITH LONG LEG
    ᵲ: 'r', // LATIN SMALL LETTER R WITH MIDDLE TILDE
    ᶉ: 'r', // LATIN SMALL LETTER R WITH PALATAL HOOK
    ɍ: 'r', // LATIN SMALL LETTER R WITH STROKE
    ɽ: 'r', // LATIN SMALL LETTER R WITH TAIL
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RAMS HORN' (ɤ)
    ↄ: 'c', // LATIN SMALL LETTER REVERSED C
    ꜿ: 'c', // LATIN SMALL LETTER REVERSED C WITH DOT
    ɘ: 'e', // LATIN SMALL LETTER REVERSED E
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E' (ɜ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E WITH HOOK' (ɝ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E WITH RETROFLEX HOOK' (ᶔ)
    ɿ: 'r', // LATIN SMALL LETTER REVERSED R WITH FISHHOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RUM' (ꝵ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RUM ROTUNDA' (ꝝ)
    ś: 's', // LATIN SMALL LETTER S WITH ACUTE
    ṥ: 's', // LATIN SMALL LETTER S WITH ACUTE AND DOT ABOVE
    š: 's', // LATIN SMALL LETTER S WITH CARON
    ṧ: 's', // LATIN SMALL LETTER S WITH CARON AND DOT ABOVE
    ş: 's', // LATIN SMALL LETTER S WITH CEDILLA
    ŝ: 's', // LATIN SMALL LETTER S WITH CIRCUMFLEX
    ș: 's', // LATIN SMALL LETTER S WITH COMMA BELOW
    ṡ: 's', // LATIN SMALL LETTER S WITH DOT ABOVE
    ṣ: 's', // LATIN SMALL LETTER S WITH DOT BELOW
    ṩ: 's', // LATIN SMALL LETTER S WITH DOT BELOW AND DOT ABOVE
    ʂ: 's', // LATIN SMALL LETTER S WITH HOOK
    ᵴ: 's', // LATIN SMALL LETTER S WITH MIDDLE TILDE
    ᶊ: 's', // LATIN SMALL LETTER S WITH PALATAL HOOK
    ȿ: 's', // LATIN SMALL LETTER S WITH SWASH TAIL
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SALTILLO' (ꞌ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA' (ə)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA WITH HOOK' (ɚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA WITH RETROFLEX HOOK' (ᶕ)
    ɡ: 'g', // LATIN SMALL LETTER SCRIPT G
    ß: 'ss', // LATIN SMALL LETTER SHARP S
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS DIAERESIZED U' (ᴞ)
    ᴑ: 'o', // LATIN SMALL LETTER SIDEWAYS O
    ᴓ: 'o', // LATIN SMALL LETTER SIDEWAYS O WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS OPEN O' (ᴒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS TURNED M' (ᴟ)
    ᴝ: 'u', // LATIN SMALL LETTER SIDEWAYS U
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SQUAT REVERSED ESH' (ʅ)
    ť: 't', // LATIN SMALL LETTER T WITH CARON
    ţ: 't', // LATIN SMALL LETTER T WITH CEDILLA
    ṱ: 't', // LATIN SMALL LETTER T WITH CIRCUMFLEX BELOW
    ț: 't', // LATIN SMALL LETTER T WITH COMMA BELOW
    ȶ: 't', // LATIN SMALL LETTER T WITH CURL
    ẗ: 't', // LATIN SMALL LETTER T WITH DIAERESIS
    ⱦ: 't', // LATIN SMALL LETTER T WITH DIAGONAL STROKE
    ṫ: 't', // LATIN SMALL LETTER T WITH DOT ABOVE
    ṭ: 't', // LATIN SMALL LETTER T WITH DOT BELOW
    ƭ: 't', // LATIN SMALL LETTER T WITH HOOK
    ṯ: 't', // LATIN SMALL LETTER T WITH LINE BELOW
    ᵵ: 't', // LATIN SMALL LETTER T WITH MIDDLE TILDE
    ƫ: 't', // LATIN SMALL LETTER T WITH PALATAL HOOK
    ʈ: 't', // LATIN SMALL LETTER T WITH RETROFLEX HOOK
    ŧ: 't', // LATIN SMALL LETTER T WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TAILLESS PHI' (ⱷ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TC DIGRAPH WITH CURL' (ʨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TESH DIGRAPH' (ʧ)
    ᵺ: 'th', // LATIN SMALL LETTER TH WITH STRIKETHROUGH
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN' (þ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN WITH STROKE' (ꝥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN WITH STROKE THROUGH DESCENDER' (ꝧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE FIVE' (ƽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE SIX' (ƅ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE TWO' (ƨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TOP HALF O' (ᴖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TRESILLO' (ꜫ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TS DIGRAPH' (ʦ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TUM' (ꝷ)
    ɐ: 'a', // LATIN SMALL LETTER TURNED A
    ᴂ: 'ae', // LATIN SMALL LETTER TURNED AE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED ALPHA' (ɒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED DELTA' (ƍ)
    ǝ: 'e', // LATIN SMALL LETTER TURNED E
    ᵷ: 'g', // LATIN SMALL LETTER TURNED G
    ɥ: 'h', // LATIN SMALL LETTER TURNED H
    ʮ: 'h', // LATIN SMALL LETTER TURNED H WITH FISHHOOK
    ʯ: 'h', // LATIN SMALL LETTER TURNED H WITH FISHHOOK AND TAIL
    ᴉ: 'i', // LATIN SMALL LETTER TURNED I
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED INSULAR G' (ꝿ)
    ʞ: 'k', // LATIN SMALL LETTER TURNED K
    ꞁ: 'l', // LATIN SMALL LETTER TURNED L
    ɯ: 'm', // LATIN SMALL LETTER TURNED M
    ɰ: 'm', // LATIN SMALL LETTER TURNED M WITH LONG LEG
    ᴔ: 'oe', // LATIN SMALL LETTER TURNED OE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED OPEN E' (ᴈ)
    ɹ: 'r', // LATIN SMALL LETTER TURNED R
    ɻ: 'r', // LATIN SMALL LETTER TURNED R WITH HOOK
    ɺ: 'r', // LATIN SMALL LETTER TURNED R WITH LONG LEG
    ⱹ: 'r', // LATIN SMALL LETTER TURNED R WITH TAIL
    ʇ: 't', // LATIN SMALL LETTER TURNED T
    ʌ: 'v', // LATIN SMALL LETTER TURNED V
    ʍ: 'w', // LATIN SMALL LETTER TURNED W
    ʎ: 'y', // LATIN SMALL LETTER TURNED Y
    ꜩ: 'tz', // LATIN SMALL LETTER TZ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER U BAR' (ʉ)
    ú: 'u', // LATIN SMALL LETTER U WITH ACUTE
    ŭ: 'u', // LATIN SMALL LETTER U WITH BREVE
    ǔ: 'u', // LATIN SMALL LETTER U WITH CARON
    û: 'u', // LATIN SMALL LETTER U WITH CIRCUMFLEX
    ṷ: 'u', // LATIN SMALL LETTER U WITH CIRCUMFLEX BELOW
    ü: 'u', // LATIN SMALL LETTER U WITH DIAERESIS
    ǘ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS AND ACUTE
    ǚ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS AND CARON
    ǜ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS AND GRAVE
    ǖ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS AND MACRON
    ṳ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS BELOW
    ụ: 'u', // LATIN SMALL LETTER U WITH DOT BELOW
    ű: 'u', // LATIN SMALL LETTER U WITH DOUBLE ACUTE
    ȕ: 'u', // LATIN SMALL LETTER U WITH DOUBLE GRAVE
    ù: 'u', // LATIN SMALL LETTER U WITH GRAVE
    ủ: 'u', // LATIN SMALL LETTER U WITH HOOK ABOVE
    ư: 'u', // LATIN SMALL LETTER U WITH HORN
    ứ: 'u', // LATIN SMALL LETTER U WITH HORN AND ACUTE
    ự: 'u', // LATIN SMALL LETTER U WITH HORN AND DOT BELOW
    ừ: 'u', // LATIN SMALL LETTER U WITH HORN AND GRAVE
    ử: 'u', // LATIN SMALL LETTER U WITH HORN AND HOOK ABOVE
    ữ: 'u', // LATIN SMALL LETTER U WITH HORN AND TILDE
    ȗ: 'u', // LATIN SMALL LETTER U WITH INVERTED BREVE
    ū: 'u', // LATIN SMALL LETTER U WITH MACRON
    ṻ: 'u', // LATIN SMALL LETTER U WITH MACRON AND DIAERESIS
    ų: 'u', // LATIN SMALL LETTER U WITH OGONEK
    ᶙ: 'u', // LATIN SMALL LETTER U WITH RETROFLEX HOOK
    ů: 'u', // LATIN SMALL LETTER U WITH RING ABOVE
    ũ: 'u', // LATIN SMALL LETTER U WITH TILDE
    ṹ: 'u', // LATIN SMALL LETTER U WITH TILDE AND ACUTE
    ṵ: 'u', // LATIN SMALL LETTER U WITH TILDE BELOW
    ᵫ: 'ue', // LATIN SMALL LETTER UE
    ꝸ: 'um', // LATIN SMALL LETTER UM
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER UPSILON' (ʊ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER UPSILON WITH STROKE' (ᵿ)
    ⱴ: 'v', // LATIN SMALL LETTER V WITH CURL
    ꝟ: 'v', // LATIN SMALL LETTER V WITH DIAGONAL STROKE
    ṿ: 'v', // LATIN SMALL LETTER V WITH DOT BELOW
    ʋ: 'v', // LATIN SMALL LETTER V WITH HOOK
    ᶌ: 'v', // LATIN SMALL LETTER V WITH PALATAL HOOK
    ⱱ: 'v', // LATIN SMALL LETTER V WITH RIGHT HOOK
    ṽ: 'v', // LATIN SMALL LETTER V WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER VEND' (ꝩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER VISIGOTHIC Z' (ꝣ)
    ꝡ: 'vy', // LATIN SMALL LETTER VY
    ẃ: 'w', // LATIN SMALL LETTER W WITH ACUTE
    ŵ: 'w', // LATIN SMALL LETTER W WITH CIRCUMFLEX
    ẅ: 'w', // LATIN SMALL LETTER W WITH DIAERESIS
    ẇ: 'w', // LATIN SMALL LETTER W WITH DOT ABOVE
    ẉ: 'w', // LATIN SMALL LETTER W WITH DOT BELOW
    ẁ: 'w', // LATIN SMALL LETTER W WITH GRAVE
    ⱳ: 'w', // LATIN SMALL LETTER W WITH HOOK
    ẘ: 'w', // LATIN SMALL LETTER W WITH RING ABOVE
    ẍ: 'x', // LATIN SMALL LETTER X WITH DIAERESIS
    ẋ: 'x', // LATIN SMALL LETTER X WITH DOT ABOVE
    ᶍ: 'x', // LATIN SMALL LETTER X WITH PALATAL HOOK
    ý: 'y', // LATIN SMALL LETTER Y WITH ACUTE
    ŷ: 'y', // LATIN SMALL LETTER Y WITH CIRCUMFLEX
    ÿ: 'y', // LATIN SMALL LETTER Y WITH DIAERESIS
    ẏ: 'y', // LATIN SMALL LETTER Y WITH DOT ABOVE
    ỵ: 'y', // LATIN SMALL LETTER Y WITH DOT BELOW
    ỳ: 'y', // LATIN SMALL LETTER Y WITH GRAVE
    ƴ: 'y', // LATIN SMALL LETTER Y WITH HOOK
    ỷ: 'y', // LATIN SMALL LETTER Y WITH HOOK ABOVE
    ỿ: 'y', // LATIN SMALL LETTER Y WITH LOOP
    ȳ: 'y', // LATIN SMALL LETTER Y WITH MACRON
    ẙ: 'y', // LATIN SMALL LETTER Y WITH RING ABOVE
    ɏ: 'y', // LATIN SMALL LETTER Y WITH STROKE
    ỹ: 'y', // LATIN SMALL LETTER Y WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER YOGH' (ȝ)
    ź: 'z', // LATIN SMALL LETTER Z WITH ACUTE
    ž: 'z', // LATIN SMALL LETTER Z WITH CARON
    ẑ: 'z', // LATIN SMALL LETTER Z WITH CIRCUMFLEX
    ʑ: 'z', // LATIN SMALL LETTER Z WITH CURL
    ⱬ: 'z', // LATIN SMALL LETTER Z WITH DESCENDER
    ż: 'z', // LATIN SMALL LETTER Z WITH DOT ABOVE
    ẓ: 'z', // LATIN SMALL LETTER Z WITH DOT BELOW
    ȥ: 'z', // LATIN SMALL LETTER Z WITH HOOK
    ẕ: 'z', // LATIN SMALL LETTER Z WITH LINE BELOW
    ᵶ: 'z', // LATIN SMALL LETTER Z WITH MIDDLE TILDE
    ᶎ: 'z', // LATIN SMALL LETTER Z WITH PALATAL HOOK
    ʐ: 'z', // LATIN SMALL LETTER Z WITH RETROFLEX HOOK
    ƶ: 'z', // LATIN SMALL LETTER Z WITH STROKE
    ɀ: 'z', // LATIN SMALL LETTER Z WITH SWASH TAIL
    ﬀ: 'ff', // LATIN SMALL LIGATURE FF
    ﬃ: 'ffi', // LATIN SMALL LIGATURE FFI
    ﬄ: 'ffl', // LATIN SMALL LIGATURE FFL
    ﬁ: 'fi', // LATIN SMALL LIGATURE FI
    ﬂ: 'fl', // LATIN SMALL LIGATURE FL
    ĳ: 'ij', // LATIN SMALL LIGATURE IJ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LIGATURE LONG S T' (ﬅ)
    œ: 'oe', // LATIN SMALL LIGATURE OE
    ﬆ: 'st', // LATIN SMALL LIGATURE ST
    ₐ: 'a', // LATIN SUBSCRIPT SMALL LETTER A
    ₑ: 'e', // LATIN SUBSCRIPT SMALL LETTER E
    ᵢ: 'i', // LATIN SUBSCRIPT SMALL LETTER I
    ⱼ: 'j', // LATIN SUBSCRIPT SMALL LETTER J
    ₒ: 'o', // LATIN SUBSCRIPT SMALL LETTER O
    ᵣ: 'r', // LATIN SUBSCRIPT SMALL LETTER R
    // CANNOT FIND APPROXIMATION FOR 'LATIN SUBSCRIPT SMALL LETTER SCHWA' (ₔ)
    ᵤ: 'u', // LATIN SUBSCRIPT SMALL LETTER U
    ᵥ: 'v', // LATIN SUBSCRIPT SMALL LETTER V
    ₓ: 'x' // LATIN SUBSCRIPT SMALL LETTER X
};

function map(x) {
    return latinMap[x] || x;
}

function latinise(input) {
    return input.replace(/[^A-Za-z0-9]/g, map);
}

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1656), __esModule: true };

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1657);
module.exports = __webpack_require__(12).Reflect.apply;


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(16);
var aFunction = __webpack_require__(80);
var anObject = __webpack_require__(46);
var rApply = (__webpack_require__(20).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(57)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1659), __esModule: true };

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118);
__webpack_require__(90);
module.exports = __webpack_require__(1660);


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(123);
var ITERATOR = __webpack_require__(21)('iterator');
var Iterators = __webpack_require__(81);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendDesktopNotification = sendDesktopNotification;

var _general = __webpack_require__(113);

var _channel_utils = __webpack_require__(854);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _notification_store = __webpack_require__(1662);

var _notification_store2 = _interopRequireDefault(_notification_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _post_utils = __webpack_require__(803);

var _user_agent = __webpack_require__(790);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function sendDesktopNotification(post, msgProps) {
    if (_user_store2.default.getCurrentId() === post.user_id && post.props.from_webhook !== 'true') {
        return;
    }

    if ((0, _post_utils.isSystemMessage)(post)) {
        return;
    }

    var mentions = [];
    if (msgProps.mentions) {
        mentions = JSON.parse(msgProps.mentions);
    }
    var teamId = msgProps.team_id;

    var channel = _channel_store2.default.get(post.channel_id);
    var user = _user_store2.default.getCurrentUser();
    var userStatus = _user_store2.default.getStatus(user.id);
    var member = _channel_store2.default.getMyMember(post.channel_id);

    if ((0, _channel_utils.isChannelMuted)(member) || userStatus === _constants.UserStatuses.DND) {
        return;
    }

    var notifyLevel = member && member.notify_props ? member.notify_props.desktop : _constants.NotificationLevels.DEFAULT;
    if (notifyLevel === _constants.NotificationLevels.DEFAULT) {
        notifyLevel = user && user.notify_props ? user.notify_props.desktop : _constants.NotificationLevels.ALL;
    }

    if (notifyLevel === _constants.NotificationLevels.NONE) {
        return;
    } else if (notifyLevel === _constants.NotificationLevels.MENTION && mentions.indexOf(user.id) === -1 && msgProps.channel_type !== _constants2.default.DM_CHANNEL) {
        return;
    }

    var config = (0, _general.getConfig)(_redux_store2.default.getState());
    var username = Utils.localizeMessage('channel_loader.someone', 'Someone');
    if (post.props.override_username && config.EnablePostUsernameOverride === 'true') {
        username = post.props.override_username;
    } else if (msgProps.sender_name) {
        username = msgProps.sender_name;
    } else if (_user_store2.default.hasProfile(post.user_id)) {
        username = _user_store2.default.getProfile(post.user_id).username;
    }

    var title = Utils.localizeMessage('channel_loader.posted', 'Posted');
    if (!channel) {
        title = msgProps.channel_display_name;
        channel = {
            name: msgProps.channel_name,
            type: msgProps.channel_type
        };
    } else if (channel.type === _constants2.default.DM_CHANNEL) {
        title = Utils.localizeMessage('notification.dm', 'Direct Message');
    } else {
        title = channel.display_name;
    }

    if (title === '') {
        if (msgProps.channel_type === _constants2.default.DM_CHANNEL) {
            title = Utils.localizeMessage('notification.dm', 'Direct Message');
        } else {
            title = msgProps.channel_display_name;
        }
    }

    var notifyText = post.message;

    var msgPropsPost = JSON.parse(msgProps.post);
    var attachments = msgPropsPost && msgPropsPost.props && msgPropsPost.props.attachments ? msgPropsPost.props.attachments : [];
    var image = false;
    attachments.forEach(function (attachment) {
        if (notifyText.length === 0) {
            notifyText = attachment.fallback || attachment.pretext || attachment.text;
        }
        image |= attachment.image_url.length > 0;
    });

    notifyText = notifyText.replace(/\n+/g, ' ');
    if (notifyText.length > 50) {
        notifyText = notifyText.substring(0, 49) + '...';
    }

    var body = '';
    if (notifyText.length === 0) {
        if (msgProps.image) {
            body = username + Utils.localizeMessage('channel_loader.uploadedImage', ' uploaded an image');
        } else if (msgProps.otherFile) {
            body = username + Utils.localizeMessage('channel_loader.uploadedFile', ' uploaded a file');
        } else if (image) {
            body = username + Utils.localizeMessage('channel_loader.postedImage', ' posted an image');
        } else {
            body = username + Utils.localizeMessage('channel_loader.something', ' did something new');
        }
    } else {
        body = username + Utils.localizeMessage('channel_loader.wrote', ' wrote: ') + notifyText;
    }

    var duration = _constants2.default.DEFAULT_NOTIFICATION_DURATION;
    if (user.notify_props && user.notify_props.desktop_duration) {
        duration = parseInt(user.notify_props.desktop_duration, 10) * 1000;
    }

    //Play a sound if explicitly set in settings
    var sound = !user.notify_props || user.notify_props.desktop_sound === 'true';

    // Notify if you're not looking in the right channel or when
    // the window itself is not active
    var activeChannel = _channel_store2.default.getCurrent();
    var channelId = channel ? channel.id : null;
    var notify = activeChannel && activeChannel.id !== channelId || !_notification_store2.default.getFocus();

    if (notify) {
        Utils.notifyMe(title, body, channel, teamId, duration, !sound);

        //Don't add extra sounds on native desktop clients
        if (sound && !(0, _user_agent.isWindowsApp)() && !(0, _user_agent.isMacApp)() && !(0, _user_agent.isMobileApp)()) {
            Utils.ding();
        }
    }
}

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'change';

var NotificationStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(NotificationStoreClass, _EventEmitter);

    function NotificationStoreClass() {
        (0, _classCallCheck3.default)(this, NotificationStoreClass);
        return (0, _possibleConstructorReturn3.default)(this, (NotificationStoreClass.__proto__ || (0, _getPrototypeOf2.default)(NotificationStoreClass)).apply(this, arguments));
    }

    (0, _createClass3.default)(NotificationStoreClass, [{
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'setFocus',
        value: function setFocus(focus) {
            this.inFocus = focus;
        }
    }, {
        key: 'getFocus',
        value: function getFocus() {
            return this.inFocus;
        }
    }]);
    return NotificationStoreClass;
}(_events2.default);

var NotificationStore = new NotificationStoreClass();

NotificationStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case ActionTypes.BROWSER_CHANGE_FOCUS:
            NotificationStore.setFocus(action.focus);
            break;
    }
});

exports.default = NotificationStore;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var parser = __webpack_require__(1664);
var processingInstructions = __webpack_require__(1136);
var isValidNodeDefinitions = __webpack_require__(1140);
var processNodeDefinitions = __webpack_require__(1137);

module.exports = {
  Parser: parser,
  ProcessingInstructions: processingInstructions,
  IsValidNodeDefinitions: isValidNodeDefinitions,
  ProcessNodeDefinitions: processNodeDefinitions,
};


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var find = __webpack_require__(1665);
var reject = __webpack_require__(1669);
var addIndex = __webpack_require__(1680);
var map = __webpack_require__(1683);
var HtmlParser = __webpack_require__(1686);
var DomHandler = __webpack_require__(1693);
var ProcessingInstructions = __webpack_require__(1136);
var IsValidNodeDefinitions = __webpack_require__(1140);
var utils = __webpack_require__(1138);

function Html2ReactParser(options) {
  function parseHtmlToTree(html) {
    options = options || {};
    options.decodeEntities = true;
    var handler = new DomHandler();
    var parser = new HtmlParser(handler, options);
    parser.parseComplete(html);
    return handler.dom.filter(function (element) {
      return element.type !== 'directive';
    });
  };

  function traverseDom(node, isValidNode, processingInstructions, index) {
    if (isValidNode(node)) {
      var processingInstruction = find(function (processingInstruction) {
        return processingInstruction.shouldProcessNode(node);
      }, processingInstructions);
      if (processingInstruction != null) {
        var children = reject(function (x) {return x == null || x === false;},
          addIndex(map)(function (child, i) {
            return traverseDom(child, isValidNode, processingInstructions, i);
          }, node.children || []));

        if (processingInstruction.replaceChildren) {
          return utils.createElement(node, index, node.data, [
            processingInstruction.processNode(node, children, index),
          ]);
        }

        return processingInstruction.processNode(node, children, index);
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  function parseWithInstructions(html, isValidNode, processingInstructions) {
    var domTree = parseHtmlToTree(html);

    var list = domTree.map(function (domTreeItem, index) {
      return traverseDom(domTreeItem, isValidNode, processingInstructions, index);
    });
    return list.length <= 1 ? list[0] : list;
  };

  function parse(html) {
    var processingInstructions = new ProcessingInstructions();
    return parseWithInstructions(html,
      IsValidNodeDefinitions.alwaysValid,
      processingInstructions.defaultProcessingInstructions);
  };

  return {
    parse: parse,
    parseWithInstructions: parseWithInstructions,
  };
};

module.exports = Html2ReactParser;


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__(846);

var _dispatchable = /*#__PURE__*/__webpack_require__(1016);

var _xfind = /*#__PURE__*/__webpack_require__(1667);

/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */


var find = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['find'], _xfind, function find(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx += 1;
  }
}));
module.exports = find;

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}
module.exports = _isTransformer;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__(846);

var _reduced = /*#__PURE__*/__webpack_require__(1668);

var _xfBase = /*#__PURE__*/__webpack_require__(1017);

var XFind = /*#__PURE__*/function () {

  function XFind(f, xf) {
    this.xf = xf;
    this.f = f;
    this.found = false;
  }
  XFind.prototype['@@transducer/init'] = _xfBase.init;
  XFind.prototype['@@transducer/result'] = function (result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, void 0);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFind.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.found = true;
      result = _reduced(this.xf['@@transducer/step'](result, input));
    }
    return result;
  };

  return XFind;
}();

var _xfind = /*#__PURE__*/_curry2(function _xfind(f, xf) {
  return new XFind(f, xf);
});
module.exports = _xfind;

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}
module.exports = _reduced;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

var _complement = /*#__PURE__*/__webpack_require__(1670);

var _curry2 = /*#__PURE__*/__webpack_require__(846);

var filter = /*#__PURE__*/__webpack_require__(1671);

/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */


var reject = /*#__PURE__*/_curry2(function reject(pred, filterable) {
  return filter(_complement(pred), filterable);
});
module.exports = reject;

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}
module.exports = _complement;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__(846);

var _dispatchable = /*#__PURE__*/__webpack_require__(1016);

var _filter = /*#__PURE__*/__webpack_require__(1672);

var _isObject = /*#__PURE__*/__webpack_require__(1673);

var _reduce = /*#__PURE__*/__webpack_require__(1018);

var _xfilter = /*#__PURE__*/__webpack_require__(1678);

var keys = /*#__PURE__*/__webpack_require__(1133);

/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */


var filter = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['filter'], _xfilter, function (pred, filterable) {
  return _isObject(filterable) ? _reduce(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }
    return acc;
  }, {}, keys(filterable)) :
  // else
  _filter(pred, filterable);
}));
module.exports = filter;

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}
module.exports = _filter;

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}
module.exports = _isObject;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__(878);

var _isArray = /*#__PURE__*/__webpack_require__(1132);

var _isString = /*#__PURE__*/__webpack_require__(1675);

/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */


var _isArrayLike = /*#__PURE__*/_curry1(function isArrayLike(x) {
  if (_isArray(x)) {
    return true;
  }
  if (!x) {
    return false;
  }
  if (typeof x !== 'object') {
    return false;
  }
  if (_isString(x)) {
    return false;
  }
  if (x.nodeType === 1) {
    return !!x.length;
  }
  if (x.length === 0) {
    return true;
  }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});
module.exports = _isArrayLike;

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}
module.exports = _isString;

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

var XWrap = /*#__PURE__*/function () {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };
  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return XWrap;
}();

function _xwrap(fn) {
  return new XWrap(fn);
}
module.exports = _xwrap;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = /*#__PURE__*/__webpack_require__(1019);

var _curry2 = /*#__PURE__*/__webpack_require__(846);

/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */


var bind = /*#__PURE__*/_curry2(function bind(fn, thisObj) {
  return _arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});
module.exports = bind;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__(846);

var _xfBase = /*#__PURE__*/__webpack_require__(1017);

var XFilter = /*#__PURE__*/function () {

  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter.prototype['@@transducer/init'] = _xfBase.init;
  XFilter.prototype['@@transducer/result'] = _xfBase.result;
  XFilter.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XFilter;
}();

var _xfilter = /*#__PURE__*/_curry2(function _xfilter(f, xf) {
  return new XFilter(f, xf);
});
module.exports = _xfilter;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

var _has = /*#__PURE__*/__webpack_require__(1020);

var toString = Object.prototype.toString;
var _isArguments = function () {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has('callee', x);
  };
};

module.exports = _isArguments;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = /*#__PURE__*/__webpack_require__(1681);

var _curry1 = /*#__PURE__*/__webpack_require__(878);

var curryN = /*#__PURE__*/__webpack_require__(1134);

/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */


var addIndex = /*#__PURE__*/_curry1(function addIndex(fn) {
  return curryN(fn.length, function () {
    var idx = 0;
    var origFn = arguments[0];
    var list = arguments[arguments.length - 1];
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = function () {
      var result = origFn.apply(this, _concat(arguments, [idx, list]));
      idx += 1;
      return result;
    };
    return fn.apply(this, args);
  });
});
module.exports = addIndex;

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];

  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
}
module.exports = _concat;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = /*#__PURE__*/__webpack_require__(1019);

var _isPlaceholder = /*#__PURE__*/__webpack_require__(948);

/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
  };
}
module.exports = _curryN;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__(846);

var _dispatchable = /*#__PURE__*/__webpack_require__(1016);

var _map = /*#__PURE__*/__webpack_require__(1684);

var _reduce = /*#__PURE__*/__webpack_require__(1018);

var _xmap = /*#__PURE__*/__webpack_require__(1685);

var curryN = /*#__PURE__*/__webpack_require__(1134);

var keys = /*#__PURE__*/__webpack_require__(1133);

/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */


var map = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return curryN(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return _reduce(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys(functor));
    default:
      return _map(fn, functor);
  }
}));
module.exports = map;

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}
module.exports = _map;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__(846);

var _xfBase = /*#__PURE__*/__webpack_require__(1017);

var XMap = /*#__PURE__*/function () {

  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = _xfBase.init;
  XMap.prototype['@@transducer/result'] = _xfBase.result;
  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap = /*#__PURE__*/_curry2(function _xmap(f, xf) {
  return new XMap(f, xf);
});
module.exports = _xmap;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

var Tokenizer = __webpack_require__(1687);

/*
	Options:

	xmlMode: Disables the special behavior for script/style tags (false by default)
	lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
	lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
*/

/*
	Callbacks:

	oncdataend,
	oncdatastart,
	onclosetag,
	oncomment,
	oncommentend,
	onerror,
	onopentag,
	onprocessinginstruction,
	onreset,
	ontext
*/

var formTags = {
	input: true,
	option: true,
	optgroup: true,
	select: true,
	button: true,
	datalist: true,
	textarea: true
};

var openImpliesClose = {
	tr      : { tr:true, th:true, td:true },
	th      : { th:true },
	td      : { thead:true, th:true, td:true },
	body    : { head:true, link:true, script:true },
	li      : { li:true },
	p       : { p:true },
	h1      : { p:true },
	h2      : { p:true },
	h3      : { p:true },
	h4      : { p:true },
	h5      : { p:true },
	h6      : { p:true },
	select  : formTags,
	input   : formTags,
	output  : formTags,
	button  : formTags,
	datalist: formTags,
	textarea: formTags,
	option  : { option:true },
	optgroup: { optgroup:true }
};

var voidElements = {
	__proto__: null,
	area: true,
	base: true,
	basefont: true,
	br: true,
	col: true,
	command: true,
	embed: true,
	frame: true,
	hr: true,
	img: true,
	input: true,
	isindex: true,
	keygen: true,
	link: true,
	meta: true,
	param: true,
	source: true,
	track: true,
	wbr: true,

	//common self closing svg elements
	path: true,
	circle: true,
	ellipse: true,
	line: true,
	rect: true,
	use: true,
	stop: true,
	polyline: true,
	polygon: true
};

var re_nameEnd = /\s|\//;

function Parser(cbs, options){
	this._options = options || {};
	this._cbs = cbs || {};

	this._tagname = "";
	this._attribname = "";
	this._attribvalue = "";
	this._attribs = null;
	this._stack = [];

	this.startIndex = 0;
	this.endIndex = null;

	this._lowerCaseTagNames = "lowerCaseTags" in this._options ?
									!!this._options.lowerCaseTags :
									!this._options.xmlMode;
	this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ?
									!!this._options.lowerCaseAttributeNames :
									!this._options.xmlMode;

	if(this._options.Tokenizer) {
		Tokenizer = this._options.Tokenizer;
	}
	this._tokenizer = new Tokenizer(this._options, this);

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
}

__webpack_require__(77)(Parser, __webpack_require__(173).EventEmitter);

Parser.prototype._updatePosition = function(initialOffset){
	if(this.endIndex === null){
		if(this._tokenizer._sectionStart <= initialOffset){
			this.startIndex = 0;
		} else {
			this.startIndex = this._tokenizer._sectionStart - initialOffset;
		}
	}
	else this.startIndex = this.endIndex + 1;
	this.endIndex = this._tokenizer.getAbsoluteIndex();
};

//Tokenizer event handlers
Parser.prototype.ontext = function(data){
	this._updatePosition(1);
	this.endIndex--;

	if(this._cbs.ontext) this._cbs.ontext(data);
};

Parser.prototype.onopentagname = function(name){
	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	this._tagname = name;

	if(!this._options.xmlMode && name in openImpliesClose) {
		for(
			var el;
			(el = this._stack[this._stack.length - 1]) in openImpliesClose[name];
			this.onclosetag(el)
		);
	}

	if(this._options.xmlMode || !(name in voidElements)){
		this._stack.push(name);
	}

	if(this._cbs.onopentagname) this._cbs.onopentagname(name);
	if(this._cbs.onopentag) this._attribs = {};
};

Parser.prototype.onopentagend = function(){
	this._updatePosition(1);

	if(this._attribs){
		if(this._cbs.onopentag) this._cbs.onopentag(this._tagname, this._attribs);
		this._attribs = null;
	}

	if(!this._options.xmlMode && this._cbs.onclosetag && this._tagname in voidElements){
		this._cbs.onclosetag(this._tagname);
	}

	this._tagname = "";
};

Parser.prototype.onclosetag = function(name){
	this._updatePosition(1);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	if(this._stack.length && (!(name in voidElements) || this._options.xmlMode)){
		var pos = this._stack.lastIndexOf(name);
		if(pos !== -1){
			if(this._cbs.onclosetag){
				pos = this._stack.length - pos;
				while(pos--) this._cbs.onclosetag(this._stack.pop());
			}
			else this._stack.length = pos;
		} else if(name === "p" && !this._options.xmlMode){
			this.onopentagname(name);
			this._closeCurrentTag();
		}
	} else if(!this._options.xmlMode && (name === "br" || name === "p")){
		this.onopentagname(name);
		this._closeCurrentTag();
	}
};

Parser.prototype.onselfclosingtag = function(){
	if(this._options.xmlMode || this._options.recognizeSelfClosing){
		this._closeCurrentTag();
	} else {
		this.onopentagend();
	}
};

Parser.prototype._closeCurrentTag = function(){
	var name = this._tagname;

	this.onopentagend();

	//self-closing tags will be on the top of the stack
	//(cheaper check than in onclosetag)
	if(this._stack[this._stack.length - 1] === name){
		if(this._cbs.onclosetag){
			this._cbs.onclosetag(name);
		}
		this._stack.pop();
	}
};

Parser.prototype.onattribname = function(name){
	if(this._lowerCaseAttributeNames){
		name = name.toLowerCase();
	}
	this._attribname = name;
};

Parser.prototype.onattribdata = function(value){
	this._attribvalue += value;
};

Parser.prototype.onattribend = function(){
	if(this._cbs.onattribute) this._cbs.onattribute(this._attribname, this._attribvalue);
	if(
		this._attribs &&
		!Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	){
		this._attribs[this._attribname] = this._attribvalue;
	}
	this._attribname = "";
	this._attribvalue = "";
};

Parser.prototype._getInstructionName = function(value){
	var idx = value.search(re_nameEnd),
	    name = idx < 0 ? value : value.substr(0, idx);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	return name;
};

Parser.prototype.ondeclaration = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("!" + name, "!" + value);
	}
};

Parser.prototype.onprocessinginstruction = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("?" + name, "?" + value);
	}
};

Parser.prototype.oncomment = function(value){
	this._updatePosition(4);

	if(this._cbs.oncomment) this._cbs.oncomment(value);
	if(this._cbs.oncommentend) this._cbs.oncommentend();
};

Parser.prototype.oncdata = function(value){
	this._updatePosition(1);

	if(this._options.xmlMode || this._options.recognizeCDATA){
		if(this._cbs.oncdatastart) this._cbs.oncdatastart();
		if(this._cbs.ontext) this._cbs.ontext(value);
		if(this._cbs.oncdataend) this._cbs.oncdataend();
	} else {
		this.oncomment("[CDATA[" + value + "]]");
	}
};

Parser.prototype.onerror = function(err){
	if(this._cbs.onerror) this._cbs.onerror(err);
};

Parser.prototype.onend = function(){
	if(this._cbs.onclosetag){
		for(
			var i = this._stack.length;
			i > 0;
			this._cbs.onclosetag(this._stack[--i])
		);
	}
	if(this._cbs.onend) this._cbs.onend();
};


//Resets the parser to a blank state, ready to parse a new HTML document
Parser.prototype.reset = function(){
	if(this._cbs.onreset) this._cbs.onreset();
	this._tokenizer.reset();

	this._tagname = "";
	this._attribname = "";
	this._attribs = null;
	this._stack = [];

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
};

//Parses a complete HTML document and pushes it to the handler
Parser.prototype.parseComplete = function(data){
	this.reset();
	this.end(data);
};

Parser.prototype.write = function(chunk){
	this._tokenizer.write(chunk);
};

Parser.prototype.end = function(chunk){
	this._tokenizer.end(chunk);
};

Parser.prototype.pause = function(){
	this._tokenizer.pause();
};

Parser.prototype.resume = function(){
	this._tokenizer.resume();
};

//alias for backwards compat
Parser.prototype.parseChunk = Parser.prototype.write;
Parser.prototype.done = Parser.prototype.end;

module.exports = Parser;


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Tokenizer;

var decodeCodePoint = __webpack_require__(1688),
    entityMap = __webpack_require__(1690),
    legacyMap = __webpack_require__(1691),
    xmlMap    = __webpack_require__(1692),

    i = 0,

    TEXT                      = i++,
    BEFORE_TAG_NAME           = i++, //after <
    IN_TAG_NAME               = i++,
    IN_SELF_CLOSING_TAG       = i++,
    BEFORE_CLOSING_TAG_NAME   = i++,
    IN_CLOSING_TAG_NAME       = i++,
    AFTER_CLOSING_TAG_NAME    = i++,

    //attributes
    BEFORE_ATTRIBUTE_NAME     = i++,
    IN_ATTRIBUTE_NAME         = i++,
    AFTER_ATTRIBUTE_NAME      = i++,
    BEFORE_ATTRIBUTE_VALUE    = i++,
    IN_ATTRIBUTE_VALUE_DQ     = i++, // "
    IN_ATTRIBUTE_VALUE_SQ     = i++, // '
    IN_ATTRIBUTE_VALUE_NQ     = i++,

    //declarations
    BEFORE_DECLARATION        = i++, // !
    IN_DECLARATION            = i++,

    //processing instructions
    IN_PROCESSING_INSTRUCTION = i++, // ?

    //comments
    BEFORE_COMMENT            = i++,
    IN_COMMENT                = i++,
    AFTER_COMMENT_1           = i++,
    AFTER_COMMENT_2           = i++,

    //cdata
    BEFORE_CDATA_1            = i++, // [
    BEFORE_CDATA_2            = i++, // C
    BEFORE_CDATA_3            = i++, // D
    BEFORE_CDATA_4            = i++, // A
    BEFORE_CDATA_5            = i++, // T
    BEFORE_CDATA_6            = i++, // A
    IN_CDATA                  = i++, // [
    AFTER_CDATA_1             = i++, // ]
    AFTER_CDATA_2             = i++, // ]

    //special tags
    BEFORE_SPECIAL            = i++, //S
    BEFORE_SPECIAL_END        = i++,   //S

    BEFORE_SCRIPT_1           = i++, //C
    BEFORE_SCRIPT_2           = i++, //R
    BEFORE_SCRIPT_3           = i++, //I
    BEFORE_SCRIPT_4           = i++, //P
    BEFORE_SCRIPT_5           = i++, //T
    AFTER_SCRIPT_1            = i++, //C
    AFTER_SCRIPT_2            = i++, //R
    AFTER_SCRIPT_3            = i++, //I
    AFTER_SCRIPT_4            = i++, //P
    AFTER_SCRIPT_5            = i++, //T

    BEFORE_STYLE_1            = i++, //T
    BEFORE_STYLE_2            = i++, //Y
    BEFORE_STYLE_3            = i++, //L
    BEFORE_STYLE_4            = i++, //E
    AFTER_STYLE_1             = i++, //T
    AFTER_STYLE_2             = i++, //Y
    AFTER_STYLE_3             = i++, //L
    AFTER_STYLE_4             = i++, //E

    BEFORE_ENTITY             = i++, //&
    BEFORE_NUMERIC_ENTITY     = i++, //#
    IN_NAMED_ENTITY           = i++,
    IN_NUMERIC_ENTITY         = i++,
    IN_HEX_ENTITY             = i++, //X

    j = 0,

    SPECIAL_NONE              = j++,
    SPECIAL_SCRIPT            = j++,
    SPECIAL_STYLE             = j++;

function whitespace(c){
	return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}

function characterState(char, SUCCESS){
	return function(c){
		if(c === char) this._state = SUCCESS;
	};
}

function ifElseState(upper, SUCCESS, FAILURE){
	var lower = upper.toLowerCase();

	if(upper === lower){
		return function(c){
			if(c === lower){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	} else {
		return function(c){
			if(c === lower || c === upper){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	}
}

function consumeSpecialNameChar(upper, NEXT_STATE){
	var lower = upper.toLowerCase();

	return function(c){
		if(c === lower || c === upper){
			this._state = NEXT_STATE;
		} else {
			this._state = IN_TAG_NAME;
			this._index--; //consume the token again
		}
	};
}

function Tokenizer(options, cbs){
	this._state = TEXT;
	this._buffer = "";
	this._sectionStart = 0;
	this._index = 0;
	this._bufferOffset = 0; //chars removed from _buffer
	this._baseState = TEXT;
	this._special = SPECIAL_NONE;
	this._cbs = cbs;
	this._running = true;
	this._ended = false;
	this._xmlMode = !!(options && options.xmlMode);
	this._decodeEntities = !!(options && options.decodeEntities);
}

Tokenizer.prototype._stateText = function(c){
	if(c === "<"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._state = BEFORE_TAG_NAME;
		this._sectionStart = this._index;
	} else if(this._decodeEntities && this._special === SPECIAL_NONE && c === "&"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._baseState = TEXT;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeTagName = function(c){
	if(c === "/"){
		this._state = BEFORE_CLOSING_TAG_NAME;
	} else if(c === "<"){
		this._cbs.ontext(this._getSection());
		this._sectionStart = this._index;
	} else if(c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
		this._state = TEXT;
	} else if(c === "!"){
		this._state = BEFORE_DECLARATION;
		this._sectionStart = this._index + 1;
	} else if(c === "?"){
		this._state = IN_PROCESSING_INSTRUCTION;
		this._sectionStart = this._index + 1;
	} else {
		this._state = (!this._xmlMode && (c === "s" || c === "S")) ?
						BEFORE_SPECIAL : IN_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInTagName = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._emitToken("onopentagname");
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateBeforeCloseingTagName = function(c){
	if(whitespace(c));
	else if(c === ">"){
		this._state = TEXT;
	} else if(this._special !== SPECIAL_NONE){
		if(c === "s" || c === "S"){
			this._state = BEFORE_SPECIAL_END;
		} else {
			this._state = TEXT;
			this._index--;
		}
	} else {
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInCloseingTagName = function(c){
	if(c === ">" || whitespace(c)){
		this._emitToken("onclosetag");
		this._state = AFTER_CLOSING_TAG_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterCloseingTagName = function(c){
	//skip everything until ">"
	if(c === ">"){
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeAttributeName = function(c){
	if(c === ">"){
		this._cbs.onopentagend();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c === "/"){
		this._state = IN_SELF_CLOSING_TAG;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInSelfClosingTag = function(c){
	if(c === ">"){
		this._cbs.onselfclosingtag();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateInAttributeName = function(c){
	if(c === "=" || c === "/" || c === ">" || whitespace(c)){
		this._cbs.onattribname(this._getSection());
		this._sectionStart = -1;
		this._state = AFTER_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterAttributeName = function(c){
	if(c === "="){
		this._state = BEFORE_ATTRIBUTE_VALUE;
	} else if(c === "/" || c === ">"){
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(!whitespace(c)){
		this._cbs.onattribend();
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeAttributeValue = function(c){
	if(c === "\""){
		this._state = IN_ATTRIBUTE_VALUE_DQ;
		this._sectionStart = this._index + 1;
	} else if(c === "'"){
		this._state = IN_ATTRIBUTE_VALUE_SQ;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_VALUE_NQ;
		this._sectionStart = this._index;
		this._index--; //reconsume token
	}
};

Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c){
	if(c === "\""){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c){
	if(c === "'"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c){
	if(whitespace(c) || c === ">"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeDeclaration = function(c){
	this._state = c === "[" ? BEFORE_CDATA_1 :
					c === "-" ? BEFORE_COMMENT :
						IN_DECLARATION;
};

Tokenizer.prototype._stateInDeclaration = function(c){
	if(c === ">"){
		this._cbs.ondeclaration(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateInProcessingInstruction = function(c){
	if(c === ">"){
		this._cbs.onprocessinginstruction(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeComment = function(c){
	if(c === "-"){
		this._state = IN_COMMENT;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
	}
};

Tokenizer.prototype._stateInComment = function(c){
	if(c === "-") this._state = AFTER_COMMENT_1;
};

Tokenizer.prototype._stateAfterComment1 = function(c){
	if(c === "-"){
		this._state = AFTER_COMMENT_2;
	} else {
		this._state = IN_COMMENT;
	}
};

Tokenizer.prototype._stateAfterComment2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "-"){
		this._state = IN_COMMENT;
	}
	// else: stay in AFTER_COMMENT_2 (`--->`)
};

Tokenizer.prototype._stateBeforeCdata1 = ifElseState("C", BEFORE_CDATA_2, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata2 = ifElseState("D", BEFORE_CDATA_3, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata3 = ifElseState("A", BEFORE_CDATA_4, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata4 = ifElseState("T", BEFORE_CDATA_5, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata5 = ifElseState("A", BEFORE_CDATA_6, IN_DECLARATION);

Tokenizer.prototype._stateBeforeCdata6 = function(c){
	if(c === "["){
		this._state = IN_CDATA;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
		this._index--;
	}
};

Tokenizer.prototype._stateInCdata = function(c){
	if(c === "]") this._state = AFTER_CDATA_1;
};

Tokenizer.prototype._stateAfterCdata1 = characterState("]", AFTER_CDATA_2);

Tokenizer.prototype._stateAfterCdata2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "]") {
		this._state = IN_CDATA;
	}
	//else: stay in AFTER_CDATA_2 (`]]]>`)
};

Tokenizer.prototype._stateBeforeSpecial = function(c){
	if(c === "c" || c === "C"){
		this._state = BEFORE_SCRIPT_1;
	} else if(c === "t" || c === "T"){
		this._state = BEFORE_STYLE_1;
	} else {
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	}
};

Tokenizer.prototype._stateBeforeSpecialEnd = function(c){
	if(this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")){
		this._state = AFTER_SCRIPT_1;
	} else if(this._special === SPECIAL_STYLE && (c === "t" || c === "T")){
		this._state = AFTER_STYLE_1;
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar("R", BEFORE_SCRIPT_2);
Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar("I", BEFORE_SCRIPT_3);
Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar("P", BEFORE_SCRIPT_4);
Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar("T", BEFORE_SCRIPT_5);

Tokenizer.prototype._stateBeforeScript5 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_SCRIPT;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);

Tokenizer.prototype._stateAfterScript5 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 6;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar("Y", BEFORE_STYLE_2);
Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar("L", BEFORE_STYLE_3);
Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar("E", BEFORE_STYLE_4);

Tokenizer.prototype._stateBeforeStyle4 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_STYLE;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);

Tokenizer.prototype._stateAfterStyle4 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 5;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeEntity = ifElseState("#", BEFORE_NUMERIC_ENTITY, IN_NAMED_ENTITY);
Tokenizer.prototype._stateBeforeNumericEntity = ifElseState("X", IN_HEX_ENTITY, IN_NUMERIC_ENTITY);

//for entities terminated with a semicolon
Tokenizer.prototype._parseNamedEntityStrict = function(){
	//offset = 1
	if(this._sectionStart + 1 < this._index){
		var entity = this._buffer.substring(this._sectionStart + 1, this._index),
		    map = this._xmlMode ? xmlMap : entityMap;

		if(map.hasOwnProperty(entity)){
			this._emitPartial(map[entity]);
			this._sectionStart = this._index + 1;
		}
	}
};


//parses legacy entities (without trailing semicolon)
Tokenizer.prototype._parseLegacyEntity = function(){
	var start = this._sectionStart + 1,
	    limit = this._index - start;

	if(limit > 6) limit = 6; //the max length of legacy entities is 6

	while(limit >= 2){ //the min length of legacy entities is 2
		var entity = this._buffer.substr(start, limit);

		if(legacyMap.hasOwnProperty(entity)){
			this._emitPartial(legacyMap[entity]);
			this._sectionStart += limit + 1;
			return;
		} else {
			limit--;
		}
	}
};

Tokenizer.prototype._stateInNamedEntity = function(c){
	if(c === ";"){
		this._parseNamedEntityStrict();
		if(this._sectionStart + 1 < this._index && !this._xmlMode){
			this._parseLegacyEntity();
		}
		this._state = this._baseState;
	} else if((c < "a" || c > "z") && (c < "A" || c > "Z") && (c < "0" || c > "9")){
		if(this._xmlMode);
		else if(this._sectionStart + 1 === this._index);
		else if(this._baseState !== TEXT){
			if(c !== "="){
				this._parseNamedEntityStrict();
			}
		} else {
			this._parseLegacyEntity();
		}

		this._state = this._baseState;
		this._index--;
	}
};

Tokenizer.prototype._decodeNumericEntity = function(offset, base){
	var sectionStart = this._sectionStart + offset;

	if(sectionStart !== this._index){
		//parse entity
		var entity = this._buffer.substring(sectionStart, this._index);
		var parsed = parseInt(entity, base);

		this._emitPartial(decodeCodePoint(parsed));
		this._sectionStart = this._index;
	} else {
		this._sectionStart--;
	}

	this._state = this._baseState;
};

Tokenizer.prototype._stateInNumericEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(2, 10);
		this._sectionStart++;
	} else if(c < "0" || c > "9"){
		if(!this._xmlMode){
			this._decodeNumericEntity(2, 10);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._stateInHexEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(3, 16);
		this._sectionStart++;
	} else if((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")){
		if(!this._xmlMode){
			this._decodeNumericEntity(3, 16);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._cleanup = function (){
	if(this._sectionStart < 0){
		this._buffer = "";
		this._bufferOffset += this._index;
		this._index = 0;
	} else if(this._running){
		if(this._state === TEXT){
			if(this._sectionStart !== this._index){
				this._cbs.ontext(this._buffer.substr(this._sectionStart));
			}
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else if(this._sectionStart === this._index){
			//the section just started
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else {
			//remove everything unnecessary
			this._buffer = this._buffer.substr(this._sectionStart);
			this._index -= this._sectionStart;
			this._bufferOffset += this._sectionStart;
		}

		this._sectionStart = 0;
	}
};

//TODO make events conditional
Tokenizer.prototype.write = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".write() after done!"));

	this._buffer += chunk;
	this._parse();
};

Tokenizer.prototype._parse = function(){
	while(this._index < this._buffer.length && this._running){
		var c = this._buffer.charAt(this._index);
		if(this._state === TEXT) {
			this._stateText(c);
		} else if(this._state === BEFORE_TAG_NAME){
			this._stateBeforeTagName(c);
		} else if(this._state === IN_TAG_NAME) {
			this._stateInTagName(c);
		} else if(this._state === BEFORE_CLOSING_TAG_NAME){
			this._stateBeforeCloseingTagName(c);
		} else if(this._state === IN_CLOSING_TAG_NAME){
			this._stateInCloseingTagName(c);
		} else if(this._state === AFTER_CLOSING_TAG_NAME){
			this._stateAfterCloseingTagName(c);
		} else if(this._state === IN_SELF_CLOSING_TAG){
			this._stateInSelfClosingTag(c);
		}

		/*
		*	attributes
		*/
		else if(this._state === BEFORE_ATTRIBUTE_NAME){
			this._stateBeforeAttributeName(c);
		} else if(this._state === IN_ATTRIBUTE_NAME){
			this._stateInAttributeName(c);
		} else if(this._state === AFTER_ATTRIBUTE_NAME){
			this._stateAfterAttributeName(c);
		} else if(this._state === BEFORE_ATTRIBUTE_VALUE){
			this._stateBeforeAttributeValue(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_DQ){
			this._stateInAttributeValueDoubleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_SQ){
			this._stateInAttributeValueSingleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_NQ){
			this._stateInAttributeValueNoQuotes(c);
		}

		/*
		*	declarations
		*/
		else if(this._state === BEFORE_DECLARATION){
			this._stateBeforeDeclaration(c);
		} else if(this._state === IN_DECLARATION){
			this._stateInDeclaration(c);
		}

		/*
		*	processing instructions
		*/
		else if(this._state === IN_PROCESSING_INSTRUCTION){
			this._stateInProcessingInstruction(c);
		}

		/*
		*	comments
		*/
		else if(this._state === BEFORE_COMMENT){
			this._stateBeforeComment(c);
		} else if(this._state === IN_COMMENT){
			this._stateInComment(c);
		} else if(this._state === AFTER_COMMENT_1){
			this._stateAfterComment1(c);
		} else if(this._state === AFTER_COMMENT_2){
			this._stateAfterComment2(c);
		}

		/*
		*	cdata
		*/
		else if(this._state === BEFORE_CDATA_1){
			this._stateBeforeCdata1(c);
		} else if(this._state === BEFORE_CDATA_2){
			this._stateBeforeCdata2(c);
		} else if(this._state === BEFORE_CDATA_3){
			this._stateBeforeCdata3(c);
		} else if(this._state === BEFORE_CDATA_4){
			this._stateBeforeCdata4(c);
		} else if(this._state === BEFORE_CDATA_5){
			this._stateBeforeCdata5(c);
		} else if(this._state === BEFORE_CDATA_6){
			this._stateBeforeCdata6(c);
		} else if(this._state === IN_CDATA){
			this._stateInCdata(c);
		} else if(this._state === AFTER_CDATA_1){
			this._stateAfterCdata1(c);
		} else if(this._state === AFTER_CDATA_2){
			this._stateAfterCdata2(c);
		}

		/*
		* special tags
		*/
		else if(this._state === BEFORE_SPECIAL){
			this._stateBeforeSpecial(c);
		} else if(this._state === BEFORE_SPECIAL_END){
			this._stateBeforeSpecialEnd(c);
		}

		/*
		* script
		*/
		else if(this._state === BEFORE_SCRIPT_1){
			this._stateBeforeScript1(c);
		} else if(this._state === BEFORE_SCRIPT_2){
			this._stateBeforeScript2(c);
		} else if(this._state === BEFORE_SCRIPT_3){
			this._stateBeforeScript3(c);
		} else if(this._state === BEFORE_SCRIPT_4){
			this._stateBeforeScript4(c);
		} else if(this._state === BEFORE_SCRIPT_5){
			this._stateBeforeScript5(c);
		}

		else if(this._state === AFTER_SCRIPT_1){
			this._stateAfterScript1(c);
		} else if(this._state === AFTER_SCRIPT_2){
			this._stateAfterScript2(c);
		} else if(this._state === AFTER_SCRIPT_3){
			this._stateAfterScript3(c);
		} else if(this._state === AFTER_SCRIPT_4){
			this._stateAfterScript4(c);
		} else if(this._state === AFTER_SCRIPT_5){
			this._stateAfterScript5(c);
		}

		/*
		* style
		*/
		else if(this._state === BEFORE_STYLE_1){
			this._stateBeforeStyle1(c);
		} else if(this._state === BEFORE_STYLE_2){
			this._stateBeforeStyle2(c);
		} else if(this._state === BEFORE_STYLE_3){
			this._stateBeforeStyle3(c);
		} else if(this._state === BEFORE_STYLE_4){
			this._stateBeforeStyle4(c);
		}

		else if(this._state === AFTER_STYLE_1){
			this._stateAfterStyle1(c);
		} else if(this._state === AFTER_STYLE_2){
			this._stateAfterStyle2(c);
		} else if(this._state === AFTER_STYLE_3){
			this._stateAfterStyle3(c);
		} else if(this._state === AFTER_STYLE_4){
			this._stateAfterStyle4(c);
		}

		/*
		* entities
		*/
		else if(this._state === BEFORE_ENTITY){
			this._stateBeforeEntity(c);
		} else if(this._state === BEFORE_NUMERIC_ENTITY){
			this._stateBeforeNumericEntity(c);
		} else if(this._state === IN_NAMED_ENTITY){
			this._stateInNamedEntity(c);
		} else if(this._state === IN_NUMERIC_ENTITY){
			this._stateInNumericEntity(c);
		} else if(this._state === IN_HEX_ENTITY){
			this._stateInHexEntity(c);
		}

		else {
			this._cbs.onerror(Error("unknown _state"), this._state);
		}

		this._index++;
	}

	this._cleanup();
};

Tokenizer.prototype.pause = function(){
	this._running = false;
};
Tokenizer.prototype.resume = function(){
	this._running = true;

	if(this._index < this._buffer.length){
		this._parse();
	}
	if(this._ended){
		this._finish();
	}
};

Tokenizer.prototype.end = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".end() after done!"));
	if(chunk) this.write(chunk);

	this._ended = true;

	if(this._running) this._finish();
};

Tokenizer.prototype._finish = function(){
	//if there is remaining data, emit it in a reasonable way
	if(this._sectionStart < this._index){
		this._handleTrailingData();
	}

	this._cbs.onend();
};

Tokenizer.prototype._handleTrailingData = function(){
	var data = this._buffer.substr(this._sectionStart);

	if(this._state === IN_CDATA || this._state === AFTER_CDATA_1 || this._state === AFTER_CDATA_2){
		this._cbs.oncdata(data);
	} else if(this._state === IN_COMMENT || this._state === AFTER_COMMENT_1 || this._state === AFTER_COMMENT_2){
		this._cbs.oncomment(data);
	} else if(this._state === IN_NAMED_ENTITY && !this._xmlMode){
		this._parseLegacyEntity();
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_NUMERIC_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(2, 10);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_HEX_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(3, 16);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(
		this._state !== IN_TAG_NAME &&
		this._state !== BEFORE_ATTRIBUTE_NAME &&
		this._state !== BEFORE_ATTRIBUTE_VALUE &&
		this._state !== AFTER_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_VALUE_SQ &&
		this._state !== IN_ATTRIBUTE_VALUE_DQ &&
		this._state !== IN_ATTRIBUTE_VALUE_NQ &&
		this._state !== IN_CLOSING_TAG_NAME
	){
		this._cbs.ontext(data);
	}
	//else, ignore remaining data
	//TODO add a way to remove current tag
};

Tokenizer.prototype.reset = function(){
	Tokenizer.call(this, {xmlMode: this._xmlMode, decodeEntities: this._decodeEntities}, this._cbs);
};

Tokenizer.prototype.getAbsoluteIndex = function(){
	return this._bufferOffset + this._index;
};

Tokenizer.prototype._getSection = function(){
	return this._buffer.substring(this._sectionStart, this._index);
};

Tokenizer.prototype._emitToken = function(name){
	this._cbs[name](this._getSection());
	this._sectionStart = -1;
};

Tokenizer.prototype._emitPartial = function(value){
	if(this._baseState !== TEXT){
		this._cbs.onattribdata(value); //TODO implement the new event
	} else {
		this._cbs.ontext(value);
	}
};


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(1689);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(1694);

var re_whitespace = /\s+/g;
var NodePrototype = __webpack_require__(1135);
var ElementPrototype = __webpack_require__(1695);

function DomHandler(callback, options, elementCB){
	if(typeof callback === "object"){
		elementCB = options;
		options = callback;
		callback = null;
	} else if(typeof options === "function"){
		elementCB = options;
		options = defaultOpts;
	}
	this._callback = callback;
	this._options = options || defaultOpts;
	this._elementCB = elementCB;
	this.dom = [];
	this._done = false;
	this._tagStack = [];
	this._parser = this._parser || null;
}

//default options
var defaultOpts = {
	normalizeWhitespace: false, //Replace all whitespace with single spaces
	withStartIndices: false, //Add startIndex properties to nodes
};

DomHandler.prototype.onparserinit = function(parser){
	this._parser = parser;
};

//Resets the handler back to starting state
DomHandler.prototype.onreset = function(){
	DomHandler.call(this, this._callback, this._options, this._elementCB);
};

//Signals the handler that parsing is done
DomHandler.prototype.onend = function(){
	if(this._done) return;
	this._done = true;
	this._parser = null;
	this._handleCallback(null);
};

DomHandler.prototype._handleCallback =
DomHandler.prototype.onerror = function(error){
	if(typeof this._callback === "function"){
		this._callback(error, this.dom);
	} else {
		if(error) throw error;
	}
};

DomHandler.prototype.onclosetag = function(){
	//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
	var elem = this._tagStack.pop();
	if(this._elementCB) this._elementCB(elem);
};

DomHandler.prototype._addDomElement = function(element){
	var parent = this._tagStack[this._tagStack.length - 1];
	var siblings = parent ? parent.children : this.dom;
	var previousSibling = siblings[siblings.length - 1];

	element.next = null;

	if(this._options.withStartIndices){
		element.startIndex = this._parser.startIndex;
	}

	if (this._options.withDomLvl1) {
		element.__proto__ = element.type === "tag" ? ElementPrototype : NodePrototype;
	}

	if(previousSibling){
		element.prev = previousSibling;
		previousSibling.next = element;
	} else {
		element.prev = null;
	}

	siblings.push(element);
	element.parent = parent || null;
};

DomHandler.prototype.onopentag = function(name, attribs){
	var element = {
		type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
		name: name,
		attribs: attribs,
		children: []
	};

	this._addDomElement(element);

	this._tagStack.push(element);
};

DomHandler.prototype.ontext = function(data){
	//the ignoreWhitespace is officially dropped, but for now,
	//it's an alias for normalizeWhitespace
	var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;

	var lastTag;

	if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
		if(normalize){
			lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
		} else {
			lastTag.data += data;
		}
	} else {
		if(
			this._tagStack.length &&
			(lastTag = this._tagStack[this._tagStack.length - 1]) &&
			(lastTag = lastTag.children[lastTag.children.length - 1]) &&
			lastTag.type === ElementType.Text
		){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(normalize){
				data = data.replace(re_whitespace, " ");
			}

			this._addDomElement({
				data: data,
				type: ElementType.Text
			});
		}
	}
};

DomHandler.prototype.oncomment = function(data){
	var lastTag = this._tagStack[this._tagStack.length - 1];

	if(lastTag && lastTag.type === ElementType.Comment){
		lastTag.data += data;
		return;
	}

	var element = {
		data: data,
		type: ElementType.Comment
	};

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncdatastart = function(){
	var element = {
		children: [{
			data: "",
			type: ElementType.Text
		}],
		type: ElementType.CDATA
	};

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
	this._tagStack.pop();
};

DomHandler.prototype.onprocessinginstruction = function(name, data){
	this._addDomElement({
		name: name,
		data: data,
		type: ElementType.Directive
	});
};

module.exports = DomHandler;


/***/ }),
/* 1694 */
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

// DOM-Level-1-compliant structure
var NodePrototype = __webpack_require__(1135);
var ElementPrototype = module.exports = Object.create(NodePrototype);

var domLvl1 = {
	tagName: "name"
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(ElementPrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function shouldProcessEveryNode(node) {
  return true;
}

module.exports = {
  shouldProcessEveryNode: shouldProcessEveryNode,
};


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

var _camelize = __webpack_require__(1698);
var _curry = __webpack_require__(1703);

module.exports = _curry(function camelize(str) {
  return _camelize(str, true);
});


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(1699);
var decap = __webpack_require__(1702);

module.exports = function camelize(str, decapitalize) {
  str = trim(str).replace(/[-_\s]+(.)?/g, function(match, c) {
    return c ? c.toUpperCase() : "";
  });

  if (decapitalize === true) {
    return decap(str);
  } else {
    return str;
  }
};


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(1021);
var defaultToWhiteSpace = __webpack_require__(1700);
var nativeTrim = String.prototype.trim;

module.exports = function trim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrim) return nativeTrim.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
};


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

var escapeRegExp = __webpack_require__(1701);

module.exports = function defaultToWhiteSpace(characters) {
  if (characters == null)
    return '\\s';
  else if (characters.source)
    return characters.source;
  else
    return '[' + escapeRegExp(characters) + ']';
};


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(1021);

module.exports = function escapeRegExp(str) {
  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
};


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(1021);

module.exports = function decapitalize(str) {
  str = makeString(str);
  return str.charAt(0).toLowerCase() + str.slice(1);
};


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(1704),
    countDefinedItems = __webpack_require__(1706),
    slice = Array.prototype.slice,
    __;


function curry(fn, length, curryArgs) {
  return function() {
    var args = slice.call(arguments),
      concatArgs = curryArgs.concat(args),
      mergedArgs = [];

    if (length <= countDefinedItems(concatArgs)) {
      mergedArgs = merge(args, curryArgs);
      return fn.apply(null, mergedArgs);
    } else {
      if (length >= concatArgs.length) {
        return curry(fn, length, concatArgs);
      } else {
        return curry(fn, length, merge(args, curryArgs));
      }
    }
  };
}

module.exports = function(fn) {
  var args = slice.call(arguments, 1);

  return curry(fn, fn.length, args);
};

module.exports.n = function(fn, length) {
  var args = slice.call(arguments, 2);

  return curry(fn, length, args);
};

module.exports.__ = __;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__(1705);

module.exports = function merge(args, curryArgs) {
  var mergedArgs = [];

  mergedArgs = map(curryArgs, function(key, item) {
    if (typeof item === 'undefined') {
      return args.shift();
    } else {
      return item;
    }
  });

  return mergedArgs.concat(args);
};


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

var forEach = __webpack_require__(1139);

module.exports = function map(arr, fn) {
  var newArr = [];

  forEach(arr, function(key, item) {
    newArr.push(fn(key, item));
  });

  return newArr;
};


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

var forEach = __webpack_require__(1139);

module.exports = function(args) {
  var count = 0;

  forEach(args, function(key, item) {
    if (typeof item !== 'undefined') {
      count = count + 1;
    }
  });

  return count;
};


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__(878);

var _has = /*#__PURE__*/__webpack_require__(1020);

/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */


var toPairs = /*#__PURE__*/_curry1(function toPairs(obj) {
  var pairs = [];
  for (var prop in obj) {
    if (_has(prop, obj)) {
      pairs[pairs.length] = [prop, obj[prop]];
    }
  }
  return pairs;
});
module.exports = toPairs;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = /*#__PURE__*/__webpack_require__(1709);

var _reduce = /*#__PURE__*/__webpack_require__(1018);

/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */


var reduce = /*#__PURE__*/_curry3(_reduce);
module.exports = reduce;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__(878);

var _curry2 = /*#__PURE__*/__webpack_require__(846);

var _isPlaceholder = /*#__PURE__*/__webpack_require__(948);

/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1(function (_c) {
          return fn(a, b, _c);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}
module.exports = _curry3;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// These are all sourced from https://facebook.github.io/react/docs/tags-and-attributes.html -
// all attributes regardless of whether they have a different case to their HTML equivalents are
// listed to reduce the chance of human error and make it easier to just copy-paste the new list if
// it changes.

var HTML_ATTRIBUTES = [
  'accept', 'acceptCharset', 'accessKey', 'action', 'allowFullScreen', 'allowTransparency',
  'alt', 'async', 'autoComplete', 'autoFocus', 'autoPlay', 'capture', 'cellPadding',
  'cellSpacing', 'challenge', 'charSet', 'checked', 'cite', 'classID', 'className',
  'colSpan', 'cols', 'content', 'contentEditable', 'contextMenu', 'controls', 'coords',
  'crossOrigin', 'data', 'dateTime', 'default', 'defer', 'dir', 'disabled', 'download',
  'draggable', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate',
  'formTarget', 'frameBorder', 'headers', 'height', 'hidden', 'high', 'href', 'hrefLang',
  'htmlFor', 'httpEquiv', 'icon', 'id', 'inputMode', 'integrity', 'is', 'keyParams', 'keyType',
  'kind', 'label', 'lang', 'list', 'loop', 'low', 'manifest', 'marginHeight', 'marginWidth',
  'max', 'maxLength', 'media', 'mediaGroup', 'method', 'min', 'minLength', 'multiple', 'muted',
  'name', 'noValidate', 'nonce', 'open', 'optimum', 'pattern', 'placeholder', 'poster',
  'preload', 'profile', 'radioGroup', 'readOnly', 'rel', 'required', 'reversed', 'role',
  'rowSpan', 'rows', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected',
  'shape', 'size', 'sizes', 'span', 'spellCheck', 'src', 'srcDoc', 'srcLang', 'srcSet', 'start',
  'step', 'style', 'summary', 'tabIndex', 'target', 'title', 'type', 'useMap', 'value', 'width',
  'wmode', 'wrap',
];

var NON_STANDARD_ATTRIBUTES = [
  'autoCapitalize', 'autoCorrect', 'color', 'itemProp', 'itemScope', 'itemType', 'itemRef',
  'itemID', 'security', 'unselectable', 'results', 'autoSave',
];

var SVG_ATTRIBUTES = [
  'accentHeight', 'accumulate', 'additive', 'alignmentBaseline', 'allowReorder', 'alphabetic',
  'amplitude', 'arabicForm', 'ascent', 'attributeName', 'attributeType', 'autoReverse', 'azimuth',
  'baseFrequency', 'baseProfile', 'baselineShift', 'bbox', 'begin', 'bias', 'by', 'calcMode',
  'capHeight', 'clip', 'clipPath', 'clipPathUnits', 'clipRule', 'colorInterpolation',
  'colorInterpolationFilters', 'colorProfile', 'colorRendering', 'contentScriptType',
  'contentStyleType', 'cursor', 'cx', 'cy', 'd', 'decelerate', 'descent', 'diffuseConstant',
  'direction', 'display', 'divisor', 'dominantBaseline', 'dur', 'dx', 'dy', 'edgeMode',
  'elevation', 'enableBackground', 'end', 'exponent', 'externalResourcesRequired', 'fill',
  'fillOpacity', 'fillRule', 'filter', 'filterRes', 'filterUnits', 'floodColor', 'floodOpacity',
  'focusable', 'fontFamily', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle',
  'fontVariant', 'fontWeight', 'format', 'from', 'fx', 'fy', 'g1', 'g2', 'glyphName',
  'glyphOrientationHorizontal', 'glyphOrientationVertical', 'glyphRef',
  'gradientTransform', 'gradientUnits', 'hanging', 'horizAdvX', 'horizOriginX', 'ideographic',
  'imageRendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kernelMatrix',
  'kernelUnitLength', 'kerning', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust',
  'letterSpacing', 'lightingColor', 'limitingConeAngle', 'local', 'markerEnd', 'markerHeight',
  'markerMid', 'markerStart', 'markerUnits', 'markerWidth', 'mask', 'maskContentUnits',
  'maskUnits', 'mathematical', 'mode', 'numOctaves', 'offset', 'opacity', 'operator', 'order',
  'orient', 'orientation', 'origin', 'overflow', 'overlinePosition', 'overlineThickness',
  'paintOrder', 'panose1', 'pathLength', 'patternContentUnits', 'patternTransform',
  'patternUnits', 'pointerEvents', 'points', 'pointsAtX', 'pointsAtY', 'pointsAtZ',
  'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'r', 'radius', 'refX', 'refY',
  'renderingIntent', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures',
  'restart', 'result', 'rotate', 'rx', 'ry', 'scale', 'seed', 'shapeRendering', 'slope',
  'spacing', 'specularConstant', 'specularExponent', 'speed', 'spreadMethod', 'startOffset',
  'stdDeviation', 'stemh', 'stemv', 'stitchTiles', 'stopColor', 'stopOpacity',
  'strikethroughPosition', 'strikethroughThickness', 'string', 'stroke', 'strokeDasharray',
  'strokeDashoffset', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity',
  'strokeWidth', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY',
  'textAnchor', 'textDecoration', 'textLength', 'textRendering', 'to', 'transform', 'u1',
  'u2', 'underlinePosition', 'underlineThickness', 'unicode', 'unicodeBidi', 'unicodeRange',
  'unitsPerEm', 'vAlphabetic', 'vHanging', 'vIdeographic', 'vMathematical', 'values',
  'vectorEffect', 'version', 'vertAdvY', 'vertOriginX', 'vertOriginY', 'viewBox',
  'viewTarget', 'visibility', 'widths', 'wordSpacing', 'writingMode', 'x', 'x1', 'x2',
  'xChannelSelector', 'xHeight', 'xlinkActuate', 'xlinkArcrole', 'xlinkHref', 'xlinkRole',
  'xlinkShow', 'xlinkTitle', 'xlinkType', 'xmlns', 'xmlnsXlink', 'xmlBase', 'xmlLang',
  'xmlSpace', 'y', 'y1', 'y2', 'yChannelSelector', 'z', 'zoomAndPan',
];

var camelCaseMap = HTML_ATTRIBUTES
  .concat(NON_STANDARD_ATTRIBUTES)
  .concat(SVG_ATTRIBUTES)
  .reduce(function (soFar, attr) {
    var lower = attr.toLowerCase();
    if (lower !== attr) {
      soFar[lower] = attr;
    }
    return soFar;
  }, {});

module.exports = camelCaseMap;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _client = __webpack_require__(270);

var _pluggable = __webpack_require__(881);

var _pluggable2 = _interopRequireDefault(_pluggable);

var _profile_popover = __webpack_require__(1028);

var _profile_popover2 = _interopRequireDefault(_profile_popover);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtMention = function (_React$PureComponent) {
    (0, _inherits3.default)(AtMention, _React$PureComponent);

    function AtMention(props) {
        (0, _classCallCheck3.default)(this, AtMention);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AtMention.__proto__ || (0, _getPrototypeOf2.default)(AtMention)).call(this, props));

        _this.hideProfilePopover = _this.hideProfilePopover.bind(_this);

        _this.state = {
            user: _this.getUserFromMentionName(props)
        };
        return _this;
    }

    (0, _createClass3.default)(AtMention, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.mentionName !== this.props.mentionName || nextProps.usersByUsername !== this.props.usersByUsername) {
                this.setState({
                    user: this.getUserFromMentionName(nextProps)
                });
            }
        }
    }, {
        key: 'hideProfilePopover',
        value: function hideProfilePopover() {
            this.refs.overlay.hide();
        }
    }, {
        key: 'getUserFromMentionName',
        value: function getUserFromMentionName(props) {
            var usersByUsername = props.usersByUsername;
            var mentionName = props.mentionName;

            while (mentionName.length > 0) {
                if (usersByUsername.hasOwnProperty(mentionName)) {
                    return usersByUsername[mentionName];
                }

                // Repeatedly trim off trailing punctuation in case this is at the end of a sentence
                if (/[._-]$/.test(mentionName)) {
                    mentionName = mentionName.substring(0, mentionName.length - 1);
                } else {
                    break;
                }
            }

            return '';
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.user) {
                return _react2.default.createElement(
                    'span',
                    null,
                    '@' + this.props.mentionName
                );
            }

            var user = this.state.user;
            var suffix = this.props.mentionName.substring(user.username.length);

            var className = 'mention-link';
            if (user.id === this.props.currentUserId) {
                className += ' mention--highlight';
            }

            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        ref: 'overlay',
                        trigger: 'click',
                        placement: 'left',
                        rootClose: true,
                        overlay: _react2.default.createElement(
                            _pluggable2.default,
                            null,
                            _react2.default.createElement(_profile_popover2.default, {
                                user: user,
                                src: _client.Client4.getProfilePictureUrl(user.id, user.last_picture_update),
                                hide: this.hideProfilePopover,
                                isRHS: this.props.isRHS,
                                hasMention: this.props.hasMention
                            })
                        )
                    },
                    _react2.default.createElement(
                        'a',
                        { className: className },
                        '@' + Utils.getDisplayNameByUser(user)
                    )
                ),
                suffix
            );
        }
    }]);
    return AtMention;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

AtMention.propTypes = {
    currentUserId: _propTypes2.default.string.isRequired,
    hasMention: _propTypes2.default.bool,
    isRHS: _propTypes2.default.bool,
    mentionName: _propTypes2.default.string.isRequired,
    usersByUsername: _propTypes2.default.object.isRequired
};
AtMention.defaultProps = {
    isRHS: false,
    hasMention: false
};
exports.default = AtMention;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(298), __esModule: true };

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(299), __esModule: true };

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(300), __esModule: true };

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(301), __esModule: true };

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(1717);
var invariant = __webpack_require__(1718);
var ReactPropTypesSecret = __webpack_require__(1719);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createUncontrollable;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(30);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(1721);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */


      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(30);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(16);
var $entries = __webpack_require__(1131)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.properties = exports.end = undefined;

var _end = __webpack_require__(1724);

var _end2 = _interopRequireDefault(_end);

var _properties = __webpack_require__(1023);

var _properties2 = _interopRequireDefault(_properties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.end = _end2.default;
exports.properties = _properties2.default;
exports.default = { end: _end2.default, properties: _properties2.default };

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _properties = __webpack_require__(1023);

var _properties2 = _interopRequireDefault(_properties);

var _style = __webpack_require__(922);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onEnd(node, handler, duration) {
  var fakeEvent = {
    target: node,
    currentTarget: node
  },
      backup;

  if (!_properties2.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;

  if (_properties2.default.end) {
    node.addEventListener(_properties2.default.end, done, false);

    backup = setTimeout(function () {
      return done(fakeEvent);
    }, (duration || 100) * 1.5);
  } else setTimeout(done.bind(null, fakeEvent), 0);

  function done(event) {
    if (event.target !== event.currentTarget) return;
    clearTimeout(backup);
    event.target.removeEventListener(_properties2.default.end, done);
    handler.call(this);
  }
}

onEnd._parseDuration = parseDuration;

exports.default = onEnd;


function parseDuration(node) {
  var str = (0, _style2.default)(node, _properties2.default.duration),
      mult = str.indexOf('ms') === -1 ? 1000 : 1;

  return parseFloat(str) * mult;
}
module.exports = exports['default'];

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(1727);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(1145);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(1732);
var invariant = __webpack_require__(1733);
var ReactPropTypesSecret = __webpack_require__(1734);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(1147);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(304), __esModule: true };

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(1738);
var invariant = __webpack_require__(1739);
var ReactPropTypesSecret = __webpack_require__(1740);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = exports.filter = exports.off = exports.on = undefined;

var _on = __webpack_require__(1025);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(1026);

var _off2 = _interopRequireDefault(_off);

var _filter = __webpack_require__(1742);

var _filter2 = _interopRequireDefault(_filter);

var _listen = __webpack_require__(1744);

var _listen2 = _interopRequireDefault(_listen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.on = _on2.default;
exports.off = _off2.default;
exports.filter = _filter2.default;
exports.listen = _listen2.default;
exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterEvents;

var _contains = __webpack_require__(903);

var _contains2 = _interopRequireDefault(_contains);

var _querySelectorAll = __webpack_require__(1743);

var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll2.default)(top, selector);

    if (matches.some(function (match) {
      return (0, _contains2.default)(match, target);
    })) handler.call(this, e);
  };
}
module.exports = exports['default'];

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));

    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}
module.exports = exports['default'];

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(862);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _on = __webpack_require__(1025);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(1026);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listen = function listen() {};

if (_inDOM2.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on2.default)(node, eventName, handler, capture);
    return function () {
      (0, _off2.default)(node, eventName, handler, capture);
    };
  };
}

exports.default = listen;
module.exports = exports['default'];

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(1148);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(903);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(862);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(880);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(952);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(1746);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(795);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(1747);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(1154);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(1753);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(1150);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(1754);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(954);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(904);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType2.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType2.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.backdropTransition;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        {
          appear: true,
          'in': _this2.props.show
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(1748);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(922);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(1151);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(1153);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(1751);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = exports.removeClass = exports.addClass = undefined;

var _addClass = __webpack_require__(1749);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1750);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _hasClass = __webpack_require__(1152);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.addClass = _addClass2.default;
exports.removeClass = _removeClass2.default;
exports.hasClass = _hasClass2.default;
exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(1152);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(880);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(952);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(954);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(904);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(880);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(880);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(795);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(1154);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(1756);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(1149);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(769);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(880);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(952);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(1757);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(954);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(904);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(1155);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(1758);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(1156);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(904);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = position;

var _offset = __webpack_require__(1155);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(1759);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(1156);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(1760);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _style = __webpack_require__(922);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = { top: 0, left: 0 },
      offset;

  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent
  if ((0, _style2.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
    offset = (0, _offset2.default)(node);

    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);

    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
  }

  // Subtract parent offsets and node margins
  return _extends({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports['default'];

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetParent;

var _ownerDocument = __webpack_require__(902);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _style = __webpack_require__(922);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument2.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}
module.exports = exports['default'];

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(953);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}
module.exports = exports['default'];

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deleteProperty = __webpack_require__(176);

var _deleteProperty2 = _interopRequireDefault(_deleteProperty);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

// EXPERIMENTAL - SUBJECT TO CHANGE

var Pluggable = function (_React$PureComponent) {
    (0, _inherits3.default)(Pluggable, _React$PureComponent);

    function Pluggable() {
        (0, _classCallCheck3.default)(this, Pluggable);
        return (0, _possibleConstructorReturn3.default)(this, (Pluggable.__proto__ || (0, _getPrototypeOf2.default)(Pluggable)).apply(this, arguments));
    }

    (0, _createClass3.default)(Pluggable, [{
        key: 'render',
        value: function render() {
            var pluggableName = this.props.pluggableName;

            var child = void 0;
            if (this.props.children) {
                child = _react2.default.Children.only(this.props.children).type;
            } else if (!pluggableName) {
                return null;
            }

            var components = this.props.components;
            var childrenProps = child ? this.props.children.props : {};
            var componentName = pluggableName || child.getComponentName();

            // Include any props passed to this component or to the child component
            var props = (0, _extends3.default)({}, this.props);
            (0, _deleteProperty2.default)(props, 'children');
            (0, _deleteProperty2.default)(props, 'components');
            (0, _deleteProperty2.default)(props, 'pluggableName');
            props = (0, _extends3.default)({}, props, childrenProps);

            // Override the default component with any registered plugin's component
            if (components.hasOwnProperty(componentName)) {
                var PluginComponent = components[componentName].component;
                return _react2.default.createElement(PluginComponent, (0, _extends3.default)({}, props, {
                    theme: this.props.theme
                }));
            }

            if (child == null) {
                return null;
            }

            return _react2.default.cloneElement(this.props.children, (0, _extends3.default)({}, props));
        }
    }]);
    return Pluggable;
}(_react2.default.PureComponent);

Pluggable.propTypes = {

    /*
     * Should be a single overridable React component. One of this or pluggableName is required
     */
    children: _propTypes2.default.element,

    /*
     * Override the component to be plugged. One of this or children is required
     */
    pluggableName: _propTypes2.default.string,

    /*
     * Components for overriding provided by plugins
     */
    components: _propTypes2.default.object.isRequired,

    /*
     * Logged in user's theme
     */
    theme: _propTypes2.default.object.isRequired
};
exports.default = Pluggable;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _local_date_time = __webpack_require__(1157);

var _local_date_time2 = _interopRequireDefault(_local_date_time);

var _browser_history = __webpack_require__(273);

var _channel_actions = __webpack_require__(809);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _webrtc_actions = __webpack_require__(905);

var WebrtcActions = _interopRequireWildcard(_webrtc_actions);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var UserStatuses = _constants2.default.UserStatuses;
var PreReleaseFeatures = _constants2.default.PRE_RELEASE_FEATURES;

/**
 * The profile popover, or hovercard, that appears with user information when clicking
 * on the username or profile picture of a user.
 */

var ProfilePopover = function (_React$Component) {
    (0, _inherits3.default)(ProfilePopover, _React$Component);
    (0, _createClass3.default)(ProfilePopover, null, [{
        key: 'getComponentName',
        value: function getComponentName() {
            return 'ProfilePopover';
        }
    }]);

    function ProfilePopover(props) {
        (0, _classCallCheck3.default)(this, ProfilePopover);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ProfilePopover.__proto__ || (0, _getPrototypeOf2.default)(ProfilePopover)).call(this, props));

        _this.initWebrtc = _this.initWebrtc.bind(_this);
        _this.handleShowDirectChannel = _this.handleShowDirectChannel.bind(_this);
        _this.handleMentionKeyClick = _this.handleMentionKeyClick.bind(_this);
        _this.handleEditAccountSettings = _this.handleEditAccountSettings.bind(_this);
        _this.state = {
            currentUserId: _user_store2.default.getCurrentId(),
            loadingDMChannel: -1
        };
        return _this;
    }

    (0, _createClass3.default)(ProfilePopover, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            if (!Utils.areObjectsEqual(nextProps.user, this.props.user)) {
                return true;
            }

            if (nextProps.src !== this.props.src) {
                return true;
            }

            if (nextProps.status !== this.props.status) {
                return true;
            }

            if (nextProps.isBusy !== this.props.isBusy) {
                return true;
            }

            // React-Bootstrap Forwarded Props from OverlayTrigger to Popover
            if (nextProps.arrowOffsetLeft !== this.props.arrowOffsetLeft) {
                return true;
            }

            if (nextProps.arrowOffsetTop !== this.props.arrowOffsetTop) {
                return true;
            }

            if (nextProps.positionLeft !== this.props.positionLeft) {
                return true;
            }

            if (nextProps.positionTop !== this.props.positionTop) {
                return true;
            }

            return false;
        }
    }, {
        key: 'handleShowDirectChannel',
        value: function handleShowDirectChannel(e) {
            var _this2 = this;

            e.preventDefault();

            if (!this.props.user) {
                return;
            }

            var user = this.props.user;

            if (this.state.loadingDMChannel !== -1) {
                return;
            }

            this.setState({ loadingDMChannel: user.id });

            (0, _channel_actions.openDirectChannelToUser)(user.id, function () {
                if (Utils.isMobile()) {
                    GlobalActions.emitCloseRightHandSide();
                }
                _this2.setState({ loadingDMChannel: -1 });
                if (_this2.props.hide) {
                    _this2.props.hide();
                }
                _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/messages/@' + user.username);
            });
        }
    }, {
        key: 'initWebrtc',
        value: function initWebrtc() {
            if (this.props.status !== UserStatuses.OFFLINE && !_webrtc_store2.default.isBusy()) {
                GlobalActions.emitCloseRightHandSide();
                WebrtcActions.initWebrtc(this.props.user.id, true);
            }
        }
    }, {
        key: 'handleMentionKeyClick',
        value: function handleMentionKeyClick(e) {
            e.preventDefault();

            if (!this.props.user) {
                return;
            }
            if (this.props.hide) {
                this.props.hide();
            }
            GlobalActions.emitPopoverMentionKeyClick(this.props.isRHS, this.props.user.username);
        }
    }, {
        key: 'handleEditAccountSettings',
        value: function handleEditAccountSettings(e) {
            e.preventDefault();

            if (!this.props.user) {
                return;
            }
            if (this.props.hide) {
                this.props.hide();
            }
            GlobalActions.showAccountSettingsModal();
        }
    }, {
        key: 'render',
        value: function render() {
            var popoverProps = (0, _assign2.default)({}, this.props);
            delete popoverProps.user;
            delete popoverProps.src;
            delete popoverProps.status;
            delete popoverProps.isBusy;
            delete popoverProps.hide;
            delete popoverProps.isRHS;
            delete popoverProps.hasMention;
            delete popoverProps.dispatch;
            delete popoverProps.enableWebrtc;
            delete popoverProps.enableTimezone;

            var webrtc = void 0;
            var userMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

            var webrtcEnabled = this.props.enableWebrtc && userMedia && Utils.isFeatureEnabled(PreReleaseFeatures.WEBRTC_PREVIEW);

            if (webrtcEnabled && this.props.user.id !== this.state.currentUserId) {
                var isOnline = this.props.status !== UserStatuses.OFFLINE;
                var webrtcMessage = void 0;
                if (isOnline && !this.props.isBusy) {
                    webrtcMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user_profile.webrtc.call',
                        defaultMessage: 'Start Video Call'
                    });
                } else if (this.props.isBusy) {
                    webrtcMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user_profile.webrtc.unavailable',
                        defaultMessage: 'New call unavailable until your existing call ends'
                    });
                } else {
                    webrtcMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user_profile.webrtc.offline',
                        defaultMessage: 'The user is offline'
                    });
                }

                webrtc = _react2.default.createElement(
                    'div',
                    {
                        'data-toggle': 'tooltip',
                        key: 'makeCall',
                        className: 'popover__row'
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            className: 'text-nowrap user-popover__email',
                            onClick: this.initWebrtc,
                            disabled: !isOnline
                        },
                        _react2.default.createElement('i', { className: 'fa fa-video-camera' }),
                        webrtcMessage
                    )
                );
            }

            var dataContent = [];
            dataContent.push(_react2.default.createElement('img', {
                className: 'user-popover__image',
                alt: (this.props.user.username || 'user') + ' profile image',
                src: this.props.src,
                height: '128',
                width: '128',
                key: 'user-popover-image'
            }));

            var fullname = Utils.getFullName(this.props.user);
            if (fullname) {
                dataContent.push(_react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        delayShow: _constants2.default.WEBRTC_TIME_DELAY,
                        placement: 'top',
                        overlay: _react2.default.createElement(
                            _reactBootstrap.Tooltip,
                            { id: 'fullNameTooltip' },
                            fullname
                        ),
                        key: 'user-popover-fullname'
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'overflow--ellipsis text-nowrap padding-top'
                        },
                        _react2.default.createElement(
                            'strong',
                            null,
                            fullname
                        )
                    )
                ));
            }

            if (this.props.user.position) {
                var position = this.props.user.position.substring(0, _constants2.default.MAX_POSITION_LENGTH);
                dataContent.push(_react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        delayShow: _constants2.default.WEBRTC_TIME_DELAY,
                        placement: 'top',
                        overlay: _react2.default.createElement(
                            _reactBootstrap.Tooltip,
                            { id: 'positionTooltip' },
                            position
                        ),
                        key: 'user-popover-position'
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'overflow--ellipsis text-nowrap padding-bottom half'
                        },
                        position
                    )
                ));
            }

            var email = this.props.user.email;
            if (email) {
                dataContent.push(_react2.default.createElement('hr', {
                    key: 'user-popover-hr',
                    className: 'divider divider--expanded'
                }));

                dataContent.push(_react2.default.createElement(
                    'div',
                    {
                        'data-toggle': 'tooltip',
                        title: email,
                        key: 'user-popover-email'
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            href: 'mailto:' + email,
                            className: 'text-nowrap text-lowercase user-popover__email padding-bottom half'
                        },
                        email
                    )
                ));
            }

            if (this.props.enableTimezone && this.props.user.timezone) {
                dataContent.push(_react2.default.createElement(
                    'div',
                    {
                        key: 'user-popover-local-time',
                        className: 'padding-bottom half'
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user_profile.account.localTime',
                        defaultMessage: 'Local Time: '
                    }),
                    _react2.default.createElement(_local_date_time2.default, { userTimezone: this.props.user.timezone })
                ));
            }

            if (this.props.user.id === _user_store2.default.getCurrentId()) {
                dataContent.push(_react2.default.createElement(
                    'div',
                    {
                        'data-toggle': 'tooltip',
                        key: 'user-popover-settings',
                        className: 'popover__row first'
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            onClick: this.handleEditAccountSettings
                        },
                        _react2.default.createElement('i', { className: 'fa fa-pencil-square-o' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user_profile.account.editSettings',
                            defaultMessage: 'Edit Account Settings'
                        })
                    )
                ));
            }

            if (this.props.user.id !== _user_store2.default.getCurrentId()) {
                dataContent.push(_react2.default.createElement(
                    'div',
                    {
                        'data-toggle': 'tooltip',
                        key: 'user-popover-dm',
                        className: 'popover__row first'
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            className: 'text-nowrap text-lowercase user-popover__email',
                            onClick: this.handleShowDirectChannel
                        },
                        _react2.default.createElement('i', { className: 'fa fa-paper-plane' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user_profile.send.dm',
                            defaultMessage: 'Send Message'
                        })
                    )
                ));
                dataContent.push(webrtc);
            }

            var title = '@' + this.props.user.username;
            if (this.props.hasMention) {
                title = _react2.default.createElement(
                    'a',
                    { onClick: this.handleMentionKeyClick },
                    title
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.Popover,
                (0, _extends3.default)({}, popoverProps, {
                    title: title,
                    id: 'user-profile-popover'
                }),
                dataContent
            );
        }
    }]);
    return ProfilePopover;
}(_react2.default.Component);

ProfilePopover.propTypes = (0, _extends3.default)({

    /**
     * Source URL from the image to display in the popover
     */
    src: _propTypes2.default.string.isRequired,

    /**
     * User the popover is being opened for
     */
    user: _propTypes2.default.object.isRequired,

    /**
     * Status for the user, either 'offline', 'away', 'dnd' or 'online'
     */
    status: _propTypes2.default.string,

    /**
     * Set to true if the user is in a WebRTC call
     */
    isBusy: _propTypes2.default.bool,

    /**
     * Function to call to hide the popover
     */
    hide: _propTypes2.default.func,

    /**
     * Set to true if the popover was opened from the right-hand
     * sidebar (comment thread, search results, etc.)
     */
    isRHS: _propTypes2.default.bool,

    /**
     * @internal
     */
    hasMention: _propTypes2.default.bool,

    /**
     * Whether or not WebRtc is enabled.
     */
    enableWebrtc: _propTypes2.default.bool.isRequired

}, _reactBootstrap.Popover.propTypes);
ProfilePopover.defaultProps = {
    isRHS: false,
    hasMention: false
};


delete ProfilePopover.propTypes.id;

exports.default = ProfilePopover;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocalDateTime = function (_React$PureComponent) {
    (0, _inherits3.default)(LocalDateTime, _React$PureComponent);

    function LocalDateTime() {
        (0, _classCallCheck3.default)(this, LocalDateTime);
        return (0, _possibleConstructorReturn3.default)(this, (LocalDateTime.__proto__ || (0, _getPrototypeOf2.default)(LocalDateTime)).apply(this, arguments));
    }

    (0, _createClass3.default)(LocalDateTime, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                enableTimezone = _props.enableTimezone,
                eventTime = _props.eventTime,
                timeZone = _props.timeZone,
                useMilitaryTime = _props.useMilitaryTime;


            var date = eventTime ? new Date(eventTime) : new Date();

            var timezoneProps = enableTimezone && timeZone ? { timeZone: timeZone } : {};

            return _react2.default.createElement(
                'time',
                {
                    className: 'post__time',
                    dateTime: date.toISOString(),
                    title: date
                },
                _react2.default.createElement(_reactIntl.FormattedTime, (0, _extends3.default)({}, timezoneProps, {
                    hour12: !useMilitaryTime,
                    value: date
                }))
            );
        }
    }]);
    return LocalDateTime;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

LocalDateTime.propTypes = {

    /*
     * The time to display
     */
    eventTime: _propTypes2.default.number,

    /*
     * Set to display using 24 hour format
     */
    useMilitaryTime: _propTypes2.default.bool,

    /*
     * Current timezone of the user
     */
    timeZone: _propTypes2.default.string,

    /*
     * Enable timezone feature
     */
    enableTimezone: _propTypes2.default.bool
};
exports.default = LocalDateTime;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.searchPosts = searchPosts;
exports.clearSearch = clearSearch;
exports.removeSearchTerms = removeSearchTerms;

var _reduxBatchedActions = __webpack_require__(278);

var _client = __webpack_require__(270);

var _action_types = __webpack_require__(3);

var _channels = __webpack_require__(798);

var _helpers = __webpack_require__(821);

var _errors = __webpack_require__(828);

var _posts = __webpack_require__(808);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getMissingChannelsFromPosts(posts) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var _getState$entities$ch, channels, membersInChannel, myMembers, promises;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _getState$entities$ch = getState().entities.channels, channels = _getState$entities$ch.channels, membersInChannel = _getState$entities$ch.membersInChannel, myMembers = _getState$entities$ch.myMembers;
                            promises = [];


                            Object.values(posts).forEach(function (post) {
                                var id = post.channel_id;
                                if (!channels[id] || !myMembers[id]) {
                                    promises.push((0, _channels.getChannelAndMyMember)(id)(dispatch, getState));
                                }

                                if (!membersInChannel[id]) {
                                    promises.push((0, _channels.getChannelMembers)(id)(dispatch, getState));
                                }
                            });

                            return _context.abrupt('return', Promise.all(promises));

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function searchPosts(teamId, terms) {
    var _this2 = this;

    var isOrSearch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var posts;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.SearchTypes.SEARCH_POSTS_REQUEST }, getState);

                            posts = void 0;
                            _context2.prev = 2;
                            _context2.next = 5;
                            return _client.Client4.searchPosts(teamId, terms, isOrSearch);

                        case 5:
                            posts = _context2.sent;
                            _context2.next = 8;
                            return Promise.all([(0, _posts.getProfilesAndStatusesForPosts)(posts.posts, dispatch, getState), getMissingChannelsFromPosts(posts.posts)(dispatch, getState)]);

                        case 8:
                            _context2.next = 15;
                            break;

                        case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch, getState);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.SearchTypes.SEARCH_POSTS_FAILURE, error: _context2.t0 }, (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', { error: _context2.t0 });

                        case 15:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.SearchTypes.RECEIVED_SEARCH_POSTS,
                                data: posts
                            }, {
                                type: _action_types.SearchTypes.RECEIVED_SEARCH_TERM,
                                data: {
                                    teamId: teamId,
                                    terms: terms,
                                    isOrSearch: isOrSearch
                                }
                            }, {
                                type: _action_types.SearchTypes.SEARCH_POSTS_SUCCESS
                            }], 'SEARCH_POST_BATCH'), getState);

                            return _context2.abrupt('return', { data: posts });

                        case 17:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[2, 10]]);
        }));

        return function (_x4, _x5) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function clearSearch() {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.SearchTypes.REMOVE_SEARCH_POSTS }, getState);

                            return _context3.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function removeSearchTerms(teamId, terms) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({
                                type: _action_types.SearchTypes.REMOVE_SEARCH_TERM,
                                data: {
                                    teamId: teamId,
                                    terms: terms
                                }
                            }, getState);

                            return _context4.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x8, _x9) {
            return _ref4.apply(this, arguments);
        };
    }();
}

exports.default = {
    clearSearch: clearSearch,
    removeSearchTerms: removeSearchTerms,
    searchPosts: searchPosts
};

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _deleteProperty = __webpack_require__(176);

var _deleteProperty2 = _interopRequireDefault(_deleteProperty);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MAX_WEBSOCKET_FAILS = 7;
var MIN_WEBSOCKET_RETRY_TIME = 3000; // 3 sec
var MAX_WEBSOCKET_RETRY_TIME = 300000; // 5 mins

var WebSocketClient = function () {
    function WebSocketClient() {
        (0, _classCallCheck3.default)(this, WebSocketClient);

        this.conn = null;
        this.connectionUrl = null;
        this.sequence = 1;
        this.eventSequence = 0;
        this.connectFailCount = 0;
        this.eventCallback = null;
        this.responseCallbacks = {};
        this.firstConnectCallback = null;
        this.reconnectCallback = null;
        this.missedEventCallback = null;
        this.errorCallback = null;
        this.closeCallback = null;
    }

    (0, _createClass3.default)(WebSocketClient, [{
        key: 'initialize',
        value: function initialize() {
            var _this = this;

            var connectionUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.connectionUrl;
            var token = arguments[1];

            if (this.conn) {
                return;
            }

            if (connectionUrl == null) {
                console.log('websocket must have connection url'); //eslint-disable-line no-console
                return;
            }

            if (this.connectFailCount === 0) {
                console.log('websocket connecting to ' + connectionUrl); //eslint-disable-line no-console
            }

            this.conn = new WebSocket(connectionUrl);
            this.connectionUrl = connectionUrl;

            this.conn.onopen = function () {
                _this.eventSequence = 0;

                if (token) {
                    _this.sendMessage('authentication_challenge', { token: token });
                }

                if (_this.connectFailCount > 0) {
                    console.log('websocket re-established connection'); //eslint-disable-line no-console
                    if (_this.reconnectCallback) {
                        _this.reconnectCallback();
                    }
                } else if (_this.firstConnectCallback) {
                    _this.firstConnectCallback();
                }

                _this.connectFailCount = 0;
            };

            this.conn.onclose = function () {
                _this.conn = null;
                _this.sequence = 1;

                if (_this.connectFailCount === 0) {
                    console.log('websocket closed'); //eslint-disable-line no-console
                }

                _this.connectFailCount++;

                if (_this.closeCallback) {
                    _this.closeCallback(_this.connectFailCount);
                }

                var retryTime = MIN_WEBSOCKET_RETRY_TIME;

                // If we've failed a bunch of connections then start backing off
                if (_this.connectFailCount > MAX_WEBSOCKET_FAILS) {
                    retryTime = MIN_WEBSOCKET_RETRY_TIME * _this.connectFailCount * _this.connectFailCount;
                    if (retryTime > MAX_WEBSOCKET_RETRY_TIME) {
                        retryTime = MAX_WEBSOCKET_RETRY_TIME;
                    }
                }

                setTimeout(function () {
                    _this.initialize(connectionUrl, token);
                }, retryTime);
            };

            this.conn.onerror = function (evt) {
                if (_this.connectFailCount <= 1) {
                    console.log('websocket error'); //eslint-disable-line no-console
                    console.log(evt); //eslint-disable-line no-console
                }

                if (_this.errorCallback) {
                    _this.errorCallback(evt);
                }
            };

            this.conn.onmessage = function (evt) {
                var msg = JSON.parse(evt.data);
                if (msg.seq_reply) {
                    if (msg.error) {
                        console.log(msg); //eslint-disable-line no-console
                    }

                    if (_this.responseCallbacks[msg.seq_reply]) {
                        _this.responseCallbacks[msg.seq_reply](msg);
                        (0, _deleteProperty2.default)(_this.responseCallbacks, msg.seq_reply);
                    }
                } else if (_this.eventCallback) {
                    if (msg.seq !== _this.eventSequence && _this.missedEventCallback) {
                        console.log('missed websocket event, act_seq=' + msg.seq + ' exp_seq=' + _this.eventSequence); //eslint-disable-line no-console
                        _this.missedEventCallback();
                    }
                    _this.eventSequence = msg.seq + 1;
                    _this.eventCallback(msg);
                }
            };
        }
    }, {
        key: 'setEventCallback',
        value: function setEventCallback(callback) {
            this.eventCallback = callback;
        }
    }, {
        key: 'setFirstConnectCallback',
        value: function setFirstConnectCallback(callback) {
            this.firstConnectCallback = callback;
        }
    }, {
        key: 'setReconnectCallback',
        value: function setReconnectCallback(callback) {
            this.reconnectCallback = callback;
        }
    }, {
        key: 'setMissedEventCallback',
        value: function setMissedEventCallback(callback) {
            this.missedEventCallback = callback;
        }
    }, {
        key: 'setErrorCallback',
        value: function setErrorCallback(callback) {
            this.errorCallback = callback;
        }
    }, {
        key: 'setCloseCallback',
        value: function setCloseCallback(callback) {
            this.closeCallback = callback;
        }
    }, {
        key: 'close',
        value: function close() {
            this.connectFailCount = 0;
            this.sequence = 1;
            if (this.conn && this.conn.readyState === WebSocket.OPEN) {
                this.conn.onclose = function () {}; //eslint-disable-line no-empty-function
                this.conn.close();
                this.conn = null;
                console.log('websocket closed'); //eslint-disable-line no-console
            }
        }
    }, {
        key: 'sendMessage',
        value: function sendMessage(action, data, responseCallback) {
            var msg = {
                action: action,
                seq: this.sequence++,
                data: data
            };

            if (responseCallback) {
                this.responseCallbacks[msg.seq] = responseCallback;
            }

            if (this.conn && this.conn.readyState === WebSocket.OPEN) {
                this.conn.send((0, _stringify2.default)(msg));
            } else if (!this.conn || this.conn.readyState === WebSocket.CLOSED) {
                this.conn = null;
                this.initialize();
            }
        }
    }, {
        key: 'userTyping',
        value: function userTyping(channelId, parentId, callback) {
            var data = {};
            data.channel_id = channelId;
            data.parent_id = parentId;

            this.sendMessage('user_typing', data, callback);
        }
    }, {
        key: 'getStatuses',
        value: function getStatuses(callback) {
            this.sendMessage('get_statuses', null, callback);
        }
    }, {
        key: 'getStatusesByIds',
        value: function getStatusesByIds(userIds, callback) {
            var data = {};
            data.user_ids = userIds;
            this.sendMessage('get_statuses_by_ids', data, callback);
        }
    }]);
    return WebSocketClient;
}();

exports.default = WebSocketClient;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Autolinker.js
 * 1.6.0
 *
 * Copyright(c) 2017 Gregory Jacobs <greg@greg-jacobs.com>
 * MIT License
 *
 * https://github.com/gregjacobs/Autolinker.js
 */
;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.Autolinker = factory();
  }
}(this, function() {
/**
 * @class Autolinker
 * @extends Object
 *
 * Utility class used to process a given string of text, and wrap the matches in
 * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
 *
 * Any of the configuration options may be provided in an Object (map) provided
 * to the Autolinker constructor, which will configure how the {@link #link link()}
 * method will process the links.
 *
 * For example:
 *
 *     var autolinker = new Autolinker( {
 *         newWindow : false,
 *         truncate  : 30
 *     } );
 *
 *     var html = autolinker.link( "Joe went to www.yahoo.com" );
 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
 *
 *
 * The {@link #static-link static link()} method may also be used to inline
 * options into a single call, which may be more convenient for one-off uses.
 * For example:
 *
 *     var html = Autolinker.link( "Joe went to www.yahoo.com", {
 *         newWindow : false,
 *         truncate  : 30
 *     } );
 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
 *
 *
 * ## Custom Replacements of Links
 *
 * If the configuration options do not provide enough flexibility, a {@link #replaceFn}
 * may be provided to fully customize the output of Autolinker. This function is
 * called once for each URL/Email/Phone#/Hashtag/Mention (Twitter, Instagram)
 * match that is encountered.
 *
 * For example:
 *
 *     var input = "...";  // string with URLs, Email Addresses, Phone #s, Hashtags, and Mentions (Twitter, Instagram)
 *
 *     var linkedText = Autolinker.link( input, {
 *         replaceFn : function( match ) {
 *             console.log( "href = ", match.getAnchorHref() );
 *             console.log( "text = ", match.getAnchorText() );
 *
 *             switch( match.getType() ) {
 *                 case 'url' :
 *                     console.log( "url: ", match.getUrl() );
 *
 *                     if( match.getUrl().indexOf( 'mysite.com' ) === -1 ) {
 *                         var tag = match.buildTag();  // returns an `Autolinker.HtmlTag` instance, which provides mutator methods for easy changes
 *                         tag.setAttr( 'rel', 'nofollow' );
 *                         tag.addClass( 'external-link' );
 *
 *                         return tag;
 *
 *                     } else {
 *                         return true;  // let Autolinker perform its normal anchor tag replacement
 *                     }
 *
 *                 case 'email' :
 *                     var email = match.getEmail();
 *                     console.log( "email: ", email );
 *
 *                     if( email === "my@own.address" ) {
 *                         return false;  // don't auto-link this particular email address; leave as-is
 *                     } else {
 *                         return;  // no return value will have Autolinker perform its normal anchor tag replacement (same as returning `true`)
 *                     }
 *
 *                 case 'phone' :
 *                     var phoneNumber = match.getPhoneNumber();
 *                     console.log( phoneNumber );
 *
 *                     return '<a href="http://newplace.to.link.phone.numbers.to/">' + phoneNumber + '</a>';
 *
 *                 case 'hashtag' :
 *                     var hashtag = match.getHashtag();
 *                     console.log( hashtag );
 *
 *                     return '<a href="http://newplace.to.link.hashtag.handles.to/">' + hashtag + '</a>';
 *
 *                 case 'mention' :
 *                     var mention = match.getMention();
 *                     console.log( mention );
 *
 *                     return '<a href="http://newplace.to.link.mention.to/">' + mention + '</a>';
 *             }
 *         }
 *     } );
 *
 *
 * The function may return the following values:
 *
 * - `true` (Boolean): Allow Autolinker to replace the match as it normally
 *   would.
 * - `false` (Boolean): Do not replace the current match at all - leave as-is.
 * - Any String: If a string is returned from the function, the string will be
 *   used directly as the replacement HTML for the match.
 * - An {@link Autolinker.HtmlTag} instance, which can be used to build/modify
 *   an HTML tag before writing out its HTML text.
 *
 * @constructor
 * @param {Object} [cfg] The configuration options for the Autolinker instance,
 *   specified in an Object (map).
 */
var Autolinker = function( cfg ) {
	cfg = cfg || {};

	this.version = Autolinker.version;

	this.urls = this.normalizeUrlsCfg( cfg.urls );
	this.email = typeof cfg.email === 'boolean' ? cfg.email : true;
	this.phone = typeof cfg.phone === 'boolean' ? cfg.phone : true;
	this.hashtag = cfg.hashtag || false;
	this.mention = cfg.mention || false;
	this.newWindow = typeof cfg.newWindow === 'boolean' ? cfg.newWindow : true;
	this.stripPrefix = this.normalizeStripPrefixCfg( cfg.stripPrefix );
	this.stripTrailingSlash = typeof cfg.stripTrailingSlash === 'boolean' ? cfg.stripTrailingSlash : true;
	this.decodePercentEncoding = typeof cfg.decodePercentEncoding === 'boolean' ? cfg.decodePercentEncoding : true;

	// Validate the value of the `mention` cfg
	var mention = this.mention;
	if( mention !== false && mention !== 'twitter' && mention !== 'instagram' ) {
		throw new Error( "invalid `mention` cfg - see docs" );
	}

	// Validate the value of the `hashtag` cfg
	var hashtag = this.hashtag;
	if( hashtag !== false && hashtag !== 'twitter' && hashtag !== 'facebook' && hashtag !== 'instagram' ) {
		throw new Error( "invalid `hashtag` cfg - see docs" );
	}

	this.truncate = this.normalizeTruncateCfg( cfg.truncate );
	this.className = cfg.className || '';
	this.replaceFn = cfg.replaceFn || null;
	this.context = cfg.context || this;

	this.htmlParser = null;
	this.matchers = null;
	this.tagBuilder = null;
};



/**
 * Automatically links URLs, Email addresses, Phone Numbers, Twitter handles,
 * Hashtags, and Mentions found in the given chunk of HTML. Does not link URLs
 * found within HTML tags.
 *
 * For instance, if given the text: `You should go to http://www.yahoo.com`,
 * then the result will be `You should go to &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
 *
 * Example:
 *
 *     var linkedText = Autolinker.link( "Go to google.com", { newWindow: false } );
 *     // Produces: "Go to <a href="http://google.com">google.com</a>"
 *
 * @static
 * @param {String} textOrHtml The HTML or text to find matches within (depending
 *   on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #mention},
 *   {@link #hashtag}, and {@link #mention} options are enabled).
 * @param {Object} [options] Any of the configuration options for the Autolinker
 *   class, specified in an Object (map). See the class description for an
 *   example call.
 * @return {String} The HTML text, with matches automatically linked.
 */
Autolinker.link = function( textOrHtml, options ) {
	var autolinker = new Autolinker( options );
	return autolinker.link( textOrHtml );
};



/**
 * Parses the input `textOrHtml` looking for URLs, email addresses, phone
 * numbers, username handles, and hashtags (depending on the configuration
 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
 * objects describing those matches (without making any replacements).
 *
 * Note that if parsing multiple pieces of text, it is slightly more efficient
 * to create an Autolinker instance, and use the instance-level {@link #parse}
 * method.
 *
 * Example:
 *
 *     var matches = Autolinker.parse( "Hello google.com, I am asdf@asdf.com", {
 *         urls: true,
 *         email: true
 *     } );
 *
 *     console.log( matches.length );           // 2
 *     console.log( matches[ 0 ].getType() );   // 'url'
 *     console.log( matches[ 0 ].getUrl() );    // 'google.com'
 *     console.log( matches[ 1 ].getType() );   // 'email'
 *     console.log( matches[ 1 ].getEmail() );  // 'asdf@asdf.com'
 *
 * @static
 * @param {String} textOrHtml The HTML or text to find matches within
 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
 *   {@link #hashtag}, and {@link #mention} options are enabled).
 * @param {Object} [options] Any of the configuration options for the Autolinker
 *   class, specified in an Object (map). See the class description for an
 *   example call.
 * @return {Autolinker.match.Match[]} The array of Matches found in the
 *   given input `textOrHtml`.
 */
Autolinker.parse = function( textOrHtml, options ) {
	var autolinker = new Autolinker( options );
	return autolinker.parse( textOrHtml );
};


/**
 * @static
 * @property {String} version (readonly)
 *
 * The Autolinker version number in the form major.minor.patch
 *
 * Ex: 0.25.1
 */
Autolinker.version = '1.6.0';


Autolinker.prototype = {
	constructor : Autolinker,  // fix constructor property

	/**
	 * @cfg {Boolean/Object} [urls]
	 *
	 * `true` if URLs should be automatically linked, `false` if they should not
	 * be. Defaults to `true`.
	 *
	 * Examples:
	 *
	 *     urls: true
	 *
	 *     // or
	 *
	 *     urls: {
	 *         schemeMatches : true,
	 *         wwwMatches    : true,
	 *         tldMatches    : true
	 *     }
	 *
	 * As shown above, this option also accepts an Object form with 3 properties
	 * to allow for more customization of what exactly gets linked. All default
	 * to `true`:
	 *
	 * @cfg {Boolean} [urls.schemeMatches] `true` to match URLs found prefixed
	 *   with a scheme, i.e. `http://google.com`, or `other+scheme://google.com`,
	 *   `false` to prevent these types of matches.
	 * @cfg {Boolean} [urls.wwwMatches] `true` to match urls found prefixed with
	 *   `'www.'`, i.e. `www.google.com`. `false` to prevent these types of
	 *   matches. Note that if the URL had a prefixed scheme, and
	 *   `schemeMatches` is true, it will still be linked.
	 * @cfg {Boolean} [urls.tldMatches] `true` to match URLs with known top
	 *   level domains (.com, .net, etc.) that are not prefixed with a scheme or
	 *   `'www.'`. This option attempts to match anything that looks like a URL
	 *   in the given text. Ex: `google.com`, `asdf.org/?page=1`, etc. `false`
	 *   to prevent these types of matches.
	 */

	/**
	 * @cfg {Boolean} [email=true]
	 *
	 * `true` if email addresses should be automatically linked, `false` if they
	 * should not be.
	 */

	/**
	 * @cfg {Boolean} [phone=true]
	 *
	 * `true` if Phone numbers ("(555)555-5555") should be automatically linked,
	 * `false` if they should not be.
	 */

	/**
	 * @cfg {Boolean/String} [hashtag=false]
	 *
	 * A string for the service name to have hashtags (ex: "#myHashtag")
	 * auto-linked to. The currently-supported values are:
	 *
	 * - 'twitter'
	 * - 'facebook'
	 * - 'instagram'
	 *
	 * Pass `false` to skip auto-linking of hashtags.
	 */

	/**
	 * @cfg {String/Boolean} [mention=false]
	 *
	 * A string for the service name to have mentions (ex: "@myuser")
	 * auto-linked to. The currently supported values are:
	 *
	 * - 'twitter'
	 * - 'instagram'
	 *
	 * Defaults to `false` to skip auto-linking of mentions.
	 */

	/**
	 * @cfg {Boolean} [newWindow=true]
	 *
	 * `true` if the links should open in a new window, `false` otherwise.
	 */

	/**
	 * @cfg {Boolean/Object} [stripPrefix]
	 *
	 * `true` if 'http://' (or 'https://') and/or the 'www.' should be stripped
	 * from the beginning of URL links' text, `false` otherwise. Defaults to
	 * `true`.
	 *
	 * Examples:
	 *
	 *     stripPrefix: true
	 *
	 *     // or
	 *
	 *     stripPrefix: {
	 *         scheme : true,
	 *         www    : true
	 *     }
	 *
	 * As shown above, this option also accepts an Object form with 2 properties
	 * to allow for more customization of what exactly is prevented from being
	 * displayed. Both default to `true`:
	 *
	 * @cfg {Boolean} [stripPrefix.scheme] `true` to prevent the scheme part of
	 *   a URL match from being displayed to the user. Example:
	 *   `'http://google.com'` will be displayed as `'google.com'`. `false` to
	 *   not strip the scheme. NOTE: Only an `'http://'` or `'https://'` scheme
	 *   will be removed, so as not to remove a potentially dangerous scheme
	 *   (such as `'file://'` or `'javascript:'`)
	 * @cfg {Boolean} [stripPrefix.www] www (Boolean): `true` to prevent the
	 *   `'www.'` part of a URL match from being displayed to the user. Ex:
	 *   `'www.google.com'` will be displayed as `'google.com'`. `false` to not
	 *   strip the `'www'`.
	 */

	/**
	 * @cfg {Boolean} [stripTrailingSlash=true]
	 *
	 * `true` to remove the trailing slash from URL matches, `false` to keep
	 *  the trailing slash.
	 *
	 *  Example when `true`: `http://google.com/` will be displayed as
	 *  `http://google.com`.
	 */

	/**
	 * @cfg {Boolean} [decodePercentEncoding=true]
	 *
	 * `true` to decode percent-encoded characters in URL matches, `false` to keep
	 *  the percent-encoded characters.
	 *
	 *  Example when `true`: `https://en.wikipedia.org/wiki/San_Jos%C3%A9` will
	 *  be displayed as `https://en.wikipedia.org/wiki/San_José`.
	 */

	/**
	 * @cfg {Number/Object} [truncate=0]
	 *
	 * ## Number Form
	 *
	 * A number for how many characters matched text should be truncated to
	 * inside the text of a link. If the matched text is over this number of
	 * characters, it will be truncated to this length by adding a two period
	 * ellipsis ('..') to the end of the string.
	 *
	 * For example: A url like 'http://www.yahoo.com/some/long/path/to/a/file'
	 * truncated to 25 characters might look something like this:
	 * 'yahoo.com/some/long/pat..'
	 *
	 * Example Usage:
	 *
	 *     truncate: 25
	 *
	 *
	 *  Defaults to `0` for "no truncation."
	 *
	 *
	 * ## Object Form
	 *
	 * An Object may also be provided with two properties: `length` (Number) and
	 * `location` (String). `location` may be one of the following: 'end'
	 * (default), 'middle', or 'smart'.
	 *
	 * Example Usage:
	 *
	 *     truncate: { length: 25, location: 'middle' }
	 *
	 * @cfg {Number} [truncate.length=0] How many characters to allow before
	 *   truncation will occur. Defaults to `0` for "no truncation."
	 * @cfg {"end"/"middle"/"smart"} [truncate.location="end"]
	 *
	 * - 'end' (default): will truncate up to the number of characters, and then
	 *   add an ellipsis at the end. Ex: 'yahoo.com/some/long/pat..'
	 * - 'middle': will truncate and add the ellipsis in the middle. Ex:
	 *   'yahoo.com/s..th/to/a/file'
	 * - 'smart': for URLs where the algorithm attempts to strip out unnecessary
	 *   parts first (such as the 'www.', then URL scheme, hash, etc.),
	 *   attempting to make the URL human-readable before looking for a good
	 *   point to insert the ellipsis if it is still too long. Ex:
	 *   'yahoo.com/some..to/a/file'. For more details, see
	 *   {@link Autolinker.truncate.TruncateSmart}.
	 */

	/**
	 * @cfg {String} className
	 *
	 * A CSS class name to add to the generated links. This class will be added
	 * to all links, as well as this class plus match suffixes for styling
	 * url/email/phone/hashtag/mention links differently.
	 *
	 * For example, if this config is provided as "myLink", then:
	 *
	 * - URL links will have the CSS classes: "myLink myLink-url"
	 * - Email links will have the CSS classes: "myLink myLink-email", and
	 * - Phone links will have the CSS classes: "myLink myLink-phone"
	 * - Hashtag links will have the CSS classes: "myLink myLink-hashtag"
	 * - Mention links will have the CSS classes: "myLink myLink-mention myLink-[type]"
	 *   where [type] is either "instagram" or "twitter"
	 */

	/**
	 * @cfg {Function} replaceFn
	 *
	 * A function to individually process each match found in the input string.
	 *
	 * See the class's description for usage.
	 *
	 * The `replaceFn` can be called with a different context object (`this`
	 * reference) using the {@link #context} cfg.
	 *
	 * This function is called with the following parameter:
	 *
	 * @cfg {Autolinker.match.Match} replaceFn.match The Match instance which
	 *   can be used to retrieve information about the match that the `replaceFn`
	 *   is currently processing. See {@link Autolinker.match.Match} subclasses
	 *   for details.
	 */

	/**
	 * @cfg {Object} context
	 *
	 * The context object (`this` reference) to call the `replaceFn` with.
	 *
	 * Defaults to this Autolinker instance.
	 */


	/**
	 * @property {String} version (readonly)
	 *
	 * The Autolinker version number in the form major.minor.patch
	 *
	 * Ex: 0.25.1
	 */

	/**
	 * @private
	 * @property {Autolinker.htmlParser.HtmlParser} htmlParser
	 *
	 * The HtmlParser instance used to skip over HTML tags, while finding text
	 * nodes to process. This is lazily instantiated in the {@link #getHtmlParser}
	 * method.
	 */

	/**
	 * @private
	 * @property {Autolinker.matcher.Matcher[]} matchers
	 *
	 * The {@link Autolinker.matcher.Matcher} instances for this Autolinker
	 * instance.
	 *
	 * This is lazily created in {@link #getMatchers}.
	 */

	/**
	 * @private
	 * @property {Autolinker.AnchorTagBuilder} tagBuilder
	 *
	 * The AnchorTagBuilder instance used to build match replacement anchor tags.
	 * Note: this is lazily instantiated in the {@link #getTagBuilder} method.
	 */


	/**
	 * Normalizes the {@link #urls} config into an Object with 3 properties:
	 * `schemeMatches`, `wwwMatches`, and `tldMatches`, all Booleans.
	 *
	 * See {@link #urls} config for details.
	 *
	 * @private
	 * @param {Boolean/Object} urls
	 * @return {Object}
	 */
	normalizeUrlsCfg : function( urls ) {
		if( urls == null ) urls = true;  // default to `true`

		if( typeof urls === 'boolean' ) {
			return { schemeMatches: urls, wwwMatches: urls, tldMatches: urls };

		} else {  // object form
			return {
				schemeMatches : typeof urls.schemeMatches === 'boolean' ? urls.schemeMatches : true,
				wwwMatches    : typeof urls.wwwMatches === 'boolean'    ? urls.wwwMatches    : true,
				tldMatches    : typeof urls.tldMatches === 'boolean'    ? urls.tldMatches    : true
			};
		}
	},


	/**
	 * Normalizes the {@link #stripPrefix} config into an Object with 2
	 * properties: `scheme`, and `www` - both Booleans.
	 *
	 * See {@link #stripPrefix} config for details.
	 *
	 * @private
	 * @param {Boolean/Object} stripPrefix
	 * @return {Object}
	 */
	normalizeStripPrefixCfg : function( stripPrefix ) {
		if( stripPrefix == null ) stripPrefix = true;  // default to `true`

		if( typeof stripPrefix === 'boolean' ) {
			return { scheme: stripPrefix, www: stripPrefix };

		} else {  // object form
			return {
				scheme : typeof stripPrefix.scheme === 'boolean' ? stripPrefix.scheme : true,
				www    : typeof stripPrefix.www === 'boolean'    ? stripPrefix.www    : true
			};
		}
	},


	/**
	 * Normalizes the {@link #truncate} config into an Object with 2 properties:
	 * `length` (Number), and `location` (String).
	 *
	 * See {@link #truncate} config for details.
	 *
	 * @private
	 * @param {Number/Object} truncate
	 * @return {Object}
	 */
	normalizeTruncateCfg : function( truncate ) {
		if( typeof truncate === 'number' ) {
			return { length: truncate, location: 'end' };

		} else {  // object, or undefined/null
			return Autolinker.Util.defaults( truncate || {}, {
				length   : Number.POSITIVE_INFINITY,
				location : 'end'
			} );
		}
	},


	/**
	 * Parses the input `textOrHtml` looking for URLs, email addresses, phone
	 * numbers, username handles, and hashtags (depending on the configuration
	 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	 * objects describing those matches (without making any replacements).
	 *
	 * This method is used by the {@link #link} method, but can also be used to
	 * simply do parsing of the input in order to discover what kinds of links
	 * there are and how many.
	 *
	 * Example usage:
	 *
	 *     var autolinker = new Autolinker( {
	 *         urls: true,
	 *         email: true
	 *     } );
	 *
	 *     var matches = autolinker.parse( "Hello google.com, I am asdf@asdf.com" );
	 *
	 *     console.log( matches.length );           // 2
	 *     console.log( matches[ 0 ].getType() );   // 'url'
	 *     console.log( matches[ 0 ].getUrl() );    // 'google.com'
	 *     console.log( matches[ 1 ].getType() );   // 'email'
	 *     console.log( matches[ 1 ].getEmail() );  // 'asdf@asdf.com'
	 *
	 * @param {String} textOrHtml The HTML or text to find matches within
	 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
	 *   {@link #hashtag}, and {@link #mention} options are enabled).
	 * @return {Autolinker.match.Match[]} The array of Matches found in the
	 *   given input `textOrHtml`.
	 */
	parse : function( textOrHtml ) {
		var htmlParser = this.getHtmlParser(),
		    htmlNodes = htmlParser.parse( textOrHtml ),
		    anchorTagStackCount = 0,  // used to only process text around anchor tags, and any inner text/html they may have;
		    matches = [];

		// Find all matches within the `textOrHtml` (but not matches that are
		// already nested within <a> tags)
		for( var i = 0, len = htmlNodes.length; i < len; i++ ) {
			var node = htmlNodes[ i ],
			    nodeType = node.getType();

			if( nodeType === 'element' && node.getTagName() === 'a' ) {  // Process HTML anchor element nodes in the input `textOrHtml` to find out when we're within an <a> tag
				if( !node.isClosing() ) {  // it's the start <a> tag
					anchorTagStackCount++;
				} else {  // it's the end </a> tag
					anchorTagStackCount = Math.max( anchorTagStackCount - 1, 0 );  // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
				}

			} else if( nodeType === 'text' && anchorTagStackCount === 0 ) {  // Process text nodes that are not within an <a> tag
				var textNodeMatches = this.parseText( node.getText(), node.getOffset() );

				matches.push.apply( matches, textNodeMatches );
			}
		}


		// After we have found all matches, remove subsequent matches that
		// overlap with a previous match. This can happen for instance with URLs,
		// where the url 'google.com/#link' would match '#link' as a hashtag.
		matches = this.compactMatches( matches );

		// And finally, remove matches for match types that have been turned
		// off. We needed to have all match types turned on initially so that
		// things like hashtags could be filtered out if they were really just
		// part of a URL match (for instance, as a named anchor).
		matches = this.removeUnwantedMatches( matches );

		return matches;
	},


	/**
	 * After we have found all matches, we need to remove subsequent matches
	 * that overlap with a previous match. This can happen for instance with
	 * URLs, where the url 'google.com/#link' would match '#link' as a hashtag.
	 *
	 * @private
	 * @param {Autolinker.match.Match[]} matches
	 * @return {Autolinker.match.Match[]}
	 */
	compactMatches : function( matches ) {
		// First, the matches need to be sorted in order of offset
		matches.sort( function( a, b ) { return a.getOffset() - b.getOffset(); } );

		for( var i = 0; i < matches.length - 1; i++ ) {
			var match = matches[ i ],
					offset = match.getOffset(),
					matchedTextLength = match.getMatchedText().length,
			    endIdx = offset + matchedTextLength;

			if( i + 1 < matches.length ) {
				// Remove subsequent matches that equal offset with current match
				if( matches[ i + 1 ].getOffset() === offset ) {
					var removeIdx = matches[ i + 1 ].getMatchedText().length > matchedTextLength ? i : i + 1;
					matches.splice( removeIdx, 1 );
					continue;
				}

				// Remove subsequent matches that overlap with the current match
				if( matches[ i + 1 ].getOffset() <= endIdx ) {
					matches.splice( i + 1, 1 );
				}
			}
		}

		return matches;
	},


	/**
	 * Removes matches for matchers that were turned off in the options. For
	 * example, if {@link #hashtag hashtags} were not to be matched, we'll
	 * remove them from the `matches` array here.
	 *
	 * @private
	 * @param {Autolinker.match.Match[]} matches The array of matches to remove
	 *   the unwanted matches from. Note: this array is mutated for the
	 *   removals.
	 * @return {Autolinker.match.Match[]} The mutated input `matches` array.
	 */
	removeUnwantedMatches : function( matches ) {
		var remove = Autolinker.Util.remove;

		if( !this.hashtag ) remove( matches, function( match ) { return match.getType() === 'hashtag'; } );
		if( !this.email )   remove( matches, function( match ) { return match.getType() === 'email'; } );
		if( !this.phone )   remove( matches, function( match ) { return match.getType() === 'phone'; } );
		if( !this.mention ) remove( matches, function( match ) { return match.getType() === 'mention'; } );
		if( !this.urls.schemeMatches ) {
			remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'scheme'; } );
		}
		if( !this.urls.wwwMatches ) {
			remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'www'; } );
		}
		if( !this.urls.tldMatches ) {
			remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'tld'; } );
		}

		return matches;
	},


	/**
	 * Parses the input `text` looking for URLs, email addresses, phone
	 * numbers, username handles, and hashtags (depending on the configuration
	 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	 * objects describing those matches.
	 *
	 * This method processes a **non-HTML string**, and is used to parse and
	 * match within the text nodes of an HTML string. This method is used
	 * internally by {@link #parse}.
	 *
	 * @private
	 * @param {String} text The text to find matches within (depending on if the
	 *   {@link #urls}, {@link #email}, {@link #phone},
	 *   {@link #hashtag}, and {@link #mention} options are enabled). This must be a non-HTML string.
	 * @param {Number} [offset=0] The offset of the text node within the
	 *   original string. This is used when parsing with the {@link #parse}
	 *   method to generate correct offsets within the {@link Autolinker.match.Match}
	 *   instances, but may be omitted if calling this method publicly.
	 * @return {Autolinker.match.Match[]} The array of Matches found in the
	 *   given input `text`.
	 */
	parseText : function( text, offset ) {
		offset = offset || 0;
		var matchers = this.getMatchers(),
		    matches = [];

		for( var i = 0, numMatchers = matchers.length; i < numMatchers; i++ ) {
			var textMatches = matchers[ i ].parseMatches( text );

			// Correct the offset of each of the matches. They are originally
			// the offset of the match within the provided text node, but we
			// need to correct them to be relative to the original HTML input
			// string (i.e. the one provided to #parse).
			for( var j = 0, numTextMatches = textMatches.length; j < numTextMatches; j++ ) {
				textMatches[ j ].setOffset( offset + textMatches[ j ].getOffset() );
			}

			matches.push.apply( matches, textMatches );
		}
		return matches;
	},


	/**
	 * Automatically links URLs, Email addresses, Phone numbers, Hashtags,
	 * and Mentions (Twitter, Instagram) found in the given chunk of HTML. Does not link
	 * URLs found within HTML tags.
	 *
	 * For instance, if given the text: `You should go to http://www.yahoo.com`,
	 * then the result will be `You should go to
	 * &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
	 *
	 * This method finds the text around any HTML elements in the input
	 * `textOrHtml`, which will be the text that is processed. Any original HTML
	 * elements will be left as-is, as well as the text that is already wrapped
	 * in anchor (&lt;a&gt;) tags.
	 *
	 * @param {String} textOrHtml The HTML or text to autolink matches within
	 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #hashtag}, and {@link #mention} options are enabled).
	 * @return {String} The HTML, with matches automatically linked.
	 */
	link : function( textOrHtml ) {
		if( !textOrHtml ) { return ""; }  // handle `null` and `undefined`

		var matches = this.parse( textOrHtml ),
			newHtml = [],
			lastIndex = 0;

		for( var i = 0, len = matches.length; i < len; i++ ) {
			var match = matches[ i ];

			newHtml.push( textOrHtml.substring( lastIndex, match.getOffset() ) );
			newHtml.push( this.createMatchReturnVal( match ) );

			lastIndex = match.getOffset() + match.getMatchedText().length;
		}
		newHtml.push( textOrHtml.substring( lastIndex ) );  // handle the text after the last match

		return newHtml.join( '' );
	},


	/**
	 * Creates the return string value for a given match in the input string.
	 *
	 * This method handles the {@link #replaceFn}, if one was provided.
	 *
	 * @private
	 * @param {Autolinker.match.Match} match The Match object that represents
	 *   the match.
	 * @return {String} The string that the `match` should be replaced with.
	 *   This is usually the anchor tag string, but may be the `matchStr` itself
	 *   if the match is not to be replaced.
	 */
	createMatchReturnVal : function( match ) {
		// Handle a custom `replaceFn` being provided
		var replaceFnResult;
		if( this.replaceFn ) {
			replaceFnResult = this.replaceFn.call( this.context, match );  // Autolinker instance is the context
		}

		if( typeof replaceFnResult === 'string' ) {
			return replaceFnResult;  // `replaceFn` returned a string, use that

		} else if( replaceFnResult === false ) {
			return match.getMatchedText();  // no replacement for the match

		} else if( replaceFnResult instanceof Autolinker.HtmlTag ) {
			return replaceFnResult.toAnchorString();

		} else {  // replaceFnResult === true, or no/unknown return value from function
			// Perform Autolinker's default anchor tag generation
			var anchorTag = match.buildTag();  // returns an Autolinker.HtmlTag instance

			return anchorTag.toAnchorString();
		}
	},


	/**
	 * Lazily instantiates and returns the {@link #htmlParser} instance for this
	 * Autolinker instance.
	 *
	 * @protected
	 * @return {Autolinker.htmlParser.HtmlParser}
	 */
	getHtmlParser : function() {
		var htmlParser = this.htmlParser;

		if( !htmlParser ) {
			htmlParser = this.htmlParser = new Autolinker.htmlParser.HtmlParser();
		}

		return htmlParser;
	},


	/**
	 * Lazily instantiates and returns the {@link Autolinker.matcher.Matcher}
	 * instances for this Autolinker instance.
	 *
	 * @protected
	 * @return {Autolinker.matcher.Matcher[]}
	 */
	getMatchers : function() {
		if( !this.matchers ) {
			var matchersNs = Autolinker.matcher,
			    tagBuilder = this.getTagBuilder();

			var matchers = [
				new matchersNs.Hashtag( { tagBuilder: tagBuilder, serviceName: this.hashtag } ),
				new matchersNs.Email( { tagBuilder: tagBuilder } ),
				new matchersNs.Phone( { tagBuilder: tagBuilder } ),
				new matchersNs.Mention( { tagBuilder: tagBuilder, serviceName: this.mention } ),
				new matchersNs.Url( { tagBuilder: tagBuilder, stripPrefix: this.stripPrefix, stripTrailingSlash: this.stripTrailingSlash, decodePercentEncoding: this.decodePercentEncoding } )
			];

			return ( this.matchers = matchers );

		} else {
			return this.matchers;
		}
	},


	/**
	 * Returns the {@link #tagBuilder} instance for this Autolinker instance, lazily instantiating it
	 * if it does not yet exist.
	 *
	 * This method may be used in a {@link #replaceFn} to generate the {@link Autolinker.HtmlTag HtmlTag} instance that
	 * Autolinker would normally generate, and then allow for modifications before returning it. For example:
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( match ) {
	 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 *
	 * @return {Autolinker.AnchorTagBuilder}
	 */
	getTagBuilder : function() {
		var tagBuilder = this.tagBuilder;

		if( !tagBuilder ) {
			tagBuilder = this.tagBuilder = new Autolinker.AnchorTagBuilder( {
				newWindow   : this.newWindow,
				truncate    : this.truncate,
				className   : this.className
			} );
		}

		return tagBuilder;
	}

};


// Autolinker Namespaces

Autolinker.match = {};
Autolinker.matcher = {};
Autolinker.htmlParser = {};
Autolinker.truncate = {};

/*global Autolinker */
/*jshint eqnull:true, boss:true */
/**
 * @class Autolinker.Util
 * @singleton
 *
 * A few utility methods for Autolinker.
 */
Autolinker.Util = {

	/**
	 * @property {Function} abstractMethod
	 *
	 * A function object which represents an abstract method.
	 */
	abstractMethod : function() { throw "abstract"; },


	/**
	 * @private
	 * @property {RegExp} trimRegex
	 *
	 * The regular expression used to trim the leading and trailing whitespace
	 * from a string.
	 */
	trimRegex : /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,


	/**
	 * Assigns (shallow copies) the properties of `src` onto `dest`.
	 *
	 * @param {Object} dest The destination object.
	 * @param {Object} src The source object.
	 * @return {Object} The destination object (`dest`)
	 */
	assign : function( dest, src ) {
		for( var prop in src ) {
			if( src.hasOwnProperty( prop ) ) {
				dest[ prop ] = src[ prop ];
			}
		}

		return dest;
	},


	/**
	 * Assigns (shallow copies) the properties of `src` onto `dest`, if the
	 * corresponding property on `dest` === `undefined`.
	 *
	 * @param {Object} dest The destination object.
	 * @param {Object} src The source object.
	 * @return {Object} The destination object (`dest`)
	 */
	defaults : function( dest, src ) {
		for( var prop in src ) {
			if( src.hasOwnProperty( prop ) && dest[ prop ] === undefined ) {
				dest[ prop ] = src[ prop ];
			}
		}

		return dest;
	},


	/**
	 * Extends `superclass` to create a new subclass, adding the `protoProps` to the new subclass's prototype.
	 *
	 * @param {Function} superclass The constructor function for the superclass.
	 * @param {Object} protoProps The methods/properties to add to the subclass's prototype. This may contain the
	 *   special property `constructor`, which will be used as the new subclass's constructor function.
	 * @return {Function} The new subclass function.
	 */
	extend : function( superclass, protoProps ) {
		var superclassProto = superclass.prototype;

		var F = function() {};
		F.prototype = superclassProto;

		var subclass;
		if( protoProps.hasOwnProperty( 'constructor' ) ) {
			subclass = protoProps.constructor;
		} else {
			subclass = function() { superclassProto.constructor.apply( this, arguments ); };
		}

		var subclassProto = subclass.prototype = new F();  // set up prototype chain
		subclassProto.constructor = subclass;  // fix constructor property
		subclassProto.superclass = superclassProto;

		delete protoProps.constructor;  // don't re-assign constructor property to the prototype, since a new function may have been created (`subclass`), which is now already there
		Autolinker.Util.assign( subclassProto, protoProps );

		return subclass;
	},


	/**
	 * Truncates the `str` at `len - ellipsisChars.length`, and adds the `ellipsisChars` to the
	 * end of the string (by default, two periods: '..'). If the `str` length does not exceed
	 * `len`, the string will be returned unchanged.
	 *
	 * @param {String} str The string to truncate and add an ellipsis to.
	 * @param {Number} truncateLen The length to truncate the string at.
	 * @param {String} [ellipsisChars=...] The ellipsis character(s) to add to the end of `str`
	 *   when truncated. Defaults to '...'
	 */
	ellipsis : function( str, truncateLen, ellipsisChars ) {
		var ellipsisLength;

		if( str.length > truncateLen ) {
			if(ellipsisChars == null) {
			  ellipsisChars = '&hellip;';
			  ellipsisLength = 3;
			} else {
			  ellipsisLength = ellipsisChars.length;
			}

			str = str.substring( 0, truncateLen - ellipsisLength ) + ellipsisChars;
		}
		return str;
	},


	/**
	 * Supports `Array.prototype.indexOf()` functionality for old IE (IE8 and below).
	 *
	 * @param {Array} arr The array to find an element of.
	 * @param {*} element The element to find in the array, and return the index of.
	 * @return {Number} The index of the `element`, or -1 if it was not found.
	 */
	indexOf : function( arr, element ) {
		if( Array.prototype.indexOf ) {
			return arr.indexOf( element );

		} else {
			for( var i = 0, len = arr.length; i < len; i++ ) {
				if( arr[ i ] === element ) return i;
			}
			return -1;
		}
	},


	/**
	 * Removes array elements based on a filtering function. Mutates the input
	 * array.
	 *
	 * Using this instead of the ES5 Array.prototype.filter() function, to allow
	 * Autolinker compatibility with IE8, and also to prevent creating many new
	 * arrays in memory for filtering.
	 *
	 * @param {Array} arr The array to remove elements from. This array is
	 *   mutated.
	 * @param {Function} fn A function which should return `true` to
	 *   remove an element.
	 * @return {Array} The mutated input `arr`.
	 */
	remove : function( arr, fn ) {
		for( var i = arr.length - 1; i >= 0; i-- ) {
			if( fn( arr[ i ] ) === true ) {
				arr.splice( i, 1 );
			}
		}
	},


	/**
	 * Performs the functionality of what modern browsers do when `String.prototype.split()` is called
	 * with a regular expression that contains capturing parenthesis.
	 *
	 * For example:
	 *
	 *     // Modern browsers:
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', ',', 'b', ',', 'c' ]
	 *
	 *     // Old IE (including IE8):
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', 'b', 'c' ]
	 *
	 * This method emulates the functionality of modern browsers for the old IE case.
	 *
	 * @param {String} str The string to split.
	 * @param {RegExp} splitRegex The regular expression to split the input `str` on. The splitting
	 *   character(s) will be spliced into the array, as in the "modern browsers" example in the
	 *   description of this method.
	 *   Note #1: the supplied regular expression **must** have the 'g' flag specified.
	 *   Note #2: for simplicity's sake, the regular expression does not need
	 *   to contain capturing parenthesis - it will be assumed that any match has them.
	 * @return {String[]} The split array of strings, with the splitting character(s) included.
	 */
	splitAndCapture : function( str, splitRegex ) {
		if( !splitRegex.global ) throw new Error( "`splitRegex` must have the 'g' flag set" );

		var result = [],
		    lastIdx = 0,
		    match;

		while( match = splitRegex.exec( str ) ) {
			result.push( str.substring( lastIdx, match.index ) );
			result.push( match[ 0 ] );  // push the splitting char(s)

			lastIdx = match.index + match[ 0 ].length;
		}
		result.push( str.substring( lastIdx ) );

		return result;
	},


	/**
	 * Trims the leading and trailing whitespace from a string.
	 *
	 * @param {String} str The string to trim.
	 * @return {String}
	 */
	trim : function( str ) {
		return str.replace( this.trimRegex, '' );
	}

};

/*global Autolinker */
/*jshint boss:true */
/**
 * @class Autolinker.HtmlTag
 * @extends Object
 *
 * Represents an HTML tag, which can be used to easily build/modify HTML tags programmatically.
 *
 * Autolinker uses this abstraction to create HTML tags, and then write them out as strings. You may also use
 * this class in your code, especially within a {@link Autolinker#replaceFn replaceFn}.
 *
 * ## Examples
 *
 * Example instantiation:
 *
 *     var tag = new Autolinker.HtmlTag( {
 *         tagName : 'a',
 *         attrs   : { 'href': 'http://google.com', 'class': 'external-link' },
 *         innerHtml : 'Google'
 *     } );
 *
 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
 *
 *     // Individual accessor methods
 *     tag.getTagName();                 // 'a'
 *     tag.getAttr( 'href' );            // 'http://google.com'
 *     tag.hasClass( 'external-link' );  // true
 *
 *
 * Using mutator methods (which may be used in combination with instantiation config properties):
 *
 *     var tag = new Autolinker.HtmlTag();
 *     tag.setTagName( 'a' );
 *     tag.setAttr( 'href', 'http://google.com' );
 *     tag.addClass( 'external-link' );
 *     tag.setInnerHtml( 'Google' );
 *
 *     tag.getTagName();                 // 'a'
 *     tag.getAttr( 'href' );            // 'http://google.com'
 *     tag.hasClass( 'external-link' );  // true
 *
 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
 *
 *
 * ## Example use within a {@link Autolinker#replaceFn replaceFn}
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( match ) {
 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance, configured with the Match's href and anchor text
 *             tag.setAttr( 'rel', 'nofollow' );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
 *
 *
 * ## Example use with a new tag for the replacement
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( match ) {
 *             var tag = new Autolinker.HtmlTag( {
 *                 tagName : 'button',
 *                 attrs   : { 'title': 'Load URL: ' + match.getAnchorHref() },
 *                 innerHtml : 'Load URL: ' + match.getAnchorText()
 *             } );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <button title="Load URL: http://google.com">Load URL: google.com</button>
 */
Autolinker.HtmlTag = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {String} tagName
	 *
	 * The tag name. Ex: 'a', 'button', etc.
	 *
	 * Not required at instantiation time, but should be set using {@link #setTagName} before {@link #toAnchorString}
	 * is executed.
	 */

	/**
	 * @cfg {Object.<String, String>} attrs
	 *
	 * An key/value Object (map) of attributes to create the tag with. The keys are the attribute names, and the
	 * values are the attribute values.
	 */

	/**
	 * @cfg {String} innerHtml
	 *
	 * The inner HTML for the tag.
	 *
	 * Note the camel case name on `innerHtml`. Acronyms are camelCased in this utility (such as not to run into the acronym
	 * naming inconsistency that the DOM developers created with `XMLHttpRequest`). You may alternatively use {@link #innerHTML}
	 * if you prefer, but this one is recommended.
	 */

	/**
	 * @cfg {String} innerHTML
	 *
	 * Alias of {@link #innerHtml}, accepted for consistency with the browser DOM api, but prefer the camelCased version
	 * for acronym names.
	 */


	/**
	 * @protected
	 * @property {RegExp} whitespaceRegex
	 *
	 * Regular expression used to match whitespace in a string of CSS classes.
	 */
	whitespaceRegex : /\s+/,


	/**
	 * @constructor
	 * @param {Object} [cfg] The configuration properties for this class, in an Object (map)
	 */
	constructor : function( cfg ) {
		Autolinker.Util.assign( this, cfg );

		this.innerHtml = this.innerHtml || this.innerHTML;  // accept either the camelCased form or the fully capitalized acronym
	},


	/**
	 * Sets the tag name that will be used to generate the tag with.
	 *
	 * @param {String} tagName
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setTagName : function( tagName ) {
		this.tagName = tagName;
		return this;
	},


	/**
	 * Retrieves the tag name.
	 *
	 * @return {String}
	 */
	getTagName : function() {
		return this.tagName || "";
	},


	/**
	 * Sets an attribute on the HtmlTag.
	 *
	 * @param {String} attrName The attribute name to set.
	 * @param {String} attrValue The attribute value to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setAttr : function( attrName, attrValue ) {
		var tagAttrs = this.getAttrs();
		tagAttrs[ attrName ] = attrValue;

		return this;
	},


	/**
	 * Retrieves an attribute from the HtmlTag. If the attribute does not exist, returns `undefined`.
	 *
	 * @param {String} attrName The attribute name to retrieve.
	 * @return {String} The attribute's value, or `undefined` if it does not exist on the HtmlTag.
	 */
	getAttr : function( attrName ) {
		return this.getAttrs()[ attrName ];
	},


	/**
	 * Sets one or more attributes on the HtmlTag.
	 *
	 * @param {Object.<String, String>} attrs A key/value Object (map) of the attributes to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setAttrs : function( attrs ) {
		var tagAttrs = this.getAttrs();
		Autolinker.Util.assign( tagAttrs, attrs );

		return this;
	},


	/**
	 * Retrieves the attributes Object (map) for the HtmlTag.
	 *
	 * @return {Object.<String, String>} A key/value object of the attributes for the HtmlTag.
	 */
	getAttrs : function() {
		return this.attrs || ( this.attrs = {} );
	},


	/**
	 * Sets the provided `cssClass`, overwriting any current CSS classes on the HtmlTag.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to set (overwrite).
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setClass : function( cssClass ) {
		return this.setAttr( 'class', cssClass );
	},


	/**
	 * Convenience method to add one or more CSS classes to the HtmlTag. Will not add duplicate CSS classes.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to add.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	addClass : function( cssClass ) {
		var classAttr = this.getClass(),
		    whitespaceRegex = this.whitespaceRegex,
		    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
		    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
		    newClasses = cssClass.split( whitespaceRegex ),
		    newClass;

		while( newClass = newClasses.shift() ) {
			if( indexOf( classes, newClass ) === -1 ) {
				classes.push( newClass );
			}
		}

		this.getAttrs()[ 'class' ] = classes.join( " " );
		return this;
	},


	/**
	 * Convenience method to remove one or more CSS classes from the HtmlTag.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to remove.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	removeClass : function( cssClass ) {
		var classAttr = this.getClass(),
		    whitespaceRegex = this.whitespaceRegex,
		    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
		    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
		    removeClasses = cssClass.split( whitespaceRegex ),
		    removeClass;

		while( classes.length && ( removeClass = removeClasses.shift() ) ) {
			var idx = indexOf( classes, removeClass );
			if( idx !== -1 ) {
				classes.splice( idx, 1 );
			}
		}

		this.getAttrs()[ 'class' ] = classes.join( " " );
		return this;
	},


	/**
	 * Convenience method to retrieve the CSS class(es) for the HtmlTag, which will each be separated by spaces when
	 * there are multiple.
	 *
	 * @return {String}
	 */
	getClass : function() {
		return this.getAttrs()[ 'class' ] || "";
	},


	/**
	 * Convenience method to check if the tag has a CSS class or not.
	 *
	 * @param {String} cssClass The CSS class to check for.
	 * @return {Boolean} `true` if the HtmlTag has the CSS class, `false` otherwise.
	 */
	hasClass : function( cssClass ) {
		return ( ' ' + this.getClass() + ' ' ).indexOf( ' ' + cssClass + ' ' ) !== -1;
	},


	/**
	 * Sets the inner HTML for the tag.
	 *
	 * @param {String} html The inner HTML to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setInnerHtml : function( html ) {
		this.innerHtml = html;

		return this;
	},


	/**
	 * Retrieves the inner HTML for the tag.
	 *
	 * @return {String}
	 */
	getInnerHtml : function() {
		return this.innerHtml || "";
	},


	/**
	 * Override of superclass method used to generate the HTML string for the tag.
	 *
	 * @return {String}
	 */
	toAnchorString : function() {
		var tagName = this.getTagName(),
		    attrsStr = this.buildAttrsStr();

		attrsStr = ( attrsStr ) ? ' ' + attrsStr : '';  // prepend a space if there are actually attributes

		return [ '<', tagName, attrsStr, '>', this.getInnerHtml(), '</', tagName, '>' ].join( "" );
	},


	/**
	 * Support method for {@link #toAnchorString}, returns the string space-separated key="value" pairs, used to populate
	 * the stringified HtmlTag.
	 *
	 * @protected
	 * @return {String} Example return: `attr1="value1" attr2="value2"`
	 */
	buildAttrsStr : function() {
		if( !this.attrs ) return "";  // no `attrs` Object (map) has been set, return empty string

		var attrs = this.getAttrs(),
		    attrsArr = [];

		for( var prop in attrs ) {
			if( attrs.hasOwnProperty( prop ) ) {
				attrsArr.push( prop + '="' + attrs[ prop ] + '"' );
			}
		}
		return attrsArr.join( " " );
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.RegexLib
 * @singleton
 *
 * Builds and stores a library of the common regular expressions used by the
 * Autolinker utility.
 *
 * Other regular expressions may exist ad-hoc, but these are generally the
 * regular expressions that are shared between source files.
 */
Autolinker.RegexLib = (function() {

	/**
	 * The string form of a regular expression that would match all of the
	 * alphabetic ("letter") chars in the unicode character set when placed in a
	 * RegExp character class (`[]`). This includes all international alphabetic
	 * characters.
	 *
	 * These would be the characters matched by unicode regex engines `\p{L}`
	 * escape ("all letters").
	 *
	 * Taken from the XRegExp library: http://xregexp.com/
	 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
	 *
	 * @private
	 * @type {String}
	 */
	var alphaCharsStr = 'A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';

	/**
	 * The string form of a regular expression that would match all of the
	 * decimal number chars in the unicode character set when placed in a RegExp
	 * character class (`[]`).
	 *
	 * These would be the characters matched by unicode regex engines `\p{Nd}`
	 * escape ("all decimal numbers")
	 *
	 * Taken from the XRegExp library: http://xregexp.com/
	 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
	 *
	 * @private
	 * @type {String}
	 */
	var decimalNumbersStr = '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';


	// See documentation below
	var alphaNumericCharsStr = alphaCharsStr + decimalNumbersStr;

	// Simplified IP regular expression
	var ipRegex = new RegExp( '(?:[' + decimalNumbersStr + ']{1,3}\\.){3}[' + decimalNumbersStr + ']{1,3}' );

	// Protected domain label which do not allow "-" character on the beginning and the end of a single label
	var domainLabelStr = '[' + alphaNumericCharsStr + '](?:[' + alphaNumericCharsStr + '\\-]*[' + alphaNumericCharsStr + '])?';

	// See documentation below
	var domainNameRegex = new RegExp( '(?:(?:(?:' + domainLabelStr + '\\.)*(?:' + domainLabelStr + '))|(?:' + ipRegex.source + '))' );

	return {

		/**
		 * The string form of a regular expression that would match all of the
		 * letters and decimal number chars in the unicode character set when placed
		 * in a RegExp character class (`[]`).
		 *
		 * These would be the characters matched by unicode regex engines `[\p{L}\p{Nd}]`
		 * escape ("all letters and decimal numbers")
		 *
		 * @property {String} alphaNumericCharsStr
		 */
		alphaNumericCharsStr : alphaNumericCharsStr,

		/**
		 * The string form of a regular expression that would match all of the
		 * letters and in the unicode character set when placed
		 * in a RegExp character class (`[]`).
		 *
		 * These would be the characters matched by unicode regex engines `[\p{L}]`
		 * escape ("all letters")
		 *
		 * @property {String} alphaCharsStr
		 */
		alphaCharsStr : alphaCharsStr,

		/**
		 * A regular expression to match domain names of a URL or email address.
		 * Ex: 'google', 'yahoo', 'some-other-company', etc.
		 *
		 * @property {RegExp} domainNameRegex
		 */
		domainNameRegex : domainNameRegex,

	};


}() );

/*global Autolinker */
/*jshint sub:true */
/**
 * @protected
 * @class Autolinker.AnchorTagBuilder
 * @extends Object
 *
 * Builds anchor (&lt;a&gt;) tags for the Autolinker utility when a match is
 * found.
 *
 * Normally this class is instantiated, configured, and used internally by an
 * {@link Autolinker} instance, but may actually be used indirectly in a
 * {@link Autolinker#replaceFn replaceFn} to create {@link Autolinker.HtmlTag HtmlTag}
 * instances which may be modified before returning from the
 * {@link Autolinker#replaceFn replaceFn}. For example:
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( match ) {
 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance
 *             tag.setAttr( 'rel', 'nofollow' );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
 */
Autolinker.AnchorTagBuilder = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {Boolean} newWindow
	 * @inheritdoc Autolinker#newWindow
	 */

	/**
	 * @cfg {Object} truncate
	 * @inheritdoc Autolinker#truncate
	 */

	/**
	 * @cfg {String} className
	 * @inheritdoc Autolinker#className
	 */


	/**
	 * @constructor
	 * @param {Object} [cfg] The configuration options for the AnchorTagBuilder instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		cfg = cfg || {};

		this.newWindow = cfg.newWindow;
		this.truncate = cfg.truncate;
		this.className = cfg.className;
	},


	/**
	 * Generates the actual anchor (&lt;a&gt;) tag to use in place of the
	 * matched text, via its `match` object.
	 *
	 * @param {Autolinker.match.Match} match The Match instance to generate an
	 *   anchor tag from.
	 * @return {Autolinker.HtmlTag} The HtmlTag instance for the anchor tag.
	 */
	build : function( match ) {
		return new Autolinker.HtmlTag( {
			tagName   : 'a',
			attrs     : this.createAttrs( match ),
			innerHtml : this.processAnchorText( match.getAnchorText() )
		} );
	},


	/**
	 * Creates the Object (map) of the HTML attributes for the anchor (&lt;a&gt;)
	 *   tag being generated.
	 *
	 * @protected
	 * @param {Autolinker.match.Match} match The Match instance to generate an
	 *   anchor tag from.
	 * @return {Object} A key/value Object (map) of the anchor tag's attributes.
	 */
	createAttrs : function( match ) {
		var attrs = {
			'href' : match.getAnchorHref()  // we'll always have the `href` attribute
		};

		var cssClass = this.createCssClass( match );
		if( cssClass ) {
			attrs[ 'class' ] = cssClass;
		}
		if( this.newWindow ) {
			attrs[ 'target' ] = "_blank";
			attrs[ 'rel' ] = "noopener noreferrer";
		}

		if( this.truncate ) {
			if( this.truncate.length && this.truncate.length < match.getAnchorText().length ) {
				attrs[ 'title' ] = match.getAnchorHref();
			}
		}

		return attrs;
	},


	/**
	 * Creates the CSS class that will be used for a given anchor tag, based on
	 * the `matchType` and the {@link #className} config.
	 *
	 * Example returns:
	 *
	 * - ""                                      // no {@link #className}
	 * - "myLink myLink-url"                     // url match
	 * - "myLink myLink-email"                   // email match
	 * - "myLink myLink-phone"                   // phone match
	 * - "myLink myLink-hashtag"                 // hashtag match
	 * - "myLink myLink-mention myLink-twitter"  // mention match with Twitter service
	 *
	 * @private
	 * @param {Autolinker.match.Match} match The Match instance to generate an
	 *   anchor tag from.
	 * @return {String} The CSS class string for the link. Example return:
	 *   "myLink myLink-url". If no {@link #className} was configured, returns
	 *   an empty string.
	 */
	createCssClass : function( match ) {
		var className = this.className;

		if( !className ) {
			return "";

		} else {
			var returnClasses = [ className ],
				cssClassSuffixes = match.getCssClassSuffixes();

			for( var i = 0, len = cssClassSuffixes.length; i < len; i++ ) {
				returnClasses.push( className + '-' + cssClassSuffixes[ i ] );
			}
			return returnClasses.join( ' ' );
		}
	},


	/**
	 * Processes the `anchorText` by truncating the text according to the
	 * {@link #truncate} config.
	 *
	 * @private
	 * @param {String} anchorText The anchor tag's text (i.e. what will be
	 *   displayed).
	 * @return {String} The processed `anchorText`.
	 */
	processAnchorText : function( anchorText ) {
		anchorText = this.doTruncate( anchorText );

		return anchorText;
	},


	/**
	 * Performs the truncation of the `anchorText` based on the {@link #truncate}
	 * option. If the `anchorText` is longer than the length specified by the
	 * {@link #truncate} option, the truncation is performed based on the
	 * `location` property. See {@link #truncate} for details.
	 *
	 * @private
	 * @param {String} anchorText The anchor tag's text (i.e. what will be
	 *   displayed).
	 * @return {String} The truncated anchor text.
	 */
	doTruncate : function( anchorText ) {
		var truncate = this.truncate;
		if( !truncate || !truncate.length ) return anchorText;

		var truncateLength = truncate.length,
			truncateLocation = truncate.location;

		if( truncateLocation === 'smart' ) {
			return Autolinker.truncate.TruncateSmart( anchorText, truncateLength );

		} else if( truncateLocation === 'middle' ) {
			return Autolinker.truncate.TruncateMiddle( anchorText, truncateLength );

		} else {
			return Autolinker.truncate.TruncateEnd( anchorText, truncateLength );
		}
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.htmlParser.HtmlParser
 * @extends Object
 *
 * An HTML parser implementation which simply walks an HTML string and returns an array of
 * {@link Autolinker.htmlParser.HtmlNode HtmlNodes} that represent the basic HTML structure of the input string.
 *
 * Autolinker uses this to only link URLs/emails/mentions within text nodes, effectively ignoring / "walking
 * around" HTML tags.
 */
Autolinker.htmlParser.HtmlParser = Autolinker.Util.extend( Object, {

	/**
	 * @private
	 * @property {RegExp} htmlRegex
	 *
	 * The regular expression used to pull out HTML tags from a string. Handles namespaced HTML tags and
	 * attribute names, as specified by http://www.w3.org/TR/html-markup/syntax.html.
	 *
	 * Capturing groups:
	 *
	 * 1. The "!DOCTYPE" tag name, if a tag is a &lt;!DOCTYPE&gt; tag.
	 * 2. If it is an end tag, this group will have the '/'.
	 * 3. If it is a comment tag, this group will hold the comment text (i.e.
	 *    the text inside the `&lt;!--` and `--&gt;`.
	 * 4. The tag name for a tag without attributes (other than the &lt;!DOCTYPE&gt; tag)
	 * 5. The tag name for a tag with attributes (other than the &lt;!DOCTYPE&gt; tag)
	 */
	htmlRegex : (function() {
		var commentTagRegex = /!--([\s\S]+?)--/,
		    tagNameRegex = /[0-9a-zA-Z][0-9a-zA-Z:]*/,
		    attrNameRegex = /[^\s"'>\/=\x00-\x1F\x7F]+/,   // the unicode range accounts for excluding control chars, and the delete char
		    attrValueRegex = /(?:"[^"]*?"|'[^']*?'|[^'"=<>`\s]+)/, // double quoted, single quoted, or unquoted attribute values
		    nameEqualsValueRegex = attrNameRegex.source + '(?:\\s*=\\s*' + attrValueRegex.source + ')?';  // optional '=[value]'

		return new RegExp( [
			// for <!DOCTYPE> tag. Ex: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
			'(?:',
				'<(!DOCTYPE)',  // *** Capturing Group 1 - If it's a doctype tag

					// Zero or more attributes following the tag name
					'(?:',
						'\\s+',  // one or more whitespace chars before an attribute

						// Either:
						// A. attr="value", or
						// B. "value" alone (To cover example doctype tag: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
						'(?:', nameEqualsValueRegex, '|', attrValueRegex.source + ')',
					')*',
				'>',
			')',

			'|',

			// All other HTML tags (i.e. tags that are not <!DOCTYPE>)
			'(?:',
				'<(/)?',  // Beginning of a tag or comment. Either '<' for a start tag, or '</' for an end tag.
				          // *** Capturing Group 2: The slash or an empty string. Slash ('/') for end tag, empty string for start or self-closing tag.

					'(?:',
						commentTagRegex.source,  // *** Capturing Group 3 - A Comment Tag's Text

						'|',

						// Handle tag without attributes.
						// Doing this separately from a tag that has attributes
						// to fix a regex time complexity issue seen with the
						// example in https://github.com/gregjacobs/Autolinker.js/issues/172
						'(?:',
							// *** Capturing Group 4 - The tag name for a tag without attributes
							'(' + tagNameRegex.source + ')',

							'\\s*/?',  // any trailing spaces and optional '/' before the closing '>'
						')',

						'|',

						// Handle tag with attributes
						// Doing this separately from a tag with no attributes
						// to fix a regex time complexity issue seen with the
						// example in https://github.com/gregjacobs/Autolinker.js/issues/172
						'(?:',
							// *** Capturing Group 5 - The tag name for a tag with attributes
							'(' + tagNameRegex.source + ')',

							'\\s+',  // must have at least one space after the tag name to prevent ReDoS issue (issue #172)

							// Zero or more attributes following the tag name
							'(?:',
								'(?:\\s+|\\b)',        // any number of whitespace chars before an attribute. NOTE: Using \s* here throws Chrome into an infinite loop for some reason, so using \s+|\b instead
								nameEqualsValueRegex,  // attr="value" (with optional ="value" part)
							')*',

							'\\s*/?',  // any trailing spaces and optional '/' before the closing '>'
						')',
					')',
				'>',
			')'
		].join( "" ), 'gi' );
	} )(),

	/**
	 * @private
	 * @property {RegExp} htmlCharacterEntitiesRegex
	 *
	 * The regular expression that matches common HTML character entities.
	 *
	 * Ignoring &amp; as it could be part of a query string -- handling it separately.
	 */
	htmlCharacterEntitiesRegex: /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi,


	/**
	 * Parses an HTML string and returns a simple array of {@link Autolinker.htmlParser.HtmlNode HtmlNodes}
	 * to represent the HTML structure of the input string.
	 *
	 * @param {String} html The HTML to parse.
	 * @return {Autolinker.htmlParser.HtmlNode[]}
	 */
	parse : function( html ) {
		var htmlRegex = this.htmlRegex,
		    currentResult,
		    lastIndex = 0,
		    textAndEntityNodes,
		    nodes = [];  // will be the result of the method

		while( ( currentResult = htmlRegex.exec( html ) ) !== null ) {
			var tagText = currentResult[ 0 ],
			    commentText = currentResult[ 3 ], // if we've matched a comment
			    tagName = currentResult[ 1 ] || currentResult[ 4 ] || currentResult[ 5 ],  // The <!DOCTYPE> tag (ex: "!DOCTYPE"), or another tag (ex: "a" or "img")
			    isClosingTag = !!currentResult[ 2 ],
			    offset = currentResult.index,
			    inBetweenTagsText = html.substring( lastIndex, offset );

			// Push TextNodes and EntityNodes for any text found between tags
			if( inBetweenTagsText ) {
				textAndEntityNodes = this.parseTextAndEntityNodes( lastIndex, inBetweenTagsText );
				nodes.push.apply( nodes, textAndEntityNodes );
			}

			// Push the CommentNode or ElementNode
			if( commentText ) {
				nodes.push( this.createCommentNode( offset, tagText, commentText ) );
			} else {
				nodes.push( this.createElementNode( offset, tagText, tagName, isClosingTag ) );
			}

			lastIndex = offset + tagText.length;
		}

		// Process any remaining text after the last HTML element. Will process all of the text if there were no HTML elements.
		if( lastIndex < html.length ) {
			var text = html.substring( lastIndex );

			// Push TextNodes and EntityNodes for any text found between tags
			if( text ) {
				textAndEntityNodes = this.parseTextAndEntityNodes( lastIndex, text );

				// Note: the following 3 lines were previously:
				//   nodes.push.apply( nodes, textAndEntityNodes );
				// but this was causing a "Maximum Call Stack Size Exceeded"
				// error on inputs with a large number of html entities.
				textAndEntityNodes.forEach( function( node ) {
					nodes.push( node );
				} );
			}
		}

		return nodes;
	},


	/**
	 * Parses text and HTML entity nodes from a given string. The input string
	 * should not have any HTML tags (elements) within it.
	 *
	 * @private
	 * @param {Number} offset The offset of the text node match within the
	 *   original HTML string.
	 * @param {String} text The string of text to parse. This is from an HTML
	 *   text node.
	 * @return {Autolinker.htmlParser.HtmlNode[]} An array of HtmlNodes to
	 *   represent the {@link Autolinker.htmlParser.TextNode TextNodes} and
	 *   {@link Autolinker.htmlParser.EntityNode EntityNodes} found.
	 */
	parseTextAndEntityNodes : function( offset, text ) {
		var nodes = [],
		    textAndEntityTokens = Autolinker.Util.splitAndCapture( text, this.htmlCharacterEntitiesRegex );  // split at HTML entities, but include the HTML entities in the results array

		// Every even numbered token is a TextNode, and every odd numbered token is an EntityNode
		// For example: an input `text` of "Test &quot;this&quot; today" would turn into the
		//   `textAndEntityTokens`: [ 'Test ', '&quot;', 'this', '&quot;', ' today' ]
		for( var i = 0, len = textAndEntityTokens.length; i < len; i += 2 ) {
			var textToken = textAndEntityTokens[ i ],
			    entityToken = textAndEntityTokens[ i + 1 ];

			if( textToken ) {
				nodes.push( this.createTextNode( offset, textToken ) );
				offset += textToken.length;
			}
			if( entityToken ) {
				nodes.push( this.createEntityNode( offset, entityToken ) );
				offset += entityToken.length;
			}
		}
		return nodes;
	},


	/**
	 * Factory method to create an {@link Autolinker.htmlParser.CommentNode CommentNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} tagText The full text of the tag (comment) that was
	 *   matched, including its &lt;!-- and --&gt;.
	 * @param {String} commentText The full text of the comment that was matched.
	 */
	createCommentNode : function( offset, tagText, commentText ) {
		return new Autolinker.htmlParser.CommentNode( {
			offset : offset,
			text   : tagText,
			comment: Autolinker.Util.trim( commentText )
		} );
	},


	/**
	 * Factory method to create an {@link Autolinker.htmlParser.ElementNode ElementNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} tagText The full text of the tag (element) that was
	 *   matched, including its attributes.
	 * @param {String} tagName The name of the tag. Ex: An &lt;img&gt; tag would
	 *   be passed to this method as "img".
	 * @param {Boolean} isClosingTag `true` if it's a closing tag, false
	 *   otherwise.
	 * @return {Autolinker.htmlParser.ElementNode}
	 */
	createElementNode : function( offset, tagText, tagName, isClosingTag ) {
		return new Autolinker.htmlParser.ElementNode( {
			offset  : offset,
			text    : tagText,
			tagName : tagName.toLowerCase(),
			closing : isClosingTag
		} );
	},


	/**
	 * Factory method to create a {@link Autolinker.htmlParser.EntityNode EntityNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} text The text that was matched for the HTML entity (such
	 *   as '&amp;nbsp;').
	 * @return {Autolinker.htmlParser.EntityNode}
	 */
	createEntityNode : function( offset, text ) {
		return new Autolinker.htmlParser.EntityNode( { offset: offset, text: text } );
	},


	/**
	 * Factory method to create a {@link Autolinker.htmlParser.TextNode TextNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} text The text that was matched.
	 * @return {Autolinker.htmlParser.TextNode}
	 */
	createTextNode : function( offset, text ) {
		return new Autolinker.htmlParser.TextNode( { offset: offset, text: text } );
	}

} );

/*global Autolinker */
/**
 * @abstract
 * @class Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML node found in an input string. An HTML node is one of the
 * following:
 *
 * 1. An {@link Autolinker.htmlParser.ElementNode ElementNode}, which represents
 *    HTML tags.
 * 2. A {@link Autolinker.htmlParser.CommentNode CommentNode}, which represents
 *    HTML comments.
 * 3. A {@link Autolinker.htmlParser.TextNode TextNode}, which represents text
 *    outside or within HTML tags.
 * 4. A {@link Autolinker.htmlParser.EntityNode EntityNode}, which represents
 *    one of the known HTML entities that Autolinker looks for. This includes
 *    common ones such as &amp;quot; and &amp;nbsp;
 */
Autolinker.htmlParser.HtmlNode = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {Number} offset (required)
	 *
	 * The offset of the HTML node in the original text that was parsed.
	 */
	offset : undefined,

	/**
	 * @cfg {String} text (required)
	 *
	 * The text that was matched for the HtmlNode.
	 *
	 * - In the case of an {@link Autolinker.htmlParser.ElementNode ElementNode},
	 *   this will be the tag's text.
	 * - In the case of an {@link Autolinker.htmlParser.CommentNode CommentNode},
	 *   this will be the comment's text.
	 * - In the case of a {@link Autolinker.htmlParser.TextNode TextNode}, this
	 *   will be the text itself.
	 * - In the case of a {@link Autolinker.htmlParser.EntityNode EntityNode},
	 *   this will be the text of the HTML entity.
	 */
	text : undefined,


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 * specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.Util.assign( this, cfg );

		if( this.offset == null ) throw new Error( '`offset` cfg required' );
		if( this.text == null ) throw new Error( '`text` cfg required' );
	},


	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @abstract
	 * @return {String}
	 */
	getType : Autolinker.Util.abstractMethod,


	/**
	 * Retrieves the {@link #offset} of the HtmlNode. This is the offset of the
	 * HTML node in the original string that was parsed.
	 *
	 * @return {Number}
	 */
	getOffset : function() {
		return this.offset;
	},


	/**
	 * Retrieves the {@link #text} for the HtmlNode.
	 *
	 * @return {String}
	 */
	getText : function() {
		return this.text;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.htmlParser.CommentNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML comment node that has been parsed by the
 * {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */
Autolinker.htmlParser.CommentNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {

	/**
	 * @cfg {String} comment (required)
	 *
	 * The text inside the comment tag. This text is stripped of any leading or
	 * trailing whitespace.
	 */
	comment : '',


	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'comment';
	},


	/**
	 * Returns the comment inside the comment tag.
	 *
	 * @return {String}
	 */
	getComment : function() {
		return this.comment;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.htmlParser.ElementNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML element node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */
Autolinker.htmlParser.ElementNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {

	/**
	 * @cfg {String} tagName (required)
	 *
	 * The name of the tag that was matched.
	 */
	tagName : '',

	/**
	 * @cfg {Boolean} closing (required)
	 *
	 * `true` if the element (tag) is a closing tag, `false` if its an opening
	 * tag.
	 */
	closing : false,


	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'element';
	},


	/**
	 * Returns the HTML element's (tag's) name. Ex: for an &lt;img&gt; tag,
	 * returns "img".
	 *
	 * @return {String}
	 */
	getTagName : function() {
		return this.tagName;
	},


	/**
	 * Determines if the HTML element (tag) is a closing tag. Ex: &lt;div&gt;
	 * returns `false`, while &lt;/div&gt; returns `true`.
	 *
	 * @return {Boolean}
	 */
	isClosing : function() {
		return this.closing;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.htmlParser.EntityNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents a known HTML entity node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 * Ex: '&amp;nbsp;', or '&amp#160;' (which will be retrievable from the {@link #getText}
 * method.
 *
 * Note that this class will only be returned from the HtmlParser for the set of
 * checked HTML entity nodes  defined by the {@link Autolinker.htmlParser.HtmlParser#htmlCharacterEntitiesRegex}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */
Autolinker.htmlParser.EntityNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {

	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'entity';
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.htmlParser.TextNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents a text node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */
Autolinker.htmlParser.TextNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {

	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'text';
	}

} );
/*global Autolinker */
/**
 * @abstract
 * @class Autolinker.match.Match
 *
 * Represents a match found in an input string which should be Autolinked. A Match object is what is provided in a
 * {@link Autolinker#replaceFn replaceFn}, and may be used to query for details about the match.
 *
 * For example:
 *
 *     var input = "...";  // string with URLs, Email Addresses, and Mentions (Twitter, Instagram)
 *
 *     var linkedText = Autolinker.link( input, {
 *         replaceFn : function( match ) {
 *             console.log( "href = ", match.getAnchorHref() );
 *             console.log( "text = ", match.getAnchorText() );
 *
 *             switch( match.getType() ) {
 *                 case 'url' :
 *                     console.log( "url: ", match.getUrl() );
 *
 *                 case 'email' :
 *                     console.log( "email: ", match.getEmail() );
 *
 *                 case 'mention' :
 *                     console.log( "mention: ", match.getMention() );
 *             }
 *         }
 *     } );
 *
 * See the {@link Autolinker} class for more details on using the {@link Autolinker#replaceFn replaceFn}.
 */
Autolinker.match.Match = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	 *
	 * Reference to the AnchorTagBuilder instance to use to generate an anchor
	 * tag for the Match.
	 */

	/**
	 * @cfg {String} matchedText (required)
	 *
	 * The original text that was matched by the {@link Autolinker.matcher.Matcher}.
	 */

	/**
	 * @cfg {Number} offset (required)
	 *
	 * The offset of where the match was made in the input string.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		if( cfg.tagBuilder == null ) throw new Error( '`tagBuilder` cfg required' );
		if( cfg.matchedText == null ) throw new Error( '`matchedText` cfg required' );
		if( cfg.offset == null ) throw new Error( '`offset` cfg required' );

		this.tagBuilder = cfg.tagBuilder;
		this.matchedText = cfg.matchedText;
		this.offset = cfg.offset;
	},


	/**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @abstract
	 * @return {String}
	 */
	getType : Autolinker.Util.abstractMethod,


	/**
	 * Returns the original text that was matched.
	 *
	 * @return {String}
	 */
	getMatchedText : function() {
		return this.matchedText;
	},


	/**
	 * Sets the {@link #offset} of where the match was made in the input string.
	 *
	 * A {@link Autolinker.matcher.Matcher} will be fed only HTML text nodes,
	 * and will therefore set an original offset that is relative to the HTML
	 * text node itself. However, we want this offset to be relative to the full
	 * HTML input string, and thus if using {@link Autolinker#parse} (rather
	 * than calling a {@link Autolinker.matcher.Matcher} directly), then this
	 * offset is corrected after the Matcher itself has done its job.
	 *
	 * @param {Number} offset
	 */
	setOffset : function( offset ) {
		this.offset = offset;
	},


	/**
	 * Returns the offset of where the match was made in the input string. This
	 * is the 0-based index of the match.
	 *
	 * @return {Number}
	 */
	getOffset : function() {
		return this.offset;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @abstract
	 * @return {String}
	 */
	getAnchorHref : Autolinker.Util.abstractMethod,


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @abstract
	 * @return {String}
	 */
	getAnchorText : Autolinker.Util.abstractMethod,


	/**
	 * Returns the CSS class suffix(es) for this match.
	 *
	 * A CSS class suffix is appended to the {@link Autolinker#className} in
	 * the {@link Autolinker.AnchorTagBuilder} when a match is translated into
	 * an anchor tag.
	 *
	 * For example, if {@link Autolinker#className} was configured as 'myLink',
	 * and this method returns `[ 'url' ]`, the final class name of the element
	 * will become: 'myLink myLink-url'.
	 *
	 * The match may provide multiple CSS class suffixes to be appended to the
	 * {@link Autolinker#className} in order to facilitate better styling
	 * options for different match criteria. See {@link Autolinker.match.Mention}
	 * for an example.
	 *
	 * By default, this method returns a single array with the match's
	 * {@link #getType type} name, but may be overridden by subclasses.
	 *
	 * @return {String[]}
	 */
	getCssClassSuffixes : function() {
		return [ this.getType() ];
	},


	/**
	 * Builds and returns an {@link Autolinker.HtmlTag} instance based on the
	 * Match.
	 *
	 * This can be used to easily generate anchor tags from matches, and either
	 * return their HTML string, or modify them before doing so.
	 *
	 * Example Usage:
	 *
	 *     var tag = match.buildTag();
	 *     tag.addClass( 'cordova-link' );
	 *     tag.setAttr( 'target', '_system' );
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="cordova-link" target="_system">Google</a>
	 */
	buildTag : function() {
		return this.tagBuilder.build( this );
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.match.Email
 * @extends Autolinker.match.Match
 *
 * Represents a Email match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */
Autolinker.match.Email = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @cfg {String} email (required)
	 *
	 * The email address that was matched.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		if( !cfg.email ) throw new Error( '`email` cfg required' );

		this.email = cfg.email;
	},


	/**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'email';
	},


	/**
	 * Returns the email address that was matched.
	 *
	 * @return {String}
	 */
	getEmail : function() {
		return this.email;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		return 'mailto:' + this.email;
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		return this.email;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.match.Hashtag
 * @extends Autolinker.match.Match
 *
 * Represents a Hashtag match found in an input string which should be
 * Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more
 * details.
 */
Autolinker.match.Hashtag = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @cfg {String} serviceName
	 *
	 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
	 * for available values.
	 */

	/**
	 * @cfg {String} hashtag (required)
	 *
	 * The Hashtag that was matched, without the '#'.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		// TODO: if( !serviceName ) throw new Error( '`serviceName` cfg required' );
		if( !cfg.hashtag ) throw new Error( '`hashtag` cfg required' );

		this.serviceName = cfg.serviceName;
		this.hashtag = cfg.hashtag;
	},


	/**
	 * Returns the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'hashtag';
	},


	/**
	 * Returns the configured {@link #serviceName} to point the Hashtag to.
	 * Ex: 'facebook', 'twitter'.
	 *
	 * @return {String}
	 */
	getServiceName : function() {
		return this.serviceName;
	},


	/**
	 * Returns the matched hashtag, without the '#' character.
	 *
	 * @return {String}
	 */
	getHashtag : function() {
		return this.hashtag;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		var serviceName = this.serviceName,
		    hashtag = this.hashtag;

		switch( serviceName ) {
			case 'twitter' :
				return 'https://twitter.com/hashtag/' + hashtag;
			case 'facebook' :
				return 'https://www.facebook.com/hashtag/' + hashtag;
			case 'instagram' :
				return 'https://instagram.com/explore/tags/' + hashtag;

			default :  // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
				throw new Error( 'Unknown service name to point hashtag to: ', serviceName );
		}
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		return '#' + this.hashtag;
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.match.Phone
 * @extends Autolinker.match.Match
 *
 * Represents a Phone number match found in an input string which should be
 * Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more
 * details.
 */
Autolinker.match.Phone = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @protected
	 * @property {String} number (required)
	 *
	 * The phone number that was matched, without any delimiter characters.
	 *
	 * Note: This is a string to allow for prefixed 0's.
	 */

	/**
	 * @protected
	 * @property  {Boolean} plusSign (required)
	 *
	 * `true` if the matched phone number started with a '+' sign. We'll include
	 * it in the `tel:` URL if so, as this is needed for international numbers.
	 *
	 * Ex: '+1 (123) 456 7879'
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		if( !cfg.number ) throw new Error( '`number` cfg required' );
		if( cfg.plusSign == null ) throw new Error( '`plusSign` cfg required' );

		this.number = cfg.number;
		this.plusSign = cfg.plusSign;
	},


	/**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'phone';
	},


	/**
	 * Returns the phone number that was matched as a string, without any
	 * delimiter characters.
	 *
	 * Note: This is a string to allow for prefixed 0's.
	 *
	 * @return {String}
	 */
	getNumber: function() {
		return this.number;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		return 'tel:' + ( this.plusSign ? '+' : '' ) + this.number;
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		return this.matchedText;
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.match.Mention
 * @extends Autolinker.match.Match
 *
 * Represents a Mention match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */
Autolinker.match.Mention = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @cfg {String} serviceName
	 *
	 * The service to point mention matches to. See {@link Autolinker#mention}
	 * for available values.
	 */

	/**
	 * @cfg {String} mention (required)
	 *
	 * The Mention that was matched, without the '@' character.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		if( !cfg.serviceName ) throw new Error( '`serviceName` cfg required' );
		if( !cfg.mention ) throw new Error( '`mention` cfg required' );

		this.mention = cfg.mention;
		this.serviceName = cfg.serviceName;
	},


	/**
	 * Returns the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'mention';
	},


	/**
	 * Returns the mention, without the '@' character.
	 *
	 * @return {String}
	 */
	getMention : function() {
		return this.mention;
	},


	/**
	 * Returns the configured {@link #serviceName} to point the mention to.
	 * Ex: 'instagram', 'twitter'.
	 *
	 * @return {String}
	 */
	getServiceName : function() {
		return this.serviceName;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		switch( this.serviceName ) {
			case 'twitter' :
				return 'https://twitter.com/' + this.mention;
			case 'instagram' :
				return 'https://instagram.com/' + this.mention;

			default :  // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
				throw new Error( 'Unknown service name to point mention to: ', this.serviceName );
		}
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		return '@' + this.mention;
	},


	/**
	 * Returns the CSS class suffixes that should be used on a tag built with
	 * the match. See {@link Autolinker.match.Match#getCssClassSuffixes} for
	 * details.
	 *
	 * @return {String[]}
	 */
	getCssClassSuffixes : function() {
		var cssClassSuffixes = Autolinker.match.Match.prototype.getCssClassSuffixes.call( this ),
		    serviceName = this.getServiceName();

		if( serviceName ) {
			cssClassSuffixes.push( serviceName );
		}
		return cssClassSuffixes;
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.match.Url
 * @extends Autolinker.match.Match
 *
 * Represents a Url match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */
Autolinker.match.Url = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @cfg {String} url (required)
	 *
	 * The url that was matched.
	 */

	/**
	 * @cfg {"scheme"/"www"/"tld"} urlMatchType (required)
	 *
	 * The type of URL match that this class represents. This helps to determine
	 * if the match was made in the original text with a prefixed scheme (ex:
	 * 'http://www.google.com'), a prefixed 'www' (ex: 'www.google.com'), or
	 * was matched by a known top-level domain (ex: 'google.com').
	 */

	/**
	 * @cfg {Boolean} protocolUrlMatch (required)
	 *
	 * `true` if the URL is a match which already has a protocol (i.e.
	 * 'http://'), `false` if the match was from a 'www' or known TLD match.
	 */

	/**
	 * @cfg {Boolean} protocolRelativeMatch (required)
	 *
	 * `true` if the URL is a protocol-relative match. A protocol-relative match
	 * is a URL that starts with '//', and will be either http:// or https://
	 * based on the protocol that the site is loaded under.
	 */

	/**
	 * @cfg {Object} stripPrefix (required)
	 *
	 * The Object form of {@link Autolinker#cfg-stripPrefix}.
	 */

	/**
	 * @cfg {Boolean} stripTrailingSlash (required)
	 * @inheritdoc Autolinker#cfg-stripTrailingSlash
	 */

	/**
	 * @cfg {Boolean} decodePercentEncoding (required)
	 * @inheritdoc Autolinker#cfg-decodePercentEncoding
	 */

	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		if( cfg.urlMatchType !== 'scheme' && cfg.urlMatchType !== 'www' && cfg.urlMatchType !== 'tld' ) throw new Error( '`urlMatchType` cfg must be one of: "scheme", "www", or "tld"' );
		if( !cfg.url ) throw new Error( '`url` cfg required' );
		if( cfg.protocolUrlMatch == null ) throw new Error( '`protocolUrlMatch` cfg required' );
		if( cfg.protocolRelativeMatch == null ) throw new Error( '`protocolRelativeMatch` cfg required' );
		if( cfg.stripPrefix == null ) throw new Error( '`stripPrefix` cfg required' );
		if( cfg.stripTrailingSlash == null ) throw new Error( '`stripTrailingSlash` cfg required' );
		if( cfg.decodePercentEncoding == null ) throw new Error( '`decodePercentEncoding` cfg required' );

		this.urlMatchType = cfg.urlMatchType;
		this.url = cfg.url;
		this.protocolUrlMatch = cfg.protocolUrlMatch;
		this.protocolRelativeMatch = cfg.protocolRelativeMatch;
		this.stripPrefix = cfg.stripPrefix;
		this.stripTrailingSlash = cfg.stripTrailingSlash;
		this.decodePercentEncoding = cfg.decodePercentEncoding;
	},


	/**
	 * @private
	 * @property {RegExp} schemePrefixRegex
	 *
	 * A regular expression used to remove the 'http://' or 'https://' from
	 * URLs.
	 */
	schemePrefixRegex: /^(https?:\/\/)?/i,

	/**
	 * @private
	 * @property {RegExp} wwwPrefixRegex
	 *
	 * A regular expression used to remove the 'www.' from URLs.
	 */
	wwwPrefixRegex: /^(https?:\/\/)?(www\.)?/i,

	/**
	 * @private
	 * @property {RegExp} protocolRelativeRegex
	 *
	 * The regular expression used to remove the protocol-relative '//' from the {@link #url} string, for purposes
	 * of {@link #getAnchorText}. A protocol-relative URL is, for example, "//yahoo.com"
	 */
	protocolRelativeRegex : /^\/\//,

	/**
	 * @private
	 * @property {Boolean} protocolPrepended
	 *
	 * Will be set to `true` if the 'http://' protocol has been prepended to the {@link #url} (because the
	 * {@link #url} did not have a protocol)
	 */
	protocolPrepended : false,


	/**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'url';
	},


	/**
	 * Returns a string name for the type of URL match that this class
	 * represents.
	 *
	 * This helps to determine if the match was made in the original text with a
	 * prefixed scheme (ex: 'http://www.google.com'), a prefixed 'www' (ex:
	 * 'www.google.com'), or was matched by a known top-level domain (ex:
	 * 'google.com').
	 *
	 * @return {"scheme"/"www"/"tld"}
	 */
	getUrlMatchType : function() {
		return this.urlMatchType;
	},


	/**
	 * Returns the url that was matched, assuming the protocol to be 'http://' if the original
	 * match was missing a protocol.
	 *
	 * @return {String}
	 */
	getUrl : function() {
		var url = this.url;

		// if the url string doesn't begin with a protocol, assume 'http://'
		if( !this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended ) {
			url = this.url = 'http://' + url;

			this.protocolPrepended = true;
		}

		return url;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		var url = this.getUrl();

		return url.replace( /&amp;/g, '&' );  // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		var anchorText = this.getMatchedText();

		if( this.protocolRelativeMatch ) {
			// Strip off any protocol-relative '//' from the anchor text
			anchorText = this.stripProtocolRelativePrefix( anchorText );
		}
		if( this.stripPrefix.scheme ) {
			anchorText = this.stripSchemePrefix( anchorText );
		}
		if( this.stripPrefix.www ) {
			anchorText = this.stripWwwPrefix( anchorText );
		}
		if( this.stripTrailingSlash ) {
			anchorText = this.removeTrailingSlash( anchorText );  // remove trailing slash, if there is one
		}
		if( this.decodePercentEncoding ) {
			anchorText = this.removePercentEncoding( anchorText);
		}

		return anchorText;
	},


	// ---------------------------------------

	// Utility Functionality

	/**
	 * Strips the scheme prefix (such as "http://" or "https://") from the given
	 * `url`.
	 *
	 * @private
	 * @param {String} url The text of the anchor that is being generated, for
	 *   which to strip off the url scheme.
	 * @return {String} The `url`, with the scheme stripped.
	 */
	stripSchemePrefix : function( url ) {
		return url.replace( this.schemePrefixRegex, '' );
	},


	/**
	 * Strips the 'www' prefix from the given `url`.
	 *
	 * @private
	 * @param {String} url The text of the anchor that is being generated, for
	 *   which to strip off the 'www' if it exists.
	 * @return {String} The `url`, with the 'www' stripped.
	 */
	stripWwwPrefix : function( url ) {
		return url.replace( this.wwwPrefixRegex, '$1' );  // leave any scheme ($1), it one exists
	},


	/**
	 * Strips any protocol-relative '//' from the anchor text.
	 *
	 * @private
	 * @param {String} text The text of the anchor that is being generated, for which to strip off the
	 *   protocol-relative prefix (such as stripping off "//")
	 * @return {String} The `anchorText`, with the protocol-relative prefix stripped.
	 */
	stripProtocolRelativePrefix : function( text ) {
		return text.replace( this.protocolRelativeRegex, '' );
	},


	/**
	 * Removes any trailing slash from the given `anchorText`, in preparation for the text to be displayed.
	 *
	 * @private
	 * @param {String} anchorText The text of the anchor that is being generated, for which to remove any trailing
	 *   slash ('/') that may exist.
	 * @return {String} The `anchorText`, with the trailing slash removed.
	 */
	removeTrailingSlash : function( anchorText ) {
		if( anchorText.charAt( anchorText.length - 1 ) === '/' ) {
			anchorText = anchorText.slice( 0, -1 );
		}
		return anchorText;
	},

	/**
	 * Decodes percent-encoded characters from the given `anchorText`, in preparation for the text to be displayed.
	 *
	 * @private
	 * @param {String} anchorText The text of the anchor that is being generated, for which to decode any percent-encoded characters.
	 * @return {String} The `anchorText`, with the percent-encoded characters decoded.
	 */
	removePercentEncoding : function( anchorText ) {
		try {
			return decodeURIComponent( anchorText
				.replace( /%22/gi, '&quot;' )
				.replace( /%26/gi, '&amp;' )
				.replace( /%27/gi, '&#39;')
				.replace( /%3C/gi, '&lt;' )
				.replace( /%3E/gi, '&gt;' )
			 );
		} catch (e) {
			// Invalid escape sequence.
			return anchorText;
		}
	}

} );
// NOTE: THIS IS A GENERATED FILE
// To update with the latest TLD list, run `gulp update-tld-list`

/*global Autolinker */
Autolinker.tldRegex = /(?:xn--vermgensberatung-pwb|xn--vermgensberater-ctb|xn--clchc0ea0b2g2a9gcd|xn--w4r85el8fhu5dnra|northwesternmutual|travelersinsurance|vermögensberatung|xn--3oq18vl8pn36a|xn--5su34j936bgsg|xn--bck1b9a5dre4c|xn--mgbai9azgqp6j|xn--mgberp4a5d4ar|xn--xkc2dl3a5ee0h|vermögensberater|xn--fzys8d69uvgm|xn--mgba7c0bbn0a|xn--xkc2al3hye2a|americanexpress|kerryproperties|sandvikcoromant|xn--i1b6b1a6a2e|xn--kcrx77d1x4a|xn--lgbbat1ad8j|xn--mgba3a4f16a|xn--mgbc0a9azcg|xn--nqv7fs00ema|afamilycompany|americanfamily|bananarepublic|cancerresearch|cookingchannel|kerrylogistics|weatherchannel|xn--54b7fta0cc|xn--6qq986b3xl|xn--80aqecdr1a|xn--b4w605ferd|xn--fiq228c5hs|xn--jlq61u9w7b|xn--mgba3a3ejt|xn--mgbaam7a8h|xn--mgbayh7gpa|xn--mgbb9fbpob|xn--mgbbh1a71e|xn--mgbca7dzdo|xn--mgbi4ecexp|xn--mgbx4cd0ab|international|lifeinsurance|orientexpress|spreadbetting|travelchannel|wolterskluwer|xn--eckvdtc9d|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--tiq49xqyj|xn--yfro4i67o|xn--ygbi2ammx|construction|lplfinancial|pamperedchef|scholarships|versicherung|xn--3e0b707e|xn--80adxhks|xn--80asehdb|xn--8y0a063a|xn--gckr3f0f|xn--mgb9awbf|xn--mgbab2bd|xn--mgbpl2fh|xn--mgbt3dhd|xn--mk1bu44c|xn--ngbc5azd|xn--ngbe9e0a|xn--ogbpf8fl|xn--qcka1pmc|accountants|barclaycard|blackfriday|blockbuster|bridgestone|calvinklein|contractors|creditunion|engineering|enterprises|foodnetwork|investments|kerryhotels|lamborghini|motorcycles|olayangroup|photography|playstation|productions|progressive|redumbrella|rightathome|williamhill|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--3bst00m|xn--3ds443g|xn--42c2d9a|xn--45brj9c|xn--55qw42g|xn--6frz82g|xn--80ao21a|xn--9krt00a|xn--cck2b3b|xn--czr694b|xn--d1acj3b|xn--efvy88h|xn--estv75g|xn--fct429k|xn--fjq720a|xn--flw351e|xn--g2xx48c|xn--gecrj9c|xn--gk3at1e|xn--h2brj9c|xn--hxt814e|xn--imr513n|xn--j6w193g|xn--jvr189m|xn--kprw13d|xn--kpry57d|xn--kpu716f|xn--mgbtx2b|xn--mix891f|xn--nyqy26a|xn--pbt977c|xn--pgbs0dh|xn--q9jyb4c|xn--rhqv96g|xn--rovu88b|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--vuq861b|xn--w4rs40l|xn--xhq521b|xn--zfr164b|சிங்கப்பூர்|accountant|apartments|associates|basketball|bnpparibas|boehringer|capitalone|consulting|creditcard|cuisinella|eurovision|extraspace|foundation|healthcare|immobilien|industries|management|mitsubishi|nationwide|newholland|nextdirect|onyourside|properties|protection|prudential|realestate|republican|restaurant|schaeffler|swiftcover|tatamotors|technology|telefonica|university|vistaprint|vlaanderen|volkswagen|xn--30rr7y|xn--3pxu8k|xn--45q11c|xn--4gbrim|xn--55qx5d|xn--5tzm5g|xn--80aswg|xn--90a3ac|xn--9dbq2a|xn--9et52u|xn--c2br7g|xn--cg4bki|xn--czrs0t|xn--czru2d|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--io0a7i|xn--kput3i|xn--mxtq1m|xn--o3cw4h|xn--pssy2u|xn--unup4y|xn--wgbh1c|xn--wgbl6a|xn--y9a3aq|accenture|alfaromeo|allfinanz|amsterdam|analytics|aquarelle|barcelona|bloomberg|christmas|community|directory|education|equipment|fairwinds|financial|firestone|fresenius|frontdoor|fujixerox|furniture|goldpoint|goodhands|hisamitsu|homedepot|homegoods|homesense|honeywell|institute|insurance|kuokgroup|ladbrokes|lancaster|landrover|lifestyle|marketing|marshalls|mcdonalds|melbourne|microsoft|montblanc|panasonic|passagens|pramerica|richardli|scjohnson|shangrila|solutions|statebank|statefarm|stockholm|travelers|vacations|xn--90ais|xn--c1avg|xn--d1alf|xn--e1a4c|xn--fhbei|xn--j1aef|xn--j1amh|xn--l1acc|xn--nqv7f|xn--p1acf|xn--tckwe|xn--vhquv|yodobashi|abudhabi|airforce|allstate|attorney|barclays|barefoot|bargains|baseball|boutique|bradesco|broadway|brussels|budapest|builders|business|capetown|catering|catholic|chrysler|cipriani|cityeats|cleaning|clinique|clothing|commbank|computer|delivery|deloitte|democrat|diamonds|discount|discover|download|engineer|ericsson|esurance|everbank|exchange|feedback|fidelity|firmdale|football|frontier|goodyear|grainger|graphics|guardian|hdfcbank|helsinki|holdings|hospital|infiniti|ipiranga|istanbul|jpmorgan|lighting|lundbeck|marriott|maserati|mckinsey|memorial|mortgage|movistar|observer|partners|pharmacy|pictures|plumbing|property|redstone|reliance|saarland|samsclub|security|services|shopping|showtime|softbank|software|stcgroup|supplies|symantec|telecity|training|uconnect|vanguard|ventures|verisign|woodside|xn--90ae|xn--node|xn--p1ai|xn--qxam|yokohama|السعودية|abogado|academy|agakhan|alibaba|android|athleta|auction|audible|auspost|avianca|banamex|bauhaus|bentley|bestbuy|booking|brother|bugatti|capital|caravan|careers|cartier|channel|chintai|citadel|clubmed|college|cologne|comcast|company|compare|contact|cooking|corsica|country|coupons|courses|cricket|cruises|dentist|digital|domains|exposed|express|farmers|fashion|ferrari|ferrero|finance|fishing|fitness|flights|florist|flowers|forsale|frogans|fujitsu|gallery|genting|godaddy|guitars|hamburg|hangout|hitachi|holiday|hosting|hoteles|hotmail|hyundai|iselect|ismaili|jewelry|juniper|kitchen|komatsu|lacaixa|lancome|lanxess|lasalle|latrobe|leclerc|liaison|limited|lincoln|markets|metlife|monster|netbank|netflix|network|neustar|okinawa|oldnavy|organic|origins|panerai|philips|pioneer|politie|realtor|recipes|rentals|reviews|rexroth|samsung|sandvik|schmidt|schwarz|science|shiksha|shriram|singles|spiegel|staples|starhub|statoil|storage|support|surgery|systems|temasek|theater|theatre|tickets|tiffany|toshiba|trading|walmart|wanggou|watches|weather|website|wedding|whoswho|windows|winners|xfinity|yamaxun|youtube|zuerich|католик|الجزائر|العليان|پاکستان|كاثوليك|موبايلي|இந்தியா|abarth|abbott|abbvie|active|africa|agency|airbus|airtel|alipay|alsace|alstom|anquan|aramco|author|bayern|beauty|berlin|bharti|blanco|bostik|boston|broker|camera|career|caseih|casino|center|chanel|chrome|church|circle|claims|clinic|coffee|comsec|condos|coupon|credit|cruise|dating|datsun|dealer|degree|dental|design|direct|doctor|dunlop|dupont|durban|emerck|energy|estate|events|expert|family|flickr|futbol|gallup|garden|george|giving|global|google|gratis|health|hermes|hiphop|hockey|hughes|imamat|insure|intuit|jaguar|joburg|juegos|kaufen|kinder|kindle|kosher|lancia|latino|lawyer|lefrak|living|locker|london|luxury|madrid|maison|makeup|market|mattel|mobile|mobily|monash|mormon|moscow|museum|mutual|nagoya|natura|nissan|nissay|norton|nowruz|office|olayan|online|oracle|orange|otsuka|pfizer|photos|physio|piaget|pictet|quebec|racing|realty|reisen|repair|report|review|rocher|rogers|ryukyu|safety|sakura|sanofi|school|schule|secure|select|shouji|soccer|social|stream|studio|supply|suzuki|swatch|sydney|taipei|taobao|target|tattoo|tennis|tienda|tjmaxx|tkmaxx|toyota|travel|unicom|viajes|viking|villas|virgin|vision|voting|voyage|vuelos|walter|warman|webcam|xihuan|xperia|yachts|yandex|zappos|москва|онлайн|ابوظبي|ارامكو|الاردن|المغرب|امارات|فلسطين|مليسيا|இலங்கை|ファッション|actor|adult|aetna|amfam|amica|apple|archi|audio|autos|azure|baidu|beats|bible|bingo|black|boats|boots|bosch|build|canon|cards|chase|cheap|chloe|cisco|citic|click|cloud|coach|codes|crown|cymru|dabur|dance|deals|delta|dodge|drive|dubai|earth|edeka|email|epost|epson|faith|fedex|final|forex|forum|gallo|games|gifts|gives|glade|glass|globo|gmail|green|gripe|group|gucci|guide|homes|honda|horse|house|hyatt|ikano|intel|irish|iveco|jetzt|koeln|kyoto|lamer|lease|legal|lexus|lilly|linde|lipsy|lixil|loans|locus|lotte|lotto|lupin|macys|mango|media|miami|money|mopar|movie|nadex|nexus|nikon|ninja|nokia|nowtv|omega|osaka|paris|parts|party|phone|photo|pizza|place|poker|praxi|press|prime|promo|quest|radio|rehab|reise|ricoh|rocks|rodeo|salon|sener|seven|sharp|shell|shoes|skype|sling|smart|smile|solar|space|stada|store|study|style|sucks|swiss|tatar|tires|tirol|tmall|today|tokyo|tools|toray|total|tours|trade|trust|tunes|tushu|ubank|vegas|video|vista|vodka|volvo|wales|watch|weber|weibo|works|world|xerox|yahoo|zippo|ایران|بازار|بھارت|سودان|سورية|همراه|संगठन|বাংলা|భారత్|嘉里大酒店|aarp|able|adac|aero|aigo|akdn|ally|amex|army|arpa|arte|asda|asia|audi|auto|baby|band|bank|bbva|beer|best|bike|bing|blog|blue|bofa|bond|book|buzz|cafe|call|camp|care|cars|casa|case|cash|cbre|cern|chat|citi|city|club|cool|coop|cyou|data|date|dclk|deal|dell|desi|diet|dish|docs|doha|duck|duns|dvag|erni|fage|fail|fans|farm|fast|fiat|fido|film|fire|fish|flir|food|ford|free|fund|game|gbiz|gent|ggee|gift|gmbh|gold|golf|goog|guge|guru|hair|haus|hdfc|help|here|hgtv|host|hsbc|icbc|ieee|imdb|immo|info|itau|java|jeep|jobs|jprs|kddi|kiwi|kpmg|kred|land|lego|lgbt|lidl|life|like|limo|link|live|loan|loft|love|ltda|luxe|maif|meet|meme|menu|mini|mint|mobi|moda|moto|mtpc|name|navy|news|next|nico|nike|ollo|open|page|pars|pccw|pics|ping|pink|play|plus|pohl|porn|post|prod|prof|qpon|raid|read|reit|rent|rest|rich|rmit|room|rsvp|ruhr|safe|sale|sapo|sarl|save|saxo|scor|scot|seat|seek|sexy|shaw|shia|shop|show|silk|sina|site|skin|sncf|sohu|song|sony|spot|star|surf|talk|taxi|team|tech|teva|tiaa|tips|town|toys|tube|vana|visa|viva|vivo|vote|voto|wang|weir|wien|wiki|wine|work|xbox|yoga|zara|zero|zone|дети|сайт|بيتك|تونس|شبكة|عراق|عمان|موقع|भारत|ভারত|ਭਾਰਤ|ભારત|ලංකා|グーグル|クラウド|ポイント|大众汽车|组织机构|電訊盈科|香格里拉|aaa|abb|abc|aco|ads|aeg|afl|aig|anz|aol|app|art|aws|axa|bar|bbc|bbt|bcg|bcn|bet|bid|bio|biz|bms|bmw|bnl|bom|boo|bot|box|buy|bzh|cab|cal|cam|car|cat|cba|cbn|cbs|ceb|ceo|cfa|cfd|com|crs|csc|dad|day|dds|dev|dhl|diy|dnp|dog|dot|dtv|dvr|eat|eco|edu|esq|eus|fan|fit|fly|foo|fox|frl|ftr|fun|fyi|gal|gap|gdn|gea|gle|gmo|gmx|goo|gop|got|gov|hbo|hiv|hkt|hot|how|htc|ibm|ice|icu|ifm|ing|ink|int|ist|itv|iwc|jcb|jcp|jio|jlc|jll|jmp|jnj|jot|joy|kfh|kia|kim|kpn|krd|lat|law|lds|lol|lpl|ltd|man|mba|mcd|med|men|meo|mil|mit|mlb|mls|mma|moe|moi|mom|mov|msd|mtn|mtr|nab|nba|nec|net|new|nfl|ngo|nhk|now|nra|nrw|ntt|nyc|obi|off|one|ong|onl|ooo|org|ott|ovh|pay|pet|pid|pin|pnc|pro|pru|pub|pwc|qvc|red|ren|ril|rio|rip|run|rwe|sap|sas|sbi|sbs|sca|scb|ses|sew|sex|sfr|ski|sky|soy|srl|srt|stc|tab|tax|tci|tdk|tel|thd|tjx|top|trv|tui|tvs|ubs|uno|uol|ups|vet|vig|vin|vip|wed|win|wme|wow|wtc|wtf|xin|xxx|xyz|you|yun|zip|бел|ком|қаз|мкд|мон|орг|рус|срб|укр|հայ|קום|قطر|كوم|مصر|कॉम|नेट|คอม|ไทย|ストア|セール|みんな|中文网|天主教|我爱你|新加坡|淡马锡|诺基亚|飞利浦|ac|ad|ae|af|ag|ai|al|am|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw|ελ|бг|ею|рф|გე|닷넷|닷컴|삼성|한국|コム|世界|中信|中国|中國|企业|佛山|信息|健康|八卦|公司|公益|台湾|台灣|商城|商店|商标|嘉里|在线|大拿|娱乐|家電|工行|广东|微博|慈善|手机|手表|政务|政府|新闻|时尚|書籍|机构|游戏|澳門|点看|珠宝|移动|网址|网店|网站|网络|联通|谷歌|购物|通販|集团|食品|餐厅|香港)/;

/*global Autolinker */
/**
 * @abstract
 * @class Autolinker.matcher.Matcher
 *
 * An abstract class and interface for individual matchers to find matches in
 * an input string with linkified versions of them.
 *
 * Note that Matchers do not take HTML into account - they must be fed the text
 * nodes of any HTML string, which is handled by {@link Autolinker#parse}.
 */
Autolinker.matcher.Matcher = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	 *
	 * Reference to the AnchorTagBuilder instance to use to generate HTML tags
	 * for {@link Autolinker.match.Match Matches}.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Matcher
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		if( !cfg.tagBuilder ) throw new Error( '`tagBuilder` cfg required' );

		this.tagBuilder = cfg.tagBuilder;
	},


	/**
	 * Parses the input `text` and returns the array of {@link Autolinker.match.Match Matches}
	 * for the matcher.
	 *
	 * @abstract
	 * @param {String} text The text to scan and replace matches in.
	 * @return {Autolinker.match.Match[]}
	 */
	parseMatches : Autolinker.Util.abstractMethod

} );
/*global Autolinker */
/**
 * @class Autolinker.matcher.Email
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find email matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
 */
Autolinker.matcher.Email = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * The regular expression to match email addresses. Example match:
	 *
	 *     person@place.com
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */
	matcherRegex : (function() {
		var alphaNumericChars = Autolinker.RegexLib.alphaNumericCharsStr,
			specialCharacters = '!#$%&\'*+\\-\\/=?^_`{|}~',
			restrictedSpecialCharacters = '\\s"(),:;<>@\\[\\]',
			validCharacters = alphaNumericChars + specialCharacters,
			validRestrictedCharacters = validCharacters + restrictedSpecialCharacters,
		    emailRegex = new RegExp( '(?:[' + validCharacters + '](?:[' + validCharacters + ']|\\.(?!\\.|@))*|\\"[' + validRestrictedCharacters + '.]+\\")@'),
			domainNameRegex = Autolinker.RegexLib.domainNameRegex,
			tldRegex = Autolinker.tldRegex;  // match our known top level domains (TLDs)

		return new RegExp( [
			emailRegex.source,
			domainNameRegex.source,
			'\\.', tldRegex.source   // '.com', '.net', etc
		].join( "" ), 'gi' );
	} )(),


	/**
	 * @inheritdoc
	 */
	parseMatches : function( text ) {
		var matcherRegex = this.matcherRegex,
		    tagBuilder = this.tagBuilder,
		    matches = [],
		    match;

		while( ( match = matcherRegex.exec( text ) ) !== null ) {
			var matchedText = match[ 0 ];

			matches.push( new Autolinker.match.Email( {
				tagBuilder  : tagBuilder,
				matchedText : matchedText,
				offset      : match.index,
				email       : matchedText
			} ) );
		}

		return matches;
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.matcher.Hashtag
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find Hashtag matches in an input string.
 */
Autolinker.matcher.Hashtag = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * @cfg {String} serviceName
	 *
	 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
	 * for available values.
	 */


	/**
	 * The regular expression to match Hashtags. Example match:
	 *
	 *     #asdf
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */
	matcherRegex : new RegExp( '#[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,139}', 'g' ),

	/**
	 * The regular expression to use to check the character before a username match to
	 * make sure we didn't accidentally match an email address.
	 *
	 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
	 *
	 * @private
	 * @property {RegExp} nonWordCharRegex
	 */
	nonWordCharRegex : new RegExp( '[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']' ),


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 *   specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.matcher.Matcher.prototype.constructor.call( this, cfg );

		this.serviceName = cfg.serviceName;
	},


	/**
	 * @inheritdoc
	 */
	parseMatches : function( text ) {
		var matcherRegex = this.matcherRegex,
		    nonWordCharRegex = this.nonWordCharRegex,
		    serviceName = this.serviceName,
		    tagBuilder = this.tagBuilder,
		    matches = [],
		    match;

		while( ( match = matcherRegex.exec( text ) ) !== null ) {
			var offset = match.index,
			    prevChar = text.charAt( offset - 1 );

			// If we found the match at the beginning of the string, or we found the match
			// and there is a whitespace char in front of it (meaning it is not a '#' char
			// in the middle of a word), then it is a hashtag match.
			if( offset === 0 || nonWordCharRegex.test( prevChar ) ) {
				var matchedText = match[ 0 ],
				    hashtag = match[ 0 ].slice( 1 );  // strip off the '#' character at the beginning

				matches.push( new Autolinker.match.Hashtag( {
					tagBuilder  : tagBuilder,
					matchedText : matchedText,
					offset      : offset,
					serviceName : serviceName,
					hashtag     : hashtag
				} ) );
			}
		}

		return matches;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.matcher.Phone
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find Phone number matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more
 * details.
 */
Autolinker.matcher.Phone = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * The regular expression to match Phone numbers. Example match:
	 *
	 *     (123) 456-7890
	 *
	 * This regular expression has the following capturing groups:
	 *
	 * 1. The prefixed '+' sign, if there is one.
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */
    matcherRegex : /(?:(\+)?\d{1,3}[-\040.]?)?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]?\d{4}([,;]*[0-9]+#?)*/g,    
    
    // ex: (123) 456-7890, 123 456 7890, 123-456-7890, +18004441234,,;,10226420346#, 
    // +1 (800) 444 1234, 10226420346#, 1-800-444-1234,1022,64,20346#

	/**
	 * @inheritdoc
	 */
	parseMatches: function(text) {
		var matcherRegex = this.matcherRegex,
			tagBuilder = this.tagBuilder,
			matches = [],
			match;

		while ((match = matcherRegex.exec(text)) !== null) {
			// Remove non-numeric values from phone number string
			var matchedText = match[0],
				cleanNumber = matchedText.replace(/[^0-9,;#]/g, ''), // strip out non-digit characters exclude comma semicolon and #
				plusSign = !!match[1]; // match[ 1 ] is the prefixed plus sign, if there is one
			if (this.testMatch(match[2]) && this.testMatch(matchedText)) {
    			matches.push(new Autolinker.match.Phone({
    				tagBuilder: tagBuilder,
    				matchedText: matchedText,
    				offset: match.index,
    				number: cleanNumber,
    				plusSign: plusSign
    			}));
            }
		}

		return matches;
	},

	testMatch: function(text) {
		return /\D/.test(text);
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.matcher.Mention
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find/replace username matches in an input string.
 */
Autolinker.matcher.Mention = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * Hash of regular expression to match username handles. Example match:
	 *
	 *     @asdf
	 *
	 * @private
	 * @property {Object} matcherRegexes
	 */
	matcherRegexes : {
		"twitter": new RegExp( '@[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,20}', 'g' ),
		"instagram": new RegExp( '@[_.' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,50}', 'g' )
	},

	/**
	 * The regular expression to use to check the character before a username match to
	 * make sure we didn't accidentally match an email address.
	 *
	 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
	 *
	 * @private
	 * @property {RegExp} nonWordCharRegex
	 */
	nonWordCharRegex : new RegExp( '[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']' ),


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 *   specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.matcher.Matcher.prototype.constructor.call( this, cfg );

		this.serviceName = cfg.serviceName;
	},


	/**
	 * @inheritdoc
	 */
	parseMatches : function( text ) {
		var matcherRegex = this.matcherRegexes[this.serviceName],
		    nonWordCharRegex = this.nonWordCharRegex,
		    serviceName = this.serviceName,
		    tagBuilder = this.tagBuilder,
		    matches = [],
		    match;

		if (!matcherRegex) {
			return matches;
		}

		while( ( match = matcherRegex.exec( text ) ) !== null ) {
			var offset = match.index,
			    prevChar = text.charAt( offset - 1 );

			// If we found the match at the beginning of the string, or we found the match
			// and there is a whitespace char in front of it (meaning it is not an email
			// address), then it is a username match.
			if( offset === 0 || nonWordCharRegex.test( prevChar ) ) {
				var matchedText = match[ 0 ].replace(/\.+$/g, ''), // strip off trailing .
				    mention = matchedText.slice( 1 );  // strip off the '@' character at the beginning

				matches.push( new Autolinker.match.Mention( {
					tagBuilder    : tagBuilder,
					matchedText   : matchedText,
					offset        : offset,
					serviceName   : serviceName,
					mention       : mention
				} ) );
			}
		}

		return matches;
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.matcher.Url
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find URL matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
 */
Autolinker.matcher.Url = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * @cfg {Object} stripPrefix (required)
	 *
	 * The Object form of {@link Autolinker#cfg-stripPrefix}.
	 */

	/**
	 * @cfg {Boolean} stripTrailingSlash (required)
	 * @inheritdoc Autolinker#stripTrailingSlash
	 */

	/**
	 * @cfg {Boolean} decodePercentEncoding (required)
	 * @inheritdoc Autolinker#decodePercentEncoding
	 */


	/**
	 * @private
	 * @property {RegExp} matcherRegex
	 *
	 * The regular expression to match URLs with an optional scheme, port
	 * number, path, query string, and hash anchor.
	 *
	 * Example matches:
	 *
	 *     http://google.com
	 *     www.google.com
	 *     google.com/path/to/file?q1=1&q2=2#myAnchor
	 *
	 *
	 * This regular expression will have the following capturing groups:
	 *
	 * 1.  Group that matches a scheme-prefixed URL (i.e. 'http://google.com').
	 *     This is used to match scheme URLs with just a single word, such as
	 *     'http://localhost', where we won't double check that the domain name
	 *     has at least one dot ('.') in it.
	 * 2.  Group that matches a 'www.' prefixed URL. This is only matched if the
	 *     'www.' text was not prefixed by a scheme (i.e.: not prefixed by
	 *     'http://', 'ftp:', etc.)
	 * 3.  A protocol-relative ('//') match for the case of a 'www.' prefixed
	 *     URL. Will be an empty string if it is not a protocol-relative match.
	 *     We need to know the character before the '//' in order to determine
	 *     if it is a valid match or the // was in a string we don't want to
	 *     auto-link.
	 * 4.  Group that matches a known TLD (top level domain), when a scheme
	 *     or 'www.'-prefixed domain is not matched.
	 * 5.  A protocol-relative ('//') match for the case of a known TLD prefixed
	 *     URL. Will be an empty string if it is not a protocol-relative match.
	 *     See #3 for more info.
	 */
	matcherRegex : (function() {
		var schemeRegex = /(?:[A-Za-z][-.+A-Za-z0-9]*:(?![A-Za-z][-.+A-Za-z0-9]*:\/\/)(?!\d+\/?)(?:\/\/)?)/,  // match protocol, allow in format "http://" or "mailto:". However, do not match the first part of something like 'link:http://www.google.com' (i.e. don't match "link:"). Also, make sure we don't interpret 'google.com:8000' as if 'google.com' was a protocol here (i.e. ignore a trailing port number in this regex)
		    wwwRegex = /(?:www\.)/,                  // starting with 'www.'
		    domainNameRegex = Autolinker.RegexLib.domainNameRegex,
		    tldRegex = Autolinker.tldRegex,  // match our known top level domains (TLDs)
		    alphaNumericCharsStr = Autolinker.RegexLib.alphaNumericCharsStr,

		    // Allow optional path, query string, and hash anchor, not ending in the following characters: "?!:,.;"
		    // http://blog.codinghorror.com/the-problem-with-urls/
		    urlSuffixRegex = new RegExp( '[/?#](?:[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]?!:,.;\u2713]*[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]\u2713])?' );

		return new RegExp( [
			'(?:', // parens to cover match for scheme (optional), and domain
				'(',  // *** Capturing group $1, for a scheme-prefixed url (ex: http://google.com)
					schemeRegex.source,
					domainNameRegex.source,
				')',

				'|',

				'(',  // *** Capturing group $2, for a 'www.' prefixed url (ex: www.google.com)
					'(//)?',  // *** Capturing group $3 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character (handled later)
					wwwRegex.source,
					domainNameRegex.source,
				')',

				'|',

				'(',  // *** Capturing group $4, for known a TLD url (ex: google.com)
					'(//)?',  // *** Capturing group $5 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character (handled later)
					domainNameRegex.source + '\\.',
					tldRegex.source,
					'(?![-' + alphaNumericCharsStr + '])', // TLD not followed by a letter, behaves like unicode-aware \b
				')',
			')',

			'(?::[0-9]+)?', // port

			'(?:' + urlSuffixRegex.source + ')?'  // match for path, query string, and/or hash anchor - optional
		].join( "" ), 'gi' );
	} )(),


	/**
	 * A regular expression to use to check the character before a protocol-relative
	 * URL match. We don't want to match a protocol-relative URL if it is part
	 * of another word.
	 *
	 * For example, we want to match something like "Go to: //google.com",
	 * but we don't want to match something like "abc//google.com"
	 *
	 * This regular expression is used to test the character before the '//'.
	 *
	 * @private
	 * @type {RegExp} wordCharRegExp
	 */
	wordCharRegExp : new RegExp( '[' + Autolinker.RegexLib.alphaNumericCharsStr + ']' ),


	/**
	 * The regular expression to match opening parenthesis in a URL match.
	 *
	 * This is to determine if we have unbalanced parenthesis in the URL, and to
	 * drop the final parenthesis that was matched if so.
	 *
	 * Ex: The text "(check out: wikipedia.com/something_(disambiguation))"
	 * should only autolink the inner "wikipedia.com/something_(disambiguation)"
	 * part, so if we find that we have unbalanced parenthesis, we will drop the
	 * last one for the match.
	 *
	 * @private
	 * @property {RegExp}
	 */
	openParensRe : /\(/g,

	/**
	 * The regular expression to match closing parenthesis in a URL match. See
	 * {@link #openParensRe} for more information.
	 *
	 * @private
	 * @property {RegExp}
	 */
	closeParensRe : /\)/g,


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 *   specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.matcher.Matcher.prototype.constructor.call( this, cfg );

		if( cfg.stripPrefix == null ) throw new Error( '`stripPrefix` cfg required' );
		if( cfg.stripTrailingSlash == null ) throw new Error( '`stripTrailingSlash` cfg required' );

		this.stripPrefix = cfg.stripPrefix;
		this.stripTrailingSlash = cfg.stripTrailingSlash;
		this.decodePercentEncoding = cfg.decodePercentEncoding;
	},


	/**
	 * @inheritdoc
	 */
	parseMatches : function( text ) {
		var matcherRegex = this.matcherRegex,
		    stripPrefix = this.stripPrefix,
		    stripTrailingSlash = this.stripTrailingSlash,
		    decodePercentEncoding = this.decodePercentEncoding,
		    tagBuilder = this.tagBuilder,
		    matches = [],
		    match;

		while( ( match = matcherRegex.exec( text ) ) !== null ) {
			var matchStr = match[ 0 ],
			    schemeUrlMatch = match[ 1 ],
			    wwwUrlMatch = match[ 2 ],
			    wwwProtocolRelativeMatch = match[ 3 ],
			    //tldUrlMatch = match[ 4 ],  -- not needed at the moment
			    tldProtocolRelativeMatch = match[ 5 ],
			    offset = match.index,
			    protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch,
				prevChar = text.charAt( offset - 1 );

			if( !Autolinker.matcher.UrlMatchValidator.isValid( matchStr, schemeUrlMatch ) ) {
				continue;
			}

			// If the match is preceded by an '@' character, then it is either
			// an email address or a username. Skip these types of matches.
			if( offset > 0 && prevChar === '@' ) {
				continue;
			}

			// If it's a protocol-relative '//' match, but the character before the '//'
			// was a word character (i.e. a letter/number), then we found the '//' in the
			// middle of another word (such as "asdf//asdf.com"). In this case, skip the
			// match.
			if( offset > 0 && protocolRelativeMatch && this.wordCharRegExp.test( prevChar ) ) {
				continue;
			}

			if( /\?$/.test(matchStr) ) {
				matchStr = matchStr.substr(0, matchStr.length-1);
			}

			// Handle a closing parenthesis at the end of the match, and exclude
			// it if there is not a matching open parenthesis in the match
			// itself.
			if( this.matchHasUnbalancedClosingParen( matchStr ) ) {
				matchStr = matchStr.substr( 0, matchStr.length - 1 );  // remove the trailing ")"
			} else {
				// Handle an invalid character after the TLD
				var pos = this.matchHasInvalidCharAfterTld( matchStr, schemeUrlMatch );
				if( pos > -1 ) {
					matchStr = matchStr.substr( 0, pos ); // remove the trailing invalid chars
				}
			}

			var urlMatchType = schemeUrlMatch ? 'scheme' : ( wwwUrlMatch ? 'www' : 'tld' ),
			    protocolUrlMatch = !!schemeUrlMatch;

			matches.push( new Autolinker.match.Url( {
				tagBuilder            : tagBuilder,
				matchedText           : matchStr,
				offset                : offset,
				urlMatchType          : urlMatchType,
				url                   : matchStr,
				protocolUrlMatch      : protocolUrlMatch,
				protocolRelativeMatch : !!protocolRelativeMatch,
				stripPrefix           : stripPrefix,
				stripTrailingSlash    : stripTrailingSlash,
				decodePercentEncoding : decodePercentEncoding,
			} ) );
		}

		return matches;
	},


	/**
	 * Determines if a match found has an unmatched closing parenthesis. If so,
	 * this parenthesis will be removed from the match itself, and appended
	 * after the generated anchor tag.
	 *
	 * A match may have an extra closing parenthesis at the end of the match
	 * because the regular expression must include parenthesis for URLs such as
	 * "wikipedia.com/something_(disambiguation)", which should be auto-linked.
	 *
	 * However, an extra parenthesis *will* be included when the URL itself is
	 * wrapped in parenthesis, such as in the case of "(wikipedia.com/something_(disambiguation))".
	 * In this case, the last closing parenthesis should *not* be part of the
	 * URL itself, and this method will return `true`.
	 *
	 * @private
	 * @param {String} matchStr The full match string from the {@link #matcherRegex}.
	 * @return {Boolean} `true` if there is an unbalanced closing parenthesis at
	 *   the end of the `matchStr`, `false` otherwise.
	 */
	matchHasUnbalancedClosingParen : function( matchStr ) {
		var lastChar = matchStr.charAt( matchStr.length - 1 );

		if( lastChar === ')' ) {
			var openParensMatch = matchStr.match( this.openParensRe ),
			    closeParensMatch = matchStr.match( this.closeParensRe ),
			    numOpenParens = ( openParensMatch && openParensMatch.length ) || 0,
			    numCloseParens = ( closeParensMatch && closeParensMatch.length ) || 0;

			if( numOpenParens < numCloseParens ) {
				return true;
			}
		}

		return false;
	},


	/**
	 * Determine if there's an invalid character after the TLD in a URL. Valid
	 * characters after TLD are ':/?#'. Exclude scheme matched URLs from this
	 * check.
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} schemeUrlMatch The match URL string for a scheme
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Number} the position where the invalid character was found. If
	 *   no such character was found, returns -1
	 */
	matchHasInvalidCharAfterTld : function( urlMatch, schemeUrlMatch ) {
		if( !urlMatch ) {
			return -1;
		}

		var offset = 0;
		if ( schemeUrlMatch ) {
			offset = urlMatch.indexOf(':');
			urlMatch = urlMatch.slice(offset);
		}

		var alphaNumeric = Autolinker.RegexLib.alphaNumericCharsStr;

		var re = new RegExp("^((.?\/\/)?[-." + alphaNumeric + "]*[-" + alphaNumeric + "]\\.[-" + alphaNumeric + "]+)");
		var res = re.exec( urlMatch );
		if ( res === null ) {
			return -1;
		}

		offset += res[1].length;
		urlMatch = urlMatch.slice(res[1].length);
		if (/^[^-.A-Za-z0-9:\/?#]/.test(urlMatch)) {
			return offset;
		}

		return -1;
	}

} );

/*global Autolinker */
/*jshint scripturl:true */
/**
 * @private
 * @class Autolinker.matcher.UrlMatchValidator
 * @singleton
 *
 * Used by Autolinker to filter out false URL positives from the
 * {@link Autolinker.matcher.Url UrlMatcher}.
 *
 * Due to the limitations of regular expressions (including the missing feature
 * of look-behinds in JS regular expressions), we cannot always determine the
 * validity of a given match. This class applies a bit of additional logic to
 * filter out any false positives that have been matched by the
 * {@link Autolinker.matcher.Url UrlMatcher}.
 */
Autolinker.matcher.UrlMatchValidator = {

	/**
	 * Regex to test for a full protocol, with the two trailing slashes. Ex: 'http://'
	 *
	 * @private
	 * @property {RegExp} hasFullProtocolRegex
	 */
	hasFullProtocolRegex : /^[A-Za-z][-.+A-Za-z0-9]*:\/\//,

	/**
	 * Regex to find the URI scheme, such as 'mailto:'.
	 *
	 * This is used to filter out 'javascript:' and 'vbscript:' schemes.
	 *
	 * @private
	 * @property {RegExp} uriSchemeRegex
	 */
	uriSchemeRegex : /^[A-Za-z][-.+A-Za-z0-9]*:/,

	/**
	 * Regex to determine if at least one word char exists after the protocol (i.e. after the ':')
	 *
	 * @private
	 * @property {RegExp} hasWordCharAfterProtocolRegex
	 */
	hasWordCharAfterProtocolRegex : new RegExp(":[^\\s]*?[" + Autolinker.RegexLib.alphaCharsStr + "]"),

	/**
	 * Regex to determine if the string is a valid IP address
	 *
	 * @private
	 * @property {RegExp} ipRegex
	 */
	ipRegex: /[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/,

	/**
	 * Determines if a given URL match found by the {@link Autolinker.matcher.Url UrlMatcher}
	 * is valid. Will return `false` for:
	 *
	 * 1) URL matches which do not have at least have one period ('.') in the
	 *    domain name (effectively skipping over matches like "abc:def").
	 *    However, URL matches with a protocol will be allowed (ex: 'http://localhost')
	 * 2) URL matches which do not have at least one word character in the
	 *    domain name (effectively skipping over matches like "git:1.0").
	 * 3) A protocol-relative url match (a URL beginning with '//') whose
	 *    previous character is a word character (effectively skipping over
	 *    strings like "abc//google.com")
	 *
	 * Otherwise, returns `true`.
	 *
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Boolean} `true` if the match given is valid and should be
	 *   processed, or `false` if the match is invalid and/or should just not be
	 *   processed.
	 */
	isValid : function( urlMatch, protocolUrlMatch ) {
		if(
			( protocolUrlMatch && !this.isValidUriScheme( protocolUrlMatch ) ) ||
			this.urlMatchDoesNotHaveProtocolOrDot( urlMatch, protocolUrlMatch ) ||    // At least one period ('.') must exist in the URL match for us to consider it an actual URL, *unless* it was a full protocol match (like 'http://localhost')
			(this.urlMatchDoesNotHaveAtLeastOneWordChar( urlMatch, protocolUrlMatch ) && // At least one letter character must exist in the domain name after a protocol match. Ex: skip over something like "git:1.0"
			   !this.isValidIpAddress( urlMatch )) || // Except if it's an IP address
			this.containsMultipleDots( urlMatch )
		) {
			return false;
		}

		return true;
	},


	isValidIpAddress : function ( uriSchemeMatch ) {
		var newRegex = new RegExp(this.hasFullProtocolRegex.source + this.ipRegex.source);
		var uriScheme = uriSchemeMatch.match( newRegex );

		return uriScheme !== null;
	},

	containsMultipleDots : function ( urlMatch ) {
		return urlMatch.indexOf("..") > -1;
	},

	/**
	 * Determines if the URI scheme is a valid scheme to be autolinked. Returns
	 * `false` if the scheme is 'javascript:' or 'vbscript:'
	 *
	 * @private
	 * @param {String} uriSchemeMatch The match URL string for a full URI scheme
	 *   match. Ex: 'http://yahoo.com' or 'mailto:a@a.com'.
	 * @return {Boolean} `true` if the scheme is a valid one, `false` otherwise.
	 */
	isValidUriScheme : function( uriSchemeMatch ) {
		var uriScheme = uriSchemeMatch.match( this.uriSchemeRegex )[ 0 ].toLowerCase();

		return ( uriScheme !== 'javascript:' && uriScheme !== 'vbscript:' );
	},


	/**
	 * Determines if a URL match does not have either:
	 *
	 * a) a full protocol (i.e. 'http://'), or
	 * b) at least one dot ('.') in the domain name (for a non-full-protocol
	 *    match).
	 *
	 * Either situation is considered an invalid URL (ex: 'git:d' does not have
	 * either the '://' part, or at least one dot in the domain name. If the
	 * match was 'git:abc.com', we would consider this valid.)
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Boolean} `true` if the URL match does not have a full protocol,
	 *   or at least one dot ('.') in a non-full-protocol match.
	 */
	urlMatchDoesNotHaveProtocolOrDot : function( urlMatch, protocolUrlMatch ) {
		return ( !!urlMatch && ( !protocolUrlMatch || !this.hasFullProtocolRegex.test( protocolUrlMatch ) ) && urlMatch.indexOf( '.' ) === -1 );
	},


	/**
	 * Determines if a URL match does not have at least one word character after
	 * the protocol (i.e. in the domain name).
	 *
	 * At least one letter character must exist in the domain name after a
	 * protocol match. Ex: skip over something like "git:1.0"
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to know whether or not we
	 *   have a protocol in the URL string, in order to check for a word
	 *   character after the protocol separator (':').
	 * @return {Boolean} `true` if the URL match does not have at least one word
	 *   character in it after the protocol, `false` otherwise.
	 */
	urlMatchDoesNotHaveAtLeastOneWordChar : function( urlMatch, protocolUrlMatch ) {
		if( urlMatch && protocolUrlMatch ) {
			return !this.hasWordCharAfterProtocolRegex.test( urlMatch );
		} else {
			return false;
		}
	}

};

/*global Autolinker */
/**
 * A truncation feature where the ellipsis will be placed at the end of the URL.
 *
 * @param {String} anchorText
 * @param {Number} truncateLen The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */
Autolinker.truncate.TruncateEnd = function(anchorText, truncateLen, ellipsisChars){
	return Autolinker.Util.ellipsis( anchorText, truncateLen, ellipsisChars );
};

/*global Autolinker */
/**
 * Date: 2015-10-05
 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
 *
 * A truncation feature, where the ellipsis will be placed in the dead-center of the URL.
 *
 * @param {String} url             A URL.
 * @param {Number} truncateLen     The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars   The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */
Autolinker.truncate.TruncateMiddle = function(url, truncateLen, ellipsisChars){
  if (url.length <= truncateLen) {
    return url;
  }

  var ellipsisLengthBeforeParsing;
  var ellipsisLength;

  if(ellipsisChars == null) {
    ellipsisChars = '&hellip;';
    ellipsisLengthBeforeParsing = 8;
    ellipsisLength = 3;
  } else {
    ellipsisLengthBeforeParsing = ellipsisChars.length;
    ellipsisLength = ellipsisChars.length;
  }

  var availableLength = truncateLen - ellipsisLength;
  var end = "";
  if (availableLength > 0) {
    end = url.substr((-1)*Math.floor(availableLength/2));
  }
  return (url.substr(0, Math.ceil(availableLength/2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
};

/*global Autolinker */
/**
 * Date: 2015-10-05
 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
 *
 * A truncation feature, where the ellipsis will be placed at a section within
 * the URL making it still somewhat human readable.
 *
 * @param {String} url						 A URL.
 * @param {Number} truncateLen		 The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars	 The characters to place within the url, e.g. "...".
 * @return {String} The truncated URL.
 */
Autolinker.truncate.TruncateSmart = function(url, truncateLen, ellipsisChars){

	var ellipsisLengthBeforeParsing;
	var ellipsisLength;

	if(ellipsisChars == null) {
		ellipsisChars = '&hellip;';
		ellipsisLength = 3;
		ellipsisLengthBeforeParsing = 8;
	} else {
		ellipsisLength = ellipsisChars.length;
		ellipsisLengthBeforeParsing = ellipsisChars.length;
	}

	var parse_url = function(url){ // Functionality inspired by PHP function of same name
		var urlObj = {};
		var urlSub = url;
		var match = urlSub.match(/^([a-z]+):\/\//i);
		if (match) {
			urlObj.scheme = match[1];
			urlSub = urlSub.substr(match[0].length);
		}
		match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
		if (match) {
			urlObj.host = match[1];
			urlSub = urlSub.substr(match[0].length);
		}
		match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
		if (match) {
			urlObj.path = match[1];
			urlSub = urlSub.substr(match[0].length);
		}
		match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
		if (match) {
			urlObj.query = match[1];
			urlSub = urlSub.substr(match[0].length);
		}
		match = urlSub.match(/^#(.*?)$/i);
		if (match) {
			urlObj.fragment = match[1];
			//urlSub = urlSub.substr(match[0].length);  -- not used. Uncomment if adding another block.
		}
		return urlObj;
	};

	var buildUrl = function(urlObj){
		var url = "";
		if (urlObj.scheme && urlObj.host) {
			url += urlObj.scheme + "://";
		}
		if (urlObj.host) {
			url += urlObj.host;
		}
		if (urlObj.path) {
			url += "/" + urlObj.path;
		}
		if (urlObj.query) {
			url += "?" + urlObj.query;
		}
		if (urlObj.fragment) {
			url += "#" + urlObj.fragment;
		}
		return url;
	};

	var buildSegment = function(segment, remainingAvailableLength){
		var remainingAvailableLengthHalf = remainingAvailableLength/ 2,
				startOffset = Math.ceil(remainingAvailableLengthHalf),
				endOffset = (-1)*Math.floor(remainingAvailableLengthHalf),
				end = "";
		if (endOffset < 0) {
			end = segment.substr(endOffset);
		}
		return segment.substr(0, startOffset) + ellipsisChars + end;
	};
	if (url.length <= truncateLen) {
		return url;
	}
	var availableLength = truncateLen - ellipsisLength;
	var urlObj = parse_url(url);
	// Clean up the URL
	if (urlObj.query) {
		var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
		if (matchQuery) {
			// Malformed URL; two or more "?". Removed any content behind the 2nd.
			urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
			url = buildUrl(urlObj);
		}
	}
	if (url.length <= truncateLen) {
		return url;
	}
	if (urlObj.host) {
		urlObj.host = urlObj.host.replace(/^www\./, "");
		url = buildUrl(urlObj);
	}
	if (url.length <= truncateLen) {
		return url;
	}
	// Process and build the URL
	var str = "";
	if (urlObj.host) {
		str += urlObj.host;
	}
	if (str.length >= availableLength) {
		if (urlObj.host.length == truncateLen) {
			return (urlObj.host.substr(0, (truncateLen - ellipsisLength)) + ellipsisChars).substr(0, availableLength + ellipsisLengthBeforeParsing);
		}
		return buildSegment(str, availableLength).substr(0, availableLength + ellipsisLengthBeforeParsing);
	}
	var pathAndQuery = "";
	if (urlObj.path) {
		pathAndQuery += "/" + urlObj.path;
	}
	if (urlObj.query) {
		pathAndQuery += "?" + urlObj.query;
	}
	if (pathAndQuery) {
		if ((str+pathAndQuery).length >= availableLength) {
			if ((str+pathAndQuery).length == truncateLen) {
				return (str + pathAndQuery).substr(0, truncateLen);
			}
			var remainingAvailableLength = availableLength - str.length;
			return (str + buildSegment(pathAndQuery, remainingAvailableLength)).substr(0, availableLength + ellipsisLengthBeforeParsing);
		} else {
			str += pathAndQuery;
		}
	}
	if (urlObj.fragment) {
		var fragment = "#"+urlObj.fragment;
		if ((str+fragment).length >= availableLength) {
			if ((str+fragment).length == truncateLen) {
				return (str + fragment).substr(0, truncateLen);
			}
			var remainingAvailableLength2 = availableLength - str.length;
			return (str + buildSegment(fragment, remainingAvailableLength2)).substr(0, availableLength + ellipsisLengthBeforeParsing);
		} else {
			str += fragment;
		}
	}
	if (urlObj.scheme && urlObj.host) {
		var scheme = urlObj.scheme + "://";
		if ((str+scheme).length < availableLength) {
			return (scheme + str).substr(0, truncateLen);
		}
	}
	if (str.length <= truncateLen) {
		return str;
	}
	var end = "";
	if (availableLength > 0) {
		end = str.substr((-1)*Math.floor(availableLength/2));
	}
	return (str.substr(0, Math.ceil(availableLength/2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
};

return Autolinker;
}));


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var location = global.location || {};
/*jslint indent: 2, browser: true, bitwise: true, plusplus: true */
var twemoji = (function (
  /*! Copyright Twitter Inc. and other contributors. Licensed under MIT *//*
    https://github.com/twitter/twemoji/blob/gh-pages/LICENSE
  */

  // WARNING:   this file is generated automatically via
  //            `node twemoji-generator.js`
  //            please update its `createTwemoji` function
  //            at the bottom of the same file instead.

) {
  'use strict';

  /*jshint maxparams:4 */

  var
    // the exported module object
    twemoji = {


    /////////////////////////
    //      properties     //
    /////////////////////////

      // default assets url, by default will be Twitter Inc. CDN
      base: 'https://twemoji.maxcdn.com/2/',

      // default assets file extensions, by default '.png'
      ext: '.png',

      // default assets/folder size, by default "72x72"
      // available via Twitter CDN: 72
      size: '72x72',

      // default class name, by default 'emoji'
      className: 'emoji',

      // basic utilities / helpers to convert code points
      // to JavaScript surrogates and vice versa
      convert: {

        /**
         * Given an HEX codepoint, returns UTF16 surrogate pairs.
         *
         * @param   string  generic codepoint, i.e. '1F4A9'
         * @return  string  codepoint transformed into utf16 surrogates pair,
         *          i.e. \uD83D\uDCA9
         *
         * @example
         *  twemoji.convert.fromCodePoint('1f1e8');
         *  // "\ud83c\udde8"
         *
         *  '1f1e8-1f1f3'.split('-').map(twemoji.convert.fromCodePoint).join('')
         *  // "\ud83c\udde8\ud83c\uddf3"
         */
        fromCodePoint: fromCodePoint,

        /**
         * Given UTF16 surrogate pairs, returns the equivalent HEX codepoint.
         *
         * @param   string  generic utf16 surrogates pair, i.e. \uD83D\uDCA9
         * @param   string  optional separator for double code points, default='-'
         * @return  string  utf16 transformed into codepoint, i.e. '1F4A9'
         *
         * @example
         *  twemoji.convert.toCodePoint('\ud83c\udde8\ud83c\uddf3');
         *  // "1f1e8-1f1f3"
         *
         *  twemoji.convert.toCodePoint('\ud83c\udde8\ud83c\uddf3', '~');
         *  // "1f1e8~1f1f3"
         */
        toCodePoint: toCodePoint
      },


    /////////////////////////
    //       methods       //
    /////////////////////////

      /**
       * User first: used to remove missing images
       * preserving the original text intent when
       * a fallback for network problems is desired.
       * Automatically added to Image nodes via DOM
       * It could be recycled for string operations via:
       *  $('img.emoji').on('error', twemoji.onerror)
       */
      onerror: function onerror() {
        if (this.parentNode) {
          this.parentNode.replaceChild(createText(this.alt, false), this);
        }
      },

      /**
       * Main method/logic to generate either <img> tags or HTMLImage nodes.
       *  "emojify" a generic text or DOM Element.
       *
       * @overloads
       *
       * String replacement for `innerHTML` or server side operations
       *  twemoji.parse(string);
       *  twemoji.parse(string, Function);
       *  twemoji.parse(string, Object);
       *
       * HTMLElement tree parsing for safer operations over existing DOM
       *  twemoji.parse(HTMLElement);
       *  twemoji.parse(HTMLElement, Function);
       *  twemoji.parse(HTMLElement, Object);
       *
       * @param   string|HTMLElement  the source to parse and enrich with emoji.
       *
       *          string              replace emoji matches with <img> tags.
       *                              Mainly used to inject emoji via `innerHTML`
       *                              It does **not** parse the string or validate it,
       *                              it simply replaces found emoji with a tag.
       *                              NOTE: be sure this won't affect security.
       *
       *          HTMLElement         walk through the DOM tree and find emoji
       *                              that are inside **text node only** (nodeType === 3)
       *                              Mainly used to put emoji in already generated DOM
       *                              without compromising surrounding nodes and
       *                              **avoiding** the usage of `innerHTML`.
       *                              NOTE: Using DOM elements instead of strings should
       *                              improve security without compromising too much
       *                              performance compared with a less safe `innerHTML`.
       *
       * @param   Function|Object  [optional]
       *                              either the callback that will be invoked or an object
       *                              with all properties to use per each found emoji.
       *
       *          Function            if specified, this will be invoked per each emoji
       *                              that has been found through the RegExp except
       *                              those follwed by the invariant \uFE0E ("as text").
       *                              Once invoked, parameters will be:
       *
       *                                iconId:string     the lower case HEX code point
       *                                                  i.e. "1f4a9"
       *
       *                                options:Object    all info for this parsing operation
       *
       *                                variant:char      the optional \uFE0F ("as image")
       *                                                  variant, in case this info
       *                                                  is anyhow meaningful.
       *                                                  By default this is ignored.
       *
       *                              If such callback will return a falsy value instead
       *                              of a valid `src` to use for the image, nothing will
       *                              actually change for that specific emoji.
       *
       *
       *          Object              if specified, an object containing the following properties
       *
       *            callback   Function  the callback to invoke per each found emoji.
       *            base       string    the base url, by default twemoji.base
       *            ext        string    the image extension, by default twemoji.ext
       *            size       string    the assets size, by default twemoji.size
       *
       * @example
       *
       *  twemoji.parse("I \u2764\uFE0F emoji!");
       *  // I <img class="emoji" draggable="false" alt="❤️" src="/assets/2764.gif"/> emoji!
       *
       *
       *  twemoji.parse("I \u2764\uFE0F emoji!", function(iconId, options) {
       *    return '/assets/' + iconId + '.gif';
       *  });
       *  // I <img class="emoji" draggable="false" alt="❤️" src="/assets/2764.gif"/> emoji!
       *
       *
       * twemoji.parse("I \u2764\uFE0F emoji!", {
       *   size: 72,
       *   callback: function(iconId, options) {
       *     return '/assets/' + options.size + '/' + iconId + options.ext;
       *   }
       * });
       *  // I <img class="emoji" draggable="false" alt="❤️" src="/assets/72x72/2764.png"/> emoji!
       *
       */
      parse: parse,

      /**
       * Given a string, invokes the callback argument
       *  per each emoji found in such string.
       * This is the most raw version used by
       *  the .parse(string) method itself.
       *
       * @param   string    generic string to parse
       * @param   Function  a generic callback that will be
       *                    invoked to replace the content.
       *                    This calback wil receive standard
       *                    String.prototype.replace(str, callback)
       *                    arguments such:
       *  callback(
       *    rawText,  // the emoji match
       *  );
       *
       *                    and others commonly received via replace.
       */
      replace: replace,

      /**
       * Simplify string tests against emoji.
       *
       * @param   string  some text that might contain emoji
       * @return  boolean true if any emoji was found, false otherwise.
       *
       * @example
       *
       *  if (twemoji.test(someContent)) {
       *    console.log("emoji All The Things!");
       *  }
       */
      test: test
    },

    // used to escape HTML special chars in attributes
    escaper = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    },

    // RegExp based on emoji's official Unicode standards
    // http://www.unicode.org/Public/UNIDATA/EmojiSources.txt
    re = /\ud83d[\udc68-\udc69](?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92])|(?:\ud83c[\udfcb\udfcc]|\ud83d\udd75|\u26f9)(?:\ufe0f|\ud83c[\udffb-\udfff])\u200d[\u2640\u2642]\ufe0f|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd37-\udd39\udd3d\udd3e\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f|(?:[\u0023\u002a\u0030-\u0039])\ufe0f?\u20e3|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0\udecc]|\ud83e[\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\uddd1-\udddd]|[\u270a\u270b])(?:\ud83c[\udffb-\udfff]|)|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud800\udc00|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a-\udc6d\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\udeeb\udeec\udef4-\udef8]|\ud83e[\udd10-\udd17\udd1d\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd40-\udd45\udd47-\udd4c\udd50-\udd6b\udd80-\udd97\uddc0\uddd0\uddde-\udde6]|[\u23e9-\u23ec\u23f0\u23f3\u2640\u2642\u2695\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a]|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u00a9\u00ae\u203c\u2049\u2122\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2694\u2696\u2697\u2699\u269b\u269c\u26a0\u26a1\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))/g,

    // avoid runtime RegExp creation for not so smart,
    // not JIT based, and old browsers / engines
    UFE0Fg = /\uFE0F/g,

    // avoid using a string literal like '\u200D' here because minifiers expand it inline
    U200D = String.fromCharCode(0x200D),

    // used to find HTML special chars in attributes
    rescaper = /[&<>'"]/g,

    // nodes with type 1 which should **not** be parsed
    shouldntBeParsed = /^(?:iframe|noframes|noscript|script|select|style|textarea)$/,

    // just a private shortcut
    fromCharCode = String.fromCharCode;

  return twemoji;


  /////////////////////////
  //  private functions  //
  //     declaration     //
  /////////////////////////

  /**
   * Shortcut to create text nodes
   * @param   string  text used to create DOM text node
   * @return  Node  a DOM node with that text
   */
  function createText(text, clean) {
    return document.createTextNode(clean ? text.replace(UFE0Fg, '') : text);
  }

  /**
   * Utility function to escape html attribute text
   * @param   string  text use in HTML attribute
   * @return  string  text encoded to use in HTML attribute
   */
  function escapeHTML(s) {
    return s.replace(rescaper, replacer);
  }

  /**
   * Default callback used to generate emoji src
   *  based on Twitter CDN
   * @param   string    the emoji codepoint string
   * @param   string    the default size to use, i.e. "36x36"
   * @return  string    the image source to use
   */
  function defaultImageSrcGenerator(icon, options) {
    return ''.concat(options.base, options.size, '/', icon, options.ext);
  }

  /**
   * Given a generic DOM nodeType 1, walk through all children
   * and store every nodeType 3 (#text) found in the tree.
   * @param   Element a DOM Element with probably some text in it
   * @param   Array the list of previously discovered text nodes
   * @return  Array same list with new discovered nodes, if any
   */
  function grabAllTextNodes(node, allText) {
    var
      childNodes = node.childNodes,
      length = childNodes.length,
      subnode,
      nodeType;
    while (length--) {
      subnode = childNodes[length];
      nodeType = subnode.nodeType;
      // parse emoji only in text nodes
      if (nodeType === 3) {
        // collect them to process emoji later
        allText.push(subnode);
      }
      // ignore all nodes that are not type 1, that are svg, or that
      // should not be parsed as script, style, and others
      else if (nodeType === 1 && !('ownerSVGElement' in subnode) &&
          !shouldntBeParsed.test(subnode.nodeName.toLowerCase())) {
        grabAllTextNodes(subnode, allText);
      }
    }
    return allText;
  }

  /**
   * Used to both remove the possible variant
   *  and to convert utf16 into code points.
   *  If there is a zero-width-joiner (U+200D), leave the variants in.
   * @param   string    the raw text of the emoji match
   * @return  string    the code point
   */
  function grabTheRightIcon(rawText) {
    // if variant is present as \uFE0F
    return toCodePoint(rawText.indexOf(U200D) < 0 ?
      rawText.replace(UFE0Fg, '') :
      rawText
    );
  }

  /**
   * DOM version of the same logic / parser:
   *  emojify all found sub-text nodes placing images node instead.
   * @param   Element   generic DOM node with some text in some child node
   * @param   Object    options  containing info about how to parse
    *
    *            .callback   Function  the callback to invoke per each found emoji.
    *            .base       string    the base url, by default twemoji.base
    *            .ext        string    the image extension, by default twemoji.ext
    *            .size       string    the assets size, by default twemoji.size
    *
   * @return  Element same generic node with emoji in place, if any.
   */
  function parseNode(node, options) {
    var
      allText = grabAllTextNodes(node, []),
      length = allText.length,
      attrib,
      attrname,
      modified,
      fragment,
      subnode,
      text,
      match,
      i,
      index,
      img,
      rawText,
      iconId,
      src;
    while (length--) {
      modified = false;
      fragment = document.createDocumentFragment();
      subnode = allText[length];
      text = subnode.nodeValue;
      i = 0;
      while ((match = re.exec(text))) {
        index = match.index;
        if (index !== i) {
          fragment.appendChild(
            createText(text.slice(i, index), true)
          );
        }
        rawText = match[0];
        iconId = grabTheRightIcon(rawText);
        i = index + rawText.length;
        src = options.callback(iconId, options);
        if (src) {
          img = new Image();
          img.onerror = options.onerror;
          img.setAttribute('draggable', 'false');
          attrib = options.attributes(rawText, iconId);
          for (attrname in attrib) {
            if (
              attrib.hasOwnProperty(attrname) &&
              // don't allow any handlers to be set + don't allow overrides
              attrname.indexOf('on') !== 0 &&
              !img.hasAttribute(attrname)
            ) {
              img.setAttribute(attrname, attrib[attrname]);
            }
          }
          img.className = options.className;
          img.alt = rawText;
          img.src = src;
          modified = true;
          fragment.appendChild(img);
        }
        if (!img) fragment.appendChild(createText(rawText, false));
        img = null;
      }
      // is there actually anything to replace in here ?
      if (modified) {
        // any text left to be added ?
        if (i < text.length) {
          fragment.appendChild(
            createText(text.slice(i), true)
          );
        }
        // replace the text node only, leave intact
        // anything else surrounding such text
        subnode.parentNode.replaceChild(fragment, subnode);
      }
    }
    return node;
  }

  /**
   * String/HTML version of the same logic / parser:
   *  emojify a generic text placing images tags instead of surrogates pair.
   * @param   string    generic string with possibly some emoji in it
   * @param   Object    options  containing info about how to parse
   *
   *            .callback   Function  the callback to invoke per each found emoji.
   *            .base       string    the base url, by default twemoji.base
   *            .ext        string    the image extension, by default twemoji.ext
   *            .size       string    the assets size, by default twemoji.size
   *
   * @return  the string with <img tags> replacing all found and parsed emoji
   */
  function parseString(str, options) {
    return replace(str, function (rawText) {
      var
        ret = rawText,
        iconId = grabTheRightIcon(rawText),
        src = options.callback(iconId, options),
        attrib,
        attrname;
      if (src) {
        // recycle the match string replacing the emoji
        // with its image counter part
        ret = '<img '.concat(
          'class="', options.className, '" ',
          'draggable="false" ',
          // needs to preserve user original intent
          // when variants should be copied and pasted too
          'alt="',
          rawText,
          '"',
          ' src="',
          src,
          '"'
        );
        attrib = options.attributes(rawText, iconId);
        for (attrname in attrib) {
          if (
            attrib.hasOwnProperty(attrname) &&
            // don't allow any handlers to be set + don't allow overrides
            attrname.indexOf('on') !== 0 &&
            ret.indexOf(' ' + attrname + '=') === -1
          ) {
            ret = ret.concat(' ', attrname, '="', escapeHTML(attrib[attrname]), '"');
          }
        }
        ret = ret.concat('/>');
      }
      return ret;
    });
  }

  /**
   * Function used to actually replace HTML special chars
   * @param   string  HTML special char
   * @return  string  encoded HTML special char
   */
  function replacer(m) {
    return escaper[m];
  }

  /**
   * Default options.attribute callback
   * @return  null
   */
  function returnNull() {
    return null;
  }

  /**
   * Given a generic value, creates its squared counterpart if it's a number.
   *  As example, number 36 will return '36x36'.
   * @param   any     a generic value.
   * @return  any     a string representing asset size, i.e. "36x36"
   *                  only in case the value was a number.
   *                  Returns initial value otherwise.
   */
  function toSizeSquaredAsset(value) {
    return typeof value === 'number' ?
      value + 'x' + value :
      value;
  }


  /////////////////////////
  //  exported functions //
  //     declaration     //
  /////////////////////////

  function fromCodePoint(codepoint) {
    var code = typeof codepoint === 'string' ?
          parseInt(codepoint, 16) : codepoint;
    if (code < 0x10000) {
      return fromCharCode(code);
    }
    code -= 0x10000;
    return fromCharCode(
      0xD800 + (code >> 10),
      0xDC00 + (code & 0x3FF)
    );
  }

  function parse(what, how) {
    if (!how || typeof how === 'function') {
      how = {callback: how};
    }
    // if first argument is string, inject html <img> tags
    // otherwise use the DOM tree and parse text nodes only
    return (typeof what === 'string' ? parseString : parseNode)(what, {
      callback:   how.callback || defaultImageSrcGenerator,
      attributes: typeof how.attributes === 'function' ? how.attributes : returnNull,
      base:       typeof how.base === 'string' ? how.base : twemoji.base,
      ext:        how.ext || twemoji.ext,
      size:       how.folder || toSizeSquaredAsset(how.size || twemoji.size),
      className:  how.className || twemoji.className,
      onerror:    how.onerror || twemoji.onerror
    });
  }

  function replace(text, callback) {
    return String(text).replace(re, callback);
  }

  function test(text) {
    // IE6 needs a reset before too
    re.lastIndex = 0;
    var result = re.test(text);
    re.lastIndex = 0;
    return result;
  }

  function toCodePoint(unicodeSurrogates, sep) {
    var
      r = [],
      c = 0,
      p = 0,
      i = 0;
    while (i < unicodeSurrogates.length) {
      c = unicodeSurrogates.charCodeAt(i++);
      if (p) {
        r.push((0x10000 + ((p - 0xD800) << 10) + (c - 0xDC00)).toString(16));
        p = 0;
      } else if (0xD800 <= c && c <= 0xDBFF) {
        p = c;
      } else {
        r.push(c.toString(16));
      }
    }
    return r.join(sep || '-');
  }

}());
if (!location.protocol) {
  twemoji.base = twemoji.base.replace(/^http:/, "");
}
module.exports = twemoji;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*!
 * XRegExp 4.0.0
 * <xregexp.com>
 * Steven Levithan (c) 2007-2017 MIT License
 */

/**
 * XRegExp provides augmented, extensible regular expressions. You get additional regex syntax and
 * flags, beyond what browsers support natively. XRegExp is also a regex utility belt with tools to
 * make your client-side grepping simpler and more powerful, while freeing you from related
 * cross-browser inconsistencies.
 */

// ==--------------------------==
// Private stuff
// ==--------------------------==

// Property name used for extended regex instance data
var REGEX_DATA = 'xregexp';
// Optional features that can be installed and uninstalled
var features = {
    astral: false
};
// Native methods to use and restore ('native' is an ES3 reserved keyword)
var nativ = {
    exec: RegExp.prototype.exec,
    test: RegExp.prototype.test,
    match: String.prototype.match,
    replace: String.prototype.replace,
    split: String.prototype.split
};
// Storage for fixed/extended native methods
var fixed = {};
// Storage for regexes cached by `XRegExp.cache`
var regexCache = {};
// Storage for pattern details cached by the `XRegExp` constructor
var patternCache = {};
// Storage for regex syntax tokens added internally or by `XRegExp.addToken`
var tokens = [];
// Token scopes
var defaultScope = 'default';
var classScope = 'class';
// Regexes that match native regex syntax, including octals
var nativeTokens = {
    // Any native multicharacter token in default scope, or any single character
    'default': /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
    // Any native multicharacter token in character class scope, or any single character
    'class': /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
};
// Any backreference or dollar-prefixed character in replacement strings
var replacementToken = /\$(?:{([\w$]+)}|<([\w$]+)>|(\d\d?|[\s\S]))/g;
// Check for correct `exec` handling of nonparticipating capturing groups
var correctExecNpcg = nativ.exec.call(/()??/, '')[1] === undefined;
// Check for ES6 `flags` prop support
var hasFlagsProp = /x/.flags !== undefined;
// Shortcut to `Object.prototype.toString`
var toString = {}.toString;

function hasNativeFlag(flag) {
    // Can't check based on the presence of properties/getters since browsers might support such
    // properties even when they don't support the corresponding flag in regex construction (tested
    // in Chrome 48, where `'unicode' in /x/` is true but trying to construct a regex with flag `u`
    // throws an error)
    var isSupported = true;
    try {
        // Can't use regex literals for testing even in a `try` because regex literals with
        // unsupported flags cause a compilation error in IE
        new RegExp('', flag);
    } catch (exception) {
        isSupported = false;
    }
    return isSupported;
}
// Check for ES6 `u` flag support
var hasNativeU = hasNativeFlag('u');
// Check for ES6 `y` flag support
var hasNativeY = hasNativeFlag('y');
// Tracker for known flags, including addon flags
var registeredFlags = {
    g: true,
    i: true,
    m: true,
    u: hasNativeU,
    y: hasNativeY
};

/**
 * Attaches extended data and `XRegExp.prototype` properties to a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to augment.
 * @param {Array} captureNames Array with capture names, or `null`.
 * @param {String} xSource XRegExp pattern used to generate `regex`, or `null` if N/A.
 * @param {String} xFlags XRegExp flags used to generate `regex`, or `null` if N/A.
 * @param {Boolean} [isInternalOnly=false] Whether the regex will be used only for internal
 *   operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *   skipping some operations like attaching `XRegExp.prototype` properties.
 * @returns {RegExp} Augmented regex.
 */
function augment(regex, captureNames, xSource, xFlags, isInternalOnly) {
    var p = void 0;

    regex[REGEX_DATA] = {
        captureNames: captureNames
    };

    if (isInternalOnly) {
        return regex;
    }

    // Can't auto-inherit these since the XRegExp constructor returns a nonprimitive value
    if (regex.__proto__) {
        regex.__proto__ = XRegExp.prototype;
    } else {
        for (p in XRegExp.prototype) {
            // An `XRegExp.prototype.hasOwnProperty(p)` check wouldn't be worth it here, since this
            // is performance sensitive, and enumerable `Object.prototype` or `RegExp.prototype`
            // extensions exist on `regex.prototype` anyway
            regex[p] = XRegExp.prototype[p];
        }
    }

    regex[REGEX_DATA].source = xSource;
    // Emulate the ES6 `flags` prop by ensuring flags are in alphabetical order
    regex[REGEX_DATA].flags = xFlags ? xFlags.split('').sort().join('') : xFlags;

    return regex;
}

/**
 * Removes any duplicate characters from the provided string.
 *
 * @private
 * @param {String} str String to remove duplicate characters from.
 * @returns {String} String with any duplicate characters removed.
 */
function clipDuplicates(str) {
    return nativ.replace.call(str, /([\s\S])(?=[\s\S]*\1)/g, '');
}

/**
 * Copies a regex object while preserving extended data and augmenting with `XRegExp.prototype`
 * properties. The copy has a fresh `lastIndex` property (set to zero). Allows adding and removing
 * flags g and y while copying the regex.
 *
 * @private
 * @param {RegExp} regex Regex to copy.
 * @param {Object} [options] Options object with optional properties:
 *   - `addG` {Boolean} Add flag g while copying the regex.
 *   - `addY` {Boolean} Add flag y while copying the regex.
 *   - `removeG` {Boolean} Remove flag g while copying the regex.
 *   - `removeY` {Boolean} Remove flag y while copying the regex.
 *   - `isInternalOnly` {Boolean} Whether the copied regex will be used only for internal
 *     operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *     skipping some operations like attaching `XRegExp.prototype` properties.
 *   - `source` {String} Overrides `<regex>.source`, for special cases.
 * @returns {RegExp} Copy of the provided regex, possibly with modified flags.
 */
function copyRegex(regex, options) {
    if (!XRegExp.isRegExp(regex)) {
        throw new TypeError('Type RegExp expected');
    }

    var xData = regex[REGEX_DATA] || {};
    var flags = getNativeFlags(regex);
    var flagsToAdd = '';
    var flagsToRemove = '';
    var xregexpSource = null;
    var xregexpFlags = null;

    options = options || {};

    if (options.removeG) {
        flagsToRemove += 'g';
    }
    if (options.removeY) {
        flagsToRemove += 'y';
    }
    if (flagsToRemove) {
        flags = nativ.replace.call(flags, new RegExp('[' + flagsToRemove + ']+', 'g'), '');
    }

    if (options.addG) {
        flagsToAdd += 'g';
    }
    if (options.addY) {
        flagsToAdd += 'y';
    }
    if (flagsToAdd) {
        flags = clipDuplicates(flags + flagsToAdd);
    }

    if (!options.isInternalOnly) {
        if (xData.source !== undefined) {
            xregexpSource = xData.source;
        }
        // null or undefined; don't want to add to `flags` if the previous value was null, since
        // that indicates we're not tracking original precompilation flags
        if (xData.flags != null) {
            // Flags are only added for non-internal regexes by `XRegExp.globalize`. Flags are never
            // removed for non-internal regexes, so don't need to handle it
            xregexpFlags = flagsToAdd ? clipDuplicates(xData.flags + flagsToAdd) : xData.flags;
        }
    }

    // Augment with `XRegExp.prototype` properties, but use the native `RegExp` constructor to avoid
    // searching for special tokens. That would be wrong for regexes constructed by `RegExp`, and
    // unnecessary for regexes constructed by `XRegExp` because the regex has already undergone the
    // translation to native regex syntax
    regex = augment(new RegExp(options.source || regex.source, flags), hasNamedCapture(regex) ? xData.captureNames.slice(0) : null, xregexpSource, xregexpFlags, options.isInternalOnly);

    return regex;
}

/**
 * Converts hexadecimal to decimal.
 *
 * @private
 * @param {String} hex
 * @returns {Number}
 */
function dec(hex) {
    return parseInt(hex, 16);
}

/**
 * Returns a pattern that can be used in a native RegExp in place of an ignorable token such as an
 * inline comment or whitespace with flag x. This is used directly as a token handler function
 * passed to `XRegExp.addToken`.
 *
 * @private
 * @param {String} match Match arg of `XRegExp.addToken` handler
 * @param {String} scope Scope arg of `XRegExp.addToken` handler
 * @param {String} flags Flags arg of `XRegExp.addToken` handler
 * @returns {String} Either '' or '(?:)', depending on which is needed in the context of the match.
 */
function getContextualTokenSeparator(match, scope, flags) {
    if (
    // No need to separate tokens if at the beginning or end of a group
    match.input[match.index - 1] === '(' || match.input[match.index + match[0].length] === ')' ||
    // Avoid separating tokens when the following token is a quantifier
    isQuantifierNext(match.input, match.index + match[0].length, flags)) {
        return '';
    }
    // Keep tokens separated. This avoids e.g. inadvertedly changing `\1 1` or `\1(?#)1` to `\11`.
    // This also ensures all tokens remain as discrete atoms, e.g. it avoids converting the syntax
    // error `(? :` into `(?:`.
    return '(?:)';
}

/**
 * Returns native `RegExp` flags used by a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {String} Native flags in use.
 */
function getNativeFlags(regex) {
    return hasFlagsProp ? regex.flags :
    // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
    // with an empty string) allows this to continue working predictably when
    // `XRegExp.proptotype.toString` is overridden
    nativ.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(regex))[1];
}

/**
 * Determines whether a regex has extended instance data used to track capture names.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {Boolean} Whether the regex uses named capture.
 */
function hasNamedCapture(regex) {
    return !!(regex[REGEX_DATA] && regex[REGEX_DATA].captureNames);
}

/**
 * Converts decimal to hexadecimal.
 *
 * @private
 * @param {Number|String} dec
 * @returns {String}
 */
function hex(dec) {
    return parseInt(dec, 10).toString(16);
}

/**
 * Checks whether the next nonignorable token after the specified position is a quantifier.
 *
 * @private
 * @param {String} pattern Pattern to search within.
 * @param {Number} pos Index in `pattern` to search at.
 * @param {String} flags Flags used by the pattern.
 * @returns {Boolean} Whether the next nonignorable token is a quantifier.
 */
function isQuantifierNext(pattern, pos, flags) {
    var inlineCommentPattern = '\\(\\?#[^)]*\\)';
    var lineCommentPattern = '#[^#\\n]*';
    var quantifierPattern = '[?*+]|{\\d+(?:,\\d*)?}';
    return nativ.test.call(flags.indexOf('x') !== -1 ?
    // Ignore any leading whitespace, line comments, and inline comments
    /^(?:\s|#[^#\n]*|\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/ :
    // Ignore any leading inline comments
    /^(?:\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/, pattern.slice(pos));
}

/**
 * Determines whether a value is of the specified type, by resolving its internal [[Class]].
 *
 * @private
 * @param {*} value Object to check.
 * @param {String} type Type to check for, in TitleCase.
 * @returns {Boolean} Whether the object matches the type.
 */
function isType(value, type) {
    return toString.call(value) === '[object ' + type + ']';
}

/**
 * Adds leading zeros if shorter than four characters. Used for fixed-length hexadecimal values.
 *
 * @private
 * @param {String} str
 * @returns {String}
 */
function pad4(str) {
    while (str.length < 4) {
        str = '0' + str;
    }
    return str;
}

/**
 * Checks for flag-related errors, and strips/applies flags in a leading mode modifier. Offloads
 * the flag preparation logic from the `XRegExp` constructor.
 *
 * @private
 * @param {String} pattern Regex pattern, possibly with a leading mode modifier.
 * @param {String} flags Any combination of flags.
 * @returns {Object} Object with properties `pattern` and `flags`.
 */
function prepareFlags(pattern, flags) {
    var i = void 0;

    // Recent browsers throw on duplicate flags, so copy this behavior for nonnative flags
    if (clipDuplicates(flags) !== flags) {
        throw new SyntaxError('Invalid duplicate regex flag ' + flags);
    }

    // Strip and apply a leading mode modifier with any combination of flags except g or y
    pattern = nativ.replace.call(pattern, /^\(\?([\w$]+)\)/, function ($0, $1) {
        if (nativ.test.call(/[gy]/, $1)) {
            throw new SyntaxError('Cannot use flag g or y in mode modifier ' + $0);
        }
        // Allow duplicate flags within the mode modifier
        flags = clipDuplicates(flags + $1);
        return '';
    });

    // Throw on unknown native or nonnative flags
    for (i = 0; i < flags.length; ++i) {
        if (!registeredFlags[flags[i]]) {
            throw new SyntaxError('Unknown regex flag ' + flags[i]);
        }
    }

    return {
        pattern: pattern,
        flags: flags
    };
}

/**
 * Prepares an options object from the given value.
 *
 * @private
 * @param {String|Object} value Value to convert to an options object.
 * @returns {Object} Options object.
 */
function prepareOptions(value) {
    var options = {};

    if (isType(value, 'String')) {
        XRegExp.forEach(value, /[^\s,]+/, function (match) {
            options[match] = true;
        });

        return options;
    }

    return value;
}

/**
 * Registers a flag so it doesn't throw an 'unknown flag' error.
 *
 * @private
 * @param {String} flag Single-character flag to register.
 */
function registerFlag(flag) {
    if (!/^[\w$]$/.test(flag)) {
        throw new Error('Flag must be a single character A-Za-z0-9_$');
    }

    registeredFlags[flag] = true;
}

/**
 * Runs built-in and custom regex syntax tokens in reverse insertion order at the specified
 * position, until a match is found.
 *
 * @private
 * @param {String} pattern Original pattern from which an XRegExp object is being built.
 * @param {String} flags Flags being used to construct the regex.
 * @param {Number} pos Position to search for tokens within `pattern`.
 * @param {Number} scope Regex scope to apply: 'default' or 'class'.
 * @param {Object} context Context object to use for token handler functions.
 * @returns {Object} Object with properties `matchLength`, `output`, and `reparse`; or `null`.
 */
function runTokens(pattern, flags, pos, scope, context) {
    var i = tokens.length;
    var leadChar = pattern[pos];
    var result = null;
    var match = void 0;
    var t = void 0;

    // Run in reverse insertion order
    while (i--) {
        t = tokens[i];
        if (t.leadChar && t.leadChar !== leadChar || t.scope !== scope && t.scope !== 'all' || t.flag && !(flags.indexOf(t.flag) !== -1)) {
            continue;
        }

        match = XRegExp.exec(pattern, t.regex, pos, 'sticky');
        if (match) {
            result = {
                matchLength: match[0].length,
                output: t.handler.call(context, match, scope, flags),
                reparse: t.reparse
            };
            // Finished with token tests
            break;
        }
    }

    return result;
}

/**
 * Enables or disables implicit astral mode opt-in. When enabled, flag A is automatically added to
 * all new regexes created by XRegExp. This causes an error to be thrown when creating regexes if
 * the Unicode Base addon is not available, since flag A is registered by that addon.
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */
function setAstral(on) {
    features.astral = on;
}

/**
 * Returns the object, or throws an error if it is `null` or `undefined`. This is used to follow
 * the ES5 abstract operation `ToObject`.
 *
 * @private
 * @param {*} value Object to check and return.
 * @returns {*} The provided object.
 */
function toObject(value) {
    // null or undefined
    if (value == null) {
        throw new TypeError('Cannot convert null or undefined to object');
    }

    return value;
}

// ==--------------------------==
// Constructor
// ==--------------------------==

/**
 * Creates an extended regular expression object for matching text with a pattern. Differs from a
 * native regular expression in that additional syntax and flags are supported. The returned object
 * is in fact a native `RegExp` and works with all native methods.
 *
 * @class XRegExp
 * @constructor
 * @param {String|RegExp} pattern Regex pattern string, or an existing regex object to copy.
 * @param {String} [flags] Any combination of flags.
 *   Native flags:
 *     - `g` - global
 *     - `i` - ignore case
 *     - `m` - multiline anchors
 *     - `u` - unicode (ES6)
 *     - `y` - sticky (Firefox 3+, ES6)
 *   Additional XRegExp flags:
 *     - `n` - explicit capture
 *     - `s` - dot matches all (aka singleline)
 *     - `x` - free-spacing and line comments (aka extended)
 *     - `A` - astral (requires the Unicode Base addon)
 *   Flags cannot be provided when constructing one `RegExp` from another.
 * @returns {RegExp} Extended regular expression object.
 * @example
 *
 * // With named capture and flag x
 * XRegExp(`(?<year>  [0-9]{4} ) -?  # year
 *          (?<month> [0-9]{2} ) -?  # month
 *          (?<day>   [0-9]{2} )     # day`, 'x');
 *
 * // Providing a regex object copies it. Native regexes are recompiled using native (not XRegExp)
 * // syntax. Copies maintain extended data, are augmented with `XRegExp.prototype` properties, and
 * // have fresh `lastIndex` properties (set to zero).
 * XRegExp(/regex/);
 */
function XRegExp(pattern, flags) {
    if (XRegExp.isRegExp(pattern)) {
        if (flags !== undefined) {
            throw new TypeError('Cannot supply flags when copying a RegExp');
        }
        return copyRegex(pattern);
    }

    // Copy the argument behavior of `RegExp`
    pattern = pattern === undefined ? '' : String(pattern);
    flags = flags === undefined ? '' : String(flags);

    if (XRegExp.isInstalled('astral') && !(flags.indexOf('A') !== -1)) {
        // This causes an error to be thrown if the Unicode Base addon is not available
        flags += 'A';
    }

    if (!patternCache[pattern]) {
        patternCache[pattern] = {};
    }

    if (!patternCache[pattern][flags]) {
        var context = {
            hasNamedCapture: false,
            captureNames: []
        };
        var scope = defaultScope;
        var output = '';
        var pos = 0;
        var result = void 0;

        // Check for flag-related errors, and strip/apply flags in a leading mode modifier
        var applied = prepareFlags(pattern, flags);
        var appliedPattern = applied.pattern;
        var appliedFlags = applied.flags;

        // Use XRegExp's tokens to translate the pattern to a native regex pattern.
        // `appliedPattern.length` may change on each iteration if tokens use `reparse`
        while (pos < appliedPattern.length) {
            do {
                // Check for custom tokens at the current position
                result = runTokens(appliedPattern, appliedFlags, pos, scope, context);
                // If the matched token used the `reparse` option, splice its output into the
                // pattern before running tokens again at the same position
                if (result && result.reparse) {
                    appliedPattern = appliedPattern.slice(0, pos) + result.output + appliedPattern.slice(pos + result.matchLength);
                }
            } while (result && result.reparse);

            if (result) {
                output += result.output;
                pos += result.matchLength || 1;
            } else {
                // Get the native token at the current position
                var token = XRegExp.exec(appliedPattern, nativeTokens[scope], pos, 'sticky')[0];
                output += token;
                pos += token.length;
                if (token === '[' && scope === defaultScope) {
                    scope = classScope;
                } else if (token === ']' && scope === classScope) {
                    scope = defaultScope;
                }
            }
        }

        patternCache[pattern][flags] = {
            // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
            // groups are sometimes inserted during regex transpilation in order to keep tokens
            // separated. However, more than one empty group in a row is never needed.
            pattern: nativ.replace.call(output, /(?:\(\?:\))+/g, '(?:)'),
            // Strip all but native flags
            flags: nativ.replace.call(appliedFlags, /[^gimuy]+/g, ''),
            // `context.captureNames` has an item for each capturing group, even if unnamed
            captures: context.hasNamedCapture ? context.captureNames : null
        };
    }

    var generated = patternCache[pattern][flags];
    return augment(new RegExp(generated.pattern, generated.flags), generated.captures, pattern, flags);
}

// Add `RegExp.prototype` to the prototype chain
XRegExp.prototype = /(?:)/;

// ==--------------------------==
// Public properties
// ==--------------------------==

/**
 * The XRegExp version number as a string containing three dot-separated parts. For example,
 * '2.0.0-beta-3'.
 *
 * @static
 * @memberOf XRegExp
 * @type String
 */
XRegExp.version = '4.0.0';

// ==--------------------------==
// Public methods
// ==--------------------------==

// Intentionally undocumented; used in tests and addons
XRegExp._clipDuplicates = clipDuplicates;
XRegExp._hasNativeFlag = hasNativeFlag;
XRegExp._dec = dec;
XRegExp._hex = hex;
XRegExp._pad4 = pad4;

/**
 * Extends XRegExp syntax and allows custom flags. This is used internally and can be used to
 * create XRegExp addons. If more than one token can match the same string, the last added wins.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex object that matches the new token.
 * @param {Function} handler Function that returns a new pattern string (using native regex syntax)
 *   to replace the matched token within all future XRegExp regexes. Has access to persistent
 *   properties of the regex being built, through `this`. Invoked with three arguments:
 *   - The match array, with named backreference properties.
 *   - The regex scope where the match was found: 'default' or 'class'.
 *   - The flags used by the regex, including any flags in a leading mode modifier.
 *   The handler function becomes part of the XRegExp construction process, so be careful not to
 *   construct XRegExps within the function or you will trigger infinite recursion.
 * @param {Object} [options] Options object with optional properties:
 *   - `scope` {String} Scope where the token applies: 'default', 'class', or 'all'.
 *   - `flag` {String} Single-character flag that triggers the token. This also registers the
 *     flag, which prevents XRegExp from throwing an 'unknown flag' error when the flag is used.
 *   - `optionalFlags` {String} Any custom flags checked for within the token `handler` that are
 *     not required to trigger the token. This registers the flags, to prevent XRegExp from
 *     throwing an 'unknown flag' error when any of the flags are used.
 *   - `reparse` {Boolean} Whether the `handler` function's output should not be treated as
 *     final, and instead be reparseable by other tokens (including the current token). Allows
 *     token chaining or deferring.
 *   - `leadChar` {String} Single character that occurs at the beginning of any successful match
 *     of the token (not always applicable). This doesn't change the behavior of the token unless
 *     you provide an erroneous value. However, providing it can increase the token's performance
 *     since the token can be skipped at any positions where this character doesn't appear.
 * @example
 *
 * // Basic usage: Add \a for the ALERT control code
 * XRegExp.addToken(
 *   /\\a/,
 *   () => '\\x07',
 *   {scope: 'all'}
 * );
 * XRegExp('\\a[\\a-\\n]+').test('\x07\n\x07'); // -> true
 *
 * // Add the U (ungreedy) flag from PCRE and RE2, which reverses greedy and lazy quantifiers.
 * // Since `scope` is not specified, it uses 'default' (i.e., transformations apply outside of
 * // character classes only)
 * XRegExp.addToken(
 *   /([?*+]|{\d+(?:,\d*)?})(\??)/,
 *   (match) => `${match[1]}${match[2] ? '' : '?'}`,
 *   {flag: 'U'}
 * );
 * XRegExp('a+', 'U').exec('aaa')[0]; // -> 'a'
 * XRegExp('a+?', 'U').exec('aaa')[0]; // -> 'aaa'
 */
XRegExp.addToken = function (regex, handler, options) {
    options = options || {};
    var optionalFlags = options.optionalFlags;
    var i = void 0;

    if (options.flag) {
        registerFlag(options.flag);
    }

    if (optionalFlags) {
        optionalFlags = nativ.split.call(optionalFlags, '');
        for (i = 0; i < optionalFlags.length; ++i) {
            registerFlag(optionalFlags[i]);
        }
    }

    // Add to the private list of syntax tokens
    tokens.push({
        regex: copyRegex(regex, {
            addG: true,
            addY: hasNativeY,
            isInternalOnly: true
        }),
        handler: handler,
        scope: options.scope || defaultScope,
        flag: options.flag,
        reparse: options.reparse,
        leadChar: options.leadChar
    });

    // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and flags
    // might now produce different results
    XRegExp.cache.flush('patterns');
};

/**
 * Caches and returns the result of calling `XRegExp(pattern, flags)`. On any subsequent call with
 * the same pattern and flag combination, the cached copy of the regex is returned.
 *
 * @memberOf XRegExp
 * @param {String} pattern Regex pattern string.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @returns {RegExp} Cached XRegExp object.
 * @example
 *
 * while (match = XRegExp.cache('.', 'gs').exec(str)) {
 *   // The regex is compiled once only
 * }
 */
XRegExp.cache = function (pattern, flags) {
    if (!regexCache[pattern]) {
        regexCache[pattern] = {};
    }
    return regexCache[pattern][flags] || (regexCache[pattern][flags] = XRegExp(pattern, flags));
};

// Intentionally undocumented; used in tests
XRegExp.cache.flush = function (cacheName) {
    if (cacheName === 'patterns') {
        // Flush the pattern cache used by the `XRegExp` constructor
        patternCache = {};
    } else {
        // Flush the regex cache populated by `XRegExp.cache`
        regexCache = {};
    }
};

/**
 * Escapes any regular expression metacharacters, for use when matching literal strings. The result
 * can safely be used at any point within a regex that uses any flags.
 *
 * @memberOf XRegExp
 * @param {String} str String to escape.
 * @returns {String} String with regex metacharacters escaped.
 * @example
 *
 * XRegExp.escape('Escaped? <.>');
 * // -> 'Escaped\?\ <\.>'
 */
XRegExp.escape = function (str) {
    return nativ.replace.call(toObject(str), /[-\[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

/**
 * Executes a regex search in a specified string. Returns a match array or `null`. If the provided
 * regex uses named capture, named backreference properties are included on the match array.
 * Optional `pos` and `sticky` arguments specify the search start position, and whether the match
 * must start at the specified position only. The `lastIndex` property of the provided regex is not
 * used, but is updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.exec` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Array} Match array with named backreference properties, or `null`.
 * @example
 *
 * // Basic use, with named backreference
 * let match = XRegExp.exec('U+2620', XRegExp('U\\+(?<hex>[0-9A-F]{4})'));
 * match.hex; // -> '2620'
 *
 * // With pos and sticky, in a loop
 * let pos = 2, result = [], match;
 * while (match = XRegExp.exec('<1><2><3><4>5<6>', /<(\d)>/, pos, 'sticky')) {
 *   result.push(match[1]);
 *   pos = match.index + match[0].length;
 * }
 * // result -> ['2', '3', '4']
 */
XRegExp.exec = function (str, regex, pos, sticky) {
    var cacheKey = 'g';
    var addY = false;
    var fakeY = false;
    var match = void 0;

    addY = hasNativeY && !!(sticky || regex.sticky && sticky !== false);
    if (addY) {
        cacheKey += 'y';
    } else if (sticky) {
        // Simulate sticky matching by appending an empty capture to the original regex. The
        // resulting regex will succeed no matter what at the current index (set with `lastIndex`),
        // and will not search the rest of the subject string. We'll know that the original regex
        // has failed if that last capture is `''` rather than `undefined` (i.e., if that last
        // capture participated in the match).
        fakeY = true;
        cacheKey += 'FakeY';
    }

    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

    // Shares cached copies with `XRegExp.match`/`replace`
    var r2 = regex[REGEX_DATA][cacheKey] || (regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
        addG: true,
        addY: addY,
        source: fakeY ? regex.source + '|()' : undefined,
        removeY: sticky === false,
        isInternalOnly: true
    }));

    pos = pos || 0;
    r2.lastIndex = pos;

    // Fixed `exec` required for `lastIndex` fix, named backreferences, etc.
    match = fixed.exec.call(r2, str);

    // Get rid of the capture added by the pseudo-sticky matcher if needed. An empty string means
    // the original regexp failed (see above).
    if (fakeY && match && match.pop() === '') {
        match = null;
    }

    if (regex.global) {
        regex.lastIndex = match ? r2.lastIndex : 0;
    }

    return match;
};

/**
 * Executes a provided function once per regex match. Searches always start at the beginning of the
 * string and continue until the end, regardless of the state of the regex's `global` property and
 * initial `lastIndex`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Function} callback Function to execute for each match. Invoked with four arguments:
 *   - The match array, with named backreference properties.
 *   - The zero-based match index.
 *   - The string being traversed.
 *   - The regex object being used to traverse the string.
 * @example
 *
 * // Extracts every other digit from a string
 * const evens = [];
 * XRegExp.forEach('1a2345', /\d/, (match, i) => {
 *   if (i % 2) evens.push(+match[0]);
 * });
 * // evens -> [2, 4]
 */
XRegExp.forEach = function (str, regex, callback) {
    var pos = 0;
    var i = -1;
    var match = void 0;

    while (match = XRegExp.exec(str, regex, pos)) {
        // Because `regex` is provided to `callback`, the function could use the deprecated/
        // nonstandard `RegExp.prototype.compile` to mutate the regex. However, since `XRegExp.exec`
        // doesn't use `lastIndex` to set the search position, this can't lead to an infinite loop,
        // at least. Actually, because of the way `XRegExp.exec` caches globalized versions of
        // regexes, mutating the regex will not have any effect on the iteration or matched strings,
        // which is a nice side effect that brings extra safety.
        callback(match, ++i, str, regex);

        pos = match.index + (match[0].length || 1);
    }
};

/**
 * Copies a regex object and adds flag `g`. The copy maintains extended data, is augmented with
 * `XRegExp.prototype` properties, and has a fresh `lastIndex` property (set to zero). Native
 * regexes are not recompiled using XRegExp syntax.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex to globalize.
 * @returns {RegExp} Copy of the provided regex with flag `g` added.
 * @example
 *
 * const globalCopy = XRegExp.globalize(/regex/);
 * globalCopy.global; // -> true
 */
XRegExp.globalize = function (regex) {
    return copyRegex(regex, { addG: true });
};

/**
 * Installs optional features according to the specified options. Can be undone using
 * `XRegExp.uninstall`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.install({
 *   // Enables support for astral code points in Unicode addons (implicitly sets flag A)
 *   astral: true
 * });
 *
 * // With an options string
 * XRegExp.install('astral');
 */
XRegExp.install = function (options) {
    options = prepareOptions(options);

    if (!features.astral && options.astral) {
        setAstral(true);
    }
};

/**
 * Checks whether an individual optional feature is installed.
 *
 * @memberOf XRegExp
 * @param {String} feature Name of the feature to check. One of:
 *   - `astral`
 * @returns {Boolean} Whether the feature is installed.
 * @example
 *
 * XRegExp.isInstalled('astral');
 */
XRegExp.isInstalled = function (feature) {
    return !!features[feature];
};

/**
 * Returns `true` if an object is a regex; `false` if it isn't. This works correctly for regexes
 * created in another frame, when `instanceof` and `constructor` checks would fail.
 *
 * @memberOf XRegExp
 * @param {*} value Object to check.
 * @returns {Boolean} Whether the object is a `RegExp` object.
 * @example
 *
 * XRegExp.isRegExp('string'); // -> false
 * XRegExp.isRegExp(/regex/i); // -> true
 * XRegExp.isRegExp(RegExp('^', 'm')); // -> true
 * XRegExp.isRegExp(XRegExp('(?s).')); // -> true
 */
XRegExp.isRegExp = function (value) {
    return toString.call(value) === '[object RegExp]';
}; // isType(value, 'RegExp');

/**
 * Returns the first matched string, or in global mode, an array containing all matched strings.
 * This is essentially a more convenient re-implementation of `String.prototype.match` that gives
 * the result types you actually want (string instead of `exec`-style array in match-first mode,
 * and an empty array instead of `null` when no matches are found in match-all mode). It also lets
 * you override flag g and ignore `lastIndex`, and fixes browser bugs.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {String} [scope='one'] Use 'one' to return the first match as a string. Use 'all' to
 *   return an array of all matched strings. If not explicitly specified and `regex` uses flag g,
 *   `scope` is 'all'.
 * @returns {String|Array} In match-first mode: First match as a string, or `null`. In match-all
 *   mode: Array of all matched strings, or an empty array.
 * @example
 *
 * // Match first
 * XRegExp.match('abc', /\w/); // -> 'a'
 * XRegExp.match('abc', /\w/g, 'one'); // -> 'a'
 * XRegExp.match('abc', /x/g, 'one'); // -> null
 *
 * // Match all
 * XRegExp.match('abc', /\w/g); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /\w/, 'all'); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /x/, 'all'); // -> []
 */
XRegExp.match = function (str, regex, scope) {
    var global = regex.global && scope !== 'one' || scope === 'all';
    var cacheKey = (global ? 'g' : '') + (regex.sticky ? 'y' : '') || 'noGY';

    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

    // Shares cached copies with `XRegExp.exec`/`replace`
    var r2 = regex[REGEX_DATA][cacheKey] || (regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
        addG: !!global,
        removeG: scope === 'one',
        isInternalOnly: true
    }));

    var result = nativ.match.call(toObject(str), r2);

    if (regex.global) {
        regex.lastIndex = scope === 'one' && result ?
        // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
        result.index + result[0].length : 0;
    }

    return global ? result || [] : result && result[0];
};

/**
 * Retrieves the matches from searching a string using a chain of regexes that successively search
 * within previous matches. The provided `chain` array can contain regexes and or objects with
 * `regex` and `backref` properties. When a backreference is specified, the named or numbered
 * backreference is passed forward to the next regex or returned.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} chain Regexes that each search for matches within preceding results.
 * @returns {Array} Matches by the last regex in the chain, or an empty array.
 * @example
 *
 * // Basic usage; matches numbers within <b> tags
 * XRegExp.matchChain('1 <b>2</b> 3 <b>4 a 56</b>', [
 *   XRegExp('(?is)<b>.*?</b>'),
 *   /\d+/
 * ]);
 * // -> ['2', '4', '56']
 *
 * // Passing forward and returning specific backreferences
 * html = '<a href="http://xregexp.com/api/">XRegExp</a>\
 *         <a href="http://www.google.com/">Google</a>';
 * XRegExp.matchChain(html, [
 *   {regex: /<a href="([^"]+)">/i, backref: 1},
 *   {regex: XRegExp('(?i)^https?://(?<domain>[^/?#]+)'), backref: 'domain'}
 * ]);
 * // -> ['xregexp.com', 'www.google.com']
 */
XRegExp.matchChain = function (str, chain) {
    return function recurseChain(values, level) {
        var item = chain[level].regex ? chain[level] : { regex: chain[level] };
        var matches = [];

        function addMatch(match) {
            if (item.backref) {
                // Safari 4.0.5 (but not 5.0.5+) inappropriately uses sparse arrays to hold the
                // `undefined`s for backreferences to nonparticipating capturing groups. In such
                // cases, a `hasOwnProperty` or `in` check on its own would inappropriately throw
                // the exception, so also check if the backreference is a number that is within the
                // bounds of the array.
                if (!(match.hasOwnProperty(item.backref) || +item.backref < match.length)) {
                    throw new ReferenceError('Backreference to undefined group: ' + item.backref);
                }

                matches.push(match[item.backref] || '');
            } else {
                matches.push(match[0]);
            }
        }

        for (var i = 0; i < values.length; ++i) {
            XRegExp.forEach(values[i], item.regex, addMatch);
        }

        return level === chain.length - 1 || !matches.length ? matches : recurseChain(matches, level + 1);
    }([str], 0);
};

/**
 * Returns a new string with one or all matches of a pattern replaced. The pattern can be a string
 * or regex, and the replacement can be a string or a function to be called for each match. To
 * perform a global search and replace, use the optional `scope` argument or include flag g if using
 * a regex. Replacement strings can use `${n}` or `$<n>` for named and numbered backreferences.
 * Replacement functions can use named backreferences via `arguments[0].name`. Also fixes browser
 * bugs compared to the native `String.prototype.replace` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 *   Replacement strings can include special replacement syntax:
 *     - $$ - Inserts a literal $ character.
 *     - $&, $0 - Inserts the matched substring.
 *     - $` - Inserts the string that precedes the matched substring (left context).
 *     - $' - Inserts the string that follows the matched substring (right context).
 *     - $n, $nn - Where n/nn are digits referencing an existent capturing group, inserts
 *       backreference n/nn.
 *     - ${n}, $<n> - Where n is a name or any number of digits that reference an existent capturing
 *       group, inserts backreference n.
 *   Replacement functions are invoked with three or more arguments:
 *     - The matched substring (corresponds to $& above). Named backreferences are accessible as
 *       properties of this first argument.
 *     - 0..n arguments, one for each backreference (corresponding to $1, $2, etc. above).
 *     - The zero-based index of the match within the total search string.
 *     - The total string being searched.
 * @param {String} [scope='one'] Use 'one' to replace the first match only, or 'all'. If not
 *   explicitly specified and using a regex with flag g, `scope` is 'all'.
 * @returns {String} New string with one or all matches replaced.
 * @example
 *
 * // Regex search, using named backreferences in replacement string
 * const name = XRegExp('(?<first>\\w+) (?<last>\\w+)');
 * XRegExp.replace('John Smith', name, '$<last>, $<first>');
 * // -> 'Smith, John'
 *
 * // Regex search, using named backreferences in replacement function
 * XRegExp.replace('John Smith', name, (match) => `${match.last}, ${match.first}`);
 * // -> 'Smith, John'
 *
 * // String search, with replace-all
 * XRegExp.replace('RegExp builds RegExps', 'RegExp', 'XRegExp', 'all');
 * // -> 'XRegExp builds XRegExps'
 */
XRegExp.replace = function (str, search, replacement, scope) {
    var isRegex = XRegExp.isRegExp(search);
    var global = search.global && scope !== 'one' || scope === 'all';
    var cacheKey = (global ? 'g' : '') + (search.sticky ? 'y' : '') || 'noGY';
    var s2 = search;

    if (isRegex) {
        search[REGEX_DATA] = search[REGEX_DATA] || {};

        // Shares cached copies with `XRegExp.exec`/`match`. Since a copy is used, `search`'s
        // `lastIndex` isn't updated *during* replacement iterations
        s2 = search[REGEX_DATA][cacheKey] || (search[REGEX_DATA][cacheKey] = copyRegex(search, {
            addG: !!global,
            removeG: scope === 'one',
            isInternalOnly: true
        }));
    } else if (global) {
        s2 = new RegExp(XRegExp.escape(String(search)), 'g');
    }

    // Fixed `replace` required for named backreferences, etc.
    var result = fixed.replace.call(toObject(str), s2, replacement);

    if (isRegex && search.global) {
        // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
        search.lastIndex = 0;
    }

    return result;
};

/**
 * Performs batch processing of string replacements. Used like `XRegExp.replace`, but accepts an
 * array of replacement details. Later replacements operate on the output of earlier replacements.
 * Replacement details are accepted as an array with a regex or string to search for, the
 * replacement string or function, and an optional scope of 'one' or 'all'. Uses the XRegExp
 * replacement text syntax, which supports named backreference properties via `${name}` or
 * `$<name>`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} replacements Array of replacement detail arrays.
 * @returns {String} New string with all replacements.
 * @example
 *
 * str = XRegExp.replaceEach(str, [
 *   [XRegExp('(?<name>a)'), 'z${name}'],
 *   [/b/gi, 'y'],
 *   [/c/g, 'x', 'one'], // scope 'one' overrides /g
 *   [/d/, 'w', 'all'],  // scope 'all' overrides lack of /g
 *   ['e', 'v', 'all'],  // scope 'all' allows replace-all for strings
 *   [/f/g, ($0) => $0.toUpperCase()]
 * ]);
 */
XRegExp.replaceEach = function (str, replacements) {
    var i = void 0;
    var r = void 0;

    for (i = 0; i < replacements.length; ++i) {
        r = replacements[i];
        str = XRegExp.replace(str, r[0], r[1], r[2]);
    }

    return str;
};

/**
 * Splits a string into an array of strings using a regex or string separator. Matches of the
 * separator are not included in the result array. However, if `separator` is a regex that contains
 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
 * cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to split.
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 * @example
 *
 * // Basic use
 * XRegExp.split('a b c', ' ');
 * // -> ['a', 'b', 'c']
 *
 * // With limit
 * XRegExp.split('a b c', ' ', 2);
 * // -> ['a', 'b']
 *
 * // Backreferences in result array
 * XRegExp.split('..word1..', /([a-z]+)(\d+)/i);
 * // -> ['..', 'word', '1', '..']
 */
XRegExp.split = function (str, separator, limit) {
    return fixed.split.call(toObject(str), separator, limit);
};

/**
 * Executes a regex search in a specified string. Returns `true` or `false`. Optional `pos` and
 * `sticky` arguments specify the search start position, and whether the match must start at the
 * specified position only. The `lastIndex` property of the provided regex is not used, but is
 * updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.test` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Boolean} Whether the regex matched the provided value.
 * @example
 *
 * // Basic use
 * XRegExp.test('abc', /c/); // -> true
 *
 * // With pos and sticky
 * XRegExp.test('abc', /c/, 0, 'sticky'); // -> false
 * XRegExp.test('abc', /c/, 2, 'sticky'); // -> true
 */
// Do this the easy way :-)
XRegExp.test = function (str, regex, pos, sticky) {
    return !!XRegExp.exec(str, regex, pos, sticky);
};

/**
 * Uninstalls optional features according to the specified options. All optional features start out
 * uninstalled, so this is used to undo the actions of `XRegExp.install`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.uninstall({
 *   // Disables support for astral code points in Unicode addons
 *   astral: true
 * });
 *
 * // With an options string
 * XRegExp.uninstall('astral');
 */
XRegExp.uninstall = function (options) {
    options = prepareOptions(options);

    if (features.astral && options.astral) {
        setAstral(false);
    }
};

/**
 * Returns an XRegExp object that is the union of the given patterns. Patterns can be provided as
 * regex objects or strings. Metacharacters are escaped in patterns provided as strings.
 * Backreferences in provided regex objects are automatically renumbered to work correctly within
 * the larger combined pattern. Native flags used by provided regexes are ignored in favor of the
 * `flags` argument.
 *
 * @memberOf XRegExp
 * @param {Array} patterns Regexes and strings to combine.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @param {Object} [options] Options object with optional properties:
 *   - `conjunction` {String} Type of conjunction to use: 'or' (default) or 'none'.
 * @returns {RegExp} Union of the provided regexes and strings.
 * @example
 *
 * XRegExp.union(['a+b*c', /(dogs)\1/, /(cats)\1/], 'i');
 * // -> /a\+b\*c|(dogs)\1|(cats)\2/i
 *
 * XRegExp.union([/man/, /bear/, /pig/], 'i', {conjunction: 'none'});
 * // -> /manbearpig/i
 */
XRegExp.union = function (patterns, flags, options) {
    options = options || {};
    var conjunction = options.conjunction || 'or';
    var numCaptures = 0;
    var numPriorCaptures = void 0;
    var captureNames = void 0;

    function rewrite(match, paren, backref) {
        var name = captureNames[numCaptures - numPriorCaptures];

        // Capturing group
        if (paren) {
            ++numCaptures;
            // If the current capture has a name, preserve the name
            if (name) {
                return '(?<' + name + '>';
            }
            // Backreference
        } else if (backref) {
            // Rewrite the backreference
            return '\\' + (+backref + numPriorCaptures);
        }

        return match;
    }

    if (!(isType(patterns, 'Array') && patterns.length)) {
        throw new TypeError('Must provide a nonempty array of patterns to merge');
    }

    var parts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
    var output = [];
    var pattern = void 0;
    for (var i = 0; i < patterns.length; ++i) {
        pattern = patterns[i];

        if (XRegExp.isRegExp(pattern)) {
            numPriorCaptures = numCaptures;
            captureNames = pattern[REGEX_DATA] && pattern[REGEX_DATA].captureNames || [];

            // Rewrite backreferences. Passing to XRegExp dies on octals and ensures patterns are
            // independently valid; helps keep this simple. Named captures are put back
            output.push(nativ.replace.call(XRegExp(pattern.source).source, parts, rewrite));
        } else {
            output.push(XRegExp.escape(pattern));
        }
    }

    var separator = conjunction === 'none' ? '' : '|';
    return XRegExp(output.join(separator), flags);
};

// ==--------------------------==
// Fixed/extended native methods
// ==--------------------------==

/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `RegExp.prototype.exec`. Use via `XRegExp.exec`.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {Array} Match array with named backreference properties, or `null`.
 */
fixed.exec = function (str) {
    var origLastIndex = this.lastIndex;
    var match = nativ.exec.apply(this, arguments);

    if (match) {
        // Fix browsers whose `exec` methods don't return `undefined` for nonparticipating capturing
        // groups. This fixes IE 5.5-8, but not IE 9's quirks mode or emulation of older IEs. IE 9
        // in standards mode follows the spec.
        if (!correctExecNpcg && match.length > 1 && match.indexOf('') !== -1) {
            var r2 = copyRegex(this, {
                removeG: true,
                isInternalOnly: true
            });
            // Using `str.slice(match.index)` rather than `match[0]` in case lookahead allowed
            // matching due to characters outside the match
            nativ.replace.call(String(str).slice(match.index), r2, function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                var len = args.length;
                // Skip index 0 and the last 2
                for (var i = 1; i < len - 2; ++i) {
                    if (args[i] === undefined) {
                        match[i] = undefined;
                    }
                }
            });
        }

        // Attach named capture properties
        if (this[REGEX_DATA] && this[REGEX_DATA].captureNames) {
            // Skip index 0
            for (var i = 1; i < match.length; ++i) {
                var name = this[REGEX_DATA].captureNames[i - 1];
                if (name) {
                    match[name] = match[i];
                }
            }
        }

        // Fix browsers that increment `lastIndex` after zero-length matches
        if (this.global && !match[0].length && this.lastIndex > match.index) {
            this.lastIndex = match.index;
        }
    }

    if (!this.global) {
        // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
        this.lastIndex = origLastIndex;
    }

    return match;
};

/**
 * Fixes browser bugs in the native `RegExp.prototype.test`.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {Boolean} Whether the regex matched the provided value.
 */
fixed.test = function (str) {
    // Do this the easy way :-)
    return !!fixed.exec.call(this, str);
};

/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `String.prototype.match`.
 *
 * @memberOf String
 * @param {RegExp|*} regex Regex to search with. If not a regex object, it is passed to `RegExp`.
 * @returns {Array} If `regex` uses flag g, an array of match strings or `null`. Without flag g,
 *   the result of calling `regex.exec(this)`.
 */
fixed.match = function (regex) {
    if (!XRegExp.isRegExp(regex)) {
        // Use the native `RegExp` rather than `XRegExp`
        regex = new RegExp(regex);
    } else if (regex.global) {
        var result = nativ.match.apply(this, arguments);
        // Fixes IE bug
        regex.lastIndex = 0;

        return result;
    }

    return fixed.exec.call(regex, toObject(this));
};

/**
 * Adds support for `${n}` (or `$<n>`) tokens for named and numbered backreferences in replacement
 * text, and provides named backreferences to replacement functions as `arguments[0].name`. Also
 * fixes browser bugs in replacement text syntax when performing a replacement using a nonregex
 * search value, and the value of a replacement regex's `lastIndex` property during replacement
 * iterations and upon completion. Note that this doesn't support SpiderMonkey's proprietary third
 * (`flags`) argument. Use via `XRegExp.replace`.
 *
 * @memberOf String
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 * @returns {String} New string with one or all matches replaced.
 */
fixed.replace = function (search, replacement) {
    var isRegex = XRegExp.isRegExp(search);
    var origLastIndex = void 0;
    var captureNames = void 0;
    var result = void 0;

    if (isRegex) {
        if (search[REGEX_DATA]) {
            captureNames = search[REGEX_DATA].captureNames;
        }
        // Only needed if `search` is nonglobal
        origLastIndex = search.lastIndex;
    } else {
        search += ''; // Type-convert
    }

    // Don't use `typeof`; some older browsers return 'function' for regex objects
    if (isType(replacement, 'Function')) {
        // Stringifying `this` fixes a bug in IE < 9 where the last argument in replacement
        // functions isn't type-converted to a string
        result = nativ.replace.call(String(this), search, function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            if (captureNames) {
                // Change the `args[0]` string primitive to a `String` object that can store
                // properties. This really does need to use `String` as a constructor
                args[0] = new String(args[0]);
                // Store named backreferences on the first argument
                for (var i = 0; i < captureNames.length; ++i) {
                    if (captureNames[i]) {
                        args[0][captureNames[i]] = args[i + 1];
                    }
                }
            }
            // Update `lastIndex` before calling `replacement`. Fixes IE, Chrome, Firefox, Safari
            // bug (last tested IE 9, Chrome 17, Firefox 11, Safari 5.1)
            if (isRegex && search.global) {
                search.lastIndex = args[args.length - 2] + args[0].length;
            }
            // ES6 specs the context for replacement functions as `undefined`
            return replacement.apply(undefined, args);
        });
    } else {
        // Ensure that the last value of `args` will be a string when given nonstring `this`,
        // while still throwing on null or undefined context
        result = nativ.replace.call(this == null ? this : String(this), search, function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            return nativ.replace.call(String(replacement), replacementToken, replacer);

            function replacer($0, bracketed, angled, dollarToken) {
                bracketed = bracketed || angled;
                // Named or numbered backreference with curly or angled braces
                if (bracketed) {
                    // XRegExp behavior for `${n}` or `$<n>`:
                    // 1. Backreference to numbered capture, if `n` is an integer. Use `0` for the
                    //    entire match. Any number of leading zeros may be used.
                    // 2. Backreference to named capture `n`, if it exists and is not an integer
                    //    overridden by numbered capture. In practice, this does not overlap with
                    //    numbered capture since XRegExp does not allow named capture to use a bare
                    //    integer as the name.
                    // 3. If the name or number does not refer to an existing capturing group, it's
                    //    an error.
                    var n = +bracketed; // Type-convert; drop leading zeros
                    if (n <= args.length - 3) {
                        return args[n] || '';
                    }
                    // Groups with the same name is an error, else would need `lastIndexOf`
                    n = captureNames ? captureNames.indexOf(bracketed) : -1;
                    if (n < 0) {
                        throw new SyntaxError('Backreference to undefined group ' + $0);
                    }
                    return args[n + 1] || '';
                }
                // Else, special variable or numbered backreference without curly braces
                if (dollarToken === '$') {
                    // $$
                    return '$';
                }
                if (dollarToken === '&' || +dollarToken === 0) {
                    // $&, $0 (not followed by 1-9), $00
                    return args[0];
                }
                if (dollarToken === '`') {
                    // $` (left context)
                    return args[args.length - 1].slice(0, args[args.length - 2]);
                }
                if (dollarToken === "'") {
                    // $' (right context)
                    return args[args.length - 1].slice(args[args.length - 2] + args[0].length);
                }
                // Else, numbered backreference without braces
                dollarToken = +dollarToken; // Type-convert; drop leading zero
                // XRegExp behavior for `$n` and `$nn`:
                // - Backrefs end after 1 or 2 digits. Use `${..}` or `$<..>` for more digits.
                // - `$1` is an error if no capturing groups.
                // - `$10` is an error if less than 10 capturing groups. Use `${1}0` or `$<1>0`
                //   instead.
                // - `$01` is `$1` if at least one capturing group, else it's an error.
                // - `$0` (not followed by 1-9) and `$00` are the entire match.
                // Native behavior, for comparison:
                // - Backrefs end after 1 or 2 digits. Cannot reference capturing group 100+.
                // - `$1` is a literal `$1` if no capturing groups.
                // - `$10` is `$1` followed by a literal `0` if less than 10 capturing groups.
                // - `$01` is `$1` if at least one capturing group, else it's a literal `$01`.
                // - `$0` is a literal `$0`.
                if (!isNaN(dollarToken)) {
                    if (dollarToken > args.length - 3) {
                        throw new SyntaxError('Backreference to undefined group ' + $0);
                    }
                    return args[dollarToken] || '';
                }
                // `$` followed by an unsupported char is an error, unlike native JS
                throw new SyntaxError('Invalid token ' + $0);
            }
        });
    }

    if (isRegex) {
        if (search.global) {
            // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
            search.lastIndex = 0;
        } else {
            // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
            search.lastIndex = origLastIndex;
        }
    }

    return result;
};

/**
 * Fixes browser bugs in the native `String.prototype.split`. Use via `XRegExp.split`.
 *
 * @memberOf String
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 */
fixed.split = function (separator, limit) {
    if (!XRegExp.isRegExp(separator)) {
        // Browsers handle nonregex split correctly, so use the faster native method
        return nativ.split.apply(this, arguments);
    }

    var str = String(this);
    var output = [];
    var origLastIndex = separator.lastIndex;
    var lastLastIndex = 0;
    var lastLength = void 0;

    // Values for `limit`, per the spec:
    // If undefined: pow(2,32) - 1
    // If 0, Infinity, or NaN: 0
    // If positive number: limit = floor(limit); if (limit >= pow(2,32)) limit -= pow(2,32);
    // If negative number: pow(2,32) - floor(abs(limit))
    // If other: Type-convert, then use the above rules
    // This line fails in very strange ways for some values of `limit` in Opera 10.5-10.63, unless
    // Opera Dragonfly is open (go figure). It works in at least Opera 9.5-10.1 and 11+
    limit = (limit === undefined ? -1 : limit) >>> 0;

    XRegExp.forEach(str, separator, function (match) {
        // This condition is not the same as `if (match[0].length)`
        if (match.index + match[0].length > lastLastIndex) {
            output.push(str.slice(lastLastIndex, match.index));
            if (match.length > 1 && match.index < str.length) {
                Array.prototype.push.apply(output, match.slice(1));
            }
            lastLength = match[0].length;
            lastLastIndex = match.index + lastLength;
        }
    });

    if (lastLastIndex === str.length) {
        if (!nativ.test.call(separator, '') || lastLength) {
            output.push('');
        }
    } else {
        output.push(str.slice(lastLastIndex));
    }

    separator.lastIndex = origLastIndex;
    return output.length > limit ? output.slice(0, limit) : output;
};

// ==--------------------------==
// Built-in syntax/flag tokens
// ==--------------------------==

/*
 * Letter escapes that natively match literal characters: `\a`, `\A`, etc. These should be
 * SyntaxErrors but are allowed in web reality. XRegExp makes them errors for cross-browser
 * consistency and to reserve their syntax, but lets them be superseded by addons.
 */
XRegExp.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/, function (match, scope) {
    // \B is allowed in default scope only
    if (match[1] === 'B' && scope === defaultScope) {
        return match[0];
    }
    throw new SyntaxError('Invalid escape ' + match[0]);
}, {
    scope: 'all',
    leadChar: '\\'
});

/*
 * Unicode code point escape with curly braces: `\u{N..}`. `N..` is any one or more digit
 * hexadecimal number from 0-10FFFF, and can include leading zeros. Requires the native ES6 `u` flag
 * to support code points greater than U+FFFF. Avoids converting code points above U+FFFF to
 * surrogate pairs (which could be done without flag `u`), since that could lead to broken behavior
 * if you follow a `\u{N..}` token that references a code point above U+FFFF with a quantifier, or
 * if you use the same in a character class.
 */
XRegExp.addToken(/\\u{([\dA-Fa-f]+)}/, function (match, scope, flags) {
    var code = dec(match[1]);
    if (code > 0x10FFFF) {
        throw new SyntaxError('Invalid Unicode code point ' + match[0]);
    }
    if (code <= 0xFFFF) {
        // Converting to \uNNNN avoids needing to escape the literal character and keep it
        // separate from preceding tokens
        return '\\u' + pad4(hex(code));
    }
    // If `code` is between 0xFFFF and 0x10FFFF, require and defer to native handling
    if (hasNativeU && flags.indexOf('u') !== -1) {
        return match[0];
    }
    throw new SyntaxError('Cannot use Unicode code point above \\u{FFFF} without flag u');
}, {
    scope: 'all',
    leadChar: '\\'
});

/*
 * Empty character class: `[]` or `[^]`. This fixes a critical cross-browser syntax inconsistency.
 * Unless this is standardized (per the ES spec), regex syntax can't be accurately parsed because
 * character class endings can't be determined.
 */
XRegExp.addToken(/\[(\^?)\]/,
// For cross-browser compatibility with ES3, convert [] to \b\B and [^] to [\s\S].
// (?!) should work like \b\B, but is unreliable in some versions of Firefox
/* eslint-disable no-confusing-arrow */
function (match) {
    return match[1] ? '[\\s\\S]' : '\\b\\B';
},
/* eslint-enable no-confusing-arrow */
{ leadChar: '[' });

/*
 * Comment pattern: `(?# )`. Inline comments are an alternative to the line comments allowed in
 * free-spacing mode (flag x).
 */
XRegExp.addToken(/\(\?#[^)]*\)/, getContextualTokenSeparator, { leadChar: '(' });

/*
 * Whitespace and line comments, in free-spacing mode (aka extended mode, flag x) only.
 */
XRegExp.addToken(/\s+|#[^\n]*\n?/, getContextualTokenSeparator, { flag: 'x' });

/*
 * Dot, in dotall mode (aka singleline mode, flag s) only.
 */
XRegExp.addToken(/\./, function () {
    return '[\\s\\S]';
}, {
    flag: 's',
    leadChar: '.'
});

/*
 * Named backreference: `\k<name>`. Backreference names can use the characters A-Z, a-z, 0-9, _,
 * and $ only. Also allows numbered backreferences as `\k<n>`.
 */
XRegExp.addToken(/\\k<([\w$]+)>/, function (match) {
    // Groups with the same name is an error, else would need `lastIndexOf`
    var index = isNaN(match[1]) ? this.captureNames.indexOf(match[1]) + 1 : +match[1];
    var endIndex = match.index + match[0].length;
    if (!index || index > this.captureNames.length) {
        throw new SyntaxError('Backreference to undefined group ' + match[0]);
    }
    // Keep backreferences separate from subsequent literal numbers. This avoids e.g.
    // inadvertedly changing `(?<n>)\k<n>1` to `()\11`.
    return '\\' + index + (endIndex === match.input.length || isNaN(match.input[endIndex]) ? '' : '(?:)');
}, { leadChar: '\\' });

/*
 * Numbered backreference or octal, plus any following digits: `\0`, `\11`, etc. Octals except `\0`
 * not followed by 0-9 and backreferences to unopened capture groups throw an error. Other matches
 * are returned unaltered. IE < 9 doesn't support backreferences above `\99` in regex syntax.
 */
XRegExp.addToken(/\\(\d+)/, function (match, scope) {
    if (!(scope === defaultScope && /^[1-9]/.test(match[1]) && +match[1] <= this.captureNames.length) && match[1] !== '0') {
        throw new SyntaxError('Cannot use octal escape or backreference to undefined group ' + match[0]);
    }
    return match[0];
}, {
    scope: 'all',
    leadChar: '\\'
});

/*
 * Named capturing group; match the opening delimiter only: `(?<name>`. Capture names can use the
 * characters A-Z, a-z, 0-9, _, and $ only. Names can't be integers. Supports Python-style
 * `(?P<name>` as an alternate syntax to avoid issues in some older versions of Opera which natively
 * supported the Python-style syntax. Otherwise, XRegExp might treat numbered backreferences to
 * Python-style named capture as octals.
 */
XRegExp.addToken(/\(\?P?<([\w$]+)>/, function (match) {
    // Disallow bare integers as names because named backreferences are added to match arrays
    // and therefore numeric properties may lead to incorrect lookups
    if (!isNaN(match[1])) {
        throw new SyntaxError('Cannot use integer as capture name ' + match[0]);
    }
    if (match[1] === 'length' || match[1] === '__proto__') {
        throw new SyntaxError('Cannot use reserved word as capture name ' + match[0]);
    }
    if (this.captureNames.indexOf(match[1]) !== -1) {
        throw new SyntaxError('Cannot use same name for multiple groups ' + match[0]);
    }
    this.captureNames.push(match[1]);
    this.hasNamedCapture = true;
    return '(';
}, { leadChar: '(' });

/*
 * Capturing group; match the opening parenthesis only. Required for support of named capturing
 * groups. Also adds explicit capture mode (flag n).
 */
XRegExp.addToken(/\((?!\?)/, function (match, scope, flags) {
    if (flags.indexOf('n') !== -1) {
        return '(?:';
    }
    this.captureNames.push(null);
    return '(';
}, {
    optionalFlags: 'n',
    leadChar: '('
});

exports.default = XRegExp;
module.exports = exports['default'];

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp.build 4.0.0
 * <xregexp.com>
 * Steven Levithan (c) 2012-2017 MIT License
 */

exports.default = function (XRegExp) {
    var REGEX_DATA = 'xregexp';
    var subParts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
    var parts = XRegExp.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, subParts], 'g', {
        conjunction: 'or'
    });

    /**
     * Strips a leading `^` and trailing unescaped `$`, if both are present.
     *
     * @private
     * @param {String} pattern Pattern to process.
     * @returns {String} Pattern with edge anchors removed.
     */
    function deanchor(pattern) {
        // Allow any number of empty noncapturing groups before/after anchors, because regexes
        // built/generated by XRegExp sometimes include them
        var leadingAnchor = /^(?:\(\?:\))*\^/;
        var trailingAnchor = /\$(?:\(\?:\))*$/;

        if (leadingAnchor.test(pattern) && trailingAnchor.test(pattern) &&
        // Ensure that the trailing `$` isn't escaped
        trailingAnchor.test(pattern.replace(/\\[\s\S]/g, ''))) {
            return pattern.replace(leadingAnchor, '').replace(trailingAnchor, '');
        }

        return pattern;
    }

    /**
     * Converts the provided value to an XRegExp. Native RegExp flags are not preserved.
     *
     * @private
     * @param {String|RegExp} value Value to convert.
     * @param {Boolean} [addFlagX] Whether to apply the `x` flag in cases when `value` is not
     *   already a regex generated by XRegExp
     * @returns {RegExp} XRegExp object with XRegExp syntax applied.
     */
    function asXRegExp(value, addFlagX) {
        var flags = addFlagX ? 'x' : '';
        return XRegExp.isRegExp(value) ? value[REGEX_DATA] && value[REGEX_DATA].captureNames ?
        // Don't recompile, to preserve capture names
        value :
        // Recompile as XRegExp
        XRegExp(value.source, flags) :
        // Compile string as XRegExp
        XRegExp(value, flags);
    }

    function interpolate(substitution) {
        return substitution instanceof RegExp ? substitution : XRegExp.escape(substitution);
    }

    function reduceToSubpatternsObject(subpatterns, interpolated, subpatternIndex) {
        subpatterns['subpattern' + subpatternIndex] = interpolated;
        return subpatterns;
    }

    function embedSubpatternAfter(raw, subpatternIndex, rawLiterals) {
        var hasSubpattern = subpatternIndex < rawLiterals.length - 1;
        return raw + (hasSubpattern ? '{{subpattern' + subpatternIndex + '}}' : '');
    }

    /**
     * Provides tagged template literals that create regexes with XRegExp syntax and flags. The
     * provided pattern is handled as a raw string, so backslashes don't need to be escaped.
     *
     * Interpolation of strings and regexes shares the features of `XRegExp.build`. Interpolated
     * patterns are treated as atomic units when quantified, interpolated strings have their special
     * characters escaped, a leading `^` and trailing unescaped `$` are stripped from interpolated
     * regexes if both are present, and any backreferences within an interpolated regex are
     * rewritten to work within the overall pattern.
     *
     * @memberOf XRegExp
     * @param {String} [flags] Any combination of XRegExp flags.
     * @returns {Function} Handler for template literals that construct regexes with XRegExp syntax.
     * @example
     *
     * const h12 = /1[0-2]|0?[1-9]/;
     * const h24 = /2[0-3]|[01][0-9]/;
     * const hours = XRegExp.tag('x')`${h12} : | ${h24}`;
     * const minutes = /^[0-5][0-9]$/;
     * // Note that explicitly naming the 'minutes' group is required for named backreferences
     * const time = XRegExp.tag('x')`^ ${hours} (?<minutes>${minutes}) $`;
     * time.test('10:59'); // -> true
     * XRegExp.exec('10:59', time).minutes; // -> '59'
     */
    XRegExp.tag = function (flags) {
        return function (literals) {
            for (var _len = arguments.length, substitutions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                substitutions[_key - 1] = arguments[_key];
            }

            var subpatterns = substitutions.map(interpolate).reduce(reduceToSubpatternsObject, {});
            var pattern = literals.raw.map(embedSubpatternAfter).join('');
            return XRegExp.build(pattern, subpatterns, flags);
        };
    };

    /**
     * Builds regexes using named subpatterns, for readability and pattern reuse. Backreferences in
     * the outer pattern and provided subpatterns are automatically renumbered to work correctly.
     * Native flags used by provided subpatterns are ignored in favor of the `flags` argument.
     *
     * @memberOf XRegExp
     * @param {String} pattern XRegExp pattern using `{{name}}` for embedded subpatterns. Allows
     *   `({{name}})` as shorthand for `(?<name>{{name}})`. Patterns cannot be embedded within
     *   character classes.
     * @param {Object} subs Lookup object for named subpatterns. Values can be strings or regexes. A
     *   leading `^` and trailing unescaped `$` are stripped from subpatterns, if both are present.
     * @param {String} [flags] Any combination of XRegExp flags.
     * @returns {RegExp} Regex with interpolated subpatterns.
     * @example
     *
     * const time = XRegExp.build('(?x)^ {{hours}} ({{minutes}}) $', {
     *   hours: XRegExp.build('{{h12}} : | {{h24}}', {
     *     h12: /1[0-2]|0?[1-9]/,
     *     h24: /2[0-3]|[01][0-9]/
     *   }, 'x'),
     *   minutes: /^[0-5][0-9]$/
     * });
     * time.test('10:59'); // -> true
     * XRegExp.exec('10:59', time).minutes; // -> '59'
     */
    XRegExp.build = function (pattern, subs, flags) {
        flags = flags || '';
        // Used with `asXRegExp` calls for `pattern` and subpatterns in `subs`, to work around how
        // some browsers convert `RegExp('\n')` to a regex that contains the literal characters `\`
        // and `n`. See more details at <https://github.com/slevithan/xregexp/pull/163>.
        var addFlagX = flags.indexOf('x') !== -1;
        var inlineFlags = /^\(\?([\w$]+)\)/.exec(pattern);
        // Add flags within a leading mode modifier to the overall pattern's flags
        if (inlineFlags) {
            flags = XRegExp._clipDuplicates(flags + inlineFlags[1]);
        }

        var data = {};
        for (var p in subs) {
            if (subs.hasOwnProperty(p)) {
                // Passing to XRegExp enables extended syntax and ensures independent validity,
                // lest an unescaped `(`, `)`, `[`, or trailing `\` breaks the `(?:)` wrapper. For
                // subpatterns provided as native regexes, it dies on octals and adds the property
                // used to hold extended regex instance data, for simplicity.
                var sub = asXRegExp(subs[p], addFlagX);
                data[p] = {
                    // Deanchoring allows embedding independently useful anchored regexes. If you
                    // really need to keep your anchors, double them (i.e., `^^...$$`).
                    pattern: deanchor(sub.source),
                    names: sub[REGEX_DATA].captureNames || []
                };
            }
        }

        // Passing to XRegExp dies on octals and ensures the outer pattern is independently valid;
        // helps keep this simple. Named captures will be put back.
        var patternAsRegex = asXRegExp(pattern, addFlagX);

        // 'Caps' is short for 'captures'
        var numCaps = 0;
        var numPriorCaps = void 0;
        var numOuterCaps = 0;
        var outerCapsMap = [0];
        var outerCapNames = patternAsRegex[REGEX_DATA].captureNames || [];
        var output = patternAsRegex.source.replace(parts, function ($0, $1, $2, $3, $4) {
            var subName = $1 || $2;
            var capName = void 0;
            var intro = void 0;
            var localCapIndex = void 0;
            // Named subpattern
            if (subName) {
                if (!data.hasOwnProperty(subName)) {
                    throw new ReferenceError('Undefined property ' + $0);
                }
                // Named subpattern was wrapped in a capturing group
                if ($1) {
                    capName = outerCapNames[numOuterCaps];
                    outerCapsMap[++numOuterCaps] = ++numCaps;
                    // If it's a named group, preserve the name. Otherwise, use the subpattern name
                    // as the capture name
                    intro = '(?<' + (capName || subName) + '>';
                } else {
                    intro = '(?:';
                }
                numPriorCaps = numCaps;
                var rewrittenSubpattern = data[subName].pattern.replace(subParts, function (match, paren, backref) {
                    // Capturing group
                    if (paren) {
                        capName = data[subName].names[numCaps - numPriorCaps];
                        ++numCaps;
                        // If the current capture has a name, preserve the name
                        if (capName) {
                            return '(?<' + capName + '>';
                        }
                        // Backreference
                    } else if (backref) {
                        localCapIndex = +backref - 1;
                        // Rewrite the backreference
                        return data[subName].names[localCapIndex] ?
                        // Need to preserve the backreference name in case using flag `n`
                        '\\k<' + data[subName].names[localCapIndex] + '>' : '\\' + (+backref + numPriorCaps);
                    }
                    return match;
                });
                return '' + intro + rewrittenSubpattern + ')';
            }
            // Capturing group
            if ($3) {
                capName = outerCapNames[numOuterCaps];
                outerCapsMap[++numOuterCaps] = ++numCaps;
                // If the current capture has a name, preserve the name
                if (capName) {
                    return '(?<' + capName + '>';
                }
                // Backreference
            } else if ($4) {
                localCapIndex = +$4 - 1;
                // Rewrite the backreference
                return outerCapNames[localCapIndex] ?
                // Need to preserve the backreference name in case using flag `n`
                '\\k<' + outerCapNames[localCapIndex] + '>' : '\\' + outerCapsMap[+$4];
            }
            return $0;
        });

        return XRegExp(output, flags);
    };
};

module.exports = exports['default'];

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp.matchRecursive 4.0.0
 * <xregexp.com>
 * Steven Levithan (c) 2009-2017 MIT License
 */

exports.default = function (XRegExp) {

    /**
     * Returns a match detail object composed of the provided values.
     *
     * @private
     */
    function row(name, value, start, end) {
        return {
            name: name,
            value: value,
            start: start,
            end: end
        };
    }

    /**
     * Returns an array of match strings between outermost left and right delimiters, or an array of
     * objects with detailed match parts and position data. An error is thrown if delimiters are
     * unbalanced within the data.
     *
     * @memberOf XRegExp
     * @param {String} str String to search.
     * @param {String} left Left delimiter as an XRegExp pattern.
     * @param {String} right Right delimiter as an XRegExp pattern.
     * @param {String} [flags] Any native or XRegExp flags, used for the left and right delimiters.
     * @param {Object} [options] Lets you specify `valueNames` and `escapeChar` options.
     * @returns {Array} Array of matches, or an empty array.
     * @example
     *
     * // Basic usage
     * let str = '(t((e))s)t()(ing)';
     * XRegExp.matchRecursive(str, '\\(', '\\)', 'g');
     * // -> ['t((e))s', '', 'ing']
     *
     * // Extended information mode with valueNames
     * str = 'Here is <div> <div>an</div></div> example';
     * XRegExp.matchRecursive(str, '<div\\s*>', '</div>', 'gi', {
     *   valueNames: ['between', 'left', 'match', 'right']
     * });
     * // -> [
     * // {name: 'between', value: 'Here is ',       start: 0,  end: 8},
     * // {name: 'left',    value: '<div>',          start: 8,  end: 13},
     * // {name: 'match',   value: ' <div>an</div>', start: 13, end: 27},
     * // {name: 'right',   value: '</div>',         start: 27, end: 33},
     * // {name: 'between', value: ' example',       start: 33, end: 41}
     * // ]
     *
     * // Omitting unneeded parts with null valueNames, and using escapeChar
     * str = '...{1}.\\{{function(x,y){return {y:x}}}';
     * XRegExp.matchRecursive(str, '{', '}', 'g', {
     *   valueNames: ['literal', null, 'value', null],
     *   escapeChar: '\\'
     * });
     * // -> [
     * // {name: 'literal', value: '...',  start: 0, end: 3},
     * // {name: 'value',   value: '1',    start: 4, end: 5},
     * // {name: 'literal', value: '.\\{', start: 6, end: 9},
     * // {name: 'value',   value: 'function(x,y){return {y:x}}', start: 10, end: 37}
     * // ]
     *
     * // Sticky mode via flag y
     * str = '<1><<<2>>><3>4<5>';
     * XRegExp.matchRecursive(str, '<', '>', 'gy');
     * // -> ['1', '<<2>>', '3']
     */
    XRegExp.matchRecursive = function (str, left, right, flags, options) {
        flags = flags || '';
        options = options || {};
        var global = flags.indexOf('g') !== -1;
        var sticky = flags.indexOf('y') !== -1;
        // Flag `y` is controlled internally
        var basicFlags = flags.replace(/y/g, '');
        var escapeChar = options.escapeChar;
        var vN = options.valueNames;
        var output = [];
        var openTokens = 0;
        var delimStart = 0;
        var delimEnd = 0;
        var lastOuterEnd = 0;
        var outerStart = void 0;
        var innerStart = void 0;
        var leftMatch = void 0;
        var rightMatch = void 0;
        var esc = void 0;
        left = XRegExp(left, basicFlags);
        right = XRegExp(right, basicFlags);

        if (escapeChar) {
            if (escapeChar.length > 1) {
                throw new Error('Cannot use more than one escape character');
            }
            escapeChar = XRegExp.escape(escapeChar);
            // Example of concatenated `esc` regex:
            // `escapeChar`: '%'
            // `left`: '<'
            // `right`: '>'
            // Regex is: /(?:%[\S\s]|(?:(?!<|>)[^%])+)+/
            esc = new RegExp('(?:' + escapeChar + '[\\S\\s]|(?:(?!' +
            // Using `XRegExp.union` safely rewrites backreferences in `left` and `right`.
            // Intentionally not passing `basicFlags` to `XRegExp.union` since any syntax
            // transformation resulting from those flags was already applied to `left` and
            // `right` when they were passed through the XRegExp constructor above.
            XRegExp.union([left, right], '', { conjunction: 'or' }).source + ')[^' + escapeChar + '])+)+',
            // Flags `gy` not needed here
            flags.replace(/[^imu]+/g, ''));
        }

        while (true) {
            // If using an escape character, advance to the delimiter's next starting position,
            // skipping any escaped characters in between
            if (escapeChar) {
                delimEnd += (XRegExp.exec(str, esc, delimEnd, 'sticky') || [''])[0].length;
            }
            leftMatch = XRegExp.exec(str, left, delimEnd);
            rightMatch = XRegExp.exec(str, right, delimEnd);
            // Keep the leftmost match only
            if (leftMatch && rightMatch) {
                if (leftMatch.index <= rightMatch.index) {
                    rightMatch = null;
                } else {
                    leftMatch = null;
                }
            }
            // Paths (LM: leftMatch, RM: rightMatch, OT: openTokens):
            // LM | RM | OT | Result
            // 1  | 0  | 1  | loop
            // 1  | 0  | 0  | loop
            // 0  | 1  | 1  | loop
            // 0  | 1  | 0  | throw
            // 0  | 0  | 1  | throw
            // 0  | 0  | 0  | break
            // The paths above don't include the sticky mode special case. The loop ends after the
            // first completed match if not `global`.
            if (leftMatch || rightMatch) {
                delimStart = (leftMatch || rightMatch).index;
                delimEnd = delimStart + (leftMatch || rightMatch)[0].length;
            } else if (!openTokens) {
                break;
            }
            if (sticky && !openTokens && delimStart > lastOuterEnd) {
                break;
            }
            if (leftMatch) {
                if (!openTokens) {
                    outerStart = delimStart;
                    innerStart = delimEnd;
                }
                ++openTokens;
            } else if (rightMatch && openTokens) {
                if (! --openTokens) {
                    if (vN) {
                        if (vN[0] && outerStart > lastOuterEnd) {
                            output.push(row(vN[0], str.slice(lastOuterEnd, outerStart), lastOuterEnd, outerStart));
                        }
                        if (vN[1]) {
                            output.push(row(vN[1], str.slice(outerStart, innerStart), outerStart, innerStart));
                        }
                        if (vN[2]) {
                            output.push(row(vN[2], str.slice(innerStart, delimStart), innerStart, delimStart));
                        }
                        if (vN[3]) {
                            output.push(row(vN[3], str.slice(delimStart, delimEnd), delimStart, delimEnd));
                        }
                    } else {
                        output.push(str.slice(innerStart, delimStart));
                    }
                    lastOuterEnd = delimEnd;
                    if (!global) {
                        break;
                    }
                }
            } else {
                throw new Error('Unbalanced delimiter found in string');
            }
            // If the delimiter matched an empty string, avoid an infinite loop
            if (delimStart === delimEnd) {
                ++delimEnd;
            }
        }

        if (global && !sticky && vN && vN[0] && str.length > lastOuterEnd) {
            output.push(row(vN[0], str.slice(lastOuterEnd), lastOuterEnd, str.length));
        }

        return output;
    };
};

module.exports = exports['default'];

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp Unicode Base 4.0.0
 * <xregexp.com>
 * Steven Levithan (c) 2008-2017 MIT License
 */

exports.default = function (XRegExp) {

    /**
     * Adds base support for Unicode matching:
     * - Adds syntax `\p{..}` for matching Unicode tokens. Tokens can be inverted using `\P{..}` or
     *   `\p{^..}`. Token names ignore case, spaces, hyphens, and underscores. You can omit the
     *   braces for token names that are a single letter (e.g. `\pL` or `PL`).
     * - Adds flag A (astral), which enables 21-bit Unicode support.
     * - Adds the `XRegExp.addUnicodeData` method used by other addons to provide character data.
     *
     * Unicode Base relies on externally provided Unicode character data. Official addons are
     * available to provide data for Unicode categories, scripts, blocks, and properties.
     *
     * @requires XRegExp
     */

    // ==--------------------------==
    // Private stuff
    // ==--------------------------==

    // Storage for Unicode data
    var unicode = {};

    // Reuse utils
    var dec = XRegExp._dec;
    var hex = XRegExp._hex;
    var pad4 = XRegExp._pad4;

    // Generates a token lookup name: lowercase, with hyphens, spaces, and underscores removed
    function normalize(name) {
        return name.replace(/[- _]+/g, '').toLowerCase();
    }

    // Gets the decimal code of a literal code unit, \xHH, \uHHHH, or a backslash-escaped literal
    function charCode(chr) {
        var esc = /^\\[xu](.+)/.exec(chr);
        return esc ? dec(esc[1]) : chr.charCodeAt(chr[0] === '\\' ? 1 : 0);
    }

    // Inverts a list of ordered BMP characters and ranges
    function invertBmp(range) {
        var output = '';
        var lastEnd = -1;

        XRegExp.forEach(range, /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/, function (m) {
            var start = charCode(m[1]);
            if (start > lastEnd + 1) {
                output += '\\u' + pad4(hex(lastEnd + 1));
                if (start > lastEnd + 2) {
                    output += '-\\u' + pad4(hex(start - 1));
                }
            }
            lastEnd = charCode(m[2] || m[1]);
        });

        if (lastEnd < 0xFFFF) {
            output += '\\u' + pad4(hex(lastEnd + 1));
            if (lastEnd < 0xFFFE) {
                output += '-\\uFFFF';
            }
        }

        return output;
    }

    // Generates an inverted BMP range on first use
    function cacheInvertedBmp(slug) {
        var prop = 'b!';
        return unicode[slug][prop] || (unicode[slug][prop] = invertBmp(unicode[slug].bmp));
    }

    // Combines and optionally negates BMP and astral data
    function buildAstral(slug, isNegated) {
        var item = unicode[slug];
        var combined = '';

        if (item.bmp && !item.isBmpLast) {
            combined = '[' + item.bmp + ']' + (item.astral ? '|' : '');
        }
        if (item.astral) {
            combined += item.astral;
        }
        if (item.isBmpLast && item.bmp) {
            combined += (item.astral ? '|' : '') + '[' + item.bmp + ']';
        }

        // Astral Unicode tokens always match a code point, never a code unit
        return isNegated ? '(?:(?!' + combined + ')(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-\uFFFF]))' : '(?:' + combined + ')';
    }

    // Builds a complete astral pattern on first use
    function cacheAstral(slug, isNegated) {
        var prop = isNegated ? 'a!' : 'a=';
        return unicode[slug][prop] || (unicode[slug][prop] = buildAstral(slug, isNegated));
    }

    // ==--------------------------==
    // Core functionality
    // ==--------------------------==

    /*
     * Add astral mode (flag A) and Unicode token syntax: `\p{..}`, `\P{..}`, `\p{^..}`, `\pC`.
     */
    XRegExp.addToken(
    // Use `*` instead of `+` to avoid capturing `^` as the token name in `\p{^}`
    /\\([pP])(?:{(\^?)([^}]*)}|([A-Za-z]))/, function (match, scope, flags) {
        var ERR_DOUBLE_NEG = 'Invalid double negation ';
        var ERR_UNKNOWN_NAME = 'Unknown Unicode token ';
        var ERR_UNKNOWN_REF = 'Unicode token missing data ';
        var ERR_ASTRAL_ONLY = 'Astral mode required for Unicode token ';
        var ERR_ASTRAL_IN_CLASS = 'Astral mode does not support Unicode tokens within character classes';
        // Negated via \P{..} or \p{^..}
        var isNegated = match[1] === 'P' || !!match[2];
        // Switch from BMP (0-FFFF) to astral (0-10FFFF) mode via flag A
        var isAstralMode = flags.indexOf('A') !== -1;
        // Token lookup name. Check `[4]` first to avoid passing `undefined` via `\p{}`
        var slug = normalize(match[4] || match[3]);
        // Token data object
        var item = unicode[slug];

        if (match[1] === 'P' && match[2]) {
            throw new SyntaxError(ERR_DOUBLE_NEG + match[0]);
        }
        if (!unicode.hasOwnProperty(slug)) {
            throw new SyntaxError(ERR_UNKNOWN_NAME + match[0]);
        }

        // Switch to the negated form of the referenced Unicode token
        if (item.inverseOf) {
            slug = normalize(item.inverseOf);
            if (!unicode.hasOwnProperty(slug)) {
                throw new ReferenceError(ERR_UNKNOWN_REF + match[0] + ' -> ' + item.inverseOf);
            }
            item = unicode[slug];
            isNegated = !isNegated;
        }

        if (!(item.bmp || isAstralMode)) {
            throw new SyntaxError(ERR_ASTRAL_ONLY + match[0]);
        }
        if (isAstralMode) {
            if (scope === 'class') {
                throw new SyntaxError(ERR_ASTRAL_IN_CLASS);
            }

            return cacheAstral(slug, isNegated);
        }

        return scope === 'class' ? isNegated ? cacheInvertedBmp(slug) : item.bmp : (isNegated ? '[^' : '[') + item.bmp + ']';
    }, {
        scope: 'all',
        optionalFlags: 'A',
        leadChar: '\\'
    });

    /**
     * Adds to the list of Unicode tokens that XRegExp regexes can match via `\p` or `\P`.
     *
     * @memberOf XRegExp
     * @param {Array} data Objects with named character ranges. Each object may have properties
     *   `name`, `alias`, `isBmpLast`, `inverseOf`, `bmp`, and `astral`. All but `name` are
     *   optional, although one of `bmp` or `astral` is required (unless `inverseOf` is set). If
     *   `astral` is absent, the `bmp` data is used for BMP and astral modes. If `bmp` is absent,
     *   the name errors in BMP mode but works in astral mode. If both `bmp` and `astral` are
     *   provided, the `bmp` data only is used in BMP mode, and the combination of `bmp` and
     *   `astral` data is used in astral mode. `isBmpLast` is needed when a token matches orphan
     *   high surrogates *and* uses surrogate pairs to match astral code points. The `bmp` and
     *   `astral` data should be a combination of literal characters and `\xHH` or `\uHHHH` escape
     *   sequences, with hyphens to create ranges. Any regex metacharacters in the data should be
     *   escaped, apart from range-creating hyphens. The `astral` data can additionally use
     *   character classes and alternation, and should use surrogate pairs to represent astral code
     *   points. `inverseOf` can be used to avoid duplicating character data if a Unicode token is
     *   defined as the exact inverse of another token.
     * @example
     *
     * // Basic use
     * XRegExp.addUnicodeData([{
     *   name: 'XDigit',
     *   alias: 'Hexadecimal',
     *   bmp: '0-9A-Fa-f'
     * }]);
     * XRegExp('\\p{XDigit}:\\p{Hexadecimal}+').test('0:3D'); // -> true
     */
    XRegExp.addUnicodeData = function (data) {
        var ERR_NO_NAME = 'Unicode token requires name';
        var ERR_NO_DATA = 'Unicode token has no character data ';
        var item = void 0;

        for (var i = 0; i < data.length; ++i) {
            item = data[i];
            if (!item.name) {
                throw new Error(ERR_NO_NAME);
            }
            if (!(item.inverseOf || item.bmp || item.astral)) {
                throw new Error(ERR_NO_DATA + item.name);
            }
            unicode[normalize(item.name)] = item;
            if (item.alias) {
                unicode[normalize(item.alias)] = item;
            }
        }

        // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and
        // flags might now produce different results
        XRegExp.cache.flush('patterns');
    };

    /**
     * @ignore
     *
     * Return a reference to the internal Unicode definition structure for the given Unicode
     * Property if the given name is a legal Unicode Property for use in XRegExp `\p` or `\P` regex
     * constructs.
     *
     * @memberOf XRegExp
     * @param {String} name Name by which the Unicode Property may be recognized (case-insensitive),
     *   e.g. `'N'` or `'Number'`. The given name is matched against all registered Unicode
     *   Properties and Property Aliases.
     * @returns {Object} Reference to definition structure when the name matches a Unicode Property.
     *
     * @note
     * For more info on Unicode Properties, see also http://unicode.org/reports/tr18/#Categories.
     *
     * @note
     * This method is *not* part of the officially documented API and may change or be removed in
     * the future. It is meant for userland code that wishes to reuse the (large) internal Unicode
     * structures set up by XRegExp.
     */
    XRegExp._getUnicodeProperty = function (name) {
        var slug = normalize(name);
        return unicode[slug];
    };
};

module.exports = exports['default'];

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp Unicode Blocks 4.0.0
 * <xregexp.com>
 * Steven Levithan (c) 2010-2017 MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */

exports.default = function (XRegExp) {

    /**
     * Adds support for all Unicode blocks. Block names use the prefix 'In'. E.g.,
     * `\p{InBasicLatin}`. Token names are case insensitive, and any spaces, hyphens, and
     * underscores are ignored.
     *
     * Uses Unicode 9.0.0.
     *
     * @requires XRegExp, Unicode Base
     */

    if (!XRegExp.addUnicodeData) {
        throw new ReferenceError('Unicode Base must be loaded before Unicode Blocks');
    }

    XRegExp.addUnicodeData([{
        name: 'InAdlam',
        astral: '\uD83A[\uDD00-\uDD5F]'
    }, {
        name: 'InAegean_Numbers',
        astral: '\uD800[\uDD00-\uDD3F]'
    }, {
        name: 'InAhom',
        astral: '\uD805[\uDF00-\uDF3F]'
    }, {
        name: 'InAlchemical_Symbols',
        astral: '\uD83D[\uDF00-\uDF7F]'
    }, {
        name: 'InAlphabetic_Presentation_Forms',
        bmp: '\uFB00-\uFB4F'
    }, {
        name: 'InAnatolian_Hieroglyphs',
        astral: '\uD811[\uDC00-\uDE7F]'
    }, {
        name: 'InAncient_Greek_Musical_Notation',
        astral: '\uD834[\uDE00-\uDE4F]'
    }, {
        name: 'InAncient_Greek_Numbers',
        astral: '\uD800[\uDD40-\uDD8F]'
    }, {
        name: 'InAncient_Symbols',
        astral: '\uD800[\uDD90-\uDDCF]'
    }, {
        name: 'InArabic',
        bmp: '\u0600-\u06FF'
    }, {
        name: 'InArabic_Extended_A',
        bmp: '\u08A0-\u08FF'
    }, {
        name: 'InArabic_Mathematical_Alphabetic_Symbols',
        astral: '\uD83B[\uDE00-\uDEFF]'
    }, {
        name: 'InArabic_Presentation_Forms_A',
        bmp: '\uFB50-\uFDFF'
    }, {
        name: 'InArabic_Presentation_Forms_B',
        bmp: '\uFE70-\uFEFF'
    }, {
        name: 'InArabic_Supplement',
        bmp: '\u0750-\u077F'
    }, {
        name: 'InArmenian',
        bmp: '\u0530-\u058F'
    }, {
        name: 'InArrows',
        bmp: '\u2190-\u21FF'
    }, {
        name: 'InAvestan',
        astral: '\uD802[\uDF00-\uDF3F]'
    }, {
        name: 'InBalinese',
        bmp: '\u1B00-\u1B7F'
    }, {
        name: 'InBamum',
        bmp: '\uA6A0-\uA6FF'
    }, {
        name: 'InBamum_Supplement',
        astral: '\uD81A[\uDC00-\uDE3F]'
    }, {
        name: 'InBasic_Latin',
        bmp: '\0-\x7F'
    }, {
        name: 'InBassa_Vah',
        astral: '\uD81A[\uDED0-\uDEFF]'
    }, {
        name: 'InBatak',
        bmp: '\u1BC0-\u1BFF'
    }, {
        name: 'InBengali',
        bmp: '\u0980-\u09FF'
    }, {
        name: 'InBhaiksuki',
        astral: '\uD807[\uDC00-\uDC6F]'
    }, {
        name: 'InBlock_Elements',
        bmp: '\u2580-\u259F'
    }, {
        name: 'InBopomofo',
        bmp: '\u3100-\u312F'
    }, {
        name: 'InBopomofo_Extended',
        bmp: '\u31A0-\u31BF'
    }, {
        name: 'InBox_Drawing',
        bmp: '\u2500-\u257F'
    }, {
        name: 'InBrahmi',
        astral: '\uD804[\uDC00-\uDC7F]'
    }, {
        name: 'InBraille_Patterns',
        bmp: '\u2800-\u28FF'
    }, {
        name: 'InBuginese',
        bmp: '\u1A00-\u1A1F'
    }, {
        name: 'InBuhid',
        bmp: '\u1740-\u175F'
    }, {
        name: 'InByzantine_Musical_Symbols',
        astral: '\uD834[\uDC00-\uDCFF]'
    }, {
        name: 'InCJK_Compatibility',
        bmp: '\u3300-\u33FF'
    }, {
        name: 'InCJK_Compatibility_Forms',
        bmp: '\uFE30-\uFE4F'
    }, {
        name: 'InCJK_Compatibility_Ideographs',
        bmp: '\uF900-\uFAFF'
    }, {
        name: 'InCJK_Compatibility_Ideographs_Supplement',
        astral: '\uD87E[\uDC00-\uDE1F]'
    }, {
        name: 'InCJK_Radicals_Supplement',
        bmp: '\u2E80-\u2EFF'
    }, {
        name: 'InCJK_Strokes',
        bmp: '\u31C0-\u31EF'
    }, {
        name: 'InCJK_Symbols_and_Punctuation',
        bmp: '\u3000-\u303F'
    }, {
        name: 'InCJK_Unified_Ideographs',
        bmp: '\u4E00-\u9FFF'
    }, {
        name: 'InCJK_Unified_Ideographs_Extension_A',
        bmp: '\u3400-\u4DBF'
    }, {
        name: 'InCJK_Unified_Ideographs_Extension_B',
        astral: '[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]'
    }, {
        name: 'InCJK_Unified_Ideographs_Extension_C',
        astral: '\uD869[\uDF00-\uDFFF]|[\uD86A-\uD86C][\uDC00-\uDFFF]|\uD86D[\uDC00-\uDF3F]'
    }, {
        name: 'InCJK_Unified_Ideographs_Extension_D',
        astral: '\uD86D[\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1F]'
    }, {
        name: 'InCJK_Unified_Ideographs_Extension_E',
        astral: '\uD86E[\uDC20-\uDFFF]|[\uD86F-\uD872][\uDC00-\uDFFF]|\uD873[\uDC00-\uDEAF]'
    }, {
        name: 'InCarian',
        astral: '\uD800[\uDEA0-\uDEDF]'
    }, {
        name: 'InCaucasian_Albanian',
        astral: '\uD801[\uDD30-\uDD6F]'
    }, {
        name: 'InChakma',
        astral: '\uD804[\uDD00-\uDD4F]'
    }, {
        name: 'InCham',
        bmp: '\uAA00-\uAA5F'
    }, {
        name: 'InCherokee',
        bmp: '\u13A0-\u13FF'
    }, {
        name: 'InCherokee_Supplement',
        bmp: '\uAB70-\uABBF'
    }, {
        name: 'InCombining_Diacritical_Marks',
        bmp: '\u0300-\u036F'
    }, {
        name: 'InCombining_Diacritical_Marks_Extended',
        bmp: '\u1AB0-\u1AFF'
    }, {
        name: 'InCombining_Diacritical_Marks_Supplement',
        bmp: '\u1DC0-\u1DFF'
    }, {
        name: 'InCombining_Diacritical_Marks_for_Symbols',
        bmp: '\u20D0-\u20FF'
    }, {
        name: 'InCombining_Half_Marks',
        bmp: '\uFE20-\uFE2F'
    }, {
        name: 'InCommon_Indic_Number_Forms',
        bmp: '\uA830-\uA83F'
    }, {
        name: 'InControl_Pictures',
        bmp: '\u2400-\u243F'
    }, {
        name: 'InCoptic',
        bmp: '\u2C80-\u2CFF'
    }, {
        name: 'InCoptic_Epact_Numbers',
        astral: '\uD800[\uDEE0-\uDEFF]'
    }, {
        name: 'InCounting_Rod_Numerals',
        astral: '\uD834[\uDF60-\uDF7F]'
    }, {
        name: 'InCuneiform',
        astral: '\uD808[\uDC00-\uDFFF]'
    }, {
        name: 'InCuneiform_Numbers_and_Punctuation',
        astral: '\uD809[\uDC00-\uDC7F]'
    }, {
        name: 'InCurrency_Symbols',
        bmp: '\u20A0-\u20CF'
    }, {
        name: 'InCypriot_Syllabary',
        astral: '\uD802[\uDC00-\uDC3F]'
    }, {
        name: 'InCyrillic',
        bmp: '\u0400-\u04FF'
    }, {
        name: 'InCyrillic_Extended_A',
        bmp: '\u2DE0-\u2DFF'
    }, {
        name: 'InCyrillic_Extended_B',
        bmp: '\uA640-\uA69F'
    }, {
        name: 'InCyrillic_Extended_C',
        bmp: '\u1C80-\u1C8F'
    }, {
        name: 'InCyrillic_Supplement',
        bmp: '\u0500-\u052F'
    }, {
        name: 'InDeseret',
        astral: '\uD801[\uDC00-\uDC4F]'
    }, {
        name: 'InDevanagari',
        bmp: '\u0900-\u097F'
    }, {
        name: 'InDevanagari_Extended',
        bmp: '\uA8E0-\uA8FF'
    }, {
        name: 'InDingbats',
        bmp: '\u2700-\u27BF'
    }, {
        name: 'InDomino_Tiles',
        astral: '\uD83C[\uDC30-\uDC9F]'
    }, {
        name: 'InDuployan',
        astral: '\uD82F[\uDC00-\uDC9F]'
    }, {
        name: 'InEarly_Dynastic_Cuneiform',
        astral: '\uD809[\uDC80-\uDD4F]'
    }, {
        name: 'InEgyptian_Hieroglyphs',
        astral: '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F]'
    }, {
        name: 'InElbasan',
        astral: '\uD801[\uDD00-\uDD2F]'
    }, {
        name: 'InEmoticons',
        astral: '\uD83D[\uDE00-\uDE4F]'
    }, {
        name: 'InEnclosed_Alphanumeric_Supplement',
        astral: '\uD83C[\uDD00-\uDDFF]'
    }, {
        name: 'InEnclosed_Alphanumerics',
        bmp: '\u2460-\u24FF'
    }, {
        name: 'InEnclosed_CJK_Letters_and_Months',
        bmp: '\u3200-\u32FF'
    }, {
        name: 'InEnclosed_Ideographic_Supplement',
        astral: '\uD83C[\uDE00-\uDEFF]'
    }, {
        name: 'InEthiopic',
        bmp: '\u1200-\u137F'
    }, {
        name: 'InEthiopic_Extended',
        bmp: '\u2D80-\u2DDF'
    }, {
        name: 'InEthiopic_Extended_A',
        bmp: '\uAB00-\uAB2F'
    }, {
        name: 'InEthiopic_Supplement',
        bmp: '\u1380-\u139F'
    }, {
        name: 'InGeneral_Punctuation',
        bmp: '\u2000-\u206F'
    }, {
        name: 'InGeometric_Shapes',
        bmp: '\u25A0-\u25FF'
    }, {
        name: 'InGeometric_Shapes_Extended',
        astral: '\uD83D[\uDF80-\uDFFF]'
    }, {
        name: 'InGeorgian',
        bmp: '\u10A0-\u10FF'
    }, {
        name: 'InGeorgian_Supplement',
        bmp: '\u2D00-\u2D2F'
    }, {
        name: 'InGlagolitic',
        bmp: '\u2C00-\u2C5F'
    }, {
        name: 'InGlagolitic_Supplement',
        astral: '\uD838[\uDC00-\uDC2F]'
    }, {
        name: 'InGothic',
        astral: '\uD800[\uDF30-\uDF4F]'
    }, {
        name: 'InGrantha',
        astral: '\uD804[\uDF00-\uDF7F]'
    }, {
        name: 'InGreek_Extended',
        bmp: '\u1F00-\u1FFF'
    }, {
        name: 'InGreek_and_Coptic',
        bmp: '\u0370-\u03FF'
    }, {
        name: 'InGujarati',
        bmp: '\u0A80-\u0AFF'
    }, {
        name: 'InGurmukhi',
        bmp: '\u0A00-\u0A7F'
    }, {
        name: 'InHalfwidth_and_Fullwidth_Forms',
        bmp: '\uFF00-\uFFEF'
    }, {
        name: 'InHangul_Compatibility_Jamo',
        bmp: '\u3130-\u318F'
    }, {
        name: 'InHangul_Jamo',
        bmp: '\u1100-\u11FF'
    }, {
        name: 'InHangul_Jamo_Extended_A',
        bmp: '\uA960-\uA97F'
    }, {
        name: 'InHangul_Jamo_Extended_B',
        bmp: '\uD7B0-\uD7FF'
    }, {
        name: 'InHangul_Syllables',
        bmp: '\uAC00-\uD7AF'
    }, {
        name: 'InHanunoo',
        bmp: '\u1720-\u173F'
    }, {
        name: 'InHatran',
        astral: '\uD802[\uDCE0-\uDCFF]'
    }, {
        name: 'InHebrew',
        bmp: '\u0590-\u05FF'
    }, {
        name: 'InHigh_Private_Use_Surrogates',
        bmp: '\uDB80-\uDBFF'
    }, {
        name: 'InHigh_Surrogates',
        bmp: '\uD800-\uDB7F'
    }, {
        name: 'InHiragana',
        bmp: '\u3040-\u309F'
    }, {
        name: 'InIPA_Extensions',
        bmp: '\u0250-\u02AF'
    }, {
        name: 'InIdeographic_Description_Characters',
        bmp: '\u2FF0-\u2FFF'
    }, {
        name: 'InIdeographic_Symbols_and_Punctuation',
        astral: '\uD81B[\uDFE0-\uDFFF]'
    }, {
        name: 'InImperial_Aramaic',
        astral: '\uD802[\uDC40-\uDC5F]'
    }, {
        name: 'InInscriptional_Pahlavi',
        astral: '\uD802[\uDF60-\uDF7F]'
    }, {
        name: 'InInscriptional_Parthian',
        astral: '\uD802[\uDF40-\uDF5F]'
    }, {
        name: 'InJavanese',
        bmp: '\uA980-\uA9DF'
    }, {
        name: 'InKaithi',
        astral: '\uD804[\uDC80-\uDCCF]'
    }, {
        name: 'InKana_Supplement',
        astral: '\uD82C[\uDC00-\uDCFF]'
    }, {
        name: 'InKanbun',
        bmp: '\u3190-\u319F'
    }, {
        name: 'InKangxi_Radicals',
        bmp: '\u2F00-\u2FDF'
    }, {
        name: 'InKannada',
        bmp: '\u0C80-\u0CFF'
    }, {
        name: 'InKatakana',
        bmp: '\u30A0-\u30FF'
    }, {
        name: 'InKatakana_Phonetic_Extensions',
        bmp: '\u31F0-\u31FF'
    }, {
        name: 'InKayah_Li',
        bmp: '\uA900-\uA92F'
    }, {
        name: 'InKharoshthi',
        astral: '\uD802[\uDE00-\uDE5F]'
    }, {
        name: 'InKhmer',
        bmp: '\u1780-\u17FF'
    }, {
        name: 'InKhmer_Symbols',
        bmp: '\u19E0-\u19FF'
    }, {
        name: 'InKhojki',
        astral: '\uD804[\uDE00-\uDE4F]'
    }, {
        name: 'InKhudawadi',
        astral: '\uD804[\uDEB0-\uDEFF]'
    }, {
        name: 'InLao',
        bmp: '\u0E80-\u0EFF'
    }, {
        name: 'InLatin_Extended_Additional',
        bmp: '\u1E00-\u1EFF'
    }, {
        name: 'InLatin_Extended_A',
        bmp: '\u0100-\u017F'
    }, {
        name: 'InLatin_Extended_B',
        bmp: '\u0180-\u024F'
    }, {
        name: 'InLatin_Extended_C',
        bmp: '\u2C60-\u2C7F'
    }, {
        name: 'InLatin_Extended_D',
        bmp: '\uA720-\uA7FF'
    }, {
        name: 'InLatin_Extended_E',
        bmp: '\uAB30-\uAB6F'
    }, {
        name: 'InLatin_1_Supplement',
        bmp: '\x80-\xFF'
    }, {
        name: 'InLepcha',
        bmp: '\u1C00-\u1C4F'
    }, {
        name: 'InLetterlike_Symbols',
        bmp: '\u2100-\u214F'
    }, {
        name: 'InLimbu',
        bmp: '\u1900-\u194F'
    }, {
        name: 'InLinear_A',
        astral: '\uD801[\uDE00-\uDF7F]'
    }, {
        name: 'InLinear_B_Ideograms',
        astral: '\uD800[\uDC80-\uDCFF]'
    }, {
        name: 'InLinear_B_Syllabary',
        astral: '\uD800[\uDC00-\uDC7F]'
    }, {
        name: 'InLisu',
        bmp: '\uA4D0-\uA4FF'
    }, {
        name: 'InLow_Surrogates',
        bmp: '\uDC00-\uDFFF'
    }, {
        name: 'InLycian',
        astral: '\uD800[\uDE80-\uDE9F]'
    }, {
        name: 'InLydian',
        astral: '\uD802[\uDD20-\uDD3F]'
    }, {
        name: 'InMahajani',
        astral: '\uD804[\uDD50-\uDD7F]'
    }, {
        name: 'InMahjong_Tiles',
        astral: '\uD83C[\uDC00-\uDC2F]'
    }, {
        name: 'InMalayalam',
        bmp: '\u0D00-\u0D7F'
    }, {
        name: 'InMandaic',
        bmp: '\u0840-\u085F'
    }, {
        name: 'InManichaean',
        astral: '\uD802[\uDEC0-\uDEFF]'
    }, {
        name: 'InMarchen',
        astral: '\uD807[\uDC70-\uDCBF]'
    }, {
        name: 'InMathematical_Alphanumeric_Symbols',
        astral: '\uD835[\uDC00-\uDFFF]'
    }, {
        name: 'InMathematical_Operators',
        bmp: '\u2200-\u22FF'
    }, {
        name: 'InMeetei_Mayek',
        bmp: '\uABC0-\uABFF'
    }, {
        name: 'InMeetei_Mayek_Extensions',
        bmp: '\uAAE0-\uAAFF'
    }, {
        name: 'InMende_Kikakui',
        astral: '\uD83A[\uDC00-\uDCDF]'
    }, {
        name: 'InMeroitic_Cursive',
        astral: '\uD802[\uDDA0-\uDDFF]'
    }, {
        name: 'InMeroitic_Hieroglyphs',
        astral: '\uD802[\uDD80-\uDD9F]'
    }, {
        name: 'InMiao',
        astral: '\uD81B[\uDF00-\uDF9F]'
    }, {
        name: 'InMiscellaneous_Mathematical_Symbols_A',
        bmp: '\u27C0-\u27EF'
    }, {
        name: 'InMiscellaneous_Mathematical_Symbols_B',
        bmp: '\u2980-\u29FF'
    }, {
        name: 'InMiscellaneous_Symbols',
        bmp: '\u2600-\u26FF'
    }, {
        name: 'InMiscellaneous_Symbols_and_Arrows',
        bmp: '\u2B00-\u2BFF'
    }, {
        name: 'InMiscellaneous_Symbols_and_Pictographs',
        astral: '\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF]'
    }, {
        name: 'InMiscellaneous_Technical',
        bmp: '\u2300-\u23FF'
    }, {
        name: 'InModi',
        astral: '\uD805[\uDE00-\uDE5F]'
    }, {
        name: 'InModifier_Tone_Letters',
        bmp: '\uA700-\uA71F'
    }, {
        name: 'InMongolian',
        bmp: '\u1800-\u18AF'
    }, {
        name: 'InMongolian_Supplement',
        astral: '\uD805[\uDE60-\uDE7F]'
    }, {
        name: 'InMro',
        astral: '\uD81A[\uDE40-\uDE6F]'
    }, {
        name: 'InMultani',
        astral: '\uD804[\uDE80-\uDEAF]'
    }, {
        name: 'InMusical_Symbols',
        astral: '\uD834[\uDD00-\uDDFF]'
    }, {
        name: 'InMyanmar',
        bmp: '\u1000-\u109F'
    }, {
        name: 'InMyanmar_Extended_A',
        bmp: '\uAA60-\uAA7F'
    }, {
        name: 'InMyanmar_Extended_B',
        bmp: '\uA9E0-\uA9FF'
    }, {
        name: 'InNKo',
        bmp: '\u07C0-\u07FF'
    }, {
        name: 'InNabataean',
        astral: '\uD802[\uDC80-\uDCAF]'
    }, {
        name: 'InNew_Tai_Lue',
        bmp: '\u1980-\u19DF'
    }, {
        name: 'InNewa',
        astral: '\uD805[\uDC00-\uDC7F]'
    }, {
        name: 'InNumber_Forms',
        bmp: '\u2150-\u218F'
    }, {
        name: 'InOgham',
        bmp: '\u1680-\u169F'
    }, {
        name: 'InOl_Chiki',
        bmp: '\u1C50-\u1C7F'
    }, {
        name: 'InOld_Hungarian',
        astral: '\uD803[\uDC80-\uDCFF]'
    }, {
        name: 'InOld_Italic',
        astral: '\uD800[\uDF00-\uDF2F]'
    }, {
        name: 'InOld_North_Arabian',
        astral: '\uD802[\uDE80-\uDE9F]'
    }, {
        name: 'InOld_Permic',
        astral: '\uD800[\uDF50-\uDF7F]'
    }, {
        name: 'InOld_Persian',
        astral: '\uD800[\uDFA0-\uDFDF]'
    }, {
        name: 'InOld_South_Arabian',
        astral: '\uD802[\uDE60-\uDE7F]'
    }, {
        name: 'InOld_Turkic',
        astral: '\uD803[\uDC00-\uDC4F]'
    }, {
        name: 'InOptical_Character_Recognition',
        bmp: '\u2440-\u245F'
    }, {
        name: 'InOriya',
        bmp: '\u0B00-\u0B7F'
    }, {
        name: 'InOrnamental_Dingbats',
        astral: '\uD83D[\uDE50-\uDE7F]'
    }, {
        name: 'InOsage',
        astral: '\uD801[\uDCB0-\uDCFF]'
    }, {
        name: 'InOsmanya',
        astral: '\uD801[\uDC80-\uDCAF]'
    }, {
        name: 'InPahawh_Hmong',
        astral: '\uD81A[\uDF00-\uDF8F]'
    }, {
        name: 'InPalmyrene',
        astral: '\uD802[\uDC60-\uDC7F]'
    }, {
        name: 'InPau_Cin_Hau',
        astral: '\uD806[\uDEC0-\uDEFF]'
    }, {
        name: 'InPhags_pa',
        bmp: '\uA840-\uA87F'
    }, {
        name: 'InPhaistos_Disc',
        astral: '\uD800[\uDDD0-\uDDFF]'
    }, {
        name: 'InPhoenician',
        astral: '\uD802[\uDD00-\uDD1F]'
    }, {
        name: 'InPhonetic_Extensions',
        bmp: '\u1D00-\u1D7F'
    }, {
        name: 'InPhonetic_Extensions_Supplement',
        bmp: '\u1D80-\u1DBF'
    }, {
        name: 'InPlaying_Cards',
        astral: '\uD83C[\uDCA0-\uDCFF]'
    }, {
        name: 'InPrivate_Use_Area',
        bmp: '\uE000-\uF8FF'
    }, {
        name: 'InPsalter_Pahlavi',
        astral: '\uD802[\uDF80-\uDFAF]'
    }, {
        name: 'InRejang',
        bmp: '\uA930-\uA95F'
    }, {
        name: 'InRumi_Numeral_Symbols',
        astral: '\uD803[\uDE60-\uDE7F]'
    }, {
        name: 'InRunic',
        bmp: '\u16A0-\u16FF'
    }, {
        name: 'InSamaritan',
        bmp: '\u0800-\u083F'
    }, {
        name: 'InSaurashtra',
        bmp: '\uA880-\uA8DF'
    }, {
        name: 'InSharada',
        astral: '\uD804[\uDD80-\uDDDF]'
    }, {
        name: 'InShavian',
        astral: '\uD801[\uDC50-\uDC7F]'
    }, {
        name: 'InShorthand_Format_Controls',
        astral: '\uD82F[\uDCA0-\uDCAF]'
    }, {
        name: 'InSiddham',
        astral: '\uD805[\uDD80-\uDDFF]'
    }, {
        name: 'InSinhala',
        bmp: '\u0D80-\u0DFF'
    }, {
        name: 'InSinhala_Archaic_Numbers',
        astral: '\uD804[\uDDE0-\uDDFF]'
    }, {
        name: 'InSmall_Form_Variants',
        bmp: '\uFE50-\uFE6F'
    }, {
        name: 'InSora_Sompeng',
        astral: '\uD804[\uDCD0-\uDCFF]'
    }, {
        name: 'InSpacing_Modifier_Letters',
        bmp: '\u02B0-\u02FF'
    }, {
        name: 'InSpecials',
        bmp: '\uFFF0-\uFFFF'
    }, {
        name: 'InSundanese',
        bmp: '\u1B80-\u1BBF'
    }, {
        name: 'InSundanese_Supplement',
        bmp: '\u1CC0-\u1CCF'
    }, {
        name: 'InSuperscripts_and_Subscripts',
        bmp: '\u2070-\u209F'
    }, {
        name: 'InSupplemental_Arrows_A',
        bmp: '\u27F0-\u27FF'
    }, {
        name: 'InSupplemental_Arrows_B',
        bmp: '\u2900-\u297F'
    }, {
        name: 'InSupplemental_Arrows_C',
        astral: '\uD83E[\uDC00-\uDCFF]'
    }, {
        name: 'InSupplemental_Mathematical_Operators',
        bmp: '\u2A00-\u2AFF'
    }, {
        name: 'InSupplemental_Punctuation',
        bmp: '\u2E00-\u2E7F'
    }, {
        name: 'InSupplemental_Symbols_and_Pictographs',
        astral: '\uD83E[\uDD00-\uDDFF]'
    }, {
        name: 'InSupplementary_Private_Use_Area_A',
        astral: '[\uDB80-\uDBBF][\uDC00-\uDFFF]'
    }, {
        name: 'InSupplementary_Private_Use_Area_B',
        astral: '[\uDBC0-\uDBFF][\uDC00-\uDFFF]'
    }, {
        name: 'InSutton_SignWriting',
        astral: '\uD836[\uDC00-\uDEAF]'
    }, {
        name: 'InSyloti_Nagri',
        bmp: '\uA800-\uA82F'
    }, {
        name: 'InSyriac',
        bmp: '\u0700-\u074F'
    }, {
        name: 'InTagalog',
        bmp: '\u1700-\u171F'
    }, {
        name: 'InTagbanwa',
        bmp: '\u1760-\u177F'
    }, {
        name: 'InTags',
        astral: '\uDB40[\uDC00-\uDC7F]'
    }, {
        name: 'InTai_Le',
        bmp: '\u1950-\u197F'
    }, {
        name: 'InTai_Tham',
        bmp: '\u1A20-\u1AAF'
    }, {
        name: 'InTai_Viet',
        bmp: '\uAA80-\uAADF'
    }, {
        name: 'InTai_Xuan_Jing_Symbols',
        astral: '\uD834[\uDF00-\uDF5F]'
    }, {
        name: 'InTakri',
        astral: '\uD805[\uDE80-\uDECF]'
    }, {
        name: 'InTamil',
        bmp: '\u0B80-\u0BFF'
    }, {
        name: 'InTangut',
        astral: '[\uD81C-\uD821][\uDC00-\uDFFF]'
    }, {
        name: 'InTangut_Components',
        astral: '\uD822[\uDC00-\uDEFF]'
    }, {
        name: 'InTelugu',
        bmp: '\u0C00-\u0C7F'
    }, {
        name: 'InThaana',
        bmp: '\u0780-\u07BF'
    }, {
        name: 'InThai',
        bmp: '\u0E00-\u0E7F'
    }, {
        name: 'InTibetan',
        bmp: '\u0F00-\u0FFF'
    }, {
        name: 'InTifinagh',
        bmp: '\u2D30-\u2D7F'
    }, {
        name: 'InTirhuta',
        astral: '\uD805[\uDC80-\uDCDF]'
    }, {
        name: 'InTransport_and_Map_Symbols',
        astral: '\uD83D[\uDE80-\uDEFF]'
    }, {
        name: 'InUgaritic',
        astral: '\uD800[\uDF80-\uDF9F]'
    }, {
        name: 'InUnified_Canadian_Aboriginal_Syllabics',
        bmp: '\u1400-\u167F'
    }, {
        name: 'InUnified_Canadian_Aboriginal_Syllabics_Extended',
        bmp: '\u18B0-\u18FF'
    }, {
        name: 'InVai',
        bmp: '\uA500-\uA63F'
    }, {
        name: 'InVariation_Selectors',
        bmp: '\uFE00-\uFE0F'
    }, {
        name: 'InVariation_Selectors_Supplement',
        astral: '\uDB40[\uDD00-\uDDEF]'
    }, {
        name: 'InVedic_Extensions',
        bmp: '\u1CD0-\u1CFF'
    }, {
        name: 'InVertical_Forms',
        bmp: '\uFE10-\uFE1F'
    }, {
        name: 'InWarang_Citi',
        astral: '\uD806[\uDCA0-\uDCFF]'
    }, {
        name: 'InYi_Radicals',
        bmp: '\uA490-\uA4CF'
    }, {
        name: 'InYi_Syllables',
        bmp: '\uA000-\uA48F'
    }, {
        name: 'InYijing_Hexagram_Symbols',
        bmp: '\u4DC0-\u4DFF'
    }]);
};

module.exports = exports['default'];

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp Unicode Categories 4.0.0
 * <xregexp.com>
 * Steven Levithan (c) 2010-2017 MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */

exports.default = function (XRegExp) {

    /**
     * Adds support for Unicode's general categories. E.g., `\p{Lu}` or `\p{Uppercase Letter}`. See
     * category descriptions in UAX #44 <http://unicode.org/reports/tr44/#GC_Values_Table>. Token
     * names are case insensitive, and any spaces, hyphens, and underscores are ignored.
     *
     * Uses Unicode 9.0.0.
     *
     * @requires XRegExp, Unicode Base
     */

    if (!XRegExp.addUnicodeData) {
        throw new ReferenceError('Unicode Base must be loaded before Unicode Categories');
    }

    XRegExp.addUnicodeData([{
        name: 'C',
        alias: 'Other',
        isBmpLast: true,
        bmp: '\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5\u08BE-\u08D3\u08E2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180E\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E45-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF',
        astral: '\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCBD\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5A\uDC5C\uDC5E-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD823-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFDF\uDFE1-\uDFFF]|\uD821[\uDFED-\uDFFF]|\uD822[\uDEF3-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4B-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDDAD-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD83D[\uDED3-\uDEDF\uDEED-\uDEEF\uDEF7-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD1F\uDD28-\uDD2F\uDD31\uDD32\uDD3F\uDD4C-\uDD4F\uDD5F-\uDD7F\uDD92-\uDDBF\uDDC1-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]'
    }, {
        name: 'Cc',
        alias: 'Control',
        bmp: '\0-\x1F\x7F-\x9F'
    }, {
        name: 'Cf',
        alias: 'Format',
        bmp: '\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB',
        astral: '\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]'
    }, {
        name: 'Cn',
        alias: 'Unassigned',
        bmp: '\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u05FF\u061D\u070E\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5\u08BE-\u08D3\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u2065\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E45-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD\uFEFE\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFF8\uFFFE\uFFFF',
        astral: '\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5A\uDC5C\uDC5E-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD823-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFDF\uDFE1-\uDFFF]|\uD821[\uDFED-\uDFFF]|\uD822[\uDEF3-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4B-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDDAD-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD83D[\uDED3-\uDEDF\uDEED-\uDEEF\uDEF7-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD1F\uDD28-\uDD2F\uDD31\uDD32\uDD3F\uDD4C-\uDD4F\uDD5F-\uDD7F\uDD92-\uDDBF\uDDC1-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]'
    }, {
        name: 'Co',
        alias: 'Private_Use',
        bmp: '\uE000-\uF8FF',
        astral: '[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]'
    }, {
        name: 'Cs',
        alias: 'Surrogate',
        bmp: '\uD800-\uDFFF'
    }, {
        name: 'L',
        alias: 'Letter',
        bmp: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
        astral: '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]'
    }, {
        name: 'Ll',
        alias: 'Lowercase_Letter',
        bmp: 'a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
        astral: '\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]'
    }, {
        name: 'Lm',
        alias: 'Modifier_Letter',
        bmp: '\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F',
        astral: '\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0]'
    }, {
        name: 'Lo',
        alias: 'Other_Letter',
        bmp: '\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
        astral: '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]'
    }, {
        name: 'Lt',
        alias: 'Titlecase_Letter',
        bmp: '\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC'
    }, {
        name: 'Lu',
        alias: 'Uppercase_Letter',
        bmp: 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A',
        astral: '\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]'
    }, {
        name: 'M',
        alias: 'Mark',
        bmp: '\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
        astral: '\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC7F-\uDC82\uDCB0-\uDCBA\uDD00-\uDD02\uDD27-\uDD34\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDCA-\uDDCC\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF51-\uDF7E\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]'
    }, {
        name: 'Mc',
        alias: 'Spacing_Mark',
        bmp: '\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BE-\u09C0\u09C7\u09C8\u09CB\u09CC\u09D7\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B3E\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0B57\u0BBE\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD7\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0-\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0CD5\u0CD6\u0D02\u0D03\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D57\u0D82\u0D83\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DF2\u0DF3\u0F3E\u0F3F\u0F7F\u102B\u102C\u1031\u1038\u103B\u103C\u1056\u1057\u1062-\u1064\u1067-\u106D\u1083\u1084\u1087-\u108C\u108F\u109A-\u109C\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A61\u1A63\u1A64\u1A6D-\u1A72\u1B04\u1B35\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF2\u1CF3\u302E\u302F\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BD-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAA7B\uAA7D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC',
        astral: '\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4]|\uD81B[\uDF51-\uDF7E]|\uD834[\uDD65\uDD66\uDD6D-\uDD72]'
    }, {
        name: 'Me',
        alias: 'Enclosing_Mark',
        bmp: '\u0488\u0489\u1ABE\u20DD-\u20E0\u20E2-\u20E4\uA670-\uA672'
    }, {
        name: 'Mn',
        alias: 'Nonspacing_Mark',
        bmp: '\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D01\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
        astral: '\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDCA-\uDDCC\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]'
    }, {
        name: 'N',
        alias: 'Number',
        bmp: '0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
        astral: '\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2]|\uD807[\uDC50-\uDC6C]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83C[\uDD00-\uDD0C]'
    }, {
        name: 'Nd',
        alias: 'Decimal_Number',
        bmp: '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
        astral: '\uD801[\uDCA0-\uDCA9]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9]|\uD807[\uDC50-\uDC59]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDD50-\uDD59]'
    }, {
        name: 'Nl',
        alias: 'Letter_Number',
        bmp: '\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF',
        astral: '\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]'
    }, {
        name: 'No',
        alias: 'Other_Number',
        bmp: '\xB2\xB3\xB9\xBC-\xBE\u09F4-\u09F9\u0B72-\u0B77\u0BF0-\u0BF2\u0C78-\u0C7E\u0D58-\u0D5E\u0D70-\u0D78\u0F2A-\u0F33\u1369-\u137C\u17F0-\u17F9\u19DA\u2070\u2074-\u2079\u2080-\u2089\u2150-\u215F\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA830-\uA835',
        astral: '\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD805[\uDF3A\uDF3B]|\uD806[\uDCEA-\uDCF2]|\uD807[\uDC5A-\uDC6C]|\uD81A[\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD83A[\uDCC7-\uDCCF]|\uD83C[\uDD00-\uDD0C]'
    }, {
        name: 'P',
        alias: 'Punctuation',
        bmp: '\x21-\x23\x25-\\x2A\x2C-\x2F\x3A\x3B\\x3F\x40\\x5B-\\x5D\x5F\\x7B\x7D\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E44\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65',
        astral: '\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]'
    }, {
        name: 'Pc',
        alias: 'Connector_Punctuation',
        bmp: '\x5F\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F'
    }, {
        name: 'Pd',
        alias: 'Dash_Punctuation',
        bmp: '\\x2D\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D'
    }, {
        name: 'Pe',
        alias: 'Close_Punctuation',
        bmp: '\\x29\\x5D\x7D\u0F3B\u0F3D\u169C\u2046\u207E\u208E\u2309\u230B\u232A\u2769\u276B\u276D\u276F\u2771\u2773\u2775\u27C6\u27E7\u27E9\u27EB\u27ED\u27EF\u2984\u2986\u2988\u298A\u298C\u298E\u2990\u2992\u2994\u2996\u2998\u29D9\u29DB\u29FD\u2E23\u2E25\u2E27\u2E29\u3009\u300B\u300D\u300F\u3011\u3015\u3017\u3019\u301B\u301E\u301F\uFD3E\uFE18\uFE36\uFE38\uFE3A\uFE3C\uFE3E\uFE40\uFE42\uFE44\uFE48\uFE5A\uFE5C\uFE5E\uFF09\uFF3D\uFF5D\uFF60\uFF63'
    }, {
        name: 'Pf',
        alias: 'Final_Punctuation',
        bmp: '\xBB\u2019\u201D\u203A\u2E03\u2E05\u2E0A\u2E0D\u2E1D\u2E21'
    }, {
        name: 'Pi',
        alias: 'Initial_Punctuation',
        bmp: '\xAB\u2018\u201B\u201C\u201F\u2039\u2E02\u2E04\u2E09\u2E0C\u2E1C\u2E20'
    }, {
        name: 'Po',
        alias: 'Other_Punctuation',
        bmp: '\x21-\x23\x25-\x27\\x2A\x2C\\x2E\x2F\x3A\x3B\\x3F\x40\\x5C\xA1\xA7\xB6\xB7\xBF\u037E\u0387\u055A-\u055F\u0589\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u166D\u166E\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u1805\u1807-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2016\u2017\u2020-\u2027\u2030-\u2038\u203B-\u203E\u2041-\u2043\u2047-\u2051\u2053\u2055-\u205E\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00\u2E01\u2E06-\u2E08\u2E0B\u2E0E-\u2E16\u2E18\u2E19\u2E1B\u2E1E\u2E1F\u2E2A-\u2E2E\u2E30-\u2E39\u2E3C-\u2E3F\u2E41\u2E43\u2E44\u3001-\u3003\u303D\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFE10-\uFE16\uFE19\uFE30\uFE45\uFE46\uFE49-\uFE4C\uFE50-\uFE52\uFE54-\uFE57\uFE5F-\uFE61\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF07\uFF0A\uFF0C\uFF0E\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3C\uFF61\uFF64\uFF65',
        astral: '\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]'
    }, {
        name: 'Ps',
        alias: 'Open_Punctuation',
        bmp: '\\x28\\x5B\\x7B\u0F3A\u0F3C\u169B\u201A\u201E\u2045\u207D\u208D\u2308\u230A\u2329\u2768\u276A\u276C\u276E\u2770\u2772\u2774\u27C5\u27E6\u27E8\u27EA\u27EC\u27EE\u2983\u2985\u2987\u2989\u298B\u298D\u298F\u2991\u2993\u2995\u2997\u29D8\u29DA\u29FC\u2E22\u2E24\u2E26\u2E28\u2E42\u3008\u300A\u300C\u300E\u3010\u3014\u3016\u3018\u301A\u301D\uFD3F\uFE17\uFE35\uFE37\uFE39\uFE3B\uFE3D\uFE3F\uFE41\uFE43\uFE47\uFE59\uFE5B\uFE5D\uFF08\uFF3B\uFF5B\uFF5F\uFF62'
    }, {
        name: 'S',
        alias: 'Symbol',
        bmp: '\\x24\\x2B\x3C-\x3E\\x5E\x60\\x7C\x7E\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BE\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u23FE\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD',
        astral: '\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD83B[\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED2\uDEE0-\uDEEC\uDEF0-\uDEF6\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3E\uDD40-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]'
    }, {
        name: 'Sc',
        alias: 'Currency_Symbol',
        bmp: '\\x24\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BE\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6'
    }, {
        name: 'Sk',
        alias: 'Modifier_Symbol',
        bmp: '\\x5E\x60\xA8\xAF\xB4\xB8\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u309B\u309C\uA700-\uA716\uA720\uA721\uA789\uA78A\uAB5B\uFBB2-\uFBC1\uFF3E\uFF40\uFFE3',
        astral: '\uD83C[\uDFFB-\uDFFF]'
    }, {
        name: 'Sm',
        alias: 'Math_Symbol',
        bmp: '\\x2B\x3C-\x3E\\x7C\x7E\xAC\xB1\xD7\xF7\u03F6\u0606-\u0608\u2044\u2052\u207A-\u207C\u208A-\u208C\u2118\u2140-\u2144\u214B\u2190-\u2194\u219A\u219B\u21A0\u21A3\u21A6\u21AE\u21CE\u21CF\u21D2\u21D4\u21F4-\u22FF\u2320\u2321\u237C\u239B-\u23B3\u23DC-\u23E1\u25B7\u25C1\u25F8-\u25FF\u266F\u27C0-\u27C4\u27C7-\u27E5\u27F0-\u27FF\u2900-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2AFF\u2B30-\u2B44\u2B47-\u2B4C\uFB29\uFE62\uFE64-\uFE66\uFF0B\uFF1C-\uFF1E\uFF5C\uFF5E\uFFE2\uFFE9-\uFFEC',
        astral: '\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD83B[\uDEF0\uDEF1]'
    }, {
        name: 'So',
        alias: 'Other_Symbol',
        bmp: '\xA6\xA9\xAE\xB0\u0482\u058D\u058E\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09FA\u0B70\u0BF3-\u0BF8\u0BFA\u0C7F\u0D4F\u0D79\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116\u2117\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u214A\u214C\u214D\u214F\u218A\u218B\u2195-\u2199\u219C-\u219F\u21A1\u21A2\u21A4\u21A5\u21A7-\u21AD\u21AF-\u21CD\u21D0\u21D1\u21D3\u21D5-\u21F3\u2300-\u2307\u230C-\u231F\u2322-\u2328\u232B-\u237B\u237D-\u239A\u23B4-\u23DB\u23E2-\u23FE\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u25B6\u25B8-\u25C0\u25C2-\u25F7\u2600-\u266E\u2670-\u2767\u2794-\u27BF\u2800-\u28FF\u2B00-\u2B2F\u2B45\u2B46\u2B4D-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA828-\uA82B\uA836\uA837\uA839\uAA77-\uAA79\uFDFD\uFFE4\uFFE8\uFFED\uFFEE\uFFFC\uFFFD',
        astral: '\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED2\uDEE0-\uDEEC\uDEF0-\uDEF6\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3E\uDD40-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]'
    }, {
        name: 'Z',
        alias: 'Separator',
        bmp: '\x20\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
    }, {
        name: 'Zl',
        alias: 'Line_Separator',
        bmp: '\u2028'
    }, {
        name: 'Zp',
        alias: 'Paragraph_Separator',
        bmp: '\u2029'
    }, {
        name: 'Zs',
        alias: 'Space_Separator',
        bmp: '\x20\xA0\u1680\u2000-\u200A\u202F\u205F\u3000'
    }]);
};

module.exports = exports['default'];

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp Unicode Properties 4.0.0
 * <xregexp.com>
 * Steven Levithan (c) 2012-2017 MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */

exports.default = function (XRegExp) {

    /**
     * Adds properties to meet the UTS #18 Level 1 RL1.2 requirements for Unicode regex support. See
     * <http://unicode.org/reports/tr18/#RL1.2>. Following are definitions of these properties from
     * UAX #44 <http://unicode.org/reports/tr44/>:
     *
     * - Alphabetic
     *   Characters with the Alphabetic property. Generated from: Lowercase + Uppercase + Lt + Lm +
     *   Lo + Nl + Other_Alphabetic.
     *
     * - Default_Ignorable_Code_Point
     *   For programmatic determination of default ignorable code points. New characters that should
     *   be ignored in rendering (unless explicitly supported) will be assigned in these ranges,
     *   permitting programs to correctly handle the default rendering of such characters when not
     *   otherwise supported.
     *
     * - Lowercase
     *   Characters with the Lowercase property. Generated from: Ll + Other_Lowercase.
     *
     * - Noncharacter_Code_Point
     *   Code points permanently reserved for internal use.
     *
     * - Uppercase
     *   Characters with the Uppercase property. Generated from: Lu + Other_Uppercase.
     *
     * - White_Space
     *   Spaces, separator characters and other control characters which should be treated by
     *   programming languages as "white space" for the purpose of parsing elements.
     *
     * The properties ASCII, Any, and Assigned are also included but are not defined in UAX #44. UTS
     * #18 RL1.2 additionally requires support for Unicode scripts and general categories. These are
     * included in XRegExp's Unicode Categories and Unicode Scripts addons.
     *
     * Token names are case insensitive, and any spaces, hyphens, and underscores are ignored.
     *
     * Uses Unicode 9.0.0.
     *
     * @requires XRegExp, Unicode Base
     */

    if (!XRegExp.addUnicodeData) {
        throw new ReferenceError('Unicode Base must be loaded before Unicode Properties');
    }

    var unicodeData = [{
        name: 'ASCII',
        bmp: '\0-\x7F'
    }, {
        name: 'Alphabetic',
        bmp: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0657\u0659-\u065F\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06ED-\u06EF\u06FA-\u06FC\u06FF\u0710-\u073F\u074D-\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0817\u081A-\u082C\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08DF\u08E3-\u08E9\u08F0-\u093B\u093D-\u094C\u094E-\u0950\u0955-\u0963\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C4\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A42\u0A47\u0A48\u0A4B\u0A4C\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC5\u0AC7-\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0-\u0AE3\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D-\u0B44\u0B47\u0B48\u0B4B\u0B4C\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4C\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCC\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E46\u0E4D\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0ECD\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F71-\u0F81\u0F88-\u0F97\u0F99-\u0FBC\u1000-\u1036\u1038\u103B-\u103F\u1050-\u1062\u1065-\u1068\u106E-\u1086\u108E\u109C\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1713\u1720-\u1733\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17B3\u17B6-\u17C8\u17D7\u17DC\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u1938\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A20-\u1A5E\u1A61-\u1A74\u1AA7\u1B00-\u1B33\u1B35-\u1B43\u1B45-\u1B4B\u1B80-\u1BA9\u1BAC-\u1BAF\u1BBA-\u1BE5\u1BE7-\u1BF1\u1C00-\u1C35\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1D00-\u1DBF\u1DE7-\u1DF4\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA674-\uA67B\uA67F-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA827\uA840-\uA873\uA880-\uA8C3\uA8C5\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA92A\uA930-\uA952\uA960-\uA97C\uA980-\uA9B2\uA9B4-\uA9BF\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA60-\uAA76\uAA7A\uAA7E-\uAABE\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
        astral: '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC45\uDC82-\uDCB8\uDCD0-\uDCE8\uDD00-\uDD32\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC00-\uDC41\uDC43-\uDC45\uDC47-\uDC4A\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDF00-\uDF19\uDF1D-\uDF2A]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC3E\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF36\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD47]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]'
    }, {
        name: 'Any',
        isBmpLast: true,
        bmp: '\0-\uFFFF',
        astral: '[\uD800-\uDBFF][\uDC00-\uDFFF]'
    }, {
        name: 'Default_Ignorable_Code_Point',
        bmp: '\xAD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8',
        astral: '\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]'
    }, {
        name: 'Lowercase',
        bmp: 'a-z\xAA\xB5\xBA\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02B8\u02C0\u02C1\u02E0-\u02E4\u0345\u0371\u0373\u0377\u037A-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1DBF\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u2071\u207F\u2090-\u209C\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2170-\u217F\u2184\u24D0-\u24E9\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7D\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B-\uA69D\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7F8-\uA7FA\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
        astral: '\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]'
    }, {
        name: 'Noncharacter_Code_Point',
        bmp: '\uFDD0-\uFDEF\uFFFE\uFFFF',
        astral: '[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]'
    }, {
        name: 'Uppercase',
        bmp: 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A',
        astral: '\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]'
    }, {
        name: 'White_Space',
        bmp: '\x09-\x0D\x20\x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
    }];

    // Add non-generated data
    unicodeData.push({
        name: 'Assigned',
        // Since this is defined as the inverse of Unicode category Cn (Unassigned), the Unicode
        // Categories addon is required to use this property
        inverseOf: 'Cn'
    });

    XRegExp.addUnicodeData(unicodeData);
};

module.exports = exports['default'];

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp Unicode Scripts 4.0.0
 * <xregexp.com>
 * Steven Levithan (c) 2010-2017 MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */

exports.default = function (XRegExp) {

    /**
     * Adds support for all Unicode scripts. E.g., `\p{Latin}`. Token names are case insensitive,
     * and any spaces, hyphens, and underscores are ignored.
     *
     * Uses Unicode 9.0.0.
     *
     * @requires XRegExp, Unicode Base
     */

    if (!XRegExp.addUnicodeData) {
        throw new ReferenceError('Unicode Base must be loaded before Unicode Scripts');
    }

    XRegExp.addUnicodeData([{
        name: 'Adlam',
        astral: '\uD83A[\uDD00-\uDD4A\uDD50-\uDD59\uDD5E\uDD5F]'
    }, {
        name: 'Ahom',
        astral: '\uD805[\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF3F]'
    }, {
        name: 'Anatolian_Hieroglyphs',
        astral: '\uD811[\uDC00-\uDE46]'
    }, {
        name: 'Arabic',
        bmp: '\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u06FF\u0750-\u077F\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u08FF\uFB50-\uFBC1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFD\uFE70-\uFE74\uFE76-\uFEFC',
        astral: '\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]'
    }, {
        name: 'Armenian',
        bmp: '\u0531-\u0556\u0559-\u055F\u0561-\u0587\u058A\u058D-\u058F\uFB13-\uFB17'
    }, {
        name: 'Avestan',
        astral: '\uD802[\uDF00-\uDF35\uDF39-\uDF3F]'
    }, {
        name: 'Balinese',
        bmp: '\u1B00-\u1B4B\u1B50-\u1B7C'
    }, {
        name: 'Bamum',
        bmp: '\uA6A0-\uA6F7',
        astral: '\uD81A[\uDC00-\uDE38]'
    }, {
        name: 'Bassa_Vah',
        astral: '\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]'
    }, {
        name: 'Batak',
        bmp: '\u1BC0-\u1BF3\u1BFC-\u1BFF'
    }, {
        name: 'Bengali',
        bmp: '\u0980-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09FB'
    }, {
        name: 'Bhaiksuki',
        astral: '\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC50-\uDC6C]'
    }, {
        name: 'Bopomofo',
        bmp: '\u02EA\u02EB\u3105-\u312D\u31A0-\u31BA'
    }, {
        name: 'Brahmi',
        astral: '\uD804[\uDC00-\uDC4D\uDC52-\uDC6F\uDC7F]'
    }, {
        name: 'Braille',
        bmp: '\u2800-\u28FF'
    }, {
        name: 'Buginese',
        bmp: '\u1A00-\u1A1B\u1A1E\u1A1F'
    }, {
        name: 'Buhid',
        bmp: '\u1740-\u1753'
    }, {
        name: 'Canadian_Aboriginal',
        bmp: '\u1400-\u167F\u18B0-\u18F5'
    }, {
        name: 'Carian',
        astral: '\uD800[\uDEA0-\uDED0]'
    }, {
        name: 'Caucasian_Albanian',
        astral: '\uD801[\uDD30-\uDD63\uDD6F]'
    }, {
        name: 'Chakma',
        astral: '\uD804[\uDD00-\uDD34\uDD36-\uDD43]'
    }, {
        name: 'Cham',
        bmp: '\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F'
    }, {
        name: 'Cherokee',
        bmp: '\u13A0-\u13F5\u13F8-\u13FD\uAB70-\uABBF'
    }, {
        name: 'Common',
        bmp: '\0-\x40\\x5B-\x60\\x7B-\xA9\xAB-\xB9\xBB-\xBF\xD7\xF7\u02B9-\u02DF\u02E5-\u02E9\u02EC-\u02FF\u0374\u037E\u0385\u0387\u0589\u0605\u060C\u061B\u061C\u061F\u0640\u06DD\u08E2\u0964\u0965\u0E3F\u0FD5-\u0FD8\u10FB\u16EB-\u16ED\u1735\u1736\u1802\u1803\u1805\u1CD3\u1CE1\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u2000-\u200B\u200E-\u2064\u2066-\u2070\u2074-\u207E\u2080-\u208E\u20A0-\u20BE\u2100-\u2125\u2127-\u2129\u212C-\u2131\u2133-\u214D\u214F-\u215F\u2189-\u218B\u2190-\u23FE\u2400-\u2426\u2440-\u244A\u2460-\u27FF\u2900-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2E00-\u2E44\u2FF0-\u2FFB\u3000-\u3004\u3006\u3008-\u3020\u3030-\u3037\u303C-\u303F\u309B\u309C\u30A0\u30FB\u30FC\u3190-\u319F\u31C0-\u31E3\u3220-\u325F\u327F-\u32CF\u3358-\u33FF\u4DC0-\u4DFF\uA700-\uA721\uA788-\uA78A\uA830-\uA839\uA92E\uA9CF\uAB5B\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFF70\uFF9E\uFF9F\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFF9-\uFFFD',
        astral: '\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9B\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDF00-\uDF56\uDF60-\uDF71]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDD0C\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED2\uDEE0-\uDEEC\uDEF0-\uDEF6\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3E\uDD40-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]|\uDB40[\uDC01\uDC20-\uDC7F]'
    }, {
        name: 'Coptic',
        bmp: '\u03E2-\u03EF\u2C80-\u2CF3\u2CF9-\u2CFF'
    }, {
        name: 'Cuneiform',
        astral: '\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]'
    }, {
        name: 'Cypriot',
        astral: '\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]'
    }, {
        name: 'Cyrillic',
        bmp: '\u0400-\u0484\u0487-\u052F\u1C80-\u1C88\u1D2B\u1D78\u2DE0-\u2DFF\uA640-\uA69F\uFE2E\uFE2F'
    }, {
        name: 'Deseret',
        astral: '\uD801[\uDC00-\uDC4F]'
    }, {
        name: 'Devanagari',
        bmp: '\u0900-\u0950\u0953-\u0963\u0966-\u097F\uA8E0-\uA8FD'
    }, {
        name: 'Duployan',
        astral: '\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]'
    }, {
        name: 'Egyptian_Hieroglyphs',
        astral: '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]'
    }, {
        name: 'Elbasan',
        astral: '\uD801[\uDD00-\uDD27]'
    }, {
        name: 'Ethiopic',
        bmp: '\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u137C\u1380-\u1399\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E'
    }, {
        name: 'Georgian',
        bmp: '\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u10FF\u2D00-\u2D25\u2D27\u2D2D'
    }, {
        name: 'Glagolitic',
        bmp: '\u2C00-\u2C2E\u2C30-\u2C5E',
        astral: '\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]'
    }, {
        name: 'Gothic',
        astral: '\uD800[\uDF30-\uDF4A]'
    }, {
        name: 'Grantha',
        astral: '\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]'
    }, {
        name: 'Greek',
        bmp: '\u0370-\u0373\u0375-\u0377\u037A-\u037D\u037F\u0384\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03E1\u03F0-\u03FF\u1D26-\u1D2A\u1D5D-\u1D61\u1D66-\u1D6A\u1DBF\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FC4\u1FC6-\u1FD3\u1FD6-\u1FDB\u1FDD-\u1FEF\u1FF2-\u1FF4\u1FF6-\u1FFE\u2126\uAB65',
        astral: '\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]'
    }, {
        name: 'Gujarati',
        bmp: '\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AF1\u0AF9'
    }, {
        name: 'Gurmukhi',
        bmp: '\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75'
    }, {
        name: 'Han',
        bmp: '\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FD5\uF900-\uFA6D\uFA70-\uFAD9',
        astral: '[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]'
    }, {
        name: 'Hangul',
        bmp: '\u1100-\u11FF\u302E\u302F\u3131-\u318E\u3200-\u321E\u3260-\u327E\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC'
    }, {
        name: 'Hanunoo',
        bmp: '\u1720-\u1734'
    }, {
        name: 'Hatran',
        astral: '\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]'
    }, {
        name: 'Hebrew',
        bmp: '\u0591-\u05C7\u05D0-\u05EA\u05F0-\u05F4\uFB1D-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFB4F'
    }, {
        name: 'Hiragana',
        bmp: '\u3041-\u3096\u309D-\u309F',
        astral: '\uD82C\uDC01|\uD83C\uDE00'
    }, {
        name: 'Imperial_Aramaic',
        astral: '\uD802[\uDC40-\uDC55\uDC57-\uDC5F]'
    }, {
        name: 'Inherited',
        bmp: '\u0300-\u036F\u0485\u0486\u064B-\u0655\u0670\u0951\u0952\u1AB0-\u1ABE\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u200C\u200D\u20D0-\u20F0\u302A-\u302D\u3099\u309A\uFE00-\uFE0F\uFE20-\uFE2D',
        astral: '\uD800[\uDDFD\uDEE0]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uDB40[\uDD00-\uDDEF]'
    }, {
        name: 'Inscriptional_Pahlavi',
        astral: '\uD802[\uDF60-\uDF72\uDF78-\uDF7F]'
    }, {
        name: 'Inscriptional_Parthian',
        astral: '\uD802[\uDF40-\uDF55\uDF58-\uDF5F]'
    }, {
        name: 'Javanese',
        bmp: '\uA980-\uA9CD\uA9D0-\uA9D9\uA9DE\uA9DF'
    }, {
        name: 'Kaithi',
        astral: '\uD804[\uDC80-\uDCC1]'
    }, {
        name: 'Kannada',
        bmp: '\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2'
    }, {
        name: 'Katakana',
        bmp: '\u30A1-\u30FA\u30FD-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF6F\uFF71-\uFF9D',
        astral: '\uD82C\uDC00'
    }, {
        name: 'Kayah_Li',
        bmp: '\uA900-\uA92D\uA92F'
    }, {
        name: 'Kharoshthi',
        astral: '\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F-\uDE47\uDE50-\uDE58]'
    }, {
        name: 'Khmer',
        bmp: '\u1780-\u17DD\u17E0-\u17E9\u17F0-\u17F9\u19E0-\u19FF'
    }, {
        name: 'Khojki',
        astral: '\uD804[\uDE00-\uDE11\uDE13-\uDE3E]'
    }, {
        name: 'Khudawadi',
        astral: '\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]'
    }, {
        name: 'Lao',
        bmp: '\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF'
    }, {
        name: 'Latin',
        bmp: 'A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A'
    }, {
        name: 'Lepcha',
        bmp: '\u1C00-\u1C37\u1C3B-\u1C49\u1C4D-\u1C4F'
    }, {
        name: 'Limbu',
        bmp: '\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1940\u1944-\u194F'
    }, {
        name: 'Linear_A',
        astral: '\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]'
    }, {
        name: 'Linear_B',
        astral: '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]'
    }, {
        name: 'Lisu',
        bmp: '\uA4D0-\uA4FF'
    }, {
        name: 'Lycian',
        astral: '\uD800[\uDE80-\uDE9C]'
    }, {
        name: 'Lydian',
        astral: '\uD802[\uDD20-\uDD39\uDD3F]'
    }, {
        name: 'Mahajani',
        astral: '\uD804[\uDD50-\uDD76]'
    }, {
        name: 'Malayalam',
        bmp: '\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4F\u0D54-\u0D63\u0D66-\u0D7F'
    }, {
        name: 'Mandaic',
        bmp: '\u0840-\u085B\u085E'
    }, {
        name: 'Manichaean',
        astral: '\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]'
    }, {
        name: 'Marchen',
        astral: '\uD807[\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]'
    }, {
        name: 'Meetei_Mayek',
        bmp: '\uAAE0-\uAAF6\uABC0-\uABED\uABF0-\uABF9'
    }, {
        name: 'Mende_Kikakui',
        astral: '\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]'
    }, {
        name: 'Meroitic_Cursive',
        astral: '\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]'
    }, {
        name: 'Meroitic_Hieroglyphs',
        astral: '\uD802[\uDD80-\uDD9F]'
    }, {
        name: 'Miao',
        astral: '\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]'
    }, {
        name: 'Modi',
        astral: '\uD805[\uDE00-\uDE44\uDE50-\uDE59]'
    }, {
        name: 'Mongolian',
        bmp: '\u1800\u1801\u1804\u1806-\u180E\u1810-\u1819\u1820-\u1877\u1880-\u18AA',
        astral: '\uD805[\uDE60-\uDE6C]'
    }, {
        name: 'Mro',
        astral: '\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]'
    }, {
        name: 'Multani',
        astral: '\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]'
    }, {
        name: 'Myanmar',
        bmp: '\u1000-\u109F\uA9E0-\uA9FE\uAA60-\uAA7F'
    }, {
        name: 'Nabataean',
        astral: '\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]'
    }, {
        name: 'New_Tai_Lue',
        bmp: '\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u19DE\u19DF'
    }, {
        name: 'Newa',
        astral: '\uD805[\uDC00-\uDC59\uDC5B\uDC5D]'
    }, {
        name: 'Nko',
        bmp: '\u07C0-\u07FA'
    }, {
        name: 'Ogham',
        bmp: '\u1680-\u169C'
    }, {
        name: 'Ol_Chiki',
        bmp: '\u1C50-\u1C7F'
    }, {
        name: 'Old_Hungarian',
        astral: '\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]'
    }, {
        name: 'Old_Italic',
        astral: '\uD800[\uDF00-\uDF23]'
    }, {
        name: 'Old_North_Arabian',
        astral: '\uD802[\uDE80-\uDE9F]'
    }, {
        name: 'Old_Permic',
        astral: '\uD800[\uDF50-\uDF7A]'
    }, {
        name: 'Old_Persian',
        astral: '\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]'
    }, {
        name: 'Old_South_Arabian',
        astral: '\uD802[\uDE60-\uDE7F]'
    }, {
        name: 'Old_Turkic',
        astral: '\uD803[\uDC00-\uDC48]'
    }, {
        name: 'Oriya',
        bmp: '\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B77'
    }, {
        name: 'Osage',
        astral: '\uD801[\uDCB0-\uDCD3\uDCD8-\uDCFB]'
    }, {
        name: 'Osmanya',
        astral: '\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]'
    }, {
        name: 'Pahawh_Hmong',
        astral: '\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]'
    }, {
        name: 'Palmyrene',
        astral: '\uD802[\uDC60-\uDC7F]'
    }, {
        name: 'Pau_Cin_Hau',
        astral: '\uD806[\uDEC0-\uDEF8]'
    }, {
        name: 'Phags_Pa',
        bmp: '\uA840-\uA877'
    }, {
        name: 'Phoenician',
        astral: '\uD802[\uDD00-\uDD1B\uDD1F]'
    }, {
        name: 'Psalter_Pahlavi',
        astral: '\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]'
    }, {
        name: 'Rejang',
        bmp: '\uA930-\uA953\uA95F'
    }, {
        name: 'Runic',
        bmp: '\u16A0-\u16EA\u16EE-\u16F8'
    }, {
        name: 'Samaritan',
        bmp: '\u0800-\u082D\u0830-\u083E'
    }, {
        name: 'Saurashtra',
        bmp: '\uA880-\uA8C5\uA8CE-\uA8D9'
    }, {
        name: 'Sharada',
        astral: '\uD804[\uDD80-\uDDCD\uDDD0-\uDDDF]'
    }, {
        name: 'Shavian',
        astral: '\uD801[\uDC50-\uDC7F]'
    }, {
        name: 'Siddham',
        astral: '\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]'
    }, {
        name: 'SignWriting',
        astral: '\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]'
    }, {
        name: 'Sinhala',
        bmp: '\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2-\u0DF4',
        astral: '\uD804[\uDDE1-\uDDF4]'
    }, {
        name: 'Sora_Sompeng',
        astral: '\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]'
    }, {
        name: 'Sundanese',
        bmp: '\u1B80-\u1BBF\u1CC0-\u1CC7'
    }, {
        name: 'Syloti_Nagri',
        bmp: '\uA800-\uA82B'
    }, {
        name: 'Syriac',
        bmp: '\u0700-\u070D\u070F-\u074A\u074D-\u074F'
    }, {
        name: 'Tagalog',
        bmp: '\u1700-\u170C\u170E-\u1714'
    }, {
        name: 'Tagbanwa',
        bmp: '\u1760-\u176C\u176E-\u1770\u1772\u1773'
    }, {
        name: 'Tai_Le',
        bmp: '\u1950-\u196D\u1970-\u1974'
    }, {
        name: 'Tai_Tham',
        bmp: '\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA0-\u1AAD'
    }, {
        name: 'Tai_Viet',
        bmp: '\uAA80-\uAAC2\uAADB-\uAADF'
    }, {
        name: 'Takri',
        astral: '\uD805[\uDE80-\uDEB7\uDEC0-\uDEC9]'
    }, {
        name: 'Tamil',
        bmp: '\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BFA'
    }, {
        name: 'Tangut',
        astral: '\uD81B\uDFE0|[\uD81C-\uD820][\uDC00-\uDFFF]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]'
    }, {
        name: 'Telugu',
        bmp: '\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C78-\u0C7F'
    }, {
        name: 'Thaana',
        bmp: '\u0780-\u07B1'
    }, {
        name: 'Thai',
        bmp: '\u0E01-\u0E3A\u0E40-\u0E5B'
    }, {
        name: 'Tibetan',
        bmp: '\u0F00-\u0F47\u0F49-\u0F6C\u0F71-\u0F97\u0F99-\u0FBC\u0FBE-\u0FCC\u0FCE-\u0FD4\u0FD9\u0FDA'
    }, {
        name: 'Tifinagh',
        bmp: '\u2D30-\u2D67\u2D6F\u2D70\u2D7F'
    }, {
        name: 'Tirhuta',
        astral: '\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]'
    }, {
        name: 'Ugaritic',
        astral: '\uD800[\uDF80-\uDF9D\uDF9F]'
    }, {
        name: 'Vai',
        bmp: '\uA500-\uA62B'
    }, {
        name: 'Warang_Citi',
        astral: '\uD806[\uDCA0-\uDCF2\uDCFF]'
    }, {
        name: 'Yi',
        bmp: '\uA000-\uA48C\uA490-\uA4C6'
    }]);
};

module.exports = exports['default'];

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(1160);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _marked = __webpack_require__(1033);

var _marked2 = _interopRequireDefault(_marked);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

var _syntax_highlighting = __webpack_require__(1161);

var SyntaxHighlighting = _interopRequireWildcard(_syntax_highlighting);

var _text_formatting = __webpack_require__(811);

var TextFormatting = _interopRequireWildcard(_text_formatting);

var _url = __webpack_require__(793);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Renderer = function (_marked$Renderer) {
    (0, _inherits3.default)(Renderer, _marked$Renderer);

    function Renderer(options) {
        var formattingOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheck3.default)(this, Renderer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Renderer.__proto__ || (0, _getPrototypeOf2.default)(Renderer)).call(this, options));

        _this.heading = _this.heading.bind(_this);
        _this.paragraph = _this.paragraph.bind(_this);
        _this.text = _this.text.bind(_this);

        _this.formattingOptions = formattingOptions;
        return _this;
    }

    (0, _createClass3.default)(Renderer, [{
        key: 'code',
        value: function code(_code, language) {
            var usedLanguage = language || '';
            usedLanguage = usedLanguage.toLowerCase();

            if (usedLanguage === 'tex' || usedLanguage === 'latex') {
                return '<div data-latex="' + TextFormatting.escapeHtml(_code) + '" />';
            }

            // treat html as xml to prevent injection attacks
            if (usedLanguage === 'html') {
                usedLanguage = 'xml';
            }

            var className = 'post-code';
            if (!usedLanguage) {
                className += ' post-code--wrap';
            }

            var header = '';
            if (SyntaxHighlighting.canHighlight(usedLanguage)) {
                header = '<span class="post-code__language">' + SyntaxHighlighting.getLanguageName(usedLanguage) + '</span>';
            }

            // if we have to apply syntax highlighting AND highlighting of search terms, create two copies
            // of the code block, one with syntax highlighting applied and another with invisible text, but
            // search term highlighting and overlap them
            var content = SyntaxHighlighting.highlight(usedLanguage, _code);
            var searchedContent = '';

            if (this.formattingOptions.searchPatterns) {
                var tokens = new _map2.default();

                var searched = TextFormatting.sanitizeHtml(_code);
                searched = TextFormatting.highlightSearchTerms(searched, tokens, this.formattingOptions.searchPatterns);

                if (tokens.size > 0) {
                    searched = TextFormatting.replaceTokens(searched, tokens);

                    searchedContent = '<div class="post-code__search-highlighting">' + searched + '</div>';
                }
            }

            return '<div class="' + className + '">' + header + '<code class="hljs">' + searchedContent + content + '</code>' + '</div>';
        }
    }, {
        key: 'codespan',
        value: function codespan(text) {
            var output = text;

            if (this.formattingOptions.searchPatterns) {
                var tokens = new _map2.default();
                output = TextFormatting.highlightSearchTerms(output, tokens, this.formattingOptions.searchPatterns);
                output = TextFormatting.replaceTokens(output, tokens);
            }

            return '<span class="codespan__pre-wrap">' + '<code>' + output + '</code>' + '</span>';
        }
    }, {
        key: 'br',
        value: function br() {
            if (this.formattingOptions.singleline) {
                return ' ';
            }

            return (0, _get3.default)(Renderer.prototype.__proto__ || (0, _getPrototypeOf2.default)(Renderer.prototype), 'br', this).call(this);
        }
    }, {
        key: 'image',
        value: function image(href, title, text) {
            var src = href;
            var dimensions = [];
            var parts = href.split(' ');
            if (parts.length > 1) {
                var lastPart = parts.pop();
                src = parts.join(' ');
                if (lastPart[0] === '=') {
                    dimensions = lastPart.substr(1).split('x');
                    if (dimensions.length === 2 && dimensions[1] === '') {
                        dimensions[1] = 'auto';
                    }
                }
            }
            src = PostUtils.getImageSrc(src, this.formattingOptions.proxyImages);
            var out = '<img src="' + src + '" alt="' + text + '"';
            if (title) {
                out += ' title="' + title + '"';
            }
            if (dimensions.length > 0) {
                out += ' width="' + dimensions[0] + '"';
            }
            if (dimensions.length > 1) {
                out += ' height="' + dimensions[1] + '"';
            }
            out += ' class="markdown-inline-img"';
            out += this.options.xhtml ? '/>' : '>';
            return out;
        }
    }, {
        key: 'heading',
        value: function heading(text, level) {
            return '<h' + level + ' class="markdown__heading">' + text + '</h' + level + '>';
        }
    }, {
        key: 'link',
        value: function link(href, title, text) {
            var outHref = href;

            if (this.formattingOptions.linkFilter && !this.formattingOptions.linkFilter(outHref)) {
                return text;
            }

            if (!(0, _url.isUrlSafe)(unescapeHtmlEntities(href))) {
                return text;
            }

            if (!/[a-z0-9+.-]+:/i.test(outHref)) {
                outHref = 'http://' + outHref;
            }

            var output = '<a class="theme markdown__link';

            if (this.formattingOptions.searchPatterns) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.formattingOptions.searchPatterns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var pattern = _step.value;

                        if (pattern.pattern.test(href)) {
                            output += ' search-highlight';
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            output += '" href="' + outHref + '" rel="noreferrer"';

            // special case for team invite links, channel links, and permalinks that are inside the app
            var internalLink = false;
            if (this.formattingOptions.siteURL) {
                var _pattern = new RegExp('^' + TextFormatting.escapeRegex(this.formattingOptions.siteURL) + '\\/(?:signup_user_complete|admin_console|[^\\/]+\\/(?:pl|channels|messages))\\/');

                internalLink = _pattern.test(outHref);
            }

            if (internalLink) {
                output += ' data-link="' + outHref.substring(this.formattingOptions.siteURL.length) + '"';
            } else {
                output += ' target="_blank"';
            }

            if (title) {
                output += ' title="' + title + '"';
            }

            // remove any links added to the text by hashtag or mention parsing since they'll break this link
            output += '>' + text.replace(/<\/?a[^>]*>/g, '') + '</a>';

            return output;
        }
    }, {
        key: 'paragraph',
        value: function paragraph(text) {
            if (this.formattingOptions.singleline) {
                return '<p class="markdown__paragraph-inline">' + text + '</p>';
            }

            return (0, _get3.default)(Renderer.prototype.__proto__ || (0, _getPrototypeOf2.default)(Renderer.prototype), 'paragraph', this).call(this, text);
        }
    }, {
        key: 'table',
        value: function table(header, body) {
            return '<div class="table-responsive"><table class="markdown__table"><thead>' + header + '</thead><tbody>' + body + '</tbody></table></div>';
        }
    }, {
        key: 'listitem',
        value: function listitem(text, bullet) {
            var taskListReg = /^\[([ |xX])] /;
            var isTaskList = taskListReg.exec(text);

            if (isTaskList) {
                return '<li class="list-item--task-list">' + ('<input type="checkbox" disabled="disabled" ' + (isTaskList[1] === ' ' ? '' : 'checked="checked" ') + '/> ') + text.replace(taskListReg, '') + '</li>';
            }

            if (/^\d+.$/.test(bullet)) {
                // this is a numbered list item so override the numbering
                return '<li value="' + parseInt(bullet, 10) + '">' + text + '</li>';
            }

            return '<li>' + text + '</li>';
        }
    }, {
        key: 'text',
        value: function text(txt) {
            return TextFormatting.doFormatText(txt, this.formattingOptions);
        }
    }]);
    return Renderer;
}(_marked2.default.Renderer);

// Marked helper functions that should probably just be exported

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = Renderer;
function unescapeHtmlEntities(html) {
    return html.replace(/&([#\w]+);/g, function (_, m) {
        var n = m.toLowerCase();
        if (n === 'colon') {
            return ':';
        } else if (n.charAt(0) === '#') {
            return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(Number(n.substring(1)));
        }
        return '';
    });
}

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1779), __esModule: true };

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1780);
var $Object = __webpack_require__(12).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(56);
var $getOwnPropertyDescriptor = __webpack_require__(121).f;

__webpack_require__(185)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/

(function(factory) {

  // Find the global object for export to both the browser and web workers.
  var globalObject = typeof window === 'object' && window ||
                     typeof self === 'object' && self;

  // Setup highlight.js for different environments. First is Node.js or
  // CommonJS.
  if(true) {
    factory(exports);
  } else if(globalObject) {
    // Export hljs globally even when using AMD for cases when this script
    // is loaded with others that may still expect a global hljs.
    globalObject.hljs = factory({});

    // Finally register the global hljs with AMD.
    if(typeof define === 'function' && define.amd) {
      define([], function() {
        return globalObject.hljs;
      });
    }
  }

}(function(hljs) {
  // Convenience variables for build-in objects
  var ArrayProto = [],
      objectKeys = Object.keys;

  // Global internal variables used within the highlight.js library.
  var languages = {},
      aliases   = {};

  // Regular expressions used throughout the highlight.js library.
  var noHighlightRe    = /^(no-?highlight|plain|text)$/i,
      languagePrefixRe = /\blang(?:uage)?-([\w-]+)\b/i,
      fixMarkupRe      = /((^(<[^>]+>|\t|)+|(?:\n)))/gm;

  var spanEndTag = '</span>';

  // Global options used when within external APIs. This is modified when
  // calling the `hljs.configure` function.
  var options = {
    classPrefix: 'hljs-',
    tabReplace: null,
    useBR: false,
    languages: undefined
  };


  /* Utility functions */

  function escape(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function tag(node) {
    return node.nodeName.toLowerCase();
  }

  function testRe(re, lexeme) {
    var match = re && re.exec(lexeme);
    return match && match.index === 0;
  }

  function isNotHighlighted(language) {
    return noHighlightRe.test(language);
  }

  function blockLanguage(block) {
    var i, match, length, _class;
    var classes = block.className + ' ';

    classes += block.parentNode ? block.parentNode.className : '';

    // language-* takes precedence over non-prefixed class names.
    match = languagePrefixRe.exec(classes);
    if (match) {
      return getLanguage(match[1]) ? match[1] : 'no-highlight';
    }

    classes = classes.split(/\s+/);

    for (i = 0, length = classes.length; i < length; i++) {
      _class = classes[i]

      if (isNotHighlighted(_class) || getLanguage(_class)) {
        return _class;
      }
    }
  }

  function inherit(parent) {  // inherit(parent, override_obj, override_obj, ...)
    var key;
    var result = {};
    var objects = Array.prototype.slice.call(arguments, 1);

    for (key in parent)
      result[key] = parent[key];
    objects.forEach(function(obj) {
      for (key in obj)
        result[key] = obj[key];
    });
    return result;
  }

  /* Stream merging */

  function nodeStream(node) {
    var result = [];
    (function _nodeStream(node, offset) {
      for (var child = node.firstChild; child; child = child.nextSibling) {
        if (child.nodeType === 3)
          offset += child.nodeValue.length;
        else if (child.nodeType === 1) {
          result.push({
            event: 'start',
            offset: offset,
            node: child
          });
          offset = _nodeStream(child, offset);
          // Prevent void elements from having an end tag that would actually
          // double them in the output. There are more void elements in HTML
          // but we list only those realistically expected in code display.
          if (!tag(child).match(/br|hr|img|input/)) {
            result.push({
              event: 'stop',
              offset: offset,
              node: child
            });
          }
        }
      }
      return offset;
    })(node, 0);
    return result;
  }

  function mergeStreams(original, highlighted, value) {
    var processed = 0;
    var result = '';
    var nodeStack = [];

    function selectStream() {
      if (!original.length || !highlighted.length) {
        return original.length ? original : highlighted;
      }
      if (original[0].offset !== highlighted[0].offset) {
        return (original[0].offset < highlighted[0].offset) ? original : highlighted;
      }

      /*
      To avoid starting the stream just before it should stop the order is
      ensured that original always starts first and closes last:

      if (event1 == 'start' && event2 == 'start')
        return original;
      if (event1 == 'start' && event2 == 'stop')
        return highlighted;
      if (event1 == 'stop' && event2 == 'start')
        return original;
      if (event1 == 'stop' && event2 == 'stop')
        return highlighted;

      ... which is collapsed to:
      */
      return highlighted[0].event === 'start' ? original : highlighted;
    }

    function open(node) {
      function attr_str(a) {return ' ' + a.nodeName + '="' + escape(a.value).replace('"', '&quot;') + '"';}
      result += '<' + tag(node) + ArrayProto.map.call(node.attributes, attr_str).join('') + '>';
    }

    function close(node) {
      result += '</' + tag(node) + '>';
    }

    function render(event) {
      (event.event === 'start' ? open : close)(event.node);
    }

    while (original.length || highlighted.length) {
      var stream = selectStream();
      result += escape(value.substring(processed, stream[0].offset));
      processed = stream[0].offset;
      if (stream === original) {
        /*
        On any opening or closing tag of the original markup we first close
        the entire highlighted node stack, then render the original tag along
        with all the following original tags at the same offset and then
        reopen all the tags on the highlighted stack.
        */
        nodeStack.reverse().forEach(close);
        do {
          render(stream.splice(0, 1)[0]);
          stream = selectStream();
        } while (stream === original && stream.length && stream[0].offset === processed);
        nodeStack.reverse().forEach(open);
      } else {
        if (stream[0].event === 'start') {
          nodeStack.push(stream[0].node);
        } else {
          nodeStack.pop();
        }
        render(stream.splice(0, 1)[0]);
      }
    }
    return result + escape(value.substr(processed));
  }

  /* Initialization */

  function expand_mode(mode) {
    if (mode.variants && !mode.cached_variants) {
      mode.cached_variants = mode.variants.map(function(variant) {
        return inherit(mode, {variants: null}, variant);
      });
    }
    return mode.cached_variants || (mode.endsWithParent && [inherit(mode)]) || [mode];
  }

  function compileLanguage(language) {

    function reStr(re) {
        return (re && re.source) || re;
    }

    function langRe(value, global) {
      return new RegExp(
        reStr(value),
        'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
      );
    }

    function compileMode(mode, parent) {
      if (mode.compiled)
        return;
      mode.compiled = true;

      mode.keywords = mode.keywords || mode.beginKeywords;
      if (mode.keywords) {
        var compiled_keywords = {};

        var flatten = function(className, str) {
          if (language.case_insensitive) {
            str = str.toLowerCase();
          }
          str.split(' ').forEach(function(kw) {
            var pair = kw.split('|');
            compiled_keywords[pair[0]] = [className, pair[1] ? Number(pair[1]) : 1];
          });
        };

        if (typeof mode.keywords === 'string') { // string
          flatten('keyword', mode.keywords);
        } else {
          objectKeys(mode.keywords).forEach(function (className) {
            flatten(className, mode.keywords[className]);
          });
        }
        mode.keywords = compiled_keywords;
      }
      mode.lexemesRe = langRe(mode.lexemes || /\w+/, true);

      if (parent) {
        if (mode.beginKeywords) {
          mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')\\b';
        }
        if (!mode.begin)
          mode.begin = /\B|\b/;
        mode.beginRe = langRe(mode.begin);
        if (!mode.end && !mode.endsWithParent)
          mode.end = /\B|\b/;
        if (mode.end)
          mode.endRe = langRe(mode.end);
        mode.terminator_end = reStr(mode.end) || '';
        if (mode.endsWithParent && parent.terminator_end)
          mode.terminator_end += (mode.end ? '|' : '') + parent.terminator_end;
      }
      if (mode.illegal)
        mode.illegalRe = langRe(mode.illegal);
      if (mode.relevance == null)
        mode.relevance = 1;
      if (!mode.contains) {
        mode.contains = [];
      }
      mode.contains = Array.prototype.concat.apply([], mode.contains.map(function(c) {
        return expand_mode(c === 'self' ? mode : c)
      }));
      mode.contains.forEach(function(c) {compileMode(c, mode);});

      if (mode.starts) {
        compileMode(mode.starts, parent);
      }

      var terminators =
        mode.contains.map(function(c) {
          return c.beginKeywords ? '\\.?(' + c.begin + ')\\.?' : c.begin;
        })
        .concat([mode.terminator_end, mode.illegal])
        .map(reStr)
        .filter(Boolean);
      mode.terminators = terminators.length ? langRe(terminators.join('|'), true) : {exec: function(/*s*/) {return null;}};
    }

    compileMode(language);
  }

  /*
  Core highlighting function. Accepts a language name, or an alias, and a
  string with the code to highlight. Returns an object with the following
  properties:

  - relevance (int)
  - value (an HTML string with highlighting markup)

  */
  function highlight(name, value, ignore_illegals, continuation) {

    function subMode(lexeme, mode) {
      var i, length;

      for (i = 0, length = mode.contains.length; i < length; i++) {
        if (testRe(mode.contains[i].beginRe, lexeme)) {
          return mode.contains[i];
        }
      }
    }

    function endOfMode(mode, lexeme) {
      if (testRe(mode.endRe, lexeme)) {
        while (mode.endsParent && mode.parent) {
          mode = mode.parent;
        }
        return mode;
      }
      if (mode.endsWithParent) {
        return endOfMode(mode.parent, lexeme);
      }
    }

    function isIllegal(lexeme, mode) {
      return !ignore_illegals && testRe(mode.illegalRe, lexeme);
    }

    function keywordMatch(mode, match) {
      var match_str = language.case_insensitive ? match[0].toLowerCase() : match[0];
      return mode.keywords.hasOwnProperty(match_str) && mode.keywords[match_str];
    }

    function buildSpan(classname, insideSpan, leaveOpen, noPrefix) {
      var classPrefix = noPrefix ? '' : options.classPrefix,
          openSpan    = '<span class="' + classPrefix,
          closeSpan   = leaveOpen ? '' : spanEndTag

      openSpan += classname + '">';

      return openSpan + insideSpan + closeSpan;
    }

    function processKeywords() {
      var keyword_match, last_index, match, result;

      if (!top.keywords)
        return escape(mode_buffer);

      result = '';
      last_index = 0;
      top.lexemesRe.lastIndex = 0;
      match = top.lexemesRe.exec(mode_buffer);

      while (match) {
        result += escape(mode_buffer.substring(last_index, match.index));
        keyword_match = keywordMatch(top, match);
        if (keyword_match) {
          relevance += keyword_match[1];
          result += buildSpan(keyword_match[0], escape(match[0]));
        } else {
          result += escape(match[0]);
        }
        last_index = top.lexemesRe.lastIndex;
        match = top.lexemesRe.exec(mode_buffer);
      }
      return result + escape(mode_buffer.substr(last_index));
    }

    function processSubLanguage() {
      var explicit = typeof top.subLanguage === 'string';
      if (explicit && !languages[top.subLanguage]) {
        return escape(mode_buffer);
      }

      var result = explicit ?
                   highlight(top.subLanguage, mode_buffer, true, continuations[top.subLanguage]) :
                   highlightAuto(mode_buffer, top.subLanguage.length ? top.subLanguage : undefined);

      // Counting embedded language score towards the host language may be disabled
      // with zeroing the containing mode relevance. Usecase in point is Markdown that
      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
      // score.
      if (top.relevance > 0) {
        relevance += result.relevance;
      }
      if (explicit) {
        continuations[top.subLanguage] = result.top;
      }
      return buildSpan(result.language, result.value, false, true);
    }

    function processBuffer() {
      result += (top.subLanguage != null ? processSubLanguage() : processKeywords());
      mode_buffer = '';
    }

    function startNewMode(mode) {
      result += mode.className? buildSpan(mode.className, '', true): '';
      top = Object.create(mode, {parent: {value: top}});
    }

    function processLexeme(buffer, lexeme) {

      mode_buffer += buffer;

      if (lexeme == null) {
        processBuffer();
        return 0;
      }

      var new_mode = subMode(lexeme, top);
      if (new_mode) {
        if (new_mode.skip) {
          mode_buffer += lexeme;
        } else {
          if (new_mode.excludeBegin) {
            mode_buffer += lexeme;
          }
          processBuffer();
          if (!new_mode.returnBegin && !new_mode.excludeBegin) {
            mode_buffer = lexeme;
          }
        }
        startNewMode(new_mode, lexeme);
        return new_mode.returnBegin ? 0 : lexeme.length;
      }

      var end_mode = endOfMode(top, lexeme);
      if (end_mode) {
        var origin = top;
        if (origin.skip) {
          mode_buffer += lexeme;
        } else {
          if (!(origin.returnEnd || origin.excludeEnd)) {
            mode_buffer += lexeme;
          }
          processBuffer();
          if (origin.excludeEnd) {
            mode_buffer = lexeme;
          }
        }
        do {
          if (top.className) {
            result += spanEndTag;
          }
          if (!top.skip) {
            relevance += top.relevance;
          }
          top = top.parent;
        } while (top !== end_mode.parent);
        if (end_mode.starts) {
          startNewMode(end_mode.starts, '');
        }
        return origin.returnEnd ? 0 : lexeme.length;
      }

      if (isIllegal(lexeme, top))
        throw new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');

      /*
      Parser should not reach this point as all types of lexemes should be caught
      earlier, but if it does due to some bug make sure it advances at least one
      character forward to prevent infinite looping.
      */
      mode_buffer += lexeme;
      return lexeme.length || 1;
    }

    var language = getLanguage(name);
    if (!language) {
      throw new Error('Unknown language: "' + name + '"');
    }

    compileLanguage(language);
    var top = continuation || language;
    var continuations = {}; // keep continuations for sub-languages
    var result = '', current;
    for(current = top; current !== language; current = current.parent) {
      if (current.className) {
        result = buildSpan(current.className, '', true) + result;
      }
    }
    var mode_buffer = '';
    var relevance = 0;
    try {
      var match, count, index = 0;
      while (true) {
        top.terminators.lastIndex = index;
        match = top.terminators.exec(value);
        if (!match)
          break;
        count = processLexeme(value.substring(index, match.index), match[0]);
        index = match.index + count;
      }
      processLexeme(value.substr(index));
      for(current = top; current.parent; current = current.parent) { // close dangling modes
        if (current.className) {
          result += spanEndTag;
        }
      }
      return {
        relevance: relevance,
        value: result,
        language: name,
        top: top
      };
    } catch (e) {
      if (e.message && e.message.indexOf('Illegal') !== -1) {
        return {
          relevance: 0,
          value: escape(value)
        };
      } else {
        throw e;
      }
    }
  }

  /*
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)

  */
  function highlightAuto(text, languageSubset) {
    languageSubset = languageSubset || options.languages || objectKeys(languages);
    var result = {
      relevance: 0,
      value: escape(text)
    };
    var second_best = result;
    languageSubset.filter(getLanguage).forEach(function(name) {
      var current = highlight(name, text, false);
      current.language = name;
      if (current.relevance > second_best.relevance) {
        second_best = current;
      }
      if (current.relevance > result.relevance) {
        second_best = result;
        result = current;
      }
    });
    if (second_best.language) {
      result.second_best = second_best;
    }
    return result;
  }

  /*
  Post-processing of the highlighted markup:

  - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers

  */
  function fixMarkup(value) {
    return !(options.tabReplace || options.useBR)
      ? value
      : value.replace(fixMarkupRe, function(match, p1) {
          if (options.useBR && match === '\n') {
            return '<br>';
          } else if (options.tabReplace) {
            return p1.replace(/\t/g, options.tabReplace);
          }
          return '';
      });
  }

  function buildClassName(prevClassName, currentLang, resultLang) {
    var language = currentLang ? aliases[currentLang] : resultLang,
        result   = [prevClassName.trim()];

    if (!prevClassName.match(/\bhljs\b/)) {
      result.push('hljs');
    }

    if (prevClassName.indexOf(language) === -1) {
      result.push(language);
    }

    return result.join(' ').trim();
  }

  /*
  Applies highlighting to a DOM node containing code. Accepts a DOM node and
  two optional parameters for fixMarkup.
  */
  function highlightBlock(block) {
    var node, originalStream, result, resultNode, text;
    var language = blockLanguage(block);

    if (isNotHighlighted(language))
        return;

    if (options.useBR) {
      node = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
      node.innerHTML = block.innerHTML.replace(/\n/g, '').replace(/<br[ \/]*>/g, '\n');
    } else {
      node = block;
    }
    text = node.textContent;
    result = language ? highlight(language, text, true) : highlightAuto(text);

    originalStream = nodeStream(node);
    if (originalStream.length) {
      resultNode = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
      resultNode.innerHTML = result.value;
      result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
    }
    result.value = fixMarkup(result.value);

    block.innerHTML = result.value;
    block.className = buildClassName(block.className, language, result.language);
    block.result = {
      language: result.language,
      re: result.relevance
    };
    if (result.second_best) {
      block.second_best = {
        language: result.second_best.language,
        re: result.second_best.relevance
      };
    }
  }

  /*
  Updates highlight.js global options with values passed in the form of an object.
  */
  function configure(user_options) {
    options = inherit(options, user_options);
  }

  /*
  Applies highlighting to all <pre><code>..</code></pre> blocks on a page.
  */
  function initHighlighting() {
    if (initHighlighting.called)
      return;
    initHighlighting.called = true;

    var blocks = document.querySelectorAll('pre code');
    ArrayProto.forEach.call(blocks, highlightBlock);
  }

  /*
  Attaches highlighting to the page load event.
  */
  function initHighlightingOnLoad() {
    addEventListener('DOMContentLoaded', initHighlighting, false);
    addEventListener('load', initHighlighting, false);
  }

  function registerLanguage(name, language) {
    var lang = languages[name] = language(hljs);
    if (lang.aliases) {
      lang.aliases.forEach(function(alias) {aliases[alias] = name;});
    }
  }

  function listLanguages() {
    return objectKeys(languages);
  }

  function getLanguage(name) {
    name = (name || '').toLowerCase();
    return languages[name] || languages[aliases[name]];
  }

  /* Interface definition */

  hljs.highlight = highlight;
  hljs.highlightAuto = highlightAuto;
  hljs.fixMarkup = fixMarkup;
  hljs.highlightBlock = highlightBlock;
  hljs.configure = configure;
  hljs.initHighlighting = initHighlighting;
  hljs.initHighlightingOnLoad = initHighlightingOnLoad;
  hljs.registerLanguage = registerLanguage;
  hljs.listLanguages = listLanguages;
  hljs.getLanguage = getLanguage;
  hljs.inherit = inherit;

  // Common regexps
  hljs.IDENT_RE = '[a-zA-Z]\\w*';
  hljs.UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
  hljs.NUMBER_RE = '\\b\\d+(\\.\\d+)?';
  hljs.C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
  hljs.BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
  hljs.RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

  // Common modes
  hljs.BACKSLASH_ESCAPE = {
    begin: '\\\\[\\s\\S]', relevance: 0
  };
  hljs.APOS_STRING_MODE = {
    className: 'string',
    begin: '\'', end: '\'',
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  hljs.QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"', end: '"',
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  hljs.PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  };
  hljs.COMMENT = function (begin, end, inherits) {
    var mode = hljs.inherit(
      {
        className: 'comment',
        begin: begin, end: end,
        contains: []
      },
      inherits || {}
    );
    mode.contains.push(hljs.PHRASAL_WORDS_MODE);
    mode.contains.push({
      className: 'doctag',
      begin: '(?:TODO|FIXME|NOTE|BUG|XXX):',
      relevance: 0
    });
    return mode;
  };
  hljs.C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$');
  hljs.C_BLOCK_COMMENT_MODE = hljs.COMMENT('/\\*', '\\*/');
  hljs.HASH_COMMENT_MODE = hljs.COMMENT('#', '$');
  hljs.NUMBER_MODE = {
    className: 'number',
    begin: hljs.NUMBER_RE,
    relevance: 0
  };
  hljs.C_NUMBER_MODE = {
    className: 'number',
    begin: hljs.C_NUMBER_RE,
    relevance: 0
  };
  hljs.BINARY_NUMBER_MODE = {
    className: 'number',
    begin: hljs.BINARY_NUMBER_RE,
    relevance: 0
  };
  hljs.CSS_NUMBER_MODE = {
    className: 'number',
    begin: hljs.NUMBER_RE + '(' +
      '%|em|ex|ch|rem'  +
      '|vw|vh|vmin|vmax' +
      '|cm|mm|in|pt|pc|px' +
      '|deg|grad|rad|turn' +
      '|s|ms' +
      '|Hz|kHz' +
      '|dpi|dpcm|dppx' +
      ')?',
    relevance: 0
  };
  hljs.REGEXP_MODE = {
    className: 'regexp',
    begin: /\//, end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      {
        begin: /\[/, end: /\]/,
        relevance: 0,
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
  hljs.TITLE_MODE = {
    className: 'title',
    begin: hljs.IDENT_RE,
    relevance: 0
  };
  hljs.UNDERSCORE_TITLE_MODE = {
    className: 'title',
    begin: hljs.UNDERSCORE_IDENT_RE,
    relevance: 0
  };
  hljs.METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: '\\.\\s*' + hljs.UNDERSCORE_IDENT_RE,
    relevance: 0
  };

  return hljs;
}));


/***/ }),
/* 1782 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';

  var AS3_REST_ARG_MODE = {
    className: 'rest_arg',
    begin: '[.]{3}', end: IDENT_RE,
    relevance: 10
  };

  return {
    aliases: ['as'],
    keywords: {
      keyword: 'as break case catch class const continue default delete do dynamic each ' +
        'else extends final finally for function get if implements import in include ' +
        'instanceof interface internal is namespace native new override package private ' +
        'protected public return set static super switch this throw try typeof use var void ' +
        'while with',
      literal: 'true false null undefined'
    },
    contains: [
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'class',
        beginKeywords: 'package', end: '{',
        contains: [hljs.TITLE_MODE]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        contains: [
          {
            beginKeywords: 'extends implements'
          },
          hljs.TITLE_MODE
        ]
      },
      {
        className: 'meta',
        beginKeywords: 'import include', end: ';',
        keywords: {'meta-keyword': 'import include'}
      },
      {
        className: 'function',
        beginKeywords: 'function', end: '[{;]', excludeEnd: true,
        illegal: '\\S',
        contains: [
          hljs.TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            contains: [
              hljs.APOS_STRING_MODE,
              hljs.QUOTE_STRING_MODE,
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              AS3_REST_ARG_MODE
            ]
          },
          {
            begin: ':\\s*' + IDENT_FUNC_RETURN_TYPE_RE
          }
        ]
      },
      hljs.METHOD_GUARD
    ],
    illegal: /#/
  };
};

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: ''});
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)',
    contains: ['self', hljs.C_NUMBER_MODE, STRING]
  };
  var COMMENT_MODE_1 = hljs.COMMENT('--', '$');
  var COMMENT_MODE_2 = hljs.COMMENT(
    '\\(\\*',
    '\\*\\)',
    {
      contains: ['self', COMMENT_MODE_1] //allow nesting
    }
  );
  var COMMENTS = [
    COMMENT_MODE_1,
    COMMENT_MODE_2,
    hljs.HASH_COMMENT_MODE
  ];

  return {
    aliases: ['osascript'],
    keywords: {
      keyword:
        'about above after against and around as at back before beginning ' +
        'behind below beneath beside between but by considering ' +
        'contain contains continue copy div does eighth else end equal ' +
        'equals error every exit fifth first for fourth from front ' +
        'get given global if ignoring in into is it its last local me ' +
        'middle mod my ninth not of on onto or over prop property put ref ' +
        'reference repeat returning script second set seventh since ' +
        'sixth some tell tenth that the|0 then third through thru ' +
        'timeout times to transaction try until where while whose with ' +
        'without',
      literal:
        'AppleScript false linefeed return pi quote result space tab true',
      built_in:
        'alias application boolean class constant date file integer list ' +
        'number real record string text ' +
        'activate beep count delay launch log offset read round ' +
        'run say summarize write ' +
        'character characters contents day frontmost id item length ' +
        'month name paragraph paragraphs rest reverse running time version ' +
        'weekday word words year'
    },
    contains: [
      STRING,
      hljs.C_NUMBER_MODE,
      {
        className: 'built_in',
        begin:
          '\\b(clipboard info|the clipboard|info for|list (disks|folder)|' +
          'mount volume|path to|(close|open for) access|(get|set) eof|' +
          'current date|do shell script|get volume settings|random number|' +
          'set volume|system attribute|system info|time to GMT|' +
          '(load|run|store) script|scripting components|' +
          'ASCII (character|number)|localized string|' +
          'choose (application|color|file|file name|' +
          'folder|from list|remote application|URL)|' +
          'display (alert|dialog))\\b|^\\s*return\\b'
      },
      {
        className: 'literal',
        begin:
          '\\b(text item delimiters|current application|missing value)\\b'
      },
      {
        className: 'keyword',
        begin:
          '\\b(apart from|aside from|instead of|out of|greater than|' +
          "isn't|(doesn't|does not) (equal|come before|come after|contain)|" +
          '(greater|less) than( or equal)?|(starts?|ends|begins?) with|' +
          'contained by|comes (before|after)|a (ref|reference)|POSIX file|' +
          'POSIX path|(date|time) string|quoted form)\\b'
      },
      {
        beginKeywords: 'on',
        illegal: '[${=;\\n]',
        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
      }
    ].concat(COMMENTS),
    illegal: '//|->|=>|\\[\\['
  };
};

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VAR = {
    className: 'variable',
    variants: [
      {begin: /\$[\w\d#@][\w\d_]*/},
      {begin: /\$\{(.*?)}/}
    ]
  };
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/, end: /"/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      VAR,
      {
        className: 'variable',
        begin: /\$\(/, end: /\)/,
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
  var APOS_STRING = {
    className: 'string',
    begin: /'/, end: /'/
  };

  return {
    aliases: ['sh', 'zsh'],
    lexemes: /\b-?[a-z\._]+\b/,
    keywords: {
      keyword:
        'if then else elif fi for while in do done case esac function',
      literal:
        'true false',
      built_in:
        // Shell built-ins
        // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        'break cd continue eval exec exit export getopts hash pwd readonly return shift test times ' +
        'trap umask unset ' +
        // Bash built-ins
        'alias bind builtin caller command declare echo enable help let local logout mapfile printf ' +
        'read readarray source type typeset ulimit unalias ' +
        // Shell modifiers
        'set shopt ' +
        // Zsh built-ins
        'autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles ' +
        'compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate ' +
        'fc fg float functions getcap getln history integer jobs kill limit log noglob popd print ' +
        'pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit ' +
        'unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof ' +
        'zpty zregexparse zsocket zstyle ztcp',
      _:
        '-ne -eq -lt -gt -f -d -e -s -l -a' // relevance booster
    },
    contains: [
      {
        className: 'meta',
        begin: /^#![^\n]+sh\s*$/,
        relevance: 10
      },
      {
        className: 'function',
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: true,
        contains: [hljs.inherit(hljs.TITLE_MODE, {begin: /\w[\w\d_]*/})],
        relevance: 0
      },
      hljs.HASH_COMMENT_MODE,
      QUOTE_STRING,
      APOS_STRING,
      VAR
    ]
  };
};

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var keywords = {
    'builtin-name':
      // Clojure keywords
      'def defonce cond apply if-not if-let if not not= = < > <= >= == + / * - rem '+
      'quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? '+
      'set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? '+
      'class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? '+
      'string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . '+
      'inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last '+
      'drop-while while intern condp case reduced cycle split-at split-with repeat replicate '+
      'iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext '+
      'nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends '+
      'add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler '+
      'set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter '+
      'monitor-exit defmacro defn defn- macroexpand macroexpand-1 for dosync and or '+
      'when when-not when-let comp juxt partial sequence memoize constantly complement identity assert '+
      'peek pop doto proxy defstruct first rest cons defprotocol cast coll deftype defrecord last butlast '+
      'sigs reify second ffirst fnext nfirst nnext defmulti defmethod meta with-meta ns in-ns create-ns import '+
      'refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! '+
      'assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger '+
      'bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline '+
      'flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking '+
      'assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! '+
      'reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! '+
      'new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty '+
      'hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list '+
      'disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer '+
      'chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate '+
      'unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta '+
      'lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize'
   };

  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';

  var SYMBOL = {
    begin: SYMBOL_RE,
    relevance: 0
  };
  var NUMBER = {
    className: 'number', begin: SIMPLE_NUMBER_RE,
    relevance: 0
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
  var COMMENT = hljs.COMMENT(
    ';',
    '$',
    {
      relevance: 0
    }
  );
  var LITERAL = {
    className: 'literal',
    begin: /\b(true|false|nil)\b/
  };
  var COLLECTION = {
    begin: '[\\[\\{]', end: '[\\]\\}]'
  };
  var HINT = {
    className: 'comment',
    begin: '\\^' + SYMBOL_RE
  };
  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
  var KEY = {
    className: 'symbol',
    begin: '[:]{1,2}' + SYMBOL_RE
  };
  var LIST = {
    begin: '\\(', end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  var NAME = {
    keywords: keywords,
    lexemes: SYMBOL_RE,
    className: 'name', begin: SYMBOL_RE,
    starts: BODY
  };
  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];

  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
  BODY.contains = DEFAULT_CONTAINS;
  COLLECTION.contains = DEFAULT_CONTAINS;
  HINT_COL.contains = [COLLECTION];

  return {
    aliases: ['clj'],
    illegal: /\S/,
    contains: [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
  }
};

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      // JS keywords
      'in if for while finally new do return else break catch instanceof throw try this ' +
      'switch continue typeof delete debugger super yield import export from as default await ' +
      // Coffee keywords
      'then unless until loop of by when and or is isnt not',
    literal:
      // JS literals
      'true false null undefined ' +
      // Coffee literals
      'yes no on off',
    built_in:
      'npm require console print module global window document'
  };
  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var SUBST = {
    className: 'subst',
    begin: /#\{/, end: /}/,
    keywords: KEYWORDS
  };
  var EXPRESSIONS = [
    hljs.BINARY_NUMBER_MODE,
    hljs.inherit(hljs.C_NUMBER_MODE, {starts: {end: '(\\s*/)?', relevance: 0}}), // a number tries to eat the following slash to prevent treating it as a regexp
    {
      className: 'string',
      variants: [
        {
          begin: /'''/, end: /'''/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /'/, end: /'/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /"""/, end: /"""/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
        },
        {
          begin: /"/, end: /"/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
        }
      ]
    },
    {
      className: 'regexp',
      variants: [
        {
          begin: '///', end: '///',
          contains: [SUBST, hljs.HASH_COMMENT_MODE]
        },
        {
          begin: '//[gim]*',
          relevance: 0
        },
        {
          // regex can't start with space to parse x / 2 / 3 as two divisions
          // regex can't start with *, and it supports an "illegal" in the main mode
          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
        }
      ]
    },
    {
      begin: '@' + JS_IDENT_RE // relevance booster
    },
    {
      subLanguage: 'javascript',
      excludeBegin: true, excludeEnd: true,
      variants: [
        {
          begin: '```', end: '```',
        },
        {
          begin: '`', end: '`',
        }
      ]
    }
  ];
  SUBST.contains = EXPRESSIONS;

  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
  var PARAMS_RE = '(\\(.*\\))?\\s*\\B[-=]>';
  var PARAMS = {
    className: 'params',
    begin: '\\([^\\(]', returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [{
      begin: /\(/, end: /\)/,
      keywords: KEYWORDS,
      contains: ['self'].concat(EXPRESSIONS)
    }]
  };

  return {
    aliases: ['coffee', 'cson', 'iced'],
    keywords: KEYWORDS,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([
      hljs.COMMENT('###', '###'),
      hljs.HASH_COMMENT_MODE,
      {
        className: 'function',
        begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + PARAMS_RE, end: '[-=]>',
        returnBegin: true,
        contains: [TITLE, PARAMS]
      },
      {
        // anonymous function start
        begin: /[:\(,=]\s*/,
        relevance: 0,
        contains: [
          {
            className: 'function',
            begin: PARAMS_RE, end: '[-=]>',
            returnBegin: true,
            contains: [PARAMS]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class',
        end: '$',
        illegal: /[:="\[\]]/,
        contains: [
          {
            beginKeywords: 'extends',
            endsWithParent: true,
            illegal: /[:="\[\]]/,
            contains: [TITLE]
          },
          TITLE
        ]
      },
      {
        begin: JS_IDENT_RE + ':', end: ':',
        returnBegin: true, returnEnd: true,
        relevance: 0
      }
    ])
  };
};

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var CPP_PRIMITIVE_TYPES = {
    className: 'keyword',
    begin: '\\b[a-z\\d_]*_t\\b'
  };

  var STRINGS = {
    className: 'string',
    variants: [
      {
        begin: '(u8?|U)?L?"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '(u8?|U)?R"', end: '"',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '\'\\\\?.', end: '\'',
        illegal: '.'
      }
    ]
  };

  var NUMBERS = {
    className: 'number',
    variants: [
      { begin: '\\b(0b[01\']+)' },
      { begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)(u|U|l|L|ul|UL|f|F|b|B)' },
      { begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)' }
    ],
    relevance: 0
  };

  var PREPROCESSOR =       {
    className: 'meta',
    begin: /#\s*[a-z]+\b/, end: /$/,
    keywords: {
      'meta-keyword':
        'if else elif endif define undef warning error line ' +
        'pragma ifdef ifndef include'
    },
    contains: [
      {
        begin: /\\\n/, relevance: 0
      },
      hljs.inherit(STRINGS, {className: 'meta-string'}),
      {
        className: 'meta-string',
        begin: /<[^\n>]*>/, end: /$/,
        illegal: '\\n',
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };

  var FUNCTION_TITLE = hljs.IDENT_RE + '\\s*\\(';

  var CPP_KEYWORDS = {
    keyword: 'int float while private char catch import module export virtual operator sizeof ' +
      'dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace ' +
      'unsigned long volatile static protected bool template mutable if public friend ' +
      'do goto auto void enum else break extern using asm case typeid ' +
      'short reinterpret_cast|10 default double register explicit signed typename try this ' +
      'switch continue inline delete alignof constexpr decltype ' +
      'noexcept static_assert thread_local restrict _Bool complex _Complex _Imaginary ' +
      'atomic_bool atomic_char atomic_schar ' +
      'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' +
      'atomic_ullong new throw return ' +
      'and or not',
    built_in: 'std string cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream ' +
      'auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set ' +
      'unordered_map unordered_multiset unordered_multimap array shared_ptr abort abs acos ' +
      'asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp ' +
      'fscanf isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper ' +
      'isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow ' +
      'printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp ' +
      'strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan ' +
      'vfprintf vprintf vsprintf endl initializer_list unique_ptr',
    literal: 'true false nullptr NULL'
  };

  var EXPRESSION_CONTAINS = [
    CPP_PRIMITIVE_TYPES,
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    NUMBERS,
    STRINGS
  ];

  return {
    aliases: ['c', 'cc', 'h', 'c++', 'h++', 'hpp'],
    keywords: CPP_KEYWORDS,
    illegal: '</',
    contains: EXPRESSION_CONTAINS.concat([
      PREPROCESSOR,
      {
        begin: '\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<', end: '>',
        keywords: CPP_KEYWORDS,
        contains: ['self', CPP_PRIMITIVE_TYPES]
      },
      {
        begin: hljs.IDENT_RE + '::',
        keywords: CPP_KEYWORDS
      },
      {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
          {begin: /=/, end: /;/},
          {begin: /\(/, end: /\)/},
          {beginKeywords: 'new throw return else', end: /;/}
        ],
        keywords: CPP_KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
          {
            begin: /\(/, end: /\)/,
            keywords: CPP_KEYWORDS,
            contains: EXPRESSION_CONTAINS.concat(['self']),
            relevance: 0
          }
        ]),
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + hljs.IDENT_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
        returnBegin: true, end: /[{;=]/,
        excludeEnd: true,
        keywords: CPP_KEYWORDS,
        illegal: /[^\w\s\*&]/,
        contains: [
          {
            begin: FUNCTION_TITLE, returnBegin: true,
            contains: [hljs.TITLE_MODE],
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: CPP_KEYWORDS,
            relevance: 0,
            contains: [
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              STRINGS,
              NUMBERS,
              CPP_PRIMITIVE_TYPES
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          PREPROCESSOR
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class struct', end: /[{;:]/,
        contains: [
          {begin: /</, end: />/, contains: ['self']}, // skip generic stuff
          hljs.TITLE_MODE
        ]
      }
    ]),
    exports: {
      preprocessor: PREPROCESSOR,
      strings: STRINGS,
      keywords: CPP_KEYWORDS
    }
  };
};

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      // Normal keywords.
      'abstract as base bool break byte case catch char checked const continue decimal ' +
      'default delegate do double enum event explicit extern finally fixed float ' +
      'for foreach goto if implicit in int interface internal is lock long nameof ' +
      'object operator out override params private protected public readonly ref sbyte ' +
      'sealed short sizeof stackalloc static string struct switch this try typeof ' +
      'uint ulong unchecked unsafe ushort using virtual void volatile while ' +
      // Contextual keywords.
      'add alias ascending async await by descending dynamic equals from get global group into join ' +
      'let on orderby partial remove select set value var where yield',
    literal:
      'null false true'
  };

  var VERBATIM_STRING = {
    className: 'string',
    begin: '@"', end: '"',
    contains: [{begin: '""'}]
  };
  var VERBATIM_STRING_NO_LF = hljs.inherit(VERBATIM_STRING, {illegal: /\n/});
  var SUBST = {
    className: 'subst',
    begin: '{', end: '}',
    keywords: KEYWORDS
  };
  var SUBST_NO_LF = hljs.inherit(SUBST, {illegal: /\n/});
  var INTERPOLATED_STRING = {
    className: 'string',
    begin: /\$"/, end: '"',
    illegal: /\n/,
    contains: [{begin: '{{'}, {begin: '}}'}, hljs.BACKSLASH_ESCAPE, SUBST_NO_LF]
  };
  var INTERPOLATED_VERBATIM_STRING = {
    className: 'string',
    begin: /\$@"/, end: '"',
    contains: [{begin: '{{'}, {begin: '}}'}, {begin: '""'}, SUBST]
  };
  var INTERPOLATED_VERBATIM_STRING_NO_LF = hljs.inherit(INTERPOLATED_VERBATIM_STRING, {
    illegal: /\n/,
    contains: [{begin: '{{'}, {begin: '}}'}, {begin: '""'}, SUBST_NO_LF]
  });
  SUBST.contains = [
    INTERPOLATED_VERBATIM_STRING,
    INTERPOLATED_STRING,
    VERBATIM_STRING,
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE,
    hljs.C_BLOCK_COMMENT_MODE
  ];
  SUBST_NO_LF.contains = [
    INTERPOLATED_VERBATIM_STRING_NO_LF,
    INTERPOLATED_STRING,
    VERBATIM_STRING_NO_LF,
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE,
    hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {illegal: /\n/})
  ];
  var STRING = {
    variants: [
      INTERPOLATED_VERBATIM_STRING,
      INTERPOLATED_STRING,
      VERBATIM_STRING,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };

  var TYPE_IDENT_RE = hljs.IDENT_RE + '(<' + hljs.IDENT_RE + '(\\s*,\\s*' + hljs.IDENT_RE + ')*>)?(\\[\\])?';

  return {
    aliases: ['csharp'],
    keywords: KEYWORDS,
    illegal: /::/,
    contains: [
      hljs.COMMENT(
        '///',
        '$',
        {
          returnBegin: true,
          contains: [
            {
              className: 'doctag',
              variants: [
                {
                  begin: '///', relevance: 0
                },
                {
                  begin: '<!--|-->'
                },
                {
                  begin: '</?', end: '>'
                }
              ]
            }
          ]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'meta',
        begin: '#', end: '$',
        keywords: {
          'meta-keyword': 'if else elif endif define undef warning error line region endregion pragma checksum'
        }
      },
      STRING,
      hljs.C_NUMBER_MODE,
      {
        beginKeywords: 'class interface', end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          hljs.TITLE_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: 'namespace', end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: '[a-zA-Z](\\.?\\w)*'}),
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // [Attributes("")]
        className: 'meta',
        begin: '^\\s*\\[', excludeBegin: true, end: '\\]', excludeEnd: true,
        contains: [
          {className: 'meta-string', begin: /"/, end: /"/}
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: 'new return throw await else',
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + TYPE_IDENT_RE + '\\s+)+' + hljs.IDENT_RE + '\\s*\\(', returnBegin: true,
        end: /[{;=]/, excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: hljs.IDENT_RE + '\\s*\\(', returnBegin: true,
            contains: [hljs.TITLE_MODE],
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              STRING,
              hljs.C_NUMBER_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      }
    ]
  };
};

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
  var RULE = {
    begin: /[A-Z\_\.\-]+\s*:/, returnBegin: true, end: ';', endsWithParent: true,
    contains: [
      {
        className: 'attribute',
        begin: /\S/, end: ':', excludeEnd: true,
        starts: {
          endsWithParent: true, excludeEnd: true,
          contains: [
            {
              begin: /[\w-]+\(/, returnBegin: true,
              contains: [
                {
                  className: 'built_in',
                  begin: /[\w-]+/
                },
                {
                  begin: /\(/, end: /\)/,
                  contains: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE
                  ]
                }
              ]
            },
            hljs.CSS_NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
              className: 'number', begin: '#[0-9A-Fa-f]+'
            },
            {
              className: 'meta', begin: '!important'
            }
          ]
        }
      }
    ]
  };

  return {
    case_insensitive: true,
    illegal: /[=\/|'\$]/,
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'selector-id', begin: /#[A-Za-z0-9_-]+/
      },
      {
        className: 'selector-class', begin: /\.[A-Za-z0-9_-]+/
      },
      {
        className: 'selector-attr',
        begin: /\[/, end: /\]/,
        illegal: '$'
      },
      {
        className: 'selector-pseudo',
        begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/
      },
      {
        begin: '@(font-face|page)',
        lexemes: '[a-z-]+',
        keywords: 'font-face page'
      },
      {
        begin: '@', end: '[{;]', // at_rule eating first "{" is a good thing
                                 // because it doesn’t let it to be parsed as
                                 // a rule set but instead drops parser into
                                 // the default mode which is how it should be.
        illegal: /:/, // break on Less variables @var: ...
        contains: [
          {
            className: 'keyword',
            begin: /\w+/
          },
          {
            begin: /\s/, endsWithParent: true, excludeEnd: true,
            relevance: 0,
            contains: [
              hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE,
              hljs.CSS_NUMBER_MODE
            ]
          }
        ]
      },
      {
        className: 'selector-tag', begin: IDENT_RE,
        relevance: 0
      },
      {
        begin: '{', end: '}',
        illegal: /\S/,
        contains: [
          hljs.C_BLOCK_COMMENT_MODE,
          RULE,
        ]
      }
    ]
  };
};

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

module.exports = /**
 * Known issues:
 *
 * - invalid hex string literals will be recognized as a double quoted strings
 *   but 'x' at the beginning of string will not be matched
 *
 * - delimited string literals are not checked for matching end delimiter
 *   (not possible to do with js regexp)
 *
 * - content of token string is colored as a string (i.e. no keyword coloring inside a token string)
 *   also, content of token string is not validated to contain only valid D tokens
 *
 * - special token sequence rule is not strictly following D grammar (anything following #line
 *   up to the end of line is matched as special token sequence)
 */

function(hljs) {
  /**
   * Language keywords
   *
   * @type {Object}
   */
  var D_KEYWORDS = {
    keyword:
      'abstract alias align asm assert auto body break byte case cast catch class ' +
      'const continue debug default delete deprecated do else enum export extern final ' +
      'finally for foreach foreach_reverse|10 goto if immutable import in inout int ' +
      'interface invariant is lazy macro mixin module new nothrow out override package ' +
      'pragma private protected public pure ref return scope shared static struct ' +
      'super switch synchronized template this throw try typedef typeid typeof union ' +
      'unittest version void volatile while with __FILE__ __LINE__ __gshared|10 ' +
      '__thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__',
    built_in:
      'bool cdouble cent cfloat char creal dchar delegate double dstring float function ' +
      'idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar ' +
      'wstring',
    literal:
      'false null true'
  };

  /**
   * Number literal regexps
   *
   * @type {String}
   */
  var decimal_integer_re = '(0|[1-9][\\d_]*)',
    decimal_integer_nosus_re = '(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)',
    binary_integer_re = '0[bB][01_]+',
    hexadecimal_digits_re = '([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)',
    hexadecimal_integer_re = '0[xX]' + hexadecimal_digits_re,

    decimal_exponent_re = '([eE][+-]?' + decimal_integer_nosus_re + ')',
    decimal_float_re = '(' + decimal_integer_nosus_re + '(\\.\\d*|' + decimal_exponent_re + ')|' +
                '\\d+\\.' + decimal_integer_nosus_re + decimal_integer_nosus_re + '|' +
                '\\.' + decimal_integer_re + decimal_exponent_re + '?' +
              ')',
    hexadecimal_float_re = '(0[xX](' +
                  hexadecimal_digits_re + '\\.' + hexadecimal_digits_re + '|'+
                  '\\.?' + hexadecimal_digits_re +
                 ')[pP][+-]?' + decimal_integer_nosus_re + ')',

    integer_re = '(' +
      decimal_integer_re + '|' +
      binary_integer_re  + '|' +
       hexadecimal_integer_re   +
    ')',

    float_re = '(' +
      hexadecimal_float_re + '|' +
      decimal_float_re  +
    ')';

  /**
   * Escape sequence supported in D string and character literals
   *
   * @type {String}
   */
  var escape_sequence_re = '\\\\(' +
              '[\'"\\?\\\\abfnrtv]|' +  // common escapes
              'u[\\dA-Fa-f]{4}|' +     // four hex digit unicode codepoint
              '[0-7]{1,3}|' +       // one to three octal digit ascii char code
              'x[\\dA-Fa-f]{2}|' +    // two hex digit ascii char code
              'U[\\dA-Fa-f]{8}' +      // eight hex digit unicode codepoint
              ')|' +
              '&[a-zA-Z\\d]{2,};';      // named character entity

  /**
   * D integer number literals
   *
   * @type {Object}
   */
  var D_INTEGER_MODE = {
    className: 'number',
      begin: '\\b' + integer_re + '(L|u|U|Lu|LU|uL|UL)?',
      relevance: 0
  };

  /**
   * [D_FLOAT_MODE description]
   * @type {Object}
   */
  var D_FLOAT_MODE = {
    className: 'number',
    begin: '\\b(' +
        float_re + '([fF]|L|i|[fF]i|Li)?|' +
        integer_re + '(i|[fF]i|Li)' +
      ')',
    relevance: 0
  };

  /**
   * D character literal
   *
   * @type {Object}
   */
  var D_CHARACTER_MODE = {
    className: 'string',
    begin: '\'(' + escape_sequence_re + '|.)', end: '\'',
    illegal: '.'
  };

  /**
   * D string escape sequence
   *
   * @type {Object}
   */
  var D_ESCAPE_SEQUENCE = {
    begin: escape_sequence_re,
    relevance: 0
  };

  /**
   * D double quoted string literal
   *
   * @type {Object}
   */
  var D_STRING_MODE = {
    className: 'string',
    begin: '"',
    contains: [D_ESCAPE_SEQUENCE],
    end: '"[cwd]?'
  };

  /**
   * D wysiwyg and delimited string literals
   *
   * @type {Object}
   */
  var D_WYSIWYG_DELIMITED_STRING_MODE = {
    className: 'string',
    begin: '[rq]"',
    end: '"[cwd]?',
    relevance: 5
  };

  /**
   * D alternate wysiwyg string literal
   *
   * @type {Object}
   */
  var D_ALTERNATE_WYSIWYG_STRING_MODE = {
    className: 'string',
    begin: '`',
    end: '`[cwd]?'
  };

  /**
   * D hexadecimal string literal
   *
   * @type {Object}
   */
  var D_HEX_STRING_MODE = {
    className: 'string',
    begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
    relevance: 10
  };

  /**
   * D delimited string literal
   *
   * @type {Object}
   */
  var D_TOKEN_STRING_MODE = {
    className: 'string',
    begin: 'q"\\{',
    end: '\\}"'
  };

  /**
   * Hashbang support
   *
   * @type {Object}
   */
  var D_HASHBANG_MODE = {
    className: 'meta',
    begin: '^#!',
    end: '$',
    relevance: 5
  };

  /**
   * D special token sequence
   *
   * @type {Object}
   */
  var D_SPECIAL_TOKEN_SEQUENCE_MODE = {
    className: 'meta',
    begin: '#(line)',
    end: '$',
    relevance: 5
  };

  /**
   * D attributes
   *
   * @type {Object}
   */
  var D_ATTRIBUTE_MODE = {
    className: 'keyword',
    begin: '@[a-zA-Z_][a-zA-Z_\\d]*'
  };

  /**
   * D nesting comment
   *
   * @type {Object}
   */
  var D_NESTING_COMMENT_MODE = hljs.COMMENT(
    '\\/\\+',
    '\\+\\/',
    {
      contains: ['self'],
      relevance: 10
    }
  );

  return {
    lexemes: hljs.UNDERSCORE_IDENT_RE,
    keywords: D_KEYWORDS,
    contains: [
      hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        D_NESTING_COMMENT_MODE,
        D_HEX_STRING_MODE,
        D_STRING_MODE,
        D_WYSIWYG_DELIMITED_STRING_MODE,
        D_ALTERNATE_WYSIWYG_STRING_MODE,
        D_TOKEN_STRING_MODE,
        D_FLOAT_MODE,
        D_INTEGER_MODE,
        D_CHARACTER_MODE,
        D_HASHBANG_MODE,
        D_SPECIAL_TOKEN_SEQUENCE_MODE,
        D_ATTRIBUTE_MODE
    ]
  };
};

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

module.exports = function (hljs) {
  var SUBST = {
    className: 'subst',
    begin: '\\$\\{', end: '}',
    keywords: 'true false null this is new super'
  };

  var STRING = {
    className: 'string',
    variants: [
      {
        begin: 'r\'\'\'', end: '\'\'\''
      },
      {
        begin: 'r"""', end: '"""'
      },
      {
        begin: 'r\'', end: '\'',
        illegal: '\\n'
      },
      {
        begin: 'r"', end: '"',
        illegal: '\\n'
      },
      {
        begin: '\'\'\'', end: '\'\'\'',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        begin: '"""', end: '"""',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        begin: '\'', end: '\'',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        begin: '"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      }
    ]
  };
  SUBST.contains = [
    hljs.C_NUMBER_MODE, STRING
  ];

  var KEYWORDS = {
    keyword: 'assert async await break case catch class const continue default do else enum extends false final ' +
      'finally for if in is new null rethrow return super switch sync this throw true try var void while with yield ' +
      'abstract as dynamic export external factory get implements import library operator part set static typedef',
    built_in:
      // dart:core
      'print Comparable DateTime Duration Function Iterable Iterator List Map Match Null Object Pattern RegExp Set ' +
      'Stopwatch String StringBuffer StringSink Symbol Type Uri bool double int num ' +
      // dart:html
      'document window querySelector querySelectorAll Element ElementList'
  };

  return {
    keywords: KEYWORDS,
    contains: [
      STRING,
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          subLanguage: 'markdown'
        }
      ),
      hljs.COMMENT(
        '///',
        '$',
        {
          subLanguage: 'markdown'
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        contains: [
          {
            beginKeywords: 'extends implements'
          },
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      hljs.C_NUMBER_MODE,
      {
        className: 'meta', begin: '@[A-Za-z]+'
      },
      {
        begin: '=>' // No markup, just a relevance booster
      }
    ]
  }
};

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS =
    'exports register file shl array record property for mod while set ally label uses raise not ' +
    'stored class safecall var interface or private static exit index inherited to else stdcall ' +
    'override shr asm far resourcestring finalization packed virtual out and protected library do ' +
    'xorwrite goto near function end div overload object unit begin string on inline repeat until ' +
    'destructor write message program with read initialization except default nil if case cdecl in ' +
    'downto threadvar of try pascal const external constructor type public then implementation ' +
    'finally published procedure absolute reintroduce operator as is abstract alias assembler ' +
    'bitpacked break continue cppdecl cvar enumerator experimental platform deprecated ' +
    'unimplemented dynamic export far16 forward generic helper implements interrupt iochecks ' +
    'local name nodefault noreturn nostackframe oldfpccall otherwise saveregisters softfloat ' +
    'specialize strict unaligned varargs ';
  var COMMENT_MODES = [
    hljs.C_LINE_COMMENT_MODE,
    hljs.COMMENT(/\{/, /\}/, {relevance: 0}),
    hljs.COMMENT(/\(\*/, /\*\)/, {relevance: 10})
  ];
  var DIRECTIVE = {
    className: 'meta',
    variants: [
      {begin: /\{\$/, end: /\}/},
      {begin: /\(\*\$/, end: /\*\)/}
    ]
  };
  var STRING = {
    className: 'string',
    begin: /'/, end: /'/,
    contains: [{begin: /''/}]
  };
  var CHAR_STRING = {
    className: 'string', begin: /(#\d+)+/
  };
  var CLASS = {
    begin: hljs.IDENT_RE + '\\s*=\\s*class\\s*\\(', returnBegin: true,
    contains: [
      hljs.TITLE_MODE
    ]
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'function constructor destructor procedure', end: /[:;]/,
    keywords: 'function constructor|10 destructor|10 procedure|10',
    contains: [
      hljs.TITLE_MODE,
      {
        className: 'params',
        begin: /\(/, end: /\)/,
        keywords: KEYWORDS,
        contains: [STRING, CHAR_STRING, DIRECTIVE].concat(COMMENT_MODES)
      },
      DIRECTIVE
    ].concat(COMMENT_MODES)
  };
  return {
    aliases: ['dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm'],
    case_insensitive: true,
    keywords: KEYWORDS,
    illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
    contains: [
      STRING, CHAR_STRING,
      hljs.NUMBER_MODE,
      CLASS,
      FUNCTION,
      DIRECTIVE
    ].concat(COMMENT_MODES)
  };
};

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['patch'],
    contains: [
      {
        className: 'meta',
        relevance: 10,
        variants: [
          {begin: /^@@ +\-\d+,\d+ +\+\d+,\d+ +@@$/},
          {begin: /^\*\*\* +\d+,\d+ +\*\*\*\*$/},
          {begin: /^\-\-\- +\d+,\d+ +\-\-\-\-$/}
        ]
      },
      {
        className: 'comment',
        variants: [
          {begin: /Index: /, end: /$/},
          {begin: /={3,}/, end: /$/},
          {begin: /^\-{3}/, end: /$/},
          {begin: /^\*{3} /, end: /$/},
          {begin: /^\+{3}/, end: /$/},
          {begin: /\*{5}/, end: /\*{5}$/}
        ]
      },
      {
        className: 'addition',
        begin: '^\\+', end: '$'
      },
      {
        className: 'deletion',
        begin: '^\\-', end: '$'
      },
      {
        className: 'addition',
        begin: '^\\!', end: '$'
      }
    ]
  };
};

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var FILTER = {
    begin: /\|[A-Za-z]+:?/,
    keywords: {
      name:
        'truncatewords removetags linebreaksbr yesno get_digit timesince random striptags ' +
        'filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands ' +
        'title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode ' +
        'timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort ' +
        'dictsortreversed default_if_none pluralize lower join center default ' +
        'truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first ' +
        'escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize ' +
        'localtime utc timezone'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE
    ]
  };

  return {
    aliases: ['jinja'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
      hljs.COMMENT(/\{%\s*comment\s*%}/, /\{%\s*endcomment\s*%}/),
      hljs.COMMENT(/\{#/, /#}/),
      {
        className: 'template-tag',
        begin: /\{%/, end: /%}/,
        contains: [
          {
            className: 'name',
            begin: /\w+/,
            keywords: {
              name:
                'comment endcomment load templatetag ifchanged endifchanged if endif firstof for ' +
                'endfor ifnotequal endifnotequal widthratio extends include spaceless ' +
                'endspaceless regroup ifequal endifequal ssi now with cycle url filter ' +
                'endfilter debug block endblock else autoescape endautoescape csrf_token empty elif ' +
                'endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix ' +
                'plural get_current_language language get_available_languages ' +
                'get_current_language_bidi get_language_info get_language_info_list localize ' +
                'endlocalize localtime endlocaltime timezone endtimezone get_current_timezone ' +
                'verbatim'
            },
            starts: {
              endsWithParent: true,
              keywords: 'in by as',
              contains: [FILTER],
              relevance: 0
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{/, end: /}}/,
        contains: [FILTER]
      }
    ]
  };
};

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['docker'],
    case_insensitive: true,
    keywords: 'from maintainer expose env arg user onbuild stopsignal',
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      {
        beginKeywords: 'run cmd entrypoint volume add copy workdir label healthcheck shell',
        starts: {
          end: /[^\\]\n/,
          subLanguage: 'bash'
        }
      }
    ],
    illegal: '</'
  }
};

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BASIC_ATOM_RE = '[a-z\'][a-zA-Z0-9_\']*';
  var FUNCTION_NAME_RE = '(' + BASIC_ATOM_RE + ':' + BASIC_ATOM_RE + '|' + BASIC_ATOM_RE + ')';
  var ERLANG_RESERVED = {
    keyword:
      'after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if ' +
      'let not of orelse|10 query receive rem try when xor',
    literal:
      'false true'
  };

  var COMMENT = hljs.COMMENT('%', '$');
  var NUMBER = {
    className: 'number',
    begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
    relevance: 0
  };
  var NAMED_FUN = {
    begin: 'fun\\s+' + BASIC_ATOM_RE + '/\\d+'
  };
  var FUNCTION_CALL = {
    begin: FUNCTION_NAME_RE + '\\(', end: '\\)',
    returnBegin: true,
    relevance: 0,
    contains: [
      {
        begin: FUNCTION_NAME_RE, relevance: 0
      },
      {
        begin: '\\(', end: '\\)', endsWithParent: true,
        returnEnd: true,
        relevance: 0
        // "contains" defined later
      }
    ]
  };
  var TUPLE = {
    begin: '{', end: '}',
    relevance: 0
    // "contains" defined later
  };
  var VAR1 = {
    begin: '\\b_([A-Z][A-Za-z0-9_]*)?',
    relevance: 0
  };
  var VAR2 = {
    begin: '[A-Z][a-zA-Z0-9_]*',
    relevance: 0
  };
  var RECORD_ACCESS = {
    begin: '#' + hljs.UNDERSCORE_IDENT_RE,
    relevance: 0,
    returnBegin: true,
    contains: [
      {
        begin: '#' + hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
      },
      {
        begin: '{', end: '}',
        relevance: 0
        // "contains" defined later
      }
    ]
  };

  var BLOCK_STATEMENTS = {
    beginKeywords: 'fun receive if try case', end: 'end',
    keywords: ERLANG_RESERVED
  };
  BLOCK_STATEMENTS.contains = [
    COMMENT,
    NAMED_FUN,
    hljs.inherit(hljs.APOS_STRING_MODE, {className: ''}),
    BLOCK_STATEMENTS,
    FUNCTION_CALL,
    hljs.QUOTE_STRING_MODE,
    NUMBER,
    TUPLE,
    VAR1, VAR2,
    RECORD_ACCESS
  ];

  var BASIC_MODES = [
    COMMENT,
    NAMED_FUN,
    BLOCK_STATEMENTS,
    FUNCTION_CALL,
    hljs.QUOTE_STRING_MODE,
    NUMBER,
    TUPLE,
    VAR1, VAR2,
    RECORD_ACCESS
  ];
  FUNCTION_CALL.contains[1].contains = BASIC_MODES;
  TUPLE.contains = BASIC_MODES;
  RECORD_ACCESS.contains[1].contains = BASIC_MODES;

  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)',
    contains: BASIC_MODES
  };
  return {
    aliases: ['erl'],
    keywords: ERLANG_RESERVED,
    illegal: '(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))',
    contains: [
      {
        className: 'function',
        begin: '^' + BASIC_ATOM_RE + '\\s*\\(', end: '->',
        returnBegin: true,
        illegal: '\\(|#|//|/\\*|\\\\|:|;',
        contains: [
          PARAMS,
          hljs.inherit(hljs.TITLE_MODE, {begin: BASIC_ATOM_RE})
        ],
        starts: {
          end: ';|\\.',
          keywords: ERLANG_RESERVED,
          contains: BASIC_MODES
        }
      },
      COMMENT,
      {
        begin: '^-', end: '\\.',
        relevance: 0,
        excludeEnd: true,
        returnBegin: true,
        lexemes: '-' + hljs.IDENT_RE,
        keywords:
          '-module -record -undef -export -ifdef -ifndef -author -copyright -doc -vsn ' +
          '-import -include -include_lib -compile -define -else -endif -file -behaviour ' +
          '-behavior -spec',
        contains: [PARAMS]
      },
      NUMBER,
      hljs.QUOTE_STRING_MODE,
      RECORD_ACCESS,
      VAR1, VAR2,
      TUPLE,
      {begin: /\.$/} // relevance booster
    ]
  };
};

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)'
  };

  var F_KEYWORDS = {
    literal: '.False. .True.',
    keyword: 'kind do while private call intrinsic where elsewhere ' +
      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
      'goto save else use module select case ' +
      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
      'continue format pause cycle exit ' +
      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' +
      'integer real character complex logical dimension allocatable|10 parameter ' +
      'external implicit|10 none double precision assign intent optional pointer ' +
      'target in out common equivalence data',
    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
      'num_images parity popcnt poppar shifta shiftl shiftr this_image'
  };
  return {
    case_insensitive: true,
    aliases: ['f90', 'f95'],
    keywords: F_KEYWORDS,
    illegal: /\/\*/,
    contains: [
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
      {
        className: 'function',
        beginKeywords: 'subroutine function program',
        illegal: '[${=\\n]',
        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
      },
      hljs.COMMENT('!', '$', {relevance: 0}),
      {
        className: 'number',
        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var TYPEPARAM = {
    begin: '<', end: '>',
    contains: [
      hljs.inherit(hljs.TITLE_MODE, {begin: /'[a-zA-Z0-9_]+/})
    ]
  };

  return {
    aliases: ['fs'],
    keywords:
      'abstract and as assert base begin class default delegate do done ' +
      'downcast downto elif else end exception extern false finally for ' +
      'fun function global if in inherit inline interface internal lazy let ' +
      'match member module mutable namespace new null of open or ' +
      'override private public rec return sig static struct then to ' +
      'true try type upcast use val void when while with yield',
    illegal: /\/\*/,
    contains: [
      {
        // monad builder keywords (matches before non-bang kws)
        className: 'keyword',
        begin: /\b(yield|return|let|do)!/
      },
      {
        className: 'string',
        begin: '@"', end: '"',
        contains: [{begin: '""'}]
      },
      {
        className: 'string',
        begin: '"""', end: '"""'
      },
      hljs.COMMENT('\\(\\*', '\\*\\)'),
      {
        className: 'class',
        beginKeywords: 'type', end: '\\(|=|$', excludeEnd: true,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          TYPEPARAM
        ]
      },
      {
        className: 'meta',
        begin: '\\[<', end: '>\\]',
        relevance: 10
      },
      {
        className: 'symbol',
        begin: '\\B(\'[A-Za-z])\\b',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    var GCODE_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
    var GCODE_CLOSE_RE = '\\%';
    var GCODE_KEYWORDS =
      'IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT ' +
      'EQ LT GT NE GE LE OR XOR';
    var GCODE_START = {
        className: 'meta',
        begin: '([O])([0-9]+)'
    };
    var GCODE_CODE = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.COMMENT(/\(/, /\)/),
        hljs.inherit(hljs.C_NUMBER_MODE, {begin: '([-+]?([0-9]*\\.?[0-9]+\\.?))|' + hljs.C_NUMBER_RE}),
        hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
        hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
        {
            className: 'name',
            begin: '([G])([0-9]+\\.?[0-9]?)'
        },
        {
            className: 'name',
            begin: '([M])([0-9]+\\.?[0-9]?)'
        },
        {
            className: 'attr',
            begin: '(VC|VS|#)',
            end: '(\\d+)'
        },
        {
            className: 'attr',
            begin: '(VZOFX|VZOFY|VZOFZ)'
        },
        {
            className: 'built_in',
            begin: '(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)',
            end: '([-+]?([0-9]*\\.?[0-9]+\\.?))(\\])'
        },
        {
            className: 'symbol',
            variants: [
                {
                    begin: 'N', end: '\\d+',
                    illegal: '\\W'
                }
            ]
        }
    ];

    return {
        aliases: ['nc'],
        // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
        // However, most prefer all uppercase and uppercase is customary.
        case_insensitive: true,
        lexemes: GCODE_IDENT_RE,
        keywords: GCODE_KEYWORDS,
        contains: [
            {
                className: 'meta',
                begin: GCODE_CLOSE_RE
            },
            GCODE_START
        ].concat(GCODE_CODE)
    };
};

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var GO_KEYWORDS = {
    keyword:
      'break default func interface select case map struct chan else goto package switch ' +
      'const fallthrough if range type continue for import return var go defer ' +
      'bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 ' +
      'uint16 uint32 uint64 int uint uintptr rune',
    literal:
       'true false iota nil',
    built_in:
      'append cap close complex copy imag len make new panic print println real recover delete'
  };
  return {
    aliases: ['golang'],
    keywords: GO_KEYWORDS,
    illegal: '</',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'string',
        variants: [
          hljs.QUOTE_STRING_MODE,
          {begin: '\'', end: '[^\\\\]\''},
          {begin: '`', end: '`'},
        ]
      },
      {
        className: 'number',
        variants: [
          {begin: hljs.C_NUMBER_RE + '[dflsi]', relevance: 1},
          hljs.C_NUMBER_MODE
        ]
      },
      {
        begin: /:=/ // relevance booster
      },
      {
        className: 'function',
        beginKeywords: 'func', end: /\s*\{/, excludeEnd: true,
        contains: [
          hljs.TITLE_MODE,
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: GO_KEYWORDS,
            illegal: /["']/
          }
        ]
      }
    ]
  };
};

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    return {
        keywords: {
            literal : 'true false null',
            keyword:
            'byte short char int long boolean float double void ' +
            // groovy specific keywords
            'def as in assert trait ' +
            // common keywords with Java
            'super this abstract static volatile transient public private protected synchronized final ' +
            'class interface enum if else for while switch case break default continue ' +
            'throw throws try catch finally implements extends new import package return instanceof'
        },

        contains: [
            hljs.COMMENT(
                '/\\*\\*',
                '\\*/',
                {
                    relevance : 0,
                    contains : [
                      {
                          // eat up @'s in emails to prevent them to be recognized as doctags
                          begin: /\w+@/, relevance: 0
                      },
                      {
                          className : 'doctag',
                          begin : '@[A-Za-z]+'
                      }
                    ]
                }
            ),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: 'string',
                begin: '"""', end: '"""'
            },
            {
                className: 'string',
                begin: "'''", end: "'''"
            },
            {
                className: 'string',
                begin: "\\$/", end: "/\\$",
                relevance: 10
            },
            hljs.APOS_STRING_MODE,
            {
                className: 'regexp',
                begin: /~?\/[^\/\n]+\//,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: 'meta',
                begin: "^#!/usr/bin/env", end: '$',
                illegal: '\n'
            },
            hljs.BINARY_NUMBER_MODE,
            {
                className: 'class',
                beginKeywords: 'class interface trait enum', end: '{',
                illegal: ':',
                contains: [
                    {beginKeywords: 'extends implements'},
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.C_NUMBER_MODE,
            {
                className: 'meta', begin: '@[A-Za-z]+'
            },
            {
                // highlight map keys and named parameters as strings
                className: 'string', begin: /[^\?]{0}[A-Za-z0-9_$]+ *:/
            },
            {
                // catch middle element of the ternary operator
                // to avoid highlight it as a label, named parameter, or map key
                begin: /\?/, end: /\:/
            },
            {
                // highlight labeled statements
                className: 'symbol', begin: '^\\s*[A-Za-z0-9_$]+:',
                relevance: 0
            }
        ],
        illegal: /#|<\//
    }
};

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BUILT_INS = {'builtin-name': 'each in with if else unless bindattr action collection debugger log outlet template unbound view yield'};
  return {
    aliases: ['hbs', 'html.hbs', 'html.handlebars'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
    hljs.COMMENT('{{!(--)?', '(--)?}}'),
      {
        className: 'template-tag',
        begin: /\{\{[#\/]/, end: /\}\}/,
        contains: [
          {
            className: 'name',
            begin: /[a-zA-Z\.-]+/,
            keywords: BUILT_INS,
            starts: {
              endsWithParent: true, relevance: 0,
              contains: [
                hljs.QUOTE_STRING_MODE
              ]
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{/, end: /\}\}/,
        keywords: BUILT_INS
      }
    ]
  };
};

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMENT = {
    variants: [
      hljs.COMMENT('--', '$'),
      hljs.COMMENT(
        '{-',
        '-}',
        {
          contains: ['self']
        }
      )
    ]
  };

  var PRAGMA = {
    className: 'meta',
    begin: '{-#', end: '#-}'
  };

  var PREPROCESSOR = {
    className: 'meta',
    begin: '^#', end: '$'
  };

  var CONSTRUCTOR = {
    className: 'type',
    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (build-in, infix).
    relevance: 0
  };

  var LIST = {
    begin: '\\(', end: '\\)',
    illegal: '"',
    contains: [
      PRAGMA,
      PREPROCESSOR,
      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'},
      hljs.inherit(hljs.TITLE_MODE, {begin: '[_a-z][\\w\']*'}),
      COMMENT
    ]
  };

  var RECORD = {
    begin: '{', end: '}',
    contains: LIST.contains
  };

  return {
    aliases: ['hs'],
    keywords:
      'let in if then else case of where do module import hiding ' +
      'qualified type data newtype deriving class instance as default ' +
      'infix infixl infixr foreign export ccall stdcall cplusplus ' +
      'jvm dotnet safe unsafe family forall mdo proc rec',
    contains: [

      // Top-level constructions.

      {
        beginKeywords: 'module', end: 'where',
        keywords: 'module where',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },
      {
        begin: '\\bimport\\b', end: '$',
        keywords: 'import qualified as hiding',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },

      {
        className: 'class',
        begin: '^(\\s*)?(class|instance)\\b', end: 'where',
        keywords: 'class family instance where',
        contains: [CONSTRUCTOR, LIST, COMMENT]
      },
      {
        className: 'class',
        begin: '\\b(data|(new)?type)\\b', end: '$',
        keywords: 'data family type newtype deriving',
        contains: [PRAGMA, CONSTRUCTOR, LIST, RECORD, COMMENT]
      },
      {
        beginKeywords: 'default', end: '$',
        contains: [CONSTRUCTOR, LIST, COMMENT]
      },
      {
        beginKeywords: 'infix infixl infixr', end: '$',
        contains: [hljs.C_NUMBER_MODE, COMMENT]
      },
      {
        begin: '\\bforeign\\b', end: '$',
        keywords: 'foreign import export ccall stdcall cplusplus jvm ' +
                  'dotnet safe unsafe',
        contains: [CONSTRUCTOR, hljs.QUOTE_STRING_MODE, COMMENT]
      },
      {
        className: 'meta',
        begin: '#!\\/usr\\/bin\\/env\ runhaskell', end: '$'
      },

      // "Whitespaces".

      PRAGMA,
      PREPROCESSOR,

      // Literals and names.

      // TODO: characters.
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      CONSTRUCTOR,
      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),

      COMMENT,

      {begin: '->|<-'} // No markup, relevance booster
    ]
  };
};

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';

  var HAXE_BASIC_TYPES = 'Int Float String Bool Dynamic Void Array ';

  return {
    aliases: ['hx'],
    keywords: {
      keyword: 'break case cast catch continue default do dynamic else enum extern ' +
               'for function here if import in inline never new override package private get set ' +
               'public return static super switch this throw trace try typedef untyped using var while ' +
               HAXE_BASIC_TYPES,
      built_in:
        'trace this',
      literal:
        'true false null _'
    },
    contains: [
      { className: 'string', // interpolate-able strings
        begin: '\'', end: '\'',
        contains: [
          hljs.BACKSLASH_ESCAPE,
          { className: 'subst', // interpolation
            begin: '\\$\\{', end: '\\}'
          },
          { className: 'subst', // interpolation
            begin: '\\$', end: '\\W}'
          }
        ]
      },
      hljs.QUOTE_STRING_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      { className: 'meta', // compiler meta
        begin: '@:', end: '$'
      },
      { className: 'meta', // compiler conditionals
        begin: '#', end: '$',
        keywords: {'meta-keyword': 'if else elseif end error'}
      },
      { className: 'type', // function types
        begin: ':[ \t]*', end: '[^A-Za-z0-9_ \t\\->]',
        excludeBegin: true, excludeEnd: true,
        relevance: 0
      },
      { className: 'type', // types
        begin: ':[ \t]*', end: '\\W',
        excludeBegin: true, excludeEnd: true
      },
      { className: 'type', // instantiation
        begin: 'new *', end: '\\W',
        excludeBegin: true, excludeEnd: true
      },
      { className: 'class', // enums
        beginKeywords: 'enum', end: '\\{',
        contains: [
          hljs.TITLE_MODE
        ]
      },
      { className: 'class', // abstracts
        beginKeywords: 'abstract', end: '[\\{$]',
        contains: [
          { className: 'type',
            begin: '\\(', end: '\\)',
            excludeBegin: true, excludeEnd: true
          },
          { className: 'type',
            begin: 'from +', end: '\\W',
            excludeBegin: true, excludeEnd: true
          },
          { className: 'type',
            begin: 'to +', end: '\\W',
            excludeBegin: true, excludeEnd: true
          },
          hljs.TITLE_MODE
        ],
        keywords: {
          keyword: 'abstract from to'
        }
      },
      { className: 'class', // classes
        begin: '\\b(class|interface) +', end: '[\\{$]',  excludeEnd: true,
        keywords: 'class interface',
        contains: [
          { className: 'keyword',
            begin: '\\b(extends|implements) +',
            keywords: 'extends implements',
            contains: [
              {
                className: 'type',
                begin: hljs.IDENT_RE,
                relevance: 0
              }
            ]
          },
          hljs.TITLE_MODE
        ]
      },
      { className: 'function',
        beginKeywords: 'function', end: '\\(', excludeEnd: true,
        illegal: '\\S',
        contains: [
          hljs.TITLE_MODE
        ]
      }
    ],
    illegal: /<\//
  };
};

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var JAVA_IDENT_RE = '[\u00C0-\u02B8a-zA-Z_$][\u00C0-\u02B8a-zA-Z_$0-9]*';
  var GENERIC_IDENT_RE = JAVA_IDENT_RE + '(<' + JAVA_IDENT_RE + '(\\s*,\\s*' + JAVA_IDENT_RE + ')*>)?';
  var KEYWORDS =
    'false synchronized int abstract float private char boolean static null if const ' +
    'for true while long strictfp finally protected import native final void ' +
    'enum else break transient catch instanceof byte super volatile case assert short ' +
    'package default double public try this switch continue throws protected public private ' +
    'module requires exports do';

  // https://docs.oracle.com/javase/7/docs/technotes/guides/language/underscores-literals.html
  var JAVA_NUMBER_RE = '\\b' +
    '(' +
      '0[bB]([01]+[01_]+[01]+|[01]+)' + // 0b...
      '|' +
      '0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)' + // 0x...
      '|' +
      '(' +
        '([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?' +
        '|' +
        '\\.([\\d]+[\\d_]+[\\d]+|[\\d]+)' +
      ')' +
      '([eE][-+]?\\d+)?' + // octal, decimal, float
    ')' +
    '[lLfF]?';
  var JAVA_NUMBER_MODE = {
    className: 'number',
    begin: JAVA_NUMBER_RE,
    relevance: 0
  };

  return {
    aliases: ['jsp'],
    keywords: KEYWORDS,
    illegal: /<\/|#/,
    contains: [
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          relevance : 0,
          contains : [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/, relevance: 0
            },
            {
              className : 'doctag',
              begin : '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'class',
        beginKeywords: 'class interface', end: /[{;=]/, excludeEnd: true,
        keywords: 'class interface',
        illegal: /[:"\[\]]/,
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: 'new throw return else',
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
            relevance: 0,
            contains: [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              hljs.APOS_STRING_MODE,
              hljs.QUOTE_STRING_MODE,
              hljs.C_NUMBER_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      JAVA_NUMBER_MODE,
      {
        className: 'meta', begin: '@[A-Za-z]+'
      }
    ]
  };
};

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var KEYWORDS = {
    keyword:
      'in of if for while finally var new function do return void else break catch ' +
      'instanceof with throw case default try this switch continue typeof delete ' +
      'let yield const export super debugger as async await static ' +
      // ECMAScript 6 modules import
      'import from as'
    ,
    literal:
      'true false null undefined NaN Infinity',
    built_in:
      'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
      'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
      'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
      'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
      'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
      'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
      'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
      'Promise'
  };
  var EXPRESSIONS;
  var NUMBER = {
    className: 'number',
    variants: [
      { begin: '\\b(0[bB][01]+)' },
      { begin: '\\b(0[oO][0-7]+)' },
      { begin: hljs.C_NUMBER_RE }
    ],
    relevance: 0
  };
  var SUBST = {
    className: 'subst',
    begin: '\\$\\{', end: '\\}',
    keywords: KEYWORDS,
    contains: []  // defined later
  };
  var TEMPLATE_STRING = {
    className: 'string',
    begin: '`', end: '`',
    contains: [
      hljs.BACKSLASH_ESCAPE,
      SUBST
    ]
  };
  SUBST.contains = [
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    TEMPLATE_STRING,
    NUMBER,
    hljs.REGEXP_MODE
  ]
  var PARAMS_CONTAINS = SUBST.contains.concat([
    hljs.C_BLOCK_COMMENT_MODE,
    hljs.C_LINE_COMMENT_MODE
  ]);

  return {
    aliases: ['js', 'jsx'],
    keywords: KEYWORDS,
    contains: [
      {
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
      },
      {
        className: 'meta',
        begin: /^#!/, end: /$/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      TEMPLATE_STRING,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      NUMBER,
      { // object attr container
        begin: /[{,]\s*/, relevance: 0,
        contains: [
          {
            begin: IDENT_RE + '\\s*:', returnBegin: true,
            relevance: 0,
            contains: [{className: 'attr', begin: IDENT_RE, relevance: 0}]
          }
        ]
      },
      { // "value" container
        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
        keywords: 'return throw case',
        contains: [
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.REGEXP_MODE,
          {
            className: 'function',
            begin: '(\\(.*?\\)|' + IDENT_RE + ')\\s*=>', returnBegin: true,
            end: '\\s*=>',
            contains: [
              {
                className: 'params',
                variants: [
                  {
                    begin: IDENT_RE
                  },
                  {
                    begin: /\(\s*\)/,
                  },
                  {
                    begin: /\(/, end: /\)/,
                    excludeBegin: true, excludeEnd: true,
                    keywords: KEYWORDS,
                    contains: PARAMS_CONTAINS
                  }
                ]
              }
            ]
          },
          { // E4X / JSX
            begin: /</, end: /(\/\w+|\w+\/)>/,
            subLanguage: 'xml',
            contains: [
              {begin: /<\w+\s*\/>/, skip: true},
              {
                begin: /<\w+/, end: /(\/\w+|\w+\/)>/, skip: true,
                contains: [
                  {begin: /<\w+\s*\/>/, skip: true},
                  'self'
                ]
              }
            ]
          }
        ],
        relevance: 0
      },
      {
        className: 'function',
        beginKeywords: 'function', end: /\{/, excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE}),
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            contains: PARAMS_CONTAINS
          }
        ],
        illegal: /\[|%/
      },
      {
        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      },
      hljs.METHOD_GUARD,
      { // ES6 class
        className: 'class',
        beginKeywords: 'class', end: /[{;=]/, excludeEnd: true,
        illegal: /[:"\[\]]/,
        contains: [
          {beginKeywords: 'extends'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        beginKeywords: 'constructor', end: /\{/, excludeEnd: true
      }
    ],
    illegal: /#(?!!)/
  };
};

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var LITERALS = {literal: 'true false null'};
  var TYPES = [
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE
  ];
  var VALUE_CONTAINER = {
    end: ',', endsWithParent: true, excludeEnd: true,
    contains: TYPES,
    keywords: LITERALS
  };
  var OBJECT = {
    begin: '{', end: '}',
    contains: [
      {
        className: 'attr',
        begin: /"/, end: /"/,
        contains: [hljs.BACKSLASH_ESCAPE],
        illegal: '\\n',
      },
      hljs.inherit(VALUE_CONTAINER, {begin: /:/})
    ],
    illegal: '\\S'
  };
  var ARRAY = {
    begin: '\\[', end: '\\]',
    contains: [hljs.inherit(VALUE_CONTAINER)], // inherit is a workaround for a bug that makes shared modes with endsWithParent compile only the ending of one of the parents
    illegal: '\\S'
  };
  TYPES.splice(TYPES.length, 0, OBJECT, ARRAY);
  return {
    contains: TYPES,
    keywords: LITERALS,
    illegal: '\\S'
  };
};

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  // Since there are numerous special names in Julia, it is too much trouble
  // to maintain them by hand. Hence these names (i.e. keywords, literals and
  // built-ins) are automatically generated from Julia v0.6 itself through
  // the following scripts for each.

  var KEYWORDS = {
    // # keyword generator, multi-word keywords handled manually below
    // foreach(println, ["in", "isa", "where"])
    // for kw in Base.REPLCompletions.complete_keyword("")
    //     if !(contains(kw, " ") || kw == "struct")
    //         println(kw)
    //     end
    // end
    keyword:
      'in isa where ' +
      'baremodule begin break catch ccall const continue do else elseif end export false finally for function ' +
      'global if import importall let local macro module quote return true try using while ' +
      // legacy, to be deprecated in the next release
      'type immutable abstract bitstype typealias ',

    // # literal generator
    // println("true")
    // println("false")
    // for name in Base.REPLCompletions.completions("", 0)[1]
    //     try
    //         v = eval(Symbol(name))
    //         if !(v isa Function || v isa Type || v isa TypeVar || v isa Module || v isa Colon)
    //             println(name)
    //         end
    //     end
    // end
    literal:
      'true false ' +
      'ARGS C_NULL DevNull ENDIAN_BOM ENV I Inf Inf16 Inf32 Inf64 InsertionSort JULIA_HOME LOAD_PATH MergeSort ' +
      'NaN NaN16 NaN32 NaN64 PROGRAM_FILE QuickSort RoundDown RoundFromZero RoundNearest RoundNearestTiesAway ' +
      'RoundNearestTiesUp RoundToZero RoundUp STDERR STDIN STDOUT VERSION catalan e|0 eu|0 eulergamma golden im ' +
      'nothing pi γ π φ ',

    // # built_in generator:
    // for name in Base.REPLCompletions.completions("", 0)[1]
    //     try
    //         v = eval(Symbol(name))
    //         if v isa Type || v isa TypeVar
    //             println(name)
    //         end
    //     end
    // end
    built_in:
      'ANY AbstractArray AbstractChannel AbstractFloat AbstractMatrix AbstractRNG AbstractSerializer AbstractSet ' +
      'AbstractSparseArray AbstractSparseMatrix AbstractSparseVector AbstractString AbstractUnitRange AbstractVecOrMat ' +
      'AbstractVector Any ArgumentError Array AssertionError Associative Base64DecodePipe Base64EncodePipe Bidiagonal '+
      'BigFloat BigInt BitArray BitMatrix BitVector Bool BoundsError BufferStream CachingPool CapturedException ' +
      'CartesianIndex CartesianRange Cchar Cdouble Cfloat Channel Char Cint Cintmax_t Clong Clonglong ClusterManager ' +
      'Cmd CodeInfo Colon Complex Complex128 Complex32 Complex64 CompositeException Condition ConjArray ConjMatrix ' +
      'ConjVector Cptrdiff_t Cshort Csize_t Cssize_t Cstring Cuchar Cuint Cuintmax_t Culong Culonglong Cushort Cwchar_t ' +
      'Cwstring DataType Date DateFormat DateTime DenseArray DenseMatrix DenseVecOrMat DenseVector Diagonal Dict ' +
      'DimensionMismatch Dims DirectIndexString Display DivideError DomainError EOFError EachLine Enum Enumerate ' +
      'ErrorException Exception ExponentialBackOff Expr Factorization FileMonitor Float16 Float32 Float64 Function ' +
      'Future GlobalRef GotoNode HTML Hermitian IO IOBuffer IOContext IOStream IPAddr IPv4 IPv6 IndexCartesian IndexLinear ' +
      'IndexStyle InexactError InitError Int Int128 Int16 Int32 Int64 Int8 IntSet Integer InterruptException ' +
      'InvalidStateException Irrational KeyError LabelNode LinSpace LineNumberNode LoadError LowerTriangular MIME Matrix ' +
      'MersenneTwister Method MethodError MethodTable Module NTuple NewvarNode NullException Nullable Number ObjectIdDict ' +
      'OrdinalRange OutOfMemoryError OverflowError Pair ParseError PartialQuickSort PermutedDimsArray Pipe ' +
      'PollingFileWatcher ProcessExitedException Ptr QuoteNode RandomDevice Range RangeIndex Rational RawFD ' +
      'ReadOnlyMemoryError Real ReentrantLock Ref Regex RegexMatch RemoteChannel RemoteException RevString RoundingMode ' +
      'RowVector SSAValue SegmentationFault SerializationState Set SharedArray SharedMatrix SharedVector Signed ' +
      'SimpleVector Slot SlotNumber SparseMatrixCSC SparseVector StackFrame StackOverflowError StackTrace StepRange ' +
      'StepRangeLen StridedArray StridedMatrix StridedVecOrMat StridedVector String SubArray SubString SymTridiagonal ' +
      'Symbol Symmetric SystemError TCPSocket Task Text TextDisplay Timer Tridiagonal Tuple Type TypeError TypeMapEntry ' +
      'TypeMapLevel TypeName TypeVar TypedSlot UDPSocket UInt UInt128 UInt16 UInt32 UInt64 UInt8 UndefRefError UndefVarError ' +
      'UnicodeError UniformScaling Union UnionAll UnitRange Unsigned UpperTriangular Val Vararg VecElement VecOrMat Vector ' +
      'VersionNumber Void WeakKeyDict WeakRef WorkerConfig WorkerPool '
  };

  // ref: http://julia.readthedocs.org/en/latest/manual/variables/#allowed-variable-names
  var VARIABLE_NAME_RE = '[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*';

  // placeholder for recursive self-reference
  var DEFAULT = {
    lexemes: VARIABLE_NAME_RE, keywords: KEYWORDS, illegal: /<\//
  };

  // ref: http://julia.readthedocs.org/en/latest/manual/integers-and-floating-point-numbers/
  var NUMBER = {
    className: 'number',
    // supported numeric literals:
    //  * binary literal (e.g. 0x10)
    //  * octal literal (e.g. 0o76543210)
    //  * hexadecimal literal (e.g. 0xfedcba876543210)
    //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
    //  * decimal literal (e.g. 9876543210, 100_000_000)
    //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
    begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
    relevance: 0
  };

  var CHAR = {
    className: 'string',
    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
  };

  var INTERPOLATION = {
    className: 'subst',
    begin: /\$\(/, end: /\)/,
    keywords: KEYWORDS
  };

  var INTERPOLATED_VARIABLE = {
    className: 'variable',
    begin: '\\$' + VARIABLE_NAME_RE
  };

  // TODO: neatly escape normal code in string literal
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
    variants: [
      { begin: /\w*"""/, end: /"""\w*/, relevance: 10 },
      { begin: /\w*"/, end: /"\w*/ }
    ]
  };

  var COMMAND = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
    begin: '`', end: '`'
  };

  var MACROCALL = {
    className: 'meta',
    begin: '@' + VARIABLE_NAME_RE
  };

  var COMMENT = {
    className: 'comment',
    variants: [
      { begin: '#=', end: '=#', relevance: 10 },
      { begin: '#', end: '$' }
    ]
  };

  DEFAULT.contains = [
    NUMBER,
    CHAR,
    STRING,
    COMMAND,
    MACROCALL,
    COMMENT,
    hljs.HASH_COMMENT_MODE,
    {
      className: 'keyword',
      begin:
        '\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b'
    },
    {begin: /<:/}  // relevance booster
  ];
  INTERPOLATION.contains = DEFAULT.contains;

  return DEFAULT;
};

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      'abstract as val var vararg get set class object open private protected public noinline ' +
      'crossinline dynamic final enum if else do while for when throw try catch finally ' +
      'import package is in fun override companion reified inline lateinit init' +
      'interface annotation data sealed internal infix operator out by constructor super ' +
      // to be deleted soon
      'trait volatile transient native default',
    built_in:
      'Byte Short Char Int Long Boolean Float Double Void Unit Nothing',
    literal:
      'true false null'
  };
  var KEYWORDS_WITH_LABEL = {
    className: 'keyword',
    begin: /\b(break|continue|return|this)\b/,
    starts: {
      contains: [
        {
          className: 'symbol',
          begin: /@\w+/
        }
      ]
    }
  };
  var LABEL = {
    className: 'symbol', begin: hljs.UNDERSCORE_IDENT_RE + '@'
  };

  // for string templates
  var SUBST = {
    className: 'subst',
    begin: '\\${', end: '}', contains: [hljs.APOS_STRING_MODE, hljs.C_NUMBER_MODE]
  };
  var VARIABLE = {
    className: 'variable', begin: '\\$' + hljs.UNDERSCORE_IDENT_RE
  };
  var STRING = {
    className: 'string',
    variants: [
      {
        begin: '"""', end: '"""',
        contains: [VARIABLE, SUBST]
      },
      // Can't use built-in modes easily, as we want to use STRING in the meta
      // context as 'meta-string' and there's no syntax to remove explicitly set
      // classNames in built-in modes.
      {
        begin: '\'', end: '\'',
        illegal: /\n/,
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '"', end: '"',
        illegal: /\n/,
        contains: [hljs.BACKSLASH_ESCAPE, VARIABLE, SUBST]
      }
    ]
  };

  var ANNOTATION_USE_SITE = {
    className: 'meta', begin: '@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*' + hljs.UNDERSCORE_IDENT_RE + ')?'
  };
  var ANNOTATION = {
    className: 'meta', begin: '@' + hljs.UNDERSCORE_IDENT_RE,
    contains: [
      {
        begin: /\(/, end: /\)/,
        contains: [
          hljs.inherit(STRING, {className: 'meta-string'})
        ]
      }
    ]
  };

  return {
    keywords: KEYWORDS,
    contains : [
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          relevance : 0,
          contains : [{
            className : 'doctag',
            begin : '@[A-Za-z]+'
          }]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      KEYWORDS_WITH_LABEL,
      LABEL,
      ANNOTATION_USE_SITE,
      ANNOTATION,
      {
        className: 'function',
        beginKeywords: 'fun', end: '[(]|$',
        returnBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS,
        illegal: /fun\s+(<.*>)?[^\s\(]+(\s+[^\s\(]+)\s*=/,
        relevance: 5,
        contains: [
          {
            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
            relevance: 0,
            contains: [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className: 'type',
            begin: /</, end: />/, keywords: 'reified',
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            endsParent: true,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              {
                begin: /:/, end: /[=,\/]/, endsWithParent: true,
                contains: [
                  {className: 'type', begin: hljs.UNDERSCORE_IDENT_RE},
                  hljs.C_LINE_COMMENT_MODE,
                  hljs.C_BLOCK_COMMENT_MODE
                ],
                relevance: 0
              },
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              ANNOTATION_USE_SITE,
              ANNOTATION,
              STRING,
              hljs.C_NUMBER_MODE
            ]
          },
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface trait', end: /[:\{(]|$/, // remove 'trait' when removed from KEYWORDS
        excludeEnd: true,
        illegal: 'extends implements',
        contains: [
          {beginKeywords: 'public protected internal private constructor'},
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'type',
            begin: /</, end: />/, excludeBegin: true, excludeEnd: true,
            relevance: 0
          },
          {
            className: 'type',
            begin: /[,:]\s*/, end: /[<\(,]|$/, excludeBegin: true, returnEnd: true
          },
          ANNOTATION_USE_SITE,
          ANNOTATION
        ]
      },
      STRING,
      {
        className: 'meta',
        begin: "^#!/usr/bin/env", end: '$',
        illegal: '\n'
      },
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE        = '[\\w-]+'; // yes, Less identifiers may begin with a digit
  var INTERP_IDENT_RE = '(' + IDENT_RE + '|@{' + IDENT_RE + '})';

  /* Generic Modes */

  var RULES = [], VALUE = []; // forward def. for recursive modes

  var STRING_MODE = function(c) { return {
    // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
    className: 'string', begin: '~?' + c + '.*?' + c
  };};

  var IDENT_MODE = function(name, begin, relevance) { return {
    className: name, begin: begin, relevance: relevance
  };};

  var PARENS_MODE = {
    // used only to properly balance nested parens inside mixin call, def. arg list
    begin: '\\(', end: '\\)', contains: VALUE, relevance: 0
  };

  // generic Less highlighter (used almost everywhere except selectors):
  VALUE.push(
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    STRING_MODE("'"),
    STRING_MODE('"'),
    hljs.CSS_NUMBER_MODE, // fixme: it does not include dot for numbers like .5em :(
    {
      begin: '(url|data-uri)\\(',
      starts: {className: 'string', end: '[\\)\\n]', excludeEnd: true}
    },
    IDENT_MODE('number', '#[0-9A-Fa-f]+\\b'),
    PARENS_MODE,
    IDENT_MODE('variable', '@@?' + IDENT_RE, 10),
    IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),
    IDENT_MODE('built_in', '~?`[^`]*?`'), // inline javascript (or whatever host language) *multiline* string
    { // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
      className: 'attribute', begin: IDENT_RE + '\\s*:', end: ':', returnBegin: true, excludeEnd: true
    },
    {
      className: 'meta',
      begin: '!important'
    }
  );

  var VALUE_WITH_RULESETS = VALUE.concat({
    begin: '{', end: '}', contains: RULES
  });

  var MIXIN_GUARD_MODE = {
    beginKeywords: 'when', endsWithParent: true,
    contains: [{beginKeywords: 'and not'}].concat(VALUE) // using this form to override VALUE’s 'function' match
  };

  /* Rule-Level Modes */

  var RULE_MODE = {
    begin: INTERP_IDENT_RE + '\\s*:', returnBegin: true, end: '[;}]',
    relevance: 0,
    contains: [
      {
        className: 'attribute',
        begin: INTERP_IDENT_RE, end: ':', excludeEnd: true,
        starts: {
          endsWithParent: true, illegal: '[<=$]',
          relevance: 0,
          contains: VALUE
        }
      }
    ]
  };

  var AT_RULE_MODE = {
    className: 'keyword',
    begin: '@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b',
    starts: {end: '[;{}]', returnEnd: true, contains: VALUE, relevance: 0}
  };

  // variable definitions and calls
  var VAR_RULE_MODE = {
    className: 'variable',
    variants: [
      // using more strict pattern for higher relevance to increase chances of Less detection.
      // this is *the only* Less specific statement used in most of the sources, so...
      // (we’ll still often loose to the css-parser unless there's '//' comment,
      // simply because 1 variable just can't beat 99 properties :)
      {begin: '@' + IDENT_RE + '\\s*:', relevance: 15},
      {begin: '@' + IDENT_RE}
    ],
    starts: {end: '[;}]', returnEnd: true, contains: VALUE_WITH_RULESETS}
  };

  var SELECTOR_MODE = {
    // first parse unambiguous selectors (i.e. those not starting with tag)
    // then fall into the scary lookahead-discriminator variant.
    // this mode also handles mixin definitions and calls
    variants: [{
      begin: '[\\.#:&\\[>]', end: '[;{}]'  // mixin calls end with ';'
      }, {
      begin: INTERP_IDENT_RE, end: '{'
    }],
    returnBegin: true,
    returnEnd:   true,
    illegal: '[<=\'$"]',
    relevance: 0,
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      MIXIN_GUARD_MODE,
      IDENT_MODE('keyword',  'all\\b'),
      IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),     // otherwise it’s identified as tag
      IDENT_MODE('selector-tag',  INTERP_IDENT_RE + '%?', 0), // '%' for more consistent coloring of @keyframes "tags"
      IDENT_MODE('selector-id', '#' + INTERP_IDENT_RE),
      IDENT_MODE('selector-class', '\\.' + INTERP_IDENT_RE, 0),
      IDENT_MODE('selector-tag',  '&', 0),
      {className: 'selector-attr', begin: '\\[', end: '\\]'},
      {className: 'selector-pseudo', begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/},
      {begin: '\\(', end: '\\)', contains: VALUE_WITH_RULESETS}, // argument list of parametric mixins
      {begin: '!important'} // eat !important after mixin call or it will be colored as tag
    ]
  };

  RULES.push(
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    AT_RULE_MODE,
    VAR_RULE_MODE,
    RULE_MODE,
    SELECTOR_MODE
  );

  return {
    case_insensitive: true,
    illegal: '[=>\'/<($"]',
    contains: RULES
  };
};

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var LISP_IDENT_RE = '[a-zA-Z_\\-\\+\\*\\/\\<\\=\\>\\&\\#][a-zA-Z0-9_\\-\\+\\*\\/\\<\\=\\>\\&\\#!]*';
  var MEC_RE = '\\|[^]*?\\|';
  var LISP_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|\\-)?\\d+)?';
  var SHEBANG = {
    className: 'meta',
    begin: '^#!', end: '$'
  };
  var LITERAL = {
    className: 'literal',
    begin: '\\b(t{1}|nil)\\b'
  };
  var NUMBER = {
    className: 'number',
    variants: [
      {begin: LISP_SIMPLE_NUMBER_RE, relevance: 0},
      {begin: '#(b|B)[0-1]+(/[0-1]+)?'},
      {begin: '#(o|O)[0-7]+(/[0-7]+)?'},
      {begin: '#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?'},
      {begin: '#(c|C)\\(' + LISP_SIMPLE_NUMBER_RE + ' +' + LISP_SIMPLE_NUMBER_RE, end: '\\)'}
    ]
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
  var COMMENT = hljs.COMMENT(
    ';', '$',
    {
      relevance: 0
    }
  );
  var VARIABLE = {
    begin: '\\*', end: '\\*'
  };
  var KEYWORD = {
    className: 'symbol',
    begin: '[:&]' + LISP_IDENT_RE
  };
  var IDENT = {
    begin: LISP_IDENT_RE,
    relevance: 0
  };
  var MEC = {
    begin: MEC_RE
  };
  var QUOTED_LIST = {
    begin: '\\(', end: '\\)',
    contains: ['self', LITERAL, STRING, NUMBER, IDENT]
  };
  var QUOTED = {
    contains: [NUMBER, STRING, VARIABLE, KEYWORD, QUOTED_LIST, IDENT],
    variants: [
      {
        begin: '[\'`]\\(', end: '\\)'
      },
      {
        begin: '\\(quote ', end: '\\)',
        keywords: {name: 'quote'}
      },
      {
        begin: '\'' + MEC_RE
      }
    ]
  };
  var QUOTED_ATOM = {
    variants: [
      {begin: '\'' + LISP_IDENT_RE},
      {begin: '#\'' + LISP_IDENT_RE + '(::' + LISP_IDENT_RE + ')*'}
    ]
  };
  var LIST = {
    begin: '\\(\\s*', end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  LIST.contains = [
    {
      className: 'name',
      variants: [
        {begin: LISP_IDENT_RE},
        {begin: MEC_RE}
      ]
    },
    BODY
  ];
  BODY.contains = [QUOTED, QUOTED_ATOM, LIST, LITERAL, NUMBER, STRING, COMMENT, VARIABLE, KEYWORD, MEC, IDENT];

  return {
    illegal: /\S/,
    contains: [
      NUMBER,
      SHEBANG,
      LITERAL,
      STRING,
      COMMENT,
      QUOTED,
      QUOTED_ATOM,
      LIST,
      IDENT
    ]
  };
};

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var OPENING_LONG_BRACKET = '\\[=*\\[';
  var CLOSING_LONG_BRACKET = '\\]=*\\]';
  var LONG_BRACKETS = {
    begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
    contains: ['self']
  };
  var COMMENTS = [
    hljs.COMMENT('--(?!' + OPENING_LONG_BRACKET + ')', '$'),
    hljs.COMMENT(
      '--' + OPENING_LONG_BRACKET,
      CLOSING_LONG_BRACKET,
      {
        contains: [LONG_BRACKETS],
        relevance: 10
      }
    )
  ];
  return {
    lexemes: hljs.UNDERSCORE_IDENT_RE,
    keywords: {
      literal: "true false nil",
      keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
      built_in:
        //Metatags and globals:
        '_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len ' +
        '__gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert ' +
        //Standard methods and properties:
        'collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring' +
        'module next pairs pcall print rawequal rawget rawset require select setfenv' +
        'setmetatable tonumber tostring type unpack xpcall arg self' +
        //Library methods and properties (one line per library):
        'coroutine resume yield status wrap create running debug getupvalue ' +
        'debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv ' +
        'io lines write close flush open output type read stderr stdin input stdout popen tmpfile ' +
        'math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan ' +
        'os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall ' +
        'string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower ' +
        'table setn insert getn foreachi maxn foreach concat sort remove'
    },
    contains: COMMENTS.concat([
      {
        className: 'function',
        beginKeywords: 'function', end: '\\)',
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
          {
            className: 'params',
            begin: '\\(', endsWithParent: true,
            contains: COMMENTS
          }
        ].concat(COMMENTS)
      },
      hljs.C_NUMBER_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
        contains: [LONG_BRACKETS],
        relevance: 5
      }
    ])
  };
};

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  /* Variables: simple (eg $(var)) and special (eg $@) */
  var VARIABLE = {
    className: 'variable',
    variants: [
      {
        begin: '\\$\\(' + hljs.UNDERSCORE_IDENT_RE + '\\)',
        contains: [hljs.BACKSLASH_ESCAPE],
      },
      {
        begin: /\$[@%<?\^\+\*]/
      },
    ]
  };
  /* Quoted string with variables inside */
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/, end: /"/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      VARIABLE,
    ]
  };
  /* Function: $(func arg,...) */
  var FUNC = {
    className: 'variable',
    begin: /\$\([\w-]+\s/, end: /\)/,
    keywords: {
      built_in:
        'subst patsubst strip findstring filter filter-out sort ' +
        'word wordlist firstword lastword dir notdir suffix basename ' +
        'addsuffix addprefix join wildcard realpath abspath error warning ' +
        'shell origin flavor foreach if or and call eval file value',
    },
    contains: [
      VARIABLE,
    ]
  };
  /* Variable assignment */
  var VAR_ASSIG = {
    begin: '^' + hljs.UNDERSCORE_IDENT_RE + '\\s*[:+?]?=',
    illegal: '\\n',
    returnBegin: true,
    contains: [
      {
        begin: '^' + hljs.UNDERSCORE_IDENT_RE, end: '[:+?]?=',
        excludeEnd: true,
      }
    ]
  };
  /* Meta targets (.PHONY) */
  var META = {
    className: 'meta',
    begin: /^\.PHONY:/, end: /$/,
    keywords: {'meta-keyword': '.PHONY'},
    lexemes: /[\.\w]+/
  };
  /* Targets */
  var TARGET = {
    className: 'section',
    begin: /^[^\s]+:/, end: /$/,
    contains: [VARIABLE,]
  };
  return {
    aliases: ['mk', 'mak'],
    keywords:
      'define endef undefine ifdef ifndef ifeq ifneq else endif ' +
      'include -include sinclude override export unexport private vpath',
    lexemes: /[\w-]+/,
    contains: [
      hljs.HASH_COMMENT_MODE,
      VARIABLE,
      QUOTE_STRING,
      FUNC,
      VAR_ASSIG,
      META,
      TARGET,
    ]
  };
};

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['md', 'mkdown', 'mkd'],
    contains: [
      // highlight headers
      {
        className: 'section',
        variants: [
          { begin: '^#{1,6}', end: '$' },
          { begin: '^.+?\\n[=-]{2,}$' }
        ]
      },
      // inline html
      {
        begin: '<', end: '>',
        subLanguage: 'xml',
        relevance: 0
      },
      // lists (indicators only)
      {
        className: 'bullet',
        begin: '^([*+-]|(\\d+\\.))\\s+'
      },
      // strong segments
      {
        className: 'strong',
        begin: '[*_]{2}.+?[*_]{2}'
      },
      // emphasis segments
      {
        className: 'emphasis',
        variants: [
          { begin: '\\*.+?\\*' },
          { begin: '_.+?_'
          , relevance: 0
          }
        ]
      },
      // blockquotes
      {
        className: 'quote',
        begin: '^>\\s+', end: '$'
      },
      // code snippets
      {
        className: 'code',
        variants: [
          {
            begin: '^```\w*\s*$', end: '^```\s*$'
          },
          {
            begin: '`.+?`'
          },
          {
            begin: '^( {4}|\t)', end: '$',
            relevance: 0
          }
        ]
      },
      // horizontal rules
      {
        begin: '^[-\\*]{3,}', end: '$'
      },
      // using links - title and link
      {
        begin: '\\[.+?\\][\\(\\[].*?[\\)\\]]',
        returnBegin: true,
        contains: [
          {
            className: 'string',
            begin: '\\[', end: '\\]',
            excludeBegin: true,
            returnEnd: true,
            relevance: 0
          },
          {
            className: 'link',
            begin: '\\]\\(', end: '\\)',
            excludeBegin: true, excludeEnd: true
          },
          {
            className: 'symbol',
            begin: '\\]\\[', end: '\\]',
            excludeBegin: true, excludeEnd: true
          }
        ],
        relevance: 10
      },
      {
        begin: /^\[[^\n]+\]:/,
        returnBegin: true,
        contains: [
          {
            className: 'symbol',
            begin: /\[/, end: /\]/,
            excludeBegin: true, excludeEnd: true
          },
          {
            className: 'link',
            begin: /:\s*/, end: /$/,
            excludeBegin: true
          }
        ]
      }
    ]
  };
};

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMON_CONTAINS = [
    hljs.C_NUMBER_MODE,
    {
      className: 'string',
      begin: '\'', end: '\'',
      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
    }
  ];
  var TRANSPOSE = {
    relevance: 0,
    contains: [
      {
        begin: /'['\.]*/
      }
    ]
  };

  return {
    keywords: {
      keyword:
        'break case catch classdef continue else elseif end enumerated events for function ' +
        'global if methods otherwise parfor persistent properties return spmd switch try while',
      built_in:
        'sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan ' +
        'atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot ' +
        'cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog ' +
        'realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal ' +
        'cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli ' +
        'besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma ' +
        'gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms ' +
        'nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones ' +
        'eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ' +
        'ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril ' +
        'triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute ' +
        'shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i inf nan ' +
        'isnan isinf isfinite j why compan gallery hadamard hankel hilb invhilb magic pascal ' +
        'rosser toeplitz vander wilkinson'
    },
    illegal: '(//|"|#|/\\*|\\s+/\\w+)',
    contains: [
      {
        className: 'function',
        beginKeywords: 'function', end: '$',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            variants: [
              {begin: '\\(', end: '\\)'},
              {begin: '\\[', end: '\\]'}
            ]
          }
        ]
      },
      {
        begin: /[a-zA-Z_][a-zA-Z_0-9]*'['\.]*/,
        returnBegin: true,
        relevance: 0,
        contains: [
          {begin: /[a-zA-Z_][a-zA-Z_0-9]*/, relevance: 0},
          TRANSPOSE.contains[0]
        ]
      },
      {
        begin: '\\[', end: '\\]',
        contains: COMMON_CONTAINS,
        relevance: 0,
        starts: TRANSPOSE
      },
      {
        begin: '\\{', end: /}/,
        contains: COMMON_CONTAINS,
        relevance: 0,
        starts: TRANSPOSE
      },
      {
        // transpose operators at the end of a function call
        begin: /\)/,
        relevance: 0,
        starts: TRANSPOSE
      },
      hljs.COMMENT('^\\s*\\%\\{\\s*$', '^\\s*\\%\\}\\s*$'),
      hljs.COMMENT('\\%', '$')
    ].concat(COMMON_CONTAINS)
  };
};

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var API_CLASS = {
    className: 'built_in',
    begin: '\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+',
  };
  var OBJC_KEYWORDS = {
    keyword:
      'int float while char export sizeof typedef const struct for union ' +
      'unsigned long volatile static bool mutable if do return goto void ' +
      'enum else break extern asm case short default double register explicit ' +
      'signed typename this switch continue wchar_t inline readonly assign ' +
      'readwrite self @synchronized id typeof ' +
      'nonatomic super unichar IBOutlet IBAction strong weak copy ' +
      'in out inout bycopy byref oneway __strong __weak __block __autoreleasing ' +
      '@private @protected @public @try @property @end @throw @catch @finally ' +
      '@autoreleasepool @synthesize @dynamic @selector @optional @required ' +
      '@encode @package @import @defs @compatibility_alias ' +
      '__bridge __bridge_transfer __bridge_retained __bridge_retain ' +
      '__covariant __contravariant __kindof ' +
      '_Nonnull _Nullable _Null_unspecified ' +
      '__FUNCTION__ __PRETTY_FUNCTION__ __attribute__ ' +
      'getter setter retain unsafe_unretained ' +
      'nonnull nullable null_unspecified null_resettable class instancetype ' +
      'NS_DESIGNATED_INITIALIZER NS_UNAVAILABLE NS_REQUIRES_SUPER ' +
      'NS_RETURNS_INNER_POINTER NS_INLINE NS_AVAILABLE NS_DEPRECATED ' +
      'NS_ENUM NS_OPTIONS NS_SWIFT_UNAVAILABLE ' +
      'NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END ' +
      'NS_REFINED_FOR_SWIFT NS_SWIFT_NAME NS_SWIFT_NOTHROW ' +
      'NS_DURING NS_HANDLER NS_ENDHANDLER NS_VALUERETURN NS_VOIDRETURN',
    literal:
      'false true FALSE TRUE nil YES NO NULL',
    built_in:
      'BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once'
  };
  var LEXEMES = /[a-zA-Z@][a-zA-Z0-9_]*/;
  var CLASS_KEYWORDS = '@interface @class @protocol @implementation';
  return {
    aliases: ['mm', 'objc', 'obj-c'],
    keywords: OBJC_KEYWORDS,
    lexemes: LEXEMES,
    illegal: '</',
    contains: [
      API_CLASS,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        variants: [
          {
            begin: '@"', end: '"',
            illegal: '\\n',
            contains: [hljs.BACKSLASH_ESCAPE]
          },
          {
            begin: '\'', end: '[^\\\\]\'',
            illegal: '[^\\\\][^\']'
          }
        ]
      },
      {
        className: 'meta',
        begin: '#',
        end: '$',
        contains: [
          {
            className: 'meta-string',
            variants: [
              { begin: '\"', end: '\"' },
              { begin: '<', end: '>' }
            ]
          }
        ]
      },
      {
        className: 'class',
        begin: '(' + CLASS_KEYWORDS.split(' ').join('|') + ')\\b', end: '({|$)', excludeEnd: true,
        keywords: CLASS_KEYWORDS, lexemes: LEXEMES,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        begin: '\\.'+hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  /* missing support for heredoc-like string (OCaml 4.0.2+) */
  return {
    aliases: ['ml'],
    keywords: {
      keyword:
        'and as assert asr begin class constraint do done downto else end ' +
        'exception external for fun function functor if in include ' +
        'inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method ' +
        'mod module mutable new object of open! open or private rec sig struct ' +
        'then to try type val! val virtual when while with ' +
        /* camlp4 */
        'parser value',
      built_in:
        /* built-in types */
        'array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit ' +
        /* (some) types in Pervasives */
        'in_channel out_channel ref',
      literal:
        'true false'
    },
    illegal: /\/\/|>>/,
    lexemes: '[a-z_]\\w*!?',
    contains: [
      {
        className: 'literal',
        begin: '\\[(\\|\\|)?\\]|\\(\\)',
        relevance: 0
      },
      hljs.COMMENT(
        '\\(\\*',
        '\\*\\)',
        {
          contains: ['self']
        }
      ),
      { /* type variable */
        className: 'symbol',
        begin: '\'[A-Za-z_](?!\')[\\w\']*'
        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
      },
      { /* polymorphic variant */
        className: 'type',
        begin: '`[A-Z][\\w\']*'
      },
      { /* module or constructor */
        className: 'type',
        begin: '\\b[A-Z][\\w\']*',
        relevance: 0
      },
      { /* don't color identifiers, but safely catch all identifiers with '*/
        begin: '[a-z_]\\w*\'[\\w\']*', relevance: 0
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      {
        className: 'number',
        begin:
          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
          '0[oO][0-7_]+[Lln]?|' +
          '0[bB][01_]+[Lln]?|' +
          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
        relevance: 0
      },
      {
        begin: /[-=]>/ // relevance booster
      }
    ]
  }
};

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var PERL_KEYWORDS = 'getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ' +
    'ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime ' +
    'readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qq' +
    'fileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent ' +
    'shutdown dump chomp connect getsockname die socketpair close flock exists index shmget' +
    'sub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr ' +
    'unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 ' +
    'getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline ' +
    'endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand ' +
    'mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink ' +
    'getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr ' +
    'untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link ' +
    'getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller ' +
    'lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and ' +
    'sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 ' +
    'chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach ' +
    'tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedir' +
    'ioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe ' +
    'atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when';
  var SUBST = {
    className: 'subst',
    begin: '[$@]\\{', end: '\\}',
    keywords: PERL_KEYWORDS
  };
  var METHOD = {
    begin: '->{', end: '}'
    // contains defined later
  };
  var VAR = {
    variants: [
      {begin: /\$\d/},
      {begin: /[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/},
      {begin: /[\$%@][^\s\w{]/, relevance: 0}
    ]
  };
  var STRING_CONTAINS = [hljs.BACKSLASH_ESCAPE, SUBST, VAR];
  var PERL_DEFAULT_CONTAINS = [
    VAR,
    hljs.HASH_COMMENT_MODE,
    hljs.COMMENT(
      '^\\=\\w',
      '\\=cut',
      {
        endsWithParent: true
      }
    ),
    METHOD,
    {
      className: 'string',
      contains: STRING_CONTAINS,
      variants: [
        {
          begin: 'q[qwxr]?\\s*\\(', end: '\\)',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\[', end: '\\]',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\{', end: '\\}',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\|', end: '\\|',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\<', end: '\\>',
          relevance: 5
        },
        {
          begin: 'qw\\s+q', end: 'q',
          relevance: 5
        },
        {
          begin: '\'', end: '\'',
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: '"', end: '"'
        },
        {
          begin: '`', end: '`',
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: '{\\w+}',
          contains: [],
          relevance: 0
        },
        {
          begin: '\-?\\w+\\s*\\=\\>',
          contains: [],
          relevance: 0
        }
      ]
    },
    {
      className: 'number',
      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
      relevance: 0
    },
    { // regexp container
      begin: '(\\/\\/|' + hljs.RE_STARTERS_RE + '|\\b(split|return|print|reverse|grep)\\b)\\s*',
      keywords: 'split return print reverse grep',
      relevance: 0,
      contains: [
        hljs.HASH_COMMENT_MODE,
        {
          className: 'regexp',
          begin: '(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*',
          relevance: 10
        },
        {
          className: 'regexp',
          begin: '(m|qr)?/', end: '/[a-z]*',
          contains: [hljs.BACKSLASH_ESCAPE],
          relevance: 0 // allows empty "//" which is a common comment delimiter in other languages
        }
      ]
    },
    {
      className: 'function',
      beginKeywords: 'sub', end: '(\\s*\\(.*?\\))?[;{]', excludeEnd: true,
      relevance: 5,
      contains: [hljs.TITLE_MODE]
    },
    {
      begin: '-\\w\\b',
      relevance: 0
    },
    {
      begin: "^__DATA__$",
      end: "^__END__$",
      subLanguage: 'mojolicious',
      contains: [
        {
            begin: "^@@.*",
            end: "$",
            className: "comment"
        }
      ]
    }
  ];
  SUBST.contains = PERL_DEFAULT_CONTAINS;
  METHOD.contains = PERL_DEFAULT_CONTAINS;

  return {
    aliases: ['pl', 'pm'],
    lexemes: /[\w\.]+/,
    keywords: PERL_KEYWORDS,
    contains: PERL_DEFAULT_CONTAINS
  };
};

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VARIABLE = {
    begin: '\\$+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*'
  };
  var PREPROCESSOR = {
    className: 'meta', begin: /<\?(php)?|\?>/
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, PREPROCESSOR],
    variants: [
      {
        begin: 'b"', end: '"'
      },
      {
        begin: 'b\'', end: '\''
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
    ]
  };
  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
  return {
    aliases: ['php3', 'php4', 'php5', 'php6'],
    case_insensitive: true,
    keywords:
      'and include_once list abstract global private echo interface as static endswitch ' +
      'array null if endwhile or const for endforeach self var while isset public ' +
      'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
      'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
      'catch __METHOD__ case exception default die require __FUNCTION__ ' +
      'enddeclare final try switch continue endfor endif declare unset true false ' +
      'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
      'yield finally',
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.COMMENT('//', '$', {contains: [PREPROCESSOR]}),
      hljs.COMMENT(
        '/\\*',
        '\\*/',
        {
          contains: [
            {
              className: 'doctag',
              begin: '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.COMMENT(
        '__halt_compiler.+?;',
        false,
        {
          endsWithParent: true,
          keywords: '__halt_compiler',
          lexemes: hljs.UNDERSCORE_IDENT_RE
        }
      ),
      {
        className: 'string',
        begin: /<<<['"]?\w+['"]?$/, end: /^\w+;?$/,
        contains: [
          hljs.BACKSLASH_ESCAPE,
          {
            className: 'subst',
            variants: [
              {begin: /\$\w+/},
              {begin: /\{\$/, end: /\}/}
            ]
          }
        ]
      },
      PREPROCESSOR,
      {
        className: 'keyword', begin: /\$this\b/
      },
      VARIABLE,
      {
        // swallow composed identifiers to avoid parsing them as keywords
        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
      },
      {
        className: 'function',
        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
        illegal: '\\$|\\[|%',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            contains: [
              'self',
              VARIABLE,
              hljs.C_BLOCK_COMMENT_MODE,
              STRING,
              NUMBER
            ]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        illegal: /[:\(\$"]/,
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        beginKeywords: 'namespace', end: ';',
        illegal: /[\.']/,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        beginKeywords: 'use', end: ';',
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        begin: '=>' // No markup, just a relevance booster
      },
      STRING,
      NUMBER
    ]
  };
};

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BACKTICK_ESCAPE = {
    begin: '`[\\s\\S]',
    relevance: 0
  };
  var VAR = {
    className: 'variable',
    variants: [
      {begin: /\$[\w\d][\w\d_:]*/}
    ]
  };
  var LITERAL = {
    className: 'literal',
    begin: /\$(null|true|false)\b/
  };
  var QUOTE_STRING = {
    className: 'string',
    variants: [
      { begin: /"/, end: /"/ },
      { begin: /@"/, end: /^"@/ }
    ],
    contains: [
      BACKTICK_ESCAPE,
      VAR,
      {
        className: 'variable',
        begin: /\$[A-z]/, end: /[^A-z]/
      }
    ]
  };
  var APOS_STRING = {
    className: 'string',
    variants: [
      { begin: /'/, end: /'/ },
      { begin: /@'/, end: /^'@/ }
    ]
  };

  var PS_HELPTAGS = {
    className: 'doctag',
    variants: [
      /* no paramater help tags */ 
      { begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/ },
      /* one parameter help tags */
      { begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/ }
    ]
  };
  var PS_COMMENT = hljs.inherit(
    hljs.COMMENT(null, null),
    {
      variants: [
        /* single-line comment */
        { begin: /#/, end: /$/ },
        /* multi-line comment */
        { begin: /<#/, end: /#>/ }
      ],
      contains: [PS_HELPTAGS]
    }
  );

  return {
    aliases: ['ps'],
    lexemes: /-?[A-z\.\-]+/,
    case_insensitive: true,
    keywords: {
      keyword: 'if else foreach return function do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch',
      built_in: 'Add-Computer Add-Content Add-History Add-JobTrigger Add-Member Add-PSSnapin Add-Type Checkpoint-Computer Clear-Content Clear-EventLog Clear-History Clear-Host Clear-Item Clear-ItemProperty Clear-Variable Compare-Object Complete-Transaction Connect-PSSession Connect-WSMan Convert-Path ConvertFrom-Csv ConvertFrom-Json ConvertFrom-SecureString ConvertFrom-StringData ConvertTo-Csv ConvertTo-Html ConvertTo-Json ConvertTo-SecureString ConvertTo-Xml Copy-Item Copy-ItemProperty Debug-Process Disable-ComputerRestore Disable-JobTrigger Disable-PSBreakpoint Disable-PSRemoting Disable-PSSessionConfiguration Disable-WSManCredSSP Disconnect-PSSession Disconnect-WSMan Disable-ScheduledJob Enable-ComputerRestore Enable-JobTrigger Enable-PSBreakpoint Enable-PSRemoting Enable-PSSessionConfiguration Enable-ScheduledJob Enable-WSManCredSSP Enter-PSSession Exit-PSSession Export-Alias Export-Clixml Export-Console Export-Counter Export-Csv Export-FormatData Export-ModuleMember Export-PSSession ForEach-Object Format-Custom Format-List Format-Table Format-Wide Get-Acl Get-Alias Get-AuthenticodeSignature Get-ChildItem Get-Command Get-ComputerRestorePoint Get-Content Get-ControlPanelItem Get-Counter Get-Credential Get-Culture Get-Date Get-Event Get-EventLog Get-EventSubscriber Get-ExecutionPolicy Get-FormatData Get-Host Get-HotFix Get-Help Get-History Get-IseSnippet Get-Item Get-ItemProperty Get-Job Get-JobTrigger Get-Location Get-Member Get-Module Get-PfxCertificate Get-Process Get-PSBreakpoint Get-PSCallStack Get-PSDrive Get-PSProvider Get-PSSession Get-PSSessionConfiguration Get-PSSnapin Get-Random Get-ScheduledJob Get-ScheduledJobOption Get-Service Get-TraceSource Get-Transaction Get-TypeData Get-UICulture Get-Unique Get-Variable Get-Verb Get-WinEvent Get-WmiObject Get-WSManCredSSP Get-WSManInstance Group-Object Import-Alias Import-Clixml Import-Counter Import-Csv Import-IseSnippet Import-LocalizedData Import-PSSession Import-Module Invoke-AsWorkflow Invoke-Command Invoke-Expression Invoke-History Invoke-Item Invoke-RestMethod Invoke-WebRequest Invoke-WmiMethod Invoke-WSManAction Join-Path Limit-EventLog Measure-Command Measure-Object Move-Item Move-ItemProperty New-Alias New-Event New-EventLog New-IseSnippet New-Item New-ItemProperty New-JobTrigger New-Object New-Module New-ModuleManifest New-PSDrive New-PSSession New-PSSessionConfigurationFile New-PSSessionOption New-PSTransportOption New-PSWorkflowExecutionOption New-PSWorkflowSession New-ScheduledJobOption New-Service New-TimeSpan New-Variable New-WebServiceProxy New-WinEvent New-WSManInstance New-WSManSessionOption Out-Default Out-File Out-GridView Out-Host Out-Null Out-Printer Out-String Pop-Location Push-Location Read-Host Receive-Job Register-EngineEvent Register-ObjectEvent Register-PSSessionConfiguration Register-ScheduledJob Register-WmiEvent Remove-Computer Remove-Event Remove-EventLog Remove-Item Remove-ItemProperty Remove-Job Remove-JobTrigger Remove-Module Remove-PSBreakpoint Remove-PSDrive Remove-PSSession Remove-PSSnapin Remove-TypeData Remove-Variable Remove-WmiObject Remove-WSManInstance Rename-Computer Rename-Item Rename-ItemProperty Reset-ComputerMachinePassword Resolve-Path Restart-Computer Restart-Service Restore-Computer Resume-Job Resume-Service Save-Help Select-Object Select-String Select-Xml Send-MailMessage Set-Acl Set-Alias Set-AuthenticodeSignature Set-Content Set-Date Set-ExecutionPolicy Set-Item Set-ItemProperty Set-JobTrigger Set-Location Set-PSBreakpoint Set-PSDebug Set-PSSessionConfiguration Set-ScheduledJob Set-ScheduledJobOption Set-Service Set-StrictMode Set-TraceSource Set-Variable Set-WmiInstance Set-WSManInstance Set-WSManQuickConfig Show-Command Show-ControlPanelItem Show-EventLog Sort-Object Split-Path Start-Job Start-Process Start-Service Start-Sleep Start-Transaction Start-Transcript Stop-Computer Stop-Job Stop-Process Stop-Service Stop-Transcript Suspend-Job Suspend-Service Tee-Object Test-ComputerSecureChannel Test-Connection Test-ModuleManifest Test-Path Test-PSSessionConfigurationFile Trace-Command Unblock-File Undo-Transaction Unregister-Event Unregister-PSSessionConfiguration Unregister-ScheduledJob Update-FormatData Update-Help Update-List Update-TypeData Use-Transaction Wait-Event Wait-Job Wait-Process Where-Object Write-Debug Write-Error Write-EventLog Write-Host Write-Output Write-Progress Write-Verbose Write-Warning Add-MDTPersistentDrive Disable-MDTMonitorService Enable-MDTMonitorService Get-MDTDeploymentShareStatistics Get-MDTMonitorData Get-MDTOperatingSystemCatalog Get-MDTPersistentDrive Import-MDTApplication Import-MDTDriver Import-MDTOperatingSystem Import-MDTPackage Import-MDTTaskSequence New-MDTDatabase Remove-MDTMonitorData Remove-MDTPersistentDrive Restore-MDTPersistentDrive Set-MDTMonitorData Test-MDTDeploymentShare Test-MDTMonitorData Update-MDTDatabaseSchema Update-MDTDeploymentShare Update-MDTLinkedDS Update-MDTMedia Update-MDTMedia Add-VamtProductKey Export-VamtData Find-VamtManagedMachine Get-VamtConfirmationId Get-VamtProduct Get-VamtProductKey Import-VamtData Initialize-VamtData Install-VamtConfirmationId Install-VamtProductActivation Install-VamtProductKey Update-VamtProduct',
      nomarkup: '-ne -eq -lt -gt -ge -le -not -like -notlike -match -notmatch -contains -notcontains -in -notin -replace'
    },
    contains: [
      BACKTICK_ESCAPE,
      hljs.NUMBER_MODE,
      QUOTE_STRING,
      APOS_STRING,
      LITERAL,
      VAR,
      PS_COMMENT
    ]
  };
};

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

  var PUPPET_KEYWORDS = {
    keyword:
    /* language keywords */
      'and case default else elsif false if in import enherits node or true undef unless main settings $string ',
    literal:
    /* metaparameters */
      'alias audit before loglevel noop require subscribe tag ' +
    /* normal attributes */
      'owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check ' +
      'en_address ip_address realname command environment hour monute month monthday special target weekday '+
      'creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore ' +
      'links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source ' +
      'souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid '+
      'ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel ' +
      'native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options ' +
      'device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use ' +
      'message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform ' +
      'responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running ' +
      'start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age ' +
      'password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled ' +
      'enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist ' +
      'priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey ' +
      'sslverify mounted',
    built_in:
    /* core facts */
      'architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers ' +
      'domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces '+
      'ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion ' +
      'kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease ' +
      'lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major ' +
      'macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease '+
      'operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion '+
      'rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced '+
      'selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime '+
      'uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version'
  };

  var COMMENT = hljs.COMMENT('#', '$');

  var IDENT_RE = '([A-Za-z_]|::)(\\w|::)*';

  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE});

  var VARIABLE = {className: 'variable', begin: '\\$' + IDENT_RE};

  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, VARIABLE],
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/}
    ]
  };

  return {
    aliases: ['pp'],
    contains: [
      COMMENT,
      VARIABLE,
      STRING,
      {
        beginKeywords: 'class', end: '\\{|;',
        illegal: /=/,
        contains: [TITLE, COMMENT]
      },
      {
        beginKeywords: 'define', end: /\{/,
        contains: [
          {
            className: 'section', begin: hljs.IDENT_RE, endsParent: true
          }
        ]
      },
      {
        begin: hljs.IDENT_RE + '\\s+\\{', returnBegin: true,
        end: /\S/,
        contains: [
          {
            className: 'keyword',
            begin: hljs.IDENT_RE
          },
          {
            begin: /\{/, end: /\}/,
            keywords: PUPPET_KEYWORDS,
            relevance: 0,
            contains: [
              STRING,
              COMMENT,
              {
                begin:'[a-zA-Z_]+\\s*=>',
                returnBegin: true, end: '=>',
                contains: [
                  {
                    className: 'attr',
                    begin: hljs.IDENT_RE,
                  }
                ]
              },
              {
                className: 'number',
                begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
                relevance: 0
              },
              VARIABLE
            ]
          }
        ],
        relevance: 0
      }
    ]
  }
};

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      'and elif is global as in if from raise for except finally print import pass return ' +
      'exec else break not with class assert yield try while continue del or def lambda ' +
      'async await nonlocal|10 None True False',
    built_in:
      'Ellipsis NotImplemented'
  };
  var PROMPT = {
    className: 'meta',  begin: /^(>>>|\.\.\.) /
  };
  var SUBST = {
    className: 'subst',
    begin: /\{/, end: /\}/,
    keywords: KEYWORDS,
    illegal: /#/
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /(u|b)?r?'''/, end: /'''/,
        contains: [PROMPT],
        relevance: 10
      },
      {
        begin: /(u|b)?r?"""/, end: /"""/,
        contains: [PROMPT],
        relevance: 10
      },
      {
        begin: /(fr|rf|f)'''/, end: /'''/,
        contains: [PROMPT, SUBST]
      },
      {
        begin: /(fr|rf|f)"""/, end: /"""/,
        contains: [PROMPT, SUBST]
      },
      {
        begin: /(u|r|ur)'/, end: /'/,
        relevance: 10
      },
      {
        begin: /(u|r|ur)"/, end: /"/,
        relevance: 10
      },
      {
        begin: /(b|br)'/, end: /'/
      },
      {
        begin: /(b|br)"/, end: /"/
      },
      {
        begin: /(fr|rf|f)'/, end: /'/,
        contains: [SUBST]
      },
      {
        begin: /(fr|rf|f)"/, end: /"/,
        contains: [SUBST]
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };
  var NUMBER = {
    className: 'number', relevance: 0,
    variants: [
      {begin: hljs.BINARY_NUMBER_RE + '[lLjJ]?'},
      {begin: '\\b(0o[0-7]+)[lLjJ]?'},
      {begin: hljs.C_NUMBER_RE + '[lLjJ]?'}
    ]
  };
  var PARAMS = {
    className: 'params',
    begin: /\(/, end: /\)/,
    contains: ['self', PROMPT, NUMBER, STRING]
  };
  SUBST.contains = [STRING, NUMBER, PROMPT];
  return {
    aliases: ['py', 'gyp'],
    keywords: KEYWORDS,
    illegal: /(<\/|->|\?)|=>/,
    contains: [
      PROMPT,
      NUMBER,
      STRING,
      hljs.HASH_COMMENT_MODE,
      {
        variants: [
          {className: 'function', beginKeywords: 'def'},
          {className: 'class', beginKeywords: 'class'}
        ],
        end: /:/,
        illegal: /[${=;\n,]/,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          PARAMS,
          {
            begin: /->/, endsWithParent: true,
            keywords: 'None'
          }
        ]
      },
      {
        className: 'meta',
        begin: /^[\t ]*@/, end: /$/
      },
      {
        begin: /\b(print|exec)\(/ // don’t highlight keywords-turned-functions in Python 3
      }
    ]
  };
};

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '([a-zA-Z]|\\.[a-zA-Z.])[a-zA-Z0-9._]*';

  return {
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        begin: IDENT_RE,
        lexemes: IDENT_RE,
        keywords: {
          keyword:
            'function if in break next repeat else for return switch while try tryCatch ' +
            'stop warning require library attach detach source setMethod setGeneric ' +
            'setGroupGeneric setClass ...',
          literal:
            'NULL NA TRUE FALSE T F Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 ' +
            'NA_complex_|10'
        },
        relevance: 0
      },
      {
        // hex value
        className: 'number',
        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
        relevance: 0
      },
      {
        // explicit integer
        className: 'number',
        begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
        relevance: 0
      },
      {
        // number with trailing decimal
        className: 'number',
        begin: "\\d+\\.(?!\\d)(?:i\\b)?",
        relevance: 0
      },
      {
        // number
        className: 'number',
        begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      },
      {
        // number with leading decimal
        className: 'number',
        begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      },

      {
        // escaped identifier
        begin: '`',
        end: '`',
        relevance: 0
      },

      {
        className: 'string',
        contains: [hljs.BACKSLASH_ESCAPE],
        variants: [
          {begin: '"', end: '"'},
          {begin: "'", end: "'"}
        ]
      }
    ]
  };
};

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var RUBY_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
  var RUBY_KEYWORDS = {
    keyword:
      'and then defined module in return redo if BEGIN retry end for self when ' +
      'next until do begin unless END rescue else break undef not super class case ' +
      'require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor',
    literal:
      'true false nil'
  };
  var YARDOCTAG = {
    className: 'doctag',
    begin: '@[A-Za-z]+'
  };
  var IRB_OBJECT = {
    begin: '#<', end: '>'
  };
  var COMMENT_MODES = [
    hljs.COMMENT(
      '#',
      '$',
      {
        contains: [YARDOCTAG]
      }
    ),
    hljs.COMMENT(
      '^\\=begin',
      '^\\=end',
      {
        contains: [YARDOCTAG],
        relevance: 10
      }
    ),
    hljs.COMMENT('^__END__', '\\n$')
  ];
  var SUBST = {
    className: 'subst',
    begin: '#\\{', end: '}',
    keywords: RUBY_KEYWORDS
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/},
      {begin: /`/, end: /`/},
      {begin: '%[qQwWx]?\\(', end: '\\)'},
      {begin: '%[qQwWx]?\\[', end: '\\]'},
      {begin: '%[qQwWx]?{', end: '}'},
      {begin: '%[qQwWx]?<', end: '>'},
      {begin: '%[qQwWx]?/', end: '/'},
      {begin: '%[qQwWx]?%', end: '%'},
      {begin: '%[qQwWx]?-', end: '-'},
      {begin: '%[qQwWx]?\\|', end: '\\|'},
      {
        // \B in the beginning suppresses recognition of ?-sequences where ?
        // is the last character of a preceding identifier, as in: `func?4`
        begin: /\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/
      },
      {
        begin: /<<(-?)\w+$/, end: /^\s*\w+$/,
      }
    ]
  };
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)', endsParent: true,
    keywords: RUBY_KEYWORDS
  };

  var RUBY_DEFAULT_CONTAINS = [
    STRING,
    IRB_OBJECT,
    {
      className: 'class',
      beginKeywords: 'class module', end: '$|;',
      illegal: /=/,
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
        {
          begin: '<\\s*',
          contains: [{
            begin: '(' + hljs.IDENT_RE + '::)?' + hljs.IDENT_RE
          }]
        }
      ].concat(COMMENT_MODES)
    },
    {
      className: 'function',
      beginKeywords: 'def', end: '$|;',
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {begin: RUBY_METHOD_RE}),
        PARAMS
      ].concat(COMMENT_MODES)
    },
    {
      // swallow namespace qualifiers before symbols
      begin: hljs.IDENT_RE + '::'
    },
    {
      className: 'symbol',
      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
      relevance: 0
    },
    {
      className: 'symbol',
      begin: ':(?!\\s)',
      contains: [STRING, {begin: RUBY_METHOD_RE}],
      relevance: 0
    },
    {
      className: 'number',
      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
      relevance: 0
    },
    {
      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))' // variables
    },
    {
      className: 'params',
      begin: /\|/, end: /\|/,
      keywords: RUBY_KEYWORDS
    },
    { // regexp container
      begin: '(' + hljs.RE_STARTERS_RE + '|unless)\\s*',
      keywords: 'unless',
      contains: [
        IRB_OBJECT,
        {
          className: 'regexp',
          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
          illegal: /\n/,
          variants: [
            {begin: '/', end: '/[a-z]*'},
            {begin: '%r{', end: '}[a-z]*'},
            {begin: '%r\\(', end: '\\)[a-z]*'},
            {begin: '%r!', end: '![a-z]*'},
            {begin: '%r\\[', end: '\\][a-z]*'}
          ]
        }
      ].concat(COMMENT_MODES),
      relevance: 0
    }
  ].concat(COMMENT_MODES);

  SUBST.contains = RUBY_DEFAULT_CONTAINS;
  PARAMS.contains = RUBY_DEFAULT_CONTAINS;

  var SIMPLE_PROMPT = "[>?]>";
  var DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+>";
  var RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>";

  var IRB_DEFAULT = [
    {
      begin: /^\s*=>/,
      starts: {
        end: '$', contains: RUBY_DEFAULT_CONTAINS
      }
    },
    {
      className: 'meta',
      begin: '^('+SIMPLE_PROMPT+"|"+DEFAULT_PROMPT+'|'+RVM_PROMPT+')',
      starts: {
        end: '$', contains: RUBY_DEFAULT_CONTAINS
      }
    }
  ];

  return {
    aliases: ['rb', 'gemspec', 'podspec', 'thor', 'irb'],
    keywords: RUBY_KEYWORDS,
    illegal: /\/\*/,
    contains: COMMENT_MODES.concat(IRB_DEFAULT).concat(RUBY_DEFAULT_CONTAINS)
  };
};

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var NUM_SUFFIX = '([ui](8|16|32|64|128|size)|f(32|64))\?';
  var KEYWORDS =
    'alignof as be box break const continue crate do else enum extern ' +
    'false fn for if impl in let loop match mod mut offsetof once priv ' +
    'proc pub pure ref return self Self sizeof static struct super trait true ' +
    'type typeof unsafe unsized use virtual while where yield move default';
  var BUILTINS =
    // functions
    'drop ' +
    // types
    'i8 i16 i32 i64 i128 isize ' +
    'u8 u16 u32 u64 u128 usize ' +
    'f32 f64 ' +
    'str char bool ' +
    'Box Option Result String Vec ' +
    // traits
    'Copy Send Sized Sync Drop Fn FnMut FnOnce ToOwned Clone Debug ' +
    'PartialEq PartialOrd Eq Ord AsRef AsMut Into From Default Iterator ' +
    'Extend IntoIterator DoubleEndedIterator ExactSizeIterator ' +
    'SliceConcatExt ToString ' +
    // macros
    'assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! ' +
    'debug_assert! debug_assert_eq! env! panic! file! format! format_args! ' +
    'include_bin! include_str! line! local_data_key! module_path! ' +
    'option_env! print! println! select! stringify! try! unimplemented! ' +
    'unreachable! vec! write! writeln! macro_rules! assert_ne! debug_assert_ne!';
  return {
    aliases: ['rs'],
    keywords: {
      keyword:
        KEYWORDS,
      literal:
        'true false Some None Ok Err',
      built_in:
        BUILTINS
    },
    lexemes: hljs.IDENT_RE + '!?',
    illegal: '</',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.COMMENT('/\\*', '\\*/', {contains: ['self']}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {begin: /b?"/, illegal: null}),
      {
        className: 'string',
        variants: [
           { begin: /r(#*)"(.|\n)*?"\1(?!#)/ },
           { begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/ }
        ]
      },
      {
        className: 'symbol',
        begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
      },
      {
        className: 'number',
        variants: [
          { begin: '\\b0b([01_]+)' + NUM_SUFFIX },
          { begin: '\\b0o([0-7_]+)' + NUM_SUFFIX },
          { begin: '\\b0x([A-Fa-f0-9_]+)' + NUM_SUFFIX },
          { begin: '\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)' +
                   NUM_SUFFIX
          }
        ],
        relevance: 0
      },
      {
        className: 'function',
        beginKeywords: 'fn', end: '(\\(|<)', excludeEnd: true,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        className: 'meta',
        begin: '#\\!?\\[', end: '\\]',
        contains: [
          {
            className: 'meta-string',
            begin: /"/, end: /"/
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'type', end: ';',
        contains: [
          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
        ],
        illegal: '\\S'
      },
      {
        className: 'class',
        beginKeywords: 'trait enum struct union', end: '{',
        contains: [
          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
        ],
        illegal: '[\\w\\d]'
      },
      {
        begin: hljs.IDENT_RE + '::',
        keywords: {built_in: BUILTINS}
      },
      {
        begin: '->'
      }
    ]
  };
};

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

  var ANNOTATION = { className: 'meta', begin: '@[A-Za-z]+' };

  // used in strings for escaping/interpolation/substitution
  var SUBST = {
    className: 'subst',
    variants: [
      {begin: '\\$[A-Za-z0-9_]+'},
      {begin: '\\${', end: '}'}
    ]
  };

  var STRING = {
    className: 'string',
    variants: [
      {
        begin: '"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '"""', end: '"""',
        relevance: 10
      },
      {
        begin: '[a-z]+"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        className: 'string',
        begin: '[a-z]+"""', end: '"""',
        contains: [SUBST],
        relevance: 10
      }
    ]

  };

  var SYMBOL = {
    className: 'symbol',
    begin: '\'\\w[\\w\\d_]*(?!\')'
  };

  var TYPE = {
    className: 'type',
    begin: '\\b[A-Z][A-Za-z0-9_]*',
    relevance: 0
  };

  var NAME = {
    className: 'title',
    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
    relevance: 0
  };

  var CLASS = {
    className: 'class',
    beginKeywords: 'class object trait type',
    end: /[:={\[\n;]/,
    excludeEnd: true,
    contains: [
      {
        beginKeywords: 'extends with',
        relevance: 10
      },
      {
        begin: /\[/,
        end: /\]/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0,
        contains: [TYPE]
      },
      {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0,
        contains: [TYPE]
      },
      NAME
    ]
  };

  var METHOD = {
    className: 'function',
    beginKeywords: 'def',
    end: /[:={\[(\n;]/,
    excludeEnd: true,
    contains: [NAME]
  };

  return {
    keywords: {
      literal: 'true false null',
      keyword: 'type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      STRING,
      SYMBOL,
      TYPE,
      METHOD,
      CLASS,
      hljs.C_NUMBER_MODE,
      ANNOTATION
    ]
  };
};

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var SCHEME_IDENT_RE = '[^\\(\\)\\[\\]\\{\\}",\'`;#|\\\\\\s]+';
  var SCHEME_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+([./]\\d+)?';
  var SCHEME_COMPLEX_NUMBER_RE = SCHEME_SIMPLE_NUMBER_RE + '[+\\-]' + SCHEME_SIMPLE_NUMBER_RE + 'i';
  var BUILTINS = {
    'builtin-name':
      'case-lambda call/cc class define-class exit-handler field import ' +
      'inherit init-field interface let*-values let-values let/ec mixin ' +
      'opt-lambda override protect provide public rename require ' +
      'require-for-syntax syntax syntax-case syntax-error unit/sig unless ' +
      'when with-syntax and begin call-with-current-continuation ' +
      'call-with-input-file call-with-output-file case cond define ' +
      'define-syntax delay do dynamic-wind else for-each if lambda let let* ' +
      'let-syntax letrec letrec-syntax map or syntax-rules \' * + , ,@ - ... / ' +
      '; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan ' +
      'boolean? caar cadr call-with-input-file call-with-output-file ' +
      'call-with-values car cdddar cddddr cdr ceiling char->integer ' +
      'char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? ' +
      'char-downcase char-lower-case? char-numeric? char-ready? char-upcase ' +
      'char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? ' +
      'char? close-input-port close-output-port complex? cons cos ' +
      'current-input-port current-output-port denominator display eof-object? ' +
      'eq? equal? eqv? eval even? exact->inexact exact? exp expt floor ' +
      'force gcd imag-part inexact->exact inexact? input-port? integer->char ' +
      'integer? interaction-environment lcm length list list->string ' +
      'list->vector list-ref list-tail list? load log magnitude make-polar ' +
      'make-rectangular make-string make-vector max member memq memv min ' +
      'modulo negative? newline not null-environment null? number->string ' +
      'number? numerator odd? open-input-file open-output-file output-port? ' +
      'pair? peek-char port? positive? procedure? quasiquote quote quotient ' +
      'rational? rationalize read read-char real-part real? remainder reverse ' +
      'round scheme-report-environment set! set-car! set-cdr! sin sqrt string ' +
      'string->list string->number string->symbol string-append string-ci<=? ' +
      'string-ci<? string-ci=? string-ci>=? string-ci>? string-copy ' +
      'string-fill! string-length string-ref string-set! string<=? string<? ' +
      'string=? string>=? string>? string? substring symbol->string symbol? ' +
      'tan transcript-off transcript-on truncate values vector ' +
      'vector->list vector-fill! vector-length vector-ref vector-set! ' +
      'with-input-from-file with-output-to-file write write-char zero?'
  };

  var SHEBANG = {
    className: 'meta',
    begin: '^#!',
    end: '$'
  };

  var LITERAL = {
    className: 'literal',
    begin: '(#t|#f|#\\\\' + SCHEME_IDENT_RE + '|#\\\\.)'
  };

  var NUMBER = {
    className: 'number',
    variants: [
      { begin: SCHEME_SIMPLE_NUMBER_RE, relevance: 0 },
      { begin: SCHEME_COMPLEX_NUMBER_RE, relevance: 0 },
      { begin: '#b[0-1]+(/[0-1]+)?' },
      { begin: '#o[0-7]+(/[0-7]+)?' },
      { begin: '#x[0-9a-f]+(/[0-9a-f]+)?' }
    ]
  };

  var STRING = hljs.QUOTE_STRING_MODE;

  var REGULAR_EXPRESSION = {
    className: 'regexp',
    begin: '#[pr]x"',
    end: '[^\\\\]"'
  };

  var COMMENT_MODES = [
    hljs.COMMENT(
      ';',
      '$',
      {
        relevance: 0
      }
    ),
    hljs.COMMENT('#\\|', '\\|#')
  ];

  var IDENT = {
    begin: SCHEME_IDENT_RE,
    relevance: 0
  };

  var QUOTED_IDENT = {
    className: 'symbol',
    begin: '\'' + SCHEME_IDENT_RE
  };

  var BODY = {
    endsWithParent: true,
    relevance: 0
  };

  var QUOTED_LIST = {
    variants: [
      { begin: /'/ },
      { begin: '`' }
    ],
    contains: [
      {
        begin: '\\(', end: '\\)',
        contains: ['self', LITERAL, STRING, NUMBER, IDENT, QUOTED_IDENT]
      }
    ]
  };

  var NAME = {
    className: 'name',
    begin: SCHEME_IDENT_RE,
    lexemes: SCHEME_IDENT_RE,
    keywords: BUILTINS
  };

  var LAMBDA = {
    begin: /lambda/, endsWithParent: true, returnBegin: true,
    contains: [
      NAME,
      {
        begin: /\(/, end: /\)/, endsParent: true,
        contains: [IDENT],
      }
    ]
  };

  var LIST = {
    variants: [
      { begin: '\\(', end: '\\)' },
      { begin: '\\[', end: '\\]' }
    ],
    contains: [LAMBDA, NAME, BODY]
  };

  BODY.contains = [LITERAL, NUMBER, STRING, IDENT, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES);

  return {
    illegal: /\S/,
    contains: [SHEBANG, NUMBER, STRING, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES)
  };
};

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
  var VARIABLE = {
    className: 'variable',
    begin: '(\\$' + IDENT_RE + ')\\b'
  };
  var HEXCOLOR = {
    className: 'number', begin: '#[0-9A-Fa-f]+'
  };
  var DEF_INTERNALS = {
    className: 'attribute',
    begin: '[A-Z\\_\\.\\-]+', end: ':',
    excludeEnd: true,
    illegal: '[^\\s]',
    starts: {
      endsWithParent: true, excludeEnd: true,
      contains: [
        HEXCOLOR,
        hljs.CSS_NUMBER_MODE,
        hljs.QUOTE_STRING_MODE,
        hljs.APOS_STRING_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        {
          className: 'meta', begin: '!important'
        }
      ]
    }
  };
  return {
    case_insensitive: true,
    illegal: '[=/|\']',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'selector-id', begin: '\\#[A-Za-z0-9_-]+',
        relevance: 0
      },
      {
        className: 'selector-class', begin: '\\.[A-Za-z0-9_-]+',
        relevance: 0
      },
      {
        className: 'selector-attr', begin: '\\[', end: '\\]',
        illegal: '$'
      },
      {
        className: 'selector-tag', // begin: IDENT_RE, end: '[,|\\s]'
        begin: '\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b',
        relevance: 0
      },
      {
        begin: ':(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)'
      },
      {
        begin: '::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)'
      },
      VARIABLE,
      {
        className: 'attribute',
        begin: '\\b(z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b',
        illegal: '[^\\s]'
      },
      {
        begin: '\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b'
      },
      {
        begin: ':', end: ';',
        contains: [
          VARIABLE,
          HEXCOLOR,
          hljs.CSS_NUMBER_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          {
            className: 'meta', begin: '!important'
          }
        ]
      },
      {
        begin: '@', end: '[{;]',
        keywords: 'mixin include extend for if else each while charset import debug media page content font-face namespace warn',
        contains: [
          VARIABLE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          HEXCOLOR,
          hljs.CSS_NUMBER_MODE,
          {
            begin: '\\s[A-Za-z0-9_.-]+',
            relevance: 0
          }
        ]
      }
    ]
  };
};

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VAR_IDENT_RE = '[a-z][a-zA-Z0-9_]*';
  var CHAR = {
    className: 'string',
    begin: '\\$.{1}'
  };
  var SYMBOL = {
    className: 'symbol',
    begin: '#' + hljs.UNDERSCORE_IDENT_RE
  };
  return {
    aliases: ['st'],
    keywords: 'self super nil true false thisContext', // only 6
    contains: [
      hljs.COMMENT('"', '"'),
      hljs.APOS_STRING_MODE,
      {
        className: 'type',
        begin: '\\b[A-Z][A-Za-z0-9_]*',
        relevance: 0
      },
      {
        begin: VAR_IDENT_RE + ':',
        relevance: 0
      },
      hljs.C_NUMBER_MODE,
      SYMBOL,
      CHAR,
      {
        // This looks more complicated than needed to avoid combinatorial
        // explosion under V8. It effectively means `| var1 var2 ... |` with
        // whitespace adjacent to `|` being optional.
        begin: '\\|[ ]*' + VAR_IDENT_RE + '([ ]+' + VAR_IDENT_RE + ')*[ ]*\\|',
        returnBegin: true, end: /\|/,
        illegal: /\S/,
        contains: [{begin: '(\\|[ ]*)?' + VAR_IDENT_RE}]
      },
      {
        begin: '\\#\\(', end: '\\)',
        contains: [
          hljs.APOS_STRING_MODE,
          CHAR,
          hljs.C_NUMBER_MODE,
          SYMBOL
        ]
      }
    ]
  };
};

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMENT_MODE = hljs.COMMENT('--', '$');
  return {
    case_insensitive: true,
    illegal: /[<>{}*#]/,
    contains: [
      {
        beginKeywords:
          'begin end start commit rollback savepoint lock alter create drop rename call ' +
          'delete do handler insert load replace select truncate update set show pragma grant ' +
          'merge describe use explain help declare prepare execute deallocate release ' +
          'unlock purge reset change stop analyze cache flush optimize repair kill ' +
          'install uninstall checksum restore check backup revoke comment',
        end: /;/, endsWithParent: true,
        lexemes: /[\w\.]+/,
        keywords: {
          keyword:
            'abort abs absolute acc acce accep accept access accessed accessible account acos action activate add ' +
            'addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias ' +
            'allocate allow alter always analyze ancillary and any anydata anydataset anyschema anytype apply ' +
            'archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan ' +
            'atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid ' +
            'authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile ' +
            'before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float ' +
            'binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound ' +
            'buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel ' +
            'capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base ' +
            'char_length character_length characters characterset charindex charset charsetform charsetid check ' +
            'checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close ' +
            'cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation ' +
            'collect colu colum column column_value columns columns_updated comment commit compact compatibility ' +
            'compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn ' +
            'connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection ' +
            'consider consistent constant constraint constraints constructor container content contents context ' +
            'contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost ' +
            'count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation ' +
            'critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user ' +
            'cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add ' +
            'date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts ' +
            'day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate ' +
            'declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults ' +
            'deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank ' +
            'depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor ' +
            'deterministic diagnostics difference dimension direct_load directory disable disable_all ' +
            'disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div ' +
            'do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable ' +
            'editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt ' +
            'end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors ' +
            'escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding ' +
            'execu execut execute exempt exists exit exp expire explain export export_set extended extent external ' +
            'external_1 external_2 externally extract failed failed_login_attempts failover failure far fast ' +
            'feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final ' +
            'finish first first_value fixed flash_cache flashback floor flush following follows for forall force ' +
            'form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ' +
            'ftp full function general generated get get_format get_lock getdate getutcdate global global_name ' +
            'globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups ' +
            'gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex ' +
            'hierarchy high high_priority hosts hour http id ident_current ident_incr ident_seed identified ' +
            'identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment ' +
            'index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile ' +
            'initial initialized initially initrans inmemory inner innodb input insert install instance instantiable ' +
            'instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat ' +
            'is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists ' +
            'keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lax lcase ' +
            'lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit ' +
            'lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate ' +
            'locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call ' +
            'logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime ' +
            'managed management manual map mapping mask master master_pos_wait match matched materialized max ' +
            'maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans ' +
            'md5 measures median medium member memcompress memory merge microsecond mid migration min minextents ' +
            'minimum mining minus minute minvalue missing mod mode model modification modify module monitoring month ' +
            'months mount move movement multiset mutex name name_const names nan national native natural nav nchar ' +
            'nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile ' +
            'nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile ' +
            'nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder ' +
            'nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck ' +
            'noswitch not nothing notice notrim novalidate now nowait nth_value nullif nulls num numb numbe ' +
            'nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ' +
            'ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old ' +
            'on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date ' +
            'oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary ' +
            'out outer outfile outline output over overflow overriding package pad parallel parallel_enable ' +
            'parameters parent parse partial partition partitions pascal passing password password_grace_time ' +
            'password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex ' +
            'pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc ' +
            'performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin ' +
            'policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction ' +
            'prediction_cost prediction_details prediction_probability prediction_set prepare present preserve ' +
            'prior priority private private_sga privileges procedural procedure procedure_analyze processlist ' +
            'profiles project prompt protection public publishingservername purge quarter query quick quiesce quota ' +
            'quotename radians raise rand range rank raw read reads readsize rebuild record records ' +
            'recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh ' +
            'regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy ' +
            'reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename ' +
            'repair repeat replace replicate replication required reset resetlogs resize resource respect restore ' +
            'restricted result result_cache resumable resume retention return returning returns reuse reverse revoke ' +
            'right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows ' +
            'rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll ' +
            'sdo_georaster sdo_topo_geometry search sec_to_time second section securefile security seed segment select ' +
            'self sequence sequential serializable server servererror session session_user sessions_per_user set ' +
            'sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor ' +
            'si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin ' +
            'size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex ' +
            'source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows ' +
            'sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone ' +
            'standby start starting startup statement static statistics stats_binomial_test stats_crosstab ' +
            'stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep ' +
            'stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev ' +
            'stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate ' +
            'subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum ' +
            'suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate ' +
            'sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tan tdo ' +
            'template temporary terminated tertiary_weights test than then thread through tier ties time time_format ' +
            'time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr ' +
            'timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking ' +
            'transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate ' +
            'try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress ' +
            'under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unpivot ' +
            'unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert ' +
            'url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date ' +
            'utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var ' +
            'var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray ' +
            'verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear ' +
            'wellformed when whene whenev wheneve whenever where while whitespace with within without work wrapped ' +
            'xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces ' +
            'xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek',
          literal:
            'true false null',
          built_in:
            'array bigint binary bit blob boolean char character date dec decimal float int int8 integer interval number ' +
            'numeric real record serial serial8 smallint text varchar varying void'
        },
        contains: [
          {
            className: 'string',
            begin: '\'', end: '\'',
            contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
          },
          {
            className: 'string',
            begin: '"', end: '"',
            contains: [hljs.BACKSLASH_ESCAPE, {begin: '""'}]
          },
          {
            className: 'string',
            begin: '`', end: '`',
            contains: [hljs.BACKSLASH_ESCAPE]
          },
          hljs.C_NUMBER_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          COMMENT_MODE
        ]
      },
      hljs.C_BLOCK_COMMENT_MODE,
      COMMENT_MODE
    ]
  };
};

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

  var VARIABLE = {
    className: 'variable',
    begin: '\\$' + hljs.IDENT_RE
  };

  var HEX_COLOR = {
    className: 'number',
    begin: '#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})'
  };

  var AT_KEYWORDS = [
    'charset',
    'css',
    'debug',
    'extend',
    'font-face',
    'for',
    'import',
    'include',
    'media',
    'mixin',
    'page',
    'warn',
    'while'
  ];

  var PSEUDO_SELECTORS = [
    'after',
    'before',
    'first-letter',
    'first-line',
    'active',
    'first-child',
    'focus',
    'hover',
    'lang',
    'link',
    'visited'
  ];

  var TAGS = [
    'a',
    'abbr',
    'address',
    'article',
    'aside',
    'audio',
    'b',
    'blockquote',
    'body',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'dd',
    'del',
    'details',
    'dfn',
    'div',
    'dl',
    'dt',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'mark',
    'menu',
    'nav',
    'object',
    'ol',
    'p',
    'q',
    'quote',
    'samp',
    'section',
    'span',
    'strong',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'ul',
    'var',
    'video'
  ];

  var TAG_END = '[\\.\\s\\n\\[\\:,]';

  var ATTRIBUTES = [
    'align-content',
    'align-items',
    'align-self',
    'animation',
    'animation-delay',
    'animation-direction',
    'animation-duration',
    'animation-fill-mode',
    'animation-iteration-count',
    'animation-name',
    'animation-play-state',
    'animation-timing-function',
    'auto',
    'backface-visibility',
    'background',
    'background-attachment',
    'background-clip',
    'background-color',
    'background-image',
    'background-origin',
    'background-position',
    'background-repeat',
    'background-size',
    'border',
    'border-bottom',
    'border-bottom-color',
    'border-bottom-left-radius',
    'border-bottom-right-radius',
    'border-bottom-style',
    'border-bottom-width',
    'border-collapse',
    'border-color',
    'border-image',
    'border-image-outset',
    'border-image-repeat',
    'border-image-slice',
    'border-image-source',
    'border-image-width',
    'border-left',
    'border-left-color',
    'border-left-style',
    'border-left-width',
    'border-radius',
    'border-right',
    'border-right-color',
    'border-right-style',
    'border-right-width',
    'border-spacing',
    'border-style',
    'border-top',
    'border-top-color',
    'border-top-left-radius',
    'border-top-right-radius',
    'border-top-style',
    'border-top-width',
    'border-width',
    'bottom',
    'box-decoration-break',
    'box-shadow',
    'box-sizing',
    'break-after',
    'break-before',
    'break-inside',
    'caption-side',
    'clear',
    'clip',
    'clip-path',
    'color',
    'column-count',
    'column-fill',
    'column-gap',
    'column-rule',
    'column-rule-color',
    'column-rule-style',
    'column-rule-width',
    'column-span',
    'column-width',
    'columns',
    'content',
    'counter-increment',
    'counter-reset',
    'cursor',
    'direction',
    'display',
    'empty-cells',
    'filter',
    'flex',
    'flex-basis',
    'flex-direction',
    'flex-flow',
    'flex-grow',
    'flex-shrink',
    'flex-wrap',
    'float',
    'font',
    'font-family',
    'font-feature-settings',
    'font-kerning',
    'font-language-override',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-variant-ligatures',
    'font-weight',
    'height',
    'hyphens',
    'icon',
    'image-orientation',
    'image-rendering',
    'image-resolution',
    'ime-mode',
    'inherit',
    'initial',
    'justify-content',
    'left',
    'letter-spacing',
    'line-height',
    'list-style',
    'list-style-image',
    'list-style-position',
    'list-style-type',
    'margin',
    'margin-bottom',
    'margin-left',
    'margin-right',
    'margin-top',
    'marks',
    'mask',
    'max-height',
    'max-width',
    'min-height',
    'min-width',
    'nav-down',
    'nav-index',
    'nav-left',
    'nav-right',
    'nav-up',
    'none',
    'normal',
    'object-fit',
    'object-position',
    'opacity',
    'order',
    'orphans',
    'outline',
    'outline-color',
    'outline-offset',
    'outline-style',
    'outline-width',
    'overflow',
    'overflow-wrap',
    'overflow-x',
    'overflow-y',
    'padding',
    'padding-bottom',
    'padding-left',
    'padding-right',
    'padding-top',
    'page-break-after',
    'page-break-before',
    'page-break-inside',
    'perspective',
    'perspective-origin',
    'pointer-events',
    'position',
    'quotes',
    'resize',
    'right',
    'tab-size',
    'table-layout',
    'text-align',
    'text-align-last',
    'text-decoration',
    'text-decoration-color',
    'text-decoration-line',
    'text-decoration-style',
    'text-indent',
    'text-overflow',
    'text-rendering',
    'text-shadow',
    'text-transform',
    'text-underline-position',
    'top',
    'transform',
    'transform-origin',
    'transform-style',
    'transition',
    'transition-delay',
    'transition-duration',
    'transition-property',
    'transition-timing-function',
    'unicode-bidi',
    'vertical-align',
    'visibility',
    'white-space',
    'widows',
    'width',
    'word-break',
    'word-spacing',
    'word-wrap',
    'z-index'
  ];

  // illegals
  var ILLEGAL = [
    '\\?',
    '(\\bReturn\\b)', // monkey
    '(\\bEnd\\b)', // monkey
    '(\\bend\\b)', // vbscript
    '(\\bdef\\b)', // gradle
    ';', // a whole lot of languages
    '#\\s', // markdown
    '\\*\\s', // markdown
    '===\\s', // markdown
    '\\|',
    '%', // prolog
  ];

  return {
    aliases: ['styl'],
    case_insensitive: false,
    keywords: 'if else for in',
    illegal: '(' + ILLEGAL.join('|') + ')',
    contains: [

      // strings
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,

      // comments
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,

      // hex colors
      HEX_COLOR,

      // class tag
      {
        begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
        returnBegin: true,
        contains: [
          {className: 'selector-class', begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*'}
        ]
      },

      // id tag
      {
        begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
        returnBegin: true,
        contains: [
          {className: 'selector-id', begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*'}
        ]
      },

      // tags
      {
        begin: '\\b(' + TAGS.join('|') + ')' + TAG_END,
        returnBegin: true,
        contains: [
          {className: 'selector-tag', begin: '\\b[a-zA-Z][a-zA-Z0-9_-]*'}
        ]
      },

      // psuedo selectors
      {
        begin: '&?:?:\\b(' + PSEUDO_SELECTORS.join('|') + ')' + TAG_END
      },

      // @ keywords
      {
        begin: '\@(' + AT_KEYWORDS.join('|') + ')\\b'
      },

      // variables
      VARIABLE,

      // dimension
      hljs.CSS_NUMBER_MODE,

      // number
      hljs.NUMBER_MODE,

      // functions
      //  - only from beginning of line + whitespace
      {
        className: 'function',
        begin: '^[a-zA-Z][a-zA-Z0-9_\-]*\\(.*\\)',
        illegal: '[\\n]',
        returnBegin: true,
        contains: [
          {className: 'title', begin: '\\b[a-zA-Z][a-zA-Z0-9_\-]*'},
          {
            className: 'params',
            begin: /\(/,
            end: /\)/,
            contains: [
              HEX_COLOR,
              VARIABLE,
              hljs.APOS_STRING_MODE,
              hljs.CSS_NUMBER_MODE,
              hljs.NUMBER_MODE,
              hljs.QUOTE_STRING_MODE
            ]
          }
        ]
      },

      // attributes
      //  - only from beginning of line + whitespace
      //  - must have whitespace after it
      {
        className: 'attribute',
        begin: '\\b(' + ATTRIBUTES.reverse().join('|') + ')\\b',
        starts: {
          // value container
          end: /;|$/,
          contains: [
            HEX_COLOR,
            VARIABLE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.CSS_NUMBER_MODE,
            hljs.NUMBER_MODE,
            hljs.C_BLOCK_COMMENT_MODE
          ],
          illegal: /\./,
          relevance: 0
        }
      }
    ]
  };
};

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var SWIFT_KEYWORDS = {
      keyword: '__COLUMN__ __FILE__ __FUNCTION__ __LINE__ as as! as? associativity ' +
        'break case catch class continue convenience default defer deinit didSet do ' +
        'dynamic dynamicType else enum extension fallthrough false fileprivate final for func ' +
        'get guard if import in indirect infix init inout internal is lazy left let ' +
        'mutating nil none nonmutating open operator optional override postfix precedence ' +
        'prefix private protocol Protocol public repeat required rethrows return ' +
        'right self Self set static struct subscript super switch throw throws true ' +
        'try try! try? Type typealias unowned var weak where while willSet',
      literal: 'true false nil',
      built_in: 'abs advance alignof alignofValue anyGenerator assert assertionFailure ' +
        'bridgeFromObjectiveC bridgeFromObjectiveCUnconditional bridgeToObjectiveC ' +
        'bridgeToObjectiveCUnconditional c contains count countElements countLeadingZeros ' +
        'debugPrint debugPrintln distance dropFirst dropLast dump encodeBitsAsWords ' +
        'enumerate equal fatalError filter find getBridgedObjectiveCType getVaList ' +
        'indices insertionSort isBridgedToObjectiveC isBridgedVerbatimToObjectiveC ' +
        'isUniquelyReferenced isUniquelyReferencedNonObjC join lazy lexicographicalCompare ' +
        'map max maxElement min minElement numericCast overlaps partition posix ' +
        'precondition preconditionFailure print println quickSort readLine reduce reflect ' +
        'reinterpretCast reverse roundUpToAlignment sizeof sizeofValue sort split ' +
        'startsWith stride strideof strideofValue swap toString transcode ' +
        'underestimateCount unsafeAddressOf unsafeBitCast unsafeDowncast unsafeUnwrap ' +
        'unsafeReflect withExtendedLifetime withObjectAtPlusZero withUnsafePointer ' +
        'withUnsafePointerToObject withUnsafeMutablePointer withUnsafeMutablePointers ' +
        'withUnsafePointer withUnsafePointers withVaList zip'
    };

  var TYPE = {
    className: 'type',
    begin: '\\b[A-Z][\\w\u00C0-\u02B8\']*',
    relevance: 0
  };
  var BLOCK_COMMENT = hljs.COMMENT(
    '/\\*',
    '\\*/',
    {
      contains: ['self']
    }
  );
  var SUBST = {
    className: 'subst',
    begin: /\\\(/, end: '\\)',
    keywords: SWIFT_KEYWORDS,
    contains: [] // assigned later
  };
  var NUMBERS = {
      className: 'number',
      begin: '\\b([\\d_]+(\\.[\\deE_]+)?|0x[a-fA-F0-9_]+(\\.[a-fA-F0-9p_]+)?|0b[01_]+|0o[0-7_]+)\\b',
      relevance: 0
  };
  var QUOTE_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    contains: [SUBST, hljs.BACKSLASH_ESCAPE]
  });
  SUBST.contains = [NUMBERS];

  return {
    keywords: SWIFT_KEYWORDS,
    contains: [
      QUOTE_STRING_MODE,
      hljs.C_LINE_COMMENT_MODE,
      BLOCK_COMMENT,
      TYPE,
      NUMBERS,
      {
        className: 'function',
        beginKeywords: 'func', end: '{', excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            begin: /[A-Za-z$_][0-9A-Za-z$_]*/
          }),
          {
            begin: /</, end: />/
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/, endsParent: true,
            keywords: SWIFT_KEYWORDS,
            contains: [
              'self',
              NUMBERS,
              QUOTE_STRING_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              {begin: ':'} // relevance booster
            ],
            illegal: /["']/
          }
        ],
        illegal: /\[|%/
      },
      {
        className: 'class',
        beginKeywords: 'struct protocol class extension enum',
        keywords: SWIFT_KEYWORDS,
        end: '\\{',
        excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/})
        ]
      },
      {
        className: 'meta', // @attributes
        begin: '(@warn_unused_result|@exported|@lazy|@noescape|' +
                  '@NSCopying|@NSManaged|@objc|@convention|@required|' +
                  '@noreturn|@IBAction|@IBDesignable|@IBInspectable|@IBOutlet|' +
                  '@infix|@prefix|@postfix|@autoclosure|@testable|@available|' +
                  '@nonobjc|@NSApplicationMain|@UIApplicationMain)'

      },
      {
        beginKeywords: 'import', end: /$/,
        contains: [hljs.C_LINE_COMMENT_MODE, BLOCK_COMMENT]
      }
    ]
  };
};

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMAND = {
    className: 'tag',
    begin: /\\/,
    relevance: 0,
    contains: [
      {
        className: 'name',
        variants: [
          {begin: /[a-zA-Zа-яА-я]+[*]?/},
          {begin: /[^a-zA-Zа-яА-я0-9]/}
        ],
        starts: {
          endsWithParent: true,
          relevance: 0,
          contains: [
            {
              className: 'string', // because it looks like attributes in HTML tags
              variants: [
                {begin: /\[/, end: /\]/},
                {begin: /\{/, end: /\}/}
              ]
            },
            {
              begin: /\s*=\s*/, endsWithParent: true,
              relevance: 0,
              contains: [
                {
                  className: 'number',
                  begin: /-?\d*\.?\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?/
                }
              ]
            }
          ]
        }
      }
    ]
  };

  return {
    contains: [
      COMMAND,
      {
        className: 'formula',
        contains: [COMMAND],
        relevance: 0,
        variants: [
          {begin: /\$\$/, end: /\$\$/},
          {begin: /\$/, end: /\$/}
        ]
      },
      hljs.COMMENT(
        '%',
        '$',
        {
          relevance: 0
        }
      )
    ]
  };
};

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['vb'],
    case_insensitive: true,
    keywords: {
      keyword:
        'addhandler addressof alias and andalso aggregate ansi as assembly auto binary by byref byval ' + /* a-b */
        'call case catch class compare const continue custom declare default delegate dim distinct do ' + /* c-d */
        'each equals else elseif end enum erase error event exit explicit finally for friend from function ' + /* e-f */
        'get global goto group handles if implements imports in inherits interface into is isfalse isnot istrue ' + /* g-i */
        'join key let lib like loop me mid mod module mustinherit mustoverride mybase myclass ' + /* j-m */
        'namespace narrowing new next not notinheritable notoverridable ' + /* n */
        'of off on operator option optional or order orelse overloads overridable overrides ' + /* o */
        'paramarray partial preserve private property protected public ' + /* p */
        'raiseevent readonly redim rem removehandler resume return ' + /* r */
        'select set shadows shared skip static step stop structure strict sub synclock ' + /* s */
        'take text then throw to try unicode until using when where while widening with withevents writeonly xor', /* t-x */
      built_in:
        'boolean byte cbool cbyte cchar cdate cdec cdbl char cint clng cobj csbyte cshort csng cstr ctype ' +  /* b-c */
        'date decimal directcast double gettype getxmlnamespace iif integer long object ' + /* d-o */
        'sbyte short single string trycast typeof uinteger ulong ushort', /* s-u */
      literal:
        'true false nothing'
    },
    illegal: '//|{|}|endif|gosub|variant|wend', /* reserved deprecated keywords */
    contains: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
      hljs.COMMENT(
        '\'',
        '$',
        {
          returnBegin: true,
          contains: [
            {
              className: 'doctag',
              begin: '\'\'\'|<!--|-->',
              contains: [hljs.PHRASAL_WORDS_MODE]
            },
            {
              className: 'doctag',
              begin: '</?', end: '>',
              contains: [hljs.PHRASAL_WORDS_MODE]
            }
          ]
        }
      ),
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '#', end: '$',
        keywords: {'meta-keyword': 'if else elseif end region externalsource'}
      }
    ]
  };
};

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['vbs'],
    case_insensitive: true,
    keywords: {
      keyword:
        'call class const dim do loop erase execute executeglobal exit for each next function ' +
        'if then else on error option explicit new private property let get public randomize ' +
        'redim rem select case set stop sub while wend with end to elseif is or xor and not ' +
        'class_initialize class_terminate default preserve in me byval byref step resume goto',
      built_in:
        'lcase month vartype instrrev ubound setlocale getobject rgb getref string ' +
        'weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency ' +
        'conversions csng timevalue second year space abs clng timeserial fixs len asc ' +
        'isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate ' +
        'instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex ' +
        'chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim ' +
        'strcomp int createobject loadpicture tan formatnumber mid scriptenginebuildversion ' +
        'scriptengine split scriptengineminorversion cint sin datepart ltrim sqr ' +
        'scriptenginemajorversion time derived eval date formatpercent exp inputbox left ascw ' +
        'chrw regexp server response request cstr err',
      literal:
        'true false null nothing empty'
    },
    illegal: '//',
    contains: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
      hljs.COMMENT(
        /'/,
        /$/,
        {
          relevance: 0
        }
      ),
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var SV_KEYWORDS = {
    keyword:
      'accept_on alias always always_comb always_ff always_latch and assert assign ' +
      'assume automatic before begin bind bins binsof bit break buf|0 bufif0 bufif1 ' +
      'byte case casex casez cell chandle checker class clocking cmos config const ' +
      'constraint context continue cover covergroup coverpoint cross deassign default ' +
      'defparam design disable dist do edge else end endcase endchecker endclass ' +
      'endclocking endconfig endfunction endgenerate endgroup endinterface endmodule ' +
      'endpackage endprimitive endprogram endproperty endspecify endsequence endtable ' +
      'endtask enum event eventually expect export extends extern final first_match for ' +
      'force foreach forever fork forkjoin function generate|5 genvar global highz0 highz1 ' +
      'if iff ifnone ignore_bins illegal_bins implements implies import incdir include ' +
      'initial inout input inside instance int integer interconnect interface intersect ' +
      'join join_any join_none large let liblist library local localparam logic longint ' +
      'macromodule matches medium modport module nand negedge nettype new nexttime nmos ' +
      'nor noshowcancelled not notif0 notif1 or output package packed parameter pmos ' +
      'posedge primitive priority program property protected pull0 pull1 pulldown pullup ' +
      'pulsestyle_ondetect pulsestyle_onevent pure rand randc randcase randsequence rcmos ' +
      'real realtime ref reg reject_on release repeat restrict return rnmos rpmos rtran ' +
      'rtranif0 rtranif1 s_always s_eventually s_nexttime s_until s_until_with scalared ' +
      'sequence shortint shortreal showcancelled signed small soft solve specify specparam ' +
      'static string strong strong0 strong1 struct super supply0 supply1 sync_accept_on ' +
      'sync_reject_on table tagged task this throughout time timeprecision timeunit tran ' +
      'tranif0 tranif1 tri tri0 tri1 triand trior trireg type typedef union unique unique0 ' +
      'unsigned until until_with untyped use uwire var vectored virtual void wait wait_order ' +
      'wand weak weak0 weak1 while wildcard wire with within wor xnor xor',
    literal:
      'null',
    built_in:
      '$finish $stop $exit $fatal $error $warning $info $realtime $time $printtimescale ' +
      '$bitstoreal $bitstoshortreal $itor $signed $cast $bits $stime $timeformat ' +
      '$realtobits $shortrealtobits $rtoi $unsigned $asserton $assertkill $assertpasson ' +
      '$assertfailon $assertnonvacuouson $assertoff $assertcontrol $assertpassoff ' +
      '$assertfailoff $assertvacuousoff $isunbounded $sampled $fell $changed $past_gclk ' +
      '$fell_gclk $changed_gclk $rising_gclk $steady_gclk $coverage_control ' +
      '$coverage_get $coverage_save $set_coverage_db_name $rose $stable $past ' +
      '$rose_gclk $stable_gclk $future_gclk $falling_gclk $changing_gclk $display ' +
      '$coverage_get_max $coverage_merge $get_coverage $load_coverage_db $typename ' +
      '$unpacked_dimensions $left $low $increment $clog2 $ln $log10 $exp $sqrt $pow ' +
      '$floor $ceil $sin $cos $tan $countbits $onehot $isunknown $fatal $warning ' +
      '$dimensions $right $high $size $asin $acos $atan $atan2 $hypot $sinh $cosh ' +
      '$tanh $asinh $acosh $atanh $countones $onehot0 $error $info $random ' +
      '$dist_chi_square $dist_erlang $dist_exponential $dist_normal $dist_poisson ' +
      '$dist_t $dist_uniform $q_initialize $q_remove $q_exam $async$and$array ' +
      '$async$nand$array $async$or$array $async$nor$array $sync$and$array ' +
      '$sync$nand$array $sync$or$array $sync$nor$array $q_add $q_full $psprintf ' +
      '$async$and$plane $async$nand$plane $async$or$plane $async$nor$plane ' +
      '$sync$and$plane $sync$nand$plane $sync$or$plane $sync$nor$plane $system ' +
      '$display $displayb $displayh $displayo $strobe $strobeb $strobeh $strobeo ' +
      '$write $readmemb $readmemh $writememh $value$plusargs ' +
      '$dumpvars $dumpon $dumplimit $dumpports $dumpportson $dumpportslimit ' +
      '$writeb $writeh $writeo $monitor $monitorb $monitorh $monitoro $writememb ' +
      '$dumpfile $dumpoff $dumpall $dumpflush $dumpportsoff $dumpportsall ' +
      '$dumpportsflush $fclose $fdisplay $fdisplayb $fdisplayh $fdisplayo ' +
      '$fstrobe $fstrobeb $fstrobeh $fstrobeo $swrite $swriteb $swriteh ' +
      '$swriteo $fscanf $fread $fseek $fflush $feof $fopen $fwrite $fwriteb ' +
      '$fwriteh $fwriteo $fmonitor $fmonitorb $fmonitorh $fmonitoro $sformat ' +
      '$sformatf $fgetc $ungetc $fgets $sscanf $rewind $ftell $ferror'
    };
  return {
    aliases: ['v', 'sv', 'svh'],
    case_insensitive: false,
    keywords: SV_KEYWORDS, lexemes: /[\w\$]+/,
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'number',
        contains: [hljs.BACKSLASH_ESCAPE],
        variants: [
          {begin: '\\b((\\d+\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'},
          {begin: '\\B((\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'},
          {begin: '\\b([0-9_])+', relevance: 0}
        ]
      },
      /* parameters to instances */
      {
        className: 'variable',
        variants: [
          {begin: '#\\((?!parameter).+\\)'},
          {begin: '\\.\\w+', relevance: 0},
        ]
      },
      {
        className: 'meta',
        begin: '`', end: '$',
        keywords: {'meta-keyword': 'define __FILE__ ' +
          '__LINE__ begin_keywords celldefine default_nettype define ' +
          'else elsif end_keywords endcelldefine endif ifdef ifndef ' +
          'include line nounconnected_drive pragma resetall timescale ' +
          'unconnected_drive undef undefineall'},
        relevance: 0
      }
    ]
  }; // return
};

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var XML_IDENT_RE = '[A-Za-z0-9\\._:-]+';
  var TAG_INTERNALS = {
    endsWithParent: true,
    illegal: /</,
    relevance: 0,
    contains: [
      {
        className: 'attr',
        begin: XML_IDENT_RE,
        relevance: 0
      },
      {
        begin: /=\s*/,
        relevance: 0,
        contains: [
          {
            className: 'string',
            endsParent: true,
            variants: [
              {begin: /"/, end: /"/},
              {begin: /'/, end: /'/},
              {begin: /[^\s"'=<>`]+/}
            ]
          }
        ]
      }
    ]
  };
  return {
    aliases: ['html', 'xhtml', 'rss', 'atom', 'xjb', 'xsd', 'xsl', 'plist'],
    case_insensitive: true,
    contains: [
      {
        className: 'meta',
        begin: '<!DOCTYPE', end: '>',
        relevance: 10,
        contains: [{begin: '\\[', end: '\\]'}]
      },
      hljs.COMMENT(
        '<!--',
        '-->',
        {
          relevance: 10
        }
      ),
      {
        begin: '<\\!\\[CDATA\\[', end: '\\]\\]>',
        relevance: 10
      },
      {
        begin: /<\?(php)?/, end: /\?>/,
        subLanguage: 'php',
        contains: [{begin: '/\\*', end: '\\*/', skip: true}]
      },
      {
        className: 'tag',
        /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending braket. The '$' is needed for the lexeme to be recognized
        by hljs.subMode() that tests lexemes outside the stream.
        */
        begin: '<style(?=\\s|>|$)', end: '>',
        keywords: {name: 'style'},
        contains: [TAG_INTERNALS],
        starts: {
          end: '</style>', returnEnd: true,
          subLanguage: ['css', 'xml']
        }
      },
      {
        className: 'tag',
        // See the comment in the <style tag about the lookahead pattern
        begin: '<script(?=\\s|>|$)', end: '>',
        keywords: {name: 'script'},
        contains: [TAG_INTERNALS],
        starts: {
          end: '\<\/script\>', returnEnd: true,
          subLanguage: ['actionscript', 'javascript', 'handlebars', 'xml']
        }
      },
      {
        className: 'meta',
        variants: [
          {begin: /<\?xml/, end: /\?>/, relevance: 10},
          {begin: /<\?\w+/, end: /\?>/}
        ]
      },
      {
        className: 'tag',
        begin: '</?', end: '/?>',
        contains: [
          {
            className: 'name', begin: /[^\/><\s]+/, relevance: 0
          },
          TAG_INTERNALS
        ]
      }
    ]
  };
};

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var LITERALS = 'true false yes no null';

  var keyPrefix = '^[ \\-]*';
  var keyName =  '[a-zA-Z_][\\w\\-]*';
  var KEY = {
    className: 'attr',
    variants: [
      { begin: keyPrefix + keyName + ":"},
      { begin: keyPrefix + '"' + keyName + '"' + ":"},
      { begin: keyPrefix + "'" + keyName + "'" + ":"}
    ]
  };

  var TEMPLATE_VARIABLES = {
    className: 'template-variable',
    variants: [
      { begin: '\{\{', end: '\}\}' }, // jinja templates Ansible
      { begin: '%\{', end: '\}' } // Ruby i18n
    ]
  };
  var STRING = {
    className: 'string',
    relevance: 0,
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/},
      {begin: /\S+/}
    ],
    contains: [
      hljs.BACKSLASH_ESCAPE,
      TEMPLATE_VARIABLES
    ]
  };

  return {
    case_insensitive: true,
    aliases: ['yml', 'YAML', 'yaml'],
    contains: [
      KEY,
      {
        className: 'meta',
        begin: '^---\s*$',
        relevance: 10
      },
      { // multi line string
        className: 'string',
        begin: '[\\|>] *$',
        returnEnd: true,
        contains: STRING.contains,
        // very simple termination: next hash key
        end: KEY.variants[0].begin
      },
      { // Ruby/Rails erb
        begin: '<%[%=-]?', end: '[%-]?%>',
        subLanguage: 'ruby',
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0
      },
      { // data type
        className: 'type',
        begin: '!!' + hljs.UNDERSCORE_IDENT_RE,
      },
      { // fragment id &ref
        className: 'meta',
        begin: '&' + hljs.UNDERSCORE_IDENT_RE + '$',
      },
      { // fragment reference *ref
        className: 'meta',
        begin: '\\*' + hljs.UNDERSCORE_IDENT_RE + '$'
      },
      { // array listing
        className: 'bullet',
        begin: '^ *-',
        relevance: 0
      },
      hljs.HASH_COMMENT_MODE,
      {
        beginKeywords: LITERALS,
        keywords: {literal: LITERALS}
      },
      hljs.C_NUMBER_MODE,
      STRING
    ]
  };
};

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

module.exports = {"about.buildnumber":"Build Number:","about.close":"Close","about.copyright":"Copyright 2015 - {currentYear} Mattermost, Inc. All rights reserved","about.database":"Database:","about.date":"Build Date:","about.dbversion":"Database Schema Version:","about.enterpriseEditionLearn":"Learn more about Enterprise Edition at ","about.enterpriseEditionSt":"Modern communication from behind your firewall.","about.enterpriseEditione1":"Enterprise Edition","about.hash":"Build Hash:","about.hashee":"EE Build Hash:","about.hashwebapp":"Webapp Build Hash:","about.licensed":"Licensed to:","about.notice":"Mattermost is made possible by the open source software used in our <a href=\"https://about.mattermost.com/platform-notice-txt/\" target='_blank'>platform</a>, <a href=\"https://about.mattermost.com/desktop-notice-txt/\" target='_blank'>desktop</a> and <a href=\"https://about.mattermost.com/mobile-notice-txt/\" target='_blank'>mobile</a> apps.","about.number":"Build Number:","about.teamEditionLearn":"Join the Mattermost community at ","about.teamEditionSt":"All your team communication in one place, instantly searchable and accessible anywhere.","about.teamEditiont0":"Team Edition","about.teamEditiont1":"Enterprise Edition","about.title":"About Mattermost","about.version":"Mattermost Version:","access_history.title":"Access History","activity_log.activeSessions":"Active Sessions","activity_log.browser":"Browser: {browser}","activity_log.firstTime":"First time active: {date}, {time}","activity_log.lastActivity":"Last activity: {date}, {time}","activity_log.logout":"Logout","activity_log.moreInfo":"More info","activity_log.os":"OS: {os}","activity_log.sessionId":"Session ID: {id}","activity_log.sessionsDescription":"Sessions are created when you log in to a new browser on a device. Sessions let you use Mattermost without having to log in again for a time period specified by the System Admin. If you want to log out sooner, use the 'Logout' button below to end a session.","activity_log_modal.android":"Android","activity_log_modal.androidNativeApp":"Android Native App","activity_log_modal.androidNativeClassicApp":"Android Native Classic App","activity_log_modal.desktop":"Native Desktop App","activity_log_modal.iphoneNativeApp":"iPhone Native App","activity_log_modal.iphoneNativeClassicApp":"iPhone Native Classic App","add_command.autocomplete":"Autocomplete","add_command.autocomplete.help":"(Optional) Show slash command in autocomplete list.","add_command.autocompleteDescription":"Autocomplete Description","add_command.autocompleteDescription.help":"(Optional) Short description of slash command for the autocomplete list.","add_command.autocompleteDescription.placeholder":"Example: \"Returns search results for patient records\"","add_command.autocompleteHint":"Autocomplete Hint","add_command.autocompleteHint.help":"(Optional) Arguments associated with your slash command, displayed as help in the autocomplete list.","add_command.autocompleteHint.placeholder":"Example: [Patient Name]","add_command.cancel":"Cancel","add_command.description":"Description","add_command.description.help":"Description for your incoming webhook.","add_command.displayName":"Title","add_command.displayName.help":"Choose a title to be displayed on the slash command settings page. Maximum 64 characters.","add_command.doneHelp":"Your slash command has been set up. The following token will be sent in the outgoing payload. Please use it to verify the request came from your Mattermost team (see <a href=\"https://docs.mattermost.com/developer/slash-commands.html\">documentation</a> for further details).","add_command.iconUrl":"Response Icon","add_command.iconUrl.help":"(Optional) Choose a profile picture override for the post responses to this slash command. Enter the URL of a .png or .jpg file at least 128 pixels by 128 pixels.","add_command.iconUrl.placeholder":"https://www.example.com/myicon.png","add_command.method":"Request Method","add_command.method.get":"GET","add_command.method.help":"The type of command request issued to the Request URL.","add_command.method.post":"POST","add_command.save":"Save","add_command.token":"<b>Token</b>: {token}","add_command.trigger":"Command Trigger Word","add_command.trigger.help":"Trigger word must be unique, and cannot begin with a slash or contain any spaces.","add_command.trigger.helpExamples":"Examples: client, employee, patient, weather","add_command.trigger.helpReserved":"Reserved: {link}","add_command.trigger.helpReservedLinkText":"see list of built-in slash commands","add_command.trigger.placeholder":"Command trigger e.g. \"hello\"","add_command.triggerInvalidLength":"A trigger word must contain between {min} and {max} characters","add_command.triggerInvalidSlash":"A trigger word cannot begin with a /","add_command.triggerInvalidSpace":"A trigger word must not contain spaces","add_command.triggerRequired":"A trigger word is required","add_command.url":"Request URL","add_command.url.help":"The callback URL to receive the HTTP POST or GET event request when the slash command is run.","add_command.url.placeholder":"Must start with http:// or https://","add_command.urlRequired":"A request URL is required","add_command.username":"Response Username","add_command.username.help":"(Optional) Choose a username override for responses for this slash command. Usernames can consist of up to 22 characters consisting of lowercase letters, numbers and they symbols \"-\", \"_\", and \".\" .","add_command.username.placeholder":"Username","add_emoji.cancel":"Cancel","add_emoji.header":"Add","add_emoji.image":"Image","add_emoji.image.button":"Select","add_emoji.image.help":"Choose the image for your emoji. The image can be a gif, png, or jpeg file with a max size of 1 MB. Dimensions will automatically resize to fit 128 by 128 pixels but keeping aspect ratio.","add_emoji.imageRequired":"An image is required for the emoji","add_emoji.name":"Name","add_emoji.name.help":"Choose a name for your emoji made of up to 64 characters consisting of lowercase letters, numbers, and the symbols '-' and '_'.","add_emoji.nameInvalid":"An emoji's name can only contain numbers, letters, and the symbols '-' and '_'.","add_emoji.nameRequired":"A name is required for the emoji","add_emoji.nameTaken":"This name is already in use by a system emoji. Please choose another name.","add_emoji.preview":"Preview","add_emoji.preview.sentence":"This is a sentence with {image} in it.","add_emoji.save":"Save","add_incoming_webhook.cancel":"Cancel","add_incoming_webhook.channel":"Channel","add_incoming_webhook.channel.help":"Public or private channel that receives the webhook payloads. You must belong to the private channel when setting up the webhook.","add_incoming_webhook.channelRequired":"A valid channel is required","add_incoming_webhook.description":"Description","add_incoming_webhook.description.help":"Description for your incoming webhook.","add_incoming_webhook.displayName":"Title","add_incoming_webhook.displayName.help":"Choose a title to be displayed on the webhook settings page. Maximum 64 characters.","add_incoming_webhook.doneHelp":"Your incoming webhook has been set up. Please send data to the following URL (see <a href=\"https://docs.mattermost.com/developer/webhooks-incoming.html\">documentation</a> for further details).","add_incoming_webhook.icon_url":"Profile Picture","add_incoming_webhook.icon_url.help":"Choose the profile picture this integration will use when posting. Enter the URL of a .png or .jpg file at least 128 pixels by 128 pixels.","add_incoming_webhook.name":"Name","add_incoming_webhook.save":"Save","add_incoming_webhook.url":"<b>URL</b>: {url}","add_incoming_webhook.username":"Username","add_incoming_webhook.username.help":"Choose the username this integration will post as. Usernames can be up to 22 characters, and may contain lowercase letters, numbers and the symbols \"-\", \"_\", and \".\" .","add_oauth_app.callbackUrls.help":"The redirect URIs to which the service will redirect users after accepting or denying authorization of your application, and which will handle authorization codes or access tokens. Must be a valid URL and start with http:// or https://.","add_oauth_app.callbackUrlsRequired":"One or more callback URLs are required","add_oauth_app.clientId":"<b>Client ID</b>: {id}","add_oauth_app.clientSecret":"<b>Client Secret</b>: {secret}","add_oauth_app.description.help":"Description for your OAuth 2.0 application.","add_oauth_app.descriptionRequired":"Description for the OAuth 2.0 application is required.","add_oauth_app.doneHelp":"Your OAuth 2.0 application has been set up. Please use the following Client ID and Client Secret when requesting authorization for your application (see <a href=\"https://docs.mattermost.com/developer/oauth-2-0-applications.html\">documentation</a> for further details).","add_oauth_app.doneUrlHelp":"The following are your authorized redirect URL(s).","add_oauth_app.header":"Add","add_oauth_app.homepage.help":"The URL for the homepage of the OAuth 2.0 application. Make sure you use HTTP or HTTPS in your URL depending on your server configuration.","add_oauth_app.homepageRequired":"Homepage for the OAuth 2.0 application is required.","add_oauth_app.icon.help":"(Optional) The URL of the image used for your OAuth 2.0 application. Make sure you use HTTP or HTTPS in your URL.","add_oauth_app.name.help":"Display name for your OAuth 2.0 application made of up to 64 characters.","add_oauth_app.nameRequired":"Name for the OAuth 2.0 application is required.","add_oauth_app.trusted.help":"When true, the OAuth 2.0 application is considered trusted by the Mattermost server and doesn't require the user to accept authorization. When false, an additional window will appear, asking the user to accept or deny the authorization.","add_oauth_app.url":"<b>URL(s)</b>: {url}","add_outgoing_webhook.callbackUrls":"Callback URLs (One Per Line)","add_outgoing_webhook.callbackUrls.help":"The URL that messages will be sent to. If the URL is private, add it as a {link}.","add_outgoing_webhook.callbackUrls.helpLinkText":"trusted internal connection","add_outgoing_webhook.callbackUrlsRequired":"One or more callback URLs are required","add_outgoing_webhook.cancel":"Cancel","add_outgoing_webhook.channel":"Channel","add_outgoing_webhook.channel.help":"Public channel to receive webhook payloads. Optional if at least one Trigger Word is specified.","add_outgoing_webhook.contentType.help1":"Choose the content type by which the response will be sent.","add_outgoing_webhook.contentType.help2":"If application/x-www-form-urlencoded is chosen, the server assumes you will be encoding the parameters in a URL format.","add_outgoing_webhook.contentType.help3":"If application/json is chosen, the server assumes you will posting JSON data.","add_outgoing_webhook.content_Type":"Content Type","add_outgoing_webhook.description":"Description","add_outgoing_webhook.description.help":"Description for your outgoing webhook.","add_outgoing_webhook.displayName":"Title","add_outgoing_webhook.displayName.help":"Choose a title to be displayed on the webhook settings page. Maximum 64 characters.","add_outgoing_webhook.doneHelp":"Your outgoing webhook has been set up. The following token will be sent in the outgoing payload. Please use it to verify the request came from your Mattermost team (see <a href=\"https://docs.mattermost.com/developer/webhooks-outgoing.html\">documentation</a> for further details).","add_outgoing_webhook.name":"Name","add_outgoing_webhook.save":"Save","add_outgoing_webhook.token":"<b>Token</b>: {token}","add_outgoing_webhook.triggerWords":"Trigger Words (One Per Line)","add_outgoing_webhook.triggerWords.help":"Messages that start with one of the specified words will trigger the outgoing webhook. Optional if Channel is selected.","add_outgoing_webhook.triggerWordsOrChannelRequired":"A valid channel or a list of trigger words is required","add_outgoing_webhook.triggerWordsTriggerWhen":"Trigger When","add_outgoing_webhook.triggerWordsTriggerWhen.help":"Choose when to trigger the outgoing webhook; if the first word of a message matches a Trigger Word exactly, or if it starts with a Trigger Word.","add_outgoing_webhook.triggerWordsTriggerWhenFullWord":"First word matches a trigger word exactly","add_outgoing_webhook.triggerWordsTriggerWhenStartsWith":"First word starts with a trigger word","add_users_to_team.title":"Add New Members To {teamName} Team","admin.advance.cluster":"High Availability","admin.advance.metrics":"Performance Monitoring","admin.audits.reload":"Reload User Activity Logs","admin.audits.title":"User Activity Logs","admin.authentication.email":"Email Authentication","admin.authentication.gitlab":"GitLab","admin.authentication.ldap":"AD/LDAP","admin.authentication.oauth":"OAuth 2.0","admin.authentication.saml":"SAML 2.0","admin.banner.heading":"Note:","admin.client_versions.androidLatestVersion":"Latest Android Version","admin.client_versions.androidLatestVersionHelp":"The latest released Android version","admin.client_versions.androidMinVersion":"Minimum Android Version","admin.client_versions.androidMinVersionHelp":"The minimum compliant Android version","admin.client_versions.desktopLatestVersion":"Latest Desktop Version","admin.client_versions.desktopLatestVersionHelp":"The latest released Desktop version","admin.client_versions.desktopMinVersion":"Minimum Desktop Version","admin.client_versions.desktopMinVersionHelp":"The minimum compliant Desktop version","admin.client_versions.iosLatestVersion":"Latest iOS Version","admin.client_versions.iosLatestVersionHelp":"The latest released iOS version","admin.client_versions.iosMinVersion":"Minimum iOS Version","admin.client_versions.iosMinVersionHelp":"The minimum compliant iOS version","admin.cluster.ClusterName":"Cluster Name:","admin.cluster.ClusterNameDesc":"The cluster to join by name.  Only nodes with the same cluster name will join together.  This is to support Blue-Green deployments or staging pointing to the same database.","admin.cluster.ClusterNameEx":"E.g.: \"Production\" or \"Staging\"","admin.cluster.GossipPort":"Gossip Port:","admin.cluster.GossipPortDesc":"The port used for the gossip protocol.  Both UDP and TCP should be allowed on this port.","admin.cluster.GossipPortEx":"E.g.: \"8074\"","admin.cluster.OverrideHostname":"Override Hostname:","admin.cluster.OverrideHostnameDesc":"The default value of <blank> will attempt to get the Hostname from the OS or use the IP Address.  You can override the hostname of this server with this property.  It is not recommended to override the Hostname unless needed. This property can also be set to a specific IP Address if needed.","admin.cluster.OverrideHostnameEx":"E.g.: \"app-server-01\"","admin.cluster.ReadOnlyConfig":"Read Only Config:","admin.cluster.ReadOnlyConfigDesc":"When true, the server will reject changes made to the configuration file from the system console. When running in production it is recommened to set this to true.","admin.cluster.StreamingPort":"Streaming Port:","admin.cluster.StreamingPortDesc":"The port used for streaming data between servers.","admin.cluster.StreamingPortEx":"E.g.: \"8075\"","admin.cluster.UseExperimentalGossip":"Use Experimental Gossip:","admin.cluster.UseExperimentalGossipDesc":"When true, the server will attempt to communicate via the gossip protocol over the gossip port.  When false the server will attempt to communicate over the streaming port. When false the gossip port and protocol are still used to determine cluster health.","admin.cluster.UseIpAddress":"Use IP Address:","admin.cluster.UseIpAddressDesc":"When true, the cluster will attempt to communicate via IP Address vs using the hostname.","admin.cluster.enableDescription":"When true, Mattermost will run in High Availability mode. Please see <a href=\"http://docs.mattermost.com/deployment/cluster.html\" target='_blank'>documentation</a> to learn more about configuring High Availability for Mattermost.","admin.cluster.enableTitle":"Enable High Availability Mode:","admin.cluster.interNodeListenAddressDesc":"The address the server will listen on for communicating with other servers.","admin.cluster.interNodeListenAddressEx":"E.g.: \":8075\"","admin.cluster.interNodeListenAddressTitle":"Inter-Node Listen Address:","admin.cluster.interNodeUrlsDesc":"The internal/private URLs of all the Mattermost servers separated by commas.","admin.cluster.interNodeUrlsEx":"E.g.: \"http://10.10.10.30, http://10.10.10.31\"","admin.cluster.interNodeUrlsTitle":"Inter-Node URLs:","admin.cluster.loadedFrom":"This configuration file was loaded from Node ID {clusterId}. Please see the Troubleshooting Guide in our <a href=\"http://docs.mattermost.com/deployment/cluster.html\" target='_blank'>documentation</a> if you are accessing the System Console through a load balancer and experiencing issues.","admin.cluster.noteDescription":"Changing properties in this section will require a server restart before taking effect. When High Availability mode is enabled, the System Console is set to read-only and can only be changed from the configuration file unless ReadOnlyConfig is disabled in the configuration file.","admin.cluster.should_not_change":"WARNING: These settings may not sync with the other servers in the cluster. High Availability inter-node communication will not start until you modify the config.json to be identical on all servers and restart Mattermost. Please see the <a href=\"http://docs.mattermost.com/deployment/cluster.html\" target='_blank'>documentation</a> on how to add or remove a server from the cluster. If you are accessing the System Console through a load balancer and experiencing issues, please see the Troubleshooting Guide in our <a href=\"http://docs.mattermost.com/deployment/cluster.html\" target='_blank'>documentation</a>.","admin.cluster.status_table.config_hash":"Config File MD5","admin.cluster.status_table.hostname":"Hostname","admin.cluster.status_table.id":"Node ID","admin.cluster.status_table.reload":" Reload Cluster Status","admin.cluster.status_table.status":"Status","admin.cluster.status_table.url":"Gossip Address","admin.cluster.status_table.version":"Version","admin.cluster.unknown":"unknown","admin.compliance.directoryDescription":"Directory to which compliance reports are written. If blank, will be set to ./data/.","admin.compliance.directoryExample":"E.g.: \"./data/\"","admin.compliance.directoryTitle":"Compliance Report Directory:","admin.compliance.enableDailyDesc":"When true, Mattermost will generate a daily compliance report.","admin.compliance.enableDailyTitle":"Enable Daily Report:","admin.compliance.enableDesc":"When true, Mattermost allows compliance reporting from the <strong>Compliance and Auditing</strong> tab. See <a href=\"https://docs.mattermost.com/administration/compliance.html\" target='_blank'>documentation</a> to learn more.","admin.compliance.enableTitle":"Enable Compliance Reporting:","admin.compliance.false":"false","admin.compliance.noLicense":"<h4 class=\"banner__heading\">Note:</h4><p>Compliance is an enterprise feature. Your current license does not support Compliance. Click <a href=\"http://mattermost.com\" target='_blank'>here</a> for information and pricing on enterprise licenses.</p>","admin.compliance.save":"Save","admin.compliance.saving":"Saving Config...","admin.compliance.title":"Compliance Settings","admin.compliance.true":"true","admin.complianceExport.createJob.help":"Initiates a Compliance Export job immediately.","admin.complianceExport.createJob.title":"Run Compliance Export Job Now","admin.complianceExport.description":"This feature supports compliance exports to the Actiance XML and Global Relay EML formats, and is currently in beta. Support for the Mattermost CSV format is scheduled for a future release, and will replace the existing <a href=\"/admin_console/general/compliance\">Compliance</a> feature.","admin.complianceExport.exportFormat.actiance":"Actiance XML","admin.complianceExport.exportFormat.description":"Format of the compliance export. Corresponds to the system that you want to import the data into.<br><br>For Actiance XML, compliance export files are written to the \"exports\" subdirectory of the configured <a href=\"/admin_console/files/storage\">Local Storage Directory</a>. For Global Relay EML, they are emailed to the configured email address.","admin.complianceExport.exportFormat.globalrelay":"Global Relay EML","admin.complianceExport.exportFormat.title":"Export Format:","admin.complianceExport.exportJobStartTime.description":"Set the start time of the daily scheduled compliance export job. Choose a time when fewer people are using your system. Must be a 24-hour time stamp in the form HH:MM.","admin.complianceExport.exportJobStartTime.example":"E.g.: \"02:00\"","admin.complianceExport.exportJobStartTime.title":"Compliance Export time:","admin.complianceExport.globalRelayCustomerType.a10.description":"A10/Type 10","admin.complianceExport.globalRelayCustomerType.a9.description":"A9/Type 9","admin.complianceExport.globalRelayCustomerType.description":"Type of Global Relay customer account your organization has.","admin.complianceExport.globalRelayCustomerType.title":"Global Relay Customer Account:","admin.complianceExport.globalRelayEmailAddress.description":"The email address your Global Relay server monitors for incoming compliance exports.","admin.complianceExport.globalRelayEmailAddress.example":"E.g.: \"globalrelay@mattermost.com\"","admin.complianceExport.globalRelayEmailAddress.title":"Global Relay Email Address:","admin.complianceExport.globalRelaySmtpPassword.description":"The password associated with the SMTP username.","admin.complianceExport.globalRelaySmtpPassword.example":"E.g.: \"globalRelayPassword\"","admin.complianceExport.globalRelaySmtpPassword.title":"Global Relay SMTP Password:","admin.complianceExport.globalRelaySmtpUsername.description":"The username for authenticating to the Global Relay SMTP server.","admin.complianceExport.globalRelaySmtpUsername.example":"E.g.: \"globalRelayUser\"","admin.complianceExport.globalRelaySmtpUsername.title":"Global Relay SMTP Username:","admin.complianceExport.title":"Compliance Export (Beta)","admin.compliance_reports.desc":"Job Name:","admin.compliance_reports.desc_placeholder":"E.g. \"Audit 445 for HR\"","admin.compliance_reports.emails":"Emails:","admin.compliance_reports.emails_placeholder":"E.g. \"bill@example.com, bob@example.com\"","admin.compliance_reports.from":"From:","admin.compliance_reports.from_placeholder":"E.g. \"2016-03-11\"","admin.compliance_reports.keywords":"Keywords:","admin.compliance_reports.keywords_placeholder":"E.g. \"shorting stock\"","admin.compliance_reports.reload":"Reload Completed Compliance Reports","admin.compliance_reports.run":"Run Compliance Report","admin.compliance_reports.title":"Compliance Reports","admin.compliance_reports.to":"To:","admin.compliance_reports.to_placeholder":"E.g. \"2016-03-15\"","admin.compliance_table.desc":"Description","admin.compliance_table.download":"Download","admin.compliance_table.params":"Params","admin.compliance_table.records":"Records","admin.compliance_table.status":"Status","admin.compliance_table.timestamp":"Timestamp","admin.compliance_table.type":"Type","admin.compliance_table.userId":"Requested By","admin.connectionSecurityNone":"None","admin.connectionSecurityNoneDescription":"Mattermost will connect over an insecure connection.","admin.connectionSecurityStart":"STARTTLS","admin.connectionSecurityStartDescription":"Takes an existing insecure connection and attempts to upgrade it to a secure connection using TLS.","admin.connectionSecurityTest":"Test Connection","admin.connectionSecurityTitle":"Connection Security:","admin.connectionSecurityTls":"TLS","admin.connectionSecurityTlsDescription":"Encrypts the communication between Mattermost and your server.","admin.customization.androidAppDownloadLinkDesc":"Add a link to download the Android app. Users who access the site on a mobile web browser will be prompted with a page giving them the option to download the app. Leave this field blank to prevent the page from appearing.","admin.customization.androidAppDownloadLinkTitle":"Android App Download Link:","admin.customization.appDownloadLinkDesc":"Add a link to a download page for the Mattermost apps. When a link is present, an option to \"Download Mattermost Apps\" will be added in the Main Menu so users can find the download page. Leave this field blank to hide the option from the Main Menu.","admin.customization.appDownloadLinkTitle":"Mattermost Apps Download Page Link:","admin.customization.customBrand":"Custom Branding","admin.customization.emoji":"Emoji","admin.customization.enableCustomEmojiDesc":"Enable users to create custom emoji for use in messages. When enabled, Custom Emoji settings can be accessed by switching to a team and clicking the three dots above the channel sidebar, and selecting \"Custom Emoji\".","admin.customization.enableCustomEmojiTitle":"Enable Custom Emoji:","admin.customization.enableEmojiPickerDesc":"The emoji picker allows users to select emoji to add as reactions or use in messages. Enabling the emoji picker with a large number of custom emoji may slow down performance.","admin.customization.enableEmojiPickerTitle":"Enable Emoji Picker:","admin.customization.enableLinkPreviewsDesc":"Display a preview of website content below messages, when available. Users can disable these previews from Account Settings > Display > Website Link Previews.","admin.customization.enableLinkPreviewsTitle":"Enable Link Previews:","admin.customization.iosAppDownloadLinkDesc":"Add a link to download the iOS app. Users who access the site on a mobile web browser will be prompted with a page giving them the option to download the app. Leave this field blank to prevent the page from appearing.","admin.customization.iosAppDownloadLinkTitle":"iOS App Download Link:","admin.customization.linkPreviews":"Link Previews","admin.customization.nativeAppLinks":"Mattermost App Links","admin.customization.restrictCustomEmojiCreationAdmin":"Allow System and Team Admins to create custom emoji","admin.customization.restrictCustomEmojiCreationAll":"Allow everyone to create custom emoji","admin.customization.restrictCustomEmojiCreationDesc":"Restrict the creation of custom emoji to certain users.","admin.customization.restrictCustomEmojiCreationSystemAdmin":"Only allow System Admins to create custom emoji","admin.customization.restrictCustomEmojiCreationTitle":"Restrict Custom Emoji Creation:","admin.customization.support":"Legal and Support","admin.data_retention.confirmChangesModal.clarification":"Once deleted, messages and files cannot be retrieved.","admin.data_retention.confirmChangesModal.confirm":"Confirm Settings","admin.data_retention.confirmChangesModal.description":"Are you sure you want to apply the following data retention policy:","admin.data_retention.confirmChangesModal.description.itemFileDeletion":"All files will be permanently deleted after {days} days.","admin.data_retention.confirmChangesModal.description.itemFileIndefinite":"All files will be retained indefinitely.","admin.data_retention.confirmChangesModal.description.itemMessageDeletion":"All messages will be permanently deleted after {days} days.","admin.data_retention.confirmChangesModal.description.itemMessageIndefinite":"All messages will be retained indefinitely.","admin.data_retention.confirmChangesModal.title":"Confirm data retention policy","admin.data_retention.createJob.help":"Initiates a Data Retention deletion job immediately.","admin.data_retention.createJob.title":"Run Deletion Job Now","admin.data_retention.deletionJobStartTime.description":"Set the start time of the daily scheduled data retention job. Choose a time when fewer people are using your system. Must be a 24-hour time stamp in the form HH:MM.","admin.data_retention.deletionJobStartTime.example":"E.g.: \"02:00\"","admin.data_retention.deletionJobStartTime.title":"Data Deletion Time:","admin.data_retention.enableFileDeletion.description":"Set how long Mattermost keeps file uploads in channels and direct messages.","admin.data_retention.enableFileDeletion.title":"File Retention:","admin.data_retention.enableMessageDeletion.description":"Set how long Mattermost keeps messages in channels and direct messages.","admin.data_retention.enableMessageDeletion.title":"Message Retention:","admin.data_retention.fileRetentionDays.description":"Set how many days file uploads are kept in Mattermost. Files older than the duration you set will be deleted nightly. The minimum time is one day.","admin.data_retention.fileRetentionDays.example":"E.g.: \"60\"","admin.data_retention.keepFilesForTime":"Keep files for a set amount of time","admin.data_retention.keepFilesIndefinitely":"Keep all files indefinitely","admin.data_retention.keepMessageForTime":"Keep messages for a set amount of time","admin.data_retention.keepMessagesIndefinitely":"Keep all messages indefinitely","admin.data_retention.messageRetentionDays.description":"Set how many days messages are kept in Mattermost. Messages, including file attachments older than the duration you set will be deleted nightly. The minimum time is one day.","admin.data_retention.messageRetentionDays.example":"E.g.: \"60\"","admin.data_retention.note.description":"Caution: Once a message or a file is deleted, the action is irreversible. Please be careful when setting up a custom data retention policy. See {documentationLink} to learn more.","admin.data_retention.note.description.documentationLinkText":"documentation","admin.data_retention.title":"Data Retention Policy (Beta)","admin.database.title":"Database Settings","admin.developer.title":"Developer Settings","admin.elasticsearch.bulkIndexButton.error":"Failed to schedule Bulk Index Job: {error}","admin.elasticsearch.bulkIndexingTitle":"Bulk Indexing:","admin.elasticsearch.connectionUrlDescription":"The address of the Elasticsearch server. {documentationLink}","admin.elasticsearch.connectionUrlExample":"E.g.: \"https://elasticsearch.example.org:9200\"","admin.elasticsearch.connectionUrlExample.documentationLinkText":"Please see documentation with server setup instructions.","admin.elasticsearch.connectionUrlTitle":"Server Connection Address:","admin.elasticsearch.createJob.help":"All posts in the database will be indexed from oldest to newest. Elasticsearch is available during indexing but search results may be incomplete until the indexing job is complete.","admin.elasticsearch.createJob.title":"Index Now","admin.elasticsearch.elasticsearch_test_button":"Test Connection","admin.elasticsearch.enableIndexingDescription":"When true, indexing of new posts occurs automatically. Search queries will use database search until \"Enable Elasticsearch for search queries\" is enabled. {documentationLink}","admin.elasticsearch.enableIndexingDescription.documentationLinkText":"Learn more about Elasticsearch in our documentation.","admin.elasticsearch.enableIndexingTitle":"Enable Elasticsearch Indexing:","admin.elasticsearch.enableSearchingDescription":"Requires a successful connection to the Elasticsearch server. When true, Elasticsearch will be used for all search queries using the latest index. Search results may be incomplete until a bulk index of the existing post database is finished. When false, database search is used.","admin.elasticsearch.enableSearchingTitle":"Enable Elasticsearch for search queries:","admin.elasticsearch.indexButton.inProgress":"Indexing in progress","admin.elasticsearch.indexButton.ready":"Build Index","admin.elasticsearch.indexHelpText.buildIndex":"All posts in the database will be indexed from oldest to newest. Elasticsearch is available during indexing but search results may be incomplete until the indexing job is complete.","admin.elasticsearch.indexHelpText.cancelIndexing":"Cancelling stops the indexing job and removes it from the queue. Posts that have already been indexed will not be deleted.","admin.elasticsearch.noteDescription":"Changing properties in this section will require a server restart before taking effect.","admin.elasticsearch.password":"E.g.: \"yourpassword\"","admin.elasticsearch.passwordDescription":"(Optional) The password to authenticate to the Elasticsearch server.","admin.elasticsearch.passwordTitle":"Server Password:","admin.elasticsearch.percentComplete":"{percent}% Complete","admin.elasticsearch.purgeIndexesButton":"Purge Indexes","admin.elasticsearch.purgeIndexesButton.error":"Failed to purge indexes: {error}","admin.elasticsearch.purgeIndexesButton.label":"Purge Indexes:","admin.elasticsearch.purgeIndexesButton.success":"Indexes purged successfully.","admin.elasticsearch.purgeIndexesHelpText":"Purging will entirely remove the index on the Elasticsearch server. Search results may be incomplete until a bulk index of the existing post database is rebuilt.","admin.elasticsearch.sniffDescription":"When true, sniffing finds and connects to all data nodes in your cluster automatically.","admin.elasticsearch.sniffTitle":"Enable Cluster Sniffing:","admin.elasticsearch.testConfigSuccess":"Test successful. Configuration saved.","admin.elasticsearch.testHelpText":"Tests if the Mattermost server can connect to the Elasticsearch server specified. Testing the connection only saves the configuration if the test is successful. See log file for more detailed error messages.","admin.elasticsearch.title":"Elasticsearch (Beta)","admin.elasticsearch.usernameDescription":"(Optional) The username to authenticate to the Elasticsearch server.","admin.elasticsearch.usernameExample":"E.g.: \"elastic\"","admin.elasticsearch.usernameTitle":"Server Username:","admin.email.agreeHPNS":" I understand and accept the Mattermost Hosted Push Notification Service <a href=\"https://about.mattermost.com/hpns-terms/\" target='_blank'>Terms of Service</a> and <a href=\"https://about.mattermost.com/hpns-privacy/\" target='_blank'>Privacy Policy</a>.","admin.email.allowEmailSignInDescription":"When true, Mattermost allows users to sign in using their email and password.","admin.email.allowEmailSignInTitle":"Enable sign-in with email: ","admin.email.allowSignupDescription":"When true, Mattermost allows account creation using email and password. This value should be false only when you want to limit sign up to a single sign-on service like AD/LDAP, SAML or GitLab.","admin.email.allowSignupTitle":"Enable account creation with email: ","admin.email.allowUsernameSignInDescription":"When true, users with email login can sign in using their username and password. This setting does not affect AD/LDAP login.","admin.email.allowUsernameSignInTitle":"Enable sign-in with username: ","admin.email.connectionSecurityTest":"Test Connection","admin.email.easHelp":"Learn more about compiling and deploying your own mobile apps from an <a href=\"https://about.mattermost.com/default-enterprise-app-store\" target='_blank'>Enterprise App Store</a>.","admin.email.emailFail":"Connection unsuccessful: {error}","admin.email.emailSuccess":"No errors were reported while sending an email.  Please check your inbox to make sure.","admin.email.enableEmailBatching.clusterEnabled":"Email batching cannot be enabled when High Availability mode is enabled.","admin.email.enableEmailBatching.siteURL":"Email batching cannot be enabled unless the SiteURL is configured in <b>Configuration > SiteURL</b>.","admin.email.enableEmailBatchingDesc":"When true, users will have email notifications for multiple direct messages and mentions combined into a single email. Batching will occur at a default interval of 15 minutes, configurable in Account Settings > Notifications.","admin.email.enableEmailBatchingTitle":"Enable Email Batching:","admin.email.enableSMTPAuthDesc":"When enabled, username and password are used for authenticating to the SMTP server.","admin.email.enableSMTPAuthTitle":"Enable SMTP Authentication:","admin.email.fullPushNotification":"Send full message snippet","admin.email.genericNoChannelPushNotification":"Send generic description with only sender name","admin.email.genericPushNotification":"Send generic description with sender and channel names","admin.email.inviteSaltDescription":"32-character salt added to signing of email invites. Randomly generated on install. Click \"Regenerate\" to create new salt.","admin.email.inviteSaltExample":"E.g.: \"bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo\"","admin.email.inviteSaltTitle":"Email Invite Salt:","admin.email.mhpns":"Use encrypted, production-quality HPNS connection to iOS and Android apps","admin.email.mhpnsHelp":"Download <a href=\"https://about.mattermost.com/mattermost-ios-app\" target='_blank'>Mattermost iOS app</a> from iTunes. Download <a href=\"https://about.mattermost.com/mattermost-android-app\" target='_blank'>Mattermost Android app</a> from Google Play. Learn more about <a href=\"https://about.mattermost.com/default-hpns\" target='_blank'>HPNS</a>.","admin.email.mtpns":"Use iOS and Android apps on iTunes and Google Play with TPNS","admin.email.mtpnsHelp":"Download <a href=\"https://about.mattermost.com/mattermost-ios-app\" target='_blank'>Mattermost iOS app</a> from iTunes. Download <a href=\"https://about.mattermost.com/mattermost-android-app\" target='_blank'>Mattermost Android app</a> from Google Play. Learn more about <a href=\"https://about.mattermost.com/default-tpns/\" target='_blank'>TPNS</a>.","admin.email.nofificationOrganizationExample":"E.g.: \"© ABC Corporation, 565 Knight Way, Palo Alto, California, 94305, USA\"","admin.email.notification.contents.full":"Send full message contents","admin.email.notification.contents.full.description":"Sender name and channel are included in email notifications.</br>Typically used for compliance reasons if Mattermost contains confidential information and policy dictates it cannot be stored in email.","admin.email.notification.contents.generic":"Send generic description with only sender name","admin.email.notification.contents.generic.description":"Only the name of the person who sent the message, with no information about channel name or message contents are included in email notifications.</br>Typically used for compliance reasons if Mattermost contains confidential information and policy dictates it cannot be stored in email.","admin.email.notification.contents.title":"Email Notification Contents: ","admin.email.notificationDisplayDescription":"Display name on email account used when sending notification emails from Mattermost.","admin.email.notificationDisplayExample":"E.g.: \"Mattermost Notification\", \"System\", \"No-Reply\"","admin.email.notificationDisplayTitle":"Notification Display Name:","admin.email.notificationEmailDescription":"Email address displayed on email account used when sending notification emails from Mattermost.","admin.email.notificationEmailExample":"E.g.: \"mattermost@yourcompany.com\", \"admin@yourcompany.com\"","admin.email.notificationEmailTitle":"Notification From Address:","admin.email.notificationOrganization":"Notification Footer Mailing Address:","admin.email.notificationOrganizationDescription":"Organization name and address displayed on email notifications from Mattermost, such as \"© ABC Corporation, 565 Knight Way, Palo Alto, California, 94305, USA\". If the field is left empty, the organization name and address will not be displayed.","admin.email.notificationOrganizationExample":"E.g.: \"© ABC Corporation, 565 Knight Way, Palo Alto, California, 94305, USA\"","admin.email.notificationsDescription":"Typically set to true in production. When true, Mattermost attempts to send email notifications. Developers may set this field to false to skip email setup for faster development.<br />Setting this to true removes the Preview Mode banner (requires logging out and logging back in after setting is changed).","admin.email.notificationsTitle":"Enable Email Notifications: ","admin.email.passwordSaltDescription":"32-character salt added to signing of password reset emails. Randomly generated on install. Click \"Regenerate\" to create new salt.","admin.email.passwordSaltExample":"E.g.: \"bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo\"","admin.email.passwordSaltTitle":"Password Reset Salt:","admin.email.pushContentDesc":"\"Send generic description with only sender name\" includes only the name of the person who sent the message in push notifications, with no information about channel name or message contents.<br /><br />\"Send generic description with sender and channel names\" includes the name of the person who sent the message and the channel it was sent in, but not the message text.<br /><br />\"Send full message snippet\" includes a message excerpt in push notifications, which may contain confidential information sent in messages. If your Push Notification Service is outside your firewall, it is *highly recommended* this option only be used with an \"https\" protocol to encrypt the connection.","admin.email.pushContentTitle":"Push Notification Contents:","admin.email.pushDesc":"Typically set to true in production. When true, Mattermost attempts to send iOS and Android push notifications through the push notification server.","admin.email.pushOff":"Do not send push notifications","admin.email.pushOffHelp":"Please see <a href=\"https://about.mattermost.com/default-mobile-push-notifications\" target='_blank'>documentation on push notifications</a> to learn more about setup options.","admin.email.pushServerDesc":"Location of Mattermost push notification service you can set up behind your firewall using https://github.com/mattermost/push-proxy. For testing you can use http://push-test.mattermost.com, which connects to the sample Mattermost iOS app in the public Apple AppStore. Please do not use test service for production deployments.","admin.email.pushServerEx":"E.g.: \"http://push-test.mattermost.com\"","admin.email.pushServerTitle":"Push Notification Server:","admin.email.pushTitle":"Enable Push Notifications: ","admin.email.requireVerificationDescription":"Typically set to true in production. When true, Mattermost requires email verification after account creation prior to allowing login. Developers may set this field to false to skip sending verification emails for faster development.","admin.email.requireVerificationTitle":"Require Email Verification: ","admin.email.selfPush":"Manually enter Push Notification Service location","admin.email.skipServerCertificateVerification.description":"When true, Mattermost will not verify the email server certificate.","admin.email.skipServerCertificateVerification.title":"Skip Server Certificate Verification: ","admin.email.smtpPasswordDescription":"The password associated with the SMTP username.","admin.email.smtpPasswordExample":"E.g.: \"yourpassword\", \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"","admin.email.smtpPasswordTitle":"SMTP Server Password:","admin.email.smtpPortDescription":"Port of SMTP email server.","admin.email.smtpPortExample":"E.g.: \"25\", \"465\", \"587\"","admin.email.smtpPortTitle":"SMTP Server Port:","admin.email.smtpServerDescription":"Location of SMTP email server.","admin.email.smtpServerExample":"E.g.: \"smtp.yourcompany.com\", \"email-smtp.us-east-1.amazonaws.com\"","admin.email.smtpServerTitle":"SMTP Server:","admin.email.smtpUsernameDescription":"The username for authenticating to the SMTP server.","admin.email.smtpUsernameExample":"E.g.: \"admin@yourcompany.com\", \"AKIADTOVBGERKLCBV\"","admin.email.smtpUsernameTitle":"SMTP Server Username:","admin.email.testing":"Testing...","admin.false":"false","admin.file.enableFileAttachments":"Allow File Sharing:","admin.file.enableFileAttachmentsDesc":"When false, disables file sharing on the server. All file and image uploads on messages are forbidden across clients and devices, including mobile.","admin.file.enableMobileDownloadDesc":"When false, disables file downloads on mobile apps. Users can still download files from a mobile web browser.","admin.file.enableMobileDownloadTitle":"Allow File Downloads on Mobile:","admin.file.enableMobileUploadDesc":"When false, disables file uploads on mobile apps. If Allow File Sharing is set to true, users can still upload files from a mobile web browser.","admin.file.enableMobileUploadTitle":"Allow File Uploads on Mobile:","admin.file_upload.chooseFile":"Choose File","admin.file_upload.noFile":"No file uploaded","admin.file_upload.uploadFile":"Upload","admin.files.images":"Images","admin.files.storage":"Storage","admin.general.configuration":"Configuration","admin.general.localization":"Localization","admin.general.localization.availableLocalesDescription":"Set which languages are available for users in Account Settings (leave this field blank to have all supported languages available). If you’re manually adding new languages, the <strong>Default Client Language</strong> must be added before saving this setting.<br /><br />Would like to help with translations? Join the <a href='http://translate.mattermost.com/' target='_blank'>Mattermost Translation Server</a> to contribute.","admin.general.localization.availableLocalesNoResults":"No results found","admin.general.localization.availableLocalesNotPresent":"The default client language must be included in the available list","admin.general.localization.availableLocalesTitle":"Available Languages:","admin.general.localization.clientLocaleDescription":"Default language for newly created users and pages where the user hasn't logged in.","admin.general.localization.clientLocaleTitle":"Default Client Language:","admin.general.localization.serverLocaleDescription":"Default language for system messages and logs. Changing this will require a server restart before taking effect.","admin.general.localization.serverLocaleTitle":"Default Server Language:","admin.general.log":"Logging","admin.general.policy":"Policy","admin.general.policy.allowBannerDismissalDesc":"When true, users can dismiss the banner until its next update. When false, the banner is permanently visible until it is turned off by the System Admin.","admin.general.policy.allowBannerDismissalTitle":"Allow Banner Dismissal:","admin.general.policy.allowEditPostAlways":"Any time","admin.general.policy.allowEditPostDescription":"Set policy on the length of time authors have to edit their messages after posting.","admin.general.policy.allowEditPostNever":"Never","admin.general.policy.allowEditPostTimeLimit":"seconds after posting","admin.general.policy.allowEditPostTitle":"Allow users to edit their messages:","admin.general.policy.bannerColorTitle":"Banner Color:","admin.general.policy.bannerTextColorTitle":"Banner Text Color:","admin.general.policy.bannerTextDesc":"Text that will appear in the announcement banner.","admin.general.policy.bannerTextTitle":"Banner Text:","admin.general.policy.enableBannerDesc":"Enable an announcement banner across all teams.","admin.general.policy.enableBannerTitle":"Enable Announcement Banner:","admin.general.policy.permissionsAdmin":"Team and System Admins","admin.general.policy.permissionsAll":"All team members","admin.general.policy.permissionsAllChannel":"All channel members","admin.general.policy.permissionsChannelAdmin":"Channel, Team and System Admins","admin.general.policy.permissionsDeletePostAdmin":"Team Admins and System Admins","admin.general.policy.permissionsDeletePostAll":"Message authors can delete their own messages, and Administrators can delete any message","admin.general.policy.permissionsDeletePostSystemAdmin":"System Admins","admin.general.policy.permissionsSystemAdmin":"System Admins","admin.general.policy.restrictPostDeleteDescription":"Set policy on who has permission to delete messages.","admin.general.policy.restrictPostDeleteTitle":"Allow which users to delete messages:","admin.general.policy.restrictPrivateChannelCreationDescription":"Set policy on who can create private channels.","admin.general.policy.restrictPrivateChannelCreationTitle":"Enable private channel creation for:","admin.general.policy.restrictPrivateChannelDeletionCommandLineToolLink":"command line tool","admin.general.policy.restrictPrivateChannelDeletionDescription":"Set policy on who can delete private channels. Deleted channels can be recovered from the database using a {commandLineToolLink}.","admin.general.policy.restrictPrivateChannelDeletionTitle":"Enable private channel deletion for:","admin.general.policy.restrictPrivateChannelManageMembersDescription":"Set policy on who can add and remove members from private channels.","admin.general.policy.restrictPrivateChannelManageMembersTitle":"Enable managing of private channel members for:","admin.general.policy.restrictPrivateChannelManagementDescription":"Set policy on who can rename and set the header or purpose for private channels.","admin.general.policy.restrictPrivateChannelManagementTitle":"Enable private channel renaming for:","admin.general.policy.restrictPublicChannelCreationDescription":"Set policy on who can create public channels.","admin.general.policy.restrictPublicChannelCreationTitle":"Enable public channel creation for:","admin.general.policy.restrictPublicChannelDeletionCommandLineToolLink":"command line tool","admin.general.policy.restrictPublicChannelDeletionDescription":"Set policy on who can delete public channels. Deleted channels can be recovered from the database using a {commandLineToolLink}.","admin.general.policy.restrictPublicChannelDeletionTitle":"Enable public channel deletion for:","admin.general.policy.restrictPublicChannelManagementDescription":"Set policy on who can rename and set the header or purpose for public channels.","admin.general.policy.restrictPublicChannelManagementTitle":"Enable public channel renaming for:","admin.general.policy.teamInviteDescription":"Set policy on who can invite others to a team using <b>Send Email Invite</b> to invite new users by email, or the <b>Get Team Invite Link</b> and <b>Add Members to Team</b> options from the Main Menu. If <b>Get Team Invite Link</b> is used to share a link, you can expire the invite code from <b>Team Settings</b> > <b>Invite Code</b> after the desired users join the team.","admin.general.policy.teamInviteTitle":"Enable sending team invites from:","admin.general.privacy":"Privacy","admin.general.usersAndTeams":"Users and Teams","admin.gitlab.EnableHtmlDesc":"<ol><li>Log in to your GitLab account and go to Profile Settings -> Applications.</li><li>Enter Redirect URIs \"<your-mattermost-url>/login/gitlab/complete\" (example: http://localhost:8065/login/gitlab/complete) and \"<your-mattermost-url>/signup/gitlab/complete\". </li><li>Then use \"Application Secret Key\" and \"Application ID\" fields from GitLab to complete the options below.</li><li>Complete the Endpoint URLs below. </li></ol>","admin.gitlab.authTitle":"Auth Endpoint:","admin.gitlab.clientIdDescription":"Obtain this value via the instructions above for logging into GitLab","admin.gitlab.clientIdExample":"E.g.: \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"","admin.gitlab.clientIdTitle":"Application ID:","admin.gitlab.clientSecretDescription":"Obtain this value via the instructions above for logging into GitLab.","admin.gitlab.clientSecretExample":"E.g.: \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"","admin.gitlab.clientSecretTitle":"Application Secret Key:","admin.gitlab.enableDescription":"When true, Mattermost allows team creation and account signup using GitLab OAuth.","admin.gitlab.enableTitle":"Enable authentication with GitLab: ","admin.gitlab.settingsTitle":"GitLab Settings","admin.gitlab.siteUrl":"GitLab Site URL: ","admin.gitlab.siteUrlDescription":"Enter the URL of your GitLab instance, e.g. https://example.com:3000. If your GitLab instance is not set up with SSL, start the URL with http:// instead of https://.","admin.gitlab.siteUrlExample":"E.g.: https://","admin.gitlab.tokenTitle":"Token Endpoint:","admin.gitlab.userTitle":"User API Endpoint:","admin.google.EnableHtmlDesc":"<ol><li><a target='_blank' href='https://accounts.google.com/login'>Log in</a> to your Google account.</li><li>Go to <a target='_blank' href='https://console.developers.google.com'>https://console.developers.google.com</a>, click <strong>Credentials</strong> in the left hand sidebar and enter \"Mattermost - your-company-name\" as the <strong>Project Name</strong>, then click <strong>Create</strong>.</li><li>Click the <strong>OAuth consent screen</strong> header and enter \"Mattermost\" as the <strong>Product name shown to users</strong>, then click <strong>Save</strong>.</li><li>Under the <strong>Credentials</strong> header, click <strong>Create credentials</strong>, choose <strong>OAuth client ID</strong> and select <strong>Web Application</strong>.</li><li>Under <strong>Restrictions</strong> and <strong>Authorized redirect URIs</strong> enter <strong>your-mattermost-url/signup/google/complete</strong> (example: http://localhost:8065/signup/google/complete). Click <strong>Create</strong>.</li><li>Paste the <strong>Client ID</strong> and <strong>Client Secret</strong> to the fields below, then click <strong>Save</strong>.</li><li>Finally, go to <a target='_blank' href='https://console.developers.google.com/apis/api/plus/overview'>Google+ API</a> and click <strong>Enable</strong>. This might take a few minutes to propagate through Google's systems.</li></ol>","admin.google.authTitle":"Auth Endpoint:","admin.google.clientIdDescription":"The Client ID you received when registering your application with Google.","admin.google.clientIdExample":"E.g.: \"7602141235235-url0fhs1mayfasbmop5qlfns8dh4.apps.googleusercontent.com\"","admin.google.clientIdTitle":"Client ID:","admin.google.clientSecretDescription":"The Client Secret you received when registering your application with Google.","admin.google.clientSecretExample":"E.g.: \"H8sz0Az-dDs2p15-7QzD231\"","admin.google.clientSecretTitle":"Client Secret:","admin.google.tokenTitle":"Token Endpoint:","admin.google.userTitle":"User API Endpoint:","admin.image.amazonS3BucketDescription":"Name you selected for your S3 bucket in AWS.","admin.image.amazonS3BucketExample":"E.g.: \"mattermost-media\"","admin.image.amazonS3BucketTitle":"Amazon S3 Bucket:","admin.image.amazonS3EndpointDescription":"Hostname of your S3 Compatible Storage provider. Defaults to \"s3.amazonaws.com\".","admin.image.amazonS3EndpointExample":"E.g.: \"s3.amazonaws.com\"","admin.image.amazonS3EndpointTitle":"Amazon S3 Endpoint:","admin.image.amazonS3IdDescription":"(Optional) Only required if you do not want to authenticate to S3 using an <a target='_blank' href=\"https://about.mattermost.com/default-iam-role\">IAM role</a>. Enter the Access Key ID provided by your Amazon EC2 administrator.","admin.image.amazonS3IdExample":"E.g.: \"AKIADTOVBGERKLCBV\"","admin.image.amazonS3IdTitle":"Amazon S3 Access Key ID:","admin.image.amazonS3RegionDescription":"AWS region you selected when creating your S3 bucket. If no region is set, Mattermost attempts to get the appropriate region from AWS, or sets it to 'us-east-1' if none found.","admin.image.amazonS3RegionExample":"E.g.: \"us-east-1\"","admin.image.amazonS3RegionTitle":"Amazon S3 Region:","admin.image.amazonS3SSEDescription":"When true, encrypt files in Amazon S3 using server-side encryption with Amazon S3-managed keys. See <a href=\"https://about.mattermost.com/default-server-side-encryption\" target=\"_blank\">documentation</a> to learn more.","admin.image.amazonS3SSETitle":"Enable Server-Side Encryption for Amazon S3:","admin.image.amazonS3SSLDescription":"When false, allow insecure connections to Amazon S3. Defaults to secure connections only.","admin.image.amazonS3SSLTitle":"Enable Secure Amazon S3 Connections:","admin.image.amazonS3SecretDescription":"(Optional) The secret access key associated with your Amazon S3 Access Key ID.","admin.image.amazonS3SecretExample":"E.g.: \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"","admin.image.amazonS3SecretTitle":"Amazon S3 Secret Access Key:","admin.image.amazonS3TraceDescription":"(Development Mode) When true, log additional debugging information to the system logs.","admin.image.amazonS3TraceTitle":"Enable Amazon S3 Debugging:","admin.image.localDescription":"Directory to which files and images are written. If blank, defaults to ./data/.","admin.image.localExample":"E.g.: \"./data/\"","admin.image.localTitle":"Local Storage Directory:","admin.image.maxFileSizeDescription":"Maximum file size for message attachments in megabytes. Caution: Verify server memory can support your setting choice. Large file sizes increase the risk of server crashes and failed uploads due to network interruptions.","admin.image.maxFileSizeExample":"50","admin.image.maxFileSizeTitle":"Maximum File Size:","admin.image.proxyOptions":"Image Proxy Options:","admin.image.proxyOptionsDescription":"Additional options such as the URL signing key. Refer to your image proxy documentation to learn more about what options are supported.","admin.image.proxyType":"Image Proxy Type:","admin.image.proxyTypeDescription":"Configure an image proxy to load all Markdown images through a proxy. The image proxy prevents users from making insecure image requests, provides caching for increased performance, and automates image adjustments such as resizing. See <a href=\"https://about.mattermost.com/default-image-proxy-documentation\">documentation</a> to learn more.","admin.image.proxyTypeNone":"None","admin.image.proxyURL":"Image Proxy URL:","admin.image.proxyURLDescription":"URL of your image proxy server.","admin.image.publicLinkDescription":"32-character salt added to signing of public image links. Randomly generated on install. Click \"Regenerate\" to create new salt.","admin.image.publicLinkExample":"E.g.: \"gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6\"","admin.image.publicLinkTitle":"Public Link Salt:","admin.image.shareDescription":"Allow users to share public links to files and images.","admin.image.shareTitle":"Enable Public File Links: ","admin.image.storeAmazonS3":"Amazon S3","admin.image.storeDescription":"Storage system where files and image attachments are saved.<br /><br />Selecting \"Amazon S3\" enables fields to enter your Amazon credentials and bucket details.<br /><br />Selecting \"Local File System\" enables the field to specify a local file directory.","admin.image.storeLocal":"Local File System","admin.image.storeTitle":"File Storage System:","admin.integrations.custom":"Custom Integrations","admin.integrations.external":"External Services","admin.integrations.webrtc":"Mattermost WebRTC","admin.jobTable.cancelButton":"Cancel","admin.jobTable.headerExtraInfo":"Details","admin.jobTable.headerFinishAt":"Finish Time","admin.jobTable.headerRunTime":"Run Time","admin.jobTable.headerStatus":"Status","admin.jobTable.jobId":"Job ID: ","admin.jobTable.lastActivityAt":"Last Activity: ","admin.jobTable.runLengthMinutes":" minutes","admin.jobTable.runLengthSeconds":" seconds","admin.jobTable.statusCanceled":"Canceled","admin.jobTable.statusCanceling":"Canceling...","admin.jobTable.statusError":"Error","admin.jobTable.statusInProgress":"In Progress","admin.jobTable.statusPending":"Pending","admin.jobTable.statusSuccess":"Success","admin.ldap.baseDesc":"The Base DN is the Distinguished Name of the location where Mattermost should start its search for users in the AD/LDAP tree.","admin.ldap.baseEx":"E.g.: \"ou=Unit Name,dc=corp,dc=example,dc=com\"","admin.ldap.baseTitle":"BaseDN:","admin.ldap.bindPwdDesc":"Password of the user given in \"Bind Username\".","admin.ldap.bindPwdTitle":"Bind Password:","admin.ldap.bindUserDesc":"The username used to perform the AD/LDAP search. This should typically be an account created specifically for use with Mattermost. It should have access limited to read the portion of the AD/LDAP tree specified in the BaseDN field.","admin.ldap.bindUserTitle":"Bind Username:","admin.ldap.emailAttrDesc":"The attribute in the AD/LDAP server that will be used to populate the email addresses of users in Mattermost.","admin.ldap.emailAttrEx":"E.g.: \"mail\" or \"userPrincipalName\"","admin.ldap.emailAttrTitle":"Email Attribute:","admin.ldap.enableDesc":"When true, Mattermost allows login using AD/LDAP","admin.ldap.enableSyncDesc":"When true, Mattermost periodically synchronizes users from AD/LDAP. When false, user attributes are updated from SAML during user login.","admin.ldap.enableSyncTitle":"Enable Synchronization with AD/LDAP:","admin.ldap.enableTitle":"Enable sign-in with AD/LDAP:","admin.ldap.firstnameAttrDesc":"(Optional) The attribute in the AD/LDAP server that will be used to populate the first name of users in Mattermost. When set, users will not be able to edit their first name, since it is synchronized with the LDAP server. When left blank, users can set their own first name in Account Settings.","admin.ldap.firstnameAttrEx":"E.g.: \"givenName\"","admin.ldap.firstnameAttrTitle":"First Name Attribute:","admin.ldap.idAttrDesc":"The attribute in the AD/LDAP server that will be used as a unique identifier in Mattermost. It should be an AD/LDAP attribute with a value that does not change, such as username or uid. If a user's ID Attribute changes, it will create a new Mattermost account unassociated with their old one. This is the value used to log in to Mattermost in the \"AD/LDAP Username\" field on the sign in page. Normally this attribute is the same as the \"Username Attribute\" field above. If your team typically uses domain\\\\username to sign in to other services with AD/LDAP, you may choose to put domain\\\\username in this field to maintain consistency between sites.","admin.ldap.idAttrEx":"E.g.: \"sAMAccountName\"","admin.ldap.idAttrTitle":"ID Attribute: ","admin.ldap.jobExtraInfo":"Scanned {ldapUsers} LDAP users, updated {updateCount}, deactivated {deleteCount}","admin.ldap.lastnameAttrDesc":"(Optional) The attribute in the AD/LDAP server that will be used to populate the last name of users in Mattermost. When set, users will not be able to edit their last name, since it is synchronized with the LDAP server. When left blank, users can set their own last name in Account Settings.","admin.ldap.lastnameAttrEx":"E.g.: \"sn\"","admin.ldap.lastnameAttrTitle":"Last Name Attribute:","admin.ldap.ldap_test_button":"AD/LDAP Test","admin.ldap.loginNameDesc":"The placeholder text that appears in the login field on the login page. Defaults to \"AD/LDAP Username\".","admin.ldap.loginNameEx":"E.g.: \"AD/LDAP Username\"","admin.ldap.loginNameTitle":"Login Field Name:","admin.ldap.maxPageSizeEx":"E.g.: \"2000\"","admin.ldap.maxPageSizeHelpText":"The maximum number of users the Mattermost server will request from the AD/LDAP server at one time. 0 is unlimited.","admin.ldap.maxPageSizeTitle":"Maximum Page Size:","admin.ldap.nicknameAttrDesc":"(Optional) The attribute in the AD/LDAP server that will be used to populate the nickname of users in Mattermost. When set, users will not be able to edit their nickname, since it is synchronized with the LDAP server. When left blank, users can set their own nickname in Account Settings.","admin.ldap.nicknameAttrEx":"E.g.: \"nickname\"","admin.ldap.nicknameAttrTitle":"Nickname Attribute:","admin.ldap.noLicense":"<h4 class=\"banner__heading\">Note:</h4><p>AD/LDAP is an enterprise feature. Your current license does not support AD/LDAP. Click <a href=\"http://mattermost.com\" target='_blank'>here</a> for information and pricing on enterprise licenses.</p>","admin.ldap.portDesc":"The port Mattermost will use to connect to the AD/LDAP server. Default is 389.","admin.ldap.portEx":"E.g.: \"389\"","admin.ldap.portTitle":"AD/LDAP Port:","admin.ldap.positionAttrDesc":"(Optional) The attribute in the AD/LDAP server that will be used to populate the position field in Mattermost.","admin.ldap.positionAttrEx":"E.g.: \"title\"","admin.ldap.positionAttrTitle":"Position Attribute:","admin.ldap.queryDesc":"The timeout value for queries to the AD/LDAP server. Increase if you are getting timeout errors caused by a slow AD/LDAP server.","admin.ldap.queryEx":"E.g.: \"60\"","admin.ldap.queryTitle":"Query Timeout (seconds):","admin.ldap.serverDesc":"The domain or IP address of AD/LDAP server.","admin.ldap.serverEx":"E.g.: \"10.0.0.23\"","admin.ldap.serverTitle":"AD/LDAP Server:","admin.ldap.skipCertificateVerification":"Skip Certificate Verification:","admin.ldap.skipCertificateVerificationDesc":"Skips the certificate verification step for TLS or STARTTLS connections. Not recommended for production environments where TLS is required. For testing only.","admin.ldap.syncFailure":"Sync Failure: {error}","admin.ldap.syncIntervalHelpText":"AD/LDAP Synchronization updates Mattermost user information to reflect updates on the AD/LDAP server. For example, when a user’s name changes on the AD/LDAP server, the change updates in Mattermost when synchronization is performed. Accounts removed from or disabled in the AD/LDAP server have their Mattermost accounts set to \"Inactive\" and have their account sessions revoked. Mattermost performs synchronization on the interval entered. For example, if 60 is entered, Mattermost synchronizes every 60 minutes.","admin.ldap.syncIntervalTitle":"Synchronization Interval (minutes):","admin.ldap.syncNowHelpText":"Initiates an AD/LDAP synchronization immediately.","admin.ldap.sync_button":"AD/LDAP Synchronize Now","admin.ldap.testFailure":"AD/LDAP Test Failure: {error}","admin.ldap.testHelpText":"Tests if the Mattermost server can connect to the AD/LDAP server specified. See log file for more detailed error messages.","admin.ldap.testSuccess":"AD/LDAP Test Successful","admin.ldap.uernameAttrDesc":"The attribute in the AD/LDAP server that will be used to populate the username field in Mattermost. This may be the same as the ID Attribute.","admin.ldap.userFilterDisc":"(Optional) Enter an AD/LDAP Filter to use when searching for user objects. Only the users selected by the query will be able to access Mattermost. For Active Directory, the query to filter out disabled users is (&(objectCategory=Person)(!(UserAccountControl:1.2.840.113556.1.4.803:=2))).","admin.ldap.userFilterEx":"E.g.: \"(objectClass=user)\"","admin.ldap.userFilterTitle":"User Filter:","admin.ldap.usernameAttrEx":"E.g.: \"sAMAccountName\"","admin.ldap.usernameAttrTitle":"Username Attribute:","admin.license.choose":"Choose File","admin.license.chooseFile":"Choose File","admin.license.edition":"Edition: ","admin.license.key":"License Key: ","admin.license.keyRemove":"Remove Enterprise License and Downgrade Server","admin.license.noFile":"No file uploaded","admin.license.removing":"Removing License...","admin.license.title":"Edition and License","admin.license.type":"License: ","admin.license.upload":"Upload","admin.license.uploadDesc":"Upload a license key for Mattermost Enterprise Edition to upgrade this server. <a href=\"http://mattermost.com\" target='_blank'>Visit us online</a> to learn more about the benefits of Enterprise Edition or to purchase a key.","admin.license.uploading":"Uploading License...","admin.log.noteDescription":"Changing properties other than <a href=\"#EnableWebhookDebugging\">Enable Webhook Debugging</a> and <a href=\"#EnableDiagnostics\">Enable Diagnostics and Error Reporting</a> in this section will require a server restart before taking effect.","admin.log.consoleDescription":"Typically set to false in production. Developers may set this field to true to output log messages to console based on the console level option.  If true, server writes messages to the standard output stream (stdout).","admin.log.consoleLogLevel":"Console Log Level","admin.log.consoleTitle":"Output logs to console: ","admin.log.enableDiagnostics":"Enable Diagnostics and Error Reporting:","admin.log.enableDiagnosticsDescription":"Enable this feature to improve the quality and performance of Mattermost by sending error reporting and diagnostic information to Mattermost, Inc. Read our <a href=\"https://about.mattermost.com/default-privacy-policy/\" target='_blank'>privacy policy</a> to learn more.","admin.log.enableWebhookDebugging":"Enable Webhook Debugging:","admin.log.enableWebhookDebuggingDescription":"To output the request body of incoming webhooks to the console, enable this setting and set {boldedConsoleLogLevel} to 'DEBUG'. Disable this setting to remove webhook request body information from console logs when in DEBUG mode.","admin.log.fileDescription":"Typically set to true in production. When true, logged events are written to the mattermost.log file in the directory specified in the File Log Directory field. The logs are rotated at 10,000 lines and archived to a file in the same directory, and given a name with a datestamp and serial number. For example, mattermost.2017-03-31.001.","admin.log.fileLevelDescription":"This setting determines the level of detail at which log events are written to the log file. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.","admin.log.fileLevelTitle":"File Log Level:","admin.log.fileTitle":"Output logs to file: ","admin.log.formatDateLong":"Date (2006/01/02)","admin.log.formatDateShort":"Date (01/02/06)","admin.log.formatDescription":"Format of log message output. If blank will be set to \"[%D %T] [%L] %M\", where:","admin.log.formatLevel":"Level (DEBG, INFO, EROR)","admin.log.formatMessage":"Message","admin.log.formatPlaceholder":"Enter your file format","admin.log.formatSource":"Source","admin.log.formatTime":"Time (15:04:05 MST)","admin.log.formatTitle":"File Log Format:","admin.log.levelDescription":"This setting determines the level of detail at which log events are written to the console. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.","admin.log.levelTitle":"Console Log Level:","admin.log.locationDescription":"The location of the log files. If blank, they are stored in the ./logs directory. The path that you set must exist and Mattermost must have write permissions in it.","admin.log.locationPlaceholder":"Enter your file location","admin.log.locationTitle":"File Log Directory:","admin.log.logSettings":"Log Settings","admin.logs.bannerDesc":"To look up users by User ID or Token ID, go to Reporting > Users and paste the ID into the search filter.","admin.logs.next":"Next","admin.logs.prev":"Previous","admin.logs.reload":"Reload","admin.logs.title":"Server Logs","admin.manage_roles.additionalRoles":"Select additional permissions for the account. <a href=\"https://about.mattermost.com/default-permissions\" target=\"_blank\">Read more about roles and permissions</a>.","admin.manage_roles.allowUserAccessTokens":"Allow this account to generate <a href=\"https://about.mattermost.com/default-user-access-tokens\" target=\"_blank\">personal access tokens</a>.","admin.manage_roles.allowUserAccessTokensDesc":"Removing this permission doesn't delete existing tokens. To delete them, go to the user's Manage Tokens menu.","admin.manage_roles.cancel":"Cancel","admin.manage_roles.manageRolesTitle":"Manage Roles","admin.manage_roles.postAllPublicRole":"Access to post to all Mattermost public channels.","admin.manage_roles.postAllPublicRoleTitle":"post:channels","admin.manage_roles.postAllRole":"Access to post to all Mattermost channels including direct messages.","admin.manage_roles.postAllRoleTitle":"post:all","admin.manage_roles.save":"Save","admin.manage_roles.saveError":"Unable to save roles.","admin.manage_roles.systemAdmin":"System Admin","admin.manage_roles.systemMember":"Member","admin.manage_tokens.manageTokensTitle":"Manage Personal Access Tokens","admin.manage_tokens.userAccessTokensDescription":"Personal access tokens function similarly to session tokens and can be used by integrations to <a href=\"https://about.mattermost.com/default-api-authentication\" target=\"_blank\">interact with this Mattermost server</a>. Tokens are disabled if the user is deactivated. Learn more about <a href=\"https://about.mattermost.com/default-user-access-tokens\" target=\"_blank\">personal access tokens</a>.","admin.manage_tokens.userAccessTokensIdLabel":"Token ID: ","admin.manage_tokens.userAccessTokensNameLabel":"Token Description: ","admin.manage_tokens.userAccessTokensNone":"No personal access tokens.","admin.metrics.enableDescription":"When true, Mattermost will enable performance monitoring collection and profiling. Please see <a href=\"http://docs.mattermost.com/deployment/metrics.html\" target='_blank'>documentation</a> to learn more about configuring performance monitoring for Mattermost.","admin.metrics.enableTitle":"Enable Performance Monitoring:","admin.metrics.listenAddressDesc":"The address the server will listen on to expose performance metrics.","admin.metrics.listenAddressEx":"E.g.: \":8067\"","admin.metrics.listenAddressTitle":"Listen Address:","admin.mfa.bannerDesc":"<a href='https://docs.mattermost.com/deployment/auth.html' target='_blank'>Multi-factor authentication</a> is available for accounts with AD/LDAP or email login. If other login methods are used, MFA should be configured with the authentication provider.","admin.mfa.cluster":"High","admin.mfa.title":"Multi-factor Authentication","admin.nav.administratorsGuide":"Administrator's Guide","admin.nav.commercialSupport":"Commercial Support","admin.nav.help":"Help","admin.nav.logout":"Logout","admin.nav.report":"Report a Problem","admin.nav.switch":"Team Selection","admin.nav.troubleshootingForum":"Troubleshooting Forum","admin.notifications.email":"Email","admin.notifications.push":"Mobile Push","admin.notifications.title":"Notification Settings","admin.oauth.gitlab":"GitLab","admin.oauth.google":"Google Apps","admin.oauth.off":"Do not allow sign-in via an OAuth 2.0 provider","admin.oauth.office365":"Office 365 (Beta)","admin.oauth.providerDescription":"When true, Mattermost can act as an OAuth 2.0 service provider allowing Mattermost to authorize API requests from external applications. See <a target='_blank' href=\"https://docs.mattermost.com/developer/oauth-2-0-applications.html\">documentation</a> to learn more.","admin.oauth.providerTitle":"Enable OAuth 2.0 Service Provider: ","admin.oauth.select":"Select OAuth 2.0 service provider:","admin.office365.EnableHtmlDesc":"<ol><li><a target='_blank' href='https://login.microsoftonline.com/'>Log in</a> to your Microsoft or Office 365 account. Make sure it's the account on the same <a target='_blank' href='https://msdn.microsoft.com/en-us/library/azure/jj573650.aspx#Anchor_0'>tenant</a> that you would like users to log in with.</li><li>Go to <a target='_blank' href='https://apps.dev.microsoft.com'>https://apps.dev.microsoft.com</a>, click <strong>Go to app list</strong> > <strong>Add an app</strong> and use \"Mattermost - your-company-name\" as the <strong>Application Name</strong>.</li><li>Under <strong>Application Secrets</strong>, click <strong>Generate New Password</strong> and paste it to the <strong>Application Secret Password</strong> field below.</li><li>Under <strong>Platforms</strong>, click <strong>Add Platform</strong>, choose <strong>Web</strong> and enter <strong>your-mattermost-url/signup/office365/complete</strong> (example: http://localhost:8065/signup/office365/complete) under <strong>Redirect URIs</strong>. Also uncheck <strong>Allow Implicit Flow</strong>.</li><li>Finally, click <strong>Save</strong> and then paste the <strong>Application ID</strong> below.</li></ol>","admin.office365.authTitle":"Auth Endpoint:","admin.office365.clientIdDescription":"The Application/Client ID you received when registering your application with Microsoft.","admin.office365.clientIdExample":"E.g.: \"adf3sfa2-ag3f-sn4n-ids0-sh1hdax192qq\"","admin.office365.clientIdTitle":"Application ID:","admin.office365.clientSecretDescription":"The Application Secret Password you generated when registering your application with Microsoft.","admin.office365.clientSecretExample":"E.g.: \"shAieM47sNBfgl20f8ci294\"","admin.office365.clientSecretTitle":"Application Secret Password:","admin.office365.tokenTitle":"Token Endpoint:","admin.office365.userTitle":"User API Endpoint:","admin.password.lowercase":"At least one lowercase letter","admin.password.minimumLength":"Minimum Password Length:","admin.password.minimumLengthDescription":"Minimum number of characters required for a valid password. Must be a whole number greater than or equal to {min} and less than or equal to {max}.","admin.password.minimumLengthExample":"E.g.: \"5\"","admin.password.number":"At least one number","admin.password.preview":"Error message preview","admin.password.requirements":"Password Requirements:","admin.password.requirementsDescription":"Character types required in a valid password.","admin.password.symbol":"At least one symbol (e.g. \"~!@#$%^&*()\")","admin.password.uppercase":"At least one uppercase letter","admin.plugin.activate":"Activate","admin.plugin.activating":"Activating...","admin.plugin.banner":"Plugins are experimental and not recommended for use in production.","admin.plugin.choose":"Choose File","admin.plugin.deactivate":"Deactivate","admin.plugin.deactivating":"Deactivating...","admin.plugin.desc":"Description:","admin.plugin.error.activate":"Unable to upload the plugin. It may conflict with another plugin on your server.","admin.plugin.error.extract":"Encountered an error when extracting the plugin. Review your plugin file content and try again.","admin.plugin.id":"Id:","admin.plugin.installedDesc":"Installed plugins on your Mattermost server. Pre-packaged plugins are installed by default, and can be deactivated but not removed.","admin.plugin.installedTitle":"Installed Plugins: ","admin.plugin.management.banner":"Plugins are disabled on your server. To enable them, go to <strong>Plugins > Configuration</strong>.","admin.plugin.management.title":"Management","admin.plugin.name":"Name:","admin.plugin.no_plugins":"No installed plugins.","admin.plugin.prepackaged":"Pre-packaged","admin.plugin.remove":"Remove","admin.plugin.removing":"Removing...","admin.plugin.settingsButton":"Settings","admin.plugin.upload":"Upload","admin.plugin.uploadDesc":"Upload a plugin for your Mattermost server. See <a href=\"https://about.mattermost.com/default-plugin-uploads\" target=\"_blank\">documentation</a> to learn more.","admin.plugin.uploadDisabledDesc":"To enable plugin uploads, go to <strong>Plugins > Configuration</strong>. See <a href=\"https://about.mattermost.com/default-plugin-uploads\" target=\"_blank\">documentation</a> to learn more.","admin.plugin.uploadTitle":"Upload Plugin: ","admin.plugin.uploading":"Uploading...","admin.plugin.version":"Version:","admin.plugins.settings.enable":"Enable Plugins: ","admin.plugins.settings.enableDesc":"When true, enables plugins on your Mattermost server. Use plugins to integrate with third-party systems, extend functionality or customize the user interface of your Mattermost server. See <a href=\"https://about.mattermost.com/default-plugins\" target=\"_blank\">documentation</a> to learn more.","admin.plugins.settings.title":"Configuration","admin.privacy.showEmailDescription":"When false, hides the email address of members from everyone except System Administrators.","admin.privacy.showEmailTitle":"Show Email Address: ","admin.privacy.showFullNameDescription":"When false, hides the full name of members from everyone except System Administrators. Username is shown in place of full name.","admin.privacy.showFullNameTitle":"Show Full Name: ","admin.purge.button":"Purge All Caches","admin.purge.loading":" Loading...","admin.purge.purgeDescription":"This will purge all the in-memory caches for things like sessions, accounts, channels, etc. Deployments using High Availability will attempt to purge all the servers in the cluster.  Purging the caches may adversly impact performance.","admin.purge.purgeFail":"Purging unsuccessful: {error}","admin.rate.enableLimiterDescription":"When true, APIs are throttled at rates specified below.","admin.rate.enableLimiterTitle":"Enable Rate Limiting: ","admin.rate.httpHeaderDescription":"When filled in, vary rate limiting by HTTP header field specified (e.g. when configuring NGINX set to \"X-Real-IP\", when configuring AmazonELB set to \"X-Forwarded-For\").","admin.rate.httpHeaderExample":"E.g.: \"X-Real-IP\", \"X-Forwarded-For\"","admin.rate.httpHeaderTitle":"Vary rate limit by HTTP header:","admin.rate.maxBurst":"Maximum Burst Size:","admin.rate.maxBurstDescription":"Maximum number of requests allowed beyond the per second query limit.","admin.rate.maxBurstExample":"E.g.: \"100\"","admin.rate.memoryDescription":"Maximum number of users sessions connected to the system as determined by \"Vary rate limit by remote address\" and \"Vary rate limit by HTTP header\" settings below.","admin.rate.memoryExample":"E.g.: \"10000\"","admin.rate.memoryTitle":"Memory Store Size:","admin.rate.noteDescription":"Changing properties other than Site URL in this section will require a server restart before taking effect.","admin.rate.noteTitle":"Note:","admin.rate.queriesDescription":"Throttles API at this number of requests per second.","admin.rate.queriesExample":"E.g.: \"10\"","admin.rate.queriesTitle":"Maximum Queries per Second:","admin.rate.remoteDescription":"When true, rate limit API access by IP address.","admin.rate.remoteTitle":"Vary rate limit by remote address: ","admin.rate.title":"Rate Limit Settings","admin.rate.varyByUser":"Vary rate limit by user: ","admin.rate.varyByUserDescription":"When true, rate limit API access by user authentication token.","admin.recycle.button":"Recycle Database Connections","admin.recycle.loading":" Recycling...","admin.recycle.recycleDescription":"Deployments using multiple databases can switch from one master database to another without restarting the Mattermost server by updating \"config.json\" to the new desired configuration and using the {reloadConfiguration} feature to load the new settings while the server is running. The administrator should then use {featureName} feature to recycle the database connections based on the new settings.","admin.recycle.recycleDescription.featureName":"Recycle Database Connections","admin.recycle.recycleDescription.reloadConfiguration":"Configuration > Reload Configuration from Disk","admin.recycle.reloadFail":"Recycling unsuccessful: {error}","admin.regenerate":"Regenerate","admin.reload.button":"Reload Configuration From Disk","admin.reload.loading":" Loading...","admin.reload.reloadDescription":"Deployments using multiple databases can switch from one master database to another without restarting the Mattermost server by updating \"config.json\" to the new desired configuration and using the {featureName} feature to load the new settings while the server is running. The administrator should then use the {recycleDatabaseConnections} feature to recycle the database connections based on the new settings.","admin.reload.reloadDescription.featureName":"Reload Configuration from Disk","admin.reload.reloadDescription.recycleDatabaseConnections":"Database > Recycle Database Connections","admin.reload.reloadFail":"Reloading unsuccessful: {error}","admin.requestButton.loading":" Loading...","admin.requestButton.requestFailure":"Test Failure: {error}","admin.requestButton.requestSuccess":"Test Successful","admin.reset_password.cancel":"Cancel","admin.reset_password.curentPassword":"Current Password","admin.reset_password.missing_current":"Please enter your current password.","admin.reset_password.newPassword":"New Password","admin.reset_password.reset":"Reset","admin.reset_password.submit":"Please enter at least {chars} characters.","admin.reset_password.titleReset":"Reset Password","admin.reset_password.titleSwitch":"Switch Account to Email/Password","admin.revoke_token_button.delete":"Delete","admin.s3.connectionS3Test":"Test Connection","admin.s3.s3Fail":"Connection unsuccessful: {error}","admin.s3.s3Success":"Connection was successful","admin.s3.testing":"Testing...","admin.saml.assertionConsumerServiceURLDesc":"Enter https://<your-mattermost-url>/login/sso/saml. Make sure you use HTTP or HTTPS in your URL depending on your server configuration. This field is also known as the Assertion Consumer Service URL.","admin.saml.assertionConsumerServiceURLEx":"E.g.: \"https://<your-mattermost-url>/login/sso/saml\"","admin.saml.assertionConsumerServiceURLPopulatedDesc":"This field is also known as the Assertion Consumer Service URL.","admin.saml.assertionConsumerServiceURLTitle":"Service Provider Login URL:","admin.saml.emailAttrDesc":"The attribute in the SAML Assertion that will be used to populate the email addresses of users in Mattermost.","admin.saml.emailAttrEx":"E.g.: \"Email\" or \"PrimaryEmail\"","admin.saml.emailAttrTitle":"Email Attribute:","admin.saml.enableDescription":"When true, Mattermost allows login using SAML 2.0. Please see <a href='http://docs.mattermost.com/deployment/sso-saml.html' target='_blank'>documentation</a> to learn more about configuring SAML for Mattermost.","admin.saml.enableSyncWithLdapDescription":"When true, Mattermost periodically synchronizes SAML user attributes, including user deactivation and removal, from AD/LDAP. Enable and configure synchronization settings at <strong>Authentication > AD/LDAP</strong>. When false, user attributes are updated in Mattermost during user login. See <a href='https://about.mattermost.com/default-saml-ldap-sync' target='_blank'>documentation</a> to learn more.","admin.saml.enableSyncWithLdapTitle":"Enable Synchronizing SAML Accounts With AD/LDAP:","admin.saml.enableTitle":"Enable Login With SAML 2.0:","admin.saml.encryptDescription":"When false, Mattermost will not decrypt SAML Assertions encrypted with your Service Provider Public Certificate. Not recommended for production environments. For testing only.","admin.saml.encryptTitle":"Enable Encryption:","admin.saml.firstnameAttrDesc":"(Optional) The attribute in the SAML Assertion that will be used to populate the first name of users in Mattermost.","admin.saml.firstnameAttrEx":"E.g.: \"FirstName\"","admin.saml.firstnameAttrTitle":"First Name Attribute:","admin.saml.idpCertificateFileDesc":"The public authentication certificate issued by your Identity Provider.","admin.saml.idpCertificateFileRemoveDesc":"Remove the public authentication certificate issued by your Identity Provider.","admin.saml.idpCertificateFileTitle":"Identity Provider Public Certificate:","admin.saml.idpDescriptorUrlDesc":"The issuer URL for the Identity Provider you use for SAML requests.","admin.saml.idpDescriptorUrlEx":"E.g.: \"https://idp.example.org/SAML2/issuer\"","admin.saml.idpDescriptorUrlTitle":"Identity Provider Issuer URL:","admin.saml.idpUrlDesc":"The URL where Mattermost sends a SAML request to start login sequence.","admin.saml.idpUrlEx":"E.g.: \"https://idp.example.org/SAML2/SSO/Login\"","admin.saml.idpUrlTitle":"SAML SSO URL:","admin.saml.lastnameAttrDesc":"(Optional) The attribute in the SAML Assertion that will be used to populate the last name of users in Mattermost.","admin.saml.lastnameAttrEx":"E.g.: \"LastName\"","admin.saml.lastnameAttrTitle":"Last Name Attribute:","admin.saml.localeAttrDesc":"(Optional) The attribute in the SAML Assertion that will be used to populate the language of users in Mattermost.","admin.saml.localeAttrEx":"E.g.: \"Locale\" or \"PrimaryLanguage\"","admin.saml.localeAttrTitle":"Preferred Language Attribute:","admin.saml.loginButtonTextDesc":"(Optional) The text that appears in the login button on the login page. Defaults to \"With SAML\".","admin.saml.loginButtonTextEx":"E.g.: \"With OKTA\"","admin.saml.loginButtonTextTitle":"Login Button Text:","admin.saml.nicknameAttrDesc":"(Optional) The attribute in the SAML Assertion that will be used to populate the nickname of users in Mattermost.","admin.saml.nicknameAttrEx":"E.g.: \"Nickname\"","admin.saml.nicknameAttrTitle":"Nickname Attribute:","admin.saml.positionAttrDesc":"(Optional) The attribute in the SAML Assertion that will be used to populate the position of users in Mattermost.","admin.saml.positionAttrEx":"E.g.: \"Role\"","admin.saml.positionAttrTitle":"Position Attribute:","admin.saml.privateKeyFileFileDesc":"The private key used to decrypt SAML Assertions from the Identity Provider.","admin.saml.privateKeyFileFileRemoveDesc":"Remove the private key used to decrypt SAML Assertions from the Identity Provider.","admin.saml.privateKeyFileTitle":"Service Provider Private Key:","admin.saml.publicCertificateFileDesc":"The certificate used to generate the signature on a SAML request to the Identity Provider for a service provider initiated SAML login, when Mattermost is the Service Provider.","admin.saml.publicCertificateFileRemoveDesc":"Remove the certificate used to generate the signature on a SAML request to the Identity Provider for a service provider initiated SAML login, when Mattermost is the Service Provider.","admin.saml.publicCertificateFileTitle":"Service Provider Public Certificate:","admin.saml.remove.idp_certificate":"Remove Identity Provider Certificate","admin.saml.remove.privKey":"Remove Service Provider Private Key","admin.saml.remove.sp_certificate":"Remove Service Provider Certificate","admin.saml.removing.certificate":"Removing Certificate...","admin.saml.removing.privKey":"Removing Private Key...","admin.saml.uploading.certificate":"Uploading Certificate...","admin.saml.uploading.privateKey":"Uploading Private Key...","admin.saml.usernameAttrDesc":"The attribute in the SAML Assertion that will be used to populate the username field in Mattermost.","admin.saml.usernameAttrEx":"E.g.: \"Username\"","admin.saml.usernameAttrTitle":"Username Attribute:","admin.saml.verifyDescription":"When false, Mattermost will not verify that the signature sent from a SAML Response matches the Service Provider Login URL. Not recommended for production environments. For testing only.","admin.saml.verifyTitle":"Verify Signature:","admin.save":"Save","admin.saving":"Saving Config...","admin.security.client_versions":"Client Versions","admin.security.connection":"Connections","admin.security.inviteSalt.disabled":"Invite salt cannot be changed while sending emails is disabled.","admin.security.login":"Login","admin.security.password":"Password","admin.security.passwordResetSalt.disabled":"Password reset salt cannot be changed while sending emails is disabled.","admin.security.public_links":"Public Links","admin.security.requireEmailVerification.disabled":"Email verification cannot be changed while sending emails is disabled.","admin.security.session":"Sessions","admin.security.signup":"Signup","admin.select_team.close":"Close","admin.select_team.select":"Select","admin.select_team.selectTeam":"Select Team","admin.service.attemptDescription":"Number of login attempts allowed before a user is locked out and required to reset their password via email.","admin.service.attemptExample":"E.g.: \"10\"","admin.service.attemptTitle":"Maximum Login Attempts:","admin.service.cmdsDesc":"When true, custom slash commands will be allowed. See <a href='http://docs.mattermost.com/developer/slash-commands.html' target='_blank'>documentation</a> to learn more.","admin.service.cmdsTitle":"Enable Custom Slash Commands: ","admin.service.complianceExportDesc":"When true, Mattermost will export all messages that were posted in the last 24 hours. The export task is scheduled to run once per day. See <a href=\"https://about.mattermost.com/default-compliance-export-documentation\" target=\"_blank\">the documentation</a> to learn more.","admin.service.complianceExportTitle":"Enable Compliance Export:","admin.service.corsDescription":"Enable HTTP Cross origin request from a specific domain. Use \"*\" if you want to allow CORS from any domain or leave it blank to disable it.","admin.service.corsEx":"http://example.com","admin.service.corsTitle":"Enable cross-origin requests from:","admin.service.developerDesc":"When true, JavaScript errors are shown in a purple bar at the top of the user interface. Not recommended for use in production. ","admin.service.developerTitle":"Enable Developer Mode: ","admin.service.enableAPIv3":"Allow use of API v3 endpoints:","admin.service.enableAPIv3Description":"Set to false to disable all version 3 endpoints of the REST API. Integrations that rely on API v3 will fail and can then be identified for migration to API v4. API v3 is deprecated and will be removed in the near future. See <a href='https://api.mattermost.com' target='_blank'>https://api.mattermost.com</a> for details.","admin.service.enforceMfaDesc":"When true, <a href='https://docs.mattermost.com/deployment/auth.html' target='_blank'>multi-factor authentication</a> is required for login. New users will be required to configure MFA on signup. Logged in users without MFA configured are redirected to the MFA setup page until configuration is complete.<br/><br/>If your system has users with login methods other than AD/LDAP and email, MFA must be enforced with the authentication provider outside of Mattermost.","admin.service.enforceMfaTitle":"Enforce Multi-factor Authentication:","admin.service.forward80To443":"Forward port 80 to 443:","admin.service.forward80To443Description":"Forwards all insecure traffic from port 80 to secure port 443. Not recommended when using a proxy server.","admin.service.forward80To443Description.disabled":"Forwards all insecure traffic from port 80 to secure port 443. Not recommended when using a proxy server.<br /><br />This setting cannot be enabled until your server is <a href=\"#ListenAddress\">listening</a> on port 443.","admin.service.googleDescription":"Set this key to enable the display of titles for embedded YouTube video previews. Without the key, YouTube previews will still be created based on hyperlinks appearing in messages or comments but they will not show the video title. View a <a href=\"https://www.youtube.com/watch?v=Im69kzhpR3I\" target='_blank'>Google Developers Tutorial</a> for instructions on how to obtain a key and add YouTube Data API v3 as a service to your key.","admin.service.googleExample":"E.g.: \"7rAh6iwQCkV4cA1Gsg3fgGOXJAQ43QV\"","admin.service.googleTitle":"Google API Key:","admin.service.iconDescription":"When true, webhooks, slash commands and other integrations, such as <a href=\"https://docs.mattermost.com/integrations/zapier.html\" target='_blank'>Zapier</a>, will be allowed to change the profile picture they post with. Note: Combined with allowing integrations to override usernames, users may be able to perform phishing attacks by attempting to impersonate other users.","admin.service.iconTitle":"Enable integrations to override profile picture icons:","admin.service.insecureTlsDesc":"When true, any outgoing HTTPS requests will accept unverified, self-signed certificates. For example, outgoing webhooks to a server with a self-signed TLS certificate, using any domain, will be allowed. Note that this makes these connections susceptible to man-in-the-middle attacks.","admin.service.insecureTlsTitle":"Enable Insecure Outgoing Connections: ","admin.service.integrationAdmin":"Restrict managing integrations to Admins:","admin.service.integrationAdminDesc":"When true, webhooks and slash commands can only be created, edited and viewed by Team and System Admins, and OAuth 2.0 applications by System Admins. Integrations are available to all users after they have been created by the Admin.","admin.service.internalConnectionsDesc":"In testing environments, such as when developing integrations locally on a development machine, use this setting to specify domains, IP addresses, or CIDR notations to allow internal connections. <b>Not recommended for use in production</b>, since this can allow a user to extract confidential data from your server or internal network.<br /><br />By default, user-supplied URLs such as those used for Open Graph metadata, webhooks, or slash commands will not be allowed to connect to reserved IP addresses including loopback or link-local addresses used for internal networks. Push notification, OAuth 2.0 and WebRTC server URLs are trusted and not affected by this setting.","admin.service.internalConnectionsEx":"webhooks.internal.example.com 127.0.0.1 10.0.16.0/28","admin.service.internalConnectionsTitle":"Allow untrusted internal connections to: ","admin.service.letsEncryptCertificateCacheFile":"Let's Encrypt Certificate Cache File:","admin.service.letsEncryptCertificateCacheFileDescription":"Certificates retrieved and other data about the Let's Encrypt service will be stored in this file.","admin.service.listenAddress":"Listen Address:","admin.service.listenDescription":"The address and port to which to bind and listen. Specifying \":8065\" will bind to all network interfaces. Specifying \"127.0.0.1:8065\" will only bind to the network interface having that IP address. If you choose a port of a lower level (called \"system ports\" or \"well-known ports\", in the range of 0-1023), you must have permissions to bind to that port. On Linux you can use: \"sudo setcap cap_net_bind_service=+ep ./bin/platform\" to allow Mattermost to bind to well-known ports.","admin.service.listenExample":"E.g.: \":8065\"","admin.service.mfaDesc":"When true, users with AD/LDAP or email login can add multi-factor authentication to their account using Google Authenticator.","admin.service.mfaTitle":"Enable Multi-factor Authentication:","admin.service.mobileSessionDays":"Session Length Mobile (days):","admin.service.mobileSessionDaysDesc":"The number of days from the last time a user entered their credentials to the expiry of the user's session. After changing this setting, the new session length will take effect after the next time the user enters their credentials.","admin.service.outWebhooksDesc":"When true, outgoing webhooks will be allowed. See <a href='http://docs.mattermost.com/developer/webhooks-outgoing.html' target='_blank'>documentation</a> to learn more.","admin.service.outWebhooksTitle":"Enable Outgoing Webhooks: ","admin.service.overrideDescription":"When true, webhooks, slash commands and other integrations, such as <a href=\"https://docs.mattermost.com/integrations/zapier.html\" target='_blank'>Zapier</a>, will be allowed to change the username they are posting as. Note: Combined with allowing integrations to override profile picture icons, users may be able to perform phishing attacks by attempting to impersonate other users.","admin.service.overrideTitle":"Enable integrations to override usernames:","admin.service.readTimeout":"Read Timeout:","admin.service.readTimeoutDescription":"Maximum time allowed from when the connection is accepted to when the request body is fully read.","admin.service.securityDesc":"When true, System Administrators are notified by email if a relevant security fix alert has been announced in the last 12 hours. Requires email to be enabled.","admin.service.securityTitle":"Enable Security Alerts: ","admin.service.sessionCache":"Session Cache (minutes):","admin.service.sessionCacheDesc":"The number of minutes to cache a session in memory.","admin.service.sessionDaysEx":"E.g.: \"30\"","admin.service.sessionIdleTimeout":"Session Idle Timeout (minutes):","admin.service.sessionIdleTimeoutDesc":"The number of minutes from the last time a user was active on the system to the expiry of the user's session. Once expired, the user will need to log in to continue. Minimum is 5 minutes, and 0 is unlimited.<br/><br/>Applies to the desktop app and browsers. For mobile apps, use an EMM provider to lock the app when not in use. In High Availability mode, enable IP hash load balancing for reliable timeout measurement.","admin.service.sessionIdleTimeoutEx":"E.g.: \"60\"","admin.service.siteURL":"Site URL:","admin.service.siteURLDescription":"The URL that users will use to access Mattermost. Standard ports, such as 80 and 443, can be omitted, but non-standard ports are required. For example: http://mattermost.example.com:8065. This setting is required.","admin.service.siteURLExample":"E.g.: \"https://mattermost.example.com:1234\"","admin.service.ssoSessionDays":"Session Length SSO (days):","admin.service.ssoSessionDaysDesc":"The number of days from the last time a user entered their credentials to the expiry of the user's session. If the authentication method is SAML or GitLab, the user may automatically be logged back in to Mattermost if they are already logged in to SAML or GitLab. After changing this setting, the setting will take effect after the next time the user enters their credentials.","admin.service.testingDescription":"When true, /test slash command is enabled to load test accounts, data and text formatting. Changing this requires a server restart before taking effect.","admin.service.testingTitle":"Enable Testing Commands: ","admin.service.tlsCertFile":"TLS Certificate File:","admin.service.tlsCertFileDescription":"The certificate file to use.","admin.service.tlsKeyFile":"TLS Key File:","admin.service.tlsKeyFileDescription":"The private key file to use.","admin.service.useLetsEncrypt":"Use Let's Encrypt:","admin.service.useLetsEncryptDescription":"Enable the automatic retrieval of certificates from Let's Encrypt. The certificate will be retrieved when a client attempts to connect from a new domain. This will work with multiple domains.","admin.service.useLetsEncryptDescription.disabled":"Enable the automatic retrieval of certificates from Let's Encrypt. The certificate will be retrieved when a client attempts to connect from a new domain. This will work with multiple domains.<br /><br />This setting cannot be enabled unless the <a href=\"#Forward80To443\">Forward port 80 to 443</a> setting is set to true.","admin.service.userAccessTokensDescLabel":"Name: ","admin.service.userAccessTokensDescription":"When true, users can create <a href=\"https://about.mattermost.com/default-user-access-tokens\" target=\"_blank\">personal access tokens</a> for integrations in <strong>Account Settings > Security</strong>. They can be used to authenticate against the API and give full access to the account.<br/><br/>To manage who can create personal access tokens or to search users by token ID, go to the <strong>System Console > Users</strong> page.","admin.service.userAccessTokensIdLabel":"Token ID: ","admin.service.userAccessTokensTitle":"Enable Personal Access Tokens: ","admin.service.webSessionDays":"Session Length AD/LDAP and Email (days):","admin.service.webSessionDaysDesc":"The number of days from the last time a user entered their credentials to the expiry of the user's session. After changing this setting, the new session length will take effect after the next time the user enters their credentials.","admin.service.webhooksDescription":"When true, incoming webhooks will be allowed. To help combat phishing attacks, all posts from webhooks will be labelled by a BOT tag. See <a href='http://docs.mattermost.com/developer/webhooks-incoming.html' target='_blank'>documentation</a> to learn more.","admin.service.webhooksTitle":"Enable Incoming Webhooks: ","admin.service.writeTimeout":"Write Timeout:","admin.service.writeTimeoutDescription":"If using HTTP (insecure), this is the maximum time allowed from the end of reading the request headers until the response is written. If using HTTPS, it is the total time from when the connection is accepted until the response is written.","admin.sidebar.advanced":"Advanced","admin.sidebar.audits":"Compliance and Auditing","admin.sidebar.authentication":"Authentication","admin.sidebar.client_versions":"Client Versions","admin.sidebar.cluster":"High Availability","admin.sidebar.compliance":"Compliance","admin.sidebar.compliance_export":"Compliance Export (Beta)","admin.sidebar.configuration":"Configuration","admin.sidebar.connections":"Connections","admin.sidebar.customBrand":"Custom Branding","admin.sidebar.customIntegrations":"Custom Integrations","admin.sidebar.customization":"Customization","admin.sidebar.data_retention":"Data Retention Policy (Beta)","admin.sidebar.database":"Database","admin.sidebar.developer":"Developer","admin.sidebar.elasticsearch":"Elasticsearch (Beta)","admin.sidebar.email":"Email","admin.sidebar.emoji":"Emoji","admin.sidebar.external":"External Services","admin.sidebar.files":"Files","admin.sidebar.general":"General","admin.sidebar.gitlab":"GitLab","admin.sidebar.integrations":"Integrations","admin.sidebar.ldap":"AD/LDAP","admin.sidebar.legalAndSupport":"Legal and Support","admin.sidebar.license":"Edition and License","admin.sidebar.linkPreviews":"Link Previews","admin.sidebar.localization":"Localization","admin.sidebar.logging":"Logging","admin.sidebar.login":"Login","admin.sidebar.logs":"Logs","admin.sidebar.metrics":"Performance Monitoring","admin.sidebar.mfa":"MFA","admin.sidebar.nativeAppLinks":"Mattermost App Links","admin.sidebar.notifications":"Notifications","admin.sidebar.oauth":"OAuth 2.0","admin.sidebar.other":"OTHER","admin.sidebar.password":"Password","admin.sidebar.plugins":"Plugins (Beta)","admin.sidebar.plugins.configuration":"Configuration","admin.sidebar.plugins.management":"Management","admin.sidebar.policy":"Policy","admin.sidebar.privacy":"Privacy","admin.sidebar.publicLinks":"Public Links","admin.sidebar.push":"Mobile Push","admin.sidebar.rateLimiting":"Rate Limiting","admin.sidebar.reports":"REPORTING","admin.sidebar.saml":"SAML 2.0","admin.sidebar.security":"Security","admin.sidebar.sessions":"Sessions","admin.sidebar.settings":"SETTINGS","admin.sidebar.signUp":"Sign Up","admin.sidebar.sign_up":"Sign Up","admin.sidebar.statistics":"Team Statistics","admin.sidebar.storage":"Storage","admin.sidebar.support":"Legal and Support","admin.sidebar.users":"Users","admin.sidebar.usersAndTeams":"Users and Teams","admin.sidebar.view_statistics":"Site Statistics","admin.sidebar.webrtc":"WebRTC (Beta)","admin.sidebarHeader.systemConsole":"System Console","admin.sql.dataSource":"Data Source:","admin.sql.driverName":"Driver Name:","admin.sql.keyDescription":"32-character salt available to encrypt and decrypt sensitive fields in database.","admin.sql.keyExample":"E.g.: \"gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6\"","admin.sql.keyTitle":"At Rest Encrypt Key:","admin.sql.maxConnectionsDescription":"Maximum number of idle connections held open to the database.","admin.sql.maxConnectionsExample":"E.g.: \"10\"","admin.sql.maxConnectionsTitle":"Maximum Idle Connections:","admin.sql.maxOpenDescription":"Maximum number of open connections held open to the database.","admin.sql.maxOpenExample":"E.g.: \"10\"","admin.sql.maxOpenTitle":"Maximum Open Connections:","admin.sql.noteDescription":"Changing properties in this section will require a server restart before taking effect.","admin.sql.noteTitle":"Note:","admin.sql.queryTimeoutDescription":"The number of seconds to wait for a response from the database after opening a connection and sending the query. Errors that you see in the UI or in the logs as a result of a query timeout can vary depending on the type of query.","admin.sql.queryTimeoutExample":"E.g.: \"30\"","admin.sql.queryTimeoutTitle":"Query Timeout:","admin.sql.replicas":"Data Source Replicas:","admin.sql.traceDescription":"(Development Mode) When true, executing SQL statements are written to the log.","admin.sql.traceTitle":"Trace: ","admin.sql.warning":"Warning: regenerating this salt may cause some columns in the database to return empty results.","admin.support.aboutDesc":"The URL for the About link on the Mattermost login and sign-up pages. If this field is empty, the About link is hidden from users.","admin.support.aboutTitle":"About link:","admin.support.emailHelp":"Email address displayed on email notifications and during tutorial for end users to ask support questions.","admin.support.emailTitle":"Support Email:","admin.support.helpDesc":"The URL for the Help link on the Mattermost login page, sign-up pages, and Main Menu. If this field is empty, the Help link is hidden from users.","admin.support.helpTitle":"Help link:","admin.support.noteDescription":"If linking to an external site, URLs should begin with http:// or https://.","admin.support.noteTitle":"Note:","admin.support.privacyDesc":"The URL for the Privacy link on the login and sign-up pages. If this field is empty, the Privacy link is hidden from users.","admin.support.privacyTitle":"Privacy Policy link:","admin.support.problemDesc":"The URL for the Report a Problem link in the Main Menu. If this field is empty, the link is removed from the Main Menu.","admin.support.problemTitle":"Report a Problem link:","admin.support.termsDesc":"Link to the terms under which users may use your online service. By default, this includes the \"Mattermost Conditions of Use (End Users)\" explaining the terms under which Mattermost software is provided to end users. If you change the default link to add your own terms for using the service you provide, your new terms must include a link to the default terms so end users are aware of the Mattermost Conditions of Use (End User) for Mattermost software.","admin.support.termsTitle":"Terms of Service link:","admin.system_analytics.activeUsers":"Active Users With Posts","admin.system_analytics.title":"the System","admin.system_analytics.totalPosts":"Total Posts","admin.system_users.allUsers":"All Users","admin.system_users.noTeams":"No Teams","admin.system_users.title":"{siteName} Users","admin.team.brandDesc":"Enable custom branding to show an image of your choice, uploaded below, and some help text, written below, on the login page.","admin.team.brandDescriptionExample":"All team communication in one place, searchable and accessible anywhere","admin.team.brandDescriptionHelp":"Description of service shown in login screens and UI. When not specified, \"All team communication in one place, searchable and accessible anywhere\" is displayed.","admin.team.brandDescriptionTitle":"Site Description: ","admin.team.brandImageTitle":"Custom Brand Image:","admin.team.brandTextDescription":"Text that will appear below your custom brand image on your login screen. Supports Markdown-formatted text. Maximum 500 characters allowed.","admin.team.brandTextTitle":"Custom Brand Text:","admin.team.brandTitle":"Enable Custom Branding: ","admin.team.chooseImage":"Choose New Image","admin.team.dirDesc":"When true, teams that are configured to show in team directory will show on main page inplace of creating a new team.","admin.team.dirTitle":"Enable Team Directory: ","admin.team.enableConfirmNotificationsToChannelDescription":"When true, users will be prompted to confirm when posting @channel and @all in channels with over five members. When false, no confirmation is required.","admin.team.enableConfirmNotificationsToChannelTitle":"Show @channel and @all confirmation dialog: ","admin.team.maxChannelsDescription":"Maximum total number of channels per team, including both active and deleted channels.","admin.team.maxChannelsExample":"E.g.: \"100\"","admin.team.maxChannelsTitle":"Max Channels Per Team:","admin.team.maxNotificationsPerChannelDescription":"Maximum total number of users in a channel before users typing messages, @all, @here, and @channel no longer send notifications because of performance.","admin.team.maxNotificationsPerChannelExample":"E.g.: \"1000\"","admin.team.maxNotificationsPerChannelTitle":"Max Notifications Per Channel:","admin.team.maxUsersDescription":"Maximum total number of users per team, including both active and inactive users.","admin.team.maxUsersExample":"E.g.: \"25\"","admin.team.maxUsersTitle":"Max Users Per Team:","admin.team.noBrandImage":"No brand image uploaded","admin.team.openServerDescription":"When true, anyone can signup for a user account on this server without the need to be invited.","admin.team.openServerTitle":"Enable Open Server: ","admin.team.restrictDescription":"Teams and user accounts can only be created from a specific domain (e.g. \"mattermost.org\") or list of comma-separated domains (e.g. \"corp.mattermost.com, mattermost.org\").","admin.team.restrictDirectMessage":"Enable users to open Direct Message channels with:","admin.team.restrictDirectMessageDesc":"'Any user on the Mattermost server' enables users to open a Direct Message channel with any user on the server, even if they are not on any teams together. 'Any member of the team' limits the ability in the Direct Messages 'More' menu to only open Direct Message channels with users who are in the same team.<br /><br />Note: This setting only affects the UI, not permissions on the server.","admin.team.restrictExample":"E.g.: \"corp.mattermost.com, mattermost.org\"","admin.team.restrictNameDesc":"When true, You cannot create a team name with reserved words like www, admin, support, test, channel, etc","admin.team.restrictNameTitle":"Restrict Team Names: ","admin.team.restrictTitle":"Restrict account creation to specified email domains:","admin.team.restrict_direct_message_any":"Any user on the Mattermost server","admin.team.restrict_direct_message_team":"Any member of the team","admin.team.showFullname":"Show first and last name","admin.team.showNickname":"Show nickname if one exists, otherwise show first and last name","admin.team.showUsername":"Show username (default)","admin.team.siteNameDescription":"Name of service shown in login screens and UI.","admin.team.siteNameExample":"E.g.: \"Mattermost\"","admin.team.siteNameTitle":"Site Name:","admin.team.teamCreationDescription":"When false, only System Administrators can create teams.","admin.team.teamCreationTitle":"Enable Team Creation: ","admin.team.teammateNameDisplay":"Teammate Name Display:","admin.team.teammateNameDisplayDesc":"Set how to display users' names in posts and the Direct Messages list.","admin.team.upload":"Upload","admin.team.uploadDesc":"Customize your user experience by adding a custom image to your login screen. Recommended maximum image size is less than 2 MB.","admin.team.uploaded":"Uploaded!","admin.team.uploading":"Uploading..","admin.team.userCreationDescription":"When false, the ability to create accounts is disabled. The create account button displays error when pressed.","admin.team.userCreationTitle":"Enable Account Creation: ","admin.team_analytics.activeUsers":"Active Users With Posts","admin.team_analytics.totalPosts":"Total Posts","admin.true":"true","admin.user_item.authServiceEmail":"<strong>Sign-in Method:</strong> Email","admin.user_item.authServiceNotEmail":"<strong>Sign-in Method:</strong> {service}","admin.user_item.confirmDemoteDescription":"If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you'll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.","admin.user_item.confirmDemoteRoleTitle":"Confirm demotion from System Admin role","admin.user_item.confirmDemotion":"Confirm Demotion","admin.user_item.confirmDemotionCmd":"platform roles system_admin {username}","admin.user_item.emailTitle":"<strong>Email:</strong> {email}","admin.user_item.inactive":"Inactive","admin.user_item.makeActive":"Activate","admin.user_item.makeInactive":"Deactivate","admin.user_item.makeMember":"Make Member","admin.user_item.makeSysAdmin":"Make System Admin","admin.user_item.makeTeamAdmin":"Make Team Admin","admin.user_item.manageRoles":"Manage Roles","admin.user_item.manageTeams":"Manage Teams","admin.user_item.manageTokens":"Manage Tokens","admin.user_item.member":"Member","admin.user_item.mfaNo":"<strong>MFA</strong>: No","admin.user_item.mfaYes":"<strong>MFA</strong>: Yes","admin.user_item.resetMfa":"Remove MFA","admin.user_item.resetPwd":"Reset Password","admin.user_item.revokeSessions":"Revoke Sessions","admin.user_item.switchToEmail":"Switch to Email/Password","admin.user_item.sysAdmin":"System Admin","admin.user_item.teamAdmin":"Team Admin","admin.user_item.teamMember":"Team Member","admin.user_item.userAccessTokenPostAll":"(with post:all personal access tokens)","admin.user_item.userAccessTokenPostAllPublic":"(with post:channels personal access tokens)","admin.user_item.userAccessTokenYes":"(with personal access tokens)","admin.webrtc.enableDescription":"When true, Mattermost allows making <strong>one-on-one</strong> video calls. WebRTC calls are available on Chrome, Firefox and Mattermost Desktop Apps.","admin.webrtc.enableTitle":"Enable Mattermost WebRTC: ","admin.webrtc.gatewayAdminSecretDescription":"Enter your admin secret password to access the Gateway Admin URL.","admin.webrtc.gatewayAdminSecretExample":"E.g.: \"PVRzWNN1Tg6szn7IQWvhpAvLByScWxdy\"","admin.webrtc.gatewayAdminSecretTitle":"Gateway Admin Secret:","admin.webrtc.gatewayAdminUrlDescription":"Enter https://<mattermost-webrtc-gateway-url>:<port>/admin. Make sure you use HTTP or HTTPS in your URL depending on your server configuration. Mattermost WebRTC uses this URL to obtain valid tokens for each peer to establish the connection.","admin.webrtc.gatewayAdminUrlExample":"E.g.: \"https://webrtc.mattermost.com:7089/admin\"","admin.webrtc.gatewayAdminUrlTitle":"Gateway Admin URL:","admin.webrtc.gatewayWebsocketUrlDescription":"Enter wss://<mattermost-webrtc-gateway-url>:<port>. Make sure you use WS or WSS in your URL depending on your server configuration. This is the WebSocket used to signal and establish communication between the peers.","admin.webrtc.gatewayWebsocketUrlExample":"E.g.: \"wss://webrtc.mattermost.com:8189\"","admin.webrtc.gatewayWebsocketUrlTitle":"Gateway WebSocket URL:","admin.webrtc.stunUriDescription":"Enter your STUN URI as stun:<your-stun-url>:<port>. STUN is a standardized network protocol to allow an end host to assist devices to access its public IP address if it is located behind a NAT.","admin.webrtc.stunUriExample":"E.g.: \"stun:webrtc.mattermost.com:5349\"","admin.webrtc.stunUriTitle":"STUN URI:","admin.webrtc.turnSharedKeyDescription":"Enter your TURN Server Shared Key. This is used to created dynamic passwords to establish the connection. Each password is valid for a short period of time.","admin.webrtc.turnSharedKeyExample":"E.g.: \"bXdkOWQxc3d0Ynk3emY5ZmsxZ3NtazRjaWg=\"","admin.webrtc.turnSharedKeyTitle":"TURN Shared Key:","admin.webrtc.turnUriDescription":"Enter your TURN URI as turn:<your-turn-url>:<port>. TURN is a standardized network protocol to allow an end host to assist devices to establish a connection by using a relay public IP address if it is located behind a symmetric NAT.","admin.webrtc.turnUriExample":"E.g.: \"turn:webrtc.mattermost.com:5349\"","admin.webrtc.turnUriTitle":"TURN URI:","admin.webrtc.turnUsernameDescription":"Enter your TURN Server Username.","admin.webrtc.turnUsernameExample":"E.g.: \"myusername\"","admin.webrtc.turnUsernameTitle":"TURN Username:","admin.webserverModeDisabled":"Disabled","admin.webserverModeDisabledDescription":"The Mattermost server will not serve static files.","admin.webserverModeGzip":"gzip","admin.webserverModeGzipDescription":"The Mattermost server will serve static files compressed with gzip.","admin.webserverModeHelpText":"gzip compression applies to static content files. It is recommended to enable gzip to improve performance unless your environment has specific restrictions, such as a web proxy that distributes gzip files poorly.","admin.webserverModeTitle":"Webserver Mode:","admin.webserverModeUncompressed":"Uncompressed","admin.webserverModeUncompressedDescription":"The Mattermost server will serve static files uncompressed.","admin.field_names.postEditTimeLimit":"Edit post time limit","admin.field_names.enableBanner":"Enable Announcement banner","admin.field_names.bannerText":"Banner text","admin.field_names.bannerColor":"Banner color","admin.field_names.bannerTextColor":"Banner text color","admin.field_names.allowBannerDismissal":"Allow banner dismissal","admin.field_names.enableIncomingWebhooks":"Enable Incomming Webhooks","admin.field_names.enableOutgoingWebhooks":"Enable Outgoing Webhooks","admin.field_names.enableCommands":"Enable Custom Slash Commands","admin.field_names.enablePostUsernameOverride":"Enable integrations to override usernames","admin.field_names.enablePostIconOverride":"Enable integrations to override profile picture icons","admin.field_names.enableOAuthServiceProvider":"Enable OAuth 2.0 Service Provider","admin.field_names.enableUserAccessTokens":"Enable Personal Access Tokens","admin.field_names.enableUserCreation":"Enable Account Creation","admin.field_names.maxUsersPerTeam":"Max Users Per Team","admin.field_names.restrictCreationToDomains":"Restrict account creation to specified email domains","admin.field_names.restrictDirectMessage":"Enable users to open Direct Message channels with","admin.field_names.teammateNameDisplay":"Teammate Name Display","admin.field_names.maxChannelsPerTeam":"Max Channels Per Team","admin.field_names.maxNotificationsPerChannel":"Max Notifications Per Channel","admin.field_names.enableConfirmNotificationsToChannel":"Show @channel and @all confirmation dialog","analytics.chart.loading":"Loading...","analytics.chart.meaningful":"Not enough data for a meaningful representation.","analytics.system.activeUsers":"Active Users With Posts","analytics.system.channelTypes":"Channel Types","analytics.system.dailyActiveUsers":"Daily Active Users","analytics.system.info":"Only data for the chosen team is calculated. Excludes posts made in direct message channels, which are not tied to a team.","analytics.system.infoAndSkippedIntensiveQueries":"Only data for the chosen team is calculated. Excludes posts made in direct message channels, which are not tied to a team. <br><br> To maximize performance, some statistics are disabled. You can <a href='https://docs.mattermost.com/administration/statistics.html' target='_blank'>re-enable them in config.json</a>.","analytics.system.monthlyActiveUsers":"Monthly Active Users","analytics.system.postTypes":"Posts, Files and Hashtags","analytics.system.privateGroups":"Private Channels","analytics.system.publicChannels":"Public Channels","analytics.system.skippedIntensiveQueries":"To maximize performance, some statistics are disabled. You can <a href='https://docs.mattermost.com/administration/statistics.html' target='_blank'>re-enable them in config.json</a>.","analytics.system.textPosts":"Posts with Text-only","analytics.system.title":"System Statistics","analytics.system.totalChannels":"Total Channels","analytics.system.totalCommands":"Total Commands","analytics.system.totalFilePosts":"Posts with Files","analytics.system.totalHashtagPosts":"Posts with Hashtags","analytics.system.totalIncomingWebhooks":"Incoming Webhooks","analytics.system.totalMasterDbConnections":"Master DB Conns","analytics.system.totalOutgoingWebhooks":"Outgoing Webhooks","analytics.system.totalPosts":"Total Posts","analytics.system.totalReadDbConnections":"Replica DB Conns","analytics.system.totalSessions":"Total Sessions","analytics.system.totalTeams":"Total Teams","analytics.system.totalUsers":"Total Users","analytics.system.totalWebsockets":"WebSocket Conns","analytics.team.activeUsers":"Active Users With Posts","analytics.team.newlyCreated":"Newly Created Users","analytics.team.noTeams":"There are no teams on this server for which to view statistics.","analytics.team.privateGroups":"Private Channels","analytics.team.publicChannels":"Public Channels","analytics.team.recentActive":"Recent Active Users","analytics.team.recentUsers":"Recent Active Users","analytics.team.title":"Team Statistics for {team}","analytics.team.totalPosts":"Total Posts","analytics.team.totalUsers":"Total Users","api.channel.add_member.added":"{addedUsername} added to the channel by {username}.","api.channel.delete_channel.archived":"{username} archived the channel.","api.channel.join_channel.post_and_forget":"{username} joined the channel.","api.channel.leave.left":"{username} left the channel.","api.channel.post_update_channel_displayname_message_and_forget.updated_from":"{username} updated the channel display name from: {old} to: {new}","api.channel.post_update_channel_header_message_and_forget.removed":"{username} removed the channel header (was: {old})","api.channel.post_update_channel_header_message_and_forget.updated_from":"{username} updated the channel header from: {old} to: {new}","api.channel.post_update_channel_header_message_and_forget.updated_to":"{username} updated the channel header to: {new}","api.channel.remove_member.removed":"{removedUsername} was removed from the channel","api.team.add_member.added":"{addedUsername} added to the team by {username}","api.team.join_team.post_and_forget":"{username} joined the team.","api.team.leave.left":"{username} left the team.","api.team.remove_user_from_team.removed":"{removedUsername} was removed from the team.","app.channel.post_update_channel_purpose_message.removed":"{username} removed the channel purpose (was: {old})","app.channel.post_update_channel_purpose_message.updated_from":"{username} updated the channel purpose from: {old} to: {new}","app.channel.post_update_channel_purpose_message.updated_to":"{username} updated the channel purpose to: {new}","audit_table.accountActive":"Account activated","audit_table.accountInactive":"Account deactivated","audit_table.action":"Action","audit_table.attemptedAllowOAuthAccess":"Attempted to allow a new OAuth service access","audit_table.attemptedLicenseAdd":"Attempted to add new license","audit_table.attemptedLogin":"Attempted to login","audit_table.attemptedOAuthToken":"Attempted to get an OAuth access token","audit_table.attemptedPassword":"Attempted to change password","audit_table.attemptedRegisterApp":"Attempted to register a new OAuth Application with ID {id}","audit_table.attemptedReset":"Attempted to reset password","audit_table.attemptedWebhookCreate":"Attempted to create a webhook","audit_table.attemptedWebhookDelete":"Attempted to delete a webhook","audit_table.authenticated":"Successfully authenticated","audit_table.by":" by {username}","audit_table.byAdmin":" by an admin","audit_table.channelCreated":"Created the {channelName} channel","audit_table.channelDeleted":"Deleted the channel with the URL {url}","audit_table.establishedDM":"Established a direct message channel with {username}","audit_table.failedExpiredLicenseAdd":"Failed to add a new license as it has either expired or not yet been started","audit_table.failedInvalidLicenseAdd":"Failed to add an invalid license","audit_table.failedLogin":"FAILED login attempt","audit_table.failedOAuthAccess":"Failed to allow a new OAuth service access - the redirect URI did not match the previously registered callback","audit_table.failedPassword":"Failed to change password - tried to update user password who was logged in through OAuth","audit_table.failedWebhookCreate":"Failed to create a webhook - bad channel permissions","audit_table.failedWebhookDelete":"Failed to delete a webhook - inappropriate conditions","audit_table.headerUpdated":"Updated the {channelName} channel header","audit_table.ip":"IP Address","audit_table.licenseRemoved":"Successfully removed a license","audit_table.loginAttempt":" (Login attempt)","audit_table.loginFailure":" (Login failure)","audit_table.logout":"Logged out of your account","audit_table.member":"member","audit_table.nameUpdated":"Updated the {channelName} channel name","audit_table.oauthTokenFailed":"Failed to get an OAuth access token - {token}","audit_table.revokedAll":"Revoked all current sessions for the team","audit_table.sentEmail":"Sent an email to {email} to reset your password","audit_table.session":"Session ID","audit_table.sessionRevoked":"The session with id {sessionId} was revoked","audit_table.successfullLicenseAdd":"Successfully added new license","audit_table.successfullLogin":"Successfully logged in","audit_table.successfullOAuthAccess":"Successfully gave a new OAuth service access","audit_table.successfullOAuthToken":"Successfully added a new OAuth service","audit_table.successfullPassword":"Successfully changed password","audit_table.successfullReset":"Successfully reset password","audit_table.successfullWebhookCreate":"Successfully created a webhook","audit_table.successfullWebhookDelete":"Successfully deleted a webhook","audit_table.timestamp":"Timestamp","audit_table.updateGeneral":"Updated the general settings of your account","audit_table.updateGlobalNotifications":"Updated your global notification settings","audit_table.updatePicture":"Updated your profile picture","audit_table.updatedRol":"Updated user role(s) to ","audit_table.userAdded":"Added {username} to the {channelName} channel","audit_table.userId":"User ID","audit_table.userRemoved":"Removed {username} to the {channelName} channel","audit_table.verified":"Successfully verified your email address","authorize.access":"Allow <strong>{appName}</strong> access?","authorize.allow":"Allow","authorize.app":"The app <strong>{appName}</strong> would like the ability to access and modify your basic information.","authorize.deny":"Deny","authorize.title":"<strong>{appName}</strong> would like to connect to your <strong>Mattermost</strong> user account","backstage_list.search":"Search","backstage_navbar.backToMattermost":"Back to {siteName}","backstage_sidebar.emoji":"Custom Emoji","backstage_sidebar.integrations":"Integrations","backstage_sidebar.integrations.commands":"Slash Commands","backstage_sidebar.integrations.incoming_webhooks":"Incoming Webhooks","backstage_sidebar.integrations.oauthApps":"OAuth 2.0 Applications","backstage_sidebar.integrations.outgoing_webhooks":"Outgoing Webhooks","calling_screen":"Calling","center_panel.recent":"Click here to jump to recent messages. ","change_url.close":"Close","change_url.endWithLetter":"URL must end with a letter or number.","change_url.invalidUrl":"Invalid URL","change_url.longer":"URL must be two or more characters.","change_url.noUnderscore":"URL can not contain two underscores in a row.","change_url.startWithLetter":"URL must start with a letter or number.","change_url.urlLabel":"Channel URL","channelHeader.addToFavorites":"Add to Favorites","channelHeader.removeFromFavorites":"Remove from Favorites","channelHeader.unmute":"Unmute","channel_flow.alreadyExist":"A channel with that URL already exists","channel_flow.changeUrlDescription":"Some characters are not allowed in URLs and may be removed.","channel_flow.changeUrlTitle":"Change Channel URL","channel_flow.create":"Create Channel","channel_flow.handleTooShort":"Channel URL must be 2 or more lowercase alphanumeric characters","channel_flow.invalidName":"Invalid Channel Name","channel_flow.set_url_title":"Set Channel URL","channel_header.addChannelHeader":"Add a channel description","channel_header.addMembers":"Add Members","channel_header.addToFavorites":"Add to Favorites","channel_header.channelHeader":"Edit Channel Header","channel_header.channelMembers":"Members","channel_header.delete":"Delete Channel","channel_header.directchannel.you":"{displayname} (you) ","channel_header.flagged":"Flagged Posts","channel_header.leave":"Leave Channel","channel_header.manageMembers":"Manage Members","channel_header.notificationPreferences":"Notification Preferences","channel_header.pinnedPosts":"Pinned Posts","channel_header.recentMentions":"Recent Mentions","channel_header.removeFromFavorites":"Remove from Favorites","channel_header.rename":"Rename Channel","channel_header.search":"Search","channel_header.setHeader":"Edit Channel Header","channel_header.setPurpose":"Edit Channel Purpose","channel_header.viewInfo":"View Info","channel_header.viewMembers":"View Members","channel_header.webrtc.call":"Start Video Call","channel_header.webrtc.doNotDisturb":"Do not disturb","channel_header.webrtc.offline":"The user is offline","channel_header.webrtc.unavailable":"New call unavailable until your existing call ends","channel_info.about":"About","channel_info.close":"Close","channel_info.header":"Header:","channel_info.id":"ID: ","channel_info.name":"Name:","channel_info.notFound":"No Channel Found","channel_info.purpose":"Purpose:","channel_info.url":"URL:","channel_invite.add":" Add","channel_invite.addNewMembers":"Add New Members to ","channel_invite.close":"Close","channel_loader.connection_error":"There appears to be a problem with your internet connection.","channel_loader.posted":"Posted","channel_loader.postedImage":" posted an image","channel_loader.socketError":"Please check connection, Mattermost unreachable. If issue persists, ask administrator to <a href=\"https://about.mattermost.com/default-websocket-port-help\" target=\"_blank\">check WebSocket port</a>.","channel_loader.someone":"Someone","channel_loader.something":" did something new","channel_loader.unknown_error":"We received an unexpected status code from the server.","channel_loader.uploadedFile":" uploaded a file","channel_loader.uploadedImage":" uploaded an image","channel_loader.wrote":" wrote: ","channel_members_dropdown.channel_admin":"Channel Admin","channel_members_dropdown.channel_member":"Channel Member","channel_members_dropdown.make_channel_admin":"Make Channel Admin","channel_members_dropdown.make_channel_member":"Make Channel Member","channel_members_dropdown.remove_from_channel":"Remove From Channel","channel_members_dropdown.remove_member":"Remove Member","channel_members_modal.addNew":" Add New Members","channel_members_modal.members":" Members","channel_members_modal.remove":"Remove","channel_modal.cancel":"Cancel","channel_modal.createNew":"Create New Channel","channel_modal.descriptionHelp":"Describe how this channel should be used.","channel_modal.displayNameError":"Channel name must be 2 or more characters","channel_modal.edit":"Edit","channel_modal.header":"Header","channel_modal.headerEx":"E.g.: \"[Link Title](http://example.com)\"","channel_modal.headerHelp":"Set text that will appear in the header of the channel beside the channel name. For example, include frequently used links by typing [Link Title](http://example.com).","channel_modal.modalTitle":"New Channel","channel_modal.name":"Name","channel_modal.nameEx":"E.g.: \"Bugs\", \"Marketing\", \"客户支持\"","channel_modal.optional":"(optional)","channel_modal.privateGroup1":"Create a new private channel with restricted membership. ","channel_modal.privateGroup2":"Create a private channel","channel_modal.publicChannel1":"Create a public channel","channel_modal.publicChannel2":"Create a new public channel anyone can join. ","channel_modal.purpose":"Purpose","channel_modal.purposeEx":"E.g.: \"A channel to file bugs and improvements\"","channel_notifications.allActivity":"For all activity","channel_notifications.globalDefault":"Global default ({notifyLevel})","channel_notifications.muteChannel.help":"Muting turns off desktop, email and push notifications for this channel. The channel will not be marked as unread unless you're mentioned.","channel_notifications.muteChannel.off.desc":"The channel is not muted","channel_notifications.muteChannel.off.title":"Off","channel_notifications.muteChannel.on.desc":"The channel is muted","channel_notifications.muteChannel.on.title":"On","channel_notifications.muteChannel.settings":"Mute channel","channel_notifications.never":"Never","channel_notifications.onlyMentions":"Only for mentions","channel_notifications.override":"Selecting an option other than \"Default\" will override the global notification settings. Desktop notifications are available on Firefox, Safari, and Chrome.","channel_notifications.overridePush":"Selecting an option other than \"Global default\" will override the global notification settings for mobile push notifications in account settings. Push notifications must be enabled by the System Admin.","channel_notifications.preferences":"Notification Preferences for ","channel_notifications.push":"Send mobile push notifications","channel_notifications.sendDesktop":"Send desktop notifications","channel_select.placeholder":"--- Select a channel ---","channel_switch_modal.deactivated":"Deactivated","channel_switch_modal.dm":"(Direct Message)","channel_switch_modal.failed_to_open":"Failed to open channel.","channel_switch_modal.not_found":"No matches found.","channel_switch_modal.submit":"Switch","channel_switch_modal.title":"Switch Channels","claim.account.noEmail":"No email specified","claim.email_to_ldap.enterLdapPwd":"Enter the ID and password for your AD/LDAP account","claim.email_to_ldap.enterPwd":"Enter the password for your {site} email account","claim.email_to_ldap.ldapId":"AD/LDAP ID","claim.email_to_ldap.ldapIdError":"Please enter your AD/LDAP ID.","claim.email_to_ldap.ldapPasswordError":"Please enter your AD/LDAP password.","claim.email_to_ldap.ldapPwd":"AD/LDAP Password","claim.email_to_ldap.pwd":"Password","claim.email_to_ldap.pwdError":"Please enter your password.","claim.email_to_ldap.ssoNote":"You must already have a valid AD/LDAP account","claim.email_to_ldap.ssoType":"Upon claiming your account, you will only be able to login with AD/LDAP","claim.email_to_ldap.switchTo":"Switch account to AD/LDAP","claim.email_to_ldap.title":"Switch Email/Password Account to AD/LDAP","claim.email_to_oauth.enterPwd":"Enter the password for your {site} account","claim.email_to_oauth.pwd":"Password","claim.email_to_oauth.pwdError":"Please enter your password.","claim.email_to_oauth.ssoNote":"You must already have a valid {type} account","claim.email_to_oauth.ssoType":"Upon claiming your account, you will only be able to login with {type} SSO","claim.email_to_oauth.switchTo":"Switch account to {uiType}","claim.email_to_oauth.title":"Switch Email/Password Account to {uiType}","claim.ldap_to_email.confirm":"Confirm Password","claim.ldap_to_email.email":"After switching your authentication method, you will use {email} to login. Your AD/LDAP credentials will no longer allow access to Mattermost.","claim.ldap_to_email.enterLdapPwd":"{ldapPassword}:","claim.ldap_to_email.enterPwd":"New email login password:","claim.ldap_to_email.ldapPasswordError":"Please enter your AD/LDAP password.","claim.ldap_to_email.ldapPwd":"AD/LDAP Password","claim.ldap_to_email.pwd":"Password","claim.ldap_to_email.pwdError":"Please enter your password.","claim.ldap_to_email.pwdNotMatch":"Passwords do not match.","claim.ldap_to_email.switchTo":"Switch account to email/password","claim.ldap_to_email.title":"Switch AD/LDAP Account to Email/Password","claim.oauth_to_email.confirm":"Confirm Password","claim.oauth_to_email.description":"Upon changing your account type, you will only be able to login with your email and password.","claim.oauth_to_email.enterNewPwd":"Enter a new password for your {site} email account","claim.oauth_to_email.enterPwd":"Please enter a password.","claim.oauth_to_email.newPwd":"New Password","claim.oauth_to_email.pwdNotMatch":"Password do not match.","claim.oauth_to_email.switchTo":"Switch {type} to email and password","claim.oauth_to_email.title":"Switch {type} Account to Email","confirm_modal.cancel":"Cancel","connecting_screen":"Connecting","copy_url_context_menu.getChannelLink":"Copy Link","create_comment.addComment":"Add a comment...","create_comment.comment":"Add Comment","create_comment.commentLength":"Comment length must be less than {max} characters.","create_comment.commentTitle":"Comment","create_comment.file":"File uploading","create_comment.files":"Files uploading","create_post.comment":"Comment","create_post.deactivated":"You are viewing an archived channel with a deactivated user.","create_post.error_message":"Your message is too long. Character count: {length}/{limit}","create_post.post":"Post","create_post.read_only":"This channel is read-only. Only members with permission can post here.","create_post.shortcutsNotSupported":"Keyboard shortcuts are not supported on your device.","create_post.tutorialTip":"<h4>Sending Messages</h4><p>Type here to write a message and press <strong>ENTER</strong> to post it.</p><p>Click the <strong>Attachment</strong> button to upload an image or a file.</p>","create_post.write":"Write a message...","create_team.agreement":"By proceeding to create your account and use {siteName}, you agree to our <a href={TermsOfServiceLink}>Terms of Service</a> and <a href={PrivacyPolicyLink}>Privacy Policy</a>. If you do not agree, you cannot use {siteName}.","create_team.display_name.charLength":"Name must be {min} or more characters up to a maximum of {max}. You can add a longer team description later.","create_team.display_name.nameHelp":"Name your team in any language. Your team name shows in menus and headings.","create_team.display_name.next":"Next","create_team.display_name.required":"This field is required","create_team.display_name.teamName":"Team Name","create_team.team_url.back":"Back to previous step","create_team.team_url.charLength":"Name must be {min} or more characters up to a maximum of {max}","create_team.team_url.creatingTeam":"Creating team...","create_team.team_url.finish":"Finish","create_team.team_url.hint":"<li>Short and memorable is best</li><li>Use lowercase letters, numbers and dashes</li><li>Must start with a letter and can't end in a dash</li>","create_team.team_url.regex":"Use only lower case letters, numbers and dashes. Must start with a letter and can't end in a dash.","create_team.team_url.required":"This field is required","create_team.team_url.taken":"This URL <a href=\"https://docs.mattermost.com/help/getting-started/creating-teams.html#team-url\" target=\"_blank\">starts with a reserved word</a> or is unavailable. Please try another.","create_team.team_url.teamUrl":"Team URL","create_team.team_url.unavailable":"This URL is taken or unavailable. Please try another.","create_team.team_url.webAddress":"Choose the web address of your new team:","custom_emoji.empty":"No custom emoji found","custom_emoji.header":"Custom Emoji","custom_emoji.search":"Search Custom Emoji","deactivate_member_modal.cancel":"Cancel","deactivate_member_modal.deactivate":"Deactivate","deactivate_member_modal.desc":"This action deactivates {username}. They will be logged out and not have access to any teams or channels on this system. Are you sure you want to deactivate {username}?","deactivate_member_modal.sso_warning":"You must also deactivate this user in the SSO provider or they will be reactivated on next login or sync.","deactivate_member_modal.title":"Deactivate {username}","default_channel.purpose":"Post messages here that you want everyone to see. Everyone automatically becomes a permanent member of this channel when they join the team.","delete_channel.cancel":"Cancel","delete_channel.confirm":"Confirm DELETE Channel","delete_channel.del":"Delete","delete_channel.question":"This will delete the channel from the team and make its contents inaccessible for all users. <br /><br />Are you sure you wish to delete the <strong>{display_name}</strong> channel?","delete_post.cancel":"Cancel","delete_post.comment":"Comment","delete_post.confirm":"Confirm {term} Delete","delete_post.del":"Delete","delete_post.post":"Post","delete_post.question":"Are you sure you want to delete this {term}?","delete_post.warning":"This post has {count, number} {count, plural, one {comment} other {comments}} on it.","discard_changes_modal.leave":"Yes, Discard","discard_changes_modal.message":"You have unsaved changes, are you sure you want to discard them?","discard_changes_modal.title":"Discard Changes?","edit_channel_header.editHeader":"Edit the Channel Header...","edit_channel_header.previewHeader":"Edit header","edit_channel_header_modal.cancel":"Cancel","edit_channel_header_modal.description":"Edit the text appearing next to the channel name in the channel header.","edit_channel_header_modal.error":"This channel header is too long, please enter a shorter one","edit_channel_header_modal.save":"Save","edit_channel_header_modal.title":"Edit Header for {channel}","edit_channel_header_modal.title_dm":"Edit Header","edit_channel_private_purpose_modal.body":"This text appears in the \"View Info\" modal of the private channel.","edit_channel_purpose_modal.body":"Describe how this channel should be used. This text appears in the channel list in the \"More...\" menu and helps others decide whether to join.","edit_channel_purpose_modal.cancel":"Cancel","edit_channel_purpose_modal.error":"This channel purpose is too long, please enter a shorter one","edit_channel_purpose_modal.save":"Save","edit_channel_purpose_modal.title1":"Edit Purpose","edit_channel_purpose_modal.title2":"Edit Purpose for ","edit_command.save":"Update","edit_post.cancel":"Cancel","edit_post.edit":"Edit {title}","edit_post.editPost":"Edit the post...","edit_post.save":"Save","email_signup.address":"Email Address","email_signup.createTeam":"Create Team","email_signup.emailError":"Please enter a valid email address.","email_signup.find":"Find my teams","email_verify.almost":"{siteName}: You are almost done","email_verify.failed":" Failed to send verification email.","email_verify.notVerifiedBody":"Please verify your email address. Check your inbox for an email.","email_verify.resend":"Resend Email","email_verify.sent":" Verification email sent.","email_verify.verified":"{siteName} Email Verified","email_verify.verifiedBody":"<p>Your email has been verified! Click <a href={url}>here</a> to log in.</p>","emoji_list.actions":"Actions","emoji_list.add":"Add Custom Emoji","emoji_list.creator":"Creator","emoji_list.delete":"Delete","emoji_list.delete.confirm.button":"Delete","emoji_list.delete.confirm.msg":"This action permanently deletes the custom emoji. Are you sure you want to delete it?","emoji_list.delete.confirm.title":"Delete Custom Emoji","emoji_list.empty":"No Custom Emoji Found","emoji_list.header":"Custom Emoji","emoji_list.help":"Custom emoji are available to everyone on your server. Type ':' followed by two characters in a message box to bring up the emoji selection menu.","emoji_list.help2":"Tip: If you add #, ##, or ### as the first character on a new line containing emoji, you can use larger sized emoji. To try it out, send a message such as: '# :smile:'.","emoji_list.image":"Image","emoji_list.name":"Name","emoji_list.search":"Search Custom Emoji","emoji_list.somebody":"Somebody on another team","emoji_picker.activity":"Activity","emoji_picker.custom":"Custom","emoji_picker.emojiPicker":"Emoji Picker","emoji_picker.flags":"Flags","emoji_picker.foods":"Foods","emoji_picker.nature":"Nature","emoji_picker.objects":"Objects","emoji_picker.people":"People","emoji_picker.places":"Places","emoji_picker.recent":"Recently Used","emoji_picker.search":"Search","emoji_picker.searchResults":"Search Results","emoji_picker.symbols":"Symbols","error.generic.link":"Back to {siteName}","error.generic.link_message":"Back to {siteName}","error.generic.message":"An error has occurred.","error.generic.title":"Error","error.local_storage.help1":"Enable cookies","error.local_storage.help2":"Turn off private browsing","error.local_storage.help3":"Use a supported browser (IE 11, Chrome 43+, Firefox 52+, Safari 9, Edge 40+)","error.local_storage.message":"Mattermost was unable to load because a setting in your browser prevents the use of its local storage features. To allow Mattermost to load, try the following actions:","error.local_storage.title":"Cannot Load Mattermost","error.not_found.link_message":"Back to Mattermost","error.not_found.message":"The page you were trying to reach does not exist","error.not_found.title":"Page not found","error.oauth_missing_code":"The service provider {service} did not provide an authorization code in the redirect URL.","error.oauth_missing_code.forum":"If you reviewed the above and are still having trouble with configuration, you may post in our {link} where we'll be happy to help with issues during setup.","error.oauth_missing_code.forum.link":"Troubleshooting forum","error.oauth_missing_code.gitlab":"For {link} please make sure you followed the setup instructions.","error.oauth_missing_code.gitlab.link":"GitLab","error.oauth_missing_code.google":"For {link} make sure your administrator enabled the Google+ API.","error.oauth_missing_code.google.link":"Google Apps","error.oauth_missing_code.office365":"For {link} make sure the administrator of your Microsoft organization has enabled the Mattermost app.","error.oauth_missing_code.office365.link":"Office 365","error.oauth_missing_code.title":"Mattermost needs your help","error_bar.apiv3_enabled":"API version 3 is deprecated and scheduled for removal. <a href=\"https://api.mattermost.com/#tag/APIv3-Deprecation\" target=\"_blank\">Learn how to migrate to APIv4</a>.","error_bar.expired":"Enterprise license is expired and some features may be disabled. <a href='{link}' target='_blank'>Please renew</a>.","error_bar.expiring":"Enterprise license expires on {date}. <a href='{link}' target='_blank'>Please renew</a>.","error_bar.past_grace":"Enterprise license is expired and some features may be disabled. Please contact your System Administrator for details.","error_bar.preview_mode":"Preview Mode: Email notifications have not been configured","error_bar.site_url":"Please configure your {docsLink} in the {link}.","error_bar.site_url.docsLink":"Site URL","error_bar.site_url.link":"System Console","error_bar.site_url_gitlab":"Please configure your {docsLink} in the System Console or in gitlab.rb if you're using GitLab Mattermost.","file_attachment.download":"Download","file_info_preview.size":"Size ","file_info_preview.type":"File type ","file_upload.disabled":"File attachments are disabled.","file_upload.fileAbove":"File above {max}MB cannot be uploaded: {filename}","file_upload.filesAbove":"Files above {max}MB cannot be uploaded: {filenames}","file_upload.limited":"Uploads limited to {count, number} files maximum. Please use additional posts for more files.","file_upload.pasted":"Image Pasted at ","file_upload.zeroBytesFile":"You are uploading an empty file: {filename}","file_upload.zeroBytesFiles":"You are uploading empty files: {filenames}","filtered_channels_list.search":"Search channels","filtered_user_list.any_team":"All Users","filtered_user_list.count":"{count, number} {count, plural, one {member} other {members}}","filtered_user_list.countTotal":"{count, number} {count, plural, one {member} other {members}} of {total, number} total","filtered_user_list.countTotalPage":"{startCount, number} - {endCount, number} {count, plural, one {member} other {members}} of {total, number} total","filtered_user_list.member":"Member","filtered_user_list.next":"Next","filtered_user_list.prev":"Previous","filtered_user_list.search":"Search users","filtered_user_list.searchButton":"Search","filtered_user_list.show":"Filter:","filtered_user_list.team_only":"Members of this Team","find_team.email":"Email","find_team.findDescription":"An email was sent with links to any teams to which you are a member.","find_team.findTitle":"Find Your Team","find_team.getLinks":"Get an email with links to any teams to which you are a member.","find_team.placeholder":"you@domain.com","find_team.send":"Send","find_team.submitError":"Please enter a valid email address","flag_post.flag":"Flag for follow up","flag_post.unflag":"Unflag","general_tab.chooseDescription":"Please choose a new description for your team","general_tab.codeDesc":"Click 'Edit' to regenerate Invite Code.","general_tab.codeLongDesc":"The Invite Code is used as part of the URL in the team invitation link created by {getTeamInviteLink} in the main menu. Regenerating creates a new team invitation link and invalidates the previous link.","general_tab.codeTitle":"Invite Code","general_tab.emptyDescription":"Click 'Edit' to add a team description.","general_tab.getTeamInviteLink":"Get Team Invite Link","general_tab.includeDirDesc":"Including this team will display the team name from the Team Directory section of the Home Page, and provide a link to the sign-in page.","general_tab.no":"No","general_tab.openInviteDesc":"When allowed, a link to this team will be included on the landing page allowing anyone with an account to join this team.","general_tab.openInviteTitle":"Allow any user with an account on this server to join this team","general_tab.regenerate":"Regenerate","general_tab.required":"This field is required","general_tab.teamDescription":"Team Description","general_tab.teamDescriptionInfo":"Team description provides additional information to help users select the right team. Maximum of 50 characters.","general_tab.teamIcon":"Team Icon","general_tab.teamIconEditHint":"Click 'Edit' to upload an image.","general_tab.teamIconEditHintMobile":"Click to upload an image.","general_tab.teamIconError":"An error occured while selecting the image.","general_tab.teamIconInvalidFileType":"Only BMP, JPG or PNG images may be used for team icons","general_tab.teamIconLastUpdated":"Image last updated {date}","general_tab.teamIconTooLarge":"Unable to upload team icon. File is too large.","general_tab.teamName":"Team Name","general_tab.teamNameInfo":"Set the name of the team as it appears on your sign-in screen and at the top of the left-hand sidebar.","general_tab.teamNameRestrictions":"Team Name must be {min} or more characters up to a maximum of {max}. You can add a longer team description.","general_tab.title":"General Settings","general_tab.yes":"Yes","get_app.alreadyHaveIt":"Already have it?","get_app.androidAppName":"Mattermost for Android","get_app.androidHeader":"Mattermost works best if you switch to our Android app","get_app.continue":"continue","get_app.continueWithBrowser":"Or {link}","get_app.continueWithBrowserLink":"continue with browser","get_app.iosHeader":"Mattermost works best if you switch to our iPhone app","get_app.mattermostInc":"Mattermost, Inc","get_app.openMattermost":"Open Mattermost","get_link.clipboard":" Link copied","get_link.close":"Close","get_link.copy":"Copy Link","get_post_link_modal.help":"The link below allows authorized users to see your post.","get_post_link_modal.title":"Copy Permalink","get_public_link_modal.help":"The link below allows anyone to see this file without being registered on this server.","get_public_link_modal.title":"Copy Public Link","get_team_invite_link_modal.help":"Send teammates the link below for them to sign-up to this team site. The Team Invite Link can be shared with multiple teammates as it does not change unless it's regenerated in Team Settings by a Team Admin.","get_team_invite_link_modal.helpDisabled":"User creation has been disabled for your team. Please ask your Team Administrator for details.","get_team_invite_link_modal.title":"Team Invite Link","help.attaching.downloading":"#### Downloading Files\nDownload an attached file by clicking the download icon next to the file thumbnail or by opening the file previewer and clicking **Download**.","help.attaching.dragdrop":"#### Drag and Drop\nUpload a file or selection of files by dragging the files from your computer into the right-hand sidebar or center pane. Dragging and dropping attaches the files to the message input box, then you can optionally type a message and press **ENTER** to post.","help.attaching.icon":"#### Attachment Icon\nAlternatively, upload files by clicking the grey paperclip icon inside the message input box. This opens up your system file viewer where you can navigate to the desired files and then click **Open** to upload the files to the message input box. Optionally type a message and then press **ENTER** to post.","help.attaching.limitations":"## File Size Limitations\nMattermost supports a maximum of five attached files per post, each with a maximum file size of 50Mb.","help.attaching.methods":"## Attachment Methods\nAttach a file by drag and drop or by clicking the attachment icon in the message input box.","help.attaching.notSupported":"Document preview (Word, Excel, PPT) is not yet supported.","help.attaching.pasting":"#### Pasting Images\nOn Chrome and Edge browsers, it is also possible to upload files by pasting them from the clipboard. This is not yet supported on other browsers.","help.attaching.previewer":"## File Previewer\nMattermost has a built in file previewer that is used to view media, download files and share public links. Click the thumbnail of an attached file to open it in the file previewer.","help.attaching.publicLinks":"#### Sharing Public Links\nPublic links allow you to share file attachments with people outside your Mattermost team. Open the file previewer by clicking on the thumbnail of an attachment, then click **Get Public Link**. This opens a dialog box with a link to copy. When the link is shared and opened by another user, the file will automatically download.","help.attaching.publicLinks2":"If **Get Public Link** is not visible in the file previewer and you prefer the feature enabled, you can request that your System Admin enable the feature from the System Console under **Security** > **Public Links**.","help.attaching.supported":"#### Supported Media Types\nIf you are trying to preview a media type that is not supported, the file previewer will open a standard media attachment icon. Supported media formats depend heavily on your browser and operating system, but the following formats are supported by Mattermost on most browsers:","help.attaching.supportedList":"- Images: BMP, GIF, JPG, JPEG, PNG\n- Video: MP4\n- Audio: MP3, M4A\n- Documents: PDF","help.attaching.title":"# Attaching Files\n_____","help.commands.builtin":"## Built-in Commands\nThe following slash commands are available on all Mattermost installations:","help.commands.builtin2":"Begin by typing `/` and a list of slash command options appears above the text input box. The autocomplete suggestions help by providing a format example in black text and a short description of the slash command in grey text.","help.commands.custom":"## Custom Commands\nCustom slash commands integrate with external applications. For example, a team might configure a custom slash command to check internal health records with `/patient joe smith` or check the weekly weather forecast in a city with `/weather toronto week`. Check with your System Admin or open the autocomplete list by typing `/` to determine if your team configured any custom slash commands.","help.commands.custom2":"Custom slash commands are disabled by default and can be enabled by the System Admin in the **System Console** > **Integrations** > **Webhooks and Commands**. Learn about configuring custom slash commands on the [developer slash command documentation page](http://docs.mattermost.com/developer/slash-commands.html).","help.commands.intro":"Slash commands perform operations in Mattermost by typing into the text input box. Enter a `/` followed by a command and some arguments to perform actions.\n\nBuilt-in slash commands come with all Mattermost installations and custom slash commands are configurable to interact with external applications. Learn about configuring custom slash commands on the [developer slash command documentation page](http://docs.mattermost.com/developer/slash-commands.html).","help.commands.title":"# Executing Commands\n___","help.composing.deleting":"## Deleting a message\nDelete a message by clicking the **[...]** icon next to any message text that you’ve composed, then click **Delete**. System and Team Admins can delete any message on their system or team.","help.composing.editing":"## Editing a Message\nEdit a message by clicking the **[...]** icon next to any message text that you’ve composed, then click **Edit**. After making modifications to the message text, press **ENTER** to save the modifications. Message edits do not trigger new @mention notifications, desktop notifications or notification sounds.","help.composing.linking":"## Linking to a message\nThe **Permalink** feature creates a link to any message. Sharing this link with other users in the channel lets them view the linked message in the Message Archives. Users who are not a member of the channel where the message was posted cannot view the permalink. Get the permalink to any message by clicking the **[...]** icon next to the message text > **Permalink** > **Copy Link**.","help.composing.posting":"## Posting a Message\nWrite a message by typing into the text input box, then press ENTER to send it. Use SHIFT+ENTER to create a new line without sending a message. To send messages by pressing CTRL+ENTER go to **Main Menu > Account Settings > Send messages on CTRL+ENTER**.","help.composing.posts":"#### Posts\nPosts can be considered parent messages. They are the messages that often start a thread of replies. Posts are composed and sent from the text input box at the bottom of the center pane.","help.composing.replies":"#### Replies\nReply to a message by clicking the reply icon next to any message text. This action opens the right-hand sidebar where you can see the message thread, then compose and send your reply. Replies are indented slightly in the center pane to indicate that they are child messages of a parent post.\n\nWhen composing a reply in the right-hand side, click the expand/collapse icon with two arrows at the top of the sidebar to make things easier to read.","help.composing.title":"# Sending Messages\n_____","help.composing.types":"## Message Types\nReply to posts to keep conversations organized in threads.","help.formatting.checklist":"Make a task list by including square brackets:","help.formatting.checklistExample":"- [ ] Item one\n- [ ] Item two\n- [x] Completed item","help.formatting.code":"## Code Block\n\nCreate a code block by indenting each line by four spaces, or by placing ``` on the line above and below your code.","help.formatting.codeBlock":"Code block","help.formatting.emojiExample":":smile: :+1: :sheep:","help.formatting.emojis":"## Emojis\n\nOpen the emoji autocomplete by typing `:`. A full list of emojis can be found [here](http://www.emoji-cheat-sheet.com/). It is also possible to create your own [Custom Emoji](http://docs.mattermost.com/help/settings/custom-emoji.html) if the emoji you want to use doesn't exist.","help.formatting.example":"Example:","help.formatting.githubTheme":"**GitHub Theme**","help.formatting.headings":"## Headings\n\nMake a heading by typing # and a space before your title. For smaller headings, use more #’s.","help.formatting.headings2":"Alternatively, you can underline the text using `===` or `---` to create headings.","help.formatting.headings2Example":"Large Heading\n-------------","help.formatting.headingsExample":"## Large Heading\n### Smaller Heading\n#### Even Smaller Heading","help.formatting.images":"## In-line Images\n\nCreate in-line images using an `!` followed by the alt text in square brackets and the link in normal brackets. Add hover text by placing it in quotes after the link.","help.formatting.imagesExample":"![alt text](link \"hover text\")\n\nand\n\n[![Build Status](https://travis-ci.org/mattermost/platform.svg?branch=master)](https://travis-ci.org/mattermost/platform) [![Github](https://assets-cdn.github.com/favicon.ico)](https://github.com/mattermost/platform)","help.formatting.inline":"## In-line Code\n\nCreate in-line monospaced font by surrounding it with backticks.","help.formatting.intro":"Markdown makes it easy to format messages. Type a message as you normally would, and use these rules to render it with special formatting.","help.formatting.lines":"## Lines\n\nCreate a line by using three `*`, `_`, or `-`.","help.formatting.linkEx":"[Check out Mattermost!](https://about.mattermost.com/)","help.formatting.links":"## Links\n\nCreate labeled links by putting the desired text in square brackets and the associated link in normal brackets.","help.formatting.listExample":"* list item one\n* list item two\n    * item two sub-point","help.formatting.lists":"## Lists\n\nCreate a list by using `*` or `-` as bullets. Indent a bullet point by adding two spaces in front of it.","help.formatting.monokaiTheme":"**Monokai Theme**","help.formatting.ordered":"Make it an ordered list by using numbers instead:","help.formatting.orderedExample":"1. Item one\n2. Item two","help.formatting.quotes":"## Block quotes\n\nCreate block quotes using `>`.","help.formatting.quotesExample":"`> block quotes` renders as:","help.formatting.quotesRender":"> block quotes","help.formatting.renders":"Renders as:","help.formatting.solirizedDarkTheme":"**Solarized Dark Theme**","help.formatting.solirizedLightTheme":"**Solarized Light Theme**","help.formatting.style":"## Text Style\n\nYou can use either `_` or `*` around a word to make it italic. Use two to make it bold.\n\n* `_italics_` renders as _italics_\n* `**bold**` renders as **bold**\n* `**_bold-italic_**` renders as **_bold-italics_**\n* `~~strikethrough~~` renders as ~~strikethrough~~","help.formatting.supportedSyntax":"Supported languages are:\n`as`, `applescript`, `osascript`, `scpt`, `bash`, `sh`, `zsh`, `clj`, `boot`, `cl2`, `cljc`, `cljs`, `cljs.hl`, `cljscm`, `cljx`, `hic`, `coffee`, `_coffee`, `cake`, `cjsx`, `cson`, `iced`, `cpp`, `c`, `cc`, `h`, `c++`, `h++`, `hpp`, `cs`, `csharp`, `css`, `d`, `di`, `dart`, `delphi`, `dpr`, `dfm`, `pas`, `pascal`, `freepascal`, `lazarus`, `lpr`, `lfm`, `diff`, `django`, `jinja`, `dockerfile`, `docker`, `erl`, `f90`, `f95`, `fsharp`, `fs`, `gcode`, `nc`, `go`, `groovy`, `handlebars`, `hbs`, `html.hbs`, `html.handlebars`, `hs`, `hx`, `java`, `jsp`, `js`, `jsx`, `json`, `jl`, `kt`, `ktm`, `kts`, `less`, `lisp`, `lua`, `mk`, `mak`, `md`, `mkdown`, `mkd`, `matlab`, `m`, `mm`, `objc`, `obj-c`, `ml`, `perl`, `pl`, `php`, `php3`, `php4`, `php5`, `php6`, `ps`, `ps1`, `pp`, `py`, `gyp`, `r`, `ruby`, `rb`, `gemspec`, `podspec`, `thor`, `irb`, `rs`, `scala`, `scm`, `sld`, `scss`, `st`, `styl`, `sql`, `swift`, `tex`, `vbnet`, `vb`, `bas`, `vbs`, `v`, `veo`, `xml`, `html`, `xhtml`, `rss`, `atom`, `xsl`, `plist`, `yaml`","help.formatting.syntax":"### Syntax Highlighting\n\nTo add syntax highlighting, type the language to be highlighted after the ``` at the beginning of the code block. Mattermost also offers four different code themes (GitHub, Solarized Dark, Solarized Light, Monokai) that can be changed in **Account Settings** > **Display** > **Theme** > **Custom Theme** > **Center Channel Styles**","help.formatting.syntaxEx":"    package main\n    import \"fmt\"\n    func main() {\n        fmt.Println(\"Hello, 世界\")\n    }","help.formatting.tableExample":"| Left-Aligned  | Center Aligned  | Right Aligned |\n| :------------ |:---------------:| -----:|\n| Left column 1 | this text       |  $100 |\n| Left column 2 | is              |   $10 |\n| Left column 3 | centered        |    $1 |","help.formatting.tables":"## Tables\n\nCreate a table by placing a dashed line under the header row and separating the columns with a pipe `|`. (The columns don’t need to line up exactly for it to work). Choose how to align table columns by including colons `:` within the header row.","help.formatting.title":"# Formatting Text\n_____","help.learnMore":"Learn more about:","help.link.attaching":"Attaching Files","help.link.commands":"Executing Commands","help.link.composing":"Composing Messages and Replies","help.link.formatting":"Formatting Messages using Markdown","help.link.mentioning":"Mentioning Teammates","help.link.messaging":"Basic Messaging","help.mentioning.channel":"#### @Channel\nYou can mention an entire channel by typing `@channel`. All members of the channel will receive a mention notification that behaves the same way as if the members had been mentioned personally.","help.mentioning.channelExample":"@channel great work on interviews this week. I think we found some excellent potential candidates!","help.mentioning.mentions":"## @Mentions\nUse @mentions to get the attention of specific team members.","help.mentioning.recent":"## Recent Mentions\nClick `@` next to the search box to query for your most recent @mentions and words that trigger mentions. Click **Jump** next to a search result in the right-hand sidebar to jump the center pane to the channel and location of the message with the mention.","help.mentioning.title":"# Mentioning Teammates\n_____","help.mentioning.triggers":"## Words That Trigger Mentions\nIn addition to being notified by @username and @channel, you can customize words that trigger mention notifications in **Account Settings** > **Notifications** > **Words that trigger mentions**. By default, you will receive mention notifications on your first name, and you can add more words by typing them into the input box separated by commas. This is useful if you want to be notified of all posts on certain topics, for example, \"interviewing\" or \"marketing\".","help.mentioning.username":"#### @Username\nYou can mention a teammate by using the `@` symbol plus their username to send them a mention notification.\n\nType `@` to bring up a list of team members who can be mentioned. To filter the list, type the first few letters of any username, first name, last name, or nickname. The **Up** and **Down** arrow keys can then be used to scroll through entries in the list, and pressing **ENTER** will select which user to mention. Once selected, the username will automatically replace the full name or nickname.\nThe following example sends a special mention notification to **alice** that alerts her of the channel and message where she has been mentioned. If **alice** is away from Mattermost and has [email notifications](http://docs.mattermost.com/help/getting-started/configuring-notifications.html#email-notifications) turned on, then she will receive an email alert of her mention along with the message text.","help.mentioning.usernameCont":"If the user you mentioned does not belong to the channel, a System Message will be posted to let you know. This is a temporary message only seen by the person who triggered it. To add the mentioned user to the channel, go to the dropdown menu beside the channel name and select **Add Members**.","help.mentioning.usernameExample":"@alice how did your interview go with the new candidate?","help.messaging.attach":"**Attach files** by dragging and dropping into Mattermost or clicking the attachment icon in the text input box.","help.messaging.emoji":"**Quickly add emoji** by typing \":\", which will open an emoji autocomplete. If the existing emoji don't cover what you want to express, you can also create your own [Custom Emoji](http://docs.mattermost.com/help/settings/custom-emoji.html).","help.messaging.format":"**Format your messages** using Markdown that supports text styling, headings, links, emoticons, code blocks, block quotes, tables, lists and in-line images.","help.messaging.notify":"**Notify teammates** when they are needed by typing `@username`.","help.messaging.reply":"**Reply to messages** by clicking the reply arrow next to the message text.","help.messaging.title":"# Messaging Basics\n_____","help.messaging.write":"**Write messages** using the text input box at the bottom of Mattermost. Press ENTER to send a message. Use SHIFT+ENTER to create a new line without sending a message.","installed_command.header":"Slash Commands","installed_commands.add":"Add Slash Command","installed_commands.delete.confirm":"This action permanently deletes the slash command and breaks any integrations using it. Are you sure you want to delete it?","installed_commands.empty":"No commands found","installed_commands.header":"Slash Commands","installed_commands.help":"Use slash commands to connect external tools to Mattermost. {buildYourOwn} or visit the {appDirectory} to find self-hosted, third-party apps and integrations.","installed_commands.help.appDirectory":"App Directory","installed_commands.help.buildYourOwn":"Build your own","installed_commands.search":"Search Slash Commands","installed_commands.unnamed_command":"Unnamed Slash Command","installed_incoming_webhooks.add":"Add Incoming Webhook","installed_incoming_webhooks.delete.confirm":"This action permanently deletes the incoming webhook and breaks any integrations using it. Are you sure you want to delete it?","installed_incoming_webhooks.empty":"No incoming webhooks found","installed_incoming_webhooks.header":"Incoming Webhooks","installed_incoming_webhooks.help":"Use incoming webhooks to connect external tools to Mattermost. {buildYourOwn} or visit the {appDirectory} to find self-hosted, third-party apps and integrations.","installed_incoming_webhooks.help.appDirectory":"App Directory","installed_incoming_webhooks.help.buildYourOwn":"Build your own","installed_incoming_webhooks.search":"Search Incoming Webhooks","installed_incoming_webhooks.unknown_channel":"A Private Webhook","installed_integrations.callback_urls":"Callback URLs: {urls}","installed_integrations.client_id":"Client ID: <strong>{clientId}</strong>","installed_integrations.client_secret":"Client Secret: <strong>{clientSecret}</strong>","installed_integrations.content_type":"Content-Type: {contentType}","installed_integrations.creation":"Created by {creator} on {createAt, date, full}","installed_integrations.delete":"Delete","installed_integrations.edit":"Edit","installed_integrations.hideSecret":"Hide Secret","installed_integrations.regenSecret":"Regenerate Secret","installed_integrations.regenToken":"Regenerate Token","installed_integrations.showSecret":"Show Secret","installed_integrations.token":"Token: {token}","installed_integrations.triggerWhen":"Trigger When: {triggerWhen}","installed_integrations.triggerWords":"Trigger Words: {triggerWords}","installed_integrations.unnamed_oauth_app":"Unnamed OAuth 2.0 Application","installed_integrations.url":"URL: {url}","installed_oauth_apps.add":"Add OAuth 2.0 Application","installed_oauth_apps.callbackUrls":"Callback URLs (One Per Line)","installed_oauth_apps.cancel":"Cancel","installed_oauth_apps.delete.confirm":"This action permanently deletes the OAuth 2.0 application and breaks any integrations using it. Are you sure you want to delete it?","installed_oauth_apps.description":"Description","installed_oauth_apps.empty":"No OAuth 2.0 Applications found","installed_oauth_apps.header":"OAuth 2.0 Applications","installed_oauth_apps.help":"Create {oauthApplications} to securely integrate bots and third-party apps with Mattermost. Visit the {appDirectory} to find available self-hosted apps.","installed_oauth_apps.help.appDirectory":"App Directory","installed_oauth_apps.help.oauthApplications":"OAuth 2.0 applications","installed_oauth_apps.homepage":"Homepage","installed_oauth_apps.iconUrl":"Icon URL","installed_oauth_apps.is_trusted":"Is Trusted: <strong>{isTrusted}</strong>","installed_oauth_apps.name":"Display Name","installed_oauth_apps.save":"Save","installed_oauth_apps.search":"Search OAuth 2.0 Applications","installed_oauth_apps.trusted":"Is Trusted","installed_oauth_apps.trusted.no":"No","installed_oauth_apps.trusted.yes":"Yes","installed_outgoing_webhooks.add":"Add Outgoing Webhook","installed_outgoing_webhooks.delete.confirm":"This action permanently deletes the outgoing webhook and breaks any integrations using it. Are you sure you want to delete it?","installed_outgoing_webhooks.empty":"No outgoing webhooks found","installed_outgoing_webhooks.header":"Outgoing Webhooks","installed_outgoing_webhooks.help":"Use outgoing webhooks to connect external tools to Mattermost. {buildYourOwn} or visit the {appDirectory} to find self-hosted, third-party apps and integrations.","installed_outgoing_webhooks.help.appDirectory":"App Directory","installed_outgoing_webhooks.help.buildYourOwn":"Build your own","installed_outgoing_webhooks.search":"Search Outgoing Webhooks","installed_outgoing_webhooks.unknown_channel":"A Private Webhook","integrations.add":"Add","integrations.command.description":"Slash commands send events to external integrations","integrations.command.title":"Slash Command","integrations.delete.confirm.button":"Delete","integrations.delete.confirm.title":"Delete Integration","integrations.done":"Done","integrations.edit":"Edit","integrations.header":"Integrations","integrations.help":"Visit the {appDirectory} to find self-hosted, third-party apps and integrations for Mattermost.","integrations.help.appDirectory":"App Directory","integrations.incomingWebhook.description":"Incoming webhooks allow external integrations to send messages","integrations.incomingWebhook.title":"Incoming Webhook","integrations.oauthApps.description":"OAuth 2.0 allows external applications to make authorized requests to the Mattermost API.","integrations.oauthApps.title":"OAuth 2.0 Applications","integrations.outgoingWebhook.description":"Outgoing webhooks allow external integrations to receive and respond to messages","integrations.outgoingWebhook.title":"Outgoing Webhook","integrations.successful":"Setup Successful","intro_messages.DM":"This is the start of your direct message history with {teammate}.<br />Direct messages and files shared here are not shown to people outside this area.","intro_messages.GM":"This is the start of your group message history with {names}.<br />Messages and files shared here are not shown to people outside this area.","intro_messages.anyMember":" Any member can join and read this channel.","intro_messages.beginning":"Beginning of {name}","intro_messages.channel":"channel","intro_messages.creator":"This is the start of the {name} {type}, created by {creator} on {date}.","intro_messages.default":"<h4 class='channel-intro__title'>Beginning of {display_name}</h4><p class='channel-intro__content'><strong>Welcome to {display_name}!</strong><br/><br/>Post messages here that you want everyone to see. Everyone automatically becomes a permanent member of this channel when they join the team.</p>","intro_messages.group":"private channel","intro_messages.group_message":"This is the start of your group message history with these teammates. Messages and files shared here are not shown to people outside this area.","intro_messages.invite":"Invite others to this {type}","intro_messages.inviteOthers":"Invite others to this team","intro_messages.noCreator":"This is the start of the {name} {type}, created on {date}.","intro_messages.offTopic":"<h4 class=\"channel-intro__title\">Beginning of {display_name}</h4><p class=\"channel-intro__content\">This is the start of {display_name}, a channel for non-work-related conversations.<br/></p>","intro_messages.onlyInvited":" Only invited members can see this private channel.","intro_messages.purpose":" This {type}'s purpose is: {purpose}.","intro_messages.setHeader":"Set a Header","intro_messages.teammate":"This is the start of your direct message history with this teammate. Direct messages and files shared here are not shown to people outside this area.","invite_member.addAnother":"Add another","invite_member.autoJoin":"People invited automatically join the <strong>{channel}</strong> channel.","invite_member.cancel":"Cancel","invite_member.content":"Email is currently disabled for your team, and email invitations cannot be sent. Contact your System Administrator to enable email and email invitations.","invite_member.disabled":"User creation has been disabled for your team. Please ask your Team Administrator for details.","invite_member.emailError":"Please enter a valid email address","invite_member.firstname":"First name","invite_member.inviteLink":"Team Invite Link","invite_member.lastname":"Last name","invite_member.modalButton":"Yes, Discard","invite_member.modalMessage":"You have unsent invitations, are you sure you want to discard them?","invite_member.modalTitle":"Discard Invitations?","invite_member.newMember":"Send Email Invite","invite_member.send":"Send Invitation","invite_member.send2":"Send Invitations","invite_member.sending":" Sending","invite_member.teamInviteLink":"You can also invite people using the {link}.","katex.error":"Couldn't compile your Latex code. Please review the syntax and try again.","ldap_signup.find":"Find my teams","ldap_signup.ldap":"Create team with AD/LDAP Account","ldap_signup.length_error":"Name must be 3 or more characters up to a maximum of 15","ldap_signup.teamName":"Enter name of new team","ldap_signup.team_error":"Please enter a team name","leave_private_channel_modal.leave":"Yes, leave channel","leave_private_channel_modal.message":"Are you sure you wish to leave the private channel {channel}? You must be re-invited in order to re-join this channel in the future.","leave_private_channel_modal.title":"Leave Private Channel {channel}","leave_team_modal.desc":"You will be removed from all public and private channels.  If the team is private you will not be able to rejoin the team.  Are you sure?","leave_team_modal.no":"No","leave_team_modal.title":"Leave the team?","leave_team_modal.yes":"Yes","loading_screen.loading":"Loading","login.changed":" Sign-in method changed successfully","login.create":"Create one now","login.createTeam":"Create a new team","login.createTeamAdminOnly":"This option is only available for System Administrators, and does not show up for other users.","login.email":"Email","login.find":"Find your other teams","login.forgot":"I forgot my password","login.gitlab":"GitLab","login.google":"Google Apps","login.invalidPassword":"Your password is incorrect.","login.ldapUsername":"AD/LDAP Username","login.ldapUsernameLower":"AD/LDAP username","login.noAccount":"Don't have an account? ","login.noEmail":"Please enter your email","login.noEmailLdapUsername":"Please enter your email or {ldapUsername}","login.noEmailUsername":"Please enter your email or username","login.noEmailUsernameLdapUsername":"Please enter your email, username or {ldapUsername}","login.noLdapUsername":"Please enter your {ldapUsername}","login.noMethods":"No sign-in methods are enabled. Please contact your System Administrator.","login.noPassword":"Please enter your password","login.noUsername":"Please enter your username","login.noUsernameLdapUsername":"Please enter your username or {ldapUsername}","login.office365":"Office 365","login.on":"on {siteName}","login.or":"or","login.password":"Password","login.passwordChanged":" Password updated successfully","login.placeholderOr":" or ","login.session_expired":" Your session has expired. Please login again.","login.signIn":"Sign in","login.signInLoading":"Signing in...","login.signInWith":"Sign in with:","login.userNotFound":"We couldn't find an account matching your login credentials.","login.username":"Username","login.verified":" Email Verified","login_mfa.enterToken":"To complete the sign in process, please enter a token from your smartphone's authenticator","login_mfa.submit":"Submit","login_mfa.submitting":"Submitting...","login_mfa.token":"MFA Token","login_mfa.tokenReq":"Please enter an MFA token","member_item.makeAdmin":"Make Admin","member_item.member":"Member","member_list.noUsersAdd":"No users to add.","members_popover.manageMembers":"Manage Members","members_popover.msg":"Message","members_popover.title":"Channel Members","members_popover.viewMembers":"View Members","mfa.confirm.complete":"<strong>Set up complete!</strong>","mfa.confirm.okay":"Okay","mfa.confirm.secure":"Your account is now secure. Next time you sign in, you will be asked to enter a code from the Google Authenticator app on your phone.","mfa.setup.badCode":"Invalid code. If this issue persists, contact your System Administrator.","mfa.setup.code":"MFA Code","mfa.setup.codeError":"Please enter the code from Google Authenticator.","mfa.setup.required":"<strong>Multi-factor authentication is required on {siteName}.</strong>","mfa.setup.save":"Save","mfa.setup.secret":"Secret: {secret}","mfa.setup.step1":"<strong>Step 1: </strong>On your phone, download Google Authenticator from <a target='_blank' href='https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8'>iTunes</a> or <a target='_blank' href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en'>Google Play</a>","mfa.setup.step2":"<strong>Step 2: </strong>Use Google Authenticator to scan this QR code, or manually type in the secret key","mfa.setup.step3":"<strong>Step 3: </strong>Enter the code generated by Google Authenticator","mfa.setupTitle":"Multi-factor Authentication Setup","mobile.about.appVersion":"App Version: {version} (Build {number})","mobile.about.copyright":"Copyright 2015-{currentYear} Mattermost, Inc. All rights reserved","mobile.about.database":"Database: {type}","mobile.about.licensed":"Licensed to: {company}","mobile.about.powered_by":"{site} is powered by Mattermost","mobile.about.serverVersion":"Server Version: {version} (Build {number})","mobile.about.serverVersionNoBuild":"Server Version: {version}","mobile.account.notifications.email.footer":"When offline or away for more than five minutes","mobile.account.settings.save":"Save","mobile.account_notifications.mentions_footer":"Your username (\"@{username}\") will always trigger mentions.","mobile.account_notifications.non-case_sensitive_words":"Other non-case sensitive words...","mobile.account_notifications.reply.header":"SEND REPLY NOTIFICATIONS FOR","mobile.account_notifications.threads_mentions":"Mentions in threads","mobile.account_notifications.threads_start":"Threads that I start","mobile.account_notifications.threads_start_participate":"Threads that I start or participate in","mobile.advanced_settings.clockDisplay":"Clock display","mobile.advanced_settings.delete":"Delete","mobile.advanced_settings.delete_file_cache":"Delete File Cache","mobile.advanced_settings.delete_file_cache_message":"\nThis will delete all the files stored in the cache. Are you sure you want to delete them?\n","mobile.advanced_settings.reset_button":"Reset","mobile.advanced_settings.reset_message":"\nThis will reset all offline data and restart the app. You will be automatically logged back in once the app restarts.\n","mobile.advanced_settings.reset_title":"Reset Cache","mobile.advanced_settings.title":"Advanced Settings","mobile.android.camera_permission_denied_description":"To take photos and videos with your camera, please change your permission settings.","mobile.android.camera_permission_denied_title":"Camera access is required","mobile.android.permission_denied_dismiss":"Dismiss","mobile.android.permission_denied_retry":"Set permission","mobile.android.photos_permission_denied_description":"To upload images from your library, please change your permission settings.","mobile.android.photos_permission_denied_title":"Photo library access is required","mobile.android.videos_permission_denied_description":"To upload videos from your library, please change your permission settings.","mobile.android.videos_permission_denied_title":"Video library access is required","mobile.announcement_banner.dismiss":"Dismiss","mobile.announcement_banner.ok":"OK","mobile.announcement_banner.title":"Announcement","mobile.channel.markAsRead":"Mark As Read","mobile.channel_drawer.search":"Jump to...","mobile.channel_info.alertMessageDeleteChannel":"Are you sure you want to delete the {term} {name}?","mobile.channel_info.alertMessageLeaveChannel":"Are you sure you want to leave the {term} {name}?","mobile.channel_info.alertNo":"No","mobile.channel_info.alertTitleDeleteChannel":"Delete {term}","mobile.channel_info.alertTitleLeaveChannel":"Leave {term}","mobile.channel_info.alertYes":"Yes","mobile.channel_info.delete_failed":"We couldn't delete the channel {displayName}. Please check your connection and try again.","mobile.channel_info.edit":"Edit Channel","mobile.channel_info.privateChannel":"Private Channel","mobile.channel_info.publicChannel":"Public Channel","mobile.channel_list.alertMessageLeaveChannel":"Are you sure you want to leave the {term} {name}?","mobile.channel_list.alertNo":"No","mobile.channel_list.alertTitleLeaveChannel":"Leave {term}","mobile.channel_list.alertYes":"Yes","mobile.channel_list.channels":"CHANNELS","mobile.channel_list.closeDM":"Close Direct Message","mobile.channel_list.closeGM":"Close Group Message","mobile.channel_list.dm":"Direct Message","mobile.channel_list.gm":"Group Message","mobile.channel_list.members":"MEMBERS","mobile.channel_list.not_member":"NOT A MEMBER","mobile.channel_list.open":"Open {term}","mobile.channel_list.openDM":"Open Direct Message","mobile.channel_list.openGM":"Open Group Message","mobile.channel_list.privateChannel":"Private Channel","mobile.channel_list.publicChannel":"Public Channel","mobile.channel_list.unreads":"UNREADS","mobile.client_upgrade":"Update App","mobile.client_upgrade.can_upgrade_subtitle":"A new version is available for download.","mobile.client_upgrade.can_upgrade_title":"Update Available","mobile.client_upgrade.close":"Update Later","mobile.client_upgrade.current_version":"Latest Version: {version}","mobile.client_upgrade.download_error.message":"An error occurred downloading the new version.","mobile.client_upgrade.download_error.title":"Unable to Install Update","mobile.client_upgrade.latest_version":"Your Version: {version}","mobile.client_upgrade.listener.message":"A client upgrade is available!","mobile.client_upgrade.must_upgrade_subtitle":"Please update the app to continue.","mobile.client_upgrade.must_upgrade_title":"Update Required","mobile.client_upgrade.no_upgrade_subtitle":"You already have the latest version.","mobile.client_upgrade.no_upgrade_title":"Your App Is Up to Date","mobile.client_upgrade.upgrade":"Update","mobile.commands.error_title":"Error Executing Command","mobile.components.channels_list_view.yourChannels":"Your channels:","mobile.components.error_list.dismiss_all":"Dismiss All","mobile.components.select_server_view.connect":"Connect","mobile.components.select_server_view.connecting":"Connecting...","mobile.components.select_server_view.continue":"Continue","mobile.components.select_server_view.enterServerUrl":"Enter Server URL","mobile.components.select_server_view.proceed":"Proceed","mobile.components.select_server_view.siteUrlPlaceholder":"https://mattermost.example.com","mobile.create_channel":"Create","mobile.create_channel.private":"New Private Channel","mobile.create_channel.public":"New Public Channel","mobile.custom_list.no_results":"No Results","mobile.document_preview.failed_description":"An error occurred while opening the document. Please make sure you have a {fileType} viewer installed and try again.\n","mobile.document_preview.failed_title":"Open Document failed","mobile.downloader.android_complete":"Download complete","mobile.downloader.android_failed":"Download failed","mobile.downloader.android_permission":"We need access to the downloads folder to save files.","mobile.downloader.android_started":"Download started","mobile.downloader.android_success":"download successful","mobile.downloader.complete":"Download complete","mobile.downloader.downloading":"Downloading...","mobile.downloader.failed_description":"An error occurred while downloading the file. Please check your internet connection and try again.\n","mobile.downloader.failed_title":"Download failed","mobile.downloader.image_saved":"Image Saved","mobile.downloader.video_saved":"Video Saved","mobile.drawer.teamsTitle":"Teams","mobile.edit_channel":"Save","mobile.edit_post.title":"Editing Message","mobile.emoji_picker.activity":"ACTIVITY","mobile.emoji_picker.custom":"CUSTOM","mobile.emoji_picker.flags":"FLAGS","mobile.emoji_picker.foods":"FOODS","mobile.emoji_picker.nature":"NATURE","mobile.emoji_picker.objects":"OBJECTS","mobile.emoji_picker.people":"PEOPLE","mobile.emoji_picker.places":"PLACES","mobile.emoji_picker.recent":"RECENTLY USED","mobile.emoji_picker.symbols":"SYMBOLS","mobile.error_handler.button":"Relaunch","mobile.error_handler.description":"\nClick relaunch to open the app again. After restart, you can report the problem from the settings menu.\n","mobile.error_handler.title":"Unexpected error occurred","mobile.extension.authentication_required":"Authentication required: Please first login using the app.","mobile.extension.file_limit":"Sharing is limited to a maximum of 5 files.","mobile.extension.max_file_size":"File attachments shared in Mattermost must be less than {size}.","mobile.extension.permission":"Mattermost needs access to the device storage to share files.","mobile.extension.posting":"Posting...","mobile.extension.title":"Share in Mattermost","mobile.file_upload.camera":"Take Photo or Video","mobile.file_upload.library":"Photo Library","mobile.file_upload.max_warning":"Uploads limited to 5 files maximum.","mobile.file_upload.more":"More","mobile.file_upload.video":"Video Library","mobile.help.title":"Help","mobile.image_preview.deleted_post_message":"This post and its files have been deleted. The previewer will now be closed.","mobile.image_preview.deleted_post_title":"Post Deleted","mobile.image_preview.save":"Save Image","mobile.image_preview.save_video":"Save Video","mobile.intro_messages.DM":"This is the start of your direct message history with {teammate}. Direct messages and files shared here are not shown to people outside this area.","mobile.intro_messages.default_message":"This is the first channel teammates see when they sign up - use it for posting updates everyone needs to know.","mobile.intro_messages.default_welcome":"Welcome to {name}!","mobile.ios.photos_permission_denied_description":"To save images and videos to your library, please change your permission settings.","mobile.join_channel.error":"We couldn't join the channel {displayName}. Please check your connection and try again.","mobile.loading_channels":"Loading Channels...","mobile.loading_members":"Loading Members...","mobile.loading_posts":"Loading messages...","mobile.login_options.choose_title":"Choose your login method","mobile.long_post_title":"{channelName} - Post","mobile.managed.blocked_by":"Blocked by {vendor}","mobile.managed.exit":"Exit","mobile.managed.jailbreak":"Jailbroken devices are not trusted by {vendor}, please exit the app.","mobile.managed.secured_by":"Secured by {vendor}","mobile.markdown.code.copy_code":"Copy Code","mobile.markdown.code.plusMoreLines":"+{count, number} more {count, plural, one {line} other {lines}}","mobile.markdown.image.error":"Image failed to load:","mobile.markdown.image.too_large":"Image exceeds max dimensions of {maxWidth} by {maxHeight}:","mobile.markdown.link.copy_url":"Copy URL","mobile.mention.copy_mention":"Copy Mention","mobile.message_length.message":"Your current message is too long. Current character count: {max}/{count}","mobile.message_length.title":"Message Length","mobile.more_dms.add_more":"You can add {remaining, number} more users","mobile.more_dms.cannot_add_more":"You cannot add more users","mobile.more_dms.start":"Start","mobile.more_dms.title":"New Conversation","mobile.more_dms.you":"(@{username} - you)","mobile.notice_mobile_link":"mobile apps","mobile.notice_platform_link":"platform","mobile.notice_text":"Mattermost is made possible by the open source software used in our {platform} and {mobile}.","mobile.notification.in":" in ","mobile.notification_settings.email":"Email","mobile.notification_settings.email_title":"Email Notifications","mobile.notification_settings.mentions.channelWide":"Channel-wide mentions","mobile.notification_settings.mentions.reply_title":"Send Reply notifications for","mobile.notification_settings.mentions.sensitiveName":"Your case sensitive first name","mobile.notification_settings.mentions.sensitiveUsername":"Your non-case sensitive username","mobile.notification_settings.mentions_replies":"Mentions and Replies","mobile.notification_settings.mobile":"Mobile","mobile.notification_settings.mobile_title":"Mobile Notifications","mobile.notification_settings.modal_cancel":"CANCEL","mobile.notification_settings.modal_save":"SAVE","mobile.notification_settings.save_failed_description":"The notification settings failed to save due to a connection issue, please try again.","mobile.notification_settings.save_failed_title":"Connection issue","mobile.notification_settings_mentions.keywords":"Keywords","mobile.notification_settings_mentions.keywordsDescription":"Other words that trigger a mention","mobile.notification_settings_mentions.keywordsHelp":"Keywords are non-case sensitive and should be separated by a comma.","mobile.notification_settings_mentions.wordsTrigger":"WORDS THAT TRIGGER MENTIONS","mobile.notification_settings_mobile.default_sound":"Default ({sound})","mobile.notification_settings_mobile.light":"Light","mobile.notification_settings_mobile.no_sound":"None","mobile.notification_settings_mobile.push_activity":"SEND NOTIFICATIONS","mobile.notification_settings_mobile.push_activity_android":"Send notifications","mobile.notification_settings_mobile.push_status":"TRIGGER PUSH NOTIFICATIONS WHEN","mobile.notification_settings_mobile.push_status_android":"Trigger push notifications when","mobile.notification_settings_mobile.sound":"Sound","mobile.notification_settings_mobile.sounds_title":"Notification sound","mobile.notification_settings_mobile.test":"Send me a test notification","mobile.notification_settings_mobile.test_push":"This is a test push notification","mobile.notification_settings_mobile.vibrate":"Vibrate","mobile.offlineIndicator.connected":"Connected","mobile.offlineIndicator.connecting":"Connecting...","mobile.offlineIndicator.offline":"Cannot connect to the server","mobile.open_dm.error":"We couldn't open a direct message with {displayName}. Please check your connection and try again.","mobile.open_gm.error":"We couldn't open a group message with those users. Please check your connection and try again.","mobile.post.cancel":"Cancel","mobile.post.delete_question":"Are you sure you want to delete this post?","mobile.post.delete_title":"Delete Post","mobile.post.failed_delete":"Delete Message","mobile.post.failed_retry":"Try Again","mobile.post.failed_title":"Unable to send your message","mobile.post.retry":"Refresh","mobile.post_body.show_more":"Show More","mobile.post_info.add_reaction":"Add Reaction","mobile.post_info.copy_post":"Copy Post","mobile.post_textbox.empty.message":"You are trying to send an empty message.\nPlease make sure you have a message or at least one attached file.","mobile.post_textbox.empty.ok":"OK","mobile.post_textbox.empty.title":"Empty Message","mobile.post_textbox.uploadFailedDesc":"Some attachments failed to upload to the server, Are you sure you want to post the message?","mobile.post_textbox.uploadFailedTitle":"Attachment failure","mobile.posts_view.moreMsg":"More New Messages Above","mobile.rename_channel.display_name_maxLength":"Channel name must be less than {maxLength, number} characters","mobile.rename_channel.display_name_minLength":"Channel name must be {minLength, number} or more characters","mobile.rename_channel.display_name_required":"Channel name is required","mobile.rename_channel.name_lowercase":"URL be lowercase alphanumeric characters","mobile.rename_channel.name_maxLength":"URL must be less than {maxLength, number} characters","mobile.rename_channel.name_minLength":"URL must be {minLength, number} or more characters","mobile.rename_channel.name_required":"URL is required","mobile.request.invalid_response":"Received invalid response from the server.","mobile.retry_message":"Refreshing messages failed. Pull up to try again.","mobile.routes.channelInfo":"Info","mobile.routes.channelInfo.createdBy":"Created by {creator} on ","mobile.routes.channelInfo.delete_channel":"Delete Channel","mobile.routes.channelInfo.favorite":"Favorite","mobile.routes.channel_members.action":"Remove Members","mobile.routes.channel_members.action_message":"You must select at least one member to remove from the channel.","mobile.routes.channel_members.action_message_confirm":"Are you sure you want to remove the selected members from the channel?","mobile.routes.channels":"Channels","mobile.routes.code":"{language} Code","mobile.routes.code.noLanguage":"Code","mobile.routes.edit_profile":"Edit Profile","mobile.routes.enterServerUrl":"Enter Server URL","mobile.routes.login":"Login","mobile.routes.loginOptions":"Login Chooser","mobile.routes.mfa":"Multi-factor Authentication","mobile.routes.postsList":"Posts List","mobile.routes.saml":"Single SignOn","mobile.routes.selectChannel":"Select Channel","mobile.routes.selectTeam":"Select Team","mobile.routes.settings":"Settings","mobile.routes.sso":"Single Sign-On","mobile.routes.table":"Table","mobile.routes.tableImage":"Image","mobile.routes.thread":"{channelName} Thread","mobile.routes.thread_dm":"Direct Message Thread","mobile.routes.user_profile":"Profile","mobile.routes.user_profile.send_message":"Send Message","mobile.search.from_modifier_description":"to find posts from specific users","mobile.search.from_modifier_title":"username","mobile.search.in_modifier_description":"to find posts in specific channels","mobile.search.in_modifier_title":"channel-name","mobile.search.jump":"Jump to recent messages","mobile.search.no_results":"No Results Found","mobile.search.recent_title":"Recent Searches","mobile.select_team.choose":"Your teams:","mobile.select_team.join_open":"Open teams you can join","mobile.select_team.no_teams":"There are no available teams for you to join.","mobile.server_ping_failed":"Cannot connect to the server. Please check your server URL and internet connection.","mobile.server_upgrade.button":"OK","mobile.server_upgrade.description":"\nA server upgrade is required to use the Mattermost app. Please ask your System Administrator for details.\n","mobile.server_upgrade.title":"Server upgrade required","mobile.server_url.invalid_format":"URL must start with http:// or https://","mobile.session_expired":"Session Expired: Please log in to continue receiving notifications.","mobile.set_status.away":"Away","mobile.set_status.dnd":"Do Not Disturb","mobile.set_status.offline":"Offline","mobile.set_status.online":"Online","mobile.settings.clear":"Clear Offline Store","mobile.settings.clear_button":"Clear","mobile.settings.clear_message":"\nThis will clear all offline data and restart the app. You will be automatically logged back in once the app restarts.\n","mobile.settings.modal.check_for_upgrade":"Check for Updates","mobile.settings.team_selection":"Team Selection","mobile.share_extension.cancel":"Cancel","mobile.share_extension.channel":"Channel","mobile.share_extension.send":"Send","mobile.share_extension.team":"Team","mobile.suggestion.members":"Members","mobile.video.save_error_message":"To save the video file you need to download it first.","mobile.video.save_error_title":"Save Video Error","mobile.video_playback.failed_description":"An error occurred while trying to play the video.\n","mobile.video_playback.failed_title":"Video playback failed","modal.manaul_status.ask":"Do not ask me again","modal.manaul_status.button":"Yes, set my status to \"Online\"","modal.manaul_status.message":"Would you like to switch your status to \"Online\"?","modal.manaul_status.title_":"Your status is set to \"{status}\"","modal.manaul_status.title_away":"Your status is set to \"Away\"","modal.manaul_status.title_dnd":"Your status is set to \"Do Not Disturb\"","modal.manaul_status.title_offline":"Your status is set to \"Offline\"","modal.manual_status.cancel_":"No, keep it as \"{status}\"","modal.manual_status.cancel_away":"No, keep it as \"Away\"","modal.manual_status.cancel_dnd":"No, keep it as \"Do Not Disturb\"","modal.manual_status.cancel_offline":"No, keep it as \"Offline\"","more_channels.close":"Close","more_channels.create":"Create New Channel","more_channels.createClick":"Click 'Create New Channel' to make a new one","more_channels.join":"Join","more_channels.next":"Next","more_channels.noMore":"No more channels to join","more_channels.prev":"Previous","more_channels.title":"More Channels","more_direct_channels.close":"Close","more_direct_channels.directchannel.deactivated":"{displayname} - Deactivated","more_direct_channels.directchannel.you":"{displayname} (you)","more_direct_channels.message":"Message","more_direct_channels.new_convo_note":"This will start a new conversation. If you’re adding a lot of people, consider creating a private channel instead.","more_direct_channels.new_convo_note.full":"You’ve reached the maximum number of people for this conversation. Consider creating a private channel instead.","more_direct_channels.title":"Direct Messages","msg_typing.areTyping":"{users} and {last} are typing...","msg_typing.isTyping":"{user} is typing...","msg_typing.someone":"Someone","multiselect.add":"Add","multiselect.go":"Go","multiselect.list.notFound":"No items found","multiselect.numPeopleRemaining":"Use ↑↓ to browse, ↵ to select. You can add {num, number} more {num, plural, one {person} other {people}}. ","multiselect.numRemaining":"You can add {num, number} more","multiselect.placeholder":"Search and add members","navbar.addMembers":"Add Members","navbar.click":"Click here","navbar.delete":"Delete Channel...","navbar.leave":"Leave Channel","navbar.manageMembers":"Manage Members","navbar.noHeader":"No channel header yet.{newline}{link} to add one.","navbar.preferences":"Notification Preferences","navbar.rename":"Rename Channel...","navbar.setHeader":"Set Channel Header...","navbar.setPurpose":"Set Channel Purpose...","navbar.toggle1":"Toggle sidebar","navbar.toggle2":"Toggle sidebar","navbar.viewInfo":"View Info","navbar.viewPinnedPosts":"View Pinned Posts","navbar_dropdown.about":"About Mattermost","navbar_dropdown.accountSettings":"Account Settings","navbar_dropdown.addMemberToTeam":"Add Members to Team","navbar_dropdown.console":"System Console","navbar_dropdown.create":"Create a New Team","navbar_dropdown.emoji":"Custom Emoji","navbar_dropdown.help":"Help","navbar_dropdown.integrations":"Integrations","navbar_dropdown.inviteMember":"Send Email Invite","navbar_dropdown.join":"Join Another Team","navbar_dropdown.keyboardShortcuts":"Keyboard Shortcuts","navbar_dropdown.leave":"Leave Team","navbar_dropdown.logout":"Logout","navbar_dropdown.manageMembers":"Manage Members","navbar_dropdown.nativeApps":"Download Apps","navbar_dropdown.report":"Report a Problem","navbar_dropdown.switchTeam":"Switch to {team}","navbar_dropdown.switchTo":"Switch to ","navbar_dropdown.teamLink":"Get Team Invite Link","navbar_dropdown.teamSettings":"Team Settings","navbar_dropdown.viewMembers":"View Members","navbar_dropdown.webrtc.call":"Start Video Call","navbar_dropdown.webrtc.offline":"Video Call Offline","navbar_dropdown.webrtc.unavailable":"Video Call Unavailable","notification.dm":"Direct Message","notify_all.confirm":"Confirm","notify_all.question":"By using @all or @channel you are about to send notifications to {totalMembers} people. Are you sure you want to do this?","notify_all.title.confirm":"Confirm sending notifications to entire channel","passwordRequirements":"Password Requirements:","password_form.change":"Change my password","password_form.click":"Click <a href={url}>here</a> to log in.","password_form.enter":"Enter a new password for your {siteName} account.","password_form.error":"Please enter at least {chars} characters.","password_form.pwd":"Password","password_form.title":"Password Reset","password_form.update":"Your password has been updated successfully.","password_send.checkInbox":"Please check your inbox.","password_send.description":"To reset your password, enter the email address you used to sign up","password_send.email":"Email","password_send.error":"Please enter a valid email address.","password_send.link":"If the account exists, a password reset email will be sent to: <br/><b>{email}</b><br/><br/>","password_send.reset":"Reset my password","password_send.title":"Password Reset","pdf_preview.max_pages":"Download to read more pages","pending_post_actions.cancel":"Cancel","pending_post_actions.retry":"Retry","permalink.error.access":"Permalink belongs to a deleted message or to a channel to which you do not have access.","permalink.error.title":"Message Not Found","post_attachment.collapse":"Show less...","post_attachment.more":"Show more...","post_body.check_for_out_of_channel_mentions.link.and":" and ","post_body.check_for_out_of_channel_mentions.link.private":"add them to this private channel","post_body.check_for_out_of_channel_mentions.link.public":"add them to the channel","post_body.check_for_out_of_channel_mentions.message.multiple":"were mentioned but they are not in the channel. Would you like to ","post_body.check_for_out_of_channel_mentions.message.one":"was mentioned but is not in the channel. Would you like to ","post_body.check_for_out_of_channel_mentions.message_last":"? They will have access to all message history.","post_body.commentedOn":"Commented on {name}{apostrophe} message: ","post_body.deleted":"(message deleted)","post_body.plusMore":" plus {count, number} other {count, plural, one {file} other {files}}","post_delete.notPosted":"Comment could not be posted","post_delete.okay":"Okay","post_delete.someone":"Someone deleted the message on which you tried to post a comment.","post_focus_view.beginning":"Beginning of Channel Archives","post_info.del":"Delete","post_info.edit":"Edit","post_info.message.visible":"(Only visible to you)","post_info.message.visible.compact":" (Only visible to you)","post_info.mobile.flag":"Flag","post_info.mobile.unflag":"Unflag","post_info.permalink":"Permalink","post_info.pin":"Pin to channel","post_info.pinned":"Pinned","post_info.reply":"Reply","post_info.system":"System","post_info.unpin":"Un-pin from channel","post_message_view.edited":"(edited)","posts_view.loadMore":"Load more messages","posts_view.loadingMore":"Loading more messages...","posts_view.maxLoaded":"Looking for a specific message? Try searching for it","posts_view.newMsg":"New Messages","posts_view.newMsgBelow":"New {count, plural, one {message} other {messages}}","quick_switch_modal.channels":"Channels","quick_switch_modal.channelsShortcut.mac":"- ⌘K","quick_switch_modal.channelsShortcut.windows":"- CTRL+K","quick_switch_modal.help":"Start typing then use TAB to toggle channels/teams, ↑↓ to browse, ↵ to select, and ESC to dismiss.","quick_switch_modal.help_mobile":"Type to find a channel.","quick_switch_modal.help_no_team":"Type to find a channel. Use ↑↓ to browse, ↵ to select, ESC to dismiss.","quick_switch_modal.teams":"Teams","quick_switch_modal.teamsShortcut.mac":"- ⌘⌥K","quick_switch_modal.teamsShortcut.windows":"- CTRL+ALT+K","reaction.clickToAdd":"(click to add)","reaction.clickToRemove":"(click to remove)","reaction.othersReacted":"{otherUsers, number} {otherUsers, plural, one {user} other {users}}","reaction.reacted":"{users} {reactionVerb} with {emoji}","reaction.reactionVerb.user":"reacted","reaction.reactionVerb.users":"reacted","reaction.reactionVerb.you":"reacted","reaction.reactionVerb.youAndUsers":"reacted","reaction.usersAndOthersReacted":"{users} and {otherUsers, number} other {otherUsers, plural, one {user} other {users}}","reaction.usersReacted":"{users} and {lastUser}","reaction.you":"You","reaction_list.addReactionTooltip":"Add reaction","removed_channel.channelName":"the channel","removed_channel.from":"Removed from ","removed_channel.okay":"Okay","removed_channel.remover":"{remover} removed you from {channel}","removed_channel.someone":"Someone","rename_channel.cancel":"Cancel","rename_channel.defaultError":" - Cannot be changed for the default channel","rename_channel.displayName":"Display Name","rename_channel.displayNameHolder":"Enter display name","rename_channel.handleHolder":"lowercase alphanumeric characters","rename_channel.lowercase":"Must be lowercase alphanumeric characters","rename_channel.maxLength":"This field must be less than {maxLength, number} characters","rename_channel.minLength":"Channel name must be {minLength, number} or more characters","rename_channel.required":"This field is required","rename_channel.save":"Save","rename_channel.title":"Rename Channel","rename_channel.url":"URL","revoke_user_sessions_modal.desc":"This action revokes all sessions for {username}. They will be logged out from all devices. Are you sure you want to revoke all sessions for {username}?","revoke_user_sessions_modal.revoke":"Revoke","revoke_user_sessions_modal.title":"Revoke Sessions for {username}","rhs_comment.comment":"Comment","rhs_comment.del":"Delete","rhs_comment.edit":"Edit","rhs_comment.mobile.flag":"Flag","rhs_comment.mobile.unflag":"Unflag","rhs_comment.permalink":"Permalink","rhs_header.backToCallTooltip":"Back to Call","rhs_header.backToFlaggedTooltip":"Back to Flagged Posts","rhs_header.backToPinnedTooltip":"Back to Pinned Posts","rhs_header.backToResultsTooltip":"Back to Search Results","rhs_header.closeSidebarTooltip":"Close Sidebar","rhs_header.closeTooltip":"Close Sidebar","rhs_header.details":"Message Details","rhs_header.expandSidebarTooltip":"Expand Sidebar","rhs_header.expandTooltip":"Shrink Sidebar","rhs_header.shrinkSidebarTooltip":"Shrink Sidebar","rhs_root.del":"Delete","rhs_root.direct":"Direct Message","rhs_root.edit":"Edit","rhs_root.mobile.flag":"Flag","rhs_root.mobile.unflag":"Unflag","rhs_root.permalink":"Permalink","rhs_root.pin":"Pin to channel","rhs_root.unpin":"Un-pin from channel","rhs_thread.rootPostDeletedMessage.body":"Part of this thread has been deleted due to a data retention policy. You can no longer reply to this thread.","save_button.save":"Save","save_button.saving":"Saving","search_bar.search":"Search","search_bar.usage":"<h4>Search Options</h4><ul><li><span>Use </span><b>\"quotation marks\"</b><span> to search for phrases</span></li><li><span>Use </span><b>from:</b><span> to find posts from specific users and </span><b>in:</b><span> to find posts in specific channels</span></li></ul>","search_header.loading":"Searching...","search_header.results":"Search Results","search_header.title2":"Recent Mentions","search_header.title3":"Flagged Posts","search_header.title4":"Pinned posts in {channelDisplayName}","search_item.direct":"Direct Message (with {username})","search_item.jump":"Jump","search_results.noResults":"No results found. Try again?","search_results.noResults.partialPhraseSuggestion":"If you're searching a partial phrase (ex. searching \"rea\", looking for \"reach\" or \"reaction\"), append a * to your search term.","search_results.noResults.stopWordsSuggestion":"Two letter searches and common words like \"this\", \"a\" and \"is\" won't appear in search results due to excessive results returned.","search_results.searching":"Searching...","search_results.usage.dataRetention":"Only messages posted in the last {days} days are returned. Contact your System Administrator for more detail.","search_results.usage.fromInSuggestion":"Use {fromUser} to find posts from specific users and {inChannel} to find posts in specific channels","search_results.usage.phrasesSuggestion":"Use {quotationMarks} to search for phrases","search_results.usage.phrasesSuggestion.quotationMarks":"\"quotation marks\"","search_results.usageFlag1":"You haven't flagged any messages yet.","search_results.usageFlag2":"You can add a flag to messages and comments by clicking the ","search_results.usageFlag3":" icon next to the timestamp.","search_results.usageFlag4":"Flags are a way to mark messages for follow up. Your flags are personal, and cannot be seen by other users.","search_results.usagePin1":"There are no pinned messages yet.","search_results.usagePin2":"All members of this channel can pin important or useful messages.","search_results.usagePin3":"Pinned messages are visible to all channel members.","search_results.usagePin4":"To pin a message: Go to the message that you want to pin and click [...] > \"Pin to channel\".","setting_item_max.cancel":"Cancel","setting_item_max.save":"Save","setting_item_min.edit":"Edit","setting_picture.cancel":"Cancel","setting_picture.help.profile":"Upload a picture in BMP, JPG or PNG format.","setting_picture.help.team":"Upload a team icon in BMP, JPG or PNG format.","setting_picture.save":"Save","setting_picture.select":"Select","setting_upload.import":"Import","setting_upload.noFile":"No file selected.","setting_upload.select":"Select file","shortcuts.browser.channel_next":"Forward in history:\tAlt|Right","shortcuts.browser.channel_next.mac":"Forward in history:\t⌘|]","shortcuts.browser.channel_prev":"Back in history:\tAlt|Left","shortcuts.browser.channel_prev.mac":"Back in history:\t⌘|[","shortcuts.browser.font_decrease":"Zoom out:\tCtrl|-","shortcuts.browser.font_decrease.mac":"Zoom out:\t⌘|-","shortcuts.browser.font_increase":"Zoom in:\tCtrl|+","shortcuts.browser.font_increase.mac":"Zoom in:\t⌘|+","shortcuts.browser.header":"Built-in Browser Commands","shortcuts.browser.highlight_next":"Highlight text to the next line:\tShift|Down","shortcuts.browser.highlight_prev":"Highlight text to the previous line:\tShift|Up","shortcuts.browser.input.header":"Works inside an input field","shortcuts.browser.newline":"Create a new line:\tShift|Enter","shortcuts.files.header":"Files","shortcuts.files.upload":"Upload files:\tCtrl|U","shortcuts.files.upload.mac":"Upload files:\t⌘|U","shortcuts.header":"Keyboard Shortcuts\tCtrl|/","shortcuts.header.mac":"Keyboard Shortcuts\t⌘|/","shortcuts.info":"Begin a message with / for a list of all the commands at your disposal.","shortcuts.msgs.comp.channel":"Channel:\t~|[a-z]|Tab","shortcuts.msgs.comp.emoji":"Emoji:\t:|[a-z]|Tab","shortcuts.msgs.comp.header":"Autocomplete","shortcuts.msgs.comp.username":"Username:\t@|[a-z]|Tab","shortcuts.msgs.edit":"Edit last message in channel:\tUp","shortcuts.msgs.header":"Messages","shortcuts.msgs.input.header":"Works inside an empty input field","shortcuts.msgs.reply":"Reply to last message in channel:\tShift|Up","shortcuts.msgs.reprint_next":"Reprint next message:\tCtrl|Down","shortcuts.msgs.reprint_next.mac":"Reprint next message:\t⌘|Down","shortcuts.msgs.reprint_prev":"Reprint previous message:\tCtrl|Up","shortcuts.msgs.reprint_prev.mac":"Reprint previous message:\t⌘|Up","shortcuts.nav.direct_messages_menu":"Direct messages menu:\tCtrl|Shift|K","shortcuts.nav.direct_messages_menu.mac":"Direct messages menu:\t⌘|Shift|K","shortcuts.nav.focus_center":"Set focus to input field:\tCtrl|Shift|L","shortcuts.nav.focus_center.mac":"Set focus to input field:\t⌘|Shift|L","shortcuts.nav.header":"Navigation","shortcuts.nav.next":"Next channel:\tAlt|Down","shortcuts.nav.next.mac":"Next channel:\t⌥|Down","shortcuts.nav.prev":"Previous channel:\tAlt|Up","shortcuts.nav.prev.mac":"Previous channel:\t⌥|Up","shortcuts.nav.recent_mentions":"Recent mentions:\tCtrl|Shift|M","shortcuts.nav.recent_mentions.mac":"Recent mentions:\t⌘|Shift|M","shortcuts.nav.settings":"Account settings:\tCtrl|Shift|A","shortcuts.nav.settings.mac":"Account settings:\t⌘|Shift|A","shortcuts.nav.switcher":"Quick channel switcher:\tCtrl|K","shortcuts.nav.switcher.mac":"Quick channel switcher:\t⌘|K","shortcuts.nav.unread_next":"Next unread channel:\tAlt|Shift|Down","shortcuts.nav.unread_next.mac":"Next unread channel:\t⌥|Shift|Down","shortcuts.nav.unread_prev":"Previous unread channel:\tAlt|Shift|Up","shortcuts.nav.unread_prev.mac":"Previous unread channel:\t⌥|Shift|Up","sidebar.channels":"PUBLIC CHANNELS","sidebar.createChannel":"Create new public channel","sidebar.createDirectMessage":"Create new direct message","sidebar.createGroup":"Create new private channel","sidebar.direct":"DIRECT MESSAGES","sidebar.directchannel.you":"{displayname} (you)","sidebar.favorite":"FAVORITE CHANNELS","sidebar.leave":"Leave channel","sidebar.mainMenu":"Main Menu","sidebar.more":"More","sidebar.moreElips":"More...","sidebar.otherMembers":"Outside this team","sidebar.pg":"PRIVATE CHANNELS","sidebar.removeList":"Remove from list","sidebar.tutorialScreen1":"<h4>Channels</h4><p><strong>Channels</strong> organize conversations across different topics. They’re open to everyone on your team. To send private communications use <strong>Direct Messages</strong> for a single person or <strong>Private Channel</strong> for multiple people.</p>","sidebar.tutorialScreen2":"<h4>\"{townsquare}\" and \"{offtopic}\" channels</h4><p>Here are two public channels to start:</p><p><strong>{townsquare}</strong> is a place for team-wide communication. Everyone in your team is a member of this channel.</p><p><strong>{offtopic}</strong> is a place for fun and humor outside of work-related channels. You and your team can decide what other channels to create.</p>","sidebar.tutorialScreen3":"<h4>Creating and Joining Channels</h4><p>Click <strong>\"More...\"</strong> to create a new channel or join an existing one.</p><p>You can also create a new channel by clicking the <strong>\"+\" symbol</strong> next to the public or private channel header.</p>","sidebar.unreadSection":"UNREADS","sidebar.unreads":"More unreads","sidebar_header.tutorial":"<h4>Main Menu</h4><p>The <strong>Main Menu</strong> is where you can <strong>Invite New Members</strong>, access your <strong>Account Settings</strong> and set your <strong>Theme Color</strong>.</p><p>Team administrators can also access their <strong>Team Settings</strong> from this menu.</p><p>System administrators will find a <strong>System Console</strong> option to administrate the entire system.</p>","sidebar_right_menu.accountSettings":"Account Settings","sidebar_right_menu.addMemberToTeam":"Add Members to Team","sidebar_right_menu.console":"System Console","sidebar_right_menu.flagged":"Flagged Posts","sidebar_right_menu.help":"Help","sidebar_right_menu.inviteNew":"Send Email Invite","sidebar_right_menu.logout":"Logout","sidebar_right_menu.manageMembers":"Manage Members","sidebar_right_menu.nativeApps":"Download Apps","sidebar_right_menu.recentMentions":"Recent Mentions","sidebar_right_menu.report":"Report a Problem","sidebar_right_menu.teamLink":"Get Team Invite Link","sidebar_right_menu.teamSettings":"Team Settings","sidebar_right_menu.viewMembers":"View Members","signup.email":"Email and Password","signup.gitlab":"GitLab Single Sign-On","signup.google":"Google Account","signup.ldap":"AD/LDAP Credentials","signup.office365":"Office 365","signup.title":"Create an account with:","signup_team.createTeam":"Or Create a Team","signup_team.disabled":"Team creation has been disabled.  Please contact an administrator for access.","signup_team.join_open":"Teams you can join: ","signup_team.noTeams":"There are no teams included in the Team Directory and team creation has been disabled.","signup_team.no_open_teams":"No teams are available to join. Please ask your administrator for an invite.","signup_team.no_open_teams_canCreate":"No teams are available to join. Please create a new team or ask your administrator for an invite.","signup_team.no_teams":"No teams have been created. Please contact your administrator.","signup_team.no_teams_canCreate":"No teams have been created. You may create one by clicking \"Create a new team\".","signup_team.none":"No team creation method has been enabled.  Please contact an administrator for access.","signup_team_complete.completed":"You've already completed the signup process for this invitation or this invitation has expired.","signup_team_confirm.checkEmail":"Please check your email: <strong>{email}</strong><br />Your email contains a link to set up your team","signup_team_confirm.title":"Sign up Complete","signup_team_system_console":"Go to System Console","signup_user_completed.choosePwd":"Choose your password","signup_user_completed.chooseUser":"Choose your username","signup_user_completed.create":"Create Account","signup_user_completed.emailHelp":"Valid email required for sign-up","signup_user_completed.emailIs":"Your email address is <strong>{email}</strong>. You'll use this address to sign in to {siteName}.","signup_user_completed.expired":"You've already completed the signup process for this invitation or this invitation has expired.","signup_user_completed.gitlab":"with GitLab","signup_user_completed.google":"with Google","signup_user_completed.haveAccount":"Already have an account?","signup_user_completed.invalid_invite":"The invite link was invalid.  Please speak with your Administrator to receive an invitation.","signup_user_completed.lets":"Let's create your account","signup_user_completed.no_open_server":"This server does not allow open signups.  Please speak with your Administrator to receive an invitation.","signup_user_completed.none":"No user creation method has been enabled.  Please contact an administrator for access.","signup_user_completed.office365":"with Office 365","signup_user_completed.onSite":"on {siteName}","signup_user_completed.or":"or","signup_user_completed.passwordLength":"Please enter between {min} and {max} characters","signup_user_completed.required":"This field is required","signup_user_completed.reserved":"This username is reserved, please choose a new one.","signup_user_completed.signIn":"Click here to sign in.","signup_user_completed.userHelp":"Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-' and '_'","signup_user_completed.usernameLength":"Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-' and '_'.","signup_user_completed.validEmail":"Please enter a valid email address","signup_user_completed.welcome":"Welcome to:","signup_user_completed.whatis":"What's your email address?","signup_user_completed.withLdap":"With your AD/LDAP credentials","sso_signup.find":"Find my teams","sso_signup.gitlab":"Create team with GitLab Account","sso_signup.google":"Create team with Google Apps Account","sso_signup.length_error":"Name must be 3 or more characters up to a maximum of 15","sso_signup.teamName":"Enter name of new team","sso_signup.team_error":"Please enter a team name","status_dropdown.set_away":"Away","status_dropdown.set_dnd":"Do Not Disturb","status_dropdown.set_dnd.extra":"Disables Desktop and Push Notifications","status_dropdown.set_offline":"Offline","status_dropdown.set_online":"Online","suggestion.loading":"Loading...","suggestion.mention.all":"CAUTION: This mentions everyone in channel","suggestion.mention.channel":"Notifies everyone in the channel","suggestion.mention.channels":"My Channels","suggestion.mention.here":"Notifies everyone in the channel and online","suggestion.mention.in_channel":"Channels","suggestion.mention.members":"Channel Members","suggestion.mention.morechannels":"Other Channels","suggestion.mention.nonmembers":"Not in Channel","suggestion.mention.not_in_channel":"Other Channels","suggestion.mention.special":"Special Mentions","suggestion.mention.unread.channels":"Unread Channels","suggestion.search.private":"Private Channels","suggestion.search.public":"Public Channels","system_users_list.count":"{count, number} {count, plural, one {user} other {users}}","system_users_list.countPage":"{startCount, number} - {endCount, number} {count, plural, one {user} other {users}} of {total, number} total","system_users_list.countSearch":"{count, number} {count, plural, one {user} other {users}} of {total, number} total","team.button.name_undefined":"Name undefined","team_export_tab.download":"download","team_export_tab.export":"Export","team_export_tab.exportTeam":"Export your team","team_export_tab.exporting":" Exporting...","team_export_tab.ready":" Ready for ","team_export_tab.unable":" Unable to export: {error}","team_import_tab.failure":" Import failure: ","team_import_tab.import":"Import","team_import_tab.importHelpDocsLink":"documentation","team_import_tab.importHelpExportInstructions":"Slack > Team Settings > Import/Export Data > Export > Start Export","team_import_tab.importHelpExporterLink":"Slack Advanced Exporter","team_import_tab.importHelpLine1":"Slack import to Mattermost supports importing of messages in your Slack team's public channels.","team_import_tab.importHelpLine2":"To import a team from Slack, go to {exportInstructions}. See {uploadDocsLink} to learn more.","team_import_tab.importHelpLine3":"To import posts with attached files, see {slackAdvancedExporterLink} for details.","team_import_tab.importSlack":"Import from Slack (Beta)","team_import_tab.importing":" Importing...","team_import_tab.successful":" Import successful: ","team_import_tab.summary":"View Summary","team_member_modal.close":"Close","team_member_modal.members":"{team} Members","team_members_dropdown.confirmDemoteDescription":"If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you'll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.","team_members_dropdown.confirmDemoteRoleTitle":"Confirm demotion from System Admin role","team_members_dropdown.confirmDemotion":"Confirm Demotion","team_members_dropdown.confirmDemotionCmd":"platform roles system_admin {username}","team_members_dropdown.inactive":"Inactive","team_members_dropdown.leave_team":"Remove From Team","team_members_dropdown.makeActive":"Activate","team_members_dropdown.makeAdmin":"Make Team Admin","team_members_dropdown.makeInactive":"Deactivate","team_members_dropdown.makeMember":"Make Member","team_members_dropdown.member":"Member","team_members_dropdown.systemAdmin":"System Admin","team_members_dropdown.teamAdmin":"Team Admin","team_settings_modal.exportTab":"Export","team_settings_modal.generalTab":"General","team_settings_modal.importTab":"Import","team_settings_modal.title":"Team Settings","team_sidebar.join":"Other teams you can join.","textbox.bold":"**bold**","textbox.edit":"Edit message","textbox.help":"Help","textbox.inlinecode":"`inline code`","textbox.italic":"_italic_","textbox.preformatted":"```preformatted```","textbox.preview":"Preview","textbox.quote":">quote","textbox.strike":"strike","tutorial_intro.allSet":"You’re all set","tutorial_intro.end":"Click \"Next\" to enter {channel}. This is the first channel teammates see when they sign up. Use it for posting updates everyone needs to know.","tutorial_intro.invite":"Invite teammates","tutorial_intro.mobileApps":"Install the apps for {link} for easy access and notifications on the go.","tutorial_intro.mobileAppsLinkText":"PC, Mac, iOS and Android","tutorial_intro.next":"Next","tutorial_intro.screenOne":"<h3>Welcome to:</h3><h1>Mattermost</h1><p>Your team communication all in one place, instantly searchable and available anywhere.</p><p>Keep your team connected to help them achieve what matters most.</p>","tutorial_intro.screenTwo":"<h3>How Mattermost works:</h3><p>Communication happens in public discussion channels, private channels and direct messages.</p><p>Everything is archived and searchable from any web-enabled desktop, laptop or phone.</p>","tutorial_intro.skip":"Skip tutorial","tutorial_intro.support":"Need anything, just email us at ","tutorial_intro.teamInvite":"Invite teammates","tutorial_intro.whenReady":" when you’re ready.","tutorial_tip.next":"Next","tutorial_tip.ok":"Okay","tutorial_tip.out":"Opt out of these tips.","tutorial_tip.seen":"Seen this before? ","update_command.cancel":"Cancel","update_command.confirm":"Edit Slash Command","update_command.question":"Your changes may break the existing slash command. Are you sure you would like to update it?","update_command.update":"Update","update_incoming_webhook.update":"Update","update_oauth_app.confirm":"Edit OAuth 2.0 application","update_oauth_app.question":"Your changes may break the existing OAuth 2.0 application. Are you sure you would like to update it?","update_outgoing_webhook.confirm":"Edit Outgoing Webhook","update_outgoing_webhook.question":"Your changes may break the existing outgoing webhook. Are you sure you would like to update it?","update_outgoing_webhook.update":"Update","upload_overlay.info":"Drop a file to upload it.","user.settings.advance.embed_toggle":"Show toggle for all embed previews","user.settings.advance.enabledFeatures":"{count, number} {count, plural, one {Feature} other {Features}} Enabled","user.settings.advance.formattingDesc":"If enabled, posts will be formatted to create links, show emoji, style the text, and add line breaks. By default, this setting is enabled. Changing this setting requires the page to be refreshed.","user.settings.advance.formattingTitle":"Enable Post Formatting","user.settings.advance.joinLeaveDesc":"When \"On\", System Messages saying a user has joined or left a channel will be visible. When \"Off\", the System Messages about joining or leaving a channel will be hidden. A message will still show up when you are added to a channel, so you can receive a notification.","user.settings.advance.joinLeaveTitle":"Enable Join/Leave Messages","user.settings.advance.markdown_preview":"Show markdown preview option in message input box","user.settings.advance.off":"Off","user.settings.advance.on":"On","user.settings.advance.preReleaseDesc":"Check any pre-released features you'd like to preview.  You may also need to refresh the page before the setting will take effect.","user.settings.advance.preReleaseTitle":"Preview pre-release features","user.settings.advance.sendDesc":"If enabled ENTER inserts a new line and CTRL+ENTER submits the message.","user.settings.advance.sendTitle":"Send messages on CTRL+ENTER","user.settings.advance.slashCmd_autocmp":"Enable external application to offer slash command autocomplete","user.settings.advance.title":"Advanced Settings","user.settings.advance.webrtc_preview":"Enable the ability to make and receive one-on-one WebRTC calls","user.settings.custom_theme.awayIndicator":"Away Indicator","user.settings.custom_theme.buttonBg":"Button BG","user.settings.custom_theme.buttonColor":"Button Text","user.settings.custom_theme.centerChannelBg":"Center Channel BG","user.settings.custom_theme.centerChannelColor":"Center Channel Text","user.settings.custom_theme.centerChannelTitle":"Center Channel Styles","user.settings.custom_theme.codeTheme":"Code Theme","user.settings.custom_theme.copyPaste":"Copy and paste to share theme colors:","user.settings.custom_theme.dndIndicator":"Do Not Disturb Indicator","user.settings.custom_theme.linkButtonTitle":"Link and Button Styles","user.settings.custom_theme.linkColor":"Link Color","user.settings.custom_theme.mentionBj":"Mention Jewel BG","user.settings.custom_theme.mentionColor":"Mention Jewel Text","user.settings.custom_theme.mentionHighlightBg":"Mention Highlight BG","user.settings.custom_theme.mentionHighlightLink":"Mention Highlight Link","user.settings.custom_theme.newMessageSeparator":"New Message Separator","user.settings.custom_theme.onlineIndicator":"Online Indicator","user.settings.custom_theme.sidebarBg":"Sidebar BG","user.settings.custom_theme.sidebarHeaderBg":"Sidebar Header BG","user.settings.custom_theme.sidebarHeaderTextColor":"Sidebar Header Text","user.settings.custom_theme.sidebarText":"Sidebar Text","user.settings.custom_theme.sidebarTextActiveBorder":"Sidebar Text Active Border","user.settings.custom_theme.sidebarTextActiveColor":"Sidebar Text Active Color","user.settings.custom_theme.sidebarTextHoverBg":"Sidebar Text Hover BG","user.settings.custom_theme.sidebarTitle":"Sidebar Styles","user.settings.custom_theme.sidebarUnreadText":"Sidebar Unread Text","user.settings.display.channelDisplayTitle":"Channel Display Mode","user.settings.display.channeldisplaymode":"Select the width of the center channel.","user.settings.display.clockDisplay":"Clock Display","user.settings.display.collapseDesc":"Set whether previews of image links show as expanded or collapsed by default. This setting can also be controlled using the slash commands /expand and /collapse.","user.settings.display.collapseDisplay":"Default appearance of image link previews","user.settings.display.collapseOff":"Collapsed","user.settings.display.collapseOn":"Expanded","user.settings.display.fixedWidthCentered":"Fixed width, centered","user.settings.display.fullScreen":"Full width","user.settings.display.language":"Language","user.settings.display.linkPreviewDesc":"When available, the first web link in a message will show a preview of the website content below the message.","user.settings.display.linkPreviewDisplay":"Website Link Previews","user.settings.display.linkPreviewOff":"Off","user.settings.display.linkPreviewOn":"On","user.settings.display.messageDisplayClean":"Standard","user.settings.display.messageDisplayCleanDes":"Easy to scan and read.","user.settings.display.messageDisplayCompact":"Compact","user.settings.display.messageDisplayCompactDes":"Fit as many messages on the screen as we can.","user.settings.display.messageDisplayDescription":"Select how messages in a channel should be displayed.","user.settings.display.messageDisplayTitle":"Message Display","user.settings.display.militaryClock":"24-hour clock (example: 16:00)","user.settings.display.nameOptsDesc":"Set how to display other user's names in posts and the Direct Messages list.","user.settings.display.normalClock":"12-hour clock (example: 4:00 PM)","user.settings.display.preferTime":"Select how you prefer time displayed.","user.settings.display.teammateNameDisplayDescription":"Set how to display other user's names in posts and the Direct Messages list.","user.settings.display.teammateNameDisplayFullname":"Show first and last name","user.settings.display.teammateNameDisplayNicknameFullname":"Show nickname if one exists, otherwise show first and last name","user.settings.display.teammateNameDisplayTitle":"Teammate Name Display","user.settings.display.teammateNameDisplayUsername":"Show username","user.settings.display.theme.applyToAllTeams":"Apply new theme to all my teams","user.settings.display.theme.customTheme":"Custom Theme","user.settings.display.theme.describe":"Open to manage your theme","user.settings.display.theme.import":"Import theme colors from Slack","user.settings.display.theme.otherThemes":"See other themes","user.settings.display.theme.themeColors":"Theme Colors","user.settings.display.theme.title":"Theme","user.settings.display.timezone":"Timezone","user.settings.display.title":"Display Settings","user.settings.general.checkEmail":"Check your email at {email} to verify the address.","user.settings.general.checkEmailNoAddress":"Check your email to verify your new address","user.settings.general.close":"Close","user.settings.general.confirmEmail":"Confirm Email","user.settings.general.currentEmail":"Current Email","user.settings.general.email":"Email","user.settings.general.emailGitlabCantUpdate":"Login occurs through GitLab. Email cannot be updated. Email address used for notifications is {email}.","user.settings.general.emailGoogleCantUpdate":"Login occurs through Google. Email cannot be updated. Email address used for notifications is {email}.","user.settings.general.emailHelp1":"Email is used for sign-in, notifications, and password reset. Email requires verification if changed.","user.settings.general.emailHelp2":"Email has been disabled by your System Administrator. No notification emails will be sent until it is enabled.","user.settings.general.emailHelp3":"Email is used for sign-in, notifications, and password reset.","user.settings.general.emailHelp4":"A verification email was sent to {email}.","user.settings.general.emailLdapCantUpdate":"Login occurs through AD/LDAP. Email cannot be updated. Email address used for notifications is {email}.","user.settings.general.emailMatch":"The new emails you entered do not match.","user.settings.general.emailOffice365CantUpdate":"Login occurs through Office 365. Email cannot be updated. Email address used for notifications is {email}.","user.settings.general.emailSamlCantUpdate":"Login occurs through SAML. Email cannot be updated. Email address used for notifications is {email}.","user.settings.general.emailUnchanged":"Your new email address is the same as your old email address.","user.settings.general.emptyName":"Click 'Edit' to add your full name","user.settings.general.emptyNickname":"Click 'Edit' to add a nickname","user.settings.general.emptyPosition":"Click 'Edit' to add your job title / position","user.settings.general.field_handled_externally":"This field is handled through your login provider. If you want to change it, you need to do so through your login provider.","user.settings.general.firstName":"First Name","user.settings.general.fullName":"Full Name","user.settings.general.imageTooLarge":"Unable to upload profile image. File is too large.","user.settings.general.imageUpdated":"Image last updated {date}","user.settings.general.lastName":"Last Name","user.settings.general.loginGitlab":"Login done through GitLab ({email})","user.settings.general.loginGoogle":"Login done through Google ({email})","user.settings.general.loginLdap":"Login done through AD/LDAP ({email})","user.settings.general.loginOffice365":"Login done through Office 365 ({email})","user.settings.general.loginSaml":"Login done through SAML ({email})","user.settings.general.mobile.emptyName":"Click to add your full name","user.settings.general.mobile.emptyNickname":"Click to add a nickname","user.settings.general.mobile.emptyPosition":"Click to add your job title / position","user.settings.general.mobile.uploadImage":"Click to upload an image.","user.settings.general.newAddress":"New Address: {email}<br />Check your email to verify the above address.","user.settings.general.newEmail":"New Email","user.settings.general.nickname":"Nickname","user.settings.general.nicknameExtra":"Use Nickname for a name you might be called that is different from your first name and username. This is most often used when two or more people have similar sounding names and usernames.","user.settings.general.notificationsExtra":"By default, you will receive mention notifications when someone types your first name. Go to {notify} settings to change this default.","user.settings.general.notificationsLink":"Notifications","user.settings.general.position":"Position","user.settings.general.positionExtra":"Use Position for your role or job title. This will be shown in your profile popover.","user.settings.general.profilePicture":"Profile Picture","user.settings.general.title":"General Settings","user.settings.general.uploadImage":"Click 'Edit' to upload an image.","user.settings.general.username":"Username","user.settings.general.usernameInfo":"Pick something easy for teammates to recognize and recall.","user.settings.general.usernameReserved":"This username is reserved, please choose a new one.","user.settings.general.usernameRestrictions":"Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-', and '_'.","user.settings.general.validEmail":"Please enter a valid email address","user.settings.general.validImage":"Only BMP, JPG or PNG images may be used for profile pictures","user.settings.import_theme.cancel":"Cancel","user.settings.import_theme.importBody":"To import a theme, go to a Slack team and look for \"Preferences -> Sidebar Theme\". Open the custom theme option, copy the theme color values and paste them here:","user.settings.import_theme.importHeader":"Import Slack Theme","user.settings.import_theme.submit":"Submit","user.settings.import_theme.submitError":"Invalid format, please try copying and pasting in again.","user.settings.languages.change":"Change interface language","user.settings.languages.promote":"Select which language Mattermost displays in the user interface.<br /><br />Would like to help with translations? Join the <a href='http://translate.mattermost.com/' target='_blank'>Mattermost Translation Server</a> to contribute.","user.settings.mfa.add":"Add MFA to your account","user.settings.mfa.addHelp":"Adding multi-factor authentication will make your account more secure by requiring a code from your mobile phone each time you sign in.","user.settings.mfa.addHelpQr":"Please scan the QR code with the Google Authenticator app on your smartphone and fill in the token with one provided by the app. If you are unable to scan the code, you can manually enter the secret provided.","user.settings.mfa.enterToken":"Token (numbers only)","user.settings.mfa.qrCode":"Bar Code","user.settings.mfa.remove":"Remove MFA from your account","user.settings.mfa.removeHelp":"Removing multi-factor authentication means you will no longer require a phone-based passcode to sign-in to your account.","user.settings.mfa.requiredHelp":"Multi-factor authentication is required on this server. Resetting is only recommended when you need to switch code generation to a new mobile device. You will be required to set it up again immediately.","user.settings.mfa.reset":"Reset MFA on your account","user.settings.mfa.secret":"Secret","user.settings.mfa.title":"Multi-factor Authentication","user.settings.modal.advanced":"Advanced","user.settings.modal.confirmBtns":"Yes, Discard","user.settings.modal.confirmMsg":"You have unsaved changes, are you sure you want to discard them?","user.settings.modal.confirmTitle":"Discard Changes?","user.settings.modal.display":"Display","user.settings.modal.general":"General","user.settings.modal.notifications":"Notifications","user.settings.modal.security":"Security","user.settings.modal.sidebar":"Sidebar","user.settings.modal.title":"Account Settings","user.settings.notifications.allActivity":"For all activity","user.settings.notifications.channelWide":"Channel-wide mentions \"@channel\", \"@all\", \"@here\"","user.settings.notifications.close":"Close","user.settings.notifications.comments":"Reply notifications","user.settings.notifications.commentsAny":"Trigger notifications on messages in reply threads that I start or participate in","user.settings.notifications.commentsInfo":"In addition to notifications for when you're mentioned, select if you would like to receive notifications on reply threads.","user.settings.notifications.commentsNever":"Do not trigger notifications on messages in reply threads unless I'm mentioned","user.settings.notifications.commentsRoot":"Trigger notifications on messages in threads that I start","user.settings.notifications.desktop":"Send desktop notifications","user.settings.notifications.desktop.allNoSoundForever":"For all activity, without sound, shown indefinitely","user.settings.notifications.desktop.allNoSoundTimed":"For all activity, without sound, shown for {seconds} seconds","user.settings.notifications.desktop.allSoundForever":"For all activity, with sound, shown indefinitely","user.settings.notifications.desktop.allSoundHiddenForever":"For all activity, shown indefinitely","user.settings.notifications.desktop.allSoundHiddenTimed":"For all activity, shown for {seconds} seconds","user.settings.notifications.desktop.allSoundTimed":"For all activity, with sound, shown for {seconds} seconds","user.settings.notifications.desktop.duration":"Notification duration","user.settings.notifications.desktop.durationInfo":"Sets how long desktop notifications will remain on screen when using Firefox or Chrome. Desktop notifications in Edge, Safari and Mattermost Desktop Apps can only stay on screen for a maximum of 5 seconds.","user.settings.notifications.desktop.mentionsNoSoundForever":"For mentions and direct messages, without sound, shown indefinitely","user.settings.notifications.desktop.mentionsNoSoundTimed":"For mentions and direct messages, without sound, shown for {seconds} seconds","user.settings.notifications.desktop.mentionsSoundForever":"For mentions and direct messages, with sound, shown indefinitely","user.settings.notifications.desktop.mentionsSoundHiddenForever":"For mentions and direct messages, shown indefinitely","user.settings.notifications.desktop.mentionsSoundHiddenTimed":"For mentions and direct messages, shown for {seconds} seconds","user.settings.notifications.desktop.mentionsSoundTimed":"For mentions and direct messages, with sound, shown for {seconds} seconds","user.settings.notifications.desktop.seconds":"{seconds} seconds","user.settings.notifications.desktop.sound":"Notification sound","user.settings.notifications.desktop.title":"Desktop notifications","user.settings.notifications.desktop.unlimited":"Unlimited","user.settings.notifications.desktopSounds":"Desktop notification sounds","user.settings.notifications.email.disabled":"Disabled by System Administrator","user.settings.notifications.email.disabled_long":"Email notifications have been disabled by your System Administrator.","user.settings.notifications.email.everyHour":"Every hour","user.settings.notifications.email.everyXMinutes":"Every {count, plural, one {minute} other {{count, number} minutes}}","user.settings.notifications.email.immediately":"Immediately","user.settings.notifications.email.never":"Never","user.settings.notifications.email.send":"Send email notifications","user.settings.notifications.emailBatchingInfo":"Notifications received over the time period selected are combined and sent in a single email.","user.settings.notifications.emailInfo":"Email notifications are sent for mentions and direct messages when you are offline or away from {siteName} for more than 5 minutes.","user.settings.notifications.emailNotifications":"Email notifications","user.settings.notifications.header":"Notifications","user.settings.notifications.info":"Desktop notifications are available on Edge, Firefox, Safari, Chrome and Mattermost Desktop Apps.","user.settings.notifications.mentionsInfo":"Mentions trigger when someone sends a message that includes your username (\"@{username}\") or any of the options selected above.","user.settings.notifications.never":"Never","user.settings.notifications.noWords":"No words configured","user.settings.notifications.off":"Off","user.settings.notifications.on":"On","user.settings.notifications.onlyMentions":"Only for mentions and direct messages","user.settings.notifications.push":"Mobile push notifications","user.settings.notifications.push_notification.status":"Trigger push notifications when","user.settings.notifications.sensitiveName":"Your case sensitive first name \"{first_name}\"","user.settings.notifications.sensitiveUsername":"Your non-case sensitive username \"{username}\"","user.settings.notifications.sensitiveWords":"Other non-case sensitive words, separated by commas:","user.settings.notifications.soundConfig":"Please configure notification sounds in your browser settings","user.settings.notifications.sounds_info":"Notification sounds are available on IE11, Safari, Chrome and Mattermost Desktop Apps.","user.settings.notifications.teamWide":"Team-wide mentions \"@all\"","user.settings.notifications.title":"Notification Settings","user.settings.notifications.wordsTrigger":"Words that trigger mentions","user.settings.push_notification.allActivity":"For all activity","user.settings.push_notification.allActivityAway":"For all activity when away or offline","user.settings.push_notification.allActivityOffline":"For all activity when offline","user.settings.push_notification.allActivityOnline":"For all activity when online, away or offline","user.settings.push_notification.away":"Away or offline","user.settings.push_notification.disabled":"Disabled by System Administrator","user.settings.push_notification.disabled_long":"Push Notifications are not enabled. Contact your System Administrator.","user.settings.push_notification.info":"Notification alerts are pushed to your mobile device when there is activity in Mattermost.","user.settings.push_notification.off":"Off","user.settings.push_notification.offline":"Offline","user.settings.push_notification.online":"Online, away or offline","user.settings.push_notification.onlyMentions":"For mentions and direct messages","user.settings.push_notification.onlyMentionsAway":"For mentions and direct messages when away or offline","user.settings.push_notification.onlyMentionsOffline":"For mentions and direct messages when offline","user.settings.push_notification.onlyMentionsOnline":"For mentions and direct messages when online, away or offline","user.settings.push_notification.send":"Send mobile push notifications","user.settings.push_notification.status":"Trigger push notifications when","user.settings.push_notification.status_info":"Notification alerts are only pushed to your mobile device when your online status matches the selection above.","user.settings.security.active":"Active","user.settings.security.close":"Close","user.settings.security.currentPassword":"Current Password","user.settings.security.currentPasswordError":"Please enter your current password.","user.settings.security.deauthorize":"Deauthorize","user.settings.security.emailPwd":"Email and Password","user.settings.security.gitlab":"GitLab","user.settings.security.google":"Google","user.settings.security.inactive":"Inactive","user.settings.security.lastUpdated":"Last updated {date} at {time}","user.settings.security.ldap":"AD/LDAP","user.settings.security.loginGitlab":"Login done through GitLab","user.settings.security.loginGoogle":"Login done through Google Apps","user.settings.security.loginLdap":"Login done through AD/LDAP","user.settings.security.loginOffice365":"Login done through Office 365","user.settings.security.loginSaml":"Login done through SAML","user.settings.security.logoutActiveSessions":"View and Logout of Active Sessions","user.settings.security.method":"Sign-in Method","user.settings.security.newPassword":"New Password","user.settings.security.noApps":"No OAuth 2.0 Applications are authorized.","user.settings.security.oauthApps":"OAuth 2.0 Applications","user.settings.security.oauthAppsDescription":"Click 'Edit' to manage your OAuth 2.0 Applications","user.settings.security.oauthAppsHelp":"Applications act on your behalf to access your data based on the permissions you grant them.","user.settings.security.office365":"Office 365","user.settings.security.oneSignin":"You may only have one sign-in method at a time. Switching sign-in method will send an email notifying you if the change was successful.","user.settings.security.password":"Password","user.settings.security.passwordError":"Your password must contain between {min} and {max} characters.","user.settings.security.passwordErrorLowercase":"Your password must contain between {min} and {max} characters made up of at least one lowercase letter.","user.settings.security.passwordErrorLowercaseNumber":"Your password must contain between {min} and {max} characters made up of at least one lowercase letter and at least one number.","user.settings.security.passwordErrorLowercaseNumberSymbol":"Your password must contain between {min} and {max} characters made up of at least one lowercase letter, at least one number, and at least one symbol (e.g. \"~!@#$%^&*()\").","user.settings.security.passwordErrorLowercaseSymbol":"Your password must contain between {min} and {max} characters made up of at least one lowercase letter and at least one symbol (e.g. \"~!@#$%^&*()\").","user.settings.security.passwordErrorLowercaseUppercase":"Your password must contain between {min} and {max} characters made up of at least one lowercase letter and at least one uppercase letter.","user.settings.security.passwordErrorLowercaseUppercaseNumber":"Your password must contain between {min} and {max} characters made up of at least one lowercase letter, at least one uppercase letter, and at least one number.","user.settings.security.passwordErrorLowercaseUppercaseNumberSymbol":"Your password must contain between {min} and {max} characters made up of at least one lowercase letter, at least one uppercase letter, at least one number, and at least one symbol (e.g. \"~!@#$%^&*()\").","user.settings.security.passwordErrorLowercaseUppercaseSymbol":"Your password must contain between {min} and {max} characters made up of at least one lowercase letter, at least one uppercase letter, and at least one symbol (e.g. \"~!@#$%^&*()\").","user.settings.security.passwordErrorNumber":"Your password must contain between {min} and {max} characters made up of at least one number.","user.settings.security.passwordErrorNumberSymbol":"Your password must contain between {min} and {max} characters made up of at least one number and at least one symbol (e.g. \"~!@#$%^&*()\").","user.settings.security.passwordErrorSymbol":"Your password must contain between {min} and {max} characters made up of at least one symbol (e.g. \"~!@#$%^&*()\").","user.settings.security.passwordErrorUppercase":"Your password must contain between {min} and {max} characters made up of at least one uppercase letter.","user.settings.security.passwordErrorUppercaseNumber":"Your password must contain between {min} and {max} characters made up of at least one uppercase letter and at least one number.","user.settings.security.passwordErrorUppercaseNumberSymbol":"Your password must contain between {min} and {max} characters made up of at least one uppercase letter, at least one number, and at least one symbol (e.g. \"~!@#$%^&*()\").","user.settings.security.passwordErrorUppercaseSymbol":"Your password must contain between {min} and {max} characters made up of at least one uppercase letter and at least one symbol (e.g. \"~!@#$%^&*()\").","user.settings.security.passwordGitlabCantUpdate":"Login occurs through GitLab. Password cannot be updated.","user.settings.security.passwordGoogleCantUpdate":"Login occurs through Google Apps. Password cannot be updated.","user.settings.security.passwordLdapCantUpdate":"Login occurs through AD/LDAP. Password cannot be updated.","user.settings.security.passwordMatchError":"The new passwords you entered do not match.","user.settings.security.passwordMinLength":"Invalid minimum length, cannot show preview.","user.settings.security.passwordOffice365CantUpdate":"Login occurs through Office 365. Password cannot be updated.","user.settings.security.passwordSamlCantUpdate":"This field is handled through your login provider. If you want to change it, you need to do so through your login provider.","user.settings.security.retypePassword":"Retype New Password","user.settings.security.saml":"SAML","user.settings.security.switchEmail":"Switch to using email and password","user.settings.security.switchGitlab":"Switch to using GitLab SSO","user.settings.security.switchGoogle":"Switch to using Google SSO","user.settings.security.switchLdap":"Switch to using AD/LDAP","user.settings.security.switchOffice365":"Switch to using Office 365 SSO","user.settings.security.switchSaml":"Switch to using SAML SSO","user.settings.security.title":"Security Settings","user.settings.security.viewHistory":"View Access History","user.settings.sidebar.after_seven_days":"After 7 days with no new messages","user.settings.sidebar.autoCloseDMDesc":"Direct Message conversations can be reopened with the “+” button in the sidebar or using the Channel Switcher (CTRL+K).","user.settings.sidebar.autoCloseDMTitle":"Automatically Close Direct Messages","user.settings.sidebar.never":"Never","user.settings.sidebar.showUnreadSection":"At the top of the channel sidebar","user.settings.sidebar.title":"Sidebar Settings","user.settings.sidebar.unreadSectionDesc":"Unread channels will be sorted at the top of the channel sidebar until read.","user.settings.sidebar.unreadSectionTitle":"Group unread channels","user.settings.timezones.automatic":"Set automatically","user.settings.timezones.change":"Change timezone","user.settings.timezones.promote":"Select the timezone used for timestamps in the user interface and email notifications.","user.settings.tokens.activate":"Activate","user.settings.tokens.cancel":"Cancel","user.settings.tokens.clickToEdit":"Click 'Edit' to manage your personal access tokens","user.settings.tokens.confirmCreateButton":"Yes, Create","user.settings.tokens.confirmCreateMessage":"You are generating a personal access token with System Admin permissions. Are you sure want to create this token?","user.settings.tokens.confirmCreateTitle":"Create System Admin Personal Access Token","user.settings.tokens.confirmDeactivateButton":"Yes, Deactivate","user.settings.tokens.confirmDeactivateMessage":"Any integrations using this token will not be able to access the Mattermost API until the token is reactivated. <br /><br />Are you sure want to deactivate the {description} token?","user.settings.tokens.confirmDeactivateTitle":"Deactivate Token?","user.settings.tokens.confirmDeleteButton":"Yes, Delete","user.settings.tokens.confirmDeleteMessage":"Any integrations using this token will no longer be able to access the Mattermost API. You cannot undo this action. <br /><br />Are you sure want to delete the <strong>{description}</strong> token?","user.settings.tokens.confirmDeleteTitle":"Delete Token?","user.settings.tokens.copy":"Please copy the access token below. You won't be able to see it again!","user.settings.tokens.create":"Create New Token","user.settings.tokens.deactivate":"Deactivate","user.settings.tokens.deactivatedWarning":"(Inactive)","user.settings.tokens.delete":"Delete","user.settings.tokens.description":"<a href=\"https://about.mattermost.com/default-user-access-tokens\" target=\"_blank\">Personal access tokens</a> function similarly to session tokens and can be used by integrations to <a href=\"https://about.mattermost.com/default-api-authentication\" target=\"_blank\">authenticate against the REST API</a>.","user.settings.tokens.description_mobile":"<a href=\"https://about.mattermost.com/default-user-access-tokens\" target=\"_blank\">Personal access tokens</a> function similarly to session tokens and can be used by integrations to <a href=\"https://about.mattermost.com/default-api-authentication\" target=\"_blank\">authenticate against the REST API</a>. Create new tokens on your desktop.","user.settings.tokens.id":"Token ID: ","user.settings.tokens.name":"Token Description: ","user.settings.tokens.nameHelp":"Enter a description for your token to remember what it does.","user.settings.tokens.nameRequired":"Please enter a description.","user.settings.tokens.save":"Save","user.settings.tokens.title":"Personal Access Tokens","user.settings.tokens.token":"Access Token: ","user.settings.tokens.tokenDesc":"Token Description: ","user.settings.tokens.tokenId":"Token ID: ","user.settings.tokens.userAccessTokensNone":"No personal access tokens.","user_list.notFound":"No users found","user_profile.account.editSettings":"Edit Account Settings","user_profile.account.localTime":"Local Time: ","user_profile.send.dm":"Send Message","user_profile.webrtc.call":"Start Video Call","user_profile.webrtc.offline":"The user is offline","user_profile.webrtc.unavailable":"New call unavailable until your existing call ends","view_image.loading":"Loading ","view_image_popover.download":"Download","view_image_popover.file":"File {count, number} of {total, number}","view_image_popover.publicLink":"Get Public Link","web.footer.about":"About","web.footer.help":"Help","web.footer.privacy":"Privacy","web.footer.terms":"Terms","web.header.back":"Back","web.header.logout":"Logout","web.root.signup_info":"All team communication in one place, searchable and accessible anywhere","webrtc.busy":"{username} is busy.","webrtc.call":"Call","webrtc.callEnded":"Call with {username} ended.","webrtc.cancel":"Cancel call","webrtc.cancelled":"{username} cancelled the call.","webrtc.declined":"Your call has been declined by {username}.","webrtc.disabled":"{username} has WebRTC disabled, and cannot receive calls. To enable the feature, they must go to Account Settings > Advanced > Preview pre-release features and turn on WebRTC.","webrtc.failed":"There was a problem connecting the video call.","webrtc.hangup":"Hang up","webrtc.header":"Call with {username}","webrtc.inProgress":"You have a call in progress. Please hang up first.","webrtc.mediaError":"Unable to access camera or microphone.","webrtc.mute_audio":"Mute microphone","webrtc.noAnswer":"{username} is not answering the call.","webrtc.notification.answer":"Answer","webrtc.notification.decline":"Decline","webrtc.notification.incoming_call":"{username} is calling you.","webrtc.notification.returnToCall":"Return to ongoing call with {username}","webrtc.offline":"{username} is offline.","webrtc.pause_video":"Turn off camera","webrtc.unmute_audio":"Unmute microphone","webrtc.unpause_video":"Turn on camera","webrtc.unsupported":"{username} client does not support video calls.","youtube_video.notFound":"Video not found","ent.cluster.save_config_with_roles.error":"The following configuration settings cannot be saved when High Availability is enabled and the System Console is in read-only mode: {keys}."}

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";return[{locale:"de",pluralRuleFunction:function(e,t){var n=!String(e).split(".")[1];return t?"other":1==e&&n?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},minute:{displayName:"Minute",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-IT",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}]});


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr"},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=o())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,o){var t=!String(e).split(".")[1];return o?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ja=t())}(this,function(){"use strict";return[{locale:"ja",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},minute:{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},second:{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}}]});


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ko=t())}(this,function(){"use strict";return[{locale:"ko",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"년",relative:{0:"올해",1:"내년","-1":"작년"},relativeTime:{future:{other:"{0}년 후"},past:{other:"{0}년 전"}}},month:{displayName:"월",relative:{0:"이번 달",1:"다음 달","-1":"지난달"},relativeTime:{future:{other:"{0}개월 후"},past:{other:"{0}개월 전"}}},day:{displayName:"일",relative:{0:"오늘",1:"내일",2:"모레","-2":"그저께","-1":"어제"},relativeTime:{future:{other:"{0}일 후"},past:{other:"{0}일 전"}}},hour:{displayName:"시",relative:{0:"현재 시간"},relativeTime:{future:{other:"{0}시간 후"},past:{other:"{0}시간 전"}}},minute:{displayName:"분",relative:{0:"현재 분"},relativeTime:{future:{other:"{0}분 후"},past:{other:"{0}분 전"}}},second:{displayName:"초",relative:{0:"지금"},relativeTime:{future:{other:"{0}초 후"},past:{other:"{0}초 전"}}}}},{locale:"ko-KP",parentLocale:"ko"}]});


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.nl=n())}(this,function(){"use strict";return[{locale:"nl",pluralRuleFunction:function(e,n){var a=!String(e).split(".")[1];return n?"other":1==e&&a?"one":"other"},fields:{year:{displayName:"jaar",relative:{0:"dit jaar",1:"volgend jaar","-1":"vorig jaar"},relativeTime:{future:{one:"over {0} jaar",other:"over {0} jaar"},past:{one:"{0} jaar geleden",other:"{0} jaar geleden"}}},month:{displayName:"maand",relative:{0:"deze maand",1:"volgende maand","-1":"vorige maand"},relativeTime:{future:{one:"over {0} maand",other:"over {0} maanden"},past:{one:"{0} maand geleden",other:"{0} maanden geleden"}}},day:{displayName:"dag",relative:{0:"vandaag",1:"morgen",2:"overmorgen","-2":"eergisteren","-1":"gisteren"},relativeTime:{future:{one:"over {0} dag",other:"over {0} dagen"},past:{one:"{0} dag geleden",other:"{0} dagen geleden"}}},hour:{displayName:"uur",relative:{0:"binnen een uur"},relativeTime:{future:{one:"over {0} uur",other:"over {0} uur"},past:{one:"{0} uur geleden",other:"{0} uur geleden"}}},minute:{displayName:"minuut",relative:{0:"binnen een minuut"},relativeTime:{future:{one:"over {0} minuut",other:"over {0} minuten"},past:{one:"{0} minuut geleden",other:"{0} minuten geleden"}}},second:{displayName:"seconde",relative:{0:"nu"},relativeTime:{future:{one:"over {0} seconde",other:"over {0} seconden"},past:{one:"{0} seconde geleden",other:"{0} seconden geleden"}}}}},{locale:"nl-AW",parentLocale:"nl"},{locale:"nl-BE",parentLocale:"nl"},{locale:"nl-BQ",parentLocale:"nl"},{locale:"nl-CW",parentLocale:"nl"},{locale:"nl-SR",parentLocale:"nl"},{locale:"nl-SX",parentLocale:"nl"}]});


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.pl=t())}(this,function(){"use strict";return[{locale:"pl",pluralRuleFunction:function(e,t){var a=String(e).split("."),i=a[0],n=!a[1],m=i.slice(-1),u=i.slice(-2);return t?"other":1==e&&n?"one":n&&m>=2&&m<=4&&(u<12||u>14)?"few":n&&1!=i&&(0==m||1==m)||n&&m>=5&&m<=9||n&&u>=12&&u<=14?"many":"other"},fields:{year:{displayName:"rok",relative:{0:"w tym roku",1:"w przyszłym roku","-1":"w zeszłym roku"},relativeTime:{future:{one:"za {0} rok",few:"za {0} lata",many:"za {0} lat",other:"za {0} roku"},past:{one:"{0} rok temu",few:"{0} lata temu",many:"{0} lat temu",other:"{0} roku temu"}}},month:{displayName:"miesiąc",relative:{0:"w tym miesiącu",1:"w przyszłym miesiącu","-1":"w zeszłym miesiącu"},relativeTime:{future:{one:"za {0} miesiąc",few:"za {0} miesiące",many:"za {0} miesięcy",other:"za {0} miesiąca"},past:{one:"{0} miesiąc temu",few:"{0} miesiące temu",many:"{0} miesięcy temu",other:"{0} miesiąca temu"}}},day:{displayName:"dzień",relative:{0:"dzisiaj",1:"jutro",2:"pojutrze","-2":"przedwczoraj","-1":"wczoraj"},relativeTime:{future:{one:"za {0} dzień",few:"za {0} dni",many:"za {0} dni",other:"za {0} dnia"},past:{one:"{0} dzień temu",few:"{0} dni temu",many:"{0} dni temu",other:"{0} dnia temu"}}},hour:{displayName:"godzina",relative:{0:"ta godzina"},relativeTime:{future:{one:"za {0} godzinę",few:"za {0} godziny",many:"za {0} godzin",other:"za {0} godziny"},past:{one:"{0} godzinę temu",few:"{0} godziny temu",many:"{0} godzin temu",other:"{0} godziny temu"}}},minute:{displayName:"minuta",relative:{0:"ta minuta"},relativeTime:{future:{one:"za {0} minutę",few:"za {0} minuty",many:"za {0} minut",other:"za {0} minuty"},past:{one:"{0} minutę temu",few:"{0} minuty temu",many:"{0} minut temu",other:"{0} minuty temu"}}},second:{displayName:"sekunda",relative:{0:"teraz"},relativeTime:{future:{one:"za {0} sekundę",few:"za {0} sekundy",many:"za {0} sekund",other:"za {0} sekundy"},past:{one:"{0} sekundę temu",few:"{0} sekundy temu",many:"{0} sekund temu",other:"{0} sekundy temu"}}}}}]});


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.pt=t())}(this,function(){"use strict";return[{locale:"pt",pluralRuleFunction:function(e,t){var o=String(e).split(".")[0];return t?"other":0==o||1==o?"one":"other"},fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"em {0} ano",other:"em {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"em {0} mês",other:"em {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"em {0} dia",other:"em {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"em {0} hora",other:"em {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"em {0} minuto",other:"em {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"em {0} segundo",other:"em {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}}}},{locale:"pt-AO",parentLocale:"pt-PT"},{locale:"pt-PT",parentLocale:"pt",fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"dentro de {0} ano",other:"dentro de {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"dentro de {0} mês",other:"dentro de {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"dentro de {0} dia",other:"dentro de {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}}}},{locale:"pt-CH",parentLocale:"pt-PT"},{locale:"pt-CV",parentLocale:"pt-PT"},{locale:"pt-GQ",parentLocale:"pt-PT"},{locale:"pt-GW",parentLocale:"pt-PT"},{locale:"pt-LU",parentLocale:"pt-PT"},{locale:"pt-MO",parentLocale:"pt-PT"},{locale:"pt-MZ",parentLocale:"pt-PT"},{locale:"pt-ST",parentLocale:"pt-PT"},{locale:"pt-TL",parentLocale:"pt-PT"}]});


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.tr=a())}(this,function(){"use strict";return[{locale:"tr",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"yıl",relative:{0:"bu yıl",1:"gelecek yıl","-1":"geçen yıl"},relativeTime:{future:{one:"{0} yıl sonra",other:"{0} yıl sonra"},past:{one:"{0} yıl önce",other:"{0} yıl önce"}}},month:{displayName:"ay",relative:{0:"bu ay",1:"gelecek ay","-1":"geçen ay"},relativeTime:{future:{one:"{0} ay sonra",other:"{0} ay sonra"},past:{one:"{0} ay önce",other:"{0} ay önce"}}},day:{displayName:"gün",relative:{0:"bugün",1:"yarın",2:"öbür gün","-2":"evvelsi gün","-1":"dün"},relativeTime:{future:{one:"{0} gün sonra",other:"{0} gün sonra"},past:{one:"{0} gün önce",other:"{0} gün önce"}}},hour:{displayName:"saat",relative:{0:"bu saat"},relativeTime:{future:{one:"{0} saat sonra",other:"{0} saat sonra"},past:{one:"{0} saat önce",other:"{0} saat önce"}}},minute:{displayName:"dakika",relative:{0:"bu dakika"},relativeTime:{future:{one:"{0} dakika sonra",other:"{0} dakika sonra"},past:{one:"{0} dakika önce",other:"{0} dakika önce"}}},second:{displayName:"saniye",relative:{0:"şimdi"},relativeTime:{future:{one:"{0} saniye sonra",other:"{0} saniye sonra"},past:{one:"{0} saniye önce",other:"{0} saniye önce"}}}}},{locale:"tr-CY",parentLocale:"tr"}]});


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ru=a())}(this,function(){"use strict";return[{locale:"ru",pluralRuleFunction:function(e,a){var t=String(e).split("."),r=t[0],o=!t[1],n=r.slice(-1),l=r.slice(-2);return a?"other":o&&1==n&&11!=l?"one":o&&n>=2&&n<=4&&(l<12||l>14)?"few":o&&0==n||o&&n>=5&&n<=9||o&&l>=11&&l<=14?"many":"other"},fields:{year:{displayName:"год",relative:{0:"в этом году",1:"в следующем году","-1":"в прошлом году"},relativeTime:{future:{one:"через {0} год",few:"через {0} года",many:"через {0} лет",other:"через {0} года"},past:{one:"{0} год назад",few:"{0} года назад",many:"{0} лет назад",other:"{0} года назад"}}},month:{displayName:"месяц",relative:{0:"в этом месяце",1:"в следующем месяце","-1":"в прошлом месяце"},relativeTime:{future:{one:"через {0} месяц",few:"через {0} месяца",many:"через {0} месяцев",other:"через {0} месяца"},past:{one:"{0} месяц назад",few:"{0} месяца назад",many:"{0} месяцев назад",other:"{0} месяца назад"}}},day:{displayName:"день",relative:{0:"сегодня",1:"завтра",2:"послезавтра","-2":"позавчера","-1":"вчера"},relativeTime:{future:{one:"через {0} день",few:"через {0} дня",many:"через {0} дней",other:"через {0} дня"},past:{one:"{0} день назад",few:"{0} дня назад",many:"{0} дней назад",other:"{0} дня назад"}}},hour:{displayName:"час",relative:{0:"в этом часе"},relativeTime:{future:{one:"через {0} час",few:"через {0} часа",many:"через {0} часов",other:"через {0} часа"},past:{one:"{0} час назад",few:"{0} часа назад",many:"{0} часов назад",other:"{0} часа назад"}}},minute:{displayName:"минута",relative:{0:"в эту минуту"},relativeTime:{future:{one:"через {0} минуту",few:"через {0} минуты",many:"через {0} минут",other:"через {0} минуты"},past:{one:"{0} минуту назад",few:"{0} минуты назад",many:"{0} минут назад",other:"{0} минуты назад"}}},second:{displayName:"секунда",relative:{0:"сейчас"},relativeTime:{future:{one:"через {0} секунду",few:"через {0} секунды",many:"через {0} секунд",other:"через {0} секунды"},past:{one:"{0} секунду назад",few:"{0} секунды назад",many:"{0} секунд назад",other:"{0} секунды назад"}}}}},{locale:"ru-BY",parentLocale:"ru"},{locale:"ru-KG",parentLocale:"ru"},{locale:"ru-KZ",parentLocale:"ru"},{locale:"ru-MD",parentLocale:"ru"},{locale:"ru-UA",parentLocale:"ru"}]});


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";return[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}]});


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/de.1b958af6a4b8b9658855bc1906705eec.json";

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/es.fa26497c8527fb8654d90e75c2c26a7a.json";

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/fr.eace094d5307c3d4ad68fe880eb50d0e.json";

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/it.d3d0e500e1b1dcac1c7faaf3a7ffb1a9.json";

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/ja.232addcf0a32b929a917dac0755a9573.json";

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/ko.bbe46216a6eb4b91916e8b1985431840.json";

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/nl.6de76209221e0407c72f76e9d4fb4974.json";

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/pl.c8bb2becb1a999acb1278180e29ac7c5.json";

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/pt-BR.89ad4c6d8a94867bbfc671b2e712bc28.json";

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/tr.c303d42567840e4b00c5f033f9a7ee02.json";

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/ru.fe6a30576bbb9849b93f1fe5330b780e.json";

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/zh-TW.629f747804cc8c21bb02af6d5c075492.json";

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/zh-CN.43a45234f5f366faeb0a360e6e0dab8b.json";

/***/ }),
/* 1866 */,
/* 1867 */,
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(283);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LatexBlock = function (_React$Component) {
    (0, _inherits3.default)(LatexBlock, _React$Component);

    function LatexBlock(props) {
        (0, _classCallCheck3.default)(this, LatexBlock);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LatexBlock.__proto__ || (0, _getPrototypeOf2.default)(LatexBlock)).call(this, props));

        _this.state = {
            katex: null
        };
        return _this;
    }

    (0, _createClass3.default)(LatexBlock, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _promise2.default.resolve().then(function () {
                return __webpack_require__(1869);
            }).then(function (katex) {
                _this2.setState({ katex: katex });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.katex == null) {
                return _react2.default.createElement(
                    'div',
                    {
                        className: 'post-body--code tex'
                    },
                    this.props.content
                );
            }

            try {
                var html = this.state.katex.renderToString(this.props.content, { throwOnError: false, displayMode: true });

                return _react2.default.createElement('div', {
                    className: 'post-body--code tex',
                    dangerouslySetInnerHTML: { __html: html }
                });
            } catch (e) {
                return _react2.default.createElement(
                    'div',
                    {
                        className: 'post-body--code tex'
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'katex.error',
                        defaultMessage: 'Couldn\'t compile your Latex code. Please review the syntax and try again.'
                    })
                );
            }
        }
    }]);
    return LatexBlock;
}(_react2.default.Component); // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

LatexBlock.propTypes = {
    content: _propTypes2.default.string.isRequired
};
exports.default = LatexBlock;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(e){if(true){module.exports=e()}else if(typeof define==="function"&&define.amd){define([],e)}else{var t;if(typeof window!=="undefined"){t=window}else if(typeof global!=="undefined"){t=global}else if(typeof self!=="undefined"){t=self}else{t=this}t.katex=e()}})(function(){var e,t,r;return function e(t,r,a){function n(l,u){if(!r[l]){if(!t[l]){var o=typeof require=="function"&&require;if(!u&&o)return require(l,!0);if(i)return i(l,!0);var s=new Error("Cannot find module '"+l+"'");throw s.code="MODULE_NOT_FOUND",s}var f=r[l]={exports:{}};t[l][0].call(f.exports,function(e){var r=t[l][1][e];return n(r?r:e)},f,f.exports,e,t,r,a)}return r[l].exports}var i=typeof require=="function"&&require;for(var l=0;l<a.length;l++)n(a[l]);return n}({1:[function(e,t,r){"use strict";var a=e("./src/ParseError");var n=c(a);var i=e("./src/Settings");var l=c(i);var u=e("./src/buildTree");var o=e("./src/parseTree");var s=c(o);var f=e("./src/utils");var d=c(f);function c(e){return e&&e.__esModule?e:{default:e}}var h=function e(t,r,a){d.default.clearNode(r);var n=m(t,a).toNode();r.appendChild(n)};if(typeof document!=="undefined"){if(document.compatMode!=="CSS1Compat"){typeof console!=="undefined"&&console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your "+"website has a suitable doctype.");h=function e(){throw new n.default("KaTeX doesn't work in quirks mode.")}}}var v=function e(t,r){var a=m(t,r).toMarkup();return a};var p=function e(t,r){var a=new l.default(r);return(0,s.default)(t,a)};var m=function e(t,r){var a=new l.default(r);var n=(0,s.default)(t,a);return(0,u.buildTree)(n,t,a)};var g=function e(t,r){var a=new l.default(r);var n=(0,s.default)(t,a);return(0,u.buildHTMLTree)(n,t,a)};t.exports={render:h,renderToString:v,ParseError:n.default,__parse:p,__renderToDomTree:m,__renderToHTMLTree:g}},{"./src/ParseError":84,"./src/Settings":87,"./src/buildTree":94,"./src/parseTree":125,"./src/utils":133}],2:[function(e,t,r){t.exports={default:e("core-js/library/fn/array/from"),__esModule:true}},{"core-js/library/fn/array/from":12}],3:[function(e,t,r){t.exports={default:e("core-js/library/fn/get-iterator"),__esModule:true}},{"core-js/library/fn/get-iterator":13}],4:[function(e,t,r){t.exports={default:e("core-js/library/fn/is-iterable"),__esModule:true}},{"core-js/library/fn/is-iterable":14}],5:[function(e,t,r){t.exports={default:e("core-js/library/fn/json/stringify"),__esModule:true}},{"core-js/library/fn/json/stringify":15}],6:[function(e,t,r){t.exports={default:e("core-js/library/fn/object/define-property"),__esModule:true}},{"core-js/library/fn/object/define-property":16}],7:[function(e,t,r){t.exports={default:e("core-js/library/fn/object/freeze"),__esModule:true}},{"core-js/library/fn/object/freeze":17}],8:[function(e,t,r){"use strict";r.__esModule=true;r.default=function(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}},{}],9:[function(e,t,r){"use strict";r.__esModule=true;var a=e("../core-js/object/define-property");var n=i(a);function i(e){return e&&e.__esModule?e:{default:e}}r.default=function(){function e(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||false;a.configurable=true;if("value"in a)a.writable=true;(0,n.default)(e,a.key,a)}}return function(t,r,a){if(r)e(t.prototype,r);if(a)e(t,a);return t}}()},{"../core-js/object/define-property":6}],10:[function(e,t,r){"use strict";r.__esModule=true;var a=e("../core-js/is-iterable");var n=u(a);var i=e("../core-js/get-iterator");var l=u(i);function u(e){return e&&e.__esModule?e:{default:e}}r.default=function(){function e(e,t){var r=[];var a=true;var n=false;var i=undefined;try{for(var u=(0,l.default)(e),o;!(a=(o=u.next()).done);a=true){r.push(o.value);if(t&&r.length===t)break}}catch(e){n=true;i=e}finally{try{if(!a&&u["return"])u["return"]()}finally{if(n)throw i}}return r}return function(t,r){if(Array.isArray(t)){return t}else if((0,n.default)(Object(t))){return e(t,r)}else{throw new TypeError("Invalid attempt to destructure non-iterable instance")}}}()},{"../core-js/get-iterator":3,"../core-js/is-iterable":4}],11:[function(e,t,r){"use strict";r.__esModule=true;var a=e("../core-js/array/from");var n=i(a);function i(e){return e&&e.__esModule?e:{default:e}}r.default=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++){r[t]=e[t]}return r}else{return(0,n.default)(e)}}},{"../core-js/array/from":2}],12:[function(e,t,r){e("../../modules/es6.string.iterator");e("../../modules/es6.array.from");t.exports=e("../../modules/_core").Array.from},{"../../modules/_core":24,"../../modules/es6.array.from":73,"../../modules/es6.string.iterator":77}],13:[function(e,t,r){e("../modules/web.dom.iterable");e("../modules/es6.string.iterator");t.exports=e("../modules/core.get-iterator")},{"../modules/core.get-iterator":71,"../modules/es6.string.iterator":77,"../modules/web.dom.iterable":78}],14:[function(e,t,r){e("../modules/web.dom.iterable");e("../modules/es6.string.iterator");t.exports=e("../modules/core.is-iterable")},{"../modules/core.is-iterable":72,"../modules/es6.string.iterator":77,"../modules/web.dom.iterable":78}],15:[function(e,t,r){var a=e("../../modules/_core"),n=a.JSON||(a.JSON={stringify:JSON.stringify});t.exports=function e(t){return n.stringify.apply(n,arguments)}},{"../../modules/_core":24}],16:[function(e,t,r){e("../../modules/es6.object.define-property");var a=e("../../modules/_core").Object;t.exports=function e(t,r,n){return a.defineProperty(t,r,n)}},{"../../modules/_core":24,"../../modules/es6.object.define-property":75}],17:[function(e,t,r){e("../../modules/es6.object.freeze");t.exports=e("../../modules/_core").Object.freeze},{"../../modules/_core":24,"../../modules/es6.object.freeze":76}],18:[function(e,t,r){t.exports=function(e){if(typeof e!="function")throw TypeError(e+" is not a function!");return e}},{}],19:[function(e,t,r){t.exports=function(){}},{}],20:[function(e,t,r){var a=e("./_is-object");t.exports=function(e){if(!a(e))throw TypeError(e+" is not an object!");return e}},{"./_is-object":40}],21:[function(e,t,r){var a=e("./_to-iobject"),n=e("./_to-length"),i=e("./_to-index");t.exports=function(e){return function(t,r,l){var u=a(t),o=n(u.length),s=i(l,o),f;if(e&&r!=r)while(o>s){f=u[s++];if(f!=f)return true}else for(;o>s;s++)if(e||s in u){if(u[s]===r)return e||s||0}return!e&&-1}}},{"./_to-index":62,"./_to-iobject":64,"./_to-length":65}],22:[function(e,t,r){var a=e("./_cof"),n=e("./_wks")("toStringTag"),i=a(function(){return arguments}())=="Arguments";var l=function(e,t){try{return e[t]}catch(e){}};t.exports=function(e){var t,r,u;return e===undefined?"Undefined":e===null?"Null":typeof(r=l(t=Object(e),n))=="string"?r:i?a(t):(u=a(t))=="Object"&&typeof t.callee=="function"?"Arguments":u}},{"./_cof":23,"./_wks":69}],23:[function(e,t,r){var a={}.toString;t.exports=function(e){return a.call(e).slice(8,-1)}},{}],24:[function(e,t,r){var a=t.exports={version:"2.4.0"};if(typeof __e=="number")__e=a},{}],25:[function(e,t,r){"use strict";var a=e("./_object-dp"),n=e("./_property-desc");t.exports=function(e,t,r){if(t in e)a.f(e,t,n(0,r));else e[t]=r}},{"./_object-dp":50,"./_property-desc":56}],26:[function(e,t,r){var a=e("./_a-function");t.exports=function(e,t,r){a(e);if(t===undefined)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,a){return e.call(t,r,a)};case 3:return function(r,a,n){return e.call(t,r,a,n)}}return function(){return e.apply(t,arguments)}}},{"./_a-function":18}],27:[function(e,t,r){t.exports=function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e}},{}],28:[function(e,t,r){t.exports=!e("./_fails")(function(){return Object.defineProperty({},"a",{get:function(){return 7}}).a!=7})},{"./_fails":32}],29:[function(e,t,r){var a=e("./_is-object"),n=e("./_global").document,i=a(n)&&a(n.createElement);t.exports=function(e){return i?n.createElement(e):{}}},{"./_global":33,"./_is-object":40}],30:[function(e,t,r){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},{}],31:[function(e,t,r){var a=e("./_global"),n=e("./_core"),i=e("./_ctx"),l=e("./_hide"),u="prototype";var o=function(e,t,r){var s=e&o.F,f=e&o.G,d=e&o.S,c=e&o.P,h=e&o.B,v=e&o.W,p=f?n:n[t]||(n[t]={}),m=p[u],g=f?a:d?a[t]:(a[t]||{})[u],b,y,x;if(f)r=t;for(b in r){y=!s&&g&&g[b]!==undefined;if(y&&b in p)continue;x=y?g[b]:r[b];p[b]=f&&typeof g[b]!="function"?r[b]:h&&y?i(x,a):v&&g[b]==x?function(e){var t=function(t,r,a){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,a)}return e.apply(this,arguments)};t[u]=e[u];return t}(x):c&&typeof x=="function"?i(Function.call,x):x;if(c){(p.virtual||(p.virtual={}))[b]=x;if(e&o.R&&m&&!m[b])l(m,b,x)}}};o.F=1;o.G=2;o.S=4;o.P=8;o.B=16;o.W=32;o.U=64;o.R=128;t.exports=o},{"./_core":24,"./_ctx":26,"./_global":33,"./_hide":35}],32:[function(e,t,r){t.exports=function(e){try{return!!e()}catch(e){return true}}},{}],33:[function(e,t,r){var a=t.exports=typeof window!="undefined"&&window.Math==Math?window:typeof self!="undefined"&&self.Math==Math?self:Function("return this")();if(typeof __g=="number")__g=a},{}],34:[function(e,t,r){var a={}.hasOwnProperty;t.exports=function(e,t){return a.call(e,t)}},{}],35:[function(e,t,r){var a=e("./_object-dp"),n=e("./_property-desc");t.exports=e("./_descriptors")?function(e,t,r){return a.f(e,t,n(1,r))}:function(e,t,r){e[t]=r;return e}},{"./_descriptors":28,"./_object-dp":50,"./_property-desc":56}],36:[function(e,t,r){t.exports=e("./_global").document&&document.documentElement},{"./_global":33}],37:[function(e,t,r){t.exports=!e("./_descriptors")&&!e("./_fails")(function(){return Object.defineProperty(e("./_dom-create")("div"),"a",{get:function(){return 7}}).a!=7})},{"./_descriptors":28,"./_dom-create":29,"./_fails":32}],38:[function(e,t,r){var a=e("./_cof");t.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return a(e)=="String"?e.split(""):Object(e)}},{"./_cof":23}],39:[function(e,t,r){var a=e("./_iterators"),n=e("./_wks")("iterator"),i=Array.prototype;t.exports=function(e){return e!==undefined&&(a.Array===e||i[n]===e)}},{"./_iterators":46,"./_wks":69}],40:[function(e,t,r){t.exports=function(e){return typeof e==="object"?e!==null:typeof e==="function"}},{}],41:[function(e,t,r){var a=e("./_an-object");t.exports=function(e,t,r,n){try{return n?t(a(r)[0],r[1]):t(r)}catch(t){var i=e["return"];if(i!==undefined)a(i.call(e));throw t}}},{"./_an-object":20}],42:[function(e,t,r){"use strict";var a=e("./_object-create"),n=e("./_property-desc"),i=e("./_set-to-string-tag"),l={};e("./_hide")(l,e("./_wks")("iterator"),function(){return this});t.exports=function(e,t,r){e.prototype=a(l,{next:n(1,r)});i(e,t+" Iterator")}},{"./_hide":35,"./_object-create":49,"./_property-desc":56,"./_set-to-string-tag":58,"./_wks":69}],43:[function(e,t,r){"use strict";var a=e("./_library"),n=e("./_export"),i=e("./_redefine"),l=e("./_hide"),u=e("./_has"),o=e("./_iterators"),s=e("./_iter-create"),f=e("./_set-to-string-tag"),d=e("./_object-gpo"),c=e("./_wks")("iterator"),h=!([].keys&&"next"in[].keys()),v="@@iterator",p="keys",m="values";var g=function(){return this};t.exports=function(e,t,r,b,y,x,w){s(r,t,b);var M=function(e){if(!h&&e in T)return T[e];switch(e){case p:return function t(){return new r(this,e)};case m:return function t(){return new r(this,e)}}return function t(){return new r(this,e)}};var k=t+" Iterator",_=y==m,S=false,T=e.prototype,z=T[c]||T[v]||y&&T[y],C=z||M(y),A=y?!_?C:M("entries"):undefined,O=t=="Array"?T.entries||z:z,L,N,E;if(O){E=d(O.call(new e));if(E!==Object.prototype){f(E,k,true);if(!a&&!u(E,c))l(E,c,g)}}if(_&&z&&z.name!==m){S=true;C=function e(){return z.call(this)}}if((!a||w)&&(h||S||!T[c])){l(T,c,C)}o[t]=C;o[k]=g;if(y){L={values:_?C:M(m),keys:x?C:M(p),entries:A};if(w)for(N in L){if(!(N in T))i(T,N,L[N])}else n(n.P+n.F*(h||S),t,L)}return L}},{"./_export":31,"./_has":34,"./_hide":35,"./_iter-create":42,"./_iterators":46,"./_library":47,"./_object-gpo":52,"./_redefine":57,"./_set-to-string-tag":58,"./_wks":69}],44:[function(e,t,r){var a=e("./_wks")("iterator"),n=false;try{var i=[7][a]();i["return"]=function(){n=true};Array.from(i,function(){throw 2})}catch(e){}t.exports=function(e,t){if(!t&&!n)return false;var r=false;try{var i=[7],l=i[a]();l.next=function(){return{done:r=true}};i[a]=function(){return l};e(i)}catch(e){}return r}},{"./_wks":69}],45:[function(e,t,r){t.exports=function(e,t){return{value:t,done:!!e}}},{}],46:[function(e,t,r){t.exports={}},{}],47:[function(e,t,r){t.exports=true},{}],48:[function(e,t,r){var a=e("./_uid")("meta"),n=e("./_is-object"),i=e("./_has"),l=e("./_object-dp").f,u=0;var o=Object.isExtensible||function(){return true};var s=!e("./_fails")(function(){return o(Object.preventExtensions({}))});var f=function(e){l(e,a,{value:{i:"O"+ ++u,w:{}}})};var d=function(e,t){if(!n(e))return typeof e=="symbol"?e:(typeof e=="string"?"S":"P")+e;if(!i(e,a)){if(!o(e))return"F";if(!t)return"E";f(e)}return e[a].i};var c=function(e,t){if(!i(e,a)){if(!o(e))return true;if(!t)return false;f(e)}return e[a].w};var h=function(e){if(s&&v.NEED&&o(e)&&!i(e,a))f(e);return e};var v=t.exports={KEY:a,NEED:false,fastKey:d,getWeak:c,onFreeze:h}},{"./_fails":32,"./_has":34,"./_is-object":40,"./_object-dp":50,"./_uid":68}],49:[function(e,t,r){var a=e("./_an-object"),n=e("./_object-dps"),i=e("./_enum-bug-keys"),l=e("./_shared-key")("IE_PROTO"),u=function(){},o="prototype";var s=function(){var t=e("./_dom-create")("iframe"),r=i.length,a="<",n=">",l;t.style.display="none";e("./_html").appendChild(t);t.src="javascript:";l=t.contentWindow.document;l.open();l.write(a+"script"+n+"document.F=Object"+a+"/script"+n);l.close();s=l.F;while(r--)delete s[o][i[r]];return s()};t.exports=Object.create||function e(t,r){var i;if(t!==null){u[o]=a(t);i=new u;u[o]=null;i[l]=t}else i=s();return r===undefined?i:n(i,r)}},{"./_an-object":20,"./_dom-create":29,"./_enum-bug-keys":30,"./_html":36,"./_object-dps":51,"./_shared-key":59}],50:[function(e,t,r){var a=e("./_an-object"),n=e("./_ie8-dom-define"),i=e("./_to-primitive"),l=Object.defineProperty;r.f=e("./_descriptors")?Object.defineProperty:function e(t,r,u){a(t);r=i(r,true);a(u);if(n)try{return l(t,r,u)}catch(e){}if("get"in u||"set"in u)throw TypeError("Accessors not supported!");if("value"in u)t[r]=u.value;return t}},{"./_an-object":20,"./_descriptors":28,"./_ie8-dom-define":37,"./_to-primitive":67}],51:[function(e,t,r){var a=e("./_object-dp"),n=e("./_an-object"),i=e("./_object-keys");t.exports=e("./_descriptors")?Object.defineProperties:function e(t,r){n(t);var l=i(r),u=l.length,o=0,s;while(u>o)a.f(t,s=l[o++],r[s]);return t}},{"./_an-object":20,"./_descriptors":28,"./_object-dp":50,"./_object-keys":54}],52:[function(e,t,r){var a=e("./_has"),n=e("./_to-object"),i=e("./_shared-key")("IE_PROTO"),l=Object.prototype;t.exports=Object.getPrototypeOf||function(e){e=n(e);if(a(e,i))return e[i];if(typeof e.constructor=="function"&&e instanceof e.constructor){return e.constructor.prototype}return e instanceof Object?l:null}},{"./_has":34,"./_shared-key":59,"./_to-object":66}],53:[function(e,t,r){var a=e("./_has"),n=e("./_to-iobject"),i=e("./_array-includes")(false),l=e("./_shared-key")("IE_PROTO");t.exports=function(e,t){var r=n(e),u=0,o=[],s;for(s in r)if(s!=l)a(r,s)&&o.push(s);while(t.length>u)if(a(r,s=t[u++])){~i(o,s)||o.push(s)}return o}},{"./_array-includes":21,"./_has":34,"./_shared-key":59,"./_to-iobject":64}],54:[function(e,t,r){var a=e("./_object-keys-internal"),n=e("./_enum-bug-keys");t.exports=Object.keys||function e(t){return a(t,n)}},{"./_enum-bug-keys":30,"./_object-keys-internal":53}],55:[function(e,t,r){var a=e("./_export"),n=e("./_core"),i=e("./_fails");t.exports=function(e,t){var r=(n.Object||{})[e]||Object[e],l={};l[e]=t(r);a(a.S+a.F*i(function(){r(1)}),"Object",l)}},{"./_core":24,"./_export":31,"./_fails":32}],56:[function(e,t,r){t.exports=function(e,t){return{enumerable:!(e&1),configurable:!(e&2),writable:!(e&4),value:t}}},{}],57:[function(e,t,r){t.exports=e("./_hide")},{"./_hide":35}],58:[function(e,t,r){var a=e("./_object-dp").f,n=e("./_has"),i=e("./_wks")("toStringTag");t.exports=function(e,t,r){if(e&&!n(e=r?e:e.prototype,i))a(e,i,{configurable:true,value:t})}},{"./_has":34,"./_object-dp":50,"./_wks":69}],59:[function(e,t,r){var a=e("./_shared")("keys"),n=e("./_uid");t.exports=function(e){return a[e]||(a[e]=n(e))}},{"./_shared":60,"./_uid":68}],60:[function(e,t,r){var a=e("./_global"),n="__core-js_shared__",i=a[n]||(a[n]={});t.exports=function(e){return i[e]||(i[e]={})}},{"./_global":33}],61:[function(e,t,r){var a=e("./_to-integer"),n=e("./_defined");t.exports=function(e){return function(t,r){var i=String(n(t)),l=a(r),u=i.length,o,s;if(l<0||l>=u)return e?"":undefined;o=i.charCodeAt(l);return o<55296||o>56319||l+1===u||(s=i.charCodeAt(l+1))<56320||s>57343?e?i.charAt(l):o:e?i.slice(l,l+2):(o-55296<<10)+(s-56320)+65536}}},{"./_defined":27,"./_to-integer":63}],62:[function(e,t,r){var a=e("./_to-integer"),n=Math.max,i=Math.min;t.exports=function(e,t){e=a(e);return e<0?n(e+t,0):i(e,t)}},{"./_to-integer":63}],63:[function(e,t,r){var a=Math.ceil,n=Math.floor;t.exports=function(e){return isNaN(e=+e)?0:(e>0?n:a)(e)}},{}],64:[function(e,t,r){var a=e("./_iobject"),n=e("./_defined");t.exports=function(e){return a(n(e))}},{"./_defined":27,"./_iobject":38}],65:[function(e,t,r){var a=e("./_to-integer"),n=Math.min;t.exports=function(e){return e>0?n(a(e),9007199254740991):0}},{"./_to-integer":63}],66:[function(e,t,r){var a=e("./_defined");t.exports=function(e){return Object(a(e))}},{"./_defined":27}],67:[function(e,t,r){var a=e("./_is-object");t.exports=function(e,t){if(!a(e))return e;var r,n;if(t&&typeof(r=e.toString)=="function"&&!a(n=r.call(e)))return n;if(typeof(r=e.valueOf)=="function"&&!a(n=r.call(e)))return n;if(!t&&typeof(r=e.toString)=="function"&&!a(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")}},{"./_is-object":40}],68:[function(e,t,r){var a=0,n=Math.random();t.exports=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++a+n).toString(36))}},{}],69:[function(e,t,r){var a=e("./_shared")("wks"),n=e("./_uid"),i=e("./_global").Symbol,l=typeof i=="function";var u=t.exports=function(e){return a[e]||(a[e]=l&&i[e]||(l?i:n)("Symbol."+e))};u.store=a},{"./_global":33,"./_shared":60,"./_uid":68}],70:[function(e,t,r){var a=e("./_classof"),n=e("./_wks")("iterator"),i=e("./_iterators");t.exports=e("./_core").getIteratorMethod=function(e){if(e!=undefined)return e[n]||e["@@iterator"]||i[a(e)]}},{"./_classof":22,"./_core":24,"./_iterators":46,"./_wks":69}],71:[function(e,t,r){var a=e("./_an-object"),n=e("./core.get-iterator-method");t.exports=e("./_core").getIterator=function(e){var t=n(e);if(typeof t!="function")throw TypeError(e+" is not iterable!");return a(t.call(e))}},{"./_an-object":20,"./_core":24,"./core.get-iterator-method":70}],72:[function(e,t,r){var a=e("./_classof"),n=e("./_wks")("iterator"),i=e("./_iterators");t.exports=e("./_core").isIterable=function(e){var t=Object(e);return t[n]!==undefined||"@@iterator"in t||i.hasOwnProperty(a(t))}},{"./_classof":22,"./_core":24,"./_iterators":46,"./_wks":69}],73:[function(e,t,r){"use strict";var a=e("./_ctx"),n=e("./_export"),i=e("./_to-object"),l=e("./_iter-call"),u=e("./_is-array-iter"),o=e("./_to-length"),s=e("./_create-property"),f=e("./core.get-iterator-method");n(n.S+n.F*!e("./_iter-detect")(function(e){Array.from(e)}),"Array",{from:function e(t){var r=i(t),n=typeof this=="function"?this:Array,d=arguments.length,c=d>1?arguments[1]:undefined,h=c!==undefined,v=0,p=f(r),m,g,b,y;if(h)c=a(c,d>2?arguments[2]:undefined,2);if(p!=undefined&&!(n==Array&&u(p))){for(y=p.call(r),g=new n;!(b=y.next()).done;v++){s(g,v,h?l(y,c,[b.value,v],true):b.value)}}else{m=o(r.length);for(g=new n(m);m>v;v++){s(g,v,h?c(r[v],v):r[v])}}g.length=v;return g}})},{"./_create-property":25,"./_ctx":26,"./_export":31,"./_is-array-iter":39,"./_iter-call":41,"./_iter-detect":44,"./_to-length":65,"./_to-object":66,"./core.get-iterator-method":70}],74:[function(e,t,r){"use strict";var a=e("./_add-to-unscopables"),n=e("./_iter-step"),i=e("./_iterators"),l=e("./_to-iobject");t.exports=e("./_iter-define")(Array,"Array",function(e,t){this._t=l(e);this._i=0;this._k=t},function(){var e=this._t,t=this._k,r=this._i++;if(!e||r>=e.length){this._t=undefined;return n(1)}if(t=="keys")return n(0,r);if(t=="values")return n(0,e[r]);return n(0,[r,e[r]])},"values");i.Arguments=i.Array;a("keys");a("values");a("entries")},{"./_add-to-unscopables":19,"./_iter-define":43,"./_iter-step":45,"./_iterators":46,"./_to-iobject":64}],75:[function(e,t,r){var a=e("./_export");a(a.S+a.F*!e("./_descriptors"),"Object",{defineProperty:e("./_object-dp").f})},{"./_descriptors":28,"./_export":31,"./_object-dp":50}],76:[function(e,t,r){var a=e("./_is-object"),n=e("./_meta").onFreeze;e("./_object-sap")("freeze",function(e){return function t(r){return e&&a(r)?e(n(r)):r}})},{"./_is-object":40,"./_meta":48,"./_object-sap":55}],77:[function(e,t,r){"use strict";var a=e("./_string-at")(true);e("./_iter-define")(String,"String",function(e){this._t=String(e);this._i=0},function(){var e=this._t,t=this._i,r;if(t>=e.length)return{value:undefined,done:true};r=a(e,t);this._i+=r.length;return{value:r,done:false}})},{"./_iter-define":43,"./_string-at":61}],78:[function(e,t,r){e("./es6.array.iterator");var a=e("./_global"),n=e("./_hide"),i=e("./_iterators"),l=e("./_wks")("toStringTag");for(var u=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],o=0;o<5;o++){var s=u[o],f=a[s],d=f&&f.prototype;if(d&&!d[l])n(d,l,s);i[s]=i.Array}},{"./_global":33,"./_hide":35,"./_iterators":46,"./_wks":69,"./es6.array.iterator":74}],79:[function(e,t,r){function a(e){if(!e.__matchAtRelocatable){var t=e.source+"|()";var r="g"+(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.unicode?"u":"");e.__matchAtRelocatable=new RegExp(t,r)}return e.__matchAtRelocatable}function n(e,t,r){if(e.global||e.sticky){throw new Error("matchAt(...): Only non-global regexes are supported")}var n=a(e);n.lastIndex=r;var i=n.exec(t);if(i[i.length-1]==null){i.length=i.length-1;return i}else{return null}}t.exports=n},{}],80:[function(e,t,r){"use strict";var a=Object.getOwnPropertySymbols;var n=Object.prototype.hasOwnProperty;var i=Object.prototype.propertyIsEnumerable;function l(e){if(e===null||e===undefined){throw new TypeError("Object.assign cannot be called with null or undefined")}return Object(e)}function u(){try{if(!Object.assign){return false}var e=new String("abc");e[5]="de";if(Object.getOwnPropertyNames(e)[0]==="5"){return false}var t={};for(var r=0;r<10;r++){t["_"+String.fromCharCode(r)]=r}var a=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if(a.join("")!=="0123456789"){return false}var n={};"abcdefghijklmnopqrst".split("").forEach(function(e){n[e]=e});if(Object.keys(Object.assign({},n)).join("")!=="abcdefghijklmnopqrst"){return false}return true}catch(e){return false}}t.exports=u()?Object.assign:function(e,t){var r;var u=l(e);var o;for(var s=1;s<arguments.length;s++){r=Object(arguments[s]);for(var f in r){if(n.call(r,f)){u[f]=r[f]}}if(a){o=a(r);for(var d=0;d<o.length;d++){if(i.call(r,o[d])){u[o[d]]=r[o[d]]}}}}return u}},{}],81:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.controlWordRegex=r.combiningDiacriticalMarksEndRegex=undefined;var a=e("babel-runtime/helpers/classCallCheck");var n=v(a);var i=e("babel-runtime/helpers/createClass");var l=v(i);var u=e("match-at");var o=v(u);var s=e("./ParseError");var f=v(s);var d=e("./SourceLocation");var c=v(d);var h=e("./Token");function v(e){return e&&e.__esModule?e:{default:e}}var p="%[^\n]*[\n]";var m="\\\\[a-zA-Z@]+";var g="\\\\[^\ud800-\udfff]";var b="[\u0300-\u036f]";var y=r.combiningDiacriticalMarksEndRegex=new RegExp(b+"+$");var x=new RegExp("([ \r\n\t]+)|"+("("+p)+"|[!-\\[\\]-\u2027\u202a-\ud7ff\uf900-\uffff]"+(b+"*")+"|[\ud800-\udbff][\udc00-\udfff]"+(b+"*")+"|\\\\verb\\*([^]).*?\\3"+"|\\\\verb([^*a-zA-Z]).*?\\4"+("|"+m)+("|"+g)+")");var w=r.controlWordRegex=new RegExp("^"+m);var M=new RegExp("^"+p);var k=function(){function e(t){(0,n.default)(this,e);this.input=t;this.pos=0}(0,l.default)(e,[{key:"lex",value:function e(){var t=this.input;var r=this.pos;if(r===t.length){return new h.Token("EOF",new c.default(this,r,r))}var a=(0,o.default)(x,t,r);if(a===null){throw new f.default("Unexpected character: '"+t[r]+"'",new h.Token(t[r],new c.default(this,r,r+1)))}var n=a[2]||" ";var i=this.pos;this.pos+=a[0].length;var l=this.pos;if(M.test(n)){return this.lex()}else{return new h.Token(n,new c.default(this,i,l))}}}]);return e}();r.default=k},{"./ParseError":84,"./SourceLocation":88,"./Token":90,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9,"match-at":79}],82:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/toConsumableArray");var n=b(a);var i=e("babel-runtime/helpers/classCallCheck");var l=b(i);var u=e("babel-runtime/helpers/createClass");var o=b(u);var s=e("./Lexer");var f=b(s);var d=e("./Token");var c=e("./macros");var h=b(c);var v=e("./ParseError");var p=b(v);var m=e("object-assign");var g=b(m);function b(e){return e&&e.__esModule?e:{default:e}}var y=function(){function e(t,r,a){(0,l.default)(this,e);this.lexer=new f.default(t);this.macros=(0,g.default)({},h.default,r);this.mode=a;this.stack=[]}(0,o.default)(e,[{key:"switchMode",value:function e(t){this.mode=t}},{key:"future",value:function e(){if(this.stack.length===0){this.pushToken(this.lexer.lex())}return this.stack[this.stack.length-1]}},{key:"popToken",value:function e(){this.future();return this.stack.pop()}},{key:"pushToken",value:function e(t){this.stack.push(t)}},{key:"pushTokens",value:function e(t){var r;(r=this.stack).push.apply(r,(0,n.default)(t))}},{key:"consumeSpaces",value:function e(){for(;;){var t=this.future();if(t.text===" "){this.stack.pop()}else{break}}}},{key:"consumeArgs",value:function e(t){var r=[];for(var a=0;a<t;++a){this.consumeSpaces();var n=this.popToken();if(n.text==="{"){var i=[];var l=1;while(l!==0){var u=this.popToken();i.push(u);if(u.text==="{"){++l}else if(u.text==="}"){--l}else if(u.text==="EOF"){throw new p.default("End of input in macro argument",n)}}i.pop();i.reverse();r[a]=i}else if(n.text==="EOF"){throw new p.default("End of input expecting macro argument")}else{r[a]=[n]}}return r}},{key:"expandOnce",value:function e(){var t=this.popToken();var r=t.text;var a=r.charAt(0)==="\\";if(a&&s.controlWordRegex.test(r)){this.consumeSpaces()}if(!this.macros.hasOwnProperty(r)){this.pushToken(t);return t}var i=this._getExpansion(r),l=i.tokens,u=i.numArgs;var o=l;if(u){var f=this.consumeArgs(u);o=o.slice();for(var d=o.length-1;d>=0;--d){var c=o[d];if(c.text==="#"){if(d===0){throw new p.default("Incomplete placeholder at end of macro body",c)}c=o[--d];if(c.text==="#"){o.splice(d+1,1)}else if(/^[1-9]$/.test(c.text)){var h;(h=o).splice.apply(h,[d,2].concat((0,n.default)(f[+c.text-1])))}else{throw new p.default("Not a valid argument number",c)}}}}this.pushTokens(o);return o}},{key:"expandAfterFuture",value:function e(){this.expandOnce();return this.future()}},{key:"expandNextToken",value:function e(){for(;;){var t=this.expandOnce();if(t instanceof d.Token){if(t.text==="\\relax"){this.stack.pop()}else{return this.stack.pop()}}}throw new Error}},{key:"_getExpansion",value:function e(t){var r=this.macros[t];var a=typeof r==="function"?r(this):r;if(typeof a==="string"){var n=0;if(a.indexOf("#")!==-1){var i=a.replace(/##/g,"");while(i.indexOf("#"+(n+1))!==-1){++n}}var l=new f.default(a);var u=[];var o=l.lex();while(o.text!=="EOF"){u.push(o);o=l.lex()}u.reverse();var s={tokens:u,numArgs:n};if(typeof r!=="function"){this.macros[t]=s}return s}return a}}]);return e}();r.default=y},{"./Lexer":81,"./ParseError":84,"./Token":90,"./macros":123,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9,"babel-runtime/helpers/toConsumableArray":11,"object-assign":80}],83:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=s(a);var i=e("babel-runtime/helpers/createClass");var l=s(i);var u=e("./fontMetrics");var o=s(u);function s(e){return e&&e.__esModule?e:{default:e}}var f=[[1,1,1],[2,1,1],[3,1,1],[4,2,1],[5,2,1],[6,3,1],[7,4,2],[8,6,3],[9,7,6],[10,8,7],[11,10,9]];var d=[.5,.6,.7,.8,.9,1,1.2,1.44,1.728,2.074,2.488];var c=function e(t,r){return r.size<2?t:f[t-1][r.size-1]};var h=function(){function e(t){(0,n.default)(this,e);this.style=t.style;this.color=t.color;this.size=t.size||e.BASESIZE;this.textSize=t.textSize||this.size;this.phantom=!!t.phantom;this.fontFamily=t.fontFamily;this.fontWeight=t.fontWeight||"";this.fontShape=t.fontShape||"";this.sizeMultiplier=d[this.size-1];this.maxSize=t.maxSize;this._fontMetrics=undefined}(0,l.default)(e,[{key:"extend",value:function t(r){var a={style:this.style,size:this.size,textSize:this.textSize,color:this.color,phantom:this.phantom,fontFamily:this.fontFamily,fontWeight:this.fontWeight,fontShape:this.fontShape,maxSize:this.maxSize};for(var n in r){if(r.hasOwnProperty(n)){a[n]=r[n]}}return new e(a)}},{key:"havingStyle",value:function e(t){if(this.style===t){return this}else{return this.extend({style:t,size:c(this.textSize,t)})}}},{key:"havingCrampedStyle",value:function e(){return this.havingStyle(this.style.cramp())}},{key:"havingSize",value:function e(t){if(this.size===t&&this.textSize===t){return this}else{return this.extend({style:this.style.text(),size:t,textSize:t})}}},{key:"havingBaseStyle",value:function t(r){r=r||this.style.text();var a=c(e.BASESIZE,r);if(this.size===a&&this.textSize===e.BASESIZE&&this.style===r){return this}else{return this.extend({style:r,size:a})}}},{key:"withColor",value:function e(t){return this.extend({color:t})}},{key:"withPhantom",value:function e(){return this.extend({phantom:true})}},{key:"withFontFamily",value:function e(t){return this.extend({fontFamily:t||this.fontFamily})}},{key:"withFontWeight",value:function e(t){return this.extend({fontWeight:t})}},{key:"withFontShape",value:function e(t){return this.extend({fontShape:t})}},{key:"sizingClasses",value:function e(t){if(t.size!==this.size){return["sizing","reset-size"+t.size,"size"+this.size]}else{return[]}}},{key:"baseSizingClasses",value:function t(){if(this.size!==e.BASESIZE){return["sizing","reset-size"+this.size,"size"+e.BASESIZE]}else{return[]}}},{key:"fontMetrics",value:function e(){if(!this._fontMetrics){this._fontMetrics=o.default.getFontMetrics(this.size)}return this._fontMetrics}},{key:"getColor",value:function t(){if(this.phantom){return"transparent"}else if(this.color!=null&&e.colorMap.hasOwnProperty(this.color)){return e.colorMap[this.color]}else{return this.color}}}]);return e}();h.BASESIZE=6;h.colorMap={"katex-blue":"#6495ed","katex-orange":"#ffa500","katex-pink":"#ff00af","katex-red":"#df0030","katex-green":"#28ae7b","katex-gray":"gray","katex-purple":"#9d38bd","katex-blueA":"#ccfaff","katex-blueB":"#80f6ff","katex-blueC":"#63d9ea","katex-blueD":"#11accd","katex-blueE":"#0c7f99","katex-tealA":"#94fff5","katex-tealB":"#26edd5","katex-tealC":"#01d1c1","katex-tealD":"#01a995","katex-tealE":"#208170","katex-greenA":"#b6ffb0","katex-greenB":"#8af281","katex-greenC":"#74cf70","katex-greenD":"#1fab54","katex-greenE":"#0d923f","katex-goldA":"#ffd0a9","katex-goldB":"#ffbb71","katex-goldC":"#ff9c39","katex-goldD":"#e07d10","katex-goldE":"#a75a05","katex-redA":"#fca9a9","katex-redB":"#ff8482","katex-redC":"#f9685d","katex-redD":"#e84d39","katex-redE":"#bc2612","katex-maroonA":"#ffbde0","katex-maroonB":"#ff92c6","katex-maroonC":"#ed5fa6","katex-maroonD":"#ca337c","katex-maroonE":"#9e034e","katex-purpleA":"#ddd7ff","katex-purpleB":"#c6b9fc","katex-purpleC":"#aa87ff","katex-purpleD":"#7854ab","katex-purpleE":"#543b78","katex-mintA":"#f5f9e8","katex-mintB":"#edf2df","katex-mintC":"#e0e5cc","katex-grayA":"#f6f7f7","katex-grayB":"#f0f1f2",
"katex-grayC":"#e3e5e6","katex-grayD":"#d6d8da","katex-grayE":"#babec2","katex-grayF":"#888d93","katex-grayG":"#626569","katex-grayH":"#3b3e40","katex-grayI":"#21242c","katex-kaBlue":"#314453","katex-kaGreen":"#71B307"};r.default=h},{"./fontMetrics":101,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],84:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=o(a);var i=e("./ParseNode");var l=o(i);var u=e("./Token");function o(e){return e&&e.__esModule?e:{default:e}}var s=function e(t,r){(0,n.default)(this,e);var a="KaTeX parse error: "+t;var i=void 0;var l=r&&r.loc;if(l&&l.start<=l.end){var u=l.lexer.input;i=l.start;var o=l.end;if(i===u.length){a+=" at end of input: "}else{a+=" at position "+(i+1)+": "}var s=u.slice(i,o).replace(/[^]/g,"$&\u0332");var f=void 0;if(i>15){f="\u2026"+u.slice(i-15,i)}else{f=u.slice(0,i)}var d=void 0;if(o+15<u.length){d=u.slice(o,o+15)+"\u2026"}else{d=u.slice(o)}a+=f+s+d}var c=new Error(a);c.name="ParseError";c.__proto__=e.prototype;c.position=i;return c};s.prototype.__proto__=Error.prototype;r.default=s},{"./ParseNode":85,"./Token":90,"babel-runtime/helpers/classCallCheck":8}],85:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=u(a);var i=e("./SourceLocation");var l=u(i);function u(e){return e&&e.__esModule?e:{default:e}}var o=function e(t,r,a,i,u){(0,n.default)(this,e);this.type=t;this.value=r;this.mode=a;this.loc=l.default.range(i,u)};r.default=o},{"./SourceLocation":88,"babel-runtime/helpers/classCallCheck":8}],86:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=L(a);var i=e("babel-runtime/helpers/createClass");var l=L(i);var u=e("./functions");var o=L(u);var s=e("./environments");var f=L(s);var d=e("./MacroExpander");var c=L(d);var h=e("./symbols");var v=L(h);var p=e("./utils");var m=L(p);var g=e("./units");var b=e("./unicodeScripts");var y=e("./unicodeAccents");var x=L(y);var w=e("./unicodeSymbols");var M=L(w);var k=e("./ParseNode");var _=L(k);var S=e("./ParseError");var T=L(S);var z=e("./Lexer.js");var C=e("./Settings");var A=L(C);var O=e("./Token");function L(e){return e&&e.__esModule?e:{default:e}}function N(e,t){return{type:"arg",result:e,token:t}}function E(e){return{type:"fn",result:e.text,token:e}}function j(e){return{type:"$",result:"$",token:e}}function B(e){if(e.type==="$"){throw new T.default("Unexpected $",e.token)}return e}var P=function(){function e(t,r){(0,n.default)(this,e);this.mode="math";this.gullet=new c.default(t,r.macros,this.mode);if(r.colorIsTextColor){this.gullet.macros["\\color"]="\\textcolor"}this.settings=r;this.leftrightDepth=0}(0,l.default)(e,[{key:"expect",value:function e(t){var r=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(this.nextToken.text!==t){throw new T.default("Expected '"+t+"', got '"+this.nextToken.text+"'",this.nextToken)}if(r){this.consume()}}},{key:"consume",value:function e(){this.nextToken=this.gullet.expandNextToken()}},{key:"switchMode",value:function e(t){this.mode=t;this.gullet.switchMode(t)}},{key:"parse",value:function e(){this.consume();var e=this.parseInput();return e}},{key:"parseInput",value:function e(){var t=this.parseExpression(false);this.expect("EOF",false);return t}},{key:"parseExpression",value:function t(r,a){var n=[];while(true){if(this.mode==="math"){this.consumeSpaces()}var i=this.nextToken;if(e.endOfExpression.indexOf(i.text)!==-1){break}if(a&&i.text===a){break}if(r&&o.default[i.text]&&o.default[i.text].infix){break}var l=this.parseAtom(a);if(!l){if(!this.settings.throwOnError&&i.text[0]==="\\"){var u=this.handleUnsupportedCmd();n.push(u);continue}break}n.push(l)}return this.handleInfixNodes(n)}},{key:"handleInfixNodes",value:function e(t){var r=-1;var a=void 0;for(var n=0;n<t.length;n++){var i=t[n];if(i.type==="infix"){if(r!==-1){throw new T.default("only one infix operator per group",i.value.token)}r=n;a=i.value.replaceWith}}if(r!==-1&&a){var l=void 0;var u=void 0;var o=t.slice(0,r);var s=t.slice(r+1);if(o.length===1&&o[0].type==="ordgroup"){l=o[0]}else{l=new _.default("ordgroup",o,this.mode)}if(s.length===1&&s[0].type==="ordgroup"){u=s[0]}else{u=new _.default("ordgroup",s,this.mode)}var f=this.callFunction(a,[l,u],[]);return[new _.default(f.type,f,this.mode)]}else{return t}}},{key:"handleSupSubscript",value:function t(r){var a=this.nextToken;var n=a.text;this.consume();this.consumeSpaces();var i=this.parseGroup();if(!i){if(!this.settings.throwOnError&&this.nextToken.text[0]==="\\"){return this.handleUnsupportedCmd()}else{throw new T.default("Expected group after '"+n+"'",a)}}var l=B(i);if(l.type==="fn"){var u=o.default[l.result].greediness;if(u>e.SUPSUB_GREEDINESS){return this.parseGivenFunction(i)}else{throw new T.default("Got function '"+l.result+"' with no arguments "+"as "+r,a)}}else{return l.result}}},{key:"handleUnsupportedCmd",value:function e(){var t=this.nextToken.text;var r=[];for(var a=0;a<t.length;a++){r.push(new _.default("textord",t[a],"text"))}var n=new _.default("text",{body:r,type:"text"},this.mode);var i=new _.default("color",{color:this.settings.errorColor,value:[n],type:"color"},this.mode);this.consume();return i}},{key:"parseAtom",value:function e(t){var r=this.parseImplicitGroup(t);if(this.mode==="text"){return r}var a=void 0;var n=void 0;while(true){this.consumeSpaces();var i=this.nextToken;if(i.text==="\\limits"||i.text==="\\nolimits"){if(!r||r.type!=="op"){throw new T.default("Limit controls must follow a math operator",i)}else{var l=i.text==="\\limits";r.value.limits=l;r.value.alwaysHandleSupSub=true}this.consume()}else if(i.text==="^"){if(a){throw new T.default("Double superscript",i)}a=this.handleSupSubscript("superscript")}else if(i.text==="_"){if(n){throw new T.default("Double subscript",i)}n=this.handleSupSubscript("subscript")}else if(i.text==="'"){if(a){throw new T.default("Double superscript",i)}var u=new _.default("textord","\\prime",this.mode);var o=[u];this.consume();while(this.nextToken.text==="'"){o.push(u);this.consume()}if(this.nextToken.text==="^"){o.push(this.handleSupSubscript("superscript"))}a=new _.default("ordgroup",o,this.mode)}else{break}}if(a||n){return new _.default("supsub",{base:r,sup:a,sub:n},this.mode)}else{return r}}},{key:"parseImplicitGroup",value:function t(r){var a=this.parseSymbol();if(a==null){return this.parseFunction()}else if(a.type==="arg"){return this.parseGivenFunction(a)}var n=a.result;if(n==="$"){if(this.mode==="math"){throw new T.default("$ within math mode")}var i=this.mode;this.switchMode("math");this.consume();var l=this.parseExpression(false,"$");this.expect("$",false);this.switchMode(i);this.consume();return new _.default("styling",{style:"text",value:l},"math")}else if(n==="\\left"){var u=this.parseGivenFunction(a);++this.leftrightDepth;var o=this.parseExpression(false);--this.leftrightDepth;this.expect("\\right",false);var s=this.parseFunction();if(!s){throw new T.default("failed to parse function after \\right")}return new _.default("leftright",{body:o,left:u.value.value,right:s.value.value},this.mode)}else if(n==="\\begin"){var d=this.parseGivenFunction(a);var c=d.value.name;if(!f.default.hasOwnProperty(c)){throw new T.default("No such environment: "+c,d.value.nameGroup)}var h=f.default[c];var v=this.parseArguments("\\begin{"+c+"}",h),p=v.args,g=v.optArgs;var b={mode:this.mode,envName:c,parser:this};var y=h.handler(b,p,g);this.expect("\\end",false);var x=this.nextToken;var w=this.parseFunction();if(!w){throw new T.default("failed to parse function after \\end")}else if(w.value.name!==c){throw new T.default("Mismatch: \\begin{"+c+"} matched "+"by \\end{"+w.value.name+"}",x)}return y}else if(m.default.contains(e.sizeFuncs,n)){this.consumeSpaces();var M=this.parseExpression(false,r);return new _.default("sizing",{size:m.default.indexOf(e.sizeFuncs,n)+1,value:M},this.mode)}else if(m.default.contains(e.styleFuncs,n)){this.consumeSpaces();var k=this.parseExpression(true,r);return new _.default("styling",{style:n.slice(1,n.length-5),value:k},this.mode)}else if(n in e.oldFontFuncs){var S=e.oldFontFuncs[n];this.consumeSpaces();var z=this.parseExpression(true,r);if(S.slice(0,4)==="text"){return new _.default("text",{style:S,body:new _.default("ordgroup",z,this.mode)},this.mode)}else{return new _.default("font",{font:S,body:new _.default("ordgroup",z,this.mode)},this.mode)}}else if(n==="\\color"){var C=this.parseColorGroup(false);if(!C){throw new T.default("\\color not followed by color")}var A=this.parseExpression(true,r);return new _.default("color",{type:"color",color:C.result.value,value:A},this.mode)}else{return this.parseGivenFunction(a)}}},{key:"parseFunction",value:function e(){var t=this.parseGroup();return t?this.parseGivenFunction(t):null}},{key:"parseGivenFunction",value:function e(t){t=B(t);if(t.type==="fn"){var r=t.result;var a=o.default[r];if(this.mode==="text"&&!a.allowedInText){throw new T.default("Can't use function '"+r+"' in text mode",t.token)}else if(this.mode==="math"&&a.allowedInMath===false){throw new T.default("Can't use function '"+r+"' in math mode",t.token)}var n=this.parseArguments(r,a),i=n.args,l=n.optArgs;var u=t.token;var s=this.callFunction(r,i,l,u);return new _.default(s.type,s,this.mode)}else{return t.result}}},{key:"callFunction",value:function e(t,r,a,n){var i={funcName:t,parser:this,token:n};var l=o.default[t];if(l&&l.handler){return l.handler(i,r,a)}else{throw new T.default("No function handler for "+t)}}},{key:"parseArguments",value:function e(t,r){var a=r.numArgs+r.numOptionalArgs;if(a===0){return{args:[],optArgs:[]}}var n=r.greediness;var i=[];var l=[];for(var u=0;u<a;u++){var s=r.argTypes&&r.argTypes[u];var f=u<r.numOptionalArgs;if(u>0&&!f){this.consumeSpaces()}if(u===0&&!f&&this.mode==="math"){this.consumeSpaces()}var d=this.nextToken;var c=s?this.parseGroupOfType(s,f):this.parseGroup(f);if(!c){if(f){l.push(null);continue}if(!this.settings.throwOnError&&this.nextToken.text[0]==="\\"){c=N(this.handleUnsupportedCmd(),d)}else{throw new T.default("Expected group after '"+t+"'",d)}}var h=void 0;c=B(c);if(c.type==="fn"){var v=o.default[c.result].greediness;if(v>n){h=this.parseGivenFunction(c)}else{throw new T.default("Got function '"+c.result+"' as "+"argument to '"+t+"'",d)}}else{h=c.result}(f?l:i).push(h)}return{args:i,optArgs:l}}},{key:"parseGroupOfType",value:function e(t,r){if(t==="original"){t=this.mode}if(t==="color"){return this.parseColorGroup(r)}if(t==="size"){return this.parseSizeGroup(r)}if(t==="url"){return this.parseUrlGroup(r)}return this.parseGroup(r,t)}},{key:"consumeSpaces",value:function e(){while(this.nextToken.text===" "){this.consume()}}},{key:"parseStringGroup",value:function e(t,r){if(r&&this.nextToken.text!=="["){return null}var a=this.mode;this.mode="text";this.expect(r?"[":"{");var n="";var i=this.nextToken;var l=i;while(this.nextToken.text!==(r?"]":"}")){if(this.nextToken.text==="EOF"){throw new T.default("Unexpected end of input in "+t,i.range(this.nextToken,n))}l=this.nextToken;n+=l.text;this.consume()}this.mode=a;this.expect(r?"]":"}");return i.range(l,n)}},{key:"parseStringGroupWithBalancedBraces",value:function e(t,r){if(r&&this.nextToken.text!=="["){return null}var a=this.mode;this.mode="text";this.expect(r?"[":"{");var n="";var i=0;var l=this.nextToken;var u=l;while(i>0||this.nextToken.text!==(r?"]":"}")){if(this.nextToken.text==="EOF"){throw new T.default("Unexpected end of input in "+t,l.range(this.nextToken,n))}u=this.nextToken;n+=u.text;if(u.text==="{"){i+=1}else if(u.text==="}"){if(i<=0){throw new T.default("Unbalanced brace of input in "+t,l.range(this.nextToken,n))}else{i-=1}}this.consume()}this.mode=a;this.expect(r?"]":"}");return l.range(u,n)}},{key:"parseRegexGroup",value:function e(t,r){var a=this.mode;this.mode="text";var n=this.nextToken;var i=n;var l="";while(this.nextToken.text!=="EOF"&&t.test(l+this.nextToken.text)){i=this.nextToken;l+=i.text;this.consume()}if(l===""){throw new T.default("Invalid "+r+": '"+n.text+"'",n)}this.mode=a;return n.range(i,l)}},{key:"parseColorGroup",value:function e(t){var r=this.parseStringGroup("color",t);if(!r){return null}var a=/^(#[a-f0-9]{3}|#[a-f0-9]{6}|[a-z]+)$/i.exec(r.text);if(!a){throw new T.default("Invalid color: '"+r.text+"'",r)}return N(new _.default("color",a[0],this.mode),r)}},{key:"parseUrlGroup",value:function e(t){var r=this.parseStringGroupWithBalancedBraces("url",t);if(!r){return null}var a=r.text;var n=a.replace(/\\([#$%&~_^{}])/g,"$1");return N(new _.default("url",n,this.mode),r)}},{key:"parseSizeGroup",value:function e(t){var r=void 0;if(!t&&this.nextToken.text!=="{"){r=this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/,"size")}else{r=this.parseStringGroup("size",t)}if(!r){return null}var a=/([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(r.text);if(!a){throw new T.default("Invalid size: '"+r.text+"'",r)}var n={number:+(a[1]+a[2]),unit:a[3]};if(!(0,g.validUnit)(n)){throw new T.default("Invalid unit: '"+n.unit+"'",r)}return N(new _.default("size",n,this.mode),r)}},{key:"parseGroup",value:function e(t,r){var a=this.mode;var n=this.nextToken;if(this.nextToken.text===(t?"[":"{")){if(r){this.switchMode(r)}this.consume();var i=this.parseExpression(false,t?"]":"}");var l=this.nextToken;if(r){this.switchMode(a)}this.expect(t?"]":"}");if(r==="text"){this.formLigatures(i)}return N(new _.default("ordgroup",i,this.mode,n,l),n.range(l,n.text))}else{if(r){this.switchMode(r)}var u=t?null:this.parseSymbol();if(r){this.switchMode(a)}return u}}},{key:"formLigatures",value:function e(t){var r=t.length-1;for(var a=0;a<r;++a){var n=t[a];var i=n.value;if(i==="-"&&t[a+1].value==="-"){if(a+1<r&&t[a+2].value==="-"){t.splice(a,3,new _.default("textord","---","text",n,t[a+2]));r-=2}else{t.splice(a,2,new _.default("textord","--","text",n,t[a+1]));r-=1}}if((i==="'"||i==="`")&&t[a+1].value===i){t.splice(a,2,new _.default("textord",i+i,"text",n,t[a+1]));r-=1}}}},{key:"parseSymbol",value:function e(){var t=this.nextToken;var r=t.text;if(o.default[r]){this.consume();return E(t)}else if(/^\\verb[^a-zA-Z]/.test(r)){this.consume();var a=r.slice(5);var n=a.charAt(0)==="*";if(n){a=a.slice(1)}if(a.length<2||a.charAt(0)!==a.slice(-1)){throw new T.default("\\verb assertion failed --\n                    please report what input caused this bug")}a=a.slice(1,-1);return N(new _.default("verb",{body:a,star:n},"text"),t)}else if(r==="$"){return j(t)}if(M.default.hasOwnProperty(r[0])&&!v.default[this.mode][r[0]]){r=M.default[r[0]]+r.substr(1)}var i=z.combiningDiacriticalMarksEndRegex.exec(r);if(i){r=r.substring(0,i.index);if(r==="i"){r="\u0131"}else if(r==="j"){r="\u0237"}}var l=null;if(v.default[this.mode][r]){l=new _.default(v.default[this.mode][r].group,r,this.mode,t)}else if(this.mode==="text"&&(0,b.supportedCodepoint)(r.charCodeAt(0))){l=new _.default("textord",r,this.mode,t)}else{return null}this.consume();if(i){for(var u=0;u<i[0].length;u++){var s=i[0][u];if(!x.default[s]){throw new T.default("Unknown accent ' "+s+"'",t)}var f=x.default[s][this.mode];if(!f){throw new T.default("Accent "+s+" unsupported in "+this.mode+" mode",t)}l=new _.default("accent",{type:"accent",label:f,isStretchy:false,isShifty:true,base:l},this.mode,t)}}return N(l,t)}}]);return e}();P.endOfExpression=["}","\\end","\\right","&","\\\\","\\cr"];P.SUPSUB_GREEDINESS=1;P.sizeFuncs=["\\tiny","\\sixptsize","\\scriptsize","\\footnotesize","\\small","\\normalsize","\\large","\\Large","\\LARGE","\\huge","\\Huge"];P.styleFuncs=["\\displaystyle","\\textstyle","\\scriptstyle","\\scriptscriptstyle"];P.oldFontFuncs={"\\rm":"mathrm","\\sf":"mathsf","\\tt":"mathtt","\\bf":"mathbf","\\it":"mathit"};r.default=P},{"./Lexer.js":81,"./MacroExpander":82,"./ParseError":84,"./ParseNode":85,"./Settings":87,"./Token":90,"./environments":99,"./functions":103,"./symbols":128,"./unicodeAccents":129,"./unicodeScripts":130,"./unicodeSymbols":131,"./units":132,"./utils":133,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],87:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=u(a);var i=e("./utils");var l=u(i);function u(e){return e&&e.__esModule?e:{default:e}}var o=function e(t){(0,n.default)(this,e);t=t||{};this.displayMode=l.default.deflt(t.displayMode,false);this.throwOnError=l.default.deflt(t.throwOnError,true);this.errorColor=l.default.deflt(t.errorColor,"#cc0000");this.macros=t.macros||{};this.colorIsTextColor=l.default.deflt(t.colorIsTextColor,false);this.maxSize=Math.max(0,l.default.deflt(t.maxSize,Infinity))};r.default=o},{"./utils":133,"babel-runtime/helpers/classCallCheck":8}],88:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/core-js/object/freeze");var n=s(a);var i=e("babel-runtime/helpers/classCallCheck");var l=s(i);var u=e("babel-runtime/helpers/createClass");var o=s(u);function s(e){return e&&e.__esModule?e:{default:e}}var f=function(){function e(t,r,a){(0,l.default)(this,e);this.lexer=t;this.start=r;this.end=a;(0,n.default)(this)}(0,o.default)(e,null,[{key:"range",value:function t(r,a){if(!a){return r&&r.loc}else if(!r||!r.loc||!a.loc||r.loc.lexer!==a.loc.lexer){return null}else{return new e(r.loc.lexer,r.loc.start,a.loc.end)}}}]);return e}();r.default=f},{"babel-runtime/core-js/object/freeze":7,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],89:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=u(a);var i=e("babel-runtime/helpers/createClass");var l=u(i);function u(e){return e&&e.__esModule?e:{default:e}}var o=function(){function e(t,r,a){(0,n.default)(this,e);this.id=t;this.size=r;this.cramped=a}(0,l.default)(e,[{key:"sup",value:function e(){return g[b[this.id]]}},{key:"sub",value:function e(){return g[y[this.id]]}},{key:"fracNum",value:function e(){return g[x[this.id]]}},{key:"fracDen",value:function e(){return g[w[this.id]]}},{key:"cramp",value:function e(){return g[M[this.id]]}},{key:"text",value:function e(){return g[k[this.id]]}},{key:"isTight",value:function e(){return this.size>=2}}]);return e}();var s=0;var f=1;var d=2;var c=3;var h=4;var v=5;var p=6;var m=7;var g=[new o(s,0,false),new o(f,0,true),new o(d,1,false),new o(c,1,true),new o(h,2,false),new o(v,2,true),new o(p,3,false),new o(m,3,true)];var b=[h,v,h,v,p,m,p,m];var y=[v,v,v,v,m,m,m,m];var x=[d,c,h,v,p,m,p,m];var w=[c,c,v,v,m,m,m,m];var M=[f,f,c,c,v,v,m,m];var k=[s,f,d,c,d,c,d,c];r.default={DISPLAY:g[s],TEXT:g[d],SCRIPT:g[h],SCRIPTSCRIPT:g[p]}},{"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],90:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.Token=undefined;var a=e("babel-runtime/helpers/classCallCheck");var n=s(a);var i=e("babel-runtime/helpers/createClass");var l=s(i);var u=e("./SourceLocation");var o=s(u);function s(e){return e&&e.__esModule?e:{default:e}}var f=r.Token=function(){function e(t,r){(0,n.default)(this,e);this.text=t;this.loc=r}(0,l.default)(e,[{key:"range",value:function t(r,a){return new e(a,o.default.range(this,r))}}]);return e}()},{"./SourceLocation":88,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],91:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/slicedToArray");var n=g(a);var i=e("babel-runtime/core-js/get-iterator");var l=g(i);var u=e("./domTree");var o=g(u);var s=e("./fontMetrics");var f=g(s);var d=e("./symbols");var c=g(d);var h=e("./utils");var v=g(h);var p=e("./stretchy");var m=g(p);function g(e){return e&&e.__esModule?e:{default:e}}var b=["\\imath","\u0131","\\jmath","\u0237","\\pounds","\\mathsterling","\\textsterling","\xa3"];var y=function e(t,r,a){if(c.default[a][t]&&c.default[a][t].replace){t=c.default[a][t].replace}return{value:t,metrics:f.default.getCharacterMetrics(t,r)}};var x=function e(t,r,a,n,i){var l=y(t,r,a);var u=l.metrics;t=l.value;var s=void 0;if(u){var f=u.italic;if(a==="text"){f=0}s=new o.default.symbolNode(t,u.height,u.depth,f,u.skew,u.width,i)}else{typeof console!=="undefined"&&console.warn("No character metrics for '"+t+"' in style '"+r+"'");s=new o.default.symbolNode(t,0,0,0,0,0,i)}if(n){s.maxFontSize=n.sizeMultiplier;if(n.style.isTight()){s.classes.push("mtight")}var d=n.getColor();if(d){s.style.color=d}}return s};var w=function e(t,r,a){var n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];if(a&&a.fontFamily&&a.fontFamily==="boldsymbol"&&y(t,"Main-Bold",r).metrics){return x(t,"Main-Bold",r,a,n.concat(["mathbf"]))}else if(t==="\\"||c.default[r][t].font==="main"){return x(t,"Main-Regular",r,a,n)}else{return x(t,"AMS-Regular",r,a,n.concat(["amsrm"]))}};var M=function e(t,r,a,n,i){if(i==="mathord"){var l=k(t,r,a,n);return x(t,l.fontName,r,a,n.concat([l.fontClass]))}else if(i==="textord"){var u=c.default[r][t]&&c.default[r][t].font;if(u==="ams"){var o=P("amsrm",a.fontWeight,a.fontShape);return x(t,o,r,a,n.concat("amsrm",a.fontWeight,a.fontShape))}else{var s=P("textrm",a.fontWeight,a.fontShape);return x(t,s,r,a,n.concat(a.fontWeight,a.fontShape))}}else{throw new Error("unexpected type: "+i+" in mathDefault")}};var k=function e(t,r,a,n){if(/[0-9]/.test(t.charAt(0))||v.default.contains(b,t)){return{fontName:"Main-Italic",fontClass:"mainit"}}else{return{fontName:"Math-Italic",fontClass:"mathit"}}};var _=function e(t,r,a,n){if(y(t,"Math-BoldItalic",r).metrics){return{fontName:"Math-BoldItalic",fontClass:"boldsymbol"}}else{return{fontName:"Main-Bold",fontClass:"mathbf"}}};var S=function e(t,r,a){var n=t.mode;var i=t.value;var l=["mord"];var u=r.fontFamily;if(u){var o=void 0;var s=void 0;if(u==="boldsymbol"){var f=_(i,n,r,l);o=f.fontName;s=[f.fontClass]}else if(u==="mathit"||v.default.contains(b,i)){var d=k(i,n,r,l);o=d.fontName;s=[d.fontClass]}else if(u.includes("math")||n==="math"){o=R[u].fontName;s=[u]}else{o=P(u,r.fontWeight,r.fontShape);s=[u,r.fontWeight,r.fontShape]}if(y(i,o,n).metrics){return x(i,o,n,r,l.concat(s))}else{return M(i,n,r,l,a)}}else{return M(i,n,r,l,a)}};var T=function e(t){for(var r=0;r<t.length-1;r++){if(t[r].tryCombine(t[r+1])){t.splice(r+1,1);r--}}return t};var z=function e(t){var r=0;var a=0;var n=0;var i=true;var u=false;var o=undefined;try{for(var s=(0,l.default)(t.children),f;!(i=(f=s.next()).done);i=true){var d=f.value;if(d.height>r){r=d.height}if(d.depth>a){a=d.depth}if(d.maxFontSize>n){n=d.maxFontSize}}}catch(e){u=true;o=e}finally{try{if(!i&&s.return){s.return()}}finally{if(u){throw o}}}t.height=r;t.depth=a;t.maxFontSize=n};var C=function e(t,r,a){var n=new o.default.span(t,r,a);z(n);return n};var A=function e(t,r){var a=r.fontMetrics().defaultRuleThickness;var n=m.default.ruleSpan(t,a,r);n.height=a;n.style.height=5*n.height+"em";n.maxFontSize=1;return n};var O=function e(t,r,a,n){var i=new o.default.anchor(t,r,a,n);z(i);return i};var L=function e(t,r){t.children=r.concat(t.children);z(t)};var N=function e(t){var r=new o.default.documentFragment(t);z(r);return r};var E=function e(t){if(t.positionType==="individualShift"){var r=t.children;var a=[r[0]];var n=-r[0].shift-r[0].elem.depth;var i=n;for(var u=1;u<r.length;u++){var o=-r[u].shift-i-r[u].elem.depth;var s=o-(r[u-1].elem.height+r[u-1].elem.depth);i=i+o;a.push({type:"kern",size:s});a.push(r[u])}return{children:a,depth:n}}var f=void 0;if(t.positionType==="top"){var d=t.positionData;var c=true;var h=false;var v=undefined;try{for(var p=(0,l.default)(t.children),m;!(c=(m=p.next()).done);c=true){var g=m.value;d-=g.type==="kern"?g.size:g.elem.height+g.elem.depth}}catch(e){h=true;v=e}finally{try{if(!c&&p.return){p.return()}}finally{if(h){throw v}}}f=d}else if(t.positionType==="bottom"){f=-t.positionData}else{var b=t.children[0];if(b.type!=="elem"){throw new Error('First child must have type "elem".')}if(t.positionType==="shift"){f=-b.elem.depth-t.positionData}else if(t.positionType==="firstBaseline"){f=-b.elem.depth}else{throw new Error("Invalid positionType "+t.positionType+".")}}return{children:t.children,depth:f}};var j=function e(t,r){var a=E(t),n=a.children,i=a.depth;var u=0;var s=true;var f=false;var d=undefined;try{for(var c=(0,l.default)(n),h;!(s=(h=c.next()).done);s=true){var v=h.value;if(v.type==="elem"){var p=v.elem;u=Math.max(u,p.maxFontSize,p.height)}}}catch(e){f=true;d=e}finally{try{if(!s&&c.return){c.return()}}finally{if(f){throw d}}}u+=2;var m=C(["pstrut"],[]);m.style.height=u+"em";var g=[];var b=i;var y=i;var x=i;var w=true;var M=false;var k=undefined;try{for(var _=(0,l.default)(n),S;!(w=(S=_.next()).done);w=true){var T=S.value;if(T.type==="kern"){x+=T.size}else{var z=T.elem;var A=T.wrapperClasses||[];var O=C(A,[m,z]);O.style.top=-u-x-z.depth+"em";if(T.marginLeft){O.style.marginLeft=T.marginLeft}if(T.marginRight){O.style.marginRight=T.marginRight}g.push(O);x+=z.height+z.depth}b=Math.min(b,x);y=Math.max(y,x)}}catch(e){M=true;k=e}finally{try{if(!w&&_.return){_.return()}}finally{if(M){throw k}}}var L=C(["vlist"],g);L.style.height=y+"em";var N=void 0;if(b<0){var j=C(["vlist"],[]);j.style.height=-b+"em";var B=C(["vlist-s"],[new o.default.symbolNode("\u200b")]);N=[C(["vlist-r"],[L,B]),C(["vlist-r"],[j])]}else{N=[C(["vlist-r"],[L])]}var P=C(["vlist-t"],N);if(N.length===2){P.classes.push("vlist-t2")}P.height=y;P.depth=-b;return P};var B=function e(t,r){var a=t.value.body;if(t.value.star){a=a.replace(/ /g,"\u2423")}else{a=a.replace(/ /g,"\xa0")}return a};var P=function e(t,r,a){var n=q(t);var i=F(r,a);return n+"-"+i};var q=function e(t){var r="";switch(t){case"amsrm":r="AMS";break;case"textrm":r="Main";break;case"textsf":r="SansSerif";break;case"texttt":r="Typewriter";break;default:throw new Error("Invalid font provided: "+t)}return r};var F=function e(t,r){var a="";if(t==="textbf"){a+="Bold"}if(r==="textit"){a+="Italic"}return a||"Regular"};var H={"\\qquad":{size:"2em",className:"qquad"},"\\quad":{size:"1em",className:"quad"},"\\enspace":{size:"0.5em",className:"enspace"},"\\;":{size:"0.277778em",className:"thickspace"},"\\:":{size:"0.22222em",className:"mediumspace"},"\\,":{size:"0.16667em",className:"thinspace"},"\\!":{size:"-0.16667em",className:"negativethinspace"}};var R={mathbf:{variant:"bold",fontName:"Main-Bold"},mathrm:{variant:"normal",fontName:"Main-Regular"},textit:{variant:"italic",fontName:"Main-Italic"},mathbb:{variant:"double-struck",fontName:"AMS-Regular"},mathcal:{variant:"script",fontName:"Caligraphic-Regular"},mathfrak:{variant:"fraktur",fontName:"Fraktur-Regular"},mathscr:{variant:"script",fontName:"Script-Regular"},mathsf:{variant:"sans-serif",fontName:"SansSerif-Regular"},mathtt:{variant:"monospace",fontName:"Typewriter-Regular"}};var D={vec:["vec",.471,.714]};var I=function e(t,r){var a=(0,n.default)(D[t],3),i=a[0],l=a[1],u=a[2];var s=new o.default.pathNode(i);var f=new o.default.svgNode([s],{width:l+"em",height:u+"em",style:"width:"+l+"em",viewBox:"0 0 "+1e3*l+" "+1e3*u,preserveAspectRatio:"xMinYMin"});var d=C(["overlay"],[f],r);d.height=u;d.style.height=u+"em";d.style.width=l+"em";return d};r.default={fontMap:R,makeSymbol:x,mathsym:w,makeSpan:C,makeLineSpan:A,makeAnchor:O,makeFragment:N,makeVList:j,makeOrd:S,makeVerb:B,staticSvg:I,tryCombineChars:T,prependChildren:L,spacingFunctions:H}},{"./domTree":98,"./fontMetrics":101,"./stretchy":126,"./symbols":128,"./utils":133,"babel-runtime/core-js/get-iterator":3,"babel-runtime/helpers/slicedToArray":10}],92:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.buildGroup=r.groupTypes=r.makeNullDelimiter=r.getTypeOfDomTree=r.buildExpression=r.spliceSpaces=undefined;var a=e("babel-runtime/core-js/json/stringify");var n=b(a);r.default=N;var i=e("./ParseError");var l=b(i);var u=e("./Style");var o=b(u);var s=e("./buildCommon");var f=b(s);var d=e("./domTree");var c=b(d);var h=e("./units");var v=e("./utils");var p=b(v);var m=e("./stretchy");var g=b(m);function b(e){return e&&e.__esModule?e:{default:e}}var y=f.default.makeSpan;var x=function e(t){return t instanceof c.default.span&&t.classes[0]==="mspace"};var w=function e(t){return t&&t.classes[0]==="mbin"};var M=function e(t,r){if(t){return p.default.contains(["mbin","mopen","mrel","mop","mpunct"],t.classes[0])}else{return r}};var k=function e(t,r){if(t){return p.default.contains(["mrel","mclose","mpunct"],t.classes[0])}else{return r}};var _=r.spliceSpaces=function e(t,r){var a=r;while(a<t.length&&x(t[a])){a++}if(a===r){return null}else{return t.splice(r,a-r)}};var S=r.buildExpression=function e(t,r,a){var n=[];for(var i=0;i<t.length;i++){var l=t[i];var u=L(l,r);if(u instanceof c.default.documentFragment){Array.prototype.push.apply(n,u.children)}else{n.push(u)}}for(var o=0;o<n.length;o++){var s=_(n,o);if(s){if(o<n.length){if(n[o]instanceof c.default.symbolNode){n[o]=y([].concat(n[o].classes),[n[o]])}f.default.prependChildren(n[o],s)}else{Array.prototype.push.apply(n,s);break}}}for(var d=0;d<n.length;d++){if(w(n[d])&&(M(n[d-1],a)||k(n[d+1],a))){n[d].classes[0]="mord"}}for(var h=0;h<n.length;h++){if(n[h].value==="\u0338"&&h+1<n.length){var v=n.slice(h,h+2);v[0].classes=["mainrm"];v[0].style.position="absolute";v[0].style.right="0";var p=n[h+1].classes;var m=y(p,v);if(p.indexOf("mord")!==-1){m.style.paddingLeft="0.277771em"}m.style.position="relative";n.splice(h,2,m)}}return n};var T=r.getTypeOfDomTree=function e(t){if(t instanceof c.default.documentFragment){if(t.children.length){return e(t.children[t.children.length-1])}}else{if(p.default.contains(["mord","mop","mbin","mrel","mopen","mclose","mpunct","minner"],t.classes[0])){return t.classes[0]}}return null};var z=function e(t,r){if(!t.value.base){return false}else{var a=t.value.base;if(a.type==="op"){return a.value.limits&&(r.style.size===o.default.DISPLAY.size||a.value.alwaysHandleSupSub)}else if(a.type==="accent"){return p.default.isCharacterBox(a.value.base)}else if(a.type==="horizBrace"){var n=t.value.sub?false:true;return n===a.value.isOver}else{return null}}};var C=r.makeNullDelimiter=function e(t,r){var a=["nulldelimiter"].concat(t.baseSizingClasses());return y(r.concat(a))};var A=r.groupTypes={};A.mathord=function(e,t){return f.default.makeOrd(e,t,"mathord")};A.textord=function(e,t){return f.default.makeOrd(e,t,"textord")};A.bin=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mbin"])};A.rel=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mrel"])};A.open=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mopen"])};A.close=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mclose"])};A.inner=function(e,t){return f.default.mathsym(e.value,e.mode,t,["minner"])};A.punct=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mpunct"])};A.ordgroup=function(e,t){return y(["mord"],S(e.value,t,true),t)};A.supsub=function(e,t){if(z(e,t)){return A[e.value.base.type](e,t)}var r=L(e.value.base,t);var a=void 0;var n=void 0;var i=t.fontMetrics();var l=void 0;var u=0;var s=0;if(e.value.sup){l=t.havingStyle(t.style.sup());a=L(e.value.sup,l,t);if(!p.default.isCharacterBox(e.value.base)){u=r.height-l.fontMetrics().supDrop*l.sizeMultiplier/t.sizeMultiplier}}if(e.value.sub){l=t.havingStyle(t.style.sub());n=L(e.value.sub,l,t);if(!p.default.isCharacterBox(e.value.base)){s=r.depth+l.fontMetrics().subDrop*l.sizeMultiplier/t.sizeMultiplier}}var d=void 0;if(t.style===o.default.DISPLAY){d=i.sup1}else if(t.style.cramped){d=i.sup3}else{d=i.sup2}var h=t.sizeMultiplier;var v=.5/i.ptPerEm/h+"em";var m=void 0;if(!e.value.sup){s=Math.max(s,i.sub1,n.height-.8*i.xHeight);var g=[{type:"elem",elem:n,marginRight:v}];if(r instanceof c.default.symbolNode){g[0].marginLeft=-r.italic+"em"}m=f.default.makeVList({positionType:"shift",positionData:s,children:g},t)}else if(!e.value.sub){u=Math.max(u,d,a.depth+.25*i.xHeight);m=f.default.makeVList({positionType:"shift",positionData:-u,children:[{type:"elem",elem:a,marginRight:v}]},t)}else{u=Math.max(u,d,a.depth+.25*i.xHeight);s=Math.max(s,i.sub2);
var b=i.defaultRuleThickness;if(u-a.depth-(n.height-s)<4*b){s=4*b-(u-a.depth)+n.height;var x=.8*i.xHeight-(u-a.depth);if(x>0){u+=x;s-=x}}var w=[{type:"elem",elem:n,shift:s,marginRight:v},{type:"elem",elem:a,shift:-u,marginRight:v}];if(r instanceof c.default.symbolNode){w[0].marginLeft=-r.italic+"em"}m=f.default.makeVList({positionType:"individualShift",children:w},t)}var M=T(r)||"mord";return y([M],[r,y(["msupsub"],[m])],t)};A.spacing=function(e,t){if(e.value==="\\ "||e.value==="\\space"||e.value===" "||e.value==="~"){if(e.mode==="text"){return f.default.makeOrd(e,t,"textord")}else{return y(["mspace"],[f.default.mathsym(e.value,e.mode,t)],t)}}else{return y(["mspace",f.default.spacingFunctions[e.value].className],[],t)}};function O(e,t,r){var a=S(e,t,false);var n=t.sizeMultiplier/r.sizeMultiplier;for(var i=0;i<a.length;i++){var l=p.default.indexOf(a[i].classes,"sizing");if(l<0){Array.prototype.push.apply(a[i].classes,t.sizingClasses(r))}else if(a[i].classes[l+1]==="reset-size"+t.size){a[i].classes[l+1]="reset-size"+r.size}a[i].height*=n;a[i].depth*=n}return f.default.makeFragment(a)}A.sizing=function(e,t){var r=t.havingSize(e.value.size);return O(e.value.value,r,t)};A.styling=function(e,t){var r={display:o.default.DISPLAY,text:o.default.TEXT,script:o.default.SCRIPT,scriptscript:o.default.SCRIPTSCRIPT};var a=r[e.value.style];var n=t.havingStyle(a);return O(e.value.value,n,t)};A.font=function(e,t){var r=e.value.font;return L(e.value.body,t.withFontFamily(r))};A.accent=function(e,t){var r=e.value.base;var a=void 0;if(e.type==="supsub"){var n=e;e=n.value.base;r=e.value.base;n.value.base=r;a=L(n,t)}var i=L(r,t.havingCrampedStyle());var l=e.value.isShifty&&p.default.isCharacterBox(r);var u=0;if(l){var o=p.default.getBaseElem(r);var s=L(o,t.havingCrampedStyle());u=s.skew}var d=Math.min(i.height,t.fontMetrics().xHeight);var c=void 0;if(!e.value.isStretchy){var h=void 0;if(e.value.label==="\\vec"){h=f.default.staticSvg("vec",t);h.width=parseFloat(h.style.width)}else{h=f.default.makeSymbol(e.value.label,"Main-Regular",e.mode,t)}h.italic=0;c=y(["accent-body"],[h]);var v=-h.width/2;v+=u;if(e.value.label==="\\H"){v+=.5}c.style.left=v+"em";c=f.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:i},{type:"kern",size:-d},{type:"elem",elem:c}]},t)}else{c=g.default.svgSpan(e,t);c=f.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:i},{type:"elem",elem:c}]},t);var m=c.children[0].children[0].children[1];m.classes.push("svg-align");if(u>0){m.style.width="calc(100% - "+2*u+"em)";m.style.marginLeft=2*u+"em"}}var b=y(["mord","accent"],[c],t);if(a){a.children[0]=b;a.height=Math.max(b.height,a.height);a.classes[0]="mord";return a}else{return b}};A.horizBrace=function(e,t){var r=t.style;var a=e.type==="supsub";var n=void 0;var i=void 0;if(a){if(e.value.sup){i=t.havingStyle(r.sup());n=L(e.value.sup,i,t)}else{i=t.havingStyle(r.sub());n=L(e.value.sub,i,t)}e=e.value.base}var l=L(e.value.base,t.havingBaseStyle(o.default.DISPLAY));var u=g.default.svgSpan(e,t);var s=void 0;if(e.value.isOver){s=f.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:l},{type:"kern",size:.1},{type:"elem",elem:u}]},t);s.children[0].children[0].children[1].classes.push("svg-align")}else{s=f.default.makeVList({positionType:"bottom",positionData:l.depth+.1+u.height,children:[{type:"elem",elem:u},{type:"kern",size:.1},{type:"elem",elem:l}]},t);s.children[0].children[0].children[0].classes.push("svg-align")}if(a){var d=y(["mord",e.value.isOver?"mover":"munder"],[s],t);if(e.value.isOver){s=f.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:d},{type:"kern",size:.2},{type:"elem",elem:n}]},t)}else{s=f.default.makeVList({positionType:"bottom",positionData:d.depth+.2+n.height,children:[{type:"elem",elem:n},{type:"kern",size:.2},{type:"elem",elem:d}]},t)}}return y(["mord",e.value.isOver?"mover":"munder"],[s],t)};A.accentUnder=function(e,t){var r=L(e.value.base,t);var a=g.default.svgSpan(e,t);var n=/tilde/.test(e.value.label)?.12:0;var i=f.default.makeVList({positionType:"bottom",positionData:a.height+n,children:[{type:"elem",elem:a},{type:"kern",size:n},{type:"elem",elem:r}]},t);i.children[0].children[0].children[0].classes.push("svg-align");return y(["mord","accentunder"],[i],t)};A.xArrow=function(e,t){var r=t.style;var a=t.havingStyle(r.sup());var n=L(e.value.body,a,t);n.classes.push("x-arrow-pad");var i=void 0;if(e.value.below){a=t.havingStyle(r.sub());i=L(e.value.below,a,t);i.classes.push("x-arrow-pad")}var l=g.default.svgSpan(e,t);var u=-t.fontMetrics().axisHeight+.5*l.height;var o=-t.fontMetrics().axisHeight-.5*l.height-.111;var s=void 0;if(e.value.below){var d=-t.fontMetrics().axisHeight+i.height+.5*l.height+.111;s=f.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:n,shift:o},{type:"elem",elem:l,shift:u},{type:"elem",elem:i,shift:d}]},t)}else{s=f.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:n,shift:o},{type:"elem",elem:l,shift:u}]},t)}s.children[0].children[0].children[1].classes.push("svg-align");return y(["mrel","x-arrow"],[s],t)};A.mclass=function(e,t){var r=S(e.value.value,t,true);return y([e.value.mclass],r,t)};A.raisebox=function(e,t){var r=A.sizing({value:{value:[{type:"text",value:{body:e.value.value,font:"mathrm"}}],size:6}},t);var a=(0,h.calculateSize)(e.value.dy.value,t);return f.default.makeVList({positionType:"shift",positionData:-a,children:[{type:"elem",elem:r}]},t)};var L=r.buildGroup=function e(t,r,a){if(!t){return y()}if(A[t.type]){var n=A[t.type](t,r);if(a&&r.size!==a.size){n=y(r.sizingClasses(a),[n],r);var i=r.sizeMultiplier/a.sizeMultiplier;n.height*=i;n.depth*=i}return n}else{throw new l.default("Got group of unknown type: '"+t.type+"'")}};function N(e,t){e=JSON.parse((0,n.default)(e));var r=S(e,t,true);var a=y(["base"],r,t);var i=y(["strut"]);var l=y(["strut","bottom"]);i.style.height=a.height+"em";l.style.height=a.height+a.depth+"em";l.style.verticalAlign=-a.depth+"em";var u=y(["katex-html"],[i,l,a]);u.setAttribute("aria-hidden","true");return u}},{"./ParseError":84,"./Style":89,"./buildCommon":91,"./domTree":98,"./stretchy":126,"./units":132,"./utils":133,"babel-runtime/core-js/json/stringify":5}],93:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.buildGroup=r.buildExpression=r.groupTypes=r.makeText=undefined;r.default=T;var a=e("./buildCommon");var n=y(a);var i=e("./fontMetrics");var l=y(i);var u=e("./mathMLTree");var o=y(u);var s=e("./ParseError");var f=y(s);var d=e("./Style");var c=y(d);var h=e("./symbols");var v=y(h);var p=e("./utils");var m=y(p);var g=e("./stretchy");var b=y(g);function y(e){return e&&e.__esModule?e:{default:e}}var x=r.makeText=function e(t,r){if(v.default[r][t]&&v.default[r][t].replace){t=v.default[r][t].replace}return new o.default.TextNode(t)};var w=function e(t,r){var a=r.fontFamily;if(!a){return null}var i=t.mode;if(a==="mathit"){return"italic"}else if(a==="boldsymbol"){return"bold-italic"}var u=t.value;if(m.default.contains(["\\imath","\\jmath"],u)){return null}if(v.default[i][u]&&v.default[i][u].replace){u=v.default[i][u].replace}var o=n.default.fontMap[a].fontName;if(l.default.getCharacterMetrics(u,o)){return n.default.fontMap[a].variant}return null};var M=r.groupTypes={};var k={mi:"italic",mn:"normal",mtext:"normal"};M.mathord=function(e,t){var r=new o.default.MathNode("mi",[x(e.value,e.mode)]);var a=w(e,t)||"italic";if(a!==k[r.type]){r.setAttribute("mathvariant",a)}return r};M.textord=function(e,t){var r=x(e.value,e.mode);var a=w(e,t)||"normal";var n=void 0;if(e.mode==="text"){n=new o.default.MathNode("mtext",[r])}else if(/[0-9]/.test(e.value)){n=new o.default.MathNode("mn",[r])}else if(e.value==="\\prime"){n=new o.default.MathNode("mo",[r])}else{n=new o.default.MathNode("mi",[r])}if(a!==k[n.type]){n.setAttribute("mathvariant",a)}return n};M.bin=function(e,t){var r=new o.default.MathNode("mo",[x(e.value,e.mode)]);var a=w(e,t);if(a==="bold-italic"){r.setAttribute("mathvariant",a)}return r};M.rel=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);return t};M.open=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);return t};M.close=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);return t};M.inner=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);return t};M.punct=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);t.setAttribute("separator","true");return t};M.ordgroup=function(e,t){var r=_(e.value,t);var a=new o.default.MathNode("mrow",r);return a};M.supsub=function(e,t){var r=false;var a=void 0;var n=void 0;if(e.value.base){if(e.value.base.value.type==="horizBrace"){n=e.value.sup?true:false;if(n===e.value.base.value.isOver){r=true;a=e.value.base.value.isOver}}}var i=true;var l=[S(e.value.base,t,i)];if(e.value.sub){l.push(S(e.value.sub,t,i))}if(e.value.sup){l.push(S(e.value.sup,t,i))}var u=void 0;if(r){u=a?"mover":"munder"}else if(!e.value.sub){var s=e.value.base;if(s&&s.value.limits&&t.style===c.default.DISPLAY){u="mover"}else{u="msup"}}else if(!e.value.sup){var f=e.value.base;if(f&&f.value.limits&&t.style===c.default.DISPLAY){u="munder"}else{u="msub"}}else{var d=e.value.base;if(d&&d.value.limits&&t.style===c.default.DISPLAY){u="munderover"}else{u="msubsup"}}var h=new o.default.MathNode(u,l);return h};M.accent=function(e,t){var r=void 0;if(e.value.isStretchy){r=b.default.mathMLnode(e.value.label)}else{r=new o.default.MathNode("mo",[x(e.value.label,e.mode)])}var a=new o.default.MathNode("mover",[S(e.value.base,t),r]);a.setAttribute("accent","true");return a};M.spacing=function(e){var t=void 0;if(e.value==="\\ "||e.value==="\\space"||e.value===" "||e.value==="~"){t=new o.default.MathNode("mtext",[new o.default.TextNode("\xa0")])}else{t=new o.default.MathNode("mspace");t.setAttribute("width",n.default.spacingFunctions[e.value].size)}return t};M.font=function(e,t){var r=e.value.font;return S(e.value.body,t.withFontFamily(r))};M.styling=function(e,t){var r={display:c.default.DISPLAY,text:c.default.TEXT,script:c.default.SCRIPT,scriptscript:c.default.SCRIPTSCRIPT};var a=r[e.value.style];var n=t.havingStyle(a);var i=_(e.value.value,n);var l=new o.default.MathNode("mstyle",i);var u={display:["0","true"],text:["0","false"],script:["1","false"],scriptscript:["2","false"]};var s=u[e.value.style];l.setAttribute("scriptlevel",s[0]);l.setAttribute("displaystyle",s[1]);return l};M.sizing=function(e,t){var r=t.havingSize(e.value.size);var a=_(e.value.value,r);var n=new o.default.MathNode("mstyle",a);n.setAttribute("mathsize",r.sizeMultiplier+"em");return n};M.accentUnder=function(e,t){var r=b.default.mathMLnode(e.value.label);var a=new o.default.MathNode("munder",[S(e.value.body,t),r]);a.setAttribute("accentunder","true");return a};M.horizBrace=function(e,t){var r=b.default.mathMLnode(e.value.label);return new o.default.MathNode(e.value.isOver?"mover":"munder",[S(e.value.base,t),r])};M.xArrow=function(e,t){var r=b.default.mathMLnode(e.value.label);var a=void 0;var n=void 0;if(e.value.body){var i=S(e.value.body,t);if(e.value.below){n=S(e.value.below,t);a=new o.default.MathNode("munderover",[r,n,i])}else{a=new o.default.MathNode("mover",[r,i])}}else if(e.value.below){n=S(e.value.below,t);a=new o.default.MathNode("munder",[r,n])}else{a=new o.default.MathNode("mover",[r])}return a};M.mclass=function(e,t){var r=_(e.value.value,t);return new o.default.MathNode("mstyle",r)};M.raisebox=function(e,t){var r=new o.default.MathNode("mpadded",[S(e.value.body,t)]);var a=e.value.dy.value.number+e.value.dy.value.unit;r.setAttribute("voffset",a);return r};var _=r.buildExpression=function e(t,r){var a=[];for(var n=0;n<t.length;n++){var i=t[n];a.push(S(i,r))}return a};var S=r.buildGroup=function e(t,r){var a=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(!t){return new o.default.MathNode("mrow")}if(M[t.type]){var n=M[t.type](t,r);if(a){if(n.type==="mrow"&&n.children.length===1){return n.children[0]}}return n}else{throw new f.default("Got group of unknown type: '"+t.type+"'")}};function T(e,t,r){var a=_(e,r);var i=new o.default.MathNode("mrow",a);var l=new o.default.MathNode("annotation",[new o.default.TextNode(t)]);l.setAttribute("encoding","application/x-tex");var u=new o.default.MathNode("semantics",[i,l]);var s=new o.default.MathNode("math",[u]);return n.default.makeSpan(["katex-mathml"],[s])}},{"./ParseError":84,"./Style":89,"./buildCommon":91,"./fontMetrics":101,"./mathMLTree":124,"./stretchy":126,"./symbols":128,"./utils":133}],94:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.buildHTMLTree=r.buildTree=undefined;var a=e("./buildHTML");var n=p(a);var i=e("./buildMathML");var l=p(i);var u=e("./buildCommon");var o=p(u);var s=e("./Options");var f=p(s);var d=e("./Settings");var c=p(d);var h=e("./Style");var v=p(h);function p(e){return e&&e.__esModule?e:{default:e}}var m=function e(t){return new f.default({style:t.displayMode?v.default.DISPLAY:v.default.TEXT,maxSize:t.maxSize})};var g=r.buildTree=function e(t,r,a){var i=m(a);var u=(0,l.default)(t,r,i);var s=(0,n.default)(t,i);var f=o.default.makeSpan(["katex"],[u,s]);if(a.displayMode){return o.default.makeSpan(["katex-display"],[f])}else{return f}};var b=r.buildHTMLTree=function e(t,r,a){var i=m(a);var l=(0,n.default)(t,i);var u=o.default.makeSpan(["katex"],[l]);if(a.displayMode){return o.default.makeSpan(["katex-display"],[u])}else{return u}};r.default=g},{"./Options":83,"./Settings":87,"./Style":89,"./buildCommon":91,"./buildHTML":92,"./buildMathML":93}],95:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r._environments=undefined;r.default=d;var a=e("./buildHTML");var n=e("./buildMathML");var i=e("./Options");var l=s(i);var u=e("./ParseNode");var o=s(u);function s(e){return e&&e.__esModule?e:{default:e}}var f=r._environments={};function d(e){var t=e.type,r=e.names,i=e.props,l=e.handler,u=e.htmlBuilder,o=e.mathmlBuilder;var s={numArgs:i.numArgs||0,greediness:1,allowedInText:false,numOptionalArgs:0,handler:l};for(var d=0;d<r.length;++d){f[r[d]]=s}if(u){a.groupTypes[t]=u}if(o){n.groupTypes[t]=o}}},{"./Options":83,"./ParseNode":85,"./buildHTML":92,"./buildMathML":93}],96:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.ordargument=r._functions=undefined;r.default=l;var a=e("./buildHTML");var n=e("./buildMathML");var i=r._functions={};function l(e){var t=e.type,r=e.names,l=e.props,u=e.handler,o=e.htmlBuilder,s=e.mathmlBuilder;var f={numArgs:l.numArgs,argTypes:l.argTypes,greediness:l.greediness===undefined?1:l.greediness,allowedInText:!!l.allowedInText,allowedInMath:l.allowedInMath===undefined?true:l.allowedInMath,numOptionalArgs:l.numOptionalArgs||0,infix:!!l.infix,handler:u};for(var d=0;d<r.length;++d){i[r[d]]=f}if(t){if(o){a.groupTypes[t]=o}if(s){n.groupTypes[t]=s}}}var u=r.ordargument=function e(t){if(t.type==="ordgroup"){return t.value}else{return[t]}}},{"./buildHTML":92,"./buildMathML":93}],97:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./ParseError");var n=g(a);var i=e("./Style");var l=g(i);var u=e("./domTree");var o=g(u);var s=e("./buildCommon");var f=g(s);var d=e("./fontMetrics");var c=g(d);var h=e("./symbols");var v=g(h);var p=e("./utils");var m=g(p);function g(e){return e&&e.__esModule?e:{default:e}}var b=function e(t,r){if(v.default.math[t]&&v.default.math[t].replace){return c.default.getCharacterMetrics(v.default.math[t].replace,r)}else{return c.default.getCharacterMetrics(t,r)}};var y=function e(t,r,a,n){var i=a.havingBaseStyle(r);var l=f.default.makeSpan((n||[]).concat(i.sizingClasses(a)),[t],a);l.delimSizeMultiplier=i.sizeMultiplier/a.sizeMultiplier;l.height*=l.delimSizeMultiplier;l.depth*=l.delimSizeMultiplier;l.maxFontSize=i.sizeMultiplier;return l};var x=function e(t,r,a){var n=r.havingBaseStyle(a);var i=(1-r.sizeMultiplier/n.sizeMultiplier)*r.fontMetrics().axisHeight;t.classes.push("delimcenter");t.style.top=i+"em";t.height-=i;t.depth+=i};var w=function e(t,r,a,n,i,l){var u=f.default.makeSymbol(t,"Main-Regular",i,n);var o=y(u,r,n,l);if(a){x(o,n,r)}return o};var M=function e(t,r,a,n){return f.default.makeSymbol(t,"Size"+r+"-Regular",a,n)};var k=function e(t,r,a,n,i,u){var o=M(t,r,i,n);var s=y(f.default.makeSpan(["delimsizing","size"+r],[o],n),l.default.TEXT,n,u);if(a){x(s,n,l.default.TEXT)}return s};var _=function e(t,r,a){var n=void 0;if(r==="Size1-Regular"){n="delim-size1"}else if(r==="Size4-Regular"){n="delim-size4"}var i=f.default.makeSpan(["delimsizinginner",n],[f.default.makeSpan([],[f.default.makeSymbol(t,r,a)])]);return{type:"elem",elem:i}};var S=function e(t,r,a,n,i,u){var o=void 0;var s=void 0;var d=void 0;var c=void 0;o=d=c=t;s=null;var h="Size1-Regular";if(t==="\\uparrow"){d=c="\u23d0"}else if(t==="\\Uparrow"){d=c="\u2016"}else if(t==="\\downarrow"){o=d="\u23d0"}else if(t==="\\Downarrow"){o=d="\u2016"}else if(t==="\\updownarrow"){o="\\uparrow";d="\u23d0";c="\\downarrow"}else if(t==="\\Updownarrow"){o="\\Uparrow";d="\u2016";c="\\Downarrow"}else if(t==="["||t==="\\lbrack"){o="\u23a1";d="\u23a2";c="\u23a3";h="Size4-Regular"}else if(t==="]"||t==="\\rbrack"){o="\u23a4";d="\u23a5";c="\u23a6";h="Size4-Regular"}else if(t==="\\lfloor"){d=o="\u23a2";c="\u23a3";h="Size4-Regular"}else if(t==="\\lceil"){o="\u23a1";d=c="\u23a2";h="Size4-Regular"}else if(t==="\\rfloor"){d=o="\u23a5";c="\u23a6";h="Size4-Regular"}else if(t==="\\rceil"){o="\u23a4";d=c="\u23a5";h="Size4-Regular"}else if(t==="("){o="\u239b";d="\u239c";c="\u239d";h="Size4-Regular"}else if(t===")"){o="\u239e";d="\u239f";c="\u23a0";h="Size4-Regular"}else if(t==="\\{"||t==="\\lbrace"){o="\u23a7";s="\u23a8";c="\u23a9";d="\u23aa";h="Size4-Regular"}else if(t==="\\}"||t==="\\rbrace"){o="\u23ab";s="\u23ac";c="\u23ad";d="\u23aa";h="Size4-Regular"}else if(t==="\\lgroup"){o="\u23a7";c="\u23a9";d="\u23aa";h="Size4-Regular"}else if(t==="\\rgroup"){o="\u23ab";c="\u23ad";d="\u23aa";h="Size4-Regular"}else if(t==="\\lmoustache"){o="\u23a7";c="\u23ad";d="\u23aa";h="Size4-Regular"}else if(t==="\\rmoustache"){o="\u23ab";c="\u23a9";d="\u23aa";h="Size4-Regular"}var v=b(o,h);var p=v.height+v.depth;var m=b(d,h);var g=m.height+m.depth;var x=b(c,h);var w=x.height+x.depth;var M=0;var k=1;if(s!==null){var S=b(s,h);M=S.height+S.depth;k=2}var T=p+w+M;var z=Math.ceil((r-T)/(k*g));var C=T+z*k*g;var A=n.fontMetrics().axisHeight;if(a){A*=n.sizeMultiplier}var O=C/2-A;var L=[];L.push(_(c,h,i));if(s===null){for(var N=0;N<z;N++){L.push(_(d,h,i))}}else{for(var E=0;E<z;E++){L.push(_(d,h,i))}L.push(_(s,h,i));for(var j=0;j<z;j++){L.push(_(d,h,i))}}L.push(_(o,h,i));var B=n.havingBaseStyle(l.default.TEXT);var P=f.default.makeVList({positionType:"bottom",positionData:O,children:L},B);return y(f.default.makeSpan(["delimsizing","mult"],[P],B),l.default.TEXT,n,u)};var T=function e(t,r,a,n){var i=void 0;if(t==="sqrtTall"){var l=a-54;i="M702 0H400000v40H742v"+l+"l-4 4-4 4c-.667.667\n-2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1h-12l-28-84c-16.667-52-96.667\n-294.333-240-727l-212 -643 -85 170c-4-3.333-8.333-7.667-13 -13l-13-13l77-155\n 77-156c66 199.333 139 419.667 219 661 l218 661zM702 0H400000v40H742z"}var u=new o.default.pathNode(t,i);var s=new o.default.svgNode([u],{width:"400em",height:r+"em",viewBox:"0 0 400000 "+a,preserveAspectRatio:"xMinYMin slice"});return f.default.makeSpan(["hide-tail"],[s],n)};var z=function e(t,r){var a=q("\\surd",t,B,r);var n=void 0;var i=r.sizeMultiplier;var l=void 0;var u=void 0;if(a.type==="small"){u=1e3;var o=r.havingBaseStyle(a.style);i=o.sizeMultiplier/r.sizeMultiplier;l=1*i;n=T("sqrtMain",l,u,r);n.style.minWidth="0.853em";n.advanceWidth=.833*i}else if(a.type==="large"){u=1e3*L[a.size];l=L[a.size]/i;n=T("sqrtSize"+a.size,l,u,r);n.style.minWidth="1.02em";n.advanceWidth=1/i}else{l=t/i;u=Math.floor(1e3*t);n=T("sqrtTall",l,u,r);n.style.minWidth="0.742em";n.advanceWidth=1.056/i}n.height=l;n.style.height=l+"em";return{span:n,ruleWidth:r.fontMetrics().sqrtRuleThickness*i}};var C=["(",")","[","\\lbrack","]","\\rbrack","\\{","\\lbrace","\\}","\\rbrace","\\lfloor","\\rfloor","\\lceil","\\rceil","\\surd"];var A=["\\uparrow","\\downarrow","\\updownarrow","\\Uparrow","\\Downarrow","\\Updownarrow","|","\\|","\\vert","\\Vert","\\lvert","\\rvert","\\lVert","\\rVert","\\lgroup","\\rgroup","\\lmoustache","\\rmoustache"];var O=["<",">","\\langle","\\rangle","/","\\backslash","\\lt","\\gt"];var L=[0,1.2,1.8,2.4,3];var N=function e(t,r,a,i,l){if(t==="<"||t==="\\lt"){t="\\langle"}else if(t===">"||t==="\\gt"){t="\\rangle"}if(m.default.contains(C,t)||m.default.contains(O,t)){return k(t,r,false,a,i,l)}else if(m.default.contains(A,t)){return S(t,L[r],false,a,i,l)}else{throw new n.default("Illegal delimiter: '"+t+"'")}};var E=[{type:"small",style:l.default.SCRIPTSCRIPT},{type:"small",style:l.default.SCRIPT},{type:"small",style:l.default.TEXT},{type:"large",size:1},{type:"large",size:2},{type:"large",size:3},{type:"large",size:4}];var j=[{type:"small",style:l.default.SCRIPTSCRIPT},{type:"small",style:l.default.SCRIPT},{type:"small",style:l.default.TEXT},{type:"stack"}];var B=[{type:"small",style:l.default.SCRIPTSCRIPT},{type:"small",style:l.default.SCRIPT},{type:"small",style:l.default.TEXT},{type:"large",size:1},{type:"large",size:2},{type:"large",size:3},{type:"large",size:4},{type:"stack"}];var P=function e(t){if(t.type==="small"){return"Main-Regular"}else if(t.type==="large"){return"Size"+t.size+"-Regular"}else if(t.type==="stack"){return"Size4-Regular"}};var q=function e(t,r,a,n){var i=Math.min(2,3-n.style.size);for(var l=i;l<a.length;l++){if(a[l].type==="stack"){break}var u=b(t,P(a[l]));var o=u.height+u.depth;if(a[l].type==="small"){var s=n.havingBaseStyle(a[l].style);o*=s.sizeMultiplier}if(o>r){return a[l]}}return a[a.length-1]};var F=function e(t,r,a,n,i,l){if(t==="<"||t==="\\lt"){t="\\langle"}else if(t===">"||t==="\\gt"){t="\\rangle"}var u=void 0;if(m.default.contains(O,t)){u=E}else if(m.default.contains(C,t)){u=B}else{u=j}var o=q(t,r,u,n);if(o.type==="small"){return w(t,o.style,a,n,i,l)}else if(o.type==="large"){return k(t,o.size,a,n,i,l)}else{return S(t,r,a,n,i,l)}};var H=function e(t,r,a,n,i,l){var u=n.fontMetrics().axisHeight*n.sizeMultiplier;var o=901;var s=5/n.fontMetrics().ptPerEm;var f=Math.max(r-u,a+u);var d=Math.max(f/500*o,2*f-s);return F(t,d,true,n,i,l)};r.default={sqrtImage:z,sizedDelim:N,customSizedDelim:F,leftRightDelim:H}},{"./ParseError":84,"./Style":89,"./buildCommon":91,"./domTree":98,"./fontMetrics":101,"./symbols":128,"./utils":133}],98:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/core-js/get-iterator");var n=v(a);var i=e("babel-runtime/helpers/classCallCheck");var l=v(i);var u=e("babel-runtime/helpers/createClass");var o=v(u);var s=e("./unicodeScripts");var f=e("./utils");var d=v(f);var c=e("./svgGeometry");var h=v(c);function v(e){return e&&e.__esModule?e:{default:e}}var p=function e(t){t=t.slice();for(var r=t.length-1;r>=0;r--){if(!t[r]){t.splice(r,1)}}return t.join(" ")};var m=function(){function e(t,r,a){(0,l.default)(this,e);this.classes=t||[];this.children=r||[];this.height=0;this.depth=0;this.maxFontSize=0;this.style={};this.attributes={};if(a){if(a.style.isTight()){this.classes.push("mtight")}var n=a.getColor();if(n){this.style.color=n}}}(0,o.default)(e,[{key:"setAttribute",value:function e(t,r){this.attributes[t]=r}},{key:"tryCombine",value:function e(t){return false}},{key:"toNode",value:function e(){var t=document.createElement("span");t.className=p(this.classes);for(var r in this.style){if(Object.prototype.hasOwnProperty.call(this.style,r)){t.style[r]=this.style[r]}}for(var a in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,a)){t.setAttribute(a,this.attributes[a])}}for(var n=0;n<this.children.length;n++){t.appendChild(this.children[n].toNode())}return t}},{key:"toMarkup",value:function e(){var t="<span";if(this.classes.length){t+=' class="';t+=d.default.escape(p(this.classes));t+='"'}var r="";for(var a in this.style){if(this.style.hasOwnProperty(a)){r+=d.default.hyphenate(a)+":"+this.style[a]+";"}}if(r){t+=' style="'+d.default.escape(r)+'"'}for(var n in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,n)){t+=" "+n+'="';t+=d.default.escape(this.attributes[n]);t+='"'}}t+=">";for(var i=0;i<this.children.length;i++){t+=this.children[i].toMarkup()}t+="</span>";return t}}]);return e}();var g=function(){function e(t,r,a,n){(0,l.default)(this,e);this.href=t;this.classes=r;this.children=a;this.height=0;this.depth=0;this.maxFontSize=0;this.style={};this.attributes={};if(n.style.isTight()){this.classes.push("mtight")}var i=n.getColor();if(i){this.style.color=i}}(0,o.default)(e,[{key:"setAttribute",value:function e(t,r){this.attributes[t]=r}},{key:"tryCombine",value:function e(t){return false}},{key:"toNode",value:function e(){var t=document.createElement("a");t.setAttribute("href",this.href);if(this.classes.length){t.className=p(this.classes)}for(var r in this.style){if(Object.prototype.hasOwnProperty.call(this.style,r)){t.style[r]=this.style[r]}}for(var a in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,a)){t.setAttribute(a,this.attributes[a])}}for(var n=0;n<this.children.length;n++){t.appendChild(this.children[n].toNode())}return t}},{key:"toMarkup",value:function e(){var t="<a";t+='href="'+(t+=d.default.escape(this.href))+'"';if(this.classes.length){t+=' class="'+d.default.escape(p(this.classes))+'"'}var r="";for(var a in this.style){if(this.style.hasOwnProperty(a)){r+=d.default.hyphenate(a)+":"+this.style[a]+";"}}if(r){t+=' style="'+d.default.escape(r)+'"'}for(var i in this.attributes){if(i!=="href"&&Object.prototype.hasOwnProperty.call(this.attributes,i)){t+=" "+i+'="'+d.default.escape(this.attributes[i])+'"'}}t+=">";var l=true;var u=false;var o=undefined;try{for(var s=(0,n.default)(this.children),f;!(l=(f=s.next()).done);l=true){var c=f.value;t+=c.toMarkup()}}catch(e){u=true;o=e}finally{try{if(!l&&s.return){s.return()}}finally{if(u){throw o}}}t+="</a>";return t}}]);return e}();var b=function(){function e(t){(0,l.default)(this,e);this.children=t||[];this.height=0;this.depth=0;this.maxFontSize=0}(0,o.default)(e,[{key:"toNode",value:function e(){var t=document.createDocumentFragment();for(var r=0;r<this.children.length;r++){t.appendChild(this.children[r].toNode())}return t}},{key:"toMarkup",value:function e(){var t="";for(var r=0;r<this.children.length;r++){t+=this.children[r].toMarkup()}return t}}]);return e}();var y={"\xee":"\u0131\u0302","\xef":"\u0131\u0308","\xed":"\u0131\u0301","\xec":"\u0131\u0300"};var x=function(){function e(t,r,a,n,i,u,o,f){(0,l.default)(this,e);this.value=t;this.height=r||0;this.depth=a||0;this.italic=n||0;this.skew=i||0;this.width=u||0;this.classes=o||[];this.style=f||{};this.maxFontSize=0;var d=(0,s.scriptFromCodepoint)(this.value.charCodeAt(0));if(d){this.classes.push(d+"_fallback")}if(/[\xee\xef\xed\xec]/.test(this.value)){this.value=y[this.value]}}(0,o.default)(e,[{key:"tryCombine",value:function t(r){if(!r||!(r instanceof e)||this.italic>0||p(this.classes)!==p(r.classes)||this.skew!==r.skew||this.maxFontSize!==r.maxFontSize){return false}for(var a in this.style){if(this.style.hasOwnProperty(a)&&this.style[a]!==r.style[a]){return false}}for(var n in r.style){if(r.style.hasOwnProperty(n)&&this.style[n]!==r.style[n]){return false}}this.value+=r.value;this.height=Math.max(this.height,r.height);this.depth=Math.max(this.depth,r.depth);this.italic=r.italic;return true}},{key:"toNode",value:function e(){var t=document.createTextNode(this.value);var r=null;if(this.italic>0){r=document.createElement("span");r.style.marginRight=this.italic+"em"}if(this.classes.length>0){r=r||document.createElement("span");r.className=p(this.classes)}for(var a in this.style){if(this.style.hasOwnProperty(a)){r=r||document.createElement("span");r.style[a]=this.style[a]}}if(r){r.appendChild(t);return r}else{return t}}},{key:"toMarkup",value:function e(){var t=false;var r="<span";if(this.classes.length){t=true;r+=' class="';r+=d.default.escape(p(this.classes));r+='"'}var a="";if(this.italic>0){a+="margin-right:"+this.italic+"em;"}for(var n in this.style){if(this.style.hasOwnProperty(n)){a+=d.default.hyphenate(n)+":"+this.style[n]+";"}}if(a){t=true;r+=' style="'+d.default.escape(a)+'"'}var i=d.default.escape(this.value);if(t){r+=">";r+=i;r+="</span>";return r}else{return i}}}]);return e}();var w=function(){function e(t,r){(0,l.default)(this,e);this.children=t||[];this.attributes=r||{};this.height=0;this.depth=0;this.maxFontSize=0}(0,o.default)(e,[{key:"toNode",value:function e(){var t="http://www.w3.org/2000/svg";var r=document.createElementNS(t,"svg");for(var a in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,a)){r.setAttribute(a,this.attributes[a])}}for(var n=0;n<this.children.length;n++){r.appendChild(this.children[n].toNode())}return r}},{key:"toMarkup",value:function e(){var t="<svg";for(var r in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,r)){t+=" "+r+"='"+this.attributes[r]+"'"}}t+=">";for(var a=0;a<this.children.length;a++){t+=this.children[a].toMarkup()}t+="</svg>";return t}}]);return e}();var M=function(){function e(t,r){(0,l.default)(this,e);this.pathName=t;this.alternate=r}(0,o.default)(e,[{key:"toNode",value:function e(){var t="http://www.w3.org/2000/svg";var r=document.createElementNS(t,"path");if(this.alternate){r.setAttribute("d",this.alternate)}else{r.setAttribute("d",h.default.path[this.pathName])}return r}},{key:"toMarkup",value:function e(){if(this.alternate){return"<path d='"+this.alternate+"'/>"}else{return"<path d='"+h.default.path[this.pathName]+"'/>"}}}]);return e}();var k=function(){function e(t){(0,l.default)(this,e);this.attributes=t||{}}(0,o.default)(e,[{key:"toNode",value:function e(){var t="http://www.w3.org/2000/svg";var r=document.createElementNS(t,"line");for(var a in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,a)){r.setAttribute(a,this.attributes[a])}}return r}},{key:"toMarkup",value:function e(){var t="<line";for(var r in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,r)){t+=" "+r+"='"+this.attributes[r]+"'"}}t+="/>";return t}}]);return e}();r.default={span:m,anchor:g,documentFragment:b,symbolNode:x,svgNode:w,pathNode:M,lineNode:k}},{"./svgGeometry":127,"./unicodeScripts":130,"./utils":133,"babel-runtime/core-js/get-iterator":3,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],99:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./defineEnvironment");e("./environments/array.js");var n=a._environments;r.default=n},{"./defineEnvironment":95,"./environments/array.js":100}],100:[function(e,t,r){"use strict";var a=e("../buildCommon");var n=k(a);var i=e("../defineEnvironment");var l=k(i);var u=e("../mathMLTree");var o=k(u);var s=e("../ParseError");var f=k(s);var d=e("../ParseNode");var c=k(d);var h=e("../units");var v=e("../utils");var p=k(v);var m=e("../stretchy");var g=k(m);var b=e("../buildHTML");var y=M(b);var x=e("../buildMathML");var w=M(x);function M(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function k(e){return e&&e.__esModule?e:{default:e}}function _(e,t,r){var a=[];var n=[a];var i=[];while(true){var l=e.parseExpression(false,undefined);l=new c.default("ordgroup",l,e.mode);if(r){l=new c.default("styling",{style:r,value:[l]},e.mode)}a.push(l);var u=e.nextToken.text;if(u==="&"){e.consume()}else if(u==="\\end"){var o=n[n.length-1];if(n.length>1&&o.length===1&&o[0].value.value[0].value.length===0){n.pop()}break}else if(u==="\\\\"||u==="\\cr"){var s=e.parseFunction();if(!s){throw new f.default("Failed to parse function after "+u)}i.push(s.value.size);a=[];n.push(a)}else{throw new f.default("Expected & or \\\\ or \\end",e.nextToken)}}t.body=n;t.rowGaps=i;return new c.default(t.type,t,e.mode)}function S(e){if(e.substr(0,1)==="d"){
return"display"}else{return"text"}}var T=function e(t,r){var a=void 0;var i=void 0;var l=t.value.body.length;var u=0;var o=new Array(l);var s=1/r.fontMetrics().ptPerEm;var d=5*s;var c=12*s;var v=3*s;var m=p.default.deflt(t.value.arraystretch,1);var b=m*c;var x=.7*b;var w=.3*b;var M=0;for(a=0;a<t.value.body.length;++a){var k=t.value.body[a];var _=x;var S=w;if(u<k.length){u=k.length}var T=new Array(k.length);for(i=0;i<k.length;++i){var z=y.buildGroup(k[i],r);if(S<z.depth){S=z.depth}if(_<z.height){_=z.height}T[i]=z}var C=0;if(t.value.rowGaps[a]){C=(0,h.calculateSize)(t.value.rowGaps[a].value,r);if(C>0){C+=w;if(S<C){S=C}C=0}}if(t.value.addJot){S+=v}T.height=_;T.depth=S;M+=_;T.pos=M;M+=S+C;o[a]=T}var A=M/2+r.fontMetrics().axisHeight;var O=t.value.cols||[];var L=[];var N=void 0;var E=void 0;for(i=0,E=0;i<u||E<O.length;++i,++E){var j=O[E]||{};var B=true;while(j.type==="separator"){if(!B){N=n.default.makeSpan(["arraycolsep"],[]);N.style.width=r.fontMetrics().doubleRuleSep+"em";L.push(N)}if(j.separator==="|"){var P=g.default.ruleSpan("vertical-separator",.05,r);P.style.height=M+"em";P.style.verticalAlign=-(M-A)+"em";L.push(P)}else{throw new f.default("Invalid separator type: "+j.separator)}E++;j=O[E]||{};B=false}if(i>=u){continue}var q=void 0;if(i>0||t.value.hskipBeforeAndAfter){q=p.default.deflt(j.pregap,d);if(q!==0){N=n.default.makeSpan(["arraycolsep"],[]);N.style.width=q+"em";L.push(N)}}var F=[];for(a=0;a<l;++a){var H=o[a];var R=H[i];if(!R){continue}var D=H.pos-A;R.depth=H.depth;R.height=H.height;F.push({type:"elem",elem:R,shift:D})}F=n.default.makeVList({positionType:"individualShift",children:F},r);F=n.default.makeSpan(["col-align-"+(j.align||"c")],[F]);L.push(F);if(i<u-1||t.value.hskipBeforeAndAfter){q=p.default.deflt(j.postgap,d);if(q!==0){N=n.default.makeSpan(["arraycolsep"],[]);N.style.width=q+"em";L.push(N)}}}o=n.default.makeSpan(["mtable"],L);return n.default.makeSpan(["mord"],[o],r)};var z=function e(t,r){return new o.default.MathNode("mtable",t.value.body.map(function(e){return new o.default.MathNode("mtr",e.map(function(e){return new o.default.MathNode("mtd",[w.buildGroup(e,r)])}))}))};var C=function e(t,r){var a={type:"array",cols:[],addJot:true};a=_(t.parser,a,"display");var n=void 0;var i=0;var l=new c.default("ordgroup",[],t.mode);if(r[0]&&r[0].value){var u="";for(var o=0;o<r[0].value.length;o++){u+=r[0].value[o].value}n=Number(u);i=n*2}var s=!i;a.value.body.forEach(function(e){for(var t=1;t<e.length;t+=2){var r=e[t].value.value[0];r.value.unshift(l)}if(!s){var a=e.length/2;if(n<a){throw new f.default("Too many math in a row: "+("expected "+n+", but got "+a),e)}}else if(i<e.length){i=e.length}});for(var d=0;d<i;++d){var h="r";var v=0;if(d%2===1){h="l"}else if(d>0&&s){v=1}a.value.cols[d]={type:"align",align:h,pregap:v,postgap:0}}return a};(0,l.default)({type:"array",names:["array","darray"],props:{numArgs:1},handler:function e(t,r){var a=r[0];a=a.value.map?a.value:[a];var n=a.map(function(e){var t=e.value;if("lcr".indexOf(t)!==-1){return{type:"align",align:t}}else if(t==="|"){return{type:"separator",separator:"|"}}throw new f.default("Unknown column alignment: "+e.value,e)});var i={type:"array",cols:n,hskipBeforeAndAfter:true};i=_(t.parser,i,S(t.envName));return i},htmlBuilder:T,mathmlBuilder:z});(0,l.default)({type:"array",names:["matrix","pmatrix","bmatrix","Bmatrix","vmatrix","Vmatrix"],props:{numArgs:0},handler:function e(t){var r={matrix:null,pmatrix:["(",")"],bmatrix:["[","]"],Bmatrix:["\\{","\\}"],vmatrix:["|","|"],Vmatrix:["\\Vert","\\Vert"]}[t.envName];var a={type:"array",hskipBeforeAndAfter:false};a=_(t.parser,a,S(t.envName));if(r){a=new c.default("leftright",{body:[a],left:r[0],right:r[1]},t.mode)}return a},htmlBuilder:T,mathmlBuilder:z});(0,l.default)({type:"array",names:["cases","dcases"],props:{numArgs:0},handler:function e(t){var r={type:"array",arraystretch:1.2,cols:[{type:"align",align:"l",pregap:0,postgap:1},{type:"align",align:"l",pregap:0,postgap:0}]};r=_(t.parser,r,S(t.envName));r=new c.default("leftright",{body:[r],left:"\\{",right:"."},t.mode);return r},htmlBuilder:T,mathmlBuilder:z});(0,l.default)({type:"array",names:["aligned"],props:{numArgs:0},handler:C,htmlBuilder:T,mathmlBuilder:z});(0,l.default)({type:"array",names:["gathered"],props:{numArgs:0},handler:function e(t){var r={type:"array",cols:[{type:"align",align:"c"}],addJot:true};r=_(t.parser,r,"display");return r},htmlBuilder:T,mathmlBuilder:z});(0,l.default)({type:"array",names:["alignedat"],props:{numArgs:1},handler:C,htmlBuilder:T,mathmlBuilder:z})},{"../ParseError":84,"../ParseNode":85,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineEnvironment":95,"../mathMLTree":124,"../stretchy":126,"../units":132,"../utils":133}],101:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./unicodeScripts");var n=e("./fontMetricsData");var i=l(n);function l(e){return e&&e.__esModule?e:{default:e}}var u={slant:[.25,.25,.25],space:[0,0,0],stretch:[0,0,0],shrink:[0,0,0],xHeight:[.431,.431,.431],quad:[1,1.171,1.472],extraSpace:[0,0,0],num1:[.677,.732,.925],num2:[.394,.384,.387],num3:[.444,.471,.504],denom1:[.686,.752,1.025],denom2:[.345,.344,.532],sup1:[.413,.503,.504],sup2:[.363,.431,.404],sup3:[.289,.286,.294],sub1:[.15,.143,.2],sub2:[.247,.286,.4],supDrop:[.386,.353,.494],subDrop:[.05,.071,.1],delim1:[2.39,1.7,1.98],delim2:[1.01,1.157,1.42],axisHeight:[.25,.25,.25],defaultRuleThickness:[.04,.049,.049],bigOpSpacing1:[.111,.111,.111],bigOpSpacing2:[.166,.166,.166],bigOpSpacing3:[.2,.2,.2],bigOpSpacing4:[.6,.611,.611],bigOpSpacing5:[.1,.143,.143],sqrtRuleThickness:[.04,.04,.04],ptPerEm:[10,10,10],doubleRuleSep:[.2,.2,.2]};var o={"\xc5":"A","\xc7":"C","\xd0":"D","\xde":"o","\xe5":"a","\xe7":"c","\xf0":"d","\xfe":"o","\u0410":"A","\u0411":"B","\u0412":"B","\u0413":"F","\u0414":"A","\u0415":"E","\u0416":"K","\u0417":"3","\u0418":"N","\u0419":"N","\u041a":"K","\u041b":"N","\u041c":"M","\u041d":"H","\u041e":"O","\u041f":"N","\u0420":"P","\u0421":"C","\u0422":"T","\u0423":"y","\u0424":"O","\u0425":"X","\u0426":"U","\u0427":"h","\u0428":"W","\u0429":"W","\u042a":"B","\u042b":"X","\u042c":"B","\u042d":"3","\u042e":"X","\u042f":"R","\u0430":"a","\u0431":"b","\u0432":"a","\u0433":"r","\u0434":"y","\u0435":"e","\u0436":"m","\u0437":"e","\u0438":"n","\u0439":"n","\u043a":"n","\u043b":"n","\u043c":"m","\u043d":"n","\u043e":"o","\u043f":"n","\u0440":"p","\u0441":"c","\u0442":"o","\u0443":"y","\u0444":"b","\u0445":"x","\u0446":"n","\u0447":"n","\u0448":"w","\u0449":"w","\u044a":"a","\u044b":"m","\u044c":"a","\u044d":"e","\u044e":"m","\u044f":"r"};var s=function e(t,r){if(!i.default[r]){throw new Error("Font metrics not found for font: "+r+".")}var n=t.charCodeAt(0);if(t[0]in o){n=o[t[0]].charCodeAt(0)}var l=i.default[r][n];if(!l){if((0,a.supportedCodepoint)(n)){l=i.default[r][77]}}if(l){return{depth:l[0],height:l[1],italic:l[2],skew:l[3],width:l[4]}}};var f={};var d=function e(t){var r=void 0;if(t>=5){r=0}else if(t>=3){r=1}else{r=2}if(!f[r]){var a=f[r]={cssEmPerMu:u.quad[r]/18};for(var n in u){if(u.hasOwnProperty(n)){a[n]=u[n][r]}}}return f[r]};r.default={getFontMetrics:d,getCharacterMetrics:s}},{"./fontMetricsData":102,"./unicodeScripts":130}],102:[function(e,t,r){"use strict";t.exports={"AMS-Regular":{65:[0,.68889,0,0,.72222],66:[0,.68889,0,0,.66667],67:[0,.68889,0,0,.72222],68:[0,.68889,0,0,.72222],69:[0,.68889,0,0,.66667],70:[0,.68889,0,0,.61111],71:[0,.68889,0,0,.77778],72:[0,.68889,0,0,.77778],73:[0,.68889,0,0,.38889],74:[.16667,.68889,0,0,.5],75:[0,.68889,0,0,.77778],76:[0,.68889,0,0,.66667],77:[0,.68889,0,0,.94445],78:[0,.68889,0,0,.72222],79:[.16667,.68889,0,0,.77778],80:[0,.68889,0,0,.61111],81:[.16667,.68889,0,0,.77778],82:[0,.68889,0,0,.72222],83:[0,.68889,0,0,.55556],84:[0,.68889,0,0,.66667],85:[0,.68889,0,0,.72222],86:[0,.68889,0,0,.72222],87:[0,.68889,0,0,1],88:[0,.68889,0,0,.72222],89:[0,.68889,0,0,.72222],90:[0,.68889,0,0,.66667],107:[0,.68889,0,0,.55556],165:[0,.675,.025,0,.75],174:[.15559,.69224,0,0,.94666],240:[0,.68889,0,0,.55556],295:[0,.68889,0,0,.54028],710:[0,.825,0,0,2.33334],732:[0,.9,0,0,2.33334],770:[0,.825,0,0,2.33334],771:[0,.9,0,0,2.33334],989:[.08167,.58167,0,0,.77778],1008:[0,.43056,.04028,0,.66667],8245:[0,.54986,0,0,.275],8463:[0,.68889,0,0,.54028],8487:[0,.68889,0,0,.72222],8498:[0,.68889,0,0,.55556],8502:[0,.68889,0,0,.66667],8503:[0,.68889,0,0,.44445],8504:[0,.68889,0,0,.66667],8513:[0,.68889,0,0,.63889],8592:[-.03598,.46402,0,0,.5],8594:[-.03598,.46402,0,0,.5],8602:[-.13313,.36687,0,0,1],8603:[-.13313,.36687,0,0,1],8606:[.01354,.52239,0,0,1],8608:[.01354,.52239,0,0,1],8610:[.01354,.52239,0,0,1.11111],8611:[.01354,.52239,0,0,1.11111],8619:[0,.54986,0,0,1],8620:[0,.54986,0,0,1],8621:[-.13313,.37788,0,0,1.38889],8622:[-.13313,.36687,0,0,1],8624:[0,.69224,0,0,.5],8625:[0,.69224,0,0,.5],8630:[0,.43056,0,0,1],8631:[0,.43056,0,0,1],8634:[.08198,.58198,0,0,.77778],8635:[.08198,.58198,0,0,.77778],8638:[.19444,.69224,0,0,.41667],8639:[.19444,.69224,0,0,.41667],8642:[.19444,.69224,0,0,.41667],8643:[.19444,.69224,0,0,.41667],8644:[.1808,.675,0,0,1],8646:[.1808,.675,0,0,1],8647:[.1808,.675,0,0,1],8648:[.19444,.69224,0,0,.83334],8649:[.1808,.675,0,0,1],8650:[.19444,.69224,0,0,.83334],8651:[.01354,.52239,0,0,1],8652:[.01354,.52239,0,0,1],8653:[-.13313,.36687,0,0,1],8654:[-.13313,.36687,0,0,1],8655:[-.13313,.36687,0,0,1],8666:[.13667,.63667,0,0,1],8667:[.13667,.63667,0,0,1],8669:[-.13313,.37788,0,0,1],8672:[-.064,.437,0,0,1187],8674:[-.064,.437,0,0,1167],8705:[0,.825,0,0,.5],8708:[0,.68889,0,0,.55556],8709:[.08167,.58167,0,0,.77778],8717:[0,.43056,0,0,.42917],8722:[-.03598,.46402,0,0,.5],8724:[.08198,.69224,0,0,.77778],8726:[.08167,.58167,0,0,.77778],8733:[0,.69224,0,0,.77778],8736:[0,.69224,0,0,.72222],8737:[0,.69224,0,0,.72222],8738:[.03517,.52239,0,0,.72222],8739:[.08167,.58167,0,0,.22222],8740:[.25142,.74111,0,0,.27778],8741:[.08167,.58167,0,0,.38889],8742:[.25142,.74111,0,0,.5],8756:[0,.69224,0,0,.66667],8757:[0,.69224,0,0,.66667],8764:[-.13313,.36687,0,0,.77778],8765:[-.13313,.37788,0,0,.77778],8769:[-.13313,.36687,0,0,.77778],8770:[-.03625,.46375,0,0,.77778],8774:[.30274,.79383,0,0,.77778],8776:[-.01688,.48312,0,0,.77778],8778:[.08167,.58167,0,0,.77778],8782:[.06062,.54986,0,0,.77778],8783:[.06062,.54986,0,0,.77778],8785:[.08198,.58198,0,0,.77778],8786:[.08198,.58198,0,0,.77778],8787:[.08198,.58198,0,0,.77778],8790:[0,.69224,0,0,.77778],8791:[.22958,.72958,0,0,.77778],8796:[.08198,.91667,0,0,.77778],8806:[.25583,.75583,0,0,.77778],8807:[.25583,.75583,0,0,.77778],8808:[.25142,.75726,0,0,.77778],8809:[.25142,.75726,0,0,.77778],8812:[.25583,.75583,0,0,.5],8814:[.20576,.70576,0,0,.77778],8815:[.20576,.70576,0,0,.77778],8816:[.30274,.79383,0,0,.77778],8817:[.30274,.79383,0,0,.77778],8818:[.22958,.72958,0,0,.77778],8819:[.22958,.72958,0,0,.77778],8822:[.1808,.675,0,0,.77778],8823:[.1808,.675,0,0,.77778],8828:[.13667,.63667,0,0,.77778],8829:[.13667,.63667,0,0,.77778],8830:[.22958,.72958,0,0,.77778],8831:[.22958,.72958,0,0,.77778],8832:[.20576,.70576,0,0,.77778],8833:[.20576,.70576,0,0,.77778],8840:[.30274,.79383,0,0,.77778],8841:[.30274,.79383,0,0,.77778],8842:[.13597,.63597,0,0,.77778],8843:[.13597,.63597,0,0,.77778],8847:[.03517,.54986,0,0,.77778],8848:[.03517,.54986,0,0,.77778],8858:[.08198,.58198,0,0,.77778],8859:[.08198,.58198,0,0,.77778],8861:[.08198,.58198,0,0,.77778],8862:[0,.675,0,0,.77778],8863:[0,.675,0,0,.77778],8864:[0,.675,0,0,.77778],8865:[0,.675,0,0,.77778],8872:[0,.69224,0,0,.61111],8873:[0,.69224,0,0,.72222],8874:[0,.69224,0,0,.88889],8876:[0,.68889,0,0,.61111],8877:[0,.68889,0,0,.61111],8878:[0,.68889,0,0,.72222],8879:[0,.68889,0,0,.72222],8882:[.03517,.54986,0,0,.77778],8883:[.03517,.54986,0,0,.77778],8884:[.13667,.63667,0,0,.77778],8885:[.13667,.63667,0,0,.77778],8888:[0,.54986,0,0,1.11111],8890:[.19444,.43056,0,0,.55556],8891:[.19444,.69224,0,0,.61111],8892:[.19444,.69224,0,0,.61111],8901:[0,.54986,0,0,.27778],8903:[.08167,.58167,0,0,.77778],8905:[.08167,.58167,0,0,.77778],8906:[.08167,.58167,0,0,.77778],8907:[0,.69224,0,0,.77778],8908:[0,.69224,0,0,.77778],8909:[-.03598,.46402,0,0,.77778],8910:[0,.54986,0,0,.76042],8911:[0,.54986,0,0,.76042],8912:[.03517,.54986,0,0,.77778],8913:[.03517,.54986,0,0,.77778],8914:[0,.54986,0,0,.66667],8915:[0,.54986,0,0,.66667],8916:[0,.69224,0,0,.66667],8918:[.0391,.5391,0,0,.77778],8919:[.0391,.5391,0,0,.77778],8920:[.03517,.54986,0,0,1.33334],8921:[.03517,.54986,0,0,1.33334],8922:[.38569,.88569,0,0,.77778],8923:[.38569,.88569,0,0,.77778],8926:[.13667,.63667,0,0,.77778],8927:[.13667,.63667,0,0,.77778],8928:[.30274,.79383,0,0,.77778],8929:[.30274,.79383,0,0,.77778],8934:[.23222,.74111,0,0,.77778],8935:[.23222,.74111,0,0,.77778],8936:[.23222,.74111,0,0,.77778],8937:[.23222,.74111,0,0,.77778],8938:[.20576,.70576,0,0,.77778],8939:[.20576,.70576,0,0,.77778],8940:[.30274,.79383,0,0,.77778],8941:[.30274,.79383,0,0,.77778],8994:[.19444,.69224,0,0,.77778],8995:[.19444,.69224,0,0,.77778],9416:[.15559,.69224,0,0,.90222],9484:[0,.69224,0,0,.5],9488:[0,.69224,0,0,.5],9492:[0,.37788,0,0,.5],9496:[0,.37788,0,0,.5],9585:[.19444,.68889,0,0,.88889],9586:[.19444,.74111,0,0,.88889],9632:[0,.675,0,0,.77778],9633:[0,.675,0,0,.77778],9650:[0,.54986,0,0,.72222],9651:[0,.54986,0,0,.72222],9654:[.03517,.54986,0,0,.77778],9660:[0,.54986,0,0,.72222],9661:[0,.54986,0,0,.72222],9664:[.03517,.54986,0,0,.77778],9674:[.11111,.69224,0,0,.66667],9733:[.19444,.69224,0,0,.94445],10003:[0,.69224,0,0,.83334],10016:[0,.69224,0,0,.83334],10731:[.11111,.69224,0,0,.66667],10846:[.19444,.75583,0,0,.61111],10877:[.13667,.63667,0,0,.77778],10878:[.13667,.63667,0,0,.77778],10885:[.25583,.75583,0,0,.77778],10886:[.25583,.75583,0,0,.77778],10887:[.13597,.63597,0,0,.77778],10888:[.13597,.63597,0,0,.77778],10889:[.26167,.75726,0,0,.77778],10890:[.26167,.75726,0,0,.77778],10891:[.48256,.98256,0,0,.77778],10892:[.48256,.98256,0,0,.77778],10901:[.13667,.63667,0,0,.77778],10902:[.13667,.63667,0,0,.77778],10933:[.25142,.75726,0,0,.77778],10934:[.25142,.75726,0,0,.77778],10935:[.26167,.75726,0,0,.77778],10936:[.26167,.75726,0,0,.77778],10937:[.26167,.75726,0,0,.77778],10938:[.26167,.75726,0,0,.77778],10949:[.25583,.75583,0,0,.77778],10950:[.25583,.75583,0,0,.77778],10955:[.28481,.79383,0,0,.77778],10956:[.28481,.79383,0,0,.77778],57350:[.08167,.58167,0,0,.22222],57351:[.08167,.58167,0,0,.38889],57352:[.08167,.58167,0,0,.77778],57353:[0,.43056,.04028,0,.66667],57356:[.25142,.75726,0,0,.77778],57357:[.25142,.75726,0,0,.77778],57358:[.41951,.91951,0,0,.77778],57359:[.30274,.79383,0,0,.77778],57360:[.30274,.79383,0,0,.77778],57361:[.41951,.91951,0,0,.77778],57366:[.25142,.75726,0,0,.77778],57367:[.25142,.75726,0,0,.77778],57368:[.25142,.75726,0,0,.77778],57369:[.25142,.75726,0,0,.77778],57370:[.13597,.63597,0,0,.77778],57371:[.13597,.63597,0,0,.77778]},"Caligraphic-Regular":{48:[0,.43056,0,0,.5],49:[0,.43056,0,0,.5],50:[0,.43056,0,0,.5],51:[.19444,.43056,0,0,.5],52:[.19444,.43056,0,0,.5],53:[.19444,.43056,0,0,.5],54:[0,.64444,0,0,.5],55:[.19444,.43056,0,0,.5],56:[0,.64444,0,0,.5],57:[.19444,.43056,0,0,.5],65:[0,.68333,0,.19445,.79847],66:[0,.68333,.03041,.13889,.65681],67:[0,.68333,.05834,.13889,.52653],68:[0,.68333,.02778,.08334,.77139],69:[0,.68333,.08944,.11111,.52778],70:[0,.68333,.09931,.11111,.71875],71:[.09722,.68333,.0593,.11111,.59487],72:[0,.68333,.00965,.11111,.84452],73:[0,.68333,.07382,0,.54452],74:[.09722,.68333,.18472,.16667,.67778],75:[0,.68333,.01445,.05556,.76195],76:[0,.68333,0,.13889,.68972],77:[0,.68333,0,.13889,1.2009],78:[0,.68333,.14736,.08334,.82049],79:[0,.68333,.02778,.11111,.79611],80:[0,.68333,.08222,.08334,.69556],81:[.09722,.68333,0,.11111,.81667],82:[0,.68333,0,.08334,.8475],83:[0,.68333,.075,.13889,.60556],84:[0,.68333,.25417,0,.54464],85:[0,.68333,.09931,.08334,.62583],86:[0,.68333,.08222,0,.61278],87:[0,.68333,.08222,.08334,.98778],88:[0,.68333,.14643,.13889,.7133],89:[.09722,.68333,.08222,.08334,.66834],90:[0,.68333,.07944,.13889,.72473]},"Fraktur-Regular":{33:[0,.69141,0,0,.29574],34:[0,.69141,0,0,.21471],38:[0,.69141,0,0,.73786],39:[0,.69141,0,0,.21201],40:[.24982,.74947,0,0,.38865],41:[.24982,.74947,0,0,.38865],42:[0,.62119,0,0,.27764],43:[.08319,.58283,0,0,.75623],44:[0,.10803,0,0,.27764],45:[.08319,.58283,0,0,.75623],46:[0,.10803,0,0,.27764],47:[.24982,.74947,0,0,.50181],48:[0,.47534,0,0,.50181],49:[0,.47534,0,0,.50181],50:[0,.47534,0,0,.50181],51:[.18906,.47534,0,0,.50181],52:[.18906,.47534,0,0,.50181],53:[.18906,.47534,0,0,.50181],54:[0,.69141,0,0,.50181],55:[.18906,.47534,0,0,.50181],56:[0,.69141,0,0,.50181],57:[.18906,.47534,0,0,.50181],58:[0,.47534,0,0,.21606],59:[.12604,.47534,0,0,.21606],61:[-.13099,.36866,0,0,.75623],63:[0,.69141,0,0,.36245],65:[0,.69141,0,0,.7176],66:[0,.69141,0,0,.88397],67:[0,.69141,0,0,.61254],68:[0,.69141,0,0,.83158],69:[0,.69141,0,0,.66278],70:[.12604,.69141,0,0,.61119],71:[0,.69141,0,0,.78539],72:[.06302,.69141,0,0,.7203],73:[0,.69141,0,0,.55448],74:[.12604,.69141,0,0,.55231],75:[0,.69141,0,0,.66845],76:[0,.69141,0,0,.66602],77:[0,.69141,0,0,1.04953],78:[0,.69141,0,0,.83212],79:[0,.69141,0,0,.82699],80:[.18906,.69141,0,0,.82753],81:[.03781,.69141,0,0,.82699],82:[0,.69141,0,0,.82807],83:[0,.69141,0,0,.82861],84:[0,.69141,0,0,.66899],85:[0,.69141,0,0,.64576],86:[0,.69141,0,0,.83131],87:[0,.69141,0,0,1.04602],88:[0,.69141,0,0,.71922],89:[.18906,.69141,0,0,.83293],90:[.12604,.69141,0,0,.60201],91:[.24982,.74947,0,0,.27764],93:[.24982,.74947,0,0,.27764],94:[0,.69141,0,0,.49965],97:[0,.47534,0,0,.50046],98:[0,.69141,0,0,.51315],99:[0,.47534,0,0,.38946],100:[0,.62119,0,0,.49857],101:[0,.47534,0,0,.40053],102:[.18906,.69141,0,0,.32626],103:[.18906,.47534,0,0,.5037],104:[.18906,.69141,0,0,.52126],105:[0,.69141,0,0,.27899],106:[0,.69141,0,0,.28088],107:[0,.69141,0,0,.38946],108:[0,.69141,0,0,.27953],109:[0,.47534,0,0,.76676],110:[0,.47534,0,0,.52666],111:[0,.47534,0,0,.48885],112:[.18906,.52396,0,0,.50046],113:[.18906,.47534,0,0,.48912],114:[0,.47534,0,0,.38919],115:[0,.47534,0,0,.44266],116:[0,.62119,0,0,.33301],117:[0,.47534,0,0,.5172],118:[0,.52396,0,0,.5118],119:[0,.52396,0,0,.77351],120:[.18906,.47534,0,0,.38865],121:[.18906,.47534,0,0,.49884],122:[.18906,.47534,0,0,.39054],8216:[0,.69141,0,0,.21471],8217:[0,.69141,0,0,.21471],58112:[0,.62119,0,0,.49749],58113:[0,.62119,0,0,.4983],58114:[.18906,.69141,0,0,.33328],58115:[.18906,.69141,0,0,.32923],58116:[.18906,.47534,0,0,.50343],58117:[0,.69141,0,0,.33301],58118:[0,.62119,0,0,.33409],58119:[0,.47534,0,0,.50073]},"Main-Bold":{33:[0,.69444,0,0,.35],34:[0,.69444,0,0,.60278],35:[.19444,.69444,0,0,.95833],36:[.05556,.75,0,0,.575],37:[.05556,.75,0,0,.95833],38:[0,.69444,0,0,.89444],39:[0,.69444,0,0,.31944],40:[.25,.75,0,0,.44722],41:[.25,.75,0,0,.44722],42:[0,.75,0,0,.575],43:[.13333,.63333,0,0,.89444],44:[.19444,.15556,0,0,.31944],45:[0,.44444,0,0,.38333],46:[0,.15556,0,0,.31944],47:[.25,.75,0,0,.575],48:[0,.64444,0,0,.575],49:[0,.64444,0,0,.575],50:[0,.64444,0,0,.575],51:[0,.64444,0,0,.575],52:[0,.64444,0,0,.575],53:[0,.64444,0,0,.575],54:[0,.64444,0,0,.575],55:[0,.64444,0,0,.575],56:[0,.64444,0,0,.575],57:[0,.64444,0,0,.575],58:[0,.44444,0,0,.31944],59:[.19444,.44444,0,0,.31944],60:[.08556,.58556,0,0,.89444],61:[-.10889,.39111,0,0,.89444],62:[.08556,.58556,0,0,.89444],63:[0,.69444,0,0,.54305],64:[0,.69444,0,0,.89444],65:[0,.68611,0,0,.86944],66:[0,.68611,0,0,.81805],67:[0,.68611,0,0,.83055],68:[0,.68611,0,0,.88194],69:[0,.68611,0,0,.75555],70:[0,.68611,0,0,.72361],71:[0,.68611,0,0,.90416],72:[0,.68611,0,0,.9],73:[0,.68611,0,0,.43611],74:[0,.68611,0,0,.59444],75:[0,.68611,0,0,.90138],76:[0,.68611,0,0,.69166],77:[0,.68611,0,0,1.09166],78:[0,.68611,0,0,.9],79:[0,.68611,0,0,.86388],80:[0,.68611,0,0,.78611],81:[.19444,.68611,0,0,.86388],82:[0,.68611,0,0,.8625],83:[0,.68611,0,0,.63889],84:[0,.68611,0,0,.8],85:[0,.68611,0,0,.88472],86:[0,.68611,.01597,0,.86944],87:[0,.68611,.01597,0,1.18888],88:[0,.68611,0,0,.86944],89:[0,.68611,.02875,0,.86944],90:[0,.68611,0,0,.70277],91:[.25,.75,0,0,.31944],92:[.25,.75,0,0,.575],93:[.25,.75,0,0,.31944],94:[0,.69444,0,0,.575],95:[.31,.13444,.03194,0,.575],96:[0,.69444,0,0,.575],97:[0,.44444,0,0,.55902],98:[0,.69444,0,0,.63889],99:[0,.44444,0,0,.51111],100:[0,.69444,0,0,.63889],101:[0,.44444,0,0,.52708],102:[0,.69444,.10903,0,.35139],103:[.19444,.44444,.01597,0,.575],104:[0,.69444,0,0,.63889],105:[0,.69444,0,0,.31944],106:[.19444,.69444,0,0,.35139],107:[0,.69444,0,0,.60694],108:[0,.69444,0,0,.31944],109:[0,.44444,0,0,.95833],110:[0,.44444,0,0,.63889],111:[0,.44444,0,0,.575],112:[.19444,.44444,0,0,.63889],113:[.19444,.44444,0,0,.60694],114:[0,.44444,0,0,.47361],115:[0,.44444,0,0,.45361],116:[0,.63492,0,0,.44722],117:[0,.44444,0,0,.63889],118:[0,.44444,.01597,0,.60694],119:[0,.44444,.01597,0,.83055],120:[0,.44444,0,0,.60694],121:[.19444,.44444,.01597,0,.60694],122:[0,.44444,0,0,.51111],123:[.25,.75,0,0,.575],124:[.25,.75,0,0,.31944],125:[.25,.75,0,0,.575],126:[.35,.34444,0,0,.575],168:[0,.69444,0,0,.575],172:[0,.44444,0,0,.76666],175:[0,.59611,0,0,.575],176:[0,.69444,0,0,.86944],177:[.13333,.63333,0,0,.89444],180:[0,.69444,0,0,.575],215:[.13333,.63333,0,0,.89444],247:[.13333,.63333,0,0,.89444],305:[0,.44444,0,0,.31944],567:[.19444,.44444,0,0,.35139],710:[0,.69444,0,0,.575],711:[0,.63194,0,0,.575],713:[0,.59611,0,0,.575],714:[0,.69444,0,0,.575],715:[0,.69444,0,0,.575],728:[0,.69444,0,0,.575],729:[0,.69444,0,0,.31944],730:[0,.69444,0,0,.86944],732:[0,.69444,0,0,.575],768:[0,.69444,0,0,.575],769:[0,.69444,0,0,.575],770:[0,.69444,0,0,.575],771:[0,.69444,0,0,.575],772:[0,.59611,0,0,.575],774:[0,.69444,0,0,.575],775:[0,.69444,0,0,.31944],776:[0,.69444,0,0,.575],778:[0,.69444,0,0,.86944],779:[0,.69444,0,0,.575],780:[0,.63194,0,0,.575],824:[.19444,.69444,0,0,0],915:[0,.68611,0,0,.69166],916:[0,.68611,0,0,.95833],920:[0,.68611,0,0,.89444],923:[0,.68611,0,0,.80555],926:[0,.68611,0,0,.76666],928:[0,.68611,0,0,.9],931:[0,.68611,0,0,.83055],933:[0,.68611,0,0,.89444],934:[0,.68611,0,0,.83055],936:[0,.68611,0,0,.89444],937:[0,.68611,0,0,.83055],8211:[0,.44444,.03194,0,.575],8212:[0,.44444,.03194,0,1.14999],8216:[0,.69444,0,0,.31944],8217:[0,.69444,0,0,.31944],8220:[0,.69444,0,0,.60278],8221:[0,.69444,0,0,.60278],8224:[.19444,.69444,0,0,.51111],8225:[.19444,.69444,0,0,.51111],8242:[0,.55556,0,0,.34444],8407:[0,.72444,.15486,0,.575],8463:[0,.69444,0,0,.66759],8465:[0,.69444,0,0,.83055],8467:[0,.69444,0,0,.47361],8472:[.19444,.44444,0,0,.74027],8476:[0,.69444,0,0,.83055],8501:[0,.69444,0,0,.70277],8592:[-.10889,.39111,0,0,1.14999],8593:[.19444,.69444,0,0,.575],8594:[-.10889,.39111,0,0,1.14999],8595:[.19444,.69444,0,0,.575],8596:[-.10889,.39111,0,0,1.14999],8597:[.25,.75,0,0,.575],8598:[.19444,.69444,0,0,1.14999],8599:[.19444,.69444,0,0,1.14999],8600:[.19444,.69444,0,0,1.14999],8601:[.19444,.69444,0,0,1.14999],8636:[-.10889,.39111,0,0,1.14999],8637:[-.10889,.39111,0,0,1.14999],8640:[-.10889,.39111,0,0,1.14999],8641:[-.10889,.39111,0,0,1.14999],8656:[-.10889,.39111,0,0,1.14999],8657:[.19444,.69444,0,0,.70277],8658:[-.10889,.39111,0,0,1.14999],8659:[.19444,.69444,0,0,.70277],8660:[-.10889,.39111,0,0,1.14999],8661:[.25,.75,0,0,.70277],8704:[0,.69444,0,0,.63889],8706:[0,.69444,.06389,0,.62847],8707:[0,.69444,0,0,.63889],8709:[.05556,.75,0,0,.575],8711:[0,.68611,0,0,.95833],8712:[.08556,.58556,0,0,.76666],8715:[.08556,.58556,0,0,.76666],8722:[.13333,.63333,0,0,.89444],8723:[.13333,.63333,0,0,.89444],8725:[.25,.75,0,0,.575],8726:[.25,.75,0,0,.575],8727:[-.02778,.47222,0,0,.575],8728:[-.02639,.47361,0,0,.575],8729:[-.02639,.47361,0,0,.575],8730:[.18,.82,0,0,.95833],8733:[0,.44444,0,0,.89444],8734:[0,.44444,0,0,1.14999],8736:[0,.69224,0,0,.72222],8739:[.25,.75,0,0,.31944],8741:[.25,.75,0,0,.575],8743:[0,.55556,0,0,.76666],8744:[0,.55556,0,0,.76666],8745:[0,.55556,0,0,.76666],8746:[0,.55556,0,0,.76666],8747:[.19444,.69444,.12778,0,.56875],8764:[-.10889,.39111,0,0,.89444],8768:[.19444,.69444,0,0,.31944],8771:[.00222,.50222,0,0,.89444],8776:[.02444,.52444,0,0,.89444],8781:[.00222,.50222,0,0,.89444],8801:[.00222,.50222,0,0,.89444],8804:[.19667,.69667,0,0,.89444],8805:[.19667,.69667,0,0,.89444],8810:[.08556,.58556,0,0,1.14999],8811:[.08556,.58556,0,0,1.14999],8826:[.08556,.58556,0,0,.89444],8827:[.08556,.58556,0,0,.89444],8834:[.08556,.58556,0,0,.89444],8835:[.08556,.58556,0,0,.89444],8838:[.19667,.69667,0,0,.89444],8839:[.19667,.69667,0,0,.89444],8846:[0,.55556,0,0,.76666],8849:[.19667,.69667,0,0,.89444],8850:[.19667,.69667,0,0,.89444],8851:[0,.55556,0,0,.76666],8852:[0,.55556,0,0,.76666],8853:[.13333,.63333,0,0,.89444],8854:[.13333,.63333,0,0,.89444],8855:[.13333,.63333,0,0,.89444],8856:[.13333,.63333,0,0,.89444],8857:[.13333,.63333,0,0,.89444],8866:[0,.69444,0,0,.70277],8867:[0,.69444,0,0,.70277],8868:[0,.69444,0,0,.89444],8869:[0,.69444,0,0,.89444],8900:[-.02639,.47361,0,0,.575],8901:[-.02639,.47361,0,0,.31944],8902:[-.02778,.47222,0,0,.575],8968:[.25,.75,0,0,.51111],8969:[.25,.75,0,0,.51111],8970:[.25,.75,0,0,.51111],8971:[.25,.75,0,0,.51111],8994:[-.13889,.36111,0,0,1.14999],8995:[-.13889,.36111,0,0,1.14999],9651:[.19444,.69444,0,0,1.02222],9657:[-.02778,.47222,0,0,.575],9661:[.19444,.69444,0,0,1.02222],9667:[-.02778,.47222,0,0,.575],9711:[.19444,.69444,0,0,1.14999],9824:[.12963,.69444,0,0,.89444],9825:[.12963,.69444,0,0,.89444],9826:[.12963,.69444,0,0,.89444],9827:[.12963,.69444,0,0,.89444],9837:[0,.75,0,0,.44722],9838:[.19444,.69444,0,0,.44722],9839:[.19444,.69444,0,0,.44722],10216:[.25,.75,0,0,.44722],10217:[.25,.75,0,0,.44722],10815:[0,.68611,0,0,.9],10927:[.19667,.69667,0,0,.89444],10928:[.19667,.69667,0,0,.89444]},"Main-Italic":{33:[0,.69444,.12417,0,.30667],34:[0,.69444,.06961,0,.51444],35:[.19444,.69444,.06616,0,.81777],37:[.05556,.75,.13639,0,.81777],38:[0,.69444,.09694,0,.76666],39:[0,.69444,.12417,0,.30667],40:[.25,.75,.16194,0,.40889],41:[.25,.75,.03694,0,.40889],42:[0,.75,.14917,0,.51111],43:[.05667,.56167,.03694,0,.76666],44:[.19444,.10556,0,0,.30667],45:[0,.43056,.02826,0,.35778],46:[0,.10556,0,0,.30667],47:[.25,.75,.16194,0,.51111],48:[0,.64444,.13556,0,.51111],49:[0,.64444,.13556,0,.51111],50:[0,.64444,.13556,0,.51111],51:[0,.64444,.13556,0,.51111],52:[.19444,.64444,.13556,0,.51111],53:[0,.64444,.13556,0,.51111],54:[0,.64444,.13556,0,.51111],55:[.19444,.64444,.13556,0,.51111],56:[0,.64444,.13556,0,.51111],57:[0,.64444,.13556,0,.51111],58:[0,.43056,.0582,0,.30667],59:[.19444,.43056,.0582,0,.30667],61:[-.13313,.36687,.06616,0,.76666],63:[0,.69444,.1225,0,.51111],64:[0,.69444,.09597,0,.76666],65:[0,.68333,0,0,.74333],66:[0,.68333,.10257,0,.70389],67:[0,.68333,.14528,0,.71555],68:[0,.68333,.09403,0,.755],69:[0,.68333,.12028,0,.67833],70:[0,.68333,.13305,0,.65277],71:[0,.68333,.08722,0,.77361],72:[0,.68333,.16389,0,.74333],73:[0,.68333,.15806,0,.38555],74:[0,.68333,.14028,0,.525],75:[0,.68333,.14528,0,.76888],76:[0,.68333,0,0,.62722],77:[0,.68333,.16389,0,.89666],78:[0,.68333,.16389,0,.74333],79:[0,.68333,.09403,0,.76666],80:[0,.68333,.10257,0,.67833],81:[.19444,.68333,.09403,0,.76666],82:[0,.68333,.03868,0,.72944],83:[0,.68333,.11972,0,.56222],84:[0,.68333,.13305,0,.71555],85:[0,.68333,.16389,0,.74333],86:[0,.68333,.18361,0,.74333],87:[0,.68333,.18361,0,.99888],88:[0,.68333,.15806,0,.74333],89:[0,.68333,.19383,0,.74333],90:[0,.68333,.14528,0,.61333],91:[.25,.75,.1875,0,.30667],93:[.25,.75,.10528,0,.30667],94:[0,.69444,.06646,0,.51111],95:[.31,.12056,.09208,0,.51111],97:[0,.43056,.07671,0,.51111],98:[0,.69444,.06312,0,.46],99:[0,.43056,.05653,0,.46],100:[0,.69444,.10333,0,.51111],101:[0,.43056,.07514,0,.46],102:[.19444,.69444,.21194,0,.30667],103:[.19444,.43056,.08847,0,.46],104:[0,.69444,.07671,0,.51111],105:[0,.65536,.1019,0,.30667],106:[.19444,.65536,.14467,0,.30667],107:[0,.69444,.10764,0,.46],108:[0,.69444,.10333,0,.25555],109:[0,.43056,.07671,0,.81777],110:[0,.43056,.07671,0,.56222],111:[0,.43056,.06312,0,.51111],112:[.19444,.43056,.06312,0,.51111],113:[.19444,.43056,.08847,0,.46],114:[0,.43056,.10764,0,.42166],115:[0,.43056,.08208,0,.40889],116:[0,.61508,.09486,0,.33222],117:[0,.43056,.07671,0,.53666],118:[0,.43056,.10764,0,.46],119:[0,.43056,.10764,0,.66444],120:[0,.43056,.12042,0,.46389],121:[.19444,.43056,.08847,0,.48555],122:[0,.43056,.12292,0,.40889],126:[.35,.31786,.11585,0,.51111],163:[0,.69444,0,0,.76909],305:[0,.43056,0,.02778,.32246],567:[.19444,.43056,0,.08334,.38403],768:[0,.69444,0,0,.51111],769:[0,.69444,.09694,0,.51111],770:[0,.69444,.06646,0,.51111],771:[0,.66786,.11585,0,.51111],772:[0,.56167,.10333,0,.51111],774:[0,.69444,.10806,0,.51111],775:[0,.66786,.11752,0,.30667],776:[0,.66786,.10474,0,.51111],778:[0,.69444,0,0,.83129],779:[0,.69444,.1225,0,.51111],780:[0,.62847,.08295,0,.51111],915:[0,.68333,.13305,0,.62722],916:[0,.68333,0,0,.81777],920:[0,.68333,.09403,0,.76666],923:[0,.68333,0,0,.69222],926:[0,.68333,.15294,0,.66444],928:[0,.68333,.16389,0,.74333],931:[0,.68333,.12028,0,.71555],933:[0,.68333,.11111,0,.76666],934:[0,.68333,.05986,0,.71555],936:[0,.68333,.11111,0,.76666],937:[0,.68333,.10257,0,.71555],8211:[0,.43056,.09208,0,.51111],8212:[0,.43056,.09208,0,1.02222],8216:[0,.69444,.12417,0,.30667],8217:[0,.69444,.12417,0,.30667],8220:[0,.69444,.1685,0,.51444],8221:[0,.69444,.06961,0,.51444],8463:[0,.68889,0,0,.54028]},"Main-Regular":{32:[0,0,0,0,0],33:[0,.69444,0,0,.27778],34:[0,.69444,0,0,.5],35:[.19444,.69444,0,0,.83334],36:[.05556,.75,0,0,.5],37:[.05556,.75,0,0,.83334],38:[0,.69444,0,0,.77778],39:[0,.69444,0,0,.27778],40:[.25,.75,0,0,.38889],41:[.25,.75,0,0,.38889],42:[0,.75,0,0,.5],43:[.08333,.58333,0,0,.77778],44:[.19444,.10556,0,0,.27778],45:[0,.43056,0,0,.33333],46:[0,.10556,0,0,.27778],47:[.25,.75,0,0,.5],48:[0,.64444,0,0,.5],49:[0,.64444,0,0,.5],50:[0,.64444,0,0,.5],51:[0,.64444,0,0,.5],52:[0,.64444,0,0,.5],53:[0,.64444,0,0,.5],54:[0,.64444,0,0,.5],55:[0,.64444,0,0,.5],56:[0,.64444,0,0,.5],57:[0,.64444,0,0,.5],58:[0,.43056,0,0,.27778],59:[.19444,.43056,0,0,.27778],60:[.0391,.5391,0,0,.77778],61:[-.13313,.36687,0,0,.77778],62:[.0391,.5391,0,0,.77778],63:[0,.69444,0,0,.47222],64:[0,.69444,0,0,.77778],65:[0,.68333,0,0,.75],66:[0,.68333,0,0,.70834],67:[0,.68333,0,0,.72222],68:[0,.68333,0,0,.76389],69:[0,.68333,0,0,.68056],70:[0,.68333,0,0,.65278],71:[0,.68333,0,0,.78472],72:[0,.68333,0,0,.75],73:[0,.68333,0,0,.36111],74:[0,.68333,0,0,.51389],75:[0,.68333,0,0,.77778],76:[0,.68333,0,0,.625],77:[0,.68333,0,0,.91667],78:[0,.68333,0,0,.75],79:[0,.68333,0,0,.77778],80:[0,.68333,0,0,.68056],81:[.19444,.68333,0,0,.77778],82:[0,.68333,0,0,.73611],83:[0,.68333,0,0,.55556],84:[0,.68333,0,0,.72222],85:[0,.68333,0,0,.75],86:[0,.68333,.01389,0,.75],87:[0,.68333,.01389,0,1.02778],88:[0,.68333,0,0,.75],89:[0,.68333,.025,0,.75],90:[0,.68333,0,0,.61111],91:[.25,.75,0,0,.27778],92:[.25,.75,0,0,.5],93:[.25,.75,0,0,.27778],94:[0,.69444,0,0,.5],95:[.31,.12056,.02778,0,.5],96:[0,.69444,0,0,.5],97:[0,.43056,0,0,.5],98:[0,.69444,0,0,.55556],99:[0,.43056,0,0,.44445],100:[0,.69444,0,0,.55556],101:[0,.43056,0,0,.44445],102:[0,.69444,.07778,0,.30556],103:[.19444,.43056,.01389,0,.5],104:[0,.69444,0,0,.55556],105:[0,.66786,0,0,.27778],106:[.19444,.66786,0,0,.30556],107:[0,.69444,0,0,.52778],108:[0,.69444,0,0,.27778],109:[0,.43056,0,0,.83334],110:[0,.43056,0,0,.55556],111:[0,.43056,0,0,.5],112:[.19444,.43056,0,0,.55556],113:[.19444,.43056,0,0,.52778],114:[0,.43056,0,0,.39167],115:[0,.43056,0,0,.39445],116:[0,.61508,0,0,.38889],117:[0,.43056,0,0,.55556],118:[0,.43056,.01389,0,.52778],119:[0,.43056,.01389,0,.72222],120:[0,.43056,0,0,.52778],121:[.19444,.43056,.01389,0,.52778],122:[0,.43056,0,0,.44445],123:[.25,.75,0,0,.5],124:[.25,.75,0,0,.27778],125:[.25,.75,0,0,.5],126:[.35,.31786,0,0,.5],160:[0,0,0,0,0],168:[0,.66786,0,0,.5],172:[0,.43056,0,0,.66667],175:[0,.56778,0,0,.5],176:[0,.69444,0,0,.75],177:[.08333,.58333,0,0,.77778],180:[0,.69444,0,0,.5],198:[0,.68333,0,0,.90278],215:[.08333,.58333,0,0,.77778],216:[.04861,.73194,0,0,.77778],223:[0,.69444,0,0,.5],230:[0,.43056,0,0,.72222],247:[.08333,.58333,0,0,.77778],248:[.09722,.52778,0,0,.5],305:[0,.43056,0,0,.27778],338:[0,.68333,0,0,1.01389],339:[0,.43056,0,0,.77778],567:[.19444,.43056,0,0,.30556],710:[0,.69444,0,0,.5],711:[0,.62847,0,0,.5],713:[0,.56778,0,0,.5],714:[0,.69444,0,0,.5],
715:[0,.69444,0,0,.5],728:[0,.69444,0,0,.5],729:[0,.66786,0,0,.27778],730:[0,.69444,0,0,.75],732:[0,.66786,0,0,.5],768:[0,.69444,0,0,.5],769:[0,.69444,0,0,.5],770:[0,.69444,0,0,.5],771:[0,.66786,0,0,.5],772:[0,.56778,0,0,.5],774:[0,.69444,0,0,.5],775:[0,.66786,0,0,.27778],776:[0,.66786,0,0,.5],778:[0,.69444,0,0,.75],779:[0,.69444,0,0,.5],780:[0,.62847,0,0,.5],824:[.19444,.69444,0,0,0],915:[0,.68333,0,0,.625],916:[0,.68333,0,0,.83334],920:[0,.68333,0,0,.77778],923:[0,.68333,0,0,.69445],926:[0,.68333,0,0,.66667],928:[0,.68333,0,0,.75],931:[0,.68333,0,0,.72222],933:[0,.68333,0,0,.77778],934:[0,.68333,0,0,.72222],936:[0,.68333,0,0,.77778],937:[0,.68333,0,0,.72222],8211:[0,.43056,.02778,0,.5],8212:[0,.43056,.02778,0,1],8216:[0,.69444,0,0,.27778],8217:[0,.69444,0,0,.27778],8220:[0,.69444,0,0,.5],8221:[0,.69444,0,0,.5],8224:[.19444,.69444,0,0,.44445],8225:[.19444,.69444,0,0,.44445],8230:[0,.12,0,0,1015],8242:[0,.55556,0,0,.275],8407:[0,.71444,.15382,0,.5],8463:[0,.68889,0,0,.54028],8465:[0,.69444,0,0,.72222],8467:[0,.69444,0,.11111,.41667],8472:[.19444,.43056,0,.11111,.63646],8476:[0,.69444,0,0,.72222],8501:[0,.69444,0,0,.61111],8592:[-.13313,.36687,0,0,1],8593:[.19444,.69444,0,0,.5],8594:[-.13313,.36687,0,0,1],8595:[.19444,.69444,0,0,.5],8596:[-.13313,.36687,0,0,1],8597:[.25,.75,0,0,.5],8598:[.19444,.69444,0,0,1],8599:[.19444,.69444,0,0,1],8600:[.19444,.69444,0,0,1],8601:[.19444,.69444,0,0,1],8614:[.011,.511,0,0,889],8617:[.011,.511,0,0,1015],8618:[.011,.511,0,0,1015],8636:[-.13313,.36687,0,0,1],8637:[-.13313,.36687,0,0,1],8640:[-.13313,.36687,0,0,1],8641:[-.13313,.36687,0,0,1],8652:[.011,.671,0,0,889],8656:[-.13313,.36687,0,0,1],8657:[.19444,.69444,0,0,.61111],8658:[-.13313,.36687,0,0,1],8659:[.19444,.69444,0,0,.61111],8660:[-.13313,.36687,0,0,1],8661:[.25,.75,0,0,.61111],8704:[0,.69444,0,0,.55556],8706:[0,.69444,.05556,.08334,.5309],8707:[0,.69444,0,0,.55556],8709:[.05556,.75,0,0,.5],8711:[0,.68333,0,0,.83334],8712:[.0391,.5391,0,0,.66667],8715:[.0391,.5391,0,0,.66667],8722:[.08333,.58333,0,0,.77778],8723:[.08333,.58333,0,0,.77778],8725:[.25,.75,0,0,.5],8726:[.25,.75,0,0,.5],8727:[-.03472,.46528,0,0,.5],8728:[-.05555,.44445,0,0,.5],8729:[-.05555,.44445,0,0,.5],8730:[.2,.8,0,0,.83334],8733:[0,.43056,0,0,.77778],8734:[0,.43056,0,0,1],8736:[0,.69224,0,0,.72222],8739:[.25,.75,0,0,.27778],8741:[.25,.75,0,0,.5],8743:[0,.55556,0,0,.66667],8744:[0,.55556,0,0,.66667],8745:[0,.55556,0,0,.66667],8746:[0,.55556,0,0,.66667],8747:[.19444,.69444,.11111,0,.41667],8764:[-.13313,.36687,0,0,.77778],8768:[.19444,.69444,0,0,.27778],8771:[-.03625,.46375,0,0,.77778],8773:[-.022,.589,0,0,667],8776:[-.01688,.48312,0,0,.77778],8781:[-.03625,.46375,0,0,.77778],8784:[-.133,.67,0,0,666],8800:[.215,.716,0,0,666],8801:[-.03625,.46375,0,0,.77778],8804:[.13597,.63597,0,0,.77778],8805:[.13597,.63597,0,0,.77778],8810:[.0391,.5391,0,0,1],8811:[.0391,.5391,0,0,1],8826:[.0391,.5391,0,0,.77778],8827:[.0391,.5391,0,0,.77778],8834:[.0391,.5391,0,0,.77778],8835:[.0391,.5391,0,0,.77778],8838:[.13597,.63597,0,0,.77778],8839:[.13597,.63597,0,0,.77778],8846:[0,.55556,0,0,.66667],8849:[.13597,.63597,0,0,.77778],8850:[.13597,.63597,0,0,.77778],8851:[0,.55556,0,0,.66667],8852:[0,.55556,0,0,.66667],8853:[.08333,.58333,0,0,.77778],8854:[.08333,.58333,0,0,.77778],8855:[.08333,.58333,0,0,.77778],8856:[.08333,.58333,0,0,.77778],8857:[.08333,.58333,0,0,.77778],8866:[0,.69444,0,0,.61111],8867:[0,.69444,0,0,.61111],8868:[0,.69444,0,0,.77778],8869:[0,.69444,0,0,.77778],8872:[.249,.75,0,0,692],8900:[-.05555,.44445,0,0,.5],8901:[-.05555,.44445,0,0,.27778],8902:[-.03472,.46528,0,0,.5],8904:[.005,.505,0,0,847],8942:[.03,.9,0,0,121],8943:[-.19,.31,0,0,1015],8945:[-.1,.82,0,0,1015],8968:[.25,.75,0,0,.44445],8969:[.25,.75,0,0,.44445],8970:[.25,.75,0,0,.44445],8971:[.25,.75,0,0,.44445],8994:[-.14236,.35764,0,0,1],8995:[-.14236,.35764,0,0,1],9136:[.244,.744,0,0,301],9137:[.244,.744,0,0,301],9651:[.19444,.69444,0,0,.88889],9657:[-.03472,.46528,0,0,.5],9661:[.19444,.69444,0,0,.88889],9667:[-.03472,.46528,0,0,.5],9711:[.19444,.69444,0,0,1],9824:[.12963,.69444,0,0,.77778],9825:[.12963,.69444,0,0,.77778],9826:[.12963,.69444,0,0,.77778],9827:[.12963,.69444,0,0,.77778],9837:[0,.75,0,0,.38889],9838:[.19444,.69444,0,0,.38889],9839:[.19444,.69444,0,0,.38889],10216:[.25,.75,0,0,.38889],10217:[.25,.75,0,0,.38889],10222:[.244,.744,0,0,184],10223:[.244,.744,0,0,184],10229:[.011,.511,0,0,1470],10230:[.011,.511,0,0,1469],10231:[.011,.511,0,0,1748],10232:[.024,.525,0,0,1497],10233:[.024,.525,0,0,1526],10234:[.024,.525,0,0,1746],10236:[.011,.511,0,0,1498],10815:[0,.68333,0,0,.75],10927:[.13597,.63597,0,0,.77778],10928:[.13597,.63597,0,0,.77778]},"Math-BoldItalic":{47:[.19444,.69444,0,0,0],65:[0,.68611,0,0,.86944],66:[0,.68611,.04835,0,.8664],67:[0,.68611,.06979,0,.81694],68:[0,.68611,.03194,0,.93812],69:[0,.68611,.05451,0,.81007],70:[0,.68611,.15972,0,.68889],71:[0,.68611,0,0,.88673],72:[0,.68611,.08229,0,.98229],73:[0,.68611,.07778,0,.51111],74:[0,.68611,.10069,0,.63125],75:[0,.68611,.06979,0,.97118],76:[0,.68611,0,0,.75555],77:[0,.68611,.11424,0,1.14201],78:[0,.68611,.11424,0,.95034],79:[0,.68611,.03194,0,.83666],80:[0,.68611,.15972,0,.72309],81:[.19444,.68611,0,0,.86861],82:[0,.68611,.00421,0,.87235],83:[0,.68611,.05382,0,.69271],84:[0,.68611,.15972,0,.63663],85:[0,.68611,.11424,0,.80027],86:[0,.68611,.25555,0,.67778],87:[0,.68611,.15972,0,1.09305],88:[0,.68611,.07778,0,.94722],89:[0,.68611,.25555,0,.67458],90:[0,.68611,.06979,0,.77257],97:[0,.44444,0,0,.63287],98:[0,.69444,0,0,.52083],99:[0,.44444,0,0,.51342],100:[0,.69444,0,0,.60972],101:[0,.44444,0,0,.55361],102:[.19444,.69444,.11042,0,.56806],103:[.19444,.44444,.03704,0,.5449],104:[0,.69444,0,0,.66759],105:[0,.69326,0,0,.4048],106:[.19444,.69326,.0622,0,.47083],107:[0,.69444,.01852,0,.6037],108:[0,.69444,.0088,0,.34815],109:[0,.44444,0,0,1.0324],110:[0,.44444,0,0,.71296],111:[0,.44444,0,0,.58472],112:[.19444,.44444,0,0,.60092],113:[.19444,.44444,.03704,0,.54213],114:[0,.44444,.03194,0,.5287],115:[0,.44444,0,0,.53125],116:[0,.63492,0,0,.41528],117:[0,.44444,0,0,.68102],118:[0,.44444,.03704,0,.56666],119:[0,.44444,.02778,0,.83148],120:[0,.44444,0,0,.65903],121:[.19444,.44444,.03704,0,.59028],122:[0,.44444,.04213,0,.55509],915:[0,.68611,.15972,0,.65694],916:[0,.68611,0,0,.95833],920:[0,.68611,.03194,0,.86722],923:[0,.68611,0,0,.80555],926:[0,.68611,.07458,0,.84125],928:[0,.68611,.08229,0,.98229],931:[0,.68611,.05451,0,.88507],933:[0,.68611,.15972,0,.67083],934:[0,.68611,0,0,.76666],936:[0,.68611,.11653,0,.71402],937:[0,.68611,.04835,0,.8789],945:[0,.44444,0,0,.76064],946:[.19444,.69444,.03403,0,.65972],947:[.19444,.44444,.06389,0,.59003],948:[0,.69444,.03819,0,.52222],949:[0,.44444,0,0,.52882],950:[.19444,.69444,.06215,0,.50833],951:[.19444,.44444,.03704,0,.6],952:[0,.69444,.03194,0,.5618],953:[0,.44444,0,0,.41204],954:[0,.44444,0,0,.66759],955:[0,.69444,0,0,.67083],956:[.19444,.44444,0,0,.70787],957:[0,.44444,.06898,0,.57685],958:[.19444,.69444,.03021,0,.50833],959:[0,.44444,0,0,.58472],960:[0,.44444,.03704,0,.68241],961:[.19444,.44444,0,0,.6118],962:[.09722,.44444,.07917,0,.42361],963:[0,.44444,.03704,0,.68588],964:[0,.44444,.13472,0,.52083],965:[0,.44444,.03704,0,.63055],966:[.19444,.44444,0,0,.74722],967:[.19444,.44444,0,0,.71805],968:[.19444,.69444,.03704,0,.75833],969:[0,.44444,.03704,0,.71782],977:[0,.69444,0,0,.69155],981:[.19444,.69444,0,0,.7125],982:[0,.44444,.03194,0,.975],1009:[.19444,.44444,0,0,.6118],1013:[0,.44444,0,0,.48333]},"Math-Italic":{47:[.19444,.69444,0,0,0],65:[0,.68333,0,.13889,.75],66:[0,.68333,.05017,.08334,.75851],67:[0,.68333,.07153,.08334,.71472],68:[0,.68333,.02778,.05556,.82792],69:[0,.68333,.05764,.08334,.7382],70:[0,.68333,.13889,.08334,.64306],71:[0,.68333,0,.08334,.78625],72:[0,.68333,.08125,.05556,.83125],73:[0,.68333,.07847,.11111,.43958],74:[0,.68333,.09618,.16667,.55451],75:[0,.68333,.07153,.05556,.84931],76:[0,.68333,0,.02778,.68056],77:[0,.68333,.10903,.08334,.97014],78:[0,.68333,.10903,.08334,.80347],79:[0,.68333,.02778,.08334,.76278],80:[0,.68333,.13889,.08334,.64201],81:[.19444,.68333,0,.08334,.79056],82:[0,.68333,.00773,.08334,.75929],83:[0,.68333,.05764,.08334,.6132],84:[0,.68333,.13889,.08334,.58438],85:[0,.68333,.10903,.02778,.68278],86:[0,.68333,.22222,0,.58333],87:[0,.68333,.13889,0,.94445],88:[0,.68333,.07847,.08334,.82847],89:[0,.68333,.22222,0,.58056],90:[0,.68333,.07153,.08334,.68264],97:[0,.43056,0,0,.52859],98:[0,.69444,0,0,.42917],99:[0,.43056,0,.05556,.43276],100:[0,.69444,0,.16667,.52049],101:[0,.43056,0,.05556,.46563],102:[.19444,.69444,.10764,.16667,.48959],103:[.19444,.43056,.03588,.02778,.47697],104:[0,.69444,0,0,.57616],105:[0,.65952,0,0,.34451],106:[.19444,.65952,.05724,0,.41181],107:[0,.69444,.03148,0,.5206],108:[0,.69444,.01968,.08334,.29838],109:[0,.43056,0,0,.87801],110:[0,.43056,0,0,.60023],111:[0,.43056,0,.05556,.48472],112:[.19444,.43056,0,.08334,.50313],113:[.19444,.43056,.03588,.08334,.44641],114:[0,.43056,.02778,.05556,.45116],115:[0,.43056,0,.05556,.46875],116:[0,.61508,0,.08334,.36111],117:[0,.43056,0,.02778,.57246],118:[0,.43056,.03588,.02778,.48472],119:[0,.43056,.02691,.08334,.71592],120:[0,.43056,0,.02778,.57153],121:[.19444,.43056,.03588,.05556,.49028],122:[0,.43056,.04398,.05556,.46505],915:[0,.68333,.13889,.08334,.61528],916:[0,.68333,0,.16667,.83334],920:[0,.68333,.02778,.08334,.76278],923:[0,.68333,0,.16667,.69445],926:[0,.68333,.07569,.08334,.74236],928:[0,.68333,.08125,.05556,.83125],931:[0,.68333,.05764,.08334,.77986],933:[0,.68333,.13889,.05556,.58333],934:[0,.68333,0,.08334,.66667],936:[0,.68333,.11,.05556,.61222],937:[0,.68333,.05017,.08334,.7724],945:[0,.43056,.0037,.02778,.6397],946:[.19444,.69444,.05278,.08334,.56563],947:[.19444,.43056,.05556,0,.51773],948:[0,.69444,.03785,.05556,.44444],949:[0,.43056,0,.08334,.46632],950:[.19444,.69444,.07378,.08334,.4375],951:[.19444,.43056,.03588,.05556,.49653],952:[0,.69444,.02778,.08334,.46944],953:[0,.43056,0,.05556,.35394],954:[0,.43056,0,0,.57616],955:[0,.69444,0,0,.58334],956:[.19444,.43056,0,.02778,.60255],957:[0,.43056,.06366,.02778,.49398],958:[.19444,.69444,.04601,.11111,.4375],959:[0,.43056,0,.05556,.48472],960:[0,.43056,.03588,0,.57003],961:[.19444,.43056,0,.08334,.51702],962:[.09722,.43056,.07986,.08334,.36285],963:[0,.43056,.03588,0,.57141],964:[0,.43056,.1132,.02778,.43715],965:[0,.43056,.03588,.02778,.54028],966:[.19444,.43056,0,.08334,.65417],967:[.19444,.43056,0,.05556,.62569],968:[.19444,.69444,.03588,.11111,.65139],969:[0,.43056,.03588,0,.62245],977:[0,.69444,0,.08334,.59144],981:[.19444,.69444,0,.08334,.59583],982:[0,.43056,.02778,0,.82813],1009:[.19444,.43056,0,.08334,.51702],1013:[0,.43056,0,.05556,.4059]},"Math-Regular":{65:[0,.68333,0,.13889,.75],66:[0,.68333,.05017,.08334,.75851],67:[0,.68333,.07153,.08334,.71472],68:[0,.68333,.02778,.05556,.82792],69:[0,.68333,.05764,.08334,.7382],70:[0,.68333,.13889,.08334,.64306],71:[0,.68333,0,.08334,.78625],72:[0,.68333,.08125,.05556,.83125],73:[0,.68333,.07847,.11111,.43958],74:[0,.68333,.09618,.16667,.55451],75:[0,.68333,.07153,.05556,.84931],76:[0,.68333,0,.02778,.68056],77:[0,.68333,.10903,.08334,.97014],78:[0,.68333,.10903,.08334,.80347],79:[0,.68333,.02778,.08334,.76278],80:[0,.68333,.13889,.08334,.64201],81:[.19444,.68333,0,.08334,.79056],82:[0,.68333,.00773,.08334,.75929],83:[0,.68333,.05764,.08334,.6132],84:[0,.68333,.13889,.08334,.58438],85:[0,.68333,.10903,.02778,.68278],86:[0,.68333,.22222,0,.58333],87:[0,.68333,.13889,0,.94445],88:[0,.68333,.07847,.08334,.82847],89:[0,.68333,.22222,0,.58056],90:[0,.68333,.07153,.08334,.68264],97:[0,.43056,0,0,.52859],98:[0,.69444,0,0,.42917],99:[0,.43056,0,.05556,.43276],100:[0,.69444,0,.16667,.52049],101:[0,.43056,0,.05556,.46563],102:[.19444,.69444,.10764,.16667,.48959],103:[.19444,.43056,.03588,.02778,.47697],104:[0,.69444,0,0,.57616],105:[0,.65952,0,0,.34451],106:[.19444,.65952,.05724,0,.41181],107:[0,.69444,.03148,0,.5206],108:[0,.69444,.01968,.08334,.29838],109:[0,.43056,0,0,.87801],110:[0,.43056,0,0,.60023],111:[0,.43056,0,.05556,.48472],112:[.19444,.43056,0,.08334,.50313],113:[.19444,.43056,.03588,.08334,.44641],114:[0,.43056,.02778,.05556,.45116],115:[0,.43056,0,.05556,.46875],116:[0,.61508,0,.08334,.36111],117:[0,.43056,0,.02778,.57246],118:[0,.43056,.03588,.02778,.48472],119:[0,.43056,.02691,.08334,.71592],120:[0,.43056,0,.02778,.57153],121:[.19444,.43056,.03588,.05556,.49028],122:[0,.43056,.04398,.05556,.46505],915:[0,.68333,.13889,.08334,.61528],916:[0,.68333,0,.16667,.83334],920:[0,.68333,.02778,.08334,.76278],923:[0,.68333,0,.16667,.69445],926:[0,.68333,.07569,.08334,.74236],928:[0,.68333,.08125,.05556,.83125],931:[0,.68333,.05764,.08334,.77986],933:[0,.68333,.13889,.05556,.58333],934:[0,.68333,0,.08334,.66667],936:[0,.68333,.11,.05556,.61222],937:[0,.68333,.05017,.08334,.7724],945:[0,.43056,.0037,.02778,.6397],946:[.19444,.69444,.05278,.08334,.56563],947:[.19444,.43056,.05556,0,.51773],948:[0,.69444,.03785,.05556,.44444],949:[0,.43056,0,.08334,.46632],950:[.19444,.69444,.07378,.08334,.4375],951:[.19444,.43056,.03588,.05556,.49653],952:[0,.69444,.02778,.08334,.46944],953:[0,.43056,0,.05556,.35394],954:[0,.43056,0,0,.57616],955:[0,.69444,0,0,.58334],956:[.19444,.43056,0,.02778,.60255],957:[0,.43056,.06366,.02778,.49398],958:[.19444,.69444,.04601,.11111,.4375],959:[0,.43056,0,.05556,.48472],960:[0,.43056,.03588,0,.57003],961:[.19444,.43056,0,.08334,.51702],962:[.09722,.43056,.07986,.08334,.36285],963:[0,.43056,.03588,0,.57141],964:[0,.43056,.1132,.02778,.43715],965:[0,.43056,.03588,.02778,.54028],966:[.19444,.43056,0,.08334,.65417],967:[.19444,.43056,0,.05556,.62569],968:[.19444,.69444,.03588,.11111,.65139],969:[0,.43056,.03588,0,.62245],977:[0,.69444,0,.08334,.59144],981:[.19444,.69444,0,.08334,.59583],982:[0,.43056,.02778,0,.82813],1009:[.19444,.43056,0,.08334,.51702],1013:[0,.43056,0,.05556,.4059]},"SansSerif-Bold":{33:[0,.69444,0,0,.36667],34:[0,.69444,0,0,.55834],35:[.19444,.69444,0,0,.91667],36:[.05556,.75,0,0,.55],37:[.05556,.75,0,0,1.02912],38:[0,.69444,0,0,.83056],39:[0,.69444,0,0,.30556],40:[.25,.75,0,0,.42778],41:[.25,.75,0,0,.42778],42:[0,.75,0,0,.55],43:[.11667,.61667,0,0,.85556],44:[.10556,.13056,0,0,.30556],45:[0,.45833,0,0,.36667],46:[0,.13056,0,0,.30556],47:[.25,.75,0,0,.55],48:[0,.69444,0,0,.55],49:[0,.69444,0,0,.55],50:[0,.69444,0,0,.55],51:[0,.69444,0,0,.55],52:[0,.69444,0,0,.55],53:[0,.69444,0,0,.55],54:[0,.69444,0,0,.55],55:[0,.69444,0,0,.55],56:[0,.69444,0,0,.55],57:[0,.69444,0,0,.55],58:[0,.45833,0,0,.30556],59:[.10556,.45833,0,0,.30556],61:[-.09375,.40625,0,0,.85556],63:[0,.69444,0,0,.51945],64:[0,.69444,0,0,.73334],65:[0,.69444,0,0,.73334],66:[0,.69444,0,0,.73334],67:[0,.69444,0,0,.70278],68:[0,.69444,0,0,.79445],69:[0,.69444,0,0,.64167],70:[0,.69444,0,0,.61111],71:[0,.69444,0,0,.73334],72:[0,.69444,0,0,.79445],73:[0,.69444,0,0,.33056],74:[0,.69444,0,0,.51945],75:[0,.69444,0,0,.76389],76:[0,.69444,0,0,.58056],77:[0,.69444,0,0,.97778],78:[0,.69444,0,0,.79445],79:[0,.69444,0,0,.79445],80:[0,.69444,0,0,.70278],81:[.10556,.69444,0,0,.79445],82:[0,.69444,0,0,.70278],83:[0,.69444,0,0,.61111],84:[0,.69444,0,0,.73334],85:[0,.69444,0,0,.76389],86:[0,.69444,.01528,0,.73334],87:[0,.69444,.01528,0,1.03889],88:[0,.69444,0,0,.73334],89:[0,.69444,.0275,0,.73334],90:[0,.69444,0,0,.67223],91:[.25,.75,0,0,.34306],93:[.25,.75,0,0,.34306],94:[0,.69444,0,0,.55],95:[.35,.10833,.03056,0,.55],97:[0,.45833,0,0,.525],98:[0,.69444,0,0,.56111],99:[0,.45833,0,0,.48889],100:[0,.69444,0,0,.56111],101:[0,.45833,0,0,.51111],102:[0,.69444,.07639,0,.33611],103:[.19444,.45833,.01528,0,.55],104:[0,.69444,0,0,.56111],105:[0,.69444,0,0,.25556],106:[.19444,.69444,0,0,.28611],107:[0,.69444,0,0,.53056],108:[0,.69444,0,0,.25556],109:[0,.45833,0,0,.86667],110:[0,.45833,0,0,.56111],111:[0,.45833,0,0,.55],112:[.19444,.45833,0,0,.56111],113:[.19444,.45833,0,0,.56111],114:[0,.45833,.01528,0,.37222],115:[0,.45833,0,0,.42167],116:[0,.58929,0,0,.40417],117:[0,.45833,0,0,.56111],118:[0,.45833,.01528,0,.5],119:[0,.45833,.01528,0,.74445],120:[0,.45833,0,0,.5],121:[.19444,.45833,.01528,0,.5],122:[0,.45833,0,0,.47639],126:[.35,.34444,0,0,.55],305:[0,.45833,0,0,.25556],567:[.19444,.45833,0,0,.28611],768:[0,.69444,0,0,.55],769:[0,.69444,0,0,.55],770:[0,.69444,0,0,.55],771:[0,.69444,0,0,.55],772:[0,.63778,0,0,.55],774:[0,.69444,0,0,.55],775:[0,.69444,0,0,.30556],776:[0,.69444,0,0,.55],778:[0,.69444,0,0,.73334],779:[0,.69444,0,0,.55],780:[0,.63542,0,0,.55],915:[0,.69444,0,0,.58056],916:[0,.69444,0,0,.91667],920:[0,.69444,0,0,.85556],923:[0,.69444,0,0,.67223],926:[0,.69444,0,0,.73334],928:[0,.69444,0,0,.79445],931:[0,.69444,0,0,.79445],933:[0,.69444,0,0,.85556],934:[0,.69444,0,0,.79445],936:[0,.69444,0,0,.85556],937:[0,.69444,0,0,.79445],8211:[0,.45833,.03056,0,.55],8212:[0,.45833,.03056,0,1.10001],8216:[0,.69444,0,0,.30556],8217:[0,.69444,0,0,.30556],8220:[0,.69444,0,0,.55834],8221:[0,.69444,0,0,.55834]},"SansSerif-Italic":{33:[0,.69444,.05733,0,.31945],34:[0,.69444,.00316,0,.5],35:[.19444,.69444,.05087,0,.83334],36:[.05556,.75,.11156,0,.5],37:[.05556,.75,.03126,0,.83334],38:[0,.69444,.03058,0,.75834],39:[0,.69444,.07816,0,.27778],40:[.25,.75,.13164,0,.38889],41:[.25,.75,.02536,0,.38889],42:[0,.75,.11775,0,.5],43:[.08333,.58333,.02536,0,.77778],44:[.125,.08333,0,0,.27778],45:[0,.44444,.01946,0,.33333],46:[0,.08333,0,0,.27778],47:[.25,.75,.13164,0,.5],48:[0,.65556,.11156,0,.5],49:[0,.65556,.11156,0,.5],50:[0,.65556,.11156,0,.5],51:[0,.65556,.11156,0,.5],52:[0,.65556,.11156,0,.5],53:[0,.65556,.11156,0,.5],54:[0,.65556,.11156,0,.5],55:[0,.65556,.11156,0,.5],56:[0,.65556,.11156,0,.5],57:[0,.65556,.11156,0,.5],58:[0,.44444,.02502,0,.27778],59:[.125,.44444,.02502,0,.27778],61:[-.13,.37,.05087,0,.77778],63:[0,.69444,.11809,0,.47222],64:[0,.69444,.07555,0,.66667],65:[0,.69444,0,0,.66667],66:[0,.69444,.08293,0,.66667],67:[0,.69444,.11983,0,.63889],68:[0,.69444,.07555,0,.72223],69:[0,.69444,.11983,0,.59722],70:[0,.69444,.13372,0,.56945],71:[0,.69444,.11983,0,.66667],72:[0,.69444,.08094,0,.70834],73:[0,.69444,.13372,0,.27778],74:[0,.69444,.08094,0,.47222],75:[0,.69444,.11983,0,.69445],76:[0,.69444,0,0,.54167],77:[0,.69444,.08094,0,.875],78:[0,.69444,.08094,0,.70834],79:[0,.69444,.07555,0,.73611],80:[0,.69444,.08293,0,.63889],81:[.125,.69444,.07555,0,.73611],82:[0,.69444,.08293,0,.64584],83:[0,.69444,.09205,0,.55556],84:[0,.69444,.13372,0,.68056],85:[0,.69444,.08094,0,.6875],86:[0,.69444,.1615,0,.66667],87:[0,.69444,.1615,0,.94445],88:[0,.69444,.13372,0,.66667],89:[0,.69444,.17261,0,.66667],90:[0,.69444,.11983,0,.61111],91:[.25,.75,.15942,0,.28889],93:[.25,.75,.08719,0,.28889],94:[0,.69444,.0799,0,.5],95:[.35,.09444,.08616,0,.5],97:[0,.44444,.00981,0,.48056],98:[0,.69444,.03057,0,.51667],99:[0,.44444,.08336,0,.44445],100:[0,.69444,.09483,0,.51667],101:[0,.44444,.06778,0,.44445],102:[0,.69444,.21705,0,.30556],103:[.19444,.44444,.10836,0,.5],104:[0,.69444,.01778,0,.51667],105:[0,.67937,.09718,0,.23889],106:[.19444,.67937,.09162,0,.26667],107:[0,.69444,.08336,0,.48889],108:[0,.69444,.09483,0,.23889],109:[0,.44444,.01778,0,.79445],110:[0,.44444,.01778,0,.51667],111:[0,.44444,.06613,0,.5],112:[.19444,.44444,.0389,0,.51667],113:[.19444,.44444,.04169,0,.51667],114:[0,.44444,.10836,0,.34167],115:[0,.44444,.0778,0,.38333],116:[0,.57143,.07225,0,.36111],117:[0,.44444,.04169,0,.51667],118:[0,.44444,.10836,0,.46111],119:[0,.44444,.10836,0,.68334],120:[0,.44444,.09169,0,.46111],121:[.19444,.44444,.10836,0,.46111],122:[0,.44444,.08752,0,.43472],126:[.35,.32659,.08826,0,.5],305:[0,.44444,.04169,0,.23889],567:[.19444,.44444,.04169,0,.26667],768:[0,.69444,0,0,.5],769:[0,.69444,.09205,0,.5],770:[0,.69444,.0799,0,.5],771:[0,.67659,.08826,0,.5],772:[0,.60889,.08776,0,.5],774:[0,.69444,.09483,0,.5],775:[0,.67937,.07774,0,.27778],776:[0,.67937,.06385,0,.5],778:[0,.69444,0,0,.73752],779:[0,.69444,.09205,0,.5],780:[0,.63194,.08432,0,.5],915:[0,.69444,.13372,0,.54167],916:[0,.69444,0,0,.83334],920:[0,.69444,.07555,0,.77778],923:[0,.69444,0,0,.61111],926:[0,.69444,.12816,0,.66667],928:[0,.69444,.08094,0,.70834],931:[0,.69444,.11983,0,.72222],933:[0,.69444,.09031,0,.77778],934:[0,.69444,.04603,0,.72222],936:[0,.69444,.09031,0,.77778],937:[0,.69444,.08293,0,.72222],8211:[0,.44444,.08616,0,.5],8212:[0,.44444,.08616,0,1],8216:[0,.69444,.07816,0,.27778],8217:[0,.69444,.07816,0,.27778],8220:[0,.69444,.14205,0,.5],8221:[0,.69444,.00316,0,.5]},"SansSerif-Regular":{33:[0,.69444,0,0,.31945],34:[0,.69444,0,0,.5],35:[.19444,.69444,0,0,.83334],36:[.05556,.75,0,0,.5],37:[.05556,.75,0,0,.83334],38:[0,.69444,0,0,.75834],39:[0,.69444,0,0,.27778],40:[.25,.75,0,0,.38889],41:[.25,.75,0,0,.38889],42:[0,.75,0,0,.5],43:[.08333,.58333,0,0,.77778],44:[.125,.08333,0,0,.27778],45:[0,.44444,0,0,.33333],46:[0,.08333,0,0,.27778],47:[.25,.75,0,0,.5],48:[0,.65556,0,0,.5],49:[0,.65556,0,0,.5],50:[0,.65556,0,0,.5],51:[0,.65556,0,0,.5],52:[0,.65556,0,0,.5],53:[0,.65556,0,0,.5],54:[0,.65556,0,0,.5],55:[0,.65556,0,0,.5],56:[0,.65556,0,0,.5],57:[0,.65556,0,0,.5],58:[0,.44444,0,0,.27778],59:[.125,.44444,0,0,.27778],61:[-.13,.37,0,0,.77778],63:[0,.69444,0,0,.47222],64:[0,.69444,0,0,.66667],65:[0,.69444,0,0,.66667],66:[0,.69444,0,0,.66667],67:[0,.69444,0,0,.63889],68:[0,.69444,0,0,.72223],69:[0,.69444,0,0,.59722],70:[0,.69444,0,0,.56945],71:[0,.69444,0,0,.66667],72:[0,.69444,0,0,.70834],73:[0,.69444,0,0,.27778],74:[0,.69444,0,0,.47222],75:[0,.69444,0,0,.69445],76:[0,.69444,0,0,.54167],77:[0,.69444,0,0,.875],78:[0,.69444,0,0,.70834],79:[0,.69444,0,0,.73611],80:[0,.69444,0,0,.63889],81:[.125,.69444,0,0,.73611],82:[0,.69444,0,0,.64584],83:[0,.69444,0,0,.55556],84:[0,.69444,0,0,.68056],85:[0,.69444,0,0,.6875],86:[0,.69444,.01389,0,.66667],87:[0,.69444,.01389,0,.94445],88:[0,.69444,0,0,.66667],89:[0,.69444,.025,0,.66667],90:[0,.69444,0,0,.61111],91:[.25,.75,0,0,.28889],93:[.25,.75,0,0,.28889],94:[0,.69444,0,0,.5],95:[.35,.09444,.02778,0,.5],97:[0,.44444,0,0,.48056],98:[0,.69444,0,0,.51667],99:[0,.44444,0,0,.44445],100:[0,.69444,0,0,.51667],101:[0,.44444,0,0,.44445],102:[0,.69444,.06944,0,.30556],103:[.19444,.44444,.01389,0,.5],104:[0,.69444,0,0,.51667],105:[0,.67937,0,0,.23889],106:[.19444,.67937,0,0,.26667],107:[0,.69444,0,0,.48889],108:[0,.69444,0,0,.23889],109:[0,.44444,0,0,.79445],110:[0,.44444,0,0,.51667],111:[0,.44444,0,0,.5],112:[.19444,.44444,0,0,.51667],113:[.19444,.44444,0,0,.51667],114:[0,.44444,.01389,0,.34167],115:[0,.44444,0,0,.38333],116:[0,.57143,0,0,.36111],117:[0,.44444,0,0,.51667],118:[0,.44444,.01389,0,.46111],119:[0,.44444,.01389,0,.68334],120:[0,.44444,0,0,.46111],121:[.19444,.44444,.01389,0,.46111],122:[0,.44444,0,0,.43472],126:[.35,.32659,0,0,.5],305:[0,.44444,0,0,.23889],567:[.19444,.44444,0,0,.26667],768:[0,.69444,0,0,.5],769:[0,.69444,0,0,.5],770:[0,.69444,0,0,.5],771:[0,.67659,0,0,.5],772:[0,.60889,0,0,.5],774:[0,.69444,0,0,.5],775:[0,.67937,0,0,.27778],776:[0,.67937,0,0,.5],778:[0,.69444,0,0,.66667],779:[0,.69444,0,0,.5],780:[0,.63194,0,0,.5],915:[0,.69444,0,0,.54167],916:[0,.69444,0,0,.83334],920:[0,.69444,0,0,.77778],923:[0,.69444,0,0,.61111],926:[0,.69444,0,0,.66667],928:[0,.69444,0,0,.70834],931:[0,.69444,0,0,.72222],933:[0,.69444,0,0,.77778],934:[0,.69444,0,0,.72222],936:[0,.69444,0,0,.77778],937:[0,.69444,0,0,.72222],8211:[0,.44444,.02778,0,.5],8212:[0,.44444,.02778,0,1],8216:[0,.69444,0,0,.27778],8217:[0,.69444,0,0,.27778],8220:[0,.69444,0,0,.5],8221:[0,.69444,0,0,.5]},"Script-Regular":{65:[0,.7,.22925,0,.80253],66:[0,.7,.04087,0,.90757],67:[0,.7,.1689,0,.66619],68:[0,.7,.09371,0,.77443],69:[0,.7,.18583,0,.56162],70:[0,.7,.13634,0,.89544],71:[0,.7,.17322,0,.60961],72:[0,.7,.29694,0,.96919],73:[0,.7,.19189,0,.80907],74:[.27778,.7,.19189,0,1.05159],75:[0,.7,.31259,0,.91364],76:[0,.7,.19189,0,.87373],77:[0,.7,.15981,0,1.08031],78:[0,.7,.3525,0,.9015],79:[0,.7,.08078,0,.73787],80:[0,.7,.08078,0,1.01262],81:[0,.7,.03305,0,.88282],82:[0,.7,.06259,0,.85],83:[0,.7,.19189,0,.86767],84:[0,.7,.29087,0,.74697],85:[0,.7,.25815,0,.79996],86:[0,.7,.27523,0,.62204],87:[0,.7,.27523,0,.80532],88:[0,.7,.26006,0,.94445],89:[0,.7,.2939,0,.70961],90:[0,.7,.24037,0,.8212]},"Size1-Regular":{40:[.35001,.85,0,0,.45834],41:[.35001,.85,0,0,.45834],47:[.35001,.85,0,0,.57778],91:[.35001,.85,0,0,.41667],92:[.35001,.85,0,0,.57778],93:[.35001,.85,0,0,.41667],123:[.35001,.85,0,0,.58334],125:[.35001,.85,0,0,.58334],710:[0,.72222,0,0,.55556],732:[0,.72222,0,0,.55556],770:[0,.72222,0,0,.55556],771:[0,.72222,0,0,.55556],8214:[-99e-5,.601,0,0,.77778],8593:[1e-5,.6,0,0,.66667],8595:[1e-5,.6,0,0,.66667],8657:[1e-5,.6,0,0,.77778],8659:[1e-5,.6,0,0,.77778],8719:[.25001,.75,0,0,.94445],8720:[.25001,.75,0,0,.94445],8721:[.25001,.75,0,0,1.05556],8730:[.35001,.85,0,0,1],8739:[-.00599,.606,0,0,.33333],8741:[-.00599,.606,0,0,.55556],8747:[.30612,.805,.19445,0,.47222],8748:[.306,.805,.19445,0,.47222],8749:[.306,.805,.19445,0,.47222],8750:[.30612,.805,.19445,0,.47222],8896:[.25001,.75,0,0,.83334],8897:[.25001,.75,0,0,.83334],8898:[.25001,.75,0,0,.83334],8899:[.25001,.75,0,0,.83334],8968:[.35001,.85,0,0,.47222],8969:[.35001,.85,0,0,.47222],8970:[.35001,.85,0,0,.47222],8971:[.35001,.85,0,0,.47222],9168:[-99e-5,.601,0,0,.66667],10216:[.35001,.85,0,0,.47222],10217:[.35001,.85,0,0,.47222],10752:[.25001,.75,0,0,1.11111],10753:[.25001,.75,0,0,1.11111],10754:[.25001,.75,0,0,1.11111],10756:[.25001,.75,0,0,.83334],10758:[.25001,.75,0,0,.83334]},"Size2-Regular":{40:[.65002,1.15,0,0,.59722],41:[.65002,1.15,0,0,.59722],47:[.65002,1.15,0,0,.81111],91:[.65002,1.15,0,0,.47222],92:[.65002,1.15,0,0,.81111],93:[.65002,1.15,0,0,.47222],123:[.65002,1.15,0,0,.66667],125:[.65002,1.15,0,0,.66667],710:[0,.75,0,0,1],732:[0,.75,0,0,1],770:[0,.75,0,0,1],771:[0,.75,0,0,1],8719:[.55001,1.05,0,0,1.27778],8720:[.55001,1.05,0,0,1.27778],8721:[.55001,1.05,0,0,1.44445],8730:[.65002,1.15,0,0,1],8747:[.86225,1.36,.44445,0,.55556],8748:[.862,1.36,.44445,0,.55556],8749:[.862,1.36,.44445,0,.55556],8750:[.86225,1.36,.44445,0,.55556],8896:[.55001,1.05,0,0,1.11111],8897:[.55001,1.05,0,0,1.11111],8898:[.55001,1.05,0,0,1.11111],8899:[.55001,1.05,0,0,1.11111],8968:[.65002,1.15,0,0,.52778],8969:[.65002,1.15,0,0,.52778],8970:[.65002,1.15,0,0,.52778],8971:[.65002,1.15,0,0,.52778],10216:[.65002,1.15,0,0,.61111],10217:[.65002,1.15,0,0,.61111],10752:[.55001,1.05,0,0,1.51112],10753:[.55001,1.05,0,0,1.51112],10754:[.55001,1.05,0,0,1.51112],10756:[.55001,1.05,0,0,1.11111],10758:[.55001,1.05,0,0,1.11111]},"Size3-Regular":{40:[.95003,1.45,0,0,.73611],41:[.95003,1.45,0,0,.73611],47:[.95003,1.45,0,0,1.04445],91:[.95003,1.45,0,0,.52778],92:[.95003,1.45,0,0,1.04445],93:[.95003,1.45,0,0,.52778],123:[.95003,1.45,0,0,.75],125:[.95003,1.45,0,0,.75],710:[0,.75,0,0,1.44445],732:[0,.75,0,0,1.44445],770:[0,.75,0,0,1.44445],771:[0,.75,0,0,1.44445],8730:[.95003,1.45,0,0,1],8968:[.95003,1.45,0,0,.58334],8969:[.95003,1.45,0,0,.58334],8970:[.95003,1.45,0,0,.58334],8971:[.95003,1.45,0,0,.58334],10216:[.95003,1.45,0,0,.75],10217:[.95003,1.45,0,0,.75]},"Size4-Regular":{40:[1.25003,1.75,0,0,.79167],41:[1.25003,1.75,0,0,.79167],47:[1.25003,1.75,0,0,1.27778],91:[1.25003,1.75,0,0,.58334],92:[1.25003,1.75,0,0,1.27778],93:[1.25003,1.75,0,0,.58334],123:[1.25003,1.75,0,0,.80556],125:[1.25003,1.75,0,0,.80556],710:[0,.825,0,0,1.8889],732:[0,.825,0,0,1.8889],770:[0,.825,0,0,1.8889],771:[0,.825,0,0,1.8889],8730:[1.25003,1.75,0,0,1],8968:[1.25003,1.75,0,0,.63889],8969:[1.25003,1.75,0,0,.63889],8970:[1.25003,1.75,0,0,.63889],8971:[1.25003,1.75,0,0,.63889],9115:[.64502,1.155,0,0,.875],9116:[1e-5,.6,0,0,.875],9117:[.64502,1.155,0,0,.875],9118:[.64502,1.155,0,0,.875],9119:[1e-5,.6,0,0,.875],9120:[.64502,1.155,0,0,.875],9121:[.64502,1.155,0,0,.66667],9122:[-99e-5,.601,0,0,.66667],9123:[.64502,1.155,0,0,.66667],9124:[.64502,1.155,0,0,.66667],9125:[-99e-5,.601,0,0,.66667],9126:[.64502,1.155,0,0,.66667],9127:[1e-5,.9,0,0,.88889],9128:[.65002,1.15,0,0,.88889],9129:[.90001,0,0,0,.88889],9130:[0,.3,0,0,.88889],9131:[1e-5,.9,0,0,.88889],9132:[.65002,1.15,0,0,.88889],9133:[.90001,0,0,0,.88889],9143:[.88502,.915,0,0,1.05556],10216:[1.25003,1.75,0,0,.80556],10217:[1.25003,1.75,0,0,.80556],57344:[-.00499,.605,0,0,1.05556],57345:[-.00499,.605,0,0,1.05556],57680:[0,.12,0,0,.45],57681:[0,.12,0,0,.45],57682:[0,.12,0,0,.45],57683:[0,.12,0,0,.45]},"Typewriter-Regular":{33:[0,.61111,0,0,.525],34:[0,.61111,0,0,.525],35:[0,.61111,0,0,.525],36:[.08333,.69444,0,0,.525],37:[.08333,.69444,0,0,.525],38:[0,.61111,0,0,.525],39:[0,.61111,0,0,.525],40:[.08333,.69444,0,0,.525],41:[.08333,.69444,0,0,.525],42:[0,.52083,0,0,.525],43:[-.08056,.53055,0,0,.525],44:[.13889,.125,0,0,.525],45:[-.08056,.53055,0,0,.525],46:[0,.125,0,0,.525],47:[.08333,.69444,0,0,.525],48:[0,.61111,0,0,.525],49:[0,.61111,0,0,.525],50:[0,.61111,0,0,.525],51:[0,.61111,0,0,.525],52:[0,.61111,0,0,.525],53:[0,.61111,0,0,.525],54:[0,.61111,0,0,.525],55:[0,.61111,0,0,.525],56:[0,.61111,0,0,.525],57:[0,.61111,0,0,.525],58:[0,.43056,0,0,.525],59:[.13889,.43056,0,0,.525],60:[-.05556,.55556,0,0,.525],61:[-.19549,.41562,0,0,.525],62:[-.05556,.55556,0,0,.525],63:[0,.61111,0,0,.525],64:[0,.61111,0,0,.525],65:[0,.61111,0,0,.525],66:[0,.61111,0,0,.525],67:[0,.61111,0,0,.525],68:[0,.61111,0,0,.525],69:[0,.61111,0,0,.525],70:[0,.61111,0,0,.525],71:[0,.61111,0,0,.525],72:[0,.61111,0,0,.525],73:[0,.61111,0,0,.525],74:[0,.61111,0,0,.525],75:[0,.61111,0,0,.525],76:[0,.61111,0,0,.525],77:[0,.61111,0,0,.525],78:[0,.61111,0,0,.525],79:[0,.61111,0,0,.525],80:[0,.61111,0,0,.525],81:[.13889,.61111,0,0,.525],82:[0,.61111,0,0,.525],83:[0,.61111,0,0,.525],84:[0,.61111,0,0,.525],85:[0,.61111,0,0,.525],86:[0,.61111,0,0,.525],87:[0,.61111,0,0,.525],88:[0,.61111,0,0,.525],89:[0,.61111,0,0,.525],90:[0,.61111,0,0,.525],91:[.08333,.69444,0,0,.525],92:[.08333,.69444,0,0,.525],93:[.08333,.69444,0,0,.525],94:[0,.61111,0,0,.525],95:[.09514,0,0,0,.525],96:[0,.61111,0,0,.525],97:[0,.43056,0,0,.525],98:[0,.61111,0,0,.525],99:[0,.43056,0,0,.525],100:[0,.61111,0,0,.525],101:[0,.43056,0,0,.525],102:[0,.61111,0,0,.525],103:[.22222,.43056,0,0,.525],104:[0,.61111,0,0,.525],105:[0,.61111,0,0,.525],106:[.22222,.61111,0,0,.525],107:[0,.61111,0,0,.525],108:[0,.61111,0,0,.525],109:[0,.43056,0,0,.525],110:[0,.43056,0,0,.525],111:[0,.43056,0,0,.525],112:[.22222,.43056,0,0,.525],113:[.22222,.43056,0,0,.525],114:[0,.43056,0,0,.525],115:[0,.43056,0,0,.525],116:[0,.55358,0,0,.525],117:[0,.43056,0,0,.525],118:[0,.43056,0,0,.525],119:[0,.43056,0,0,.525],120:[0,.43056,0,0,.525],121:[.22222,.43056,0,0,.525],122:[0,.43056,0,0,.525],123:[.08333,.69444,0,0,.525],124:[.08333,.69444,0,0,.525],125:[.08333,.69444,0,0,.525],126:[0,.61111,0,0,.525],127:[0,.61111,0,0,.525],305:[0,.43056,0,0,.525],567:[.22222,.43056,0,0,.525],768:[0,.61111,0,0,.525],769:[0,.61111,0,0,.525],770:[0,.61111,0,0,.525],771:[0,.61111,0,0,.525],772:[0,.56555,0,0,.525],774:[0,.61111,0,0,.525],776:[0,.61111,0,0,.525],778:[0,.61111,0,0,.525],780:[0,.56597,0,0,.525],915:[0,.61111,0,0,.525],916:[0,.61111,0,0,.525],920:[0,.61111,0,0,.525],923:[0,.61111,0,0,.525],926:[0,.61111,0,0,.525],928:[0,.61111,0,0,.525],931:[0,.61111,0,0,.525],933:[0,.61111,0,0,.525],934:[0,.61111,0,0,.525],936:[0,.61111,0,0,.525],937:[0,.61111,0,0,.525],8216:[0,.61111,0,0,.525],8217:[0,.61111,0,0,.525],8242:[0,.61111,0,0,.525],9251:[.11111,.21944,0,0,.525]}}},{}],103:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./utils");var n=d(a);var i=e("./ParseError");var l=d(i);var u=e("./ParseNode");var o=d(u);var s=e("./defineFunction");var f=d(s);e("./functions/sqrt");e("./functions/color");e("./functions/text");e("./functions/enclose");e("./functions/overline");e("./functions/underline");e("./functions/rule");e("./functions/kern");e("./functions/phantom");e("./functions/mod");e("./functions/op");e("./functions/operatorname");e("./functions/genfrac");e("./functions/lap");e("./functions/smash");e("./functions/delimsizing");e("./functions/verb");e("./functions/href");e("./functions/mathchoice");function d(e){return e&&e.__esModule?e:{default:e}}var c=s._functions;r.default=c;var h=function e(t,r,a){(0,f.default)({names:t,props:r,handler:a})};h(["\\color"],{numArgs:1,allowedInText:true,greediness:3,argTypes:["color"]},null);h(["\\mathord","\\mathbin","\\mathrel","\\mathopen","\\mathclose","\\mathpunct","\\mathinner"],{
numArgs:1},function(e,t){var r=t[0];return{type:"mclass",mclass:"m"+e.funcName.substr(5),value:(0,s.ordargument)(r)}});h(["\\stackrel"],{numArgs:2},function(e,t){var r=t[0];var a=t[1];var n=new o.default("op",{type:"op",limits:true,alwaysHandleSupSub:true,symbol:false,value:(0,s.ordargument)(a)},a.mode);var i=new o.default("supsub",{base:n,sup:r,sub:null},r.mode);return{type:"mclass",mclass:"mrel",value:[i]}});var v={"\\Bbb":"\\mathbb","\\bold":"\\mathbf","\\frak":"\\mathfrak","\\bm":"\\boldsymbol"};var p={"\u222b":"\\int","\u222c":"\\iint","\u222d":"\\iiint","\u222e":"\\oint"};h(["\\arcsin","\\arccos","\\arctan","\\arctg","\\arcctg","\\arg","\\ch","\\cos","\\cosec","\\cosh","\\cot","\\cotg","\\coth","\\csc","\\ctg","\\cth","\\deg","\\dim","\\exp","\\hom","\\ker","\\lg","\\ln","\\log","\\sec","\\sin","\\sinh","\\sh","\\tan","\\tanh","\\tg","\\th"],{numArgs:0},function(e){return{type:"op",limits:false,symbol:false,body:e.funcName}});h(["\\det","\\gcd","\\inf","\\lim","\\max","\\min","\\Pr","\\sup"],{numArgs:0},function(e){return{type:"op",limits:true,symbol:false,body:e.funcName}});h(["\\int","\\iint","\\iiint","\\oint","\u222b","\u222c","\u222d","\u222e"],{numArgs:0},function(e){var t=e.funcName;if(t.length===1){t=p[t]}return{type:"op",limits:false,symbol:true,body:t}});h(["\\tiny","\\scriptsize","\\footnotesize","\\small","\\normalsize","\\large","\\Large","\\LARGE","\\huge","\\Huge"],{numArgs:0},null);h(["\\displaystyle","\\textstyle","\\scriptstyle","\\scriptscriptstyle"],{numArgs:0},null);h(["\\rm","\\sf","\\tt","\\bf","\\it"],{numArgs:0},null);h(["\\mathrm","\\mathit","\\mathbf","\\boldsymbol","\\mathbb","\\mathcal","\\mathfrak","\\mathscr","\\mathsf","\\mathtt","\\Bbb","\\bold","\\frak","\\bm"],{numArgs:1,greediness:2},function(e,t){var r=t[0];var a=e.funcName;if(a in v){a=v[a]}return{type:"font",font:a.slice(1),body:r}});h(["\\acute","\\grave","\\ddot","\\tilde","\\bar","\\breve","\\check","\\hat","\\vec","\\dot","\\widehat","\\widetilde","\\overrightarrow","\\overleftarrow","\\Overrightarrow","\\overleftrightarrow","\\overgroup","\\overlinesegment","\\overleftharpoon","\\overrightharpoon"],{numArgs:1},function(e,t){var r=t[0];var a=!n.default.contains(["\\acute","\\grave","\\ddot","\\tilde","\\bar","\\breve","\\check","\\hat","\\vec","\\dot"],e.funcName);var i=!a||n.default.contains(["\\widehat","\\widetilde"],e.funcName);return{type:"accent",label:e.funcName,isStretchy:a,isShifty:i,base:r}});h(["\\'","\\`","\\^","\\~","\\=","\\u","\\.",'\\"',"\\r","\\H","\\v"],{numArgs:1,allowedInText:true,allowedInMath:false},function(e,t){var r=t[0];return{type:"accent",label:e.funcName,isStretchy:false,isShifty:true,base:r}});h(["\\overbrace","\\underbrace"],{numArgs:1},function(e,t){var r=t[0];return{type:"horizBrace",label:e.funcName,isOver:/^\\over/.test(e.funcName),base:r}});h(["\\underleftarrow","\\underrightarrow","\\underleftrightarrow","\\undergroup","\\underlinesegment","\\utilde"],{numArgs:1},function(e,t){var r=t[0];return{type:"accentUnder",label:e.funcName,base:r}});h(["\\xleftarrow","\\xrightarrow","\\xLeftarrow","\\xRightarrow","\\xleftrightarrow","\\xLeftrightarrow","\\xhookleftarrow","\\xhookrightarrow","\\xmapsto","\\xrightharpoondown","\\xrightharpoonup","\\xleftharpoondown","\\xleftharpoonup","\\xrightleftharpoons","\\xleftrightharpoons","\\xlongequal","\\xtwoheadrightarrow","\\xtwoheadleftarrow","\\xtofrom"],{numArgs:1,numOptionalArgs:1},function(e,t,r){var a=r[0];var n=t[0];return{type:"xArrow",label:e.funcName,body:n,below:a}});h(["\\over","\\choose","\\atop"],{numArgs:0,infix:true},function(e){var t=void 0;switch(e.funcName){case"\\over":t="\\frac";break;case"\\choose":t="\\binom";break;case"\\atop":t="\\\\atopfrac";break;default:throw new Error("Unrecognized infix genfrac command")}return{type:"infix",replaceWith:t,token:e.token}});h(["\\\\","\\cr"],{numArgs:0,numOptionalArgs:1,argTypes:["size"]},function(e,t,r){var a=r[0];return{type:"cr",size:a}});h(["\\begin","\\end"],{numArgs:1,argTypes:["text"]},function(e,t){var r=t[0];if(r.type!=="ordgroup"){throw new l.default("Invalid environment name",r)}var a="";for(var n=0;n<r.value.length;++n){a+=r.value[n].value}return{type:"environment",name:a,nameGroup:r}});h(["\\raisebox"],{numArgs:2,argTypes:["size","text"],allowedInText:true},function(e,t){var r=t[0];var a=t[1];return{type:"raisebox",dy:r,body:a,value:(0,s.ordargument)(a)}})},{"./ParseError":84,"./ParseNode":85,"./defineFunction":96,"./functions/color":104,"./functions/delimsizing":105,"./functions/enclose":106,"./functions/genfrac":107,"./functions/href":108,"./functions/kern":109,"./functions/lap":110,"./functions/mathchoice":111,"./functions/mod":112,"./functions/op":113,"./functions/operatorname":114,"./functions/overline":115,"./functions/phantom":116,"./functions/rule":117,"./functions/smash":118,"./functions/sqrt":119,"./functions/text":120,"./functions/underline":121,"./functions/verb":122,"./utils":133}],104:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}var p=function e(t,r){var a=f.buildExpression(t.value.value,r.withColor(t.value.color),false);return new l.default.makeFragment(a)};var m=function e(t,r){var a=c.buildExpression(t.value.value,r);var n=new o.default.MathNode("mstyle",a);n.setAttribute("mathcolor",t.value.color);return n};(0,n.default)({type:"color",names:["\\textcolor"],props:{numArgs:2,allowedInText:true,greediness:3,argTypes:["color","original"]},handler:function e(t,r){var n=r[0];var i=r[1];return{type:"color",color:n.value,value:(0,a.ordargument)(i)}},htmlBuilder:p,mathmlBuilder:m});(0,n.default)({type:"color",names:["\\blue","\\orange","\\pink","\\red","\\green","\\gray","\\purple","\\blueA","\\blueB","\\blueC","\\blueD","\\blueE","\\tealA","\\tealB","\\tealC","\\tealD","\\tealE","\\greenA","\\greenB","\\greenC","\\greenD","\\greenE","\\goldA","\\goldB","\\goldC","\\goldD","\\goldE","\\redA","\\redB","\\redC","\\redD","\\redE","\\maroonA","\\maroonB","\\maroonC","\\maroonD","\\maroonE","\\purpleA","\\purpleB","\\purpleC","\\purpleD","\\purpleE","\\mintA","\\mintB","\\mintC","\\grayA","\\grayB","\\grayC","\\grayD","\\grayE","\\grayF","\\grayG","\\grayH","\\grayI","\\kaBlue","\\kaGreen"],props:{numArgs:1,allowedInText:true,greediness:3},handler:function e(t,r){var n=r[0];return{type:"color",color:"katex-"+t.funcName.slice(1),value:(0,a.ordargument)(n)}},htmlBuilder:p,mathmlBuilder:m})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],105:[function(e,t,r){"use strict";var a=e("../buildCommon");var n=x(a);var i=e("../defineFunction");var l=x(i);var u=e("../delimiter");var o=x(u);var s=e("../mathMLTree");var f=x(s);var d=e("../ParseError");var c=x(d);var h=e("../utils");var v=x(h);var p=e("../buildHTML");var m=y(p);var g=e("../buildMathML");var b=y(g);function y(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function x(e){return e&&e.__esModule?e:{default:e}}var w={"\\bigl":{mclass:"mopen",size:1},"\\Bigl":{mclass:"mopen",size:2},"\\biggl":{mclass:"mopen",size:3},"\\Biggl":{mclass:"mopen",size:4},"\\bigr":{mclass:"mclose",size:1},"\\Bigr":{mclass:"mclose",size:2},"\\biggr":{mclass:"mclose",size:3},"\\Biggr":{mclass:"mclose",size:4},"\\bigm":{mclass:"mrel",size:1},"\\Bigm":{mclass:"mrel",size:2},"\\biggm":{mclass:"mrel",size:3},"\\Biggm":{mclass:"mrel",size:4},"\\big":{mclass:"mord",size:1},"\\Big":{mclass:"mord",size:2},"\\bigg":{mclass:"mord",size:3},"\\Bigg":{mclass:"mord",size:4}};var M=["(",")","[","\\lbrack","]","\\rbrack","\\{","\\lbrace","\\}","\\rbrace","\\lfloor","\\rfloor","\\lceil","\\rceil","<",">","\\langle","\\rangle","\\lt","\\gt","\\lvert","\\rvert","\\lVert","\\rVert","\\lgroup","\\rgroup","\\lmoustache","\\rmoustache","/","\\backslash","|","\\vert","\\|","\\Vert","\\uparrow","\\Uparrow","\\downarrow","\\Downarrow","\\updownarrow","\\Updownarrow","."];function k(e,t){if(v.default.contains(M,e.value)){return e}else{throw new c.default("Invalid delimiter: '"+e.value+"' after '"+t.funcName+"'",e)}}(0,l.default)({type:"delimsizing",names:["\\bigl","\\Bigl","\\biggl","\\Biggl","\\bigr","\\Bigr","\\biggr","\\Biggr","\\bigm","\\Bigm","\\biggm","\\Biggm","\\big","\\Big","\\bigg","\\Bigg"],props:{numArgs:1},handler:function e(t,r){var a=k(r[0],t);return{type:"delimsizing",size:w[t.funcName].size,mclass:w[t.funcName].mclass,value:a.value}},htmlBuilder:function e(t,r){var a=t.value.value;if(a==="."){return n.default.makeSpan([t.value.mclass])}return o.default.sizedDelim(a,t.value.size,r,t.mode,[t.value.mclass])},mathmlBuilder:function e(t){var r=[];if(t.value.value!=="."){r.push(b.makeText(t.value.value,t.mode))}var a=new f.default.MathNode("mo",r);if(t.value.mclass==="mopen"||t.value.mclass==="mclose"){a.setAttribute("fence","true")}else{a.setAttribute("fence","false")}return a}});(0,l.default)({type:"leftright",names:["\\left","\\right"],props:{numArgs:1},handler:function e(t,r){var a=k(r[0],t);return{type:"leftright",value:a.value}},htmlBuilder:function e(t,r){var a=m.buildExpression(t.value.body,r,true);var i=0;var l=0;var u=false;for(var s=0;s<a.length;s++){if(a[s].isMiddle){u=true}else{i=Math.max(a[s].height,i);l=Math.max(a[s].depth,l)}}i*=r.sizeMultiplier;l*=r.sizeMultiplier;var f=void 0;if(t.value.left==="."){f=m.makeNullDelimiter(r,["mopen"])}else{f=o.default.leftRightDelim(t.value.left,i,l,r,t.mode,["mopen"])}a.unshift(f);if(u){for(var d=1;d<a.length;d++){var c=a[d];if(c.isMiddle){a[d]=o.default.leftRightDelim(c.isMiddle.value,i,l,c.isMiddle.options,t.mode,[]);var h=m.spliceSpaces(c.children,0);if(h){n.default.prependChildren(a[d],h)}}}}var v=void 0;if(t.value.right==="."){v=m.makeNullDelimiter(r,["mclose"])}else{v=o.default.leftRightDelim(t.value.right,i,l,r,t.mode,["mclose"])}a.push(v);return n.default.makeSpan(["minner"],a,r)},mathmlBuilder:function e(t,r){var a=b.buildExpression(t.value.body,r);if(t.value.left!=="."){var n=new f.default.MathNode("mo",[b.makeText(t.value.left,t.mode)]);n.setAttribute("fence","true");a.unshift(n)}if(t.value.right!=="."){var i=new f.default.MathNode("mo",[b.makeText(t.value.right,t.mode)]);i.setAttribute("fence","true");a.push(i)}var l=new f.default.MathNode("mrow",a);return l}});(0,l.default)({type:"middle",names:["\\middle"],props:{numArgs:1},handler:function e(t,r){var a=k(r[0],t);if(!t.parser.leftrightDepth){throw new c.default("\\middle without preceding \\left",a)}return{type:"middle",value:a.value}},htmlBuilder:function e(t,r){var a=void 0;if(t.value.value==="."){a=m.makeNullDelimiter(r,[])}else{a=o.default.sizedDelim(t.value.value,1,r,t.mode,[]);a.isMiddle={value:t.value.value,options:r}}return a},mathmlBuilder:function e(t,r){var a=new f.default.MathNode("mo",[b.makeText(t.value.middle,t.mode)]);a.setAttribute("fence","true");return a}})},{"../ParseError":84,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../delimiter":97,"../mathMLTree":124,"../utils":133}],106:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=b(a);var i=e("../buildCommon");var l=b(i);var u=e("../mathMLTree");var o=b(u);var s=e("../utils");var f=b(s);var d=e("../stretchy");var c=b(d);var h=e("../buildHTML");var v=g(h);var p=e("../buildMathML");var m=g(p);function g(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function b(e){return e&&e.__esModule?e:{default:e}}var y=function e(t,r){var a=v.buildGroup(t.value.body,r);var n=t.value.label.substr(1);var i=r.sizeMultiplier;var u=void 0;var o=0;var s=/color/.test(n);if(n==="sout"){u=l.default.makeSpan(["stretchy","sout"]);u.height=r.fontMetrics().defaultRuleThickness/i;o=-.5*r.fontMetrics().xHeight}else{a.classes.push(/cancel/.test(n)?"cancel-pad":"boxpad");var d=0;if(/box/.test(n)){d=n==="colorbox"?.3:.34}else{d=f.default.isCharacterBox(t.value.body)?.2:0}u=c.default.encloseSpan(a,n,d,r);o=a.depth+d;if(s){u.style.backgroundColor=t.value.backgroundColor.value;if(n==="fcolorbox"){u.style.borderColor=t.value.borderColor.value}}}var h=void 0;if(s){h=l.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:u,shift:o},{type:"elem",elem:a,shift:0}]},r)}else{h=l.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:a,shift:0},{type:"elem",elem:u,shift:o,wrapperClasses:/cancel/.test(n)?["svg-align"]:[]}]},r)}if(/cancel/.test(n)){return l.default.makeSpan(["mord","cancel-lap"],[h],r)}else{return l.default.makeSpan(["mord"],[h],r)}};var x=function e(t,r){var a=new o.default.MathNode("menclose",[m.buildGroup(t.value.body,r)]);switch(t.value.label){case"\\cancel":a.setAttribute("notation","updiagonalstrike");break;case"\\bcancel":a.setAttribute("notation","downdiagonalstrike");break;case"\\sout":a.setAttribute("notation","horizontalstrike");break;case"\\fbox":a.setAttribute("notation","box");break;case"\\colorbox":a.setAttribute("mathbackground",t.value.backgroundColor.value);break;case"\\fcolorbox":a.setAttribute("mathbackground",t.value.backgroundColor.value);a.setAttribute("notation","box");break;default:a.setAttribute("notation","updiagonalstrike downdiagonalstrike")}return a};(0,n.default)({type:"enclose",names:["\\colorbox"],props:{numArgs:2,allowedInText:true,greediness:3,argTypes:["color","text"]},handler:function e(t,r,a){var n=r[0];var i=r[1];return{type:"enclose",label:t.funcName,backgroundColor:n,body:i}},htmlBuilder:y,mathmlBuilder:x});(0,n.default)({type:"enclose",names:["\\fcolorbox"],props:{numArgs:3,allowedInText:true,greediness:3,argTypes:["color","color","text"]},handler:function e(t,r,a){var n=r[0];var i=r[1];var l=r[2];return{type:"enclose",label:t.funcName,backgroundColor:i,borderColor:n,body:l}},htmlBuilder:y,mathmlBuilder:x});(0,n.default)({type:"enclose",names:["\\cancel","\\bcancel","\\xcancel","\\sout","\\fbox"],props:{numArgs:1},handler:function e(t,r,a){var n=r[0];return{type:"enclose",label:t.funcName,body:n}},htmlBuilder:y,mathmlBuilder:x})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124,"../stretchy":126,"../utils":133}],107:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=b(a);var i=e("../buildCommon");var l=b(i);var u=e("../delimiter");var o=b(u);var s=e("../mathMLTree");var f=b(s);var d=e("../Style");var c=b(d);var h=e("../buildHTML");var v=g(h);var p=e("../buildMathML");var m=g(p);function g(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function b(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"genfrac",names:["\\dfrac","\\frac","\\tfrac","\\dbinom","\\binom","\\tbinom","\\\\atopfrac"],props:{numArgs:2,greediness:2},handler:function e(t,r){var a=r[0];var n=r[1];var i=void 0;var l=null;var u=null;var o="auto";switch(t.funcName){case"\\dfrac":case"\\frac":case"\\tfrac":i=true;break;case"\\\\atopfrac":i=false;break;case"\\dbinom":case"\\binom":case"\\tbinom":i=false;l="(";u=")";break;default:throw new Error("Unrecognized genfrac command")}switch(t.funcName){case"\\dfrac":case"\\dbinom":o="display";break;case"\\tfrac":case"\\tbinom":o="text";break}return{type:"genfrac",numer:a,denom:n,hasBarLine:i,leftDelim:l,rightDelim:u,size:o}},htmlBuilder:function e(t,r){var a=r.style;if(t.value.size==="display"){a=c.default.DISPLAY}else if(t.value.size==="text"){a=c.default.TEXT}var n=a.fracNum();var i=a.fracDen();var u=void 0;u=r.havingStyle(n);var s=v.buildGroup(t.value.numer,u,r);u=r.havingStyle(i);var f=v.buildGroup(t.value.denom,u,r);var d=void 0;var h=void 0;var p=void 0;if(t.value.hasBarLine){d=l.default.makeLineSpan("frac-line",r);h=d.height;p=d.height}else{d=null;h=0;p=r.fontMetrics().defaultRuleThickness}var m=void 0;var g=void 0;var b=void 0;if(a.size===c.default.DISPLAY.size){m=r.fontMetrics().num1;if(h>0){g=3*p}else{g=7*p}b=r.fontMetrics().denom1}else{if(h>0){m=r.fontMetrics().num2;g=p}else{m=r.fontMetrics().num3;g=3*p}b=r.fontMetrics().denom2}var y=void 0;if(!d){var x=m-s.depth-(f.height-b);if(x<g){m+=.5*(g-x);b+=.5*(g-x)}y=l.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:f,shift:b},{type:"elem",elem:s,shift:-m}]},r)}else{var w=r.fontMetrics().axisHeight;if(m-s.depth-(w+.5*h)<g){m+=g-(m-s.depth-(w+.5*h))}if(w-.5*h-(f.height-b)<g){b+=g-(w-.5*h-(f.height-b))}var M=-(w-.5*h);y=l.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:f,shift:b},{type:"elem",elem:d,shift:M+2*h},{type:"elem",elem:s,shift:-m}]},r)}u=r.havingStyle(a);y.height*=u.sizeMultiplier/r.sizeMultiplier;y.depth*=u.sizeMultiplier/r.sizeMultiplier;var k=void 0;if(a.size===c.default.DISPLAY.size){k=r.fontMetrics().delim1}else{k=r.fontMetrics().delim2}var _=void 0;var S=void 0;if(t.value.leftDelim==null){_=v.makeNullDelimiter(r,["mopen"])}else{_=o.default.customSizedDelim(t.value.leftDelim,k,true,r.havingStyle(a),t.mode,["mopen"])}if(t.value.rightDelim==null){S=v.makeNullDelimiter(r,["mclose"])}else{S=o.default.customSizedDelim(t.value.rightDelim,k,true,r.havingStyle(a),t.mode,["mclose"])}return l.default.makeSpan(["mord"].concat(u.sizingClasses(r)),[_,l.default.makeSpan(["mfrac"],[y]),S],r)},mathmlBuilder:function e(t,r){var a=new f.default.MathNode("mfrac",[m.buildGroup(t.value.numer,r),m.buildGroup(t.value.denom,r)]);if(!t.value.hasBarLine){a.setAttribute("linethickness","0px")}if(t.value.leftDelim!=null||t.value.rightDelim!=null){var n=[];if(t.value.leftDelim!=null){var i=new f.default.MathNode("mo",[new f.default.TextNode(t.value.leftDelim)]);i.setAttribute("fence","true");n.push(i)}n.push(a);if(t.value.rightDelim!=null){var l=new f.default.MathNode("mo",[new f.default.TextNode(t.value.rightDelim)]);l.setAttribute("fence","true");n.push(l)}var u=new f.default.MathNode("mrow",n);return u}return a}})},{"../Style":89,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../delimiter":97,"../mathMLTree":124}],108:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"href",names:["\\href"],props:{numArgs:2,argTypes:["url","original"]},handler:function e(t,r){var n=r[1];var i=r[0].value;return{type:"href",href:i,body:(0,a.ordargument)(n)}},htmlBuilder:function e(t,r){var a=f.buildExpression(t.value.body,r,false);var n=t.value.href;var i=[];var u=void 0;var o=void 0;if(a.length===1){i=a[0].classes}else if(a.length>=2){u=f.getTypeOfDomTree(a[0])||"mord";o=f.getTypeOfDomTree(a[a.length-1])||"mord";if(u===o){i=[u]}else{var s=l.default.makeAnchor(n,[],a,r);return new l.default.makeFragment([new l.default.makeSpan([u],[],r),s,new l.default.makeSpan([o],[],r)])}}return new l.default.makeAnchor(n,i,a,r)},mathmlBuilder:function e(t,r){var a=c.buildExpression(t.value.body,r);var n=new o.default.MathNode("mrow",a);n.setAttribute("href",t.value.href);return n}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],109:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=c(a);var i=e("../buildCommon");var l=c(i);var u=e("../mathMLTree");var o=c(u);var s=e("../units");var f=e("../ParseError");var d=c(f);function c(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"kern",names:["\\kern","\\mkern","\\hskip","\\mskip"],props:{numArgs:1,argTypes:["size"],allowedInText:true},handler:function e(t,r){var a=t.funcName[1]==="m";var n=r[0].value.unit==="mu";if(a){if(!n){typeof console!=="undefined"&&console.warn("In LaTeX, "+t.funcName+" supports only mu units, "+("not "+r[0].value.unit+" units"))}if(t.parser.mode!=="math"){throw new d.default("Can't use function '"+t.funcName+"' in text mode")}}else{if(n){typeof console!=="undefined"&&console.warn("In LaTeX, "+t.funcName+" does not support mu units")}}return{type:"kern",dimension:r[0].value}},htmlBuilder:function e(t,r){var a=l.default.makeSpan(["mord","rule"],[],r);if(t.value.dimension){var n=(0,s.calculateSize)(t.value.dimension,r);a.style.marginRight=n+"em"}return a},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mspace");if(t.value.dimension){var n=(0,s.calculateSize)(t.value.dimension,r);a.setAttribute("width",n+"em")}return a}})},{"../ParseError":84,"../buildCommon":91,"../defineFunction":96,"../mathMLTree":124,"../units":132}],110:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"lap",names:["\\mathllap","\\mathrlap","\\mathclap"],props:{numArgs:1,allowedInText:true},handler:function e(t,r){var a=r[0];return{type:"lap",alignment:t.funcName.slice(5),body:a}},htmlBuilder:function e(t,r){var a=void 0;if(t.value.alignment==="clap"){a=l.default.makeSpan([],[f.buildGroup(t.value.body,r)]);a=l.default.makeSpan(["inner"],[a],r)}else{a=l.default.makeSpan(["inner"],[f.buildGroup(t.value.body,r)])}var n=l.default.makeSpan(["fix"],[]);return l.default.makeSpan(["mord",t.value.alignment],[a,n],r)},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mpadded",[c.buildGroup(t.value.body,r)]);if(t.value.alignment!=="rlap"){var n=t.value.alignment==="llap"?"-1":"-0.5";a.setAttribute("lspace",n+"width")}a.setAttribute("width","0px");return a}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],111:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=m(a);var i=e("../buildCommon");var l=m(i);var u=e("../mathMLTree");var o=m(u);var s=e("../Style");var f=m(s);var d=e("../buildHTML");var c=p(d);var h=e("../buildMathML");var v=p(h);function p(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function m(e){return e&&e.__esModule?e:{default:e}}var g=function e(t,r){var a=r.style;if(a.size===f.default.DISPLAY.size){return t.value.display}else if(a.size===f.default.TEXT.size){return t.value.text}else if(a.size===f.default.SCRIPT.size){return t.value.script}else if(a.size===f.default.SCRIPTSCRIPT.size){return t.value.scriptscript}return t.value.text};(0,n.default)({type:"mathchoice",names:["\\mathchoice"],props:{numArgs:4},handler:function e(t,r){return{type:"mathchoice",display:(0,a.ordargument)(r[0]),text:(0,a.ordargument)(r[1]),script:(0,a.ordargument)(r[2]),scriptscript:(0,a.ordargument)(r[3])}},htmlBuilder:function e(t,r){var a=g(t,r);var n=c.buildExpression(a,r,false);return new l.default.makeFragment(n)},mathmlBuilder:function e(t,r){var a=g(t,r);var n=v.buildExpression(a,r,false);return new o.default.MathNode("mrow",n)}})},{"../Style":89,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],112:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=m(a);var i=e("../buildCommon");var l=m(i);var u=e("../mathMLTree");var o=m(u);var s=e("../Style");var f=m(s);var d=e("../buildHTML");var c=p(d);var h=e("../buildMathML");var v=p(h);function p(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function m(e){return e&&e.__esModule?e:{default:e}}var g=function e(t,r){var a=[];if(t.value.modType==="bmod"){if(!r.style.isTight()){a.push(l.default.makeSpan(["mspace","muspace"],[],r))}else{a.push(l.default.makeSpan(["mspace","thickspace"],[],r))}}else if(r.style.size===f.default.DISPLAY.size){a.push(l.default.makeSpan(["mspace","quad"],[],r))}else if(t.value.modType==="mod"){a.push(l.default.makeSpan(["mspace","twelvemuspace"],[],r))}else{a.push(l.default.makeSpan(["mspace","eightmuspace"],[],r))}if(t.value.modType==="pod"||t.value.modType==="pmod"){a.push(l.default.mathsym("(",t.mode))}if(t.value.modType!=="pod"){var n=[l.default.mathsym("m",t.mode),l.default.mathsym("o",t.mode),l.default.mathsym("d",t.mode)];if(t.value.modType==="bmod"){a.push(l.default.makeSpan(["mbin"],n,r));if(!r.style.isTight()){a.push(l.default.makeSpan(["mspace","muspace"],[],r))}else{a.push(l.default.makeSpan(["mspace","thickspace"],[],r))}}else{Array.prototype.push.apply(a,n);a.push(l.default.makeSpan(["mspace","sixmuspace"],[],r))}}if(t.value.value){Array.prototype.push.apply(a,c.buildExpression(t.value.value,r,false))}if(t.value.modType==="pod"||t.value.modType==="pmod"){a.push(l.default.mathsym(")",t.mode))}return l.default.makeFragment(a)};var b=function e(t,r){var a=[];if(t.value.modType==="pod"||t.value.modType==="pmod"){a.push(new o.default.MathNode("mo",[v.makeText("(",t.mode)]))}if(t.value.modType!=="pod"){a.push(new o.default.MathNode("mo",[v.makeText("mod",t.mode)]))}if(t.value.value){var n=new o.default.MathNode("mspace");n.setAttribute("width","0.333333em");a.push(n);a=a.concat(v.buildExpression(t.value.value,r))}if(t.value.modType==="pod"||t.value.modType==="pmod"){a.push(new o.default.MathNode("mo",[v.makeText(")",t.mode)]))}return new o.default.MathNode("mo",a)};(0,n.default)({type:"mod",names:["\\bmod"],props:{numArgs:0},handler:function e(t,r){return{type:"mod",modType:"bmod",value:null}},htmlBuilder:g,mathmlBuilder:b});(0,n.default)({type:"mod",names:["\\pod","\\pmod","\\mod"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"mod",modType:t.funcName.substr(1),value:(0,a.ordargument)(n)}},htmlBuilder:g,mathmlBuilder:b})},{"../Style":89,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],113:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=x(a);var i=e("../buildCommon");var l=x(i);var u=e("../domTree");var o=x(u);var s=e("../mathMLTree");var f=x(s);var d=e("../utils");var c=x(d);var h=e("../Style");var v=x(h);var p=e("../buildHTML");var m=y(p);var g=e("../buildMathML");var b=y(g);function y(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function x(e){return e&&e.__esModule?e:{default:e}}var w=function e(t,r){var a=void 0;var n=void 0;var i=false;if(t.type==="supsub"){a=t.value.sup;n=t.value.sub;t=t.value.base;i=true}var u=r.style;var s=["\\smallint"];var f=false;if(u.size===v.default.DISPLAY.size&&t.value.symbol&&!c.default.contains(s,t.value.body)){f=true}var d=void 0;if(t.value.symbol){var h=f?"Size2-Regular":"Size1-Regular";d=l.default.makeSymbol(t.value.body,h,"math",r,["mop","op-symbol",f?"large-op":"small-op"])}else if(t.value.value){var p=m.buildExpression(t.value.value,r,true);if(p.length===1&&p[0]instanceof o.default.symbolNode){d=p[0];d.classes[0]="mop"}else{d=l.default.makeSpan(["mop"],p,r)}}else{var g=[];for(var b=1;b<t.value.body.length;b++){g.push(l.default.mathsym(t.value.body[b],t.mode))}d=l.default.makeSpan(["mop"],g,r)}var y=0;var x=0;if(d instanceof o.default.symbolNode){y=(d.height-d.depth)/2-r.fontMetrics().axisHeight;x=d.italic}if(i){d=l.default.makeSpan([],[d]);var w=void 0;var M=void 0;if(a){var k=m.buildGroup(a,r.havingStyle(u.sup()),r);M={elem:k,kern:Math.max(r.fontMetrics().bigOpSpacing1,r.fontMetrics().bigOpSpacing3-k.depth)}}if(n){var _=m.buildGroup(n,r.havingStyle(u.sub()),r);w={elem:_,kern:Math.max(r.fontMetrics().bigOpSpacing2,r.fontMetrics().bigOpSpacing4-_.height)}}var S=void 0;if(M&&w){var T=r.fontMetrics().bigOpSpacing5+w.elem.height+w.elem.depth+w.kern+d.depth+y;S=l.default.makeVList({positionType:"bottom",positionData:T,children:[{type:"kern",size:r.fontMetrics().bigOpSpacing5},{type:"elem",elem:w.elem,marginLeft:-x+"em"},{type:"kern",size:w.kern},{type:"elem",elem:d},{type:"kern",size:M.kern},{type:"elem",elem:M.elem,marginLeft:x+"em"},{type:"kern",size:r.fontMetrics().bigOpSpacing5}]},r)}else if(w){var z=d.height-y;S=l.default.makeVList({positionType:"top",positionData:z,children:[{type:"kern",size:r.fontMetrics().bigOpSpacing5},{type:"elem",elem:w.elem,marginLeft:-x+"em"},{type:"kern",size:w.kern},{type:"elem",elem:d}]},r)}else if(M){var C=d.depth+y;S=l.default.makeVList({positionType:"bottom",positionData:C,children:[{type:"elem",elem:d},{type:"kern",size:M.kern},{type:"elem",elem:M.elem,marginLeft:x+"em"},{type:"kern",size:r.fontMetrics().bigOpSpacing5}]},r)}else{return d}return l.default.makeSpan(["mop","op-limits"],[S],r)}else{if(y){d.style.position="relative";d.style.top=y+"em"}return d}};var M=function e(t,r){var a=void 0;if(t.value.symbol){a=new f.default.MathNode("mo",[b.makeText(t.value.body,t.mode)])}else if(t.value.value){a=new f.default.MathNode("mo",b.buildExpression(t.value.value,r))}else{a=new f.default.MathNode("mi",[new f.default.TextNode(t.value.body.slice(1))]);var n=new f.default.MathNode("mo",[b.makeText("\u2061","text")]);return new o.default.documentFragment([a,n])}return a};var k={"\u220f":"\\prod","\u2210":"\\coprod","\u2211":"\\sum","\u22c0":"\\bigwedge","\u22c1":"\\bigvee","\u22c2":"\\bigcap","\u22c3":"\\bigcap","\u2a00":"\\bigodot","\u2a01":"\\bigoplus","\u2a02":"\\bigotimes","\u2a04":"\\biguplus","\u2a06":"\\bigsqcup"};(0,n.default)({type:"op",names:["\\coprod","\\bigvee","\\bigwedge","\\biguplus","\\bigcap","\\bigcup","\\intop","\\prod","\\sum","\\bigotimes","\\bigoplus","\\bigodot","\\bigsqcup","\\smallint","\u220f","\u2210","\u2211","\u22c0","\u22c1","\u22c2","\u22c3","\u2a00","\u2a01","\u2a02","\u2a04","\u2a06"],props:{numArgs:0},handler:function e(t,r){var a=t.funcName;if(a.length===1){a=k[a]}return{type:"op",limits:true,symbol:true,body:a}},htmlBuilder:w,mathmlBuilder:M});(0,n.default)({type:"op",names:["\\mathop"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"op",limits:false,symbol:false,value:(0,a.ordargument)(n)}},htmlBuilder:w,mathmlBuilder:M})},{"../Style":89,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../domTree":98,"../mathMLTree":124,"../utils":133}],114:[function(e,t,r){"use strict";var a=e("babel-runtime/core-js/get-iterator");var n=b(a);var i=e("../defineFunction");var l=b(i);var u=e("../buildCommon");var o=b(u);var s=e("../mathMLTree");var f=b(s);var d=e("../domTree");var c=b(d);var h=e("../buildHTML");var v=g(h);var p=e("../buildMathML");var m=g(p);function g(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function b(e){return e&&e.__esModule?e:{default:e}}(0,l.default)({type:"operatorname",names:["\\operatorname"],props:{numArgs:1},handler:function e(t,r){var a=r[0];return{type:"operatorname",value:(0,i.ordargument)(a)}},htmlBuilder:function e(t,r){var a=[];if(t.value.value.length>0){var i="";var l="";var u=v.buildExpression(t.value.value,r.withFontFamily("mathrm"),true);var s=true;var f=false;var d=undefined;try{for(var h=(0,n.default)(u),p;!(s=(p=h.next()).done);s=true){var m=p.value;if(m instanceof c.default.symbolNode){i=m.value;i=i.replace(/\u2212/,"-");i=i.replace(/\u2217/,"*");l=/[\u0391-\u03D7]/.test(i)?"math":"text";a.push(o.default.mathsym(i,l))}else{a.push(m)}}}catch(e){f=true;d=e}finally{try{if(!s&&h.return){h.return()}}finally{if(f){throw d}}}}return o.default.makeSpan(["mop"],a,r);
},mathmlBuilder:function e(t,r){var a=[];if(t.value.value.length>0){var n=m.buildExpression(t.value.value,r.withFontFamily("mathrm"));var i=n.map(function(e){return e.toText()}).join("");i=i.replace(/\u2212/g,"-");i=i.replace(/\u2217/g,"*");a=[new f.default.TextNode(i)]}var l=new f.default.MathNode("mi",a);l.setAttribute("mathvariant","normal");var u=new f.default.MathNode("mo",[m.makeText("\u2061","text")]);return new c.default.documentFragment([l,u])}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../domTree":98,"../mathMLTree":124,"babel-runtime/core-js/get-iterator":3}],115:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"overline",names:["\\overline"],props:{numArgs:1},handler:function e(t,r){var a=r[0];return{type:"overline",body:a}},htmlBuilder:function e(t,r){var a=f.buildGroup(t.value.body,r.havingCrampedStyle());var n=l.default.makeLineSpan("overline-line",r);var i=l.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:a},{type:"kern",size:n.height},{type:"elem",elem:n}]},r);return l.default.makeSpan(["mord","overline"],[i],r)},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mo",[new o.default.TextNode("\u203e")]);a.setAttribute("stretchy","true");var n=new o.default.MathNode("mover",[c.buildGroup(t.value.body,r),a]);n.setAttribute("accent","true");return n}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],116:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"phantom",names:["\\phantom"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"phantom",value:(0,a.ordargument)(n)}},htmlBuilder:function e(t,r){var a=f.buildExpression(t.value.value,r.withPhantom(),false);return new l.default.makeFragment(a)},mathmlBuilder:function e(t,r){var a=c.buildExpression(t.value.value,r);return new o.default.MathNode("mphantom",a)}});(0,n.default)({type:"hphantom",names:["\\hphantom"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"hphantom",value:(0,a.ordargument)(n),body:n}},htmlBuilder:function e(t,r){var a=l.default.makeSpan([],[f.buildGroup(t.value.body,r.withPhantom())]);a.height=0;a.depth=0;if(a.children){for(var n=0;n<a.children.length;n++){a.children[n].height=0;a.children[n].depth=0}}a=l.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:a}]},r);return a},mathmlBuilder:function e(t,r){var a=c.buildExpression(t.value.value,r);var n=new o.default.MathNode("mphantom",a);n.setAttribute("height","0px");return n}});(0,n.default)({type:"vphantom",names:["\\vphantom"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"vphantom",value:(0,a.ordargument)(n),body:n}},htmlBuilder:function e(t,r){var a=l.default.makeSpan(["inner"],[f.buildGroup(t.value.body,r.withPhantom())]);var n=l.default.makeSpan(["fix"],[]);return l.default.makeSpan(["mord","rlap"],[a,n],r)},mathmlBuilder:function e(t,r){var a=c.buildExpression(t.value.value,r);var n=new o.default.MathNode("mphantom",a);n.setAttribute("width","0px");return n}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],117:[function(e,t,r){"use strict";var a=e("../buildCommon");var n=f(a);var i=e("../defineFunction");var l=f(i);var u=e("../mathMLTree");var o=f(u);var s=e("../units");function f(e){return e&&e.__esModule?e:{default:e}}(0,l.default)({type:"rule",names:["\\rule"],props:{numArgs:2,numOptionalArgs:1,argTypes:["size","size","size"]},handler:function e(t,r,a){var n=a[0];var i=r[0];var l=r[1];return{type:"rule",shift:n&&n.value,width:i.value,height:l.value}},htmlBuilder:function e(t,r){var a=n.default.makeSpan(["mord","rule"],[],r);var i=0;if(t.value.shift){i=(0,s.calculateSize)(t.value.shift,r)}var l=(0,s.calculateSize)(t.value.width,r);var u=(0,s.calculateSize)(t.value.height,r);a.style.borderRightWidth=l+"em";a.style.borderTopWidth=u+"em";a.style.bottom=i+"em";a.width=l;a.height=u+i;a.depth=-i;a.maxFontSize=u*1.125*r.sizeMultiplier;return a},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mrow");return a}})},{"../buildCommon":91,"../defineFunction":96,"../mathMLTree":124,"../units":132}],118:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"smash",names:["\\smash"],props:{numArgs:1,numOptionalArgs:1,allowedInText:true},handler:function e(t,r,a){var n=false;var i=false;var l=a[0];if(l){var u="";for(var o=0;o<l.value.length;++o){u=l.value[o].value;if(u==="t"){n=true}else if(u==="b"){i=true}else{n=false;i=false;break}}}else{n=true;i=true}var s=r[0];return{type:"smash",body:s,smashHeight:n,smashDepth:i}},htmlBuilder:function e(t,r){var a=l.default.makeSpan(["mord"],[f.buildGroup(t.value.body,r)]);if(!t.value.smashHeight&&!t.value.smashDepth){return a}if(t.value.smashHeight){a.height=0;if(a.children){for(var n=0;n<a.children.length;n++){a.children[n].height=0}}}if(t.value.smashDepth){a.depth=0;if(a.children){for(var i=0;i<a.children.length;i++){a.children[i].depth=0}}}return l.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:a}]},r)},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mpadded",[c.buildGroup(t.value.body,r)]);if(t.value.smashHeight){a.setAttribute("height","0px")}if(t.value.smashDepth){a.setAttribute("depth","0px")}return a}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],119:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=x(a);var i=e("../buildCommon");var l=x(i);var u=e("../domTree");var o=x(u);var s=e("../mathMLTree");var f=x(s);var d=e("../delimiter");var c=x(d);var h=e("../Style");var v=x(h);var p=e("../buildHTML");var m=y(p);var g=e("../buildMathML");var b=y(g);function y(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function x(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"sqrt",names:["\\sqrt"],props:{numArgs:1,numOptionalArgs:1},handler:function e(t,r,a){var n=a[0];var i=r[0];return{type:"sqrt",body:i,index:n}},htmlBuilder:function e(t,r){var a=m.buildGroup(t.value.body,r.havingCrampedStyle());if(a.height===0){a.height=r.fontMetrics().xHeight}if(a instanceof o.default.documentFragment){a=l.default.makeSpan([],[a],r)}var n=r.fontMetrics();var i=n.defaultRuleThickness;var u=i;if(r.style.id<v.default.TEXT.id){u=r.fontMetrics().xHeight}var s=i+u/4;var f=(a.height+a.depth+s+i)*r.sizeMultiplier;var d=c.default.sqrtImage(f,r),h=d.span,p=d.ruleWidth;var g=h.height-p;if(g>a.height+a.depth+s){s=(s+g-a.height-a.depth)/2}var b=h.height-a.height-s-p;a.style.paddingLeft=h.advanceWidth+"em";var y=l.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:a,wrapperClasses:["svg-align"]},{type:"kern",size:-(a.height+b)},{type:"elem",elem:h},{type:"kern",size:p}]},r);if(!t.value.index){return l.default.makeSpan(["mord","sqrt"],[y],r)}else{var x=r.havingStyle(v.default.SCRIPTSCRIPT);var w=m.buildGroup(t.value.index,x,r);var M=.6*(y.height-y.depth);var k=l.default.makeVList({positionType:"shift",positionData:-M,children:[{type:"elem",elem:w}]},r);var _=l.default.makeSpan(["root"],[k]);return l.default.makeSpan(["mord","sqrt"],[_,y],r)}},mathmlBuilder:function e(t,r){var a=void 0;if(t.value.index){a=new f.default.MathNode("mroot",[b.buildGroup(t.value.body,r),b.buildGroup(t.value.index,r)])}else{a=new f.default.MathNode("msqrt",[b.buildGroup(t.value.body,r)])}return a}})},{"../Style":89,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../delimiter":97,"../domTree":98,"../mathMLTree":124}],120:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}var p={"\\text":undefined,"\\textrm":"textrm","\\textsf":"textsf","\\texttt":"texttt","\\textnormal":"textrm"};var m={"\\textbf":"textbf"};var g={"\\textit":"textit"};(0,n.default)({type:"text",names:["\\text","\\textrm","\\textsf","\\texttt","\\textnormal","\\textbf","\\textit"],props:{numArgs:1,argTypes:["text"],greediness:2,allowedInText:true},handler:function e(t,r){var n=r[0];return{type:"text",body:(0,a.ordargument)(n),font:t.funcName}},htmlBuilder:function e(t,r){var a=t.value.font;var n=void 0;if(p[a]){n=r.withFontFamily(p[a])}else if(m[a]){n=r.withFontWeight(m[a])}else{n=r.withFontShape(g[a])}var i=f.buildExpression(t.value.body,n,true);l.default.tryCombineChars(i);return l.default.makeSpan(["mord","text"],i,n)},mathmlBuilder:function e(t,r){var a=t.value.body;var n=[];var i=null;for(var l=0;l<a.length;l++){var u=c.buildGroup(a[l],r);if(u.type==="mtext"&&i!=null){Array.prototype.push.apply(i.children,u.children)}else{n.push(u);if(u.type==="mtext"){i=u}}}if(n.length===1){return n[0]}else{return new o.default.MathNode("mrow",n)}}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],121:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"underline",names:["\\underline"],props:{numArgs:1},handler:function e(t,r){var a=r[0];return{type:"underline",body:a}},htmlBuilder:function e(t,r){var a=f.buildGroup(t.value.body,r);var n=l.default.makeLineSpan("underline-line",r);var i=l.default.makeVList({positionType:"top",positionData:a.height,children:[{type:"elem",elem:n},{type:"kern",size:5*n.height},{type:"elem",elem:a}]},r);return l.default.makeSpan(["mord","underline"],[i],r)},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mo",[new o.default.TextNode("\u203e")]);a.setAttribute("stretchy","true");var n=new o.default.MathNode("munder",[c.buildGroup(t.value.body,r),a]);n.setAttribute("accentunder","true");return n}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":124}],122:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=d(a);var i=e("../buildCommon");var l=d(i);var u=e("../mathMLTree");var o=d(u);var s=e("../ParseError");var f=d(s);function d(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"verb",names:["\\verb"],props:{numArgs:0,allowedInText:true},handler:function e(t,r,a){throw new f.default("\\verb ended by end of line instead of matching delimiter")},htmlBuilder:function e(t,r){var a=l.default.makeVerb(t,r);var n=[];var i=r.havingStyle(r.style.text());for(var u=0;u<a.length;u++){if(a[u]==="\xa0"){var o=l.default.makeSpan(["mord","rule"],[],i);o.style.marginLeft="0.525em";n.push(o)}else{n.push(l.default.makeSymbol(a[u],"Typewriter-Regular",t.mode,i,["mathtt"]))}}l.default.tryCombineChars(n);return l.default.makeSpan(["mord","text"].concat(i.sizingClasses(r)),n,i)},mathmlBuilder:function e(t,r){var a=new o.default.TextNode(l.default.makeVerb(t,r));var n=new o.default.MathNode("mtext",[a]);n.setAttribute("mathvariant",l.default.fontMap["mathtt"].variant);return n}})},{"../ParseError":84,"../buildCommon":91,"../defineFunction":96,"../mathMLTree":124}],123:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.defineMacro=c;var a=e("./fontMetricsData");var n=f(a);var i=e("./symbols");var l=f(i);var u=e("./utils");var o=f(u);var s=e("./Token");function f(e){return e&&e.__esModule?e:{default:e}}var d={};r.default=d;function c(e,t){d[e]=t}c("\\@firstoftwo",function(e){var t=e.consumeArgs(2);return{tokens:t[0],numArgs:0}});c("\\@secondoftwo",function(e){var t=e.consumeArgs(2);return{tokens:t[1],numArgs:0}});c("\\@ifnextchar",function(e){var t=e.consumeArgs(3);var r=e.future();if(t[0].length===1&&t[0][0].text===r.text){return{tokens:t[1],numArgs:0}}else{return{tokens:t[2],numArgs:0}}});c("\\@ifstar","\\@ifnextchar *{\\@firstoftwo{#1}}");c("\\TextOrMath",function(e){var t=e.consumeArgs(2);if(e.mode==="text"){return{tokens:t[0],numArgs:0}}else{return{tokens:t[1],numArgs:0}}});c("\\bgroup","{");c("\\egroup","}");c("\\begingroup","{");c("\\endgroup","}");c("\u2102","\\mathbb{C}");c("\u210d","\\mathbb{H}");c("\u2115","\\mathbb{N}");c("\u2119","\\mathbb{P}");c("\u211a","\\mathbb{Q}");c("\u211d","\\mathbb{R}");c("\u2124","\\mathbb{Z}");c("\xb7","\\cdotp");c("\\llap","\\mathllap{\\textrm{#1}}");c("\\rlap","\\mathrlap{\\textrm{#1}}");c("\\clap","\\mathclap{\\textrm{#1}}");c("\\overset","\\mathop{#2}\\limits^{#1}");c("\\underset","\\mathop{#2}\\limits_{#1}");c("\\boxed","\\fbox{\\displaystyle{#1}}");c("\\iff","\\DOTSB\\;\\Longleftrightarrow\\;");c("\\implies","\\DOTSB\\;\\Longrightarrow\\;");c("\\impliedby","\\DOTSB\\;\\Longleftarrow\\;");var h={",":"\\dotsc","\\not":"\\dotsb","+":"\\dotsb","=":"\\dotsb","<":"\\dotsb",">":"\\dotsb","-":"\\dotsb","*":"\\dotsb",":":"\\dotsb","\\DOTSB":"\\dotsb","\\coprod":"\\dotsb","\\bigvee":"\\dotsb","\\bigwedge":"\\dotsb","\\biguplus":"\\dotsb","\\bigcap":"\\dotsb","\\bigcup":"\\dotsb","\\prod":"\\dotsb","\\sum":"\\dotsb","\\bigotimes":"\\dotsb","\\bigoplus":"\\dotsb","\\bigodot":"\\dotsb","\\bigsqcup":"\\dotsb","\\implies":"\\dotsb","\\impliedby":"\\dotsb","\\And":"\\dotsb","\\longrightarrow":"\\dotsb","\\Longrightarrow":"\\dotsb","\\longleftarrow":"\\dotsb","\\Longleftarrow":"\\dotsb","\\longleftrightarrow":"\\dotsb","\\Longleftrightarrow":"\\dotsb","\\mapsto":"\\dotsb","\\longmapsto":"\\dotsb","\\hookrightarrow":"\\dotsb","\\iff":"\\dotsb","\\doteq":"\\dotsb","\\mathbin":"\\dotsb","\\bmod":"\\dotsb","\\mathrel":"\\dotsb","\\relbar":"\\dotsb","\\Relbar":"\\dotsb","\\xrightarrow":"\\dotsb","\\xleftarrow":"\\dotsb","\\DOTSI":"\\dotsi","\\int":"\\dotsi","\\oint":"\\dotsi","\\iint":"\\dotsi","\\iiint":"\\dotsi","\\iiiint":"\\dotsi","\\idotsint":"\\dotsi","\\DOTSX":"\\dotsx"};c("\\dots",function(e){var t="\\dotso";var r=e.expandAfterFuture().text;if(r in h){t=h[r]}else if(r.substr(0,4)==="\\not"){t="\\dotsb"}else if(r in l.default.math){if(o.default.contains(["bin","rel"],l.default.math[r].group)){t="\\dotsb"}}return t});var v={")":true,"]":true,"\\rbrack":true,"\\}":true,"\\rbrace":true,"\\rangle":true,"\\rceil":true,"\\rfloor":true,"\\rgroup":true,"\\rmoustache":true,"\\right":true,"\\bigr":true,"\\biggr":true,"\\Bigr":true,"\\Biggr":true,$:true,";":true,".":true,",":true};c("\\dotso",function(e){var t=e.future().text;if(t in v){return"\\ldots\\,"}else{return"\\ldots"}});c("\\dotsc",function(e){var t=e.future().text;if(t in v&&t!==","){return"\\ldots\\,"}else{return"\\ldots"}});c("\\cdots",function(e){var t=e.future().text;if(t in v){return"\\@cdots\\,"}else{return"\\@cdots"}});c("\\dotsb","\\cdots");c("\\dotsm","\\cdots");c("\\dotsi","\\!\\cdots");c("\\dotsx","\\ldots\\,");c("\\DOTSI","\\relax");c("\\DOTSB","\\relax");c("\\DOTSX","\\relax");c("\\thinspace","\\,");c("\\medspace","\\:");c("\\thickspace","\\;");c("\\TeX","\\textrm{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}");var p=n.default["Main-Regular"]["T".charCodeAt(0)][1]-.7*n.default["Main-Regular"]["A".charCodeAt(0)][1]+"em";c("\\LaTeX","\\textrm{L\\kern-.36em\\raisebox{"+p+"}{\\scriptsize A}"+"\\kern-.15em\\TeX}");c("\\KaTeX","\\textrm{K\\kern-.17em\\raisebox{"+p+"}{\\scriptsize A}"+"\\kern-.15em\\TeX}");c("\\hspace","\\@ifstar\\kern\\kern");c("\\ordinarycolon",":");c("\\vcentcolon","\\mathrel{\\mathop\\ordinarycolon}");c("\\dblcolon","\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon");c("\\coloneqq","\\vcentcolon\\mathrel{\\mkern-1.2mu}=");c("\\Coloneqq","\\dblcolon\\mathrel{\\mkern-1.2mu}=");c("\\coloneq","\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}");c("\\Coloneq","\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}");c("\\eqqcolon","=\\mathrel{\\mkern-1.2mu}\\vcentcolon");c("\\Eqqcolon","=\\mathrel{\\mkern-1.2mu}\\dblcolon");c("\\eqcolon","\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon");c("\\Eqcolon","\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon");c("\\colonapprox","\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx");c("\\Colonapprox","\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx");c("\\colonsim","\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim");c("\\Colonsim","\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim");c("\\ratio","\\vcentcolon");c("\\coloncolon","\\dblcolon");c("\\colonequals","\\coloneqq");c("\\coloncolonequals","\\Coloneqq");c("\\equalscolon","\\eqqcolon");c("\\equalscoloncolon","\\Eqqcolon");c("\\colonminus","\\coloneq");c("\\coloncolonminus","\\Coloneq");c("\\minuscolon","\\eqcolon");c("\\minuscoloncolon","\\Eqcolon");c("\\coloncolonapprox","\\Colonapprox");c("\\coloncolonsim","\\Colonsim");c("\\simcolon","\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon");c("\\simcoloncolon","\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon");c("\\approxcolon","\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon");c("\\approxcoloncolon","\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon");c("\\notni","\\not\\ni");c("\\limsup","\\DOTSB\\mathop{\\operatorname{lim\\,sup}}\\limits");c("\\liminf","\\DOTSB\\mathop{\\operatorname{lim\\,inf}}\\limits")},{"./Token":90,"./fontMetricsData":102,"./symbols":128,"./utils":133}],124:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/core-js/get-iterator");var n=d(a);var i=e("babel-runtime/helpers/classCallCheck");var l=d(i);var u=e("babel-runtime/helpers/createClass");var o=d(u);var s=e("./utils");var f=d(s);function d(e){return e&&e.__esModule?e:{default:e}}var c=function(){function e(t,r){(0,l.default)(this,e);this.type=t;this.attributes={};this.children=r||[]}(0,o.default)(e,[{key:"setAttribute",value:function e(t,r){this.attributes[t]=r}},{key:"toNode",value:function e(){var t=document.createElementNS("http://www.w3.org/1998/Math/MathML",this.type);for(var r in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,r)){t.setAttribute(r,this.attributes[r])}}var a=true;var i=false;var l=undefined;try{for(var u=(0,n.default)(this.children),o;!(a=(o=u.next()).done);a=true){var s=o.value;t.appendChild(s.toNode())}}catch(e){i=true;l=e}finally{try{if(!a&&u.return){u.return()}}finally{if(i){throw l}}}return t}},{key:"toMarkup",value:function e(){var t="<"+this.type;for(var r in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,r)){t+=" "+r+'="';t+=f.default.escape(this.attributes[r]);t+='"'}}t+=">";for(var a=0;a<this.children.length;a++){t+=this.children[a].toMarkup()}t+="</"+this.type+">";return t}},{key:"toText",value:function e(){if(this.type==="mspace"){if(this.attributes.width==="0.16667em"){return"\u2006"}else{return" "}}return this.children.map(function(e){return e.toText()}).join("")}}]);return e}();var h=function(){function e(t){(0,l.default)(this,e);this.text=t}(0,o.default)(e,[{key:"toNode",value:function e(){return document.createTextNode(this.text)}},{key:"toMarkup",value:function e(){return f.default.escape(this.text)}},{key:"toText",value:function e(){return this.text}}]);return e}();r.default={MathNode:c,TextNode:h}},{"./utils":133,"babel-runtime/core-js/get-iterator":3,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],125:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./Parser");var n=i(a);function i(e){return e&&e.__esModule?e:{default:e}}var l=function e(t,r){if(!(typeof t==="string"||t instanceof String)){throw new TypeError("KaTeX can only parse string typed expression")}var a=new n.default(t,r);return a.parse()};r.default=l},{"./Parser":86}],126:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/slicedToArray");var n=h(a);var i=e("./domTree");var l=h(i);var u=e("./buildCommon");var o=h(u);var s=e("./mathMLTree");var f=h(s);var d=e("./utils");var c=h(d);function h(e){return e&&e.__esModule?e:{default:e}}var v={widehat:"^",widetilde:"~",utilde:"~",overleftarrow:"\u2190",underleftarrow:"\u2190",xleftarrow:"\u2190",overrightarrow:"\u2192",underrightarrow:"\u2192",xrightarrow:"\u2192",underbrace:"\u23b5",overbrace:"\u23de",overleftrightarrow:"\u2194",underleftrightarrow:"\u2194",xleftrightarrow:"\u2194",Overrightarrow:"\u21d2",xRightarrow:"\u21d2",overleftharpoon:"\u21bc",xleftharpoonup:"\u21bc",overrightharpoon:"\u21c0",xrightharpoonup:"\u21c0",xLeftarrow:"\u21d0",xLeftrightarrow:"\u21d4",xhookleftarrow:"\u21a9",xhookrightarrow:"\u21aa",xmapsto:"\u21a6",xrightharpoondown:"\u21c1",xleftharpoondown:"\u21bd",xrightleftharpoons:"\u21cc",xleftrightharpoons:"\u21cb",xtwoheadleftarrow:"\u219e",xtwoheadrightarrow:"\u21a0",xlongequal:"=",xtofrom:"\u21c4"};var p=function e(t){var r=new f.default.MathNode("mo",[new f.default.TextNode(v[t.substr(1)])]);r.setAttribute("stretchy","true");return r};var m={overrightarrow:[["rightarrow"],.888,522,"xMaxYMin"],overleftarrow:[["leftarrow"],.888,522,"xMinYMin"],underrightarrow:[["rightarrow"],.888,522,"xMaxYMin"],underleftarrow:[["leftarrow"],.888,522,"xMinYMin"],xrightarrow:[["rightarrow"],1.469,522,"xMaxYMin"],xleftarrow:[["leftarrow"],1.469,522,"xMinYMin"],Overrightarrow:[["doublerightarrow"],.888,560,"xMaxYMin"],xRightarrow:[["doublerightarrow"],1.526,560,"xMaxYMin"],xLeftarrow:[["doubleleftarrow"],1.526,560,"xMinYMin"],overleftharpoon:[["leftharpoon"],.888,522,"xMinYMin"],xleftharpoonup:[["leftharpoon"],.888,522,"xMinYMin"],xleftharpoondown:[["leftharpoondown"],.888,522,"xMinYMin"],overrightharpoon:[["rightharpoon"],.888,522,"xMaxYMin"],xrightharpoonup:[["rightharpoon"],.888,522,"xMaxYMin"],xrightharpoondown:[["rightharpoondown"],.888,522,"xMaxYMin"],xlongequal:[["longequal"],.888,334,"xMinYMin"],xtwoheadleftarrow:[["twoheadleftarrow"],.888,334,"xMinYMin"],xtwoheadrightarrow:[["twoheadrightarrow"],.888,334,"xMaxYMin"],overleftrightarrow:[["leftarrow","rightarrow"],.888,522],overbrace:[["leftbrace","midbrace","rightbrace"],1.6,548],underbrace:[["leftbraceunder","midbraceunder","rightbraceunder"],1.6,548],underleftrightarrow:[["leftarrow","rightarrow"],.888,522],xleftrightarrow:[["leftarrow","rightarrow"],1.75,522],xLeftrightarrow:[["doubleleftarrow","doublerightarrow"],1.75,560],xrightleftharpoons:[["leftharpoondownplus","rightharpoonplus"],1.75,716],xleftrightharpoons:[["leftharpoonplus","rightharpoondownplus"],1.75,716],xhookleftarrow:[["leftarrow","righthook"],1.08,522],xhookrightarrow:[["lefthook","rightarrow"],1.08,522],overlinesegment:[["leftlinesegment","rightlinesegment"],.888,522],underlinesegment:[["leftlinesegment","rightlinesegment"],.888,522],overgroup:[["leftgroup","rightgroup"],.888,342],undergroup:[["leftgroupunder","rightgroupunder"],.888,342],xmapsto:[["leftmapsto","rightarrow"],1.5,522],xtofrom:[["leftToFrom","rightToFrom"],1.75,528]};var g=function e(t){if(t.type==="ordgroup"){return t.value.length}else{return 1}};var b=function e(t,r){function a(){var e=4e5;var a=t.value.label.substr(1);if(c.default.contains(["widehat","widetilde","utilde"],a)){var i=g(t.value.base);var u=void 0;var s=void 0;var f=void 0;if(i>5){u=a==="widehat"?420:312;e=a==="widehat"?2364:2340;f=a==="widehat"?.42:.34;s=(a==="widehat"?"widehat":"tilde")+"4"}else{var d=[1,1,2,2,3,3][i];if(a==="widehat"){e=[0,1062,2364,2364,2364][d];u=[0,239,300,360,420][d];f=[0,.24,.3,.3,.36,.42][d];s="widehat"+d}else{e=[0,600,1033,2339,2340][d];u=[0,260,286,306,312][d];f=[0,.26,.286,.3,.306,.34][d];s="tilde"+d}}var h=new l.default.pathNode(s);var v=new l.default.svgNode([h],{width:"100%",height:f+"em",viewBox:"0 0 "+e+" "+u,preserveAspectRatio:"none"});return{span:o.default.makeSpan([],[v],r),minWidth:0,height:f}}else{var p=[];var b=(0,n.default)(m[a],4),y=b[0],x=b[1],w=b[2],M=b[3];var k=w/1e3;var _=y.length;var S=void 0;var T=void 0;if(_===1){S=["hide-tail"];T=[M]}else if(_===2){S=["halfarrow-left","halfarrow-right"];T=["xMinYMin","xMaxYMin"]}else if(_===3){S=["brace-left","brace-center","brace-right"];T=["xMinYMin","xMidYMin","xMaxYMin"]}else{throw new Error("Correct katexImagesData or update code here to support\n                    "+_+" children.")}for(var z=0;z<_;z++){var C=new l.default.pathNode(y[z]);var A=new l.default.svgNode([C],{width:"400em",height:k+"em",viewBox:"0 0 "+e+" "+w,preserveAspectRatio:T[z]+" slice"});var O=o.default.makeSpan([S[z]],[A],r);if(_===1){return{span:O,minWidth:x,height:k}}else{O.style.height=k+"em";p.push(O)}}return{span:o.default.makeSpan(["stretchy"],p,r),minWidth:x,height:k}}}var i=a(),u=i.span,s=i.minWidth,f=i.height;u.height=f;u.style.height=f+"em";if(s>0){u.style.minWidth=s+"em"}return u};var y=function e(t,r,a,n){var i=void 0;var u=t.height+t.depth+2*a;if(/fbox|color/.test(r)){i=o.default.makeSpan(["stretchy",r],[],n);if(r==="fbox"){var s=n.color&&n.getColor();if(s){i.style.borderColor=s}}}else{var f=[];if(/^[bx]cancel$/.test(r)){f.push(new l.default.lineNode({x1:"0",y1:"0",x2:"100%",y2:"100%","stroke-width":"0.046em"}))}if(/^x?cancel$/.test(r)){f.push(new l.default.lineNode({x1:"0",y1:"100%",x2:"100%",y2:"0","stroke-width":"0.046em"}))}var d=new l.default.svgNode(f,{width:"100%",height:u+"em"});i=o.default.makeSpan([],[d],n)}i.height=u;i.style.height=u+"em";return i};var x=function e(t,r,a){var n=[];var i=void 0;if(t==="vertical-separator"){for(var u=0;u<2;u++){n.push(new l.default.lineNode({x1:"5",y1:"0",x2:"5",y2:"10","stroke-width":"2"}))}i=new l.default.svgNode(n,{width:"0.25em",height:"100%",viewBox:"0 0 10 10",preserveAspectRatio:"none"})}else{for(var s=0;s<2;s++){n.push(new l.default.lineNode({x1:"0",y1:"5",x2:"10",y2:"5","stroke-width":"2"}))}i=new l.default.svgNode(n,{width:"100%",height:5*r+"em",viewBox:"0 0 10 10",preserveAspectRatio:"none"})}return o.default.makeSpan([t],[i],a)};r.default={encloseSpan:y,mathMLnode:p,ruleSpan:x,svgSpan:b}},{"./buildCommon":91,"./domTree":98,"./mathMLTree":124,"./utils":133,"babel-runtime/helpers/slicedToArray":10}],127:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a={sqrtMain:"M95 622c-2.667 0-7.167-2.667-13.5\n-8S72 604 72 600c0-2 .333-3.333 1-4 1.333-2.667 23.833-20.667 67.5-54s\n65.833-50.333 66.5-51c1.333-1.333 3-2 5-2 4.667 0 8.667 3.333 12 10l173\n378c.667 0 35.333-71 104-213s137.5-285 206.5-429S812 17.333 812 14c5.333\n-9.333 12-14 20-14h399166v40H845.272L620 507 385 993c-2.667 4.667-9 7-19\n7-6 0-10-1-12-3L160 575l-65 47zM834 0h399166v40H845z",sqrtSize1:"M263 601c.667 0 18 39.667 52 119s68.167\n 158.667 102.5 238 51.833 119.333 52.5 120C810 373.333 980.667 17.667 982 11\nc4.667-7.333 11-11 19-11h398999v40H1012.333L741 607c-38.667 80.667-84 175-136\n 283s-89.167 185.333-111.5 232-33.833 70.333-34.5 71c-4.667 4.667-12.333 7-23\n 7l-12-1-109-253c-72.667-168-109.333-252-110-252-10.667 8-22 16.667-34 26-22\n 17.333-33.333 26-34 26l-26-26 76-59 76-60zM1001 0h398999v40H1012z",sqrtSize2:"M1001 0h398999v40H1013.084S929.667 308 749\n 880s-277 876.333-289 913c-4.667 4.667-12.667 7-24 7h-12c-1.333-3.333-3.667\n-11.667-7-25-35.333-125.333-106.667-373.333-214-744-10 12-21 25-33 39l-32 39\nc-6-5.333-15-14-27-26l25-30c26.667-32.667 52-63 76-91l52-60 208 722c56-175.333\n 126.333-397.333 211-666s153.833-488.167 207.5-658.5C944.167 129.167 975 32.667\n 983 10c4-6.667 10-10 18-10zm0 0h398999v40H1013z",sqrtSize3:"M424 2398c-1.333-.667-38.5-172-111.5-514 S202.667 1370.667 202\n 1370c0-2-10.667 14.333-32 49-4.667 7.333-9.833 15.667-15.5 25s-9.833 16-12.5\n 20l-5 7c-4-3.333-8.333-7.667-13-13l-13-13 76-122 77-121 209 968c0-2 84.667\n-361.667 254-1079C896.333 373.667 981.667 13.333 983 10c4-6.667 10-10 18-10\nh398999v40H1014.622S927.332 418.667 742 1206c-185.333 787.333-279.333 1182.333\n-282 1185-2 6-10 9-24 9-8 0-12-.667-12-2zM1001 0h398999v40H1014z",sqrtSize4:"M473 2713C812.333 913.667 982.333 13 983 11c3.333-7.333 9.333\n-11 18-11h399110v40H1017.698S927.168 518 741.5 1506C555.833 2494 462 2989 460\n 2991c-2 6-10 9-24 9-8 0-12-.667-12-2s-5.333-32-16-92c-50.667-293.333-119.667\n-693.333-207-1200 0-1.333-5.333 8.667-16 30l-32 64-16 33-26-26 76-153 77-151\nc.667.667 35.667 202 105 604 67.333 400.667 102 602.667 104 606z\nM1001 0h398999v40H1017z",doubleleftarrow:"M262 157\nl10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3\n 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28\n 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5\nc2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5\n 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87\n-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7\n-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z\nm8 0v40h399730v-40zm0 194v40h399730v-40z",doublerightarrow:"M399738 392l\n-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5\n 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88\n-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68\n-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18\n-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782\nc-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3\n-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z",leftarrow:"M400000 241H110l3-3c68.7-52.7 113.7-120\n 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8\n-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247\nc-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208\n 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3\n 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202\n l-3-3h399890zM100 241v40h399900v-40z",leftbrace:"M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117\n-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7\n 5-6 9-10 13-.7 1-7.3 1-20 1H6z",leftbraceunder:"M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13\n 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688\n 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7\n-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z",leftgroup:"M400000 80\nH435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0\n 435 0h399565z",leftgroupunder:"M400000 262\nH435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219\n 435 219h399565z",leftharpoon:"M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3\n-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5\n-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7\n-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z",
leftharpoonplus:"M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5\n 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3\n-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7\n-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z\nm0 0v40h400000v-40z",leftharpoondown:"M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333\n 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5\n 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667\n-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z",leftharpoondownplus:"M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12\n 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7\n-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0\nv40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z",lefthook:"M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5\n-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3\n-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21\n 71.5 23h399859zM103 281v-40h399897v40z",leftlinesegment:"M40 281 V428 H0 V94 H40 V241 H400000 v40z\nM40 281 V428 H0 V94 H40 V241 H400000 v40z",leftmapsto:"M40 281 V448H0V74H40V241H400000v40z\nM40 281 V448H0V74H40V241H400000v40z",leftToFrom:"M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23\n-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8\nc28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3\n 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z",longequal:"M0 50 h400000 v40H0z m0 194h40000v40H0z\nM0 50 h400000 v40H0z m0 194h40000v40H0z",midbrace:"M200428 334\nc-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14\n-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7\n 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11\n 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z",midbraceunder:"M199572 214\nc100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14\n 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3\n 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0\n-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z",rightarrow:"M0 241v40h399891c-47.3 35.3-84 78-110 128\n-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20\n 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7\n 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85\n-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n 151.7 139 205zm0 0v40h399900v-40z",rightbrace:"M400000 542l\n-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5\ns-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1\nc124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z",rightbraceunder:"M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3\n 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237\n-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z",rightgroup:"M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0\n 3-1 3-3v-38c-76-158-257-219-435-219H0z",rightgroupunder:"M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18\n 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z",rightharpoon:"M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3\n-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2\n-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58\n 69.2 92 94.5zm0 0v40h399900v-40z",rightharpoonplus:"M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11\n-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7\n 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z\nm0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z",rightharpoondown:"M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8\n 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5\n-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95\n-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z",rightharpoondownplus:"M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8\n 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3\n 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3\n-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z\nm0-194v40h400000v-40zm0 0v40h400000v-40z",righthook:"M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3\n 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0\n-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21\n 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z",rightlinesegment:"M399960 241 V94 h40 V428 h-40 V281 H0 v-40z\nM399960 241 V94 h40 V428 h-40 V281 H0 v-40z",rightToFrom:"M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23\n 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32\n-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142\n-167z M100 147v40h399900v-40zM0 341v40h399900v-40z",twoheadleftarrow:"M0 167c68 40\n 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69\n-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3\n-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19\n-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101\n 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z",twoheadrightarrow:"M400000 167\nc-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3\n 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42\n 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333\n-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70\n 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z",tilde1:"M200 55.538c-77 0-168 73.953-177 73.953-3 0-7\n-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0\n 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0\n 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128\n-68.267.847-113-73.952-191-73.952z",tilde2:"M344 55.266c-142 0-300.638 81.316-311.5 86.418\n-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9\n 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114\nc1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751\n 181.476 676 181.476c-149 0-189-126.21-332-126.21z",tilde3:"M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457\n-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0\n 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697\n 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696\n -338 0-409-156.573-744-156.573z",tilde4:"M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345\n-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409\n 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9\n 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409\n -175.236-744-175.236z",vec:"M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5\n3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11\n10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63\n-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1\n-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59\nH213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359\nc-16-25.333-24-45-24-59z",widehat1:"M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22\nc-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z",widehat2:"M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",widehat3:"M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",widehat4:"M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z"};r.default={path:a}},{}],128:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a={math:{},text:{}};r.default=a;function n(e,t,r,n,i,l){a[e][i]={font:t,group:r,replace:n};if(l&&n){a[e][n]=a[e][i]}}var i="math";var l="text";var u="main";var o="ams";var s="accent";var f="bin";var d="close";var c="inner";var h="mathord";var v="op";var p="open";var m="punct";var g="rel";var b="spacing";var y="textord";n(i,u,g,"\u2261","\\equiv",true);n(i,u,g,"\u227a","\\prec",true);n(i,u,g,"\u227b","\\succ",true);n(i,u,g,"\u223c","\\sim",true);n(i,u,g,"\u22a5","\\perp");n(i,u,g,"\u2aaf","\\preceq",true);n(i,u,g,"\u2ab0","\\succeq",true);n(i,u,g,"\u2243","\\simeq",true);n(i,u,g,"\u2223","\\mid",true);n(i,u,g,"\u226a","\\ll");n(i,u,g,"\u226b","\\gg",true);n(i,u,g,"\u224d","\\asymp",true);n(i,u,g,"\u2225","\\parallel");n(i,u,g,"\u22c8","\\bowtie",true);n(i,u,g,"\u2323","\\smile",true);n(i,u,g,"\u2291","\\sqsubseteq",true);n(i,u,g,"\u2292","\\sqsupseteq",true);n(i,u,g,"\u2250","\\doteq",true);n(i,u,g,"\u2322","\\frown",true);n(i,u,g,"\u220b","\\ni",true);n(i,u,g,"\u221d","\\propto",true);n(i,u,g,"\u22a2","\\vdash",true);n(i,u,g,"\u22a3","\\dashv",true);n(i,u,g,"\u220b","\\owns");n(i,u,m,".","\\ldotp");n(i,u,m,"\u22c5","\\cdotp");n(i,u,y,"#","\\#");n(l,u,y,"#","\\#");n(i,u,y,"&","\\&");n(l,u,y,"&","\\&");n(i,u,y,"\u2135","\\aleph",true);n(i,u,y,"\u2200","\\forall",true);n(i,u,y,"\u210f","\\hbar");n(i,u,y,"\u2203","\\exists",true);n(i,u,y,"\u2207","\\nabla",true);n(i,u,y,"\u266d","\\flat",true);n(i,u,y,"\u2113","\\ell",true);n(i,u,y,"\u266e","\\natural",true);n(i,u,y,"\u2663","\\clubsuit",true);n(i,u,y,"\u2118","\\wp",true);n(i,u,y,"\u266f","\\sharp",true);n(i,u,y,"\u2662","\\diamondsuit",true);n(i,u,y,"\u211c","\\Re",true);n(i,u,y,"\u2661","\\heartsuit",true);n(i,u,y,"\u2111","\\Im",true);n(i,u,y,"\u2660","\\spadesuit",true);n(i,u,y,"\u2020","\\dag");n(l,u,y,"\u2020","\\dag");n(l,u,y,"\u2020","\\textdagger");n(i,u,y,"\u2021","\\ddag");n(l,u,y,"\u2021","\\ddag");n(l,u,y,"\u2020","\\textdaggerdbl");n(i,u,d,"\u23b1","\\rmoustache");n(i,u,p,"\u23b0","\\lmoustache");n(i,u,d,"\u27ef","\\rgroup");n(i,u,p,"\u27ee","\\lgroup");n(i,u,f,"\u2213","\\mp",true);n(i,u,f,"\u2296","\\ominus",true);n(i,u,f,"\u228e","\\uplus",true);n(i,u,f,"\u2293","\\sqcap",true);n(i,u,f,"\u2217","\\ast");n(i,u,f,"\u2294","\\sqcup",true);n(i,u,f,"\u25ef","\\bigcirc");n(i,u,f,"\u2219","\\bullet");n(i,u,f,"\u2021","\\ddagger");n(i,u,f,"\u2240","\\wr",true);n(i,u,f,"\u2a3f","\\amalg");n(i,u,f,"&","\\And");n(i,u,g,"\u27f5","\\longleftarrow",true);n(i,u,g,"\u21d0","\\Leftarrow",true);n(i,u,g,"\u27f8","\\Longleftarrow",true);n(i,u,g,"\u27f6","\\longrightarrow",true);n(i,u,g,"\u21d2","\\Rightarrow",true);n(i,u,g,"\u27f9","\\Longrightarrow",true);n(i,u,g,"\u2194","\\leftrightarrow",true);n(i,u,g,"\u27f7","\\longleftrightarrow",true);n(i,u,g,"\u21d4","\\Leftrightarrow",true);n(i,u,g,"\u27fa","\\Longleftrightarrow",true);n(i,u,g,"\u21a6","\\mapsto",true);n(i,u,g,"\u27fc","\\longmapsto",true);n(i,u,g,"\u2197","\\nearrow",true);n(i,u,g,"\u21a9","\\hookleftarrow",true);n(i,u,g,"\u21aa","\\hookrightarrow",true);n(i,u,g,"\u2198","\\searrow",true);n(i,u,g,"\u21bc","\\leftharpoonup",true);n(i,u,g,"\u21c0","\\rightharpoonup",true);n(i,u,g,"\u2199","\\swarrow",true);n(i,u,g,"\u21bd","\\leftharpoondown",true);n(i,u,g,"\u21c1","\\rightharpoondown",true);n(i,u,g,"\u2196","\\nwarrow",true);n(i,u,g,"\u21cc","\\rightleftharpoons",true);n(i,o,g,"\u226e","\\nless",true);n(i,o,g,"\ue010","\\nleqslant");n(i,o,g,"\ue011","\\nleqq");n(i,o,g,"\u2a87","\\lneq",true);n(i,o,g,"\u2268","\\lneqq",true);n(i,o,g,"\ue00c","\\lvertneqq");n(i,o,g,"\u22e6","\\lnsim",true);n(i,o,g,"\u2a89","\\lnapprox",true);n(i,o,g,"\u2280","\\nprec",true);n(i,o,g,"\u22e0","\\npreceq",true);n(i,o,g,"\u22e8","\\precnsim",true);n(i,o,g,"\u2ab9","\\precnapprox",true);n(i,o,g,"\u2241","\\nsim",true);n(i,o,g,"\ue006","\\nshortmid");n(i,o,g,"\u2224","\\nmid",true);n(i,o,g,"\u22ac","\\nvdash",true);n(i,o,g,"\u22ad","\\nvDash",true);n(i,o,g,"\u22ea","\\ntriangleleft");n(i,o,g,"\u22ec","\\ntrianglelefteq",true);n(i,o,g,"\u228a","\\subsetneq",true);n(i,o,g,"\ue01a","\\varsubsetneq");n(i,o,g,"\u2acb","\\subsetneqq",true);n(i,o,g,"\ue017","\\varsubsetneqq");n(i,o,g,"\u226f","\\ngtr",true);n(i,o,g,"\ue00f","\\ngeqslant");n(i,o,g,"\ue00e","\\ngeqq");n(i,o,g,"\u2a88","\\gneq",true);n(i,o,g,"\u2269","\\gneqq",true);n(i,o,g,"\ue00d","\\gvertneqq");n(i,o,g,"\u22e7","\\gnsim",true);n(i,o,g,"\u2a8a","\\gnapprox",true);n(i,o,g,"\u2281","\\nsucc",true);n(i,o,g,"\u22e1","\\nsucceq",true);n(i,o,g,"\u22e9","\\succnsim",true);n(i,o,g,"\u2aba","\\succnapprox",true);n(i,o,g,"\u2246","\\ncong",true);n(i,o,g,"\ue007","\\nshortparallel");n(i,o,g,"\u2226","\\nparallel",true);n(i,o,g,"\u22af","\\nVDash",true);n(i,o,g,"\u22eb","\\ntriangleright");n(i,o,g,"\u22ed","\\ntrianglerighteq",true);n(i,o,g,"\ue018","\\nsupseteqq");n(i,o,g,"\u228b","\\supsetneq",true);n(i,o,g,"\ue01b","\\varsupsetneq");n(i,o,g,"\u2acc","\\supsetneqq",true);n(i,o,g,"\ue019","\\varsupsetneqq");n(i,o,g,"\u22ae","\\nVdash",true);n(i,o,g,"\u2ab5","\\precneqq",true);n(i,o,g,"\u2ab6","\\succneqq",true);n(i,o,g,"\ue016","\\nsubseteqq");n(i,o,f,"\u22b4","\\unlhd");n(i,o,f,"\u22b5","\\unrhd");n(i,o,g,"\u219a","\\nleftarrow",true);n(i,o,g,"\u219b","\\nrightarrow",true);n(i,o,g,"\u21cd","\\nLeftarrow",true);n(i,o,g,"\u21cf","\\nRightarrow",true);n(i,o,g,"\u21ae","\\nleftrightarrow",true);n(i,o,g,"\u21ce","\\nLeftrightarrow",true);n(i,o,g,"\u25b3","\\vartriangle");n(i,o,y,"\u210f","\\hslash");n(i,o,y,"\u25bd","\\triangledown");n(i,o,y,"\u25ca","\\lozenge");n(i,o,y,"\u24c8","\\circledS");n(i,o,y,"\xae","\\circledR");n(l,o,y,"\xae","\\circledR");n(i,o,y,"\u2221","\\measuredangle",true);n(i,o,y,"\u2204","\\nexists");n(i,o,y,"\u2127","\\mho");n(i,o,y,"\u2132","\\Finv",true);n(i,o,y,"\u2141","\\Game",true);n(i,o,y,"k","\\Bbbk");n(i,o,y,"\u2035","\\backprime");n(i,o,y,"\u25b2","\\blacktriangle");n(i,o,y,"\u25bc","\\blacktriangledown");n(i,o,y,"\u25a0","\\blacksquare");n(i,o,y,"\u29eb","\\blacklozenge");n(i,o,y,"\u2605","\\bigstar");n(i,o,y,"\u2222","\\sphericalangle",true);n(i,o,y,"\u2201","\\complement",true);n(i,o,y,"\xf0","\\eth",true);n(i,o,y,"\u2571","\\diagup");n(i,o,y,"\u2572","\\diagdown");n(i,o,y,"\u25a1","\\square");n(i,o,y,"\u25a1","\\Box");n(i,o,y,"\u25ca","\\Diamond");n(i,o,y,"\xa5","\\yen",true);n(i,o,y,"\u2713","\\checkmark",true);n(l,o,y,"\u2713","\\checkmark");n(i,o,y,"\u2136","\\beth",true);n(i,o,y,"\u2138","\\daleth",true);n(i,o,y,"\u2137","\\gimel",true);n(i,o,y,"\u03dd","\\digamma");n(i,o,y,"\u03f0","\\varkappa");n(i,o,p,"\u250c","\\ulcorner");n(i,o,d,"\u2510","\\urcorner");n(i,o,p,"\u2514","\\llcorner");n(i,o,d,"\u2518","\\lrcorner");n(i,o,g,"\u2266","\\leqq",true);n(i,o,g,"\u2a7d","\\leqslant");n(i,o,g,"\u2a95","\\eqslantless",true);n(i,o,g,"\u2272","\\lesssim");n(i,o,g,"\u2a85","\\lessapprox");n(i,o,g,"\u224a","\\approxeq",true);n(i,o,f,"\u22d6","\\lessdot");n(i,o,g,"\u22d8","\\lll");n(i,o,g,"\u2276","\\lessgtr");n(i,o,g,"\u22da","\\lesseqgtr");n(i,o,g,"\u2a8b","\\lesseqqgtr");n(i,o,g,"\u2251","\\doteqdot");n(i,o,g,"\u2253","\\risingdotseq",true);n(i,o,g,"\u2252","\\fallingdotseq",true);n(i,o,g,"\u223d","\\backsim",true);n(i,o,g,"\u22cd","\\backsimeq",true);n(i,o,g,"\u2ac5","\\subseteqq",true);n(i,o,g,"\u22d0","\\Subset",true);n(i,o,g,"\u228f","\\sqsubset",true);n(i,o,g,"\u227c","\\preccurlyeq",true);n(i,o,g,"\u22de","\\curlyeqprec",true);n(i,o,g,"\u227e","\\precsim",true);n(i,o,g,"\u2ab7","\\precapprox",true);n(i,o,g,"\u22b2","\\vartriangleleft");n(i,o,g,"\u22b4","\\trianglelefteq");n(i,o,g,"\u22a8","\\vDash");n(i,o,g,"\u22aa","\\Vvdash",true);n(i,o,g,"\u2323","\\smallsmile");n(i,o,g,"\u2322","\\smallfrown");n(i,o,g,"\u224f","\\bumpeq",true);n(i,o,g,"\u224e","\\Bumpeq",true);n(i,o,g,"\u2267","\\geqq",true);n(i,o,g,"\u2a7e","\\geqslant",true);n(i,o,g,"\u2a96","\\eqslantgtr",true);n(i,o,g,"\u2273","\\gtrsim",true);n(i,o,g,"\u2a86","\\gtrapprox",true);n(i,o,f,"\u22d7","\\gtrdot");n(i,o,g,"\u22d9","\\ggg",true);n(i,o,g,"\u2277","\\gtrless",true);n(i,o,g,"\u22db","\\gtreqless",true);n(i,o,g,"\u2a8c","\\gtreqqless",true);n(i,o,g,"\u2256","\\eqcirc",true);n(i,o,g,"\u2257","\\circeq",true);n(i,o,g,"\u225c","\\triangleq",true);n(i,o,g,"\u223c","\\thicksim");n(i,o,g,"\u2248","\\thickapprox");n(i,o,g,"\u2ac6","\\supseteqq",true);n(i,o,g,"\u22d1","\\Supset",true);n(i,o,g,"\u2290","\\sqsupset",true);n(i,o,g,"\u227d","\\succcurlyeq",true);n(i,o,g,"\u22df","\\curlyeqsucc",true);n(i,o,g,"\u227f","\\succsim",true);n(i,o,g,"\u2ab8","\\succapprox",true);n(i,o,g,"\u22b3","\\vartriangleright");n(i,o,g,"\u22b5","\\trianglerighteq");n(i,o,g,"\u22a9","\\Vdash",true);n(i,o,g,"\u2223","\\shortmid");n(i,o,g,"\u2225","\\shortparallel");n(i,o,g,"\u226c","\\between",true);n(i,o,g,"\u22d4","\\pitchfork",true);n(i,o,g,"\u221d","\\varpropto");n(i,o,g,"\u25c0","\\blacktriangleleft");n(i,o,g,"\u2234","\\therefore",true);n(i,o,g,"\u220d","\\backepsilon");n(i,o,g,"\u25b6","\\blacktriangleright");n(i,o,g,"\u2235","\\because",true);n(i,o,g,"\u22d8","\\llless");n(i,o,g,"\u22d9","\\gggtr");n(i,o,f,"\u22b2","\\lhd");n(i,o,f,"\u22b3","\\rhd");n(i,o,g,"\u2242","\\eqsim",true);n(i,u,g,"\u22c8","\\Join");n(i,o,g,"\u2251","\\Doteq",true);n(i,o,f,"\u2214","\\dotplus",true);n(i,o,f,"\u2216","\\smallsetminus");n(i,o,f,"\u22d2","\\Cap",true);n(i,o,f,"\u22d3","\\Cup",true);n(i,o,f,"\u2a5e","\\doublebarwedge",true);n(i,o,f,"\u229f","\\boxminus",true);n(i,o,f,"\u229e","\\boxplus",true);n(i,o,f,"\u22c7","\\divideontimes",true);n(i,o,f,"\u22c9","\\ltimes",true);n(i,o,f,"\u22ca","\\rtimes",true);n(i,o,f,"\u22cb","\\leftthreetimes",true);n(i,o,f,"\u22cc","\\rightthreetimes",true);n(i,o,f,"\u22cf","\\curlywedge",true);n(i,o,f,"\u22ce","\\curlyvee",true);n(i,o,f,"\u229d","\\circleddash",true);n(i,o,f,"\u229b","\\circledast",true);n(i,o,f,"\u22c5","\\centerdot");n(i,o,f,"\u22ba","\\intercal",true);n(i,o,f,"\u22d2","\\doublecap");n(i,o,f,"\u22d3","\\doublecup");n(i,o,f,"\u22a0","\\boxtimes",true);n(i,o,g,"\u21e2","\\dashrightarrow",true);n(i,o,g,"\u21e0","\\dashleftarrow",true);n(i,o,g,"\u21c7","\\leftleftarrows",true);n(i,o,g,"\u21c6","\\leftrightarrows",true);n(i,o,g,"\u21da","\\Lleftarrow",true);n(i,o,g,"\u219e","\\twoheadleftarrow",true);n(i,o,g,"\u21a2","\\leftarrowtail",true);n(i,o,g,"\u21ab","\\looparrowleft",true);n(i,o,g,"\u21cb","\\leftrightharpoons",true);n(i,o,g,"\u21b6","\\curvearrowleft",true);n(i,o,g,"\u21ba","\\circlearrowleft",true);n(i,o,g,"\u21b0","\\Lsh",true);n(i,o,g,"\u21c8","\\upuparrows",true);n(i,o,g,"\u21bf","\\upharpoonleft",true);n(i,o,g,"\u21c3","\\downharpoonleft",true);n(i,o,g,"\u22b8","\\multimap",true);n(i,o,g,"\u21ad","\\leftrightsquigarrow",true);n(i,o,g,"\u21c9","\\rightrightarrows",true);n(i,o,g,"\u21c4","\\rightleftarrows",true);n(i,o,g,"\u21a0","\\twoheadrightarrow",true);n(i,o,g,"\u21a3","\\rightarrowtail",true);n(i,o,g,"\u21ac","\\looparrowright",true);n(i,o,g,"\u21b7","\\curvearrowright",true);n(i,o,g,"\u21bb","\\circlearrowright",true);n(i,o,g,"\u21b1","\\Rsh",true);n(i,o,g,"\u21ca","\\downdownarrows",true);n(i,o,g,"\u21be","\\upharpoonright",true);n(i,o,g,"\u21c2","\\downharpoonright",true);n(i,o,g,"\u21dd","\\rightsquigarrow",true);n(i,o,g,"\u21dd","\\leadsto");n(i,o,g,"\u21db","\\Rrightarrow",true);n(i,o,g,"\u21be","\\restriction");n(i,u,y,"\u2018","`");n(i,u,y,"$","\\$");n(l,u,y,"$","\\$");n(l,u,y,"$","\\textdollar");n(i,u,y,"%","\\%");n(l,u,y,"%","\\%");n(i,u,y,"_","\\_");n(l,u,y,"_","\\_");n(l,u,y,"_","\\textunderscore");n(i,u,y,"\u2220","\\angle",true);n(i,u,y,"\u221e","\\infty",true);n(i,u,y,"\u2032","\\prime");n(i,u,y,"\u25b3","\\triangle");n(i,u,y,"\u0393","\\Gamma",true);n(i,u,y,"\u0394","\\Delta",true);n(i,u,y,"\u0398","\\Theta",true);n(i,u,y,"\u039b","\\Lambda",true);n(i,u,y,"\u039e","\\Xi",true);n(i,u,y,"\u03a0","\\Pi",true);n(i,u,y,"\u03a3","\\Sigma",true);n(i,u,y,"\u03a5","\\Upsilon",true);n(i,u,y,"\u03a6","\\Phi",true);n(i,u,y,"\u03a8","\\Psi",true);n(i,u,y,"\u03a9","\\Omega",true);n(i,u,y,"\xac","\\neg");n(i,u,y,"\xac","\\lnot");n(i,u,y,"\u22a4","\\top");n(i,u,y,"\u22a5","\\bot");n(i,u,y,"\u2205","\\emptyset");n(i,o,y,"\u2205","\\varnothing");n(i,u,h,"\u03b1","\\alpha",true);n(i,u,h,"\u03b2","\\beta",true);n(i,u,h,"\u03b3","\\gamma",true);n(i,u,h,"\u03b4","\\delta",true);n(i,u,h,"\u03f5","\\epsilon",true);n(i,u,h,"\u03b6","\\zeta",true);n(i,u,h,"\u03b7","\\eta",true);n(i,u,h,"\u03b8","\\theta",true);n(i,u,h,"\u03b9","\\iota",true);n(i,u,h,"\u03ba","\\kappa",true);n(i,u,h,"\u03bb","\\lambda",true);n(i,u,h,"\u03bc","\\mu",true);n(i,u,h,"\u03bd","\\nu",true);n(i,u,h,"\u03be","\\xi",true);n(i,u,h,"\u03bf","\\omicron",true);n(i,u,h,"\u03c0","\\pi",true);n(i,u,h,"\u03c1","\\rho",true);n(i,u,h,"\u03c3","\\sigma",true);n(i,u,h,"\u03c4","\\tau",true);n(i,u,h,"\u03c5","\\upsilon",true);n(i,u,h,"\u03d5","\\phi",true);n(i,u,h,"\u03c7","\\chi",true);n(i,u,h,"\u03c8","\\psi",true);n(i,u,h,"\u03c9","\\omega",true);n(i,u,h,"\u03b5","\\varepsilon",true);n(i,u,h,"\u03d1","\\vartheta",true);n(i,u,h,"\u03d6","\\varpi",true);n(i,u,h,"\u03f1","\\varrho",true);n(i,u,h,"\u03c2","\\varsigma",true);n(i,u,h,"\u03c6","\\varphi",true);n(i,u,f,"\u2217","*");n(i,u,f,"+","+");n(i,u,f,"\u2212","-");n(i,u,f,"\u22c5","\\cdot",true);n(i,u,f,"\u2218","\\circ");n(i,u,f,"\xf7","\\div",true);n(i,u,f,"\xb1","\\pm",true);n(i,u,f,"\xd7","\\times",true);n(i,u,f,"\u2229","\\cap",true);n(i,u,f,"\u222a","\\cup",true);n(i,u,f,"\u2216","\\setminus");n(i,u,f,"\u2227","\\land");n(i,u,f,"\u2228","\\lor");n(i,u,f,"\u2227","\\wedge",true);n(i,u,f,"\u2228","\\vee",true);n(i,u,y,"\u221a","\\surd");n(i,u,p,"(","(");n(i,u,p,"[","[");n(i,u,p,"\u27e8","\\langle");n(i,u,p,"\u2223","\\lvert");n(i,u,p,"\u2225","\\lVert");n(i,u,d,")",")");n(i,u,d,"]","]");n(i,u,d,"?","?");n(i,u,d,"!","!");n(i,u,d,"\u27e9","\\rangle");n(i,u,d,"\u2223","\\rvert");n(i,u,d,"\u2225","\\rVert");n(i,u,g,"=","=");n(i,u,g,"<","<");n(i,u,g,">",">");n(i,u,g,":",":");n(i,u,g,"\u2248","\\approx",true);n(i,u,g,"\u2245","\\cong",true);n(i,u,g,"\u2265","\\ge");n(i,u,g,"\u2265","\\geq",true);n(i,u,g,"\u2190","\\gets");n(i,u,g,">","\\gt");n(i,u,g,"\u2208","\\in",true);n(i,u,g,"\u2209","\\notin",true);n(i,u,g,"\u0338","\\not");n(i,u,g,"\u2282","\\subset",true);n(i,u,g,"\u2283","\\supset",true);n(i,u,g,"\u2286","\\subseteq",true);n(i,u,g,"\u2287","\\supseteq",true);n(i,o,g,"\u2288","\\nsubseteq",true);n(i,o,g,"\u2289","\\nsupseteq",true);n(i,u,g,"\u22a8","\\models");n(i,u,g,"\u2190","\\leftarrow",true);n(i,u,g,"\u2264","\\le");n(i,u,g,"\u2264","\\leq",true);n(i,u,g,"<","\\lt");n(i,u,g,"\u2260","\\ne",true);n(i,u,g,"\u2260","\\neq");n(i,u,g,"\u2192","\\rightarrow",true);n(i,u,g,"\u2192","\\to");n(i,o,g,"\u2271","\\ngeq",true);n(i,o,g,"\u2270","\\nleq",true);n(i,u,b,null,"\\!");n(i,u,b,"\xa0","\\ ");n(i,u,b,"\xa0","~");n(i,u,b,null,"\\,");n(i,u,b,null,"\\:");n(i,u,b,null,"\\;");n(i,u,b,null,"\\enspace");n(i,u,b,null,"\\qquad");n(i,u,b,null,"\\quad");n(i,u,b,"\xa0","\\space");n(i,u,m,",",",");n(i,u,m,";",";");n(i,u,m,":","\\colon");n(i,o,f,"\u22bc","\\barwedge",true);n(i,o,f,"\u22bb","\\veebar",true);n(i,u,f,"\u2299","\\odot",true);n(i,u,f,"\u2295","\\oplus",true);n(i,u,f,"\u2297","\\otimes",true);n(i,u,y,"\u2202","\\partial",true);n(i,u,f,"\u2298","\\oslash",true);n(i,o,f,"\u229a","\\circledcirc",true);n(i,o,f,"\u22a1","\\boxdot",true);n(i,u,f,"\u25b3","\\bigtriangleup");n(i,u,f,"\u25bd","\\bigtriangledown");n(i,u,f,"\u2020","\\dagger");n(i,u,f,"\u22c4","\\diamond");n(i,u,f,"\u22c6","\\star");n(i,u,f,"\u25c3","\\triangleleft");n(i,u,f,"\u25b9","\\triangleright");n(i,u,p,"{","\\{");n(l,u,y,"{","\\{");n(l,u,y,"{","\\textbraceleft");n(i,u,d,"}","\\}");n(l,u,y,"}","\\}");n(l,u,y,"}","\\textbraceright");n(i,u,p,"{","\\lbrace");n(i,u,d,"}","\\rbrace");n(i,u,p,"[","\\lbrack");n(i,u,d,"]","\\rbrack");n(l,u,y,"<","\\textless");n(l,u,y,">","\\textgreater");n(i,u,p,"\u230a","\\lfloor");n(i,u,d,"\u230b","\\rfloor");n(i,u,p,"\u2308","\\lceil");n(i,u,d,"\u2309","\\rceil");n(i,u,y,"\\","\\backslash");n(i,u,y,"\u2223","|");n(i,u,y,"\u2223","\\vert");n(l,u,y,"|","\\textbar");n(i,u,y,"\u2225","\\|");n(i,u,y,"\u2225","\\Vert");n(l,u,y,"\u2225","\\textbardbl");n(i,u,g,"\u2191","\\uparrow",true);n(i,u,g,"\u21d1","\\Uparrow",true);n(i,u,g,"\u2193","\\downarrow",true);n(i,u,g,"\u21d3","\\Downarrow",true);n(i,u,g,"\u2195","\\updownarrow",true);n(i,u,g,"\u21d5","\\Updownarrow",true);n(i,u,v,"\u2210","\\coprod");n(i,u,v,"\u22c1","\\bigvee");n(i,u,v,"\u22c0","\\bigwedge");n(i,u,v,"\u2a04","\\biguplus");n(i,u,v,"\u22c2","\\bigcap");n(i,u,v,"\u22c3","\\bigcup");n(i,u,v,"\u222b","\\int");n(i,u,v,"\u222b","\\intop");n(i,u,v,"\u222c","\\iint");n(i,u,v,"\u222d","\\iiint");n(i,u,v,"\u220f","\\prod");n(i,u,v,"\u2211","\\sum");n(i,u,v,"\u2a02","\\bigotimes");n(i,u,v,"\u2a01","\\bigoplus");n(i,u,v,"\u2a00","\\bigodot");n(i,u,v,"\u222e","\\oint");n(i,u,v,"\u2a06","\\bigsqcup");n(i,u,v,"\u222b","\\smallint");n(l,u,c,"\u2026","\\textellipsis");n(i,u,c,"\u2026","\\mathellipsis");n(l,u,c,"\u2026","\\ldots",true);n(i,u,c,"\u2026","\\ldots",true);n(i,u,c,"\u22ef","\\@cdots",true);n(i,u,c,"\u22f1","\\ddots",true);n(i,u,y,"\u22ee","\\vdots",true);n(i,u,s,"\xb4","\\acute");n(i,u,s,"`","\\grave");n(i,u,s,"\xa8","\\ddot");n(i,u,s,"~","\\tilde");n(i,u,s,"\xaf","\\bar");n(i,u,s,"\u02d8","\\breve");n(i,u,s,"\u02c7","\\check");n(i,u,s,"^","\\hat");n(i,u,s,"\u20d7","\\vec");n(i,u,s,"\u02d9","\\dot");n(i,u,h,"\u0131","\\imath",true);n(i,u,h,"\u0237","\\jmath",true);n(l,u,y,"\u0131","\\i",true);n(l,u,y,"\u0237","\\j",true);n(l,u,y,"\xdf","\\ss",true);n(l,u,y,"\xe6","\\ae",true);n(l,u,y,"\xe6","\\ae",true);n(l,u,y,"\u0153","\\oe",true);n(l,u,y,"\xf8","\\o",true);n(l,u,y,"\xc6","\\AE",true);n(l,u,y,"\u0152","\\OE",true);n(l,u,y,"\xd8","\\O",true);n(l,u,s,"\u02ca","\\'");n(l,u,s,"\u02cb","\\`");n(l,u,s,"\u02c6","\\^");n(l,u,s,"\u02dc","\\~");n(l,u,s,"\u02c9","\\=");n(l,u,s,"\u02d8","\\u");n(l,u,s,"\u02d9","\\.");n(l,u,s,"\u02da","\\r");n(l,u,s,"\u02c7","\\v");n(l,u,s,"\xa8",'\\"');n(l,u,s,"\u030b","\\H");n(l,u,y,"\u2013","--");n(l,u,y,"\u2013","\\textendash");n(l,u,y,"\u2014","---");n(l,u,y,"\u2014","\\textemdash");n(l,u,y,"\u2018","`");n(l,u,y,"\u2018","\\textquoteleft");n(l,u,y,"\u2019","'");n(l,u,y,"\u2019","\\textquoteright");n(l,u,y,"\u201c","``");n(l,u,y,"\u201c","\\textquotedblleft");n(l,u,y,"\u201d","''");n(l,u,y,"\u201d","\\textquotedblright");n(i,u,y,"\xb0","\\degree");n(l,u,y,"\xb0","\\degree");n(i,u,h,"\xa3","\\pounds");n(i,u,h,"\xa3","\\mathsterling",true);n(l,u,h,"\xa3","\\pounds");n(l,u,h,"\xa3","\\textsterling",true);n(i,o,y,"\u2720","\\maltese");n(l,o,y,"\u2720","\\maltese");n(l,u,b,"\xa0","\\ ");n(l,u,b,"\xa0"," ");n(l,u,b,"\xa0","~");var x='0123456789/@."';for(var w=0;w<x.length;w++){var M=x.charAt(w);n(i,u,y,M,M)}var k='0123456789!@*()-=+[]<>|";:?/.,';for(var _=0;_<k.length;_++){var S=k.charAt(_);n(l,u,y,S,S)}var T="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";for(var z=0;z<T.length;z++){var C=T.charAt(z);n(i,u,h,C,C);n(l,u,y,C,C)}var A="\xc7\xd0\xde\xe7\xf0\xfe";for(var O=0;O<A.length;O++){var L=A.charAt(O);n(i,u,h,L,L);n(l,u,y,L,L)}var N="\xc5\xe5";for(var E=0;E<N.length;E++){var j=N.charAt(E);n(i,u,h,j,j)}for(var B=1040;B<=1103;B++){var P=String.fromCharCode(B);n(l,u,y,P,P)}n(l,u,y,"\u2013","\u2013");n(l,u,y,"\u2014","\u2014");n(l,u,y,"\u2018","\u2018");n(l,u,y,"\u2019","\u2019");n(l,u,y,"\u201c","\u201c");n(l,u,y,"\u201d","\u201d")},{}],129:[function(e,t,r){"use strict";t.exports={"\u0301":{text:"\\'",math:"\\acute"},"\u0300":{text:"\\`",math:"\\grave"},"\u0308":{text:'\\"',math:"\\ddot"},"\u0303":{text:"\\~",math:"\\tilde"},"\u0304":{text:"\\=",math:"\\bar"},"\u0306":{text:"\\u",math:"\\breve"},"\u030c":{text:"\\v",math:"\\check"},"\u0302":{text:"\\^",math:"\\hat"},"\u0307":{text:"\\.",math:"\\dot"},"\u030a":{text:"\\r"},"\u030b":{text:"\\H"}}},{}],130:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/toConsumableArray");var n=u(a);var i=e("babel-runtime/core-js/get-iterator");var l=u(i);r.scriptFromCodepoint=s;r.supportedCodepoint=d;function u(e){return e&&e.__esModule?e:{default:e}}var o=[{name:"cjk",blocks:[[12288,12543],[19968,40879],[65280,65376]]},{name:"hangul",blocks:[[44032,55215]]},{name:"brahmic",blocks:[[2304,4255]]}];function s(e){var t=true;var r=false;var a=undefined;try{for(var n=(0,l.default)(o),i;!(t=(i=n.next()).done);t=true){var u=i.value;var s=true;var f=false;var d=undefined;try{for(var c=(0,l.default)(u.blocks),h;!(s=(h=c.next()).done);s=true){var v=h.value;if(e>=v[0]&&e<=v[1]){return u.name}}}catch(e){f=true;d=e}finally{try{if(!s&&c.return){c.return()}}finally{if(f){throw d}}}}}catch(e){r=true;a=e}finally{try{if(!t&&n.return){n.return()}}finally{if(r){throw a}}}return null}var f=[];o.forEach(function(e){return e.blocks.forEach(function(e){return f.push.apply(f,(0,n.default)(e))})});function d(e){for(var t=0;t<f.length;t+=2){if(e>=f[t]&&e<=f[t+1]){return true}}return false}},{"babel-runtime/core-js/get-iterator":3,"babel-runtime/helpers/toConsumableArray":11}],131:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.default={"\xe1":"a\u0301","\xe0":"a\u0300","\xe4":"a\u0308","\u01df":"a\u0308\u0304","\xe3":"a\u0303","\u0101":"a\u0304","\u0103":"a\u0306","\u1eaf":"a\u0306\u0301","\u1eb1":"a\u0306\u0300","\u1eb5":"a\u0306\u0303","\u01ce":"a\u030c","\xe2":"a\u0302","\u1ea5":"a\u0302\u0301","\u1ea7":"a\u0302\u0300","\u1eab":"a\u0302\u0303","\u0227":"a\u0307","\u01e1":"a\u0307\u0304","\xe5":"a\u030a","\u01fb":"a\u030a\u0301","\u1e03":"b\u0307","\u0107":"c\u0301","\u010d":"c\u030c","\u0109":"c\u0302","\u010b":"c\u0307","\u010f":"d\u030c","\u1e0b":"d\u0307","\xe9":"e\u0301","\xe8":"e\u0300","\xeb":"e\u0308","\u1ebd":"e\u0303","\u0113":"e\u0304","\u1e17":"e\u0304\u0301","\u1e15":"e\u0304\u0300","\u0115":"e\u0306","\u011b":"e\u030c","\xea":"e\u0302","\u1ebf":"e\u0302\u0301","\u1ec1":"e\u0302\u0300","\u1ec5":"e\u0302\u0303","\u0117":"e\u0307","\u1e1f":"f\u0307","\u01f5":"g\u0301","\u1e21":"g\u0304","\u011f":"g\u0306","\u01e7":"g\u030c","\u011d":"g\u0302","\u0121":"g\u0307","\u1e27":"h\u0308","\u021f":"h\u030c","\u0125":"h\u0302","\u1e23":"h\u0307","\xed":"i\u0301","\xec":"i\u0300","\xef":"i\u0308","\u1e2f":"i\u0308\u0301","\u0129":"i\u0303","\u012b":"i\u0304","\u012d":"i\u0306","\u01d0":"i\u030c","\xee":"i\u0302","\u01f0":"j\u030c","\u0135":"j\u0302","\u1e31":"k\u0301","\u01e9":"k\u030c","\u013a":"l\u0301","\u013e":"l\u030c","\u1e3f":"m\u0301","\u1e41":"m\u0307","\u0144":"n\u0301","\u01f9":"n\u0300","\xf1":"n\u0303","\u0148":"n\u030c","\u1e45":"n\u0307","\xf3":"o\u0301","\xf2":"o\u0300","\xf6":"o\u0308","\u022b":"o\u0308\u0304","\xf5":"o\u0303","\u1e4d":"o\u0303\u0301","\u1e4f":"o\u0303\u0308","\u022d":"o\u0303\u0304","\u014d":"o\u0304","\u1e53":"o\u0304\u0301","\u1e51":"o\u0304\u0300","\u014f":"o\u0306","\u01d2":"o\u030c","\xf4":"o\u0302","\u1ed1":"o\u0302\u0301","\u1ed3":"o\u0302\u0300","\u1ed7":"o\u0302\u0303","\u022f":"o\u0307","\u0231":"o\u0307\u0304","\u0151":"o\u030b","\u1e55":"p\u0301","\u1e57":"p\u0307","\u0155":"r\u0301","\u0159":"r\u030c","\u1e59":"r\u0307","\u015b":"s\u0301","\u1e65":"s\u0301\u0307","\u0161":"s\u030c","\u1e67":"s\u030c\u0307","\u015d":"s\u0302","\u1e61":"s\u0307","\u1e97":"t\u0308","\u0165":"t\u030c","\u1e6b":"t\u0307","\xfa":"u\u0301","\xf9":"u\u0300","\xfc":"u\u0308","\u01d8":"u\u0308\u0301","\u01dc":"u\u0308\u0300","\u01d6":"u\u0308\u0304","\u01da":"u\u0308\u030c",
"\u0169":"u\u0303","\u1e79":"u\u0303\u0301","\u016b":"u\u0304","\u1e7b":"u\u0304\u0308","\u016d":"u\u0306","\u01d4":"u\u030c","\xfb":"u\u0302","\u016f":"u\u030a","\u0171":"u\u030b","\u1e7d":"v\u0303","\u1e83":"w\u0301","\u1e81":"w\u0300","\u1e85":"w\u0308","\u0175":"w\u0302","\u1e87":"w\u0307","\u1e98":"w\u030a","\u1e8d":"x\u0308","\u1e8b":"x\u0307","\xfd":"y\u0301","\u1ef3":"y\u0300","\xff":"y\u0308","\u1ef9":"y\u0303","\u0233":"y\u0304","\u0177":"y\u0302","\u1e8f":"y\u0307","\u1e99":"y\u030a","\u017a":"z\u0301","\u017e":"z\u030c","\u1e91":"z\u0302","\u017c":"z\u0307","\xc1":"A\u0301","\xc0":"A\u0300","\xc4":"A\u0308","\u01de":"A\u0308\u0304","\xc3":"A\u0303","\u0100":"A\u0304","\u0102":"A\u0306","\u1eae":"A\u0306\u0301","\u1eb0":"A\u0306\u0300","\u1eb4":"A\u0306\u0303","\u01cd":"A\u030c","\xc2":"A\u0302","\u1ea4":"A\u0302\u0301","\u1ea6":"A\u0302\u0300","\u1eaa":"A\u0302\u0303","\u0226":"A\u0307","\u01e0":"A\u0307\u0304","\xc5":"A\u030a","\u01fa":"A\u030a\u0301","\u1e02":"B\u0307","\u0106":"C\u0301","\u010c":"C\u030c","\u0108":"C\u0302","\u010a":"C\u0307","\u010e":"D\u030c","\u1e0a":"D\u0307","\xc9":"E\u0301","\xc8":"E\u0300","\xcb":"E\u0308","\u1ebc":"E\u0303","\u0112":"E\u0304","\u1e16":"E\u0304\u0301","\u1e14":"E\u0304\u0300","\u0114":"E\u0306","\u011a":"E\u030c","\xca":"E\u0302","\u1ebe":"E\u0302\u0301","\u1ec0":"E\u0302\u0300","\u1ec4":"E\u0302\u0303","\u0116":"E\u0307","\u1e1e":"F\u0307","\u01f4":"G\u0301","\u1e20":"G\u0304","\u011e":"G\u0306","\u01e6":"G\u030c","\u011c":"G\u0302","\u0120":"G\u0307","\u1e26":"H\u0308","\u021e":"H\u030c","\u0124":"H\u0302","\u1e22":"H\u0307","\xcd":"I\u0301","\xcc":"I\u0300","\xcf":"I\u0308","\u1e2e":"I\u0308\u0301","\u0128":"I\u0303","\u012a":"I\u0304","\u012c":"I\u0306","\u01cf":"I\u030c","\xce":"I\u0302","\u0130":"I\u0307","\u0134":"J\u0302","\u1e30":"K\u0301","\u01e8":"K\u030c","\u0139":"L\u0301","\u013d":"L\u030c","\u1e3e":"M\u0301","\u1e40":"M\u0307","\u0143":"N\u0301","\u01f8":"N\u0300","\xd1":"N\u0303","\u0147":"N\u030c","\u1e44":"N\u0307","\xd3":"O\u0301","\xd2":"O\u0300","\xd6":"O\u0308","\u022a":"O\u0308\u0304","\xd5":"O\u0303","\u1e4c":"O\u0303\u0301","\u1e4e":"O\u0303\u0308","\u022c":"O\u0303\u0304","\u014c":"O\u0304","\u1e52":"O\u0304\u0301","\u1e50":"O\u0304\u0300","\u014e":"O\u0306","\u01d1":"O\u030c","\xd4":"O\u0302","\u1ed0":"O\u0302\u0301","\u1ed2":"O\u0302\u0300","\u1ed6":"O\u0302\u0303","\u022e":"O\u0307","\u0230":"O\u0307\u0304","\u0150":"O\u030b","\u1e54":"P\u0301","\u1e56":"P\u0307","\u0154":"R\u0301","\u0158":"R\u030c","\u1e58":"R\u0307","\u015a":"S\u0301","\u1e64":"S\u0301\u0307","\u0160":"S\u030c","\u1e66":"S\u030c\u0307","\u015c":"S\u0302","\u1e60":"S\u0307","\u0164":"T\u030c","\u1e6a":"T\u0307","\xda":"U\u0301","\xd9":"U\u0300","\xdc":"U\u0308","\u01d7":"U\u0308\u0301","\u01db":"U\u0308\u0300","\u01d5":"U\u0308\u0304","\u01d9":"U\u0308\u030c","\u0168":"U\u0303","\u1e78":"U\u0303\u0301","\u016a":"U\u0304","\u1e7a":"U\u0304\u0308","\u016c":"U\u0306","\u01d3":"U\u030c","\xdb":"U\u0302","\u016e":"U\u030a","\u0170":"U\u030b","\u1e7c":"V\u0303","\u1e82":"W\u0301","\u1e80":"W\u0300","\u1e84":"W\u0308","\u0174":"W\u0302","\u1e86":"W\u0307","\u1e8c":"X\u0308","\u1e8a":"X\u0307","\xdd":"Y\u0301","\u1ef2":"Y\u0300","\u0178":"Y\u0308","\u1ef8":"Y\u0303","\u0232":"Y\u0304","\u0176":"Y\u0302","\u1e8e":"Y\u0307","\u0179":"Z\u0301","\u017d":"Z\u030c","\u1e90":"Z\u0302","\u017b":"Z\u0307","\u03ac":"\u03b1\u0301","\u1f70":"\u03b1\u0300","\u1fb1":"\u03b1\u0304","\u1fb0":"\u03b1\u0306","\u03ad":"\u03b5\u0301","\u1f72":"\u03b5\u0300","\u03ae":"\u03b7\u0301","\u1f74":"\u03b7\u0300","\u03af":"\u03b9\u0301","\u1f76":"\u03b9\u0300","\u03ca":"\u03b9\u0308","\u0390":"\u03b9\u0308\u0301","\u1fd2":"\u03b9\u0308\u0300","\u1fd1":"\u03b9\u0304","\u1fd0":"\u03b9\u0306","\u03cc":"\u03bf\u0301","\u1f78":"\u03bf\u0300","\u03cd":"\u03c5\u0301","\u1f7a":"\u03c5\u0300","\u03cb":"\u03c5\u0308","\u03b0":"\u03c5\u0308\u0301","\u1fe2":"\u03c5\u0308\u0300","\u1fe1":"\u03c5\u0304","\u1fe0":"\u03c5\u0306","\u03ce":"\u03c9\u0301","\u1f7c":"\u03c9\u0300","\u038e":"\u03a5\u0301","\u1fea":"\u03a5\u0300","\u03ab":"\u03a5\u0308","\u1fe9":"\u03a5\u0304","\u1fe8":"\u03a5\u0306","\u038f":"\u03a9\u0301","\u1ffa":"\u03a9\u0300"}},{}],132:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.calculateSize=r.validUnit=undefined;var a=e("./ParseError");var n=u(a);var i=e("./Options");var l=u(i);function u(e){return e&&e.__esModule?e:{default:e}}var o={pt:1,mm:7227/2540,cm:7227/254,in:72.27,bp:803/800,pc:12,dd:1238/1157,cc:14856/1157,nd:685/642,nc:1370/107,sp:1/65536,px:803/800};var s={ex:true,em:true,mu:true};var f=r.validUnit=function e(t){if(typeof t!=="string"){t=t.unit}return t in o||t in s||t==="ex"};var d=r.calculateSize=function e(t,r){var a=void 0;if(t.unit in o){a=o[t.unit]/r.fontMetrics().ptPerEm/r.sizeMultiplier}else if(t.unit==="mu"){a=r.fontMetrics().cssEmPerMu}else{var i=void 0;if(r.style.isTight()){i=r.havingStyle(r.style.text())}else{i=r}if(t.unit==="ex"){a=i.fontMetrics().xHeight}else if(t.unit==="em"){a=i.fontMetrics().quad}else{throw new n.default("Invalid unit: '"+t.unit+"'")}if(i!==r){a*=i.sizeMultiplier/r.sizeMultiplier}}return Math.min(t.number*a,r.maxSize)}},{"./Options":83,"./ParseError":84}],133:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=Array.prototype.indexOf;var n=function e(t,r){if(t==null){return-1}if(a&&t.indexOf===a){return t.indexOf(r)}var n=t.length;for(var i=0;i<n;i++){if(t[i]===r){return i}}return-1};var i=function e(t,r){return n(t,r)!==-1};var l=function e(t,r){return t===undefined?r:t};var u=/([A-Z])/g;var o=function e(t){return t.replace(u,"-$1").toLowerCase()};var s={"&":"&amp;",">":"&gt;","<":"&lt;",'"':"&quot;","'":"&#x27;"};var f=/[&><"']/g;function d(e){return String(e).replace(f,function(e){return s[e]})}var c=void 0;if(typeof document!=="undefined"){var h=document.createElement("span");if("textContent"in h){c=function e(t,r){t.textContent=r}}else{c=function e(t,r){t.innerText=r}}}function v(e){c(e,"")}var p=function e(t){if(!t){return false}else if(t.type==="ordgroup"){if(t.value.length===1){return e(t.value[0])}else{return t}}else if(t.type==="color"){if(t.value.value.length===1){return e(t.value.value[0])}else{return t}}else if(t.type==="font"){return e(t.value.body)}else{return t}};var m=function e(t){var r=p(t);return r.type==="mathord"||r.type==="textord"||r.type==="bin"||r.type==="rel"||r.type==="inner"||r.type==="open"||r.type==="close"||r.type==="punct"};r.default={contains:i,deflt:l,escape:d,hyphenate:o,indexOf:n,setTextContent:c,clearNode:v,getBaseElem:p,isCharacterBox:m}},{}]},{},[1])(1)});


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _global_actions = __webpack_require__(778);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WAIT_FOR_HEIGHT_TIMEOUT = 100; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MarkdownImage = function (_React$PureComponent) {
    (0, _inherits3.default)(MarkdownImage, _React$PureComponent);

    function MarkdownImage(props) {
        (0, _classCallCheck3.default)(this, MarkdownImage);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MarkdownImage.__proto__ || (0, _getPrototypeOf2.default)(MarkdownImage)).call(this, props));

        _this.waitForHeight = function () {
            if (_this.refs.image.height) {
                setTimeout(_global_actions.postListScrollChange, 0);

                _this.heightTimeout = 0;
            } else {
                _this.heightTimeout = setTimeout(_this.waitForHeight, WAIT_FOR_HEIGHT_TIMEOUT);
            }
        };

        _this.stopWaitingForHeight = function () {
            if (_this.heightTimeout !== 0) {
                clearTimeout(_this.heightTimeout);
                _this.heightTimeout = 0;
            }
        };

        _this.heightTimeout = 0;
        return _this;
    }

    (0, _createClass3.default)(MarkdownImage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.waitForHeight();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.href !== prevProps.href) {
                this.waitForHeight();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopWaitingForHeight();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('img', (0, _extends3.default)({}, this.props, {
                ref: 'image',
                onLoad: this.stopWaitingForHeight,
                onError: this.stopWaitingForHeight
            }));
        }
    }]);
    return MarkdownImage;
}(_react2.default.PureComponent);

MarkdownImage.propTypes = {

    /*
     * The href of the image to be loaded
     */
    href: _propTypes2.default.string
};
exports.default = MarkdownImage;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _users = __webpack_require__(777);

var _emoji_store = __webpack_require__(829);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

var _emojis = __webpack_require__(961);

var _post_emoji = __webpack_require__(1872);

var _post_emoji2 = _interopRequireDefault(_post_emoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var emojiMap = (0, _emojis.getEmojiMap)(state);
    var emoji = emojiMap.get(ownProps.name);

    var imageUrl = '';
    var displayTextOnly = false;
    if (emoji) {
        imageUrl = _emoji_store2.default.getEmojiImageUrl(emoji);
    } else {
        displayTextOnly = state.entities.emojis.nonExistentEmoji.has(ownProps.name) || (0, _general.getConfig)(state).EnableCustomEmoji !== 'true' || (0, _users.getCurrentUserId)(state) === '';
    }

    return {
        imageUrl: imageUrl,
        displayTextOnly: displayTextOnly
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_post_emoji2.default);

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PostEmoji = function (_React$PureComponent) {
    (0, _inherits3.default)(PostEmoji, _React$PureComponent);

    function PostEmoji() {
        (0, _classCallCheck3.default)(this, PostEmoji);
        return (0, _possibleConstructorReturn3.default)(this, (PostEmoji.__proto__ || (0, _getPrototypeOf2.default)(PostEmoji)).apply(this, arguments));
    }

    (0, _createClass3.default)(PostEmoji, [{
        key: 'render',
        value: function render() {
            var emojiText = ':' + this.props.name + ':';

            if (this.props.displayTextOnly) {
                return emojiText;
            }

            return _react2.default.createElement('span', {
                alt: emojiText,
                className: 'emoticon',
                title: emojiText,
                style: { backgroundImage: 'url(' + this.props.imageUrl + ')' }
            });
        }
    }]);
    return PostEmoji;
}(_react2.default.PureComponent);

PostEmoji.propTypes = {

    /*
     * Emoji name.
     */
    name: _propTypes2.default.string.isRequired,

    /*
     * Emoji image URL.
     */
    imageUrl: _propTypes2.default.string.isRequired,

    /*
     * Set to display the emoji text instead of the image.
     */
    displayTextOnly: _propTypes2.default.bool.isRequired
};
PostEmoji.defaultProps = {
    name: '',
    imageUrl: '',
    displayTextOnly: false
};
exports.default = PostEmoji;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _marked = __webpack_require__(1033);

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** A Markdown renderer that converts a post into plain text that we can search for mentions */
var MentionableRenderer = function (_marked$Renderer) {
    (0, _inherits3.default)(MentionableRenderer, _marked$Renderer);

    function MentionableRenderer() {
        (0, _classCallCheck3.default)(this, MentionableRenderer);
        return (0, _possibleConstructorReturn3.default)(this, (MentionableRenderer.__proto__ || (0, _getPrototypeOf2.default)(MentionableRenderer)).apply(this, arguments));
    }

    (0, _createClass3.default)(MentionableRenderer, [{
        key: 'code',
        value: function code() {
            // Code blocks can't contain mentions
            return '\n';
        }
    }, {
        key: 'blockquote',
        value: function blockquote(text) {
            return text + '\n';
        }
    }, {
        key: 'heading',
        value: function heading(text) {
            return text + '\n';
        }
    }, {
        key: 'hr',
        value: function hr() {
            return '\n';
        }
    }, {
        key: 'list',
        value: function list(body) {
            return body + '\n';
        }
    }, {
        key: 'listitem',
        value: function listitem(text) {
            return text + '\n';
        }
    }, {
        key: 'paragraph',
        value: function paragraph(text) {
            return text + '\n';
        }
    }, {
        key: 'table',
        value: function table(header, body) {
            return header + '\n' + body;
        }
    }, {
        key: 'tablerow',
        value: function tablerow(content) {
            return content;
        }
    }, {
        key: 'tablecell',
        value: function tablecell(content) {
            return content + '\n';
        }
    }, {
        key: 'strong',
        value: function strong(text) {
            return ' ' + text + ' ';
        }
    }, {
        key: 'em',
        value: function em(text) {
            return ' ' + text + ' ';
        }
    }, {
        key: 'codespan',
        value: function codespan() {
            // Code spans can't contain mentions
            return ' ';
        }
    }, {
        key: 'br',
        value: function br() {
            return '\n';
        }
    }, {
        key: 'del',
        value: function del(text) {
            return ' ' + text + ' ';
        }
    }, {
        key: 'link',
        value: function link(href, title, text) {
            return ' ' + text + ' ';
        }
    }, {
        key: 'image',
        value: function image(href, title, text) {
            return ' ' + text + ' ';
        }
    }, {
        key: 'text',
        value: function text(_text) {
            return _text;
        }
    }]);
    return MentionableRenderer;
}(_marked2.default.Renderer); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = MentionableRenderer;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/3812df668bb0144f7ae51853b202315b.mp3";

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d6014ee68e32b68c27d853075c2781d7.png";

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoggedInHFTRoute = exports.HFTRoute = undefined;

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

var _header_footer_template = __webpack_require__(1877);

var _header_footer_template2 = _interopRequireDefault(_header_footer_template);

var _logged_in = __webpack_require__(1177);

var _logged_in2 = _interopRequireDefault(_logged_in);

var _async_load = __webpack_require__(282);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HFTRoute = function HFTRoute(_ref) {
    var Component = _ref.component,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['component']);
    return _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
        render: function render(props) {
            return _react2.default.createElement(
                _async_load.AsyncComponent,
                (0, _extends3.default)({
                    doLoad: _header_footer_template2.default
                }, props),
                _react2.default.createElement(Component, props)
            );
        }
    }));
}; // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.HFTRoute = HFTRoute;
var LoggedInHFTRoute = function LoggedInHFTRoute(_ref2) {
    var Component = _ref2.component,
        rest = (0, _objectWithoutProperties3.default)(_ref2, ['component']);
    return _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
        render: function render(props) {
            return _react2.default.createElement(
                _async_load.AsyncComponent,
                (0, _extends3.default)({
                    doLoad: _logged_in2.default
                }, props),
                _react2.default.createElement(
                    _async_load.AsyncComponent,
                    (0, _extends3.default)({
                        doLoad: _header_footer_template2.default
                    }, props),
                    _react2.default.createElement(Component, props)
                )
            );
        }
    }));
};
exports.LoggedInHFTRoute = LoggedInHFTRoute;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(21).then((function(require) {
		cb(__webpack_require__(1878));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1884);
moment.tz.load(__webpack_require__(1886));


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.14
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(763)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.14",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 1180,
	"./af.js": 1180,
	"./ar": 1181,
	"./ar-dz": 1182,
	"./ar-dz.js": 1182,
	"./ar-kw": 1183,
	"./ar-kw.js": 1183,
	"./ar-ly": 1184,
	"./ar-ly.js": 1184,
	"./ar-ma": 1185,
	"./ar-ma.js": 1185,
	"./ar-sa": 1186,
	"./ar-sa.js": 1186,
	"./ar-tn": 1187,
	"./ar-tn.js": 1187,
	"./ar.js": 1181,
	"./az": 1188,
	"./az.js": 1188,
	"./be": 1189,
	"./be.js": 1189,
	"./bg": 1190,
	"./bg.js": 1190,
	"./bm": 1191,
	"./bm.js": 1191,
	"./bn": 1192,
	"./bn.js": 1192,
	"./bo": 1193,
	"./bo.js": 1193,
	"./br": 1194,
	"./br.js": 1194,
	"./bs": 1195,
	"./bs.js": 1195,
	"./ca": 1196,
	"./ca.js": 1196,
	"./cs": 1197,
	"./cs.js": 1197,
	"./cv": 1198,
	"./cv.js": 1198,
	"./cy": 1199,
	"./cy.js": 1199,
	"./da": 1200,
	"./da.js": 1200,
	"./de": 1201,
	"./de-at": 1202,
	"./de-at.js": 1202,
	"./de-ch": 1203,
	"./de-ch.js": 1203,
	"./de.js": 1201,
	"./dv": 1204,
	"./dv.js": 1204,
	"./el": 1205,
	"./el.js": 1205,
	"./en-au": 1206,
	"./en-au.js": 1206,
	"./en-ca": 1207,
	"./en-ca.js": 1207,
	"./en-gb": 1208,
	"./en-gb.js": 1208,
	"./en-ie": 1209,
	"./en-ie.js": 1209,
	"./en-il": 1210,
	"./en-il.js": 1210,
	"./en-nz": 1211,
	"./en-nz.js": 1211,
	"./eo": 1212,
	"./eo.js": 1212,
	"./es": 1213,
	"./es-do": 1214,
	"./es-do.js": 1214,
	"./es-us": 1215,
	"./es-us.js": 1215,
	"./es.js": 1213,
	"./et": 1216,
	"./et.js": 1216,
	"./eu": 1217,
	"./eu.js": 1217,
	"./fa": 1218,
	"./fa.js": 1218,
	"./fi": 1219,
	"./fi.js": 1219,
	"./fo": 1220,
	"./fo.js": 1220,
	"./fr": 1221,
	"./fr-ca": 1222,
	"./fr-ca.js": 1222,
	"./fr-ch": 1223,
	"./fr-ch.js": 1223,
	"./fr.js": 1221,
	"./fy": 1224,
	"./fy.js": 1224,
	"./gd": 1225,
	"./gd.js": 1225,
	"./gl": 1226,
	"./gl.js": 1226,
	"./gom-latn": 1227,
	"./gom-latn.js": 1227,
	"./gu": 1228,
	"./gu.js": 1228,
	"./he": 1229,
	"./he.js": 1229,
	"./hi": 1230,
	"./hi.js": 1230,
	"./hr": 1231,
	"./hr.js": 1231,
	"./hu": 1232,
	"./hu.js": 1232,
	"./hy-am": 1233,
	"./hy-am.js": 1233,
	"./id": 1234,
	"./id.js": 1234,
	"./is": 1235,
	"./is.js": 1235,
	"./it": 1236,
	"./it.js": 1236,
	"./ja": 1237,
	"./ja.js": 1237,
	"./jv": 1238,
	"./jv.js": 1238,
	"./ka": 1239,
	"./ka.js": 1239,
	"./kk": 1240,
	"./kk.js": 1240,
	"./km": 1241,
	"./km.js": 1241,
	"./kn": 1242,
	"./kn.js": 1242,
	"./ko": 1243,
	"./ko.js": 1243,
	"./ky": 1244,
	"./ky.js": 1244,
	"./lb": 1245,
	"./lb.js": 1245,
	"./lo": 1246,
	"./lo.js": 1246,
	"./lt": 1247,
	"./lt.js": 1247,
	"./lv": 1248,
	"./lv.js": 1248,
	"./me": 1249,
	"./me.js": 1249,
	"./mi": 1250,
	"./mi.js": 1250,
	"./mk": 1251,
	"./mk.js": 1251,
	"./ml": 1252,
	"./ml.js": 1252,
	"./mr": 1253,
	"./mr.js": 1253,
	"./ms": 1254,
	"./ms-my": 1255,
	"./ms-my.js": 1255,
	"./ms.js": 1254,
	"./mt": 1256,
	"./mt.js": 1256,
	"./my": 1257,
	"./my.js": 1257,
	"./nb": 1258,
	"./nb.js": 1258,
	"./ne": 1259,
	"./ne.js": 1259,
	"./nl": 1260,
	"./nl-be": 1261,
	"./nl-be.js": 1261,
	"./nl.js": 1260,
	"./nn": 1262,
	"./nn.js": 1262,
	"./pa-in": 1263,
	"./pa-in.js": 1263,
	"./pl": 1264,
	"./pl.js": 1264,
	"./pt": 1265,
	"./pt-br": 1266,
	"./pt-br.js": 1266,
	"./pt.js": 1265,
	"./ro": 1267,
	"./ro.js": 1267,
	"./ru": 1268,
	"./ru.js": 1268,
	"./sd": 1269,
	"./sd.js": 1269,
	"./se": 1270,
	"./se.js": 1270,
	"./si": 1271,
	"./si.js": 1271,
	"./sk": 1272,
	"./sk.js": 1272,
	"./sl": 1273,
	"./sl.js": 1273,
	"./sq": 1274,
	"./sq.js": 1274,
	"./sr": 1275,
	"./sr-cyrl": 1276,
	"./sr-cyrl.js": 1276,
	"./sr.js": 1275,
	"./ss": 1277,
	"./ss.js": 1277,
	"./sv": 1278,
	"./sv.js": 1278,
	"./sw": 1279,
	"./sw.js": 1279,
	"./ta": 1280,
	"./ta.js": 1280,
	"./te": 1281,
	"./te.js": 1281,
	"./tet": 1282,
	"./tet.js": 1282,
	"./tg": 1283,
	"./tg.js": 1283,
	"./th": 1284,
	"./th.js": 1284,
	"./tl-ph": 1285,
	"./tl-ph.js": 1285,
	"./tlh": 1286,
	"./tlh.js": 1286,
	"./tr": 1287,
	"./tr.js": 1287,
	"./tzl": 1288,
	"./tzl.js": 1288,
	"./tzm": 1289,
	"./tzm-latn": 1290,
	"./tzm-latn.js": 1290,
	"./tzm.js": 1289,
	"./ug-cn": 1291,
	"./ug-cn.js": 1291,
	"./uk": 1292,
	"./uk.js": 1292,
	"./ur": 1293,
	"./ur.js": 1293,
	"./uz": 1294,
	"./uz-latn": 1295,
	"./uz-latn.js": 1295,
	"./uz.js": 1294,
	"./vi": 1296,
	"./vi.js": 1296,
	"./x-pseudo": 1297,
	"./x-pseudo.js": 1297,
	"./yo": 1298,
	"./yo.js": 1298,
	"./zh-cn": 1299,
	"./zh-cn.js": 1299,
	"./zh-hk": 1300,
	"./zh-hk.js": 1300,
	"./zh-tw": 1301,
	"./zh-tw.js": 1301
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1885;

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

module.exports = {"version":"2017c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|01213454545454545454545454545454545454545454545454543|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _channels = __webpack_require__(798);

var _teams = __webpack_require__(816);

var _preferences = __webpack_require__(784);

var _reactRouterDom = __webpack_require__(269);

var _general = __webpack_require__(113);

var _route = __webpack_require__(1179);

var _needs_team = __webpack_require__(1888);

var _needs_team2 = _interopRequireDefault(_needs_team);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    return {
        theme: (0, _preferences.getTheme)(state),
        mfaRequired: (0, _route.checkIfMFARequired)(license, config, ownProps.match.url)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            fetchMyChannelsAndMembers: _channels.fetchMyChannelsAndMembers,
            getMyTeamUnreads: _teams.getMyTeamUnreads,
            viewChannel: _channels.viewChannel,
            markChannelAsRead: _channels.markChannelAsRead
        }, dispatch)
    };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_needs_team2.default));

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

var _inobounce = __webpack_require__(1889);

var _inobounce2 = _interopRequireDefault(_inobounce);

var _status_actions = __webpack_require__(955);

var _websocket_actions = __webpack_require__(1030);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _user_actions = __webpack_require__(781);

var _async_load = __webpack_require__(282);

var _backstage = __webpack_require__(1890);

var _backstage2 = _interopRequireDefault(_backstage);

var _channel_controller = __webpack_require__(1948);

var _channel_controller2 = _interopRequireDefault(_channel_controller);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackstageController = (0, _async_load.makeAsyncComponent)(_backstage2.default); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var wakeUpInterval = void 0;
var lastTime = new Date().getTime();
var WAKEUP_CHECK_INTERVAL = 30000; // 30 seconds
var WAKEUP_THRESHOLD = 60000; // 60 seconds
var UNREAD_CHECK_TIME_MILLISECONDS = 10000;

var NeedsTeam = function (_React$Component) {
    (0, _inherits3.default)(NeedsTeam, _React$Component);

    function NeedsTeam(params) {
        (0, _classCallCheck3.default)(this, NeedsTeam);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NeedsTeam.__proto__ || (0, _getPrototypeOf2.default)(NeedsTeam)).call(this, params));

        _this.shortcutKeyDown = function (e) {
            return _this.onShortcutKeyDown(e);
        };
        _this.updateCurrentTeam = _this.updateCurrentTeam.bind(_this);

        _this.blurTime = new Date().getTime();

        if (_this.props.mfaRequired) {
            _this.props.history.push('/mfa/setup');
            return (0, _possibleConstructorReturn3.default)(_this);
        }

        clearInterval(wakeUpInterval);

        wakeUpInterval = setInterval(function () {
            var currentTime = new Date().getTime();
            if (currentTime > lastTime + WAKEUP_THRESHOLD) {
                // ignore small delays
                console.log('computer woke up - fetching latest'); //eslint-disable-line no-console
                (0, _websocket_actions.reconnect)(false);
            }
            lastTime = currentTime;
        }, WAKEUP_CHECK_INTERVAL);

        var team = _this.updateCurrentTeam(_this.props);

        _this.state = {
            team: team,
            finishedFetchingChannels: false
        };
        return _this;
    }

    (0, _createClass3.default)(NeedsTeam, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.match.params.team !== nextProps.match.params.team) {
                this.setState({ team: this.updateCurrentTeam(nextProps) });
            }
        }
    }, {
        key: 'updateCurrentTeam',
        value: function updateCurrentTeam(props) {
            var _this2 = this;

            // First check to make sure you're in the current team
            // for the current url.
            var teamName = props.match.params.team;
            var team = _team_store2.default.getByName(teamName);

            if (!team) {
                props.history.push('/?redirect_to=' + encodeURIComponent(props.location.pathname));
                return null;
            }

            // If current team is set, then this is not first load
            // The first load action pulls team unreads
            if (_team_store2.default.getCurrentId()) {
                this.props.actions.getMyTeamUnreads();
            }

            _team_store2.default.saveMyTeam(team);
            _browser_store2.default.setGlobalItem('team', team.id);
            _team_store2.default.emitChange();
            GlobalActions.emitCloseRightHandSide();

            this.props.actions.fetchMyChannelsAndMembers(team.id).then(function () {
                _this2.setState({
                    finishedFetchingChannels: true
                });
            });

            (0, _status_actions.loadStatusesForChannelAndSidebar)();
            (0, _user_actions.loadProfilesForSidebar)();

            return team;
        }
    }, {
        key: 'onShortcutKeyDown',
        value: function onShortcutKeyDown(e) {
            if (e.shiftKey && Utils.cmdOrCtrlPressed(e) && Utils.isKeyPressed(e, _constants2.default.KeyCodes.L)) {
                if (document.getElementById('sidebar-right').className.match('sidebar--right sidebar--right--expanded')) {
                    document.getElementById('reply_textbox').focus();
                } else {
                    document.getElementById('post_textbox').focus();
                }
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            (0, _status_actions.startPeriodicStatusUpdates)();
            (0, _websocket_actions.startPeriodicSync)();

            // Set up tracking for whether the window is active
            window.isActive = true;
            (0, _jquery2.default)(window).on('focus', (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this3.props.actions.markChannelAsRead(_channel_store2.default.getCurrentId());

                            case 2:
                                _channel_store2.default.emitChange();
                                window.isActive = true;

                                if (new Date().getTime() - _this3.blurTime > UNREAD_CHECK_TIME_MILLISECONDS) {
                                    _this3.props.actions.fetchMyChannelsAndMembers(_team_store2.default.getCurrentId()).then(_user_actions.loadProfilesForSidebar);
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            })));

            (0, _jquery2.default)(window).on('blur', function () {
                window.isActive = false;
                _this3.blurTime = new Date().getTime();
                if (_user_store2.default.getCurrentUser()) {
                    _this3.props.actions.viewChannel('');
                }
            });

            Utils.applyTheme(this.props.theme);

            if (UserAgent.isIosSafari()) {
                // Use iNoBounce to prevent scrolling past the boundaries of the page
                _inobounce2.default.enable();
            }
            document.addEventListener('keydown', this.shortcutKeyDown);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)(window).off('focus');
            (0, _jquery2.default)(window).off('blur');

            if (UserAgent.isIosSafari()) {
                _inobounce2.default.disable();
            }
            (0, _status_actions.stopPeriodicStatusUpdates)();
            (0, _websocket_actions.stopPeriodicSync)();
            clearInterval(wakeUpInterval);
            document.removeEventListener('keydown', this.shortcutKeyDown);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var theme = this.props.theme;

            if (!Utils.areObjectsEqual(prevProps.theme, theme)) {
                Utils.applyTheme(theme);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.team === null || this.state.finishedFetchingChannels === false) {
                return _react2.default.createElement('div', null);
            }
            var teamType = this.state.team ? this.state.team.type : '';

            return _react2.default.createElement(
                _reactRouterDom.Switch,
                null,
                _react2.default.createElement(_reactRouterDom.Route, {
                    path: '/:team/integrations',
                    component: BackstageController
                }),
                _react2.default.createElement(_reactRouterDom.Route, {
                    path: '/:team/emoji',
                    component: BackstageController
                }),
                _react2.default.createElement(_reactRouterDom.Route, {
                    render: function render(renderProps) {
                        return _react2.default.createElement(_channel_controller2.default, {
                            pathName: renderProps.location.pathname,
                            teamType: teamType
                        });
                    }
                })
            );
        }
    }]);
    return NeedsTeam;
}(_react2.default.Component);

NeedsTeam.propTypes = {
    params: _propTypes2.default.object,
    actions: _propTypes2.default.shape({
        fetchMyChannelsAndMembers: _propTypes2.default.func.isRequired,
        getMyTeamUnreads: _propTypes2.default.func.isRequired,
        viewChannel: _propTypes2.default.func.isRequired,
        markChannelAsRead: _propTypes2.default.func.isRequired
    }).isRequired,
    theme: _propTypes2.default.object.isRequired,
    mfaRequired: _propTypes2.default.bool.isRequired,

    /*
     * Object from react-router
     */
    match: _propTypes2.default.shape({
        params: _propTypes2.default.shape({
            team: _propTypes2.default.string.isRequired
        }).isRequired
    }).isRequired
};
exports.default = NeedsTeam;

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

/*! iNoBounce - v0.1.0
* https://github.com/lazd/iNoBounce/
* Copyright (c) 2013 Larry Davis <lazdnet@gmail.com>; Licensed BSD */
(function(global) {
	// Stores the Y position where the touch started
	var startY = 0;

	// Store enabled status
	var enabled = false;

	var handleTouchmove = function(evt) {
		// Get the element that was scrolled upon
		var el = evt.target;

		// Check all parent elements for scrollability
		while (el !== document.body && el !== document) {
			// Get some style properties
			var style = window.getComputedStyle(el);

			if (!style) {
				// If we've encountered an element we can't compute the style for, get out
				break;
			}

			// Ignore range input element
			if (el.nodeName === 'INPUT' && el.getAttribute('type') === 'range') {
				return;
			}

			var scrolling = style.getPropertyValue('-webkit-overflow-scrolling');
			var overflowY = style.getPropertyValue('overflow-y');
			var height = parseInt(style.getPropertyValue('height'), 10);

			// Determine if the element should scroll
			var isScrollable = scrolling === 'touch' && (overflowY === 'auto' || overflowY === 'scroll');
			var canScroll = el.scrollHeight > el.offsetHeight;

			if (isScrollable && canScroll) {
				// Get the current Y position of the touch
				var curY = evt.touches ? evt.touches[0].screenY : evt.screenY;

				// Determine if the user is trying to scroll past the top or bottom
				// In this case, the window will bounce, so we have to prevent scrolling completely
				var isAtTop = (startY <= curY && el.scrollTop === 0);
				var isAtBottom = (startY >= curY && el.scrollHeight - el.scrollTop === height);

				// Stop a bounce bug when at the bottom or top of the scrollable element
				if (isAtTop || isAtBottom) {
					evt.preventDefault();
				}

				// No need to continue up the DOM, we've done our job
				return;
			}

			// Test the next parent
			el = el.parentNode;
		}

		// Stop the bouncing -- no parents are scrollable
		evt.preventDefault();
	};

	var handleTouchstart = function(evt) {
		// Store the first Y position of the touch
		startY = evt.touches ? evt.touches[0].screenY : evt.screenY;
	};

	var enable = function() {
		// Listen to a couple key touch events
		window.addEventListener('touchstart', handleTouchstart, false);
		window.addEventListener('touchmove', handleTouchmove, false);
		enabled = true;
	};

	var disable = function() {
		// Stop listening
		window.removeEventListener('touchstart', handleTouchstart, false);
		window.removeEventListener('touchmove', handleTouchmove, false);
		enabled = false;
	};

	var isEnabled = function() {
		return enabled;
	};

	// Enable by default if the browser supports -webkit-overflow-scrolling
	// Test this by setting the property with JavaScript on an element that exists in the DOM
	// Then, see if the property is reflected in the computed style
	var testDiv = document.createElement('div');
	document.documentElement.appendChild(testDiv);
	testDiv.style.WebkitOverflowScrolling = 'touch';
	var scrollSupport = 'getComputedStyle' in window && window.getComputedStyle(testDiv)['-webkit-overflow-scrolling'] === 'touch';
	document.documentElement.removeChild(testDiv);

	if (scrollSupport) {
		enable();
	}

	// A module to support enabling/disabling iNoBounce
	var iNoBounce = {
		enable: enable,
		disable: disable,
		isEnabled: isEnabled
	};

	if (typeof module !== 'undefined' && module.exports) {
		// Node.js Support
		module.exports = iNoBounce;
	}
	if (typeof global.define === 'function') {
		// AMD Support
		(function(define) {
			define('iNoBounce', [], function() { return iNoBounce; });
		}(global.define));
	}
	else {
		// Browser support
		global.iNoBounce = iNoBounce;
	}
}(this));


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(4).then((function(require) {
		cb(__webpack_require__(1891));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 1891 */,
/* 1892 */,
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _admin_actions = __webpack_require__(797);

var AdminActions = _interopRequireWildcard(_admin_actions);

var _analytics_store = __webpack_require__(964);

var _analytics_store2 = _interopRequireDefault(_analytics_store);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _constants = __webpack_require__(29);

var _license_utils = __webpack_require__(1894);

var _text_formatting = __webpack_require__(811);

var TextFormatting = _interopRequireWildcard(_text_formatting);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RENEWAL_LINK = 'https://licensing.mattermost.com/renew'; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var BAR_DEVELOPER_TYPE = 'developer';
var BAR_CRITICAL_TYPE = 'critical';
var BAR_ANNOUNCEMENT_TYPE = 'announcement';

var AnnouncementBar = function (_React$PureComponent) {
    (0, _inherits3.default)(AnnouncementBar, _React$PureComponent);

    function AnnouncementBar(props) {
        (0, _classCallCheck3.default)(this, AnnouncementBar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AnnouncementBar.__proto__ || (0, _getPrototypeOf2.default)(AnnouncementBar)).call(this, props));

        _this.setInitialError = function () {
            var errorIgnored = _error_store2.default.getIgnoreNotification();

            if (!errorIgnored) {
                if (_this.props.canViewSystemErrors && _this.props.siteURL === '') {
                    _error_store2.default.storeLastError({ notification: true, message: _constants.ErrorBarTypes.SITE_URL });
                    return;
                } else if (!_this.props.sendEmailNotifications) {
                    _error_store2.default.storeLastError({ notification: true, message: _constants.ErrorBarTypes.PREVIEW_MODE });
                    return;
                }
            }

            if ((0, _license_utils.isLicensePastGracePeriod)()) {
                if (_this.props.canViewSystemErrors) {
                    _error_store2.default.storeLastError({ notification: true, message: _constants.ErrorBarTypes.LICENSE_EXPIRED, type: BAR_CRITICAL_TYPE });
                } else {
                    _error_store2.default.storeLastError({ notification: true, message: _constants.ErrorBarTypes.LICENSE_PAST_GRACE, type: BAR_CRITICAL_TYPE });
                }
            } else if ((0, _license_utils.isLicenseExpired)() && _this.props.canViewSystemErrors) {
                _error_store2.default.storeLastError({ notification: true, message: _constants.ErrorBarTypes.LICENSE_EXPIRED, type: BAR_CRITICAL_TYPE });
            } else if ((0, _license_utils.isLicenseExpiring)() && _this.props.canViewSystemErrors) {
                _error_store2.default.storeLastError({ notification: true, message: _constants.ErrorBarTypes.LICENSE_EXPIRING, type: BAR_CRITICAL_TYPE });
            }
        };

        _this.onErrorChange = _this.onErrorChange.bind(_this);
        _this.onAnalyticsChange = _this.onAnalyticsChange.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);

        _error_store2.default.clearLastError(true);

        _this.setInitialError();

        _this.state = _this.getState();
        return _this;
    }

    (0, _createClass3.default)(AnnouncementBar, [{
        key: 'getState',
        value: function getState() {
            var error = _error_store2.default.getLastError();
            if (error && error.message) {
                return { message: error.message, color: null, textColor: null, type: error.type, allowDismissal: true };
            }

            var bannerText = this.props.bannerText || '';
            var allowDismissal = this.props.allowBannerDismissal;
            var bannerDismissed = localStorage.getItem(_constants.StoragePrefixes.ANNOUNCEMENT + this.props.bannerText);

            if (this.props.enableBanner && bannerText.length > 0 && (!bannerDismissed || !allowDismissal)) {
                // Remove old local storage items
                Utils.removePrefixFromLocalStorage(_constants.StoragePrefixes.ANNOUNCEMENT);
                return {
                    message: bannerText,
                    color: this.props.bannerColor,
                    textColor: this.props.bannerTextColor,
                    type: BAR_ANNOUNCEMENT_TYPE,
                    allowDismissal: allowDismissal
                };
            }

            return { message: null, color: null, colorText: null, textColor: null, type: null, allowDismissal: true };
        }
    }, {
        key: 'isValidState',
        value: function isValidState(s) {
            if (!s) {
                return false;
            }

            if (!s.message) {
                return false;
            }

            if (s.message === _constants.ErrorBarTypes.LICENSE_EXPIRING && !this.state.totalUsers) {
                return false;
            }

            return true;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isLoggedIn && !this.state.allowDismissal) {
                document.body.classList.add('error-bar--fixed');
            }

            _error_store2.default.addChangeListener(this.onErrorChange);
            _analytics_store2.default.addChangeListener(this.onAnalyticsChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.classList.remove('error-bar--fixed');
            _error_store2.default.removeChangeListener(this.onErrorChange);
            _analytics_store2.default.removeChangeListener(this.onAnalyticsChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!this.props.isLoggedIn) {
                return;
            }

            if (!prevState.allowDismissal && this.state.allowDismissal) {
                document.body.classList.remove('error-bar--fixed');
            } else if (prevState.allowDismissal && !this.state.allowDismissal) {
                document.body.classList.add('error-bar--fixed');
            }
        }
    }, {
        key: 'onErrorChange',
        value: function onErrorChange() {
            var newState = this.getState();
            if (newState.message === _constants.ErrorBarTypes.LICENSE_EXPIRING && !this.state.totalUsers) {
                AdminActions.getStandardAnalytics();
            }
            this.setState(newState);
        }
    }, {
        key: 'onAnalyticsChange',
        value: function onAnalyticsChange() {
            var stats = _analytics_store2.default.getAllSystem();
            this.setState({ totalUsers: stats[_constants.StatTypes.TOTAL_USERS] });
        }
    }, {
        key: 'handleClose',
        value: function handleClose(e) {
            if (e) {
                e.preventDefault();
            }

            if (this.state.type === BAR_ANNOUNCEMENT_TYPE) {
                localStorage.setItem(_constants.StoragePrefixes.ANNOUNCEMENT + this.state.message, true);
            }

            if (_error_store2.default.getLastError() && _error_store2.default.getLastError().notification) {
                _error_store2.default.clearNotificationError();
            } else {
                _error_store2.default.clearLastError();
            }

            this.setState(this.getState());
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.isValidState(this.state)) {
                return _react2.default.createElement('div', null);
            }

            if (!this.props.isLoggedIn && this.state.type === BAR_ANNOUNCEMENT_TYPE) {
                return _react2.default.createElement('div', null);
            }

            var errClass = 'error-bar';
            var dismissClass = ' error-bar--fixed';
            var barStyle = {};
            var linkStyle = {};
            if (this.state.color && this.state.textColor) {
                barStyle.backgroundColor = this.state.color;
                barStyle.color = this.state.textColor;
                linkStyle.color = this.state.textColor;
            } else if (this.state.type === BAR_DEVELOPER_TYPE) {
                errClass = 'error-bar error-bar-developer';
            } else if (this.state.type === BAR_CRITICAL_TYPE) {
                errClass = 'error-bar error-bar-critical';
            }

            var closeButton = void 0;
            if (this.state.allowDismissal) {
                dismissClass = '';
                closeButton = _react2.default.createElement(
                    'a',
                    {
                        href: '#',
                        className: 'error-bar__close',
                        style: linkStyle,
                        onClick: this.handleClose
                    },
                    '×'
                );
            }

            var renewalLink = RENEWAL_LINK + '?id=' + this.props.licenseId + '&user_count=' + this.state.totalUsers;

            var message = this.state.message;
            if (this.state.type === BAR_ANNOUNCEMENT_TYPE) {
                message = _react2.default.createElement('span', {
                    dangerouslySetInnerHTML: { __html: TextFormatting.formatText(message, { singleline: true, mentionHighlight: false }) }
                });
            } else if (message === _constants.ErrorBarTypes.PREVIEW_MODE) {
                message = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: _constants.ErrorBarTypes.PREVIEW_MODE,
                    defaultMessage: 'Preview Mode: Email notifications have not been configured'
                });
            } else if (message === _constants.ErrorBarTypes.LICENSE_EXPIRING) {
                message = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: _constants.ErrorBarTypes.LICENSE_EXPIRING,
                    defaultMessage: 'Enterprise license expires on {date}. <a href="{link}" target="_blank">Please renew</a>.',
                    values: {
                        date: (0, _license_utils.displayExpiryDate)(),
                        link: renewalLink
                    }
                });
            } else if (message === _constants.ErrorBarTypes.LICENSE_EXPIRED) {
                message = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: _constants.ErrorBarTypes.LICENSE_EXPIRED,
                    defaultMessage: 'Enterprise license is expired and some features may be disabled. <a href="{link}" target="_blank">Please renew</a>.',
                    values: {
                        link: renewalLink
                    }
                });
            } else if (message === _constants.ErrorBarTypes.LICENSE_PAST_GRACE) {
                message = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: _constants.ErrorBarTypes.LICENSE_PAST_GRACE,
                    defaultMessage: 'Enterprise license is expired and some features may be disabled. Please contact your System Administrator for details.'
                });
            } else if (message === _constants.ErrorBarTypes.WEBSOCKET_PORT_ERROR) {
                message = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: _constants.ErrorBarTypes.WEBSOCKET_PORT_ERROR,
                    defaultMessage: 'Please check connection, Mattermost unreachable. If issue persists, ask administrator to <a href="https://about.mattermost.com/default-websocket-port-help" target="_blank">check WebSocket port</a>.'
                });
            } else if (message === _constants.ErrorBarTypes.SITE_URL) {
                var id = void 0;
                var defaultMessage = void 0;
                if (this.props.enableSignUpWithGitLab) {
                    id = 'error_bar.site_url_gitlab';
                    defaultMessage = 'Please configure your {docsLink} in the System Console or in gitlab.rb if you\'re using GitLab Mattermost.';
                } else {
                    id = 'error_bar.site_url';
                    defaultMessage = 'Please configure your {docsLink} in the System Console.';
                }

                message = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: id,
                    defaultMessage: defaultMessage,
                    values: {
                        docsLink: _react2.default.createElement(
                            'a',
                            {
                                href: 'https://docs.mattermost.com/administration/config-settings.html#site-url',
                                rel: 'noopener noreferrer',
                                target: '_blank'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'error_bar.site_url.docsLink',
                                defaultMessage: 'Site URL'
                            })
                        ),
                        link: _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: '/admin_console/general/configuration' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'error_bar.site_url.link',
                                defaultMessage: 'the System Console'
                            })
                        )
                    }
                });
            }

            return _react2.default.createElement(
                'div',
                {
                    className: errClass + dismissClass,
                    style: barStyle
                },
                _react2.default.createElement(
                    'span',
                    null,
                    message
                ),
                closeButton
            );
        }
    }]);
    return AnnouncementBar;
}(_react2.default.PureComponent);

AnnouncementBar.propTypes = {

    /*
     * Set if the user is logged in
     */
    isLoggedIn: _propTypes2.default.bool.isRequired,

    /*
     * Set if the user can view system errors
     */
    canViewSystemErrors: _propTypes2.default.bool.isRequired,
    canViewAPIv3Banner: _propTypes2.default.bool.isRequired,
    licenseId: _propTypes2.default.string,
    siteURL: _propTypes2.default.string,
    sendEmailNotifications: _propTypes2.default.bool.isRequired,
    bannerText: _propTypes2.default.string,
    allowBannerDismissal: _propTypes2.default.bool.isRequired,
    enableBanner: _propTypes2.default.bool.isRequired,
    bannerColor: _propTypes2.default.string,
    bannerTextColor: _propTypes2.default.string,
    enableSignUpWithGitLab: _propTypes2.default.bool.isRequired
};
exports.default = AnnouncementBar;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLicenseExpiring = isLicenseExpiring;
exports.isLicenseExpired = isLicenseExpired;
exports.isLicensePastGracePeriod = isLicensePastGracePeriod;
exports.displayExpiryDate = displayExpiryDate;

var _general = __webpack_require__(113);

var _localization_store = __webpack_require__(906);

var _localization_store2 = _interopRequireDefault(_localization_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LICENSE_EXPIRY_NOTIFICATION = 1000 * 60 * 60 * 24 * 60; // 60 days
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
//
var LICENSE_GRACE_PERIOD = 1000 * 60 * 60 * 24 * 15; // 15 days

function isLicenseExpiring() {
    var license = (0, _general.getLicense)(_redux_store2.default.getState());
    if (license.IsLicensed !== 'true') {
        return false;
    }

    var timeDiff = parseInt(license.ExpiresAt, 10) - Date.now();
    return timeDiff <= LICENSE_EXPIRY_NOTIFICATION;
}

function isLicenseExpired() {
    var license = (0, _general.getLicense)(_redux_store2.default.getState());
    if (license.IsLicensed !== 'true') {
        return false;
    }

    var timeDiff = parseInt(license.ExpiresAt, 10) - Date.now();
    return timeDiff < 0;
}

function isLicensePastGracePeriod() {
    var license = (0, _general.getLicense)(_redux_store2.default.getState());
    if (license.IsLicensed !== 'true') {
        return false;
    }

    var timeDiff = Date.now() - parseInt(license.ExpiresAt, 10);
    return timeDiff > LICENSE_GRACE_PERIOD;
}

function displayExpiryDate() {
    var license = (0, _general.getLicense)(_redux_store2.default.getState());
    var date = new Date(parseInt(license.ExpiresAt, 10));
    return date.toLocaleString(_localization_store2.default.getLocale(), { year: 'numeric', month: 'long', day: 'numeric' });
}

/***/ }),
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SystemPermissionGate = function (_React$Component) {
    (0, _inherits3.default)(SystemPermissionGate, _React$Component);

    function SystemPermissionGate() {
        (0, _classCallCheck3.default)(this, SystemPermissionGate);
        return (0, _possibleConstructorReturn3.default)(this, (SystemPermissionGate.__proto__ || (0, _getPrototypeOf2.default)(SystemPermissionGate)).apply(this, arguments));
    }

    (0, _createClass3.default)(SystemPermissionGate, [{
        key: 'render',
        value: function render() {
            if (this.props.hasPermission && !this.props.invert) {
                return this.props.children;
            }
            if (!this.props.hasPermission && this.props.invert) {
                return this.props.children;
            }
            return null;
        }
    }]);
    return SystemPermissionGate;
}(_react2.default.Component);

SystemPermissionGate.defaultProps = {
    invert: false
};
SystemPermissionGate.propTypes = {

    /**
     * Permissions enough to pass the gate (binary OR)
     */
    permissions: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,

    /**
     * Has permission
     */
    hasPermission: _propTypes2.default.bool.isRequired,

    /**
     * Invert the permission (used for else)
     */
    invert: _propTypes2.default.bool.isRequired,

    /**
     * Content protected by the permissions gate
     */
    children: _propTypes2.default.node.isRequired
};
exports.default = SystemPermissionGate;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TeamPermissionGate = function (_React$Component) {
    (0, _inherits3.default)(TeamPermissionGate, _React$Component);

    function TeamPermissionGate() {
        (0, _classCallCheck3.default)(this, TeamPermissionGate);
        return (0, _possibleConstructorReturn3.default)(this, (TeamPermissionGate.__proto__ || (0, _getPrototypeOf2.default)(TeamPermissionGate)).apply(this, arguments));
    }

    (0, _createClass3.default)(TeamPermissionGate, [{
        key: 'render',
        value: function render() {
            if (this.props.hasPermission && !this.props.invert) {
                return this.props.children;
            }
            if (!this.props.hasPermission && this.props.invert) {
                return this.props.children;
            }
            return null;
        }
    }]);
    return TeamPermissionGate;
}(_react2.default.Component);

TeamPermissionGate.defaultProps = {
    invert: false
};
TeamPermissionGate.propTypes = {

    /**
     * Team to check the permission
     */
    teamId: _propTypes2.default.string,

    /**
     * Permissions enough to pass the gate (binary OR)
     */
    permissions: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,

    /**
     * Has permission
     */
    hasPermission: _propTypes2.default.bool.isRequired,

    /**
     * Invert the permission (used for else)
     */
    invert: _propTypes2.default.bool.isRequired,

    /**
     * Content protected by the permissions gate
     */
    children: _propTypes2.default.node.isRequired
};
exports.default = TeamPermissionGate;

/***/ }),
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(269);

var _pluggable = __webpack_require__(881);

var _pluggable2 = _interopRequireDefault(_pluggable);

var _announcement_bar = __webpack_require__(882);

var _announcement_bar2 = _interopRequireDefault(_announcement_bar);

var _edit_post_modal = __webpack_require__(1949);

var _edit_post_modal2 = _interopRequireDefault(_edit_post_modal);

var _get_post_link_modal = __webpack_require__(1978);

var _get_post_link_modal2 = _interopRequireDefault(_get_post_link_modal);

var _get_team_invite_link_modal = __webpack_require__(1980);

var _get_team_invite_link_modal2 = _interopRequireDefault(_get_team_invite_link_modal);

var _get_public_link_modal = __webpack_require__(1982);

var _get_public_link_modal2 = _interopRequireDefault(_get_public_link_modal);

var _invite_member_modal = __webpack_require__(1984);

var _invite_member_modal2 = _interopRequireDefault(_invite_member_modal);

var _leave_team_modal = __webpack_require__(1986);

var _leave_team_modal2 = _interopRequireDefault(_leave_team_modal);

var _leave_private_channel_modal = __webpack_require__(1987);

var _leave_private_channel_modal2 = _interopRequireDefault(_leave_private_channel_modal);

var _removed_from_channel_modal = __webpack_require__(1988);

var _removed_from_channel_modal2 = _interopRequireDefault(_removed_from_channel_modal);

var _reset_status_modal = __webpack_require__(1989);

var _reset_status_modal2 = _interopRequireDefault(_reset_status_modal);

var _shortcuts_modal = __webpack_require__(1991);

var _shortcuts_modal2 = _interopRequireDefault(_shortcuts_modal);

var _sidebar_right = __webpack_require__(1992);

var _sidebar_right2 = _interopRequireDefault(_sidebar_right);

var _sidebar_right_menu = __webpack_require__(2089);

var _sidebar_right_menu2 = _interopRequireDefault(_sidebar_right_menu);

var _team_settings_modal = __webpack_require__(1052);

var _team_settings_modal2 = _interopRequireDefault(_team_settings_modal);

var _import_theme_modal = __webpack_require__(2123);

var _import_theme_modal2 = _interopRequireDefault(_import_theme_modal);

var _modal = __webpack_require__(2124);

var _modal2 = _interopRequireDefault(_modal);

var _notification = __webpack_require__(2349);

var _notification2 = _interopRequireDefault(_notification);

var _sidebar = __webpack_require__(2351);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _modal_controller = __webpack_require__(2368);

var _modal_controller2 = _interopRequireDefault(_modal_controller);

var _team_sidebar = __webpack_require__(2370);

var _team_sidebar2 = _interopRequireDefault(_team_sidebar);

var _sidebar3 = __webpack_require__(2374);

var _sidebar4 = _interopRequireDefault(_sidebar3);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _center_channel = __webpack_require__(2404);

var _center_channel2 = _interopRequireDefault(_center_channel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChannelController = function (_React$Component) {
    (0, _inherits3.default)(ChannelController, _React$Component);

    function ChannelController() {
        (0, _classCallCheck3.default)(this, ChannelController);
        return (0, _possibleConstructorReturn3.default)(this, (ChannelController.__proto__ || (0, _getPrototypeOf2.default)(ChannelController)).apply(this, arguments));
    }

    (0, _createClass3.default)(ChannelController, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return this.props.teamType !== nextProps.teamType || this.props.pathName !== nextProps.pathName;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'channel-view' },
                _react2.default.createElement(_announcement_bar2.default, null),
                _react2.default.createElement(_notification2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid' },
                    _react2.default.createElement(_sidebar_right2.default, null),
                    _react2.default.createElement(_sidebar_right_menu2.default, { teamType: this.props.teamType }),
                    _react2.default.createElement(_sidebar2.default, null),
                    _react2.default.createElement(_reactRouterDom.Route, { component: _team_sidebar2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { component: _sidebar4.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { component: _center_channel2.default }),
                    _react2.default.createElement(_pluggable2.default, { pluggableName: 'Root' }),
                    _react2.default.createElement(_modal2.default, null),
                    _react2.default.createElement(_get_post_link_modal2.default, null),
                    _react2.default.createElement(_get_public_link_modal2.default, null),
                    _react2.default.createElement(_get_team_invite_link_modal2.default, null),
                    _react2.default.createElement(_invite_member_modal2.default, null),
                    _react2.default.createElement(_leave_team_modal2.default, null),
                    _react2.default.createElement(_import_theme_modal2.default, null),
                    _react2.default.createElement(_team_settings_modal2.default, null),
                    _react2.default.createElement(_edit_post_modal2.default, null),
                    _react2.default.createElement(_removed_from_channel_modal2.default, null),
                    _react2.default.createElement(_reset_status_modal2.default, null),
                    _react2.default.createElement(_leave_private_channel_modal2.default, null),
                    _react2.default.createElement(_shortcuts_modal2.default, { isMac: Utils.isMac() }),
                    _react2.default.createElement(_modal_controller2.default, null)
                )
            );
        }
    }]);
    return ChannelController;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ChannelController.propTypes = {
    pathName: _propTypes2.default.string.isRequired,
    teamType: _propTypes2.default.string.isRequired
};
exports.default = ChannelController;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _posts = __webpack_require__(808);

var _constants = __webpack_require__(19);

var _general = __webpack_require__(113);

var _preferences = __webpack_require__(784);

var _modals = __webpack_require__(927);

var _post_actions = __webpack_require__(802);

var _edit_post_modal = __webpack_require__(1950);

var _posts2 = __webpack_require__(1951);

var _edit_post_modal2 = __webpack_require__(1952);

var _edit_post_modal3 = _interopRequireDefault(_edit_post_modal2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        ctrlSend: (0, _preferences.getBool)(state, _constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter'),
        config: (0, _general.getConfig)(state),
        editingPost: (0, _posts2.getEditingPost)(state)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            addMessageIntoHistory: _posts.addMessageIntoHistory,
            editPost: _edit_post_modal.editPost,
            hideEditPostModal: _post_actions.hideEditPostModal,
            openModal: _modals.openModal
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_edit_post_modal3.default);

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.editPost = editPost;

var _posts = __webpack_require__(808);

var PostActions = _interopRequireWildcard(_posts);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function editPost(post) {
    var _this = this;

    return function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return PostActions.editPost(post)(dispatch, getState);

                        case 2:
                            result = _context.sent;


                            if (result.error) {
                                _app_dispatcher2.default.handleServerAction({
                                    type: _constants.ActionTypes.RECEIVED_ERROR,
                                    err: (0, _extends3.default)({
                                        id: result.error.server_error_id
                                    }, result.error)
                                });
                            }

                            return _context.abrupt('return', result);

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEditingPost = undefined;

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reselect = __webpack_require__(78);

var _posts = __webpack_require__(805);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getEditingPost = exports.getEditingPost = (0, _reselect.createSelector)(function (state) {
    if (state.views.posts.editingPost && state.views.posts.editingPost.postId) {
        return (0, _posts.getPost)(state, state.views.posts.editingPost.postId);
    }

    return null;
}, function (state) {
    return state.views.posts.editingPost;
}, function (post, editingPost) {
    return (0, _extends3.default)({}, editingPost, {
        post: post
    });
});

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _posts = __webpack_require__(805);

var Selectors = _interopRequireWildcard(_posts);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants = __webpack_require__(29);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _delete_post_modal = __webpack_require__(1309);

var _delete_post_modal2 = _interopRequireDefault(_delete_post_modal);

var _emoji_picker_overlay = __webpack_require__(883);

var _emoji_picker_overlay2 = _interopRequireDefault(_emoji_picker_overlay);

var _emoji_icon = __webpack_require__(909);

var _emoji_icon2 = _interopRequireDefault(_emoji_icon);

var _textbox = __webpack_require__(968);

var _textbox2 = _interopRequireDefault(_textbox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyCodes = _constants.Constants.KeyCodes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

var EditPostModal = function (_React$PureComponent) {
    (0, _inherits3.default)(EditPostModal, _React$PureComponent);

    function EditPostModal(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, EditPostModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EditPostModal.__proto__ || (0, _getPrototypeOf2.default)(EditPostModal)).call(this, props));

        _this.getContainer = function () {
            return _this.refs.editModalBody;
        };

        _this.toggleEmojiPicker = function () {
            _this.setState({ showEmojiPicker: !_this.state.showEmojiPicker });
        };

        _this.hideEmojiPicker = function () {
            _this.setState({ showEmojiPicker: false });
        };

        _this.handleEmojiClick = function (emoji) {
            var emojiAlias = emoji && (emoji.name || emoji.aliases && emoji.aliases[0]);

            if (!emojiAlias) {
                //Oops.. There went something wrong
                return;
            }

            if (_this.state.editText === '') {
                _this.setState({ editText: ':' + emojiAlias + ': ' });
            } else {
                //check whether there is already a blank at the end of the current message
                var newMessage = /\s+$/.test(_this.state.editText) ? _this.state.editText + ':' + emojiAlias + ': ' : _this.state.editText + ' :' + emojiAlias + ': ';

                _this.setState({ editText: newMessage });
            }

            _this.setState({ showEmojiPicker: false });

            _this.refs.editbox.focus();
        };

        _this.getEditPostControls = function () {
            return _this.refs.editPostEmoji;
        };

        _this.handlePostError = function (postError) {
            if (_this.state.postError !== postError) {
                _this.setState({ postError: postError });
            }
        };

        _this.handleEdit = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var _this$props, actions, editingPost, updatedPost, hasAttachment, deletePostModalData, data;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this$props = _this.props, actions = _this$props.actions, editingPost = _this$props.editingPost;
                            updatedPost = {
                                message: _this.state.editText,
                                id: editingPost.postId,
                                channel_id: editingPost.post.channel_id
                            };

                            if (!_this.state.postError) {
                                _context.next = 6;
                                break;
                            }

                            _this.setState({ errorClass: 'animation--highlight' });
                            setTimeout(function () {
                                _this.setState({ errorClass: null });
                            }, _constants.Constants.ANIMATION_TIMEOUT);
                            return _context.abrupt('return');

                        case 6:
                            if (!(updatedPost.message === (editingPost.post.message_source || editingPost.post.message))) {
                                _context.next = 9;
                                break;
                            }

                            // no changes so just close the modal
                            _this.handleHide();
                            return _context.abrupt('return');

                        case 9:
                            hasAttachment = editingPost.post.file_ids && editingPost.post.file_ids.length > 0;

                            if (!(updatedPost.message.trim().length === 0 && !hasAttachment)) {
                                _context.next = 15;
                                break;
                            }

                            _this.handleHide(false);

                            deletePostModalData = {
                                ModalId: _constants.ModalIdentifiers.DELETE_POST,
                                dialogType: _delete_post_modal2.default,
                                dialogProps: {
                                    post: Selectors.getPost(getState(), editingPost.postId),
                                    commentCount: editingPost.commentsCount,
                                    isRHS: editingPost.isRHS
                                }
                            };


                            _this.props.actions.openModal(deletePostModalData);
                            return _context.abrupt('return');

                        case 15:

                            actions.addMessageIntoHistory(updatedPost.message);

                            _context.next = 18;
                            return actions.editPost(updatedPost);

                        case 18:
                            data = _context.sent;

                            if (data) {
                                window.scrollTo(0, 0);
                            }

                            _this.handleHide();

                        case 21:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.handleChange = function (e) {
            var message = e.target.value;
            _this.setState({
                editText: message
            });
        };

        _this.handleEditKeyPress = function (e) {
            if (!UserAgent.isMobile() && !_this.props.ctrlSend && Utils.isKeyPressed(e, KeyCodes.ENTER) && !e.shiftKey && !e.altKey) {
                e.preventDefault();
                _this.refs.editbox.blur();
                _this.handleEdit();
            } else if (_this.props.ctrlSend && e.ctrlKey && Utils.isKeyPressed(e, KeyCodes.ENTER)) {
                e.preventDefault();
                _this.refs.editbox.blur();
                _this.handleEdit();
            }
        };

        _this.handleKeyDown = function (e) {
            if (_this.props.ctrlSend && Utils.isKeyPressed(e, KeyCodes.ENTER) && e.ctrlKey === true) {
                _this.handleEdit();
            }
        };

        _this.handleHide = function () {
            var doRefocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            _this.refocusId = doRefocus ? _this.props.editingPost.refocusId : null;
            _this.props.actions.hideEditPostModal();
        };

        _this.handleEntered = function () {
            _this.refs.editbox.focus();
            _this.refs.editbox.recalculateSize();
        };

        _this.handleExit = function () {
            _this.refs.editbox.hidePreview();
        };

        _this.handleExited = function () {
            var refocusId = _this.refocusId;
            if (refocusId) {
                setTimeout(function () {
                    var element = document.getElementById(refocusId);
                    if (element) {
                        element.focus();
                    }
                });
            }

            _this.refocusId = null;
            _this.setState({ editText: '', postError: '', errorClass: null, showEmojiPicker: false });
        };

        _this.state = {
            editText: '',
            postError: '',
            errorClass: null,
            showEmojiPicker: false
        };
        return _this;
    }

    (0, _createClass3.default)(EditPostModal, [{
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            if (!this.props.editingPost.show && nextProps.editingPost.show) {
                this.setState({
                    editText: nextProps.editingPost.post.message_source || nextProps.editingPost.post.message
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var errorBoxClass = 'edit-post-footer' + (this.state.postError ? ' has-error' : '');
            var postError = null;
            if (this.state.postError) {
                var postErrorClass = 'post-error' + (this.state.errorClass ? ' ' + this.state.errorClass : '');
                postError = _react2.default.createElement(
                    'label',
                    { className: postErrorClass },
                    this.state.postError
                );
            }

            var emojiPicker = null;
            if (this.props.config.EnableEmojiPicker === 'true') {
                emojiPicker = _react2.default.createElement(
                    'span',
                    { className: 'emoji-picker__container' },
                    _react2.default.createElement(_emoji_picker_overlay2.default, {
                        show: this.state.showEmojiPicker,
                        container: this.getContainer,
                        target: this.getEditPostControls,
                        onHide: this.hideEmojiPicker,
                        onEmojiClick: this.handleEmojiClick,
                        rightOffset: 50,
                        topOffset: -20
                    }),
                    _react2.default.createElement(_emoji_icon2.default, {
                        className: 'icon icon--emoji',
                        onClick: this.toggleEmojiPicker
                    })
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'edit-modal',
                    show: this.props.editingPost.show,
                    onKeyDown: this.handleKeyDown,
                    onHide: this.handleHide,
                    onEntered: this.handleEntered,
                    onExit: this.handleExit,
                    onExited: this.handleExited
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'edit_post.edit',
                            defaultMessage: 'Edit {title}',
                            values: {
                                title: this.props.editingPost.title
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    {
                        bsClass: 'modal-body edit-modal-body',
                        ref: 'editModalBody'
                    },
                    _react2.default.createElement(_textbox2.default, {
                        onChange: this.handleChange,
                        onKeyPress: this.handleEditKeyPress,
                        onKeyDown: this.handleKeyDown,
                        handlePostError: this.handlePostError,
                        value: this.state.editText,
                        channelId: this.props.editingPost.post && this.props.editingPost.post.channel_id,
                        emojiEnabled: this.props.config.EnableEmojiPicker === 'true',
                        createMessage: Utils.localizeMessage('edit_post.editPost', 'Edit the post...'),
                        supportsCommands: false,
                        suggestionListStyle: 'bottom',
                        id: 'edit_textbox',
                        ref: 'editbox'
                    }),
                    _react2.default.createElement(
                        'span',
                        {
                            ref: 'editPostEmoji',
                            className: 'edit-post__actions'
                        },
                        emojiPicker
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: errorBoxClass },
                        postError
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-default',
                            onClick: this.handleHide
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'edit_post.cancel',
                            defaultMessage: 'Cancel'
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-primary',
                            onClick: this.handleEdit
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'edit_post.save',
                            defaultMessage: 'Save'
                        })
                    )
                )
            );
        }
    }]);
    return EditPostModal;
}(_react2.default.PureComponent);

EditPostModal.propTypes = {

    /**
     * Set to force form submission on CTRL/CMD + ENTER instead of ENTER
     */
    ctrlSend: _propTypes2.default.bool,

    /**
     * Global config object
     */
    config: _propTypes2.default.object.isRequired,

    /**
     * Editing post information
     */
    editingPost: _propTypes2.default.shape({

        /**
         * The post being edited
         */
        post: _propTypes2.default.object,

        /**
         * The ID of the post being edited
         */
        postId: _propTypes2.default.string,

        /**
         * The ID of a DOM node to focus with the keyboard when this modal closes
         */
        refocusId: _propTypes2.default.string,

        /**
         * Whether or not to show the modal
         */
        show: _propTypes2.default.bool.isRequired,

        /**
         * What to show in the title of the modal as "Edit {title}"
         */
        title: _propTypes2.default.string,

        /**
         * Whether or not the modal was open from RHS
         */
        isRHS: _propTypes2.default.bool
    }).isRequired,

    actions: _propTypes2.default.shape({
        addMessageIntoHistory: _propTypes2.default.func.isRequired,
        editPost: _propTypes2.default.func.isRequired,
        hideEditPostModal: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = EditPostModal;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DeletePostModal = function (_React$PureComponent) {
    (0, _inherits3.default)(DeletePostModal, _React$PureComponent);

    function DeletePostModal(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, DeletePostModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DeletePostModal.__proto__ || (0, _getPrototypeOf2.default)(DeletePostModal)).call(this, props));

        _this.handleDelete = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var _this$props, actions, channelName, focusedPostId, post, teamName, _ref2, data;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this$props = _this.props, actions = _this$props.actions, channelName = _this$props.channelName, focusedPostId = _this$props.focusedPostId, post = _this$props.post, teamName = _this$props.teamName;
                            _context.next = 3;
                            return actions.deleteAndRemovePost(post);

                        case 3:
                            _ref2 = _context.sent;
                            data = _ref2.data;


                            if (post.id === focusedPostId && channelName) {
                                _browser_history.browserHistory.push('/' + teamName + '/channels/' + channelName);
                            }

                            if (data) {
                                _this.onHide();
                            }

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.handleDelete = _this.handleDelete.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        _this.state = {
            show: true
        };
        return _this;
    }

    (0, _createClass3.default)(DeletePostModal, [{
        key: 'onHide',
        value: function onHide() {
            this.setState({ show: false });

            if (!UserAgent.isMobile()) {
                var element;
                if (this.props.isRHS) {
                    element = document.getElementById('reply_textbox');
                } else {
                    element = document.getElementById('post_textbox');
                }
                if (element) {
                    element.focus();
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var commentWarning = '';
            if (this.props.commentCount > 0) {
                commentWarning = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'delete_post.warning',
                    defaultMessage: 'This post has {count, number} {count, plural, one {comment} other {comments}} on it.',
                    values: {
                        count: this.props.commentCount
                    }
                });
            }

            var postTerm = this.props.post.root_id ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'delete_post.comment',
                defaultMessage: 'Comment'
            }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'delete_post.post',
                defaultMessage: 'Post'
            });

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.state.show,
                    onHide: this.onHide,
                    onExited: this.props.onHide,
                    enforceFocus: false
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'delete_post.confirm',
                            defaultMessage: 'Confirm {term} Delete',
                            values: {
                                term: postTerm
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'delete_post.question',
                        defaultMessage: 'Are you sure you want to delete this {term}?',
                        values: {
                            term: postTerm
                        }
                    }),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null),
                    commentWarning
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-default',
                            onClick: this.onHide
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'delete_post.cancel',
                            defaultMessage: 'Cancel'
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            ref: function ref(deletePostBtn) {
                                _this3.deletePostBtn = deletePostBtn;
                            },
                            type: 'button',
                            autoFocus: true,
                            className: 'btn btn-danger',
                            onClick: this.handleDelete
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'delete_post.del',
                            defaultMessage: 'Delete'
                        })
                    )
                )
            );
        }
    }]);
    return DeletePostModal;
}(_react2.default.PureComponent);

DeletePostModal.propTypes = {

    channelName: _propTypes2.default.string,
    focusedPostId: _propTypes2.default.string,
    teamName: _propTypes2.default.string,
    post: _propTypes2.default.object.isRequired,
    commentCount: _propTypes2.default.number.isRequired,

    /**
     * Does the post come from RHS mode
     */
    isRHS: _propTypes2.default.bool.isRequired,

    /**
    * Function called when modal is dismissed
    */
    onHide: _propTypes2.default.func.isRequired,

    actions: _propTypes2.default.shape({

        /**
        * Function called for deleting post
        */
        deleteAndRemovePost: _propTypes2.default.func.isRequired
    })
};
exports.default = DeletePostModal;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _emojis = __webpack_require__(853);

var _emoji_actions = __webpack_require__(1036);

var _emojis2 = __webpack_require__(961);

var _emoji_picker = __webpack_require__(1955);

var _emoji_picker2 = _interopRequireDefault(_emoji_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    return {
        customEmojisEnabled: state.entities.general.config.EnableCustomEmoji === 'true',
        customEmojiPage: state.views.emoji.emojiPickerCustomPage,
        emojiMap: (0, _emojis2.getEmojiMap)(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getCustomEmojis: _emojis.getCustomEmojis,
            searchCustomEmojis: _emojis.searchCustomEmojis,
            incrementEmojiPickerPage: _emoji_actions.incrementEmojiPickerPage
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_emoji_picker2.default);

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(44);

var _extends4 = _interopRequireDefault(_extends3);

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _throttle = __webpack_require__(1310);

var _throttle2 = _interopRequireDefault(_throttle);

var _emoji_store = __webpack_require__(829);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

var _emoji = __webpack_require__(947);

var Emoji = _interopRequireWildcard(_emoji);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _emoji_picker_category = __webpack_require__(1960);

var _emoji_picker_category2 = _interopRequireDefault(_emoji_picker_category);

var _emoji_picker_item = __webpack_require__(1961);

var _emoji_picker_item2 = _interopRequireDefault(_emoji_picker_item);

var _emoji_picker_category_section = __webpack_require__(1962);

var _emoji_picker_category_section2 = _interopRequireDefault(_emoji_picker_category_section);

var _emoji_picker_preview = __webpack_require__(1963);

var _emoji_picker_preview2 = _interopRequireDefault(_emoji_picker_preview);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CATEGORY_SEARCH_RESULTS = 'searchResults';
var EMOJI_HEIGHT = 27;
var EMOJI_CONTAINER_HEIGHT = 300;
var EMOJI_CONTAINER_STYLE = {
    height: EMOJI_CONTAINER_HEIGHT
};
var EMOJI_LAZY_LOAD_BUFFER = 75;
var EMOJI_PER_ROW = 9;
var EMOJI_TO_LOAD_PER_UPDATE = 135;
var SYSTEM_EMOJIS_COUNT = 1476;
var EMOJI_LAZY_LOAD_SCROLL_THROTTLE = 100;

var CATEGORIES = {
    recent: {
        name: 'recent',
        className: 'fa fa-clock-o',
        id: 'emoji_picker.recent',
        message: 'Recently Used',
        offset: 0
    },
    people: {
        name: 'people',
        className: 'fa fa-smile-o',
        id: 'emoji_picker.people',
        message: 'People',
        offset: 0
    },
    nature: {
        name: 'nature',
        className: 'fa fa-leaf',
        id: 'emoji_picker.nature',
        message: 'Nature',
        offset: 0
    },
    foods: {
        name: 'foods',
        className: 'fa fa-cutlery',
        id: 'emoji_picker.foods',
        message: 'Foods',
        offset: 0
    },
    activity: {
        name: 'activity',
        className: 'fa fa-futbol-o',
        id: 'emoji_picker.activity',
        message: 'Activity',
        offset: 0
    },
    places: {
        name: 'places',
        className: 'fa fa-plane',
        id: 'emoji_picker.places',
        message: 'Places',
        offset: 0
    },
    objects: {
        name: 'objects',
        className: 'fa fa-lightbulb-o',
        id: 'emoji_picker.objects',
        message: 'Objects',
        offset: 0
    },
    symbols: {
        name: 'symbols',
        className: 'fa fa-heart-o',
        id: 'emoji_picker.symbols',
        message: 'Symbols',
        offset: 0
    },
    flags: {
        name: 'flags',
        className: 'fa fa-flag-o',
        id: 'emoji_picker.flags',
        message: 'Flags',
        offset: 0
    },
    custom: {
        name: 'custom',
        className: 'fa fa-at',
        id: 'emoji_picker.custom',
        message: 'Custom',
        offset: 0
    }
};

function getEmojiFilename(emoji) {
    return emoji.filename || emoji.id;
}

var EMOJIS_PER_PAGE = 200;
var LOAD_MORE_AT_PIXELS_FROM_BOTTOM = 500;

var EmojiPicker = function (_React$PureComponent) {
    (0, _inherits3.default)(EmojiPicker, _React$PureComponent);

    function EmojiPicker(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, EmojiPicker);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiPicker.__proto__ || (0, _getPrototypeOf2.default)(EmojiPicker)).call(this, props));

        _this.loadMoreCustomEmojis = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var _ref2, data;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(!_this.props.customEmojisEnabled || _this.loadingMoreEmojis)) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:

                            _this.loadingMoreEmojis = true;

                            _context.next = 5;
                            return _this.props.actions.getCustomEmojis(_this.props.customEmojiPage, EMOJIS_PER_PAGE);

                        case 5:
                            _ref2 = _context.sent;
                            data = _ref2.data;

                            if (data) {
                                _context.next = 10;
                                break;
                            }

                            _this.loadingMoreEmojis = false;
                            return _context.abrupt('return');

                        case 10:
                            if (!(data.length < EMOJIS_PER_PAGE)) {
                                _context.next = 14;
                                break;
                            }

                            _this.missingPages = false;
                            _this.loadingMoreEmojis = false;
                            return _context.abrupt('return');

                        case 14:
                            _context.next = 16;
                            return _this.props.actions.incrementEmojiPickerPage();

                        case 16:

                            _this.loadingMoreEmojis = false;

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.lastVisibleEmojiRef = function (lastVisibleEmoji) {
            _this.lastVisibleEmoji = lastVisibleEmoji;
        };

        _this.emojiPickerContainerRef = function (emojiPickerContainer) {
            _this.emojiPickerContainer = emojiPickerContainer;
        };

        _this.emojiSearchInput = function (input) {
            _this.searchInput = input;
        };

        _this.emojiCurrentResultsItems = function (categoryIndex, emojis, currentEmojiLoadedCount) {
            var _this$state = _this.state,
                cursor = _this$state.cursor,
                emojisToShow = _this$state.emojisToShow;

            var numEmojisLoaded = currentEmojiLoadedCount;

            return emojis.map(function (emoji, emojiIndex) {
                numEmojisLoaded++;

                // set ref on first unloaded emoji
                var ref = void 0;
                if (numEmojisLoaded === emojisToShow) {
                    ref = _this.lastVisibleEmojiRef;
                }
                if (numEmojisLoaded >= emojisToShow) {
                    return _react2.default.createElement(
                        'div',
                        {
                            key: numEmojisLoaded,
                            className: 'emoji-picker__item',
                            ref: ref
                        },
                        _react2.default.createElement('img', {
                            src: '/static/images/img_trans.gif',
                            className: 'emojisprite'
                        })
                    );
                }
                return _react2.default.createElement(_emoji_picker_item2.default, {
                    key: emoji.filename + ':' + emoji.id,
                    emoji: emoji,
                    onItemOver: _this.handleItemOver,
                    onItemClick: _this.handleItemClick,
                    onItemUnmount: emoji,
                    category: emoji.category,
                    isSelected: cursor[0] === categoryIndex && cursor[1] === emojiIndex,
                    categoryIndex: categoryIndex,
                    emojiIndex: emojiIndex,
                    containerRef: _this.emojiPickerContainer,
                    containerTop: _this.state.divTopOffset,
                    containerBottom: _this.state.divTopOffset + _this.divHeight
                });
            });
        };

        _this.handleCategoryClick = _this.handleCategoryClick.bind(_this);
        _this.handleFilterChange = _this.handleFilterChange.bind(_this);
        _this.handleItemOver = _this.handleItemOver.bind(_this);
        _this.handleItemClick = _this.handleItemClick.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleScrollThrottle = (0, _throttle2.default)(_this.handleScroll, EMOJI_LAZY_LOAD_SCROLL_THROTTLE, { leading: false, trailing: true });
        _this.updateCategoryOffset = _this.updateCategoryOffset.bind(_this);

        _this.divHeight = 0;
        _this.missingPages = true;
        _this.loadingMoreEmojis = false;
        _this.state = {
            allEmojis: {},
            categories: CATEGORIES,
            filter: '',
            cursor: [0, 0], // categoryIndex, emojiIndex
            divTopOffset: 0,
            emojisToShow: SYSTEM_EMOJIS_COUNT
        };
        return _this;
    }

    (0, _createClass3.default)(EmojiPicker, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.customEmojiPage === 0) {
                this.loadMoreCustomEmojis();
            }
            this.getEmojis();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            // Delay taking focus because this briefly renders offscreen when using an Overlay
            // so focusing it immediately on mount can cause weird scrolling
            requestAnimationFrame(function () {
                _this3.searchInput.focus();
            });
            this.divHeight = this.emojiPickerContainer.offsetHeight;
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if (this.state.divTopOffset === nextState.divTopOffset) {
                return;
            }

            if (this.lastVisibleEmoji) {
                var difference = this.lastVisibleEmoji.offsetTop - (nextState.divTopOffset + EMOJI_CONTAINER_HEIGHT + EMOJI_LAZY_LOAD_BUFFER);
                if (difference <= 0) {
                    var numToLoad = EMOJI_TO_LOAD_PER_UPDATE + Math.ceil(difference / EMOJI_HEIGHT * EMOJI_PER_ROW * -1);
                    this.setState(function (state) {
                        return {
                            emojisToShow: state.emojisToShow + numToLoad
                        };
                    });
                }
            }

            if (!this.missingPages || !this.emojiPickerContainer) {
                return;
            }

            var pixelsFromBottom = this.emojiPickerContainer.scrollHeight - nextState.divTopOffset - this.emojiPickerContainer.clientHeight;
            if (pixelsFromBottom <= LOAD_MORE_AT_PIXELS_FROM_BOTTOM) {
                this.loadMoreCustomEmojis();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.emojiMap !== nextProps.emojiMap) {
                this.getEmojis(nextProps);
            }
        }
    }, {
        key: 'handleCategoryClick',
        value: function handleCategoryClick(categoryName) {
            this.emojiPickerContainer.scrollTop = this.state.categories[categoryName].offset;
        }
    }, {
        key: 'handleFilterChange',
        value: function handleFilterChange(e) {
            e.preventDefault();
            var filter = e.target.value.toLowerCase();

            if (this.props.customEmojisEnabled && filter && filter.trim() !== '') {
                this.props.actions.searchCustomEmojis(filter);
            }

            this.setState(function () {
                return {
                    filter: filter,
                    cursor: [0, 0]
                };
            });
        }
    }, {
        key: 'handleItemOver',
        value: function handleItemOver(categoryIndex, emojiIndex) {
            this.setState({
                cursor: [categoryIndex, emojiIndex]
            });
        }
    }, {
        key: 'handleItemClick',
        value: function handleItemClick(emoji) {
            this.props.onEmojiClick(emoji);
        }
    }, {
        key: 'handleKeyDown',
        value: function handleKeyDown(e) {
            switch (e.key) {
                case 'ArrowRight':
                    e.preventDefault();
                    this.selectNextEmoji();
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    this.selectPrevEmoji();
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    this.selectPrevEmoji(EMOJI_PER_ROW);
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    this.selectNextEmoji(EMOJI_PER_ROW);
                    break;
                case 'Enter':
                    e.preventDefault();
                    if (this.getCurrentEmojiByCursor(this.state.cursor)) {
                        this.props.onEmojiClick(this.getCurrentEmojiByCursor(this.state.cursor));
                    }
                    break;
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll() {
            this.setState({ divTopOffset: this.emojiPickerContainer.scrollTop });
        }
    }, {
        key: 'selectNextEmoji',
        value: function selectNextEmoji() {
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var cursor = this.state.cursor;

            // try moving to next emoji in index

            var newCursor = [cursor[0], cursor[1] + offset];
            if (this.getCurrentEmojiByCursor(newCursor)) {
                this.setState({ cursor: newCursor });
                return;
            }

            // try moving to next category
            newCursor = [cursor[0] + 1, 0];
            if (this.getCurrentEmojiByCursor(newCursor)) {
                this.setState({ cursor: newCursor });
            }
        }
    }, {
        key: 'selectPrevEmoji',
        value: function selectPrevEmoji() {
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var cursor = this.state.cursor;

            // try moving to prev emoji in index

            var newCursor = [cursor[0], cursor[1] - offset];
            if (this.getCurrentEmojiByCursor(newCursor)) {
                this.setState({ cursor: newCursor });
                return;
            }

            // try moving to end of prev category
            if (cursor[0] !== 0) {
                var newCategory = this.getCategoryByIndex(cursor[0] - 1);
                var lastVisibleEmojiInNewCategory = this.state.categories[newCategory.name].emojiIds.length - 1;
                newCursor = [cursor[0] - 1, lastVisibleEmojiInNewCategory];
                if (this.getCurrentEmojiByCursor(newCursor)) {
                    this.setState({ cursor: newCursor });
                }
            }
        }
    }, {
        key: 'getCategoryByIndex',
        value: function getCategoryByIndex(index) {
            if (this.state.filter && index !== 0) {
                return null;
            }
            return this.getCategoriesByKey((0, _keys2.default)(this.state.categories)[index]);
        }
    }, {
        key: 'getCurrentEmojiByCursor',
        value: function getCurrentEmojiByCursor(cursor) {
            var category = this.getCategoryByIndex(cursor[0]);
            if (!category) {
                return null;
            }
            return this.getEmojisByCategory(category)[cursor[1]];
        }
    }, {
        key: 'getCategoriesByKey',
        value: function getCategoriesByKey(key) {
            return this.state.filter ? {
                id: CATEGORY_SEARCH_RESULTS,
                name: CATEGORY_SEARCH_RESULTS
            } : this.state.categories[key];
        }
    }, {
        key: 'getEmojisByCategory',
        value: function getEmojisByCategory(category) {
            var _this4 = this;

            if (this.state.filter) {
                return (0, _values2.default)(this.state.allEmojis).filter(function (emoji) {
                    for (var i = 0; i < emoji.aliases.length; i++) {
                        if (emoji.aliases[i].toLowerCase().includes(_this4.state.filter)) {
                            return true;
                        }
                    }
                    return false;
                });
            }
            return this.state.categories[category.name].emojiIds.map(function (emojiId) {
                return _this4.state.allEmojis[emojiId];
            });
        }
    }, {
        key: 'getEmojis',
        value: function getEmojis() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var _state = this.state,
                categories = _state.categories,
                allEmojis = _state.allEmojis;

            var emojiMap = props.emojiMap;
            var customEmojiMap = emojiMap.customEmojis;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(categories)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var category = _step.value;

                    var categoryEmojis = [];
                    if (category === 'recent') {
                        var recentEmojis = [].concat((0, _toConsumableArray3.default)(_emoji_store2.default.getRecentEmojis())).reverse();
                        categoryEmojis = recentEmojis.filter(function (name) {
                            return emojiMap.has(name);
                        }).map(function (name) {
                            return emojiMap.get(name);
                        });
                    } else {
                        var indices = Emoji.EmojiIndicesByCategory.get(category) || [];
                        categoryEmojis = indices.map(function (index) {
                            return Emoji.Emojis[index];
                        });
                        if (category === 'custom') {
                            categoryEmojis = categoryEmojis.concat([].concat((0, _toConsumableArray3.default)(customEmojiMap.values())));
                        }
                    }
                    categories[category].emojiIds = categoryEmojis.map(function (emoji) {
                        return getEmojiFilename(emoji);
                    });
                    for (var i = 0; i < categoryEmojis.length; i++) {
                        var currentEmoji = categoryEmojis[i];
                        var fileName = getEmojiFilename(currentEmoji);
                        allEmojis[fileName] = (0, _extends4.default)({}, currentEmoji, {
                            visible: false,
                            offset: null
                        });
                        if (!currentEmoji.filename) {
                            // if custom emoji, set proper attributes
                            allEmojis[fileName] = (0, _extends4.default)({}, allEmojis[fileName], {
                                aliases: [currentEmoji.name],
                                category: 'custom',
                                filename: fileName
                            });
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.setState({
                categories: categories,
                allEmojis: allEmojis
            });
        }
    }, {
        key: 'getCurrentEmojiCategoryName',
        value: function getCurrentEmojiCategoryName() {
            var categories = (0, _keys2.default)(this.state.categories);
            var currentCategoryName = '';
            for (var i = categories.length - 1; i >= 0; i--) {
                // go through in reverse so that you get the last category that matches
                var category = this.state.categories[categories[i]];
                if (this.state.divTopOffset > category.offset - 20) {
                    currentCategoryName = categories[i];
                    break;
                }
            }
            return currentCategoryName;
        }
    }, {
        key: 'emojiCategories',
        value: function emojiCategories() {
            var _this5 = this;

            var categories = this.state.categories;
            var categoryKeys = (0, _keys2.default)(categories);
            var currentCategoryName = this.state.filter ? categoryKeys[0] : this.getCurrentEmojiCategoryName();
            var emojiPickerCategories = categoryKeys.map(function (categoryName) {
                var category = categories[categoryName];
                return _react2.default.createElement(_emoji_picker_category2.default, {
                    key: 'header-' + category.name,
                    category: category.name,
                    icon: _react2.default.createElement('i', {
                        className: category.className,
                        title: Utils.localizeMessage(category.id, category.message)
                    }),
                    onCategoryClick: _this5.handleCategoryClick,
                    selected: currentCategoryName === category.name,
                    enable: !_this5.state.filter
                });
            });
            return _react2.default.createElement(
                'div',
                { className: 'emoji-picker__categories' },
                emojiPickerCategories
            );
        }
    }, {
        key: 'emojiSearch',
        value: function emojiSearch() {
            return _react2.default.createElement(
                'div',
                { className: 'emoji-picker__search-container' },
                _react2.default.createElement('span', { className: 'fa fa-search emoji-picker__search-icon' }),
                _react2.default.createElement('input', {
                    ref: this.emojiSearchInput,
                    className: 'emoji-picker__search',
                    type: 'text',
                    onChange: this.handleFilterChange,
                    onKeyDown: this.handleKeyDown,
                    placeholder: Utils.localizeMessage('emoji_picker.search', 'search')
                })
            );
        }
    }, {
        key: 'emojiCurrentResults',
        value: function emojiCurrentResults() {
            var filter = this.state.filter;

            var categories = filter ? [CATEGORY_SEARCH_RESULTS] : (0, _keys2.default)(this.state.categories);
            var numEmojisLoaded = 0;

            var categoryComponents = [];

            for (var i = 0; i < categories.length; i++) {
                var category = this.getCategoriesByKey(categories[i]);
                var emojis = this.getEmojisByCategory(category);
                var items = this.emojiCurrentResultsItems(i, emojis, numEmojisLoaded);
                numEmojisLoaded += items.length;
                categoryComponents = [].concat((0, _toConsumableArray3.default)(categoryComponents), [_react2.default.createElement(
                    _emoji_picker_category_section2.default,
                    {
                        key: category.id,
                        categoryName: category.name,
                        updateCategoryOffset: this.updateCategoryOffset
                    },
                    items
                )]);
            }

            return _react2.default.createElement(
                'div',
                {
                    ref: this.emojiPickerContainerRef,
                    onScroll: this.handleScrollThrottle,
                    className: 'emoji-picker__items',
                    style: EMOJI_CONTAINER_STYLE
                },
                _react2.default.createElement(
                    'div',
                    { className: 'emoji-picker__container' },
                    categoryComponents
                )
            );
        }
    }, {
        key: 'updateCategoryOffset',
        value: function updateCategoryOffset(categoryName, offset) {
            if (categoryName !== CATEGORY_SEARCH_RESULTS) {
                this.setState(function (state) {
                    return {
                        categories: (0, _extends4.default)({}, state.categories, (0, _defineProperty3.default)({}, categoryName, (0, _extends4.default)({}, state.categories[categoryName], {
                            offset: offset
                        }))) };
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var pickerStyle = void 0;
            if (this.props.style && !(this.props.style.left === 0 || this.props.style.top === 0)) {
                if (this.props.placement === 'top' || this.props.placement === 'bottom') {
                    // Only take the top/bottom position passed by React Bootstrap since we want to be right-aligned
                    pickerStyle = {
                        top: this.props.style.top,
                        bottom: this.props.style.bottom,
                        right: this.props.rightOffset
                    };
                } else {
                    pickerStyle = (0, _extends4.default)({}, this.props.style);
                }
            }
            if (pickerStyle && pickerStyle.top) {
                pickerStyle.top += this.props.topOffset;
            }
            return _react2.default.createElement(
                'div',
                {
                    className: 'emoji-picker',
                    style: pickerStyle
                },
                this.emojiCategories(),
                this.emojiSearch(),
                this.emojiCurrentResults(),
                _react2.default.createElement(_emoji_picker_preview2.default, { emoji: this.getCurrentEmojiByCursor(this.state.cursor) })
            );
        }
    }]);
    return EmojiPicker;
}(_react2.default.PureComponent);

EmojiPicker.propTypes = {
    style: _propTypes2.default.object,
    rightOffset: _propTypes2.default.number,
    topOffset: _propTypes2.default.number,
    placement: _propTypes2.default.oneOf(['top', 'bottom', 'left']),
    onEmojiClick: _propTypes2.default.func.isRequired,
    customEmojisEnabled: _propTypes2.default.bool,
    emojiMap: _propTypes2.default.object.isRequired,
    customEmojiPage: _propTypes2.default.number.isRequired,
    actions: _propTypes2.default.shape({
        getCustomEmojis: _propTypes2.default.func.isRequired,
        searchCustomEmojis: _propTypes2.default.func.isRequired,
        incrementEmojiPickerPage: _propTypes2.default.func.isRequired
    }).isRequired
};
EmojiPicker.defaultProps = {
    rightOffset: 0,
    topOffset: 0,
    customEmojiPage: 0,
    customEmojisEnabled: false
};
exports.default = EmojiPicker;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(836);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(856),
    isSymbol = __webpack_require__(967);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(928);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1959 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EmojiPickerCategory = function (_React$Component) {
    (0, _inherits3.default)(EmojiPickerCategory, _React$Component);

    function EmojiPickerCategory(props) {
        (0, _classCallCheck3.default)(this, EmojiPickerCategory);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiPickerCategory.__proto__ || (0, _getPrototypeOf2.default)(EmojiPickerCategory)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(EmojiPickerCategory, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.selected !== this.props.selected || nextProps.enable !== this.props.enable;
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            e.preventDefault();
            this.props.onCategoryClick(this.props.category);
        }
    }, {
        key: 'render',
        value: function render() {
            var className = 'emoji-picker__category';
            if (this.props.selected) {
                className += ' emoji-picker__category--selected';
            }

            if (!this.props.enable) {
                className += ' disable';
            }

            return _react2.default.createElement(
                'a',
                {
                    className: className,
                    href: '#',
                    onClick: this.handleClick
                },
                this.props.icon
            );
        }
    }]);
    return EmojiPickerCategory;
}(_react2.default.Component);

EmojiPickerCategory.propTypes = {
    category: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.node.isRequired,
    onCategoryClick: _propTypes2.default.func.isRequired,
    selected: _propTypes2.default.bool.isRequired,
    enable: _propTypes2.default.bool.isRequired
};
exports.default = EmojiPickerCategory;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _debounce = __webpack_require__(1037);

var _debounce2 = _interopRequireDefault(_debounce);

var _emoji_store = __webpack_require__(829);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SCROLLING_ADDITIONAL_VISUAL_SPACING = 10; // to make give the emoji some visual 'breathing room'
var EMOJI_LAZY_LOAD_SCROLL_THROTTLE = 150;

var EmojiPickerItem = function (_React$Component) {
    (0, _inherits3.default)(EmojiPickerItem, _React$Component);

    function EmojiPickerItem() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, EmojiPickerItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmojiPickerItem.__proto__ || (0, _getPrototypeOf2.default)(EmojiPickerItem)).call.apply(_ref, [this].concat(args))), _this), _this.emojiItemRef = function (emojiItem) {
            _this.emojiItem = emojiItem;
        }, _this.handleMouseOver = function () {
            if (!_this.props.isSelected) {
                _this.props.onItemOver(_this.props.categoryIndex, _this.props.emojiIndex);
            }
        }, _this.handleMouseOverThrottle = (0, _debounce2.default)(_this.handleMouseOver, EMOJI_LAZY_LOAD_SCROLL_THROTTLE, { leading: true, trailing: true }), _this.handleClick = function () {
            _this.props.onItemClick(_this.props.emoji);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(EmojiPickerItem, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.isSelected !== this.props.isSelected;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.isSelected && nextProps.isSelected) {
                var topOfTheEmojiItem = this.emojiItem.offsetTop;
                var bottomOfTheEmojiItem = topOfTheEmojiItem + this.emojiItem.offsetHeight;
                var containerRef = nextProps.containerRef,
                    containerTop = nextProps.containerTop,
                    containerBottom = nextProps.containerBottom;

                if (topOfTheEmojiItem < containerTop) {
                    containerRef.scrollTop = topOfTheEmojiItem - SCROLLING_ADDITIONAL_VISUAL_SPACING;
                } else if (bottomOfTheEmojiItem > containerBottom) {
                    containerRef.scrollTop = bottomOfTheEmojiItem - containerRef.offsetHeight + SCROLLING_ADDITIONAL_VISUAL_SPACING;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var emoji = this.props.emoji;


            var itemClassName = 'emoji-picker__item';
            if (this.props.isSelected) {
                itemClassName += ' selected';
            }

            var spriteClassName = 'emojisprite';
            spriteClassName += ' emoji-category-' + emoji.category + '-' + emoji.batch;
            spriteClassName += ' emoji-' + emoji.filename;

            var image = void 0;
            if (emoji.category && emoji.batch) {
                image = _react2.default.createElement('img', {
                    onMouseOver: this.handleMouseOverThrottle,
                    src: '/static/images/img_trans.gif',
                    className: spriteClassName,
                    onClick: this.handleClick
                });
            } else {
                image = _react2.default.createElement('img', {
                    onMouseOver: this.handleMouseOver,
                    src: _emoji_store2.default.getEmojiImageUrl(emoji),
                    className: 'emoji-category--custom',
                    onClick: this.handleClick
                });
            }

            return _react2.default.createElement(
                'div',
                {
                    className: itemClassName,
                    ref: this.emojiItemRef
                },
                _react2.default.createElement(
                    'div',
                    null,
                    image
                )
            );
        }
    }]);
    return EmojiPickerItem;
}(_react2.default.Component);

EmojiPickerItem.propTypes = {
    emoji: _propTypes2.default.object.isRequired,
    onItemOver: _propTypes2.default.func.isRequired,
    onItemClick: _propTypes2.default.func.isRequired,
    category: _propTypes2.default.string.isRequired,
    isSelected: _propTypes2.default.bool,
    categoryIndex: _propTypes2.default.number.isRequired,
    emojiIndex: _propTypes2.default.number.isRequired,
    containerRef: _propTypes2.default.any,
    containerTop: _propTypes2.default.number.isRequired,
    containerBottom: _propTypes2.default.number.isRequired
};
exports.default = EmojiPickerItem;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmojiPickerCategorySection = function (_React$PureComponent) {
    (0, _inherits3.default)(EmojiPickerCategorySection, _React$PureComponent);

    function EmojiPickerCategorySection() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, EmojiPickerCategorySection);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmojiPickerCategorySection.__proto__ || (0, _getPrototypeOf2.default)(EmojiPickerCategorySection)).call.apply(_ref, [this].concat(args))), _this), _this.divRef = function (div) {
            _this.div = div;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(EmojiPickerCategorySection, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.updateCategoryOffset(this.props.categoryName, this.div.offsetTop);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    ref: this.divRef
                },
                _react2.default.createElement(
                    'div',
                    { className: 'emoji-picker-items__container' },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'emoji-picker__category-header',
                            id: 'emojipickercat-' + this.props.categoryName
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'emoji_picker.' + this.props.categoryName })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'emoji-picker-items__container' },
                    this.props.children
                )
            );
        }
    }]);
    return EmojiPickerCategorySection;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

EmojiPickerCategorySection.propTypes = {
    categoryName: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.any,
    updateCategoryOffset: _propTypes2.default.func.isRequired
};
exports.default = EmojiPickerCategorySection;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _emoji_store = __webpack_require__(829);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EmojiPickerPreview = function (_React$Component) {
    (0, _inherits3.default)(EmojiPickerPreview, _React$Component);

    function EmojiPickerPreview() {
        (0, _classCallCheck3.default)(this, EmojiPickerPreview);
        return (0, _possibleConstructorReturn3.default)(this, (EmojiPickerPreview.__proto__ || (0, _getPrototypeOf2.default)(EmojiPickerPreview)).apply(this, arguments));
    }

    (0, _createClass3.default)(EmojiPickerPreview, [{
        key: 'render',
        value: function render() {
            var emoji = this.props.emoji;

            if (emoji) {
                var name = void 0;
                var aliases = void 0;
                var previewImage = void 0;

                if (emoji.aliases && emoji.category && emoji.batch) {
                    // This is a system emoji which only has a list of aliases
                    name = emoji.aliases[0];
                    aliases = emoji.aliases;

                    previewImage = _react2.default.createElement(
                        'span',
                        { className: 'sprite-preview' },
                        _react2.default.createElement('img', {
                            src: '/static/images/img_trans.gif',
                            className: 'emojisprite-preview emoji-category-' + emoji.category + '-' + emoji.batch + ' emoji-' + emoji.filename
                        })
                    );
                } else {
                    // This is a custom emoji that matches the model on the server
                    name = emoji.name;
                    aliases = [emoji.name];
                    previewImage = _react2.default.createElement('img', {
                        className: 'emoji-picker__preview-image',
                        src: _emoji_store2.default.getEmojiImageUrl(emoji)
                    });
                }

                return _react2.default.createElement(
                    'div',
                    { className: 'emoji-picker__preview' },
                    _react2.default.createElement(
                        'div',
                        { className: 'emoji-picker__preview-image-box' },
                        previewImage
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'emoji-picker__preview-image-label-box' },
                        _react2.default.createElement(
                            'span',
                            { className: 'emoji-picker__preview-name' },
                            name
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'emoji-picker__preview-aliases' },
                            ':' + aliases[0] + ':'
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'emoji-picker__preview emoji-picker__preview-placeholder' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'emoji_picker.emojiPicker',
                    defaultMessage: 'Emoji Picker'
                })
            );
        }
    }]);
    return EmojiPickerPreview;
}(_react2.default.Component);

EmojiPickerPreview.propTypes = {
    emoji: _propTypes2.default.object
};
exports.default = EmojiPickerPreview;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _deleteProperty = __webpack_require__(176);

var _deleteProperty2 = _interopRequireDefault(_deleteProperty);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var AutosizeTextarea = function (_React$Component) {
    (0, _inherits3.default)(AutosizeTextarea, _React$Component);

    function AutosizeTextarea(props) {
        (0, _classCallCheck3.default)(this, AutosizeTextarea);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AutosizeTextarea.__proto__ || (0, _getPrototypeOf2.default)(AutosizeTextarea)).call(this, props));

        _this.recalculateSize = function () {
            var height = _this.refs.reference.scrollHeight;

            if (height > 0 && height !== _this.height) {
                var textarea = _this.refs.textarea;

                var _style = getComputedStyle(textarea);
                var borderWidth = parseInt(_style.borderTopWidth, 10) + parseInt(_style.borderBottomWidth, 10);

                // Directly change the height to avoid circular rerenders
                textarea.style.height = String(height + borderWidth) + 'px';

                _this.height = height;

                if (_this.props.onHeightChange) {
                    _this.props.onHeightChange(height, parseInt(_style.maxHeight, 10));
                }
            }
        };

        _this.getDOMNode = function () {
            return _this.refs.textarea;
        };

        _this.handleChange = function (e) {
            if (_this.props.onChange) {
                _this.props.onChange(e);
            }
        };

        _this.height = 0;
        return _this;
    }

    (0, _createClass3.default)(AutosizeTextarea, [{
        key: 'focus',
        value: function focus() {
            this.refs.textarea.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.refs.textarea.blur();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.recalculateSize();
        }
    }, {
        key: 'render',
        value: function render() {
            var props = (0, _extends3.default)({}, this.props);

            (0, _deleteProperty2.default)(props, 'onHeightChange');
            (0, _deleteProperty2.default)(props, 'providers');
            (0, _deleteProperty2.default)(props, 'channelId');

            var value = props.value,
                defaultValue = props.defaultValue,
                placeholder = props.placeholder,
                disabled = props.disabled,
                onInput = props.onInput,
                id = props.id,
                otherProps = (0, _objectWithoutProperties3.default)(props, ['value', 'defaultValue', 'placeholder', 'disabled', 'onInput', 'id']);


            var heightProps = {};
            if (this.height <= 0) {
                // Set an initial number of rows so that the textarea doesn't appear too large when its first rendered
                heightProps.rows = 1;
            } else {
                heightProps.height = this.height;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('textarea', (0, _extends3.default)({
                    ref: 'textarea',
                    id: id
                }, heightProps, otherProps, {
                    disabled: disabled,
                    placeholder: placeholder,
                    onChange: this.handleChange,
                    onInput: onInput,
                    value: value,
                    defaultValue: defaultValue
                })),
                _react2.default.createElement(
                    'div',
                    { style: style.container },
                    _react2.default.createElement('textarea', (0, _extends3.default)({
                        ref: 'reference',
                        id: id + '-reference',
                        style: style.reference,
                        disabled: true,
                        placeholder: placeholder,
                        rows: '1'
                    }, otherProps, {
                        value: value || defaultValue || placeholder
                    }))
                )
            );
        }
    }, {
        key: 'value',
        get: function get() {
            return this.refs.textarea.value;
        },
        set: function set(value) {
            this.refs.textarea.value = value;
        }
    }, {
        key: 'selectionStart',
        get: function get() {
            return this.refs.textarea.selectionStart;
        },
        set: function set(selectionStart) {
            this.refs.textarea.selectionStart = selectionStart;
        }
    }, {
        key: 'selectionEnd',
        get: function get() {
            return this.refs.textarea.selectionEnd;
        },
        set: function set(selectionEnd) {
            this.refs.textarea.selectionEnd = selectionEnd;
        }
    }]);
    return AutosizeTextarea;
}(_react2.default.Component);

AutosizeTextarea.propTypes = {
    value: _propTypes2.default.string,
    defaultValue: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    onHeightChange: _propTypes2.default.func
};
exports.default = AutosizeTextarea;


var style = {
    container: { height: 0, overflow: 'hidden' },
    reference: { height: 'auto', width: '100%' }
};

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

var _text_formatting = __webpack_require__(811);

var TextFormatting = _interopRequireWildcard(_text_formatting);

var _system_message_helpers = __webpack_require__(1966);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostMarkdown = function (_React$PureComponent) {
  (0, _inherits3.default)(PostMarkdown, _React$PureComponent);

  function PostMarkdown() {
    (0, _classCallCheck3.default)(this, PostMarkdown);
    return (0, _possibleConstructorReturn3.default)(this, (PostMarkdown.__proto__ || (0, _getPrototypeOf2.default)(PostMarkdown)).apply(this, arguments));
  }

  (0, _createClass3.default)(PostMarkdown, [{
    key: 'render',
    value: function render() {
      var options = (0, _assign2.default)({
        siteURL: this.props.siteURL,
        mentionKeys: this.props.mentionKeys,
        atMentions: true,
        channelNamesMap: this.props.channelNamesMap,
        team: this.props.team,

        // Proxy images if we have an image proxy and the server hasn't already rewritten the post's image URLs.
        proxyImages: this.props.hasImageProxy && (!this.props.post || !this.props.post.message_source || this.props.post.message === this.props.post.message_source)
      }, this.props.options);

      if (this.props.post) {
        var renderedSystemMessage = (0, _system_message_helpers.renderSystemMessage)(this.props.post, options);
        if (renderedSystemMessage) {
          return _react2.default.createElement(
            'div',
            null,
            renderedSystemMessage
          );
        }
      }

      var htmlFormattedText = TextFormatting.formatText(this.props.message, options);
      return PostUtils.messageHtmlToComponent(htmlFormattedText, this.props.isRHS);
    }
  }]);
  return PostMarkdown;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PostMarkdown.propTypes = {

  /*
   * An object mapping channel names to channels for the current team
   */
  channelNamesMap: _propTypes2.default.object.isRequired,

  /*
   * Whether or not this text is part of the RHS
   */
  isRHS: _propTypes2.default.bool,

  /*
   * An array of words that can be used to mention a user
   */
  mentionKeys: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,

  /*
   * The post text to be rendered
   */
  message: _propTypes2.default.string.isRequired,

  /*
   * Any additional text formatting options to be used
   */
  options: _propTypes2.default.object,

  /*
   * The optional post for which this message is being rendered
   */
  post: _propTypes2.default.object,

  /*
   * The root Site URL for the page
   */
  siteURL: _propTypes2.default.string.isRequired,

  /*
   * The current team
   */
  team: _propTypes2.default.object.isRequired,

  /**
   * If an image proxy is enabled.
   */
  hasImageProxy: _propTypes2.default.bool.isRequired
};
PostMarkdown.defaultProps = {
  options: {},
  isRHS: false
};
exports.default = PostMarkdown;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _systemMessageRendere; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.renderSystemMessage = renderSystemMessage;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _channel_utils = __webpack_require__(830);

var _constants = __webpack_require__(29);

var _text_formatting = __webpack_require__(811);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _post_add_channel_member = __webpack_require__(1967);

var _post_add_channel_member2 = _interopRequireDefault(_post_add_channel_member);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderUsername(value, options) {
    return renderFormattedText(value, (0, _extends3.default)({}, options, { markdown: false }));
}

function renderUsernameForUserIdAndUsername(userId, username, options) {
    var displayUsername = Utils.getDisplayNameByUserId(userId, options);
    if (displayUsername && displayUsername.trim() !== '') {
        return renderUsername(displayUsername);
    }
    return renderUsername(username);
}

function renderFormattedText(value, options) {
    return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _text_formatting.formatText)(value, options) } });
}

function renderJoinChannelMessage(post, options) {
    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.channel.join_channel.post_and_forget',
        defaultMessage: '{username} joined the channel.',
        values: { username: username }
    });
}

function renderLeaveChannelMessage(post, options) {
    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.channel.leave.left',
        defaultMessage: '{username} has left the channel.',
        values: { username: username }
    });
}

function renderAddToChannelMessage(post, options) {
    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);
    var addedUsername = renderUsernameForUserIdAndUsername(post.props.addedUserId, post.props.addedUsername, options);

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.channel.add_member.added',
        defaultMessage: '{addedUsername} added to the channel by {username}.',
        values: {
            username: username,
            addedUsername: addedUsername
        }
    });
}

function renderRemoveFromChannelMessage(post, options) {
    var removedUsername = renderUsernameForUserIdAndUsername(post.props.removedUserId, post.props.removedUsername, options);

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.channel.remove_member.removed',
        defaultMessage: '{removedUsername} was removed from the channel',
        values: {
            removedUsername: removedUsername
        }
    });
}

function renderJoinTeamMessage(post, options) {
    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.team.join_team.post_and_forget',
        defaultMessage: '{username} joined the team.',
        values: { username: username }
    });
}

function renderLeaveTeamMessage(post, options) {
    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.team.leave.left',
        defaultMessage: '{username} left the team.',
        values: { username: username }
    });
}

function renderAddToTeamMessage(post, options) {
    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);
    var addedUsername = renderUsernameForUserIdAndUsername(post.props.addedUserId, post.props.addedUsername, options);

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.team.add_member.added',
        defaultMessage: '{addedUsername} added to the team by {username}.',
        values: {
            username: username,
            addedUsername: addedUsername
        }
    });
}

function renderRemoveFromTeamMessage(post, options) {
    var removedUsername = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.team.remove_user_from_team.removed',
        defaultMessage: '{removedUsername} was removed from the team.',
        values: {
            removedUsername: removedUsername
        }
    });
}

function renderHeaderChangeMessage(post, options) {
    if (!post.props.username) {
        return null;
    }

    var headerOptions = (0, _extends3.default)({}, options, {
        singleline: true
    });

    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);
    var oldHeader = post.props.old_header ? renderFormattedText(post.props.old_header, headerOptions) : null;
    var newHeader = post.props.new_header ? renderFormattedText(post.props.new_header, headerOptions) : null;

    if (post.props.new_header) {
        if (post.props.old_header) {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'api.channel.post_update_channel_header_message_and_forget.updated_from',
                defaultMessage: '{username} updated the channel header from: {old} to: {new}',
                values: {
                    username: username,
                    old: oldHeader,
                    new: newHeader
                }
            });
        }

        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'api.channel.post_update_channel_header_message_and_forget.updated_to',
            defaultMessage: '{username} updated the channel header to: {new}',
            values: {
                username: username,
                new: newHeader
            }
        });
    } else if (post.props.old_header) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'api.channel.post_update_channel_header_message_and_forget.removed',
            defaultMessage: '{username} removed the channel header (was: {old})',
            values: {
                username: username,
                old: oldHeader
            }
        });
    }

    return null;
}

function renderDisplayNameChangeMessage(post, options) {
    if (!(post.props.username && post.props.old_displayname && post.props.new_displayname)) {
        return null;
    }

    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);
    var oldDisplayName = post.props.old_displayname;
    var newDisplayName = post.props.new_displayname;

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.channel.post_update_channel_displayname_message_and_forget.updated_from',
        defaultMessage: '{username} updated the channel display name from: {old} to: {new}',
        values: {
            username: username,
            old: oldDisplayName,
            new: newDisplayName
        }
    });
}

function renderPurposeChangeMessage(post, options) {
    if (!post.props.username) {
        return null;
    }

    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);
    var oldPurpose = post.props.old_purpose;
    var newPurpose = post.props.new_purpose;

    if (post.props.new_purpose) {
        if (post.props.old_purpose) {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'app.channel.post_update_channel_purpose_message.updated_from',
                defaultMessage: '{username} updated the channel purpose from: {old} to: {new}',
                values: {
                    username: username,
                    old: oldPurpose,
                    new: newPurpose
                }
            });
        }

        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'app.channel.post_update_channel_purpose_message.updated_to',
            defaultMessage: '{username} updated the channel purpose to: {new}',
            values: {
                username: username,
                new: newPurpose
            }
        });
    } else if (post.props.old_purpose) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'app.channel.post_update_channel_purpose_message.removed',
            defaultMessage: '{username} removed the channel purpose (was: {old})',
            values: {
                username: username,
                old: oldPurpose
            }
        });
    }

    return null;
}

function renderChannelDeletedMessage(post, options) {
    if (!post.props.username) {
        return null;
    }

    var username = renderUsernameForUserIdAndUsername(post.user_id, post.props.username, options);

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'api.channel.delete_channel.archived',
        defaultMessage: '{username} has archived the channel.',
        values: { username: username }
    });
}

var systemMessageRenderers = (_systemMessageRendere = {}, (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.JOIN_CHANNEL, renderJoinChannelMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.LEAVE_CHANNEL, renderLeaveChannelMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.ADD_TO_CHANNEL, renderAddToChannelMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.REMOVE_FROM_CHANNEL, renderRemoveFromChannelMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.JOIN_TEAM, renderJoinTeamMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.LEAVE_TEAM, renderLeaveTeamMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.ADD_TO_TEAM, renderAddToTeamMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.REMOVE_FROM_TEAM, renderRemoveFromTeamMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.HEADER_CHANGE, renderHeaderChangeMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.DISPLAYNAME_CHANGE, renderDisplayNameChangeMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.PURPOSE_CHANGE, renderPurposeChangeMessage), (0, _defineProperty3.default)(_systemMessageRendere, _constants.PostTypes.CHANNEL_DELETED, renderChannelDeletedMessage), _systemMessageRendere);

function renderSystemMessage(post, options) {
    if (post.props && post.props.add_channel_member) {
        var channel = _channel_store2.default.getCurrent();
        var isUserCanManageMembers = (0, _channel_utils.canManageMembers)(channel);
        var isEphemeral = Utils.isPostEphemeral(post);

        if ((channel.type === _constants.Constants.PRIVATE_CHANNEL || channel.type === _constants.Constants.OPEN_CHANNEL) && isUserCanManageMembers && isEphemeral) {
            var addMemberProps = post.props.add_channel_member;
            return _react2.default.createElement(_post_add_channel_member2.default, {
                postId: addMemberProps.post_id,
                userIds: addMemberProps.user_ids,
                usernames: addMemberProps.usernames
            });
        }

        return null;
    } else if (systemMessageRenderers[post.type]) {
        return systemMessageRenderers[post.type](post, options);
    } else if (post.type === _constants.PostTypes.EPHEMERAL_ADD_TO_CHANNEL) {
        return renderAddToChannelMessage(post, options);
    }

    return null;
}

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(798);

var _posts = __webpack_require__(808);

var _posts2 = __webpack_require__(805);

var _channels2 = __webpack_require__(783);

var _users = __webpack_require__(777);

var _post_add_channel_member = __webpack_require__(1968);

var _post_add_channel_member2 = _interopRequireDefault(_post_add_channel_member);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var post = (0, _posts2.getPost)(state, ownProps.postId) || {};
    var channelType = '';
    if (post && post.channel_id) {
        var channel = (0, _channels2.getChannel)(state, post.channel_id);
        if (channel && channel.type) {
            channelType = channel.type;
        }
    }

    return (0, _extends3.default)({}, ownProps, {
        channelType: channelType,
        currentUser: (0, _users.getCurrentUser)(state),
        post: post
    });
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            addChannelMember: _channels.addChannelMember,
            removePost: _posts.removePost
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_post_add_channel_member2.default);

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _global_actions = __webpack_require__(778);

var _constants = __webpack_require__(29);

var _at_mention = __webpack_require__(1141);

var _at_mention2 = _interopRequireDefault(_at_mention);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PostAddChannelMember = function (_React$PureComponent) {
    (0, _inherits3.default)(PostAddChannelMember, _React$PureComponent);

    function PostAddChannelMember() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PostAddChannelMember);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PostAddChannelMember.__proto__ || (0, _getPrototypeOf2.default)(PostAddChannelMember)).call.apply(_ref, [this].concat(args))), _this), _this.handleAddChannelMember = function () {
            var _this$props = _this.props,
                currentUser = _this$props.currentUser,
                post = _this$props.post,
                userIds = _this$props.userIds,
                usernames = _this$props.usernames;


            if (post && post.channel_id) {
                var createAt = post.create_at;
                userIds.forEach(function (userId, index) {
                    createAt++;
                    _this.props.actions.addChannelMember(post.channel_id, userId);
                    (0, _global_actions.sendAddToChannelEphemeralPost)(currentUser, usernames[index], userId, post.channel_id, post.root_id, createAt);
                });

                _this.props.actions.removePost(post);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PostAddChannelMember, [{
        key: 'generateAtMentions',
        value: function generateAtMentions() {
            var usernames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            if (usernames.length === 1) {
                return _react2.default.createElement(_at_mention2.default, { mentionName: usernames[0] });
            } else if (usernames.length > 1) {
                var andSeparator = function andSeparator(key) {
                    return _react2.default.createElement(_reactIntl.FormattedMessage, {
                        key: key,
                        id: 'post_body.check_for_out_of_channel_mentions.link.and',
                        defaultMessage: ' and '
                    });
                };

                var commaSeparator = function commaSeparator(key) {
                    return _react2.default.createElement(
                        'span',
                        { key: key },
                        ', '
                    );
                };

                return _react2.default.createElement(
                    'span',
                    null,
                    usernames.map(function (username) {
                        return _react2.default.createElement(_at_mention2.default, {
                            key: username,
                            mentionName: username
                        });
                    }).reduce(function (acc, el, idx, arr) {
                        if (idx === 0) {
                            return [el];
                        } else if (idx === arr.length - 1) {
                            return [].concat((0, _toConsumableArray3.default)(acc), [andSeparator(idx), el]);
                        }

                        return [].concat((0, _toConsumableArray3.default)(acc), [commaSeparator(idx), el]);
                    }, [])
                );
            }

            return '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                channelType = _props.channelType,
                postId = _props.postId,
                usernames = _props.usernames;

            if (!postId || !channelType) {
                return null;
            }

            var linkId = void 0;
            var linkText = void 0;
            if (channelType === _constants.Constants.PRIVATE_CHANNEL) {
                linkId = 'post_body.check_for_out_of_channel_mentions.link.private';
                linkText = 'add them to this private channel';
            } else if (channelType === _constants.Constants.OPEN_CHANNEL) {
                linkId = 'post_body.check_for_out_of_channel_mentions.link.public';
                linkText = 'add them to the channel';
            }

            var messageId = void 0;
            var messageText = void 0;
            if (usernames.length === 1) {
                messageId = 'post_body.check_for_out_of_channel_mentions.message.one';
                messageText = 'was mentioned but is not in the channel. Would you like to ';
            } else if (usernames.length > 1) {
                messageId = 'post_body.check_for_out_of_channel_mentions.message.multiple';
                messageText = 'were mentioned but they are not in the channel. Would you like to ';
            }

            var atMentions = this.generateAtMentions(usernames);

            return _react2.default.createElement(
                'p',
                null,
                atMentions,
                ' ',
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: messageId,
                    defaultMessage: messageText
                }),
                _react2.default.createElement(
                    'a',
                    {
                        id: 'add_channel_member_link',
                        onClick: this.handleAddChannelMember
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: linkId,
                        defaultMessage: linkText
                    })
                ),
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'post_body.check_for_out_of_channel_mentions.message_last',
                    defaultMessage: '? They will have access to all message history.'
                })
            );
        }
    }]);
    return PostAddChannelMember;
}(_react2.default.PureComponent);

PostAddChannelMember.propTypes = {

    /*
    * Current user
    */
    currentUser: _propTypes2.default.object.isRequired,

    /*
    * Type of current channel
    */
    channelType: _propTypes2.default.string.isRequired,

    /*
    * ID of ephemeral post (at-mention's "add to channel" post)
    */
    postId: _propTypes2.default.string.isRequired,

    /*
    * Ephemeral post (at-mention's "add to channel" post)
    */
    post: _propTypes2.default.object.isRequired,

    /*
    * user ids to add to channel
    */
    userIds: _propTypes2.default.array.isRequired,

    /*
    * usernames to add to channel
    */
    usernames: _propTypes2.default.array.isRequired,

    actions: _propTypes2.default.shape({

        /*
        * Function to add members to channel
        */
        addChannelMember: _propTypes2.default.func.isRequired,

        /*
        * Function to remove post (ephemeral)
        */
        removePost: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = PostAddChannelMember;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _xregexp = __webpack_require__(1031);

var _xregexp2 = _interopRequireDefault(_xregexp);

var _user_actions = __webpack_require__(781);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _provider = __webpack_require__(866);

var _provider2 = _interopRequireDefault(_provider);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var AtMentionSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(AtMentionSuggestion, _Suggestion);

    function AtMentionSuggestion() {
        (0, _classCallCheck3.default)(this, AtMentionSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (AtMentionSuggestion.__proto__ || (0, _getPrototypeOf2.default)(AtMentionSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(AtMentionSuggestion, [{
        key: 'render',
        value: function render() {
            var isSelection = this.props.isSelection;
            var user = this.props.item;

            var username = void 0;
            var description = void 0;
            var icon = void 0;
            if (user.username === 'all') {
                username = 'all';
                description = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'suggestion.mention.all',
                    defaultMessage: 'CAUTION: This mentions everyone in channel'
                });
                icon = _react2.default.createElement('i', { className: 'mention__image fa fa-users fa-2x' });
            } else if (user.username === 'channel') {
                username = 'channel';
                description = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'suggestion.mention.channel',
                    defaultMessage: 'Notifies everyone in the channel'
                });
                icon = _react2.default.createElement('i', { className: 'mention__image fa fa-users fa-2x' });
            } else if (user.username === 'here') {
                username = 'here';
                description = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'suggestion.mention.here',
                    defaultMessage: 'Notifies everyone in the channel and online'
                });
                icon = _react2.default.createElement('i', { className: 'mention__image fa fa-users fa-2x' });
            } else {
                username = user.username;

                if ((user.first_name || user.last_name) && user.nickname) {
                    description = '- ' + Utils.getFullName(user) + ' (' + user.nickname + ')';
                } else if (user.nickname) {
                    description = '- (' + user.nickname + ')';
                } else if (user.first_name || user.last_name) {
                    description = '- ' + Utils.getFullName(user);
                }

                icon = _react2.default.createElement('img', {
                    className: 'mention__image',
                    src: Utils.imageURLForUser(user)
                });
            }

            var className = 'mentions__name';
            if (isSelection) {
                className += ' suggestion--selected';
            }

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.handleClick
                },
                _react2.default.createElement(
                    'div',
                    { className: 'pull-left' },
                    icon
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pull-left mention--align' },
                    _react2.default.createElement(
                        'span',
                        null,
                        '@' + username
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'mention__fullname' },
                        ' ',
                        description
                    )
                )
            );
        }
    }]);
    return AtMentionSuggestion;
}(_suggestion2.default);

var AtMentionProvider = function (_Provider) {
    (0, _inherits3.default)(AtMentionProvider, _Provider);

    function AtMentionProvider(channelId) {
        (0, _classCallCheck3.default)(this, AtMentionProvider);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (AtMentionProvider.__proto__ || (0, _getPrototypeOf2.default)(AtMentionProvider)).call(this));

        _this2.channelId = channelId;
        return _this2;
    }

    (0, _createClass3.default)(AtMentionProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, pretext) {
            var _this3 = this;

            var captured = _xregexp2.default.cache('(?:^|\\W)@([\\pL\\d\\-_.]*)$', 'i').exec(pretext.toLowerCase());
            if (!captured) {
                return false;
            }

            var prefix = captured[1];

            this.startNewRequest(suggestionId, prefix);

            (0, _user_actions.autocompleteUsersInChannel)(prefix, this.channelId, function (data) {
                if (_this3.shouldCancelDispatch(prefix)) {
                    return;
                }

                var members = (0, _assign2.default)([], data.users);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(members)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var id = _step.value;

                        members[id] = (0, _extends3.default)({}, members[id], { type: _constants.Constants.MENTION_MEMBERS });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var nonmembers = data.out_of_channel || [];
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(nonmembers)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _id = _step2.value;

                        nonmembers[_id] = (0, _extends3.default)({}, nonmembers[_id], { type: _constants.Constants.MENTION_NONMEMBERS });
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                var specialMentions = [];
                if (!pretext.startsWith('/msg')) {
                    specialMentions = ['here', 'channel', 'all'].filter(function (item) {
                        return item.startsWith(prefix);
                    }).map(function (name) {
                        return { username: name, type: _constants.Constants.MENTION_SPECIAL };
                    });
                }

                var users = members.concat(specialMentions).concat(nonmembers);
                var me = _user_store2.default.getCurrentUser();
                users = users.filter(function (user) {
                    return user.id !== me.id;
                });

                var mentions = users.map(function (user) {
                    return '@' + user.username;
                });

                _app_dispatcher2.default.handleServerAction({
                    type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                    id: suggestionId,
                    matchedPretext: '@' + captured[1],
                    terms: mentions,
                    items: users,
                    component: AtMentionSuggestion
                });
            });

            return true;
        }
    }]);
    return AtMentionProvider;
}(_provider2.default);

exports.default = AtMentionProvider;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _channel_actions = __webpack_require__(809);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _suggestion_store = __webpack_require__(969);

var _suggestion_store2 = _interopRequireDefault(_suggestion_store);

var _constants = __webpack_require__(29);

var _channel_utils = __webpack_require__(830);

var ChannelUtils = _interopRequireWildcard(_channel_utils);

var _provider = __webpack_require__(866);

var _provider2 = _interopRequireDefault(_provider);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChannelMentionSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(ChannelMentionSuggestion, _Suggestion);

    function ChannelMentionSuggestion() {
        (0, _classCallCheck3.default)(this, ChannelMentionSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (ChannelMentionSuggestion.__proto__ || (0, _getPrototypeOf2.default)(ChannelMentionSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(ChannelMentionSuggestion, [{
        key: 'render',
        value: function render() {
            var isSelection = this.props.isSelection;
            var item = this.props.item;

            var channelName = item.channel.display_name;
            var purpose = item.channel.purpose;

            var className = 'mentions__name';
            if (isSelection) {
                className += ' suggestion--selected';
            }

            var description = '(~' + item.channel.name + ')';

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.handleClick
                },
                _react2.default.createElement(
                    'div',
                    { className: 'mention__align' },
                    _react2.default.createElement(
                        'span',
                        null,
                        channelName
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'mention__channelname' },
                        ' ',
                        description
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mention__purpose' },
                    purpose
                )
            );
        }
    }]);
    return ChannelMentionSuggestion;
}(_suggestion2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ChannelMentionProvider = function (_Provider) {
    (0, _inherits3.default)(ChannelMentionProvider, _Provider);

    function ChannelMentionProvider() {
        (0, _classCallCheck3.default)(this, ChannelMentionProvider);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (ChannelMentionProvider.__proto__ || (0, _getPrototypeOf2.default)(ChannelMentionProvider)).call(this));

        _this2.lastPrefixWithNoResults = '';
        _this2.lastCompletedWord = '';
        return _this2;
    }

    (0, _createClass3.default)(ChannelMentionProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, pretext) {
            var _this3 = this;

            var captured = /(^|\s)(~([^~\r\n]*))$/i.exec(pretext.toLowerCase());

            if (!captured) {
                // Not a channel mention
                return false;
            }

            var prefix = captured[3];

            if (this.lastPrefixWithNoResults && prefix.startsWith(this.lastPrefixWithNoResults)) {
                // Just give up since we know it won't return any results
                return false;
            }

            if (this.lastCompletedWord && captured[0].startsWith(this.lastCompletedWord)) {
                // It appears we're still matching a channel handle that we already completed
                return false;
            }

            // Clear the last completed word since we've started to match new text
            this.lastCompletedWord = '';

            this.startNewRequest(suggestionId, prefix);

            _suggestion_store2.default.clearSuggestions(suggestionId);

            var words = prefix.toLowerCase().split(/\s+/);
            var wrappedChannelIds = {};
            var wrappedChannels = [];
            _channel_store2.default.getAll().forEach(function (item) {
                if (item.type !== 'O' || item.delete_at > 0) {
                    return;
                }
                var nameWords = item.name.toLowerCase().split(/\s+/).concat(item.display_name.toLowerCase().split(/\s+/));
                var matched = true;
                for (var j = 0; matched && j < words.length; j++) {
                    if (!words[j]) {
                        continue;
                    }
                    var wordMatched = false;
                    for (var i = 0; i < nameWords.length; i++) {
                        if (nameWords[i].startsWith(words[j])) {
                            wordMatched = true;
                            break;
                        }
                    }
                    if (!wordMatched) {
                        matched = false;
                        break;
                    }
                }
                if (!matched) {
                    return;
                }
                wrappedChannelIds[item.id] = true;
                wrappedChannels.push({
                    type: _constants.Constants.MENTION_CHANNELS,
                    channel: item
                });
            });
            wrappedChannels = wrappedChannels.sort(function (a, b) {
                return ChannelUtils.sortChannelsByDisplayName(a.channel, b.channel);
            });
            var channelMentions = wrappedChannels.map(function (item) {
                return '~' + item.channel.name;
            });
            if (channelMentions.length > 0) {
                _suggestion_store2.default.addSuggestions(suggestionId, channelMentions, wrappedChannels, ChannelMentionSuggestion, captured[2]);
            }

            _suggestion_store2.default.addSuggestions(suggestionId, [''], [{
                type: _constants.Constants.MENTION_MORE_CHANNELS,
                loading: true
            }], ChannelMentionSuggestion, captured[2]);

            (0, _channel_actions.autocompleteChannels)(prefix, function (channels) {
                if (_this3.shouldCancelDispatch(prefix)) {
                    return;
                }

                if (channels.length === 0) {
                    _this3.lastPrefixWithNoResults = prefix;
                }

                // Wrap channels in an outer object to avoid overwriting the 'type' property.
                var wrappedMoreChannels = [];
                var moreChannels = [];
                channels.forEach(function (item) {
                    if (_channel_store2.default.get(item.id)) {
                        if (!wrappedChannelIds[item.id]) {
                            wrappedChannelIds[item.id] = true;
                            wrappedChannels.push({
                                type: _constants.Constants.MENTION_CHANNELS,
                                channel: item
                            });
                        }
                        return;
                    }

                    wrappedMoreChannels.push({
                        type: _constants.Constants.MENTION_MORE_CHANNELS,
                        channel: item
                    });

                    moreChannels.push(item);
                });

                wrappedChannels = wrappedChannels.sort(function (a, b) {
                    return ChannelUtils.sortChannelsByDisplayName(a.channel, b.channel);
                });
                var wrapped = wrappedChannels.concat(wrappedMoreChannels);
                var mentions = wrapped.map(function (item) {
                    return '~' + item.channel.name;
                });

                _app_dispatcher2.default.handleServerAction({
                    type: _constants.ActionTypes.RECEIVED_MORE_CHANNELS,
                    channels: moreChannels
                });

                _app_dispatcher2.default.handleServerAction({
                    type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                    id: suggestionId,
                    matchedPretext: captured[2],
                    terms: mentions,
                    items: wrapped,
                    component: ChannelMentionSuggestion
                });
            });

            return true;
        }
    }, {
        key: 'handleCompleteWord',
        value: function handleCompleteWord(term) {
            this.lastCompletedWord = term;
            this.lastPrefixWithNoResults = '';
        }
    }]);
    return ChannelMentionProvider;
}(_provider2.default);

exports.default = ChannelMentionProvider;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _integration_actions = __webpack_require__(1313);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommandSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(CommandSuggestion, _Suggestion);

    function CommandSuggestion() {
        (0, _classCallCheck3.default)(this, CommandSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (CommandSuggestion.__proto__ || (0, _getPrototypeOf2.default)(CommandSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(CommandSuggestion, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                isSelection = _props.isSelection;


            var className = 'command';
            if (isSelection) {
                className += ' suggestion--selected';
            }

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.handleClick
                },
                _react2.default.createElement(
                    'div',
                    { className: 'command__title' },
                    _react2.default.createElement(
                        'string',
                        null,
                        item.suggestion,
                        ' ',
                        item.hint
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'command__desc' },
                    item.description
                )
            );
        }
    }]);
    return CommandSuggestion;
}(_suggestion2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CommandProvider = function () {
    function CommandProvider() {
        (0, _classCallCheck3.default)(this, CommandProvider);
    }

    (0, _createClass3.default)(CommandProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, pretext) {
            if (pretext.startsWith('/')) {
                (0, _integration_actions.getSuggestedCommands)(pretext.toLowerCase(), suggestionId, CommandSuggestion, pretext.toLowerCase());

                return true;
            }
            return false;
        }
    }]);
    return CommandProvider;
}();

exports.default = CommandProvider;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(1315);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(1975);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
};


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),
/* 1976 */
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _emojis = __webpack_require__(853);

var _emojis2 = __webpack_require__(961);

var _emoji_store = __webpack_require__(829);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _suggestion_store = __webpack_require__(969);

var _suggestion_store2 = _interopRequireDefault(_suggestion_store);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _emoticons = __webpack_require__(1032);

var Emoticons = _interopRequireWildcard(_emoticons);

var _constants = __webpack_require__(29);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MIN_EMOTICON_LENGTH = 2;
var EMOJI_CATEGORY_SUGGESTION_BLACKLIST = ['skintone'];

var EmoticonSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(EmoticonSuggestion, _Suggestion);

    function EmoticonSuggestion() {
        (0, _classCallCheck3.default)(this, EmoticonSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (EmoticonSuggestion.__proto__ || (0, _getPrototypeOf2.default)(EmoticonSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(EmoticonSuggestion, [{
        key: 'render',
        value: function render() {
            var text = this.props.term;
            var emoji = this.props.item.emoji;

            var className = 'emoticon-suggestion';
            if (this.props.isSelection) {
                className += ' suggestion--selected';
            }

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.handleClick
                },
                _react2.default.createElement(
                    'div',
                    { className: 'pull-left' },
                    _react2.default.createElement('img', {
                        alt: text,
                        className: 'emoticon-suggestion__image',
                        src: _emoji_store2.default.getEmojiImageUrl(emoji),
                        title: text
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pull-left' },
                    text
                )
            );
        }
    }]);
    return EmoticonSuggestion;
}(_suggestion2.default);

var EmoticonProvider = function () {
    function EmoticonProvider() {
        (0, _classCallCheck3.default)(this, EmoticonProvider);
    }

    (0, _createClass3.default)(EmoticonProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, pretext) {
            var _this2 = this;

            // Look for the potential emoticons at the start of the text, after whitespace, and at the start of emoji reaction commands
            var captured = /(^|\s|^\+|^-)(:([^:\s]*))$/g.exec(pretext);
            if (!captured) {
                return false;
            }

            var prefix = captured[1];
            var text = captured[2];
            var partialName = captured[3];

            if (partialName.length < MIN_EMOTICON_LENGTH) {
                _suggestion_store2.default.clearSuggestions(suggestionId);
                return false;
            }

            // Check for text emoticons if this isn't for an emoji reaction
            if (prefix !== '-' && prefix !== '+') {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(Emoticons.emoticonPatterns)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var emoticon = _step.value;

                        if (Emoticons.emoticonPatterns[emoticon].test(text)) {
                            // Don't show the autocomplete for text emoticons
                            return false;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            if (_redux_store2.default.getState().entities.general.config.EnableCustomEmoji === 'true') {
                (0, _emojis.autocompleteCustomEmojis)(partialName)(_redux_store2.default.dispatch, _redux_store2.default.getState).then(function () {
                    return _this2.findAndSuggestEmojis(suggestionId, text, partialName);
                });
            }

            this.findAndSuggestEmojis(suggestionId, text, partialName);

            return true;
        }
    }, {
        key: 'findAndSuggestEmojis',
        value: function findAndSuggestEmojis(suggestionId, text, partialName) {
            var matched = [];

            var emojiMap = (0, _emojis2.getEmojiMap)(_redux_store2.default.getState());

            // Check for named emoji
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(emojiMap), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                        name = _step2$value[0],
                        emoji = _step2$value[1];

                    if (emoji.aliases) {
                        // This is a system emoji so it may have multiple names
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = (0, _getIterator3.default)(emoji.aliases), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var alias = _step3.value;

                                if (!EMOJI_CATEGORY_SUGGESTION_BLACKLIST.includes(emoji.category) && alias.indexOf(partialName) !== -1) {
                                    matched.push({ name: alias, emoji: emoji });
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    } else if (name.indexOf(partialName) !== -1) {
                        // This is a custom emoji so it only has one name
                        if (_emoji_store2.default.hasSystemEmoji(name)) {
                            // System emojis take precedence over custom ones
                            continue;
                        }

                        matched.push({ name: name, emoji: emoji });
                    }
                }

                // Sort the emoticons so that emoticons starting with the entered text come first
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            matched.sort(function (a, b) {
                var aName = a.name;
                var bName = b.name;

                var aPrefix = aName.startsWith(partialName);
                var bPrefix = bName.startsWith(partialName);

                if (aPrefix === bPrefix) {
                    return aName.localeCompare(bName);
                } else if (aPrefix) {
                    return -1;
                }

                return 1;
            });

            var terms = matched.map(function (item) {
                return ':' + item.name + ':';
            });

            // Required to get past the dispatch during dispatch error
            setTimeout(function () {
                _app_dispatcher2.default.handleServerAction({
                    type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                    id: suggestionId,
                    matchedPretext: text,
                    terms: terms,
                    items: matched,
                    component: EmoticonSuggestion
                });
            }, 0);
        }
    }]);
    return EmoticonProvider;
}();

exports.default = EmoticonProvider;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _teams = __webpack_require__(274);

var _url = __webpack_require__(793);

var _get_post_link_modal = __webpack_require__(1979);

var _get_post_link_modal2 = _interopRequireDefault(_get_post_link_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var currentTeam = (0, _teams.getCurrentTeam)(state) || {};
    var currentTeamUrl = (0, _url.getSiteURL)() + '/' + currentTeam.name;
    return (0, _extends3.default)({}, ownProps, {
        currentTeamUrl: currentTeamUrl
    });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_get_post_link_modal2.default);

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _get_link_modal = __webpack_require__(1039);

var _get_link_modal2 = _interopRequireDefault(_get_link_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var GetPostLinkModal = function (_React$PureComponent) {
    (0, _inherits3.default)(GetPostLinkModal, _React$PureComponent);

    function GetPostLinkModal(props) {
        (0, _classCallCheck3.default)(this, GetPostLinkModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GetPostLinkModal.__proto__ || (0, _getPrototypeOf2.default)(GetPostLinkModal)).call(this, props));

        _this.handleToggle = _this.handleToggle.bind(_this);
        _this.hide = _this.hide.bind(_this);

        _this.state = {
            show: false,
            post: {}
        };
        return _this;
    }

    (0, _createClass3.default)(GetPostLinkModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _modal_store2.default.addModalListener(_constants2.default.ActionTypes.TOGGLE_GET_POST_LINK_MODAL, this.handleToggle);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _modal_store2.default.removeModalListener(_constants2.default.ActionTypes.TOGGLE_GET_POST_LINK_MODAL, this.handleToggle);
        }
    }, {
        key: 'handleToggle',
        value: function handleToggle(value, args) {
            this.setState({
                show: value,
                post: args.post
            });
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.setState({
                show: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var postUrl = this.props.currentTeamUrl + '/pl/' + this.state.post.id;
            return _react2.default.createElement(_get_link_modal2.default, {
                show: this.state.show,
                onHide: this.hide,
                title: Utils.localizeMessage('get_post_link_modal.title', 'Copy Permalink'),
                helpText: Utils.localizeMessage('get_post_link_modal.help', 'The link below allows authorized users to see your post.'),
                link: postUrl
            });
        }
    }]);
    return GetPostLinkModal;
}(_react2.default.PureComponent);

GetPostLinkModal.propTypes = {

    /**
     * URL of current team
     */
    currentTeamUrl: _propTypes2.default.string.isRequired
};
exports.default = GetPostLinkModal;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _teams = __webpack_require__(274);

var _general = __webpack_require__(113);

var _get_team_invite_link_modal = __webpack_require__(1981);

var _get_team_invite_link_modal2 = _interopRequireDefault(_get_team_invite_link_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        currentTeam: (0, _teams.getCurrentTeam)(state),
        config: (0, _general.getConfig)(state)
    });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_get_team_invite_link_modal2.default);

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _url = __webpack_require__(793);

var _get_link_modal = __webpack_require__(1039);

var _get_link_modal2 = _interopRequireDefault(_get_link_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetTeamInviteLinkModal = function (_React$PureComponent) {
    (0, _inherits3.default)(GetTeamInviteLinkModal, _React$PureComponent);

    function GetTeamInviteLinkModal(props) {
        (0, _classCallCheck3.default)(this, GetTeamInviteLinkModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GetTeamInviteLinkModal.__proto__ || (0, _getPrototypeOf2.default)(GetTeamInviteLinkModal)).call(this, props));

        _this.handleToggle = function (value) {
            _this.setState({
                show: value
            });
        };

        _this.onHide = function () {
            _this.handleToggle(false);
        };

        _this.state = {
            show: false
        };
        return _this;
    }

    (0, _createClass3.default)(GetTeamInviteLinkModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _modal_store2.default.addModalListener(_constants2.default.ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL, this.handleToggle);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _modal_store2.default.removeModalListener(_constants2.default.ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL, this.handleToggle);
        }
    }, {
        key: 'render',
        value: function render() {
            var inviteUrl = (0, _url.getSiteURL)() + '/signup_user_complete/?id=' + this.props.currentTeam.invite_id;

            var helpText = void 0;
            if (this.props.config.EnableUserCreation === 'true') {
                helpText = Utils.localizeMessage('get_team_invite_link_modal.help', 'Send teammates the link below for them to sign-up to this team site. The Team Invite Link can be shared with multiple teammates as it does not change unless it\'s regenerated in Team Settings by a Team Admin.');
            } else {
                helpText = Utils.localizeMessage('get_team_invite_link_modal.helpDisabled', 'User creation has been disabled for your team. Please ask your team administrator for details.');
            }

            return _react2.default.createElement(_get_link_modal2.default, {
                show: this.state.show,
                onHide: this.onHide,
                title: Utils.localizeMessage('get_team_invite_link_modal.title', 'Team Invite Link'),
                helpText: helpText,
                link: inviteUrl
            });
        }
    }]);
    return GetTeamInviteLinkModal;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

GetTeamInviteLinkModal.propTypes = {

    /**
     * Current team object
     */
    currentTeam: _propTypes2.default.object.isRequired,

    /**
     * Global config object
     */
    config: _propTypes2.default.object.isRequired
};
GetTeamInviteLinkModal.defaultProps = {
    currentTeam: {}
};
exports.default = GetTeamInviteLinkModal;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _files = __webpack_require__(1040);

var _files2 = __webpack_require__(1041);

var Selectors = _interopRequireWildcard(_files2);

var _get_public_link_modal = __webpack_require__(1983);

var _get_public_link_modal2 = _interopRequireDefault(_get_public_link_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        link: Selectors.getFilePublicLink(state).link
    });
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getFilePublicLink: _files.getFilePublicLink
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_get_public_link_modal2.default);

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _get_link_modal = __webpack_require__(1039);

var _get_link_modal2 = _interopRequireDefault(_get_link_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var GetPublicLinkModal = function (_React$PureComponent) {
    (0, _inherits3.default)(GetPublicLinkModal, _React$PureComponent);

    function GetPublicLinkModal(props) {
        (0, _classCallCheck3.default)(this, GetPublicLinkModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GetPublicLinkModal.__proto__ || (0, _getPrototypeOf2.default)(GetPublicLinkModal)).call(this, props));

        _this.handleToggle = function (value, args) {
            _this.setState({
                show: value,
                fileId: args.fileId
            });
        };

        _this.onHide = function () {
            _this.setState({
                show: false
            });
        };

        _this.state = {
            show: false,
            fileId: ''
        };
        return _this;
    }

    (0, _createClass3.default)(GetPublicLinkModal, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _modal_store2.default.removeModalListener(_constants2.default.ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL, this.handleToggle);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _modal_store2.default.addModalListener(_constants2.default.ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL, this.handleToggle);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.show && !prevState.show) {
                this.props.actions.getFilePublicLink(this.state.fileId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_get_link_modal2.default, {
                show: this.state.show,
                onHide: this.onHide,
                title: Utils.localizeMessage('get_public_link_modal.title', 'Copy Public Link'),
                helpText: Utils.localizeMessage('get_public_link_modal.help', 'The link below allows anyone to see this file without being registered on this server.'),
                link: this.props.link
            });
        }
    }]);
    return GetPublicLinkModal;
}(_react2.default.PureComponent);

GetPublicLinkModal.propTypes = {

    /**
     * Public link of the file
     */
    link: _propTypes2.default.string,

    actions: _propTypes2.default.shape({

        /**
         * An action to get public link
         */
        getFilePublicLink: _propTypes2.default.func.isRequired
    }).isRequired
};
GetPublicLinkModal.defaultProps = {
    link: ''
};
exports.default = GetPublicLinkModal;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _invite_member_modal = __webpack_require__(1985);

var _invite_member_modal2 = _interopRequireDefault(_invite_member_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    var sendEmailNotifications = config.SendEmailNotifications === 'true';
    var enableUserCreation = config.EnableUserCreation === 'true';

    return {
        sendEmailNotifications: sendEmailNotifications,
        enableUserCreation: enableUserCreation
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_invite_member_modal2.default);

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _team_actions = __webpack_require__(832);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var utils = _interopRequireWildcard(_utils);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ActionTypes = _constants2.default.ActionTypes;

var holders = (0, _reactIntl.defineMessages)({
    emailError: {
        id: 'invite_member.emailError',
        defaultMessage: 'Please enter a valid email address'
    },
    firstname: {
        id: 'invite_member.firstname',
        defaultMessage: 'First name'
    },
    lastname: {
        id: 'invite_member.lastname',
        defaultMessage: 'Last name'
    },
    modalTitle: {
        id: 'invite_member.modalTitle',
        defaultMessage: 'Discard Invitations?'
    },
    modalMessage: {
        id: 'invite_member.modalMessage',
        defaultMessage: 'You have unsent invitations, are you sure you want to discard them?'
    },
    modalButton: {
        id: 'invite_member.modalButton',
        defaultMessage: 'Yes, Discard'
    }
});

var InviteMemberModal = function (_React$Component) {
    (0, _inherits3.default)(InviteMemberModal, _React$Component);

    function InviteMemberModal(props) {
        (0, _classCallCheck3.default)(this, InviteMemberModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InviteMemberModal.__proto__ || (0, _getPrototypeOf2.default)(InviteMemberModal)).call(this, props));

        _initialiseProps.call(_this);

        var team = _team_store2.default.getCurrent();

        _this.state = {
            show: false,
            inviteIds: [0],
            idCount: 0,
            emailErrors: {},
            firstNameErrors: {},
            lastNameErrors: {},
            showConfirmModal: false,
            isSendingEmails: false,
            teamType: team ? team.type : null
        };
        return _this;
    }

    (0, _createClass3.default)(InviteMemberModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _modal_store2.default.addModalListener(ActionTypes.TOGGLE_INVITE_MEMBER_MODAL, this.handleToggle);
            _team_store2.default.addChangeListener(this.teamChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _modal_store2.default.removeModalListener(ActionTypes.TOGGLE_INVITE_MEMBER_MODAL, this.handleToggle);
            _team_store2.default.removeChangeListener(this.teamChange);
        }
    }, {
        key: 'render',
        value: function render() {
            var currentUser = _user_store2.default.getCurrentUser();
            var formatMessage = this.props.intl.formatMessage;


            if (currentUser != null && this.state.teamType != null) {
                var inviteSections = [];
                var inviteIds = this.state.inviteIds;
                for (var i = 0; i < inviteIds.length; i++) {
                    var index = inviteIds[i];
                    var emailError = null;
                    if (this.state.emailErrors[index]) {
                        emailError = _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            this.state.emailErrors[index]
                        );
                    }
                    var firstNameError = null;
                    if (this.state.firstNameErrors[index]) {
                        firstNameError = _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            this.state.firstNameErrors[index]
                        );
                    }
                    var lastNameError = null;
                    if (this.state.lastNameErrors[index]) {
                        lastNameError = _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            this.state.lastNameErrors[index]
                        );
                    }

                    var removeButton = null;
                    if (index) {
                        removeButton = _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'button',
                                {
                                    type: 'button',
                                    className: 'btn btn-link remove__member',
                                    onClick: this.removeInviteFields.bind(this, index)
                                },
                                _react2.default.createElement('span', { className: 'fa fa-trash' })
                            )
                        );
                    }
                    var emailClass = 'form-group invite';
                    if (emailError) {
                        emailClass += ' has-error';
                    }

                    var nameFields = null;

                    var firstNameClass = 'form-group';
                    if (firstNameError) {
                        firstNameClass += ' has-error';
                    }
                    var lastNameClass = 'form-group';
                    if (lastNameError) {
                        lastNameClass += ' has-error';
                    }
                    nameFields = _react2.default.createElement(
                        'div',
                        { className: 'row row--invite' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(
                                'div',
                                { className: firstNameClass },
                                _react2.default.createElement('input', {
                                    onKeyDown: this.handleKeyDown,
                                    type: 'text',
                                    className: 'form-control',
                                    ref: 'first_name' + index,
                                    placeholder: formatMessage(holders.firstname),
                                    maxLength: '64',
                                    disabled: !this.props.sendEmailNotifications || !this.props.enableUserCreation,
                                    spellCheck: 'false'
                                }),
                                firstNameError
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(
                                'div',
                                { className: lastNameClass },
                                _react2.default.createElement('input', {
                                    onKeyDown: this.handleKeyDown,
                                    type: 'text',
                                    className: 'form-control',
                                    ref: 'last_name' + index,
                                    placeholder: formatMessage(holders.lastname),
                                    maxLength: '64',
                                    disabled: !this.props.sendEmailNotifications || !this.props.enableUserCreation,
                                    spellCheck: 'false'
                                }),
                                lastNameError
                            )
                        )
                    );

                    inviteSections[index] = _react2.default.createElement(
                        'div',
                        { key: 'key' + index },
                        removeButton,
                        _react2.default.createElement(
                            'div',
                            { className: emailClass },
                            _react2.default.createElement('input', {
                                onKeyUp: this.displayNameKeyUp,
                                onKeyDown: this.handleKeyDown,
                                type: 'text',
                                ref: 'email' + index,
                                className: 'form-control',
                                placeholder: 'email@domain.com',
                                maxLength: '64',
                                disabled: !this.props.sendEmailNotifications || !this.props.enableUserCreation,
                                spellCheck: 'false',
                                autoFocus: true
                            }),
                            emailError
                        ),
                        nameFields
                    );
                }

                var serverError = null;
                if (this.state.serverError) {
                    serverError = _react2.default.createElement(
                        'div',
                        { className: 'form-group has-error' },
                        _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            this.state.serverError
                        )
                    );
                }

                var content = null;
                var sendButton = null;

                var defaultChannelName = '';
                if (_channel_store2.default.getByName(_constants2.default.DEFAULT_CHANNEL)) {
                    defaultChannelName = _channel_store2.default.getByName(_constants2.default.DEFAULT_CHANNEL).display_name;
                }

                if (this.props.sendEmailNotifications && this.props.enableUserCreation) {
                    content = _react2.default.createElement(
                        'div',
                        null,
                        serverError,
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'btn btn-default',
                                onClick: this.addInviteFields
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'invite_member.addAnother',
                                defaultMessage: 'Add another'
                            })
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                id: 'invite_member.autoJoin',
                                defaultMessage: 'People invited automatically join the <strong>{channel}</strong> channel.',
                                values: {
                                    channel: defaultChannelName
                                }
                            })
                        )
                    );

                    var sendButtonLabel = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'invite_member.send',
                        defaultMessage: 'Send Invitation'
                    });
                    if (this.state.isSendingEmails) {
                        sendButtonLabel = _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'invite_member.sending',
                                defaultMessage: ' Sending'
                            })
                        );
                    } else if (this.state.inviteIds.length > 1) {
                        sendButtonLabel = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'invite_member.send2',
                            defaultMessage: 'Send Invitations'
                        });
                    }

                    sendButton = _react2.default.createElement(
                        'button',
                        {
                            onClick: this.handleSubmit,
                            type: 'button',
                            className: 'btn btn-primary',
                            disabled: this.state.isSendingEmails
                        },
                        sendButtonLabel
                    );
                } else if (this.props.enableUserCreation) {
                    var teamInviteLink = null;
                    if (currentUser && this.state.teamType === 'O') {
                        var link = _react2.default.createElement(
                            'button',
                            {
                                className: 'color--link style--none',
                                onClick: this.showGetTeamInviteLinkModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'invite_member.inviteLink',
                                defaultMessage: 'Team Invite Link'
                            })
                        );

                        teamInviteLink = _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'invite_member.teamInviteLink',
                                defaultMessage: 'You can also invite people using the {link}.',
                                values: {
                                    link: link
                                }
                            })
                        );
                    }

                    content = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'invite_member.content',
                                defaultMessage: 'Email is currently disabled for your team, and email invitations cannot be sent. Contact your System Administrator to enable email and email invitations.'
                            })
                        ),
                        teamInviteLink
                    );
                } else {
                    content = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'invite_member.disabled',
                                defaultMessage: 'User creation has been disabled for your team. Please ask your Team Administrator for details.'
                            })
                        )
                    );
                }

                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        _reactBootstrap.Modal,
                        {
                            dialogClassName: 'modal-invite-member',
                            show: this.state.show,
                            onHide: this.handleHide.bind(this, true),
                            enforceFocus: !this.state.showConfirmModal,
                            backdrop: this.state.isSendingEmails ? 'static' : true
                        },
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Header,
                            { closeButton: !this.state.isSendingEmails },
                            _react2.default.createElement(
                                _reactBootstrap.Modal.Title,
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'invite_member.newMember',
                                    defaultMessage: 'Send Email Invite'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Body,
                            { ref: 'modalBody' },
                            _react2.default.createElement(
                                'form',
                                { role: 'form' },
                                inviteSections
                            ),
                            content
                        ),
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Footer,
                            null,
                            _react2.default.createElement(
                                'button',
                                {
                                    type: 'button',
                                    className: 'btn btn-default',
                                    onClick: this.handleHide.bind(this, true),
                                    disabled: this.state.isSendingEmails
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'invite_member.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            ),
                            sendButton
                        )
                    ),
                    _react2.default.createElement(_confirm_modal2.default, {
                        title: formatMessage(holders.modalTitle),
                        message: formatMessage(holders.modalMessage),
                        confirmButtonText: formatMessage(holders.modalButton),
                        show: this.state.showConfirmModal,
                        onConfirm: this.handleHide.bind(this, false),
                        onCancel: this.hideConfirmModal
                    })
                );
            }

            return null;
        }
    }]);
    return InviteMemberModal;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.teamChange = function () {
        var team = _team_store2.default.getCurrent();
        var teamType = team ? team.type : null;
        _this2.setState({
            teamType: teamType
        });
    };

    this.handleToggle = function (value) {
        _this2.setState({
            show: value,
            serverError: null
        });
    };

    this.handleSubmit = function () {
        if (!_this2.props.sendEmailNotifications) {
            return;
        }

        var inviteIds = _this2.state.inviteIds;
        var count = inviteIds.length;
        var invites = [];
        var emailErrors = _this2.state.emailErrors;
        var firstNameErrors = _this2.state.firstNameErrors;
        var lastNameErrors = _this2.state.lastNameErrors;
        var valid = true;

        for (var i = 0; i < count; i++) {
            var invite = {};
            var index = inviteIds[i];
            invite.email = _reactDom2.default.findDOMNode(_this2.refs['email' + index]).value.trim();
            invite.firstName = _reactDom2.default.findDOMNode(_this2.refs['first_name' + index]).value.trim();
            invite.lastName = _reactDom2.default.findDOMNode(_this2.refs['last_name' + index]).value.trim();
            if (invite.email !== '' || index === 0) {
                if (!invite.email || !utils.isEmail(invite.email)) {
                    emailErrors[index] = _this2.props.intl.formatMessage(holders.emailError);
                    valid = false;
                } else {
                    emailErrors[index] = '';
                }
                invites.push(invite);
            }
        }

        _this2.setState({ emailErrors: emailErrors, firstNameErrors: firstNameErrors, lastNameErrors: lastNameErrors });

        if (!valid || invites.length === 0) {
            return;
        }

        var data = {};
        data.invites = invites;

        _this2.setState({ isSendingEmails: true });

        (0, _team_actions.inviteMembers)(data, function () {
            _this2.handleHide(false);
            _this2.setState({ isSendingEmails: false });
        }, function (err) {
            if (err.id === 'api.team.invite_members.already.app_error') {
                emailErrors[err.detailed_error] = err.message;
                _this2.setState({ emailErrors: emailErrors });
            } else {
                _this2.setState({ serverError: err.message });
            }

            _this2.setState({ isSendingEmails: false });
        });
    };

    this.handleHide = function (requireConfirm) {
        if (requireConfirm) {
            var notEmpty = false;
            for (var i = 0; i < _this2.state.inviteIds.length; i++) {
                var index = _this2.state.inviteIds[i];
                if (_reactDom2.default.findDOMNode(_this2.refs['email' + index]).value.trim() !== '') {
                    notEmpty = true;
                    break;
                }
            }

            if (notEmpty) {
                _this2.setState({
                    showConfirmModal: true
                });

                return;
            }
        }

        _this2.clearFields();

        _this2.setState({
            show: false,
            showConfirmModal: false
        });
    };

    this.addInviteFields = function () {
        var count = _this2.state.idCount + 1;
        var inviteIds = _this2.state.inviteIds;
        inviteIds.push(count);
        _this2.setState({ inviteIds: inviteIds, idCount: count });
    };

    this.clearFields = function () {
        var inviteIds = _this2.state.inviteIds;

        for (var i = 0; i < inviteIds.length; i++) {
            var index = inviteIds[i];
            _reactDom2.default.findDOMNode(_this2.refs['email' + index]).value = '';
            _reactDom2.default.findDOMNode(_this2.refs['first_name' + index]).value = '';
            _reactDom2.default.findDOMNode(_this2.refs['last_name' + index]).value = '';
        }

        _this2.setState({
            inviteIds: [0],
            idCount: 0,
            emailErrors: {},
            firstNameErrors: {},
            lastNameErrors: {}
        });
    };

    this.removeInviteFields = function (index) {
        var count = _this2.state.idCount;
        var inviteIds = _this2.state.inviteIds;
        var i = inviteIds.indexOf(index);
        if (i > -1) {
            inviteIds.splice(i, 1);
        }
        if (!inviteIds.length) {
            inviteIds.push(++count);
        }
        _this2.setState({ inviteIds: inviteIds, idCount: count });
    };

    this.showGetTeamInviteLinkModal = function () {
        _this2.handleHide(false);

        GlobalActions.showGetTeamInviteLinkModal();
    };

    this.handleKeyDown = function (e) {
        if (utils.isKeyPressed(e, _constants2.default.KeyCodes.ENTER)) {
            e.preventDefault();
            _this2.handleSubmit();
        }
    };

    this.hideConfirmModal = function () {
        _this2.setState({ showConfirmModal: false });
    };
};

InviteMemberModal.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    sendEmailNotifications: _propTypes2.default.bool.isRequired,
    enableUserCreation: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(InviteMemberModal);

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _constants = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var LeaveTeamModal = function (_React$Component) {
    (0, _inherits3.default)(LeaveTeamModal, _React$Component);

    function LeaveTeamModal(props) {
        (0, _classCallCheck3.default)(this, LeaveTeamModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LeaveTeamModal.__proto__ || (0, _getPrototypeOf2.default)(LeaveTeamModal)).call(this, props));

        _this.handleToggle = _this.handleToggle.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleHide = _this.handleHide.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);

        _this.state = {
            show: false
        };
        return _this;
    }

    (0, _createClass3.default)(LeaveTeamModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _modal_store2.default.addModalListener(_constants.ActionTypes.TOGGLE_LEAVE_TEAM_MODAL, this.handleToggle);
            document.addEventListener('keypress', this.handleKeyPress);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _modal_store2.default.removeModalListener(_constants.ActionTypes.TOGGLE_LEAVE_TEAM_MODAL, this.handleToggle);
            document.removeEventListener('keypress', this.handleKeyPress);
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key === 'Enter' && this.state.show) {
                this.handleSubmit(e);
            }
        }
    }, {
        key: 'handleToggle',
        value: function handleToggle(value) {
            this.setState({
                show: value
            });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            this.setState({
                show: false
            });

            if (_webrtc_store2.default.isBusy()) {
                _webrtc_store2.default.emitChanged({ action: _constants.WebrtcActionTypes.IN_PROGRESS });
                e.preventDefault();
                return;
            }

            GlobalActions.emitLeaveTeam();
            GlobalActions.toggleSideBarRightMenuAction();
        }
    }, {
        key: 'handleHide',
        value: function handleHide() {
            this.setState({
                show: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var currentUser = _user_store2.default.getCurrentUser();

            if (currentUser != null) {
                return _react2.default.createElement(
                    _reactBootstrap.Modal,
                    {
                        className: 'modal-confirm',
                        show: this.state.show,
                        onHide: this.handleHide
                    },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Header,
                        { closeButton: false },
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Title,
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'leave_team_modal.title',
                                defaultMessage: 'Leave the team?'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Body,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'leave_team_modal.desc',
                            defaultMessage: 'You will be removed from all public and private channels.  If the team is private you will not be able to rejoin the team.  Are you sure?'
                        })
                    ),
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Footer,
                        null,
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'btn btn-default',
                                onClick: this.handleHide
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'leave_team_modal.no',
                                defaultMessage: 'No'
                            })
                        ),
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'btn btn-danger',
                                onClick: this.handleSubmit
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'leave_team_modal.yes',
                                defaultMessage: 'Yes'
                            })
                        )
                    )
                );
            }

            return null;
        }
    }]);
    return LeaveTeamModal;
}(_react2.default.Component);

LeaveTeamModal.propTypes = {
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(LeaveTeamModal);

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _channel_actions = __webpack_require__(809);

var ChannelActions = _interopRequireWildcard(_channel_actions);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var LeavePrivateChannelModal = function (_React$Component) {
    (0, _inherits3.default)(LeavePrivateChannelModal, _React$Component);

    function LeavePrivateChannelModal(props) {
        (0, _classCallCheck3.default)(this, LeavePrivateChannelModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LeavePrivateChannelModal.__proto__ || (0, _getPrototypeOf2.default)(LeavePrivateChannelModal)).call(this, props));

        _this.handleToggle = _this.handleToggle.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleHide = _this.handleHide.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);

        _this.state = {
            show: false,
            channel: null
        };
        _this.mounted = false;
        return _this;
    }

    (0, _createClass3.default)(LeavePrivateChannelModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.mounted = true;
            _modal_store2.default.addModalListener(_constants2.default.ActionTypes.TOGGLE_LEAVE_PRIVATE_CHANNEL_MODAL, this.handleToggle);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.mounted = false;
            _modal_store2.default.removeModalListener(_constants2.default.ActionTypes.TOGGLE_LEAVE_PRIVATE_CHANNEL_MODAL, this.handleToggle);
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key === 'Enter' && this.state.show) {
                this.handleSubmit();
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            var channelId = this.state.channel.id;
            this.setState({
                show: false,
                channel: null
            });
            ChannelActions.leaveChannel(channelId);
        }
    }, {
        key: 'handleToggle',
        value: function handleToggle(value) {
            this.setState({
                channel: value,
                show: value !== null
            });
        }
    }, {
        key: 'handleHide',
        value: function handleHide() {
            this.setState({
                show: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var title = '';
            var message = '';
            if (this.state.channel) {
                title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'leave_private_channel_modal.title',
                    defaultMessage: 'Leave Private Channel {channel}',
                    values: {
                        channel: _react2.default.createElement(
                            'b',
                            null,
                            this.state.channel.display_name
                        )
                    }
                });

                message = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'leave_private_channel_modal.message',
                    defaultMessage: 'Are you sure you wish to leave the private channel {channel}? You must be re-invited in order to re-join this channel in the future.',
                    values: {
                        channel: _react2.default.createElement(
                            'b',
                            null,
                            this.state.channel.display_name
                        )
                    }
                });
            }

            var buttonClass = 'btn btn-danger';
            var button = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'leave_private_channel_modal.leave',
                defaultMessage: 'Yes, leave channel'
            });

            return _react2.default.createElement(_confirm_modal2.default, {
                show: this.state.show,
                title: title,
                message: message,
                confirmButtonClass: buttonClass,
                confirmButtonText: button,
                onConfirm: this.handleSubmit,
                onCancel: this.handleHide
            });
        }
    }]);
    return LeavePrivateChannelModal;
}(_react2.default.Component);

LeavePrivateChannelModal.propTypes = {
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(LeavePrivateChannelModal);

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var RemovedFromChannelModal = function (_React$Component) {
    (0, _inherits3.default)(RemovedFromChannelModal, _React$Component);

    function RemovedFromChannelModal(props) {
        (0, _classCallCheck3.default)(this, RemovedFromChannelModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RemovedFromChannelModal.__proto__ || (0, _getPrototypeOf2.default)(RemovedFromChannelModal)).call(this, props));

        _this.handleShow = _this.handleShow.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);

        _this.state = {
            channelName: '',
            remover: ''
        };
        return _this;
    }

    (0, _createClass3.default)(RemovedFromChannelModal, [{
        key: 'handleShow',
        value: function handleShow() {
            var newState = {};
            if (_browser_store2.default.getItem('channel-removed-state')) {
                newState = _browser_store2.default.getItem('channel-removed-state');
                _browser_store2.default.removeItem('channel-removed-state');
            }

            var townSquare = _channel_store2.default.getByName(_constants.Constants.DEFAULT_CHANNEL);
            setTimeout(function () {
                _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + townSquare.name);
            }, 1);

            this.setState(newState);
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.setState({ channelName: '', remover: '' });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this)).on('show.bs.modal', this.handleShow);
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this)).on('hidden.bs.modal', this.handleClose);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this)).off('show.bs.modal', this.handleShow);
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this)).off('hidden.bs.modal', this.handleClose);
        }
    }, {
        key: 'render',
        value: function render() {
            var currentUser = _user_store2.default.getCurrentUser();

            var channelName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'removed_channel.channelName',
                defaultMessage: 'the channel'
            });
            if (this.state.channelName) {
                channelName = this.state.channelName;
            }

            var remover = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'removed_channel.someone',
                defaultMessage: 'Someone'
            });
            if (this.state.remover) {
                remover = this.state.remover;
            }

            if (currentUser != null) {
                return _react2.default.createElement(
                    'div',
                    {
                        className: 'modal fade',
                        ref: 'modal',
                        id: 'removed_from_channel',
                        tabIndex: '-1',
                        role: 'dialog',
                        'aria-hidden': 'true'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-content' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-header' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        type: 'button',
                                        className: 'close',
                                        'data-dismiss': 'modal',
                                        'aria-label': 'Close'
                                    },
                                    _react2.default.createElement(
                                        'span',
                                        { 'aria-hidden': 'true' },
                                        '×'
                                    )
                                ),
                                _react2.default.createElement(
                                    'h4',
                                    { className: 'modal-title' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'removed_channel.from',
                                        defaultMessage: 'Removed from '
                                    }),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'name' },
                                        channelName
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-body' },
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'removed_channel.remover',
                                        defaultMessage: '{remover} removed you from {channel}',
                                        values: {
                                            remover: remover,
                                            channel: channelName
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-footer' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        type: 'button',
                                        className: 'btn btn-primary',
                                        'data-dismiss': 'modal'
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'removed_channel.okay',
                                        defaultMessage: 'Okay'
                                    })
                                )
                            )
                        )
                    )
                );
            }

            return _react2.default.createElement('div', null);
        }
    }]);
    return RemovedFromChannelModal;
}(_react2.default.Component);

exports.default = RemovedFromChannelModal;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _preferences = __webpack_require__(861);

var _users = __webpack_require__(786);

var _constants = __webpack_require__(19);

var _preferences2 = __webpack_require__(784);

var _user_actions = __webpack_require__(781);

var _reset_status_modal = __webpack_require__(1990);

var _reset_status_modal2 = _interopRequireDefault(_reset_status_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var currentUserId = state.entities.users.currentUserId;

    return (0, _extends3.default)({}, ownProps, {
        autoResetPref: (0, _preferences2.get)(state, _constants.Preferences.CATEGORY_AUTO_RESET_MANUAL_STATUS, currentUserId, '')
    });
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            autoResetStatus: _user_actions.autoResetStatus,
            setStatus: _users.setStatus,
            savePreferences: _preferences.savePreferences
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_reset_status_modal2.default);

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _utils = __webpack_require__(762);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ResetStatusModal = function (_React$PureComponent) {
    (0, _inherits3.default)(ResetStatusModal, _React$PureComponent);

    function ResetStatusModal(props) {
        (0, _classCallCheck3.default)(this, ResetStatusModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ResetStatusModal.__proto__ || (0, _getPrototypeOf2.default)(ResetStatusModal)).call(this, props));

        _this.onConfirm = function (checked) {
            _this.setState({ show: false });

            var newStatus = (0, _extends3.default)({}, _this.state.currentUserStatus);
            newStatus.status = 'online';
            _this.props.actions.setStatus(newStatus);

            if (checked) {
                var pref = { category: _constants.Preferences.CATEGORY_AUTO_RESET_MANUAL_STATUS, user_id: newStatus.user_id, name: newStatus.user_id, value: 'true' };
                _this.props.actions.savePreferences(pref.user_id, [pref]);
            }
        };

        _this.onCancel = function (checked) {
            _this.setState({ show: false });

            if (checked) {
                var status = (0, _extends3.default)({}, _this.state.currentUserStatus);
                var pref = { category: _constants.Preferences.CATEGORY_AUTO_RESET_MANUAL_STATUS, user_id: status.user_id, name: status.user_id, value: 'false' };
                _this.props.actions.savePreferences(pref.user_id, [pref]);
            }
        };

        _this.state = {
            show: false,
            currentUserStatus: {}
        };
        return _this;
    }

    (0, _createClass3.default)(ResetStatusModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.actions.autoResetStatus().then(function (status) {
                var statusIsManual = status.manual;
                var autoResetPrefNotSet = _this2.props.autoResetPref === '';

                _this2.setState({
                    currentUserStatus: status, // Set in state until status refactor where we store 'manual' field in redux
                    show: Boolean(statusIsManual && autoResetPrefNotSet)
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var userStatus = this.state.currentUserStatus.status || '';
            var userStatusId = 'modal.manaul_status.title_' + userStatus;
            var manualStatusTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: userStatusId,
                defaultMessage: 'Your status is set to "{status}"',
                values: {
                    status: (0, _utils.toTitleCase)(userStatus)
                }
            });

            var manualStatusMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'modal.manaul_status.message',
                defaultMessage: 'Would you like to switch your status to "Online"?'
            });

            var manualStatusButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'modal.manaul_status.button',
                defaultMessage: 'Yes, set my status to "Online"'
            });
            var manualStatusId = 'modal.manual_status.cancel_' + userStatus;
            var manualStatusCancel = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: manualStatusId,
                defaultMessage: 'No, keep it as "{status}"',
                values: {
                    status: (0, _utils.toTitleCase)(userStatus)
                }
            });

            var manualStatusCheckbox = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'modal.manaul_status.ask',
                defaultMessage: 'Do not ask me again'
            });

            return _react2.default.createElement(_confirm_modal2.default, {
                show: this.state.show,
                title: manualStatusTitle,
                message: manualStatusMessage,
                confirmButtonText: manualStatusButton,
                onConfirm: this.onConfirm,
                cancelButtonText: manualStatusCancel,
                onCancel: this.onCancel,
                showCheckbox: true,
                checkboxText: manualStatusCheckbox
            });
        }
    }]);
    return ResetStatusModal;
}(_react2.default.PureComponent);

ResetStatusModal.propTypes = {

    /*
     * The user's preference for whether their status is automatically reset
     */
    autoResetPref: _propTypes2.default.string,
    actions: _propTypes2.default.shape({

        /*
         * Function to get and then reset the user's status if needed
         */
        autoResetStatus: _propTypes2.default.func.isRequired,

        /*
         * Function to set the status for a user
         */
        setStatus: _propTypes2.default.func.isRequired,

        /*
         * Function to save user preferences
         */
        savePreferences: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = ResetStatusModal;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var allShortcuts = (0, _reactIntl.defineMessages)({
    mainHeader: {
        default: {
            id: 'shortcuts.header',
            defaultMessage: 'Keyboard Shortcuts\tCtrl|/'
        },
        mac: {
            id: 'shortcuts.header.mac',
            defaultMessage: 'Keyboard Shortcuts\t⌘|/'
        }
    },
    navHeader: {
        id: 'shortcuts.nav.header',
        defaultMessage: 'Navigation'
    },
    navPrev: {
        default: {
            id: 'shortcuts.nav.prev',
            defaultMessage: 'Previous channel:\tAlt|Up'
        },
        mac: {
            id: 'shortcuts.nav.prev.mac',
            defaultMessage: 'Previous channel:\t⌥|Up'
        }
    },
    navNext: {
        default: {
            id: 'shortcuts.nav.next',
            defaultMessage: 'Next channel:\tAlt|Down'
        },
        mac: {
            id: 'shortcuts.nav.next.mac',
            defaultMessage: 'Next channel:\t⌥|Down'
        }
    },
    navUnreadPrev: {
        default: {
            id: 'shortcuts.nav.unread_prev',
            defaultMessage: 'Previous unread channel:\tAlt|Shift|Up'
        },
        mac: {
            id: 'shortcuts.nav.unread_prev.mac',
            defaultMessage: 'Previous unread channel:\t⌥|Shift|Up'
        }
    },
    navUnreadNext: {
        default: {
            id: 'shortcuts.nav.unread_next',
            defaultMessage: 'Next unread channel:\tAlt|Shift|Down'
        },
        mac: {
            id: 'shortcuts.nav.unread_next.mac',
            defaultMessage: 'Next unread channel:\t⌥|Shift|Down'
        }
    },
    navSwitcher: {
        default: {
            id: 'shortcuts.nav.switcher',
            defaultMessage: 'Quick channel switcher:\tCtrl|K'
        },
        mac: {
            id: 'shortcuts.nav.switcher.mac',
            defaultMessage: 'Quick channel switcher:\t⌘|K'
        }
    },
    navDMMenu: {
        default: {
            id: 'shortcuts.nav.direct_messages_menu',
            defaultMessage: 'Direct messages menu:\tCtrl|Shift|K'
        },
        mac: {
            id: 'shortcuts.nav.direct_messages_menu.mac',
            defaultMessage: 'Direct messages menu:\t⌘|Shift|K'
        }
    },
    navSettings: {
        default: {
            id: 'shortcuts.nav.settings',
            defaultMessage: 'Account settings:\tCtrl|Shift|A'
        },
        mac: {
            id: 'shortcuts.nav.settings.mac',
            defaultMessage: 'Account settings:\t⌘|Shift|A'
        }
    },
    navMentions: {
        default: {
            id: 'shortcuts.nav.recent_mentions',
            defaultMessage: 'Recent mentions:\tCtrl|Shift|M'
        },
        mac: {
            id: 'shortcuts.nav.recent_mentions.mac',
            defaultMessage: 'Recent mentions:\t⌘|Shift|M'
        }
    },
    navFocusCenter: {
        default: {
            id: 'shortcuts.nav.focus_center',
            defaultMessage: 'Set focus to input field:\tCtrl|Shift|L'
        },
        mac: {
            id: 'shortcuts.nav.focus_center.mac',
            defaultMessage: 'Set focus to input field:\t⌘|Shift|L'
        }
    },
    msgHeader: {
        id: 'shortcuts.msgs.header',
        defaultMessage: 'Messages'
    },
    msgInputHeader: {
        id: 'shortcuts.msgs.input.header',
        defaultMessage: 'Works inside an empty input field'
    },
    msgEdit: {
        id: 'shortcuts.msgs.edit',
        defaultMessage: 'Edit last message in channel:\tUp'
    },
    msgReply: {
        id: 'shortcuts.msgs.reply',
        defaultMessage: 'Reply to last message in channel:\tShift|Up'
    },
    msgReprintPrev: {
        default: {
            id: 'shortcuts.msgs.reprint_prev',
            defaultMessage: 'Reprint previous message:\tCtrl|Up'
        },
        mac: {
            id: 'shortcuts.msgs.reprint_prev.mac',
            defaultMessage: 'Reprint previous message:\t⌘|Up'
        }
    },
    msgReprintNext: {
        default: {
            id: 'shortcuts.msgs.reprint_next',
            defaultMessage: 'Reprint next message:\tCtrl|Down'
        },
        mac: {
            id: 'shortcuts.msgs.reprint_next.mac',
            defaultMessage: 'Reprint next message:\t⌘|Down'
        }
    },
    msgCompHeader: {
        id: 'shortcuts.msgs.comp.header',
        defaultMessage: 'Autocomplete'
    },
    msgCompUsername: {
        id: 'shortcuts.msgs.comp.username',
        defaultMessage: 'Username:\t@|[a-z]|Tab'
    },
    msgCompChannel: {
        id: 'shortcuts.msgs.comp.channel',
        defaultMessage: 'Channel:\t~|[a-z]|Tab'
    },
    msgCompEmoji: {
        id: 'shortcuts.msgs.comp.emoji',
        defaultMessage: 'Emoji:\t:|[a-z]|Tab'
    },
    filesHeader: {
        id: 'shortcuts.files.header',
        defaultMessage: 'Files'
    },
    filesUpload: {
        default: {
            id: 'shortcuts.files.upload',
            defaultMessage: 'Upload files:\tCtrl|U'
        },
        mac: {
            id: 'shortcuts.files.upload.mac',
            defaultMessage: 'Upload files:\t⌘|U'
        }
    },
    browserHeader: {
        id: 'shortcuts.browser.header',
        defaultMessage: 'Built-in Browser Commands'
    },
    browserChannelPrev: {
        default: {
            id: 'shortcuts.browser.channel_prev',
            defaultMessage: 'Back in history:\tAlt|Left'
        },
        mac: {
            id: 'shortcuts.browser.channel_prev.mac',
            defaultMessage: 'Back in history:\t⌘|['
        }
    },
    browserChannelNext: {
        default: {
            id: 'shortcuts.browser.channel_next',
            defaultMessage: 'Forward in history:\tAlt|Right'
        },
        mac: {
            id: 'shortcuts.browser.channel_next.mac',
            defaultMessage: 'Forward in history:\t⌘|]'
        }
    },
    browserFontIncrease: {
        default: {
            id: 'shortcuts.browser.font_increase',
            defaultMessage: 'Zoom in:\tCtrl|+'
        },
        mac: {
            id: 'shortcuts.browser.font_increase.mac',
            defaultMessage: 'Zoom in:\t⌘|+'
        }
    },
    browserFontDecrease: {
        default: {
            id: 'shortcuts.browser.font_decrease',
            defaultMessage: 'Zoom out:\tCtrl|-'
        },
        mac: {
            id: 'shortcuts.browser.font_decrease.mac',
            defaultMessage: 'Zoom out:\t⌘|-'
        }
    },
    browserInputHeader: {
        id: 'shortcuts.browser.input.header',
        defaultMessage: 'Works inside an input field'
    },
    browserHighlightPrev: {
        id: 'shortcuts.browser.highlight_prev',
        defaultMessage: 'Highlight text to the previous line:\tShift|Up'
    },
    browserHighlightNext: {
        id: 'shortcuts.browser.highlight_next',
        defaultMessage: 'Highlight text to the next line:\tShift|Down'
    },
    browserNewline: {
        id: 'shortcuts.browser.newline',
        defaultMessage: 'Create a new line:\tShift|Enter'
    },
    info: {
        id: 'shortcuts.info',
        defaultMessage: 'Begin a message with / for a list of all the commands at your disposal.'
    }
});

var ShortcutsModal = function (_React$PureComponent) {
    (0, _inherits3.default)(ShortcutsModal, _React$PureComponent);

    function ShortcutsModal(props) {
        (0, _classCallCheck3.default)(this, ShortcutsModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ShortcutsModal.__proto__ || (0, _getPrototypeOf2.default)(ShortcutsModal)).call(this, props));

        _this.handleToggle = function () {
            //toggles the state of shortcut dialog
            _this.setState({
                show: !_this.state.show
            });
        };

        _this.handleHide = function () {
            _this.setState({ show: false });
        };

        _this.state = {
            show: false
        };
        return _this;
    }

    (0, _createClass3.default)(ShortcutsModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _modal_store2.default.addModalListener(_constants2.default.ActionTypes.TOGGLE_SHORTCUTS_MODAL, this.handleToggle);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _modal_store2.default.removeModalListener(_constants2.default.ActionTypes.TOGGLE_SHORTCUTS_MODAL, this.handleToggle);
        }
    }, {
        key: 'getShortcuts',
        value: function getShortcuts() {
            var isMac = this.props.isMac;

            var shortcuts = {};
            (0, _keys2.default)(allShortcuts).forEach(function (s) {
                if (isMac && allShortcuts[s].mac) {
                    shortcuts[s] = allShortcuts[s].mac;
                } else if (!isMac && allShortcuts[s].default) {
                    shortcuts[s] = allShortcuts[s].default;
                } else {
                    shortcuts[s] = allShortcuts[s];
                }
            });

            return shortcuts;
        }
    }, {
        key: 'render',
        value: function render() {
            var shortcuts = this.getShortcuts();
            var formatMessage = this.props.intl.formatMessage;


            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'shortcuts-modal',
                    show: this.state.show,
                    onHide: this.handleHide,
                    onExited: this.handleHide
                },
                _react2.default.createElement(
                    'div',
                    { className: 'shortcuts-content' },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Header,
                        { closeButton: true },
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Title,
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                renderShortcut(formatMessage(shortcuts.mainHeader))
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Body,
                        { ref: 'modalBody' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'section' },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'h4',
                                            { className: 'section-title' },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                formatMessage(shortcuts.navHeader)
                                            )
                                        ),
                                        renderShortcut(formatMessage(shortcuts.navPrev)),
                                        renderShortcut(formatMessage(shortcuts.navNext)),
                                        renderShortcut(formatMessage(shortcuts.navUnreadPrev)),
                                        renderShortcut(formatMessage(shortcuts.navUnreadNext)),
                                        renderShortcut(formatMessage(shortcuts.navSwitcher)),
                                        renderShortcut(formatMessage(shortcuts.navDMMenu)),
                                        renderShortcut(formatMessage(shortcuts.navSettings)),
                                        renderShortcut(formatMessage(shortcuts.navMentions)),
                                        renderShortcut(formatMessage(shortcuts.navFocusCenter))
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'section' },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'h4',
                                            { className: 'section-title' },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                formatMessage(shortcuts.msgHeader)
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'span',
                                            null,
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                formatMessage(shortcuts.msgInputHeader)
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'subsection' },
                                            renderShortcut(formatMessage(shortcuts.msgEdit)),
                                            renderShortcut(formatMessage(shortcuts.msgReply)),
                                            renderShortcut(formatMessage(shortcuts.msgReprintPrev)),
                                            renderShortcut(formatMessage(shortcuts.msgReprintNext))
                                        ),
                                        _react2.default.createElement(
                                            'span',
                                            null,
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                formatMessage(shortcuts.msgCompHeader)
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'subsection' },
                                            renderShortcut(formatMessage(shortcuts.msgCompUsername)),
                                            renderShortcut(formatMessage(shortcuts.msgCompChannel)),
                                            renderShortcut(formatMessage(shortcuts.msgCompEmoji))
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'section' },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'h4',
                                            { className: 'section-title' },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                formatMessage(shortcuts.filesHeader)
                                            )
                                        ),
                                        renderShortcut(formatMessage(shortcuts.filesUpload))
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'section--lower' },
                                        _react2.default.createElement(
                                            'h4',
                                            { className: 'section-title' },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                formatMessage(shortcuts.browserHeader)
                                            )
                                        ),
                                        renderShortcut(formatMessage(shortcuts.browserChannelPrev)),
                                        renderShortcut(formatMessage(shortcuts.browserChannelNext)),
                                        renderShortcut(formatMessage(shortcuts.browserFontIncrease)),
                                        renderShortcut(formatMessage(shortcuts.browserFontDecrease)),
                                        _react2.default.createElement(
                                            'span',
                                            null,
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                formatMessage(shortcuts.browserInputHeader)
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'subsection' },
                                            renderShortcut(formatMessage(shortcuts.browserHighlightPrev)),
                                            renderShortcut(formatMessage(shortcuts.browserHighlightNext)),
                                            renderShortcut(formatMessage(shortcuts.browserNewline))
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'info__label' },
                            formatMessage(shortcuts.info)
                        )
                    )
                )
            );
        }
    }]);
    return ShortcutsModal;
}(_react2.default.PureComponent);

ShortcutsModal.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    isMac: _propTypes2.default.bool.isRequired
};


function renderShortcut(text) {
    if (!text) {
        return null;
    }

    var shortcut = text.split('\t');
    var description = _react2.default.createElement(
        'span',
        null,
        shortcut[0]
    );

    var keys = null;
    if (shortcut.length > 1) {
        keys = shortcut[1].split('|').map(function (key) {
            return _react2.default.createElement(
                'span',
                {
                    className: 'shortcut-key',
                    key: key
                },
                key
            );
        });
    }

    return _react2.default.createElement(
        'div',
        { className: 'shortcut-line' },
        description,
        keys
    );
}

exports.default = (0, _reactIntl.injectIntl)(ShortcutsModal);

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(777);

var _channels = __webpack_require__(783);

var _posts = __webpack_require__(805);

var _post_store = __webpack_require__(956);

var _post_store2 = _interopRequireDefault(_post_store);

var _rhs = __webpack_require__(817);

var _rhs2 = __webpack_require__(818);

var _constants = __webpack_require__(29);

var _sidebar_right = __webpack_require__(1993);

var _sidebar_right2 = _interopRequireDefault(_sidebar_right);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var rhsState = (0, _rhs2.getRhsState)(state);

    var channelId = (0, _rhs2.getSelectedChannelId)(state);

    var channel = null;
    if (channelId) {
        channel = (0, _channels.getChannel)(state, channelId);
        if (channel == null) {
            // the permalink view is not really tied to a particular channel but still needs it
            var postId = _post_store2.default.getFocusedPostId();
            var post = (0, _posts.getPost)(state, postId);

            // the post take some time before being available on page load
            if (post != null) {
                channel = (0, _channels.getChannel)(state, post.channel_id);
            }
        }
    }

    return {
        isOpen: (0, _rhs2.getIsRhsOpen)(state),
        channel: channel,
        currentUser: (0, _users.getCurrentUser)(state),
        postRightVisible: Boolean((0, _rhs2.getSelectedPostId)(state)),
        searchVisible: Boolean(rhsState),
        previousRhsState: (0, _rhs2.getPreviousRhsState)(state),
        isMentionSearch: rhsState === _constants.RHSStates.MENTION,
        isFlaggedPosts: rhsState === _constants.RHSStates.FLAG,
        isPinnedPosts: rhsState === _constants.RHSStates.PIN
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getPinnedPosts: _rhs.getPinnedPosts,
            getFlaggedPosts: _rhs.getFlaggedPosts
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_sidebar_right2.default);

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(769);

var _classnames2 = _interopRequireDefault(_classnames);

var _diagnostics_actions = __webpack_require__(804);

var _global_actions = __webpack_require__(778);

var _post_store = __webpack_require__(956);

var _post_store2 = _interopRequireDefault(_post_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _file_upload_overlay = __webpack_require__(1316);

var _file_upload_overlay2 = _interopRequireDefault(_file_upload_overlay);

var _rhs_thread = __webpack_require__(1996);

var _rhs_thread2 = _interopRequireDefault(_rhs_thread);

var _search_bar = __webpack_require__(1047);

var _search_bar2 = _interopRequireDefault(_search_bar);

var _search_results = __webpack_require__(2082);

var _search_results2 = _interopRequireDefault(_search_results);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarRight = function (_React$Component) {
    (0, _inherits3.default)(SidebarRight, _React$Component);

    function SidebarRight(props) {
        (0, _classCallCheck3.default)(this, SidebarRight);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarRight.__proto__ || (0, _getPrototypeOf2.default)(SidebarRight)).call(this, props));

        _this.onPostPinnedChange = function () {
            if (_this.props.channel && _this.props.isPinnedPosts) {
                _this.props.actions.getPinnedPosts(_this.props.channel.id);
            }
        };

        _this.onShrink = function () {
            _this.setState({
                expanded: false
            });
        };

        _this.toggleSize = function () {
            _this.setState({ expanded: !_this.state.expanded });
        };

        _this.plScrolledToBottom = true;

        _this.state = {
            expanded: false
        };
        return _this;
    }

    (0, _createClass3.default)(SidebarRight, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _post_store2.default.addPostPinnedChangeListener(this.onPostPinnedChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _post_store2.default.removePostPinnedChangeListener(this.onPostPinnedChange);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isOpen = this.props.searchVisible || this.props.postRightVisible;
            var willOpen = nextProps.searchVisible || nextProps.postRightVisible;

            if (!isOpen && willOpen) {
                (0, _diagnostics_actions.trackEvent)('ui', 'ui_rhs_opened');
            }

            if (!isOpen && willOpen) {
                this.setState({
                    expanded: false
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var isOpen = this.props.searchVisible || this.props.postRightVisible;

            var wasOpen = prevProps.searchVisible || prevProps.postRightVisible;

            if (isOpen && !wasOpen) {
                setTimeout(function () {
                    return (0, _global_actions.postListScrollChange)();
                }, 0);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                channel = _props.channel,
                currentUser = _props.currentUser,
                isFlaggedPosts = _props.isFlaggedPosts,
                isMentionSearch = _props.isMentionSearch,
                isPinnedPosts = _props.isPinnedPosts,
                postRightVisible = _props.postRightVisible,
                previousRhsState = _props.previousRhsState,
                searchVisible = _props.searchVisible;


            var content = null;
            var expandedClass = '';

            if (this.state.expanded) {
                expandedClass = 'sidebar--right--expanded';
            }

            var searchForm = null;
            if (currentUser) {
                searchForm = _react2.default.createElement(_search_bar2.default, { isFocus: searchVisible && !isFlaggedPosts && !isPinnedPosts });
            }

            var channelDisplayName = '';
            if (channel) {
                if (channel.type === _constants2.default.DM_CHANNEL || channel.type === _constants2.default.GM_CHANNEL) {
                    channelDisplayName = Utils.localizeMessage('rhs_root.direct', 'Direct Message');
                } else {
                    channelDisplayName = channel.display_name;
                }
            }

            if (searchVisible) {
                content = _react2.default.createElement(
                    'div',
                    { className: 'sidebar--right__content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'search-bar__container channel-header alt' },
                        searchForm
                    ),
                    _react2.default.createElement(_search_results2.default, {
                        isMentionSearch: isMentionSearch,
                        isFlaggedPosts: isFlaggedPosts,
                        isPinnedPosts: isPinnedPosts,
                        toggleSize: this.toggleSize,
                        shrink: this.onShrink,
                        channelDisplayName: channelDisplayName
                    })
                );
            } else if (postRightVisible) {
                content = _react2.default.createElement(
                    'div',
                    { className: 'post-right__container' },
                    _react2.default.createElement(_file_upload_overlay2.default, { overlayType: 'right' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'search-bar__container channel-header alt' },
                        searchForm
                    ),
                    _react2.default.createElement(_rhs_thread2.default, {
                        previousRhsState: previousRhsState,
                        isWebrtc: _webrtc_store2.default.isBusy(),
                        currentUser: currentUser,
                        toggleSize: this.toggleSize,
                        shrink: this.onShrink
                    })
                );
            }

            if (!content) {
                expandedClass = '';
            }

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('sidebar--right', expandedClass, { 'move--left': this.props.isOpen }),
                    id: 'sidebar-right'
                },
                _react2.default.createElement('div', {
                    onClick: this.onShrink,
                    className: 'sidebar--right__bg'
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'sidebar-right-container' },
                    content
                )
            );
        }
    }]);
    return SidebarRight;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SidebarRight.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    currentUser: _propTypes2.default.object,
    channel: _propTypes2.default.object,
    postRightVisible: _propTypes2.default.bool,
    searchVisible: _propTypes2.default.bool,
    isMentionSearch: _propTypes2.default.bool,
    isFlaggedPosts: _propTypes2.default.bool,
    isPinnedPosts: _propTypes2.default.bool,
    previousRhsState: _propTypes2.default.string,
    actions: _propTypes2.default.shape({
        getPinnedPosts: _propTypes2.default.func,
        getFlaggedPosts: _propTypes2.default.func
    })
};
exports.default = SidebarRight;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a289292b58691d535a8bbaf4b945015e.png";

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/5b4a7904a3e041018526a00dba59ee48.png";

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _channels = __webpack_require__(783);

var _posts = __webpack_require__(805);

var _preferences = __webpack_require__(784);

var _posts2 = __webpack_require__(808);

var _constants = __webpack_require__(29);

var _rhs = __webpack_require__(818);

var _rhs_thread = __webpack_require__(1997);

var _rhs_thread2 = _interopRequireDefault(_rhs_thread);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeMapStateToProps() {
    var getPostsForThread = (0, _posts.makeGetPostsForThread)();
    var getPostsEmbedVisibleObj = (0, _rhs.makeGetPostsEmbedVisibleObj)();

    return function mapStateToProps(state) {
        var selected = (0, _rhs.getSelectedPost)(state);

        var channel = null;
        var posts = [];
        if (selected) {
            posts = getPostsForThread(state, { rootId: selected.id });
            channel = (0, _channels.getChannel)(state, selected.channel_id);
        }

        var previewCollapsed = (0, _preferences.get)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.COLLAPSE_DISPLAY, _constants.Preferences.COLLAPSE_DISPLAY_DEFAULT);
        var postsEmbedVisibleObj = getPostsEmbedVisibleObj(state, posts);

        return {
            selected: selected,
            channel: channel,
            posts: posts,
            previewCollapsed: previewCollapsed,
            postsEmbedVisibleObj: postsEmbedVisibleObj,
            previewEnabled: (0, _preferences.getBool)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.LINK_PREVIEW_DISPLAY, _constants.Preferences.LINK_PREVIEW_DISPLAY_DEFAULT)
        };
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            removePost: _posts2.removePost
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_rhs_thread2.default);

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

exports.renderView = renderView;
exports.renderThumbHorizontal = renderThumbHorizontal;
exports.renderThumbVertical = renderThumbVertical;

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactCustomScrollbars = __webpack_require__(1317);

var _reactCustomScrollbars2 = _interopRequireDefault(_reactCustomScrollbars);

var _constants = __webpack_require__(19);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _delayed_action = __webpack_require__(931);

var _delayed_action2 = _interopRequireDefault(_delayed_action);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _create_comment = __webpack_require__(2018);

var _create_comment2 = _interopRequireDefault(_create_comment);

var _date_separator = __webpack_require__(1042);

var _date_separator2 = _interopRequireDefault(_date_separator);

var _floating_timestamp = __webpack_require__(1325);

var _floating_timestamp2 = _interopRequireDefault(_floating_timestamp);

var _rhs_comment = __webpack_require__(2028);

var _rhs_comment2 = _interopRequireDefault(_rhs_comment);

var _rhs_header_post = __webpack_require__(2074);

var _rhs_header_post2 = _interopRequireDefault(_rhs_header_post);

var _rhs_root_post = __webpack_require__(2076);

var _rhs_root_post2 = _interopRequireDefault(_rhs_root_post);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Preferences = _constants3.default.Preferences; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function renderView(props) {
    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
        className: 'scrollbar--view'
    }));
}

function renderThumbHorizontal(props) {
    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
        className: 'scrollbar--horizontal'
    }));
}

function renderThumbVertical(props) {
    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
        className: 'scrollbar--vertical'
    }));
}

var RhsThread = function (_React$Component) {
    (0, _inherits3.default)(RhsThread, _React$Component);

    function RhsThread(props) {
        (0, _classCallCheck3.default)(this, RhsThread);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RhsThread.__proto__ || (0, _getPrototypeOf2.default)(RhsThread)).call(this, props));

        _initialiseProps.call(_this);

        _this.scrollStopAction = new _delayed_action2.default(_this.handleScrollStop);

        var openTime = new Date().getTime();

        _this.state = {
            windowWidth: Utils.windowWidth(),
            windowHeight: Utils.windowHeight(),
            profiles: JSON.parse((0, _stringify2.default)(_user_store2.default.getProfiles())),
            compactDisplay: _preference_store2.default.get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.MESSAGE_DISPLAY, Preferences.MESSAGE_DISPLAY_DEFAULT) === Preferences.MESSAGE_DISPLAY_COMPACT,
            flaggedPosts: _preference_store2.default.getCategory(_constants3.default.Preferences.CATEGORY_FLAGGED_POST),
            statuses: (0, _assign2.default)({}, _user_store2.default.getStatuses()),
            previewsCollapsed: _preference_store2.default.get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.COLLAPSE_DISPLAY, 'false'),
            isBusy: _webrtc_store2.default.isBusy(),
            isScrolling: false,
            topRhsPostCreateAt: 0,
            openTime: openTime
        };
        return _this;
    }

    (0, _createClass3.default)(RhsThread, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _preference_store2.default.addChangeListener(this.onPreferenceChange);
            _user_store2.default.addChangeListener(this.onUserChange);
            _user_store2.default.addStatusesChangeListener(this.onStatusChange);
            _webrtc_store2.default.addBusyListener(this.onBusy);

            this.scrollToBottom();
            window.addEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _preference_store2.default.removeChangeListener(this.onPreferenceChange);
            _user_store2.default.removeChangeListener(this.onUserChange);
            _user_store2.default.removeStatusesChangeListener(this.onStatusChange);
            _webrtc_store2.default.removeBusyListener(this.onBusy);

            window.removeEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.selected || !nextProps.selected) {
                return;
            }

            if (this.props.selected.id !== nextProps.selected.id) {
                this.setState({
                    openTime: new Date().getTime()
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var prevPostsArray = prevProps.posts || [];
            var curPostsArray = this.props.posts || [];

            if (prevPostsArray.length >= curPostsArray.length) {
                return;
            }

            var curLastPost = curPostsArray[curPostsArray.length - 1];

            if (curLastPost.user_id === _user_store2.default.getCurrentId()) {
                this.scrollToBottom();
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (!Utils.areObjectsEqual(nextState.statuses, this.state.statuses)) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextState.postsArray, this.props.posts)) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextState.selected, this.props.selected)) {
                return true;
            }

            if (nextState.compactDisplay !== this.state.compactDisplay) {
                return true;
            }

            if (nextProps.previewEnabled !== this.props.previewEnabled) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextState.flaggedPosts, this.state.flaggedPosts)) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextState.profiles, this.state.profiles)) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextProps.currentUser, this.props.currentUser)) {
                return true;
            }

            if (nextState.isBusy !== this.state.isBusy) {
                return true;
            }

            if (nextState.isScrolling !== this.state.isScrolling) {
                return true;
            }

            if (nextState.topRhsPostCreateAt !== this.state.topRhsPostCreateAt) {
                return true;
            }
            if (nextProps.postsEmbedVisibleObj !== this.props.postsEmbedVisibleObj) {
                return true;
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.posts == null || this.props.selected == null) {
                return _react2.default.createElement('div', null);
            }

            var postsArray = this.filterPosts(this.props.posts, this.props.selected, this.state.openTime);
            var selected = this.props.selected;
            var profiles = this.state.profiles || {};

            var profile = void 0;
            if (_user_store2.default.getCurrentId() === selected.user_id) {
                profile = this.props.currentUser;
            } else {
                profile = profiles[selected.user_id];
            }

            var isRootFlagged = false;
            if (this.state.flaggedPosts) {
                isRootFlagged = this.state.flaggedPosts.get(selected.id) != null;
            }

            var rootStatus = 'offline';
            if (this.state.statuses) {
                rootStatus = this.state.statuses[selected.user_id] || 'offline';
            }

            var createAt = selected.create_at;
            if (!createAt) {
                createAt = this.props.posts[0].create_at;
            }
            var rootPostDay = Utils.getDateForUnixTicks(createAt);
            var previousPostDay = rootPostDay;

            var commentsLists = [];
            var postsLength = postsArray.length;
            for (var i = 0; i < postsLength; i++) {
                var comPost = postsArray[i];
                var p = void 0;
                if (_user_store2.default.getCurrentId() === comPost.user_id) {
                    p = _user_store2.default.getCurrentUser();
                } else {
                    p = profiles[comPost.user_id];
                }

                var isFlagged = false;
                if (this.state.flaggedPosts) {
                    isFlagged = this.state.flaggedPosts.get(comPost.id) != null;
                }

                var status = 'offline';
                if (this.state.statuses && p && p.id) {
                    status = this.state.statuses[p.id] || 'offline';
                }

                var currentPostDay = Utils.getDateForUnixTicks(comPost.create_at);
                if (currentPostDay.toDateString() !== previousPostDay.toDateString()) {
                    previousPostDay = currentPostDay;
                    commentsLists.push(_react2.default.createElement(_date_separator2.default, {
                        key: currentPostDay,
                        date: currentPostDay
                    }));
                }

                var keyPrefix = comPost.id ? comPost.id : comPost.pending_post_id;
                var reverseCount = postsLength - i - 1;
                commentsLists.push(_react2.default.createElement(
                    'div',
                    { key: keyPrefix + 'commentKey' },
                    _react2.default.createElement(_rhs_comment2.default, {
                        ref: comPost.id,
                        post: comPost,
                        teamId: this.props.channel.team_id,
                        lastPostCount: reverseCount >= 0 && reverseCount < _constants3.default.TEST_ID_COUNT ? reverseCount : -1,
                        user: p,
                        currentUser: this.props.currentUser,
                        compactDisplay: this.state.compactDisplay,
                        isFlagged: isFlagged,
                        status: status,
                        isBusy: this.state.isBusy,
                        removePost: this.props.actions.removePost,
                        previewCollapsed: this.props.previewCollapsed,
                        previewEnabled: this.props.previewEnabled,
                        isEmbedVisible: this.props.postsEmbedVisibleObj[comPost.id]
                    })
                ));
            }

            var createComment = void 0;
            if (selected.type !== _constants3.default.PostTypes.FAKE_PARENT_DELETED) {
                createComment = _react2.default.createElement(
                    'div',
                    { className: 'post-create__container' },
                    _react2.default.createElement(_create_comment2.default, {
                        channelId: selected.channel_id,
                        rootId: selected.id,
                        rootDeleted: selected.state === _constants.Posts.POST_DELETED,
                        latestPostId: postsLength > 0 ? postsArray[postsLength - 1].id : selected.id,
                        getSidebarBody: this.getSidebarBody
                    })
                );
            }

            if (this.props.channel.type === _constants3.default.DM_CHANNEL) {
                var teammate = Utils.getDirectTeammate(this.props.channel.id);
                if (teammate && teammate.delete_at) {
                    createComment = _react2.default.createElement(
                        'div',
                        {
                            className: 'post-create-message'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'create_post.deactivated',
                            defaultMessage: 'You are viewing an archived channel with a deactivated user.'
                        })
                    );
                }
            }

            return _react2.default.createElement(
                'div',
                {
                    className: 'sidebar-right__body',
                    ref: 'sidebarbody'
                },
                _react2.default.createElement(_floating_timestamp2.default, {
                    isScrolling: this.state.isScrolling,
                    isMobile: Utils.isMobile(),
                    createAt: this.state.topRhsPostCreateAt,
                    isRhsPost: true
                }),
                _react2.default.createElement(_rhs_header_post2.default, {
                    previousRhsState: this.props.previousRhsState,
                    isWebrtc: this.props.isWebrtc,
                    toggleSize: this.props.toggleSize,
                    shrink: this.props.shrink
                }),
                _react2.default.createElement(
                    _reactCustomScrollbars2.default,
                    {
                        autoHide: true,
                        autoHideTimeout: 500,
                        autoHideDuration: 500,
                        renderThumbHorizontal: renderThumbHorizontal,
                        renderThumbVertical: renderThumbVertical,
                        renderView: renderView,
                        onScroll: this.handleScroll
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'post-right__scroll' },
                        _react2.default.createElement(_date_separator2.default, { date: rootPostDay }),
                        _react2.default.createElement(_rhs_root_post2.default, {
                            ref: selected.id,
                            post: selected,
                            commentCount: postsLength,
                            user: profile,
                            teamId: this.props.channel.team_id,
                            currentUser: this.props.currentUser,
                            compactDisplay: this.state.compactDisplay,
                            isFlagged: isRootFlagged,
                            status: rootStatus,
                            previewCollapsed: this.props.previewCollapsed,
                            previewEnabled: this.props.previewEnabled,
                            isBusy: this.state.isBusy,
                            isEmbedVisible: this.props.postsEmbedVisibleObj[selected.id]
                        }),
                        _react2.default.createElement(
                            'div',
                            {
                                ref: 'rhspostlist',
                                className: 'post-right-comments-container'
                            },
                            commentsLists
                        ),
                        createComment
                    )
                )
            );
        }
    }]);
    return RhsThread;
}(_react2.default.Component);

RhsThread.propTypes = {
    posts: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    channel: _propTypes2.default.object.isRequired,
    selected: _propTypes2.default.object.isRequired,
    previousRhsState: _propTypes2.default.string,
    isWebrtc: _propTypes2.default.bool,
    currentUser: _propTypes2.default.object.isRequired,
    toggleSize: _propTypes2.default.func,
    shrink: _propTypes2.default.func,
    previewCollapsed: _propTypes2.default.string.isRequired,
    previewEnabled: _propTypes2.default.bool.isRequired,
    postsEmbedVisibleObj: _propTypes2.default.object,
    actions: _propTypes2.default.shape({
        removePost: _propTypes2.default.func.isRequired
    }).isRequired
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleResize = function () {
        _this2.setState({
            windowWidth: Utils.windowWidth(),
            windowHeight: Utils.windowHeight()
        });

        if (UserAgent.isMobile() && document.activeElement.id === 'reply_textbox') {
            _this2.scrollToBottom();
        }
    };

    this.onPreferenceChange = function () {
        _this2.setState({
            compactDisplay: _preference_store2.default.get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.MESSAGE_DISPLAY, Preferences.MESSAGE_DISPLAY_DEFAULT) === Preferences.MESSAGE_DISPLAY_COMPACT,
            flaggedPosts: _preference_store2.default.getCategory(_constants3.default.Preferences.CATEGORY_FLAGGED_POST)
        });
    };

    this.onStatusChange = function () {
        _this2.setState({ statuses: (0, _assign2.default)({}, _user_store2.default.getStatuses()) });
    };

    this.onBusy = function (isBusy) {
        _this2.setState({ isBusy: isBusy });
    };

    this.filterPosts = function (posts, selected, openTime) {
        var postsArray = [];

        posts.forEach(function (cpost) {
            // Do not show empherals created before sidebar has been opened
            if (cpost.type === 'system_ephemeral' && cpost.create_at < openTime) {
                return;
            }

            if (cpost.root_id === selected.id) {
                postsArray.unshift(cpost);
            }
        });

        return postsArray;
    };

    this.onUserChange = function () {
        var profiles = JSON.parse((0, _stringify2.default)(_user_store2.default.getProfiles()));
        _this2.setState({ profiles: profiles });
    };

    this.scrollToBottom = function () {
        if ((0, _jquery2.default)('.post-right__scroll')[0]) {
            (0, _jquery2.default)('.post-right__scroll').parent().scrollTop((0, _jquery2.default)('.post-right__scroll')[0].scrollHeight);
        }
    };

    this.updateFloatingTimestamp = function () {
        // skip this in non-mobile view since that's when the timestamp is visible
        if (!Utils.isMobile()) {
            return;
        }

        if (_this2.props.posts) {
            var childNodes = _this2.refs.rhspostlist.childNodes;
            var viewPort = _this2.refs.rhspostlist.getBoundingClientRect();
            var topRhsPostCreateAt = 0;
            var offset = 100;

            // determine the top rhs comment assuming that childNodes and postsArray are of same length
            for (var i = 0; i < childNodes.length; i++) {
                if (childNodes[i].offsetTop + viewPort.top - offset > 0) {
                    topRhsPostCreateAt = _this2.props.posts[i].create_at;
                    break;
                }
            }

            if (topRhsPostCreateAt !== _this2.state.topRhsPostCreateAt) {
                _this2.setState({
                    topRhsPostCreateAt: topRhsPostCreateAt
                });
            }
        }
    };

    this.handleScroll = function () {
        _this2.updateFloatingTimestamp();

        if (!_this2.state.isScrolling) {
            _this2.setState({
                isScrolling: true
            });
        }

        _this2.scrollStopAction.fireAfter(_constants3.default.SCROLL_DELAY);
    };

    this.handleScrollStop = function () {
        _this2.setState({
            isScrolling: false
        });
    };

    this.getSidebarBody = function () {
        return _this2.refs.sidebarbody;
    };
};

exports.default = RhsThread;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = __webpack_require__(1999);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(1318);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(14);

var _propTypes = __webpack_require__(2006);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(2011);

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__(2012);

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__(2013);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(2014);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(2015);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(2016);

var _defaultRenderElements = __webpack_require__(2017);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            if (!this.view) return 0;
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            if (!this.view) return 0;
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            if (!this.view) return 0;
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            if (!this.view) return 0;
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            if (!this.view) return 0;
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            if (!this.view) return 0;
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _ref2 = this.view || {},
                _ref2$scrollLeft = _ref2.scrollLeft,
                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2.scrollTop,
                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                _ref2$scrollWidth = _ref2.scrollWidth,
                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                _ref2$scrollHeight = _ref2.scrollHeight,
                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                _ref2$clientWidth = _ref2.clientWidth,
                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                _ref2$clientHeight = _ref2.clientHeight,
                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view = this.view,
                scrollWidth = _view.scrollWidth,
                clientWidth = _view.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth === width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view2 = this.view,
                scrollHeight = _view2.scrollHeight,
                clientHeight = _view2.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight === height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view3 = this.view,
                scrollWidth = _view3.scrollWidth,
                clientWidth = _view3.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view4 = this.view,
                scrollHeight = _view4.scrollHeight,
                clientHeight = _view4.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            if (!this.view) return;
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (!this.view) return;
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            if (!this.view) return;
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            if (!this.view) return;
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.update();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props,
                onScroll = _props5.onScroll,
                onScrollFrame = _props5.onScrollFrame,
                onScrollStart = _props5.onScrollStart,
                onScrollStop = _props5.onScrollStop,
                onUpdate = _props5.onUpdate,
                renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName,
                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                autoHide = _props5.autoHide,
                autoHideTimeout = _props5.autoHideTimeout,
                autoHideDuration = _props5.autoHideDuration,
                thumbSize = _props5.thumbSize,
                thumbMinSize = _props5.thumbMinSize,
                universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                    _this7.container = _ref3;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                    _this7.view = _ref4;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                    _this7.trackHorizontal = _ref5;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                    _this7.thumbHorizontal = _ref6;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                    _this7.trackVertical = _ref7;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                    _this7.thumbVertical = _ref8;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2000)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {


var space = __webpack_require__(2003)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__(2004)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),
/* 2004 */
/***/ (function(module, exports) {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),
/* 2005 */
/***/ (function(module, exports) {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2007)();
}


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(2008);
var invariant = __webpack_require__(2009);
var ReactPropTypesSecret = __webpack_require__(2010);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__(1318);

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var containerStyleDefault = exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ''
};

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _general = __webpack_require__(113);

var _users = __webpack_require__(777);

var _preferences = __webpack_require__(784);

var _channels = __webpack_require__(783);

var _posts = __webpack_require__(805);

var _posts2 = __webpack_require__(808);

var _constants = __webpack_require__(19);

var _constants2 = __webpack_require__(29);

var _create_comment = __webpack_require__(2019);

var _rhs = __webpack_require__(818);

var _create_comment2 = __webpack_require__(2020);

var _create_comment3 = _interopRequireDefault(_create_comment2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var err = state.requests.posts.createPost.error || {};

    var draft = (0, _rhs.getPostDraft)(state, _constants2.StoragePrefixes.COMMENT_DRAFT, ownProps.rootId);
    var enableAddButton = draft.message.trim().length !== 0 || draft.fileInfos.length !== 0;

    var channelMembersCount = (0, _channels.getAllChannelStats)(state)[ownProps.channelId] ? (0, _channels.getAllChannelStats)(state)[ownProps.channelId].member_count : 1;
    var messageInHistory = (0, _posts.makeGetMessageInHistoryItem)(_constants.Posts.MESSAGE_TYPES.COMMENT)(state);

    var channel = state.entities.channels.channels[ownProps.channelId] || {};

    var config = (0, _general.getConfig)(state);
    var enableConfirmNotificationsToChannel = config.EnableConfirmNotificationsToChannel === 'true';
    var enableEmojiPicker = config.EnableEmojiPicker === 'true';

    return {
        draft: draft,
        messageInHistory: messageInHistory,
        enableAddButton: enableAddButton,
        channelMembersCount: channelMembersCount,
        ctrlSend: (0, _preferences.getBool)(state, _constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter'),
        createPostErrorId: err.server_error_id,
        readOnlyChannel: !(0, _users.isCurrentUserSystemAdmin)(state) && config.ExperimentalTownSquareIsReadOnly === 'true' && channel.name === _constants2.Constants.DEFAULT_CHANNEL,
        enableConfirmNotificationsToChannel: enableConfirmNotificationsToChannel,
        enableEmojiPicker: enableEmojiPicker
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function makeOnUpdateCommentDraft(rootId) {
    return function (draft) {
        return (0, _create_comment.updateCommentDraft)(rootId, draft);
    };
}

function makeMapDispatchToProps() {
    var onUpdateCommentDraft = void 0;
    var onSubmit = void 0;
    var onMoveHistoryIndexBack = void 0;
    var onMoveHistoryIndexForward = void 0;
    var onEditLatestPost = void 0;

    function onResetHistoryIndex() {
        return (0, _posts2.resetHistoryIndex)(_constants.Posts.MESSAGE_TYPES.COMMENT);
    }

    var rootId = void 0;
    var channelId = void 0;
    var latestPostId = void 0;

    return function (dispatch, ownProps) {
        if (rootId !== ownProps.rootId) {
            onUpdateCommentDraft = makeOnUpdateCommentDraft(ownProps.rootId);
            onMoveHistoryIndexBack = (0, _create_comment.makeOnMoveHistoryIndex)(ownProps.rootId, -1);
            onMoveHistoryIndexForward = (0, _create_comment.makeOnMoveHistoryIndex)(ownProps.rootId, 1);
        }

        if (rootId !== ownProps.rootId || channelId !== ownProps.channelId) {
            onEditLatestPost = (0, _create_comment.makeOnEditLatestPost)(ownProps.channelId, ownProps.rootId);
        }

        if (rootId !== ownProps.rootId || channelId !== ownProps.channelId || latestPostId !== ownProps.latestPostId) {
            onSubmit = (0, _create_comment.makeOnSubmit)(ownProps.channelId, ownProps.rootId, ownProps.latestPostId);
        }

        rootId = ownProps.rootId;
        channelId = ownProps.channelId;
        latestPostId = ownProps.latestPostId;

        return (0, _redux.bindActionCreators)({
            clearCommentDraftUploads: _create_comment.clearCommentDraftUploads,
            onUpdateCommentDraft: onUpdateCommentDraft,
            onSubmit: onSubmit,
            onResetHistoryIndex: onResetHistoryIndex,
            onMoveHistoryIndexBack: onMoveHistoryIndexBack,
            onMoveHistoryIndexForward: onMoveHistoryIndexForward,
            onEditLatestPost: onEditLatestPost,
            resetCreatePostRequest: _posts2.resetCreatePostRequest
        }, dispatch);
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, makeMapDispatchToProps)(_create_comment3.default);

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(283);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

exports.clearCommentDraftUploads = clearCommentDraftUploads;
exports.updateCommentDraft = updateCommentDraft;
exports.makeOnMoveHistoryIndex = makeOnMoveHistoryIndex;
exports.submitPost = submitPost;
exports.submitReaction = submitReaction;
exports.submitCommand = submitCommand;
exports.makeOnSubmit = makeOnSubmit;
exports.makeOnEditLatestPost = makeOnEditLatestPost;

var _reselect = __webpack_require__(78);

var _users = __webpack_require__(777);

var _teams = __webpack_require__(274);

var _posts = __webpack_require__(805);

var _emojis = __webpack_require__(877);

var _posts2 = __webpack_require__(808);

var _constants = __webpack_require__(19);

var _post_actions = __webpack_require__(802);

var PostActions = _interopRequireWildcard(_post_actions);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _channel_actions = __webpack_require__(809);

var ChannelActions = _interopRequireWildcard(_channel_actions);

var _storage = __webpack_require__(285);

var _emoji_store = __webpack_require__(829);

var _rhs = __webpack_require__(818);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _constants2 = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clearCommentDraftUploads() {
    return (0, _storage.actionOnGlobalItemsWithPrefix)(_constants2.StoragePrefixes.COMMENT_DRAFT, function (key, value) {
        if (value) {
            return (0, _extends3.default)({}, value, { uploadsInProgress: [] });
        }
        return value;
    });
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function updateCommentDraft(rootId, draft) {
    return (0, _storage.setGlobalItem)('' + _constants2.StoragePrefixes.COMMENT_DRAFT + rootId, draft);
}

function makeOnMoveHistoryIndex(rootId, direction) {
    var getMessageInHistory = (0, _posts.makeGetMessageInHistoryItem)(_constants.Posts.MESSAGE_TYPES.COMMENT);

    return function () {
        return function (dispatch, getState) {
            var draft = (0, _rhs.getPostDraft)(getState(), _constants2.StoragePrefixes.COMMENT_DRAFT, rootId);
            if (draft.message !== '' && draft.message !== getMessageInHistory(getState())) {
                return;
            }

            if (direction === -1) {
                dispatch((0, _posts2.moveHistoryIndexBack)(_constants.Posts.MESSAGE_TYPES.COMMENT));
            } else if (direction === 1) {
                dispatch((0, _posts2.moveHistoryIndexForward)(_constants.Posts.MESSAGE_TYPES.COMMENT));
            }

            var nextMessageInHistory = getMessageInHistory(getState());

            dispatch(updateCommentDraft(rootId, (0, _extends3.default)({}, draft, { message: nextMessageInHistory })));
        };
    };
}

function submitPost(channelId, rootId, draft) {
    return function (dispatch, getState) {
        var state = getState();

        var userId = (0, _users.getCurrentUserId)(state);

        var time = Utils.getTimestamp();

        var post = {
            file_ids: [],
            message: draft.message,
            channel_id: channelId,
            root_id: rootId,
            parent_id: rootId,
            pending_post_id: userId + ':' + time,
            user_id: userId,
            create_at: time
        };

        GlobalActions.emitUserCommentedEvent(post);

        PostActions.createPost(post, draft.fileInfos);
    };
}

function submitReaction(postId, action, emojiName) {
    return function (dispatch) {
        if (action === '+') {
            dispatch((0, _posts2.addReaction)(postId, emojiName));
            PostActions.emitEmojiPosted(emojiName);
        } else if (action === '-') {
            dispatch((0, _posts2.removeReaction)(postId, emojiName));
        }
    };
}

function submitCommand(channelId, rootId, draft) {
    return function (dispatch, getState) {
        var state = getState();

        var teamId = (0, _teams.getCurrentTeamId)(state);

        var args = {
            channel_id: channelId,
            team_id: teamId,
            root_id: rootId,
            parent_id: rootId
        };

        var message = draft.message;


        return new _promise2.default(function (resolve, reject) {
            ChannelActions.executeCommand(message, args, resolve, function (err) {
                if (err.sendMessage) {
                    dispatch(submitPost(channelId, rootId, draft));
                } else {
                    reject(err);
                }
            });
        });
    };
}

function makeOnSubmit(channelId, rootId, latestPostId) {
    var _this = this;

    return function () {
        return function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatch, getState) {
                var draft, message, isReaction, emojis, emojiMap;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                draft = (0, _rhs.getPostDraft)(getState(), _constants2.StoragePrefixes.COMMENT_DRAFT, rootId);
                                message = draft.message;


                                dispatch((0, _posts2.addMessageIntoHistory)(message));

                                dispatch(updateCommentDraft(rootId, null));

                                isReaction = Utils.REACTION_PATTERN.exec(message);
                                emojis = (0, _emojis.getCustomEmojisByName)(getState());
                                emojiMap = new _emoji_store.EmojiMap(emojis);

                                if (!(isReaction && emojiMap.has(isReaction[2]))) {
                                    _context.next = 11;
                                    break;
                                }

                                dispatch(submitReaction(latestPostId, isReaction[1], isReaction[2]));
                                _context.next = 17;
                                break;

                            case 11:
                                if (!(message.indexOf('/') === 0)) {
                                    _context.next = 16;
                                    break;
                                }

                                _context.next = 14;
                                return dispatch(submitCommand(channelId, rootId, draft));

                            case 14:
                                _context.next = 17;
                                break;

                            case 16:
                                dispatch(submitPost(channelId, rootId, draft));

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }();
    };
}

function makeGetCurrentUsersLatestPost(channelId, rootId) {
    return (0, _reselect.createSelector)(_users.getCurrentUserId, function (state) {
        return state.entities.posts.postsInChannel[channelId];
    }, function (state) {
        return function (id) {
            return (0, _posts.getPost)(state, id);
        };
    }, function (userId, postIds, getPostById) {
        var lastPost = null;

        if (!postIds) {
            return lastPost;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(postIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var id = _step.value;

                var post = getPostById(id) || {};

                // don't edit webhook posts, deleted posts, or system messages
                if (post.user_id !== userId || post.props && post.props.from_webhook || post.state === _constants2.Constants.POST_DELETED || post.type && post.type.startsWith(_constants2.Constants.SYSTEM_MESSAGE_PREFIX)) {
                    continue;
                }

                if (rootId) {
                    if (post.root_id === rootId || post.id === rootId) {
                        lastPost = post;
                        break;
                    }
                } else {
                    lastPost = post;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return lastPost;
    });
}

function makeOnEditLatestPost(channelId, rootId) {
    var getCurrentUsersLatestPost = makeGetCurrentUsersLatestPost(channelId, rootId);
    var getCommentCount = (0, _posts.makeGetCommentCountForPost)();

    return function () {
        return function (dispatch, getState) {
            var state = getState();

            var lastPost = getCurrentUsersLatestPost(state);

            if (!lastPost) {
                return;
            }

            dispatch(PostActions.setEditingPost(lastPost.id, getCommentCount(state, { post: lastPost }), 'reply_textbox', Utils.localizeMessage('create_comment.commentTitle', 'Comment'), true));
        };
    };
}

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

var _emoji_picker_overlay = __webpack_require__(883);

var _emoji_picker_overlay2 = _interopRequireDefault(_emoji_picker_overlay);

var _file_preview = __webpack_require__(1319);

var _file_preview2 = _interopRequireDefault(_file_preview);

var _file_upload = __webpack_require__(1322);

var _file_upload2 = _interopRequireDefault(_file_upload);

var _msg_typing = __webpack_require__(1323);

var _msg_typing2 = _interopRequireDefault(_msg_typing);

var _post_deleted_modal = __webpack_require__(1324);

var _post_deleted_modal2 = _interopRequireDefault(_post_deleted_modal);

var _emoji_icon = __webpack_require__(909);

var _emoji_icon2 = _interopRequireDefault(_emoji_icon);

var _textbox = __webpack_require__(968);

var _textbox2 = _interopRequireDefault(_textbox);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyCodes = _constants2.default.KeyCodes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CreateComment = function (_React$PureComponent) {
    (0, _inherits3.default)(CreateComment, _React$PureComponent);

    function CreateComment(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, CreateComment);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CreateComment.__proto__ || (0, _getPrototypeOf2.default)(CreateComment)).call(this, props));

        _this.handleNotifyAllConfirmation = function (e) {
            _this.hideNotifyAllModal();
            _this.doSubmit(e);
        };

        _this.hideNotifyAllModal = function () {
            _this.setState({ showConfirmModal: false });
        };

        _this.showNotifyAllModal = function () {
            _this.setState({ showConfirmModal: true });
        };

        _this.toggleEmojiPicker = function () {
            _this.setState({ showEmojiPicker: !_this.state.showEmojiPicker });
        };

        _this.hideEmojiPicker = function () {
            _this.setState({ showEmojiPicker: false });
        };

        _this.handleEmojiClick = function (emoji) {
            var emojiAlias = emoji.name || emoji.aliases[0];

            if (!emojiAlias) {
                //Oops.. There went something wrong
                return;
            }

            var draft = _this.state.draft;


            var newMessage = '';
            if (draft.message === '') {
                newMessage = ':' + emojiAlias + ': ';
            } else if (/\s+$/.test(draft.message)) {
                // Check whether there is already a blank at the end of the current message
                newMessage = draft.message + ':' + emojiAlias + ': ';
            } else {
                newMessage = draft.message + ' :' + emojiAlias + ': ';
            }

            _this.props.onUpdateCommentDraft((0, _extends3.default)({}, draft, { message: newMessage }));

            _this.setState({
                showEmojiPicker: false,
                draft: (0, _extends3.default)({}, draft, { message: newMessage })
            });

            _this.focusTextbox();
        };

        _this.handlePostError = function (postError) {
            _this.setState({ postError: postError });
        };

        _this.handleSubmit = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(e) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                e.preventDefault();

                                if (!(_this.props.enableConfirmNotificationsToChannel && _this.props.channelMembersCount > _constants2.default.NOTIFY_ALL_MEMBERS && PostUtils.containsAtChannel(_this.state.draft.message))) {
                                    _context.next = 4;
                                    break;
                                }

                                _this.showNotifyAllModal();
                                return _context.abrupt('return');

                            case 4:
                                _context.next = 6;
                                return _this.doSubmit(e);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.doSubmit = function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
                var enableAddButton, draft, fasterThanHumanWillClick, forceFocus;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (e) {
                                    e.preventDefault();
                                }

                                enableAddButton = _this.props.enableAddButton;
                                draft = _this.state.draft;

                                if (enableAddButton) {
                                    _context2.next = 5;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 5:
                                if (!(draft.uploadsInProgress.length > 0)) {
                                    _context2.next = 7;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 7:
                                if (!_this.state.postError) {
                                    _context2.next = 11;
                                    break;
                                }

                                _this.setState({ errorClass: 'animation--highlight' });
                                setTimeout(function () {
                                    _this.setState({ errorClass: null });
                                }, _constants2.default.ANIMATION_TIMEOUT);
                                return _context2.abrupt('return');

                            case 11:
                                if (!_this.props.rootDeleted) {
                                    _context2.next = 14;
                                    break;
                                }

                                _this.showPostDeletedModal();
                                return _context2.abrupt('return');

                            case 14:
                                fasterThanHumanWillClick = 150;
                                forceFocus = Date.now() - _this.lastBlurAt < fasterThanHumanWillClick;

                                _this.focusTextbox(forceFocus);

                                _context2.prev = 17;
                                _context2.next = 20;
                                return _this.props.onSubmit();

                            case 20:

                                _this.setState({
                                    postError: null,
                                    serverError: null
                                });
                                _context2.next = 27;
                                break;

                            case 23:
                                _context2.prev = 23;
                                _context2.t0 = _context2['catch'](17);

                                _this.setState({ serverError: _context2.t0.message });
                                return _context2.abrupt('return');

                            case 27:

                                _this.setState({ draft: (0, _extends3.default)({}, _this.props.draft, { uploadsInProgress: [] }) });

                            case 28:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[17, 23]]);
            }));

            return function (_x2) {
                return _ref2.apply(this, arguments);
            };
        }();

        _this.commentMsgKeyPress = function (e) {
            if (!UserAgent.isMobile() && (_this.props.ctrlSend && (e.ctrlKey || e.metaKey) || !_this.props.ctrlSend)) {
                if (Utils.isKeyPressed(e, KeyCodes.ENTER) && !e.shiftKey && !e.altKey) {
                    e.preventDefault();
                    _this.refs.textbox.blur();
                    _this.handleSubmit(e);
                }
            }

            GlobalActions.emitLocalUserTypingEvent(_this.props.channelId, _this.props.rootId);
        };

        _this.scrollToBottom = function () {
            var $el = (0, _jquery2.default)('.post-right__scroll');
            if ($el[0]) {
                $el.parent().scrollTop($el[0].scrollHeight);
            }
        };

        _this.handleChange = function (e) {
            var message = e.target.value;

            var draft = _this.state.draft;

            var updatedDraft = (0, _extends3.default)({}, draft, { message: message });
            _this.props.onUpdateCommentDraft(updatedDraft);
            _this.setState({ draft: updatedDraft });

            _this.scrollToBottom();
        };

        _this.handleKeyDown = function (e) {
            if (_this.props.ctrlSend && Utils.isKeyPressed(e, _constants2.default.KeyCodes.ENTER) && (e.ctrlKey || e.metaKey)) {
                _this.commentMsgKeyPress(e);
                return;
            }

            var draft = _this.state.draft;
            var message = draft.message;


            if (!e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey && Utils.isKeyPressed(e, _constants2.default.KeyCodes.UP) && message === '') {
                e.preventDefault();
                if (_this.refs.textbox) {
                    _this.refs.textbox.blur();
                }
                _this.props.onEditLatestPost();
            }

            if ((e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey) {
                if (Utils.isKeyPressed(e, _constants2.default.KeyCodes.UP)) {
                    e.preventDefault();
                    _this.props.onMoveHistoryIndexBack();
                } else if (Utils.isKeyPressed(e, _constants2.default.KeyCodes.DOWN)) {
                    e.preventDefault();
                    _this.props.onMoveHistoryIndexForward();
                }
            }
        };

        _this.handleFileUploadChange = function () {
            _this.focusTextbox(true);
        };

        _this.handleUploadStart = function (clientIds) {
            var draft = _this.state.draft;

            var uploadsInProgress = [].concat((0, _toConsumableArray3.default)(draft.uploadsInProgress), (0, _toConsumableArray3.default)(clientIds));

            _this.props.onUpdateCommentDraft((0, _extends3.default)({}, draft, { uploadsInProgress: uploadsInProgress }));
            _this.setState({ draft: (0, _extends3.default)({}, draft, { uploadsInProgress: uploadsInProgress }) });

            // this is a bit redundant with the code that sets focus when the file input is clicked,
            // but this also resets the focus after a drag and drop
            _this.focusTextbox();
        };

        _this.handleFileUploadComplete = function (fileInfos, clientIds) {
            var draft = _this.state.draft;

            var uploadsInProgress = [].concat((0, _toConsumableArray3.default)(draft.uploadsInProgress));
            var newFileInfos = [].concat((0, _toConsumableArray3.default)(draft.fileInfos), (0, _toConsumableArray3.default)(fileInfos));

            // remove each finished file from uploads
            for (var i = 0; i < clientIds.length; i++) {
                var index = uploadsInProgress.indexOf(clientIds[i]);

                if (index !== -1) {
                    uploadsInProgress.splice(index, 1);
                }
            }

            _this.props.onUpdateCommentDraft((0, _extends3.default)({}, draft, { fileInfos: newFileInfos, uploadsInProgress: uploadsInProgress }));
            _this.setState({ draft: (0, _extends3.default)({}, draft, { fileInfos: newFileInfos, uploadsInProgress: uploadsInProgress }) });

            // Focus on preview if needed/possible - if user has switched teams since starting the file upload,
            // the preview will be undefined and the switch will fail
            if (typeof _this.refs.preview != 'undefined' && _this.refs.preview) {
                _this.refs.preview.refs.container.scrollIntoView();
            }
        };

        _this.handleUploadError = function (err) {
            var clientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

            if (clientId !== -1) {
                var draft = _this.state.draft;

                var uploadsInProgress = [].concat((0, _toConsumableArray3.default)(draft.uploadsInProgress));

                var index = uploadsInProgress.indexOf(clientId);
                if (index !== -1) {
                    uploadsInProgress.splice(index, 1);
                }

                _this.props.onUpdateCommentDraft((0, _extends3.default)({}, draft, { uploadsInProgress: uploadsInProgress }));
                _this.setState({ draft: (0, _extends3.default)({}, draft, { uploadsInProgress: uploadsInProgress }) });
            }

            _this.setState({ serverError: err });
        };

        _this.removePreview = function (id) {
            var draft = _this.state.draft;

            var fileInfos = [].concat((0, _toConsumableArray3.default)(draft.fileInfos));
            var uploadsInProgress = [].concat((0, _toConsumableArray3.default)(draft.uploadsInProgress));

            // Clear previous errors
            _this.handleUploadError(null);

            // id can either be the id of an uploaded file or the client id of an in progress upload
            var index = fileInfos.findIndex(function (info) {
                return info.id === id;
            });
            if (index === -1) {
                index = uploadsInProgress.indexOf(id);

                if (index !== -1) {
                    uploadsInProgress.splice(index, 1);

                    if (_this.refs.fileUpload && _this.refs.fileUpload.getWrappedInstance()) {
                        _this.refs.fileUpload.getWrappedInstance().cancelUpload(id);
                    }
                }
            } else {
                fileInfos.splice(index, 1);
            }

            _this.props.onUpdateCommentDraft((0, _extends3.default)({}, draft, { fileInfos: fileInfos, uploadsInProgress: uploadsInProgress }));
            _this.setState({ draft: (0, _extends3.default)({}, draft, { fileInfos: fileInfos, uploadsInProgress: uploadsInProgress }) });

            _this.handleFileUploadChange();
        };

        _this.getFileCount = function () {
            var _this$state$draft = _this.state.draft,
                fileInfos = _this$state$draft.fileInfos,
                uploadsInProgress = _this$state$draft.uploadsInProgress;

            return fileInfos.length + uploadsInProgress.length;
        };

        _this.getFileUploadTarget = function () {
            return _this.refs.textbox;
        };

        _this.getCreateCommentControls = function () {
            return _this.refs.createCommentControls;
        };

        _this.focusTextbox = function () {
            var keepFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (_this.refs.textbox && (keepFocus || !UserAgent.isMobile())) {
                _this.refs.textbox.focus();
            }
        };

        _this.showPostDeletedModal = function () {
            _this.setState({
                showPostDeletedModal: true
            });
        };

        _this.hidePostDeletedModal = function () {
            _this.setState({
                showPostDeletedModal: false
            });

            _this.props.resetCreatePostRequest();
        };

        _this.handleBlur = function () {
            _this.lastBlurAt = Date.now();
        };

        _this.state = {
            showPostDeletedModal: false,
            showConfirmModal: false,
            showEmojiPicker: false,
            draft: {
                message: '',
                uploadsInProgress: [],
                fileInfos: []
            }
        };

        _this.lastBlurAt = 0;
        return _this;
    }

    (0, _createClass3.default)(CreateComment, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.clearCommentDraftUploads();
            this.props.onResetHistoryIndex();
            this.setState({ draft: (0, _extends3.default)({}, this.props.draft, { uploadsInProgress: [] }) });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.focusTextbox();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetCreatePostRequest();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (newProps.createPostErrorId === 'api.post.create_post.root_id.app_error' && newProps.createPostErrorId !== this.props.createPostErrorId) {
                this.showPostDeletedModal();
            }
            if (newProps.rootId !== this.props.rootId) {
                this.setState({ draft: (0, _extends3.default)({}, newProps.draft, { uploadsInProgress: [] }) });
            }

            if (this.props.messageInHistory !== newProps.messageInHistory) {
                this.setState({ draft: newProps.draft });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevState.draft.uploadsInProgress.length < this.state.draft.uploadsInProgress.length) {
                this.scrollToBottom();
            }

            if (prevProps.rootId !== this.props.rootId) {
                this.focusTextbox();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var draft = this.state.draft;
            var readOnlyChannel = this.props.readOnlyChannel;


            var notifyAllTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'notify_all.title.confirm',
                defaultMessage: 'Confirm sending notifications to entire channel'
            });

            var notifyAllConfirm = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'notify_all.confirm',
                defaultMessage: 'Confirm'
            });

            var notifyAllMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'notify_all.question',
                defaultMessage: 'By using @all or @channel you are about to send notifications to {totalMembers} people. Are you sure you want to do this?',
                values: {
                    totalMembers: this.props.channelMembersCount - 1
                }
            });

            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.serverError
                    )
                );
            }

            var postError = null;
            if (this.state.postError) {
                var postErrorClass = 'post-error' + (this.state.errorClass ? ' ' + this.state.errorClass : '');
                postError = _react2.default.createElement(
                    'label',
                    { className: postErrorClass },
                    this.state.postError
                );
            }

            var preview = null;
            if (!readOnlyChannel && (draft.fileInfos.length > 0 || draft.uploadsInProgress.length > 0)) {
                preview = _react2.default.createElement(_file_preview2.default, {
                    fileInfos: draft.fileInfos,
                    onRemove: this.removePreview,
                    uploadsInProgress: draft.uploadsInProgress,
                    ref: 'preview'
                });
            }

            var uploadsInProgressText = null;
            if (draft.uploadsInProgress.length > 0) {
                uploadsInProgressText = _react2.default.createElement(
                    'span',
                    { className: 'pull-right post-right-comments-upload-in-progress' },
                    draft.uploadsInProgress.length === 1 ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'create_comment.file',
                        defaultMessage: 'File uploading'
                    }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'create_comment.files',
                        defaultMessage: 'Files uploading'
                    })
                );
            }

            var addButtonClass = 'btn btn-primary comment-btn pull-right';
            if (!this.props.enableAddButton) {
                addButtonClass += ' disabled';
            }

            var fileUpload = void 0;
            if (!readOnlyChannel) {
                fileUpload = _react2.default.createElement(_file_upload2.default, {
                    ref: 'fileUpload',
                    fileCount: this.getFileCount(),
                    getTarget: this.getFileUploadTarget,
                    onFileUploadChange: this.handleFileUploadChange,
                    onUploadStart: this.handleUploadStart,
                    onFileUpload: this.handleFileUploadComplete,
                    onUploadError: this.handleUploadError,
                    postType: 'comment'
                });
            }

            var emojiPicker = null;
            if (this.props.enableEmojiPicker && !readOnlyChannel) {
                emojiPicker = _react2.default.createElement(
                    'span',
                    { className: 'emoji-picker__container' },
                    _react2.default.createElement(_emoji_picker_overlay2.default, {
                        show: this.state.showEmojiPicker,
                        container: this.props.getSidebarBody,
                        target: this.getCreateCommentControls,
                        onHide: this.hideEmojiPicker,
                        onEmojiClick: this.handleEmojiClick,
                        rightOffset: 15,
                        topOffset: 55
                    }),
                    _react2.default.createElement(_emoji_icon2.default, {
                        className: 'icon icon--emoji emoji-rhs ' + (this.state.showEmojiPicker ? 'active' : ''),
                        onClick: this.toggleEmojiPicker
                    })
                );
            }

            var createMessage = void 0;
            if (readOnlyChannel) {
                createMessage = Utils.localizeMessage('create_post.read_only', 'This channel is read-only. Only members with permission can post here.');
            } else {
                createMessage = Utils.localizeMessage('create_comment.addComment', 'Add a comment...');
            }

            return _react2.default.createElement(
                'form',
                { onSubmit: this.handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'post-create' },
                    _react2.default.createElement(
                        'div',
                        {
                            id: this.props.rootId,
                            className: 'post-create-body comment-create-body'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'post-body__cell' },
                            _react2.default.createElement(_textbox2.default, {
                                onChange: this.handleChange,
                                onKeyPress: this.commentMsgKeyPress,
                                onKeyDown: this.handleKeyDown,
                                handlePostError: this.handlePostError,
                                value: readOnlyChannel ? '' : draft.message,
                                onBlur: this.handleBlur,
                                createMessage: createMessage,
                                emojiEnabled: this.props.enableEmojiPicker,
                                initialText: '',
                                channelId: this.props.channelId,
                                isRHS: true,
                                popoverMentionKeyClick: true,
                                id: 'reply_textbox',
                                ref: 'textbox',
                                disabled: readOnlyChannel
                            }),
                            _react2.default.createElement(
                                'span',
                                {
                                    ref: 'createCommentControls',
                                    className: 'post-body__actions'
                                },
                                fileUpload,
                                emojiPicker
                            )
                        )
                    ),
                    _react2.default.createElement(_msg_typing2.default, {
                        channelId: this.props.channelId,
                        postId: this.props.rootId
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'post-create-footer' },
                        _react2.default.createElement('input', {
                            type: 'button',
                            className: addButtonClass,
                            value: Utils.localizeMessage('create_comment.comment', 'Add Comment'),
                            onClick: this.handleSubmit
                        }),
                        uploadsInProgressText,
                        postError,
                        preview,
                        serverError
                    )
                ),
                _react2.default.createElement(_post_deleted_modal2.default, {
                    show: this.state.showPostDeletedModal,
                    onHide: this.hidePostDeletedModal
                }),
                _react2.default.createElement(_confirm_modal2.default, {
                    title: notifyAllTitle,
                    message: notifyAllMessage,
                    confirmButtonText: notifyAllConfirm,
                    show: this.state.showConfirmModal,
                    onConfirm: this.handleNotifyAllConfirmation,
                    onCancel: this.hideNotifyAllModal
                })
            );
        }
    }]);
    return CreateComment;
}(_react2.default.PureComponent);

CreateComment.propTypes = {

    /**
     * The channel for which this comment is a part of
     */
    channelId: _propTypes2.default.string.isRequired,

    /**
     * The number of channel members
     */
    channelMembersCount: _propTypes2.default.number.isRequired,

    /**
     * The id of the parent post
     */
    rootId: _propTypes2.default.string.isRequired,

    /**
     * True if the root message was deleted
     */
    rootDeleted: _propTypes2.default.bool.isRequired,

    /**
     * The current history message selected
     */
    messageInHistory: _propTypes2.default.string,

    /**
     * The current draft of the comment
     */
    draft: _propTypes2.default.shape({
        message: _propTypes2.default.string.isRequired,
        uploadsInProgress: _propTypes2.default.array.isRequired,
        fileInfos: _propTypes2.default.array.isRequired
    }).isRequired,

    /**
     * Whether the submit button is enabled
     */
    enableAddButton: _propTypes2.default.bool.isRequired,

    /**
     * Set to force form submission on CTRL/CMD + ENTER instead of ENTER
     */
    ctrlSend: _propTypes2.default.bool,

    /**
     * The id of the latest post in this channel
     */
    latestPostId: _propTypes2.default.string,

    /**
     * A function returning a ref to the sidebar
     */
    getSidebarBody: _propTypes2.default.func,

    /**
     * Create post error id
     */
    createPostErrorId: _propTypes2.default.string,

    /**
     * Called to clear file uploads in progress
     */
    clearCommentDraftUploads: _propTypes2.default.func.isRequired,

    /**
     * Called when comment draft needs to be updated
     */
    onUpdateCommentDraft: _propTypes2.default.func.isRequired,

    /**
     * Called when submitting the comment
     */
    onSubmit: _propTypes2.default.func.isRequired,

    /**
     * Called when resetting comment message history index
     */
    onResetHistoryIndex: _propTypes2.default.func.isRequired,

    /**
     * Called when navigating back through comment message history
     */
    onMoveHistoryIndexBack: _propTypes2.default.func.isRequired,

    /**
     * Called when navigating forward through comment message history
     */
    onMoveHistoryIndexForward: _propTypes2.default.func.isRequired,

    /**
     * Called to initiate editing the user's latest post
     */
    onEditLatestPost: _propTypes2.default.func.isRequired,

    /**
     * Reset state of createPost request
     */
    resetCreatePostRequest: _propTypes2.default.func.isRequired,

    /**
     * Set if channel is read only
     */
    readOnlyChannel: _propTypes2.default.bool,

    /**
     * Set if @channel should warn in this channel.
     */
    enableConfirmNotificationsToChannel: _propTypes2.default.bool.isRequired,

    /**
     * Set if the emoji picker is enabled.
     */
    enableEmojiPicker: _propTypes2.default.bool.isRequired
};
exports.default = CreateComment;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * MIT Licensed
 */

/**
 * Module exports.
 */

module.exports = __webpack_require__(2022)


/***/ }),
/* 2022 */
/***/ (function(module, exports) {

module.exports = {"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana"},"application/3gpp-ims+xml":{"source":"iana"},"application/a2l":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana"},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","extensions":["atomsvc"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana"},"application/bacnet-xdd+zip":{"source":"iana"},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana"},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana"},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/cbor":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana"},"application/ccxml+xml":{"source":"iana","extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana"},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana"},"application/cellml+xml":{"source":"iana"},"application/cfw":{"source":"iana"},"application/clue_info+xml":{"source":"iana"},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana"},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana"},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana"},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana"},"application/cstadata+xml":{"source":"iana"},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","extensions":["mpd"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana"},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana"},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/docbook+xml":{"source":"apache","extensions":["dbk"]},"application/dskpp+xml":{"source":"iana"},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/emergencycalldata.comment+xml":{"source":"iana"},"application/emergencycalldata.control+xml":{"source":"iana"},"application/emergencycalldata.deviceinfo+xml":{"source":"iana"},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana"},"application/emergencycalldata.serviceinfo+xml":{"source":"iana"},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana"},"application/emergencycalldata.veds+xml":{"source":"iana"},"application/emma+xml":{"source":"iana","extensions":["emma"]},"application/emotionml+xml":{"source":"iana"},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana"},"application/epub+zip":{"source":"iana","extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana"},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false,"extensions":["woff"]},"application/font-woff2":{"compressible":false,"extensions":["woff2"]},"application/framework-attributes+xml":{"source":"iana"},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geoxacml+xml":{"source":"iana"},"application/gml+xml":{"source":"iana","extensions":["gml"]},"application/gpx+xml":{"source":"apache","extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana"},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana"},"application/ibe-pkg-reply+xml":{"source":"iana"},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana"},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana"},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana"},"application/kpml-response+xml":{"source":"iana"},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana"},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana"},"application/lost+xml":{"source":"iana","extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana"},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","extensions":["mads"]},"application/manifest+json":{"charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana"},"application/mathml-presentation+xml":{"source":"iana"},"application/mbms-associated-procedure-description+xml":{"source":"iana"},"application/mbms-deregister+xml":{"source":"iana"},"application/mbms-envelope+xml":{"source":"iana"},"application/mbms-msk+xml":{"source":"iana"},"application/mbms-msk-response+xml":{"source":"iana"},"application/mbms-protection-description+xml":{"source":"iana"},"application/mbms-reception-report+xml":{"source":"iana"},"application/mbms-register+xml":{"source":"iana"},"application/mbms-register-response+xml":{"source":"iana"},"application/mbms-schedule+xml":{"source":"iana"},"application/mbms-user-service-description+xml":{"source":"iana"},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana"},"application/media_control+xml":{"source":"iana"},"application/mediaservercontrol+xml":{"source":"iana","extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","extensions":["meta4"]},"application/mets+xml":{"source":"iana","extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mmt-usd+xml":{"source":"iana"},"application/mods+xml":{"source":"iana","extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana"},"application/mrb-publish+xml":{"source":"iana"},"application/msc-ivr+xml":{"source":"iana"},"application/msc-mixer+xml":{"source":"iana"},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana"},"application/n-triples":{"source":"iana"},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana"},"application/news-groupinfo":{"source":"iana"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana"},"application/nss":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p2p-overlay+xml":{"source":"iana"},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana"},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana"},"application/pidf-diff+xml":{"source":"iana"},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","extensions":["pls"]},"application/poc-settings+xml":{"source":"iana"},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana"},"application/provenance+xml":{"source":"iana"},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.hpub+zip":{"source":"iana"},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana"},"application/pskc+xml":{"source":"iana","extensions":["pskcxml"]},"application/qsig":{"source":"iana"},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf"]},"application/reginfo+xml":{"source":"iana","extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","extensions":["rld"]},"application/rfc+xml":{"source":"iana"},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana"},"application/rls-services+xml":{"source":"iana","extensions":["rs"]},"application/route-apd+xml":{"source":"iana"},"application/route-s-tsid+xml":{"source":"iana"},"application/route-usd+xml":{"source":"iana"},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana"},"application/samlmetadata+xml":{"source":"iana"},"application/sbml+xml":{"source":"iana","extensions":["sbml"]},"application/scaip+xml":{"source":"iana"},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/sep+xml":{"source":"iana"},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","extensions":["shf"]},"application/sieve":{"source":"iana"},"application/simple-filter+xml":{"source":"iana"},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","extensions":["srx"]},"application/spirits-event+xml":{"source":"iana"},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","extensions":["grxml"]},"application/sru+xml":{"source":"iana","extensions":["sru"]},"application/ssdl+xml":{"source":"apache","extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","extensions":["ssml"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/tei+xml":{"source":"iana","extensions":["tei","teicorpus"]},"application/thraud+xml":{"source":"iana","extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/trig":{"source":"iana"},"application/ttml+xml":{"source":"iana"},"application/tve-trigger":{"source":"iana"},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana"},"application/urc-ressheet+xml":{"source":"iana"},"application/urc-targetdesc+xml":{"source":"iana"},"application/urc-uisocketdesc+xml":{"source":"iana"},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana"},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana"},"application/vnd.3gpp-prose+xml":{"source":"iana"},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana"},"application/vnd.3gpp.bsf+xml":{"source":"iana"},"application/vnd.3gpp.gmop+xml":{"source":"iana"},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana"},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana"},"application/vnd.3gpp.mid-call+xml":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana"},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana"},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana"},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana"},"application/vnd.3gpp.ussd+xml":{"source":"iana"},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana"},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","extensions":["mpkg"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avistar+xml":{"source":"iana"},"application/vnd.balsamiq.bmml+xml":{"source":"iana"},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana"},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana"},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","extensions":["wbs"]},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana"},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana"},"application/vnd.cybank":{"source":"iana"},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume-movie":{"source":"iana"},"application/vnd.desmume.movie":{"source":"apache"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana"},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana"},"application/vnd.dvb.notif-container+xml":{"source":"iana"},"application/vnd.dvb.notif-generic+xml":{"source":"iana"},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana"},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana"},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana"},"application/vnd.dvb.notif-init+xml":{"source":"iana"},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana"},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana"},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana"},"application/vnd.eszigno3+xml":{"source":"iana","extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana"},"application/vnd.etsi.asic-e+zip":{"source":"iana"},"application/vnd.etsi.asic-s+zip":{"source":"iana"},"application/vnd.etsi.cug+xml":{"source":"iana"},"application/vnd.etsi.iptvcommand+xml":{"source":"iana"},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana"},"application/vnd.etsi.iptvprofile+xml":{"source":"iana"},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana"},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana"},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana"},"application/vnd.etsi.iptvservice+xml":{"source":"iana"},"application/vnd.etsi.iptvsync+xml":{"source":"iana"},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana"},"application/vnd.etsi.mcid+xml":{"source":"iana"},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana"},"application/vnd.etsi.pstn+xml":{"source":"iana"},"application/vnd.etsi.sci+xml":{"source":"iana"},"application/vnd.etsi.simservs+xml":{"source":"iana"},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana"},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana"},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana"},"application/vnd.gov.sk.e-form+zip":{"source":"iana"},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana"},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana"},"application/vnd.imagemeter.image+zip":{"source":"iana"},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana"},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana"},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana"},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana"},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana"},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana"},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana"},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana"},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana"},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","extensions":["lasxml"]},"application/vnd.liberty-request+xml":{"source":"iana"},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","extensions":["lbe"]},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana"},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana"},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana"},"application/vnd.marlin.drm.license+xml":{"source":"iana"},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana"},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana"},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana"},"application/vnd.ms-printing.printticket+xml":{"source":"apache"},"application/vnd.ms-printschematicket+xml":{"source":"iana"},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana"},"application/vnd.nokia.iptv.config+xml":{"source":"iana"},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana"},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana"},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana"},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana"},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana"},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana"},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana"},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana"},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana"},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana"},"application/vnd.oipf.spdlist+xml":{"source":"iana"},"application/vnd.oipf.ueprofile+xml":{"source":"iana"},"application/vnd.oipf.userprofile+xml":{"source":"iana"},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana"},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana"},"application/vnd.oma.bcast.imd+xml":{"source":"iana"},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana"},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana"},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana"},"application/vnd.oma.bcast.sprov+xml":{"source":"iana"},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana"},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana"},"application/vnd.oma.cab-pcc+xml":{"source":"iana"},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana"},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana"},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana"},"application/vnd.oma.group-usage-list+xml":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana"},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana"},"application/vnd.oma.poc.final-report+xml":{"source":"iana"},"application/vnd.oma.poc.groups+xml":{"source":"iana"},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana"},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana"},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana"},"application/vnd.oma.xcap-directory+xml":{"source":"iana"},"application/vnd.omads-email+xml":{"source":"iana"},"application/vnd.omads-file+xml":{"source":"iana"},"application/vnd.omads-folder+xml":{"source":"iana"},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana"},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml-template":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"apache","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml-template":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"apache","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml-template":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"apache","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana"},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana"},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana"},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana"},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana"},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos+xml":{"source":"iana"},"application/vnd.paos.xml":{"source":"apache"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana"},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana"},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana"},"application/vnd.radisys.msml+xml":{"source":"iana"},"application/vnd.radisys.msml-audit+xml":{"source":"iana"},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana"},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana"},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana"},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana"},"application/vnd.radisys.msml-conf+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana"},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana"},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.software602.filler.form+xml":{"source":"iana"},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana"},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana"},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana"},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana"},"application/vnd.wv.ssp+xml":{"source":"iana"},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana"},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","extensions":["vxml"]},"application/vq-rtcpxr":{"source":"iana"},"application/watcherinfo+xml":{"source":"iana"},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-otf":{"source":"apache","compressible":true,"extensions":["otf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-ttf":{"source":"apache","compressible":true,"extensions":["ttf","ttc"]},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"apache","extensions":["der","crt","pem"]},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana"},"application/xaml+xml":{"source":"apache","extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana"},"application/xcap-caps+xml":{"source":"iana"},"application/xcap-diff+xml":{"source":"iana","extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana"},"application/xcap-error+xml":{"source":"iana"},"application/xcap-ns+xml":{"source":"iana"},"application/xcon-conference-info+xml":{"source":"iana"},"application/xcon-conference-info-diff+xml":{"source":"iana"},"application/xenc+xml":{"source":"iana","extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache"},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana"},"application/xmpp+xml":{"source":"iana"},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","extensions":["xpl"]},"application/xslt+xml":{"source":"iana","extensions":["xslt"]},"application/xspf+xml":{"source":"apache","extensions":["xspf"]},"application/xv+xml":{"source":"iana","extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana"},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana"},"application/yin+xml":{"source":"iana","extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana"},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana"},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/otf":{"compressible":true,"extensions":["otf"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana"},"image/emf":{"source":"iana"},"image/fits":{"source":"iana"},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana"},"image/jp2":{"source":"iana"},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jpm":{"source":"iana"},"image/jpx":{"source":"iana"},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana"},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana"},"image/tiff":{"source":"iana","compressible":false,"extensions":["tiff","tif"]},"image/tiff-fx":{"source":"iana"},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana"},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana"},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana"},"image/vnd.valve.source.texture":{"source":"iana"},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana"},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana"},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana"},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana"},"message/global-delivery-status":{"source":"iana"},"message/global-disposition-notification":{"source":"iana"},"message/global-headers":{"source":"iana"},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana"},"model/3mf":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/vnd.collada+xml":{"source":"iana","extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana"},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana"},"model/vnd.parasolid.transmit.binary":{"source":"iana"},"model/vnd.parasolid.transmit.text":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.valve.source.compiled-map":{"source":"iana"},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana"},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana"},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana","compressible":false},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/hjson":{"extensions":["hjson"]},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/slim":{"extensions":["slim","slm"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana"},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vp8":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPublicLink = undefined;

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var getPublicLink = exports.getPublicLink = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(fileId, success) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _client.Client4.getFilePublicLink(fileId).then(function (data) {
                            if (data && success) {
                                success(data.link);
                            }
                        }).catch(function () {} //eslint-disable-line no-empty-function
                        );

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getPublicLink(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

exports.uploadFile = uploadFile;

var _reduxBatchedActions = __webpack_require__(921);

var _superagent = __webpack_require__(1314);

var _superagent2 = _interopRequireDefault(_superagent);

var _action_types = __webpack_require__(3);

var _errors = __webpack_require__(828);

var _helpers = __webpack_require__(821);

var _client = __webpack_require__(270);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function uploadFile(file, name, channelId, clientId, successCallback, errorCallback) {
    var dispatch = _redux_store2.default.dispatch,
        getState = _redux_store2.default.getState;


    function handleResponse(err, res) {
        if (err) {
            var e = void 0;
            if (res && res.body && res.body.id) {
                e = res.body;
            } else if (err.status === 0 || !err.status) {
                e = { message: Utils.localizeMessage('channel_loader.connection_error', 'There appears to be a problem with your internet connection.') };
            } else {
                e = { message: Utils.localizeMessage('channel_loader.unknown_error', 'We received an unexpected status code from the server.') + ' (' + err.status + ')' };
            }

            (0, _helpers.forceLogoutIfNecessary)(err, dispatch);

            var failure = {
                type: _action_types.FileTypes.UPLOAD_FILES_FAILURE,
                clientIds: [clientId],
                channelId: channelId,
                rootId: null,
                error: err
            };

            dispatch((0, _reduxBatchedActions.batchActions)([failure, (0, _errors.getLogErrorAction)(err)]), getState);

            if (errorCallback) {
                errorCallback(e);
            }
        } else if (res) {
            var data = res.body.file_infos.map(function (fileInfo, index) {
                return (0, _extends3.default)({}, fileInfo, {
                    clientId: res.body.client_ids[index]
                });
            });

            dispatch((0, _reduxBatchedActions.batchActions)([{
                type: _action_types.FileTypes.RECEIVED_UPLOAD_FILES,
                data: data,
                channelId: channelId,
                rootId: null
            }, {
                type: _action_types.FileTypes.UPLOAD_FILES_SUCCESS
            }]), getState);

            if (successCallback) {
                successCallback(res.body);
            }
        }
    }

    dispatch({ type: _action_types.FileTypes.UPLOAD_FILES_REQUEST }, getState);

    return _superagent2.default.post(_client.Client4.getFilesRoute()).set(_client.Client4.getOptions().headers).attach('files', file, name).field('channel_id', channelId).field('client_ids', clientId).accept('application/json').end(handleResponse);
}

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deleteProperty = __webpack_require__(176);

var _deleteProperty2 = _interopRequireDefault(_deleteProperty);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

__webpack_require__(2025);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _delayed_action = __webpack_require__(931);

var _delayed_action2 = _interopRequireDefault(_delayed_action);

var _user_agent = __webpack_require__(790);

var _utils = __webpack_require__(762);

var _attachment_icon = __webpack_require__(1321);

var _attachment_icon2 = _interopRequireDefault(_attachment_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var holders = (0, _reactIntl.defineMessages)({
    limited: {
        id: 'file_upload.limited',
        defaultMessage: 'Uploads limited to {count, number} files maximum. Please use additional posts for more files.'
    },
    filesAbove: {
        id: 'file_upload.filesAbove',
        defaultMessage: 'Files above {max}MB could not be uploaded: {filenames}'
    },
    fileAbove: {
        id: 'file_upload.fileAbove',
        defaultMessage: 'File above {max}MB could not be uploaded: {filename}'
    },
    zeroBytesFiles: {
        id: 'file_upload.zeroBytesFiles',
        defaultMessage: 'You are uploading empty files: {filenames}'
    },
    zeroBytesFile: {
        id: 'file_upload.zeroBytesFile',
        defaultMessage: 'You are uploading an empty file: {filename}'
    },
    pasted: {
        id: 'file_upload.pasted',
        defaultMessage: 'Image Pasted at '
    }
}); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var OVERLAY_TIMEOUT = 500;

var FileUpload = function (_PureComponent) {
    (0, _inherits3.default)(FileUpload, _PureComponent);

    function FileUpload(props) {
        (0, _classCallCheck3.default)(this, FileUpload);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FileUpload.__proto__ || (0, _getPrototypeOf2.default)(FileUpload)).call(this, props));

        _this.fileUploadSuccess = function (data) {
            if (data) {
                _this.props.onFileUpload(data.file_infos, data.client_ids, _this.props.currentChannelId);

                var requests = (0, _assign2.default)({}, _this.state.requests);
                for (var j = 0; j < data.client_ids.length; j++) {
                    (0, _deleteProperty2.default)(requests, data.client_ids[j]);
                }
                _this.setState({ requests: requests });
            }
        };

        _this.fileUploadFail = function (err, clientId) {
            _this.props.onUploadError(err, clientId, _this.props.currentChannelId);
        };

        _this.uploadFiles = function (files) {
            var sortedFiles = (0, _utils.sortFilesByName)(files);

            // clear any existing errors
            _this.props.onUploadError(null);

            var currentChannelId = _this.props.currentChannelId;


            var uploadsRemaining = _constants2.default.MAX_UPLOAD_FILES - _this.props.fileCount;
            var numUploads = 0;

            // keep track of how many files have been too large
            var tooLargeFiles = [];
            var zeroFiles = [];
            var clientIds = [];

            var _loop = function _loop(i) {
                if (sortedFiles[i].size > _this.props.maxFileSize) {
                    tooLargeFiles.push(sortedFiles[i]);
                    return 'continue';
                }
                if (sortedFiles[i].size === 0) {
                    zeroFiles.push(sortedFiles[i]);
                }

                // generate a unique id that can be used by other components to refer back to this upload
                var clientId = (0, _utils.generateId)();

                var request = _this.props.uploadFile(sortedFiles[i], sortedFiles[i].name, currentChannelId, clientId, function (data) {
                    return _this.fileUploadSuccess(data);
                }, function (e) {
                    return _this.fileUploadFail(e, clientId);
                });

                var requests = _this.state.requests;
                requests[clientId] = request;
                _this.setState({ requests: requests });
                clientIds.push(clientId);

                numUploads += 1;
            };

            for (var i = 0; i < sortedFiles.length && numUploads < uploadsRemaining; i++) {
                var _ret = _loop(i);

                if (_ret === 'continue') continue;
            }

            _this.props.onUploadStart(clientIds, currentChannelId);

            var formatMessage = _this.context.intl.formatMessage;

            var errors = [];
            if (sortedFiles.length > uploadsRemaining) {
                errors.push(formatMessage(holders.limited, { count: _constants2.default.MAX_UPLOAD_FILES }));
            }

            if (tooLargeFiles.length > 1) {
                var tooLargeFilenames = tooLargeFiles.map(function (file) {
                    return file.name;
                }).join(', ');

                errors.push(formatMessage(holders.filesAbove, { max: _this.props.maxFileSize / 1048576, filenames: tooLargeFilenames }));
            } else if (tooLargeFiles.length > 0) {
                errors.push(formatMessage(holders.fileAbove, { max: _this.props.maxFileSize / 1048576, filename: tooLargeFiles[0].name }));
            }

            if (zeroFiles.length > 1) {
                var zeroFilenames = zeroFiles.map(function (file) {
                    return file.name;
                }).join(', ');

                errors.push(formatMessage(holders.zeroBytesFiles, { filenames: zeroFilenames }));
            } else if (zeroFiles.length > 0) {
                errors.push(formatMessage(holders.zeroBytesFile, { filename: zeroFiles[0].name }));
            }

            if (errors.length > 0) {
                _this.props.onUploadError(errors.join(', '));
            }
        };

        _this.handleChange = function (e) {
            if (e.target.files.length > 0) {
                _this.uploadFiles(e.target.files);

                (0, _utils.clearFileInput)(e.target);
            }

            _this.props.onFileUploadChange();
        };

        _this.handleDrop = function (e) {
            if (!_this.props.canUploadFiles) {
                _this.props.onUploadError((0, _utils.localizeMessage)('file_upload.disabled', 'File attachments are disabled.'));
                return;
            }

            _this.props.onUploadError(null);

            var files = e.originalEvent.dataTransfer.files;

            if (typeof files !== 'string' && files.length) {
                _this.uploadFiles(files);
            }

            _this.props.onFileUploadChange();
        };

        _this.registerDragEvents = function (containerSelector, overlaySelector) {
            var self = _this;

            var overlay = (0, _jquery2.default)(overlaySelector);

            var dragTimeout = new _delayed_action2.default(function () {
                if (!overlay.hasClass('hidden')) {
                    overlay.addClass('hidden');
                }
            });

            var dragsterActions = {};
            if (_this.props.canUploadFiles) {
                dragsterActions = {
                    enter: function enter(dragsterEvent, e) {
                        var files = e.originalEvent.dataTransfer;

                        if ((0, _utils.isFileTransfer)(files)) {
                            (0, _jquery2.default)(overlaySelector).removeClass('hidden');
                        }
                    },
                    leave: function leave(dragsterEvent, e) {
                        var files = e.originalEvent.dataTransfer;

                        if ((0, _utils.isFileTransfer)(files) && !overlay.hasClass('hidden')) {
                            overlay.addClass('hidden');
                        }

                        dragTimeout.cancel();
                    },
                    over: function over() {
                        dragTimeout.fireAfter(OVERLAY_TIMEOUT);
                    },
                    drop: function drop(dragsterEvent, e) {
                        if (!overlay.hasClass('hidden')) {
                            overlay.addClass('hidden');
                        }

                        dragTimeout.cancel();

                        self.handleDrop(e);
                    }
                };
            } else {
                dragsterActions = {
                    drop: function drop(dragsterEvent, e) {
                        self.handleDrop(e);
                    }
                };
            }

            (0, _jquery2.default)(containerSelector).dragster(dragsterActions);
        };

        _this.pasteUpload = function (e) {
            var formatMessage = _this.context.intl.formatMessage;


            if (!e.clipboardData || !e.clipboardData.items) {
                return;
            }

            var textarea = _reactDom2.default.findDOMNode(_this.props.getTarget());
            if (!textarea || !textarea.contains(e.target)) {
                return;
            }

            _this.props.onUploadError(null);

            var items = [];
            for (var _i = 0; _i < e.clipboardData.items.length; _i++) {
                var item = e.clipboardData.items[_i];

                if (item.kind !== 'file') {
                    continue;
                }

                items.push(item);
            }

            // This looks redundant, but must be done this way due to
            // setState being an asynchronous call
            if (items && items.length > 0) {
                if (!_this.props.canUploadFiles) {
                    _this.props.onUploadError((0, _utils.localizeMessage)('file_upload.disabled', 'File attachments are disabled.'));
                    return;
                }
                var uploadsRemaining = _constants2.default.MAX_UPLOAD_FILES - _this.props.fileCount;
                var numToUpload = Math.min(uploadsRemaining, items.length);

                if (items.length > numToUpload) {
                    _this.props.onUploadError(formatMessage(holders.limited, { count: _constants2.default.MAX_UPLOAD_FILES }));
                }

                var currentChannelId = _this.props.currentChannelId;

                var _loop2 = function _loop2() {
                    file = items[i].getAsFile();

                    if (!file) {
                        return 'continue';
                    }

                    // generate a unique id that can be used by other components to refer back to this file upload
                    var clientId = (0, _utils.generateId)();

                    d = new Date();

                    var hour = d.getHours();
                    hour = hour < 10 ? '0' + hour : '' + hour;

                    var minute = d.getMinutes();
                    minute = minute < 10 ? '0' + minute : '' + minute;

                    ext = '';

                    if (file.name) {
                        if (file.name.includes('.')) {
                            ext = file.name.substr(file.name.lastIndexOf('.'));
                        }
                    } else if (items[i].type.includes('/')) {
                        ext = '.' + items[i].type.split('/')[1].toLowerCase();
                    }

                    var name = formatMessage(holders.pasted) + d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + hour + '-' + minute + ext;

                    var request = _this.props.uploadFile(file, name, currentChannelId, clientId, function (data) {
                        return _this.fileUploadSuccess(data);
                    }, function (err) {
                        return _this.fileUploadFail(err, clientId);
                    });

                    var requests = _this.state.requests;
                    requests[clientId] = request;
                    _this.setState({ requests: requests });

                    _this.props.onUploadStart([clientId], currentChannelId);
                };

                for (var i = 0; i < items.length && i < numToUpload; i++) {
                    var file;
                    var d;
                    var ext;

                    var _ret2 = _loop2();

                    if (_ret2 === 'continue') continue;
                }

                if (numToUpload > 0) {
                    _this.props.onFileUploadChange();
                }
            }
        };

        _this.keyUpload = function (e) {
            if ((0, _utils.cmdOrCtrlPressed)(e) && (0, _utils.isKeyPressed)(e, _constants2.default.KeyCodes.U)) {
                e.preventDefault();

                if (!_this.props.canUploadFiles) {
                    _this.props.onUploadError((0, _utils.localizeMessage)('file_upload.disabled', 'File attachments are disabled.'));
                    return;
                }
                var postTextbox = _this.props.postType === 'post' && document.activeElement.id === 'post_textbox';
                var commentTextbox = _this.props.postType === 'comment' && document.activeElement.id === 'reply_textbox';
                if (postTextbox || commentTextbox) {
                    (0, _jquery2.default)(_this.refs.fileInput).focus().trigger('click');
                }
            }
        };

        _this.cancelUpload = function (clientId) {
            var requests = (0, _assign2.default)({}, _this.state.requests);
            var request = requests[clientId];

            if (request) {
                request.abort();

                (0, _deleteProperty2.default)(requests, clientId);
                _this.setState({ requests: requests });
            }
        };

        _this.handleMaxUploadReached = function (e) {
            e.preventDefault();

            var onUploadError = _this.props.onUploadError;
            var formatMessage = _this.context.intl.formatMessage;


            onUploadError(formatMessage(holders.limited, { count: _constants2.default.MAX_UPLOAD_FILES }));
        };

        _this.state = {
            requests: {}
        };
        return _this;
    }

    (0, _createClass3.default)(FileUpload, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.postType === 'post') {
                this.registerDragEvents('.row.main', '.center-file-overlay');
            } else if (this.props.postType === 'comment') {
                this.registerDragEvents('.post-right__container', '.right-file-overlay');
            }

            document.addEventListener('paste', this.pasteUpload);
            document.addEventListener('keydown', this.keyUpload);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var target = void 0;
            if (this.props.postType === 'post') {
                target = (0, _jquery2.default)('.row.main');
            } else {
                target = (0, _jquery2.default)('.post-right__container');
            }

            document.removeEventListener('paste', this.pasteUpload);
            document.removeEventListener('keydown', this.keyUpload);

            // jquery-dragster doesn't provide a function to unregister itself so do it manually
            target.off('dragenter dragleave dragover drop dragster:enter dragster:leave dragster:over dragster:drop');
        }
    }, {
        key: 'render',
        value: function render() {
            var multiple = true;
            if ((0, _user_agent.isMobileApp)()) {
                // iOS WebViews don't upload videos properly in multiple mode
                multiple = false;
            }

            var accept = '';
            if ((0, _user_agent.isIosChrome)()) {
                // iOS Chrome can't upload videos at all
                accept = 'image/*';
            }

            var uploadsRemaining = _constants2.default.MAX_UPLOAD_FILES - this.props.fileCount;
            var onClick = uploadsRemaining > 0 ? this.props.onClick : this.handleMaxUploadReached;

            return _react2.default.createElement(
                'span',
                {
                    ref: 'input',
                    className: uploadsRemaining <= 0 ? ' btn-file__disabled' : ''
                },
                this.props.canUploadFiles && _react2.default.createElement(
                    'div',
                    {
                        id: 'fileUploadButton',
                        className: 'icon icon--attachment'
                    },
                    _react2.default.createElement(_attachment_icon2.default, null),
                    _react2.default.createElement('input', {
                        ref: 'fileInput',
                        type: 'file',
                        onChange: this.handleChange,
                        onClick: onClick,
                        multiple: multiple,
                        accept: accept
                    })
                )
            );
        }
    }]);
    return FileUpload;
}(_react.PureComponent);

FileUpload.propTypes = {

    /**
     * Current channel's ID
     */
    currentChannelId: _propTypes2.default.string.isRequired,

    /**
     * Number of files to attach
     */
    fileCount: _propTypes2.default.number.isRequired,

    /**
     * Function to get file upload targeted input
     */
    getTarget: _propTypes2.default.func.isRequired,

    /**
     * Function to be called when file upload input is clicked
     */
    onClick: _propTypes2.default.func,

    /**
     * Function to be called when file upload is complete
     */
    onFileUpload: _propTypes2.default.func,

    /**
     * Function to be called when file upload input's change event is fired
     */
    onFileUploadChange: _propTypes2.default.func,

    /**
     * Function to be called when upload fails
     */
    onUploadError: _propTypes2.default.func,

    /**
     * Function to be called when file upload starts
     */
    onUploadStart: _propTypes2.default.func,

    /**
     * Type of the object which the uploaded file is attached to
     */
    postType: _propTypes2.default.string,

    /**
     * Function to be called to upload file
     */
    uploadFile: _propTypes2.default.func.isRequired,

    /**
     * The maximum uploaded file size.
     */
    maxFileSize: _propTypes2.default.number,

    /**
     * Whether or not file upload is allowed.
     */
    canUploadFiles: _propTypes2.default.bool.isRequired
};
FileUpload.contextTypes = {
    intl: _reactIntl.intlShape
};
exports.default = FileUpload;

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {// 1.0.3
/*
The MIT License (MIT)

Copyright (c) 2015 Jan Martin

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
(function ($) {

    $.fn.dragster = function (options) {
        var settings = $.extend({
            enter: $.noop,
            leave: $.noop,
            over: $.noop,
            drop: $.noop
        }, options);

        return this.each(function () {
            var first = false,
                second = false,
                $this = $(this);

            $this.on({
                dragenter: function (event) {
                    if (first) {
                        second = true;
                        return;
                    } else {
                        first = true;
                        $this.trigger('dragster:enter', event);
                    }
                    event.preventDefault();
                },
                dragleave: function (event) {
                    if (second) {
                        second = false;
                    } else if (first) {
                        first = false;
                    }
                    if (!first && !second) {
                        $this.trigger('dragster:leave', event);
                    }
                    event.preventDefault();
                },
                dragover: function (event) {
                    $this.trigger('dragster:over', event);
                    event.preventDefault();
                },
                drop: function (event) {
                    if (second) {
                        second = false;
                    } else if (first) {
                        first = false;
                    }
                    if (!first && !second) {
                        $this.trigger('dragster:drop', event);
                    }
                    event.preventDefault();
                },
                'dragster:enter': settings.enter,
                'dragster:leave': settings.leave,
                'dragster:over': settings.over,
                'dragster:drop': settings.drop
            });
        });
    };

}(jQuery));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUsersTyping = exports.makeGetUsersTypingByChannelAndPost = undefined;

var _reselect = __webpack_require__(78);

var _common = __webpack_require__(280);

var _preferences = __webpack_require__(784);

var _user_utils = __webpack_require__(175);

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getUsersTypingImpl = function getUsersTypingImpl(profiles, teammateNameDisplay, channelId, parentPostId, typing) {
    var id = channelId + parentPostId;

    if (typing[id]) {
        var users = Object.keys(typing[id]);

        if (users.length) {
            return users.map(function (userId) {
                return (0, _user_utils.displayUsername)(profiles[userId], teammateNameDisplay);
            });
        }
    }

    return [];
};

var makeGetUsersTypingByChannelAndPost = exports.makeGetUsersTypingByChannelAndPost = function makeGetUsersTypingByChannelAndPost() {
    return (0, _reselect.createSelector)(_common.getUsers, _preferences.getTeammateNameDisplaySetting, function (state, options) {
        return options.channelId;
    }, function (state, options) {
        return options.postId;
    }, function (state) {
        return state.entities.typing;
    }, getUsersTypingImpl);
};

var getUsersTyping = exports.getUsersTyping = (0, _reselect.createSelector)(_common.getUsers, _preferences.getTeammateNameDisplaySetting, _common.getCurrentChannelId, function (state) {
    return state.entities.posts.selectedPostId;
}, function (state) {
    return state.entities.typing;
}, getUsersTypingImpl);

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MsgTyping = function (_React$Component) {
    (0, _inherits3.default)(MsgTyping, _React$Component);

    function MsgTyping() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MsgTyping);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MsgTyping.__proto__ || (0, _getPrototypeOf2.default)(MsgTyping)).call.apply(_ref, [this].concat(args))), _this), _this.getTypingText = function () {
            var users = [];
            var numUsers = 0;
            if (_this.props.typingUsers) {
                users = [].concat((0, _toConsumableArray3.default)(_this.props.typingUsers));
                numUsers = users.length;
            }

            if (numUsers === 0) {
                return '';
            }
            if (numUsers === 1) {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'msg_typing.isTyping',
                    defaultMessage: '{user} is typing...',
                    values: {
                        user: users[0]
                    }
                });
            }
            var last = users.pop();
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'msg_typing.areTyping',
                defaultMessage: '{users} and {last} are typing...',
                values: {
                    users: users.join(', '),
                    last: last
                }
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(MsgTyping, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                { className: 'msg-typing' },
                this.getTypingText()
            );
        }
    }]);
    return MsgTyping;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

MsgTyping.propTypes = {
    typingUsers: _propTypes2.default.array.isRequired,
    channelId: _propTypes2.default.string.isRequired,
    postId: _propTypes2.default.string
};
exports.default = MsgTyping;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(783);

var _teams = __webpack_require__(274);

var _general = __webpack_require__(113);

var _rhs_comment = __webpack_require__(2029);

var _rhs_comment2 = _interopRequireDefault(_rhs_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var config = (0, _general.getConfig)(state);
    var enableEmojiPicker = config.EnableEmojiPicker === 'true';
    var enablePostUsernameOverride = config.EnablePostUsernameOverride === 'true';
    var teamId = ownProps.teamId || (0, _teams.getCurrentTeamId)(state);

    return {
        enableEmojiPicker: enableEmojiPicker,
        enablePostUsernameOverride: enablePostUsernameOverride,
        isReadOnly: (0, _channels.isChannelReadOnlyById)(state, ownProps.post.channel_id),
        teamId: teamId,
        pluginPostTypes: state.plugins.postTypes
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_rhs_comment2.default);

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _index = __webpack_require__(19);

var _post_utils = __webpack_require__(281);

var _permissions = __webpack_require__(279);

var _permissions2 = _interopRequireDefault(_permissions);

var _post_actions = __webpack_require__(802);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _post_utils2 = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils2);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _dot_menu = __webpack_require__(970);

var _dot_menu2 = _interopRequireDefault(_dot_menu);

var _emoji_picker_overlay = __webpack_require__(883);

var _emoji_picker_overlay2 = _interopRequireDefault(_emoji_picker_overlay);

var _file_attachment_list = __webpack_require__(971);

var _file_attachment_list2 = _interopRequireDefault(_file_attachment_list);

var _failed_post_options = __webpack_require__(1327);

var _failed_post_options2 = _interopRequireDefault(_failed_post_options);

var _post_flag_icon = __webpack_require__(973);

var _post_flag_icon2 = _interopRequireDefault(_post_flag_icon);

var _post_time = __webpack_require__(975);

var _post_time2 = _interopRequireDefault(_post_time);

var _reaction_list = __webpack_require__(1044);

var _reaction_list2 = _interopRequireDefault(_reaction_list);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

var _emoji_icon = __webpack_require__(909);

var _emoji_icon2 = _interopRequireDefault(_emoji_icon);

var _mattermost_logo = __webpack_require__(976);

var _mattermost_logo2 = _interopRequireDefault(_mattermost_logo);

var _channel_permission_gate = __webpack_require__(888);

var _channel_permission_gate2 = _interopRequireDefault(_channel_permission_gate);

var _message_with_additional_content = __webpack_require__(1328);

var _message_with_additional_content2 = _interopRequireDefault(_message_with_additional_content);

var _user_profile = __webpack_require__(933);

var _user_profile2 = _interopRequireDefault(_user_profile);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var RhsComment = function (_React$Component) {
    (0, _inherits3.default)(RhsComment, _React$Component);

    function RhsComment(props) {
        (0, _classCallCheck3.default)(this, RhsComment);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RhsComment.__proto__ || (0, _getPrototypeOf2.default)(RhsComment)).call(this, props));

        _this.removePost = function () {
            _this.props.removePost(_this.props.post);
        };

        _this.createRemovePostButton = function () {
            return _react2.default.createElement(
                'button',
                {
                    className: 'post__remove theme color--link style--none',
                    type: 'button',
                    onClick: _this.removePost
                },
                '×'
            );
        };

        _this.renderPostTime = function (isEphemeral) {
            var post = _this.props.post;

            var isPermalink = !(isEphemeral || _index.Posts.POST_DELETED === post.state || (0, _post_utils.isPostPendingOrFailed)(post));

            return _react2.default.createElement(_post_time2.default, {
                isPermalink: isPermalink,
                eventTime: post.create_at,
                postId: post.id
            });
        };

        _this.toggleEmojiPicker = function () {
            var showEmojiPicker = !_this.state.showEmojiPicker;

            _this.setState({
                showEmojiPicker: showEmojiPicker,
                dropdownOpened: showEmojiPicker
            });
        };

        _this.reactEmojiClick = function (emoji) {
            _this.setState({ showEmojiPicker: false });
            var emojiName = emoji.name || emoji.aliases[0];
            (0, _post_actions.addReaction)(_this.props.post.channel_id, _this.props.post.id, emojiName);
            (0, _post_actions.emitEmojiPosted)(emojiName);
            _this.handleDropdownOpened(false);
        };

        _this.getClassName = function (post, isSystemMessage) {
            var className = 'post post--thread';

            if (_this.props.currentUser.id === post.user_id) {
                className += ' current--user';
            }

            if (isSystemMessage) {
                className += ' post--system';
            }

            if (_this.props.compactDisplay) {
                className += ' post--compact';
            }

            if (post.is_pinned) {
                className += ' post--pinned';
            }

            if (_this.state.dropdownOpened) {
                className += ' post--hovered';
            }

            return className;
        };

        _this.handleDropdownOpened = function (isOpened) {
            _this.setState({
                dropdownOpened: isOpened
            });
        };

        _this.getDotMenuRef = function () {
            return _this.refs.dotMenu;
        };

        _this.state = {
            currentTeamDisplayName: _team_store2.default.getCurrent().name,
            showEmojiPicker: false,
            dropdownOpened: false
        };
        return _this;
    }

    (0, _createClass3.default)(RhsComment, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (nextProps.status !== this.props.status) {
                return true;
            }

            if (nextProps.isBusy !== this.props.isBusy) {
                return true;
            }

            if (nextProps.compactDisplay !== this.props.compactDisplay) {
                return true;
            }

            if (nextProps.isFlagged !== this.props.isFlagged) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextProps.post, this.props.post)) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextProps.currentUser, this.props.currentUser)) {
                return true;
            }

            if (this.state.showEmojiPicker !== nextState.showEmojiPicker) {
                return true;
            }

            if (nextProps.lastPostCount !== this.props.lastPostCount) {
                return true;
            }

            if (this.state.dropdownOpened !== nextState.dropdownOpened) {
                return true;
            }

            if (nextProps.isEmbedVisible !== this.props.isEmbedVisible) {
                return true;
            }

            if (this.props.previewEnabled !== nextProps.previewEnabled) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextProps.user, this.props.user)) {
                return true;
            }

            if (this.state.width !== nextState.width || this.state.height !== nextState.height) {
                return true;
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                post = _props.post,
                isReadOnly = _props.isReadOnly;


            var idCount = -1;
            if (this.props.lastPostCount >= 0 && this.props.lastPostCount < _constants2.default.TEST_ID_COUNT) {
                idCount = this.props.lastPostCount;
            }

            var isEphemeral = (0, _post_utils.isPostEphemeral)(post);
            var isSystemMessage = PostUtils.isSystemMessage(post);

            var status = this.props.status;
            if (post.props && post.props.from_webhook === 'true') {
                status = null;
            }

            var botIndicator = void 0;
            var userProfile = _react2.default.createElement(_user_profile2.default, {
                user: this.props.user,
                status: status,
                isBusy: this.props.isBusy,
                isRHS: true,
                hasMention: true
            });

            var visibleMessage = void 0;
            if (post.props && post.props.from_webhook) {
                if (post.props.override_username && this.props.enablePostUsernameOverride) {
                    userProfile = _react2.default.createElement(_user_profile2.default, {
                        user: this.props.user,
                        overwriteName: post.props.override_username,
                        disablePopover: true
                    });
                } else {
                    userProfile = _react2.default.createElement(_user_profile2.default, {
                        user: this.props.user,
                        disablePopover: true
                    });
                }

                botIndicator = _react2.default.createElement(
                    'div',
                    { className: 'col col__name bot-indicator' },
                    'BOT'
                );
            } else if (isSystemMessage) {
                userProfile = _react2.default.createElement(_user_profile2.default, {
                    user: {},
                    overwriteName: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_info.system',
                        defaultMessage: 'System'
                    }),
                    overwriteImage: _constants2.default.SYSTEM_MESSAGE_PROFILE_IMAGE,
                    disablePopover: true
                });

                visibleMessage = _react2.default.createElement(
                    'span',
                    { className: 'post__visibility' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_info.message.visible',
                        defaultMessage: '(Only visible to you)'
                    })
                );
            }

            var failedPostOptions = void 0;
            var postClass = '';

            if (post.failed) {
                postClass += ' post-failed';
                failedPostOptions = _react2.default.createElement(_failed_post_options2.default, { post: this.props.post });
            }

            if (PostUtils.isEdited(this.props.post)) {
                postClass += ' post--edited';
            }

            var profilePic = _react2.default.createElement(_profile_picture2.default, {
                src: PostUtils.getProfilePicSrcForPost(post, this.props.user),
                status: status,
                width: '36',
                height: '36',
                user: this.props.user,
                isBusy: this.props.isBusy,
                isRHS: true,
                hasMention: true
            });

            if (post.props && post.props.from_webhook) {
                profilePic = _react2.default.createElement(_profile_picture2.default, {
                    src: PostUtils.getProfilePicSrcForPost(post, this.props.user),
                    width: '36',
                    height: '36'
                });
            } else if (isSystemMessage) {
                profilePic = _react2.default.createElement(_mattermost_logo2.default, { className: 'icon' });
            }

            if (this.props.compactDisplay) {
                if (post.props && post.props.from_webhook) {
                    profilePic = _react2.default.createElement(_profile_picture2.default, {
                        src: ''
                    });
                } else {
                    profilePic = _react2.default.createElement(_profile_picture2.default, {
                        src: '',
                        status: status,
                        user: this.props.user,
                        isBusy: this.props.isBusy,
                        isRHS: true,
                        hasMention: true
                    });
                }
            }

            var profilePicContainer = _react2.default.createElement(
                'div',
                { className: 'post__img' },
                profilePic
            );

            var fileAttachment = null;
            if (post.file_ids && post.file_ids.length > 0) {
                fileAttachment = _react2.default.createElement(_file_attachment_list2.default, {
                    post: post,
                    compactDisplay: this.props.compactDisplay
                });
            }

            var react = void 0;

            if (!isReadOnly && !isEphemeral && !post.failed && !isSystemMessage && this.props.enableEmojiPicker) {
                react = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_emoji_picker_overlay2.default, {
                        show: this.state.showEmojiPicker,
                        onHide: this.toggleEmojiPicker,
                        target: this.getDotMenuRef,
                        onEmojiClick: this.reactEmojiClick,
                        rightOffset: 15,
                        spaceRequiredAbove: 342,
                        spaceRequiredBelow: 342
                    }),
                    _react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: post.channel_id,
                            teamId: this.props.teamId,
                            permissions: [_permissions2.default.ADD_REACTION]
                        },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'reacticon__container reaction color--link style--none',
                                onClick: this.toggleEmojiPicker,
                                ref: 'rhs_reacticon_' + post.id
                            },
                            _react2.default.createElement(_emoji_icon2.default, { className: 'icon icon--emoji' })
                        )
                    )
                );
            }

            var options = void 0;
            if (isEphemeral) {
                options = _react2.default.createElement(
                    'div',
                    { className: 'col col__remove' },
                    this.createRemovePostButton()
                );
            } else if (!isSystemMessage) {
                var dotMenu = _react2.default.createElement(_dot_menu2.default, {
                    idPrefix: _constants2.default.RHS,
                    isRHS: true,
                    idCount: idCount,
                    post: this.props.post,
                    isFlagged: this.props.isFlagged,
                    handleDropdownOpened: this.handleDropdownOpened,
                    isReadOnly: isReadOnly
                });

                options = _react2.default.createElement(
                    'div',
                    {
                        ref: 'dotMenu',
                        className: 'col col__reply'
                    },
                    dotMenu,
                    react
                );
            }

            var pinnedBadge = void 0;
            if (post.is_pinned) {
                pinnedBadge = _react2.default.createElement(
                    'span',
                    { className: 'post__pinned-badge' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_info.pinned',
                        defaultMessage: 'Pinned'
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    ref: 'post_body_' + post.id,
                    className: this.getClassName(post, isSystemMessage)
                },
                _react2.default.createElement(
                    'div',
                    { className: 'post__content' },
                    profilePicContainer,
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'post__header' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col col__name' },
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    userProfile
                                )
                            ),
                            botIndicator,
                            _react2.default.createElement(
                                'div',
                                { className: 'col' },
                                this.renderPostTime(isEphemeral),
                                pinnedBadge,
                                _react2.default.createElement(_post_flag_icon2.default, {
                                    idPrefix: 'rhsCommentFlag',
                                    idCount: idCount,
                                    postId: post.id,
                                    isFlagged: this.props.isFlagged,
                                    isEphemeral: isEphemeral
                                }),
                                visibleMessage
                            ),
                            options
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'post__body' },
                            _react2.default.createElement(
                                'div',
                                { className: postClass },
                                failedPostOptions,
                                _react2.default.createElement(_message_with_additional_content2.default, {
                                    post: post,
                                    previewCollapsed: this.props.previewCollapsed,
                                    previewEnabled: this.props.previewEnabled,
                                    isEmbedVisible: this.props.isEmbedVisible,
                                    pluginPostTypes: this.props.pluginPostTypes
                                })
                            ),
                            fileAttachment,
                            _react2.default.createElement(_reaction_list2.default, {
                                post: post,
                                isReadOnly: isReadOnly
                            })
                        )
                    )
                )
            );
        }
    }]);
    return RhsComment;
}(_react2.default.Component);

RhsComment.propTypes = {
    post: _propTypes2.default.object,
    teamId: _propTypes2.default.string.isRequired,
    lastPostCount: _propTypes2.default.number,
    user: _propTypes2.default.object,
    currentUser: _propTypes2.default.object.isRequired,
    compactDisplay: _propTypes2.default.bool,
    isFlagged: _propTypes2.default.bool,
    status: _propTypes2.default.string,
    isBusy: _propTypes2.default.bool,
    removePost: _propTypes2.default.func.isRequired,
    previewCollapsed: _propTypes2.default.string.isRequired,
    previewEnabled: _propTypes2.default.bool.isRequired,
    isEmbedVisible: _propTypes2.default.bool,
    enableEmojiPicker: _propTypes2.default.bool.isRequired,
    enablePostUsernameOverride: _propTypes2.default.bool.isRequired,
    isReadOnly: _propTypes2.default.bool.isRequired,
    pluginPostTypes: _propTypes2.default.object
};
exports.default = RhsComment;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _delayed_action = __webpack_require__(931);

var _delayed_action2 = _interopRequireDefault(_delayed_action);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _dot_menu_edit = __webpack_require__(2031);

var _dot_menu_edit2 = _interopRequireDefault(_dot_menu_edit);

var _dot_menu_flag = __webpack_require__(2032);

var _dot_menu_flag2 = _interopRequireDefault(_dot_menu_flag);

var _dot_menu_item = __webpack_require__(2033);

var _dot_menu_item2 = _interopRequireDefault(_dot_menu_item);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DotMenu = function (_Component) {
    (0, _inherits3.default)(DotMenu, _Component);

    function DotMenu(props) {
        (0, _classCallCheck3.default)(this, DotMenu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DotMenu.__proto__ || (0, _getPrototypeOf2.default)(DotMenu)).call(this, props));

        _this.handleDropdownOpened = function () {
            _this.props.handleDropdownOpened(true);

            var position = (0, _jquery2.default)('#post-list').height() - (0, _jquery2.default)(_this.refs.dropdownToggle).offset().top;
            var dropdown = (0, _jquery2.default)(_this.refs.dropdown);

            if (position < dropdown.height()) {
                dropdown.addClass('bottom');
            }
        };

        _this.handleEditDisable = function () {
            _this.setState({ canEdit: false });
        };

        _this.editDisableAction = new _delayed_action2.default(_this.handleEditDisable);

        _this.state = {
            canDelete: PostUtils.canDeletePost(props.post),
            canEdit: PostUtils.canEditPost(props.post, _this.editDisableAction)
        };
        return _this;
    }

    (0, _createClass3.default)(DotMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            (0, _jquery2.default)('#' + this.props.idPrefix + '_dropdown' + this.props.post.id).on('shown.bs.dropdown', this.handleDropdownOpened);
            (0, _jquery2.default)('#' + this.props.idPrefix + '_dropdown' + this.props.post.id).on('hidden.bs.dropdown', function () {
                return _this2.props.handleDropdownOpened(false);
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.post !== this.props.post) {
                this.setState({
                    canDelete: PostUtils.canDeletePost(nextProps.post),
                    canEdit: PostUtils.canEditPost(nextProps.post, this.editDisableAction)
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.editDisableAction.cancel();
        }
    }, {
        key: 'render',
        value: function render() {
            var isSystemMessage = PostUtils.isSystemMessage(this.props.post);
            var isMobile = Utils.isMobile();

            if (this.props.idPrefix === _constants2.default.CENTER && !isMobile && isSystemMessage && !this.state.canDelete && !this.state.canEdit) {
                return null;
            }

            if (this.props.idPrefix === _constants2.default.RHS && (this.props.post.state === _constants2.default.POST_FAILED || this.props.post.state === _constants2.default.POST_LOADING)) {
                return null;
            }

            var type = 'Post';
            if (this.props.post.root_id && this.props.post.root_id.length > 0) {
                type = 'Comment';
            }

            var idPrefix = this.props.idPrefix + 'DotMenu';

            var dotMenuFlag = null;
            if (isMobile && !isSystemMessage) {
                dotMenuFlag = _react2.default.createElement(_dot_menu_flag2.default, {
                    idPrefix: idPrefix + 'Flag',
                    idCount: this.props.idCount,
                    postId: this.props.post.id,
                    isFlagged: this.props.isFlagged,
                    actions: {
                        flagPost: this.props.actions.flagPost,
                        unflagPost: this.props.actions.unflagPost
                    }
                });
            }

            var dotMenuReply = null;
            var dotMenuPermalink = null;
            var dotMenuPin = null;
            if (!isSystemMessage) {
                if (this.props.idPrefix === _constants2.default.CENTER) {
                    dotMenuReply = _react2.default.createElement(_dot_menu_item2.default, {
                        idPrefix: idPrefix + 'Reply',
                        idCount: this.props.idCount,
                        handleOnClick: this.props.handleCommentClick
                    });
                }

                dotMenuPermalink = _react2.default.createElement(_dot_menu_item2.default, {
                    idPrefix: idPrefix + 'Permalink',
                    idCount: this.props.idCount,
                    post: this.props.post
                });
                if (!this.props.isReadOnly) {
                    dotMenuPin = _react2.default.createElement(_dot_menu_item2.default, {
                        idPrefix: idPrefix + 'Pin',
                        idCount: this.props.idCount,
                        post: this.props.post,
                        actions: {
                            pinPost: this.props.actions.pinPost,
                            unpinPost: this.props.actions.unpinPost
                        }
                    });
                }
            }

            var dotMenuDelete = null;
            if (this.state.canDelete) {
                dotMenuDelete = _react2.default.createElement(_dot_menu_item2.default, {
                    idPrefix: idPrefix + 'Delete',
                    isRHS: this.props.isRHS,
                    idCount: this.props.idCount,
                    post: this.props.post,
                    commentCount: type === 'Post' ? this.props.commentCount : 0,
                    actions: {
                        openModal: this.props.actions.openModal
                    }
                });
            }

            var dotMenuEdit = null;
            if (this.state.canEdit) {
                dotMenuEdit = _react2.default.createElement(_dot_menu_edit2.default, {
                    idPrefix: idPrefix + 'Edit',
                    isRHS: this.props.isRHS,
                    idCount: this.props.idCount,
                    post: this.props.post,
                    type: type,
                    commentCount: type === 'Post' ? this.props.commentCount : 0,
                    actions: {
                        setEditingPost: this.props.actions.setEditingPost
                    }
                });
            }

            var dotMenuId = null;
            if (this.props.idCount > -1) {
                dotMenuId = Utils.createSafeId(idPrefix + this.props.idCount);
            }

            if (this.props.idPrefix === _constants2.default.RHS_ROOT) {
                dotMenuId = idPrefix;
            }

            return _react2.default.createElement(
                'div',
                {
                    id: dotMenuId,
                    className: 'dropdown',
                    ref: 'dotMenu'
                },
                _react2.default.createElement(
                    'div',
                    {
                        id: this.props.idPrefix + '_dropdown' + this.props.post.id
                    },
                    _react2.default.createElement('button', {
                        ref: 'dropdownToggle',
                        className: 'dropdown-toggle post__dropdown color--link style--none',
                        type: 'button',
                        'data-toggle': 'dropdown',
                        'aria-expanded': 'false'
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown-menu__content' },
                        _react2.default.createElement(
                            'ul',
                            {
                                ref: 'dropdown',
                                className: 'dropdown-menu',
                                role: 'menu'
                            },
                            dotMenuReply,
                            dotMenuFlag,
                            dotMenuPermalink,
                            dotMenuPin,
                            dotMenuDelete,
                            dotMenuEdit
                        )
                    )
                )
            );
        }
    }]);
    return DotMenu;
}(_react.Component);

DotMenu.propTypes = {
    idPrefix: _propTypes2.default.string.isRequired,
    idCount: _propTypes2.default.number,
    post: _propTypes2.default.object.isRequired,
    commentCount: _propTypes2.default.number,
    isFlagged: _propTypes2.default.bool,
    isRHS: _propTypes2.default.bool,
    handleCommentClick: _propTypes2.default.func,
    handleDropdownOpened: _propTypes2.default.func,
    isReadOnly: _propTypes2.default.bool,

    actions: _propTypes2.default.shape({

        /**
         * Function flag the post
         */
        flagPost: _propTypes2.default.func.isRequired,

        /**
         * Function to unflag the post
         */
        unflagPost: _propTypes2.default.func.isRequired,

        /**
         * Function to set the editing post
         */
        setEditingPost: _propTypes2.default.func.isRequired,

        /**
         * Function to pin the post
         */
        pinPost: _propTypes2.default.func.isRequired,

        /**
         * Function to unpin the post
         */
        unpinPost: _propTypes2.default.func.isRequired,

        /**
         * Function to open a modal
         */
        openModal: _propTypes2.default.func.isRequired
    }).isRequired
};
DotMenu.defaultProps = {
    idCount: -1,
    post: {},
    commentCount: 0,
    isFlagged: false,
    isRHS: false,
    isReadOnly: false
};
exports.default = DotMenu;

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DotMenuEdit;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DotMenuEdit(props) {
    var editId = null;
    if (props.idCount > -1) {
        editId = Utils.createSafeId(props.idPrefix + props.idCount);
    }

    if (props.idPrefix.indexOf(_constants2.default.RHS_ROOT) === 0) {
        editId = props.idPrefix;
    }

    function handleOnClick() {
        props.actions.setEditingPost(props.post.id, props.commentsCount, props.idPrefix.indexOf(_constants2.default.CENTER) === 0 ? 'post_textbox' : 'reply_textbox', props.idPrefix.indexOf(_constants2.default.CENTER) === 0 ? props.type : Utils.localizeMessage('rhs_comment.comment', 'Comment'), props.isRHS);
    }

    return _react2.default.createElement(
        'li',
        {
            id: Utils.createSafeId(editId),
            key: props.idPrefix,
            role: 'presentation'
        },
        _react2.default.createElement(
            'button',
            {
                className: 'style--none',
                onClick: handleOnClick
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'post_info.edit',
                defaultMessage: 'Edit'
            })
        )
    );
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

DotMenuEdit.propTypes = {
    idPrefix: _propTypes2.default.string.isRequired,
    isRHS: _propTypes2.default.bool,
    idCount: _propTypes2.default.number,
    post: _propTypes2.default.object,
    type: _propTypes2.default.string,
    commentsCount: _propTypes2.default.number,
    actions: _propTypes2.default.shape({

        /*
         * Function set the editing post
         */
        setEditingPost: _propTypes2.default.func.isRequired
    }).isRequired
};

DotMenuEdit.defaultProps = {
    idCount: -1
};

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DotMenuFlag;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatMessage(isFlagged) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: isFlagged ? 'rhs_root.mobile.unflag' : 'rhs_root.mobile.flag',
        defaultMessage: isFlagged ? 'Unflag' : 'Flag'
    });
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function DotMenuFlag(props) {
    function onFlagPost(e) {
        e.preventDefault();
        props.actions.flagPost(props.postId);
    }

    function onUnflagPost(e) {
        e.preventDefault();
        props.actions.unflagPost(props.postId);
    }

    var flagFunc = props.isFlagged ? onUnflagPost : onFlagPost;

    var flagId = null;
    if (props.idCount > -1) {
        flagId = Utils.createSafeId(props.idPrefix + props.idCount);
    }

    if (props.idPrefix.indexOf(_constants2.default.RHS_ROOT) === 0) {
        flagId = props.idPrefix;
    }

    return _react2.default.createElement(
        'li',
        {
            key: props.idPrefix,
            role: 'presentation'
        },
        _react2.default.createElement(
            'button',
            {
                id: flagId,
                className: 'style--none',
                onClick: flagFunc
            },
            formatMessage(props.isFlagged)
        )
    );
}

DotMenuFlag.propTypes = {
    idCount: _propTypes2.default.number,
    idPrefix: _propTypes2.default.string.isRequired,
    postId: _propTypes2.default.string.isRequired,
    isFlagged: _propTypes2.default.bool.isRequired,

    actions: _propTypes2.default.shape({

        /*
         * Function flag the post
         */
        flagPost: _propTypes2.default.func.isRequired,

        /*
         * Function to unflag the post
         */
        unflagPost: _propTypes2.default.func.isRequired

    }).isRequired
};

DotMenuFlag.defaultProps = {
    idCount: -1,
    postId: '',
    isFlagged: false
};

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DotMenuItem;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _global_actions = __webpack_require__(778);

var _delete_post_modal = __webpack_require__(1309);

var _delete_post_modal2 = _interopRequireDefault(_delete_post_modal);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DotMenuItem(props) {
    function handlePermalink(e) {
        e.preventDefault();
        (0, _global_actions.showGetPostLinkModal)(props.post);
    }

    function handleUnpinPost(e) {
        e.preventDefault();
        props.actions.unpinPost(props.post.id);
    }

    function handlePinPost(e) {
        e.preventDefault();
        props.actions.pinPost(props.post.id);
    }

    function handleDeletePost(e) {
        e.preventDefault();

        var deletePostModalData = {
            ModalId: _constants.ModalIdentifiers.DELETE_POST,
            dialogType: _delete_post_modal2.default,
            dialogProps: {
                post: props.post,
                commentCount: props.commentCount,
                isRHS: props.isRHS
            }
        };

        props.actions.openModal(deletePostModalData);
    }

    var attrib = {};
    attrib.idPrefix = props.idPrefix;
    attrib.class = '';

    switch (props.idPrefix.substring(props.idPrefix.indexOf('DotMenu') + 7)) {
        case 'Reply':
            attrib.class = 'link__reply theme';
            attrib.onClick = props.handleOnClick;
            attrib.formattedMessageId = 'post_info.reply';
            attrib.formattedDefaultMessage = 'Reply';
            break;
        case 'Permalink':
            attrib.onClick = handlePermalink;
            attrib.formattedMessageId = 'post_info.permalink';
            attrib.formattedDefaultMessage = 'Permalink';
            attrib.post = props.post;
            break;
        case 'Pin':
            attrib.onClick = props.post.is_pinned ? handleUnpinPost : handlePinPost;
            attrib.formattedMessageId = props.post.is_pinned ? 'post_info.unpin' : 'post_info.pin';
            attrib.formattedDefaultMessage = props.post.is_pinned ? 'Un-pin from channel' : 'Pin from channel';
            attrib.post = props.post;
            break;
        case 'Delete':
            attrib.onClick = handleDeletePost;
            attrib.formattedMessageId = 'post_info.del';
            attrib.formattedDefaultMessage = 'Delete';
            attrib.commentCount = props.commentCount;
            break;
        default:
    }

    var itemId = null;
    if (props.idCount > -1) {
        itemId = Utils.createSafeId(props.idPrefix + props.idCount);
    }

    if (attrib.idPrefix.indexOf(_constants.Constants.RHS_ROOT) === 0) {
        itemId = attrib.idPrefix;
    }

    return _react2.default.createElement(
        'li',
        {
            id: Utils.createSafeId(itemId),
            key: attrib.idPrefix,
            role: 'presentation'
        },
        _react2.default.createElement(
            'button',
            {
                className: 'style--none',
                role: 'menuitem',
                onClick: attrib.onClick
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: attrib.formattedMessageId,
                defaultMessage: attrib.formattedDefaultMessage
            })
        )
    );
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

DotMenuItem.propTypes = {
    idPrefix: _propTypes2.default.string.isRequired,
    idCount: _propTypes2.default.number,
    isRHS: _propTypes2.default.bool,
    post: _propTypes2.default.object,
    handleOnClick: _propTypes2.default.func,
    commentCount: _propTypes2.default.number,

    actions: _propTypes2.default.shape({

        /**
         * Function to pin the post
         */
        pinPost: _propTypes2.default.func,

        /**
         * Function to unpin the post
         */
        unpinPost: _propTypes2.default.func,

        /**
         * Function to open a modal
         */
        openModal: _propTypes2.default.func
    })
};

DotMenuItem.defaultProps = {
    idPrefix: '',
    idCount: -1
};

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var _file_attachment = __webpack_require__(2035);

var _file_attachment2 = _interopRequireDefault(_file_attachment);

var _single_image_view = __webpack_require__(2039);

var _single_image_view2 = _interopRequireDefault(_single_image_view);

var _view_image = __webpack_require__(1043);

var _view_image2 = _interopRequireDefault(_view_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileAttachmentList = function (_React$Component) {
    (0, _inherits3.default)(FileAttachmentList, _React$Component);

    function FileAttachmentList(props) {
        (0, _classCallCheck3.default)(this, FileAttachmentList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FileAttachmentList.__proto__ || (0, _getPrototypeOf2.default)(FileAttachmentList)).call(this, props));

        _this.hidePreviewModal = function () {
            _this.setState({ showPreviewModal: false });
        };

        _this.handleImageClick = _this.handleImageClick.bind(_this);

        _this.state = { showPreviewModal: false, startImgIndex: 0 };
        return _this;
    }

    (0, _createClass3.default)(FileAttachmentList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.post.file_ids || this.props.post.filenames) {
                this.props.actions.getMissingFilesForPost(this.props.post.id);
            }
        }
    }, {
        key: 'handleImageClick',
        value: function handleImageClick(indexClicked) {
            this.setState({ showPreviewModal: true, startImgIndex: indexClicked });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                fileInfos = _props.fileInfos,
                fileCount = _props.fileCount,
                compactDisplay = _props.compactDisplay;


            if (compactDisplay === false) {
                if (fileInfos && fileInfos.length === 1) {
                    var fileType = (0, _utils.getFileType)(fileInfos[0].extension);

                    if (fileType === _constants.FileTypes.IMAGE || fileType === _constants.FileTypes.SVG) {
                        return _react2.default.createElement(_single_image_view2.default, {
                            fileInfo: fileInfos[0]
                        });
                    }
                } else if (fileCount === 1) {
                    return _react2.default.createElement('div', { style: style.minHeightPlaceholder });
                }
            }

            var postFiles = [];
            var sortedFileInfos = [];

            if (fileInfos && fileInfos.length > 0) {
                sortedFileInfos = fileInfos.sort(function (a, b) {
                    return a.create_at - b.create_at;
                });
                for (var i = 0; i < Math.min(sortedFileInfos.length, _constants2.default.MAX_DISPLAY_FILES); i++) {
                    var fileInfo = sortedFileInfos[i];

                    postFiles.push(_react2.default.createElement(_file_attachment2.default, {
                        key: fileInfo.id,
                        fileInfo: sortedFileInfos[i],
                        index: i,
                        handleImageClick: this.handleImageClick,
                        compactDisplay: compactDisplay
                    }));
                }
            } else if (fileCount > 0) {
                for (var _i = 0; _i < Math.min(fileCount, _constants2.default.MAX_DISPLAY_FILES); _i++) {
                    // Add a placeholder to avoid pop-in once we get the file infos for this post
                    postFiles.push(_react2.default.createElement('div', {
                        key: 'fileCount-' + _i,
                        className: 'post-image__column post-image__column--placeholder'
                    }));
                }
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'post-image__columns clearfix' },
                    postFiles
                ),
                _react2.default.createElement(_view_image2.default, {
                    show: this.state.showPreviewModal,
                    onModalDismissed: this.hidePreviewModal,
                    startIndex: this.state.startImgIndex,
                    fileInfos: sortedFileInfos
                })
            );
        }
    }]);
    return FileAttachmentList;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

FileAttachmentList.propTypes = {

    /*
     * The post the files are attached to
     */
    post: _propTypes2.default.object.isRequired,

    /*
     * The number of files attached to the post
     */
    fileCount: _propTypes2.default.number.isRequired,

    /*
     * Array of metadata for each file attached to the post
     */
    fileInfos: _propTypes2.default.arrayOf(_propTypes2.default.object),

    /*
     * Set to render compactly
     */
    compactDisplay: _propTypes2.default.bool,

    actions: _propTypes2.default.shape({

        /*
         * Function to get file metadata for a post
         */
        getMissingFilesForPost: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = FileAttachmentList;


var style = {
    minHeightPlaceholder: { minHeight: '385px' }
};

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _file_utils = __webpack_require__(887);

var _file_attachment = __webpack_require__(2036);

var _file_attachment2 = _interopRequireDefault(_file_attachment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    return {
        canDownloadFiles: (0, _file_utils.canDownloadFiles)(config)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_file_attachment2.default);

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _file_utils = __webpack_require__(886);

var _constants = __webpack_require__(29);

var _file_utils2 = __webpack_require__(887);

var _utils = __webpack_require__(762);

var _download_icon = __webpack_require__(2037);

var _download_icon2 = _interopRequireDefault(_download_icon);

var _filename_overlay = __webpack_require__(1320);

var _filename_overlay2 = _interopRequireDefault(_filename_overlay);

var _file_thumbnail = __webpack_require__(2038);

var _file_thumbnail2 = _interopRequireDefault(_file_thumbnail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileAttachment = function (_React$PureComponent) {
    (0, _inherits3.default)(FileAttachment, _React$PureComponent);

    function FileAttachment(props) {
        (0, _classCallCheck3.default)(this, FileAttachment);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FileAttachment.__proto__ || (0, _getPrototypeOf2.default)(FileAttachment)).call(this, props));

        _this.loadFiles = function () {
            var fileInfo = _this.props.fileInfo;
            var fileType = (0, _utils.getFileType)(fileInfo.extension);

            if (fileType === _constants.FileTypes.IMAGE) {
                var thumbnailUrl = (0, _file_utils.getFileThumbnailUrl)(fileInfo.id);

                (0, _utils.loadImage)(thumbnailUrl, _this.handleImageLoaded);
            } else if (fileInfo.extension === _constants.FileTypes.SVG) {
                (0, _utils.loadImage)((0, _file_utils.getFileUrl)(fileInfo.id), _this.handleImageLoaded);
            }
        };

        _this.handleImageLoaded = function () {
            _this.setState({
                loaded: true
            });
        };

        _this.onAttachmentClick = function (e) {
            e.preventDefault();
            if (_this.props.handleImageClick) {
                _this.props.handleImageClick(_this.props.index);
            }
        };

        _this.state = {
            loaded: (0, _utils.getFileType)(props.fileInfo.extension) !== _constants.FileTypes.IMAGE
        };
        return _this;
    }

    (0, _createClass3.default)(FileAttachment, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadFiles();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.fileInfo.id !== this.props.fileInfo.id) {
                var extension = nextProps.fileInfo.extension;

                this.setState({
                    loaded: (0, _utils.getFileType)(extension) !== _constants.FileTypes.IMAGE && extension !== _constants.FileTypes.SVG
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!this.state.loaded && this.props.fileInfo.id !== prevProps.fileInfo.id) {
                this.loadFiles();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                compactDisplay = _props.compactDisplay,
                fileInfo = _props.fileInfo;


            var trimmedFilename = (0, _file_utils2.trimFilename)(fileInfo.name);
            var fileThumbnail = void 0;
            var fileDetail = void 0;
            if (!compactDisplay) {
                fileThumbnail = _react2.default.createElement(
                    'a',
                    {
                        className: 'post-image__thumbnail',
                        href: '#',
                        onClick: this.onAttachmentClick
                    },
                    this.state.loaded ? _react2.default.createElement(_file_thumbnail2.default, { fileInfo: fileInfo }) : _react2.default.createElement('div', { className: 'post-image__load' })
                );

                fileDetail = _react2.default.createElement(
                    'div',
                    {
                        className: 'post-image__detail_wrapper',
                        onClick: this.onAttachmentClick
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'post-image__detail' },
                        _react2.default.createElement(
                            'span',
                            { className: 'post-image__name' },
                            trimmedFilename
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'post-image__type' },
                            fileInfo.extension.toUpperCase()
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'post-image__size' },
                            (0, _utils.fileSizeToString)(fileInfo.size)
                        )
                    )
                );
            }

            var filenameOverlay = void 0;
            if (this.props.canDownloadFiles) {
                filenameOverlay = _react2.default.createElement(
                    _filename_overlay2.default,
                    {
                        fileInfo: fileInfo,
                        compactDisplay: compactDisplay,
                        canDownload: this.props.canDownloadFiles,
                        handleImageClick: this.onAttachmentClick,
                        iconClass: 'post-image__download'
                    },
                    _react2.default.createElement(_download_icon2.default, null)
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'post-image__column' },
                fileThumbnail,
                _react2.default.createElement(
                    'div',
                    { className: 'post-image__details' },
                    fileDetail,
                    filenameOverlay
                )
            );
        }
    }]);
    return FileAttachment;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

FileAttachment.propTypes = {

    /*
     * File detailed information
     */
    fileInfo: _propTypes2.default.object.isRequired,

    /*
     * The index of this attachment preview in the parent FileAttachmentList
     */
    index: _propTypes2.default.number.isRequired,

    /*
     * Handler for when the thumbnail is clicked passed the index above
     */
    handleImageClick: _propTypes2.default.func,

    /*
     * Display in compact format
     */
    compactDisplay: _propTypes2.default.bool,

    canDownloadFiles: _propTypes2.default.bool
};
exports.default = FileAttachment;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(DownloadIcon, _React$PureComponent);

    function DownloadIcon() {
        (0, _classCallCheck3.default)(this, DownloadIcon);
        return (0, _possibleConstructorReturn3.default)(this, (DownloadIcon.__proto__ || (0, _getPrototypeOf2.default)(DownloadIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(DownloadIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '40px',
                        height: '40px',
                        viewBox: '0 0 42 42'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'inherit',
                            strokeWidth: '1',
                            fill: 'none',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            { transform: 'translate(-986.000000, -1142.000000)' },
                            _react2.default.createElement(
                                'g',
                                { transform: 'translate(50.000000, 1034.000000)' },
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(539.000000, 54.000000)' },
                                    _react2.default.createElement(
                                        'g',
                                        { transform: 'translate(398.000000, 55.000000)' },
                                        _react2.default.createElement(
                                            'g',
                                            {
                                                transform: 'translate(11.000000, 11.000000)',
                                                fillRule: 'nonzero',
                                                fill: 'inherit'
                                            },
                                            _react2.default.createElement('path', { d: 'M8.7345,14.1405 C8.74725,14.1525 8.763,14.15775 8.7765,14.16825 C8.802,14.18775 8.82675,14.20875 8.85675,14.22075 C8.9025,14.24025 8.95125,14.25 9,14.25 C9.04875,14.25 9.0975,14.24025 9.14325,14.22075 C9.18975,14.20125 9.23175,14.17275 9.267,14.1375 L13.764,9.6405 C13.91025,9.49425 13.91025,9.2565 13.764,9.11025 C13.61775,8.964 13.38,8.964 13.23375,9.11025 L9.375,12.969 L9.375,0.375 C9.375,0.168 9.207,0 9,0 C8.793,0 8.625,0.168 8.625,0.375 L8.625,12.9705 L4.76475,9.11025 C4.6185,8.964 4.38075,8.964 4.2345,9.11025 C4.08825,9.2565 4.08825,9.49425 4.2345,9.6405 L8.7345,14.1405 Z M17.25,13.5 C17.043,13.5 16.875,13.668 16.875,13.875 L16.875,17.25 L1.125,17.25 L1.125,13.875 C1.125,13.668 0.957,13.5 0.75,13.5 C0.543,13.5 0.375,13.668 0.375,13.875 L0.375,17.625 C0.375,17.832 0.543,18 0.75,18 L17.25,18 C17.457,18 17.625,17.832 17.625,17.625 L17.625,13.875 C17.625,13.668 17.457,13.5 17.25,13.5 Z' })
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return DownloadIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = DownloadIcon;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _file_utils = __webpack_require__(886);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileThumbnail = function (_React$PureComponent) {
    (0, _inherits3.default)(FileThumbnail, _React$PureComponent);

    function FileThumbnail() {
        (0, _classCallCheck3.default)(this, FileThumbnail);
        return (0, _possibleConstructorReturn3.default)(this, (FileThumbnail.__proto__ || (0, _getPrototypeOf2.default)(FileThumbnail)).apply(this, arguments));
    }

    (0, _createClass3.default)(FileThumbnail, [{
        key: 'render',
        value: function render() {
            var fileInfo = this.props.fileInfo;

            var type = (0, _utils.getFileType)(fileInfo.extension);

            var thumbnail = void 0;
            if (type === _constants.FileTypes.IMAGE) {
                var className = 'post-image';

                if (fileInfo.width < _constants2.default.THUMBNAIL_WIDTH && fileInfo.height < _constants2.default.THUMBNAIL_HEIGHT) {
                    className += ' small';
                } else {
                    className += ' normal';
                }

                var thumbnailUrl = (0, _file_utils.getFileThumbnailUrl)(fileInfo.id);
                if ((0, _utils.isGIFImage)(fileInfo.extension) && !fileInfo.has_preview_image) {
                    thumbnailUrl = (0, _file_utils.getFileUrl)(fileInfo.id);
                }

                return _react2.default.createElement('div', {
                    className: className,
                    style: {
                        backgroundImage: 'url(' + thumbnailUrl + ')',
                        backgroundSize: 'cover'
                    }
                });
            } else if (fileInfo.extension === _constants.FileTypes.SVG) {
                thumbnail = _react2.default.createElement('img', {
                    className: 'post-image normal',
                    src: (0, _file_utils.getFileUrl)(fileInfo.id)
                });
            } else {
                thumbnail = _react2.default.createElement('div', { className: 'file-icon ' + (0, _utils.getIconClassName)(type) });
            }

            return thumbnail;
        }
    }]);
    return FileThumbnail;
}(_react2.default.PureComponent); // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

FileThumbnail.propTypes = {

    /*
     * File detailed information
     */
    fileInfo: _propTypes2.default.object.isRequired
};
exports.default = FileThumbnail;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _rhs = __webpack_require__(818);

var _single_image_view = __webpack_require__(2040);

var _single_image_view2 = _interopRequireDefault(_single_image_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var isRhsOpen = (0, _rhs.getIsRhsOpen)(state);

    return {
        isRhsOpen: isRhsOpen
    };
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_single_image_view2.default);

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _file_utils = __webpack_require__(886);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var _global_actions = __webpack_require__(778);

var _loading_image_preview = __webpack_require__(1326);

var _loading_image_preview2 = _interopRequireDefault(_loading_image_preview);

var _view_image = __webpack_require__(1043);

var _view_image2 = _interopRequireDefault(_view_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PREVIEW_IMAGE_MAX_WIDTH = 1024;
var PREVIEW_IMAGE_MAX_HEIGHT = 350;
var PREVIEW_IMAGE_MIN_DIMENSION = 50;

var SingleImageView = function (_React$PureComponent) {
    (0, _inherits3.default)(SingleImageView, _React$PureComponent);

    function SingleImageView(props) {
        (0, _classCallCheck3.default)(this, SingleImageView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SingleImageView.__proto__ || (0, _getPrototypeOf2.default)(SingleImageView)).call(this, props));

        _this.handleResize = function () {
            _this.setViewPortWidth();
        };

        _this.setViewPortRef = function (node) {
            _this.viewPort = node;
        };

        _this.setViewPortWidth = function () {
            if (_this.viewPort && _this.viewPort.getBoundingClientRect) {
                var rect = _this.viewPort.getBoundingClientRect();
                _this.setState({ viewPortWidth: rect.width });
            }
        };

        _this.loadImage = function (fileInfo) {
            var hasPreviewImage = fileInfo.has_preview_image,
                id = fileInfo.id;

            var fileURL = (0, _file_utils.getFileUrl)(id);
            var previewURL = hasPreviewImage ? (0, _file_utils.getFilePreviewUrl)(id) : fileURL;

            var loaderImage = new Image();
            loaderImage.src = previewURL;
            loaderImage.onload = function () {
                if (_this.imageLoaded) {
                    _this.imageLoaded.src = previewURL;
                }

                _this.setState({ loaded: true });
            };
        };

        _this.handleImageClick = function (e) {
            e.preventDefault();
            _this.setState({ showPreviewModal: true });
        };

        _this.showPreviewModal = function () {
            _this.setState({ showPreviewModal: false });
        };

        _this.setImageLoadedRef = function (node) {
            _this.imageLoaded = node;
        };

        _this.computeImageDimensions = function () {
            var fileInfo = _this.props.fileInfo;

            var viewPortWidth = _this.state.viewPortWidth;

            var previewWidth = fileInfo.width;
            var previewHeight = fileInfo.height;

            if (viewPortWidth && previewWidth > viewPortWidth) {
                var origRatio = fileInfo.height / fileInfo.width;
                previewWidth = Math.min(PREVIEW_IMAGE_MAX_WIDTH, fileInfo.width, viewPortWidth);
                previewHeight = previewWidth * origRatio;
            }

            if (previewHeight > PREVIEW_IMAGE_MAX_HEIGHT) {
                var heightRatio = PREVIEW_IMAGE_MAX_HEIGHT / previewHeight;
                previewHeight = PREVIEW_IMAGE_MAX_HEIGHT;
                previewWidth *= heightRatio;
            }

            return { previewWidth: previewWidth, previewHeight: previewHeight };
        };

        _this.state = {
            loaded: false,
            showPreviewModal: false,
            viewPortWidth: 0
        };

        _this.imageLoaded = null;
        return _this;
    }

    (0, _createClass3.default)(SingleImageView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.handleResize);
            this.setViewPortWidth();
            this.loadImage(this.props.fileInfo);

            // Timeout used to delay execution until after current render cycle
            setTimeout(_global_actions.postListScrollChange, 0);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            window.removeEventListener('resize', this.handleResize);
            this.loadImage(nextProps.fileInfo);

            if (nextProps.isRhsOpen !== this.props.isRhsOpen) {
                this.handleResize();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var fileInfo = this.props.fileInfo;
            var _state = this.state,
                loaded = _state.loaded,
                viewPortWidth = _state.viewPortWidth;

            var _computeImageDimensio = this.computeImageDimensions(),
                previewHeight = _computeImageDimensio.previewHeight,
                previewWidth = _computeImageDimensio.previewWidth;

            var minPreviewClass = '';
            if (previewWidth < PREVIEW_IMAGE_MIN_DIMENSION || previewHeight < PREVIEW_IMAGE_MIN_DIMENSION) {
                minPreviewClass = 'min-preview ';

                if (previewHeight > previewWidth) {
                    minPreviewClass += 'min-preview--portrait ';
                }
            }

            var fileHeader = _react2.default.createElement(
                'div',
                { className: 'file-details' },
                _react2.default.createElement(
                    'span',
                    {
                        className: 'file-details__name',
                        onClick: this.handleImageClick
                    },
                    fileInfo.name
                )
            );

            var fileType = (0, _utils.getFileType)(fileInfo.extension);
            var svgClass = '';
            if (fileType === _constants.FileTypes.SVG) {
                svgClass = 'post-image normal';
            }

            var loading = (0, _utils.localizeMessage)('view_image.loading', 'Loading');

            var viewImageModal = void 0;
            var loadingImagePreview = void 0;
            var fadeInClass = '';

            var height = previewHeight;
            if (height < PREVIEW_IMAGE_MIN_DIMENSION) {
                height = PREVIEW_IMAGE_MIN_DIMENSION;
            }

            var width = previewWidth;
            if (width < PREVIEW_IMAGE_MIN_DIMENSION) {
                width = PREVIEW_IMAGE_MIN_DIMENSION;
            }

            var imageStyle = { height: height };
            var imageLoadedStyle = { height: height };
            var imageContainerStyle = {};
            if (width < viewPortWidth && height === PREVIEW_IMAGE_MAX_HEIGHT) {
                imageContainerStyle = { width: width };
            }

            if (loaded) {
                viewImageModal = _react2.default.createElement(_view_image2.default, {
                    show: this.state.showPreviewModal,
                    onModalDismissed: this.showPreviewModal,
                    fileInfos: [fileInfo]
                });

                fadeInClass = 'image-fade-in';
                imageStyle = { cursor: 'pointer' };
                imageLoadedStyle = {};
            } else {
                loadingImagePreview = _react2.default.createElement(_loading_image_preview2.default, {
                    loading: loading,
                    containerClass: 'file__image-loading'
                });
            }

            return _react2.default.createElement(
                'div',
                {
                    ref: 'singleImageView',
                    className: 'file-view--single'
                },
                _react2.default.createElement(
                    'div',
                    {
                        ref: this.setViewPortRef,
                        className: 'file__image'
                    },
                    fileHeader,
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'image-container',
                            style: imageContainerStyle
                        },
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'image-loaded ' + fadeInClass,
                                style: imageLoadedStyle
                            },
                            _react2.default.createElement('img', {
                                ref: this.setImageLoadedRef,
                                style: imageStyle,
                                className: minPreviewClass + ' ' + svgClass,
                                onClick: this.handleImageClick
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'image-preload' },
                            loadingImagePreview
                        )
                    ),
                    viewImageModal
                )
            );
        }
    }]);
    return SingleImageView;
}(_react2.default.PureComponent);

SingleImageView.propTypes = {

    /**
     * FileInfo to view
     **/
    fileInfo: _propTypes2.default.object.isRequired,
    isRhsOpen: _propTypes2.default.bool.isRequired
};
SingleImageView.defaultProps = {
    fileInfo: {}
};
exports.default = SingleImageView;

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(44);

var _extends5 = _interopRequireDefault(_extends4);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _file_utils = __webpack_require__(886);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _audio_video_preview = __webpack_require__(2042);

var _audio_video_preview2 = _interopRequireDefault(_audio_video_preview);

var _code_preview = __webpack_require__(2044);

var _code_preview2 = _interopRequireDefault(_code_preview);

var _file_info_preview = __webpack_require__(972);

var _file_info_preview2 = _interopRequireDefault(_file_info_preview);

var _loading_image_preview = __webpack_require__(1326);

var _loading_image_preview2 = _interopRequireDefault(_loading_image_preview);

var _async_load = __webpack_require__(282);

var _pdf_preview = __webpack_require__(2045);

var _pdf_preview2 = _interopRequireDefault(_pdf_preview);

var _image_preview = __webpack_require__(2047);

var _image_preview2 = _interopRequireDefault(_image_preview);

var _popover_bar = __webpack_require__(2048);

var _popover_bar2 = _interopRequireDefault(_popover_bar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyCodes = _constants2.default.KeyCodes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ViewImageModal = function (_React$PureComponent) {
    (0, _inherits3.default)(ViewImageModal, _React$PureComponent);

    function ViewImageModal(props) {
        (0, _classCallCheck3.default)(this, ViewImageModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ViewImageModal.__proto__ || (0, _getPrototypeOf2.default)(ViewImageModal)).call(this, props));

        _this.handleNext = function (e) {
            if (e) {
                e.stopPropagation();
            }
            var id = _this.state.imageIndex + 1;
            if (id > _this.props.fileInfos.length - 1) {
                id = 0;
            }
            _this.showImage(id);
        };

        _this.handlePrev = function (e) {
            if (e) {
                e.stopPropagation();
            }
            var id = _this.state.imageIndex - 1;
            if (id < 0) {
                id = _this.props.fileInfos.length - 1;
            }
            _this.showImage(id);
        };

        _this.handleKeyPress = function (e) {
            if (Utils.isKeyPressed(e, KeyCodes.RIGHT)) {
                _this.handleNext();
            } else if (Utils.isKeyPressed(e, KeyCodes.LEFT)) {
                _this.handlePrev();
            }
        };

        _this.onModalShown = function (nextProps) {
            document.addEventListener('keyup', _this.handleKeyPress);

            _this.showImage(nextProps.startIndex);
        };

        _this.onModalHidden = function () {
            document.addEventListener('keyup', _this.handleKeyPress);

            if (_this.refs.video) {
                _this.refs.video.stop();
            }
        };

        _this.showImage = function (id) {
            _this.setState({ imageIndex: id });

            var imageHeight = window.innerHeight - 100;
            _this.setState({ imageHeight: imageHeight });

            if (!_this.state.loaded[id]) {
                _this.loadImage(id);
            }
        };

        _this.loadImage = function (index) {
            var fileInfo = _this.props.fileInfos[index];
            var fileType = Utils.getFileType(fileInfo.extension);

            if (fileType === _constants.FileTypes.IMAGE) {
                var previewUrl = void 0;
                if (fileInfo.has_image_preview) {
                    previewUrl = (0, _file_utils.getFilePreviewUrl)(fileInfo.id);
                } else {
                    // some images (eg animated gifs) just show the file itself and not a preview
                    previewUrl = (0, _file_utils.getFileUrl)(fileInfo.id);
                }

                Utils.loadImage(previewUrl, function () {
                    return _this.handleImageLoaded(index);
                }, function (completedPercentage) {
                    return _this.handleImageProgress(index, completedPercentage);
                });
            } else {
                // there's nothing to load for non-image files
                _this.handleImageLoaded(index);
            }
        };

        _this.handleImageLoaded = function (index) {
            _this.setState(function (prevState) {
                return {
                    loaded: (0, _extends5.default)({}, prevState.loaded, (0, _defineProperty3.default)({}, index, true))
                };
            });
        };

        _this.handleImageProgress = function (index, completedPercentage) {
            _this.setState(function (prevState) {
                return {
                    progress: (0, _extends5.default)({}, prevState.progress, (0, _defineProperty3.default)({}, index, completedPercentage))
                };
            });
        };

        _this.handleGetPublicLink = function () {
            _this.props.onModalDismissed();

            GlobalActions.showGetPublicLinkModal(_this.props.fileInfos[_this.state.imageIndex].id);
        };

        _this.onMouseEnterImage = function () {
            _this.setState({ showFooter: true });
        };

        _this.onMouseLeaveImage = function () {
            _this.setState({ showFooter: false });
        };

        _this.state = {
            imageIndex: _this.props.startIndex,
            imageHeight: '100%',
            loaded: Utils.fillArray(false, _this.props.fileInfos.length),
            progress: Utils.fillArray(0, _this.props.fileInfos.length),
            showFooter: false
        };
        return _this;
    }

    (0, _createClass3.default)(ViewImageModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.show === true && this.props.show === false) {
                this.onModalShown(nextProps);
            } else if (nextProps.show === false && this.props.show === true) {
                this.onModalHidden();
            }

            if (this.props.fileInfos.length !== nextProps.fileInfos.length) {
                this.setState({
                    loaded: Utils.fillArray(false, nextProps.fileInfos.length),
                    progress: Utils.fillArray(0, nextProps.fileInfos.length)
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.fileInfos.length < 1 || this.props.fileInfos.length - 1 < this.state.imageIndex) {
                return null;
            }

            var fileInfo = this.props.fileInfos[this.state.imageIndex];
            var showPublicLink = !fileInfo.link;
            var fileName = fileInfo.link || fileInfo.name;
            var fileUrl = fileInfo.link || (0, _file_utils.getFileUrl)(fileInfo.id);
            var fileDownloadUrl = fileInfo.link || (0, _file_utils.getFileDownloadUrl)(fileInfo.id);

            var content = void 0;
            if (this.state.loaded[this.state.imageIndex]) {
                var fileType = Utils.getFileType(fileInfo.extension);

                if (fileType === _constants.FileTypes.IMAGE || fileType === _constants.FileTypes.SVG) {
                    content = _react2.default.createElement(_image_preview2.default, {
                        fileInfo: fileInfo,
                        canDownloadFiles: this.props.canDownloadFiles
                    });
                } else if (fileType === _constants.FileTypes.VIDEO || fileType === _constants.FileTypes.AUDIO) {
                    content = _react2.default.createElement(_audio_video_preview2.default, {
                        fileInfo: fileInfo,
                        fileUrl: fileUrl
                    });
                } else if (fileInfo && fileInfo.extension && fileInfo.extension === _constants.FileTypes.PDF) {
                    content = _react2.default.createElement(_async_load.AsyncComponent, {
                        doLoad: _pdf_preview2.default,
                        fileInfo: fileInfo,
                        fileUrl: fileUrl
                    });
                } else if (_code_preview2.default.supports(fileInfo)) {
                    content = _react2.default.createElement(_code_preview2.default, {
                        fileInfo: fileInfo,
                        fileUrl: fileUrl
                    });
                } else {
                    content = _react2.default.createElement(_file_info_preview2.default, {
                        fileInfo: fileInfo,
                        fileUrl: fileUrl
                    });
                }
            } else {
                // display a progress indicator when the preview for an image is still loading
                var loading = Utils.localizeMessage('view_image.loading', 'Loading');
                var progress = Math.floor(this.state.progress[this.state.imageIndex]);

                content = _react2.default.createElement(_loading_image_preview2.default, {
                    loading: loading,
                    progress: progress
                });
            }

            var leftArrow = null;
            var rightArrow = null;
            if (this.props.fileInfos.length > 1) {
                leftArrow = _react2.default.createElement(
                    'a',
                    {
                        id: 'previewArrowLeft',
                        ref: 'previewArrowLeft',
                        className: 'modal-prev-bar',
                        href: '#',
                        onClick: this.handlePrev
                    },
                    _react2.default.createElement('i', { className: 'image-control image-prev' })
                );

                rightArrow = _react2.default.createElement(
                    'a',
                    {
                        id: 'previewArrowRight',
                        ref: 'previewArrowRight',
                        className: 'modal-next-bar',
                        href: '#',
                        onClick: this.handleNext
                    },
                    _react2.default.createElement('i', { className: 'image-control image-next' })
                );
            }

            var closeButtonClass = 'modal-close';
            if (this.state.showFooter) {
                closeButtonClass += ' modal-close--show';
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.props.show,
                    onHide: this.props.onModalDismissed,
                    className: 'modal-image',
                    dialogClassName: 'modal-image'
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    {
                        modalClassName: 'modal-image__body',
                        onClick: this.props.onModalDismissed
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'modal-image__wrapper',
                            onClick: this.props.onModalDismissed
                        },
                        _react2.default.createElement(
                            'div',
                            {
                                onMouseEnter: this.onMouseEnterImage,
                                onMouseLeave: this.onMouseLeaveImage,
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                }
                            },
                            _react2.default.createElement('div', {
                                className: closeButtonClass,
                                onClick: this.props.onModalDismissed
                            }),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-image__content' },
                                content
                            ),
                            _react2.default.createElement(_popover_bar2.default, {
                                show: this.state.showFooter,
                                showPublicLink: showPublicLink,
                                fileIndex: this.state.imageIndex,
                                totalFiles: this.props.fileInfos.length,
                                filename: fileName,
                                fileURL: fileDownloadUrl,
                                enablePublicLink: this.props.enablePublicLink,
                                canDownloadFiles: this.props.canDownloadFiles,
                                onGetPublicLink: this.handleGetPublicLink
                            })
                        )
                    ),
                    leftArrow,
                    rightArrow
                )
            );
        }
    }]);
    return ViewImageModal;
}(_react2.default.PureComponent);

ViewImageModal.propTypes = {

    /**
     * Set whether to show this modal or not
     */
    show: _propTypes2.default.bool.isRequired,

    /**
     * Function to call when this modal is dismissed
     **/
    onModalDismissed: _propTypes2.default.func.isRequired,

    /**
     * List of FileInfo to view
     **/
    fileInfos: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,

    /**
     * The index number of starting image
     **/
    startIndex: _propTypes2.default.number.isRequired,

    canDownloadFiles: _propTypes2.default.bool.isRequired,
    enablePublicLink: _propTypes2.default.bool.isRequired
};
ViewImageModal.defaultProps = {
    show: false,
    fileInfos: [],
    startIndex: 0
};
exports.default = ViewImageModal;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _file_info_preview = __webpack_require__(972);

var _file_info_preview2 = _interopRequireDefault(_file_info_preview);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudioVideoPreview = function (_React$PureComponent) {
    (0, _inherits3.default)(AudioVideoPreview, _React$PureComponent);

    function AudioVideoPreview(props) {
        (0, _classCallCheck3.default)(this, AudioVideoPreview);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AudioVideoPreview.__proto__ || (0, _getPrototypeOf2.default)(AudioVideoPreview)).call(this, props));

        _this.handleFileInfoChanged = _this.handleFileInfoChanged.bind(_this);
        _this.handleLoadError = _this.handleLoadError.bind(_this);

        _this.stop = _this.stop.bind(_this);

        _this.state = {
            canPlay: true
        };
        return _this;
    }

    (0, _createClass3.default)(AudioVideoPreview, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.handleFileInfoChanged(this.props.fileInfo);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.refs.source) {
                (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.source)).one('error', this.handleLoadError);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.fileUrl !== nextProps.fileUrl) {
                this.handleFileInfoChanged(nextProps.fileInfo);
            }
        }
    }, {
        key: 'handleFileInfoChanged',
        value: function handleFileInfoChanged(fileInfo) {
            var video = _reactDom2.default.findDOMNode(this.refs.video);
            if (!video) {
                video = document.createElement('video');
            }

            var canPlayType = video.canPlayType(fileInfo.mime_type);

            this.setState({
                canPlay: canPlayType === 'probably' || canPlayType === 'maybe'
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.refs.source) {
                (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.source)).one('error', this.handleLoadError);
            }
        }
    }, {
        key: 'handleLoadError',
        value: function handleLoadError() {
            this.setState({
                canPlay: false
            });
        }
    }, {
        key: 'stop',
        value: function stop() {
            if (this.refs.video) {
                var video = _reactDom2.default.findDOMNode(this.refs.video);
                video.pause();
                video.currentTime = 0;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.canPlay) {
                return _react2.default.createElement(_file_info_preview2.default, {
                    fileInfo: this.props.fileInfo,
                    fileUrl: this.props.fileUrl
                });
            }

            var width = _constants2.default.WEB_VIDEO_WIDTH;
            var height = _constants2.default.WEB_VIDEO_HEIGHT;
            if (Utils.isMobile()) {
                width = _constants2.default.MOBILE_VIDEO_WIDTH;
                height = _constants2.default.MOBILE_VIDEO_HEIGHT;
            }

            // add a key to the video to prevent React from using an old video source while a new one is loading
            return _react2.default.createElement(
                'video',
                {
                    key: this.props.fileInfo.id,
                    ref: 'video',
                    'data-setup': '{}',
                    controls: 'controls',
                    width: width,
                    height: height
                },
                _react2.default.createElement('source', {
                    ref: 'source',
                    src: this.props.fileUrl
                })
            );
        }
    }]);
    return AudioVideoPreview;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

AudioVideoPreview.propTypes = {

    /**
    * Compare file types
    */
    fileInfo: _propTypes2.default.object.isRequired,

    /**
    *  URL of pdf file to output and compare to update props url
    */
    fileUrl: _propTypes2.default.string.isRequired
};
exports.default = AudioVideoPreview;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileInfoPreview = function (_React$PureComponent) {
    (0, _inherits3.default)(FileInfoPreview, _React$PureComponent);

    function FileInfoPreview() {
        (0, _classCallCheck3.default)(this, FileInfoPreview);
        return (0, _possibleConstructorReturn3.default)(this, (FileInfoPreview.__proto__ || (0, _getPrototypeOf2.default)(FileInfoPreview)).apply(this, arguments));
    }

    (0, _createClass3.default)(FileInfoPreview, [{
        key: 'render',
        value: function render() {
            var fileInfo = this.props.fileInfo;
            var fileUrl = this.props.fileUrl;

            // non-image files include a section providing details about the file
            var infoParts = [];

            if (fileInfo.extension !== '') {
                infoParts.push(Utils.localizeMessage('file_info_preview.type', 'File type ') + fileInfo.extension.toUpperCase());
            }

            infoParts.push(Utils.localizeMessage('file_info_preview.size', 'Size ') + Utils.fileSizeToString(fileInfo.size));

            var infoString = infoParts.join(', ');

            var preview = null;
            if (this.props.canDownloadFiles) {
                preview = _react2.default.createElement(
                    'a',
                    {
                        className: 'file-details__preview',
                        href: fileUrl,
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    },
                    _react2.default.createElement('span', { className: 'file-details__preview-helper' }),
                    _react2.default.createElement('img', { src: Utils.getFileIconPath(fileInfo) })
                );
            } else {
                preview = _react2.default.createElement(
                    'span',
                    { className: 'file-details__preview' },
                    _react2.default.createElement('span', { className: 'file-details__preview-helper' }),
                    _react2.default.createElement('img', { src: Utils.getFileIconPath(fileInfo) })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'file-details__container' },
                preview,
                _react2.default.createElement(
                    'div',
                    { className: 'file-details' },
                    _react2.default.createElement(
                        'div',
                        { className: 'file-details__name' },
                        fileInfo.name
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'file-details__info' },
                        infoString
                    )
                )
            );
        }
    }]);
    return FileInfoPreview;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

FileInfoPreview.propTypes = {
    fileInfo: _propTypes2.default.object.isRequired,
    fileUrl: _propTypes2.default.string.isRequired,
    canDownloadFiles: _propTypes2.default.bool.isRequired
};
exports.default = FileInfoPreview;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _syntax_highlighting = __webpack_require__(1161);

var SyntaxHighlighting = _interopRequireWildcard(_syntax_highlighting);

var _load = __webpack_require__(865);

var _load2 = _interopRequireDefault(_load);

var _file_info_preview = __webpack_require__(972);

var _file_info_preview2 = _interopRequireDefault(_file_info_preview);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CodePreview = function (_React$Component) {
    (0, _inherits3.default)(CodePreview, _React$Component);

    function CodePreview(props) {
        (0, _classCallCheck3.default)(this, CodePreview);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CodePreview.__proto__ || (0, _getPrototypeOf2.default)(CodePreview)).call(this, props));

        _this.updateStateFromProps = _this.updateStateFromProps.bind(_this);
        _this.handleReceivedError = _this.handleReceivedError.bind(_this);
        _this.handleReceivedCode = _this.handleReceivedCode.bind(_this);

        _this.state = {
            code: '',
            lang: '',
            loading: true,
            success: true
        };
        return _this;
    }

    (0, _createClass3.default)(CodePreview, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateStateFromProps(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.fileUrl !== nextProps.fileUrl) {
                this.updateStateFromProps(nextProps);
            }
        }
    }, {
        key: 'updateStateFromProps',
        value: function updateStateFromProps(props) {
            var usedLanguage = SyntaxHighlighting.getLanguageFromFileExtension(props.fileInfo.extension);

            if (!usedLanguage || props.fileInfo.size > _constants2.default.CODE_PREVIEW_MAX_FILE_SIZE) {
                this.setState({ code: '', lang: '', loading: false, success: false });
                return;
            }

            this.setState({ code: '', lang: usedLanguage, loading: true });

            _jquery2.default.ajax({
                async: true,
                url: props.fileUrl,
                type: 'GET',
                dataType: 'text',
                error: this.handleReceivedError,
                success: this.handleReceivedCode
            });
        }
    }, {
        key: 'handleReceivedCode',
        value: function handleReceivedCode(data) {
            var code = data;
            if (data.nodeName === '#document') {
                code = new XMLSerializer().serializeToString(data);
            }
            this.setState({
                code: code,
                loading: false,
                success: true
            });
        }
    }, {
        key: 'handleReceivedError',
        value: function handleReceivedError() {
            this.setState({ loading: false, success: false });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.loading) {
                return _react2.default.createElement(
                    'div',
                    { className: 'view-image__loading' },
                    _react2.default.createElement('img', {
                        className: 'loader-image',
                        src: _load2.default
                    })
                );
            }

            if (!this.state.success) {
                return _react2.default.createElement(_file_info_preview2.default, {
                    fileInfo: this.props.fileInfo,
                    fileUrl: this.props.fileUrl
                });
            }

            // add line numbers when viewing a code file preview
            var lines = this.state.code.match(/\r\n|\r|\n|$/g).length;
            var strlines = '';
            for (var i = 1; i <= lines; i++) {
                if (strlines) {
                    strlines += '\n' + i;
                } else {
                    strlines += i;
                }
            }

            var language = SyntaxHighlighting.getLanguageName(this.state.lang);

            var highlighted = SyntaxHighlighting.highlight(this.state.lang, this.state.code);

            return _react2.default.createElement(
                'div',
                { className: 'post-code' },
                _react2.default.createElement(
                    'span',
                    { className: 'post-code__language' },
                    this.props.fileInfo.name + ' - ' + language
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'post-code__container' },
                    _react2.default.createElement(
                        'code',
                        { className: 'hljs' },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'post-code__lineno' },
                                        strlines
                                    ),
                                    _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: highlighted } })
                                )
                            )
                        )
                    )
                )
            );
        }
    }], [{
        key: 'supports',
        value: function supports(fileInfo) {
            return Boolean(SyntaxHighlighting.getLanguageFromFileExtension(fileInfo.extension));
        }
    }]);
    return CodePreview;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = CodePreview;


CodePreview.propTypes = {
    fileInfo: _propTypes2.default.object.isRequired,
    fileUrl: _propTypes2.default.string.isRequired
};

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(24).then((function(require) {
		cb(__webpack_require__(2046));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2046 */,
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ImagePreview;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _file_utils = __webpack_require__(886);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ImagePreview(_ref) {
    var fileInfo = _ref.fileInfo,
        canDownloadFiles = _ref.canDownloadFiles;
    var hasPreviewImage = fileInfo.has_preview_image,
        id = fileInfo.id,
        link = fileInfo.link;

    var fileUrl = link || (0, _file_utils.getFileDownloadUrl)(id);
    var previewUrl = hasPreviewImage ? (0, _file_utils.getFilePreviewUrl)(id) : fileUrl;

    if (!canDownloadFiles) {
        return _react2.default.createElement('img', { src: previewUrl });
    }

    return _react2.default.createElement(
        'a',
        {
            href: fileUrl,
            target: '_blank',
            rel: 'noopener noreferrer',
            download: true
        },
        _react2.default.createElement('img', { src: previewUrl })
    );
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ImagePreview.propTypes = {
    fileInfo: _propTypes2.default.object.isRequired,
    canDownloadFiles: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopoverBar = function (_React$PureComponent) {
    (0, _inherits3.default)(PopoverBar, _React$PureComponent);

    function PopoverBar() {
        (0, _classCallCheck3.default)(this, PopoverBar);
        return (0, _possibleConstructorReturn3.default)(this, (PopoverBar.__proto__ || (0, _getPrototypeOf2.default)(PopoverBar)).apply(this, arguments));
    }

    (0, _createClass3.default)(PopoverBar, [{
        key: 'render',
        value: function render() {
            var publicLink = '';
            if (this.props.enablePublicLink && this.props.showPublicLink) {
                publicLink = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            className: 'public-link text',
                            'data-title': 'Public Image',
                            onClick: this.props.onGetPublicLink
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'view_image_popover.publicLink',
                            defaultMessage: 'Get Public Link'
                        })
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'text' },
                        ' | '
                    )
                );
            }

            var footerClass = 'modal-button-bar';
            if (this.props.show) {
                footerClass += ' footer--show';
            }

            var downloadLinks = null;
            if (this.props.canDownloadFiles) {
                downloadLinks = _react2.default.createElement(
                    'div',
                    { className: 'image-links' },
                    publicLink,
                    _react2.default.createElement(
                        'a',
                        {
                            href: this.props.fileURL,
                            download: this.props.filename,
                            className: 'text',
                            target: '_blank',
                            rel: 'noopener noreferrer'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'view_image_popover.download',
                            defaultMessage: 'Download'
                        })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    ref: 'imageFooter',
                    className: footerClass
                },
                _react2.default.createElement(
                    'span',
                    { className: 'pull-left text' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'view_image_popover.file',
                        defaultMessage: 'File {count, number} of {total, number}',
                        values: {
                            count: this.props.fileIndex + 1,
                            total: this.props.totalFiles
                        }
                    })
                ),
                downloadLinks
            );
        }
    }]);
    return PopoverBar;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PopoverBar.propTypes = {

    /**
     * Set whether to show this component or not
     */
    show: _propTypes2.default.bool.isRequired,

    /**
     * The index number of the current file.
     */
    fileIndex: _propTypes2.default.number.isRequired,

    /**
     * The count of total files.
     */
    totalFiles: _propTypes2.default.number.isRequired,

    /**
     * The name of current file.
     */
    filename: _propTypes2.default.string.isRequired,

    /**
     * The API route to get current file.
     */
    fileURL: _propTypes2.default.string.isRequired,

    /**
     * Set whether to show "Get Public Link"
     */
    showPublicLink: _propTypes2.default.bool,

    /**
     * Set whether public links are enabled.
     */
    enablePublicLink: _propTypes2.default.bool.isRequired,

    canDownloadFiles: _propTypes2.default.bool.isRequired,

    /**
     * Function to call when click on "Get Public Link"
     */
    onGetPublicLink: _propTypes2.default.func
};
PopoverBar.defaultProps = {
    show: false,
    fileIndex: 0,
    totalFiles: 0,
    filename: '',
    fileURL: '',
    showPublicLink: true
};
exports.default = PopoverBar;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deleteProperty = __webpack_require__(176);

var _deleteProperty2 = _interopRequireDefault(_deleteProperty);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _post_actions = __webpack_require__(802);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var FailedPostOptions = function (_React$PureComponent) {
    (0, _inherits3.default)(FailedPostOptions, _React$PureComponent);

    function FailedPostOptions(props) {
        (0, _classCallCheck3.default)(this, FailedPostOptions);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FailedPostOptions.__proto__ || (0, _getPrototypeOf2.default)(FailedPostOptions)).call(this, props));

        _this.retryPost = _this.retryPost.bind(_this);
        _this.cancelPost = _this.cancelPost.bind(_this);

        _this.submitting = false;
        return _this;
    }

    (0, _createClass3.default)(FailedPostOptions, [{
        key: 'retryPost',
        value: function retryPost(e) {
            var _this2 = this;

            e.preventDefault();

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            var post = (0, _extends3.default)({}, this.props.post);
            (0, _deleteProperty2.default)(post, 'id');
            (0, _post_actions.createPost)(post, function () {
                _this2.submitting = false;
            }, function (err) {
                if (err && err.id && err.id === 'api.post.create_post.root_id.app_error') {
                    _this2.showPostDeletedModal();
                }

                _this2.submitting = false;
            });
        }
    }, {
        key: 'cancelPost',
        value: function cancelPost(e) {
            e.preventDefault();
            this.props.actions.removePost(this.props.post);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                { className: 'pending-post-actions' },
                _react2.default.createElement(
                    'a',
                    {
                        className: 'post-retry',
                        href: '#',
                        onClick: this.retryPost
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'pending_post_actions.retry',
                        defaultMessage: 'Retry'
                    })
                ),
                ' - ',
                _react2.default.createElement(
                    'a',
                    {
                        className: 'post-cancel',
                        href: '#',
                        onClick: this.cancelPost
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'pending_post_actions.cancel',
                        defaultMessage: 'Cancel'
                    })
                )
            );
        }
    }]);
    return FailedPostOptions;
}(_react2.default.PureComponent);

FailedPostOptions.propTypes = {

    /*
     * The failed post
     */
    post: _propTypes2.default.object.isRequired,
    actions: _propTypes2.default.shape({

        /**
         * The function to delete the post
         */
        removePost: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = FailedPostOptions;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlagIconFilled = function (_React$PureComponent) {
    (0, _inherits3.default)(FlagIconFilled, _React$PureComponent);

    function FlagIconFilled() {
        (0, _classCallCheck3.default)(this, FlagIconFilled);
        return (0, _possibleConstructorReturn3.default)(this, (FlagIconFilled.__proto__ || (0, _getPrototypeOf2.default)(FlagIconFilled)).apply(this, arguments));
    }

    (0, _createClass3.default)(FlagIconFilled, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '16px',
                        height: '16px',
                        viewBox: '0 0 16 16'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-1073.000000, -33.000000)',
                                fillRule: 'nonzero',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                { transform: 'translate(-1.000000, 0.000000)' },
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(1064.000000, 22.000000)' },
                                    _react2.default.createElement(
                                        'g',
                                        { transform: 'translate(10.000000, 11.000000)' },
                                        _react2.default.createElement('path', { d: 'M8,1 L2,1 C2,0.447 1.553,0 1,0 C0.447,0 0,0.447 0,1 L0,15.5 C0,15.776 0.224,16 0.5,16 L1.5,16 C1.776,16 2,15.776 2,15.5 L2,11 L7,11 L7,12 C7,12.553 7.447,13 8,13 L15,13 C15.553,13 16,12.553 16,12 L16,4 C16,3.447 15.553,3 15,3 L9,3 L9,2 C9,1.447 8.553,1 8,1 Z' })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return FlagIconFilled;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = FlagIconFilled;

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _permissions = __webpack_require__(279);

var _permissions2 = _interopRequireDefault(_permissions);

var _global_actions = __webpack_require__(778);

var _post_actions = __webpack_require__(802);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _reaction = __webpack_require__(2052);

var _reaction2 = _interopRequireDefault(_reaction);

var _emoji_picker_overlay = __webpack_require__(883);

var _emoji_picker_overlay2 = _interopRequireDefault(_emoji_picker_overlay);

var _channel_permission_gate = __webpack_require__(888);

var _channel_permission_gate2 = _interopRequireDefault(_channel_permission_gate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_EMOJI_PICKER_RIGHT_OFFSET = 15; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EMOJI_PICKER_WIDTH_OFFSET = 260;

var ReactionListView = function (_React$PureComponent) {
    (0, _inherits3.default)(ReactionListView, _React$PureComponent);

    function ReactionListView(props) {
        (0, _classCallCheck3.default)(this, ReactionListView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ReactionListView.__proto__ || (0, _getPrototypeOf2.default)(ReactionListView)).call(this, props));

        _this.getTarget = function () {
            return _this.refs.addReactionButton;
        };

        _this.handleEmojiClick = function (emoji) {
            _this.setState({ showEmojiPicker: false });
            var emojiName = emoji.name || emoji.aliases[0];
            _this.props.actions.addReaction(_this.props.post.id, emojiName);
            (0, _post_actions.emitEmojiPosted)(emojiName);
        };

        _this.hideEmojiPicker = function () {
            _this.setState({ showEmojiPicker: false });
        };

        _this.toggleEmojiPicker = function () {
            _this.setState({ showEmojiPicker: !_this.state.showEmojiPicker });
        };

        _this.state = {
            showEmojiPicker: false
        };
        return _this;
    }

    (0, _createClass3.default)(ReactionListView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.post.has_reactions) {
                this.props.actions.getReactionsForPost(this.props.post.id);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.reactions !== prevProps.reactions) {
                (0, _global_actions.postListScrollChange)();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.props.post.has_reactions || this.props.reactions && this.props.reactions.length === 0) {
                return null;
            }

            var reactionsByName = new _map2.default();
            var emojiNames = [];

            if (this.props.reactions) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.props.reactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var reaction = _step.value;

                        var emojiName = reaction.emoji_name;

                        if (reactionsByName.has(emojiName)) {
                            reactionsByName.get(emojiName).push(reaction);
                        } else {
                            emojiNames.push(emojiName);
                            reactionsByName.set(emojiName, [reaction]);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            var reactions = emojiNames.map(function (emojiName) {
                return _react2.default.createElement(_reaction2.default, {
                    key: emojiName,
                    post: _this2.props.post,
                    emojiName: emojiName,
                    reactions: reactionsByName.get(emojiName) || [],
                    emojis: _this2.props.emojis
                });
            });

            var addReactionButton = this.getTarget();
            var rightOffset = DEFAULT_EMOJI_PICKER_RIGHT_OFFSET;
            if (addReactionButton) {
                rightOffset = window.innerWidth - addReactionButton.getBoundingClientRect().right - EMOJI_PICKER_WIDTH_OFFSET;

                if (rightOffset < 0) {
                    rightOffset = DEFAULT_EMOJI_PICKER_RIGHT_OFFSET;
                }
            }

            var emojiPicker = null;
            if (this.props.enableEmojiPicker) {
                var addReactionTooltip = _react2.default.createElement(
                    _reactBootstrap.Tooltip,
                    { id: 'addReactionTooltip' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'reaction_list.addReactionTooltip',
                        defaultMessage: 'Add reaction'
                    })
                );

                emojiPicker = _react2.default.createElement(
                    'span',
                    { className: 'emoji-picker__container' },
                    _react2.default.createElement(_emoji_picker_overlay2.default, {
                        show: this.state.showEmojiPicker,
                        target: this.getTarget,
                        onHide: this.hideEmojiPicker,
                        onEmojiClick: this.handleEmojiClick,
                        rightOffset: rightOffset,
                        topOffset: -5
                    }),
                    _react2.default.createElement(
                        _reactBootstrap.OverlayTrigger,
                        {
                            trigger: ['hover', 'focus'],
                            placement: 'top',
                            delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                            overlay: addReactionTooltip
                        },
                        _react2.default.createElement(
                            _channel_permission_gate2.default,
                            {
                                channelId: this.props.post.channel_id,
                                teamId: this.props.teamId,
                                permissions: [_permissions2.default.ADD_REACTION]
                            },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: 'post-reaction',
                                    onClick: this.toggleEmojiPicker
                                },
                                _react2.default.createElement(
                                    'span',
                                    {
                                        className: 'post-reaction__add',
                                        ref: 'addReactionButton'
                                    },
                                    '+'
                                )
                            )
                        )
                    )
                );
            }

            var addReactionClassName = 'post-add-reaction';
            if (this.state.showEmojiPicker) {
                addReactionClassName += ' post-add-reaction-emoji-picker-open';
            }

            return _react2.default.createElement(
                'div',
                { className: 'post-reaction-list' },
                reactions,
                _react2.default.createElement(
                    'div',
                    { className: addReactionClassName },
                    emojiPicker
                )
            );
        }
    }]);
    return ReactionListView;
}(_react2.default.PureComponent);

ReactionListView.propTypes = {

    /**
     * The post to render reactions for
     */
    post: _propTypes2.default.object.isRequired,

    /*
     * The id of the team which belongs the post
     */
    teamId: _propTypes2.default.string,

    /**
     * The reactions to render
     */
    reactions: _propTypes2.default.arrayOf(_propTypes2.default.object),

    /**
     * The emojis for the different reactions
     */
    emojis: _propTypes2.default.object.isRequired,

    /**
     * Whether to show the emoji picker.
     */
    enableEmojiPicker: _propTypes2.default.bool.isRequired,

    actions: _propTypes2.default.shape({

        /**
         * Function to get reactions for a post
         */
        getReactionsForPost: _propTypes2.default.func.isRequired,

        /**
         * Function to add a reaction to the post
         */
        addReaction: _propTypes2.default.func.isRequired
    })
};
exports.default = ReactionListView;

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _posts = __webpack_require__(808);

var _users = __webpack_require__(786);

var _users2 = __webpack_require__(777);

var _channels = __webpack_require__(783);

var _emoji_utils = __webpack_require__(1015);

var _roles = __webpack_require__(276);

var _permissions = __webpack_require__(279);

var _permissions2 = _interopRequireDefault(_permissions);

var _emoji = __webpack_require__(947);

var Emoji = _interopRequireWildcard(_emoji);

var _reaction = __webpack_require__(2053);

var _reaction2 = _interopRequireDefault(_reaction);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeMapStateToProps() {
    var getProfilesForReactions = (0, _users2.makeGetProfilesForReactions)();

    return function mapStateToProps(state, ownProps) {
        var profiles = getProfilesForReactions(state, ownProps.reactions);
        var emoji = void 0;
        if (Emoji.EmojiIndicesByAlias.has(ownProps.emojiName)) {
            emoji = Emoji.Emojis[Emoji.EmojiIndicesByAlias.get(ownProps.emojiName)];
        } else {
            emoji = ownProps.emojis.get(ownProps.emojiName);
        }

        var emojiImageUrl = '';
        if (emoji) {
            emojiImageUrl = (0, _emoji_utils.getEmojiImageUrl)(emoji);
        }
        var channel = (0, _channels.getChannel)(state, { id: ownProps.post.channel_id }) || {};
        var teamId = channel.team_id;
        var canAddReaction = (0, _roles.haveIChannelPermission)(state, { team: teamId, channel: ownProps.post.channel_id, permission: _permissions2.default.ADD_REACTION });
        var canRemoveReaction = (0, _roles.haveIChannelPermission)(state, { team: teamId, channel: ownProps.post.channel_id, permission: _permissions2.default.REMOVE_REACTION });

        return {
            profiles: profiles,
            otherUsersCount: ownProps.reactions.length - profiles.length,
            currentUserId: (0, _users2.getCurrentUserId)(state),
            reactionCount: ownProps.reactions.length,
            canAddReaction: canAddReaction,
            canRemoveReaction: canRemoveReaction,
            emojiImageUrl: emojiImageUrl
        };
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            addReaction: _posts.addReaction,
            removeReaction: _posts.removeReaction,
            getMissingProfilesByIds: _users.getMissingProfilesByIds
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_reaction2.default);

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _post_actions = __webpack_require__(802);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Reaction = function (_React$PureComponent) {
    (0, _inherits3.default)(Reaction, _React$PureComponent);

    function Reaction(props) {
        (0, _classCallCheck3.default)(this, Reaction);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Reaction.__proto__ || (0, _getPrototypeOf2.default)(Reaction)).call(this, props));

        _this.loadMissingProfiles = function () {
            var ids = _this.props.reactions.map(function (reaction) {
                return reaction.user_id;
            });
            _this.props.actions.getMissingProfilesByIds(ids);
        };

        _this.addReaction = _this.addReaction.bind(_this);
        _this.removeReaction = _this.removeReaction.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Reaction, [{
        key: 'addReaction',
        value: function addReaction(e) {
            e.preventDefault();
            var _props = this.props,
                actions = _props.actions,
                post = _props.post,
                emojiName = _props.emojiName;

            actions.addReaction(post.id, emojiName);
            (0, _post_actions.emitEmojiPosted)(emojiName);
        }
    }, {
        key: 'removeReaction',
        value: function removeReaction(e) {
            e.preventDefault();
            this.props.actions.removeReaction(this.props.post.id, this.props.emojiName);
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.emojiImageUrl) {
                return null;
            }

            var currentUserReacted = false;
            var users = [];
            var otherUsersCount = this.props.otherUsersCount;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.props.profiles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var user = _step.value;

                    if (user.id === this.props.currentUserId) {
                        currentUserReacted = true;
                    } else {
                        users.push(Utils.getDisplayNameByUser(user));
                    }
                }

                // Sort users in alphabetical order with "you" being first if the current user reacted
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            users.sort();
            if (currentUserReacted) {
                users.unshift(Utils.localizeMessage('reaction.you', 'You'));
            }

            var names = void 0;
            if (otherUsersCount > 0) {
                if (users.length > 0) {
                    names = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'reaction.usersAndOthersReacted',
                        defaultMessage: '{users} and {otherUsers, number} other {otherUsers, plural, one {user} other {users}}',
                        values: {
                            users: users.join(', '),
                            otherUsers: otherUsersCount
                        }
                    });
                } else {
                    names = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'reaction.othersReacted',
                        defaultMessage: '{otherUsers, number} {otherUsers, plural, one {user} other {users}}',
                        values: {
                            otherUsers: otherUsersCount
                        }
                    });
                }
            } else if (users.length > 1) {
                names = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'reaction.usersReacted',
                    defaultMessage: '{users} and {lastUser}',
                    values: {
                        users: users.slice(0, -1).join(', '),
                        lastUser: users[users.length - 1]
                    }
                });
            } else {
                names = users[0];
            }

            var reactionVerb = void 0;
            if (users.length + otherUsersCount > 1) {
                if (currentUserReacted) {
                    reactionVerb = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'reaction.reactionVerb.youAndUsers',
                        defaultMessage: 'reacted'
                    });
                } else {
                    reactionVerb = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'reaction.reactionVerb.users',
                        defaultMessage: 'reacted'
                    });
                }
            } else if (currentUserReacted) {
                reactionVerb = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'reaction.reactionVerb.you',
                    defaultMessage: 'reacted'
                });
            } else {
                reactionVerb = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'reaction.reactionVerb.user',
                    defaultMessage: 'reacted'
                });
            }

            var tooltip = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'reaction.reacted',
                defaultMessage: '{users} {reactionVerb} with {emoji}',
                values: {
                    users: _react2.default.createElement(
                        'b',
                        null,
                        names
                    ),
                    reactionVerb: reactionVerb,
                    emoji: _react2.default.createElement(
                        'b',
                        null,
                        ':' + this.props.emojiName + ':'
                    )
                }
            });

            var handleClick = void 0;
            var clickTooltip = void 0;
            var className = 'post-reaction';
            if (currentUserReacted) {
                if (this.props.canRemoveReaction) {
                    handleClick = this.removeReaction;
                    clickTooltip = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'reaction.clickToRemove',
                        defaultMessage: '(click to remove)'
                    });
                }

                className += ' post-reaction--current-user';
            } else if (!currentUserReacted && this.props.canAddReaction) {
                handleClick = this.addReaction;
                clickTooltip = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'reaction.clickToAdd',
                    defaultMessage: '(click to add)'
                });
            }

            return _react2.default.createElement(
                _reactBootstrap.OverlayTrigger,
                {
                    trigger: ['hover', 'focus'],
                    delayShow: 1000,
                    placement: 'top',
                    shouldUpdatePosition: true,
                    overlay: _react2.default.createElement(
                        _reactBootstrap.Tooltip,
                        { id: this.props.post.id + '-' + this.props.emojiName + '-reaction' },
                        tooltip,
                        _react2.default.createElement('br', null),
                        clickTooltip
                    ),
                    onEnter: this.loadMissingProfiles
                },
                _react2.default.createElement(
                    'div',
                    {
                        className: className,
                        onClick: handleClick
                    },
                    _react2.default.createElement('span', {
                        className: 'post-reaction__emoji emoticon',
                        style: { backgroundImage: 'url(' + this.props.emojiImageUrl + ')' }
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'post-reaction__count' },
                        this.props.reactionCount
                    )
                )
            );
        }
    }]);
    return Reaction;
}(_react2.default.PureComponent);

Reaction.propTypes = {

    /*
     * The post to render the reaction for
     */
    post: _propTypes2.default.object.isRequired,

    /*
     * The user id of the logged in user
     */
    currentUserId: _propTypes2.default.string.isRequired,

    /*
     * The name of the emoji for the reaction
     */
    emojiName: _propTypes2.default.string.isRequired,

    /*
     * The number of reactions to this post for this emoji
     */
    reactionCount: _propTypes2.default.number.isRequired,

    /*
     * Array of users who reacted to this post
     */
    profiles: _propTypes2.default.array.isRequired,

    /*
     * The number of users not in the profile list who have reacted with this emoji
     */
    otherUsersCount: _propTypes2.default.number.isRequired,

    /*
     * Array of reactions by user
     */
    reactions: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,

    /*
     * True if the user has the permission to add a reaction in this channel
     */
    canAddReaction: _propTypes2.default.bool.isRequired,

    /*
     * True if user has the permission to remove his own reactions in this channel
     */
    canRemoveReaction: _propTypes2.default.bool.isRequired,

    /*
     * The URL of the emoji image
     */
    emojiImageUrl: _propTypes2.default.string.isRequired,

    actions: _propTypes2.default.shape({

        /*
         * Function to add a reaction to a post
         */
        addReaction: _propTypes2.default.func.isRequired,

        /*
         * Function to get non-loaded profiles by id
         */
        getMissingProfilesByIds: _propTypes2.default.func.isRequired,

        /*
         * Function to remove a reaction from a post
         */
        removeReaction: _propTypes2.default.func.isRequired
    })
};
exports.default = Reaction;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ChannelPermissionGate = function (_React$Component) {
  (0, _inherits3.default)(ChannelPermissionGate, _React$Component);

  function ChannelPermissionGate() {
    (0, _classCallCheck3.default)(this, ChannelPermissionGate);
    return (0, _possibleConstructorReturn3.default)(this, (ChannelPermissionGate.__proto__ || (0, _getPrototypeOf2.default)(ChannelPermissionGate)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChannelPermissionGate, [{
    key: 'render',
    value: function render() {
      if (this.props.hasPermission && !this.props.invert) {
        return this.props.children;
      }
      if (!this.props.hasPermission && this.props.invert) {
        return this.props.children;
      }
      return null;
    }
  }]);
  return ChannelPermissionGate;
}(_react2.default.Component);

ChannelPermissionGate.defaultProps = {
  invert: false
};
ChannelPermissionGate.propTypes = {

  /**
   * Channel to check the permission
   */
  channelId: _propTypes2.default.string,

  /**
   * Team to check the permission
   */
  teamId: _propTypes2.default.string,

  /**
   * Permissions enough to pass the gate (binary OR)
   */
  permissions: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,

  /**
   * Has permission
   */
  hasPermission: _propTypes2.default.bool.isRequired,

  /**
   * Invert the permission (used for else)
   */
  invert: _propTypes2.default.bool.isRequired,

  /**
   * Content protected by the permissions gate
   */
  children: _propTypes2.default.node.isRequired
};
exports.default = ChannelPermissionGate;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusAwayAvatarIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(StatusAwayAvatarIcon, _React$PureComponent);

    function StatusAwayAvatarIcon() {
        (0, _classCallCheck3.default)(this, StatusAwayAvatarIcon);
        return (0, _possibleConstructorReturn3.default)(this, (StatusAwayAvatarIcon.__proto__ || (0, _getPrototypeOf2.default)(StatusAwayAvatarIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusAwayAvatarIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '13px',
                        height: '13px',
                        viewBox: '0 0 12 12',
                        style: style
                    },
                    _react2.default.createElement('path', {
                        className: 'away--icon',
                        d: 'M9.081,5.712C9.267,5.712 9.417,5.863 9.417,6.048L9.417,9.086L11.864,10.499C12.025,10.592 12.08,10.797 11.987,10.958L11.482,11.832C11.39,11.993 11.184,12.048 11.023,11.955L7.904,10.154C7.788,10.087 7.727,9.961 7.737,9.836C7.736,9.827 7.736,9.818 7.736,9.809L7.736,6.048C7.736,5.863 7.886,5.712 8.072,5.712L9.081,5.712ZM4.812,11.513L4.605,11.513C2.325,11.41 0.253,10.374 0.046,9.027C-0.058,8.923 0.046,8.509 0.046,8.405C0.15,7.576 0.357,6.437 0.771,5.815C0.978,5.401 2.015,5.297 2.015,5.297C2.015,5.297 2.015,7.369 4.605,7.369L5.019,7.369C4.915,7.784 4.812,8.198 4.812,8.612C4.812,9.648 5.226,10.581 5.848,11.41C5.537,11.513 5.123,11.513 4.812,11.513ZM4.605,0.117C6.034,0.117 7.195,1.277 7.195,2.707C7.195,4.136 6.034,5.297 4.605,5.297C3.175,5.297 2.015,4.136 2.015,2.707C2.015,1.277 3.175,0.117 4.605,0.117Z'
                    })
                )
            );
        }
    }]);
    return StatusAwayAvatarIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = StatusAwayAvatarIcon;


var style = {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    strokeLinejoin: 'round',
    strokeMiterlimit: 1.41421
};

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusAwayIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(StatusAwayIcon, _React$PureComponent);

    function StatusAwayIcon() {
        (0, _classCallCheck3.default)(this, StatusAwayIcon);
        return (0, _possibleConstructorReturn3.default)(this, (StatusAwayIcon.__proto__ || (0, _getPrototypeOf2.default)(StatusAwayIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusAwayIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '100%',
                        height: '100%',
                        viewBox: '0 0 20 20',
                        style: style
                    },
                    _react2.default.createElement('path', {
                        className: 'away--icon',
                        d: 'M10,0C15.519,0 20,4.481 20,10C20,15.519 15.519,20 10,20C4.481,20 0,15.519 0,10C0,4.481 4.481,0 10,0ZM10.27,3C10.949,3 11.5,3.586 11.5,4.307L11.5,9.379L15.002,12.881C15.492,13.37 15.499,14.158 15.019,14.638L14.638,15.019C14.158,15.499 13.37,15.492 12.881,15.002L8.887,11.008C8.739,10.861 8.636,10.686 8.576,10.501C8.528,10.402 8.5,10.299 8.5,10.193L8.5,4.307C8.5,3.586 9.051,3 9.73,3L10.27,3Z'
                    })
                )
            );
        }
    }]);
    return StatusAwayIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = StatusAwayIcon;


var style = {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    strokeLinejoin: 'round',
    strokeMiterlimit: 1.41421
};

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusDndAvatarIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(StatusDndAvatarIcon, _React$PureComponent);

    function StatusDndAvatarIcon() {
        (0, _classCallCheck3.default)(this, StatusDndAvatarIcon);
        return (0, _possibleConstructorReturn3.default)(this, (StatusDndAvatarIcon.__proto__ || (0, _getPrototypeOf2.default)(StatusDndAvatarIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusDndAvatarIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        id: 'Layer_1',
                        x: '0px',
                        y: '0px',
                        width: '13px',
                        height: '13px',
                        viewBox: '-299 391 12 12',
                        style: style
                    },
                    _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('ellipse', {
                            className: 'dnd--icon',
                            cx: '-294.6',
                            cy: '394',
                            rx: '2.5',
                            ry: '2.5'
                        }),
                        _react2.default.createElement('path', {
                            className: 'dnd--icon',
                            d: 'M-293.8,399.4c0-0.4,0.1-0.7,0.2-1c-0.3,0.1-0.6,0.2-1,0.2c-2.5,0-2.5-2-2.5-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5 c0,0.1-0.1,0.5,0,0.6c0.2,1.3,2.2,2.3,4.4,2.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.7,0,1.4-0.1,2-0.3 C-293.3,401.5-293.8,400.5-293.8,399.4z'
                        })
                    ),
                    _react2.default.createElement('path', {
                        className: 'dnd--icon',
                        d: 'M-287,400c0,0.1-0.1,0.1-0.1,0.1l-4.9,0c-0.1,0-0.1-0.1-0.1-0.1v-1.6c0-0.1,0.1-0.1,0.1-0.1l4.9,0c0.1,0,0.1,0.1,0.1,0.1 V400z'
                    })
                )
            );
        }
    }]);
    return StatusDndAvatarIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = StatusDndAvatarIcon;


var style = {
    enableBackground: 'new -299 391 12 12'
};

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusDndIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(StatusDndIcon, _React$PureComponent);

    function StatusDndIcon() {
        (0, _classCallCheck3.default)(this, StatusDndIcon);
        return (0, _possibleConstructorReturn3.default)(this, (StatusDndIcon.__proto__ || (0, _getPrototypeOf2.default)(StatusDndIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusDndIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '100%',
                        height: '100%',
                        viewBox: '0 0 20 20',
                        style: style
                    },
                    _react2.default.createElement('path', {
                        className: 'dnd--icon',
                        d: 'M10,0c5.519,0 10,4.481 10,10c0,5.519 -4.481,10 -10,10c-5.519,0 -10,-4.481 -10,-10c0,-5.519 4.481,-10 10,-10Zm5.25,8.5l-10.5,0c-0.414,0 -0.75,0.336 -0.75,0.75l0,1.5c0,0.414 0.336,0.75 0.75,0.75l10.5,0c0.414,0 0.75,-0.336 0.75,-0.75l0,-1.5c0,-0.414 -0.336,-0.75 -0.75,-0.75Z'
                    })
                )
            );
        }
    }]);
    return StatusDndIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = StatusDndIcon;


var style = {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    strokeLinejoin: 'round',
    strokeMiterlimit: 1.41421
};

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusDndAvatarIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(StatusDndAvatarIcon, _React$PureComponent);

    function StatusDndAvatarIcon() {
        (0, _classCallCheck3.default)(this, StatusDndAvatarIcon);
        return (0, _possibleConstructorReturn3.default)(this, (StatusDndAvatarIcon.__proto__ || (0, _getPrototypeOf2.default)(StatusDndAvatarIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusDndAvatarIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        id: 'Layer_1',
                        x: '0px',
                        y: '0px',
                        width: '13px',
                        height: '13px',
                        viewBox: '-299 391 12 12',
                        style: style
                    },
                    _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement(
                            'g',
                            null,
                            _react2.default.createElement('ellipse', {
                                className: 'offline--icon',
                                cx: '-294.5',
                                cy: '394',
                                rx: '2.5',
                                ry: '2.5'
                            }),
                            _react2.default.createElement('path', {
                                className: 'offline--icon',
                                d: 'M-294.3,399.7c0-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.2,0-0.4,0c-2.5,0-2.5-2-2.5-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5 c0,0.1-0.1,0.5,0,0.6c0.2,1.3,2.2,2.3,4.4,2.4h0.1h0.1c0.3,0,0.7,0,1-0.1C-293.9,401.6-294.3,400.7-294.3,399.7z'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('path', {
                            className: 'offline--icon',
                            d: 'M-288.9,399.4l1.8-1.8c0.1-0.1,0.1-0.3,0-0.3l-0.7-0.7c-0.1-0.1-0.3-0.1-0.3,0l-1.8,1.8l-1.8-1.8c-0.1-0.1-0.3-0.1-0.3,0 l-0.7,0.7c-0.1,0.1-0.1,0.3,0,0.3l1.8,1.8l-1.8,1.8c-0.1,0.1-0.1,0.3,0,0.3l0.7,0.7c0.1,0.1,0.3,0.1,0.3,0l1.8-1.8l1.8,1.8 c0.1,0.1,0.3,0.1,0.3,0l0.7-0.7c0.1-0.1,0.1-0.3,0-0.3L-288.9,399.4z'
                        })
                    )
                )
            );
        }
    }]);
    return StatusDndAvatarIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = StatusDndAvatarIcon;


var style = {
    enableBackground: 'new -299 391 12 12'
};

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusOfflineIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(StatusOfflineIcon, _React$PureComponent);

    function StatusOfflineIcon() {
        (0, _classCallCheck3.default)(this, StatusOfflineIcon);
        return (0, _possibleConstructorReturn3.default)(this, (StatusOfflineIcon.__proto__ || (0, _getPrototypeOf2.default)(StatusOfflineIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusOfflineIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '100%',
                        height: '100%',
                        className: 'offline--icon',
                        viewBox: '0 0 20 20',
                        style: style
                    },
                    _react2.default.createElement('path', { d: 'M10,0c5.519,0 10,4.481 10,10c0,5.519 -4.481,10 -10,10c-5.519,0 -10,-4.481 -10,-10c0,-5.519 4.481,-10 10,-10Zm0,2c4.415,0 8,3.585 8,8c0,4.415 -3.585,8 -8,8c-4.415,0 -8,-3.585 -8,-8c0,-4.415 3.585,-8 8,-8Z' })
                )
            );
        }
    }]);
    return StatusOfflineIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = StatusOfflineIcon;


var style = {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    strokeLinejoin: 'round',
    strokeMiterlimit: 1.41421
};

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusOnlineAvatarIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(StatusOnlineAvatarIcon, _React$PureComponent);

    function StatusOnlineAvatarIcon() {
        (0, _classCallCheck3.default)(this, StatusOnlineAvatarIcon);
        return (0, _possibleConstructorReturn3.default)(this, (StatusOnlineAvatarIcon.__proto__ || (0, _getPrototypeOf2.default)(StatusOnlineAvatarIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusOnlineAvatarIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        id: 'Layer_1',
                        x: '0px',
                        y: '0px',
                        width: '13px',
                        height: '13px',
                        viewBox: '-243 245 12 12',
                        style: style
                    },
                    _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('path', {
                            className: 'online--icon',
                            d: 'M-236,250.5C-236,250.5-236,250.5-236,250.5C-236,250.5-236,250.5-236,250.5C-236,250.5-236,250.5-236,250.5z'
                        }),
                        _react2.default.createElement('ellipse', {
                            className: 'online--icon',
                            cx: '-238.5',
                            cy: '248',
                            rx: '2.5',
                            ry: '2.5'
                        })
                    ),
                    _react2.default.createElement('path', {
                        className: 'online--icon',
                        d: 'M-238.9,253.8c0-0.4,0.1-0.9,0.2-1.3c-2.2-0.2-2.2-2-2.2-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5c0,0.1-0.1,0.5,0,0.6 c0.2,1.3,2.2,2.3,4.4,2.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0C-238.7,255.7-238.9,254.8-238.9,253.8z'
                    }),
                    _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement(
                            'g',
                            null,
                            _react2.default.createElement('path', {
                                className: 'online--icon',
                                d: 'M-232.3,250.1l1.3,1.3c0,0,0,0.1,0,0.1l-4.1,4.1c0,0,0,0-0.1,0c0,0,0,0,0,0l-2.7-2.7c0,0,0-0.1,0-0.1l1.2-1.2 c0,0,0.1,0,0.1,0l1.4,1.4l2.9-2.9C-232.4,250.1-232.3,250.1-232.3,250.1z'
                            })
                        )
                    )
                )
            );
        }
    }]);
    return StatusOnlineAvatarIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = StatusOnlineAvatarIcon;


var style = {
    enableBackground: 'new -243 245 12 12'
};

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusOnlineIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(StatusOnlineIcon, _React$PureComponent);

    function StatusOnlineIcon() {
        (0, _classCallCheck3.default)(this, StatusOnlineIcon);
        return (0, _possibleConstructorReturn3.default)(this, (StatusOnlineIcon.__proto__ || (0, _getPrototypeOf2.default)(StatusOnlineIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusOnlineIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '100%',
                        height: '100%',
                        viewBox: '0 0 20 20',
                        style: style
                    },
                    _react2.default.createElement('path', {
                        className: 'online--icon',
                        d: 'M10,0c5.519,0 10,4.481 10,10c0,5.519 -4.481,10 -10,10c-5.519,0 -10,-4.481 -10,-10c0,-5.519 4.481,-10 10,-10Zm6.19,7.18c0,0.208 -0.075,0.384 -0.224,0.53l-5.782,5.64l-1.087,1.059c-0.149,0.146 -0.33,0.218 -0.543,0.218c-0.213,0 -0.394,-0.072 -0.543,-0.218l-1.086,-1.059l-2.891,-2.82c-0.149,-0.146 -0.224,-0.322 -0.224,-0.53c0,-0.208 0.075,-0.384 0.224,-0.53l1.086,-1.059c0.149,-0.146 0.33,-0.218 0.543,-0.218c0.213,0 0.394,0.072 0.543,0.218l2.348,2.298l5.24,-5.118c0.149,-0.146 0.33,-0.218 0.543,-0.218c0.213,0 0.394,0.072 0.543,0.218l1.086,1.059c0.149,0.146 0.224,0.322 0.224,0.53Z'
                    })
                )
            );
        }
    }]);
    return StatusOnlineIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = StatusOnlineIcon;


var style = {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    strokeLinejoin: 'round',
    strokeMiterlimit: 1.41421
};

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _constants = __webpack_require__(29);

var _youtube_video = __webpack_require__(2064);

var _youtube_video2 = _interopRequireDefault(_youtube_video);

var _view_image = __webpack_require__(1043);

var _view_image2 = _interopRequireDefault(_view_image);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

var _post_attachment_list = __webpack_require__(2066);

var _post_attachment_list2 = _interopRequireDefault(_post_attachment_list);

var _post_attachment_opengraph = __webpack_require__(2068);

var _post_attachment_opengraph2 = _interopRequireDefault(_post_attachment_opengraph);

var _post_image = __webpack_require__(2071);

var _post_image2 = _interopRequireDefault(_post_image);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostBodyAdditionalContent = function (_React$PureComponent) {
    (0, _inherits3.default)(PostBodyAdditionalContent, _React$PureComponent);

    function PostBodyAdditionalContent(props) {
        (0, _classCallCheck3.default)(this, PostBodyAdditionalContent);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostBodyAdditionalContent.__proto__ || (0, _getPrototypeOf2.default)(PostBodyAdditionalContent)).call(this, props));

        _this.toggleEmbedVisibility = function () {
            // save the toggle info in the localstorage
            _browser_store2.default.setGlobalItem(_constants.StoragePrefixes.EMBED_VISIBLE + _this.props.post.id, !_this.props.isEmbedVisible);
        };

        _this.handleImageClick = function () {
            _this.setState({
                showPreviewModal: true
            });
        };

        _this.getSlackAttachment = _this.getSlackAttachment.bind(_this);
        _this.generateToggleableEmbed = _this.generateToggleableEmbed.bind(_this);
        _this.generateStaticEmbed = _this.generateStaticEmbed.bind(_this);
        _this.isLinkToggleable = _this.isLinkToggleable.bind(_this);
        _this.handleLinkLoadError = _this.handleLinkLoadError.bind(_this);
        _this.handleLinkLoaded = _this.handleLinkLoaded.bind(_this);

        _this.state = {
            link: Utils.extractFirstLink(props.post.message),
            linkLoadError: false,
            linkLoaded: false
        };
        return _this;
    }

    (0, _createClass3.default)(PostBodyAdditionalContent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // check the availability of the image rendered(if any) in the first render.
            this.preCheckImageLink();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.post.message !== this.props.post.message) {
                this.setState({
                    link: Utils.extractFirstLink(nextProps.post.message)
                }, function () {
                    // check the availability of the image link
                    _this2.preCheckImageLink();
                });
            }
        }
    }, {
        key: 'getSlackAttachment',
        value: function getSlackAttachment() {
            var attachments = [];
            if (this.props.post.props && this.props.post.props.attachments) {
                attachments = this.props.post.props.attachments;
            }

            return _react2.default.createElement(_post_attachment_list2.default, {
                attachments: attachments,
                postId: this.props.post.id,
                key: this.props.post.id
            });
        }

        // when image links are collapsed, check if the link is a valid image url and it is available

    }, {
        key: 'preCheckImageLink',
        value: function preCheckImageLink() {
            var _this3 = this;

            // check only if embedVisible is false i.e the image are by default hidden/collapsed
            // if embedVisible is true, the image is rendered, during which image load error is captured
            if (!this.props.isEmbedVisible && this.isLinkImage(this.state.link)) {
                var image = new Image();
                image.src = PostUtils.getImageSrc(this.state.link, this.props.hasImageProxy);

                image.onload = function () {
                    _this3.handleLinkLoaded();
                };

                image.onerror = function () {
                    _this3.handleLinkLoadError();
                };
            }
        }
    }, {
        key: 'isLinkImage',
        value: function isLinkImage(link) {
            var regex = /.+\/(.+\.(?:jpg|gif|bmp|png|jpeg))(?:\?.*)?$/i;
            var match = link.match(regex);
            if (match && match[1]) {
                return true;
            }

            return false;
        }
    }, {
        key: 'isLinkToggleable',
        value: function isLinkToggleable() {
            var link = this.state.link;
            if (!link) {
                return false;
            }

            if (_youtube_video2.default.isYoutubeLink(link)) {
                return true;
            }

            if (this.isLinkImage(link)) {
                return true;
            }

            return false;
        }
    }, {
        key: 'handleLinkLoadError',
        value: function handleLinkLoadError() {
            this.setState({
                linkLoadError: true
            });
        }
    }, {
        key: 'handleLinkLoaded',
        value: function handleLinkLoaded() {
            this.setState({
                linkLoaded: true
            });
        }
    }, {
        key: 'generateToggleableEmbed',
        value: function generateToggleableEmbed() {
            var link = this.state.link;
            if (!link) {
                return null;
            }

            if (_youtube_video2.default.isYoutubeLink(link)) {
                return _react2.default.createElement(_youtube_video2.default, {
                    channelId: this.props.post.channel_id,
                    link: link,
                    show: this.props.isEmbedVisible,
                    onLinkLoaded: this.handleLinkLoaded
                });
            }

            if (this.isLinkImage(link)) {
                return _react2.default.createElement(_post_image2.default, {
                    channelId: this.props.post.channel_id,
                    link: link,
                    onLinkLoadError: this.handleLinkLoadError,
                    onLinkLoaded: this.handleLinkLoaded,
                    handleImageClick: this.handleImageClick
                });
            }

            return null;
        }
    }, {
        key: 'generateStaticEmbed',
        value: function generateStaticEmbed() {
            if (this.props.post.props && this.props.post.props.attachments) {
                return this.getSlackAttachment();
            }

            var link = Utils.extractFirstLink(this.props.post.message);
            if (link && this.props.enableLinkPreviews && this.props.previewEnabled) {
                return _react2.default.createElement(_post_attachment_opengraph2.default, {
                    link: link,
                    previewCollapsed: this.props.previewCollapsed,
                    post: this.props.post
                });
            }

            return null;
        }
    }, {
        key: 'renderImagePreview',
        value: function renderImagePreview() {
            var _this4 = this;

            var link = this.state.link;
            if (!link || !this.isLinkImage(link)) {
                return null;
            }

            var captureExt = /(?:\.([^.]+))?$/;
            if (!captureExt || captureExt.length <= 1) {
                return null;
            }

            var ext = captureExt.exec(link)[1];

            return _react2.default.createElement(_view_image2.default, {
                show: this.state.showPreviewModal,
                onModalDismissed: function onModalDismissed() {
                    return _this4.setState({ showPreviewModal: false });
                },
                startIndex: 0,
                fileInfos: [{
                    hasPreviewImage: false,
                    link: link,
                    extension: ext
                }]
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.isLinkToggleable() && !this.state.linkLoadError) {
                // if message has only one line and starts with a link place toggle in this only line
                // else - place it in new line between message and embed
                var prependToggle = /^\s*https?:\/\/.*$/.test(this.props.post.message);

                var toggle = _react2.default.createElement('a', {
                    key: 'toggle',
                    className: 'post__embed-visibility ' + (prependToggle ? 'pull-left' : ''),
                    'data-expanded': this.props.isEmbedVisible,
                    'aria-label': 'Toggle Embed Visibility',
                    onClick: this.toggleEmbedVisibility
                });
                var message = _react2.default.createElement(
                    'div',
                    { key: 'message' },
                    this.props.children
                );

                var contents = [message];

                if (this.state.linkLoaded || _youtube_video2.default.isYoutubeLink(this.state.link)) {
                    if (prependToggle) {
                        contents.unshift(toggle);
                    } else {
                        contents.push(toggle);
                    }
                }

                if (this.props.isEmbedVisible) {
                    contents.push(_react2.default.createElement(
                        'div',
                        {
                            key: 'embed',
                            className: 'post__embed-container'
                        },
                        this.generateToggleableEmbed()
                    ));
                }
                var imagePreview = this.renderImagePreview();

                return _react2.default.createElement(
                    'div',
                    null,
                    contents,
                    imagePreview
                );
            }

            var staticEmbed = this.generateStaticEmbed();

            if (staticEmbed) {
                return _react2.default.createElement(
                    'div',
                    null,
                    this.props.children,
                    staticEmbed
                );
            }

            return this.props.children;
        }
    }]);
    return PostBodyAdditionalContent;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PostBodyAdditionalContent.propTypes = {

    /**
     * The post to render the content of
     */
    post: _propTypes2.default.object.isRequired,

    /**
     * The post's message
     */
    children: _propTypes2.default.element.isRequired,

    /**
     * Set to collapse image and video previews
     */
    previewCollapsed: _propTypes2.default.string,

    /**
     * User's preference to link previews
     */
    previewEnabled: _propTypes2.default.bool,

    /**
     * Flag passed down to PostBodyAdditionalContent for determining if post embed is visible
     */
    isEmbedVisible: _propTypes2.default.bool,

    /**
     * Whether link previews are enabled in the first place.
     */
    enableLinkPreviews: _propTypes2.default.bool.isRequired,

    /**
     * If an image proxy is enabled.
     */
    hasImageProxy: _propTypes2.default.bool.isRequired
};
PostBodyAdditionalContent.defaultProps = {
    previewCollapsed: '',
    previewEnabled: false
};
exports.default = PostBodyAdditionalContent;

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(783);

var _general = __webpack_require__(113);

var _youtube_video = __webpack_require__(2065);

var _youtube_video2 = _interopRequireDefault(_youtube_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    var googleDeveloperKey = config.GoogleDeveloperKey;

    return {
        currentChannelId: (0, _channels.getCurrentChannelId)(state),
        googleDeveloperKey: googleDeveloperKey
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_youtube_video2.default);

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _integration_actions = __webpack_require__(1313);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ytRegex = /(?:http|https):\/\/(?:www\.|m\.)?(?:(?:youtube\.com\/(?:(?:v\/)|(?:(?:watch|embed\/watch)(?:\/|.*v=))|(?:embed\/)|(?:user\/[^/]+\/u\/[0-9]\/)))|(?:youtu\.be\/))([^#&?]*)/;

var YoutubeVideo = function (_React$PureComponent) {
    (0, _inherits3.default)(YoutubeVideo, _React$PureComponent);

    function YoutubeVideo(props) {
        (0, _classCallCheck3.default)(this, YoutubeVideo);

        var _this = (0, _possibleConstructorReturn3.default)(this, (YoutubeVideo.__proto__ || (0, _getPrototypeOf2.default)(YoutubeVideo)).call(this, props));

        _this.updateStateFromProps = _this.updateStateFromProps.bind(_this);
        _this.handleReceivedMetadata = _this.handleReceivedMetadata.bind(_this);
        _this.handleMetadataError = _this.handleMetadataError.bind(_this);
        _this.loadWithoutKey = _this.loadWithoutKey.bind(_this);

        _this.play = _this.play.bind(_this);
        _this.stop = _this.stop.bind(_this);

        _this.state = {
            loaded: false,
            failed: false,
            playing: false,
            title: ''
        };
        return _this;
    }

    (0, _createClass3.default)(YoutubeVideo, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.updateStateFromProps(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.updateStateFromProps(nextProps);
        }
    }, {
        key: 'updateStateFromProps',
        value: function updateStateFromProps(props) {
            var link = props.link;

            var match = link.trim().match(ytRegex);
            if (!match || match[1].length !== 11) {
                return;
            }

            if (props.show === false) {
                this.stop();
            }

            if (props.channelId !== props.currentChannelId) {
                this.stop();
            }

            this.setState({
                videoId: match[1],
                time: this.handleYoutubeTime(link)
            });
        }
    }, {
        key: 'handleYoutubeTime',
        value: function handleYoutubeTime(link) {
            var timeRegex = /[\\?&]t=([0-9]+h)?([0-9]+m)?([0-9]+s?)/;

            var time = link.match(timeRegex);
            if (!time || !time[0]) {
                return '';
            }

            var hours = time[1] ? time[1].match(/([0-9]+)h/) : null;
            var minutes = time[2] ? time[2].match(/([0-9]+)m/) : null;
            var seconds = time[3] ? time[3].match(/([0-9]+)s?/) : null;

            var ticks = 0;

            if (hours && hours[1]) {
                ticks += parseInt(hours[1], 10) * 3600;
            }

            if (minutes && minutes[1]) {
                ticks += parseInt(minutes[1], 10) * 60;
            }

            if (seconds && seconds[1]) {
                ticks += parseInt(seconds[1], 10);
            }

            return '&start=' + ticks.toString();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var key = this.props.googleDeveloperKey;
            if (key) {
                (0, _integration_actions.getYoutubeVideoInfo)(key, this.state.videoId, this.handleReceivedMetadata, this.handleMetadataError);
            } else {
                this.loadWithoutKey();
            }
            this.props.onLinkLoaded();
        }
    }, {
        key: 'loadWithoutKey',
        value: function loadWithoutKey() {
            this.setState({
                loaded: true,
                thumb: 'https://i.ytimg.com/vi/' + this.state.videoId + '/hqdefault.jpg'
            });
        }
    }, {
        key: 'handleMetadataError',
        value: function handleMetadataError() {
            this.setState({
                failed: true,
                loaded: true,
                title: Utils.localizeMessage('youtube_video.notFound', 'Video not found')
            });
        }
    }, {
        key: 'handleReceivedMetadata',
        value: function handleReceivedMetadata(data) {
            if (!data || !data.items || !data.items.length || !data.items[0].snippet) {
                this.setState({
                    failed: true,
                    loaded: true,
                    title: Utils.localizeMessage('youtube_video.notFound', 'Video not found')
                });
                return null;
            }
            var metadata = data.items[0].snippet;
            var thumb = 'https://i.ytimg.com/vi/' + this.state.videoId + '/hqdefault.jpg';
            if (metadata.liveBroadcastContent === 'live') {
                thumb = 'https://i.ytimg.com/vi/' + this.state.videoId + '/hqdefault_live.jpg';
            }

            this.setState({
                loaded: true,
                receivedYoutubeData: true,
                title: metadata.title,
                thumb: thumb
            });
            return null;
        }
    }, {
        key: 'play',
        value: function play() {
            this.setState({ playing: true });
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.setState({ playing: false });
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.loaded) {
                return _react2.default.createElement(
                    'div',
                    {
                        className: 'post__embed-container'
                    },
                    _react2.default.createElement('div', { className: 'video-loading' })
                );
            }

            var header = void 0;
            if (this.state.title) {
                header = _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'span',
                        { className: 'video-type' },
                        'Youtube - '
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'video-title' },
                        _react2.default.createElement(
                            'a',
                            {
                                href: this.props.link,
                                target: 'blank',
                                rel: 'noopener noreferrer'
                            },
                            this.state.title
                        )
                    )
                );
            }

            var content = void 0;
            if (this.state.failed) {
                content = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'video-thumbnail__container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'video-thumbnail__error' },
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement('i', { className: 'fa fa-warning fa-2x' })
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                Utils.localizeMessage('youtube_video.notFound', 'Video not found')
                            )
                        )
                    )
                );
            } else if (this.state.playing) {
                content = _react2.default.createElement('iframe', {
                    src: 'https://www.youtube.com/embed/' + this.state.videoId + '?autoplay=1&autohide=1&border=0&wmode=opaque&fs=1&enablejsapi=1' + this.state.time,
                    width: '480px',
                    height: '360px',
                    type: 'text/html',
                    frameBorder: '0',
                    allowFullScreen: 'allowfullscreen'
                });
            } else {
                content = _react2.default.createElement(
                    'div',
                    { className: 'embed-responsive embed-responsive-4by3 video-div__placeholder' },
                    _react2.default.createElement(
                        'div',
                        { className: 'video-thumbnail__container' },
                        _react2.default.createElement('img', {
                            className: 'video-thumbnail',
                            src: this.state.thumb
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'block' },
                            _react2.default.createElement(
                                'span',
                                { className: 'play-button' },
                                _react2.default.createElement('span', null)
                            )
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    className: 'post__embed-container'
                },
                _react2.default.createElement(
                    'div',
                    null,
                    header,
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'video-div embed-responsive-item',
                            onClick: this.play
                        },
                        content
                    )
                )
            );
        }
    }], [{
        key: 'isYoutubeLink',
        value: function isYoutubeLink(link) {
            return link.trim().match(ytRegex);
        }
    }]);
    return YoutubeVideo;
}(_react2.default.PureComponent);

YoutubeVideo.propTypes = {
    channelId: _propTypes2.default.string.isRequired,
    currentChannelId: _propTypes2.default.string.isRequired,
    link: _propTypes2.default.string.isRequired,
    show: _propTypes2.default.bool.isRequired,
    googleDeveloperKey: _propTypes2.default.string,
    onLinkLoaded: _propTypes2.default.func
};
exports.default = YoutubeVideo;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _post_attachment = __webpack_require__(2067);

var _post_attachment2 = _interopRequireDefault(_post_attachment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostAttachmentList = function (_React$PureComponent) {
    (0, _inherits3.default)(PostAttachmentList, _React$PureComponent);

    function PostAttachmentList() {
        (0, _classCallCheck3.default)(this, PostAttachmentList);
        return (0, _possibleConstructorReturn3.default)(this, (PostAttachmentList.__proto__ || (0, _getPrototypeOf2.default)(PostAttachmentList)).apply(this, arguments));
    }

    (0, _createClass3.default)(PostAttachmentList, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var content = [];
            this.props.attachments.forEach(function (attachment, i) {
                content.push(_react2.default.createElement(_post_attachment2.default, {
                    attachment: attachment,
                    postId: _this2.props.postId,
                    key: 'att_' + i
                }));
            });

            return _react2.default.createElement(
                'div',
                { className: 'attachment__list' },
                content
            );
        }
    }]);
    return PostAttachmentList;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PostAttachmentList.propTypes = {

    /**
     * The post id
     */
    postId: _propTypes2.default.string.isRequired,

    /**
     * Array of attachments to render
     */
    attachments: _propTypes2.default.array.isRequired
};
exports.default = PostAttachmentList;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _post_actions = __webpack_require__(802);

var PostActions = _interopRequireWildcard(_post_actions);

var _text_formatting = __webpack_require__(811);

var TextFormatting = _interopRequireWildcard(_text_formatting);

var _post_utils = __webpack_require__(803);

var _url = __webpack_require__(793);

var _utils = __webpack_require__(762);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostAttachment = function (_React$PureComponent) {
    (0, _inherits3.default)(PostAttachment, _React$PureComponent);

    function PostAttachment(props) {
        (0, _classCallCheck3.default)(this, PostAttachment);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostAttachment.__proto__ || (0, _getPrototypeOf2.default)(PostAttachment)).call(this, props));

        _this.toggleCollapseState = function (e) {
            e.preventDefault();
            _this.setState(function (prevState) {
                return {
                    collapsed: !prevState.collapsed
                };
            });
        };

        _this.handleActionButtonClick = function (e) {
            e.preventDefault();
            var actionId = e.currentTarget.getAttribute('data-action-id');
            PostActions.doPostAction(_this.props.postId, actionId);
        };

        _this.state = {
            collapsed: true
        };
        return _this;
    }

    (0, _createClass3.default)(PostAttachment, [{
        key: 'shouldCollapse',
        value: function shouldCollapse() {
            var text = this.props.attachment.text || '';
            return (text.match(/\n/g) || []).length >= 5 || text.length > 700;
        }
    }, {
        key: 'getCollapsedTextHTML',
        value: function getCollapsedTextHTML() {
            // TODO: this breaks markdown formatting when it e.g. cuts a ``` block terminator
            // Should be collapsed using another method.
            var text = this.props.attachment.text || '';
            if ((text.match(/\n/g) || []).length >= 5) {
                text = text.split('\n').splice(0, 5).join('\n');
            }
            if (text.length > 300) {
                text = text.substr(0, 300);
            }

            return TextFormatting.formatText(text);
        }
    }, {
        key: 'getActionView',
        value: function getActionView() {
            var _this2 = this;

            var actions = this.props.attachment.actions;
            if (!actions || !actions.length) {
                return '';
            }

            var buttons = [];

            actions.forEach(function (action) {
                if (!action.id || !action.name) {
                    return;
                }
                buttons.push(_react2.default.createElement(
                    'button',
                    {
                        'data-action-id': action.id,
                        key: action.id,
                        onClick: _this2.handleActionButtonClick
                    },
                    action.name
                ));
            });

            return _react2.default.createElement(
                'div',
                {
                    className: 'attachment-actions'
                },
                buttons
            );
        }
    }, {
        key: 'getFieldsTable',
        value: function getFieldsTable() {
            var fields = this.props.attachment.fields;
            if (!fields || !fields.length) {
                return '';
            }

            var fieldTables = [];

            var headerCols = [];
            var bodyCols = [];
            var rowPos = 0;
            var lastWasLong = false;
            var nrTables = 0;

            fields.forEach(function (field, i) {
                if (rowPos === 2 || !(field.short === true) || lastWasLong) {
                    fieldTables.push(_react2.default.createElement(
                        'table',
                        {
                            className: 'attachment-fields',
                            key: 'attachment__table__' + nrTables
                        },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                headerCols
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                bodyCols
                            )
                        )
                    ));
                    headerCols = [];
                    bodyCols = [];
                    rowPos = 0;
                    nrTables += 1;
                    lastWasLong = false;
                }
                headerCols.push(_react2.default.createElement(
                    'th',
                    {
                        className: 'attachment-field__caption',
                        key: 'attachment__field-caption-' + i + '__' + nrTables,
                        width: '50%'
                    },
                    field.title
                ));

                var formattedText = TextFormatting.formatText(field.value || '');

                bodyCols.push(_react2.default.createElement(
                    'td',
                    {
                        className: 'attachment-field',
                        key: 'attachment__field-' + i + '__' + nrTables
                    },
                    (0, _post_utils.messageHtmlToComponent)(formattedText, false)
                ));
                rowPos += 1;
                lastWasLong = !(field.short === true);
            });
            if (headerCols.length > 0) {
                // Flush last fields
                fieldTables.push(_react2.default.createElement(
                    'table',
                    {
                        className: 'attachment-fields',
                        key: 'attachment__table__' + nrTables
                    },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            headerCols
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            bodyCols
                        )
                    )
                ));
            }
            return _react2.default.createElement(
                'div',
                null,
                fieldTables
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var data = this.props.attachment;
            var preTextClass = '';

            var preText = void 0;
            if (data.pretext) {
                var formattedText = TextFormatting.formatText(data.pretext || '');
                preTextClass = 'attachment--pretext';
                preText = _react2.default.createElement(
                    'div',
                    { className: 'attachment__thumb-pretext' },
                    (0, _post_utils.messageHtmlToComponent)(formattedText, false)
                );
            }

            var author = [];
            if (data.author_name || data.author_icon) {
                if (data.author_icon) {
                    author.push(_react2.default.createElement('img', {
                        className: 'attachment__author-icon',
                        src: data.author_icon,
                        key: 'attachment__author-icon',
                        height: '14',
                        width: '14'
                    }));
                }
                if (data.author_name) {
                    author.push(_react2.default.createElement(
                        'span',
                        {
                            className: 'attachment__author-name',
                            key: 'attachment__author-name'
                        },
                        data.author_name
                    ));
                }
            }
            if (data.author_link && (0, _url.isUrlSafe)(data.author_link)) {
                author = _react2.default.createElement(
                    'a',
                    {
                        href: data.author_link,
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    },
                    author
                );
            }

            var title = void 0;
            if (data.title) {
                if (data.title_link && (0, _url.isUrlSafe)(data.title_link)) {
                    title = _react2.default.createElement(
                        'h1',
                        {
                            className: 'attachment__title'
                        },
                        _react2.default.createElement(
                            'a',
                            {
                                className: 'attachment__title-link',
                                href: data.title_link,
                                target: '_blank',
                                rel: 'noopener noreferrer'
                            },
                            data.title
                        )
                    );
                } else {
                    title = _react2.default.createElement(
                        'h1',
                        {
                            className: 'attachment__title'
                        },
                        data.title
                    );
                }
            }

            var text = void 0;
            if (data.text) {
                var shouldCollapse = this.shouldCollapse();
                var collapsed = shouldCollapse && this.state.collapsed;
                var textHTML = collapsed ? this.getCollapsedTextHTML() : TextFormatting.formatText(this.props.attachment.text || '');
                var collapseMessage = collapsed ? (0, _utils.localizeMessage)('post_attachment.more', 'Show more...') : (0, _utils.localizeMessage)('post_attachment.collapse', 'Show less...');

                text = _react2.default.createElement(
                    'div',
                    { className: 'attachment__text' },
                    (0, _post_utils.messageHtmlToComponent)(textHTML, false),
                    shouldCollapse && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'a',
                            {
                                className: 'attachment-link-more',
                                href: '#',
                                onClick: this.toggleCollapseState
                            },
                            collapseMessage
                        )
                    )
                );
            }

            var image = void 0;
            if (data.image_url) {
                image = _react2.default.createElement('img', {
                    className: 'attachment__image',
                    src: data.image_url
                });
            }

            var thumb = void 0;
            if (data.thumb_url) {
                thumb = _react2.default.createElement(
                    'div',
                    {
                        className: 'attachment__thumb-container'
                    },
                    _react2.default.createElement('img', {
                        src: data.thumb_url
                    })
                );
            }

            var fields = this.getFieldsTable();
            var actions = this.getActionView();

            var useBorderStyle = void 0;
            if (data.color && data.color[0] === '#') {
                useBorderStyle = { borderLeftColor: data.color };
            }

            return _react2.default.createElement(
                'div',
                {
                    className: 'attachment ' + preTextClass,
                    ref: 'attachment'
                },
                preText,
                _react2.default.createElement(
                    'div',
                    { className: 'attachment__content' },
                    _react2.default.createElement(
                        'div',
                        {
                            className: useBorderStyle ? 'clearfix attachment__container' : 'clearfix attachment__container attachment__container--' + data.color,
                            style: useBorderStyle
                        },
                        author,
                        title,
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                {
                                    className: thumb ? 'attachment__body' : 'attachment__body attachment__body--no_thumb'
                                },
                                text,
                                image,
                                fields,
                                actions
                            ),
                            thumb,
                            _react2.default.createElement('div', { style: style.footer })
                        )
                    )
                )
            );
        }
    }]);
    return PostAttachment;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PostAttachment.propTypes = {

    /**
     * The post id
     */
    postId: _propTypes2.default.string.isRequired,

    /**
     * The attachment to render
     */
    attachment: _propTypes2.default.object.isRequired
};
exports.default = PostAttachment;


var style = {
    footer: { clear: 'both' }
};

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _posts = __webpack_require__(808);

var _posts2 = __webpack_require__(805);

var _users = __webpack_require__(777);

var _post_attachment_opengraph = __webpack_require__(2069);

var _post_attachment_opengraph2 = _interopRequireDefault(_post_attachment_opengraph);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        openGraphData: (0, _posts2.getOpenGraphMetadataForUrl)(state, ownProps.link),
        currentUser: (0, _users.getCurrentUser)(state)
    });
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getOpenGraphMetadata: _posts.getOpenGraphMetadata
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_post_attachment_opengraph2.default);

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _global_actions = __webpack_require__(778);

var _post_actions = __webpack_require__(802);

var _commons = __webpack_require__(2070);

var CommonUtils = _interopRequireWildcard(_commons);

var _constants = __webpack_require__(29);

var _url = __webpack_require__(793);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PostAttachmentOpenGraph = function (_React$PureComponent) {
    (0, _inherits3.default)(PostAttachmentOpenGraph, _React$PureComponent);

    function PostAttachmentOpenGraph(props) {
        (0, _classCallCheck3.default)(this, PostAttachmentOpenGraph);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostAttachmentOpenGraph.__proto__ || (0, _getPrototypeOf2.default)(PostAttachmentOpenGraph)).call(this, props));

        _this.getSmallImageContainer = function (node) {
            _this.smallImageContainer = node;
        };

        _this.getSmallImageElement = function (node) {
            _this.smallImageElement = node;
        };

        _this.largeImageMinWidth = 150;
        _this.imageDimentions = { // Image dimentions in pixels.
            height: 80,
            width: 80
        };
        _this.textMaxLenght = 300;
        _this.textEllipsis = '...';
        _this.largeImageMinRatio = 16 / 9;
        _this.smallImageContainerLeftPadding = 15;

        _this.imageRatio = null;

        _this.smallImageContainer = null;
        _this.smallImageElement = null;

        _this.IMAGE_LOADED = {
            LOADING: 'loading',
            YES: 'yes',
            ERROR: 'error'
        };

        _this.fetchData = _this.fetchData.bind(_this);
        _this.toggleImageVisibility = _this.toggleImageVisibility.bind(_this);
        _this.onImageLoad = _this.onImageLoad.bind(_this);
        _this.onImageError = _this.onImageError.bind(_this);
        _this.handleRemovePreview = _this.handleRemovePreview.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PostAttachmentOpenGraph, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var removePreview = this.isRemovePreview(this.props.post, this.props.currentUser);

            this.setState({
                imageLoaded: this.IMAGE_LOADED.LOADING,
                imageVisible: this.props.previewCollapsed.startsWith('false'),
                hasLargeImage: false,
                removePreview: removePreview
            });
            this.fetchData(this.props.link);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!Utils.areObjectsEqual(nextProps.post, this.props.post)) {
                var removePreview = this.isRemovePreview(nextProps.post, nextProps.currentUser);
                this.setState({
                    removePreview: removePreview
                });
            }
            if (nextProps.link !== this.props.link) {
                this.fetchData(nextProps.link);
            }
            if (nextProps.previewCollapsed !== this.props.previewCollapsed) {
                this.setState({
                    imageVisible: nextProps.previewCollapsed.startsWith('false')
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            setTimeout(_global_actions.postListScrollChange, 0);
        }
    }, {
        key: 'fetchData',
        value: function fetchData(url) {
            if (!this.props.openGraphData) {
                this.props.actions.getOpenGraphMetadata(url);
            }
        }
    }, {
        key: 'getBestImageUrl',
        value: function getBestImageUrl(data) {
            if (Utils.isEmptyObject(data.images)) {
                return null;
            }

            var bestImage = CommonUtils.getNearestPoint(this.imageDimentions, data.images, 'width', 'height');
            return bestImage.secure_url || bestImage.url;
        }
    }, {
        key: 'toggleImageVisibility',
        value: function toggleImageVisibility() {
            this.setState({ imageVisible: !this.state.imageVisible });
        }
    }, {
        key: 'onImageLoad',
        value: function onImageLoad(image) {
            this.imageRatio = image.target.naturalWidth / image.target.naturalHeight;
            if (image.target.naturalWidth >= this.largeImageMinWidth && this.imageRatio >= this.largeImageMinRatio && !this.state.hasLargeImage) {
                this.setState({
                    hasLargeImage: true
                });
            }
            this.setState({
                imageLoaded: this.IMAGE_LOADED.YES
            });
        }
    }, {
        key: 'onImageError',
        value: function onImageError() {
            this.setState({ imageLoaded: this.IMAGE_LOADED.ERROR });
        }
    }, {
        key: 'loadImage',
        value: function loadImage(src) {
            var img = new Image();
            img.onload = this.onImageLoad;
            img.onerror = this.onImageError;
            img.src = src;
        }
    }, {
        key: 'imageToggleAnchoreTag',
        value: function imageToggleAnchoreTag(imageUrl) {
            if (imageUrl && this.state.hasLargeImage) {
                return _react2.default.createElement('a', {
                    className: 'post__embed-visibility',
                    'data-expanded': this.state.imageVisible,
                    'aria-label': 'Toggle Embed Visibility',
                    onClick: this.toggleImageVisibility
                });
            }
            return null;
        }
    }, {
        key: 'wrapInSmallImageContainer',
        value: function wrapInSmallImageContainer(imageElement) {
            return _react2.default.createElement(
                'div',
                {
                    className: 'attachment__image__container--openraph',
                    ref: this.getSmallImageContainer
                },
                imageElement
            );
        }
    }, {
        key: 'imageTag',
        value: function imageTag(imageUrl) {
            var renderingForLargeImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var element = null;
            if (imageUrl && renderingForLargeImage === this.state.hasLargeImage && (!renderingForLargeImage || renderingForLargeImage && this.state.imageVisible)) {
                if (this.state.imageLoaded === this.IMAGE_LOADED.LOADING) {
                    if (renderingForLargeImage) {
                        element = _react2.default.createElement('img', { className: 'attachment__image attachment__image--openraph loading large_image' });
                    } else {
                        element = this.wrapInSmallImageContainer(_react2.default.createElement('img', { className: 'attachment__image attachment__image--openraph loading ' }));
                    }
                } else if (this.state.imageLoaded === this.IMAGE_LOADED.YES) {
                    if (renderingForLargeImage) {
                        element = _react2.default.createElement('img', {
                            className: 'attachment__image attachment__image--openraph large_image',
                            src: imageUrl
                        });
                    } else {
                        element = this.wrapInSmallImageContainer(_react2.default.createElement('img', {
                            className: 'attachment__image attachment__image--openraph',
                            src: imageUrl,
                            ref: this.getSmallImageElement
                        }));
                    }
                } else if (this.state.imageLoaded === this.IMAGE_LOADED.ERROR) {
                    return null;
                }
            }
            return element;
        }
    }, {
        key: 'truncateText',
        value: function truncateText(text) {
            var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.textMaxLenght;
            var ellipsis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.textEllipsis;

            if (text.length > maxLength) {
                return text.substring(0, maxLength - ellipsis.length) + ellipsis;
            }
            return text;
        }
    }, {
        key: 'handleRemovePreview',
        value: function handleRemovePreview() {
            var _this2 = this;

            var props = (0, _assign2.default)({}, this.props.post.props);
            props[_constants.PostTypes.REMOVE_LINK_PREVIEW] = 'true';

            var patchedPost = {
                id: this.props.post.id,
                props: props
            };

            (0, _post_actions.updatePost)(patchedPost, function () {
                _this2.setState({ removePreview: true });
            });
        }
    }, {
        key: 'isRemovePreview',
        value: function isRemovePreview(post, currentUser) {
            if (post && post.props && currentUser.id === post.user_id) {
                return post.props[_constants.PostTypes.REMOVE_LINK_PREVIEW] && post.props[_constants.PostTypes.REMOVE_LINK_PREVIEW] === 'true';
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var data = this.props.openGraphData;
            if (!data || Utils.isEmptyObject(data.description) || this.state.removePreview) {
                return null;
            }

            var removePreviewButton = void 0;
            if (this.props.currentUser.id === this.props.post.user_id) {
                removePreviewButton = _react2.default.createElement(
                    'button',
                    {
                        id: 'removePreviewButton',
                        type: 'button',
                        className: 'btn-close',
                        'aria-label': 'Close',
                        onClick: this.handleRemovePreview
                    },
                    _react2.default.createElement(
                        'span',
                        { 'aria-hidden': 'true' },
                        '×'
                    )
                );
            }

            var imageUrl = this.getBestImageUrl(data);
            if (imageUrl) {
                this.loadImage(imageUrl);
            }

            return _react2.default.createElement(
                'div',
                {
                    className: 'attachment attachment--opengraph',
                    ref: 'attachment'
                },
                _react2.default.createElement(
                    'div',
                    { className: 'attachment__content' },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'clearfix attachment__container attachment__container--opengraph'
                        },
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'attachment__body__wrap attachment__body__wrap--opengraph'
                            },
                            _react2.default.createElement(
                                'span',
                                { className: 'sitename' },
                                this.truncateText(data.site_name)
                            ),
                            removePreviewButton,
                            _react2.default.createElement(
                                'h1',
                                {
                                    className: 'attachment__title attachment__title--opengraph' + (data.title ? '' : ' is-url')
                                },
                                _react2.default.createElement(
                                    'a',
                                    {
                                        className: 'attachment__title-link attachment__title-link--opengraph',
                                        href: (0, _url.useSafeUrl)(data.url || this.props.link),
                                        target: '_blank',
                                        rel: 'noopener noreferrer',
                                        title: data.title || data.url || this.props.link
                                    },
                                    this.truncateText(data.title || data.url || this.props.link)
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'attachment__body attachment__body--opengraph'
                                    },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            this.truncateText(data.description),
                                            ' \xA0',
                                            this.imageToggleAnchoreTag(imageUrl)
                                        ),
                                        this.imageTag(imageUrl, true)
                                    )
                                )
                            )
                        ),
                        this.imageTag(imageUrl, false)
                    )
                )
            );
        }
    }]);
    return PostAttachmentOpenGraph;
}(_react2.default.PureComponent);

PostAttachmentOpenGraph.propTypes = {

    /**
     * The link to display the open graph data for
     */
    link: _propTypes2.default.string.isRequired,

    /**
     * The current user viewing the post
     */
    currentUser: _propTypes2.default.object,

    /**
     * The post where this link is included
     */
    post: _propTypes2.default.object,

    /**
     * The open graph data to render
     */
    openGraphData: _propTypes2.default.object,

    /**
     * Set to collapse the preview
     */
    previewCollapsed: _propTypes2.default.string,
    actions: _propTypes2.default.shape({

        /**
         * The function to get open graph data for a link
         */
        getOpenGraphMetadata: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = PostAttachmentOpenGraph;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.getDistanceBW2Points = getDistanceBW2Points;
exports.getNearestPoint = getNearestPoint;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getDistanceBW2Points(point1, point2) {
    var xAttr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
    var yAttr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'y';

    return Math.sqrt(Math.pow(point1[xAttr] - point2[xAttr], 2) + Math.pow(point1[yAttr] - point2[yAttr], 2));
}

/**
  * Funtion to return nearest point of given pivot point.
  * It return two points one nearest and other nearest but having both coorditanes smaller than the given point's coordinates.
  */
function getNearestPoint(pivotPoint, points) {
    var xAttr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
    var yAttr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'y';

    var nearestPoint = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(points), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var point = _step.value;

            if (typeof nearestPoint[xAttr] === 'undefined' || typeof nearestPoint[yAttr] === 'undefined') {
                nearestPoint = point;
            } else if (getDistanceBW2Points(point, pivotPoint, xAttr, yAttr) < getDistanceBW2Points(nearestPoint, pivotPoint, xAttr, yAttr)) {
                // Check for bestImage
                nearestPoint = point;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return nearestPoint;
}

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _post_image = __webpack_require__(2072);

var _post_image2 = _interopRequireDefault(_post_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var hasImageProxy = config.HasImageProxy === 'true';

    return {
        hasImageProxy: hasImageProxy
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_post_image2.default);

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _global_actions = __webpack_require__(778);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PostImageEmbed = function (_React$PureComponent) {
    (0, _inherits3.default)(PostImageEmbed, _React$PureComponent);

    function PostImageEmbed(props) {
        (0, _classCallCheck3.default)(this, PostImageEmbed);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostImageEmbed.__proto__ || (0, _getPrototypeOf2.default)(PostImageEmbed)).call(this, props));

        _this.onImageClick = function (e) {
            e.preventDefault();
            _this.props.handleImageClick();
        };

        _this.handleLoadComplete = _this.handleLoadComplete.bind(_this);
        _this.handleLoadError = _this.handleLoadError.bind(_this);

        _this.state = {
            loaded: false,
            errored: false
        };
        return _this;
    }

    (0, _createClass3.default)(PostImageEmbed, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.loadImg(this.props.link);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.link !== this.props.link) {
                this.setState({
                    loaded: false,
                    errored: false
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!this.state.loaded && prevProps.link !== this.props.link) {
                this.loadImg(this.props.link);
            }
        }
    }, {
        key: 'loadImg',
        value: function loadImg(src) {
            var img = new Image();
            img.onload = this.handleLoadComplete;
            img.onerror = this.handleLoadError;
            img.src = PostUtils.getImageSrc(src, this.props.hasImageProxy);
        }
    }, {
        key: 'handleLoadComplete',
        value: function handleLoadComplete() {
            this.setState({
                loaded: true,
                errored: false
            });

            (0, _global_actions.postListScrollChange)();

            if (this.props.onLinkLoaded) {
                this.props.onLinkLoaded();
            }
        }
    }, {
        key: 'handleLoadError',
        value: function handleLoadError() {
            this.setState({
                errored: true,
                loaded: true
            });
            if (this.props.onLinkLoadError) {
                this.props.onLinkLoadError();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.errored || !this.state.loaded) {
                // scroll pop could be improved with a placeholder when !this.state.loaded
                return null;
            }

            return _react2.default.createElement(
                'div',
                {
                    className: 'post__embed-container'
                },
                _react2.default.createElement('img', {
                    onClick: this.onImageClick,
                    className: 'img-div cursor--pointer',
                    src: PostUtils.getImageSrc(this.props.link, this.props.hasImageProxy)
                })
            );
        }
    }]);
    return PostImageEmbed;
}(_react2.default.PureComponent);

PostImageEmbed.propTypes = {

    /**
     * The link to load the image from
     */
    link: _propTypes2.default.string.isRequired,

    /**
     * Function to call when image is loaded
     */
    onLinkLoaded: _propTypes2.default.func,

    /**
     * The function to call if image load fails
     */
    onLinkLoadError: _propTypes2.default.func,

    /**
     * The function to call if image is clicked
     */
    handleImageClick: _propTypes2.default.func,

    /**
     * If an image proxy is enabled.
     */
    hasImageProxy: _propTypes2.default.bool.isRequired
};
exports.default = PostImageEmbed;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _post_markdown = __webpack_require__(1312);

var _post_markdown2 = _interopRequireDefault(_post_markdown);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostMessageView = function (_React$PureComponent) {
    (0, _inherits3.default)(PostMessageView, _React$PureComponent);

    function PostMessageView() {
        (0, _classCallCheck3.default)(this, PostMessageView);
        return (0, _possibleConstructorReturn3.default)(this, (PostMessageView.__proto__ || (0, _getPrototypeOf2.default)(PostMessageView)).apply(this, arguments));
    }

    (0, _createClass3.default)(PostMessageView, [{
        key: 'renderDeletedPost',
        value: function renderDeletedPost() {
            return _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'post_body.deleted',
                    defaultMessage: '(message deleted)'
                })
            );
        }
    }, {
        key: 'renderEditedIndicator',
        value: function renderEditedIndicator() {
            if (!PostUtils.isEdited(this.props.post)) {
                return null;
            }

            return _react2.default.createElement(
                'span',
                { className: 'post-edited__indicator' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'post_message_view.edited',
                    defaultMessage: '(edited)'
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                post = _props.post,
                enableFormatting = _props.enableFormatting,
                options = _props.options,
                pluginPostTypes = _props.pluginPostTypes,
                compactDisplay = _props.compactDisplay,
                isRHS = _props.isRHS,
                theme = _props.theme,
                lastPostCount = _props.lastPostCount;


            if (post.state === _constants.Posts.POST_DELETED) {
                return this.renderDeletedPost();
            }

            if (!enableFormatting) {
                return _react2.default.createElement(
                    'span',
                    null,
                    post.message
                );
            }

            var postType = post.type;
            if (postType) {
                if (pluginPostTypes.hasOwnProperty(postType)) {
                    var PluginComponent = pluginPostTypes[postType].component;
                    return _react2.default.createElement(PluginComponent, {
                        post: post,
                        compactDisplay: compactDisplay,
                        isRHS: isRHS,
                        theme: theme
                    });
                }
            }

            var postId = null;
            if (lastPostCount >= 0) {
                postId = Utils.createSafeId('lastPostMessageText' + lastPostCount);
            }

            var message = post.message;
            var isEphemeral = Utils.isPostEphemeral(post);
            if (compactDisplay && isEphemeral) {
                var visibleMessage = Utils.localizeMessage('post_info.message.visible.compact', ' (Only visible to you)');
                message = message.concat(visibleMessage);
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'span',
                    {
                        id: postId,
                        className: 'post-message__text',
                        onClick: Utils.handleFormattedTextClick
                    },
                    _react2.default.createElement(_post_markdown2.default, {
                        message: message,
                        isRHS: isRHS,
                        options: options,
                        post: post
                    })
                ),
                this.renderEditedIndicator()
            );
        }
    }]);
    return PostMessageView;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PostMessageView.propTypes = {

    /*
     * The post to render the message for
     */
    post: _propTypes2.default.object.isRequired,

    /*
     * Set to enable Markdown formatting
     */
    enableFormatting: _propTypes2.default.bool,

    /*
     * Options specific to text formatting
     */
    options: _propTypes2.default.object,

    /*
     * Post identifiers for selenium tests
     */
    lastPostCount: _propTypes2.default.number,

    /**
     * Set to render post body compactly
     */
    compactDisplay: _propTypes2.default.bool,

    /**
     * Flags if the post_message_view is for the RHS (Reply).
     */
    isRHS: _propTypes2.default.bool,

    /*
     * Logged in user's theme
     */
    theme: _propTypes2.default.object.isRequired,

    /*
     * Post type components from plugins
     */
    pluginPostTypes: _propTypes2.default.object
};
PostMessageView.defaultProps = {
    options: {},
    isRHS: false,
    pluginPostTypes: {}
};
exports.default = PostMessageView;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _rhs = __webpack_require__(817);

var _rhs_header_post = __webpack_require__(2075);

var _rhs_header_post2 = _interopRequireDefault(_rhs_header_post);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            showSearchResults: _rhs.showSearchResults,
            showMentions: _rhs.showMentions,
            showFlaggedPosts: _rhs.showFlaggedPosts,
            showPinnedPosts: _rhs.showPinnedPosts,
            closeRightHandSide: _rhs.closeRightHandSide
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_rhs_header_post2.default);

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RhsHeaderPost = function (_React$Component) {
    (0, _inherits3.default)(RhsHeaderPost, _React$Component);

    function RhsHeaderPost(props) {
        (0, _classCallCheck3.default)(this, RhsHeaderPost);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RhsHeaderPost.__proto__ || (0, _getPrototypeOf2.default)(RhsHeaderPost)).call(this, props));

        _this.handleClose = function (e) {
            e.preventDefault();
            _this.props.actions.closeRightHandSide();
            _this.props.shrink();
        };

        _this.toggleSize = function (e) {
            e.preventDefault();
            _this.props.toggleSize();
        };

        _this.handleBack = function (e) {
            e.preventDefault();

            if (_this.props.isWebrtc) {
                _this.props.actions.showSearchResults();
                return;
            }

            switch (_this.props.previousRhsState) {
                case _constants.RHSStates.SEARCH:
                    _this.props.actions.showSearchResults();
                    break;
                case _constants.RHSStates.MENTION:
                    _this.props.actions.showMentions();
                    break;
                case _constants.RHSStates.FLAG:
                    _this.props.actions.showFlaggedPosts();
                    break;
                case _constants.RHSStates.PIN:
                    _this.props.actions.showPinnedPosts();
                    break;
                default:
                    break;
            }
        };

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(RhsHeaderPost, [{
        key: 'render',
        value: function render() {
            var back = void 0;
            var closeSidebarTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'closeSidebarTooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'rhs_header.closeSidebarTooltip',
                    defaultMessage: 'Close Sidebar'
                })
            );

            var backToResultsTooltip = void 0;

            switch (this.props.previousRhsState) {
                case _constants.RHSStates.SEARCH:
                case _constants.RHSStates.MENTION:
                    backToResultsTooltip = _react2.default.createElement(
                        _reactBootstrap.Tooltip,
                        { id: 'backToResultsTooltip' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'rhs_header.backToResultsTooltip',
                            defaultMessage: 'Back to Search Results'
                        })
                    );
                    break;
                case _constants.RHSStates.FLAG:
                    backToResultsTooltip = _react2.default.createElement(
                        _reactBootstrap.Tooltip,
                        { id: 'backToResultsTooltip' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'rhs_header.backToFlaggedTooltip',
                            defaultMessage: 'Back to Flagged Posts'
                        })
                    );
                    break;
                case _constants.RHSStates.PIN:
                    backToResultsTooltip = _react2.default.createElement(
                        _reactBootstrap.Tooltip,
                        { id: 'backToResultsTooltip' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'rhs_header.backToPinnedTooltip',
                            defaultMessage: 'Back to Pinned Posts'
                        })
                    );
                    break;
                default:
                    if (this.props.isWebrtc) {
                        backToResultsTooltip = _react2.default.createElement(
                            _reactBootstrap.Tooltip,
                            { id: 'backToResultsTooltip' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'rhs_header.backToCallTooltip',
                                defaultMessage: 'Back to Call'
                            })
                        );
                    }
                    break;
            }

            var expandSidebarTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'expandSidebarTooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'rhs_header.expandSidebarTooltip',
                    defaultMessage: 'Expand Sidebar'
                })
            );

            var shrinkSidebarTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'shrinkSidebarTooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'rhs_header.shrinkSidebarTooltip',
                    defaultMessage: 'Shrink Sidebar'
                })
            );

            if (backToResultsTooltip) {
                back = _react2.default.createElement(
                    'a',
                    {
                        href: '#',
                        onClick: this.handleBack,
                        className: 'sidebar--right__back'
                    },
                    _react2.default.createElement(
                        _reactBootstrap.OverlayTrigger,
                        {
                            trigger: ['hover', 'focus'],
                            delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                            placement: 'top',
                            overlay: backToResultsTooltip
                        },
                        _react2.default.createElement('i', { className: 'fa fa-angle-left' })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'sidebar--right__header' },
                _react2.default.createElement(
                    'span',
                    { className: 'sidebar--right__title' },
                    back,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'rhs_header.details',
                        defaultMessage: 'Message Details'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pull-right' },
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'sidebar--right__expand',
                            'aria-label': 'Expand',
                            onClick: this.toggleSize
                        },
                        _react2.default.createElement(
                            _reactBootstrap.OverlayTrigger,
                            {
                                trigger: ['hover', 'focus'],
                                delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                placement: 'top',
                                overlay: expandSidebarTooltip
                            },
                            _react2.default.createElement('i', { className: 'fa fa-expand' })
                        ),
                        _react2.default.createElement(
                            _reactBootstrap.OverlayTrigger,
                            {
                                trigger: ['hover', 'focus'],
                                delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                placement: 'top',
                                overlay: shrinkSidebarTooltip
                            },
                            _react2.default.createElement('i', { className: 'fa fa-compress' })
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'sidebar--right__close',
                            'aria-label': 'Close',
                            onClick: this.handleClose
                        },
                        _react2.default.createElement(
                            _reactBootstrap.OverlayTrigger,
                            {
                                trigger: ['hover', 'focus'],
                                delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                placement: 'top',
                                overlay: closeSidebarTooltip
                            },
                            _react2.default.createElement('i', { className: 'fa fa-sign-out' })
                        )
                    )
                )
            );
        }
    }]);
    return RhsHeaderPost;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

RhsHeaderPost.propTypes = {
    isWebrtc: _propTypes2.default.bool,
    previousRhsState: _propTypes2.default.oneOf((0, _values2.default)(_constants.RHSStates)),
    toggleSize: _propTypes2.default.func,
    shrink: _propTypes2.default.func,
    actions: _propTypes2.default.shape({
        showMentions: _propTypes2.default.func,
        showSearchResults: _propTypes2.default.func,
        showFlaggedPosts: _propTypes2.default.func,
        showPinnedPosts: _propTypes2.default.func,
        closeRightHandSide: _propTypes2.default.func
    })
};
exports.default = RhsHeaderPost;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(783);

var _teams = __webpack_require__(274);

var _general = __webpack_require__(113);

var _rhs_root_post = __webpack_require__(2077);

var _rhs_root_post2 = _interopRequireDefault(_rhs_root_post);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var config = (0, _general.getConfig)(state);
    var enableEmojiPicker = config.EnableEmojiPicker === 'true';
    var enablePostUsernameOverride = config.EnablePostUsernameOverride === 'true';
    var teamId = ownProps.teamId || (0, _teams.getCurrentTeamId)(state);

    return {
        enableEmojiPicker: enableEmojiPicker,
        enablePostUsernameOverride: enablePostUsernameOverride,
        isReadOnly: (0, _channels.isChannelReadOnlyById)(state, ownProps.post.channel_id),
        teamId: teamId,
        pluginPostTypes: state.plugins.postTypes
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_rhs_root_post2.default);

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _post_utils = __webpack_require__(281);

var ReduxPostUtils = _interopRequireWildcard(_post_utils);

var _permissions = __webpack_require__(279);

var _permissions2 = _interopRequireDefault(_permissions);

var _post_actions = __webpack_require__(802);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _post_utils2 = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils2);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _dot_menu = __webpack_require__(970);

var _dot_menu2 = _interopRequireDefault(_dot_menu);

var _emoji_picker_overlay = __webpack_require__(883);

var _emoji_picker_overlay2 = _interopRequireDefault(_emoji_picker_overlay);

var _file_attachment_list = __webpack_require__(971);

var _file_attachment_list2 = _interopRequireDefault(_file_attachment_list);

var _post_flag_icon = __webpack_require__(973);

var _post_flag_icon2 = _interopRequireDefault(_post_flag_icon);

var _reaction_list = __webpack_require__(1044);

var _reaction_list2 = _interopRequireDefault(_reaction_list);

var _post_time = __webpack_require__(975);

var _post_time2 = _interopRequireDefault(_post_time);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

var _emoji_icon = __webpack_require__(909);

var _emoji_icon2 = _interopRequireDefault(_emoji_icon);

var _mattermost_logo = __webpack_require__(976);

var _mattermost_logo2 = _interopRequireDefault(_mattermost_logo);

var _channel_permission_gate = __webpack_require__(888);

var _channel_permission_gate2 = _interopRequireDefault(_channel_permission_gate);

var _message_with_additional_content = __webpack_require__(1328);

var _message_with_additional_content2 = _interopRequireDefault(_message_with_additional_content);

var _user_profile = __webpack_require__(933);

var _user_profile2 = _interopRequireDefault(_user_profile);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RhsRootPost = function (_React$Component) {
    (0, _inherits3.default)(RhsRootPost, _React$Component);

    function RhsRootPost(props) {
        (0, _classCallCheck3.default)(this, RhsRootPost);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RhsRootPost.__proto__ || (0, _getPrototypeOf2.default)(RhsRootPost)).call(this, props));

        _this.renderPostTime = function (isEphemeral) {
            var post = _this.props.post;

            if (post.type === _constants3.default.PostTypes.FAKE_PARENT_DELETED) {
                return null;
            }

            var isPermalink = !(isEphemeral || _constants.Posts.POST_DELETED === post.state || ReduxPostUtils.isPostPendingOrFailed(post));

            return _react2.default.createElement(_post_time2.default, {
                isPermalink: isPermalink,
                eventTime: post.create_at,
                postId: post.id
            });
        };

        _this.toggleEmojiPicker = function () {
            var showEmojiPicker = !_this.state.showEmojiPicker;

            _this.setState({
                showEmojiPicker: showEmojiPicker,
                dropdownOpened: showEmojiPicker
            });
        };

        _this.reactEmojiClick = function (emoji) {
            _this.setState({ showEmojiPicker: false });
            var emojiName = emoji.name || emoji.aliases[0];
            (0, _post_actions.addReaction)(_this.props.post.channel_id, _this.props.post.id, emojiName);
            (0, _post_actions.emitEmojiPosted)(emojiName);
            _this.handleDropdownOpened(false);
        };

        _this.getClassName = function (post, isSystemMessage) {
            var className = 'post post--root post--thread';
            if (_user_store2.default.getCurrentId() === post.user_id) {
                className += ' current--user';
            }

            if (isSystemMessage) {
                className += ' post--system';
            }

            if (_this.props.compactDisplay) {
                className += ' post--compact';
            }

            if (post.is_pinned) {
                className += ' post--pinned';
            }

            if (_this.state.dropdownOpened) {
                className += ' post--hovered';
            }

            return className;
        };

        _this.handleDropdownOpened = function (isOpened) {
            _this.setState({
                dropdownOpened: isOpened
            });
        };

        _this.getDotMenuRef = function () {
            return _this.refs.dotMenu;
        };

        _this.state = {
            currentTeamDisplayName: _team_store2.default.getCurrent().name,
            showEmojiPicker: false,
            testStateObj: true,
            dropdownOpened: false
        };
        return _this;
    }

    (0, _createClass3.default)(RhsRootPost, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (nextProps.status !== this.props.status) {
                return true;
            }

            if (nextProps.isBusy !== this.props.isBusy) {
                return true;
            }

            if (nextProps.compactDisplay !== this.props.compactDisplay) {
                return true;
            }

            if (nextProps.isFlagged !== this.props.isFlagged) {
                return true;
            }

            if (nextProps.isEmbedVisible !== this.props.isEmbedVisible) {
                return true;
            }

            if (nextProps.previewEnabled !== this.props.previewEnabled) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextProps.post, this.props.post)) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextProps.user, this.props.user)) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextProps.currentUser, this.props.currentUser)) {
                return true;
            }

            if (this.state.showEmojiPicker !== nextState.showEmojiPicker) {
                return true;
            }

            if (this.state.dropdownOpened !== nextState.dropdownOpened) {
                return true;
            }

            if (this.props.previewCollapsed !== nextProps.previewCollapsed) {
                return true;
            }

            if (this.state.width !== nextState.width || this.state.height !== nextState.height) {
                return true;
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                post = _props.post,
                user = _props.user,
                isReadOnly = _props.isReadOnly,
                teamId = _props.teamId;

            var channel = _channel_store2.default.get(post.channel_id);

            var isEphemeral = Utils.isPostEphemeral(post);
            var isSystemMessage = PostUtils.isSystemMessage(post);

            var channelName;
            if (channel) {
                if (channel.type === 'D') {
                    channelName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'rhs_root.direct',
                        defaultMessage: 'Direct Message'
                    });
                } else {
                    channelName = channel.display_name;
                }
            }

            var react = void 0;

            if (!isReadOnly && !isEphemeral && !post.failed && !isSystemMessage && this.props.enableEmojiPicker) {
                react = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_emoji_picker_overlay2.default, {
                        show: this.state.showEmojiPicker,
                        onHide: this.toggleEmojiPicker,
                        target: this.getDotMenuRef,
                        onEmojiClick: this.reactEmojiClick,
                        rightOffset: 15,
                        spaceRequiredAbove: 342,
                        spaceRequiredBelow: 342
                    }),
                    _react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: post.channel_id,
                            teamId: teamId,
                            permissions: [_permissions2.default.ADD_REACTION]
                        },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'reacticon__container reaction color--link style--none',
                                onClick: this.toggleEmojiPicker,
                                ref: 'rhs_root_reacticon'
                            },
                            _react2.default.createElement(_emoji_icon2.default, { className: 'icon icon--emoji' })
                        )
                    )
                );
            }

            var fileAttachment = null;
            if (post.file_ids && post.file_ids.length > 0) {
                fileAttachment = _react2.default.createElement(_file_attachment_list2.default, {
                    post: post,
                    compactDisplay: this.props.compactDisplay
                });
            }

            var userProfile = void 0;
            var botIndicator = void 0;
            if (isSystemMessage) {
                userProfile = _react2.default.createElement(_user_profile2.default, {
                    user: {},
                    overwriteName: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_info.system',
                        defaultMessage: 'System'
                    }),
                    overwriteImage: _constants3.default.SYSTEM_MESSAGE_PROFILE_IMAGE,
                    disablePopover: true
                });
            } else if (post.props && post.props.from_webhook) {
                if (post.props.override_username && this.props.enablePostUsernameOverride) {
                    userProfile = _react2.default.createElement(_user_profile2.default, {
                        user: user,
                        overwriteName: post.props.override_username,
                        disablePopover: true
                    });
                } else {
                    userProfile = _react2.default.createElement(_user_profile2.default, {
                        user: user,
                        disablePopover: true
                    });
                }

                botIndicator = _react2.default.createElement(
                    'div',
                    { className: 'col col__name bot-indicator' },
                    'BOT'
                );
            } else {
                userProfile = _react2.default.createElement(_user_profile2.default, {
                    user: user,
                    status: this.props.status,
                    isBusy: this.props.isBusy,
                    isRHS: true,
                    hasMention: true
                });
            }

            var status = this.props.status;
            if (post.props && post.props.from_webhook === 'true') {
                status = null;
            }

            var profilePic = void 0;
            if (isSystemMessage) {
                profilePic = _react2.default.createElement(_mattermost_logo2.default, { className: 'icon' });
            } else if (post.props && post.props.from_webhook) {
                profilePic = _react2.default.createElement(_profile_picture2.default, {
                    src: PostUtils.getProfilePicSrcForPost(post, user),
                    width: '36',
                    height: '36'
                });
            } else {
                profilePic = _react2.default.createElement(_profile_picture2.default, {
                    src: PostUtils.getProfilePicSrcForPost(post, user),
                    status: status,
                    width: '36',
                    height: '36',
                    user: this.props.user,
                    isBusy: this.props.isBusy,
                    isRHS: true,
                    hasMention: true
                });
            }

            if (this.props.compactDisplay) {
                if (post.props && post.props.from_webhook) {
                    profilePic = _react2.default.createElement(_profile_picture2.default, {
                        src: ''
                    });
                } else {
                    profilePic = _react2.default.createElement(_profile_picture2.default, {
                        src: '',
                        status: status,
                        user: this.props.user,
                        isBusy: this.props.isBusy,
                        isRHS: true,
                        hasMention: true
                    });
                }
            }

            var postClass = '';
            if (PostUtils.isEdited(this.props.post)) {
                postClass += ' post--edited';
            }

            var profilePicContainer = _react2.default.createElement(
                'div',
                { className: 'post__img' },
                profilePic
            );

            var pinnedBadge = void 0;
            if (post.is_pinned) {
                pinnedBadge = _react2.default.createElement(
                    'span',
                    { className: 'post__pinned-badge' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_info.pinned',
                        defaultMessage: 'Pinned'
                    })
                );
            }

            var dotMenu = _react2.default.createElement(_dot_menu2.default, {
                idPrefix: _constants3.default.RHS_ROOT,
                post: this.props.post,
                isFlagged: this.props.isFlagged,
                handleDropdownOpened: this.handleDropdownOpened,
                commentCount: this.props.commentCount,
                isReadOnly: isReadOnly
            });

            var dotMenuContainer = void 0;
            if (this.props.post.type !== _constants3.default.PostTypes.FAKE_PARENT_DELETED) {
                dotMenuContainer = _react2.default.createElement(
                    'div',
                    {
                        ref: 'dotMenu',
                        className: 'col col__reply'
                    },
                    dotMenu,
                    react
                );
            }

            var postFlagIcon = void 0;
            if (this.props.post.type !== _constants3.default.PostTypes.FAKE_PARENT_DELETED) {
                postFlagIcon = _react2.default.createElement(_post_flag_icon2.default, {
                    idPrefix: 'rhsRootPostFlag',
                    postId: post.id,
                    isFlagged: this.props.isFlagged
                });
            }

            return _react2.default.createElement(
                'div',
                {
                    id: 'thread--root',
                    className: this.getClassName(post, isSystemMessage)
                },
                _react2.default.createElement(
                    'div',
                    { className: 'post-right-channel__name' },
                    channelName
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'post__content' },
                    profilePicContainer,
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'post__header' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col__name' },
                                userProfile
                            ),
                            botIndicator,
                            _react2.default.createElement(
                                'div',
                                { className: 'col' },
                                this.renderPostTime(isEphemeral),
                                pinnedBadge,
                                postFlagIcon
                            ),
                            dotMenuContainer
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'post__body' },
                            _react2.default.createElement(
                                'div',
                                { className: postClass },
                                _react2.default.createElement(_message_with_additional_content2.default, {
                                    post: post,
                                    previewCollapsed: this.props.previewCollapsed,
                                    previewEnabled: this.props.previewEnabled,
                                    isEmbedVisible: this.props.isEmbedVisible,
                                    pluginPostTypes: this.props.pluginPostTypes
                                })
                            ),
                            fileAttachment,
                            _react2.default.createElement(_reaction_list2.default, {
                                post: post,
                                isReadOnly: isReadOnly
                            })
                        )
                    )
                )
            );
        }
    }]);
    return RhsRootPost;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

RhsRootPost.propTypes = {
    post: _propTypes2.default.object.isRequired,
    user: _propTypes2.default.object.isRequired,
    teamId: _propTypes2.default.string.isRequired,
    currentUser: _propTypes2.default.object.isRequired,
    compactDisplay: _propTypes2.default.bool,
    commentCount: _propTypes2.default.number.isRequired,
    isFlagged: _propTypes2.default.bool,
    status: _propTypes2.default.string,
    previewCollapsed: _propTypes2.default.string,
    previewEnabled: _propTypes2.default.bool,
    isBusy: _propTypes2.default.bool,
    isEmbedVisible: _propTypes2.default.bool,
    enableEmojiPicker: _propTypes2.default.bool.isRequired,
    enablePostUsernameOverride: _propTypes2.default.bool.isRequired,
    isReadOnly: _propTypes2.default.bool.isRequired,
    pluginPostTypes: _propTypes2.default.object
};
RhsRootPost.defaultProps = {
    commentCount: 0
};
exports.default = RhsRootPost;

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _search_channel_provider = __webpack_require__(2079);

var _search_channel_provider2 = _interopRequireDefault(_search_channel_provider);

var _search_suggestion_list = __webpack_require__(2080);

var _search_suggestion_list2 = _interopRequireDefault(_search_suggestion_list);

var _search_user_provider = __webpack_require__(2081);

var _search_user_provider2 = _interopRequireDefault(_search_user_provider);

var _suggestion_box = __webpack_require__(929);

var _suggestion_box2 = _interopRequireDefault(_suggestion_box);

var _header_icon_wrapper = __webpack_require__(1329);

var _header_icon_wrapper2 = _interopRequireDefault(_header_icon_wrapper);

var _flag_icon = __webpack_require__(974);

var _flag_icon2 = _interopRequireDefault(_flag_icon);

var _mentions_icon = __webpack_require__(1330);

var _mentions_icon2 = _interopRequireDefault(_mentions_icon);

var _search_icon = __webpack_require__(1048);

var _search_icon2 = _interopRequireDefault(_search_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var KeyCodes = _constants2.default.KeyCodes;

var SearchBar = function (_React$Component) {
    (0, _inherits3.default)(SearchBar, _React$Component);

    function SearchBar() {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, SearchBar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchBar.__proto__ || (0, _getPrototypeOf2.default)(SearchBar)).call(this));

        _this.handleClose = function () {
            _this.props.actions.closeWebrtc();
            _this.props.actions.closeRightHandSide();
        };

        _this.handleKeyDown = function (e) {
            if (Utils.isKeyPressed(e, KeyCodes.ESCAPE)) {
                e.stopPropagation();
                e.preventDefault();
            }
        };

        _this.handleChange = function (e) {
            var term = e.target.value;
            _this.props.actions.updateSearchTerms(term);
        };

        _this.handleUserBlur = function () {
            // add time out so that the pinned and member buttons are clickable
            // when focus is released from the search box.
            setTimeout(function () {
                _this.setState({ focused: false });
            }, 100);
        };

        _this.handleClear = function () {
            _this.props.actions.updateSearchTerms('');
        };

        _this.handleUserFocus = function () {
            _this.setState({ focused: true });
        };

        _this.handleSearch = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(terms) {
                var _ref2, error;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!terms.length) {
                                    _context.next = 7;
                                    break;
                                }

                                _this.setState({
                                    isPristine: false
                                });

                                _context.next = 4;
                                return _this.props.actions.showSearchResults();

                            case 4:
                                _ref2 = _context.sent;
                                error = _ref2.error;


                                if (!error) {
                                    _this.handleSearchOnSuccess();
                                }

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.handleSearchOnSuccess = function () {
            if (Utils.isMobile() && _this.search) {
                _this.search.value = '';
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            var terms = _this.props.searchTerms.trim();

            if (terms.length === 0) {
                return;
            }

            _this.handleSearch(terms);

            _this.search.blur();
        };

        _this.searchMentions = function (e) {
            e.preventDefault();
            if (_this.props.isMentionSearch) {
                // Close
                _this.props.actions.closeRightHandSide();
            } else {
                _this.props.actions.showMentions();
            }
        };

        _this.getFlagged = function (e) {
            e.preventDefault();
            if (_this.props.isFlaggedPosts) {
                _this.props.actions.closeRightHandSide();
            } else {
                _this.props.actions.showFlaggedPosts();
            }
        };

        _this.getSearch = function (node) {
            _this.search = node;
        };

        _this.state = {
            focused: false,
            isPristine: true
        };

        _this.suggestionProviders = [new _search_channel_provider2.default(), new _search_user_provider2.default()];
        return _this;
    }

    (0, _createClass3.default)(SearchBar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (Utils.isMobile()) {
                setTimeout(function () {
                    var element = document.querySelector('.app__body .sidebar--menu');
                    if (element) {
                        element.classList.remove('visible');
                    }
                });
            }
        }
    }, {
        key: 'renderHintPopover',
        value: function renderHintPopover(helpClass) {
            if (!this.props.isCommentsPage && Utils.isMobile() && this.state.isPristine) {
                return false;
            }

            return _react2.default.createElement(
                _reactBootstrap.Popover,
                {
                    id: 'searchbar-help-popup',
                    placement: 'bottom',
                    className: helpClass
                },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'search_bar.usage',
                    defaultMessage: '<h4>Search Options</h4><ul><li><span>Use </span><b>"quotation marks"</b><span> to search for phrases</span></li><li><span>Use </span><b>from:</b><span> to find posts from specific users and </span><b>in:</b><span> to find posts in specific channels</span></li></ul>'
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var isSearchingTerm = null;
            if (this.props.isSearchingTerm) {
                isSearchingTerm = _react2.default.createElement('span', { className: 'fa fa-spin fa-spinner' });
            }

            var helpClass = 'search-help-popover';
            if (!this.props.searchTerms && this.state.focused) {
                helpClass += ' visible';
            }

            var mentionBtn = void 0;
            var flagBtn = void 0;
            if (this.props.showMentionFlagBtns) {
                var mentionBtnClass = this.props.isMentionSearch ? 'active' : '';

                mentionBtn = _react2.default.createElement(_header_icon_wrapper2.default, {
                    iconComponent: _react2.default.createElement(_mentions_icon2.default, {
                        className: 'icon icon__mentions',
                        'aria-hidden': 'true'
                    }),
                    buttonClass: 'channel-header__icon style--none ' + mentionBtnClass,
                    buttonId: 'channelHeaderMentionButton',
                    onClick: this.searchMentions,
                    tooltipKey: 'recentMentions'
                });

                var flagBtnClass = this.props.isFlaggedPosts ? 'active' : '';

                flagBtn = _react2.default.createElement(_header_icon_wrapper2.default, {
                    iconComponent: _react2.default.createElement(_flag_icon2.default, { className: 'icon icon__flag' }),
                    buttonClass: 'channel-header__icon style--none ' + flagBtnClass,
                    buttonId: 'channelHeaderFlagButton',
                    onClick: this.getFlagged,
                    tooltipKey: 'flaggedPosts'
                });
            }

            var clearClass = 'sidebar__search-clear';
            if (!this.props.isSearchingTerm && this.props.searchTerms && this.props.searchTerms.trim() !== '') {
                clearClass += ' visible';
            }

            var searchFormClass = 'search__form';
            if (this.state.focused) {
                searchFormClass += ' focused';
            }

            return _react2.default.createElement(
                'div',
                { className: 'sidebar-right__table' },
                _react2.default.createElement(
                    'div',
                    { className: 'sidebar-collapse__container' },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'sidebar-collapse',
                            onClick: this.handleClose
                        },
                        _react2.default.createElement('span', { className: 'fa fa-chevron-left' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        id: 'searchFormContainer',
                        className: 'search-form__container'
                    },
                    _react2.default.createElement(
                        'form',
                        {
                            role: 'form',
                            className: searchFormClass,
                            onSubmit: this.handleSubmit,
                            style: style.searchForm,
                            autoComplete: 'off'
                        },
                        _react2.default.createElement(_search_icon2.default, {
                            id: 'searchIcon',
                            className: 'search__icon',
                            'aria-hidden': 'true'
                        }),
                        _react2.default.createElement(_suggestion_box2.default, {
                            id: 'searchBox',
                            ref: this.getSearch,
                            className: 'search-bar',
                            placeholder: Utils.localizeMessage('search_bar.search', 'Search'),
                            value: this.props.searchTerms,
                            onFocus: this.handleUserFocus,
                            onBlur: this.handleUserBlur,
                            onChange: this.handleChange,
                            onKeyDown: this.handleKeyDown,
                            listComponent: _search_suggestion_list2.default,
                            providers: this.suggestionProviders,
                            type: 'search',
                            autoFocus: this.props.isFocus && this.props.searchTerms === '',
                            delayInputUpdate: true
                        }),
                        _react2.default.createElement(
                            'div',
                            {
                                id: 'searchClearButton',
                                className: clearClass,
                                onClick: this.handleClear
                            },
                            _react2.default.createElement(
                                'span',
                                {
                                    className: 'sidebar__search-clear-x',
                                    'aria-hidden': 'true'
                                },
                                '×'
                            )
                        ),
                        isSearchingTerm,
                        this.renderHintPopover(helpClass)
                    )
                ),
                mentionBtn,
                flagBtn
            );
        }
    }]);
    return SearchBar;
}(_react2.default.Component);

SearchBar.propTypes = {
    isSearchingTerm: _propTypes2.default.bool,
    searchTerms: _propTypes2.default.string,
    isMentionSearch: _propTypes2.default.bool,
    isFlaggedPosts: _propTypes2.default.bool,
    actions: _propTypes2.default.shape({
        updateSearchTerms: _propTypes2.default.func,
        showSearchResults: _propTypes2.default.func,
        showMentions: _propTypes2.default.func,
        showFlaggedPosts: _propTypes2.default.func,
        closeRightHandSide: _propTypes2.default.func,
        closeWebrtc: _propTypes2.default.func
    })
};
exports.default = SearchBar;


SearchBar.defaultProps = {
    showMentionFlagBtns: true,
    isFocus: false
};

SearchBar.propTypes = {
    showMentionFlagBtns: _propTypes2.default.bool,
    isCommentsPage: _propTypes2.default.bool,
    isFocus: _propTypes2.default.bool
};

var style = {
    searchForm: { overflow: 'visible' }
};

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _channel_actions = __webpack_require__(809);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _channel_utils = __webpack_require__(830);

var _constants = __webpack_require__(29);

var _provider = __webpack_require__(866);

var _provider2 = _interopRequireDefault(_provider);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SearchChannelSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(SearchChannelSuggestion, _Suggestion);

    function SearchChannelSuggestion() {
        (0, _classCallCheck3.default)(this, SearchChannelSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (SearchChannelSuggestion.__proto__ || (0, _getPrototypeOf2.default)(SearchChannelSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(SearchChannelSuggestion, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                isSelection = _props.isSelection;


            var className = 'search-autocomplete__item';
            if (isSelection) {
                className += ' selected';
            }

            return _react2.default.createElement(
                'div',
                {
                    onClick: this.handleClick,
                    className: className
                },
                _react2.default.createElement('i', { className: 'fa fa fa-plus-square' }),
                item.name
            );
        }
    }]);
    return SearchChannelSuggestion;
}(_suggestion2.default);

var SearchChannelProvider = function (_Provider) {
    (0, _inherits3.default)(SearchChannelProvider, _Provider);

    function SearchChannelProvider() {
        (0, _classCallCheck3.default)(this, SearchChannelProvider);
        return (0, _possibleConstructorReturn3.default)(this, (SearchChannelProvider.__proto__ || (0, _getPrototypeOf2.default)(SearchChannelProvider)).apply(this, arguments));
    }

    (0, _createClass3.default)(SearchChannelProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, pretext) {
            var _this3 = this;

            var captured = /\b(?:in|channel):\s*(\S*)$/i.exec(pretext.toLowerCase());
            if (captured) {
                var channelPrefix = captured[1];

                this.startNewRequest(suggestionId, channelPrefix);

                (0, _channel_actions.autocompleteChannels)(channelPrefix, function (data) {
                    if (_this3.shouldCancelDispatch(channelPrefix)) {
                        return;
                    }

                    var publicChannels = data;

                    var localChannels = _channel_store2.default.getAll();
                    var privateChannels = [];

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(localChannels)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var id = _step.value;

                            var channel = localChannels[id];
                            if (channel.name.startsWith(channelPrefix) && channel.type === _constants.Constants.PRIVATE_CHANNEL) {
                                privateChannels.push(channel);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    var filteredPublicChannels = [];
                    publicChannels.forEach(function (item) {
                        if (item.name.startsWith(channelPrefix)) {
                            filteredPublicChannels.push(item);
                        }
                    });

                    privateChannels = privateChannels.sort(_channel_utils.sortChannelsByDisplayName);
                    filteredPublicChannels = filteredPublicChannels.sort(_channel_utils.sortChannelsByDisplayName);

                    var channels = filteredPublicChannels.concat(privateChannels);
                    var channelNames = channels.map(function (channel) {
                        return channel.name;
                    });

                    _app_dispatcher2.default.handleServerAction({
                        type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                        id: suggestionId,
                        matchedPretext: channelPrefix,
                        terms: channelNames,
                        items: channels,
                        component: SearchChannelSuggestion
                    });
                });
            }

            return Boolean(captured);
        }
    }]);
    return SearchChannelProvider;
}(_provider2.default);

exports.default = SearchChannelProvider;

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _suggestion_list = __webpack_require__(930);

var _suggestion_list2 = _interopRequireDefault(_suggestion_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchSuggestionList = function (_SuggestionList) {
    (0, _inherits3.default)(SearchSuggestionList, _SuggestionList);

    function SearchSuggestionList() {
        (0, _classCallCheck3.default)(this, SearchSuggestionList);
        return (0, _possibleConstructorReturn3.default)(this, (SearchSuggestionList.__proto__ || (0, _getPrototypeOf2.default)(SearchSuggestionList)).apply(this, arguments));
    }

    (0, _createClass3.default)(SearchSuggestionList, [{
        key: 'getContent',
        value: function getContent() {
            return (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.popover)).find('.popover-content');
        }
    }, {
        key: 'renderChannelDivider',
        value: function renderChannelDivider(type) {
            var text = void 0;
            if (type === _constants2.default.OPEN_CHANNEL) {
                text = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'suggestion.search.public',
                    defaultMessage: 'Public Channels'
                });
            } else {
                text = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'suggestion.search.private',
                    defaultMessage: 'Private Channels'
                });
            }

            return _react2.default.createElement(
                'div',
                {
                    key: type + '-divider',
                    className: 'search-autocomplete__divider'
                },
                _react2.default.createElement(
                    'span',
                    null,
                    text
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.items.length === 0) {
                return null;
            }

            var items = [];
            for (var i = 0; i < this.state.items.length; i++) {
                var item = this.state.items[i];
                var term = this.state.terms[i];
                var isSelection = term === this.state.selection;

                // ReactComponent names need to be upper case when used in JSX
                var Component = this.state.components[i];

                // temporary hack to add dividers between public and private channels in the search suggestion list
                if (i === 0 || item.type !== this.state.items[i - 1].type) {
                    if (item.type === _constants2.default.OPEN_CHANNEL) {
                        items.push(this.renderChannelDivider(_constants2.default.OPEN_CHANNEL));
                    } else if (item.type === _constants2.default.PRIVATE_CHANNEL) {
                        items.push(this.renderChannelDivider(_constants2.default.PRIVATE_CHANNEL));
                    }
                }

                items.push(_react2.default.createElement(Component, {
                    key: term,
                    ref: term,
                    item: item,
                    term: term,
                    matchedPretext: this.state.matchedPretext[i],
                    isSelection: isSelection,
                    onClick: this.props.onCompleteWord
                }));
            }

            return _react2.default.createElement(
                _reactBootstrap.Popover,
                {
                    ref: 'popover',
                    id: 'search-autocomplete__popover',
                    className: 'search-help-popover autocomplete visible',
                    placement: 'bottom'
                },
                items
            );
        }
    }]);
    return SearchSuggestionList;
}(_suggestion_list2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SearchSuggestionList.propTypes = (0, _extends3.default)({}, _suggestion_list2.default.propTypes);
exports.default = SearchSuggestionList;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _user_actions = __webpack_require__(781);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _provider = __webpack_require__(866);

var _provider2 = _interopRequireDefault(_provider);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchUserSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(SearchUserSuggestion, _Suggestion);

    function SearchUserSuggestion() {
        (0, _classCallCheck3.default)(this, SearchUserSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (SearchUserSuggestion.__proto__ || (0, _getPrototypeOf2.default)(SearchUserSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(SearchUserSuggestion, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                isSelection = _props.isSelection;


            var className = 'search-autocomplete__item';
            if (isSelection) {
                className += ' selected';
            }

            var username = item.username;
            var description = '';

            if ((item.first_name || item.last_name) && item.nickname) {
                description = '- ' + Utils.getFullName(item) + ' (' + item.nickname + ')';
            } else if (item.nickname) {
                description = '- (' + item.nickname + ')';
            } else if (item.first_name || item.last_name) {
                description = '- ' + Utils.getFullName(item);
            }

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.handleClick
                },
                _react2.default.createElement('i', { className: 'fa fa fa-plus-square' }),
                _react2.default.createElement('img', {
                    className: 'profile-img rounded',
                    src: Utils.imageURLForUser(item)
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'mention--align' },
                    _react2.default.createElement(
                        'span',
                        null,
                        username
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'mention__fullname' },
                        ' ',
                        description
                    )
                )
            );
        }
    }]);
    return SearchUserSuggestion;
}(_suggestion2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SearchUserProvider = function (_Provider) {
    (0, _inherits3.default)(SearchUserProvider, _Provider);

    function SearchUserProvider() {
        (0, _classCallCheck3.default)(this, SearchUserProvider);
        return (0, _possibleConstructorReturn3.default)(this, (SearchUserProvider.__proto__ || (0, _getPrototypeOf2.default)(SearchUserProvider)).apply(this, arguments));
    }

    (0, _createClass3.default)(SearchUserProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, pretext) {
            var _this3 = this;

            var captured = /\bfrom:\s*(\S*)$/i.exec(pretext.toLowerCase());
            if (captured) {
                var usernamePrefix = captured[1];

                this.startNewRequest(suggestionId, usernamePrefix);

                (0, _user_actions.autocompleteUsersInTeam)(usernamePrefix, function (data) {
                    if (_this3.shouldCancelDispatch(usernamePrefix)) {
                        return;
                    }

                    var users = (0, _assign2.default)([], data.users);
                    var mentions = users.map(function (user) {
                        return user.username;
                    });

                    _app_dispatcher2.default.handleServerAction({
                        type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                        id: suggestionId,
                        matchedPretext: usernamePrefix,
                        terms: mentions,
                        items: users,
                        component: SearchUserSuggestion
                    });
                });
            }

            return Boolean(captured);
        }
    }]);
    return SearchUserProvider;
}(_provider2.default);

exports.default = SearchUserProvider;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(783);

var _posts = __webpack_require__(805);

var _preferences = __webpack_require__(784);

var PreferenceSelectors = _interopRequireWildcard(_preferences);

var _general = __webpack_require__(113);

var _rhs = __webpack_require__(817);

var _rhs2 = __webpack_require__(818);

var _constants = __webpack_require__(29);

var _search_results = __webpack_require__(2083);

var _search_results2 = _interopRequireDefault(_search_results);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCategory = PreferenceSelectors.makeGetCategory(); // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function makeMapStateToProps() {
    var results = void 0;
    var posts = void 0;
    var channels = void 0;
    var flaggedPosts = void 0;
    var isFlaggedByPostId = void 0;

    return function mapStateToProps(state) {
        var newResults = (0, _posts.getSearchResults)(state);

        // Cache posts and channels
        if (newResults && newResults !== results) {
            results = newResults;

            posts = results.filter(function (post) {
                return Boolean(post);
            });

            channels = new _map2.default();

            var channelIds = posts.map(function (post) {
                return post.channel_id;
            });

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(channelIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var id = _step.value;

                    if (channels.has(id)) {
                        continue;
                    }

                    channels.set(id, (0, _channels.getChannel)(state, id));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        var newFlaggedPosts = getCategory(state, _constants.Preferences.CATEGORY_FLAGGED_POST);

        // Cache flagged posts map
        if (newFlaggedPosts !== flaggedPosts) {
            flaggedPosts = newFlaggedPosts;

            isFlaggedByPostId = new _map2.default();

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(flaggedPosts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var pref = _step2.value;

                    isFlaggedByPostId.set(pref.name, true);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }

        var config = (0, _general.getConfig)(state);

        var dataRetentionEnableMessageDeletion = config.DataRetentionEnableMessageDeletion === 'true';
        var dataRetentionMessageRetentionDays = config.DataRetentionMessageRetentionDays;

        return {
            results: posts,
            channels: channels,
            searchTerms: (0, _rhs2.getSearchResultsTerms)(state),
            isFlaggedByPostId: isFlaggedByPostId,
            isSearchingTerm: (0, _rhs2.getIsSearchingTerm)(state),
            isSearchingFlaggedPost: (0, _rhs2.getIsSearchingFlaggedPost)(state),
            isSearchingPinnedPost: (0, _rhs2.getIsSearchingPinnedPost)(state),
            compactDisplay: PreferenceSelectors.get(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.MESSAGE_DISPLAY, _constants.Preferences.MESSAGE_DISPLAY_DEFAULT) === _constants.Preferences.MESSAGE_DISPLAY_COMPACT,
            dataRetentionEnableMessageDeletion: dataRetentionEnableMessageDeletion,
            dataRetentionMessageRetentionDays: dataRetentionMessageRetentionDays
        };
    };
}

var mapDispatchToProps = {
    selectPost: _rhs.selectPostFromRightHandSideSearch
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_search_results2.default);

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

exports.renderView = renderView;
exports.renderThumbHorizontal = renderThumbHorizontal;
exports.renderThumbVertical = renderThumbVertical;

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactCustomScrollbars = __webpack_require__(1317);

var _reactCustomScrollbars2 = _interopRequireDefault(_reactCustomScrollbars);

var _search_results_header = __webpack_require__(2084);

var _search_results_header2 = _interopRequireDefault(_search_results_header);

var _search_results_item = __webpack_require__(2086);

var _search_results_item2 = _interopRequireDefault(_search_results_item);

var _flag_icon = __webpack_require__(974);

var _flag_icon2 = _interopRequireDefault(_flag_icon);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function renderView(props) {
    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
        className: 'scrollbar--view'
    }));
}

function renderThumbHorizontal(props) {
    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
        className: 'scrollbar--horizontal'
    }));
}

function renderThumbVertical(props) {
    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
        className: 'scrollbar--vertical'
    }));
}

var SearchResults = function (_React$PureComponent) {
    (0, _inherits3.default)(SearchResults, _React$PureComponent);

    function SearchResults(props) {
        (0, _classCallCheck3.default)(this, SearchResults);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchResults.__proto__ || (0, _getPrototypeOf2.default)(SearchResults)).call(this, props));

        _this.handleResize = function () {
            _this.setState({
                windowWidth: Utils.windowWidth(),
                windowHeight: Utils.windowHeight()
            });
        };

        _this.onUserChange = function () {
            _this.setState({ profiles: JSON.parse((0, _stringify2.default)(_user_store2.default.getProfiles())) });
        };

        _this.onBusy = function (isBusy) {
            _this.setState({ isBusy: isBusy });
        };

        _this.onStatusChange = function () {
            _this.setState({ statuses: (0, _assign2.default)({}, _user_store2.default.getStatuses()) });
        };

        _this.scrollToTop = function () {
            (0, _jquery2.default)('#search-items-container').scrollTop(0);
        };

        _this.state = {
            windowWidth: Utils.windowWidth(),
            windowHeight: Utils.windowHeight(),
            profiles: JSON.parse((0, _stringify2.default)(_user_store2.default.getProfiles())),
            isBusy: _webrtc_store2.default.isBusy(),
            statuses: (0, _assign2.default)({}, _user_store2.default.getStatuses())
        };
        return _this;
    }

    (0, _createClass3.default)(SearchResults, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _user_store2.default.addChangeListener(this.onUserChange);
            _user_store2.default.addStatusesChangeListener(this.onStatusChange);
            _webrtc_store2.default.addBusyListener(this.onBusy);

            this.scrollToTop();
            window.addEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeChangeListener(this.onUserChange);
            _user_store2.default.removeStatusesChangeListener(this.onStatusChange);
            _webrtc_store2.default.removeBusyListener(this.onBusy);

            window.removeEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.searchTerms !== prevProps.searchTerms) {
                this.scrollToTop();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var results = this.props.results;
            var noResults = !results || results.length === 0;
            var searchTerms = this.props.searchTerms;
            var profiles = this.state.profiles || {};

            var ctls = null;

            if (this.props.isSearchingTerm || this.props.isSearchingFlaggedPost || this.props.isSearchingPinnedPost) {
                ctls = _react2.default.createElement(
                    'div',
                    { className: 'sidebar--right__subheader' },
                    _react2.default.createElement(
                        'div',
                        { className: 'sidebar--right__loading' },
                        _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'search_header.loading',
                            defaultMessage: 'Searching...'
                        })
                    )
                );
            } else if (this.props.isFlaggedPosts && noResults) {
                var tips = [_react2.default.createElement(
                    'li',
                    { key: 'pin1' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usageFlag1',
                        defaultMessage: 'You haven\'t flagged any messages yet.'
                    })
                ), _react2.default.createElement(
                    'li',
                    { key: 'pin2' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usageFlag2',
                        defaultMessage: 'You can add a flag to messages and comments by clicking the '
                    }),
                    _react2.default.createElement(_flag_icon2.default, { className: 'usage__icon' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usageFlag3',
                        defaultMessage: ' icon next to the timestamp.'
                    })
                ), _react2.default.createElement(
                    'li',
                    { key: 'pin3' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usageFlag4',
                        defaultMessage: 'Flags are a way to mark messages for follow up. Your flags are personal, and cannot be seen by other users.'
                    })
                )];

                if (this.props.dataRetentionEnableMessageDeletion) {
                    tips.push(_react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'search_results.usage.dataRetention',
                            defaultMessage: 'Only messages posted in the last {days} days are returned. Contact your System Administrator for more detail.',
                            values: {
                                days: this.props.dataRetentionMessageRetentionDays
                            }
                        })
                    ));
                }

                ctls = _react2.default.createElement(
                    'div',
                    { className: 'sidebar--right__subheader' },
                    _react2.default.createElement(
                        'ul',
                        null,
                        tips
                    )
                );
            } else if (this.props.isPinnedPosts && noResults) {
                var _tips = [_react2.default.createElement(
                    'li',
                    { key: 'pin1' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usagePin1',
                        defaultMessage: 'There are no pinned messages yet.'
                    })
                ), _react2.default.createElement(
                    'li',
                    { key: 'pin2' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usagePin2',
                        defaultMessage: 'All members of this channel can pin important or useful messages.'
                    })
                ), _react2.default.createElement(
                    'li',
                    { key: 'pin3' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usagePin3',
                        defaultMessage: 'Pinned messages are visible to all channel members.'
                    })
                ), _react2.default.createElement(
                    'li',
                    { key: 'pin4' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usagePin4',
                        defaultMessage: 'To pin a message: Go to the message that you want to pin and click [...] > "Pin to channel".'
                    })
                )];

                if (this.props.dataRetentionEnableMessageDeletion) {
                    _tips.push(_react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'search_results.usage.dataRetention',
                            defaultMessage: 'Only messages posted in the last {days} days are returned. Contact your System Administrator for more detail.',
                            values: {
                                days: this.props.dataRetentionMessageRetentionDays
                            }
                        })
                    ));
                }

                ctls = _react2.default.createElement(
                    'div',
                    { className: 'sidebar--right__subheader' },
                    _react2.default.createElement(
                        'ul',
                        null,
                        _tips
                    )
                );
            } else if (!searchTerms && noResults) {
                var _tips2 = [_react2.default.createElement(
                    'li',
                    { key: 'quotes' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usage.phrasesSuggestion',
                        defaultMessage: 'Use {quotationMarks} to search for phrases',
                        values: {
                            quotationMarks: _react2.default.createElement(
                                'b',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'search_results.usage.phrasesSuggestion.quotationMarks',
                                    defaultMessage: '"quotation marks"'
                                })
                            )
                        }
                    })
                ), _react2.default.createElement(
                    'li',
                    { key: 'fromIn' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.usage.fromInSuggestion',
                        defaultMessage: 'Use {fromUser} to find posts from specific users and {inChannel} to find posts in specific channels',
                        values: {
                            fromUser: 'from:',
                            inChannel: 'in:'
                        }
                    })
                )];

                ctls = _react2.default.createElement(
                    'div',
                    { className: 'sidebar--right__subheader' },
                    _react2.default.createElement(
                        'ul',
                        null,
                        _tips2
                    )
                );
            } else if (noResults) {
                var _tips3 = [_react2.default.createElement(
                    'li',
                    { key: 'partialPhrase' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.noResults.partialPhraseSuggestion',
                        defaultMessage: 'If you\'re searching a partial phrase (ex. searching "rea", looking for "reach" or "reaction"), append a * to your search term.'
                    })
                ), _react2.default.createElement(
                    'li',
                    { key: 'stopWords' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_results.noResults.stopWordsSuggestion',
                        defaultMessage: 'Two letter searches and common words like "this", "a" and "is" won\'t appear in search results due to the excessive results returned.'
                    })
                )];

                if (this.props.dataRetentionEnableMessageDeletion) {
                    _tips3.push(_react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'search_results.usage.dataRetention',
                            defaultMessage: 'Only messages posted in the last {days} days are returned. Contact your System Administrator for more detail.',
                            values: {
                                days: this.props.dataRetentionMessageRetentionDays
                            }
                        })
                    ));
                }

                ctls = _react2.default.createElement(
                    'div',
                    { className: 'sidebar--right__subheader' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'search_results.noResults',
                            defaultMessage: 'No results found. Try again?'
                        })
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _tips3
                    )
                );
            } else {
                var sortedResults = void 0;
                if (this.props.isPinnedPosts) {
                    sortedResults = [].concat((0, _toConsumableArray3.default)(results));
                    sortedResults.sort(function (postA, postB) {
                        return postB.create_at - postA.create_at;
                    });
                } else {
                    sortedResults = results;
                }

                ctls = sortedResults.map(function searchResults(post, idx, arr) {
                    var profile = void 0;
                    if (_user_store2.default.getCurrentId() === post.user_id) {
                        profile = _user_store2.default.getCurrentUser();
                    } else {
                        profile = profiles[post.user_id];
                    }

                    var status = 'offline';
                    if (this.state.statuses) {
                        status = this.state.statuses[post.user_id] || 'offline';
                    }

                    var isFlagged = false;
                    if (this.props.isFlaggedByPostId) {
                        isFlagged = this.props.isFlaggedByPostId.get(post.id) || false;
                    }

                    var reverseCount = arr.length - idx - 1;

                    return _react2.default.createElement(_search_results_item2.default, {
                        key: post.id,
                        channel: this.props.channels.get(post.channel_id),
                        compactDisplay: this.props.compactDisplay,
                        post: post,
                        lastPostCount: reverseCount >= 0 && reverseCount < _constants2.default.TEST_ID_COUNT ? reverseCount : -1,
                        user: profile,
                        term: searchTerms,
                        isMentionSearch: this.props.isMentionSearch,
                        shrink: this.props.shrink,
                        isFlagged: isFlagged,
                        isBusy: this.state.isBusy,
                        status: status,
                        onSelect: this.props.selectPost
                    });
                }, this);
            }

            return _react2.default.createElement(
                'div',
                { className: 'sidebar-right__body' },
                _react2.default.createElement(_search_results_header2.default, {
                    isMentionSearch: this.props.isMentionSearch,
                    toggleSize: this.props.toggleSize,
                    shrink: this.props.shrink,
                    isFlaggedPosts: this.props.isFlaggedPosts,
                    isPinnedPosts: this.props.isPinnedPosts,
                    channelDisplayName: this.props.channelDisplayName,
                    isLoading: this.props.isSearchingTerm
                }),
                _react2.default.createElement(
                    _reactCustomScrollbars2.default,
                    {
                        autoHide: true,
                        autoHideTimeout: 500,
                        autoHideDuration: 500,
                        renderThumbHorizontal: renderThumbHorizontal,
                        renderThumbVertical: renderThumbVertical,
                        renderView: renderView,
                        onScroll: this.handleScroll
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            id: 'search-items-container',
                            className: 'search-items-container'
                        },
                        ctls
                    )
                )
            );
        }
    }]);
    return SearchResults;
}(_react2.default.PureComponent);

SearchResults.propTypes = {
    results: _propTypes2.default.array,
    channels: _propTypes2.default.object,
    searchTerms: _propTypes2.default.string,
    isFlaggedByPostId: _propTypes2.default.object,
    isSearchingTerm: _propTypes2.default.bool,
    isSearchingFlaggedPost: _propTypes2.default.bool,
    isSearchingPinnedPost: _propTypes2.default.bool,
    compactDisplay: _propTypes2.default.bool,
    toggleSize: _propTypes2.default.func,
    shrink: _propTypes2.default.func,
    isMentionSearch: _propTypes2.default.bool,
    isFlaggedPosts: _propTypes2.default.bool,
    isPinnedPosts: _propTypes2.default.bool,
    channelDisplayName: _propTypes2.default.string.isRequired,
    selectPost: _propTypes2.default.func,
    dataRetentionEnableMessageDeletion: _propTypes2.default.bool.isRequired,
    dataRetentionMessageRetentionDays: _propTypes2.default.string
};
exports.default = SearchResults;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _rhs = __webpack_require__(817);

var _search_results_header = __webpack_require__(2085);

var _search_results_header2 = _interopRequireDefault(_search_results_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            closeRightHandSide: _rhs.closeRightHandSide
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_search_results_header2.default);

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResultsHeader = function (_React$Component) {
    (0, _inherits3.default)(SearchResultsHeader, _React$Component);

    function SearchResultsHeader() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SearchResultsHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchResultsHeader.__proto__ || (0, _getPrototypeOf2.default)(SearchResultsHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = function (e) {
            e.preventDefault();

            _this.props.actions.closeRightHandSide();

            _this.props.shrink();
        }, _this.toggleSize = function (e) {
            e.preventDefault();
            _this.props.toggleSize();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SearchResultsHeader, [{
        key: 'render',
        value: function render() {
            var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'search_header.results',
                defaultMessage: 'Search Results'
            });

            var closeSidebarTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'closeSidebarTooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'rhs_header.closeSidebarTooltip',
                    defaultMessage: 'Close Sidebar'
                })
            );

            var expandSidebarTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'expandSidebarTooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'rhs_header.expandSidebarTooltip',
                    defaultMessage: 'Expand Sidebar'
                })
            );

            var shrinkSidebarTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'shrinkSidebarTooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'rhs_header.shrinkSidebarTooltip',
                    defaultMessage: 'Shrink Sidebar'
                })
            );

            if (this.props.isMentionSearch) {
                title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'search_header.title2',
                    defaultMessage: 'Recent Mentions'
                });
            } else if (this.props.isFlaggedPosts) {
                title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'search_header.title3',
                    defaultMessage: 'Flagged Posts'
                });
            } else if (this.props.isPinnedPosts) {
                title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'search_header.title4',
                    defaultMessage: 'Pinned posts in {channelDisplayName}',
                    values: {
                        channelDisplayName: this.props.channelDisplayName
                    }
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'sidebar--right__header' },
                _react2.default.createElement(
                    'span',
                    { className: 'sidebar--right__title' },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pull-right' },
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'sidebar--right__expand',
                            'aria-label': 'Expand',
                            onClick: this.toggleSize
                        },
                        _react2.default.createElement(
                            _reactBootstrap.OverlayTrigger,
                            {
                                trigger: ['hover', 'focus'],
                                delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                placement: 'top',
                                overlay: expandSidebarTooltip
                            },
                            _react2.default.createElement('i', { className: 'fa fa-expand' })
                        ),
                        _react2.default.createElement(
                            _reactBootstrap.OverlayTrigger,
                            {
                                trigger: ['hover', 'focus'],
                                delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                placement: 'top',
                                overlay: shrinkSidebarTooltip
                            },
                            _react2.default.createElement('i', { className: 'fa fa-compress' })
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'sidebar--right__close',
                            'aria-label': 'Close',
                            title: 'Close',
                            onClick: this.handleClose
                        },
                        _react2.default.createElement(
                            _reactBootstrap.OverlayTrigger,
                            {
                                trigger: ['hover', 'focus'],
                                delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                placement: 'top',
                                overlay: closeSidebarTooltip
                            },
                            _react2.default.createElement('i', { className: 'fa fa-sign-out' })
                        )
                    )
                )
            );
        }
    }]);
    return SearchResultsHeader;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SearchResultsHeader.propTypes = {
    isMentionSearch: _propTypes2.default.bool,
    isFlaggedPosts: _propTypes2.default.bool,
    isPinnedPosts: _propTypes2.default.bool,
    toggleSize: _propTypes2.default.func,
    shrink: _propTypes2.default.func,
    channelDisplayName: _propTypes2.default.string.isRequired,
    actions: _propTypes2.default.shape({
        closeRightHandSide: _propTypes2.default.func
    })
};
exports.default = SearchResultsHeader;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _teams = __webpack_require__(274);

var _posts = __webpack_require__(805);

var _general = __webpack_require__(113);

var _rhs = __webpack_require__(817);

var _search_results_item = __webpack_require__(2087);

var _search_results_item2 = _interopRequireDefault(_search_results_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps() {
    var getCommentCountForPost = (0, _posts.makeGetCommentCountForPost)();

    return function (state, ownProps) {
        var config = (0, _general.getConfig)(state);
        var enablePostUsernameOverride = config.EnablePostUsernameOverride === 'true';

        return {
            currentTeamName: (0, _teams.getCurrentTeam)(state).name,
            commentCountForPost: getCommentCountForPost(state, { post: ownProps.post }),
            enablePostUsernameOverride: enablePostUsernameOverride
        };
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            closeRightHandSide: _rhs.closeRightHandSide
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_search_results_item2.default);

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _index = __webpack_require__(19);

var _post_utils = __webpack_require__(281);

var ReduxPostUtils = _interopRequireWildcard(_post_utils);

var _post_message_view = __webpack_require__(1046);

var _post_message_view2 = _interopRequireDefault(_post_message_view);

var _file_attachment_list = __webpack_require__(971);

var _file_attachment_list2 = _interopRequireDefault(_file_attachment_list);

var _comment_icon = __webpack_require__(1331);

var _comment_icon2 = _interopRequireDefault(_comment_icon);

var _dot_menu = __webpack_require__(970);

var _dot_menu2 = _interopRequireDefault(_dot_menu);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

var _user_profile = __webpack_require__(933);

var _user_profile2 = _interopRequireDefault(_user_profile);

var _date_separator = __webpack_require__(1042);

var _date_separator2 = _interopRequireDefault(_date_separator);

var _post_body_additional_content = __webpack_require__(1045);

var _post_body_additional_content2 = _interopRequireDefault(_post_body_additional_content);

var _post_flag_icon = __webpack_require__(973);

var _post_flag_icon2 = _interopRequireDefault(_post_flag_icon);

var _post_time = __webpack_require__(975);

var _post_time2 = _interopRequireDefault(_post_time);

var _browser_history = __webpack_require__(273);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _post_utils2 = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils2);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResultsItem = function (_React$PureComponent) {
    (0, _inherits3.default)(SearchResultsItem, _React$PureComponent);

    function SearchResultsItem(props) {
        (0, _classCallCheck3.default)(this, SearchResultsItem);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchResultsItem.__proto__ || (0, _getPrototypeOf2.default)(SearchResultsItem)).call(this, props));

        _this.shrinkSidebar = function () {
            setTimeout(function () {
                _this.props.shrink();
            });
        };

        _this.handleFocusRHSClick = function (e) {
            e.preventDefault();
            _this.props.onSelect(_this.props.post);
        };

        _this.handleJumpClick = function () {
            if (Utils.isMobile()) {
                _this.props.actions.closeRightHandSide();
            }

            _this.shrinkSidebar();
            _browser_history.browserHistory.push('/' + _this.props.currentTeamName + '/pl/' + _this.props.post.id);
        };

        _this.handleDropdownOpened = function (isOpened) {
            _this.setState({
                dropdownOpened: isOpened
            });
        };

        _this.renderPostTime = function () {
            var post = _this.props.post;

            var isPermalink = !(_index.Posts.POST_DELETED === post.state || ReduxPostUtils.isPostPendingOrFailed(post));

            return _react2.default.createElement(_post_time2.default, {
                isPermalink: isPermalink,
                eventTime: post.create_at,
                postId: post.id
            });
        };

        _this.getClassName = function () {
            var className = 'post post--thread';

            if (_this.props.compactDisplay) {
                className += ' post--compact';
            }

            if (_this.state.dropdownOpened) {
                className += ' post--hovered';
            }

            return className;
        };

        _this.state = {
            dropdownOpened: false
        };
        return _this;
    }

    (0, _createClass3.default)(SearchResultsItem, [{
        key: 'render',
        value: function render() {
            var channelName = null;
            var channel = this.props.channel;
            var user = this.props.user || {};
            var post = this.props.post;

            if (channel) {
                channelName = channel.display_name;
                if (channel.type === _constants2.default.DM_CHANNEL) {
                    channelName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'search_item.direct',
                        defaultMessage: 'Direct Message (with {username})',
                        values: {
                            username: Utils.getDisplayNameByUser(Utils.getDirectTeammate(channel.id))
                        }
                    });
                }
            }

            var overrideUsername = void 0;
            var disableProfilePopover = false;
            if (post.props && post.props.from_webhook && post.props.override_username && this.props.enablePostUsernameOverride) {
                overrideUsername = post.props.override_username;
                disableProfilePopover = true;
            }

            var botIndicator = void 0;
            if (post.props && post.props.from_webhook) {
                botIndicator = _react2.default.createElement(
                    'div',
                    { className: 'bot-indicator' },
                    _constants2.default.BOT_NAME
                );
            }

            var profilePic = _react2.default.createElement(_profile_picture2.default, {
                src: PostUtils.getProfilePicSrcForPost(post, user),
                user: this.props.user,
                status: this.props.status,
                isBusy: this.props.isBusy
            });

            var profilePicContainer = _react2.default.createElement(
                'div',
                { className: 'post__img' },
                profilePic
            );

            var postClass = '';
            if (PostUtils.isEdited(this.props.post)) {
                postClass += ' post--edited';
            }

            var fileAttachment = null;
            if (post.file_ids && post.file_ids.length > 0) {
                fileAttachment = _react2.default.createElement(_file_attachment_list2.default, {
                    post: post,
                    compactDisplay: this.props.compactDisplay
                });
            }

            var message = void 0;
            var flagContent = void 0;
            var rhsControls = void 0;
            if (post.state === _constants2.default.POST_DELETED) {
                message = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_body.deleted',
                        defaultMessage: '(message deleted)'
                    })
                );
            } else {
                flagContent = _react2.default.createElement(_post_flag_icon2.default, {
                    idPrefix: 'searchPostFlag',
                    idCount: this.props.lastPostCount,
                    postId: post.id,
                    isFlagged: this.props.isFlagged
                });

                rhsControls = _react2.default.createElement(
                    'div',
                    { className: 'col__controls' },
                    _react2.default.createElement(_dot_menu2.default, {
                        idPrefix: _constants2.default.SEARCH_POST,
                        idCount: this.props.lastPostCount,
                        post: post,
                        isFlagged: this.props.isFlagged,
                        handleDropdownOpened: this.handleDropdownOpened,
                        commentCount: this.props.commentCountForPost
                    }),
                    _react2.default.createElement(_comment_icon2.default, {
                        idPrefix: 'searchCommentIcon',
                        idCount: this.props.lastPostCount,
                        handleCommentClick: this.handleFocusRHSClick,
                        searchStyle: 'search-item__comment'
                    }),
                    _react2.default.createElement(
                        'a',
                        {
                            onClick: this.handleJumpClick,
                            className: 'search-item__jump'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'search_item.jump',
                            defaultMessage: 'Jump'
                        })
                    )
                );

                message = _react2.default.createElement(
                    _post_body_additional_content2.default,
                    { post: post },
                    _react2.default.createElement(_post_message_view2.default, {
                        post: post,
                        options: {
                            searchTerm: this.props.term,
                            mentionHighlight: this.props.isMentionSearch
                        }
                    })
                );
            }

            var pinnedBadge = void 0;
            if (post.is_pinned) {
                pinnedBadge = _react2.default.createElement(
                    'span',
                    { className: 'post__pinned-badge' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_info.pinned',
                        defaultMessage: 'Pinned'
                    })
                );
            }

            var currentPostDay = Utils.getDateForUnixTicks(post.create_at);

            return _react2.default.createElement(
                'div',
                { className: 'search-item__container' },
                _react2.default.createElement(_date_separator2.default, { date: currentPostDay }),
                _react2.default.createElement(
                    'div',
                    { className: this.getClassName() },
                    _react2.default.createElement(
                        'div',
                        { className: 'search-channel__name' },
                        channelName
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'post__content' },
                        profilePicContainer,
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'post__header' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col col__name' },
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        _react2.default.createElement(_user_profile2.default, {
                                            user: user,
                                            overwriteName: overrideUsername,
                                            disablePopover: disableProfilePopover,
                                            status: this.props.status,
                                            isBusy: this.props.isBusy
                                        })
                                    )
                                ),
                                botIndicator,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col' },
                                    this.renderPostTime(),
                                    pinnedBadge,
                                    flagContent
                                ),
                                rhsControls
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'search-item-snippet post__body' },
                                _react2.default.createElement(
                                    'div',
                                    { className: postClass },
                                    message,
                                    fileAttachment
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return SearchResultsItem;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SearchResultsItem.propTypes = {

    /**
    *  Data used for rendering post
    */
    post: _propTypes2.default.object,

    /**
    *  count used for passing down to PostFlagIcon, DotMenu and CommentIcon
    */
    lastPostCount: _propTypes2.default.number,

    /**
    *  user object for rendering profile_picture
    */
    user: _propTypes2.default.object,

    /**
    *  channel object for rendering channel name on top of result
    */
    channel: _propTypes2.default.object,

    /**
    *  Flag for determining result display setting
    */
    compactDisplay: _propTypes2.default.bool,

    /**
    *  Flag for highlighting mentions
    */
    isMentionSearch: _propTypes2.default.bool,

    /**
    *  Flag for highlighting search term
    */
    term: _propTypes2.default.string,

    /**
    *  Flag for determining result flag state
    */
    isFlagged: _propTypes2.default.bool,

    /**
    *  Flag for determining profile busy status
    */
    isBusy: _propTypes2.default.bool,

    /**
    *  Data used for status in profile
    */
    status: _propTypes2.default.string,

    /**
    *  Data used creating URl for jump to post
    */
    currentTeamName: _propTypes2.default.string,

    /**
    *  Data used for delete in DotMenu
    */
    commentCountForPost: _propTypes2.default.number,

    /**
     * Whether post username overrides are to be respected.
     */
    enablePostUsernameOverride: _propTypes2.default.bool.isRequired,

    /**
    *  Function used for shrinking LHS
    *  on click of jump to message in expanded mode
    */
    shrink: _propTypes2.default.func,

    /**
    *  Function used for selecting a post to comment
    */
    onSelect: _propTypes2.default.func,

    /**
    *  Function used for closing LHS
    */
    actions: _propTypes2.default.shape({
        closeRightHandSide: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = SearchResultsItem;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReplyIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(ReplyIcon, _React$PureComponent);

    function ReplyIcon() {
        (0, _classCallCheck3.default)(this, ReplyIcon);
        return (0, _possibleConstructorReturn3.default)(this, (ReplyIcon.__proto__ || (0, _getPrototypeOf2.default)(ReplyIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(ReplyIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        id: 'Layer_1',
                        x: '0px',
                        y: '0px',
                        width: '17px',
                        height: '17px',
                        viewBox: '-158 242 18 18',
                        style: style
                    },
                    _react2.default.createElement('path', { d: 'M-142.2,252.6c-2-3-4.8-4.7-8.3-4.8v-3.3c0-0.2-0.1-0.3-0.2-0.3s-0.3,0-0.4,0.1l-6.9,6.2c-0.1,0.1-0.1,0.2-0.1,0.3 c0,0.1,0,0.2,0.1,0.3l6.9,6.4c0.1,0.1,0.3,0.1,0.4,0.1c0.1-0.1,0.2-0.2,0.2-0.4v-3.8c4.2,0,7.4,0.4,9.6,4.4c0.1,0.1,0.2,0.2,0.3,0.2 c0,0,0.1,0,0.1,0c0.2-0.1,0.3-0.3,0.2-0.4C-140.2,257.3-140.6,255-142.2,252.6z M-150.8,252.5c-0.2,0-0.4,0.2-0.4,0.4v3.3l-6-5.5 l6-5.3v2.8c0,0.2,0.2,0.4,0.4,0.4c3.3,0,6,1.5,8,4.5c0.5,0.8,0.9,1.6,1.2,2.3C-144,252.8-147.1,252.5-150.8,252.5z' })
                )
            );
        }
    }]);
    return ReplyIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = ReplyIcon;


var style = {
    enableBackground: 'new -158 242 18 18'
};

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _general = __webpack_require__(113);

var _users = __webpack_require__(777);

var _teams = __webpack_require__(274);

var _preferences = __webpack_require__(784);

var _rhs = __webpack_require__(817);

var _rhs2 = __webpack_require__(818);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var _sidebar_right_menu = __webpack_require__(2090);

var _sidebar_right_menu2 = _interopRequireDefault(_sidebar_right_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);
    var rhsState = (0, _rhs2.getRhsState)(state);

    var enableTutorial = config.EnableTutorial === 'true';
    var tutorialStep = (0, _preferences.getInt)(state, _constants.Preferences.TUTORIAL_STEP, (0, _users.getCurrentUserId)(state), _constants.TutorialSteps.FINISHED);

    var isLicensed = license.IsLicensed === 'true';
    var appDownloadLink = config.AppDownloadLink;
    var enableTeamCreation = config.EnableTeamCreation === 'true';
    var enableUserCreation = config.EnableUserCreation === 'true';
    var experimentalPrimaryTeam = config.ExperimentalPrimaryTeam;
    var helpLink = config.HelpLink;
    var reportAProblemLink = config.ReportAProblemLink;
    var restrictTeamInvite = config.RestrictTeamInvite;
    var siteName = config.SiteName;

    return {
        teamId: (0, _teams.getCurrentTeamId)(state),
        isOpen: (0, _rhs2.getIsRhsMenuOpen)(state),
        isMentionSearch: rhsState === _constants.RHSStates.MENTION,
        showTutorialTip: enableTutorial && (0, _utils.isMobile)() && tutorialStep === _constants.TutorialSteps.MENU_POPOVER,
        isLicensed: isLicensed,
        appDownloadLink: appDownloadLink,
        enableTeamCreation: enableTeamCreation,
        enableUserCreation: enableUserCreation,
        experimentalPrimaryTeam: experimentalPrimaryTeam,
        helpLink: helpLink,
        reportAProblemLink: reportAProblemLink,
        restrictTeamInvite: restrictTeamInvite,
        siteName: siteName,
        pluginMenuItems: state.plugins.mainMenuActions
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            showMentions: _rhs.showMentions,
            showFlaggedPosts: _rhs.showFlaggedPosts,
            closeRightHandSide: _rhs.closeRightHandSide,
            openRhsMenu: _rhs.openMenu,
            closeRhsMenu: _rhs.closeMenu
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_sidebar_right_menu2.default);

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _constants = __webpack_require__(19);

var _classnames = __webpack_require__(769);

var _classnames2 = _interopRequireDefault(_classnames);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _constants2 = __webpack_require__(29);

var _url = __webpack_require__(793);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _about_build_modal = __webpack_require__(1049);

var _about_build_modal2 = _interopRequireDefault(_about_build_modal);

var _add_users_to_team = __webpack_require__(1332);

var _add_users_to_team2 = _interopRequireDefault(_add_users_to_team);

var _leave_team_icon = __webpack_require__(2105);

var _leave_team_icon2 = _interopRequireDefault(_leave_team_icon);

var _team_members_modal = __webpack_require__(1051);

var _team_members_modal2 = _interopRequireDefault(_team_members_modal);

var _toggle_modal_button = __webpack_require__(977);

var _toggle_modal_button2 = _interopRequireDefault(_toggle_modal_button);

var _team_settings_modal = __webpack_require__(1052);

var _team_settings_modal2 = _interopRequireDefault(_team_settings_modal);

var _team_permission_gate = __webpack_require__(864);

var _team_permission_gate2 = _interopRequireDefault(_team_permission_gate);

var _system_permission_gate = __webpack_require__(863);

var _system_permission_gate2 = _interopRequireDefault(_system_permission_gate);

var _menu_tutorial_tip = __webpack_require__(1338);

var _menu_tutorial_tip2 = _interopRequireDefault(_menu_tutorial_tip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SidebarRightMenu = function (_React$Component) {
    (0, _inherits3.default)(SidebarRightMenu, _React$Component);

    function SidebarRightMenu(props) {
        (0, _classCallCheck3.default)(this, SidebarRightMenu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarRightMenu.__proto__ || (0, _getPrototypeOf2.default)(SidebarRightMenu)).call(this, props));

        _this.handleClick = function (e) {
            if (_webrtc_store2.default.isBusy()) {
                _webrtc_store2.default.emitChanged({ action: _constants2.WebrtcActionTypes.IN_PROGRESS });
                e.preventDefault();
            }
        };

        _this.handleAboutModal = function () {
            _this.setState({ showAboutModal: true });
        };

        _this.aboutModalDismissed = function () {
            _this.setState({ showAboutModal: false });
        };

        _this.showAddUsersToTeamModal = function (e) {
            e.preventDefault();

            _this.setState({
                showAddUsersToTeamModal: true,
                showDropdown: false
            });
        };

        _this.hideAddUsersToTeamModal = function () {
            _this.setState({
                showAddUsersToTeamModal: false
            });
        };

        _this.showTeamSettingsModal = function (e) {
            e.preventDefault();

            _this.setState({
                showTeamSettingsModal: true,
                showDropdown: false
            });
        };

        _this.hideTeamSettingsModal = function () {
            _this.setState({ showTeamSettingsModal: false });
        };

        _this.getFlagged = function (e) {
            e.preventDefault();
            _this.props.actions.showFlaggedPosts();
            _this.props.actions.closeRhsMenu();
        };

        _this.getStateFromStores = function () {
            return {
                currentUser: _user_store2.default.getCurrentUser(),
                teamMembers: _team_store2.default.getMyTeamMembers(),
                teamListings: _team_store2.default.getTeamListings()
            };
        };

        _this.onChange = function () {
            _this.setState(_this.getStateFromStores());
        };

        _this.searchMentions = function (e) {
            e.preventDefault();

            if (_this.props.isMentionSearch) {
                _this.props.actions.closeRightHandSide();
            } else {
                _this.props.actions.closeRhsMenu();
                _this.props.actions.showMentions();
            }
        };

        _this.showAccountSettingsModal = function () {
            GlobalActions.showAccountSettingsModal();
        };

        _this.handleEmitUserLoggedOutEvent = function () {
            GlobalActions.emitUserLoggedOutEvent();
        };

        _this.state = (0, _extends3.default)({}, _this.getStateFromStores(), {
            showAboutModal: false,
            showAddUsersToTeamModal: false,
            showTeamSettingsModal: false
        });
        return _this;
    }

    (0, _createClass3.default)(SidebarRightMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _team_store2.default.addChangeListener(this.onChange);
            _preference_store2.default.addChangeListener(this.onChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _team_store2.default.removeChangeListener(this.onChange);
            _preference_store2.default.removeChangeListener(this.onChange);
        }
    }, {
        key: 'render',
        value: function render() {
            var currentUser = _user_store2.default.getCurrentUser();
            var teamLink = void 0;
            var inviteLink = void 0;
            var addUserToTeamLink = void 0;
            var manageLink = void 0;
            var consoleLink = void 0;
            var joinAnotherTeamLink = void 0;
            var createTeam = null;

            if (currentUser != null) {
                inviteLink = _react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        teamId: this.props.teamId,
                        permissions: [_constants.Permissions.INVITE_USER]
                    },
                    _react2.default.createElement(
                        _team_permission_gate2.default,
                        {
                            teamId: this.props.teamId,
                            permissions: [_constants.Permissions.ADD_USER_TO_TEAM]
                        },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: GlobalActions.showInviteMemberModal
                                },
                                _react2.default.createElement('i', { className: 'icon fa fa-user-plus' }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar_right_menu.inviteNew',
                                    defaultMessage: 'Send Email Invite'
                                })
                            )
                        )
                    )
                );

                addUserToTeamLink = _react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        teamId: this.props.teamId,
                        permissions: [_constants.Permissions.ADD_USER_TO_TEAM]
                    },
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                            'a',
                            {
                                id: 'addUsersToTeam',
                                href: '#',
                                onClick: this.showAddUsersToTeamModal
                            },
                            _react2.default.createElement('i', { className: 'icon fa fa-user-plus' }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'sidebar_right_menu.addMemberToTeam',
                                defaultMessage: 'Add Members to Team'
                            })
                        )
                    )
                );

                if (this.props.teamType === _constants2.Constants.OPEN_TEAM && this.props.enableUserCreation) {
                    teamLink = _react2.default.createElement(
                        _team_permission_gate2.default,
                        {
                            teamId: this.props.teamId,
                            permissions: [_constants.Permissions.INVITE_USER]
                        },
                        _react2.default.createElement(
                            _team_permission_gate2.default,
                            {
                                teamId: this.props.teamId,
                                permissions: [_constants.Permissions.ADD_USER_TO_TEAM]
                            },
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'a',
                                    {
                                        href: '#',
                                        onClick: GlobalActions.showGetTeamInviteLinkModal
                                    },
                                    _react2.default.createElement('i', { className: 'icon fa fa-link' }),
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'sidebar_right_menu.teamLink',
                                        defaultMessage: 'Get Team Invite Link'
                                    })
                                )
                            )
                        )
                    );
                }

                var moreTeams = false;
                var isAlreadyMember = this.state.teamMembers.reduce(function (result, item) {
                    result[item.team_id] = true;
                    return result;
                }, {});

                for (var id in this.state.teamListings) {
                    if (this.state.teamListings.hasOwnProperty(id) && !isAlreadyMember[id]) {
                        moreTeams = true;
                        break;
                    }
                }

                if (moreTeams && !this.props.experimentalPrimaryTeam) {
                    joinAnotherTeamLink = _react2.default.createElement(
                        'li',
                        { key: 'joinTeam_li' },
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: '/select_team' },
                            _react2.default.createElement('i', { className: 'icon fa fa-plus-square' }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar_dropdown.join',
                                defaultMessage: 'Join Another Team'
                            })
                        )
                    );
                }

                createTeam = _react2.default.createElement(
                    _system_permission_gate2.default,
                    { permissions: [_constants.Permissions.CREATE_TEAM] },
                    _react2.default.createElement(
                        'li',
                        { key: 'newTeam_li' },
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            {
                                id: 'createTeam',
                                key: 'newTeam_a',
                                to: '/create_team',
                                onClick: this.handleClick
                            },
                            _react2.default.createElement('i', { className: 'icon fa fa-plus-square' }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar_dropdown.create',
                                defaultMessage: 'Create a New Team'
                            })
                        )
                    )
                );
            }

            manageLink = _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    _toggle_modal_button2.default,
                    { dialogType: _team_members_modal2.default },
                    _react2.default.createElement('i', { className: 'icon fa fa-users' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'sidebar_right_menu.viewMembers',
                        defaultMessage: 'View Members'
                    })
                )
            );

            var pluginItems = this.props.pluginMenuItems.map(function (item) {
                var MenuIcon = item.mobile_icon;
                return _react2.default.createElement(
                    'li',
                    { key: item.id + '_pluginrightmenuitem' },
                    _react2.default.createElement(
                        'a',
                        {
                            id: item.id + '_pluginrightmenuitem',
                            href: '#',
                            onClick: item.action
                        },
                        MenuIcon ? _react2.default.createElement(MenuIcon, null) : _react2.default.createElement('i', { className: 'icon fa fa-plus-square' }),
                        item.text
                    )
                );
            });

            var pluginDivider = null;
            if (pluginItems.length > 0) {
                pluginDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            var leaveTeam = '';
            if (!this.props.experimentalPrimaryTeam) {
                leaveTeam = _react2.default.createElement(
                    'li',
                    { key: 'leaveTeam_li' },
                    _react2.default.createElement(
                        'a',
                        {
                            id: 'leaveTeam',
                            href: '#',
                            onClick: GlobalActions.showLeaveTeamModal
                        },
                        _react2.default.createElement(_leave_team_icon2.default, { className: 'icon' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.leave',
                            defaultMessage: 'Leave Team'
                        })
                    )
                );
            }

            var teamSettingsLink = _react2.default.createElement(
                _team_permission_gate2.default,
                {
                    teamId: this.props.teamId,
                    permissions: [_constants.Permissions.MANAGE_TEAM]
                },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            onClick: this.showTeamSettingsModal
                        },
                        _react2.default.createElement('i', { className: 'icon fa fa-globe' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'sidebar_right_menu.teamSettings',
                            defaultMessage: 'Team Settings'
                        })
                    )
                )
            );
            manageLink = _react2.default.createElement(
                _team_permission_gate2.default,
                {
                    teamId: this.props.teamId,
                    permissions: [_constants.Permissions.MANAGE_TEAM]
                },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        _toggle_modal_button2.default,
                        {
                            dialogType: _team_members_modal2.default
                        },
                        _react2.default.createElement('i', { className: 'icon fa fa-users' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'sidebar_right_menu.manageMembers',
                            defaultMessage: 'Manage Members'
                        })
                    )
                )
            );

            if (!Utils.isMobile()) {
                consoleLink = _react2.default.createElement(
                    _system_permission_gate2.default,
                    { permissions: [_constants.Permissions.MANAGE_SYSTEM] },
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            {
                                to: '/admin_console',
                                onClick: this.handleClick
                            },
                            _react2.default.createElement('i', { className: 'icon fa fa-wrench' }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'sidebar_right_menu.console',
                                defaultMessage: 'System Console'
                            })
                        )
                    )
                );
            }

            var siteName = '';
            if (this.props.siteName != null) {
                siteName = this.props.siteName;
            }
            var teamDisplayName = siteName;
            if (this.props.teamDisplayName) {
                teamDisplayName = this.props.teamDisplayName;
            }

            var helpLink = null;
            if (this.props.helpLink) {
                helpLink = _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            to: this.props.helpLink
                        },
                        _react2.default.createElement('i', { className: 'icon fa fa-question' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'sidebar_right_menu.help',
                            defaultMessage: 'Help'
                        })
                    )
                );
            }

            var reportLink = null;
            if (this.props.reportAProblemLink) {
                reportLink = _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            to: this.props.reportAProblemLink
                        },
                        _react2.default.createElement('i', { className: 'icon fa fa-phone' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'sidebar_right_menu.report',
                            defaultMessage: 'Report a Problem'
                        })
                    )
                );
            }

            var tutorialTip = null;
            if (this.props.showTutorialTip) {
                tutorialTip = _react2.default.createElement(_menu_tutorial_tip2.default, { onBottom: true });
                this.props.actions.openRhsMenu();
            }

            var nativeAppLink = null;
            if (this.props.appDownloadLink && !UserAgent.isMobileApp()) {
                nativeAppLink = _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            to: (0, _url.useSafeUrl)(this.props.appDownloadLink)
                        },
                        _react2.default.createElement('i', { className: 'icon fa fa-mobile' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'sidebar_right_menu.nativeApps',
                            defaultMessage: 'Download Apps'
                        })
                    )
                );
            }

            var addUsersToTeamModal = void 0;
            if (this.state.showAddUsersToTeamModal) {
                addUsersToTeamModal = _react2.default.createElement(_add_users_to_team2.default, {
                    onModalDismissed: this.hideAddUsersToTeamModal
                });
            }

            var teamDivider = null;
            if (teamSettingsLink || manageLink || joinAnotherTeamLink || createTeam || leaveTeam) {
                teamDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            var consoleDivider = null;
            if (consoleLink) {
                consoleDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('sidebar--menu', { 'move--left': this.props.isOpen && Utils.isMobile() }),
                    id: 'sidebar-menu'
                },
                _react2.default.createElement(
                    'div',
                    { className: 'team__header theme' },
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            className: 'team__name',
                            to: '/channels/' + _constants2.Constants.DEFAULT_CHANNEL
                        },
                        teamDisplayName
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'nav-pills__container' },
                    tutorialTip,
                    _react2.default.createElement(
                        'ul',
                        { className: 'nav nav-pills nav-stacked' },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: this.searchMentions
                                },
                                _react2.default.createElement(
                                    'i',
                                    { className: 'icon mentions' },
                                    '@'
                                ),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar_right_menu.recentMentions',
                                    defaultMessage: 'Recent Mentions'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: this.getFlagged
                                },
                                _react2.default.createElement('i', { className: 'icon fa fa-flag' }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar_right_menu.flagged',
                                    defaultMessage: 'Flagged Posts'
                                })
                            )
                        ),
                        _react2.default.createElement('li', { className: 'divider' }),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: this.showAccountSettingsModal
                                },
                                _react2.default.createElement('i', { className: 'icon fa fa-cog' }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar_right_menu.accountSettings',
                                    defaultMessage: 'Account Settings'
                                })
                            )
                        ),
                        _react2.default.createElement('li', { className: 'divider' }),
                        inviteLink,
                        teamLink,
                        addUserToTeamLink,
                        teamDivider,
                        teamSettingsLink,
                        manageLink,
                        createTeam,
                        joinAnotherTeamLink,
                        leaveTeam,
                        pluginDivider,
                        pluginItems,
                        consoleDivider,
                        consoleLink,
                        _react2.default.createElement('li', { className: 'divider' }),
                        helpLink,
                        reportLink,
                        nativeAppLink,
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: this.handleAboutModal
                                },
                                _react2.default.createElement('i', { className: 'icon fa fa-info' }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'navbar_dropdown.about',
                                    defaultMessage: 'About Mattermost'
                                })
                            )
                        ),
                        _react2.default.createElement('li', { className: 'divider' }),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: this.handleEmitUserLoggedOutEvent
                                },
                                _react2.default.createElement('i', { className: 'icon fa fa-sign-out' }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar_right_menu.logout',
                                    defaultMessage: 'Logout'
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement(_about_build_modal2.default, {
                    show: this.state.showAboutModal,
                    onModalDismissed: this.aboutModalDismissed
                }),
                _react2.default.createElement(_team_settings_modal2.default, {
                    show: this.state.showTeamSettingsModal,
                    onModalDismissed: this.hideTeamSettingsModal
                }),
                addUsersToTeamModal
            );
        }
    }]);
    return SidebarRightMenu;
}(_react2.default.Component);

SidebarRightMenu.propTypes = {
    teamId: _propTypes2.default.string,
    isOpen: _propTypes2.default.bool.isRequired,
    teamType: _propTypes2.default.string,
    teamDisplayName: _propTypes2.default.string,
    isMentionSearch: _propTypes2.default.bool,
    showTutorialTip: _propTypes2.default.bool.isRequired,
    appDownloadLink: _propTypes2.default.string,
    enableUserCreation: _propTypes2.default.bool.isRequired,
    experimentalPrimaryTeam: _propTypes2.default.string,
    helpLink: _propTypes2.default.string,
    reportAProblemLink: _propTypes2.default.string,
    siteName: _propTypes2.default.string,
    pluginMenuItems: _propTypes2.default.arrayOf(_propTypes2.default.object),
    actions: _propTypes2.default.shape({
        showMentions: _propTypes2.default.func,
        showFlaggedPosts: _propTypes2.default.func,
        closeRightHandSide: _propTypes2.default.func.isRequired,
        openRhsMenu: _propTypes2.default.func.isRequired,
        closeRhsMenu: _propTypes2.default.func.isRequired
    })
};
SidebarRightMenu.defaultProps = {
    pluginMenuItems: []
};
exports.default = SidebarRightMenu;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _mattermost_logo = __webpack_require__(976);

var _mattermost_logo2 = _interopRequireDefault(_mattermost_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AboutBuildModal = function (_React$PureComponent) {
    (0, _inherits3.default)(AboutBuildModal, _React$PureComponent);

    function AboutBuildModal(props) {
        (0, _classCallCheck3.default)(this, AboutBuildModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AboutBuildModal.__proto__ || (0, _getPrototypeOf2.default)(AboutBuildModal)).call(this, props));

        _this.doHide = _this.doHide.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(AboutBuildModal, [{
        key: 'doHide',
        value: function doHide() {
            this.props.onModalDismissed();
        }
    }, {
        key: 'render',
        value: function render() {
            var config = this.props.config;
            var license = this.props.license;

            var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'about.teamEditiont0',
                defaultMessage: 'Team Edition'
            });

            var subTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'about.teamEditionSt',
                defaultMessage: 'All your team communication in one place, instantly searchable and accessible anywhere.'
            });

            var learnMore = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'about.teamEditionLearn',
                    defaultMessage: 'Join the Mattermost community at '
                }),
                _react2.default.createElement(
                    'a',
                    {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: 'http://www.mattermost.org/'
                    },
                    'mattermost.org'
                )
            );

            var licensee = void 0;
            if (config.BuildEnterpriseReady === 'true') {
                title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'about.teamEditiont1',
                    defaultMessage: 'Enterprise Edition'
                });

                subTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'about.enterpriseEditionSt',
                    defaultMessage: 'Modern communication from behind your firewall.'
                });

                learnMore = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'about.enterpriseEditionLearn',
                        defaultMessage: 'Learn more about Enterprise Edition at '
                    }),
                    _react2.default.createElement(
                        'a',
                        {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            href: 'http://about.mattermost.com/'
                        },
                        'about.mattermost.com'
                    )
                );

                if (license.IsLicensed === 'true') {
                    title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'about.enterpriseEditione1',
                        defaultMessage: 'Enterprise Edition'
                    });
                    licensee = _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'about.licensed',
                            defaultMessage: 'Licensed to:'
                        }),
                        '\xA0',
                        license.Company
                    );
                }
            }

            // Only show build number if it's a number (so only builds from Jenkins)
            var buildnumber = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'about.buildnumber',
                    defaultMessage: 'Build Number:'
                }),
                _react2.default.createElement(
                    'span',
                    { id: 'buildnumberString' },
                    '\xA0' + config.BuildNumber
                )
            );
            if (isNaN(config.BuildNumber)) {
                buildnumber = null;
            }

            var mmversion = config.BuildNumber;
            if (!isNaN(config.BuildNumber)) {
                mmversion = 'ci';
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'about-modal',
                    show: this.props.show,
                    onHide: this.doHide
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'about.title',
                            defaultMessage: 'About Mattermost'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'about-modal__content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'about-modal__logo' },
                            _react2.default.createElement(_mattermost_logo2.default, null)
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'h3',
                                { className: 'about-modal__title' },
                                'Mattermost',
                                ' ',
                                title
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'about-modal__subtitle padding-bottom' },
                                subTitle
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group less' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'about.version',
                                        defaultMessage: 'Mattermost Version:'
                                    }),
                                    _react2.default.createElement(
                                        'span',
                                        { id: 'versionString' },
                                        '\xA0' + mmversion
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'about.dbversion',
                                        defaultMessage: 'Database Schema Version:'
                                    }),
                                    _react2.default.createElement(
                                        'span',
                                        { id: 'dbversionString' },
                                        '\xA0' + config.Version
                                    )
                                ),
                                buildnumber,
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'about.database',
                                        defaultMessage: 'Database:'
                                    }),
                                    '\xA0' + config.SQLDriverName
                                )
                            ),
                            licensee
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'about-modal__footer' },
                        learnMore,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group about-modal__copyright' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'about.copyright',
                                defaultMessage: 'Copyright 2015 - {currentYear} Mattermost, Inc. All rights reserved',
                                values: {
                                    currentYear: new Date().getFullYear()
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'about-modal__notice form-group padding-top x2' },
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                id: 'about.notice',
                                defaultMessage: 'Mattermost is made possible by the open source software used in our <a href="https://about.mattermost.com/platform-notice-txt/" target="_blank">platform</a>, <a href="https://about.mattermost.com/desktop-notice-txt/" target="_blank">desktop</a> and <a href="https://about.mattermost.com/mobile-notice-txt/" target="_blank">mobile</a> apps.'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'about-modal__hash' },
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'about.hash',
                                defaultMessage: 'Build Hash:'
                            }),
                            '\xA0',
                            config.BuildHash,
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'about.hashee',
                                defaultMessage: 'EE Build Hash:'
                            }),
                            '\xA0',
                            config.BuildHashEnterprise,
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'about.hashwebapp',
                                defaultMessage: 'Webapp Build Hash:'
                            }),
                            '\xA0',
                            /* global COMMIT_HASH */this.props.webappBuildHash || ( false ? '' : "0493d8a9bb536429e29a792db95a46b141421981\n")
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'about.date',
                                defaultMessage: 'Build Date:'
                            }),
                            '\xA0',
                            config.BuildDate
                        )
                    )
                )
            );
        }
    }]);
    return AboutBuildModal;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

AboutBuildModal.defaultProps = {
    show: false
};
AboutBuildModal.propTypes = {

    /**
     * Determines whether modal is shown or not
     */
    show: _propTypes2.default.bool.isRequired,

    /**
     * Function that is called when the modal is dismissed
     */
    onModalDismissed: _propTypes2.default.func.isRequired,

    /**
     * Global config object
     */
    config: _propTypes2.default.object.isRequired,

    /**
     * Global license object
     */
    license: _propTypes2.default.object.isRequired,

    /**
     * Webapp build hash override. By default, webpack sets this (so it must be overridden in tests).
     */
    webappBuildHash: _propTypes2.default.string
};
exports.default = AboutBuildModal;

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _users = __webpack_require__(777);

var _team_actions = __webpack_require__(832);

var _user_actions = __webpack_require__(781);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var _multiselect = __webpack_require__(1050);

var _multiselect2 = _interopRequireDefault(_multiselect);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USERS_PER_PAGE = 50; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MAX_SELECTABLE_VALUES = 20;

var AddUsersToTeam = function (_React$Component) {
    (0, _inherits3.default)(AddUsersToTeam, _React$Component);

    function AddUsersToTeam(props) {
        (0, _classCallCheck3.default)(this, AddUsersToTeam);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddUsersToTeam.__proto__ || (0, _getPrototypeOf2.default)(AddUsersToTeam)).call(this, props));

        _this.setUsersLoadingState = function (loadingState) {
            _this.setState({
                loadingUsers: loadingState
            });
        };

        _this.handleHide = _this.handleHide.bind(_this);
        _this.handleExit = _this.handleExit.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleDelete = _this.handleDelete.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.search = _this.search.bind(_this);
        _this.addValue = _this.addValue.bind(_this);
        _this.handlePageChange = _this.handlePageChange.bind(_this);

        _this.searchTimeoutId = 0;

        _this.state = {
            users: (0, _assign2.default)([], _user_store2.default.getProfileListNotInTeam(_team_store2.default.getCurrentId(), true)),
            values: [],
            show: true,
            search: false,
            saving: false,
            addError: null,
            loadingUsers: true
        };
        return _this;
    }

    (0, _createClass3.default)(AddUsersToTeam, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _user_store2.default.addChangeListener(this.onChange);
            _user_store2.default.addNotInTeamChangeListener(this.onChange);
            _user_store2.default.addStatusesChangeListener(this.onChange);

            this.props.actions.getProfilesNotInTeam(_team_store2.default.getCurrentId(), 0, USERS_PER_PAGE * 2).then(function () {
                _this2.setUsersLoadingState(false);
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeChangeListener(this.onChange);
            _user_store2.default.removeNotInTeamChangeListener(this.onChange);
            _user_store2.default.removeStatusesChangeListener(this.onChange);
        }
    }, {
        key: 'handleHide',
        value: function handleHide() {
            this.setState({ show: false });
        }
    }, {
        key: 'handleExit',
        value: function handleExit() {
            if (this.props.onModalDismissed) {
                this.props.onModalDismissed();
            }
        }
    }, {
        key: 'handleResponse',
        value: function handleResponse(err) {
            var addError = null;
            if (err && err.message) {
                addError = err.message;
            }

            this.setState({
                saving: false,
                addError: addError
            });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var _this3 = this;

            if (e) {
                e.preventDefault();
            }

            var userIds = this.state.values.map(function (v) {
                return v.id;
            });
            if (userIds.length === 0) {
                return;
            }

            this.setState({ saving: true });

            (0, _team_actions.addUsersToTeam)(_team_store2.default.getCurrentId(), userIds, function () {
                _this3.handleResponse();
                _this3.handleHide();
            }, function (err) {
                _this3.handleResponse(err);
            });
        }
    }, {
        key: 'addValue',
        value: function addValue(value) {
            var values = (0, _assign2.default)([], this.state.values);
            var userIds = values.map(function (v) {
                return v.id;
            });
            if (value && value.id && userIds.indexOf(value.id) === -1) {
                values.push(value);
            }

            this.setState({ values: values });
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            var users = void 0;
            if (this.term) {
                users = (0, _assign2.default)([], (0, _users.searchProfilesNotInCurrentTeam)(_redux_store2.default.getState(), this.term, true));
            } else {
                users = (0, _assign2.default)([], _user_store2.default.getProfileListNotInTeam(_team_store2.default.getCurrentId(), true));
            }

            for (var i = 0; i < users.length; i++) {
                var user = (0, _assign2.default)({}, users[i]);
                users[i] = user;
            }

            this.setState({
                users: users
            });
        }
    }, {
        key: 'handlePageChange',
        value: function handlePageChange(page, prevPage) {
            var _this4 = this;

            if (page > prevPage) {
                this.setUsersLoadingState(true);
                this.props.actions.getProfilesNotInTeam(_team_store2.default.getCurrentId(), page + 1, USERS_PER_PAGE).then(function () {
                    _this4.setUsersLoadingState(false);
                });
            }
        }
    }, {
        key: 'search',
        value: function search(term) {
            var _this5 = this;

            clearTimeout(this.searchTimeoutId);
            this.term = term;

            if (term === '') {
                this.onChange();
                return;
            }

            this.searchTimeoutId = setTimeout(function () {
                _this5.setUsersLoadingState(true);
                (0, _user_actions.searchUsersNotInTeam)(term, _team_store2.default.getCurrentId(), {}).then(function () {
                    _this5.setUsersLoadingState(false);
                });
            }, _constants2.default.SEARCH_TIMEOUT_MILLISECONDS);
        }
    }, {
        key: 'handleDelete',
        value: function handleDelete(values) {
            this.setState({ values: values });
        }
    }, {
        key: 'renderOption',
        value: function renderOption(option, isSelected, onAdd) {
            var rowSelected = '';
            if (isSelected) {
                rowSelected = 'more-modal__row--selected';
            }

            return _react2.default.createElement(
                'div',
                {
                    key: option.id,
                    ref: isSelected ? 'selected' : option.id,
                    className: 'more-modal__row clickable ' + rowSelected,
                    onClick: function onClick() {
                        return onAdd(option);
                    }
                },
                _react2.default.createElement(_profile_picture2.default, {
                    src: _client.Client4.getProfilePictureUrl(option.id, option.last_picture_update),
                    width: '32',
                    height: '32'
                }),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'more-modal__details'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'more-modal__name' },
                        (0, _utils.displayEntireNameForUser)(option)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'more-modal__description' },
                        option.email
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__actions' },
                    _react2.default.createElement(
                        'div',
                        { className: 'more-modal__actions--round' },
                        _react2.default.createElement('i', { className: 'fa fa-plus' })
                    )
                )
            );
        }
    }, {
        key: 'renderValue',
        value: function renderValue(user) {
            return user.username;
        }
    }, {
        key: 'render',
        value: function render() {
            var numRemainingText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'multiselect.numPeopleRemaining',
                defaultMessage: 'Use \u2191\u2193 to browse, \u21B5 to select. You can add {num, number} more {num, plural, one {person} other {people}}. ',
                values: {
                    num: MAX_SELECTABLE_VALUES - this.state.values.length
                }
            });

            var buttonSubmitText = (0, _utils.localizeMessage)('multiselect.add', 'Add');

            var users = [];
            if (this.state.users) {
                users = this.state.users.filter(function (user) {
                    return user.delete_at === 0;
                });
            }

            var addError = null;
            if (this.state.addError) {
                addError = _react2.default.createElement(
                    'div',
                    { className: 'has-error col-sm-12' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label font-weight--normal' },
                        this.state.addError
                    )
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'more-modal more-direct-channels',
                    show: this.state.show,
                    onHide: this.handleHide,
                    onExited: this.handleExit
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'add_users_to_team.title',
                            defaultMessage: 'Add New Members To {teamName} Team',
                            values: {
                                teamName: _react2.default.createElement(
                                    'strong',
                                    null,
                                    _team_store2.default.getCurrent().display_name
                                )
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    addError,
                    _react2.default.createElement(_multiselect2.default, {
                        key: 'addUsersToTeamKey',
                        options: users,
                        optionRenderer: this.renderOption,
                        values: this.state.values,
                        valueKey: 'id',
                        valueRenderer: this.renderValue,
                        perPage: USERS_PER_PAGE,
                        handlePageChange: this.handlePageChange,
                        handleInput: this.search,
                        handleDelete: this.handleDelete,
                        handleAdd: this.addValue,
                        handleSubmit: this.handleSubmit,
                        maxValues: MAX_SELECTABLE_VALUES,
                        numRemainingText: numRemainingText,
                        buttonSubmitText: buttonSubmitText,
                        saving: this.state.saving,
                        loading: this.state.loadingUsers
                    })
                )
            );
        }
    }]);
    return AddUsersToTeam;
}(_react2.default.Component);

AddUsersToTeam.propTypes = {
    onModalDismissed: _propTypes2.default.func,
    actions: _propTypes2.default.shape({
        getProfilesNotInTeam: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = AddUsersToTeam;

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2094);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2095)();
}


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(2096);
var invariant = __webpack_require__(2097);
var ReactPropTypesSecret = __webpack_require__(2098);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2100)();
}


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(2101);
var invariant = __webpack_require__(2102);
var ReactPropTypesSecret = __webpack_require__(2103);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var KeyCodes = _constants2.default.KeyCodes;

var MultiSelectList = function (_React$Component) {
    (0, _inherits3.default)(MultiSelectList, _React$Component);

    function MultiSelectList(props) {
        (0, _classCallCheck3.default)(this, MultiSelectList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MultiSelectList.__proto__ || (0, _getPrototypeOf2.default)(MultiSelectList)).call(this, props));

        _this.defaultOptionRenderer = _this.defaultOptionRenderer.bind(_this);
        _this.handleArrowPress = _this.handleArrowPress.bind(_this);
        _this.setSelected = _this.setSelected.bind(_this);

        _this.toSelect = -1;

        _this.state = {
            selected: -1
        };
        return _this;
    }

    (0, _createClass3.default)(MultiSelectList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('keydown', this.handleArrowPress);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.handleArrowPress);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ selected: this.toSelect });

            var options = nextProps.options;

            if (options && options.length > 0 && this.toSelect >= 0) {
                this.props.onSelect(options[this.toSelect]);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.refs.list && this.refs.selected) {
                var elemTop = this.refs.selected.getBoundingClientRect().top;
                var elemBottom = this.refs.selected.getBoundingClientRect().bottom;
                var listTop = this.refs.list.getBoundingClientRect().top;
                var listBottom = this.refs.list.getBoundingClientRect().bottom;
                if (elemBottom > listBottom) {
                    this.refs.selected.scrollIntoView(false);
                } else if (elemTop < listTop) {
                    this.refs.selected.scrollIntoView(true);
                }
            }
        }
    }, {
        key: 'setSelected',
        value: function setSelected(selected) {
            this.toSelect = selected;
        }
    }, {
        key: 'handleArrowPress',
        value: function handleArrowPress(e) {
            if ((0, _utils.cmdOrCtrlPressed)(e) && e.shiftKey) {
                return;
            }

            var options = this.props.options;
            if (options.length === 0) {
                return;
            }

            var selected = void 0;
            switch (e.key) {
                case KeyCodes.DOWN[0]:
                    if (this.state.selected === -1) {
                        selected = 0;
                        break;
                    }
                    selected = Math.min(this.state.selected + 1, options.length - 1);
                    break;
                case KeyCodes.UP[0]:
                    if (this.state.selected === -1) {
                        selected = 0;
                        break;
                    }
                    selected = Math.max(this.state.selected - 1, 0);
                    break;
                default:
                    return;
            }

            e.preventDefault();
            this.setState({ selected: selected });
            this.props.onSelect(options[selected]);
        }
    }, {
        key: 'defaultOptionRenderer',
        value: function defaultOptionRenderer(option, isSelected, onAdd) {
            var rowSelected = '';
            if (isSelected) {
                rowSelected = 'more-modal__row--selected';
            }

            return _react2.default.createElement(
                'div',
                {
                    ref: isSelected ? 'selected' : option.value,
                    className: rowSelected,
                    key: 'multiselectoption' + option.value,
                    onClick: function onClick() {
                        return onAdd(option);
                    }
                },
                option.label
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var options = this.props.options;
            if (this.props.loading) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_loading_screen2.default, {
                        position: 'absolute',
                        key: 'loading'
                    })
                );
            }
            if (options == null || options.length === 0) {
                return _react2.default.createElement(
                    'div',
                    {
                        key: 'no-users-found',
                        className: 'no-channel-message'
                    },
                    _react2.default.createElement(
                        'p',
                        { className: 'primary-message' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'multiselect.list.notFound',
                            defaultMessage: 'No items found'
                        })
                    )
                );
            }

            var renderer = void 0;
            if (this.props.optionRenderer) {
                renderer = this.props.optionRenderer;
            } else {
                renderer = this.defaultOptionRenderer;
            }

            var optionControls = options.map(function (o, i) {
                return renderer(o, _this2.state.selected === i, _this2.props.onAdd);
            });

            return _react2.default.createElement(
                'div',
                { className: 'more-modal__list' },
                _react2.default.createElement(
                    'div',
                    {
                        ref: 'list'
                    },
                    optionControls
                )
            );
        }
    }]);
    return MultiSelectList;
}(_react2.default.Component);

exports.default = MultiSelectList;


MultiSelectList.defaultProps = {
    options: [],
    perPage: 50,
    onAction: function onAction() {
        return null;
    }
};

MultiSelectList.propTypes = {
    options: _propTypes2.default.arrayOf(_propTypes2.default.object),
    optionRenderer: _propTypes2.default.func,
    page: _propTypes2.default.number,
    perPage: _propTypes2.default.number,
    onPageChange: _propTypes2.default.func,
    onAdd: _propTypes2.default.func,
    onSelect: _propTypes2.default.func,
    loading: _propTypes2.default.bool
};

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeaveTeamIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(LeaveTeamIcon, _React$PureComponent);

    function LeaveTeamIcon() {
        (0, _classCallCheck3.default)(this, LeaveTeamIcon);
        return (0, _possibleConstructorReturn3.default)(this, (LeaveTeamIcon.__proto__ || (0, _getPrototypeOf2.default)(LeaveTeamIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(LeaveTeamIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '100%',
                        height: '100%',
                        viewBox: '0 0 164 164',
                        style: style
                    },
                    _react2.default.createElement('path', { d: 'M26.023,164L26.023,7.035L26.022,0.32L137.658,0.32L137.658,164L124.228,164L124.228, 13.749L39.452,13.749L39.452,164L26.023, 164ZM118.876,164L118.876,18.619L58.137,32.918L58.137,149.701L118.876,164Z' })
                )
            );
        }
    }]);
    return LeaveTeamIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = LeaveTeamIcon;


var style = {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    strokeLinejoin: 'round',
    strokeMiterlimit: 1.41421
};

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _member_list_team = __webpack_require__(2107);

var _member_list_team2 = _interopRequireDefault(_member_list_team);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeamMembersModal = function (_React$PureComponent) {
    (0, _inherits3.default)(TeamMembersModal, _React$PureComponent);

    function TeamMembersModal(props) {
        (0, _classCallCheck3.default)(this, TeamMembersModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamMembersModal.__proto__ || (0, _getPrototypeOf2.default)(TeamMembersModal)).call(this, props));

        _this.onHide = function () {
            _this.setState({ show: false });
        };

        _this.state = {
            show: true
        };
        return _this;
    }

    (0, _createClass3.default)(TeamMembersModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.onLoad) {
                this.props.onLoad();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var teamDisplayName = '';
            if (this.props.currentTeam) {
                teamDisplayName = this.props.currentTeam.display_name;
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'more-modal',
                    show: this.state.show,
                    onHide: this.onHide,
                    onExited: this.props.onHide
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_member_modal.members',
                            defaultMessage: '{team} Members',
                            values: {
                                team: teamDisplayName
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react2.default.createElement(_member_list_team2.default, {
                        teamId: this.props.currentTeam.id
                    })
                )
            );
        }
    }]);
    return TeamMembersModal;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

TeamMembersModal.propTypes = {

    /**
     * Current team object
     */
    currentTeam: _propTypes2.default.object.isRequired,

    /**
     * Function called when modal is dismissed
     */
    onHide: _propTypes2.default.func.isRequired,

    /**
     * Function called when modal is loaded
     */
    onLoad: _propTypes2.default.func
};
exports.default = TeamMembersModal;

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _teams = __webpack_require__(816);

var _roles = __webpack_require__(276);

var _constants = __webpack_require__(19);

var _member_list_team = __webpack_require__(2108);

var _member_list_team2 = _interopRequireDefault(_member_list_team);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var canManageTeamMembers = (0, _roles.haveITeamPermission)(state, { team: ownProps.teamId, permission: _constants.Permissions.MANAGE_TEAM_ROLES });
    return (0, _extends3.default)({
        canManageTeamMembers: canManageTeamMembers
    }, ownProps);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getTeamStats: _teams.getTeamStats
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_member_list_team2.default);

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _users = __webpack_require__(777);

var _user_actions = __webpack_require__(781);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _searchable_user_list_container = __webpack_require__(1334);

var _searchable_user_list_container2 = _interopRequireDefault(_searchable_user_list_container);

var _team_members_dropdown = __webpack_require__(2111);

var _team_members_dropdown2 = _interopRequireDefault(_team_members_dropdown);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USERS_PER_PAGE = 50; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MemberListTeam = function (_React$Component) {
    (0, _inherits3.default)(MemberListTeam, _React$Component);

    function MemberListTeam(props) {
        (0, _classCallCheck3.default)(this, MemberListTeam);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MemberListTeam.__proto__ || (0, _getPrototypeOf2.default)(MemberListTeam)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onStatsChange = _this.onStatsChange.bind(_this);
        _this.search = _this.search.bind(_this);
        _this.loadComplete = _this.loadComplete.bind(_this);

        _this.searchTimeoutId = 0;
        _this.term = '';

        var stats = _team_store2.default.getCurrentStats();

        _this.state = {
            users: _user_store2.default.getProfileListInTeam(),
            teamMembers: (0, _assign2.default)([], _team_store2.default.getMembersInTeam()),
            total: stats.active_member_count,
            loading: true
        };
        return _this;
    }

    (0, _createClass3.default)(MemberListTeam, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _user_store2.default.addInTeamChangeListener(this.onChange);
            _user_store2.default.addStatusesChangeListener(this.onChange);
            _team_store2.default.addChangeListener(this.onChange);
            _team_store2.default.addStatsChangeListener(this.onStatsChange);

            (0, _user_actions.loadProfilesAndTeamMembers)(0, _constants2.default.PROFILE_CHUNK_SIZE, _team_store2.default.getCurrentId(), this.loadComplete);
            this.props.actions.getTeamStats(_team_store2.default.getCurrentId());
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeInTeamChangeListener(this.onChange);
            _user_store2.default.removeStatusesChangeListener(this.onChange);
            _team_store2.default.removeChangeListener(this.onChange);
            _team_store2.default.removeStatsChangeListener(this.onStatsChange);
        }
    }, {
        key: 'loadComplete',
        value: function loadComplete() {
            this.setState({ loading: false });
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            var users = void 0;
            if (this.term) {
                users = (0, _users.searchProfilesInCurrentTeam)(_redux_store2.default.getState(), this.term);
            } else {
                users = _user_store2.default.getProfileListInTeam();
            }

            this.setState({ users: users, teamMembers: (0, _assign2.default)([], _team_store2.default.getMembersInTeam()) });
        }
    }, {
        key: 'onStatsChange',
        value: function onStatsChange() {
            var stats = _team_store2.default.getCurrentStats();
            this.setState({ total: stats.active_member_count });
        }
    }, {
        key: 'nextPage',
        value: function nextPage(page) {
            (0, _user_actions.loadProfilesAndTeamMembers)(page + 1, USERS_PER_PAGE);
        }
    }, {
        key: 'search',
        value: function search(term) {
            var _this2 = this;

            clearTimeout(this.searchTimeoutId);
            this.term = term;

            if (term === '') {
                this.setState({ loading: false });
                this.searchTimeoutId = '';
                this.onChange();
                return;
            }

            var searchTimeoutId = setTimeout(function () {
                (0, _user_actions.searchUsers)(term, _team_store2.default.getCurrentId(), {}, function (users) {
                    if (searchTimeoutId !== _this2.searchTimeoutId) {
                        return;
                    }
                    _this2.setState({ loading: true });
                    (0, _user_actions.loadTeamMembersForProfilesList)(users, _team_store2.default.getCurrentId(), _this2.loadComplete);
                });
            }, _constants2.default.SEARCH_TIMEOUT_MILLISECONDS);

            this.searchTimeoutId = searchTimeoutId;
        }
    }, {
        key: 'render',
        value: function render() {
            var teamMembersDropdown = null;
            if (this.props.canManageTeamMembers) {
                teamMembersDropdown = [_team_members_dropdown2.default];
            }

            var teamMembers = this.state.teamMembers;
            var users = this.state.users;
            var actionUserProps = {};

            var usersToDisplay = void 0;
            if (this.state.loading) {
                usersToDisplay = null;
            } else {
                usersToDisplay = [];

                for (var i = 0; i < users.length; i++) {
                    var user = users[i];

                    if (teamMembers[user.id] && user.delete_at === 0) {
                        usersToDisplay.push(user);
                        actionUserProps[user.id] = {
                            teamMember: teamMembers[user.id]
                        };
                    }
                }
            }

            return _react2.default.createElement(_searchable_user_list_container2.default, {
                users: usersToDisplay,
                usersPerPage: USERS_PER_PAGE,
                total: this.state.total,
                nextPage: this.nextPage,
                search: this.search,
                actions: teamMembersDropdown,
                actionUserProps: actionUserProps,
                focusOnMount: !UserAgent.isMobile()
            });
        }
    }]);
    return MemberListTeam;
}(_react2.default.Component);

MemberListTeam.propTypes = {
    teamId: _propTypes2.default.string.isRequired,
    canManageTeamMembers: _propTypes2.default.bool,
    actions: _propTypes2.default.shape({
        getTeamStats: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = MemberListTeam;

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _user_list_row = __webpack_require__(2110);

var _user_list_row2 = _interopRequireDefault(_user_list_row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var UserList = function (_React$Component) {
    (0, _inherits3.default)(UserList, _React$Component);

    function UserList(props) {
        (0, _classCallCheck3.default)(this, UserList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserList.__proto__ || (0, _getPrototypeOf2.default)(UserList)).call(this, props));

        _this.scrollToTop = _this.scrollToTop.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(UserList, [{
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (this.refs.container) {
                this.refs.container.scrollTop = 0;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var users = this.props.users;
            var RowComponentType = this.props.rowComponentType;

            var content = void 0;
            if (users == null) {
                return _react2.default.createElement(_loading_screen2.default, null);
            } else if (users.length > 0) {
                content = users.map(function (user, index) {
                    return _react2.default.createElement(RowComponentType, {
                        key: user.id,
                        user: user,
                        extraInfo: _this2.props.extraInfo[user.id],
                        actions: _this2.props.actions,
                        actionProps: _this2.props.actionProps,
                        actionUserProps: _this2.props.actionUserProps[user.id],
                        userCount: index >= 0 && index < _constants2.default.TEST_ID_COUNT ? index : -1
                    });
                });
            } else {
                content = _react2.default.createElement(
                    'div',
                    {
                        key: 'no-users-found',
                        className: 'more-modal__placeholder-row'
                    },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user_list.notFound',
                            defaultMessage: 'No users found'
                        })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { ref: 'container' },
                content
            );
        }
    }]);
    return UserList;
}(_react2.default.Component);

exports.default = UserList;


UserList.defaultProps = {
    users: [],
    extraInfo: {},
    actions: [],
    actionProps: {},
    rowComponentType: _user_list_row2.default
};

UserList.propTypes = {
    users: _propTypes2.default.arrayOf(_propTypes2.default.object),
    extraInfo: _propTypes2.default.object,
    actions: _propTypes2.default.arrayOf(_propTypes2.default.func),
    actionProps: _propTypes2.default.object,
    actionUserProps: _propTypes2.default.object,

    // the type of user list row to render
    rowComponentType: _propTypes2.default.func
};

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserListRow = function (_React$Component) {
    (0, _inherits3.default)(UserListRow, _React$Component);

    function UserListRow() {
        (0, _classCallCheck3.default)(this, UserListRow);
        return (0, _possibleConstructorReturn3.default)(this, (UserListRow.__proto__ || (0, _getPrototypeOf2.default)(UserListRow)).apply(this, arguments));
    }

    (0, _createClass3.default)(UserListRow, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var buttons = null;
            if (this.props.actions) {
                buttons = this.props.actions.map(function (Action, index) {
                    return _react2.default.createElement(Action, (0, _extends3.default)({
                        key: index.toString(),
                        user: _this2.props.user
                    }, _this2.props.actionProps, _this2.props.actionUserProps));
                });
            }

            // QUICK HACK, NEEDS A PROP FOR TOGGLING STATUS
            var email = this.props.user.email;
            var emailStyle = 'more-modal__description';
            var status = void 0;
            if (this.props.extraInfo && this.props.extraInfo.length > 0) {
                email = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.user_item.emailTitle',
                    defaultMessage: '<strong>Email:</strong> {email}',
                    values: {
                        email: this.props.user.email
                    }
                });
                emailStyle = '';
            } else if (this.props.user.status) {
                status = this.props.user.status;
            } else {
                status = _user_store2.default.getStatus(this.props.user.id);
            }

            var userCountID = null;
            var userCountEmail = null;
            if (this.props.userCount >= 0) {
                userCountID = Utils.createSafeId('userListRowName' + this.props.userCount);
                userCountEmail = Utils.createSafeId('userListRowEmail' + this.props.userCount);
            }

            return _react2.default.createElement(
                'div',
                {
                    key: this.props.user.id,
                    className: 'more-modal__row'
                },
                _react2.default.createElement(_profile_picture2.default, {
                    src: _client.Client4.getProfilePictureUrl(this.props.user.id, this.props.user.last_picture_update),
                    status: status,
                    width: '32',
                    height: '32'
                }),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'more-modal__details'
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            id: userCountID,
                            className: 'more-modal__name'
                        },
                        Utils.displayEntireNameForUser(this.props.user)
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            id: userCountEmail,
                            className: emailStyle
                        },
                        email
                    ),
                    this.props.extraInfo
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'more-modal__actions'
                    },
                    buttons
                )
            );
        }
    }]);
    return UserListRow;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

UserListRow.propTypes = {
    user: _propTypes2.default.object.isRequired,
    extraInfo: _propTypes2.default.arrayOf(_propTypes2.default.object),
    actions: _propTypes2.default.arrayOf(_propTypes2.default.func),
    actionProps: _propTypes2.default.object,
    actionUserProps: _propTypes2.default.object,
    userCount: _propTypes2.default.number
};
UserListRow.defaultProps = {
    extraInfo: [],
    actions: [],
    actionProps: {},
    actionUserProps: {}
};
exports.default = UserListRow;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _channels = __webpack_require__(798);

var _teams = __webpack_require__(816);

var _users = __webpack_require__(786);

var _team_members_dropdown = __webpack_require__(2112);

var _team_members_dropdown2 = _interopRequireDefault(_team_members_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getUser: _users.getUser,
            getTeamStats: _teams.getTeamStats,
            getChannelStats: _channels.getChannelStats
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_team_members_dropdown2.default);

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _team_actions = __webpack_require__(832);

var _user_actions = __webpack_require__(781);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeamMembersDropdown = function (_React$Component) {
    (0, _inherits3.default)(TeamMembersDropdown, _React$Component);

    function TeamMembersDropdown(props) {
        (0, _classCallCheck3.default)(this, TeamMembersDropdown);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamMembersDropdown.__proto__ || (0, _getPrototypeOf2.default)(TeamMembersDropdown)).call(this, props));

        _this.handleMakeMember = _this.handleMakeMember.bind(_this);
        _this.handleRemoveFromTeam = _this.handleRemoveFromTeam.bind(_this);
        _this.handleMakeActive = _this.handleMakeActive.bind(_this);
        _this.handleMakeNotActive = _this.handleMakeNotActive.bind(_this);
        _this.handleMakeAdmin = _this.handleMakeAdmin.bind(_this);
        _this.handleDemote = _this.handleDemote.bind(_this);
        _this.handleDemoteSubmit = _this.handleDemoteSubmit.bind(_this);
        _this.handleDemoteCancel = _this.handleDemoteCancel.bind(_this);

        _this.state = {
            serverError: null,
            showDemoteModal: false,
            user: null,
            role: null
        };
        return _this;
    }

    (0, _createClass3.default)(TeamMembersDropdown, [{
        key: 'handleMakeMember',
        value: function handleMakeMember() {
            var _this2 = this;

            var me = _user_store2.default.getCurrentUser();
            if (this.props.user.id === me.id && me.roles.includes('system_admin')) {
                this.handleDemote(this.props.user, 'team_user');
            } else {
                (0, _team_actions.updateTeamMemberRoles)(this.props.teamMember.team_id, this.props.user.id, 'team_user', function () {
                    _this2.props.actions.getUser(_this2.props.user.id);

                    if (_this2.props.user.id === me.id) {
                        (0, _user_actions.loadMyTeamMembers)();
                    }
                }, function (err) {
                    _this2.setState({ serverError: err.message });
                });
            }
        }
    }, {
        key: 'handleRemoveFromTeam',
        value: function handleRemoveFromTeam() {
            var _this3 = this;

            (0, _team_actions.removeUserFromTeam)(this.props.teamMember.team_id, this.props.user.id, function () {
                _user_store2.default.removeProfileFromTeam(_this3.props.teamMember.team_id, _this3.props.user.id);
                _user_store2.default.emitInTeamChange();
                _this3.props.actions.getTeamStats(_this3.props.teamMember.team_id);
            }, function (err) {
                _this3.setState({ serverError: err.message });
            });
        }
    }, {
        key: 'handleMakeActive',
        value: function handleMakeActive() {
            var _this4 = this;

            (0, _user_actions.updateActive)(this.props.user.id, true, function () {
                _this4.props.actions.getChannelStats(_channel_store2.default.getCurrentId());
                _this4.props.actions.getTeamStats(_this4.props.teamMember.team_id);
            }, function (err) {
                _this4.setState({ serverError: err.message });
            });
        }
    }, {
        key: 'handleMakeNotActive',
        value: function handleMakeNotActive() {
            var _this5 = this;

            (0, _user_actions.updateActive)(this.props.user.id, false, function () {
                _this5.props.actions.getChannelStats(_channel_store2.default.getCurrentId());
                _this5.props.actions.getTeamStats(_this5.props.teamMember.team_id);
            }, function (err) {
                _this5.setState({ serverError: err.message });
            });
        }
    }, {
        key: 'handleMakeAdmin',
        value: function handleMakeAdmin() {
            var _this6 = this;

            var me = _user_store2.default.getCurrentUser();
            if (this.props.user.id === me.id && me.roles.includes('system_admin')) {
                this.handleDemote(this.props.user, 'team_user team_admin');
            } else {
                (0, _team_actions.updateTeamMemberRoles)(this.props.teamMember.team_id, this.props.user.id, 'team_user team_admin', function () {
                    _this6.props.actions.getUser(_this6.props.user.id);
                }, function (err) {
                    _this6.setState({ serverError: err.message });
                });
            }
        }
    }, {
        key: 'handleDemote',
        value: function handleDemote(user, role, newRole) {
            this.setState({
                serverError: this.state.serverError,
                showDemoteModal: true,
                user: user,
                role: role,
                newRole: newRole
            });
        }
    }, {
        key: 'handleDemoteCancel',
        value: function handleDemoteCancel() {
            this.setState({
                serverError: null,
                showDemoteModal: false,
                user: null,
                role: null,
                newRole: null
            });
        }
    }, {
        key: 'handleDemoteSubmit',
        value: function handleDemoteSubmit() {
            var _this7 = this;

            (0, _team_actions.updateTeamMemberRoles)(this.props.teamMember.team_id, this.props.user.id, this.state.newRole, function () {
                _this7.props.actions.getUser(_this7.props.user.id);

                var teamUrl = _team_store2.default.getCurrentTeamUrl();
                if (teamUrl) {
                    _browser_history.browserHistory.push(teamUrl);
                } else {
                    _browser_history.browserHistory.push('/');
                }
            }, function (err) {
                _this7.setState({ serverError: err.message });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'has-error control-label' },
                        this.state.serverError
                    )
                );
            }

            var teamMember = this.props.teamMember;
            var user = this.props.user;
            var currentRoles = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'team_members_dropdown.member',
                defaultMessage: 'Member'
            });

            if (teamMember.roles.length > 0 && Utils.isAdmin(teamMember.roles)) {
                currentRoles = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_members_dropdown.teamAdmin',
                    defaultMessage: 'Team Admin'
                });
            }

            if (user.roles.length > 0 && Utils.isSystemAdmin(user.roles)) {
                currentRoles = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_members_dropdown.systemAdmin',
                    defaultMessage: 'System Admin'
                });
            }

            var me = _user_store2.default.getCurrentUser();
            var showMakeMember = Utils.isAdmin(teamMember.roles) && !Utils.isSystemAdmin(user.roles);
            var showMakeAdmin = !Utils.isAdmin(teamMember.roles) && !Utils.isSystemAdmin(user.roles);
            var showMakeActive = false;
            var showMakeNotActive = Utils.isSystemAdmin(user.roles);

            if (user.delete_at > 0) {
                currentRoles = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_members_dropdown.inactive',
                    defaultMessage: 'Inactive'
                });
                showMakeMember = false;
                showMakeAdmin = false;
                showMakeActive = true;
                showMakeNotActive = false;
            }

            var makeAdmin = null;
            if (showMakeAdmin) {
                makeAdmin = _react2.default.createElement(
                    'li',
                    { role: 'presentation' },
                    _react2.default.createElement(
                        'a',
                        {
                            role: 'menuitem',
                            href: '#',
                            onClick: this.handleMakeAdmin
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_members_dropdown.makeAdmin',
                            defaultMessage: 'Make Team Admin'
                        })
                    )
                );
            }

            var makeMember = null;
            if (showMakeMember) {
                makeMember = _react2.default.createElement(
                    'li',
                    { role: 'presentation' },
                    _react2.default.createElement(
                        'a',
                        {
                            role: 'menuitem',
                            href: '#',
                            onClick: this.handleMakeMember
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_members_dropdown.makeMember',
                            defaultMessage: 'Make Member'
                        })
                    )
                );
            }

            var removeFromTeam = null;
            if (this.props.user.id !== me.id) {
                removeFromTeam = _react2.default.createElement(
                    'li',
                    { role: 'presentation' },
                    _react2.default.createElement(
                        'a',
                        {
                            role: 'menuitem',
                            href: '#',
                            onClick: this.handleRemoveFromTeam
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_members_dropdown.leave_team',
                            defaultMessage: 'Remove From Team'
                        })
                    )
                );
            }

            var makeActive = null;
            if (showMakeActive) {
                // makeActive = (
                //     <li role='presentation'>
                //         <a
                //             role='menuitem'
                //             href='#'
                //             onClick={this.handleMakeActive}
                //         >
                //             <FormattedMessage
                //                 id='team_members_dropdown.makeActive'
                //                 defaultMessage='Activate'
                //             />
                //         </a>
                //     </li>
                // );
            }

            var makeNotActive = null;
            if (showMakeNotActive) {
                // makeNotActive = (
                //     <li role='presentation'>
                //         <a
                //             role='menuitem'
                //             href='#'
                //             onClick={this.handleMakeNotActive}
                //         >
                //             <FormattedMessage
                //                 id='team_members_dropdown.makeInactive'
                //                 defaultMessage='Deactivate'
                //             />
                //         </a>
                //     </li>
                // );
            }

            var makeDemoteModal = null;
            if (this.props.user.id === me.id) {
                var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_members_dropdown.confirmDemoteRoleTitle',
                    defaultMessage: 'Confirm demotion from System Admin role'
                });

                var message = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'team_members_dropdown.confirmDemoteDescription',
                        defaultMessage: 'If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you\'ll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.'
                    }),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'team_members_dropdown.confirmDemotionCmd',
                        defaultMessage: 'platform roles system_admin {username}',
                        vallues: {
                            username: me.username
                        }
                    }),
                    serverError
                );

                var confirmButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_members_dropdown.confirmDemotion',
                    defaultMessage: 'Confirm Demotion'
                });

                makeDemoteModal = _react2.default.createElement(_confirm_modal2.default, {
                    show: this.state.showDemoteModal,
                    title: title,
                    message: message,
                    confirmButtonText: confirmButton,
                    onConfirm: this.handleDemoteSubmit,
                    onCancel: this.handleDemoteCancel
                });
            }

            if (!removeFromTeam && !makeAdmin && !makeMember && !makeActive && !makeNotActive) {
                return _react2.default.createElement(
                    'div',
                    null,
                    currentRoles
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'dropdown member-drop' },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'dropdown-toggle theme color--link style--none',
                        type: 'button',
                        'data-toggle': 'dropdown',
                        'aria-expanded': 'true'
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        currentRoles,
                        ' '
                    ),
                    _react2.default.createElement('span', { className: 'fa fa-chevron-down' })
                ),
                _react2.default.createElement(
                    'ul',
                    {
                        className: 'dropdown-menu member-menu',
                        role: 'menu'
                    },
                    removeFromTeam,
                    makeAdmin,
                    makeMember,
                    makeActive,
                    makeNotActive
                ),
                makeDemoteModal,
                serverError
            );
        }
    }]);
    return TeamMembersDropdown;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

TeamMembersDropdown.propTypes = {
    user: _propTypes2.default.object.isRequired,
    teamMember: _propTypes2.default.object.isRequired,
    actions: _propTypes2.default.shape({
        getUser: _propTypes2.default.func.isRequired,
        getTeamStats: _propTypes2.default.func.isRequired,
        getChannelStats: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = TeamMembersDropdown;

/***/ }),
/* 2113 */,
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _team_general_tab = __webpack_require__(2115);

var _team_general_tab2 = _interopRequireDefault(_team_general_tab);

var _team_import_tab = __webpack_require__(2118);

var _team_import_tab2 = _interopRequireDefault(_team_import_tab);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TeamSettings = function (_React$Component) {
    (0, _inherits3.default)(TeamSettings, _React$Component);

    function TeamSettings(props) {
        (0, _classCallCheck3.default)(this, TeamSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamSettings.__proto__ || (0, _getPrototypeOf2.default)(TeamSettings)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);

        _this.state = { team: _team_store2.default.getCurrent() };
        return _this;
    }

    (0, _createClass3.default)(TeamSettings, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _team_store2.default.addChangeListener(this.onChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _team_store2.default.removeChangeListener(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            var team = _team_store2.default.getCurrent();

            if (!Utils.areObjectsEqual(this.state.team, team)) {
                this.setState({ team: team });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.team) {
                return null;
            }

            var result = void 0;
            switch (this.props.activeTab) {
                case 'general':
                    result = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_team_general_tab2.default, {
                            team: this.state.team,
                            activeSection: this.props.activeSection,
                            updateSection: this.props.updateSection,
                            closeModal: this.props.closeModal,
                            collapseModal: this.props.collapseModal
                        })
                    );
                    break;
                case 'import':
                    result = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_team_import_tab2.default, {
                            team: this.state.team,
                            activeSection: this.props.activeSection,
                            updateSection: this.props.updateSection,
                            closeModal: this.props.closeModal,
                            collapseModal: this.props.collapseModal
                        })
                    );
                    break;
                default:
                    result = _react2.default.createElement('div', null);
                    break;
            }

            return result;
        }
    }]);
    return TeamSettings;
}(_react2.default.Component);

exports.default = TeamSettings;


TeamSettings.defaultProps = {
    activeTab: '',
    activeSection: ''
};

TeamSettings.propTypes = {
    activeTab: _propTypes2.default.string.isRequired,
    activeSection: _propTypes2.default.string.isRequired,
    updateSection: _propTypes2.default.func.isRequired,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired
};

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _teams = __webpack_require__(816);

var _team_general_tab = __webpack_require__(2116);

var _team_general_tab2 = _interopRequireDefault(_team_general_tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var config = (0, _general.getConfig)(state);
    var maxFileSize = parseInt(config.MaxFileSize, 10);

    return (0, _extends3.default)({}, ownProps, {
        maxFileSize: maxFileSize
    });
} // Copyright (c) 2018 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            updateTeam: _teams.updateTeam,
            setTeamIcon: _teams.setTeamIcon
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_team_general_tab2.default);

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

var _setting_picture = __webpack_require__(1337);

var _setting_picture2 = _interopRequireDefault(_setting_picture);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACCEPTED_TEAM_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/bmp']; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var GeneralTab = function (_React$Component) {
    (0, _inherits3.default)(GeneralTab, _React$Component);

    function GeneralTab(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, GeneralTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GeneralTab.__proto__ || (0, _getPrototypeOf2.default)(GeneralTab)).call(this, props));

        _this.handleOpenInviteSubmit = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var state, data, _ref2, error;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = { serverError: '', clientError: '' };
                            data = (0, _extends3.default)({}, _this.props.team);

                            data.allow_open_invite = _this.state.allow_open_invite;

                            _context.next = 5;
                            return _this.props.actions.updateTeam(data);

                        case 5:
                            _ref2 = _context.sent;
                            error = _ref2.error;


                            if (error) {
                                state.serverError = error.message;
                                _this.setState(state);
                            } else {
                                _this.updateSection('');
                            }

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));
        _this.handleNameSubmit = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var state, valid, name, data, _ref4, error;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = { serverError: '', clientError: '' };
                            valid = true;
                            name = _this.state.name.trim();


                            if (!name) {
                                state.clientError = Utils.localizeMessage('general_tab.required', 'This field is required');
                                valid = false;
                            } else if (name.length < _constants2.default.MIN_TEAMNAME_LENGTH) {
                                state.clientError = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'general_tab.teamNameRestrictions',
                                    defaultMessage: 'Team Name must be {min} or more characters up to a maximum of {max}. You can add a longer team description.',
                                    values: {
                                        min: _constants2.default.MIN_TEAMNAME_LENGTH,
                                        max: _constants2.default.MAX_TEAMNAME_LENGTH
                                    }
                                });

                                valid = false;
                            } else {
                                state.clientError = '';
                            }

                            _this.setState(state);

                            if (valid) {
                                _context2.next = 7;
                                break;
                            }

                            return _context2.abrupt('return');

                        case 7:
                            data = (0, _extends3.default)({}, _this.props.team);

                            data.display_name = _this.state.name;

                            _context2.next = 11;
                            return _this.props.actions.updateTeam(data);

                        case 11:
                            _ref4 = _context2.sent;
                            error = _ref4.error;


                            if (error) {
                                state.serverError = error.message;
                                _this.setState(state);
                            } else {
                                _this.updateSection('');
                            }

                        case 14:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));
        _this.handleInviteIdSubmit = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
            var state, valid, inviteId, data, _ref6, error;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = { serverError: '', clientError: '' };
                            valid = true;
                            inviteId = _this.state.invite_id.trim();

                            if (inviteId) {
                                state.clientError = '';
                            } else {
                                state.clientError = Utils.localizeMessage('general_tab.required', 'This field is required');
                                valid = false;
                            }

                            _this.setState(state);

                            if (valid) {
                                _context3.next = 7;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 7:
                            data = (0, _extends3.default)({}, _this.props.team);

                            data.invite_id = _this.state.invite_id;

                            _context3.next = 11;
                            return _this.props.actions.updateTeam(data);

                        case 11:
                            _ref6 = _context3.sent;
                            error = _ref6.error;


                            if (error) {
                                state.serverError = error.message;
                                _this.setState(state);
                            } else {
                                _this.updateSection('');
                            }

                        case 14:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2);
        }));
        _this.handleDescriptionSubmit = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            var state, valid, description, data, _ref8, error;

            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = { serverError: '', clientError: '' };
                            valid = true;
                            description = _this.state.description.trim();

                            if (description === _this.props.team.description) {
                                state.clientError = Utils.localizeMessage('general_tab.chooseDescription', 'Please choose a new description for your team');
                                valid = false;
                            } else {
                                state.clientError = '';
                            }

                            _this.setState(state);

                            if (valid) {
                                _context4.next = 7;
                                break;
                            }

                            return _context4.abrupt('return');

                        case 7:
                            data = (0, _extends3.default)({}, _this.props.team);

                            data.description = _this.state.description;

                            _context4.next = 11;
                            return _this.props.actions.updateTeam(data);

                        case 11:
                            _ref8 = _context4.sent;
                            error = _ref8.error;


                            if (error) {
                                state.serverError = error.message;
                                _this.setState(state);
                            } else {
                                _this.updateSection('');
                            }

                        case 14:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this2);
        }));

        _this.handleTeamIconSubmit = function () {
            var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(e) {
                var _ref10, error;

                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                e.preventDefault();

                                if (_this.state.teamIconFile) {
                                    _context5.next = 3;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 3:
                                if (_this.state.submitActive) {
                                    _context5.next = 5;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 5:

                                _this.setState({
                                    clientError: '',
                                    serverError: ''
                                });

                                _this.setState({ loadingIcon: true });

                                _context5.next = 9;
                                return _this.props.actions.setTeamIcon(_this.props.team.id, _this.state.teamIconFile);

                            case 9:
                                _ref10 = _context5.sent;
                                error = _ref10.error;


                                if (error) {
                                    _this.setState({
                                        loadingIcon: false,
                                        serverError: error.message
                                    });
                                } else {
                                    _this.setState({
                                        loadingIcon: false,
                                        submitActive: false
                                    });
                                    _this.updateSection('');
                                }

                            case 12:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this2);
            }));

            return function (_x) {
                return _ref9.apply(this, arguments);
            };
        }();

        _this.handleUpdateSection = function (section) {
            _this.updateSection(section);
        };

        _this.updateSection = _this.updateSection.bind(_this);
        _this.handleNameSubmit = _this.handleNameSubmit.bind(_this);
        _this.handleInviteIdSubmit = _this.handleInviteIdSubmit.bind(_this);
        _this.handleOpenInviteSubmit = _this.handleOpenInviteSubmit.bind(_this);
        _this.handleDescriptionSubmit = _this.handleDescriptionSubmit.bind(_this);
        _this.handleTeamIconSubmit = _this.handleTeamIconSubmit.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);

        _this.updateName = _this.updateName.bind(_this);
        _this.updateDescription = _this.updateDescription.bind(_this);
        _this.updateTeamIcon = _this.updateTeamIcon.bind(_this);
        _this.updateInviteId = _this.updateInviteId.bind(_this);
        _this.handleOpenInviteRadio = _this.handleOpenInviteRadio.bind(_this);
        _this.handleGenerateInviteId = _this.handleGenerateInviteId.bind(_this);

        _this.state = _this.setupInitialState(props);
        return _this;
    }

    (0, _createClass3.default)(GeneralTab, [{
        key: 'updateSection',
        value: function updateSection(section) {
            if ((0, _jquery2.default)('.section-max').length) {
                (0, _jquery2.default)('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
            }
            this.setState(this.setupInitialState(this.props));
            this.props.updateSection(section);
        }
    }, {
        key: 'setupInitialState',
        value: function setupInitialState(props) {
            var team = props.team;

            return {
                name: team.display_name,
                invite_id: team.invite_id,
                allow_open_invite: team.allow_open_invite,
                description: team.description,
                serverError: '',
                clientError: '',
                teamIconFile: null,
                loadingIcon: false,
                submitActive: false
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                name: nextProps.team.display_name,
                description: nextProps.team.description,
                invite_id: nextProps.team.invite_id,
                allow_open_invite: nextProps.team.allow_open_invite
            });
        }
    }, {
        key: 'handleGenerateInviteId',
        value: function handleGenerateInviteId(e) {
            e.preventDefault();

            var newId = '';
            for (var i = 0; i < 32; i++) {
                newId += Math.floor(Math.random() * 16).toString(16);
            }

            this.setState({ invite_id: newId });
        }
    }, {
        key: 'handleOpenInviteRadio',
        value: function handleOpenInviteRadio(openInvite) {
            this.setState({ allow_open_invite: openInvite });
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.updateSection('');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _jquery2.default)('#team_settings').on('hidden.bs.modal', this.handleClose);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)('#team_settings').off('hidden.bs.modal', this.handleClose);
        }
    }, {
        key: 'updateName',
        value: function updateName(e) {
            this.setState({ name: e.target.value });
        }
    }, {
        key: 'updateDescription',
        value: function updateDescription(e) {
            this.setState({ description: e.target.value });
        }
    }, {
        key: 'updateTeamIcon',
        value: function updateTeamIcon(e) {
            if (e && e.target && e.target.files && e.target.files[0]) {
                var file = e.target.files[0];

                if (!ACCEPTED_TEAM_IMAGE_TYPES.includes(file.type)) {
                    this.setState({
                        clientError: Utils.localizeMessage('general_tab.teamIconInvalidFileType', 'Only BMP, JPG or PNG images may be used for team icons')
                    });
                } else if (file.size > this.props.maxFileSize) {
                    this.setState({
                        clientError: Utils.localizeMessage('general_tab.teamIconTooLarge', 'Unable to upload team icon. File is too large.')
                    });
                } else {
                    this.setState({
                        teamIconFile: e.target.files[0],
                        clientError: '',
                        submitActive: true
                    });
                }
            } else {
                this.setState({
                    teamIconFile: null,
                    clientError: Utils.localizeMessage('general_tab.teamIconError', 'An error occured while selecting the image.')
                });
            }
        }
    }, {
        key: 'updateInviteId',
        value: function updateInviteId(e) {
            this.setState({ invite_id: e.target.value });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var team = this.props.team;

            var clientError = null;
            var serverError = null;

            if (this.state.clientError) {
                clientError = this.state.clientError;
            }
            if (this.state.serverError) {
                serverError = this.state.serverError;
            }

            var openInviteSection = void 0;
            if (this.props.activeSection === 'open_invite') {
                var inputs = [_react2.default.createElement(
                    'div',
                    { key: 'userOpenInviteOptions' },
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'teamOpenInvite',
                                name: 'userOpenInviteOptions',
                                type: 'radio',
                                defaultChecked: this.state.allow_open_invite,
                                onChange: this.handleOpenInviteRadio.bind(this, true)
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'general_tab.yes',
                                defaultMessage: 'Yes'
                            })
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                id: 'teamOpenInviteNo',
                                name: 'userOpenInviteOptions',
                                type: 'radio',
                                defaultChecked: !this.state.allow_open_invite,
                                onChange: this.handleOpenInviteRadio.bind(this, false)
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'general_tab.no',
                                defaultMessage: 'No'
                            })
                        ),
                        _react2.default.createElement('br', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'general_tab.openInviteDesc',
                            defaultMessage: 'When allowed, a link to this team will be included on the landing page allowing anyone with an account to join this team.'
                        })
                    )
                )];

                openInviteSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('general_tab.openInviteTitle', 'Allow any user with an account on this server to join this team'),
                    inputs: inputs,
                    submit: this.handleOpenInviteSubmit,
                    serverError: serverError,
                    updateSection: this.handleUpdateSection
                });
            } else {
                var _describe = '';
                if (this.state.allow_open_invite === true) {
                    _describe = Utils.localizeMessage('general_tab.yes', 'Yes');
                } else {
                    _describe = Utils.localizeMessage('general_tab.no', 'No');
                }

                openInviteSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: Utils.localizeMessage('general_tab.openInviteTitle', 'Allow any user with an account on this server to join this team'),
                    describe: _describe,
                    updateSection: this.handleUpdateSection,
                    section: 'open_invite'
                });
            }

            var inviteSection = void 0;

            if (this.props.activeSection === 'invite_id') {
                var _inputs = [];

                _inputs.push(_react2.default.createElement(
                    'div',
                    { key: 'teamInviteSetting' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement('label', { className: 'col-sm-5 control-label visible-xs-block' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement('input', {
                                id: 'teamInviteId',
                                autoFocus: true,
                                className: 'form-control',
                                type: 'text',
                                onChange: this.updateInviteId,
                                value: this.state.invite_id,
                                maxLength: '32'
                            }),
                            _react2.default.createElement(
                                'div',
                                { className: 'padding-top x2' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        id: 'teamInviteIdRegenerate',
                                        className: 'color--link style--none',
                                        onClick: this.handleGenerateInviteId
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'general_tab.regenerate',
                                        defaultMessage: 'Regenerate'
                                    })
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'setting-list__hint' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'general_tab.codeLongDesc',
                            defaultMessage: 'The Invite Code is used as part of the URL in the team invitation link created by {getTeamInviteLink} in the main menu. Regenerating creates a new team invitation link and invalidates the previous link.',
                            values: {
                                getTeamInviteLink: _react2.default.createElement(
                                    'strong',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'general_tab.getTeamInviteLink',
                                        defaultMessage: 'Get Team Invite Link'
                                    })
                                )
                            }
                        })
                    )
                ));

                inviteSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('general_tab.codeTitle', 'Invite Code'),
                    inputs: _inputs,
                    submit: this.handleInviteIdSubmit,
                    serverError: serverError,
                    clientError: clientError,
                    updateSection: this.handleUpdateSection
                });
            } else {
                inviteSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: Utils.localizeMessage('general_tab.codeTitle', 'Invite Code'),
                    describe: Utils.localizeMessage('general_tab.codeDesc', "Click 'Edit' to regenerate Invite Code."),
                    updateSection: this.handleUpdateSection,
                    section: 'invite_id'
                });
            }

            var nameSection = void 0;

            if (this.props.activeSection === 'name') {
                var _inputs2 = [];

                var teamNameLabel = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'general_tab.teamName',
                    defaultMessage: 'Team Name'
                });
                if (Utils.isMobile()) {
                    teamNameLabel = '';
                }

                _inputs2.push(_react2.default.createElement(
                    'div',
                    {
                        key: 'teamNameSetting',
                        className: 'form-group'
                    },
                    _react2.default.createElement(
                        'label',
                        { className: 'col-sm-5 control-label' },
                        teamNameLabel
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-7' },
                        _react2.default.createElement('input', {
                            id: 'teamName',
                            autoFocus: true,
                            className: 'form-control',
                            type: 'text',
                            maxLength: _constants2.default.MAX_TEAMNAME_LENGTH.toString(),
                            onChange: this.updateName,
                            value: this.state.name
                        })
                    )
                ));

                var nameExtraInfo = _react2.default.createElement(
                    'span',
                    null,
                    Utils.localizeMessage('general_tab.teamNameInfo', 'Set the name of the team as it appears on your sign-in screen and at the top of the left-hand sidebar.')
                );

                nameSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('general_tab.teamName', 'Team Name'),
                    inputs: _inputs2,
                    submit: this.handleNameSubmit,
                    serverError: serverError,
                    clientError: clientError,
                    updateSection: this.handleUpdateSection,
                    extraInfo: nameExtraInfo
                });
            } else {
                var describe = this.state.name;

                nameSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: Utils.localizeMessage('general_tab.teamName', 'Team Name'),
                    describe: describe,
                    updateSection: this.handleUpdateSection,
                    section: 'name'
                });
            }

            var descriptionSection = void 0;

            if (this.props.activeSection === 'description') {
                var _inputs3 = [];

                var teamDescriptionLabel = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'general_tab.teamDescription',
                    defaultMessage: 'Team Description'
                });
                if (Utils.isMobile()) {
                    teamDescriptionLabel = '';
                }

                _inputs3.push(_react2.default.createElement(
                    'div',
                    {
                        key: 'teamDescriptionSetting',
                        className: 'form-group'
                    },
                    _react2.default.createElement(
                        'label',
                        { className: 'col-sm-5 control-label' },
                        teamDescriptionLabel
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-7' },
                        _react2.default.createElement('input', {
                            id: 'teamDescription',
                            autoFocus: true,
                            className: 'form-control',
                            type: 'text',
                            maxLength: _constants2.default.MAX_TEAMDESCRIPTION_LENGTH.toString(),
                            onChange: this.updateDescription,
                            value: this.state.description
                        })
                    )
                ));

                var descriptionExtraInfo = _react2.default.createElement(
                    'span',
                    null,
                    Utils.localizeMessage('general_tab.teamDescriptionInfo', 'Team description provides additional information to help users select the right team. Maximum of 50 characters.')
                );

                descriptionSection = _react2.default.createElement(_setting_item_max2.default, {
                    title: Utils.localizeMessage('general_tab.teamDescription', 'Team Description'),
                    inputs: _inputs3,
                    submit: this.handleDescriptionSubmit,
                    serverError: serverError,
                    clientError: clientError,
                    updateSection: this.handleUpdateSection,
                    extraInfo: descriptionExtraInfo
                });
            } else {
                var describemsg = '';
                if (this.state.description) {
                    describemsg = this.state.description;
                } else {
                    describemsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'general_tab.emptyDescription',
                        defaultMessage: 'Click \'Edit\' to add a team description.'
                    });
                }
                descriptionSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: Utils.localizeMessage('general_tab.teamDescription', 'Team Description'),
                    describe: describemsg,
                    updateSection: this.handleUpdateSection,
                    section: 'description'
                });
            }

            var teamIconSection = void 0;
            if (this.props.activeSection === 'team_icon') {
                teamIconSection = _react2.default.createElement(_setting_picture2.default, {
                    imageContext: 'team',
                    title: Utils.localizeMessage('general_tab.teamIcon', 'Team Icon'),
                    src: Utils.imageURLForTeam(team),
                    file: this.state.teamIconFile,
                    serverError: this.state.serverError,
                    clientError: this.state.clientError,
                    loadingPicture: this.state.loadingIcon,
                    submitActive: this.state.submitActive,
                    updateSection: function updateSection(e) {
                        _this3.updateSection('');
                        e.preventDefault();
                    },
                    onFileChange: this.updateTeamIcon,
                    submit: this.handleTeamIconSubmit
                });
            } else {
                var minMessage = void 0;

                if (team.last_team_icon_update) {
                    minMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'general_tab.teamIconLastUpdated',
                        defaultMessage: 'Image last updated {date}',
                        values: {
                            date: _react2.default.createElement(_reactIntl.FormattedDate, {
                                value: new Date(team.last_team_icon_update),
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                            })
                        }
                    });
                } else {
                    minMessage = Utils.isMobile() ? Utils.localizeMessage('general_tab.teamIconEditHintMobile', 'Click to upload an image.') : Utils.localizeMessage('general_tab.teamIconEditHint', 'Click \'Edit\' to upload an image.');
                }

                teamIconSection = _react2.default.createElement(_setting_item_min2.default, {
                    title: Utils.localizeMessage('general_tab.teamIcon', 'Team Icon'),
                    describe: minMessage,
                    section: 'team_icon',
                    updateSection: this.handleUpdateSection
                });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'closeButton',
                            type: 'button',
                            className: 'close',
                            'data-dismiss': 'modal',
                            'aria-label': 'Close',
                            onClick: this.props.closeModal
                        },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '×'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        {
                            className: 'modal-title',
                            ref: 'title'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-back' },
                            _react2.default.createElement('i', {
                                className: 'fa fa-angle-left',
                                onClick: this.props.collapseModal
                            })
                        ),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'general_tab.title',
                            defaultMessage: 'General Settings'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        ref: 'wrapper',
                        className: 'user-settings'
                    },
                    _react2.default.createElement(
                        'h3',
                        { className: 'tab-header' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'general_tab.title',
                            defaultMessage: 'General Settings'
                        })
                    ),
                    _react2.default.createElement('div', { className: 'divider-dark first' }),
                    nameSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    descriptionSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    teamIconSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    openInviteSection,
                    _react2.default.createElement('div', { className: 'divider-light' }),
                    inviteSection,
                    _react2.default.createElement('div', { className: 'divider-dark' })
                )
            );
        }
    }]);
    return GeneralTab;
}(_react2.default.Component);

GeneralTab.propTypes = {
    updateSection: _propTypes2.default.func.isRequired,
    team: _propTypes2.default.object.isRequired,
    activeSection: _propTypes2.default.string.isRequired,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired,
    maxFileSize: _propTypes2.default.number.isRequired,
    actions: _propTypes2.default.shape({
        updateTeam: _propTypes2.default.func.isRequired,
        setTeamIcon: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = GeneralTab;

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

var propMap = {
    r: 'rotate',
    ry: 'rotateY',
    t: 'translateX',
    ty: 'translateY',
}

var transformsMap = {
    '2': {
        ry: 180,
    },
    '3': {
        r: 180,
    },
    '4': {
        r: 180,
        ry: 180,
    },
    '5': {
        r: 270,
        ry: 180,
    },
    '6': {
        ty: -1,
        r: 90,
    },
    '7': {
        ty: -1,
        t: -1,
        r: 90,
        ry: 180,
    },
    '8': {
        t: -1,
        r: 270,
    },
}

var transformOriginMap = {
    '5': 'top left',
    '6': 'bottom left',
    '7': 'bottom right',
    '8': 'top right',
}

function expandTransforms(transforms) {
    var o = {}
    var expanded = false
    for (var prop in transforms) {
        if (!expanded) expanded = true
        var ep = propMap[prop]
        o[ep] = transforms[prop]
    }
    return expanded ? o : null
}

function getValue(prop, value) {
    if (prop === 'r' || prop === 'ry') {
        return value + 'deg'
    }
    if (prop === 't' || prop === 'ty') {
        return value * 100 + '%'
    }
}

function expandTransform(transforms) {
    var a = []
    for (var prop in transforms) {
        var ep = propMap[prop]
        a.push(ep + '(' + getValue(prop, transforms[prop]) + ')')
    }
    return a.length ? a.join(' ') : null
}


function expandTransformStrings(transforms) {
    var o = {}
    var expanded = false
    for (var prop in transforms) {
        if (!expanded) expanded = true
        var ep = propMap[prop]
        o[ep] = ep + '(' + getValue(prop, transforms[prop]) + ')'
    }
    return expanded ? o : null
}

function exif2css(orientation) {
    var s = String(orientation)
    var transforms = transformsMap[s]

    var transform = expandTransform(transforms)
    var transformOrigin = transformOriginMap[s]
    var allTransforms = expandTransforms(transforms)
    var allTransformStrings = expandTransformStrings(transforms)

    var css = {}
    if (transform) {
        css.transform = transform
    }
    if (transformOrigin) {
        css['transform-origin'] = transformOrigin
    }
    if (allTransforms) {
        css.transforms = allTransforms
    }
    if (allTransformStrings) {
        css.transformStrings = allTransformStrings
    }
    return css
}

module.exports = exif2css


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var utils = _interopRequireWildcard(_utils);

var _setting_upload = __webpack_require__(2119);

var _setting_upload2 = _interopRequireDefault(_setting_upload);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var holders = (0, _reactIntl.defineMessages)({
    importSlack: {
        id: 'team_import_tab.importSlack',
        defaultMessage: 'Import from Slack (Beta)'
    }
}); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TeamImportTab = function (_React$Component) {
    (0, _inherits3.default)(TeamImportTab, _React$Component);

    function TeamImportTab(props) {
        (0, _classCallCheck3.default)(this, TeamImportTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamImportTab.__proto__ || (0, _getPrototypeOf2.default)(TeamImportTab)).call(this, props));

        _this.onImportFailure = _this.onImportFailure.bind(_this);
        _this.onImportSuccess = _this.onImportSuccess.bind(_this);
        _this.doImportSlack = _this.doImportSlack.bind(_this);

        _this.state = {
            status: 'ready',
            link: ''
        };
        return _this;
    }

    (0, _createClass3.default)(TeamImportTab, [{
        key: 'onImportFailure',
        value: function onImportFailure() {
            this.setState({ status: 'fail' });
        }
    }, {
        key: 'onImportSuccess',
        value: function onImportSuccess(data) {
            this.setState({ status: 'done', link: 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(atob(data.results)) });
        }
    }, {
        key: 'doImportSlack',
        value: function doImportSlack(file) {
            this.setState({ status: 'in-progress', link: '' });
            utils.importSlack(file, this.onImportSuccess, this.onImportFailure);
        }
    }, {
        key: 'render',
        value: function render() {
            var formatMessage = this.props.intl.formatMessage;

            var uploadDocsLink = _react2.default.createElement(
                'a',
                {
                    href: 'https://docs.mattermost.com/administration/migrating.html#migrating-from-slack',
                    target: '_blank',
                    rel: 'noopener noreferrer'
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_import_tab.importHelpDocsLink',
                    defaultMessage: 'documentation'
                })
            );

            var uploadExportInstructions = _react2.default.createElement(
                'strong',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_import_tab.importHelpExportInstructions',
                    defaultMessage: 'Slack > Team Settings > Import/Export Data > Export > Start Export'
                })
            );

            var uploadExporterLink = _react2.default.createElement(
                'a',
                {
                    href: 'https://github.com/grundleborg/slack-advanced-exporter',
                    target: '_blank',
                    rel: 'noopener noreferrer'
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_import_tab.importHelpExporterLink',
                    defaultMessage: 'Slack Advanced Exporter'
                })
            );

            var uploadHelpText = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'team_import_tab.importHelpLine1',
                        defaultMessage: 'Slack import to Mattermost supports importing of messages in your Slack team\'s public channels.'
                    })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'team_import_tab.importHelpLine2',
                        defaultMessage: 'To import a team from Slack, go to {exportInstructions}. See {uploadDocsLink} to learn more.',
                        values: {
                            exportInstructions: uploadExportInstructions,
                            uploadDocsLink: uploadDocsLink
                        }
                    })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'team_import_tab.importHelpLine3',
                        defaultMessage: 'To import posts with attached files, see {slackAdvancedExporterLink} for details.',
                        values: {
                            slackAdvancedExporterLink: uploadExporterLink
                        }
                    })
                )
            );

            var uploadSection = _react2.default.createElement(_setting_upload2.default, {
                title: formatMessage(holders.importSlack),
                submit: this.doImportSlack,
                helpText: uploadHelpText,
                fileTypesAccepted: '.zip'
            });

            var messageSection;
            switch (this.state.status) {
                case 'ready':
                    messageSection = '';
                    break;
                case 'in-progress':
                    messageSection = _react2.default.createElement(
                        'p',
                        { className: 'confirm-import alert alert-warning' },
                        _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_import_tab.importing',
                            defaultMessage: ' Importing...'
                        })
                    );
                    break;
                case 'done':
                    messageSection = _react2.default.createElement(
                        'p',
                        { className: 'confirm-import alert alert-success' },
                        _react2.default.createElement('i', { className: 'fa fa-check' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_import_tab.successful',
                            defaultMessage: ' Import successful: '
                        }),
                        _react2.default.createElement(
                            'a',
                            {
                                href: this.state.link,
                                download: 'MattermostImportSummary.txt'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'team_import_tab.summary',
                                defaultMessage: 'View Summary'
                            })
                        )
                    );
                    break;
                case 'fail':
                    messageSection = _react2.default.createElement(
                        'p',
                        { className: 'confirm-import alert alert-warning' },
                        _react2.default.createElement('i', { className: 'fa fa-warning' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_import_tab.failure',
                            defaultMessage: ' Import failure: '
                        }),
                        _react2.default.createElement(
                            'a',
                            {
                                href: this.state.link,
                                download: 'MattermostImportSummary.txt'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'team_import_tab.summary',
                                defaultMessage: 'View Summary'
                            })
                        )
                    );
                    break;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'close',
                            'data-dismiss': 'modal',
                            'aria-label': 'Close',
                            onClick: this.props.closeModal
                        },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '×'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        {
                            className: 'modal-title',
                            ref: 'title'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-back' },
                            _react2.default.createElement('i', {
                                className: 'fa fa-angle-left',
                                onClick: this.props.collapseModal
                            })
                        ),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_import_tab.import',
                            defaultMessage: 'Import'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        ref: 'wrapper',
                        className: 'user-settings'
                    },
                    _react2.default.createElement(
                        'h3',
                        { className: 'tab-header' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_import_tab.import',
                            defaultMessage: 'Import'
                        })
                    ),
                    _react2.default.createElement('div', { className: 'divider-dark first' }),
                    uploadSection,
                    _react2.default.createElement('div', { className: 'divider-dark' }),
                    messageSection
                )
            );
        }
    }]);
    return TeamImportTab;
}(_react2.default.Component);

TeamImportTab.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    closeModal: _propTypes2.default.func.isRequired,
    collapseModal: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(TeamImportTab);

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsUpload = function (_React$Component) {
    (0, _inherits3.default)(SettingsUpload, _React$Component);

    function SettingsUpload(props) {
        (0, _classCallCheck3.default)(this, SettingsUpload);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SettingsUpload.__proto__ || (0, _getPrototypeOf2.default)(SettingsUpload)).call(this, props));

        _this.doFileSelect = _this.doFileSelect.bind(_this);
        _this.doSubmit = _this.doSubmit.bind(_this);

        _this.state = {
            clientError: _this.props.clientError,
            serverError: _this.props.serverError,
            filename: ''
        };
        return _this;
    }

    (0, _createClass3.default)(SettingsUpload, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            this.setState({
                clientError: this.props.clientError,
                serverError: this.props.serverError
            });
        }
    }, {
        key: 'doFileSelect',
        value: function doFileSelect(e) {
            e.preventDefault();
            var filename = (0, _jquery2.default)(e.target).val();
            if (filename.substring(3, 11) === 'fakepath') {
                filename = filename.substring(12);
            }
            this.setState({
                clientError: '',
                serverError: '',
                filename: filename
            });
        }
    }, {
        key: 'doSubmit',
        value: function doSubmit(e) {
            e.preventDefault();
            var inputnode = _reactDom2.default.findDOMNode(this.refs.uploadinput);
            if (inputnode.files && inputnode.files[0]) {
                this.props.submit(inputnode.files[0]);
            } else {
                this.setState({ clientError: true });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var clientError = null;
            if (this.state.clientError) {
                clientError = _react2.default.createElement(
                    'div',
                    { className: 'file-status' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'setting_upload.noFile',
                        defaultMessage: 'No file selected.'
                    })
                );
            }
            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'file-status' },
                    this.state.serverError
                );
            }
            var fileNameText = null;
            var submitButtonClass = 'btn btn-sm btn-primary disabled';
            if (this.state.filename) {
                fileNameText = _react2.default.createElement(
                    'div',
                    { className: 'file-status file-name' },
                    this.state.filename
                );
                submitButtonClass = 'btn btn-sm btn-primary';
            }

            return _react2.default.createElement(
                'ul',
                { className: 'section-max' },
                _react2.default.createElement(
                    'li',
                    { className: 'col-sm-12 section-title' },
                    this.props.title
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'col-sm-offset-3 col-sm-9' },
                    this.props.helpText
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'col-sm-offset-3 col-sm-9' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'setting-list' },
                        _react2.default.createElement(
                            'li',
                            { className: 'setting-list-item' },
                            _react2.default.createElement(
                                'span',
                                { className: 'btn btn-sm btn-primary btn-file sel-btn' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'setting_upload.select',
                                    defaultMessage: 'Select file'
                                }),
                                _react2.default.createElement('input', {
                                    ref: 'uploadinput',
                                    accept: this.props.fileTypesAccepted,
                                    type: 'file',
                                    onChange: this.doFileSelect
                                })
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    className: submitButtonClass,
                                    onClick: this.doSubmit
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'setting_upload.import',
                                    defaultMessage: 'Import'
                                })
                            ),
                            fileNameText,
                            serverError,
                            clientError
                        )
                    )
                )
            );
        }
    }]);
    return SettingsUpload;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = SettingsUpload;


SettingsUpload.propTypes = {
    title: _propTypes2.default.string.isRequired,
    submit: _propTypes2.default.func.isRequired,
    fileTypesAccepted: _propTypes2.default.string.isRequired,
    clientError: _propTypes2.default.string,
    serverError: _propTypes2.default.string,
    helpText: _propTypes2.default.object
};

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _diagnostics_actions = __webpack_require__(804);

var _user_actions = __webpack_require__(781);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _tutorialTip = __webpack_require__(2121);

var _tutorialTip2 = _interopRequireDefault(_tutorialTip);

var _tutorialTipWhite = __webpack_require__(2122);

var _tutorialTipWhite2 = _interopRequireDefault(_tutorialTipWhite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Preferences = _constants2.default.Preferences; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TutorialSteps = _constants2.default.TutorialSteps;

var TutorialTip = function (_React$Component) {
    (0, _inherits3.default)(TutorialTip, _React$Component);

    function TutorialTip(props) {
        (0, _classCallCheck3.default)(this, TutorialTip);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TutorialTip.__proto__ || (0, _getPrototypeOf2.default)(TutorialTip)).call(this, props));

        _this.show = function () {
            _this.setState({ show: true });
        };

        _this.hide = function () {
            _this.setState({ show: false });
        };

        _this.handleNext = function () {
            if (_this.state.currentScreen < _this.props.screens.length - 1) {
                _this.setState({ currentScreen: _this.state.currentScreen + 1 });
                return;
            }

            if (_this.props.diagnosticsTag) {
                var tag = _this.props.diagnosticsTag;

                if (_this.props.screens.length > 1) {
                    tag += '_' + (_this.state.currentScreen + 1).toString();
                }

                if (_this.state.currentScreen === _this.props.screens.length - 1) {
                    tag += '_okay';
                } else {
                    tag += '_next';
                }

                (0, _diagnostics_actions.trackEvent)('tutorial', tag);
            }

            _this.props.actions.closeRhsMenu();
            _this.hide();

            var step = _preference_store2.default.getInt(Preferences.TUTORIAL_STEP, _user_store2.default.getCurrentId(), 0);
            (0, _user_actions.savePreference)(Preferences.TUTORIAL_STEP, _user_store2.default.getCurrentId(), (step + 1).toString());
        };

        _this.skipTutorial = function (e) {
            e.preventDefault();

            if (_this.props.diagnosticsTag) {
                var tag = _this.props.diagnosticsTag;
                if (_this.props.screens.length > 1) {
                    tag += '_' + _this.state.currentScreen;
                }
                tag += '_skip';
                (0, _diagnostics_actions.trackEvent)('tutorial', tag);
            }

            (0, _user_actions.savePreference)(Preferences.TUTORIAL_STEP, _user_store2.default.getCurrentId(), TutorialSteps.FINISHED.toString());
        };

        _this.handleCircleClick = function (e, screen) {
            e.preventDefault();
            _this.setState({ currentScreen: screen });
        };

        _this.getTarget = function () {
            return _this.refs.target;
        };

        _this.state = { currentScreen: 0, show: false };
        return _this;
    }

    (0, _createClass3.default)(TutorialTip, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var buttonText = this.state.currentScreen === this.props.screens.length - 1 ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'tutorial_tip.ok',
                defaultMessage: 'Okay'
            }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'tutorial_tip.next',
                defaultMessage: 'Next'
            });

            var dots = [];
            if (this.props.screens.length > 1) {
                var _loop = function _loop(i) {
                    var className = 'circle';
                    if (i === _this2.state.currentScreen) {
                        className += ' active';
                    }

                    dots.push(_react2.default.createElement('a', {
                        href: '#',
                        key: 'dotactive' + i,
                        className: className,
                        'data-screen': i,
                        onClick: function onClick(e) {
                            return _this2.handleCircleClick(e, i);
                        }
                    }));
                };

                for (var i = 0; i < this.props.screens.length; i++) {
                    _loop(i);
                }
            }

            var tutorialGifImage = _tutorialTip2.default;
            if (this.props.overlayClass === 'tip-overlay--header' || this.props.overlayClass === 'tip-overlay--sidebar' || this.props.overlayClass === 'tip-overlay--header--up') {
                tutorialGifImage = _tutorialTipWhite2.default;
            }

            return _react2.default.createElement(
                'div',
                {
                    id: 'tipButton',
                    className: 'tip-div ' + this.props.overlayClass,
                    onClick: this.show
                },
                _react2.default.createElement('img', {
                    className: 'tip-button',
                    src: tutorialGifImage,
                    width: '35',
                    onClick: this.show,
                    ref: 'target'
                }),
                _react2.default.createElement(
                    _reactBootstrap.Overlay,
                    {
                        show: this.state.show
                    },
                    _react2.default.createElement('div', { className: 'tip-backdrop' })
                ),
                _react2.default.createElement(
                    _reactBootstrap.Overlay,
                    {
                        placement: this.props.placement,
                        show: this.state.show,
                        rootClose: true,
                        onHide: this.hide,
                        target: this.getTarget
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'tip-overlay ' + this.props.overlayClass },
                        _react2.default.createElement('div', { className: 'arrow' }),
                        this.props.screens[this.state.currentScreen],
                        _react2.default.createElement(
                            'div',
                            { className: 'tutorial__footer' },
                            _react2.default.createElement(
                                'div',
                                { className: 'tutorial__circles' },
                                dots
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'text-right' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        id: 'tipNextButton',
                                        className: 'btn btn-primary',
                                        onClick: this.handleNext
                                    },
                                    buttonText
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'tip-opt' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'tutorial_tip.seen',
                                        defaultMessage: 'Seen this before? '
                                    }),
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            href: '#',
                                            onClick: this.skipTutorial
                                        },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'tutorial_tip.out',
                                            defaultMessage: 'Opt out of these tips.'
                                        })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return TutorialTip;
}(_react2.default.Component);

exports.default = TutorialTip;


TutorialTip.defaultProps = {
    overlayClass: ''
};

TutorialTip.propTypes = {
    screens: _propTypes2.default.array.isRequired,
    placement: _propTypes2.default.string.isRequired,
    overlayClass: _propTypes2.default.string,
    diagnosticsTag: _propTypes2.default.string,
    actions: _propTypes2.default.shape({
        closeRhsMenu: _propTypes2.default.func.isRequired
    })
};

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/f89e113dbd8096fa76dd9ecca67ea57c.gif";

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/f5a93efd142cd455d2f3d2b6cfa0e17e.gif";

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ImportThemeModal = function (_React$Component) {
    (0, _inherits3.default)(ImportThemeModal, _React$Component);

    function ImportThemeModal(props) {
        (0, _classCallCheck3.default)(this, ImportThemeModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ImportThemeModal.__proto__ || (0, _getPrototypeOf2.default)(ImportThemeModal)).call(this, props));

        _this.updateShow = function (show, args) {
            _this.setState({
                show: show,
                callback: args.callback
            });
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var text = _this.state.value;

            if (!_this.isInputValid(text)) {
                _this.setState({
                    inputError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.import_theme.submitError',
                        defaultMessage: 'Invalid format, please try copying and pasting in again.'
                    })
                });
                return;
            }

            var colors = text.split(',');
            var theme = { type: 'custom' };

            theme.sidebarBg = colors[0];
            theme.sidebarText = colors[5];
            theme.sidebarUnreadText = colors[5];
            theme.sidebarTextHoverBg = colors[4];
            theme.sidebarTextActiveBorder = colors[2];
            theme.sidebarTextActiveColor = colors[3];
            theme.sidebarHeaderBg = colors[1];
            theme.sidebarHeaderTextColor = colors[5];
            theme.onlineIndicator = colors[6];
            theme.awayIndicator = '#E0B333';
            theme.mentionBg = colors[7];
            theme.mentionColor = '#ffffff';
            theme.centerChannelBg = '#ffffff';
            theme.centerChannelColor = '#333333';
            theme.newMessageSeparator = '#F80';
            theme.linkColor = '#2389d7';
            theme.buttonBg = '#26a970';
            theme.buttonColor = '#ffffff';
            theme.mentionHighlightBg = '#fff2bb';
            theme.mentionHighlightLink = '#2f81b7';
            theme.codeTheme = 'github';

            _this.state.callback(theme);
            _this.setState({
                show: false,
                callback: null
            });
        };

        _this.handleChange = function (e) {
            var value = e.target.value;
            _this.setState({ value: value });

            if (_this.isInputValid(value)) {
                _this.setState({ inputError: null });
            } else {
                _this.setState({
                    inputError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.import_theme.submitError',
                        defaultMessage: 'Invalid format, please try copying and pasting in again.'
                    })
                });
            }
        };

        _this.handleOnHide = function () {
            _this.setState({ show: false });
        };

        _this.state = {
            value: '',
            inputError: '',
            show: false,
            callback: null
        };
        return _this;
    }

    (0, _createClass3.default)(ImportThemeModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _modal_store2.default.addModalListener(ActionTypes.TOGGLE_IMPORT_THEME_MODAL, this.updateShow);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _modal_store2.default.removeModalListener(ActionTypes.TOGGLE_IMPORT_THEME_MODAL, this.updateShow);
        }
    }, {
        key: 'isInputValid',
        value: function isInputValid(text) {
            if (text.length === 0) {
                return false;
            }

            if (text.indexOf(' ') !== -1) {
                return false;
            }

            if (text.length > 0 && text.indexOf(',') === -1) {
                return false;
            }

            if (text.length > 0) {
                var colors = text.split(',');

                if (colors.length !== 8) {
                    return false;
                }

                for (var i = 0; i < colors.length; i++) {
                    if (colors[i].length !== 7 && colors[i].length !== 4) {
                        return false;
                    }

                    if (colors[i].charAt(0) !== '#') {
                        return false;
                    }
                }
            }

            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    _reactBootstrap.Modal,
                    {
                        show: this.state.show,
                        onHide: this.handleOnHide
                    },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Header,
                        { closeButton: true },
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Title,
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'user.settings.import_theme.importHeader',
                                defaultMessage: 'Import Slack Theme'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'form',
                        {
                            role: 'form',
                            className: 'form-horizontal'
                        },
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Body,
                            null,
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.import_theme.importBody',
                                    defaultMessage: 'To import a theme, go to a Slack team and look for "Preferences -> Sidebar Theme". Open the custom theme option, copy the theme color values and paste them here:'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group less' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12' },
                                    _react2.default.createElement('input', {
                                        id: 'themeVector',
                                        type: 'text',
                                        className: 'form-control',
                                        value: this.state.value,
                                        onChange: this.handleChange
                                    }),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input__help' },
                                        this.state.inputError
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Footer,
                            null,
                            _react2.default.createElement(
                                'button',
                                {
                                    id: 'cancelButton',
                                    type: 'button',
                                    className: 'btn btn-default',
                                    onClick: this.handleOnHide
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.import_theme.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            ),
                            _react2.default.createElement(
                                'button',
                                {
                                    id: 'submitButton',
                                    onClick: this.handleSubmit,
                                    type: 'submit',
                                    className: 'btn btn-primary',
                                    tabIndex: '3'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'user.settings.import_theme.submit',
                                    defaultMessage: 'Submit'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return ImportThemeModal;
}(_react2.default.Component);

exports.default = ImportThemeModal;

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _user_settings_modal = __webpack_require__(2125);

var _user_settings_modal2 = _interopRequireDefault(_user_settings_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    var closeUnusedDirectMessages = config.CloseUnusedDirectMessages === 'true';
    var experimentalGroupUnreadChannels = config.ExperimentalGroupUnreadChannels;

    return {
        closeUnusedDirectMessages: closeUnusedDirectMessages,
        experimentalGroupUnreadChannels: experimentalGroupUnreadChannels
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_user_settings_modal2.default);

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

var _async_load = __webpack_require__(282);

var _user_settings = __webpack_require__(2126);

var _user_settings2 = _interopRequireDefault(_user_settings);

var _settings_sidebar = __webpack_require__(1336);

var _settings_sidebar2 = _interopRequireDefault(_settings_sidebar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var holders = (0, _reactIntl.defineMessages)({
    general: {
        id: 'user.settings.modal.general',
        defaultMessage: 'General'
    },
    security: {
        id: 'user.settings.modal.security',
        defaultMessage: 'Security'
    },
    notifications: {
        id: 'user.settings.modal.notifications',
        defaultMessage: 'Notifications'
    },
    display: {
        id: 'user.settings.modal.display',
        defaultMessage: 'Display'
    },
    sidebar: {
        id: 'user.settings.modal.sidebar',
        defaultMessage: 'Sidebar'
    },
    advanced: {
        id: 'user.settings.modal.advanced',
        defaultMessage: 'Advanced'
    },
    confirmTitle: {
        id: 'user.settings.modal.confirmTitle',
        defaultMessage: 'Discard Changes?'
    },
    confirmMsg: {
        id: 'user.settings.modal.confirmMsg',
        defaultMessage: 'You have unsaved changes, are you sure you want to discard them?'
    },
    confirmBtns: {
        id: 'user.settings.modal.confirmBtns',
        defaultMessage: 'Yes, Discard'
    }
});

var UserSettingsModal = function (_React$Component) {
    (0, _inherits3.default)(UserSettingsModal, _React$Component);

    function UserSettingsModal(props) {
        (0, _classCallCheck3.default)(this, UserSettingsModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserSettingsModal.__proto__ || (0, _getPrototypeOf2.default)(UserSettingsModal)).call(this, props));

        _this.onUserChanged = function () {
            if (_this.mounted) {
                _this.setState({ currentUser: _user_store2.default.getCurrentUser() });
            }
        };

        _this.handleKeyDown = function (e) {
            if (Utils.cmdOrCtrlPressed(e) && e.shiftKey && Utils.isKeyPressed(e, _constants2.default.KeyCodes.A)) {
                _this.setState({
                    show: !_this.state.show
                });
            }
        };

        _this.handleToggle = function (value) {
            _this.setState({
                show: value
            });
        };

        _this.handleHide = function () {
            if (_this.requireConfirm) {
                _this.afterConfirm = function () {
                    return _this.handleHide();
                };
                _this.showConfirmModal();

                return;
            }

            _this.setState({
                show: false
            });
        };

        _this.handleHidden = function () {
            _this.setState({
                active_tab: 'general',
                active_section: '',
                prev_active_section: ''
            });
        };

        _this.handleCollapse = function () {
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this.refs.modalBody)).closest('.modal-dialog').removeClass('display--content');

            _this.setState({
                active_tab: '',
                active_section: '',
                prev_active_section: ''
            });
        };

        _this.handleConfirm = function () {
            _this.setState({
                showConfirmModal: false,
                enforceFocus: true
            });

            _this.requireConfirm = false;

            if (_this.afterConfirm) {
                _this.afterConfirm();
                _this.afterConfirm = null;
            }
        };

        _this.handleCancelConfirmation = function () {
            _this.setState({
                showConfirmModal: false,
                enforceFocus: true
            });

            _this.afterConfirm = null;
        };

        _this.closeModal = function () {
            if (_this.requireConfirm) {
                _this.showConfirmModal(_this.closeModal);
            } else {
                _this.handleHide();
            }
        };

        _this.collapseModal = function () {
            if (_this.requireConfirm) {
                _this.showConfirmModal(_this.collapseModal);
            } else {
                _this.handleCollapse();
            }
        };

        _this.updateTab = function (tab, skipConfirm) {
            if (!skipConfirm && _this.requireConfirm) {
                _this.showConfirmModal(function () {
                    return _this.updateTab(tab, true);
                });
            } else {
                _this.setState({
                    active_tab: tab,
                    active_section: '',
                    prev_active_section: ''
                });
            }
        };

        _this.updateSection = function (section, skipConfirm) {
            if (!skipConfirm && _this.requireConfirm) {
                _this.showConfirmModal(function () {
                    return _this.updateSection(section, true);
                });
            } else {
                _this.setState({
                    prev_active_section: section ? '' : _this.state.active_section,
                    active_section: section
                });
            }
        };

        _this.state = {
            active_tab: 'general',
            active_section: '',
            prev_active_section: '',
            showConfirmModal: false,
            enforceFocus: true,
            currentUser: _user_store2.default.getCurrentUser(),
            show: false
        };

        _this.requireConfirm = false;
        _this.mounted = false;
        return _this;
    }

    (0, _createClass3.default)(UserSettingsModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.mounted = true;
            _user_store2.default.addChangeListener(this.onUserChanged);
            _modal_store2.default.addModalListener(_constants2.default.ActionTypes.TOGGLE_ACCOUNT_SETTINGS_MODAL, this.handleToggle);
            document.addEventListener('keydown', this.handleKeyDown);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.mounted = false;
            _modal_store2.default.removeModalListener(_constants2.default.ActionTypes.TOGGLE_ACCOUNT_SETTINGS_MODAL, this.handleToggle);
            document.removeEventListener('keydown', this.handleKeyDown);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            _user_store2.default.removeChangeListener(this.onUserChanged);
            if (!Utils.isMobile()) {
                (0, _jquery2.default)('.settings-content .minimize-settings').perfectScrollbar('update');
            }
        }

        // Called when the close button is pressed on the main modal


        // called after the dialog is fully hidden and faded out


        // Called to hide the settings pane when on mobile

    }, {
        key: 'showConfirmModal',
        value: function showConfirmModal(afterConfirm) {
            this.setState({
                showConfirmModal: true,
                enforceFocus: false
            });

            if (afterConfirm) {
                this.afterConfirm = afterConfirm;
            }
        }

        // Called by settings tabs when their close button is pressed


        // Called by settings tabs when their back button is pressed

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var formatMessage = this.props.intl.formatMessage;

            if (this.state.currentUser == null) {
                return _react2.default.createElement('div', null);
            }
            var tabs = [];

            tabs.push({ name: 'general', uiName: formatMessage(holders.general), icon: 'icon fa fa-gear' });
            tabs.push({ name: 'security', uiName: formatMessage(holders.security), icon: 'icon fa fa-lock' });
            tabs.push({ name: 'notifications', uiName: formatMessage(holders.notifications), icon: 'icon fa fa-exclamation-circle' });
            tabs.push({ name: 'display', uiName: formatMessage(holders.display), icon: 'icon fa fa-eye' });
            if (this.props.closeUnusedDirectMessages || this.props.experimentalGroupUnreadChannels !== _constants.GroupUnreadChannels.DISABLED) {
                tabs.push({ name: 'sidebar', uiName: formatMessage(holders.sidebar), icon: 'icon fa fa-columns' });
            }
            tabs.push({ name: 'advanced', uiName: formatMessage(holders.advanced), icon: 'icon fa fa-list-alt' });

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    id: 'accountSettingsModal',
                    dialogClassName: 'settings-modal',
                    show: this.state.show,
                    onHide: this.handleHide,
                    onExited: this.handleHidden,
                    enforceFocus: this.state.enforceFocus
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    {
                        id: 'accountSettingsHeader',
                        closeButton: true
                    },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        { id: 'accountSettingsTitle' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'user.settings.modal.title',
                            defaultMessage: 'Account Settings'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    { ref: 'modalBody' },
                    _react2.default.createElement(
                        'div',
                        { className: 'settings-table' },
                        _react2.default.createElement(
                            'div',
                            { className: 'settings-links' },
                            _react2.default.createElement(_async_load.AsyncComponent, {
                                doLoad: _settings_sidebar2.default,
                                tabs: tabs,
                                activeTab: this.state.active_tab,
                                updateTab: this.updateTab
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'settings-content minimize-settings' },
                            _react2.default.createElement(_async_load.AsyncComponent, {
                                doLoad: _user_settings2.default,
                                ref: 'userSettings',
                                activeTab: this.state.active_tab,
                                activeSection: this.state.active_section,
                                prevActiveSection: this.state.prev_active_section,
                                updateSection: this.updateSection,
                                updateTab: this.updateTab,
                                closeModal: this.closeModal,
                                collapseModal: this.collapseModal,
                                setEnforceFocus: function setEnforceFocus(enforceFocus) {
                                    return _this2.setState({ enforceFocus: enforceFocus });
                                },
                                setRequireConfirm: function setRequireConfirm(requireConfirm) {
                                    _this2.requireConfirm = requireConfirm;
                                }
                            })
                        )
                    )
                ),
                _react2.default.createElement(_confirm_modal2.default, {
                    title: formatMessage(holders.confirmTitle),
                    message: formatMessage(holders.confirmMsg),
                    confirmButtonText: formatMessage(holders.confirmBtns),
                    show: this.state.showConfirmModal,
                    onConfirm: this.handleConfirm,
                    onCancel: this.handleCancelConfirmation
                })
            );
        }
    }]);
    return UserSettingsModal;
}(_react2.default.Component);

UserSettingsModal.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    closeUnusedDirectMessages: _propTypes2.default.bool,
    experimentalGroupUnreadChannels: _propTypes2.default.string
};

exports.default = (0, _reactIntl.injectIntl)(UserSettingsModal);

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(3).then((function(require) {
		cb(__webpack_require__(2127));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

var _AlphaPointer = __webpack_require__(2299);

var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _AlphaPointer2.default
};

exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;

var _isString2 = __webpack_require__(2182);

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = __webpack_require__(1071);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = __webpack_require__(2193);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = __webpack_require__(869);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports.default = flattenNames;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(884),
    isArray = __webpack_require__(833),
    isObjectLike = __webpack_require__(885);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2184);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 2184 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 2185 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(884),
    isObjectLike = __webpack_require__(885);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 2187 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(884),
    isLength = __webpack_require__(1073),
    isObjectLike = __webpack_require__(885);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 2189 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(1311);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1074),
    nativeKeys = __webpack_require__(2192);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1374);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(884),
    getPrototype = __webpack_require__(1075),
    isObjectLike = __webpack_require__(885);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(2195),
    baseMatchesProperty = __webpack_require__(2237),
    identity = __webpack_require__(1377),
    isArray = __webpack_require__(833),
    property = __webpack_require__(2247);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2196),
    getMatchData = __webpack_require__(2236),
    matchesStrictComparable = __webpack_require__(1391);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1076),
    baseIsEqual = __webpack_require__(1380);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 2197 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(981);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(981);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(981);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(981);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(980);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 2203 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 2204 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 2205 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(980),
    Map = __webpack_require__(1078),
    MapCache = __webpack_require__(1079);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(1375),
    isMasked = __webpack_require__(2208),
    isObject = __webpack_require__(856),
    toSource = __webpack_require__(1379);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(2209);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(836);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 2210 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(2212),
    ListCache = __webpack_require__(980),
    Map = __webpack_require__(1078);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2213),
    hashDelete = __webpack_require__(2214),
    hashGet = __webpack_require__(2215),
    hashHas = __webpack_require__(2216),
    hashSet = __webpack_require__(2217);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(982);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 2214 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(982);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(982);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(982);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(983);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 2219 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(983);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(983);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(983);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1076),
    equalArrays = __webpack_require__(1381),
    equalByTag = __webpack_require__(2229),
    equalObjects = __webpack_require__(2230),
    getTag = __webpack_require__(1389),
    isArray = __webpack_require__(833),
    isBuffer = __webpack_require__(1072),
    isTypedArray = __webpack_require__(1373);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(1079),
    setCacheAdd = __webpack_require__(2225),
    setCacheHas = __webpack_require__(2226);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 2225 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 2226 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 2227 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 2228 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(928),
    Uint8Array = __webpack_require__(1382),
    eq = __webpack_require__(1077),
    equalArrays = __webpack_require__(1381),
    mapToArray = __webpack_require__(1383),
    setToArray = __webpack_require__(1384);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1385);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 2231 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(891),
    root = __webpack_require__(836);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(891),
    root = __webpack_require__(836);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(891),
    root = __webpack_require__(836);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(891),
    root = __webpack_require__(836);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(1390),
    keys = __webpack_require__(936);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1380),
    get = __webpack_require__(2238),
    hasIn = __webpack_require__(2244),
    isKey = __webpack_require__(1081),
    isStrictComparable = __webpack_require__(1390),
    matchesStrictComparable = __webpack_require__(1391),
    toKey = __webpack_require__(984);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1392);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2240);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(2241);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(1079);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(2243);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(928),
    arrayMap = __webpack_require__(1378),
    isArray = __webpack_require__(833),
    isSymbol = __webpack_require__(967);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(2245),
    hasPath = __webpack_require__(2246);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 2245 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(1393),
    isArguments = __webpack_require__(1371),
    isArray = __webpack_require__(833),
    isIndex = __webpack_require__(1372),
    isLength = __webpack_require__(1073),
    toKey = __webpack_require__(984);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(2248),
    basePropertyDeep = __webpack_require__(2249),
    isKey = __webpack_require__(1081),
    toKey = __webpack_require__(984);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 2248 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1392);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1394),
    isArrayLike = __webpack_require__(979);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(979);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;

var _forOwn2 = __webpack_require__(1071);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = __webpack_require__(2253);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports.default = mergeClasses;

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(2254);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1076),
    arrayEach = __webpack_require__(1395),
    assignValue = __webpack_require__(1396),
    baseAssign = __webpack_require__(2256),
    baseAssignIn = __webpack_require__(2257),
    cloneBuffer = __webpack_require__(2260),
    copyArray = __webpack_require__(2261),
    copySymbols = __webpack_require__(2262),
    copySymbolsIn = __webpack_require__(2263),
    getAllKeys = __webpack_require__(1385),
    getAllKeysIn = __webpack_require__(2264),
    getTag = __webpack_require__(1389),
    initCloneArray = __webpack_require__(2265),
    initCloneByTag = __webpack_require__(2266),
    initCloneObject = __webpack_require__(2275),
    isArray = __webpack_require__(833),
    isBuffer = __webpack_require__(1072),
    isObject = __webpack_require__(856),
    keys = __webpack_require__(936);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(891);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(985),
    keys = __webpack_require__(936);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(985),
    keysIn = __webpack_require__(1398);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(856),
    isPrototype = __webpack_require__(1074),
    nativeKeysIn = __webpack_require__(2259);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 2259 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(836);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 2261 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(985),
    getSymbols = __webpack_require__(1080);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(985),
    getSymbolsIn = __webpack_require__(1399);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1386),
    getSymbolsIn = __webpack_require__(1399),
    keysIn = __webpack_require__(1398);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 2265 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1082),
    cloneDataView = __webpack_require__(2267),
    cloneMap = __webpack_require__(2268),
    cloneRegExp = __webpack_require__(2270),
    cloneSet = __webpack_require__(2271),
    cloneSymbol = __webpack_require__(2273),
    cloneTypedArray = __webpack_require__(2274);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1082);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(2269),
    arrayReduce = __webpack_require__(1400),
    mapToArray = __webpack_require__(1383);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 2269 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 2270 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(2272),
    arrayReduce = __webpack_require__(1400),
    setToArray = __webpack_require__(1384);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 2272 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(928);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1082);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(2276),
    getPrototype = __webpack_require__(1075),
    isPrototype = __webpack_require__(1074);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(856);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;

var _forOwn2 = __webpack_require__(1071);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports.default = autoprefix;

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports.default = hover;

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports.default = active;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports.default = loopable;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alpha = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _alpha = __webpack_require__(2282);

var alpha = _interopRequireWildcard(_alpha);

var _Checkboard = __webpack_require__(1401);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = exports.Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
      var change = alpha.calculateChange(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden'
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2.default.createElement(
        'div',
        { style: styles.alpha },
        _react2.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
        ),
        _react2.default.createElement('div', { style: styles.gradient }),
        _react2.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(_react.PureComponent || _react.Component);

exports.default = Alpha;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (props.hsl.a !== a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (props.a !== _a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkboardCache = {};

var render = exports.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = exports.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
  var checkboard = render(c1, c2, size, serverCanvas);

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }
  checkboardCache[key] = checkboard;
  return checkboard;
};

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableInput = exports.EditableInput = function (_ref) {
  _inherits(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck(this, EditableInput);

    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      if (_this.props.label) {
        _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, e.target.value), e);
      } else {
        _this.props.onChange && _this.props.onChange(e.target.value, e);
      }

      _this.setState({ value: e.target.value });
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var stringValue = String(e.target.value);
      var isPercentage = stringValue.indexOf('%') > -1;
      var number = Number(stringValue.replace(/%/g, ''));
      if (!isNaN(number)) {
        var amount = _this.props.arrowOffset || 1;

        // Up
        if (e.keyCode === 38) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number + amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number + amount, e);
          }

          if (isPercentage) {
            _this.setState({ value: number + amount + '%' });
          } else {
            _this.setState({ value: number + amount });
          }
        }

        // Down
        if (e.keyCode === 40) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number - amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number - amount, e);
          }

          if (isPercentage) {
            _this.setState({ value: number - amount + '%' });
          } else {
            _this.setState({ value: number - amount });
          }
        }
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    return _this;
  }

  _createClass(EditableInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var input = this.input;
      if (nextProps.value !== this.state.value) {
        if (input === document.activeElement) {
          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
        } else {
          this.setState({ value: String(nextProps.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.wrap },
        _react2.default.createElement('input', {
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label ? _react2.default.createElement(
          'span',
          { style: styles.label, onMouseDown: this.handleMouseDown },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(_react.PureComponent || _react.Component);

exports.default = EditableInput;

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _hue = __webpack_require__(2286);

var hue = _interopRequireWildcard(_hue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = exports.Hue = function (_ref) {
  _inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
      var change = hue.calculateChange(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%'
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2.default.createElement(
        'div',
        { style: styles.hue },
        _react2.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(_react.PureComponent || _react.Component);

exports.default = Hue;

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (props.hsl.h !== h) {
      return {
        h: h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: 'rgb'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (props.hsl.h !== _h) {
      return {
        h: _h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Raised = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = exports.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children;

  var styles = (0, _reactcss2.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, { 'zDepth-1': zDepth === 1 });

  return _react2.default.createElement(
    'div',
    { style: styles.wrap },
    _react2.default.createElement('div', { style: styles.bg }),
    _react2.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2.default.string,
  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2.default.number
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2
};

exports.default = Raised;

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(2289);
var invariant = __webpack_require__(2290);
var ReactPropTypesSecret = __webpack_require__(2291);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Saturation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _throttle = __webpack_require__(1310);

var _throttle2 = _interopRequireDefault(_throttle);

var _saturation = __webpack_require__(2293);

var saturation = _interopRequireWildcard(_saturation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = exports.Saturation = function (_ref) {
  _inherits(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck(this, Saturation);

    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e, skip) {
      _this.props.onChange && _this.throttle(_this.props.onChange, saturation.calculateChange(e, skip, _this.props, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(_react.PureComponent || _react.Component);

exports.default = Saturation;

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();

  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  } else if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left * 100 / containerWidth;
  var bright = -(top * 100 / containerHeight) + 100;

  return {
    h: props.hsl.h,
    s: saturation,
    v: bright,
    a: props.hsl.a,
    source: 'rgb'
  };
};

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2295);


/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(1395),
    baseEach = __webpack_require__(1394),
    castFunction = __webpack_require__(1376),
    isArray = __webpack_require__(833);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _interaction = __webpack_require__(2298);

var _ = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = exports.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2.default)({
    default: {
      swatch: _extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2.default.createElement(
    'div',
    _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2.default.createElement(_.Checkboard, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFocus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


var handleFocus = exports.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onFocus: _this.handleFocus, onBlur: _this.handleBlur },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Focus;
  }(_react2.default.Component);
};

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPointer = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = AlphaPointer;

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(857);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(799);

var _BlockSwatches = __webpack_require__(2301);

var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Block = exports.Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    _color2.default.isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: transparent ? 'rgba(0,0,0,0.4)' : '#fff',
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, { 'hide-triangle': triangle === 'hide' });

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.head },
      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
      _react2.default.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['top', 'hide'])
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top'
};

exports.default = (0, _common.ColorWrap)(Block);

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockSwatches = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(869);

var _map2 = _interopRequireDefault(_map);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_common.Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = BlockSwatches;

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(869);

var _map2 = _interopRequireDefault(_map);

var _materialColors = __webpack_require__(1403);

var material = _interopRequireWildcard(_materialColors);

var _common = __webpack_require__(799);

var _CircleSwatch = __webpack_require__(2303);

var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = exports.Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  });

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_CircleSwatch2.default, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  circleSize: _propTypes2.default.number,
  circleSpacing: _propTypes2.default.number
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']]
};

exports.default = (0, _common.ColorWrap)(Circle);

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleSwatch = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + circleSize / 2 + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chrome = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

var _ChromeFields = __webpack_require__(2305);

var _ChromeFields2 = _interopRequireDefault(_ChromeFields);

var _ChromePointer = __webpack_require__(2306);

var _ChromePointer2 = _interopRequireDefault(_ChromePointer);

var _ChromePointerCircle = __webpack_require__(2307);

var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chrome = exports.Chrome = function Chrome(_ref) {
  var onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        width: '225px',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: _ChromePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.color },
          _react2.default.createElement(
            'div',
            { style: styles.swatch },
            _react2.default.createElement('div', { style: styles.active }),
            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: styles.toggles },
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              onChange: onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      _react2.default.createElement(_ChromeFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  disableAlpha: _propTypes2.default.bool
};

Chrome.defaultProps = {
  disableAlpha: false
};

exports.default = (0, _common.ColorWrap)(Chrome);

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromeFields = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(857);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */

var ChromeFields = exports.ChromeFields = function (_React$Component) {
  _inherits(ChromeFields, _React$Component);

  function ChromeFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChromeFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      view: ''
    }, _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    }, _this.handleChange = function (data, e) {
      if (data.hex) {
        _color2.default.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: data.s && data.s || _this.props.hsl.s,
          l: data.l && data.l || _this.props.hsl.l,
          source: 'hsl'
        }, e);
      }
    }, _this.showHighlight = function (e) {
      e.target.style.background = '#eee';
    }, _this.hideHighlight = function (e) {
      e.target.style.background = 'transparent';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChromeFields, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
        this.setState({ view: 'hex' });
      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
        this.setState({ view: 'rgb' });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
        this.setState({ view: 'rgb' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        _react2.default.createElement(
          'div',
          { style: styles.toggle },
          _react2.default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            _react2.default.createElement(
              'svg',
              {
                style: styles.svg,
                viewBox: '0 0 24 24',
                onMouseOver: this.showHighlight,
                onMouseEnter: this.showHighlight,
                onMouseOut: this.hideHighlight
              },
              _react2.default.createElement('path', {
                ref: function ref(iconUp) {
                  return _this2.iconUp = iconUp;
                },
                fill: '#333',
                d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
              }),
              _react2.default.createElement('path', {
                ref: function ref(iconDown) {
                  return _this2.iconDown = iconDown;
                },
                fill: '#333',
                d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z'
              })
            )
          )
        )
      );
    }
  }]);

  return ChromeFields;
}(_react2.default.Component);

exports.default = ChromeFields;

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointer = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointer = exports.ChromePointer = function ChromePointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointer;

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointerCircle = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointerCircle;

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compact = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(869);

var _map2 = _interopRequireDefault(_map);

var _color = __webpack_require__(857);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(799);

var _CompactColor = __webpack_require__(2309);

var _CompactColor2 = _interopRequireDefault(_CompactColor);

var _CompactFields = __webpack_require__(2310);

var _CompactFields2 = _interopRequireDefault(_CompactFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Compact = exports.Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    { style: styles.Compact },
    _react2.default.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      _react2.default.createElement(
        'div',
        null,
        (0, _map2.default)(colors, function (c) {
          return _react2.default.createElement(_CompactColor2.default, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        _react2.default.createElement('div', { style: styles.clear })
      ),
      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']
};

exports.default = (0, _common.ColorWrap)(Compact);

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactColor = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactColor = exports.CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: '#fff',
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return _react2.default.createElement(
    _common.Swatch,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement('div', { style: styles.dot })
  );
};

exports.default = CompactColor;

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactFields = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactFields = exports.CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement('div', { style: styles.active }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

exports.default = CompactFields;

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Github = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(869);

var _map2 = _interopRequireDefault(_map);

var _common = __webpack_require__(799);

var _GithubSwatch = __webpack_require__(2312);

var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Github = exports.Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_GithubSwatch2.default, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right'])
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left'
};

exports.default = (0, _common.ColorWrap)(Github);

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GithubSwatch = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HuePicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

var _HuePointer = __webpack_require__(2314);

var _HuePointer2 = _interopRequireDefault(_HuePointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HuePicker = exports.HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  });

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _HuePointer2.default
};

exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Material = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(857);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Material = exports.Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    null,
    _react2.default.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      _react2.default.createElement(_common.EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      _react2.default.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

exports.default = (0, _common.ColorWrap)(Material);

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Photoshop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

var _PhotoshopFields = __webpack_require__(2317);

var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);

var _PhotoshopPointerCircle = __webpack_require__(2318);

var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);

var _PhotoshopPointer = __webpack_require__(2319);

var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);

var _PhotoshopButton = __webpack_require__(2320);

var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);

var _PhotoshopPreviews = __webpack_require__(2321);

var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photoshop = exports.Photoshop = function (_React$Component) {
  _inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck(this, Photoshop);

    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props$className = this.props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = (0, _reactcss2.default)({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        _react2.default.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        _react2.default.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.saturation },
            _react2.default.createElement(_common.Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: _PhotoshopPointerCircle2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: _PhotoshopPointer2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.controls },
            _react2.default.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              _react2.default.createElement(
                'div',
                { style: styles.previews },
                _react2.default.createElement(_PhotoshopPreviews2.default, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              _react2.default.createElement(
                'div',
                { style: styles.actions },
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
                _react2.default.createElement(_PhotoshopFields2.default, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(_react2.default.Component);

Photoshop.propTypes = {
  header: _propTypes2.default.string
};

Photoshop.defaultProps = {
  header: 'Color Picker'
};

exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPicker = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(857);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      _color2.default.isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields },
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    _react2.default.createElement(
      'div',
      { style: styles.fieldSymbols },
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

exports.default = PhotoshopPicker;

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.pointer },
    _react2.default.createElement(
      'div',
      { style: styles.left },
      _react2.default.createElement('div', { style: styles.leftInside })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.right },
      _react2.default.createElement('div', { style: styles.rightInside })
    )
  );
};

exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopBotton = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopBotton = exports.PhotoshopBotton = function PhotoshopBotton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

exports.default = PhotoshopBotton;

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPreviews = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement('div', { style: styles.new }),
      _react2.default.createElement('div', { style: styles.current })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

exports.default = PhotoshopPreviews;

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sketch = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

var _SketchFields = __webpack_require__(2323);

var _SketchFields2 = _interopRequireDefault(_SketchFields);

var _SketchPresetColors = __webpack_require__(2324);

var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sketch = exports.Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    },
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      _react2.default.createElement(
        'div',
        { style: styles.sliders },
        _react2.default.createElement(
          'div',
          { style: styles.hue },
          _react2.default.createElement(_common.Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.alpha },
          _react2.default.createElement(_common.Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { style: styles.color },
        _react2.default.createElement(_common.Checkboard, null),
        _react2.default.createElement('div', { style: styles.activeColor })
      )
    ),
    _react2.default.createElement(_SketchFields2.default, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    _react2.default.createElement(_SketchPresetColors2.default, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: _propTypes2.default.bool,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

exports.default = (0, _common.ColorWrap)(Sketch);

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchFields = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(857);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

var SketchFields = exports.SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement(
      'div',
      { style: styles.double },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.alpha },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

exports.default = SketchFields;

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchPresetColors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      return _react2.default.createElement(
        'div',
        { key: c.color, style: styles.swatchWrap },
        _react2.default.createElement(_common.Swatch, _extends({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    color: _propTypes2.default.string,
    title: _propTypes2.default.string
  })])).isRequired
};

exports.default = SketchPresetColors;

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

var _SliderSwatches = __webpack_require__(2326);

var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);

var _SliderPointer = __webpack_require__(2328);

var _SliderPointer2 = _interopRequireDefault(_SliderPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = exports.Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { className: 'slider-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.hue },
      _react2.default.createElement(_common.Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.defaultProps = {
  pointer: _SliderPointer2.default
};

exports.default = (0, _common.ColorWrap)(Slider);

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatches = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _SliderSwatch = __webpack_require__(2327);

var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.80',
        active: Math.round(hsl.l * 100) / 100 === 0.80 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick,
        first: true
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.65',
        active: Math.round(hsl.l * 100) / 100 === 0.65 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.50',
        active: Math.round(hsl.l * 100) / 100 === 0.50 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.35',
        active: Math.round(hsl.l * 100) / 100 === 0.35 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.20',
        active: Math.round(hsl.l * 100) / 100 === 0.20 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick,
        last: true
      })
    ),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = SliderSwatches;

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatch = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
};

exports.default = SliderSwatch;

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatches = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(869);

var _map2 = _interopRequireDefault(_map);

var _color = __webpack_require__(857);

var _color2 = _interopRequireDefault(_color);

var _materialColors = __webpack_require__(1403);

var material = _interopRequireWildcard(_materialColors);

var _common = __webpack_require__(799);

var _SwatchesGroup = __webpack_require__(2330);

var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Swatches = exports.Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    _color2.default.isValidHex(data) && onChange({
      hex: data,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    _react2.default.createElement(
      _common.Raised,
      null,
      _react2.default.createElement(
        'div',
        { style: styles.overflow },
        _react2.default.createElement(
          'div',
          { style: styles.body },
          (0, _map2.default)(colors, function (group) {
            return _react2.default.createElement(_SwatchesGroup2.default, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          _react2.default.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string))

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']]
};

exports.default = (0, _common.ColorWrap)(Swatches);

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesGroup = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(869);

var _map2 = _interopRequireDefault(_map);

var _SwatchesColor = __webpack_require__(2331);

var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.group },
    (0, _map2.default)(group, function (color, i) {
      return _react2.default.createElement(_SwatchesColor2.default, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

exports.default = SwatchesGroup;

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesColor = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        fill: '#fff',
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        fill: '#333'
      }
    },
    'transparent': {
      check: {
        fill: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return _react2.default.createElement(
    _common.Swatch,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement(
      'div',
      { style: styles.check },
      _react2.default.createElement(
        'svg',
        { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
        _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
      )
    )
  );
};

exports.default = SwatchesColor;

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(840);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(780);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(869);

var _map2 = _interopRequireDefault(_map);

var _color = __webpack_require__(857);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Twitter = exports.Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    _color2.default.isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      (0, _map2.default)(colors, function (c, i) {
        return _react2.default.createElement(_common.Swatch, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      _react2.default.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      _react2.default.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left'
};

exports.default = (0, _common.ColorWrap)(Twitter);

/***/ }),
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _rhs = __webpack_require__(817);

var _rhs2 = __webpack_require__(818);

var _webrtc_notification = __webpack_require__(2350);

var _webrtc_notification2 = _interopRequireDefault(_webrtc_notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        isRhsOpen: (0, _rhs2.getIsRhsOpen)(state)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            closeRhs: _rhs.closeRightHandSide
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_webrtc_notification2.default);

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _webrtc_actions = __webpack_require__(905);

var WebrtcActions = _interopRequireWildcard(_webrtc_actions);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _web_websocket_client = __webpack_require__(959);

var _web_websocket_client2 = _interopRequireDefault(_web_websocket_client);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _ring = __webpack_require__(1405);

var _ring2 = _interopRequireDefault(_ring);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreReleaseFeatures = _constants.Constants.PRE_RELEASE_FEATURES; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var WebrtcNotification = function (_React$Component) {
    (0, _inherits3.default)(WebrtcNotification, _React$Component);

    function WebrtcNotification() {
        (0, _classCallCheck3.default)(this, WebrtcNotification);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WebrtcNotification.__proto__ || (0, _getPrototypeOf2.default)(WebrtcNotification)).call(this));

        _this.closeRightHandSide = function (e) {
            e.preventDefault();
            GlobalActions.emitCloseRightHandSide();
            _this.props.actions.closeRhs();
        };

        _this.mounted = false;

        _this.closeNotification = _this.closeNotification.bind(_this);
        _this.onIncomingCall = _this.onIncomingCall.bind(_this);
        _this.onCancelCall = _this.onCancelCall.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.handleAnswer = _this.handleAnswer.bind(_this);
        _this.handleTimeout = _this.handleTimeout.bind(_this);
        _this.stopRinging = _this.stopRinging.bind(_this);

        _this.state = {
            userCalling: null
        };
        return _this;
    }

    (0, _createClass3.default)(WebrtcNotification, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _webrtc_store2.default.addNotifyListener(this.onIncomingCall);
            _webrtc_store2.default.addChangedListener(this.onCancelCall);
            this.mounted = true;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _webrtc_store2.default.removeNotifyListener(this.onIncomingCall);
            _webrtc_store2.default.removeChangedListener(this.onCancelCall);
            if (this.refs.ring) {
                this.refs.ring.removeListener('ended', this.handleTimeout);
            }
            this.mounted = false;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.userCalling) {
                this.refs.ring.addEventListener('ended', this.handleTimeout);
            }
        }
    }, {
        key: 'closeNotification',
        value: function closeNotification() {
            this.setState({
                userCalling: null
            });
        }
    }, {
        key: 'stopRinging',
        value: function stopRinging() {
            if (this.refs.ring) {
                this.refs.ring.pause();
                this.refs.ring.currentTime = 0;
            }
            this.setState({ userCalling: null });
        }
    }, {
        key: 'onIncomingCall',
        value: function onIncomingCall(incoming) {
            if (this.mounted) {
                var userId = incoming.from_user_id;
                var userMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                var featureEnabled = Utils.isFeatureEnabled(PreReleaseFeatures.WEBRTC_PREVIEW);

                if (featureEnabled) {
                    if (_webrtc_store2.default.isBusy()) {
                        _web_websocket_client2.default.sendMessage('webrtc', {
                            action: _constants.WebrtcActionTypes.BUSY,
                            from_user_id: _user_store2.default.getCurrentId(),
                            to_user_id: userId
                        });
                        this.stopRinging();
                    } else if (userMedia) {
                        _webrtc_store2.default.setVideoCallWith(userId);
                        this.setState({
                            userCalling: _user_store2.default.getProfile(userId)
                        });
                    } else {
                        _web_websocket_client2.default.sendMessage('webrtc', {
                            action: _constants.WebrtcActionTypes.UNSUPPORTED,
                            from_user_id: _user_store2.default.getCurrentId(),
                            to_user_id: userId
                        });
                        this.stopRinging();
                    }
                } else {
                    _web_websocket_client2.default.sendMessage('webrtc', {
                        action: _constants.WebrtcActionTypes.DISABLED,
                        from_user_id: _user_store2.default.getCurrentId(),
                        to_user_id: userId
                    });
                    this.stopRinging();
                }
            }
        }
    }, {
        key: 'onCancelCall',
        value: function onCancelCall(message) {
            if (message) {
                if (message.action !== _constants.WebrtcActionTypes.CANCEL) {
                    return;
                }
                if (this.state.userCalling) {
                    if (message.from_user_uid === _user_store2.default.getCurrentId() && message.calling_user_id === this.state.userCalling.id) {
                        // Allow cancel message from ourselves when the calling user_id matches our current state.
                    } else if (message.from_user_id !== this.state.userCalling.id) {
                        // Ignore cancel messages from user_ids which are not in our current state.
                        return;
                    }
                }
            }

            _webrtc_store2.default.setVideoCallWith(null);
            this.closeNotification();
        }
    }, {
        key: 'handleTimeout',
        value: function handleTimeout() {
            _web_websocket_client2.default.sendMessage('webrtc', {
                action: _constants.WebrtcActionTypes.NO_ANSWER,
                from_user_id: _user_store2.default.getCurrentId(),
                to_user_id: this.state.userCalling.id
            });

            this.onCancelCall();
        }
    }, {
        key: 'handleAnswer',
        value: function handleAnswer(e) {
            if (e) {
                e.preventDefault();
            }

            var caller = this.state.userCalling;
            if (caller) {
                var callerId = caller.id;
                var currentUserId = _user_store2.default.getCurrentId();
                var message = {
                    action: _constants.WebrtcActionTypes.ANSWER,
                    from_user_id: currentUserId,
                    to_user_id: callerId
                };

                GlobalActions.emitCloseRightHandSide();
                WebrtcActions.initWebrtc(callerId, false);
                _web_websocket_client2.default.sendMessage('webrtc', message);

                // delay till next tick (this will give time to listen for events
                setTimeout(function () {
                    //we switch from and to user to handle the event locally
                    message.from_user_id = callerId;
                    message.to_user_id = currentUserId;
                    WebrtcActions.handle(message);

                    // Notify current users sessions.
                    _web_websocket_client2.default.sendMessage('webrtc', {
                        action: _constants.WebrtcActionTypes.CANCEL,
                        from_user_id: currentUserId,
                        to_user_id: currentUserId,
                        calling_user_id: callerId
                    });
                }, 0);

                this.closeNotification();
            }
        }
    }, {
        key: 'handleClose',
        value: function handleClose(e) {
            if (e) {
                e.preventDefault();
            }
            if (this.state.userCalling) {
                // Notify current users sessions.
                _web_websocket_client2.default.sendMessage('webrtc', {
                    action: _constants.WebrtcActionTypes.CANCEL,
                    from_user_id: _user_store2.default.getCurrentId(),
                    to_user_id: _user_store2.default.getCurrentId(),
                    calling_user_id: this.state.userCalling.id
                });

                _web_websocket_client2.default.sendMessage('webrtc', {
                    action: _constants.WebrtcActionTypes.DECLINE,
                    from_user_id: _user_store2.default.getCurrentId(),
                    to_user_id: this.state.userCalling.id
                });
            }

            this.onCancelCall();
        }
    }, {
        key: 'render',
        value: function render() {
            var user = this.state.userCalling;
            if (user) {
                var username = Utils.getDisplayNameByUserId(user.id);
                var profileImgSrc = Utils.imageURLForUser(user);
                var profileImg = _react2.default.createElement('img', {
                    className: 'user-popover__image',
                    src: profileImgSrc,
                    height: '128',
                    width: '128',
                    key: 'user-popover-image'
                });
                var answerBtn = _react2.default.createElement(
                    'svg',
                    {
                        className: 'webrtc-icons__pickup',
                        xmlns: 'http://www.w3.org/2000/svg',
                        width: '48',
                        height: '48',
                        viewBox: '-10 -10 68 68',
                        onClick: this.handleAnswer
                    },
                    _react2.default.createElement(
                        'circle',
                        {
                            cx: '24',
                            cy: '24',
                            r: '34'
                        },
                        _react2.default.createElement(
                            'title',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'webrtc.notification.answer',
                                defaultMessage: 'Answer'
                            })
                        )
                    ),
                    _react2.default.createElement('path', {
                        transform: 'translate(-10,-10)',
                        fill: '#fff',
                        d: 'M29.854,37.627c1.723,1.904 3.679,3.468 5.793,4.684l3.683,-3.334c0.469,-0.424 1.119,-0.517 1.669,-0.302c1.628,0.63 3.331,1.021 5.056,1.174c0.401,0.026 0.795,0.199 1.09,0.525c0.295,0.326 0.433,0.741 0.407,1.153l-0.279,5.593c-0.02,0.418 -0.199,0.817 -0.525,1.112c-0.326,0.296 -0.741,0.434 -1.159,0.413c-6.704,-0.504 -13.238,-3.491 -18.108,-8.87c-4.869,-5.38 -7.192,-12.179 -7.028,-18.899c0.015,-0.413 0.199,-0.817 0.526,-1.113c0.326,-0.295 0.74,-0.433 1.153,-0.407l5.593,0.279c0.407,0.02 0.812,0.193 1.107,0.519c0.29,0.32 0.428,0.735 0.413,1.137c-0.018,1.732 0.202,3.464 0.667,5.147c0.159,0.569 0.003,1.207 -0.466,1.631l-3.683,3.334c1.005,2.219 2.368,4.32 4.091,6.224Z'
                    })
                );

                var rejectBtn = _react2.default.createElement(
                    'svg',
                    {
                        className: 'webrtc-icons__cancel',
                        xmlns: 'http://www.w3.org/2000/svg',
                        width: '48',
                        height: '48',
                        viewBox: '-10 -10 68 68',
                        onClick: this.handleClose
                    },
                    _react2.default.createElement(
                        'circle',
                        {
                            cx: '24',
                            cy: '24',
                            r: '34'
                        },
                        _react2.default.createElement(
                            'title',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'webrtc.notification.decline',
                                defaultMessage: 'Decline'
                            })
                        )
                    ),
                    _react2.default.createElement('path', {
                        transform: 'scale(0.7), translate(11,10)',
                        d: 'M24 18c-3.21 0-6.3.5-9.2 1.44v6.21c0 .79-.46 1.47-1.12 1.8-1.95.98-3.74 2.23-5.33 3.7-.36.35-.85.57-1.4.57-.55 0-1.05-.22-1.41-.59L.59 26.18c-.37-.37-.59-.87-.59-1.42 0-.55.22-1.05.59-1.42C6.68 17.55 14.93 14 24 14s17.32 3.55 23.41 9.34c.37.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-4.95 4.95c-.36.36-.86.59-1.41.59-.54 0-1.04-.22-1.4-.57-1.59-1.47-3.38-2.72-5.33-3.7-.66-.33-1.12-1.01-1.12-1.8v-6.21C30.3 18.5 27.21 18 24 18z',
                        fill: 'white'
                    })
                );

                var msg = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'webrtc.notification.incoming_call',
                        defaultMessage: '{username} is calling you.',
                        values: {
                            username: username
                        }
                    }),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'webrtc-buttons webrtc-icons active',
                            style: style.buttons
                        },
                        answerBtn,
                        rejectBtn
                    )
                );

                return _react2.default.createElement(
                    'div',
                    { className: 'webrtc-notification' },
                    _react2.default.createElement('audio', {
                        ref: 'ring',
                        src: _ring2.default,
                        autoPlay: true
                    }),
                    _react2.default.createElement(
                        'div',
                        null,
                        profileImg
                    ),
                    msg
                );
            } else if (this.props.isRhsOpen && _webrtc_store2.default.isBusy()) {
                return _react2.default.createElement(
                    'div',
                    {
                        className: 'webrtc__notification--rhs',
                        onClick: this.closeRightHandSide
                    },
                    _react2.default.createElement('i', { className: 'fa fa-phone' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'webrtc.notification.returnToCall',
                        defaultMessage: 'Return to ongoing call with {username}',
                        values: {
                            username: Utils.getDisplayNameByUserId(_webrtc_store2.default.getVideoCallWith())
                        }
                    })
                );
            }

            return _react2.default.createElement('div', null);
        }
    }]);
    return WebrtcNotification;
}(_react2.default.Component);

WebrtcNotification.propTypes = {
    isRhsOpen: _propTypes2.default.bool.isRequired,
    actions: _propTypes2.default.shape({
        closeRhs: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = WebrtcNotification;


var style = {
    buttons: { marginTop: 5 }
};

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _users = __webpack_require__(777);

var _webrtc = __webpack_require__(1406);

var _webrtc_sidebar = __webpack_require__(2352);

var _webrtc_sidebar2 = _interopRequireDefault(_webrtc_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    return {
        isOpen: (0, _webrtc.getIsWebrtcOpen)(state),
        currentUser: (0, _users.getCurrentUser)(state)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_webrtc_sidebar2.default);

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(769);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _controller = __webpack_require__(2353);

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebrtcSidebar = function (_React$Component) {
    (0, _inherits3.default)(WebrtcSidebar, _React$Component);

    function WebrtcSidebar(props) {
        (0, _classCallCheck3.default)(this, WebrtcSidebar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WebrtcSidebar.__proto__ || (0, _getPrototypeOf2.default)(WebrtcSidebar)).call(this, props));

        _this.onShrink = function () {
            _this.setState({ expanded: false });
        };

        _this.toggleSize = function (e) {
            if (e) {
                e.preventDefault();
            }
            _this.setState(function (prevState) {
                return { expanded: !prevState.expanded };
            });
        };

        _this.onInitializeVideoCall = function (userId, isCaller) {
            var expanded = _this.state.expanded;
            if (userId === null) {
                expanded = false;
            }
            _this.setState({
                videoCallVisible: userId !== null,
                isCaller: isCaller,
                userId: userId,
                expanded: expanded
            });
        };

        _this.state = {
            expanded: false,
            videoCallVisible: false,
            isCaller: false,
            userId: null
        };
        return _this;
    }

    (0, _createClass3.default)(WebrtcSidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _webrtc_store2.default.addInitListener(this.onInitializeVideoCall);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _webrtc_store2.default.removeInitListener(this.onInitializeVideoCall);
        }
    }, {
        key: 'render',
        value: function render() {
            var content = null;

            if (this.state.videoCallVisible) {
                content = _react2.default.createElement(_controller2.default, {
                    currentUser: this.state.currentUser,
                    userId: this.state.userId,
                    isCaller: this.state.isCaller,
                    expanded: this.state.expanded,
                    toggleSize: this.toggleSize
                });
            }

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('sidebar--right', 'webrtc', {
                        'webrtc--show': this.props.isOpen,
                        'sidebar--right--expanded': this.state.expanded,
                        'move--left': this.props.isOpen
                    })
                },
                _react2.default.createElement('div', {
                    onClick: this.onShrink,
                    className: 'sidebar--right__bg'
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'sidebar-right-container' },
                    content
                )
            );
        }
    }]);
    return WebrtcSidebar;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

WebrtcSidebar.propTypes = {
    currentUser: _propTypes2.default.object,
    isOpen: _propTypes2.default.bool.isRequired
};
exports.default = WebrtcSidebar;

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _general = __webpack_require__(113);

var _rhs = __webpack_require__(817);

var _webrtc_controller = __webpack_require__(2354);

var _webrtc_controller2 = _interopRequireDefault(_webrtc_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var enableDeveloper = config.EnableDeveloper === 'true';

    return {
        enableDeveloper: enableDeveloper
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            closeRhs: _rhs.closeRightHandSide
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_webrtc_controller2.default);

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _janus = __webpack_require__(2355);

var _janus2 = _interopRequireDefault(_janus);

var _diagnostics_actions = __webpack_require__(804);

var _webrtc_actions = __webpack_require__(905);

var WebrtcActions = _interopRequireWildcard(_webrtc_actions);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _web_websocket_client = __webpack_require__(959);

var _web_websocket_client2 = _interopRequireDefault(_web_websocket_client);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _ring = __webpack_require__(1405);

var _ring2 = _interopRequireDefault(_ring);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _search_bar = __webpack_require__(1047);

var _search_bar2 = _interopRequireDefault(_search_bar);

var _webrtc_header = __webpack_require__(2367);

var _webrtc_header2 = _interopRequireDefault(_webrtc_header);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var VIDEO_WIDTH = 640;
var VIDEO_HEIGHT = 360;
var MIN_ASPECT = 1.777;
var MAX_ASPECT = 1.778;
var ALREADY_REGISTERED_ERROR = 477;
var USERNAME_TAKEN = 476;

var WebrtcController = function (_React$Component) {
    (0, _inherits3.default)(WebrtcController, _React$Component);

    function WebrtcController(props) {
        (0, _classCallCheck3.default)(this, WebrtcController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WebrtcController.__proto__ || (0, _getPrototypeOf2.default)(WebrtcController)).call(this, props));

        _this.mounted = false;
        _this.localMedia = null;
        _this.session = null;
        _this.videocall = null;

        _this.handleResize = _this.handleResize.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.clearError = _this.clearError.bind(_this);

        _this.getLocalMedia = _this.getLocalMedia.bind(_this);
        _this.stopMediaStream = _this.stopMediaStream.bind(_this);
        _this.previewVideo = _this.previewVideo.bind(_this);
        _this.stopRinging = _this.stopRinging.bind(_this);

        _this.handleMakeOffer = _this.handleMakeOffer.bind(_this);
        _this.handleCancelOffer = _this.handleCancelOffer.bind(_this);
        _this.handleWebrtcEvent = _this.handleWebrtcEvent.bind(_this);
        _this.handleVideoCallEvent = _this.handleVideoCallEvent.bind(_this);
        _this.handleRemoteStream = _this.handleRemoteStream.bind(_this);

        _this.onStatusChange = _this.onStatusChange.bind(_this);
        _this.onCallDeclined = _this.onCallDeclined.bind(_this);
        _this.onUnsupported = _this.onUnsupported.bind(_this);
        _this.onNoAnswer = _this.onNoAnswer.bind(_this);
        _this.onBusy = _this.onBusy.bind(_this);
        _this.onDisabled = _this.onDisabled.bind(_this);
        _this.onFailed = _this.onFailed.bind(_this);
        _this.onCancelled = _this.onCancelled.bind(_this);
        _this.onConnectCall = _this.onConnectCall.bind(_this);

        _this.onSessionCreated = _this.onSessionCreated.bind(_this);
        _this.onSessionError = _this.onSessionError.bind(_this);

        _this.doCall = _this.doCall.bind(_this);
        _this.doAnswer = _this.doAnswer.bind(_this);
        _this.doHangup = _this.doHangup.bind(_this);
        _this.doCleanup = _this.doCleanup.bind(_this);

        _this.renderButtons = _this.renderButtons.bind(_this);
        _this.onToggleVideo = _this.onToggleVideo.bind(_this);
        _this.onToggleAudio = _this.onToggleAudio.bind(_this);
        _this.onToggleRemoteMute = _this.onToggleRemoteMute.bind(_this);
        _this.toggleIcons = _this.toggleIcons.bind(_this);

        var currentUser = _user_store2.default.getCurrentUser();
        var remoteUser = _user_store2.default.getProfile(props.userId);
        var remoteUserImage = Utils.imageURLForUser(remoteUser);

        _this.state = {
            windowWidth: Utils.windowWidth(),
            windowHeight: Utils.windowHeight(),
            channelId: _channel_store2.default.getCurrentId(),
            currentUser: currentUser,
            currentUserImage: Utils.imageURLForUser(currentUser),
            remoteUserImage: remoteUserImage,
            localMediaLoaded: false,
            isPaused: false,
            isMuted: false,
            isRemotePaused: false,
            isRemoteMuted: false,
            isCalling: false,
            isAnswering: false,
            callInProgress: false,
            error: null,
            errorType: '',
            ended: null
        };
        return _this;
    }

    (0, _createClass3.default)(WebrtcController, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.handleResize);
            _webrtc_store2.default.addChangedListener(this.handleWebrtcEvent);
            _user_store2.default.addStatusesChangeListener(this.onStatusChange);

            this.mounted = true;
            this.previewVideo();

            if (this.props.isCaller) {
                this.handleMakeOffer();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
            _webrtc_store2.default.removeChangedListener(this.handleWebrtcEvent);
            _user_store2.default.removeStatusesChangeListener(this.onStatusChange);
            this.mounted = false;
            this.close();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.currentUser !== this.props.currentUser || nextProps.userId !== this.props.userId || nextProps.isCaller !== this.props.isCaller) {
                var remoteUser = _user_store2.default.getProfile(nextProps.userId);
                var remoteUserImage = Utils.imageURLForUser(remoteUser);
                this.setState({
                    error: null,
                    remoteUserImage: remoteUserImage
                });
            }

            if (nextProps.isCaller && nextProps.expanded === this.props.expanded) {
                this.startCall = true;
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.isCaller && this.startCall) {
                this.startCall = false;
                this.handleMakeOffer();
            }
        }
    }, {
        key: 'handleResize',
        value: function handleResize() {
            this.setState({
                windowWidth: Utils.windowWidth(),
                windowHeight: Utils.windowHeight()
            });
        }
    }, {
        key: 'clearError',
        value: function clearError() {
            var _this2 = this;

            setTimeout(function () {
                _this2.setState({ error: null, ended: null, errorType: '' });
            }, _constants.Constants.WEBRTC_CLEAR_ERROR_DELAY);
        }
    }, {
        key: 'getLocalMedia',
        value: function getLocalMedia(constraints, element, callback) {
            var media = constraints || { audio: true, video: true };
            navigator.mediaDevices.getUserMedia(media).then(function (stream) {
                if (element) {
                    element.srcObject = stream;
                }

                if (callback && typeof callback === 'function') {
                    callback(null, stream);
                }
            }).catch(function (error) {
                callback(error);
            });
        }
    }, {
        key: 'stopMediaStream',
        value: function stopMediaStream(stream) {
            var tracks = stream.getTracks();
            tracks.forEach(function (track) {
                track.stop();
            });
        }
    }, {
        key: 'previewVideo',
        value: function previewVideo() {
            var _this3 = this;

            if (this.mounted) {
                if (this.localMedia) {
                    this.setState({
                        localMediaLoaded: true,
                        error: null
                    });
                    this.localMedia.enabled = true;
                } else {
                    this.getLocalMedia({
                        audio: true,
                        video: {
                            minAspectRatio: MIN_ASPECT,
                            maxAspectRatio: MAX_ASPECT,
                            width: VIDEO_WIDTH,
                            height: VIDEO_HEIGHT
                        }
                    }, this.refs['local-video'], function (error, stream) {
                        if (error) {
                            _this3.setState({
                                error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'webrtc.mediaError',
                                    defaultMessage: 'Unable to access Camera and Microphone'
                                })
                            });
                            return;
                        }
                        _this3.localMedia = stream;
                        _this3.setState({
                            localMediaLoaded: true
                        });
                    });
                }
            }
        }
    }, {
        key: 'stopRinging',
        value: function stopRinging() {
            if (this.refs.ring) {
                this.refs.ring.pause();
                this.refs.ring.currentTime = 0;
            }
        }
    }, {
        key: 'handleMakeOffer',
        value: function handleMakeOffer() {
            if (_user_store2.default.getStatus(this.props.userId) === _constants.UserStatuses.OFFLINE) {
                this.onStatusChange();
            } else {
                var connectingMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'calling_screen',
                    defaultMessage: 'Calling'
                });

                this.setState({
                    isCalling: true,
                    isAnswering: false,
                    callInProgress: false,
                    error: null,
                    ended: null,
                    connectingMsg: connectingMsg
                });

                _webrtc_store2.default.setVideoCallWith(this.props.userId);

                var user = this.state.currentUser;
                _web_websocket_client2.default.sendMessage('webrtc', {
                    action: _constants.WebrtcActionTypes.NOTIFY,
                    from_user_id: user.id,
                    to_user_id: this.props.userId
                });
            }
        }
    }, {
        key: 'handleCancelOffer',
        value: function handleCancelOffer() {
            this.setState({
                isCalling: false,
                isAnswering: false,
                callInProgress: false,
                error: null,
                ended: null
            });

            var user = this.state.currentUser;
            _web_websocket_client2.default.sendMessage('webrtc', {
                action: _constants.WebrtcActionTypes.CANCEL,
                from_user_id: user.id,
                to_user_id: this.props.userId
            });

            this.doCleanup();
        }
    }, {
        key: 'handleWebrtcEvent',
        value: function handleWebrtcEvent(message) {
            switch (message.action) {
                case _constants.WebrtcActionTypes.DECLINE:
                    this.onCallDeclined();
                    this.clearError();
                    break;
                case _constants.WebrtcActionTypes.UNSUPPORTED:
                    this.onUnsupported();
                    this.clearError();
                    break;
                case _constants.WebrtcActionTypes.BUSY:
                    this.onBusy();
                    this.clearError();
                    break;
                case _constants.WebrtcActionTypes.NO_ANSWER:
                    this.onNoAnswer();
                    this.clearError();
                    break;
                case _constants.WebrtcActionTypes.FAILED:
                    this.onFailed();
                    this.clearError();
                    break;
                case _constants.WebrtcActionTypes.ANSWER:
                    this.onConnectCall();
                    break;
                case _constants.WebrtcActionTypes.CANCEL:
                    this.onCancelled();
                    this.clearError();
                    break;
                case _constants.WebrtcActionTypes.MUTED:
                    this.onToggleRemoteMute(message);
                    break;
                case _constants.WebrtcActionTypes.IN_PROGRESS:
                    this.setState({
                        error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'webrtc.inProgress',
                            defaultMessage: 'You have a call in progress. Please hang up first.'
                        }),
                        errorType: ' warning'
                    });
                    this.clearError();
                    break;
                case _constants.WebrtcActionTypes.DISABLED:
                    this.onDisabled();
                    this.clearError();
                    break;
            }
        }
    }, {
        key: 'handleVideoCallEvent',
        value: function handleVideoCallEvent(msg, jsep) {
            var result = msg.result;

            if (result) {
                var event = result.event;
                switch (event) {
                    case 'registered':
                        if (this.state.isCalling) {
                            this.doCall();
                        }
                        break;
                    case 'incomingcall':
                        this.doAnswer(jsep);
                        break;
                    case 'accepted':
                        this.stopRinging();

                        if (jsep) {
                            this.videocall.handleRemoteJsep({ jsep: jsep });
                        }
                        break;
                    case 'hangup':
                        this.doHangup(false);
                        break;
                }
            } else {
                var errorCode = msg.error_code;
                if (errorCode !== ALREADY_REGISTERED_ERROR && errorCode !== USERNAME_TAKEN) {
                    this.doHangup(true);
                } else if (this.state.isCalling) {
                    this.doCall();
                }
            }
        }
    }, {
        key: 'handleRemoteStream',
        value: function handleRemoteStream(stream) {
            // attaching stream to where they belong
            this.refs['main-video'].srcObject = stream;

            var isRemotePaused = false;
            var isRemoteMuted = false;
            var videoTracks = stream.getVideoTracks();
            var audioTracks = stream.getAudioTracks();
            if (!videoTracks || videoTracks.length === 0 || videoTracks[0].muted || !videoTracks[0].enabled) {
                isRemotePaused = true;
            }

            if (!audioTracks || audioTracks.length === 0 || audioTracks[0].muted || !audioTracks[0].enabled) {
                isRemoteMuted = true;
            }

            this.setState({
                isCalling: false,
                isAnswering: false,
                callInProgress: true,
                isMuted: false,
                isPaused: false,
                error: null,
                ended: null,
                isRemotePaused: isRemotePaused,
                isRemoteMuted: isRemoteMuted
            });

            var icons = this.refs.icons;
            if (icons) {
                icons.classList.remove('hidden');
                icons.classList.add('active');
            }
        }
    }, {
        key: 'handleClose',
        value: function handleClose(e) {
            e.preventDefault();
            if (this.state.callInProgress) {
                this.setState({
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'webrtc.inProgress',
                        defaultMessage: 'You have a call in progress. Please hang up first.'
                    }),
                    errorType: ' warning'
                });
            } else if (this.state.isCalling) {
                this.handleCancelOffer();
                this.close();
            } else {
                this.close();
            }
        }
    }, {
        key: 'close',
        value: function close() {
            this.doCleanup();

            if (this.session) {
                this.session.destroy();
                this.session = null;
            }

            if (this.localMedia) {
                this.stopMediaStream(this.localMedia);
                this.localMedia = null;
            }

            WebrtcActions.initWebrtc(null, false);
        }
    }, {
        key: 'onStatusChange',
        value: function onStatusChange() {
            var status = _user_store2.default.getStatus(this.props.userId);

            if (status === _constants.UserStatuses.OFFLINE) {
                var error = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'webrtc.offline',
                    defaultMessage: '{username} is offline',
                    values: {
                        username: Utils.getDisplayNameByUserId(this.props.userId)
                    }
                });

                if (this.state.isCalling || this.state.isAnswering) {
                    this.setState({
                        isCalling: false,
                        isAnswering: false,
                        callInProgress: false,
                        error: error
                    });
                } else {
                    this.setState({
                        error: error
                    });
                }
            } else if (status !== _constants.UserStatuses.OFFLINE && this.state.error) {
                this.setState({
                    error: null,
                    ended: null
                });
            }
        }
    }, {
        key: 'onCallDeclined',
        value: function onCallDeclined() {
            var error = null;

            if (this.state.isCalling) {
                error = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'webrtc.declined',
                    defaultMessage: 'Your call has been declined by {username}',
                    values: {
                        username: Utils.getDisplayNameByUserId(this.props.userId)
                    }
                });
            }

            this.stopRinging();

            this.setState({
                isCalling: false,
                isAnswering: false,
                callInProgress: false,
                error: error
            });

            this.doCleanup();
        }
    }, {
        key: 'onUnsupported',
        value: function onUnsupported() {
            if (this.mounted) {
                this.stopRinging();

                this.setState({
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'webrtc.unsupported',
                        defaultMessage: 'Call to {username} not successful. Their client does not support video calls.',
                        values: {
                            username: Utils.getDisplayNameByUserId(this.props.userId)
                        }
                    }),
                    callInProgress: false,
                    isCalling: false,
                    isAnswering: false
                });
            }

            this.doCleanup();
        }
    }, {
        key: 'onNoAnswer',
        value: function onNoAnswer() {
            var error = null;

            if (this.state.isCalling) {
                error = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'webrtc.noAnswer',
                    defaultMessage: '{username} is not answering the call',
                    values: {
                        username: Utils.getDisplayNameByUserId(this.props.userId)
                    }
                });
            }
            this.stopRinging();

            this.setState({
                isCalling: false,
                isAnswering: false,
                callInProgress: false,
                error: error
            });

            this.doCleanup();
        }
    }, {
        key: 'onBusy',
        value: function onBusy() {
            var error = null;

            if (this.state.isCalling) {
                error = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'webrtc.busy',
                    defaultMessage: '{username} is busy',
                    values: {
                        username: Utils.getDisplayNameByUserId(this.props.userId)
                    }
                });
            }
            this.stopRinging();

            this.setState({
                isCalling: false,
                isAnswering: false,
                callInProgress: false,
                error: error
            });

            this.doCleanup();
        }
    }, {
        key: 'onDisabled',
        value: function onDisabled() {
            var error = null;

            if (this.state.isCalling) {
                error = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'webrtc.disabled',
                    defaultMessage: '{username} has WebRTC disabled, and cannot receive calls. To enable the feature, they must go to Account Settings > Advanced > Preview pre-release features and turn on WebRTC.',
                    values: {
                        username: Utils.getDisplayNameByUserId(this.props.userId)
                    }
                });
            }

            this.stopRinging();

            this.setState({
                isCalling: false,
                isAnswering: false,
                callInProgress: false,
                error: error
            });

            this.doCleanup();
        }
    }, {
        key: 'onFailed',
        value: function onFailed() {
            (0, _diagnostics_actions.trackEvent)('api', 'api_users_webrtc_failed');

            this.setState({
                isCalling: false,
                isAnswering: false,
                callInProgress: false,
                isPaused: false,
                isMuted: false,
                isRemotePaused: false,
                isRemoteMuted: false,
                error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'webrtc.failed',
                    defaultMessage: 'There was a problem connecting the video call'
                })
            });

            this.stopRinging();

            this.doCleanup();
        }
    }, {
        key: 'onCancelled',
        value: function onCancelled() {
            if (this.mounted && this.state.isAnswering) {
                this.stopRinging();
                this.setState({
                    isCalling: false,
                    isAnswering: false,
                    callInProgress: false,
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'webrtc.cancelled',
                        defaultMessage: '{username} cancelled the call',
                        values: {
                            username: Utils.getDisplayNameByUserId(this.props.userId)
                        }
                    })
                });
            }

            this.doCleanup();
        }
    }, {
        key: 'onConnectCall',
        value: function onConnectCall() {
            var _this4 = this;

            WebrtcActions.webrtcToken(function (info) {
                var connectingMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'connecting_screen',
                    defaultMessage: 'Connecting'
                });

                _this4.setState({ isAnswering: !_this4.state.isCalling, connectingMsg: connectingMsg });
                if (_this4.session) {
                    _this4.onSessionCreated();
                } else {
                    var iceServers = [];

                    if (info.stun_uri) {
                        iceServers.push({
                            urls: info.stun_uri.split(' ')
                        });
                    }

                    if (info.turn_uri) {
                        iceServers.push({
                            urls: info.turn_uri.split(' '),
                            username: info.turn_username,
                            credential: info.turn_password
                        });
                    }

                    _janus2.default.init({ debug: _this4.props.enableDeveloper });
                    _this4.session = new _janus2.default({
                        server: info.gateway_url,
                        iceServers: iceServers,
                        token: info.token,
                        success: _this4.onSessionCreated,
                        error: _this4.onSessionError
                    });
                }
            }, function () {
                _this4.onSessionError();
            });
        }
    }, {
        key: 'onSessionCreated',
        value: function onSessionCreated() {
            var _this5 = this;

            if (this.videocall) {
                this.doCall();
            } else {
                this.session.attach({
                    plugin: 'janus.plugin.videocall',
                    success: function success(plugin) {
                        _this5.videocall = plugin;
                        _this5.videocall.send({ message: { request: 'register', username: _this5.state.currentUser.id } });
                    },
                    error: this.onSessionError,
                    onmessage: this.handleVideoCallEvent,
                    onremotestream: this.handleRemoteStream
                });
            }
        }
    }, {
        key: 'onSessionError',
        value: function onSessionError() {
            var user = this.state.currentUser;
            _web_websocket_client2.default.sendMessage('webrtc', {
                action: _constants.WebrtcActionTypes.FAILED,
                from_user_id: user.id,
                to_user_id: this.props.userId
            });

            this.onFailed();
        }
    }, {
        key: 'doCall',
        value: function doCall() {
            var _this6 = this;

            // delay call so receiver has time to register
            setTimeout(function () {
                _this6.videocall.createOffer({
                    stream: _this6.localMedia,
                    success: function success(jsep) {
                        var body = { request: 'call', username: _this6.props.userId };
                        _this6.videocall.send({ message: body, jsep: jsep });
                    },
                    error: function error() {
                        _this6.doHangup(true);
                    }
                });
            }, _constants.Constants.WEBRTC_TIME_DELAY);
        }
    }, {
        key: 'doAnswer',
        value: function doAnswer(jsep) {
            var _this7 = this;

            (0, _diagnostics_actions.trackEvent)('api', 'api_users_webrtc_start');
            this.videocall.createAnswer({
                jsep: jsep,
                stream: this.localMedia,
                success: function success(jsepSuccess) {
                    var body = { request: 'accept' };
                    _this7.videocall.send({ message: body, jsep: jsepSuccess });
                },
                error: function error() {
                    _this7.doHangup(true);
                }
            });
        }
    }, {
        key: 'doHangup',
        value: function doHangup(error, manual) {
            (0, _diagnostics_actions.trackEvent)('api', 'api_users_webrtc_end');
            if (this.videocall && this.state.callInProgress) {
                this.videocall.send({ message: { request: 'hangup' } });
                this.videocall.hangup();
                this.toggleIcons();

                if (this.localMedia) {
                    this.localMedia.getVideoTracks()[0].enabled = true;
                    this.localMedia.getAudioTracks()[0].enabled = true;
                }
            }

            if (error) {
                this.onSessionError();
                return this.doCleanup();
            }

            _webrtc_store2.default.setVideoCallWith(null);
            this.props.actions.closeRhs();

            if (manual) {
                return this.close();
            }

            this.setState({
                isCalling: false,
                isAnswering: false,
                callInProgress: false,
                isPaused: false,
                isMuted: false,
                isRemotePaused: false,
                isRemoteMuted: false,
                error: null,
                ended: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'webrtc.callEnded',
                    defaultMessage: 'Call with {username} ended.',
                    values: {
                        username: Utils.getDisplayNameByUserId(this.props.userId)
                    }
                })
            });
            this.clearError();
            return this.doCleanup();
        }
    }, {
        key: 'doCleanup',
        value: function doCleanup() {
            _webrtc_store2.default.setVideoCallWith(null);

            if (this.videocall) {
                this.videocall.detach();
                this.videocall = null;
            }
        }
    }, {
        key: 'onToggleVideo',
        value: function onToggleVideo() {
            var shouldPause = !this.state.isPaused;
            if (shouldPause) {
                this.videocall.unmuteVideo();
            } else {
                this.videocall.muteVideo();
            }

            var user = this.state.currentUser;
            _web_websocket_client2.default.sendMessage('webrtc', {
                action: _constants.WebrtcActionTypes.MUTED,
                from_user_id: user.id,
                to_user_id: this.props.userId,
                type: 'video',
                mute: shouldPause
            });

            this.setState({
                isPaused: shouldPause,
                error: null,
                ended: null
            });
        }
    }, {
        key: 'onToggleAudio',
        value: function onToggleAudio() {
            var shouldMute = !this.state.isMuted;
            if (shouldMute) {
                this.videocall.unmuteAudio();
            } else {
                this.videocall.muteAudio();
            }

            var user = this.state.currentUser;
            _web_websocket_client2.default.sendMessage('webrtc', {
                action: _constants.WebrtcActionTypes.MUTED,
                from_user_id: user.id,
                to_user_id: this.props.userId,
                type: 'audio',
                mute: shouldMute
            });

            this.setState({
                isMuted: shouldMute,
                error: null,
                ended: null
            });
        }
    }, {
        key: 'onToggleRemoteMute',
        value: function onToggleRemoteMute(message) {
            if (message.type === 'video') {
                this.setState({
                    isRemotePaused: message.mute
                });
            } else {
                this.setState({ isRemoteMuted: message.mute, error: null, ended: null });
            }
        }
    }, {
        key: 'toggleIcons',
        value: function toggleIcons() {
            var icons = this.refs.icons;
            if (icons) {
                icons.classList.toggle('hidden');
                icons.classList.toggle('active');
            }
        }
    }, {
        key: 'renderButtons',
        value: function renderButtons() {
            var _this8 = this;

            var buttons = void 0;
            if (this.state.isCalling) {
                buttons = _react2.default.createElement(
                    'svg',
                    {
                        id: 'cancel',
                        className: 'webrtc-icons__cancel',
                        xmlns: 'http://www.w3.org/2000/svg',
                        width: '48',
                        height: '48',
                        viewBox: '-10 -10 68 68',
                        onClick: function onClick() {
                            return _this8.handleCancelOffer();
                        }
                    },
                    _react2.default.createElement(
                        'circle',
                        {
                            cx: '24',
                            cy: '24',
                            r: '34'
                        },
                        _react2.default.createElement(
                            'title',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'webrtc.cancel',
                                defaultMessage: 'Cancel Call'
                            })
                        )
                    ),
                    _react2.default.createElement('path', {
                        transform: 'scale(0.8), translate(6,10)',
                        d: 'M24 18c-3.21 0-6.3.5-9.2 1.44v6.21c0 .79-.46 1.47-1.12 1.8-1.95.98-3.74 2.23-5.33 3.7-.36.35-.85.57-1.4.57-.55 0-1.05-.22-1.41-.59L.59 26.18c-.37-.37-.59-.87-.59-1.42 0-.55.22-1.05.59-1.42C6.68 17.55 14.93 14 24 14s17.32 3.55 23.41 9.34c.37.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-4.95 4.95c-.36.36-.86.59-1.41.59-.54 0-1.04-.22-1.4-.57-1.59-1.47-3.38-2.72-5.33-3.7-.66-.33-1.12-1.01-1.12-1.8v-6.21C30.3 18.5 27.21 18 24 18z',
                        fill: 'white'
                    })
                );
            } else if (!this.state.callInProgress && this.state.localMediaLoaded) {
                buttons = _react2.default.createElement(
                    'svg',
                    {
                        id: 'call',
                        className: 'webrtc-icons__call',
                        xmlns: 'http://www.w3.org/2000/svg',
                        width: '48',
                        height: '48',
                        viewBox: '-10 -10 68 68',
                        onClick: function onClick() {
                            return _this8.handleMakeOffer();
                        },
                        disabled: _user_store2.default.getStatus(this.props.userId) === 'offline'
                    },
                    _react2.default.createElement(
                        'circle',
                        {
                            cx: '24',
                            cy: '24',
                            r: '34'
                        },
                        _react2.default.createElement(
                            'title',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'webrtc.call',
                                defaultMessage: 'Call'
                            })
                        )
                    ),
                    _react2.default.createElement('path', {
                        transform: 'translate(-10,-10)',
                        fill: '#fff',
                        d: 'M29.854,37.627c1.723,1.904 3.679,3.468 5.793,4.684l3.683,-3.334c0.469,-0.424 1.119,-0.517 1.669,-0.302c1.628,0.63 3.331,1.021 5.056,1.174c0.401,0.026 0.795,0.199 1.09,0.525c0.295,0.326 0.433,0.741 0.407,1.153l-0.279,5.593c-0.02,0.418 -0.199,0.817 -0.525,1.112c-0.326,0.296 -0.741,0.434 -1.159,0.413c-6.704,-0.504 -13.238,-3.491 -18.108,-8.87c-4.869,-5.38 -7.192,-12.179 -7.028,-18.899c0.015,-0.413 0.199,-0.817 0.526,-1.113c0.326,-0.295 0.74,-0.433 1.153,-0.407l5.593,0.279c0.407,0.02 0.812,0.193 1.107,0.519c0.29,0.32 0.428,0.735 0.413,1.137c-0.018,1.732 0.202,3.464 0.667,5.147c0.159,0.569 0.003,1.207 -0.466,1.631l-3.683,3.334c1.005,2.219 2.368,4.32 4.091,6.224Z'
                    })
                );
            } else if (this.state.callInProgress) {
                var onClass = 'on';
                var offClass = 'off';
                var audioOnClass = offClass;
                var audioOffClass = onClass;
                var videoOnClass = offClass;
                var videoOffClass = onClass;

                var audioTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'webrtc.mute_audio',
                    defaultMessage: 'Mute'
                });

                var videoTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'webrtc.pause_video',
                    defaultMessage: 'Turn off Video'
                });

                if (this.state.isMuted) {
                    audioOnClass = onClass;
                    audioOffClass = offClass;
                    audioTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'webrtc.unmute_audio',
                        defaultMessage: 'Unmute'
                    });
                }

                if (this.state.isPaused) {
                    videoOnClass = onClass;
                    videoOffClass = offClass;
                    videoTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'webrtc.unpause_video',
                        defaultMessage: 'Turn on Video'
                    });
                }

                buttons = _react2.default.createElement(
                    'div',
                    {
                        ref: 'icons',
                        className: 'webrtc-icons hidden'
                    },
                    _react2.default.createElement(
                        'svg',
                        {
                            id: 'mute-audio',
                            className: 'webrtc-icons__call',
                            xmlns: 'http://www.w3.org/2000/svg',
                            width: '48',
                            height: '48',
                            viewBox: '-10 -10 68 68',
                            onClick: function onClick() {
                                return _this8.onToggleAudio();
                            }
                        },
                        _react2.default.createElement(
                            'circle',
                            {
                                cx: '24',
                                cy: '24',
                                r: '34'
                            },
                            _react2.default.createElement(
                                'title',
                                null,
                                audioTitle
                            )
                        ),
                        _react2.default.createElement('path', {
                            className: audioOnClass,
                            transform: 'scale(0.6), translate(17,18)',
                            d: 'M38 22h-3.4c0 1.49-.31 2.87-.87 4.1l2.46 2.46C37.33 26.61 38 24.38 38 22zm-8.03.33c0-.11.03-.22.03-.33V10c0-3.32-2.69-6-6-6s-6 2.68-6 6v.37l11.97 11.96zM8.55 6L6 8.55l12.02 12.02v1.44c0 3.31 2.67 6 5.98 6 .45 0 .88-.06 1.3-.15l3.32 3.32c-1.43.66-3 1.03-4.62 1.03-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c1.81-.27 3.53-.9 5.08-1.81L39.45 42 42 39.46 8.55 6z',
                            fill: 'white'
                        }),
                        _react2.default.createElement('path', {
                            className: audioOffClass,
                            transform: 'scale(0.6), translate(17,18)',
                            d: 'M24 28c3.31 0 5.98-2.69 5.98-6L30 10c0-3.32-2.68-6-6-6-3.31 0-6 2.68-6 6v12c0 3.31 2.69 6 6 6zm10.6-6c0 6-5.07 10.2-10.6 10.2-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c6.56-.97 12-6.61 12-13.44h-3.4z',
                            fill: 'white'
                        })
                    ),
                    _react2.default.createElement(
                        'svg',
                        {
                            id: 'mute-video',
                            className: 'webrtc-icons__call',
                            xmlns: 'http://www.w3.org/2000/svg',
                            width: '48',
                            height: '48',
                            viewBox: '-10 -10 68 68',
                            onClick: function onClick() {
                                return _this8.onToggleVideo();
                            }
                        },
                        _react2.default.createElement(
                            'circle',
                            {
                                cx: '24',
                                cy: '24',
                                r: '34'
                            },
                            _react2.default.createElement(
                                'title',
                                null,
                                videoTitle
                            )
                        ),
                        _react2.default.createElement('path', {
                            className: videoOnClass,
                            transform: 'scale(0.6), translate(17,16)',
                            d: 'M40 8H15.64l8 8H28v4.36l1.13 1.13L36 16v12.36l7.97 7.97L44 36V12c0-2.21-1.79-4-4-4zM4.55 2L2 4.55l4.01 4.01C4.81 9.24 4 10.52 4 12v24c0 2.21 1.79 4 4 4h29.45l4 4L44 41.46 4.55 2zM12 16h1.45L28 30.55V32H12V16z',
                            fill: 'white'
                        }),
                        _react2.default.createElement('path', {
                            className: videoOffClass,
                            transform: 'scale(0.6), translate(17,16)',
                            d: 'M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm-4 24l-8-6.4V32H12V16h16v6.4l8-6.4v16z',
                            fill: 'white'
                        })
                    ),
                    _react2.default.createElement(
                        'svg',
                        {
                            id: 'hangup',
                            className: 'webrtc-icons__cancel',
                            xmlns: 'http://www.w3.org/2000/svg',
                            width: '48',
                            height: '48',
                            viewBox: '-10 -10 68 68',
                            onClick: function onClick() {
                                return _this8.doHangup(false, true);
                            }
                        },
                        _react2.default.createElement(
                            'circle',
                            {
                                cx: '24',
                                cy: '24',
                                r: '34'
                            },
                            _react2.default.createElement(
                                'title',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'webrtc.hangup',
                                    defaultMessage: 'Hang up'
                                })
                            )
                        ),
                        _react2.default.createElement('path', {
                            transform: 'scale(0.7), translate(11,10)',
                            d: 'M24 18c-3.21 0-6.3.5-9.2 1.44v6.21c0 .79-.46 1.47-1.12 1.8-1.95.98-3.74 2.23-5.33 3.7-.36.35-.85.57-1.4.57-.55 0-1.05-.22-1.41-.59L.59 26.18c-.37-.37-.59-.87-.59-1.42 0-.55.22-1.05.59-1.42C6.68 17.55 14.93 14 24 14s17.32 3.55 23.41 9.34c.37.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-4.95 4.95c-.36.36-.86.59-1.41.59-.54 0-1.04-.22-1.4-.57-1.59-1.47-3.38-2.72-5.33-3.7-.66-.33-1.12-1.01-1.12-1.8v-6.21C30.3 18.5 27.21 18 24 18z',
                            fill: 'white'
                        })
                    )
                );
            }

            return buttons;
        }
    }, {
        key: 'render',
        value: function render() {
            var currentId = _user_store2.default.getCurrentId();
            var remoteImage = _react2.default.createElement('img', { src: this.state.remoteUserImage });
            var localImage = void 0;
            var localVideoHidden = '';
            var remoteVideoHidden = 'hidden';
            var error = void 0;
            var remoteMute = void 0;
            var localImageHidden = 'webrtc__local-image hidden';
            var remoteImageHidden = 'webrtc__remote-image';

            if (this.state.error) {
                error = _react2.default.createElement(
                    'div',
                    { className: 'webrtc__error' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group has-error' },
                        _react2.default.createElement(
                            'label',
                            { className: 'control-label' + this.state.errorType },
                            this.state.error
                        )
                    )
                );
            } else if (this.state.ended) {
                error = _react2.default.createElement(
                    'div',
                    { className: 'webrtc__error' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            this.state.ended
                        )
                    )
                );
            }

            if (this.state.isRemoteMuted) {
                remoteMute = _react2.default.createElement(
                    'div',
                    { className: 'webrtc__remote-mute' },
                    _react2.default.createElement(
                        'svg',
                        {
                            xmlns: 'http://www.w3.org/2000/svg',
                            width: '60',
                            height: '60',
                            viewBox: '-10 -10 68 68'
                        },
                        _react2.default.createElement('path', {
                            className: 'off',
                            transform: 'scale(0.6), translate(17,18)',
                            d: 'M38 22h-3.4c0 1.49-.31 2.87-.87 4.1l2.46 2.46C37.33 26.61 38 24.38 38 22zm-8.03.33c0-.11.03-.22.03-.33V10c0-3.32-2.69-6-6-6s-6 2.68-6 6v.37l11.97 11.96zM8.55 6L6 8.55l12.02 12.02v1.44c0 3.31 2.67 6 5.98 6 .45 0 .88-.06 1.3-.15l3.32 3.32c-1.43.66-3 1.03-4.62 1.03-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c1.81-.27 3.53-.9 5.08-1.81L39.45 42 42 39.46 8.55 6z',
                            fill: 'white'
                        }),
                        _react2.default.createElement('path', {
                            className: 'on',
                            transform: 'scale(0.6), translate(17,18)',
                            d: 'M24 28c3.31 0 5.98-2.69 5.98-6L30 10c0-3.32-2.68-6-6-6-3.31 0-6 2.68-6 6v12c0 3.31 2.69 6 6 6zm10.6-6c0 6-5.07 10.2-10.6 10.2-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c6.56-.97 12-6.61 12-13.44h-3.4z',
                            fill: 'white'
                        })
                    )
                );
            }

            var searchForm = void 0;
            if (currentId != null) {
                searchForm = _react2.default.createElement(_search_bar2.default, null);
            }

            var buttons = this.renderButtons();
            var calling = this.state.isCalling;
            var connecting = void 0;
            var audio = void 0;
            if (calling || this.state.isAnswering) {
                if (calling) {
                    audio = _react2.default.createElement('audio', {
                        ref: 'ring',
                        src: _ring2.default,
                        autoPlay: true
                    });
                }

                connecting = _react2.default.createElement(
                    'div',
                    { className: 'connecting' },
                    _react2.default.createElement(_loading_screen2.default, {
                        position: 'absolute',
                        message: this.state.connectingMsg
                    }),
                    audio
                );
            }

            if (this.state.callInProgress) {
                if (this.state.isPaused) {
                    localVideoHidden = 'hidden';
                    localImageHidden = 'webrtc__local-image';
                    localImage = _react2.default.createElement('img', { src: this.state.currentUserImage });
                }

                if (this.state.isRemotePaused) {
                    remoteVideoHidden = 'hidden';
                    remoteImageHidden = 'webrtc__remote-image';
                } else {
                    remoteVideoHidden = '';
                    remoteImageHidden = 'webrtc__remote-image hidden';
                }
            }

            return _react2.default.createElement(
                'div',
                { className: 'post-right__container' },
                _react2.default.createElement(
                    'div',
                    { className: 'search-bar__container channel-header alt' },
                    searchForm
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sidebar-right__body' },
                    _react2.default.createElement(_webrtc_header2.default, {
                        username: Utils.getDisplayNameByUserId(this.props.userId),
                        onClose: this.handleClose,
                        toggleSize: this.props.toggleSize
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'post-right__scroll' },
                        _react2.default.createElement(
                            'div',
                            { id: 'videos' },
                            remoteMute,
                            _react2.default.createElement(
                                'div',
                                {
                                    id: 'main-video',
                                    className: remoteVideoHidden,
                                    autoPlay: true
                                },
                                _react2.default.createElement('video', {
                                    ref: 'main-video',
                                    autoPlay: true
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    id: 'local-video',
                                    className: localVideoHidden
                                },
                                _react2.default.createElement('video', {
                                    ref: 'local-video',
                                    autoPlay: true,
                                    muted: true
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: remoteImageHidden },
                                remoteImage
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: localImageHidden },
                                localImage
                            )
                        ),
                        error,
                        connecting,
                        _react2.default.createElement(
                            'div',
                            { className: 'webrtc-buttons' },
                            buttons
                        )
                    )
                )
            );
        }
    }]);
    return WebrtcController;
}(_react2.default.Component);

exports.default = WebrtcController;


WebrtcController.propTypes = {
    currentUser: _propTypes2.default.object,
    userId: _propTypes2.default.string.isRequired,
    isCaller: _propTypes2.default.bool.isRequired,
    expanded: _propTypes2.default.bool.isRequired,
    toggleSize: _propTypes2.default.func,
    enableDeveloper: _propTypes2.default.bool.isRequired,
    actions: _propTypes2.default.shape({
        closeRhs: _propTypes2.default.func.isRequired
    }).isRequired
};

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 The MIT License (MIT)

 Copyright (c) 2016 Meetecho

 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the "Software"),
 to deal in the Software without restriction, including without limitation
 the rights to use, copy, modify, merge, publish, distribute, sublicense,
 and/or sell copies of the Software, and to permit persons to whom the
 Software is furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included
 in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
 OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
 ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 OTHER DEALINGS IN THE SOFTWARE.
 */

/* eslint-disable */

var adapter = __webpack_require__(2356);

// List of sessions
Janus.sessions = {};

// Screensharing Chrome Extension ID
Janus.extensionId = "hapfgfdkleiggjjpfpenajgdnfckjpaj";
Janus.isExtensionEnabled = function() {
    if(window.navigator.userAgent.match('Chrome')) {
        var chromever = parseInt(window.navigator.userAgent.match(/Chrome\/(.*) /)[1], 10);
        var maxver = 33;
        if(window.navigator.userAgent.match('Linux'))
            maxver = 35;	// "known" crash in chrome 34 and 35 on linux
        if(chromever >= 26 && chromever <= maxver) {
            // Older versions of Chrome don't support this extension-based approach, so lie
            return true;
        }
        return Janus.checkJanusExtension();
    } else {
        // Firefox of others, no need for the extension (but this doesn't mean it will work)
        return true;
    }
};

Janus.useDefaultDependencies = function (deps) {
    var f = (deps && deps.fetch) || fetch;
    var p = (deps && deps.Promise) || Promise;
    var socketCls = (deps && deps.WebSocket) || WebSocket;
    return {
        newWebSocket: function(server, proto) { return new socketCls(server, proto); },
        isArray: function(arr) { return Array.isArray(arr); },
        checkJanusExtension: function() { return document.querySelector('#janus-extension-installed') !== null; },
        webRTCAdapter: (deps && deps.adapter) || adapter,
        httpAPICall: function(url, options) {
            var fetchOptions = {method: options.verb, cache: 'no-cache'};
            if(options.withCredentials !== undefined) {
                fetchOptions.credentials = options.withCredentials === true ? 'include' : (options.withCredentials ? options.withCredentials : 'omit');
            }
            if(options.body !== undefined) {
                fetchOptions.body = JSON.stringify(options.body);
            }

            var fetching = f(url, fetchOptions).catch(function(error) {
                return p.reject({message: 'Probably a network error, is the gateway down?', error: error});
            });

            /*
             * fetch() does not natively support timeouts.
             * Work around this by starting a timeout manually, and racing it agains the fetch() to see which thing resolves first.
             */

            if(options.timeout !== undefined) {
                var timeout = new p(function(resolve, reject) {
                    var timerId = setTimeout(function() {
                        clearTimeout(timerId);
                        return reject({message: 'Request timed out', timeout: options.timeout});
                    }, options.timeout);
                });
                fetching = p.race([fetching,timeout]);
            }

            fetching.then(function(response) {
                if(response.ok) {
                    if(typeof(options.success) === typeof(Janus.noop)) {
                        return response.json().then(function(parsed) {
                            options.success(parsed);
                        }).catch(function(error) {
                            return p.reject({message: 'Failed to parse response body', error: error, response: response});
                        });
                    }
                }
                else {
                    return p.reject({message: 'API call failed', response: response});
                }
            }).catch(function(error) {
                if(typeof(options.error) === typeof(Janus.noop)) {
                    options.error(error.message || '<< internal error >>', error);
                }
            });

            return fetching;
        }
    }
};

Janus.useOldDependencies = function (deps) {
    var jq = (deps && deps.jQuery) || jQuery;
    var socketCls = (deps && deps.WebSocket) || WebSocket;
    return {
        newWebSocket: function(server, proto) { return new socketCls(server, proto); },
        isArray: function(arr) { return jq.isArray(arr); },
        checkJanusExtension: function() { return jq('#janus-extension-installed').length > 0; },
        webRTCAdapter: (deps && deps.adapter) || adapter,
        httpAPICall: function(url, options) {
            var payload = options.body !== undefined ? {
                contentType: 'application/json',
                data: JSON.stringify(options.body)
            } : {};
            var credentials = options.withCredentials !== undefined ? {xhrFields: {withCredentials: options.withCredentials}} : {};

            return jq.ajax(jq.extend(payload, credentials, {
                url: url,
                type: options.verb,
                cache: false,
                dataType: 'json',
                async: options.async,
                timeout: options.timeout,
                success: function(result) {
                    if(typeof(options.success) === typeof(Janus.noop)) {
                        options.success(result);
                    }
                },
                error: function(xhr, status, err) {
                    if(typeof(options.error) === typeof(Janus.noop)) {
                        options.error(status, err);
                    }
                }
            }));
        },
    };
};

Janus.noop = function() {};

// Initialization
Janus.init = function(options) {
    options = options || {};
    options.callback = (typeof options.callback == "function") ? options.callback : Janus.noop;
    if(Janus.initDone === true) {
        // Already initialized
        options.callback();
    } else {
        if(typeof console == "undefined" || typeof console.log == "undefined")
            console = { log: function() {} };
        // Console logging (all debugging disabled by default)
        Janus.trace = Janus.noop;
        Janus.debug = Janus.noop;
        Janus.vdebug = Janus.noop;
        Janus.log = Janus.noop;
        Janus.warn = Janus.noop;
        Janus.error = Janus.noop;
        if(options.debug === true || options.debug === "all") {
            // Enable all debugging levels
            Janus.trace = console.trace.bind(console);
            Janus.debug = console.debug.bind(console);
            Janus.vdebug = console.debug.bind(console);
            Janus.log = console.log.bind(console);
            Janus.warn = console.warn.bind(console);
            Janus.error = console.error.bind(console);
        } else if(Array.isArray(options.debug)) {
            for(var i in options.debug) {
                var d = options.debug[i];
                switch(d) {
                case "trace":
                    Janus.trace = console.trace.bind(console);
                    break;
                case "debug":
                    Janus.debug = console.debug.bind(console);
                    break;
                case "vdebug":
                    Janus.vdebug = console.debug.bind(console);
                    break;
                case "log":
                    Janus.log = console.log.bind(console);
                    break;
                case "warn":
                    Janus.warn = console.warn.bind(console);
                    break;
                case "error":
                    Janus.error = console.error.bind(console);
                    break;
                default:
                    console.error("Unknown debugging option '" + d + "' (supported: 'trace', 'debug', 'vdebug', 'log', warn', 'error')");
                    break;
                }
            }
        }
        Janus.log("Initializing library");

        var usedDependencies = options.dependencies || Janus.useDefaultDependencies();
        Janus.isArray = usedDependencies.isArray;
        Janus.webRTCAdapter = usedDependencies.webRTCAdapter;
        Janus.httpAPICall = usedDependencies.httpAPICall;
        Janus.checkJanusExtension = usedDependencies.checkJanusExtension;
        Janus.newWebSocket = usedDependencies.newWebSocket;

        // Helper method to enumerate devices
        Janus.listDevices = function(callback, config) {
            callback = (typeof callback == "function") ? callback : Janus.noop;
            if (config == null) config = { audio: true, video: true };
            if(navigator.mediaDevices) {
                navigator.mediaDevices.getUserMedia(config)
                .then(function(stream) {
                    navigator.mediaDevices.enumerateDevices().then(function(devices) {
                        Janus.debug(devices);
                        callback(devices);
                        // Get rid of the now useless stream
                        try {
                            var tracks = stream.getTracks();
                            for(var i in tracks) {
                                var mst = tracks[i];
                                if(mst !== null && mst !== undefined)
                                    mst.stop();
                            }
                        } catch(e) {}
                    });
                })
                .catch(function(err) {
                    Janus.error(err);
                    callback([]);
                });
            } else {
                Janus.warn("navigator.mediaDevices unavailable");
                callback([]);
            }
        }
        // Helper methods to attach/reattach a stream to a video element (previously part of adapter.js)
        Janus.attachMediaStream = function(element, stream) {
            if(Janus.webRTCAdapter.browserDetails.browser === 'chrome') {
                var chromever = Janus.webRTCAdapter.browserDetails.version;
                if(chromever >= 43) {
                    element.srcObject = stream;
                } else if(typeof element.src !== 'undefined') {
                    element.src = URL.createObjectURL(stream);
                } else {
                    Janus.error("Error attaching stream to element");
                }
            } else {
                element.srcObject = stream;
            }
        };
        Janus.reattachMediaStream = function(to, from) {
            if(Janus.webRTCAdapter.browserDetails.browser === 'chrome') {
                var chromever = Janus.webRTCAdapter.browserDetails.version;
                if(chromever >= 43) {
                    to.srcObject = from.srcObject;
                } else if(typeof to.src !== 'undefined') {
                    to.src = from.src;
                } else {
                    Janus.error("Error reattaching stream to element");
                }
            } else {
                to.srcObject = from.srcObject;
            }
        };
        // Detect tab close: make sure we don't loose existing onbeforeunload handlers
        var oldOBF = window.onbeforeunload;
        window.onbeforeunload = function() {
            Janus.log("Closing window");
            for(var s in Janus.sessions) {
                if(Janus.sessions[s] !== null && Janus.sessions[s] !== undefined &&
                    Janus.sessions[s].destroyOnUnload) {
                    Janus.log("Destroying session " + s);
                    Janus.sessions[s].destroy({asyncRequest: false});
                }
            }
            if(oldOBF && typeof oldOBF == "function")
                oldOBF();
        }
        Janus.initDone = true;
        options.callback();
    }
};

// Helper method to check whether WebRTC is supported by this browser
Janus.isWebrtcSupported = function() {
    return window.RTCPeerConnection !== undefined && window.RTCPeerConnection !== null &&
        navigator.getUserMedia !== undefined && navigator.getUserMedia !== null;
};

// Helper method to create random identifiers (e.g., transaction)
Janus.randomString = function(len) {
    var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = '';
    for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz,randomPoz+1);
    }
    return randomString;
}


function Janus(gatewayCallbacks) {
    if(Janus.initDone === undefined) {
        gatewayCallbacks.error("Library not initialized");
        return {};
    }
    if(!Janus.isWebrtcSupported()) {
        gatewayCallbacks.error("WebRTC not supported by this browser");
        return {};
    }
    Janus.log("Library initialized: " + Janus.initDone);
    gatewayCallbacks = gatewayCallbacks || {};
    gatewayCallbacks.success = (typeof gatewayCallbacks.success == "function") ? gatewayCallbacks.success : Janus.noop;
    gatewayCallbacks.error = (typeof gatewayCallbacks.error == "function") ? gatewayCallbacks.error : Janus.noop;
    gatewayCallbacks.destroyed = (typeof gatewayCallbacks.destroyed == "function") ? gatewayCallbacks.destroyed : Janus.noop;
    if(gatewayCallbacks.server === null || gatewayCallbacks.server === undefined) {
        gatewayCallbacks.error("Invalid gateway url");
        return {};
    }
    var websockets = false;
    var ws = null;
    var wsHandlers = {};
    var wsKeepaliveTimeoutId = null;

    var servers = null, serversIndex = 0;
    var server = gatewayCallbacks.server;
    if(Janus.isArray(server)) {
        Janus.log("Multiple servers provided (" + server.length + "), will use the first that works");
        server = null;
        servers = gatewayCallbacks.server;
        Janus.debug(servers);
    } else {
        if(server.indexOf("ws") === 0) {
            websockets = true;
            Janus.log("Using WebSockets to contact Janus: " + server);
        } else {
            websockets = false;
            Janus.log("Using REST API to contact Janus: " + server);
        }
    }
    var iceServers = gatewayCallbacks.iceServers;
    if(iceServers === undefined || iceServers === null)
        iceServers = [{urls: "stun:stun.l.google.com:19302"}];
    var iceTransportPolicy = gatewayCallbacks.iceTransportPolicy;
    var bundlePolicy = gatewayCallbacks.bundlePolicy;
    // Whether IPv6 candidates should be gathered
    var ipv6Support = gatewayCallbacks.ipv6;
    if(ipv6Support === undefined || ipv6Support === null)
        ipv6Support = false;
    // Whether we should enable the withCredentials flag for XHR requests
    var withCredentials = false;
    if(gatewayCallbacks.withCredentials !== undefined && gatewayCallbacks.withCredentials !== null)
        withCredentials = gatewayCallbacks.withCredentials === true;
    // Optional max events
    var maxev = null;
    if(gatewayCallbacks.max_poll_events !== undefined && gatewayCallbacks.max_poll_events !== null)
        maxev = gatewayCallbacks.max_poll_events;
    if(maxev < 1)
        maxev = 1;
    // Token to use (only if the token based authentication mechanism is enabled)
    var token = null;
    if(gatewayCallbacks.token !== undefined && gatewayCallbacks.token !== null)
        token = gatewayCallbacks.token;
    // API secret to use (only if the shared API secret is enabled)
    var apisecret = null;
    if(gatewayCallbacks.apisecret !== undefined && gatewayCallbacks.apisecret !== null)
        apisecret = gatewayCallbacks.apisecret;
    // Whether we should destroy this session when onbeforeunload is called
    this.destroyOnUnload = true;
    if(gatewayCallbacks.destroyOnUnload !== undefined && gatewayCallbacks.destroyOnUnload !== null)
        this.destroyOnUnload = (gatewayCallbacks.destroyOnUnload === true);

    var connected = false;
    var sessionId = null;
    var pluginHandles = {};
    var that = this;
    var retries = 0;
    var transactions = {};
    createSession(gatewayCallbacks);

    // Public methods
    this.getServer = function() { return server; };
    this.isConnected = function() { return connected; };
    this.getSessionId = function() { return sessionId; };
    this.destroy = function(callbacks) { destroySession(callbacks); };
    this.attach = function(callbacks) { createHandle(callbacks); };

    function eventHandler() {
        if(sessionId == null)
            return;
        Janus.debug('Long poll...');
        if(!connected) {
            Janus.warn("Is the gateway down? (connected=false)");
            return;
        }
        var longpoll = server + "/" + sessionId + "?rid=" + new Date().getTime();
        if(maxev !== undefined && maxev !== null)
            longpoll = longpoll + "&maxev=" + maxev;
        if(token !== null && token !== undefined)
            longpoll = longpoll + "&token=" + token;
        if(apisecret !== null && apisecret !== undefined)
            longpoll = longpoll + "&apisecret=" + apisecret;
        Janus.httpAPICall(longpoll, {
            verb: 'GET',
            withCredentials: withCredentials,
            success: handleEvent,
            timeout: 60000,	// FIXME
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ": " + errorThrown);
                retries++;
                if(retries > 3) {
                    // Did we just lose the gateway? :-(
                    connected = false;
                    gatewayCallbacks.error("Lost connection to the gateway (is it down?)");
                    return;
                }
                eventHandler();
            }
        });
    }

    // Private event handler: this will trigger plugin callbacks, if set
    function handleEvent(json, skipTimeout) {
        retries = 0;
        if(!websockets && sessionId !== undefined && sessionId !== null && skipTimeout !== true)
            setTimeout(eventHandler, 200);
        if(!websockets && Janus.isArray(json)) {
            // We got an array: it means we passed a maxev > 1, iterate on all objects
            for(var i=0; i<json.length; i++) {
                handleEvent(json[i], true);
            }
            return;
        }
        if(json["janus"] === "keepalive") {
            // Nothing happened
            Janus.vdebug("Got a keepalive on session " + sessionId);
            return;
        } else if(json["janus"] === "ack") {
            // Just an ack, we can probably ignore
            Janus.debug("Got an ack on session " + sessionId);
            Janus.debug(json);
            var transaction = json["transaction"];
            if(transaction !== null && transaction !== undefined) {
                var reportSuccess = transactions[transaction];
                if(reportSuccess !== null && reportSuccess !== undefined) {
                    reportSuccess(json);
                }
                delete transactions[transaction];
            }
            return;
        } else if(json["janus"] === "success") {
            // Success!
            Janus.debug("Got a success on session " + sessionId);
            Janus.debug(json);
            var transaction = json["transaction"];
            if(transaction !== null && transaction !== undefined) {
                var reportSuccess = transactions[transaction];
                if(reportSuccess !== null && reportSuccess !== undefined) {
                    reportSuccess(json);
                }
                delete transactions[transaction];
            }
            return;
        } else if(json["janus"] === "webrtcup") {
            // The PeerConnection with the gateway is up! Notify this
            Janus.debug("Got a webrtcup event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if(sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if(pluginHandle === undefined || pluginHandle === null) {
                Janus.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.webrtcState(true);
            return;
        } else if(json["janus"] === "hangup") {
            // A plugin asked the core to hangup a PeerConnection on one of our handles
            Janus.debug("Got a hangup event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if(sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if(pluginHandle === undefined || pluginHandle === null) {
                Janus.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.webrtcState(false, json["reason"]);
            pluginHandle.hangup();
        } else if(json["janus"] === "detached") {
            // A plugin asked the core to detach one of our handles
            Janus.debug("Got a detached event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if(sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if(pluginHandle === undefined || pluginHandle === null) {
                // Don't warn here because destroyHandle causes this situation.
                return;
            }
            pluginHandle.detached = true;
            pluginHandle.ondetached();
            pluginHandle.detach();
        } else if(json["janus"] === "media") {
            // Media started/stopped flowing
            Janus.debug("Got a media event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if(sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if(pluginHandle === undefined || pluginHandle === null) {
                Janus.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.mediaState(json["type"], json["receiving"]);
        } else if(json["janus"] === "slowlink") {
            Janus.debug("Got a slowlink event on session " + sessionId);
            Janus.debug(json);
            // Trouble uplink or downlink
            var sender = json["sender"];
            if(sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if(pluginHandle === undefined || pluginHandle === null) {
                Janus.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.slowLink(json["uplink"], json["nacks"]);
        } else if(json["janus"] === "error") {
            // Oops, something wrong happened
            Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
            Janus.debug(json);
            var transaction = json["transaction"];
            if(transaction !== null && transaction !== undefined) {
                var reportSuccess = transactions[transaction];
                if(reportSuccess !== null && reportSuccess !== undefined) {
                    reportSuccess(json);
                }
                delete transactions[transaction];
            }
            return;
        } else if(json["janus"] === "event") {
            Janus.debug("Got a plugin event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if(sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var plugindata = json["plugindata"];
            if(plugindata === undefined || plugindata === null) {
                Janus.warn("Missing plugindata...");
                return;
            }
            Janus.debug("  -- Event is coming from " + sender + " (" + plugindata["plugin"] + ")");
            var data = plugindata["data"];
            Janus.debug(data);
            var pluginHandle = pluginHandles[sender];
            if(pluginHandle === undefined || pluginHandle === null) {
                Janus.warn("This handle is not attached to this session");
                return;
            }
            var jsep = json["jsep"];
            if(jsep !== undefined && jsep !== null) {
                Janus.debug("Handling SDP as well...");
                Janus.debug(jsep);
            }
            var callback = pluginHandle.onmessage;
            if(callback !== null && callback !== undefined) {
                Janus.debug("Notifying application...");
                // Send to callback specified when attaching plugin handle
                callback(data, jsep);
            } else {
                // Send to generic callback (?)
                Janus.debug("No provided notification callback");
            }
        } else {
            Janus.warn("Unkown message/event  '" + json["janus"] + "' on session " + sessionId);
            Janus.debug(json);
        }
    }

    // Private helper to send keep-alive messages on WebSockets
    function keepAlive() {
        if(server === null || !websockets || !connected)
            return;
        wsKeepaliveTimeoutId = setTimeout(keepAlive, 30000);
        var request = { "janus": "keepalive", "session_id": sessionId, "transaction": Janus.randomString(12) };
        if(token !== null && token !== undefined)
            request["token"] = token;
        if(apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        ws.send(JSON.stringify(request));
    }

    // Private method to create a session
    function createSession(callbacks) {
        var transaction = Janus.randomString(12);
        var request = { "janus": "create", "transaction": transaction };
        if(token !== null && token !== undefined)
            request["token"] = token;
        if(apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        if(server === null && Janus.isArray(servers)) {
            // We still need to find a working server from the list we were given
            server = servers[serversIndex];
            if(server.indexOf("ws") === 0) {
                websockets = true;
                Janus.log("Server #" + (serversIndex+1) + ": trying WebSockets to contact Janus (" + server + ")");
            } else {
                websockets = false;
                Janus.log("Server #" + (serversIndex+1) + ": trying REST API to contact Janus (" + server + ")");
            }
        }
        if(websockets) {
            ws = Janus.newWebSocket(server, 'janus-protocol');
            wsHandlers = {
                'error': function() {
                    Janus.error("Error connecting to the Janus WebSockets server... " + server);
                    if (Janus.isArray(servers)) {
                        serversIndex++;
                        if (serversIndex == servers.length) {
                            // We tried all the servers the user gave us and they all failed
                            callbacks.error("Error connecting to any of the provided Janus servers: Is the gateway down?");
                            return;
                        }
                        // Let's try the next server
                        server = null;
                        setTimeout(function() {
                            createSession(callbacks);
                        }, 200);
                        return;
                    }
                    callbacks.error("Error connecting to the Janus WebSockets server: Is the gateway down?");
                },

                'open': function() {
                    // We need to be notified about the success
                    transactions[transaction] = function(json) {
                        Janus.debug(json);
                        if (json["janus"] !== "success") {
                            Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
                            callbacks.error(json["error"].reason);
                            return;
                        }
                        wsKeepaliveTimeoutId = setTimeout(keepAlive, 30000);
                        connected = true;
                        sessionId = json.data["id"];
                        Janus.log("Created session: " + sessionId);
                        Janus.sessions[sessionId] = that;
                        callbacks.success();
                    };
                    ws.send(JSON.stringify(request));
                },

                'message': function(event) {
                    handleEvent(JSON.parse(event.data));
                },

                'close': function() {
                    if (server === null || !connected) {
                        return;
                    }
                    connected = false;
                    // FIXME What if this is called when the page is closed?
                    gatewayCallbacks.error("Lost connection to the gateway (is it down?)");
                }
            };

            for(var eventName in wsHandlers) {
                ws.addEventListener(eventName, wsHandlers[eventName]);
            }

            return;
        }
        Janus.httpAPICall(server, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.debug(json);
                if(json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
                    callbacks.error(json["error"].reason);
                    return;
                }
                connected = true;
                sessionId = json.data["id"];
                Janus.log("Created session: " + sessionId);
                Janus.sessions[sessionId] = that;
                eventHandler();
                callbacks.success();
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ": " + errorThrown);	// FIXME
                if(Janus.isArray(servers)) {
                    serversIndex++;
                    if(serversIndex == servers.length) {
                        // We tried all the servers the user gave us and they all failed
                        callbacks.error("Error connecting to any of the provided Janus servers: Is the gateway down?");
                        return;
                    }
                    // Let's try the next server
                    server = null;
                    setTimeout(function() { createSession(callbacks); }, 200);
                    return;
                }
                if(errorThrown === "")
                    callbacks.error(textStatus + ": Is the gateway down?");
                else
                    callbacks.error(textStatus + ": " + errorThrown);
            }
        });
    }

    // Private method to destroy a session
    function destroySession(callbacks) {
        callbacks = callbacks || {};
        // FIXME This method triggers a success even when we fail
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        var asyncRequest = true;
        if(callbacks.asyncRequest !== undefined && callbacks.asyncRequest !== null)
            asyncRequest = (callbacks.asyncRequest === true);
        Janus.log("Destroying session " + sessionId + " (async=" + asyncRequest + ")");
        if(!connected) {
            Janus.warn("Is the gateway down? (connected=false)");
            callbacks.success();
            return;
        }
        if(sessionId === undefined || sessionId === null) {
            Janus.warn("No session to destroy");
            callbacks.success();
            gatewayCallbacks.destroyed();
            return;
        }
        delete Janus.sessions[sessionId];
        // No need to destroy all handles first, Janus will do that itself
        var request = { "janus": "destroy", "transaction": Janus.randomString(12) };
        if(token !== null && token !== undefined)
            request["token"] = token;
        if(apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        if(websockets) {
            request["session_id"] = sessionId;

            var unbindWebSocket = function() {
                for(var eventName in wsHandlers) {
                    ws.removeEventListener(eventName, wsHandlers[eventName]);
                }
                ws.removeEventListener('message', onUnbindMessage);
                ws.removeEventListener('error', onUnbindError);
                if(wsKeepaliveTimeoutId) {
                    clearTimeout(wsKeepaliveTimeoutId);
                }
            };

            var onUnbindMessage = function(event){
                var data = JSON.parse(event.data);
                if(data.session_id == request.session_id && data.transaction == request.transaction) {
                    unbindWebSocket();
                    callbacks.success();
                    gatewayCallbacks.destroyed();
                }
            };
            var onUnbindError = function(event) {
                unbindWebSocket();
                callbacks.error("Failed to destroy the gateway: Is the gateway down?");
                gatewayCallbacks.destroyed();
            };

            ws.addEventListener('message', onUnbindMessage);
            ws.addEventListener('error', onUnbindError);

            ws.send(JSON.stringify(request));
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId, {
            verb: 'POST',
            async: asyncRequest,	// Sometimes we need false here, or destroying in onbeforeunload won't work
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.log("Destroyed session:");
                Janus.debug(json);
                sessionId = null;
                connected = false;
                if(json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
                }
                callbacks.success();
                gatewayCallbacks.destroyed();
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ": " + errorThrown);	// FIXME
                // Reset everything anyway
                sessionId = null;
                connected = false;
                callbacks.success();
                gatewayCallbacks.destroyed();
            }
        });
    }

    // Private method to create a plugin handle
    function createHandle(callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        callbacks.consentDialog = (typeof callbacks.consentDialog == "function") ? callbacks.consentDialog : Janus.noop;
        callbacks.iceState = (typeof callbacks.iceState == "function") ? callbacks.iceState : Janus.noop;
        callbacks.mediaState = (typeof callbacks.mediaState == "function") ? callbacks.mediaState : Janus.noop;
        callbacks.webrtcState = (typeof callbacks.webrtcState == "function") ? callbacks.webrtcState : Janus.noop;
        callbacks.slowLink = (typeof callbacks.slowLink == "function") ? callbacks.slowLink : Janus.noop;
        callbacks.onmessage = (typeof callbacks.onmessage == "function") ? callbacks.onmessage : Janus.noop;
        callbacks.onlocalstream = (typeof callbacks.onlocalstream == "function") ? callbacks.onlocalstream : Janus.noop;
        callbacks.onremotestream = (typeof callbacks.onremotestream == "function") ? callbacks.onremotestream : Janus.noop;
        callbacks.ondata = (typeof callbacks.ondata == "function") ? callbacks.ondata : Janus.noop;
        callbacks.ondataopen = (typeof callbacks.ondataopen == "function") ? callbacks.ondataopen : Janus.noop;
        callbacks.oncleanup = (typeof callbacks.oncleanup == "function") ? callbacks.oncleanup : Janus.noop;
        callbacks.ondetached = (typeof callbacks.ondetached == "function") ? callbacks.ondetached : Janus.noop;
        if(!connected) {
            Janus.warn("Is the gateway down? (connected=false)");
            callbacks.error("Is the gateway down? (connected=false)");
            return;
        }
        var plugin = callbacks.plugin;
        if(plugin === undefined || plugin === null) {
            Janus.error("Invalid plugin");
            callbacks.error("Invalid plugin");
            return;
        }
        var opaqueId = callbacks.opaqueId;
        var transaction = Janus.randomString(12);
        var request = { "janus": "attach", "plugin": plugin, "opaque_id": opaqueId, "transaction": transaction };
        if(token !== null && token !== undefined)
            request["token"] = token;
        if(apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        // If we know the browser supports BUNDLE and/or rtcp-mux, let's advertise those right away
        if(Janus.webRTCAdapter.browserDetails.browser == "chrome" || Janus.webRTCAdapter.browserDetails.browser == "firefox" ||
            Janus.webRTCAdapter.browserDetails.browser == "safari") {
            request["force-bundle"] = true;
            request["force-rtcp-mux"] = true;
        }
        if(websockets) {
            transactions[transaction] = function(json) {
                Janus.debug(json);
                if(json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
                    callbacks.error("Ooops: " + json["error"].code + " " + json["error"].reason);
                    return;
                }
                var handleId = json.data["id"];
                Janus.log("Created handle: " + handleId);
                var pluginHandle =
                    {
                        session : that,
                        plugin : plugin,
                        id : handleId,
                        detached : false,
                        webrtcStuff : {
                            started : false,
                            myStream : null,
                            streamExternal : false,
                            remoteStream : null,
                            mySdp : null,
                            pc : null,
                            dataChannel : null,
                            dtmfSender : null,
                            trickle : true,
                            iceDone : false,
                            sdpSent : false,
                            volume : {
                                value : null,
                                timer : null
                            },
                            bitrate : {
                                value : null,
                                bsnow : null,
                                bsbefore : null,
                                tsnow : null,
                                tsbefore : null,
                                timer : null
                            }
                        },
                        getId : function() { return handleId; },
                        getPlugin : function() { return plugin; },
                        getVolume : function() { return getVolume(handleId); },
                        isAudioMuted : function() { return isMuted(handleId, false); },
                        muteAudio : function() { return mute(handleId, false, true); },
                        unmuteAudio : function() { return mute(handleId, false, false); },
                        isVideoMuted : function() { return isMuted(handleId, true); },
                        muteVideo : function() { return mute(handleId, true, true); },
                        unmuteVideo : function() { return mute(handleId, true, false); },
                        getBitrate : function() { return getBitrate(handleId); },
                        send : function(callbacks) { sendMessage(handleId, callbacks); },
                        data : function(callbacks) { sendData(handleId, callbacks); },
                        dtmf : function(callbacks) { sendDtmf(handleId, callbacks); },
                        consentDialog : callbacks.consentDialog,
                        iceState : callbacks.iceState,
                        mediaState : callbacks.mediaState,
                        webrtcState : callbacks.webrtcState,
                        slowLink : callbacks.slowLink,
                        onmessage : callbacks.onmessage,
                        createOffer : function(callbacks) { prepareWebrtc(handleId, callbacks); },
                        createAnswer : function(callbacks) { prepareWebrtc(handleId, callbacks); },
                        handleRemoteJsep : function(callbacks) { prepareWebrtcPeer(handleId, callbacks); },
                        onlocalstream : callbacks.onlocalstream,
                        onremotestream : callbacks.onremotestream,
                        ondata : callbacks.ondata,
                        ondataopen : callbacks.ondataopen,
                        oncleanup : callbacks.oncleanup,
                        ondetached : callbacks.ondetached,
                        hangup : function(sendRequest) { cleanupWebrtc(handleId, sendRequest === true); },
                        detach : function(callbacks) { destroyHandle(handleId, callbacks); }
                    }
                pluginHandles[handleId] = pluginHandle;
                callbacks.success(pluginHandle);
            };
            request["session_id"] = sessionId;
            ws.send(JSON.stringify(request));
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.debug(json);
                if(json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
                    callbacks.error("Ooops: " + json["error"].code + " " + json["error"].reason);
                    return;
                }
                var handleId = json.data["id"];
                Janus.log("Created handle: " + handleId);
                var pluginHandle =
                    {
                        session : that,
                        plugin : plugin,
                        id : handleId,
                        detached : false,
                        webrtcStuff : {
                            started : false,
                            myStream : null,
                            streamExternal : false,
                            remoteStream : null,
                            mySdp : null,
                            pc : null,
                            dataChannel : null,
                            dtmfSender : null,
                            trickle : true,
                            iceDone : false,
                            sdpSent : false,
                            volume : {
                                value : null,
                                timer : null
                            },
                            bitrate : {
                                value : null,
                                bsnow : null,
                                bsbefore : null,
                                tsnow : null,
                                tsbefore : null,
                                timer : null
                            }
                        },
                        getId : function() { return handleId; },
                        getPlugin : function() { return plugin; },
                        getVolume : function() { return getVolume(handleId); },
                        isAudioMuted : function() { return isMuted(handleId, false); },
                        muteAudio : function() { return mute(handleId, false, true); },
                        unmuteAudio : function() { return mute(handleId, false, false); },
                        isVideoMuted : function() { return isMuted(handleId, true); },
                        muteVideo : function() { return mute(handleId, true, true); },
                        unmuteVideo : function() { return mute(handleId, true, false); },
                        getBitrate : function() { return getBitrate(handleId); },
                        send : function(callbacks) { sendMessage(handleId, callbacks); },
                        data : function(callbacks) { sendData(handleId, callbacks); },
                        dtmf : function(callbacks) { sendDtmf(handleId, callbacks); },
                        consentDialog : callbacks.consentDialog,
                        iceState : callbacks.iceState,
                        mediaState : callbacks.mediaState,
                        webrtcState : callbacks.webrtcState,
                        slowLink : callbacks.slowLink,
                        onmessage : callbacks.onmessage,
                        createOffer : function(callbacks) { prepareWebrtc(handleId, callbacks); },
                        createAnswer : function(callbacks) { prepareWebrtc(handleId, callbacks); },
                        handleRemoteJsep : function(callbacks) { prepareWebrtcPeer(handleId, callbacks); },
                        onlocalstream : callbacks.onlocalstream,
                        onremotestream : callbacks.onremotestream,
                        ondata : callbacks.ondata,
                        ondataopen : callbacks.ondataopen,
                        oncleanup : callbacks.oncleanup,
                        ondetached : callbacks.ondetached,
                        hangup : function(sendRequest) { cleanupWebrtc(handleId, sendRequest === true); },
                        detach : function(callbacks) { destroyHandle(handleId, callbacks); }
                    }
                pluginHandles[handleId] = pluginHandle;
                callbacks.success(pluginHandle);
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ": " + errorThrown);	// FIXME
            }
        });
    }

    // Private method to send a message
    function sendMessage(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        if(!connected) {
            Janus.warn("Is the gateway down? (connected=false)");
            callbacks.error("Is the gateway down? (connected=false)");
            return;
        }
        var message = callbacks.message;
        var jsep = callbacks.jsep;
        var transaction = Janus.randomString(12);
        var request = { "janus": "message", "body": message, "transaction": transaction };
        if(token !== null && token !== undefined)
            request["token"] = token;
        if(apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        if(jsep !== null && jsep !== undefined)
            request.jsep = jsep;
        Janus.debug("Sending message to plugin (handle=" + handleId + "):");
        Janus.debug(request);
        if(websockets) {
            request["session_id"] = sessionId;
            request["handle_id"] = handleId;
            transactions[transaction] = function(json) {
                Janus.debug("Message sent!");
                Janus.debug(json);
                if(json["janus"] === "success") {
                    // We got a success, must have been a synchronous transaction
                    var plugindata = json["plugindata"];
                    if(plugindata === undefined || plugindata === null) {
                        Janus.warn("Request succeeded, but missing plugindata...");
                        callbacks.success();
                        return;
                    }
                    Janus.log("Synchronous transaction successful (" + plugindata["plugin"] + ")");
                    var data = plugindata["data"];
                    Janus.debug(data);
                    callbacks.success(data);
                    return;
                } else if(json["janus"] !== "ack") {
                    // Not a success and not an ack, must be an error
                    if(json["error"] !== undefined && json["error"] !== null) {
                        Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
                        callbacks.error(json["error"].code + " " + json["error"].reason);
                    } else {
                        Janus.error("Unknown error");	// FIXME
                        callbacks.error("Unknown error");
                    }
                    return;
                }
                // If we got here, the plugin decided to handle the request asynchronously
                callbacks.success();
            };
            ws.send(JSON.stringify(request));
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.debug("Message sent!");
                Janus.debug(json);
                if(json["janus"] === "success") {
                    // We got a success, must have been a synchronous transaction
                    var plugindata = json["plugindata"];
                    if(plugindata === undefined || plugindata === null) {
                        Janus.warn("Request succeeded, but missing plugindata...");
                        callbacks.success();
                        return;
                    }
                    Janus.log("Synchronous transaction successful (" + plugindata["plugin"] + ")");
                    var data = plugindata["data"];
                    Janus.debug(data);
                    callbacks.success(data);
                    return;
                } else if(json["janus"] !== "ack") {
                    // Not a success and not an ack, must be an error
                    if(json["error"] !== undefined && json["error"] !== null) {
                        Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
                        callbacks.error(json["error"].code + " " + json["error"].reason);
                    } else {
                        Janus.error("Unknown error");	// FIXME
                        callbacks.error("Unknown error");
                    }
                    return;
                }
                // If we got here, the plugin decided to handle the request asynchronously
                callbacks.success();
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ": " + errorThrown);	// FIXME
                callbacks.error(textStatus + ": " + errorThrown);
            }
        });
    }

    // Private method to send a trickle candidate
    function sendTrickleCandidate(handleId, candidate) {
        if(!connected) {
            Janus.warn("Is the gateway down? (connected=false)");
            return;
        }
        var request = { "janus": "trickle", "candidate": candidate, "transaction": Janus.randomString(12) };
        if(token !== null && token !== undefined)
            request["token"] = token;
        if(apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        Janus.vdebug("Sending trickle candidate (handle=" + handleId + "):");
        Janus.vdebug(request);
        if(websockets) {
            request["session_id"] = sessionId;
            request["handle_id"] = handleId;
            ws.send(JSON.stringify(request));
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.vdebug("Candidate sent!");
                Janus.vdebug(json);
                if(json["janus"] !== "ack") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
                    return;
                }
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ": " + errorThrown);	// FIXME
            }
        });
    }

    // Private method to send a data channel message
    function sendData(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        var text = callbacks.text;
        if(text === null || text === undefined) {
            Janus.warn("Invalid text");
            callbacks.error("Invalid text");
            return;
        }
        Janus.log("Sending string on data channel: " + text);
        config.dataChannel.send(text);
        callbacks.success();
    }

    // Private method to send a DTMF tone
    function sendDtmf(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        if(config.dtmfSender === null || config.dtmfSender === undefined) {
            // Create the DTMF sender, if possible
            if(config.myStream !== undefined && config.myStream !== null) {
                var tracks = config.myStream.getAudioTracks();
                if(tracks !== null && tracks !== undefined && tracks.length > 0) {
                    var local_audio_track = tracks[0];
                    config.dtmfSender = config.pc.createDTMFSender(local_audio_track);
                    Janus.log("Created DTMF Sender");
                    config.dtmfSender.ontonechange = function(tone) { Janus.debug("Sent DTMF tone: " + tone.tone); };
                }
            }
            if(config.dtmfSender === null || config.dtmfSender === undefined) {
                Janus.warn("Invalid DTMF configuration");
                callbacks.error("Invalid DTMF configuration");
                return;
            }
        }
        var dtmf = callbacks.dtmf;
        if(dtmf === null || dtmf === undefined) {
            Janus.warn("Invalid DTMF parameters");
            callbacks.error("Invalid DTMF parameters");
            return;
        }
        var tones = dtmf.tones;
        if(tones === null || tones === undefined) {
            Janus.warn("Invalid DTMF string");
            callbacks.error("Invalid DTMF string");
            return;
        }
        var duration = dtmf.duration;
        if(duration === null || duration === undefined)
            duration = 500;	// We choose 500ms as the default duration for a tone
        var gap = dtmf.gap;
        if(gap === null || gap === undefined)
            gap = 50;	// We choose 50ms as the default gap between tones
        Janus.debug("Sending DTMF string " + tones + " (duration " + duration + "ms, gap " + gap + "ms)");
        config.dtmfSender.insertDTMF(tones, duration, gap);
    }

    // Private method to destroy a plugin handle
    function destroyHandle(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        Janus.warn(callbacks);
        var asyncRequest = true;
        if(callbacks.asyncRequest !== undefined && callbacks.asyncRequest !== null)
            asyncRequest = (callbacks.asyncRequest === true);
        Janus.log("Destroying handle " + handleId + " (async=" + asyncRequest + ")");
        cleanupWebrtc(handleId);
        if (pluginHandles[handleId].detached) {
            // Plugin was already detached by Janus, calling detach again will return a handle not found error, so just exit here
            delete pluginHandles[handleId];
            callbacks.success();
            return;
        }
        if(!connected) {
            Janus.warn("Is the gateway down? (connected=false)");
            callbacks.error("Is the gateway down? (connected=false)");
            return;
        }
        var request = { "janus": "detach", "transaction": Janus.randomString(12) };
        if(token !== null && token !== undefined)
            request["token"] = token;
        if(apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        if(websockets) {
            request["session_id"] = sessionId;
            request["handle_id"] = handleId;
            ws.send(JSON.stringify(request));
            delete pluginHandles[handleId];
            callbacks.success();
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            async: asyncRequest,	// Sometimes we need false here, or destroying in onbeforeunload won't work
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.log("Destroyed handle:");
                Janus.debug(json);
                if(json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason);	// FIXME
                }
                delete pluginHandles[handleId];
                callbacks.success();
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ": " + errorThrown);	// FIXME
                // We cleanup anyway
                delete pluginHandles[handleId];
                callbacks.success();
            }
        });
    }

    // WebRTC stuff
    function streamsDone(handleId, jsep, media, callbacks, stream) {
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        Janus.debug("streamsDone:", stream);
        config.myStream = stream;
        var pc_config = {"iceServers": iceServers, "iceTransportPolicy": iceTransportPolicy, "bundlePolicy": bundlePolicy};
        //~ var pc_constraints = {'mandatory': {'MozDontOfferDataChannel':true}};
        var pc_constraints = {
            "optional": [{"DtlsSrtpKeyAgreement": true}]
        };
        if(ipv6Support === true) {
            // FIXME This is only supported in Chrome right now
            // For support in Firefox track this: https://bugzilla.mozilla.org/show_bug.cgi?id=797262
            pc_constraints.optional.push({"googIPv6":true});
        }
        // Any custom constraint to add?
        if(callbacks.rtcConstraints && typeof callbacks.rtcConstraints === 'object') {
            Janus.debug("Adding custom PeerConnection constraints:", callbacks.rtcConstraints);
            for(var i in callbacks.rtcConstraints) {
                pc_constraints.optional.push(callbacks.rtcConstraints[i]);
            }
        }
        if(Janus.webRTCAdapter.browserDetails.browser === "edge") {
            // This is Edge, enable BUNDLE explicitly
            pc_config.bundlePolicy = "max-bundle";
        }
        Janus.log("Creating PeerConnection");
        Janus.debug(pc_constraints);
        config.pc = new RTCPeerConnection(pc_config, pc_constraints);
        Janus.debug(config.pc);
        if(config.pc.getStats) {	// FIXME
            config.volume.value = 0;
            config.bitrate.value = "0 kbits/sec";
        }
        Janus.log("Preparing local SDP and gathering candidates (trickle=" + config.trickle + ")");
        config.pc.oniceconnectionstatechange = function(e) {
            if(config.pc)
                pluginHandle.iceState(config.pc.iceConnectionState);
        };
        config.pc.onicecandidate = function(event) {
            if (event.candidate == null ||
                (Janus.webRTCAdapter.browserDetails.browser === 'edge' && event.candidate.candidate.indexOf('endOfCandidates') > 0)) {
                Janus.log("End of candidates.");
                config.iceDone = true;
                if(config.trickle === true) {
                    // Notify end of candidates
                    sendTrickleCandidate(handleId, {"completed": true});
                } else {
                    // No trickle, time to send the complete SDP (including all candidates)
                    sendSDP(handleId, callbacks);
                }
            } else {
                // JSON.stringify doesn't work on some WebRTC objects anymore
                // See https://code.google.com/p/chromium/issues/detail?id=467366
                var candidate = {
                    "candidate": event.candidate.candidate,
                    "sdpMid": event.candidate.sdpMid,
                    "sdpMLineIndex": event.candidate.sdpMLineIndex
                };
                if(config.trickle === true) {
                    // Send candidate
                    sendTrickleCandidate(handleId, candidate);
                }
            }
        };
        if(stream !== null && stream !== undefined) {
            Janus.log('Adding local stream');
            stream.getTracks().forEach(function(track) { config.pc.addTrack(track, stream); });
            pluginHandle.onlocalstream(stream);
        }
        config.pc.ontrack = function(event) {
            Janus.log("Handling Remote Track");
            Janus.debug(event);
            if(!event.streams)
                return;
            config.remoteStream = event.streams[0];
            pluginHandle.onremotestream(config.remoteStream);
        };
        // Any data channel to create?
        if(isDataEnabled(media)) {
            Janus.log("Creating data channel");
            var onDataChannelMessage = function(event) {
                Janus.log('Received message on data channel: ' + event.data);
                pluginHandle.ondata(event.data);	// FIXME
            }
            var onDataChannelStateChange = function() {
                var dcState = config.dataChannel !== null ? config.dataChannel.readyState : "null";
                Janus.log('State change on data channel: ' + dcState);
                if(dcState === 'open') {
                    pluginHandle.ondataopen();	// FIXME
                }
            }
            var onDataChannelError = function(error) {
                Janus.error('Got error on data channel:', error);
                // TODO
            }
            // Until we implement the proxying of open requests within the Janus core, we open a channel ourselves whatever the case
            config.dataChannel = config.pc.createDataChannel("JanusDataChannel", {ordered:false});	// FIXME Add options (ordered, maxRetransmits, etc.)
            config.dataChannel.onmessage = onDataChannelMessage;
            config.dataChannel.onopen = onDataChannelStateChange;
            config.dataChannel.onclose = onDataChannelStateChange;
            config.dataChannel.onerror = onDataChannelError;
        }
        // Create offer/answer now
        if(jsep === null || jsep === undefined) {
            createOffer(handleId, media, callbacks);
        } else {
            config.pc.setRemoteDescription(
                new RTCSessionDescription(jsep),
                function() {
                    Janus.log("Remote description accepted!");
                    createAnswer(handleId, media, callbacks);
                }, callbacks.error);
        }
    }

    function prepareWebrtc(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : webrtcError;
        var jsep = callbacks.jsep;
        var media = callbacks.media;
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        // Are we updating a session?
        if(config.pc !== undefined && config.pc !== null) {
            Janus.log("Updating existing media session");
            // Create offer/answer now
            if(jsep === null || jsep === undefined) {
                createOffer(handleId, media, callbacks);
            } else {
                config.pc.setRemoteDescription(
                    new RTCSessionDescription(jsep),
                    function() {
                        Janus.log("Remote description accepted!");
                        createAnswer(handleId, media, callbacks);
                    }, callbacks.error);
            }
            return;
        }
        config.trickle = isTrickleEnabled(callbacks.trickle);
        // Was a MediaStream object passed, or do we need to take care of that?
        if(callbacks.stream !== null && callbacks.stream !== undefined) {
            var stream = callbacks.stream;
            Janus.log("MediaStream provided by the application");
            Janus.debug(stream);
            // Skip the getUserMedia part
            config.streamExternal = true;
            streamsDone(handleId, jsep, media, callbacks, stream);
            return;
        }
        if(isAudioSendEnabled(media) || isVideoSendEnabled(media)) {
            var constraints = { mandatory: {}, optional: []};
            pluginHandle.consentDialog(true);
            var audioSupport = isAudioSendEnabled(media);
            if(audioSupport === true && media != undefined && media != null) {
                if(typeof media.audio === 'object') {
                    audioSupport = media.audio;
                }
            }
            var videoSupport = isVideoSendEnabled(media);
            if(videoSupport === true && media != undefined && media != null) {
                var simulcast = callbacks.simulcast === true ? true : false;
                if(simulcast && !jsep && (media.video === undefined || media.video === false))
                    media.video = "hires";
                if(media.video && media.video != 'screen' && media.video != 'window') {
                    var width = 0;
                    var height = 0, maxHeight = 0;
                    if(media.video === 'lowres') {
                        // Small resolution, 4:3
                        height = 240;
                        maxHeight = 240;
                        width = 320;
                    } else if(media.video === 'lowres-16:9') {
                        // Small resolution, 16:9
                        height = 180;
                        maxHeight = 180;
                        width = 320;
                    } else if(media.video === 'hires' || media.video === 'hires-16:9' ) {
                        // High resolution is only 16:9
                        height = 720;
                        maxHeight = 720;
                        width = 1280;
                        if(navigator.mozGetUserMedia) {
                            var firefoxVer = parseInt(window.navigator.userAgent.match(/Firefox\/(.*)/)[1], 10);
                            if(firefoxVer < 38) {
                                // Unless this is and old Firefox, which doesn't support it
                                Janus.warn(media.video + " unsupported, falling back to stdres (old Firefox)");
                                height = 480;
                                maxHeight = 480;
                                width  = 640;
                            }
                        }
                    } else if(media.video === 'stdres') {
                        // Normal resolution, 4:3
                        height = 480;
                        maxHeight = 480;
                        width  = 640;
                    } else if(media.video === 'stdres-16:9') {
                        // Normal resolution, 16:9
                        height = 360;
                        maxHeight = 360;
                        width = 640;
                    } else {
                        Janus.log("Default video setting is stdres 4:3");
                        height = 480;
                        maxHeight = 480;
                        width = 640;
                    }
                    Janus.log("Adding media constraint:", media.video);
                    if(navigator.mozGetUserMedia) {
                        var firefoxVer = parseInt(window.navigator.userAgent.match(/Firefox\/(.*)/)[1], 10);
                        if(firefoxVer < 38) {
                            videoSupport = {
                                'require': ['height', 'width'],
                                'height': {'max': maxHeight, 'min': height},
                                'width':  {'max': width,  'min': width}
                            };
                        } else {
                            // http://stackoverflow.com/questions/28282385/webrtc-firefox-constraints/28911694#28911694
                            // https://github.com/meetecho/janus-gateway/pull/246
                            videoSupport = {
                                'height': {'ideal': height},
                                'width':  {'ideal': width}
                            };
                        }
                    } else {
                        videoSupport = {
                            'mandatory': {
                                'maxHeight': maxHeight,
                                'minHeight': height,
                                'maxWidth':  width,
                                'minWidth':  width
                            },
                            'optional': []
                        };
                    }
                    if(typeof media.video === 'object') {
                        videoSupport = media.video;
                    }
                    Janus.debug(videoSupport);
                } else if(media.video === 'screen' || media.video === 'window') {
                    if(!media.screenshareFrameRate) {
                        media.screenshareFrameRate = 3;
                    }
                    // Not a webcam, but screen capture
                    if(window.location.protocol !== 'https:') {
                        // Screen sharing mandates HTTPS
                        Janus.warn("Screen sharing only works on HTTPS, try the https:// version of this page");
                        pluginHandle.consentDialog(false);
                        callbacks.error("Screen sharing only works on HTTPS, try the https:// version of this page");
                        return;
                    }
                    // We're going to try and use the extension for Chrome 34+, the old approach
                    // for older versions of Chrome, or the experimental support in Firefox 33+
                    var cache = {};
                    function callbackUserMedia (error, stream) {
                        pluginHandle.consentDialog(false);
                        if(error) {
                            callbacks.error({code: error.code, name: error.name, message: error.message});
                        } else {
                            streamsDone(handleId, jsep, media, callbacks, stream);
                        }
                    };
                    function getScreenMedia(constraints, gsmCallback, useAudio) {
                        Janus.log("Adding media constraint (screen capture)");
                        Janus.debug(constraints);
                        navigator.mediaDevices.getUserMedia(constraints)
                        .then(function(stream) {
                            if(useAudio){
                                navigator.mediaDevices.getUserMedia({ audio: true, video: false })
                                .then(function (audioStream) {
                                    stream.addTrack(audioStream.getAudioTracks()[0]);
                                    gsmCallback(null, stream);
                                })
                            } else {
                                gsmCallback(null, stream);
                            }
                        })
                        .catch(function(error) { pluginHandle.consentDialog(false); gsmCallback(error); });
                    };
                    if(Janus.webRTCAdapter.browserDetails.browser === 'chrome') {
                        var chromever = Janus.webRTCAdapter.browserDetails.version;
                        var maxver = 33;
                        if(window.navigator.userAgent.match('Linux'))
                            maxver = 35;	// "known" crash in chrome 34 and 35 on linux
                        if(chromever >= 26 && chromever <= maxver) {
                            // Chrome 26->33 requires some awkward chrome://flags manipulation
                            constraints = {
                                video: {
                                    mandatory: {
                                        googLeakyBucket: true,
                                        maxWidth: window.screen.width,
                                        maxHeight: window.screen.height,
                                        minFrameRate: media.screenshareFrameRate,
                                        maxFrameRate: media.screenshareFrameRate,
                                        chromeMediaSource: 'screen'
                                    }
                                },
                                audio: isAudioSendEnabled(media)
                            };
                            getScreenMedia(constraints, callbackUserMedia);
                        } else {
                            // Chrome 34+ requires an extension
                            var pending = window.setTimeout(
                                function () {
                                    error = new Error('NavigatorUserMediaError');
                                    error.name = 'The required Chrome extension is not installed: click <a href="#">here</a> to install it. (NOTE: this will need you to refresh the page)';
                                    pluginHandle.consentDialog(false);
                                    return callbacks.error(error);
                                }, 1000);
                            cache[pending] = [callbackUserMedia, null];
                            window.postMessage({ type: 'janusGetScreen', id: pending }, '*');
                        }
                    } else if (window.navigator.userAgent.match('Firefox')) {
                        var ffver = parseInt(window.navigator.userAgent.match(/Firefox\/(.*)/)[1], 10);
                        if(ffver >= 33) {
                            // Firefox 33+ has experimental support for screen sharing
                            constraints = {
                                video: {
                                    mozMediaSource: media.video,
                                    mediaSource: media.video
                                },
                                audio: isAudioSendEnabled(media)
                            };
                            getScreenMedia(constraints, function (err, stream) {
                                callbackUserMedia(err, stream);
                                // Workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=1045810
                                if (!err) {
                                    var lastTime = stream.currentTime;
                                    var polly = window.setInterval(function () {
                                        if(!stream)
                                            window.clearInterval(polly);
                                        if(stream.currentTime == lastTime) {
                                            window.clearInterval(polly);
                                            if(stream.onended) {
                                                stream.onended();
                                            }
                                        }
                                        lastTime = stream.currentTime;
                                    }, 500);
                                }
                            });
                        } else {
                            var error = new Error('NavigatorUserMediaError');
                            error.name = 'Your version of Firefox does not support screen sharing, please install Firefox 33 (or more recent versions)';
                            pluginHandle.consentDialog(false);
                            callbacks.error(error);
                            return;
                        }
                    }

                    // Wait for events from the Chrome Extension
                    window.addEventListener('message', function (event) {
                        if(event.origin != window.location.origin)
                            return;
                        if(event.data.type == 'janusGotScreen' && cache[event.data.id]) {
                            var data = cache[event.data.id];
                            var callback = data[0];
                            delete cache[event.data.id];

                            if (event.data.sourceId === '') {
                                // user canceled
                                var error = new Error('NavigatorUserMediaError');
                                error.name = 'You cancelled the request for permission, giving up...';
                                pluginHandle.consentDialog(false);
                                callbacks.error(error);
                            } else {
                                constraints = {
                                    audio: false,
                                    video: {
                                        mandatory: {
                                            chromeMediaSource: 'desktop',
                                            maxWidth: window.screen.width,
                                            maxHeight: window.screen.height,
                                            minFrameRate: media.screenshareFrameRate,
                                            maxFrameRate: media.screenshareFrameRate,
                                        },
                                        optional: [
                                            {googLeakyBucket: true},
                                            {googTemporalLayeredScreencast: true}
                                        ]
                                    }
                                };
                                constraints.video.mandatory.chromeMediaSourceId = event.data.sourceId;
                                getScreenMedia(constraints, callback, isAudioSendEnabled(media));
                            }
                        } else if (event.data.type == 'janusGetScreenPending') {
                            window.clearTimeout(event.data.id);
                        }
                    });
                    return;
                }
            }
            // If we got here, we're not screensharing
            if(media === null || media === undefined || media.video !== 'screen') {
                // Check whether all media sources are actually available or not
                navigator.mediaDevices.enumerateDevices().then(function(devices) {
                    var audioExist = devices.some(function(device) {
                            return device.kind === 'audioinput';
                        }),
                        videoExist = devices.some(function(device) {
                            return device.kind === 'videoinput';
                        });

                    // Check whether a missing device is really a problem
                    var audioSend = isAudioSendEnabled(media);
                    var videoSend = isVideoSendEnabled(media);
                    var needAudioDevice = isAudioSendRequired(media);
                    var needVideoDevice = isVideoSendRequired(media);
                    if(audioSend || videoSend || needAudioDevice || needVideoDevice) {
                        // We need to send either audio or video
                        var haveAudioDevice = audioSend ? audioExist : false;
                        var haveVideoDevice = videoSend ? videoExist : false;
                        if(!haveAudioDevice && !haveVideoDevice) {
                            // FIXME Should we really give up, or just assume recvonly for both?
                            pluginHandle.consentDialog(false);
                            callbacks.error('No capture device found');
                            return false;
                        } else if(!haveAudioDevice && needAudioDevice) {
                            pluginHandle.consentDialog(false);
                            callbacks.error('Audio capture is required, but no capture device found');
                            return false;
                        } else if(!haveVideoDevice && needVideoDevice) {
                            pluginHandle.consentDialog(false);
                            callbacks.error('Video capture is required, but no capture device found');
                            return false;
                        }
                    }

                    navigator.mediaDevices.getUserMedia({
                        audio: audioExist ? audioSupport : false,
                        video: videoExist ? videoSupport : false
                    })
                    .then(function(stream) { pluginHandle.consentDialog(false); streamsDone(handleId, jsep, media, callbacks, stream); })
                    .catch(function(error) { pluginHandle.consentDialog(false); callbacks.error({code: error.code, name: error.name, message: error.message}); });
                })
                .catch(function(error) {
                    pluginHandle.consentDialog(false);
                    callbacks.error('enumerateDevices error', error);
                });
            }
        } else {
            // No need to do a getUserMedia, create offer/answer right away
            streamsDone(handleId, jsep, media, callbacks);
        }
    }

    function prepareWebrtcPeer(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : webrtcError;
        var jsep = callbacks.jsep;
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        if(jsep !== undefined && jsep !== null) {
            if(config.pc === null) {
                Janus.warn("Wait, no PeerConnection?? if this is an answer, use createAnswer and not handleRemoteJsep");
                callbacks.error("No PeerConnection: if this is an answer, use createAnswer and not handleRemoteJsep");
                return;
            }
            config.pc.setRemoteDescription(
                new RTCSessionDescription(jsep),
                function() {
                    Janus.log("Remote description accepted!");
                    callbacks.success();
                }, callbacks.error);
        } else {
            callbacks.error("Invalid JSEP");
        }
    }

    function createOffer(handleId, media, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        var simulcast = callbacks.simulcast === true ? true : false;
        if(!simulcast) {
            Janus.log("Creating offer (iceDone=" + config.iceDone + ")");
        } else {
            Janus.log("Creating offer (iceDone=" + config.iceDone + ", simulcast=" + simulcast + ")");
        }
        // https://code.google.com/p/webrtc/issues/detail?id=3508
        var mediaConstraints = null;
        if(Janus.webRTCAdapter.browserDetails.browser == "firefox" || Janus.webRTCAdapter.browserDetails.browser == "edge") {
            mediaConstraints = {
                'offerToReceiveAudio':isAudioRecvEnabled(media),
                'offerToReceiveVideo':isVideoRecvEnabled(media)
            };
        } else {
            mediaConstraints = {
                'mandatory': {
                    'OfferToReceiveAudio':isAudioRecvEnabled(media),
                    'OfferToReceiveVideo':isVideoRecvEnabled(media)
                }
            };
        }
        Janus.debug(mediaConstraints);
        // Check if this is Firefox and we've been asked to do simulcasting
        var sendVideo = isVideoSendEnabled(media);
        if(sendVideo && simulcast && Janus.webRTCAdapter.browserDetails.browser === "firefox") {
            // FIXME Based on https://gist.github.com/voluntas/088bc3cc62094730647b
            Janus.log("Enabling Simulcasting for Firefox (RID)");
            var sender = config.pc.getSenders()[1];
            Janus.log(sender);
            var parameters = sender.getParameters();
            Janus.log(parameters);
            sender.setParameters({encodings: [
                { rid: "high", active: true, priority: "high", maxBitrate: 1000000 },
                { rid: "medium", active: true, priority: "medium", maxBitrate: 300000 },
                { rid: "low", active: true, priority: "low", maxBitrate: 100000 }
            ]});
        }
        config.pc.createOffer(
            function(offer) {
                Janus.debug(offer);
                if(config.mySdp === null || config.mySdp === undefined) {
                    Janus.log("Setting local description");
                    if(sendVideo && simulcast) {
                        // This SDP munging only works with Chrome
                        if(Janus.webRTCAdapter.browserDetails.browser === "chrome") {
                            Janus.log("Enabling Simulcasting for Chrome (SDP munging)");
                            offer.sdp = mungeSdpForSimulcasting(offer.sdp);
                        } else if(Janus.webRTCAdapter.browserDetails.browser !== "firefox") {
                            Janus.warn("simulcast=true, but this is not Chrome nor Firefox, ignoring");
                        }
                    }
                    config.mySdp = offer.sdp;
                    config.pc.setLocalDescription(offer);
                }
                if(!config.iceDone && !config.trickle) {
                    // Don't do anything until we have all candidates
                    Janus.log("Waiting for all candidates...");
                    return;
                }
                if(config.sdpSent) {
                    Janus.log("Offer already sent, not sending it again");
                    return;
                }
                Janus.log("Offer ready");
                Janus.debug(callbacks);
                config.sdpSent = true;
                // JSON.stringify doesn't work on some WebRTC objects anymore
                // See https://code.google.com/p/chromium/issues/detail?id=467366
                var jsep = {
                    "type": offer.type,
                    "sdp": offer.sdp
                };
                callbacks.success(jsep);
            }, callbacks.error, mediaConstraints);
    }

    function createAnswer(handleId, media, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        var simulcast = callbacks.simulcast === true ? true : false;
        if(!simulcast) {
            Janus.log("Creating answer (iceDone=" + config.iceDone + ")");
        } else {
            Janus.log("Creating answer (iceDone=" + config.iceDone + ", simulcast=" + simulcast + ")");
        }
        var mediaConstraints = null;
        if(Janus.webRTCAdapter.browserDetails.browser == "firefox" || Janus.webRTCAdapter.browserDetails.browser == "edge") {
            mediaConstraints = {
                'offerToReceiveAudio':isAudioRecvEnabled(media),
                'offerToReceiveVideo':isVideoRecvEnabled(media)
            };
        } else {
            mediaConstraints = {
                'mandatory': {
                    'OfferToReceiveAudio':isAudioRecvEnabled(media),
                    'OfferToReceiveVideo':isVideoRecvEnabled(media)
                }
            };
        }
        Janus.debug(mediaConstraints);
        // Check if this is Firefox and we've been asked to do simulcasting
        var sendVideo = isVideoSendEnabled(media);
        if(sendVideo && simulcast && Janus.webRTCAdapter.browserDetails.browser === "firefox") {
            // FIXME Based on https://gist.github.com/voluntas/088bc3cc62094730647b
            Janus.log("Enabling Simulcasting for Firefox (RID)");
            var sender = config.pc.getSenders()[1];
            Janus.log(sender);
            var parameters = sender.getParameters();
            Janus.log(parameters);
            sender.setParameters({encodings: [
                { rid: "high", active: true, priority: "high", maxBitrate: 1000000 },
                { rid: "medium", active: true, priority: "medium", maxBitrate: 300000 },
                { rid: "low", active: true, priority: "low", maxBitrate: 100000 }
            ]});
        }
        config.pc.createAnswer(
            function(answer) {
                Janus.debug(answer);
                if(config.mySdp === null || config.mySdp === undefined) {
                    Janus.log("Setting local description");
                    if(sendVideo && simulcast) {
                        // This SDP munging only works with Chrome
                        if(Janus.webRTCAdapter.browserDetails.browser === "chrome") {
                            // FIXME Apparently trying to simulcast when answering breaks video in Chrome...
                            //~ Janus.log("Enabling Simulcasting for Chrome (SDP munging)");
                            //~ answer.sdp = mungeSdpForSimulcasting(answer.sdp);
                            Janus.warn("simulcast=true, but this is an answer, and video breaks in Chrome if we enable it");
                        } else if(Janus.webRTCAdapter.browserDetails.browser !== "firefox") {
                            Janus.warn("simulcast=true, but this is not Chrome nor Firefox, ignoring");
                        }
                    }
                    config.mySdp = answer.sdp;
                    config.pc.setLocalDescription(answer);
                }
                if(!config.iceDone && !config.trickle) {
                    // Don't do anything until we have all candidates
                    Janus.log("Waiting for all candidates...");
                    return;
                }
                if(config.sdpSent) {	// FIXME badly
                    Janus.log("Answer already sent, not sending it again");
                    return;
                }
                config.sdpSent = true;
                // JSON.stringify doesn't work on some WebRTC objects anymore
                // See https://code.google.com/p/chromium/issues/detail?id=467366
                var jsep = {
                    "type": answer.type,
                    "sdp": answer.sdp
                };
                callbacks.success(jsep);
            }, callbacks.error, mediaConstraints);
    }

    function sendSDP(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle, not sending anything");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        Janus.log("Sending offer/answer SDP...");
        if(config.mySdp === null || config.mySdp === undefined) {
            Janus.warn("Local SDP instance is invalid, not sending anything...");
            return;
        }
        config.mySdp = {
            "type": config.pc.localDescription.type,
            "sdp": config.pc.localDescription.sdp
        };
        if(config.sdpSent) {
            Janus.log("Offer/Answer SDP already sent, not sending it again");
            return;
        }
        if(config.trickle === false)
            config.mySdp["trickle"] = false;
        Janus.debug(callbacks);
        config.sdpSent = true;
        callbacks.success(config.mySdp);
    }

    function getVolume(handleId) {
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return 0;
        }
        var config = pluginHandle.webrtcStuff;
        // Start getting the volume, if getStats is supported
        if(config.pc.getStats && Janus.webRTCAdapter.browserDetails.browser == "chrome") {	// FIXME
            if(config.remoteStream === null || config.remoteStream === undefined) {
                Janus.warn("Remote stream unavailable");
                return 0;
            }
            // http://webrtc.googlecode.com/svn/trunk/samples/js/demos/html/constraints-and-stats.html
            if(config.volume.timer === null || config.volume.timer === undefined) {
                Janus.log("Starting volume monitor");
                config.volume.timer = setInterval(function() {
                    config.pc.getStats(function(stats) {
                        var results = stats.result();
                        for(var i=0; i<results.length; i++) {
                            var res = results[i];
                            if(res.type == 'ssrc' && res.stat('audioOutputLevel')) {
                                config.volume.value = res.stat('audioOutputLevel');
                            }
                        }
                    });
                }, 200);
                return 0;	// We don't have a volume to return yet
            }
            return config.volume.value;
        } else {
            Janus.log("Getting the remote volume unsupported by browser");
            return 0;
        }
    }

    function isMuted(handleId, video) {
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return true;
        }
        var config = pluginHandle.webrtcStuff;
        if(config.pc === null || config.pc === undefined) {
            Janus.warn("Invalid PeerConnection");
            return true;
        }
        if(config.myStream === undefined || config.myStream === null) {
            Janus.warn("Invalid local MediaStream");
            return true;
        }
        if(video) {
            // Check video track
            if(config.myStream.getVideoTracks() === null
                || config.myStream.getVideoTracks() === undefined
                || config.myStream.getVideoTracks().length === 0) {
                Janus.warn("No video track");
                return true;
            }
            return !config.myStream.getVideoTracks()[0].enabled;
        } else {
            // Check audio track
            if(config.myStream.getAudioTracks() === null
                || config.myStream.getAudioTracks() === undefined
                || config.myStream.getAudioTracks().length === 0) {
                Janus.warn("No audio track");
                return true;
            }
            return !config.myStream.getAudioTracks()[0].enabled;
        }
    }

    function mute(handleId, video, mute) {
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return false;
        }
        var config = pluginHandle.webrtcStuff;
        if(config.pc === null || config.pc === undefined) {
            Janus.warn("Invalid PeerConnection");
            return false;
        }
        if(config.myStream === undefined || config.myStream === null) {
            Janus.warn("Invalid local MediaStream");
            return false;
        }
        if(video) {
            // Mute/unmute video track
            if(config.myStream.getVideoTracks() === null
                || config.myStream.getVideoTracks() === undefined
                || config.myStream.getVideoTracks().length === 0) {
                Janus.warn("No video track");
                return false;
            }
            config.myStream.getVideoTracks()[0].enabled = mute ? false : true;
            return true;
        } else {
            // Mute/unmute audio track
            if(config.myStream.getAudioTracks() === null
                || config.myStream.getAudioTracks() === undefined
                || config.myStream.getAudioTracks().length === 0) {
                Janus.warn("No audio track");
                return false;
            }
            config.myStream.getAudioTracks()[0].enabled = mute ? false : true;
            return true;
        }
    }

    function getBitrate(handleId) {
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return "Invalid handle";
        }
        var config = pluginHandle.webrtcStuff;
        if(config.pc === null || config.pc === undefined)
            return "Invalid PeerConnection";
        // Start getting the bitrate, if getStats is supported
        if(config.pc.getStats) {
            if(config.bitrate.timer === null || config.bitrate.timer === undefined) {
                Janus.log("Starting bitrate timer (via getStats)");
                config.bitrate.timer = setInterval(function() {
                    config.pc.getStats()
                    .then(function(stats) {
                        stats.forEach(function (res) {
                            if(!res)
                                return;
                            var inStats = false;
                            // Check if these are statistics on incoming media
                            if((res.mediaType === "video" || res.id.toLowerCase().indexOf("video") > -1) &&
                                res.type === "inbound-rtp" && res.id.indexOf("rtcp") < 0) {
                                // New stats
                                inStats = true;
                            } else if(res.type == 'ssrc' && res.bytesReceived &&
                                (res.googCodecName === "VP8" || res.googCodecName === "")) {
                                // Older Chromer versions
                                inStats = true;
                            }
                            // Parse stats now
                            if(inStats) {
                                config.bitrate.bsnow = res.bytesReceived;
                                config.bitrate.tsnow = res.timestamp;
                                if(config.bitrate.bsbefore === null || config.bitrate.tsbefore === null) {
                                    // Skip this round
                                    config.bitrate.bsbefore = config.bitrate.bsnow;
                                    config.bitrate.tsbefore = config.bitrate.tsnow;
                                } else {
                                    // Calculate bitrate
                                    var timePassed = config.bitrate.tsnow - config.bitrate.tsbefore;
                                    if(Janus.webRTCAdapter.browserDetails.browser == "safari")
                                        timePassed = timePassed/1000;	// Apparently the timestamp is in microseconds, in Safari
                                    var bitRate = Math.round((config.bitrate.bsnow - config.bitrate.bsbefore) * 8 / timePassed);
                                    config.bitrate.value = bitRate + ' kbits/sec';
                                    //~ Janus.log("Estimated bitrate is " + config.bitrate.value);
                                    config.bitrate.bsbefore = config.bitrate.bsnow;
                                    config.bitrate.tsbefore = config.bitrate.tsnow;
                                }
                            }
                        });
                    });
                }, 1000);
                return "0 kbits/sec";	// We don't have a bitrate value yet
            }
            return config.bitrate.value;
        } else {
            Janus.warn("Getting the video bitrate unsupported by browser");
            return "Feature unsupported by browser";
        }
    }

    function webrtcError(error) {
        Janus.error("WebRTC error:", error);
    }

    function cleanupWebrtc(handleId, hangupRequest) {
        Janus.log("Cleaning WebRTC stuff");
        var pluginHandle = pluginHandles[handleId];
        if(pluginHandle === null || pluginHandle === undefined) {
            // Nothing to clean
            return;
        }
        var config = pluginHandle.webrtcStuff;
        if(config !== null && config !== undefined) {
            if(hangupRequest === true) {
                // Send a hangup request (we don't really care about the response)
                var request = { "janus": "hangup", "transaction": Janus.randomString(12) };
                if(token !== null && token !== undefined)
                    request["token"] = token;
                if(apisecret !== null && apisecret !== undefined)
                    request["apisecret"] = apisecret;
                Janus.debug("Sending hangup request (handle=" + handleId + "):");
                Janus.debug(request);
                if(websockets) {
                    request["session_id"] = sessionId;
                    request["handle_id"] = handleId;
                    ws.send(JSON.stringify(request));
                } else {
                    Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
                        verb: 'POST',
                        withCredentials: withCredentials,
                        data: request
                    });
                }
            }
            // Cleanup stack
            config.remoteStream = null;
            if(config.volume.timer)
                clearInterval(config.volume.timer);
            config.volume.value = null;
            if(config.bitrate.timer)
                clearInterval(config.bitrate.timer);
            config.bitrate.timer = null;
            config.bitrate.bsnow = null;
            config.bitrate.bsbefore = null;
            config.bitrate.tsnow = null;
            config.bitrate.tsbefore = null;
            config.bitrate.value = null;
            try {
                // Try a MediaStreamTrack.stop() for each track
                if(!config.streamExternal && config.myStream !== null && config.myStream !== undefined) {
                    Janus.log("Stopping local stream tracks");
                    var tracks = config.myStream.getTracks();
                    for(var i in tracks) {
                        var mst = tracks[i];
                        Janus.log(mst);
                        if(mst !== null && mst !== undefined)
                            mst.stop();
                    }
                }
            } catch(e) {
                // Do nothing if this fails
            }
            config.streamExternal = false;
            config.myStream = null;
            // Close PeerConnection
            try {
                config.pc.close();
            } catch(e) {
                // Do nothing
            }
            config.pc = null;
            config.mySdp = null;
            config.iceDone = false;
            config.sdpSent = false;
            config.dataChannel = null;
            config.dtmfSender = null;
        }
        pluginHandle.oncleanup();
    }

    // Helper method to munge an SDP to enable simulcasting (Chrome only)
    function mungeSdpForSimulcasting(sdp) {
        // Let's munge the SDP to add the attributes for enabling simulcasting
        // (based on https://gist.github.com/ggarber/a19b4c33510028b9c657)
        var lines = sdp.split("\r\n");
        var video = false;
        var ssrc = [ -1 ], ssrc_fid = -1;
        var cname = null, msid = null, mslabel = null, label = null;
        var insertAt = -1;
        for(var i=0; i<lines.length; i++) {
            var mline = lines[i].match(/m=(\w+) */);
            if(mline) {
                var medium = mline[1];
                if(medium === "video") {
                    // New video m-line: make sure it's the first one
                    if(ssrc[0] < 0) {
                        video = true;
                    } else {
                        // We're done, let's add the new attributes here
                        insertAt = i;
                        break;
                    }
                } else {
                    // New non-video m-line: do we have what we were looking for?
                    if(ssrc[0] > -1) {
                        // We're done, let's add the new attributes here
                        insertAt = i;
                        break;
                    }
                }
                continue;
            }
            if(!video)
                continue;
            var fid = lines[i].match(/a=ssrc-group:FID (\d+) (\d+)/);
            if(fid) {
                ssrc[0] = fid[1];
                ssrc_fid = fid[2];
                lines.splice(i, 1); i--;
                continue;
            }
            if(ssrc[0]) {
                var match = lines[i].match('a=ssrc:' + ssrc[0] + ' cname:(.+)')
                if(match) {
                    cname = match[1];
                }
                match = lines[i].match('a=ssrc:' + ssrc[0] + ' msid:(.+)')
                if(match) {
                    msid = match[1];
                }
                match = lines[i].match('a=ssrc:' + ssrc[0] + ' mslabel:(.+)')
                if(match) {
                    mslabel = match[1];
                }
                match = lines[i].match('a=ssrc:' + ssrc + ' label:(.+)')
                if(match) {
                    label = match[1];
                }
                if(lines[i].indexOf('a=ssrc:' + ssrc_fid) === 0) {
                    lines.splice(i, 1); i--;
                    continue;
                }
                if(lines[i].indexOf('a=ssrc:' + ssrc[0]) === 0) {
                    lines.splice(i, 1); i--;
                    continue;
                }
            }
            if(lines[i].length == 0) {
                lines.splice(i, 1); i--;
                continue;
            }
        }
        if(ssrc[0] < 0) {
            // Couldn't find a FID attribute, let's just take the first video SSRC we find
            insertAt = -1;
            video = false;
            for(var i=0; i<lines.length; i++) {
                var mline = lines[i].match(/m=(\w+) */);
                if(mline) {
                    var medium = mline[1];
                    if(medium === "video") {
                        // New video m-line: make sure it's the first one
                        if(ssrc[0] < 0) {
                            video = true;
                        } else {
                            // We're done, let's add the new attributes here
                            insertAt = i;
                            break;
                        }
                    } else {
                        // New non-video m-line: do we have what we were looking for?
                        if(ssrc[0] > -1) {
                            // We're done, let's add the new attributes here
                            insertAt = i;
                            break;
                        }
                    }
                    continue;
                }
                if(!video)
                    continue;
                if(ssrc[0] < 0) {
                    var value = lines[i].match(/a=ssrc:(\d+)/);
                    if(value) {
                        ssrc[0] = value[1];
                        lines.splice(i, 1); i--;
                        continue;
                    }
                } else {
                    var match = lines[i].match('a=ssrc:' + ssrc[0] + ' cname:(.+)')
                    if(match) {
                        cname = match[1];
                    }
                    match = lines[i].match('a=ssrc:' + ssrc[0] + ' msid:(.+)')
                    if(match) {
                        msid = match[1];
                    }
                    match = lines[i].match('a=ssrc:' + ssrc[0] + ' mslabel:(.+)')
                    if(match) {
                        mslabel = match[1];
                    }
                    match = lines[i].match('a=ssrc:' + ssrc + ' label:(.+)')
                    if(match) {
                        label = match[1];
                    }
                    if(lines[i].indexOf('a=ssrc:' + ssrc_fid) === 0) {
                        lines.splice(i, 1); i--;
                        continue;
                    }
                    if(lines[i].indexOf('a=ssrc:' + ssrc[0]) === 0) {
                        lines.splice(i, 1); i--;
                        continue;
                    }
                }
                if(lines[i].length == 0) {
                    lines.splice(i, 1); i--;
                    continue;
                }
            }
        }
        if(ssrc[0] < 0) {
            // Still nothing, let's just return the SDP we were asked to munge
            Janus.warn("Couldn't find the video SSRC, simulcasting NOT enabled");
            return sdp;
        }
        if(insertAt < 0) {
            // Append at the end
            insertAt = lines.length;
        }
        // Generate a couple of SSRCs
        ssrc[1] = Math.floor(Math.random()*0xFFFFFFFF);
        ssrc[2] = Math.floor(Math.random()*0xFFFFFFFF);
        // Add attributes to the SDP
        for(var i=0; i<ssrc.length; i++) {
            if(cname) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' cname:' + cname);
                insertAt++;
            }
            if(msid) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' msid:' + msid);
                insertAt++;
            }
            if(mslabel) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' mslabel:' + msid);
                insertAt++;
            }
            if(label) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' label:' + msid);
                insertAt++;
            }
        }
        lines.splice(insertAt, 0, 'a=ssrc-group:SIM ' + ssrc[0] + ' ' + ssrc[1] + ' ' + ssrc[2]);
        sdp = lines.join("\r\n");
        if(!sdp.endsWith("\r\n"))
            sdp += "\r\n";
        return sdp;
    }

    // Helper methods to parse a media object
    function isAudioSendEnabled(media) {
        Janus.debug("isAudioSendEnabled:", media);
        if(media === undefined || media === null)
            return true;	// Default
        if(media.audio === false)
            return false;	// Generic audio has precedence
        if(media.audioSend === undefined || media.audioSend === null)
            return true;	// Default
        return (media.audioSend === true);
    }

    function isAudioSendRequired(media) {
        Janus.debug("isAudioSendRequired:", media);
        if(media === undefined || media === null)
            return false;	// Default
        if(media.audio === false || media.audioSend === false)
            return false;	// If we're not asking to capture audio, it's not required
        if(media.failIfNoAudio === undefined || media.failIfNoAudio === null)
            return false;	// Default
        return (media.failIfNoAudio === true);
    }

    function isAudioRecvEnabled(media) {
        Janus.debug("isAudioRecvEnabled:", media);
        if(media === undefined || media === null)
            return true;	// Default
        if(media.audio === false)
            return false;	// Generic audio has precedence
        if(media.audioRecv === undefined || media.audioRecv === null)
            return true;	// Default
        return (media.audioRecv === true);
    }

    function isVideoSendEnabled(media) {
        Janus.debug("isVideoSendEnabled:", media);
        if(media === undefined || media === null)
            return true;	// Default
        if(media.video === false)
            return false;	// Generic video has precedence
        if(media.videoSend === undefined || media.videoSend === null)
            return true;	// Default
        return (media.videoSend === true);
    }

    function isVideoSendRequired(media) {
        Janus.debug("isVideoSendRequired:", media);
        if(media === undefined || media === null)
            return false;	// Default
        if(media.video === false || media.videoSend === false)
            return false;	// If we're not asking to capture video, it's not required
        if(media.failIfNoVideo === undefined || media.failIfNoVideo === null)
            return false;	// Default
        return (media.failIfNoVideo === true);
    }

    function isVideoRecvEnabled(media) {
        Janus.debug("isVideoRecvEnabled:", media);
        if(media === undefined || media === null)
            return true;	// Default
        if(media.video === false)
            return false;	// Generic video has precedence
        if(media.videoRecv === undefined || media.videoRecv === null)
            return true;	// Default
        return (media.videoRecv === true);
    }

    function isDataEnabled(media) {
        Janus.debug("isDataEnabled:", media);
        if(Janus.webRTCAdapter.browserDetails.browser == "edge") {
            Janus.warn("Edge doesn't support data channels yet");
            return false;
        }
        if(media === undefined || media === null)
            return false;	// Default
        return (media.data === true);
    }

    function isTrickleEnabled(trickle) {
        Janus.debug("isTrickleEnabled:", trickle);
        if(trickle === undefined || trickle === null)
            return true;	// Default is true
        return (trickle === true);
    }
};

module.exports = Janus;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */



var adapterFactory = __webpack_require__(2357);
module.exports = adapterFactory({window: global.window});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */



var utils = __webpack_require__(870);
// Shimming starts here.
module.exports = function(dependencies, opts) {
  var window = dependencies && dependencies.window;

  var options = {
    shimChrome: true,
    shimFirefox: true,
    shimEdge: true,
    shimSafari: true,
  };

  for (var key in opts) {
    if (hasOwnProperty.call(opts, key)) {
      options[key] = opts[key];
    }
  }

  // Utils.
  var logging = utils.log;
  var browserDetails = utils.detectBrowser(window);

  // Export to the adapter global object visible in the browser.
  var adapter = {
    browserDetails: browserDetails,
    extractVersion: utils.extractVersion,
    disableLog: utils.disableLog,
    disableWarnings: utils.disableWarnings
  };

  // Uncomment the line below if you want logging to occur, including logging
  // for the switch statement below. Can also be turned on in the browser via
  // adapter.disableLog(false), but then logging from the switch statement below
  // will not appear.
  // require('./utils').disableLog(false);

  // Browser shims.
  var chromeShim = __webpack_require__(2358) || null;
  var edgeShim = __webpack_require__(2360) || null;
  var firefoxShim = __webpack_require__(2363) || null;
  var safariShim = __webpack_require__(2365) || null;
  var commonShim = __webpack_require__(2366) || null;

  // Shim browser if found.
  switch (browserDetails.browser) {
    case 'chrome':
      if (!chromeShim || !chromeShim.shimPeerConnection ||
          !options.shimChrome) {
        logging('Chrome shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming chrome.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = chromeShim;
      commonShim.shimCreateObjectURL(window);

      chromeShim.shimGetUserMedia(window);
      chromeShim.shimMediaStream(window);
      chromeShim.shimSourceObject(window);
      chromeShim.shimPeerConnection(window);
      chromeShim.shimOnTrack(window);
      chromeShim.shimAddTrackRemoveTrack(window);
      chromeShim.shimGetSendersWithDtmf(window);

      commonShim.shimRTCIceCandidate(window);
      break;
    case 'firefox':
      if (!firefoxShim || !firefoxShim.shimPeerConnection ||
          !options.shimFirefox) {
        logging('Firefox shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming firefox.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = firefoxShim;
      commonShim.shimCreateObjectURL(window);

      firefoxShim.shimGetUserMedia(window);
      firefoxShim.shimSourceObject(window);
      firefoxShim.shimPeerConnection(window);
      firefoxShim.shimOnTrack(window);
      firefoxShim.shimRemoveStream(window);

      commonShim.shimRTCIceCandidate(window);
      break;
    case 'edge':
      if (!edgeShim || !edgeShim.shimPeerConnection || !options.shimEdge) {
        logging('MS edge shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming edge.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = edgeShim;
      commonShim.shimCreateObjectURL(window);

      edgeShim.shimGetUserMedia(window);
      edgeShim.shimPeerConnection(window);
      edgeShim.shimReplaceTrack(window);

      // the edge shim implements the full RTCIceCandidate object.
      break;
    case 'safari':
      if (!safariShim || !options.shimSafari) {
        logging('Safari shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming safari.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = safariShim;
      commonShim.shimCreateObjectURL(window);

      safariShim.shimRTCIceServerUrls(window);
      safariShim.shimCallbacksAPI(window);
      safariShim.shimLocalStreamsAPI(window);
      safariShim.shimRemoteStreamsAPI(window);
      safariShim.shimTrackEventTransceiver(window);
      safariShim.shimGetUserMedia(window);
      safariShim.shimCreateOfferLegacy(window);

      commonShim.shimRTCIceCandidate(window);
      break;
    default:
      logging('Unsupported browser!');
      break;
  }

  return adapter;
};


/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */

var utils = __webpack_require__(870);
var logging = utils.log;

module.exports = {
  shimGetUserMedia: __webpack_require__(2359),
  shimMediaStream: function(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
  },

  shimOnTrack: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
          }
          this.addEventListener('track', this._ontrack = f);
        }
      });
      var origSetRemoteDescription =
          window.RTCPeerConnection.prototype.setRemoteDescription;
      window.RTCPeerConnection.prototype.setRemoteDescription = function() {
        var pc = this;
        if (!pc._ontrackpoly) {
          pc._ontrackpoly = function(e) {
            // onaddstream does not fire when a track is added to an existing
            // stream. But stream.onaddtrack is implemented so we use that.
            e.stream.addEventListener('addtrack', function(te) {
              var receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = pc.getReceivers().find(function(r) {
                  return r.track && r.track.id === te.track.id;
                });
              } else {
                receiver = {track: te.track};
              }

              var event = new Event('track');
              event.track = te.track;
              event.receiver = receiver;
              event.transceiver = {receiver: receiver};
              event.streams = [e.stream];
              pc.dispatchEvent(event);
            });
            e.stream.getTracks().forEach(function(track) {
              var receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = pc.getReceivers().find(function(r) {
                  return r.track && r.track.id === track.id;
                });
              } else {
                receiver = {track: track};
              }
              var event = new Event('track');
              event.track = track;
              event.receiver = receiver;
              event.transceiver = {receiver: receiver};
              event.streams = [e.stream];
              pc.dispatchEvent(event);
            });
          };
          pc.addEventListener('addstream', pc._ontrackpoly);
        }
        return origSetRemoteDescription.apply(pc, arguments);
      };
    }
  },

  shimGetSendersWithDtmf: function(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === 'object' && window.RTCPeerConnection &&
        !('getSenders' in window.RTCPeerConnection.prototype) &&
        'createDTMFSender' in window.RTCPeerConnection.prototype) {
      var shimSenderWithDtmf = function(pc, track) {
        return {
          track: track,
          get dtmf() {
            if (this._dtmf === undefined) {
              if (track.kind === 'audio') {
                this._dtmf = pc.createDTMFSender(track);
              } else {
                this._dtmf = null;
              }
            }
            return this._dtmf;
          },
          _pc: pc
        };
      };

      // augment addTrack when getSenders is not available.
      if (!window.RTCPeerConnection.prototype.getSenders) {
        window.RTCPeerConnection.prototype.getSenders = function() {
          this._senders = this._senders || [];
          return this._senders.slice(); // return a copy of the internal state.
        };
        var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
          var pc = this;
          var sender = origAddTrack.apply(pc, arguments);
          if (!sender) {
            sender = shimSenderWithDtmf(pc, track);
            pc._senders.push(sender);
          }
          return sender;
        };

        var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
        window.RTCPeerConnection.prototype.removeTrack = function(sender) {
          var pc = this;
          origRemoveTrack.apply(pc, arguments);
          var idx = pc._senders.indexOf(sender);
          if (idx !== -1) {
            pc._senders.splice(idx, 1);
          }
        };
      }
      var origAddStream = window.RTCPeerConnection.prototype.addStream;
      window.RTCPeerConnection.prototype.addStream = function(stream) {
        var pc = this;
        pc._senders = pc._senders || [];
        origAddStream.apply(pc, [stream]);
        stream.getTracks().forEach(function(track) {
          pc._senders.push(shimSenderWithDtmf(pc, track));
        });
      };

      var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
      window.RTCPeerConnection.prototype.removeStream = function(stream) {
        var pc = this;
        pc._senders = pc._senders || [];
        origRemoveStream.apply(pc, [stream]);

        stream.getTracks().forEach(function(track) {
          var sender = pc._senders.find(function(s) {
            return s.track === track;
          });
          if (sender) {
            pc._senders.splice(pc._senders.indexOf(sender), 1); // remove sender
          }
        });
      };
    } else if (typeof window === 'object' && window.RTCPeerConnection &&
               'getSenders' in window.RTCPeerConnection.prototype &&
               'createDTMFSender' in window.RTCPeerConnection.prototype &&
               window.RTCRtpSender &&
               !('dtmf' in window.RTCRtpSender.prototype)) {
      var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
      window.RTCPeerConnection.prototype.getSenders = function() {
        var pc = this;
        var senders = origGetSenders.apply(pc, []);
        senders.forEach(function(sender) {
          sender._pc = pc;
        });
        return senders;
      };

      Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
        get: function() {
          if (this._dtmf === undefined) {
            if (this.track.kind === 'audio') {
              this._dtmf = this._pc.createDTMFSender(this.track);
            } else {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        }
      });
    }
  },

  shimSourceObject: function(window) {
    var URL = window && window.URL;

    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        // Shim the srcObject property, once, when HTMLMediaElement is found.
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this._srcObject;
          },
          set: function(stream) {
            var self = this;
            // Use _srcObject as a private property for this shim
            this._srcObject = stream;
            if (this.src) {
              URL.revokeObjectURL(this.src);
            }

            if (!stream) {
              this.src = '';
              return undefined;
            }
            this.src = URL.createObjectURL(stream);
            // We need to recreate the blob url when a track is added or
            // removed. Doing it manually since we want to avoid a recursion.
            stream.addEventListener('addtrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
            stream.addEventListener('removetrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
          }
        });
      }
    }
  },

  shimAddTrackRemoveTrackWithNative: function(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function() {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      return Object.keys(this._shimmedLocalStreams).map(function(streamId) {
        return pc._shimmedLocalStreams[streamId][0];
      });
    };

    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
      if (!stream) {
        return origAddTrack.apply(this, arguments);
      }
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};

      var sender = origAddTrack.apply(this, arguments);
      if (!this._shimmedLocalStreams[stream.id]) {
        this._shimmedLocalStreams[stream.id] = [stream, sender];
      } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
        this._shimmedLocalStreams[stream.id].push(sender);
      }
      return sender;
    };

    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function(stream) {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};

      stream.getTracks().forEach(function(track) {
        var alreadyExists = pc.getSenders().find(function(s) {
          return s.track === track;
        });
        if (alreadyExists) {
          throw new DOMException('Track already exists.',
              'InvalidAccessError');
        }
      });
      var existingSenders = pc.getSenders();
      origAddStream.apply(this, arguments);
      var newSenders = pc.getSenders().filter(function(newSender) {
        return existingSenders.indexOf(newSender) === -1;
      });
      this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
    };

    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      delete this._shimmedLocalStreams[stream.id];
      return origRemoveStream.apply(this, arguments);
    };

    var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function(sender) {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      if (sender) {
        Object.keys(this._shimmedLocalStreams).forEach(function(streamId) {
          var idx = pc._shimmedLocalStreams[streamId].indexOf(sender);
          if (idx !== -1) {
            pc._shimmedLocalStreams[streamId].splice(idx, 1);
          }
          if (pc._shimmedLocalStreams[streamId].length === 1) {
            delete pc._shimmedLocalStreams[streamId];
          }
        });
      }
      return origRemoveTrack.apply(this, arguments);
    };
  },

  shimAddTrackRemoveTrack: function(window) {
    var browserDetails = utils.detectBrowser(window);
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack &&
        browserDetails.version >= 65) {
      return this.shimAddTrackRemoveTrackWithNative(window);
    }

    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    var origGetLocalStreams = window.RTCPeerConnection.prototype
        .getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function() {
      var pc = this;
      var nativeStreams = origGetLocalStreams.apply(this);
      pc._reverseStreams = pc._reverseStreams || {};
      return nativeStreams.map(function(stream) {
        return pc._reverseStreams[stream.id];
      });
    };

    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function(stream) {
      var pc = this;
      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};

      stream.getTracks().forEach(function(track) {
        var alreadyExists = pc.getSenders().find(function(s) {
          return s.track === track;
        });
        if (alreadyExists) {
          throw new DOMException('Track already exists.',
              'InvalidAccessError');
        }
      });
      // Add identity mapping for consistency with addTrack.
      // Unless this is being used with a stream from addTrack.
      if (!pc._reverseStreams[stream.id]) {
        var newStream = new window.MediaStream(stream.getTracks());
        pc._streams[stream.id] = newStream;
        pc._reverseStreams[newStream.id] = stream;
        stream = newStream;
      }
      origAddStream.apply(pc, [stream]);
    };

    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      var pc = this;
      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};

      origRemoveStream.apply(pc, [(pc._streams[stream.id] || stream)]);
      delete pc._reverseStreams[(pc._streams[stream.id] ?
          pc._streams[stream.id].id : stream.id)];
      delete pc._streams[stream.id];
    };

    window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
      var pc = this;
      if (pc.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      var streams = [].slice.call(arguments, 1);
      if (streams.length !== 1 ||
          !streams[0].getTracks().find(function(t) {
            return t === track;
          })) {
        // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException(
          'The adapter.js addTrack polyfill only supports a single ' +
          ' stream which is associated with the specified track.',
          'NotSupportedError');
      }

      var alreadyExists = pc.getSenders().find(function(s) {
        return s.track === track;
      });
      if (alreadyExists) {
        throw new DOMException('Track already exists.',
            'InvalidAccessError');
      }

      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};
      var oldStream = pc._streams[stream.id];
      if (oldStream) {
        // this is using odd Chrome behaviour, use with caution:
        // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
        // Note: we rely on the high-level addTrack/dtmf shim to
        // create the sender with a dtmf sender.
        oldStream.addTrack(track);

        // Trigger ONN async.
        Promise.resolve().then(function() {
          pc.dispatchEvent(new Event('negotiationneeded'));
        });
      } else {
        var newStream = new window.MediaStream([track]);
        pc._streams[stream.id] = newStream;
        pc._reverseStreams[newStream.id] = stream;
        pc.addStream(newStream);
      }
      return pc.getSenders().find(function(s) {
        return s.track === track;
      });
    };

    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
      var sdp = description.sdp;
      Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
        var externalStream = pc._reverseStreams[internalId];
        var internalStream = pc._streams[externalStream.id];
        sdp = sdp.replace(new RegExp(internalStream.id, 'g'),
            externalStream.id);
      });
      return new RTCSessionDescription({
        type: description.type,
        sdp: sdp
      });
    }
    function replaceExternalStreamId(pc, description) {
      var sdp = description.sdp;
      Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
        var externalStream = pc._reverseStreams[internalId];
        var internalStream = pc._streams[externalStream.id];
        sdp = sdp.replace(new RegExp(externalStream.id, 'g'),
            internalStream.id);
      });
      return new RTCSessionDescription({
        type: description.type,
        sdp: sdp
      });
    }
    ['createOffer', 'createAnswer'].forEach(function(method) {
      var nativeMethod = window.RTCPeerConnection.prototype[method];
      window.RTCPeerConnection.prototype[method] = function() {
        var pc = this;
        var args = arguments;
        var isLegacyCall = arguments.length &&
            typeof arguments[0] === 'function';
        if (isLegacyCall) {
          return nativeMethod.apply(pc, [
            function(description) {
              var desc = replaceInternalStreamId(pc, description);
              args[0].apply(null, [desc]);
            },
            function(err) {
              if (args[1]) {
                args[1].apply(null, err);
              }
            }, arguments[2]
          ]);
        }
        return nativeMethod.apply(pc, arguments)
        .then(function(description) {
          return replaceInternalStreamId(pc, description);
        });
      };
    });

    var origSetLocalDescription =
        window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function() {
      var pc = this;
      if (!arguments.length || !arguments[0].type) {
        return origSetLocalDescription.apply(pc, arguments);
      }
      arguments[0] = replaceExternalStreamId(pc, arguments[0]);
      return origSetLocalDescription.apply(pc, arguments);
    };

    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier

    var origLocalDescription = Object.getOwnPropertyDescriptor(
        window.RTCPeerConnection.prototype, 'localDescription');
    Object.defineProperty(window.RTCPeerConnection.prototype,
        'localDescription', {
          get: function() {
            var pc = this;
            var description = origLocalDescription.get.apply(this);
            if (description.type === '') {
              return description;
            }
            return replaceInternalStreamId(pc, description);
          }
        });

    window.RTCPeerConnection.prototype.removeTrack = function(sender) {
      var pc = this;
      if (pc.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      // We can not yet check for sender instanceof RTCRtpSender
      // since we shim RTPSender. So we check if sender._pc is set.
      if (!sender._pc) {
        throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' +
            'does not implement interface RTCRtpSender.', 'TypeError');
      }
      var isLocal = sender._pc === pc;
      if (!isLocal) {
        throw new DOMException('Sender was not created by this connection.',
            'InvalidAccessError');
      }

      // Search for the native stream the senders track belongs to.
      pc._streams = pc._streams || {};
      var stream;
      Object.keys(pc._streams).forEach(function(streamid) {
        var hasTrack = pc._streams[streamid].getTracks().find(function(track) {
          return sender.track === track;
        });
        if (hasTrack) {
          stream = pc._streams[streamid];
        }
      });

      if (stream) {
        if (stream.getTracks().length === 1) {
          // if this is the last track of the stream, remove the stream. This
          // takes care of any shimmed _senders.
          pc.removeStream(pc._reverseStreams[stream.id]);
        } else {
          // relying on the same odd chrome behaviour as above.
          stream.removeTrack(sender.track);
        }
        pc.dispatchEvent(new Event('negotiationneeded'));
      }
    };
  },

  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);

    // The RTCPeerConnection object.
    if (!window.RTCPeerConnection) {
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        // Translate iceTransportPolicy to iceTransports,
        // see https://code.google.com/p/webrtc/issues/detail?id=4869
        // this was fixed in M56 along with unprefixing RTCPeerConnection.
        logging('PeerConnection');
        if (pcConfig && pcConfig.iceTransportPolicy) {
          pcConfig.iceTransports = pcConfig.iceTransportPolicy;
        }

        return new window.webkitRTCPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype =
          window.webkitRTCPeerConnection.prototype;
      // wrap static methods. Currently just generateCertificate.
      if (window.webkitRTCPeerConnection.generateCertificate) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function() {
            return window.webkitRTCPeerConnection.generateCertificate;
          }
        });
      }
    } else {
      // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
      var OrigPeerConnection = window.RTCPeerConnection;
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
          var newIceServers = [];
          for (var i = 0; i < pcConfig.iceServers.length; i++) {
            var server = pcConfig.iceServers[i];
            if (!server.hasOwnProperty('urls') &&
                server.hasOwnProperty('url')) {
              utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
              server = JSON.parse(JSON.stringify(server));
              server.urls = server.url;
              newIceServers.push(server);
            } else {
              newIceServers.push(pcConfig.iceServers[i]);
            }
          }
          pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
      // wrap static methods. Currently just generateCertificate.
      Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get: function() {
          return OrigPeerConnection.generateCertificate;
        }
      });
    }

    var origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function(selector,
        successCallback, errorCallback) {
      var pc = this;
      var args = arguments;

      // If selector is a function then we are in the old style stats so just
      // pass back the original getStats format to avoid breaking old users.
      if (arguments.length > 0 && typeof selector === 'function') {
        return origGetStats.apply(this, arguments);
      }

      // When spec-style getStats is supported, return those when called with
      // either no arguments or the selector argument is null.
      if (origGetStats.length === 0 && (arguments.length === 0 ||
          typeof arguments[0] !== 'function')) {
        return origGetStats.apply(this, []);
      }

      var fixChromeStats_ = function(response) {
        var standardReport = {};
        var reports = response.result();
        reports.forEach(function(report) {
          var standardStats = {
            id: report.id,
            timestamp: report.timestamp,
            type: {
              localcandidate: 'local-candidate',
              remotecandidate: 'remote-candidate'
            }[report.type] || report.type
          };
          report.names().forEach(function(name) {
            standardStats[name] = report.stat(name);
          });
          standardReport[standardStats.id] = standardStats;
        });

        return standardReport;
      };

      // shim getStats with maplike support
      var makeMapStats = function(stats) {
        return new Map(Object.keys(stats).map(function(key) {
          return [key, stats[key]];
        }));
      };

      if (arguments.length >= 2) {
        var successCallbackWrapper_ = function(response) {
          args[1](makeMapStats(fixChromeStats_(response)));
        };

        return origGetStats.apply(this, [successCallbackWrapper_,
          arguments[0]]);
      }

      // promise-support
      return new Promise(function(resolve, reject) {
        origGetStats.apply(pc, [
          function(response) {
            resolve(makeMapStats(fixChromeStats_(response)));
          }, reject]);
      }).then(successCallback, errorCallback);
    };

    // add promise support -- natively available in Chrome 51
    if (browserDetails.version < 51) {
      ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
          .forEach(function(method) {
            var nativeMethod = window.RTCPeerConnection.prototype[method];
            window.RTCPeerConnection.prototype[method] = function() {
              var args = arguments;
              var pc = this;
              var promise = new Promise(function(resolve, reject) {
                nativeMethod.apply(pc, [args[0], resolve, reject]);
              });
              if (args.length < 2) {
                return promise;
              }
              return promise.then(function() {
                args[1].apply(null, []);
              },
              function(err) {
                if (args.length >= 3) {
                  args[2].apply(null, [err]);
                }
              });
            };
          });
    }

    // promise support for createOffer and createAnswer. Available (without
    // bugs) since M52: crbug/619289
    if (browserDetails.version < 52) {
      ['createOffer', 'createAnswer'].forEach(function(method) {
        var nativeMethod = window.RTCPeerConnection.prototype[method];
        window.RTCPeerConnection.prototype[method] = function() {
          var pc = this;
          if (arguments.length < 1 || (arguments.length === 1 &&
              typeof arguments[0] === 'object')) {
            var opts = arguments.length === 1 ? arguments[0] : undefined;
            return new Promise(function(resolve, reject) {
              nativeMethod.apply(pc, [resolve, reject, opts]);
            });
          }
          return nativeMethod.apply(this, arguments);
        };
      });
    }

    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = window.RTCPeerConnection.prototype[method];
          window.RTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });

    // support for addIceCandidate(null or undefined)
    var nativeAddIceCandidate =
        window.RTCPeerConnection.prototype.addIceCandidate;
    window.RTCPeerConnection.prototype.addIceCandidate = function() {
      if (!arguments[0]) {
        if (arguments[1]) {
          arguments[1].apply(null);
        }
        return Promise.resolve();
      }
      return nativeAddIceCandidate.apply(this, arguments);
    };
  }
};


/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */

var utils = __webpack_require__(870);
var logging = utils.log;

// Expose public methods.
module.exports = function(window) {
  var browserDetails = utils.detectBrowser(window);
  var navigator = window && window.navigator;

  var constraintsToChrome_ = function(c) {
    if (typeof c !== 'object' || c.mandatory || c.optional) {
      return c;
    }
    var cc = {};
    Object.keys(c).forEach(function(key) {
      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
        return;
      }
      var r = (typeof c[key] === 'object') ? c[key] : {ideal: c[key]};
      if (r.exact !== undefined && typeof r.exact === 'number') {
        r.min = r.max = r.exact;
      }
      var oldname_ = function(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }
        return (name === 'deviceId') ? 'sourceId' : name;
      };
      if (r.ideal !== undefined) {
        cc.optional = cc.optional || [];
        var oc = {};
        if (typeof r.ideal === 'number') {
          oc[oldname_('min', key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_('max', key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_('', key)] = r.ideal;
          cc.optional.push(oc);
        }
      }
      if (r.exact !== undefined && typeof r.exact !== 'number') {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_('', key)] = r.exact;
      } else {
        ['min', 'max'].forEach(function(mix) {
          if (r[mix] !== undefined) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });
    if (c.advanced) {
      cc.optional = (cc.optional || []).concat(c.advanced);
    }
    return cc;
  };

  var shimConstraints_ = function(constraints, func) {
    if (browserDetails.version >= 61) {
      return func(constraints);
    }
    constraints = JSON.parse(JSON.stringify(constraints));
    if (constraints && typeof constraints.audio === 'object') {
      var remap = function(obj, a, b) {
        if (a in obj && !(b in obj)) {
          obj[b] = obj[a];
          delete obj[a];
        }
      };
      constraints = JSON.parse(JSON.stringify(constraints));
      remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
      remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
      constraints.audio = constraintsToChrome_(constraints.audio);
    }
    if (constraints && typeof constraints.video === 'object') {
      // Shim facingMode for mobile & surface pro.
      var face = constraints.video.facingMode;
      face = face && ((typeof face === 'object') ? face : {ideal: face});
      var getSupportedFacingModeLies = browserDetails.version < 66;

      if ((face && (face.exact === 'user' || face.exact === 'environment' ||
                    face.ideal === 'user' || face.ideal === 'environment')) &&
          !(navigator.mediaDevices.getSupportedConstraints &&
            navigator.mediaDevices.getSupportedConstraints().facingMode &&
            !getSupportedFacingModeLies)) {
        delete constraints.video.facingMode;
        var matches;
        if (face.exact === 'environment' || face.ideal === 'environment') {
          matches = ['back', 'rear'];
        } else if (face.exact === 'user' || face.ideal === 'user') {
          matches = ['front'];
        }
        if (matches) {
          // Look for matches in label, or use last cam for back (typical).
          return navigator.mediaDevices.enumerateDevices()
          .then(function(devices) {
            devices = devices.filter(function(d) {
              return d.kind === 'videoinput';
            });
            var dev = devices.find(function(d) {
              return matches.some(function(match) {
                return d.label.toLowerCase().indexOf(match) !== -1;
              });
            });
            if (!dev && devices.length && matches.indexOf('back') !== -1) {
              dev = devices[devices.length - 1]; // more likely the back cam
            }
            if (dev) {
              constraints.video.deviceId = face.exact ? {exact: dev.deviceId} :
                                                        {ideal: dev.deviceId};
            }
            constraints.video = constraintsToChrome_(constraints.video);
            logging('chrome: ' + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }
      constraints.video = constraintsToChrome_(constraints.video);
    }
    logging('chrome: ' + JSON.stringify(constraints));
    return func(constraints);
  };

  var shimError_ = function(e) {
    return {
      name: {
        PermissionDeniedError: 'NotAllowedError',
        InvalidStateError: 'NotReadableError',
        DevicesNotFoundError: 'NotFoundError',
        ConstraintNotSatisfiedError: 'OverconstrainedError',
        TrackStartError: 'NotReadableError',
        MediaDeviceFailedDueToShutdown: 'NotReadableError',
        MediaDeviceKillSwitchOn: 'NotReadableError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraintName,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  var getUserMedia_ = function(constraints, onSuccess, onError) {
    shimConstraints_(constraints, function(c) {
      navigator.webkitGetUserMedia(c, onSuccess, function(e) {
        if (onError) {
          onError(shimError_(e));
        }
      });
    });
  };

  navigator.getUserMedia = getUserMedia_;

  // Returns the result of getUserMedia as a Promise.
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      navigator.getUserMedia(constraints, resolve, reject);
    });
  };

  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {
      getUserMedia: getUserMediaPromise_,
      enumerateDevices: function() {
        return new Promise(function(resolve) {
          var kinds = {audio: 'audioinput', video: 'videoinput'};
          return window.MediaStreamTrack.getSources(function(devices) {
            resolve(devices.map(function(device) {
              return {label: device.label,
                kind: kinds[device.kind],
                deviceId: device.id,
                groupId: ''};
            }));
          });
        });
      },
      getSupportedConstraints: function() {
        return {
          deviceId: true, echoCancellation: true, facingMode: true,
          frameRate: true, height: true, width: true
        };
      }
    };
  }

  // A shim for getUserMedia method on the mediaDevices object.
  // TODO(KaptenJansson) remove once implemented in Chrome stable.
  if (!navigator.mediaDevices.getUserMedia) {
    navigator.mediaDevices.getUserMedia = function(constraints) {
      return getUserMediaPromise_(constraints);
    };
  } else {
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(cs) {
      return shimConstraints_(cs, function(c) {
        return origGetUserMedia(c).then(function(stream) {
          if (c.audio && !stream.getAudioTracks().length ||
              c.video && !stream.getVideoTracks().length) {
            stream.getTracks().forEach(function(track) {
              track.stop();
            });
            throw new DOMException('', 'NotFoundError');
          }
          return stream;
        }, function(e) {
          return Promise.reject(shimError_(e));
        });
      });
    };
  }

  // Dummy devicechange event methods.
  // TODO(KaptenJansson) remove once implemented in Chrome stable.
  if (typeof navigator.mediaDevices.addEventListener === 'undefined') {
    navigator.mediaDevices.addEventListener = function() {
      logging('Dummy mediaDevices.addEventListener called.');
    };
  }
  if (typeof navigator.mediaDevices.removeEventListener === 'undefined') {
    navigator.mediaDevices.removeEventListener = function() {
      logging('Dummy mediaDevices.removeEventListener called.');
    };
  }
};


/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(870);
var shimRTCPeerConnection = __webpack_require__(2361);

module.exports = {
  shimGetUserMedia: __webpack_require__(2362),
  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);

    if (window.RTCIceGatherer) {
      // ORTC defines an RTCIceCandidate object but no constructor.
      // Not implemented in Edge.
      if (!window.RTCIceCandidate) {
        window.RTCIceCandidate = function(args) {
          return args;
        };
      }
      // ORTC does not have a session description object but
      // other browsers (i.e. Chrome) that will support both PC and ORTC
      // in the future might have this defined already.
      if (!window.RTCSessionDescription) {
        window.RTCSessionDescription = function(args) {
          return args;
        };
      }
      // this adds an additional event listener to MediaStrackTrack that signals
      // when a tracks enabled property was changed. Workaround for a bug in
      // addStream, see below. No longer required in 15025+
      if (browserDetails.version < 15025) {
        var origMSTEnabled = Object.getOwnPropertyDescriptor(
            window.MediaStreamTrack.prototype, 'enabled');
        Object.defineProperty(window.MediaStreamTrack.prototype, 'enabled', {
          set: function(value) {
            origMSTEnabled.set.call(this, value);
            var ev = new Event('enabled');
            ev.enabled = value;
            this.dispatchEvent(ev);
          }
        });
      }
    }

    // ORTC defines the DTMF sender a bit different.
    // https://github.com/w3c/ortc/issues/714
    if (window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
      Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
        get: function() {
          if (this._dtmf === undefined) {
            if (this.track.kind === 'audio') {
              this._dtmf = new window.RTCDtmfSender(this);
            } else if (this.track.kind === 'video') {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        }
      });
    }

    window.RTCPeerConnection =
        shimRTCPeerConnection(window, browserDetails.version);
  },
  shimReplaceTrack: function(window) {
    // ORTC has replaceTrack -- https://github.com/w3c/ortc/issues/614
    if (window.RTCRtpSender &&
        !('replaceTrack' in window.RTCRtpSender.prototype)) {
      window.RTCRtpSender.prototype.replaceTrack =
          window.RTCRtpSender.prototype.setTrack;
    }
  }
};


/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var SDPUtils = __webpack_require__(1407);

function writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);

  // Map ICE parameters (ufrag, pwd) to SDP.
  sdp += SDPUtils.writeIceParameters(
      transceiver.iceGatherer.getLocalParameters());

  // Map DTLS parameters to SDP.
  sdp += SDPUtils.writeDtlsParameters(
      transceiver.dtlsTransport.getLocalParameters(),
      type === 'offer' ? 'actpass' : dtlsRole || 'active');

  sdp += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.direction) {
    sdp += 'a=' + transceiver.direction + '\r\n';
  } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    // spec.
    var msid = 'msid:' + stream.id + ' ' +
        transceiver.rtpSender.track.id + '\r\n';
    sdp += 'a=' + msid;

    // for Chrome.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  // FIXME: this should be written by writeRtpDescription.
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
}

// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
function filterIceServers(iceServers, edgeVersion) {
  var hasTurn = false;
  iceServers = JSON.parse(JSON.stringify(iceServers));
  return iceServers.filter(function(server) {
    if (server && (server.urls || server.url)) {
      var urls = server.urls || server.url;
      if (server.url && !server.urls) {
        console.warn('RTCIceServer.url is deprecated! Use urls instead.');
      }
      var isString = typeof urls === 'string';
      if (isString) {
        urls = [urls];
      }
      urls = urls.filter(function(url) {
        var validTurn = url.indexOf('turn:') === 0 &&
            url.indexOf('transport=udp') !== -1 &&
            url.indexOf('turn:[') === -1 &&
            !hasTurn;

        if (validTurn) {
          hasTurn = true;
          return true;
        }
        return url.indexOf('stun:') === 0 && edgeVersion >= 14393 &&
            url.indexOf('?transport=udp') === -1;
      });

      delete server.url;
      server.urls = isString ? urls[0] : urls;
      return !!urls.length;
    }
    return false;
  });
}

// Determines the intersection of local and remote capabilities.
function getCommonCapabilities(localCapabilities, remoteCapabilities) {
  var commonCapabilities = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: []
  };

  var findCodecByPayloadType = function(pt, codecs) {
    pt = parseInt(pt, 10);
    for (var i = 0; i < codecs.length; i++) {
      if (codecs[i].payloadType === pt ||
          codecs[i].preferredPayloadType === pt) {
        return codecs[i];
      }
    }
  };

  var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
    var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
    var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
    return lCodec && rCodec &&
        lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
  };

  localCapabilities.codecs.forEach(function(lCodec) {
    for (var i = 0; i < remoteCapabilities.codecs.length; i++) {
      var rCodec = remoteCapabilities.codecs[i];
      if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() &&
          lCodec.clockRate === rCodec.clockRate) {
        if (lCodec.name.toLowerCase() === 'rtx' &&
            lCodec.parameters && rCodec.parameters.apt) {
          // for RTX we need to find the local rtx that has a apt
          // which points to the same local codec as the remote one.
          if (!rtxCapabilityMatches(lCodec, rCodec,
              localCapabilities.codecs, remoteCapabilities.codecs)) {
            continue;
          }
        }
        rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
        // number of channels is the highest common number of channels
        rCodec.numChannels = Math.min(lCodec.numChannels,
            rCodec.numChannels);
        // push rCodec so we reply with offerer payload type
        commonCapabilities.codecs.push(rCodec);

        // determine common feedback mechanisms
        rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
          for (var j = 0; j < lCodec.rtcpFeedback.length; j++) {
            if (lCodec.rtcpFeedback[j].type === fb.type &&
                lCodec.rtcpFeedback[j].parameter === fb.parameter) {
              return true;
            }
          }
          return false;
        });
        // FIXME: also need to determine .parameters
        //  see https://github.com/openpeer/ortc/issues/569
        break;
      }
    }
  });

  localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
    for (var i = 0; i < remoteCapabilities.headerExtensions.length;
         i++) {
      var rHeaderExtension = remoteCapabilities.headerExtensions[i];
      if (lHeaderExtension.uri === rHeaderExtension.uri) {
        commonCapabilities.headerExtensions.push(rHeaderExtension);
        break;
      }
    }
  });

  // FIXME: fecMechanisms
  return commonCapabilities;
}

// is action=setLocalDescription with type allowed in signalingState
function isActionAllowedInSignalingState(action, type, signalingState) {
  return {
    offer: {
      setLocalDescription: ['stable', 'have-local-offer'],
      setRemoteDescription: ['stable', 'have-remote-offer']
    },
    answer: {
      setLocalDescription: ['have-remote-offer', 'have-local-pranswer'],
      setRemoteDescription: ['have-local-offer', 'have-remote-pranswer']
    }
  }[type][action].indexOf(signalingState) !== -1;
}

function maybeAddCandidate(iceTransport, candidate) {
  // Edge's internal representation adds some fields therefore
  // not all fieldѕ are taken into account.
  var alreadyAdded = iceTransport.getRemoteCandidates()
      .find(function(remoteCandidate) {
        return candidate.foundation === remoteCandidate.foundation &&
            candidate.ip === remoteCandidate.ip &&
            candidate.port === remoteCandidate.port &&
            candidate.priority === remoteCandidate.priority &&
            candidate.protocol === remoteCandidate.protocol &&
            candidate.type === remoteCandidate.type;
      });
  if (!alreadyAdded) {
    iceTransport.addRemoteCandidate(candidate);
  }
  return !alreadyAdded;
}

module.exports = function(window, edgeVersion) {
  var RTCPeerConnection = function(config) {
    var self = this;

    var _eventTarget = document.createDocumentFragment();
    ['addEventListener', 'removeEventListener', 'dispatchEvent']
        .forEach(function(method) {
          self[method] = _eventTarget[method].bind(_eventTarget);
        });

    this.onicecandidate = null;
    this.onaddstream = null;
    this.ontrack = null;
    this.onremovestream = null;
    this.onsignalingstatechange = null;
    this.oniceconnectionstatechange = null;
    this.onicegatheringstatechange = null;
    this.onnegotiationneeded = null;
    this.ondatachannel = null;
    this.canTrickleIceCandidates = null;

    this.needNegotiation = false;

    this.localStreams = [];
    this.remoteStreams = [];

    this.localDescription = null;
    this.remoteDescription = null;

    this.signalingState = 'stable';
    this.iceConnectionState = 'new';
    this.iceGatheringState = 'new';

    config = JSON.parse(JSON.stringify(config || {}));

    this.usingBundle = config.bundlePolicy === 'max-bundle';
    if (config.rtcpMuxPolicy === 'negotiate') {
      var e = new Error('rtcpMuxPolicy \'negotiate\' is not supported');
      e.name = 'NotSupportedError';
      throw(e);
    } else if (!config.rtcpMuxPolicy) {
      config.rtcpMuxPolicy = 'require';
    }

    switch (config.iceTransportPolicy) {
      case 'all':
      case 'relay':
        break;
      default:
        config.iceTransportPolicy = 'all';
        break;
    }

    switch (config.bundlePolicy) {
      case 'balanced':
      case 'max-compat':
      case 'max-bundle':
        break;
      default:
        config.bundlePolicy = 'balanced';
        break;
    }

    config.iceServers = filterIceServers(config.iceServers || [], edgeVersion);

    this._iceGatherers = [];
    if (config.iceCandidatePoolSize) {
      for (var i = config.iceCandidatePoolSize; i > 0; i--) {
        this._iceGatherers = new window.RTCIceGatherer({
          iceServers: config.iceServers,
          gatherPolicy: config.iceTransportPolicy
        });
      }
    } else {
      config.iceCandidatePoolSize = 0;
    }

    this._config = config;

    // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
    // everything that is needed to describe a SDP m-line.
    this.transceivers = [];

    this._sdpSessionId = SDPUtils.generateSessionId();
    this._sdpSessionVersion = 0;

    this._dtlsRole = undefined; // role for a=setup to use in answers.
  };

  RTCPeerConnection.prototype._emitGatheringStateChange = function() {
    var event = new Event('icegatheringstatechange');
    this.dispatchEvent(event);
    if (typeof this.onicegatheringstatechange === 'function') {
      this.onicegatheringstatechange(event);
    }
  };

  RTCPeerConnection.prototype.getConfiguration = function() {
    return this._config;
  };

  RTCPeerConnection.prototype.getLocalStreams = function() {
    return this.localStreams;
  };

  RTCPeerConnection.prototype.getRemoteStreams = function() {
    return this.remoteStreams;
  };

  // internal helper to create a transceiver object.
  // (whih is not yet the same as the WebRTC 1.0 transceiver)
  RTCPeerConnection.prototype._createTransceiver = function(kind) {
    var hasBundleTransport = this.transceivers.length > 0;
    var transceiver = {
      track: null,
      iceGatherer: null,
      iceTransport: null,
      dtlsTransport: null,
      localCapabilities: null,
      remoteCapabilities: null,
      rtpSender: null,
      rtpReceiver: null,
      kind: kind,
      mid: null,
      sendEncodingParameters: null,
      recvEncodingParameters: null,
      stream: null,
      wantReceive: true
    };
    if (this.usingBundle && hasBundleTransport) {
      transceiver.iceTransport = this.transceivers[0].iceTransport;
      transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
    } else {
      var transports = this._createIceAndDtlsTransports();
      transceiver.iceTransport = transports.iceTransport;
      transceiver.dtlsTransport = transports.dtlsTransport;
    }
    this.transceivers.push(transceiver);
    return transceiver;
  };

  RTCPeerConnection.prototype.addTrack = function(track, stream) {
    var transceiver;
    for (var i = 0; i < this.transceivers.length; i++) {
      if (!this.transceivers[i].track &&
          this.transceivers[i].kind === track.kind) {
        transceiver = this.transceivers[i];
      }
    }
    if (!transceiver) {
      transceiver = this._createTransceiver(track.kind);
    }

    this._maybeFireNegotiationNeeded();

    if (this.localStreams.indexOf(stream) === -1) {
      this.localStreams.push(stream);
    }

    transceiver.track = track;
    transceiver.stream = stream;
    transceiver.rtpSender = new window.RTCRtpSender(track,
        transceiver.dtlsTransport);
    return transceiver.rtpSender;
  };

  RTCPeerConnection.prototype.addStream = function(stream) {
    var self = this;
    if (edgeVersion >= 15025) {
      stream.getTracks().forEach(function(track) {
        self.addTrack(track, stream);
      });
    } else {
      // Clone is necessary for local demos mostly, attaching directly
      // to two different senders does not work (build 10547).
      // Fixed in 15025 (or earlier)
      var clonedStream = stream.clone();
      stream.getTracks().forEach(function(track, idx) {
        var clonedTrack = clonedStream.getTracks()[idx];
        track.addEventListener('enabled', function(event) {
          clonedTrack.enabled = event.enabled;
        });
      });
      clonedStream.getTracks().forEach(function(track) {
        self.addTrack(track, clonedStream);
      });
    }
  };

  RTCPeerConnection.prototype.removeStream = function(stream) {
    var idx = this.localStreams.indexOf(stream);
    if (idx > -1) {
      this.localStreams.splice(idx, 1);
      this._maybeFireNegotiationNeeded();
    }
  };

  RTCPeerConnection.prototype.getSenders = function() {
    return this.transceivers.filter(function(transceiver) {
      return !!transceiver.rtpSender;
    })
    .map(function(transceiver) {
      return transceiver.rtpSender;
    });
  };

  RTCPeerConnection.prototype.getReceivers = function() {
    return this.transceivers.filter(function(transceiver) {
      return !!transceiver.rtpReceiver;
    })
    .map(function(transceiver) {
      return transceiver.rtpReceiver;
    });
  };


  RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex,
      usingBundle) {
    var self = this;
    if (usingBundle && sdpMLineIndex > 0) {
      return this.transceivers[0].iceGatherer;
    } else if (this._iceGatherers.length) {
      return this._iceGatherers.shift();
    }
    var iceGatherer = new window.RTCIceGatherer({
      iceServers: this._config.iceServers,
      gatherPolicy: this._config.iceTransportPolicy
    });
    Object.defineProperty(iceGatherer, 'state',
        {value: 'new', writable: true}
    );

    this.transceivers[sdpMLineIndex].candidates = [];
    this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
      var end = !event.candidate || Object.keys(event.candidate).length === 0;
      // polyfill since RTCIceGatherer.state is not implemented in
      // Edge 10547 yet.
      iceGatherer.state = end ? 'completed' : 'gathering';
      if (self.transceivers[sdpMLineIndex].candidates !== null) {
        self.transceivers[sdpMLineIndex].candidates.push(event.candidate);
      }
    };
    iceGatherer.addEventListener('localcandidate',
      this.transceivers[sdpMLineIndex].bufferCandidates);
    return iceGatherer;
  };

  // start gathering from an RTCIceGatherer.
  RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
    var self = this;
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
    if (iceGatherer.onlocalcandidate) {
      return;
    }
    var candidates = this.transceivers[sdpMLineIndex].candidates;
    this.transceivers[sdpMLineIndex].candidates = null;
    iceGatherer.removeEventListener('localcandidate',
      this.transceivers[sdpMLineIndex].bufferCandidates);
    iceGatherer.onlocalcandidate = function(evt) {
      if (self.usingBundle && sdpMLineIndex > 0) {
        // if we know that we use bundle we can drop candidates with
        // ѕdpMLineIndex > 0. If we don't do this then our state gets
        // confused since we dispose the extra ice gatherer.
        return;
      }
      var event = new Event('icecandidate');
      event.candidate = {sdpMid: mid, sdpMLineIndex: sdpMLineIndex};

      var cand = evt.candidate;
      // Edge emits an empty object for RTCIceCandidateComplete‥
      var end = !cand || Object.keys(cand).length === 0;
      if (end) {
        // polyfill since RTCIceGatherer.state is not implemented in
        // Edge 10547 yet.
        if (iceGatherer.state === 'new' || iceGatherer.state === 'gathering') {
          iceGatherer.state = 'completed';
        }
      } else {
        if (iceGatherer.state === 'new') {
          iceGatherer.state = 'gathering';
        }
        // RTCIceCandidate doesn't have a component, needs to be added
        cand.component = 1;
        event.candidate.candidate = SDPUtils.writeCandidate(cand);
      }

      // update local description.
      var sections = SDPUtils.splitSections(self.localDescription.sdp);
      if (!end) {
        sections[event.candidate.sdpMLineIndex + 1] +=
            'a=' + event.candidate.candidate + '\r\n';
      } else {
        sections[event.candidate.sdpMLineIndex + 1] +=
            'a=end-of-candidates\r\n';
      }
      self.localDescription.sdp = sections.join('');
      var complete = self.transceivers.every(function(transceiver) {
        return transceiver.iceGatherer &&
            transceiver.iceGatherer.state === 'completed';
      });

      if (self.iceGatheringState !== 'gathering') {
        self.iceGatheringState = 'gathering';
        self._emitGatheringStateChange();
      }

      // Emit candidate. Also emit null candidate when all gatherers are
      // complete.
      if (!end) {
        self.dispatchEvent(event);
        if (typeof self.onicecandidate === 'function') {
          self.onicecandidate(event);
        }
      }
      if (complete) {
        self.dispatchEvent(new Event('icecandidate'));
        if (typeof self.onicecandidate === 'function') {
          self.onicecandidate(new Event('icecandidate'));
        }
        self.iceGatheringState = 'complete';
        self._emitGatheringStateChange();
      }
    };

    // emit already gathered candidates.
    window.setTimeout(function() {
      candidates.forEach(function(candidate) {
        var e = new Event('RTCIceGatherEvent');
        e.candidate = candidate;
        iceGatherer.onlocalcandidate(e);
      });
    }, 0);
  };

  // Create ICE transport and DTLS transport.
  RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
    var self = this;
    var iceTransport = new window.RTCIceTransport(null);
    iceTransport.onicestatechange = function() {
      self._updateConnectionState();
    };

    var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
    dtlsTransport.ondtlsstatechange = function() {
      self._updateConnectionState();
    };
    dtlsTransport.onerror = function() {
      // onerror does not set state to failed by itself.
      Object.defineProperty(dtlsTransport, 'state',
          {value: 'failed', writable: true});
      self._updateConnectionState();
    };

    return {
      iceTransport: iceTransport,
      dtlsTransport: dtlsTransport
    };
  };

  // Destroy ICE gatherer, ICE transport and DTLS transport.
  // Without triggering the callbacks.
  RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(
      sdpMLineIndex) {
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
    if (iceGatherer) {
      delete iceGatherer.onlocalcandidate;
      delete this.transceivers[sdpMLineIndex].iceGatherer;
    }
    var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
    if (iceTransport) {
      delete iceTransport.onicestatechange;
      delete this.transceivers[sdpMLineIndex].iceTransport;
    }
    var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
    if (dtlsTransport) {
      delete dtlsTransport.ondtlsstatechange;
      delete dtlsTransport.onerror;
      delete this.transceivers[sdpMLineIndex].dtlsTransport;
    }
  };

  // Start the RTP Sender and Receiver for a transceiver.
  RTCPeerConnection.prototype._transceive = function(transceiver,
      send, recv) {
    var params = getCommonCapabilities(transceiver.localCapabilities,
        transceiver.remoteCapabilities);
    if (send && transceiver.rtpSender) {
      params.encodings = transceiver.sendEncodingParameters;
      params.rtcp = {
        cname: SDPUtils.localCName,
        compound: transceiver.rtcpParameters.compound
      };
      if (transceiver.recvEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
      }
      transceiver.rtpSender.send(params);
    }
    if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
      // remove RTX field in Edge 14942
      if (transceiver.kind === 'video'
          && transceiver.recvEncodingParameters
          && edgeVersion < 15019) {
        transceiver.recvEncodingParameters.forEach(function(p) {
          delete p.rtx;
        });
      }
      params.encodings = transceiver.recvEncodingParameters;
      params.rtcp = {
        cname: transceiver.rtcpParameters.cname,
        compound: transceiver.rtcpParameters.compound
      };
      if (transceiver.sendEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
      }
      transceiver.rtpReceiver.receive(params);
    }
  };

  RTCPeerConnection.prototype.setLocalDescription = function(description) {
    var self = this;
    var args = arguments;

    if (!isActionAllowedInSignalingState('setLocalDescription',
        description.type, this.signalingState)) {
      return new Promise(function(resolve, reject) {
        var e = new Error('Can not set local ' + description.type +
            ' in state ' + self.signalingState);
        e.name = 'InvalidStateError';
        if (args.length > 2 && typeof args[2] === 'function') {
          args[2].apply(null, [e]);
        }
        reject(e);
      });
    }

    var sections;
    var sessionpart;
    if (description.type === 'offer') {
      // VERY limited support for SDP munging. Limited to:
      // * changing the order of codecs
      sections = SDPUtils.splitSections(description.sdp);
      sessionpart = sections.shift();
      sections.forEach(function(mediaSection, sdpMLineIndex) {
        var caps = SDPUtils.parseRtpParameters(mediaSection);
        self.transceivers[sdpMLineIndex].localCapabilities = caps;
      });

      this.transceivers.forEach(function(transceiver, sdpMLineIndex) {
        self._gather(transceiver.mid, sdpMLineIndex);
      });
    } else if (description.type === 'answer') {
      sections = SDPUtils.splitSections(self.remoteDescription.sdp);
      sessionpart = sections.shift();
      var isIceLite = SDPUtils.matchPrefix(sessionpart,
          'a=ice-lite').length > 0;
      sections.forEach(function(mediaSection, sdpMLineIndex) {
        var transceiver = self.transceivers[sdpMLineIndex];
        var iceGatherer = transceiver.iceGatherer;
        var iceTransport = transceiver.iceTransport;
        var dtlsTransport = transceiver.dtlsTransport;
        var localCapabilities = transceiver.localCapabilities;
        var remoteCapabilities = transceiver.remoteCapabilities;

        // treat bundle-only as not-rejected.
        var rejected = SDPUtils.isRejected(mediaSection) &&
            !SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 1;

        if (!rejected && !transceiver.isDatachannel) {
          var remoteIceParameters = SDPUtils.getIceParameters(
              mediaSection, sessionpart);
          var remoteDtlsParameters = SDPUtils.getDtlsParameters(
              mediaSection, sessionpart);
          if (isIceLite) {
            remoteDtlsParameters.role = 'server';
          }

          if (!self.usingBundle || sdpMLineIndex === 0) {
            self._gather(transceiver.mid, sdpMLineIndex);
            if (iceTransport.state === 'new') {
              iceTransport.start(iceGatherer, remoteIceParameters,
                  isIceLite ? 'controlling' : 'controlled');
            }
            if (dtlsTransport.state === 'new') {
              dtlsTransport.start(remoteDtlsParameters);
            }
          }

          // Calculate intersection of capabilities.
          var params = getCommonCapabilities(localCapabilities,
              remoteCapabilities);

          // Start the RTCRtpSender. The RTCRtpReceiver for this
          // transceiver has already been started in setRemoteDescription.
          self._transceive(transceiver,
              params.codecs.length > 0,
              false);
        }
      });
    }

    this.localDescription = {
      type: description.type,
      sdp: description.sdp
    };
    switch (description.type) {
      case 'offer':
        this._updateSignalingState('have-local-offer');
        break;
      case 'answer':
        this._updateSignalingState('stable');
        break;
      default:
        throw new TypeError('unsupported type "' + description.type +
            '"');
    }

    // If a success callback was provided, emit ICE candidates after it
    // has been executed. Otherwise, emit callback after the Promise is
    // resolved.
    var cb = arguments.length > 1 && typeof arguments[1] === 'function' &&
        arguments[1];
    return new Promise(function(resolve) {
      if (cb) {
        cb.apply(null);
      }
      resolve();
    });
  };

  RTCPeerConnection.prototype.setRemoteDescription = function(description) {
    var self = this;
    var args = arguments;

    if (!isActionAllowedInSignalingState('setRemoteDescription',
        description.type, this.signalingState)) {
      return new Promise(function(resolve, reject) {
        var e = new Error('Can not set remote ' + description.type +
            ' in state ' + self.signalingState);
        e.name = 'InvalidStateError';
        if (args.length > 2 && typeof args[2] === 'function') {
          args[2].apply(null, [e]);
        }
        reject(e);
      });
    }

    var streams = {};
    this.remoteStreams.forEach(function(stream) {
      streams[stream.id] = stream;
    });
    var receiverList = [];
    var sections = SDPUtils.splitSections(description.sdp);
    var sessionpart = sections.shift();
    var isIceLite = SDPUtils.matchPrefix(sessionpart,
        'a=ice-lite').length > 0;
    var usingBundle = SDPUtils.matchPrefix(sessionpart,
        'a=group:BUNDLE ').length > 0;
    this.usingBundle = usingBundle;
    var iceOptions = SDPUtils.matchPrefix(sessionpart,
        'a=ice-options:')[0];
    if (iceOptions) {
      this.canTrickleIceCandidates = iceOptions.substr(14).split(' ')
          .indexOf('trickle') >= 0;
    } else {
      this.canTrickleIceCandidates = false;
    }

    sections.forEach(function(mediaSection, sdpMLineIndex) {
      var lines = SDPUtils.splitLines(mediaSection);
      var kind = SDPUtils.getKind(mediaSection);
      // treat bundle-only as not-rejected.
      var rejected = SDPUtils.isRejected(mediaSection) &&
          !SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 1;
      var protocol = lines[0].substr(2).split(' ')[2];

      var direction = SDPUtils.getDirection(mediaSection, sessionpart);
      var remoteMsid = SDPUtils.parseMsid(mediaSection);

      var mid = SDPUtils.getMid(mediaSection) || SDPUtils.generateIdentifier();

      // Reject datachannels which are not implemented yet.
      if (kind === 'application' && protocol === 'DTLS/SCTP') {
        self.transceivers[sdpMLineIndex] = {
          mid: mid,
          isDatachannel: true
        };
        return;
      }

      var transceiver;
      var iceGatherer;
      var iceTransport;
      var dtlsTransport;
      var rtpReceiver;
      var sendEncodingParameters;
      var recvEncodingParameters;
      var localCapabilities;

      var track;
      // FIXME: ensure the mediaSection has rtcp-mux set.
      var remoteCapabilities = SDPUtils.parseRtpParameters(mediaSection);
      var remoteIceParameters;
      var remoteDtlsParameters;
      if (!rejected) {
        remoteIceParameters = SDPUtils.getIceParameters(mediaSection,
            sessionpart);
        remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection,
            sessionpart);
        remoteDtlsParameters.role = 'client';
      }
      recvEncodingParameters =
          SDPUtils.parseRtpEncodingParameters(mediaSection);

      var rtcpParameters = SDPUtils.parseRtcpParameters(mediaSection);

      var isComplete = SDPUtils.matchPrefix(mediaSection,
          'a=end-of-candidates', sessionpart).length > 0;
      var cands = SDPUtils.matchPrefix(mediaSection, 'a=candidate:')
          .map(function(cand) {
            return SDPUtils.parseCandidate(cand);
          })
          .filter(function(cand) {
            return cand.component === 1;
          });

      // Check if we can use BUNDLE and dispose transports.
      if ((description.type === 'offer' || description.type === 'answer') &&
          !rejected && usingBundle && sdpMLineIndex > 0 &&
          self.transceivers[sdpMLineIndex]) {
        self._disposeIceAndDtlsTransports(sdpMLineIndex);
        self.transceivers[sdpMLineIndex].iceGatherer =
            self.transceivers[0].iceGatherer;
        self.transceivers[sdpMLineIndex].iceTransport =
            self.transceivers[0].iceTransport;
        self.transceivers[sdpMLineIndex].dtlsTransport =
            self.transceivers[0].dtlsTransport;
        if (self.transceivers[sdpMLineIndex].rtpSender) {
          self.transceivers[sdpMLineIndex].rtpSender.setTransport(
              self.transceivers[0].dtlsTransport);
        }
        if (self.transceivers[sdpMLineIndex].rtpReceiver) {
          self.transceivers[sdpMLineIndex].rtpReceiver.setTransport(
              self.transceivers[0].dtlsTransport);
        }
      }
      if (description.type === 'offer' && !rejected) {
        transceiver = self.transceivers[sdpMLineIndex] ||
            self._createTransceiver(kind);
        transceiver.mid = mid;

        if (!transceiver.iceGatherer) {
          transceiver.iceGatherer = self._createIceGatherer(sdpMLineIndex,
              usingBundle);
        }

        if (cands.length && transceiver.iceTransport.state === 'new') {
          if (isComplete && (!usingBundle || sdpMLineIndex === 0)) {
            transceiver.iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function(candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        localCapabilities = window.RTCRtpReceiver.getCapabilities(kind);

        // filter RTX until additional stuff needed for RTX is implemented
        // in adapter.js
        if (edgeVersion < 15019) {
          localCapabilities.codecs = localCapabilities.codecs.filter(
              function(codec) {
                return codec.name !== 'rtx';
              });
        }

        sendEncodingParameters = transceiver.sendEncodingParameters || [{
          ssrc: (2 * sdpMLineIndex + 2) * 1001
        }];

        var isNewTrack = false;
        if (direction === 'sendrecv' || direction === 'sendonly') {
          isNewTrack = !transceiver.rtpReceiver;
          rtpReceiver = transceiver.rtpReceiver ||
              new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);

          if (isNewTrack) {
            var stream;
            track = rtpReceiver.track;
            // FIXME: does not work with Plan B.
            if (remoteMsid) {
              if (!streams[remoteMsid.stream]) {
                streams[remoteMsid.stream] = new window.MediaStream();
                Object.defineProperty(streams[remoteMsid.stream], 'id', {
                  get: function() {
                    return remoteMsid.stream;
                  }
                });
              }
              Object.defineProperty(track, 'id', {
                get: function() {
                  return remoteMsid.track;
                }
              });
              stream = streams[remoteMsid.stream];
            } else {
              if (!streams.default) {
                streams.default = new window.MediaStream();
              }
              stream = streams.default;
            }
            stream.addTrack(track);
            receiverList.push([track, rtpReceiver, stream]);
          }
        }

        transceiver.localCapabilities = localCapabilities;
        transceiver.remoteCapabilities = remoteCapabilities;
        transceiver.rtpReceiver = rtpReceiver;
        transceiver.rtcpParameters = rtcpParameters;
        transceiver.sendEncodingParameters = sendEncodingParameters;
        transceiver.recvEncodingParameters = recvEncodingParameters;

        // Start the RTCRtpReceiver now. The RTPSender is started in
        // setLocalDescription.
        self._transceive(self.transceivers[sdpMLineIndex],
            false,
            isNewTrack);
      } else if (description.type === 'answer' && !rejected) {
        transceiver = self.transceivers[sdpMLineIndex];
        iceGatherer = transceiver.iceGatherer;
        iceTransport = transceiver.iceTransport;
        dtlsTransport = transceiver.dtlsTransport;
        rtpReceiver = transceiver.rtpReceiver;
        sendEncodingParameters = transceiver.sendEncodingParameters;
        localCapabilities = transceiver.localCapabilities;

        self.transceivers[sdpMLineIndex].recvEncodingParameters =
            recvEncodingParameters;
        self.transceivers[sdpMLineIndex].remoteCapabilities =
            remoteCapabilities;
        self.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;

        if (cands.length && iceTransport.state === 'new') {
          if ((isIceLite || isComplete) &&
              (!usingBundle || sdpMLineIndex === 0)) {
            iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function(candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        if (!usingBundle || sdpMLineIndex === 0) {
          if (iceTransport.state === 'new') {
            iceTransport.start(iceGatherer, remoteIceParameters,
                'controlling');
          }
          if (dtlsTransport.state === 'new') {
            dtlsTransport.start(remoteDtlsParameters);
          }
        }

        self._transceive(transceiver,
            direction === 'sendrecv' || direction === 'recvonly',
            direction === 'sendrecv' || direction === 'sendonly');

        if (rtpReceiver &&
            (direction === 'sendrecv' || direction === 'sendonly')) {
          track = rtpReceiver.track;
          if (remoteMsid) {
            if (!streams[remoteMsid.stream]) {
              streams[remoteMsid.stream] = new window.MediaStream();
            }
            streams[remoteMsid.stream].addTrack(track);
            receiverList.push([track, rtpReceiver, streams[remoteMsid.stream]]);
          } else {
            if (!streams.default) {
              streams.default = new window.MediaStream();
            }
            streams.default.addTrack(track);
            receiverList.push([track, rtpReceiver, streams.default]);
          }
        } else {
          // FIXME: actually the receiver should be created later.
          delete transceiver.rtpReceiver;
        }
      }
    });

    if (this._dtlsRole === undefined) {
      this._dtlsRole = description.type === 'offer' ? 'active' : 'passive';
    }

    this.remoteDescription = {
      type: description.type,
      sdp: description.sdp
    };
    switch (description.type) {
      case 'offer':
        this._updateSignalingState('have-remote-offer');
        break;
      case 'answer':
        this._updateSignalingState('stable');
        break;
      default:
        throw new TypeError('unsupported type "' + description.type +
            '"');
    }
    Object.keys(streams).forEach(function(sid) {
      var stream = streams[sid];
      if (stream.getTracks().length) {
        if (self.remoteStreams.indexOf(stream) === -1) {
          self.remoteStreams.push(stream);
          var event = new Event('addstream');
          event.stream = stream;
          window.setTimeout(function() {
            self.dispatchEvent(event);
            if (typeof self.onaddstream === 'function') {
              self.onaddstream(event);
            }
          });
        }

        receiverList.forEach(function(item) {
          var track = item[0];
          var receiver = item[1];
          if (stream.id !== item[2].id) {
            return;
          }
          var trackEvent = new Event('track');
          trackEvent.track = track;
          trackEvent.receiver = receiver;
          trackEvent.transceiver = {receiver: receiver};
          trackEvent.streams = [stream];
          window.setTimeout(function() {
            self.dispatchEvent(trackEvent);
            if (typeof self.ontrack === 'function') {
              self.ontrack(trackEvent);
            }
          });
        });
      }
    });

    // check whether addIceCandidate({}) was called within four seconds after
    // setRemoteDescription.
    window.setTimeout(function() {
      if (!(self && self.transceivers)) {
        return;
      }
      self.transceivers.forEach(function(transceiver) {
        if (transceiver.iceTransport &&
            transceiver.iceTransport.state === 'new' &&
            transceiver.iceTransport.getRemoteCandidates().length > 0) {
          console.warn('Timeout for addRemoteCandidate. Consider sending ' +
              'an end-of-candidates notification');
          transceiver.iceTransport.addRemoteCandidate({});
        }
      });
    }, 4000);

    return new Promise(function(resolve) {
      if (args.length > 1 && typeof args[1] === 'function') {
        args[1].apply(null);
      }
      resolve();
    });
  };

  RTCPeerConnection.prototype.close = function() {
    this.transceivers.forEach(function(transceiver) {
      /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */
      if (transceiver.iceTransport) {
        transceiver.iceTransport.stop();
      }
      if (transceiver.dtlsTransport) {
        transceiver.dtlsTransport.stop();
      }
      if (transceiver.rtpSender) {
        transceiver.rtpSender.stop();
      }
      if (transceiver.rtpReceiver) {
        transceiver.rtpReceiver.stop();
      }
    });
    // FIXME: clean up tracks, local streams, remote streams, etc
    this._updateSignalingState('closed');
  };

  // Update the signaling state.
  RTCPeerConnection.prototype._updateSignalingState = function(newState) {
    this.signalingState = newState;
    var event = new Event('signalingstatechange');
    this.dispatchEvent(event);
    if (typeof this.onsignalingstatechange === 'function') {
      this.onsignalingstatechange(event);
    }
  };

  // Determine whether to fire the negotiationneeded event.
  RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
    var self = this;
    if (this.signalingState !== 'stable' || this.needNegotiation === true) {
      return;
    }
    this.needNegotiation = true;
    window.setTimeout(function() {
      if (self.needNegotiation === false) {
        return;
      }
      self.needNegotiation = false;
      var event = new Event('negotiationneeded');
      self.dispatchEvent(event);
      if (typeof self.onnegotiationneeded === 'function') {
        self.onnegotiationneeded(event);
      }
    }, 0);
  };

  // Update the connection state.
  RTCPeerConnection.prototype._updateConnectionState = function() {
    var newState;
    var states = {
      'new': 0,
      closed: 0,
      connecting: 0,
      checking: 0,
      connected: 0,
      completed: 0,
      disconnected: 0,
      failed: 0
    };
    this.transceivers.forEach(function(transceiver) {
      states[transceiver.iceTransport.state]++;
      states[transceiver.dtlsTransport.state]++;
    });
    // ICETransport.completed and connected are the same for this purpose.
    states.connected += states.completed;

    newState = 'new';
    if (states.failed > 0) {
      newState = 'failed';
    } else if (states.connecting > 0 || states.checking > 0) {
      newState = 'connecting';
    } else if (states.disconnected > 0) {
      newState = 'disconnected';
    } else if (states.new > 0) {
      newState = 'new';
    } else if (states.connected > 0 || states.completed > 0) {
      newState = 'connected';
    }

    if (newState !== this.iceConnectionState) {
      this.iceConnectionState = newState;
      var event = new Event('iceconnectionstatechange');
      this.dispatchEvent(event);
      if (typeof this.oniceconnectionstatechange === 'function') {
        this.oniceconnectionstatechange(event);
      }
    }
  };

  RTCPeerConnection.prototype.createOffer = function() {
    var self = this;
    var args = arguments;

    var offerOptions;
    if (arguments.length === 1 && typeof arguments[0] !== 'function') {
      offerOptions = arguments[0];
    } else if (arguments.length === 3) {
      offerOptions = arguments[2];
    }

    var numAudioTracks = this.transceivers.filter(function(t) {
      return t.kind === 'audio';
    }).length;
    var numVideoTracks = this.transceivers.filter(function(t) {
      return t.kind === 'video';
    }).length;

    // Determine number of audio and video tracks we need to send/recv.
    if (offerOptions) {
      // Reject Chrome legacy constraints.
      if (offerOptions.mandatory || offerOptions.optional) {
        throw new TypeError(
            'Legacy mandatory/optional constraints not supported.');
      }
      if (offerOptions.offerToReceiveAudio !== undefined) {
        if (offerOptions.offerToReceiveAudio === true) {
          numAudioTracks = 1;
        } else if (offerOptions.offerToReceiveAudio === false) {
          numAudioTracks = 0;
        } else {
          numAudioTracks = offerOptions.offerToReceiveAudio;
        }
      }
      if (offerOptions.offerToReceiveVideo !== undefined) {
        if (offerOptions.offerToReceiveVideo === true) {
          numVideoTracks = 1;
        } else if (offerOptions.offerToReceiveVideo === false) {
          numVideoTracks = 0;
        } else {
          numVideoTracks = offerOptions.offerToReceiveVideo;
        }
      }
    }

    this.transceivers.forEach(function(transceiver) {
      if (transceiver.kind === 'audio') {
        numAudioTracks--;
        if (numAudioTracks < 0) {
          transceiver.wantReceive = false;
        }
      } else if (transceiver.kind === 'video') {
        numVideoTracks--;
        if (numVideoTracks < 0) {
          transceiver.wantReceive = false;
        }
      }
    });

    // Create M-lines for recvonly streams.
    while (numAudioTracks > 0 || numVideoTracks > 0) {
      if (numAudioTracks > 0) {
        this._createTransceiver('audio');
        numAudioTracks--;
      }
      if (numVideoTracks > 0) {
        this._createTransceiver('video');
        numVideoTracks--;
      }
    }

    var sdp = SDPUtils.writeSessionBoilerplate(this._sdpSessionId,
        this._sdpSessionVersion++);
    this.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      // For each track, create an ice gatherer, ice transport,
      // dtls transport, potentially rtpsender and rtpreceiver.
      var track = transceiver.track;
      var kind = transceiver.kind;
      var mid = SDPUtils.generateIdentifier();
      transceiver.mid = mid;

      if (!transceiver.iceGatherer) {
        transceiver.iceGatherer = self._createIceGatherer(sdpMLineIndex,
            self.usingBundle);
      }

      var localCapabilities = window.RTCRtpSender.getCapabilities(kind);
      // filter RTX until additional stuff needed for RTX is implemented
      // in adapter.js
      if (edgeVersion < 15019) {
        localCapabilities.codecs = localCapabilities.codecs.filter(
            function(codec) {
              return codec.name !== 'rtx';
            });
      }
      localCapabilities.codecs.forEach(function(codec) {
        // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
        // by adding level-asymmetry-allowed=1
        if (codec.name === 'H264' &&
            codec.parameters['level-asymmetry-allowed'] === undefined) {
          codec.parameters['level-asymmetry-allowed'] = '1';
        }
      });

      // generate an ssrc now, to be used later in rtpSender.send
      var sendEncodingParameters = transceiver.sendEncodingParameters || [{
        ssrc: (2 * sdpMLineIndex + 1) * 1001
      }];
      if (track) {
        // add RTX
        if (edgeVersion >= 15019 && kind === 'video' &&
            !sendEncodingParameters[0].rtx) {
          sendEncodingParameters[0].rtx = {
            ssrc: sendEncodingParameters[0].ssrc + 1
          };
        }
      }

      if (transceiver.wantReceive) {
        transceiver.rtpReceiver = new window.RTCRtpReceiver(
            transceiver.dtlsTransport, kind);
      }

      transceiver.localCapabilities = localCapabilities;
      transceiver.sendEncodingParameters = sendEncodingParameters;
    });

    // always offer BUNDLE and dispose on return if not supported.
    if (this._config.bundlePolicy !== 'max-compat') {
      sdp += 'a=group:BUNDLE ' + this.transceivers.map(function(t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }
    sdp += 'a=ice-options:trickle\r\n';

    this.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      sdp += writeMediaSection(transceiver, transceiver.localCapabilities,
          'offer', transceiver.stream, self._dtlsRole);
      sdp += 'a=rtcp-rsize\r\n';

      if (transceiver.iceGatherer && self.iceGatheringState !== 'new' &&
          (sdpMLineIndex === 0 || !self.usingBundle)) {
        transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
          cand.component = 1;
          sdp += 'a=' + SDPUtils.writeCandidate(cand) + '\r\n';
        });

        if (transceiver.iceGatherer.state === 'completed') {
          sdp += 'a=end-of-candidates\r\n';
        }
      }
    });

    var desc = new window.RTCSessionDescription({
      type: 'offer',
      sdp: sdp
    });
    return new Promise(function(resolve) {
      if (args.length > 0 && typeof args[0] === 'function') {
        args[0].apply(null, [desc]);
        resolve();
        return;
      }
      resolve(desc);
    });
  };

  RTCPeerConnection.prototype.createAnswer = function() {
    var self = this;
    var args = arguments;

    var sdp = SDPUtils.writeSessionBoilerplate(this._sdpSessionId,
        this._sdpSessionVersion++);
    if (this.usingBundle) {
      sdp += 'a=group:BUNDLE ' + this.transceivers.map(function(t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }
    var mediaSectionsInOffer = SDPUtils.splitSections(
        this.remoteDescription.sdp).length - 1;
    this.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      if (sdpMLineIndex + 1 > mediaSectionsInOffer) {
        return;
      }
      if (transceiver.isDatachannel) {
        sdp += 'm=application 0 DTLS/SCTP 5000\r\n' +
            'c=IN IP4 0.0.0.0\r\n' +
            'a=mid:' + transceiver.mid + '\r\n';
        return;
      }

      // FIXME: look at direction.
      if (transceiver.stream) {
        var localTrack;
        if (transceiver.kind === 'audio') {
          localTrack = transceiver.stream.getAudioTracks()[0];
        } else if (transceiver.kind === 'video') {
          localTrack = transceiver.stream.getVideoTracks()[0];
        }
        if (localTrack) {
          // add RTX
          if (edgeVersion >= 15019 && transceiver.kind === 'video' &&
              !transceiver.sendEncodingParameters[0].rtx) {
            transceiver.sendEncodingParameters[0].rtx = {
              ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
            };
          }
        }
      }

      // Calculate intersection of capabilities.
      var commonCapabilities = getCommonCapabilities(
          transceiver.localCapabilities,
          transceiver.remoteCapabilities);

      var hasRtx = commonCapabilities.codecs.filter(function(c) {
        return c.name.toLowerCase() === 'rtx';
      }).length;
      if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
        delete transceiver.sendEncodingParameters[0].rtx;
      }

      sdp += writeMediaSection(transceiver, commonCapabilities,
          'answer', transceiver.stream, self._dtlsRole);
      if (transceiver.rtcpParameters &&
          transceiver.rtcpParameters.reducedSize) {
        sdp += 'a=rtcp-rsize\r\n';
      }
    });

    var desc = new window.RTCSessionDescription({
      type: 'answer',
      sdp: sdp
    });
    return new Promise(function(resolve) {
      if (args.length > 0 && typeof args[0] === 'function') {
        args[0].apply(null, [desc]);
        resolve();
        return;
      }
      resolve(desc);
    });
  };

  RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
    var err;
    var sections;
    if (!candidate || candidate.candidate === '') {
      for (var j = 0; j < this.transceivers.length; j++) {
        if (this.transceivers[j].isDatachannel) {
          continue;
        }
        this.transceivers[j].iceTransport.addRemoteCandidate({});
        sections = SDPUtils.splitSections(this.remoteDescription.sdp);
        sections[j + 1] += 'a=end-of-candidates\r\n';
        this.remoteDescription.sdp = sections.join('');
        if (this.usingBundle) {
          break;
        }
      }
    } else if (!(candidate.sdpMLineIndex !== undefined || candidate.sdpMid)) {
      throw new TypeError('sdpMLineIndex or sdpMid required');
    } else if (!this.remoteDescription) {
      err = new Error('Can not add ICE candidate without ' +
          'a remote description');
      err.name = 'InvalidStateError';
    } else {
      var sdpMLineIndex = candidate.sdpMLineIndex;
      if (candidate.sdpMid) {
        for (var i = 0; i < this.transceivers.length; i++) {
          if (this.transceivers[i].mid === candidate.sdpMid) {
            sdpMLineIndex = i;
            break;
          }
        }
      }
      var transceiver = this.transceivers[sdpMLineIndex];
      if (transceiver) {
        if (transceiver.isDatachannel) {
          return Promise.resolve();
        }
        var cand = Object.keys(candidate.candidate).length > 0 ?
            SDPUtils.parseCandidate(candidate.candidate) : {};
        // Ignore Chrome's invalid candidates since Edge does not like them.
        if (cand.protocol === 'tcp' && (cand.port === 0 || cand.port === 9)) {
          return Promise.resolve();
        }
        // Ignore RTCP candidates, we assume RTCP-MUX.
        if (cand.component && cand.component !== 1) {
          return Promise.resolve();
        }
        // when using bundle, avoid adding candidates to the wrong
        // ice transport. And avoid adding candidates added in the SDP.
        if (sdpMLineIndex === 0 || (sdpMLineIndex > 0 &&
            transceiver.iceTransport !== this.transceivers[0].iceTransport)) {
          if (!maybeAddCandidate(transceiver.iceTransport, cand)) {
            err = new Error('Can not add ICE candidate');
            err.name = 'OperationError';
          }
        }

        if (!err) {
          // update the remoteDescription.
          var candidateString = candidate.candidate.trim();
          if (candidateString.indexOf('a=') === 0) {
            candidateString = candidateString.substr(2);
          }
          sections = SDPUtils.splitSections(this.remoteDescription.sdp);
          sections[sdpMLineIndex + 1] += 'a=' +
              (cand.type ? candidateString : 'end-of-candidates')
              + '\r\n';
          this.remoteDescription.sdp = sections.join('');
        }
      } else {
        err = new Error('Can not add ICE candidate');
        err.name = 'OperationError';
      }
    }
    var args = arguments;
    return new Promise(function(resolve, reject) {
      if (err) {
        if (args.length > 2 && typeof args[2] === 'function') {
          args[2].apply(null, [err]);
        }
        reject(err);
      } else {
        if (args.length > 1 && typeof args[1] === 'function') {
          args[1].apply(null);
        }
        resolve();
      }
    });
  };

  RTCPeerConnection.prototype.getStats = function() {
    var promises = [];
    this.transceivers.forEach(function(transceiver) {
      ['rtpSender', 'rtpReceiver', 'iceGatherer', 'iceTransport',
          'dtlsTransport'].forEach(function(method) {
            if (transceiver[method]) {
              promises.push(transceiver[method].getStats());
            }
          });
    });
    var cb = arguments.length > 1 && typeof arguments[1] === 'function' &&
        arguments[1];
    var fixStatsType = function(stat) {
      return {
        inboundrtp: 'inbound-rtp',
        outboundrtp: 'outbound-rtp',
        candidatepair: 'candidate-pair',
        localcandidate: 'local-candidate',
        remotecandidate: 'remote-candidate'
      }[stat.type] || stat.type;
    };
    return new Promise(function(resolve) {
      // shim getStats with maplike support
      var results = new Map();
      Promise.all(promises).then(function(res) {
        res.forEach(function(result) {
          Object.keys(result).forEach(function(id) {
            result[id].type = fixStatsType(result[id]);
            results.set(id, result[id]);
          });
        });
        if (cb) {
          cb.apply(null, results);
        }
        resolve(results);
      });
    });
  };
  return RTCPeerConnection;
};


/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


// Expose public methods.
module.exports = function(window) {
  var navigator = window && window.navigator;

  var shimError_ = function(e) {
    return {
      name: {PermissionDeniedError: 'NotAllowedError'}[e.name] || e.name,
      message: e.message,
      constraint: e.constraint,
      toString: function() {
        return this.name;
      }
    };
  };

  // getUserMedia error shim.
  var origGetUserMedia = navigator.mediaDevices.getUserMedia.
      bind(navigator.mediaDevices);
  navigator.mediaDevices.getUserMedia = function(c) {
    return origGetUserMedia(c).catch(function(e) {
      return Promise.reject(shimError_(e));
    });
  };
};


/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(870);

module.exports = {
  shimGetUserMedia: __webpack_require__(2364),
  shimOnTrack: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
            this.removeEventListener('addstream', this._ontrackpoly);
          }
          this.addEventListener('track', this._ontrack = f);
          this.addEventListener('addstream', this._ontrackpoly = function(e) {
            e.stream.getTracks().forEach(function(track) {
              var event = new Event('track');
              event.track = track;
              event.receiver = {track: track};
              event.transceiver = {receiver: event.receiver};
              event.streams = [e.stream];
              this.dispatchEvent(event);
            }.bind(this));
          }.bind(this));
        }
      });
    }
    if (typeof window === 'object' && window.RTCTrackEvent &&
        ('receiver' in window.RTCTrackEvent.prototype) &&
        !('transceiver' in window.RTCTrackEvent.prototype)) {
      Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get: function() {
          return {receiver: this.receiver};
        }
      });
    }
  },

  shimSourceObject: function(window) {
    // Firefox has supported mozSrcObject since FF22, unprefixed in 42.
    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        // Shim the srcObject property, once, when HTMLMediaElement is found.
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this.mozSrcObject;
          },
          set: function(stream) {
            this.mozSrcObject = stream;
          }
        });
      }
    }
  },

  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);

    if (typeof window !== 'object' || !(window.RTCPeerConnection ||
        window.mozRTCPeerConnection)) {
      return; // probably media.peerconnection.enabled=false in about:config
    }
    // The RTCPeerConnection object.
    if (!window.RTCPeerConnection) {
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        if (browserDetails.version < 38) {
          // .urls is not supported in FF < 38.
          // create RTCIceServers with a single url.
          if (pcConfig && pcConfig.iceServers) {
            var newIceServers = [];
            for (var i = 0; i < pcConfig.iceServers.length; i++) {
              var server = pcConfig.iceServers[i];
              if (server.hasOwnProperty('urls')) {
                for (var j = 0; j < server.urls.length; j++) {
                  var newServer = {
                    url: server.urls[j]
                  };
                  if (server.urls[j].indexOf('turn') === 0) {
                    newServer.username = server.username;
                    newServer.credential = server.credential;
                  }
                  newIceServers.push(newServer);
                }
              } else {
                newIceServers.push(pcConfig.iceServers[i]);
              }
            }
            pcConfig.iceServers = newIceServers;
          }
        }
        return new window.mozRTCPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype =
          window.mozRTCPeerConnection.prototype;

      // wrap static methods. Currently just generateCertificate.
      if (window.mozRTCPeerConnection.generateCertificate) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function() {
            return window.mozRTCPeerConnection.generateCertificate;
          }
        });
      }

      window.RTCSessionDescription = window.mozRTCSessionDescription;
      window.RTCIceCandidate = window.mozRTCIceCandidate;
    }

    // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = window.RTCPeerConnection.prototype[method];
          window.RTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });

    // support for addIceCandidate(null or undefined)
    var nativeAddIceCandidate =
        window.RTCPeerConnection.prototype.addIceCandidate;
    window.RTCPeerConnection.prototype.addIceCandidate = function() {
      if (!arguments[0]) {
        if (arguments[1]) {
          arguments[1].apply(null);
        }
        return Promise.resolve();
      }
      return nativeAddIceCandidate.apply(this, arguments);
    };

    // shim getStats with maplike support
    var makeMapStats = function(stats) {
      var map = new Map();
      Object.keys(stats).forEach(function(key) {
        map.set(key, stats[key]);
        map[key] = stats[key];
      });
      return map;
    };

    var modernStatsTypes = {
      inboundrtp: 'inbound-rtp',
      outboundrtp: 'outbound-rtp',
      candidatepair: 'candidate-pair',
      localcandidate: 'local-candidate',
      remotecandidate: 'remote-candidate'
    };

    var nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function(
      selector,
      onSucc,
      onErr
    ) {
      return nativeGetStats.apply(this, [selector || null])
        .then(function(stats) {
          if (browserDetails.version < 48) {
            stats = makeMapStats(stats);
          }
          if (browserDetails.version < 53 && !onSucc) {
            // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
              stats.forEach(function(stat) {
                stat.type = modernStatsTypes[stat.type] || stat.type;
              });
            } catch (e) {
              if (e.name !== 'TypeError') {
                throw e;
              }
              // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
              stats.forEach(function(stat, i) {
                stats.set(i, Object.assign({}, stat, {
                  type: modernStatsTypes[stat.type] || stat.type
                }));
              });
            }
          }
          return stats;
        })
        .then(onSucc, onErr);
    };
  },

  shimRemoveStream: function(window) {
    if (!window.RTCPeerConnection ||
        'removeStream' in window.RTCPeerConnection.prototype) {
      return;
    }
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      var pc = this;
      utils.deprecated('removeStream', 'removeTrack');
      this.getSenders().forEach(function(sender) {
        if (sender.track && stream.getTracks().indexOf(sender.track) !== -1) {
          pc.removeTrack(sender);
        }
      });
    };
  }
};


/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(870);
var logging = utils.log;

// Expose public methods.
module.exports = function(window) {
  var browserDetails = utils.detectBrowser(window);
  var navigator = window && window.navigator;
  var MediaStreamTrack = window && window.MediaStreamTrack;

  var shimError_ = function(e) {
    return {
      name: {
        InternalError: 'NotReadableError',
        NotSupportedError: 'TypeError',
        PermissionDeniedError: 'NotAllowedError',
        SecurityError: 'NotAllowedError'
      }[e.name] || e.name,
      message: {
        'The operation is insecure.': 'The request is not allowed by the ' +
        'user agent or the platform in the current context.'
      }[e.message] || e.message,
      constraint: e.constraint,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  // getUserMedia constraints shim.
  var getUserMedia_ = function(constraints, onSuccess, onError) {
    var constraintsToFF37_ = function(c) {
      if (typeof c !== 'object' || c.require) {
        return c;
      }
      var require = [];
      Object.keys(c).forEach(function(key) {
        if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
          return;
        }
        var r = c[key] = (typeof c[key] === 'object') ?
            c[key] : {ideal: c[key]};
        if (r.min !== undefined ||
            r.max !== undefined || r.exact !== undefined) {
          require.push(key);
        }
        if (r.exact !== undefined) {
          if (typeof r.exact === 'number') {
            r. min = r.max = r.exact;
          } else {
            c[key] = r.exact;
          }
          delete r.exact;
        }
        if (r.ideal !== undefined) {
          c.advanced = c.advanced || [];
          var oc = {};
          if (typeof r.ideal === 'number') {
            oc[key] = {min: r.ideal, max: r.ideal};
          } else {
            oc[key] = r.ideal;
          }
          c.advanced.push(oc);
          delete r.ideal;
          if (!Object.keys(r).length) {
            delete c[key];
          }
        }
      });
      if (require.length) {
        c.require = require;
      }
      return c;
    };
    constraints = JSON.parse(JSON.stringify(constraints));
    if (browserDetails.version < 38) {
      logging('spec: ' + JSON.stringify(constraints));
      if (constraints.audio) {
        constraints.audio = constraintsToFF37_(constraints.audio);
      }
      if (constraints.video) {
        constraints.video = constraintsToFF37_(constraints.video);
      }
      logging('ff37: ' + JSON.stringify(constraints));
    }
    return navigator.mozGetUserMedia(constraints, onSuccess, function(e) {
      onError(shimError_(e));
    });
  };

  // Returns the result of getUserMedia as a Promise.
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      getUserMedia_(constraints, resolve, reject);
    });
  };

  // Shim for mediaDevices on older versions.
  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {getUserMedia: getUserMediaPromise_,
      addEventListener: function() { },
      removeEventListener: function() { }
    };
  }
  navigator.mediaDevices.enumerateDevices =
      navigator.mediaDevices.enumerateDevices || function() {
        return new Promise(function(resolve) {
          var infos = [
            {kind: 'audioinput', deviceId: 'default', label: '', groupId: ''},
            {kind: 'videoinput', deviceId: 'default', label: '', groupId: ''}
          ];
          resolve(infos);
        });
      };

  if (browserDetails.version < 41) {
    // Work around http://bugzil.la/1169665
    var orgEnumerateDevices =
        navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices);
    navigator.mediaDevices.enumerateDevices = function() {
      return orgEnumerateDevices().then(undefined, function(e) {
        if (e.name === 'NotFoundError') {
          return [];
        }
        throw e;
      });
    };
  }
  if (browserDetails.version < 49) {
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      return origGetUserMedia(c).then(function(stream) {
        // Work around https://bugzil.la/802326
        if (c.audio && !stream.getAudioTracks().length ||
            c.video && !stream.getVideoTracks().length) {
          stream.getTracks().forEach(function(track) {
            track.stop();
          });
          throw new DOMException('The object can not be found here.',
                                 'NotFoundError');
        }
        return stream;
      }, function(e) {
        return Promise.reject(shimError_(e));
      });
    };
  }
  if (!(browserDetails.version > 55 &&
      'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
    var remap = function(obj, a, b) {
      if (a in obj && !(b in obj)) {
        obj[b] = obj[a];
        delete obj[a];
      }
    };

    var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      if (typeof c === 'object' && typeof c.audio === 'object') {
        c = JSON.parse(JSON.stringify(c));
        remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
        remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
      }
      return nativeGetUserMedia(c);
    };

    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
      var nativeGetSettings = MediaStreamTrack.prototype.getSettings;
      MediaStreamTrack.prototype.getSettings = function() {
        var obj = nativeGetSettings.apply(this, arguments);
        remap(obj, 'mozAutoGainControl', 'autoGainControl');
        remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
        return obj;
      };
    }

    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
      var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
      MediaStreamTrack.prototype.applyConstraints = function(c) {
        if (this.kind === 'audio' && typeof c === 'object') {
          c = JSON.parse(JSON.stringify(c));
          remap(c, 'autoGainControl', 'mozAutoGainControl');
          remap(c, 'noiseSuppression', 'mozNoiseSuppression');
        }
        return nativeApplyConstraints.apply(this, [c]);
      };
    }
  }
  navigator.getUserMedia = function(constraints, onSuccess, onError) {
    if (browserDetails.version < 44) {
      return getUserMedia_(constraints, onSuccess, onError);
    }
    // Replace Firefox 44+'s deprecation warning with unprefixed version.
    utils.deprecated('navigator.getUserMedia',
        'navigator.mediaDevices.getUserMedia');
    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };
};


/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

var utils = __webpack_require__(870);

module.exports = {
  shimLocalStreamsAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getLocalStreams = function() {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        return this._localStreams;
      };
    }
    if (!('getStreamById' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getStreamById = function(id) {
        var result = null;
        if (this._localStreams) {
          this._localStreams.forEach(function(stream) {
            if (stream.id === id) {
              result = stream;
            }
          });
        }
        if (this._remoteStreams) {
          this._remoteStreams.forEach(function(stream) {
            if (stream.id === id) {
              result = stream;
            }
          });
        }
        return result;
      };
    }
    if (!('addStream' in window.RTCPeerConnection.prototype)) {
      var _addTrack = window.RTCPeerConnection.prototype.addTrack;
      window.RTCPeerConnection.prototype.addStream = function(stream) {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        if (this._localStreams.indexOf(stream) === -1) {
          this._localStreams.push(stream);
        }
        var pc = this;
        stream.getTracks().forEach(function(track) {
          _addTrack.call(pc, track, stream);
        });
      };

      window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
        if (stream) {
          if (!this._localStreams) {
            this._localStreams = [stream];
          } else if (this._localStreams.indexOf(stream) === -1) {
            this._localStreams.push(stream);
          }
        }
        return _addTrack.call(this, track, stream);
      };
    }
    if (!('removeStream' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.removeStream = function(stream) {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        var index = this._localStreams.indexOf(stream);
        if (index === -1) {
          return;
        }
        this._localStreams.splice(index, 1);
        var pc = this;
        var tracks = stream.getTracks();
        this.getSenders().forEach(function(sender) {
          if (tracks.indexOf(sender.track) !== -1) {
            pc.removeTrack(sender);
          }
        });
      };
    }
  },
  shimRemoteStreamsAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getRemoteStreams = function() {
        return this._remoteStreams ? this._remoteStreams : [];
      };
    }
    if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
        get: function() {
          return this._onaddstream;
        },
        set: function(f) {
          if (this._onaddstream) {
            this.removeEventListener('addstream', this._onaddstream);
            this.removeEventListener('track', this._onaddstreampoly);
          }
          this.addEventListener('addstream', this._onaddstream = f);
          this.addEventListener('track', this._onaddstreampoly = function(e) {
            var stream = e.streams[0];
            if (!this._remoteStreams) {
              this._remoteStreams = [];
            }
            if (this._remoteStreams.indexOf(stream) >= 0) {
              return;
            }
            this._remoteStreams.push(stream);
            var event = new Event('addstream');
            event.stream = e.streams[0];
            this.dispatchEvent(event);
          }.bind(this));
        }
      });
    }
  },
  shimCallbacksAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    var prototype = window.RTCPeerConnection.prototype;
    var createOffer = prototype.createOffer;
    var createAnswer = prototype.createAnswer;
    var setLocalDescription = prototype.setLocalDescription;
    var setRemoteDescription = prototype.setRemoteDescription;
    var addIceCandidate = prototype.addIceCandidate;

    prototype.createOffer = function(successCallback, failureCallback) {
      var options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      var promise = createOffer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };

    prototype.createAnswer = function(successCallback, failureCallback) {
      var options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      var promise = createAnswer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };

    var withCallback = function(description, successCallback, failureCallback) {
      var promise = setLocalDescription.apply(this, [description]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;

    withCallback = function(description, successCallback, failureCallback) {
      var promise = setRemoteDescription.apply(this, [description]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;

    withCallback = function(candidate, successCallback, failureCallback) {
      var promise = addIceCandidate.apply(this, [candidate]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
  },
  shimGetUserMedia: function(window) {
    var navigator = window && window.navigator;

    if (!navigator.getUserMedia) {
      if (navigator.webkitGetUserMedia) {
        navigator.getUserMedia = navigator.webkitGetUserMedia.bind(navigator);
      } else if (navigator.mediaDevices &&
          navigator.mediaDevices.getUserMedia) {
        navigator.getUserMedia = function(constraints, cb, errcb) {
          navigator.mediaDevices.getUserMedia(constraints)
          .then(cb, errcb);
        }.bind(navigator);
      }
    }
  },
  shimRTCIceServerUrls: function(window) {
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    var OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function(pcConfig, pcConstraints) {
      if (pcConfig && pcConfig.iceServers) {
        var newIceServers = [];
        for (var i = 0; i < pcConfig.iceServers.length; i++) {
          var server = pcConfig.iceServers[i];
          if (!server.hasOwnProperty('urls') &&
              server.hasOwnProperty('url')) {
            utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
            server = JSON.parse(JSON.stringify(server));
            server.urls = server.url;
            delete server.url;
            newIceServers.push(server);
          } else {
            newIceServers.push(pcConfig.iceServers[i]);
          }
        }
        pcConfig.iceServers = newIceServers;
      }
      return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ('generateCertificate' in window.RTCPeerConnection) {
      Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get: function() {
          return OrigPeerConnection.generateCertificate;
        }
      });
    }
  },
  shimTrackEventTransceiver: function(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === 'object' && window.RTCPeerConnection &&
        ('receiver' in window.RTCTrackEvent.prototype) &&
        // can't check 'transceiver' in window.RTCTrackEvent.prototype, as it is
        // defined for some reason even when window.RTCTransceiver is not.
        !window.RTCTransceiver) {
      Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get: function() {
          return {receiver: this.receiver};
        }
      });
    }
  },

  shimCreateOfferLegacy: function(window) {
    var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function(offerOptions) {
      var pc = this;
      if (offerOptions) {
        var audioTransceiver = pc.getTransceivers().find(function(transceiver) {
          return transceiver.sender.track &&
              transceiver.sender.track.kind === 'audio';
        });
        if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
          if (audioTransceiver.direction === 'sendrecv') {
            audioTransceiver.setDirection('sendonly');
          } else if (audioTransceiver.direction === 'recvonly') {
            audioTransceiver.setDirection('inactive');
          }
        } else if (offerOptions.offerToReceiveAudio === true &&
            !audioTransceiver) {
          pc.addTransceiver('audio');
        }

        var videoTransceiver = pc.getTransceivers().find(function(transceiver) {
          return transceiver.sender.track &&
              transceiver.sender.track.kind === 'video';
        });
        if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
          if (videoTransceiver.direction === 'sendrecv') {
            videoTransceiver.setDirection('sendonly');
          } else if (videoTransceiver.direction === 'recvonly') {
            videoTransceiver.setDirection('inactive');
          }
        } else if (offerOptions.offerToReceiveVideo === true &&
            !videoTransceiver) {
          pc.addTransceiver('video');
        }
      }
      return origCreateOffer.apply(pc, arguments);
    };
  }
};


/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var SDPUtils = __webpack_require__(1407);
var utils = __webpack_require__(870);

// Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object.
function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
  if (!window.RTCPeerConnection) {
    return;
  }
  var proto = window.RTCPeerConnection.prototype;
  var nativeAddEventListener = proto.addEventListener;
  proto.addEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap) {
      return nativeAddEventListener.apply(this, arguments);
    }
    var wrappedCallback = function(e) {
      cb(wrapper(e));
    };
    this._eventMap = this._eventMap || {};
    this._eventMap[cb] = wrappedCallback;
    return nativeAddEventListener.apply(this, [nativeEventName,
      wrappedCallback]);
  };

  var nativeRemoveEventListener = proto.removeEventListener;
  proto.removeEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap || !this._eventMap
        || !this._eventMap[cb]) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    var unwrappedCb = this._eventMap[cb];
    delete this._eventMap[cb];
    return nativeRemoveEventListener.apply(this, [nativeEventName,
      unwrappedCb]);
  };

  Object.defineProperty(proto, 'on' + eventNameToWrap, {
    get: function() {
      return this['_on' + eventNameToWrap];
    },
    set: function(cb) {
      if (this['_on' + eventNameToWrap]) {
        this.removeEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap]);
        delete this['_on' + eventNameToWrap];
      }
      if (cb) {
        this.addEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap] = cb);
      }
    }
  });
}

module.exports = {
  shimRTCIceCandidate: function(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (window.RTCIceCandidate && 'foundation' in
        window.RTCIceCandidate.prototype) {
      return;
    }

    var NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function(args) {
      // Remove the a= which shouldn't be part of the candidate string.
      if (typeof args === 'object' && args.candidate &&
          args.candidate.indexOf('a=') === 0) {
        args = JSON.parse(JSON.stringify(args));
        args.candidate = args.candidate.substr(2);
      }

      // Augment the native candidate with the parsed fields.
      var nativeCandidate = new NativeRTCIceCandidate(args);
      var parsedCandidate = SDPUtils.parseCandidate(args.candidate);
      var augmentedCandidate = Object.assign(nativeCandidate,
          parsedCandidate);

      // Add a serializer that does not serialize the extra attributes.
      augmentedCandidate.toJSON = function() {
        return {
          candidate: augmentedCandidate.candidate,
          sdpMid: augmentedCandidate.sdpMid,
          sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
          usernameFragment: augmentedCandidate.usernameFragment,
        };
      };
      return augmentedCandidate;
    };

    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    wrapPeerConnectionEvent(window, 'icecandidate', function(e) {
      if (e.candidate) {
        Object.defineProperty(e, 'candidate', {
          value: new window.RTCIceCandidate(e.candidate),
          writable: 'false'
        });
      }
      return e;
    });
  },

  // shimCreateObjectURL must be called before shimSourceObject to avoid loop.

  shimCreateObjectURL: function(window) {
    var URL = window && window.URL;

    if (!(typeof window === 'object' && window.HTMLMediaElement &&
          'srcObject' in window.HTMLMediaElement.prototype &&
        URL.createObjectURL && URL.revokeObjectURL)) {
      // Only shim CreateObjectURL using srcObject if srcObject exists.
      return undefined;
    }

    var nativeCreateObjectURL = URL.createObjectURL.bind(URL);
    var nativeRevokeObjectURL = URL.revokeObjectURL.bind(URL);
    var streams = new Map(), newId = 0;

    URL.createObjectURL = function(stream) {
      if ('getTracks' in stream) {
        var url = 'polyblob:' + (++newId);
        streams.set(url, stream);
        utils.deprecated('URL.createObjectURL(stream)',
            'elem.srcObject = stream');
        return url;
      }
      return nativeCreateObjectURL(stream);
    };
    URL.revokeObjectURL = function(url) {
      nativeRevokeObjectURL(url);
      streams.delete(url);
    };

    var dsc = Object.getOwnPropertyDescriptor(window.HTMLMediaElement.prototype,
                                              'src');
    Object.defineProperty(window.HTMLMediaElement.prototype, 'src', {
      get: function() {
        return dsc.get.apply(this);
      },
      set: function(url) {
        this.srcObject = streams.get(url) || null;
        return dsc.set.apply(this, [url]);
      }
    });

    var nativeSetAttribute = window.HTMLMediaElement.prototype.setAttribute;
    window.HTMLMediaElement.prototype.setAttribute = function() {
      if (arguments.length === 2 &&
          ('' + arguments[0]).toLowerCase() === 'src') {
        this.srcObject = streams.get(arguments[1]) || null;
      }
      return nativeSetAttribute.apply(this, arguments);
    };
  }
};


/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = WebrtcHeader;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WebrtcHeader(props) {
    var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'webrtc.header',
        defaultMessage: 'Call with {username}',
        values: {
            username: props.username
        }
    });

    var closeSidebarTooltip = _react2.default.createElement(
        _reactBootstrap.Tooltip,
        { id: 'closeSidebarTooltip' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'rhs_header.closeTooltip',
            defaultMessage: 'Close Sidebar'
        })
    );

    var expandSidebarTooltip = _react2.default.createElement(
        _reactBootstrap.Tooltip,
        { id: 'expandSidebarTooltip' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'rhs_header.expandTooltip',
            defaultMessage: 'Expand Sidebar'
        })
    );

    var shrinkSidebarTooltip = _react2.default.createElement(
        _reactBootstrap.Tooltip,
        { id: 'shrinkSidebarTooltip' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'rhs_header.expandTooltip',
            defaultMessage: 'Shrink Sidebar'
        })
    );

    return _react2.default.createElement(
        'div',
        { className: 'sidebar--right__header' },
        _react2.default.createElement(
            'span',
            { className: 'sidebar--right__title' },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            _react2.default.createElement(
                'button',
                {
                    type: 'button',
                    className: 'sidebar--right__expand',
                    'aria-label': 'Expand',
                    onClick: props.toggleSize
                },
                _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        trigger: ['hover', 'focus'],
                        delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                        placement: 'top',
                        overlay: expandSidebarTooltip
                    },
                    _react2.default.createElement('i', { className: 'fa fa-expand' })
                ),
                _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        trigger: ['hover', 'focus'],
                        delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                        placement: 'top',
                        overlay: shrinkSidebarTooltip
                    },
                    _react2.default.createElement('i', { className: 'fa fa-compress' })
                )
            ),
            _react2.default.createElement(
                'button',
                {
                    type: 'button',
                    className: 'sidebar--right__close',
                    'aria-label': 'Close',
                    title: 'Close',
                    onClick: props.onClose
                },
                _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                        placement: 'top',
                        overlay: closeSidebarTooltip
                    },
                    _react2.default.createElement('i', { className: 'fa fa-sign-out' })
                )
            )
        )
    );
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

WebrtcHeader.propTypes = {
    username: _propTypes2.default.string.isRequired,
    onClose: _propTypes2.default.func.isRequired,
    toggleSize: _propTypes2.default.func
};

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _modals = __webpack_require__(927);

var _modal_controller = __webpack_require__(2369);

var _modal_controller2 = _interopRequireDefault(_modal_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        modals: state.views.modals
    });
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            closeModal: _modals.closeModal
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_modal_controller2.default);

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ModalController = function (_React$Component) {
    (0, _inherits3.default)(ModalController, _React$Component);

    function ModalController() {
        (0, _classCallCheck3.default)(this, ModalController);
        return (0, _possibleConstructorReturn3.default)(this, (ModalController.__proto__ || (0, _getPrototypeOf2.default)(ModalController)).apply(this, arguments));
    }

    (0, _createClass3.default)(ModalController, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                modals = _props.modals,
                props = (0, _objectWithoutProperties3.default)(_props, ['modals']);
            var modalState = modals.modalState;


            if (!modals) {
                return _react2.default.createElement('div', null);
            }

            var modalOutput = [];

            for (var modalId in modalState) {
                if (modalState.hasOwnProperty(modalId)) {
                    var modal = modalState[modalId];
                    if (modal.open) {
                        var modalComponent = _react2.default.createElement(modal.dialogType, (0, _assign2.default)({}, modal.dialogProps, {
                            onHide: props.actions.closeModal.bind(this, modalId),
                            key: modalId + '_modal'
                        }));

                        modalOutput.push(modalComponent);
                    }
                }
            }

            return _react2.default.createElement(
                'div',
                null,
                modalOutput
            );
        }
    }]);
    return ModalController;
}(_react2.default.Component);

ModalController.propTypes = {
    modals: _propTypes2.default.object.isRequired,
    actions: _propTypes2.default.shape({
        closeModal: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = ModalController;

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _teams = __webpack_require__(816);

var _reactRouterDom = __webpack_require__(269);

var _general = __webpack_require__(113);

var _lhs = __webpack_require__(1083);

var _team_sidebar_controller = __webpack_require__(2371);

var _team_sidebar_controller2 = _interopRequireDefault(_team_sidebar_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    var experimentalPrimaryTeam = config.ExperimentalPrimaryTeam;
    var enableTeamCreation = config.EnableTeamCreation === 'true';

    return {
        isOpen: (0, _lhs.getIsLhsOpen)(state),
        experimentalPrimaryTeam: experimentalPrimaryTeam,
        enableTeamCreation: enableTeamCreation
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getTeams: _teams.getTeams
        }, dispatch)
    };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_team_sidebar_controller2.default));

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _permissions = __webpack_require__(279);

var _permissions2 = _interopRequireDefault(_permissions);

var _classnames = __webpack_require__(769);

var _classnames2 = _interopRequireDefault(_classnames);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _team_utils = __webpack_require__(960);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _system_permission_gate = __webpack_require__(863);

var _system_permission_gate2 = _interopRequireDefault(_system_permission_gate);

var _team_button = __webpack_require__(2372);

var _team_button2 = _interopRequireDefault(_team_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeamSidebar = function (_React$Component) {
    (0, _inherits3.default)(TeamSidebar, _React$Component);

    function TeamSidebar(props) {
        (0, _classCallCheck3.default)(this, TeamSidebar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamSidebar.__proto__ || (0, _getPrototypeOf2.default)(TeamSidebar)).call(this, props));

        _this.getStateFromStores = function () {
            var teamMembers = _team_store2.default.getMyTeamMembers();
            var currentTeamId = _team_store2.default.getCurrentId();

            return {
                teams: _team_store2.default.getAll(),
                teamListings: _team_store2.default.getTeamListings(),
                teamMembers: teamMembers,
                currentTeamId: currentTeamId,
                show: teamMembers && teamMembers.length > 1,
                isMobile: Utils.isMobile()
            };
        };

        _this.onChange = function () {
            _this.setState(_this.getStateFromStores());
            _this.setStyles();
        };

        _this.handleResize = function () {
            var teamMembers = _this.state.teamMembers;
            _this.setState({ show: teamMembers && teamMembers.length > 1 });
            _this.setStyles();
        };

        _this.setStyles = function () {
            var root = document.querySelector('#root');

            if (_this.state.show) {
                root.classList.add('multi-teams');
            } else {
                root.classList.remove('multi-teams');
            }
        };

        _this.state = _this.getStateFromStores();
        return _this;
    }

    (0, _createClass3.default)(TeamSidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.handleResize);
            _team_store2.default.addChangeListener(this.onChange);
            _team_store2.default.addUnreadChangeListener(this.onChange);
            this.props.actions.getTeams(0, 200);
            this.setStyles();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
            _team_store2.default.removeChangeListener(this.onChange);
            _team_store2.default.removeUnreadChangeListener(this.onChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!this.state.isMobile) {
                (0, _jquery2.default)('.team-wrapper').perfectScrollbar();
            }

            // reset the scrollbar upon switching teams
            if (this.state.currentTeam !== prevState.currentTeam) {
                this.refs.container.scrollTop = 0;
                if (!this.state.isMobile) {
                    (0, _jquery2.default)('.team-wrapper').perfectScrollbar('update');
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.state.show) {
                return null;
            }

            var myTeams = [];
            var isAlreadyMember = new _map2.default();
            var moreTeams = false;

            for (var index in this.state.teamMembers) {
                if (this.state.teamMembers.hasOwnProperty(index)) {
                    var teamMember = this.state.teamMembers[index];
                    if (teamMember.delete_at > 0) {
                        continue;
                    }
                    var teamId = teamMember.team_id;
                    myTeams.push((0, _assign2.default)({
                        unread: teamMember.msg_count > 0,
                        mentions: teamMember.mention_count
                    }, this.state.teams[teamId]));
                    isAlreadyMember[teamId] = true;
                }
            }

            for (var id in this.state.teamListings) {
                if (this.state.teamListings.hasOwnProperty(id) && !isAlreadyMember[id]) {
                    moreTeams = true;
                    break;
                }
            }

            var teams = (0, _team_utils.filterAndSortTeamsByDisplayName)(myTeams).map(function (team) {
                return _react2.default.createElement(_team_button2.default, {
                    key: 'switch_team_' + team.name,
                    url: '/' + team.name,
                    tip: team.display_name,
                    active: team.id === _this2.state.currentTeamId,
                    isMobile: _this2.state.isMobile,
                    displayName: team.display_name,
                    unread: team.unread,
                    mentions: team.mentions,
                    teamIconUrl: Utils.imageURLForTeam(team)
                });
            });

            if (moreTeams && !this.props.experimentalPrimaryTeam) {
                teams.push(_react2.default.createElement(_team_button2.default, {
                    btnClass: 'team-btn__add',
                    key: 'more_teams',
                    url: '/select_team',
                    isMobile: this.state.isMobile,
                    tip: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'team_sidebar.join',
                        defaultMessage: 'Other teams you can join.'
                    }),
                    content: _react2.default.createElement('i', { className: 'fa fa-plus' })
                }));
            } else {
                teams.push(_react2.default.createElement(
                    _system_permission_gate2.default,
                    {
                        permissions: [_permissions2.default.CREATE_TEAM],
                        key: 'more_teams'
                    },
                    _react2.default.createElement(_team_button2.default, {
                        btnClass: 'team-btn__add',
                        url: '/create_team',
                        isMobile: this.state.isMobile,
                        tip: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.create',
                            defaultMessage: 'Create a New Team'
                        }),
                        content: _react2.default.createElement('i', { className: 'fa fa-plus' })
                    })
                ));
            }

            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('team-sidebar', { 'move--right': this.props.isOpen }) },
                _react2.default.createElement(
                    'div',
                    { className: 'team-wrapper' },
                    teams
                )
            );
        }
    }]);
    return TeamSidebar;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

TeamSidebar.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    experimentalPrimaryTeam: _propTypes2.default.string,
    enableTeamCreation: _propTypes2.default.bool.isRequired,
    actions: _propTypes2.default.shape({
        getTeams: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = TeamSidebar;

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactRouterDom = __webpack_require__(269);

var _diagnostics_actions = __webpack_require__(804);

var _team_actions = __webpack_require__(832);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _user_agent = __webpack_require__(790);

var _utils = __webpack_require__(762);

var _copy_url_context_menu = __webpack_require__(1408);

var _copy_url_context_menu2 = _interopRequireDefault(_copy_url_context_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TeamButton = function (_React$Component) {
    (0, _inherits3.default)(TeamButton, _React$Component);

    function TeamButton(props) {
        (0, _classCallCheck3.default)(this, TeamButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamButton.__proto__ || (0, _getPrototypeOf2.default)(TeamButton)).call(this, props));

        _this.handleSwitch = _this.handleSwitch.bind(_this);
        _this.handleDisabled = _this.handleDisabled.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(TeamButton, [{
        key: 'handleSwitch',
        value: function handleSwitch(e) {
            e.preventDefault();
            (0, _diagnostics_actions.mark)('TeamLink#click');
            (0, _diagnostics_actions.trackEvent)('ui', 'ui_team_sidebar_switch_team');
            (0, _team_actions.switchTeams)(this.props.url);
        }
    }, {
        key: 'handleDisabled',
        value: function handleDisabled(e) {
            e.preventDefault();
        }
    }, {
        key: 'render',
        value: function render() {
            var teamIconUrl = this.props.teamIconUrl;

            var teamClass = this.props.active ? 'active' : '';
            var btnClass = this.props.btnClass;
            var disabled = this.props.disabled ? 'team-disabled' : '';
            var handleClick = this.props.active || this.props.disabled ? this.handleDisabled : this.handleSwitch;
            var badge = void 0;

            if (!teamClass) {
                teamClass = this.props.unread ? 'unread' : '';

                if (this.props.mentions) {
                    badge = _react2.default.createElement(
                        'span',
                        { className: 'badge pull-right small ' + (teamIconUrl ? 'stroked' : '') },
                        this.props.mentions
                    );
                }
            }

            var btn = void 0;
            var content = this.props.content;

            if (!content) {
                if (teamIconUrl) {
                    content = _react2.default.createElement('div', {
                        className: 'team-btn__image',
                        style: { backgroundImage: 'url(\'' + teamIconUrl + '\')' }
                    });
                } else {
                    var initials = this.props.displayName;
                    initials = initials ? initials.replace(/\s/g, '').substring(0, 2) : '??';

                    content = _react2.default.createElement(
                        'div',
                        { className: 'team-btn__initials' },
                        initials,
                        _react2.default.createElement(
                            'div',
                            { className: 'team-btn__content' },
                            this.props.displayName
                        )
                    );
                }
            }

            if (this.props.isMobile) {
                btn = _react2.default.createElement(
                    'div',
                    { className: 'team-btn ' + btnClass },
                    badge,
                    content
                );
            } else {
                var toolTip = this.props.tip || (0, _utils.localizeMessage)('team.button.name_undefined', 'Name undefined');
                btn = _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        trigger: ['hover', 'focus'],
                        delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                        placement: this.props.placement,
                        overlay: _react2.default.createElement(
                            _reactBootstrap.Tooltip,
                            { id: 'tooltip-' + this.props.url },
                            toolTip
                        )
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'team-btn ' + btnClass },
                        badge,
                        content
                    )
                );
            }

            var teamButton = void 0;
            if ((0, _user_agent.isDesktopApp)()) {
                teamButton = _react2.default.createElement(
                    'button',
                    {
                        className: 'btn btn-link ' + disabled,
                        onClick: handleClick
                    },
                    btn
                );

                // if this is not a "special" team button, give it a context menu
                if (!this.props.url.endsWith('create_team') && !this.props.url.endsWith('select_team')) {
                    teamButton = _react2.default.createElement(
                        _copy_url_context_menu2.default,
                        {
                            link: this.props.url,
                            menuId: this.props.url
                        },
                        teamButton
                    );
                }
            } else {
                teamButton = _react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        className: disabled,
                        to: this.props.url,
                        onClick: handleClick
                    },
                    btn
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    className: 'team-container ' + teamClass
                },
                teamButton
            );
        }
    }]);
    return TeamButton;
}(_react2.default.Component);

exports.default = TeamButton;


TeamButton.defaultProps = {
    btnClass: '',
    tip: '',
    placement: 'right',
    active: false,
    disabled: false,
    unread: false,
    mentions: 0
};

TeamButton.propTypes = {
    btnClass: _propTypes2.default.string,
    url: _propTypes2.default.string.isRequired,
    displayName: _propTypes2.default.string,
    content: _propTypes2.default.node,
    tip: _propTypes2.default.node.isRequired,
    active: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    unread: _propTypes2.default.bool,
    mentions: _propTypes2.default.number,
    placement: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom']),
    teamIconUrl: _propTypes2.default.string
};

/***/ }),
/* 2373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(14);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(22);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(769);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__(178);
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/helpers.js
function callIfExists(func) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    return typeof func === 'function' && func.apply(undefined, args);
}

function hasOwnProp(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

function uniqueId() {
    return Math.random().toString(36).substring(7);
}

var cssClasses = {
    menu: 'react-contextmenu',
    menuVisible: 'react-contextmenu--visible',
    menuWrapper: 'react-contextmenu-wrapper',
    menuItem: 'react-contextmenu-item',
    menuItemActive: 'react-contextmenu-item--active',
    menuItemDisabled: 'react-contextmenu-item--disabled',
    menuItemDivider: 'react-contextmenu-item--divider',
    menuItemSelected: 'react-contextmenu-item--selected',
    subMenu: 'react-contextmenu-submenu'
};

var store = {};

var canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/actions.js




var MENU_SHOW = 'REACT_CONTEXTMENU_SHOW';
var MENU_HIDE = 'REACT_CONTEXTMENU_HIDE';

function dispatchGlobalEvent(eventName, opts) {
    var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;

    // Compatibale with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    var event = void 0;

    if (typeof window.CustomEvent === 'function') {
        event = new window.CustomEvent(eventName, { detail: opts });
    } else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, false, true, opts);
    }

    if (target) {
        target.dispatchEvent(event);
        object_assign_default()(store, opts);
    }
}

function showMenu() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var target = arguments[1];

    dispatchGlobalEvent(MENU_SHOW, object_assign_default()({}, opts, { type: MENU_SHOW }), target);
}

function hideMenu() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var target = arguments[1];

    dispatchGlobalEvent(MENU_HIDE, object_assign_default()({}, opts, { type: MENU_HIDE }), target);
}
// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/globalEventListener.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var globalEventListener_GlobalEventListener = function GlobalEventListener() {
    var _this = this;

    _classCallCheck(this, GlobalEventListener);

    this.handleShowEvent = function (event) {
        for (var id in _this.callbacks) {
            if (hasOwnProp(_this.callbacks, id)) _this.callbacks[id].show(event);
        }
    };

    this.handleHideEvent = function (event) {
        for (var id in _this.callbacks) {
            if (hasOwnProp(_this.callbacks, id)) _this.callbacks[id].hide(event);
        }
    };

    this.register = function (showCallback, hideCallback) {
        var id = uniqueId();

        _this.callbacks[id] = {
            show: showCallback,
            hide: hideCallback
        };

        return id;
    };

    this.unregister = function (id) {
        if (id && _this.callbacks[id]) {
            delete _this.callbacks[id];
        }
    };

    this.callbacks = {};

    if (canUseDOM) {
        window.addEventListener(MENU_SHOW, this.handleShowEvent);
        window.addEventListener(MENU_HIDE, this.handleHideEvent);
    }
};

/* harmony default export */ var globalEventListener = (new globalEventListener_GlobalEventListener());
// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/MenuItem.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function MenuItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MenuItem_MenuItem = function (_Component) {
    _inherits(MenuItem, _Component);

    function MenuItem() {
        var _ref;

        var _temp, _this, _ret;

        MenuItem__classCallCheck(this, MenuItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
            event.preventDefault();

            if (_this.props.disabled || _this.props.divider) return;

            callIfExists(_this.props.onClick, event, object_assign_default()({}, _this.props.data, store.data), store.target);

            if (_this.props.preventClose) return;

            hideMenu();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MenuItem, [{
        key: 'render',
        value: function render() {
            var _cx,
                _this2 = this;

            var _props = this.props,
                disabled = _props.disabled,
                divider = _props.divider,
                children = _props.children,
                attributes = _props.attributes,
                selected = _props.selected;

            var menuItemClassNames = classnames_default()(cssClasses.menuItem, attributes && attributes.className, (_cx = {}, _defineProperty(_cx, cssClasses.menuItemDisabled, disabled), _defineProperty(_cx, cssClasses.menuItemDivider, divider), _defineProperty(_cx, cssClasses.menuItemSelected, selected), _cx));

            return react_default.a.createElement(
                'div',
                _extends({}, attributes, { className: menuItemClassNames,
                    role: 'menuitem', tabIndex: '-1', 'aria-disabled': disabled ? 'true' : 'false',
                    'aria-orientation': divider ? 'horizontal' : null,
                    ref: function ref(_ref2) {
                        _this2.ref = _ref2;
                    },
                    onMouseMove: this.props.onMouseMove, onMouseLeave: this.props.onMouseLeave,
                    onTouchEnd: this.handleClick, onClick: this.handleClick }),
                divider ? null : children
            );
        }
    }]);

    return MenuItem;
}(react["Component"]);

MenuItem_MenuItem.propTypes = {
    children: prop_types_default.a.node,
    attributes: prop_types_default.a.object,
    data: prop_types_default.a.object,
    disabled: prop_types_default.a.bool,
    divider: prop_types_default.a.bool,
    preventClose: prop_types_default.a.bool,
    onClick: prop_types_default.a.func,
    selected: prop_types_default.a.bool,
    onMouseMove: prop_types_default.a.func,
    onMouseLeave: prop_types_default.a.func
};
MenuItem_MenuItem.defaultProps = {
    disabled: false,
    data: {},
    divider: false,
    attributes: {},
    preventClose: false,
    onClick: function onClick() {
        return null;
    },

    children: null,
    selected: false,
    onMouseMove: function onMouseMove() {
        return null;
    },
    onMouseLeave: function onMouseLeave() {
        return null;
    }
};
/* harmony default export */ var es6_MenuItem = (MenuItem_MenuItem);
// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/AbstractMenu.js
function AbstractMenu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AbstractMenu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AbstractMenu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AbstractMenu = function (_Component) {
    AbstractMenu__inherits(AbstractMenu, _Component);

    function AbstractMenu(props) {
        AbstractMenu__classCallCheck(this, AbstractMenu);

        var _this = AbstractMenu__possibleConstructorReturn(this, (AbstractMenu.__proto__ || Object.getPrototypeOf(AbstractMenu)).call(this, props));

        AbstractMenu__initialiseProps.call(_this);

        _this.seletedItemRef = null;
        _this.state = {
            selectedItem: null,
            forceSubMenuOpen: false
        };
        return _this;
    }

    return AbstractMenu;
}(react["Component"]);

AbstractMenu.propTypes = {
    children: prop_types_default.a.node.isRequired
};

var AbstractMenu__initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleKeyNavigation = function (e) {
        // check for isVisible strictly here as it might be undefined when this code executes in the context of SubMenu
        // but we only need to check when it runs in the ContextMenu context
        if (_this2.state.isVisible === false) {
            return;
        }

        switch (e.keyCode) {
            case 37: // left arrow
            case 27:
                // escape
                e.preventDefault();
                _this2.hideMenu(e);
                break;
            case 38:
                // up arrow
                e.preventDefault();
                _this2.selectChildren(true);
                break;
            case 40:
                // down arrow
                e.preventDefault();
                _this2.selectChildren(false);
                break;
            case 39:
                // right arrow
                _this2.tryToOpenSubMenu(e);
                break;
            case 13:
                // enter
                e.preventDefault();
                _this2.tryToOpenSubMenu(e);
                {
                    // determine the selected item is disabled or not
                    var disabled = _this2.seletedItemRef && _this2.seletedItemRef.props && _this2.seletedItemRef.props.disabled;

                    if (_this2.seletedItemRef && _this2.seletedItemRef.ref instanceof HTMLElement && !disabled) {
                        _this2.seletedItemRef.ref.click();
                    } else {
                        _this2.hideMenu(e);
                    }
                }
                break;
            default:
            // do nothing
        }
    };

    this.handleForceClose = function () {
        _this2.setState({ forceSubMenuOpen: false });
    };

    this.tryToOpenSubMenu = function (e) {
        if (_this2.state.selectedItem && _this2.state.selectedItem.type === _this2.getSubMenuType()) {
            e.preventDefault();
            _this2.setState({ forceSubMenuOpen: true });
        }
    };

    this.selectChildren = function (forward) {
        var selectedItem = _this2.state.selectedItem;

        var children = [];
        var childCollector = function childCollector(child) {
            // child can be empty in case you do conditional rendering of components, in which
            // case it should not be accounted for as a real child
            if (!child) {
                return;
            }

            if ([es6_MenuItem, _this2.getSubMenuType()].indexOf(child.type) < 0) {
                // Maybe the MenuItem or SubMenu is capsuled in a wrapper div or something else
                react_default.a.Children.forEach(child.props.children, childCollector);
            } else if (!child.props.divider) {
                children.push(child);
            }
        };
        react_default.a.Children.forEach(_this2.props.children, childCollector);
        var currentIndex = children.indexOf(selectedItem);
        if (currentIndex < 0) {
            _this2.setState({
                selectedItem: forward ? children[children.length - 1] : children[0],
                forceSubMenuOpen: false
            });
        } else if (forward) {
            _this2.setState({
                selectedItem: children[currentIndex - 1 < 0 ? children.length - 1 : currentIndex - 1],
                forceSubMenuOpen: false
            });
        } else {
            _this2.setState({
                selectedItem: children[currentIndex + 1 < children.length ? currentIndex + 1 : 0],
                forceSubMenuOpen: false
            });
        }
    };

    this.onChildMouseMove = function (child) {
        if (_this2.state.selectedItem !== child) {
            _this2.setState({ selectedItem: child, forceSubMenuOpen: false });
        }
    };

    this.onChildMouseLeave = function () {
        _this2.setState({ selectedItem: null, forceSubMenuOpen: false });
    };

    this.renderChildren = function (children) {
        return react_default.a.Children.map(children, function (child) {
            var props = {};
            if (!react_default.a.isValidElement(child)) return child;
            if ([es6_MenuItem, _this2.getSubMenuType()].indexOf(child.type) < 0) {
                // Maybe the MenuItem or SubMenu is capsuled in a wrapper div or something else
                props.children = _this2.renderChildren(child.props.children);
                return react_default.a.cloneElement(child, props);
            }
            props.onMouseLeave = _this2.onChildMouseLeave.bind(_this2);
            if (child.type === _this2.getSubMenuType()) {
                // special props for SubMenu only
                props.forceOpen = _this2.state.forceSubMenuOpen && _this2.state.selectedItem === child;
                props.forceClose = _this2.handleForceClose;
                props.parentKeyNavigationHandler = _this2.handleKeyNavigation;
            }
            if (!child.props.divider && _this2.state.selectedItem === child) {
                // special props for selected item only
                props.selected = true;
                props.ref = function (ref) {
                    _this2.seletedItemRef = ref;
                };
                return react_default.a.cloneElement(child, props);
            }
            // onMouseMove is only needed for non selected items
            props.onMouseMove = function () {
                return _this2.onChildMouseMove(child);
            };
            return react_default.a.cloneElement(child, props);
        });
    };
};

/* harmony default export */ var es6_AbstractMenu = (AbstractMenu);
// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/SubMenu.js
var SubMenu__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SubMenu__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SubMenu__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SubMenu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SubMenu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SubMenu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SubMenu_SubMenu = function (_AbstractMenu) {
    SubMenu__inherits(SubMenu, _AbstractMenu);

    function SubMenu(props) {
        SubMenu__classCallCheck(this, SubMenu);

        var _this = SubMenu__possibleConstructorReturn(this, (SubMenu.__proto__ || Object.getPrototypeOf(SubMenu)).call(this, props));

        _this.getMenuPosition = function () {
            var _window = window,
                innerWidth = _window.innerWidth,
                innerHeight = _window.innerHeight;

            var rect = _this.subMenu.getBoundingClientRect();
            var position = {};

            if (rect.bottom > innerHeight) {
                position.bottom = 0;
            } else {
                position.top = 0;
            }

            if (rect.right < innerWidth) {
                position.left = '100%';
            } else {
                position.right = '100%';
            }

            return position;
        };

        _this.getRTLMenuPosition = function () {
            var _window2 = window,
                innerHeight = _window2.innerHeight;

            var rect = _this.subMenu.getBoundingClientRect();
            var position = {};

            if (rect.bottom > innerHeight) {
                position.bottom = 0;
            } else {
                position.top = 0;
            }

            if (rect.left < 0) {
                position.left = '100%';
            } else {
                position.right = '100%';
            }

            return position;
        };

        _this.hideMenu = function () {
            if (_this.props.forceOpen) {
                _this.props.forceClose();
            }
            _this.setState({ visible: false, selectedItem: null });
            _this.unregisterHandlers();
        };

        _this.handleClick = function (event) {
            event.preventDefault();

            if (_this.props.disabled) return;

            callIfExists(_this.props.onClick, event, object_assign_default()({}, _this.props.data, store.data), store.target);

            if (_this.props.preventClose) return;

            hideMenu();
        };

        _this.handleMouseEnter = function () {
            if (_this.closetimer) clearTimeout(_this.closetimer);

            if (_this.props.disabled || _this.state.visible) return;

            _this.opentimer = setTimeout(function () {
                return _this.setState({
                    visible: true,
                    selectedItem: null
                });
            }, _this.props.hoverDelay);
        };

        _this.handleMouseLeave = function () {
            if (_this.opentimer) clearTimeout(_this.opentimer);

            if (!_this.state.visible) return;

            _this.closetimer = setTimeout(function () {
                return _this.setState({
                    visible: false,
                    selectedItem: null
                });
            }, _this.props.hoverDelay);
        };

        _this.menuRef = function (c) {
            _this.menu = c;
        };

        _this.subMenuRef = function (c) {
            _this.subMenu = c;
        };

        _this.registerHandlers = function () {
            document.removeEventListener('keydown', _this.props.parentKeyNavigationHandler);
            document.addEventListener('keydown', _this.handleKeyNavigation);
        };

        _this.unregisterHandlers = function () {
            document.removeEventListener('keydown', _this.handleKeyNavigation);
            document.addEventListener('keydown', _this.props.parentKeyNavigationHandler);
        };

        _this.state = object_assign_default()({}, _this.state, {
            visible: false
        });
        return _this;
    }

    SubMenu__createClass(SubMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.listenId = globalEventListener.register(function () {}, this.hideMenu);
        }
    }, {
        key: 'getSubMenuType',
        value: function getSubMenuType() {
            // eslint-disable-line class-methods-use-this
            return SubMenu;
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            this.isVisibilityChange = (this.state.visible !== nextState.visible || this.props.forceOpen !== nextProps.forceOpen) && !(this.state.visible && nextProps.forceOpen) && !(this.props.forceOpen && nextState.visible);
            return true;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            if (!this.isVisibilityChange) return;
            if (this.props.forceOpen || this.state.visible) {
                var wrapper = window.requestAnimationFrame || setTimeout;
                wrapper(function () {
                    var styles = _this2.props.rtl ? _this2.getRTLMenuPosition() : _this2.getMenuPosition();

                    _this2.subMenu.style.removeProperty('top');
                    _this2.subMenu.style.removeProperty('bottom');
                    _this2.subMenu.style.removeProperty('left');
                    _this2.subMenu.style.removeProperty('right');

                    if (hasOwnProp(styles, 'top')) _this2.subMenu.style.top = styles.top;
                    if (hasOwnProp(styles, 'left')) _this2.subMenu.style.left = styles.left;
                    if (hasOwnProp(styles, 'bottom')) _this2.subMenu.style.bottom = styles.bottom;
                    if (hasOwnProp(styles, 'right')) _this2.subMenu.style.right = styles.right;
                    _this2.subMenu.classList.add(cssClasses.menuVisible);

                    _this2.registerHandlers();
                    _this2.setState({ selectedItem: null });
                });
            } else {
                var cleanup = function cleanup() {
                    _this2.subMenu.removeEventListener('transitionend', cleanup);
                    _this2.subMenu.style.removeProperty('bottom');
                    _this2.subMenu.style.removeProperty('right');
                    _this2.subMenu.style.top = 0;
                    _this2.subMenu.style.left = '100%';
                    _this2.unregisterHandlers();
                };
                this.subMenu.addEventListener('transitionend', cleanup);
                this.subMenu.classList.remove(cssClasses.menuVisible);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.listenId) {
                globalEventListener.unregister(this.listenId);
            }

            if (this.opentimer) clearTimeout(this.opentimer);

            if (this.closetimer) clearTimeout(this.closetimer);

            this.unregisterHandlers();
        }
    }, {
        key: 'render',
        value: function render() {
            var _cx;

            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                title = _props.title,
                selected = _props.selected;
            var visible = this.state.visible;

            var menuProps = {
                ref: this.menuRef,
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
                className: classnames_default()(cssClasses.menuItem, cssClasses.subMenu),
                style: {
                    position: 'relative'
                }
            };
            var menuItemProps = {
                className: classnames_default()(cssClasses.menuItem, (_cx = {}, SubMenu__defineProperty(_cx, cssClasses.menuItemDisabled, disabled), SubMenu__defineProperty(_cx, cssClasses.menuItemActive, visible), SubMenu__defineProperty(_cx, cssClasses.menuItemSelected, selected), _cx)),
                onMouseMove: this.props.onMouseMove,
                onMouseOut: this.props.onMouseOut,
                onClick: this.handleClick
            };
            var subMenuProps = {
                ref: this.subMenuRef,
                style: {
                    position: 'absolute',
                    transition: 'opacity 1ms', // trigger transitionend event
                    top: 0,
                    left: '100%'
                },
                className: classnames_default()(cssClasses.menu, this.props.className)
            };

            return react_default.a.createElement(
                'nav',
                SubMenu__extends({}, menuProps, { role: 'menuitem', tabIndex: '-1', 'aria-haspopup': 'true' }),
                react_default.a.createElement(
                    'div',
                    menuItemProps,
                    title
                ),
                react_default.a.createElement(
                    'nav',
                    SubMenu__extends({}, subMenuProps, { role: 'menu', tabIndex: '-1' }),
                    this.renderChildren(children)
                )
            );
        }
    }]);

    return SubMenu;
}(es6_AbstractMenu);

SubMenu_SubMenu.propTypes = {
    children: prop_types_default.a.node.isRequired,
    title: prop_types_default.a.node.isRequired,
    className: prop_types_default.a.string,
    disabled: prop_types_default.a.bool,
    hoverDelay: prop_types_default.a.number,
    rtl: prop_types_default.a.bool,
    selected: prop_types_default.a.bool,
    onMouseMove: prop_types_default.a.func,
    onMouseOut: prop_types_default.a.func,
    forceOpen: prop_types_default.a.bool,
    forceClose: prop_types_default.a.func,
    parentKeyNavigationHandler: prop_types_default.a.func
};
SubMenu_SubMenu.defaultProps = {
    disabled: false,
    hoverDelay: 500,
    className: '',
    rtl: false,
    selected: false,
    onMouseMove: function onMouseMove() {
        return null;
    },
    onMouseOut: function onMouseOut() {
        return null;
    },
    forceOpen: false,
    forceClose: function forceClose() {
        return null;
    },
    parentKeyNavigationHandler: function parentKeyNavigationHandler() {
        return null;
    }
};
/* harmony default export */ var es6_SubMenu = (SubMenu_SubMenu);
// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/ContextMenu.js
var ContextMenu__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ContextMenu__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ContextMenu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ContextMenu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ContextMenu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ContextMenu_ContextMenu = function (_AbstractMenu) {
    ContextMenu__inherits(ContextMenu, _AbstractMenu);

    function ContextMenu(props) {
        ContextMenu__classCallCheck(this, ContextMenu);

        var _this = ContextMenu__possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call(this, props));

        _this.registerHandlers = function () {
            document.addEventListener('mousedown', _this.handleOutsideClick);
            document.addEventListener('ontouchstart', _this.handleOutsideClick);
            document.addEventListener('scroll', _this.handleHide);
            document.addEventListener('contextmenu', _this.handleHide);
            document.addEventListener('keydown', _this.handleKeyNavigation);
            window.addEventListener('resize', _this.handleHide);
        };

        _this.unregisterHandlers = function () {
            document.removeEventListener('mousedown', _this.handleOutsideClick);
            document.removeEventListener('ontouchstart', _this.handleOutsideClick);
            document.removeEventListener('scroll', _this.handleHide);
            document.removeEventListener('contextmenu', _this.handleHide);
            document.removeEventListener('keydown', _this.handleKeyNavigation);
            window.removeEventListener('resize', _this.handleHide);
        };

        _this.handleShow = function (e) {
            if (e.detail.id !== _this.props.id || _this.state.isVisible) return;

            var _e$detail$position = e.detail.position,
                x = _e$detail$position.x,
                y = _e$detail$position.y;


            _this.setState({ isVisible: true, x: x, y: y });
            _this.registerHandlers();
            callIfExists(_this.props.onShow, e);
        };

        _this.handleHide = function (e) {
            if (_this.state.isVisible && (!e.detail || !e.detail.id || e.detail.id === _this.props.id)) {
                _this.unregisterHandlers();
                _this.setState({ isVisible: false, selectedItem: null, forceSubMenuOpen: false });
                callIfExists(_this.props.onHide, e);
            }
        };

        _this.handleOutsideClick = function (e) {
            if (!_this.menu.contains(e.target)) hideMenu();
        };

        _this.handleMouseLeave = function (event) {
            event.preventDefault();

            callIfExists(_this.props.onMouseLeave, event, object_assign_default()({}, _this.props.data, store.data), store.target);

            if (_this.props.hideOnLeave) hideMenu();
        };

        _this.handleContextMenu = function (e) {
            if (true) {
                e.preventDefault();
            }
            _this.handleHide(e);
        };

        _this.hideMenu = function (e) {
            if (e.keyCode === 27 || e.keyCode === 13) {
                // ECS or enter
                hideMenu();
            }
        };

        _this.getMenuPosition = function () {
            var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var menuStyles = {
                top: y,
                left: x
            };

            if (!_this.menu) return menuStyles;

            var _window = window,
                innerWidth = _window.innerWidth,
                innerHeight = _window.innerHeight;

            var rect = _this.menu.getBoundingClientRect();

            if (y + rect.height > innerHeight) {
                menuStyles.top -= rect.height;
            }

            if (x + rect.width > innerWidth) {
                menuStyles.left -= rect.width;
            }

            if (menuStyles.top < 0) {
                menuStyles.top = rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
            }

            if (menuStyles.left < 0) {
                menuStyles.left = rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
            }

            return menuStyles;
        };

        _this.menuRef = function (c) {
            _this.menu = c;
        };

        _this.state = object_assign_default()({}, _this.state, {
            x: 0,
            y: 0,
            isVisible: false
        });
        return _this;
    }

    ContextMenu__createClass(ContextMenu, [{
        key: 'getSubMenuType',
        value: function getSubMenuType() {
            // eslint-disable-line class-methods-use-this
            return es6_SubMenu;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.listenId = globalEventListener.register(this.handleShow, this.handleHide);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            if (this.state.isVisible) {
                var wrapper = window.requestAnimationFrame || setTimeout;

                wrapper(function () {
                    var _state = _this2.state,
                        x = _state.x,
                        y = _state.y;

                    var _getMenuPosition = _this2.getMenuPosition(x, y),
                        top = _getMenuPosition.top,
                        left = _getMenuPosition.left;

                    wrapper(function () {
                        if (!_this2.menu) return;
                        _this2.menu.style.top = top + 'px';
                        _this2.menu.style.left = left + 'px';
                        _this2.menu.style.opacity = 1;
                        _this2.menu.style.pointerEvents = 'auto';
                    });
                });
            } else {
                if (!this.menu) return;
                this.menu.style.opacity = 0;
                this.menu.style.pointerEvents = 'none';
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.listenId) {
                globalEventListener.unregister(this.listenId);
            }

            this.unregisterHandlers();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                style = _props.style;
            var isVisible = this.state.isVisible;

            var inlineStyle = object_assign_default()({}, style, { position: 'fixed', opacity: 0, pointerEvents: 'none' });
            var menuClassnames = classnames_default()(cssClasses.menu, className, ContextMenu__defineProperty({}, cssClasses.menuVisible, isVisible));

            return react_default.a.createElement(
                'nav',
                {
                    role: 'menu', tabIndex: '-1', ref: this.menuRef, style: inlineStyle, className: menuClassnames,
                    onContextMenu: this.handleContextMenu, onMouseLeave: this.handleMouseLeave },
                this.renderChildren(children)
            );
        }
    }]);

    return ContextMenu;
}(es6_AbstractMenu);

ContextMenu_ContextMenu.propTypes = {
    id: prop_types_default.a.string.isRequired,
    children: prop_types_default.a.node.isRequired,
    data: prop_types_default.a.object,
    className: prop_types_default.a.string,
    hideOnLeave: prop_types_default.a.bool,
    onHide: prop_types_default.a.func,
    onMouseLeave: prop_types_default.a.func,
    onShow: prop_types_default.a.func,
    style: prop_types_default.a.object
};
ContextMenu_ContextMenu.defaultProps = {
    className: '',
    data: {},
    hideOnLeave: false,
    onHide: function onHide() {
        return null;
    },
    onMouseLeave: function onMouseLeave() {
        return null;
    },
    onShow: function onShow() {
        return null;
    },

    style: {}
};
/* harmony default export */ var es6_ContextMenu = (ContextMenu_ContextMenu);
// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/ContextMenuTrigger.js
var ContextMenuTrigger__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ContextMenuTrigger__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ContextMenuTrigger__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ContextMenuTrigger__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ContextMenuTrigger_ContextMenuTrigger = function (_Component) {
    ContextMenuTrigger__inherits(ContextMenuTrigger, _Component);

    function ContextMenuTrigger() {
        var _ref;

        var _temp, _this, _ret;

        ContextMenuTrigger__classCallCheck(this, ContextMenuTrigger);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = ContextMenuTrigger__possibleConstructorReturn(this, (_ref = ContextMenuTrigger.__proto__ || Object.getPrototypeOf(ContextMenuTrigger)).call.apply(_ref, [this].concat(args))), _this), _this.touchHandled = false, _this.handleMouseDown = function (event) {
            if (_this.props.holdToDisplay >= 0 && event.button === 0) {
                event.persist();
                event.stopPropagation();

                _this.mouseDownTimeoutId = setTimeout(function () {
                    return _this.handleContextClick(event);
                }, _this.props.holdToDisplay);
            }
            callIfExists(_this.props.attributes.onMouseDown, event);
        }, _this.handleMouseUp = function (event) {
            if (event.button === 0) {
                clearTimeout(_this.mouseDownTimeoutId);
            }
            callIfExists(_this.props.attributes.onMouseUp, event);
        }, _this.handleMouseOut = function (event) {
            if (event.button === 0) {
                clearTimeout(_this.mouseDownTimeoutId);
            }
            callIfExists(_this.props.attributes.onMouseOut, event);
        }, _this.handleTouchstart = function (event) {
            _this.touchHandled = false;

            if (_this.props.holdToDisplay >= 0) {
                event.persist();
                event.stopPropagation();

                _this.touchstartTimeoutId = setTimeout(function () {
                    _this.handleContextClick(event);
                    _this.touchHandled = true;
                }, _this.props.holdToDisplay);
            }
            callIfExists(_this.props.attributes.onTouchStart, event);
        }, _this.handleTouchEnd = function (event) {
            if (_this.touchHandled) {
                event.preventDefault();
            }
            clearTimeout(_this.touchstartTimeoutId);
            callIfExists(_this.props.attributes.onTouchEnd, event);
        }, _this.handleContextMenu = function (event) {
            _this.handleContextClick(event);
            callIfExists(_this.props.attributes.onContextMenu, event);
        }, _this.handleContextClick = function (event) {
            if (_this.props.disable) return;

            event.preventDefault();
            event.stopPropagation();

            var x = event.clientX || event.touches && event.touches[0].pageX;
            var y = event.clientY || event.touches && event.touches[0].pageY;

            hideMenu();

            var data = callIfExists(_this.props.collect, _this.props);
            var showMenuConfig = {
                position: { x: x, y: y },
                target: _this.elem,
                id: _this.props.id,
                data: data
            };
            if (data && typeof data.then === 'function') {
                // it's promise
                data.then(function (resp) {
                    showMenuConfig.data = resp;
                    showMenu(showMenuConfig);
                });
            } else {
                showMenu(showMenuConfig);
            }
        }, _this.elemRef = function (c) {
            _this.elem = c;
        }, _temp), ContextMenuTrigger__possibleConstructorReturn(_this, _ret);
    }

    ContextMenuTrigger__createClass(ContextMenuTrigger, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                renderTag = _props.renderTag,
                attributes = _props.attributes,
                children = _props.children;

            var newAttrs = object_assign_default()({}, attributes, {
                className: classnames_default()(cssClasses.menuWrapper, attributes.className),
                onContextMenu: this.handleContextMenu,
                onMouseDown: this.handleMouseDown,
                onMouseUp: this.handleMouseUp,
                onTouchStart: this.handleTouchstart,
                onTouchEnd: this.handleTouchEnd,
                onMouseOut: this.handleMouseOut,
                ref: this.elemRef
            });

            return react_default.a.createElement(renderTag, newAttrs, children);
        }
    }]);

    return ContextMenuTrigger;
}(react["Component"]);

ContextMenuTrigger_ContextMenuTrigger.propTypes = {
    id: prop_types_default.a.string.isRequired,
    children: prop_types_default.a.node.isRequired,
    attributes: prop_types_default.a.object,
    collect: prop_types_default.a.func,
    disable: prop_types_default.a.bool,
    holdToDisplay: prop_types_default.a.number,
    renderTag: prop_types_default.a.oneOfType([prop_types_default.a.node, prop_types_default.a.func])
};
ContextMenuTrigger_ContextMenuTrigger.defaultProps = {
    attributes: {},
    collect: function collect() {
        return null;
    },

    disable: false,
    holdToDisplay: 1000,
    renderTag: 'div'
};
/* harmony default export */ var es6_ContextMenuTrigger = (ContextMenuTrigger_ContextMenuTrigger);
// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/connectMenu.js
var connectMenu__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var connectMenu__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function connectMenu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function connectMenu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function connectMenu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






// collect ContextMenuTrigger's expected props to NOT pass them on as part of the context
var ignoredTriggerProps = [].concat(_toConsumableArray(Object.keys(es6_ContextMenuTrigger.propTypes)), ['children']);

// expect the id of the menu to be responsible for as outer parameter
/* harmony default export */ var connectMenu = (function (menuId) {
    // expect menu component to connect as inner parameter
    // <Child/> is presumably a wrapper of <ContextMenu/>
    return function (Child) {
        // return wrapper for <Child/> that forwards the ContextMenuTrigger's additional props
        return function (_Component) {
            connectMenu__inherits(ConnectMenu, _Component);

            function ConnectMenu(props) {
                connectMenu__classCallCheck(this, ConnectMenu);

                var _this = connectMenu__possibleConstructorReturn(this, (ConnectMenu.__proto__ || Object.getPrototypeOf(ConnectMenu)).call(this, props));

                _this.handleShow = function (e) {
                    if (e.detail.id !== menuId) return;

                    // the onShow event's detail.data object holds all ContextMenuTrigger props
                    var data = e.detail.data;

                    var filteredData = {};

                    for (var key in data) {
                        // exclude props the ContextMenuTrigger is expecting itself
                        if (!ignoredTriggerProps.includes(key)) {
                            filteredData[key] = data[key];
                        }
                    }
                    _this.setState({ trigger: filteredData });
                };

                _this.handleHide = function () {
                    _this.setState({ trigger: null });
                };

                _this.state = { trigger: null };
                return _this;
            }

            connectMenu__createClass(ConnectMenu, [{
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.listenId = globalEventListener.register(this.handleShow, this.handleHide);
                }
            }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (this.listenId) {
                        globalEventListener.unregister(this.listenId);
                    }
                }
            }, {
                key: 'render',
                value: function render() {
                    return react_default.a.createElement(Child, connectMenu__extends({}, this.props, { id: menuId, trigger: this.state.trigger }));
                }
            }]);

            return ConnectMenu;
        }(react["Component"]);
    };
});
// CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ContextMenu", function() { return es6_ContextMenu; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ContextMenuTrigger", function() { return es6_ContextMenuTrigger; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MenuItem", function() { return es6_MenuItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SubMenu", function() { return es6_SubMenu; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "connectMenu", function() { return connectMenu; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "hideMenu", function() { return hideMenu; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "showMenu", function() { return showMenu; });







/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _index = __webpack_require__(19);

var _channels = __webpack_require__(783);

var _general = __webpack_require__(113);

var _preferences = __webpack_require__(784);

var _users = __webpack_require__(777);

var _teams = __webpack_require__(274);

var _constants = __webpack_require__(29);

var _lhs = __webpack_require__(958);

var _lhs2 = __webpack_require__(1083);

var _sidebar = __webpack_require__(2375);

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var currentChannel = (0, _channels.getCurrentChannel)(state);
    var currentTeammate = currentChannel && currentChannel.teammate_id && (0, _channels.getCurrentChannel)(state, currentChannel.teammate_id);
    var publicChannelIds = void 0;
    var privateChannelIds = void 0;
    var favoriteChannelIds = void 0;
    var directAndGroupChannelIds = void 0;

    var showUnreadSection = config.ExperimentalGroupUnreadChannels !== _constants.GroupUnreadChannels.DISABLED && (0, _preferences.getBool)(state, _index.Preferences.CATEGORY_SIDEBAR_SETTINGS, 'show_unread_section', config.ExperimentalGroupUnreadChannels === _constants.GroupUnreadChannels.DEFAULT_ON);

    var keepChannelIdAsUnread = state.views.channel.keepChannelIdAsUnread;

    if (showUnreadSection) {
        publicChannelIds = (0, _channels.getSortedPublicChannelIds)(state, keepChannelIdAsUnread);
        privateChannelIds = (0, _channels.getSortedPrivateChannelIds)(state, keepChannelIdAsUnread);
        favoriteChannelIds = (0, _channels.getSortedFavoriteChannelIds)(state, keepChannelIdAsUnread);
        directAndGroupChannelIds = (0, _channels.getSortedDirectChannelIds)(state, keepChannelIdAsUnread);
    } else {
        publicChannelIds = (0, _channels.getSortedPublicChannelWithUnreadsIds)(state);
        privateChannelIds = (0, _channels.getSortedPrivateChannelWithUnreadsIds)(state);
        favoriteChannelIds = (0, _channels.getSortedFavoriteChannelWithUnreadsIds)(state);
        directAndGroupChannelIds = (0, _channels.getSortedDirectChannelWithUnreadsIds)(state);
    }

    return {
        config: config,
        isOpen: (0, _lhs2.getIsLhsOpen)(state),
        showUnreadSection: showUnreadSection,
        publicChannelIds: publicChannelIds,
        privateChannelIds: privateChannelIds,
        favoriteChannelIds: favoriteChannelIds,
        directAndGroupChannelIds: directAndGroupChannelIds,
        unreadChannelIds: (0, _channels.getSortedUnreadChannelIds)(state, keepChannelIdAsUnread),
        currentChannel: currentChannel,
        currentTeammate: currentTeammate,
        currentTeam: (0, _teams.getCurrentTeam)(state),
        currentUser: (0, _users.getCurrentUser)(state),
        unreads: (0, _channels.getUnreads)(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            close: _lhs.close
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_sidebar2.default);

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = __webpack_require__(835);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _permissions = __webpack_require__(279);

var _permissions2 = _interopRequireDefault(_permissions);

var _classnames = __webpack_require__(769);

var _classnames2 = _interopRequireDefault(_classnames);

var _browser_history = __webpack_require__(273);

var _diagnostics_actions = __webpack_require__(804);

var _channel_actions = __webpack_require__(809);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _channel_utils = __webpack_require__(830);

var ChannelUtils = _interopRequireWildcard(_channel_utils);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _favicon16x = __webpack_require__(311);

var _favicon16x2 = _interopRequireDefault(_favicon16x);

var _redfavicon16x = __webpack_require__(2376);

var _redfavicon16x2 = _interopRequireDefault(_redfavicon16x);

var _more_channels = __webpack_require__(2377);

var _more_channels2 = _interopRequireDefault(_more_channels);

var _more_direct_channels = __webpack_require__(1084);

var _more_direct_channels2 = _interopRequireDefault(_more_direct_channels);

var _team_permission_gate = __webpack_require__(864);

var _team_permission_gate2 = _interopRequireDefault(_team_permission_gate);

var _new_channel_flow = __webpack_require__(2383);

var _new_channel_flow2 = _interopRequireDefault(_new_channel_flow);

var _unread_channel_indicator = __webpack_require__(2388);

var _unread_channel_indicator2 = _interopRequireDefault(_unread_channel_indicator);

var _header = __webpack_require__(2389);

var _header2 = _interopRequireDefault(_header);

var _sidebar_channel = __webpack_require__(2397);

var _sidebar_channel2 = _interopRequireDefault(_sidebar_channel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Sidebar = function (_React$PureComponent) {
    (0, _inherits3.default)(Sidebar, _React$PureComponent);

    function Sidebar(props) {
        (0, _classCallCheck3.default)(this, Sidebar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Sidebar.__proto__ || (0, _getPrototypeOf2.default)(Sidebar)).call(this, props));

        _initialiseProps.call(_this);

        _this.badgesActive = false;
        _this.firstUnreadChannel = null;
        _this.lastUnreadChannel = null;

        _this.isLeaving = new _map2.default();
        _this.isSwitchingChannel = false;
        _this.closedDirectChannel = false;

        _this.state = {
            newChannelModalType: '',
            showDirectChannelsModal: false,
            showMoreChannelsModal: false
        };
        return _this;
    }

    (0, _createClass3.default)(Sidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateUnreadIndicators();
            document.addEventListener('keydown', this.navigateChannelShortcut);
            document.addEventListener('keydown', this.navigateUnreadChannelShortcut);
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate() {
            this.updateUnreadIndicators();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // if the active channel disappeared (which can happen when dm channels autoclose), go to town square
            if (this.props.currentTeam === prevProps.currentTeam && this.props.currentChannel.id === prevProps.currentChannel.id && !this.channelIdIsDisplayedForProps(this.props, this.props.currentChannel.id) && this.channelIdIsDisplayedForProps(prevProps, this.props.currentChannel.id)) {
                this.closedDirectChannel = true;
                _browser_history.browserHistory.push('/' + this.props.currentTeam.name + '/channels/' + _constants.Constants.DEFAULT_CHANNEL);
                return;
            }

            if (!Utils.isMobile()) {
                (0, _jquery2.default)('.sidebar--left .nav-pills__container').perfectScrollbar();
            }

            // reset the scrollbar upon switching teams
            if (this.props.currentTeam !== prevProps.currentTeam) {
                this.refs.container.scrollTop = 0;
                (0, _jquery2.default)('.nav-pills__container').perfectScrollbar('update');
            }

            // close the LHS on mobile when you change channels
            if (this.props.currentChannel.id !== prevProps.currentChannel.id) {
                if (this.closedDirectChannel) {
                    this.closedDirectChannel = false;
                } else {
                    this.props.actions.close();
                }
            }

            this.updateTitle();
            this.setBadgesActiveAndFavicon();
            this.setFirstAndLastUnreadChannels();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.navigateChannelShortcut);
            document.removeEventListener('keydown', this.navigateUnreadChannelShortcut);
        }
    }, {
        key: 'setBadgesActiveAndFavicon',
        value: function setBadgesActiveAndFavicon() {
            this.lastBadgesActive = this.badgesActive;
            this.badgesActive = this.props.unreads.mentions;

            // update the favicon to show if there are any notifications
            if (this.lastBadgesActive !== this.badgesActive) {
                var link = document.createElement('link');
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.id = 'favicon';
                if (this.badgesActive) {
                    link.href = _redfavicon16x2.default;
                } else {
                    link.href = _favicon16x2.default;
                }
                var head = document.getElementsByTagName('head')[0];
                var oldLink = document.getElementById('favicon');
                if (oldLink) {
                    head.removeChild(oldLink);
                }
                head.appendChild(link);
            }
        }
    }, {
        key: 'setFirstAndLastUnreadChannels',
        value: function setFirstAndLastUnreadChannels() {
            var _this2 = this;

            var _props = this.props,
                currentChannel = _props.currentChannel,
                unreadChannelIds = _props.unreadChannelIds;


            this.getDisplayedChannels().map(function (channelId) {
                if (channelId !== currentChannel.id && unreadChannelIds.includes(channelId)) {
                    if (!_this2.firstUnreadChannel) {
                        _this2.firstUnreadChannel = channelId;
                    }
                    _this2.lastUnreadChannel = channelId;
                }
                return null;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                directAndGroupChannelIds = _props2.directAndGroupChannelIds,
                favoriteChannelIds = _props2.favoriteChannelIds,
                publicChannelIds = _props2.publicChannelIds,
                privateChannelIds = _props2.privateChannelIds,
                unreadChannelIds = _props2.unreadChannelIds,
                showUnreadSection = _props2.showUnreadSection;

            // Check if we have all info needed to render

            if (this.props.currentTeam == null || this.props.currentUser == null) {
                return _react2.default.createElement('div', null);
            }

            this.badgesActive = false;

            // keep track of the first and last unread channels so we can use them to set the unread indicators
            this.firstUnreadChannel = null;
            this.lastUnreadChannel = null;

            // create elements for all 5 types of channels
            var unreadChannelItems = showUnreadSection ? unreadChannelIds.map(this.createSidebarChannel) : [];
            var favoriteItems = favoriteChannelIds.map(this.createSidebarChannel);
            var publicChannelItems = publicChannelIds.map(this.createSidebarChannel);
            var privateChannelItems = privateChannelIds.map(this.createSidebarChannel);
            var directMessageItems = directAndGroupChannelIds.map(this.createSidebarChannel);

            var directMessageMore = _react2.default.createElement(
                'li',
                { key: 'more' },
                _react2.default.createElement(
                    'button',
                    {
                        id: 'moreDirectMessage',
                        className: 'nav-more cursor--pointer style--none btn--block',
                        onClick: this.handleOpenMoreDirectChannelsModal
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'sidebar.moreElips',
                        defaultMessage: 'More...'
                    })
                )
            );

            var showChannelModal = false;
            if (this.state.newChannelModalType !== '') {
                showChannelModal = true;
            }

            var createChannelTootlip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'new-channel-tooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'sidebar.createChannel',
                    defaultMessage: 'Create new public channel'
                })
            );
            var createGroupTootlip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'new-group-tooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'sidebar.createGroup',
                    defaultMessage: 'Create new private channel'
                })
            );

            var createDirectMessageTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                {
                    id: 'new-group-tooltip',
                    className: 'hidden-xs'
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'sidebar.createDirectMessage',
                    defaultMessage: 'Create new direct message'
                })
            );

            var above = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'sidebar.unreads',
                defaultMessage: 'More unreads'
            });

            var below = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'sidebar.unreads',
                defaultMessage: 'More unreads'
            });

            var tooltipTriggers = ['hover', 'focus'];

            if (Utils.isMobile()) {
                tooltipTriggers = [];
            }

            var createPublicChannelIcon = _react2.default.createElement(
                _reactBootstrap.OverlayTrigger,
                {
                    trigger: tooltipTriggers,
                    delayShow: 500,
                    placement: 'top',
                    overlay: createChannelTootlip
                },
                _react2.default.createElement(
                    'button',
                    {
                        id: 'createPublicChannel',
                        className: 'add-channel-btn cursor--pointer style--none',
                        onClick: this.showNewChannelModal.bind(this, _constants.Constants.OPEN_CHANNEL)
                    },
                    '+'
                )
            );

            var createPrivateChannelIcon = _react2.default.createElement(
                _reactBootstrap.OverlayTrigger,
                {
                    trigger: tooltipTriggers,
                    delayShow: 500,
                    placement: 'top',
                    overlay: createGroupTootlip
                },
                _react2.default.createElement(
                    'button',
                    {
                        id: 'createPrivateChannel',
                        className: 'add-channel-btn cursor--pointer style--none',
                        onClick: this.showNewChannelModal.bind(this, _constants.Constants.PRIVATE_CHANNEL)
                    },
                    '+'
                )
            );

            var createDirectMessageIcon = _react2.default.createElement(
                _reactBootstrap.OverlayTrigger,
                {
                    className: 'hidden-xs',
                    delayShow: 500,
                    placement: 'top',
                    overlay: createDirectMessageTooltip
                },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'add-channel-btn cursor--pointer style--none',
                        onClick: this.handleOpenMoreDirectChannelsModal
                    },
                    '+'
                )
            );

            var moreDirectChannelsModal = void 0;
            if (this.state.showDirectChannelsModal) {
                moreDirectChannelsModal = _react2.default.createElement(_more_direct_channels2.default, {
                    onModalDismissed: this.hideMoreDirectChannelsModal,
                    isExistingChannel: false
                });
            }

            var moreChannelsModal = void 0;
            if (this.state.showMoreChannelsModal) {
                moreChannelsModal = _react2.default.createElement(_more_channels2.default, {
                    onModalDismissed: this.hideMoreChannelsModal,
                    handleNewChannel: function handleNewChannel() {
                        _this3.hideMoreChannelsModal();
                        _this3.showNewChannelModal(_constants.Constants.OPEN_CHANNEL);
                    }
                });
            }

            var quickSwitchTextShortcutId = 'quick_switch_modal.channelsShortcut.windows';
            var quickSwitchTextShortcutDefault = '- CTRL+K';
            if (Utils.isMac()) {
                quickSwitchTextShortcutId = 'quick_switch_modal.channelsShortcut.mac';
                quickSwitchTextShortcutDefault = '- ⌘K';
            }

            var quickSwitchTextShortcut = _react2.default.createElement(
                'span',
                { className: 'switch__shortcut hidden-xs' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: quickSwitchTextShortcutId,
                    defaultMessage: quickSwitchTextShortcutDefault
                })
            );

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('sidebar--left', { 'move--right': this.props.isOpen && Utils.isMobile() }),
                    id: 'sidebar-left',
                    key: 'sidebar-left'
                },
                _react2.default.createElement(_new_channel_flow2.default, {
                    show: showChannelModal,
                    channelType: this.state.newChannelModalType,
                    onModalDismissed: this.hideNewChannelModal
                }),
                moreDirectChannelsModal,
                moreChannelsModal,
                _react2.default.createElement(_header2.default, {
                    teamId: this.props.currentTeam.id,
                    teamDisplayName: this.props.currentTeam.display_name,
                    teamDescription: this.props.currentTeam.description,
                    teamName: this.props.currentTeam.name,
                    teamType: this.props.currentTeam.type,
                    currentUser: this.props.currentUser
                }),
                _react2.default.createElement(_unread_channel_indicator2.default, {
                    name: 'Top',
                    show: this.state.showTopUnread,
                    onClick: this.scrollToFirstUnreadChannel,
                    extraClass: 'nav-pills__unread-indicator-top',
                    content: above
                }),
                _react2.default.createElement(_unread_channel_indicator2.default, {
                    name: 'Bottom',
                    show: this.state.showBottomUnread,
                    onClick: this.scrollToLastUnreadChannel,
                    extraClass: 'nav-pills__unread-indicator-bottom',
                    content: below
                }),
                _react2.default.createElement(
                    'div',
                    {
                        id: 'sidebarChannelContainer',
                        ref: 'container',
                        className: 'nav-pills__container',
                        onScroll: this.onScroll
                    },
                    unreadChannelItems.length !== 0 && _react2.default.createElement(
                        'ul',
                        { className: 'nav nav-pills nav-stacked' },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                { id: 'favoriteChannel' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar.unreadSection',
                                    defaultMessage: 'UNREADS'
                                })
                            )
                        ),
                        unreadChannelItems
                    ),
                    favoriteItems.length !== 0 && _react2.default.createElement(
                        'ul',
                        { className: 'nav nav-pills nav-stacked' },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                { id: 'favoriteChannel' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar.favorite',
                                    defaultMessage: 'FAVORITE CHANNELS'
                                })
                            )
                        ),
                        favoriteItems
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'nav nav-pills nav-stacked' },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                { id: 'publicChannel' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar.channels',
                                    defaultMessage: 'PUBLIC CHANNELS'
                                }),
                                _react2.default.createElement(
                                    _team_permission_gate2.default,
                                    {
                                        teamId: this.props.currentTeam.id,
                                        permissions: [_permissions2.default.CREATE_PUBLIC_CHANNEL]
                                    },
                                    createPublicChannelIcon
                                )
                            )
                        ),
                        publicChannelItems,
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'button',
                                {
                                    id: 'sidebarChannelsMore',
                                    className: 'nav-more cursor--pointer style--none btn--block',
                                    onClick: this.showMoreChannelsModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar.moreElips',
                                    defaultMessage: 'More...'
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'nav nav-pills nav-stacked' },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                { id: 'privateChannel' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar.pg',
                                    defaultMessage: 'PRIVATE CHANNELS'
                                }),
                                _react2.default.createElement(
                                    _team_permission_gate2.default,
                                    {
                                        teamId: this.props.currentTeam.id,
                                        permissions: [_permissions2.default.CREATE_PRIVATE_CHANNEL]
                                    },
                                    createPrivateChannelIcon
                                )
                            )
                        ),
                        privateChannelItems
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'nav nav-pills nav-stacked' },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                { id: 'directChannel' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'sidebar.direct',
                                    defaultMessage: 'DIRECT MESSAGES'
                                }),
                                createDirectMessageIcon
                            )
                        ),
                        directMessageItems,
                        directMessageMore
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sidebar__switcher' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'sidebarSwitcherButton',
                            className: 'btn btn-link',
                            onClick: this.openQuickSwitcher
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_switch_modal.title',
                            defaultMessage: 'Switch Channels'
                        }),
                        quickSwitchTextShortcut
                    )
                )
            );
        }
    }]);
    return Sidebar;
}(_react2.default.PureComponent);

Sidebar.propTypes = {

    /**
     * Global config object
     */
    config: _propTypes.PropTypes.object.isRequired,

    isOpen: _propTypes.PropTypes.bool.isRequired,

    /**
     * List of public channels (ids)
     */
    publicChannelIds: _propTypes.PropTypes.array.isRequired,

    /**
     * List of private channels (ids)
     */
    privateChannelIds: _propTypes.PropTypes.array.isRequired,

    /**
     * List of favorite channels (ids)
     */
    favoriteChannelIds: _propTypes.PropTypes.array.isRequired,

    /**
     * List of direct/group channels (ids)
     */
    directAndGroupChannelIds: _propTypes.PropTypes.array.isRequired,

    /**
     * List of unread channels (ids)
     */
    unreadChannelIds: _propTypes.PropTypes.array.isRequired,

    /**
     * Current channel object
     */
    currentChannel: _propTypes.PropTypes.object,

    /**
     * Current channel teammeat (for direct messages)
     */
    currentTeammate: _propTypes.PropTypes.object,

    /**
     * Current team object
     */
    currentTeam: _propTypes.PropTypes.object,

    /**
     * Current user object
     */
    currentUser: _propTypes.PropTypes.object,

    /**
     * Number of unread mentions/messages
     */
    unreads: _propTypes.PropTypes.object.isRequired,

    /**
     * Flag to display the Unread channels section
     */
    showUnreadSection: _propTypes.PropTypes.bool.isRequired,

    actions: _propTypes.PropTypes.shape({
        close: _propTypes.PropTypes.func.isRequired
    }).isRequired
};
Sidebar.defaultProps = {
    currentChannel: {}
};

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.handleOpenMoreDirectChannelsModal = function (e) {
        e.preventDefault();
        if (_this4.state.showDirectChannelsModal) {
            _this4.hideMoreDirectChannelsModal();
        } else {
            _this4.showMoreDirectChannelsModal();
        }
    };

    this.updateTitle = function () {
        var _props3 = _this4.props,
            config = _props3.config,
            currentChannel = _props3.currentChannel,
            currentTeam = _props3.currentTeam,
            currentTeammate = _props3.currentTeammate,
            unreads = _props3.unreads;


        if (currentChannel && currentTeam) {
            var currentSiteName = '';
            if (config.SiteName != null) {
                currentSiteName = config.SiteName;
            }

            var currentChannelName = currentChannel.display_name;
            if (currentChannel.type === _constants.Constants.DM_CHANNEL) {
                if (currentTeammate != null) {
                    currentChannelName = currentTeammate.display_name;
                }
            }

            var mentionTitle = unreads.mentionCount > 0 ? '(' + unreads.mentionCount + ') ' : '';
            var unreadTitle = unreads.messageCount > 0 ? '* ' : '';
            document.title = mentionTitle + unreadTitle + currentChannelName + ' - ' + _this4.props.currentTeam.display_name + ' ' + currentSiteName;
        }
    };

    this.onScroll = function () {
        _this4.updateUnreadIndicators();
    };

    this.scrollToFirstUnreadChannel = function () {
        if (_this4.firstUnreadChannel) {
            var unreadMargin = 15;
            var container = (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this4.refs.container));
            var firstUnreadElement = (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this4.refs[_this4.firstUnreadChannel]));
            var scrollTop = container.scrollTop() + firstUnreadElement.position().top - unreadMargin;
            container.stop().animate({ scrollTop: scrollTop }, 500, 'swing');
        }
    };

    this.scrollToLastUnreadChannel = function () {
        if (_this4.lastUnreadChannel) {
            var unreadMargin = 15;
            var container = (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this4.refs.container));
            var lastUnreadElement = (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this4.refs[_this4.lastUnreadChannel]));
            var elementBottom = lastUnreadElement.position().top + lastUnreadElement.height();
            var scrollTop = container.scrollTop() + (elementBottom - container.height()) + unreadMargin;
            container.stop().animate({ scrollTop: scrollTop }, 500, 'swing');
        }
    };

    this.updateUnreadIndicators = function () {
        var container = (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this4.refs.container));

        var showTopUnread = false;
        var showBottomUnread = false;

        // Consider partially obscured channels as above/below
        var unreadMargin = 15;

        if (_this4.firstUnreadChannel) {
            var firstUnreadElement = (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this4.refs[_this4.firstUnreadChannel]));
            var fistUnreadPosition = firstUnreadElement ? firstUnreadElement.position() : null;

            if (fistUnreadPosition && fistUnreadPosition.top + firstUnreadElement.height() < unreadMargin) {
                showTopUnread = true;
            }
        }

        if (_this4.lastUnreadChannel) {
            var lastUnreadElement = (0, _jquery2.default)(_reactDom2.default.findDOMNode(_this4.refs[_this4.lastUnreadChannel]));
            var lastUnreadPosition = lastUnreadElement ? lastUnreadElement.position() : null;

            if (lastUnreadPosition && lastUnreadPosition.top > container.height() - unreadMargin) {
                showBottomUnread = true;
            }
        }

        _this4.setState({
            showTopUnread: showTopUnread,
            showBottomUnread: showBottomUnread
        });
    };

    this.updateScrollbarOnChannelChange = function (channelId) {
        var curChannel = _this4.refs[channelId].getWrappedInstance().refs.channel.getBoundingClientRect();
        if (curChannel.top - _constants.Constants.CHANNEL_SCROLL_ADJUSTMENT < 0 || curChannel.top + curChannel.height > _this4.refs.container.getBoundingClientRect().height) {
            _this4.refs.container.scrollTop = _this4.refs.container.scrollTop + (curChannel.top - _constants.Constants.CHANNEL_SCROLL_ADJUSTMENT);
            (0, _jquery2.default)('.nav-pills__container').perfectScrollbar('update');
        }
    };

    this.navigateChannelShortcut = function (e) {
        if (e.altKey && !e.shiftKey && (Utils.isKeyPressed(e, _constants.Constants.KeyCodes.UP) || Utils.isKeyPressed(e, _constants.Constants.KeyCodes.DOWN))) {
            e.preventDefault();

            if (_this4.isSwitchingChannel) {
                return;
            }

            _this4.isSwitchingChannel = true;
            var allChannelIds = _this4.getDisplayedChannels();
            var curChannelId = _this4.props.currentChannel.id;
            var curIndex = -1;
            for (var i = 0; i < allChannelIds.length; i++) {
                if (allChannelIds[i] === curChannelId) {
                    curIndex = i;
                }
            }
            var nextIndex = curIndex;
            if (Utils.isKeyPressed(e, _constants.Constants.KeyCodes.DOWN)) {
                nextIndex = curIndex + 1;
            } else {
                nextIndex = curIndex - 1;
            }
            var nextChannelId = allChannelIds[Utils.mod(nextIndex, allChannelIds.length)];
            (0, _channel_actions.goToChannelById)(nextChannelId);
            _this4.updateScrollbarOnChannelChange(nextChannelId);
            _this4.isSwitchingChannel = false;
        } else if (Utils.cmdOrCtrlPressed(e) && e.shiftKey && Utils.isKeyPressed(e, _constants.Constants.KeyCodes.K)) {
            _this4.handleOpenMoreDirectChannelsModal(e);
        }
    };

    this.navigateUnreadChannelShortcut = function (e) {
        if (e.altKey && e.shiftKey && (Utils.isKeyPressed(e, _constants.Constants.KeyCodes.UP) || Utils.isKeyPressed(e, _constants.Constants.KeyCodes.DOWN))) {
            e.preventDefault();

            if (_this4.isSwitchingChannel) {
                return;
            }

            _this4.isSwitchingChannel = true;

            var allChannelIds = _this4.getDisplayedChannels();

            var direction = 0;
            if (Utils.isKeyPressed(e, _constants.Constants.KeyCodes.UP)) {
                direction = -1;
            } else {
                direction = 1;
            }

            var nextIndex = ChannelUtils.findNextUnreadChannelId(_this4.props.currentChannel.id, allChannelIds, _this4.props.unreadChannelIds, direction);

            if (nextIndex !== -1) {
                var nextChannelId = allChannelIds[nextIndex];
                (0, _channel_actions.goToChannelById)(nextChannelId);
                _this4.updateScrollbarOnChannelChange(nextChannelId);
            }

            _this4.isSwitchingChannel = false;
        }
    };

    this.getDisplayedChannels = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.props;

        if (props.showUnreadSection) {
            return props.unreadChannelIds.concat(props.favoriteChannelIds).concat(props.publicChannelIds).concat(props.privateChannelIds).concat(props.directAndGroupChannelIds);
        }

        return props.favoriteChannelIds.concat(props.publicChannelIds).concat(props.privateChannelIds).concat(props.directAndGroupChannelIds);
    };

    this.channelIdIsDisplayedForProps = function (props, id) {
        var allChannels = _this4.getDisplayedChannels(props);
        for (var i = 0; i < allChannels.length; i++) {
            if (allChannels[i] === id) {
                return true;
            }
        }
        return false;
    };

    this.showMoreChannelsModal = function () {
        _this4.setState({ showMoreChannelsModal: true });
        (0, _diagnostics_actions.trackEvent)('ui', 'ui_channels_more_public');
    };

    this.hideMoreChannelsModal = function () {
        _this4.setState({ showMoreChannelsModal: false });
    };

    this.showNewChannelModal = function (type) {
        _this4.setState({ newChannelModalType: type });
    };

    this.hideNewChannelModal = function () {
        _this4.setState({ newChannelModalType: '' });
    };

    this.showMoreDirectChannelsModal = function () {
        (0, _diagnostics_actions.trackEvent)('ui', 'ui_channels_more_direct');
        _this4.setState({ showDirectChannelsModal: true });
    };

    this.hideMoreDirectChannelsModal = function () {
        _this4.setState({ showDirectChannelsModal: false });
    };

    this.openQuickSwitcher = function (e) {
        e.preventDefault();
        _app_dispatcher2.default.handleViewAction({
            type: _constants.ActionTypes.TOGGLE_QUICK_SWITCH_MODAL
        });
    };

    this.createSidebarChannel = function (channelId) {
        return _react2.default.createElement(_sidebar_channel2.default, {
            key: channelId,
            ref: channelId,
            channelId: channelId,
            active: channelId === _this4.props.currentChannel.id,
            currentTeamName: _this4.props.currentTeam.name,
            currentUserId: _this4.props.currentUser.id
        });
    };
};

exports.default = Sidebar;

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b0d0ad99214c4723703614b6c6723e33.png";

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _channels = __webpack_require__(798);

var _more_channels = __webpack_require__(2378);

var _more_channels2 = _interopRequireDefault(_more_channels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getChannels: _channels.getChannels
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_more_channels2.default);

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = __webpack_require__(2379);

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _permissions = __webpack_require__(279);

var _permissions2 = _interopRequireDefault(_permissions);

var _browser_history = __webpack_require__(273);

var _channel_actions = __webpack_require__(809);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _searchable_channel_list = __webpack_require__(2381);

var _searchable_channel_list2 = _interopRequireDefault(_searchable_channel_list);

var _team_permission_gate = __webpack_require__(864);

var _team_permission_gate2 = _interopRequireDefault(_team_permission_gate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANNELS_CHUNK_SIZE = 50;
var CHANNELS_PER_PAGE = 50;
var SEARCH_TIMEOUT_MILLISECONDS = 100;

var MoreChannels = function (_React$Component) {
    (0, _inherits3.default)(MoreChannels, _React$Component);

    function MoreChannels(props) {
        (0, _classCallCheck3.default)(this, MoreChannels);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MoreChannels.__proto__ || (0, _getPrototypeOf2.default)(MoreChannels)).call(this, props));

        _this.handleHide = function () {
            _this.setState({ show: false });
        };

        _this.handleExit = function () {
            if (_this.props.onModalDismissed) {
                _this.props.onModalDismissed();
            }
        };

        _this.onChange = function (force) {
            if (_this.state.search && !force) {
                return;
            }

            _this.setState({
                channels: _channel_store2.default.getMoreChannelsList(),
                serverError: null
            });
        };

        _this.nextPage = function (page) {
            _this.props.actions.getChannels(_team_store2.default.getCurrentId(), page + 1, CHANNELS_PER_PAGE);
        };

        _this.handleJoin = function (channel, done) {
            (0, _channel_actions.joinChannel)(channel, function () {
                _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name);
                if (done) {
                    done();
                }

                _this.handleHide();
            }, function (err) {
                _this.setState({ serverError: err.message });
                if (done) {
                    done();
                }
            });
        };

        _this.search = function (term) {
            clearTimeout(_this.searchTimeoutId);

            if (term === '') {
                _this.onChange(true);
                _this.setState({ search: false });
                _this.searchTimeoutId = '';
                return;
            }

            var searchTimeoutId = setTimeout(function () {
                (0, _channel_actions.searchMoreChannels)(term, function (channels) {
                    if (searchTimeoutId !== _this.searchTimeoutId) {
                        return;
                    }
                    _this.setState({ search: true, channels: channels });
                });
            }, SEARCH_TIMEOUT_MILLISECONDS);

            _this.searchTimeoutId = searchTimeoutId;
        };

        _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);

        _this.searchTimeoutId = 0;

        _this.state = {
            show: true,
            search: false,
            channels: null,
            serverError: null
        };
        return _this;
    }

    (0, _createClass3.default)(MoreChannels, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _channel_store2.default.addChangeListener(this.onChange);
            this.props.actions.getChannels(_team_store2.default.getCurrentId(), 0, CHANNELS_CHUNK_SIZE * 2);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _channel_store2.default.removeChangeListener(this.onChange);
        }
    }, {
        key: 'render',
        value: function render() {
            var serverError = void 0;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.serverError
                    )
                );
            }

            var createNewChannelButton = _react2.default.createElement(
                _team_permission_gate2.default,
                {
                    teamId: _team_store2.default.getCurrentId(),
                    permissions: [_permissions2.default.CREATE_PUBLIC_CHANNEL]
                },
                _react2.default.createElement(
                    'button',
                    {
                        id: 'createNewChannel',
                        type: 'button',
                        className: 'btn btn-primary channel-create-btn',
                        onClick: this.props.handleNewChannel
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'more_channels.create',
                        defaultMessage: 'Create New Channel'
                    })
                )
            );

            var createChannelHelpText = _react2.default.createElement(
                _team_permission_gate2.default,
                {
                    teamId: _team_store2.default.getCurrentId(),
                    permissions: [_permissions2.default.CREATE_PUBLIC_CHANNEL]
                },
                _react2.default.createElement(
                    'p',
                    { className: 'secondary-message' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'more_channels.createClick',
                        defaultMessage: 'Click \'Create New Channel\' to make a new one'
                    })
                )
            );

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'more-modal more-modal--action',
                    show: this.state.show,
                    onHide: this.handleHide,
                    onExited: this.handleExit
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'more_channels.title',
                            defaultMessage: 'More Channels'
                        })
                    ),
                    createNewChannelButton
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react2.default.createElement(_searchable_channel_list2.default, {
                        channels: this.state.channels,
                        channelsPerPage: CHANNELS_PER_PAGE,
                        nextPage: this.nextPage,
                        isSearch: this.state.search,
                        search: this.search,
                        handleJoin: this.handleJoin,
                        noResultsText: createChannelHelpText
                    }),
                    serverError
                )
            );
        }
    }]);
    return MoreChannels;
}(_react2.default.Component);

MoreChannels.propTypes = {
    onModalDismissed: _propTypes2.default.func,
    handleNewChannel: _propTypes2.default.func,
    actions: _propTypes2.default.shape({
        getChannels: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = MoreChannels;

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var shallowEqual = __webpack_require__(2380);

module.exports = {
  shouldComponentUpdate: function(nextProps, nextState) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState)
    );
  }
};


/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _quick_input = __webpack_require__(1038);

var _quick_input2 = _interopRequireDefault(_quick_input);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var _load = __webpack_require__(865);

var _load2 = _interopRequireDefault(_load);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var NEXT_BUTTON_TIMEOUT_MILLISECONDS = 500;

var SearchableChannelList = function (_React$Component) {
    (0, _inherits3.default)(SearchableChannelList, _React$Component);

    function SearchableChannelList(props) {
        (0, _classCallCheck3.default)(this, SearchableChannelList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchableChannelList.__proto__ || (0, _getPrototypeOf2.default)(SearchableChannelList)).call(this, props));

        _this.createChannelRow = _this.createChannelRow.bind(_this);
        _this.nextPage = _this.nextPage.bind(_this);
        _this.previousPage = _this.previousPage.bind(_this);
        _this.doSearch = _this.doSearch.bind(_this);

        _this.nextTimeoutId = 0;

        _this.state = {
            joiningChannel: '',
            page: 0,
            nextDisabled: false
        };
        return _this;
    }

    (0, _createClass3.default)(SearchableChannelList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // only focus the search box on desktop so that we don't cause the keyboard to open on mobile
            if (!UserAgent.isMobile()) {
                this.refs.filter.focus();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevState.page !== this.state.page) {
                (0, _jquery2.default)(this.refs.channelList).scrollTop(0);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isSearch && !this.props.isSearch) {
                this.setState({ page: 0 });
            }
        }
    }, {
        key: 'handleJoin',
        value: function handleJoin(channel) {
            var _this2 = this;

            this.setState({ joiningChannel: channel.id });
            this.props.handleJoin(channel, function () {
                _this2.setState({ joiningChannel: '' });
            });
        }
    }, {
        key: 'createChannelRow',
        value: function createChannelRow(channel) {
            var joinButton = void 0;
            if (this.state.joiningChannel === channel.id) {
                joinButton = _react2.default.createElement('img', {
                    className: 'join-channel-loading-gif',
                    src: _load2.default
                });
            } else {
                joinButton = _react2.default.createElement(
                    'button',
                    {
                        onClick: this.handleJoin.bind(this, channel),
                        className: 'btn btn-primary',
                        disabled: this.state.joiningChannel !== '' && this.state.joiningChannel !== channel.id
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'more_channels.join',
                        defaultMessage: 'Join'
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    className: 'more-modal__row',
                    key: channel.id
                },
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__details' },
                    _react2.default.createElement(
                        'p',
                        { className: 'more-modal__name' },
                        channel.display_name
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'more-modal__description' },
                        channel.purpose
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__actions' },
                    joinButton
                )
            );
        }
    }, {
        key: 'nextPage',
        value: function nextPage(e) {
            var _this3 = this;

            e.preventDefault();
            this.setState({ page: this.state.page + 1, nextDisabled: true });
            this.nextTimeoutId = setTimeout(function () {
                return _this3.setState({ nextDisabled: false });
            }, NEXT_BUTTON_TIMEOUT_MILLISECONDS);
            this.props.nextPage(this.state.page + 1);
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.channelListScroll)).scrollTop(0);
        }
    }, {
        key: 'previousPage',
        value: function previousPage(e) {
            e.preventDefault();
            this.setState({ page: this.state.page - 1 });
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.channelListScroll)).scrollTop(0);
        }
    }, {
        key: 'doSearch',
        value: function doSearch() {
            var term = this.refs.filter.value;
            this.props.search(term);
            if (term === '') {
                this.setState({ page: 0 });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var channels = this.props.channels;
            var listContent = void 0;
            var nextButton = void 0;
            var previousButton = void 0;

            if (channels == null) {
                listContent = _react2.default.createElement(_loading_screen2.default, null);
            } else if (channels.length === 0) {
                listContent = _react2.default.createElement(
                    'div',
                    { className: 'no-channel-message' },
                    _react2.default.createElement(
                        'p',
                        { className: 'primary-message' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'more_channels.noMore',
                            defaultMessage: 'No more channels to join'
                        })
                    ),
                    this.props.noResultsText
                );
            } else {
                var pageStart = this.state.page * this.props.channelsPerPage;
                var pageEnd = pageStart + this.props.channelsPerPage;
                var channelsToDisplay = this.props.channels.slice(pageStart, pageEnd);
                listContent = channelsToDisplay.map(this.createChannelRow);

                if (channelsToDisplay.length >= this.props.channelsPerPage && pageEnd < this.props.channels.length) {
                    nextButton = _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-default filter-control filter-control__next',
                            onClick: this.nextPage,
                            disabled: this.state.nextDisabled
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'more_channels.next',
                            defaultMessage: 'Next'
                        })
                    );
                }

                if (this.state.page > 0) {
                    previousButton = _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-default filter-control filter-control__prev',
                            onClick: this.previousPage
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'more_channels.prev',
                            defaultMessage: 'Previous'
                        })
                    );
                }
            }

            return _react2.default.createElement(
                'div',
                { className: 'filtered-user-list' },
                _react2.default.createElement(
                    'div',
                    { className: 'filter-row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(_quick_input2.default, {
                            id: 'searchChannelsTextbox',
                            ref: 'filter',
                            className: 'form-control filter-textbox',
                            placeholder: (0, _utils.localizeMessage)('filtered_channels_list.search', 'Search channels'),
                            onInput: this.doSearch
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        ref: 'channelList',
                        className: 'more-modal__list'
                    },
                    _react2.default.createElement(
                        'div',
                        { ref: 'channelListScroll' },
                        listContent
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'filter-controls' },
                    previousButton,
                    nextButton
                )
            );
        }
    }]);
    return SearchableChannelList;
}(_react2.default.Component);

exports.default = SearchableChannelList;


SearchableChannelList.defaultProps = {
    channels: [],
    isSearch: false
};

SearchableChannelList.propTypes = {
    channels: _propTypes2.default.arrayOf(_propTypes2.default.object),
    channelsPerPage: _propTypes2.default.number,
    nextPage: _propTypes2.default.func.isRequired,
    isSearch: _propTypes2.default.bool,
    search: _propTypes2.default.func.isRequired,
    handleJoin: _propTypes2.default.func.isRequired,
    noResultsText: _propTypes2.default.object
};

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _users = __webpack_require__(777);

var _browser_history = __webpack_require__(273);

var _channel_actions = __webpack_require__(809);

var _user_actions = __webpack_require__(781);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var _multiselect = __webpack_require__(1050);

var _multiselect2 = _interopRequireDefault(_multiselect);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var USERS_PER_PAGE = 50;
var MAX_SELECTABLE_VALUES = _constants2.default.MAX_USERS_IN_GM - 1;

var MoreDirectChannels = function (_React$Component) {
    (0, _inherits3.default)(MoreDirectChannels, _React$Component);

    function MoreDirectChannels(props) {
        (0, _classCallCheck3.default)(this, MoreDirectChannels);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MoreDirectChannels.__proto__ || (0, _getPrototypeOf2.default)(MoreDirectChannels)).call(this, props));

        _this.setUsersLoadingState = function (loadingState) {
            _this.setState({
                loadingUsers: loadingState
            });
        };

        _this.resetPaging = function () {
            if (_this.refs.multiselect) {
                _this.refs.multiselect.resetPaging();
            }
        };

        _this.handleSubmitImmediatelyOn = function (value) {
            return value.id === _this.props.currentUserId || value.delete_at;
        };

        _this.handleHide = _this.handleHide.bind(_this);
        _this.handleExit = _this.handleExit.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleDelete = _this.handleDelete.bind(_this);
        _this.handlePageChange = _this.handlePageChange.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.search = _this.search.bind(_this);
        _this.addValue = _this.addValue.bind(_this);

        _this.searchTimeoutId = 0;
        _this.term = '';
        _this.listType = _this.props.restrictDirectMessage;

        var values = [];

        if (props.currentChannelMembers) {
            for (var i = 0; i < props.currentChannelMembers.length; i++) {
                var user = (0, _assign2.default)({}, props.currentChannelMembers[i]);

                if (user.id === props.currentUserId) {
                    continue;
                }

                values.push(user);
            }
        }

        _this.state = {
            users: null,
            values: values,
            show: true,
            search: false,
            saving: false,
            loadingUsers: true
        };
        return _this;
    }

    (0, _createClass3.default)(MoreDirectChannels, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _user_store2.default.addChangeListener(this.onChange);
            _user_store2.default.addInTeamChangeListener(this.onChange);
            _user_store2.default.addStatusesChangeListener(this.onChange);
            this.getUserProfiles();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeChangeListener(this.onChange);
            _user_store2.default.removeInTeamChangeListener(this.onChange);
            _user_store2.default.removeStatusesChangeListener(this.onChange);
        }
    }, {
        key: 'handleHide',
        value: function handleHide() {
            this.setState({ show: false });
        }
    }, {
        key: 'handleExit',
        value: function handleExit() {
            if (this.exitToChannel) {
                _browser_history.browserHistory.push(this.exitToChannel);
            }

            if (this.props.onModalDismissed) {
                this.props.onModalDismissed();
            }

            if (this.props.onHide) {
                this.props.onHide();
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            var _this2 = this;

            var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.values;

            if (this.state.saving) {
                return;
            }

            var userIds = values.map(function (v) {
                return v.id;
            });
            if (userIds.length === 0) {
                return;
            }

            this.setState({ saving: true });

            var success = function success(channel) {
                // Due to how react-overlays Modal handles focus, we delay pushing
                // the new channel information until the modal is fully exited.
                // The channel information will be pushed in `handleExit`
                _this2.exitToChannel = _team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name;
                _this2.setState({ saving: false });
                _this2.handleHide();
            };

            var error = function error() {
                _this2.setState({ saving: false });
            };

            if (userIds.length === 1) {
                (0, _channel_actions.openDirectChannelToUser)(userIds[0], success, error);
            } else {
                (0, _channel_actions.openGroupChannelToUsers)(userIds, success, error);
            }
        }
    }, {
        key: 'addValue',
        value: function addValue(value) {
            var values = (0, _assign2.default)([], this.state.values);

            if (values.indexOf(value) === -1) {
                values.push(value);
            }

            this.setState({ values: values });
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            var users = void 0;

            if (this.term) {
                if (this.listType === 'any') {
                    users = (0, _assign2.default)([], (0, _users.searchProfiles)(_redux_store2.default.getState(), this.term, false));
                } else {
                    users = (0, _assign2.default)([], (0, _users.searchProfilesInCurrentTeam)(_redux_store2.default.getState(), this.term, false));
                }
            } else if (this.listType === 'any') {
                users = (0, _assign2.default)([], _user_store2.default.getProfileList(false, true));
            } else {
                users = (0, _assign2.default)([], _user_store2.default.getProfileListInTeam(_team_store2.default.getCurrentId(), false, false));
            }

            for (var i = 0; i < users.length; i++) {
                var user = (0, _assign2.default)({}, users[i]);
                users[i] = user;
            }

            this.setState({
                users: users
            });
        }
    }, {
        key: 'getUserProfiles',
        value: function getUserProfiles(page) {
            var _this3 = this;

            var pageNum = page ? page + 1 : 0;
            if (this.listType === 'any') {
                this.props.actions.getProfiles(pageNum, USERS_PER_PAGE * 2).then(function () {
                    _this3.setUsersLoadingState(false);
                });
            } else {
                this.props.actions.getProfilesInTeam(_team_store2.default.getCurrentId(), pageNum, USERS_PER_PAGE * 2).then(function () {
                    _this3.setUsersLoadingState(false);
                });
            }
        }
    }, {
        key: 'handlePageChange',
        value: function handlePageChange(page, prevPage) {
            if (page > prevPage) {
                this.setUsersLoadingState(true);
                this.getUserProfiles(page);
            }
        }
    }, {
        key: 'search',
        value: function search(term) {
            var _this4 = this;

            clearTimeout(this.searchTimeoutId);
            this.term = term;

            if (term === '') {
                this.resetPaging();
                this.onChange();
                return;
            }

            var teamId = void 0;
            if (this.listType === 'any') {
                teamId = '';
            } else {
                teamId = _team_store2.default.getCurrentId();
            }

            this.searchTimeoutId = setTimeout(function () {
                _this4.setUsersLoadingState(true);
                (0, _user_actions.searchUsers)(term, teamId, {}, _this4.resetPaging).then(function () {
                    _this4.setUsersLoadingState(false);
                });
            }, _constants2.default.SEARCH_TIMEOUT_MILLISECONDS);
        }
    }, {
        key: 'handleDelete',
        value: function handleDelete(values) {
            this.setState({ values: values });
        }
    }, {
        key: 'renderOption',
        value: function renderOption(option, isSelected, onAdd) {
            var currentUser = _user_store2.default.getCurrentUser();
            var displayName = (0, _utils.displayEntireNameForUser)(option);

            var modalName = displayName;
            if (option.id === currentUser.id) {
                modalName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'more_direct_channels.directchannel.you',
                    defaultMessage: '{displayname} (you)',
                    values: {
                        displayname: displayName
                    }
                });
            } else if (option.delete_at) {
                modalName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'more_direct_channels.directchannel.deactivated',
                    defaultMessage: '{displayname} - Deactivated',
                    values: {
                        displayname: displayName
                    }
                });
            }

            var rowSelected = '';
            if (isSelected) {
                rowSelected = 'more-modal__row--selected';
            }

            var status = option.delete_at ? null : _user_store2.default.getStatus(option.id);

            return _react2.default.createElement(
                'div',
                {
                    key: option.id,
                    ref: isSelected ? 'selected' : option.id,
                    className: 'more-modal__row clickable ' + rowSelected,
                    onClick: function onClick() {
                        return onAdd(option);
                    }
                },
                _react2.default.createElement(_profile_picture2.default, {
                    src: _client.Client4.getProfilePictureUrl(option.id, option.last_picture_update),
                    status: status,
                    width: '32',
                    height: '32'
                }),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'more-modal__details'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'more-modal__name' },
                        modalName
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'more-modal__description' },
                        option.email
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__actions' },
                    _react2.default.createElement(
                        'div',
                        { className: 'more-modal__actions--round' },
                        _react2.default.createElement('i', { className: 'fa fa-plus' })
                    )
                )
            );
        }
    }, {
        key: 'renderValue',
        value: function renderValue(user) {
            return user.username;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var note = void 0;
            if (this.props.currentChannelMembers) {
                if (this.state.values && this.state.values.length >= MAX_SELECTABLE_VALUES) {
                    note = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'more_direct_channels.new_convo_note.full',
                        defaultMessage: 'You\u2019ve reached the maximum number of people for this conversation. Consider creating a private channel instead.'
                    });
                } else if (this.props.isExistingChannel) {
                    note = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'more_direct_channels.new_convo_note',
                        defaultMessage: 'This will start a new conversation. If you\u2019re adding a lot of people, consider creating a private channel instead.'
                    });
                }
            }

            var buttonSubmitText = (0, _utils.localizeMessage)('multiselect.go', 'Go');

            var numRemainingText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'multiselect.numPeopleRemaining',
                defaultMessage: 'Use \u2191\u2193 to browse, \u21B5 to select. You can add {num, number} more {num, plural, one {person} other {people}}. ',
                values: {
                    num: MAX_SELECTABLE_VALUES - this.state.values.length
                }
            });

            var users = this.state.users || [];

            if (this.state.values.length) {
                users = users.filter(function (user) {
                    return user.delete_at === 0 && user.id !== _this5.props.currentUserId;
                });
            } else {
                var active = [];
                var inactive = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(users), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var user = _step.value;

                        (user.delete_at ? inactive : active).push(user);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                users = active.concat(inactive);
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'more-modal more-direct-channels',
                    show: this.state.show,
                    onHide: this.handleHide,
                    onExited: this.handleExit
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'more_direct_channels.title',
                            defaultMessage: 'Direct Messages'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react2.default.createElement(_multiselect2.default, {
                        key: 'moreDirectChannelsList',
                        ref: 'multiselect',
                        options: users,
                        optionRenderer: this.renderOption,
                        values: this.state.values,
                        valueKey: 'id',
                        valueRenderer: this.renderValue,
                        perPage: USERS_PER_PAGE,
                        handlePageChange: this.handlePageChange,
                        handleInput: this.search,
                        handleDelete: this.handleDelete,
                        handleAdd: this.addValue,
                        handleSubmit: this.handleSubmit,
                        noteText: note,
                        maxValues: MAX_SELECTABLE_VALUES,
                        numRemainingText: numRemainingText,
                        buttonSubmitText: buttonSubmitText,
                        submitImmediatelyOn: this.handleSubmitImmediatelyOn,
                        saving: this.state.saving,
                        loading: this.state.loadingUsers
                    })
                )
            );
        }
    }]);
    return MoreDirectChannels;
}(_react2.default.Component);

MoreDirectChannels.propTypes = {

    /*
     * Current user's ID
     */
    currentUserId: _propTypes2.default.string.isRequired,

    /*
     * List of current channel members of existing channel
     */
    currentChannelMembers: _propTypes2.default.arrayOf(_propTypes2.default.object),

    /*
     * Whether the modal is for existing channel or not
     */
    isExistingChannel: _propTypes2.default.bool.isRequired,

    /*
     * The mode by which direct messages are restricted, if at all.
     */
    restrictDirectMessage: _propTypes2.default.string,

    /*
     * Function to call on modal dismissed
     */
    onModalDismissed: _propTypes2.default.func,

    /**
     * Function to call on modal hide
     */
    onHide: _propTypes2.default.func.isRequired,

    actions: _propTypes2.default.shape({

        /**
         * Function to get profiles
         */
        getProfiles: _propTypes2.default.func.isRequired,

        /**
         * Function to get profiles in team
         */
        getProfilesInTeam: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = MoreDirectChannels;

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHOW_EDIT_URL_THEN_COMPLETE = exports.SHOW_EDIT_URL = exports.SHOW_NEW_CHANNEL = undefined;

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _channel_actions = __webpack_require__(809);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _url = __webpack_require__(793);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _new_channel_modal = __webpack_require__(2384);

var _new_channel_modal2 = _interopRequireDefault(_new_channel_modal);

var _change_url_modal = __webpack_require__(2386);

var _change_url_modal2 = _interopRequireDefault(_change_url_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_NEW_CHANNEL = exports.SHOW_NEW_CHANNEL = 1; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SHOW_EDIT_URL = exports.SHOW_EDIT_URL = 2;
var SHOW_EDIT_URL_THEN_COMPLETE = exports.SHOW_EDIT_URL_THEN_COMPLETE = 3;

var NewChannelFlow = function (_React$Component) {
    (0, _inherits3.default)(NewChannelFlow, _React$Component);

    function NewChannelFlow(props) {
        (0, _classCallCheck3.default)(this, NewChannelFlow);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NewChannelFlow.__proto__ || (0, _getPrototypeOf2.default)(NewChannelFlow)).call(this, props));

        _this.onSubmit = function () {
            if (!_this.state.channelDisplayName) {
                _this.setState({ serverError: Utils.localizeMessage('channel_flow.invalidName', 'Invalid Channel Name') });
                return;
            }

            if (_this.state.channelName.length < 2) {
                _this.setState({ flowState: SHOW_EDIT_URL_THEN_COMPLETE });
                return;
            }

            var channel = {
                team_id: _team_store2.default.getCurrentId(),
                name: _this.state.channelName,
                display_name: _this.state.channelDisplayName,
                purpose: _this.state.channelPurpose,
                header: _this.state.channelHeader,
                type: _this.state.channelType
            };

            (0, _channel_actions.createChannel)(channel, function (data) {
                _this.doOnModalExited = function () {
                    _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + data.name);
                };

                _this.props.onModalDismissed();
            }, function (err) {
                if (err.id === 'model.channel.is_valid.2_or_more.app_error') {
                    _this.setState({
                        flowState: SHOW_EDIT_URL_THEN_COMPLETE,
                        serverError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_flow.handleTooShort',
                            defaultMessage: 'Channel URL must be 2 or more lowercase alphanumeric characters'
                        })
                    });
                } else if (err.id === 'store.sql_channel.update.exists.app_error') {
                    _this.setState({ serverError: Utils.localizeMessage('channel_flow.alreadyExist', 'A channel with that URL already exists') });
                } else {
                    _this.setState({ serverError: err.message });
                }
            });
        };

        _this.onModalExited = function () {
            if (_this.doOnModalExited) {
                _this.doOnModalExited();
            }
        };

        _this.typeSwitched = function (e) {
            e.preventDefault();

            var channelType = _constants2.default.PRIVATE_CHANNEL;
            if (_this.state.channelType === _constants2.default.PRIVATE_CHANNEL) {
                channelType = _constants2.default.OPEN_CHANNEL;
            }

            _this.setState({
                channelType: channelType,
                serverError: ''
            });
        };

        _this.urlChangeRequested = function (e) {
            if (e) {
                e.preventDefault();
            }
            _this.setState({ flowState: SHOW_EDIT_URL });
        };

        _this.urlChangeSubmitted = function (newURL) {
            if (_this.state.flowState === SHOW_EDIT_URL_THEN_COMPLETE) {
                _this.setState({ channelName: newURL, nameModified: true }, _this.onSubmit);
            } else {
                _this.setState({ flowState: SHOW_NEW_CHANNEL, serverError: null, channelName: newURL, nameModified: true });
            }
        };

        _this.urlChangeDismissed = function () {
            _this.setState({ flowState: SHOW_NEW_CHANNEL });
        };

        _this.channelDataChanged = function (data) {
            _this.setState({
                channelDisplayName: data.displayName,
                channelPurpose: data.purpose,
                channelHeader: data.header
            });
            if (!_this.state.nameModified) {
                _this.setState({ channelName: (0, _url.cleanUpUrlable)(data.displayName.trim()) });
            }
        };

        _this.state = {
            serverError: '',
            channelType: props.channelType || _constants2.default.OPEN_CHANNEL,
            flowState: SHOW_NEW_CHANNEL,
            channelDisplayName: '',
            channelName: '',
            channelPurpose: '',
            channelHeader: '',
            nameModified: false
        };
        return _this;
    }

    (0, _createClass3.default)(NewChannelFlow, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // If we are being shown, grab channel type from props and clear
            if (nextProps.show === true && this.props.show === false) {
                this.setState({
                    serverError: '',
                    channelType: nextProps.channelType,
                    flowState: SHOW_NEW_CHANNEL,
                    channelDisplayName: '',
                    channelName: '',
                    channelPurpose: '',
                    channelHeader: '',
                    nameModified: false
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var channelData = {
                name: this.state.channelName,
                displayName: this.state.channelDisplayName,
                purpose: this.state.channelPurpose,
                header: this.state.channelHeader
            };

            var showChannelModal = false;
            var showGroupModal = false;
            var showChangeURLModal = false;

            var changeURLTitle = '';
            var changeURLSubmitButtonText = '';

            // Only listen to flow state if we are being shown
            if (this.props.show) {
                switch (this.state.flowState) {
                    case SHOW_NEW_CHANNEL:
                        if (this.state.channelType === _constants2.default.OPEN_CHANNEL) {
                            showChannelModal = true;
                        } else {
                            showGroupModal = true;
                        }
                        break;
                    case SHOW_EDIT_URL:
                        showChangeURLModal = true;
                        changeURLTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_flow.changeUrlTitle',
                            defaultMessage: 'Change Channel URL'
                        });
                        changeURLSubmitButtonText = changeURLTitle;
                        break;
                    case SHOW_EDIT_URL_THEN_COMPLETE:
                        showChangeURLModal = true;
                        changeURLTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_flow.set_url_title',
                            defaultMessage: 'Set Channel URL'
                        });
                        changeURLSubmitButtonText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_flow.create',
                            defaultMessage: 'Create Channel'
                        });
                        break;
                }
            }
            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(_new_channel_modal2.default, {
                    show: showChannelModal,
                    channelType: _constants2.default.OPEN_CHANNEL,
                    channelData: channelData,
                    serverError: this.state.serverError,
                    onSubmitChannel: this.onSubmit,
                    onModalDismissed: this.props.onModalDismissed,
                    onModalExited: this.onModalExited,
                    onTypeSwitched: this.typeSwitched,
                    onChangeURLPressed: this.urlChangeRequested,
                    onDataChanged: this.channelDataChanged
                }),
                _react2.default.createElement(_new_channel_modal2.default, {
                    show: showGroupModal,
                    channelType: _constants2.default.PRIVATE_CHANNEL,
                    channelData: channelData,
                    serverError: this.state.serverError,
                    onSubmitChannel: this.onSubmit,
                    onModalExited: this.onModalExited,
                    onModalDismissed: this.props.onModalDismissed,
                    onTypeSwitched: this.typeSwitched,
                    onChangeURLPressed: this.urlChangeRequested,
                    onDataChanged: this.channelDataChanged
                }),
                _react2.default.createElement(_change_url_modal2.default, {
                    show: showChangeURLModal,
                    title: changeURLTitle,
                    submitButtonText: changeURLSubmitButtonText,
                    currentURL: this.state.channelName,
                    serverError: this.state.serverError,
                    onModalSubmit: this.urlChangeSubmitted,
                    onModalDismissed: this.urlChangeDismissed,
                    onModalExited: this.onModalExited
                })
            );
        }
    }]);
    return NewChannelFlow;
}(_react2.default.Component);

NewChannelFlow.propTypes = {

    /**
    * Set whether to show the modal or not
    */
    show: _propTypes2.default.bool.isRequired,

    /**
    * Set to Constants.OPEN_CHANNEL or Constants.PRIVATE_CHANNEL depending on which modal we should show
    */
    channelType: _propTypes2.default.string.isRequired,

    /**
    * Function to call when modal is dimissed
    */
    onModalDismissed: _propTypes2.default.func.isRequired
};
NewChannelFlow.defaultProps = {
    show: false,
    channelType: _constants2.default.OPEN_CHANNEL
};
exports.default = NewChannelFlow;

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _constants = __webpack_require__(19);

var _preferences = __webpack_require__(784);

var _teams = __webpack_require__(274);

var _new_channel_modal = __webpack_require__(2385);

var _new_channel_modal2 = _interopRequireDefault(_new_channel_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        ctrlSend: (0, _preferences.getBool)(state, _constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter'),
        currentTeamId: (0, _teams.getCurrentTeamId)(state)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_new_channel_modal2.default);

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _url = __webpack_require__(793);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _team_permission_gate = __webpack_require__(864);

var _team_permission_gate2 = _interopRequireDefault(_team_permission_gate);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var NewChannelModal = function (_React$PureComponent) {
    (0, _inherits3.default)(NewChannelModal, _React$PureComponent);

    function NewChannelModal(props) {
        (0, _classCallCheck3.default)(this, NewChannelModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NewChannelModal.__proto__ || (0, _getPrototypeOf2.default)(NewChannelModal)).call(this, props));

        _this.onEnterKeyDown = function (e) {
            var enterPressed = Utils.isKeyPressed(e, _constants3.default.KeyCodes.ENTER);
            var ctrlSend = _this.props.ctrlSend;

            // Enter pressed alone without required cmd or ctrl key

            if (ctrlSend && enterPressed && !e.ctrlKey) {
                e.preventDefault();
            } else if (ctrlSend && enterPressed && e.ctrlKey || !ctrlSend && enterPressed && !e.shiftKey && !e.altKey) {
                _this.handleSubmit(e);
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var displayName = _reactDom2.default.findDOMNode(_this.refs.display_name).value.trim();
            if (displayName.length < _constants3.default.MIN_CHANNELNAME_LENGTH) {
                _this.setState({ displayNameError: true });
                return;
            }

            _this.props.onSubmitChannel();
        };

        _this.handleChange = function () {
            var newData = {
                displayName: _this.refs.display_name.value,
                header: _this.refs.channel_header.value,
                purpose: _this.refs.channel_purpose.value
            };
            _this.props.onDataChanged(newData);
        };

        _this.handleOnURLChange = function (e) {
            e.preventDefault();
            if (_this.props.onChangeURLPressed) {
                _this.props.onChangeURLPressed();
            }
        };

        _this.state = {
            displayNameError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(NewChannelModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.show === true && this.props.show === false) {
                this.setState({
                    displayNameError: ''
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // ???
            if (UserAgent.isInternetExplorer() || UserAgent.isEdge()) {
                (0, _jquery2.default)('body').addClass('browser--ie');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var displayNameError = null;
            var serverError = null;
            var displayNameClass = 'form-group';

            if (this.state.displayNameError) {
                displayNameError = _react2.default.createElement(
                    'p',
                    { className: 'input__help error' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'channel_modal.displayNameError',
                        defaultMessage: 'Channel name must be 2 or more characters'
                    }),
                    this.state.displayNameError
                );
                displayNameClass += ' has-error';
            }

            if (this.props.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(
                            'p',
                            { className: 'input__help error' },
                            this.props.serverError
                        )
                    )
                );
            }

            var createPublicChannelLink = _react2.default.createElement(
                'button',
                {
                    className: 'style--none color--link',
                    onClick: this.props.onTypeSwitched
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'channel_modal.publicChannel1',
                    defaultMessage: 'Create a public channel'
                })
            );

            var createPrivateChannelLink = _react2.default.createElement(
                'button',
                {
                    className: 'style--none color--link',
                    onClick: this.props.onTypeSwitched,
                    tabIndex: '6'
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'channel_modal.privateGroup2',
                    defaultMessage: 'Create a private channel'
                })
            );

            var channelSwitchText = '';
            var inputPrefixId = '';
            switch (this.props.channelType) {
                case 'P':
                    channelSwitchText = _react2.default.createElement(
                        'div',
                        { className: 'modal-intro' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_modal.privateGroup1',
                            defaultMessage: 'Create a new private channel with restricted membership. '
                        }),
                        _react2.default.createElement(
                            _team_permission_gate2.default,
                            {
                                teamId: this.props.currentTeamId,
                                permissions: [_constants.Permissions.CREATE_PUBLIC_CHANNEL]
                            },
                            createPublicChannelLink
                        )
                    );
                    inputPrefixId = 'newPrivateChannel';
                    break;
                case 'O':
                    channelSwitchText = _react2.default.createElement(
                        'div',
                        { className: 'modal-intro' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_modal.publicChannel2',
                            defaultMessage: 'Create a new public channel anyone can join. '
                        }),
                        _react2.default.createElement(
                            _team_permission_gate2.default,
                            {
                                teamId: this.props.currentTeamId,
                                permissions: [_constants.Permissions.CREATE_PRIVATE_CHANNEL]
                            },
                            createPrivateChannelLink
                        )
                    );
                    inputPrefixId = 'newPublicChannel';
                    break;
            }

            var prettyTeamURL = (0, _url.getShortenedURL)();

            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    _reactBootstrap.Modal,
                    {
                        dialogClassName: 'new-channel__modal',
                        show: this.props.show,
                        bsSize: 'large',
                        onHide: this.props.onModalDismissed,
                        onExited: this.props.onModalExited,
                        autoFocus: true,
                        restoreFocus: true
                    },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Header,
                        null,
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'close',
                                onClick: this.props.onModalDismissed,
                                tabIndex: '5'
                            },
                            _react2.default.createElement(
                                'span',
                                { 'aria-hidden': 'true' },
                                '×'
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                'Close'
                            )
                        ),
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Title,
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_modal.modalTitle',
                                defaultMessage: 'New Channel'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'form',
                        {
                            role: 'form',
                            className: 'form-horizontal'
                        },
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Body,
                            null,
                            _react2.default.createElement(
                                'div',
                                null,
                                channelSwitchText
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: displayNameClass },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'col-sm-3 form__label control-label' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'channel_modal.name',
                                        defaultMessage: 'Name'
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-9' },
                                    _react2.default.createElement('input', {
                                        id: inputPrefixId + 'Name',
                                        onChange: this.handleChange,
                                        type: 'text',
                                        ref: 'display_name',
                                        className: 'form-control',
                                        placeholder: Utils.localizeMessage('channel_modal.nameEx', 'E.g.: "Bugs", "Marketing", "客户支持"'),
                                        maxLength: _constants3.default.MAX_CHANNELNAME_LENGTH,
                                        value: this.props.channelData.displayName,
                                        autoFocus: true,
                                        tabIndex: '1',
                                        onKeyDown: this.onEnterKeyDown
                                    }),
                                    displayNameError,
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'input__help dark' },
                                        'URL: ' + prettyTeamURL + this.props.channelData.name + ' (',
                                        _react2.default.createElement(
                                            'button',
                                            {
                                                className: 'color--link style--none',
                                                onClick: this.handleOnURLChange,
                                                tabIndex: '7'
                                            },
                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                                id: 'channel_modal.edit',
                                                defaultMessage: 'Edit'
                                            })
                                        ),
                                        ')'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-3' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'form__label control-label' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'channel_modal.purpose',
                                            defaultMessage: 'Purpose'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'form__label light' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'channel_modal.optional',
                                            defaultMessage: '(optional)'
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-9' },
                                    _react2.default.createElement('textarea', {
                                        id: inputPrefixId + 'Purpose',
                                        className: 'form-control no-resize',
                                        ref: 'channel_purpose',
                                        rows: '4',
                                        placeholder: Utils.localizeMessage('channel_modal.purposeEx', 'E.g.: "A channel to file bugs and improvements"'),
                                        maxLength: '250',
                                        value: this.props.channelData.purpose,
                                        onChange: this.handleChange,
                                        tabIndex: '2'
                                    }),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'input__help' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'channel_modal.descriptionHelp',
                                            defaultMessage: 'Describe how this channel should be used.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group less' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-3' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'form__label control-label' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'channel_modal.header',
                                            defaultMessage: 'Header'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'form__label light' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'channel_modal.optional',
                                            defaultMessage: '(optional)'
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-9' },
                                    _react2.default.createElement('textarea', {
                                        id: inputPrefixId + 'Header',
                                        className: 'form-control no-resize',
                                        ref: 'channel_header',
                                        rows: '4',
                                        placeholder: Utils.localizeMessage('channel_modal.headerEx', 'E.g.: "[Link Title](http://example.com)"'),
                                        maxLength: '1024',
                                        value: this.props.channelData.header,
                                        onChange: this.handleChange,
                                        tabIndex: '3'
                                    }),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'input__help' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'channel_modal.headerHelp',
                                            defaultMessage: 'Set text that will appear in the header of the channel beside the channel name. For example, include frequently used links by typing [Link Title](http://example.com).'
                                        })
                                    ),
                                    serverError
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Footer,
                            null,
                            _react2.default.createElement(
                                'button',
                                {
                                    type: 'button',
                                    className: 'btn btn-default',
                                    onClick: this.props.onModalDismissed,
                                    tabIndex: '8',
                                    onBlur: function onBlur() {
                                        return document.getElementById(inputPrefixId + 'Name').focus();
                                    }
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_modal.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            ),
                            _react2.default.createElement(
                                'button',
                                {
                                    onClick: this.handleSubmit,
                                    type: 'submit',
                                    className: 'btn btn-primary',
                                    tabIndex: '4'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_modal.createNew',
                                    defaultMessage: 'Create New Channel'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return NewChannelModal;
}(_react2.default.PureComponent);

NewChannelModal.propTypes = {

    /**
     * Set whether to show the modal or not
     */
    show: _propTypes2.default.bool.isRequired,

    /**
     * Id of the active team
     */
    currentTeamId: _propTypes2.default.string.isRequired,

    /**
     * The type of channel to create, 'O' or 'P'
     */
    channelType: _propTypes2.default.string.isRequired,

    /**
     * The data needed to create the channel
     */
    channelData: _propTypes2.default.object.isRequired,

    /**
     * Set to force form submission on CTRL/CMD + ENTER instead of ENTER
     */
    ctrlSend: _propTypes2.default.bool,

    /**
     * Server error from failed channel creation
     */
    serverError: _propTypes2.default.node,

    /**
     * Function used to submit the channel
     */
    onSubmitChannel: _propTypes2.default.func.isRequired,

    /**
     * Function to call when modal is dimissed
     */
    onModalDismissed: _propTypes2.default.func.isRequired,

    /**
     * Function to call when modal has exited
     */
    onModalExited: _propTypes2.default.func,

    /**
     * Function to call to switch channel type
     */
    onTypeSwitched: _propTypes2.default.func.isRequired,

    /**
     * Function to call when edit URL button is pressed
     */
    onChangeURLPressed: _propTypes2.default.func.isRequired,

    /**
     * Function to call when channel data is modified
     */
    onDataChanged: _propTypes2.default.func.isRequired
};
exports.default = NewChannelModal;

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _teams = __webpack_require__(274);

var _url = __webpack_require__(793);

var _change_url_modal = __webpack_require__(2387);

var _change_url_modal2 = _interopRequireDefault(_change_url_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var currentTeam = (0, _teams.getCurrentTeam)(state);
    var currentTeamURL = (0, _url.getSiteURL)() + '/' + currentTeam.name;
    return {
        currentTeamURL: currentTeamURL
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_change_url_modal2.default);

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _url = __webpack_require__(793);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ChangeURLModal = function (_React$PureComponent) {
    (0, _inherits3.default)(ChangeURLModal, _React$PureComponent);

    function ChangeURLModal(props) {
        (0, _classCallCheck3.default)(this, ChangeURLModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChangeURLModal.__proto__ || (0, _getPrototypeOf2.default)(ChangeURLModal)).call(this, props));

        _this.onURLChanged = function (e) {
            var url = e.target.value.trim();
            _this.setState({ currentURL: url.replace(/[^A-Za-z0-9-_]/g, '').toLowerCase(), userEdit: true });
        };

        _this.formattedError = function (key, id, message) {
            return _react2.default.createElement(
                'span',
                { key: key },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: id,
                    defaultMessage: message
                }),
                _react2.default.createElement('br', null)
            );
        };

        _this.getURLError = function (url) {
            var error = []; //eslint-disable-line prefer-const

            if (url.length < 2) {
                error.push(_this.formattedError('error1', 'change_url.longer', 'URL must be two or more characters.'));
            }
            if (url.charAt(0) === '-' || url.charAt(0) === '_') {
                error.push(_this.formattedError('error2', 'change_url.startWithLetter', 'URL must start with a letter or number.'));
            }
            if (url.length > 1 && (url.charAt(url.length - 1) === '-' || url.charAt(url.length - 1) === '_')) {
                error.push(_this.formattedError('error3', 'change_url.endWithLetter', 'URL must end with a letter or number.'));
            }
            if (url.indexOf('__') > -1) {
                error.push(_this.formattedError('error4', 'change_url.noUnderscore', 'URL can not contain two underscores in a row.'));
            }

            // In case of error we don't detect
            if (error.length === 0) {
                error.push(_this.formattedError('errorlast', 'change_url.invalidUrl', 'Invalid URL'));
            }
            return error;
        };

        _this.onSubmit = function (e) {
            e.preventDefault();
            var url = _this.refs.urlinput.value;
            var cleanedURL = (0, _url.cleanUpUrlable)(url);
            if (cleanedURL !== url || url.length < 2 || url.indexOf('__') > -1) {
                _this.setState({ urlError: _this.getURLError(url) });
                return;
            }
            _this.setState({ urlError: '', userEdit: false });
            _this.props.onModalSubmit(url);
        };

        _this.onCancel = function () {
            _this.setState({ urlError: '', userEdit: false });
            _this.props.onModalDismissed();
        };

        _this.state = {
            currentURL: props.currentURL,
            urlError: '',
            userEdit: false
        };
        return _this;
    }

    (0, _createClass3.default)(ChangeURLModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // This check prevents the url being deleted when we re-render
            // because of user status check
            if (!this.state.userEdit) {
                this.setState({
                    currentURL: nextProps.currentURL
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var urlClass = 'input-group input-group--limit';
            var error = null;

            if (this.state.urlError) {
                urlClass += ' has-error';
            }

            if (this.props.serverError || this.state.urlError) {
                error = _react2.default.createElement(
                    'div',
                    { className: 'has-error' },
                    _react2.default.createElement(
                        'p',
                        { className: 'input__help error' },
                        this.state.urlError || this.props.serverError
                    )
                );
            }

            var fullURL = this.props.currentTeamURL + '/channels';
            var shortURL = (0, _url.getShortenedURL)(fullURL);
            var urlTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'urlTooltip' },
                fullURL
            );

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.props.show,
                    onHide: this.onCancel,
                    onExited: this.props.onModalExited
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        this.props.title
                    )
                ),
                _react2.default.createElement(
                    'form',
                    {
                        role: 'form',
                        className: 'form-horizontal'
                    },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Body,
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-intro' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_flow.changeUrlDescription',
                                defaultMessage: 'Some characters are now allowed in URLs and may be removed.'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { className: 'col-sm-3 form__label control-label' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'change_url.urlLabel',
                                    defaultMessage: 'Channel URL'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-9' },
                                _react2.default.createElement(
                                    'div',
                                    { className: urlClass },
                                    _react2.default.createElement(
                                        _reactBootstrap.OverlayTrigger,
                                        {
                                            trigger: ['hover', 'focus'],
                                            delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                            placement: 'top',
                                            overlay: urlTooltip
                                        },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'input-group-addon' },
                                            shortURL
                                        )
                                    ),
                                    _react2.default.createElement('input', {
                                        type: 'text',
                                        ref: 'urlinput',
                                        className: 'form-control',
                                        maxLength: _constants2.default.MAX_CHANNELNAME_LENGTH,
                                        onChange: this.onURLChanged,
                                        value: this.state.currentURL,
                                        autoFocus: true,
                                        tabIndex: '1'
                                    })
                                ),
                                error
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Footer,
                        null,
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'btn btn-default',
                                onClick: this.onCancel
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'change_url.close',
                                defaultMessage: 'Close'
                            })
                        ),
                        _react2.default.createElement(
                            'button',
                            {
                                onClick: this.onSubmit,
                                type: 'submit',
                                className: 'btn btn-primary',
                                tabIndex: '2'
                            },
                            this.props.submitButtonText
                        )
                    )
                )
            );
        }
    }]);
    return ChangeURLModal;
}(_react2.default.PureComponent);

ChangeURLModal.propTypes = {

    /**
    * Set whether to show the modal or not
    */
    show: _propTypes2.default.bool.isRequired,

    /**
    * Set to change the title of the modal
    */
    title: _propTypes2.default.node,

    /**
    * Set to change the submit button text
    */
    submitButtonText: _propTypes2.default.node,

    /**
    * Set to change the current URL
    */
    currentURL: _propTypes2.default.string,

    /**
    * Set to the current team URL
    */
    currentTeamURL: _propTypes2.default.string.isRequired,

    /**
    * Server error from failed channel creation
    */
    serverError: _propTypes2.default.node,

    /**
     * Function to call when modal is submitted
     */
    onModalSubmit: _propTypes2.default.func.isRequired,

    /**
     * Function to call when modal is exited
     */
    onModalExited: _propTypes2.default.func,

    /**
     * Function to call when modal is dimissed
     */
    onModalDismissed: _propTypes2.default.func.isRequired
};
ChangeURLModal.defaultProps = {
    show: false,
    title: 'Change URL',
    submitButtonText: 'Save',
    currentURL: '',
    serverError: null
};
exports.default = ChangeURLModal;

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _unread_below_icon = __webpack_require__(1409);

var _unread_below_icon2 = _interopRequireDefault(_unread_below_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnreadChannelIndicator = function (_React$PureComponent) {
    (0, _inherits3.default)(UnreadChannelIndicator, _React$PureComponent);

    function UnreadChannelIndicator() {
        (0, _classCallCheck3.default)(this, UnreadChannelIndicator);
        return (0, _possibleConstructorReturn3.default)(this, (UnreadChannelIndicator.__proto__ || (0, _getPrototypeOf2.default)(UnreadChannelIndicator)).apply(this, arguments));
    }

    (0, _createClass3.default)(UnreadChannelIndicator, [{
        key: 'render',
        value: function render() {
            var displayValue = 'none';
            if (this.props.show) {
                displayValue = 'block';
            }

            return _react2.default.createElement(
                'div',
                {
                    id: 'unreadIndicator' + this.props.name,
                    className: 'nav-pills__unread-indicator ' + this.props.extraClass,
                    style: { display: displayValue },
                    onClick: this.props.onClick
                },
                this.props.content,
                _react2.default.createElement(_unread_below_icon2.default, { className: 'icon icon__unread' })
            );
        }
    }]);
    return UnreadChannelIndicator;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

UnreadChannelIndicator.propTypes = {

    /**
     * Function to call when the indicator is clicked
     */
    onClick: _propTypes2.default.func.isRequired,

    /**
     * Set whether to show the indicator or not
     */
    show: _propTypes2.default.bool,

    /**
     * The additional CSS class for the indicator
     */
    extraClass: _propTypes2.default.string,

    /**
     * The content of the indicator
     */
    content: _propTypes2.default.node,

    /**
     * The name of the indicator
     */
    name: _propTypes2.default.string
};
UnreadChannelIndicator.defaultProps = {
    show: false,
    extraClass: '',
    content: ''
};
exports.default = UnreadChannelIndicator;

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _sidebar_header = __webpack_require__(2390);

var _sidebar_header2 = _interopRequireDefault(_sidebar_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    var enableTutorial = config.EnableTutorial === 'true';

    return {
        enableTutorial: enableTutorial
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_sidebar_header2.default);

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _index = __webpack_require__(2391);

var _index2 = _interopRequireDefault(_index);

var _menu_tutorial_tip = __webpack_require__(1338);

var _menu_tutorial_tip2 = _interopRequireDefault(_menu_tutorial_tip);

var _dropdown = __webpack_require__(2394);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarHeader = function (_React$Component) {
    (0, _inherits3.default)(SidebarHeader, _React$Component);

    function SidebarHeader(props) {
        (0, _classCallCheck3.default)(this, SidebarHeader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarHeader.__proto__ || (0, _getPrototypeOf2.default)(SidebarHeader)).call(this, props));

        _this.handleResize = function () {
            var isMobile = Utils.isMobile();
            _this.setState({ isMobile: isMobile });
        };

        _this.getPreferences = function () {
            if (!_this.props.currentUser) {
                return {};
            }
            var tutorialStep = _preference_store2.default.getInt(_constants.Preferences.TUTORIAL_STEP, _this.props.currentUser.id, _constants.TutorialSteps.FINISHED);
            var showTutorialTip = tutorialStep === _constants.TutorialSteps.MENU_POPOVER && !Utils.isMobile() && _this.props.enableTutorial;

            return { showTutorialTip: showTutorialTip };
        };

        _this.getStateFromStores = function () {
            var preferences = _this.getPreferences();
            var isMobile = Utils.isMobile();
            return (0, _extends3.default)({}, preferences, {
                isMobile: isMobile,
                showDropdown: false
            });
        };

        _this.onPreferenceChange = function () {
            _this.setState(_this.getPreferences());
        };

        _this.toggleDropdown = function (toggle) {
            if (typeof toggle === 'boolean') {
                _this.setState({
                    showDropdown: toggle
                });
            } else {
                _this.setState({
                    showDropdown: !_this.state.showDropdown
                });
            }
        };

        _this.showDropdown = function () {
            _this.toggleDropdown(true);
        };

        _this.renderStatusDropdown = function () {
            if (_this.state.isMobile) {
                return null;
            }
            return _react2.default.createElement(_index2.default, null);
        };

        _this.state = _this.getStateFromStores();
        return _this;
    }

    (0, _createClass3.default)(SidebarHeader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _preference_store2.default.addChangeListener(this.onPreferenceChange);
            window.addEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _preference_store2.default.removeChangeListener(this.onPreferenceChange);
            window.removeEventListener('resize', this.handleResize);
        }
    }, {
        key: 'render',
        value: function render() {
            var statusDropdown = this.renderStatusDropdown();

            var tutorialTip = null;
            if (this.state.showTutorialTip) {
                tutorialTip = _react2.default.createElement(_menu_tutorial_tip2.default, {
                    toggleFunc: this.showDropdown,
                    onBottom: false
                });
            }

            var teamNameWithToolTip = null;
            if (this.props.teamDescription === '') {
                teamNameWithToolTip = _react2.default.createElement(
                    'h1',
                    {
                        id: 'headerTeamName',
                        className: 'team__name'
                    },
                    this.props.teamDisplayName
                );
            } else {
                teamNameWithToolTip = _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        trigger: ['hover', 'focus'],
                        delayShow: _constants.Constants.OVERLAY_TIME_DELAY,
                        placement: 'bottom',
                        overlay: _react2.default.createElement(
                            _reactBootstrap.Tooltip,
                            { id: 'team-name__tooltip' },
                            this.props.teamDescription
                        ),
                        ref: 'descriptionOverlay'
                    },
                    _react2.default.createElement(
                        'h1',
                        {
                            id: 'headerTeamName',
                            className: 'team__name'
                        },
                        this.props.teamDisplayName
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    id: 'teamHeader',
                    className: 'team__header theme'
                },
                tutorialTip,
                _react2.default.createElement(
                    'div',
                    {
                        id: 'headerInfo',
                        className: 'header__info'
                    },
                    teamNameWithToolTip,
                    _react2.default.createElement(
                        'div',
                        {
                            id: 'headerUsername',
                            className: 'user__name'
                        },
                        '@' + this.props.currentUser.username
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'sidebarDropdownMenuContainer' },
                    _react2.default.createElement(_dropdown2.default, {
                        teamId: this.props.teamId,
                        teamType: this.props.teamType,
                        teamDisplayName: this.props.teamDisplayName,
                        teamName: this.props.teamName,
                        currentUser: this.props.currentUser,
                        showDropdown: this.state.showDropdown,
                        onToggleDropdown: this.toggleDropdown
                    })
                ),
                statusDropdown
            );
        }
    }]);
    return SidebarHeader;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = SidebarHeader;


SidebarHeader.propTypes = {
    teamId: _propTypes2.default.string,
    teamDisplayName: _propTypes2.default.string,
    teamDescription: _propTypes2.default.string,
    teamName: _propTypes2.default.string,
    teamType: _propTypes2.default.string,
    currentUser: _propTypes2.default.object,
    enableTutorial: _propTypes2.default.bool.isRequired
};

SidebarHeader.defaultProps = {
    teamDisplayName: '',
    teamDescription: '',
    teamType: ''
};

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _client = __webpack_require__(270);

var _users2 = __webpack_require__(777);

var _status_dropdown = __webpack_require__(2392);

var _status_dropdown2 = _interopRequireDefault(_status_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var currentUser = (0, _users2.getCurrentUser)(state);

    if (!currentUser) {
        return {};
    }

    var userId = currentUser.id;
    return {
        userId: userId,
        profilePicture: _client.Client4.getProfilePictureUrl(userId, currentUser.last_picture_update),
        status: (0, _users2.getStatusForUserId)(state, userId)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            setStatus: _users.setStatus
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_status_dropdown2.default);

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var _bootstrap_span = __webpack_require__(2393);

var _bootstrap_span2 = _interopRequireDefault(_bootstrap_span);

var _status_icon = __webpack_require__(932);

var _status_icon2 = _interopRequireDefault(_status_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var StatusDropdown = function (_React$Component) {
    (0, _inherits3.default)(StatusDropdown, _React$Component);

    function StatusDropdown() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StatusDropdown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StatusDropdown.__proto__ || (0, _getPrototypeOf2.default)(StatusDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            showDropdown: false
        }, _this.onToggle = function (showDropdown) {
            _this.setState({ showDropdown: showDropdown });
        }, _this.closeDropdown = function () {
            _this.setState({ showDropdown: false });
        }, _this.setStatus = function (status) {
            _this.props.actions.setStatus({
                user_id: _this.props.userId,
                status: status
            });
            _this.closeDropdown();
        }, _this.setOnline = function (event) {
            event.preventDefault();
            _this.setStatus(_constants.UserStatuses.ONLINE);
        }, _this.setOffline = function (event) {
            event.preventDefault();
            _this.setStatus(_constants.UserStatuses.OFFLINE);
        }, _this.setAway = function (event) {
            event.preventDefault();
            _this.setStatus(_constants.UserStatuses.AWAY);
        }, _this.setDnd = function (event) {
            event.preventDefault();
            _this.setStatus(_constants.UserStatuses.DND);
        }, _this.renderStatusOnlineAction = function () {
            return _this.renderStatusAction(_constants.UserStatuses.ONLINE, _this.setOnline);
        }, _this.renderStatusAwayAction = function () {
            return _this.renderStatusAction(_constants.UserStatuses.AWAY, _this.setAway);
        }, _this.renderStatusOfflineAction = function () {
            return _this.renderStatusAction(_constants.UserStatuses.OFFLINE, _this.setOffline);
        }, _this.renderStatusDndAction = function () {
            return _this.renderStatusAction(_constants.UserStatuses.DND, _this.setDnd, (0, _utils.localizeMessage)('status_dropdown.set_dnd.extra', 'Disables Desktop and Push Notifications'));
        }, _this.renderProfilePicture = function () {
            if (!_this.props.profilePicture) {
                return null;
            }
            return _react2.default.createElement('img', {
                className: 'user__picture',
                src: _this.props.profilePicture
            });
        }, _this.renderStatusAction = function (status, onClick, extraText) {
            return _react2.default.createElement(
                'li',
                { key: status },
                _react2.default.createElement(
                    'a',
                    {
                        id: 'status' + status,
                        href: '#',
                        onClick: onClick
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'status_dropdown.set_' + status,
                        defaultMessage: status
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'status-dropdown-extra' },
                        extraText
                    )
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(StatusDropdown, [{
        key: 'render',
        value: function render() {
            var profilePicture = this.renderProfilePicture();
            var actions = [this.renderStatusOnlineAction(), this.renderStatusAwayAction(), this.renderStatusDndAction(), this.renderStatusOfflineAction()];
            return _react2.default.createElement(
                _reactBootstrap.Dropdown,
                {
                    id: 'status-dropdown',
                    open: this.state.showDropdown,
                    onToggle: this.onToggle,
                    style: this.props.style
                },
                _react2.default.createElement(
                    _bootstrap_span2.default,
                    {
                        bsRole: 'toggle'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'status-wrapper status-selector' },
                        profilePicture,
                        _react2.default.createElement(_status_icon2.default, { status: this.props.status }),
                        _react2.default.createElement(
                            'span',
                            { className: 'status status-edit edit' },
                            _react2.default.createElement('i', { className: 'fa fa-caret-down' })
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Dropdown.Menu,
                    { id: 'editStatusMenu' },
                    actions
                )
            );
        }
    }]);
    return StatusDropdown;
}(_react2.default.Component);

StatusDropdown.propTypes = {
    style: _propTypes2.default.object,
    status: _propTypes2.default.string,
    userId: _propTypes2.default.string.isRequired,
    profilePicture: _propTypes2.default.string,
    actions: _propTypes2.default.shape({
        setStatus: _propTypes2.default.func.isRequired
    }).isRequired
};
StatusDropdown.defaultProps = {
    userId: '',
    profilePicture: '',
    status: _constants.UserStatuses.OFFLINE
};
exports.default = StatusDropdown;

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var BootstrapSpan = function (_React$PureComponent) {
    (0, _inherits3.default)(BootstrapSpan, _React$PureComponent);

    function BootstrapSpan() {
        (0, _classCallCheck3.default)(this, BootstrapSpan);
        return (0, _possibleConstructorReturn3.default)(this, (BootstrapSpan.__proto__ || (0, _getPrototypeOf2.default)(BootstrapSpan)).apply(this, arguments));
    }

    (0, _createClass3.default)(BootstrapSpan, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                props = (0, _objectWithoutProperties3.default)(_props, ['children']);

            delete props.bsRole;
            delete props.bsClass;

            return _react2.default.createElement(
                'span',
                props,
                children
            );
        }
    }]);
    return BootstrapSpan;
}(_react2.default.PureComponent);

BootstrapSpan.propTypes = {
    children: _propTypes2.default.element
};
exports.default = BootstrapSpan;

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _sidebar_header_dropdown = __webpack_require__(2395);

var _sidebar_header_dropdown2 = _interopRequireDefault(_sidebar_header_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var license = (0, _general.getLicense)(state);

    var isLicensed = license.IsLicensed === 'true';

    var appDownloadLink = config.AppDownloadLink;
    var enableCommands = config.EnableCommands === 'true';
    var enableCustomEmoji = config.EnableCustomEmoji === 'true';
    var enableIncomingWebhooks = config.EnableIncomingWebhooks === 'true';
    var enableOAuthServiceProvider = config.EnableOAuthServiceProvider === 'true';
    var enableOnlyAdminIntegrations = config.EnableOnlyAdminIntegrations === 'true';
    var enableOutgoingWebhooks = config.EnableOutgoingWebhooks === 'true';
    var enableTeamCreation = config.EnableTeamCreation === 'true';
    var enableUserCreation = config.EnableUserCreation === 'true';
    var experimentalPrimaryTeam = config.ExperimentalPrimaryTeam;
    var helpLink = config.HelpLink;
    var reportAProblemLink = config.ReportAProblemLink;
    var restrictTeamInvite = config.RestrictTeamInvite;

    return {
        isLicensed: isLicensed,
        appDownloadLink: appDownloadLink,
        enableCommands: enableCommands,
        enableCustomEmoji: enableCustomEmoji,
        enableIncomingWebhooks: enableIncomingWebhooks,
        enableOAuthServiceProvider: enableOAuthServiceProvider,
        enableOnlyAdminIntegrations: enableOnlyAdminIntegrations,
        enableOutgoingWebhooks: enableOutgoingWebhooks,
        enableTeamCreation: enableTeamCreation,
        enableUserCreation: enableUserCreation,
        experimentalPrimaryTeam: experimentalPrimaryTeam,
        helpLink: helpLink,
        reportAProblemLink: reportAProblemLink,
        restrictTeamInvite: restrictTeamInvite,
        pluginMenuItems: state.plugins.mainMenuActions
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_sidebar_header_dropdown2.default);

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _constants = __webpack_require__(19);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _constants2 = __webpack_require__(29);

var _url = __webpack_require__(793);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _about_build_modal = __webpack_require__(1049);

var _about_build_modal2 = _interopRequireDefault(_about_build_modal);

var _add_users_to_team = __webpack_require__(1332);

var _add_users_to_team2 = _interopRequireDefault(_add_users_to_team);

var _team_members_modal = __webpack_require__(1051);

var _team_members_modal2 = _interopRequireDefault(_team_members_modal);

var _team_settings_modal = __webpack_require__(1052);

var _team_settings_modal2 = _interopRequireDefault(_team_settings_modal);

var _team_permission_gate = __webpack_require__(864);

var _team_permission_gate2 = _interopRequireDefault(_team_permission_gate);

var _system_permission_gate = __webpack_require__(863);

var _system_permission_gate2 = _interopRequireDefault(_system_permission_gate);

var _sidebar_header_dropdown_button = __webpack_require__(2396);

var _sidebar_header_dropdown_button2 = _interopRequireDefault(_sidebar_header_dropdown_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SidebarHeaderDropdown = function (_React$Component) {
    (0, _inherits3.default)(SidebarHeaderDropdown, _React$Component);

    function SidebarHeaderDropdown(props) {
        (0, _classCallCheck3.default)(this, SidebarHeaderDropdown);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarHeaderDropdown.__proto__ || (0, _getPrototypeOf2.default)(SidebarHeaderDropdown)).call(this, props));

        _this.toggleDropdown = function (val) {
            if (typeof val === 'boolean') {
                _this.props.onToggleDropdown(val);
                return;
            }

            if (val && val.preventDefault) {
                val.preventDefault();
            }

            _this.props.onToggleDropdown();
        };

        _this.showTeamSettingsModal = function (e) {
            e.preventDefault();

            _this.setState({
                showTeamSettingsModal: true
            });
            _this.props.onToggleDropdown(false);
        };

        _this.hideTeamSettingsModal = function () {
            _this.setState({
                showTeamSettingsModal: false
            });
        };

        _this.handleEmitUserLoggedOutEvent = function () {
            GlobalActions.emitUserLoggedOutEvent();
        };

        _this.handleAboutModal = _this.handleAboutModal.bind(_this);
        _this.aboutModalDismissed = _this.aboutModalDismissed.bind(_this);
        _this.showAccountSettingsModal = _this.showAccountSettingsModal.bind(_this);
        _this.showAddUsersToTeamModal = _this.showAddUsersToTeamModal.bind(_this);
        _this.hideAddUsersToTeamModal = _this.hideAddUsersToTeamModal.bind(_this);
        _this.showInviteMemberModal = _this.showInviteMemberModal.bind(_this);
        _this.showGetTeamInviteLinkModal = _this.showGetTeamInviteLinkModal.bind(_this);
        _this.showTeamMembersModal = _this.showTeamMembersModal.bind(_this);
        _this.hideTeamMembersModal = _this.hideTeamMembersModal.bind(_this);
        _this.toggleShortcutsModal = _this.toggleShortcutsModal.bind(_this);

        _this.onTeamChange = _this.onTeamChange.bind(_this);

        _this.renderCustomEmojiLink = _this.renderCustomEmojiLink.bind(_this);

        _this.handleClick = _this.handleClick.bind(_this);

        _this.state = {
            teamMembers: _team_store2.default.getMyTeamMembers(),
            teamListings: _team_store2.default.getTeamListings(),
            showAboutModal: false,
            showTeamSettingsModal: false,
            showTeamMembersModal: false,
            showAddUsersToTeamModal: false
        };
        return _this;
    }

    (0, _createClass3.default)(SidebarHeaderDropdown, [{
        key: 'handleClick',
        value: function handleClick(e) {
            if (_webrtc_store2.default.isBusy()) {
                _webrtc_store2.default.emitChanged({ action: _constants2.WebrtcActionTypes.IN_PROGRESS });
                e.preventDefault();
            }
        }
    }, {
        key: 'handleAboutModal',
        value: function handleAboutModal(e) {
            e.preventDefault();

            this.setState({
                showAboutModal: true
            });
            this.props.onToggleDropdown(false);
        }
    }, {
        key: 'aboutModalDismissed',
        value: function aboutModalDismissed() {
            this.setState({ showAboutModal: false });
        }
    }, {
        key: 'showAccountSettingsModal',
        value: function showAccountSettingsModal(e) {
            e.preventDefault();

            this.props.onToggleDropdown(false);

            GlobalActions.showAccountSettingsModal();
        }
    }, {
        key: 'toggleShortcutsModal',
        value: function toggleShortcutsModal(e) {
            e.preventDefault();
            this.props.onToggleDropdown(false);

            GlobalActions.toggleShortcutsModal();
        }
    }, {
        key: 'showAddUsersToTeamModal',
        value: function showAddUsersToTeamModal(e) {
            e.preventDefault();

            this.setState({
                showAddUsersToTeamModal: true
            });
            this.props.onToggleDropdown(false);
        }
    }, {
        key: 'hideAddUsersToTeamModal',
        value: function hideAddUsersToTeamModal() {
            this.setState({
                showAddUsersToTeamModal: false
            });
        }
    }, {
        key: 'showInviteMemberModal',
        value: function showInviteMemberModal(e) {
            e.preventDefault();

            this.props.onToggleDropdown(false);

            GlobalActions.showInviteMemberModal();
        }
    }, {
        key: 'showGetTeamInviteLinkModal',
        value: function showGetTeamInviteLinkModal(e) {
            e.preventDefault();

            this.props.onToggleDropdown(false);

            GlobalActions.showGetTeamInviteLinkModal();
        }
    }, {
        key: 'showTeamMembersModal',
        value: function showTeamMembersModal(e) {
            e.preventDefault();

            this.setState({
                showTeamMembersModal: true
            });
        }
    }, {
        key: 'hideTeamMembersModal',
        value: function hideTeamMembersModal() {
            this.setState({
                showTeamMembersModal: false
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _team_store2.default.addChangeListener(this.onTeamChange);
        }
    }, {
        key: 'onTeamChange',
        value: function onTeamChange() {
            this.setState({
                teamMembers: _team_store2.default.getMyTeamMembers(),
                teamListings: _team_store2.default.getTeamListings()
            });
            this.props.onToggleDropdown(false);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.dropdown)).off('hide.bs.dropdown');
            _team_store2.default.removeChangeListener(this.onTeamChange);
        }
    }, {
        key: 'renderCustomEmojiLink',
        value: function renderCustomEmojiLink() {
            if (!this.props.enableCustomEmoji || !Utils.canCreateCustomEmoji(this.props.currentUser)) {
                return null;
            }

            return _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        id: 'customEmoji',
                        onClick: this.handleClick,
                        to: '/' + this.props.teamName + '/emoji'
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'navbar_dropdown.emoji',
                        defaultMessage: 'Custom Emoji'
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var currentUser = this.props.currentUser;
            var teamLink = '';
            var inviteLink = '';
            var addMemberToTeam = '';
            var sysAdminLink = '';
            var teamSettings = null;
            var integrationsLink = null;

            if (!currentUser) {
                return null;
            }

            if (currentUser != null) {
                inviteLink = _react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        teamId: this.props.teamId,
                        permissions: [_constants.Permissions.INVITE_USER]
                    },
                    _react2.default.createElement(
                        _team_permission_gate2.default,
                        {
                            teamId: this.props.teamId,
                            permissions: [_constants.Permissions.ADD_USER_TO_TEAM]
                        },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'style--none',
                                    id: 'sendEmailInvite',
                                    onClick: this.showInviteMemberModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'navbar_dropdown.inviteMember',
                                    defaultMessage: 'Send Email Invite'
                                })
                            )
                        )
                    )
                );

                addMemberToTeam = _react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        teamId: this.props.teamId,
                        permissions: [_constants.Permissions.ADD_USER_TO_TEAM]
                    },
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'style--none',
                                id: 'addUsersToTeam',
                                onClick: this.showAddUsersToTeamModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar_dropdown.addMemberToTeam',
                                defaultMessage: 'Add Members to Team'
                            })
                        )
                    )
                );

                if (this.props.teamType === _constants2.Constants.OPEN_TEAM && this.props.enableUserCreation) {
                    teamLink = _react2.default.createElement(
                        _team_permission_gate2.default,
                        {
                            teamId: this.props.teamId,
                            permissions: [_constants.Permissions.INVITE_USER]
                        },
                        _react2.default.createElement(
                            _team_permission_gate2.default,
                            {
                                teamId: this.props.teamId,
                                permissions: [_constants.Permissions.ADD_USER_TO_TEAM]
                            },
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'button',
                                    {
                                        className: 'style--none',
                                        id: 'getTeamInviteLink',
                                        onClick: this.showGetTeamInviteLinkModal
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'navbar_dropdown.teamLink',
                                        defaultMessage: 'Get Team Invite Link'
                                    })
                                )
                            )
                        )
                    );
                }
            }

            teamSettings = _react2.default.createElement(
                _team_permission_gate2.default,
                {
                    teamId: this.props.teamId,
                    permissions: [_constants.Permissions.MANAGE_TEAM]
                },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'style--none',
                            id: 'teamSettings',
                            onClick: this.showTeamSettingsModal
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.teamSettings',
                            defaultMessage: 'Team Settings'
                        })
                    )
                )
            );

            var manageLink = _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'button',
                    {
                        id: 'manageMembers',
                        className: 'style--none',
                        onClick: this.showTeamMembersModal
                    },
                    _react2.default.createElement(
                        _team_permission_gate2.default,
                        {
                            teamId: this.props.teamId,
                            permissions: [_constants.Permissions.MANAGE_TEAM]
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.manageMembers',
                            defaultMessage: 'Manage Members'
                        })
                    ),
                    _react2.default.createElement(
                        _team_permission_gate2.default,
                        {
                            teamId: this.props.teamId,
                            permissions: [_constants.Permissions.MANAGE_TEAM],
                            invert: true
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.viewMembers',
                            defaultMessage: 'View Members'
                        })
                    )
                )
            );

            var integrationsEnabled = this.props.enableIncomingWebhooks || this.props.enableOutgoingWebhooks || this.props.enableCommands || this.props.enableOAuthServiceProvider;
            if (integrationsEnabled) {
                integrationsLink = _react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        teamId: this.props.teamId,
                        permissions: [_constants.Permissions.MANAGE_SLASH_COMMANDS, _constants.Permissions.MANAGE_OAUTH, _constants.Permissions.MANAGE_WEBHOOKS]
                    },
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            {
                                id: 'Integrations',
                                to: '/' + this.props.teamName + '/integrations',
                                onClick: this.handleClick
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar_dropdown.integrations',
                                defaultMessage: 'Integrations'
                            })
                        )
                    )
                );
            }

            sysAdminLink = _react2.default.createElement(
                _system_permission_gate2.default,
                { permissions: [_constants.Permissions.MANAGE_SYSTEM] },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            id: 'systemConsole',
                            to: '/admin_console',
                            onClick: this.handleClick
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.console',
                            defaultMessage: 'System Console'
                        })
                    )
                )
            );

            var teams = [];
            var moreTeams = false;

            teams.push(_react2.default.createElement(
                _system_permission_gate2.default,
                {
                    permissions: [_constants.Permissions.CREATE_TEAM],
                    key: 'newTeam_permission'
                },
                _react2.default.createElement(
                    'li',
                    { key: 'newTeam_li' },
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            id: 'createTeam',
                            key: 'newTeam_a',
                            to: '/create_team',
                            onClick: this.handleClick
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.create',
                            defaultMessage: 'Create a New Team'
                        })
                    )
                )
            ));

            if (!this.props.experimentalPrimaryTeam) {
                var isAlreadyMember = this.state.teamMembers.reduce(function (result, item) {
                    result[item.team_id] = true;
                    return result;
                }, {});

                for (var id in this.state.teamListings) {
                    if (this.state.teamListings.hasOwnProperty(id) && !isAlreadyMember[id]) {
                        moreTeams = true;
                        break;
                    }
                }

                if (moreTeams) {
                    teams.push(_react2.default.createElement(
                        'li',
                        { key: 'joinTeam_li' },
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            {
                                id: 'joinAnotherTeam',
                                onClick: this.handleClick,
                                to: '/select_team'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar_dropdown.join',
                                defaultMessage: 'Join Another Team'
                            })
                        )
                    ));
                }

                teams.push(_react2.default.createElement(
                    'li',
                    { key: 'leaveTeam_li' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'style--none',
                            id: 'leaveTeam',
                            onClick: GlobalActions.showLeaveTeamModal
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.leave',
                            defaultMessage: 'Leave Team'
                        })
                    )
                ));
            }

            var pluginItems = this.props.pluginMenuItems.map(function (item) {
                return _react2.default.createElement(
                    'li',
                    { key: item.id + '_pluginmenuitem' },
                    _react2.default.createElement(
                        'a',
                        {
                            id: item.id + '_pluginmenuitem',
                            href: '#',
                            onClick: function onClick() {
                                if (item.action) {
                                    item.action();
                                }
                                _this2.toggleDropdown(false);
                            }
                        },
                        item.text
                    )
                );
            });

            var pluginDivider = null;
            if (pluginItems.length > 0) {
                pluginDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            var helpLink = null;
            if (this.props.helpLink) {
                helpLink = _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            id: 'helpLink',
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            to: this.props.helpLink
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.help',
                            defaultMessage: 'Help'
                        })
                    )
                );
            }

            var reportLink = null;
            if (this.props.reportAProblemLink) {
                reportLink = _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            id: 'reportLink',
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            to: this.props.reportAProblemLink
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.report',
                            defaultMessage: 'Report a Problem'
                        })
                    )
                );
            }

            var nativeAppLink = null;
            if (this.props.appDownloadLink && !UserAgent.isMobileApp()) {
                nativeAppLink = _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            id: 'nativeAppLink',
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            to: (0, _url.useSafeUrl)(this.props.appDownloadLink)
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar_dropdown.nativeApps',
                            defaultMessage: 'Download Apps'
                        })
                    )
                );
            }

            var teamMembersModal = void 0;
            if (this.state.showTeamMembersModal) {
                teamMembersModal = _react2.default.createElement(_team_members_modal2.default, {
                    onLoad: this.toggleDropdown,
                    onHide: this.hideTeamMembersModal
                });
            }

            var addUsersToTeamModal = void 0;
            if (this.state.showAddUsersToTeamModal) {
                addUsersToTeamModal = _react2.default.createElement(_add_users_to_team2.default, {
                    onModalDismissed: this.hideAddUsersToTeamModal
                });
            }

            var keyboardShortcuts = _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'button',
                    {
                        className: 'style--none',
                        id: 'keyboardShortcuts',
                        onClick: this.toggleShortcutsModal
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'navbar_dropdown.keyboardShortcuts',
                        defaultMessage: 'Keyboard Shortcuts'
                    })
                )
            );

            var accountSettings = _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'button',
                    {
                        className: 'style--none',
                        id: 'accountSettings',
                        onClick: this.showAccountSettingsModal
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'navbar_dropdown.accountSettings',
                        defaultMessage: 'Account Settings'
                    })
                )
            );

            var about = _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'button',
                    {
                        id: 'about',
                        className: 'style--none',
                        onClick: this.handleAboutModal
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'navbar_dropdown.about',
                        defaultMessage: 'About Mattermost'
                    })
                )
            );

            var logout = _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'button',
                    {
                        className: 'style--none',
                        id: 'logout',
                        onClick: this.handleEmitUserLoggedOutEvent
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'navbar_dropdown.logout',
                        defaultMessage: 'Logout'
                    })
                )
            );

            var customEmoji = this.renderCustomEmojiLink();

            // Dividers.
            var inviteDivider = null;
            if (inviteLink || teamLink || addMemberToTeam) {
                inviteDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            var teamDivider = null;
            if (teamSettings || manageLink || teams) {
                teamDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            var backstageDivider = null;
            if (integrationsLink || customEmoji) {
                backstageDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            var sysAdminDivider = null;
            if (sysAdminLink) {
                sysAdminDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            var helpDivider = null;
            if (helpLink || reportLink || nativeAppLink || about) {
                helpDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            var logoutDivider = null;
            if (logout) {
                logoutDivider = _react2.default.createElement('li', { className: 'divider' });
            }

            return _react2.default.createElement(
                _reactBootstrap.Dropdown,
                {
                    id: 'sidebar-header-dropdown',
                    open: this.props.showDropdown,
                    onToggle: this.toggleDropdown,
                    className: 'sidebar-header-dropdown',
                    pullRight: true
                },
                _react2.default.createElement(_sidebar_header_dropdown_button2.default, {
                    bsRole: 'toggle',
                    onClick: this.toggleDropdown
                }),
                _react2.default.createElement(
                    _reactBootstrap.Dropdown.Menu,
                    { id: 'sidebarDropdownMenu' },
                    accountSettings,
                    inviteDivider,
                    inviteLink,
                    teamLink,
                    addMemberToTeam,
                    teamDivider,
                    teamSettings,
                    manageLink,
                    teams,
                    pluginDivider,
                    pluginItems,
                    backstageDivider,
                    integrationsLink,
                    customEmoji,
                    sysAdminDivider,
                    sysAdminLink,
                    helpDivider,
                    helpLink,
                    keyboardShortcuts,
                    reportLink,
                    nativeAppLink,
                    about,
                    logoutDivider,
                    logout,
                    teamMembersModal,
                    _react2.default.createElement(_team_settings_modal2.default, {
                        show: this.state.showTeamSettingsModal,
                        onModalDismissed: this.hideTeamSettingsModal
                    }),
                    _react2.default.createElement(_about_build_modal2.default, {
                        show: this.state.showAboutModal,
                        onModalDismissed: this.aboutModalDismissed
                    }),
                    addUsersToTeamModal
                )
            );
        }
    }]);
    return SidebarHeaderDropdown;
}(_react2.default.Component);

SidebarHeaderDropdown.propTypes = {
    teamId: _propTypes2.default.string,
    teamType: _propTypes2.default.string,
    teamDisplayName: _propTypes2.default.string,
    teamName: _propTypes2.default.string,
    currentUser: _propTypes2.default.object,
    appDownloadLink: _propTypes2.default.string,
    enableCommands: _propTypes2.default.bool.isRequired,
    enableCustomEmoji: _propTypes2.default.bool.isRequired,
    enableIncomingWebhooks: _propTypes2.default.bool.isRequired,
    enableOAuthServiceProvider: _propTypes2.default.bool.isRequired,
    enableOnlyAdminIntegrations: _propTypes2.default.bool.isRequired,
    enableOutgoingWebhooks: _propTypes2.default.bool.isRequired,
    enableTeamCreation: _propTypes2.default.bool.isRequired,
    enableUserCreation: _propTypes2.default.bool.isRequired,
    experimentalPrimaryTeam: _propTypes2.default.string,
    helpLink: _propTypes2.default.string,
    reportAProblemLink: _propTypes2.default.string,
    restrictTeamInvite: _propTypes2.default.string,
    showDropdown: _propTypes2.default.bool.isRequired,
    onToggleDropdown: _propTypes2.default.func.isRequired,
    pluginMenuItems: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
SidebarHeaderDropdown.defaultProps = {
    teamType: '',
    pluginMenuItems: []
};
exports.default = SidebarHeaderDropdown;

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _menu_icon = __webpack_require__(1085);

var _menu_icon2 = _interopRequireDefault(_menu_icon);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SidebarHeaderDropdownButton = function (_React$PureComponent) {
    (0, _inherits3.default)(SidebarHeaderDropdownButton, _React$PureComponent);

    function SidebarHeaderDropdownButton() {
        (0, _classCallCheck3.default)(this, SidebarHeaderDropdownButton);
        return (0, _possibleConstructorReturn3.default)(this, (SidebarHeaderDropdownButton.__proto__ || (0, _getPrototypeOf2.default)(SidebarHeaderDropdownButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(SidebarHeaderDropdownButton, [{
        key: 'render',
        value: function render() {
            var mainMenuToolTip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'main-menu__tooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'sidebar.mainMenu',
                    defaultMessage: 'Main menu'
                })
            );

            return _react2.default.createElement(
                _reactBootstrap.OverlayTrigger,
                {
                    trigger: ['hover', 'focus'],
                    delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                    placement: 'right',
                    overlay: mainMenuToolTip
                },
                _react2.default.createElement(
                    'button',
                    {
                        id: 'sidebarHeaderDropdownButton',
                        className: 'sidebar-header-dropdown__toggle cursor--pointer style--none',
                        onClick: this.props.onClick
                    },
                    _react2.default.createElement(_menu_icon2.default, { className: 'sidebar-header-dropdown__icon' })
                )
            );
        }
    }]);
    return SidebarHeaderDropdownButton;
}(_react2.default.PureComponent);

SidebarHeaderDropdownButton.propTypes = {
    bsRole: _propTypes2.default.oneOf(['toggle']).isRequired, // eslint-disable-line react/no-unused-prop-types
    onClick: _propTypes2.default.func.isRequired
};
exports.default = SidebarHeaderDropdownButton;

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _preferences = __webpack_require__(861);

var _channels = __webpack_require__(798);

var _channels2 = __webpack_require__(783);

var _common = __webpack_require__(280);

var _users = __webpack_require__(777);

var _preferences2 = __webpack_require__(784);

var _general = __webpack_require__(113);

var _channel_utils = __webpack_require__(854);

var _user_utils = __webpack_require__(175);

var _constants = __webpack_require__(29);

var _lhs = __webpack_require__(958);

var _sidebar_channel = __webpack_require__(2398);

var _sidebar_channel2 = _interopRequireDefault(_sidebar_channel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function makeMapStateToProps() {
    var getChannel = (0, _channels2.makeGetChannel)();

    return function (state, ownProps) {
        var channelId = ownProps.channelId;

        var config = (0, _general.getConfig)(state);
        var channel = getChannel(state, { id: channelId }) || {};

        var enableTutorial = config.EnableTutorial === 'true';
        var tutorialStep = (0, _preferences2.getInt)(state, _constants.Constants.Preferences.TUTORIAL_STEP, ownProps.currentUserId, _constants.Constants.TutorialSteps.FINISHED);
        var channelsByName = (0, _channels2.getChannelsNameMapInCurrentTeam)(state);
        var memberIds = (0, _users.getUserIdsInChannels)(state);

        var membersCount = 0;
        if (memberIds && memberIds[channel.id]) {
            membersCount = memberIds[channel.id].size;
            if (memberIds[channel.id].has(ownProps.currentUserId)) {
                membersCount--;
            }
        }

        var member = (0, _common.getMyChannelMemberships)(state)[channelId];

        var unreadMentions = 0;
        var unreadMsgs = 0;
        var showUnreadForMsgs = true;
        if (member) {
            unreadMentions = member.mention_count;

            if (channel) {
                unreadMsgs = Math.max(channel.total_msg_count - member.msg_count, 0);
            }

            if (member.notify_props) {
                showUnreadForMsgs = member.notify_props.mark_unread !== _constants.NotificationLevels.MENTION;
            }
        }

        var teammateNameDisplay = (0, _preferences2.getTeammateNameDisplaySetting)(state);
        var teammate = null;
        var channelTeammateId = '';
        var channelTeammateDeletedAt = 0;
        var channelTeammateUsername = '';
        var channelDisplayName = channel.display_name;
        if (channel.type === _constants.Constants.DM_CHANNEL) {
            teammate = (0, _users.getUser)(state, channel.teammate_id);
            if (teammate) {
                channelTeammateId = teammate.id;
                channelTeammateDeletedAt = teammate.delete_at;
                channelTeammateUsername = teammate.username;
            }

            channelDisplayName = (0, _user_utils.displayUsername)(teammate, teammateNameDisplay);
        }

        var shouldHideChannel = (0, _channels2.isChannelReadOnly)(state, channel) && !ownProps.active && !(0, _channel_utils.isFavoriteChannel)(state.entities.preferences.myPreferences, channel.id);

        return {
            config: config,
            channelId: channelId,
            channelName: channel.name,
            channelDisplayName: channelDisplayName,
            channelType: channel.type,
            channelStatus: channel.status,
            channelFake: channel.fake,
            channelMuted: (0, _channel_utils.isChannelMuted)(member),
            channelStringified: channel.fake && (0, _stringify2.default)(channel),
            channelTeammateId: channelTeammateId,
            channelTeammateUsername: channelTeammateUsername,
            channelTeammateDeletedAt: channelTeammateDeletedAt,
            showTutorialTip: enableTutorial && tutorialStep === _constants.Constants.TutorialSteps.CHANNEL_POPOVER,
            townSquareDisplayName: channelsByName[_constants.Constants.DEFAULT_CHANNEL] && channelsByName[_constants.Constants.DEFAULT_CHANNEL].display_name,
            offTopicDisplayName: channelsByName[_constants.Constants.OFFTOPIC_CHANNEL] && channelsByName[_constants.Constants.OFFTOPIC_CHANNEL].display_name,
            showUnreadForMsgs: showUnreadForMsgs,
            unreadMsgs: unreadMsgs,
            unreadMentions: unreadMentions,
            membersCount: membersCount,
            shouldHideChannel: shouldHideChannel
        };
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            savePreferences: _preferences.savePreferences,
            leaveChannel: _channels.leaveChannel,
            openLhs: _lhs.open
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps, null, { withRef: true })(_sidebar_channel2.default);

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _browser_history = __webpack_require__(273);

var _constants = __webpack_require__(29);

var _diagnostics_actions = __webpack_require__(804);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _sidebar_channel_button_or_link = __webpack_require__(2399);

var _sidebar_channel_button_or_link2 = _interopRequireDefault(_sidebar_channel_button_or_link);

var _sidebar_tutorial_tip = __webpack_require__(2403);

var _sidebar_tutorial_tip2 = _interopRequireDefault(_sidebar_tutorial_tip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarChannel = function (_React$PureComponent) {
    (0, _inherits3.default)(SidebarChannel, _React$PureComponent);

    function SidebarChannel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SidebarChannel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SidebarChannel.__proto__ || (0, _getPrototypeOf2.default)(SidebarChannel)).call.apply(_ref, [this].concat(args))), _this), _this.isLeaving = false, _this.handleLeavePublicChannel = function () {
            _this.props.actions.leaveChannel(_this.props.channelId);
            (0, _diagnostics_actions.trackEvent)('ui', 'ui_public_channel_x_button_clicked');
        }, _this.handleLeavePrivateChannel = function () {
            GlobalActions.showLeavePrivateChannelModal({ id: _this.props.channelId, display_name: _this.props.channelDisplayName });
            (0, _diagnostics_actions.trackEvent)('ui', 'ui_private_channel_x_button_clicked');
        }, _this.handleLeaveDirectChannel = function () {
            if (!_this.isLeaving) {
                _this.isLeaving = true;

                var id = void 0;
                var category = void 0;
                if (_this.props.channelType === _constants.Constants.DM_CHANNEL) {
                    id = _this.props.channelTeammateId;
                    category = _constants.Constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW;
                } else {
                    id = _this.props.channelId;
                    category = _constants.Constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW;
                }

                var currentUserId = _this.props.currentUserId;
                _this.props.actions.savePreferences(currentUserId, [{ user_id: currentUserId, category: category, name: id, value: 'false' }]).then(function () {
                    _this.isLeaving = false;
                });

                (0, _diagnostics_actions.trackEvent)('ui', 'ui_direct_channel_x_button_clicked');
            }

            if (_this.props.active) {
                _browser_history.browserHistory.push('/' + _this.props.currentTeamName + '/channels/' + _constants.Constants.DEFAULT_CHANNEL);
            }
        }, _this.showChannelAsUnread = function () {
            return _this.props.unreadMentions > 0 || _this.props.unreadMsgs > 0 && _this.props.showUnreadForMsgs;
        }, _this.render = function () {
            if (!_this.props.channelDisplayName || !_this.props.channelType) {
                return _react2.default.createElement('div', null);
            }

            var closeHandler = null;
            if (!_this.showChannelAsUnread()) {
                if (_this.props.shouldHideChannel) {
                    return '';
                }
                if (_this.props.channelType === _constants.Constants.DM_CHANNEL || _this.props.channelType === _constants.Constants.GM_CHANNEL) {
                    closeHandler = _this.handleLeaveDirectChannel;
                } else if (_this.props.config.EnableXToLeaveChannelsFromLHS === 'true') {
                    if (_this.props.channelType === _constants.Constants.OPEN_CHANNEL && _this.props.channelName !== _constants.Constants.DEFAULT_CHANNEL) {
                        closeHandler = _this.handleLeavePublicChannel;
                    } else if (_this.props.channelType === _constants.Constants.PRIVATE_CHANNEL) {
                        closeHandler = _this.handleLeavePrivateChannel;
                    }
                }
            }

            var linkClass = '';
            if (_this.props.active) {
                linkClass = 'active';
            }

            var rowClass = 'sidebar-item';
            var badge = false;
            if (_this.showChannelAsUnread()) {
                rowClass += ' unread-title';
            }

            if (_this.props.unreadMentions > 0) {
                rowClass += ' has-badge';

                badge = true;
            }

            if (_this.props.channelMuted) {
                rowClass += ' muted';
            }

            if (closeHandler && !badge) {
                rowClass += ' has-close';
            }

            var tutorialTip = null;
            if (_this.props.showTutorialTip && _this.props.channelName === _constants.Constants.DEFAULT_CHANNEL) {
                tutorialTip = _react2.default.createElement(_sidebar_tutorial_tip2.default, {
                    townSquareDisplayName: _this.props.townSquareDisplayName,
                    offTopicDisplayName: _this.props.offTopicDisplayName
                });
                _this.props.actions.openLhs();
            }

            var link = '';
            if (_this.props.channelFake) {
                link = '/' + _this.props.currentTeamName + '/channels/' + _this.props.channelName + '?fakechannel=' + encodeURIComponent(_this.props.channelStringified);
            } else if (_this.props.channelType === _constants.Constants.DM_CHANNEL) {
                link = '/' + _this.props.currentTeamName + '/messages/@' + _this.props.channelTeammateUsername;
            } else if (_this.props.channelType === _constants.Constants.GM_CHANNEL) {
                link = '/' + _this.props.currentTeamName + '/messages/' + _this.props.channelName;
            } else {
                link = '/' + _this.props.currentTeamName + '/channels/' + _this.props.channelName;
            }

            var displayName = '';
            if (_this.props.currentUserId === _this.props.channelTeammateId) {
                displayName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'sidebar.directchannel.you',
                    defaultMessage: '{displayname} (you)',
                    values: {
                        displayname: _this.props.channelDisplayName
                    }
                });
            } else {
                displayName = _this.props.channelDisplayName;
            }

            return _react2.default.createElement(
                'li',
                {
                    key: _this.props.channelName,
                    ref: 'channel',
                    className: linkClass
                },
                _react2.default.createElement(_sidebar_channel_button_or_link2.default, {
                    link: link,
                    rowClass: rowClass,
                    channelId: _this.props.channelId,
                    channelStatus: _this.props.channelStatus,
                    channelType: _this.props.channelType,
                    displayName: displayName,
                    handleClose: closeHandler,
                    badge: badge,
                    unreadMentions: _this.props.unreadMentions,
                    membersCount: _this.props.membersCount,
                    teammateId: _this.props.channelTeammateId,
                    teammateDeletedAt: _this.props.channelTeammateDeletedAt
                }),
                tutorialTip
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return SidebarChannel;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SidebarChannel.propTypes = {

    /**
     * Global config object
     */
    config: _propTypes2.default.object.isRequired,

    /**
     * Channel id
     */
    channelId: _propTypes2.default.string.isRequired,

    /**
     * Channel name
     */
    channelName: _propTypes2.default.string.isRequired,

    /**
     * Channel display name
     */
    channelDisplayName: _propTypes2.default.string.isRequired,

    /**
     * Channel is muted
     */
    channelMuted: _propTypes2.default.bool,

    /**
     * Channel type
     */
    channelType: _propTypes2.default.string.isRequired,

    /**
     * Channel status
     */
    channelStatus: _propTypes2.default.string,

    /**
     * Channel is fake
     */
    channelFake: _propTypes2.default.bool,

    /**
     * Serialized channel information (for fake channels)
     */
    channelStringified: _propTypes2.default.string,

    /**
     * Teammate id (for direct messages)
     */
    channelTeammateId: _propTypes2.default.string,

    /**
     * Teammate username (for direct messages)
     */
    channelTeammateUsername: _propTypes2.default.string,

    /**
     * Teammate delete at date (for direct messages)
     */
    channelTeammateDeletedAt: _propTypes2.default.number,

    /**
     * Whether or not to mark the channel as unread when it has unread messages and no mentions
     */
    showUnreadForMsgs: _propTypes2.default.bool.isRequired,

    /**
     * Number of unread messages
     */
    unreadMsgs: _propTypes2.default.number.isRequired,

    /**
     * Number of unread mentions
     */
    unreadMentions: _propTypes2.default.number.isRequired,

    /**
     * Set if the channel is the current active channel
     */
    active: _propTypes2.default.bool.isRequired,

    /**
     * Current team name
     */
    currentTeamName: _propTypes2.default.string.isRequired,

    /**
     * Current user id
     */
    currentUserId: _propTypes2.default.string.isRequired,

    /**
     * Set if the tutorial must be shown
     */
    showTutorialTip: _propTypes2.default.bool.isRequired,

    /**
     * TownSquare (default channel) display name
     */
    townSquareDisplayName: _propTypes2.default.string,

    /**
     * OffTopic (default channel) display name
     */
    offTopicDisplayName: _propTypes2.default.string,

    /**
     * Number of members
     */
    membersCount: _propTypes2.default.number.isRequired,

    /**
     * Flag if channel should be hidden in sidebar
     */
    shouldHideChannel: _propTypes2.default.bool.isRequired,

    actions: _propTypes2.default.shape({
        savePreferences: _propTypes2.default.func.isRequired,
        leaveChannel: _propTypes2.default.func.isRequired,
        openLhs: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = SidebarChannel;

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(269);

var _browser_history = __webpack_require__(273);

var _diagnostics_actions = __webpack_require__(804);

var _user_agent = __webpack_require__(790);

var _copy_url_context_menu = __webpack_require__(1408);

var _copy_url_context_menu2 = _interopRequireDefault(_copy_url_context_menu);

var _sidebar_channel_button_or_link_icon = __webpack_require__(2400);

var _sidebar_channel_button_or_link_icon2 = _interopRequireDefault(_sidebar_channel_button_or_link_icon);

var _sidebar_channel_button_or_link_close_button = __webpack_require__(2402);

var _sidebar_channel_button_or_link_close_button2 = _interopRequireDefault(_sidebar_channel_button_or_link_close_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarChannelButtonOrLink = function (_React$PureComponent) {
    (0, _inherits3.default)(SidebarChannelButtonOrLink, _React$PureComponent);

    function SidebarChannelButtonOrLink() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SidebarChannelButtonOrLink);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SidebarChannelButtonOrLink.__proto__ || (0, _getPrototypeOf2.default)(SidebarChannelButtonOrLink)).call.apply(_ref, [this].concat(args))), _this), _this.trackChannelSelectedEvent = function () {
            (0, _diagnostics_actions.mark)('SidebarChannelLink#click');
            (0, _diagnostics_actions.trackEvent)('ui', 'ui_channel_selected');
        }, _this.handleClick = function () {
            _this.trackChannelSelectedEvent();
            _browser_history.browserHistory.push(_this.props.link);
        }, _this.render = function () {
            var badge = null;
            if (_this.props.badge) {
                badge = _react2.default.createElement(
                    'span',
                    { className: 'badge' },
                    _this.props.unreadMentions
                );
            }

            var content = _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_sidebar_channel_button_or_link_icon2.default, {
                    channelId: _this.props.channelId,
                    channelStatus: _this.props.channelStatus,
                    channelType: _this.props.channelType,
                    membersCount: _this.props.membersCount,
                    teammateId: _this.props.teammateId,
                    teammateDeletedAt: _this.props.teammateDeletedAt
                }),
                _react2.default.createElement(
                    'span',
                    { className: 'sidebar-item__name' },
                    _this.props.displayName
                ),
                badge,
                _react2.default.createElement(_sidebar_channel_button_or_link_close_button2.default, {
                    handleClose: _this.props.handleClose,
                    channelId: _this.props.channelId,
                    channelType: _this.props.channelType,
                    teammateId: _this.props.teammateId,
                    badge: _this.props.badge
                })
            );

            var element = void 0;
            if ((0, _user_agent.isDesktopApp)()) {
                element = _react2.default.createElement(
                    _copy_url_context_menu2.default,
                    {
                        link: _this.props.link,
                        menuId: _this.props.channelId
                    },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-link ' + _this.props.rowClass,
                            onClick: _this.handleClick
                        },
                        content
                    )
                );
            } else {
                element = _react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        to: _this.props.link,
                        className: _this.props.rowClass,
                        onClick: _this.trackChannelSelectedEvent
                    },
                    content
                );
            }

            return element;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return SidebarChannelButtonOrLink;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SidebarChannelButtonOrLink.propTypes = {
    link: _propTypes2.default.string.isRequired,
    rowClass: _propTypes2.default.string.isRequired,
    channelType: _propTypes2.default.string.isRequired,
    channelId: _propTypes2.default.string.isRequired,
    displayName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
    channelStatus: _propTypes2.default.string,
    handleClose: _propTypes2.default.func,
    badge: _propTypes2.default.bool,
    membersCount: _propTypes2.default.number.isRequired,
    unreadMentions: _propTypes2.default.number,
    teammateId: _propTypes2.default.string,
    teammateDeletedAt: _propTypes2.default.number
};
exports.default = SidebarChannelButtonOrLink;

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(29);

var _status_icon = __webpack_require__(932);

var _status_icon2 = _interopRequireDefault(_status_icon);

var _archive_icon = __webpack_require__(2401);

var _archive_icon2 = _interopRequireDefault(_archive_icon);

var _globe_icon = __webpack_require__(1086);

var _globe_icon2 = _interopRequireDefault(_globe_icon);

var _lock_icon = __webpack_require__(1087);

var _lock_icon2 = _interopRequireDefault(_lock_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarChannelButtonOrLinkIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(SidebarChannelButtonOrLinkIcon, _React$PureComponent);

    function SidebarChannelButtonOrLinkIcon() {
        (0, _classCallCheck3.default)(this, SidebarChannelButtonOrLinkIcon);
        return (0, _possibleConstructorReturn3.default)(this, (SidebarChannelButtonOrLinkIcon.__proto__ || (0, _getPrototypeOf2.default)(SidebarChannelButtonOrLinkIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(SidebarChannelButtonOrLinkIcon, [{
        key: 'render',
        value: function render() {
            var icon = null;
            if (this.props.channelType === _constants.Constants.OPEN_CHANNEL) {
                icon = _react2.default.createElement(_globe_icon2.default, { className: 'icon icon__globe' });
            } else if (this.props.channelType === _constants.Constants.PRIVATE_CHANNEL) {
                icon = _react2.default.createElement(_lock_icon2.default, { className: 'icon icon__lock' });
            } else if (this.props.channelType === _constants.Constants.GM_CHANNEL) {
                icon = _react2.default.createElement(
                    'div',
                    { className: 'status status--group' },
                    this.props.membersCount
                );
            } else if (this.props.channelType === _constants.Constants.DM_CHANNEL) {
                if (this.props.teammateId && this.props.teammateDeletedAt) {
                    icon = _react2.default.createElement(_archive_icon2.default, { className: 'icon icon__archive' });
                } else {
                    icon = _react2.default.createElement(_status_icon2.default, {
                        type: 'avatar',
                        status: this.props.channelStatus
                    });
                }
            }
            return icon;
        }
    }]);
    return SidebarChannelButtonOrLinkIcon;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SidebarChannelButtonOrLinkIcon.propTypes = {
    channelType: _propTypes2.default.string.isRequired,
    channelId: _propTypes2.default.string.isRequired,
    membersCount: _propTypes2.default.number,
    channelStatus: _propTypes2.default.string,
    teammateId: _propTypes2.default.string,
    teammateDeletedAt: _propTypes2.default.number
};
exports.default = SidebarChannelButtonOrLinkIcon;

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArchiveIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(ArchiveIcon, _React$PureComponent);

    function ArchiveIcon() {
        (0, _classCallCheck3.default)(this, ArchiveIcon);
        return (0, _possibleConstructorReturn3.default)(this, (ArchiveIcon.__proto__ || (0, _getPrototypeOf2.default)(ArchiveIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(ArchiveIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '14',
                        height: '14',
                        viewBox: '0 0 14 14'
                    },
                    _react2.default.createElement('path', { d: 'M8.5 6.5q0-0.203-0.148-0.352t-0.352-0.148h-2q-0.203 0-0.352 0.148t-0.148 0.352 0.148 0.352 0.352 0.148h2q0.203 0 0.352-0.148t0.148-0.352zM13 5v7.5q0 0.203-0.148 0.352t-0.352 0.148h-11q-0.203 0-0.352-0.148t-0.148-0.352v-7.5q0-0.203 0.148-0.352t0.352-0.148h11q0.203 0 0.352 0.148t0.148 0.352zM13.5 1.5v2q0 0.203-0.148 0.352t-0.352 0.148h-12q-0.203 0-0.352-0.148t-0.148-0.352v-2q0-0.203 0.148-0.352t0.352-0.148h12q0.203 0 0.352 0.148t0.148 0.352z' })
                )
            );
        }
    }]);
    return ArchiveIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = ArchiveIcon;

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarChannelButtonOrLinkCloseButton = function (_React$PureComponent) {
    (0, _inherits3.default)(SidebarChannelButtonOrLinkCloseButton, _React$PureComponent);

    function SidebarChannelButtonOrLinkCloseButton() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SidebarChannelButtonOrLinkCloseButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SidebarChannelButtonOrLinkCloseButton.__proto__ || (0, _getPrototypeOf2.default)(SidebarChannelButtonOrLinkCloseButton)).call.apply(_ref, [this].concat(args))), _this), _this.overlayTriggerAttr = ['hover', 'focus'], _this.handleClose = function (e) {
            e.stopPropagation();
            e.preventDefault();
            _this.props.handleClose();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SidebarChannelButtonOrLinkCloseButton, [{
        key: 'render',
        value: function render() {
            var closeButton = null;

            if (this.props.handleClose && !this.props.badge) {
                var removeTooltip = _react2.default.createElement(
                    _reactBootstrap.Tooltip,
                    { id: 'remove-dm-tooltip' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'sidebar.removeList',
                        defaultMessage: 'Remove from list'
                    })
                );

                if (this.props.channelType === _constants.Constants.OPEN_CHANNEL || this.props.channelType === _constants.Constants.PRIVATE_CHANNEL) {
                    removeTooltip = _react2.default.createElement(
                        _reactBootstrap.Tooltip,
                        { id: 'remove-dm-tooltip' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'sidebar.leave',
                            defaultMessage: 'Leave channel'
                        })
                    );
                }

                closeButton = _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        trigger: this.overlayTriggerAttr,
                        delayShow: 1000,
                        placement: 'top',
                        overlay: removeTooltip
                    },
                    _react2.default.createElement(
                        'span',
                        {
                            onClick: this.handleClose,
                            className: 'btn-close'
                        },
                        '×'
                    )
                );
            }
            return closeButton;
        }
    }]);
    return SidebarChannelButtonOrLinkCloseButton;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SidebarChannelButtonOrLinkCloseButton.propTypes = {
    handleClose: _propTypes2.default.func,
    channelId: _propTypes2.default.string.isRequired,
    channelType: _propTypes2.default.string.isRequired,
    teammateId: _propTypes2.default.string,
    badge: _propTypes2.default.bool
};
exports.default = SidebarChannelButtonOrLinkCloseButton;

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _tutorial_tip = __webpack_require__(1053);

var _tutorial_tip2 = _interopRequireDefault(_tutorial_tip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarTutorialTip = function (_React$PureComponent) {
    (0, _inherits3.default)(SidebarTutorialTip, _React$PureComponent);

    function SidebarTutorialTip() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SidebarTutorialTip);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SidebarTutorialTip.__proto__ || (0, _getPrototypeOf2.default)(SidebarTutorialTip)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            var screens = [];

            var townSquareDisplayName = _constants.Constants.DEFAULT_CHANNEL_UI_NAME;
            if (_this.props.townSquareDisplayName) {
                townSquareDisplayName = _this.props.townSquareDisplayName;
            }

            var offTopicDisplayName = _constants.Constants.OFFTOPIC_CHANNEL_UI_NAME;
            if (_this.props.offTopicDisplayName) {
                offTopicDisplayName = _this.props.offTopicDisplayName;
            }

            screens.push(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'sidebar.tutorialScreen1',
                    defaultMessage: '<h4>Channels</h4><p><strong>Channels</strong> organize conversations across different topics. They\u2019re open to everyone on your team. To send private communications use <strong>Direct Messages</strong> for a single person or <strong>Private Channels</strong> for multiple people.</p>'
                })
            ));

            screens.push(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'sidebar.tutorialScreen2',
                    defaultMessage: '<h4>"{townsquare}" and "{offtopic}" channels</h4> <p>Here are two public channels to start:</p> <p><strong>{townsquare}</strong> is a place for team-wide communication. Everyone in your team is a member of this channel.</p> <p><strong>{offtopic}</strong> is a place for fun and humor outside of work-related channels. You and your team can decide what other channels to create.</p>',
                    values: {
                        townsquare: townSquareDisplayName,
                        offtopic: offTopicDisplayName
                    }
                })
            ));

            screens.push(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'sidebar.tutorialScreen3',
                    defaultMessage: '<h4>Creating and Joining Channels</h4> <p>Click <strong>"More..."</strong> to create a new channel or join an existing one.</p> <p>You can also create a new public or private channel by clicking the <strong>"+" symbol</strong> next to the public or private channel header.</p>'
                })
            ));

            return _react2.default.createElement(_tutorial_tip2.default, {
                placement: 'right',
                screens: screens,
                overlayClass: 'tip-overlay--sidebar',
                diagnosticsTag: 'tutorial_tip_2_channels'
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return SidebarTutorialTip;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SidebarTutorialTip.propTypes = {
    townSquareDisplayName: _propTypes2.default.string,
    offTopicDisplayName: _propTypes2.default.string
};
exports.default = SidebarTutorialTip;

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _teams = __webpack_require__(274);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _storage = __webpack_require__(957);

var _rhs = __webpack_require__(818);

var _lhs = __webpack_require__(1083);

var _webrtc = __webpack_require__(1406);

var _center_channel = __webpack_require__(2405);

var _center_channel2 = _interopRequireDefault(_center_channel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost Inc. All Rights Reserved.
// See License.txt for license information.

var getLastChannelPath = function getLastChannelPath(state, teamName) {
    var team = (0, _teams.getTeamByName)(state, teamName);

    if (team) {
        return (0, _storage.getGlobalItem)(state, _constants2.default.PREV_CHANNEL_KEY + team.id, _constants2.default.DEFAULT_CHANNEL);
    }
    return _constants2.default.DEFAULT_CHANNEL;
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        lastChannelPath: ownProps.match.url + '/channels/' + getLastChannelPath(state, ownProps.match.params.team),
        lhsOpen: (0, _lhs.getIsLhsOpen)(state),
        rhsOpen: (0, _rhs.getIsRhsOpen)(state),
        rhsMenuOpen: (0, _rhs.getIsRhsMenuOpen)(state),
        webRtcOpen: (0, _webrtc.getIsWebrtcOpen)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_center_channel2.default);

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(269);

var _classnames = __webpack_require__(769);

var _classnames2 = _interopRequireDefault(_classnames);

var _permalink_view = __webpack_require__(2406);

var _permalink_view2 = _interopRequireDefault(_permalink_view);

var _navbar = __webpack_require__(2465);

var _navbar2 = _interopRequireDefault(_navbar);

var _channel_identifier_router = __webpack_require__(2474);

var _channel_identifier_router2 = _interopRequireDefault(_channel_identifier_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CenterChannel = function (_React$PureComponent) {
    (0, _inherits3.default)(CenterChannel, _React$PureComponent);

    function CenterChannel(props) {
        (0, _classCallCheck3.default)(this, CenterChannel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CenterChannel.__proto__ || (0, _getPrototypeOf2.default)(CenterChannel)).call(this, props));

        _this.state = {
            returnTo: ''
        };
        return _this;
    }

    (0, _createClass3.default)(CenterChannel, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.location.pathname !== nextProps.location.pathname && nextProps.location.pathname.includes('/pl/')) {
                this.setState({ returnTo: this.props.location.pathname });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var lastChannelPath = this.props.lastChannelPath;

            var url = this.props.match.url;
            return _react2.default.createElement(
                'div',
                {
                    key: 'inner-wrap',
                    className: (0, _classnames2.default)('inner-wrap', 'channel__wrap', {
                        'webrtc--show': this.props.webRtcOpen,
                        'move--right': this.props.lhsOpen,
                        'move--left': this.props.rhsOpen || this.props.webRtcOpen,
                        'move--left-small': this.props.rhsMenuOpen
                    })
                },
                _react2.default.createElement(
                    'div',
                    { className: 'row header' },
                    _react2.default.createElement(
                        'div',
                        { id: 'navbar' },
                        _react2.default.createElement(_navbar2.default, null)
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row main' },
                    _react2.default.createElement(
                        _reactRouterDom.Switch,
                        null,
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: url + '/pl/:postid',
                            render: function render(props) {
                                return _react2.default.createElement(_permalink_view2.default, (0, _extends3.default)({}, props, {
                                    returnTo: _this2.state.returnTo
                                }));
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: '/:team/:path(channels|messages)/:identifier',
                            component: _channel_identifier_router2.default
                        }),
                        _react2.default.createElement(_reactRouterDom.Redirect, { to: lastChannelPath })
                    )
                )
            );
        }
    }]);
    return CenterChannel;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

CenterChannel.propTypes = {
    match: _propTypes2.default.object.isRequired,
    location: _propTypes2.default.object.isRequired,
    lastChannelPath: _propTypes2.default.string.isRequired,
    lhsOpen: _propTypes2.default.bool.isRequired,
    rhsOpen: _propTypes2.default.bool.isRequired,
    rhsMenuOpen: _propTypes2.default.bool.isRequired,
    webRtcOpen: _propTypes2.default.bool.isRequired
};
exports.default = CenterChannel;

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(783);

var _teams = __webpack_require__(274);

var _permalink_view = __webpack_require__(2407);

var _permalink_view2 = _interopRequireDefault(_permalink_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var team = (0, _teams.getCurrentTeam)(state);
    var channel = (0, _channels.getCurrentChannel)(state);
    var channelId = '';
    var channelName = '';
    if (channel) {
        channelId = channel.id;
        channelName = channel.name;
    }

    var teamName = '';
    if (team) {
        teamName = team.name;
    }

    return {
        channelId: channelId,
        channelName: channelName,
        teamName: teamName
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_permalink_view2.default);

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _channel_header = __webpack_require__(1410);

var _channel_header2 = _interopRequireDefault(_channel_header);

var _post_view = __webpack_require__(1421);

var _post_view2 = _interopRequireDefault(_post_view);

var _global_actions = __webpack_require__(778);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PermalinkView = function (_React$PureComponent) {
    (0, _inherits3.default)(PermalinkView, _React$PureComponent);

    function PermalinkView(props) {
        (0, _classCallCheck3.default)(this, PermalinkView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PermalinkView.__proto__ || (0, _getPrototypeOf2.default)(PermalinkView)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = { valid: false };
        return _this;
    }

    (0, _createClass3.default)(PermalinkView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.doPermalinkEvent(this.props);
            document.body.classList.add('app__body');
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.classList.remove('app__body');
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.match.params.postid !== nextProps.match.params.postid) {
                this.doPermalinkEvent(nextProps);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                channelId = _props.channelId,
                channelName = _props.channelName,
                match = _props.match,
                teamName = _props.teamName;


            if (!this.isStateValid()) {
                return _react2.default.createElement('div', {
                    id: 'app-content',
                    className: 'app__content'
                });
            }

            return _react2.default.createElement(
                'div',
                {
                    id: 'app-content',
                    className: 'app__content'
                },
                _react2.default.createElement(_channel_header2.default, {
                    channelId: channelId
                }),
                _react2.default.createElement(_post_view2.default, {
                    channelId: channelId,
                    focusedPostId: match.params.postid
                }),
                _react2.default.createElement(
                    'div',
                    { id: 'archive-link-home' },
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            to: '/' + teamName + '/channels/' + channelName
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'center_panel.recent',
                            defaultMessage: 'Click here to jump to recent messages. '
                        }),
                        _react2.default.createElement('i', { className: 'fa fa-arrow-down' })
                    )
                )
            );
        }
    }]);
    return PermalinkView;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PermalinkView.propTypes = {
    channelId: _propTypes2.default.string,
    channelName: _propTypes2.default.string,

    /*
     * Object from react-router
     */
    match: _propTypes2.default.shape({
        params: _propTypes2.default.shape({
            postid: _propTypes2.default.string.isRequired
        }).isRequired
    }).isRequired,
    returnTo: _propTypes2.default.string.isRequired,
    teamName: _propTypes2.default.string
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.doPermalinkEvent = function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(props) {
            var postId;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this2.setState({ valid: false });
                            postId = props.match.params.postid;
                            _context.next = 4;
                            return (0, _global_actions.emitPostFocusEvent)(postId, _this2.props.returnTo);

                        case 4:
                            _this2.setState({ valid: true });

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    this.isStateValid = function () {
        return _this2.state.valid && _this2.props.channelId && _this2.props.teamName;
    };
};

exports.default = PermalinkView;

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

__webpack_require__(1411);

var _channel_utils = __webpack_require__(854);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _webrtc_actions = __webpack_require__(905);

var WebrtcActions = _interopRequireWildcard(_webrtc_actions);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _message_wrapper = __webpack_require__(1412);

var _message_wrapper2 = _interopRequireDefault(_message_wrapper);

var _constants2 = __webpack_require__(29);

var _text_formatting = __webpack_require__(811);

var TextFormatting = _interopRequireWildcard(_text_formatting);

var _url = __webpack_require__(793);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _post_utils = __webpack_require__(803);

var _channel_info_modal = __webpack_require__(1413);

var _channel_info_modal2 = _interopRequireDefault(_channel_info_modal);

var _channel_invite_modal = __webpack_require__(986);

var _channel_invite_modal2 = _interopRequireDefault(_channel_invite_modal);

var _channel_members_modal = __webpack_require__(1088);

var _channel_members_modal2 = _interopRequireDefault(_channel_members_modal);

var _channel_notifications_modal = __webpack_require__(1414);

var _channel_notifications_modal2 = _interopRequireDefault(_channel_notifications_modal);

var _delete_channel_modal = __webpack_require__(1417);

var _delete_channel_modal2 = _interopRequireDefault(_delete_channel_modal);

var _edit_channel_header_modal = __webpack_require__(1089);

var _edit_channel_header_modal2 = _interopRequireDefault(_edit_channel_header_modal);

var _edit_channel_purpose_modal = __webpack_require__(1418);

var _edit_channel_purpose_modal2 = _interopRequireDefault(_edit_channel_purpose_modal);

var _more_direct_channels = __webpack_require__(1084);

var _more_direct_channels2 = _interopRequireDefault(_more_direct_channels);

var _popover_list_members = __webpack_require__(2436);

var _popover_list_members2 = _interopRequireDefault(_popover_list_members);

var _rename_channel_modal = __webpack_require__(1419);

var _rename_channel_modal2 = _interopRequireDefault(_rename_channel_modal);

var _search_bar = __webpack_require__(1047);

var _search_bar2 = _interopRequireDefault(_search_bar);

var _status_icon = __webpack_require__(932);

var _status_icon2 = _interopRequireDefault(_status_icon);

var _flag_icon = __webpack_require__(974);

var _flag_icon2 = _interopRequireDefault(_flag_icon);

var _mentions_icon = __webpack_require__(1330);

var _mentions_icon2 = _interopRequireDefault(_mentions_icon);

var _pin_icon = __webpack_require__(2442);

var _pin_icon2 = _interopRequireDefault(_pin_icon);

var _search_icon = __webpack_require__(1048);

var _search_icon2 = _interopRequireDefault(_search_icon);

var _toggle_modal_button_redux = __webpack_require__(1420);

var _toggle_modal_button_redux2 = _interopRequireDefault(_toggle_modal_button_redux);

var _channel_permission_gate = __webpack_require__(888);

var _channel_permission_gate2 = _interopRequireDefault(_channel_permission_gate);

var _pluggable = __webpack_require__(881);

var _pluggable2 = _interopRequireDefault(_pluggable);

var _header_icon_wrapper = __webpack_require__(1329);

var _header_icon_wrapper2 = _interopRequireDefault(_header_icon_wrapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PreReleaseFeatures = _constants2.Constants.PRE_RELEASE_FEATURES;
var SEARCH_BAR_MINIMUM_WINDOW_SIZE = 1140;

var ChannelHeader = function (_React$Component) {
    (0, _inherits3.default)(ChannelHeader, _React$Component);

    function ChannelHeader(props) {
        (0, _classCallCheck3.default)(this, ChannelHeader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelHeader.__proto__ || (0, _getPrototypeOf2.default)(ChannelHeader)).call(this, props));

        _this.handleResize = function () {
            var windowWidth = Utils.windowWidth();

            _this.setState({ showSearchBar: windowWidth > SEARCH_BAR_MINIMUM_WINDOW_SIZE });
        };

        _this.onWebrtcChange = function () {
            _this.setState({ isBusy: _webrtc_store2.default.isBusy() });
        };

        _this.onBusy = function (isBusy) {
            _this.setState({ isBusy: isBusy });
        };

        _this.handleLeave = function () {
            if (_this.props.channel.type === _constants2.Constants.PRIVATE_CHANNEL) {
                GlobalActions.showLeavePrivateChannelModal(_this.props.channel);
            } else {
                _this.props.actions.leaveChannel(_this.props.channel.id);
            }
        };

        _this.toggleFavorite = function () {
            if (_this.props.isFavorite) {
                _this.props.actions.unfavoriteChannel(_this.props.channel.id);
            } else {
                _this.props.actions.favoriteChannel(_this.props.channel.id);
            }
        };

        _this.unmute = function () {
            var _this$props = _this.props,
                actions = _this$props.actions,
                channel = _this$props.channel,
                channelMember = _this$props.channelMember,
                currentUser = _this$props.currentUser;


            if (!channelMember || !currentUser || !channel) {
                return;
            }

            var options = { mark_unread: _constants2.NotificationLevels.ALL };
            actions.updateChannelNotifyProps(currentUser.id, channel.id, options);
        };

        _this.searchMentions = function (e) {
            e.preventDefault();
            if (_this.props.rhsState === _constants2.RHSStates.MENTION) {
                _this.props.actions.closeRightHandSide();
            } else {
                _this.props.actions.showMentions();
            }
        };

        _this.getPinnedPosts = function (e) {
            e.preventDefault();
            if (_this.props.rhsState === _constants2.RHSStates.PIN) {
                _this.props.actions.closeRightHandSide();
            } else {
                _this.props.actions.showPinnedPosts();
            }
        };

        _this.getFlagged = function (e) {
            e.preventDefault();
            if (_this.props.rhsState === _constants2.RHSStates.FLAG) {
                _this.props.actions.closeRightHandSide();
            } else {
                _this.props.actions.showFlaggedPosts();
            }
        };

        _this.searchButtonClick = function (e) {
            e.preventDefault();
            _this.props.actions.updateRhsState(_constants2.RHSStates.SEARCH);
        };

        _this.handleShortcut = function (e) {
            if (Utils.cmdOrCtrlPressed(e) && e.shiftKey) {
                if (Utils.isKeyPressed(e, _constants2.Constants.KeyCodes.M)) {
                    e.preventDefault();
                    _this.searchMentions(e);
                }
            }
        };

        _this.showRenameChannelModal = function (e) {
            e.preventDefault();

            _this.setState({
                showRenameChannelModal: true
            });
        };

        _this.hideRenameChannelModal = function () {
            _this.setState({
                showRenameChannelModal: false
            });
        };

        _this.showChannelNotificationsModal = function (e) {
            e.preventDefault();

            _this.setState({
                showChannelNotificationsModal: true
            });
        };

        _this.hideChannelNotificationsModal = function () {
            _this.setState({
                showChannelNotificationsModal: false
            });
        };

        _this.initWebrtc = function (contactId, isOnline) {
            if (isOnline && !_this.state.isBusy) {
                _this.props.actions.closeRightHandSide();
                WebrtcActions.initWebrtc(contactId, true);
            }
        };

        _this.handleOnMouseOver = function () {
            if (_this.refs.headerOverlay) {
                _this.refs.headerOverlay.show();
            }
        };

        _this.handleOnMouseOut = function () {
            if (_this.refs.headerOverlay) {
                _this.refs.headerOverlay.hide();
            }
        };

        _this.showMembersModal = function () {
            _this.setState({ showMembersModal: true });
        };

        _this.hideMembersModal = function () {
            _this.setState({ showMembersModal: false });
        };

        _this.showEditChannelPurposeModal = function () {
            _this.setState({ showEditChannelPurposeModal: true });
        };

        _this.hideEditChannelPurposeModal = function () {
            _this.setState({ showEditChannelPurposeModal: false });
        };

        _this.hideEditChannelHeaderModal = function () {
            _this.setState({ showEditChannelHeaderModal: false });
        };

        _this.showEditChannelHeaderModal = function () {
            _this.setState({ showEditChannelHeaderModal: true });
        };

        _this.handleWebRTCOnClick = function (e) {
            e.preventDefault();
            var dmUserId = _this.props.dmUser.id;
            var dmUserStatus = _this.props.dmUserStatus.status;
            var isOffline = dmUserStatus === _constants2.UserStatuses.OFFLINE;
            var isDoNotDisturb = dmUserStatus === _constants2.UserStatuses.DND;

            _this.initWebrtc(dmUserId, !isOffline || !isDoNotDisturb);
        };

        _this.showInviteModal = function () {
            var _this$props2 = _this.props,
                channel = _this$props2.channel,
                currentUser = _this$props2.currentUser,
                actions = _this$props2.actions;

            var inviteModalData = {
                modalId: _constants2.ModalIdentifiers.CHANNEL_INVITE,
                dialogType: _channel_invite_modal2.default,
                dialogProps: { channel: channel, currentUser: currentUser }
            };

            actions.openModal(inviteModalData);
        };

        var showSearchBar = Utils.windowWidth() > SEARCH_BAR_MINIMUM_WINDOW_SIZE;
        _this.state = {
            showSearchBar: showSearchBar,
            showEditChannelHeaderModal: false,
            showEditChannelPurposeModal: false,
            showMembersModal: false,
            showRenameChannelModal: false,
            showChannelNotificationsModal: false,
            isBusy: _webrtc_store2.default.isBusy()
        };
        return _this;
    }

    (0, _createClass3.default)(ChannelHeader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.actions.getCustomEmojisInText(this.props.channel.header);
            _webrtc_store2.default.addChangedListener(this.onWebrtcChange);
            _webrtc_store2.default.addBusyListener(this.onBusy);
            document.addEventListener('keydown', this.handleShortcut);
            window.addEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _webrtc_store2.default.removeChangedListener(this.onWebrtcChange);
            _webrtc_store2.default.removeBusyListener(this.onBusy);
            document.removeEventListener('keydown', this.handleShortcut);
            window.removeEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.channel.id !== nextProps.channel.id) {
                this.props.actions.getCustomEmojisInText(nextProps.channel.header);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (Utils.isEmptyObject(this.props.channel) || Utils.isEmptyObject(this.props.channelMember) || Utils.isEmptyObject(this.props.currentUser)) {
                // Use an empty div to make sure the header's height stays constant
                return _react2.default.createElement('div', { className: 'channel-header' });
            }

            var channel = this.props.channel;

            var textFormattingOptions = { singleline: true, mentionHighlight: false, siteURL: (0, _url.getSiteURL)(), channelNamesMap: _channel_store2.default.getChannelNamesMap(), team: _team_store2.default.getCurrent(), atMentions: true };
            var popoverContent = _react2.default.createElement(
                _reactBootstrap.Popover,
                {
                    id: 'header-popover',
                    bStyle: 'info',
                    bSize: 'large',
                    placement: 'bottom',
                    className: 'description',
                    onMouseOver: this.handleOnMouseOver,
                    onMouseOut: this.handleOnMouseOut
                },
                _react2.default.createElement(_message_wrapper2.default, {
                    message: channel.header,
                    options: textFormattingOptions
                })
            );

            var channelTitle = channel.display_name;
            var isDirect = this.props.channel.type === _constants2.Constants.DM_CHANNEL;
            var isGroup = this.props.channel.type === _constants2.Constants.GM_CHANNEL;
            var isPrivate = this.props.channel.type === _constants2.Constants.PRIVATE_CHANNEL;
            var teamId = _team_store2.default.getCurrentId();
            var webrtc = void 0;

            if (isDirect) {
                var userMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                var dmUserStatus = this.props.dmUserStatus.status;

                var teammateId = Utils.getUserIdFromChannelName(channel);
                if (this.props.currentUser.id === teammateId) {
                    channelTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'channel_header.directchannel.you',
                        defaultMessage: '{displayname} (you) ',
                        values: {
                            displayname: Utils.getDisplayNameByUserId(teammateId)
                        }
                    });
                } else {
                    channelTitle = Utils.getDisplayNameByUserId(teammateId) + ' ';
                }

                var webrtcEnabled = this.props.enableWebrtc && userMedia && Utils.isFeatureEnabled(PreReleaseFeatures.WEBRTC_PREVIEW);

                if (webrtcEnabled && this.props.currentUser.id !== teammateId) {
                    var isOffline = dmUserStatus === _constants2.UserStatuses.OFFLINE;
                    var isDoNotDisturb = dmUserStatus === _constants2.UserStatuses.DND;
                    var busy = this.props.dmUserIsInCall;
                    var circleClass = '';
                    var webrtcMessage = void 0;

                    if (isOffline || isDoNotDisturb || busy) {
                        circleClass = 'offline';

                        if (isOffline) {
                            webrtcMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_header.webrtc.offline',
                                defaultMessage: 'The user is offline'
                            });
                        } else if (isDoNotDisturb) {
                            webrtcMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_header.webrtc.doNotDisturb',
                                defaultMessage: 'Do not disturb'
                            });
                        } else if (busy) {
                            webrtcMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_header.webrtc.unavailable',
                                defaultMessage: 'New call unavailable until your existing call ends'
                            });
                        }
                    } else {
                        webrtcMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_header.webrtc.call',
                            defaultMessage: 'Start Video Call'
                        });
                    }

                    var webrtcTooltip = _react2.default.createElement(
                        _reactBootstrap.Tooltip,
                        { id: 'webrtcTooltip' },
                        webrtcMessage
                    );

                    webrtc = _react2.default.createElement(
                        'div',
                        { className: 'webrtc__header channel-header__icon wide text ' + circleClass },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'style--none',
                                onClick: this.handleWebRTCOnClick,
                                disabled: isOffline || isDoNotDisturb
                            },
                            _react2.default.createElement(
                                _reactBootstrap.OverlayTrigger,
                                {
                                    trigger: ['hover', 'focus'],
                                    delayShow: _constants2.Constants.WEBRTC_TIME_DELAY,
                                    placement: 'bottom',
                                    overlay: webrtcTooltip
                                },
                                _react2.default.createElement(
                                    'div',
                                    {
                                        id: 'webrtc-btn',
                                        className: 'webrtc__button ' + circleClass
                                    },
                                    'WebRTC'
                                )
                            )
                        )
                    );
                }
            }

            var popoverListMembers = void 0;
            if (!isDirect) {
                popoverListMembers = _react2.default.createElement(_popover_list_members2.default, {
                    channel: channel
                });
            }

            var dropdownContents = [];
            if (isDirect) {
                dropdownContents.push(_react2.default.createElement(
                    'li',
                    {
                        key: 'edit_header_direct',
                        role: 'presentation'
                    },
                    _react2.default.createElement(
                        _toggle_modal_button_redux2.default,
                        {
                            id: 'channelEditHeaderDirect',
                            role: 'menuitem',
                            modalId: _constants2.ModalIdentifiers.EDIT_CHANNEL_HEADER,
                            dialogType: _edit_channel_header_modal2.default,
                            dialogProps: { channel: channel }
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_header.channelHeader',
                            defaultMessage: 'Edit Channel Header'
                        })
                    )
                ));
            } else if (isGroup) {
                dropdownContents.push(_react2.default.createElement(
                    'li',
                    {
                        key: 'edit_header_direct',
                        role: 'presentation'
                    },
                    _react2.default.createElement(
                        _toggle_modal_button_redux2.default,
                        {
                            id: 'channelEditHeaderGroup',
                            role: 'menuitem',
                            modalId: _constants2.ModalIdentifiers.EDIT_CHANNEL_HEADER,
                            dialogType: _edit_channel_header_modal2.default,
                            dialogProps: { channel: channel }
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_header.channelHeader',
                            defaultMessage: 'Edit Channel Header'
                        })
                    )
                ));

                dropdownContents.push(_react2.default.createElement(
                    'li',
                    {
                        key: 'notification_preferences',
                        role: 'presentation'
                    },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'style--none',
                            id: 'channelNotificationsGroup',
                            role: 'menuitem',
                            onClick: this.showChannelNotificationsModal
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_header.notificationPreferences',
                            defaultMessage: 'Notification Preferences'
                        })
                    )
                ));

                dropdownContents.push(_react2.default.createElement(
                    'li',
                    {
                        key: 'add_members',
                        role: 'presentation'
                    },
                    _react2.default.createElement(
                        _toggle_modal_button_redux2.default,
                        {
                            id: 'channelAddMembersGroup',
                            role: 'menuitem',
                            modalId: _constants2.ModalIdentifiers.CREATE_DM_CHANNEL,
                            dialogType: _more_direct_channels2.default,
                            dialogProps: { isExistingChannel: true }
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_header.addMembers',
                            defaultMessage: 'Add Members'
                        })
                    )
                ));
            } else {
                dropdownContents.push(_react2.default.createElement(
                    'li',
                    {
                        key: 'view_info',
                        role: 'presentation'
                    },
                    _react2.default.createElement(
                        _toggle_modal_button_redux2.default,
                        {
                            id: 'channelViewInfo',
                            role: 'menuitem',
                            modalId: _constants2.ModalIdentifiers.CHANNEL_INFO,
                            dialogType: _channel_info_modal2.default,
                            dialogProps: { channel: channel }
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_header.viewInfo',
                            defaultMessage: 'View Info'
                        })
                    )
                ));

                if (this.props.isDefault) {
                    dropdownContents.push(_react2.default.createElement(
                        'li',
                        {
                            key: 'manage_members',
                            role: 'presentation'
                        },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'style--none',
                                id: 'channelManageMembers',
                                role: 'menuitem',
                                onClick: this.showMembersModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_header.viewMembers',
                                defaultMessage: 'View Members'
                            })
                        )
                    ));
                }

                dropdownContents.push(_react2.default.createElement(
                    'li',
                    {
                        key: 'notification_preferences',
                        role: 'presentation'
                    },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'style--none',
                            id: 'channelNotificationsGroup',
                            role: 'menuitem',
                            onClick: this.showChannelNotificationsModal
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_header.notificationPreferences',
                            defaultMessage: 'Notification Preferences'
                        })
                    )
                ));

                if (!this.props.isDefault) {
                    dropdownContents.push(_react2.default.createElement('li', {
                        key: 'divider-1',
                        className: 'divider'
                    }));

                    dropdownContents.push(_react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: channel.id,
                            teamId: teamId,
                            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_MEMBERS : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_MEMBERS],
                            key: 'add_members_permission'
                        },
                        _react2.default.createElement(
                            'li',
                            {
                                key: 'add_members',
                                role: 'presentation'
                            },
                            _react2.default.createElement(
                                _toggle_modal_button_redux2.default,
                                {
                                    id: 'channelAddMembers',
                                    ref: 'channelInviteModalButton',
                                    role: 'menuitem',
                                    modalId: _constants2.ModalIdentifiers.CHANNEL_INVITE,
                                    dialogType: _channel_invite_modal2.default,
                                    dialogProps: { channel: channel, currentUser: this.props.currentUser }
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.addMembers',
                                    defaultMessage: 'Add Members'
                                })
                            )
                        )
                    ));
                    dropdownContents.push(_react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: channel.id,
                            teamId: teamId,
                            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_MEMBERS : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_MEMBERS],
                            key: 'manage_members_permission'
                        },
                        _react2.default.createElement(
                            'li',
                            {
                                key: 'manage_members',
                                role: 'presentation'
                            },
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'style--none',
                                    id: 'channelManageMembers',
                                    role: 'menuitem',
                                    onClick: this.showMembersModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.manageMembers',
                                    defaultMessage: 'Manage Members'
                                })
                            )
                        )
                    ));

                    dropdownContents.push(_react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: channel.id,
                            teamId: teamId,
                            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_MEMBERS : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_MEMBERS],
                            invert: true,
                            key: 'view_members_permission'
                        },
                        _react2.default.createElement(
                            'li',
                            {
                                key: 'view_members',
                                role: 'presentation'
                            },
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'style--none',
                                    id: 'channelViewMembers',
                                    role: 'menuitem',
                                    onClick: this.showMembersModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.viewMembers',
                                    defaultMessage: 'View Members'
                                })
                            )
                        )
                    ));
                }

                if (!this.props.isReadOnly) {
                    dropdownContents.push(_react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: channel.id,
                            teamId: teamId,
                            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES],
                            key: 'set_channel_info_permission'
                        },
                        _react2.default.createElement('li', {
                            key: 'divider-2',
                            className: 'divider'
                        }),
                        _react2.default.createElement(
                            'li',
                            {
                                key: 'set_channel_header',
                                role: 'presentation'
                            },
                            _react2.default.createElement(
                                _toggle_modal_button_redux2.default,
                                {
                                    id: 'channelEditHeader',
                                    role: 'menuitem',
                                    modalId: _constants2.ModalIdentifiers.EDIT_CHANNEL_HEADER,
                                    dialogType: _edit_channel_header_modal2.default,
                                    dialogProps: { channel: channel }
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.setHeader',
                                    defaultMessage: 'Edit Channel Header'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            {
                                key: 'set_channel_purpose',
                                role: 'presentation'
                            },
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'style--none',
                                    id: 'channelEditPurpose',
                                    role: 'menuitem',
                                    onClick: this.showEditChannelPurposeModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.setPurpose',
                                    defaultMessage: 'Edit Channel Purpose'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            {
                                key: 'rename_channel',
                                role: 'presentation'
                            },
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'style--none',
                                    id: 'channelRename',
                                    role: 'menuitem',
                                    onClick: this.showRenameChannelModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.rename',
                                    defaultMessage: 'Rename Channel'
                                })
                            )
                        )
                    ));
                }

                if (!this.props.isDefault) {
                    dropdownContents.push(_react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: channel.id,
                            teamId: teamId,
                            permissions: [isPrivate ? _constants.Permissions.DELETE_PRIVATE_CHANNEL : _constants.Permissions.DELETE_PUBLIC_CHANNEL],
                            key: 'delete_channel_permission'
                        },
                        _react2.default.createElement(
                            'li',
                            {
                                key: 'delete_channel',
                                role: 'presentation'
                            },
                            _react2.default.createElement(
                                _toggle_modal_button_redux2.default,
                                {
                                    id: 'channelDelete',
                                    role: 'menuitem',
                                    modalId: _constants2.ModalIdentifiers.DELETE_CHANNEL,
                                    dialogType: _delete_channel_modal2.default,
                                    dialogProps: { channel: channel }
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.delete',
                                    defaultMessage: 'Delete Channel'
                                })
                            )
                        )
                    ));

                    dropdownContents.push(_react2.default.createElement('li', {
                        key: 'divider-3',
                        className: 'divider'
                    }));

                    dropdownContents.push(_react2.default.createElement(
                        'li',
                        {
                            key: 'leave_channel',
                            role: 'presentation'
                        },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'style--none',
                                id: 'channelLeave',
                                role: 'menuitem',
                                onClick: this.handleLeave
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_header.leave',
                                defaultMessage: 'Leave Channel'
                            })
                        )
                    ));
                }
            }

            var dmHeaderIconStatus = void 0;
            var dmHeaderTextStatus = void 0;
            if (channel.type === _constants2.Constants.DM_CHANNEL && !this.props.dmUser.delete_at) {
                dmHeaderIconStatus = _react2.default.createElement(_status_icon2.default, {
                    type: 'avatar',
                    status: channel.status
                });

                dmHeaderTextStatus = _react2.default.createElement(
                    'span',
                    { className: 'header-status__text' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'status_dropdown.set_' + channel.status,
                        defaultMessage: Utils.toTitleCase(channel.status)
                    })
                );
            }

            var headerTextContainer = void 0;
            if (channel.header) {
                var headerTextElement = void 0;
                var formattedText = TextFormatting.formatText(channel.header, textFormattingOptions);
                if (this.props.enableFormatting) {
                    headerTextElement = _react2.default.createElement(
                        'div',
                        {
                            id: 'channelHeaderDescription',
                            className: 'channel-header__description'
                        },
                        dmHeaderIconStatus,
                        dmHeaderTextStatus,
                        _react2.default.createElement(
                            'span',
                            { onClick: Utils.handleFormattedTextClick },
                            (0, _post_utils.messageHtmlToComponent)(formattedText, false, { mentions: false })
                        )
                    );
                } else {
                    headerTextElement = _react2.default.createElement(
                        'div',
                        {
                            id: 'channelHeaderDescription',
                            onClick: Utils.handleFormattedTextClick,
                            className: 'channel-header__description light'
                        },
                        dmHeaderIconStatus,
                        dmHeaderTextStatus,
                        channel.header
                    );
                }

                headerTextContainer = _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        trigger: 'click',
                        placement: 'bottom',
                        rootClose: true,
                        overlay: popoverContent,
                        ref: 'headerOverlay'
                    },
                    headerTextElement
                );
            } else {
                var editMessage = void 0;
                if (!this.props.isReadOnly) {
                    if (isDirect || isGroup) {
                        editMessage = _react2.default.createElement(
                            'button',
                            {
                                className: 'style--none',
                                onClick: this.showEditChannelHeaderModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_header.addChannelHeader',
                                defaultMessage: 'Add a channel description'
                            })
                        );
                    } else {
                        editMessage = _react2.default.createElement(
                            _channel_permission_gate2.default,
                            {
                                channelId: channel.id,
                                teamId: teamId,
                                permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES]
                            },
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'style--none',
                                    onClick: this.showEditChannelHeaderModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.addChannelHeader',
                                    defaultMessage: 'Add a channel description'
                                })
                            )
                        );
                    }
                }
                headerTextContainer = _react2.default.createElement(
                    'div',
                    {
                        id: 'channelHeaderDescription',
                        className: 'channel-header__description light'
                    },
                    dmHeaderIconStatus,
                    dmHeaderTextStatus,
                    editMessage
                );
            }

            var editHeaderModal = void 0;
            if (this.state.showEditChannelHeaderModal) {
                editHeaderModal = _react2.default.createElement(_edit_channel_header_modal2.default, {
                    onHide: this.hideEditChannelHeaderModal,
                    channel: channel
                });
            }

            var toggleFavoriteTooltip = void 0;
            if (this.props.isFavorite) {
                toggleFavoriteTooltip = _react2.default.createElement(
                    _reactBootstrap.Tooltip,
                    { id: 'favoriteTooltip' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'channelHeader.removeFromFavorites',
                        defaultMessage: 'Remove from Favorites'
                    })
                );
            } else {
                toggleFavoriteTooltip = _react2.default.createElement(
                    _reactBootstrap.Tooltip,
                    { id: 'favoriteTooltip' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'channelHeader.addToFavorites',
                        defaultMessage: 'Add to Favorites'
                    })
                );
            }

            var toggleFavorite = _react2.default.createElement(
                _reactBootstrap.OverlayTrigger,
                {
                    trigger: ['hover', 'focus'],
                    delayShow: _constants2.Constants.OVERLAY_TIME_DELAY,
                    placement: 'bottom',
                    overlay: toggleFavoriteTooltip
                },
                _react2.default.createElement(
                    'button',
                    {
                        id: 'toggleFavorite',
                        onClick: this.toggleFavorite,
                        className: 'style--none color--link channel-header__favorites ' + (this.props.isFavorite ? 'active' : 'inactive')
                    },
                    _react2.default.createElement('i', { className: 'icon fa ' + (this.props.isFavorite ? 'fa-star' : 'fa-star-o') })
                )
            );

            var channelMuted = (0, _channel_utils.isChannelMuted)(this.props.channelMember);
            var channelMutedTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'channelMutedTooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'channelHeader.unmute',
                    defaultMessage: 'Unmute'
                })
            );

            var muteTrigger = void 0;
            if (channelMuted) {
                muteTrigger = _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        trigger: ['hover', 'focus'],
                        delayShow: _constants2.Constants.OVERLAY_TIME_DELAY,
                        placement: 'bottom',
                        overlay: channelMutedTooltip
                    },
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'toggleMute',
                            onClick: this.unmute,
                            className: 'style--none color--link channel-header__mute inactive'
                        },
                        _react2.default.createElement('i', { className: 'icon fa fa-bell-slash-o' })
                    )
                );
            }

            var channelMembersModal = void 0;
            if (this.state.showMembersModal) {
                channelMembersModal = _react2.default.createElement(_channel_members_modal2.default, {
                    onModalDismissed: this.hideMembersModal,
                    showInviteModal: this.showInviteModal,
                    channel: channel
                });
            }

            var editPurposeModal = void 0;
            if (this.state.showEditChannelPurposeModal) {
                editPurposeModal = _react2.default.createElement(_edit_channel_purpose_modal2.default, {
                    onModalDismissed: this.hideEditChannelPurposeModal,
                    channel: channel
                });
            }

            var pinnedIconClass = 'channel-header__icon';
            if (this.props.rhsState === _constants2.RHSStates.PIN) {
                pinnedIconClass += ' active';
            }

            return _react2.default.createElement(
                'div',
                {
                    id: 'channel-header',
                    className: 'channel-header alt'
                },
                _react2.default.createElement(
                    'div',
                    { className: 'flex-parent' },
                    _react2.default.createElement(
                        'div',
                        { className: 'flex-child' },
                        _react2.default.createElement(
                            'div',
                            {
                                id: 'channelHeaderInfo',
                                className: 'channel-header__info'
                            },
                            _react2.default.createElement(
                                'div',
                                {
                                    id: 'channelHeaderTitle',
                                    className: 'channel-header__title dropdown'
                                },
                                toggleFavorite,
                                _react2.default.createElement(
                                    'h2',
                                    null,
                                    _react2.default.createElement(
                                        'button',
                                        {
                                            id: 'channelHeaderDropdownButton',
                                            className: 'dropdown-toggle theme style--none',
                                            type: 'button',
                                            'data-toggle': 'dropdown',
                                            'aria-expanded': 'true'
                                        },
                                        _react2.default.createElement(
                                            'strong',
                                            {
                                                id: 'channelHeaderTitle',
                                                className: 'heading'
                                            },
                                            channelTitle
                                        ),
                                        _react2.default.createElement('span', {
                                            id: 'channelHeaderDropdownIcon',
                                            className: 'fa fa-angle-down header-dropdown__icon'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        {
                                            id: 'channelHeaderDropdownMenu',
                                            className: 'dropdown-menu',
                                            role: 'menu',
                                            'aria-labelledby': 'channel_header_dropdown'
                                        },
                                        dropdownContents
                                    )
                                ),
                                muteTrigger
                            ),
                            headerTextContainer
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'flex-child' },
                        webrtc
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'flex-child' },
                        popoverListMembers
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'flex-child' },
                        _react2.default.createElement(_pluggable2.default, { pluggableName: 'ChannelHeaderButton' })
                    ),
                    _react2.default.createElement(_header_icon_wrapper2.default, {
                        iconComponent: _react2.default.createElement(_pin_icon2.default, {
                            className: 'icon icon__pin',
                            'aria-hidden': 'true'
                        }),
                        buttonClass: 'style--none ' + pinnedIconClass,
                        buttonId: 'channelHeaderPinButton',
                        onClick: this.getPinnedPosts,
                        tooltipKey: 'pinnedPosts'
                    }),
                    this.state.showSearchBar ? _react2.default.createElement(
                        'div',
                        { className: 'flex-child search-bar__container' },
                        _react2.default.createElement(_search_bar2.default, {
                            showMentionFlagBtns: false,
                            isFocus: Utils.isMobile()
                        })
                    ) : _react2.default.createElement(_header_icon_wrapper2.default, {
                        iconComponent: _react2.default.createElement(_search_icon2.default, {
                            className: 'icon icon__search icon--stroke',
                            'aria-hidden': 'true'
                        }),
                        buttonId: 'channelHeaderSearchButton',
                        onClick: this.searchButtonClick,
                        tooltipKey: 'search'
                    }),
                    _react2.default.createElement(_header_icon_wrapper2.default, {
                        iconComponent: _react2.default.createElement(_mentions_icon2.default, {
                            className: 'icon icon__mentions',
                            'aria-hidden': 'true'
                        }),
                        buttonId: 'channelHeaderMentionButton',
                        onClick: this.searchMentions,
                        tooltipKey: 'recentMentions'
                    }),
                    _react2.default.createElement(_header_icon_wrapper2.default, {
                        iconComponent: _react2.default.createElement(_flag_icon2.default, { className: 'icon icon__flag' }),
                        buttonId: 'channelHeaderFlagButton',
                        onClick: this.getFlagged,
                        tooltipKey: 'flaggedPosts'
                    })
                ),
                editHeaderModal,
                editPurposeModal,
                channelMembersModal,
                _react2.default.createElement(_channel_notifications_modal2.default, {
                    show: this.state.showChannelNotificationsModal,
                    onHide: this.hideChannelNotificationsModal,
                    channel: channel,
                    channelMember: this.props.channelMember,
                    currentUser: this.props.currentUser
                }),
                _react2.default.createElement(_rename_channel_modal2.default, {
                    show: this.state.showRenameChannelModal,
                    onHide: this.hideRenameChannelModal,
                    channel: channel
                })
            );
        }
    }]);
    return ChannelHeader;
}(_react2.default.Component);

ChannelHeader.propTypes = {
    actions: _propTypes2.default.shape({
        leaveChannel: _propTypes2.default.func.isRequired,
        favoriteChannel: _propTypes2.default.func.isRequired,
        unfavoriteChannel: _propTypes2.default.func.isRequired,
        showFlaggedPosts: _propTypes2.default.func.isRequired,
        showPinnedPosts: _propTypes2.default.func.isRequired,
        showMentions: _propTypes2.default.func.isRequired,
        closeRightHandSide: _propTypes2.default.func.isRequired,
        updateRhsState: _propTypes2.default.func.isRequired,
        openModal: _propTypes2.default.func.isRequired,
        getCustomEmojisInText: _propTypes2.default.func.isRequired,
        updateChannelNotifyProps: _propTypes2.default.func.isRequired
    }).isRequired,
    channel: _propTypes2.default.object.isRequired,
    channelMember: _propTypes2.default.object.isRequired,
    isFavorite: _propTypes2.default.bool,
    isDefault: _propTypes2.default.bool,
    currentUser: _propTypes2.default.object.isRequired,
    dmUser: _propTypes2.default.object,
    dmUserStatus: _propTypes2.default.object,
    dmUserIsInCall: _propTypes2.default.bool,
    enableFormatting: _propTypes2.default.bool.isRequired,
    isReadOnly: _propTypes2.default.bool,
    rhsState: _propTypes2.default.oneOf((0, _values2.default)(_constants2.RHSStates)),
    enableWebrtc: _propTypes2.default.bool.isRequired
};
ChannelHeader.defaultProps = {
    dmUser: {},
    dmUserStatus: { status: _constants2.UserStatuses.OFFLINE }
};
exports.default = ChannelHeader;

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773)))

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _globe_icon = __webpack_require__(1086);

var _globe_icon2 = _interopRequireDefault(_globe_icon);

var _lock_icon = __webpack_require__(1087);

var _lock_icon2 = _interopRequireDefault(_lock_icon);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _text_formatting = __webpack_require__(811);

var TextFormatting = _interopRequireWildcard(_text_formatting);

var _url = __webpack_require__(793);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ChannelInfoModal = function (_React$PureComponent) {
    (0, _inherits3.default)(ChannelInfoModal, _React$PureComponent);

    function ChannelInfoModal(props) {
        (0, _classCallCheck3.default)(this, ChannelInfoModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelInfoModal.__proto__ || (0, _getPrototypeOf2.default)(ChannelInfoModal)).call(this, props));

        _this.onHide = _this.onHide.bind(_this);

        _this.state = { show: true };
        return _this;
    }

    (0, _createClass3.default)(ChannelInfoModal, [{
        key: 'onHide',
        value: function onHide() {
            this.setState({ show: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var channel = this.props.channel;
            var channelIcon = void 0;

            if (!channel) {
                var notFound = Utils.localizeMessage('channel_info.notFound', 'No Channel Found');

                channel = {
                    display_name: notFound,
                    name: notFound,
                    purpose: notFound,
                    header: notFound,
                    id: notFound
                };
            }

            if (channel.type === 'O') {
                channelIcon = _react2.default.createElement(_globe_icon2.default, { className: 'icon icon__globe icon--body' });
            } else if (channel.type === 'P') {
                channelIcon = _react2.default.createElement(_lock_icon2.default, { className: 'icon icon__globe icon--body' });
            }

            var channelURL = (0, _url.getSiteURL)() + '/' + this.props.currentTeam.name + '/channels/' + channel.name;

            var channelPurpose = void 0;
            if (channel.purpose) {
                channelPurpose = channel.purpose;
            } else if (channel.name === _constants2.default.DEFAULT_CHANNEL) {
                channelPurpose = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'default_channel.purpose',
                    defaultMessage: 'Post messages here that you want everyone to see. Everyone automatically becomes a permanent member of this channel when they join the team.'
                });
            }

            var channelPurposeElement = void 0;
            if (channelPurpose) {
                channelPurposeElement = _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'div',
                        { className: 'info__label' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_info.purpose',
                            defaultMessage: 'Purpose:'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'info__value' },
                        channelPurpose
                    )
                );
            }

            var channelHeader = null;
            if (channel.header) {
                channelHeader = _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'div',
                        { className: 'info__label' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_info.header',
                            defaultMessage: 'Header:'
                        })
                    ),
                    _react2.default.createElement('div', {
                        className: 'info__value',
                        dangerouslySetInnerHTML: { __html: TextFormatting.formatText(channel.header, { singleline: false, mentionHighlight: false }) }
                    })
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'about-modal',
                    show: this.state.show,
                    onHide: this.onHide,
                    onExited: this.props.onHide
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_info.about',
                            defaultMessage: 'About'
                        }),
                        _react2.default.createElement(
                            'strong',
                            null,
                            channelIcon,
                            channel.display_name
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    { ref: 'modalBody' },
                    channelPurposeElement,
                    channelHeader,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'info__label' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_info.url',
                                defaultMessage: 'URL:'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'info__value' },
                            channelURL
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'about-modal__hash form-group padding-top x2' },
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_info.id',
                                defaultMessage: 'ID: '
                            }),
                            channel.id
                        )
                    )
                )
            );
        }
    }]);
    return ChannelInfoModal;
}(_react2.default.PureComponent);

ChannelInfoModal.propTypes = {

    /**
     * Function that is called when modal is hidden
     */
    onHide: _propTypes2.default.func.isRequired,

    /**
     * Channel object
     */
    channel: _propTypes2.default.object.isRequired,

    /**
     * Current team object
     */
    currentTeam: _propTypes2.default.object.isRequired
};
exports.default = ChannelInfoModal;

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _users = __webpack_require__(777);

var _client = __webpack_require__(270);

var _user_actions = __webpack_require__(781);

var _channel_actions = __webpack_require__(809);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

var _multiselect = __webpack_require__(1050);

var _multiselect2 = _interopRequireDefault(_multiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USERS_PER_PAGE = 50; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MAX_SELECTABLE_VALUES = 20;

var ChannelInviteModal = function (_React$Component) {
    (0, _inherits3.default)(ChannelInviteModal, _React$Component);

    function ChannelInviteModal(props) {
        (0, _classCallCheck3.default)(this, ChannelInviteModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelInviteModal.__proto__ || (0, _getPrototypeOf2.default)(ChannelInviteModal)).call(this, props));

        _initialiseProps.call(_this);

        _this.term = '';
        _this.searchTimeoutId = 0;

        var channelStats = _channel_store2.default.getStats(props.channel.id);
        var teamStats = _team_store2.default.getCurrentStats();

        _this.state = {
            users: (0, _assign2.default)([], _user_store2.default.getProfileListNotInChannel(props.channel.id, true)),
            total: teamStats.active_member_count - channelStats.member_count,
            values: [],
            show: true,
            statusChange: false,
            saving: false,
            loadingUsers: true
        };
        return _this;
    }

    (0, _createClass3.default)(ChannelInviteModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _team_store2.default.addStatsChangeListener(this.onChange);
            _channel_store2.default.addStatsChangeListener(this.onChange);
            _user_store2.default.addNotInChannelChangeListener(this.onChange);
            _user_store2.default.addStatusesChangeListener(this.onStatusChange);

            this.props.actions.getProfilesNotInChannel(_team_store2.default.getCurrentId(), this.props.channel.id, 0).then(function () {
                _this2.setUsersLoadingState(false);
            });
            this.props.actions.getTeamStats(_team_store2.default.getCurrentId());
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _team_store2.default.removeStatsChangeListener(this.onChange);
            _channel_store2.default.removeStatsChangeListener(this.onChange);
            _user_store2.default.removeNotInChannelChangeListener(this.onChange);
            _user_store2.default.removeStatusesChangeListener(this.onStatusChange);
        }
    }, {
        key: 'render',
        value: function render() {
            var inviteError = null;
            if (this.state.inviteError) {
                inviteError = _react2.default.createElement(
                    'label',
                    { className: 'has-error control-label' },
                    this.state.inviteError
                );
            }

            var numRemainingText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'multiselect.numPeopleRemaining',
                defaultMessage: 'Use \u2191\u2193 to browse, \u21B5 to select. You can add {num, number} more {num, plural, one {person} other {people}}. ',
                values: {
                    num: MAX_SELECTABLE_VALUES - this.state.values.length
                }
            });

            var buttonSubmitText = (0, _utils.localizeMessage)('multiselect.add', 'Add');

            var users = [];
            if (this.state.users) {
                users = this.state.users.filter(function (user) {
                    return user.delete_at === 0;
                });
            }

            var content = void 0;
            if (this.state.loading) {
                content = _react2.default.createElement(_loading_screen2.default, null);
            } else {
                content = _react2.default.createElement(_multiselect2.default, {
                    key: 'addUsersToChannelKey',
                    options: users,
                    optionRenderer: this.renderOption,
                    values: this.state.values,
                    valueKey: 'id',
                    valueRenderer: this.renderValue,
                    perPage: USERS_PER_PAGE,
                    handlePageChange: this.handlePageChange,
                    handleInput: this.search,
                    handleDelete: this.handleDelete,
                    handleAdd: this.addValue,
                    handleSubmit: this.handleSubmit,
                    maxValues: MAX_SELECTABLE_VALUES,
                    numRemainingText: numRemainingText,
                    buttonSubmitText: buttonSubmitText,
                    saving: this.state.saving
                });
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'more-modal',
                    show: this.state.show,
                    onHide: this.onHide,
                    onExited: this.props.onHide
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_invite.addNewMembers',
                            defaultMessage: 'Add New Members to '
                        }),
                        _react2.default.createElement(
                            'span',
                            { className: 'name' },
                            this.props.channel.display_name
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    inviteError,
                    content
                )
            );
        }
    }]);
    return ChannelInviteModal;
}(_react2.default.Component);

ChannelInviteModal.propTypes = {
    onHide: _propTypes2.default.func.isRequired,
    channel: _propTypes2.default.object.isRequired,
    actions: _propTypes2.default.shape({
        getProfilesNotInChannel: _propTypes2.default.func.isRequired,
        getTeamStats: _propTypes2.default.func.isRequired
    }).isRequired
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.addValue = function (value) {
        var values = (0, _assign2.default)([], _this3.state.values);
        if (values.indexOf(value) === -1) {
            values.push(value);
        }

        _this3.setState({ values: values });
    };

    this.onChange = function () {
        var users = void 0;
        if (_this3.term) {
            users = (0, _users.searchProfilesNotInCurrentChannel)(_redux_store2.default.getState(), _this3.term, true);
        } else {
            users = _user_store2.default.getProfileListNotInChannel(_this3.props.channel.id, true);
        }

        var channelStats = _channel_store2.default.getStats(_this3.props.channel.id);
        var teamStats = _team_store2.default.getCurrentStats();

        _this3.setState({
            users: users,
            total: teamStats.active_member_count - channelStats.member_count
        });
    };

    this.onStatusChange = function () {
        // Initiate a render to pick up on new statuses
        _this3.setState({
            statusChange: !_this3.state.statusChange
        });
    };

    this.onHide = function () {
        _this3.setState({ show: false });
    };

    this.handleInviteError = function (err) {
        if (err) {
            _this3.setState({
                saving: false,
                inviteError: err.message
            });
        } else {
            _this3.setState({
                saving: false,
                inviteError: null
            });
        }
    };

    this.handleDelete = function (values) {
        _this3.setState({ values: values });
    };

    this.setUsersLoadingState = function (loadingState) {
        _this3.setState({
            loadingUsers: loadingState
        });
    };

    this.handlePageChange = function (page, prevPage) {
        if (page > prevPage) {
            _this3.setUsersLoadingState(true);
            _this3.props.actions.getProfilesNotInChannel(_team_store2.default.getCurrentId(), _this3.props.channel.id, page + 1, USERS_PER_PAGE).then(function () {
                _this3.setUsersLoadingState(false);
            });
        }
    };

    this.handleSubmit = function (e) {
        if (e) {
            e.preventDefault();
        }

        var userIds = _this3.state.values.map(function (v) {
            return v.id;
        });
        if (userIds.length === 0) {
            return;
        }

        _this3.setState({ saving: true });

        userIds.forEach(function (userId) {
            (0, _channel_actions.addUserToChannel)(_this3.props.channel.id, userId, function () {
                _this3.handleInviteError(null);
            }, function (err) {
                _this3.handleInviteError(err);
            });
        });

        _this3.onHide();
    };

    this.search = function (term) {
        clearTimeout(_this3.searchTimeoutId);
        _this3.term = term;

        if (term === '') {
            _this3.onChange();
            return;
        }

        _this3.searchTimeoutId = setTimeout(function () {
            _this3.setUsersLoadingState(true);
            (0, _user_actions.searchUsers)(term, _team_store2.default.getCurrentId(), { not_in_channel_id: _this3.props.channel.id }).then(function () {
                _this3.setUsersLoadingState(false);
            });
        }, _constants2.default.SEARCH_TIMEOUT_MILLISECONDS);
    };

    this.renderOption = function (option, isSelected, onAdd) {
        var rowSelected = '';
        if (isSelected) {
            rowSelected = 'more-modal__row--selected';
        }

        return _react2.default.createElement(
            'div',
            {
                key: option.id,
                ref: isSelected ? 'selected' : option.id,
                className: 'more-modal__row clickable ' + rowSelected,
                onClick: function onClick() {
                    return onAdd(option);
                }
            },
            _react2.default.createElement(_profile_picture2.default, {
                src: _client.Client4.getProfilePictureUrl(option.id, option.last_picture_update),
                width: '32',
                height: '32'
            }),
            _react2.default.createElement(
                'div',
                { className: 'more-modal__details' },
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__name' },
                    (0, _utils.displayEntireNameForUser)(option)
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'more-modal__actions' },
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__actions--round' },
                    _react2.default.createElement('i', { className: 'fa fa-plus' })
                )
            )
        );
    };

    this.renderValue = function (user) {
        return user.username;
    };
};

exports.default = ChannelInviteModal;

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _member_list_channel = __webpack_require__(2424);

var _member_list_channel2 = _interopRequireDefault(_member_list_channel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChannelMembersModal = function (_React$PureComponent) {
    (0, _inherits3.default)(ChannelMembersModal, _React$PureComponent);

    function ChannelMembersModal(props) {
        (0, _classCallCheck3.default)(this, ChannelMembersModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelMembersModal.__proto__ || (0, _getPrototypeOf2.default)(ChannelMembersModal)).call(this, props));

        _this.onHide = function () {
            _this.setState({
                show: false
            });
        };

        _this.onClickManageChannelsButton = function () {
            _this.props.showInviteModal();
            _this.onHide();
        };

        _this.state = {
            show: true
        };
        return _this;
    }

    (0, _createClass3.default)(ChannelMembersModal, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactBootstrap.Modal,
                    {
                        dialogClassName: 'more-modal more-modal--action',
                        onExited: this.props.onModalDismissed,
                        onHide: this.onHide,
                        show: this.state.show
                    },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Header,
                        { closeButton: true },
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Title,
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'name' },
                                this.props.channel.display_name
                            ),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_members_modal.members',
                                defaultMessage: ' Members'
                            })
                        ),
                        this.props.canManageChannelMembers && _react2.default.createElement(
                            'a',
                            {
                                id: 'showInviteModal',
                                className: 'btn btn-md btn-primary',
                                href: '#',
                                onClick: this.onClickManageChannelsButton
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_members_modal.addNew',
                                defaultMessage: ' Add New Members'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Body,
                        null,
                        _react2.default.createElement(_member_list_channel2.default, {
                            channel: this.props.channel
                        })
                    )
                )
            );
        }
    }]);
    return ChannelMembersModal;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ChannelMembersModal.propTypes = {
    canManageChannelMembers: _propTypes2.default.bool.isRequired,
    channel: _propTypes2.default.shape({
        display_name: _propTypes2.default.string.isRequired
    }).isRequired,
    onModalDismissed: _propTypes2.default.func.isRequired,
    showInviteModal: _propTypes2.default.func.isRequired
};
exports.default = ChannelMembersModal;

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _channels = __webpack_require__(798);

var _member_list_channel = __webpack_require__(2425);

var _member_list_channel2 = _interopRequireDefault(_member_list_channel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getChannelStats: _channels.getChannelStats
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_member_list_channel2.default);

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _users = __webpack_require__(777);

var _user_utils = __webpack_require__(175);

var _user_actions = __webpack_require__(781);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _channel_members_dropdown = __webpack_require__(2426);

var _channel_members_dropdown2 = _interopRequireDefault(_channel_members_dropdown);

var _searchable_user_list_container = __webpack_require__(1334);

var _searchable_user_list_container2 = _interopRequireDefault(_searchable_user_list_container);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var USERS_PER_PAGE = 50;

var MemberListChannel = function (_React$Component) {
    (0, _inherits3.default)(MemberListChannel, _React$Component);

    function MemberListChannel(props) {
        (0, _classCallCheck3.default)(this, MemberListChannel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MemberListChannel.__proto__ || (0, _getPrototypeOf2.default)(MemberListChannel)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onStatsChange = _this.onStatsChange.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.loadComplete = _this.loadComplete.bind(_this);

        _this.searchTimeoutId = 0;
        _this.term = '';

        var stats = _channel_store2.default.getCurrentStats();

        _this.state = {
            users: _user_store2.default.getProfileListInChannel(_channel_store2.default.getCurrentId(), false, true),
            teamMembers: (0, _assign2.default)({}, _team_store2.default.getMembersInTeam()),
            channelMembers: (0, _assign2.default)({}, _channel_store2.default.getMembersInChannel()),
            total: stats.member_count,
            loading: true,
            actionUserProps: {},
            usersToDisplay: []
        };
        return _this;
    }

    (0, _createClass3.default)(MemberListChannel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _user_store2.default.addInChannelChangeListener(this.onChange);
            _team_store2.default.addChangeListener(this.onChange);
            _channel_store2.default.addChangeListener(this.onChange);
            _channel_store2.default.addStatsChangeListener(this.onStatsChange);

            (0, _user_actions.loadProfilesAndTeamMembersAndChannelMembers)(0, _constants2.default.PROFILE_CHUNK_SIZE, _team_store2.default.getCurrentId(), _channel_store2.default.getCurrentId(), this.loadComplete);
            this.props.actions.getChannelStats(_channel_store2.default.getCurrentId());
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _user_store2.default.removeInTeamChangeListener(this.onChange);
            _team_store2.default.removeChangeListener(this.onChange);
            _channel_store2.default.removeChangeListener(this.onChange);
            _channel_store2.default.removeStatsChangeListener(this.onStatsChange);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.loading !== this.state.loading) {
                return true;
            }

            if (nextState.total !== this.state.total) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextState.usersToDisplay, this.state.usersToDisplay)) {
                return true;
            }

            if (!Utils.areObjectsEqual(nextState.actionUserProps, this.state.actionUserProps)) {
                return true;
            }

            return false;
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(_, nextState) {
            if (!nextState.loading) {
                var users = nextState.users,
                    teamMembers = nextState.teamMembers,
                    channelMembers = nextState.channelMembers;


                this.setUsersDisplayAndActionProps(users, teamMembers, channelMembers);
            }
        }
    }, {
        key: 'setUsersDisplayAndActionProps',
        value: function setUsersDisplayAndActionProps(users, teamMembers, channelMembers) {
            var actionUserProps = {};
            var usersToDisplay = [];

            for (var i = 0; i < users.length; i++) {
                var user = users[i];

                if (teamMembers[user.id] && channelMembers[user.id] && user.delete_at === 0) {
                    usersToDisplay.push(user);

                    actionUserProps[user.id] = {
                        channel: this.props.channel,
                        teamMember: teamMembers[user.id],
                        channelMember: channelMembers[user.id]
                    };
                }
            }

            this.setState({
                usersToDisplay: usersToDisplay.sort(_user_utils.sortByUsername),
                actionUserProps: actionUserProps
            });
        }
    }, {
        key: 'loadComplete',
        value: function loadComplete() {
            this.setState({ loading: false });
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            var users = void 0;
            if (this.term) {
                users = (0, _users.searchProfilesInCurrentChannel)(_redux_store2.default.getState(), this.term);
            } else {
                users = _user_store2.default.getProfileListInChannel(_channel_store2.default.getCurrentId(), false, true);
            }

            var teamMembers = (0, _assign2.default)({}, _team_store2.default.getMembersInTeam());
            var channelMembers = (0, _assign2.default)({}, _channel_store2.default.getMembersInChannel());

            this.setState({
                users: users,
                teamMembers: teamMembers,
                channelMembers: channelMembers
            });

            this.setUsersDisplayAndActionProps(users, teamMembers, channelMembers);
        }
    }, {
        key: 'onStatsChange',
        value: function onStatsChange() {
            var stats = _channel_store2.default.getCurrentStats();
            this.setState({ total: stats.member_count });
        }
    }, {
        key: 'nextPage',
        value: function nextPage(page) {
            (0, _user_actions.loadProfilesAndTeamMembersAndChannelMembers)(page + 1, USERS_PER_PAGE);
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(term) {
            var _this2 = this;

            clearTimeout(this.searchTimeoutId);
            this.term = term;

            if (term === '') {
                this.setState({ loading: false });
                this.searchTimeoutId = '';
                this.onChange();
                return;
            }

            var searchTimeoutId = setTimeout(function () {
                (0, _user_actions.searchUsers)(term, '', { in_channel_id: _channel_store2.default.getCurrentId() }, function (users) {
                    if (searchTimeoutId !== _this2.searchTimeoutId) {
                        return;
                    }

                    _this2.setState({ loading: true });

                    (0, _user_actions.loadTeamMembersAndChannelMembersForProfilesList)(users, _team_store2.default.getCurrentId(), _channel_store2.default.getCurrentId(), _this2.loadComplete);
                });
            }, _constants2.default.SEARCH_TIMEOUT_MILLISECONDS);

            this.searchTimeoutId = searchTimeoutId;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_searchable_user_list_container2.default, {
                users: this.state.usersToDisplay,
                usersPerPage: USERS_PER_PAGE,
                total: this.state.total,
                nextPage: this.nextPage,
                search: this.handleSearch,
                actions: [_channel_members_dropdown2.default],
                actionUserProps: this.state.actionUserProps,
                focusOnMount: !UserAgent.isMobile()
            });
        }
    }]);
    return MemberListChannel;
}(_react2.default.Component);

MemberListChannel.propTypes = {
    channel: _propTypes2.default.object.isRequired,
    actions: _propTypes2.default.shape({
        getChannelStats: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = MemberListChannel;

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _channels = __webpack_require__(798);

var _roles = __webpack_require__(276);

var _general = __webpack_require__(113);

var _constants = __webpack_require__(19);

var _channel_utils = __webpack_require__(830);

var _channel_members_dropdown = __webpack_require__(2427);

var _channel_members_dropdown2 = _interopRequireDefault(_channel_members_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var canChangeMemberRoles = (0, _roles.haveIChannelPermission)(state, {
        channel: ownProps.channel.id,
        team: ownProps.channel.team_id,
        permission: _constants.Permissions.MANAGE_CHANNEL_ROLES
    });
    var license = (0, _general.getLicense)(state);
    var isLicensed = license.IsLicensed === 'true';

    var canRemoveMember = (0, _channel_utils.canManageMembers)(ownProps.channel);

    return {
        isLicensed: isLicensed,
        canChangeMemberRoles: canChangeMemberRoles,
        canRemoveMember: canRemoveMember
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getChannelStats: _channels.getChannelStats
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_channel_members_dropdown2.default);

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _channel_actions = __webpack_require__(809);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChannelMembersDropdown = function (_React$Component) {
    (0, _inherits3.default)(ChannelMembersDropdown, _React$Component);

    function ChannelMembersDropdown(props) {
        (0, _classCallCheck3.default)(this, ChannelMembersDropdown);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelMembersDropdown.__proto__ || (0, _getPrototypeOf2.default)(ChannelMembersDropdown)).call(this, props));

        _this.handleRemoveFromChannel = function () {
            if (_this.state.removing) {
                return;
            }

            _this.setState({ removing: true });

            (0, _channel_actions.removeUserFromChannel)(_this.props.channel.id, _this.props.user.id, function () {
                _this.props.actions.getChannelStats(_this.props.channel.id);
            }, function (err) {
                _this.setState({
                    serverError: err.message,
                    removing: false
                });
            });
        };

        _this.handleMakeChannelMember = function () {
            (0, _channel_actions.makeUserChannelMember)(_this.props.channel.id, _this.props.user.id, function () {
                _this.props.actions.getChannelStats(_this.props.channel.id);
            }, function (err) {
                _this.setState({ serverError: err.message });
            });
        };

        _this.handleMakeChannelAdmin = function () {
            (0, _channel_actions.makeUserChannelAdmin)(_this.props.channel.id, _this.props.user.id, function () {
                _this.props.actions.getChannelStats(_this.props.channel.id);
            }, function (err) {
                _this.setState({ serverError: err.message });
            });
        };

        _this.state = {
            serverError: null,
            user: null,
            role: null,
            removing: false
        };
        return _this;
    }

    (0, _createClass3.default)(ChannelMembersDropdown, [{
        key: 'render',
        value: function render() {
            var supportsChannelAdmin = this.props.isLicensed;
            var isChannelAdmin = supportsChannelAdmin && Utils.isChannelAdmin(this.props.isLicensed, this.props.channelMember.roles);

            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'has-error control-label' },
                        this.state.serverError
                    )
                );
            }

            if (this.props.user.id === _user_store2.default.getCurrentId()) {
                return null;
            }

            if (this.props.canChangeMemberRoles) {
                var role = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'channel_members_dropdown.channel_member',
                    defaultMessage: 'Channel Member'
                });

                if (isChannelAdmin) {
                    role = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'channel_members_dropdown.channel_admin',
                        defaultMessage: 'Channel Admin'
                    });
                }

                var removeFromChannel = null;
                if (this.props.canRemoveMember && this.props.channel.name !== _constants.Constants.DEFAULT_CHANNEL) {
                    removeFromChannel = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                id: 'removeFromChannel',
                                role: 'menuitem',
                                href: '#',
                                onClick: this.handleRemoveFromChannel
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_members_dropdown.remove_from_channel',
                                defaultMessage: 'Remove From Channel'
                            })
                        )
                    );
                }

                var makeChannelMember = null;
                if (isChannelAdmin) {
                    makeChannelMember = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                id: 'makeChannelMember',
                                role: 'menuitem',
                                href: '#',
                                onClick: this.handleMakeChannelMember
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_members_dropdown.make_channel_member',
                                defaultMessage: 'Make Channel Member'
                            })
                        )
                    );
                }

                var makeChannelAdmin = null;
                if (supportsChannelAdmin && !isChannelAdmin) {
                    makeChannelAdmin = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                id: 'makeChannelAdmin',
                                role: 'menuitem',
                                href: '#',
                                onClick: this.handleMakeChannelAdmin
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_members_dropdown.make_channel_admin',
                                defaultMessage: 'Make Channel Admin'
                            })
                        )
                    );
                }

                if ((makeChannelMember || makeChannelAdmin) && removeFromChannel) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'dropdown member-drop' },
                        _react2.default.createElement(
                            'button',
                            {
                                id: 'channelMemberDropdown',
                                className: 'dropdown-toggle theme color--link style--none',
                                type: 'button',
                                'data-toggle': 'dropdown',
                                'aria-expanded': 'true'
                            },
                            _react2.default.createElement(
                                'span',
                                null,
                                role,
                                ' '
                            ),
                            _react2.default.createElement('span', { className: 'fa fa-chevron-down' })
                        ),
                        _react2.default.createElement(
                            'ul',
                            {
                                className: 'dropdown-menu member-menu',
                                role: 'menu'
                            },
                            makeChannelMember,
                            makeChannelAdmin,
                            removeFromChannel
                        ),
                        serverError
                    );
                }
            }

            if (this.props.canRemoveMember && this.props.channel.name !== _constants.Constants.DEFAULT_CHANNEL) {
                return _react2.default.createElement(
                    'button',
                    {
                        id: 'removeMember',
                        type: 'button',
                        className: 'btn btn-danger btn-message',
                        onClick: this.handleRemoveFromChannel,
                        disabled: this.state.removing
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'channel_members_dropdown.remove_member',
                        defaultMessage: 'Remove Member'
                    })
                );
            }

            if (isChannelAdmin) {
                if (this.props.channel.name === _constants.Constants.DEFAULT_CHANNEL) {
                    return _react2.default.createElement('div', null);
                }

                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'channel_members_dropdown.channel_admin',
                        defaultMessage: 'Channel Admin'
                    })
                );
            }

            if (this.props.channel.name === _constants.Constants.DEFAULT_CHANNEL) {
                return _react2.default.createElement('div', null);
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'channel_members_dropdown.channel_member',
                    defaultMessage: 'Channel Member'
                })
            );
        }
    }]);
    return ChannelMembersDropdown;
}(_react2.default.Component); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ChannelMembersDropdown.propTypes = {
    channel: _propTypes2.default.object.isRequired,
    user: _propTypes2.default.object.isRequired,
    teamMember: _propTypes2.default.object.isRequired,
    channelMember: _propTypes2.default.object.isRequired,
    isLicensed: _propTypes2.default.bool.isRequired,
    canChangeMemberRoles: _propTypes2.default.bool.isRequired,
    canRemoveMember: _propTypes2.default.bool.isRequired,
    actions: _propTypes2.default.shape({
        getChannelStats: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = ChannelMembersDropdown;

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _channel_utils = __webpack_require__(854);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _notification_section = __webpack_require__(2429);

var _notification_section2 = _interopRequireDefault(_notification_section);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChannelNotificationsModal = function (_React$Component) {
    (0, _inherits3.default)(ChannelNotificationsModal, _React$Component);

    function ChannelNotificationsModal(props) {
        (0, _classCallCheck3.default)(this, ChannelNotificationsModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelNotificationsModal.__proto__ || (0, _getPrototypeOf2.default)(ChannelNotificationsModal)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            activeSection: _constants.NotificationSections.NONE,
            desktopNotifyLevel: props.channelMember.notify_props.desktop,
            markUnreadNotifyLevel: props.channelMember.notify_props.mark_unread,
            pushNotifyLevel: props.channelMember.notify_props.push || _constants.NotificationLevels.DEFAULT
        };
        return _this;
    }

    (0, _createClass3.default)(ChannelNotificationsModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!Utils.areObjectsEqual(this.props.channelMember.notify_props, nextProps.channelMember.notify_props)) {
                this.setState({
                    desktopNotifyLevel: nextProps.channelMember.notify_props.desktop,
                    markUnreadNotifyLevel: nextProps.channelMember.notify_props.mark_unread,
                    pushNotifyLevel: nextProps.channelMember.notify_props.push || _constants.NotificationLevels.DEFAULT
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                activeSection = _state.activeSection,
                desktopNotifyLevel = _state.desktopNotifyLevel,
                markUnreadNotifyLevel = _state.markUnreadNotifyLevel,
                pushNotifyLevel = _state.pushNotifyLevel,
                serverError = _state.serverError;
            var _props = this.props,
                channel = _props.channel,
                channelMember = _props.channelMember,
                currentUser = _props.currentUser,
                sendPushNotifications = _props.sendPushNotifications,
                show = _props.show;


            var serverErrorTag = null;
            if (serverError) {
                serverErrorTag = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        serverError
                    )
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: show,
                    dialogClassName: 'settings-modal settings-modal--tabless',
                    onHide: this.handleOnHide,
                    onExited: this.handleOnHide
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_notifications.preferences',
                            defaultMessage: 'Notification Preferences for '
                        }),
                        _react2.default.createElement(
                            'span',
                            { className: 'name' },
                            channel.display_name
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'settings-table' },
                        _react2.default.createElement(
                            'div',
                            { className: 'settings-content' },
                            _react2.default.createElement(
                                'div',
                                {
                                    ref: 'wrapper',
                                    className: 'user-settings'
                                },
                                _react2.default.createElement('br', null),
                                _react2.default.createElement('div', { className: 'divider-dark first' }),
                                _react2.default.createElement(_notification_section2.default, {
                                    section: _constants.NotificationSections.MARK_UNREAD,
                                    expand: activeSection === _constants.NotificationSections.MARK_UNREAD,
                                    memberNotificationLevel: markUnreadNotifyLevel,
                                    onChange: this.handleUpdateMarkUnreadLevel,
                                    onSubmit: this.handleSubmitMarkUnreadLevel,
                                    onUpdateSection: this.handleUpdateMarkUnreadSection,
                                    serverError: serverError
                                }),
                                !(0, _channel_utils.isChannelMuted)(channelMember) && _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement('div', { className: 'divider-light' }),
                                    _react2.default.createElement(_notification_section2.default, {
                                        section: _constants.NotificationSections.DESKTOP,
                                        expand: activeSection === _constants.NotificationSections.DESKTOP,
                                        memberNotificationLevel: desktopNotifyLevel,
                                        globalNotificationLevel: currentUser.notify_props ? currentUser.notify_props.desktop : _constants.NotificationLevels.ALL,
                                        onChange: this.handleUpdateDesktopNotifyLevel,
                                        onSubmit: this.handleSubmitDesktopNotifyLevel,
                                        onUpdateSection: this.handleUpdateDesktopSection,
                                        serverError: serverError
                                    }),
                                    _react2.default.createElement('div', { className: 'divider-light' }),
                                    sendPushNotifications && _react2.default.createElement(_notification_section2.default, {
                                        section: _constants.NotificationSections.PUSH,
                                        expand: activeSection === _constants.NotificationSections.PUSH,
                                        memberNotificationLevel: pushNotifyLevel,
                                        globalNotificationLevel: currentUser.notify_props ? currentUser.notify_props.push : _constants.NotificationLevels.ALL,
                                        onChange: this.handleUpdatePushNotificationLevel,
                                        onSubmit: this.handleSubmitPushNotificationLevel,
                                        onUpdateSection: this.handleUpdatePushSection,
                                        serverError: serverError
                                    })
                                ),
                                _react2.default.createElement('div', { className: 'divider-dark' })
                            )
                        )
                    ),
                    serverErrorTag
                )
            );
        }
    }]);
    return ChannelNotificationsModal;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ChannelNotificationsModal.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    onHide: _propTypes2.default.func.isRequired,
    channel: _propTypes2.default.object.isRequired,
    channelMember: _propTypes2.default.object.isRequired,
    currentUser: _propTypes2.default.object.isRequired,
    sendPushNotifications: _propTypes2.default.bool.isRequired,
    actions: _propTypes2.default.shape({
        updateChannelNotifyProps: _propTypes2.default.func.isRequired
    })
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleOnHide = function () {
        _this2.setState({
            activeSection: _constants.NotificationSections.NONE
        });

        _this2.props.onHide();
    };

    this.updateSection = function (section) {
        if ((0, _jquery2.default)('.section-max').length) {
            (0, _jquery2.default)('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
        }
        _this2.setState({ activeSection: section });
    };

    this.handleUpdateChannelNotifyProps = function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(props) {
            var _props2, actions, channel, currentUser, _ref2, error;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _props2 = _this2.props, actions = _props2.actions, channel = _props2.channel, currentUser = _props2.currentUser;
                            _context.next = 3;
                            return actions.updateChannelNotifyProps(currentUser.id, channel.id, props);

                        case 3:
                            _ref2 = _context.sent;
                            error = _ref2.error;

                            if (error) {
                                _this2.setState({ serverError: error.message });
                            } else {
                                _this2.updateSection('');
                            }

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    this.handleSubmitDesktopNotifyLevel = function () {
        var channelMember = _this2.props.channelMember;
        var desktopNotifyLevel = _this2.state.desktopNotifyLevel;


        if (channelMember.notify_props.desktop === desktopNotifyLevel) {
            _this2.updateSection('');
            return;
        }

        var props = { desktop: desktopNotifyLevel };
        _this2.handleUpdateChannelNotifyProps(props);
    };

    this.handleUpdateDesktopNotifyLevel = function (desktopNotifyLevel) {
        _this2.setState({ desktopNotifyLevel: desktopNotifyLevel });
    };

    this.handleUpdateDesktopSection = function () {
        var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.NotificationSections.NONE;

        _this2.updateSection(section);
        _this2.setState({
            desktopNotifyLevel: _this2.props.channelMember.notify_props.desktop
        });
    };

    this.handleSubmitMarkUnreadLevel = function () {
        var channelMember = _this2.props.channelMember;
        var markUnreadNotifyLevel = _this2.state.markUnreadNotifyLevel;


        if (channelMember.notify_props.mark_unread === markUnreadNotifyLevel) {
            _this2.updateSection('');
            return;
        }

        var props = { mark_unread: markUnreadNotifyLevel };
        _this2.handleUpdateChannelNotifyProps(props);
    };

    this.handleUpdateMarkUnreadLevel = function (markUnreadNotifyLevel) {
        _this2.setState({ markUnreadNotifyLevel: markUnreadNotifyLevel });
    };

    this.handleUpdateMarkUnreadSection = function () {
        var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.NotificationSections.NONE;

        _this2.updateSection(section);
        _this2.setState({
            markUnreadNotifyLevel: _this2.props.channelMember.notify_props.mark_unread
        });
    };

    this.handleSubmitPushNotificationLevel = function () {
        var pushNotifyLevel = _this2.state.pushNotifyLevel;


        if (_this2.props.channelMember.notify_props.push === pushNotifyLevel) {
            _this2.updateSection('');
            return;
        }

        var props = { push: pushNotifyLevel };
        _this2.handleUpdateChannelNotifyProps(props);
    };

    this.handleUpdatePushNotificationLevel = function (pushNotifyLevel) {
        _this2.setState({ pushNotifyLevel: pushNotifyLevel });
    };

    this.handleUpdatePushSection = function () {
        var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.NotificationSections.NONE;

        _this2.updateSection(section);
        _this2.setState({
            pushNotifyLevel: _this2.props.channelMember.notify_props.push
        });
    };
};

exports.default = ChannelNotificationsModal;

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _collapse_view = __webpack_require__(2430);

var _collapse_view2 = _interopRequireDefault(_collapse_view);

var _expand_view = __webpack_require__(2431);

var _expand_view2 = _interopRequireDefault(_expand_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var NotificationSection = function (_React$PureComponent) {
    (0, _inherits3.default)(NotificationSection, _React$PureComponent);

    function NotificationSection() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, NotificationSection);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NotificationSection.__proto__ || (0, _getPrototypeOf2.default)(NotificationSection)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnChange = function (e) {
            _this.props.onChange(e.target.value);
        }, _this.handleExpandSection = function () {
            _this.props.onUpdateSection(_this.props.section);
        }, _this.handleCollapseSection = function () {
            _this.props.onUpdateSection();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(NotificationSection, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                expand = _props.expand,
                globalNotificationLevel = _props.globalNotificationLevel,
                memberNotificationLevel = _props.memberNotificationLevel,
                onSubmit = _props.onSubmit,
                section = _props.section,
                serverError = _props.serverError;


            if (expand) {
                return _react2.default.createElement(_expand_view2.default, {
                    section: section,
                    memberNotifyLevel: memberNotificationLevel,
                    globalNotifyLevel: globalNotificationLevel,
                    onChange: this.handleOnChange,
                    onSubmit: onSubmit,
                    serverError: serverError,
                    onCollapseSection: this.handleCollapseSection
                });
            }

            return _react2.default.createElement(_collapse_view2.default, {
                section: section,
                onExpandSection: this.handleExpandSection,
                memberNotifyLevel: memberNotificationLevel,
                globalNotifyLevel: globalNotificationLevel
            });
        }
    }]);
    return NotificationSection;
}(_react2.default.PureComponent);

NotificationSection.propTypes = {

    /**
     * Notification section
     */
    section: _propTypes2.default.string.isRequired,

    /**
     * Expand if true, else collapse the section
     */
    expand: _propTypes2.default.bool.isRequired,

    /**
     * Member's desktop notification level
     */
    memberNotificationLevel: _propTypes2.default.string.isRequired,

    /**
     * User's global notification level
     */
    globalNotificationLevel: _propTypes2.default.string,

    /**
     * onChange handles update of desktop notification level
     */
    onChange: _propTypes2.default.func.isRequired,

    /**
     * Submit function to save notification level
     */
    onSubmit: _propTypes2.default.func.isRequired,

    /**
     * Update function to to expand or collapse a section
     */
    onUpdateSection: _propTypes2.default.func.isRequired,

    /**
     * Error string from the server
     */
    serverError: _propTypes2.default.string
};
exports.default = NotificationSection;

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CollapseView;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _setting_item_min = __webpack_require__(838);

var _setting_item_min2 = _interopRequireDefault(_setting_item_min);

var _describe = __webpack_require__(1415);

var _describe2 = _interopRequireDefault(_describe);

var _section_title = __webpack_require__(1416);

var _section_title2 = _interopRequireDefault(_section_title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CollapseView(_ref) {
    var onExpandSection = _ref.onExpandSection,
        globalNotifyLevel = _ref.globalNotifyLevel,
        memberNotifyLevel = _ref.memberNotifyLevel,
        section = _ref.section;

    return _react2.default.createElement(_setting_item_min2.default, {
        title: _react2.default.createElement(_section_title2.default, { section: section }),
        describe: _react2.default.createElement(_describe2.default, {
            section: section,
            memberNotifyLevel: memberNotifyLevel,
            globalNotifyLevel: globalNotifyLevel
        }),
        updateSection: onExpandSection,
        section: section
    });
} // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

CollapseView.propTypes = {
    onExpandSection: _propTypes2.default.func.isRequired,
    globalNotifyLevel: _propTypes2.default.string,
    memberNotifyLevel: _propTypes2.default.string.isRequired,
    section: _propTypes2.default.string.isRequired
};

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ExpandView;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(29);

var _setting_item_max = __webpack_require__(826);

var _setting_item_max2 = _interopRequireDefault(_setting_item_max);

var _describe = __webpack_require__(1415);

var _describe2 = _interopRequireDefault(_describe);

var _extra_info = __webpack_require__(2432);

var _extra_info2 = _interopRequireDefault(_extra_info);

var _section_title = __webpack_require__(1416);

var _section_title2 = _interopRequireDefault(_section_title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExpandView(_ref) {
    var section = _ref.section,
        memberNotifyLevel = _ref.memberNotifyLevel,
        globalNotifyLevel = _ref.globalNotifyLevel,
        onChange = _ref.onChange,
        onSubmit = _ref.onSubmit,
        serverError = _ref.serverError,
        onCollapseSection = _ref.onCollapseSection;

    var inputs = [_react2.default.createElement(
        'div',
        { key: 'channel-notification-level-radio' },
        (section === _constants.NotificationSections.DESKTOP || section === _constants.NotificationSections.PUSH) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: 'radio' },
                _react2.default.createElement(
                    'label',
                    { className: '' },
                    _react2.default.createElement('input', {
                        id: 'channelNotificationGlobalDefault',
                        type: 'radio',
                        value: _constants.NotificationLevels.DEFAULT,
                        checked: memberNotifyLevel === _constants.NotificationLevels.DEFAULT,
                        onChange: onChange
                    }),
                    _react2.default.createElement(_describe2.default, {
                        section: section,
                        memberNotifyLevel: _constants.NotificationLevels.DEFAULT,
                        globalNotifyLevel: globalNotifyLevel
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'radio' },
                _react2.default.createElement(
                    'label',
                    { className: '' },
                    _react2.default.createElement('input', {
                        id: 'channelNotificationAllActivity',
                        type: 'radio',
                        value: _constants.NotificationLevels.ALL,
                        checked: memberNotifyLevel === _constants.NotificationLevels.ALL,
                        onChange: onChange
                    }),
                    _react2.default.createElement(_describe2.default, {
                        section: section,
                        memberNotifyLevel: _constants.NotificationLevels.ALL
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'radio' },
                _react2.default.createElement(
                    'label',
                    { className: '' },
                    _react2.default.createElement('input', {
                        id: 'channelNotificationMentions',
                        type: 'radio',
                        value: _constants.NotificationLevels.MENTION,
                        checked: memberNotifyLevel === _constants.NotificationLevels.MENTION,
                        onChange: onChange
                    }),
                    _react2.default.createElement(_describe2.default, {
                        section: section,
                        memberNotifyLevel: _constants.NotificationLevels.MENTION
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'radio' },
                _react2.default.createElement(
                    'label',
                    null,
                    _react2.default.createElement('input', {
                        id: 'channelNotificationNever',
                        type: 'radio',
                        value: _constants.NotificationLevels.NONE,
                        checked: memberNotifyLevel === _constants.NotificationLevels.NONE,
                        onChange: onChange
                    }),
                    _react2.default.createElement(_describe2.default, {
                        section: section,
                        memberNotifyLevel: _constants.NotificationLevels.NONE
                    })
                )
            )
        ),
        section === _constants.NotificationSections.MARK_UNREAD && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: 'radio' },
                _react2.default.createElement(
                    'label',
                    { className: '' },
                    _react2.default.createElement('input', {
                        id: 'channelNotificationUnmute',
                        type: 'radio',
                        value: _constants.NotificationLevels.MENTION,
                        checked: memberNotifyLevel === _constants.NotificationLevels.MENTION,
                        onChange: onChange
                    }),
                    _react2.default.createElement(_describe2.default, {
                        section: section,
                        memberNotifyLevel: _constants.NotificationLevels.MENTION
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'radio' },
                _react2.default.createElement(
                    'label',
                    { className: '' },
                    _react2.default.createElement('input', {
                        id: 'channelNotificationMute',
                        type: 'radio',
                        value: _constants.NotificationLevels.ALL,
                        checked: memberNotifyLevel === _constants.NotificationLevels.ALL,
                        onChange: onChange
                    }),
                    _react2.default.createElement(_describe2.default, {
                        section: section,
                        memberNotifyLevel: _constants.NotificationLevels.ALL
                    })
                )
            )
        )
    )];

    return _react2.default.createElement(_setting_item_max2.default, {
        title: _react2.default.createElement(_section_title2.default, { section: section }),
        inputs: inputs,
        submit: onSubmit,
        server_error: serverError,
        updateSection: onCollapseSection,
        extraInfo: _react2.default.createElement(_extra_info2.default, { section: section })
    });
} // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ExpandView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    onCollapseSection: _propTypes2.default.func.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    globalNotifyLevel: _propTypes2.default.string,
    memberNotifyLevel: _propTypes2.default.string.isRequired,
    section: _propTypes2.default.string.isRequired,
    serverError: _propTypes2.default.string
};

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ExtraInfo;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function ExtraInfo(_ref) {
    var section = _ref.section;

    switch (section) {
        case _constants.NotificationSections.DESKTOP:
            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'channel_notifications.override',
                    defaultMessage: 'Selecting an option other than "Default" will override the global notification settings. Desktop notifications are available on Firefox, Safari, and Chrome.'
                })
            );
        case _constants.NotificationSections.PUSH:
            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'channel_notifications.overridePush',
                    defaultMessage: 'Selecting an option other than "Global default" will override the global notification settings for mobile push notifications in account settings. Push notifications must be enabled by the System Admin.'
                })
            );
        case _constants.NotificationSections.MARK_UNREAD:
            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'channel_notifications.muteChannel.help',
                    defaultMessage: 'Muting turns off desktop, email and push notifications for this channel. The channel will not be marked as unread unless you are mentioned.'
                })
            );
        default:
            return null;
    }
}

ExtraInfo.propTypes = {
    section: _propTypes2.default.string.isRequired
};

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DeleteChannelModal = function (_React$PureComponent) {
    (0, _inherits3.default)(DeleteChannelModal, _React$PureComponent);

    function DeleteChannelModal(props) {
        (0, _classCallCheck3.default)(this, DeleteChannelModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DeleteChannelModal.__proto__ || (0, _getPrototypeOf2.default)(DeleteChannelModal)).call(this, props));

        _this.handleDelete = _this.handleDelete.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        _this.state = { show: true };
        return _this;
    }

    (0, _createClass3.default)(DeleteChannelModal, [{
        key: 'handleDelete',
        value: function handleDelete() {
            if (this.props.channel.id.length !== _constants2.default.CHANNEL_ID_LENGTH) {
                return;
            }
            _browser_history.browserHistory.push('/' + this.props.currentTeamDetails.name + '/channels/' + _constants2.default.DEFAULT_CHANNEL);
            this.props.actions.deleteChannel(this.props.channel.id);
            this.onHide();
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            this.setState({ show: false });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.state.show,
                    onHide: this.onHide,
                    onExited: this.props.onHide
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        'h4',
                        { className: 'modal-title' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'delete_channel.confirm',
                            defaultMessage: 'Confirm DELETE Channel'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'alert alert-danger' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'delete_channel.question',
                            defaultMessage: 'This will delete the channel from the team and make its contents inaccessible for all users. <br /><br />Are you sure you wish to delete the <strong>{display_name}</strong> channel?',
                            values: {
                                display_name: this.props.channel.display_name
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-default',
                            onClick: this.onHide
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'delete_channel.cancel',
                            defaultMessage: 'Cancel'
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-danger',
                            'data-dismiss': 'modal',
                            onClick: this.handleDelete,
                            autoFocus: true
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'delete_channel.del',
                            defaultMessage: 'Delete'
                        })
                    )
                )
            );
        }
    }]);
    return DeleteChannelModal;
}(_react2.default.PureComponent);

DeleteChannelModal.propTypes = {

    /**
    * Function called when modal is dismissed
    */
    onHide: _propTypes2.default.func.isRequired,

    /**
     * channel data
     */
    channel: _propTypes2.default.object.isRequired,

    /**
     * currentTeamDetails used for redirection after deleting channel
     */
    currentTeamDetails: _propTypes2.default.object.isRequired,

    actions: _propTypes2.default.shape({

        /**
        * Function called for deleting channel,
        */

        deleteChannel: _propTypes2.default.func.isRequired
    })
};
exports.default = DeleteChannelModal;

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _textbox = __webpack_require__(968);

var _textbox2 = _interopRequireDefault(_textbox);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
var KeyCodes = _constants3.default.KeyCodes;

var holders = (0, _reactIntl.defineMessages)({
    error: {
        id: 'edit_channel_header_modal.error',
        defaultMessage: 'This channel header is too long, please enter a shorter one'
    }
});

var EditChannelHeaderModal = function (_React$PureComponent) {
    (0, _inherits3.default)(EditChannelHeaderModal, _React$PureComponent);

    function EditChannelHeaderModal(props) {
        (0, _classCallCheck3.default)(this, EditChannelHeaderModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EditChannelHeaderModal.__proto__ || (0, _getPrototypeOf2.default)(EditChannelHeaderModal)).call(this, props));

        _this.handleChange = function (e) {
            _this.setState({
                header: e.target.value
            });
        };

        _this.handleSave = function () {
            var _this$props = _this.props,
                channel = _this$props.channel,
                patchChannel = _this$props.actions.patchChannel;
            var header = _this.state.header;

            patchChannel(channel.id, { header: header });
        };

        _this.onHide = function () {
            _this.setState({ show: false });
        };

        _this.focusTextbox = function () {
            if (!Utils.isMobile()) {
                _this.refs.editChannelHeaderTextbox.focus();
            }
        };

        _this.handleEntering = function () {
            _this.focusTextbox();
        };

        _this.handleKeyDown = function (e) {
            var ctrlSend = _this.props.ctrlSend;

            if (ctrlSend && Utils.isKeyPressed(e, KeyCodes.ENTER) && e.ctrlKey === true) {
                _this.handleKeyPress(e);
            }
        };

        _this.handleKeyPress = function (e) {
            var ctrlSend = _this.props.ctrlSend;

            if (!UserAgent.isMobile() && (ctrlSend && e.ctrlKey || !ctrlSend)) {
                if (Utils.isKeyPressed(e, KeyCodes.ENTER) && !e.shiftKey && !e.altKey) {
                    e.preventDefault();
                    _reactDom2.default.findDOMNode(_this.refs.editChannelHeaderTextbox).blur();
                    _this.handleSave(e);
                }
            }
        };

        _this.state = {
            header: props.channel.header,
            show: true,
            showError: false
        };
        return _this;
    }

    (0, _createClass3.default)(EditChannelHeaderModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var nextRequestStatus = nextProps.requestStatus;
            var requestStatus = this.props.requestStatus;


            if (requestStatus !== nextRequestStatus && nextRequestStatus === _constants.RequestStatus.FAILURE) {
                this.setState({ showError: true });
            } else if (requestStatus !== nextRequestStatus && nextRequestStatus === _constants.RequestStatus.SUCCESS) {
                this.onHide();
            } else {
                this.setState({ showError: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var serverError = null;
            if (this.props.serverError && this.state.showError) {
                var errorMsg = void 0;
                if (this.props.serverError.server_error_id === 'model.channel.is_valid.header.app_error') {
                    errorMsg = this.props.intl.formatMessage(holders.error);
                } else {
                    errorMsg = this.props.serverError.message;
                }

                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        errorMsg
                    )
                );
            }

            var headerTitle = null;
            if (this.props.channel.type === _constants3.default.DM_CHANNEL) {
                headerTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'edit_channel_header_modal.title_dm',
                    defaultMessage: 'Edit Header'
                });
            } else {
                headerTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'edit_channel_header_modal.title',
                    defaultMessage: 'Edit Header for {channel}',
                    values: {
                        channel: this.props.channel.display_name
                    }
                });
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.state.show,
                    onHide: this.onHide,
                    onEntering: this.handleEntering,
                    onExited: this.props.onHide
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        headerTitle
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    { bsClass: 'modal-body edit-modal-body' },
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'edit_channel_header_modal.description',
                                defaultMessage: 'Edit the text appearing next to the channel name in the channel header.'
                            })
                        ),
                        _react2.default.createElement(_textbox2.default, {
                            value: this.state.header,
                            onChange: this.handleChange,
                            onKeyPress: this.handleKeyPress,
                            onKeyDown: this.handleKeyDown,
                            supportsCommands: false,
                            suggestionListStyle: 'bottom',
                            createMessage: Utils.localizeMessage('edit_channel_header.editHeader', 'Edit the Channel Header...'),
                            previewMessageLink: Utils.localizeMessage('edit_channel_header.previewHeader', 'Edit Header'),
                            handlePostError: this.handlePostError,
                            id: 'edit_textbox',
                            ref: 'editChannelHeaderTextbox',
                            characterLimit: 1024
                        }),
                        _react2.default.createElement('br', null),
                        serverError
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-default cancel-button',
                            onClick: this.onHide
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'edit_channel_header_modal.cancel',
                            defaultMessage: 'Cancel'
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            disabled: this.props.requestStatus === _constants.RequestStatus.STARTED,
                            type: 'button',
                            className: 'btn btn-primary save-button',
                            onClick: this.handleSave
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'edit_channel_header_modal.save',
                            defaultMessage: 'Save'
                        })
                    )
                )
            );
        }
    }]);
    return EditChannelHeaderModal;
}(_react2.default.PureComponent);

EditChannelHeaderModal.propTypes = {

    /*
     * react-intl helper object
     */
    intl: _reactIntl.intlShape.isRequired,

    /*
     * callback to call when modal will hide
     */
    onHide: _propTypes2.default.func.isRequired,

    /*
     * Object with info about current channel ,
     */
    channel: _propTypes2.default.object.isRequired,

    /*
     * boolean should be `ctrl` button pressed to send
     */
    ctrlSend: _propTypes2.default.bool.isRequired,

    /*
     * object with info about server error
     */
    serverError: _propTypes2.default.object,

    /*
     * string with info about about request
     */
    requestStatus: _propTypes2.default.string.isRequired,

    /*
     * Collection of redux actions
     */
    actions: _propTypes2.default.shape({

        /*
         * patch channel redux-action
         */
        patchChannel: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = (0, _reactIntl.injectIntl)(EditChannelHeaderModal);

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditChannelPurposeModal = function (_React$Component) {
    (0, _inherits3.default)(EditChannelPurposeModal, _React$Component);

    function EditChannelPurposeModal(props) {
        (0, _classCallCheck3.default)(this, EditChannelPurposeModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EditChannelPurposeModal.__proto__ || (0, _getPrototypeOf2.default)(EditChannelPurposeModal)).call(this, props));

        _this.setError = function (err) {
            if (err.id === 'api.context.invalid_param.app_error') {
                _this.setState({
                    serverError: Utils.localizeMessage('edit_channel_purpose_modal.error', 'This channel purpose is too long, please enter a shorter one')
                });
            } else {
                _this.setState({ serverError: err.message });
            }
        };

        _this.unsetError = function () {
            _this.setState({ serverError: '' });
        };

        _this.handleEntering = function () {
            Utils.placeCaretAtEnd(_this.purpose);
        };

        _this.handleHide = function () {
            _this.setState({ show: false });
        };

        _this.handleKeyDown = function (e) {
            var ctrlSend = _this.props.ctrlSend;


            if (ctrlSend && Utils.isKeyPressed(e, _constants3.default.KeyCodes.ENTER) && e.ctrlKey) {
                e.preventDefault();
                _this.handleSave(e);
            } else if (!ctrlSend && Utils.isKeyPressed(e, _constants3.default.KeyCodes.ENTER) && !e.shiftKey && !e.altKey) {
                e.preventDefault();
                _this.handleSave(e);
            }
        };

        _this.handleSave = function () {
            var _this$props = _this.props,
                channel = _this$props.channel,
                patchChannel = _this$props.actions.patchChannel;
            var purpose = _this.state.purpose;

            if (!channel) {
                return;
            }

            patchChannel(channel.id, { purpose: purpose });
        };

        _this.handleChange = function (e) {
            e.preventDefault();
            _this.setState({ purpose: e.target.value });
        };

        _this.getPurpose = function (node) {
            _this.purpose = node;
        };

        _this.state = {
            purpose: props.channel.purpose || '',
            serverError: '',
            show: true,
            submitted: false
        };
        return _this;
    }

    (0, _createClass3.default)(EditChannelPurposeModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var nextRequestStatus = nextProps.requestStatus,
                nextServerError = nextProps.serverError;
            var requestStatus = this.props.requestStatus;


            if (requestStatus !== nextRequestStatus && nextRequestStatus === _constants.RequestStatus.SUCCESS) {
                this.handleHide();
            }

            if (requestStatus !== nextRequestStatus && nextRequestStatus === _constants.RequestStatus.FAILURE) {
                this.setError(nextServerError);
            } else {
                this.unsetError();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.serverError
                    )
                );
            }

            var title = _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'edit_channel_purpose_modal.title1',
                    defaultMessage: 'Edit Purpose'
                })
            );
            if (this.props.channel.display_name) {
                title = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'edit_channel_purpose_modal.title2',
                        defaultMessage: 'Edit Purpose for '
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'name' },
                        this.props.channel.display_name
                    )
                );
            }

            var channelPurposeModal = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'edit_channel_purpose_modal.body',
                defaultMessage: 'Describe how this channel should be used. This text appears in the channel list in the "More..." menu and helps others decide whether to join.'
            });
            if (this.props.channel.type === 'P') {
                channelPurposeModal = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'edit_channel_private_purpose_modal.body',
                    defaultMessage: 'This text appears in the \\"View Info\\" modal of the private channel.'
                });
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    className: 'modal-edit-channel-purpose',
                    ref: 'modal',
                    show: this.state.show,
                    onHide: this.handleHide,
                    onEntering: this.handleEntering,
                    onExited: this.props.onModalDismissed
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        title
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        channelPurposeModal
                    ),
                    _react2.default.createElement('textarea', {
                        ref: this.getPurpose,
                        className: 'form-control no-resize',
                        rows: '6',
                        maxLength: '250',
                        value: this.state.purpose,
                        onKeyDown: this.handleKeyDown,
                        onChange: this.handleChange
                    }),
                    serverError
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-default cancel-button',
                            onClick: this.handleHide
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'edit_channel_purpose_modal.cancel',
                            defaultMessage: 'Cancel'
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-primary save-button',
                            disabled: this.props.requestStatus === _constants.RequestStatus.STARTED,
                            onClick: this.handleSave
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'edit_channel_purpose_modal.save',
                            defaultMessage: 'Save'
                        })
                    )
                )
            );
        }
    }]);
    return EditChannelPurposeModal;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

EditChannelPurposeModal.propTypes = {

    /*
     * Channel info object
     */
    channel: _propTypes2.default.object,

    /*
     * Check should we send purpose on CTRL + ENTER
     */
    ctrlSend: _propTypes2.default.bool.isRequired,

    /*
     * Info about patch serverError
     */
    serverError: _propTypes2.default.object,

    /*
     *  Status of patch info about channel request
     */
    requestStatus: _propTypes2.default.string.isRequired,

    /*
     * Callback to call on modal hide
     */
    onModalDismissed: _propTypes2.default.func.isRequired,

    /*
     * Object with redux action creators
     */
    actions: _propTypes2.default.shape({

        /*
         * Action creator to patch current channel
         */
        patchChannel: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = EditChannelPurposeModal;

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _channels = __webpack_require__(783);

var _users2 = __webpack_require__(777);

var _popover_list_members = __webpack_require__(2437);

var _popover_list_members2 = _interopRequireDefault(_popover_list_members);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function makeMapStateToProps() {
    var doGetProfilesInChannel = (0, _users2.makeGetProfilesInChannel)();

    return function mapStateToProps(state, ownProps) {
        var stats = (0, _channels.getAllChannelStats)(state)[ownProps.channel.id] || {};
        var users = doGetProfilesInChannel(state, ownProps.channel.id, true);

        return {
            currentUserId: (0, _users2.getCurrentUserId)(state),
            memberCount: stats.member_count,
            users: users,
            statuses: (0, _users2.getUserStatuses)(state)
        };
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getProfilesInChannel: _users.getProfilesInChannel
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_popover_list_members2.default);

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _channel_actions = __webpack_require__(809);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _channel_utils = __webpack_require__(830);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _channel_invite_modal = __webpack_require__(986);

var _channel_invite_modal2 = _interopRequireDefault(_channel_invite_modal);

var _channel_members_modal = __webpack_require__(1088);

var _channel_members_modal2 = _interopRequireDefault(_channel_members_modal);

var _member_icon = __webpack_require__(2438);

var _member_icon2 = _interopRequireDefault(_member_icon);

var _team_members_modal = __webpack_require__(1051);

var _team_members_modal2 = _interopRequireDefault(_team_members_modal);

var _popover_list_members_item = __webpack_require__(2439);

var _popover_list_members_item2 = _interopRequireDefault(_popover_list_members_item);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopoverListMembers = function (_React$Component) {
    (0, _inherits3.default)(PopoverListMembers, _React$Component);

    function PopoverListMembers(props) {
        (0, _classCallCheck3.default)(this, PopoverListMembers);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PopoverListMembers.__proto__ || (0, _getPrototypeOf2.default)(PopoverListMembers)).call(this, props));

        _this.sortUsers = function (users, statuses) {
            return Utils.sortUsersByStatusAndDisplayName(users, statuses);
        };

        _this.handleShowDirectChannel = function (user) {
            var teammateId = user.id;

            if (teammateId) {
                (0, _channel_actions.openDirectChannelToUser)(teammateId, function (channel, channelAlreadyExisted) {
                    _browser_history.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name);
                    if (channelAlreadyExisted) {
                        _this.closePopover();
                    }
                }, function () {
                    _this.closePopover();
                });
            }
        };

        _this.closePopover = function () {
            _this.setState({ showPopover: false });
        };

        _this.showMembersModal = function (e) {
            e.preventDefault();

            _this.setState({
                showPopover: false,
                showChannelMembersModal: true
            });
        };

        _this.hideChannelMembersModal = function () {
            _this.setState({ showChannelMembersModal: false });
        };

        _this.showChannelInviteModal = function () {
            _this.setState({ showChannelInviteModal: true });
        };

        _this.hideChannelInviteModal = function () {
            _this.setState({ showChannelInviteModal: false });
        };

        _this.hideTeamMembersModal = function () {
            _this.setState({ showTeamMembersModal: false });
        };

        _this.handleGetProfilesInChannel = function (e) {
            _this.setState({ popoverTarget: e.target, showPopover: !_this.state.showPopover });
            _this.props.actions.getProfilesInChannel(_this.props.channel.id, 0, undefined, 'status'); // eslint-disable-line no-undefined
        };

        _this.getTargetPopover = function () {
            return _this.state.popoverTarget;
        };

        _this.state = {
            showPopover: false,
            showTeamMembersModal: false,
            showChannelMembersModal: false,
            showChannelInviteModal: false,
            sortedUsers: _this.sortUsers(props.users, props.statuses)
        };
        return _this;
    }

    (0, _createClass3.default)(PopoverListMembers, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            (0, _jquery2.default)('.member-list__popover .popover-content .more-modal__body').perfectScrollbar();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.users !== nextProps.users || this.props.statuses !== nextProps.statuses) {
                var sortedUsers = this.sortUsers(nextProps.users, nextProps.statuses);

                this.setState({ sortedUsers: sortedUsers });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isDirectChannel = this.props.channel.type === _constants2.default.DM_CHANNEL;

            var items = this.state.sortedUsers.map(function (user) {
                return _react2.default.createElement(_popover_list_members_item2.default, {
                    key: user.id,
                    onItemClick: _this2.handleShowDirectChannel,
                    showMessageIcon: _this2.props.currentUserId !== user.id && !isDirectChannel,
                    status: _this2.props.statuses[user.id],
                    user: user
                });
            });

            var popoverButton = void 0;
            if (this.props.channel.type !== _constants2.default.GM_CHANNEL) {
                var membersName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'members_popover.manageMembers',
                    defaultMessage: 'Manage Members'
                });

                var manageMembers = (0, _channel_utils.canManageMembers)(this.props.channel);
                var isDefaultChannel = _channel_store2.default.isDefault(this.props.channel);

                if (isDefaultChannel || !manageMembers) {
                    membersName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'members_popover.viewMembers',
                        defaultMessage: 'View Members'
                    });
                }

                popoverButton = _react2.default.createElement(
                    'div',
                    {
                        className: 'more-modal__button',
                        key: 'popover-member-more'
                    },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-link',
                            onClick: this.showMembersModal
                        },
                        membersName
                    )
                );
            }

            var count = this.props.memberCount;
            var countText = '-';
            if (count > 0) {
                countText = count.toString();
            }

            var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'members_popover.title',
                defaultMessage: 'Channel Members'
            });

            var channelMembersModal = void 0;
            if (this.state.showChannelMembersModal) {
                channelMembersModal = _react2.default.createElement(_channel_members_modal2.default, {
                    onModalDismissed: this.hideChannelMembersModal,
                    showInviteModal: this.showChannelInviteModal,
                    channel: this.props.channel
                });
            }

            var teamMembersModal = void 0;
            if (this.state.showTeamMembersModal) {
                teamMembersModal = _react2.default.createElement(_team_members_modal2.default, {
                    onHide: this.hideTeamMembersModal
                });
            }

            var channelInviteModal = void 0;
            if (this.state.showChannelInviteModal) {
                channelInviteModal = _react2.default.createElement(_channel_invite_modal2.default, {
                    onHide: this.hideChannelInviteModal,
                    channel: this.props.channel
                });
            }

            var channelMembersTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'channelMembersTooltip' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'channel_header.channelMembers',
                    defaultMessage: 'Members'
                })
            );

            return _react2.default.createElement(
                'div',
                {
                    id: 'channelMember',
                    className: 'channel-header__icon wide ' + (this.state.showPopover ? 'active' : '')
                },
                _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        trigger: ['hover', 'focus'],
                        delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                        placement: 'bottom',
                        overlay: channelMembersTooltip
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            id: 'member_popover',
                            className: 'member-popover__trigger',
                            ref: 'member_popover_target',
                            onClick: this.handleGetProfilesInChannel
                        },
                        _react2.default.createElement(
                            'span',
                            {
                                id: 'channelMemberCountText',
                                className: 'icon__text'
                            },
                            countText
                        ),
                        _react2.default.createElement(_member_icon2.default, {
                            id: 'channelMemberIcon',
                            className: 'icon icon__members',
                            'aria-hidden': 'true'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Overlay,
                    {
                        rootClose: true,
                        onHide: this.closePopover,
                        show: this.state.showPopover,
                        target: this.getTargetPopover,
                        placement: 'bottom'
                    },
                    _react2.default.createElement(
                        _reactBootstrap.Popover,
                        {
                            ref: 'memebersPopover',
                            className: 'member-list__popover',
                            id: 'member-list-popover'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'more-modal__header' },
                            title
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'more-modal__body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'more-modal__list' },
                                items
                            )
                        ),
                        popoverButton
                    )
                ),
                channelMembersModal,
                teamMembersModal,
                channelInviteModal
            );
        }
    }]);
    return PopoverListMembers;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PopoverListMembers.propTypes = {
    channel: _propTypes2.default.object.isRequired,
    statuses: _propTypes2.default.object.isRequired,
    users: _propTypes2.default.array.isRequired,
    memberCount: _propTypes2.default.number,
    currentUserId: _propTypes2.default.string.isRequired,
    actions: _propTypes2.default.shape({
        getProfilesInChannel: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = PopoverListMembers;

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(MemberIcon, _React$PureComponent);

    function MemberIcon() {
        (0, _classCallCheck3.default)(this, MemberIcon);
        return (0, _possibleConstructorReturn3.default)(this, (MemberIcon.__proto__ || (0, _getPrototypeOf2.default)(MemberIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(MemberIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '14px',
                        height: '14px',
                        viewBox: '0 0 16 16'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            id: 'Symbols',
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                id: 'Channel-Header/Web-HD',
                                transform: 'translate(-725.000000, -32.000000)',
                                fillRule: 'nonzero',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                { id: 'Channel-Header' },
                                _react2.default.createElement(
                                    'g',
                                    {
                                        id: 'user-count',
                                        transform: 'translate(676.000000, 22.000000)'
                                    },
                                    _react2.default.createElement('path', {
                                        d: 'M64.9481342,24 C64.6981342,20.955 63.2551342,19.076 60.6731342,18.354 C61.4831342,17.466 61.9881342,16.296 61.9881342,15 C61.9881342,12.238 59.7501342,10 56.9881342,10 C54.2261342,10 51.9881342,12.238 51.9881342,15 C51.9881342,16.297 52.4941342,17.467 53.3031342,18.354 C50.7221342,19.076 49.2771342,20.955 49.0271342,24 C49.0161342,24.146 49.0061342,24.577 49.0001342,25.001 C48.9911342,25.553 49.4361342,26 49.9881342,26 L63.9881342,26 C64.5411342,26 64.9851342,25.553 64.9761342,25.001 C64.9701342,24.577 64.9601342,24.146 64.9481342,24 Z M56.9881342,12 C58.6421342,12 59.9881342,13.346 59.9881342,15 C59.9881342,16.654 58.6421342,18 56.9881342,18 C55.3341342,18 53.9881342,16.654 53.9881342,15 C53.9881342,13.346 55.3341342,12 56.9881342,12 Z M51.0321342,24 C51.2981342,21.174 52.7911342,20 55.9881342,20 L57.9881342,20 C61.1851342,20 62.6781342,21.174 62.9441342,24 L51.0321342,24 Z',
                                        id: 'User_4_x2C__Profile_5-Copy-9'
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return MemberIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = MemberIcon;

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _client = __webpack_require__(270);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

var _message_icon = __webpack_require__(2440);

var _message_icon2 = _interopRequireDefault(_message_icon);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopoverListMembersItem = function (_React$PureComponent) {
    (0, _inherits3.default)(PopoverListMembersItem, _React$PureComponent);

    function PopoverListMembersItem() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PopoverListMembersItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverListMembersItem.__proto__ || (0, _getPrototypeOf2.default)(PopoverListMembersItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            _this.props.onItemClick(_this.props.user);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PopoverListMembersItem, [{
        key: 'render',
        value: function render() {
            if (!this.props.user) {
                return null;
            }

            var name = Utils.getDisplayNameByUser(this.props.user);
            if (!name) {
                return null;
            }

            var messageIcon = void 0;
            if (this.props.showMessageIcon) {
                messageIcon = _react2.default.createElement(_message_icon2.default, {
                    className: 'icon icon__message',
                    'aria-hidden': 'true'
                });
            }

            return _react2.default.createElement(
                'div',
                {
                    className: 'more-modal__row',
                    onClick: this.handleClick
                },
                _react2.default.createElement(_profile_picture2.default, {
                    src: _client.Client4.getProfilePictureUrl(this.props.user.id, this.props.user.last_picture_update),
                    status: this.props.status,
                    width: '32',
                    height: '32'
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__details' },
                    _react2.default.createElement(
                        'div',
                        { className: 'more-modal__name' },
                        name
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__actions' },
                    messageIcon
                )
            );
        }
    }]);
    return PopoverListMembersItem;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PopoverListMembersItem.propTypes = {
    showMessageIcon: _propTypes2.default.bool.isRequired,
    onItemClick: _propTypes2.default.func.isRequired,
    status: _propTypes2.default.string.isRequired,
    user: _propTypes2.default.object.isRequired
};
PopoverListMembersItem.defaultProps = {
    status: _constants.UserStatuses.OFFLINE
};
exports.default = PopoverListMembersItem;

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(MessageIcon, _React$PureComponent);

    function MessageIcon() {
        (0, _classCallCheck3.default)(this, MessageIcon);
        return (0, _possibleConstructorReturn3.default)(this, (MessageIcon.__proto__ || (0, _getPrototypeOf2.default)(MessageIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(MessageIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '18px',
                        height: '16px',
                        viewBox: '0 0 18 16'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-200.000000, -174.000000)',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                { transform: 'translate(200.000000, 174.000000)' },
                                _react2.default.createElement('path', { d: 'M7.2546625,1.42801356 C10.458475,1.42801356 12.999475,3.24528136 12.999475,5.52023729 C12.9895,8.04188475 10.6062625,9.89326102 7.40245,9.89326102 C7.40245,9.89326102 6.9134125,9.91229831 6.4115125,9.83747119 L5.82535,9.79622373 L5.15335,10.3586169 C4.997425,10.5397356 4.3199125,11.1095322 3.736375,11.4794373 C4.0915375,10.4598847 4.07605,10.1370441 4.07605,10.1370441 L4.1251375,9.49004068 L3.55315,9.19549153 C2.0986375,8.44616271 1.4444875,6.88616271 1.4444875,5.52023729 C1.4444875,3.24528136 4.05085,1.42801356 7.2546625,1.42801356 M7.2546625,0.370386441 C3.465475,0.370386441 0.3944875,2.65829831 0.3944875,5.52023729 C0.3944875,7.3028678 1.2623125,9.20342373 3.0751375,10.1370441 C3.0751375,10.1478847 3.07225,10.1560814 3.07225,10.1679797 C3.07225,10.9426915 2.43175,12.0048136 2.1794875,12.4429356 L2.1805375,12.4429356 C2.1605875,12.4902644 2.148775,12.5420881 2.148775,12.5973492 C2.148775,12.8141627 2.322025,12.9881424 2.5375375,12.9881424 C2.5693,12.9881424 2.6210125,12.9815322 2.6393875,12.9815322 C2.6446375,12.9815322 2.6467375,12.9815322 2.6462125,12.9831186 C3.986275,12.762339 5.9642125,11.2435864 6.2576875,10.8837288 C6.5585125,10.928678 6.761425,10.9358169 7.0136875,10.9358169 C7.120525,10.9358169 7.2347125,10.9342305 7.3696375,10.9342305 C11.1583,10.9342305 14.094625,8.75446102 14.049475,5.52023729 C14.049475,2.65829831 11.0435875,0.370386441 7.2546625,0.370386441' }),
                                _react2.default.createElement('path', { d: 'M17.2055125,9.79172881 C17.2055125,8.35811525 16.6498,7.26532203 15.2624875,6.4451322 C15.228625,6.82614237 15.120475,7.23517966 15.0031375,7.59477288 C15.8998375,8.21903729 16.1555125,8.85995932 16.1555125,9.79172881 C16.1555125,10.9323797 15.62815,11.7597085 14.40175,12.3919051 L13.879375,12.653139 C13.879375,12.653139 13.9337125,14.0082237 14.0140375,14.3511593 C12.9895,13.5946915 12.6374875,12.9630237 12.6374875,12.9630237 L12.08545,13.0486915 C11.86705,13.0809492 11.276425,13.0812136 11.276425,13.0812136 C9.85,13.0812136 8.7929125,12.7388068 7.8909625,12.0278169 C8.135875,12.0124814 6.42805,12.0132746 6.3899875,12.0468542 C7.4326375,13.3297559 9.1373125,14.1388407 11.276425,14.1388407 C11.3927125,14.1388407 11.49115,14.1398983 11.58355,14.1398983 C11.801425,14.1398983 11.9773,14.1338169 12.237175,14.095478 C12.491275,14.4058915 13.914025,15.7728746 15.0724375,15.9629831 C15.0719125,15.9619254 15.073225,15.9619254 15.078475,15.9619254 C15.0939625,15.9619254 15.13885,15.967478 15.16615,15.967478 C15.3522625,15.967478 15.5024125,15.8167661 15.5024125,15.6293017 C15.5024125,15.5817085 15.49165,15.5367593 15.47485,15.4960407 L15.4759,15.4960407 C15.258025,15.117939 14.9159875,14.0129831 14.9159875,13.3435051 C14.9159875,13.3331932 14.9128375,13.3260542 14.9128375,13.3168 C16.4797,12.5095661 17.2055125,11.3321627 17.2055125,9.79172881' })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return MessageIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = MessageIcon;

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RenameChannelModal = undefined;

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _url = __webpack_require__(793);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var holders = (0, _reactIntl.defineMessages)({
    required: {
        id: 'rename_channel.required',
        defaultMessage: 'This field is required'
    },
    maxLength: {
        id: 'rename_channel.maxLength',
        defaultMessage: 'This field must be less than {maxLength, number} characters'
    },
    lowercase: {
        id: 'rename_channel.lowercase',
        defaultMessage: 'Must be lowercase alphanumeric characters'
    },
    url: {
        id: 'rename_channel.url',
        defaultMessage: 'URL'
    },
    defaultError: {
        id: 'rename_channel.defaultError',
        defaultMessage: ' - Cannot be changed for the default channel'
    },
    displayNameHolder: {
        id: 'rename_channel.displayNameHolder',
        defaultMessage: 'Enter display name'
    },
    handleHolder: {
        id: 'rename_channel.handleHolder',
        defaultMessage: 'lowercase alphanumeric characters'
    }
});

var RenameChannelModal = exports.RenameChannelModal = function (_React$PureComponent) {
    (0, _inherits3.default)(RenameChannelModal, _React$PureComponent);

    function RenameChannelModal(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, RenameChannelModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RenameChannelModal.__proto__ || (0, _getPrototypeOf2.default)(RenameChannelModal)).call(this, props));

        _this.setError = function (err) {
            _this.setState({ serverError: err.message });
        };

        _this.unsetError = function () {
            _this.setState({ serverError: '' });
        };

        _this.handleEntering = function () {
            Utils.placeCaretAtEnd(_this.textbox);
        };

        _this.handleHide = function (e) {
            if (e) {
                e.preventDefault();
            }

            _this.props.onHide();

            _this.setState({
                serverError: '',
                nameError: '',
                displayNameError: '',
                invalid: false
            });
        };

        _this.handleSubmit = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(e) {
                var channel, oldName, oldDisplayName, state, formatMessage, updateChannel, cleanedName, _ref2, data, error;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (e) {
                                    e.preventDefault();
                                }

                                channel = (0, _assign2.default)({}, _this.props.channel);
                                oldName = channel.name;
                                oldDisplayName = channel.display_name;
                                state = { serverError: '' };
                                formatMessage = _this.props.intl.formatMessage;
                                updateChannel = _this.props.actions.updateChannel;


                                channel.display_name = _this.state.displayName.trim();
                                if (!channel.display_name) {
                                    state.displayNameError = formatMessage(holders.required);
                                    state.invalid = true;
                                } else if (channel.display_name.length > _constants2.default.MAX_CHANNELNAME_LENGTH) {
                                    state.displayNameError = formatMessage(holders.maxLength, { maxLength: _constants2.default.MAX_CHANNELNAME_LENGTH });
                                    state.invalid = true;
                                } else if (channel.display_name.length < _constants2.default.MIN_CHANNELNAME_LENGTH) {
                                    state.displayNameError = _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'rename_channel.minLength',
                                        defaultMessage: 'Channel name must be {minLength, number} or more characters',
                                        values: {
                                            minLength: _constants2.default.MIN_CHANNELNAME_LENGTH
                                        }
                                    });
                                    state.invalid = true;
                                } else {
                                    state.displayNameError = '';
                                }

                                channel.name = _this.state.channelName.trim();
                                if (!channel.name) {
                                    state.nameError = formatMessage(holders.required);
                                    state.invalid = true;
                                } else if (channel.name.length > _constants2.default.MAX_CHANNELNAME_LENGTH) {
                                    state.nameError = formatMessage(holders.maxLength, { maxLength: _constants2.default.MAX_CHANNELNAME_LENGTH });
                                    state.invalid = true;
                                } else {
                                    cleanedName = (0, _url.cleanUpUrlable)(channel.name);

                                    if (cleanedName === channel.name) {
                                        state.nameError = '';
                                    } else {
                                        state.nameError = formatMessage(holders.lowercase);
                                        state.invalid = true;
                                    }
                                }

                                _this.setState(state);

                                if (!state.invalid) {
                                    _context.next = 14;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 14:
                                if (!(oldName === channel.name && oldDisplayName === channel.display_name)) {
                                    _context.next = 17;
                                    break;
                                }

                                _this.onSaveSuccess();
                                return _context.abrupt('return');

                            case 17:
                                _context.next = 19;
                                return updateChannel(channel);

                            case 19:
                                _ref2 = _context.sent;
                                data = _ref2.data;
                                error = _ref2.error;


                                if (data) {
                                    _this.onSaveSuccess();
                                } else if (error) {
                                    _this.setError(error);
                                }

                            case 23:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.onSaveSuccess = function () {
            _this.handleHide();
            _this.unsetError();
            _browser_history.browserHistory.push('/' + _this.props.team.name + '/channels/' + _this.state.channelName);
        };

        _this.handleCancel = function (e) {
            _this.setState({
                displayName: _this.props.channel.display_name,
                channelName: _this.props.channel.name
            });

            _this.handleHide(e);
        };

        _this.onNameChange = function (e) {
            _this.setState({ channelName: e.target.value });
        };

        _this.onDisplayNameChange = function (e) {
            _this.setState({ displayName: e.target.value });
        };

        _this.getTextbox = function (node) {
            _this.textbox = node;
        };

        _this.state = {
            displayName: props.channel.display_name,
            channelName: props.channel.name,
            serverError: '',
            nameError: '',
            displayNameError: '',
            invalid: false
        };
        return _this;
    }

    (0, _createClass3.default)(RenameChannelModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!Utils.areObjectsEqual(nextProps.channel, this.props.channel)) {
                this.setState({
                    displayName: nextProps.channel.display_name,
                    channelName: nextProps.channel.name
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var displayNameError = null;
            var displayNameClass = 'form-group';
            if (this.state.displayNameError) {
                displayNameError = _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    this.state.displayNameError
                );
                displayNameClass += ' has-error';
            }

            var nameError = null;
            var nameClass = 'form-group';
            if (this.state.nameError) {
                nameError = _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    this.state.nameError
                );
                nameClass += ' has-error';
            }

            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.serverError
                    )
                );
            }

            var formatMessage = this.props.intl.formatMessage;


            var urlInputLabel = formatMessage(holders.url);
            var handleInputClass = 'form-control';
            var readOnlyHandleInput = false;
            if (this.state.channelName === _constants2.default.DEFAULT_CHANNEL) {
                urlInputLabel += formatMessage(holders.defaultError);
                readOnlyHandleInput = true;
            }

            var fullUrl = this.props.currentTeamUrl + '/channels';
            var shortUrl = (0, _url.getShortenedURL)(fullUrl, 35);
            var urlTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'urlTooltip' },
                fullUrl
            );

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.props.show,
                    onEntering: this.handleEntering,
                    onHide: this.handleCancel
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'rename_channel.title',
                            defaultMessage: 'Rename Channel'
                        })
                    )
                ),
                _react2.default.createElement(
                    'form',
                    { role: 'form' },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Body,
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: displayNameClass },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'rename_channel.displayName',
                                    defaultMessage: 'Display Name'
                                })
                            ),
                            _react2.default.createElement('input', {
                                onChange: this.onDisplayNameChange,
                                type: 'text',
                                ref: this.getTextbox,
                                id: 'display_name',
                                className: 'form-control',
                                placeholder: formatMessage(holders.displayNameHolder),
                                value: this.state.displayName,
                                maxLength: _constants2.default.MAX_CHANNELNAME_LENGTH
                            }),
                            displayNameError
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: nameClass },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label' },
                                urlInputLabel
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group--limit' },
                                _react2.default.createElement(
                                    _reactBootstrap.OverlayTrigger,
                                    {
                                        trigger: ['hover', 'focus'],
                                        delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                        placement: 'top',
                                        overlay: urlTooltip
                                    },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'input-group-addon' },
                                        shortUrl
                                    )
                                ),
                                _react2.default.createElement('input', {
                                    onChange: this.onNameChange,
                                    type: 'text',
                                    className: handleInputClass,
                                    id: 'channel_name',
                                    placeholder: formatMessage(holders.handleHolder),
                                    value: this.state.channelName,
                                    maxLength: _constants2.default.MAX_CHANNELNAME_LENGTH,
                                    readOnly: readOnlyHandleInput
                                })
                            ),
                            nameError
                        ),
                        serverError
                    ),
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Footer,
                        null,
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'btn btn-default',
                                onClick: this.handleCancel
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'rename_channel.cancel',
                                defaultMessage: 'Cancel'
                            })
                        ),
                        _react2.default.createElement(
                            'button',
                            {
                                onClick: this.handleSubmit,
                                type: 'submit',
                                id: 'save-button',
                                className: 'btn btn-primary'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'rename_channel.save',
                                defaultMessage: 'Save'
                            })
                        )
                    )
                )
            );
        }
    }]);
    return RenameChannelModal;
}(_react2.default.PureComponent);

RenameChannelModal.propTypes = {

    /**
     * react-intl helper object
     */
    intl: _reactIntl.intlShape.isRequired,

    /**
     * Determines whether this modal should be shown or not
     */
    show: _propTypes2.default.bool.isRequired,

    /**
     * Function that is called when modal is hidden
     */
    onHide: _propTypes2.default.func.isRequired,

    /**
     * Object with info about current channel
     */
    channel: _propTypes2.default.object.isRequired,

    /**
     * Object with info about current team
     */
    team: _propTypes2.default.object.isRequired,

    /**
     * String with the current team URL
     */
    currentTeamUrl: _propTypes2.default.string.isRequired,

    /*
     * Object with redux action creators
     */
    actions: _propTypes2.default.shape({

        /*
         * Action creator to update current channel
         */
        updateChannel: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = (0, _reactIntl.injectIntl)(RenameChannelModal);

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PinIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(PinIcon, _React$PureComponent);

    function PinIcon() {
        (0, _classCallCheck3.default)(this, PinIcon);
        return (0, _possibleConstructorReturn3.default)(this, (PinIcon.__proto__ || (0, _getPrototypeOf2.default)(PinIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(PinIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '14px',
                        height: '14px',
                        viewBox: '0 0 16 16',
                        version: '1.1'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            id: 'Symbols',
                            stroke: 'inherit',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-775.000000, -32.000000)',
                                fillRule: 'nonzero',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                null,
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(764.000000, 22.000000)' },
                                    _react2.default.createElement(
                                        'g',
                                        { transform: 'translate(10.000000, 10.000000)' },
                                        _react2.default.createElement('path', { d: 'M16.456,7.291 L9.483,0.25 C9.31,0.078 9.178,0 9.08,0 C8.896,0 8.831,0.276 8.831,0.732 L8.831,3.044 L5.831,5.96 L2.578,6.268 C1.887,6.405 1.668,6.917 2.167,7.41 L4.781,10.011 L3.83,10.961 L1.05,15.511 C0.93,15.761 1.03,15.862 1.28,15.74 L5.83,12.961 L6.786,12.005 L9.359,14.565 C9.556,14.76 9.754,14.854 9.929,14.854 C10.197,14.854 10.413,14.634 10.497,14.219 L10.83,10.961 L13.746,7.961 L16.082,7.961 C16.788,7.961 16.955,7.785 16.456,7.291 Z M12.312,6.567 L9.396,9.567 L8.911,10.065 L8.84,10.757 L8.797,11.184 L5.589,7.992 L6.018,7.952 L6.72,7.886 L7.225,7.396 L10.225,4.48 L10.547,4.167 L12.616,6.256 L12.312,6.567 Z' })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return PinIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = PinIcon;

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ModalToggleButtonRedux = function (_React$Component) {
    (0, _inherits3.default)(ModalToggleButtonRedux, _React$Component);

    function ModalToggleButtonRedux() {
        (0, _classCallCheck3.default)(this, ModalToggleButtonRedux);
        return (0, _possibleConstructorReturn3.default)(this, (ModalToggleButtonRedux.__proto__ || (0, _getPrototypeOf2.default)(ModalToggleButtonRedux)).apply(this, arguments));
    }

    (0, _createClass3.default)(ModalToggleButtonRedux, [{
        key: 'show',
        value: function show(e) {
            if (e) {
                e.preventDefault();
            }

            var _props = this.props,
                modalId = _props.modalId,
                dialogProps = _props.dialogProps,
                dialogType = _props.dialogType;


            var modalData = {
                modalId: modalId,
                dialogProps: dialogProps,
                dialogType: dialogType
            };

            this.props.actions.openModal(modalData);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                children = _props2.children,
                onClick = _props2.onClick,
                props = (0, _objectWithoutProperties3.default)(_props2, ['children', 'onClick']);

            // removing these three props since they are not valid props on buttons

            delete props.modalId;
            delete props.dialogType;
            delete props.dialogProps;

            // allow callers to provide an onClick which will be called before the modal is shown
            var clickHandler = function clickHandler() {
                return _this2.show();
            };
            if (onClick) {
                clickHandler = function clickHandler(e) {
                    onClick();

                    _this2.show(e);
                };
            }

            return _react2.default.createElement(
                'button',
                (0, _extends3.default)({}, props, {
                    className: 'style--none ' + props.className,
                    onClick: clickHandler
                }),
                children
            );
        }
    }]);
    return ModalToggleButtonRedux;
}(_react2.default.Component);

ModalToggleButtonRedux.propTypes = {
    children: _propTypes2.default.node.isRequired,
    modalId: _propTypes2.default.string.isRequired,
    dialogType: _propTypes2.default.func.isRequired,
    dialogProps: _propTypes2.default.object,
    onClick: _propTypes2.default.func,
    className: _propTypes2.default.string,
    actions: _propTypes2.default.shape({
        openModal: _propTypes2.default.func.isRequired
    }).isRequired
};
ModalToggleButtonRedux.defaultProps = {
    dialogProps: {},
    className: ''
};
exports.default = ModalToggleButtonRedux;

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkAndSetMobileView = checkAndSetMobileView;

var _utils = __webpack_require__(762);

var _constants = __webpack_require__(29);

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function checkAndSetMobileView() {
    return function (dispatch) {
        dispatch({
            type: _constants.ActionTypes.UPDATE_MOBILE_VIEW,
            data: (0, _utils.isMobile)()
        });
    };
}

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _maxSafeInteger = __webpack_require__(2446);

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _delayed_action = __webpack_require__(931);

var _delayed_action2 = _interopRequireDefault(_delayed_action);

var _event_types = __webpack_require__(1034);

var _event_types2 = _interopRequireDefault(_event_types);

var _global_event_emitter = __webpack_require__(2449);

var _global_event_emitter2 = _interopRequireDefault(_global_event_emitter);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _date_separator = __webpack_require__(1042);

var _date_separator2 = _interopRequireDefault(_date_separator);

var _floating_timestamp = __webpack_require__(1325);

var _floating_timestamp2 = _interopRequireDefault(_floating_timestamp);

var _new_message_indicator = __webpack_require__(2450);

var _new_message_indicator2 = _interopRequireDefault(_new_message_indicator);

var _post = __webpack_require__(2451);

var _post2 = _interopRequireDefault(_post);

var _scroll_to_bottom_arrows = __webpack_require__(2461);

var _scroll_to_bottom_arrows2 = _interopRequireDefault(_scroll_to_bottom_arrows);

var _channel_intro_message = __webpack_require__(2463);

var _channel_intro_message2 = _interopRequireDefault(_channel_intro_message);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLOSE_TO_BOTTOM_SCROLL_MARGIN = 10; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var POSTS_PER_PAGE = _constants2.default.POST_CHUNK_SIZE / 2;

var PostList = function (_React$PureComponent) {
    (0, _inherits3.default)(PostList, _React$PureComponent);

    function PostList(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, PostList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostList.__proto__ || (0, _getPrototypeOf2.default)(PostList)).call(this, props));

        _this.initialScroll = function () {
            if (_this.hasScrolledToNewMessageSeparator) {
                // Already scrolled to new messages indicator
                return false;
            }

            var postList = _this.refs.postlist;
            var posts = _this.props.posts;
            if (!postList || !posts) {
                // Not able to do initial scroll yet
                return false;
            }

            var messageSeparator = _this.refs.newMessageSeparator;
            if (messageSeparator) {
                // Scroll to new message indicator since we have unread posts
                messageSeparator.scrollIntoView();
                if (!_this.checkBottom()) {
                    _this.setUnreadsBelow(posts, _this.props.currentUserId);
                }
                return true;
            }

            // Scroll to bottom since we don't have unread posts
            postList.scrollTop = postList.scrollHeight;
            _this.atBottom = true;
            return true;
        };

        _this.setUnreadsBelow = function (posts, currentUserId) {
            var unViewedCount = posts.reduce(function (count, post) {
                if (post.create_at > _this.state.lastViewed && post.user_id !== currentUserId && post.state !== _constants2.default.POST_DELETED) {
                    return count + 1;
                }
                return count;
            }, 0);
            _this.setState({ unViewedCount: unViewedCount });
        };

        _this.handleScrollStop = function () {
            _this.setState({
                isScrolling: false
            });
        };

        _this.checkBottom = function () {
            if (!_this.refs.postlist) {
                return true;
            }

            // No scroll bar so we're at the bottom
            if (_this.refs.postlist.scrollHeight <= _this.refs.postlist.clientHeight) {
                return true;
            }

            return _this.refs.postlist.clientHeight + _this.refs.postlist.scrollTop >= _this.refs.postlist.scrollHeight - CLOSE_TO_BOTTOM_SCROLL_MARGIN;
        };

        _this.handleWindowResize = function () {
            _this.handleResize();
        };

        _this.handleResize = function (forceScrollToBottom) {
            var postList = _this.refs.postlist;
            var messageSeparator = _this.refs.newMessageSeparator;
            var doScrollToBottom = _this.atBottom || forceScrollToBottom;

            if (postList) {
                if (doScrollToBottom) {
                    postList.scrollTop = postList.scrollHeight;
                } else if (!_this.hasScrolled && messageSeparator) {
                    var element = _reactDom2.default.findDOMNode(messageSeparator);
                    element.scrollIntoView();
                }

                _this.previousScrollHeight = postList.scrollHeight;
                _this.previousScrollTop = postList.scrollTop;
                _this.previousClientHeight = postList.clientHeight;

                _this.atBottom = _this.checkBottom();
            }

            _this.props.actions.checkAndSetMobileView();
        };

        _this.loadPosts = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(channelId, focusedPostId) {
                var posts, getPostThreadAsync, getPostsBeforeAsync, getPostsAfterAsync, result, _result, postsArray;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                posts = void 0;

                                if (!focusedPostId) {
                                    _context.next = 16;
                                    break;
                                }

                                getPostThreadAsync = _this.props.actions.getPostThread(focusedPostId, false);
                                getPostsBeforeAsync = _this.props.actions.getPostsBefore(channelId, focusedPostId, 0, POSTS_PER_PAGE);
                                getPostsAfterAsync = _this.props.actions.getPostsAfter(channelId, focusedPostId, 0, POSTS_PER_PAGE);
                                _context.next = 7;
                                return getPostsBeforeAsync;

                            case 7:
                                result = _context.sent;

                                posts = result.data;
                                _context.next = 11;
                                return getPostsAfterAsync;

                            case 11:
                                _context.next = 13;
                                return getPostThreadAsync;

                            case 13:

                                _this.hasScrolledToFocusedPost = true;
                                _context.next = 22;
                                break;

                            case 16:
                                _context.next = 18;
                                return _this.props.actions.getPosts(channelId, 0, POSTS_PER_PAGE);

                            case 18:
                                _result = _context.sent;

                                posts = _result.data;

                                if (!_this.checkBottom()) {
                                    postsArray = posts.order.map(function (id) {
                                        return posts.posts[id];
                                    });

                                    _this.setUnreadsBelow(postsArray, _this.props.currentUserId);
                                }

                                _this.hasScrolledToNewMessageSeparator = true;

                            case 22:

                                _this.setState({ isDoingInitialLoad: false });
                                if (posts && posts.order.length < POSTS_PER_PAGE) {
                                    _this.setState({ atEnd: true });
                                }

                            case 24:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.loadMorePosts = function (e) {
            if (e) {
                e.preventDefault();
            }

            _this.props.actions.increasePostVisibility(_this.props.channel.id, _this.props.focusedPostId).then(function (moreToLoad) {
                _this.setState({ atEnd: !moreToLoad && _this.props.posts.length < _this.props.postVisibility });
            });
        };

        _this.handleScroll = function () {
            // Only count as user scroll if we've already performed our first load scroll
            _this.hasScrolled = _this.hasScrolledToNewMessageSeparator || _this.hasScrolledToFocusedPost;
            if (!_this.refs.postlist) {
                return;
            }

            _this.previousScrollTop = _this.refs.postlist.scrollTop;

            if (_this.refs.postlist.scrollHeight === _this.previousScrollHeight) {
                _this.atBottom = _this.checkBottom();
            }

            _this.updateFloatingTimestamp();

            if (!_this.state.isScrolling) {
                _this.setState({
                    isScrolling: true
                });
            }

            if (_this.checkBottom()) {
                _this.setState({
                    lastViewed: new Date().getTime(),
                    unViewedCount: 0,
                    isScrolling: false
                });
            }

            _this.scrollStopAction.fireAfter(_constants2.default.SCROLL_DELAY);
        };

        _this.updateFloatingTimestamp = function () {
            // skip this in non-mobile view since that's when the timestamp is visible
            if (!Utils.isMobile()) {
                return;
            }

            if (_this.props.posts) {
                // iterate through posts starting at the bottom since users are more likely to be viewing newer posts
                for (var i = 0; i < _this.props.posts.length; i++) {
                    var post = _this.props.posts[i];
                    var element = _this.refs[post.id];

                    if (!element || !element.domNode || element.domNode.offsetTop + element.domNode.clientHeight <= _this.refs.postlist.scrollTop) {
                        // this post is off the top of the screen so the last one is at the top of the screen
                        var topPost = void 0;

                        if (i > 0) {
                            topPost = _this.props.posts[i - 1];
                        } else {
                            // the first post we look at should always be on the screen, but handle that case anyway
                            topPost = post;
                        }

                        if (!_this.state.topPost || topPost.id !== _this.state.topPost.id) {
                            _this.setState({
                                topPost: topPost
                            });
                        }

                        break;
                    }
                }
            }
        };

        _this.scrollToBottom = function () {
            if (_this.refs.postlist) {
                _this.refs.postlist.scrollTop = _this.refs.postlist.scrollHeight;
            }
        };

        _this.createPosts = function (posts) {
            var postCtls = [];
            var previousPostDay = new Date(0);
            var currentUserId = _this.props.currentUserId;
            var lastViewed = _this.props.lastViewedAt || 0;

            var renderedLastViewed = false;

            for (var i = posts.length - 1; i >= 0; i--) {
                var post = posts[i];

                if (post == null || post.type === _constants.PostTypes.EPHEMERAL_ADD_TO_CHANNEL) {
                    continue;
                }

                var postCtl = _react2.default.createElement(_post2.default, {
                    ref: post.id,
                    key: 'post ' + (post.id || post.pending_post_id),
                    post: post,
                    lastPostCount: i >= 0 && i < _constants2.default.TEST_ID_COUNT ? i : -1,
                    getPostList: _this.getPostList
                });

                var currentPostDay = Utils.getDateForUnixTicks(post.create_at);
                if (currentPostDay.toDateString() !== previousPostDay.toDateString()) {
                    postCtls.push(_react2.default.createElement(_date_separator2.default, {
                        key: currentPostDay,
                        date: currentPostDay
                    }));
                }

                if (post.user_id !== currentUserId && lastViewed !== 0 && post.create_at > lastViewed && !Utils.isPostEphemeral(post) && !renderedLastViewed) {
                    renderedLastViewed = true;

                    // Temporary fix to solve ie11 rendering issue
                    var newSeparatorId = '';
                    if (!UserAgent.isInternetExplorer()) {
                        newSeparatorId = 'new_message_' + post.id;
                    }
                    postCtls.push(_react2.default.createElement(
                        'div',
                        {
                            id: newSeparatorId,
                            key: 'unviewed',
                            ref: 'newMessageSeparator',
                            className: 'new-separator'
                        },
                        _react2.default.createElement('hr', {
                            className: 'separator__hr'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'separator__text' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'posts_view.newMsg',
                                defaultMessage: 'New Messages'
                            })
                        )
                    ));
                }

                postCtls.push(postCtl);
                previousPostDay = currentPostDay;
            }

            return postCtls;
        };

        _this.getPostList = function () {
            return _this.refs.postlist;
        };

        _this.scrollStopAction = new _delayed_action2.default(_this.handleScrollStop);

        _this.previousScrollTop = _maxSafeInteger2.default;
        _this.previousScrollHeight = 0;
        _this.previousClientHeight = 0;
        _this.atBottom = false;

        _this.state = {
            atEnd: false,
            unViewedCount: 0,
            isDoingInitialLoad: true,
            isScrolling: false,
            lastViewed: props.lastViewedAt
        };
        return _this;
    }

    (0, _createClass3.default)(PostList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadPosts(this.props.channel.id, this.props.focusedPostId);
            this.props.actions.checkAndSetMobileView();
            _global_event_emitter2.default.addListener(_event_types2.default.POST_LIST_SCROLL_CHANGE, this.handleResize);

            window.addEventListener('resize', this.handleWindowResize);

            this.initialScroll();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _global_event_emitter2.default.removeListener(_event_types2.default.POST_LIST_SCROLL_CHANGE, this.handleResize);
            window.removeEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Focusing on a new post so load posts around it
            if (nextProps.focusedPostId && this.props.focusedPostId !== nextProps.focusedPostId) {
                this.hasScrolledToFocusedPost = false;
                this.hasScrolledToNewMessageSeparator = false;
                this.setState({ atEnd: false, isDoingInitialLoad: !nextProps.posts });
                this.loadPosts(nextProps.channel.id, nextProps.focusedPostId);
                return;
            }

            var channel = this.props.channel || {};
            var nextChannel = nextProps.channel || {};

            if (nextProps.focusedPostId == null) {
                // Channel changed so load posts for new channel
                if (channel.id !== nextChannel.id) {
                    this.hasScrolled = false;
                    this.hasScrolledToFocusedPost = false;
                    this.hasScrolledToNewMessageSeparator = false;
                    this.atBottom = false;
                    this.setState({ atEnd: false, lastViewed: nextProps.lastViewedAt, isDoingInitialLoad: !nextProps.posts, unViewedCount: 0 });

                    if (nextChannel.id) {
                        this.loadPosts(nextChannel.id);
                    }
                }
            }
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate() {
            if (this.refs.postlist) {
                this.previousScrollTop = this.refs.postlist.scrollTop;
                this.previousScrollHeight = this.refs.postlist.scrollHeight;
                this.previousClientHeight = this.refs.postlist.clientHeight;
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            // Do not update scrolling unless posts, visibility or intro message change
            if (this.props.posts === prevProps.posts && this.props.postVisibility === prevProps.postVisibility && this.state.atEnd === prevState.atEnd) {
                return;
            }

            var prevPosts = prevProps.posts || [];
            var posts = this.props.posts || [];

            if (this.props.focusedPostId == null) {
                var hasNewPosts = prevPosts.length === 0 && posts.length > 0 || prevPosts.length > 0 && posts.length > 0 && prevPosts[0].id !== posts[0].id;

                if (!this.checkBottom() && hasNewPosts) {
                    this.setUnreadsBelow(posts, this.props.currentUserId);
                }
            }

            var postList = this.refs.postlist;
            if (!postList) {
                return;
            }

            // Scroll to focused post on first load
            var focusedPost = this.refs[this.props.focusedPostId];
            if (focusedPost && this.props.posts) {
                if (!this.hasScrolledToFocusedPost) {
                    var element = _reactDom2.default.findDOMNode(focusedPost);
                    var rect = element.getBoundingClientRect();
                    var listHeight = postList.clientHeight / 2;
                    postList.scrollTop += rect.top - listHeight;
                    this.atBottom = this.checkBottom();
                } else if (this.previousScrollHeight !== postList.scrollHeight && posts[0].id === prevPosts[0].id) {
                    postList.scrollTop = this.previousScrollTop + (postList.scrollHeight - this.previousScrollHeight);
                }
                return;
            }

            var didInitialScroll = this.initialScroll();

            if (posts.length >= POSTS_PER_PAGE) {
                this.hasScrolledToNewMessageSeparator = true;
            }

            if (didInitialScroll) {
                return;
            }

            if (postList && prevPosts && posts && posts[0] && prevPosts[0]) {
                // A new message was posted, so scroll to bottom if user
                // was already scrolled close to bottom
                var doScrollToBottom = false;
                var postId = posts[0].id;
                var prevPostId = prevPosts[0].id;
                var pendingPostId = posts[0].pending_post_id;
                if (postId !== prevPostId && pendingPostId !== prevPostId) {
                    // If already scrolled to bottom
                    if (this.atBottom) {
                        doScrollToBottom = true;
                    }

                    // If new post was ephemeral
                    if (Utils.isPostEphemeral(posts[0])) {
                        doScrollToBottom = true;
                    }
                }

                if (doScrollToBottom) {
                    this.atBottom = true;
                    postList.scrollTop = postList.scrollHeight;
                    return;
                }

                // New posts added at the top, maintain scroll position
                if (this.previousScrollHeight !== postList.scrollHeight && posts[0].id === prevPosts[0].id) {
                    postList.scrollTop = this.previousScrollTop + (postList.scrollHeight - this.previousScrollHeight);
                }
            }
        }

        // Scroll to new message indicator or bottom on first load. Returns true
        // if we just scrolled for the initial load.

    }, {
        key: 'render',
        value: function render() {
            var posts = this.props.posts || [];
            var channel = this.props.channel;

            if (posts.length === 0 && this.state.isDoingInitialLoad || channel == null) {
                return _react2.default.createElement(
                    'div',
                    { id: 'post-list' },
                    _react2.default.createElement(_loading_screen2.default, {
                        position: 'absolute',
                        key: 'loading'
                    })
                );
            }

            var topRow = void 0;
            if (this.state.atEnd) {
                topRow = _react2.default.createElement(_channel_intro_message2.default, {
                    channel: channel,
                    fullWidth: this.props.fullWidth
                });
            } else if (this.props.postVisibility >= _constants2.default.MAX_POST_VISIBILITY) {
                topRow = _react2.default.createElement(
                    'div',
                    { className: 'post-list__loading post-list__loading-search' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'posts_view.maxLoaded',
                        defaultMessage: 'Looking for a specific message? Try searching for it'
                    })
                );
            } else if (this.state.isDoingInitialLoad) {
                topRow = _react2.default.createElement(_loading_screen2.default, { style: { height: '0px' } });
            } else {
                topRow = _react2.default.createElement(
                    'button',
                    {
                        ref: 'loadmoretop',
                        className: 'more-messages-text theme style--none color--link',
                        onClick: this.loadMorePosts
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'posts_view.loadMore',
                        defaultMessage: 'Load more messages'
                    })
                );
            }

            var topPostCreateAt = this.state.topPost ? this.state.topPost.create_at : 0;

            var postVisibility = this.props.postVisibility;

            // In focus mode there's an extra (Constants.POST_CHUNK_SIZE / 2) posts to show
            if (this.props.focusedPostId) {
                postVisibility += _constants2.default.POST_CHUNK_SIZE / 2;
            }

            return _react2.default.createElement(
                'div',
                { id: 'post-list' },
                _react2.default.createElement(_floating_timestamp2.default, {
                    isScrolling: this.state.isScrolling,
                    isMobile: Utils.isMobile(),
                    createAt: topPostCreateAt
                }),
                _react2.default.createElement(_scroll_to_bottom_arrows2.default, {
                    isScrolling: this.state.isScrolling,
                    atBottom: this.atBottom,
                    onClick: this.scrollToBottom
                }),
                _react2.default.createElement(_new_message_indicator2.default, {
                    newMessages: this.state.unViewedCount,
                    onClick: this.scrollToBottom
                }),
                _react2.default.createElement(
                    'div',
                    {
                        ref: 'postlist',
                        className: 'post-list-holder-by-time',
                        key: 'postlist-' + channel.id,
                        onScroll: this.handleScroll
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'post-list__table' },
                        _react2.default.createElement(
                            'div',
                            {
                                id: 'postListContent',
                                ref: 'postlistcontent',
                                className: 'post-list__content'
                            },
                            topRow,
                            this.createPosts(posts.slice(0, postVisibility))
                        )
                    )
                )
            );
        }
    }]);
    return PostList;
}(_react2.default.PureComponent);

PostList.propTypes = {

    /**
     * Array of posts in the channel, ordered from oldest to newest
     */
    posts: _propTypes2.default.array,

    /**
     * The number of posts that should be rendered
     */
    postVisibility: _propTypes2.default.number,

    /**
     * The channel the posts are in
     */
    channel: _propTypes2.default.object.isRequired,

    /**
     * The last time the channel was viewed, sets the new message separator
     */
    lastViewedAt: _propTypes2.default.number,

    /**
     * Set if more posts are being loaded
     */
    loadingPosts: _propTypes2.default.bool,

    /**
     * The user id of the logged in user
     */
    currentUserId: _propTypes2.default.string,

    /**
     * Set to focus this post
     */
    focusedPostId: _propTypes2.default.string,

    /**
     * Whether to display the channel intro at full width
     */
    fullWidth: _propTypes2.default.bool,

    actions: _propTypes2.default.shape({

        /**
         * Function to get posts in the channel
         */
        getPosts: _propTypes2.default.func.isRequired,

        /**
         * Function to get posts in the channel older than the focused post
         */
        getPostsBefore: _propTypes2.default.func.isRequired,

        /**
         * Function to get posts in the channel newer than the focused post
         */
        getPostsAfter: _propTypes2.default.func.isRequired,

        /**
         * Function to get the post thread for the focused post
         */
        getPostThread: _propTypes2.default.func.isRequired,

        /**
         * Function to increase the number of posts being rendered
         */
        increasePostVisibility: _propTypes2.default.func.isRequired,

        /**
         * Function to check and set if app is in mobile view
         */
        checkAndSetMobileView: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = PostList;

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2447), __esModule: true };

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2448);
module.exports = 0x1fffffffffffff;


/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(16);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _event_types = __webpack_require__(1034);

var _event_types2 = _interopRequireDefault(_event_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalEventEmitterClass = function (_EventEmitter) {
    (0, _inherits3.default)(GlobalEventEmitterClass, _EventEmitter);

    function GlobalEventEmitterClass() {
        (0, _classCallCheck3.default)(this, GlobalEventEmitterClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GlobalEventEmitterClass.__proto__ || (0, _getPrototypeOf2.default)(GlobalEventEmitterClass)).call(this));

        _this.handleEventPayload = function (payload) {
            var _payload$action = payload.action,
                type = _payload$action.type,
                value = _payload$action.value,
                args = (0, _objectWithoutProperties3.default)(_payload$action, ['type', 'value']); //eslint-disable-line no-use-before-define

            switch (type) {
                case _event_types2.default.POST_LIST_SCROLL_CHANGE:
                    _this.emit(type, value, args);
                    break;
            }
        };

        _this.dispatchToken = _app_dispatcher2.default.register(_this.handleEventPayload);
        return _this;
    }

    return GlobalEventEmitterClass;
}(_events2.default); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var GlobalEventEmitter = new GlobalEventEmitterClass();
exports.default = GlobalEventEmitter;

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _unread_below_icon = __webpack_require__(1409);

var _unread_below_icon2 = _interopRequireDefault(_unread_below_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var NewMessageIndicator = function (_React$PureComponent) {
    (0, _inherits3.default)(NewMessageIndicator, _React$PureComponent);

    function NewMessageIndicator(props) {
        (0, _classCallCheck3.default)(this, NewMessageIndicator);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NewMessageIndicator.__proto__ || (0, _getPrototypeOf2.default)(NewMessageIndicator)).call(this, props));

        _this.state = {
            visible: false,
            rendered: false
        };
        return _this;
    }

    (0, _createClass3.default)(NewMessageIndicator, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.newMessages > 0) {
                this.setState({ rendered: true }, function () {
                    _this2.setState({ visible: true });
                });
            } else {
                this.setState({ visible: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var className = 'new-messages__button';
            if (this.state.visible) {
                className += ' visible';
            }
            if (!this.state.rendered) {
                className += ' disabled';
            }
            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onTransitionEnd: this.setRendered.bind(this),
                    ref: 'indicator'
                },
                _react2.default.createElement(
                    'div',
                    { onClick: this.props.onClick },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'posts_view.newMsgBelow',
                        defaultMessage: 'New {count, plural, one {message} other {messages}}',
                        values: { count: this.props.newMessages }
                    }),
                    _react2.default.createElement(_unread_below_icon2.default, { className: 'icon icon__unread' })
                )
            );
        }

        // Sync 'rendered' state with visibility param, only after transitions
        // have ended

    }, {
        key: 'setRendered',
        value: function setRendered() {
            this.setState({ rendered: this.state.visible });
        }
    }]);
    return NewMessageIndicator;
}(_react2.default.PureComponent);

NewMessageIndicator.propTypes = {
    onClick: _propTypes2.default.func.isRequired,
    newMessages: _propTypes2.default.number
};
NewMessageIndicator.defaultProps = {
    newMessages: 0
};
exports.default = NewMessageIndicator;

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _posts = __webpack_require__(805);

var _preferences = __webpack_require__(784);

var _users = __webpack_require__(777);

var _constants = __webpack_require__(29);

var _post = __webpack_require__(2452);

var _post2 = _interopRequireDefault(_post);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var detailedPost = ownProps.post || {};

    return {
        post: (0, _posts.getPost)(state, detailedPost.id),
        lastPostCount: ownProps.lastPostCount,
        user: (0, _users.getUser)(state, detailedPost.user_id),
        status: (0, _users.getStatusForUserId)(state, detailedPost.user_id),
        currentUser: (0, _users.getCurrentUser)(state),
        isFirstReply: Boolean(detailedPost.isFirstReply && detailedPost.commentedOnPost),
        highlight: detailedPost.highlight,
        consecutivePostByUser: detailedPost.consecutivePostByUser,
        previousPostIsComment: detailedPost.previousPostIsComment,
        replyCount: detailedPost.replyCount,
        isCommentMention: detailedPost.isCommentMention,
        center: (0, _preferences.get)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.CHANNEL_DISPLAY_MODE, _constants.Preferences.CHANNEL_DISPLAY_MODE_DEFAULT) === _constants.Preferences.CHANNEL_DISPLAY_MODE_CENTERED,
        compactDisplay: (0, _preferences.get)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.MESSAGE_DISPLAY, _constants.Preferences.MESSAGE_DISPLAY_DEFAULT) === _constants.Preferences.MESSAGE_DISPLAY_COMPACT
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_post2.default);

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(19);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants2 = __webpack_require__(29);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _post_body = __webpack_require__(2453);

var _post_body2 = _interopRequireDefault(_post_body);

var _post_header = __webpack_require__(2457);

var _post_header2 = _interopRequireDefault(_post_header);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

var _mattermost_logo = __webpack_require__(976);

var _mattermost_logo2 = _interopRequireDefault(_mattermost_logo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Post = function (_React$PureComponent) {
    (0, _inherits3.default)(Post, _React$PureComponent);

    function Post(props) {
        (0, _classCallCheck3.default)(this, Post);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Post.__proto__ || (0, _getPrototypeOf2.default)(Post)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            dropdownOpened: false,
            hover: false,
            sameRoot: _this.hasSameRoot(props)
        };
        return _this;
    }

    (0, _createClass3.default)(Post, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ sameRoot: this.hasSameRoot(nextProps) });
        }
    }, {
        key: 'render',
        value: function render() {
            var post = this.props.post || {};

            var isSystemMessage = PostUtils.isSystemMessage(post);
            var fromWebhook = post && post.props && post.props.from_webhook === 'true';

            var status = this.props.status;
            if (fromWebhook) {
                status = null;
            }

            var profilePic = void 0;
            var hideProfilePicture = this.state.sameRoot && this.props.consecutivePostByUser && !post.root_id && this.props.replyCount === 0;
            if (!hideProfilePicture) {
                profilePic = _react2.default.createElement(_profile_picture2.default, {
                    src: PostUtils.getProfilePicSrcForPost(post, this.props.user),
                    status: status,
                    user: this.props.user,
                    isBusy: this.props.isBusy,
                    hasMention: true
                });

                if (fromWebhook) {
                    profilePic = _react2.default.createElement(_profile_picture2.default, {
                        src: PostUtils.getProfilePicSrcForPost(post, this.props.user)
                    });
                } else if (PostUtils.isSystemMessage(post)) {
                    profilePic = _react2.default.createElement(_mattermost_logo2.default, { className: 'icon' });
                }

                if (this.props.compactDisplay) {
                    if (fromWebhook) {
                        profilePic = _react2.default.createElement(_profile_picture2.default, {
                            src: '',
                            status: status,
                            isBusy: this.props.isBusy,
                            user: this.props.user
                        });
                    } else {
                        profilePic = _react2.default.createElement(_profile_picture2.default, {
                            src: '',
                            status: status
                        });
                    }
                }
            }

            var profilePicContainer = _react2.default.createElement(
                'div',
                { className: 'post__img' },
                profilePic
            );

            var centerClass = '';
            if (this.props.center) {
                centerClass = 'center';
            }

            return _react2.default.createElement(
                'div',
                {
                    ref: this.getRef,
                    onMouseOver: this.setHover,
                    onMouseLeave: this.unsetHover
                },
                _react2.default.createElement(
                    'div',
                    {
                        id: 'post_' + post.id,
                        className: this.getClassName(post, isSystemMessage, fromWebhook)
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'post__content ' + centerClass },
                        profilePicContainer,
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_post_header2.default, {
                                post: post,
                                handleCommentClick: this.handleCommentClick,
                                handleDropdownOpened: this.handleDropdownOpened,
                                user: this.props.user,
                                currentUser: this.props.currentUser,
                                compactDisplay: this.props.compactDisplay,
                                status: this.props.status,
                                isBusy: this.props.isBusy,
                                lastPostCount: this.props.lastPostCount,
                                isFirstReply: this.props.isFirstReply,
                                replyCount: this.props.replyCount,
                                showTimeWithoutHover: !hideProfilePicture,
                                getPostList: this.props.getPostList,
                                hover: this.state.hover
                            }),
                            _react2.default.createElement(_post_body2.default, {
                                post: post,
                                handleCommentClick: this.handleCommentClick,
                                compactDisplay: this.props.compactDisplay,
                                lastPostCount: this.props.lastPostCount,
                                isCommentMention: this.props.isCommentMention,
                                isFirstReply: this.props.isFirstReply
                            })
                        )
                    )
                )
            );
        }
    }]);
    return Post;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

Post.propTypes = {

    /**
     * The post to render
     */
    post: _propTypes2.default.object.isRequired,

    /**
     * The user who created the post
     */
    user: _propTypes2.default.object,

    /**
     * The status of the poster
     */
    status: _propTypes2.default.string,

    /**
     * The logged in user
     */
    currentUser: _propTypes2.default.object.isRequired,

    /**
     * Set to center the post
     */
    center: _propTypes2.default.bool,

    /**
     * Set to render post compactly
     */
    compactDisplay: _propTypes2.default.bool,

    /**
     * Set to render a preview of the parent post above this reply
     */
    isFirstReply: _propTypes2.default.bool,

    /**
     * Set to highlight the background of the post
     */
    highlight: _propTypes2.default.bool,

    /**
     * Set to render this post as if it was attached to the previous post
     */
    consecutivePostByUser: _propTypes2.default.bool,

    /**
     * Set if the previous post is a comment
     */
    previousPostIsComment: _propTypes2.default.bool,

    /**
     * Set to render this comment as a mention
     */
    isCommentMention: _propTypes2.default.bool,

    /**
     * The number of replies in the same thread as this post
     */
    replyCount: _propTypes2.default.number,

    /**
     * Set to mark the poster as in a webrtc call
     */
    isBusy: _propTypes2.default.bool,

    /**
     * The post count used for selenium tests
     */
    lastPostCount: _propTypes2.default.number,

    /**
     * Function to get the post list HTML element
     */
    getPostList: _propTypes2.default.func.isRequired
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleCommentClick = function (e) {
        e.preventDefault();

        var post = _this2.props.post;
        if (!post) {
            return;
        }

        _app_dispatcher2.default.handleServerAction({
            type: _constants2.ActionTypes.RECEIVED_POST_SELECTED,
            postId: Utils.getRootId(post),
            channelId: post.channel_id
        });
    };

    this.handleDropdownOpened = function (opened) {
        _this2.setState({
            dropdownOpened: opened
        });
    };

    this.hasSameRoot = function (props) {
        var post = props.post;

        if (props.isFirstReply) {
            return false;
        } else if (!post.root_id && !props.previousPostIsComment && props.consecutivePostByUser) {
            return true;
        } else if (post.root_id) {
            return true;
        }

        return false;
    };

    this.getClassName = function (post, isSystemMessage, fromWebhook) {
        var className = 'post';

        if (post.failed || post.state === _constants.Posts.POST_DELETED) {
            className += ' post--hide-controls';
        }

        if (_this2.props.highlight) {
            className += ' post--highlight';
        }

        var rootUser = '';
        if (_this2.state.sameRoot) {
            rootUser = 'same--root';
        } else {
            rootUser = 'other--root';
        }

        var currentUserCss = '';
        if (_this2.props.currentUser.id === post.user_id && !fromWebhook && !isSystemMessage) {
            currentUserCss = 'current--user';
        }

        var sameUserClass = '';
        if (_this2.props.consecutivePostByUser) {
            sameUserClass = 'same--user';
        }

        var postType = '';
        if (post.root_id && post.root_id.length > 0) {
            postType = 'post--comment';
        } else if (_this2.props.replyCount > 0) {
            postType = 'post--root';
            sameUserClass = '';
            rootUser = '';
        }

        if (isSystemMessage) {
            className += ' post--system';
            sameUserClass = '';
            currentUserCss = '';
            postType = '';
            rootUser = '';
        }

        if (_this2.props.compactDisplay) {
            className += ' post--compact';
        }

        if (_this2.state.dropdownOpened) {
            className += ' post--hovered';
        }

        if (post.is_pinned) {
            className += ' post--pinned';
        }

        return className + ' ' + sameUserClass + ' ' + rootUser + ' ' + postType + ' ' + currentUserCss;
    };

    this.getRef = function (node) {
        _this2.domNode = node;
    };

    this.setHover = function () {
        _this2.setState({ hover: true });
    };

    this.unsetHover = function () {
        _this2.setState({ hover: false });
    };
};

exports.default = Post;

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _posts = __webpack_require__(805);

var _channels = __webpack_require__(783);

var _preferences = __webpack_require__(784);

var _users = __webpack_require__(777);

var _general = __webpack_require__(113);

var _storage = __webpack_require__(957);

var _constants = __webpack_require__(29);

var _post_body = __webpack_require__(2454);

var _post_body2 = _interopRequireDefault(_post_body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var parentPost = void 0;
    var parentPostUser = void 0;
    var previewCollapsed = (0, _preferences.get)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.COLLAPSE_DISPLAY, _constants.Preferences.COLLAPSE_DISPLAY_DEFAULT);
    var isEmbedVisible = (0, _storage.makeGetGlobalItem)(_constants.StoragePrefixes.EMBED_VISIBLE + ownProps.post.id, previewCollapsed.startsWith('false'))(state);
    if (ownProps.post.root_id) {
        parentPost = (0, _posts.getPost)(state, ownProps.post.root_id);
        parentPostUser = parentPost ? (0, _users.getUser)(state, parentPost.user_id) : null;
    }

    var config = (0, _general.getConfig)(state);
    var enablePostUsernameOverride = config.EnablePostUsernameOverride === 'true';

    return {
        parentPost: parentPost,
        parentPostUser: parentPostUser,
        pluginPostTypes: state.plugins.postTypes,
        previewCollapsed: previewCollapsed,
        previewEnabled: (0, _preferences.getBool)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.LINK_PREVIEW_DISPLAY, true),
        isEmbedVisible: isEmbedVisible,
        enablePostUsernameOverride: enablePostUsernameOverride,
        isReadOnly: (0, _channels.isCurrentChannelReadOnly)(state)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_post_body2.default);

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _post_actions = __webpack_require__(802);

var PostActions = _interopRequireWildcard(_post_actions);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _delayed_action = __webpack_require__(931);

var _delayed_action2 = _interopRequireDefault(_delayed_action);

var _file_attachment_list = __webpack_require__(971);

var _file_attachment_list2 = _interopRequireDefault(_file_attachment_list);

var _commented_on_files_message = __webpack_require__(2455);

var _commented_on_files_message2 = _interopRequireDefault(_commented_on_files_message);

var _failed_post_options = __webpack_require__(1327);

var _failed_post_options2 = _interopRequireDefault(_failed_post_options);

var _post_body_additional_content = __webpack_require__(1045);

var _post_body_additional_content2 = _interopRequireDefault(_post_body_additional_content);

var _post_message_view = __webpack_require__(1046);

var _post_message_view2 = _interopRequireDefault(_post_message_view);

var _reaction_list = __webpack_require__(1044);

var _reaction_list2 = _interopRequireDefault(_reaction_list);

var _load = __webpack_require__(865);

var _load2 = _interopRequireDefault(_load);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SENDING_ANIMATION_DELAY = 3000; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PostBody = function (_React$PureComponent) {
    (0, _inherits3.default)(PostBody, _React$PureComponent);

    function PostBody(props) {
        (0, _classCallCheck3.default)(this, PostBody);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostBody.__proto__ || (0, _getPrototypeOf2.default)(PostBody)).call(this, props));

        _this.sendingAction = new _delayed_action2.default(function () {
            var post = _this.props.post;
            if (post && post.id === post.pending_post_id) {
                _this.setState({ sending: true });
            }
        });

        _this.state = { sending: false };
        return _this;
    }

    (0, _createClass3.default)(PostBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var post = this.props.post;
            if (post && post.id === post.pending_post_id) {
                this.sendingAction.fireAfter(SENDING_ANIMATION_DELAY);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.sendingAction.cancel();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var post = nextProps.post;
            if (post && post.id !== post.pending_post_id) {
                this.sendingAction.cancel();
                this.setState({ sending: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var post = this.props.post;
            var parentPost = this.props.parentPost;

            var comment = '';
            var postClass = '';
            var isEphemeral = Utils.isPostEphemeral(post);
            if (this.props.isFirstReply && parentPost && !isEphemeral) {
                var profile = this.props.parentPostUser;

                var apostrophe = '';
                var name = '...';
                if (profile != null) {
                    var username = Utils.getDisplayNameByUser(profile);
                    if (parentPost.props && parentPost.props.from_webhook && parentPost.props.override_username && this.props.enablePostUsernameOverride) {
                        username = parentPost.props.override_username;
                    }

                    if (username.slice(-1) === 's') {
                        apostrophe = '\'';
                    } else {
                        apostrophe = '\'s';
                    }
                    name = _react2.default.createElement(
                        'a',
                        {
                            className: 'theme',
                            onClick: PostActions.searchForTerm.bind(null, username)
                        },
                        username
                    );
                }

                var message = '';
                if (parentPost.message) {
                    message = Utils.replaceHtmlEntities(parentPost.message);
                } else if (parentPost.file_ids && parentPost.file_ids.length > 0) {
                    message = _react2.default.createElement(_commented_on_files_message2.default, {
                        parentPostId: parentPost.id
                    });
                }

                comment = _react2.default.createElement(
                    'div',
                    { className: 'post__link' },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'post_body.commentedOn',
                            defaultMessage: 'Commented on {name}{apostrophe} message: ',
                            values: {
                                name: name,
                                apostrophe: apostrophe
                            }
                        }),
                        _react2.default.createElement(
                            'a',
                            {
                                className: 'theme',
                                onClick: this.props.handleCommentClick
                            },
                            message
                        )
                    )
                );
            }

            var failedOptions = void 0;
            if (this.props.post.failed) {
                postClass += ' post--fail';
                failedOptions = _react2.default.createElement(_failed_post_options2.default, { post: this.props.post });
            }

            if (PostUtils.isEdited(this.props.post)) {
                postClass += ' post--edited';
            }

            var fileAttachmentHolder = null;
            if ((post.file_ids && post.file_ids.length > 0 || post.filenames && post.filenames.length > 0) && this.props.post.state !== _constants.Posts.POST_DELETED) {
                fileAttachmentHolder = _react2.default.createElement(_file_attachment_list2.default, {
                    post: post,
                    compactDisplay: this.props.compactDisplay
                });
            }

            var sending = void 0;
            if (this.state.sending) {
                sending = _react2.default.createElement('img', {
                    className: 'post-loading-gif pull-right',
                    src: _load2.default
                });

                postClass += ' post-waiting';
            }

            var messageWrapper = _react2.default.createElement(
                'div',
                {
                    key: post.id + '_message',
                    id: post.id + '_message',
                    className: postClass
                },
                failedOptions,
                sending,
                _react2.default.createElement(_post_message_view2.default, {
                    lastPostCount: this.props.lastPostCount,
                    post: this.props.post,
                    compactDisplay: this.props.compactDisplay,
                    hasMention: true
                })
            );

            var hasPlugin = post.type && this.props.pluginPostTypes.hasOwnProperty(post.type);

            var messageWithAdditionalContent = void 0;
            if (this.props.post.state === _constants.Posts.POST_DELETED || hasPlugin) {
                messageWithAdditionalContent = messageWrapper;
            } else {
                messageWithAdditionalContent = _react2.default.createElement(
                    _post_body_additional_content2.default,
                    {
                        post: this.props.post,
                        previewCollapsed: this.props.previewCollapsed,
                        previewEnabled: this.props.previewEnabled,
                        isEmbedVisible: this.props.isEmbedVisible
                    },
                    messageWrapper
                );
            }

            var mentionHighlightClass = '';
            if (this.props.isCommentMention) {
                mentionHighlightClass = 'mention-comment';
            }

            var ephemeralPostClass = '';
            if (isEphemeral) {
                ephemeralPostClass = 'post--ephemeral';
            }

            return _react2.default.createElement(
                'div',
                null,
                comment,
                _react2.default.createElement(
                    'div',
                    { className: 'post__body ' + mentionHighlightClass + ' ' + ephemeralPostClass },
                    messageWithAdditionalContent,
                    fileAttachmentHolder,
                    _react2.default.createElement(_reaction_list2.default, {
                        post: post,
                        isReadOnly: this.props.isReadOnly
                    })
                )
            );
        }
    }]);
    return PostBody;
}(_react2.default.PureComponent);

PostBody.propTypes = {

    /**
     * The post to render the body of
     */
    post: _propTypes2.default.object.isRequired,

    /**
     * The parent post of the thread this post is in
     */
    parentPost: _propTypes2.default.object,

    /**
     * The poster of the parent post, if exists
     */
    parentPostUser: _propTypes2.default.object,

    /**
     * The function called when the comment icon is clicked
     */
    handleCommentClick: _propTypes2.default.func.isRequired,

    /**
     * Set to render post body compactly
     */
    compactDisplay: _propTypes2.default.bool,

    /**
     * Set to highlight comment as a mention
     */
    isCommentMention: _propTypes2.default.bool,

    /**
     * Set to render a preview of the parent post above this reply
     */
    isFirstReply: _propTypes2.default.bool,

    /**
     * Set to collapse image and video previews
     */
    previewCollapsed: _propTypes2.default.string,

    /**
     * User's preference to link previews
     */
    previewEnabled: _propTypes2.default.bool,

    /**
     * Post identifiers for selenium tests
     */
    lastPostCount: _propTypes2.default.number,

    /*
     * Post type components from plugins
     */
    pluginPostTypes: _propTypes2.default.object,

    /**
     * Flag passed down to PostBodyAdditionalContent for determining if post embed is visible
     */
    isEmbedVisible: _propTypes2.default.bool,

    /**
     * Whether or not the post username can be overridden.
     */
    enablePostUsernameOverride: _propTypes2.default.bool.isRequired,

    /**
     * Set not to allow edits on post
     */
    isReadOnly: _propTypes2.default.bool
};
PostBody.defaultProps = {
    isReadOnly: false
};
exports.default = PostBody;

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _files = __webpack_require__(1040);

var _files2 = __webpack_require__(1041);

var _commented_on_files_message = __webpack_require__(2456);

var _commented_on_files_message2 = _interopRequireDefault(_commented_on_files_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeMapStateToProps() {
    var selectFileInfosForPost = (0, _files2.makeGetFilesForPost)();

    return function mapStateToProps(state, ownProps) {
        var fileInfos = void 0;
        if (ownProps.parentPostId) {
            fileInfos = selectFileInfosForPost(state, ownProps.parentPostId);
        }

        return (0, _extends3.default)({}, ownProps, {
            fileInfos: fileInfos
        });
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getFilesForPost: _files.getFilesForPost
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_commented_on_files_message2.default);

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentedOnFilesMessage = function (_React$PureComponent) {
    (0, _inherits3.default)(CommentedOnFilesMessage, _React$PureComponent);

    function CommentedOnFilesMessage() {
        (0, _classCallCheck3.default)(this, CommentedOnFilesMessage);
        return (0, _possibleConstructorReturn3.default)(this, (CommentedOnFilesMessage.__proto__ || (0, _getPrototypeOf2.default)(CommentedOnFilesMessage)).apply(this, arguments));
    }

    (0, _createClass3.default)(CommentedOnFilesMessage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.fileInfos || this.props.fileInfos.length === 0) {
                this.props.actions.getFilesForPost(this.props.parentPostId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.fileInfos || this.props.fileInfos.length === 0) {
                return null;
            }

            var plusMore = null;
            if (this.props.fileInfos.length > 1) {
                plusMore = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'post_body.plusMore',
                    defaultMessage: ' plus {count, number} other {count, plural, one {file} other {files}}',
                    values: {
                        count: this.props.fileInfos.length - 1
                    }
                });
            }

            return _react2.default.createElement(
                'span',
                null,
                this.props.fileInfos[0].name,
                plusMore
            );
        }
    }]);
    return CommentedOnFilesMessage;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

CommentedOnFilesMessage.propTypes = {

    /*
     * The id of the post that was commented on
     */
    parentPostId: _propTypes2.default.string.isRequired,

    /*
     * An array of file metadata for the parent post
     */
    fileInfos: _propTypes2.default.arrayOf(_propTypes2.default.object),

    actions: _propTypes2.default.shape({

        /*
         * Function to get file metadata for a post
         */
        getFilesForPost: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = CommentedOnFilesMessage;

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _constants = __webpack_require__(19);

var _preferences = __webpack_require__(784);

var _general = __webpack_require__(113);

var _post_header = __webpack_require__(2458);

var _post_header2 = _interopRequireDefault(_post_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var enablePostUsernameOverride = config.EnablePostUsernameOverride === 'true';

    return {
        displayNameType: (0, _preferences.get)(state, _constants.Preferences.CATEGORY_DISPLAY_SETTINGS, 'name_format', 'false'),
        enablePostUsernameOverride: enablePostUsernameOverride
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_post_header2.default);

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

var _post_info = __webpack_require__(2459);

var _post_info2 = _interopRequireDefault(_post_info);

var _user_profile = __webpack_require__(933);

var _user_profile2 = _interopRequireDefault(_user_profile);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostHeader = function (_React$PureComponent) {
    (0, _inherits3.default)(PostHeader, _React$PureComponent);

    function PostHeader() {
        (0, _classCallCheck3.default)(this, PostHeader);
        return (0, _possibleConstructorReturn3.default)(this, (PostHeader.__proto__ || (0, _getPrototypeOf2.default)(PostHeader)).apply(this, arguments));
    }

    (0, _createClass3.default)(PostHeader, [{
        key: 'render',
        value: function render() {
            var post = this.props.post;
            var isSystemMessage = PostUtils.isSystemMessage(post);

            var userProfile = _react2.default.createElement(_user_profile2.default, {
                user: this.props.user,
                displayNameType: this.props.displayNameType,
                status: this.props.status,
                isBusy: this.props.isBusy,
                hasMention: true
            });
            var botIndicator = void 0;
            var colon = void 0;

            if (post.props && post.props.from_webhook) {
                if (post.props.override_username && this.props.enablePostUsernameOverride) {
                    userProfile = _react2.default.createElement(_user_profile2.default, {
                        user: this.props.user,
                        overwriteName: post.props.override_username,
                        disablePopover: true
                    });
                } else {
                    userProfile = _react2.default.createElement(_user_profile2.default, {
                        user: this.props.user,
                        displayNameType: this.props.displayNameType,
                        disablePopover: true
                    });
                }

                botIndicator = _react2.default.createElement(
                    'div',
                    { className: 'bot-indicator' },
                    _constants2.default.BOT_NAME
                );
            } else if (isSystemMessage) {
                userProfile = _react2.default.createElement(_user_profile2.default, {
                    user: {},
                    overwriteName: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_info.system',
                        defaultMessage: 'System'
                    }),
                    overwriteImage: _constants2.default.SYSTEM_MESSAGE_PROFILE_IMAGE,
                    disablePopover: true
                });
            }

            if (this.props.compactDisplay) {
                colon = _react2.default.createElement(
                    'strong',
                    { className: 'colon' },
                    ':'
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'post__header' },
                _react2.default.createElement(
                    'div',
                    { className: 'col col__name' },
                    userProfile,
                    colon
                ),
                botIndicator,
                _react2.default.createElement(
                    'div',
                    { className: 'col' },
                    _react2.default.createElement(_post_info2.default, {
                        post: post,
                        handleCommentClick: this.props.handleCommentClick,
                        handleDropdownOpened: this.props.handleDropdownOpened,
                        compactDisplay: this.props.compactDisplay,
                        lastPostCount: this.props.lastPostCount,
                        replyCount: this.props.replyCount,
                        isFirstReply: this.props.isFirstReply,
                        showTimeWithoutHover: this.props.showTimeWithoutHover,
                        getPostList: this.props.getPostList,
                        hover: this.props.hover
                    })
                )
            );
        }
    }]);
    return PostHeader;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PostHeader.propTypes = {

    /*
     * The post to render the header for
     */
    post: _propTypes2.default.object.isRequired,

    /*
     * The user who created the post
     */
    user: _propTypes2.default.object,

    /*
     * Function called when the comment icon is clicked
     */
    handleCommentClick: _propTypes2.default.func.isRequired,

    /*
     * Function called when the post options dropdown is opened
     */
    handleDropdownOpened: _propTypes2.default.func.isRequired,

    /*
     * Set to render compactly
     */
    compactDisplay: _propTypes2.default.bool,

    /*
     * The method for displaying the post creator's name
     */
    displayNameType: _propTypes2.default.string,

    /*
     * The status of the user who created the post
     */
    status: _propTypes2.default.string,

    /*
     * Set if the post creator is currenlty in a WebRTC call
     */
    isBusy: _propTypes2.default.bool,

    /*
     * The number of replies in the same thread as this post
     */
    replyCount: _propTypes2.default.number,

    /**
     * Set to indicate that this is previous post was not a reply to the same thread
     */
    isFirstReply: _propTypes2.default.bool,

    /*
     * Post identifiers for selenium tests
     */
    lastPostCount: _propTypes2.default.number,

    /**
     * Function to get the post list HTML element
     */
    getPostList: _propTypes2.default.func.isRequired,

    /**
     * Set to mark post as being hovered over
     */
    hover: _propTypes2.default.bool.isRequired,

    /*
     * Set to render the post time when not hovering
     */
    showTimeWithoutHover: _propTypes2.default.bool,

    /**
     * Whether or not the post username can be overridden.
     */
    enablePostUsernameOverride: _propTypes2.default.bool.isRequired
};
exports.default = PostHeader;

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _posts = __webpack_require__(808);

var _channels = __webpack_require__(783);

var _teams = __webpack_require__(274);

var _preferences = __webpack_require__(784);

var _general = __webpack_require__(113);

var _constants = __webpack_require__(29);

var _post_info = __webpack_require__(2460);

var _post_info2 = _interopRequireDefault(_post_info);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var config = (0, _general.getConfig)(state);
    var enableEmojiPicker = config.EnableEmojiPicker === 'true';
    var teamId = (0, _teams.getCurrentTeamId)(state);

    return {
        teamId: teamId,
        isFlagged: (0, _preferences.get)(state, _constants.Preferences.CATEGORY_FLAGGED_POST, ownProps.post.id, null) != null,
        isMobile: state.views.channel.mobileView,
        enableEmojiPicker: enableEmojiPicker,
        isReadOnly: (0, _channels.isCurrentChannelReadOnly)(state)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            removePost: _posts.removePost,
            addReaction: _posts.addReaction
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_post_info2.default);

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _post_utils = __webpack_require__(281);

var ReduxPostUtils = _interopRequireWildcard(_post_utils);

var _permissions = __webpack_require__(279);

var _permissions2 = _interopRequireDefault(_permissions);

var _post_actions = __webpack_require__(802);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _post_utils2 = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils2);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _comment_icon = __webpack_require__(1331);

var _comment_icon2 = _interopRequireDefault(_comment_icon);

var _dot_menu = __webpack_require__(970);

var _dot_menu2 = _interopRequireDefault(_dot_menu);

var _emoji_picker_overlay = __webpack_require__(883);

var _emoji_picker_overlay2 = _interopRequireDefault(_emoji_picker_overlay);

var _post_flag_icon = __webpack_require__(973);

var _post_flag_icon2 = _interopRequireDefault(_post_flag_icon);

var _post_time = __webpack_require__(975);

var _post_time2 = _interopRequireDefault(_post_time);

var _emoji_icon = __webpack_require__(909);

var _emoji_icon2 = _interopRequireDefault(_emoji_icon);

var _channel_permission_gate = __webpack_require__(888);

var _channel_permission_gate2 = _interopRequireDefault(_channel_permission_gate);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostInfo = function (_React$PureComponent) {
    (0, _inherits3.default)(PostInfo, _React$PureComponent);

    function PostInfo(props) {
        (0, _classCallCheck3.default)(this, PostInfo);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostInfo.__proto__ || (0, _getPrototypeOf2.default)(PostInfo)).call(this, props));

        _this.toggleEmojiPicker = function () {
            var showEmojiPicker = !_this.state.showEmojiPicker;

            _this.setState({ showEmojiPicker: showEmojiPicker });
            _this.props.handleDropdownOpened(showEmojiPicker);
        };

        _this.hideEmojiPicker = function () {
            _this.setState({ showEmojiPicker: false });
            _this.props.handleDropdownOpened(false);
        };

        _this.removePost = function () {
            _this.props.actions.removePost(_this.props.post);
        };

        _this.createRemovePostButton = function () {
            return _react2.default.createElement(
                'button',
                {
                    className: 'post__remove theme color--link style--none',
                    type: 'button',
                    onClick: _this.removePost
                },
                '×'
            );
        };

        _this.reactEmojiClick = function (emoji) {
            var pickerOffset = 21;
            _this.setState({ showEmojiPicker: false, reactionPickerOffset: pickerOffset });
            var emojiName = emoji.name || emoji.aliases[0];
            _this.props.actions.addReaction(_this.props.post.id, emojiName);
            (0, _post_actions.emitEmojiPosted)(emojiName);
            _this.props.handleDropdownOpened(false);
        };

        _this.handleDotMenuOpened = function (open) {
            _this.setState({ showDotMenu: open });
            _this.props.handleDropdownOpened(open);
        };

        _this.getDotMenu = function () {
            return _this.refs.dotMenu;
        };

        _this.buildOptions = function (post, isSystemMessage, idCount) {
            if (!PostUtils.shouldShowDotMenu(post)) {
                return null;
            }

            var _this$props = _this.props,
                isMobile = _this$props.isMobile,
                isReadOnly = _this$props.isReadOnly;

            var hover = _this.props.hover || _this.state.showEmojiPicker || _this.state.showDotMenu;

            var comments = void 0;
            var react = void 0;

            if (!isSystemMessage) {
                if (isMobile || hover || !post.root_id && _this.props.replyCount || _this.props.isFirstReply) {
                    var extraClass = isMobile ? '' : 'pull-right';
                    comments = _react2.default.createElement(_comment_icon2.default, {
                        idPrefix: 'commentIcon',
                        idCount: idCount,
                        handleCommentClick: _this.props.handleCommentClick,
                        commentCount: _this.props.replyCount,
                        id: post.channel_id + '_' + post.id,
                        extraClass: extraClass
                    });
                }

                if (hover && !isReadOnly && _this.props.enableEmojiPicker) {
                    react = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_emoji_picker_overlay2.default, {
                            show: _this.state.showEmojiPicker,
                            container: _this.props.getPostList,
                            target: _this.getDotMenu,
                            onHide: _this.hideEmojiPicker,
                            onEmojiClick: _this.reactEmojiClick,
                            rightOffset: 7
                        }),
                        _react2.default.createElement(
                            _channel_permission_gate2.default,
                            {
                                channelId: post.channel_id,
                                teamId: _this.props.teamId,
                                permissions: [_permissions2.default.ADD_REACTION]
                            },
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'reacticon__container color--link style--none',
                                    onClick: _this.toggleEmojiPicker
                                },
                                _react2.default.createElement(_emoji_icon2.default, { className: 'icon icon--emoji' })
                            )
                        )
                    );
                }
            }

            var dotMenu = void 0;
            if (isMobile || hover) {
                dotMenu = _react2.default.createElement(_dot_menu2.default, {
                    idPrefix: _constants3.default.CENTER,
                    idCount: idCount,
                    post: post,
                    commentCount: _this.props.replyCount,
                    isFlagged: _this.props.isFlagged,
                    handleCommentClick: _this.props.handleCommentClick,
                    handleDropdownOpened: _this.handleDotMenuOpened,
                    isReadOnly: isReadOnly
                });
            }

            return _react2.default.createElement(
                'div',
                {
                    ref: 'dotMenu',
                    className: 'col col__reply' + (isReadOnly ? ' dot_small' : '')
                },
                dotMenu,
                react,
                comments
            );
        };

        _this.state = {
            showEmojiPicker: false,
            reactionPickerOffset: 21
        };
        return _this;
    }

    (0, _createClass3.default)(PostInfo, [{
        key: 'render',
        value: function render() {
            var post = this.props.post;

            var idCount = -1;
            if (this.props.lastPostCount >= 0 && this.props.lastPostCount < _constants3.default.TEST_ID_COUNT) {
                idCount = this.props.lastPostCount;
            }

            var isEphemeral = Utils.isPostEphemeral(post);
            var isSystemMessage = PostUtils.isSystemMessage(post);

            var flagIcon = void 0;
            if (!isEphemeral && !post.failed && !isSystemMessage && (this.props.hover || this.props.isFlagged)) {
                flagIcon = _react2.default.createElement(_post_flag_icon2.default, {
                    idPrefix: 'centerPostFlag',
                    idCount: idCount,
                    postId: post.id,
                    isFlagged: this.props.isFlagged,
                    isEphemeral: isEphemeral
                });
            }

            var options = void 0;
            if (isEphemeral) {
                options = _react2.default.createElement(
                    'div',
                    { className: 'col col__remove' },
                    this.createRemovePostButton()
                );
            } else if (!post.failed) {
                options = this.buildOptions(post, isSystemMessage, idCount);
            }

            var visibleMessage = void 0;
            if (isEphemeral && !this.props.compactDisplay && post.state !== _constants.Posts.POST_DELETED) {
                visibleMessage = _react2.default.createElement(
                    'span',
                    { className: 'post__visibility' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_info.message.visible',
                        defaultMessage: '(Only visible to you)'
                    })
                );
            }

            var pinnedBadge = void 0;
            if (post.is_pinned) {
                pinnedBadge = _react2.default.createElement(
                    'span',
                    { className: 'post__pinned-badge' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'post_info.pinned',
                        defaultMessage: 'Pinned'
                    })
                );
            }

            var postTime = void 0;
            if (this.props.hover || this.props.showTimeWithoutHover) {
                // timestamp should not be a permalink if the post has been deleted, is ephemeral message, or is pending
                var isPermalink = !(isEphemeral || _constants.Posts.POST_DELETED === post.state || ReduxPostUtils.isPostPendingOrFailed(post));

                postTime = _react2.default.createElement(_post_time2.default, {
                    isPermalink: isPermalink,
                    eventTime: post.create_at,
                    postId: post.id
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'post__header--info' },
                _react2.default.createElement(
                    'div',
                    { className: 'col' },
                    postTime,
                    pinnedBadge,
                    flagIcon,
                    visibleMessage
                ),
                options
            );
        }
    }]);
    return PostInfo;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PostInfo.propTypes = {

    /*
     * The post to render the info for
     */
    post: _propTypes2.default.object.isRequired,

    /*
     * The id of the team which belongs the post
     */
    teamId: _propTypes2.default.string,

    /*
     * Function called when the comment icon is clicked
     */
    handleCommentClick: _propTypes2.default.func.isRequired,

    /*
     * Funciton called when the post options dropdown is opened
     */
    handleDropdownOpened: _propTypes2.default.func.isRequired,

    /*
     * Set to mark the post as flagged
     */
    isFlagged: _propTypes2.default.bool,

    /*
     * The number of replies in the same thread as this post
     */
    replyCount: _propTypes2.default.number,

    /**
     * Set to indicate that this is previous post was not a reply to the same thread
     */
    isFirstReply: _propTypes2.default.bool,

    /**
     * Set to render in mobile view
     */
    isMobile: _propTypes2.default.bool,

    /*
     * Post identifiers for selenium tests
     */
    lastPostCount: _propTypes2.default.number,

    /**
     * Set to render in compact view
     */
    compactDisplay: _propTypes2.default.bool,

    /**
     * Function to get the post list HTML element
     */
    getPostList: _propTypes2.default.func.isRequired,

    /**
     * Set to mark post as being hovered over
     */
    hover: _propTypes2.default.bool.isRequired,

    /**
     * Set to render the post time when not hovering
     */
    showTimeWithoutHover: _propTypes2.default.bool.isRequired,

    /**
     * Whether to show the emoji picker.
     */
    enableEmojiPicker: _propTypes2.default.bool.isRequired,

    /**
     * Set not to allow edits on post
     */
    isReadOnly: _propTypes2.default.bool,

    actions: _propTypes2.default.shape({

        /*
         * Function to remove the post
         */
        removePost: _propTypes2.default.func.isRequired,

        /*
         * Function to add a reaction to the post
         */
        addReaction: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = PostInfo;

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _scroll_to_bottom_icon = __webpack_require__(2462);

var _scroll_to_bottom_icon2 = _interopRequireDefault(_scroll_to_bottom_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ScrollToBottomArrows = function (_React$PureComponent) {
    (0, _inherits3.default)(ScrollToBottomArrows, _React$PureComponent);

    function ScrollToBottomArrows() {
        (0, _classCallCheck3.default)(this, ScrollToBottomArrows);
        return (0, _possibleConstructorReturn3.default)(this, (ScrollToBottomArrows.__proto__ || (0, _getPrototypeOf2.default)(ScrollToBottomArrows)).apply(this, arguments));
    }

    (0, _createClass3.default)(ScrollToBottomArrows, [{
        key: 'render',
        value: function render() {
            // only show on mobile
            if ((0, _jquery2.default)(window).width() > 768) {
                return null;
            }

            var className = 'post-list__arrows';
            if (this.props.isScrolling && !this.props.atBottom) {
                className += ' scrolling';
            }

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.props.onClick
                },
                _react2.default.createElement(_scroll_to_bottom_icon2.default, null)
            );
        }
    }]);
    return ScrollToBottomArrows;
}(_react2.default.PureComponent);

ScrollToBottomArrows.propTypes = {
    isScrolling: _propTypes2.default.bool.isRequired,
    atBottom: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};
exports.default = ScrollToBottomArrows;

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollToBottomIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(ScrollToBottomIcon, _React$PureComponent);

    function ScrollToBottomIcon() {
        (0, _classCallCheck3.default)(this, ScrollToBottomIcon);
        return (0, _possibleConstructorReturn3.default)(this, (ScrollToBottomIcon.__proto__ || (0, _getPrototypeOf2.default)(ScrollToBottomIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(ScrollToBottomIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        id: 'Layer_1',
                        x: '0px',
                        y: '0px',
                        viewBox: '-239 239 21 23',
                        style: style
                    },
                    _react2.default.createElement('path', { d: 'M-239,241.4l2.4-2.4l8.1,8.2l8.1-8.2l2.4,2.4l-10.5,10.6L-239,241.4z M-228.5,257.2l8.1-8.2l2.4,2.4l-10.5,10.6l-10.5-10.6 l2.4-2.4L-228.5,257.2z' })
                )
            );
        }
    }]);
    return ScrollToBottomIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = ScrollToBottomIcon;


var style = {
    enableBackground: 'new -239 239 21 23'
};

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _channel_intro_message = __webpack_require__(2464);

var _channel_intro_message2 = _interopRequireDefault(_channel_intro_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);

    return {
        isLicensed: license.IsLicensed === 'true'
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_channel_intro_message2.default);

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDefaultIntroMessage = createDefaultIntroMessage;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(19);

var _channels = __webpack_require__(783);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _channel_invite_modal = __webpack_require__(986);

var _channel_invite_modal2 = _interopRequireDefault(_channel_invite_modal);

var _edit_channel_header_modal = __webpack_require__(1089);

var _edit_channel_header_modal2 = _interopRequireDefault(_edit_channel_header_modal);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

var _toggle_modal_button = __webpack_require__(977);

var _toggle_modal_button2 = _interopRequireDefault(_toggle_modal_button);

var _user_profile = __webpack_require__(933);

var _user_profile2 = _interopRequireDefault(_user_profile);

var _channel_permission_gate = __webpack_require__(888);

var _channel_permission_gate2 = _interopRequireDefault(_channel_permission_gate);

var _team_permission_gate = __webpack_require__(864);

var _team_permission_gate2 = _interopRequireDefault(_team_permission_gate);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateChannelIntroMessage = function CreateChannelIntroMessage(_ref) {
    var channel = _ref.channel,
        fullWidth = _ref.fullWidth;

    var centeredIntro = '';
    if (!fullWidth) {
        centeredIntro = 'channel-intro--centered';
    }

    if (channel.type === _constants3.default.DM_CHANNEL) {
        return createDMIntroMessage(channel, centeredIntro);
    } else if (channel.type === _constants3.default.GM_CHANNEL) {
        return createGMIntroMessage(channel, centeredIntro);
    } else if (_channel_store2.default.isDefault(channel)) {
        return createDefaultIntroMessage(channel, centeredIntro);
    } else if (channel.name === _constants3.default.OFFTOPIC_CHANNEL) {
        return createOffTopicIntroMessage(channel, centeredIntro);
    } else if (channel.type === _constants3.default.OPEN_CHANNEL || channel.type === _constants3.default.PRIVATE_CHANNEL) {
        return createStandardIntroMessage(channel, centeredIntro);
    }
    return null;
}; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

CreateChannelIntroMessage.propTypes = {
    isLicensed: _propTypes2.default.bool.isRequired
};

exports.default = CreateChannelIntroMessage;


function createGMIntroMessage(channel, centeredIntro) {
    var profiles = _user_store2.default.getProfileListInChannel(channel.id, true);
    var channelIntroId = 'channelIntro';

    if (profiles.length > 0) {
        var pictures = [];
        var names = '';
        for (var i = 0; i < profiles.length; i++) {
            var profile = profiles[i];

            pictures.push(_react2.default.createElement(_profile_picture2.default, {
                key: 'introprofilepicture' + profile.id,
                src: Utils.imageURLForUser(profile),
                width: '50',
                height: '50',
                user: profile
            }));

            if (i === profiles.length - 1) {
                names += Utils.getDisplayNameByUser(profile);
            } else if (i === profiles.length - 2) {
                names += Utils.getDisplayNameByUser(profile) + ' and ';
            } else {
                names += Utils.getDisplayNameByUser(profile) + ', ';
            }
        }

        return _react2.default.createElement(
            'div',
            {
                id: channelIntroId,
                className: 'channel-intro ' + centeredIntro
            },
            _react2.default.createElement(
                'div',
                { className: 'post-profile-img__container channel-intro-img' },
                pictures
            ),
            _react2.default.createElement(
                'p',
                { className: 'channel-intro-text' },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'intro_messages.GM',
                    defaultMessage: 'This is the start of your group message history with {names}.<br />Messages and files shared here are not shown to people outside this area.',
                    values: {
                        names: names
                    }
                })
            ),
            createSetHeaderButton(channel)
        );
    }

    return _react2.default.createElement(
        'div',
        {
            id: channelIntroId,
            className: 'channel-intro ' + centeredIntro
        },
        _react2.default.createElement(
            'p',
            { className: 'channel-intro-text' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'intro_messages.group_message',
                defaultMessage: 'This is the start of your group message history with these teammates. Messages and files shared here are not shown to people outside this area.'
            })
        )
    );
}

function createDMIntroMessage(channel, centeredIntro) {
    var teammate = Utils.getDirectTeammate(channel.id);
    var channelIntroId = 'channelIntro';

    if (teammate) {
        var teammateName = teammate.username;
        if (teammate.nickname.length > 0) {
            teammateName = teammate.nickname;
        }

        return _react2.default.createElement(
            'div',
            {
                id: channelIntroId,
                className: 'channel-intro ' + centeredIntro
            },
            _react2.default.createElement(
                'div',
                { className: 'post-profile-img__container channel-intro-img' },
                _react2.default.createElement(_profile_picture2.default, {
                    src: Utils.imageURLForUser(teammate),
                    width: '50',
                    height: '50',
                    user: teammate,
                    hasMention: true
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'channel-intro-profile' },
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_user_profile2.default, {
                        user: teammate,
                        disablePopover: false,
                        hasMention: true
                    })
                )
            ),
            _react2.default.createElement(
                'p',
                { className: 'channel-intro-text' },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'intro_messages.DM',
                    defaultMessage: 'This is the start of your direct message history with {teammate}.<br />Direct messages and files shared here are not shown to people outside this area.',
                    values: {
                        teammate: teammateName
                    }
                })
            ),
            createSetHeaderButton(channel)
        );
    }

    return _react2.default.createElement(
        'div',
        {
            id: channelIntroId,
            className: 'channel-intro ' + centeredIntro
        },
        _react2.default.createElement(
            'p',
            { className: 'channel-intro-text' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'intro_messages.teammate',
                defaultMessage: 'This is the start of your direct message history with this teammate. Direct messages and files shared here are not shown to people outside this area.'
            })
        )
    );
}

function createOffTopicIntroMessage(channel, centeredIntro) {
    var uiType = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'intro_messages.channel',
        defaultMessage: 'channel'
    });

    var teamId = _team_store2.default.getCurrentId();
    var isPrivate = channel.type === _constants3.default.PRIVATE_CHANNEL;
    var setHeaderButton = _react2.default.createElement(
        _channel_permission_gate2.default,
        {
            teamId: teamId,
            channelId: channel.id,
            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES]
        },
        createSetHeaderButton(channel)
    );

    var channelInviteButton = createInviteChannelMemberButton(channel, uiType);

    return _react2.default.createElement(
        'div',
        {
            id: 'channelIntro',
            className: 'channel-intro ' + centeredIntro
        },
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
            id: 'intro_messages.offTopic',
            defaultMessage: '<h4 class="channel-intro__title">Beginning of {display_name}</h4><p class="channel-intro__content">This is the start of {display_name}, a channel for non-work-related conversations.<br/></p>',
            values: {
                display_name: channel.display_name
            }
        }),
        channelInviteButton,
        setHeaderButton
    );
}

function createDefaultIntroMessage(channel, centeredIntro) {
    var teamInviteLink = null;
    var isReadOnly = (0, _channels.isCurrentChannelReadOnly)(_redux_store2.default.getState());
    if (!isReadOnly) {
        teamInviteLink = _react2.default.createElement(
            _team_permission_gate2.default,
            {
                teamId: channel.team_id,
                permissions: [_constants.Permissions.INVITE_USER]
            },
            _react2.default.createElement(
                _team_permission_gate2.default,
                {
                    teamId: channel.team_id,
                    permissions: [_constants.Permissions.ADD_USER_TO_TEAM]
                },
                _react2.default.createElement(
                    'span',
                    {
                        className: 'intro-links color--link cursor--pointer',
                        onClick: GlobalActions.showGetTeamInviteLinkModal
                    },
                    _react2.default.createElement('i', { className: 'fa fa-user-plus' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'intro_messages.inviteOthers',
                        defaultMessage: 'Invite others to this team'
                    })
                )
            )
        );
    }

    var teamId = _team_store2.default.getCurrentId();
    var isPrivate = channel.type === _constants3.default.PRIVATE_CHANNEL;

    var setHeaderButton = null;
    if (!isReadOnly) {
        setHeaderButton = _react2.default.createElement(
            _channel_permission_gate2.default,
            {
                teamId: teamId,
                channelId: channel.id,
                permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES]
            },
            createSetHeaderButton(channel)
        );
    }

    return _react2.default.createElement(
        'div',
        {
            id: 'channelIntro',
            className: 'channel-intro ' + centeredIntro
        },
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
            id: 'intro_messages.default',
            defaultMessage: '<h4 class=\'channel-intro__title\'>Beginning of {display_name}</h4><p class=\'channel-intro__content\'><strong>Welcome to {display_name}!</strong><br/><br/>This is the first channel teammates see when they sign up - use it for posting updates everyone needs to know.</p>',
            values: {
                display_name: channel.display_name
            }
        }),
        teamInviteLink,
        setHeaderButton,
        _react2.default.createElement('br', null)
    );
}

function createStandardIntroMessage(channel, centeredIntro) {
    var uiName = channel.display_name;
    var creatorName = Utils.getDisplayNameByUserId(channel.creator_id);
    var uiType;
    var memberMessage;

    if (channel.type === _constants3.default.PRIVATE_CHANNEL) {
        uiType = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'intro_messages.group',
            defaultMessage: 'private channel'
        });
        memberMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'intro_messages.onlyInvited',
            defaultMessage: ' Only invited members can see this private channel.'
        });
    } else {
        uiType = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'intro_messages.channel',
            defaultMessage: 'channel'
        });
        memberMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'intro_messages.anyMember',
            defaultMessage: ' Any member can join and read this channel.'
        });
    }

    var date = _react2.default.createElement(_reactIntl.FormattedDate, {
        value: channel.create_at,
        month: 'long',
        day: '2-digit',
        year: 'numeric'
    });

    var createMessage;
    if (creatorName === '') {
        createMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'intro_messages.noCreator',
            defaultMessage: 'This is the start of the {name} {type}, created on {date}.',
            values: {
                name: uiName,
                type: uiType,
                date: date
            }
        });
    } else {
        createMessage = _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'intro_messages.creator',
                defaultMessage: 'This is the start of the {name} {type}, created by {creator} on {date}.',
                values: {
                    name: uiName,
                    type: uiType,
                    creator: creatorName,
                    date: date
                }
            })
        );
    }

    var purposeMessage = '';
    if (channel.purpose && channel.purpose !== '') {
        purposeMessage = _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'intro_messages.purpose',
                defaultMessage: ' This {type}\'s purpose is: {purpose}',
                values: {
                    purpose: channel.purpose,
                    type: uiType
                }
            })
        );
    }

    var teamId = _team_store2.default.getCurrentId();
    var isPrivate = channel.type === _constants3.default.PRIVATE_CHANNEL;
    var setHeaderButton = _react2.default.createElement(
        _channel_permission_gate2.default,
        {
            teamId: teamId,
            channelId: channel.id,
            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES]
        },
        createSetHeaderButton(channel)
    );

    var channelInviteButton = createInviteChannelMemberButton(channel, uiType);

    return _react2.default.createElement(
        'div',
        {
            id: 'channelIntro',
            className: 'channel-intro ' + centeredIntro
        },
        _react2.default.createElement(
            'h4',
            { className: 'channel-intro__title' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'intro_messages.beginning',
                defaultMessage: 'Beginning of {name}',
                values: {
                    name: uiName
                }
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'channel-intro__content' },
            createMessage,
            memberMessage,
            purposeMessage,
            _react2.default.createElement('br', null)
        ),
        channelInviteButton,
        setHeaderButton
    );
}

function createInviteChannelMemberButton(channel, uiType) {
    var isPrivate = channel.type === _constants3.default.PRIVATE_CHANNEL;
    return _react2.default.createElement(
        _channel_permission_gate2.default,
        {
            channelId: channel.id,
            teamId: channel.team_id,
            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_MEMBERS : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_MEMBERS]
        },
        _react2.default.createElement(
            _toggle_modal_button2.default,
            {
                className: 'intro-links color--link',
                dialogType: _channel_invite_modal2.default,
                dialogProps: { channel: channel }
            },
            _react2.default.createElement('i', { className: 'fa fa-user-plus' }),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'intro_messages.invite',
                defaultMessage: 'Invite others to this {type}',
                values: {
                    type: uiType
                }
            })
        )
    );
}

function createSetHeaderButton(channel) {
    return _react2.default.createElement(
        _toggle_modal_button2.default,
        {
            className: 'intro-links color--link',
            dialogType: _edit_channel_header_modal2.default,
            dialogProps: { channel: channel }
        },
        _react2.default.createElement('i', { className: 'fa fa-pencil' }),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'intro_messages.setHeader',
            defaultMessage: 'Set a Header'
        })
    );
}

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _general = __webpack_require__(113);

var _rhs = __webpack_require__(817);

var _lhs = __webpack_require__(958);

var _rhs2 = __webpack_require__(818);

var _constants = __webpack_require__(29);

var _navbar = __webpack_require__(2466);

var _navbar2 = _interopRequireDefault(_navbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var enableWebrtc = config.EnableWebrtc === 'true';

    var rhsState = (0, _rhs2.getRhsState)(state);

    return {
        isPinnedPosts: rhsState === _constants.RHSStates.PIN,
        enableWebrtc: enableWebrtc
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            updateRhsState: _rhs.updateRhsState,
            showPinnedPosts: _rhs.showPinnedPosts,
            toggleLhs: _lhs.toggle,
            closeLhs: _lhs.close,
            closeRhs: _rhs.closeRightHandSide,
            toggleRhsMenu: _rhs.toggleMenu,
            closeRhsMenu: _rhs.closeMenu
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_navbar2.default);

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _constants = __webpack_require__(19);

var _edit_channel_header_modal = __webpack_require__(1089);

var _edit_channel_header_modal2 = _interopRequireDefault(_edit_channel_header_modal);

var _edit_channel_purpose_modal = __webpack_require__(1418);

var _edit_channel_purpose_modal2 = _interopRequireDefault(_edit_channel_purpose_modal);

var _channel_actions = __webpack_require__(809);

var ChannelActions = _interopRequireWildcard(_channel_actions);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _webrtc_actions = __webpack_require__(905);

var WebrtcActions = _interopRequireWildcard(_webrtc_actions);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _modal_store = __webpack_require__(849);

var _modal_store2 = _interopRequireDefault(_modal_store);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _webrtc_store = __webpack_require__(831);

var _webrtc_store2 = _interopRequireDefault(_webrtc_store);

var _channel_utils = __webpack_require__(830);

var ChannelUtils = _interopRequireWildcard(_channel_utils);

var _constants2 = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _channel_info_modal = __webpack_require__(1413);

var _channel_info_modal2 = _interopRequireDefault(_channel_info_modal);

var _channel_invite_modal = __webpack_require__(986);

var _channel_invite_modal2 = _interopRequireDefault(_channel_invite_modal);

var _channel_members_modal = __webpack_require__(1088);

var _channel_members_modal2 = _interopRequireDefault(_channel_members_modal);

var _channel_notifications_modal = __webpack_require__(1414);

var _channel_notifications_modal2 = _interopRequireDefault(_channel_notifications_modal);

var _delete_channel_modal = __webpack_require__(1417);

var _delete_channel_modal2 = _interopRequireDefault(_delete_channel_modal);

var _more_direct_channels = __webpack_require__(1084);

var _more_direct_channels2 = _interopRequireDefault(_more_direct_channels);

var _notify_counts = __webpack_require__(2467);

var _notify_counts2 = _interopRequireDefault(_notify_counts);

var _quick_switch_modal = __webpack_require__(2468);

var _quick_switch_modal2 = _interopRequireDefault(_quick_switch_modal);

var _rename_channel_modal = __webpack_require__(1419);

var _rename_channel_modal2 = _interopRequireDefault(_rename_channel_modal);

var _status_icon = __webpack_require__(932);

var _status_icon2 = _interopRequireDefault(_status_icon);

var _menu_icon = __webpack_require__(1085);

var _menu_icon2 = _interopRequireDefault(_menu_icon);

var _search_icon = __webpack_require__(1048);

var _search_icon2 = _interopRequireDefault(_search_icon);

var _toggle_modal_button = __webpack_require__(977);

var _toggle_modal_button2 = _interopRequireDefault(_toggle_modal_button);

var _toggle_modal_button_redux = __webpack_require__(1420);

var _toggle_modal_button_redux2 = _interopRequireDefault(_toggle_modal_button_redux);

var _channel_permission_gate = __webpack_require__(888);

var _channel_permission_gate2 = _interopRequireDefault(_channel_permission_gate);

var _pluggable = __webpack_require__(881);

var _pluggable2 = _interopRequireDefault(_pluggable);

var _navbar_info_button = __webpack_require__(2472);

var _navbar_info_button2 = _interopRequireDefault(_navbar_info_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Navbar = function (_React$Component) {
    (0, _inherits3.default)(Navbar, _React$Component);

    function Navbar(props) {
        (0, _classCallCheck3.default)(this, Navbar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Navbar.__proto__ || (0, _getPrototypeOf2.default)(Navbar)).call(this, props));

        _this.getStateFromStores = function () {
            var channel = _channel_store2.default.getCurrent();

            var contactId = null;
            if (channel && channel.type === 'D') {
                contactId = Utils.getUserIdFromChannelName(channel);
            }

            return {
                channel: channel,
                member: _channel_store2.default.getCurrentMember(),
                users: [],
                userCount: _channel_store2.default.getCurrentStats().member_count,
                currentUser: _user_store2.default.getCurrentUser(),
                isFavorite: channel && ChannelUtils.isFavoriteChannel(channel),
                contactId: contactId,
                isBusy: _webrtc_store2.default.isBusy()
            };
        };

        _this.isStateValid = function () {
            return _this.state.channel && _this.state.member && _this.state.users && _this.state.currentUser;
        };

        _this.handleLeave = function () {
            if (_this.state.channel.type === _constants2.Constants.PRIVATE_CHANNEL) {
                GlobalActions.showLeavePrivateChannelModal(_this.state.channel);
            } else {
                ChannelActions.leaveChannel(_this.state.channel.id);
            }
        };

        _this.hideSidebars = function (e) {
            var windowWidth = (0, _jquery2.default)(window).outerWidth();
            if (windowWidth <= 768) {
                _this.props.actions.closeRhs();

                if (e.target.className !== 'navbar-toggle' && e.target.className !== 'icon-bar') {
                    _this.props.actions.closeLhs();
                    _this.props.actions.closeRhs();
                    _this.props.actions.closeRhsMenu();
                }
            }
        };

        _this.toggleLeftSidebar = function () {
            _this.props.actions.toggleLhs();
        };

        _this.toggleRightSidebar = function () {
            _this.props.actions.toggleRhsMenu();
        };

        _this.showSearch = function () {
            _this.props.actions.updateRhsState(_constants2.RHSStates.SEARCH);
        };

        _this.onChange = function () {
            _this.setState(_this.getStateFromStores());
        };

        _this.showEditChannelHeaderModal = function () {
            _this.setState({
                showEditChannelHeaderModal: true
            });
        };

        _this.hideEditChannelHeaderModal = function () {
            _this.setState({
                showEditChannelHeaderModal: false
            });
        };

        _this.showChannelNotificationsModal = function (e) {
            e.preventDefault();

            _this.setState({
                showChannelNotificationsModal: true
            });
        };

        _this.hideChannelNotificationsModal = function () {
            _this.setState({
                showChannelNotificationsModal: false
            });
        };

        _this.showChannelPurposeModal = function () {
            _this.setState({
                showEditChannelPurposeModal: true
            });
        };

        _this.hideChannelPurposeModal = function () {
            _this.setState({
                showEditChannelPurposeModal: false
            });
        };

        _this.showRenameChannelModal = function () {
            _this.setState({
                showRenameChannelModal: true
            });
        };

        _this.hideRenameChannelModal = function () {
            _this.setState({
                showRenameChannelModal: false
            });
        };

        _this.showMembersModal = function (e) {
            e.preventDefault();

            _this.setState({ showMembersModal: true });
        };

        _this.hideMembersModal = function () {
            _this.setState({ showMembersModal: false });
        };

        _this.handleQuickSwitchKeyPress = function (e) {
            if (Utils.cmdOrCtrlPressed(e) && !e.shiftKey && Utils.isKeyPressed(e, _constants2.Constants.KeyCodes.K)) {
                if (!e.altKey) {
                    e.preventDefault();
                    _this.toggleQuickSwitchModal('channel');
                }
            }
        };

        _this.toggleQuickSwitchModal = function () {
            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'channel';

            if (_this.state.showQuickSwitchModal) {
                _this.setState({ showQuickSwitchModal: false, quickSwitchMode: 'channel' });
            } else {
                _this.setState({ showQuickSwitchModal: true, quickSwitchMode: mode });
            }
        };

        _this.hideQuickSwitchModal = function () {
            _this.setState({
                showQuickSwitchModal: false,
                quickSwitchMode: 'channel'
            });
        };

        _this.getPinnedPosts = function (e) {
            e.preventDefault();
            if (_this.props.isPinnedPosts) {
                GlobalActions.emitCloseRightHandSide();
            } else {
                _this.props.actions.showPinnedPosts(_this.state.channel.id);
            }
        };

        _this.toggleFavorite = function (e) {
            e.preventDefault();

            if (_this.state.isFavorite) {
                ChannelActions.unmarkFavorite(_this.state.channel.id);
            } else {
                ChannelActions.markFavorite(_this.state.channel.id);
            }
        };

        _this.onBusy = function (isBusy) {
            _this.setState({ isBusy: isBusy });
        };

        _this.initWebrtc = function () {
            if (!_this.isContactNotAvailable()) {
                GlobalActions.emitCloseRightHandSide();
                WebrtcActions.initWebrtc(_this.state.contactId, true);
            }
        };

        _this.hideHeaderOverlay = function () {
            if (_this.refs.headerOverlay) {
                _this.refs.headerOverlay.hide();
            }
        };

        _this.createDropdown = function (teamId, channel, channelTitle, isDirect, isGroup) {
            if (channel) {
                var viewInfoOption = void 0;
                var webrtcOption = void 0;
                var viewPinnedPostsOption = void 0;
                var addMembersOption = void 0;
                var manageMembersOption = void 0;
                var setChannelHeaderOption = void 0;
                var setChannelPurposeOption = void 0;
                var notificationPreferenceOption = void 0;
                var renameChannelOption = void 0;
                var deleteChannelOption = void 0;
                var leaveChannelOption = void 0;

                if (isDirect) {
                    setChannelHeaderOption = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                role: 'menuitem',
                                href: '#',
                                onClick: _this.showEditChannelHeaderModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_header.channelHeader',
                                defaultMessage: 'Edit Channel Header'
                            })
                        )
                    );

                    webrtcOption = _this.generateWebrtcDropdown();
                } else if (isGroup) {
                    setChannelHeaderOption = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                role: 'menuitem',
                                href: '#',
                                onClick: _this.showEditChannelHeaderModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'channel_header.channelHeader',
                                defaultMessage: 'Edit Channel Header'
                            })
                        )
                    );

                    notificationPreferenceOption = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                role: 'menuitem',
                                href: '#',
                                onClick: _this.showChannelNotificationsModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar.preferences',
                                defaultMessage: 'Notification Preferences'
                            })
                        )
                    );

                    addMembersOption = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            _toggle_modal_button_redux2.default,
                            {
                                id: 'channelAddMembersGroup',
                                role: 'menuitem',
                                modalId: _constants2.ModalIdentifiers.CREATE_DM_CHANNEL,
                                dialogType: _more_direct_channels2.default,
                                dialogProps: { isExistingChannel: true }
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar.addMembers',
                                defaultMessage: 'Add Members'
                            })
                        )
                    );
                } else {
                    var isPrivate = channel.type === _constants2.Constants.PRIVATE_CHANNEL;
                    viewInfoOption = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            _toggle_modal_button_redux2.default,
                            {
                                role: 'menuitem',
                                modalId: _constants2.ModalIdentifiers.CHANNEL_INFO,
                                dialogType: _channel_info_modal2.default,
                                dialogProps: { channel: channel }
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar.viewInfo',
                                defaultMessage: 'View Info'
                            })
                        )
                    );

                    viewPinnedPostsOption = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                role: 'menuitem',
                                href: '#',
                                onClick: _this.getPinnedPosts
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar.viewPinnedPosts',
                                defaultMessage: 'View Pinned Posts'
                            })
                        )
                    );

                    if (_channel_store2.default.isDefault(channel)) {
                        manageMembersOption = _react2.default.createElement(
                            'li',
                            {
                                key: 'view_members',
                                role: 'presentation'
                            },
                            _react2.default.createElement(
                                'a',
                                {
                                    role: 'menuitem',
                                    href: '#',
                                    onClick: _this.showMembersModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.viewMembers',
                                    defaultMessage: 'View Members'
                                })
                            )
                        );
                    } else {
                        addMembersOption = _react2.default.createElement(
                            _channel_permission_gate2.default,
                            {
                                channelId: channel.id,
                                teamId: teamId,
                                permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_MEMBERS : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_MEMBERS],
                                key: 'add_members_permission'
                            },
                            _react2.default.createElement(
                                'li',
                                { role: 'presentation' },
                                _react2.default.createElement(
                                    _toggle_modal_button2.default,
                                    {
                                        ref: 'channelInviteModalButton',
                                        role: 'menuitem',
                                        dialogType: _channel_invite_modal2.default,
                                        dialogProps: { channel: channel, currentUser: _this.state.currentUser }
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'navbar.addMembers',
                                        defaultMessage: 'Add Members'
                                    })
                                )
                            )
                        );

                        manageMembersOption = _react2.default.createElement(
                            'li',
                            {
                                key: 'manage_members',
                                role: 'presentation'
                            },
                            _react2.default.createElement(
                                'a',
                                {
                                    role: 'menuitem',
                                    href: '#',
                                    onClick: _this.showMembersModal
                                },
                                _react2.default.createElement(
                                    _channel_permission_gate2.default,
                                    {
                                        channelId: channel.id,
                                        teamId: teamId,
                                        permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_MEMBERS : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_MEMBERS]
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'channel_header.manageMembers',
                                        defaultMessage: 'Manage Members'
                                    })
                                ),
                                _react2.default.createElement(
                                    _channel_permission_gate2.default,
                                    {
                                        channelId: channel.id,
                                        teamId: teamId,
                                        invert: true,
                                        permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_MEMBERS : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_MEMBERS]
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'channel_header.viewMembers',
                                        defaultMessage: 'View Members'
                                    })
                                )
                            )
                        );
                    }

                    notificationPreferenceOption = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                role: 'menuitem',
                                href: '#',
                                onClick: _this.showChannelNotificationsModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'navbar.preferences',
                                defaultMessage: 'Notification Preferences'
                            })
                        )
                    );

                    setChannelHeaderOption = _react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: channel.id,
                            teamId: teamId,
                            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES]
                        },
                        _react2.default.createElement(
                            'li',
                            { role: 'presentation' },
                            _react2.default.createElement(
                                'a',
                                {
                                    role: 'menuitem',
                                    href: '#',
                                    onClick: _this.showEditChannelHeaderModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.setHeader',
                                    defaultMessage: 'Edit Channel Header'
                                })
                            )
                        )
                    );

                    setChannelPurposeOption = _react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: channel.id,
                            teamId: teamId,
                            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES]
                        },
                        _react2.default.createElement(
                            'li',
                            { role: 'presentation' },
                            _react2.default.createElement(
                                'a',
                                {
                                    role: 'menuitem',
                                    href: '#',
                                    onClick: _this.showChannelPurposeModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.setPurpose',
                                    defaultMessage: 'Edit Channel Purpose'
                                })
                            )
                        )
                    );

                    renameChannelOption = _react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: channel.id,
                            teamId: teamId,
                            permissions: [isPrivate ? _constants.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES : _constants.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES]
                        },
                        _react2.default.createElement(
                            'li',
                            { role: 'presentation' },
                            _react2.default.createElement(
                                'a',
                                {
                                    role: 'menuitem',
                                    href: '#',
                                    onClick: _this.showRenameChannelModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.rename',
                                    defaultMessage: 'Rename Channel'
                                })
                            )
                        )
                    );

                    deleteChannelOption = _react2.default.createElement(
                        _channel_permission_gate2.default,
                        {
                            channelId: channel.id,
                            teamId: teamId,
                            permissions: [isPrivate ? _constants.Permissions.DELETE_PRIVATE_CHANNEL : _constants.Permissions.DELETE_PUBLIC_CHANNEL]
                        },
                        _react2.default.createElement(
                            'li',
                            { role: 'presentation' },
                            _react2.default.createElement(
                                _toggle_modal_button2.default,
                                {
                                    role: 'menuitem',
                                    dialogType: _delete_channel_modal2.default,
                                    dialogProps: { channel: channel }
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.delete',
                                    defaultMessage: 'Delete Channel'
                                })
                            )
                        )
                    );

                    if (!_channel_store2.default.isDefault(channel)) {
                        leaveChannelOption = _react2.default.createElement(
                            'li',
                            { role: 'presentation' },
                            _react2.default.createElement(
                                'a',
                                {
                                    role: 'menuitem',
                                    href: '#',
                                    onClick: _this.handleLeave
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'channel_header.leave',
                                    defaultMessage: 'Leave Channel'
                                })
                            )
                        );
                    }
                }

                var toggleFavoriteOption = _react2.default.createElement(
                    'li',
                    {
                        key: 'toggle_favorite',
                        role: 'presentation'
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            role: 'menuitem',
                            href: '#',
                            onClick: _this.toggleFavorite
                        },
                        _this.state.isFavorite ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channelHeader.removeFromFavorites',
                            defaultMessage: 'Remove from Favorites'
                        }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channelHeader.addToFavorites',
                            defaultMessage: 'Add to Favorites'
                        })
                    )
                );

                return _react2.default.createElement(
                    'div',
                    { className: 'navbar-brand' },
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown' },
                        _this.generateWebrtcIcon(),
                        _react2.default.createElement(
                            'a',
                            {
                                href: '#',
                                className: 'dropdown-toggle theme',
                                type: 'button',
                                'data-toggle': 'dropdown',
                                'aria-expanded': 'true'
                            },
                            _react2.default.createElement(
                                'span',
                                { className: 'heading' },
                                _react2.default.createElement(_status_icon2.default, { status: _this.getTeammateStatus() }),
                                channelTitle,
                                ' '
                            ),
                            _react2.default.createElement('span', { className: 'fa fa-angle-down header-dropdown__icon' })
                        ),
                        _react2.default.createElement(
                            'ul',
                            {
                                className: 'dropdown-menu',
                                role: 'menu'
                            },
                            viewInfoOption,
                            webrtcOption,
                            viewPinnedPostsOption,
                            notificationPreferenceOption,
                            addMembersOption,
                            manageMembersOption,
                            setChannelHeaderOption,
                            setChannelPurposeOption,
                            renameChannelOption,
                            deleteChannelOption,
                            leaveChannelOption,
                            toggleFavoriteOption,
                            _react2.default.createElement(
                                'div',
                                {
                                    className: 'close visible-xs-block',
                                    onClick: _this.hideHeaderOverlay
                                },
                                '×'
                            )
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'navbar-brand' },
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        to: _team_store2.default.getCurrentTeamUrl() + ('/channels/' + _constants2.Constants.DEFAULT_CHANNEL),
                        className: 'heading'
                    },
                    channelTitle
                )
            );
        };

        _this.createCollapseButtons = function (currentId) {
            var buttons = [];

            if (currentId == null) {
                buttons.push(_react2.default.createElement(
                    'button',
                    {
                        key: 'navbar-toggle-collapse',
                        type: 'button',
                        className: 'navbar-toggle',
                        'data-toggle': 'collapse',
                        'data-target': '#navbar-collapse-1'
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar.toggle1',
                            defaultMessage: 'Toggle sidebar'
                        })
                    ),
                    _react2.default.createElement('span', { className: 'icon-bar' }),
                    _react2.default.createElement('span', { className: 'icon-bar' }),
                    _react2.default.createElement('span', { className: 'icon-bar' })
                ));
            } else {
                buttons.push(_react2.default.createElement(
                    'button',
                    {
                        key: 'navbar-toggle-sidebar',
                        type: 'button',
                        className: 'navbar-toggle',
                        'data-toggle': 'collapse',
                        'data-target': '#sidebar-nav',
                        onClick: _this.toggleLeftSidebar
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar.toggle2',
                            defaultMessage: 'Toggle sidebar'
                        })
                    ),
                    _react2.default.createElement(_menu_icon2.default, { className: 'icon icon__menu icon--sidebarHeaderTextColor' }),
                    _react2.default.createElement(_notify_counts2.default, null)
                ));

                buttons.push(_react2.default.createElement(
                    'button',
                    {
                        key: 'navbar-toggle-menu',
                        type: 'button',
                        className: 'navbar-toggle navbar-right__icon menu-toggle pull-right',
                        'data-toggle': 'collapse',
                        'data-target': '#sidebar-nav',
                        onClick: _this.toggleRightSidebar
                    },
                    _react2.default.createElement(_menu_icon2.default, null)
                ));
            }

            return buttons;
        };

        _this.getTeammateStatus = function () {
            var channel = _this.state.channel;

            // get status for direct message channels
            if (channel.type === 'D') {
                var currentUserId = _this.state.currentUser.id;
                var teammate = _this.state.users.find(function (user) {
                    return user.id !== currentUserId;
                });
                if (teammate) {
                    return _user_store2.default.getStatus(teammate.id);
                }
            }
            return null;
        };

        _this.showChannelInviteModalButton = function () {
            if (_this.refs.channelInviteModalButton) {
                _this.refs.channelInviteModalButton.show();
            }
        };

        _this.state = (0, _extends3.default)({}, _this.getStateFromStores(), {
            showEditChannelPurposeModal: false,
            showEditChannelHeaderModal: false,
            showMembersModal: false,
            showRenameChannelModal: false,
            showQuickSwitchModal: false,
            showChannelNotificationsModal: false,
            quickSwitchMode: 'channel'
        });
        return _this;
    }

    (0, _createClass3.default)(Navbar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _channel_store2.default.addChangeListener(this.onChange);
            _channel_store2.default.addStatsChangeListener(this.onChange);
            _user_store2.default.addStatusesChangeListener(this.onChange);
            _user_store2.default.addChangeListener(this.onChange);
            _preference_store2.default.addChangeListener(this.onChange);
            _modal_store2.default.addModalListener(_constants2.ActionTypes.TOGGLE_QUICK_SWITCH_MODAL, this.toggleQuickSwitchModal);
            _modal_store2.default.addModalListener(_constants2.ActionTypes.TOGGLE_CHANNEL_HEADER_UPDATE_MODAL, this.showEditChannelHeaderModal);
            _modal_store2.default.addModalListener(_constants2.ActionTypes.TOGGLE_CHANNEL_PURPOSE_UPDATE_MODAL, this.showChannelPurposeModal);
            _modal_store2.default.addModalListener(_constants2.ActionTypes.TOGGLE_CHANNEL_NAME_UPDATE_MODAL, this.showRenameChannelModal);
            _webrtc_store2.default.addChangedListener(this.onChange);
            _webrtc_store2.default.addBusyListener(this.onBusy);
            document.addEventListener('keydown', this.handleQuickSwitchKeyPress);
            (0, _jquery2.default)('.inner-wrap').on('click', this.hideSidebars);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _channel_store2.default.removeChangeListener(this.onChange);
            _channel_store2.default.removeStatsChangeListener(this.onChange);
            _user_store2.default.removeStatusesChangeListener(this.onChange);
            _user_store2.default.removeChangeListener(this.onChange);
            _preference_store2.default.removeChangeListener(this.onChange);
            _modal_store2.default.removeModalListener(_constants2.ActionTypes.TOGGLE_QUICK_SWITCH_MODAL, this.toggleQuickSwitchModal);
            _modal_store2.default.removeModalListener(_constants2.ActionTypes.TOGGLE_CHANNEL_HEADER_UPDATE_MODAL, this.showEditChannelHeaderModal);
            _modal_store2.default.removeModalListener(_constants2.ActionTypes.TOGGLE_CHANNEL_PURPOSE_UPDATE_MODAL, this.showChannelPurposeModal);
            _modal_store2.default.removeModalListener(_constants2.ActionTypes.TOGGLE_CHANNEL_NAME_UPDATE_MODAL, this.showRenameChannelModal);
            _webrtc_store2.default.removeChangedListener(this.onChange);
            _webrtc_store2.default.removeBusyListener(this.onBusy);
            document.removeEventListener('keydown', this.handleQuickSwitchKeyPress);
            (0, _jquery2.default)('.inner-wrap').off('click', this.hideSidebars);
        }
    }, {
        key: 'isContactNotAvailable',
        value: function isContactNotAvailable() {
            var contactStatus = _user_store2.default.getStatus(this.state.contactId);

            return contactStatus === _constants2.UserStatuses.OFFLINE || contactStatus === _constants2.UserStatuses.DND || this.state.isBusy;
        }
    }, {
        key: 'isWebrtcEnabled',
        value: function isWebrtcEnabled() {
            var userMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
            var PreReleaseFeatures = _constants2.Constants.PRE_RELEASE_FEATURES;
            return this.props.enableWebrtc && userMedia && Utils.isFeatureEnabled(PreReleaseFeatures.WEBRTC_PREVIEW);
        }
    }, {
        key: 'generateWebrtcDropdown',
        value: function generateWebrtcDropdown() {
            if (!this.isWebrtcEnabled()) {
                return null;
            }

            var linkClass = '';
            if (this.isContactNotAvailable()) {
                linkClass = 'disable-links';
            }

            return _react2.default.createElement(
                'li',
                {
                    role: 'presentation',
                    className: 'webrtc__option'
                },
                _react2.default.createElement(
                    'a',
                    {
                        role: 'menuitem',
                        href: '#',
                        onClick: this.initWebrtc,
                        className: linkClass
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'navbar_dropdown.webrtc.call',
                        defaultMessage: 'Start Video Call'
                    })
                )
            );
        }
    }, {
        key: 'generateWebrtcIcon',
        value: function generateWebrtcIcon() {
            var channel = this.state.channel || {};
            if (!this.isWebrtcEnabled() || channel.type !== _constants2.Constants.DM_CHANNEL) {
                return null;
            }

            var circleClass = '';
            if (this.isContactNotAvailable()) {
                circleClass = 'offline';
            }

            return _react2.default.createElement(
                'div',
                { className: 'pull-right description navbar-right__icon webrtc__button ' + circleClass },
                _react2.default.createElement(
                    'a',
                    { onClick: this.initWebrtc },
                    'WebRTC'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.isStateValid()) {
                return null;
            }

            var currentId = this.state.currentUser.id;
            var channel = this.state.channel;
            var channelTitle = this.props.teamDisplayName;
            var isDirect = false;
            var isGroup = false;
            var teamId = channel && channel.team_id;

            var editChannelHeaderModal = null;
            var editChannelPurposeModal = null;
            var renameChannelModal = null;
            var channelMembersModal = null;
            var channelNotificationsModal = null;
            var quickSwitchModal = null;

            if (channel) {
                channelTitle = channel.display_name;

                if (channel.type === _constants2.Constants.DM_CHANNEL) {
                    isDirect = true;
                    var teammateId = Utils.getUserIdFromChannelName(channel);
                    if (currentId === teammateId) {
                        channelTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'channel_header.directchannel.you',
                            defaultMessage: '{displayname} (you) ',
                            values: {
                                displayname: Utils.getDisplayNameByUserId(teammateId)
                            }
                        });
                    } else {
                        channelTitle = Utils.getDisplayNameByUserId(teammateId);
                    }
                } else if (channel.type === _constants2.Constants.GM_CHANNEL) {
                    isGroup = true;
                }

                if (this.state.showEditChannelHeaderModal) {
                    editChannelHeaderModal = _react2.default.createElement(_edit_channel_header_modal2.default, {
                        onHide: this.hideEditChannelHeaderModal,
                        channel: channel
                    });
                }

                if (this.state.showEditChannelPurposeModal) {
                    editChannelPurposeModal = _react2.default.createElement(_edit_channel_purpose_modal2.default, {
                        onModalDismissed: this.hideChannelPurposeModal,
                        channel: channel
                    });
                }

                renameChannelModal = _react2.default.createElement(_rename_channel_modal2.default, {
                    show: this.state.showRenameChannelModal,
                    onHide: this.hideRenameChannelModal,
                    channel: channel
                });

                if (this.state.showMembersModal) {
                    channelMembersModal = _react2.default.createElement(_channel_members_modal2.default, {
                        onModalDismissed: this.hideMembersModal,
                        showInviteModal: this.showChannelInviteModalButton,
                        channel: channel
                    });
                }

                channelNotificationsModal = _react2.default.createElement(_channel_notifications_modal2.default, {
                    show: this.state.showChannelNotificationsModal,
                    onHide: this.hideChannelNotificationsModal,
                    channel: channel,
                    channelMember: this.state.member,
                    currentUser: this.state.currentUser
                });

                quickSwitchModal = _react2.default.createElement(_quick_switch_modal2.default, {
                    show: this.state.showQuickSwitchModal,
                    onHide: this.hideQuickSwitchModal,
                    initialMode: this.state.quickSwitchMode
                });
            }

            var collapseButtons = this.createCollapseButtons(currentId);

            var searchButton = _react2.default.createElement(
                'button',
                {
                    type: 'button',
                    className: 'navbar-toggle navbar-right__icon navbar-search pull-right',
                    onClick: this.showSearch
                },
                _react2.default.createElement(_search_icon2.default, {
                    className: 'icon icon__search',
                    'aria-hidden': 'true'
                })
            );

            var channelMenuDropdown = this.createDropdown(teamId, channel, channelTitle, isDirect, isGroup);

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'nav',
                    {
                        className: 'navbar navbar-default navbar-fixed-top',
                        role: 'navigation'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-fluid theme' },
                        _react2.default.createElement(
                            'div',
                            { className: 'navbar-header' },
                            collapseButtons,
                            searchButton,
                            _react2.default.createElement(_navbar_info_button2.default, {
                                ref: 'headerOverlay',
                                channel: channel,
                                showEditChannelHeaderModal: this.showEditChannelHeaderModal
                            }),
                            _react2.default.createElement(_pluggable2.default, { pluggableName: 'MobileChannelHeaderButton' }),
                            channelMenuDropdown
                        )
                    )
                ),
                editChannelHeaderModal,
                editChannelPurposeModal,
                renameChannelModal,
                channelMembersModal,
                channelNotificationsModal,
                quickSwitchModal
            );
        }
    }]);
    return Navbar;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

Navbar.propTypes = {
    teamDisplayName: _propTypes2.default.string,
    isPinnedPosts: _propTypes2.default.bool,
    enableWebrtc: _propTypes2.default.bool.isRequired,
    actions: _propTypes2.default.shape({
        updateRhsState: _propTypes2.default.func,
        showPinnedPosts: _propTypes2.default.func,
        toggleLhs: _propTypes2.default.func.isRequired,
        closeLhs: _propTypes2.default.func.isRequired,
        closeRhs: _propTypes2.default.func.isRequired,
        toggleRhsMenu: _propTypes2.default.func.isRequired,
        closeRhsMenu: _propTypes2.default.func.isRequired
    })
};
Navbar.defaultProps = {
    teamDisplayName: ''
};
exports.default = Navbar;

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _channel_utils = __webpack_require__(830);

var _utils = __webpack_require__(762);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotifyCounts = function (_React$Component) {
    (0, _inherits3.default)(NotifyCounts, _React$Component);

    function NotifyCounts(props) {
        (0, _classCallCheck3.default)(this, NotifyCounts);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NotifyCounts.__proto__ || (0, _getPrototypeOf2.default)(NotifyCounts)).call(this, props));

        _this.onListenerChange = _this.onListenerChange.bind(_this);

        _this.state = (0, _channel_utils.getCountsStateFromStores)();
        _this.mounted = false;
        return _this;
    }

    (0, _createClass3.default)(NotifyCounts, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.mounted = true;
            _channel_store2.default.addChangeListener(this.onListenerChange);
            _team_store2.default.addChangeListener(this.onListenerChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.mounted = false;
            _channel_store2.default.removeChangeListener(this.onListenerChange);
            _team_store2.default.removeChangeListener(this.onListenerChange);
        }
    }, {
        key: 'onListenerChange',
        value: function onListenerChange() {
            if (this.mounted) {
                var newState = (0, _channel_utils.getCountsStateFromStores)();
                if (!utils.areObjectsEqual(newState, this.state)) {
                    this.setState(newState);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.mentionCount) {
                return _react2.default.createElement(
                    'span',
                    { className: 'badge badge-notify' },
                    this.state.mentionCount
                );
            } else if (this.state.messageCount) {
                return _react2.default.createElement(
                    'span',
                    { className: 'badge badge-notify' },
                    '•'
                );
            }
            return null;
        }
    }]);
    return NotifyCounts;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = NotifyCounts;

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _quick_switch_modal = __webpack_require__(2469);

var _quick_switch_modal2 = _interopRequireDefault(_quick_switch_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        showTeamSwitcher: false
    });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_quick_switch_modal2.default);

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _channels = __webpack_require__(783);

var _browser_history = __webpack_require__(273);

var _channel_actions = __webpack_require__(809);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _suggestion_box = __webpack_require__(929);

var _suggestion_box2 = _interopRequireDefault(_suggestion_box);

var _suggestion_list = __webpack_require__(930);

var _suggestion_list2 = _interopRequireDefault(_suggestion_list);

var _switch_channel_provider = __webpack_require__(2470);

var _switch_channel_provider2 = _interopRequireDefault(_switch_channel_provider);

var _switch_team_provider = __webpack_require__(2471);

var _switch_team_provider2 = _interopRequireDefault(_switch_team_provider);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getState = _redux_store2.default.getState; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANNEL_MODE = 'channel';
var TEAM_MODE = 'team';

var QuickSwitchModal = function (_React$PureComponent) {
    (0, _inherits3.default)(QuickSwitchModal, _React$PureComponent);

    function QuickSwitchModal(props) {
        (0, _classCallCheck3.default)(this, QuickSwitchModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (QuickSwitchModal.__proto__ || (0, _getPrototypeOf2.default)(QuickSwitchModal)).call(this, props));

        _this.setSwitchBoxRef = function (input) {
            _this.switchBox = input;
            _this.focusTextbox();
        };

        _this.handleOnClick = function (e) {
            e.preventDefault();
            var mode = e.currentTarget.getAttribute('data-mode');
            _this.enableChannelProvider();
            _this.setState({ mode: mode });
            _this.focusTextbox();
        };

        _this.onChange = _this.onChange.bind(_this);
        _this.onShow = _this.onShow.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        _this.onExited = _this.onExited.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.switchToChannel = _this.switchToChannel.bind(_this);
        _this.switchMode = _this.switchMode.bind(_this);
        _this.focusTextbox = _this.focusTextbox.bind(_this);

        _this.enableChannelProvider = _this.enableChannelProvider.bind(_this);
        _this.enableTeamProvider = _this.enableTeamProvider.bind(_this);
        _this.channelProviders = [new _switch_channel_provider2.default()];
        _this.teamProviders = [new _switch_team_provider2.default()];

        _this.switchBox = null;

        _this.state = {
            text: '',
            mode: props.initialMode
        };
        return _this;
    }

    (0, _createClass3.default)(QuickSwitchModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.show && nextProps.show) {
                this.setState({ mode: nextProps.initialMode, text: '' });
            }
        }
    }, {
        key: 'focusTextbox',
        value: function focusTextbox() {
            if (this.switchBox == null) {
                return;
            }

            var textbox = this.switchBox.getTextbox();
            if (document.activeElement !== textbox) {
                textbox.focus();
                Utils.placeCaretAtEnd(textbox);
            }
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            this.setState({
                text: ''
            });
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            this.setState({
                text: ''
            });
            this.props.onHide();
        }
    }, {
        key: 'onExited',
        value: function onExited() {
            if (!UserAgent.isMobile()) {
                setTimeout(function () {
                    var textbox = document.querySelector('#post_textbox');
                    if (textbox) {
                        textbox.focus();
                    }
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            this.setState({ text: e.target.value });
        }
    }, {
        key: 'handleKeyDown',
        value: function handleKeyDown(e) {
            if (Utils.isKeyPressed(e, _constants2.default.KeyCodes.TAB)) {
                e.preventDefault();
                this.switchMode();
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(selected) {
            var _this2 = this;

            var channel = null;

            if (!selected) {
                return;
            }

            if (this.state.mode === CHANNEL_MODE) {
                var selectedChannel = selected.channel;
                if (selectedChannel.type === _constants2.default.DM_CHANNEL) {
                    (0, _channel_actions.openDirectChannelToUser)(selectedChannel.id, function (ch) {
                        channel = ch;
                        _this2.switchToChannel(channel);
                    }, function () {
                        channel = null;
                        _this2.switchToChannel(channel);
                    });
                } else if (selectedChannel.type === _constants2.default.GM_CHANNEL) {
                    channel = (0, _channels.getChannel)(getState(), selectedChannel.id);
                    this.switchToChannel(channel);
                } else {
                    this.switchToChannel(selectedChannel);
                }
            } else {
                _browser_history.browserHistory.push('/' + selected.name);
                this.onHide();
            }
        }
    }, {
        key: 'switchToChannel',
        value: function switchToChannel(channel) {
            if (channel != null) {
                (0, _channel_actions.goToChannel)(channel);
                this.onHide();
            }
        }
    }, {
        key: 'enableChannelProvider',
        value: function enableChannelProvider() {
            this.channelProviders[0].disableDispatches = false;
            this.teamProviders[0].disableDispatches = true;
        }
    }, {
        key: 'enableTeamProvider',
        value: function enableTeamProvider() {
            this.teamProviders[0].disableDispatches = false;
            this.channelProviders[0].disableDispatches = true;
        }
    }, {
        key: 'switchMode',
        value: function switchMode() {
            if (this.state.mode === CHANNEL_MODE && this.props.showTeamSwitcher) {
                this.enableTeamProvider();
                this.setState({ mode: TEAM_MODE });
            } else if (this.state.mode === TEAM_MODE) {
                this.enableChannelProvider();
                this.setState({ mode: CHANNEL_MODE });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var providers = this.channelProviders;
            var header = void 0;
            var renderDividers = true;

            var channelShortcut = 'quick_switch_modal.channelsShortcut.windows';
            var defaultChannelShortcut = 'CTRL+K';
            if (Utils.isMac()) {
                channelShortcut = 'quick_switch_modal.channelsShortcut.mac';
                defaultChannelShortcut = 'CMD+K';
            }

            var teamShortcut = 'quick_switch_modal.teamsShortcut.windows';
            var defaultTeamShortcut = 'CTRL+ALT+K';
            if (Utils.isMac()) {
                teamShortcut = 'quick_switch_modal.teamsShortcut.mac';
                defaultTeamShortcut = 'CMD+ALT+K';
            }

            if (this.props.showTeamSwitcher) {
                var channelsActiveClass = '';
                var teamsActiveClass = '';
                if (this.state.mode === TEAM_MODE) {
                    providers = this.teamProviders;
                    renderDividers = false;
                    teamsActiveClass = 'active';
                } else {
                    channelsActiveClass = 'active';
                }

                header = _react2.default.createElement(
                    'div',
                    { className: 'nav nav-tabs' },
                    _react2.default.createElement(
                        'li',
                        { className: channelsActiveClass },
                        _react2.default.createElement(
                            'a',
                            {
                                'data-mode': 'channel',
                                href: '#',
                                onClick: this.handleOnClick
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'quick_switch_modal.channels',
                                defaultMessage: 'Channels'
                            }),
                            _react2.default.createElement(
                                'span',
                                { className: 'small' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: channelShortcut,
                                    defaultMessage: defaultChannelShortcut
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: teamsActiveClass },
                        _react2.default.createElement(
                            'a',
                            {
                                'data-mode': 'team',
                                href: '#',
                                onClick: this.handleOnClick
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'quick_switch_modal.teams',
                                defaultMessage: 'Teams'
                            }),
                            _react2.default.createElement(
                                'span',
                                { className: 'small' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: teamShortcut,
                                    defaultMessage: defaultTeamShortcut
                                })
                            )
                        )
                    )
                );
            }

            var help = void 0;
            if (Utils.isMobile()) {
                help = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'quick_switch_modal.help_mobile',
                    defaultMessage: 'Type to find a channel.'
                });
            } else if (this.props.showTeamSwitcher) {
                help = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'quick_switch_modal.help',
                    defaultMessage: 'Start typing then use TAB to toggle channels/teams, \u2191\u2193 to browse, \u21B5 to select, and ESC to dismiss.'
                });
            } else {
                help = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'quick_switch_modal.help_no_team',
                    defaultMessage: 'Type to find a channel. Use \u2191\u2193 to browse, \u21B5 to select, ESC to dismiss.'
                });
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: 'channel-switch-modal modal--overflow',
                    ref: 'modal',
                    show: this.props.show,
                    onHide: this.onHide,
                    onExited: this.onExited
                },
                _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    header,
                    _react2.default.createElement(
                        'div',
                        { className: 'modal__hint' },
                        help
                    ),
                    _react2.default.createElement(_suggestion_box2.default, {
                        ref: this.setSwitchBoxRef,
                        className: 'form-control focused',
                        onChange: this.onChange,
                        value: this.state.text,
                        onKeyDown: this.handleKeyDown,
                        onItemSelected: this.handleSubmit,
                        listComponent: _suggestion_list2.default,
                        maxLength: '64',
                        providers: providers,
                        listStyle: 'bottom',
                        completeOnTab: false,
                        renderDividers: renderDividers,
                        delayInputUpdate: true,
                        openWhenEmpty: true
                    })
                )
            );
        }
    }]);
    return QuickSwitchModal;
}(_react2.default.PureComponent);

QuickSwitchModal.propTypes = {

    /**
     * The mode to start in when showing the modal, either 'channel' or 'team'
     */
    initialMode: _propTypes2.default.string.isRequired,

    /**
     * Set to show the modal
     */
    show: _propTypes2.default.bool.isRequired,

    /**
     * The function called to hide the modal
     */
    onHide: _propTypes2.default.func.isRequired,

    /**
     * Set to show team switcher
     */
    showTeamSwitcher: _propTypes2.default.bool
};
QuickSwitchModal.defaultProps = {
    initialMode: CHANNEL_MODE
};
exports.default = QuickSwitchModal;

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _channels = __webpack_require__(783);

var _common = __webpack_require__(280);

var _preferences = __webpack_require__(784);

var _general = __webpack_require__(113);

var _teams = __webpack_require__(274);

var _users = __webpack_require__(777);

var _globe_icon = __webpack_require__(1086);

var _globe_icon2 = _interopRequireDefault(_globe_icon);

var _lock_icon = __webpack_require__(1087);

var _lock_icon2 = _interopRequireDefault(_lock_icon);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _channel_utils = __webpack_require__(830);

var _constants2 = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _provider = __webpack_require__(866);

var _provider2 = _interopRequireDefault(_provider);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

var SwitchChannelSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(SwitchChannelSuggestion, _Suggestion);

    function SwitchChannelSuggestion() {
        (0, _classCallCheck3.default)(this, SwitchChannelSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (SwitchChannelSuggestion.__proto__ || (0, _getPrototypeOf2.default)(SwitchChannelSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(SwitchChannelSuggestion, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                isSelection = _props.isSelection;

            var channel = item.channel;

            var member = (0, _common.getMyChannelMemberships)(getState())[item.id];
            var badge = null;
            if (member) {
                if (member.notify_props && member.mention_count > 0) {
                    badge = _react2.default.createElement(
                        'span',
                        { className: 'badge' },
                        member.mention_count
                    );
                }
            }

            var className = 'mentions__name';
            if (isSelection) {
                className += ' suggestion--selected';
            }

            var displayName = channel.display_name;
            var icon = null;
            if (channel.type === _constants2.Constants.OPEN_CHANNEL) {
                icon = _react2.default.createElement(_globe_icon2.default, { className: 'icon icon__globe icon--body' });
            } else if (channel.type === _constants2.Constants.PRIVATE_CHANNEL) {
                icon = _react2.default.createElement(_lock_icon2.default, { className: 'icon icon__lock icon--body' });
            } else if (channel.type === _constants2.Constants.GM_CHANNEL) {
                displayName = (0, _channel_utils.getChannelDisplayName)(channel);
                icon = _react2.default.createElement(
                    'div',
                    { className: 'status status--group' },
                    'G'
                );
            } else {
                icon = _react2.default.createElement(
                    'div',
                    { className: 'pull-left' },
                    _react2.default.createElement('img', {
                        className: 'mention__image',
                        src: Utils.imageURLForUser(channel)
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    onClick: this.handleClick,
                    className: className
                },
                icon,
                displayName,
                badge
            );
        }
    }]);
    return SwitchChannelSuggestion;
}(_suggestion2.default);

var prefix = '';

function quickSwitchSorter(wrappedA, wrappedB) {
    if (wrappedA.type === _constants2.Constants.MENTION_CHANNELS && wrappedB.type === _constants2.Constants.MENTION_MORE_CHANNELS) {
        return -1;
    } else if (wrappedB.type === _constants2.Constants.MENTION_CHANNELS && wrappedA.type === _constants2.Constants.MENTION_MORE_CHANNELS) {
        return 1;
    }

    if (wrappedA.deactivated && !wrappedB.deactivated) {
        return 1;
    } else if (wrappedB.deactivated && !wrappedA.deactivated) {
        return -1;
    }

    var a = wrappedA.channel;
    var b = wrappedB.channel;

    var aDisplayName = (0, _channel_utils.getChannelDisplayName)(a).toLowerCase();
    var bDisplayName = (0, _channel_utils.getChannelDisplayName)(b).toLowerCase();

    if (a.type === _constants2.Constants.DM_CHANNEL) {
        aDisplayName = aDisplayName.substring(1);
    }

    if (b.type === _constants2.Constants.DM_CHANNEL) {
        bDisplayName = bDisplayName.substring(1);
    }

    var aStartsWith = aDisplayName.startsWith(prefix);
    var bStartsWith = bDisplayName.startsWith(prefix);
    if (aStartsWith && bStartsWith) {
        return (0, _channel_utils.sortChannelsByDisplayName)(a, b);
    } else if (!aStartsWith && !bStartsWith) {
        return (0, _channel_utils.sortChannelsByDisplayName)(a, b);
    } else if (aStartsWith) {
        return -1;
    }

    return 1;
}

function makeChannelSearchFilter(channelPrefix) {
    var channelPrefixLower = channelPrefix.toLowerCase();
    var curState = getState();
    var usersInChannels = (0, _users.getUserIdsInChannels)(curState);
    var userSearchStrings = {};

    return function (channel) {
        var searchString = channel.display_name;

        if (channel.type === _constants2.Constants.GM_CHANNEL || channel.type === _constants2.Constants.DM_CHANNEL) {
            var usersInChannel = usersInChannels[channel.id] || [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(usersInChannel), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var userId = _step.value;

                    var userString = userSearchStrings[userId];

                    if (!userString) {
                        var user = (0, _users.getUser)(curState, userId);
                        if (!user) {
                            continue;
                        }
                        var nickname = user.nickname,
                            username = user.username;

                        userString = '' + nickname + username + Utils.getFullName(user);
                        userSearchStrings[userId] = userString;
                    }
                    searchString += userString;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        return searchString.toLowerCase().includes(channelPrefixLower);
    };
}

var SwitchChannelProvider = function (_Provider) {
    (0, _inherits3.default)(SwitchChannelProvider, _Provider);

    function SwitchChannelProvider() {
        (0, _classCallCheck3.default)(this, SwitchChannelProvider);
        return (0, _possibleConstructorReturn3.default)(this, (SwitchChannelProvider.__proto__ || (0, _getPrototypeOf2.default)(SwitchChannelProvider)).apply(this, arguments));
    }

    (0, _createClass3.default)(SwitchChannelProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, channelPrefix) {
            if (channelPrefix) {
                prefix = channelPrefix;
                this.startNewRequest(suggestionId, channelPrefix);

                // Dispatch suggestions for local data
                var channels = (0, _channels.getChannelsInCurrentTeam)(getState()).concat((0, _channels.getGroupChannels)(getState()));
                var users = (0, _assign2.default)([], (0, _users.searchProfiles)(getState(), channelPrefix, false));
                this.formatChannelsAndDispatch(channelPrefix, suggestionId, channels, users, true);

                // Fetch data from the server and dispatch
                this.fetchUsersAndChannels(channelPrefix, suggestionId);
            } else {
                this.formatUnreadChannelsAndDispatch(suggestionId);
            }

            return true;
        }
    }, {
        key: 'fetchUsersAndChannels',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(channelPrefix, suggestionId) {
                var state, teamId, config, usersAsync, channelsAsync, usersFromServer, channelsFromServer, users, channels;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                state = getState();
                                teamId = (0, _teams.getCurrentTeamId)(state);

                                if (teamId) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 4:
                                config = (0, _general.getConfig)(state);
                                usersAsync = void 0;

                                if (config.RestrictDirectMessage === 'team') {
                                    usersAsync = _client.Client4.autocompleteUsers(channelPrefix, teamId, '');
                                } else {
                                    usersAsync = _client.Client4.autocompleteUsers(channelPrefix, '', '');
                                }

                                channelsAsync = _client.Client4.searchChannels(teamId, channelPrefix);
                                usersFromServer = [];
                                channelsFromServer = [];
                                _context.prev = 10;
                                _context.next = 13;
                                return usersAsync;

                            case 13:
                                usersFromServer = _context.sent;
                                _context.next = 16;
                                return channelsAsync;

                            case 16:
                                channelsFromServer = _context.sent;
                                _context.next = 22;
                                break;

                            case 19:
                                _context.prev = 19;
                                _context.t0 = _context['catch'](10);

                                _app_dispatcher2.default.handleServerAction({
                                    type: _constants2.ActionTypes.RECEIVED_ERROR,
                                    err: _context.t0
                                });

                            case 22:
                                if (!this.shouldCancelDispatch(channelPrefix)) {
                                    _context.next = 24;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 24:
                                users = (0, _assign2.default)([], (0, _users.searchProfiles)(state, channelPrefix, false)).concat(usersFromServer.users);
                                channels = (0, _channels.getChannelsInCurrentTeam)(state).concat((0, _channels.getGroupChannels)(state)).concat(channelsFromServer);

                                this.formatChannelsAndDispatch(channelPrefix, suggestionId, channels, users);

                            case 27:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[10, 19]]);
            }));

            function fetchUsersAndChannels(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return fetchUsersAndChannels;
        }()
    }, {
        key: 'userWrappedChannel',
        value: function userWrappedChannel(user) {
            var displayName = '@' + user.username;

            if ((user.first_name || user.last_name) && user.nickname) {
                displayName += ' - ' + Utils.getFullName(user) + ' (' + user.nickname + ')';
            } else if (user.nickname) {
                displayName += ' - (' + user.nickname + ')';
            } else if (user.first_name || user.last_name) {
                displayName += ' - ' + Utils.getFullName(user);
            }

            if (user.delete_at) {
                displayName += ' - ' + Utils.localizeMessage('channel_switch_modal.deactivated', 'Deactivated');
            }

            return {
                channel: {
                    display_name: displayName,
                    name: user.username,
                    id: user.id,
                    update_at: user.update_at,
                    type: _constants2.Constants.DM_CHANNEL,
                    last_picture_update: user.last_picture_update || 0
                },
                name: user.username,
                deactivated: user.delete_at
            };
        }
    }, {
        key: 'formatChannelsAndDispatch',
        value: function formatChannelsAndDispatch(channelPrefix, suggestionId, allChannels, users) {
            var skipNotInChannel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            var channels = [];

            var members = (0, _common.getMyChannelMemberships)(getState());

            if (this.shouldCancelDispatch(channelPrefix)) {
                return;
            }

            var completedChannels = {};

            var channelFilter = makeChannelSearchFilter(channelPrefix);

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(allChannels)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var id = _step2.value;

                    var channel = allChannels[id];

                    if (completedChannels[channel.id]) {
                        continue;
                    }

                    if (channelFilter(channel)) {
                        var newChannel = (0, _assign2.default)({}, channel);
                        var _wrappedChannel = { channel: newChannel, name: newChannel.name, deactivated: false };
                        if (newChannel.type === _constants2.Constants.GM_CHANNEL) {
                            newChannel.name = (0, _channel_utils.getChannelDisplayName)(newChannel);
                            _wrappedChannel.name = newChannel.name;
                            var isGMVisible = (0, _preferences.getBool)(getState(), _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, newChannel.id, false);
                            if (isGMVisible) {
                                _wrappedChannel.type = _constants2.Constants.MENTION_CHANNELS;
                            } else {
                                _wrappedChannel.type = _constants2.Constants.MENTION_MORE_CHANNELS;
                                if (skipNotInChannel) {
                                    continue;
                                }
                            }
                        } else if (members[channel.id]) {
                            _wrappedChannel.type = _constants2.Constants.MENTION_CHANNELS;
                        } else {
                            _wrappedChannel.type = _constants2.Constants.MENTION_MORE_CHANNELS;
                            if (skipNotInChannel || !newChannel.display_name.toLowerCase().startsWith(channelPrefix)) {
                                continue;
                            }
                        }

                        completedChannels[channel.id] = true;
                        channels.push(_wrappedChannel);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            for (var i = 0; i < users.length; i++) {
                var user = users[i];

                if (completedChannels[user.id]) {
                    continue;
                }

                var isDMVisible = (0, _preferences.getBool)(getState(), _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, user.id, false);

                var wrappedChannel = this.userWrappedChannel(user);

                if (isDMVisible) {
                    wrappedChannel.type = _constants2.Constants.MENTION_CHANNELS;
                } else {
                    wrappedChannel.type = _constants2.Constants.MENTION_MORE_CHANNELS;
                    if (skipNotInChannel) {
                        continue;
                    }
                }

                completedChannels[user.id] = true;
                channels.push(wrappedChannel);
            }

            var channelNames = channels.sort(quickSwitchSorter).map(function (wrappedChannel) {
                return wrappedChannel.channel.name;
            });

            if (skipNotInChannel) {
                channels.push({
                    type: _constants2.Constants.MENTION_MORE_CHANNELS,
                    loading: true
                });
            }

            setTimeout(function () {
                _app_dispatcher2.default.handleServerAction({
                    type: _constants2.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                    id: suggestionId,
                    matchedPretext: channelPrefix,
                    terms: channelNames,
                    items: channels,
                    component: SwitchChannelSuggestion
                });
            }, 0);
        }
    }, {
        key: 'formatUnreadChannelsAndDispatch',
        value: function formatUnreadChannelsAndDispatch(suggestionId) {
            var getChannel = (0, _channels.makeGetChannel)();

            var unreadChannelIds = (0, _channels.getSortedUnreadChannelIds)(getState(), false);

            var channels = [];
            for (var i = 0; i < unreadChannelIds.length; i++) {
                var channel = getChannel(getState(), { id: unreadChannelIds[i] }) || {};

                var wrappedChannel = { channel: channel, name: channel.name, deactivated: false };
                if (channel.type === _constants2.Constants.GM_CHANNEL) {
                    wrappedChannel.name = (0, _channel_utils.getChannelDisplayName)(channel);
                } else if (channel.type === _constants2.Constants.DM_CHANNEL) {
                    wrappedChannel = this.userWrappedChannel((0, _users.getUser)(getState(), Utils.getUserIdFromChannelId(channel.name)));
                }
                wrappedChannel.type = _constants2.Constants.MENTION_UNREAD_CHANNELS;
                wrappedChannel.id = channel.id;
                channels.push(wrappedChannel);
            }

            var channelNames = channels.map(function (wrappedChannel) {
                return wrappedChannel.channel.name;
            });

            setTimeout(function () {
                _app_dispatcher2.default.handleServerAction({
                    type: _constants2.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                    id: suggestionId,
                    matchedPretext: '',
                    terms: channelNames,
                    items: channels,
                    component: SwitchChannelSuggestion
                });
            }, 0);
        }
    }]);
    return SwitchChannelProvider;
}(_provider2.default);

exports.default = SwitchChannelProvider;

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _teams = __webpack_require__(274);

var Selectors = _interopRequireWildcard(_teams);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _localization_store = __webpack_require__(906);

var _localization_store2 = _interopRequireDefault(_localization_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants = __webpack_require__(29);

var _provider = __webpack_require__(866);

var _provider2 = _interopRequireDefault(_provider);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

var SwitchTeamSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(SwitchTeamSuggestion, _Suggestion);

    function SwitchTeamSuggestion() {
        (0, _classCallCheck3.default)(this, SwitchTeamSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (SwitchTeamSuggestion.__proto__ || (0, _getPrototypeOf2.default)(SwitchTeamSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(SwitchTeamSuggestion, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                isSelection = _props.isSelection;


            var className = 'mentions__name';
            if (isSelection) {
                className += ' suggestion--selected';
            }

            return _react2.default.createElement(
                'div',
                {
                    onClick: this.handleClick,
                    className: className
                },
                _react2.default.createElement(
                    'div',
                    { className: 'status' },
                    _react2.default.createElement('i', { className: 'fa fa-group' })
                ),
                item.display_name
            );
        }
    }]);
    return SwitchTeamSuggestion;
}(_suggestion2.default);

var prefix = '';

function quickSwitchSorter(a, b) {
    var aDisplayName = a.display_name.toLowerCase();
    var bDisplayName = b.display_name.toLowerCase();
    var aStartsWith = aDisplayName.startsWith(prefix);
    var bStartsWith = bDisplayName.startsWith(prefix);

    if (aStartsWith && bStartsWith) {
        var locale = _localization_store2.default.getLocale();

        if (aDisplayName !== bDisplayName) {
            return aDisplayName.localeCompare(bDisplayName, locale, { numeric: true });
        }

        return a.name.localeCompare(b.name, locale, { numeric: true });
    } else if (aStartsWith) {
        return -1;
    }

    return 1;
}

var SwitchTeamProvider = function (_Provider) {
    (0, _inherits3.default)(SwitchTeamProvider, _Provider);

    function SwitchTeamProvider() {
        (0, _classCallCheck3.default)(this, SwitchTeamProvider);
        return (0, _possibleConstructorReturn3.default)(this, (SwitchTeamProvider.__proto__ || (0, _getPrototypeOf2.default)(SwitchTeamProvider)).apply(this, arguments));
    }

    (0, _createClass3.default)(SwitchTeamProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, teamPrefix) {
            if (teamPrefix) {
                prefix = teamPrefix;
                this.startNewRequest(suggestionId, teamPrefix);

                var allTeams = Selectors.getMyTeams(getState());

                var teams = allTeams.filter(function (team) {
                    return team.display_name.toLowerCase().indexOf(teamPrefix) !== -1 || team.name.indexOf(teamPrefix) !== -1;
                });

                var teamNames = teams.sort(quickSwitchSorter).map(function (team) {
                    return team.name;
                });

                setTimeout(function () {
                    _app_dispatcher2.default.handleServerAction({
                        type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                        id: suggestionId,
                        matchedPretext: teamPrefix,
                        terms: teamNames,
                        items: teams,
                        component: SwitchTeamSuggestion
                    });
                }, 0);

                return true;
            }

            return false;
        }
    }]);
    return SwitchTeamProvider;
}(_provider2.default);

exports.default = SwitchTeamProvider;

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _message_wrapper = __webpack_require__(1412);

var _message_wrapper2 = _interopRequireDefault(_message_wrapper);

var _info_icon = __webpack_require__(2473);

var _info_icon2 = _interopRequireDefault(_info_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var NavbarInfoButton = function (_React$PureComponent) {
    (0, _inherits3.default)(NavbarInfoButton, _React$PureComponent);

    function NavbarInfoButton() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, NavbarInfoButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NavbarInfoButton.__proto__ || (0, _getPrototypeOf2.default)(NavbarInfoButton)).call.apply(_ref, [this].concat(args))), _this), _this.showEditChannelHeaderModal = function () {
            _this.refs.headerOverlay.hide();

            _this.props.showEditChannelHeaderModal();
        }, _this.hide = function () {
            _this.refs.headerOverlay.hide();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(NavbarInfoButton, [{
        key: 'render',
        value: function render() {
            var popoverContent = null;
            if (this.props.channel) {
                if (this.props.channel.header) {
                    popoverContent = _react2.default.createElement(_message_wrapper2.default, {
                        message: this.props.channel.header,
                        options: { singleline: true, mentionHighlight: false }
                    });
                } else {
                    var link = _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            onClick: this.showEditChannelHeaderModal
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar.click',
                            defaultMessage: 'Click here'
                        })
                    );

                    popoverContent = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navbar.noHeader',
                            defaultMessage: 'No channel header yet.{newline}{link} to add one.',
                            values: {
                                newline: _react2.default.createElement('br', null),
                                link: link
                            }
                        })
                    );
                }
            }

            var popover = _react2.default.createElement(
                _reactBootstrap.Popover,
                {
                    bsStyle: 'info',
                    placement: 'bottom',
                    id: 'header-popover'
                },
                popoverContent,
                _react2.default.createElement(
                    'div',
                    {
                        className: 'close visible-xs-block',
                        onClick: this.hide
                    },
                    '×'
                )
            );

            return _react2.default.createElement(
                _reactBootstrap.OverlayTrigger,
                {
                    ref: 'headerOverlay',
                    trigger: 'click',
                    placement: 'bottom',
                    overlay: popover,
                    className: 'description',
                    rootClose: true
                },
                _react2.default.createElement(
                    'div',
                    { className: 'navbar-toggle navbar-right__icon navbar-info-button pull-right' },
                    _react2.default.createElement(_info_icon2.default, {
                        className: 'icon icon__info',
                        'aria-hidden': 'true'
                    })
                )
            );
        }
    }]);
    return NavbarInfoButton;
}(_react2.default.PureComponent);

NavbarInfoButton.propTypes = {
    channel: _propTypes2.default.object,
    showEditChannelHeaderModal: _propTypes2.default.func.isRequired
};
exports.default = NavbarInfoButton;

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoIcon = function (_React$PureComponent) {
    (0, _inherits3.default)(InfoIcon, _React$PureComponent);

    function InfoIcon() {
        (0, _classCallCheck3.default)(this, InfoIcon);
        return (0, _possibleConstructorReturn3.default)(this, (InfoIcon.__proto__ || (0, _getPrototypeOf2.default)(InfoIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(InfoIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                this.props,
                _react2.default.createElement(
                    'svg',
                    {
                        width: '22px',
                        height: '22px',
                        viewBox: '0 0 22 22'
                    },
                    _react2.default.createElement(
                        'g',
                        {
                            stroke: 'none',
                            strokeWidth: '1',
                            fill: 'inherit',
                            fillRule: 'evenodd'
                        },
                        _react2.default.createElement(
                            'g',
                            {
                                transform: 'translate(-388.000000, -18.000000)',
                                fill: 'inherit'
                            },
                            _react2.default.createElement(
                                'g',
                                null,
                                _react2.default.createElement(
                                    'g',
                                    { transform: 'translate(381.000000, 11.000000)' },
                                    _react2.default.createElement(
                                        'g',
                                        { transform: 'translate(7.000000, 7.000000)' },
                                        _react2.default.createElement('path', { d: 'M11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 Z M11,20.7924685 C16.408231,20.7924685 20.7924685,16.408231 20.7924685,11 C20.7924685,5.59176898 16.408231,1.20753149 11,1.20753149 C5.59176898,1.20753149 1.20753149,5.59176898 1.20753149,11 C1.20753149,16.408231 5.59176898,20.7924685 11,20.7924685 Z M10.1572266,16.0625 L10.1572266,8.69335938 L11.3466797,8.69335938 L11.3466797,16.0625 L10.1572266,16.0625 Z M10.7519531,7.50390625 C10.3417969,7.50390625 10,7.16210938 10,6.75195312 C10,6.33496094 10.3417969,6 10.7519531,6 C11.1689453,6 11.5039062,6.33496094 11.5039062,6.75195312 C11.5039062,7.16210938 11.1689453,7.50390625 10.7519531,7.50390625 Z' })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return InfoIcon;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = InfoIcon;

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var goToChannelByChannelId = function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(match, history) {
        var _match$params2, team, identifier, channelId, channel, _ref3, data, error;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _match$params2 = match.params, team = _match$params2.team, identifier = _match$params2.identifier;
                        channelId = identifier.toLowerCase();
                        channel = _channel_store2.default.get(channelId);

                        if (channel) {
                            _context.next = 13;
                            break;
                        }

                        _context.next = 6;
                        return (0, _channels.joinChannel)(_user_store2.default.getCurrentId(), _team_store2.default.getCurrentId(), channelId, null)(dispatch, getState);

                    case 6:
                        _ref3 = _context.sent;
                        data = _ref3.data;
                        error = _ref3.error;

                        if (!error) {
                            _context.next = 12;
                            break;
                        }

                        handleError(match, history);
                        return _context.abrupt('return');

                    case 12:
                        channel = data.channel;

                    case 13:

                        if (channel.type === _constants.Constants.DM_CHANNEL) {
                            goToDirectChannelByUserId(match, history, Utils.getUserIdFromChannelId(channel.name));
                        } else if (channel.type === _constants.Constants.GM_CHANNEL) {
                            history.replace('/' + team + '/messages/' + channel.name);
                        } else {
                            history.replace('/' + team + '/channels/' + channel.name);
                        }

                    case 14:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function goToChannelByChannelId(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

var goToChannelByChannelName = function () {
    var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(match, history) {
        var _match$params3, team, identifier, channelName, channel, _ref5, data, error;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _match$params3 = match.params, team = _match$params3.team, identifier = _match$params3.identifier;
                        channelName = identifier.toLowerCase();
                        channel = _channel_store2.default.getByName(channelName);

                        if (channel) {
                            _context2.next = 13;
                            break;
                        }

                        _context2.next = 6;
                        return (0, _channels.joinChannel)(_user_store2.default.getCurrentId(), _team_store2.default.getCurrentId(), null, channelName)(dispatch, getState);

                    case 6:
                        _ref5 = _context2.sent;
                        data = _ref5.data;
                        error = _ref5.error;

                        if (!error) {
                            _context2.next = 12;
                            break;
                        }

                        handleError(match, history);
                        return _context2.abrupt('return');

                    case 12:
                        channel = data.channel;

                    case 13:

                        if (channel.type === _constants.Constants.DM_CHANNEL) {
                            goToDirectChannelByUserIds(match, history);
                        } else if (channel.type === _constants.Constants.GM_CHANNEL) {
                            history.replace('/' + team + '/messages/' + channel.name);
                        } else {
                            doChannelChange(channel);
                        }

                    case 14:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function goToChannelByChannelName(_x3, _x4) {
        return _ref4.apply(this, arguments);
    };
}();

var goToDirectChannelByUsername = function () {
    var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(match, history) {
        var identifier, username, user, _ref7, data, error;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        identifier = match.params.identifier;
                        username = identifier.slice(1, identifier.length).toLowerCase();
                        user = _user_store2.default.getProfileByUsername(username);

                        if (user) {
                            _context3.next = 13;
                            break;
                        }

                        _context3.next = 6;
                        return (0, _users.getUserByUsername)(username)(dispatch, getState);

                    case 6:
                        _ref7 = _context3.sent;
                        data = _ref7.data;
                        error = _ref7.error;

                        if (!error) {
                            _context3.next = 12;
                            break;
                        }

                        handleError(match, history);
                        return _context3.abrupt('return');

                    case 12:
                        user = data;

                    case 13:

                        (0, _channel_actions.openDirectChannelToUser)(user.id, function (channel) {
                            doChannelChange(channel);
                        }, function () {
                            return handleError(match, history);
                        });

                    case 14:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function goToDirectChannelByUsername(_x5, _x6) {
        return _ref6.apply(this, arguments);
    };
}();

var goToDirectChannelByUserId = function () {
    var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(match, history, userId) {
        var team, user, _ref9, data, error;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        team = match.params.team;
                        user = _user_store2.default.getProfile(userId);

                        if (user) {
                            _context4.next = 12;
                            break;
                        }

                        _context4.next = 5;
                        return (0, _users.getUser)(userId)(dispatch, getState);

                    case 5:
                        _ref9 = _context4.sent;
                        data = _ref9.data;
                        error = _ref9.error;

                        if (!error) {
                            _context4.next = 11;
                            break;
                        }

                        handleError(match, history);
                        return _context4.abrupt('return');

                    case 11:
                        user = data;

                    case 12:

                        history.replace('/' + team + '/messages/@' + user.username);

                    case 13:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function goToDirectChannelByUserId(_x7, _x8, _x9) {
        return _ref8.apply(this, arguments);
    };
}();

var goToDirectChannelByUserIds = function () {
    var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(match, history) {
        var _match$params4, team, identifier, userId, user, _ref11, data, error;

        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _match$params4 = match.params, team = _match$params4.team, identifier = _match$params4.identifier;
                        userId = Utils.getUserIdFromChannelId(identifier.toLowerCase());
                        user = _user_store2.default.getProfile(userId);

                        if (user) {
                            _context5.next = 13;
                            break;
                        }

                        _context5.next = 6;
                        return (0, _users.getUser)(userId)(dispatch, getState);

                    case 6:
                        _ref11 = _context5.sent;
                        data = _ref11.data;
                        error = _ref11.error;

                        if (!error) {
                            _context5.next = 12;
                            break;
                        }

                        handleError(match, history);
                        return _context5.abrupt('return');

                    case 12:
                        user = data;

                    case 13:

                        history.replace('/' + team + '/messages/@' + user.username);

                    case 14:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function goToDirectChannelByUserIds(_x10, _x11) {
        return _ref10.apply(this, arguments);
    };
}();

var goToDirectChannelByEmail = function () {
    var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(match, history) {
        var _match$params5, team, identifier, email, user, _ref13, data, error;

        return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _match$params5 = match.params, team = _match$params5.team, identifier = _match$params5.identifier;
                        email = identifier.toLowerCase();
                        user = _user_store2.default.getProfileByEmail(email);

                        if (user) {
                            _context6.next = 13;
                            break;
                        }

                        _context6.next = 6;
                        return (0, _users.getUserByEmail)(email)(dispatch, getState);

                    case 6:
                        _ref13 = _context6.sent;
                        data = _ref13.data;
                        error = _ref13.error;

                        if (!error) {
                            _context6.next = 12;
                            break;
                        }

                        handleError(match, history);
                        return _context6.abrupt('return');

                    case 12:
                        user = data;

                    case 13:

                        history.replace('/' + team + '/messages/@' + user.username);

                    case 14:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function goToDirectChannelByEmail(_x12, _x13) {
        return _ref12.apply(this, arguments);
    };
}();

var goToGroupChannelByGroupId = function () {
    var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(match, history) {
        var identifier, groupId, channel, _ref15, data, error;

        return _regenerator2.default.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        identifier = match.params.identifier;
                        groupId = identifier.toLowerCase();


                        history.replace(match.url.replace('/channels/', '/messages/'));

                        channel = _channel_store2.default.getByName(groupId);

                        if (channel) {
                            _context7.next = 14;
                            break;
                        }

                        _context7.next = 7;
                        return (0, _channels.joinChannel)(_user_store2.default.getCurrentId(), _team_store2.default.getCurrentId(), null, groupId)(dispatch, getState);

                    case 7:
                        _ref15 = _context7.sent;
                        data = _ref15.data;
                        error = _ref15.error;

                        if (!error) {
                            _context7.next = 13;
                            break;
                        }

                        handleError(match, history);
                        return _context7.abrupt('return');

                    case 13:
                        channel = data.channel;

                    case 14:

                        doChannelChange(channel);

                    case 15:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function goToGroupChannelByGroupId(_x14, _x15) {
        return _ref14.apply(this, arguments);
    };
}();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _channels = __webpack_require__(798);

var _users = __webpack_require__(786);

var _index = __webpack_require__(2475);

var _index2 = _interopRequireDefault(_index);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _constants = __webpack_require__(29);

var _channel_actions = __webpack_require__(809);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

var LENGTH_OF_ID = 26;
var LENGTH_OF_GROUP_ID = 40;
var LENGTH_OF_USER_ID_PAIR = 54;

function onChannelByIdentifierEnter(_ref) {
    var match = _ref.match,
        history = _ref.history;
    var _match$params = match.params,
        path = _match$params.path,
        identifier = _match$params.identifier;


    if (path === 'channels') {
        if (identifier.length === LENGTH_OF_ID) {
            // It's hard to tell an ID apart from a channel name of the same length, so check first if
            // the identifier matches a channel that we have
            if (_channel_store2.default.getByName(identifier)) {
                goToChannelByChannelName(match, history);
            } else {
                goToChannelByChannelId(match, history);
            }
        } else if (identifier.length === LENGTH_OF_GROUP_ID) {
            goToGroupChannelByGroupId(match, history);
        } else if (identifier.length === LENGTH_OF_USER_ID_PAIR) {
            goToDirectChannelByUserIds(match, history);
        } else {
            goToChannelByChannelName(match, history);
        }
    } else if (path === 'messages') {
        if (identifier.indexOf('@') === 0) {
            goToDirectChannelByUsername(match, history);
        } else if (identifier.indexOf('@') > 0) {
            goToDirectChannelByEmail(match, history);
        } else if (identifier.length === LENGTH_OF_ID) {
            goToDirectChannelByUserId(match, history, identifier);
        } else if (identifier.length === LENGTH_OF_GROUP_ID) {
            goToGroupChannelByGroupId(match, history);
        } else {
            handleError(match, history);
        }
    }
}

function doChannelChange(channel) {
    GlobalActions.emitChannelClickEvent(channel);
}

function handleError(match, history) {
    var team = match.params.team;

    history.push(team ? '/' + team + '/channels/' + _constants.Constants.DEFAULT_CHANNEL : '/');
}

var ChannelIdentifierRouter = function (_React$PureComponent) {
    (0, _inherits3.default)(ChannelIdentifierRouter, _React$PureComponent);

    function ChannelIdentifierRouter(props) {
        (0, _classCallCheck3.default)(this, ChannelIdentifierRouter);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelIdentifierRouter.__proto__ || (0, _getPrototypeOf2.default)(ChannelIdentifierRouter)).call(this, props));

        onChannelByIdentifierEnter(props);
        return _this;
    }

    (0, _createClass3.default)(ChannelIdentifierRouter, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.match.params.identifier !== nextProps.match.params.identifier) {
                onChannelByIdentifierEnter(nextProps);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_index2.default, null);
        }
    }]);
    return ChannelIdentifierRouter;
}(_react2.default.PureComponent);

ChannelIdentifierRouter.propTypes = {

    /*
     * Object from react-router
     */
    match: _propTypes2.default.shape({
        params: _propTypes2.default.shape({
            identifier: _propTypes2.default.string.isRequired
        }).isRequired
    }).isRequired
};
exports.default = ChannelIdentifierRouter;

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _reselect = __webpack_require__(78);

var _preferences = __webpack_require__(784);

var _users = __webpack_require__(777);

var _general = __webpack_require__(113);

var _reactRouterDom = __webpack_require__(269);

var _utils = __webpack_require__(762);

var _constants = __webpack_require__(29);

var _channel_view = __webpack_require__(2476);

var _channel_view2 = _interopRequireDefault(_channel_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Temporary selector until getDirectTeammate is converted to be redux-friendly
var getDeactivatedChannel = (0, _reselect.createSelector)(function (state) {
    return state.entities.users.profiles;
}, function (state, channelId) {
    return channelId;
}, function (users, channelId) {
    var teammate = (0, _utils.getDirectTeammate)(channelId);
    return Boolean(teammate && teammate.delete_at);
}); // Copyright (c) 2017 Mattermost Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var channelId = state.entities.channels.currentChannelId;

    var config = (0, _general.getConfig)(state);
    var enableTutorial = config.EnableTutorial === 'true';
    var tutorialStep = (0, _preferences.getInt)(state, _constants.Preferences.TUTORIAL_STEP, (0, _users.getCurrentUserId)(state), _constants.TutorialSteps.FINISHED);

    return {
        channelId: channelId,
        deactivatedChannel: getDeactivatedChannel(state, channelId),
        showTutorial: enableTutorial && tutorialStep <= _constants.TutorialSteps.INTRO_SCREENS
    };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(_channel_view2.default));

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _deferComponentRender = __webpack_require__(2477);

var _deferComponentRender2 = _interopRequireDefault(_deferComponentRender);

var _channel_header = __webpack_require__(1410);

var _channel_header2 = _interopRequireDefault(_channel_header);

var _create_post = __webpack_require__(2478);

var _create_post2 = _interopRequireDefault(_create_post);

var _file_upload_overlay = __webpack_require__(1316);

var _file_upload_overlay2 = _interopRequireDefault(_file_upload_overlay);

var _post_view = __webpack_require__(1421);

var _post_view2 = _interopRequireDefault(_post_view);

var _tutorial = __webpack_require__(2480);

var _tutorial2 = _interopRequireDefault(_tutorial);

var _diagnostics_actions = __webpack_require__(804);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ChannelView = function (_React$PureComponent) {
    (0, _inherits3.default)(ChannelView, _React$PureComponent);

    function ChannelView(props) {
        (0, _classCallCheck3.default)(this, ChannelView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelView.__proto__ || (0, _getPrototypeOf2.default)(ChannelView)).call(this, props));

        _this.createDeferredPostView = function () {
            _this.deferredPostView = (0, _deferComponentRender2.default)(_post_view2.default, _react2.default.createElement('div', { id: 'post-list' }));
        };

        _this.getChannelView = function () {
            return _this.refs.channelView;
        };

        _this.createDeferredPostView();
        return _this;
    }

    (0, _createClass3.default)(ChannelView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _jquery2.default)('body').addClass('app__body');

            // IE Detection
            if (UserAgent.isInternetExplorer() || UserAgent.isEdge()) {
                (0, _jquery2.default)('body').addClass('browser--ie');
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)('body').removeClass('app__body');
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.match.url !== nextProps.match.url) {
                this.createDeferredPostView();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.channelId !== this.props.channelId) {
                (0, _diagnostics_actions.mark)('ChannelView#componentDidUpdate');

                var _measure = (0, _diagnostics_actions.measure)('SidebarChannelLink#click', 'ChannelView#componentDidUpdate'),
                    _measure2 = (0, _slicedToArray3.default)(_measure, 1),
                    dur1 = _measure2[0];

                var _measure3 = (0, _diagnostics_actions.measure)('TeamLink#click', 'ChannelView#componentDidUpdate'),
                    _measure4 = (0, _slicedToArray3.default)(_measure3, 1),
                    dur2 = _measure4[0];

                (0, _diagnostics_actions.clearMarks)(['SidebarChannelLink#click', 'ChannelView#componentDidUpdate', 'TeamLink#click']);

                if (dur1 !== -1) {
                    (0, _diagnostics_actions.trackEvent)('performance', 'channel_switch', { duration: Math.round(dur1) });
                }
                if (dur2 !== -1) {
                    (0, _diagnostics_actions.trackEvent)('performance', 'team_switch', { duration: Math.round(dur2) });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.showTutorial) {
                return _react2.default.createElement(_tutorial2.default, {
                    isRoot: false
                });
            }

            var createPost = void 0;
            if (this.props.deactivatedChannel) {
                createPost = _react2.default.createElement(
                    'div',
                    {
                        className: 'post-create-message'
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'create_post.deactivated',
                        defaultMessage: 'You are viewing an archived channel with a deactivated user.'
                    })
                );
            } else {
                createPost = _react2.default.createElement(
                    'div',
                    {
                        className: 'post-create__container',
                        id: 'post-create'
                    },
                    _react2.default.createElement(_create_post2.default, {
                        getChannelView: this.getChannelView
                    })
                );
            }

            var DeferredPostView = this.deferredPostView;

            return _react2.default.createElement(
                'div',
                {
                    ref: 'channelView',
                    id: 'app-content',
                    className: 'app__content'
                },
                _react2.default.createElement(_file_upload_overlay2.default, { overlayType: 'center' }),
                _react2.default.createElement(_channel_header2.default, {
                    channelId: this.props.channelId
                }),
                _react2.default.createElement(DeferredPostView, {
                    channelId: this.props.channelId
                }),
                createPost
            );
        }
    }]);
    return ChannelView;
}(_react2.default.PureComponent);

ChannelView.propTypes = {

    /**
     * ID of the channel to display
     */
    channelId: _propTypes2.default.string.isRequired,

    /**
     * Set if this channel is deactivated, primarily used for DMs with inactive users
     */
    deactivatedChannel: _propTypes2.default.bool.isRequired,

    /**
     * Object from react-router
     */
    match: _propTypes2.default.shape({
        url: _propTypes2.default.string.isRequired
    }).isRequired,

    /**
     * Set to show the tutorial
     */
    showTutorial: _propTypes2.default.bool.isRequired
};
exports.default = ChannelView;

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = deferComponentRender;

var _hoistNonReactStatics = __webpack_require__(292);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Allows two animation frames to complete to allow other components to update
 * and re-render before mounting and rendering an expensive `WrappedComponent`.
 * If provided, `PreRenderComponent` will be rendered instead of null when not
 * rendering the `Wrapped Component`.
 *
 * Based on this Twitter built component
 * https://gist.github.com/paularmstrong/cc2ead7e2a0dec37d8b2096fc8d85759#file-defercomponentrender-js
 */
// Copyright (c) 2017 Mattermost Inc. All Rights Reserved.
// See License.txt for license information.

function deferComponentRender(WrappedComponent) {
    var PreRenderComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var DeferredRenderWrapper = function (_React$Component) {
        (0, _inherits3.default)(DeferredRenderWrapper, _React$Component);

        function DeferredRenderWrapper(props, context) {
            (0, _classCallCheck3.default)(this, DeferredRenderWrapper);

            var _this = (0, _possibleConstructorReturn3.default)(this, (DeferredRenderWrapper.__proto__ || (0, _getPrototypeOf2.default)(DeferredRenderWrapper)).call(this, props, context));

            _this.state = {
                shouldRender: false
            };
            return _this;
        }

        (0, _createClass3.default)(DeferredRenderWrapper, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                window.requestAnimationFrame(function () {
                    window.requestAnimationFrame(function () {
                        return _this2.setState({ shouldRender: true });
                    });
                });
            }
        }, {
            key: 'render',
            value: function render() {
                return this.state.shouldRender ? _react2.default.createElement(WrappedComponent, this.props) : PreRenderComponent;
            }
        }]);
        return DeferredRenderWrapper;
    }(_react2.default.Component);

    return (0, _hoistNonReactStatics2.default)(DeferredRenderWrapper, WrappedComponent);
}

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _general = __webpack_require__(113);

var _teams = __webpack_require__(274);

var _channels = __webpack_require__(783);

var _users = __webpack_require__(777);

var _preferences = __webpack_require__(784);

var _posts = __webpack_require__(805);

var _posts2 = __webpack_require__(808);

var _constants = __webpack_require__(19);

var _global_actions = __webpack_require__(778);

var _post_actions = __webpack_require__(802);

var _rhs = __webpack_require__(817);

var _rhs2 = __webpack_require__(818);

var _storage = __webpack_require__(285);

var _constants2 = __webpack_require__(29);

var _file_utils = __webpack_require__(887);

var _create_post = __webpack_require__(2479);

var _create_post2 = _interopRequireDefault(_create_post);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps() {
    return function (state) {
        var config = (0, _general.getConfig)(state);
        var currentChannel = (0, _channels.getCurrentChannel)(state) || {};
        var draft = (0, _rhs2.getPostDraft)(state, _constants2.StoragePrefixes.DRAFT, currentChannel.id);
        var recentPostIdInChannel = (0, _posts.getMostRecentPostIdInChannel)(state, currentChannel.id);
        var post = (0, _posts.getPost)(state, recentPostIdInChannel);
        var getCommentCountForPost = (0, _posts.makeGetCommentCountForPost)();
        var latestReplyablePostId = (0, _posts.getLatestReplyablePostId)(state);
        var currentChannelMembersCount = (0, _channels.getCurrentChannelStats)(state) ? (0, _channels.getCurrentChannelStats)(state).member_count : 1;
        var enableTutorial = config.EnableTutorial === 'true';
        var tutorialStep = (0, _preferences.getInt)(state, _constants2.Preferences.TUTORIAL_STEP, (0, _users.getCurrentUserId)(state), _constants2.TutorialSteps.FINISHED);
        var enableEmojiPicker = config.EnableEmojiPicker === 'true';
        var enableConfirmNotificationsToChannel = config.EnableConfirmNotificationsToChannel === 'true';

        return {
            currentTeamId: (0, _teams.getCurrentTeamId)(state),
            currentChannel: currentChannel,
            currentChannelMembersCount: currentChannelMembersCount,
            currentUserId: (0, _users.getCurrentUserId)(state),
            ctrlSend: (0, _preferences.getBool)(state, _constants2.Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter'),
            fullWidthTextBox: (0, _preferences.get)(state, _constants2.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants2.Preferences.CHANNEL_DISPLAY_MODE, _constants2.Preferences.CHANNEL_DISPLAY_MODE_DEFAULT) === _constants2.Preferences.CHANNEL_DISPLAY_MODE_FULL_SCREEN,
            showTutorialTip: enableTutorial && tutorialStep === _constants2.TutorialSteps.POST_POPOVER,
            messageInHistoryItem: (0, _posts.makeGetMessageInHistoryItem)(_constants.Posts.MESSAGE_TYPES.POST)(state),
            draft: draft,
            recentPostIdInChannel: recentPostIdInChannel,
            commentCountForPost: getCommentCountForPost(state, { post: post }),
            latestReplyablePostId: latestReplyablePostId,
            currentUsersLatestPost: (0, _posts.getCurrentUsersLatestPost)(state),
            readOnlyChannel: !(0, _users.isCurrentUserSystemAdmin)(state) && config.ExperimentalTownSquareIsReadOnly === 'true' && currentChannel.name === _constants2.Constants.DEFAULT_CHANNEL,
            canUploadFiles: (0, _file_utils.canUploadFiles)(config),
            enableEmojiPicker: enableEmojiPicker,
            enableConfirmNotificationsToChannel: enableConfirmNotificationsToChannel
        };
    };
}

function onSubmitPost(post, fileInfos) {
    return function () {
        (0, _global_actions.emitUserPostedEvent)(post);
        (0, _post_actions.createPost)(post, fileInfos);
        (0, _global_actions.postListScrollChange)(true);
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            addMessageIntoHistory: _posts2.addMessageIntoHistory,
            onSubmitPost: onSubmitPost,
            moveHistoryIndexBack: _posts2.moveHistoryIndexBack,
            moveHistoryIndexForward: _posts2.moveHistoryIndexForward,
            addReaction: _posts2.addReaction,
            removeReaction: _posts2.removeReaction,
            setDraft: _storage.setGlobalItem,
            clearDraftUploads: _storage.actionOnGlobalItemsWithPrefix,
            selectPostFromRightHandSideSearchByPostId: _rhs.selectPostFromRightHandSideSearchByPostId,
            setEditingPost: _post_actions.setEditingPost
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_create_post2.default);

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _channel_actions = __webpack_require__(809);

var ChannelActions = _interopRequireWildcard(_channel_actions);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _post_actions = __webpack_require__(802);

var _emoji_store = __webpack_require__(829);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

var _constants2 = __webpack_require__(29);

var _constants3 = _interopRequireDefault(_constants2);

var _post_utils = __webpack_require__(803);

var PostUtils = _interopRequireWildcard(_post_utils);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

var _emoji_picker_overlay = __webpack_require__(883);

var _emoji_picker_overlay2 = _interopRequireDefault(_emoji_picker_overlay);

var _file_preview = __webpack_require__(1319);

var _file_preview2 = _interopRequireDefault(_file_preview);

var _file_upload = __webpack_require__(1322);

var _file_upload2 = _interopRequireDefault(_file_upload);

var _msg_typing = __webpack_require__(1323);

var _msg_typing2 = _interopRequireDefault(_msg_typing);

var _post_deleted_modal = __webpack_require__(1324);

var _post_deleted_modal2 = _interopRequireDefault(_post_deleted_modal);

var _emoji_icon = __webpack_require__(909);

var _emoji_icon2 = _interopRequireDefault(_emoji_icon);

var _textbox = __webpack_require__(968);

var _textbox2 = _interopRequireDefault(_textbox);

var _tutorial_tip = __webpack_require__(1053);

var _tutorial_tip2 = _interopRequireDefault(_tutorial_tip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var KeyCodes = _constants3.default.KeyCodes;

var CreatePost = function (_React$Component) {
    (0, _inherits3.default)(CreatePost, _React$Component);

    function CreatePost(props) {
        (0, _classCallCheck3.default)(this, CreatePost);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CreatePost.__proto__ || (0, _getPrototypeOf2.default)(CreatePost)).call(this, props));

        _this.handlePostError = function (postError) {
            _this.setState({ postError: postError });
        };

        _this.toggleEmojiPicker = function () {
            _this.setState({ showEmojiPicker: !_this.state.showEmojiPicker });
        };

        _this.hideEmojiPicker = function () {
            _this.setState({ showEmojiPicker: false });
        };

        _this.doSubmit = function (e) {
            var channelId = _this.props.currentChannel.id;
            if (e) {
                e.preventDefault();
            }

            if (_this.props.draft.uploadsInProgress.length > 0 || _this.state.submitting) {
                return;
            }

            var post = {};
            post.file_ids = [];
            post.message = _this.state.message;

            if (post.message.trim().length === 0 && _this.props.draft.fileInfos.length === 0) {
                return;
            }

            if (_this.state.postError) {
                _this.setState({ errorClass: 'animation--highlight' });
                setTimeout(function () {
                    _this.setState({ errorClass: null });
                }, _constants3.default.ANIMATION_TIMEOUT);
                return;
            }

            _this.props.actions.addMessageIntoHistory(_this.state.message);

            _this.setState({ submitting: true, serverError: null });

            var isReaction = Utils.REACTION_PATTERN.exec(post.message);
            if (post.message.indexOf('/') === 0) {
                _this.setState({ message: '', postError: null, enableSendButton: false });
                var args = {};
                args.channel_id = channelId;
                args.team_id = _this.props.currentTeamId;
                ChannelActions.executeCommand(post.message, args, function () {
                    _this.setState({ submitting: false });
                }, function (err) {
                    if (err.sendMessage) {
                        _this.sendMessage(post);
                    } else {
                        _this.setState({
                            serverError: err.message,
                            submitting: false,
                            message: post.message
                        });
                    }
                });
            } else if (isReaction && _emoji_store2.default.has(isReaction[2])) {
                _this.sendReaction(isReaction);
            } else {
                _this.sendMessage(post);
            }

            _this.setState({
                message: '',
                submitting: false,
                postError: null,
                serverError: null,
                enableSendButton: false
            });

            _this.props.actions.setDraft(_constants2.StoragePrefixes.DRAFT + channelId, null);

            var fasterThanHumanWillClick = 150;
            var forceFocus = Date.now() - _this.lastBlurAt < fasterThanHumanWillClick;

            _this.focusTextbox(forceFocus);
        };

        _this.handleNotifyAllConfirmation = function (e) {
            _this.hideNotifyAllModal();
            _this.doSubmit(e);
        };

        _this.hideNotifyAllModal = function () {
            _this.setState({ showConfirmModal: false });
        };

        _this.showNotifyAllModal = function () {
            _this.setState({ showConfirmModal: true });
        };

        _this.handleSubmit = function (e) {
            var updateChannel = _this.props.currentChannel;

            if (_this.props.enableConfirmNotificationsToChannel && _this.props.currentChannelMembersCount > _constants3.default.NOTIFY_ALL_MEMBERS && PostUtils.containsAtChannel(_this.state.message)) {
                _this.showNotifyAllModal();
                return;
            }

            if (_this.state.message.trimRight() === '/header') {
                GlobalActions.showChannelHeaderUpdateModal(updateChannel);
                _this.setState({ message: '' });
                return;
            }

            var isDirectOrGroup = updateChannel.type === _constants3.default.DM_CHANNEL || updateChannel.type === _constants3.default.GM_CHANNEL;
            if (!isDirectOrGroup && _this.state.message.trimRight() === '/purpose') {
                GlobalActions.showChannelPurposeUpdateModal(updateChannel);
                _this.setState({ message: '' });
                return;
            }

            if (!isDirectOrGroup && _this.state.message.trimRight() === '/rename') {
                GlobalActions.showChannelNameUpdateModal(updateChannel);
                _this.setState({ message: '' });
                return;
            }

            _this.doSubmit(e);
        };

        _this.sendMessage = function (post) {
            var _this$props = _this.props,
                actions = _this$props.actions,
                currentChannel = _this$props.currentChannel,
                currentUserId = _this$props.currentUserId,
                draft = _this$props.draft;


            post.channel_id = currentChannel.id;

            var time = Utils.getTimestamp();
            var userId = currentUserId;
            post.pending_post_id = userId + ':' + time;
            post.user_id = userId;
            post.create_at = time;
            post.parent_id = _this.state.parentId;

            actions.onSubmitPost(post, draft.fileInfos);

            _this.setState({
                submitting: false
            });
        };

        _this.focusTextbox = function () {
            var keepFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (_this.refs.textbox && (keepFocus || !UserAgent.isMobile())) {
                _this.refs.textbox.focus();
            }
        };

        _this.postMsgKeyPress = function (e) {
            var ctrlOrMetaKeyPressed = e.ctrlKey || e.metaKey;
            if (!UserAgent.isMobile() && (_this.props.ctrlSend && ctrlOrMetaKeyPressed || !_this.props.ctrlSend)) {
                if (Utils.isKeyPressed(e, KeyCodes.ENTER) && !e.shiftKey && !e.altKey) {
                    e.preventDefault();
                    _reactDom2.default.findDOMNode(_this.refs.textbox).blur();
                    _this.handleSubmit(e);
                }
            }

            GlobalActions.emitLocalUserTypingEvent(_this.props.currentChannel.id, '');
        };

        _this.handleChange = function (e) {
            var message = e.target.value;
            var channelId = _this.props.currentChannel.id;
            var enableSendButton = _this.handleEnableSendButton(message, _this.props.draft.fileInfos);
            _this.setState({
                message: message,
                enableSendButton: enableSendButton
            });

            var draft = (0, _extends3.default)({}, _this.props.draft, {
                message: message
            });

            _this.props.actions.setDraft(_constants2.StoragePrefixes.DRAFT + channelId, draft);
        };

        _this.handleFileUploadChange = function () {
            _this.focusTextbox(true);
        };

        _this.handleUploadStart = function (clientIds, channelId) {
            var uploadsInProgress = [].concat((0, _toConsumableArray3.default)(_this.props.draft.uploadsInProgress), (0, _toConsumableArray3.default)(clientIds));

            var draft = (0, _extends3.default)({}, _this.props.draft, {
                uploadsInProgress: uploadsInProgress
            });

            _this.props.actions.setDraft(_constants2.StoragePrefixes.DRAFT + channelId, draft);

            // this is a bit redundant with the code that sets focus when the file input is clicked,
            // but this also resets the focus after a drag and drop
            _this.focusTextbox();
        };

        _this.handleFileUploadComplete = function (fileInfos, clientIds, channelId) {
            var draft = (0, _extends3.default)({}, _this.props.draft);

            // remove each finished file from uploads

            var _loop = function _loop(i) {
                var index = draft.uploadsInProgress.indexOf(clientIds[i]);

                if (index !== -1) {
                    draft.uploadsInProgress = draft.uploadsInProgress.filter(function (item, itemIndex) {
                        return index !== itemIndex;
                    });
                }
            };

            for (var i = 0; i < clientIds.length; i++) {
                _loop(i);
            }

            draft.fileInfos = draft.fileInfos.concat(fileInfos);
            _this.props.actions.setDraft(_constants2.StoragePrefixes.DRAFT + channelId, draft);

            if (channelId === _this.props.currentChannel.id) {
                _this.setState({
                    enableSendButton: true
                });
            }
        };

        _this.handleUploadError = function (err, clientId, channelId) {
            var draft = _this.props.draft;
            var message = err;
            if (message && typeof message !== 'string') {
                // err is an AppError from the server
                message = err.message;
            }

            if (clientId !== -1) {
                var _index = draft.uploadsInProgress.indexOf(clientId);

                if (_index !== -1) {
                    var uploadsInProgress = draft.uploadsInProgress.filter(function (item, itemIndex) {
                        return _index !== itemIndex;
                    });
                    var modifiedDraft = (0, _extends3.default)({}, draft, {
                        uploadsInProgress: uploadsInProgress
                    });
                    _this.props.actions.setDraft(_constants2.StoragePrefixes.DRAFT + channelId, modifiedDraft);
                }
            }

            _this.setState({ serverError: message });
        };

        _this.removePreview = function (id) {
            var modifiedDraft = {};
            var draft = (0, _extends3.default)({}, _this.props.draft);
            var channelId = _this.props.currentChannel.id;

            // Clear previous errors
            _this.setState({ serverError: null });

            // id can either be the id of an uploaded file or the client id of an in progress upload
            var index = draft.fileInfos.findIndex(function (info) {
                return info.id === id;
            });
            if (index === -1) {
                index = draft.uploadsInProgress.indexOf(id);

                if (index !== -1) {
                    var uploadsInProgress = draft.uploadsInProgress.filter(function (item, itemIndex) {
                        return index !== itemIndex;
                    });

                    modifiedDraft = (0, _extends3.default)({}, draft, {
                        uploadsInProgress: uploadsInProgress
                    });

                    if (_this.refs.fileUpload && _this.refs.fileUpload.getWrappedInstance()) {
                        _this.refs.fileUpload.getWrappedInstance().cancelUpload(id);
                    }
                }
            } else {
                var fileInfos = draft.fileInfos.filter(function (item, itemIndex) {
                    return index !== itemIndex;
                });

                modifiedDraft = (0, _extends3.default)({}, draft, {
                    fileInfos: fileInfos
                });
            }

            _this.props.actions.setDraft(_constants2.StoragePrefixes.DRAFT + channelId, modifiedDraft);
            var enableSendButton = _this.handleEnableSendButton(_this.state.message, draft.fileInfos);

            _this.setState({ enableSendButton: enableSendButton });

            _this.handleFileUploadChange();
        };

        _this.getFileCount = function () {
            var draft = _this.props.draft;
            return draft.fileInfos.length + draft.uploadsInProgress.length;
        };

        _this.getFileUploadTarget = function () {
            return _this.refs.textbox;
        };

        _this.getCreatePostControls = function () {
            return _this.refs.createPostControls;
        };

        _this.handleKeyDown = function (e) {
            var ctrlOrMetaKeyPressed = e.ctrlKey || e.metaKey;
            var messageIsEmpty = _this.state.message.length === 0;
            var draftMessageIsEmpty = _this.props.draft.message.length === 0;
            var ctrlEnterKeyCombo = _this.props.ctrlSend && Utils.isKeyPressed(e, KeyCodes.ENTER) && ctrlOrMetaKeyPressed;
            var upKeyOnly = !ctrlOrMetaKeyPressed && !e.altKey && !e.shiftKey && Utils.isKeyPressed(e, KeyCodes.UP);
            var shiftUpKeyCombo = !ctrlOrMetaKeyPressed && !e.altKey && e.shiftKey && Utils.isKeyPressed(e, KeyCodes.UP);
            var ctrlKeyCombo = ctrlOrMetaKeyPressed && !e.altKey && !e.shiftKey;

            if (ctrlEnterKeyCombo) {
                _this.postMsgKeyPress(e);
            } else if (upKeyOnly && messageIsEmpty) {
                _this.editLastPost(e);
            } else if (shiftUpKeyCombo && messageIsEmpty) {
                _this.replyToLastPost(e);
            } else if (ctrlKeyCombo && draftMessageIsEmpty && Utils.isKeyPressed(e, KeyCodes.UP)) {
                _this.loadPrevMessage(e);
            } else if (ctrlKeyCombo && draftMessageIsEmpty && Utils.isKeyPressed(e, KeyCodes.DOWN)) {
                _this.loadNextMessage(e);
            }
        };

        _this.editLastPost = function (e) {
            e.preventDefault();

            var lastPost = _this.props.currentUsersLatestPost;
            if (!lastPost) {
                return;
            }

            var type = void 0;
            if (lastPost.root_id && lastPost.root_id.length > 0) {
                type = Utils.localizeMessage('create_post.comment', _constants.Posts.MESSAGE_TYPES.COMMENT);
            } else {
                type = Utils.localizeMessage('create_post.post', _constants.Posts.MESSAGE_TYPES.POST);
            }
            if (_this.refs.textbox) {
                _this.refs.textbox.blur();
            }
            _this.props.actions.setEditingPost(lastPost.id, _this.props.commentCountForPost, 'post_textbox', type);
        };

        _this.replyToLastPost = function (e) {
            e.preventDefault();
            var latestReplyablePostId = _this.props.latestReplyablePostId;
            if (latestReplyablePostId) {
                _this.props.actions.selectPostFromRightHandSideSearchByPostId(latestReplyablePostId);
            }
        };

        _this.loadPrevMessage = function (e) {
            e.preventDefault();
            _this.props.actions.moveHistoryIndexBack(_constants.Posts.MESSAGE_TYPES.POST).then(function () {
                return _this.fillMessageFromHistory();
            });
        };

        _this.loadNextMessage = function (e) {
            e.preventDefault();
            _this.props.actions.moveHistoryIndexForward(_constants.Posts.MESSAGE_TYPES.POST).then(function () {
                return _this.fillMessageFromHistory();
            });
        };

        _this.handleBlur = function () {
            _this.lastBlurAt = Date.now();
        };

        _this.showPostDeletedModal = function () {
            _this.setState({
                showPostDeletedModal: true
            });
        };

        _this.hidePostDeletedModal = function () {
            _this.setState({
                showPostDeletedModal: false
            });
        };

        _this.handleEmojiClick = function (emoji) {
            var emojiAlias = emoji.name || emoji.aliases[0];

            if (!emojiAlias) {
                //Oops.. There went something wrong
                return;
            }

            if (_this.state.message === '') {
                _this.setState({ message: ':' + emojiAlias + ': ' });
            } else {
                //check whether there is already a blank at the end of the current message
                var newMessage = /\s+$/.test(_this.state.message) ? _this.state.message + ':' + emojiAlias + ': ' : _this.state.message + ' :' + emojiAlias + ': ';

                _this.setState({ message: newMessage });
            }

            _this.setState({ showEmojiPicker: false });

            _this.focusTextbox();
        };

        _this.state = {
            message: _this.props.draft.message,
            submitting: false,
            showPostDeletedModal: false,
            enableSendButton: false,
            showEmojiPicker: false,
            showConfirmModal: false
        };

        _this.lastBlurAt = 0;
        return _this;
    }

    (0, _createClass3.default)(CreatePost, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var enableSendButton = this.handleEnableSendButton(this.state.message, this.props.draft.fileInfos);
            this.props.actions.clearDraftUploads(_constants2.StoragePrefixes.DRAFT, function (key, value) {
                if (value) {
                    return (0, _extends3.default)({}, value, { uploadsInProgress: [] });
                }
                return value;
            });

            // wait to load these since they may have changed since the component was constructed (particularly in the case of skipping the tutorial)
            this.setState({
                enableSendButton: enableSendButton
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.focusTextbox();
            document.addEventListener('keydown', this.showShortcuts);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.currentChannel.id !== this.props.currentChannel.id) {
                var draft = nextProps.draft;

                this.setState({
                    message: draft.message,
                    submitting: false,
                    serverError: null
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.currentChannel.id !== this.props.currentChannel.id) {
                this.focusTextbox();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.showShortcuts);
        }
    }, {
        key: 'sendReaction',
        value: function sendReaction(isReaction) {
            var channelId = this.props.currentChannel.id;
            var action = isReaction[1];
            var emojiName = isReaction[2];
            var postId = this.props.latestReplyablePostId;

            if (postId && action === '+') {
                this.props.actions.addReaction(postId, emojiName);
                (0, _post_actions.emitEmojiPosted)(emojiName);
            } else if (postId && action === '-') {
                this.props.actions.removeReaction(postId, emojiName);
            }

            this.props.actions.setDraft(_constants2.StoragePrefixes.DRAFT + channelId, null);
        }
    }, {
        key: 'showShortcuts',
        value: function showShortcuts(e) {
            if ((e.ctrlKey || e.metaKey) && Utils.isKeyPressed(e, KeyCodes.FORWARD_SLASH)) {
                e.preventDefault();

                GlobalActions.toggleShortcutsModal();
            }
        }
    }, {
        key: 'fillMessageFromHistory',
        value: function fillMessageFromHistory() {
            var lastMessage = this.props.messageInHistoryItem;
            if (lastMessage) {
                this.setState({
                    message: lastMessage
                });
            }
        }
    }, {
        key: 'createTutorialTip',
        value: function createTutorialTip() {
            var screens = [];

            screens.push(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'create_post.tutorialTip',
                    defaultMessage: '<h4>Sending Messages</h4><p>Type here to write a message and press <strong>Enter</strong> to post it.</p><p>Click the <strong>Attachment</strong> button to upload an image or a file.</p>'
                })
            ));

            return _react2.default.createElement(_tutorial_tip2.default, {
                id: 'postTextboxTipMessage',
                placement: 'top',
                screens: screens,
                overlayClass: 'tip-overlay--chat',
                diagnosticsTag: 'tutorial_tip_1_sending_messages'
            });
        }
    }, {
        key: 'handleEnableSendButton',
        value: function handleEnableSendButton(message, fileInfos) {
            return message.trim().length !== 0 || fileInfos.length !== 0;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                currentChannel = _props.currentChannel,
                currentChannelMembersCount = _props.currentChannelMembersCount,
                draft = _props.draft,
                fullWidthTextBox = _props.fullWidthTextBox,
                getChannelView = _props.getChannelView,
                showTutorialTip = _props.showTutorialTip,
                readOnlyChannel = _props.readOnlyChannel;

            var members = currentChannelMembersCount - 1;

            var notifyAllTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'notify_all.title.confirm',
                defaultMessage: 'Confirm sending notifications to entire channel'
            });

            var notifyAllConfirm = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'notify_all.confirm',
                defaultMessage: 'Confirm'
            });

            var notifyAllMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'notify_all.question',
                defaultMessage: 'By using @all or @channel you are about to send notifications to {totalMembers} people. Are you sure you want to do this?',
                values: {
                    totalMembers: members
                }
            });

            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.serverError
                    )
                );
            }

            var postError = null;
            if (this.state.postError) {
                var postErrorClass = 'post-error' + (this.state.errorClass ? ' ' + this.state.errorClass : '');
                postError = _react2.default.createElement(
                    'label',
                    { className: postErrorClass },
                    this.state.postError
                );
            }

            var preview = null;
            if (!readOnlyChannel && (draft.fileInfos.length > 0 || draft.uploadsInProgress.length > 0)) {
                preview = _react2.default.createElement(_file_preview2.default, {
                    fileInfos: draft.fileInfos,
                    onRemove: this.removePreview,
                    uploadsInProgress: draft.uploadsInProgress
                });
            }

            var postFooterClassName = 'post-create-footer';
            if (postError) {
                postFooterClassName += ' has-error';
            }

            var tutorialTip = null;
            if (showTutorialTip) {
                tutorialTip = this.createTutorialTip();
            }

            var centerClass = '';
            if (!fullWidthTextBox) {
                centerClass = 'center';
            }

            var sendButtonClass = 'send-button theme';
            if (!this.state.enableSendButton) {
                sendButtonClass += ' disabled';
            }

            var attachmentsDisabled = '';
            if (!this.props.canUploadFiles) {
                attachmentsDisabled = ' post-create--attachment-disabled';
            }

            var fileUpload = void 0;
            if (!readOnlyChannel) {
                fileUpload = _react2.default.createElement(_file_upload2.default, {
                    ref: 'fileUpload',
                    fileCount: this.getFileCount(),
                    getTarget: this.getFileUploadTarget,
                    onFileUploadChange: this.handleFileUploadChange,
                    onUploadStart: this.handleUploadStart,
                    onFileUpload: this.handleFileUploadComplete,
                    onUploadError: this.handleUploadError,
                    postType: 'post'
                });
            }

            var emojiPicker = null;
            if (this.props.enableEmojiPicker && !readOnlyChannel) {
                emojiPicker = _react2.default.createElement(
                    'span',
                    { className: 'emoji-picker__container' },
                    _react2.default.createElement(_emoji_picker_overlay2.default, {
                        show: this.state.showEmojiPicker,
                        container: getChannelView,
                        target: this.getCreatePostControls,
                        onHide: this.hideEmojiPicker,
                        onEmojiClick: this.handleEmojiClick,
                        rightOffset: 15,
                        topOffset: -7
                    }),
                    _react2.default.createElement(_emoji_icon2.default, {
                        id: 'emojiPickerButton',
                        className: 'icon icon--emoji ' + (this.state.showEmojiPicker ? 'active' : ''),
                        onClick: this.toggleEmojiPicker
                    })
                );
            }

            var createMessage = void 0;
            if (readOnlyChannel) {
                createMessage = Utils.localizeMessage('create_post.read_only', 'This channel is read-only. Only members with permission can post here.');
            } else {
                createMessage = Utils.localizeMessage('create_post.write', 'Write a message...');
            }

            return _react2.default.createElement(
                'form',
                {
                    id: 'create_post',
                    ref: 'topDiv',
                    role: 'form',
                    className: centerClass,
                    onSubmit: this.handleSubmit
                },
                _react2.default.createElement(
                    'div',
                    { className: 'post-create' + attachmentsDisabled },
                    _react2.default.createElement(
                        'div',
                        { className: 'post-create-body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'post-body__cell' },
                            _react2.default.createElement(_textbox2.default, {
                                onChange: this.handleChange,
                                onKeyPress: this.postMsgKeyPress,
                                onKeyDown: this.handleKeyDown,
                                handlePostError: this.handlePostError,
                                value: readOnlyChannel ? '' : this.state.message,
                                onBlur: this.handleBlur,
                                emojiEnabled: this.props.enableEmojiPicker,
                                createMessage: createMessage,
                                channelId: currentChannel.id,
                                popoverMentionKeyClick: true,
                                id: 'post_textbox',
                                ref: 'textbox',
                                disabled: readOnlyChannel
                            }),
                            _react2.default.createElement(
                                'span',
                                {
                                    ref: 'createPostControls',
                                    className: 'post-body__actions'
                                },
                                fileUpload,
                                emojiPicker,
                                _react2.default.createElement(
                                    'a',
                                    {
                                        className: sendButtonClass,
                                        onClick: this.handleSubmit
                                    },
                                    _react2.default.createElement('i', { className: 'fa fa-paper-plane' })
                                )
                            )
                        ),
                        tutorialTip
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            id: 'postCreateFooter',
                            className: postFooterClassName
                        },
                        _react2.default.createElement(_msg_typing2.default, {
                            channelId: currentChannel.id,
                            postId: ''
                        }),
                        postError,
                        preview,
                        serverError
                    )
                ),
                _react2.default.createElement(_post_deleted_modal2.default, {
                    show: this.state.showPostDeletedModal,
                    onHide: this.hidePostDeletedModal
                }),
                _react2.default.createElement(_confirm_modal2.default, {
                    title: notifyAllTitle,
                    message: notifyAllMessage,
                    confirmButtonText: notifyAllConfirm,
                    show: this.state.showConfirmModal,
                    onConfirm: this.handleNotifyAllConfirmation,
                    onCancel: this.hideNotifyAllModal
                })
            );
        }
    }]);
    return CreatePost;
}(_react2.default.Component);

CreatePost.propTypes = {

    /**
    *  ref passed from channelView for EmojiPickerOverlay
    */
    getChannelView: _propTypes2.default.func,

    /**
    *  Data used in notifying user for @all and @channel
    */
    currentChannelMembersCount: _propTypes2.default.number,

    /**
    *  Data used in multiple places of the component
    */
    currentChannel: _propTypes2.default.object,

    /**
    *  Data used in executing commands for channel actions passed down to client4 function
    */
    currentTeamId: _propTypes2.default.string,

    /**
    *  Data used for posting message
    */
    currentUserId: _propTypes2.default.string,

    /**
    *  Flag used for handling submit
    */
    ctrlSend: _propTypes2.default.bool,

    /**
    *  Flag used for adding a class center to Postbox based on user pref
    */
    fullWidthTextBox: _propTypes2.default.bool,

    /**
    *  Data used for deciding if tutorial tip is to be shown
    */
    showTutorialTip: _propTypes2.default.bool.isRequired,

    /**
    *  Data used populating message state when triggered by shortcuts
    */
    messageInHistoryItem: _propTypes2.default.string,

    /**
    *  Data used for populating message state from previous draft
    */
    draft: _propTypes2.default.shape({
        message: _propTypes2.default.string.isRequired,
        uploadsInProgress: _propTypes2.default.array.isRequired,
        fileInfos: _propTypes2.default.array.isRequired
    }).isRequired,

    /**
    *  Data used adding reaction on +/- to recent post
    */
    recentPostIdInChannel: _propTypes2.default.string,

    /**
    *  Data used dispatching handleViewAction
    */
    commentCountForPost: _propTypes2.default.number,

    /**
    *  Data used dispatching handleViewAction ex: edit post
    */
    latestReplyablePostId: _propTypes2.default.string,

    /**
    *  Data used for calling edit of post
    */
    currentUsersLatestPost: _propTypes2.default.object,

    /**
    *  Set if the channel is read only.
    */
    readOnlyChannel: _propTypes2.default.bool,

    /**
     * Whether or not file upload is allowed.
     */
    canUploadFiles: _propTypes2.default.bool.isRequired,

    /**
     * Whether to show the emoji picker.
     */
    enableEmojiPicker: _propTypes2.default.bool.isRequired,

    /**
     * Whether to check with the user before notifying the whole channel.
     */
    enableConfirmNotificationsToChannel: _propTypes2.default.bool.isRequired,

    actions: _propTypes2.default.shape({

        /**
        *  func called after message submit.
        */
        addMessageIntoHistory: _propTypes2.default.func.isRequired,

        /**
        *  func called for navigation through messages by Up arrow
        */
        moveHistoryIndexBack: _propTypes2.default.func.isRequired,

        /**
        *  func called for navigation through messages by Down arrow
        */
        moveHistoryIndexForward: _propTypes2.default.func.isRequired,

        /**
        *  func called for adding a reaction
        */
        addReaction: _propTypes2.default.func.isRequired,

        /**
        *  func called for posting message
        */
        onSubmitPost: _propTypes2.default.func.isRequired,

        /**
        *  func called for removing a reaction
        */
        removeReaction: _propTypes2.default.func.isRequired,

        /**
        *  func called on load of component to clear drafts
        */
        clearDraftUploads: _propTypes2.default.func.isRequired,

        /**
        *  func called for setting drafts
        */
        setDraft: _propTypes2.default.func.isRequired,

        /**
        *  func called for editing posts
        */
        setEditingPost: _propTypes2.default.func.isRequired,

        /**
         *  func called for opening the last replayable post in the RHS
         */
        selectPostFromRightHandSideSearchByPostId: _propTypes2.default.func.isRequired
    }).isRequired
};
CreatePost.defaultProps = {
    latestReplyablePostId: ''
};
exports.default = CreatePost;

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _channels = __webpack_require__(783);

var _general = __webpack_require__(113);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _tutorial_view = __webpack_require__(2481);

var _tutorial_view2 = _interopRequireDefault(_tutorial_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    var teamChannels = (0, _channels.getChannelsNameMapInCurrentTeam)(state);
    var townSquare = teamChannels[_constants2.default.DEFAULT_CHANNEL];
    var townSquareDisplayName = townSquare ? townSquare.display_name : _constants2.default.DEFAULT_CHANNEL_UI_NAME;

    var appDownloadLink = config.AppDownloadLink;
    var isLicensed = license.IsLicensed === 'true';
    var restrictTeamInvite = config.RestrictTeamInvite;
    var supportEmail = config.SupportEmail;

    return {
        townSquareDisplayName: townSquareDisplayName,
        appDownloadLink: appDownloadLink,
        isLicensed: isLicensed,
        restrictTeamInvite: restrictTeamInvite,
        supportEmail: supportEmail
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_tutorial_view2.default);

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _tutorial_intro_screens = __webpack_require__(2482);

var _tutorial_intro_screens2 = _interopRequireDefault(_tutorial_intro_screens);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TutorialView = function (_React$Component) {
    (0, _inherits3.default)(TutorialView, _React$Component);

    function TutorialView() {
        (0, _classCallCheck3.default)(this, TutorialView);
        return (0, _possibleConstructorReturn3.default)(this, (TutorialView.__proto__ || (0, _getPrototypeOf2.default)(TutorialView)).apply(this, arguments));
    }

    (0, _createClass3.default)(TutorialView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isRoot) {
                (0, _jquery2.default)('body').addClass('app__body');
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.isRoot) {
                (0, _jquery2.default)('body').removeClass('app__body');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    id: 'app-content',
                    className: 'app__content'
                },
                _react2.default.createElement(_tutorial_intro_screens2.default, {
                    townSquareDisplayName: this.props.townSquareDisplayName,
                    appDownloadLink: this.props.appDownloadLink,
                    isLicensed: this.props.isLicensed,
                    restrictTeamInvite: this.props.restrictTeamInvite,
                    supportEmail: this.props.supportEmail
                })
            );
        }
    }]);
    return TutorialView;
}(_react2.default.Component);

exports.default = TutorialView;


TutorialView.propTypes = {
    isRoot: _propTypes2.default.bool,
    townSquareDisplayName: _propTypes2.default.string.isRequired,
    appDownloadLink: _propTypes2.default.string,
    isLicensed: _propTypes2.default.bool.isRequired,
    restrictTeamInvite: _propTypes2.default.string.isRequired,
    supportEmail: _propTypes2.default.string.isRequired
};

TutorialView.defaultProps = {
    isRoot: true
};

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _diagnostics_actions = __webpack_require__(804);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _user_actions = __webpack_require__(781);

var _preference_store = __webpack_require__(814);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _url = __webpack_require__(793);

var _appIcons = __webpack_require__(2483);

var _appIcons2 = _interopRequireDefault(_appIcons);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var NUM_SCREENS = 3;

var TutorialIntroScreens = function (_React$Component) {
    (0, _inherits3.default)(TutorialIntroScreens, _React$Component);

    function TutorialIntroScreens(props) {
        (0, _classCallCheck3.default)(this, TutorialIntroScreens);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TutorialIntroScreens.__proto__ || (0, _getPrototypeOf2.default)(TutorialIntroScreens)).call(this, props));

        _this.handleNext = function () {
            switch (_this.state.currentScreen) {
                case 0:
                    (0, _diagnostics_actions.trackEvent)('tutorial', 'tutorial_screen_1_welcome_to_mattermost_next');
                    break;
                case 1:
                    (0, _diagnostics_actions.trackEvent)('tutorial', 'tutorial_screen_2_how_mattermost_works_next');
                    break;
                case 2:
                    (0, _diagnostics_actions.trackEvent)('tutorial', 'tutorial_screen_3_youre_all_set_next');
                    break;
            }

            if (_this.state.currentScreen < 2) {
                _this.setState({ currentScreen: _this.state.currentScreen + 1 });
                return;
            }

            var step = _preference_store2.default.getInt(_constants.Preferences.TUTORIAL_STEP, _user_store2.default.getCurrentId(), 0);

            (0, _user_actions.savePreference)(_constants.Preferences.TUTORIAL_STEP, _user_store2.default.getCurrentId(), (step + 1).toString());
        };

        _this.skipTutorial = function (e) {
            e.preventDefault();

            switch (_this.state.currentScreen) {
                case 0:
                    (0, _diagnostics_actions.trackEvent)('tutorial', 'tutorial_screen_1_welcome_to_mattermost_skip');
                    break;
                case 1:
                    (0, _diagnostics_actions.trackEvent)('tutorial', 'tutorial_screen_2_how_mattermost_works_skip');
                    break;
                case 2:
                    (0, _diagnostics_actions.trackEvent)('tutorial', 'tutorial_screen_3_youre_all_set_skip');
                    break;
            }

            (0, _user_actions.savePreference)(_constants.Preferences.TUTORIAL_STEP, _user_store2.default.getCurrentId(), _constants.Constants.TutorialSteps.FINISHED.toString());
        };

        _this.createScreen = function () {
            switch (_this.state.currentScreen) {
                case 0:
                    return _this.createScreenOne();
                case 1:
                    return _this.createScreenTwo();
                case 2:
                    return _this.createScreenThree();
            }
            return null;
        };

        _this.handleCircleClick = function (e, screen) {
            e.preventDefault();
            _this.setState({ currentScreen: screen });
        };

        _this.createCircles = function () {
            var circles = [];

            var _loop = function _loop(i) {
                var className = 'circle';
                if (i === _this.state.currentScreen) {
                    className += ' active';
                }

                circles.push(_react2.default.createElement('a', {
                    id: 'tutorialIntroCircle' + i,
                    href: '#',
                    key: 'circle' + i,
                    className: className,
                    'data-screen': i,
                    onClick: function onClick(e) {
                        return _this.handleCircleClick(e, i);
                    }
                }));
            };

            for (var i = 0; i < NUM_SCREENS; i++) {
                _loop(i);
            }

            return _react2.default.createElement(
                'div',
                { className: 'tutorial__circles' },
                circles
            );
        };

        _this.state = { currentScreen: 0 };
        return _this;
    }

    (0, _createClass3.default)(TutorialIntroScreens, [{
        key: 'createScreenOne',
        value: function createScreenOne() {
            var circles = this.createCircles();

            return _react2.default.createElement(
                'div',
                { id: 'tutorialIntroOne' },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'tutorial_intro.screenOne',
                    defaultMessage: '<h3>Welcome to:</h3> <h1>Mattermost</h1> <p>Your team communication all in one place, instantly searchable and available anywhere.</p> <p>Keep your team connected to help them achieve what matters most.</p>'
                }),
                circles
            );
        }
    }, {
        key: 'createScreenTwo',
        value: function createScreenTwo() {
            var circles = this.createCircles();

            var appDownloadLink = null;
            var appDownloadImage = null;
            if (this.props.appDownloadLink) {
                var link = (0, _url.useSafeUrl)(this.props.appDownloadLink);

                // not using a FormattedHTMLMessage here since appDownloadLink is configurable and could be used
                // to inject HTML if we're not careful
                appDownloadLink = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'tutorial_intro.mobileApps',
                    defaultMessage: 'Install the apps for {link} for easy access and notifications on the go.',
                    values: {
                        link: _react2.default.createElement(
                            'a',
                            {
                                id: 'appDownloadLink',
                                href: link,
                                target: '_blank',
                                rel: 'noopener noreferrer'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'tutorial_intro.mobileAppsLinkText',
                                defaultMessage: 'PC, Mac, iOS and Android'
                            })
                        )
                    }
                });

                appDownloadImage = _react2.default.createElement(
                    'a',
                    {
                        id: 'appDownloadImage',
                        href: link,
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    },
                    _react2.default.createElement('img', {
                        className: 'tutorial__app-icons',
                        src: _appIcons2.default
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { id: 'tutorialIntroTwo' },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'tutorial_intro.screenTwo',
                    defaultMessage: '<h3>How Mattermost works:</h3> <p>Communication happens in public discussion channels, private channels and direct messages.</p> <p>Everything is archived and searchable from any web-enabled desktop, laptop or phone.</p>'
                }),
                appDownloadLink,
                appDownloadImage,
                circles
            );
        }
    }, {
        key: 'createScreenThree',
        value: function createScreenThree() {
            var team = _team_store2.default.getCurrent();
            var inviteModalLink = void 0;
            var inviteText = void 0;

            if (!this.props.isLicensed || this.props.restrictTeamInvite === _constants.Constants.PERMISSIONS_ALL) {
                if (team.type === _constants.Constants.INVITE_TEAM) {
                    inviteModalLink = _react2.default.createElement(
                        'button',
                        {
                            id: 'tutorialIntroInvite',
                            className: 'intro-links color--link style--none',
                            onClick: GlobalActions.showInviteMemberModal
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'tutorial_intro.invite',
                            defaultMessage: 'Invite teammates'
                        })
                    );
                } else {
                    inviteModalLink = _react2.default.createElement(
                        'button',
                        {
                            id: 'tutorialIntroInvite',
                            className: 'intro-links color--link style--none',
                            onClick: GlobalActions.showGetTeamInviteLinkModal
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'tutorial_intro.teamInvite',
                            defaultMessage: 'Invite teammates'
                        })
                    );
                }

                inviteText = _react2.default.createElement(
                    'p',
                    null,
                    inviteModalLink,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'tutorial_intro.whenReady',
                        defaultMessage: ' when you\u2019re ready.'
                    })
                );
            }

            var circles = this.createCircles();

            var supportInfo = null;
            if (this.props.supportEmail) {
                supportInfo = _react2.default.createElement(
                    'p',
                    { id: 'supportInfo' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'tutorial_intro.support',
                        defaultMessage: 'Need anything, just email us at '
                    }),
                    _react2.default.createElement(
                        'a',
                        {
                            href: 'mailto:' + this.props.supportEmail,
                            target: '_blank',
                            rel: 'noopener noreferrer'
                        },
                        this.props.supportEmail
                    ),
                    '.'
                );
            }

            return _react2.default.createElement(
                'div',
                { id: 'tutorialIntroThree' },
                _react2.default.createElement(
                    'h3',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'tutorial_intro.allSet',
                        defaultMessage: 'You\u2019re all set'
                    })
                ),
                inviteText,
                supportInfo,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'tutorial_intro.end',
                    defaultMessage: 'Click "Next" to enter {channel}. This is the first channel teammates see when they sign up. Use it for posting updates everyone needs to know.',
                    values: {
                        channel: this.props.townSquareDisplayName
                    }
                }),
                circles
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var screen = this.createScreen();

            return _react2.default.createElement(
                'div',
                { className: 'tutorial-steps__container' },
                _react2.default.createElement(
                    'div',
                    {
                        id: 'tutorialIntroContent',
                        className: 'tutorial__content'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'tutorial__steps' },
                        screen,
                        _react2.default.createElement(
                            'div',
                            { className: 'tutorial__footer' },
                            _react2.default.createElement(
                                'button',
                                {
                                    id: 'tutorialNextButton',
                                    className: 'btn btn-primary',
                                    tabIndex: '1',
                                    onClick: this.handleNext
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'tutorial_intro.next',
                                    defaultMessage: 'Next'
                                })
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    id: 'tutorialSkipLink',
                                    className: 'tutorial-skip',
                                    href: '#',
                                    onClick: this.skipTutorial
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'tutorial_intro.skip',
                                    defaultMessage: 'Skip tutorial'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return TutorialIntroScreens;
}(_react2.default.Component);

TutorialIntroScreens.propTypes = {
    townSquareDisplayName: _propTypes2.default.string.isRequired,
    appDownloadLink: _propTypes2.default.string,
    isLicensed: _propTypes2.default.bool.isRequired,
    restrictTeamInvite: _propTypes2.default.string.isRequired,
    supportEmail: _propTypes2.default.string.isRequired
};
exports.default = TutorialIntroScreens;

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/8a237bc56e1e2ddacaa7a194f4d28986.png";

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(9).then((function(require) {
		cb(__webpack_require__(2485));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2485 */,
/* 2486 */,
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
var intSize = 4;
var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
var chrsz = 8;

function toArray(buf, bigEndian) {
  if ((buf.length % intSize) !== 0) {
    var len = buf.length + (intSize - (buf.length % intSize));
    buf = Buffer.concat([buf, zeroBuffer], len);
  }

  var arr = [];
  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
  for (var i = 0; i < buf.length; i += intSize) {
    arr.push(fn.call(buf, i));
  }
  return arr;
}

function toBuffer(arr, size, bigEndian) {
  var buf = new Buffer(size);
  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
  for (var i = 0; i < arr.length; i++) {
    fn.call(buf, arr[i], i * 4, true);
  }
  return buf;
}

function hash(buf, fn, hashSize, bigEndian) {
  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
  return toBuffer(arr, hashSize, bigEndian);
}
exports.hash = hash;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
/** @preserve
(c) 2012 by Cédric Mesnil. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

// constants table
var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]
var hr = [0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]

function bytesToWords (bytes) {
  var words = []
  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
    words[b >>> 5] |= bytes[i] << (24 - b % 32)
  }
  return words
}

function wordsToBytes (words) {
  var bytes = []
  for (var b = 0; b < words.length * 32; b += 8) {
    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF)
  }
  return bytes
}

function processBlock (H, M, offset) {
  // swap endian
  for (var i = 0; i < 16; i++) {
    var offset_i = offset + i
    var M_offset_i = M[offset_i]

    // Swap
    M[offset_i] = (
      (((M_offset_i << 8) | (M_offset_i >>> 24)) & 0x00ff00ff) |
      (((M_offset_i << 24) | (M_offset_i >>> 8)) & 0xff00ff00)
    )
  }

  // Working variables
  var al, bl, cl, dl, el
  var ar, br, cr, dr, er

  ar = al = H[0]
  br = bl = H[1]
  cr = cl = H[2]
  dr = dl = H[3]
  er = el = H[4]

  // computation
  var t
  for (i = 0; i < 80; i += 1) {
    t = (al + M[offset + zl[i]]) | 0
    if (i < 16) {
      t += f1(bl, cl, dl) + hl[0]
    } else if (i < 32) {
      t += f2(bl, cl, dl) + hl[1]
    } else if (i < 48) {
      t += f3(bl, cl, dl) + hl[2]
    } else if (i < 64) {
      t += f4(bl, cl, dl) + hl[3]
    } else {// if (i<80) {
      t += f5(bl, cl, dl) + hl[4]
    }
    t = t | 0
    t = rotl(t, sl[i])
    t = (t + el) | 0
    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = t

    t = (ar + M[offset + zr[i]]) | 0
    if (i < 16) {
      t += f5(br, cr, dr) + hr[0]
    } else if (i < 32) {
      t += f4(br, cr, dr) + hr[1]
    } else if (i < 48) {
      t += f3(br, cr, dr) + hr[2]
    } else if (i < 64) {
      t += f2(br, cr, dr) + hr[3]
    } else {// if (i<80) {
      t += f1(br, cr, dr) + hr[4]
    }

    t = t | 0
    t = rotl(t, sr[i])
    t = (t + er) | 0
    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = t
  }

  // intermediate hash value
  t = (H[1] + cl + dr) | 0
  H[1] = (H[2] + dl + er) | 0
  H[2] = (H[3] + el + ar) | 0
  H[3] = (H[4] + al + br) | 0
  H[4] = (H[0] + bl + cr) | 0
  H[0] = t
}

function f1 (x, y, z) {
  return ((x) ^ (y) ^ (z))
}

function f2 (x, y, z) {
  return (((x) & (y)) | ((~x) & (z)))
}

function f3 (x, y, z) {
  return (((x) | (~(y))) ^ (z))
}

function f4 (x, y, z) {
  return (((x) & (z)) | ((y) & (~(z))))
}

function f5 (x, y, z) {
  return ((x) ^ ((y) | (~(z))))
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function ripemd160 (message) {
  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]

  if (typeof message === 'string') {
    message = new Buffer(message, 'utf8')
  }

  var m = bytesToWords(message)

  var nBitsLeft = message.length * 8
  var nBitsTotal = message.length * 8

  // Add padding
  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32)
  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
    (((nBitsTotal << 8) | (nBitsTotal >>> 24)) & 0x00ff00ff) |
    (((nBitsTotal << 24) | (nBitsTotal >>> 8)) & 0xff00ff00)
  )

  for (var i = 0; i < m.length; i += 16) {
    processBlock(H, m, i)
  }

  // swap endian
  for (i = 0; i < 5; i++) {
    // shortcut
    var H_i = H[i]

    // Swap
    H[i] = (((H_i << 8) | (H_i >>> 24)) & 0x00ff00ff) |
      (((H_i << 24) | (H_i >>> 8)) & 0xff00ff00)
  }

  var digestbytes = wordsToBytes(H)
  return new Buffer(digestbytes)
}

module.exports = ripemd160

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(2490)
exports.sha1 = __webpack_require__(2491)
exports.sha224 = __webpack_require__(2492)
exports.sha256 = __webpack_require__(1424)
exports.sha384 = __webpack_require__(2493)
exports.sha512 = __webpack_require__(1425)


/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(77)
var Hash = __webpack_require__(915)

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = new Buffer(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(77)
var Hash = __webpack_require__(915)

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = new Buffer(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(77)
var Sha256 = __webpack_require__(1424)
var Hash = __webpack_require__(915)

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = new Buffer(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var inherits = __webpack_require__(77)
var SHA512 = __webpack_require__(1425)
var Hash = __webpack_require__(915)

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = new Buffer(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2494 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(1092).Buffer;
var util = __webpack_require__(2496);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 2496 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(1429);

/*<replacement>*/
var util = __webpack_require__(79);
util.inherits = __webpack_require__(77);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1093);


/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(892);


/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1091).Transform


/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1091).PassThrough


/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1430)


/***/ }),
/* 2503 */
/***/ (function(module, exports) {

var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
module.exports = function (iterations, keylen) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}


/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

var ebtk = __webpack_require__(988)
var aes = __webpack_require__(1095)
var DES = __webpack_require__(2508)
var desModes = __webpack_require__(2514)
var aesModes = __webpack_require__(990)
function createCipher (suite, password) {
  var keyLen, ivLen
  suite = suite.toLowerCase()
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }
  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}
function createDecipher (suite, password) {
  var keyLen, ivLen
  suite = suite.toLowerCase()
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }
  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) {
    return aes.createCipheriv(suite, key, iv)
  } else if (desModes[suite]) {
    return new DES({
      key: key,
      iv: iv,
      mode: suite
    })
  } else {
    throw new TypeError('invalid suite type')
  }
}
function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) {
    return aes.createDecipheriv(suite, key, iv)
  } else if (desModes[suite]) {
    return new DES({
      key: key,
      iv: iv,
      mode: suite,
      decrypt: true
    })
  } else {
    throw new TypeError('invalid suite type')
  }
}
exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(989)
var Transform = __webpack_require__(916)
var inherits = __webpack_require__(77)
var modes = __webpack_require__(990)
var ebtk = __webpack_require__(988)
var StreamCipher = __webpack_require__(1432)
var AuthCipher = __webpack_require__(1433)
inherits(Cipher, Transform)
function Cipher (mode, key, iv) {
  if (!(this instanceof Cipher)) {
    return new Cipher(mode, key, iv)
  }
  Transform.call(this)
  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = new Buffer(iv.length)
  iv.copy(this._prev)
  this._mode = mode
  this._autopadding = true
}
Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}
Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  } else if (chunk.toString('hex') !== '10101010101010101010101010101010') {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}
Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  if (!(this instanceof Splitter)) {
    return new Splitter()
  }
  this.cache = new Buffer('')
}
Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}
Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = new Buffer(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }
  var out = Buffer.concat([this.cache, padBuff])
  return out
}
var modelist = {
  ECB: __webpack_require__(1434),
  CBC: __webpack_require__(1435),
  CFB: __webpack_require__(1436),
  CFB8: __webpack_require__(1437),
  CFB1: __webpack_require__(1438),
  OFB: __webpack_require__(1439),
  CTR: __webpack_require__(991),
  GCM: __webpack_require__(991)
}

function createCipheriv (suite, password, iv) {
  var config = modes[suite.toLowerCase()]
  if (!config) {
    throw new TypeError('invalid suite type')
  }
  if (typeof iv === 'string') {
    iv = new Buffer(iv)
  }
  if (typeof password === 'string') {
    password = new Buffer(password)
  }
  if (password.length !== config.key / 8) {
    throw new TypeError('invalid key length ' + password.length)
  }
  if (iv.length !== config.iv) {
    throw new TypeError('invalid iv length ' + iv.length)
  }
  if (config.type === 'stream') {
    return new StreamCipher(modelist[config.mode], password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(modelist[config.mode], password, iv)
  }
  return new Cipher(modelist[config.mode], password, iv)
}
function createCipher (suite, password) {
  var config = modes[suite.toLowerCase()]
  if (!config) {
    throw new TypeError('invalid suite type')
  }
  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var zeros = new Buffer(16)
zeros.fill(0)
module.exports = GHASH
function GHASH (key) {
  this.h = key
  this.state = new Buffer(16)
  this.state.fill(0)
  this.cache = new Buffer('')
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsb_Vi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - i % 8))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi = xor(Zi, Vi)
    }

    // Store the value of LSB(V_i)
    lsb_Vi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsb_Vi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}
GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}
GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, zeros], 16))
  }
  this.ghash(fromArray([
    0, abl,
    0, bl
  ]))
  return this.state
}

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}
function fromArray (out) {
  out = out.map(fixup_uint32)
  var buf = new Buffer(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}
var uint_max = Math.pow(2, 32)
function fixup_uint32 (x) {
  var ret, x_pos
  ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x
  return ret
}
function xor (a, b) {
  return [
    a[0] ^ b[0],
    a[1] ^ b[1],
    a[2] ^ b[2],
    a[3] ^ b[3]
  ]
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(989)
var Transform = __webpack_require__(916)
var inherits = __webpack_require__(77)
var modes = __webpack_require__(990)
var StreamCipher = __webpack_require__(1432)
var AuthCipher = __webpack_require__(1433)
var ebtk = __webpack_require__(988)

inherits(Decipher, Transform)
function Decipher (mode, key, iv) {
  if (!(this instanceof Decipher)) {
    return new Decipher(mode, key, iv)
  }
  Transform.call(this)
  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = new Buffer(iv.length)
  iv.copy(this._prev)
  this._mode = mode
  this._autopadding = true
}
Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}
Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}
Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}
function Splitter () {
  if (!(this instanceof Splitter)) {
    return new Splitter()
  }
  this.cache = new Buffer('')
}
Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }
  return null
}
Splitter.prototype.flush = function () {
  if (this.cache.length) {
    return this.cache
  }
}
function unpad (last) {
  var padded = last[15]
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) {
    return
  }
  return last.slice(0, 16 - padded)
}

var modelist = {
  ECB: __webpack_require__(1434),
  CBC: __webpack_require__(1435),
  CFB: __webpack_require__(1436),
  CFB8: __webpack_require__(1437),
  CFB1: __webpack_require__(1438),
  OFB: __webpack_require__(1439),
  CTR: __webpack_require__(991),
  GCM: __webpack_require__(991)
}

function createDecipheriv (suite, password, iv) {
  var config = modes[suite.toLowerCase()]
  if (!config) {
    throw new TypeError('invalid suite type')
  }
  if (typeof iv === 'string') {
    iv = new Buffer(iv)
  }
  if (typeof password === 'string') {
    password = new Buffer(password)
  }
  if (password.length !== config.key / 8) {
    throw new TypeError('invalid key length ' + password.length)
  }
  if (iv.length !== config.iv) {
    throw new TypeError('invalid iv length ' + iv.length)
  }
  if (config.type === 'stream') {
    return new StreamCipher(modelist[config.mode], password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(modelist[config.mode], password, iv, true)
  }
  return new Decipher(modelist[config.mode], password, iv)
}

function createDecipher (suite, password) {
  var config = modes[suite.toLowerCase()]
  if (!config) {
    throw new TypeError('invalid suite type')
  }
  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}
exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var CipherBase = __webpack_require__(916)
var des = __webpack_require__(1096)
var inherits = __webpack_require__(77)

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return new Buffer(this._des.update(data))
}
DES.prototype._final = function () {
  return new Buffer(this._des.final())
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(893);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(893);
var inherits = __webpack_require__(77);

var des = __webpack_require__(1096);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(893);
var inherits = __webpack_require__(77);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(893);
var inherits = __webpack_require__(77);

var des = __webpack_require__(1096);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 2514 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(1440)
var primes = __webpack_require__(2517)

var DH = __webpack_require__(2518)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2516 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2517 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(806);
var MillerRabin = __webpack_require__(1441);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(1440);
var randomBytes = __webpack_require__(937);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(914)
var stream = __webpack_require__(1090)
var inherits = __webpack_require__(77)
var sign = __webpack_require__(2520)
var verify = __webpack_require__(2555)

var algorithms = __webpack_require__(1430)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(1094)
var crt = __webpack_require__(1097)
var EC = __webpack_require__(824).ec
var BN = __webpack_require__(806)
var parseKeys = __webpack_require__(993)
var curves = __webpack_require__(1448)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2521 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.4.0","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(806);
var minAssert = __webpack_require__(893);
var minUtils = __webpack_require__(1443);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(806);
var elliptic = __webpack_require__(824);
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(992);
var elliptic = __webpack_require__(824);
var BN = __webpack_require__(806);
var inherits = __webpack_require__(77);
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
  return false;
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(992);
var BN = __webpack_require__(806);
var inherits = __webpack_require__(77);
var Base = curve.base;

var elliptic = __webpack_require__(824);
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(992);
var elliptic = __webpack_require__(824);
var BN = __webpack_require__(806);
var inherits = __webpack_require__(77);
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - 1) / (d y^2 + 1)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.one);
  var rhs = y2.redMul(this.d).redAdd(this.one);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
         this.y.cmp(this.z) === 0;
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.c.redMul(this.z)).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
  return false;
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(894);
var elliptic = __webpack_require__(824);

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new elliptic.curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new elliptic.curve.edwards(options);
  else
    this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(2533);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

var utils = exports;
var inherits = __webpack_require__(77);

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi)
          res.push(hi, lo);
        else
          res.push(lo);
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (var i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
utils.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
utils.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
utils.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
utils.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
utils.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
utils.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
utils.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
utils.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
utils.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
utils.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
utils.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
utils.sum32_5 = sum32_5;

function assert(cond, msg) {
  if (!cond)
    throw new Error(msg || 'Assertion failed');
}
utils.assert = assert;

utils.inherits = inherits;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
};
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
};
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
};
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
};
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
};
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
};
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
};
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
};
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
};
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
};
exports.shr64_lo = shr64_lo;


/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

var hash = __webpack_require__(894);
var utils = hash.utils;
var assert = utils.assert;

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

var hash = __webpack_require__(894);
var utils = hash.utils;
var assert = utils.assert;

var rotr32 = utils.rotr32;
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;
var BlockHash = hash.common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [ 0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
             0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19 ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
exports.sha256 = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [ 0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
             0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
exports.sha224 = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [ 0x6a09e667, 0xf3bcc908,
             0xbb67ae85, 0x84caa73b,
             0x3c6ef372, 0xfe94f82b,
             0xa54ff53a, 0x5f1d36f1,
             0x510e527f, 0xade682d1,
             0x9b05688c, 0x2b3e6c1f,
             0x1f83d9ab, 0xfb41bd6b,
             0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
exports.sha512 = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(c0_hi, c0_lo,
                      c1_hi, c1_lo,
                      c2_hi, c2_lo,
                      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(c0_hi, c0_lo,
                          c1_hi, c1_lo,
                          c2_hi, c2_lo,
                          c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(c0_hi, c0_lo,
                           c1_hi, c1_lo,
                           c2_hi, c2_lo,
                           c3_hi, c3_lo,
                           c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(c0_hi, c0_lo,
                           c1_hi, c1_lo,
                           c2_hi, c2_lo,
                           c3_hi, c3_lo,
                           c4_hi, c4_lo);

    var c0_hi = s0_512_hi(ah, al);
    var c0_lo = s0_512_lo(ah, al);
    var c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    var c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [ 0xcbbb9d5d, 0xc1059ed8,
             0x629a292a, 0x367cd507,
             0x9159015a, 0x3070dd17,
             0x152fecd8, 0xf70e5939,
             0x67332667, 0xffc00b31,
             0x8eb44a87, 0x68581511,
             0xdb0c2e0d, 0x64f98fa7,
             0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
exports.sha384 = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe,
             0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
exports.sha1 = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (var i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}

function p32(x, y, z) {
  return x ^ y ^ z;
}

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}

function ch64_hi(xh, xl, yh, yl, zh, zl) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh, zl) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

var hash = __webpack_require__(894);
var utils = hash.utils;

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = hash.common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

var hmac = exports;

var hash = __webpack_require__(894);
var utils = hash.utils;
var assert = utils.assert;

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (var i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (var i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 2533 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(806);
var HmacDRBG = __webpack_require__(2535);
var elliptic = __webpack_require__(824);
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__(2536);
var Signature = __webpack_require__(2537);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(894);
var utils = __webpack_require__(1443);
var assert = __webpack_require__(893);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(806);
var elliptic = __webpack_require__(824);
var utils = elliptic.utils;
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(806);

var elliptic = __webpack_require__(824);
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(894);
var elliptic = __webpack_require__(824);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(2539);
var Signature = __webpack_require__(2540);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__(824);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(806);
var elliptic = __webpack_require__(824);
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(939)

exports.certificate = __webpack_require__(2552)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(939);
var inherits = __webpack_require__(77);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(2543).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(2544);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 2544 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(77);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(940).Reporter;
var EncoderBuffer = __webpack_require__(940).EncoderBuffer;
var DecoderBuffer = __webpack_require__(940).DecoderBuffer;
var assert = __webpack_require__(893);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be ommited only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(1445);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(1446);
decoders.pem = __webpack_require__(2549);


/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(77);
var Buffer = __webpack_require__(45).Buffer;

var DERDecoder = __webpack_require__(1446);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(1447);
encoders.pem = __webpack_require__(2551);


/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(77);

var DEREncoder = __webpack_require__(1447);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(939)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 2553 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED\n\r?DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)\n\r?\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?/m
var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n/m
var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?-----END \1-----$/m
var evp = __webpack_require__(988)
var ciphers = __webpack_require__(1095)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/\r?\n/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = new Buffer(match[2], 'hex')
    var cipherText = new Buffer(match[3].replace(/\r?\n/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(806)
var EC = __webpack_require__(824).ec
var parseKeys = __webpack_require__(993)
var curves = __webpack_require__(1448)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(824);
var BN = __webpack_require__(806);

module.exports = function createECDH(curve) {
	return new ECDH(curve);
};

var aliases = {
	secp256k1: {
		name: 'secp256k1',
		byteLength: 32
	},
	secp224r1: {
		name: 'p224',
		byteLength: 28
	},
	prime256v1: {
		name: 'p256',
		byteLength: 32
	},
	prime192v1: {
		name: 'p192',
		byteLength: 24
	},
	ed25519: {
		name: 'ed25519',
		byteLength: 32
	},
	secp384r1: {
		name: 'p384',
		byteLength: 48
	},
	secp521r1: {
		name: 'p521',
		byteLength: 66
	}
};

aliases.p224 = aliases.secp224r1;
aliases.p256 = aliases.secp256r1 = aliases.prime256v1;
aliases.p192 = aliases.secp192r1 = aliases.prime192v1;
aliases.p384 = aliases.secp384r1;
aliases.p521 = aliases.secp521r1;

function ECDH(curve) {
	this.curveType = aliases[curve];
	if (!this.curveType ) {
		this.curveType = {
			name: curve
		};
	}
	this.curve = new elliptic.ec(this.curveType.name);
	this.keys = void 0;
}

ECDH.prototype.generateKeys = function (enc, format) {
	this.keys = this.curve.genKeyPair();
	return this.getPublicKey(enc, format);
};

ECDH.prototype.computeSecret = function (other, inenc, enc) {
	inenc = inenc || 'utf8';
	if (!Buffer.isBuffer(other)) {
		other = new Buffer(other, inenc);
	}
	var otherPub = this.curve.keyFromPublic(other).getPublic();
	var out = otherPub.mul(this.keys.getPrivate()).getX();
	return formatReturnValue(out, enc, this.curveType.byteLength);
};

ECDH.prototype.getPublicKey = function (enc, format) {
	var key = this.keys.getPublic(format === 'compressed', true);
	if (format === 'hybrid') {
		if (key[key.length - 1] % 2) {
			key[0] = 7;
		} else {
			key [0] = 6;
		}
	}
	return formatReturnValue(key, enc);
};

ECDH.prototype.getPrivateKey = function (enc) {
	return formatReturnValue(this.keys.getPrivate(), enc);
};

ECDH.prototype.setPublicKey = function (pub, enc) {
	enc = enc || 'utf8';
	if (!Buffer.isBuffer(pub)) {
		pub = new Buffer(pub, enc);
	}
	this.keys._importPublic(pub);
	return this;
};

ECDH.prototype.setPrivateKey = function (priv, enc) {
	enc = enc || 'utf8';
	if (!Buffer.isBuffer(priv)) {
		priv = new Buffer(priv, enc);
	}
	var _priv = new BN(priv);
	_priv = _priv.toString(16);
	this.keys._importPrivate(_priv);
	return this;
};

function formatReturnValue(bn, enc, len) {
	if (!Array.isArray(bn)) {
		bn = bn.toArray();
	}
	var buf = new Buffer(bn);
	if (len && buf.length < len) {
		var zeros = new Buffer(len - buf.length);
		zeros.fill(0);
		buf = Buffer.concat([zeros, buf]);
	}
	if (!enc) {
		return buf;
	} else {
		return buf.toString(enc);
	}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(2558);
exports.privateDecrypt = __webpack_require__(2559);

exports.privateEncrypt = function privateEncrypt(key, buf) {
  return exports.publicEncrypt(key, buf, true);
};

exports.publicDecrypt = function publicDecrypt(key, buf) {
  return exports.privateDecrypt(key, buf, true);
};

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var parseKeys = __webpack_require__(993);
var randomBytes = __webpack_require__(937);
var createHash = __webpack_require__(914);
var mgf = __webpack_require__(1449);
var xor = __webpack_require__(1450);
var bn = __webpack_require__(806);
var withPublic = __webpack_require__(1451);
var crt = __webpack_require__(1097);

var constants = {
  RSA_PKCS1_OAEP_PADDING: 4,
  RSA_PKCS1_PADDIN: 1,
  RSA_NO_PADDING: 3
};

module.exports = function publicEncrypt(public_key, msg, reverse) {
  var padding;
  if (public_key.padding) {
    padding = public_key.padding;
  } else if (reverse) {
    padding = 1;
  } else {
    padding = 4;
  }
  var key = parseKeys(public_key);
  var paddedMsg;
  if (padding === 4) {
    paddedMsg = oaep(key, msg);
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse);
  } else if (padding === 3) {
    paddedMsg = new bn(msg);
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus');
    }
  } else {
    throw new Error('unknown padding');
  }
  if (reverse) {
    return crt(paddedMsg, key);
  } else {
    return withPublic(paddedMsg, key);
  }
};

function oaep(key, msg){
  var k = key.modulus.byteLength();
  var mLen = msg.length;
  var iHash = createHash('sha1').update(new Buffer('')).digest();
  var hLen = iHash.length;
  var hLen2 = 2 * hLen;
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long');
  }
  var ps = new Buffer(k - mLen - hLen2 - 2);
  ps.fill(0);
  var dblen = k - hLen - 1;
  var seed = randomBytes(hLen);
  var maskedDb = xor(Buffer.concat([iHash, ps, new Buffer([1]), msg], dblen), mgf(seed, dblen));
  var maskedSeed = xor(seed, mgf(maskedDb, hLen));
  return new bn(Buffer.concat([new Buffer([0]), maskedSeed, maskedDb], k));
}
function pkcs1(key, msg, reverse){
  var mLen = msg.length;
  var k = key.modulus.byteLength();
  if (mLen > k - 11) {
    throw new Error('message too long');
  }
  var ps;
  if (reverse) {
    ps = new Buffer(k - mLen - 3);
    ps.fill(0xff);
  } else {
    ps = nonZero(k - mLen - 3);
  }
  return new bn(Buffer.concat([new Buffer([0, reverse?1:2]), ps, new Buffer([0]), msg], k));
}
function nonZero(len, crypto) {
  var out = new Buffer(len);
  var i = 0;
  var cache = randomBytes(len*2);
  var cur = 0;
  var num;
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len*2);
      cur = 0;
    }
    num = cache[cur++];
    if (num) {
      out[i++] = num;
    }
  }
  return out;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var parseKeys = __webpack_require__(993);
var mgf = __webpack_require__(1449);
var xor = __webpack_require__(1450);
var bn = __webpack_require__(806);
var crt = __webpack_require__(1097);
var createHash = __webpack_require__(914);
var withPublic = __webpack_require__(1451);
module.exports = function privateDecrypt(private_key, enc, reverse) {
  var padding;
  if (private_key.padding) {
    padding = private_key.padding;
  } else if (reverse) {
    padding = 1;
  } else {
    padding = 4;
  }
  
  var key = parseKeys(private_key);
  var k = key.modulus.byteLength();
  if (enc.length > k || new bn(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error');
  }
  var msg;
  if (reverse) {
    msg = withPublic(new bn(enc), key);
  } else {
    msg = crt(enc, key);
  }
  var zBuffer = new Buffer(k - msg.length);
  zBuffer.fill(0);
  msg = Buffer.concat([zBuffer, msg], k);
  if (padding === 4) {
    return oaep(key, msg);
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse);
  } else if (padding === 3) {
    return msg;
  } else {
    throw new Error('unknown padding');
  }
};

function oaep(key, msg){
  var n = key.modulus;
  var k = key.modulus.byteLength();
  var mLen = msg.length;
  var iHash = createHash('sha1').update(new Buffer('')).digest();
  var hLen = iHash.length;
  var hLen2 = 2 * hLen;
  if (msg[0] !== 0) {
    throw new Error('decryption error');
  }
  var maskedSeed = msg.slice(1, hLen + 1);
  var maskedDb =  msg.slice(hLen + 1);
  var seed = xor(maskedSeed, mgf(maskedDb, hLen));
  var db = xor(maskedDb, mgf(seed, k - hLen - 1));
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error');
  }
  var i = hLen;
  while (db[i] === 0) {
    i++;
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error');
  }
  return db.slice(i);
}

function pkcs1(key, msg, reverse){
  var p1 = msg.slice(0, 2);
  var i = 2;
  var status = 0;
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++;
      break;
    }
  }
  var ps = msg.slice(2, i - 1);
  var p2 = msg.slice(i - 1, i);

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)){
    status++;
  }
  if (ps.length < 8) {
    status++;
  }
  if (status) {
    throw new Error('decryption error');
  }
  return  msg.slice(i);
}
function compare(a, b){
  a = new Buffer(a);
  b = new Buffer(b);
  var dif = 0;
  var len = a.length;
  if (a.length !== b.length) {
    dif++;
    len = Math.min(a.length, b.length);
  }
  var i = -1;
  while (++i < len) {
    dif += (a[i] ^ b[i]);
  }
  return dif;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(20).then((function(require) {
		cb(__webpack_require__(2564));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2564 */,
/* 2565 */,
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(2).then((function(require) {
		cb(__webpack_require__(2567));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */,
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */,
/* 2671 */,
/* 2672 */,
/* 2673 */,
/* 2674 */,
/* 2675 */,
/* 2676 */,
/* 2677 */,
/* 2678 */,
/* 2679 */,
/* 2680 */,
/* 2681 */,
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */,
/* 2693 */,
/* 2694 */,
/* 2695 */,
/* 2696 */,
/* 2697 */,
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */,
/* 2702 */,
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(25).then((function(require) {
		cb(__webpack_require__(2715));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2715 */,
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(19).then((function(require) {
		cb(__webpack_require__(2717));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2717 */,
/* 2718 */,
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(17).then((function(require) {
		cb(__webpack_require__(2720));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2720 */,
/* 2721 */,
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(16).then((function(require) {
		cb(__webpack_require__(2723));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2723 */,
/* 2724 */,
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(15).then((function(require) {
		cb(__webpack_require__(2726));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2726 */,
/* 2727 */,
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(18).then((function(require) {
		cb(__webpack_require__(2729));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2729 */,
/* 2730 */,
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(22).then((function(require) {
		cb(__webpack_require__(2732));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2732 */,
/* 2733 */,
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(7).then((function(require) {
		cb(__webpack_require__(2735));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2735 */,
/* 2736 */,
/* 2737 */,
/* 2738 */,
/* 2739 */,
/* 2740 */,
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(6).then((function(require) {
		cb(__webpack_require__(2742));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2742 */,
/* 2743 */,
/* 2744 */,
/* 2745 */,
/* 2746 */,
/* 2747 */,
/* 2748 */,
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(12).then((function(require) {
		cb(__webpack_require__(2750));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(14).then((function(require) {
		cb(__webpack_require__(2755));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(11).then((function(require) {
		cb(__webpack_require__(2759));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(26).then((function(require) {
		cb(__webpack_require__(2764));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2764 */,
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(10).then((function(require) {
		cb(__webpack_require__(2766));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(8).then((function(require) {
		cb(__webpack_require__(2772));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(2778);


/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var ps = __webpack_require__(2779);
var psInstances = __webpack_require__(827);

function mountJQuery(jQuery) {
  jQuery.fn.perfectScrollbar = function (settingOrCommand) {
    return this.each(function () {
      if (typeof settingOrCommand === 'object' ||
          typeof settingOrCommand === 'undefined') {
        // If it's an object or none, initialize.
        var settings = settingOrCommand;

        if (!psInstances.get(this)) {
          ps.initialize(this, settings);
        }
      } else {
        // Unless, it may be a command.
        var command = settingOrCommand;

        if (command === 'update') {
          ps.update(this);
        } else if (command === 'destroy') {
          ps.destroy(this);
        }
      }
    });
  };
}

if (true) {
  // AMD. Register as an anonymous module.
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(773)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mountJQuery),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  var jq = window.jQuery ? window.jQuery : window.$;
  if (typeof jq !== 'undefined') {
    mountJQuery(jq);
  }
}

module.exports = mountJQuery;


/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var destroy = __webpack_require__(2780);
var initialize = __webpack_require__(2784);
var update = __webpack_require__(2792);

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};


/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(872);
var dom = __webpack_require__(895);
var instances = __webpack_require__(827);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  i.event.unbindAll();
  dom.remove(i.scrollbarX);
  dom.remove(i.scrollbarY);
  dom.remove(i.scrollbarXRail);
  dom.remove(i.scrollbarYRail);
  _.removePsClasses(element);

  instances.remove(element);
};


/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    handlers: ['click-rail', 'drag-scrollbar', 'keyboard', 'wheel', 'touch'],
    maxScrollbarLength: null,
    minScrollbarLength: null,
    scrollXMarginOffset: 0,
    scrollYMarginOffset: 0,
    suppressScrollX: false,
    suppressScrollY: false,
    swipePropagation: true,
    swipeEasing: true,
    useBothWheelAxes: false,
    wheelPropagation: false,
    wheelSpeed: 1,
    theme: 'default'
  };
};


/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EventElement = function (element) {
  this.element = element;
  this.events = {};
};

EventElement.prototype.bind = function (eventName, handler) {
  if (typeof this.events[eventName] === 'undefined') {
    this.events[eventName] = [];
  }
  this.events[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function (eventName, handler) {
  var isHandlerProvided = (typeof handler !== 'undefined');
  this.events[eventName] = this.events[eventName].filter(function (hdlr) {
    if (isHandlerProvided && hdlr !== handler) {
      return true;
    }
    this.element.removeEventListener(eventName, hdlr, false);
    return false;
  }, this);
};

EventElement.prototype.unbindAll = function () {
  for (var name in this.events) {
    this.unbind(name);
  }
};

var EventManager = function () {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function (element) {
  var ee = this.eventElements.filter(function (eventElement) {
    return eventElement.element === element;
  })[0];
  if (typeof ee === 'undefined') {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function (element, eventName, handler) {
  this.eventElement(element).unbind(eventName, handler);
};

EventManager.prototype.unbindAll = function () {
  for (var i = 0; i < this.eventElements.length; i++) {
    this.eventElements[i].unbindAll();
  }
};

EventManager.prototype.once = function (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (e) {
    ee.unbind(eventName, onceHandler);
    handler(e);
  };
  ee.bind(eventName, onceHandler);
};

module.exports = EventManager;


/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = (function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
  };
})();


/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(827);
var updateGeometry = __webpack_require__(858);

// Handlers
var handlers = {
  'click-rail': __webpack_require__(2785),
  'drag-scrollbar': __webpack_require__(2786),
  'keyboard': __webpack_require__(2787),
  'wheel': __webpack_require__(2788),
  'touch': __webpack_require__(2789),
  'selection': __webpack_require__(2790)
};
var nativeScrollHandler = __webpack_require__(2791);

module.exports = function (element, userSettings) {
  element.classList.add('ps');

  // Create a plugin instance.
  var i = instances.add(
    element,
    typeof userSettings === 'object' ? userSettings : {}
  );

  element.classList.add('ps--theme_' + i.settings.theme);

  i.settings.handlers.forEach(function (handlerName) {
    handlers[handlerName](element);
  });

  nativeScrollHandler(element);

  updateGeometry(element);
};


/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(827);
var updateGeometry = __webpack_require__(858);
var updateScroll = __webpack_require__(873);

function bindClickRailHandler(element, i) {
  function pageOffset(el) {
    return el.getBoundingClientRect();
  }
  var stopPropagation = function (e) { e.stopPropagation(); };

  i.event.bind(i.scrollbarY, 'click', stopPropagation);
  i.event.bind(i.scrollbarYRail, 'click', function (e) {
    var positionTop = e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    updateScroll(element, 'top', element.scrollTop + direction * i.containerHeight);
    updateGeometry(element);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'click', stopPropagation);
  i.event.bind(i.scrollbarXRail, 'click', function (e) {
    var positionLeft = e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    updateScroll(element, 'left', element.scrollLeft + direction * i.containerWidth);
    updateGeometry(element);

    e.stopPropagation();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindClickRailHandler(element, i);
};


/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(872);
var dom = __webpack_require__(895);
var instances = __webpack_require__(827);
var updateGeometry = __webpack_require__(858);
var updateScroll = __webpack_require__(873);

function bindMouseScrollXHandler(element, i) {
  var currentLeft = null;
  var currentPageX = null;

  function updateScrollLeft(deltaX) {
    var newLeft = currentLeft + (deltaX * i.railXRatio);
    var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));

    if (newLeft < 0) {
      i.scrollbarXLeft = 0;
    } else if (newLeft > maxLeft) {
      i.scrollbarXLeft = maxLeft;
    } else {
      i.scrollbarXLeft = newLeft;
    }

    var scrollLeft = _.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
    updateScroll(element, 'left', scrollLeft);
  }

  var mouseMoveHandler = function (e) {
    updateScrollLeft(e.pageX - currentPageX);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'x');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarX, 'mousedown', function (e) {
    currentPageX = e.pageX;
    currentLeft = _.toInt(dom.css(i.scrollbarX, 'left')) * i.railXRatio;
    _.startScrolling(element, 'x');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

function bindMouseScrollYHandler(element, i) {
  var currentTop = null;
  var currentPageY = null;

  function updateScrollTop(deltaY) {
    var newTop = currentTop + (deltaY * i.railYRatio);
    var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));

    if (newTop < 0) {
      i.scrollbarYTop = 0;
    } else if (newTop > maxTop) {
      i.scrollbarYTop = maxTop;
    } else {
      i.scrollbarYTop = newTop;
    }

    var scrollTop = _.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
    updateScroll(element, 'top', scrollTop);
  }

  var mouseMoveHandler = function (e) {
    updateScrollTop(e.pageY - currentPageY);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'y');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarY, 'mousedown', function (e) {
    currentPageY = e.pageY;
    currentTop = _.toInt(dom.css(i.scrollbarY, 'top')) * i.railYRatio;
    _.startScrolling(element, 'y');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseScrollXHandler(element, i);
  bindMouseScrollYHandler(element, i);
};


/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(872);
var dom = __webpack_require__(895);
var instances = __webpack_require__(827);
var updateGeometry = __webpack_require__(858);
var updateScroll = __webpack_require__(873);

function bindKeyboardHandler(element, i) {
  var hovered = false;
  i.event.bind(element, 'mouseenter', function () {
    hovered = true;
  });
  i.event.bind(element, 'mouseleave', function () {
    hovered = false;
  });

  var shouldPrevent = false;
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if ((e.isDefaultPrevented && e.isDefaultPrevented()) || e.defaultPrevented) {
      return;
    }

    var focused = dom.matches(i.scrollbarX, ':focus') ||
                  dom.matches(i.scrollbarY, ':focus');

    if (!hovered && !focused) {
      return;
    }

    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (_.isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
    case 37: // left
      if (e.metaKey) {
        deltaX = -i.contentWidth;
      } else if (e.altKey) {
        deltaX = -i.containerWidth;
      } else {
        deltaX = -30;
      }
      break;
    case 38: // up
      if (e.metaKey) {
        deltaY = i.contentHeight;
      } else if (e.altKey) {
        deltaY = i.containerHeight;
      } else {
        deltaY = 30;
      }
      break;
    case 39: // right
      if (e.metaKey) {
        deltaX = i.contentWidth;
      } else if (e.altKey) {
        deltaX = i.containerWidth;
      } else {
        deltaX = 30;
      }
      break;
    case 40: // down
      if (e.metaKey) {
        deltaY = -i.contentHeight;
      } else if (e.altKey) {
        deltaY = -i.containerHeight;
      } else {
        deltaY = -30;
      }
      break;
    case 33: // page up
      deltaY = 90;
      break;
    case 32: // space bar
      if (e.shiftKey) {
        deltaY = 90;
      } else {
        deltaY = -90;
      }
      break;
    case 34: // page down
      deltaY = -90;
      break;
    case 35: // end
      if (e.ctrlKey) {
        deltaY = -i.contentHeight;
      } else {
        deltaY = -i.containerHeight;
      }
      break;
    case 36: // home
      if (e.ctrlKey) {
        deltaY = element.scrollTop;
      } else {
        deltaY = i.containerHeight;
      }
      break;
    default:
      return;
    }

    updateScroll(element, 'top', element.scrollTop - deltaY);
    updateScroll(element, 'left', element.scrollLeft + deltaX);
    updateGeometry(element);

    shouldPrevent = shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent) {
      e.preventDefault();
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindKeyboardHandler(element, i);
};


/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(827);
var updateGeometry = __webpack_require__(858);
var updateScroll = __webpack_require__(873);

function bindMouseWheelHandler(element, i) {
  var shouldPrevent = false;

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(deltaX, deltaY) {
    var child = element.querySelector('textarea:hover, select[multiple]:hover, .ps-child:hover');
    if (child) {
      var style = window.getComputedStyle(child);
      var overflow = [
        style.overflow,
        style.overflowX,
        style.overflowY
      ].join('');

      if (!overflow.match(/(scroll|auto)/)) {
        // if not scrollable
        return false;
      }

      var maxScrollTop = child.scrollHeight - child.clientHeight;
      if (maxScrollTop > 0) {
        if (!(child.scrollTop === 0 && deltaY > 0) && !(child.scrollTop === maxScrollTop && deltaY < 0)) {
          return true;
        }
      }
      var maxScrollLeft = child.scrollLeft - child.clientWidth;
      if (maxScrollLeft > 0) {
        if (!(child.scrollLeft === 0 && deltaX < 0) && !(child.scrollLeft === maxScrollLeft && deltaX > 0)) {
          return true;
        }
      }
    }
    return false;
  }

  function mousewheelHandler(e) {
    var delta = getDeltaFromEvent(e);

    var deltaX = delta[0];
    var deltaY = delta[1];

    if (shouldBeConsumedByChild(deltaX, deltaY)) {
      return;
    }

    shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    }

    updateGeometry(element);

    shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
    if (shouldPrevent) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== "undefined") {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== "undefined") {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseWheelHandler(element, i);
};


/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(872);
var instances = __webpack_require__(827);
var updateGeometry = __webpack_require__(858);
var updateScroll = __webpack_require__(873);

function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
          ((deltaY > 0) && (scrollTop === 0))) {
        return !i.settings.swipePropagation;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
          ((deltaX > 0) && (scrollLeft === 0))) {
        return !i.settings.swipePropagation;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    updateScroll(element, 'top', element.scrollTop - differenceY);
    updateScroll(element, 'left', element.scrollLeft - differenceX);

    updateGeometry(element);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;
  var inGlobalTouch = false;
  var inLocalTouch = false;

  function globalTouchStart() {
    inGlobalTouch = true;
  }
  function globalTouchEnd() {
    inGlobalTouch = false;
  }

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }
  function shouldHandle(e) {
    if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
      return false;
    }
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
      return true;
    }
    return false;
  }
  function touchStart(e) {
    if (shouldHandle(e)) {
      inLocalTouch = true;

      var touch = getTouch(e);

      startOffset.pageX = touch.pageX;
      startOffset.pageY = touch.pageY;

      startTime = (new Date()).getTime();

      if (easingLoop !== null) {
        clearInterval(easingLoop);
      }

      e.stopPropagation();
    }
  }
  function touchMove(e) {
    if (!inLocalTouch && i.settings.swipePropagation) {
      touchStart(e);
    }
    if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = (new Date()).getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPreventDefault(differenceX, differenceY)) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (!inGlobalTouch && inLocalTouch) {
      inLocalTouch = false;

      if (i.settings.swipeEasing) {
        clearInterval(easingLoop);
        easingLoop = setInterval(function () {
          if (!instances.get(element)) {
            clearInterval(easingLoop);
            return;
          }

          if (!speed.x && !speed.y) {
            clearInterval(easingLoop);
            return;
          }

          if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
            clearInterval(easingLoop);
            return;
          }

          applyTouchMove(speed.x * 30, speed.y * 30);

          speed.x *= 0.8;
          speed.y *= 0.8;
        }, 10);
      }
    }
  }

  if (supportsTouch) {
    i.event.bind(window, 'touchstart', globalTouchStart);
    i.event.bind(window, 'touchend', globalTouchEnd);
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(window, 'pointerdown', globalTouchStart);
      i.event.bind(window, 'pointerup', globalTouchEnd);
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(window, 'MSPointerDown', globalTouchStart);
      i.event.bind(window, 'MSPointerUp', globalTouchEnd);
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
}

module.exports = function (element) {
  if (!_.env.supportsTouch && !_.env.supportsIePointer) {
    return;
  }

  var i = instances.get(element);
  bindTouchHandler(element, i, _.env.supportsTouch, _.env.supportsIePointer);
};


/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(872);
var instances = __webpack_require__(827);
var updateGeometry = __webpack_require__(858);
var updateScroll = __webpack_require__(873);

function bindSelectionHandler(element, i) {
  function getRangeNode() {
    var selection = window.getSelection ? window.getSelection() :
                    document.getSelection ? document.getSelection() : '';
    if (selection.toString().length === 0) {
      return null;
    } else {
      return selection.getRangeAt(0).commonAncestorContainer;
    }
  }

  var scrollingLoop = null;
  var scrollDiff = {top: 0, left: 0};
  function startScrolling() {
    if (!scrollingLoop) {
      scrollingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(scrollingLoop);
          return;
        }

        updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
        updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
        updateGeometry(element);
      }, 50); // every .1 sec
    }
  }
  function stopScrolling() {
    if (scrollingLoop) {
      clearInterval(scrollingLoop);
      scrollingLoop = null;
    }
    _.stopScrolling(element);
  }

  var isSelected = false;
  i.event.bind(i.ownerDocument, 'selectionchange', function () {
    if (element.contains(getRangeNode())) {
      isSelected = true;
    } else {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'mouseup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'keyup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });

  i.event.bind(window, 'mousemove', function (e) {
    if (isSelected) {
      var mousePosition = {x: e.pageX, y: e.pageY};
      var containerGeometry = {
        left: element.offsetLeft,
        right: element.offsetLeft + element.offsetWidth,
        top: element.offsetTop,
        bottom: element.offsetTop + element.offsetHeight
      };

      if (mousePosition.x < containerGeometry.left + 3) {
        scrollDiff.left = -5;
        _.startScrolling(element, 'x');
      } else if (mousePosition.x > containerGeometry.right - 3) {
        scrollDiff.left = 5;
        _.startScrolling(element, 'x');
      } else {
        scrollDiff.left = 0;
      }

      if (mousePosition.y < containerGeometry.top + 3) {
        if (containerGeometry.top + 3 - mousePosition.y < 5) {
          scrollDiff.top = -5;
        } else {
          scrollDiff.top = -20;
        }
        _.startScrolling(element, 'y');
      } else if (mousePosition.y > containerGeometry.bottom - 3) {
        if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
          scrollDiff.top = 5;
        } else {
          scrollDiff.top = 20;
        }
        _.startScrolling(element, 'y');
      } else {
        scrollDiff.top = 0;
      }

      if (scrollDiff.top === 0 && scrollDiff.left === 0) {
        stopScrolling();
      } else {
        startScrolling();
      }
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindSelectionHandler(element, i);
};


/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(827);
var updateGeometry = __webpack_require__(858);

function bindNativeScrollHandler(element, i) {
  i.event.bind(element, 'scroll', function () {
    updateGeometry(element);
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindNativeScrollHandler(element, i);
};


/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(872);
var dom = __webpack_require__(895);
var instances = __webpack_require__(827);
var updateGeometry = __webpack_require__(858);
var updateScroll = __webpack_require__(873);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;

  // Recalculate rail margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  dom.css(i.scrollbarXRail, 'display', 'none');
  dom.css(i.scrollbarYRail, 'display', 'none');

  updateGeometry(element);

  // Update top/left scroll to trigger events
  updateScroll(element, 'top', element.scrollTop);
  updateScroll(element, 'left', element.scrollLeft);

  dom.css(i.scrollbarXRail, 'display', '');
  dom.css(i.scrollbarYRail, 'display', '');
};


/***/ })
]));


// WEBPACK FOOTER //
// 0.14cb5b1a47e01503ba25.js